// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"9g7ql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Root);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _connectedReactRouter = require("connected-react-router");
var _carrierLogisticsCommonsProvider = require("@amzn/carrierlogistics-commons/dist/CarrierLogisticsCommonsProvider");
var _carrierLogisticsCommonsProviderDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsProvider);
var _clwscallerApp = require("@amzn/carrier-logistics-common-ui-assets/dist/CLWSCallerApp");
var _clwscallerAppDefault = parcelHelpers.interopDefault(_clwscallerApp);
var _slideOutSheet = require("@amzn/carrier-logistics-inline-help-ui-assets/dist/SlideOutSheet");
var _slideOutSheetDefault = parcelHelpers.interopDefault(_slideOutSheet);
var _app = require("../components/App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _updateCSRFToken = require("../utils/updateCSRFToken");
var _updateCSRFTokenDefault = parcelHelpers.interopDefault(_updateCSRFToken);
var _authorizedPageUtils = require("../utils/authorizedPageUtils");
var _navigationalRoutes = require("../config/navigationalRoutes");
function Root({ store, history }) {
    (0, _react.useEffect)(()=>{
        // extracting csrf token set by MONS and saving it in the session, if present
        (0, _updateCSRFTokenDefault.default)();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        store: store
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "passport-app-root"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _connectedReactRouter.ConnectedRouter), {
        history: history
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _slideOutSheetDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carrierLogisticsCommonsProviderDefault.default), {
        CLWSCaller: (0, _clwscallerAppDefault.default),
        isPageAuthorized: (0, _authorizedPageUtils.isAuthorizedPage)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Route), {
        path: (0, _navigationalRoutes.HOME),
        component: (0, _appDefault.default)
    })))));
}
Root.propTypes = {
    store: (0, _propTypesDefault.default).object.isRequired,
    history: (0, _propTypesDefault.default).object.isRequired
};

},{"prop-types":"6FKs7","react":"6uln9","react-redux":"3qqlL","react-router-dom":"5fzqq","connected-react-router":"gi8ZX","@amzn/carrierlogistics-commons/dist/CarrierLogisticsCommonsProvider":"iWCdR","@amzn/carrier-logistics-common-ui-assets/dist/CLWSCallerApp":"FYIfi","@amzn/carrier-logistics-inline-help-ui-assets/dist/SlideOutSheet":"bdEl4","../components/App":"gMWMA","../utils/updateCSRFToken":"copTY","../utils/authorizedPageUtils":"8Nt2u","../config/navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5fzqq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"i3TiW","@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","history":"grwqf","prop-types":"6FKs7","tiny-warning":"328jC","@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iWCdR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CarrierLogisticsCommonsProvider", ()=>CarrierLogisticsCommonsProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _carrierLogisticsCommonsContext = require("./context/CarrierLogisticsCommonsContext");
var _carrierLogisticsCommonsContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsContext);
var _carrierLogisticsCommonsDispatchContext = require("./context/CarrierLogisticsCommonsDispatchContext");
var _carrierLogisticsCommonsDispatchContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsDispatchContext);
var _authorisationDispatch = require("./dispatch/authorization/authorisationDispatch");
var _authorisationDispatchDefault = parcelHelpers.interopDefault(_authorisationDispatch);
var _localisationDispatch = require("./dispatch/localisation/localisationDispatch");
var _localisationDispatchDefault = parcelHelpers.interopDefault(_localisationDispatch);
var _reducers = require("./reducers");
var _reducersDefault = parcelHelpers.interopDefault(_reducers);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var CarrierLogisticsCommonsProvider = function(param) {
    var children = param.children, CLWSCaller = param.CLWSCaller, isPageAuthorized = param.isPageAuthorized;
    var pathname = (0, _reactRouterDom.useLocation)().pathname;
    var ref = _slicedToArray((0, _react.useReducer)((0, _reducersDefault.default), (0, _carrierLogisticsCommonsContext.initialContextValue)), 2), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carrierLogisticsCommonsContextDefault.default).Provider, {
        value: state
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _carrierLogisticsCommonsDispatchContextDefault.default).Provider, {
        value: {
            localisationDispatch: (0, _localisationDispatchDefault.default)(dispatch)
        }
    }, children, /*#__PURE__*/ (0, _reactDefault.default).createElement(CLWSCaller, {
        isPageAuthorized: isPageAuthorized(pathname),
        authorizationDispatch: (0, _authorisationDispatchDefault.default)(dispatch)
    })));
};
exports.default = CarrierLogisticsCommonsProvider;

},{"react":"6uln9","react-router-dom":"5fzqq","./context/CarrierLogisticsCommonsContext":"kTkCE","./context/CarrierLogisticsCommonsDispatchContext":"dmv1W","./dispatch/authorization/authorisationDispatch":"7DUhz","./dispatch/localisation/localisationDispatch":"akZ8C","./reducers":"3mqme","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kTkCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialContextValue", ()=>initialContextValue);
var _react = require("react");
var _localisation = require("../constants/localisation");
var initialContextValue = {
    lps: {
        authorizedEntities: {},
        authorizedLps: null,
        lpSelected: null,
        authorizedDSPs: null
    },
    localization: {
        locale: (0, _localisation.DEFAULT_LOCALE)
    }
};
var CarrierLogisticsCommonsContext = (0, _react.createContext)(initialContextValue);
exports.default = CarrierLogisticsCommonsContext;

},{"react":"6uln9","../constants/localisation":"158kl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"158kl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>DEFAULT_LOCALE);
parcelHelpers.export(exports, "IS_LOCALISATION_FEATURE_ENABLED", ()=>IS_LOCALISATION_FEATURE_ENABLED);
var DEFAULT_LOCALE = "en-US";
var IS_LOCALISATION_FEATURE_ENABLED = "IS_LOCALISATION_FEATURE_ENABLED";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dmv1W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var CarrierLogisticsCommonsDispatchContext = (0, _react.createContext)({
    localisationDispatch: null
});
exports.default = CarrierLogisticsCommonsDispatchContext;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7DUhz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authorizationDispatch", ()=>authorizationDispatch);
var _actions = require("../../actions/lps/actions");
var authorizationDispatch = function(clwsDispatch) {
    return {
        dispatchGetAuthorizedEntities: function(payload) {
            return clwsDispatch((0, _actions.storeAuthorizedEntitiesAction)(payload));
        },
        dispatchGetAuthorizedLps: function(payload) {
            return clwsDispatch((0, _actions.storeAuthorizedLpsAction)(payload));
        },
        dispatchGetAuthorizedDSPs: function(payload) {
            return clwsDispatch((0, _actions.storeAuthorizedDSPsAction)(payload));
        },
        dispatchGetLPDetails: function(payload) {
            return clwsDispatch((0, _actions.storeAuthorizedLpSelectedAction)(payload));
        }
    };
};
exports.default = authorizationDispatch;

},{"../../actions/lps/actions":"i8qDq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8qDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storeAuthorizedLpsAction", ()=>storeAuthorizedLpsAction);
parcelHelpers.export(exports, "storeAuthorizedDSPsAction", ()=>storeAuthorizedDSPsAction);
parcelHelpers.export(exports, "storeAuthorizedEntitiesAction", ()=>storeAuthorizedEntitiesAction);
parcelHelpers.export(exports, "storeAuthorizedLpSelectedAction", ()=>storeAuthorizedLpSelectedAction);
var _createAction = require("../../redux/createAction");
var _createActionDefault = parcelHelpers.interopDefault(_createAction);
var _lpActionTypes = require("./lpActionTypes");
var _lpActionTypesDefault = parcelHelpers.interopDefault(_lpActionTypes);
var storeAuthorizedLpsAction = (0, _createActionDefault.default)((0, _lpActionTypesDefault.default).SET_AUTHORIZED_LPS);
var storeAuthorizedDSPsAction = (0, _createActionDefault.default)((0, _lpActionTypesDefault.default).SET_AUTHORIZED_DSPS);
var storeAuthorizedEntitiesAction = (0, _createActionDefault.default)((0, _lpActionTypesDefault.default).SET_AUTHORIZED_ENTITIES);
var storeAuthorizedLpSelectedAction = (0, _createActionDefault.default)((0, _lpActionTypesDefault.default).SET_SELECTED_LP);

},{"../../redux/createAction":"8CBKk","./lpActionTypes":"RhlzD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8CBKk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAction", ()=>createAction);
var createAction = function(type) {
    return function() {
        var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        return {
            type: type,
            payload: payload
        };
    };
};
exports.default = createAction;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"RhlzD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lpActions", ()=>lpActions);
var lpActions = {
    SET_AUTHORIZED_ENTITIES: "SET_AUTHORIZED_ENTITIES",
    SET_AUTHORIZED_LPS: "SET_AUTHORIZED_LPS",
    SET_AUTHORIZED_DSPS: "SET_AUTHORIZED_DSPS",
    SET_SELECTED_LP: "SET_SELECTED_LP"
};
exports.default = lpActions;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"akZ8C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localisationDispatch", ()=>localisationDispatch);
var _actions = require("../../actions/localization/actions");
var localisationDispatch = function(dispatch) {
    return {
        dispatchStoreLocale: function(payload) {
            dispatch((0, _actions.storeLocale)(payload));
        }
    };
};
exports.default = localisationDispatch;

},{"../../actions/localization/actions":"jDLGi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDLGi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storeLocale", ()=>storeLocale);
var _createAction = require("../../redux/createAction");
var _createActionDefault = parcelHelpers.interopDefault(_createAction);
var _localizationActionstypes = require("./localizationActionstypes");
var _localizationActionstypesDefault = parcelHelpers.interopDefault(_localizationActionstypes);
var storeLocale = (0, _createActionDefault.default)((0, _localizationActionstypesDefault.default).SET_LOCALE);

},{"../../redux/createAction":"8CBKk","./localizationActionstypes":"cDBii","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDBii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localizationActions", ()=>localizationActions);
var localizationActions = {
    SET_LOCALE: "SET_LOCALE"
};
exports.default = localizationActions;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3mqme":[function(require,module,exports) {
/*
 * Root reducer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _combineReducers = require("../utils/combineReducers");
var _combineReducersDefault = parcelHelpers.interopDefault(_combineReducers);
var _lpsReducer = require("./lpsReducer");
var _lpsReducerDefault = parcelHelpers.interopDefault(_lpsReducer);
var _localizationReducer = require("./localizationReducer");
var _localizationReducerDefault = parcelHelpers.interopDefault(_localizationReducer);
var rootReducer = (0, _combineReducersDefault.default)({
    lps: (0, _lpsReducerDefault.default),
    localization: (0, _localizationReducerDefault.default)
});
exports.default = rootReducer;

},{"../utils/combineReducers":"7pJAA","./lpsReducer":"5ZfBY","./localizationReducer":"cq1n3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7pJAA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var combineReducers = function(reducers) {
    return function() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        return Object.keys(reducers).reduce(function(nextState, key) {
            nextState[key] = reducers[key](state[key], action);
            return nextState;
        }, {});
    };
};
exports.default = combineReducers;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ZfBY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lpsReducer", ()=>lpsReducer);
var _lpActionTypes = require("../actions/lps/lpActionTypes");
var _lpActionTypesDefault = parcelHelpers.interopDefault(_lpActionTypes);
var _carrierLogisticsCommonsContext = require("../context/CarrierLogisticsCommonsContext");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function lpsReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _carrierLogisticsCommonsContext.initialContextValue).lps, action = arguments.length > 1 ? arguments[1] : void 0;
    var type = action.type, payload = action.payload;
    switch(type){
        case (0, _lpActionTypesDefault.default).SET_AUTHORIZED_ENTITIES:
            return _objectSpreadProps(_objectSpread({}, state), {
                authorizedEntities: payload
            });
        case (0, _lpActionTypesDefault.default).SET_AUTHORIZED_LPS:
            return _objectSpreadProps(_objectSpread({}, state), {
                authorizedLps: payload
            });
        case (0, _lpActionTypesDefault.default).SET_AUTHORIZED_DSPS:
            return _objectSpreadProps(_objectSpread({}, state), {
                authorizedDSPs: payload
            });
        case (0, _lpActionTypesDefault.default).SET_SELECTED_LP:
            return _objectSpreadProps(_objectSpread({}, state), {
                lpSelected: payload
            });
        default:
            return state;
    }
}
exports.default = lpsReducer;

},{"../actions/lps/lpActionTypes":"RhlzD","../context/CarrierLogisticsCommonsContext":"kTkCE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cq1n3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localizationReducer", ()=>localizationReducer);
var _localizationActionstypes = require("../actions/localization/localizationActionstypes");
var _localizationActionstypesDefault = parcelHelpers.interopDefault(_localizationActionstypes);
var _carrierLogisticsCommonsContext = require("../context/CarrierLogisticsCommonsContext");
var _localisation = require("../constants/localisation");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function localizationReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _carrierLogisticsCommonsContext.initialContextValue).localization, action = arguments.length > 1 ? arguments[1] : void 0;
    var type = action.type, payload = action.payload;
    switch(type){
        case (0, _localizationActionstypesDefault.default).SET_LOCALE:
            return _objectSpreadProps(_objectSpread({}, state), {
                locale: payload || (0, _localisation.DEFAULT_LOCALE)
            });
        default:
            return state;
    }
}
exports.default = localizationReducer;

},{"../actions/localization/localizationActionstypes":"cDBii","../context/CarrierLogisticsCommonsContext":"kTkCE","../constants/localisation":"158kl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FYIfi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _clwsauthZCaller = require("./exportable/CLWSAuthZCaller");
var _clwsauthZCallerDefault = parcelHelpers.interopDefault(_clwsauthZCaller);
var _store = require("./store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var CLWSCallerApp = function(param) {
    var isPageAuthorized = param.isPageAuthorized, authorizationDispatch = param.authorizationDispatch;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        store: (0, _storeDefault.default)
    }, isPageAuthorized && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _clwsauthZCallerDefault.default), {
        authorizationDispatch: authorizationDispatch
    }));
};
exports.default = CLWSCallerApp;
CLWSCallerApp.propTypes = {};

},{"react":"6uln9","react-redux":"3qqlL","./exportable/CLWSAuthZCaller":"hihwN","./store":"e0AKW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hihwN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAuthorizedDSPs = require("../hooks/useLps/useAuthorizedDSPs");
var _useAuthorizedEntities = require("../hooks/useLps/useAuthorizedEntities");
var _useAuthorizedLps = require("../hooks/useLps/useAuthorizedLps");
var _useLpSelected = require("../hooks/useLps/useLpSelected");
var CLWSAuthZCaller = function(param) {
    var authorizationDispatch = param.authorizationDispatch;
    var dispatchGetAuthorizedEntities = authorizationDispatch.dispatchGetAuthorizedEntities, dispatchGetAuthorizedLps = authorizationDispatch.dispatchGetAuthorizedLps, dispatchGetLPDetails = authorizationDispatch.dispatchGetLPDetails, dispatchGetAuthorizedDSPs = authorizationDispatch.dispatchGetAuthorizedDSPs;
    var authorizedEntities = (0, _useAuthorizedEntities.useAuthorizedEntities)();
    var lpSelected = (0, _useLpSelected.useLpSelected)();
    var authorizedLps = (0, _useAuthorizedLps.useAuthorizedLps)();
    var authorizedDSPs = (0, _useAuthorizedDSPs.useAuthorizedDSPs)();
    (0, _react.useEffect)(function() {
        if ((0, _lodash.isEmpty)(authorizedEntities)) return;
        dispatchGetAuthorizedEntities(authorizedEntities);
    }, [
        authorizedEntities
    ]);
    (0, _react.useEffect)(function() {
        if ((0, _lodash.isEmpty)(lpSelected)) return;
        dispatchGetLPDetails(lpSelected);
    }, [
        lpSelected
    ]);
    (0, _react.useEffect)(function() {
        if ((0, _lodash.isNull)(authorizedLps)) return;
        dispatchGetAuthorizedLps(authorizedLps);
    }, [
        authorizedLps
    ]);
    (0, _react.useEffect)(function() {
        if ((0, _lodash.isNull)(authorizedDSPs)) return;
        dispatchGetAuthorizedDSPs(authorizedDSPs);
    }, [
        authorizedLps
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
};
exports.default = CLWSAuthZCaller;

},{"lodash":"7vCCa","react":"6uln9","../hooks/useLps/useAuthorizedDSPs":"84C93","../hooks/useLps/useAuthorizedEntities":"5PXi8","../hooks/useLps/useAuthorizedLps":"f2yw1","../hooks/useLps/useLpSelected":"8RHmn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vCCa":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"84C93":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorizedDSPs", ()=>useAuthorizedDSPs);
var _dspFeature = require("@amzn/carrierlogistics-commons/dist/utils/featureFlags/dspFeature");
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _react = require("react");
var _reactRedux = require("react-redux");
var _lp = require("../../actions/lp");
var _actionTypes = require("../../actions/lp/actionTypes");
var _selectors = require("../../actions/lp/selectors");
function useAuthorizedDSPs() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var authorizedDSPs = (0, _reactRedux.useSelector)((0, _selectors.getAuthorizedDSPsSelector));
    (0, _react.useEffect)(function() {
        if (!(0, _dspFeature.isDSPFeatureEnabled)()) return;
        dispatch((0, _lp.getAuthorizedLps).request({
            getAuthorizedLpsInput: (0, _coralComAmazonCarrierlogisticswebserverModel.GetAuthorizedLogisticsPartiesInput).clone({
                serviceProviderIdentifierType: (0, _coralComAmazonCarrierlogisticswebserverModel.ServiceProviderIdentifierType).DSP_COMPANY_ID
            })
        }, (0, _actionTypes.GET_AUTHORIZED_LPS_REQUEST)));
    }, [
        dispatch
    ]);
    return authorizedDSPs;
}

},{"@amzn/carrierlogistics-commons/dist/utils/featureFlags/dspFeature":"jKlob","@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","react":"6uln9","react-redux":"3qqlL","../../actions/lp":"fg6Rs","../../actions/lp/actionTypes":"k7dvX","../../actions/lp/selectors":"e37s8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKlob":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDSPFeatureEnabled", ()=>isDSPFeatureEnabled);
function isDSPFeatureEnabled() {
    return localStorage.getItem("dsp-feature");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e8xZv":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _beer = require("./Beer");
parcelHelpers.exportAll(_beer, exports);
var _beerList = require("./BeerList");
parcelHelpers.exportAll(_beerList, exports);
var _beerListDefinition = require("./beerListDefinition");
parcelHelpers.exportAll(_beerListDefinition, exports);
var _carrierLogisticsWebServer = require("./CarrierLogisticsWebServer");
parcelHelpers.exportAll(_carrierLogisticsWebServer, exports);
var _clwsinvalidRequestException = require("./CLWSInvalidRequestException");
parcelHelpers.exportAll(_clwsinvalidRequestException, exports);
var _clwsrecoverableException = require("./CLWSRecoverableException");
parcelHelpers.exportAll(_clwsrecoverableException, exports);
var _clwsunauthorizedException = require("./CLWSUnauthorizedException");
parcelHelpers.exportAll(_clwsunauthorizedException, exports);
var _clwsunrecoverableException = require("./CLWSUnrecoverableException");
parcelHelpers.exportAll(_clwsunrecoverableException, exports);
var _dependencyException = require("./DependencyException");
parcelHelpers.exportAll(_dependencyException, exports);
var _entity = require("./Entity");
parcelHelpers.exportAll(_entity, exports);
var _entityFilterToEntityListMap = require("./EntityFilterToEntityListMap");
parcelHelpers.exportAll(_entityFilterToEntityListMap, exports);
var _entityFilterType = require("./EntityFilterType");
parcelHelpers.exportAll(_entityFilterType, exports);
var _entityList = require("./EntityList");
parcelHelpers.exportAll(_entityList, exports);
var _fileAccessInformation = require("./FileAccessInformation");
parcelHelpers.exportAll(_fileAccessInformation, exports);
var _fileAccessInformationList = require("./FileAccessInformationList");
parcelHelpers.exportAll(_fileAccessInformationList, exports);
var _fileIdentifierList = require("./FileIdentifierList");
parcelHelpers.exportAll(_fileIdentifierList, exports);
var _fileOperationType = require("./FileOperationType");
parcelHelpers.exportAll(_fileOperationType, exports);
var _getAuthorizedEntitiesInput = require("./GetAuthorizedEntitiesInput");
parcelHelpers.exportAll(_getAuthorizedEntitiesInput, exports);
var _getAuthorizedEntitiesOutput = require("./GetAuthorizedEntitiesOutput");
parcelHelpers.exportAll(_getAuthorizedEntitiesOutput, exports);
var _getAuthorizedLogisticsPartiesInput = require("./GetAuthorizedLogisticsPartiesInput");
parcelHelpers.exportAll(_getAuthorizedLogisticsPartiesInput, exports);
var _getAuthorizedLogisticsPartiesOutput = require("./GetAuthorizedLogisticsPartiesOutput");
parcelHelpers.exportAll(_getAuthorizedLogisticsPartiesOutput, exports);
var _getInlineHelpContentInput = require("./GetInlineHelpContentInput");
parcelHelpers.exportAll(_getInlineHelpContentInput, exports);
var _getInlineHelpContentOutput = require("./GetInlineHelpContentOutput");
parcelHelpers.exportAll(_getInlineHelpContentOutput, exports);
var _getLogisticsPartyDetailsInput = require("./GetLogisticsPartyDetailsInput");
parcelHelpers.exportAll(_getLogisticsPartyDetailsInput, exports);
var _getLogisticsPartyDetailsOutput = require("./GetLogisticsPartyDetailsOutput");
parcelHelpers.exportAll(_getLogisticsPartyDetailsOutput, exports);
var _getTermManualInput = require("./GetTermManualInput");
parcelHelpers.exportAll(_getTermManualInput, exports);
var _getTermManualOutput = require("./GetTermManualOutput");
parcelHelpers.exportAll(_getTermManualOutput, exports);
var _logisticsPartiesInfoList = require("./LogisticsPartiesInfoList");
parcelHelpers.exportAll(_logisticsPartiesInfoList, exports);
var _logisticsPartyDetails = require("./LogisticsPartyDetails");
parcelHelpers.exportAll(_logisticsPartyDetails, exports);
var _permissionToEntitiesMap = require("./PermissionToEntitiesMap");
parcelHelpers.exportAll(_permissionToEntitiesMap, exports);
var _presignedUrlInputParameters = require("./PresignedUrlInputParameters");
parcelHelpers.exportAll(_presignedUrlInputParameters, exports);
var _serviceProviderIdentifierType = require("./ServiceProviderIdentifierType");
parcelHelpers.exportAll(_serviceProviderIdentifierType, exports);

},{"./Beer":"7Z2vh","./BeerList":"dFBKs","./beerListDefinition":"gQq3q","./CarrierLogisticsWebServer":"42UE7","./CLWSInvalidRequestException":"dP371","./CLWSRecoverableException":"kckWl","./CLWSUnauthorizedException":"dvmWH","./CLWSUnrecoverableException":"jfPkF","./DependencyException":"lJKo3","./Entity":"dBmOE","./EntityFilterToEntityListMap":"lW7WK","./EntityFilterType":"8fP8o","./EntityList":"3kDVL","./FileAccessInformation":"5BHxq","./FileAccessInformationList":"ln81B","./FileIdentifierList":"d79F2","./FileOperationType":"2ALcE","./GetAuthorizedEntitiesInput":"9EHGO","./GetAuthorizedEntitiesOutput":"bwCiU","./GetAuthorizedLogisticsPartiesInput":"bwUMr","./GetAuthorizedLogisticsPartiesOutput":"bEpU9","./GetInlineHelpContentInput":"ciJIN","./GetInlineHelpContentOutput":"6Tkp0","./GetLogisticsPartyDetailsInput":"1Kk0F","./GetLogisticsPartyDetailsOutput":"igwZj","./GetTermManualInput":"0oBd0","./GetTermManualOutput":"3zHZ1","./LogisticsPartiesInfoList":"3a4P0","./LogisticsPartyDetails":"bYElY","./PermissionToEntitiesMap":"elCiD","./PresignedUrlInputParameters":"3P8gD","./ServiceProviderIdentifierType":"3eCMt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Z2vh":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Beer", ()=>Beer);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Beer] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBeer", ()=>validateBeer);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Beer extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Beer#clone(obj: PlainObjectFrom<Beer>) method.
     */ constructor(__name, __beerCompanyName, __beerId, __beerTypeName, __description){
        super();
        this.name = __name;
        this.beerCompanyName = __beerCompanyName;
        this.beerId = __beerId;
        this.beerTypeName = __beerTypeName;
        this.description = __description;
    }
    /**
     * Create a shallow clone of Beer from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Beer(obj.name, obj.beerCompanyName, obj.beerId, obj.beerTypeName, obj.description);
    }
    static fromJson(data) {
        return new Beer((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.name), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerCompanyName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerTypeName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.description));
    }
    static toJson(data) {
        return Object.assign({
            name: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.name),
            beerCompanyName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerCompanyName),
            beerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerId),
            beerTypeName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerTypeName),
            description: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.description)
        });
    }
}
Beer.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#Beer";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Beer);
function validateBeer(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9PLBl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _serdes = require("./serdes");
parcelHelpers.exportAll(_serdes, exports);

},{"./serdes":"bWygJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWygJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Contains helper methods for serializing/deserializing coral timestamps, blobs, and primitives
 * into Dates, Uint8Array, and corresponding primitive instances respectively.
 */ parcelHelpers.export(exports, "SerdesUtils", ()=>SerdesUtils);
var _typescriptBase64Arraybuffer = require("./vendor/typescript-base64-arraybuffer");
class SerdesUtils {
    static identityFunction(val) {
        return val;
    }
    static dateToJson(date) {
        return date.getTime() / 1000;
    }
    static blobToJson(blob) {
        return _typescriptBase64Arraybuffer.encode(blob.buffer);
    }
    static jsonToDate(timestamp) {
        return new Date(timestamp * 1000);
    }
    static jsonToBlob(blob) {
        return _typescriptBase64Arraybuffer.decode(blob);
    }
}

},{"./vendor/typescript-base64-arraybuffer":"9wbVH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9wbVH":[function(require,module,exports) {
// Source: https://www.npmjs.com/package/typescript-base64-arraybuffer
// Version: 0.1.0
// License: ISC © Rhett Robinson
// Note: Vended/shrinkwrapped here due to improper ES Module package.json.
// ---
// For the base64 encoding pieces.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
var alphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "+",
    "/"
];
var values = {};
for(var /** @type {?} */ i = 0; i < 64; ++i)values[alphabet[i]] = i;
/**
 * @param {?} bytes
 * @return {?}
 */ function encode(bytes) {
    var /** @type {?} */ array = new Uint8Array(bytes);
    var /** @type {?} */ base64 = [];
    var /** @type {?} */ index = 0;
    var /** @type {?} */ quantum;
    var /** @type {?} */ value;
    /* tslint:disable:no-bitwise */ // Grab as many sets of 3 bytes as we can, that form 24 bits.
    while(index + 2 < array.byteLength){
        quantum = array[index] << 16 | array[index + 1] << 8 | array[index + 2];
        // 24 bits will become 4 base64 chars.
        value = quantum >> 18 & 0x3f;
        base64.push(alphabet[value]);
        value = quantum >> 12 & 0x3f;
        base64.push(alphabet[value]);
        value = quantum >> 6 & 0x3f;
        base64.push(alphabet[value]);
        value = quantum & 0x3f;
        base64.push(alphabet[value]);
        index += 3;
    }
    // At this point, there are 0, 1 or 2 bytes left.
    if (index + 1 === array.byteLength) {
        // 8 bits; shift by 4 to pad on the right with 0s to make 12 bits total.
        quantum = array[index] << 4;
        value = quantum >> 6 & 0x3f;
        base64.push(alphabet[value]);
        value = quantum & 0x3f;
        base64.push(alphabet[value]);
        base64.push("==");
    } else if (index + 2 === array.byteLength) {
        // 16 bits; shift by 2 to pad on the right with 0s to make 18 bits total.
        quantum = array[index] << 10 | array[index + 1] << 2;
        value = quantum >> 12 & 0x3f;
        base64.push(alphabet[value]);
        value = quantum >> 6 & 0x3f;
        base64.push(alphabet[value]);
        value = quantum & 0x3f;
        base64.push(alphabet[value]);
        base64.push("=");
    }
    /* tslint:enable:no-bitwise */ return base64.join("");
}
/**
 * @param {?} string
 * @return {?}
 */ function decode(string) {
    var /** @type {?} */ size = string.length;
    if (size === 0) return new Uint8Array(new ArrayBuffer(0));
    if (size % 4 !== 0) throw new Error("Bad length: " + size);
    if (!string.match(/^[a-zA-Z0-9+/]+={0,2}$/)) throw new Error("Invalid base64 encoded value");
    // Every 4 base64 chars = 24 bits = 3 bytes. But, we also need to figure out
    // padding, if any.
    var /** @type {?} */ bytes = 3 * (size / 4);
    var /** @type {?} */ numPad = 0;
    if (string.charAt(size - 1) === "=") {
        numPad++;
        bytes--;
    }
    if (string.charAt(size - 2) === "=") {
        numPad++;
        bytes--;
    }
    var /** @type {?} */ buffer = new Uint8Array(new ArrayBuffer(bytes));
    var /** @type {?} */ index = 0;
    var /** @type {?} */ bufferIndex = 0;
    var /** @type {?} */ quantum;
    if (numPad > 0) size -= 4; // handle the last one specially
    /* tslint:disable:no-bitwise */ while(index < size){
        quantum = 0;
        for(var /** @type {?} */ i = 0; i < 4; ++i)quantum = quantum << 6 | values[string.charAt(index + i)];
        // quantum is now a 24-bit value.
        buffer[bufferIndex++] = quantum >> 16 & 0xff;
        buffer[bufferIndex++] = quantum >> 8 & 0xff;
        buffer[bufferIndex++] = quantum & 0xff;
        index += 4;
    }
    if (numPad > 0) {
        // if numPad == 1, there is one =, and we have 18 bits with 2 0s at end.
        // if numPad == 2, there is two ==, and we have 12 bits with 4 0s at end.
        // First, grab my quantum.
        quantum = 0;
        for(var /** @type {?} */ i = 0; i < 4 - numPad; ++i)quantum = quantum << 6 | values[string.charAt(index + i)];
        if (numPad === 1) {
            // quantum is 18 bits, but really represents two bytes.
            quantum = quantum >> 2;
            buffer[bufferIndex++] = quantum >> 8 & 0xff;
            buffer[bufferIndex++] = quantum & 0xff;
        } else {
            // quantum is 12 bits, but really represents only one byte.
            quantum = quantum >> 4;
            buffer[bufferIndex++] = quantum & 0xff;
        }
    }
    /* tslint:enable:no-bitwise */ return buffer;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eOj61":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _handlers = require("./handlers");
parcelHelpers.exportAll(_handlers, exports);
var _interceptors = require("./interceptors");
parcelHelpers.exportAll(_interceptors, exports);
var _model = require("./model");
parcelHelpers.exportAll(_model, exports);

},{"./client":"7JSEz","./handlers":"l9D3Q","./interceptors":"lofXI","./model":"8kt8R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JSEz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clientFactory = require("./client-factory");
parcelHelpers.exportAll(_clientFactory, exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _configFactory = require("./config-factory");
parcelHelpers.exportAll(_configFactory, exports);
var _partitionCoralClientConfigFactory = require("./partition-coral-client-config-factory");
parcelHelpers.exportAll(_partitionCoralClientConfigFactory, exports);
var _coralRequest = require("./coral-request");
parcelHelpers.exportAll(_coralRequest, exports);
var _coralResponse = require("./coral-response");
parcelHelpers.exportAll(_coralResponse, exports);
var _errors = require("./errors");
parcelHelpers.exportAll(_errors, exports);

},{"./client-factory":"7iQ4d","./client":"1FBEe","./config-factory":"8WUGh","./partition-coral-client-config-factory":"amNSK","./coral-request":"2PeF2","./coral-response":"kISDu","./errors":"50875","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7iQ4d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A repository of instantiated CoralClients.
 *
 * Applications may want to create a singleton instance of this class as an easy
 * way to maintain a list of global interceptors, default qualifier, and the
 * list of available service configurations.
 */ parcelHelpers.export(exports, "CoralClientFactory", ()=>CoralClientFactory);
var _errors = require("./errors");
var _interceptingHandler = require("../interceptors/intercepting-handler");
class CoralClientFactory {
    constructor(clientConfigFactories, qualifier, handler, globalInterceptors = []){
        this.qualifier = qualifier;
        this.chain = new (0, _interceptingHandler.InterceptingHandler)(handler, globalInterceptors);
        this.clientConfigFactoryRegistry = new Map(clientConfigFactories.map((factory)=>{
            return [
                factory.service,
                factory
            ];
        }));
        this.clientRegistry = new Map;
    }
    /**
     * Create a new instance of a given CoralClient.
     *
     * Will always instantiate a new object, and will *not* persist that instance
     * in the client registry.
     */ create(Constructor, qualifier = this.qualifier) {
        const configFactory = this.getConfigFactoryForService(Constructor.serviceName);
        return new Constructor(configFactory.getConfigForQualifier(qualifier), this.chain);
    }
    /**
     * Return an instance of the given CoralClient for a given (or default) qualifier.
     *
     * This will re-use an existing instance if one was already created for the
     * given CoralClient type with the given qualifier. If no such object exists,
     * a new client will be created and persisted for later re-use.
     */ get(Constructor, qualifier = this.qualifier) {
        const qualifiedClientRegistry = this.clientRegistry.get(qualifier) || new Map;
        const registeredClient = qualifiedClientRegistry.get(Constructor);
        if (registeredClient) return registeredClient;
        const client = this.create(Constructor, qualifier);
        qualifiedClientRegistry.set(Constructor, client);
        this.clientRegistry.set(qualifier, qualifiedClientRegistry);
        return client;
    }
    getConfigFactoryForService(serviceName) {
        const configFactory = this.clientConfigFactoryRegistry.get(serviceName);
        if (!configFactory) throw new (0, _errors.CoralClientConfigNotFound)(serviceName);
        return configFactory;
    }
}

},{"./errors":"50875","../interceptors/intercepting-handler":"2p2GN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50875":[function(require,module,exports) {
// tslint:disable:max-classes-per-file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralClientConfigNotFound", ()=>CoralClientConfigNotFound);
/**
 * Catch-all exception for Coral operations when an unmodeled exception is received
 * or if a network failure occurs.
 *
 * Clients can access the <i>receivedException</i> property to inspect the
 * underlying error, and <i>status</i> to inspect the response status.
 */ parcelHelpers.export(exports, "UnknownCoralError", ()=>UnknownCoralError);
/**
 * Exception indicating that an `input` string expected to be JSON but was actually not.
 */ parcelHelpers.export(exports, "JsonParsingException", ()=>JsonParsingException);
class CoralClientConfigNotFound extends ReferenceError {
    constructor(service, { qualifier, key } = {}){
        const keyClause = key ? `, key: "${key}"` : "";
        const qualifierClause = qualifier ? ` with qualifier "${qualifier}"` : "";
        const message = `[CoralClientConfigNotFound] No config found for ` + `${service}${qualifierClause}${keyClause}`;
        super(message);
        // as of TS2.1, extending built-ins like Error require a little extra
        // boilerplate to work properly. In TS2.2 this boilerplate was reduced, but
        // it's still necessary. For more, see:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class UnknownCoralError extends Error {
    constructor(receivedException, status){
        super("[UnknownCoralError] Encountered unknown coral exception");
        this.receivedException = receivedException;
        this.status = status;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class JsonParsingException extends Error {
    constructor(input, e){
        super("[JsonParsingException] Could not parse the response as JSON: " + `${input.substr(0, JsonParsingException.MAX_INPUT_LENGTH)}, original exception: ${e.message}`);
        this.input = input;
        this.e = e;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
JsonParsingException.MAX_INPUT_LENGTH = 1000; // prevent extra long errors from clogging the logs

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2p2GN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Compose a list of interceptors with a given CoralHandler to produce a chain
 * of interceptors which will each be called before the handler finally is
 * called to handle the request.
 */ parcelHelpers.export(exports, "InterceptingHandler", ()=>InterceptingHandler);
class InterceptorRequestHandler {
    constructor(next, interceptor){
        this.next = next;
        this.interceptor = interceptor;
    }
    handle(request) {
        return this.interceptor.intercept(request, this.next);
    }
}
class InterceptingHandler {
    constructor(handler, interceptors){
        this.handler = handler;
        this.handlerChain = interceptors.reduceRight((next, interceptor)=>{
            return new InterceptorRequestHandler(next, interceptor);
        }, this.handler);
    }
    handle(request) {
        return this.handlerChain.handle(request);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1FBEe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Framework-agnostic abstract Coral service client. Service-specific clients
 * will be generated as concrete subclasses.
 *
 * The structure of this client is heavily influenced by the Angular HttpClient,
 * while remaining framework-agnostic.
 *
 * The handler is responsible for consuming requests and producing responses.
 * When supporting interceptors, this will be an instance of
 * InterceptingRequestHandler -- see CoralClientFactory for an example.
 *
 * (see https://angular.io/guide/http#intercepting-requests-and-responses for
 * more general info on interceptors)
 */ parcelHelpers.export(exports, "CoralClient", ()=>CoralClient);
var _coralRequest = require("./coral-request");
class CoralClient {
    constructor(config, handler){
        this.config = config;
        this.handler = handler;
    }
    /**
     * Make a Coral service request.
     */ call(operation, data) {
        const { assembly, serviceName } = this.constructor;
        const headers = this.constructHeaders(assembly, serviceName, operation);
        return this.handler.handle(new (0, _coralRequest.CoralRequest)({
            body: data,
            config: this.config,
            headers,
            operation,
            serviceName,
            url: this.config.httpEndpoint.url
        }));
    }
    constructHeaders(assembly, serviceName, operation) {
        return [
            [
                "Content-Encoding",
                "amz-1.0"
            ],
            [
                "Content-Type",
                "application/json;charset=UTF-8"
            ],
            [
                "X-Amz-Target",
                `${assembly}.${serviceName}.${operation}`
            ]
        ];
    }
}

},{"./coral-request":"2PeF2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2PeF2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Coral clients need a framework-agnostic request class that can be easily
 * copied (to support e.g. serialization, auth, etc.)
 *
 * The spec-compliant Request class falls short, as there is no easy way to copy
 * it -- in particular, the body can only be read once and is only available
 * asynchronously.
 *
 * The CoralRequest can also simplify some constituent types (e.g. headers), while
 * also ensuring certain default values (POST method, include credentials).
 */ parcelHelpers.export(exports, "CoralRequest", ()=>CoralRequest);
var _headers = require("../common/headers");
class CoralRequest {
    constructor(init){
        Object.assign(this, init);
        // explicit assignment avoids compiler warning that readonly properties
        // are not definitely set in the constructor.
        this.config = init.config;
        this.credentials = init.credentials || "include";
        this.headers = init.headers;
        this.operation = init.operation;
        this.method = init.method || "POST";
        this.serviceName = init.serviceName;
        this.url = init.url;
    }
    /**
     * Clone the request with one or more updated properties.
     *
     * By default, `signal` will not be shared with the cloned request -- if that
     * behavior is desirable, do `request.clone({signal: request.signal})`
     */ clone(update) {
        // by default, do not share signals between requests.
        return new CoralRequest(Object.assign(Object.assign(Object.assign({}, this), {
            signal: null
        }), update));
    }
    /**
     * Convert to a native HTML-spec-compliant Request instance.
     */ toNativeRequest() {
        return new Request(this.url, Object.assign({}, this, {
            headers: (0, _headers.getHeaderList)(this.getHeaderBag())
        }));
    }
    /** Convert headers from list to map. */ getHeaderBag() {
        return (0, _headers.getHeaderBag)(this.headers);
    }
}

},{"../common/headers":"4CIZw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CIZw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHeaderBag", ()=>getHeaderBag);
parcelHelpers.export(exports, "getHeaderList", ()=>getHeaderList);
function getHeaderBag(headers) {
    return headers.reduce((acc, [header, ...values])=>Object.assign(Object.assign({}, acc), {
            [header]: values.join(", ")
        }), {});
}
function getHeaderList(headerBag) {
    return Object.entries(headerBag);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8WUGh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Config factory backed by key-value pairs where the key is the qualifier and the value is CoralConfigSchema instance.
 */ parcelHelpers.export(exports, "CoralClientConfigFactory", ()=>CoralClientConfigFactory);
var _errors = require("./errors");
function hasRequiredFields(config) {
    return config != null && config.httpEndpoint != null && config.httpEndpoint.url != null;
}
class CoralClientConfigFactory {
    constructor(service, configs){
        this.service = service;
        this.getConfigForQualifier = (qualifier)=>{
            const config = configs[qualifier];
            if (hasRequiredFields(config)) return config;
            throw new (0, _errors.CoralClientConfigNotFound)(this.service, {
                qualifier
            });
        };
    }
}

},{"./errors":"50875","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amNSK":[function(require,module,exports) {
/**
 * Wrap config to operate on partitioned endpoints.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PartitionCoralClientConfigFactory", ()=>PartitionCoralClientConfigFactory);
class PartitionCoralClientConfigFactory {
    constructor(partition, factory){
        this.service = factory.service;
        this.getConfigForQualifier = (qualifier)=>{
            const config = factory.getConfigForQualifier(qualifier);
            return Object.assign(Object.assign({}, config), {
                httpEndpoint: Object.assign(Object.assign({}, config.httpEndpoint), {
                    url: config.httpEndpoint.url.replace(/\bPARTITION\b/, partition)
                })
            });
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kISDu":[function(require,module,exports) {
/**
 * Framework-agnostic generic Coral response, allowing individual operations
 * to return properly-typed response bodies.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralResponse", ()=>CoralResponse);
class CoralResponse {
    constructor(init){
        this.body = init.body || null;
        this.headers = init.headers || [];
        this.status = init.status;
        this.statusText = init.statusText;
        this.url = init.url || null;
        this.ok = init.ok;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l9D3Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHandler = require("./fetch-handler");
parcelHelpers.exportAll(_fetchHandler, exports);
var _handler = require("./handler");
parcelHelpers.exportAll(_handler, exports);

},{"./fetch-handler":"iNqWI","./handler":"7fbkw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNqWI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handle Coral requests using the Fetch API, producing an Observable of the
 * response.
 *
 * When the Observable is unsubscribed, the request will be aborted (if
 * it hasn't already completed).
 *
 * The handler is constructed with a fetch implementation where the default is
 * the global *fetch* implementation. Clients may choose to provide their own
 * implementation (eg. SentryFetch, node-fetch), if required.
 * This handler would just handle the json responses in body. In case of empty
 * body or non valid json body, it would throw error.
 */ parcelHelpers.export(exports, "CoralFetchHandler", ()=>CoralFetchHandler);
var _rxjs = require("rxjs");
var _client = require("../client");
var global = arguments[3];
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const fetchThis = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : window;
class CoralFetchHandler {
    constructor(fetchImpl = fetch.bind(fetchThis)){
        this.fetchImpl = fetchImpl;
    }
    handle(request) {
        return new (0, _rxjs.Observable)((observer)=>{
            const controller = new AbortController;
            // Convert body to JSON string
            const body = !request.body || typeof request.body === "string" ? request.body : JSON.stringify(request.body);
            const abortableRequest = request.clone({
                body,
                signal: controller.signal
            });
            this.fetchImpl(abortableRequest.toNativeRequest()).then((response)=>__awaiter(this, void 0, void 0, function*() {
                    const responseText = yield response.text();
                    const responseBody = responseText.length ? parseJsonOrThrow(responseText) : undefined;
                    const headers = Array.from(response.headers.entries());
                    return new (0, _client.CoralResponse)({
                        headers,
                        body: responseBody,
                        status: response.status,
                        ok: response.ok,
                        url: response.url,
                        statusText: response.statusText
                    });
                })).then(observer.next.bind(observer)).catch(observer.error.bind(observer)).finally(observer.complete.bind(observer));
            // Return a function to be called when the Observable is unsubscribed.
            return ()=>controller.abort();
        });
    }
}
/**
 * Helper function that parses JSON and returns the parsed object.
 * If it fails, the function throws a custom exception capturing the exact input (for debugging purposes).
 * @param input - a string of JSON to parse
 */ function parseJsonOrThrow(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        if (e instanceof Error) throw new (0, _client.JsonParsingException)(input, e);
        else throw new (0, _client.JsonParsingException)(input, new Error(`${e}`));
    }
}

},{"rxjs":"gxhPq","../client":"7JSEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxhPq":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":"9oc0x","./internal/observable/ConnectableObservable":"f4mOY","./internal/operators/groupBy":"g6z19","./internal/symbol/observable":"9l5a7","./internal/Subject":"84bef","./internal/BehaviorSubject":"anOW9","./internal/ReplaySubject":"gRMu9","./internal/AsyncSubject":"6P7LP","./internal/scheduler/asap":"5Pp9f","./internal/scheduler/async":"l1cmn","./internal/scheduler/queue":"9CC3u","./internal/scheduler/animationFrame":"5JNHq","./internal/scheduler/VirtualTimeScheduler":"5SGjm","./internal/Scheduler":"7PKfs","./internal/Subscription":"ahthJ","./internal/Subscriber":"jGx8F","./internal/Notification":"3c26n","./internal/util/pipe":"4asJs","./internal/util/noop":"4s4qZ","./internal/util/identity":"kDT9y","./internal/util/isObservable":"6AlwM","./internal/util/ArgumentOutOfRangeError":"38Gbx","./internal/util/EmptyError":"7a4tA","./internal/util/ObjectUnsubscribedError":"xtsCl","./internal/util/UnsubscriptionError":"byliX","./internal/util/TimeoutError":"iA33G","./internal/observable/bindCallback":"28HCa","./internal/observable/bindNodeCallback":"aiFEB","./internal/observable/combineLatest":"wg3KP","./internal/observable/concat":"2cXL0","./internal/observable/defer":"1uvAg","./internal/observable/empty":"J4JDz","./internal/observable/forkJoin":"37dhH","./internal/observable/from":"6aqs0","./internal/observable/fromEvent":"7pSEN","./internal/observable/fromEventPattern":"fxxhB","./internal/observable/generate":"fBVaJ","./internal/observable/iif":"17pPY","./internal/observable/interval":"fMFuc","./internal/observable/merge":"38GKY","./internal/observable/never":"3FrL8","./internal/observable/of":"alTvf","./internal/observable/onErrorResumeNext":"hm3A5","./internal/observable/pairs":"iTEBj","./internal/observable/partition":"8Djd6","./internal/observable/race":"6YL9k","./internal/observable/range":"cuk43","./internal/observable/throwError":"4BUNm","./internal/observable/timer":"jufOf","./internal/observable/using":"jpgyo","./internal/observable/zip":"57TWv","./internal/scheduled/scheduled":"3d02Q","./internal/config":"aKksQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9oc0x":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"keo8s","./util/toSubscriber":"8Nysp","./symbol/observable":"9l5a7","./util/pipe":"4asJs","./config":"aKksQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"keo8s":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGx8F":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"gBS4y","./util/isFunction":"atYNr","./Observer":"g4n0O","./Subscription":"ahthJ","../internal/symbol/rxSubscriber":"6DhWt","./config":"aKksQ","./util/hostReportError":"l3YZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBS4y":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"atYNr":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g4n0O":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"aKksQ","./util/hostReportError":"l3YZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKksQ":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l3YZ5":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ahthJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"2HaTi","./util/isObject":"6Fmw6","./util/isFunction":"atYNr","./util/UnsubscriptionError":"byliX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2HaTi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Fmw6":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byliX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6DhWt":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Nysp":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"jGx8F","../symbol/rxSubscriber":"6DhWt","../Observer":"g4n0O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9l5a7":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4asJs":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDT9y":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4mOY":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectableObservable", ()=>ConnectableObservable);
parcelHelpers.export(exports, "connectableObservableDescriptor", ()=>connectableObservableDescriptor);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _observable = require("../Observable");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
var _refCount = require("../operators/refCount");
var ConnectableObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new (0, _subscription.Subscription)();
            connection.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = (0, _subscription.Subscription).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, _refCount.refCount)()(this);
    };
    return ConnectableObservable;
}((0, _observable.Observable));
var connectableObservableDescriptor = /*@__PURE__*/ function() {
    var connectableProto = ConnectableObservable.prototype;
    return {
        operator: {
            value: null
        },
        _refCount: {
            value: 0,
            writable: true
        },
        _subject: {
            value: null,
            writable: true
        },
        _connection: {
            value: null,
            writable: true
        },
        _subscribe: {
            value: connectableProto._subscribe
        },
        _isComplete: {
            value: connectableProto._isComplete,
            writable: true
        },
        getSubject: {
            value: connectableProto.getSubject
        },
        connect: {
            value: connectableProto.connect
        },
        refCount: {
            value: connectableProto.refCount
        }
    };
}();
var ConnectableSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}((0, _subject.SubjectSubscriber));
var RefCountOperator = /*@__PURE__*/ function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var RefCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subject":"84bef","../Observable":"9oc0x","../Subscriber":"jGx8F","../Subscription":"ahthJ","../operators/refCount":"ihxKV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"84bef":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"gBS4y","./Observable":"9oc0x","./Subscriber":"jGx8F","./Subscription":"ahthJ","./util/ObjectUnsubscribedError":"xtsCl","./SubjectSubscription":"9Q6jX","../internal/symbol/rxSubscriber":"6DhWt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xtsCl":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Q6jX":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"gBS4y","./Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihxKV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refCount", ()=>refCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var RefCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6z19":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
parcelHelpers.export(exports, "GroupedObservable", ()=>GroupedObservable);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
var _observable = require("../Observable");
var _subject = require("../Subject");
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
var GroupBySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = new Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new (0, _subject.Subject)();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}((0, _subscriber.Subscriber));
var GroupDurationSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}((0, _subscriber.Subscriber));
var GroupedObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new (0, _subscription.Subscription)();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}((0, _observable.Observable));
var InnerRefCountSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}((0, _subscription.Subscription));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../Subscription":"ahthJ","../Observable":"9oc0x","../Subject":"84bef","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anOW9":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var BehaviorSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"gBS4y","./Subject":"84bef","./util/ObjectUnsubscribedError":"xtsCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gRMu9":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _queue = require("./scheduler/queue");
var _subscription = require("./Subscription");
var _observeOn = require("./operators/observeOn");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var ReplaySubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        } else _this.next = _this.nextTimeWindow;
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function(value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function(value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.isStopped || this.hasError) subscription = (0, _subscription.Subscription).EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new (0, _observeOn.ObserveOnSubscriber)(subscriber, scheduler));
        if (_infiniteTimeWindow) for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i]);
        else for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || (0, _queue.queue)).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}((0, _subject.Subject));
var ReplayEvent = /*@__PURE__*/ function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

},{"tslib":"gBS4y","./Subject":"84bef","./scheduler/queue":"9CC3u","./Subscription":"ahthJ","./operators/observeOn":"8iKY0","./util/ObjectUnsubscribedError":"xtsCl","./SubjectSubscription":"9Q6jX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CC3u":[function(require,module,exports) {
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = /*@__PURE__*/ new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"5ysZC","./QueueScheduler":"hVNPQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ysZC":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"gBS4y","./AsyncAction":"5Tduw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Tduw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var AsyncAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"gBS4y","./Action":"4kx73","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kx73":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"gBS4y","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVNPQ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"gBS4y","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l4ot2":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"gBS4y","../Scheduler":"7PKfs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7PKfs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var Scheduler = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iKY0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
parcelHelpers.export(exports, "ObserveOnOperator", ()=>ObserveOnOperator);
parcelHelpers.export(exports, "ObserveOnSubscriber", ()=>ObserveOnSubscriber);
parcelHelpers.export(exports, "ObserveOnMessage", ()=>ObserveOnMessage);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var ObserveOnSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, _notification.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, _notification.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, _subscriber.Subscriber));
var ObserveOnMessage = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../Notification":"3c26n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3c26n":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var NotificationKind;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, _of.of)(this.value);
            case "E":
                return (0, _throwError.throwError)(this.error);
            case "C":
                return (0, _empty.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

},{"./observable/empty":"J4JDz","./observable/of":"alTvf","./observable/throwError":"4BUNm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"J4JDz":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = /*@__PURE__*/ new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"alTvf":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _isScheduler = require("../util/isScheduler");
var _fromArray = require("./fromArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        args.pop();
        return (0, _scheduleArray.scheduleArray)(args, scheduler);
    } else return (0, _fromArray.fromArray)(args);
}

},{"../util/isScheduler":"4iYg4","./fromArray":"b1aUF","../scheduled/scheduleArray":"7CQYE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iYg4":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
function isScheduler(value) {
    return value && typeof value.schedule === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1aUF":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromArray", ()=>fromArray);
var _observable = require("../Observable");
var _subscribeToArray = require("../util/subscribeToArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function fromArray(input, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)((0, _subscribeToArray.subscribeToArray)(input));
    else return (0, _scheduleArray.scheduleArray)(input, scheduler);
}

},{"../Observable":"9oc0x","../util/subscribeToArray":"av2hi","../scheduled/scheduleArray":"7CQYE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"av2hi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7CQYE":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BUNm":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
function throwError(error, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6P7LP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncSubject", ()=>AsyncSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _subscription = require("./Subscription");
var AsyncSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}((0, _subject.Subject));

},{"tslib":"gBS4y","./Subject":"84bef","./Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Pp9f":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = /*@__PURE__*/ new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"dfAb5","./AsapScheduler":"iCzDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfAb5":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var _asyncAction = require("./AsyncAction");
var AsapAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, _immediate.Immediate).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, _immediate.Immediate).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"gBS4y","../util/Immediate":"8ngek","./AsyncAction":"5Tduw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ngek":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCzDz":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"gBS4y","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1cmn":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = /*@__PURE__*/ new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"5Tduw","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5JNHq":[function(require,module,exports) {
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameScheduler", ()=>animationFrameScheduler);
parcelHelpers.export(exports, "animationFrame", ()=>animationFrame);
var _animationFrameAction = require("./AnimationFrameAction");
var _animationFrameScheduler = require("./AnimationFrameScheduler");
var animationFrameScheduler = /*@__PURE__*/ new (0, _animationFrameScheduler.AnimationFrameScheduler)((0, _animationFrameAction.AnimationFrameAction));
var animationFrame = animationFrameScheduler;

},{"./AnimationFrameAction":"IJG8Q","./AnimationFrameScheduler":"hxiBN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IJG8Q":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameAction", ()=>AnimationFrameAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var AnimationFrameAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function() {
            return scheduler.flush(null);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"gBS4y","./AsyncAction":"5Tduw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hxiBN":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameScheduler", ()=>AnimationFrameScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AnimationFrameScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"gBS4y","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5SGjm":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>VirtualTimeScheduler);
parcelHelpers.export(exports, "VirtualAction", ()=>VirtualAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var VirtualTimeScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) SchedulerAction = VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, SchedulerAction, function() {
            return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions[0]) && action.delay <= maxFrames){
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}((0, _asyncScheduler.AsyncScheduler));
var VirtualAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"gBS4y","./AsyncAction":"5Tduw","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4s4qZ":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6AlwM":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObservable", ()=>isObservable);
var _observable = require("../Observable");
function isObservable(obj) {
    return !!obj && (obj instanceof (0, _observable.Observable) || typeof obj.lift === "function" && typeof obj.subscribe === "function");
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38Gbx":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>ArgumentOutOfRangeError);
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7a4tA":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyError", ()=>EmptyError);
var EmptyErrorImpl = /*@__PURE__*/ function() {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = "no elements in sequence";
        this.name = "EmptyError";
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
}();
var EmptyError = EmptyErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iA33G":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
var TimeoutErrorImpl = /*@__PURE__*/ function() {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
}();
var TimeoutError = TimeoutErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"28HCa":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallback", ()=>bindCallback);
var _observable = require("../Observable");
var _asyncSubject = require("../AsyncSubject");
var _map = require("../operators/map");
var _canReportError = require("../util/canReportError");
var _isArray = require("../util/isArray");
var _isScheduler = require("../util/isScheduler");
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe((0, _map.map)(function(args) {
                return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
            }));
        };
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler
        };
        return new (0, _observable.Observable)(function(subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new (0, _asyncSubject.AsyncSubject)();
                    var handler = function() {
                        var innerArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([
                            handler
                        ]));
                    } catch (err) {
                        if ((0, _canReportError.canReportError)(subject)) subject.error(err);
                        else console.warn(err);
                    }
                }
                return subject.subscribe(subscriber);
            } else {
                var state = {
                    args: args,
                    subscriber: subscriber,
                    params: params
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
        var handler = function() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, {
                value: value,
                subject: subject
            }));
        };
        try {
            callbackFunc.apply(context, args.concat([
                handler
            ]));
        } catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}

},{"../Observable":"9oc0x","../AsyncSubject":"6P7LP","../operators/map":"cvzfg","../util/canReportError":"keo8s","../util/isArray":"2HaTi","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvzfg":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aiFEB":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindNodeCallback", ()=>bindNodeCallback);
var _observable = require("../Observable");
var _asyncSubject = require("../AsyncSubject");
var _map = require("../operators/map");
var _canReportError = require("../util/canReportError");
var _isScheduler = require("../util/isScheduler");
var _isArray = require("../util/isArray");
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe((0, _map.map)(function(args) {
                return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
            }));
        };
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this
        };
        return new (0, _observable.Observable)(function(subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
                    var handler = function() {
                        var innerArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([
                            handler
                        ]));
                    } catch (err) {
                        if ((0, _canReportError.canReportError)(subject)) subject.error(err);
                        else console.warn(err);
                    }
                }
                return subject.subscribe(subscriber);
            } else return scheduler.schedule(dispatch, 0, {
                params: params,
                subscriber: subscriber,
                context: context
            });
        });
    };
}
function dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
        var handler = function() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
            var err = innerArgs.shift();
            if (err) _this.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([
                handler
            ]));
        } catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subject: subject
            }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

},{"../Observable":"9oc0x","../AsyncSubject":"6P7LP","../operators/map":"cvzfg","../util/canReportError":"keo8s","../util/isScheduler":"4iYg4","../util/isArray":"2HaTi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wg3KP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
parcelHelpers.export(exports, "CombineLatestOperator", ()=>CombineLatestOperator);
parcelHelpers.export(exports, "CombineLatestSubscriber", ()=>CombineLatestSubscriber);
var _tslib = require("tslib");
var _isScheduler = require("../util/isScheduler");
var _isArray = require("../util/isArray");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
var _fromArray = require("./fromArray");
var NONE = {};
function combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = undefined;
    var scheduler = undefined;
    if ((0, _isScheduler.isScheduler)(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === "function") resultSelector = observables.pop();
    if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0];
    return (0, _fromArray.fromArray)(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ function() {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}();
var CombineLatestSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add((0, _subscribeToResult.subscribeToResult)(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) this._tryResultSelector(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function(values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"gBS4y","../util/isScheduler":"4iYg4","../util/isArray":"2HaTi","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","./fromArray":"b1aUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fECUl":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OuterSubscriber", ()=>OuterSubscriber);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var OuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","./Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ctqX":[function(require,module,exports) {
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToResult", ()=>subscribeToResult);
var _innerSubscriber = require("../InnerSubscriber");
var _subscribeTo = require("./subscribeTo");
var _observable = require("../Observable");
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) innerSubscriber = new (0, _innerSubscriber.InnerSubscriber)(outerSubscriber, outerValue, outerIndex);
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    return (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
}

},{"../InnerSubscriber":"93bks","./subscribeTo":"fU69c","../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93bks":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerSubscriber", ()=>InnerSubscriber);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var InnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","./Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fU69c":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"av2hi","./subscribeToPromise":"4BxHE","./subscribeToIterable":"04UeX","./subscribeToObservable":"dZiTJ","./isArrayLike":"go7hX","./isPromise":"9CjT0","./isObject":"6Fmw6","../symbol/iterator":"jShcT","../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BxHE":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"l3YZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"04UeX":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"jShcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jShcT":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZiTJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"go7hX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CjT0":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cXL0":[function(require,module,exports) {
/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _of = require("./of");
var _concatAll = require("../operators/concatAll");
function concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _of.of).apply(void 0, observables));
}

},{"./of":"alTvf","../operators/concatAll":"8bdTP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bdTP":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", ()=>concatAll);
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"jXE8c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXE8c":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"7NAZz","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NAZz":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
parcelHelpers.export(exports, "MergeMapOperator", ()=>MergeMapOperator);
parcelHelpers.export(exports, "MergeMapSubscriber", ()=>MergeMapSubscriber);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(mergeMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new MergeMapOperator(project, concurrent));
    };
}
var MergeMapOperator = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));
var flatMap = mergeMap;

},{"tslib":"gBS4y","./map":"cvzfg","../observable/from":"6aqs0","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6aqs0":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"9oc0x","../util/subscribeTo":"fU69c","../scheduled/scheduled":"3d02Q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3d02Q":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"hGPHf","./schedulePromise":"4mYM9","./scheduleArray":"7CQYE","./scheduleIterable":"601jO","../util/isInteropObservable":"ivPHI","../util/isPromise":"9CjT0","../util/isArrayLike":"go7hX","../util/isIterable":"7bSqA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGPHf":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4mYM9":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"601jO":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","../symbol/iterator":"jShcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivPHI":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bSqA":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"jShcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73frt":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

},{"tslib":"gBS4y","./Subscriber":"jGx8F","./Observable":"9oc0x","./util/subscribeTo":"fU69c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1uvAg":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defer", ()=>defer);
var _observable = require("../Observable");
var _from = require("./from");
var _empty = require("./empty");
function defer(observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var input;
        try {
            input = observableFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? (0, _from.from)(input) : (0, _empty.empty)();
        return source.subscribe(subscriber);
    });
}

},{"../Observable":"9oc0x","./from":"6aqs0","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"37dhH":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forkJoin", ()=>forkJoin);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _map = require("../operators/map");
var _isObject = require("../util/isObject");
var _from = require("./from");
function forkJoin() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 1) {
        var first_1 = sources[0];
        if ((0, _isArray.isArray)(first_1)) return forkJoinInternal(first_1, null);
        if ((0, _isObject.isObject)(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function(key) {
                return first_1[key];
            }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === "function") {
        var resultSelector_1 = sources.pop();
        sources = sources.length === 1 && (0, _isArray.isArray)(sources[0]) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe((0, _map.map)(function(args) {
            return resultSelector_1.apply(void 0, args);
        }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new (0, _observable.Observable)(function(subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function(i) {
            var source = (0, _from.from)(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function(value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function(err) {
                    return subscriber.error(err);
                },
                complete: function() {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) subscriber.next(keys ? keys.reduce(function(result, key, i) {
                            return result[key] = values[i], result;
                        }, {}) : values);
                        subscriber.complete();
                    }
                }
            }));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
    });
}

},{"../Observable":"9oc0x","../util/isArray":"2HaTi","../operators/map":"cvzfg","../util/isObject":"6Fmw6","./from":"6aqs0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7pSEN":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _isFunction = require("../util/isFunction");
var _map = require("../operators/map");
var toString = /*@__PURE__*/ function() {
    return Object.prototype.toString;
}();
function fromEvent(target, eventName, options, resultSelector) {
    if ((0, _isFunction.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return fromEvent(target, eventName, options).pipe((0, _map.map)(function(args) {
        return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, _observable.Observable)(function(subscriber) {
        function handler(e) {
            if (arguments.length > 1) subscriber.next(Array.prototype.slice.call(arguments));
            else subscriber.next(e);
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function() {
            return source_1.removeEventListener(eventName, handler, options);
        };
    } else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function() {
            return source_2.off(eventName, handler);
        };
    } else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function() {
            return source_3.removeListener(eventName, handler);
        };
    } else if (sourceObj && sourceObj.length) for(var i = 0, len = sourceObj.length; i < len; i++)setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
    else throw new TypeError("Invalid event target");
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === "function" && typeof sourceObj.removeListener === "function";
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === "function" && typeof sourceObj.off === "function";
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === "function" && typeof sourceObj.removeEventListener === "function";
}

},{"../Observable":"9oc0x","../util/isArray":"2HaTi","../util/isFunction":"atYNr","../operators/map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxxhB":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEventPattern", ()=>fromEventPattern);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _isFunction = require("../util/isFunction");
var _map = require("../operators/map");
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return fromEventPattern(addHandler, removeHandler).pipe((0, _map.map)(function(args) {
        return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!(0, _isFunction.isFunction)(removeHandler)) return undefined;
        return function() {
            return removeHandler(handler, retValue);
        };
    });
}

},{"../Observable":"9oc0x","../util/isArray":"2HaTi","../util/isFunction":"atYNr","../operators/map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fBVaJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>generate);
var _observable = require("../Observable");
var _identity = require("../util/identity");
var _isScheduler = require("../util/isScheduler");
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || (0, _identity.identity);
        scheduler = options.scheduler;
    } else if (resultSelectorOrObservable === undefined || (0, _isScheduler.isScheduler)(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = (0, _identity.identity);
        scheduler = resultSelectorOrObservable;
    } else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var state = initialState;
        if (scheduler) return scheduler.schedule(dispatch, 0, {
            subscriber: subscriber,
            iterate: iterate,
            condition: condition,
            resultSelector: resultSelector,
            state: state
        });
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return undefined;
            }
        }while (true);
        return undefined;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) return undefined;
    if (state.needIterate) try {
        state.state = state.iterate(state.state);
    } catch (err) {
        subscriber.error(err);
        return undefined;
    }
    else state.needIterate = true;
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) return undefined;
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    } catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) return undefined;
    subscriber.next(value);
    if (subscriber.closed) return undefined;
    return this.schedule(state);
}

},{"../Observable":"9oc0x","../util/identity":"kDT9y","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17pPY":[function(require,module,exports) {
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iif", ()=>iif);
var _defer = require("./defer");
var _empty = require("./empty");
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) trueResult = (0, _empty.EMPTY);
    if (falseResult === void 0) falseResult = (0, _empty.EMPTY);
    return (0, _defer.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

},{"./defer":"1uvAg","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMFuc":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interval", ()=>interval);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
function interval(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    if (!(0, _isNumeric.isNumeric)(period) || period < 0) period = 0;
    if (!scheduler || typeof scheduler.schedule !== "function") scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, {
            subscriber: subscriber,
            counter: 0,
            period: period
        }));
        return subscriber;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({
        subscriber: subscriber,
        counter: counter + 1,
        period: period
    }, period);
}

},{"../Observable":"9oc0x","../scheduler/async":"l1cmn","../util/isNumeric":"i95aV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i95aV":[function(require,module,exports) {
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
var _isArray = require("./isArray");
function isNumeric(val) {
    return !(0, _isArray.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

},{"./isArray":"2HaTi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38GKY":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _observable = require("../Observable");
var _isScheduler = require("../util/isScheduler");
var _mergeAll = require("../operators/mergeAll");
var _fromArray = require("./fromArray");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, _isScheduler.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, _observable.Observable)) return observables[0];
    return (0, _mergeAll.mergeAll)(concurrent)((0, _fromArray.fromArray)(observables, scheduler));
}

},{"../Observable":"9oc0x","../util/isScheduler":"4iYg4","../operators/mergeAll":"jXE8c","./fromArray":"b1aUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3FrL8":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "never", ()=>never);
var _observable = require("../Observable");
var _noop = require("../util/noop");
var NEVER = /*@__PURE__*/ new (0, _observable.Observable)((0, _noop.noop));
function never() {
    return NEVER;
}

},{"../Observable":"9oc0x","../util/noop":"4s4qZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hm3A5":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _observable = require("../Observable");
var _from = require("./from");
var _isArray = require("../util/isArray");
var _empty = require("./empty");
function onErrorResumeNext() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 0) return 0, _empty.EMPTY;
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && (0, _isArray.isArray)(first)) return onErrorResumeNext.apply(void 0, first);
    return new (0, _observable.Observable)(function(subscriber) {
        var subNext = function() {
            return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber));
        };
        return (0, _from.from)(first).subscribe({
            next: function(value) {
                subscriber.next(value);
            },
            error: subNext,
            complete: subNext
        });
    });
}

},{"../Observable":"9oc0x","./from":"6aqs0","../util/isArray":"2HaTi","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iTEBj":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairs", ()=>pairs);
parcelHelpers.export(exports, "dispatch", ()=>dispatch);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function pairs(obj, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        var keys = Object.keys(obj);
        for(var i = 0; i < keys.length && !subscriber.closed; i++){
            var key = keys[i];
            if (obj.hasOwnProperty(key)) subscriber.next([
                key,
                obj[key]
            ]);
        }
        subscriber.complete();
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        var keys = Object.keys(obj);
        var subscription = new (0, _subscription.Subscription)();
        subscription.add(scheduler.schedule(dispatch, 0, {
            keys: keys,
            index: 0,
            subscriber: subscriber,
            subscription: subscription,
            obj: obj
        }));
        return subscription;
    });
}
function dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([
                key,
                obj[key]
            ]);
            subscription.add(this.schedule({
                keys: keys,
                index: index + 1,
                subscriber: subscriber,
                subscription: subscription,
                obj: obj
            }));
        } else subscriber.complete();
    }
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Djd6":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _subscribeTo = require("../util/subscribeTo");
var _filter = require("../operators/filter");
var _observable = require("../Observable");
function partition(source, predicate, thisArg) {
    return [
        (0, _filter.filter)(predicate, thisArg)(new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(source))),
        (0, _filter.filter)((0, _not.not)(predicate, thisArg))(new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(source)))
    ];
}

},{"../util/not":"6oUZX","../util/subscribeTo":"fU69c","../operators/filter":"1uwXV","../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6oUZX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "not", ()=>not);
function not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1uwXV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var FilterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YL9k":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "RaceOperator", ()=>RaceOperator);
parcelHelpers.export(exports, "RaceSubscriber", ()=>RaceSubscriber);
var _tslib = require("tslib");
var _isArray = require("../util/isArray");
var _fromArray = require("./fromArray");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    if (observables.length === 1) {
        if ((0, _isArray.isArray)(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return (0, _fromArray.fromArray)(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
var RaceSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = (0, _subscribeToResult.subscribeToResult)(this, observable, undefined, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"gBS4y","../util/isArray":"2HaTi","./fromArray":"b1aUF","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuk43":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "dispatch", ()=>dispatch);
var _observable = require("../Observable");
function range(start, count, scheduler) {
    if (start === void 0) start = 0;
    return new (0, _observable.Observable)(function(subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) return scheduler.schedule(dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(current++);
            if (subscriber.closed) break;
        }while (true);
        return undefined;
    });
}
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) return;
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jufOf":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    var period = -1;
    if ((0, _isNumeric.isNumeric)(periodOrScheduler)) period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    else if ((0, _isScheduler.isScheduler)(periodOrScheduler)) scheduler = periodOrScheduler;
    if (!(0, _isScheduler.isScheduler)(scheduler)) scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isNumeric.isNumeric)(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule(dispatch, due, {
            index: 0,
            period: period,
            subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) return;
    else if (period === -1) return subscriber.complete();
    state.index = index + 1;
    this.schedule(state, period);
}

},{"../Observable":"9oc0x","../scheduler/async":"l1cmn","../util/isNumeric":"i95aV","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpgyo":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "using", ()=>using);
var _observable = require("../Observable");
var _from = require("./from");
var _empty = require("./empty");
function using(resourceFactory, observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? (0, _from.from)(result) : (0, _empty.EMPTY);
        var subscription = source.subscribe(subscriber);
        return function() {
            subscription.unsubscribe();
            if (resource) resource.unsubscribe();
        };
    });
}

},{"../Observable":"9oc0x","./from":"6aqs0","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57TWv":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
parcelHelpers.export(exports, "ZipOperator", ()=>ZipOperator);
parcelHelpers.export(exports, "ZipSubscriber", ()=>ZipSubscriber);
var _tslib = require("tslib");
var _fromArray = require("./fromArray");
var _isArray = require("../util/isArray");
var _subscriber = require("../Subscriber");
var _iterator = require("../../internal/symbol/iterator");
var _innerSubscribe = require("../innerSubscribe");
function zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === "function") observables.pop();
    return (0, _fromArray.fromArray)(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ function() {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}();
var ZipSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) values = Object.create(null);
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = typeof resultSelector === "function" ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ((0, _isArray.isArray)(value)) iterators.push(new StaticArrayIterator(value));
        else if (typeof value[0, _iterator.iterator] === "function") iterators.push(new StaticIterator(value[0, _iterator.iterator]()));
        else iterators.push(new ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            } else this.active--;
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === "function" && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) this._tryresultSelector(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryresultSelector = function(args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}((0, _subscriber.Subscriber));
var StaticIterator = /*@__PURE__*/ function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}();
var StaticArrayIterator = /*@__PURE__*/ function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[0, _iterator.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
var ZipBufferIterator = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[0, _iterator.iterator] = function() {
        return this;
    };
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function() {
        return (0, _innerSubscribe.innerSubscribe)(this.observable, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
    };
    return ZipBufferIterator;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","./fromArray":"b1aUF","../util/isArray":"2HaTi","../Subscriber":"jGx8F","../../internal/symbol/iterator":"jShcT","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fbkw":[function(require,module,exports) {
/**
 * Handles CoralRequests, producing observable CoralResponses.
 *
 * Based on Angular's HttpHandler interface. While this class is fully
 * framework-agnostic, the Angular documenation may be useful for understanding
 * how handlers are used.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralHandler", ()=>CoralHandler);
class CoralHandler {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lofXI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interceptingHandler = require("./intercepting-handler");
parcelHelpers.exportAll(_interceptingHandler, exports);
var _interceptor = require("./interceptor");
parcelHelpers.exportAll(_interceptor, exports);
var _coralClientHttpBindingInterceptor = require("./coral-client-http-binding-interceptor");
parcelHelpers.exportAll(_coralClientHttpBindingInterceptor, exports);
var _coralClientSerdesInterceptor = require("./coral-client-serdes-interceptor");
parcelHelpers.exportAll(_coralClientSerdesInterceptor, exports);
var _retryInterceptor = require("./retry-interceptor");
parcelHelpers.exportAll(_retryInterceptor, exports);
var _tapInterceptor = require("./tap-interceptor");
parcelHelpers.exportAll(_tapInterceptor, exports);
var _timeoutInterceptor = require("./timeout-interceptor");
parcelHelpers.exportAll(_timeoutInterceptor, exports);
var _aws4HmacSha256Interceptor = require("./aws4-hmac-sha256-interceptor");
parcelHelpers.exportAll(_aws4HmacSha256Interceptor, exports);

},{"./intercepting-handler":"2p2GN","./interceptor":"1y3ek","./coral-client-http-binding-interceptor":"95Fua","./coral-client-serdes-interceptor":"cm7uO","./retry-interceptor":"ckJ25","./tap-interceptor":"bc2Vw","./timeout-interceptor":"tnxww","./aws4-hmac-sha256-interceptor":"3t4DJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1y3ek":[function(require,module,exports) {
/**
 * Intercepts CoralRequests, produces observable CoralResponses. Typically this will
 * involve passing execution to the handler, which will produce the response.
 *
 * Based on Angular's HttpInterceptor interface. While this class is fully
 * framework-agnostic, the Angular documenation may be useful for understanding
 * how interceptors are used.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralInterceptor", ()=>CoralInterceptor);
class CoralInterceptor {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95Fua":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Interceptor that handles HTTP requests based on the Coral operation bindings.
 *
 * @see https://w.amazon.com/bin/view/Coral/Manual/HttpBinding/
 */ parcelHelpers.export(exports, "CoralClientHttpBindingInterceptor", ()=>CoralClientHttpBindingInterceptor);
var _url = require("core-js-pure/features/url");
var _urlDefault = parcelHelpers.interopDefault(_url);
var _urlSearchParams = require("core-js-pure/features/url-search-params");
var _urlSearchParamsDefault = parcelHelpers.interopDefault(_urlSearchParams);
var _interceptor = require("./interceptor");
class CoralClientHttpBindingInterceptor extends (0, _interceptor.CoralInterceptor) {
    constructor(bindings = {}){
        super();
        this.bindings = bindings;
    }
    intercept(request, next) {
        const operationName = request.operation;
        const coralOperationHttpBinding = this.bindings[operationName];
        // Don't bother intercepting if the operation has not been configured.
        if (!coralOperationHttpBinding) return next.handle(request);
        // Determine the path of the operation
        const path = this.resolvePath(coralOperationHttpBinding, request);
        // Create a new request with the updated path and method properties.
        // If the HTTP method does not support a body, remove it from the request.
        const newRequest = request.clone({
            body: this.supportsHttpBody(coralOperationHttpBinding.method) ? request.body : null,
            method: coralOperationHttpBinding.method,
            url: this.constructUrl(request.url, path)
        });
        return next.handle(newRequest);
    }
    /*
     * The modeled path can contain Labels, eg. getBeer/{beerId}/?brewery={breweryId}
     *
     * This method fetches the 'beerId' and 'breweryId' properties from the request body, substitutes the values
     * in the URL path, and returns a new path.
     *
     * In the above case, the method will resolve the beerId and breweryId properties from the request body.
     *
     * If the label cannot be resolved with a primitive value, it is replaced with an empty string, unless the label
     * makes up the entirety of a query parameter value. In that case, the query parameter is excluded from the
     * resolved path entirely.
     */ resolvePath(coralOperationHttpBinding, request) {
        // a prefix is necessary because the URL API only parses absolute URLs
        const urlPrefix = "http://placeholder" + (coralOperationHttpBinding.path.startsWith("/") ? "" : "/");
        // Extract everything before the query string out of the raw URL and do label find/replace before
        // parsing with the URL API to avoid the '{' and '}' characters for labels getting URL-encoded. Otherwise,
        // the label find/replace that depends on these characters would break.
        // See section 3.6 here: http://www.faqs.org/rfcs/rfc3986.html
        const [pathTemplate, ...remainingURLComponents] = coralOperationHttpBinding.path.split("?");
        const path = this.replaceLabels(pathTemplate, coralOperationHttpBinding, request);
        const url = new (0, _urlDefault.default)(`${urlPrefix}${[
            path,
            ...remainingURLComponents
        ].join("?")}`);
        // for the query string, we require more complex logic to potentially omit parameters with no resolved value
        // from the URL
        url.search = this.resolveQuery(url.searchParams, coralOperationHttpBinding, request);
        return url.toString().replace(urlPrefix, "");
    }
    replaceLabels(template, coralOperationHttpBinding, request) {
        // tslint:disable-next-line:no-let The path is generated by resolving the labels.
        let value = template;
        const labels = this.findLabels(value);
        if (!labels || labels.length === 0) return value;
        // No label transformations are available, return what we have.
        if (!coralOperationHttpBinding.labelTransformations) return value;
        labels.forEach((label)=>{
            const labelValue = this.resolveLabel(label, coralOperationHttpBinding, request) || "";
            value = value.replace(label, `${labelValue}`);
        });
        return value;
    }
    findLabels(s) {
        // The regex match extracts the '{}' groups into a list.
        return s.match(/{([a-zA-Z]+)}/g);
    }
    resolveQuery(query, coralOperationHttpBinding, request) {
        const newQuery = new (0, _urlSearchParamsDefault.default)();
        for (const [key, value] of query){
            const newValue = this.replaceLabelsInQueryParam(value, coralOperationHttpBinding, request);
            if (newValue !== undefined) newQuery.append(key, newValue);
        }
        return newQuery.toString();
    }
    replaceLabelsInQueryParam(template, coralOperationHttpBinding, request) {
        const labels = this.findLabels(template);
        if (labels && labels.length === 1 && labels[0] === template) // If there is one label in the query parameter value and the label makes up the entire query parameter,
        // simply resolve the parameter to that value. If we cannot resolve the label to a primitive value,
        // the undefined result returned from here will result in that parameter not getting included in the final path.
        return this.resolveLabel(labels[0], coralOperationHttpBinding, request);
        else // Otherwise do simple find/replace as we would for any other segment of the url.
        return this.replaceLabels(template, coralOperationHttpBinding, request);
    }
    resolveLabel(label, coralOperationHttpBinding, request) {
        // Remove the braces
        const labelProperty = label.replace(/{|}/g, "");
        // Fetch the request property name that should be substituted for the label. The label string itself is used as a fallback.
        // tslint:disable-next-line:no-non-null-assertion Non-null check on labelTransformations is performed in resolvePath().
        const labelTransformationProperty = coralOperationHttpBinding.labelTransformations[labelProperty] || labelProperty;
        const body = request.body;
        // The body is missing the required property, nothing to substitute.
        if (!body || !body.hasOwnProperty || !body.hasOwnProperty(labelTransformationProperty)) return;
        const labelPropertyValue = body[labelTransformationProperty];
        // For now, object values (including Arrays) are not supported for substitution.
        if (typeof labelPropertyValue === "object") return;
        return labelPropertyValue;
    }
    supportsHttpBody(method) {
        return ![
            "GET",
            "HEAD"
        ].includes(method);
    }
    constructUrl(url, path) {
        const urlPrefix = url.endsWith("/") ? url : url + "/";
        const pathSuffix = path.startsWith("/") ? path.substring(1) : path;
        return urlPrefix + pathSuffix;
    }
}

},{"core-js-pure/features/url":"gBYa6","core-js-pure/features/url-search-params":"h9MeM","./interceptor":"1y3ek","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBYa6":[function(require,module,exports) {
"use strict";
module.exports = require("55cc4f24155ada52");

},{"55cc4f24155ada52":"bEg0j"}],"bEg0j":[function(require,module,exports) {
"use strict";
var parent = require("34de09b177591ae8");
module.exports = parent;

},{"34de09b177591ae8":"lkBxs"}],"lkBxs":[function(require,module,exports) {
"use strict";
var parent = require("46157ad563116b92");
module.exports = parent;

},{"46157ad563116b92":"f9ThD"}],"f9ThD":[function(require,module,exports) {
"use strict";
var parent = require("1ed6d0f7692d8210");
module.exports = parent;

},{"1ed6d0f7692d8210":"1KaGj"}],"1KaGj":[function(require,module,exports) {
"use strict";
require("36deb9e98036fc1a");
require("8c2031279e25e439");
require("c411a05581975b6d");
require("a673a71483138646");
require("6603320a20485c4b");
var path = require("4c7ec9bfaacc45c2");
module.exports = path.URL;

},{"36deb9e98036fc1a":"lJY9U","8c2031279e25e439":"cZd9M","c411a05581975b6d":"k2589","a673a71483138646":"gPb1i","6603320a20485c4b":"eIBFV","4c7ec9bfaacc45c2":"eLZ9u"}],"lJY9U":[function(require,module,exports) {
"use strict";
require("6c49b5f5ec7da887");
require("c10e8da9e0f90295");
require("2f9ac6deef64c22d");
require("d7ad1b757ef4d4ae");
var path = require("1a9918607b1a0bd1");
module.exports = path.URLSearchParams;

},{"6c49b5f5ec7da887":"ebESK","c10e8da9e0f90295":"5ryP3","2f9ac6deef64c22d":"coFHg","d7ad1b757ef4d4ae":"k8Vb7","1a9918607b1a0bd1":"eLZ9u"}],"ebESK":[function(require,module,exports) {
"use strict";
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("9e97aa77d9a907b4");

},{"9e97aa77d9a907b4":"bIJiC"}],"bIJiC":[function(require,module,exports) {
"use strict";
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require("935daf9500e76abe");
var $ = require("25540f564a77faa3");
var global = require("e2b578ea66f5c783");
var safeGetBuiltIn = require("fc4176832413ad52");
var call = require("a0b84e9e927f4411");
var uncurryThis = require("9b50b082709eb7e1");
var DESCRIPTORS = require("dd44206bb10ec3dc");
var USE_NATIVE_URL = require("f8ba8015d08972e6");
var defineBuiltIn = require("5d476942a2f1c4b9");
var defineBuiltInAccessor = require("ff6a4110bf98232");
var defineBuiltIns = require("c229cda58ac738a6");
var setToStringTag = require("787ea5608ec5352e");
var createIteratorConstructor = require("6f4fc0a6fd1acc2b");
var InternalStateModule = require("764deb4e61487d85");
var anInstance = require("e67393b0c5166318");
var isCallable = require("c258c59600e4cadb");
var hasOwn = require("68549ef503e8bef8");
var bind = require("9577aeefa682a51c");
var classof = require("947811ddd36a17");
var anObject = require("d39c712408691ca5");
var isObject = require("f44ba4504dfb47ba");
var $toString = require("3b665ae83edeb425");
var create = require("77629d918f23b71a");
var createPropertyDescriptor = require("c6378eb94de3edb3");
var getIterator = require("ba917f68cde9788e");
var getIteratorMethod = require("35765f6f2b88c6ef");
var createIterResultObject = require("5332b5ffa9620f5e");
var validateArgumentsLength = require("252aee772bc463f3");
var wellKnownSymbol = require("2945b15be70c1386");
var arraySort = require("8d5bd4207ad6583e");
var ITERATOR = wellKnownSymbol("iterator");
var URL_SEARCH_PARAMS = "URLSearchParams";
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + "Iterator";
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
var nativeFetch = safeGetBuiltIn("fetch");
var NativeRequest = safeGetBuiltIn("Request");
var Headers = safeGetBuiltIn("Headers");
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis("".charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis("".replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis("".split);
var stringSlice = uncurryThis("".slice);
var plus = /\+/g;
var sequences = Array(4);
var percentSequence = function(bytes) {
    return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var percentDecode = function(sequence) {
    try {
        return decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var deserialize = function(it) {
    var result = replace(it, plus, " ");
    var bytes = 4;
    try {
        return decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = replace(result, percentSequence(bytes--), percentDecode);
        return result;
    }
};
var find = /[!'()~]|%20/g;
var replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var replacer = function(match) {
    return replacements[match];
};
var serialize = function(it) {
    return replace(encodeURIComponent(it), find, replacer);
};
var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
    setInternalState(this, {
        type: URL_SEARCH_PARAMS_ITERATOR,
        target: getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, URL_SEARCH_PARAMS, function next() {
    var state = getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return createIterResultObject(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case "keys":
            return createIterResultObject(entry.key, false);
        case "values":
            return createIterResultObject(entry.value, false);
    }
    return createIterResultObject([
        entry.key,
        entry.value
    ], false);
}, true);
var URLSearchParamsState = function(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if (isObject(init)) this.parseObject(init);
        else this.parseQuery(typeof init == "string" ? charAt(init, 0) === "?" ? stringSlice(init, 1) : init : $toString(init));
    }
};
URLSearchParamsState.prototype = {
    type: URL_SEARCH_PARAMS,
    bindURL: function(url) {
        this.url = url;
        this.update();
    },
    parseObject: function(object) {
        var entries = this.entries;
        var iteratorMethod = getIteratorMethod(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = getIterator(object, iteratorMethod);
            next = iterator.next;
            while(!(step = call(next, iterator)).done){
                entryIterator = getIterator(anObject(step.value));
                entryNext = entryIterator.next;
                if ((first = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done) throw new TypeError("Expected sequence with length 2");
                push(entries, {
                    key: $toString(first.value),
                    value: $toString(second.value)
                });
            }
        } else for(var key in object)if (hasOwn(object, key)) push(entries, {
            key: key,
            value: $toString(object[key])
        });
    },
    parseQuery: function(query) {
        if (query) {
            var entries = this.entries;
            var attributes = split(query, "&");
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = split(attribute, "=");
                    push(entries, {
                        key: deserialize(shift(entry)),
                        value: deserialize(join(entry, "="))
                    });
                }
            }
        }
    },
    serialize: function() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            push(result, serialize(entry.key) + "=" + serialize(entry.value));
        }
        return join(result, "&");
    },
    update: function() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams() {
    anInstance(this, URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = setInternalState(this, new URLSearchParamsState(init));
    if (!DESCRIPTORS) this.size = state.entries.length;
};
var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
defineBuiltIns(URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = getInternalParamsState(this);
        validateArgumentsLength(arguments.length, 2);
        push(state.entries, {
            key: $toString(name),
            value: $toString(value)
        });
        if (!DESCRIPTORS) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name /* , value */ ) {
        var state = getInternalParamsState(this);
        var length = validateArgumentsLength(arguments.length, 1);
        var entries = state.entries;
        var key = $toString(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $toString($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!DESCRIPTORS) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = getInternalParamsState(this).entries;
        validateArgumentsLength(arguments.length, 1);
        var key = $toString(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = getInternalParamsState(this).entries;
        validateArgumentsLength(arguments.length, 1);
        var key = $toString(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = getInternalParamsState(this).entries;
        var length = validateArgumentsLength(arguments.length, 1);
        var key = $toString(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $toString($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = getInternalParamsState(this);
        validateArgumentsLength(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $toString(name);
        var val = $toString(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) push(entries, {
            key: key,
            value: val
        });
        if (!DESCRIPTORS) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = getInternalParamsState(this);
        arraySort(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = getInternalParamsState(this).entries;
        var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, "toString", function toString() {
    return getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, "size", {
    get: function size() {
        return getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
$({
    global: true,
    constructor: true,
    forced: !USE_NATIVE_URL
}, {
    URLSearchParams: URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
    var headersHas = uncurryThis(HeadersPrototype.has);
    var headersSet = uncurryThis(HeadersPrototype.set);
    var wrapRequestOptions = function(init) {
        if (isObject(init)) {
            var body = init.body;
            var headers;
            if (classof(body) === URL_SEARCH_PARAMS) {
                headers = init.headers ? new Headers(init.headers) : new Headers();
                if (!headersHas(headers, "content-type")) headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return create(init, {
                    body: createPropertyDescriptor(0, $toString(body)),
                    headers: createPropertyDescriptor(0, headers)
                });
            }
        }
        return init;
    };
    if (isCallable(nativeFetch)) $({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        }
    });
    if (isCallable(NativeRequest)) {
        var RequestConstructor = function Request(input /* , init */ ) {
            anInstance(this, RequestPrototype);
            return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        };
        RequestPrototype.constructor = RequestConstructor;
        RequestConstructor.prototype = RequestPrototype;
        $({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: RequestConstructor
        });
    }
}
module.exports = {
    URLSearchParams: URLSearchParamsConstructor,
    getState: getInternalParamsState
};

},{"935daf9500e76abe":"3YkFB","25540f564a77faa3":"4CdND","e2b578ea66f5c783":"lVXFY","fc4176832413ad52":"5F3BB","a0b84e9e927f4411":"eRBbz","9b50b082709eb7e1":"b7Ro2","dd44206bb10ec3dc":"4wVcO","f8ba8015d08972e6":"3GsGZ","5d476942a2f1c4b9":"cBlN5","ff6a4110bf98232":"7Acg5","c229cda58ac738a6":"fJcZy","787ea5608ec5352e":"kNxUP","6f4fc0a6fd1acc2b":"9VWpW","764deb4e61487d85":"gn7n9","e67393b0c5166318":"8Ydpa","c258c59600e4cadb":"3n2Kg","68549ef503e8bef8":"6ZrQU","9577aeefa682a51c":"4gNtY","947811ddd36a17":"9xtZk","d39c712408691ca5":"gmak8","f44ba4504dfb47ba":"6gtp8","3b665ae83edeb425":"25yKQ","77629d918f23b71a":"2dAco","c6378eb94de3edb3":"35V9v","ba917f68cde9788e":"kcajT","35765f6f2b88c6ef":"b7Qae","5332b5ffa9620f5e":"hDCch","252aee772bc463f3":"ZmUg7","2945b15be70c1386":"guevu","8d5bd4207ad6583e":"1g1Zv"}],"3YkFB":[function(require,module,exports) {
"use strict";
var toIndexedObject = require("4639bf4357079971");
var addToUnscopables = require("818838cc12177d33");
var Iterators = require("e1004d41bff53cd");
var InternalStateModule = require("b7f90778928a6259");
var defineProperty = require("c743d17f0e12d89").f;
var defineIterator = require("d20476e487603a3");
var createIterResultObject = require("a9986882a9a14ac6");
var IS_PURE = require("8feba3942d6643b6");
var DESCRIPTORS = require("1e104e0284a8a159");
var ARRAY_ITERATOR = "Array Iterator";
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, "Array", function(iterated, kind) {
    setInternalState(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return createIterResultObject(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return createIterResultObject(index, false);
        case "values":
            return createIterResultObject(target[index], false);
    }
    return createIterResultObject([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables("keys");
addToUnscopables("values");
addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== "values") try {
    defineProperty(values, "name", {
        value: "values"
    });
} catch (error) {}

},{"4639bf4357079971":"ln2qL","818838cc12177d33":"gM0EZ","e1004d41bff53cd":"lqVAd","b7f90778928a6259":"gn7n9","c743d17f0e12d89":"l2cFV","d20476e487603a3":"4ZygF","a9986882a9a14ac6":"hDCch","8feba3942d6643b6":"5eDb0","1e104e0284a8a159":"4wVcO"}],"ln2qL":[function(require,module,exports) {
"use strict";
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require("a7551b28df49764a");
var requireObjectCoercible = require("b1b2e1578196acf2");
module.exports = function(it) {
    return IndexedObject(requireObjectCoercible(it));
};

},{"a7551b28df49764a":"2dJh8","b1b2e1578196acf2":"2wITG"}],"2dJh8":[function(require,module,exports) {
"use strict";
var uncurryThis = require("e762c482860574dd");
var fails = require("9e77e6d6ee040f3b");
var classof = require("f2c7c7b17b75bb9");
var $Object = Object;
var split = uncurryThis("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) === "String" ? split(it, "") : $Object(it);
} : $Object;

},{"e762c482860574dd":"b7Ro2","9e77e6d6ee040f3b":"cpXM6","f2c7c7b17b75bb9":"1piK0"}],"b7Ro2":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("15a325d6cc49c31a");
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
    return function() {
        return call.apply(fn, arguments);
    };
};

},{"15a325d6cc49c31a":"hTrrN"}],"hTrrN":[function(require,module,exports) {
"use strict";
var fails = require("ece43f21edf242ad");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

},{"ece43f21edf242ad":"cpXM6"}],"cpXM6":[function(require,module,exports) {
"use strict";
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

},{}],"1piK0":[function(require,module,exports) {
"use strict";
var uncurryThis = require("3bfb3d079df6cddf");
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis("".slice);
module.exports = function(it) {
    return stringSlice(toString(it), 8, -1);
};

},{"3bfb3d079df6cddf":"b7Ro2"}],"2wITG":[function(require,module,exports) {
"use strict";
var isNullOrUndefined = require("4c5c65c250aff1b8");
var $TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
    return it;
};

},{"4c5c65c250aff1b8":"9MCnB"}],"9MCnB":[function(require,module,exports) {
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

},{}],"gM0EZ":[function(require,module,exports) {
"use strict";
module.exports = function() {};

},{}],"lqVAd":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"gn7n9":[function(require,module,exports) {
"use strict";
var NATIVE_WEAK_MAP = require("ebbabefb6295e565");
var global = require("3f2934de253b3326");
var isObject = require("5ed6c0568842552f");
var createNonEnumerableProperty = require("1b24361798c22aa9");
var hasOwn = require("f9144bcb40559c42");
var shared = require("a2950fa3d1bba52e");
var sharedKey = require("63ced356c6a71979");
var hiddenKeys = require("5972583f13a68c1b");
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store.get(it) || {};
    };
    has = function(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey("state");
    hiddenKeys[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn(it, STATE);
    };
}
module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};

},{"ebbabefb6295e565":"dsrRu","3f2934de253b3326":"lVXFY","5ed6c0568842552f":"6gtp8","1b24361798c22aa9":"e9yHG","f9144bcb40559c42":"6ZrQU","a2950fa3d1bba52e":"8HEmW","63ced356c6a71979":"ge3J0","5972583f13a68c1b":"fje6F"}],"dsrRu":[function(require,module,exports) {
"use strict";
var global = require("a24166d3cff77a19");
var isCallable = require("e5e8abf8e337cb2b");
var WeakMap = global.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"a24166d3cff77a19":"lVXFY","e5e8abf8e337cb2b":"3n2Kg"}],"lVXFY":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof global == "object" && global) || check(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

},{}],"3n2Kg":[function(require,module,exports) {
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == "undefined" && documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === documentAll;
} : function(argument) {
    return typeof argument == "function";
};

},{}],"6gtp8":[function(require,module,exports) {
"use strict";
var isCallable = require("560fcd15b556338a");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : isCallable(it);
};

},{"560fcd15b556338a":"3n2Kg"}],"e9yHG":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("6a41151e417e0d5a");
var definePropertyModule = require("a43a9e7f4954e8f9");
var createPropertyDescriptor = require("6317956bbcb935d5");
module.exports = DESCRIPTORS ? function(object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"6a41151e417e0d5a":"4wVcO","a43a9e7f4954e8f9":"l2cFV","6317956bbcb935d5":"35V9v"}],"4wVcO":[function(require,module,exports) {
"use strict";
var fails = require("f63d4a80622d6205");
// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

},{"f63d4a80622d6205":"cpXM6"}],"l2cFV":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("e87c552c95d47417");
var IE8_DOM_DEFINE = require("1d0d25e398c9097b");
var V8_PROTOTYPE_DEFINE_BUG = require("1bc2387b228f52a8");
var anObject = require("699c471765c95452");
var toPropertyKey = require("158df1570926fb43");
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE = "configurable";
var WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

},{"e87c552c95d47417":"4wVcO","1d0d25e398c9097b":"fZLI7","1bc2387b228f52a8":"6v5VX","699c471765c95452":"gmak8","158df1570926fb43":"biizp"}],"fZLI7":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("e8c3543ef241e39");
var fails = require("d54cb53030dde16f");
var createElement = require("84559b61bbd09714");
// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

},{"e8c3543ef241e39":"4wVcO","d54cb53030dde16f":"cpXM6","84559b61bbd09714":"behOu"}],"behOu":[function(require,module,exports) {
"use strict";
var global = require("798a08d02e0187b5");
var isObject = require("d3a6b57614738655");
var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return EXISTS ? document.createElement(it) : {};
};

},{"798a08d02e0187b5":"lVXFY","d3a6b57614738655":"6gtp8"}],"6v5VX":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("2e2d7866bde3eb99");
var fails = require("fb0cae9e30301d29");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});

},{"2e2d7866bde3eb99":"4wVcO","fb0cae9e30301d29":"cpXM6"}],"gmak8":[function(require,module,exports) {
"use strict";
var isObject = require("a722fbb49aeb9bcf");
var $String = String;
var $TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if (isObject(argument)) return argument;
    throw new $TypeError($String(argument) + " is not an object");
};

},{"a722fbb49aeb9bcf":"6gtp8"}],"biizp":[function(require,module,exports) {
"use strict";
var toPrimitive = require("d9395d21fb152065");
var isSymbol = require("ca9fd052b0588c48");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
};

},{"d9395d21fb152065":"dCnrA","ca9fd052b0588c48":"5T9Vi"}],"dCnrA":[function(require,module,exports) {
"use strict";
var call = require("2d04628a2bad11f2");
var isObject = require("f01a02de95d2a2f7");
var isSymbol = require("e82424bb8538de63");
var getMethod = require("9331c17879bf09f7");
var ordinaryToPrimitive = require("9729d6b0ccef3efa");
var wellKnownSymbol = require("679fae1fbb0e8cab");
var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};

},{"2d04628a2bad11f2":"eRBbz","f01a02de95d2a2f7":"6gtp8","e82424bb8538de63":"5T9Vi","9331c17879bf09f7":"fUt66","9729d6b0ccef3efa":"1TwoL","679fae1fbb0e8cab":"guevu"}],"eRBbz":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("986ec29e81511db3");
var call = Function.prototype.call;
module.exports = NATIVE_BIND ? call.bind(call) : function() {
    return call.apply(call, arguments);
};

},{"986ec29e81511db3":"hTrrN"}],"5T9Vi":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("c802cdce083f08de");
var isCallable = require("ae1b35d7829f17f7");
var isPrototypeOf = require("f14b984e44c778c3");
var USE_SYMBOL_AS_UID = require("4009d9192ed8bb81");
var $Object = Object;
module.exports = USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn("Symbol");
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"c802cdce083f08de":"9SbBm","ae1b35d7829f17f7":"3n2Kg","f14b984e44c778c3":"cIcau","4009d9192ed8bb81":"lXGid"}],"9SbBm":[function(require,module,exports) {
"use strict";
var path = require("1642fcc922bafa53");
var global = require("5e0f0a5159b9d2b2");
var isCallable = require("c04a19d1e96f50bb");
var aFunction = function(variable) {
    return isCallable(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};

},{"1642fcc922bafa53":"eLZ9u","5e0f0a5159b9d2b2":"lVXFY","c04a19d1e96f50bb":"3n2Kg"}],"eLZ9u":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"cIcau":[function(require,module,exports) {
"use strict";
var uncurryThis = require("92a0229526dc8825");
module.exports = uncurryThis({}.isPrototypeOf);

},{"92a0229526dc8825":"b7Ro2"}],"lXGid":[function(require,module,exports) {
"use strict";
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = require("b66b793a435f7bae");
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";

},{"b66b793a435f7bae":"9Q8SC"}],"9Q8SC":[function(require,module,exports) {
"use strict";
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = require("68700f673320a22a");
var fails = require("428e95488da0e54e");
var global = require("eb1f1f7f7de97ce0");
var $String = global.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"68700f673320a22a":"6W2jV","428e95488da0e54e":"cpXM6","eb1f1f7f7de97ce0":"lVXFY"}],"6W2jV":[function(require,module,exports) {
"use strict";
var global = require("dc37f58b80d99c1e");
var userAgent = require("e124e75481a7e505");
var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
module.exports = version;

},{"dc37f58b80d99c1e":"lVXFY","e124e75481a7e505":"hmtXa"}],"hmtXa":[function(require,module,exports) {
"use strict";
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

},{}],"fUt66":[function(require,module,exports) {
"use strict";
var aCallable = require("d22489f7446fc8fb");
var isNullOrUndefined = require("fd4a4ca6f921c6ca");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"d22489f7446fc8fb":"kUVsN","fd4a4ca6f921c6ca":"9MCnB"}],"kUVsN":[function(require,module,exports) {
"use strict";
var isCallable = require("8c4d67abd1d747ee");
var tryToString = require("c12152a1f2dfe9f4");
var $TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if (isCallable(argument)) return argument;
    throw new $TypeError(tryToString(argument) + " is not a function");
};

},{"8c4d67abd1d747ee":"3n2Kg","c12152a1f2dfe9f4":"dMRbE"}],"dMRbE":[function(require,module,exports) {
"use strict";
var $String = String;
module.exports = function(argument) {
    try {
        return $String(argument);
    } catch (error) {
        return "Object";
    }
};

},{}],"1TwoL":[function(require,module,exports) {
"use strict";
var call = require("77074cd10c6e491d");
var isCallable = require("865510c544cceb0c");
var isObject = require("63ce2d975f867fdb");
var $TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw new $TypeError("Can't convert object to primitive value");
};

},{"77074cd10c6e491d":"eRBbz","865510c544cceb0c":"3n2Kg","63ce2d975f867fdb":"6gtp8"}],"guevu":[function(require,module,exports) {
"use strict";
var global = require("7ca9fc36c62b1b25");
var shared = require("572b05fc0c453f80");
var hasOwn = require("6dbac8e7fa5c32d6");
var uid = require("1b8547440158a21b");
var NATIVE_SYMBOL = require("72a2b70ca66375de");
var USE_SYMBOL_AS_UID = require("ac7bf6a1019cebe6");
var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared("wks");
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol["for"] || Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function(name) {
    if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol("Symbol." + name);
    return WellKnownSymbolsStore[name];
};

},{"7ca9fc36c62b1b25":"lVXFY","572b05fc0c453f80":"6fUY6","6dbac8e7fa5c32d6":"6ZrQU","1b8547440158a21b":"V4RCU","72a2b70ca66375de":"9Q8SC","ac7bf6a1019cebe6":"lXGid"}],"6fUY6":[function(require,module,exports) {
"use strict";
var store = require("b833e17679ad2ed1");
module.exports = function(key, value) {
    return store[key] || (store[key] = value || {});
};

},{"b833e17679ad2ed1":"8HEmW"}],"8HEmW":[function(require,module,exports) {
"use strict";
var IS_PURE = require("523218b2942bc3c5");
var globalThis = require("f80f118fb59b58");
var defineGlobalProperty = require("c876c9e4ed7104e8");
var SHARED = "__core-js_shared__";
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
(store.versions || (store.versions = [])).push({
    version: "3.37.0",
    mode: IS_PURE ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

},{"523218b2942bc3c5":"5eDb0","f80f118fb59b58":"lVXFY","c876c9e4ed7104e8":"eCjQX"}],"5eDb0":[function(require,module,exports) {
"use strict";
module.exports = true;

},{}],"eCjQX":[function(require,module,exports) {
"use strict";
var global = require("6ff5aca7b1539d8a");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        defineProperty(global, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global[key] = value;
    }
    return value;
};

},{"6ff5aca7b1539d8a":"lVXFY"}],"6ZrQU":[function(require,module,exports) {
"use strict";
var uncurryThis = require("3cf56701fc9c38e9");
var toObject = require("8ecdc5b2a0f6b18d");
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};

},{"3cf56701fc9c38e9":"b7Ro2","8ecdc5b2a0f6b18d":"gHSkd"}],"gHSkd":[function(require,module,exports) {
"use strict";
var requireObjectCoercible = require("1a54b2fc5414b42");
var $Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $Object(requireObjectCoercible(argument));
};

},{"1a54b2fc5414b42":"2wITG"}],"V4RCU":[function(require,module,exports) {
"use strict";
var uncurryThis = require("deb3c44f049c7ae1");
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
};

},{"deb3c44f049c7ae1":"b7Ro2"}],"35V9v":[function(require,module,exports) {
"use strict";
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"ge3J0":[function(require,module,exports) {
"use strict";
var shared = require("b14d9ce5d84daf6c");
var uid = require("19f4af8326851c2e");
var keys = shared("keys");
module.exports = function(key) {
    return keys[key] || (keys[key] = uid(key));
};

},{"b14d9ce5d84daf6c":"6fUY6","19f4af8326851c2e":"V4RCU"}],"fje6F":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"4ZygF":[function(require,module,exports) {
"use strict";
var $ = require("144c0040c0c3bbe2");
var call = require("6ce83eb769436d06");
var IS_PURE = require("f55ac01c536bc1cf");
var FunctionName = require("709c95a41e95afa8");
var isCallable = require("2cbfc096b0568f0e");
var createIteratorConstructor = require("706f97f18a35406b");
var getPrototypeOf = require("b70de57005e5b2c9");
var setPrototypeOf = require("5fb10ea89c62009d");
var setToStringTag = require("b01c089256559ff7");
var createNonEnumerableProperty = require("3d1ea03a6642f60f");
var defineBuiltIn = require("363a40789225a8da");
var wellKnownSymbol = require("da749b7bde36acca");
var Iterators = require("ad4e8329053ac433");
var IteratorsCore = require("e8f4702b6498edd");
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";
var returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
            }
            // Set @@toStringTag to native iterators
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, "name", VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return call(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
        } else $({
            target: NAME,
            proto: true,
            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    Iterators[NAME] = defaultIterator;
    return methods;
};

},{"144c0040c0c3bbe2":"4CdND","6ce83eb769436d06":"eRBbz","f55ac01c536bc1cf":"5eDb0","709c95a41e95afa8":"4yJFe","2cbfc096b0568f0e":"3n2Kg","706f97f18a35406b":"9VWpW","b70de57005e5b2c9":"5S24S","5fb10ea89c62009d":"chSEo","b01c089256559ff7":"kNxUP","3d1ea03a6642f60f":"e9yHG","363a40789225a8da":"cBlN5","da749b7bde36acca":"guevu","ad4e8329053ac433":"lqVAd","e8f4702b6498edd":"hBfBn"}],"4CdND":[function(require,module,exports) {
"use strict";
var global = require("7d044f98fc1861d6");
var apply = require("6de292810f3a9cd7");
var uncurryThis = require("9a8bbec352e29b2f");
var isCallable = require("4d1326db4592c739");
var getOwnPropertyDescriptor = require("f64d770b5171c2d1").f;
var isForced = require("98299f18395dc362");
var path = require("9ab8ed42f2c4f65c");
var bind = require("3b4b22cc90130557");
var createNonEnumerableProperty = require("f2423250b2ddae23");
var hasOwn = require("15522871b02febaf");
// add debugging info
require("5ce2e0662515fd06");
var wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return apply(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : global[TARGET] && global[TARGET].prototype;
    var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && hasOwn(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (!FORCED && !PROTO && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
        else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
        else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(resultProperty, "sham", true);
        createNonEnumerableProperty(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!hasOwn(path, VIRTUAL_PROTOTYPE)) createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) createNonEnumerableProperty(targetPrototype, key, sourceProperty);
        }
    }
};

},{"7d044f98fc1861d6":"lVXFY","6de292810f3a9cd7":"grEZF","9a8bbec352e29b2f":"fRUeM","4d1326db4592c739":"3n2Kg","f64d770b5171c2d1":"2g2dT","98299f18395dc362":"3WAEs","9ab8ed42f2c4f65c":"eLZ9u","3b4b22cc90130557":"4gNtY","f2423250b2ddae23":"e9yHG","15522871b02febaf":"6ZrQU","5ce2e0662515fd06":"8HEmW"}],"grEZF":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("d5957747272d351b");
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
    return call.apply(apply, arguments);
});

},{"d5957747272d351b":"hTrrN"}],"fRUeM":[function(require,module,exports) {
"use strict";
var classofRaw = require("9beae915cec6700a");
var uncurryThis = require("ba2e97345298e1a4");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw(fn) === "Function") return uncurryThis(fn);
};

},{"9beae915cec6700a":"1piK0","ba2e97345298e1a4":"b7Ro2"}],"2g2dT":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("5cc9c247fabaebfc");
var call = require("1cb196f47cbd4941");
var propertyIsEnumerableModule = require("b931dc9f5ea526c0");
var createPropertyDescriptor = require("8baaeeff4cdea512");
var toIndexedObject = require("335dcc484b2eb15f");
var toPropertyKey = require("52e07c32afa1a22f");
var hasOwn = require("8660aa38b55bbcc4");
var IE8_DOM_DEFINE = require("3d39b0c7d6fe2f54");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"5cc9c247fabaebfc":"4wVcO","1cb196f47cbd4941":"eRBbz","b931dc9f5ea526c0":"5qnTr","8baaeeff4cdea512":"35V9v","335dcc484b2eb15f":"ln2qL","52e07c32afa1a22f":"biizp","8660aa38b55bbcc4":"6ZrQU","3d39b0c7d6fe2f54":"fZLI7"}],"5qnTr":[function(require,module,exports) {
"use strict";
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],"3WAEs":[function(require,module,exports) {
"use strict";
var fails = require("e0650ac81afce64d");
var isCallable = require("11203b8abdab027a");
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = "N";
var POLYFILL = isForced.POLYFILL = "P";
module.exports = isForced;

},{"e0650ac81afce64d":"cpXM6","11203b8abdab027a":"3n2Kg"}],"4gNtY":[function(require,module,exports) {
"use strict";
var uncurryThis = require("a49e75ca3c37abfe");
var aCallable = require("d3b2e0b141bf3a63");
var NATIVE_BIND = require("db6aaf31b65a915f");
var bind = uncurryThis(uncurryThis.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

},{"a49e75ca3c37abfe":"fRUeM","d3b2e0b141bf3a63":"kUVsN","db6aaf31b65a915f":"hTrrN"}],"4yJFe":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("3b71b514e304a59d");
var hasOwn = require("2786ea9a9cedcf38");
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};

},{"3b71b514e304a59d":"4wVcO","2786ea9a9cedcf38":"6ZrQU"}],"9VWpW":[function(require,module,exports) {
"use strict";
var IteratorPrototype = require("28d60c9b5121107a").IteratorPrototype;
var create = require("12505868274b6836");
var createPropertyDescriptor = require("4d85cf43e61cd80e");
var setToStringTag = require("bc38deebfc16b1ed");
var Iterators = require("c7c4b5aafaddd53c");
var returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = create(IteratorPrototype, {
        next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators[TO_STRING_TAG] = returnThis;
    return IteratorConstructor;
};

},{"28d60c9b5121107a":"hBfBn","12505868274b6836":"2dAco","4d85cf43e61cd80e":"35V9v","bc38deebfc16b1ed":"kNxUP","c7c4b5aafaddd53c":"lqVAd"}],"hBfBn":[function(require,module,exports) {
"use strict";
var fails = require("ab64dbeb497ace02");
var isCallable = require("c9f6fbec21b5b15f");
var isObject = require("71cfc6348b6b3acb");
var create = require("ce71d013b61db1c8");
var getPrototypeOf = require("f97114d28895ee30");
var defineBuiltIn = require("519f454e9d00b62a");
var wellKnownSymbol = require("50f78fa9604d448c");
var IS_PURE = require("ca7cc883581bbf59");
var ITERATOR = wellKnownSymbol("iterator");
var BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
    else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
}
var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function() {
    var test = {};
    // FF44- legacy iterators case
    return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) defineBuiltIn(IteratorPrototype, ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"ab64dbeb497ace02":"cpXM6","c9f6fbec21b5b15f":"3n2Kg","71cfc6348b6b3acb":"6gtp8","ce71d013b61db1c8":"2dAco","f97114d28895ee30":"5S24S","519f454e9d00b62a":"cBlN5","50f78fa9604d448c":"guevu","ca7cc883581bbf59":"5eDb0"}],"2dAco":[function(require,module,exports) {
"use strict";
/* global ActiveXObject -- old IE, WSH */ var anObject = require("91376c8d0abaa88a");
var definePropertiesModule = require("3eab2ebd8380d383");
var enumBugKeys = require("33e7ba4c31998187");
var hiddenKeys = require("ae6b7e66eda930de");
var html = require("2b481f3735a9eb3e");
var documentCreateElement = require("8fe8aba721fd2029");
var sharedKey = require("d4e9203da96f0b4c");
var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement("iframe");
    var JS = "java" + SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"91376c8d0abaa88a":"gmak8","3eab2ebd8380d383":"aEIIA","33e7ba4c31998187":"jwLvP","ae6b7e66eda930de":"fje6F","2b481f3735a9eb3e":"3FGJ3","8fe8aba721fd2029":"behOu","d4e9203da96f0b4c":"ge3J0"}],"aEIIA":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("fa205ea66618feb9");
var V8_PROTOTYPE_DEFINE_BUG = require("29f019a67494fbf4");
var definePropertyModule = require("1653eee63068872f");
var anObject = require("893ccb2820d4f439");
var toIndexedObject = require("cd264d7575ca265d");
var objectKeys = require("62c80d07eb1de532");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};

},{"fa205ea66618feb9":"4wVcO","29f019a67494fbf4":"6v5VX","1653eee63068872f":"l2cFV","893ccb2820d4f439":"gmak8","cd264d7575ca265d":"ln2qL","62c80d07eb1de532":"kdoy9"}],"kdoy9":[function(require,module,exports) {
"use strict";
var internalObjectKeys = require("4c00d15bc2384448");
var enumBugKeys = require("e1ea7cbce9490a53");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
};

},{"4c00d15bc2384448":"lulf7","e1ea7cbce9490a53":"jwLvP"}],"lulf7":[function(require,module,exports) {
"use strict";
var uncurryThis = require("e63120e138cf3aae");
var hasOwn = require("b1e48e8d68afab38");
var toIndexedObject = require("45d2cfd9ec104733");
var indexOf = require("7453f339088c99e7").indexOf;
var hiddenKeys = require("548f9fd974215a48");
var push = uncurryThis([].push);
module.exports = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};

},{"e63120e138cf3aae":"b7Ro2","b1e48e8d68afab38":"6ZrQU","45d2cfd9ec104733":"ln2qL","7453f339088c99e7":"f0ZHK","548f9fd974215a48":"fje6F"}],"f0ZHK":[function(require,module,exports) {
"use strict";
var toIndexedObject = require("cd4e6dbda28fb5f1");
var toAbsoluteIndex = require("b18444423922b27b");
var lengthOfArrayLike = require("5d0292df13413b66");
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};

},{"cd4e6dbda28fb5f1":"ln2qL","b18444423922b27b":"lDpW1","5d0292df13413b66":"ayCmf"}],"lDpW1":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("e199f58c4cc74442");
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"e199f58c4cc74442":"alLu5"}],"alLu5":[function(require,module,exports) {
"use strict";
var trunc = require("ee47284a9a53d2d4");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};

},{"ee47284a9a53d2d4":"4Mpug"}],"4Mpug":[function(require,module,exports) {
"use strict";
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};

},{}],"ayCmf":[function(require,module,exports) {
"use strict";
var toLength = require("80b24ea6763f6d60");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return toLength(obj.length);
};

},{"80b24ea6763f6d60":"9NnqV"}],"9NnqV":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("a2c4d3a5374513c3");
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = toIntegerOrInfinity(argument);
    return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"a2c4d3a5374513c3":"alLu5"}],"jwLvP":[function(require,module,exports) {
"use strict";
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

},{}],"3FGJ3":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("e0ddcac760d7346a");
module.exports = getBuiltIn("document", "documentElement");

},{"e0ddcac760d7346a":"9SbBm"}],"5S24S":[function(require,module,exports) {
"use strict";
var hasOwn = require("a7241aa10ce7a133");
var isCallable = require("a331eb0cdbbce71f");
var toObject = require("fb3d4f0c40b195b3");
var sharedKey = require("e8c3ea24cea26a66");
var CORRECT_PROTOTYPE_GETTER = require("63dfe3761d5dc038");
var IE_PROTO = sharedKey("IE_PROTO");
var $Object = Object;
var ObjectPrototype = $Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $Object ? ObjectPrototype : null;
};

},{"a7241aa10ce7a133":"6ZrQU","a331eb0cdbbce71f":"3n2Kg","fb3d4f0c40b195b3":"gHSkd","e8c3ea24cea26a66":"ge3J0","63dfe3761d5dc038":"l0mae"}],"l0mae":[function(require,module,exports) {
"use strict";
var fails = require("9cb7c297d70ae3d");
module.exports = !fails(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"9cb7c297d70ae3d":"cpXM6"}],"cBlN5":[function(require,module,exports) {
"use strict";
var createNonEnumerableProperty = require("55fb9f3249d37347");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else createNonEnumerableProperty(target, key, value);
    return target;
};

},{"55fb9f3249d37347":"e9yHG"}],"kNxUP":[function(require,module,exports) {
"use strict";
var TO_STRING_TAG_SUPPORT = require("7673b35616f48cb3");
var defineProperty = require("e02e83a16911ec49").f;
var createNonEnumerableProperty = require("43713ce2b5f29265");
var hasOwn = require("5ff6dfcf211c7b3");
var toString = require("33ccbf98a189ba38");
var wellKnownSymbol = require("864f9f0ea8e4be2b");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    var target = STATIC ? it : it && it.prototype;
    if (target) {
        if (!hasOwn(target, TO_STRING_TAG)) defineProperty(target, TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !TO_STRING_TAG_SUPPORT) createNonEnumerableProperty(target, "toString", toString);
    }
};

},{"7673b35616f48cb3":"duLTs","e02e83a16911ec49":"l2cFV","43713ce2b5f29265":"e9yHG","5ff6dfcf211c7b3":"6ZrQU","33ccbf98a189ba38":"8HLPq","864f9f0ea8e4be2b":"guevu"}],"duLTs":[function(require,module,exports) {
"use strict";
var wellKnownSymbol = require("ba0a343f3b18fcdd");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var test = {};
test[TO_STRING_TAG] = "z";
module.exports = String(test) === "[object z]";

},{"ba0a343f3b18fcdd":"guevu"}],"8HLPq":[function(require,module,exports) {
"use strict";
var TO_STRING_TAG_SUPPORT = require("71de9c12ce48151b");
var classof = require("de8994810d73555c");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
    return "[object " + classof(this) + "]";
};

},{"71de9c12ce48151b":"duLTs","de8994810d73555c":"9xtZk"}],"9xtZk":[function(require,module,exports) {
"use strict";
var TO_STRING_TAG_SUPPORT = require("ca80980ca8828ed9");
var isCallable = require("b0a3d999017d786");
var classofRaw = require("547575657d0eac4a");
var wellKnownSymbol = require("d0d3a571c672065f");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var $Object = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === "Object" && isCallable(O.callee) ? "Arguments" : result;
};

},{"ca80980ca8828ed9":"duLTs","b0a3d999017d786":"3n2Kg","547575657d0eac4a":"1piK0","d0d3a571c672065f":"guevu"}],"chSEo":[function(require,module,exports) {
"use strict";
/* eslint-disable no-proto -- safe */ var uncurryThisAccessor = require("c853342675be3a14");
var isObject = require("67a13ef7e16025ca");
var requireObjectCoercible = require("6f408548a0bee5c2");
var aPossiblePrototype = require("5536fd1509637c0c");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = uncurryThisAccessor(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        requireObjectCoercible(O);
        aPossiblePrototype(proto);
        if (!isObject(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

},{"c853342675be3a14":"kNy4l","67a13ef7e16025ca":"6gtp8","6f408548a0bee5c2":"2wITG","5536fd1509637c0c":"hCyEs"}],"kNy4l":[function(require,module,exports) {
"use strict";
var uncurryThis = require("bd6cd550666a3166");
var aCallable = require("72002f741e4febe7");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

},{"bd6cd550666a3166":"b7Ro2","72002f741e4febe7":"kUVsN"}],"hCyEs":[function(require,module,exports) {
"use strict";
var isPossiblePrototype = require("fdf59f0ef06b4002");
var $String = String;
var $TypeError = TypeError;
module.exports = function(argument) {
    if (isPossiblePrototype(argument)) return argument;
    throw new $TypeError("Can't set " + $String(argument) + " as a prototype");
};

},{"fdf59f0ef06b4002":"LVTiM"}],"LVTiM":[function(require,module,exports) {
"use strict";
var isObject = require("7bd3b3cc624a50b5");
module.exports = function(argument) {
    return isObject(argument) || argument === null;
};

},{"7bd3b3cc624a50b5":"6gtp8"}],"hDCch":[function(require,module,exports) {
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

},{}],"5F3BB":[function(require,module,exports) {
"use strict";
var global = require("38630e4b2e37e3f7");
var DESCRIPTORS = require("7eeb49328a551c04");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!DESCRIPTORS) return global[name];
    var descriptor = getOwnPropertyDescriptor(global, name);
    return descriptor && descriptor.value;
};

},{"38630e4b2e37e3f7":"lVXFY","7eeb49328a551c04":"4wVcO"}],"3GsGZ":[function(require,module,exports) {
"use strict";
var fails = require("a2da4b23f75059f2");
var wellKnownSymbol = require("748635d5e556d6e");
var DESCRIPTORS = require("2e57f5c040b13b70");
var IS_PURE = require("f2c8fc6bd76ed288");
var ITERATOR = wellKnownSymbol("iterator");
module.exports = !fails(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var params = url.searchParams;
    var params2 = new URLSearchParams("a=1&a=2&b=3");
    var result = "";
    url.pathname = "c%20d";
    params.forEach(function(value, key) {
        params["delete"]("b");
        result += key + value;
    });
    params2["delete"]("a", 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2["delete"]("b", undefined);
    return IS_PURE && (!url.toJSON || !params2.has("a", 1) || params2.has("a", 2) || !params2.has("a", undefined) || params2.has("b")) || !params.size && (IS_PURE || !DESCRIPTORS) || !params.sort || url.href !== "http://a/c%20d?a=1&c=3" || params.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !params[ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://\u0442\u0435\u0441\u0442").host !== "xn--e1aybc" || new URL("http://a#\u0431").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});

},{"a2da4b23f75059f2":"cpXM6","748635d5e556d6e":"guevu","2e57f5c040b13b70":"4wVcO","f2c8fc6bd76ed288":"5eDb0"}],"7Acg5":[function(require,module,exports) {
"use strict";
var defineProperty = require("bd197f2859d21e5b");
module.exports = function(target, name, descriptor) {
    return defineProperty.f(target, name, descriptor);
};

},{"bd197f2859d21e5b":"l2cFV"}],"fJcZy":[function(require,module,exports) {
"use strict";
var defineBuiltIn = require("b2bc0a28654316f4");
module.exports = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else defineBuiltIn(target, key, src[key], options);
    return target;
};

},{"b2bc0a28654316f4":"cBlN5"}],"8Ydpa":[function(require,module,exports) {
"use strict";
var isPrototypeOf = require("fd0529e143e1c2e8");
var $TypeError = TypeError;
module.exports = function(it, Prototype) {
    if (isPrototypeOf(Prototype, it)) return it;
    throw new $TypeError("Incorrect invocation");
};

},{"fd0529e143e1c2e8":"cIcau"}],"25yKQ":[function(require,module,exports) {
"use strict";
var classof = require("3d4d7e741c7538b9");
var $String = String;
module.exports = function(argument) {
    if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $String(argument);
};

},{"3d4d7e741c7538b9":"9xtZk"}],"kcajT":[function(require,module,exports) {
"use strict";
var call = require("1ed03ce4620a3314");
var aCallable = require("7ff8cbd64baae7a8");
var anObject = require("4af82b8cc468d406");
var tryToString = require("356c6d40d3eb7e34");
var getIteratorMethod = require("7ef8b84795881d05");
var $TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
    throw new $TypeError(tryToString(argument) + " is not iterable");
};

},{"1ed03ce4620a3314":"eRBbz","7ff8cbd64baae7a8":"kUVsN","4af82b8cc468d406":"gmak8","356c6d40d3eb7e34":"dMRbE","7ef8b84795881d05":"b7Qae"}],"b7Qae":[function(require,module,exports) {
"use strict";
var classof = require("585a0e07ddf61fb6");
var getMethod = require("3f48ea3686dda97c");
var isNullOrUndefined = require("4c36f79ab29ce40c");
var Iterators = require("741057f93ff851f");
var wellKnownSymbol = require("cab389129623db46");
var ITERATOR = wellKnownSymbol("iterator");
module.exports = function(it) {
    if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, "@@iterator") || Iterators[classof(it)];
};

},{"585a0e07ddf61fb6":"9xtZk","3f48ea3686dda97c":"fUt66","4c36f79ab29ce40c":"9MCnB","741057f93ff851f":"lqVAd","cab389129623db46":"guevu"}],"ZmUg7":[function(require,module,exports) {
"use strict";
var $TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $TypeError("Not enough arguments");
    return passed;
};

},{}],"1g1Zv":[function(require,module,exports) {
"use strict";
var arraySlice = require("5cf7fe8551b45f68");
var floor = Math.floor;
var sort = function(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = floor(length / 2);
        var left = sort(arraySlice(array, 0, middle), comparefn);
        var right = sort(arraySlice(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
module.exports = sort;

},{"5cf7fe8551b45f68":"lyRes"}],"lyRes":[function(require,module,exports) {
"use strict";
var uncurryThis = require("9bc49279ff26093a");
module.exports = uncurryThis([].slice);

},{"9bc49279ff26093a":"b7Ro2"}],"5ryP3":[function(require,module,exports) {
// empty

},{}],"coFHg":[function(require,module,exports) {
// empty

},{}],"k8Vb7":[function(require,module,exports) {
// empty

},{}],"cZd9M":[function(require,module,exports) {
"use strict";
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("d1eac6aca5b5f06e");

},{"d1eac6aca5b5f06e":"4iFkh"}],"4iFkh":[function(require,module,exports) {
"use strict";
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require("9a2f136e9b58bb3a");
var $ = require("971cb3db25283e26");
var DESCRIPTORS = require("e0b7956ce2ed5f8e");
var USE_NATIVE_URL = require("ee479faad711ac86");
var global = require("e31e52a1e0ab4182");
var bind = require("ad8a8634ccbd7f31");
var uncurryThis = require("a734512304e090d7");
var defineBuiltIn = require("2a3cab5cec42fbc");
var defineBuiltInAccessor = require("dbd11dd291badec3");
var anInstance = require("8fd9cd1507d045e0");
var hasOwn = require("dd074e7a5fa8a4");
var assign = require("4c0b7b9b29c798fc");
var arrayFrom = require("25be85473a80211d");
var arraySlice = require("a4f7bf62ac0dd279");
var codeAt = require("1054d066d4bfa08a").codeAt;
var toASCII = require("7c649a29c82992e3");
var $toString = require("b055506eacfb8b20");
var setToStringTag = require("3e08e4cd555f7073");
var validateArgumentsLength = require("6e6043273cc6f8a8");
var URLSearchParamsModule = require("b08c591b4c9defcd");
var InternalStateModule = require("1aeb4c1feb0e52c5");
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor("URL");
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis("".charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis("".replace);
var shift = uncurryThis([].shift);
var split = uncurryThis("".split);
var stringSlice = uncurryThis("".slice);
var toLowerCase = uncurryThis("".toLowerCase);
var unshift = uncurryThis([].unshift);
var INVALID_AUTHORITY = "Invalid authority";
var INVALID_SCHEME = "Invalid scheme";
var INVALID_HOST = "Invalid host";
var INVALID_PORT = "Invalid port";
var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function(input) {
    var parts = split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === "") return input;
        radix = 10;
        if (part.length > 1 && charAt(part, 0) === "0") {
            radix = exec(HEX_START, part) ? 16 : 8;
            part = stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
            number = parseInt(part, radix);
        }
        push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function() {
        return charAt(input, pointer);
    };
    if (chr() === ":") {
        if (charAt(input, 1) !== ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && exec(HEX, chr())){
            value = value * 16 + parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === ".") {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!exec(DIGIT, chr())) return;
                while(exec(DIGIT, chr())){
                    number = parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var findLongestZeroSequence = function(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            unshift(result, host % 256);
            host = floor(host / 256);
        }
        return join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var percentEncode = function(chr, set) {
    var code = codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function(string, normalized) {
    var second;
    return string.length === 2 && exec(ALPHA, charAt(string, 0)) && ((second = charAt(string, 1)) === ":" || !normalized && second === "|");
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function(string) {
    var third;
    return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (string.length === 2 || (third = charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function(segment) {
    return segment === "." || toLowerCase(segment) === "%2e";
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function(segment) {
    segment = toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};
var URLState = function(url, isBase, base) {
    var urlString = $toString(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new TypeError(failure);
        searchParams = getInternalSearchParamsState(new URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
URLState.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || SCHEME_START;
        var pointer = 0;
        var buffer = "";
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $toString(input);
        if (!stateOverride) {
            url.scheme = "";
            url.username = "";
            url.password = "";
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = replace(input, LEADING_C0_CONTROL_OR_SPACE, "");
            input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, "$1");
        }
        input = replace(input, TAB_AND_NEW_LINE, "");
        codePoints = arrayFrom(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case SCHEME_START:
                    if (chr && exec(ALPHA, chr)) {
                        buffer += toLowerCase(chr);
                        state = SCHEME;
                    } else if (!stateOverride) {
                        state = NO_SCHEME;
                        continue;
                    } else return INVALID_SCHEME;
                    break;
                case SCHEME:
                    if (chr && (exec(ALPHANUMERIC, chr) || chr === "+" || chr === "-" || chr === ".")) buffer += toLowerCase(chr);
                    else if (chr === ":") {
                        if (stateOverride && (url.isSpecial() !== hasOwn(specialSchemes, buffer) || buffer === "file" && (url.includesCredentials() || url.port !== null) || url.scheme === "file" && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = "";
                        if (url.scheme === "file") state = FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === "/") {
                            state = PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            push(url.path, "");
                            state = CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = "";
                        state = NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return INVALID_SCHEME;
                    break;
                case NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== "#") return INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === "#") {
                        url.scheme = base.scheme;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        url.cannotBeABaseURL = true;
                        state = FRAGMENT;
                        break;
                    }
                    state = base.scheme === "file" ? FILE : RELATIVE;
                    continue;
                case SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === "/" && codePoints[pointer + 1] === "/") {
                        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = RELATIVE;
                        continue;
                    }
                    break;
                case PATH_OR_AUTHORITY:
                    if (chr === "/") {
                        state = AUTHORITY;
                        break;
                    } else {
                        state = PATH;
                        continue;
                    }
                case RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                    } else if (chr === "/" || chr === "\\" && url.isSpecial()) state = RELATIVE_SLASH;
                    else if (chr === "?") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.query = "";
                        state = QUERY;
                    } else if (chr === "#") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = arraySlice(base.path);
                        url.path.length--;
                        state = PATH;
                        continue;
                    }
                    break;
                case RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === "/" || chr === "\\")) state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === "/") state = AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = PATH;
                        continue;
                    }
                    break;
                case SPECIAL_AUTHORITY_SLASHES:
                    state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== "/" || charAt(buffer, pointer + 1) !== "/") continue;
                    pointer++;
                    break;
                case SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== "/" && chr !== "\\") {
                        state = AUTHORITY;
                        continue;
                    }
                    break;
                case AUTHORITY:
                    if (chr === "@") {
                        if (seenAt) buffer = "%40" + buffer;
                        seenAt = true;
                        bufferCodePoints = arrayFrom(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ":" && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = "";
                    } else if (chr === EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
                        if (seenAt && buffer === "") return INVALID_AUTHORITY;
                        pointer -= arrayFrom(buffer).length + 1;
                        buffer = "";
                        state = HOST;
                    } else buffer += chr;
                    break;
                case HOST:
                case HOSTNAME:
                    if (stateOverride && url.scheme === "file") {
                        state = FILE_HOST;
                        continue;
                    } else if (chr === ":" && !seenBracket) {
                        if (buffer === "") return INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = PORT;
                        if (stateOverride === HOSTNAME) return;
                    } else if (chr === EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial()) {
                        if (url.isSpecial() && buffer === "") return INVALID_HOST;
                        if (stateOverride && buffer === "" && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === "[") seenBracket = true;
                        else if (chr === "]") seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case PORT:
                    if (exec(DIGIT, chr)) buffer += chr;
                    else if (chr === EOF || chr === "/" || chr === "?" || chr === "#" || chr === "\\" && url.isSpecial() || stateOverride) {
                        if (buffer !== "") {
                            var port = parseInt(buffer, 10);
                            if (port > 0xFFFF) return INVALID_PORT;
                            url.port = url.isSpecial() && port === specialSchemes[url.scheme] ? null : port;
                            buffer = "";
                        }
                        if (stateOverride) return;
                        state = PATH_START;
                        continue;
                    } else return INVALID_PORT;
                    break;
                case FILE:
                    url.scheme = "file";
                    if (chr === "/" || chr === "\\") state = FILE_SLASH;
                    else if (base && base.scheme === "file") switch(chr){
                        case EOF:
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            url.query = base.query;
                            break;
                        case "?":
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            url.query = "";
                            state = QUERY;
                            break;
                        case "#":
                            url.host = base.host;
                            url.path = arraySlice(base.path);
                            url.query = base.query;
                            url.fragment = "";
                            state = FRAGMENT;
                            break;
                        default:
                            if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ""))) {
                                url.host = base.host;
                                url.path = arraySlice(base.path);
                                url.shortenPath();
                            }
                            state = PATH;
                            continue;
                    }
                    else {
                        state = PATH;
                        continue;
                    }
                    break;
                case FILE_SLASH:
                    if (chr === "/" || chr === "\\") {
                        state = FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === "file" && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ""))) {
                        if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = PATH;
                    continue;
                case FILE_HOST:
                    if (chr === EOF || chr === "/" || chr === "\\" || chr === "?" || chr === "#") {
                        if (!stateOverride && isWindowsDriveLetter(buffer)) state = PATH;
                        else if (buffer === "") {
                            url.host = "";
                            if (stateOverride) return;
                            state = PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === "localhost") url.host = "";
                            if (stateOverride) return;
                            buffer = "";
                            state = PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case PATH_START:
                    if (url.isSpecial()) {
                        state = PATH;
                        if (chr !== "/" && chr !== "\\") continue;
                    } else if (!stateOverride && chr === "?") {
                        url.query = "";
                        state = QUERY;
                    } else if (!stateOverride && chr === "#") {
                        url.fragment = "";
                        state = FRAGMENT;
                    } else if (chr !== EOF) {
                        state = PATH;
                        if (chr !== "/") continue;
                    }
                    break;
                case PATH:
                    if (chr === EOF || chr === "/" || chr === "\\" && url.isSpecial() || !stateOverride && (chr === "?" || chr === "#")) {
                        if (isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== "/" && !(chr === "\\" && url.isSpecial())) push(url.path, "");
                        } else if (isSingleDot(buffer)) {
                            if (chr !== "/" && !(chr === "\\" && url.isSpecial())) push(url.path, "");
                        } else {
                            if (url.scheme === "file" && !url.path.length && isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = "";
                                buffer = charAt(buffer, 0) + ":"; // normalize windows drive letter
                            }
                            push(url.path, buffer);
                        }
                        buffer = "";
                        if (url.scheme === "file" && (chr === EOF || chr === "?" || chr === "#")) while(url.path.length > 1 && url.path[0] === "")shift(url.path);
                        if (chr === "?") {
                            url.query = "";
                            state = QUERY;
                        } else if (chr === "#") {
                            url.fragment = "";
                            state = FRAGMENT;
                        }
                    } else buffer += percentEncode(chr, pathPercentEncodeSet);
                    break;
                case CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === "?") {
                        url.query = "";
                        state = QUERY;
                    } else if (chr === "#") {
                        url.fragment = "";
                        state = FRAGMENT;
                    } else if (chr !== EOF) url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
                    break;
                case QUERY:
                    if (!stateOverride && chr === "#") {
                        url.fragment = "";
                        state = FRAGMENT;
                    } else if (chr !== EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += "%27";
                        else if (chr === "#") url.query += "%23";
                        else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
                    }
                    break;
                case FRAGMENT:
                    if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(input) {
        var result, codePoints, index;
        if (charAt(input, 0) === "[") {
            if (charAt(input, input.length - 1) !== "]") return INVALID_HOST;
            result = parseIPv6(stringSlice(input, 1, -1));
            if (!result) return INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
            result = "";
            codePoints = arrayFrom(input);
            for(index = 0; index < codePoints.length; index++)result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = toASCII(input);
            if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
            result = parseIPv4(input);
            if (result === null) return INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
        return !this.host || this.cannotBeABaseURL || this.scheme === "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
        return this.username !== "" || this.password !== "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
        return hasOwn(specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== "file" || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ":";
        if (host !== null) {
            output += "//";
            if (url.includesCredentials()) output += username + (password ? ":" + password : "") + "@";
            output += serializeHost(host);
            if (port !== null) output += ":" + port;
        } else if (scheme === "file") output += "//";
        output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + join(path, "/") : "";
        if (query !== null) output += "?" + query;
        if (fragment !== null) output += "#" + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(href) {
        var failure = this.parse(href);
        if (failure) throw new TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === "blob") try {
            return new URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return "null";
        }
        if (scheme === "file" || !this.isSpecial()) return "null";
        return scheme + "://" + serializeHost(this.host) + (port !== null ? ":" + port : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
        return this.scheme + ":";
    },
    setProtocol: function(protocol) {
        this.parse($toString(protocol) + ":", SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
        return this.username;
    },
    setUsername: function(username) {
        var codePoints = arrayFrom($toString(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = "";
        for(var i = 0; i < codePoints.length; i++)this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
        return this.password;
    },
    setPassword: function(password) {
        var codePoints = arrayFrom($toString(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = "";
        for(var i = 0; i < codePoints.length; i++)this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
        var host = this.host;
        var port = this.port;
        return host === null ? "" : port === null ? serializeHost(host) : serializeHost(host) + ":" + port;
    },
    setHost: function(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
        var host = this.host;
        return host === null ? "" : serializeHost(host);
    },
    setHostname: function(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
        var port = this.port;
        return port === null ? "" : $toString(port);
    },
    setPort: function(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $toString(port);
        if (port === "") this.port = null;
        else this.parse(port, PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? "/" + join(path, "/") : "";
    },
    setPathname: function(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
        var query = this.query;
        return query ? "?" + query : "";
    },
    setSearch: function(search) {
        search = $toString(search);
        if (search === "") this.query = null;
        else {
            if (charAt(search, 0) === "?") search = stringSlice(search, 1);
            this.query = "";
            this.parse(search, QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
        var fragment = this.fragment;
        return fragment ? "#" + fragment : "";
    },
    setHash: function(hash) {
        hash = $toString(hash);
        if (hash === "") {
            this.fragment = null;
            return;
        }
        if (charAt(hash, 0) === "#") hash = stringSlice(hash, 1);
        this.fragment = "";
        this.parse(hash, FRAGMENT);
    },
    update: function() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */ ) {
    var that = anInstance(this, URLPrototype);
    var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = setInternalState(that, new URLState(url, false, base));
    if (!DESCRIPTORS) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var URLPrototype = URLConstructor.prototype;
var accessorDescriptor = function(getter, setter) {
    return {
        get: function() {
            return getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if (DESCRIPTORS) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    defineBuiltInAccessor(URLPrototype, "href", accessorDescriptor("serialize", "setHref"));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    defineBuiltInAccessor(URLPrototype, "origin", accessorDescriptor("getOrigin"));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    defineBuiltInAccessor(URLPrototype, "protocol", accessorDescriptor("getProtocol", "setProtocol"));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    defineBuiltInAccessor(URLPrototype, "username", accessorDescriptor("getUsername", "setUsername"));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    defineBuiltInAccessor(URLPrototype, "password", accessorDescriptor("getPassword", "setPassword"));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    defineBuiltInAccessor(URLPrototype, "host", accessorDescriptor("getHost", "setHost"));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    defineBuiltInAccessor(URLPrototype, "hostname", accessorDescriptor("getHostname", "setHostname"));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    defineBuiltInAccessor(URLPrototype, "port", accessorDescriptor("getPort", "setPort"));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    defineBuiltInAccessor(URLPrototype, "pathname", accessorDescriptor("getPathname", "setPathname"));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    defineBuiltInAccessor(URLPrototype, "search", accessorDescriptor("getSearch", "setSearch"));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    defineBuiltInAccessor(URLPrototype, "searchParams", accessorDescriptor("getSearchParams"));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    defineBuiltInAccessor(URLPrototype, "hash", accessorDescriptor("getHash", "setHash"));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, "toJSON", function toJSON() {
    return getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, "toString", function toString() {
    return getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if (NativeURL) {
    var nativeCreateObjectURL = NativeURL.createObjectURL;
    var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, "createObjectURL", bind(nativeCreateObjectURL, NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, "revokeObjectURL", bind(nativeRevokeObjectURL, NativeURL));
}
setToStringTag(URLConstructor, "URL");
$({
    global: true,
    constructor: true,
    forced: !USE_NATIVE_URL,
    sham: !DESCRIPTORS
}, {
    URL: URLConstructor
});

},{"9a2f136e9b58bb3a":"5WN74","971cb3db25283e26":"4CdND","e0b7956ce2ed5f8e":"4wVcO","ee479faad711ac86":"3GsGZ","e31e52a1e0ab4182":"lVXFY","ad8a8634ccbd7f31":"4gNtY","a734512304e090d7":"b7Ro2","2a3cab5cec42fbc":"cBlN5","dbd11dd291badec3":"7Acg5","8fd9cd1507d045e0":"8Ydpa","dd074e7a5fa8a4":"6ZrQU","4c0b7b9b29c798fc":"5Oufb","25be85473a80211d":"lG07M","a4f7bf62ac0dd279":"lyRes","1054d066d4bfa08a":"iJU3P","7c649a29c82992e3":"8o3xv","b055506eacfb8b20":"25yKQ","3e08e4cd555f7073":"kNxUP","6e6043273cc6f8a8":"ZmUg7","b08c591b4c9defcd":"bIJiC","1aeb4c1feb0e52c5":"gn7n9"}],"5WN74":[function(require,module,exports) {
"use strict";
var charAt = require("e0ebabe3a406d951").charAt;
var toString = require("21771611fb7b9ee8");
var InternalStateModule = require("ac50ef960e508a39");
var defineIterator = require("c80c7e7435a65811");
var createIterResultObject = require("5e88ad8c47a69bec");
var STRING_ITERATOR = "String Iterator";
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, "String", function(iterated) {
    setInternalState(this, {
        type: STRING_ITERATOR,
        string: toString(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return createIterResultObject(undefined, true);
    point = charAt(string, index);
    state.index += point.length;
    return createIterResultObject(point, false);
});

},{"e0ebabe3a406d951":"iJU3P","21771611fb7b9ee8":"25yKQ","ac50ef960e508a39":"gn7n9","c80c7e7435a65811":"4ZygF","5e88ad8c47a69bec":"hDCch"}],"iJU3P":[function(require,module,exports) {
"use strict";
var uncurryThis = require("9fb6b0d2cabacc66");
var toIntegerOrInfinity = require("3707a16edec4ccec");
var toString = require("e95f3139075064f5");
var requireObjectCoercible = require("ecc4d9f3f4663b71");
var charAt = uncurryThis("".charAt);
var charCodeAt = uncurryThis("".charCodeAt);
var stringSlice = uncurryThis("".slice);
var createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = toString(requireObjectCoercible($this));
        var position = toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
};

},{"9fb6b0d2cabacc66":"b7Ro2","3707a16edec4ccec":"alLu5","e95f3139075064f5":"25yKQ","ecc4d9f3f4663b71":"2wITG"}],"5Oufb":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("d3bb23ab2544e091");
var uncurryThis = require("26c479dcd2597a7b");
var call = require("e4dbf0a7a5ecfd5c");
var fails = require("1122b7cf1e5217ae");
var objectKeys = require("9bfcf8310a7eecfa");
var getOwnPropertySymbolsModule = require("99e6c3f7c60800d0");
var propertyIsEnumerableModule = require("5becab0b1e793466");
var toObject = require("392699a892cb1289");
var IndexedObject = require("6c3dfa948d386fec");
// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function() {
    // should have correct order of operations (Edge bug)
    if (DESCRIPTORS && $assign({
        b: 1
    }, $assign(defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;

},{"d3bb23ab2544e091":"4wVcO","26c479dcd2597a7b":"b7Ro2","e4dbf0a7a5ecfd5c":"eRBbz","1122b7cf1e5217ae":"cpXM6","9bfcf8310a7eecfa":"kdoy9","99e6c3f7c60800d0":"92aI3","5becab0b1e793466":"5qnTr","392699a892cb1289":"gHSkd","6c3dfa948d386fec":"2dJh8"}],"92aI3":[function(require,module,exports) {
"use strict";
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],"lG07M":[function(require,module,exports) {
"use strict";
var bind = require("5659cc3c212e1d05");
var call = require("ab25573878595136");
var toObject = require("822f2a25f6c24f00");
var callWithSafeIterationClosing = require("2e47ddf08b436781");
var isArrayIteratorMethod = require("2109fe506db269a7");
var isConstructor = require("52d7e566eb84398f");
var lengthOfArrayLike = require("c40d050a5fb59259");
var createProperty = require("6eb9cbc78f34b5ba");
var getIterator = require("a60a462f53964604");
var getIteratorMethod = require("3d776dcce177cf84");
var $Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = toObject(arrayLike);
    var IS_CONSTRUCTOR = isConstructor(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = getIteratorMethod(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = getIterator(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = call(next, iterator)).done; index++){
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            createProperty(result, index, value);
        }
    } else {
        length = lengthOfArrayLike(O);
        result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            createProperty(result, index, value);
        }
    }
    result.length = index;
    return result;
};

},{"5659cc3c212e1d05":"4gNtY","ab25573878595136":"eRBbz","822f2a25f6c24f00":"gHSkd","2e47ddf08b436781":"9ZWY3","2109fe506db269a7":"5IdlC","52d7e566eb84398f":"5Slrw","c40d050a5fb59259":"ayCmf","6eb9cbc78f34b5ba":"4VAUd","a60a462f53964604":"kcajT","3d776dcce177cf84":"b7Qae"}],"9ZWY3":[function(require,module,exports) {
"use strict";
var anObject = require("342af485950b53c4");
var iteratorClose = require("7f8444b3df75ffb");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
    } catch (error) {
        iteratorClose(iterator, "throw", error);
    }
};

},{"342af485950b53c4":"gmak8","7f8444b3df75ffb":"8FPBT"}],"8FPBT":[function(require,module,exports) {
"use strict";
var call = require("bea3ceae6dc568a5");
var anObject = require("b4acfa8ef74502cc");
var getMethod = require("b6385ef844a024b6");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    anObject(iterator);
    try {
        innerResult = getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = call(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    anObject(innerResult);
    return value;
};

},{"bea3ceae6dc568a5":"eRBbz","b4acfa8ef74502cc":"gmak8","b6385ef844a024b6":"fUt66"}],"5IdlC":[function(require,module,exports) {
"use strict";
var wellKnownSymbol = require("d67a8865daa2c800");
var Iterators = require("3c0c029dc4382426");
var ITERATOR = wellKnownSymbol("iterator");
var ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"d67a8865daa2c800":"guevu","3c0c029dc4382426":"lqVAd"}],"5Slrw":[function(require,module,exports) {
"use strict";
var uncurryThis = require("593efac18ede3666");
var fails = require("5a0c3746e01d7358");
var isCallable = require("e130ade161aa0df");
var classof = require("e9e20de2bed4e467");
var getBuiltIn = require("f959f837ef140e61");
var inspectSource = require("39e31a122d1ff603");
var noop = function() {};
var construct = getBuiltIn("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
var isConstructorModern = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    try {
        construct(noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    switch(classof(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
        return true;
    }
};
isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"593efac18ede3666":"b7Ro2","5a0c3746e01d7358":"cpXM6","e130ade161aa0df":"3n2Kg","e9e20de2bed4e467":"9xtZk","f959f837ef140e61":"9SbBm","39e31a122d1ff603":"iN4X8"}],"iN4X8":[function(require,module,exports) {
"use strict";
var uncurryThis = require("9b2808ae2f1b93ca");
var isCallable = require("2665e08ce7390c36");
var store = require("42eb5fda20c53450");
var functionToString = uncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
module.exports = store.inspectSource;

},{"9b2808ae2f1b93ca":"b7Ro2","2665e08ce7390c36":"3n2Kg","42eb5fda20c53450":"8HEmW"}],"4VAUd":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("77363901c620d6f2");
var definePropertyModule = require("44aa9d5f94ef6c4e");
var createPropertyDescriptor = require("759fdb96211597b4");
module.exports = function(object, key, value) {
    if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
    else object[key] = value;
};

},{"77363901c620d6f2":"4wVcO","44aa9d5f94ef6c4e":"l2cFV","759fdb96211597b4":"35V9v"}],"8o3xv":[function(require,module,exports) {
"use strict";
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = require("7431fe92a1b34178");
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = "-"; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var baseMinusTMin = base - tMin;
var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis("".charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis("".replace);
var split = uncurryThis("".split);
var toLowerCase = uncurryThis("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var ucs2decode = function(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                push(output, value);
                counter--;
            }
        } else push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var digitToBasic = function(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var adapt = function(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    while(delta > baseMinusTMin * tMax >> 1){
        delta = floor(delta / baseMinusTMin);
        k += base;
    }
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var encode = function(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = initialN;
    var delta = 0;
    var bias = initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) push(output, fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) push(output, delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) throw new $RangeError(OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > maxInt) throw new $RangeError(OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = base;
                while(true){
                    var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = base - t;
                    push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
                    q = floor(qMinusT / baseMinusT);
                    k += base;
                }
                push(output, fromCharCode(digitToBasic(q)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return join(output, "");
};
module.exports = function(input) {
    var encoded = [];
    var labels = split(replace(toLowerCase(input), regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        push(encoded, exec(regexNonASCII, label) ? "xn--" + encode(label) : label);
    }
    return join(encoded, ".");
};

},{"7431fe92a1b34178":"b7Ro2"}],"k2589":[function(require,module,exports) {
"use strict";
var $ = require("cdda4d6033cf03b9");
var getBuiltIn = require("45fcb781936fe66d");
var fails = require("c67764390ae5ac59");
var validateArgumentsLength = require("b73bc2011364e1a6");
var toString = require("7b20c8cac1b0e1ec");
var USE_NATIVE_URL = require("dd5ab92f11b24a3c");
var URL = getBuiltIn("URL");
// https://github.com/nodejs/node/issues/47505
// https://github.com/denoland/deno/issues/18893
var THROWS_WITHOUT_ARGUMENTS = USE_NATIVE_URL && fails(function() {
    URL.canParse();
});
// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9250
var WRONG_ARITY = fails(function() {
    return URL.canParse.length !== 1;
});
// `URL.canParse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({
    target: "URL",
    stat: true,
    forced: !THROWS_WITHOUT_ARGUMENTS || WRONG_ARITY
}, {
    canParse: function canParse(url) {
        var length = validateArgumentsLength(arguments.length, 1);
        var urlString = toString(url);
        var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
        try {
            return new URL(urlString, base), true;
        } catch (error) {
            return false;
        }
    }
});

},{"cdda4d6033cf03b9":"4CdND","45fcb781936fe66d":"9SbBm","c67764390ae5ac59":"cpXM6","b73bc2011364e1a6":"ZmUg7","7b20c8cac1b0e1ec":"25yKQ","dd5ab92f11b24a3c":"3GsGZ"}],"gPb1i":[function(require,module,exports) {
"use strict";
var $ = require("69c6b45caba5ba35");
var getBuiltIn = require("9fbf955a03b64c18");
var validateArgumentsLength = require("f0e65ba0ad8e505");
var toString = require("65267a18f837a2be");
var URL = getBuiltIn("URL");
// `URL.parse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({
    target: "URL",
    stat: true
}, {
    parse: function parse(url) {
        var length = validateArgumentsLength(arguments.length, 1);
        var urlString = toString(url);
        var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
        try {
            return new URL(urlString, base);
        } catch (error) {
            return null;
        }
    }
});

},{"69c6b45caba5ba35":"4CdND","9fbf955a03b64c18":"9SbBm","f0e65ba0ad8e505":"ZmUg7","65267a18f837a2be":"25yKQ"}],"eIBFV":[function(require,module,exports) {
// empty

},{}],"h9MeM":[function(require,module,exports) {
"use strict";
module.exports = require("95f180e1b5b5624b");

},{"95f180e1b5b5624b":"juKae"}],"juKae":[function(require,module,exports) {
"use strict";
var parent = require("6fc219d725ead6f3");
module.exports = parent;

},{"6fc219d725ead6f3":"5ThRl"}],"5ThRl":[function(require,module,exports) {
"use strict";
var parent = require("4847891e1615acc3");
module.exports = parent;

},{"4847891e1615acc3":"2uxLY"}],"2uxLY":[function(require,module,exports) {
"use strict";
var parent = require("dc98c38ade64b2f4");
require("60bc19f0ba3a21d1");
module.exports = parent;

},{"dc98c38ade64b2f4":"lJY9U","60bc19f0ba3a21d1":"aU85N"}],"aU85N":[function(require,module,exports) {
"use strict";
require("c4700241874e9cb4");
var DOMIterables = require("ef690f213183c609");
var global = require("c0663627648e9016");
var setToStringTag = require("d4601542c89a2d74");
var Iterators = require("7030c6180b1403f6");
for(var COLLECTION_NAME in DOMIterables){
    setToStringTag(global[COLLECTION_NAME], COLLECTION_NAME);
    Iterators[COLLECTION_NAME] = Iterators.Array;
}

},{"c4700241874e9cb4":"3YkFB","ef690f213183c609":"gYjmy","c0663627648e9016":"lVXFY","d4601542c89a2d74":"kNxUP","7030c6180b1403f6":"lqVAd"}],"gYjmy":[function(require,module,exports) {
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

},{}],"cm7uO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralClientSerdesInterceptor", ()=>CoralClientSerdesInterceptor);
var _operators = require("rxjs/operators");
var _client = require("../client");
var _model = require("../model");
class CoralClientSerdesInterceptor {
    constructor(operations = {}, syntheticExceptions = []){
        this.operations = operations;
        this.syntheticExceptions = syntheticExceptions;
    }
    intercept(request, next) {
        const response = next.handle(this.withSerializedBody(request));
        const coralOperation = this.operations[request.operation];
        if (!coralOperation) return response;
        return response.pipe((0, _operators.map)((response)=>{
            const body = response.body;
            if (response.ok) {
                const deserializationFn = coralOperation.deserializationFn;
                return new (0, _client.CoralResponse)(Object.assign(Object.assign({}, response), {
                    body: deserializationFn ? deserializationFn(body) : body
                }));
            } else {
                const exception = [].concat(this.syntheticExceptions).concat(coralOperation.modelledExceptions).find((errorConstructor)=>errorConstructor.fullyQualifiedTypeName === body.__type);
                if (exception) // tslint:disable-next-line:no-non-null-assertion
                throw new (0, _client.CoralResponse)(Object.assign(Object.assign({}, response), {
                    body: exception.fromJson(body)
                }));
                // Unmodelled Exception
                throw new (0, _client.CoralResponse)(Object.assign(Object.assign({}, response), {
                    body: new (0, _client.UnknownCoralError)(body, response.status)
                }));
            }
        }));
    }
    withSerializedBody(request) {
        const coralOperation = this.operations[request.operation];
        if (!coralOperation) return request;
        const serializationFn = coralOperation.serializationFn;
        if (serializationFn) return request.clone({
            body: serializationFn(request.body)
        });
        else {
            if (!request.body || !(request.body instanceof (0, _model.CoralModel))) return request;
            const body = request.body.constructor.toJson(request.body);
            return request.clone({
                body
            });
        }
    }
}

},{"rxjs/operators":"ggrIi","../client":"7JSEz","../model":"8kt8R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ggrIi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":"4qWW6","../internal/operators/auditTime":"8RvbG","../internal/operators/buffer":"2S6EL","../internal/operators/bufferCount":"gmiQw","../internal/operators/bufferTime":"7jBeD","../internal/operators/bufferToggle":"3I58S","../internal/operators/bufferWhen":"eAxGr","../internal/operators/catchError":"7rF1H","../internal/operators/combineAll":"3gD1U","../internal/operators/combineLatest":"3N35f","../internal/operators/concat":"8pRKh","../internal/operators/concatAll":"8bdTP","../internal/operators/concatMap":"4nwZ8","../internal/operators/concatMapTo":"dqNGp","../internal/operators/count":"2Fibo","../internal/operators/debounce":"6qDC7","../internal/operators/debounceTime":"c8BHO","../internal/operators/defaultIfEmpty":"1eMdN","../internal/operators/delay":"64BbM","../internal/operators/delayWhen":"lDbXG","../internal/operators/dematerialize":"1bYYn","../internal/operators/distinct":"gWe8h","../internal/operators/distinctUntilChanged":"98B5v","../internal/operators/distinctUntilKeyChanged":"hd3Vz","../internal/operators/elementAt":"92xaa","../internal/operators/endWith":"4VxEc","../internal/operators/every":"dXibX","../internal/operators/exhaust":"4Ehtr","../internal/operators/exhaustMap":"2Xdls","../internal/operators/expand":"3i3MM","../internal/operators/filter":"1uwXV","../internal/operators/finalize":"757w3","../internal/operators/find":"7WaV6","../internal/operators/findIndex":"9qcAF","../internal/operators/first":"eGELz","../internal/operators/groupBy":"g6z19","../internal/operators/ignoreElements":"ckr01","../internal/operators/isEmpty":"b6CBY","../internal/operators/last":"2oVKC","../internal/operators/map":"cvzfg","../internal/operators/mapTo":"39msm","../internal/operators/materialize":"aXm7q","../internal/operators/max":"9VIwB","../internal/operators/merge":"9GXnX","../internal/operators/mergeAll":"jXE8c","../internal/operators/mergeMap":"7NAZz","../internal/operators/mergeMapTo":"lm8sA","../internal/operators/mergeScan":"8odnE","../internal/operators/min":"eIMaq","../internal/operators/multicast":"GLY7l","../internal/operators/observeOn":"8iKY0","../internal/operators/onErrorResumeNext":"1lwYl","../internal/operators/pairwise":"hAUti","../internal/operators/partition":"51UVV","../internal/operators/pluck":"enRwh","../internal/operators/publish":"eqLc5","../internal/operators/publishBehavior":"aC28n","../internal/operators/publishLast":"aqjv1","../internal/operators/publishReplay":"2pe5R","../internal/operators/race":"3Gd59","../internal/operators/reduce":"8LzQg","../internal/operators/repeat":"7VXQV","../internal/operators/repeatWhen":"2wa5h","../internal/operators/retry":"jiZ39","../internal/operators/retryWhen":"4F6hS","../internal/operators/refCount":"ihxKV","../internal/operators/sample":"awQoL","../internal/operators/sampleTime":"10Tw1","../internal/operators/scan":"hX6nA","../internal/operators/sequenceEqual":"81se8","../internal/operators/share":"diIIU","../internal/operators/shareReplay":"1ysaZ","../internal/operators/single":"3kbFw","../internal/operators/skip":"6Y7P6","../internal/operators/skipLast":"dehzH","../internal/operators/skipUntil":"8Gc8j","../internal/operators/skipWhile":"brJq3","../internal/operators/startWith":"dBObJ","../internal/operators/subscribeOn":"33YTz","../internal/operators/switchAll":"kcfvT","../internal/operators/switchMap":"5lH3R","../internal/operators/switchMapTo":"b6eN6","../internal/operators/take":"jMzpW","../internal/operators/takeLast":"21udE","../internal/operators/takeUntil":"8NfQ5","../internal/operators/takeWhile":"dcbUw","../internal/operators/tap":"1LiLi","../internal/operators/throttle":"jinO2","../internal/operators/throttleTime":"6lj6f","../internal/operators/throwIfEmpty":"3A9HT","../internal/operators/timeInterval":"7omle","../internal/operators/timeout":"5TIfU","../internal/operators/timeoutWith":"d8OMJ","../internal/operators/timestamp":"cuNU1","../internal/operators/toArray":"ajufK","../internal/operators/window":"kAG83","../internal/operators/windowCount":"c5rVO","../internal/operators/windowTime":"1eYrc","../internal/operators/windowToggle":"iNHIA","../internal/operators/windowWhen":"iz1YG","../internal/operators/withLatestFrom":"fqcM0","../internal/operators/zip":"dfA7f","../internal/operators/zipAll":"1bLGR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qWW6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>audit);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
var AuditSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = void 0;
            try {
                var durationSelector = this.durationSelector;
                duration = durationSelector(value);
            } catch (err) {
                return this.destination.error(err);
            }
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
            if (!innerSubscription || innerSubscription.closed) this.clearThrottle();
            else this.add(this.throttled = innerSubscription);
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = undefined;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = undefined;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function() {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8RvbG":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auditTime", ()=>auditTime);
var _async = require("../scheduler/async");
var _audit = require("./audit");
var _timer = require("../observable/timer");
function auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _audit.audit)(function() {
        return (0, _timer.timer)(duration, scheduler);
    });
}

},{"../scheduler/async":"l1cmn","./audit":"4qWW6","../observable/timer":"jufOf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2S6EL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
var BufferSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add((0, _innerSubscribe.innerSubscribe)(closingNotifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(_this)));
        return _this;
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function() {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gmiQw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferCount", ()=>bufferCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = BufferCountSubscriber;
        else this.subscriberClass = BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
var BufferCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}((0, _subscriber.Subscriber));
var BufferSkipCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jBeD":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferTime", ()=>bufferTime);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _subscriber = require("../Subscriber");
var _isScheduler = require("../util/isScheduler");
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = (0, _async.async);
    if ((0, _isScheduler.isScheduler)(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var Context = /*@__PURE__*/ function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
var BufferTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: _this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: _this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: _this,
                scheduler: scheduler
            };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context_1;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

},{"tslib":"gBS4y","../scheduler/async":"l1cmn","../Subscriber":"jGx8F","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3I58S":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToggle", ()=>bufferToggle);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _subscribeToResult = require("../util/subscribeToResult");
var _outerSubscriber = require("../OuterSubscriber");
function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
var BufferToggleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add((0, _subscribeToResult.subscribeToResult)(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new (0, _subscription.Subscription)();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"gBS4y","../Subscription":"ahthJ","../util/subscribeToResult":"4ctqX","../OuterSubscriber":"fECUl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eAxGr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferWhen", ()=>bufferWhen);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _innerSubscribe = require("../innerSubscribe");
function bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
var BufferWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = undefined;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function() {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        } catch (err) {
            return this.error(err);
        }
        closingSubscription = new (0, _subscription.Subscription)();
        this.closingSubscription = closingSubscription;
        this.add(closingSubscription);
        this.subscribing = true;
        closingSubscription.add((0, _innerSubscribe.innerSubscribe)(closingNotifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
        this.subscribing = false;
    };
    return BufferWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../Subscription":"ahthJ","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rF1H":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3gD1U":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineAll", ()=>combineAll);
var _combineLatest = require("../observable/combineLatest");
function combineAll(project) {
    return function(source) {
        return source.lift(new (0, _combineLatest.CombineLatestOperator)(project));
    };
}

},{"../observable/combineLatest":"wg3KP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3N35f":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
var _isArray = require("../util/isArray");
var _combineLatest = require("../observable/combineLatest");
var _from = require("../observable/from");
var none = {};
function combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === "function") project = observables.pop();
    if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call((0, _from.from)([
            source
        ].concat(observables)), new (0, _combineLatest.CombineLatestOperator)(project));
    };
}

},{"../util/isArray":"2HaTi","../observable/combineLatest":"wg3KP","../observable/from":"6aqs0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8pRKh":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _concat = require("../observable/concat");
function concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function(source) {
        return source.lift.call((0, _concat.concat).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/concat":"2cXL0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nwZ8":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMap", ()=>concatMap);
var _mergeMap = require("./mergeMap");
function concatMap(project, resultSelector) {
    return (0, _mergeMap.mergeMap)(project, resultSelector, 1);
}

},{"./mergeMap":"7NAZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dqNGp":[function(require,module,exports) {
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMapTo", ()=>concatMapTo);
var _concatMap = require("./concatMap");
function concatMapTo(innerObservable, resultSelector) {
    return (0, _concatMap.concatMap)(function() {
        return innerObservable;
    }, resultSelector);
}

},{"./concatMap":"4nwZ8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Fibo":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", ()=>count);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
var CountOperator = /*@__PURE__*/ function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
var CountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qDC7":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function debounce(durationSelector) {
    return function(source) {
        return source.lift(new DebounceOperator(durationSelector));
    };
}
var DebounceOperator = /*@__PURE__*/ function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
var DebounceSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
        if (subscription && !subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = undefined;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = undefined;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8BHO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", ()=>debounceTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return source.lift(new DebounceTimeOperator(dueTime, scheduler));
    };
}
var DebounceTimeOperator = /*@__PURE__*/ function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
var DebounceTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../scheduler/async":"l1cmn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1eMdN":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIfEmpty", ()=>defaultIfEmpty);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new DefaultIfEmptyOperator(defaultValue));
    };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
var DefaultIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"64BbM":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    var absoluteDelay = (0, _isDate.isDate)(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
var DelayOperator = /*@__PURE__*/ function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
var DelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification((0, _notification.Notification).createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}((0, _subscriber.Subscriber));
var DelayMessage = /*@__PURE__*/ function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

},{"tslib":"gBS4y","../scheduler/async":"l1cmn","../util/isDate":"g98jK","../Subscriber":"jGx8F","../Notification":"3c26n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g98jK":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lDbXG":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", ()=>delayWhen);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _observable = require("../Observable");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new SubscriptionDelayObservable(source, subscriptionDelay).lift(new DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new DelayWhenOperator(delayDurationSelector));
    };
}
var DelayWhenOperator = /*@__PURE__*/ function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
var DelayWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
        this.unsubscribe();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = (0, _subscribeToResult.subscribeToResult)(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            var destination = this.destination;
            destination.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}((0, _outerSubscriber.OuterSubscriber));
var SubscriptionDelayObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}((0, _observable.Observable));
var SubscriptionDelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.unsubscribe();
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../Observable":"9oc0x","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bYYn":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dematerialize", ()=>dematerialize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
var DeMaterializeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWe8h":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinct", ()=>distinct);
parcelHelpers.export(exports, "DistinctSubscriber", ()=>DistinctSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new DistinctOperator(keySelector, flushes));
    };
}
var DistinctOperator = /*@__PURE__*/ function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
var DistinctSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) _this.add((0, _innerSubscribe.innerSubscribe)(flushes, new (0, _innerSubscribe.SimpleInnerSubscriber)(_this)));
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function() {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98B5v":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilChanged", ()=>distinctUntilChanged);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
    };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
var DistinctUntilChangedSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === "function") _this.compare = compare;
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        } catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) try {
            var compare = this.compare;
            result = compare(this.key, key);
        } catch (err) {
            return this.destination.error(err);
        }
        else this.hasKey = true;
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hd3Vz":[function(require,module,exports) {
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>distinctUntilKeyChanged);
var _distinctUntilChanged = require("./distinctUntilChanged");
function distinctUntilKeyChanged(key, compare) {
    return (0, _distinctUntilChanged.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

},{"./distinctUntilChanged":"98B5v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92xaa":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAt", ()=>elementAt);
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _filter = require("./filter");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _take = require("./take");
function elementAt(index, defaultValue) {
    if (index < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe((0, _filter.filter)(function(v, i) {
            return i === index;
        }), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
        }));
    };
}

},{"../util/ArgumentOutOfRangeError":"38Gbx","./filter":"1uwXV","./throwIfEmpty":"3A9HT","./defaultIfEmpty":"1eMdN","./take":"jMzpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3A9HT":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwIfEmpty", ()=>throwIfEmpty);
var _tslib = require("tslib");
var _emptyError = require("../util/EmptyError");
var _subscriber = require("../Subscriber");
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = defaultErrorFactory;
    return function(source) {
        return source.lift(new ThrowIfEmptyOperator(errorFactory));
    };
}
var ThrowIfEmptyOperator = /*@__PURE__*/ function() {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}();
var ThrowIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function(value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function() {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            } catch (e) {
                err = e;
            }
            this.destination.error(err);
        } else return this.destination.complete();
    };
    return ThrowIfEmptySubscriber;
}((0, _subscriber.Subscriber));
function defaultErrorFactory() {
    return new (0, _emptyError.EmptyError)();
}

},{"tslib":"gBS4y","../util/EmptyError":"7a4tA","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMzpW":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function take(count) {
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeOperator(count));
    };
}
var TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var TakeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../util/ArgumentOutOfRangeError":"38Gbx","../observable/empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4VxEc":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endWith", ()=>endWith);
var _concat = require("../observable/concat");
var _of = require("../observable/of");
function endWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    return function(source) {
        return (0, _concat.concat)(source, (0, _of.of).apply(void 0, array));
    };
}

},{"../observable/concat":"2cXL0","../observable/of":"alTvf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXibX":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "every", ()=>every);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function every(predicate, thisArg) {
    return function(source) {
        return source.lift(new EveryOperator(predicate, thisArg, source));
    };
}
var EveryOperator = /*@__PURE__*/ function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
var EverySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Ehtr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaust", ()=>exhaust);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function exhaust() {
    return function(source) {
        return source.lift(new SwitchFirstOperator());
    };
}
var SwitchFirstOperator = /*@__PURE__*/ function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
var SwitchFirstSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add((0, _innerSubscribe.innerSubscribe)(value, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Xdls":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustMap", ()=>exhaustMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function exhaustMap(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe(exhaustMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new ExhaustMapOperator(project));
    };
}
var ExhaustMapOperator = /*@__PURE__*/ function() {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}();
var ExhaustMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    ExhaustMapSubscriber.prototype.tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result);
    };
    ExhaustMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    ExhaustMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return ExhaustMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","./map":"cvzfg","../observable/from":"6aqs0","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3i3MM":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expand", ()=>expand);
parcelHelpers.export(exports, "ExpandOperator", ()=>ExpandOperator);
parcelHelpers.export(exports, "ExpandSubscriber", ()=>ExpandSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new ExpandOperator(project, concurrent, scheduler));
    };
}
var ExpandOperator = /*@__PURE__*/ function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
var ExpandSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) _this.buffer = [];
        return _this;
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            try {
                var project = this.project;
                var result = project(value, index);
                if (!this.scheduler) this.subscribeToProjection(result, value, index);
                else {
                    var state = {
                        subscriber: this,
                        result: result,
                        value: value,
                        index: index
                    };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            } catch (e) {
                destination.error(e);
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        var destination = this.destination;
        destination.add((0, _innerSubscribe.innerSubscribe)(result, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
        this.unsubscribe();
    };
    ExpandSubscriber.prototype.notifyNext = function(innerValue) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"757w3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "finalize", ()=>finalize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
function finalize(callback) {
    return function(source) {
        return source.lift(new FinallyOperator(callback));
    };
}
var FinallyOperator = /*@__PURE__*/ function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
var FinallySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new (0, _subscription.Subscription)(callback));
        return _this;
    }
    return FinallySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WaV6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "FindValueOperator", ()=>FindValueOperator);
parcelHelpers.export(exports, "FindValueSubscriber", ()=>FindValueSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function find(predicate, thisArg) {
    if (typeof predicate !== "function") throw new TypeError("predicate is not a function");
    return function(source) {
        return source.lift(new FindValueOperator(predicate, source, false, thisArg));
    };
}
var FindValueOperator = /*@__PURE__*/ function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
var FindValueSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qcAF":[function(require,module,exports) {
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
var _find = require("../operators/find");
function findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new (0, _find.FindValueOperator)(predicate, source, true, thisArg));
    };
}

},{"../operators/find":"7WaV6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eGELz":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "first", ()=>first);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _take = require("./take");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _throwIfEmpty = require("./throwIfEmpty");
var _identity = require("../util/identity");
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"7a4tA","./filter":"1uwXV","./take":"jMzpW","./defaultIfEmpty":"1eMdN","./throwIfEmpty":"3A9HT","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckr01":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", ()=>ignoreElements);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
var IgnoreElementsSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {};
    return IgnoreElementsSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6CBY":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function isEmpty() {
    return function(source) {
        return source.lift(new IsEmptyOperator());
    };
}
var IsEmptyOperator = /*@__PURE__*/ function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
var IsEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2oVKC":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "last", ()=>last);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _takeLast = require("./takeLast");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _identity = require("../util/identity");
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _takeLast.takeLast)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"7a4tA","./filter":"1uwXV","./takeLast":"21udE","./throwIfEmpty":"3A9HT","./defaultIfEmpty":"1eMdN","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21udE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeLast", ()=>takeLast);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeLastOperator(count));
    };
}
var TakeLastOperator = /*@__PURE__*/ function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
var TakeLastSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../util/ArgumentOutOfRangeError":"38Gbx","../observable/empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39msm":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", ()=>mapTo);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function mapTo(value) {
    return function(source) {
        return source.lift(new MapToOperator(value));
    };
}
var MapToOperator = /*@__PURE__*/ function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
var MapToSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aXm7q":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "materialize", ()=>materialize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
var MaterializeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next((0, _notification.Notification).createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next((0, _notification.Notification).createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next((0, _notification.Notification).createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../Notification":"3c26n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VIwB":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
var _reduce = require("./reduce");
function max(comparer) {
    var max = typeof comparer === "function" ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return (0, _reduce.reduce)(max);
}

},{"./reduce":"8LzQg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LzQg":[function(require,module,exports) {
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _scan = require("./scan");
var _takeLast = require("./takeLast");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _pipe = require("../util/pipe");
function reduce(accumulator, seed) {
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return (0, _pipe.pipe)((0, _scan.scan)(accumulator, seed), (0, _takeLast.takeLast)(1), (0, _defaultIfEmpty.defaultIfEmpty)(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return (0, _pipe.pipe)((0, _scan.scan)(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), (0, _takeLast.takeLast)(1))(source);
    };
}

},{"./scan":"hX6nA","./takeLast":"21udE","./defaultIfEmpty":"1eMdN","../util/pipe":"4asJs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hX6nA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scan", ()=>scan);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
var ScanSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9GXnX":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _merge = require("../observable/merge");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function(source) {
        return source.lift.call((0, _merge.merge).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/merge":"38GKY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lm8sA":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMapTo", ()=>mergeMapTo);
var _mergeMap = require("./mergeMap");
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, concurrent);
}

},{"./mergeMap":"7NAZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8odnE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeScan", ()=>mergeScan);
parcelHelpers.export(exports, "MergeScanOperator", ()=>MergeScanOperator);
parcelHelpers.export(exports, "MergeScanSubscriber", ()=>MergeScanSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new MergeScanOperator(accumulator, seed, concurrent));
    };
}
var MergeScanOperator = /*@__PURE__*/ function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
var MergeScanSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var destination = this.destination;
            var ish = void 0;
            try {
                var accumulator = this.accumulator;
                ish = accumulator(this.acc, value, index);
            } catch (e) {
                return destination.error(e);
            }
            this.active++;
            this._innerSub(ish);
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeScanSubscriber.prototype.notifyNext = function(innerValue) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eIMaq":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "min", ()=>min);
var _reduce = require("./reduce");
function min(comparer) {
    var min = typeof comparer === "function" ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return (0, _reduce.reduce)(min);
}

},{"./reduce":"8LzQg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GLY7l":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multicast", ()=>multicast);
parcelHelpers.export(exports, "MulticastOperator", ()=>MulticastOperator);
var _connectableObservable = require("../observable/ConnectableObservable");
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === "function") subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === "function") return source.lift(new MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, (0, _connectableObservable.connectableObservableDescriptor));
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();

},{"../observable/ConnectableObservable":"f4mOY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1lwYl":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
parcelHelpers.export(exports, "onErrorResumeNextStatic", ()=>onErrorResumeNextStatic);
var _tslib = require("tslib");
var _from = require("../observable/from");
var _isArray = require("../util/isArray");
var _innerSubscribe = require("../innerSubscribe");
function onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i] = arguments[_i];
    if (nextSources.length === 1 && (0, _isArray.isArray)(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new OnErrorResumeNextOperator(nextSources));
    };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i] = arguments[_i];
    var source = undefined;
    if (nextSources.length === 1 && (0, _isArray.isArray)(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return (0, _from.from)(source).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var OnErrorResumeNextSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (!!next) {
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(next, innerSubscriber);
            if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
        } else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../observable/from":"6aqs0","../util/isArray":"2HaTi","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hAUti":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairwise", ()=>pairwise);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function pairwise() {
    return function(source) {
        return source.lift(new PairwiseOperator());
    };
}
var PairwiseOperator = /*@__PURE__*/ function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
var PairwiseSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        var pair;
        if (this.hasPrev) pair = [
            this.prev,
            value
        ];
        else this.hasPrev = true;
        this.prev = value;
        if (pair) this.destination.next(pair);
    };
    return PairwiseSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51UVV":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _filter = require("./filter");
function partition(predicate, thisArg) {
    return function(source) {
        return [
            (0, _filter.filter)(predicate, thisArg)(source),
            (0, _filter.filter)((0, _not.not)(predicate, thisArg))(source)
        ];
    };
}

},{"../util/not":"6oUZX","./filter":"1uwXV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"enRwh":[function(require,module,exports) {
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pluck", ()=>pluck);
var _map = require("./map");
function pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error("list of properties cannot be empty.");
    return function(source) {
        return (0, _map.map)(plucker(properties, length))(source);
    };
}
function plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp != null ? currentProp[props[i]] : undefined;
            if (p !== void 0) currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

},{"./map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eqLc5":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publish", ()=>publish);
var _subject = require("../Subject");
var _multicast = require("./multicast");
function publish(selector) {
    return selector ? (0, _multicast.multicast)(function() {
        return new (0, _subject.Subject)();
    }, selector) : (0, _multicast.multicast)(new (0, _subject.Subject)());
}

},{"../Subject":"84bef","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aC28n":[function(require,module,exports) {
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishBehavior", ()=>publishBehavior);
var _behaviorSubject = require("../BehaviorSubject");
var _multicast = require("./multicast");
function publishBehavior(value) {
    return function(source) {
        return (0, _multicast.multicast)(new (0, _behaviorSubject.BehaviorSubject)(value))(source);
    };
}

},{"../BehaviorSubject":"anOW9","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqjv1":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishLast", ()=>publishLast);
var _asyncSubject = require("../AsyncSubject");
var _multicast = require("./multicast");
function publishLast() {
    return function(source) {
        return (0, _multicast.multicast)(new (0, _asyncSubject.AsyncSubject)())(source);
    };
}

},{"../AsyncSubject":"6P7LP","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pe5R":[function(require,module,exports) {
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishReplay", ()=>publishReplay);
var _replaySubject = require("../ReplaySubject");
var _multicast = require("./multicast");
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== "function") scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === "function" ? selectorOrScheduler : undefined;
    var subject = new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
    return function(source) {
        return (0, _multicast.multicast)(function() {
            return subject;
        }, selector)(source);
    };
}

},{"../ReplaySubject":"gRMu9","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Gd59":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
var _isArray = require("../util/isArray");
var _race = require("../observable/race");
function race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0];
        return source.lift.call((0, _race.race).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../util/isArray":"2HaTi","../observable/race":"6YL9k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VXQV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>repeat);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _empty = require("../observable/empty");
function repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else if (count < 0) return source.lift(new RepeatOperator(-1, source));
        else return source.lift(new RepeatOperator(count - 1, source));
    };
}
var RepeatOperator = /*@__PURE__*/ function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
var RepeatSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../observable/empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wa5h":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeatWhen", ()=>repeatWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function repeatWhen(notifier) {
    return function(source) {
        return source.lift(new RepeatWhenOperator(notifier));
    };
}
var RepeatWhenOperator = /*@__PURE__*/ function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
var RepeatWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function() {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function() {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next(undefined);
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new (0, _subject.Subject)();
        var retries;
        try {
            var notifier = this.notifier;
            retries = notifier(this.notifications);
        } catch (e) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = (0, _innerSubscribe.innerSubscribe)(retries, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
    };
    return RepeatWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../Subject":"84bef","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jiZ39":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retry", ()=>retry);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new RetryOperator(count, source));
    };
}
var RetryOperator = /*@__PURE__*/ function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
var RetrySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4F6hS":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryWhen", ()=>retryWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function retryWhen(notifier) {
    return function(source) {
        return source.lift(new RetryWhenOperator(notifier, source));
    };
}
var RetryWhenOperator = /*@__PURE__*/ function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
var RetryWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new (0, _subject.Subject)();
                try {
                    var notifier = this.notifier;
                    retries = notifier(errors);
                } catch (e) {
                    return _super.prototype.error.call(this, e);
                }
                retriesSubscription = (0, _innerSubscribe.innerSubscribe)(retries, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
            } else {
                this.errors = undefined;
                this.retriesSubscription = undefined;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RetryWhenSubscriber.prototype.notifyNext = function() {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../Subject":"84bef","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awQoL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sample", ()=>sample);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function sample(notifier) {
    return function(source) {
        return source.lift(new SampleOperator(notifier));
    };
}
var SampleOperator = /*@__PURE__*/ function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add((0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(sampleSubscriber)));
        return subscription;
    };
    return SampleOperator;
}();
var SampleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"10Tw1":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleTime", ()=>sampleTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
function sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return source.lift(new SampleTimeOperator(period, scheduler));
    };
}
var SampleTimeOperator = /*@__PURE__*/ function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
var SampleTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, {
            subscriber: _this,
            period: period
        }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../scheduler/async":"l1cmn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"81se8":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sequenceEqual", ()=>sequenceEqual);
parcelHelpers.export(exports, "SequenceEqualOperator", ()=>SequenceEqualOperator);
parcelHelpers.export(exports, "SequenceEqualSubscriber", ()=>SequenceEqualSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function sequenceEqual(compareTo, comparator) {
    return function(source) {
        return source.lift(new SequenceEqualOperator(compareTo, comparator));
    };
}
var SequenceEqualOperator = /*@__PURE__*/ function() {
    function SequenceEqualOperator(compareTo, comparator) {
        this.compareTo = compareTo;
        this.comparator = comparator;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
    };
    return SequenceEqualOperator;
}();
var SequenceEqualSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparator) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparator = comparator;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
        this.unsubscribe();
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            try {
                areEqual = comparator ? comparator(a, b) : a === b;
            } catch (e) {
                this.destination.error(e);
            }
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype.completeB = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    return SequenceEqualSubscriber;
}((0, _subscriber.Subscriber));
var SequenceEqualCompareToSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
        this.unsubscribe();
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent.completeB();
        this.unsubscribe();
    };
    return SequenceEqualCompareToSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"diIIU":[function(require,module,exports) {
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", ()=>share);
var _multicast = require("./multicast");
var _refCount = require("./refCount");
var _subject = require("../Subject");
function shareSubjectFactory() {
    return new (0, _subject.Subject)();
}
function share() {
    return function(source) {
        return (0, _refCount.refCount)()((0, _multicast.multicast)(shareSubjectFactory)(source));
    };
}

},{"./multicast":"GLY7l","./refCount":"ihxKV","../Subject":"84bef","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ysaZ":[function(require,module,exports) {
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shareReplay", ()=>shareReplay);
var _replaySubject = require("../ReplaySubject");
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var config;
    if (configOrBufferSize && typeof configOrBufferSize === "object") config = configOrBufferSize;
    else config = {
        bufferSize: configOrBufferSize,
        windowTime: windowTime,
        refCount: false,
        scheduler: scheduler
    };
    return function(source) {
        return source.lift(shareReplayOperator(config));
    };
}
function shareReplayOperator(_a) {
    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        var innerSub;
        if (!subject || hasError) {
            hasError = false;
            subject = new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
            innerSub = subject.subscribe(this);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subscription = undefined;
                    subject.complete();
                }
            });
            if (isComplete) subscription = undefined;
        } else innerSub = subject.subscribe(this);
        this.add(function() {
            refCount--;
            innerSub.unsubscribe();
            innerSub = undefined;
            if (subscription && !isComplete && useRefCount && refCount === 0) {
                subscription.unsubscribe();
                subscription = undefined;
                subject = undefined;
            }
        });
    };
}

},{"../ReplaySubject":"gRMu9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kbFw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "single", ()=>single);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _emptyError = require("../util/EmptyError");
function single(predicate) {
    return function(source) {
        return source.lift(new SingleOperator(predicate, source));
    };
}
var SingleOperator = /*@__PURE__*/ function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
var SingleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error("Sequence contains more than one element");
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new (0, _emptyError.EmptyError));
    };
    return SingleSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../util/EmptyError":"7a4tA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Y7P6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skip", ()=>skip);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function skip(count) {
    return function(source) {
        return source.lift(new SkipOperator(count));
    };
}
var SkipOperator = /*@__PURE__*/ function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
var SkipSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dehzH":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipLast", ()=>skipLast);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
function skipLast(count) {
    return function(source) {
        return source.lift(new SkipLastOperator(count));
    };
}
var SkipLastOperator = /*@__PURE__*/ function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) return source.subscribe(new (0, _subscriber.Subscriber)(subscriber));
        else return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
var SkipLastSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../util/ArgumentOutOfRangeError":"38Gbx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Gc8j":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipUntil", ()=>skipUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function skipUntil(notifier) {
    return function(source) {
        return source.lift(new SkipUntilOperator(notifier));
    };
}
var SkipUntilOperator = /*@__PURE__*/ function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}();
var SkipUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(_this);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(notifier, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype.notifyNext = function() {
        this.hasValue = true;
        if (this.innerSubscription) this.innerSubscription.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {};
    return SkipUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brJq3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipWhile", ()=>skipWhile);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function skipWhile(predicate) {
    return function(source) {
        return source.lift(new SkipWhileOperator(predicate));
    };
}
var SkipWhileOperator = /*@__PURE__*/ function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
var SkipWhileSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBObJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWith", ()=>startWith);
var _concat = require("../observable/concat");
var _isScheduler = require("../util/isScheduler");
function startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    var scheduler = array[array.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        array.pop();
        return function(source) {
            return (0, _concat.concat)(array, source, scheduler);
        };
    } else return function(source) {
        return (0, _concat.concat)(array, source);
    };
}

},{"../observable/concat":"2cXL0","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33YTz":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _subscribeOnObservable = require("../observable/SubscribeOnObservable");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, _subscribeOnObservable.SubscribeOnObservable)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

},{"../observable/SubscribeOnObservable":"1XZn2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1XZn2":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscribeOnObservable", ()=>SubscribeOnObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _asap = require("../scheduler/asap");
var _isNumeric = require("../util/isNumeric");
var SubscribeOnObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, _isNumeric.isNumeric)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, _asap.asap);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, _observable.Observable));

},{"tslib":"gBS4y","../Observable":"9oc0x","../scheduler/asap":"5Pp9f","../util/isNumeric":"i95aV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcfvT":[function(require,module,exports) {
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchAll", ()=>switchAll);
var _switchMap = require("./switchMap");
var _identity = require("../util/identity");
function switchAll() {
    return (0, _switchMap.switchMap)((0, _identity.identity));
}

},{"./switchMap":"5lH3R","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5lH3R":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","./map":"cvzfg","../observable/from":"6aqs0","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6eN6":[function(require,module,exports) {
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMapTo", ()=>switchMapTo);
var _switchMap = require("./switchMap");
function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? (0, _switchMap.switchMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _switchMap.switchMap)(function() {
        return innerObservable;
    });
}

},{"./switchMap":"5lH3R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NfQ5":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeUntil", ()=>takeUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function takeUntil(notifier) {
    return function(source) {
        return source.lift(new TakeUntilOperator(notifier));
    };
}
var TakeUntilOperator = /*@__PURE__*/ function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = (0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(takeUntilSubscriber));
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}();
var TakeUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function() {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {};
    return TakeUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcbUw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeWhile", ()=>takeWhile);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return function(source) {
        return source.lift(new TakeWhileOperator(predicate, inclusive));
    };
}
var TakeWhileOperator = /*@__PURE__*/ function() {
    function TakeWhileOperator(predicate, inclusive) {
        this.predicate = predicate;
        this.inclusive = inclusive;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
    };
    return TakeWhileOperator;
}();
var TakeWhileSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate, inclusive) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.inclusive = inclusive;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else {
            if (this.inclusive) destination.next(value);
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LiLi":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tap", ()=>tap);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _noop = require("../util/noop");
var _isFunction = require("../util/isFunction");
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
var TapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = (0, _noop.noop);
        _this._tapError = (0, _noop.noop);
        _this._tapComplete = (0, _noop.noop);
        _this._tapError = error || (0, _noop.noop);
        _this._tapComplete = complete || (0, _noop.noop);
        if ((0, _isFunction.isFunction)(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        } else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || (0, _noop.noop);
            _this._tapError = observerOrNext.error || (0, _noop.noop);
            _this._tapComplete = observerOrNext.complete || (0, _noop.noop);
        }
        return _this;
    }
    TapSubscriber.prototype._next = function(value) {
        try {
            this._tapNext.call(this._context, value);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function(err) {
        try {
            this._tapError.call(this._context, err);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function() {
        try {
            this._tapComplete.call(this._context);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../util/noop":"4s4qZ","../util/isFunction":"atYNr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jinO2":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrottleConfig", ()=>defaultThrottleConfig);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) config = defaultThrottleConfig;
    return function(source) {
        return source.lift(new ThrottleOperator(durationSelector, !!config.leading, !!config.trailing));
    };
}
var ThrottleOperator = /*@__PURE__*/ function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
var ThrottleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) this.send();
            else this.throttle(value);
        }
    };
    ThrottleSubscriber.prototype.send = function() {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = undefined;
    };
    ThrottleSubscriber.prototype.throttle = function(value) {
        var duration = this.tryDurationSelector(value);
        if (!!duration) this.add(this._throttled = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function() {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) _throttled.unsubscribe();
        this._throttled = undefined;
        if (_trailing) this.send();
    };
    ThrottleSubscriber.prototype.notifyNext = function() {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lj6f":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttleTime", ()=>throttleTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
var _throttle = require("./throttle");
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    if (config === void 0) config = (0, _throttle.defaultThrottleConfig);
    return function(source) {
        return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
var ThrottleTimeOperator = /*@__PURE__*/ function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
var ThrottleTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
            else if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function() {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        } else this.destination.complete();
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../scheduler/async":"l1cmn","./throttle":"jinO2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7omle":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "TimeInterval", ()=>TimeInterval);
var _async = require("../scheduler/async");
var _scan = require("./scan");
var _defer = require("../observable/defer");
var _map = require("./map");
function timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return (0, _defer.defer)(function() {
            return source.pipe((0, _scan.scan)(function(_a, value) {
                var current = _a.current;
                return {
                    value: value,
                    current: scheduler.now(),
                    last: current
                };
            }, {
                current: scheduler.now(),
                value: undefined,
                last: undefined
            }), (0, _map.map)(function(_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();

},{"../scheduler/async":"l1cmn","./scan":"hX6nA","../observable/defer":"1uvAg","./map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TIfU":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeout", ()=>timeout);
var _async = require("../scheduler/async");
var _timeoutError = require("../util/TimeoutError");
var _timeoutWith = require("./timeoutWith");
var _throwError = require("../observable/throwError");
function timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _timeoutWith.timeoutWith)(due, (0, _throwError.throwError)(new (0, _timeoutError.TimeoutError)()), scheduler);
}

},{"../scheduler/async":"l1cmn","../util/TimeoutError":"iA33G","./timeoutWith":"d8OMJ","../observable/throwError":"4BUNm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8OMJ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutWith", ()=>timeoutWith);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _innerSubscribe = require("../innerSubscribe");
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        var absoluteTimeout = (0, _isDate.isDate)(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
var TimeoutWithSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add((0, _innerSubscribe.innerSubscribe)(withObservable, new (0, _innerSubscribe.SimpleInnerSubscriber)(subscriber)));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = undefined;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../scheduler/async":"l1cmn","../util/isDate":"g98jK","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuNU1":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timestamp", ()=>timestamp);
parcelHelpers.export(exports, "Timestamp", ()=>Timestamp);
var _async = require("../scheduler/async");
var _map = require("./map");
function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _map.map)(function(value) {
        return new Timestamp(value, scheduler.now());
    });
}
var Timestamp = /*@__PURE__*/ function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();

},{"../scheduler/async":"l1cmn","./map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ajufK":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
var _reduce = require("./reduce");
function toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function toArray() {
    return (0, _reduce.reduce)(toArrayReducer, []);
}

},{"./reduce":"8LzQg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kAG83":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "window", ()=>window);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
var WindowOperator = /*@__PURE__*/ function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add((0, _innerSubscribe.innerSubscribe)(this.windowBoundaries, new (0, _innerSubscribe.SimpleInnerSubscriber)(windowSubscriber)));
        return sourceSubscription;
    };
    return WindowOperator;
}();
var WindowSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new (0, _subject.Subject)();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function() {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function() {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new (0, _subject.Subject)();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"gBS4y","../Subject":"84bef","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c5rVO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowCount", ()=>windowCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subject = require("../Subject");
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
var WindowCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [
            new (0, _subject.Subject)()
        ];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new (0, _subject.Subject)();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"gBS4y","../Subscriber":"jGx8F","../Subject":"84bef","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1eYrc":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowTime", ()=>windowTime);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _async = require("../scheduler/async");
var _subscriber = require("../Subscriber");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function windowTime(windowTimeSpan) {
    var scheduler = (0, _async.async);
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ((0, _isScheduler.isScheduler)(arguments[3])) scheduler = arguments[3];
    if ((0, _isScheduler.isScheduler)(arguments[2])) scheduler = arguments[2];
    else if ((0, _isNumeric.isNumeric)(arguments[2])) maxWindowSize = Number(arguments[2]);
    if ((0, _isScheduler.isScheduler)(arguments[1])) scheduler = arguments[1];
    else if ((0, _isNumeric.isNumeric)(arguments[1])) windowCreationInterval = Number(arguments[1]);
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var CountedSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}((0, _subject.Subject));
var WindowTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: _this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: _this,
                scheduler: scheduler
            };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: _this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

},{"tslib":"gBS4y","../Subject":"84bef","../scheduler/async":"l1cmn","../Subscriber":"jGx8F","../util/isNumeric":"i95aV","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNHIA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowToggle", ()=>windowToggle);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _subscription = require("../Subscription");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new WindowToggleOperator(openings, closingSelector));
    };
}
var WindowToggleOperator = /*@__PURE__*/ function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
var WindowToggleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = (0, _subscribeToResult.subscribeToResult)(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingNotifier = void 0;
            try {
                var closingSelector = this.closingSelector;
                closingNotifier = closingSelector(innerValue);
            } catch (e) {
                return this.error(e);
            }
            var window_1 = new (0, _subject.Subject)();
            var subscription = new (0, _subscription.Subscription)();
            var context_4 = {
                window: window_1,
                subscription: subscription
            };
            this.contexts.push(context_4);
            var innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier, context_4);
            if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
            else {
                innerSubscription.context = context_4;
                subscription.add(innerSubscription);
            }
            this.destination.next(window_1);
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"gBS4y","../Subject":"84bef","../Subscription":"ahthJ","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iz1YG":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowWhen", ()=>windowWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
var WindowOperator = /*@__PURE__*/ function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
var WindowSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function(_outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new (0, _subject.Subject)();
        this.destination.next(window);
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        } catch (e) {
            this.destination.error(e);
            this.window.error(e);
            return;
        }
        this.add(this.closingNotification = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier));
    };
    return WindowSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"gBS4y","../Subject":"84bef","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqcM0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withLatestFrom", ()=>withLatestFrom);
var _tslib = require("tslib");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === "function") project = args.pop();
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
var WithLatestFromSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for(var i = 0; i < len; i++)_this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            _this.add((0, _subscribeToResult.subscribeToResult)(_this, observable, undefined, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {};
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"gBS4y","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfA7f":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _zip = require("../observable/zip");
function zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call((0, _zip.zip).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/zip":"57TWv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bLGR":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipAll", ()=>zipAll);
var _zip = require("../observable/zip");
function zipAll(project) {
    return function(source) {
        return source.lift(new (0, _zip.ZipOperator)(project));
    };
}

},{"../observable/zip":"57TWv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kt8R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralModel = require("./coral-model");
parcelHelpers.exportAll(_coralModel, exports);
var _modelRegistry = require("./model-registry");
parcelHelpers.exportAll(_modelRegistry, exports);

},{"./coral-model":"cjw45","./model-registry":"cLFbt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cjw45":[function(require,module,exports) {
/**
 * Base implementation of a Coral model class.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralModel", ()=>CoralModel);
class CoralModel {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLFbt":[function(require,module,exports) {
/**
 * Registry of CoralModelConstructor instances that can be used by serialization utilities to identify an abstract type.
 *
 * CoralModelConstructor instances are de-duped by their `fullyQualifiedTypeName` value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modelRegistrySingleton", ()=>modelRegistrySingleton);
class ModelRegistry {
    constructor(){
        this.lookupByFullyQualifiedTypeName = new Map();
    }
    /**
     * Add the type to the registry, if it doesn't already exist.
     *
     * @param ctor CoralModelConstructor
     */ registerType(ctor) {
        const __type = ctor.fullyQualifiedTypeName;
        if (!this.lookupByFullyQualifiedTypeName.has(__type)) this.lookupByFullyQualifiedTypeName.set(__type, ctor);
    }
    /**
     *
     * @param __type string
     * @return the constructor previously registered with the given type name, or undefined if it wasn't previously registered
     */ getConstructorByTypeName(__type) {
        return this.lookupByFullyQualifiedTypeName.get(__type);
    }
}
const modelRegistrySingleton = new ModelRegistry();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckJ25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Implementation of the "Decorrelated Jitter" strategy described here:
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter
 */ parcelHelpers.export(exports, "CoralRetryInterceptor", ()=>CoralRetryInterceptor);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
class CoralRetryInterceptor {
    /**
     * @param options
     * @param options.doNotRetryHttpStatuses
     * @param options.maxDelay 0 default delay, any negative values will be set to 0
     * @param options.maxRetries Defaults to 3
     * @param options.seedDelay 0 default delay, any negative values will be set to 0
     */ constructor(options = {}){
        this.options = Object.assign({
            doNotRetryHttpStatuses: [],
            maxDelay: 0,
            maxRetries: 3,
            seedDelay: 0
        }, options);
        this.options.maxDelay = Math.max(0, this.options.maxDelay);
        this.options.seedDelay = Math.max(0, this.options.seedDelay);
    }
    intercept(request, next) {
        let delay = this.options.seedDelay;
        return next.handle(request).pipe((0, _operators.retryWhen)((errors)=>{
            return errors.pipe((0, _operators.mergeMap)((error, i)=>{
                const currentAttempt = i + 1;
                if (currentAttempt >= this.options.maxRetries || error && error.status && this.options.doNotRetryHttpStatuses.includes(error.status)) return (0, _rxjs.throwError)(error);
                delay = Math.min(this.options.maxDelay, Math.max(this.options.seedDelay, delay * 3 * Math.random()));
                return (0, _rxjs.timer)(delay);
            }));
        }));
    }
}

},{"rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bc2Vw":[function(require,module,exports) {
/**
 * Generic interceptor allowing the instantiator to "tap" into the interceptor
 * chain in order to perform some non-mutating operation on the request and
 * response.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TapRequestInterceptor", ()=>TapRequestInterceptor);
class TapRequestInterceptor {
    constructor(tap){
        this.tap = tap;
    }
    intercept(request, next) {
        const response = next.handle(request);
        this.tap(request, response);
        return response;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tnxww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Impose a client-side request timeout.
 *
 * The interceptor will use timeout values specified in the request config, if available.
 * In this case, the timeout value provided to the constructor is used as a fallback, if a matching
 * entry could not be determined.
 *
 * The expected format for timeouts in client configuration is:
 *
 * @example
 * {
 *   timeouts: {
 *     BeerService/GetAllBeers: 5000,
 *     BeerService/CreateBeer: 2500,
 *     BeerService/*: 1000 // wildcard
 *   }
 * }
 *
 * If used *before* CoralRetryInterceptor in the interceptor chain, this will
 * set a total timeout for the entire request (i.e. all retries combined). If
 * used after CoralRetryInterceptor it will timeout each individual attempt.
 *
 * @example
 * new InterceptingRequestHandler(
 *   new FetchRequestHandler(),
 *   [
 *     new CoralTimeoutInterceptor(10000), // timeout the entire request
 *     new CoralRetryInterceptor(),
 *     new CoralTimeoutInterceptor(1000), // timeout each retry attempt
 *   ]
 * )
 */ parcelHelpers.export(exports, "CoralTimeoutInterceptor", ()=>CoralTimeoutInterceptor);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../client");
class CoralTimeoutInterceptor {
    constructor(fallbackTimeoutMs){
        this.fallbackTimeoutMs = fallbackTimeoutMs;
    }
    intercept(request, next) {
        return next.handle(request).pipe((0, _operators.timeout)(this.getTimeoutMs(request)), (0, _operators.catchError)((error)=>{
            if (error.name === "TimeoutError") return (0, _rxjs.throwError)(new (0, _client.CoralResponse)({
                ok: false,
                status: 408,
                statusText: "Request Timeout"
            }));
            else return (0, _rxjs.throwError)(error);
        }));
    }
    getTimeoutMs(request) {
        const config = request.config;
        if (!config.timeouts || !config.timeouts.operationTimeouts) return this.fallbackTimeoutMs;
        // If timeout values are defined in the client config, match by operation name (preferred) or wildcard (*) entry (fallback).
        const operation = request.operation;
        const timeoutByOperation = Object.entries(config.timeouts.operationTimeouts).filter((entry)=>{
            // Key format: $serviceName/$operationName
            const operationNameWithTimeout = entry[0].split("/")[1];
            return operationNameWithTimeout === "*" || operationNameWithTimeout === operation;
        }).sort((first)=>{
            // Sort so that timeout values matched by operationName are in the front of the list whereas wildcard entries are in the back.
            return first[0].split("/")[1] === "*" ? 1 : -1;
        });
        // If there is a timeout value for the operation or a wildcard entry exists, the first value in the array should be selected.
        if (timeoutByOperation.length > 0) return timeoutByOperation[0][1];
        // If there is no match, return the fallback timeout value.
        return this.fallbackTimeoutMs;
    }
}

},{"rxjs":"gxhPq","rxjs/operators":"ggrIi","../client":"7JSEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3t4DJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sign requests using the aws4-hmac-sha256 HTTP signing scheme.
 */ parcelHelpers.export(exports, "Aws4HmacSha256Interceptor", ()=>Aws4HmacSha256Interceptor);
var _signatureV4Universal = require("@aws-sdk/signature-v4-universal");
var _urlParserUniversal = require("@aws-sdk/url-parser-universal");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _cached = require("../common/cached");
var _interceptor = require("./interceptor");
/** Convert headers from map to list. */ const toHeaderList = (headers)=>Object.entries(headers);
class Aws4HmacSha256Interceptor extends (0, _interceptor.CoralInterceptor) {
    constructor(credentialsProvider){
        super();
        this.credentials = (0, _rxjs.defer)(credentialsProvider).pipe((0, _cached.cached)((credentials)=>credentials.expiration === undefined ? new Date(8640000000000000) : new Date(credentials.expiration * 1000 - 60000)));
    }
    intercept(request, next) {
        const httpSigning = request.config.httpSigning;
        if (!httpSigning || httpSigning.scheme !== "aws4-hmac-sha256") return next.handle(request);
        return this.credentials.pipe((0, _operators.take)(1), (0, _operators.mergeMap)((credentials)=>{
            const signer = new (0, _signatureV4Universal.SignatureV4)({
                service: httpSigning.service,
                region: httpSigning.region,
                credentials
            });
            const endpoint = (0, _urlParserUniversal.parseUrl)(request.url);
            const body = typeof request.body === "string" ? request.body : JSON.stringify(request.body);
            return signer.sign(Object.assign(Object.assign({}, endpoint), {
                body,
                method: request.method,
                headers: request.getHeaderBag()
            }), {
                signingDate: request.signingDate
            });
        }), (0, _operators.mergeMap)((signedRequest)=>next.handle(request.clone({
                body: signedRequest.body,
                headers: toHeaderList(signedRequest.headers)
            }))));
    }
}

},{"@aws-sdk/signature-v4-universal":"7ppPU","@aws-sdk/url-parser-universal":"eVxk4","rxjs":"gxhPq","rxjs/operators":"ggrIi","../common/cached":"4tWF8","./interceptor":"1y3ek","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ppPU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("7d774b569f66d43d");
const sha256_browser_1 = require("128fc4a2a01ecfc0");
const signature_v4_1 = require("891e44f724bdb2b9");
class SignatureV4 extends signature_v4_1.SignatureV4 {
    constructor(_a){
        var { sha256 = sha256_browser_1.Sha256 } = _a, rest = tslib_1.__rest(_a, [
            "sha256"
        ]);
        super(Object.assign({
            sha256
        }, rest));
    }
}
exports.SignatureV4 = SignatureV4;

},{"7d774b569f66d43d":"gBS4y","128fc4a2a01ecfc0":"b9LZy","891e44f724bdb2b9":"bXv8T"}],"b9LZy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("62ec12493516a334");
tslib_1.__exportStar(require("e099a4a7ffb231f5"), exports);
var ie11Sha256_1 = require("de15e02776b0e316");
exports.Ie11Sha256 = ie11Sha256_1.Sha256;
var webCryptoSha256_1 = require("8c4446d1ab49a729");
exports.WebCryptoSha256 = webCryptoSha256_1.Sha256;

},{"62ec12493516a334":"gBS4y","e099a4a7ffb231f5":"79xLO","de15e02776b0e316":"ekPEs","8c4446d1ab49a729":"bPfVO"}],"79xLO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var ie11Sha256_1 = require("a7f146ad1f3cbfc1");
var webCryptoSha256_1 = require("725c2de9fef54f64");
var sha256_js_1 = require("acd71c1991c101d8");
var supports_web_crypto_1 = require("b78851f350642902");
var ie11_detection_1 = require("d3a26cad479a1048");
var util_locate_window_1 = require("cb5027cfddf0ae5a");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (supports_web_crypto_1.supportsWebCrypto(util_locate_window_1.locateWindow())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if (ie11_detection_1.isMsWindow(util_locate_window_1.locateWindow())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"a7f146ad1f3cbfc1":"ekPEs","725c2de9fef54f64":"bPfVO","acd71c1991c101d8":"9EWpH","b78851f350642902":"2YsHG","d3a26cad479a1048":"7wNQA","cb5027cfddf0ae5a":"b53pF"}],"ekPEs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var isEmptyData_1 = require("d8dc3989d6db06cb");
var constants_1 = require("d71db60dd455789b");
var util_utf8_browser_1 = require("b2a4d6e137ed6620");
var util_locate_window_1 = require("fb05deefe8f5231");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return util_locate_window_1.locateWindow().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve(util_locate_window_1.locateWindow().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if (isEmptyData_1.isEmptyData(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject("Error encountered finalizing hash");
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject("Error encountered finalizing hash");
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = util_locate_window_1.locateWindow().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject("ImportKey completed without importing key.");
        };
        keyOperation.onerror = function() {
            reject("ImportKey failed to import key.");
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return util_utf8_browser_1.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"d8dc3989d6db06cb":"OVDMf","d71db60dd455789b":"950l0","b2a4d6e137ed6620":"dx7ox","fb05deefe8f5231":"b53pF"}],"OVDMf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"950l0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"dx7ox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"4QumE","./whatwgEncodingApi":"gtMyQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4QumE":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gtMyQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b53pF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Locates the global scope for a browser or browser-like environment. If
 * neither `window` nor `self` is defined by the environment, the same object
 * will be returned on each invocation.
 */ parcelHelpers.export(exports, "locateWindow", ()=>locateWindow);
var fallbackWindow = {};
function locateWindow() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return fallbackWindow;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPfVO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var util_utf8_browser_1 = require("e5b434f4fba2fc15");
var isEmptyData_1 = require("9e0ca5327dca8c2d");
var constants_1 = require("a96b793b8f5ad16");
var util_locate_window_1 = require("3b3155587be8430d");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                util_locate_window_1.locateWindow().crypto.subtle.importKey("raw", convertToBuffer(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if (isEmptyData_1.isEmptyData(data)) return;
        var update = convertToBuffer(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return util_locate_window_1.locateWindow().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if (isEmptyData_1.isEmptyData(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return util_locate_window_1.locateWindow().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function convertToBuffer(data) {
    if (typeof data === "string") return util_utf8_browser_1.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"e5b434f4fba2fc15":"dx7ox","9e0ca5327dca8c2d":"OVDMf","a96b793b8f5ad16":"950l0","3b3155587be8430d":"b53pF"}],"9EWpH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("847e9f41fbd48d18");
tslib_1.__exportStar(require("952fa851a97011d6"), exports);

},{"847e9f41fbd48d18":"gBS4y","952fa851a97011d6":"ddBER"}],"ddBER":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("4cf08e042cbd4f6b");
var constants_1 = require("2f5507f5e1102429");
var RawSha256_1 = require("c4be19be66a5b026");
var util_utf8_browser_1 = require("467323582678cba7");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256;
        if (secret) {
            this.outer = new RawSha256_1.RawSha256;
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if (isEmptyData(toHash) || this.error) return;
        try {
            this.hash.update(convertToBuffer(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
            return tslib_1.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = convertToBuffer(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256;
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function convertToBuffer(data) {
    if (typeof data === "string") return util_utf8_browser_1.fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"4cf08e042cbd4f6b":"gBS4y","2f5507f5e1102429":"7goG0","c4be19be66a5b026":"8GToF","467323582678cba7":"dx7ox"}],"7goG0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"8GToF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var constants_1 = require("611362490e842507");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"611362490e842507":"7goG0"}],"2YsHG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("77b6e702e4b0428a");
tslib_1.__exportStar(require("150bdc65f19f6fe8"), exports);

},{"77b6e702e4b0428a":"gBS4y","150bdc65f19f6fe8":"gqJAk"}],"gqJAk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("d9d4edfd7f160da1");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"d9d4edfd7f160da1":"gBS4y"}],"7wNQA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("349d4ad1a84f9391");
tslib_1.__exportStar(require("14b671c7aac632d"), exports);

},{"349d4ad1a84f9391":"gBS4y","14b671c7aac632d":"9b5ZG"}],"9b5ZG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"bXv8T":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("2766ae8b79c5d97e");
tslib_1.__exportStar(require("1746854556466f6c"), exports);
tslib_1.__exportStar(require("78964467554d34b4"), exports);

},{"2766ae8b79c5d97e":"gBS4y","1746854556466f6c":"kfUlY","78964467554d34b4":"iH1on"}],"kfUlY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const constants_1 = require("d4bbf162015151aa");
const signingKeyCache = {};
const cacheQueue = [];
/**
 * Create a string describing the scope of credentials used to sign a request.
 *
 * @param shortDate The current calendar date in the form YYYYMMDD.
 * @param region    The AWS region in which the service resides.
 * @param service   The service to which the signed request is being sent.
 */ function createScope(shortDate, region, service) {
    return `${shortDate}/${region}/${service}/${constants_1.KEY_TYPE_IDENTIFIER}`;
}
exports.createScope = createScope;
/**
 * Derive a signing key from its composite parts
 *
 * @param sha256Constructor A constructor function that can instantiate SHA-256
 *                          hash objects.
 * @param credentials       The credentials with which the request will be
 *                          signed.
 * @param shortDate         The current calendar date in the form YYYYMMDD.
 * @param region            The AWS region in which the service resides.
 * @param service           The service to which the signed request is being
 *                          sent.
 */ function getSigningKey(sha256Constructor, credentials, shortDate, region, service) {
    const cacheKey = `${shortDate}:${region}:${service}:` + `${credentials.accessKeyId}:${credentials.sessionToken}`;
    if (cacheKey in signingKeyCache) return signingKeyCache[cacheKey];
    cacheQueue.push(cacheKey);
    while(cacheQueue.length > constants_1.MAX_CACHE_SIZE)delete signingKeyCache[cacheQueue.shift()];
    return signingKeyCache[cacheKey] = new Promise((resolve, reject)=>{
        let keyPromise = Promise.resolve(`AWS4${credentials.secretAccessKey}`);
        for (let signable of [
            shortDate,
            region,
            service,
            constants_1.KEY_TYPE_IDENTIFIER
        ]){
            keyPromise = keyPromise.then((intermediateKey)=>hmac(sha256Constructor, intermediateKey, signable));
            keyPromise.catch(()=>{});
        }
        keyPromise.then(resolve, (reason)=>{
            delete signingKeyCache[cacheKey];
            reject(reason);
        });
    });
}
exports.getSigningKey = getSigningKey;
/**
 * @internal
 */ function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach((cacheKey)=>{
        delete signingKeyCache[cacheKey];
    });
}
exports.clearCredentialCache = clearCredentialCache;
function hmac(ctor, secret, data) {
    const hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}

},{"d4bbf162015151aa":"l3wVA"}],"l3wVA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
exports.CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
exports.AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
exports.SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
exports.EXPIRES_QUERY_PARAM = "X-Amz-Expires";
exports.SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
exports.TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
exports.AUTH_HEADER = "authorization";
exports.AMZ_DATE_HEADER = exports.AMZ_DATE_QUERY_PARAM.toLowerCase();
exports.DATE_HEADER = "date";
exports.GENERATED_HEADERS = [
    exports.AUTH_HEADER,
    exports.AMZ_DATE_HEADER,
    exports.DATE_HEADER
];
exports.SIGNATURE_HEADER = exports.SIGNATURE_QUERY_PARAM.toLowerCase();
exports.SHA256_HEADER = "x-amz-content-sha256";
exports.TOKEN_HEADER = exports.TOKEN_QUERY_PARAM.toLowerCase();
exports.HOST_HEADER = "host";
exports.ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
exports.PROXY_HEADER_PATTERN = /^proxy-/;
exports.SEC_HEADER_PATTERN = /^sec-/;
exports.UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
exports.ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
exports.UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
exports.MAX_CACHE_SIZE = 50;
exports.KEY_TYPE_IDENTIFIER = "aws4_request";
exports.MAX_PRESIGNED_TTL = 604800;

},{}],"iH1on":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("4fdc13ab6b6474d2");
const credentialDerivation_1 = require("68fe308299a13823");
const getCanonicalHeaders_1 = require("5a0bb77d79c3f2c4");
const getCanonicalQuery_1 = require("22b38ef1d3bff57");
const getPayloadHash_1 = require("49e76a91c3acd9c0");
const prepareRequest_1 = require("3f51e83593357551");
const moveHeadersToQuery_1 = require("7d9541c823bdf8f2");
const constants_1 = require("6bd3303e77629aa5");
const protocol_timestamp_1 = require("1410dea30d14d733");
const util_hex_encoding_1 = require("da95af0ab8c8257");
const hasHeader_1 = require("657aa19dff7eecf1");
class SignatureV4 {
    constructor({ applyChecksum, credentials, region, service, sha256, uriEscapePath = true }){
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        if (typeof region === "string") {
            const promisified = Promise.resolve(region);
            this.regionProvider = ()=>promisified;
        } else this.regionProvider = region;
        if (typeof credentials === "object") {
            const promisified = Promise.resolve(credentials);
            this.credentialProvider = ()=>promisified;
        } else this.credentialProvider = credentials;
    }
    async presignRequest(originalRequest, expiration, options = {}) {
        const [region, credentials] = await Promise.all([
            this.regionProvider(),
            this.credentialProvider()
        ]);
        const { signingDate = new Date(), unsignableHeaders, signableHeaders } = options;
        const { longDate, shortDate } = formatDate(signingDate);
        const ttl = getTtl(signingDate, expiration);
        if (ttl > constants_1.MAX_PRESIGNED_TTL) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = credentialDerivation_1.createScope(shortDate, region, this.service);
        const request = moveHeadersToQuery_1.moveHeadersToQuery(prepareRequest_1.prepareRequest(originalRequest));
        if (credentials.sessionToken) request.query[constants_1.TOKEN_QUERY_PARAM] = credentials.sessionToken;
        request.query[constants_1.ALGORITHM_QUERY_PARAM] = constants_1.ALGORITHM_IDENTIFIER;
        request.query[constants_1.CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
        request.query[constants_1.AMZ_DATE_QUERY_PARAM] = longDate;
        request.query[constants_1.EXPIRES_QUERY_PARAM] = ttl.toString(10);
        const canonicalHeaders = getCanonicalHeaders_1.getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
        request.query[constants_1.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
        request.query[constants_1.SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate), this.createCanonicalRequest(request, canonicalHeaders, await getPayloadHash_1.getPayloadHash(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, _a = {}) {
        var { signingDate = new Date() } = _a, options = tslib_1.__rest(_a, [
            "signingDate"
        ]);
        const [region, credentials] = await Promise.all([
            this.regionProvider(),
            this.credentialProvider()
        ]);
        if (typeof toSign === "string") return this.signString(toSign, signingDate, region, credentials);
        else {
            const { unsignableHeaders, signableHeaders } = options;
            return this.signRequest(toSign, signingDate, region, credentials, unsignableHeaders, signableHeaders);
        }
    }
    async signString(stringToSign, signingDate, region, credentials) {
        const { shortDate } = formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate));
        hash.update(stringToSign);
        return util_hex_encoding_1.toHex(await hash.digest());
    }
    async signRequest(originalRequest, signingDate, region, credentials, unsignableHeaders, signableHeaders) {
        const request = prepareRequest_1.prepareRequest(originalRequest);
        const { longDate, shortDate } = formatDate(signingDate);
        const scope = credentialDerivation_1.createScope(shortDate, region, this.service);
        request.headers[constants_1.AMZ_DATE_HEADER] = longDate;
        if (credentials.sessionToken) request.headers[constants_1.TOKEN_HEADER] = credentials.sessionToken;
        const payloadHash = await getPayloadHash_1.getPayloadHash(request, this.sha256);
        if (!hasHeader_1.hasHeader(constants_1.SHA256_HEADER, request.headers) && this.applyChecksum) request.headers[constants_1.SHA256_HEADER] = payloadHash;
        const canonicalHeaders = getCanonicalHeaders_1.getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[constants_1.AUTH_HEADER] = `${constants_1.ALGORITHM_IDENTIFIER} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${getCanonicalQuery_1.getCanonicalQuery(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update(canonicalRequest);
        const hashedRequest = await hash.digest();
        return `${constants_1.ALGORITHM_IDENTIFIER}
${longDate}
${credentialScope}
${util_hex_encoding_1.toHex(hashedRequest)}`;
    }
    getCanonicalPath({ path }) {
        if (this.uriEscapePath) {
            const doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return `/${doubleEncoded.replace(/%2F/g, "/")}`;
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update(stringToSign);
        return util_hex_encoding_1.toHex(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate) {
        return credentialDerivation_1.getSigningKey(this.sha256, credentials, shortDate, region, this.service);
    }
}
exports.SignatureV4 = SignatureV4;
function formatDate(now) {
    const longDate = protocol_timestamp_1.iso8601(now).replace(/[\-:]/g, "");
    return {
        longDate,
        shortDate: longDate.substr(0, 8)
    };
}
function getCanonicalHeaderList(headers) {
    return Object.keys(headers).sort().join(";");
}
function getTtl(start, expiration) {
    return Math.floor((protocol_timestamp_1.toDate(expiration).valueOf() - protocol_timestamp_1.toDate(start).valueOf()) / 1000);
}

},{"4fdc13ab6b6474d2":"gBS4y","68fe308299a13823":"kfUlY","5a0bb77d79c3f2c4":"wmh3g","22b38ef1d3bff57":"hlwuz","49e76a91c3acd9c0":"eGdEN","3f51e83593357551":"kztT1","7d9541c823bdf8f2":"9E5O6","6bd3303e77629aa5":"l3wVA","1410dea30d14d733":"ct3z4","da95af0ab8c8257":"2k00g","657aa19dff7eecf1":"foN3B"}],"wmh3g":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const constants_1 = require("286d7a6617d2c70f");
/**
 * @internal
 */ function getCanonicalHeaders({ headers }, unsignableHeaders, signableHeaders) {
    const canonical = {};
    for (let headerName of Object.keys(headers).sort()){
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in constants_1.ALWAYS_UNSIGNABLE_HEADERS || unsignableHeaders && unsignableHeaders.has(canonicalHeaderName) || constants_1.PROXY_HEADER_PATTERN.test(canonicalHeaderName) || constants_1.SEC_HEADER_PATTERN.test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
}
exports.getCanonicalHeaders = getCanonicalHeaders;

},{"286d7a6617d2c70f":"l3wVA"}],"hlwuz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const constants_1 = require("5cb08cae974fd9cd");
/**
 * @internal
 */ function getCanonicalQuery({ query = {} }) {
    const keys = [];
    const serialized = {};
    for (let key of Object.keys(query).sort()){
        if (key.toLowerCase() === constants_1.SIGNATURE_HEADER) continue;
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") serialized[key] = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce((encoded, value)=>encoded.concat([
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            ]), []).join("&");
    }
    return keys.map((key)=>serialized[key]).filter((serialized)=>serialized) // omit any falsy values
    .join("&");
}
exports.getCanonicalQuery = getCanonicalQuery;

},{"5cb08cae974fd9cd":"l3wVA"}],"eGdEN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const constants_1 = require("5203826bd9783143");
const is_array_buffer_1 = require("8b9e5bfc31c92d19");
const util_hex_encoding_1 = require("c01ab8ac96c8094a");
/**
 * @internal
 */ async function getPayloadHash({ headers, body }, hashConstructor) {
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === constants_1.SHA256_HEADER) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || is_array_buffer_1.isArrayBuffer(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update(body);
        return util_hex_encoding_1.toHex(await hashCtor.digest());
    }
    // As any defined body that is not a string or binary data is a stream, this
    // body is unsignable. Attempt to send the request with an unsigned payload,
    // which may or may not be accepted by the service.
    return constants_1.UNSIGNED_PAYLOAD;
}
exports.getPayloadHash = getPayloadHash;

},{"5203826bd9783143":"l3wVA","8b9e5bfc31c92d19":"1VonN","c01ab8ac96c8094a":"2k00g"}],"1VonN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function isArrayBuffer(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
}
exports.isArrayBuffer = isArrayBuffer;

},{}],"2k00g":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0" + encodedByte;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
exports.fromHex = fromHex;
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}
exports.toHex = toHex;

},{}],"kztT1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const cloneRequest_1 = require("bd9307dbc9ac5880");
const constants_1 = require("4148d7be3548a3bf");
/**
 * @internal
 */ function prepareRequest(request) {
    // Create a clone of the request object that does not clone the body
    request = cloneRequest_1.cloneRequest(request);
    for (let headerName of Object.keys(request.headers))if (constants_1.GENERATED_HEADERS.indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    if (!(constants_1.HOST_HEADER in request.headers)) request.headers[constants_1.HOST_HEADER] = request.hostname;
    return request;
}
exports.prepareRequest = prepareRequest;

},{"bd9307dbc9ac5880":"iR3S6","4148d7be3548a3bf":"l3wVA"}],"iR3S6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("22c498b72b0956e2");
/**
 * @internal
 */ function cloneRequest(_a) {
    var { headers, query } = _a, rest = tslib_1.__rest(_a, [
        "headers",
        "query"
    ]);
    return Object.assign({}, rest, {
        headers: Object.assign({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
}
exports.cloneRequest = cloneRequest;
function cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return Object.assign({}, carry, {
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        });
    }, {});
}

},{"22c498b72b0956e2":"gBS4y"}],"9E5O6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const cloneRequest_1 = require("4c6600cf9c44a010");
/**
 * @internal
 */ function moveHeadersToQuery(request) {
    const { headers, query = {} } = cloneRequest_1.cloneRequest(request);
    for (let name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.substr(0, 6) === "x-amz-") {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return Object.assign({}, request, {
        headers,
        query
    });
}
exports.moveHeadersToQuery = moveHeadersToQuery;

},{"4c6600cf9c44a010":"iR3S6"}],"ct3z4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
exports.iso8601 = iso8601;
function rfc822(time) {
    return toDate(time).toUTCString();
}
exports.rfc822 = rfc822;
function epoch(time) {
    return Math.floor(toDate(time).valueOf() / 1000);
}
exports.epoch = epoch;
function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}
exports.toDate = toDate;
function formatTimestamp(time, format) {
    switch(format){
        case "iso8601":
            return iso8601(time);
        case "rfc822":
            return rfc822(time);
        case "unixTimestamp":
            return epoch(time);
        default:
            throw new Error("Invalid TimestampFormat: " + format);
    }
}
exports.formatTimestamp = formatTimestamp;

},{}],"foN3B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function hasHeader(soughtHeader, headers) {
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
}
exports.hasHeader = hasHeader;

},{}],"eVxk4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var querystring_parser_1 = require("57ab7b1d9cc0dbdf");
exports.parseUrl = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = querystring_parser_1.parseQueryString(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"57ab7b1d9cc0dbdf":"03lWP"}],"03lWP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("151121ec756a91da");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = tslib_1.__values(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = tslib_1.__read(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}
exports.parseQueryString = parseQueryString;

},{"151121ec756a91da":"gBS4y"}],"4tWF8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cached", ()=>cached);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const cached = (getExpires)=>(observable)=>{
        let cachedValue;
        let cachedExpires;
        // Need to share the observable to ensure that concurrent subscriptions to
        // expired content result in just one subscription to the source. The shared
        // observable completes after caching the new value value, ensuring that a
        // new source subscription will be created the next time the shared
        // observable is used (after the cache expires again).
        const shared = observable.pipe((0, _operators.take)(1), (0, _operators.tap)((value)=>{
            cachedValue = value;
            cachedExpires = getExpires(value);
        }), (0, _operators.share)());
        return new (0, _rxjs.Observable)((subscriber)=>{
            if (cachedExpires === undefined || (0, _rxjs.asyncScheduler).now() >= cachedExpires.getTime()) return shared.subscribe(subscriber);
            else {
                subscriber.next(cachedValue);
                subscriber.complete();
                return ()=>{};
            }
        });
    };

},{"rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dFBKs":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BeerList", ()=>BeerList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BeerList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBeerlist", ()=>validateBeerlist);
var _beerListDefinition = require("./beerListDefinition");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class BeerList extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BeerList#clone(obj: PlainObjectFrom<BeerList>) method.
     */ constructor(__beers){
        super();
        this.beers = __beers;
    }
    /**
     * Create a shallow clone of BeerList from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BeerList(obj.beers);
    }
    static fromJson(data) {
        return new BeerList((($$val)=>$$val == undefined ? undefined : (0, _beerListDefinition.beerListDefinition).fromJson($$val))(data.beers));
    }
    static toJson(data) {
        return Object.assign({
            beers: (($$val)=>$$val == undefined ? null : (0, _beerListDefinition.beerListDefinition).toJson($$val))(data.beers)
        });
    }
}
BeerList.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#BeerList";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BeerList);
function validateBeerlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./beerListDefinition":"gQq3q","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gQq3q":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "beerListDefinition", ()=>beerListDefinition);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [beerListDefinition] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBeerlistdefinition", ()=>validateBeerlistdefinition);
var _beer = require("./Beer");
class beerListDefinition extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(beerListDefinition.prototype));
    }
    static fromJson(data) {
        return new beerListDefinition(data.map((datum)=>(0, _beer.Beer).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _beer.Beer).toJson(datum));
    }
}
function validateBeerlistdefinition(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Beer":"7Z2vh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"42UE7":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "carrierLogisticsWebServerSerdesInterceptor", ()=>carrierLogisticsWebServerSerdesInterceptor);
parcelHelpers.export(exports, "carrierLogisticsWebServerHttpBindingInterceptor", ()=>carrierLogisticsWebServerHttpBindingInterceptor);
/**
 * <p>An example service, deployed with the Octane Service creator,
 * which will echo the string<\/p>
 **/ parcelHelpers.export(exports, "CarrierLogisticsWebServer", ()=>CarrierLogisticsWebServer);
var _coralComAmazonCoralAvailability = require("@amzn/coral_com-amazon-coral-availability");
var _coralComAmazonCoralServiceBsf = require("@amzn/coral_com-amazon-coral-service-bsf");
var _coralComAmazonCoralClient = require("@amzn/coral_com-amazon-coral-client");
var _coralComAmazonCoralService = require("@amzn/coral_com-amazon-coral-service");
var _coralComAmazonTransFeedbackTcfaModelV1 = require("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1");
var _getTermManualInput = require("./GetTermManualInput");
var _clwsinvalidRequestException = require("./CLWSInvalidRequestException");
var _getInlineHelpContentOutput = require("./GetInlineHelpContentOutput");
var _clwsunrecoverableException = require("./CLWSUnrecoverableException");
var _getLogisticsPartyDetailsInput = require("./GetLogisticsPartyDetailsInput");
var _getAuthorizedEntitiesInput = require("./GetAuthorizedEntitiesInput");
var _getInlineHelpContentInput = require("./GetInlineHelpContentInput");
var _getAuthorizedEntitiesOutput = require("./GetAuthorizedEntitiesOutput");
var _getAuthorizedLogisticsPartiesInput = require("./GetAuthorizedLogisticsPartiesInput");
var _getAuthorizedLogisticsPartiesOutput = require("./GetAuthorizedLogisticsPartiesOutput");
var _clwsrecoverableException = require("./CLWSRecoverableException");
var _getLogisticsPartyDetailsOutput = require("./GetLogisticsPartyDetailsOutput");
var _getTermManualOutput = require("./GetTermManualOutput");
var _coralComAmazonCoralServiceJms = require("@amzn/coral_com-amazon-coral-service-jms");
var _coralComAmazonCoralValidate = require("@amzn/coral_com-amazon-coral-validate");
var _coralComAmazonCoralServiceHttp = require("@amzn/coral_com-amazon-coral-service-http");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const carrierLogisticsWebServerSerdesInterceptor = new (0, _ihmJsCoralClient.CoralClientSerdesInterceptor)({
    GetAuthorizedEntities: {
        deserializationFn: (0, _getAuthorizedEntitiesOutput.GetAuthorizedEntitiesOutput).fromJson,
        serializationFn: (0, _getAuthorizedEntitiesInput.GetAuthorizedEntitiesInput).toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    },
    GetAuthorizedLogisticsParties: {
        deserializationFn: (0, _getAuthorizedLogisticsPartiesOutput.GetAuthorizedLogisticsPartiesOutput).fromJson,
        serializationFn: (0, _getAuthorizedLogisticsPartiesInput.GetAuthorizedLogisticsPartiesInput).toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    },
    GetDisplayableFeedbackQuestionnaire: {
        deserializationFn: _coralComAmazonTransFeedbackTcfaModelV1.GetDisplayableFeedbackQuestionnaireResponse.fromJson,
        serializationFn: _coralComAmazonTransFeedbackTcfaModelV1.GetDisplayableFeedbackQuestionnaireRequest.toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    },
    GetInlineHelpContent: {
        deserializationFn: (0, _getInlineHelpContentOutput.GetInlineHelpContentOutput).fromJson,
        serializationFn: (0, _getInlineHelpContentInput.GetInlineHelpContentInput).toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    },
    GetLogisticsPartyDetails: {
        deserializationFn: (0, _getLogisticsPartyDetailsOutput.GetLogisticsPartyDetailsOutput).fromJson,
        serializationFn: (0, _getLogisticsPartyDetailsInput.GetLogisticsPartyDetailsInput).toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    },
    GetTermManual: {
        deserializationFn: (0, _getTermManualOutput.GetTermManualOutput).fromJson,
        serializationFn: (0, _getTermManualInput.GetTermManualInput).toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    },
    SubmitFeedback: {
        serializationFn: _coralComAmazonTransFeedbackTcfaModelV1.SubmitFeedbackRequest.toJson,
        modelledExceptions: [
            (0, _clwsrecoverableException.CLWSRecoverableException),
            (0, _clwsinvalidRequestException.CLWSInvalidRequestException),
            (0, _clwsunrecoverableException.CLWSUnrecoverableException)
        ]
    }
}, [
    _coralComAmazonCoralAvailability.BackOffException,
    _coralComAmazonCoralAvailability.ThrottlingException,
    _coralComAmazonCoralClient.ClientUnavailableException,
    _coralComAmazonCoralClient.HttpConnectionTimeoutException,
    _coralComAmazonCoralClient.HttpFailureException,
    _coralComAmazonCoralClient.HttpTimeoutException,
    _coralComAmazonCoralServiceBsf.InvalidCodigoMessageException,
    _coralComAmazonCoralServiceHttp.HeaderMisclassificationException,
    _coralComAmazonCoralServiceHttp.HttpNotFoundException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.InvalidMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.MissingMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingRequiredHeaderException,
    _coralComAmazonCoralServiceJms.MessageProcessingException,
    _coralComAmazonCoralServiceJms.MessagePublishException,
    _coralComAmazonCoralService.AccessDeniedException,
    _coralComAmazonCoralService.DelegationException,
    _coralComAmazonCoralService.ExpiredTokenException,
    _coralComAmazonCoralService.IncompleteSignatureException,
    _coralComAmazonCoralService.InternalFailure,
    _coralComAmazonCoralService.InvalidAwsQueryStringException,
    _coralComAmazonCoralService.InvalidParameterCombinationException,
    _coralComAmazonCoralService.InvalidParameterValueException,
    _coralComAmazonCoralService.InvalidQueryParameterException,
    _coralComAmazonCoralService.InvalidQueryStringException,
    _coralComAmazonCoralService.InvalidSignatureException,
    _coralComAmazonCoralService.MalformedHttpRequestException,
    _coralComAmazonCoralService.MissingActionException,
    _coralComAmazonCoralService.MissingAuthenticationTokenException,
    _coralComAmazonCoralService.MissingRequiredParameterException,
    _coralComAmazonCoralService.NotAuthorizedException,
    _coralComAmazonCoralService.RequestAbortedException,
    _coralComAmazonCoralService.RequestEntityTooLargeException,
    _coralComAmazonCoralService.RequestExpiredException,
    _coralComAmazonCoralService.RequestTimeoutException,
    _coralComAmazonCoralService.SerializationException,
    _coralComAmazonCoralService.ServiceUnavailableException,
    _coralComAmazonCoralService.SubscriptionRequiredException,
    _coralComAmazonCoralService.TimeoutException,
    _coralComAmazonCoralService.TransmutationException,
    _coralComAmazonCoralService.UnknownOperationException,
    _coralComAmazonCoralService.UnrecognizedClientException,
    _coralComAmazonCoralService.UnsupportedMediaTypeException,
    _coralComAmazonCoralValidate.ValidationException
]);
const carrierLogisticsWebServerHttpBindingInterceptor = new (0, _ihmJsCoralClient.CoralClientHttpBindingInterceptor)({
    GetAuthorizedEntities: {
        method: "POST",
        path: "/clws/entities/v1/get-authorized-entities"
    },
    GetAuthorizedLogisticsParties: {
        method: "POST",
        path: "/clws/logisticsParty/v1/get-authorized-logisticsParties"
    },
    GetDisplayableFeedbackQuestionnaire: {
        method: "GET",
        path: "/clws/feedback/v1/displayable-questionnaire/applications/{applicationId}/intents/{feedbackIntent}/",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    },
    GetInlineHelpContent: {
        method: "POST",
        path: "/clws/content/v1/get-inline-help-content"
    },
    GetLogisticsPartyDetails: {
        method: "GET",
        path: "/clws/logisticsParty/v1/get-logisticsParty-details"
    },
    GetTermManual: {
        method: "POST",
        path: "/clws/content/v1/download-manual"
    },
    SubmitFeedback: {
        method: "POST",
        path: "/clws/feedback/v1/submit/applications/{applicationId}/intents/{feedbackIntent}?sif_profile={sifProfileId}",
        labelTransformations: {
            sifProfileId: "sifProfileId",
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    }
});
class CarrierLogisticsWebServer extends (0, _ihmJsCoralClient.CoralClient) {
    constructor(config, handler){
        const serdesHandler = new (0, _ihmJsCoralClient.InterceptingHandler)(handler, [
            carrierLogisticsWebServerSerdesInterceptor
        ]);
        super(config, serdesHandler);
    }
    /**
     * <pre><code>Sync API responsible to give all the entities that user have permission to
     * These entities are returned at each PermissionLevel
     * <\/code><\/pre>
     **/ getAuthorizedEntities(request) {
        return super.call("GetAuthorizedEntities", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getAuthorizedEntitiesOutput.GetAuthorizedEntitiesOutput))) throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetAuthorizedEntitiesOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API responsible to give all the Lps user have ACCESS permission to,
     * This API solves the partner-picker use case<\/p>
     **/ getAuthorizedLogisticsParties(request) {
        return super.call("GetAuthorizedLogisticsParties", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getAuthorizedLogisticsPartiesOutput.GetAuthorizedLogisticsPartiesOutput))) throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetAuthorizedLogisticsPartiesOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API responsible for getting eligible questionnaire inorder to provide feedback<\/p>
     **/ getDisplayableFeedbackQuestionnaire(request) {
        return super.call("GetDisplayableFeedbackQuestionnaire", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof _coralComAmazonTransFeedbackTcfaModelV1.GetDisplayableFeedbackQuestionnaireResponse)) throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type com_amazon_trans_feedback_tcfa_model_v_1.GetDisplayableFeedbackQuestionnaireResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API responsible for getting inline help content<\/p>
     **/ getInlineHelpContent(request) {
        return super.call("GetInlineHelpContent", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getInlineHelpContentOutput.GetInlineHelpContentOutput))) throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetInlineHelpContentOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API responsible to give LogisticsPartyDetails for the given LpId<\/p>
     **/ getLogisticsPartyDetails(request) {
        return super.call("GetLogisticsPartyDetails", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getLogisticsPartyDetailsOutput.GetLogisticsPartyDetailsOutput))) throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetLogisticsPartyDetailsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API responsible for getting presigned urls for downloading manuals<\/p>
     **/ getTermManual(request) {
        return super.call("GetTermManual", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getTermManualOutput.GetTermManualOutput))) throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetTermManualOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API responsible to submitFeedback<\/p>
     **/ submitFeedback(request) {
        return super.call("SubmitFeedback", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
}
CarrierLogisticsWebServer.assembly = "com.amazon.carrierlogisticswebserver.model";
CarrierLogisticsWebServer.serviceName = "CarrierLogisticsWebServer";

},{"@amzn/coral_com-amazon-coral-availability":"XcIbm","@amzn/coral_com-amazon-coral-service-bsf":"cXsMq","@amzn/coral_com-amazon-coral-client":"5x6ZW","@amzn/coral_com-amazon-coral-service":"17IVk","@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1":"6278u","./GetTermManualInput":"0oBd0","./CLWSInvalidRequestException":"dP371","./GetInlineHelpContentOutput":"6Tkp0","./CLWSUnrecoverableException":"jfPkF","./GetLogisticsPartyDetailsInput":"1Kk0F","./GetAuthorizedEntitiesInput":"9EHGO","./GetInlineHelpContentInput":"ciJIN","./GetAuthorizedEntitiesOutput":"bwCiU","./GetAuthorizedLogisticsPartiesInput":"bwUMr","./GetAuthorizedLogisticsPartiesOutput":"bEpU9","./CLWSRecoverableException":"kckWl","./GetLogisticsPartyDetailsOutput":"igwZj","./GetTermManualOutput":"3zHZ1","@amzn/coral_com-amazon-coral-service-jms":"6RZKg","@amzn/coral_com-amazon-coral-validate":"dF4p4","@amzn/coral_com-amazon-coral-service-http":"hKSuo","@amzn/ihm-js-coral-client":"eOj61","rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XcIbm":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("86e3320955fd5c5"), exports);
__exportStar(require("93e290a2c97037cf"), exports);

},{"86e3320955fd5c5":"ibkJz","93e290a2c97037cf":"8w0Cu"}],"ibkJz":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBackoffexception = exports.BackOffException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("dcaef7e640e010fa");
const ihm_js_coral_client_1 = require("f7085c49ae0a7eb5");
class BackOffException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BackOffException#clone(obj: PlainObjectFrom<BackOffException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of BackOffException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BackOffException(obj.message);
    }
    static fromJson(data) {
        return new BackOffException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.BackOffException = BackOffException;
BackOffException.fullyQualifiedTypeName = "com.amazon.coral.availability#BackOffException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(BackOffException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BackOffException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateBackoffexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateBackoffexception = validateBackoffexception;

},{"dcaef7e640e010fa":"9PLBl","f7085c49ae0a7eb5":"eOj61"}],"8w0Cu":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateThrottlingexception = exports.ThrottlingException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("b4b2ee042b277554");
const ihm_js_coral_client_1 = require("918f2bd0ae028be4");
class ThrottlingException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ThrottlingException#clone(obj: PlainObjectFrom<ThrottlingException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of ThrottlingException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ThrottlingException(obj.message);
    }
    static fromJson(data) {
        return new ThrottlingException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.ThrottlingException = ThrottlingException;
ThrottlingException.fullyQualifiedTypeName = "com.amazon.coral.availability#ThrottlingException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(ThrottlingException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ThrottlingException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateThrottlingexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateThrottlingexception = validateThrottlingexception;

},{"b4b2ee042b277554":"9PLBl","918f2bd0ae028be4":"eOj61"}],"cXsMq":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("cd2c4e68ca656faa"), exports);

},{"cd2c4e68ca656faa":"g0u6c"}],"g0u6c":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidcodigomessageexception = exports.InvalidCodigoMessageException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("7304f21905fb26d3");
const ihm_js_coral_client_1 = require("bcfe5ac1ad12b9f0");
class InvalidCodigoMessageException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidCodigoMessageException#clone(obj: PlainObjectFrom<InvalidCodigoMessageException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidCodigoMessageException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidCodigoMessageException(obj.message);
    }
    static fromJson(data) {
        return new InvalidCodigoMessageException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidCodigoMessageException = InvalidCodigoMessageException;
InvalidCodigoMessageException.fullyQualifiedTypeName = "com.amazon.coral.service.bsf#InvalidCodigoMessageException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidCodigoMessageException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidCodigoMessageException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidcodigomessageexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidcodigomessageexception = validateInvalidcodigomessageexception;

},{"7304f21905fb26d3":"9PLBl","bcfe5ac1ad12b9f0":"eOj61"}],"5x6ZW":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("afd237bddd7cb991"), exports);
__exportStar(require("1a35752e97d8846c"), exports);
__exportStar(require("d0051272f965a687"), exports);
__exportStar(require("57f45173253eead2"), exports);

},{"afd237bddd7cb991":"81BTe","1a35752e97d8846c":"biune","d0051272f965a687":"lD5Dp","57f45173253eead2":"3iPgi"}],"81BTe":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateClientunavailableexception = exports.ClientUnavailableException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("e7df3d846c2de7cf");
const ihm_js_coral_client_1 = require("986aebc2a81d343c");
class ClientUnavailableException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ClientUnavailableException#clone(obj: PlainObjectFrom<ClientUnavailableException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of ClientUnavailableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ClientUnavailableException(obj.Message);
    }
    static fromJson(data) {
        return new ClientUnavailableException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.ClientUnavailableException = ClientUnavailableException;
ClientUnavailableException.fullyQualifiedTypeName = "com.amazon.coral.client#ClientUnavailableException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(ClientUnavailableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ClientUnavailableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateClientunavailableexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateClientunavailableexception = validateClientunavailableexception;

},{"e7df3d846c2de7cf":"9PLBl","986aebc2a81d343c":"eOj61"}],"biune":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateHttpconnectiontimeoutexception = exports.HttpConnectionTimeoutException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("193e342f6ecb44e");
const ihm_js_coral_client_1 = require("3e8a93c15b5309db");
class HttpConnectionTimeoutException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the HttpConnectionTimeoutException#clone(obj: PlainObjectFrom<HttpConnectionTimeoutException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of HttpConnectionTimeoutException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new HttpConnectionTimeoutException(obj.message);
    }
    static fromJson(data) {
        return new HttpConnectionTimeoutException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.HttpConnectionTimeoutException = HttpConnectionTimeoutException;
HttpConnectionTimeoutException.fullyQualifiedTypeName = "com.amazon.coral.client#HttpConnectionTimeoutException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(HttpConnectionTimeoutException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [HttpConnectionTimeoutException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateHttpconnectiontimeoutexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateHttpconnectiontimeoutexception = validateHttpconnectiontimeoutexception;

},{"193e342f6ecb44e":"9PLBl","3e8a93c15b5309db":"eOj61"}],"lD5Dp":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateHttpfailureexception = exports.HttpFailureException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("133938b77c2886e");
const ihm_js_coral_client_1 = require("d116985a91e81ac8");
class HttpFailureException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the HttpFailureException#clone(obj: PlainObjectFrom<HttpFailureException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of HttpFailureException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new HttpFailureException(obj.message);
    }
    static fromJson(data) {
        return new HttpFailureException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.HttpFailureException = HttpFailureException;
HttpFailureException.fullyQualifiedTypeName = "com.amazon.coral.client#HttpFailureException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(HttpFailureException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [HttpFailureException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateHttpfailureexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateHttpfailureexception = validateHttpfailureexception;

},{"133938b77c2886e":"9PLBl","d116985a91e81ac8":"eOj61"}],"3iPgi":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateHttptimeoutexception = exports.HttpTimeoutException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("fdd8f5253133ee5f");
const ihm_js_coral_client_1 = require("6b8343d59a8f075f");
class HttpTimeoutException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the HttpTimeoutException#clone(obj: PlainObjectFrom<HttpTimeoutException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of HttpTimeoutException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new HttpTimeoutException(obj.message);
    }
    static fromJson(data) {
        return new HttpTimeoutException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.HttpTimeoutException = HttpTimeoutException;
HttpTimeoutException.fullyQualifiedTypeName = "com.amazon.coral.client#HttpTimeoutException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(HttpTimeoutException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [HttpTimeoutException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateHttptimeoutexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateHttptimeoutexception = validateHttptimeoutexception;

},{"fdd8f5253133ee5f":"9PLBl","6b8343d59a8f075f":"eOj61"}],"17IVk":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("9d9b3b36a98d25db"), exports);
__exportStar(require("b0fc8efacd207030"), exports);
__exportStar(require("80e9936b53acd040"), exports);
__exportStar(require("56d6afc6f61a0660"), exports);
__exportStar(require("d626ba69602ef12c"), exports);
__exportStar(require("be5c744072ca0006"), exports);
__exportStar(require("738ab1d335a096b8"), exports);
__exportStar(require("4e01294be8267543"), exports);
__exportStar(require("c58fb97c4429bf7f"), exports);
__exportStar(require("4a7b4f80b28b904b"), exports);
__exportStar(require("b1c2ae5ccaeb4627"), exports);
__exportStar(require("69159b9c3db78c03"), exports);
__exportStar(require("b24b6e94daa952f3"), exports);
__exportStar(require("e1b2368960856c24"), exports);
__exportStar(require("c7a373d6dc9c05b4"), exports);
__exportStar(require("97eaf3b17a3dba39"), exports);
__exportStar(require("20e3dd1634a7e854"), exports);
__exportStar(require("7f287d51bc1a12fc"), exports);
__exportStar(require("a4029ebd365264f2"), exports);
__exportStar(require("e4836d374e7c76d7"), exports);
__exportStar(require("2f20c15acbf8a5a7"), exports);
__exportStar(require("54916e570a62fefb"), exports);
__exportStar(require("ff11c108eb4b451"), exports);
__exportStar(require("9c9180e9c278919e"), exports);
__exportStar(require("7be2d89b3a9afb37"), exports);
__exportStar(require("f1ff14b717a4a3e8"), exports);
__exportStar(require("8522ee07582b431b"), exports);
__exportStar(require("709c9790dbf137aa"), exports);
__exportStar(require("ec2386a0ec900144"), exports);

},{"9d9b3b36a98d25db":"bm25m","b0fc8efacd207030":"i6Av2","80e9936b53acd040":"er6QW","56d6afc6f61a0660":"dzmgN","d626ba69602ef12c":"7B8Jc","be5c744072ca0006":"3aeFX","738ab1d335a096b8":"feOmJ","4e01294be8267543":"dp7Nt","c58fb97c4429bf7f":"6zPVu","4a7b4f80b28b904b":"bo8Ys","b1c2ae5ccaeb4627":"1BbZb","69159b9c3db78c03":"dSQ8R","b24b6e94daa952f3":"iNWPv","e1b2368960856c24":"7XP2N","c7a373d6dc9c05b4":"eZJbK","97eaf3b17a3dba39":"8sJkh","20e3dd1634a7e854":"108ke","7f287d51bc1a12fc":"kXNvo","a4029ebd365264f2":"30RcP","e4836d374e7c76d7":"chqxX","2f20c15acbf8a5a7":"fggQO","54916e570a62fefb":"5onRc","ff11c108eb4b451":"fH6P7","9c9180e9c278919e":"4DSAG","7be2d89b3a9afb37":"6j2sG","f1ff14b717a4a3e8":"2t8B2","8522ee07582b431b":"kiGyw","709c9790dbf137aa":"fqtU7","ec2386a0ec900144":"iCfPj"}],"bm25m":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateAccessdeniedexception = exports.AccessDeniedException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("cae55414878a4001");
const ihm_js_coral_client_1 = require("7e53102866bd9a0");
class AccessDeniedException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AccessDeniedException#clone(obj: PlainObjectFrom<AccessDeniedException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of AccessDeniedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AccessDeniedException(obj.Message);
    }
    static fromJson(data) {
        return new AccessDeniedException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.AccessDeniedException = AccessDeniedException;
AccessDeniedException.fullyQualifiedTypeName = "com.amazon.coral.service#AccessDeniedException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(AccessDeniedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AccessDeniedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateAccessdeniedexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateAccessdeniedexception = validateAccessdeniedexception;

},{"cae55414878a4001":"9PLBl","7e53102866bd9a0":"eOj61"}],"i6Av2":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateDelegationexception = exports.DelegationException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("8d00acc1b8d9532b");
const ihm_js_coral_client_1 = require("4f6ba5cc090b10a7");
class DelegationException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DelegationException#clone(obj: PlainObjectFrom<DelegationException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of DelegationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DelegationException(obj.message);
    }
    static fromJson(data) {
        return new DelegationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.DelegationException = DelegationException;
DelegationException.fullyQualifiedTypeName = "com.amazon.coral.service#DelegationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(DelegationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DelegationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateDelegationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateDelegationexception = validateDelegationexception;

},{"8d00acc1b8d9532b":"9PLBl","4f6ba5cc090b10a7":"eOj61"}],"er6QW":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateExpiredtokenexception = exports.ExpiredTokenException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("c2391f7d6b31cde4");
const ihm_js_coral_client_1 = require("339435aa3fd15ca6");
class ExpiredTokenException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ExpiredTokenException#clone(obj: PlainObjectFrom<ExpiredTokenException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of ExpiredTokenException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ExpiredTokenException(obj.message);
    }
    static fromJson(data) {
        return new ExpiredTokenException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.ExpiredTokenException = ExpiredTokenException;
ExpiredTokenException.fullyQualifiedTypeName = "com.amazon.coral.service#ExpiredTokenException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(ExpiredTokenException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ExpiredTokenException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateExpiredtokenexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateExpiredtokenexception = validateExpiredtokenexception;

},{"c2391f7d6b31cde4":"9PLBl","339435aa3fd15ca6":"eOj61"}],"dzmgN":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateIncompletesignatureexception = exports.IncompleteSignatureException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("941132c7714d9ed8");
const ihm_js_coral_client_1 = require("b6aa0627d701e1a8");
class IncompleteSignatureException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the IncompleteSignatureException#clone(obj: PlainObjectFrom<IncompleteSignatureException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of IncompleteSignatureException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new IncompleteSignatureException(obj.message);
    }
    static fromJson(data) {
        return new IncompleteSignatureException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.IncompleteSignatureException = IncompleteSignatureException;
IncompleteSignatureException.fullyQualifiedTypeName = "com.amazon.coral.service#IncompleteSignatureException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(IncompleteSignatureException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [IncompleteSignatureException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateIncompletesignatureexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateIncompletesignatureexception = validateIncompletesignatureexception;

},{"941132c7714d9ed8":"9PLBl","b6aa0627d701e1a8":"eOj61"}],"7B8Jc":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInternalfailure = exports.InternalFailure = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("49915f77180f827b");
const ihm_js_coral_client_1 = require("42ec4db0f1eb8389");
class InternalFailure extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InternalFailure#clone(obj: PlainObjectFrom<InternalFailure>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InternalFailure from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InternalFailure(obj.message);
    }
    static fromJson(data) {
        return new InternalFailure((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InternalFailure = InternalFailure;
InternalFailure.fullyQualifiedTypeName = "com.amazon.coral.service#InternalFailure";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InternalFailure);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InternalFailure] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInternalfailure(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInternalfailure = validateInternalfailure;

},{"49915f77180f827b":"9PLBl","42ec4db0f1eb8389":"eOj61"}],"3aeFX":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidawsquerystringexception = exports.InvalidAwsQueryStringException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("27a5a0006ea3353d");
const ihm_js_coral_client_1 = require("3ab067c3d7d0b276");
class InvalidAwsQueryStringException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidAwsQueryStringException#clone(obj: PlainObjectFrom<InvalidAwsQueryStringException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidAwsQueryStringException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidAwsQueryStringException(obj.message);
    }
    static fromJson(data) {
        return new InvalidAwsQueryStringException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidAwsQueryStringException = InvalidAwsQueryStringException;
InvalidAwsQueryStringException.fullyQualifiedTypeName = "com.amazon.coral.service#InvalidAwsQueryStringException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidAwsQueryStringException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidAwsQueryStringException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidawsquerystringexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidawsquerystringexception = validateInvalidawsquerystringexception;

},{"27a5a0006ea3353d":"9PLBl","3ab067c3d7d0b276":"eOj61"}],"feOmJ":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidparametercombinationexception = exports.InvalidParameterCombinationException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("867537a6013bd484");
const ihm_js_coral_client_1 = require("3ff95925d07292dc");
class InvalidParameterCombinationException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidParameterCombinationException#clone(obj: PlainObjectFrom<InvalidParameterCombinationException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidParameterCombinationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidParameterCombinationException(obj.message);
    }
    static fromJson(data) {
        return new InvalidParameterCombinationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidParameterCombinationException = InvalidParameterCombinationException;
InvalidParameterCombinationException.fullyQualifiedTypeName = "com.amazon.coral.service#InvalidParameterCombinationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidParameterCombinationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidParameterCombinationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidparametercombinationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidparametercombinationexception = validateInvalidparametercombinationexception;

},{"867537a6013bd484":"9PLBl","3ff95925d07292dc":"eOj61"}],"dp7Nt":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidparametervalueexception = exports.InvalidParameterValueException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("2406075dfdeeb1f4");
const ihm_js_coral_client_1 = require("99d69bd5c9583223");
class InvalidParameterValueException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidParameterValueException#clone(obj: PlainObjectFrom<InvalidParameterValueException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidParameterValueException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidParameterValueException(obj.message);
    }
    static fromJson(data) {
        return new InvalidParameterValueException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidParameterValueException = InvalidParameterValueException;
InvalidParameterValueException.fullyQualifiedTypeName = "com.amazon.coral.service#InvalidParameterValueException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidParameterValueException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidParameterValueException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidparametervalueexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidparametervalueexception = validateInvalidparametervalueexception;

},{"2406075dfdeeb1f4":"9PLBl","99d69bd5c9583223":"eOj61"}],"6zPVu":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidqueryparameterexception = exports.InvalidQueryParameterException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("38fee37bf455429b");
const ihm_js_coral_client_1 = require("caa8dc4720045bf");
class InvalidQueryParameterException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidQueryParameterException#clone(obj: PlainObjectFrom<InvalidQueryParameterException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidQueryParameterException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidQueryParameterException(obj.message);
    }
    static fromJson(data) {
        return new InvalidQueryParameterException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidQueryParameterException = InvalidQueryParameterException;
InvalidQueryParameterException.fullyQualifiedTypeName = "com.amazon.coral.service#InvalidQueryParameterException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidQueryParameterException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidQueryParameterException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidqueryparameterexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidqueryparameterexception = validateInvalidqueryparameterexception;

},{"38fee37bf455429b":"9PLBl","caa8dc4720045bf":"eOj61"}],"bo8Ys":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidquerystringexception = exports.InvalidQueryStringException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("192f6de4c885b91b");
const ihm_js_coral_client_1 = require("1a1436ebc05e231f");
class InvalidQueryStringException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidQueryStringException#clone(obj: PlainObjectFrom<InvalidQueryStringException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidQueryStringException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidQueryStringException(obj.message);
    }
    static fromJson(data) {
        return new InvalidQueryStringException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidQueryStringException = InvalidQueryStringException;
InvalidQueryStringException.fullyQualifiedTypeName = "com.amazon.coral.service#InvalidQueryStringException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidQueryStringException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidQueryStringException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidquerystringexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidquerystringexception = validateInvalidquerystringexception;

},{"192f6de4c885b91b":"9PLBl","1a1436ebc05e231f":"eOj61"}],"1BbZb":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidsignatureexception = exports.InvalidSignatureException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("546c979755c37e21");
const ihm_js_coral_client_1 = require("510e147a8b0f7ab8");
class InvalidSignatureException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidSignatureException#clone(obj: PlainObjectFrom<InvalidSignatureException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidSignatureException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidSignatureException(obj.message);
    }
    static fromJson(data) {
        return new InvalidSignatureException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidSignatureException = InvalidSignatureException;
InvalidSignatureException.fullyQualifiedTypeName = "com.amazon.coral.service#InvalidSignatureException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidSignatureException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidSignatureException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidsignatureexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidsignatureexception = validateInvalidsignatureexception;

},{"546c979755c37e21":"9PLBl","510e147a8b0f7ab8":"eOj61"}],"dSQ8R":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMalformedhttprequestexception = exports.MalformedHttpRequestException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("b65448de5b552c6");
const ihm_js_coral_client_1 = require("5be0aa2faf650db6");
class MalformedHttpRequestException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MalformedHttpRequestException#clone(obj: PlainObjectFrom<MalformedHttpRequestException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of MalformedHttpRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MalformedHttpRequestException(obj.Message);
    }
    static fromJson(data) {
        return new MalformedHttpRequestException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.MalformedHttpRequestException = MalformedHttpRequestException;
MalformedHttpRequestException.fullyQualifiedTypeName = "com.amazon.coral.service#MalformedHttpRequestException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MalformedHttpRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MalformedHttpRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMalformedhttprequestexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMalformedhttprequestexception = validateMalformedhttprequestexception;

},{"b65448de5b552c6":"9PLBl","5be0aa2faf650db6":"eOj61"}],"iNWPv":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMissingactionexception = exports.MissingActionException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("4749f94c29a1a3e2");
const ihm_js_coral_client_1 = require("9e50f9257b071d0f");
class MissingActionException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MissingActionException#clone(obj: PlainObjectFrom<MissingActionException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MissingActionException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MissingActionException(obj.message);
    }
    static fromJson(data) {
        return new MissingActionException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MissingActionException = MissingActionException;
MissingActionException.fullyQualifiedTypeName = "com.amazon.coral.service#MissingActionException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MissingActionException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MissingActionException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMissingactionexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMissingactionexception = validateMissingactionexception;

},{"4749f94c29a1a3e2":"9PLBl","9e50f9257b071d0f":"eOj61"}],"7XP2N":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMissingauthenticationtokenexception = exports.MissingAuthenticationTokenException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("8fd0ae879b342eab");
const ihm_js_coral_client_1 = require("ec166c005b5b6d36");
class MissingAuthenticationTokenException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MissingAuthenticationTokenException#clone(obj: PlainObjectFrom<MissingAuthenticationTokenException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MissingAuthenticationTokenException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MissingAuthenticationTokenException(obj.message);
    }
    static fromJson(data) {
        return new MissingAuthenticationTokenException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MissingAuthenticationTokenException = MissingAuthenticationTokenException;
MissingAuthenticationTokenException.fullyQualifiedTypeName = "com.amazon.coral.service#MissingAuthenticationTokenException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MissingAuthenticationTokenException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MissingAuthenticationTokenException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMissingauthenticationtokenexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMissingauthenticationtokenexception = validateMissingauthenticationtokenexception;

},{"8fd0ae879b342eab":"9PLBl","ec166c005b5b6d36":"eOj61"}],"eZJbK":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMissingrequiredparameterexception = exports.MissingRequiredParameterException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("e09ae9d66d36f7c8");
const ihm_js_coral_client_1 = require("49e668d87d6bde83");
class MissingRequiredParameterException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MissingRequiredParameterException#clone(obj: PlainObjectFrom<MissingRequiredParameterException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MissingRequiredParameterException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MissingRequiredParameterException(obj.message);
    }
    static fromJson(data) {
        return new MissingRequiredParameterException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MissingRequiredParameterException = MissingRequiredParameterException;
MissingRequiredParameterException.fullyQualifiedTypeName = "com.amazon.coral.service#MissingRequiredParameterException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MissingRequiredParameterException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MissingRequiredParameterException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMissingrequiredparameterexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMissingrequiredparameterexception = validateMissingrequiredparameterexception;

},{"e09ae9d66d36f7c8":"9PLBl","49e668d87d6bde83":"eOj61"}],"8sJkh":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateNotauthorizedexception = exports.NotAuthorizedException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("c2def9308795b472");
const ihm_js_coral_client_1 = require("3027a3f537d951fc");
class NotAuthorizedException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the NotAuthorizedException#clone(obj: PlainObjectFrom<NotAuthorizedException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of NotAuthorizedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new NotAuthorizedException(obj.Message);
    }
    static fromJson(data) {
        return new NotAuthorizedException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.NotAuthorizedException = NotAuthorizedException;
NotAuthorizedException.fullyQualifiedTypeName = "com.amazon.coral.service#NotAuthorizedException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(NotAuthorizedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [NotAuthorizedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateNotauthorizedexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateNotauthorizedexception = validateNotauthorizedexception;

},{"c2def9308795b472":"9PLBl","3027a3f537d951fc":"eOj61"}],"108ke":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateRequestabortedexception = exports.RequestAbortedException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("b9955e73b77da4c");
const ihm_js_coral_client_1 = require("306b9295c3017a96");
/**
 * Convenient exception that can be used when a request is aborted
 * before a reply is sent back (e.g. client closed connection)
 **/ class RequestAbortedException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestAbortedException#clone(obj: PlainObjectFrom<RequestAbortedException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of RequestAbortedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestAbortedException(obj.message);
    }
    static fromJson(data) {
        return new RequestAbortedException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.RequestAbortedException = RequestAbortedException;
RequestAbortedException.fullyQualifiedTypeName = "com.amazon.coral.service#RequestAbortedException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(RequestAbortedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestAbortedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateRequestabortedexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateRequestabortedexception = validateRequestabortedexception;

},{"b9955e73b77da4c":"9PLBl","306b9295c3017a96":"eOj61"}],"kXNvo":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateRequestentitytoolargeexception = exports.RequestEntityTooLargeException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("c97cca4573d6883");
const ihm_js_coral_client_1 = require("807cf3d1034b233b");
class RequestEntityTooLargeException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestEntityTooLargeException#clone(obj: PlainObjectFrom<RequestEntityTooLargeException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of RequestEntityTooLargeException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestEntityTooLargeException(obj.Message);
    }
    static fromJson(data) {
        return new RequestEntityTooLargeException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.RequestEntityTooLargeException = RequestEntityTooLargeException;
RequestEntityTooLargeException.fullyQualifiedTypeName = "com.amazon.coral.service#RequestEntityTooLargeException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(RequestEntityTooLargeException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestEntityTooLargeException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateRequestentitytoolargeexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateRequestentitytoolargeexception = validateRequestentitytoolargeexception;

},{"c97cca4573d6883":"9PLBl","807cf3d1034b233b":"eOj61"}],"30RcP":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateRequestexpiredexception = exports.RequestExpiredException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("ff17426b5a1ad64a");
const ihm_js_coral_client_1 = require("82c2d253d737b2e");
class RequestExpiredException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestExpiredException#clone(obj: PlainObjectFrom<RequestExpiredException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of RequestExpiredException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestExpiredException(obj.message);
    }
    static fromJson(data) {
        return new RequestExpiredException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.RequestExpiredException = RequestExpiredException;
RequestExpiredException.fullyQualifiedTypeName = "com.amazon.coral.service#RequestExpiredException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(RequestExpiredException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestExpiredException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateRequestexpiredexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateRequestexpiredexception = validateRequestexpiredexception;

},{"ff17426b5a1ad64a":"9PLBl","82c2d253d737b2e":"eOj61"}],"chqxX":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateRequesttimeoutexception = exports.RequestTimeoutException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("7e2221af6ad9f37c");
const ihm_js_coral_client_1 = require("5f6a5d4b75142403");
class RequestTimeoutException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestTimeoutException#clone(obj: PlainObjectFrom<RequestTimeoutException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of RequestTimeoutException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestTimeoutException(obj.Message);
    }
    static fromJson(data) {
        return new RequestTimeoutException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.RequestTimeoutException = RequestTimeoutException;
RequestTimeoutException.fullyQualifiedTypeName = "com.amazon.coral.service#RequestTimeoutException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(RequestTimeoutException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestTimeoutException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateRequesttimeoutexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateRequesttimeoutexception = validateRequesttimeoutexception;

},{"7e2221af6ad9f37c":"9PLBl","5f6a5d4b75142403":"eOj61"}],"fggQO":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSerializationexception = exports.SerializationException = void 0;
const TransmutationException_1 = require("5e809f3204ea7d9");
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("12ebd976239a784a");
const ihm_js_coral_client_1 = require("fc07f14a406f21bf");
class SerializationException extends TransmutationException_1.TransmutationException {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SerializationException#clone(obj: PlainObjectFrom<SerializationException>) method.
     */ /**
     * Create a shallow clone of SerializationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SerializationException(obj.Message);
    }
    static fromJson(data) {
        return new SerializationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.SerializationException = SerializationException;
SerializationException.fullyQualifiedTypeName = "com.amazon.coral.service#SerializationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SerializationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SerializationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSerializationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSerializationexception = validateSerializationexception;

},{"5e809f3204ea7d9":"6j2sG","12ebd976239a784a":"9PLBl","fc07f14a406f21bf":"eOj61"}],"6j2sG":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateTransmutationexception = exports.TransmutationException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("1dde2aac0049bad1");
const ihm_js_coral_client_1 = require("d35d2cbe187f200b");
const serializer_1 = require("d05378dedc894793");
class TransmutationException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TransmutationException#clone(obj: PlainObjectFrom<TransmutationException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of TransmutationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TransmutationException(obj.Message);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== TransmutationException.fullyQualifiedTypeName) {
            const ctor = ihm_js_coral_client_1.modelRegistrySingleton.getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new serializer_1.CoralDeserializationTypeError(data.__type);
        }
        return new TransmutationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== TransmutationException.fullyQualifiedTypeName) {
            const ctor = ihm_js_coral_client_1.modelRegistrySingleton.getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new serializer_1.CoralSerializationTypeError(__type);
        }
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.TransmutationException = TransmutationException;
TransmutationException.fullyQualifiedTypeName = "com.amazon.coral.service#TransmutationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(TransmutationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TransmutationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateTransmutationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateTransmutationexception = validateTransmutationexception;

},{"1dde2aac0049bad1":"9PLBl","d35d2cbe187f200b":"eOj61","d05378dedc894793":"ikaAd"}],"ikaAd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("./errors");
parcelHelpers.exportAll(_errors, exports);

},{"./errors":"aHR4F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aHR4F":[function(require,module,exports) {
// tslint:disable:max-classes-per-file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralDeserializationTypeError", ()=>CoralDeserializationTypeError);
parcelHelpers.export(exports, "CoralSerializationTypeError", ()=>CoralSerializationTypeError);
class CoralDeserializationTypeError extends TypeError {
    constructor(receivedType = "undefined", expectedType = "undefined"){
        const message = `[CoralDeserializationTypeError] Cannot deserialize received type
    "${receivedType}" to type "${expectedType}"`;
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class CoralSerializationTypeError extends TypeError {
    constructor(receivedType = "undefined", expectedType = "undefined"){
        const message = `[CoralSerializationTypeError] Cannot serialize received type
    "${receivedType}" to type "${expectedType}"`;
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5onRc":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateServiceunavailableexception = exports.ServiceUnavailableException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("2b5d5a30ab21ad93");
const ihm_js_coral_client_1 = require("620ba89ede97d403");
class ServiceUnavailableException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ServiceUnavailableException#clone(obj: PlainObjectFrom<ServiceUnavailableException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of ServiceUnavailableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ServiceUnavailableException(obj.Message);
    }
    static fromJson(data) {
        return new ServiceUnavailableException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.ServiceUnavailableException = ServiceUnavailableException;
ServiceUnavailableException.fullyQualifiedTypeName = "com.amazon.coral.service#ServiceUnavailableException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(ServiceUnavailableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ServiceUnavailableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateServiceunavailableexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateServiceunavailableexception = validateServiceunavailableexception;

},{"2b5d5a30ab21ad93":"9PLBl","620ba89ede97d403":"eOj61"}],"fH6P7":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSubscriptionrequiredexception = exports.SubscriptionRequiredException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("d6542918ff0e6e88");
const ihm_js_coral_client_1 = require("f14879ed89e1cd67");
class SubscriptionRequiredException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SubscriptionRequiredException#clone(obj: PlainObjectFrom<SubscriptionRequiredException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of SubscriptionRequiredException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SubscriptionRequiredException(obj.message);
    }
    static fromJson(data) {
        return new SubscriptionRequiredException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.SubscriptionRequiredException = SubscriptionRequiredException;
SubscriptionRequiredException.fullyQualifiedTypeName = "com.amazon.coral.service#SubscriptionRequiredException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SubscriptionRequiredException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SubscriptionRequiredException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSubscriptionrequiredexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSubscriptionrequiredexception = validateSubscriptionrequiredexception;

},{"d6542918ff0e6e88":"9PLBl","f14879ed89e1cd67":"eOj61"}],"4DSAG":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateTimeoutexception = exports.TimeoutException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("e313a53f3845f7d");
const ihm_js_coral_client_1 = require("c063c2c7f420759b");
class TimeoutException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TimeoutException#clone(obj: PlainObjectFrom<TimeoutException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of TimeoutException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TimeoutException(obj.message);
    }
    static fromJson(data) {
        return new TimeoutException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.TimeoutException = TimeoutException;
TimeoutException.fullyQualifiedTypeName = "com.amazon.coral.service#TimeoutException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(TimeoutException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TimeoutException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateTimeoutexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateTimeoutexception = validateTimeoutexception;

},{"e313a53f3845f7d":"9PLBl","c063c2c7f420759b":"eOj61"}],"2t8B2":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateUnknownoperationexception = exports.UnknownOperationException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("5a5036d80d8b8e");
const ihm_js_coral_client_1 = require("4ee783f3c438648c");
class UnknownOperationException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UnknownOperationException#clone(obj: PlainObjectFrom<UnknownOperationException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of UnknownOperationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UnknownOperationException(obj.message);
    }
    static fromJson(data) {
        return new UnknownOperationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.UnknownOperationException = UnknownOperationException;
UnknownOperationException.fullyQualifiedTypeName = "com.amazon.coral.service#UnknownOperationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(UnknownOperationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UnknownOperationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateUnknownoperationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateUnknownoperationexception = validateUnknownoperationexception;

},{"5a5036d80d8b8e":"9PLBl","4ee783f3c438648c":"eOj61"}],"kiGyw":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnknownService = exports.unknownServiceSerdesInterceptor = void 0;
const ThrottlingException_1 = require("a34fda90c14a16d2");
const BackOffException_1 = require("324adcf17f9cc262");
const InvalidCodigoMessageException_1 = require("9029fd1309717b54");
const HttpFailureException_1 = require("e7b8632510a4a55d");
const HttpTimeoutException_1 = require("ce2f026566590eb9");
const ClientUnavailableException_1 = require("d6aac4ae1593208");
const HttpConnectionTimeoutException_1 = require("6348404471b26adc");
const InvalidParameterCombinationException_1 = require("48db73dcb9705f99");
const UnknownOperationException_1 = require("a7665d4adc36d4b6");
const RequestEntityTooLargeException_1 = require("57ea2ed88c6e9cef");
const ExpiredTokenException_1 = require("90ad53c6593cc7fc");
const InternalFailure_1 = require("ad66cbfb9c329708");
const UnrecognizedClientException_1 = require("f87936faf36cbd8d");
const TimeoutException_1 = require("8b8ef4ef12146bbc");
const MalformedHttpRequestException_1 = require("d122e14cbe70b8b");
const TransmutationException_1 = require("2586afeaee03e1ab");
const InvalidQueryStringException_1 = require("20d86c1aebb022e7");
const DelegationException_1 = require("74b9d4d30fb4e7e");
const NotAuthorizedException_1 = require("57ea0e0cb75b9485");
const RequestAbortedException_1 = require("53dc304f8c1f0d17");
const MissingAuthenticationTokenException_1 = require("9ef18fe7920d899d");
const InvalidSignatureException_1 = require("6d08149698a1efe2");
const InvalidAwsQueryStringException_1 = require("ae391106fa6d32e4");
const MissingRequiredParameterException_1 = require("be0f8c3549145a09");
const AccessDeniedException_1 = require("9f25757393d5406b");
const IncompleteSignatureException_1 = require("d22bd3b22657d427");
const MissingActionException_1 = require("ae8f922762881f09");
const InvalidQueryParameterException_1 = require("566ca9bb08a0e853");
const InvalidParameterValueException_1 = require("57c10eb64620f61b");
const ServiceUnavailableException_1 = require("27ea60da94621e64");
const SerializationException_1 = require("d6d0cf058931b33e");
const RequestTimeoutException_1 = require("c704fd557adebb8f");
const UnsupportedMediaTypeException_1 = require("3151220df5c112df");
const RequestExpiredException_1 = require("423becf4a2d15ae0");
const SubscriptionRequiredException_1 = require("6c884f77ce89cdc5");
const SentryAccessDeniedException_1 = require("ea5235c59cfdc2a0");
const SentryInternalServerError_1 = require("d6175bca135a1906");
const SentryRedirectException_1 = require("65d57e6d28e695b0");
const SentryBadRequestException_1 = require("5f4b07c2a7596e56");
const SentryUnauthorizedException_1 = require("590f0c3c4e44d3ef");
const ValidationException_1 = require("77810114c7c75613");
const MessagePublishException_1 = require("68ed0a321d82aabe");
const MessageProcessingException_1 = require("b3082a6fff3b66ca");
const InvalidMessageDigestException_1 = require("ae6efe26b5986958");
const HeaderMisclassificationException_1 = require("e65eb123e82913e5");
const InvalidAuthSchemeParameterException_1 = require("26c0813897c738e1");
const MissingRequiredHeaderException_1 = require("84181c814ccde7d7");
const MissingAuthSchemeParameterException_1 = require("6342eaca7673cab1");
const MissingMessageDigestException_1 = require("250364d3b2206b53");
const HttpNotFoundException_1 = require("2b765d1980fe6e48");
const InvalidAuthSchemeException_1 = require("229b389e873e1b1a");
const ihm_js_coral_client_1 = require("17339396d5246c5b");
const ihm_js_coral_client_2 = require("17339396d5246c5b");
const rxjs_1 = require("900ef8663996076f");
const operators_1 = require("e921484e590b27ac");
exports.unknownServiceSerdesInterceptor = new ihm_js_coral_client_2.CoralClientSerdesInterceptor({
    UnknownOperation: {
        modelledExceptions: []
    }
}, [
    BackOffException_1.BackOffException,
    ThrottlingException_1.ThrottlingException,
    ClientUnavailableException_1.ClientUnavailableException,
    HttpConnectionTimeoutException_1.HttpConnectionTimeoutException,
    HttpFailureException_1.HttpFailureException,
    HttpTimeoutException_1.HttpTimeoutException,
    InvalidCodigoMessageException_1.InvalidCodigoMessageException,
    HeaderMisclassificationException_1.HeaderMisclassificationException,
    HttpNotFoundException_1.HttpNotFoundException,
    InvalidAuthSchemeException_1.InvalidAuthSchemeException,
    InvalidAuthSchemeParameterException_1.InvalidAuthSchemeParameterException,
    InvalidMessageDigestException_1.InvalidMessageDigestException,
    MissingAuthSchemeParameterException_1.MissingAuthSchemeParameterException,
    MissingMessageDigestException_1.MissingMessageDigestException,
    MissingRequiredHeaderException_1.MissingRequiredHeaderException,
    MessageProcessingException_1.MessageProcessingException,
    MessagePublishException_1.MessagePublishException,
    AccessDeniedException_1.AccessDeniedException,
    DelegationException_1.DelegationException,
    ExpiredTokenException_1.ExpiredTokenException,
    IncompleteSignatureException_1.IncompleteSignatureException,
    InternalFailure_1.InternalFailure,
    InvalidAwsQueryStringException_1.InvalidAwsQueryStringException,
    InvalidParameterCombinationException_1.InvalidParameterCombinationException,
    InvalidParameterValueException_1.InvalidParameterValueException,
    InvalidQueryParameterException_1.InvalidQueryParameterException,
    InvalidQueryStringException_1.InvalidQueryStringException,
    InvalidSignatureException_1.InvalidSignatureException,
    MalformedHttpRequestException_1.MalformedHttpRequestException,
    MissingActionException_1.MissingActionException,
    MissingAuthenticationTokenException_1.MissingAuthenticationTokenException,
    MissingRequiredParameterException_1.MissingRequiredParameterException,
    NotAuthorizedException_1.NotAuthorizedException,
    RequestAbortedException_1.RequestAbortedException,
    RequestEntityTooLargeException_1.RequestEntityTooLargeException,
    RequestExpiredException_1.RequestExpiredException,
    RequestTimeoutException_1.RequestTimeoutException,
    SerializationException_1.SerializationException,
    ServiceUnavailableException_1.ServiceUnavailableException,
    SubscriptionRequiredException_1.SubscriptionRequiredException,
    TimeoutException_1.TimeoutException,
    TransmutationException_1.TransmutationException,
    UnknownOperationException_1.UnknownOperationException,
    UnrecognizedClientException_1.UnrecognizedClientException,
    UnsupportedMediaTypeException_1.UnsupportedMediaTypeException,
    ValidationException_1.ValidationException,
    SentryAccessDeniedException_1.SentryAccessDeniedException,
    SentryBadRequestException_1.SentryBadRequestException,
    SentryInternalServerError_1.SentryInternalServerError,
    SentryRedirectException_1.SentryRedirectException,
    SentryUnauthorizedException_1.SentryUnauthorizedException
]);
class UnknownService extends ihm_js_coral_client_1.CoralClient {
    constructor(config, handler){
        const serdesHandler = new ihm_js_coral_client_2.InterceptingHandler(handler, [
            exports.unknownServiceSerdesInterceptor
        ]);
        super(config, serdesHandler);
    }
    unknownOperation() {
        return super.call("UnknownOperation").pipe(operators_1.map(()=>undefined), operators_1.catchError((error)=>rxjs_1.throwError(typeof error === "object" && error !== null && error.constructor.name === ihm_js_coral_client_1.CoralResponse.name && error.body !== undefined ? error.body : error)));
    }
}
exports.UnknownService = UnknownService;
UnknownService.assembly = "com.amazon.coral.service";
UnknownService.serviceName = "UnknownService";

},{"a34fda90c14a16d2":"8w0Cu","324adcf17f9cc262":"ibkJz","9029fd1309717b54":"g0u6c","e7b8632510a4a55d":"lD5Dp","ce2f026566590eb9":"3iPgi","d6aac4ae1593208":"81BTe","6348404471b26adc":"biune","48db73dcb9705f99":"feOmJ","a7665d4adc36d4b6":"2t8B2","57ea2ed88c6e9cef":"kXNvo","90ad53c6593cc7fc":"er6QW","ad66cbfb9c329708":"7B8Jc","f87936faf36cbd8d":"fqtU7","8b8ef4ef12146bbc":"4DSAG","d122e14cbe70b8b":"dSQ8R","2586afeaee03e1ab":"6j2sG","20d86c1aebb022e7":"bo8Ys","74b9d4d30fb4e7e":"i6Av2","57ea0e0cb75b9485":"8sJkh","53dc304f8c1f0d17":"108ke","9ef18fe7920d899d":"7XP2N","6d08149698a1efe2":"1BbZb","ae391106fa6d32e4":"3aeFX","be0f8c3549145a09":"eZJbK","9f25757393d5406b":"bm25m","d22bd3b22657d427":"dzmgN","ae8f922762881f09":"iNWPv","566ca9bb08a0e853":"6zPVu","57c10eb64620f61b":"dp7Nt","27ea60da94621e64":"5onRc","d6d0cf058931b33e":"fggQO","c704fd557adebb8f":"chqxX","3151220df5c112df":"iCfPj","423becf4a2d15ae0":"30RcP","6c884f77ce89cdc5":"fH6P7","ea5235c59cfdc2a0":"2BCXy","d6175bca135a1906":"jqPN0","65d57e6d28e695b0":"6Zebg","5f4b07c2a7596e56":"eIGJ7","590f0c3c4e44d3ef":"4xNPP","77810114c7c75613":"dadgW","68ed0a321d82aabe":"hoMtd","b3082a6fff3b66ca":"7iASr","ae6efe26b5986958":"5I65p","e65eb123e82913e5":"crKOF","26c0813897c738e1":"asWRV","84181c814ccde7d7":"dZrcy","6342eaca7673cab1":"bXK3T","250364d3b2206b53":"9dPeG","2b765d1980fe6e48":"iBbzU","229b389e873e1b1a":"bAxMD","17339396d5246c5b":"eOj61","900ef8663996076f":"gxhPq","e921484e590b27ac":"ggrIi"}],"fqtU7":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateUnrecognizedclientexception = exports.UnrecognizedClientException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("7bef8ff3a7cac271");
const ihm_js_coral_client_1 = require("d15c6f16bec7662d");
class UnrecognizedClientException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UnrecognizedClientException#clone(obj: PlainObjectFrom<UnrecognizedClientException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of UnrecognizedClientException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UnrecognizedClientException(obj.message);
    }
    static fromJson(data) {
        return new UnrecognizedClientException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.UnrecognizedClientException = UnrecognizedClientException;
UnrecognizedClientException.fullyQualifiedTypeName = "com.amazon.coral.service#UnrecognizedClientException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(UnrecognizedClientException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UnrecognizedClientException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateUnrecognizedclientexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateUnrecognizedclientexception = validateUnrecognizedclientexception;

},{"7bef8ff3a7cac271":"9PLBl","d15c6f16bec7662d":"eOj61"}],"iCfPj":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateUnsupportedmediatypeexception = exports.UnsupportedMediaTypeException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("52c9656f90a4be6d");
const ihm_js_coral_client_1 = require("3bdee389b960d71f");
class UnsupportedMediaTypeException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UnsupportedMediaTypeException#clone(obj: PlainObjectFrom<UnsupportedMediaTypeException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of UnsupportedMediaTypeException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UnsupportedMediaTypeException(obj.message);
    }
    static fromJson(data) {
        return new UnsupportedMediaTypeException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.UnsupportedMediaTypeException = UnsupportedMediaTypeException;
UnsupportedMediaTypeException.fullyQualifiedTypeName = "com.amazon.coral.service#UnsupportedMediaTypeException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(UnsupportedMediaTypeException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UnsupportedMediaTypeException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateUnsupportedmediatypeexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateUnsupportedmediatypeexception = validateUnsupportedmediatypeexception;

},{"52c9656f90a4be6d":"9PLBl","3bdee389b960d71f":"eOj61"}],"2BCXy":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSentryaccessdeniedexception = exports.SentryAccessDeniedException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("7205d5bdc0cab94d");
const ihm_js_coral_client_1 = require("9f915e8f9158bb82");
class SentryAccessDeniedException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SentryAccessDeniedException#clone(obj: PlainObjectFrom<SentryAccessDeniedException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of SentryAccessDeniedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SentryAccessDeniedException(obj.Message);
    }
    static fromJson(data) {
        return new SentryAccessDeniedException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.SentryAccessDeniedException = SentryAccessDeniedException;
SentryAccessDeniedException.fullyQualifiedTypeName = "com.amazon.sentry.sso#SentryAccessDeniedException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SentryAccessDeniedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SentryAccessDeniedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSentryaccessdeniedexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSentryaccessdeniedexception = validateSentryaccessdeniedexception;

},{"7205d5bdc0cab94d":"9PLBl","9f915e8f9158bb82":"eOj61"}],"jqPN0":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSentryinternalservererror = exports.SentryInternalServerError = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("6e5d7f45f2587d9c");
const ihm_js_coral_client_1 = require("7a1fb120f5d8ec18");
class SentryInternalServerError extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SentryInternalServerError#clone(obj: PlainObjectFrom<SentryInternalServerError>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of SentryInternalServerError from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SentryInternalServerError(obj.Message);
    }
    static fromJson(data) {
        return new SentryInternalServerError((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.SentryInternalServerError = SentryInternalServerError;
SentryInternalServerError.fullyQualifiedTypeName = "com.amazon.sentry.sso#SentryInternalServerError";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SentryInternalServerError);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SentryInternalServerError] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSentryinternalservererror(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSentryinternalservererror = validateSentryinternalservererror;

},{"6e5d7f45f2587d9c":"9PLBl","7a1fb120f5d8ec18":"eOj61"}],"6Zebg":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSentryredirectexception = exports.SentryRedirectException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("bf7c198bd5bd79c2");
const ihm_js_coral_client_1 = require("3435588158ad650");
class SentryRedirectException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SentryRedirectException#clone(obj: PlainObjectFrom<SentryRedirectException>) method.
     */ constructor(__Location){
        super();
        this.Location = __Location;
    }
    /**
     * Create a shallow clone of SentryRedirectException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SentryRedirectException(obj.Location);
    }
    static fromJson(data) {
        return new SentryRedirectException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Location));
    }
    static toJson(data) {
        return Object.assign({
            Location: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Location)
        });
    }
}
exports.SentryRedirectException = SentryRedirectException;
SentryRedirectException.fullyQualifiedTypeName = "com.amazon.sentry.sso#SentryRedirectException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SentryRedirectException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SentryRedirectException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSentryredirectexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSentryredirectexception = validateSentryredirectexception;

},{"bf7c198bd5bd79c2":"9PLBl","3435588158ad650":"eOj61"}],"eIGJ7":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSentrybadrequestexception = exports.SentryBadRequestException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("fd9f1ca06fd54a57");
const ihm_js_coral_client_1 = require("62951a7734c95a36");
class SentryBadRequestException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SentryBadRequestException#clone(obj: PlainObjectFrom<SentryBadRequestException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of SentryBadRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SentryBadRequestException(obj.Message);
    }
    static fromJson(data) {
        return new SentryBadRequestException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.SentryBadRequestException = SentryBadRequestException;
SentryBadRequestException.fullyQualifiedTypeName = "com.amazon.sentry.sso#SentryBadRequestException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SentryBadRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SentryBadRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSentrybadrequestexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSentrybadrequestexception = validateSentrybadrequestexception;

},{"fd9f1ca06fd54a57":"9PLBl","62951a7734c95a36":"eOj61"}],"4xNPP":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSentryunauthorizedexception = exports.SentryUnauthorizedException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("fc8058e16519fa2e");
const ihm_js_coral_client_1 = require("1f214eedf8dd327c");
class SentryUnauthorizedException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SentryUnauthorizedException#clone(obj: PlainObjectFrom<SentryUnauthorizedException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of SentryUnauthorizedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SentryUnauthorizedException(obj.Message);
    }
    static fromJson(data) {
        return new SentryUnauthorizedException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.SentryUnauthorizedException = SentryUnauthorizedException;
SentryUnauthorizedException.fullyQualifiedTypeName = "com.amazon.sentry.sso#SentryUnauthorizedException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(SentryUnauthorizedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SentryUnauthorizedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateSentryunauthorizedexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateSentryunauthorizedexception = validateSentryunauthorizedexception;

},{"fc8058e16519fa2e":"9PLBl","1f214eedf8dd327c":"eOj61"}],"dadgW":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateValidationexception = exports.ValidationException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("93cafde61d9d2c7f");
const ihm_js_coral_client_1 = require("6ace9e73eef34084");
class ValidationException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ValidationException#clone(obj: PlainObjectFrom<ValidationException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of ValidationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ValidationException(obj.message);
    }
    static fromJson(data) {
        return new ValidationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.ValidationException = ValidationException;
ValidationException.fullyQualifiedTypeName = "com.amazon.coral.validate#ValidationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(ValidationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ValidationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateValidationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateValidationexception = validateValidationexception;

},{"93cafde61d9d2c7f":"9PLBl","6ace9e73eef34084":"eOj61"}],"hoMtd":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMessagepublishexception = exports.MessagePublishException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("3f46b15bb3398050");
const ihm_js_coral_client_1 = require("430b136bd55d3383");
class MessagePublishException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MessagePublishException#clone(obj: PlainObjectFrom<MessagePublishException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MessagePublishException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MessagePublishException(obj.message);
    }
    static fromJson(data) {
        return new MessagePublishException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MessagePublishException = MessagePublishException;
MessagePublishException.fullyQualifiedTypeName = "com.amazon.coral.service.jms#MessagePublishException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MessagePublishException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MessagePublishException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMessagepublishexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMessagepublishexception = validateMessagepublishexception;

},{"3f46b15bb3398050":"9PLBl","430b136bd55d3383":"eOj61"}],"7iASr":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMessageprocessingexception = exports.MessageProcessingException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("2932364c1efc73d6");
const ihm_js_coral_client_1 = require("4dbebaf7a0a6147c");
class MessageProcessingException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MessageProcessingException#clone(obj: PlainObjectFrom<MessageProcessingException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MessageProcessingException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MessageProcessingException(obj.message);
    }
    static fromJson(data) {
        return new MessageProcessingException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MessageProcessingException = MessageProcessingException;
MessageProcessingException.fullyQualifiedTypeName = "com.amazon.coral.service.jms#MessageProcessingException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MessageProcessingException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MessageProcessingException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMessageprocessingexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMessageprocessingexception = validateMessageprocessingexception;

},{"2932364c1efc73d6":"9PLBl","4dbebaf7a0a6147c":"eOj61"}],"5I65p":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidmessagedigestexception = exports.InvalidMessageDigestException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("de9f56acea3ff5cd");
const ihm_js_coral_client_1 = require("8e6c8dece82496d9");
class InvalidMessageDigestException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidMessageDigestException#clone(obj: PlainObjectFrom<InvalidMessageDigestException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidMessageDigestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidMessageDigestException(obj.message);
    }
    static fromJson(data) {
        return new InvalidMessageDigestException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidMessageDigestException = InvalidMessageDigestException;
InvalidMessageDigestException.fullyQualifiedTypeName = "com.amazon.coral.service.http#InvalidMessageDigestException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidMessageDigestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidMessageDigestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidmessagedigestexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidmessagedigestexception = validateInvalidmessagedigestexception;

},{"de9f56acea3ff5cd":"9PLBl","8e6c8dece82496d9":"eOj61"}],"crKOF":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateHeadermisclassificationexception = exports.HeaderMisclassificationException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("9da5db5eeea9400c");
const ihm_js_coral_client_1 = require("68e2abb8e22615e2");
class HeaderMisclassificationException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the HeaderMisclassificationException#clone(obj: PlainObjectFrom<HeaderMisclassificationException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of HeaderMisclassificationException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new HeaderMisclassificationException(obj.message);
    }
    static fromJson(data) {
        return new HeaderMisclassificationException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.HeaderMisclassificationException = HeaderMisclassificationException;
HeaderMisclassificationException.fullyQualifiedTypeName = "com.amazon.coral.service.http#HeaderMisclassificationException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(HeaderMisclassificationException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [HeaderMisclassificationException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateHeadermisclassificationexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateHeadermisclassificationexception = validateHeadermisclassificationexception;

},{"9da5db5eeea9400c":"9PLBl","68e2abb8e22615e2":"eOj61"}],"asWRV":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidauthschemeparameterexception = exports.InvalidAuthSchemeParameterException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("42c78228449dd61e");
const ihm_js_coral_client_1 = require("d085d1c53aba5190");
class InvalidAuthSchemeParameterException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidAuthSchemeParameterException#clone(obj: PlainObjectFrom<InvalidAuthSchemeParameterException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidAuthSchemeParameterException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidAuthSchemeParameterException(obj.message);
    }
    static fromJson(data) {
        return new InvalidAuthSchemeParameterException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidAuthSchemeParameterException = InvalidAuthSchemeParameterException;
InvalidAuthSchemeParameterException.fullyQualifiedTypeName = "com.amazon.coral.service.http#InvalidAuthSchemeParameterException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidAuthSchemeParameterException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidAuthSchemeParameterException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidauthschemeparameterexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidauthschemeparameterexception = validateInvalidauthschemeparameterexception;

},{"42c78228449dd61e":"9PLBl","d085d1c53aba5190":"eOj61"}],"dZrcy":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMissingrequiredheaderexception = exports.MissingRequiredHeaderException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("456d9bc6630e5c66");
const ihm_js_coral_client_1 = require("ac055e3e9a0469cc");
class MissingRequiredHeaderException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MissingRequiredHeaderException#clone(obj: PlainObjectFrom<MissingRequiredHeaderException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MissingRequiredHeaderException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MissingRequiredHeaderException(obj.message);
    }
    static fromJson(data) {
        return new MissingRequiredHeaderException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MissingRequiredHeaderException = MissingRequiredHeaderException;
MissingRequiredHeaderException.fullyQualifiedTypeName = "com.amazon.coral.service.http#MissingRequiredHeaderException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MissingRequiredHeaderException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MissingRequiredHeaderException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMissingrequiredheaderexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMissingrequiredheaderexception = validateMissingrequiredheaderexception;

},{"456d9bc6630e5c66":"9PLBl","ac055e3e9a0469cc":"eOj61"}],"bXK3T":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMissingauthschemeparameterexception = exports.MissingAuthSchemeParameterException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("1722eb36d764677d");
const ihm_js_coral_client_1 = require("370e68efb0020c57");
class MissingAuthSchemeParameterException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MissingAuthSchemeParameterException#clone(obj: PlainObjectFrom<MissingAuthSchemeParameterException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MissingAuthSchemeParameterException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MissingAuthSchemeParameterException(obj.message);
    }
    static fromJson(data) {
        return new MissingAuthSchemeParameterException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MissingAuthSchemeParameterException = MissingAuthSchemeParameterException;
MissingAuthSchemeParameterException.fullyQualifiedTypeName = "com.amazon.coral.service.http#MissingAuthSchemeParameterException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MissingAuthSchemeParameterException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MissingAuthSchemeParameterException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMissingauthschemeparameterexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMissingauthschemeparameterexception = validateMissingauthschemeparameterexception;

},{"1722eb36d764677d":"9PLBl","370e68efb0020c57":"eOj61"}],"9dPeG":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateMissingmessagedigestexception = exports.MissingMessageDigestException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("d3e4d1464bf593d4");
const ihm_js_coral_client_1 = require("58092a8607374153");
class MissingMessageDigestException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MissingMessageDigestException#clone(obj: PlainObjectFrom<MissingMessageDigestException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of MissingMessageDigestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MissingMessageDigestException(obj.message);
    }
    static fromJson(data) {
        return new MissingMessageDigestException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.MissingMessageDigestException = MissingMessageDigestException;
MissingMessageDigestException.fullyQualifiedTypeName = "com.amazon.coral.service.http#MissingMessageDigestException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(MissingMessageDigestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MissingMessageDigestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateMissingmessagedigestexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateMissingmessagedigestexception = validateMissingmessagedigestexception;

},{"d3e4d1464bf593d4":"9PLBl","58092a8607374153":"eOj61"}],"iBbzU":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateHttpnotfoundexception = exports.HttpNotFoundException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("2feac4849f9baf90");
const ihm_js_coral_client_1 = require("ca24667e7c379d20");
class HttpNotFoundException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the HttpNotFoundException#clone(obj: PlainObjectFrom<HttpNotFoundException>) method.
     */ constructor(__Message){
        super();
        this.Message = __Message;
    }
    /**
     * Create a shallow clone of HttpNotFoundException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new HttpNotFoundException(obj.Message);
    }
    static fromJson(data) {
        return new HttpNotFoundException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message));
    }
    static toJson(data) {
        return Object.assign({
            Message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.Message)
        });
    }
}
exports.HttpNotFoundException = HttpNotFoundException;
HttpNotFoundException.fullyQualifiedTypeName = "com.amazon.coral.service.http#HttpNotFoundException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(HttpNotFoundException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [HttpNotFoundException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateHttpnotfoundexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateHttpnotfoundexception = validateHttpnotfoundexception;

},{"2feac4849f9baf90":"9PLBl","ca24667e7c379d20":"eOj61"}],"bAxMD":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateInvalidauthschemeexception = exports.InvalidAuthSchemeException = void 0;
// Common imports for generated code - may result in unused local variables if imports are unused in certain files
const coral_typescript_types_pieces_1 = require("a0bd2e71b0ea73ba");
const ihm_js_coral_client_1 = require("15e83f4589bed510");
class InvalidAuthSchemeException extends ihm_js_coral_client_1.CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvalidAuthSchemeException#clone(obj: PlainObjectFrom<InvalidAuthSchemeException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of InvalidAuthSchemeException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvalidAuthSchemeException(obj.message);
    }
    static fromJson(data) {
        return new InvalidAuthSchemeException((($$val)=>$$val == undefined ? undefined : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : coral_typescript_types_pieces_1.SerdesUtils.identityFunction($$val))(data.message)
        });
    }
}
exports.InvalidAuthSchemeException = InvalidAuthSchemeException;
InvalidAuthSchemeException.fullyQualifiedTypeName = "com.amazon.coral.service.http#InvalidAuthSchemeException";
// Register concrete types for serialization/deserialization
ihm_js_coral_client_1.modelRegistrySingleton.registerType(InvalidAuthSchemeException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvalidAuthSchemeException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ function validateInvalidauthschemeexception(data) {
    // TODO: Actually implement this!
    return data;
}
exports.validateInvalidauthschemeexception = validateInvalidauthschemeexception;

},{"a0bd2e71b0ea73ba":"9PLBl","15e83f4589bed510":"eOj61"}],"6278u":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _feedbackAcknowledgement = require("./FeedbackAcknowledgement");
parcelHelpers.exportAll(_feedbackAcknowledgement, exports);
var _feedbackAcknowledgementList = require("./FeedbackAcknowledgementList");
parcelHelpers.exportAll(_feedbackAcknowledgementList, exports);
var _feedbackMetaData = require("./FeedbackMetaData");
parcelHelpers.exportAll(_feedbackMetaData, exports);
var _feedbackQueryResponse = require("./FeedbackQueryResponse");
parcelHelpers.exportAll(_feedbackQueryResponse, exports);
var _feedbackQuestion = require("./FeedbackQuestion");
parcelHelpers.exportAll(_feedbackQuestion, exports);
var _getDisplayableFeedbackQuestionnaireRequest = require("./GetDisplayableFeedbackQuestionnaireRequest");
parcelHelpers.exportAll(_getDisplayableFeedbackQuestionnaireRequest, exports);
var _getDisplayableFeedbackQuestionnaireResponse = require("./GetDisplayableFeedbackQuestionnaireResponse");
parcelHelpers.exportAll(_getDisplayableFeedbackQuestionnaireResponse, exports);
var _getFeedbackQuestionnaireRequest = require("./GetFeedbackQuestionnaireRequest");
parcelHelpers.exportAll(_getFeedbackQuestionnaireRequest, exports);
var _getFeedbackQuestionnaireResponse = require("./GetFeedbackQuestionnaireResponse");
parcelHelpers.exportAll(_getFeedbackQuestionnaireResponse, exports);
var _getFeedbacksRequest = require("./GetFeedbacksRequest");
parcelHelpers.exportAll(_getFeedbacksRequest, exports);
var _getFeedbacksResponse = require("./GetFeedbacksResponse");
parcelHelpers.exportAll(_getFeedbacksResponse, exports);
var _multipleChoiceQuestionType = require("./MultipleChoiceQuestionType");
parcelHelpers.exportAll(_multipleChoiceQuestionType, exports);
var _multipleChoiceQuestionTypeResponse = require("./MultipleChoiceQuestionTypeResponse");
parcelHelpers.exportAll(_multipleChoiceQuestionTypeResponse, exports);
var _option = require("./Option");
parcelHelpers.exportAll(_option, exports);
var _optionNumberList = require("./optionNumberList");
parcelHelpers.exportAll(_optionNumberList, exports);
var _optionsList = require("./optionsList");
parcelHelpers.exportAll(_optionsList, exports);
var _questionClassification = require("./QuestionClassification");
parcelHelpers.exportAll(_questionClassification, exports);
var _questionnaire = require("./Questionnaire");
parcelHelpers.exportAll(_questionnaire, exports);
var _questionType = require("./QuestionType");
parcelHelpers.exportAll(_questionType, exports);
var _ratingQuestionType = require("./RatingQuestionType");
parcelHelpers.exportAll(_ratingQuestionType, exports);
var _ratingQuestionTypeResponse = require("./RatingQuestionTypeResponse");
parcelHelpers.exportAll(_ratingQuestionTypeResponse, exports);
var _submitFeedbackRequest = require("./SubmitFeedbackRequest");
parcelHelpers.exportAll(_submitFeedbackRequest, exports);
var _tcfainvalidRequestException = require("./TCFAInvalidRequestException");
parcelHelpers.exportAll(_tcfainvalidRequestException, exports);
var _tcfanonRecoverableException = require("./TCFANonRecoverableException");
parcelHelpers.exportAll(_tcfanonRecoverableException, exports);
var _tcfarecoverableException = require("./TCFARecoverableException");
parcelHelpers.exportAll(_tcfarecoverableException, exports);
var _textQuestionType = require("./TextQuestionType");
parcelHelpers.exportAll(_textQuestionType, exports);
var _textQuestionTypeResponse = require("./TextQuestionTypeResponse");
parcelHelpers.exportAll(_textQuestionTypeResponse, exports);
var _transCustomerFeedbackAggreatorServiceLambda = require("./TransCustomerFeedbackAggreatorServiceLambda");
parcelHelpers.exportAll(_transCustomerFeedbackAggreatorServiceLambda, exports);
var _upsertFeedbackQuestionnaireRequest = require("./UpsertFeedbackQuestionnaireRequest");
parcelHelpers.exportAll(_upsertFeedbackQuestionnaireRequest, exports);
var _userFeedback = require("./UserFeedback");
parcelHelpers.exportAll(_userFeedback, exports);
var _userFeedbackList = require("./UserFeedbackList");
parcelHelpers.exportAll(_userFeedbackList, exports);
var _userIdInformation = require("./UserIdInformation");
parcelHelpers.exportAll(_userIdInformation, exports);

},{"./FeedbackAcknowledgement":"jhMrg","./FeedbackAcknowledgementList":"SlCVB","./FeedbackMetaData":"cYf3u","./FeedbackQueryResponse":"lKLGs","./FeedbackQuestion":"Z873Z","./GetDisplayableFeedbackQuestionnaireRequest":"du7Z6","./GetDisplayableFeedbackQuestionnaireResponse":"hKvr0","./GetFeedbackQuestionnaireRequest":"lGDeU","./GetFeedbackQuestionnaireResponse":"bEj7S","./GetFeedbacksRequest":"4CNjj","./GetFeedbacksResponse":"6mAo0","./MultipleChoiceQuestionType":"3JeIp","./MultipleChoiceQuestionTypeResponse":"9CVV8","./Option":"dYvkW","./optionNumberList":"8MezA","./optionsList":"dw2bl","./QuestionClassification":"7yctH","./Questionnaire":"1dwjQ","./QuestionType":"12uqy","./RatingQuestionType":"kpR6a","./RatingQuestionTypeResponse":"jF1av","./SubmitFeedbackRequest":"jaXWI","./TCFAInvalidRequestException":"aAeTo","./TCFANonRecoverableException":"elHJE","./TCFARecoverableException":"fASdB","./TextQuestionType":"hO8le","./TextQuestionTypeResponse":"kN1LJ","./TransCustomerFeedbackAggreatorServiceLambda":"79QrO","./UpsertFeedbackQuestionnaireRequest":"3bQCc","./UserFeedback":"ieiR8","./UserFeedbackList":"iqnjF","./UserIdInformation":"4XR3w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jhMrg":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This is to store the response of user for a single question.<\/p>
 **/ parcelHelpers.export(exports, "FeedbackAcknowledgement", ()=>FeedbackAcknowledgement);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FeedbackAcknowledgement] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFeedbackacknowledgement", ()=>validateFeedbackacknowledgement);
var _feedbackQueryResponse = require("./FeedbackQueryResponse");
var _feedbackQuestion = require("./FeedbackQuestion");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FeedbackAcknowledgement extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FeedbackAcknowledgement#clone(obj: PlainObjectFrom<FeedbackAcknowledgement>) method.
     */ constructor(__question, __response){
        super();
        this.question = __question;
        this.response = __response;
    }
    /**
     * Create a shallow clone of FeedbackAcknowledgement from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FeedbackAcknowledgement(obj.question, obj.response);
    }
    static fromJson(data) {
        return new FeedbackAcknowledgement((0, _feedbackQuestion.FeedbackQuestion).fromJson(data.question), (0, _feedbackQueryResponse.FeedbackQueryResponse).fromJson(data.response));
    }
    static toJson(data) {
        return Object.assign({
            question: (0, _feedbackQuestion.FeedbackQuestion).toJson(data.question),
            response: (0, _feedbackQueryResponse.FeedbackQueryResponse).toJson(data.response)
        });
    }
}
FeedbackAcknowledgement.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#FeedbackAcknowledgement";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FeedbackAcknowledgement);
function validateFeedbackacknowledgement(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FeedbackQueryResponse":"lKLGs","./FeedbackQuestion":"Z873Z","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lKLGs":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This models the type of response given by user. Since, Smithy does not support inheritance, it suggests the use of Tagged unions through union.<\/p>
 **/ parcelHelpers.export(exports, "FeedbackQueryResponse", ()=>FeedbackQueryResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FeedbackQueryResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFeedbackqueryresponse", ()=>validateFeedbackqueryresponse);
var _textQuestionTypeResponse = require("./TextQuestionTypeResponse");
var _ratingQuestionTypeResponse = require("./RatingQuestionTypeResponse");
var _multipleChoiceQuestionTypeResponse = require("./MultipleChoiceQuestionTypeResponse");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FeedbackQueryResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FeedbackQueryResponse#clone(obj: PlainObjectFrom<FeedbackQueryResponse>) method.
     */ constructor(__multipleChoiceQuestionTypeResponse, __ratingQuestionTypeResponse, __textQuestionTypeResponse){
        super();
        this.multipleChoiceQuestionTypeResponse = __multipleChoiceQuestionTypeResponse;
        this.ratingQuestionTypeResponse = __ratingQuestionTypeResponse;
        this.textQuestionTypeResponse = __textQuestionTypeResponse;
    }
    /**
     * Create a shallow clone of FeedbackQueryResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FeedbackQueryResponse(obj.multipleChoiceQuestionTypeResponse, obj.ratingQuestionTypeResponse, obj.textQuestionTypeResponse);
    }
    static fromJson(data) {
        return new FeedbackQueryResponse((($$val)=>$$val == undefined ? undefined : (0, _multipleChoiceQuestionTypeResponse.MultipleChoiceQuestionTypeResponse).fromJson($$val))(data.multipleChoiceQuestionTypeResponse), (($$val)=>$$val == undefined ? undefined : (0, _ratingQuestionTypeResponse.RatingQuestionTypeResponse).fromJson($$val))(data.ratingQuestionTypeResponse), (($$val)=>$$val == undefined ? undefined : (0, _textQuestionTypeResponse.TextQuestionTypeResponse).fromJson($$val))(data.textQuestionTypeResponse));
    }
    static toJson(data) {
        return Object.assign({
            multipleChoiceQuestionTypeResponse: (($$val)=>$$val == undefined ? null : (0, _multipleChoiceQuestionTypeResponse.MultipleChoiceQuestionTypeResponse).toJson($$val))(data.multipleChoiceQuestionTypeResponse),
            ratingQuestionTypeResponse: (($$val)=>$$val == undefined ? null : (0, _ratingQuestionTypeResponse.RatingQuestionTypeResponse).toJson($$val))(data.ratingQuestionTypeResponse),
            textQuestionTypeResponse: (($$val)=>$$val == undefined ? null : (0, _textQuestionTypeResponse.TextQuestionTypeResponse).toJson($$val))(data.textQuestionTypeResponse)
        });
    }
}
FeedbackQueryResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#FeedbackQueryResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FeedbackQueryResponse);
function validateFeedbackqueryresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TextQuestionTypeResponse":"kN1LJ","./RatingQuestionTypeResponse":"jF1av","./MultipleChoiceQuestionTypeResponse":"9CVV8","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kN1LJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the user's response to a text question.<\/p>
 **/ parcelHelpers.export(exports, "TextQuestionTypeResponse", ()=>TextQuestionTypeResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TextQuestionTypeResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTextquestiontyperesponse", ()=>validateTextquestiontyperesponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TextQuestionTypeResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TextQuestionTypeResponse#clone(obj: PlainObjectFrom<TextQuestionTypeResponse>) method.
     */ constructor(__textQuestionResponse){
        super();
        this.textQuestionResponse = __textQuestionResponse;
    }
    /**
     * Create a shallow clone of TextQuestionTypeResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TextQuestionTypeResponse(obj.textQuestionResponse);
    }
    static fromJson(data) {
        return new TextQuestionTypeResponse((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.textQuestionResponse));
    }
    static toJson(data) {
        return Object.assign({
            textQuestionResponse: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.textQuestionResponse)
        });
    }
}
TextQuestionTypeResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#TextQuestionTypeResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TextQuestionTypeResponse);
function validateTextquestiontyperesponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jF1av":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the user's response to a rating question.<\/p>
 **/ parcelHelpers.export(exports, "RatingQuestionTypeResponse", ()=>RatingQuestionTypeResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RatingQuestionTypeResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRatingquestiontyperesponse", ()=>validateRatingquestiontyperesponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RatingQuestionTypeResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RatingQuestionTypeResponse#clone(obj: PlainObjectFrom<RatingQuestionTypeResponse>) method.
     */ constructor(__ratingQuestionResponse){
        super();
        this.ratingQuestionResponse = __ratingQuestionResponse;
    }
    /**
     * Create a shallow clone of RatingQuestionTypeResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RatingQuestionTypeResponse(obj.ratingQuestionResponse);
    }
    static fromJson(data) {
        return new RatingQuestionTypeResponse((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.ratingQuestionResponse));
    }
    static toJson(data) {
        return Object.assign({
            ratingQuestionResponse: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.ratingQuestionResponse)
        });
    }
}
RatingQuestionTypeResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#RatingQuestionTypeResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RatingQuestionTypeResponse);
function validateRatingquestiontyperesponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CVV8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the option number which user chooses.<\/p>
 **/ parcelHelpers.export(exports, "MultipleChoiceQuestionTypeResponse", ()=>MultipleChoiceQuestionTypeResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MultipleChoiceQuestionTypeResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateMultiplechoicequestiontyperesponse", ()=>validateMultiplechoicequestiontyperesponse);
var _optionNumberList = require("./optionNumberList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class MultipleChoiceQuestionTypeResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MultipleChoiceQuestionTypeResponse#clone(obj: PlainObjectFrom<MultipleChoiceQuestionTypeResponse>) method.
     */ constructor(__multipleChoiceQuestionResponse){
        super();
        this.multipleChoiceQuestionResponse = __multipleChoiceQuestionResponse;
    }
    /**
     * Create a shallow clone of MultipleChoiceQuestionTypeResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MultipleChoiceQuestionTypeResponse(obj.multipleChoiceQuestionResponse);
    }
    static fromJson(data) {
        return new MultipleChoiceQuestionTypeResponse((($$val)=>$$val == undefined ? undefined : (0, _optionNumberList.optionNumberList).fromJson($$val))(data.multipleChoiceQuestionResponse));
    }
    static toJson(data) {
        return Object.assign({
            multipleChoiceQuestionResponse: (($$val)=>$$val == undefined ? null : (0, _optionNumberList.optionNumberList).toJson($$val))(data.multipleChoiceQuestionResponse)
        });
    }
}
MultipleChoiceQuestionTypeResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#MultipleChoiceQuestionTypeResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(MultipleChoiceQuestionTypeResponse);
function validateMultiplechoicequestiontyperesponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./optionNumberList":"8MezA","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MezA":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the list of option numbers which will be returned in multiple choice response<\/p>
 **/ parcelHelpers.export(exports, "optionNumberList", ()=>optionNumberList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [optionNumberList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateOptionnumberlist", ()=>validateOptionnumberlist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class optionNumberList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(optionNumberList.prototype));
    }
    static fromJson(data) {
        return new optionNumberList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateOptionnumberlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Z873Z":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the structure of a single question which will be the part of questionnaire list.<\/p>
 **/ parcelHelpers.export(exports, "FeedbackQuestion", ()=>FeedbackQuestion);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FeedbackQuestion] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFeedbackquestion", ()=>validateFeedbackquestion);
var _questionType = require("./QuestionType");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FeedbackQuestion extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FeedbackQuestion#clone(obj: PlainObjectFrom<FeedbackQuestion>) method.
     */ constructor(__isMandatory, __questionId, __questionText, __questionType, __questionCategory){
        super();
        this.isMandatory = __isMandatory;
        this.questionId = __questionId;
        this.questionText = __questionText;
        this.questionType = __questionType;
        this.questionCategory = __questionCategory;
    }
    /**
     * Create a shallow clone of FeedbackQuestion from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FeedbackQuestion(obj.isMandatory, obj.questionId, obj.questionText, obj.questionType, obj.questionCategory);
    }
    static fromJson(data) {
        return new FeedbackQuestion((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.isMandatory), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.questionId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.questionText), (0, _questionType.QuestionType).fromJson(data.questionType), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.questionCategory));
    }
    static toJson(data) {
        return Object.assign({
            isMandatory: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.isMandatory),
            questionId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.questionId),
            questionText: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.questionText),
            questionType: (0, _questionType.QuestionType).toJson(data.questionType),
            questionCategory: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.questionCategory)
        });
    }
}
FeedbackQuestion.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#FeedbackQuestion";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FeedbackQuestion);
function validateFeedbackquestion(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./QuestionType":"12uqy","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12uqy":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Models different types of question that can present in feedback. Since, Smithy does not support inheritance, it suggests the use of Tagged unions through union.<\/p>
 **/ parcelHelpers.export(exports, "QuestionType", ()=>QuestionType);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [QuestionType] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateQuestiontype", ()=>validateQuestiontype);
var _textQuestionType = require("./TextQuestionType");
var _multipleChoiceQuestionType = require("./MultipleChoiceQuestionType");
var _ratingQuestionType = require("./RatingQuestionType");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class QuestionType extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the QuestionType#clone(obj: PlainObjectFrom<QuestionType>) method.
     */ constructor(__multipleChoiceQuestionType, __ratingQuestionType, __textQuestionType){
        super();
        this.multipleChoiceQuestionType = __multipleChoiceQuestionType;
        this.ratingQuestionType = __ratingQuestionType;
        this.textQuestionType = __textQuestionType;
    }
    /**
     * Create a shallow clone of QuestionType from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new QuestionType(obj.multipleChoiceQuestionType, obj.ratingQuestionType, obj.textQuestionType);
    }
    static fromJson(data) {
        return new QuestionType((($$val)=>$$val == undefined ? undefined : (0, _multipleChoiceQuestionType.MultipleChoiceQuestionType).fromJson($$val))(data.multipleChoiceQuestionType), (($$val)=>$$val == undefined ? undefined : (0, _ratingQuestionType.RatingQuestionType).fromJson($$val))(data.ratingQuestionType), (($$val)=>$$val == undefined ? undefined : (0, _textQuestionType.TextQuestionType).fromJson($$val))(data.textQuestionType));
    }
    static toJson(data) {
        return Object.assign({
            multipleChoiceQuestionType: (($$val)=>$$val == undefined ? null : (0, _multipleChoiceQuestionType.MultipleChoiceQuestionType).toJson($$val))(data.multipleChoiceQuestionType),
            ratingQuestionType: (($$val)=>$$val == undefined ? null : (0, _ratingQuestionType.RatingQuestionType).toJson($$val))(data.ratingQuestionType),
            textQuestionType: (($$val)=>$$val == undefined ? null : (0, _textQuestionType.TextQuestionType).toJson($$val))(data.textQuestionType)
        });
    }
}
QuestionType.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#QuestionType";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(QuestionType);
function validateQuestiontype(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TextQuestionType":"hO8le","./MultipleChoiceQuestionType":"3JeIp","./RatingQuestionType":"kpR6a","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hO8le":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the text question, which will allow users to provide text answers to the question. There will be a limit
 * on the number of words which user can enter, and that will be determined by wordLimit.<\/p>
 **/ parcelHelpers.export(exports, "TextQuestionType", ()=>TextQuestionType);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TextQuestionType] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTextquestiontype", ()=>validateTextquestiontype);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TextQuestionType extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TextQuestionType#clone(obj: PlainObjectFrom<TextQuestionType>) method.
     */ constructor(__wordLimit, __charLimit){
        super();
        this.wordLimit = __wordLimit;
        this.charLimit = __charLimit;
    }
    /**
     * Create a shallow clone of TextQuestionType from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TextQuestionType(obj.wordLimit, obj.charLimit);
    }
    static fromJson(data) {
        return new TextQuestionType((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.wordLimit), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.charLimit));
    }
    static toJson(data) {
        return Object.assign({
            wordLimit: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.wordLimit),
            charLimit: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.charLimit)
        });
    }
}
TextQuestionType.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#TextQuestionType";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TextQuestionType);
function validateTextquestiontype(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3JeIp":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the multiple choice question type, which can be used to provide different options to choose from.<\/p>
 **/ parcelHelpers.export(exports, "MultipleChoiceQuestionType", ()=>MultipleChoiceQuestionType);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MultipleChoiceQuestionType] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateMultiplechoicequestiontype", ()=>validateMultiplechoicequestiontype);
var _optionsList = require("./optionsList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class MultipleChoiceQuestionType extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MultipleChoiceQuestionType#clone(obj: PlainObjectFrom<MultipleChoiceQuestionType>) method.
     */ constructor(__options, __isMultiSelect){
        super();
        this.options = __options;
        this.isMultiSelect = __isMultiSelect;
    }
    /**
     * Create a shallow clone of MultipleChoiceQuestionType from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MultipleChoiceQuestionType(obj.options, obj.isMultiSelect);
    }
    static fromJson(data) {
        return new MultipleChoiceQuestionType((0, _optionsList.optionsList).fromJson(data.options), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isMultiSelect));
    }
    static toJson(data) {
        return Object.assign({
            options: (0, _optionsList.optionsList).toJson(data.options),
            isMultiSelect: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isMultiSelect)
        });
    }
}
MultipleChoiceQuestionType.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#MultipleChoiceQuestionType";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(MultipleChoiceQuestionType);
function validateMultiplechoicequestiontype(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./optionsList":"dw2bl","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dw2bl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the list of options which will be displayed in multiple choice question.<\/p>
 **/ parcelHelpers.export(exports, "optionsList", ()=>optionsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [optionsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateOptionslist", ()=>validateOptionslist);
var _option = require("./Option");
class optionsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(optionsList.prototype));
    }
    static fromJson(data) {
        return new optionsList(data.map((datum)=>(0, _option.Option).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _option.Option).toJson(datum));
    }
}
function validateOptionslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Option":"dYvkW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYvkW":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the structure of a single option in multiple choice question<\/p>
 **/ parcelHelpers.export(exports, "Option", ()=>Option);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Option] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateOption", ()=>validateOption);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Option extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Option#clone(obj: PlainObjectFrom<Option>) method.
     */ constructor(__optionNumber, __optionValue){
        super();
        this.optionNumber = __optionNumber;
        this.optionValue = __optionValue;
    }
    /**
     * Create a shallow clone of Option from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Option(obj.optionNumber, obj.optionValue);
    }
    static fromJson(data) {
        return new Option((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.optionNumber), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.optionValue));
    }
    static toJson(data) {
        return Object.assign({
            optionNumber: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.optionNumber),
            optionValue: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.optionValue)
        });
    }
}
Option.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#Option";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Option);
function validateOption(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kpR6a":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the rating question, which can be of two types visual and numerical.<\/p>
 **/ parcelHelpers.export(exports, "RatingQuestionType", ()=>RatingQuestionType);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RatingQuestionType] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRatingquestiontype", ()=>validateRatingquestiontype);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RatingQuestionType extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RatingQuestionType#clone(obj: PlainObjectFrom<RatingQuestionType>) method.
     */ constructor(__isVisualRatingType, __minRatingValue, __numberOfIntervals, __ratingInterval, __questionClassification){
        super();
        this.isVisualRatingType = __isVisualRatingType;
        this.minRatingValue = __minRatingValue;
        this.numberOfIntervals = __numberOfIntervals;
        this.ratingInterval = __ratingInterval;
        this.questionClassification = __questionClassification;
    }
    /**
     * Create a shallow clone of RatingQuestionType from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RatingQuestionType(obj.isVisualRatingType, obj.minRatingValue, obj.numberOfIntervals, obj.ratingInterval, obj.questionClassification);
    }
    static fromJson(data) {
        return new RatingQuestionType((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.isVisualRatingType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.minRatingValue), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.numberOfIntervals), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.ratingInterval), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.questionClassification));
    }
    static toJson(data) {
        return Object.assign({
            isVisualRatingType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.isVisualRatingType),
            minRatingValue: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.minRatingValue),
            numberOfIntervals: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.numberOfIntervals),
            ratingInterval: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.ratingInterval),
            questionClassification: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.questionClassification)
        });
    }
}
RatingQuestionType.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#RatingQuestionType";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RatingQuestionType);
function validateRatingquestiontype(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"SlCVB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This is to store the response of user for the questionnaires in the feedback.<\/p>
 **/ parcelHelpers.export(exports, "FeedbackAcknowledgementList", ()=>FeedbackAcknowledgementList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FeedbackAcknowledgementList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFeedbackacknowledgementlist", ()=>validateFeedbackacknowledgementlist);
var _feedbackAcknowledgement = require("./FeedbackAcknowledgement");
class FeedbackAcknowledgementList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FeedbackAcknowledgementList.prototype));
    }
    static fromJson(data) {
        return new FeedbackAcknowledgementList(data.map((datum)=>(0, _feedbackAcknowledgement.FeedbackAcknowledgement).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _feedbackAcknowledgement.FeedbackAcknowledgement).toJson(datum));
    }
}
function validateFeedbackacknowledgementlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FeedbackAcknowledgement":"jhMrg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYf3u":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This is to store the metadata for responses. For example userId,URL from which feedback submitted.<\/p>
 **/ parcelHelpers.export(exports, "FeedbackMetaData", ()=>FeedbackMetaData);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FeedbackMetaData] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFeedbackmetadata", ()=>validateFeedbackmetadata);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FeedbackMetaData extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FeedbackMetaData#clone(obj: PlainObjectFrom<FeedbackMetaData>) method.
     */ constructor(__isAnonymous, __responseCollectionDurationInMilliSecond, __responseTimestamp, __applicationId, __feedbackIntent, __feedbackSubmissionPageIdentifier, __feedbackSubmissionURL, __userId){
        super();
        this.isAnonymous = __isAnonymous;
        this.responseCollectionDurationInMilliSecond = __responseCollectionDurationInMilliSecond;
        this.responseTimestamp = __responseTimestamp;
        this.applicationId = __applicationId;
        this.feedbackIntent = __feedbackIntent;
        this.feedbackSubmissionPageIdentifier = __feedbackSubmissionPageIdentifier;
        this.feedbackSubmissionURL = __feedbackSubmissionURL;
        this.userId = __userId;
    }
    /**
     * Create a shallow clone of FeedbackMetaData from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FeedbackMetaData(obj.isAnonymous, obj.responseCollectionDurationInMilliSecond, obj.responseTimestamp, obj.applicationId, obj.feedbackIntent, obj.feedbackSubmissionPageIdentifier, obj.feedbackSubmissionURL, obj.userId);
    }
    static fromJson(data) {
        return new FeedbackMetaData((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.isAnonymous), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.responseCollectionDurationInMilliSecond), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.responseTimestamp), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.applicationId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackIntent), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackSubmissionPageIdentifier), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackSubmissionURL), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userId));
    }
    static toJson(data) {
        return Object.assign({
            isAnonymous: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.isAnonymous),
            responseCollectionDurationInMilliSecond: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.responseCollectionDurationInMilliSecond),
            responseTimestamp: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.responseTimestamp),
            applicationId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.applicationId),
            feedbackIntent: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackIntent),
            feedbackSubmissionPageIdentifier: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackSubmissionPageIdentifier),
            feedbackSubmissionURL: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackSubmissionURL),
            userId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userId)
        });
    }
}
FeedbackMetaData.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#FeedbackMetaData";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FeedbackMetaData);
function validateFeedbackmetadata(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"du7Z6":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This structure defines the input parameters required for making the getDisplayableFeedbackQuestionnaire API call.<\/p>
 **/ parcelHelpers.export(exports, "GetDisplayableFeedbackQuestionnaireRequest", ()=>GetDisplayableFeedbackQuestionnaireRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetDisplayableFeedbackQuestionnaireRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetdisplayablefeedbackquestionnairerequest", ()=>validateGetdisplayablefeedbackquestionnairerequest);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetDisplayableFeedbackQuestionnaireRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetDisplayableFeedbackQuestionnaireRequest#clone(obj: PlainObjectFrom<GetDisplayableFeedbackQuestionnaireRequest>) method.
     */ constructor(__applicationId, __feedbackIntent, __customerId, __userSessionAttributes){
        super();
        this.applicationId = __applicationId;
        this.feedbackIntent = __feedbackIntent;
        this.customerId = __customerId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of GetDisplayableFeedbackQuestionnaireRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetDisplayableFeedbackQuestionnaireRequest(obj.applicationId, obj.feedbackIntent, obj.customerId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new GetDisplayableFeedbackQuestionnaireRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            applicationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId),
            feedbackIntent: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
GetDisplayableFeedbackQuestionnaireRequest.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#GetDisplayableFeedbackQuestionnaireRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetDisplayableFeedbackQuestionnaireRequest);
function validateGetdisplayablefeedbackquestionnairerequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hKvr0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This structure defines the output of the getDisplayableFeedbackQuestionnaire API call,
 * which will be a list of questions to be displayed on feedback form and a boolean which decides whther
 * to display the feedback or not.
 * As its not user friendly to provide feedback for every request we have decided to display feedback only after specific
 * period of time and based on the time IsDisplayable parameter is set to either true\/false. Only when IsDisplayable is
 * set to true user will be asked to provide feedback<\/p>
 **/ parcelHelpers.export(exports, "GetDisplayableFeedbackQuestionnaireResponse", ()=>GetDisplayableFeedbackQuestionnaireResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetDisplayableFeedbackQuestionnaireResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetdisplayablefeedbackquestionnaireresponse", ()=>validateGetdisplayablefeedbackquestionnaireresponse);
var _questionnaire = require("./Questionnaire");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetDisplayableFeedbackQuestionnaireResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetDisplayableFeedbackQuestionnaireResponse#clone(obj: PlainObjectFrom<GetDisplayableFeedbackQuestionnaireResponse>) method.
     */ constructor(__display, __questionnaire){
        super();
        this.display = __display;
        this.questionnaire = __questionnaire;
    }
    /**
     * Create a shallow clone of GetDisplayableFeedbackQuestionnaireResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetDisplayableFeedbackQuestionnaireResponse(obj.display, obj.questionnaire);
    }
    static fromJson(data) {
        return new GetDisplayableFeedbackQuestionnaireResponse((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.display), (($$val)=>$$val == undefined ? undefined : (0, _questionnaire.Questionnaire).fromJson($$val))(data.questionnaire));
    }
    static toJson(data) {
        return Object.assign({
            display: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.display),
            questionnaire: (($$val)=>$$val == undefined ? null : (0, _questionnaire.Questionnaire).toJson($$val))(data.questionnaire)
        });
    }
}
GetDisplayableFeedbackQuestionnaireResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#GetDisplayableFeedbackQuestionnaireResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetDisplayableFeedbackQuestionnaireResponse);
function validateGetdisplayablefeedbackquestionnaireresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Questionnaire":"1dwjQ","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1dwjQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents a list of questionnaire which will be displayed to user.<\/p>
 **/ parcelHelpers.export(exports, "Questionnaire", ()=>Questionnaire);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Questionnaire] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateQuestionnaire", ()=>validateQuestionnaire);
var _feedbackQuestion = require("./FeedbackQuestion");
class Questionnaire extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(Questionnaire.prototype));
    }
    static fromJson(data) {
        return new Questionnaire(data.map((datum)=>(0, _feedbackQuestion.FeedbackQuestion).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _feedbackQuestion.FeedbackQuestion).toJson(datum));
    }
}
function validateQuestionnaire(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FeedbackQuestion":"Z873Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGDeU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This structure defines the input parameters required for making the getFeedbackQuestionnaire API call.<\/p>
 **/ parcelHelpers.export(exports, "GetFeedbackQuestionnaireRequest", ()=>GetFeedbackQuestionnaireRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetFeedbackQuestionnaireRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetfeedbackquestionnairerequest", ()=>validateGetfeedbackquestionnairerequest);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetFeedbackQuestionnaireRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetFeedbackQuestionnaireRequest#clone(obj: PlainObjectFrom<GetFeedbackQuestionnaireRequest>) method.
     */ constructor(__applicationId, __feedbackIntent){
        super();
        this.applicationId = __applicationId;
        this.feedbackIntent = __feedbackIntent;
    }
    /**
     * Create a shallow clone of GetFeedbackQuestionnaireRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetFeedbackQuestionnaireRequest(obj.applicationId, obj.feedbackIntent);
    }
    static fromJson(data) {
        return new GetFeedbackQuestionnaireRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent));
    }
    static toJson(data) {
        return Object.assign({
            applicationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId),
            feedbackIntent: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent)
        });
    }
}
GetFeedbackQuestionnaireRequest.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#GetFeedbackQuestionnaireRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetFeedbackQuestionnaireRequest);
function validateGetfeedbackquestionnairerequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEj7S":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This structure defines the output of the getFeedbackQuestionnaire API call, which will be a list of questions to be displayed on feedback form.<\/p>
 **/ parcelHelpers.export(exports, "GetFeedbackQuestionnaireResponse", ()=>GetFeedbackQuestionnaireResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetFeedbackQuestionnaireResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetfeedbackquestionnaireresponse", ()=>validateGetfeedbackquestionnaireresponse);
var _questionnaire = require("./Questionnaire");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetFeedbackQuestionnaireResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetFeedbackQuestionnaireResponse#clone(obj: PlainObjectFrom<GetFeedbackQuestionnaireResponse>) method.
     */ constructor(__questionnaire){
        super();
        this.questionnaire = __questionnaire;
    }
    /**
     * Create a shallow clone of GetFeedbackQuestionnaireResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetFeedbackQuestionnaireResponse(obj.questionnaire);
    }
    static fromJson(data) {
        return new GetFeedbackQuestionnaireResponse((0, _questionnaire.Questionnaire).fromJson(data.questionnaire));
    }
    static toJson(data) {
        return Object.assign({
            questionnaire: (0, _questionnaire.Questionnaire).toJson(data.questionnaire)
        });
    }
}
GetFeedbackQuestionnaireResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#GetFeedbackQuestionnaireResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetFeedbackQuestionnaireResponse);
function validateGetfeedbackquestionnaireresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Questionnaire":"1dwjQ","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CNjj":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>This structure defines the input parameters required for making the getFeedbacks API call.
 * applicationId- Required - Unique Id of the application for which feedbacks will be fetched
 * pageToken - Optional - indicates identifier for the page to be fetched. If pageToken is null, the first
 * page is fetched.
 * PageSize - Optional - indicates number of feedbacks to be fetched in a page
 * feedbackIntent- Optional - Represents the type of feedback. If not passed, all the feedbacks will be fetched
 * for the given applicationId
 * startDate, endDate - Represents the range( both date inclusive) for which feedback will be fetched.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetFeedbacksRequest", ()=>GetFeedbacksRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetFeedbacksRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetfeedbacksrequest", ()=>validateGetfeedbacksrequest);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetFeedbacksRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetFeedbacksRequest#clone(obj: PlainObjectFrom<GetFeedbacksRequest>) method.
     */ constructor(__applicationId, __endDate, __startDate, __feedbackIntent, __pageSize, __pageToken){
        super();
        this.applicationId = __applicationId;
        this.endDate = __endDate;
        this.startDate = __startDate;
        this.feedbackIntent = __feedbackIntent;
        this.pageSize = __pageSize;
        this.pageToken = __pageToken;
    }
    /**
     * Create a shallow clone of GetFeedbacksRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetFeedbacksRequest(obj.applicationId, obj.endDate, obj.startDate, obj.feedbackIntent, obj.pageSize, obj.pageToken);
    }
    static fromJson(data) {
        return new GetFeedbacksRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId), (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate(data.endDate), (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate(data.startDate), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackIntent), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pageSize), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pageToken));
    }
    static toJson(data) {
        return Object.assign({
            applicationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId),
            endDate: (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson(data.endDate),
            startDate: (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson(data.startDate),
            feedbackIntent: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.feedbackIntent),
            pageSize: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pageSize),
            pageToken: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pageToken)
        });
    }
}
GetFeedbacksRequest.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#GetFeedbacksRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetFeedbacksRequest);
function validateGetfeedbacksrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6mAo0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>This structure defines the output of the getFeedbacksAPI call.
 * userFeedbackList - Represents the feedbacks fetched for given input
 * nextPageToken - indicates identifier for the next page. If nextPageToken is null, this means there is no more data
 * available for the given input.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetFeedbacksResponse", ()=>GetFeedbacksResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetFeedbacksResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetfeedbacksresponse", ()=>validateGetfeedbacksresponse);
var _userFeedbackList = require("./UserFeedbackList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetFeedbacksResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetFeedbacksResponse#clone(obj: PlainObjectFrom<GetFeedbacksResponse>) method.
     */ constructor(__userFeedbackList, __nextPageToken){
        super();
        this.userFeedbackList = __userFeedbackList;
        this.nextPageToken = __nextPageToken;
    }
    /**
     * Create a shallow clone of GetFeedbacksResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetFeedbacksResponse(obj.userFeedbackList, obj.nextPageToken);
    }
    static fromJson(data) {
        return new GetFeedbacksResponse((0, _userFeedbackList.UserFeedbackList).fromJson(data.userFeedbackList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.nextPageToken));
    }
    static toJson(data) {
        return Object.assign({
            userFeedbackList: (0, _userFeedbackList.UserFeedbackList).toJson(data.userFeedbackList),
            nextPageToken: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.nextPageToken)
        });
    }
}
GetFeedbacksResponse.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#GetFeedbacksResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetFeedbacksResponse);
function validateGetfeedbacksresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserFeedbackList":"iqnjF","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqnjF":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the list of feedbacks which will be returned by getFeedbacks API<\/p>
 **/ parcelHelpers.export(exports, "UserFeedbackList", ()=>UserFeedbackList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserFeedbackList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUserfeedbacklist", ()=>validateUserfeedbacklist);
var _userFeedback = require("./UserFeedback");
class UserFeedbackList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(UserFeedbackList.prototype));
    }
    static fromJson(data) {
        return new UserFeedbackList(data.map((datum)=>(0, _userFeedback.UserFeedback).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _userFeedback.UserFeedback).toJson(datum));
    }
}
function validateUserfeedbacklist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserFeedback":"ieiR8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ieiR8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This represents the response given by the user to the feedback questionnaire.<\/p>
 **/ parcelHelpers.export(exports, "UserFeedback", ()=>UserFeedback);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserFeedback] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUserfeedback", ()=>validateUserfeedback);
var _feedbackMetaData = require("./FeedbackMetaData");
var _feedbackAcknowledgementList = require("./FeedbackAcknowledgementList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UserFeedback extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UserFeedback#clone(obj: PlainObjectFrom<UserFeedback>) method.
     */ constructor(__acknowledgements, __metaData){
        super();
        this.acknowledgements = __acknowledgements;
        this.metaData = __metaData;
    }
    /**
     * Create a shallow clone of UserFeedback from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UserFeedback(obj.acknowledgements, obj.metaData);
    }
    static fromJson(data) {
        return new UserFeedback((0, _feedbackAcknowledgementList.FeedbackAcknowledgementList).fromJson(data.acknowledgements), (0, _feedbackMetaData.FeedbackMetaData).fromJson(data.metaData));
    }
    static toJson(data) {
        return Object.assign({
            acknowledgements: (0, _feedbackAcknowledgementList.FeedbackAcknowledgementList).toJson(data.acknowledgements),
            metaData: (0, _feedbackMetaData.FeedbackMetaData).toJson(data.metaData)
        });
    }
}
UserFeedback.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#UserFeedback";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UserFeedback);
function validateUserfeedback(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FeedbackMetaData":"cYf3u","./FeedbackAcknowledgementList":"SlCVB","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7yctH":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Classification of questions based on customer satisfaction\/effort<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuestionClassification", ()=>QuestionClassification);
var QuestionClassification;
(function(QuestionClassification) {
    QuestionClassification["CUSTOMER_SATISFACTION_QUESTION"] = "CustomerSatisfactionQuestion";
    QuestionClassification["CUSTOMER_EFFORT_QUESTION"] = "CustomerEffortQuestion";
})(QuestionClassification || (QuestionClassification = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jaXWI":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This structure defines the input parameters required for making the submitFeedback API call.<\/p>
 **/ parcelHelpers.export(exports, "SubmitFeedbackRequest", ()=>SubmitFeedbackRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SubmitFeedbackRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSubmitfeedbackrequest", ()=>validateSubmitfeedbackrequest);
var _userFeedback = require("./UserFeedback");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SubmitFeedbackRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SubmitFeedbackRequest#clone(obj: PlainObjectFrom<SubmitFeedbackRequest>) method.
     */ constructor(__applicationId, __feedbackIntent, __userFeedback, __customerId, __sifProfileId, __userSessionAttributes){
        super();
        this.applicationId = __applicationId;
        this.feedbackIntent = __feedbackIntent;
        this.userFeedback = __userFeedback;
        this.customerId = __customerId;
        this.sifProfileId = __sifProfileId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of SubmitFeedbackRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SubmitFeedbackRequest(obj.applicationId, obj.feedbackIntent, obj.userFeedback, obj.customerId, obj.sifProfileId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new SubmitFeedbackRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent), (0, _userFeedback.UserFeedback).fromJson(data.userFeedback), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.sifProfileId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            applicationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId),
            feedbackIntent: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent),
            userFeedback: (0, _userFeedback.UserFeedback).toJson(data.userFeedback),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            sifProfileId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.sifProfileId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
SubmitFeedbackRequest.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#SubmitFeedbackRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SubmitFeedbackRequest);
function validateSubmitfeedbackrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserFeedback":"ieiR8","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aAeTo":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on receiving invalid request which cannot be processed by service.<\/p>
 **/ parcelHelpers.export(exports, "TCFAInvalidRequestException", ()=>TCFAInvalidRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TCFAInvalidRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTcfainvalidrequestexception", ()=>validateTcfainvalidrequestexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TCFAInvalidRequestException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TCFAInvalidRequestException#clone(obj: PlainObjectFrom<TCFAInvalidRequestException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of TCFAInvalidRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TCFAInvalidRequestException(obj.message);
    }
    static fromJson(data) {
        return new TCFAInvalidRequestException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TCFAInvalidRequestException.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#TCFAInvalidRequestException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TCFAInvalidRequestException);
function validateTcfainvalidrequestexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"elHJE":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on non-retryable error in the service or its dependencies.<\/p>
 **/ parcelHelpers.export(exports, "TCFANonRecoverableException", ()=>TCFANonRecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TCFANonRecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTcfanonrecoverableexception", ()=>validateTcfanonrecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TCFANonRecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TCFANonRecoverableException#clone(obj: PlainObjectFrom<TCFANonRecoverableException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of TCFANonRecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TCFANonRecoverableException(obj.message);
    }
    static fromJson(data) {
        return new TCFANonRecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TCFANonRecoverableException.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#TCFANonRecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TCFANonRecoverableException);
function validateTcfanonrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fASdB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on a re-tryable error in the service<\/p>
 **/ parcelHelpers.export(exports, "TCFARecoverableException", ()=>TCFARecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TCFARecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTcfarecoverableexception", ()=>validateTcfarecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TCFARecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TCFARecoverableException#clone(obj: PlainObjectFrom<TCFARecoverableException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of TCFARecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TCFARecoverableException(obj.message);
    }
    static fromJson(data) {
        return new TCFARecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TCFARecoverableException.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#TCFARecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TCFARecoverableException);
function validateTcfarecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"79QrO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transCustomerFeedbackAggreatorServiceLambdaSerdesInterceptor", ()=>transCustomerFeedbackAggreatorServiceLambdaSerdesInterceptor);
parcelHelpers.export(exports, "transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor", ()=>transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor);
/**
 * <p>This service will implement a generic feedback module, which will allow users to provide their feedback.<\/p>
 **/ parcelHelpers.export(exports, "TransCustomerFeedbackAggreatorServiceLambda", ()=>TransCustomerFeedbackAggreatorServiceLambda);
var _coralComAmazonCoralAvailability = require("@amzn/coral_com-amazon-coral-availability");
var _coralComAmazonCoralServiceBsf = require("@amzn/coral_com-amazon-coral-service-bsf");
var _coralComAmazonCoralClient = require("@amzn/coral_com-amazon-coral-client");
var _coralComAmazonCoralService = require("@amzn/coral_com-amazon-coral-service");
var _getFeedbacksResponse = require("./GetFeedbacksResponse");
var _getDisplayableFeedbackQuestionnaireRequest = require("./GetDisplayableFeedbackQuestionnaireRequest");
var _getFeedbackQuestionnaireRequest = require("./GetFeedbackQuestionnaireRequest");
var _upsertFeedbackQuestionnaireRequest = require("./UpsertFeedbackQuestionnaireRequest");
var _getDisplayableFeedbackQuestionnaireResponse = require("./GetDisplayableFeedbackQuestionnaireResponse");
var _tcfainvalidRequestException = require("./TCFAInvalidRequestException");
var _tcfanonRecoverableException = require("./TCFANonRecoverableException");
var _tcfarecoverableException = require("./TCFARecoverableException");
var _getFeedbacksRequest = require("./GetFeedbacksRequest");
var _submitFeedbackRequest = require("./SubmitFeedbackRequest");
var _getFeedbackQuestionnaireResponse = require("./GetFeedbackQuestionnaireResponse");
var _coralComAmazonCoralServiceJms = require("@amzn/coral_com-amazon-coral-service-jms");
var _coralComAmazonCoralValidate = require("@amzn/coral_com-amazon-coral-validate");
var _coralComAmazonCoralServiceHttp = require("@amzn/coral_com-amazon-coral-service-http");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const transCustomerFeedbackAggreatorServiceLambdaSerdesInterceptor = new (0, _ihmJsCoralClient.CoralClientSerdesInterceptor)({
    GetDisplayableFeedbackQuestionnaire: {
        deserializationFn: (0, _getDisplayableFeedbackQuestionnaireResponse.GetDisplayableFeedbackQuestionnaireResponse).fromJson,
        serializationFn: (0, _getDisplayableFeedbackQuestionnaireRequest.GetDisplayableFeedbackQuestionnaireRequest).toJson,
        modelledExceptions: [
            (0, _tcfainvalidRequestException.TCFAInvalidRequestException),
            (0, _tcfarecoverableException.TCFARecoverableException),
            (0, _tcfanonRecoverableException.TCFANonRecoverableException)
        ]
    },
    GetFeedbackQuestionnaire: {
        deserializationFn: (0, _getFeedbackQuestionnaireResponse.GetFeedbackQuestionnaireResponse).fromJson,
        serializationFn: (0, _getFeedbackQuestionnaireRequest.GetFeedbackQuestionnaireRequest).toJson,
        modelledExceptions: [
            (0, _tcfainvalidRequestException.TCFAInvalidRequestException),
            (0, _tcfarecoverableException.TCFARecoverableException),
            (0, _tcfanonRecoverableException.TCFANonRecoverableException)
        ]
    },
    GetFeedbacks: {
        deserializationFn: (0, _getFeedbacksResponse.GetFeedbacksResponse).fromJson,
        serializationFn: (0, _getFeedbacksRequest.GetFeedbacksRequest).toJson,
        modelledExceptions: [
            (0, _tcfainvalidRequestException.TCFAInvalidRequestException),
            (0, _tcfarecoverableException.TCFARecoverableException),
            (0, _tcfanonRecoverableException.TCFANonRecoverableException)
        ]
    },
    SubmitFeedback: {
        serializationFn: (0, _submitFeedbackRequest.SubmitFeedbackRequest).toJson,
        modelledExceptions: [
            (0, _tcfainvalidRequestException.TCFAInvalidRequestException),
            (0, _tcfarecoverableException.TCFARecoverableException),
            (0, _tcfanonRecoverableException.TCFANonRecoverableException)
        ]
    },
    UpsertFeedbackQuestionnaire: {
        serializationFn: (0, _upsertFeedbackQuestionnaireRequest.UpsertFeedbackQuestionnaireRequest).toJson,
        modelledExceptions: [
            (0, _tcfainvalidRequestException.TCFAInvalidRequestException),
            (0, _tcfarecoverableException.TCFARecoverableException),
            (0, _tcfanonRecoverableException.TCFANonRecoverableException)
        ]
    }
}, [
    _coralComAmazonCoralAvailability.BackOffException,
    _coralComAmazonCoralAvailability.ThrottlingException,
    _coralComAmazonCoralClient.ClientUnavailableException,
    _coralComAmazonCoralClient.HttpConnectionTimeoutException,
    _coralComAmazonCoralClient.HttpFailureException,
    _coralComAmazonCoralClient.HttpTimeoutException,
    _coralComAmazonCoralServiceBsf.InvalidCodigoMessageException,
    _coralComAmazonCoralServiceHttp.HeaderMisclassificationException,
    _coralComAmazonCoralServiceHttp.HttpNotFoundException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.InvalidMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.MissingMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingRequiredHeaderException,
    _coralComAmazonCoralServiceJms.MessageProcessingException,
    _coralComAmazonCoralServiceJms.MessagePublishException,
    _coralComAmazonCoralService.AccessDeniedException,
    _coralComAmazonCoralService.DelegationException,
    _coralComAmazonCoralService.ExpiredTokenException,
    _coralComAmazonCoralService.IncompleteSignatureException,
    _coralComAmazonCoralService.InternalFailure,
    _coralComAmazonCoralService.InvalidAwsQueryStringException,
    _coralComAmazonCoralService.InvalidParameterCombinationException,
    _coralComAmazonCoralService.InvalidParameterValueException,
    _coralComAmazonCoralService.InvalidQueryParameterException,
    _coralComAmazonCoralService.InvalidQueryStringException,
    _coralComAmazonCoralService.InvalidSignatureException,
    _coralComAmazonCoralService.MalformedHttpRequestException,
    _coralComAmazonCoralService.MissingActionException,
    _coralComAmazonCoralService.MissingAuthenticationTokenException,
    _coralComAmazonCoralService.MissingRequiredParameterException,
    _coralComAmazonCoralService.NotAuthorizedException,
    _coralComAmazonCoralService.RequestAbortedException,
    _coralComAmazonCoralService.RequestEntityTooLargeException,
    _coralComAmazonCoralService.RequestExpiredException,
    _coralComAmazonCoralService.RequestTimeoutException,
    _coralComAmazonCoralService.SerializationException,
    _coralComAmazonCoralService.ServiceUnavailableException,
    _coralComAmazonCoralService.SubscriptionRequiredException,
    _coralComAmazonCoralService.TimeoutException,
    _coralComAmazonCoralService.TransmutationException,
    _coralComAmazonCoralService.UnknownOperationException,
    _coralComAmazonCoralService.UnrecognizedClientException,
    _coralComAmazonCoralService.UnsupportedMediaTypeException,
    _coralComAmazonCoralValidate.ValidationException
]);
const transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor = new (0, _ihmJsCoralClient.CoralClientHttpBindingInterceptor)({
    GetDisplayableFeedbackQuestionnaire: {
        method: "GET",
        path: "/displayable-questionnaire/v1/applications/{applicationId}/intents/{feedbackIntent}/",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    },
    GetFeedbackQuestionnaire: {
        method: "GET",
        path: "/questionnaires/v1/applications/{applicationId}/intents/{feedbackIntent}",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    },
    GetFeedbacks: {
        method: "GET",
        path: "/feedbacks/v1/applications/{applicationId}?endDate={endDate}&feedbackIntent={feedbackIntent}&pageSize={pageSize}&pageToken={pageToken}&startDate={startDate}",
        labelTransformations: {
            pageSize: "pageSize",
            pageToken: "pageToken",
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    },
    SubmitFeedback: {
        method: "POST",
        path: "/feedbacks/v1/applications/{applicationId}/intents/{feedbackIntent}?sif_profile={sifProfileId}",
        labelTransformations: {
            sifProfileId: "sifProfileId",
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    },
    UpsertFeedbackQuestionnaire: {
        method: "POST",
        path: "/questionnaires/v1/applications/{applicationId}/intents/{feedbackIntent}",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent"
        }
    }
});
class TransCustomerFeedbackAggreatorServiceLambda extends (0, _ihmJsCoralClient.CoralClient) {
    constructor(config, handler){
        const serdesHandler = new (0, _ihmJsCoralClient.InterceptingHandler)(handler, [
            transCustomerFeedbackAggreatorServiceLambdaSerdesInterceptor
        ]);
        super(config, serdesHandler);
    }
    /**
     * <p>getDisplayableFeedbackQuestionnaire will be used to get eligible questionnaire from DDB Table<\/p>
     **/ getDisplayableFeedbackQuestionnaire(request) {
        return super.call("GetDisplayableFeedbackQuestionnaire", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getDisplayableFeedbackQuestionnaireResponse.GetDisplayableFeedbackQuestionnaireResponse))) throw new TypeError(`[TransCustomerFeedbackAggreatorServiceLambda] Expected response body to be of type GetDisplayableFeedbackQuestionnaireResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>Get Feedback Questionnaire based on applicationId and feedbackIntent. Each service using feedback module
     * will have a separate applicationID which will be a primary key to differentiate between questionnaire of
     * different service. Questionnaire can be further divided on the basis of feedbackIntent which represents the
     * type of feedback appears to user. It can be a general feedback which users can access through a link or button,
     * or it can be a triggered feedback which will be triggered based on some events in the service.<\/p>
     **/ getFeedbackQuestionnaire(request) {
        return super.call("GetFeedbackQuestionnaire", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getFeedbackQuestionnaireResponse.GetFeedbackQuestionnaireResponse))) throw new TypeError(`[TransCustomerFeedbackAggreatorServiceLambda] Expected response body to be of type GetFeedbackQuestionnaireResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>This operation will fetch the users feedback submitted for an application between the provided start and end date.<\/p>
     **/ getFeedbacks(request) {
        return super.call("GetFeedbacks", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getFeedbacksResponse.GetFeedbacksResponse))) throw new TypeError(`[TransCustomerFeedbackAggreatorServiceLambda] Expected response body to be of type GetFeedbacksResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>This operation will store the user feedback based on applicationId and feedbackIntent<\/p>
     **/ submitFeedback(request) {
        return super.call("SubmitFeedback", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>UpsertFeedbackQuestionnaire will be used to update or add new questionnaire in DDB Table<\/p>
     **/ upsertFeedbackQuestionnaire(request) {
        return super.call("UpsertFeedbackQuestionnaire", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
}
TransCustomerFeedbackAggreatorServiceLambda.assembly = "com.amazon.trans.feedback.tcfa.model.v1";
TransCustomerFeedbackAggreatorServiceLambda.serviceName = "TransCustomerFeedbackAggreatorServiceLambda";

},{"@amzn/coral_com-amazon-coral-availability":"XcIbm","@amzn/coral_com-amazon-coral-service-bsf":"cXsMq","@amzn/coral_com-amazon-coral-client":"5x6ZW","@amzn/coral_com-amazon-coral-service":"17IVk","./GetFeedbacksResponse":"6mAo0","./GetDisplayableFeedbackQuestionnaireRequest":"du7Z6","./GetFeedbackQuestionnaireRequest":"lGDeU","./UpsertFeedbackQuestionnaireRequest":"3bQCc","./GetDisplayableFeedbackQuestionnaireResponse":"hKvr0","./TCFAInvalidRequestException":"aAeTo","./TCFANonRecoverableException":"elHJE","./TCFARecoverableException":"fASdB","./GetFeedbacksRequest":"4CNjj","./SubmitFeedbackRequest":"jaXWI","./GetFeedbackQuestionnaireResponse":"bEj7S","@amzn/coral_com-amazon-coral-service-jms":"6RZKg","@amzn/coral_com-amazon-coral-validate":"dF4p4","@amzn/coral_com-amazon-coral-service-http":"hKSuo","@amzn/ihm-js-coral-client":"eOj61","rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bQCc":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This structure defines the input parameters required for making the upsertFeedbackQuestionnaire API call.
 * applicationId - Unique identifier of the application using Feedback
 * feedbackIntent - identifier used to differentiate between different questionnaire for a given
 * applicationID
 * questionnaire - Questions( new or updated), which will be stored in the questionnaire table
 * userId - user name of the person upserting the questions.<\/p>
 **/ parcelHelpers.export(exports, "UpsertFeedbackQuestionnaireRequest", ()=>UpsertFeedbackQuestionnaireRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UpsertFeedbackQuestionnaireRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUpsertfeedbackquestionnairerequest", ()=>validateUpsertfeedbackquestionnairerequest);
var _questionnaire = require("./Questionnaire");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UpsertFeedbackQuestionnaireRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UpsertFeedbackQuestionnaireRequest#clone(obj: PlainObjectFrom<UpsertFeedbackQuestionnaireRequest>) method.
     */ constructor(__applicationId, __feedbackIntent, __questionnaire, __userId){
        super();
        this.applicationId = __applicationId;
        this.feedbackIntent = __feedbackIntent;
        this.questionnaire = __questionnaire;
        this.userId = __userId;
    }
    /**
     * Create a shallow clone of UpsertFeedbackQuestionnaireRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UpsertFeedbackQuestionnaireRequest(obj.applicationId, obj.feedbackIntent, obj.questionnaire, obj.userId);
    }
    static fromJson(data) {
        return new UpsertFeedbackQuestionnaireRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent), (0, _questionnaire.Questionnaire).fromJson(data.questionnaire), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId));
    }
    static toJson(data) {
        return Object.assign({
            applicationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.applicationId),
            feedbackIntent: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.feedbackIntent),
            questionnaire: (0, _questionnaire.Questionnaire).toJson(data.questionnaire),
            userId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId)
        });
    }
}
UpsertFeedbackQuestionnaireRequest.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#UpsertFeedbackQuestionnaireRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpsertFeedbackQuestionnaireRequest);
function validateUpsertfeedbackquestionnairerequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Questionnaire":"1dwjQ","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RZKg":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("ee18526140a7120b"), exports);
__exportStar(require("5cd0ef4da9fcbffb"), exports);

},{"ee18526140a7120b":"7iASr","5cd0ef4da9fcbffb":"hoMtd"}],"dF4p4":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("1c9eb1e3d7e8102"), exports);

},{"1c9eb1e3d7e8102":"dadgW"}],"hKSuo":[function(require,module,exports) {
"use strict";
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("5eea2779bf199276"), exports);
__exportStar(require("5321e805825d33b3"), exports);
__exportStar(require("3a49b09ceee9e722"), exports);
__exportStar(require("3771a93b7a5c6bb6"), exports);
__exportStar(require("e926f539b580cbb9"), exports);
__exportStar(require("9923c24d2c95e317"), exports);
__exportStar(require("207b2979df180a69"), exports);
__exportStar(require("88d5105c1f26555"), exports);

},{"5eea2779bf199276":"crKOF","5321e805825d33b3":"iBbzU","3a49b09ceee9e722":"bAxMD","3771a93b7a5c6bb6":"asWRV","e926f539b580cbb9":"5I65p","9923c24d2c95e317":"bXK3T","207b2979df180a69":"9dPeG","88d5105c1f26555":"dZrcy"}],"4XR3w":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>User id is obtained either from either external id or internal id but not both.<\/p>
 **/ parcelHelpers.export(exports, "UserIdInformation", ()=>UserIdInformation);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserIdInformation] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUseridinformation", ()=>validateUseridinformation);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UserIdInformation extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UserIdInformation#clone(obj: PlainObjectFrom<UserIdInformation>) method.
     */ constructor(__customerId, __userSessionAttributes){
        super();
        this.customerId = __customerId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of UserIdInformation from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UserIdInformation(obj.customerId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new UserIdInformation((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
UserIdInformation.fullyQualifiedTypeName = "com.amazon.trans.feedback.tcfa.model.v1#UserIdInformation";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UserIdInformation);
function validateUseridinformation(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0oBd0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GetTermManualInput API
 * presignedUrlInputParameters: input paramters for getting presigned url
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetTermManualInput", ()=>GetTermManualInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetTermManualInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGettermmanualinput", ()=>validateGettermmanualinput);
var _presignedUrlInputParameters = require("./PresignedUrlInputParameters");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetTermManualInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetTermManualInput#clone(obj: PlainObjectFrom<GetTermManualInput>) method.
     */ constructor(__presignedUrlInputParameters, __customerId){
        super();
        this.presignedUrlInputParameters = __presignedUrlInputParameters;
        this.customerId = __customerId;
    }
    /**
     * Create a shallow clone of GetTermManualInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetTermManualInput(obj.presignedUrlInputParameters, obj.customerId);
    }
    static fromJson(data) {
        return new GetTermManualInput((0, _presignedUrlInputParameters.PresignedUrlInputParameters).fromJson(data.presignedUrlInputParameters), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId));
    }
    static toJson(data) {
        return Object.assign({
            presignedUrlInputParameters: (0, _presignedUrlInputParameters.PresignedUrlInputParameters).toJson(data.presignedUrlInputParameters),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId)
        });
    }
}
GetTermManualInput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetTermManualInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetTermManualInput);
function validateGettermmanualinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PresignedUrlInputParameters":"3P8gD","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3P8gD":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Structure containing all the parameters relevant for file operation<\/p>
 **/ parcelHelpers.export(exports, "PresignedUrlInputParameters", ()=>PresignedUrlInputParameters);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PresignedUrlInputParameters] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePresignedurlinputparameters", ()=>validatePresignedurlinputparameters);
var _fileIdentifierList = require("./FileIdentifierList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class PresignedUrlInputParameters extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PresignedUrlInputParameters#clone(obj: PlainObjectFrom<PresignedUrlInputParameters>) method.
     */ constructor(__s3ObjectKeys){
        super();
        this.s3ObjectKeys = __s3ObjectKeys;
    }
    /**
     * Create a shallow clone of PresignedUrlInputParameters from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PresignedUrlInputParameters(obj.s3ObjectKeys);
    }
    static fromJson(data) {
        return new PresignedUrlInputParameters((0, _fileIdentifierList.FileIdentifierList).fromJson(data.s3ObjectKeys));
    }
    static toJson(data) {
        return Object.assign({
            s3ObjectKeys: (0, _fileIdentifierList.FileIdentifierList).toJson(data.s3ObjectKeys)
        });
    }
}
PresignedUrlInputParameters.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#PresignedUrlInputParameters";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PresignedUrlInputParameters);
function validatePresignedurlinputparameters(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FileIdentifierList":"d79F2","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d79F2":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>List containing the identifers which are used for uniquely identifying a file<\/p>
 **/ parcelHelpers.export(exports, "FileIdentifierList", ()=>FileIdentifierList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FileIdentifierList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFileidentifierlist", ()=>validateFileidentifierlist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class FileIdentifierList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FileIdentifierList.prototype));
    }
    static fromJson(data) {
        return new FileIdentifierList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateFileidentifierlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dP371":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown if the request is Invalid. Non-retryable.<\/p>
 **/ parcelHelpers.export(exports, "CLWSInvalidRequestException", ()=>CLWSInvalidRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CLWSInvalidRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateClwsinvalidrequestexception", ()=>validateClwsinvalidrequestexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CLWSInvalidRequestException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CLWSInvalidRequestException#clone(obj: PlainObjectFrom<CLWSInvalidRequestException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of CLWSInvalidRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CLWSInvalidRequestException(obj.message);
    }
    static fromJson(data) {
        return new CLWSInvalidRequestException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
CLWSInvalidRequestException.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#CLWSInvalidRequestException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CLWSInvalidRequestException);
function validateClwsinvalidrequestexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Tkp0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GetInlineHelpContent API
 * inlineHelpContent- returns the content for a specific page id
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetInlineHelpContentOutput", ()=>GetInlineHelpContentOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetInlineHelpContentOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetinlinehelpcontentoutput", ()=>validateGetinlinehelpcontentoutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetInlineHelpContentOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetInlineHelpContentOutput#clone(obj: PlainObjectFrom<GetInlineHelpContentOutput>) method.
     */ constructor(__inlineHelpContent){
        super();
        this.inlineHelpContent = __inlineHelpContent;
    }
    /**
     * Create a shallow clone of GetInlineHelpContentOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetInlineHelpContentOutput(obj.inlineHelpContent);
    }
    static fromJson(data) {
        return new GetInlineHelpContentOutput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.inlineHelpContent));
    }
    static toJson(data) {
        return Object.assign({
            inlineHelpContent: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.inlineHelpContent)
        });
    }
}
GetInlineHelpContentOutput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetInlineHelpContentOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInlineHelpContentOutput);
function validateGetinlinehelpcontentoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfPkF":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on non-retryable error in service or its dependencies<\/p>
 **/ parcelHelpers.export(exports, "CLWSUnrecoverableException", ()=>CLWSUnrecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CLWSUnrecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateClwsunrecoverableexception", ()=>validateClwsunrecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CLWSUnrecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CLWSUnrecoverableException#clone(obj: PlainObjectFrom<CLWSUnrecoverableException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of CLWSUnrecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CLWSUnrecoverableException(obj.message);
    }
    static fromJson(data) {
        return new CLWSUnrecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
CLWSUnrecoverableException.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#CLWSUnrecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CLWSUnrecoverableException);
function validateClwsunrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Kk0F":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GetLogisticsPartyDetails API
 * Takes CID(CustomerId) and LpId(LogisticsPartyId) from the Mons-headers
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetLogisticsPartyDetailsInput", ()=>GetLogisticsPartyDetailsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetLogisticsPartyDetailsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetlogisticspartydetailsinput", ()=>validateGetlogisticspartydetailsinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetLogisticsPartyDetailsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetLogisticsPartyDetailsInput#clone(obj: PlainObjectFrom<GetLogisticsPartyDetailsInput>) method.
     */ constructor(__customerId, __logisticsPartyId){
        super();
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of GetLogisticsPartyDetailsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetLogisticsPartyDetailsInput(obj.customerId, obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new GetLogisticsPartyDetailsInput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId)
        });
    }
}
GetLogisticsPartyDetailsInput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetLogisticsPartyDetailsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetLogisticsPartyDetailsInput);
function validateGetlogisticspartydetailsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9EHGO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GetAuthorizedEntities API
 * CID(CustomerId): of the external user is passed via headers
 * LpId: if user selected LpId then it is passed via headers
 * entityFilter: can be anyof the filterType for now (LP , LP_TERM) filters are present,
 * if filter is not specified will return all the Entities user is authorized of
 * \/\/Sample Input
 * {
 * &quot;GetAuthorizedEntitiesInput&quot;: {
 * &quot;entityFilter&quot;: &quot;LP_TERM&quot;,
 * }
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetAuthorizedEntitiesInput", ()=>GetAuthorizedEntitiesInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedEntitiesInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauthorizedentitiesinput", ()=>validateGetauthorizedentitiesinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetAuthorizedEntitiesInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedEntitiesInput#clone(obj: PlainObjectFrom<GetAuthorizedEntitiesInput>) method.
     */ constructor(__customerId, __entityFilter, __logisticsPartyId){
        super();
        this.customerId = __customerId;
        this.entityFilter = __entityFilter;
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of GetAuthorizedEntitiesInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuthorizedEntitiesInput(obj.customerId, obj.entityFilter, obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new GetAuthorizedEntitiesInput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.entityFilter), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            entityFilter: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.entityFilter),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId)
        });
    }
}
GetAuthorizedEntitiesInput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetAuthorizedEntitiesInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuthorizedEntitiesInput);
function validateGetauthorizedentitiesinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ciJIN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GetInlineHelpContent API
 * Takes CID(CustomerId) from Mons-headers
 * pageId: id of a particular page
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetInlineHelpContentInput", ()=>GetInlineHelpContentInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetInlineHelpContentInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetinlinehelpcontentinput", ()=>validateGetinlinehelpcontentinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetInlineHelpContentInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetInlineHelpContentInput#clone(obj: PlainObjectFrom<GetInlineHelpContentInput>) method.
     */ constructor(__pageId, __customerId){
        super();
        this.pageId = __pageId;
        this.customerId = __customerId;
    }
    /**
     * Create a shallow clone of GetInlineHelpContentInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetInlineHelpContentInput(obj.pageId, obj.customerId);
    }
    static fromJson(data) {
        return new GetInlineHelpContentInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.pageId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId));
    }
    static toJson(data) {
        return Object.assign({
            pageId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.pageId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId)
        });
    }
}
GetInlineHelpContentInput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetInlineHelpContentInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInlineHelpContentInput);
function validateGetinlinehelpcontentinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwCiU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GetAuthorizedEntities API
 * permissionToEntitiesMap - respresents all the Entities that user have access to at each permission level
 * entity- holds values related to the filterType
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetAuthorizedEntitiesOutput", ()=>GetAuthorizedEntitiesOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedEntitiesOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauthorizedentitiesoutput", ()=>validateGetauthorizedentitiesoutput);
var _permissionToEntitiesMap = require("./PermissionToEntitiesMap");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetAuthorizedEntitiesOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedEntitiesOutput#clone(obj: PlainObjectFrom<GetAuthorizedEntitiesOutput>) method.
     */ constructor(__permissionToEntitiesMap){
        super();
        this.permissionToEntitiesMap = __permissionToEntitiesMap;
    }
    /**
     * Create a shallow clone of GetAuthorizedEntitiesOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuthorizedEntitiesOutput(obj.permissionToEntitiesMap);
    }
    static fromJson(data) {
        return new GetAuthorizedEntitiesOutput((($$val)=>$$val == undefined ? undefined : (0, _permissionToEntitiesMap.PermissionToEntitiesMap).fromJson($$val))(data.permissionToEntitiesMap));
    }
    static toJson(data) {
        return Object.assign({
            permissionToEntitiesMap: (($$val)=>$$val == undefined ? null : (0, _permissionToEntitiesMap.PermissionToEntitiesMap).toJson($$val))(data.permissionToEntitiesMap)
        });
    }
}
GetAuthorizedEntitiesOutput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetAuthorizedEntitiesOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuthorizedEntitiesOutput);
function validateGetauthorizedentitiesoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionToEntitiesMap":"elCiD","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"elCiD":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Map containing Permission to the correspoding Entities that user have permission to
 * permission: Represents Permissions a user can have-- VIEW, ACCESS, EDIT etc
 * entityFilterToEntityListMap - List of possible Entities for a given permission
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "PermissionToEntitiesMap", ()=>PermissionToEntitiesMap);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionToEntitiesMap] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissiontoentitiesmap", ()=>validatePermissiontoentitiesmap);
var _entityFilterToEntityListMap = require("./EntityFilterToEntityListMap");
class PermissionToEntitiesMap {
    constructor(options){
        for (const key of Object.keys(options))this[key] = options[key];
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data))obj[key] = (0, _entityFilterToEntityListMap.EntityFilterToEntityListMap).fromJson(data[key]);
        return new PermissionToEntitiesMap(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map))data[key] = (0, _entityFilterToEntityListMap.EntityFilterToEntityListMap).toJson(map[key]);
        return data;
    }
}
function validatePermissiontoentitiesmap(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityFilterToEntityListMap":"lW7WK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lW7WK":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Map containing EntityFilter to corresponding EntitiesList
 * entityFilter: Represents filter used to group the entities
 * entityList: Represent the list of entities corresponding to the EntityFilter
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "EntityFilterToEntityListMap", ()=>EntityFilterToEntityListMap);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EntityFilterToEntityListMap] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEntityfiltertoentitylistmap", ()=>validateEntityfiltertoentitylistmap);
var _entityList = require("./EntityList");
class EntityFilterToEntityListMap {
    constructor(options){
        for (const key of Object.keys(options))this[key] = options[key];
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data))obj[key] = (0, _entityList.EntityList).fromJson(data[key]);
        return new EntityFilterToEntityListMap(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map))data[key] = (0, _entityList.EntityList).toJson(map[key]);
        return data;
    }
}
function validateEntityfiltertoentitylistmap(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityList":"3kDVL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kDVL":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityList", ()=>EntityList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EntityList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEntitylist", ()=>validateEntitylist);
var _entity = require("./Entity");
class EntityList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(EntityList.prototype));
    }
    static fromJson(data) {
        return new EntityList(data.map((datum)=>(0, _entity.Entity).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _entity.Entity).toJson(datum));
    }
}
function validateEntitylist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Entity":"dBmOE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBmOE":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents a structure that contains authorized LpIds(LogisticsPartyIds), Terms for a user
 * term - Represents Term
 * lpId - UniqueId representing LogisticsParty
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "Entity", ()=>Entity);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Entity] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEntity", ()=>validateEntity);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Entity extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Entity#clone(obj: PlainObjectFrom<Entity>) method.
     */ constructor(__lpId, __term){
        super();
        this.lpId = __lpId;
        this.term = __term;
    }
    /**
     * Create a shallow clone of Entity from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Entity(obj.lpId, obj.term);
    }
    static fromJson(data) {
        return new Entity((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.lpId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term));
    }
    static toJson(data) {
        return Object.assign({
            lpId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.lpId),
            term: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term)
        });
    }
}
Entity.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#Entity";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Entity);
function validateEntity(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwUMr":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GetAuthorizedLogisticsPartiesInput API
 * 1. Takes CID(CustomerId) from the Mons-headers
 * 2. ServiceProviderIdentifierType is the type of ServiceProvider. Empty or default value can be assumed as
 * Logistics Party Id.
 * Note : This is a short term solution until we move to Central Identity.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetAuthorizedLogisticsPartiesInput", ()=>GetAuthorizedLogisticsPartiesInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedLogisticsPartiesInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauthorizedlogisticspartiesinput", ()=>validateGetauthorizedlogisticspartiesinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetAuthorizedLogisticsPartiesInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedLogisticsPartiesInput#clone(obj: PlainObjectFrom<GetAuthorizedLogisticsPartiesInput>) method.
     */ constructor(__customerId, __serviceProviderIdentifierType){
        super();
        this.customerId = __customerId;
        this.serviceProviderIdentifierType = __serviceProviderIdentifierType;
    }
    /**
     * Create a shallow clone of GetAuthorizedLogisticsPartiesInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuthorizedLogisticsPartiesInput(obj.customerId, obj.serviceProviderIdentifierType);
    }
    static fromJson(data) {
        return new GetAuthorizedLogisticsPartiesInput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.serviceProviderIdentifierType));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            serviceProviderIdentifierType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.serviceProviderIdentifierType)
        });
    }
}
GetAuthorizedLogisticsPartiesInput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetAuthorizedLogisticsPartiesInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuthorizedLogisticsPartiesInput);
function validateGetauthorizedlogisticspartiesinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEpU9":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GetAuthorizedLogisticsParties API
 * LogisticsPartiesInfoList - List of Lps user have ACCESS permission to
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetAuthorizedLogisticsPartiesOutput", ()=>GetAuthorizedLogisticsPartiesOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedLogisticsPartiesOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauthorizedlogisticspartiesoutput", ()=>validateGetauthorizedlogisticspartiesoutput);
var _logisticsPartiesInfoList = require("./LogisticsPartiesInfoList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetAuthorizedLogisticsPartiesOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedLogisticsPartiesOutput#clone(obj: PlainObjectFrom<GetAuthorizedLogisticsPartiesOutput>) method.
     */ constructor(__LogisticsPartiesInfoList){
        super();
        this.LogisticsPartiesInfoList = __LogisticsPartiesInfoList;
    }
    /**
     * Create a shallow clone of GetAuthorizedLogisticsPartiesOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuthorizedLogisticsPartiesOutput(obj.LogisticsPartiesInfoList);
    }
    static fromJson(data) {
        return new GetAuthorizedLogisticsPartiesOutput((0, _logisticsPartiesInfoList.LogisticsPartiesInfoList).fromJson(data.LogisticsPartiesInfoList));
    }
    static toJson(data) {
        return Object.assign({
            LogisticsPartiesInfoList: (0, _logisticsPartiesInfoList.LogisticsPartiesInfoList).toJson(data.LogisticsPartiesInfoList)
        });
    }
}
GetAuthorizedLogisticsPartiesOutput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetAuthorizedLogisticsPartiesOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuthorizedLogisticsPartiesOutput);
function validateGetauthorizedlogisticspartiesoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./LogisticsPartiesInfoList":"3a4P0","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3a4P0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogisticsPartiesInfoList", ()=>LogisticsPartiesInfoList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [LogisticsPartiesInfoList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateLogisticspartiesinfolist", ()=>validateLogisticspartiesinfolist);
var _logisticsPartyDetails = require("./LogisticsPartyDetails");
class LogisticsPartiesInfoList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(LogisticsPartiesInfoList.prototype));
    }
    static fromJson(data) {
        return new LogisticsPartiesInfoList(data.map((datum)=>(0, _logisticsPartyDetails.LogisticsPartyDetails).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _logisticsPartyDetails.LogisticsPartyDetails).toJson(datum));
    }
}
function validateLogisticspartiesinfolist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./LogisticsPartyDetails":"bYElY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYElY":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Details of LogisticsParty
 * lpId: UniqueId that represents the LogisticsParty
 * logisticsPartyName: Name of the LogisticsPartyName
 * logisticsPartyDisplayName: Display of the LogisticsParty
 * directedLpId: directedId to the corresponding LpId
 * countryCode: countryCode of the LogisticsParty
 * ServiceProviderIdentifierType : Type of the ServiceProviderId.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "LogisticsPartyDetails", ()=>LogisticsPartyDetails);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [LogisticsPartyDetails] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateLogisticspartydetails", ()=>validateLogisticspartydetails);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class LogisticsPartyDetails extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the LogisticsPartyDetails#clone(obj: PlainObjectFrom<LogisticsPartyDetails>) method.
     */ constructor(__directedLpId, __logisticsPartyDisplayName, __logisticsPartyName, __lpId, __countryCode, __serviceProviderIdentifierType){
        super();
        this.directedLpId = __directedLpId;
        this.logisticsPartyDisplayName = __logisticsPartyDisplayName;
        this.logisticsPartyName = __logisticsPartyName;
        this.lpId = __lpId;
        this.countryCode = __countryCode;
        this.serviceProviderIdentifierType = __serviceProviderIdentifierType;
    }
    /**
     * Create a shallow clone of LogisticsPartyDetails from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new LogisticsPartyDetails(obj.directedLpId, obj.logisticsPartyDisplayName, obj.logisticsPartyName, obj.lpId, obj.countryCode, obj.serviceProviderIdentifierType);
    }
    static fromJson(data) {
        return new LogisticsPartyDetails((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.directedLpId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyDisplayName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.lpId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.countryCode), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.serviceProviderIdentifierType));
    }
    static toJson(data) {
        return Object.assign({
            directedLpId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.directedLpId),
            logisticsPartyDisplayName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyDisplayName),
            logisticsPartyName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyName),
            lpId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.lpId),
            countryCode: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.countryCode),
            serviceProviderIdentifierType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.serviceProviderIdentifierType)
        });
    }
}
LogisticsPartyDetails.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#LogisticsPartyDetails";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(LogisticsPartyDetails);
function validateLogisticspartydetails(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kckWl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on a retryable error in service, e.g throttled from underlying service<\/p>
 **/ parcelHelpers.export(exports, "CLWSRecoverableException", ()=>CLWSRecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CLWSRecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateClwsrecoverableexception", ()=>validateClwsrecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CLWSRecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CLWSRecoverableException#clone(obj: PlainObjectFrom<CLWSRecoverableException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of CLWSRecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CLWSRecoverableException(obj.message);
    }
    static fromJson(data) {
        return new CLWSRecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
CLWSRecoverableException.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#CLWSRecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CLWSRecoverableException);
function validateClwsrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"igwZj":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GetLogisticsPartyDetails API
 * logisticsPartyDetails: Represents the logisticsParty details for a given lpId
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetLogisticsPartyDetailsOutput", ()=>GetLogisticsPartyDetailsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetLogisticsPartyDetailsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetlogisticspartydetailsoutput", ()=>validateGetlogisticspartydetailsoutput);
var _logisticsPartyDetails = require("./LogisticsPartyDetails");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetLogisticsPartyDetailsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetLogisticsPartyDetailsOutput#clone(obj: PlainObjectFrom<GetLogisticsPartyDetailsOutput>) method.
     */ constructor(__logisticsPartyDetails){
        super();
        this.logisticsPartyDetails = __logisticsPartyDetails;
    }
    /**
     * Create a shallow clone of GetLogisticsPartyDetailsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetLogisticsPartyDetailsOutput(obj.logisticsPartyDetails);
    }
    static fromJson(data) {
        return new GetLogisticsPartyDetailsOutput((($$val)=>$$val == undefined ? undefined : (0, _logisticsPartyDetails.LogisticsPartyDetails).fromJson($$val))(data.logisticsPartyDetails));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyDetails: (($$val)=>$$val == undefined ? null : (0, _logisticsPartyDetails.LogisticsPartyDetails).toJson($$val))(data.logisticsPartyDetails)
        });
    }
}
GetLogisticsPartyDetailsOutput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetLogisticsPartyDetailsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetLogisticsPartyDetailsOutput);
function validateGetlogisticspartydetailsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./LogisticsPartyDetails":"bYElY","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zHZ1":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GetTermManualOutput API
 * fileAccessInformation:- containing all the access information related details for the files
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetTermManualOutput", ()=>GetTermManualOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetTermManualOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGettermmanualoutput", ()=>validateGettermmanualoutput);
var _fileAccessInformationList = require("./FileAccessInformationList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetTermManualOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetTermManualOutput#clone(obj: PlainObjectFrom<GetTermManualOutput>) method.
     */ constructor(__fileAccessInformation){
        super();
        this.fileAccessInformation = __fileAccessInformation;
    }
    /**
     * Create a shallow clone of GetTermManualOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetTermManualOutput(obj.fileAccessInformation);
    }
    static fromJson(data) {
        return new GetTermManualOutput((0, _fileAccessInformationList.FileAccessInformationList).fromJson(data.fileAccessInformation));
    }
    static toJson(data) {
        return Object.assign({
            fileAccessInformation: (0, _fileAccessInformationList.FileAccessInformationList).toJson(data.fileAccessInformation)
        });
    }
}
GetTermManualOutput.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#GetTermManualOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetTermManualOutput);
function validateGettermmanualoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FileAccessInformationList":"ln81B","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ln81B":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>List containing all the relevant details for accessing the files<\/p>
 **/ parcelHelpers.export(exports, "FileAccessInformationList", ()=>FileAccessInformationList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FileAccessInformationList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFileaccessinformationlist", ()=>validateFileaccessinformationlist);
var _fileAccessInformation = require("./FileAccessInformation");
class FileAccessInformationList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FileAccessInformationList.prototype));
    }
    static fromJson(data) {
        return new FileAccessInformationList(data.map((datum)=>(0, _fileAccessInformation.FileAccessInformation).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _fileAccessInformation.FileAccessInformation).toJson(datum));
    }
}
function validateFileaccessinformationlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FileAccessInformation":"5BHxq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5BHxq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Structure containing all the relevant details for accessing a file<\/p>
 **/ parcelHelpers.export(exports, "FileAccessInformation", ()=>FileAccessInformation);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FileAccessInformation] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFileaccessinformation", ()=>validateFileaccessinformation);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FileAccessInformation extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FileAccessInformation#clone(obj: PlainObjectFrom<FileAccessInformation>) method.
     */ constructor(__fileOperationType, __s3ObjectKey, __s3presignedUrl){
        super();
        this.fileOperationType = __fileOperationType;
        this.s3ObjectKey = __s3ObjectKey;
        this.s3presignedUrl = __s3presignedUrl;
    }
    /**
     * Create a shallow clone of FileAccessInformation from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FileAccessInformation(obj.fileOperationType, obj.s3ObjectKey, obj.s3presignedUrl);
    }
    static fromJson(data) {
        return new FileAccessInformation((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fileOperationType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.s3ObjectKey), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.s3presignedUrl));
    }
    static toJson(data) {
        return Object.assign({
            fileOperationType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fileOperationType),
            s3ObjectKey: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.s3ObjectKey),
            s3presignedUrl: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.s3presignedUrl)
        });
    }
}
FileAccessInformation.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#FileAccessInformation";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FileAccessInformation);
function validateFileaccessinformation(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvmWH":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown if a user isn't authorized. Non-retryable<\/p>
 **/ parcelHelpers.export(exports, "CLWSUnauthorizedException", ()=>CLWSUnauthorizedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CLWSUnauthorizedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateClwsunauthorizedexception", ()=>validateClwsunauthorizedexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CLWSUnauthorizedException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CLWSUnauthorizedException#clone(obj: PlainObjectFrom<CLWSUnauthorizedException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of CLWSUnauthorizedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CLWSUnauthorizedException(obj.message);
    }
    static fromJson(data) {
        return new CLWSUnauthorizedException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
CLWSUnauthorizedException.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#CLWSUnauthorizedException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CLWSUnauthorizedException);
function validateClwsunauthorizedexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJKo3":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on a database (or other dependency) error<\/p>
 **/ parcelHelpers.export(exports, "DependencyException", ()=>DependencyException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DependencyException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDependencyexception", ()=>validateDependencyexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DependencyException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DependencyException#clone(obj: PlainObjectFrom<DependencyException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of DependencyException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DependencyException(obj.message);
    }
    static fromJson(data) {
        return new DependencyException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
DependencyException.fullyQualifiedTypeName = "com.amazon.carrierlogisticswebserver.model#DependencyException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DependencyException);
function validateDependencyexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8fP8o":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityFilterType", ()=>EntityFilterType);
var EntityFilterType;
(function(EntityFilterType) {
    EntityFilterType["LP"] = "LP";
    EntityFilterType["LP_TERM"] = "LP_TERM";
})(EntityFilterType || (EntityFilterType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ALcE":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>This enum represents the operation to be performed on a file<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileOperationType", ()=>FileOperationType);
var FileOperationType;
(function(FileOperationType) {
    FileOperationType["DOWNLOAD"] = "DOWNLOAD";
    FileOperationType["UPLOAD"] = "UPLOAD";
})(FileOperationType || (FileOperationType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3eCMt":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>This enum signifies the type of the ServiceProvider Identifier.<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceProviderIdentifierType", ()=>ServiceProviderIdentifierType);
var ServiceProviderIdentifierType;
(function(ServiceProviderIdentifierType) {
    ServiceProviderIdentifierType["LOGISTICS_PARTY_ID"] = "LOGISTICS_PARTY_ID";
    ServiceProviderIdentifierType["DSP_COMPANY_ID"] = "DSP_COMPANY_ID";
})(ServiceProviderIdentifierType || (ServiceProviderIdentifierType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fg6Rs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthorizedLps", ()=>getAuthorizedLps);
parcelHelpers.export(exports, "getAuthorizedLpSelected", ()=>getAuthorizedLpSelected);
parcelHelpers.export(exports, "getAuthorizedEntities", ()=>getAuthorizedEntities);
parcelHelpers.export(exports, "setLpPickerInput", ()=>setLpPickerInput);
var _typesafeActions = require("typesafe-actions");
var _actionTypes = require("./actionTypes");
var getAuthorizedLps = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_AUTHORIZED_LPS_REQUEST), (0, _actionTypes.GET_AUTHORIZED_LPS_SUCCESS), (0, _actionTypes.GET_AUTHORIZED_LPS_FAILURE))();
var getAuthorizedLpSelected = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_AUTHORIZED_LP_SELECTED_REQUEST), (0, _actionTypes.GET_AUTHORIZED_LP_SELECTED_SUCCESS), (0, _actionTypes.GET_AUTHORIZED_LP_SELECTED_FAILURE))();
var getAuthorizedEntities = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_AUTHORIZED_ENTITIES_REQUEST), (0, _actionTypes.GET_AUTHORIZED_ENTITIES_SUCCESS), (0, _actionTypes.GET_AUTHORIZED_ENTITIES_FAILURE))();
function setLpPickerInput(payload) {
    return {
        type: (0, _actionTypes.SET_LP_PICKER_INPUT),
        payload: payload
    };
}

},{"typesafe-actions":"qdgAa","./actionTypes":"k7dvX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"qdgAa":[function(require,module,exports) {
!function(n, t) {
    t(exports);
}(this, function(n) {
    "use strict";
    function t(n) {
        return null == n;
    }
    function r(n) {
        throw new Error("Argument " + n + " is empty.");
    }
    function e(n) {
        return "function" == typeof n && "getType" in n;
    }
    function i(n) {
        throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
    }
    function o(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if (null == n.getType) throw new Error("Argument contains array with invalid element at index " + t + ', it should be an action-creator instance from "typesafe-actions"');
    }
    function u(n) {
        return "string" == typeof n || "symbol" == typeof n;
    }
    function a(n) {
        return !u(n);
    }
    function c(n) {
        throw new Error("Argument " + n + " is invalid, it should be an action type of type: string | symbol");
    }
    function f(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument contains array with invalid element at index " + t + ", it should be of type: string | symbol");
    }
    function s(n, e, o, u) {
        return t(n) && r(1), a(n) && i(1), {
            type: n,
            payload: e,
            meta: o,
            error: u
        };
    }
    function y(n, e) {
        t(n) && r(1), a(n) && c(1);
        return Object.assign(function() {
            var t = null != e ? e.apply(void 0, arguments) : void 0;
            return Object.assign({
                type: n
            }, t);
        }, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    function l(n, e, i) {
        return t(n) && r(1), a(n) && c(1), function() {
            return y(n, function() {
                var n = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1];
                return null == e && null == i || (n = null != e ? e.apply(void 0, arguments) : void 0, t = null != i ? i.apply(void 0, arguments) : void 0), Object.assign({}, void 0 !== n && {
                    payload: n
                }, {}, void 0 !== t && {
                    meta: t
                });
            });
        };
    }
    function p(n) {
        return t(n) && r(1), e(n) || i(1), n.getType();
    }
    function d(n, e) {
        t(n) && r(1), a(n) && c(1);
        var i = null != e ? e(n) : function() {
            return {
                type: n
            };
        };
        return Object.assign(i, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    var g = {
        createAction: function(n, t) {
            var r = null == t ? function() {
                return s(n);
            } : t(s.bind(null, n));
            return Object.assign(r, {
                getType: function() {
                    return n;
                },
                toString: function() {
                    return n;
                }
            });
        },
        createCustomAction: d,
        createStandardAction: function(n) {
            return t(n) && r(1), a(n) && c(1), Object.assign(function() {
                return d(n, function(n) {
                    return function(t, r) {
                        return {
                            type: n,
                            payload: t,
                            meta: r
                        };
                    };
                });
            }, {
                map: function(t) {
                    return d(n, function(n) {
                        return function(r, e) {
                            return Object.assign(t(r, e), {
                                type: n
                            });
                        };
                    });
                }
            });
        }
    };
    n.action = s, n.createAction = l, n.createAsyncAction = function(n, t, r, e) {
        return function() {
            var i = [
                n,
                t,
                r,
                e
            ].map(function(n, t) {
                return Array.isArray(n) ? l(n[0], n[1], n[2])() : "string" == typeof n || "symbol" == typeof n ? l(n)() : void (t < 3 && function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action type of "string | symbol" or a tuple of "[string | symbol, Function, Function?]"');
                }(t));
            });
            return {
                request: i[0],
                success: i[1],
                failure: i[2],
                cancel: i[3]
            };
        };
    }, n.createCustomAction = y, n.createReducer = function n(t, r) {
        void 0 === r && (r = {});
        var i = Object.assign({}, r), o = function(r, o) {
            var a = Array.isArray(r) ? r : [
                r
            ], c = {};
            return a.map(function(n, t) {
                return e(n) ? p(n) : u(n) ? n : function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
                }(t + 1);
            }).forEach(function(n) {
                return c[n] = o;
            }), n(t, Object.assign({}, i, {}, c));
        };
        return Object.assign(function(n, r) {
            if (void 0 === n && (n = t), i.hasOwnProperty(r.type)) {
                var e = i[r.type];
                if ("function" != typeof e) throw Error('Reducer under "' + r.type + '" key is not a valid reducer');
                return e(n, r);
            }
            return n;
        }, {
            handlers: Object.assign({}, i),
            handleAction: o,
            handleType: o
        });
    }, n.deprecated = g, n.getType = p, n.isActionOf = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(o);
        var u = function(n) {
            return i.some(function(t) {
                return n.type === t.getType();
            });
        };
        return void 0 === e ? u : u(e);
    }, n.isOfType = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(f);
        var o = function(n) {
            return i.includes(n.type);
        };
        return void 0 === e ? o : o(e);
    };
});

},{}],"k7dvX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SLICE", ()=>SLICE);
parcelHelpers.export(exports, "GET_AUTHORIZED_LPS_REQUEST", ()=>GET_AUTHORIZED_LPS_REQUEST);
parcelHelpers.export(exports, "GET_AUTHORIZED_LPS_SUCCESS", ()=>GET_AUTHORIZED_LPS_SUCCESS);
parcelHelpers.export(exports, "GET_AUTHORIZED_LPS_FAILURE", ()=>GET_AUTHORIZED_LPS_FAILURE);
parcelHelpers.export(exports, "GET_AUTHORIZED_LP_SELECTED_REQUEST", ()=>GET_AUTHORIZED_LP_SELECTED_REQUEST);
parcelHelpers.export(exports, "GET_AUTHORIZED_LP_SELECTED_SUCCESS", ()=>GET_AUTHORIZED_LP_SELECTED_SUCCESS);
parcelHelpers.export(exports, "GET_AUTHORIZED_LP_SELECTED_FAILURE", ()=>GET_AUTHORIZED_LP_SELECTED_FAILURE);
parcelHelpers.export(exports, "GET_AUTHORIZED_ENTITIES_REQUEST", ()=>GET_AUTHORIZED_ENTITIES_REQUEST);
parcelHelpers.export(exports, "GET_AUTHORIZED_ENTITIES_SUCCESS", ()=>GET_AUTHORIZED_ENTITIES_SUCCESS);
parcelHelpers.export(exports, "GET_AUTHORIZED_ENTITIES_FAILURE", ()=>GET_AUTHORIZED_ENTITIES_FAILURE);
parcelHelpers.export(exports, "SET_LP_PICKER_INPUT", ()=>SET_LP_PICKER_INPUT);
var SLICE = "lps";
// getUserProfileInfo action types.
var GET_AUTHORIZED_LPS = "".concat(SLICE, "/GET_AUTHORIZED_LPS");
var GET_AUTHORIZED_LPS_REQUEST = "".concat(GET_AUTHORIZED_LPS, "_REQUEST");
var GET_AUTHORIZED_LPS_SUCCESS = "".concat(GET_AUTHORIZED_LPS, "_SUCCESS");
var GET_AUTHORIZED_LPS_FAILURE = "".concat(GET_AUTHORIZED_LPS, "_FAILURE");
// getSelectedLp action types.
var GET_AUTHORIZED_LP_SELECTED = "".concat(SLICE, "/GET_AUTHORIZED_LP_SELECTED");
var GET_AUTHORIZED_LP_SELECTED_REQUEST = "".concat(GET_AUTHORIZED_LP_SELECTED, "_REQUEST");
var GET_AUTHORIZED_LP_SELECTED_SUCCESS = "".concat(GET_AUTHORIZED_LP_SELECTED, "_SUCCESS");
var GET_AUTHORIZED_LP_SELECTED_FAILURE = "".concat(GET_AUTHORIZED_LP_SELECTED, "_FAILURE");
// getAuthorizedEntities action types.
var GET_AUTHORIZED_ENTITIES = "".concat(SLICE, "/GET_AUTHORIZED_ENTITIES");
var GET_AUTHORIZED_ENTITIES_REQUEST = "".concat(GET_AUTHORIZED_ENTITIES, "_REQUEST");
var GET_AUTHORIZED_ENTITIES_SUCCESS = "".concat(GET_AUTHORIZED_ENTITIES, "_SUCCESS");
var GET_AUTHORIZED_ENTITIES_FAILURE = "".concat(GET_AUTHORIZED_ENTITIES, "_FAILURE");
var SET_LP_PICKER_INPUT = "".concat(SLICE, "/SET_LP_PICKER_INPUT");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e37s8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lpsSelector", ()=>lpsSelector);
parcelHelpers.export(exports, "getAuthorizedLpsSelector", ()=>getAuthorizedLpsSelector);
parcelHelpers.export(exports, "getAuthorizedDSPsSelector", ()=>getAuthorizedDSPsSelector);
parcelHelpers.export(exports, "getAuthorizedLpSelectedSelector", ()=>getAuthorizedLpSelectedSelector);
parcelHelpers.export(exports, "getAuthorizedEntitiesSelector", ()=>getAuthorizedEntitiesSelector);
parcelHelpers.export(exports, "lpPickerInputSelector", ()=>lpPickerInputSelector);
var _reselect = require("reselect");
var lpsSelector = function(state) {
    return state.lps;
};
var getAuthorizedLpsSelector = (0, _reselect.createSelector)(lpsSelector, function(param) {
    var authorizedLps = param.authorizedLps;
    return authorizedLps;
});
var getAuthorizedDSPsSelector = (0, _reselect.createSelector)(lpsSelector, function(param) {
    var authorizedDSPs = param.authorizedDSPs;
    return authorizedDSPs;
});
var getAuthorizedLpSelectedSelector = (0, _reselect.createSelector)(lpsSelector, function(param) {
    var lpSelected = param.lpSelected;
    return lpSelected;
});
var getAuthorizedEntitiesSelector = (0, _reselect.createSelector)(lpsSelector, function(param) {
    var authorizedEntities = param.authorizedEntities;
    return authorizedEntities;
});
var lpPickerInputSelector = (0, _reselect.createSelector)(lpsSelector, function(param) {
    var lpPickerInput = param.lpPickerInput;
    return lpPickerInput;
});

},{"reselect":"knn6S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knn6S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"dbTak","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbTak":[function(require,module,exports) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PXi8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorizedEntities", ()=>useAuthorizedEntities);
var _lodash = require("lodash");
var _react = require("react");
var _reactRedux = require("react-redux");
var _lp = require("../../actions/lp");
var _selectors = require("../../actions/lp/selectors");
var _authorization = require("../../constants/authorization");
function useAuthorizedEntities() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var lpSelected = (0, _reactRedux.useSelector)((0, _selectors.getAuthorizedLpSelectedSelector));
    var authorizedEntities = (0, _reactRedux.useSelector)((0, _selectors.getAuthorizedEntitiesSelector));
    (0, _react.useEffect)(function() {
        var _lpSelected;
        if ((0, _lodash.isEmpty)(lpSelected) || (0, _lodash.isEmpty)((_lpSelected = lpSelected) === null || _lpSelected === void 0 ? void 0 : _lpSelected.lpId)) return;
        dispatch((0, _lp.getAuthorizedEntities).request({
            entityFilter: (0, _authorization.ENTITY_FILTER_ENUMS).NO_FILTER
        })); // To Fetch All authorized Entities
    }, [
        dispatch,
        lpSelected
    ]);
    return authorizedEntities;
}

},{"lodash":"7vCCa","react":"6uln9","react-redux":"3qqlL","../../actions/lp":"fg6Rs","../../actions/lp/selectors":"e37s8","../../constants/authorization":"iwYTV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iwYTV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENTITY_FILTER_ENUMS", ()=>ENTITY_FILTER_ENUMS);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var ENTITY_FILTER_ENUMS = {
    LP: (0, _coralComAmazonCarrierlogisticswebserverModel.EntityFilterType).LP,
    LP_TERM: (0, _coralComAmazonCarrierlogisticswebserverModel.EntityFilterType).LP_TERM,
    NO_FILTER: null
};

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2yw1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorizedLps", ()=>useAuthorizedLps);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _react = require("react");
var _reactRedux = require("react-redux");
var _lp = require("../../actions/lp");
var _actionTypes = require("../../actions/lp/actionTypes");
var _selectors = require("../../actions/lp/selectors");
function useAuthorizedLps() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var authorizedLps = (0, _reactRedux.useSelector)((0, _selectors.getAuthorizedLpsSelector));
    (0, _react.useEffect)(function() {
        dispatch((0, _lp.getAuthorizedLps).request({
            getAuthorizedLpsInput: (0, _coralComAmazonCarrierlogisticswebserverModel.GetAuthorizedLogisticsPartiesInput).clone({
                serviceProviderIdentifierType: (0, _coralComAmazonCarrierlogisticswebserverModel.ServiceProviderIdentifierType).LOGISTICS_PARTY_ID
            })
        }, (0, _actionTypes.GET_AUTHORIZED_LPS_REQUEST))); // To Fetch All Lps details
    }, [
        dispatch
    ]);
    return authorizedLps;
}

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","react":"6uln9","react-redux":"3qqlL","../../actions/lp":"fg6Rs","../../actions/lp/actionTypes":"k7dvX","../../actions/lp/selectors":"e37s8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8RHmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLpSelected", ()=>useLpSelected);
var _react = require("react");
var _reactRedux = require("react-redux");
var _lp = require("../../actions/lp");
var _actionTypes = require("../../actions/lp/actionTypes");
var _selectors = require("../../actions/lp/selectors");
function useLpSelected() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var lpSelected = (0, _reactRedux.useSelector)((0, _selectors.getAuthorizedLpSelectedSelector));
    (0, _react.useEffect)(function() {
        dispatch((0, _lp.getAuthorizedLpSelected).request({}, (0, _actionTypes.GET_AUTHORIZED_LP_SELECTED_REQUEST))); // To fetch Lp that is already selected
    }, [
        dispatch
    ]);
    return lpSelected;
}

},{"react":"6uln9","react-redux":"3qqlL","../../actions/lp":"fg6Rs","../../actions/lp/actionTypes":"k7dvX","../../actions/lp/selectors":"e37s8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0AKW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var _reduxObservable = require("redux-observable");
var _reduxLogger = require("redux-logger");
var _reduxLoggerDefault = parcelHelpers.interopDefault(_reduxLogger);
var _rootEpic = require("../epics/rootEpic");
var _rootEpicDefault = parcelHelpers.interopDefault(_rootEpic);
var _reducers = require("../reducers");
var _reducersDefault = parcelHelpers.interopDefault(_reducers);
var _services = require("../services");
var _servicesDefault = parcelHelpers.interopDefault(_services);
var _routerMiddleware = require("./middlewares/routerMiddleware");
var _routerMiddlewareDefault = parcelHelpers.interopDefault(_routerMiddleware);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _window_location_host, _window_location, _window;
var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)({
    dependencies: (0, _servicesDefault.default)
});
var middlewares = [
    (0, _reduxThunkDefault.default),
    (0, _routerMiddlewareDefault.default),
    epicMiddleware
];
if ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : (_window_location_host = _window_location.host) === null || _window_location_host === void 0 ? void 0 : _window_location_host.includes("localhost")) middlewares.push((0, _reduxLoggerDefault.default));
var store = (0, _redux.createStore)((0, _reducersDefault.default), (0, _redux.applyMiddleware).apply(void 0, _to_consumable_array(middlewares)));
epicMiddleware.run((0, _rootEpicDefault.default));
exports.default = store;

},{"redux":"9FlA6","redux-thunk":"5DEc0","redux-observable":"2KWJL","redux-logger":"4eYK1","../epics/rootEpic":"6UmIs","../reducers":"f2XKl","../services":"1s9sr","./middlewares/routerMiddleware":"biaRa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9FlA6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"bdF3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdF3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, _definePropertyJsDefault.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

},{"./defineProperty.js":"hB6Hc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hB6Hc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(obj, key, value) {
    key = (0, _toPropertyKeyJsDefault.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"./toPropertyKey.js":"eeQfG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eeQfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function _toPropertyKey(arg) {
    var key = (0, _toPrimitiveJsDefault.default)(arg, "string");
    return (0, _typeofJsDefault.default)(key) === "symbol" ? key : String(key);
}

},{"./typeof.js":"bfY36","./toPrimitive.js":"rCnQy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfY36":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"rCnQy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function _toPrimitive(input, hint) {
    if ((0, _typeofJsDefault.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeofJsDefault.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./typeof.js":"bfY36","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5DEc0":[function(require,module,exports) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2KWJL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>(0, _createEpicMiddleware.createEpicMiddleware));
parcelHelpers.export(exports, "ActionsObservable", ()=>(0, _actionsObservable.ActionsObservable));
parcelHelpers.export(exports, "StateObservable", ()=>(0, _stateObservable.StateObservable));
parcelHelpers.export(exports, "combineEpics", ()=>(0, _combineEpics.combineEpics));
parcelHelpers.export(exports, "ofType", ()=>(0, _operators.ofType));
var _createEpicMiddleware = require("./createEpicMiddleware");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _combineEpics = require("./combineEpics");
var _operators = require("./operators");

},{"./createEpicMiddleware":"aSrGy","./ActionsObservable":false,"./StateObservable":false,"./combineEpics":"h9xry","./operators":"5LoUt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSrGy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>createEpicMiddleware);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _console = require("./utils/console");
function createEpicMiddleware() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // This isn't great. RxJS doesn't publicly export the constructor for
    // QueueScheduler nor QueueAction, so we reach in. We need to do this because
    // we don't want our internal queuing mechanism to be on the same queue as any
    // other RxJS code outside of redux-observable internals.
    var QueueScheduler = (0, _rxjs.queueScheduler).constructor;
    var uniqueQueueScheduler = new QueueScheduler((0, _rxjs.queueScheduler).SchedulerAction);
    var epic$ = new (0, _rxjs.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        var actionSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var stateSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var action$ = new (0, _actionsObservable.ActionsObservable)(actionSubject$);
        var state$ = new (0, _stateObservable.StateObservable)(stateSubject$, store.getState());
        var result$ = epic$.pipe((0, _operators.map)(function(epic) {
            var output$ = "dependencies" in options ? epic(action$, state$, options.dependencies) : epic(action$, state$);
            if (!output$) throw new TypeError('Your root Epic "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        }), (0, _operators.mergeMap)(function(output$) {
            return (0, _rxjs.from)(output$).pipe((0, _operators.subscribeOn)(uniqueQueueScheduler), (0, _operators.observeOn)(uniqueQueueScheduler));
        }));
        result$.subscribe(store.dispatch);
        return function(next) {
            return function(action) {
                // Downstream middleware gets the action first,
                // which includes their reducers, so state is
                // updated before epics receive the action
                var result = next(action);
                // It's important to update the state$ before we emit
                // the action because otherwise it would be stale
                stateSubject$.next(store.getState());
                actionSubject$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.run = function(rootEpic) {
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

},{"rxjs":"k96vz","rxjs/operators":"jqupl","./ActionsObservable":"4sXEf","./StateObservable":"ee6yw","./utils/console":"6ddpY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k96vz":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":"iCLEN","./internal/observable/ConnectableObservable":false,"./internal/operators/groupBy":false,"./internal/symbol/observable":false,"./internal/Subject":"4UtGr","./internal/BehaviorSubject":false,"./internal/ReplaySubject":false,"./internal/AsyncSubject":false,"./internal/scheduler/asap":false,"./internal/scheduler/async":false,"./internal/scheduler/queue":"c6FI5","./internal/scheduler/animationFrame":false,"./internal/scheduler/VirtualTimeScheduler":false,"./internal/Scheduler":false,"./internal/Subscription":false,"./internal/Subscriber":false,"./internal/Notification":false,"./internal/util/pipe":false,"./internal/util/noop":false,"./internal/util/identity":false,"./internal/util/isObservable":false,"./internal/util/ArgumentOutOfRangeError":false,"./internal/util/EmptyError":false,"./internal/util/ObjectUnsubscribedError":false,"./internal/util/UnsubscriptionError":false,"./internal/util/TimeoutError":false,"./internal/observable/bindCallback":false,"./internal/observable/bindNodeCallback":false,"./internal/observable/combineLatest":false,"./internal/observable/concat":false,"./internal/observable/defer":false,"./internal/observable/empty":false,"./internal/observable/forkJoin":false,"./internal/observable/from":"7moac","./internal/observable/fromEvent":false,"./internal/observable/fromEventPattern":false,"./internal/observable/generate":false,"./internal/observable/iif":false,"./internal/observable/interval":false,"./internal/observable/merge":"4tPSs","./internal/observable/never":false,"./internal/observable/of":"aH2U1","./internal/observable/onErrorResumeNext":false,"./internal/observable/pairs":false,"./internal/observable/partition":false,"./internal/observable/race":false,"./internal/observable/range":false,"./internal/observable/throwError":false,"./internal/observable/timer":false,"./internal/observable/using":false,"./internal/observable/zip":false,"./internal/scheduled/scheduled":false,"./internal/config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCLEN":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"coO33","./util/toSubscriber":"9c67S","./symbol/observable":"6QJGV","./util/pipe":"h9cCW","./config":"k6A3z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"coO33":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"itYWB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"itYWB":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"4SPkl","./util/isFunction":"kUN3M","./Observer":"7mekb","./Subscription":"9tJMu","../internal/symbol/rxSubscriber":"kNEbN","./config":"k6A3z","./util/hostReportError":"h5kxT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4SPkl":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUN3M":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mekb":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"k6A3z","./util/hostReportError":"h5kxT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6A3z":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h5kxT":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tJMu":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"aO0AG","./util/isObject":"6aDrE","./util/isFunction":"kUN3M","./util/UnsubscriptionError":"fNvGd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aO0AG":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6aDrE":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fNvGd":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kNEbN":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9c67S":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"itYWB","../symbol/rxSubscriber":"kNEbN","../Observer":"7mekb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QJGV":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9cCW":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"lqP1v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lqP1v":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4UtGr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"4SPkl","./Observable":"iCLEN","./Subscriber":"itYWB","./Subscription":"9tJMu","./util/ObjectUnsubscribedError":"5zRiX","./SubjectSubscription":"cRyE6","../internal/symbol/rxSubscriber":"kNEbN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5zRiX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRyE6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"4SPkl","./Subscription":"9tJMu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyHdw":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = /*@__PURE__*/ new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"7A1Pn","./AsapScheduler":"i7VQw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7A1Pn":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var _asyncAction = require("./AsyncAction");
var AsapAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, _immediate.Immediate).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, _immediate.Immediate).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"4SPkl","../util/Immediate":"yt9wM","./AsyncAction":"cnky3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"yt9wM":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cnky3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var AsyncAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"4SPkl","./Action":"jpIoR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpIoR":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"4SPkl","../Subscription":"9tJMu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i7VQw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"4SPkl","./AsyncScheduler":"4RhvE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4RhvE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"4SPkl","../Scheduler":"wNwr4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wNwr4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var Scheduler = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c6FI5":[function(require,module,exports) {
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = /*@__PURE__*/ new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"9vR9v","./QueueScheduler":"9Hgxj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9vR9v":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"4SPkl","./AsyncAction":"cnky3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Hgxj":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"4SPkl","./AsyncScheduler":"4RhvE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cnqSj":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var NotificationKind;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, _of.of)(this.value);
            case "E":
                return (0, _throwError.throwError)(this.error);
            case "C":
                return (0, _empty.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

},{"./observable/empty":"eTLlg","./observable/of":"aH2U1","./observable/throwError":"eZwbm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eTLlg":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = /*@__PURE__*/ new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"iCLEN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aH2U1":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _isScheduler = require("../util/isScheduler");
var _fromArray = require("./fromArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        args.pop();
        return (0, _scheduleArray.scheduleArray)(args, scheduler);
    } else return (0, _fromArray.fromArray)(args);
}

},{"../util/isScheduler":"9aKVi","./fromArray":"4Bpzv","../scheduled/scheduleArray":"fOwSE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9aKVi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
function isScheduler(value) {
    return value && typeof value.schedule === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Bpzv":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromArray", ()=>fromArray);
var _observable = require("../Observable");
var _subscribeToArray = require("../util/subscribeToArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function fromArray(input, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)((0, _subscribeToArray.subscribeToArray)(input));
    else return (0, _scheduleArray.scheduleArray)(input, scheduler);
}

},{"../Observable":"iCLEN","../util/subscribeToArray":"l8ZsD","../scheduled/scheduleArray":"fOwSE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l8ZsD":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fOwSE":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"iCLEN","../Subscription":"9tJMu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eZwbm":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
function throwError(error, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

},{"../Observable":"iCLEN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7moac":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"iCLEN","../util/subscribeTo":"4uUOs","../scheduled/scheduled":"1JUmG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4uUOs":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"l8ZsD","./subscribeToPromise":"bw5KS","./subscribeToIterable":"1Cr1A","./subscribeToObservable":"7oXfo","./isArrayLike":"9cVg9","./isPromise":"26wIo","./isObject":"6aDrE","../symbol/iterator":"hn0ad","../symbol/observable":"6QJGV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bw5KS":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"h5kxT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Cr1A":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"hn0ad","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hn0ad":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7oXfo":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"6QJGV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9cVg9":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26wIo":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JUmG":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"4NwPM","./schedulePromise":"ejgRs","./scheduleArray":"fOwSE","./scheduleIterable":"1nd2r","../util/isInteropObservable":"8iK9u","../util/isPromise":"26wIo","../util/isArrayLike":"9cVg9","../util/isIterable":"cZJ0T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4NwPM":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"iCLEN","../Subscription":"9tJMu","../symbol/observable":"6QJGV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejgRs":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"iCLEN","../Subscription":"9tJMu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nd2r":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"iCLEN","../Subscription":"9tJMu","../symbol/iterator":"hn0ad","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iK9u":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"6QJGV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZJ0T":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"hn0ad","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tPSs":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _observable = require("../Observable");
var _isScheduler = require("../util/isScheduler");
var _mergeAll = require("../operators/mergeAll");
var _fromArray = require("./fromArray");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, _isScheduler.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, _observable.Observable)) return observables[0];
    return (0, _mergeAll.mergeAll)(concurrent)((0, _fromArray.fromArray)(observables, scheduler));
}

},{"../Observable":"iCLEN","../util/isScheduler":"9aKVi","../operators/mergeAll":"8bcWE","./fromArray":"4Bpzv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bcWE":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"5Zcu6","../util/identity":"lqP1v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Zcu6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
parcelHelpers.export(exports, "MergeMapOperator", ()=>MergeMapOperator);
parcelHelpers.export(exports, "MergeMapSubscriber", ()=>MergeMapSubscriber);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(mergeMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new MergeMapOperator(project, concurrent));
    };
}
var MergeMapOperator = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));
var flatMap = mergeMap;

},{"tslib":"4SPkl","./map":"fJkhf","../observable/from":"7moac","../innerSubscribe":"jiCGn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fJkhf":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"4SPkl","../Subscriber":"itYWB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jiCGn":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

},{"tslib":"4SPkl","./Subscriber":"itYWB","./Observable":"iCLEN","./util/subscribeTo":"4uUOs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqupl":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":false,"../internal/operators/auditTime":false,"../internal/operators/buffer":false,"../internal/operators/bufferCount":false,"../internal/operators/bufferTime":false,"../internal/operators/bufferToggle":false,"../internal/operators/bufferWhen":false,"../internal/operators/catchError":"gp9Jg","../internal/operators/combineAll":false,"../internal/operators/combineLatest":false,"../internal/operators/concat":false,"../internal/operators/concatAll":false,"../internal/operators/concatMap":false,"../internal/operators/concatMapTo":false,"../internal/operators/count":false,"../internal/operators/debounce":false,"../internal/operators/debounceTime":false,"../internal/operators/defaultIfEmpty":false,"../internal/operators/delay":false,"../internal/operators/delayWhen":false,"../internal/operators/dematerialize":false,"../internal/operators/distinct":false,"../internal/operators/distinctUntilChanged":false,"../internal/operators/distinctUntilKeyChanged":false,"../internal/operators/elementAt":false,"../internal/operators/endWith":false,"../internal/operators/every":false,"../internal/operators/exhaust":false,"../internal/operators/exhaustMap":false,"../internal/operators/expand":false,"../internal/operators/filter":"gEgzP","../internal/operators/finalize":false,"../internal/operators/find":false,"../internal/operators/findIndex":false,"../internal/operators/first":false,"../internal/operators/groupBy":false,"../internal/operators/ignoreElements":false,"../internal/operators/isEmpty":false,"../internal/operators/last":false,"../internal/operators/map":"fJkhf","../internal/operators/mapTo":false,"../internal/operators/materialize":false,"../internal/operators/max":false,"../internal/operators/merge":false,"../internal/operators/mergeAll":false,"../internal/operators/mergeMap":"5Zcu6","../internal/operators/mergeMapTo":false,"../internal/operators/mergeScan":false,"../internal/operators/min":false,"../internal/operators/multicast":false,"../internal/operators/observeOn":"5PFM8","../internal/operators/onErrorResumeNext":false,"../internal/operators/pairwise":false,"../internal/operators/partition":false,"../internal/operators/pluck":false,"../internal/operators/publish":false,"../internal/operators/publishBehavior":false,"../internal/operators/publishLast":false,"../internal/operators/publishReplay":false,"../internal/operators/race":false,"../internal/operators/reduce":false,"../internal/operators/repeat":false,"../internal/operators/repeatWhen":false,"../internal/operators/retry":false,"../internal/operators/retryWhen":false,"../internal/operators/refCount":false,"../internal/operators/sample":false,"../internal/operators/sampleTime":false,"../internal/operators/scan":false,"../internal/operators/sequenceEqual":false,"../internal/operators/share":false,"../internal/operators/shareReplay":false,"../internal/operators/single":false,"../internal/operators/skip":false,"../internal/operators/skipLast":false,"../internal/operators/skipUntil":false,"../internal/operators/skipWhile":false,"../internal/operators/startWith":false,"../internal/operators/subscribeOn":"3PzdI","../internal/operators/switchAll":false,"../internal/operators/switchMap":"iHcg1","../internal/operators/switchMapTo":false,"../internal/operators/take":false,"../internal/operators/takeLast":false,"../internal/operators/takeUntil":false,"../internal/operators/takeWhile":false,"../internal/operators/tap":false,"../internal/operators/throttle":false,"../internal/operators/throttleTime":false,"../internal/operators/throwIfEmpty":false,"../internal/operators/timeInterval":false,"../internal/operators/timeout":false,"../internal/operators/timeoutWith":false,"../internal/operators/timestamp":false,"../internal/operators/toArray":false,"../internal/operators/window":false,"../internal/operators/windowCount":false,"../internal/operators/windowTime":false,"../internal/operators/windowToggle":false,"../internal/operators/windowWhen":false,"../internal/operators/withLatestFrom":false,"../internal/operators/zip":false,"../internal/operators/zipAll":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gp9Jg":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"4SPkl","../innerSubscribe":"jiCGn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gEgzP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var FilterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"4SPkl","../Subscriber":"itYWB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PFM8":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
parcelHelpers.export(exports, "ObserveOnOperator", ()=>ObserveOnOperator);
parcelHelpers.export(exports, "ObserveOnSubscriber", ()=>ObserveOnSubscriber);
parcelHelpers.export(exports, "ObserveOnMessage", ()=>ObserveOnMessage);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var ObserveOnSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, _notification.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, _notification.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, _subscriber.Subscriber));
var ObserveOnMessage = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

},{"tslib":"4SPkl","../Subscriber":"itYWB","../Notification":"cnqSj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3PzdI":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _subscribeOnObservable = require("../observable/SubscribeOnObservable");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, _subscribeOnObservable.SubscribeOnObservable)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

},{"../observable/SubscribeOnObservable":"eS2Yv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eS2Yv":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscribeOnObservable", ()=>SubscribeOnObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _asap = require("../scheduler/asap");
var _isNumeric = require("../util/isNumeric");
var SubscribeOnObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, _isNumeric.isNumeric)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, _asap.asap);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, _observable.Observable));

},{"tslib":"4SPkl","../Observable":"iCLEN","../scheduler/asap":"gyHdw","../util/isNumeric":"7CGXS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7CGXS":[function(require,module,exports) {
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
var _isArray = require("./isArray");
function isNumeric(val) {
    return !(0, _isArray.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

},{"./isArray":"aO0AG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iHcg1":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"4SPkl","./map":"fJkhf","../observable/from":"7moac","../innerSubscribe":"jiCGn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4sXEf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionsObservable", ()=>ActionsObservable);
var _rxjs = require("rxjs");
var _operators = require("./operators");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ActionsObservable = function(_Observable) {
    _inherits(ActionsObservable, _Observable);
    _createClass(ActionsObservable, null, [
        {
            key: "of",
            value: function of() {
                return new this((0, _rxjs.of).apply(undefined, arguments));
            }
        },
        {
            key: "from",
            value: function from(actions, scheduler) {
                return new this((0, _rxjs.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        _classCallCheck(this, ActionsObservable);
        var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    _createClass(ActionsObservable, [
        {
            key: "lift",
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: "ofType",
            value: function ofType() {
                return (0, _operators.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, _rxjs.Observable));

},{"rxjs":"k96vz","./operators":"5LoUt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LoUt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ofType", ()=>ofType);
var _operators = require("rxjs/operators");
var keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === "function" && type === key.toString();
};
var ofType = function ofType() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function(source) {
        return source.pipe((0, _operators.filter)(function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if (keyHasType(type, keys[i])) return true;
            }
            return false;
        }));
    };
};

},{"rxjs/operators":"jqupl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ee6yw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StateObservable", ()=>StateObservable);
var _rxjs = require("rxjs");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var StateObservable = function(_Observable) {
    _inherits(StateObservable, _Observable);
    function StateObservable(stateSubject, initialState) {
        _classCallCheck(this, StateObservable);
        var _this = _possibleConstructorReturn(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function(subscriber) {
            var subscription = _this.__notifier.subscribe(subscriber);
            if (subscription && !subscription.closed) subscriber.next(_this.value);
            return subscription;
        }));
        _this.value = initialState;
        _this.__notifier = new (0, _rxjs.Subject)();
        _this.__subscription = stateSubject.subscribe(function(value) {
            // We only want to update state$ if it has actually changed since
            // redux requires reducers use immutability patterns.
            // This is basically what distinctUntilChanged() does but it's so simple
            // we don't need to pull that code in
            if (value !== _this.value) {
                _this.value = value;
                _this.__notifier.next(value);
            }
        });
        return _this;
    }
    return StateObservable;
}((0, _rxjs.Observable));

},{"rxjs":"k96vz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ddpY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetDeprecationsSeen", ()=>resetDeprecationsSeen);
parcelHelpers.export(exports, "deprecate", ()=>deprecate);
parcelHelpers.export(exports, "warn", ()=>warn);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var deprecationsSeen = {};
var resetDeprecationsSeen = function resetDeprecationsSeen() {
    deprecationsSeen = {};
};
var consoleWarn = (typeof console === "undefined" ? "undefined" : _typeof(console)) === "object" && typeof console.warn === "function" ? function() {
    var _console;
    return (_console = console).warn.apply(_console, arguments);
} : function() {};
var deprecate = function deprecate(msg) {
    if (!deprecationsSeen[msg]) {
        deprecationsSeen[msg] = true;
        consoleWarn("redux-observable | DEPRECATION: " + msg);
    }
};
var warn = function warn(msg) {
    consoleWarn("redux-observable | WARNING: " + msg);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h9xry":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineEpics", ()=>combineEpics);
var _rxjs = require("rxjs");
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var combineEpics = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    var merger = function merger() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, _rxjs.merge).apply(undefined, _toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        })));
    };
    // Technically the `name` property on Function's are supposed to be read-only.
    // While some JS runtimes allow it anyway (so this is useful in debugging)
    // some actually throw an exception when you attempt to do so.
    try {
        Object.defineProperty(merger, "name", {
            value: "combineEpics(" + epics.map(function(epic) {
                return epic.name || "<anonymous>";
            }).join(", ") + ")"
        });
    } catch (e) {}
    return merger;
};

},{"rxjs":"k96vz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4eYK1":[function(require,module,exports) {
var global = arguments[3];
!function(e, t) {
    t(exports);
}(this, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{}],"6UmIs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduxObservable = require("redux-observable");
var _apiLoadingEpic = require("./apiLoadingEpic");
var _lp = require("./lp");
var _lpDefault = parcelHelpers.interopDefault(_lp);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var epics = (0, _reduxObservable.combineEpics).apply(void 0, _to_consumable_array((0, _lpDefault.default)).concat([
    (0, _apiLoadingEpic.apiLoadingEpic)
]));
exports.default = epics;

},{"redux-observable":"2KWJL","./apiLoadingEpic":"vFYDr","./lp":"liGE9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"vFYDr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiLoadingEpic", ()=>apiLoadingEpic);
var _operators = require("rxjs/operators");
var _ui = require("../actions/ui");
var _apiLoading = require("../utils/apiLoading");
var _apiLoading1 = require("../constants/apiLoading");
var apiLoadingEpic = function(action$) {
    return action$.pipe((0, _operators.filter)(function(action) {
        return (0, _apiLoading1.requestFlowActionsRegex).test(action.type);
    }), (0, _operators.map)(function(action) {
        var type = action.type;
        var isRequestBeingSent = (0, _apiLoading1.requestActionRegex).test(type);
        var call = (0, _apiLoading.getCall)(type);
        if (isRequestBeingSent) return (0, _ui.startRequestLoading)(call);
        return (0, _ui.endRequestLoading)(call);
    }));
};
exports.default = apiLoadingEpic;

},{"rxjs/operators":"jqupl","../actions/ui":"c00tM","../utils/apiLoading":"1FcBi","../constants/apiLoading":"LpXnv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c00tM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Action to handle notification addition.
 */ parcelHelpers.export(exports, "addNotification", ()=>addNotification);
/**
 * Action to handle notification closures.
 */ parcelHelpers.export(exports, "closeNotification", ()=>closeNotification);
/**
 * Action to push to a different route.
 */ parcelHelpers.export(exports, "pushRoute", ()=>pushRoute);
parcelHelpers.export(exports, "startRequestLoading", ()=>startRequestLoading);
parcelHelpers.export(exports, "endRequestLoading", ()=>endRequestLoading);
var _uuid = require("uuid");
var _types = require("./types");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function addNotification(config) {
    return {
        type: (0, _types.ADD_NOTIFICATION),
        payload: _object_spread({
            id: (0, _uuid.v4)()
        }, config)
    };
}
function closeNotification(id) {
    return {
        type: (0, _types.CLOSE_NOTIFICATION),
        payload: id
    };
}
function pushRoute(history, route) {
    return {
        type: (0, _types.PUSH_ROUTE),
        payload: {
            history: history,
            route: route
        }
    };
}
var startRequestLoading = function(payload) {
    return {
        type: (0, _types.START_REQUEST_LOADING),
        payload: payload
    };
};
var endRequestLoading = function(payload) {
    return {
        type: (0, _types.END_REQUEST_LOADING),
        payload: payload
    };
};

},{"uuid":"4y4j8","./types":"9G6gl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4y4j8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"5XThY","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XThY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"2TUwT","./stringify.js":"eMxfY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TUwT":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eMxfY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"1bbAq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bbAq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"ePDzU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePDzU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9G6gl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SLICE", ()=>SLICE);
parcelHelpers.export(exports, "PUSH_ROUTE", ()=>PUSH_ROUTE);
parcelHelpers.export(exports, "ADD_NOTIFICATION", ()=>ADD_NOTIFICATION);
parcelHelpers.export(exports, "CLOSE_NOTIFICATION", ()=>CLOSE_NOTIFICATION);
parcelHelpers.export(exports, "START_REQUEST_LOADING", ()=>START_REQUEST_LOADING);
parcelHelpers.export(exports, "END_REQUEST_LOADING", ()=>END_REQUEST_LOADING);
parcelHelpers.export(exports, "NotificationTypeEnum", ()=>NotificationTypeEnum);
parcelHelpers.export(exports, "DEFAULT_NOTIFICATION_CLOSE_TIMEOUT", ()=>DEFAULT_NOTIFICATION_CLOSE_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_ROUTE_CHANGE_TIMEOUT", ()=>DEFAULT_ROUTE_CHANGE_TIMEOUT);
var SLICE = "ui";
var PUSH_ROUTE = "".concat(SLICE, "/PUSH_ROUTE");
var ADD_NOTIFICATION = "".concat(SLICE, "/ADD_NOTIFICATION");
var CLOSE_NOTIFICATION = "".concat(SLICE, "/CLOSE_NOTIFICATION");
var START_REQUEST_LOADING = "".concat(SLICE, "/START_REQUEST_LOADING");
var END_REQUEST_LOADING = "".concat(SLICE, "/END_REQUEST_LOADING");
var NotificationTypeEnum = Object.freeze({
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "informational"
});
var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
var DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1FcBi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get the name of the call being made.
 * Replace /(_REQUEST|_SUCCESS|_FAILURE)$/ with empty string
 *
 * @param {string} action
 * @returns {string}
 */ parcelHelpers.export(exports, "getCall", ()=>getCall);
var _apiLoading = require("../constants/apiLoading");
function getCall(action) {
    return action.replace((0, _apiLoading.requestFlowActionsRegex), "");
}
exports.default = {
    getCall: getCall
};

},{"../constants/apiLoading":"LpXnv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"LpXnv":[function(require,module,exports) {
// To match strings ending with REQUEST | SUCCESS | FAILURE
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestFlowActionsRegex", ()=>requestFlowActionsRegex);
parcelHelpers.export(exports, "requestActionRegex", ()=>requestActionRegex);
var requestFlowActionsRegex = /(_REQUEST|_SUCCESS|_FAILURE)$/;
var requestActionRegex = /_REQUEST$/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"liGE9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lpEpics", ()=>lpEpics);
var _getAuthorizedLpsEpic = require("./getAuthorizedLpsEpic");
var _getAuthorizedLpsEpicDefault = parcelHelpers.interopDefault(_getAuthorizedLpsEpic);
var _getLpSelectedEpic = require("./getLpSelectedEpic");
var _getLpSelectedEpicDefault = parcelHelpers.interopDefault(_getLpSelectedEpic);
var _getAuthhorizedEntitiesEpic = require("./getAuthhorizedEntitiesEpic");
var _getAuthhorizedEntitiesEpicDefault = parcelHelpers.interopDefault(_getAuthhorizedEntitiesEpic);
var lpEpics = [
    (0, _getAuthorizedLpsEpicDefault.default),
    (0, _getAuthhorizedEntitiesEpicDefault.default),
    (0, _getLpSelectedEpicDefault.default)
];
exports.default = lpEpics;

},{"./getAuthorizedLpsEpic":"jpCij","./getLpSelectedEpic":"g8Z17","./getAuthhorizedEntitiesEpic":"5c8KG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpCij":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthorizedLpsEpic", ()=>getAuthorizedLpsEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _lp = require("../../actions/lp");
var _actionTypes = require("../../actions/lp/actionTypes");
var _ui = require("../../actions/ui");
var _types = require("../../actions/ui/types");
var getAuthorizedLpsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_AUTHORIZED_LPS_REQUEST)), (0, _operators.mergeMap)(function(action) {
        var getAuthorizedLpsInput = action.payload.getAuthorizedLpsInput;
        return (0, _rxjs.from)(api.clwsServices.getAuthorizedLpsService(getAuthorizedLpsInput).pipe((0, _operators.mergeMap)(function(param) {
            var serviceProvidersList = param.LogisticsPartiesInfoList;
            return (0, _rxjs.of)((0, _lp.getAuthorizedLps).success({
                serviceProvidersList: serviceProvidersList,
                serviceProviderIdentifierType: getAuthorizedLpsInput.serviceProviderIdentifierType
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _lp.getAuthorizedLps).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.GET_AUTHORIZED_LPS_FAILURE),
                message: "lps.get_authorized_lps.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = getAuthorizedLpsEpic;

},{"redux-observable":"2KWJL","rxjs":"k96vz","rxjs/operators":"jqupl","../../actions/lp":"fg6Rs","../../actions/lp/actionTypes":"k7dvX","../../actions/ui":"c00tM","../../actions/ui/types":"9G6gl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8Z17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLpSelectedEpic", ()=>getLpSelectedEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _lp = require("../../actions/lp");
var _actionTypes = require("../../actions/lp/actionTypes");
var getLpSelectedEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_AUTHORIZED_LP_SELECTED_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.clwsServices.getLpDetailsService().pipe((0, _operators.mergeMap)(function(param) {
            var logisticsPartyDetails = param.logisticsPartyDetails;
            return (0, _rxjs.of)((0, _lp.getAuthorizedLpSelected).success(logisticsPartyDetails));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _lp.getAuthorizedLpSelected).failure(err));
        })));
    }));
};
exports.default = getLpSelectedEpic;

},{"redux-observable":"2KWJL","rxjs":"k96vz","rxjs/operators":"jqupl","../../actions/lp":"fg6Rs","../../actions/lp/actionTypes":"k7dvX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5c8KG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthorizedEntitiesEpic", ()=>getAuthorizedEntitiesEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _lp = require("../../actions/lp");
var _actionTypes = require("../../actions/lp/actionTypes");
var _ui = require("../../actions/ui");
var _types = require("../../actions/ui/types");
var getAuthorizedEntitiesEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_AUTHORIZED_ENTITIES_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload = action.payload, entityFilter = _action_payload.entityFilter, logisticsPartyId = _action_payload.logisticsPartyId;
        return (0, _rxjs.from)(api.clwsServices.getAuthorizedEntitiesService({
            entityFilter: entityFilter,
            logisticsPartyId: logisticsPartyId
        }).pipe((0, _operators.mergeMap)(function(param) {
            var permissionToEntitiesMap = param.permissionToEntitiesMap;
            return (0, _rxjs.of)((0, _lp.getAuthorizedEntities).success({
                permissionToEntitiesMap: permissionToEntitiesMap
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _lp.getAuthorizedEntities).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.GET_AUTHORIZED_ENTITIES_FAILURE),
                message: "lps.get_authorized_entities.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = getAuthorizedEntitiesEpic;

},{"redux-observable":"2KWJL","rxjs":"k96vz","rxjs/operators":"jqupl","../../actions/lp":"fg6Rs","../../actions/lp/actionTypes":"k7dvX","../../actions/ui":"c00tM","../../actions/ui/types":"9G6gl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2XKl":[function(require,module,exports) {
/*
 * Root reducer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _lp = require("./lp");
var _ui = require("./ui");
var _uiDefault = parcelHelpers.interopDefault(_ui);
var rootReducer = (0, _redux.combineReducers)({
    ui: (0, _uiDefault.default),
    lps: (0, _lp.lpReducer)
});
exports.default = rootReducer;

},{"redux":"9FlA6","./lp":"ko5De","./ui":"7e2oy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ko5De":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "lpReducer", ()=>lpReducer);
var _actionTypes = require("../../actions/lp/actionTypes");
var _routes = require("../../routes");
var _entityPicker = require("../../utils/entityPicker");
var _mapPermissionsToTerms = require("../../utils/mapPermissionsToTerms");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
var initialState = {
    authorizedEntities: {},
    authorizedLps: null,
    authorizedDSPs: null,
    lpSelected: null,
    lpPickerInput: ""
};
function lpReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var type = action.type, payload = action.payload;
    switch(type){
        case _actionTypes.GET_AUTHORIZED_LPS_SUCCESS:
            var serviceProvidersList = payload.serviceProvidersList, serviceProviderIdentifierType = payload.serviceProviderIdentifierType;
            return _object_spread_props(_object_spread({}, state), _define_property({}, (0, _entityPicker.getAuthorizedServiceProvidersState)(serviceProviderIdentifierType), serviceProvidersList));
        case _actionTypes.GET_AUTHORIZED_LPS_FAILURE:
            return _object_spread_props(_object_spread({}, state), {
                authorizedLps: []
            });
        case _actionTypes.GET_AUTHORIZED_ENTITIES_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                authorizedEntities: (0, _mapPermissionsToTerms.mapPermissionsToTerms)(payload.permissionToEntitiesMap)
            });
        case _actionTypes.GET_AUTHORIZED_LP_SELECTED_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                lpSelected: payload
            });
        case _actionTypes.GET_AUTHORIZED_LP_SELECTED_FAILURE:
            window.location.pathname = (0, _routes.pageRoutes).PICKER_PAGE; // If user is unAuthorized for any reason, he should be navigated to /global-picker page for AuthZ
            return state;
        case _actionTypes.SET_LP_PICKER_INPUT:
            return _object_spread_props(_object_spread({}, state), {
                lpPickerInput: action.payload
            });
        default:
            return state;
    }
}

},{"../../actions/lp/actionTypes":"k7dvX","../../routes":"fh1pw","../../utils/entityPicker":"2t923","../../utils/mapPermissionsToTerms":"5EpcN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fh1pw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANDING_PAGE_BASE_PATH", ()=>LANDING_PAGE_BASE_PATH);
parcelHelpers.export(exports, "pageRoutes", ()=>pageRoutes);
parcelHelpers.export(exports, "PROFILE_PAGE", ()=>PROFILE_PAGE);
var LANDING_PAGE_BASE_PATH = "/landing-page";
var pageRoutes = {
    LANDING_PAGE: LANDING_PAGE_BASE_PATH,
    PICKER_PAGE: "/global-picker"
};
var PROFILE_PAGE = "/profile";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2t923":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthorizedServiceProvidersState", ()=>getAuthorizedServiceProvidersState);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
function getAuthorizedServiceProvidersState(serviceProviderIdentifierType) {
    return serviceProviderIdentifierType === (0, _coralComAmazonCarrierlogisticswebserverModel.ServiceProviderIdentifierType).LOGISTICS_PARTY_ID ? "authorizedLps" : "authorizedDSPs";
}

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EpcN":[function(require,module,exports) {
/* eslint-disable no-restricted-syntax */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapPermissionsToTerms", ()=>mapPermissionsToTerms);
var _authorization = require("../constants/authorization");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var mapPermissionsToTerms = function(permissionEntities) {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = _sliced_to_array(_step.value, 2), permission = _step_value[0], entityList = _step_value[1];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _step_value = _sliced_to_array(_step1.value, 2), filter = _step_value[0], entity = _step_value[1];
                    var _result_permission;
                    var existingMap = (_result_permission = result[permission]) !== null && _result_permission !== void 0 ? _result_permission : [];
                    result[permission] = existingMap.concat(entity.map(function(param) {
                        var lpId = param.lpId, term = param.term;
                        return filter === (0, _authorization.ENTITY_FILTER_ENUMS).LP ? lpId : term;
                    }));
                };
                for(var _iterator = Object.entries(entityList)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                } finally{
                    if (_didIteratorError) throw _iteratorError;
                }
            }
        };
        for(var _iterator = Object.entries(permissionEntities)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return updateKeysWithValues(result);
};
var updateKeysWithValues = function(entity) {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = _sliced_to_array(_step.value, 2), permission = _step_value[0], terms = _step_value[1];
            terms.forEach(function(term) {
                var _result_term;
                var existingPermissions = (_result_term = result[term]) !== null && _result_term !== void 0 ? _result_term : [];
                result[term] = _to_consumable_array(existingPermissions).concat([
                    permission
                ]);
            });
        };
        for(var _iterator = Object.entries(entity)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return result;
};

},{"../constants/authorization":"iwYTV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7e2oy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>ui);
var _lodash = require("lodash");
var _types = require("../../actions/ui/types");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var initialState = {
    loading: false,
    pendingRequests: [],
    notifications: []
};
function ui() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 0, _types.ADD_NOTIFICATION:
            return _object_spread_props(_object_spread({}, state), {
                notifications: _to_consumable_array(state.notifications).concat([
                    action.payload
                ])
            });
        case 0, _types.CLOSE_NOTIFICATION:
            return _object_spread_props(_object_spread({}, state), {
                notifications: state.notifications.filter(function(param) {
                    var id = param.id;
                    return id !== action.payload;
                })
            });
        case 0, _types.START_REQUEST_LOADING:
            return _object_spread_props(_object_spread({}, state), {
                pendingRequests: (0, _lodash.uniq)(_to_consumable_array(state.pendingRequests).concat([
                    action.payload
                ]))
            });
        case 0, _types.END_REQUEST_LOADING:
            return _object_spread_props(_object_spread({}, state), {
                pendingRequests: state.pendingRequests.filter(function(call) {
                    return call !== action.payload;
                })
            });
        default:
            return state;
    }
}

},{"lodash":"7vCCa","../../actions/ui/types":"9G6gl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1s9sr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clwsService = require("./clwsService");
exports.default = {
    api: {
        clwsServices: _clwsService
    }
};

},{"./clwsService":"a7Q9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7Q9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthorizedLpsService", ()=>getAuthorizedLpsService);
parcelHelpers.export(exports, "getAuthorizedEntitiesService", ()=>getAuthorizedEntitiesService);
parcelHelpers.export(exports, "getLpDetailsService", ()=>getLpDetailsService);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _carrierLogisticsWebServerClient = require("../clients/CarrierLogisticsWebServerClient");
var _carrierLogisticsWebServerClientDefault = parcelHelpers.interopDefault(_carrierLogisticsWebServerClient);
function getAuthorizedLpsService() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, _carrierLogisticsWebServerClientDefault.default).getAuthorizedLogisticsParties(input);
}
function getAuthorizedEntitiesService(input) {
    return (0, _carrierLogisticsWebServerClientDefault.default).getAuthorizedEntities((0, _coralComAmazonCarrierlogisticswebserverModel.GetAuthorizedEntitiesInput).clone(input));
}
function getLpDetailsService() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0, _carrierLogisticsWebServerClientDefault.default).getLogisticsPartyDetails(input);
}

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","../clients/CarrierLogisticsWebServerClient":"k0dpX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k0dpX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralConfigCarrierLogisticsWebServer = require("@amzn/coral-config_carrier-logistics-web-server");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _requestOptionsInterceptor = require("./RequestOptionsInterceptor");
var _requestOptionsInterceptorDefault = parcelHelpers.interopDefault(_requestOptionsInterceptor);
var _env = require("../config/env");
var _envDefault = parcelHelpers.interopDefault(_env);
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possible_constructor_return(this, result);
    };
}
var clientFactory = new (0, _ihmJsCoralClient.CoralClientFactory)([
    (0, _coralConfigCarrierLogisticsWebServer.CarrierLogisticsWebServerClientConfigFactory)
], (0, _envDefault.default).getEnv(), new (0, _ihmJsCoralClient.InterceptingHandler)(new (0, _ihmJsCoralClient.CoralFetchHandler)(), [
    (0, _coralComAmazonCarrierlogisticswebserverModel.carrierLogisticsWebServerHttpBindingInterceptor),
    new (0, _requestOptionsInterceptorDefault.default)()
]));
/**
 * Custom web server to override serialization/deserialization
 */ var CustomWebServer = /*#__PURE__*/ function(CarrierLogisticsWebServer1) {
    "use strict";
    _inherits(CustomWebServer, CarrierLogisticsWebServer1);
    var _super = _create_super(CustomWebServer);
    function CustomWebServer(config, handler) {
        _class_call_check(this, CustomWebServer);
        return _super.call(this, config, handler);
    }
    return CustomWebServer;
}((0, _coralComAmazonCarrierlogisticswebserverModel.CarrierLogisticsWebServer));
var CarrierLogisticsWebServerClient = clientFactory.get(CustomWebServer);
exports.default = CarrierLogisticsWebServerClient;

},{"@amzn/coral-config_carrier-logistics-web-server":"9l2WX","@amzn/ihm-js-coral-client":"eOj61","@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","./RequestOptionsInterceptor":"3oGZU","../config/env":"dbyme","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9l2WX":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _carrierLogisticsWebServerClientConfigFactory = require("./CarrierLogisticsWebServerClientConfigFactory");
parcelHelpers.exportAll(_carrierLogisticsWebServerClientConfigFactory, exports);

},{"./CarrierLogisticsWebServerClientConfigFactory":"kpjJ9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kpjJ9":[function(require,module,exports) {
/* This file was automatically generated by CoralTypeScriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CarrierLogisticsWebServerClientConfigFactory", ()=>CarrierLogisticsWebServerClientConfigFactory);
var _client = require("@amzn/ihm-js-coral-client/client");
const CarrierLogisticsWebServerClientConfigFactory = new (0, _client.CoralClientConfigFactory)("CarrierLogisticsWebServer", {
    "master.USAmazon": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.gamma.clws.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Gamma": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.gamma.clws.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Beta": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.beta.clws.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Carrierlogistics.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.integ.amazon.com/"
        }
    },
    "prod.carrierlogistics.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.amazon.com/"
        }
    },
    Base: {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "prod.USAmazon": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.prod.clws.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Carrierlogistics.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.amazon.com/"
        }
    },
    "master.carrierlogistics.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics-gamma.aka.amazon.com/"
        }
    },
    "test.carrierlogistics.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.integ.amazon.com/"
        }
    },
    "test.USAmazon": {
        httpEndpoint: {
            url: "http://localhost:3000/"
        }
    },
    "Carrierlogistics.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics-gamma.aka.amazon.com/"
        }
    },
    "desktop.USAmazon": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "http://127.0.0.1:8080/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Development": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "http://127.0.0.1:8080/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Prod": {
        httpClient: {
            clientType: "netty4",
            allIdleTimeout: 55000,
            connectionTimeout: 2500,
            sslMode: "cdoclient.approved"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.prod.clws.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "CarrierLogisticsWebServer/GetAuthorizedEntities": 20000,
                "CarrierLogisticsWebServer/GetAuthorizedLogisticsParties": 20000,
                "CarrierLogisticsWebServer/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    }
});

},{"@amzn/ihm-js-coral-client/client":"7JSEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3oGZU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _externalSiteConstants = require("../config/externalSiteConstants");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possible_constructor_return(this, result);
    };
}
var RequestOptionsInterceptor = /*#__PURE__*/ function(CoralInterceptor1) {
    "use strict";
    _inherits(RequestOptionsInterceptor, CoralInterceptor1);
    var _super = _create_super(RequestOptionsInterceptor);
    function RequestOptionsInterceptor() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, RequestOptionsInterceptor);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    _create_class(RequestOptionsInterceptor, [
        {
            /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns {CoralResponse} response
   */ // eslint-disable-next-line class-methods-use-this
            key: "intercept",
            value: function intercept(request, next) {
                var _sessionStorage_getItem;
                // Adding required header
                var headers = [
                    [
                        "Accept",
                        "application/json"
                    ],
                    [
                        "Content-Type",
                        "application/json"
                    ],
                    [
                        (0, _externalSiteConstants.CSRF_TOKEN_ID),
                        (_sessionStorage_getItem = sessionStorage.getItem((0, _externalSiteConstants.CSRF_TOKEN_ID))) !== null && _sessionStorage_getItem !== void 0 ? _sessionStorage_getItem : ""
                    ]
                ];
                var modifiedRequest = request.clone({
                    headers: headers,
                    credentials: "same-origin"
                });
                return (0, _rxjs.from)(next.handle(modifiedRequest)).pipe((0, _operators.map)(function(response) {
                    var _responseHeaders;
                    var responseHeaders = response.headers;
                    var _responseHeaders_find;
                    var _ref = _sliced_to_array((_responseHeaders_find = (_responseHeaders = responseHeaders) === null || _responseHeaders === void 0 ? void 0 : _responseHeaders.find(function(param) {
                        var _param = _sliced_to_array(param, 1), k = _param[0];
                        return k === (0, _externalSiteConstants.CSRF_TOKEN_ID);
                    })) !== null && _responseHeaders_find !== void 0 ? _responseHeaders_find : [
                        (0, _externalSiteConstants.CSRF_TOKEN_ID),
                        ""
                    ], 2), csrfToken = _ref[1];
                    // Adding monsCustomerId to session storage for future reference in apis.
                    sessionStorage.setItem((0, _externalSiteConstants.CSRF_TOKEN_ID), csrfToken);
                    return new (0, _ihmJsCoralClient.CoralResponse)(response);
                }));
            }
        }
    ]);
    return RequestOptionsInterceptor;
}((0, _ihmJsCoralClient.CoralInterceptor));
exports.default = RequestOptionsInterceptor;

},{"rxjs":"k96vz","rxjs/operators":"jqupl","@amzn/ihm-js-coral-client":"eOj61","../config/externalSiteConstants":"eEY3L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eEY3L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSRF_TOKEN_ID", ()=>CSRF_TOKEN_ID);
var CSRF_TOKEN_ID = "anti-csrftoken-a2z";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbyme":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointConfig = require("./endpointConfig");
var getEnv = function() {
    var url = window.location.href;
    var env;
    if (url.includes((0, _endpointConfig.URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.CLWS_CORAL_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.CLWS_CORAL_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.CLWS_CORAL_CONFIG).PROD_CONFIG;
    else env = (0, _endpointConfig.CLWS_CORAL_CONFIG).LOCAL_DEV;
    return env;
};
var envHelper = {
    getEnv: getEnv
};
exports.default = envHelper;

},{"./endpointConfig":"1KGgB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1KGgB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URL_PREFIXES", ()=>URL_PREFIXES);
parcelHelpers.export(exports, "CLWS_CORAL_CONFIG", ()=>CLWS_CORAL_CONFIG);
var URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon"
};
var CLWS_CORAL_CONFIG = {
    BETA_CONFIG: "Carrierlogistics.Beta.USAmazon",
    GAMMA_CONFIG: "Carrierlogistics.Gamma.USAmazon",
    PROD_CONFIG: "Carrierlogistics.Prod.USAmazon",
    LOCAL_DEV: "test.USAmazon"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"biaRa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types = require("../../actions/ui/types");
/**
 * custom middleware to route on action dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */ function createRouterMiddleware() {
    return function() {
        return function(next) {
            return function(action) {
                var type = action.type;
                if (type === (0, _types.PUSH_ROUTE)) {
                    var _action_payload = action.payload, history = _action_payload.history, route = _action_payload.route;
                    history.push(route);
                }
                return next(action);
            };
        };
    };
}
var routerMiddleware = createRouterMiddleware();
exports.default = routerMiddleware;

},{"../../actions/ui/types":"9G6gl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdEl4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _close = require("@amzn/meridian-tokens/base/icon/close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _sheet = require("@amzn/meridian/sheet");
var _sheetDefault = parcelHelpers.interopDefault(_sheet);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("@amzn/meridian/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _heading = require("@amzn/meridian/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _box = require("@amzn/meridian/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _arrowLeftLarge = require("@amzn/meridian-tokens/base/icon/arrow-left-large");
var _arrowLeftLargeDefault = parcelHelpers.interopDefault(_arrowLeftLarge);
var _reactIntl = require("react-intl");
var _sheetContent = require("./containers/SheetContent");
var _sheetContentDefault = parcelHelpers.interopDefault(_sheetContent);
var _useInlineHelp = require("./hooks/useInlineHelp");
var _useInlineHelpDefault = parcelHelpers.interopDefault(_useInlineHelp);
var _withIntl = require("./hoc/withIntl");
var _withIntlDefault = parcelHelpers.interopDefault(_withIntl);
var _pageHistoryStore = require("./store/pageHistoryStore");
var SlideOutSheet = function() {
    var pageHistory = (0, _pageHistoryStore.getpageHistoryStoreValue)();
    var shouldRenderBackButton = pageHistory.length > 0;
    var _useInlineHelp = (0, _useInlineHelpDefault.default)(), pageId = _useInlineHelp.pageId, closeInlineHelpSheet = _useInlineHelp.closeInlineHelpSheet, navigateToPrevPage = _useInlineHelp.navigateToPrevPage;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    var open = !!pageId;
    if (!pageId) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sheetDefault.default), {
        type: "overlay",
        side: "right",
        open: open,
        onClose: closeInlineHelpSheet
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        spacing: "300",
        width: "320px",
        height: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        alignmentHorizontal: "justify"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        spacing: "none"
    }, shouldRenderBackButton && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        onClick: navigateToPrevPage,
        type: "icon"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        tokens: (0, _arrowLeftLargeDefault.default)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        level: 2
    }, formatMessage({
        id: "messages.dev_app.title"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        onClick: closeInlineHelpSheet,
        type: "icon"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        tokens: (0, _closeDefault.default)
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        overflowY: "scroll"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sheetContentDefault.default), {
        pageId: pageId
    }))));
};
exports.default = (0, _withIntlDefault.default)(SlideOutSheet);

},{"react":"6uln9","@amzn/meridian-tokens/base/icon/close":"2AQYC","@amzn/meridian/sheet":"4UxsJ","@amzn/meridian/column":"aw8aI","@amzn/meridian/row":"2VLMq","@amzn/meridian/button":"9uVFW","@amzn/meridian/icon":"fxUjK","@amzn/meridian/heading":"biBV3","@amzn/meridian/box":"dULlg","@amzn/meridian-tokens/base/icon/arrow-left-large":"d3SJz","react-intl":"63umq","./containers/SheetContent":"1ZcAm","./hooks/useInlineHelp":"kqnal","./hoc/withIntl":"bUddL","./store/pageHistoryStore":"5zuD2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2AQYC":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconCloseData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1.76 1.76l8.48 8.48M10.24 1.76l-8.48 8.48'/%3e%3c/g%3e%3c/svg%3e",
    iconCloseWidth: 12,
    iconCloseHeight: 12
};

},{}],"4UxsJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("11fcad8a05b7071e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _sheet = _interopRequireDefault(require("ab69ce884e881d5c"));
var _default = _sheet["default"];
exports["default"] = _default;

},{"11fcad8a05b7071e":"hVU2P","ab69ce884e881d5c":"5DRhk"}],"hVU2P":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault;

},{}],"5DRhk":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("213db4879a57f7f5");
var _interopRequireDefault = require("d2465fa08722003a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("ae8c676d11295d57"));
var _defineProperty2 = _interopRequireDefault(require("db52da57c26ddee2"));
var _react = _interopRequireWildcard(require("da7fe195e72ca0a9"));
var _keycode = _interopRequireDefault(require("4bf7455b722dc1d2"));
var _emotion = require("4f8ecace5cec6b40");
var _propTypes = _interopRequireDefault(require("ffbf8f2b77427fd4"));
var _sheet = _interopRequireDefault(require("ba4c30d57fdb3d5"));
var _scrim = _interopRequireDefault(require("1a8ac4272959bb4b"));
var _theme = require("c09004c335fe2ad");
var _expanderController = _interopRequireDefault(require("3cf078beb96d6296"));
var _scrim2 = _interopRequireDefault(require("f2014279b7327c34"));
var _portal = _interopRequireDefault(require("be6d0e559ce5f387"));
var _focusTrap = _interopRequireDefault(require("ba2324a341c7ca01"));
var _useFocus2 = _interopRequireDefault(require("9e3b026810fbb35d"));
var _focus = require("44ee5f23ed16715");
var _token = require("f240c153beefdbcd");
var _parsers = require("763390531a55dc07");
var _filterPropsByPrefix = _interopRequireDefault(require("b4b62a1df6dcf49f"));
var borderSides = {
    left: "borderRight",
    right: "borderLeft",
    bottom: "borderTop"
};
var containerStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var _css;
    var side = _ref.side, spacingInset = _ref.spacingInset, backgroundColor = _ref.backgroundColor;
    return (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, borderSides[side], t.borderCss("border")), (0, _defineProperty2["default"])(_css, "& > div", {
        backgroundColor: backgroundColor,
        padding: "".concat((0, _parsers.parseSpacing)(spacingInset), "px"),
        outline: "none",
        overflowY: "auto",
        boxSizing: "border-box",
        maxHeight: side === "bottom" ? "calc(100vh - ".concat(t("minimumPageReveal"), "px)") : undefined
    }), _css));
}, [
    "side",
    "spacingInset",
    "backgroundColor"
]);
var modalStyles = function modalStyles(tScrim, t, _ref2) {
    var _ref3;
    var side = _ref2.side;
    return (0, _emotion.css)({
        zIndex: tScrim("elevation") - 1,
        position: "fixed",
        boxShadow: "".concat(t("shadowOffset", [
            side,
            "x"
        ]), "px ").concat(t("shadowOffset", [
            side,
            "y"
        ]), "px ").concat(t("shadow", "blur"), "px ").concat(t("shadow", "spread"), "px ").concat(t("shadow", "color"), "}")
    }, side === "bottom" ? {
        bottom: 0,
        left: 0,
        right: 0
    } : (_ref3 = {
        top: 0
    }, (0, _defineProperty2["default"])(_ref3, side, 0), (0, _defineProperty2["default"])(_ref3, "bottom", 0), _ref3));
};
var overlayScrimStyles = function overlayScrimStyles(_ref4) {
    var tScrim = _ref4.tScrim;
    return (0, _emotion.css)({
        zIndex: tScrim("elevation") - 2
    });
}; // Overlay expanders are put into a portal
var OverlayExpanderController = function OverlayExpanderController(props) {
    return /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, /*#__PURE__*/ _react["default"].createElement(_expanderController["default"], props));
};
/**
 * This component renders a sheet that enters/exits on a particular side of
 * the screen. The sheet can appear as a overlay above other components or
 * displace surrounding components.
 *
 * @since 5.x
 */ var Sheet = function Sheet(props) {
    var open = props.open, side = props.side, onClose = props.onClose, spacingInset = props.spacingInset, onOpen = props.onOpen; // Always render children if closed size is set greater than 0 or
    // we're explicitly told via props
    var alwaysRenderChildren = props.closedSize !== undefined && props.closedSize > 0 || props.alwaysRenderChildren; // If we're always visible, force type to be push
    var type = alwaysRenderChildren ? "push" : props.type;
    var t = (0, _theme.useTheme)(_sheet["default"], "sheet");
    var tScrim = (0, _theme.useTheme)(_scrim["default"], "scrim");
    var hasMounted = (0, _react.useRef)(false);
    var contentRef = (0, _react.useRef)(); // DOM node wrapping sheet content
    var anchorRef = (0, _react.useRef)(); // DOM element that originally opened sheet
    var initializeContentRef = (0, _react.useCallback)(function(contentProps) {
        return function(element) {
            contentRef.current = element;
            contentProps.ref(element);
        };
    }, []);
    var backgroundColor = (0, _react.useMemo)(function() {
        return (0, _token.getToken)(t.tokens, "themeBackground", [
            props.backgroundColor,
            "default"
        ]) || props.backgroundColor;
    }, [
        t,
        props.backgroundColor
    ]); // Put "overlay" sheets, which are essentially modals, in an expander that has built
    // in portal and focus trap.
    var Expander = (0, _react.useCallback)(function(props) {
        return /*#__PURE__*/ _react["default"].createElement(type === "overlay" ? OverlayExpanderController : _expanderController["default"], props);
    }, [
        type
    ]); // Put "overlay" sheets, which are essentially modals, in a focus trap
    var SheetWrapper = (0, _react.useCallback)(function(props) {
        return /*#__PURE__*/ _react["default"].createElement(type === "overlay" ? _focusTrap["default"] : _react["default"].Fragment, props);
    }, [
        type
    ]); // Overlay sheets are essentially modals. Here we add an keyboard listener
    // that closes the sheet when the user presses the "esc" key.
    // https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal
    (0, _react.useEffect)(function() {
        if (type === "overlay" && onClose) {
            var onKeyDown = function onKeyDown(e) {
                if ((0, _keycode["default"])(e) === "esc") onClose();
            };
            window.addEventListener("keydown", onKeyDown);
            return function() {
                return window.removeEventListener("keydown", onKeyDown);
            };
        }
    }, [
        type,
        onClose
    ]); // On open, move focus to the first focusable element. On close, move focus
    // back to the original element that opened the sheet.
    var onAfterOpen = (0, _react.useCallback)(function() {
        // Run this effect only after the component has mounted. Else, sheet
        // that load as `open` will immediately take over the active element.
        if (hasMounted.current && contentRef.current) {
            var firstFocusableNode = (0, _focus.getKeyboardFocusNodes)(contentRef.current)[0];
            if (firstFocusableNode) firstFocusableNode.focus();
            else contentRef.current.focus();
        }
    }, []); // On close, return focus to where it was before the bottom sheet was opened.
    var onAfterClose = (0, _react.useCallback)(function() {
        if (anchorRef.current) anchorRef.current.focus();
    }, []); // When opening, record which element opened the sheet
    (0, _react.useEffect)(function() {
        if (open) anchorRef.current = document.activeElement;
        hasMounted.current = true;
    }, [
        open
    ]);
    (0, _react.useEffect)(function() {
        if (open && onOpen) onOpen();
    }, [
        open,
        onOpen
    ]);
    var _useFocus = (0, _useFocus2["default"])({
        multipleNodes: true,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }), focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(Expander, {
        open: open,
        direction: side === "bottom" ? "down" : side,
        motionDuration: props.motionDuration || parseInt(t("motionTiming")),
        motionFunction: props.motionFunction || t("motionFunction"),
        onAfterOpen: onAfterOpen,
        onAfterClose: onAfterClose,
        alwaysRenderChildren: alwaysRenderChildren,
        closedSize: props.closedSize
    }, function(_ref5) {
        var state = _ref5.state, containerProps = _ref5.containerProps, contentProps = _ref5.contentProps;
        // The children of a sheet might be interested in the state of the expander
        // to dynamically hide/show components for various stages. For example, skinny
        // SideMenu shows different links based on the expander state.
        var children = typeof props.children === "function" ? props.children({
            expanderState: state
        }) : props.children;
        return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(SheetWrapper, null, /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
            className: (0, _emotion.cx)(props.className, containerStyles(t, {
                side: side,
                spacingInset: spacingInset,
                backgroundColor: backgroundColor
            }), type === "overlay" ? modalStyles(tScrim, t, {
                side: side
            }) : undefined, containerProps.className)
        }), /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: contentProps.className,
            id: props.id,
            ref: initializeContentRef(contentProps),
            role: type === "overlay" ? "dialog" : undefined,
            "aria-modal": type === "overlay" ? true : undefined,
            tabIndex: "-1",
            "aria-labelledby": props.labelledById,
            "aria-describedby": props.describedById,
            onKeyDown: props.onKeyDown
        }), children))), type === "overlay" ? /*#__PURE__*/ _react["default"].createElement(_scrim2["default"], {
            className: overlayScrimStyles({
                tScrim: tScrim
            }),
            onClick: props.onClose,
            open: state === "entering" || state === "entered",
            duration: t("motionTiming")
        }) : null);
    });
};
Sheet.displayName = "Sheet";
Sheet.propTypes = {};
Sheet.defaultProps = {
    type: "push",
    open: false,
    side: "right",
    spacingInset: "medium",
    backgroundColor: "alternatePrimary"
};
var _default = Sheet;
exports["default"] = _default;

},{"213db4879a57f7f5":"jNy6G","d2465fa08722003a":"hVU2P","ae8c676d11295d57":"5G7gB","db52da57c26ddee2":"74DXJ","da7fe195e72ca0a9":"6uln9","4bf7455b722dc1d2":"2YoiJ","4f8ecace5cec6b40":"kbmlY","ffbf8f2b77427fd4":"1hOJi","ba4c30d57fdb3d5":"gloX6","1a8ac4272959bb4b":"i5KEc","c09004c335fe2ad":"f7yMb","3cf078beb96d6296":"4BhjO","f2014279b7327c34":"46QLi","be6d0e559ce5f387":"dkg9Y","ba2324a341c7ca01":"hRglT","9e3b026810fbb35d":"1Rsyx","44ee5f23ed16715":"deEJ0","f240c153beefdbcd":"dp1DQ","763390531a55dc07":"7BvDg","b4b62a1df6dcf49f":"aJ6so"}],"jNy6G":[function(require,module,exports) {
var _typeof = require("53454fcdac7ea0f2");
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
module.exports = _interopRequireWildcard;

},{"53454fcdac7ea0f2":"gC4jv"}],"gC4jv":[function(require,module,exports) {
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
module.exports = _typeof;

},{}],"5G7gB":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
module.exports = _extends;

},{}],"74DXJ":[function(require,module,exports) {
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty;

},{}],"2YoiJ":[function(require,module,exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && "object" === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ("number" === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === "string") {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === "number") return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes["f" + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes["numpad " + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

},{}],"kbmlY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _createEmotion = require("create-emotion");
var _createEmotionDefault = parcelHelpers.interopDefault(_createEmotion);
var _createEmotion1 = (0, _createEmotionDefault.default)(), flush = _createEmotion1.flush, hydrate = _createEmotion1.hydrate, cx = _createEmotion1.cx, merge = _createEmotion1.merge, getRegisteredStyles = _createEmotion1.getRegisteredStyles, injectGlobal = _createEmotion1.injectGlobal, keyframes = _createEmotion1.keyframes, css = _createEmotion1.css, sheet = _createEmotion1.sheet, cache = _createEmotion1.cache;

},{"create-emotion":"k03Sb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k03Sb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
exports.default = createEmotion;

},{"@emotion/cache":"lftrH","@emotion/serialize":"k7zlz","@emotion/utils":"4RPcQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lftrH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sheet = require("@emotion/sheet");
var _stylis = require("@emotion/stylis");
var _stylisDefault = parcelHelpers.interopDefault(_stylis);
var _weakMemoize = require("@emotion/weak-memoize");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = "/*|*/";
var needle = delimiter + "}";
function toSheet(block) {
    if (block) Sheet.current.insert(block + "}");
}
var Sheet = {
    current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? delimiter : "");
            }
        case -2:
            content.split(needle).forEach(toSheet);
    }
};
var createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, _stylisDefault.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
exports.default = createCache;

},{"@emotion/sheet":"jDVWY","@emotion/stylis":"217fo","@emotion/weak-memoize":"eygjj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDVWY":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"217fo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
exports.default = stylis_min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eygjj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
exports.default = weakMemoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7zlz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var shouldWarnAboutInterpolatingClassNameFromCss = true;
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"jkZ1g","@emotion/unitless":"iEKUt","@emotion/memoize":"kCJIn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jkZ1g":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
exports.default = murmur2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iEKUt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kCJIn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4RPcQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1hOJi":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("a687334b73c971d")();

},{"a687334b73c971d":"bQYoP"}],"bQYoP":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("8a187f2fcf74fcd9");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"8a187f2fcf74fcd9":"bnr8J"}],"bnr8J":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"gloX6":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        sheetMinimumPageReveal: 40,
        sheetMotionTiming: "200ms",
        sheetMotionFunction: "ease",
        sheetBorderWidth: 1,
        sheetBorderRadius: 0,
        sheetBorderColor: tokens.themeBorderSecondaryDefault,
        sheetShadowColor: "rgba(11, 12, 12, 0.1)",
        sheetShadowBlur: 16,
        sheetShadowSpread: 0,
        sheetShadowOffsetBottomX: 0,
        sheetShadowOffsetBottomY: -8,
        sheetShadowOffsetLeftX: 8,
        sheetShadowOffsetLeftY: 0,
        sheetShadowOffsetRightX: -8,
        sheetShadowOffsetRightY: 0
    };
};

},{}],"i5KEc":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        scrimBackgroundColor: tokens.themeBackgroundOverlayDefault,
        scrimMotionTiming: "150ms",
        scrimMotionFunction: "ease",
        scrimElevation: 60
    };
};

},{}],"f7yMb":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("e16dde67e461b095");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function get() {
        return _theme.useTheme;
    }
});
Object.defineProperty(exports, "Style", {
    enumerable: true,
    get: function get() {
        return _theme.Style;
    }
});
exports["default"] = void 0;
require("955ec7f176272f09");
var _theme = _interopRequireWildcard(require("fb0e34e80910c568"));
var _default = _theme["default"];
exports["default"] = _default;

},{"e16dde67e461b095":"jNy6G","955ec7f176272f09":"l7LuQ","fb0e34e80910c568":"bfhzX"}],"l7LuQ":[function(require,module,exports) {
"use strict";
var _emotion = require("b9fd4ac188482ad2");
/**
 * Global styles
 */ (0, _emotion.injectGlobal)({
    /**
   * Set font smoothing technique
   *
   * On macOS the default font smoothing technique (subpixel antialiasing) is
   * optimized for dark text on light backgrounds. Unfortunately when applied to
   * light text on dark backgrounds this results in extra heavy, fuzzy text. The
   * following two properties turn off subpixel antialiasing in webkit browsers
   * and Firefox on macOS when the display's pixel density is high enough to
   * support full-pixel aliasing without decreasing text legibility.
   */ "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx)": {
        body: {
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale"
        }
    },
    /**
   * HACK: Fix html5 tags in IE11
   *
   * IE11 won't apply styles correctly to newer html5 tags that it doesn't
   * recognize unless they have a "display" property set.
   */ "main, nav, header, footer": {
        display: "block"
    }
});

},{"b9fd4ac188482ad2":"kbmlY"}],"bfhzX":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("9e91ac7ff9e70e17");
var _interopRequireDefault = require("a54faaa7e48ce3e1");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Style = Style;
exports.ThemeContext = exports.useTheme = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("3e8f84ee33a7574"));
var _react = _interopRequireWildcard(require("345a77195ed2a957"));
var _propTypes = _interopRequireDefault(require("8b46808515d6c726"));
var _blueLight = _interopRequireDefault(require("1c72fd24eb29c1d8"));
var _token = require("f339f466252ee491");
var _functional = require("d6dea249333d1da7");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Context for passing theme tokens down the tree.
 */ var ThemeContext = /*#__PURE__*/ (0, _react.createContext)(_blueLight["default"]);
/**
 * Merge two token objects together.
 */ exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function(a, b) {
    return _objectSpread(_objectSpread({}, a), b);
}, 1);
/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */ var applyTheme = (0, _functional.memoizeCurry)(function(themeTokens, tokens) {
    return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
/**
 * A hook that grants access to theme tokens. Optionally pass in themeable
 * tokens as a function or non-themeable tokens as an object to mix with the
 * theme tokens. If tokens are provided, a prefixKey can be passed to allow easier
 * selection of tokens with a common prefix. For example:
 *   const t = useTheme(buttonTokens, "button")
 *   const buttonBgColor = t("backgroundColor")
 */ var useTheme = function useTheme(tokens) {
    var prefixKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var _legacyHelperForBackwardsCompatibilityDoNotUse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var themeTokens = (0, _react.useContext)(ThemeContext);
    var currentTokens = applyTheme(themeTokens)(tokens);
    return typeof _legacyHelperForBackwardsCompatibilityDoNotUse === "function" ? _legacyHelperForBackwardsCompatibilityDoNotUse(currentTokens) : _legacyHelperForBackwardsCompatibilityDoNotUse ? currentTokens : (0, _token.getTokenHelper)(prefixKey)(currentTokens);
};
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */ exports.useTheme = useTheme;
function Theme(_ref) {
    var tokens = _ref.tokens, children = _ref.children;
    var contextTokens = (0, _react.useContext)(ThemeContext);
    var currentTokens = mergeTokens(contextTokens)(tokens);
    return /*#__PURE__*/ _react["default"].createElement(ThemeContext.Provider, {
        value: currentTokens
    }, children);
}
Theme.propTypes = {};
/**
 * IMPORTANT: For backwards-compatibility only! Use the "useTheme" hook instead.
 */ function Style(_ref2) {
    var tokens = _ref2.tokens, map = _ref2.map, children = _ref2.children;
    return children(useTheme(tokens, "", map || true));
}
Style.propTypes = {
    children: _propTypes["default"].func.isRequired,
    map: _propTypes["default"].func,
    tokens: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        _propTypes["default"].object
    ])
};
var _default = Theme;
exports["default"] = _default;

},{"9e91ac7ff9e70e17":"jNy6G","a54faaa7e48ce3e1":"hVU2P","3e8f84ee33a7574":"74DXJ","345a77195ed2a957":"6uln9","8b46808515d6c726":"1hOJi","1c72fd24eb29c1d8":"9s5Kc","f339f466252ee491":"dp1DQ","d6dea249333d1da7":"4L61K"}],"dp1DQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("17b3edc954d410b9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.memoizeTokenStyles = exports.removeTokenPrefixes = exports.getUnthemedTokens = exports.getIconFromTokens = exports.getTokenHelper = exports.getToken = void 0;
var _pascalCase = _interopRequireDefault(require("7f4026bfa6a87858"));
var _upperFirst = _interopRequireDefault(require("26eb4a8b4a14d465"));
var _lowerFirst = _interopRequireDefault(require("c8d4766241545910"));
var _functional = require("a976aa58cd8c344c");
/**
 * Select a single token from a token object given a key (and optionally a
 * "suffix" key or list of suffix keys). If the token doesn't exist then an
 * attempt is made to replace the last suffix key with "default" and get the
 * value for that token. If that token also doesn't exist then `undefined` is
 * returned.
 *
 * @example
 * const tokens = {
 *   backgroundColorDefault: "#fff",
 *   backgroundColorHover: "#ccc",
 *   backgroundColorPressed: "#f00",
 * }
 * getToken(tokens, "backgroundColor", "active") // #fff
 * getTokens(tokens, "background", ["color", "pressed"]) // #f00
 * getToken(tokens, "myBackgroundColor") // undefined
 */ var getToken = function getToken(tokens, key, suffixKeys) {
    // If we got an array of suffix keys, turn them into a PascalCaseString and
    // look up the token
    if (suffixKeys && Array.isArray(suffixKeys)) {
        var value = tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys))];
        return value !== undefined ? value : tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys.slice(0, -1)), "Default")]; // If we got a single suffix key then upper case the first character and look
    // up the token
    } else if (suffixKeys) {
        var _value = tokens["".concat(key).concat((0, _upperFirst["default"])(suffixKeys))];
        return _value !== undefined ? _value : tokens["".concat(key, "Default")]; // If we didn't get any suffix keys then do a simple lookup
    } else return tokens[key];
};
/**
 * This will, given a root key and token object, return a special helper that
 * includes token utilities with those inputs already applied. Calling the
 * helper as a function is equivalent to calling `getToken`, but the helper also
 * includes several properties that make it easier to construct CSS from tokens.
 * This helper is useful when working with an object of tokens that all have the
 * same prefix.
 *
 * @example
 * const tokens = {
 *   buttonBorderWidth: 1,
 *   buttonBorderStyle: "dotted",
 *   buttonBorderColor: "#f00",
 * }
 * const t = getTokenHelper("button")(tokens)
 * t("borderWidth") // 1
 * t.borderCss("border") // "1px dotted #f00"
 * t.tokens === tokens // true
 *
 */ exports.getToken = getToken;
var getTokenHelper = (0, _functional.memoizeCurry)(function(prefixKey, tokens) {
    var helper = function helper(key, suffixKeys) {
        return getToken(tokens, prefixKey ? "".concat(prefixKey).concat((0, _upperFirst["default"])(key)) : key, suffixKeys);
    };
    helper.tokens = tokens; // Pass in "myBorder" and shorthand border css will be generated based on
    // "myBorderWidth" and "myBorderColor" tokens.
    helper.borderCss = function(key) {
        var width = helper(key, "width");
        var color = helper(key, "color");
        return width && color ? "".concat(width, "px solid ").concat(color) : undefined;
    }; // Pass in "myShadow" and shorthand box shadow css will be generated based on
    // "myShadowOffsetX", "myShadowOffsetY", "myShadowBlur", "myShadowSpread",
    // and "myShadowColor" tokens
    helper.boxShadowCss = function(key) {
        var color = helper(key, "color");
        return color ? "".concat(helper(key, "offsetX"), "px ").concat(helper(key, "offsetY"), "px ").concat(helper(key, "blur"), "px ").concat(helper(key, "spread"), "px ").concat(color) : undefined;
    }; // Pass in "myMotion" and a single css property or array of properties and
    // shorthand transition css will be generated that animates those properties
    // based on "myMotionFunction" and "myMotionDuration" tokens
    helper.transitionCss = function(key, properties) {
        var transition = "".concat(helper(key, "duration"), " ").concat(helper(key, "function"));
        return Array.isArray(properties) ? properties.map(function(property) {
            return "".concat(property, " ").concat(transition);
        }).join(", ") : "".concat(properties, " ").concat(transition);
    };
    return helper;
}, 1);
/**
 * Gets icon data from a set of icon tokens
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * getIconFromTokens(tokens)
 * ```
 */ exports.getTokenHelper = getTokenHelper;
var getIconFromTokens = function getIconFromTokens(tokens) {
    return Object.keys(tokens).reduce(function(result, key) {
        if (key.indexOf("Data") > 0) result.data = tokens[key];
        else if (key.indexOf("Width") > 0) result.width = tokens[key];
        else if (key.indexOf("Height") > 0) result.height = tokens[key];
        return result;
    }, {});
};
/**
 * If you pass in a function that returns themed tokens when given a theme
 * object (e.g. any of our "component" tokens), this will call that function
 * with an empty theme object and filter out any tokens that are undefined. This
 * is useful for quickly accessing unthemed component tokens. Use this sparingly
 * as what is and is not themed may change in the future and require a refactor
 * of any code using this function.
 */ exports.getIconFromTokens = getIconFromTokens;
var getUnthemedTokens = function getUnthemedTokens(tokens) {
    var unthemedTokens = tokens({});
    return Object.keys(unthemedTokens).reduce(function(result, key) {
        if (unthemedTokens[key] !== undefined) result[key] = unthemedTokens[key];
        return result;
    }, {});
};
/**
 * Takes an object of tokens and removes the prefix from each token name (object
 * key). The result is returned with the first character of the new keys
 * lowercased.
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * removetokenPrefixes(tokens, "iconCheckmark")
 * ```
 */ exports.getUnthemedTokens = getUnthemedTokens;
var removeTokenPrefixes = function removeTokenPrefixes(tokens, prefix) {
    var match = new RegExp("^".concat(prefix));
    return Object.keys(tokens).reduce(function(result, key) {
        if (match.test(key)) result[(0, _lowerFirst["default"])(key.replace(match, ""))] = tokens[key];
        return result;
    }, {});
};
/**
 * Memoize f(tokens, props) that is used extensively throughout meridian components,
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * @example
 * const style = memoizeTokenStyles((t, {a, b}) => css({a, b}), ["a", "b"])
 * style(tokens, {a, b})
 */ exports.removeTokenPrefixes = removeTokenPrefixes;
var memoizeTokenStyles = function memoizeTokenStyles(f, keys) {
    /* eslint-disable-next-line rulesdir/no-partial-memoization */ var fn = (0, _functional.memoize)(function(t) {
        return (0, _functional.memoizeByKeys)(function(props) {
            return f(t, props);
        }, keys);
    });
    return function(t, props) {
        return fn(t)(props);
    };
};
exports.memoizeTokenStyles = memoizeTokenStyles;

},{"17b3edc954d410b9":"hVU2P","7f4026bfa6a87858":"7LLEA","26eb4a8b4a14d465":"bD5mI","c8d4766241545910":"kjefB","a976aa58cd8c344c":"4L61K"}],"7LLEA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("54491f601ecb277d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _upperFirst = _interopRequireDefault(require("8a5cd333d37530b"));
var pascalCase = function pascalCase(strings) {
    return strings.map(_upperFirst["default"]).join("");
};
var _default = pascalCase;
exports["default"] = _default;

},{"54491f601ecb277d":"hVU2P","8a5cd333d37530b":"bD5mI"}],"bD5mI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var upperFirst = function upperFirst(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};
var _default = upperFirst;
exports["default"] = _default;

},{}],"kjefB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var lowerFirst = function lowerFirst(str) {
    return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
};
var _default = lowerFirst;
exports["default"] = _default;

},{}],"4L61K":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.memoize = memoize;
exports.memoizeCurry = memoizeCurry;
exports.memoizeByKeys = memoizeByKeys;
exports.memoizeArray = memoizeArray;
/**
 * Author: shekwong@
 */ var END = new Object();
/**
 * Memoize a function with one argument.
 *
 * @example
 * const square = a => a * a
 * const memoizedSquare = memoize(square)
 * memoizedSquare(2) // 4
 */ function memoize(f) {
    var memo = new Map();
    return function(i) {
        if (memo.has(i)) return memo.get(i);
        var result = f(i);
        memo.set(i, result);
        return result;
    };
}
/**
 * Memoize a function with N args by currying it
 *
 * @example
 * const multiply = (a, b) => a * b
 * const memoizedMultiply = memoize(multiply, 1)
 * memoizedMultiply(2)(3) // 6
 */ function memoizeCurry(f, depth) {
    var a = f;
    if (depth == 0) return memoize(a);
    return memoize(function(x) {
        return memoizeCurry(a.bind(null, x), depth - 1);
    });
}
/**
 * A helper function used by memoizeByKeys.
 */ function memoizeByKeysCurry(f, resolver, depth) {
    var a = f;
    if (depth == 0) return memoize(resolver);
    return memoize(function(x) {
        return memoizeByKeysCurry(a.bind(null, x), resolver, depth - 1);
    });
}
/**
 * Memoize a function that accepts an object as its only argument. You must
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * NOTE: This can only support properties in the object that are simple (e.g.
 * strings, numbers, booleans, not nested objects or arrays).
 *
 * @example
 * const multiply = ({ a, b }) => a * b
 * cont memoizedMultiply = memoizeByKeys(multiply, ["a", "b"])
 * memoizedMultiply({ a: 2, b: 3 }) // 6
 */ function memoizeByKeys(f, keys) {
    var args = undefined;
    var g = memoizeByKeysCurry(f, function() {
        return f(args);
    }, keys.length - 1);
    return function(a) {
        if (!a) {
            var _c = g;
            keys.forEach(function() {
                _c = _c(undefined);
            });
            return _c;
        }
        args = a;
        var c = g;
        keys.forEach(function(k) {
            c = c(args[k]);
        });
        return c;
    };
}
/**
 * A helper function used by memoizeArray.
 */ function memoizeByVarArgsCurry(f) {
    var a = f;
    return memoize(function(x) {
        return x === END ? a() : memoizeByVarArgsCurry(a.bind(null, x));
    });
}
/**
 * Memoize a function that accepts an array as its only argument.
 *
 * @example
 * const multiply = numbers => numbers.reduce((result, num) => result * num)
 * cont memoizedMultiply = memoizeArray(multiply)
 * memoizedMultiply([2, 3, 4]) // 24
 */ function memoizeArray(f) {
    var memoized = memoizeByVarArgsCurry(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return f(args);
    });
    return function(vals) {
        var g = memoized;
        vals.forEach(function(v) {
            g = g(v);
        });
        return g(END);
    };
}

},{}],"4BhjO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("558f9d39df3af113");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _expanderController = _interopRequireDefault(require("3529d55927574947"));
var _default = _expanderController["default"];
exports["default"] = _default;

},{"558f9d39df3af113":"hVU2P","3529d55927574947":"8O5QD"}],"8O5QD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6819a4eee9ed7e8f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("12e8a6ec02152b1f"));
var _classCallCheck2 = _interopRequireDefault(require("c78cbecad7305a9f"));
var _createClass2 = _interopRequireDefault(require("c540e32bc77c27d2"));
var _assertThisInitialized2 = _interopRequireDefault(require("84b2fcaecd9ff52b"));
var _inherits2 = _interopRequireDefault(require("b48efaf4dabb17c9"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("847000dcbc21e0c"));
var _getPrototypeOf2 = _interopRequireDefault(require("3965067c6797a1a1"));
var _defineProperty2 = _interopRequireDefault(require("61afc31cd35ed48b"));
var _react = _interopRequireDefault(require("bf2c88b27c9f3c7b"));
var _propTypes = _interopRequireDefault(require("8842768ccdd69bda"));
var _emotion = require("50fd402ad011e6f3");
var _transitionController = _interopRequireDefault(require("ae8625245b3a503f"));
var _waitAnimationFrame = _interopRequireDefault(require("4417efdadb24f337"));
var _functional = require("540ed628db7a5a47");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var getSizeProperty = function getSizeProperty(direction) {
    return ({
        left: "width",
        right: "width",
        up: "height",
        down: "height"
    })[direction];
}; // The container element sets the width or height of the expander and handles
// the expanding and collapsing motion.
var containerStyles = (0, _functional.memoizeByKeys)(function(_ref) {
    var _css;
    var state = _ref.state, direction = _ref.direction, size = _ref.size, motionDuration = _ref.motionDuration, motionFunction = _ref.motionFunction, closedSize = _ref.closedSize;
    return (0, _emotion.css)({
        left: {
            // Horizontal expanders are inline-flex to ensure they shrink to fit
            // their children's width (vertical expanders shrink to fit by default
            // 'cause that's how CSS layout works).
            display: "inline-flex",
            // The up/left expanders use row/column-reverse so that content is fixed
            // to the bottom/right edges instead of top/left (the default).
            // NOTE: justifyContent: "flex-end" would work here instead *except* for
            // a bug in IE11: https://stackoverflow.com/questions/32885534/how-to-make-flex-end-work-in-ie11
            flexDirection: "row-reverse"
        },
        right: {
            display: "inline-flex",
            flexDirection: "row"
        },
        up: {
            display: "flex",
            flexDirection: "column-reverse"
        },
        down: {
            display: "flex",
            flexDirection: "column"
        }
    }[direction], (_css = {
        // Don't let a flex parent squish the expander
        flexShrink: 0
    }, (0, _defineProperty2["default"])(_css, getSizeProperty(direction), state === "entering" || state === "entered" ? size : closedSize), (0, _defineProperty2["default"])(_css, "overflow", "hidden"), (0, _defineProperty2["default"])(_css, "transition", motionDuration && motionFunction ? "".concat(getSizeProperty(direction), " ").concat(motionDuration, "ms ").concat(motionFunction) : undefined), (0, _defineProperty2["default"])(_css, "visibility", state === "exited" && closedSize === 0 ? "hidden" : undefined), (0, _defineProperty2["default"])(_css, "maxWidth", state === "exited" && (direction === "left" || direction === "right") ? closedSize : undefined), _css));
}, [
    "state",
    "direction",
    "size",
    "motionDuration",
    "motionFunction",
    "closedSize"
]); // The content element automatically holds its dimensions, even when the
// container is collapsed, so that the container knows what size to animate to.
var contentStyles = (0, _functional.memoize)(function(direction) {
    var _css2;
    return (0, _emotion.css)((_css2 = {}, (0, _defineProperty2["default"])(_css2, getSizeProperty(direction), "max-content"), (0, _defineProperty2["default"])(_css2, "flexShrink", 0), (0, _defineProperty2["default"])(_css2, "transform", "translateZ(0)"), _css2));
});
/* eslint-disable react/prop-types */ /**
 * This component makes it easy to animate the size of a content block from 0 to
 * "auto" and back. It handles some nice things like expanding in various
 * directions, keeping children out of the tab order when collapsed, setting an
 * aria-hidden attribute when collapsed, and correctly handling situations when
 * the dimensions of the expander contents change on the fly.
 *
 * This component doesn't render anything to the DOM itself, but it needs at
 * least two nested elements to work. To make this happen it requires that you
 * pass in children as a function. It will call that function, passing it an
 * object containing two more objects keyed under "containerProps" and
 * "contentProps". These objects should be passed through as props to two nested
 * elements by your children function (with the container element as the root of
 * the expander and the content element as the only child of the container).
 * This allows you to take advantage of the expander functionality while
 * maintaining maximum control over the DOM. Example:
 *
 * ```
 * <ExpanderController>
 *   {({ containerProps, contentProps }) => (
 *     <div {...containerProps}>
 *       <div {...contentProps}>
 *         My expandable content here...
 *       <div>
 *     </div>
 *   )}
 * </ExpanderController>
 * ```
 *
 * NOTE: Horizontal ExpanderControllers are inline elements, so extra attention
 * may be needed to avoid unwanted whitespace around them. A couple tricks for
 * removing whitespace include setting `font-size: 0` or `display: flex` on an
 * inline element's parent.
 */ var ExpanderControllerClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(ExpanderControllerClass, _React$Component);
    var _super = _createSuper(ExpanderControllerClass);
    function ExpanderControllerClass() {
        var _this;
        (0, _classCallCheck2["default"])(this, ExpanderControllerClass);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            size: undefined,
            render: _this.props.open || _this.props.alwaysRenderChildren
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContentRef", function(node) {
            return _this.contentRef = node;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelFixSize", function() {});
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixSize", function(done) {
            return _this.setState({
                size: _this.contentRef && _this.contentRef.getBoundingClientRect()[getSizeProperty(_this.props.direction)]
            }, done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function(done) {
            if (!_this.state.render) // If the children aren't rendered yet, do so and then give them a chance
            // to settle before poking through the DOM
            _this.setState({
                render: true
            }, function() {
                _this.cancelFixSize = (0, _waitAnimationFrame["default"])(function() {
                    return _this.fixSize(done);
                });
            });
            else _this.fixSize(done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterOpen", function() {
            _this.setState({
                size: undefined
            });
            if (_this.props.onAfterOpen) _this.props.onAfterOpen();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeClose", function(done) {
            _this.cancelFixSize();
            _this.fixSize(done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function() {
            if (!_this.props.alwaysRenderChildren) _this.setState({
                render: false
            });
            if (_this.props.onAfterClose) _this.props.onAfterClose();
        });
        return _this;
    }
    (0, _createClass2["default"])(ExpanderControllerClass, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelFixSize();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, children = _this$props.children, props = (0, _objectWithoutProperties2["default"])(_this$props, [
                    "children"
                ]);
                var _this$state = this.state, size = _this$state.size, render = _this$state.render;
                return /*#__PURE__*/ _react["default"].createElement(_transitionController["default"], {
                    "in": props.open,
                    duration: props.motionDuration && props.motionFunction ? props.motionDuration : 0,
                    onBeforeEnter: this.onBeforeOpen,
                    onAfterEnter: this.onAfterOpen,
                    onBeforeExit: this.onBeforeClose,
                    onAfterExit: this.onAfterClose
                }, function(state) {
                    return render ? children({
                        state: state,
                        containerProps: {
                            className: containerStyles(_objectSpread(_objectSpread({}, props), {}, {
                                state: state,
                                size: size
                            })),
                            "aria-hidden": !props.closedSize && !props.open
                        },
                        contentProps: {
                            className: contentStyles(props.direction),
                            ref: _this2.updateContentRef
                        }
                    }) : null;
                });
            }
        }
    ]);
    return ExpanderControllerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change
var ExpanderController = function ExpanderController(props) {
    return /*#__PURE__*/ _react["default"].createElement(ExpanderControllerClass, props);
};
ExpanderController.propTypes = {};
ExpanderController.defaultProps = {
    closedSize: 0
};
var _default = ExpanderController;
exports["default"] = _default;

},{"6819a4eee9ed7e8f":"hVU2P","12e8a6ec02152b1f":"i4rUG","c78cbecad7305a9f":"8KeDp","c540e32bc77c27d2":"5f8kn","84b2fcaecd9ff52b":"9vjID","b48efaf4dabb17c9":"3lN0X","847000dcbc21e0c":"eIx1K","3965067c6797a1a1":"iYiZL","61afc31cd35ed48b":"74DXJ","bf2c88b27c9f3c7b":"6uln9","8842768ccdd69bda":"1hOJi","50fd402ad011e6f3":"kbmlY","ae8625245b3a503f":"f3g3z","4417efdadb24f337":"68VbC","540ed628db7a5a47":"4L61K"}],"i4rUG":[function(require,module,exports) {
var objectWithoutPropertiesLoose = require("8105c8e98c807bee");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = _objectWithoutProperties;

},{"8105c8e98c807bee":"6EgOv"}],"6EgOv":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose;

},{}],"8KeDp":[function(require,module,exports) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck;

},{}],"5f8kn":[function(require,module,exports) {
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = _createClass;

},{}],"9vjID":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized;

},{}],"3lN0X":[function(require,module,exports) {
var setPrototypeOf = require("868bbd3eec23d036");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits;

},{"868bbd3eec23d036":"UwFVj"}],"UwFVj":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf;

},{}],"eIx1K":[function(require,module,exports) {
var _typeof = require("6cf2c539a86b89c3");
var assertThisInitialized = require("aa1732dd91a09973");
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn;

},{"6cf2c539a86b89c3":"gC4jv","aa1732dd91a09973":"9vjID"}],"iYiZL":[function(require,module,exports) {
function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf;

},{}],"f3g3z":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5d768c2ee9398c62");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _transitionController = _interopRequireDefault(require("cc59b48e551172a8"));
var _default = _transitionController["default"];
exports["default"] = _default;

},{"5d768c2ee9398c62":"hVU2P","cc59b48e551172a8":"dOGwr"}],"dOGwr":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5f89774c0cf1f227");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("6dc4e6dffd490ee8"));
var _createClass2 = _interopRequireDefault(require("b2509cfaf50e0bb3"));
var _assertThisInitialized2 = _interopRequireDefault(require("715349978eda186b"));
var _inherits2 = _interopRequireDefault(require("f4f36cf4be032dd5"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("cbaee9186c76cd9d"));
var _getPrototypeOf2 = _interopRequireDefault(require("1ba5a86302410b77"));
var _defineProperty2 = _interopRequireDefault(require("bed5cdb8937ebccd"));
var _react = _interopRequireDefault(require("27b1ff8c137f1782"));
var _propTypes = _interopRequireDefault(require("c7537a67aab8d29e"));
var _noop = _interopRequireDefault(require("c2b46f810a6f35e6"));
var _waitAnimationFrame = _interopRequireDefault(require("5cf5bcb7df75145b"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var noopWithCallback = function noopWithCallback(callback) {
    return callback();
};
/**
 * This component makes it easy to apply complex transitions to elements. You
 * tell it whether the children should be transitioned in or out and what the
 * duration of the transition should be. It will provide you with the state of
 * the transition via a render prop. The state may be one of four values:
 * "entering", "entered", "exiting", or "exited". Six lifecycle hooks are
 * available: onBeforeEnter, onEnter, onAfterEnter, onBeforeExit, onExit, and
 * onAfterExit.
 */ var TransitionController = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(TransitionController, _React$Component);
    var _super = _createSuper(TransitionController);
    function TransitionController() {
        var _this;
        (0, _classCallCheck2["default"])(this, TransitionController);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            state: _this.props["in"] ? "entered" : "exited"
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelWait", _noop["default"]);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callback", _noop["default"]);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitAnimationFrame", function(callback, skip) {
            if (skip) callback();
            else {
                _this.cancelWait();
                _this.cancelWait = (0, _waitAnimationFrame["default"])(callback);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitDuration", function(callback) {
            var timeout;
            _this.cancelWait();
            _this.cancelWait = function() {
                return clearTimeout(timeout);
            };
            timeout = setTimeout(callback, _this.props.duration);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withCallback", function(func) {
            return function(callback) {
                _this.callback = callback;
                func(function() {
                    if (_this.callback === callback) callback();
                });
            };
        });
        return _this;
    }
    (0, _createClass2["default"])(TransitionController, [
        {
            key: "transition",
            /**
     * This orchestrates a transition. The basic flow is:
     * 1) cancel any existing timeouts
     * 2) call onBefore
     * 3) wait for a single animation frame *if* onBefore is defined (so that the
     *    DOM has a chance to settle)
     * 4) update the state to transitioning
     * 5) wait for a single animation frame *if* onTransition is defined (so that
     *    the DOM has a chance to settle)
     * 6) call onTransition
     * 7) wait for the duration of the animation
     * 8) update the state to transitioned
     * 9) wait for a single animation frame
     * 10) call onAfter
     */ value: function transition(_ref) {
                var _this2 = this;
                var onBefore = _ref.onBefore, onTransition = _ref.onTransition, onAfter = _ref.onAfter, stateDuring = _ref.stateDuring, stateAfter = _ref.stateAfter;
                var onBeforeWithCallback = this.withCallback(onBefore);
                var onTransitionWithCallback = this.withCallback(onTransition);
                this.cancelWait();
                onBeforeWithCallback(function() {
                    return _this2.waitAnimationFrame(function() {
                        return _this2.setState({
                            state: stateDuring
                        }, function() {
                            return _this2.waitAnimationFrame(function() {
                                return onTransitionWithCallback(function() {
                                    return _this2.waitDuration(function() {
                                        return _this2.setState({
                                            state: stateAfter
                                        }, _this2.waitAnimationFrame(onAfter, onAfter === _noop["default"]));
                                    });
                                });
                            }, // provided
                            onTransition === noopWithCallback);
                        });
                    }, onBefore === noopWithCallback);
                });
            }
        },
        {
            key: "transitionIn",
            value: function transitionIn() {
                this.transition({
                    onBefore: this.props.onBeforeEnter,
                    onTransition: this.props.onEnter,
                    onAfter: this.props.onAfterEnter,
                    stateDuring: "entering",
                    stateAfter: "entered"
                });
            }
        },
        {
            key: "transitionOut",
            value: function transitionOut() {
                this.transition({
                    onBefore: this.props.onBeforeExit,
                    onTransition: this.props.onExit,
                    onAfter: this.props.onAfterExit,
                    stateDuring: "exiting",
                    stateAfter: "exited"
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props["in"] && !prevProps["in"]) this.transitionIn();
                else if (!this.props["in"] && prevProps["in"]) this.transitionOut();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelWait();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children(this.state.state);
            }
        }
    ]);
    return TransitionController;
}(_react["default"].Component);
(0, _defineProperty2["default"])(TransitionController, "defaultProps", {
    onBeforeEnter: noopWithCallback,
    onEnter: noopWithCallback,
    onAfterEnter: _noop["default"],
    onBeforeExit: noopWithCallback,
    onExit: noopWithCallback,
    onAfterExit: _noop["default"]
});
TransitionController.propTypes = {};
var _default = TransitionController;
exports["default"] = _default;

},{"5f89774c0cf1f227":"hVU2P","6dc4e6dffd490ee8":"8KeDp","b2509cfaf50e0bb3":"5f8kn","715349978eda186b":"9vjID","f4f36cf4be032dd5":"3lN0X","cbaee9186c76cd9d":"eIx1K","1ba5a86302410b77":"iYiZL","bed5cdb8937ebccd":"74DXJ","27b1ff8c137f1782":"6uln9","c7537a67aab8d29e":"1hOJi","c2b46f810a6f35e6":"4uGIw","5cf5bcb7df75145b":"68VbC"}],"4uGIw":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"68VbC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// Executes code after waiting at least one whole animation frame. This is
// helpful when you want to allow DOM updates to settle before triggering
// something like a css transition. This returns a function that can be used to
// cancel the callback.
var waitAnimationFrame = function waitAnimationFrame(callback) {
    var frame = requestAnimationFrame(function() {
        frame = requestAnimationFrame(callback);
    });
    return function() {
        return cancelAnimationFrame(frame);
    };
};
var _default = waitAnimationFrame;
exports["default"] = _default;

},{}],"46QLi":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3e49797c7dfc0338");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _scrim = _interopRequireDefault(require("6290dbc92ca78e5a"));
var _default = _scrim["default"];
exports["default"] = _default;

},{"3e49797c7dfc0338":"hVU2P","6290dbc92ca78e5a":"qztjM"}],"qztjM":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("cbbd05f1fd8865cd");
var _interopRequireDefault = require("a6a489e7ffd3313");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("9284206adb73688e"));
var _propTypes = _interopRequireDefault(require("4eefa7b2ca2790cf"));
var _emotion = require("dd71c4a463b9d14e");
var _scrim = _interopRequireDefault(require("c11def67a5e1712c"));
var _theme = require("7cc7b488356dc5ac");
var _animateMount = _interopRequireWildcard(require("ecaf0c351a543615"));
var _onDirectClick = _interopRequireDefault(require("f6c4c6f24ab4a9e3"));
var AnimateFadeWithMount = (0, _animateMount["default"])(_animateMount.AnimateFade);
var styles = function styles(t) {
    return (0, _emotion.css)({
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: t("elevation"),
        backgroundColor: t("backgroundColor")
    });
};
/**
 * Don't bother updating the scrim if it's persisting in a closed state.
 */ var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return !prevProps.open && !nextProps.open;
};
var Scrim = /*#__PURE__*/ _react["default"].memo(/*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_scrim["default"], "scrim");
    return /*#__PURE__*/ _react["default"].createElement(AnimateFadeWithMount, {
        open: props.open,
        onOpen: props.onOpen,
        duration: props.duration || t("motionTiming"),
        easing: props.easing || t("motionFunction"),
        type: "fade"
    }, function(_ref) {
        var className = _ref.className, onTransitionEnd = _ref.onTransitionEnd;
        return(/*#__PURE__*/ // Regarding role=none, see:
        // https://www.scottohara.me/blog/2018/05/05/hidden-vs-none.html#what-does-rolenone-and-rolepresentation-do
        _react["default"].createElement("div", {
            role: "none",
            className: (0, _emotion.cx)(className, styles(t), props.className),
            onTransitionEnd: onTransitionEnd,
            onMouseDown: (0, _onDirectClick["default"])(props.onClick),
            ref: ref
        }, props.children));
    });
}), shouldNotUpdate);
Scrim.displayName = "Scrim";
Scrim.propTypes = {};
Scrim.defaultProps = {
    open: false,
    className: null
};
var _default = Scrim;
exports["default"] = _default;

},{"cbbd05f1fd8865cd":"jNy6G","a6a489e7ffd3313":"hVU2P","9284206adb73688e":"6uln9","4eefa7b2ca2790cf":"1hOJi","dd71c4a463b9d14e":"kbmlY","c11def67a5e1712c":"i5KEc","7cc7b488356dc5ac":"f7yMb","ecaf0c351a543615":"dHV2O","f6c4c6f24ab4a9e3":"k2AeU"}],"dHV2O":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("643d480c994c97c6");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnimateFade", {
    enumerable: true,
    get: function get() {
        return _animateFade["default"];
    }
});
Object.defineProperty(exports, "AnimateSlideIn", {
    enumerable: true,
    get: function get() {
        return _animateSlideIn["default"];
    }
});
Object.defineProperty(exports, "AnimateFadeScale", {
    enumerable: true,
    get: function get() {
        return _animateFadeScale["default"];
    }
});
exports["default"] = void 0;
var _withAnimateMount = _interopRequireDefault(require("b5acd3e19141922b"));
var _animateFade = _interopRequireDefault(require("a628966b04de9bc0"));
var _animateSlideIn = _interopRequireDefault(require("f14423a12a34a66b"));
var _animateFadeScale = _interopRequireDefault(require("20e85d6cc32a9421"));
var _default = _withAnimateMount["default"];
exports["default"] = _default;

},{"643d480c994c97c6":"hVU2P","b5acd3e19141922b":"kUr0V","a628966b04de9bc0":"3W2Qb","f14423a12a34a66b":"4mAw8","20e85d6cc32a9421":"5bAra"}],"kUr0V":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c65b26680307bee");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("12c91dd3a2c5704"));
var _classCallCheck2 = _interopRequireDefault(require("1546d87a1e73c004"));
var _createClass2 = _interopRequireDefault(require("bcfed331477ae18"));
var _assertThisInitialized2 = _interopRequireDefault(require("cd638caff59e659"));
var _inherits2 = _interopRequireDefault(require("e6e520dc4dc91a5d"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("9dad46474e639f1e"));
var _getPrototypeOf2 = _interopRequireDefault(require("c5e34dfb1673017e"));
var _defineProperty2 = _interopRequireDefault(require("c726da3e87ced7f4"));
var _react = _interopRequireDefault(require("6c7fad5cc8691bd9"));
var _propTypes = _interopRequireDefault(require("93d265484933af59"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// Provides the WrappedComponent's displayName
// for easy debugging
var getsDisplayName = function getsDisplayName(WrappedComponent) {
    return WrappedComponent.getsDisplayName || WrappedComponent.name || "Component";
};
var withAnimateMount = function withAnimateMount(WrappedComponent) {
    var _class, _temp;
    /**
   * This is a higher order component that provides a consistent API to easily
   * create animations to be used for elements that need to be added and
   * removed to the DOM dynamically. Receives an animation component and returns a
   * wrapped, composed component.
   */ return _temp = _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inherits2["default"])(WithAnimateMount, _React$Component);
        var _super = _createSuper(WithAnimateMount);
        function WithAnimateMount() {
            var _this;
            (0, _classCallCheck2["default"])(this, WithAnimateMount);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
                show: false
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
                if (typeof _this.props.onOpen !== "undefined" && _this.state.show) _this.props.onOpen();
                 // Remount the node when the open prop is true
                _this.setState({
                    show: true
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
                if (!_this.props.open) _this.setState({
                    show: false
                });
            });
            return _this;
        }
        (0, _createClass2["default"])(WithAnimateMount, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.open) this.updateStateOnOpen();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (!prevProps.open && this.props.open) this.updateStateOnOpen();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, open = _this$props.open, animateToHeight = _this$props.animateToHeight;
                    var animateToHeightProps = typeof animateToHeight !== "undefined" ? {
                        animateToHeight: animateToHeight
                    } : null;
                    return this.state.show && /*#__PURE__*/ _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
                        duration: duration,
                        easing: easing,
                        open: open,
                        updateStateOnOpen: this.updateStateOnOpen,
                        transitionEnd: this.transitionEnd
                    }, animateToHeightProps), children);
                }
            }
        ]);
        return WithAnimateMount;
    }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "propTypes", {
        /**
     * A function that returns the elements to animate.
     */ children: _propTypes["default"].func.isRequired,
        /**
     * If true the children will be mounted, otherwise they will be unmounted.
     */ open: _propTypes["default"].bool.isRequired,
        /**
     * Only applies to height based transitions. Allows for cases when the
     * desired effect is animating height to a value that's different than
     * the element's scrollHeight.
     */ animateToHeight: _propTypes["default"].oneOfType([
            _propTypes["default"].string,
            _propTypes["default"].number
        ]),
        /**
     * The duration of the animation. This should be a valid CSS animation
     * duration (e.g. `"100ms"` or `"1s"`).
     */ duration: _propTypes["default"].string,
        /**
     * The easing function of the animation. This should be a valid CSS easing
     * function (e.g. `"linear"` or `"ease"`).
     */ easing: _propTypes["default"].string,
        /**
     * The function provided here will be called if the component transitions
     * from a closed state to an open state, or if it is mounted in an open
     * state. Note that this is called as soon as the state changes, which
     * occurs *before* the elements being mounted are actually available in
     * the DOM.
     */ onOpen: _propTypes["default"].func
    }), (0, _defineProperty2["default"])(_class, "defaultProps", {
        duration: "150ms",
        easing: "ease",
        open: false
    }), (0, _defineProperty2["default"])(_class, "displayName", "WithAnimateMount(".concat(getsDisplayName(WrappedComponent), ")")), _temp;
};
var _default = withAnimateMount;
exports["default"] = _default;

},{"c65b26680307bee":"hVU2P","12c91dd3a2c5704":"5G7gB","1546d87a1e73c004":"8KeDp","bcfed331477ae18":"5f8kn","cd638caff59e659":"9vjID","e6e520dc4dc91a5d":"3lN0X","9dad46474e639f1e":"eIx1K","c5e34dfb1673017e":"iYiZL","c726da3e87ced7f4":"74DXJ","6c7fad5cc8691bd9":"6uln9","93d265484933af59":"1hOJi"}],"3W2Qb":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c429b2e637f9f424");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("2520633ea610e2e9"));
var _createClass2 = _interopRequireDefault(require("55374bbbbf626aac"));
var _assertThisInitialized2 = _interopRequireDefault(require("293170e9eb246c2f"));
var _inherits2 = _interopRequireDefault(require("ec61c61cb942c905"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("7bbc479f1aa2eac5"));
var _getPrototypeOf2 = _interopRequireDefault(require("1656c402cbeb8d61"));
var _defineProperty2 = _interopRequireDefault(require("a0b90df155698723"));
var _react = _interopRequireDefault(require("ebd88fe12ab53d8a"));
var _propTypes = _interopRequireDefault(require("7a08fed685135de4"));
var _emotion = require("d8b86f3e285d915e");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(opacity, duration, easing) {
    return (0, _emotion.css)({
        opacity: opacity,
        transition: "opacity ".concat(duration, " ").concat(easing)
    });
};
var AnimateFade = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateFade, _React$Component);
    var _super = _createSuper(AnimateFade);
    function AnimateFade() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateFade);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            opacity: 0
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Set state to trigger intro animation
            _this.timer = setTimeout(_this.updateStateOnMount, 0);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            // Update state for unmount animation
            _this.setState({
                opacity: 0
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            // Update state for mount animation
            _this.setState({
                opacity: 1
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
            if (!_this.props.open) // Tell the wrapper component to remove the node on transition end when
            // the open prop is false
            _this.props.transitionEnd();
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateFade, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
                else if (!prevProps.open && this.props.open) this.updateStateOnMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clear our timer to prevent leaks
                clearTimeout(this.timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var opacity = this.state.opacity;
                var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, className = _this$props.className;
                var styles = mountStyled(opacity, duration, easing);
                return children({
                    className: (0, _emotion.cx)(className, styles),
                    onTransitionEnd: this.transitionEnd
                });
            }
        }
    ]);
    return AnimateFade;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateFade, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateFade.propTypes = {};
var _default = AnimateFade;
exports["default"] = _default;

},{"c429b2e637f9f424":"hVU2P","2520633ea610e2e9":"8KeDp","55374bbbbf626aac":"5f8kn","293170e9eb246c2f":"9vjID","ec61c61cb942c905":"3lN0X","7bbc479f1aa2eac5":"eIx1K","1656c402cbeb8d61":"iYiZL","a0b90df155698723":"74DXJ","ebd88fe12ab53d8a":"6uln9","7a08fed685135de4":"1hOJi","d8b86f3e285d915e":"kbmlY"}],"4mAw8":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8b2e42ceb0a26061");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("c67f4f334dea1bdf"));
var _createClass2 = _interopRequireDefault(require("682b7b8ac4660d52"));
var _assertThisInitialized2 = _interopRequireDefault(require("21cb4c309d4c927a"));
var _inherits2 = _interopRequireDefault(require("3777ec1bf6c6a80b"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("98b7daa662eaa73a"));
var _getPrototypeOf2 = _interopRequireDefault(require("33a8bc2df791c809"));
var _defineProperty2 = _interopRequireDefault(require("db27c8777628f958"));
var _react = _interopRequireDefault(require("1a8720d04dae49ed"));
var _propTypes = _interopRequireDefault(require("baed94ef119cfa42"));
var _emotion = require("8f29c69786922ba8");
var _waitAnimationFrame = _interopRequireDefault(require("b86662155e09223d"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(_ref) {
    var open = _ref.open, height = _ref.height, duration = _ref.duration, easing = _ref.easing;
    return (0, _emotion.css)({
        transform: "translateY(".concat(open ? "0" : "100%", ")"),
        height: height,
        overflow: "auto",
        transition: "transform ".concat(duration, " ").concat(easing)
    });
};
var AnimateSlideIn = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateSlideIn, _React$Component);
    var _super = _createSuper(AnimateSlideIn);
    function AnimateSlideIn() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateSlideIn);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            open: false
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMounted", false);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Wait one animation frame so that the DOM can settle after mounting the
            // element, then set the state to trigger the mount animation
            (0, _waitAnimationFrame["default"])(_this.updateStateOnMount);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            return _this.setState({
                open: false
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            if (_this.isMounted) _this.setState({
                open: true
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateSlideIn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.isMounted = true;
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.open && this.props.open) this.updateStateOnOpen();
                else if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.isMounted = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var state = this.state;
                var props = this.props;
                var styles = mountStyled({
                    open: state.open,
                    duration: props.duration,
                    easing: props.easing,
                    height: props.animateToHeight
                });
                return props.children({
                    open: state.open,
                    className: (0, _emotion.cx)(props.className, styles),
                    onTransitionEnd: this.props.transitionEnd
                });
            }
        }
    ]);
    return AnimateSlideIn;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateSlideIn, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateSlideIn.propTypes = {};
var _default = AnimateSlideIn;
exports["default"] = _default;

},{"8b2e42ceb0a26061":"hVU2P","c67f4f334dea1bdf":"8KeDp","682b7b8ac4660d52":"5f8kn","21cb4c309d4c927a":"9vjID","3777ec1bf6c6a80b":"3lN0X","98b7daa662eaa73a":"eIx1K","33a8bc2df791c809":"iYiZL","db27c8777628f958":"74DXJ","1a8720d04dae49ed":"6uln9","baed94ef119cfa42":"1hOJi","8f29c69786922ba8":"kbmlY","b86662155e09223d":"68VbC"}],"5bAra":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4a7b84aec79befa8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("176f9c4bdb0b4148"));
var _createClass2 = _interopRequireDefault(require("b245a6e00a82ee41"));
var _assertThisInitialized2 = _interopRequireDefault(require("3696eef942c9db25"));
var _inherits2 = _interopRequireDefault(require("accaee3465b6b10a"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("12822a4031bc8214"));
var _getPrototypeOf2 = _interopRequireDefault(require("222ca357eef72e82"));
var _defineProperty2 = _interopRequireDefault(require("7a50d091e66446fc"));
var _react = _interopRequireDefault(require("153b7b978f35a21b"));
var _propTypes = _interopRequireDefault(require("ba8db367a002839f"));
var _emotion = require("da1342b53bdfecc4");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(opacity, scale, duration, easing) {
    return (0, _emotion.css)({
        opacity: opacity,
        transform: "scale(".concat(scale, ")"),
        transition: "opacity ".concat(duration, " ").concat(easing, ", transform ").concat(duration, " ").concat(easing)
    });
};
var AnimateFadeScale = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateFadeScale, _React$Component);
    var _super = _createSuper(AnimateFadeScale);
    function AnimateFadeScale() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateFadeScale);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            opacity: 0,
            scale: 0.75
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Set state to trigger intro animation
            _this.timer = setTimeout(_this.updateStateOnMount, 0);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            // Update state for unmount animation
            _this.setState({
                opacity: 0,
                scale: 0.75
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            // Update state for mount animation
            _this.setState({
                opacity: 1,
                scale: 1
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
            if (!_this.props.open) // Tell the wrapper component to remove the node on transition end when
            // the open prop is false
            _this.props.transitionEnd();
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateFadeScale, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
                else if (!prevProps.open && this.props.open) this.updateStateOnMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clear our timer to prevent leaks
                clearTimeout(this.timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, opacity = _this$state.opacity, scale = _this$state.scale;
                var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, className = _this$props.className;
                var styles = mountStyled(opacity, scale, duration, easing);
                return children({
                    open: opacity !== 0,
                    className: (0, _emotion.cx)(className, styles),
                    onTransitionEnd: this.transitionEnd
                });
            }
        }
    ]);
    return AnimateFadeScale;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateFadeScale, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateFadeScale.propTypes = {};
var _default = AnimateFadeScale;
exports["default"] = _default;

},{"4a7b84aec79befa8":"hVU2P","176f9c4bdb0b4148":"8KeDp","b245a6e00a82ee41":"5f8kn","3696eef942c9db25":"9vjID","accaee3465b6b10a":"3lN0X","12822a4031bc8214":"eIx1K","222ca357eef72e82":"iYiZL","7a50d091e66446fc":"74DXJ","153b7b978f35a21b":"6uln9","ba8db367a002839f":"1hOJi","da1342b53bdfecc4":"kbmlY"}],"k2AeU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * WHAT: This function makes it easy to detect a direct click on an element. It
 * will only trigger if both the mouse down and mouse up parts of the click
 * occurr directly on the element itself, and not the element's children.
 *
 * WHY: Listening for a direct click on an element, excluding its children, is
 * pretty tricky. You could try comparing event.target to event.currentTarget in
 * a click handler bound directly to the element, but that would still fire if
 * the click started on another element. For example if the user moused down on
 * a child element, moused over to the parent element, and released then a click
 * even would be fired on the parent where event.target was the same as
 * event.currentTarget. This same limitation applies to the method of trying to
 * call event.stopPropagation on click events from children to keep them from
 * bubbling up to parents. See https://sim.amazon.com/issues/MRDN-592 for why
 * triggering a click that started on another element can be problematic.

 * HOW: Usage of this utility is a little weird, but it's the only consistent
 * solution I could find to the problem. This function's only argument is the
 * onClick handler that should be called when a direct click is made. However
 * instead of returning some sort of more robust click handler it returns a
 * mouse down handler. This handler should be passed to the onMouseDown prop of
 * the element. For example:
 *
 * ```
 * const onClick = () => console.log("clicked directly on div!")
 *
 * // NOTE: onClick can't change after this point as onDirectClick stores it in
 * // memory. If onClick may change just inline this in your jsx (e.g.
 * // `onMouseDown={onDirectClick(onClick)}`).
 * const onMouseDown = onDirectClick(onClick)
 *
 * <div onMouseDown={onMouseDown}>
 *   <p>Clicking on this will not trigger a "direct" click on the parent</p>
 * </div>
 * ```
 *
 * Not super intuitive, but it works. This allows the utility to start listening
 * for clicks only when the user mouses down on the element, avoiding the
 * situation where a mousedown on another element, then a mouseover to our
 * element, then a mouse up would fire a click.
 */ var onDirectClick = function onDirectClick(callback) {
    // Listeners to add when the user mouses down on our element.
    var addListeners = function addListeners(node) {
        node.addEventListener("click", onClick);
        node.addEventListener("mouseout", onMouseOut);
    }; // Listeners to remove when the user finishes their click or mouses out of
    // the element.
    var removeListeners = function removeListeners(node) {
        node.removeEventListener("click", onClick);
        node.removeEventListener("mouseout", onMouseOut);
    }; // This is the final "direct" click handler.
    var onClick = function onClick(event) {
        removeListeners(event.target);
        callback(event);
    }; // If the user mouses out clear our listeners (and stop listening for a click
    // event, as it would no longer be directly on the element).
    var onMouseOut = function onMouseOut(event) {
        return removeListeners(event.target);
    }; // If the user mouses down directly on the element that this event is bound
    // to then start listening for a click event to finish things off.
    var onMouseDown = function onMouseDown(event) {
        if (event.target === event.currentTarget) addListeners(event.target);
    };
    return callback ? onMouseDown : undefined;
};
var _default = onDirectClick;
exports["default"] = _default;

},{}],"dkg9Y":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("257b83ac18f7468");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _portal = _interopRequireDefault(require("af71c5d8c92a6862"));
var _default = _portal["default"];
exports["default"] = _default;

},{"257b83ac18f7468":"hVU2P","af71c5d8c92a6862":"2W6xh"}],"2W6xh":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f91a8154e5f650be");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("6ba612d646748b7f"));
var _createClass2 = _interopRequireDefault(require("d3ea8bb23b0b88e8"));
var _inherits2 = _interopRequireDefault(require("2f07065c312533fd"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("c2fcc33d74841098"));
var _getPrototypeOf2 = _interopRequireDefault(require("b1e8a7fe63201369"));
var _react = _interopRequireDefault(require("591298901d0aa250"));
var _propTypes = _interopRequireDefault(require("1e85bd6c8d96e8e5"));
var _reactDom = _interopRequireDefault(require("27e518ed13c10221"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var Portal = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Portal, _React$Component);
    var _super = _createSuper(Portal);
    function Portal() {
        (0, _classCallCheck2["default"])(this, Portal);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(Portal, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
            }
        },
        {
            key: "render",
            value: function render() {
                if (!canUseDOM) return null;
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement("div");
                    document.body.appendChild(this.defaultNode);
                }
                return /*#__PURE__*/ _reactDom["default"].createPortal(this.props.children, this.props.node || this.defaultNode);
            }
        }
    ]);
    return Portal;
}(_react["default"].Component);
Portal.propTypes = {};
var _default = Portal;
exports["default"] = _default;

},{"f91a8154e5f650be":"hVU2P","6ba612d646748b7f":"8KeDp","d3ea8bb23b0b88e8":"5f8kn","2f07065c312533fd":"3lN0X","c2fcc33d74841098":"eIx1K","b1e8a7fe63201369":"iYiZL","591298901d0aa250":"6uln9","1e85bd6c8d96e8e5":"1hOJi","27e518ed13c10221":"b8T3j"}],"hRglT":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("38de0483348a0a3f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _focusTrap = _interopRequireDefault(require("1204a11573a707d8"));
var _default = _focusTrap["default"];
exports["default"] = _default;

},{"38de0483348a0a3f":"hVU2P","1204a11573a707d8":"gVN7K"}],"gVN7K":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bcc0bd65de469530");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("3f91a5f334acb764"));
var _createClass2 = _interopRequireDefault(require("3a80b53344d3c30d"));
var _assertThisInitialized2 = _interopRequireDefault(require("ae8ca39b3a5a509f"));
var _inherits2 = _interopRequireDefault(require("3144251dcd66cd93"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("1feefff609cf7c3f"));
var _getPrototypeOf2 = _interopRequireDefault(require("d513f339f4d70ee"));
var _defineProperty2 = _interopRequireDefault(require("207e40cd4b301ff5"));
var _react = _interopRequireDefault(require("ab103c3e588c45b7"));
var _propTypes = _interopRequireDefault(require("bae4d942edaf2846"));
var _reactDom = _interopRequireDefault(require("9d5855eee84d3c4f"));
var _keycode = _interopRequireDefault(require("17d392d62ba47b09"));
var _includes = _interopRequireDefault(require("bbe1f929fdf1ad1c"));
var _find = _interopRequireDefault(require("4d6904369dfe81e"));
var _findLast = _interopRequireDefault(require("5522240bfde65b04"));
var _noop = _interopRequireDefault(require("2e686a4392f1dd70"));
var _focus = require("95e9a1dcee024e1");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This component allows you to trap the keyboard focus within a particular
 * section of the DOM (the component's children). An optional onBeforeBlur event
 * handler can be defined that allows you to execute custom behavior when the
 * user attempts to move the focus outside of the trap by pressing the tab key.
 *
 * NOTE: This component only handles keyboard focus. If the mouse is used to
 * move focus outside of the trap then the trap will not prevent the focus
 * change and onBeforeBlur will not be called.
 *
 * NOTE: This component must be wrapped around a single element to work
 * properly.
 *
 * NOTE: This component only manages focus for elements that are
 * descendents in the real DOM. This means that it will ignore any portals
 * nested inside of it in the virtual DOM.
 */ var FocusTrap = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(FocusTrap, _React$Component);
    var _super = _createSuper(FocusTrap);
    function FocusTrap() {
        var _this;
        (0, _classCallCheck2["default"])(this, FocusTrap);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootNode", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function(event) {
            if ((0, _keycode["default"])(event) === "tab") {
                var _getBoundingFocusNode = (0, _focus.getBoundingFocusNodes)(_this.rootNode), startNodes = _getBoundingFocusNode.startNodes, endNodes = _getBoundingFocusNode.endNodes;
                var willBlur = _this.willBlur(event, startNodes, endNodes);
                var allowBlur = willBlur && _this.props.onBeforeBlur(willBlur);
                var firstFocusNode = (0, _find["default"])(startNodes, _focus.canKeyboardFocusNode);
                var lastFocusNode = (0, _findLast["default"])(endNodes, _focus.canKeyboardFocusNode); // If onBeforeBlur returned nothing then loop the focus ourselves
                if (willBlur === -1 && allowBlur === undefined && lastFocusNode) lastFocusNode.focus();
                if (willBlur === 1 && allowBlur === undefined && firstFocusNode) firstFocusNode.focus();
                 // If allowBlur was not explicitly set to true then cancel the default event
                // behavior
                if (willBlur && allowBlur !== true) event.preventDefault();
            }
        });
        return _this;
    }
    (0, _createClass2["default"])(FocusTrap, [
        {
            key: "focus",
            value: function focus() {
                var node = (0, _focus.getKeyboardFocusNodes)(this.rootNode)[0];
                if (node) node.focus();
            }
        },
        {
            key: "focusEnd",
            value: function focusEnd() {
                var nodes = (0, _focus.getKeyboardFocusNodes)(this.rootNode);
                var node = nodes[nodes.length - 1];
                if (node) node.focus();
            }
        },
        {
            key: "willBlur",
            value: function willBlur(event, startNodes, endNodes) {
                var key = (0, _keycode["default"])(event);
                var target = event.target, shiftKey = event.shiftKey;
                return (0, _includes["default"])(endNodes, target) && key === "tab" && !shiftKey ? 1 : (0, _includes["default"])(startNodes, target) && key === "tab" && shiftKey ? -1 : 0;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                /* eslint-disable-next-line react/no-find-dom-node */ this.rootNode = _reactDom["default"].findDOMNode(this);
                this.rootNode.addEventListener("keydown", this.onKeyDown);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.rootNode.removeEventListener("keydown", this.onKeyDown);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return FocusTrap;
}(_react["default"].Component);
(0, _defineProperty2["default"])(FocusTrap, "defaultProps", {
    onBeforeBlur: _noop["default"]
});
FocusTrap.propTypes = {};
var _default = FocusTrap;
exports["default"] = _default;

},{"bcc0bd65de469530":"hVU2P","3f91a5f334acb764":"8KeDp","3a80b53344d3c30d":"5f8kn","ae8ca39b3a5a509f":"9vjID","3144251dcd66cd93":"3lN0X","1feefff609cf7c3f":"eIx1K","d513f339f4d70ee":"iYiZL","207e40cd4b301ff5":"74DXJ","ab103c3e588c45b7":"6uln9","bae4d942edaf2846":"1hOJi","9d5855eee84d3c4f":"b8T3j","17d392d62ba47b09":"2YoiJ","bbe1f929fdf1ad1c":"kB3To","4d6904369dfe81e":"hpCY3","5522240bfde65b04":"jskkr","2e686a4392f1dd70":"4uGIw","95e9a1dcee024e1":"deEJ0"}],"kB3To":[function(require,module,exports) {
var baseIndexOf = require("a36455f938cb9955"), isArrayLike = require("cf2cf13fc9fe530d"), isString = require("930dc6cae078c0de"), toInteger = require("a4565841c2a46525"), values = require("e7f7c8b864b351d2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
    return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
module.exports = includes;

},{"a36455f938cb9955":"6JBAJ","cf2cf13fc9fe530d":"hx7OW","930dc6cae078c0de":"b0SR1","a4565841c2a46525":"SvAYX","e7f7c8b864b351d2":"9lPH6"}],"6JBAJ":[function(require,module,exports) {
var baseFindIndex = require("e5cb216af043bb43"), baseIsNaN = require("65b21c3fdf726b0a"), strictIndexOf = require("d023a733f53fde32");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"e5cb216af043bb43":"84Khh","65b21c3fdf726b0a":"bkYXm","d023a733f53fde32":"5XnK3"}],"84Khh":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"bkYXm":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"5XnK3":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"hx7OW":[function(require,module,exports) {
var isFunction = require("545fa616d5e91f3d"), isLength = require("51d82137b6942994");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"545fa616d5e91f3d":"6Mk8z","51d82137b6942994":"kcH0i"}],"6Mk8z":[function(require,module,exports) {
var baseGetTag = require("d83ab951de76d15e"), isObject = require("902aa468f4154e5b");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"d83ab951de76d15e":"h2psl","902aa468f4154e5b":"2T4Z1"}],"h2psl":[function(require,module,exports) {
var Symbol = require("a6248f2df7fd3d3e"), getRawTag = require("9cc730b327075077"), objectToString = require("2197e4ed69dfe765");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"a6248f2df7fd3d3e":"76QqE","9cc730b327075077":"gLBJd","2197e4ed69dfe765":"fiAcA"}],"76QqE":[function(require,module,exports) {
var root = require("38528fdc22ce903c");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"38528fdc22ce903c":"dsaaV"}],"dsaaV":[function(require,module,exports) {
var freeGlobal = require("e903a7be2ddc2b10");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"e903a7be2ddc2b10":"guxZL"}],"guxZL":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"gLBJd":[function(require,module,exports) {
var Symbol = require("f16f06497832e202");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"f16f06497832e202":"76QqE"}],"fiAcA":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"2T4Z1":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"kcH0i":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"b0SR1":[function(require,module,exports) {
var baseGetTag = require("b49bca5b2976f8f8"), isArray = require("cdb0e42c23a17cee"), isObjectLike = require("534d75c8a3d9303f");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b49bca5b2976f8f8":"h2psl","cdb0e42c23a17cee":"3zDjI","534d75c8a3d9303f":"3DHvt"}],"3zDjI":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"3DHvt":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"SvAYX":[function(require,module,exports) {
var toFinite = require("bfbde11f6050b93d");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"bfbde11f6050b93d":"jhSsv"}],"jhSsv":[function(require,module,exports) {
var toNumber = require("d5908978dd37a5bf");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"d5908978dd37a5bf":"eFYMf"}],"eFYMf":[function(require,module,exports) {
var isObject = require("5974fa590b23479f"), isSymbol = require("81e31fe7f16cf1d3");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"5974fa590b23479f":"2T4Z1","81e31fe7f16cf1d3":"hAPdd"}],"hAPdd":[function(require,module,exports) {
var baseGetTag = require("eff0ff96f59af4bf"), isObjectLike = require("81f244819af10af9");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"eff0ff96f59af4bf":"h2psl","81f244819af10af9":"3DHvt"}],"9lPH6":[function(require,module,exports) {
var baseValues = require("4ea0cd0b2d82d921"), keys = require("b11c67001071901");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"4ea0cd0b2d82d921":"iypdE","b11c67001071901":"dpjtS"}],"iypdE":[function(require,module,exports) {
var arrayMap = require("7bae5c395fe6a644");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"7bae5c395fe6a644":"jKhVW"}],"jKhVW":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"dpjtS":[function(require,module,exports) {
var arrayLikeKeys = require("9a09f082053877de"), baseKeys = require("9a5e78105676746d"), isArrayLike = require("95df766415ba3443");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"9a09f082053877de":"8p3FR","9a5e78105676746d":"4pK7r","95df766415ba3443":"hx7OW"}],"8p3FR":[function(require,module,exports) {
var baseTimes = require("3478d25da23ce2cd"), isArguments = require("2cfef3dc26aa9002"), isArray = require("8797f356742928cb"), isBuffer = require("4fb9ae2b1135f48c"), isIndex = require("e51cbeba1cf622bb"), isTypedArray = require("a6a459c3cf3ee000");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"3478d25da23ce2cd":"7FkYC","2cfef3dc26aa9002":"8HZaX","8797f356742928cb":"3zDjI","4fb9ae2b1135f48c":"dzx3W","e51cbeba1cf622bb":"jqEJp","a6a459c3cf3ee000":"lu18S"}],"7FkYC":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"8HZaX":[function(require,module,exports) {
var baseIsArguments = require("43cea7cbb521693a"), isObjectLike = require("a36a453e1cf92e38");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"43cea7cbb521693a":"85Xhi","a36a453e1cf92e38":"3DHvt"}],"85Xhi":[function(require,module,exports) {
var baseGetTag = require("c3bfccd4adf3c4fe"), isObjectLike = require("9b0c46aedad72a3b");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"c3bfccd4adf3c4fe":"h2psl","9b0c46aedad72a3b":"3DHvt"}],"dzx3W":[function(require,module,exports) {
var root = require("5656034e5e9c08de"), stubFalse = require("f6a6fd5fcf62e0b4");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"5656034e5e9c08de":"dsaaV","f6a6fd5fcf62e0b4":"eJNOu"}],"eJNOu":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"jqEJp":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"lu18S":[function(require,module,exports) {
var baseIsTypedArray = require("89dbf3ee50b7477f"), baseUnary = require("65507eb176e66c74"), nodeUtil = require("1e3dc0098fafeafe");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"89dbf3ee50b7477f":"lwONm","65507eb176e66c74":"3cR4l","1e3dc0098fafeafe":"1wNKL"}],"lwONm":[function(require,module,exports) {
var baseGetTag = require("b092e5d4f0e030c"), isLength = require("a0f2d0a771f9cca5"), isObjectLike = require("bd01effab75ef56");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"b092e5d4f0e030c":"h2psl","a0f2d0a771f9cca5":"kcH0i","bd01effab75ef56":"3DHvt"}],"3cR4l":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"1wNKL":[function(require,module,exports) {
var freeGlobal = require("a3b11216d53ac613");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"a3b11216d53ac613":"guxZL"}],"4pK7r":[function(require,module,exports) {
var isPrototype = require("5bdc12dfa77fba31"), nativeKeys = require("39dcb433c3bf7155");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"5bdc12dfa77fba31":"14LSl","39dcb433c3bf7155":"jb8rL"}],"14LSl":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"jb8rL":[function(require,module,exports) {
var overArg = require("c991163fef34595d");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"c991163fef34595d":"5w6dt"}],"5w6dt":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"hpCY3":[function(require,module,exports) {
var createFind = require("9f5813f108c177d2"), findIndex = require("70cc91a2eeb015");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"9f5813f108c177d2":"73t5l","70cc91a2eeb015":"4mfgP"}],"73t5l":[function(require,module,exports) {
var baseIteratee = require("9dcd4e8a01a476d3"), isArrayLike = require("76c47b2dc11f327b"), keys = require("73f6102a593e6d2b");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"9dcd4e8a01a476d3":"cMUMW","76c47b2dc11f327b":"hx7OW","73f6102a593e6d2b":"dpjtS"}],"cMUMW":[function(require,module,exports) {
var baseMatches = require("998977db78ba528"), baseMatchesProperty = require("c61273e3b031d891"), identity = require("57ab6e3670157bba"), isArray = require("d6f6a15048af98c4"), property = require("11741ccb6a4d0f4e");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"998977db78ba528":"3UeAp","c61273e3b031d891":"lXP4r","57ab6e3670157bba":"92ecY","d6f6a15048af98c4":"3zDjI","11741ccb6a4d0f4e":"7T57N"}],"3UeAp":[function(require,module,exports) {
var baseIsMatch = require("be5630948adab50e"), getMatchData = require("be608016fc14b612"), matchesStrictComparable = require("bd296df53092055e");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"be5630948adab50e":"hjUEM","be608016fc14b612":"fwTQL","bd296df53092055e":"1FAs6"}],"hjUEM":[function(require,module,exports) {
var Stack = require("49d8925de566576c"), baseIsEqual = require("59dd11d5ae2edfa");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"49d8925de566576c":"evNTe","59dd11d5ae2edfa":"hzESu"}],"evNTe":[function(require,module,exports) {
var ListCache = require("b3110271b8468c04"), stackClear = require("4c37bcc56675a5f5"), stackDelete = require("a4111e886e5dde03"), stackGet = require("c658bcf3e3526df0"), stackHas = require("b5017eede1ee24a3"), stackSet = require("4cd8989d180bc953");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"b3110271b8468c04":"bUpeA","4c37bcc56675a5f5":"7dU65","a4111e886e5dde03":"jQ2KS","c658bcf3e3526df0":"ey57L","b5017eede1ee24a3":"dW4tw","4cd8989d180bc953":"6WwSe"}],"bUpeA":[function(require,module,exports) {
var listCacheClear = require("2a2586e1a0e2358b"), listCacheDelete = require("2e43d1ce6306ff7"), listCacheGet = require("1d9585d939f8161e"), listCacheHas = require("70a8f032c7a0b781"), listCacheSet = require("62c8720e680f08d0");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"2a2586e1a0e2358b":"1o4qR","2e43d1ce6306ff7":"jmCEJ","1d9585d939f8161e":"eSKPO","70a8f032c7a0b781":"3LGOu","62c8720e680f08d0":"fhr35"}],"1o4qR":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"jmCEJ":[function(require,module,exports) {
var assocIndexOf = require("fb08074e93815d27");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"fb08074e93815d27":"7EZzi"}],"7EZzi":[function(require,module,exports) {
var eq = require("2ce289946c5f415d");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"2ce289946c5f415d":"dFO8r"}],"dFO8r":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"eSKPO":[function(require,module,exports) {
var assocIndexOf = require("63fb9ad95ba35a8d");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"63fb9ad95ba35a8d":"7EZzi"}],"3LGOu":[function(require,module,exports) {
var assocIndexOf = require("e4b17da1519e2bab");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"e4b17da1519e2bab":"7EZzi"}],"fhr35":[function(require,module,exports) {
var assocIndexOf = require("61969b14db246a2e");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"61969b14db246a2e":"7EZzi"}],"7dU65":[function(require,module,exports) {
var ListCache = require("4eacd9ec33dc552e");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"4eacd9ec33dc552e":"bUpeA"}],"jQ2KS":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ey57L":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"dW4tw":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"6WwSe":[function(require,module,exports) {
var ListCache = require("40f45dbefcc7cda4"), Map = require("61badcd28969cec2"), MapCache = require("927d27b31ce8e1a");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"40f45dbefcc7cda4":"bUpeA","61badcd28969cec2":"1GuGy","927d27b31ce8e1a":"1kcfm"}],"1GuGy":[function(require,module,exports) {
var getNative = require("bfa511c6216fe550"), root = require("801142c2ccc41b7e");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"bfa511c6216fe550":"dzU24","801142c2ccc41b7e":"dsaaV"}],"dzU24":[function(require,module,exports) {
var baseIsNative = require("847bcee41aa04d79"), getValue = require("faa508e33ffb33bb");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"847bcee41aa04d79":"fiQ6m","faa508e33ffb33bb":"6O7DU"}],"fiQ6m":[function(require,module,exports) {
var isFunction = require("cda0bc0ee9306b25"), isMasked = require("5bb330e92128510f"), isObject = require("c61fecf6192ec7c1"), toSource = require("654c2eedfa407425");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"cda0bc0ee9306b25":"6Mk8z","5bb330e92128510f":"bZzbn","c61fecf6192ec7c1":"2T4Z1","654c2eedfa407425":"a75Yo"}],"bZzbn":[function(require,module,exports) {
var coreJsData = require("291b54809a5cb658");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"291b54809a5cb658":"acmij"}],"acmij":[function(require,module,exports) {
var root = require("933ac694e4709ee7");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"933ac694e4709ee7":"dsaaV"}],"a75Yo":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"6O7DU":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"1kcfm":[function(require,module,exports) {
var mapCacheClear = require("446e6822cc1bfda6"), mapCacheDelete = require("deab1eb081f9086b"), mapCacheGet = require("e4eb6d3b76841d12"), mapCacheHas = require("bf1aa28efcdced44"), mapCacheSet = require("9d35276963f12d28");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"446e6822cc1bfda6":"51IbB","deab1eb081f9086b":"e0aTL","e4eb6d3b76841d12":"TOWzz","bf1aa28efcdced44":"dshTM","9d35276963f12d28":"kDJie"}],"51IbB":[function(require,module,exports) {
var Hash = require("915de7a8d353a912"), ListCache = require("acb9a32798f600f8"), Map = require("22f4f084af5ddfce");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"915de7a8d353a912":"cOZAh","acb9a32798f600f8":"bUpeA","22f4f084af5ddfce":"1GuGy"}],"cOZAh":[function(require,module,exports) {
var hashClear = require("abf9ec81581ec0ab"), hashDelete = require("fe6c1a92c8333b52"), hashGet = require("f77c3fe1164b7550"), hashHas = require("1f62c51517c2256"), hashSet = require("ceba11f7b9f72401");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"abf9ec81581ec0ab":"4V48E","fe6c1a92c8333b52":"6t8NG","f77c3fe1164b7550":"iUQCl","1f62c51517c2256":"b6Rjn","ceba11f7b9f72401":"7TMlM"}],"4V48E":[function(require,module,exports) {
var nativeCreate = require("eca2cb3062dfab69");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"eca2cb3062dfab69":"asnH5"}],"asnH5":[function(require,module,exports) {
var getNative = require("6e4cec675f80ea33");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"6e4cec675f80ea33":"dzU24"}],"6t8NG":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"iUQCl":[function(require,module,exports) {
var nativeCreate = require("8e8df5d32bbb81b6");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"8e8df5d32bbb81b6":"asnH5"}],"b6Rjn":[function(require,module,exports) {
var nativeCreate = require("2c8a186d1b7eb856");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"2c8a186d1b7eb856":"asnH5"}],"7TMlM":[function(require,module,exports) {
var nativeCreate = require("605b5ec825f49bc5");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"605b5ec825f49bc5":"asnH5"}],"e0aTL":[function(require,module,exports) {
var getMapData = require("52db1b1ea256bd4b");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"52db1b1ea256bd4b":"cTgwr"}],"cTgwr":[function(require,module,exports) {
var isKeyable = require("e1b222ca24e4ce3a");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"e1b222ca24e4ce3a":"exMFv"}],"exMFv":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"TOWzz":[function(require,module,exports) {
var getMapData = require("8dcd3863207295bc");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"8dcd3863207295bc":"cTgwr"}],"dshTM":[function(require,module,exports) {
var getMapData = require("7e713699c3bd2a1f");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"7e713699c3bd2a1f":"cTgwr"}],"kDJie":[function(require,module,exports) {
var getMapData = require("be7020c1df2619a9");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"be7020c1df2619a9":"cTgwr"}],"hzESu":[function(require,module,exports) {
var baseIsEqualDeep = require("4f024d585e5285d6"), isObjectLike = require("d4096cc18817af9d");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"4f024d585e5285d6":"irWBX","d4096cc18817af9d":"3DHvt"}],"irWBX":[function(require,module,exports) {
var Stack = require("a3bd249505ff04d8"), equalArrays = require("bbdd8e956b06a9db"), equalByTag = require("14e5d03293a9948a"), equalObjects = require("61df0f9a75214a7f"), getTag = require("d2b9c4f59de139f4"), isArray = require("7b67ed061fc8aca1"), isBuffer = require("71a27fa2177cd572"), isTypedArray = require("28e4e63c2cb02f9b");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"a3bd249505ff04d8":"evNTe","bbdd8e956b06a9db":"dodC9","14e5d03293a9948a":"8nxyP","61df0f9a75214a7f":"8HZ86","d2b9c4f59de139f4":"fjZWa","7b67ed061fc8aca1":"3zDjI","71a27fa2177cd572":"dzx3W","28e4e63c2cb02f9b":"lu18S"}],"dodC9":[function(require,module,exports) {
var SetCache = require("e77e24e8955481b4"), arraySome = require("655142c8683bb2f3"), cacheHas = require("ed69624dc41449ec");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"e77e24e8955481b4":"3U7jC","655142c8683bb2f3":"8PZ8I","ed69624dc41449ec":"7K1Gh"}],"3U7jC":[function(require,module,exports) {
var MapCache = require("6b97558c63bc26b1"), setCacheAdd = require("c8365e5c2427000c"), setCacheHas = require("98ee6d5cc3eeb64c");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"6b97558c63bc26b1":"1kcfm","c8365e5c2427000c":"fJI4B","98ee6d5cc3eeb64c":"h7hU5"}],"fJI4B":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"h7hU5":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"8PZ8I":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"7K1Gh":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"8nxyP":[function(require,module,exports) {
var Symbol = require("109b3203b2bf4312"), Uint8Array = require("a38807bd8c34a3aa"), eq = require("fed853de754c5cc3"), equalArrays = require("639f9a68158e5630"), mapToArray = require("aec8ebcff739f5e"), setToArray = require("5d9d796d3e4d6c83");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"109b3203b2bf4312":"76QqE","a38807bd8c34a3aa":"koPrB","fed853de754c5cc3":"dFO8r","639f9a68158e5630":"dodC9","aec8ebcff739f5e":"3LD4A","5d9d796d3e4d6c83":"4SH9I"}],"koPrB":[function(require,module,exports) {
var root = require("3c48106aed14b049");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"3c48106aed14b049":"dsaaV"}],"3LD4A":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"4SH9I":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"8HZ86":[function(require,module,exports) {
var getAllKeys = require("ee476c54705b6e12");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"ee476c54705b6e12":"dvyAW"}],"dvyAW":[function(require,module,exports) {
var baseGetAllKeys = require("894317612e231a76"), getSymbols = require("6e933b0495792d2e"), keys = require("740427d36141e060");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"894317612e231a76":"jmCYG","6e933b0495792d2e":"hvWKR","740427d36141e060":"dpjtS"}],"jmCYG":[function(require,module,exports) {
var arrayPush = require("7cd2aba580302a26"), isArray = require("fed946f2c382b462");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"7cd2aba580302a26":"8G7oT","fed946f2c382b462":"3zDjI"}],"8G7oT":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"hvWKR":[function(require,module,exports) {
var arrayFilter = require("16f8d1de3a2e1f5d"), stubArray = require("2067597d3151f91d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"16f8d1de3a2e1f5d":"kq9pj","2067597d3151f91d":"lr0bi"}],"kq9pj":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"lr0bi":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"fjZWa":[function(require,module,exports) {
var DataView = require("8f6b6e0e08613596"), Map = require("1236f2ff705b395b"), Promise = require("8104f80eecdcad4c"), Set = require("e0996193298029e0"), WeakMap = require("c4b027cfea8197b4"), baseGetTag = require("9a2a232c2b8e382f"), toSource = require("208df093cf86b2cb");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"8f6b6e0e08613596":"4w4Ml","1236f2ff705b395b":"1GuGy","8104f80eecdcad4c":"dx320","e0996193298029e0":"8nxq3","c4b027cfea8197b4":"8CwJl","9a2a232c2b8e382f":"h2psl","208df093cf86b2cb":"a75Yo"}],"4w4Ml":[function(require,module,exports) {
var getNative = require("393554faa354a36d"), root = require("ac69cdc1ff4e561a");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"393554faa354a36d":"dzU24","ac69cdc1ff4e561a":"dsaaV"}],"dx320":[function(require,module,exports) {
var getNative = require("b47dd04defbee0f3"), root = require("7f3935de6efd38c1");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"b47dd04defbee0f3":"dzU24","7f3935de6efd38c1":"dsaaV"}],"8nxq3":[function(require,module,exports) {
var getNative = require("a079172e0ed395e5"), root = require("b3b8cdb604e8ee6");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"a079172e0ed395e5":"dzU24","b3b8cdb604e8ee6":"dsaaV"}],"8CwJl":[function(require,module,exports) {
var getNative = require("842dd07343c6fa0a"), root = require("19f9957fb7220718");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"842dd07343c6fa0a":"dzU24","19f9957fb7220718":"dsaaV"}],"fwTQL":[function(require,module,exports) {
var isStrictComparable = require("9804195a39fb7887"), keys = require("5f790d262ae1c8e2");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"9804195a39fb7887":"bqOOB","5f790d262ae1c8e2":"dpjtS"}],"bqOOB":[function(require,module,exports) {
var isObject = require("892a477e7a5c79c7");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"892a477e7a5c79c7":"2T4Z1"}],"1FAs6":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"lXP4r":[function(require,module,exports) {
var baseIsEqual = require("3fcdd51206cd5bd6"), get = require("9a14f31d422cad83"), hasIn = require("f99b0416fce0125"), isKey = require("b350e874393ae8b9"), isStrictComparable = require("6446e5dc9e4aed88"), matchesStrictComparable = require("8a973770b0156341"), toKey = require("3628535abd6de450");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"3fcdd51206cd5bd6":"hzESu","9a14f31d422cad83":"70mQV","f99b0416fce0125":"j2Trz","b350e874393ae8b9":"9di2Y","6446e5dc9e4aed88":"bqOOB","8a973770b0156341":"1FAs6","3628535abd6de450":"3s1jt"}],"70mQV":[function(require,module,exports) {
var baseGet = require("fe825043377d441c");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"fe825043377d441c":"2Y03D"}],"2Y03D":[function(require,module,exports) {
var castPath = require("29d2608bf8a1a653"), toKey = require("46cfd00f85dd3316");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"29d2608bf8a1a653":"fOjK2","46cfd00f85dd3316":"3s1jt"}],"fOjK2":[function(require,module,exports) {
var isArray = require("f1697bd7cf52345e"), isKey = require("a9bebefcc540969d"), stringToPath = require("a2eca5a28a4ac423"), toString = require("a0a34982c4f39fe4");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"f1697bd7cf52345e":"3zDjI","a9bebefcc540969d":"9di2Y","a2eca5a28a4ac423":"iNrpL","a0a34982c4f39fe4":"eWHIU"}],"9di2Y":[function(require,module,exports) {
var isArray = require("ba0919fa9b35e94f"), isSymbol = require("68dce4ce63491c6");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"ba0919fa9b35e94f":"3zDjI","68dce4ce63491c6":"hAPdd"}],"iNrpL":[function(require,module,exports) {
var memoizeCapped = require("36ad1c32a81634a3");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"36ad1c32a81634a3":"i2kFh"}],"i2kFh":[function(require,module,exports) {
var memoize = require("2779cecad018be67");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"2779cecad018be67":"jAgx6"}],"jAgx6":[function(require,module,exports) {
var MapCache = require("115df36af4db60a6");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"115df36af4db60a6":"1kcfm"}],"eWHIU":[function(require,module,exports) {
var baseToString = require("d86e2cc78e0d9d9e");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"d86e2cc78e0d9d9e":"e32J3"}],"e32J3":[function(require,module,exports) {
var Symbol = require("ec06b1d8e7dd097"), arrayMap = require("63270777b46c3dd3"), isArray = require("ef26ed09ffbcc356"), isSymbol = require("f414789200f8161a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"ec06b1d8e7dd097":"76QqE","63270777b46c3dd3":"jKhVW","ef26ed09ffbcc356":"3zDjI","f414789200f8161a":"hAPdd"}],"3s1jt":[function(require,module,exports) {
var isSymbol = require("c906ac81e6e73a42");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"c906ac81e6e73a42":"hAPdd"}],"j2Trz":[function(require,module,exports) {
var baseHasIn = require("2d81adca570cf53c"), hasPath = require("70d12e9f4221ffcd");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"2d81adca570cf53c":"7YzG2","70d12e9f4221ffcd":"l8Bcy"}],"7YzG2":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"l8Bcy":[function(require,module,exports) {
var castPath = require("b0196fd954c355cc"), isArguments = require("6d1a36ecb83aa71f"), isArray = require("69937529eac32637"), isIndex = require("f19f53c01abb0510"), isLength = require("7148b12a355ba59"), toKey = require("b50fb4c03a439e7");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"b0196fd954c355cc":"fOjK2","6d1a36ecb83aa71f":"8HZaX","69937529eac32637":"3zDjI","f19f53c01abb0510":"jqEJp","7148b12a355ba59":"kcH0i","b50fb4c03a439e7":"3s1jt"}],"92ecY":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"7T57N":[function(require,module,exports) {
var baseProperty = require("a3fdde6b84d20882"), basePropertyDeep = require("e776bfd4685db362"), isKey = require("8a7e12f393c730a5"), toKey = require("8bd01aff19931435");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"a3fdde6b84d20882":"9LzcC","e776bfd4685db362":"blyIu","8a7e12f393c730a5":"9di2Y","8bd01aff19931435":"3s1jt"}],"9LzcC":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"blyIu":[function(require,module,exports) {
var baseGet = require("e9b6d77852bde2b");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"e9b6d77852bde2b":"2Y03D"}],"4mfgP":[function(require,module,exports) {
var baseFindIndex = require("6f040e2a2032721c"), baseIteratee = require("b81d60db764775c"), toInteger = require("3ef2fb35791cfee4");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"6f040e2a2032721c":"84Khh","b81d60db764775c":"cMUMW","3ef2fb35791cfee4":"SvAYX"}],"jskkr":[function(require,module,exports) {
var createFind = require("8258bbaa01b0362b"), findLastIndex = require("67ee2a54523611db");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var findLast = createFind(findLastIndex);
module.exports = findLast;

},{"8258bbaa01b0362b":"73t5l","67ee2a54523611db":"jB7zw"}],"jB7zw":[function(require,module,exports) {
var baseFindIndex = require("30608751c6f2adce"), baseIteratee = require("5a83441f9383e9c9"), toInteger = require("b1a72fc53dae434f");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}
module.exports = findLastIndex;

},{"30608751c6f2adce":"84Khh","5a83441f9383e9c9":"cMUMW","b1a72fc53dae434f":"SvAYX"}],"deEJ0":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b8843ea55005f6ea");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBoundingFocusNodes = exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("635dfea881a03d36"));
var _findIndex = _interopRequireDefault(require("3364d630ce4ba69"));
var _findLastIndex = _interopRequireDefault(require("a519954f4ecb0566"));
var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Returns true if a node can be focused
 */ var canFocusNode = function canFocusNode(node) {
    return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};
exports.canFocusNode = canFocusNode;
var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
    return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};
exports.canKeyboardFocusNode = canKeyboardFocusNode;
var getFocusNodes = function getFocusNodes(node) {
    return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};
exports.getFocusNodes = getFocusNodes;
var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
    return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */ exports.getKeyboardFocusNodes = getKeyboardFocusNodes;
var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
    var nodes = [
        canFocusNode(node) ? node : undefined
    ].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
    var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
    var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
    var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
    var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
    return {
        startNodes: startNodes,
        endNodes: endNodes
    };
};
exports.getBoundingFocusNodes = getBoundingFocusNodes;

},{"b8843ea55005f6ea":"hVU2P","635dfea881a03d36":"eeyCq","3364d630ce4ba69":"4mfgP","a519954f4ecb0566":"jB7zw"}],"eeyCq":[function(require,module,exports) {
var arrayWithoutHoles = require("10773680d85f0d44");
var iterableToArray = require("585c2aca7ce3cf3f");
var unsupportedIterableToArray = require("8a5b5900a4a07c63");
var nonIterableSpread = require("f3206a934bcf2d33");
function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray;

},{"10773680d85f0d44":"lG8Pt","585c2aca7ce3cf3f":"ljpbi","8a5b5900a4a07c63":"f7aaR","f3206a934bcf2d33":"7P1XR"}],"lG8Pt":[function(require,module,exports) {
var arrayLikeToArray = require("ee8be07cf919684d");
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles;

},{"ee8be07cf919684d":"jy1ky"}],"jy1ky":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray;

},{}],"ljpbi":[function(require,module,exports) {
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
module.exports = _iterableToArray;

},{}],"f7aaR":[function(require,module,exports) {
var arrayLikeToArray = require("ff16c2480541fceb");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray;

},{"ff16c2480541fceb":"jy1ky"}],"7P1XR":[function(require,module,exports) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread;

},{}],"1Rsyx":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("78ed5b2e7f61c1cc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _useFocus = _interopRequireDefault(require("ac3f5833fe2b37d"));
var _default = _useFocus["default"];
exports["default"] = _default;

},{"78ed5b2e7f61c1cc":"hVU2P","ac3f5833fe2b37d":"dPzCO"}],"dPzCO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("522e5ba81a405aa8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("533ffbe98cd8e61a"));
var _react = require("ca9ca507b9b38784");
var _noop = _interopRequireDefault(require("6ef903a8db03cbe9"));
/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */ /**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */ /**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */ /**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */ var useFocus = function useFocus() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, disabled = _ref.disabled, multipleNodes = _ref.multipleNodes, _ref$onBlur = _ref.onBlur, onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur, _ref$onFocus = _ref.onFocus, onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;
    var _useState = (0, _react.useState)([
        false,
        null
    ]), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2), focus = _useState2$[0], focusDescendent = _useState2$[1], setFocus = _useState2[1];
    var focusedNode = (0, _react.useRef)();
    var blurTimeout = (0, _react.useRef)();
    var onFocus = (0, _react.useCallback)(function(event) {
        clearTimeout(blurTimeout.current);
        focusedNode.current = event ? event.target : undefined;
        var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;
        if (!focus || focusDescendent !== nextFocusDescendent) setFocus([
            true,
            nextFocusDescendent
        ]);
        if (!focus) onFocusCallback(event, getInteractionDevice());
    }, [
        onFocusCallback,
        focus,
        focusDescendent
    ]);
    var onBlurComplete = (0, _react.useCallback)(function(event) {
        setFocus([
            false,
            false
        ]);
        onBlurCallback(event, getInteractionDevice());
    }, [
        onBlurCallback
    ]);
    var onBlur = (0, _react.useCallback)(function(event) {
        if (event && multipleNodes) {
            clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
            // multiple elements. Instead, wait briefly using setTimeout to see if
            // onFocus is called for another element we're tracking. If it is then
            // we consider the state to still be focused, otherwise we can move ahead
            // and call `onBlurComplete`.
            event.persist();
            blurTimeout.current = setTimeout(function() {
                if (event.target === focusedNode.current) onBlurComplete(event);
            }, 0);
        } else onBlurComplete(event);
    }, [
        onBlurComplete,
        multipleNodes
    ]);
    var focusProps = (0, _react.useMemo)(function() {
        return {
            onFocus: onFocus,
            onBlur: onBlur
        };
    }, [
        onFocus,
        onBlur
    ]);
    (0, _react.useEffect)(function() {
        // When the node(s) are focused and we flip from enabled to disabled, clear
        // the focus (see the docs for the disabled param re: why this is
        // necessary).
        if (focus && disabled) setFocus([
            false,
            false
        ]);
         // Clear the timeout when unmounting
        return function() {
            return clearTimeout(blurTimeout.current);
        };
    }, [
        focus,
        disabled
    ]);
    return {
        focus: focus,
        focusProps: focusProps,
        focusDescendent: focusDescendent,
        focusTrigger: getInteractionDevice()
    };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */ var getInteractionDevice = function() {
    var device = "keyboard";
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("mousedown", function() {
            return device = "mouse";
        }, true);
        window.addEventListener("keydown", function() {
            return device = "keyboard";
        }, true);
    }
    return function() {
        return device;
    };
}();
var _default = useFocus;
exports["default"] = _default;

},{"522e5ba81a405aa8":"hVU2P","533ffbe98cd8e61a":"8ndYg","ca9ca507b9b38784":"6uln9","6ef903a8db03cbe9":"4uGIw"}],"8ndYg":[function(require,module,exports) {
var arrayWithHoles = require("811542977f8e0f8a");
var iterableToArrayLimit = require("8d00fd210e4610b8");
var unsupportedIterableToArray = require("4337fe58776f2845");
var nonIterableRest = require("9dc0c16dbab77f87");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray;

},{"811542977f8e0f8a":"kY9x4","8d00fd210e4610b8":"1CgnA","4337fe58776f2845":"f7aaR","9dc0c16dbab77f87":"cQxRl"}],"kY9x4":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles;

},{}],"1CgnA":[function(require,module,exports) {
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = _iterableToArrayLimit;

},{}],"cQxRl":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest;

},{}],"7BvDg":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d6fb95373999746");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseAlignment = exports.parseSpacing = void 0;
var _spacing = _interopRequireDefault(require("e216503239bdea89"));
var _token = require("918972f665f89fbb");
// Parses the value for a spacing prop. This turns a string of spacing names
// like "medium" or "small medium" into an array of spacing values like ["16px"]
// or ["8px", "16px"].
var parseSpacing = function parseSpacing(spacing) {
    return spacing ? spacing.split(" ").map(function(spacing) {
        return (0, _token.getToken)(_spacing["default"], "spacing", spacing) || 0;
    }) : [];
}; // Parses the value for a alignment prop. Given a valid alignment prop value
// this will return an array of two values representing x and y alignment
// respectively.
exports.parseSpacing = parseSpacing;
var parseAlignment = function parseAlignment(alignment) {
    var values = alignment.split(" ");
    return {
        x: values[1],
        y: values[0]
    };
};
exports.parseAlignment = parseAlignment;

},{"d6fb95373999746":"hVU2P","e216503239bdea89":"8D3is","918972f665f89fbb":"dp1DQ"}],"aJ6so":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Takes an object of props and filters them down to only the props with names
 * that start with one of a given set of prefixes.
 */ var filterPropsByPrefix = function filterPropsByPrefix(props, prefixes) {
    return Object.keys(props).filter(function(name) {
        return prefixes.some(function(prefix) {
            return name.indexOf(prefix) === 0;
        });
    }).reduce(function(result, name) {
        result[name] = props[name];
        return result;
    }, {});
};
var _default = filterPropsByPrefix;
exports["default"] = _default;

},{}],"aw8aI":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a0b9b24de06da05");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _column = _interopRequireDefault(require("2742c56c778ccc80"));
var _default = _column["default"];
exports["default"] = _default;

},{"a0b9b24de06da05":"hVU2P","2742c56c778ccc80":"gbBzx"}],"gbBzx":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ac43b75ecdbc1da");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("8229e8f50ccda07b"));
var _react = _interopRequireDefault(require("17348124ee0c7632"));
var _propTypes = _interopRequireDefault(require("4935b8e0da60bc0a"));
var _emotion = require("d5181b2f2be8f99d");
var _reduce = _interopRequireDefault(require("774fccfa1e12b698"));
var _box = _interopRequireDefault(require("5bbd3c1cf8a3de42"));
var _propTypes2 = _interopRequireDefault(require("fea37e146f33e14f"));
var _parsers = require("1160359e9521618a");
var _functional = require("fb42d9a3a2352b89");
var _cxMemoized = _interopRequireDefault(require("ccf3b51cbcf0b891"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = function styles(heights) {
    return (0, _functional.memoizeByKeys)(function(_ref) {
        var spacing = _ref.spacing, alignmentVertical = _ref.alignmentVertical, alignmentHorizontal = _ref.alignmentHorizontal;
        return (0, _emotion.css)({
            display: "flex",
            flexDirection: "column",
            justifyContent: {
                top: "flex-start",
                bottom: "flex-end",
                center: "center",
                justify: "space-between"
            }[alignmentVertical],
            alignItems: {
                left: "flex-start",
                right: "flex-end",
                center: "center",
                stretch: "stretch"
            }[alignmentHorizontal],
            // Set margins and heights on the children of the column. Use !important to
            // override any existing styles.
            "& > *": {
                // Make sure that any borders or padding applied to the child don't throw
                // of the heights that we apply
                boxSizing: "border-box !important",
                // Ensure that the correct bottom margin is set (and clear other margins)
                margin: "0 0 ".concat((0, _parsers.parseSpacing)(spacing)[0], "px 0 !important"),
                // Don't let the last child add extra space to the end of the column.
                ":last-child": {
                    margin: "0 !important"
                }
            }
        }, // whose index in the dom matches the height's index in the array. If
        // we've got a single height, apply that to all children.
        Array.isArray(heights) ? (0, _reduce["default"])(heights, function(result, height, index) {
            return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, "& > *:nth-child(".concat(parseInt(index) + 1, ")"), childStyles(height)));
        }, {}) : {
            "& > *": childStyles(heights)
        });
    }, [
        "spacing",
        "alignmentVertical",
        "alignmentHorizontal"
    ]);
};
var stylesWithUniqueWidths = (0, _functional.memoizeArray)(styles);
var stylesWithUniformWidths = (0, _functional.memoize)(styles);
var childStyles = function childStyles(height) {
    return {
        flex: height === "fill" ? "1 !important" : undefined,
        flexShrink: height && height !== "fill" && height !== "auto" ? "0 !important" : undefined,
        height: height !== "fill" && height !== "fit" && height !== undefined && height !== null && height !== "" ? "".concat(height).concat(typeof height === "number" ? "px" : "", " !important") : undefined
    };
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */ var Column = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    // We need to memoize differently based on whether we got an array or scalar
    // for the "heights" property
    var stylesFunc = Array.isArray(props.heights) ? stylesWithUniqueWidths : stylesWithUniformWidths;
    var styles = stylesFunc(props.heights)(props);
    return /*#__PURE__*/ _react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
        className: (0, _cxMemoized["default"])(styles, props.className),
        ref: ref
    }));
});
Column.displayName = "Column";
Column.propTypes = {};
Column.defaultProps = {
    spacing: "medium",
    alignmentVertical: "top",
    alignmentHorizontal: "stretch"
};
var _default = Column;
exports["default"] = _default;

},{"ac43b75ecdbc1da":"hVU2P","8229e8f50ccda07b":"74DXJ","17348124ee0c7632":"6uln9","4935b8e0da60bc0a":"1hOJi","d5181b2f2be8f99d":"kbmlY","774fccfa1e12b698":"9ehhA","5bbd3c1cf8a3de42":"dULlg","fea37e146f33e14f":"c8tMj","1160359e9521618a":"7BvDg","fb42d9a3a2352b89":"4L61K","ccf3b51cbcf0b891":"ixtrV"}],"9ehhA":[function(require,module,exports) {
var arrayReduce = require("b2ac44f0b0d2ce"), baseEach = require("b189010b19f5b940"), baseIteratee = require("91403391f832de20"), baseReduce = require("2f2177f8cc5ec2b0"), isArray = require("f2798c40933daed0");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
module.exports = reduce;

},{"b2ac44f0b0d2ce":"ffHCB","b189010b19f5b940":"5SSG2","91403391f832de20":"cMUMW","2f2177f8cc5ec2b0":"d11vW","f2798c40933daed0":"3zDjI"}],"ffHCB":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"5SSG2":[function(require,module,exports) {
var baseForOwn = require("a423a28dfc96af30"), createBaseEach = require("d42c06d15dc24f91");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"a423a28dfc96af30":"aGMR8","d42c06d15dc24f91":"hBCvT"}],"aGMR8":[function(require,module,exports) {
var baseFor = require("328528ff2c3e444"), keys = require("edd21651a64e63be");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"328528ff2c3e444":"aTF8L","edd21651a64e63be":"dpjtS"}],"aTF8L":[function(require,module,exports) {
var createBaseFor = require("f5c9934dd9b1d76");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"f5c9934dd9b1d76":"iH34S"}],"iH34S":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"hBCvT":[function(require,module,exports) {
var isArrayLike = require("73f723f241e434bb");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"73f723f241e434bb":"hx7OW"}],"d11vW":[function(require,module,exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = baseReduce;

},{}],"dULlg":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c03c1d5da84874b0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _box = _interopRequireDefault(require("e69fba0e93330061"));
var _default = _box["default"];
exports["default"] = _default;

},{"c03c1d5da84874b0":"hVU2P","e69fba0e93330061":"8pzup"}],"8pzup":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("eda29f73422bf38c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("7e3672448bdf8fc1"));
var _react = _interopRequireDefault(require("c0baab6011b2229b"));
var _propTypes = _interopRequireDefault(require("931a9df2557b1692"));
var _box = _interopRequireDefault(require("5c019523c9a1a6a8"));
var _emotion = require("340e7db407efda3f");
var _propTypes2 = _interopRequireDefault(require("710a4d15f8df019d"));
var _parsers = require("e293b3cde1c0b737");
var _theme = require("3df780746a70f942");
var _token = require("6fa46cd0702391b3");
var _functional = require("a6e8e7335243ccac");
var _cxMemoized = _interopRequireDefault(require("8c87545b8b79889"));
var _filterPropsByPrefix = _interopRequireDefault(require("16aecdf86fc89eca"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _functional.memoizeByKeys)(function(_ref) {
    var backgroundColor = _ref.backgroundColor, borderColor = _ref.borderColor, borderWidth = _ref.borderWidth, borderRadius = _ref.borderRadius, width = _ref.width, height = _ref.height, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxWidth = _ref.maxWidth, maxHeight = _ref.maxHeight, overflowY = _ref.overflowY, spacingInset = _ref.spacingInset;
    return (0, _emotion.css)({
        boxSizing: "border-box",
        // If we have a border radius defined then clip content so that it doesn't
        // bleed out the corners
        overflow: borderRadius ? "hidden" : undefined,
        overflowY: overflowY ? overflowY : undefined,
        padding: (0, _parsers.parseSpacing)(spacingInset).map(function(value) {
            return "".concat(value, "px");
        }).join(" "),
        borderStyle: borderWidth && borderColor ? "solid" : undefined,
        borderWidth: borderWidth,
        borderColor: borderColor,
        borderRadius: borderRadius,
        backgroundColor: backgroundColor,
        width: width,
        height: height,
        minWidth: minWidth,
        maxWidth: maxWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    });
}, [
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "width",
    "height",
    "minWidth",
    "minHeight",
    "maxWidth",
    "maxHeight",
    "overflowY",
    "spacingInset"
]);
var themedStyles = (0, _functional.memoize)(function(t) {
    return (0, _functional.memoizeByKeys)(function(_ref2) {
        var type = _ref2.type, backgroundColor = _ref2.backgroundColor, width = _ref2.width, height = _ref2.height, minWidth = _ref2.minWidth, minHeight = _ref2.minHeight, maxWidth = _ref2.maxWidth, maxHeight = _ref2.maxHeight, overflowY = _ref2.overflowY, spacingInset = _ref2.spacingInset;
        return styles({
            backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [
                backgroundColor,
                "default"
            ]) || backgroundColor : t("backgroundColor", type),
            borderColor: t("borderColor", type),
            borderWidth: t("borderWidth"),
            borderRadius: t("borderRadius", type),
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            overflowY: overflowY,
            spacingInset: spacingInset
        });
    }, [
        "type",
        "backgroundColor",
        "width",
        "height",
        "minWidth",
        "minHeight",
        "maxWidth",
        "maxHeight",
        "overflowY",
        "spacingInset"
    ]);
});
/**
 * The Box component can also be used to visually separate part of the layout by
 * applying an outline or fill.
 *
 * It can also be used as a layout component (similar to the Row and Column
 * components) to apply width and inset padding to any part of the layout (with
 * or without an outline or fill).
 */ var Box = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return props.backgroundColor || props.type ? /*#__PURE__*/ _react["default"].createElement(ThemedBox, _objectSpread(_objectSpread({}, props), {}, {
        ref: ref
    }), props.children) : /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ])), {}, {
        className: (0, _cxMemoized["default"])(styles(props), props.className),
        id: props.id,
        tabIndex: props.tabIndex,
        ref: ref
    }), props.children);
});
Box.displayName = "Box";
Box.propTypes = {
    /**
   * Set the box's background color using a preset, or using a string
   * containing any valid CSS color.
   */ backgroundColor: _propTypes["default"].oneOfType([
        _propTypes["default"].oneOf([
            "primary",
            "secondary",
            "alternatePrimary",
            "alternateSecondary"
        ]),
        _propTypes["default"].string
    ]),
    /**
   * The elements to render inside the box.
   */ children: _propTypes["default"].node,
    /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */ className: _propTypes["default"].string,
    /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */ "data-*": _propTypes["default"].string,
    /**
   * Set the height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ height: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Adds an [id](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id) to the component.
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   *
   * @since 4.x
   */ id: _propTypes["default"].string,
    /**
   * Set the maximum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ maxHeight: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Set the maximum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ maxWidth: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Set the minimum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ minHeight: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Set the minimum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ minWidth: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   */ overflowY: _propTypes["default"].oneOf([
        "auto",
        "hidden",
        "scroll"
    ]),
    /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */ spacingInset: _propTypes2["default"].spacing(4),
    /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */ tabIndex: _propTypes["default"].string,
    /**
   * The HTML tag to use when rendering the component to the DOM.
   */ tag: _propTypes["default"].string,
    /**
   * The type of visuals to apply to the box. If this is omitted the box will
   * not have any decorative styles and can be used purely for layout purposes.
   */ type: _propTypes["default"].oneOf([
        "outline",
        "fill"
    ]),
    /**
   * Set the width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ width: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ])
};
Box.defaultProps = {
    tag: "div",
    spacingInset: "none"
};
/* eslint-disable react/prop-types */ /**
 * This component renders a themed box. This is only used if themed styles are
 * actually applied to the box. Otherwise we can skip all the extra work that
 * goes into theming.
 */ var ThemedBox = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_box["default"], "box");
    return /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ])), {}, {
        className: (0, _cxMemoized["default"])(themedStyles(t)(props), props.className),
        id: props.id,
        tabIndex: props.tabIndex,
        ref: ref
    }), props.children);
});
ThemedBox.displayName = "ThemedBox";
/* eslint-enable react/prop-types */ var _default = Box;
exports["default"] = _default;

},{"eda29f73422bf38c":"hVU2P","7e3672448bdf8fc1":"74DXJ","c0baab6011b2229b":"6uln9","931a9df2557b1692":"1hOJi","5c019523c9a1a6a8":"6etQy","340e7db407efda3f":"kbmlY","710a4d15f8df019d":"c8tMj","e293b3cde1c0b737":"7BvDg","3df780746a70f942":"f7yMb","6fa46cd0702391b3":"dp1DQ","a6e8e7335243ccac":"4L61K","8c87545b8b79889":"ixtrV","16aecdf86fc89eca":"aJ6so"}],"c8tMj":[function(require,module,exports) {
"use strict";
module.exports = require("183008e8711fcdf7");

},{"183008e8711fcdf7":"gAQ06"}],"gAQ06":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var shim = function shim() {};
shim.isRequired = shim;
var getShim = function getShim() {
    return shim;
}; // Important!
// Keep this list in sync with production version in `./_prop-types.js`.
var size = shim;
var flexAlignment = getShim;
var spacing = getShim;
var alignment = shim;
var _default = {
    size: size,
    flexAlignment: flexAlignment,
    spacing: spacing,
    alignment: alignment
};
exports["default"] = _default;

},{}],"ixtrV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _emotion = require("1770bd0839ff9709");
var _functional = require("51cd19ed3b68d236");
var cxMemoizedCurried = (0, _functional.memoizeCurry)(_emotion.cx, 1);
/**
 * A memoized version of cx. Only supports two classes.
 */ var cxMemoized = function cxMemoized(a, b) {
    return cxMemoizedCurried(a)(b);
};
var _default = cxMemoized;
exports["default"] = _default;

},{"1770bd0839ff9709":"kbmlY","51cd19ed3b68d236":"4L61K"}],"2VLMq":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("686d812175f89fc5");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _row = _interopRequireDefault(require("ce0a8acbc3ffd0f"));
var _default = _row["default"];
exports["default"] = _default;

},{"686d812175f89fc5":"hVU2P","ce0a8acbc3ffd0f":"6cEKG"}],"6cEKG":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("795db92d9e806d2d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.gridColumns = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("46561bb046ed6e28"));
var _react = _interopRequireDefault(require("a4f99ad4fb793706"));
var _propTypes = _interopRequireDefault(require("22d308163af2d61c"));
var _emotion = require("3981994786f19f12");
var _box = _interopRequireDefault(require("169f02f03341e807"));
var _propTypes2 = _interopRequireDefault(require("acaf511cbbc47fdb"));
var _parsers = require("60c4cdc993c1c576");
var _functional = require("58231c0e0f94a556");
var _cxMemoized = _interopRequireDefault(require("bcb55ca464a031ce"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var gridColumns = 12; // Turns a raw width value (a string or number) into an object with fields
// containing the type of width and the parsed width values
exports.gridColumns = gridColumns;
var parseWidth = function parseWidth(width) {
    return typeof width === "string" && /^grid-/.test(width) ? {
        type: "grid",
        // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
        // "grid-4" to 0.3333)
        value: Math.floor(10000 * parseInt(width.substr(5)) / gridColumns) / 10000
    } : typeof width === "string" && /^[0-9.]+%\s*$/.test(width) ? {
        type: "percentage",
        // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
        // to 0.3333)
        value: Math.floor(100 * parseFloat(width)) / 10000
    } : width === "fit" || width === "fill" ? {
        type: "flex",
        value: width
    } : width !== undefined && width !== null && width !== "" ? {
        type: "css",
        value: width
    } : {
        type: "empty",
        value: null
    };
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)
var wrapContainerStyles = (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch"
});
var rowStyles = function rowStyles(widths) {
    return (0, _functional.memoizeByKeys)(function(_ref) {
        var wrap = _ref.wrap, spacing = _ref.spacing, alignmentHorizontal = _ref.alignmentHorizontal, alignmentVertical = _ref.alignmentVertical, reverse = _ref.reverse;
        var spacingValues = (0, _parsers.parseSpacing)(spacing);
        var verticalSpacing = spacingValues[0];
        var horizontalSpacing = spacingValues[1] || verticalSpacing;
        return (0, _emotion.css)((0, _defineProperty2["default"])({
            width: wrap === "none" ? undefined : "calc(100% + ".concat(horizontalSpacing, "px)"),
            display: "flex",
            flexDirection: reverse ? "row-reverse" : "row",
            flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
            alignItems: {
                top: "flex-start",
                bottom: "flex-end"
            }[alignmentVertical] || alignmentVertical,
            justifyContent: {
                left: "flex-start",
                right: "flex-end",
                justify: "space-between"
            }[alignmentHorizontal] || alignmentHorizontal,
            // Reset the extra margins caused by the children on the right/bottom
            // edges. We can't do a simple reset on the first/last child because
            // there may be any number of children on the right/bottom edges if the
            // row wraps.
            margin: wrap === "none" ? undefined : "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0"),
            // Set margins and widths on the children of the row. Use !important to
            // override any existing styles.
            "& > *": {
                // Make sure that any borders or padding applied to the child don't throw
                // of the widths that we apply
                boxSizing: "border-box !important",
                // Set margins for horizontal spacing and vertical spacing if the row is
                // allowed to wrap (and clear other margins)
                margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
            }
        }, "& > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
            marginRight: "0 !important"
        } : undefined), // index in the dom matches the widths's index in the array. If we've
        // got a single height, apply that to all children.
        Array.isArray(widths) ? widths.reduce(function(result, width, index) {
            result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
                width: width,
                wrap: wrap,
                horizontalSpacing: horizontalSpacing
            });
            return result;
        }, {}) : {
            "& > *": childStyles({
                width: widths,
                wrap: wrap,
                horizontalSpacing: horizontalSpacing
            })
        });
    }, [
        "wrap",
        "spacing",
        "alignmentHorizontal",
        "alignmentVertical",
        "reverse"
    ]);
};
var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);
var childStyles = function childStyles(_ref2) {
    var rawWidth = _ref2.width, wrap = _ref2.wrap, horizontalSpacing = _ref2.horizontalSpacing;
    var width = parseWidth(rawWidth);
    return {
        // Stretch the child to fill remaining space if the width is "fill"
        flex: width.type === "flex" && width.value === "fill" ? "1 !important" : undefined,
        // Ensure that the child isn't smashed by flexbox if it has an explicit
        // width set.
        flexShrink: width.type === "grid" || width.type === "percentage" || width.type === "flex" && width.value === "fit" || width.type === "css" && width.value !== "auto" ? "0 !important" : undefined,
        width: width.type === "grid" || width.type === "percentage" ? // specified percentage of the row's width (e.g. 50%) but subtract the
        // gutter spacing from the width to ensure there's enough room for the
        // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
        // subtract the full gutter width since each element has a full gutter
        // to its right (the extra gutter on the right edge of the row is
        // removed with a negative margin on the parent element). For rows
        // that don't wrap the last element doesn't have a gutter to its
        // right, so things are a bit more complicated. In this case there's
        // one less gutter than there are elements in the row (e.g. 3 elements
        // have 2 gutters between them) so subtracting a full gutter from each
        // element's width would be too much. We have to spread out this saved
        // saved gutter space proportional to the percentage of the row that
        // the element takes up. For example if a row has two elements that
        // each take up 50% of the row with a single 16px gutter between them,
        // then we'd subtract 50% of the 16px gutter from each element giving
        // us a final width of 50% - 8px for each element.
        "calc(".concat(width.value * 100, "% - ").concat(horizontalSpacing - (wrap === "none" ? width.value * horizontalSpacing : 0), "px) !important") : width.type === "css" ? "".concat(width.value).concat(typeof width.value === "number" ? "px" : "", " !important") : undefined
    };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */ var Row = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    // A row with an explicit height cannot wrap
    var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array or scalar
    // for the "widths" property
    var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
    var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
        wrap: wrap
    })); // Apply the row styles to an extra div inside the box so margins that are
    // applied to the box (e.g. if the row is nested in another row) don't
    // conflict with the margins that are applied by `rowStyles`.
    return /*#__PURE__*/ _react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
        className: wrap === "none" ? (0, _cxMemoized["default"])(rowStyles, props.className) : (0, _cxMemoized["default"])(wrapContainerStyles, props.className),
        ref: ref
    }), wrap === "none" ? props.children : /*#__PURE__*/ _react["default"].createElement("div", {
        className: rowStyles
    }, props.children));
});
Row.displayName = "Row";
Row.propTypes = {};
Row.defaultProps = {
    wrap: "none",
    spacing: "medium",
    alignmentVertical: "center",
    alignmentHorizontal: "left"
};
var _default = Row;
exports["default"] = _default;

},{"795db92d9e806d2d":"hVU2P","46561bb046ed6e28":"74DXJ","a4f99ad4fb793706":"6uln9","22d308163af2d61c":"1hOJi","3981994786f19f12":"kbmlY","169f02f03341e807":"dULlg","acaf511cbbc47fdb":"c8tMj","60c4cdc993c1c576":"7BvDg","58231c0e0f94a556":"4L61K","bcb55ca464a031ce":"ixtrV"}],"9uVFW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("47c55a88be6e1396");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _button = _interopRequireDefault(require("a2e46d65d491eeb5"));
var _default = _button["default"];
exports["default"] = _default;

},{"47c55a88be6e1396":"hVU2P","a2e46d65d491eeb5":"kx0qn"}],"kx0qn":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8cb4ac3014e0db42");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("953026ee609b6a0"));
var _react = _interopRequireDefault(require("b89a3e16e7f9c1fe"));
var _propTypes = _interopRequireDefault(require("6e00cdfe312b5893"));
var _emotion = require("e5a798b34ee833e2");
var _button = _interopRequireDefault(require("d7fea1c552f2849b"));
var _theme = require("4f9e06a09d4d45f7");
var _clickable = _interopRequireDefault(require("54e47e5f1a0d313a"));
var _useFocus2 = _interopRequireDefault(require("a3063c72965e3037"));
var _icon = _interopRequireDefault(require("b60e162d7eb3a074"));
var _buttonStyles = require("1ff2156044c34541");
var _text = _interopRequireDefault(require("710519311c5beb37"));
var _token = require("215f2509fbe878ca");
var _isColorDark = _interopRequireDefault(require("7f2e5654aea4b621"));
var _isElementOf = _interopRequireDefault(require("81e9a195c6cb86c9"));
var _filterPropsByPrefix = _interopRequireDefault(require("af8548d9cc44a05"));
var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, type = _ref.type, focus = _ref.focus, disabled = _ref.disabled, minWidth = _ref.minWidth, _ref$backdropColor = _ref.backdropColor, backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor, iconOnly = _ref.iconOnly, circular = _ref.circular;
    var state = disabled ? "disabled" : "default";
    var linkOrIcon = type === "link" || type === "icon";
    var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
    var borderColor = t("borderColor", [
        type,
        state
    ]);
    var borderWidth = borderColor ? t("borderWidth") : 0;
    var borderStyle = borderColor ? "solid" : undefined;
    var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
    return (0, _emotion.css)((0, _text["default"])(t, {
        fontSize: size
    }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
        type: type,
        backdrop: backdrop
    }) : (0, _buttonStyles.defaultStyles)(t, {
        type: type,
        backdrop: backdrop
    }), {
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        outline: "none",
        position: "relative",
        minWidth: minWidth,
        height: t("height", size),
        // Make icon-only buttons square w/ no padding and all other buttons
        // flexible with padding.
        width: iconOnly ? t("height", size) : undefined,
        flexShrink: iconOnly ? 0 : undefined,
        padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
        transition: t.transitionCss("motion", [
            "color",
            "background-color",
            "border-color"
        ]),
        borderRadius: borderRadius,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        whiteSpace: "nowrap",
        // HACK: IE11 will only show a pseudo element on a button if
        // overflow is set to visible, and our focus ring is displayed with a
        // pseudo element.
        overflow: "visible",
        "& > * + *": {
            marginLeft: t("spacingInsetHorizontal", size)
        },
        ":hover": !disabled ? (0, _buttonStyles.hoverStyles)(t, {
            type: type,
            backdrop: backdrop
        }) : undefined,
        ":active": !disabled ? (0, _buttonStyles.activeStyles)(t, {
            type: type,
            backdrop: backdrop
        }) : undefined
    }, !disabled ? (0, _buttonStyles.focusStyles)(t, {
        focus: focus,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        backdropColor: backdropColor,
        linkOrIcon: linkOrIcon
    }) : undefined);
}, [
    "size",
    "type",
    "focus",
    "disabled",
    "backdropColor",
    "minWidth",
    "iconOnly",
    "circular"
]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.
var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
    var arr = _react["default"].Children.toArray(children);
    return arr.length > 1 ? arr.map(function(child, index) {
        return typeof child === "string" ? /*#__PURE__*/ _react["default"].createElement("span", {
            key: index
        }, child) : child;
    }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */ var Button = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_button["default"], "button"); // Does the button contain only an icon (no text)?
    var iconOnly = _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon/link buttons so that they're offset from the
    // edge of the icon/text (which is visible), not the edge of the button
    // element (which is not visible). The magic "24" for the icon variant is the
    // size of a standard icon. By subtracting that from the height of the button
    // and dividing by 2 we get the distance between the invisible edge of the
    // button and the visible edge of the icon.
    var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : props.type === "link" ? -(t("height", props.size) - t("fontSize", props.size)) / 2 : undefined;
    var _useFocus = (0, _useFocus2["default"])(props), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
        ref: ref,
        className: (0, _emotion.cx)(styles(t, {
            type: props.type,
            size: props.size,
            disabled: props.disabled,
            circular: props.circular,
            backdropColor: props.backdropColor,
            minWidth: props.minWidth,
            focus: focus && focusTrigger === "keyboard",
            iconOnly: iconOnly
        }), props.className),
        disabled: props.disabled,
        id: props.id,
        href: props.href,
        rel: props.rel,
        target: props.target,
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        propagateClickEvent: props.propagateClickEvent,
        tabIndex: props.tabIndex,
        download: props.download,
        submit: props.submit,
        "aria-hidden": props["aria-hidden"] || undefined,
        "aria-label": props.label || undefined,
        "mdn-popover-offset": popoverOffset
    }, focusProps), wrapStringSiblingsInSpans(props.children));
});
Button.displayName = "Button";
Button.propTypes = {};
Button.defaultProps = {
    propagateClickEvent: true,
    size: "medium",
    type: "primary"
};
var _default = Button;
exports["default"] = _default;

},{"8cb4ac3014e0db42":"hVU2P","953026ee609b6a0":"5G7gB","b89a3e16e7f9c1fe":"6uln9","6e00cdfe312b5893":"1hOJi","e5a798b34ee833e2":"kbmlY","d7fea1c552f2849b":"4wQlF","4f9e06a09d4d45f7":"f7yMb","54e47e5f1a0d313a":"aYwD3","a3063c72965e3037":"1Rsyx","b60e162d7eb3a074":"fxUjK","1ff2156044c34541":"4TNer","710519311c5beb37":"blvoW","215f2509fbe878ca":"dp1DQ","7f2e5654aea4b621":"bKUxm","81e9a195c6cb86c9":"bxL74","af8548d9cc44a05":"aJ6so"}],"4wQlF":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        buttonMotionDuration: "100ms",
        buttonMotionFunction: "ease",
        buttonBackgroundColorPrimaryDefault: tokens.themeForegroundAccentDefault,
        buttonBackgroundColorPrimaryHover: tokens.themeForegroundAccentHover,
        buttonBackgroundColorPrimaryPressed: tokens.themeForegroundAccentPressed,
        buttonBackgroundColorPrimaryDisabled: tokens.themeForegroundAccentDisabled,
        buttonBackgroundColorSecondaryDefault: tokens.themeBackgroundTertiaryDefault,
        buttonBackgroundColorSecondaryHover: tokens.themeBackgroundTertiaryHover,
        buttonBackgroundColorSecondaryPressed: tokens.themeBackgroundTertiaryPressed,
        buttonBackgroundColorSecondaryDisabled: tokens.themeBackgroundTertiaryDisabled,
        buttonBackgroundColorTertiaryDefault: "rgba(0, 0, 0, 0)",
        buttonBackgroundColorTertiaryHover: tokens.themeForegroundAccentHover,
        buttonBackgroundColorTertiaryPressed: tokens.themeForegroundAccentPressed,
        buttonBackgroundColorLinkDarkBackdropDefault: "rgba(0, 0, 0, 0)",
        buttonBackgroundColorLinkDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
        buttonBackgroundColorLinkDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
        buttonBackgroundColorLinkLightBackdropDefault: "rgba(0, 0, 0, 0)",
        buttonBackgroundColorLinkLightBackdropHover: "rgba(11, 12, 12, 0.1)",
        buttonBackgroundColorLinkLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
        buttonBackgroundColorIconDarkBackdropDefault: "rgba(0, 0, 0, 0)",
        buttonBackgroundColorIconDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
        buttonBackgroundColorIconDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
        buttonBackgroundColorIconLightBackdropDefault: "rgba(0, 0, 0, 0)",
        buttonBackgroundColorIconLightBackdropHover: "rgba(11, 12, 12, 0.1)",
        buttonBackgroundColorIconLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
        buttonForegroundColorPrimaryDefault: tokens.themeForegroundInvertedDefault,
        buttonForegroundColorPrimaryDisabled: tokens.themeBackgroundAccentDisabled,
        buttonForegroundColorSecondaryDefault: tokens.themeForegroundPrimaryDefault,
        buttonForegroundColorSecondaryDisabled: tokens.themeForegroundTertiaryDisabled,
        buttonForegroundColorTertiaryDefault: tokens.themeForegroundAccentDefault,
        buttonForegroundColorTertiaryHover: tokens.themeForegroundInvertedDefault,
        buttonForegroundColorTertiaryFocus: tokens.themeForegroundInvertedDefault,
        buttonForegroundColorTertiaryPressed: tokens.themeForegroundInvertedDefault,
        buttonForegroundColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
        buttonForegroundColorLinkDarkBackdropDefault: tokens.themePalette300,
        buttonForegroundColorLinkDarkBackdropHover: tokens.themePalette200,
        buttonForegroundColorLinkDarkBackdropPressed: tokens.themePalette100,
        buttonForegroundColorLinkDarkBackdropDisabled: tokens.themePaletteMuted500,
        buttonForegroundColorLinkLightBackdropDefault: tokens.themePalette500,
        buttonForegroundColorLinkLightBackdropHover: tokens.themePalette600,
        buttonForegroundColorLinkLightBackdropPressed: tokens.themePalette700,
        buttonForegroundColorLinkLightBackdropDisabled: tokens.themePaletteMuted200,
        buttonForegroundColorIconDarkBackdropDefault: "#FFFFFF",
        buttonForegroundColorIconDarkBackdropDisabled: "#6C7778",
        buttonForegroundColorIconLightBackdropDefault: "#232F3E",
        buttonForegroundColorIconLightBackdropDisabled: "#BBC0C1",
        buttonFontSizeSmall: 14,
        buttonFontSizeMedium: 16,
        buttonFontSizeLarge: 18,
        buttonFontSizeXlarge: 28,
        buttonBorderWidth: 2,
        buttonBorderRadius: 4,
        buttonBorderColorTertiaryDefault: tokens.themeForegroundAccentDefault,
        buttonBorderColorTertiaryHover: tokens.themeForegroundAccentHover,
        buttonBorderColorTertiaryPressed: tokens.themeForegroundAccentPressed,
        buttonBorderColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
        buttonSpacingInsetHorizontalSmall: 10,
        buttonSpacingInsetHorizontalMedium: 16,
        buttonSpacingInsetHorizontalLarge: 16,
        buttonSpacingInsetHorizontalXlarge: 24,
        buttonHeightSmall: 32,
        buttonHeightMedium: 40,
        buttonHeightLarge: 48,
        buttonHeightXlarge: 64,
        buttonFocusOutlineOffset: 4
    };
};

},{}],"aYwD3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("19be80a88a145297");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _clickable = _interopRequireDefault(require("7713380a626ca58e"));
var _default = _clickable["default"];
exports["default"] = _default;

},{"19be80a88a145297":"hVU2P","7713380a626ca58e":"cehMV"}],"cehMV":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("5d7e4ebd85245c04");
var _interopRequireDefault = require("392154708bb058bb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("cf80874cab68415c"));
var _react = _interopRequireWildcard(require("f04b2843dba956ee"));
var _propTypes = _interopRequireDefault(require("3b87728a3279ecb9"));
var _emotion = require("e4a6fa7431265dd7");
var _keycode = _interopRequireDefault(require("753f9edb9025ca7e"));
var _noop = _interopRequireDefault(require("ef3a2973d306fd2c"));
var _buttonReset = _interopRequireDefault(require("e877424bcbfe216c"));
var _linkReset = _interopRequireDefault(require("76183153aee9ac30"));
var _functional = require("bcee259f50393c7f");
var _cxMemoized = _interopRequireDefault(require("5f5f8146f1685874"));
var _filterPropsByPrefix = _interopRequireDefault(require("3fe78f240d706a57"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _functional.memoizeByKeys)(function(_ref) {
    var tag = _ref.tag, disabled = _ref.disabled;
    return (0, _emotion.css)({
        button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
            // HACK: IE offsets the contents of buttons on mouse down (in the active
            // state) to create a faux 3D effect. These styles are applied to every
            // child of  the button in order to counter this effect so that we are
            // the masters of our own button-content-position-destiny.
            "& > *": {
                position: "relative"
            }
        }),
        a: _linkReset["default"]
    }[tag], {
        cursor: disabled ? "not-allowed" : "pointer",
        outline: "none"
    });
}, [
    "tag",
    "disabled"
]);
var getPropsForNativeLink = function getPropsForNativeLink(props) {
    return {
        href: props.disabled ? undefined : props.href,
        target: props.target,
        rel: props.rel,
        "aria-disabled": props.disabled || undefined,
        role: props.role !== "link" ? props.role : undefined,
        tabIndex: props.disabled ? "-1" : props.tabIndex,
        onClick: props.onClick
    };
};
var getPropsForNativeButton = function getPropsForNativeButton(props) {
    return {
        disabled: props.disabled || undefined,
        type: props.submit ? "submit" : "button",
        role: props.role !== "button" ? props.role : undefined,
        tabIndex: props.tabIndex,
        onClick: props.onClick
    };
};
var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
    return {
        href: props.disabled ? undefined : props.href,
        target: props.target,
        rel: props.rel,
        "aria-disabled": props.disabled || undefined,
        tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
        role: props.role,
        onKeyDown: function onKeyDown(event) {
            var key = (0, _keycode["default"])(event);
            var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links
            if (focus && key === "enter") props.onClick(event);
             // Disable scrolling on space-key-down for buttons
            if (focus && key === "space" && props.role === "button") event.preventDefault();
        },
        onKeyUp: props.role === "button" ? function(event) {
            var key = (0, _keycode["default"])(event);
            var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons
            if (focus && key === "space") // NOTE: event.preventDefault() will have already been called at
            // this point to keep the space key from triggering a scroll
            // (see `onKeyDown` above), so instead of passing the original
            // event this will pass a mock event that looks like it hasn't
            // had preventDefault() called.
            props.onClick({
                defaultPrevented: false,
                preventDefault: _noop["default"]
            });
        } : undefined,
        onClick: props.onClick
    };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */ var simulateLinkClick = function simulateLinkClick(linkAttributes) {
    // Create a link element that we can click
    var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
    // React normally does this for us, but the DOM doesn't so we have to do it
    // manually to avoid things like `download="undefined"` in the DOM.
    Object.assign(link, Object.keys(linkAttributes).reduce(function(result, key) {
        if (linkAttributes[key] !== undefined) result[key] = linkAttributes[key];
        return result;
    }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
    // FF)
    document.body.appendChild(link); // Trigger a click on the link
    link.click(); // Remove the link from the dom.
    document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */ var Clickable = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var onClick = props.onClick, href = props.href, target = props.target, submit = props.submit, disabled = props.disabled, rel = props.rel, download = props.download, tabIndex = props.tabIndex, propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
    // DOM
    var nativeRole = href && !submit ? "link" : "button";
    var role = props.role !== undefined ? props.role : nativeRole;
    var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-",
        "mdn-",
        "aria-"
    ]); // What happens when the Clickable is clicked. Pretty key.
    var onClickTag = (0, _react.useCallback)(function(event) {
        // If the default event behavior was already prevented (e.g. by a nested
        // Clickable inside this one) then don't do anything
        if (!event.defaultPrevented) {
            var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
            // custom onClick handler, or do not have any native browser behavior.
            // This keeps any parent Clickable elements higher up in the DOM tree from
            // also handling the event. This doesn't stop propagation though - other
            // elements may want to react to the event even if its default behavior
            // was cancelled.
            if (disabled || onClick || !nativeBehavior) event.preventDefault();
             // If we were explicitly told to stop propagation on the event then
            // do so now
            if (!propagateClickEvent) event.stopPropagation();
             // If we're not disabled then handle the click
            if (!disabled) {
                // If the element has native behavior and we don't have a custom
                // onClick handler, then fall back to the native behavior (and stop
                // propagation to keep anyone else from handling the click).
                if (nativeBehavior && !onClick) event.stopPropagation();
                else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) simulateLinkClick({
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    download: download
                });
                else if (onClick) onClick(href);
                else if (href) simulateLinkClick({
                    href: href,
                    target: target,
                    rel: rel,
                    download: download
                });
            }
        }
    }, [
        onClick,
        href,
        target,
        submit,
        disabled,
        tag,
        rel,
        download,
        propagateClickEvent
    ]); // Generate props that are specific to the tag we're rendering (e.g. a link,
    // a button, and a div will all require different props in order to acheive
    // a particular behavior). Memoize these to reduce the number of large objects
    // created on each render.
    var clickableProps = (0, _react.useMemo)(function() {
        var props = {
            onClick: onClickTag,
            role: role,
            disabled: disabled,
            href: href,
            rel: rel,
            target: target,
            tabIndex: tabIndex,
            submit: submit
        };
        return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
    }, [
        tag,
        onClickTag,
        role,
        disabled,
        href,
        rel,
        target,
        tabIndex,
        submit
    ]); // HACK: Wrap string children in a span so that the IE positioning
    // hack (see the button styles above) can take effect
    var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function(child) {
        return typeof child !== "string";
    }).length === 0;
    return /*#__PURE__*/ _react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        onMouseMove: props.onMouseMove,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        id: props.id,
        download: props.download,
        title: props.title,
        className: (0, _cxMemoized["default"])(styles({
            tag: tag,
            disabled: props.disabled
        }), props.className),
        ref: ref
    }), applyIE11StyleHack ? /*#__PURE__*/ _react["default"].createElement("span", null, props.children) : props.children);
});
Clickable.displayName = "Clickable";
Clickable.propTypes = {};
Clickable.defaultProps = {
    propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

},{"5d7e4ebd85245c04":"jNy6G","392154708bb058bb":"hVU2P","cf80874cab68415c":"74DXJ","f04b2843dba956ee":"6uln9","3b87728a3279ecb9":"1hOJi","e4a6fa7431265dd7":"kbmlY","753f9edb9025ca7e":"2YoiJ","ef3a2973d306fd2c":"4uGIw","e877424bcbfe216c":"q2BAC","76183153aee9ac30":"7lct6","bcee259f50393c7f":"4L61K","5f5f8146f1685874":"ixtrV","3fe78f240d706a57":"aJ6so"}],"q2BAC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var buttonReset = {
    display: "inline-block",
    padding: 0,
    border: 0,
    outline: "none",
    backgroundColor: "transparent",
    textAlign: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    WebkitAppearance: "none",
    WebkitMarginBefore: 0,
    WebkitMarginAfter: 0,
    WebkitMarginStart: 0,
    WebkitMarginEnd: 0,
    "::-moz-focus-inner": {
        border: 0
    }
};
var _default = buttonReset;
exports["default"] = _default;

},{}],"7lct6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var linkReset = {
    display: "inline-block",
    outline: "none",
    textDecoration: "none",
    color: "inherit",
    cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

},{}],"fxUjK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d471203dd3433719");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _icon = _interopRequireDefault(require("ff4731840ba5400f"));
var _default = _icon["default"];
exports["default"] = _default;

},{"d471203dd3433719":"hVU2P","ff4731840ba5400f":"lbKKG"}],"lbKKG":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a582145d602c8634");
var _interopRequireWildcard = require("426f0f68b481c6b6");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("9773fb0455f36a81"));
var _propTypes = _interopRequireDefault(require("f4e0bcc5136ef488"));
var _emotion = require("95aa9d79e48a52f");
var _token = require("39b3becf6992a030");
var _functional = require("82643a3c93fc11d7");
var _cxMemoized = _interopRequireDefault(require("568aade00e2612f9"));
var styles = (0, _functional.memoize)(function(size) {
    return (0, _emotion.css)({
        position: "relative",
        flexShrink: 0,
        display: "inline-block",
        width: size,
        height: size,
        verticalAlign: "middle",
        // Don't show the icon's label
        fontSize: 0,
        // Center the icon image
        "& svg": {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%) translateX(-50%)"
        }
    });
});
var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};
var Icon = /*#__PURE__*/ _react["default"].memo(/*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens), data = _getIconFromTokens.data, width = _getIconFromTokens.width, height = _getIconFromTokens.height;
    var svg = decodeURIComponent(data.replace(/^data:image\/svg\+xml,/, "")) // Add aria-hidden="true" so that screen readers ignore the underlying svg
    // (we label the parent span) and focusable="false" because IE11 defaults
    // to adding SVGs to the tab order
    .replace(/<svg/, '<svg aria-hidden="true" focusable="false"');
    var html = (0, _react.useMemo)(function() {
        return {
            __html: svg
        };
    }, [
        svg
    ]);
    var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
    var simpleChildren = props.children === undefined || typeof props.children === "string";
    return /*#__PURE__*/ _react["default"].createElement("span", {
        role: "img",
        "aria-hidden": !props.children ? true : undefined,
        "aria-label": simpleChildren ? props.children : undefined,
        className: (0, _cxMemoized["default"])(styles(size), props.className),
        tabIndex: props.tabIndex,
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        ref: ref,
        dangerouslySetInnerHTML: simpleChildren ? html : undefined
    }, simpleChildren ? null : /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement("span", {
        dangerouslySetInnerHTML: html
    }), props.children));
}), shouldNotUpdate);
Icon.sizes = {
    small: 16,
    large: 24
};
Icon.displayName = "Icon";
Icon.propTypes = {};
Icon.sizes = {
    small: 16,
    large: 24
};
var _default = Icon;
exports["default"] = _default;

},{"a582145d602c8634":"hVU2P","426f0f68b481c6b6":"jNy6G","9773fb0455f36a81":"6uln9","f4e0bcc5136ef488":"1hOJi","95aa9d79e48a52f":"kbmlY","39b3becf6992a030":"dp1DQ","82643a3c93fc11d7":"4L61K","568aade00e2612f9":"ixtrV"}],"4TNer":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6f621efecf56b8ee");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disabledStyles = exports.defaultStyles = exports.focusStyles = exports.hoverStyles = exports.activeStyles = void 0;
var _focusRing = _interopRequireDefault(require("588a8d5f72bbd2a4"));
var getStyles = function getStyles(t, _ref) {
    var type = _ref.type, backdrop = _ref.backdrop, state = _ref.state;
    return {
        color: t("foregroundColor", [
            type,
            backdrop,
            state
        ]),
        backgroundColor: t("backgroundColor", [
            type,
            backdrop,
            state
        ]),
        borderColor: t("borderColor", [
            type,
            state
        ])
    };
};
var activeStyles = function activeStyles(t, _ref2) {
    var type = _ref2.type, backdrop = _ref2.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "pressed"
    });
};
exports.activeStyles = activeStyles;
var hoverStyles = function hoverStyles(t, _ref3) {
    var type = _ref3.type, backdrop = _ref3.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "hover"
    });
};
exports.hoverStyles = hoverStyles;
var defaultStyles = function defaultStyles(t, _ref4) {
    var type = _ref4.type, backdrop = _ref4.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "default"
    });
};
exports.defaultStyles = defaultStyles;
var disabledStyles = function disabledStyles(t, _ref5) {
    var type = _ref5.type, backdrop = _ref5.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "disabled"
    });
};
exports.disabledStyles = disabledStyles;
var focusStyles = function focusStyles(t, _ref6) {
    var focus = _ref6.focus, borderWidth = _ref6.borderWidth, borderRadius = _ref6.borderRadius, backdropColor = _ref6.backdropColor, linkOrIcon = _ref6.linkOrIcon;
    return (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        gapColor: backdropColor,
        dropShadow: !linkOrIcon,
        offset: t("focusOutlineOffset")
    });
};
exports.focusStyles = focusStyles;

},{"6f621efecf56b8ee":"hVU2P","588a8d5f72bbd2a4":"01EBl"}],"01EBl":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8938a06921bffec");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("b2a6b8931432ceee"));
var _focusRing = _interopRequireDefault(require("863aa1e7103c0930"));
var _elevation = require("582434852d36699e");
var _token = require("705f5110ad69fb47");
/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */ var focusRing = function focusRing(themeTokens, _ref) {
    var _ref2;
    var focus = _ref.focus, error = _ref.error, dropShadow = _ref.dropShadow, gapColor = _ref.gapColor, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius, _ref$hoverSelector = _ref.hoverSelector, hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector;
    var tokens = (0, _focusRing["default"])(themeTokens);
    var state = focus ? "focus" : error ? "error" : undefined;
    var width = (0, _token.getToken)(tokens, "focusRingWidth");
    var color = (0, _token.getToken)(tokens, "focusRingColor", state);
    var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
    // element then use an inset box shadow.
    var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
    var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
    return _ref2 = {
        // The focuseable element needs to be relatively positioned so that we can
        // absolutely position the focus ring
        position: "relative",
        // If the ring entirely overlaps the focused element's border, turn the
        // element's border off to avoid artifacts near the rounded corners
        borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
    }, (0, _defineProperty2["default"])(_ref2, hoverSelector, dropShadowCss && !color ? {
        boxShadow: dropShadowCss
    } : undefined), (0, _defineProperty2["default"])(_ref2, hoverSelector.split(",").map(function(selector) {
        return "".concat(selector.trim(), ":after");
    }).join(", "), dropShadowCss && state === "error" ? {
        boxShadow: dropShadowAndGapShadowCss
    } : undefined), (0, _defineProperty2["default"])(_ref2, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref2, "&:after", color ? {
        content: "''",
        pointerEvents: "none",
        position: "absolute",
        top: -offset - borderWidth,
        right: -offset - borderWidth,
        bottom: -offset - borderWidth,
        left: -offset - borderWidth,
        border: "".concat(width, "px solid ").concat(color),
        borderRadius: typeof borderRadius === "string" ? borderRadius.split(" ").map(function(radius) {
            var r = parseInt(radius);
            return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
        }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0,
        boxShadow: state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss
    } : undefined), _ref2;
};
var _default = focusRing;
exports["default"] = _default;

},{"8938a06921bffec":"hVU2P","b2a6b8931432ceee":"74DXJ","863aa1e7103c0930":"dixtu","582434852d36699e":"dKmTh","705f5110ad69fb47":"dp1DQ"}],"dixtu":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        focusRingWidth: 2,
        focusRingColorFocus: tokens.themeBorderPrimaryFocus,
        focusRingColorError: tokens.themeBorderPrimaryError,
        focusRingDropShadowOffsetX: 0,
        focusRingDropShadowOffsetY: 1,
        focusRingDropShadowBlur: 2,
        focusRingDropShadowSpread: 0,
        focusRingDropShadowColor: "rgba(11, 12, 12, 0.16)"
    };
};

},{}],"dKmTh":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports = {
    elevationBackground: 0,
    elevationMidground: 10,
    elevationForeground: 20,
    elevationMasthead: 30,
    elevationFixture: 40,
    elevationSideMenu: 50,
    elevationModal: 60,
    elevationPopover: 70,
    elevationTooltip: 80
};

},{}],"blvoW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("77a68364d0121bd0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _text = _interopRequireDefault(require("1869315d2672527"));
var text = function text(t) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var tokens = (0, _text["default"])(t.tokens);
    return {
        color: t("foregroundColor", keys.color) || t.tokens.themeForegroundPrimaryDefault,
        fontFamily: t("fontFamily", keys.fontFamily) || tokens.textFontFamilyAmazonEmber,
        fontSize: t("fontSize", keys.fontSize) || tokens.textFontSizeB300,
        fontWeight: t("fontWeight", keys.fontWeight) || tokens.textFontWeightB300,
        lineHeight: t("lineHeight", keys.lineHeight) || tokens.textLineHeightB300
    };
};
var _default = text;
exports["default"] = _default;

},{"77a68364d0121bd0":"hVU2P","1869315d2672527":"9Sdvg"}],"bKUxm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
    var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal
    var r = decimal >> 16 & 0xff; // extract red
    var g = decimal >> 8 & 0xff; // extract green
    var b = decimal >> 0 & 0xff; // extract blue
    return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};
var isColorDark = function isColorDark(hex) {
    return getBrightness(hex) < 128;
};
var _default = isColorDark;
exports["default"] = _default;

},{}],"bxL74":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 * import Radio from "@amzn/meridian/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */ var isSameComponent = function isSameComponent(a, b) {
    if (!a || !b) // Bail if either component wasn't provided
    return false;
    else {
        var aName, bName;
        // Just check if the components reference the same class/function.
        return a === b;
    }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */ var isElementOf = function isElementOf(component) {
    return function(element) {
        if (!component || !element) // Bail if either the component or element wasn't provided
        return false;
        else if (element.type && element.type.WrappedComponent) // If the element's component has a static WrappedComponent property, assume
        // we're working with a HoC and compare the wrapped component instead of the
        // HoC component. The connect HoC from redux uses this pattern, so this
        // check ensures that isElementOf works correctly on redux-connected
        // components.
        return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
        else // If WrappedComonent isn't set do a normal comparison of element.type
        // (the component that element was instantiated from) and component.
        return isSameComponent(element.type, component);
    };
};
var _default = isElementOf;
exports["default"] = _default;

},{}],"biBV3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("78230c7b439fa3cb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _heading = _interopRequireDefault(require("8f1c8f5008e2fc6f"));
var _default = _heading["default"];
exports["default"] = _default;

},{"78230c7b439fa3cb":"hVU2P","8f1c8f5008e2fc6f":"hr5jA"}],"hr5jA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f08020ea04c99b6");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("6ec5da0cf0444026"));
var _propTypes = _interopRequireDefault(require("1f109089491ea19d"));
var _text = _interopRequireDefault(require("507b30762261f2e7"));
function Heading(props) {
    return /*#__PURE__*/ _react["default"].createElement(_text["default"], {
        type: props.type ? props.type : "h".concat(7 - props.level, "00"),
        tag: "h".concat(props.level),
        id: props.id,
        color: props.color,
        alignment: props.alignment,
        transform: props.transform,
        truncate: props.truncate,
        fontFamily: props.fontFamily,
        className: props.className
    }, props.children);
}
Heading.propTypes = {};
var _default = Heading;
exports["default"] = _default;

},{"f08020ea04c99b6":"hVU2P","6ec5da0cf0444026":"6uln9","1f109089491ea19d":"1hOJi","507b30762261f2e7":"93LxJ"}],"93LxJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("455cd867a965d36e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _text = _interopRequireDefault(require("203ac05a0930c40c"));
var _default = _text["default"];
exports["default"] = _default;

},{"455cd867a965d36e":"hVU2P","203ac05a0930c40c":"paiHI"}],"paiHI":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e6c4771b4337fc1c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("fdc8394f95b02ef9"));
var _react = _interopRequireDefault(require("18754cc11c35651a"));
var _propTypes = _interopRequireDefault(require("314102c4f16ef6ee"));
var _text = _interopRequireDefault(require("87dcb24dc6f297eb"));
var _getTextStyles = _interopRequireDefault(require("4caefe7c6a19fb78"));
var _theme = require("bd58a7fdd624d696");
var _cxMemoized = _interopRequireDefault(require("afd67dfbb7a4197d"));
var _filterPropsByPrefix = _interopRequireDefault(require("595f4fcab0f4fe67"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * This component can be used to apply Meridian text styles to the UI. Text
 * styles will cascade to descendent Text, Heading, and Link components as well
 * as native HTML elements, but not to other Meridian components that define
 * their own text styles.
 */ var Text = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var children = props.children;
    var t = (0, _theme.useTheme)(_text["default"], "text");
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
        id: props.id,
        className: (0, _cxMemoized["default"])((0, _getTextStyles["default"])(t, props), props.className),
        title: props.title === undefined && props.truncate && typeof children === "string" ? children : props.title,
        "mdn-text": "",
        ref: ref
    }), children);
});
Text.displayName = "Text";
Text.propTypes = {};
Text.defaultProps = {
    tag: "p"
};
var _default = Text;
exports["default"] = _default;

},{"e6c4771b4337fc1c":"hVU2P","fdc8394f95b02ef9":"74DXJ","18754cc11c35651a":"6uln9","314102c4f16ef6ee":"1hOJi","87dcb24dc6f297eb":"9Sdvg","4caefe7c6a19fb78":"hhLqc","bd58a7fdd624d696":"f7yMb","afd67dfbb7a4197d":"ixtrV","595f4fcab0f4fe67":"aJ6so"}],"hhLqc":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6b98861df7b71c85");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("7b86386b1635bfe7"));
var _token = require("f8d96b80ea4ee397");
var _emotion = require("e9c5d5a6dfc97e91");
var _noTextWrap = _interopRequireDefault(require("99a0b5ffd07f4b72"));
/**
 * Pass in a token helper for text tokens
 * (e.g. getTokenHelper("text")(themedTextTokens)) and any text props.
 */ var getTextStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var _css;
    var fontFamily = _ref.fontFamily, color = _ref.color, type = _ref.type, transform = _ref.transform, alignment = _ref.alignment, tag = _ref.tag, truncate = _ref.truncate, breakWord = _ref.breakWord;
    return (0, _emotion.css)(// with no parent and no props and this is what you'll get.
    {
        fontFamily: t("fontFamilyAmazonEmber"),
        fontWeight: t("fontWeightB300"),
        fontSize: t("fontSizeB300"),
        lineHeight: t("lineHeightB300"),
        color: t("colorPrimary")
    }, // <Text /> component inside another <Text /> component and the descendant
    // component will inherit from the ancestor instead of falling back to the
    // default styles.
    {
        "[mdn-text] &": {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            color: "inherit"
        }
    }, // styles using the component's props. The :not() selector is added to
    // increase the specificity of the styles so they override everything else
    // without resorting to !important.
    {
        "&:not(#mdn-specificity-hack)": {
            fontFamily: fontFamily ? t("fontFamily", fontFamily) : undefined,
            fontWeight: type ? t("fontWeight", type) : undefined,
            fontSize: type ? t("fontSize", type) : undefined,
            lineHeight: type ? t("lineHeight", type) : undefined,
            color: color ? t("color", color) : undefined
        }
    }, (_css = {
        textTransform: transform,
        textAlign: alignment ? alignment : undefined,
        // Clear the default margin on tags like "p"
        margin: 0,
        // If a single word is too wide for the element then allow the browser
        // to break it up at an arbitrary location. A hyphen will not be
        // added. This won't look great, but is better than the word flowing
        // off the edge of the element and potentially getting
        // clipped/obscured.
        overflowWrap: breakWord ? "break-word" : undefined,
        // HACK: Overflow wrap for IE11
        wordWrap: breakWord ? "break-word" : undefined
    }, (0, _defineProperty2["default"])(_css, tag === "ul" ? "&" : "& ul", {
        paddingLeft: t("listSpacingHorizontal"),
        listStyleType: "disc",
        "& ul": {
            paddingLeft: t("listSpacingHorizontal"),
            listStyleType: "circle",
            "& ul": {
                listStyleType: "square"
            }
        }
    }), (0, _defineProperty2["default"])(_css, tag === "ol" ? "&" : "& ol", {
        paddingLeft: t("listSpacingHorizontal"),
        listStyleType: "decimal",
        "& ol": {
            paddingLeft: t("listSpacingHorizontal"),
            listStyleType: "lower-alpha",
            "& ol": {
                listStyleType: "lower-roman"
            }
        }
    }), (0, _defineProperty2["default"])(_css, "".concat(tag === "ul" || tag === "ol" ? "& > * + *, " : "", "& ul > * + *, & ol > * + *"), {
        paddingTop: t("listSpacingVertical")
    }), _css), truncate ? _noTextWrap["default"] : undefined);
}, [
    "fontFamily",
    "color",
    "type",
    "transform",
    "alignment",
    "tag",
    "truncate",
    "breakWord"
]);
var _default = getTextStyles;
exports["default"] = _default;

},{"6b98861df7b71c85":"hVU2P","7b86386b1635bfe7":"74DXJ","f8d96b80ea4ee397":"dp1DQ","e9c5d5a6dfc97e91":"kbmlY","99a0b5ffd07f4b72":"81Axp"}],"81Axp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var noTextWrap = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};
var _default = noTextWrap;
exports["default"] = _default;

},{}],"d3SJz":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconArrowLeftLargeData: "data:image/svg+xml,%3csvg width='14' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M1 5h12'/%3e%3c/g%3e%3c/svg%3e",
    iconArrowLeftLargeWidth: 14,
    iconArrowLeftLargeHeight: 10
};

},{}],"63umq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _intl.createIntlCache));
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>(0, _intl.UnsupportedFormatterError));
parcelHelpers.export(exports, "InvalidConfigError", ()=>(0, _intl.InvalidConfigError));
parcelHelpers.export(exports, "MissingDataError", ()=>(0, _intl.MissingDataError));
parcelHelpers.export(exports, "MessageFormatError", ()=>(0, _intl.MessageFormatError));
parcelHelpers.export(exports, "MissingTranslationError", ()=>(0, _intl.MissingTranslationError));
parcelHelpers.export(exports, "ReactIntlErrorCode", ()=>(0, _intl.IntlErrorCode));
parcelHelpers.export(exports, "ReactIntlError", ()=>(0, _intl.IntlError));
parcelHelpers.export(exports, "FormattedNumberParts", ()=>(0, _createFormattedComponent.FormattedNumberParts));
parcelHelpers.export(exports, "FormattedListParts", ()=>(0, _createFormattedComponent.FormattedListParts));
parcelHelpers.export(exports, "FormattedDateTimeRange", ()=>(0, _dateTimeRangeDefault.default));
parcelHelpers.export(exports, "FormattedMessage", ()=>(0, _messageDefault.default));
parcelHelpers.export(exports, "FormattedPlural", ()=>(0, _pluralDefault.default));
parcelHelpers.export(exports, "FormattedRelativeTime", ()=>(0, _relativeDefault.default));
parcelHelpers.export(exports, "IntlContext", ()=>(0, _injectIntl.Context));
parcelHelpers.export(exports, "IntlProvider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "RawIntlProvider", ()=>(0, _injectIntl.Provider));
parcelHelpers.export(exports, "createIntl", ()=>(0, _provider.createIntl));
parcelHelpers.export(exports, "injectIntl", ()=>(0, _injectIntlDefault.default));
parcelHelpers.export(exports, "useIntl", ()=>(0, _useIntlDefault.default));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
parcelHelpers.export(exports, "FormattedDate", ()=>FormattedDate);
parcelHelpers.export(exports, "FormattedTime", ()=>FormattedTime);
parcelHelpers.export(exports, "FormattedNumber", ()=>FormattedNumber);
parcelHelpers.export(exports, "FormattedList", ()=>FormattedList);
parcelHelpers.export(exports, "FormattedDisplayName", ()=>FormattedDisplayName);
parcelHelpers.export(exports, "FormattedDateParts", ()=>FormattedDateParts);
parcelHelpers.export(exports, "FormattedTimeParts", ()=>FormattedTimeParts);
var _createFormattedComponent = require("./src/components/createFormattedComponent");
var _injectIntl = require("./src/components/injectIntl");
var _injectIntlDefault = parcelHelpers.interopDefault(_injectIntl);
var _useIntl = require("./src/components/useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var _provider = require("./src/components/provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _relative = require("./src/components/relative");
var _relativeDefault = parcelHelpers.interopDefault(_relative);
var _plural = require("./src/components/plural");
var _pluralDefault = parcelHelpers.interopDefault(_plural);
var _message = require("./src/components/message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _dateTimeRange = require("./src/components/dateTimeRange");
var _dateTimeRangeDefault = parcelHelpers.interopDefault(_dateTimeRange);
var _intl = require("@formatjs/intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
var FormattedDate = (0, _createFormattedComponent.createFormattedComponent)("formatDate");
var FormattedTime = (0, _createFormattedComponent.createFormattedComponent)("formatTime");
var FormattedNumber = (0, _createFormattedComponent.createFormattedComponent)("formatNumber");
var FormattedList = (0, _createFormattedComponent.createFormattedComponent)("formatList");
var FormattedDisplayName = (0, _createFormattedComponent.createFormattedComponent)("formatDisplayName");
var FormattedDateParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)("formatDate");
var FormattedTimeParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)("formatTime");

},{"./src/components/createFormattedComponent":"4amvr","./src/components/injectIntl":false,"./src/components/useIntl":"7uXjv","./src/components/provider":"9bIqF","./src/components/relative":false,"./src/components/plural":false,"./src/components/message":false,"./src/components/dateTimeRange":false,"@formatjs/intl":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4amvr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormattedNumberParts", ()=>FormattedNumberParts);
parcelHelpers.export(exports, "FormattedListParts", ()=>FormattedListParts);
parcelHelpers.export(exports, "createFormattedDateTimePartsComponent", ()=>createFormattedDateTimePartsComponent);
parcelHelpers.export(exports, "createFormattedComponent", ()=>createFormattedComponent);
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
var FormattedListParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || _react.Fragment;
        return _react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

},{"tslib":"l9bn4","react":"6uln9","./useIntl":"7uXjv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l9bn4":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7uXjv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIntl);
var _react = require("react");
var _injectIntl = require("./injectIntl");
var _utils = require("../utils");
function useIntl() {
    var intl = _react.useContext((0, _injectIntl.Context));
    (0, _utils.invariantIntlContext)(intl);
    return intl;
}

},{"react":"6uln9","./injectIntl":"iqVDm","../utils":"jMEMh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqVDm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "default", ()=>injectIntl);
var _tslib = require("tslib");
var _react = require("react");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _utils = require("../utils");
function getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var IntlContext = _react.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return _react.createElement(IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, _utils.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return _react.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, _hoistNonReactStaticsDefault.default)(_react.forwardRef(function(props, ref) {
        return _react.createElement(WithIntl, (0, _tslib.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, _hoistNonReactStaticsDefault.default)(WithIntl, WrappedComponent);
}

},{"tslib":"l9bn4","react":"6uln9","hoist-non-react-statics":"jqHr2","../utils":"jMEMh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqHr2":[function(require,module,exports) {
"use strict";
var reactIs = require("66c18f2d150d1ee1");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"66c18f2d150d1ee1":"h3r8t"}],"h3r8t":[function(require,module,exports) {
"use strict";
module.exports = require("b911290613a11f57");

},{"b911290613a11f57":"jNhsd"}],"jNhsd":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"jMEMh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariantIntlContext", ()=>invariantIntlContext);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ parcelHelpers.export(exports, "assignUniqueKeysToParts", ()=>assignUniqueKeysToParts);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
var _tslib = require("tslib");
var _react = require("react");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intl = require("@formatjs/intl");
function invariantIntlContext(intl) {
    (0, _ecma402Abstract.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _intl.DEFAULT_INTL_CONFIG)), {
    textComponent: _react.Fragment
});
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(_react.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

},{"tslib":"l9bn4","react":"6uln9","@formatjs/ecma402-abstract":"eTAPG","@formatjs/intl":"4L5SY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eTAPG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_formatToParts", ()=>(0, _formatToPartsDefault.default));
parcelHelpers.export(exports, "getInternalSlot", ()=>(0, _utils.getInternalSlot));
parcelHelpers.export(exports, "getMultiInternalSlots", ()=>(0, _utils.getMultiInternalSlots));
parcelHelpers.export(exports, "isLiteralPart", ()=>(0, _utils.isLiteralPart));
parcelHelpers.export(exports, "setInternalSlot", ()=>(0, _utils.setInternalSlot));
parcelHelpers.export(exports, "setMultiInternalSlots", ()=>(0, _utils.setMultiInternalSlots));
parcelHelpers.export(exports, "getMagnitude", ()=>(0, _utils.getMagnitude));
parcelHelpers.export(exports, "defineProperty", ()=>(0, _utils.defineProperty));
parcelHelpers.export(exports, "isMissingLocaleDataError", ()=>(0, _data.isMissingLocaleDataError));
parcelHelpers.export(exports, "invariant", ()=>(0, _utils.invariant));
var _canonicalizeLocaleList = require("./CanonicalizeLocaleList");
parcelHelpers.exportAll(_canonicalizeLocaleList, exports);
var _canonicalizeTimeZoneName = require("./CanonicalizeTimeZoneName");
parcelHelpers.exportAll(_canonicalizeTimeZoneName, exports);
var _coerceOptionsToObject = require("./CoerceOptionsToObject");
parcelHelpers.exportAll(_coerceOptionsToObject, exports);
var _getNumberOption = require("./GetNumberOption");
parcelHelpers.exportAll(_getNumberOption, exports);
var _getOption = require("./GetOption");
parcelHelpers.exportAll(_getOption, exports);
var _getOptionsObject = require("./GetOptionsObject");
parcelHelpers.exportAll(_getOptionsObject, exports);
var _isSanctionedSimpleUnitIdentifier = require("./IsSanctionedSimpleUnitIdentifier");
parcelHelpers.exportAll(_isSanctionedSimpleUnitIdentifier, exports);
var _isValidTimeZoneName = require("./IsValidTimeZoneName");
parcelHelpers.exportAll(_isValidTimeZoneName, exports);
var _isWellFormedCurrencyCode = require("./IsWellFormedCurrencyCode");
parcelHelpers.exportAll(_isWellFormedCurrencyCode, exports);
var _isWellFormedUnitIdentifier = require("./IsWellFormedUnitIdentifier");
parcelHelpers.exportAll(_isWellFormedUnitIdentifier, exports);
var _computeExponent = require("./NumberFormat/ComputeExponent");
parcelHelpers.exportAll(_computeExponent, exports);
var _computeExponentForMagnitude = require("./NumberFormat/ComputeExponentForMagnitude");
parcelHelpers.exportAll(_computeExponentForMagnitude, exports);
var _currencyDigits = require("./NumberFormat/CurrencyDigits");
parcelHelpers.exportAll(_currencyDigits, exports);
var _formatNumericToParts = require("./NumberFormat/FormatNumericToParts");
parcelHelpers.exportAll(_formatNumericToParts, exports);
var _formatNumericToString = require("./NumberFormat/FormatNumericToString");
parcelHelpers.exportAll(_formatNumericToString, exports);
var _initializeNumberFormat = require("./NumberFormat/InitializeNumberFormat");
parcelHelpers.exportAll(_initializeNumberFormat, exports);
var _partitionNumberPattern = require("./NumberFormat/PartitionNumberPattern");
parcelHelpers.exportAll(_partitionNumberPattern, exports);
var _setNumberFormatDigitOptions = require("./NumberFormat/SetNumberFormatDigitOptions");
parcelHelpers.exportAll(_setNumberFormatDigitOptions, exports);
var _setNumberFormatUnitOptions = require("./NumberFormat/SetNumberFormatUnitOptions");
parcelHelpers.exportAll(_setNumberFormatUnitOptions, exports);
var _toRawFixed = require("./NumberFormat/ToRawFixed");
parcelHelpers.exportAll(_toRawFixed, exports);
var _toRawPrecision = require("./NumberFormat/ToRawPrecision");
parcelHelpers.exportAll(_toRawPrecision, exports);
var _formatToParts = require("./NumberFormat/format_to_parts");
var _formatToPartsDefault = parcelHelpers.interopDefault(_formatToParts);
var _partitionPattern = require("./PartitionPattern");
parcelHelpers.exportAll(_partitionPattern, exports);
var _supportedLocales = require("./SupportedLocales");
parcelHelpers.exportAll(_supportedLocales, exports);
var _utils = require("./utils");
var _data = require("./data");
var _relativeTime = require("./types/relative-time");
parcelHelpers.exportAll(_relativeTime, exports);
var _dateTime = require("./types/date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _list = require("./types/list");
parcelHelpers.exportAll(_list, exports);
var _pluralRules = require("./types/plural-rules");
parcelHelpers.exportAll(_pluralRules, exports);
var _number = require("./types/number");
parcelHelpers.exportAll(_number, exports);
var _displaynames = require("./types/displaynames");
parcelHelpers.exportAll(_displaynames, exports);
var _262 = require("./262");
parcelHelpers.exportAll(_262, exports);

},{"./CanonicalizeLocaleList":false,"./CanonicalizeTimeZoneName":false,"./CoerceOptionsToObject":false,"./GetNumberOption":false,"./GetOption":false,"./GetOptionsObject":false,"./IsSanctionedSimpleUnitIdentifier":false,"./IsValidTimeZoneName":false,"./IsWellFormedCurrencyCode":false,"./IsWellFormedUnitIdentifier":false,"./NumberFormat/ComputeExponent":false,"./NumberFormat/ComputeExponentForMagnitude":false,"./NumberFormat/CurrencyDigits":false,"./NumberFormat/FormatNumericToParts":false,"./NumberFormat/FormatNumericToString":false,"./NumberFormat/InitializeNumberFormat":false,"./NumberFormat/PartitionNumberPattern":false,"./NumberFormat/SetNumberFormatDigitOptions":false,"./NumberFormat/SetNumberFormatUnitOptions":false,"./NumberFormat/ToRawFixed":false,"./NumberFormat/ToRawPrecision":false,"./NumberFormat/format_to_parts":false,"./PartitionPattern":false,"./SupportedLocales":false,"./utils":"kKEib","./data":false,"./types/relative-time":false,"./types/date-time":false,"./types/list":false,"./types/plural-rules":false,"./types/number":false,"./types/displaynames":false,"./262":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kKEib":[function(require,module,exports) {
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMagnitude", ()=>getMagnitude);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "setInternalSlot", ()=>setInternalSlot);
parcelHelpers.export(exports, "setMultiInternalSlots", ()=>setMultiInternalSlots);
parcelHelpers.export(exports, "getInternalSlot", ()=>getInternalSlot);
parcelHelpers.export(exports, "getMultiInternalSlots", ()=>getMultiInternalSlots);
parcelHelpers.export(exports, "isLiteralPart", ()=>isLiteralPart);
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ parcelHelpers.export(exports, "defineProperty", ()=>defineProperty);
parcelHelpers.export(exports, "UNICODE_EXTENSION_SEQUENCE_REGEX", ()=>UNICODE_EXTENSION_SEQUENCE_REGEX);
parcelHelpers.export(exports, "invariant", ()=>invariant);
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4L5SY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _utils.createIntlCache));
parcelHelpers.export(exports, "filterProps", ()=>(0, _utils.filterProps));
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>(0, _utils.DEFAULT_INTL_CONFIG));
parcelHelpers.export(exports, "createFormatters", ()=>(0, _utils.createFormatters));
parcelHelpers.export(exports, "getNamedFormat", ()=>(0, _utils.getNamedFormat));
parcelHelpers.export(exports, "formatMessage", ()=>(0, _message.formatMessage));
parcelHelpers.export(exports, "formatDate", ()=>(0, _dateTime.formatDate));
parcelHelpers.export(exports, "formatDateToParts", ()=>(0, _dateTime.formatDateToParts));
parcelHelpers.export(exports, "formatTime", ()=>(0, _dateTime.formatTime));
parcelHelpers.export(exports, "formatTimeToParts", ()=>(0, _dateTime.formatTimeToParts));
parcelHelpers.export(exports, "formatDisplayName", ()=>(0, _displayName.formatDisplayName));
parcelHelpers.export(exports, "formatList", ()=>(0, _list.formatList));
parcelHelpers.export(exports, "formatPlural", ()=>(0, _plural.formatPlural));
parcelHelpers.export(exports, "formatRelativeTime", ()=>(0, _relativeTime.formatRelativeTime));
parcelHelpers.export(exports, "formatNumber", ()=>(0, _number.formatNumber));
parcelHelpers.export(exports, "formatNumberToParts", ()=>(0, _number.formatNumberToParts));
parcelHelpers.export(exports, "createIntl", ()=>(0, _createIntl.createIntl));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
var _types = require("./src/types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./src/utils");
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _message = require("./src/message");
var _dateTime = require("./src/dateTime");
var _displayName = require("./src/displayName");
var _list = require("./src/list");
var _plural = require("./src/plural");
var _relativeTime = require("./src/relativeTime");
var _number = require("./src/number");
var _createIntl = require("./src/create-intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}

},{"./src/types":false,"./src/utils":"4mZfW","./src/error":false,"./src/message":"jbhax","./src/dateTime":false,"./src/displayName":false,"./src/list":false,"./src/plural":false,"./src/relativeTime":false,"./src/number":false,"./src/create-intl":"9etnz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4mZfW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
parcelHelpers.export(exports, "createIntlCache", ()=>createIntlCache);
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ parcelHelpers.export(exports, "createFormatters", ()=>createFormatters);
parcelHelpers.export(exports, "getNamedFormat", ()=>getNamedFormat);
var _tslib = require("tslib");
var _intlMessageformat = require("intl-messageformat");
var _fastMemoize = require("@formatjs/fast-memoize");
var _fastMemoizeDefault = parcelHelpers.interopDefault(_fastMemoize);
var _error = require("./error");
function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var defaultErrorHandler = function(error) {};
var defaultWarnHandler = function(warning) {};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createFormatters(cache) {
    if (cache === void 0) cache = createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, _fastMemoizeDefault.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getNumberFormat = (0, _fastMemoizeDefault.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getPluralRules = (0, _fastMemoizeDefault.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, _fastMemoizeDefault.default)(function(message, locales, overrideFormats, opts) {
            return new (0, _intlMessageformat.IntlMessageFormat)(message, locales, overrideFormats, (0, _tslib.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getRelativeTimeFormat: (0, _fastMemoizeDefault.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, _fastMemoizeDefault.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDisplayNames: (0, _fastMemoizeDefault.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, _error.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

},{"tslib":"5uhn9","intl-messageformat":"9mzoV","@formatjs/fast-memoize":"gqN5i","./error":"2F7nd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5uhn9":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9mzoV":[function(require,module,exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("./src/core");
var _formatters = require("./src/formatters");
parcelHelpers.exportAll(_formatters, exports);
parcelHelpers.exportAll(_core, exports);
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
exports.default = (0, _core.IntlMessageFormat);

},{"./src/core":"j0Ibx","./src/formatters":"j4Zcd","./src/error":"2jt9a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j0Ibx":[function(require,module,exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", ()=>IntlMessageFormat);
var _tslib = require("tslib");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _fastMemoize = require("@formatjs/fast-memoize");
var _fastMemoizeDefault = parcelHelpers.interopDefault(_fastMemoize);
var _formatters = require("./formatters");
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, _tslib.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, _fastMemoizeDefault.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDateTimeFormat: (0, _fastMemoizeDefault.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: (0, _fastMemoizeDefault.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
var IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, _formatters.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, _formatters.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, _icuMessageformatParser.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

},{"tslib":"1FEjw","@formatjs/icu-messageformat-parser":"gxgj7","@formatjs/fast-memoize":"gqN5i","./formatters":"j4Zcd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1FEjw":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxgj7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
var _tslib = require("tslib");
var _error = require("./error");
var _parser = require("./parser");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
function pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, _types.isSelectElement)(el) || (0, _types.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            pruneLocation(el.options[k].value);
        }
        else if ((0, _types.isNumberElement)(el) && (0, _types.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, _types.isDateElement)(el) || (0, _types.isTimeElement)(el)) && (0, _types.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, _types.isTagElement)(el)) pruneLocation(el.children);
    });
}
function parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, _tslib.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, _parser.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, _error.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) pruneLocation(result.val);
    return result.val;
}

},{"tslib":"8rDPg","./error":"dtZot","./parser":"9DQqj","./types":"1xdJq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8rDPg":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dtZot":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorKind", ()=>ErrorKind);
var ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9DQqj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _tslib = require("tslib");
var _error = require("./error");
var _types = require("./types");
var _regexGenerated = require("./regex.generated");
var _icuSkeletonParser = require("@formatjs/icu-skeleton-parser");
var _dateTimePatternGenerator = require("./date-time-pattern-generator");
var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*$"));
function createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec("a")) === null || _a === void 0 ? void 0 : _a[0]) === "a";
} catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var fromEntries = // native
hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var codePointAt = hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var trimStart = hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace(SPACE_SEPARATOR_START_REGEX, "");
};
var trimEnd = hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace(SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = codePointAt(s, index);
        if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, match);
};
var Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, _types.TYPE).pound,
                    location: createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !_isAlpha(this.char())) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, _types.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, _error.ErrorKind).UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && _isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, _error.ErrorKind).EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, _types.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = trimEnd(result.val);
                    if (style.length === 0) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, _types.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, _error.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, _dateTimePatternGenerator.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, _types.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, _types.TYPE).date : (0, _types.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, _types.TYPE).number : argType === "date" ? (0, _types.TYPE).date : (0, _types.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, _tslib.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, _types.TYPE).select,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, _types.TYPE).plural,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, _error.ErrorKind).INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, _error.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, _icuSkeletonParser.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, _error.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, _types.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, _error.ErrorKind).MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && _isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function _isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function _isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

},{"tslib":"8rDPg","./error":"dtZot","./types":"1xdJq","./regex.generated":"18Den","@formatjs/icu-skeleton-parser":"6ZsCQ","./date-time-pattern-generator":"j8vhG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xdJq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", ()=>TYPE);
parcelHelpers.export(exports, "SKELETON_TYPE", ()=>SKELETON_TYPE);
/**
 * Type Guards
 */ parcelHelpers.export(exports, "isLiteralElement", ()=>isLiteralElement);
parcelHelpers.export(exports, "isArgumentElement", ()=>isArgumentElement);
parcelHelpers.export(exports, "isNumberElement", ()=>isNumberElement);
parcelHelpers.export(exports, "isDateElement", ()=>isDateElement);
parcelHelpers.export(exports, "isTimeElement", ()=>isTimeElement);
parcelHelpers.export(exports, "isSelectElement", ()=>isSelectElement);
parcelHelpers.export(exports, "isPluralElement", ()=>isPluralElement);
parcelHelpers.export(exports, "isPoundElement", ()=>isPoundElement);
parcelHelpers.export(exports, "isTagElement", ()=>isTagElement);
parcelHelpers.export(exports, "isNumberSkeleton", ()=>isNumberSkeleton);
parcelHelpers.export(exports, "isDateTimeSkeleton", ()=>isDateTimeSkeleton);
parcelHelpers.export(exports, "createLiteralElement", ()=>createLiteralElement);
parcelHelpers.export(exports, "createNumberElement", ()=>createNumberElement);
var TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"18Den":[function(require,module,exports) {
// @generated from regex-gen.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPACE_SEPARATOR_REGEX", ()=>SPACE_SEPARATOR_REGEX);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZsCQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dateTime = require("./date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _number = require("./number");
parcelHelpers.exportAll(_number, exports);

},{"./date-time":"1EGTf","./number":"5BclG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EGTf":[function(require,module,exports) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ parcelHelpers.export(exports, "parseDateTimeSkeleton", ()=>parseDateTimeSkeleton);
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5BclG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNumberSkeletonFromString", ()=>parseNumberSkeletonFromString);
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ parcelHelpers.export(exports, "parseNumberSkeleton", ()=>parseNumberSkeleton);
var _tslib = require("tslib");
var _regexGenerated = require("./regex.generated");
function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, _regexGenerated.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace(SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace(INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace(FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

},{"tslib":"1cAlr","./regex.generated":"cFy5r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cAlr":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFy5r":[function(require,module,exports) {
// @generated from regex-gen.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j8vhG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ parcelHelpers.export(exports, "getBestPattern", ()=>getBestPattern);
var _timeDataGenerated = require("./time-data.generated");
function getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, _timeDataGenerated.timeData)[regionTag || ""] || (0, _timeDataGenerated.timeData)[languageTag || ""] || (0, _timeDataGenerated.timeData)["".concat(languageTag, "-001")] || (0, _timeDataGenerated.timeData)["001"];
    return hourCycles[0];
}

},{"./time-data.generated":"lQO6V","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lQO6V":[function(require,module,exports) {
// @generated from time-data-gen.ts
// prettier-ignore  
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeData", ()=>timeData);
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqN5i":[function(require,module,exports) {
//
// Main
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
parcelHelpers.export(exports, "strategies", ()=>strategies);
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    }
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j4Zcd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PART_TYPE", ()=>PART_TYPE);
parcelHelpers.export(exports, "isFormatXMLElementFn", ()=>isFormatXMLElementFn);
// TODO(skeleton): add skeleton support
parcelHelpers.export(exports, "formatToParts", ()=>formatToParts);
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _error = require("./error");
var PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === "function";
}
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, _icuMessageformatParser.isLiteralElement)(els[0])) return [
        {
            type: PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, _icuMessageformatParser.isLiteralElement)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, _icuMessageformatParser.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, _error.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, _icuMessageformatParser.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? PART_TYPE.literal : PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, _icuMessageformatParser.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, _icuMessageformatParser.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) throw new (0, _error.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? PART_TYPE.literal : PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, _icuMessageformatParser.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, _icuMessageformatParser.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, _error.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, _error.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

},{"@formatjs/icu-messageformat-parser":"gxgj7","./error":"2jt9a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jt9a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "FormatError", ()=>FormatError);
parcelHelpers.export(exports, "InvalidValueError", ()=>InvalidValueError);
parcelHelpers.export(exports, "InvalidValueTypeError", ()=>InvalidValueTypeError);
parcelHelpers.export(exports, "MissingValueError", ()=>MissingValueError);
var _tslib = require("tslib");
var ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var InvalidValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError);
var InvalidValueTypeError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError);
var MissingValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError);

},{"tslib":"1FEjw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2F7nd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlErrorCode", ()=>IntlErrorCode);
parcelHelpers.export(exports, "IntlError", ()=>IntlError);
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>UnsupportedFormatterError);
parcelHelpers.export(exports, "InvalidConfigError", ()=>InvalidConfigError);
parcelHelpers.export(exports, "MissingDataError", ()=>MissingDataError);
parcelHelpers.export(exports, "IntlFormatError", ()=>IntlFormatError);
parcelHelpers.export(exports, "MessageFormatError", ()=>MessageFormatError);
parcelHelpers.export(exports, "MissingTranslationError", ()=>MissingTranslationError);
var _tslib = require("tslib");
var IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var UnsupportedFormatterError = /** @class */ function(_super) {
    (0, _tslib.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError);
var InvalidConfigError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError);
var MissingDataError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError);
var IntlFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError);
var MessageFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError);
var MissingTranslationError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError);

},{"tslib":"5uhn9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbhax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatMessage", ()=>formatMessage);
var _tslib = require("tslib");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, _tslib.__assign)((0, _tslib.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, _intlMessageformat.IntlMessageFormat).formats;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, mfFormats), f1), {
        date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, _ecma402Abstract.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, _icuMessageformatParser.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultRichTextElements), values || {});
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, _error.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, _error.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, _tslib.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

},{"tslib":"5uhn9","@formatjs/ecma402-abstract":"eTAPG","intl-messageformat":"9mzoV","./error":"2F7nd","@formatjs/icu-messageformat-parser":"gxgj7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"elwuA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "formatDateTimeRange", ()=>formatDateTimeRange);
parcelHelpers.export(exports, "formatDateToParts", ()=>formatDateToParts);
parcelHelpers.export(exports, "formatTimeToParts", ()=>formatTimeToParts);
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, _tslib.__assign)((0, _tslib.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, _utils.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

},{"tslib":"5uhn9","./utils":"4mZfW","./error":"2F7nd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bs65G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDisplayName", ()=>formatDisplayName);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, _intlMessageformat.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

},{"./utils":"4mZfW","intl-messageformat":"9mzoV","./error":"2F7nd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2XLZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatList", ()=>formatList);
parcelHelpers.export(exports, "formatListToParts", ()=>formatListToParts);
var _tslib = require("tslib");
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, _intlMessageformat.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, _tslib.__assign)((0, _tslib.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

},{"tslib":"5uhn9","./utils":"4mZfW","intl-messageformat":"9mzoV","./error":"2F7nd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKS7o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPlural", ()=>formatPlural);
var _utils = require("./utils");
var _error = require("./error");
var _intlMessageformat = require("intl-messageformat");
var PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, _intlMessageformat.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

},{"./utils":"4mZfW","./error":"2F7nd","intl-messageformat":"9mzoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fevQk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelativeTime", ()=>formatRelativeTime);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, _utils.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, _intlMessageformat.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    try {
        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

},{"./utils":"4mZfW","intl-messageformat":"9mzoV","./error":"2F7nd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j2ztr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatNumber", ()=>formatNumber);
parcelHelpers.export(exports, "formatNumberToParts", ()=>formatNumberToParts);
var _utils = require("./utils");
var _error = require("./error");
var NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, _utils.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

},{"./utils":"4mZfW","./error":"2F7nd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9etnz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var _number = require("./number");
var _relativeTime = require("./relativeTime");
var _dateTime = require("./dateTime");
var _plural = require("./plural");
var _message = require("./message");
var _list = require("./list");
var _displayName = require("./displayName");
function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function createIntl(config, cache) {
    var formatters = (0, _utils.createFormatters)(cache);
    var resolvedConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, _error.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    verifyConfigMessages(resolvedConfig);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, _number.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, _number.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, _relativeTime.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, _dateTime.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, _dateTime.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, _dateTime.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, _dateTime.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, _dateTime.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, _plural.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, _list.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, _list.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, _displayName.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

},{"tslib":"5uhn9","./utils":"4mZfW","./error":"2F7nd","./number":"j2ztr","./relativeTime":"fevQk","./dateTime":"elwuA","./plural":"aKS7o","./message":"jbhax","./list":"h2XLZ","./displayName":"bs65G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9bIqF":[function(require,module,exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _react = require("react");
var _injectIntl = require("./injectIntl");
var _utils = require("../utils");
var _intl = require("@formatjs/intl");
var _intlMessageformat = require("intl-messageformat");
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, _intlMessageformat.isFormatXMLElementFn)(v) ? (0, _utils.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, _intl.formatMessage).apply(void 0, (0, _tslib.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return _react.Children.toArray(chunks);
    return chunks;
};
var createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, _tslib.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, _intl.createIntl)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, coreIntl), {
        formatMessage: formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var IntlProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, _intl.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0, _utils.shallowEqual)(prevConfig, config)) return {
            intl: createIntl(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, _utils.invariantIntlContext)(this.state.intl);
        return _react.createElement((0, _injectIntl.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, _utils.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}(_react.PureComponent);
exports.default = IntlProvider;

},{"tslib":"l9bn4","react":"6uln9","./injectIntl":"iqVDm","../utils":"jMEMh","@formatjs/intl":"4L5SY","intl-messageformat":"9mzoV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ZcAm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _heading = require("@amzn/meridian/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _useInlineHelpContentActions = require("../hooks/useInlineHelpContentActions");
var _useInlineHelpContentActionsDefault = parcelHelpers.interopDefault(_useInlineHelpContentActions);
var _useInlineHelpContent = require("../hooks/useInlineHelpContent");
var _useInlineHelpContentDefault = parcelHelpers.interopDefault(_useInlineHelpContent);
var _useDownloadTermManualActions = require("../hooks/useDownloadTermManualActions");
var _useDownloadTermManualActionsDefault = parcelHelpers.interopDefault(_useDownloadTermManualActions);
var _loadingComponent = require("../components/atoms/LoadingComponent");
var _loadingComponentDefault = parcelHelpers.interopDefault(_loadingComponent);
var _contentRenderer = require("../components/molecules/ContentRenderer");
var _contentRendererDefault = parcelHelpers.interopDefault(_contentRenderer);
var _common = require("../constants/common");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var SheetContent = function(param) {
    var pageId = param.pageId;
    var downloadTermManual = (0, _useDownloadTermManualActionsDefault.default)().downloadTermManual;
    var isLoading = (0, _useInlineHelpContentActionsDefault.default)().isLoading;
    var response = (0, _useInlineHelpContentDefault.default)().response;
    if (isLoading) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingComponentDefault.default), {
        isLoading: isLoading
    });
    if (!response) return null;
    var parsedResponse = JSON.parse(response);
    var propertyNames = Object.keys(parsedResponse);
    var renderSheetContent = function(keyNames) {
        var sheetContent = [];
        var keyProperties = keyNames;
        if (keyNames.includes((0, _common.HEADER))) {
            var _parsedResponse;
            sheetContent.push(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
                level: 1
            }, (_parsedResponse = parsedResponse) === null || _parsedResponse === void 0 ? void 0 : _parsedResponse.header));
        }
        // Swapping to maintain overview and keyTerm order
        if (keyNames.includes((0, _common.OVERVIEW)) && keyNames.includes((0, _common.KEY_HEADING))) {
            var overviewIndex = keyNames.indexOf((0, _common.OVERVIEW));
            keyProperties[keyNames.indexOf((0, _common.KEY_HEADING))] = (0, _common.OVERVIEW);
            keyProperties[overviewIndex] = (0, _common.KEY_HEADING);
        }
        sheetContent = _to_consumable_array(sheetContent).concat(_to_consumable_array(keyProperties.filter(function(keyName) {
            return keyName.toLowerCase() !== (0, _common.HEADER) && keyName.toLowerCase() !== (0, _common.FOOTER);
        }).map(function(propertyName) {
            var propertyValues = JSON.parse(parsedResponse[propertyName]);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentRendererDefault.default), {
                title: propertyValues.title,
                contentType: propertyValues.contentType,
                content: propertyValues.content,
                onDownloadBtnClick: function(termKey) {
                    return downloadTermManual(termKey);
                }
            });
        })));
        if (keyNames.includes((0, _common.FOOTER))) {
            var propertyValues = JSON.parse(parsedResponse.footer);
            sheetContent.push(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentRendererDefault.default), {
                title: propertyValues.title,
                contentType: propertyValues.contentType,
                content: propertyValues.content,
                onDownloadBtnClick: function(termKey) {
                    return downloadTermManual(termKey);
                }
            }));
        }
        return sheetContent;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), null, renderSheetContent(propertyNames.sort()));
};
exports.default = SheetContent;

},{"react":"6uln9","@amzn/meridian/heading":"biBV3","@amzn/meridian/column":"aw8aI","../hooks/useInlineHelpContentActions":"7KJU6","../hooks/useInlineHelpContent":"83mKr","../hooks/useDownloadTermManualActions":"gBq4R","../components/atoms/LoadingComponent":"99Dzh","../components/molecules/ContentRenderer":"eL04v","../constants/common":"ijIZO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7KJU6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _inlineHelpStore = require("../store/inlineHelpStore");
var _useStoreLoader = require("./useStoreLoader");
var _useStoreLoaderDefault = parcelHelpers.interopDefault(_useStoreLoader);
var _inlineHelpContentStore = require("../store/inlineHelpContentStore");
function useInlineHelpContentActions() {
    var pageId = (0, _inlineHelpStore.getInlineHelpStoreValue)().pageId;
    var isLoading = (0, _useStoreLoaderDefault.default)((0, _inlineHelpContentStore.inlineHelpContentAction$), (0, _inlineHelpContentStore.inlineHelpContentStore$)).isLoading;
    (0, _react.useEffect)(function() {
        (0, _inlineHelpContentStore.inlineHelpContentAction$).next({
            pageId: pageId
        });
    }, [
        pageId
    ]);
    return {
        isLoading: isLoading
    };
}
exports.default = useInlineHelpContentActions;

},{"react":"6uln9","../store/inlineHelpStore":"85GZA","./useStoreLoader":"9kAbs","../store/inlineHelpContentStore":"9HIgE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85GZA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineHelpStore", ()=>inlineHelpStore);
parcelHelpers.export(exports, "getInlineHelpStoreValue", ()=>getInlineHelpStoreValue);
var _createStore = require("./createStore");
var _createStoreDefault = parcelHelpers.interopDefault(_createStore);
var inlineHelpStore;
var getInlineHelpStoreValue = function() {
    if (!inlineHelpStore) inlineHelpStore = (0, _createStoreDefault.default)({
        pageId: null
    });
    return inlineHelpStore.value;
};

},{"./createStore":"7P9ZX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7P9ZX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rxjs = require("rxjs");
function createStore(initialValue) {
    var store = new (0, _rxjs.BehaviorSubject)(initialValue);
    return store;
}
exports.default = createStore;

},{"rxjs":"9GCG7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9GCG7":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":false,"./internal/observable/ConnectableObservable":false,"./internal/operators/groupBy":false,"./internal/symbol/observable":false,"./internal/Subject":"fkmmb","./internal/BehaviorSubject":"1wyzU","./internal/ReplaySubject":false,"./internal/AsyncSubject":false,"./internal/scheduler/asap":false,"./internal/scheduler/async":false,"./internal/scheduler/queue":false,"./internal/scheduler/animationFrame":false,"./internal/scheduler/VirtualTimeScheduler":false,"./internal/Scheduler":false,"./internal/Subscription":false,"./internal/Subscriber":false,"./internal/Notification":false,"./internal/util/pipe":false,"./internal/util/noop":false,"./internal/util/identity":false,"./internal/util/isObservable":false,"./internal/util/ArgumentOutOfRangeError":false,"./internal/util/EmptyError":false,"./internal/util/ObjectUnsubscribedError":false,"./internal/util/UnsubscriptionError":false,"./internal/util/TimeoutError":false,"./internal/observable/bindCallback":false,"./internal/observable/bindNodeCallback":false,"./internal/observable/combineLatest":false,"./internal/observable/concat":false,"./internal/observable/defer":false,"./internal/observable/empty":false,"./internal/observable/forkJoin":false,"./internal/observable/from":"40mz6","./internal/observable/fromEvent":false,"./internal/observable/fromEventPattern":false,"./internal/observable/generate":false,"./internal/observable/iif":false,"./internal/observable/interval":false,"./internal/observable/merge":false,"./internal/observable/never":false,"./internal/observable/of":false,"./internal/observable/onErrorResumeNext":false,"./internal/observable/pairs":false,"./internal/observable/partition":false,"./internal/observable/race":false,"./internal/observable/range":false,"./internal/observable/throwError":false,"./internal/observable/timer":false,"./internal/observable/using":false,"./internal/observable/zip":false,"./internal/scheduled/scheduled":false,"./internal/config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j4Smp":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"lb6TL","./util/toSubscriber":"2sEIu","./symbol/observable":"cRA4o","./util/pipe":"1C4RA","./config":"ie9lG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lb6TL":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"lzall","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lzall":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"e77Q8","./util/isFunction":"7NvaE","./Observer":"54n5r","./Subscription":"dxYmY","../internal/symbol/rxSubscriber":"5OSG9","./config":"ie9lG","./util/hostReportError":"6jynY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e77Q8":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NvaE":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"54n5r":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"ie9lG","./util/hostReportError":"6jynY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ie9lG":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6jynY":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxYmY":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"lx0i2","./util/isObject":"1ElRR","./util/isFunction":"7NvaE","./util/UnsubscriptionError":"o2duh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lx0i2":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ElRR":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"o2duh":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5OSG9":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2sEIu":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"lzall","../symbol/rxSubscriber":"5OSG9","../Observer":"54n5r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRA4o":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1C4RA":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"chn6K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chn6K":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fkmmb":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"e77Q8","./Observable":"j4Smp","./Subscriber":"lzall","./Subscription":"dxYmY","./util/ObjectUnsubscribedError":"jvZWR","./SubjectSubscription":"hAxuS","../internal/symbol/rxSubscriber":"5OSG9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jvZWR":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hAxuS":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"e77Q8","./Subscription":"dxYmY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1wyzU":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var BehaviorSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"e77Q8","./Subject":"fkmmb","./util/ObjectUnsubscribedError":"jvZWR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"40mz6":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"j4Smp","../util/subscribeTo":"fusrQ","../scheduled/scheduled":"8kwgx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fusrQ":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"1v9ak","./subscribeToPromise":"czrYn","./subscribeToIterable":"jpLtj","./subscribeToObservable":"jRUYH","./isArrayLike":"kc2rd","./isPromise":"gdGVg","./isObject":"1ElRR","../symbol/iterator":"7aA3a","../symbol/observable":"cRA4o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1v9ak":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czrYn":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"6jynY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpLtj":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"7aA3a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7aA3a":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jRUYH":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"cRA4o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kc2rd":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gdGVg":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kwgx":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"f7ryQ","./schedulePromise":"7AMam","./scheduleArray":"drdor","./scheduleIterable":"2bD6u","../util/isInteropObservable":"62VUw","../util/isPromise":"gdGVg","../util/isArrayLike":"kc2rd","../util/isIterable":"fMTAU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7ryQ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"j4Smp","../Subscription":"dxYmY","../symbol/observable":"cRA4o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7AMam":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"j4Smp","../Subscription":"dxYmY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"drdor":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"j4Smp","../Subscription":"dxYmY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2bD6u":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"j4Smp","../Subscription":"dxYmY","../symbol/iterator":"7aA3a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"62VUw":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"cRA4o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMTAU":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"7aA3a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kAbs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function useStoreLoader(action$, store$) {
    var _useState = _sliced_to_array((0, _react.useState)(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    (0, _react.useEffect)(function() {
        var actionSubscription = action$.subscribe(function() {
            setIsLoading(true);
        });
        return function() {
            if (actionSubscription) actionSubscription.unsubscribe();
        };
    }, [
        action$,
        setIsLoading
    ]);
    (0, _react.useEffect)(function() {
        var storeValueSubscription = store$.subscribe(function() {
            setIsLoading(false);
        });
        return function() {
            if (storeValueSubscription) storeValueSubscription.unsubscribe();
        };
    }, [
        store$,
        setIsLoading
    ]);
    return {
        isLoading: isLoading
    };
}
exports.default = useStoreLoader;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9HIgE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineHelpContentAction$", ()=>inlineHelpContentAction$);
parcelHelpers.export(exports, "inlineHelpContentStore$", ()=>inlineHelpContentStore$);
parcelHelpers.export(exports, "resetContentStore", ()=>resetContentStore);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _inlineHelpContent = require("../services/inlineHelpContent");
var _inlineHelpContentDefault = parcelHelpers.interopDefault(_inlineHelpContent);
var inlineHelpContentAction$ = new (0, _rxjs.Subject)();
var inlineHelpContentPayloadStore$ = new (0, _rxjs.BehaviorSubject)({
    pageId: ""
});
var inlineHelpContentStore$ = new (0, _rxjs.BehaviorSubject)({});
inlineHelpContentAction$.subscribe(inlineHelpContentPayloadStore$);
inlineHelpContentAction$.pipe((0, _operators.switchMap)(function(param) {
    var pageId = param.pageId;
    return (0, _inlineHelpContentDefault.default)({
        pageId: pageId
    }).pipe((0, _operators.map)(function(param) {
        var inlineHelpContent = param.inlineHelpContent;
        return {
            response: inlineHelpContent
        };
    }), (0, _operators.catchError)(function(err) {
        return (0, _rxjs.from)([
            {
                error: err
            }
        ]);
    }));
})).subscribe(inlineHelpContentStore$);
function resetContentStore() {
    inlineHelpContentStore$.next({});
}
inlineHelpContentStore$.subscribe(function(param) {
    var error = param.error;
    if (!error) // eslint-disable-next-line no-useless-return
    return;
// TODO: implement notification for failed request
});

},{"rxjs":"9GCG7","rxjs/operators":"cSE7H","../services/inlineHelpContent":"7z8RE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cSE7H":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":false,"../internal/operators/auditTime":false,"../internal/operators/buffer":false,"../internal/operators/bufferCount":false,"../internal/operators/bufferTime":false,"../internal/operators/bufferToggle":false,"../internal/operators/bufferWhen":false,"../internal/operators/catchError":"2F0LL","../internal/operators/combineAll":false,"../internal/operators/combineLatest":false,"../internal/operators/concat":false,"../internal/operators/concatAll":false,"../internal/operators/concatMap":false,"../internal/operators/concatMapTo":false,"../internal/operators/count":false,"../internal/operators/debounce":false,"../internal/operators/debounceTime":false,"../internal/operators/defaultIfEmpty":false,"../internal/operators/delay":false,"../internal/operators/delayWhen":false,"../internal/operators/dematerialize":false,"../internal/operators/distinct":false,"../internal/operators/distinctUntilChanged":false,"../internal/operators/distinctUntilKeyChanged":false,"../internal/operators/elementAt":false,"../internal/operators/endWith":false,"../internal/operators/every":false,"../internal/operators/exhaust":false,"../internal/operators/exhaustMap":false,"../internal/operators/expand":false,"../internal/operators/filter":false,"../internal/operators/finalize":false,"../internal/operators/find":false,"../internal/operators/findIndex":false,"../internal/operators/first":false,"../internal/operators/groupBy":false,"../internal/operators/ignoreElements":false,"../internal/operators/isEmpty":false,"../internal/operators/last":false,"../internal/operators/map":"b2GyY","../internal/operators/mapTo":false,"../internal/operators/materialize":false,"../internal/operators/max":false,"../internal/operators/merge":false,"../internal/operators/mergeAll":false,"../internal/operators/mergeMap":false,"../internal/operators/mergeMapTo":false,"../internal/operators/mergeScan":false,"../internal/operators/min":false,"../internal/operators/multicast":false,"../internal/operators/observeOn":false,"../internal/operators/onErrorResumeNext":false,"../internal/operators/pairwise":false,"../internal/operators/partition":false,"../internal/operators/pluck":false,"../internal/operators/publish":false,"../internal/operators/publishBehavior":false,"../internal/operators/publishLast":false,"../internal/operators/publishReplay":false,"../internal/operators/race":false,"../internal/operators/reduce":false,"../internal/operators/repeat":false,"../internal/operators/repeatWhen":false,"../internal/operators/retry":false,"../internal/operators/retryWhen":false,"../internal/operators/refCount":false,"../internal/operators/sample":false,"../internal/operators/sampleTime":false,"../internal/operators/scan":false,"../internal/operators/sequenceEqual":false,"../internal/operators/share":false,"../internal/operators/shareReplay":false,"../internal/operators/single":false,"../internal/operators/skip":false,"../internal/operators/skipLast":false,"../internal/operators/skipUntil":false,"../internal/operators/skipWhile":false,"../internal/operators/startWith":false,"../internal/operators/subscribeOn":false,"../internal/operators/switchAll":false,"../internal/operators/switchMap":"CTyaE","../internal/operators/switchMapTo":false,"../internal/operators/take":false,"../internal/operators/takeLast":false,"../internal/operators/takeUntil":false,"../internal/operators/takeWhile":false,"../internal/operators/tap":false,"../internal/operators/throttle":false,"../internal/operators/throttleTime":false,"../internal/operators/throwIfEmpty":false,"../internal/operators/timeInterval":false,"../internal/operators/timeout":false,"../internal/operators/timeoutWith":false,"../internal/operators/timestamp":false,"../internal/operators/toArray":false,"../internal/operators/window":false,"../internal/operators/windowCount":false,"../internal/operators/windowTime":false,"../internal/operators/windowToggle":false,"../internal/operators/windowWhen":false,"../internal/operators/withLatestFrom":false,"../internal/operators/zip":false,"../internal/operators/zipAll":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2F0LL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"e77Q8","../innerSubscribe":"fyYiL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fyYiL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

},{"tslib":"e77Q8","./Subscriber":"lzall","./Observable":"j4Smp","./util/subscribeTo":"fusrQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2GyY":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"e77Q8","../Subscriber":"lzall","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"CTyaE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"e77Q8","./map":"b2GyY","../observable/from":"40mz6","../innerSubscribe":"fyYiL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7z8RE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInlineHelpContentService", ()=>getInlineHelpContentService);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _carrierLogisticsWebServerClient = require("../clients/CarrierLogisticsWebServerClient");
var _carrierLogisticsWebServerClientDefault = parcelHelpers.interopDefault(_carrierLogisticsWebServerClient);
function getInlineHelpContentService(param) {
    var pageId = param.pageId;
    return (0, _carrierLogisticsWebServerClientDefault.default).getInlineHelpContent((0, _coralComAmazonCarrierlogisticswebserverModel.GetInlineHelpContentInput).clone({
        pageId: pageId
    }));
}
exports.default = getInlineHelpContentService;

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","../clients/CarrierLogisticsWebServerClient":"lIJr4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lIJr4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralConfigCarrierLogisticsWebServer = require("@amzn/coral-config_carrier-logistics-web-server");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _requestOptionsInterceptor = require("./RequestOptionsInterceptor");
var _requestOptionsInterceptorDefault = parcelHelpers.interopDefault(_requestOptionsInterceptor);
var _env = require("../config/env");
var _envDefault = parcelHelpers.interopDefault(_env);
var clientFactory = new (0, _ihmJsCoralClient.CoralClientFactory)([
    (0, _coralConfigCarrierLogisticsWebServer.CarrierLogisticsWebServerClientConfigFactory)
], (0, _envDefault.default).getEnv(), new (0, _ihmJsCoralClient.InterceptingHandler)(new (0, _ihmJsCoralClient.CoralFetchHandler)(), [
    (0, _coralComAmazonCarrierlogisticswebserverModel.carrierLogisticsWebServerHttpBindingInterceptor),
    new (0, _requestOptionsInterceptorDefault.default)()
]));
var CarrierLogisticsWebServerClient = clientFactory.get((0, _coralComAmazonCarrierlogisticswebserverModel.CarrierLogisticsWebServer));
exports.default = CarrierLogisticsWebServerClient;

},{"@amzn/coral-config_carrier-logistics-web-server":"9l2WX","@amzn/ihm-js-coral-client":"eOj61","@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","./RequestOptionsInterceptor":"jE93j","../config/env":"flQu4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jE93j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _index = require("@amzn/carrierlogistics-commons/dist/constants/index");
var _csrf = require("@amzn/carrierlogistics-commons/dist/utils/csrf");
var _csrfDefault = parcelHelpers.interopDefault(_csrf);
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possible_constructor_return(this, result);
    };
}
/**
 * This class is used during client construction, and helps to intercept 
 * the headers during request handling for the passport external App.
 */ var RequestOptionsInterceptor = /*#__PURE__*/ function(CoralInterceptor1) {
    "use strict";
    _inherits(RequestOptionsInterceptor, CoralInterceptor1);
    var _super = _create_super(RequestOptionsInterceptor);
    function RequestOptionsInterceptor() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, RequestOptionsInterceptor);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    _create_class(RequestOptionsInterceptor, [
        {
            /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
            key: "intercept",
            value: function intercept(request, next) {
                // Adding required header
                var headers = [
                    [
                        "Accept",
                        "application/json"
                    ],
                    [
                        "Content-Type",
                        "application/json"
                    ],
                    [
                        (0, _index.CSRF_TOKEN_ID),
                        (0, _csrfDefault.default)()
                    ]
                ];
                var modifiedRequest = request.clone({
                    headers: headers,
                    credentials: "same-origin",
                    url: request.url
                });
                return (0, _rxjs.from)(next.handle(modifiedRequest)).pipe((0, _operators.map)(function(response) {
                    return new (0, _ihmJsCoralClient.CoralResponse)(response);
                }));
            }
        }
    ]);
    return RequestOptionsInterceptor;
}((0, _ihmJsCoralClient.CoralInterceptor));
exports.default = RequestOptionsInterceptor;

},{"@amzn/ihm-js-coral-client":"eOj61","rxjs":"9GCG7","rxjs/operators":"cSE7H","@amzn/carrierlogistics-commons/dist/constants/index":"aArvG","@amzn/carrierlogistics-commons/dist/utils/csrf":"ke6AF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aArvG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSRF_TOKEN_ID", ()=>CSRF_TOKEN_ID);
var CSRF_TOKEN_ID = "anti-csrftoken-a2z";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ke6AF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCsrfToken", ()=>getCsrfToken);
var _constants = require("../constants");
var getCsrfToken = function() {
    var csrfTokenMeta = document.querySelector("meta[name='".concat((0, _constants.CSRF_TOKEN_ID), "']"));
    var ref;
    return (ref = csrfTokenMeta === null || csrfTokenMeta === void 0 ? void 0 : csrfTokenMeta.getAttribute("content")) !== null && ref !== void 0 ? ref : "";
};
exports.default = getCsrfToken;

},{"../constants":"aArvG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flQu4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointConfig = require("./endpointConfig");
var getEnv = function() {
    var url = window.location.href;
    var env;
    if (url.includes((0, _endpointConfig.URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.CLWS_CORAL_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.CLWS_CORAL_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.CLWS_CORAL_CONFIG).PROD_CONFIG;
    else env = (0, _endpointConfig.CLWS_CORAL_CONFIG).LOCAL_DEV;
    return env;
};
var envHelper = {
    getEnv: getEnv
};
exports.default = envHelper;

},{"./endpointConfig":"kGvzM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kGvzM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URL_PREFIXES", ()=>URL_PREFIXES);
parcelHelpers.export(exports, "CLWS_CORAL_CONFIG", ()=>CLWS_CORAL_CONFIG);
var URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon"
};
var CLWS_CORAL_CONFIG = {
    BETA_CONFIG: "Carrierlogistics.Beta.USAmazon",
    GAMMA_CONFIG: "Carrierlogistics.Gamma.USAmazon",
    PROD_CONFIG: "Carrierlogistics.Prod.USAmazon",
    LOCAL_DEV: "test.USAmazon"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"83mKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useObservable = require("./useObservable");
var _useObservableDefault = parcelHelpers.interopDefault(_useObservable);
var _inlineHelpContentStore = require("../store/inlineHelpContentStore");
function useInlineHelpContent() {
    var response = (0, _useObservableDefault.default)((0, _inlineHelpContentStore.inlineHelpContentStore$)).response;
    return {
        response: response
    };
}
exports.default = useInlineHelpContent;

},{"./useObservable":"2cxjD","../store/inlineHelpContentStore":"9HIgE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cxjD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var useObservable = function(observable) {
    var _useState = _sliced_to_array((0, _react.useState)(observable.getValue()), 2), state = _useState[0], setState = _useState[1];
    (0, _react.useEffect)(function() {
        var subscription = observable.subscribe(setState);
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return state;
};
exports.default = useObservable;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBq4R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _inlineHelpStore = require("../store/inlineHelpStore");
var _downloadTermManualStore = require("../store/downloadTermManualStore");
function useDownloadTermManualActions() {
    var pageId = (0, _inlineHelpStore.getInlineHelpStoreValue)().pageId;
    var downloadTermManual = (0, _react.useCallback)(function(s3Object) {
        if (!pageId) return;
        (0, _downloadTermManualStore.downloadTermManualAction$).next({
            termKey: s3Object
        });
    }, [
        pageId
    ]);
    return {
        downloadTermManual: downloadTermManual
    };
}
exports.default = useDownloadTermManualActions;

},{"react":"6uln9","../store/inlineHelpStore":"85GZA","../store/downloadTermManualStore":"jRP2i","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jRP2i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadTermManualAction$", ()=>downloadTermManualAction$);
parcelHelpers.export(exports, "downloadTermManualStore$", ()=>downloadTermManualStore$);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _downloadTermManual = require("../services/downloadTermManual");
var _downloadTermManualDefault = parcelHelpers.interopDefault(_downloadTermManual);
var _downloadFile = require("../utils/downloadFile");
var downloadTermManualAction$ = new (0, _rxjs.Subject)();
var downloadTermManualPayloadStore$ = new (0, _rxjs.BehaviorSubject)({
    termKey: ""
});
var downloadTermManualStore$ = new (0, _rxjs.BehaviorSubject)({});
downloadTermManualAction$.subscribe(downloadTermManualPayloadStore$);
downloadTermManualAction$.pipe((0, _operators.switchMap)(function(param) {
    var termKey = param.termKey;
    return (0, _downloadTermManualDefault.default)({
        termKey: termKey
    }).pipe((0, _operators.map)(function(param) {
        var fileAccessInformation = param.fileAccessInformation;
        fileAccessInformation.forEach(function(fileInformation) {
            var _fileInformation;
            (0, _downloadFile.downloadFile)((_fileInformation = fileInformation) === null || _fileInformation === void 0 ? void 0 : _fileInformation.s3presignedUrl);
        });
        return {
            response: fileAccessInformation
        };
    }), (0, _operators.catchError)(function(err) {
        return (0, _rxjs.from)([
            {
                error: err
            }
        ]);
    }));
})).subscribe(downloadTermManualStore$);
downloadTermManualStore$.subscribe(function(param) {
    var error = param.error;
    if (!error) // eslint-disable-next-line no-useless-return
    return;
// TODO: implement notification for failed request
});

},{"rxjs":"9GCG7","rxjs/operators":"cSE7H","../services/downloadTermManual":"dTpSp","../utils/downloadFile":"1DLWG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dTpSp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTermManualService", ()=>getTermManualService);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
var _carrierLogisticsWebServerClient = require("../clients/CarrierLogisticsWebServerClient");
var _carrierLogisticsWebServerClientDefault = parcelHelpers.interopDefault(_carrierLogisticsWebServerClient);
function getTermManualService(param) {
    var termKey = param.termKey;
    return (0, _carrierLogisticsWebServerClientDefault.default).getTermManual((0, _coralComAmazonCarrierlogisticswebserverModel.GetTermManualInput).clone({
        presignedUrlInputParameters: {
            s3ObjectKeys: [
                termKey
            ]
        }
    }));
}
exports.default = getTermManualService;

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","../clients/CarrierLogisticsWebServerClient":"lIJr4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1DLWG":[function(require,module,exports) {
/* eslint-disable import/prefer-default-export */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadFile", ()=>downloadFile);
var _window = require("../shared/window");
var _windowDefault = parcelHelpers.interopDefault(_window);
var previousFrame = null;
function downloadFile(uri) {
    var iframe = (0, _windowDefault.default).document.createElement("iframe");
    iframe.src = uri;
    iframe.setAttribute("style", "display: none");
    if (previousFrame) (0, _windowDefault.default).document.body.removeChild(previousFrame);
    previousFrame = iframe;
    (0, _windowDefault.default).document.body.append(iframe);
}

},{"../shared/window":"1FrxN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1FrxN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = window;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99Dzh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loader = require("@amzn/meridian/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var LoadingComponent = function(param) {
    var isLoading = param.isLoading;
    if (!isLoading) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        heights: "100%",
        alignmentVertical: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        alignmentHorizontal: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loaderDefault.default), {
        size: "medium"
    })));
};
exports.default = LoadingComponent;

},{"react":"6uln9","@amzn/meridian/loader":"4OOdK","@amzn/meridian/row":"2VLMq","@amzn/meridian/column":"aw8aI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4OOdK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a72f1e5282b2eb5d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _loader = _interopRequireDefault(require("a67bd634bc9af38a"));
var _default = _loader["default"];
exports["default"] = _default;

},{"a72f1e5282b2eb5d":"hVU2P","a67bd634bc9af38a":"gQoOO"}],"gQoOO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("730139350c44d99b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("dd2ba6c0149794c7"));
var _classCallCheck2 = _interopRequireDefault(require("12662ae0714cec5b"));
var _createClass2 = _interopRequireDefault(require("160a61aa16277c05"));
var _inherits2 = _interopRequireDefault(require("847a4c45fd4dc40b"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("2e89d13c288609fc"));
var _getPrototypeOf2 = _interopRequireDefault(require("dc80c10bcf5d5222"));
var _defineProperty2 = _interopRequireDefault(require("c9bc42707c39aea3"));
var _react = _interopRequireDefault(require("e46a4ba9aec4b2bd"));
var _propTypes = _interopRequireDefault(require("20514ef1fa6b069a"));
var _emotion = require("7dcfba57291e4b53");
var _loader = _interopRequireDefault(require("342a9ed3feb13538"));
var _linear = _interopRequireDefault(require("34b41616824f0ad7"));
var _circular = _interopRequireDefault(require("f673ac64f894a556"));
var _theme = require("b1ad172d0899bdfa");
var _token = require("b219e5bc4925016e");
var _text = _interopRequireDefault(require("4ec1879e0f9c1761"));
var _filterPropsByPrefix = _interopRequireDefault(require("fad12f4a41fb7b36"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var wrapperStyles = function wrapperStyles(t, _ref) {
    var type = _ref.type, size = _ref.size;
    return (0, _emotion.css)((0, _text["default"])(t, {
        fontSize: type === "linear" ? type : size,
        lineHeight: type === "linear" ? type : size,
        fontWeight: "body"
    }));
};
var Loader = /*#__PURE__*/ function(_React$PureComponent) {
    (0, _inherits2["default"])(Loader, _React$PureComponent);
    var _super = _createSuper(Loader);
    function Loader() {
        (0, _classCallCheck2["default"])(this, Loader);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(Loader, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, size = _this$props.size, type = _this$props.type, showPercentageText = _this$props.showPercentageText;
                var percentage = this.props.percentage;
                percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage;
                var determinate = percentage !== undefined;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _loader["default"],
                    map: (0, _token.getTokenHelper)("loader")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
                        className: wrapperStyles(t, {
                            size: size,
                            type: type
                        })
                    }), type === "linear" ? /*#__PURE__*/ _react["default"].createElement(_linear["default"], {
                        percentage: percentage,
                        showPercentageText: showPercentageText,
                        size: size,
                        determinate: determinate,
                        t: t
                    }) : /*#__PURE__*/ _react["default"].createElement(_circular["default"], {
                        percentage: percentage,
                        showPercentageText: showPercentageText,
                        size: size,
                        determinate: determinate,
                        t: t
                    }));
                });
            }
        }
    ]);
    return Loader;
}(_react["default"].PureComponent);
(0, _defineProperty2["default"])(Loader, "defaultProps", {
    size: "large",
    type: "circular",
    showPercentageText: true
});
Loader.propTypes = {};
var _default = Loader;
exports["default"] = _default;

},{"730139350c44d99b":"hVU2P","dd2ba6c0149794c7":"5G7gB","12662ae0714cec5b":"8KeDp","160a61aa16277c05":"5f8kn","847a4c45fd4dc40b":"3lN0X","2e89d13c288609fc":"eIx1K","dc80c10bcf5d5222":"iYiZL","c9bc42707c39aea3":"74DXJ","e46a4ba9aec4b2bd":"6uln9","20514ef1fa6b069a":"1hOJi","7dcfba57291e4b53":"kbmlY","342a9ed3feb13538":"evSRZ","34b41616824f0ad7":"5qKMy","f673ac64f894a556":"4zQb7","b1ad172d0899bdfa":"f7yMb","b219e5bc4925016e":"dp1DQ","4ec1879e0f9c1761":"blvoW","fad12f4a41fb7b36":"aJ6so"}],"5qKMy":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9b1abc6bad987e54");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("a8c065f0c34e66ea"));
var _emotion = require("d1031764de28c95");
var _token = require("f38824f98f3894b8");
var indeterminateLinearAnimation = (0, _emotion.keyframes)({
    from: {
        transform: "scaleX(0.25) translateX(-100%)"
    },
    to: {
        transform: "scaleX(1) translateX(150%)"
    }
});
var linearWrapperStyle = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size;
    return (0, _emotion.css)({
        display: "flex",
        borderRadius: t("borderRadius"),
        width: "100%",
        minWidth: 100,
        height: t("trackLinear", [
            size,
            "height"
        ]),
        backgroundColor: t("trackBackgroundColor"),
        position: "relative",
        overflow: "hidden"
    });
}, [
    "size"
]);
var linearIndicatorStyle = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var determinate = _ref2.determinate, _ref2$percentage = _ref2.percentage, percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage;
    return (0, _emotion.css)({
        width: "".concat(percentage, "%"),
        height: "100%",
        backgroundColor: t("indicatorBackgroundColor"),
        transition: t.transitionCss("indicatorMotionDeterminate", "width")
    }, !determinate ? linearIndeterminateStyle(t) : undefined);
}, [
    "determinate",
    "percentage"
]);
var linearIndeterminateStyle = function linearIndeterminateStyle(t) {
    return {
        width: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        borderRadius: t("borderRadius"),
        transformOrigin: "top left",
        animation: "".concat(indeterminateLinearAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
    };
};
var linearPercentageStyle = (0, _token.memoizeTokenStyles)(function(t, _ref3) {
    var percentage = _ref3.percentage;
    return (0, _emotion.css)({
        width: "".concat(percentage, "%"),
        textAlign: "right",
        marginTop: t("percentageSpacing"),
        transition: t.transitionCss("indicatorMotionDeterminate", "width")
    });
}, [
    "percentage"
]);
/* eslint-disable react/prop-types */ var LinearLoader = function LinearLoader(_ref4) {
    var t = _ref4.t, percentage = _ref4.percentage, showPercentageText = _ref4.showPercentageText, size = _ref4.size, determinate = _ref4.determinate;
    return /*#__PURE__*/ _react["default"].createElement("div", null, /*#__PURE__*/ _react["default"].createElement("div", {
        className: linearWrapperStyle(t, {
            size: size
        })
    }, /*#__PURE__*/ _react["default"].createElement("div", {
        className: linearIndicatorStyle(t, {
            determinate: determinate,
            percentage: percentage
        })
    })), determinate && showPercentageText ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: linearPercentageStyle(t, {
            percentage: percentage
        })
    }, "".concat(percentage, "%")) : null);
};
/* eslint-enable react/prop-types */ var _default = LinearLoader;
exports["default"] = _default;

},{"9b1abc6bad987e54":"hVU2P","a8c065f0c34e66ea":"6uln9","d1031764de28c95":"kbmlY","f38824f98f3894b8":"dp1DQ"}],"4zQb7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("fc33f8d6d9585f4d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("214219ce352fc40e"));
var _emotion = require("c13f67c28ec01d24");
var _token = require("319c219ae07d95a9");
var _functional = require("38e80b0759ddfa74");
var indeterminateCircularAnimation = (0, _emotion.keyframes)({
    "0%": {
        strokeDasharray: "100% 200%",
        transform: "rotate(100deg)"
    },
    "50%": {
        strokeDasharray: "30% 400%"
    },
    "100%": {
        strokeDasharray: "100% 200%",
        transform: "rotate(460deg)"
    }
});
var wrapperStyle = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size;
    return (0, _emotion.css)({
        position: "relative"
    }, size === "small" ? {
        display: "flex",
        alignItems: "center"
    } : undefined);
}, [
    "size"
]);
var svgStyle = function svgStyle(size) {
    return (0, _emotion.css)({
        width: size,
        height: size
    });
};
var pathStyle = (0, _functional.memoize)(function(t) {
    return (0, _emotion.css)({
        transition: t.transitionCss("indicatorMotionDeterminate", "stroke-dasharray")
    });
});
var indeterminatePathStyle = (0, _functional.memoize)(function(t) {
    return (0, _emotion.css)({
        transformOrigin: "center",
        animation: "".concat(indeterminateCircularAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionDeterminateFunction"), " infinite")
    });
});
var percentageStyle = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var size = _ref2.size;
    return (0, _emotion.css)(size === "small" ? smallPercentageStyle : size === "medium" ? mediumPercentageStyle(t) : largePercentageStyle(t));
}, [
    "size"
]);
var smallPercentageStyle = {
    marginLeft: 8
};
var mediumPercentageStyle = function mediumPercentageStyle(t) {
    return {
        width: t("trackCircularMediumSize"),
        textAlign: "center",
        marginTop: t("percentageSpacing")
    };
};
var largePercentageStyle = function largePercentageStyle(t) {
    return {
        position: "absolute",
        top: t("trackCircularLargeSize") / 2,
        width: t("trackCircularLargeSize"),
        lineHeight: 0,
        textAlign: "center"
    };
};
/**
 * To draw the right amount of stroke we need to know
 * the total length of the path. These path lengths were
 * derived once in Chrome console in order that they not
 * be calculated every time
 */ var pathLengths = {
    large: 188.5220947265625,
    medium: 87.97695922851562,
    small: 43.98847961425781
};
/* eslint-disable react/prop-types */ var CircularLoader = function CircularLoader(props) {
    var t = props.t, size = props.size, percentage = props.percentage, showPercentageText = props.showPercentageText, determinate = props.determinate;
    var box = t("trackCircular", [
        size,
        "size"
    ]);
    var startX = box / 2;
    var startY = t("trackCircular", [
        size,
        "strokeWidth"
    ]) / 2;
    var endX = 0;
    var endY = box - t("trackCircular", [
        size,
        "strokeWidth"
    ]);
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: wrapperStyle(t, {
            size: size
        })
    }, /*#__PURE__*/ _react["default"].createElement("svg", {
        viewBox: "0 0 ".concat(box, " ").concat(box),
        className: svgStyle(box)
    }, /*#__PURE__*/ _react["default"].createElement("circle", {
        cx: box / 2,
        cy: box / 2,
        r: endY / 2,
        stroke: t("track", "backgroundColor"),
        strokeWidth: t("trackCircular", [
            size,
            "strokeWidth"
        ]),
        fill: "none"
    }), !determinate ? /*#__PURE__*/ _react["default"].createElement("circle", {
        className: indeterminatePathStyle(t),
        cx: box / 2,
        cy: box / 2,
        r: endY / 2,
        stroke: t("indicatorBackgroundColor"),
        strokeWidth: t("trackCircular", [
            size,
            "strokeWidth"
        ]),
        strokeLinecap: "round",
        strokeDasharray: "10% 100%",
        fill: "none"
    }) : /*#__PURE__*/ _react["default"].createElement("path", {
        className: pathStyle(t),
        d: "M".concat(startX, ",").concat(startY, "\n              a 1 1 0 0 1 ").concat(endX, " ").concat(endY, "\n              a 1 1 0 0 1 ").concat(endX, " -").concat(endY),
        fill: "none",
        stroke: t("indicatorBackgroundColor"),
        strokeWidth: t("trackCircular", [
            size,
            "strokeWidth"
        ]),
        strokeLinecap: "round",
        strokeDasharray: "".concat(pathLengths[size] * percentage / 100, ", ").concat(pathLengths[size])
    })), determinate && showPercentageText ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: percentageStyle(t, {
            size: size
        })
    }, "".concat(percentage, "%")) : null);
};
/* eslint-enable react/prop-types */ var _default = CircularLoader;
exports["default"] = _default;

},{"fc33f8d6d9585f4d":"hVU2P","214219ce352fc40e":"6uln9","c13f67c28ec01d24":"kbmlY","319c219ae07d95a9":"dp1DQ","38e80b0759ddfa74":"4L61K"}],"eL04v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _heading = require("@amzn/meridian/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _common = require("../../constants/common");
var _textContent = require("./TextContent");
var _textContentDefault = parcelHelpers.interopDefault(_textContent);
var _keyTermContent = require("./KeyTermContent");
var _keyTermContentDefault = parcelHelpers.interopDefault(_keyTermContent);
var _imageContent = require("./ImageContent");
var _imageContentDefault = parcelHelpers.interopDefault(_imageContent);
var _videoContent = require("./VideoContent");
var _videoContentDefault = parcelHelpers.interopDefault(_videoContent);
var _linkContent = require("./LinkContent");
var _linkContentDefault = parcelHelpers.interopDefault(_linkContent);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ContentRenderer = function(param) {
    var title = param.title, content = param.content, contentType = param.contentType, onDownloadBtnClick = param.onDownloadBtnClick;
    var _obj;
    var contentRenderers = (_obj = {}, _define_property(_obj, (0, _common.TEXT_TYPE), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textContentDefault.default), {
        content: content
    })), _define_property(_obj, (0, _common.KEY_TERM_TYPE), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyTermContentDefault.default), {
        content: content
    })), _define_property(_obj, (0, _common.IMAGE_TYPE), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageContentDefault.default), {
        content: content
    })), _define_property(_obj, (0, _common.VIDEO_TYPE), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _videoContentDefault.default), {
        content: content
    })), _define_property(_obj, (0, _common.LINK_TYPE), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _linkContentDefault.default), {
        content: content,
        onDownloadBtnClick: onDownloadBtnClick
    })), _obj);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        spacing: "small"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        level: 2
    }, title)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, contentRenderers[contentType]));
};
exports.default = ContentRenderer;

},{"@amzn/meridian/heading":"biBV3","react":"6uln9","@amzn/meridian/column":"aw8aI","@amzn/meridian/row":"2VLMq","../../constants/common":"ijIZO","./TextContent":"jVFOG","./KeyTermContent":"hYsSf","./ImageContent":"gglNP","./VideoContent":"ebg96","./LinkContent":"9k2AX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ijIZO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FEATURE_FLAG", ()=>FEATURE_FLAG);
parcelHelpers.export(exports, "TEXT_TYPE", ()=>TEXT_TYPE);
parcelHelpers.export(exports, "KEY_TERM_TYPE", ()=>KEY_TERM_TYPE);
parcelHelpers.export(exports, "IMAGE_TYPE", ()=>IMAGE_TYPE);
parcelHelpers.export(exports, "VIDEO_TYPE", ()=>VIDEO_TYPE);
parcelHelpers.export(exports, "LINK_TYPE", ()=>LINK_TYPE);
parcelHelpers.export(exports, "HEADER", ()=>HEADER);
parcelHelpers.export(exports, "OVERVIEW", ()=>OVERVIEW);
parcelHelpers.export(exports, "KEY_HEADING", ()=>KEY_HEADING);
parcelHelpers.export(exports, "FOOTER", ()=>FOOTER);
var FEATURE_FLAG = "EnableInlineHelp";
var TEXT_TYPE = "text";
var KEY_TERM_TYPE = "keyTerm";
var IMAGE_TYPE = "image";
var VIDEO_TYPE = "video";
var LINK_TYPE = "link";
var HEADER = "header";
var OVERVIEW = "overview";
var KEY_HEADING = "keyTerminology";
var FOOTER = "footer";
exports.default = FEATURE_FLAG;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jVFOG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var TextContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        tag: "ul"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, content));
};
exports.default = TextContent;

},{"react":"6uln9","@amzn/meridian/text":"93LxJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hYsSf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var KeyTermContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        tag: "ul"
    }, content.map(function(keyTerm) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, keyTerm.term, " - ", keyTerm.description);
    }));
};
exports.default = KeyTermContent;

},{"react":"6uln9","@amzn/meridian/text":"93LxJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gglNP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var ImageContent = function(param) {
    var content = param.content;
    var baseAssetPath = window.location.origin;
    if (Array.isArray(content)) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        tag: "ul"
    }, content.map(function(imgPath) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: "".concat(baseAssetPath).concat(imgPath),
            alt: imgPath,
            width: 250
        }));
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        src: "".concat(baseAssetPath).concat(content),
        alt: content,
        width: 250
    }));
};
exports.default = ImageContent;

},{"react":"6uln9","@amzn/meridian/text":"93LxJ","@amzn/meridian/row":"2VLMq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebg96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var VideoContent = function(param) {
    var content = param.content;
    var baseAssetPath = window.location.origin;
    var formatMessage = (0, _reactIntl.useIntl)().formatMessage;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("video", {
        width: "400",
        controls: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("source", {
        src: "".concat(baseAssetPath).concat(content),
        type: "video/mp4"
    }), formatMessage({
        id: "messages.dev_app.video"
    }));
};
exports.default = VideoContent;

},{"react":"6uln9","react-intl":"63umq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9k2AX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _icon = require("@amzn/meridian/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _downloadSmall = require("@amzn/meridian-tokens/base/icon/download-small");
var _downloadSmallDefault = parcelHelpers.interopDefault(_downloadSmall);
var LinkContent = function(param) {
    var content = param.content, onDownloadBtnClick = param.onDownloadBtnClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), null, content.map(function(knowledgeLink) {
        var _knowledgeLink_title, _knowledgeLink;
        if ((_knowledgeLink_title = knowledgeLink.title) === null || _knowledgeLink_title === void 0 ? void 0 : _knowledgeLink_title.includes("Download Manual")) {
            var _knowledgeLink1;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
                type: "link",
                onClick: function() {
                    var _knowledgeLink;
                    return onDownloadBtnClick((_knowledgeLink = knowledgeLink) === null || _knowledgeLink === void 0 ? void 0 : _knowledgeLink.link);
                }
            }, (_knowledgeLink1 = knowledgeLink) === null || _knowledgeLink1 === void 0 ? void 0 : _knowledgeLink1.title, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
                tokens: (0, _downloadSmallDefault.default)
            })));
        }
        // eslint-disable-next-line react/no-array-index-key
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            type: "link",
            onClick: function() {
                var _knowledgeLink;
                return window.open((_knowledgeLink = knowledgeLink) === null || _knowledgeLink === void 0 ? void 0 : _knowledgeLink.link);
            }
        }, (_knowledgeLink = knowledgeLink) === null || _knowledgeLink === void 0 ? void 0 : _knowledgeLink.title));
    }));
};
exports.default = LinkContent;

},{"@amzn/meridian/button":"9uVFW","@amzn/meridian/column":"aw8aI","@amzn/meridian/icon":"fxUjK","@amzn/meridian/row":"2VLMq","react":"6uln9","@amzn/meridian-tokens/base/icon/download-small":"65qF6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"65qF6":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconDownloadSmallData: "data:image/svg+xml,%3csvg width='15' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M13.5 10v2a1 1 0 01-1 1h-10a1 1 0 01-1-1v-2M4.5 6l3 3 3-3M7.5 1v8'/%3e%3c/g%3e%3c/svg%3e",
    iconDownloadSmallWidth: 15,
    iconDownloadSmallHeight: 14
};

},{}],"kqnal":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _inlineHelpStore = require("../store/inlineHelpStore");
var _usePageHistory = require("./usePageHistory");
var _usePageHistoryDefault = parcelHelpers.interopDefault(_usePageHistory);
var _inlineHelpContentStore = require("../store/inlineHelpContentStore");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function useInlineHelp() {
    var _useState = _sliced_to_array((0, _react.useState)((0, _inlineHelpStore.getInlineHelpStoreValue)().pageId), 2), pageId = _useState[0], setPageId = _useState[1];
    var _usePageHistory = (0, _usePageHistoryDefault.default)(), resetPageHistory = _usePageHistory.resetPageHistory, pushtoPageHistory = _usePageHistory.pushtoPageHistory, popLastVisitedPage = _usePageHistory.popLastVisitedPage;
    (0, _react.useEffect)(function() {
        var subscription = (0, _inlineHelpStore.inlineHelpStore).subscribe(function(updatedValue) {
            return setPageId(updatedValue.pageId);
        });
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, []);
    var openInlineHelpSheet = (0, _react.useCallback)(function(id) {
        (0, _inlineHelpStore.inlineHelpStore).next({
            pageId: id
        });
    }, []);
    var navigateToNextPage = (0, _react.useCallback)(function(id) {
        if (pageId) pushtoPageHistory(id);
        openInlineHelpSheet(id);
    }, []);
    var navigateToPrevPage = (0, _react.useCallback)(function() {
        var prevOpenedPage = popLastVisitedPage();
        if (prevOpenedPage) openInlineHelpSheet(prevOpenedPage);
    }, [
        openInlineHelpSheet,
        popLastVisitedPage
    ]);
    var closeInlineHelpSheet = (0, _react.useCallback)(function() {
        resetPageHistory();
        (0, _inlineHelpContentStore.resetContentStore)();
        (0, _inlineHelpStore.inlineHelpStore).next({
            pageId: null
        });
    }, []);
    return {
        pageId: pageId,
        openInlineHelpSheet: openInlineHelpSheet,
        closeInlineHelpSheet: closeInlineHelpSheet,
        navigateToNextPage: navigateToNextPage,
        navigateToPrevPage: navigateToPrevPage
    };
}
exports.default = useInlineHelp;

},{"react":"6uln9","../store/inlineHelpStore":"85GZA","./usePageHistory":"9geUj","../store/inlineHelpContentStore":"9HIgE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9geUj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _pageHistoryStore = require("../store/pageHistoryStore");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function usePageHistory() {
    var _useState = _sliced_to_array((0, _react.useState)((0, _pageHistoryStore.getpageHistoryStoreValue)().pageStack), 2), pageStack = _useState[0], setPageStack = _useState[1];
    (0, _react.useEffect)(function() {
        var subscription = (0, _pageHistoryStore.pageHistoryStore).subscribe(function(updatedValue) {
            return setPageStack(updatedValue.pageStack);
        });
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, []);
    var pushtoPageHistory = (0, _react.useCallback)(function(id) {
        (0, _pageHistoryStore.pageHistoryStore).next({
            pageStack: _to_consumable_array(pageStack).concat([
                id
            ])
        });
    }, [
        pageStack
    ]);
    var popLastVisitedPage = (0, _react.useCallback)(function() {
        var currentStack = _to_consumable_array(pageStack);
        var lastVisitedPage = currentStack.pop();
        (0, _pageHistoryStore.pageHistoryStore).next({
            pageStack: currentStack
        });
        return lastVisitedPage;
    }, [
        pageStack
    ]);
    var resetPageHistory = (0, _react.useCallback)(function() {
        (0, _pageHistoryStore.pageHistoryStore).next({
            pageStack: []
        });
    }, []);
    return {
        pushtoPageHistory: pushtoPageHistory,
        popLastVisitedPage: popLastVisitedPage,
        resetPageHistory: resetPageHistory,
        isPageHistoryEmpty: !pageStack.length
    };
}
exports.default = usePageHistory;

},{"react":"6uln9","../store/pageHistoryStore":"5zuD2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5zuD2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pageHistoryStore", ()=>pageHistoryStore);
parcelHelpers.export(exports, "getpageHistoryStoreValue", ()=>getpageHistoryStoreValue);
var _createStore = require("./createStore");
var _createStoreDefault = parcelHelpers.interopDefault(_createStore);
var pageHistoryStore;
var getpageHistoryStoreValue = function() {
    if (!pageHistoryStore) pageHistoryStore = (0, _createStoreDefault.default)({
        pageStack: []
    });
    return pageHistoryStore.value;
};

},{"./createStore":"7P9ZX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bUddL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _locales = require("../constants/locales");
var _messages = require("../config/i18n/messages");
var _messagesDefault = parcelHelpers.interopDefault(_messages);
var _flattenObject = require("../utils/flattenObject");
var _flattenObjectDefault = parcelHelpers.interopDefault(_flattenObject);
/**
 * Wrap component with IntlProvider
 */ var withIntl = function(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.IntlProvider), {
            locale: (0, _locales.DEFAULT_LOCALE),
            messages: (0, _flattenObjectDefault.default)((0, _messagesDefault.default))
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, props));
    };
};
exports.default = withIntl;

},{"react":"6uln9","react-intl":"63umq","../constants/locales":"c5h3s","../config/i18n/messages":"2SB0y","../utils/flattenObject":"7lhkE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c5h3s":[function(require,module,exports) {
// eslint-disable-next-line import/prefer-default-export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>DEFAULT_LOCALE);
var DEFAULT_LOCALE = "en-US";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SB0y":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var messages = {
    dev_app: {
        error: "Unable to process the request.",
        title: "Help",
        video: "Your browser does not support HTML video."
    }
};
exports.default = {
    messages: messages
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lhkE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var flattenObject = function(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return Object.keys(obj).reduce(function(acc, key) {
        var nestedPath = prefix.length ? "".concat(prefix, ".") : "";
        if (typeof obj[key] === "object") Object.assign(acc, flattenObject(obj[key], nestedPath + key));
        else acc[nestedPath + key] = obj[key];
        return acc;
    }, {});
};
exports.default = flattenObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gMWMA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexCss = require("../styles/index.css");
var _reactRouter = require("react-router");
var _useRouteWithAuthZMiddleware = require("@amzn/carrierlogistics-commons/dist/middlewares/useRouteWithAuthZMiddleware");
var _useRouteWithAuthZMiddlewareDefault = parcelHelpers.interopDefault(_useRouteWithAuthZMiddleware);
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _layout = require("../containers/Layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _externalPassportUIConstants = require("../constants/externalPassportUIConstants");
var _getSettings = require("../utils/auth/getSettings");
var _getSettingsDefault = parcelHelpers.interopDefault(_getSettings);
var _cookieUtils = require("../utils/cookieUtils");
var _window = require("../utils/window");
var _windowDefault = parcelHelpers.interopDefault(_window);
var _authorizedPageUtils = require("../utils/authorizedPageUtils");
var _sideMenuNavItems = require("../config/sideMenuNavItems");
var _navigationalRoutes = require("../config/navigationalRoutes");
var _nonSignedInPageRoutes = require("../config/nonSignedInPageRoutes");
var _env = require("../config/env");
const App = ()=>{
    const history = (0, _reactRouter.useHistory)();
    const { isLoading, isAuthorized } = (0, _useRouteWithAuthZMiddlewareDefault.default)((0, _authorizedPageUtils.isAuthorizedPage), (0, _sideMenuNavItems.sideNavItemsExternal), (0, _nonSignedInPageRoutes.exceptedAuthorizedPages));
    const isUnAuthorizedAccess = !isLoading && !isAuthorized;
    const site = history.location.search.split(`${(0, _externalPassportUIConstants.SITE_QUERY_PARAM)}=`)[1];
    (0, _react.useEffect)(()=>{
        (0, _getSettingsDefault.default)().then(({ devSiteCookies })=>{
            if (!devSiteCookies || !site) return;
            (0, _cookieUtils.setCookie)((0, _externalPassportUIConstants.MONS_OVERRIDE_COOKIE), devSiteCookies[site]);
            history.push({
                search: ""
            });
            (0, _windowDefault.default).location.reload();
        // once cookie is updated should also
        // reload the page to get the page from the desired UI bucket
        });
    }, [
        site,
        history
    ]);
    (0, _react.useEffect)(()=>{
        if (isUnAuthorizedAccess) history.push((0, _navigationalRoutes.LANDING_PAGE));
    }, [
        history,
        isUnAuthorizedAccess
    ]);
    (0, _react.useEffect)(()=>{
        if (!(0, _env.isLocal)()) (0, _getSettingsDefault.default)().then(({ rumUIParams })=>{
            (0, _cloudwatchRum.initializeAWSRum)(rumUIParams);
        });
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layoutDefault.default), {
        isLoading: isLoading
    });
};
exports.default = App;

},{"react":"6uln9","../styles/index.css":"bnaDs","react-router":"i3TiW","@amzn/carrierlogistics-commons/dist/middlewares/useRouteWithAuthZMiddleware":"4RJCI","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","../containers/Layout":"9KpGA","../constants/externalPassportUIConstants":"gaxjj","../utils/auth/getSettings":"4BUv4","../utils/cookieUtils":"4RW9j","../utils/window":"4IKui","../utils/authorizedPageUtils":"8Nt2u","../config/sideMenuNavItems":"cekZL","../config/navigationalRoutes":"32s8M","../config/nonSignedInPageRoutes":"6YOyO","../config/env":"318XE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnaDs":[function() {},{}],"4RJCI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lodash = require("lodash");
var _reactRouter = require("react-router");
var _useTermAccessRights = require("../hooks/authorisation/useTermAccessRights");
var _useAuthorisedEntities = require("../hooks/authorisation/useAuthorisedEntities");
var _findTermFromPath = require("../utils/findTermFromPath");
var _findTermFromPathDefault = parcelHelpers.interopDefault(_findTermFromPath);
function useRouteWithAuthZMiddleware(isAuthorizedPage, config) {
    var exceptedAuthorizedPages = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var pathname = (0, _reactRouter.useLocation)().pathname;
    var term = (0, _findTermFromPathDefault.default)(config, pathname);
    var authorizedEntities = (0, _useAuthorisedEntities.useAuthorisedEntities)();
    var ref;
    var hasTermAccess = (0, _useTermAccessRights.useTermAccessRights)((ref = term === null || term === void 0 ? void 0 : term.pamPermKey) !== null && ref !== void 0 ? ref : "");
    var isExceptedPage = exceptedAuthorizedPages.some(function(path) {
        var match = (0, _reactRouter.matchPath)(pathname, {
            path: path
        });
        return (match === null || match === void 0 ? void 0 : match.path) === path || pathname.includes(path);
    });
    if (!isAuthorizedPage(pathname) || isExceptedPage) return {
        isAuthorized: true,
        isLoading: false
    };
    return {
        isLoading: (0, _lodash.isEmpty)(authorizedEntities),
        isAuthorized: !(0, _lodash.isEmpty)(hasTermAccess)
    };
}
exports.default = useRouteWithAuthZMiddleware;

},{"lodash":"6KT6f","react-router":"i3TiW","../hooks/authorisation/useTermAccessRights":"c64aJ","../hooks/authorisation/useAuthorisedEntities":"8sDqO","../utils/findTermFromPath":"hi0s1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KT6f":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"c64aJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTermAccessRights", ()=>useTermAccessRights);
var _useAuthorisedEntities = require("./useAuthorisedEntities");
var _useAuthorisedEntitiesDefault = parcelHelpers.interopDefault(_useAuthorisedEntities);
var _useLpAccessRights = require("./useLpAccessRights");
var _useLpAccessRightsDefault = parcelHelpers.interopDefault(_useLpAccessRights);
function useTermAccessRights(termKey) {
    var authorizedEntities = (0, _useAuthorisedEntitiesDefault.default)();
    var ref = (0, _useLpAccessRightsDefault.default)(), hasAccessRights = ref.hasAccessRights, hasAdminRights = ref.hasAdminRights;
    if (!termKey) return [];
    var ref1;
    if (hasAccessRights || hasAdminRights) return (ref1 = authorizedEntities === null || authorizedEntities === void 0 ? void 0 : authorizedEntities[termKey]) !== null && ref1 !== void 0 ? ref1 : [];
    return [];
}
exports.default = useTermAccessRights;

},{"./useAuthorisedEntities":"8sDqO","./useLpAccessRights":"jqrBt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8sDqO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorisedEntities", ()=>useAuthorisedEntities);
var _useLogisticParties = require("./useLogisticParties");
var _useLogisticPartiesDefault = parcelHelpers.interopDefault(_useLogisticParties);
function useAuthorisedEntities() {
    var logisticParties = (0, _useLogisticPartiesDefault.default)();
    return logisticParties === null || logisticParties === void 0 ? void 0 : logisticParties.authorizedEntities;
}
exports.default = useAuthorisedEntities;

},{"./useLogisticParties":"hp4T8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hp4T8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLogisticParties", ()=>useLogisticParties);
var _react = require("react");
var _carrierLogisticsCommonsContext = require("../../context/CarrierLogisticsCommonsContext");
var _carrierLogisticsCommonsContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsContext);
function useLogisticParties() {
    var carrierLogisticsCommons = (0, _react.useContext)((0, _carrierLogisticsCommonsContextDefault.default));
    return carrierLogisticsCommons === null || carrierLogisticsCommons === void 0 ? void 0 : carrierLogisticsCommons.lps;
}
exports.default = useLogisticParties;

},{"react":"6uln9","../../context/CarrierLogisticsCommonsContext":"kTkCE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqrBt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLpAccessRights", ()=>useLpAccessRights);
var _authorization = require("../../constants/authorization");
var _useAuthorisedEntities = require("./useAuthorisedEntities");
var _useAuthorisedEntitiesDefault = parcelHelpers.interopDefault(_useAuthorisedEntities);
var _useSelectedLp = require("./useSelectedLp");
var _useSelectedLpDefault = parcelHelpers.interopDefault(_useSelectedLp);
function useLpAccessRights() {
    var authorizedEntities = (0, _useAuthorisedEntitiesDefault.default)();
    var lpSelected = (0, _useSelectedLpDefault.default)();
    var rights = authorizedEntities === null || authorizedEntities === void 0 ? void 0 : authorizedEntities[lpSelected === null || lpSelected === void 0 ? void 0 : lpSelected.lpId];
    return {
        hasAdminRights: rights === null || rights === void 0 ? void 0 : rights.includes((0, _authorization.AUTHORIZATION).ADMIN),
        hasAccessRights: rights === null || rights === void 0 ? void 0 : rights.includes((0, _authorization.AUTHORIZATION).ACCESS)
    };
}
exports.default = useLpAccessRights;

},{"../../constants/authorization":"hG17f","./useAuthorisedEntities":"8sDqO","./useSelectedLp":"hA2Nq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hG17f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTHORIZATION", ()=>AUTHORIZATION);
var AUTHORIZATION = {
    ADMIN: "ADMIN",
    ACCESS: "ACCESS"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hA2Nq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelectedLp", ()=>useSelectedLp);
var _useLogisticParties = require("./useLogisticParties");
var _useLogisticPartiesDefault = parcelHelpers.interopDefault(_useLogisticParties);
function useSelectedLp() {
    var logisticParties = (0, _useLogisticPartiesDefault.default)();
    return logisticParties === null || logisticParties === void 0 ? void 0 : logisticParties.lpSelected;
}
exports.default = useSelectedLp;

},{"./useLogisticParties":"hp4T8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hi0s1":[function(require,module,exports) {
/* eslint-disable no-restricted-syntax */ /**
 * This function finds the term from provided path
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const findTermFromPath = (termList, pathName)=>{
    for (const term of termList){
        if (pathName.includes(term.link)) return term;
        if (term.childNodes) {
            const filteredTerm = findTermFromPath(term.childNodes, pathName);
            if (filteredTerm) return filteredTerm;
        }
    }
    return undefined;
};
exports.default = findTermFromPath;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ViCX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeAWSRum", ()=>initializeAWSRum);
parcelHelpers.export(exports, "getAWSRumInstance", ()=>getAWSRumInstance);
parcelHelpers.export(exports, "recordErrorInCloudWatchRUM", ()=>recordErrorInCloudWatchRUM);
parcelHelpers.export(exports, "recordCustomEventInCloudWatchRUM", ()=>recordCustomEventInCloudWatchRUM);
parcelHelpers.export(exports, "setCustomSessionProperties", ()=>setCustomSessionProperties);
var _awsRumWeb = require("aws-rum-web");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var awsRum = null;
function initializeAWSRum(rumUIParams) {
    try {
        var APPLICATION_ID = rumUIParams.APPLICATION_ID, APPLICATION_VERSION = rumUIParams.APPLICATION_VERSION, APPLICATION_REGION = rumUIParams.APPLICATION_REGION, config = rumUIParams.config;
        awsRum = new (0, _awsRumWeb.AwsRum)(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
    } catch (error) {
    // Rum initialisation is failed
    }
    return awsRum;
}
function getAWSRumInstance(rumUIParams) {
    return _getAWSRumInstance.apply(this, arguments);
}
function _getAWSRumInstance() {
    _getAWSRumInstance = _asyncToGenerator(function(rumUIParams) {
        return __generator(this, function(_state) {
            if (awsRum) return [
                2,
                awsRum
            ];
            if (rumUIParams) awsRum = initializeAWSRum(rumUIParams);
            return [
                2,
                awsRum
            ];
        });
    });
    return _getAWSRumInstance.apply(this, arguments);
}
function recordErrorInCloudWatchRUM(message) {
    getAWSRumInstance().then(function(awsRum) {
        if (awsRum) {
            var ref;
            (ref = awsRum.recordError) === null || ref === void 0 || ref.call(awsRum, message);
        }
    });
}
function recordCustomEventInCloudWatchRUM(eventName, eventProperties) {
    getAWSRumInstance().then(function(awsRum) {
        if (awsRum) {
            var ref;
            awsRum === null || awsRum === void 0 || (ref = awsRum.recordEvent) === null || ref === void 0 || ref.call(awsRum, eventName, _objectSpread({
                view_properties: {
                    page: window.location.pathname
                }
            }, eventProperties));
        }
    });
}
function setCustomSessionProperties(customSessionProperties, rumUIParams) {
    getAWSRumInstance(rumUIParams).then(function(awsRum) {
        if (awsRum) {
            var ref;
            (ref = awsRum.addSessionAttributes) === null || ref === void 0 || ref.call(awsRum, customSessionProperties);
        }
    });
}
exports.default = getAWSRumInstance;

},{"aws-rum-web":"kInHo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kInHo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AwsRum", ()=>(0, _orchestration.Orchestration));
parcelHelpers.export(exports, "PageIdFormatEnum", ()=>(0, _orchestration.PageIdFormatEnum));
parcelHelpers.export(exports, "TelemetryEnum", ()=>(0, _orchestration.TelemetryEnum));
var _orchestration = require("./orchestration/Orchestration");
var _domEventPlugin = require("./plugins/event-plugins/DomEventPlugin");
parcelHelpers.exportAll(_domEventPlugin, exports);
var _jsErrorPlugin = require("./plugins/event-plugins/JsErrorPlugin");
parcelHelpers.exportAll(_jsErrorPlugin, exports);
var _navigationPlugin = require("./plugins/event-plugins/NavigationPlugin");
parcelHelpers.exportAll(_navigationPlugin, exports);
var _pageViewPlugin = require("./plugins/event-plugins/PageViewPlugin");
parcelHelpers.exportAll(_pageViewPlugin, exports);
var _resourcePlugin = require("./plugins/event-plugins/ResourcePlugin");
parcelHelpers.exportAll(_resourcePlugin, exports);
var _webVitalsPlugin = require("./plugins/event-plugins/WebVitalsPlugin");
parcelHelpers.exportAll(_webVitalsPlugin, exports);
var _fetchPlugin = require("./plugins/event-plugins/FetchPlugin");
parcelHelpers.exportAll(_fetchPlugin, exports);
var _xhrPlugin = require("./plugins/event-plugins/XhrPlugin");
parcelHelpers.exportAll(_xhrPlugin, exports);

},{"./orchestration/Orchestration":"7WQDS","./plugins/event-plugins/DomEventPlugin":false,"./plugins/event-plugins/JsErrorPlugin":false,"./plugins/event-plugins/NavigationPlugin":false,"./plugins/event-plugins/PageViewPlugin":false,"./plugins/event-plugins/ResourcePlugin":false,"./plugins/event-plugins/WebVitalsPlugin":false,"./plugins/event-plugins/FetchPlugin":false,"./plugins/event-plugins/XhrPlugin":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WQDS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TelemetryEnum", ()=>TelemetryEnum);
parcelHelpers.export(exports, "PageIdFormatEnum", ()=>PageIdFormatEnum);
parcelHelpers.export(exports, "defaultCookieAttributes", ()=>defaultCookieAttributes);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "Orchestration", ()=>Orchestration);
var _authentication = require("../dispatch/Authentication");
var _enhancedAuthentication = require("../dispatch/EnhancedAuthentication");
var _pluginManager = require("../plugins/PluginManager");
var _domEventPlugin = require("../plugins/event-plugins/DomEventPlugin");
var _jsErrorPlugin = require("../plugins/event-plugins/JsErrorPlugin");
var _eventCache = require("../event-cache/EventCache");
var _dispatch = require("../dispatch/Dispatch");
var _navigationPlugin = require("../plugins/event-plugins/NavigationPlugin");
var _resourcePlugin = require("../plugins/event-plugins/ResourcePlugin");
var _webVitalsPlugin = require("../plugins/event-plugins/WebVitalsPlugin");
var _xhrPlugin = require("../plugins/event-plugins/XhrPlugin");
var _fetchPlugin = require("../plugins/event-plugins/FetchPlugin");
var _pageViewPlugin = require("../plugins/event-plugins/PageViewPlugin");
var _constants = require("../utils/constants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var DEFAULT_REGION = "us-west-2";
var DEFAULT_ENDPOINT = "https://dataplane.rum.".concat(DEFAULT_REGION, ".amazonaws.com");
var TelemetryEnum;
(function(TelemetryEnum) {
    TelemetryEnum["Errors"] = "errors";
    TelemetryEnum["Performance"] = "performance";
    TelemetryEnum["Interaction"] = "interaction";
    TelemetryEnum["Http"] = "http";
})(TelemetryEnum || (TelemetryEnum = {}));
var PageIdFormatEnum;
(function(PageIdFormatEnum) {
    PageIdFormatEnum["Path"] = "PATH";
    PageIdFormatEnum["Hash"] = "HASH";
    PageIdFormatEnum["PathAndHash"] = "PATH_AND_HASH";
})(PageIdFormatEnum || (PageIdFormatEnum = {}));
var defaultCookieAttributes = function() {
    return {
        unique: false,
        domain: window.location.hostname,
        path: "/",
        sameSite: "Strict",
        secure: true
    };
};
var defaultConfig = function(cookieAttributes) {
    return {
        allowCookies: false,
        batchLimit: 100,
        client: (0, _constants.INSTALL_MODULE),
        cookieAttributes: cookieAttributes,
        disableAutoPageView: false,
        dispatchInterval: 5000,
        enableRumClient: true,
        enableXRay: false,
        endpoint: DEFAULT_ENDPOINT,
        endpointUrl: new URL(DEFAULT_ENDPOINT),
        eventCacheSize: 200,
        eventPluginsToLoad: [],
        pageIdFormat: PageIdFormatEnum.Path,
        pagesToExclude: [],
        pagesToInclude: [
            /.*/
        ],
        signing: true,
        recordResourceUrl: true,
        retries: 2,
        routeChangeComplete: 100,
        routeChangeTimeout: 10000,
        sessionAttributes: {},
        sessionEventLimit: 200,
        sessionLengthSeconds: 1800,
        sessionSampleRate: 1,
        telemetries: [],
        useBeacon: true,
        userIdRetentionDays: 30
    };
};
/**
 * An orchestrator which (1) initializes cwr components and (2) provides the API for the application to interact
 * with the RUM web client. Depending on how the RUM web client was loaded, this class may be called directly, or
 * indirectly through the CommandQueue:
 * - If the client was loaded by an HTML script tag, Orchestration is called indirectly through the CommandQueue.
 * - If the client was loaded as an NPM module, Orchestration is called directly by the application.
 */ var Orchestration = /** @class */ function() {
    /**
     * Instantiate the CloudWatch RUM web client and begin monitoring the
     * application.
     *
     * This constructor may throw a TypeError if not correctly configured. In
     * production code, wrap calls to this constructor in a try/catch block so
     * that this does not impact the application.
     *
     * @param applicationId A globally unique identifier for the CloudWatch RUM
     * app monitor which monitors your application.
     * @param applicationVersion Your application's semantic version. If you do
     * not wish to use this field then add any placeholder, such as '0.0.0'.
     * @param region The AWS region of the app monitor. For example, 'us-east-1'
     * or 'eu-west-2'.
     * @param configCookieAttributes
     * @param partialConfig An application-specific configuration for the web
     * client.
     */ function Orchestration(applicationId, applicationVersion, region, _a) {
        if (_a === void 0) _a = {};
        var configCookieAttributes = _a.cookieAttributes, partialConfig = __rest(_a, [
            "cookieAttributes"
        ]);
        if (typeof region === "undefined") // Provide temporary backwards compatibility if the region was not provided by the loader. This will be
        // removed when internal users have migrated to the new signature.
        region = "us-west-2";
        var cookieAttributes = __assign(__assign({}, defaultCookieAttributes()), configCookieAttributes);
        this.config = __assign(__assign({
            fetchFunction: fetch
        }, defaultConfig(cookieAttributes)), partialConfig);
        this.config.endpoint = this.getDataPlaneEndpoint(region, partialConfig);
        // If the URL is not formatted correctly, a TypeError will be thrown.
        // This breaks our convention to fail-safe here for the sake of
        // debugging. It is expected that the application has wrapped the call
        // to the constructor in a try/catch block, as is done in the example
        // code.
        this.config.endpointUrl = new URL(this.config.endpoint);
        this.eventCache = this.initEventCache(applicationId, applicationVersion);
        this.dispatchManager = this.initDispatch(region);
        this.pluginManager = this.initPluginManager(applicationId, applicationVersion);
        if (this.config.enableRumClient) this.enable();
        else this.disable();
    }
    /**
     * Set the credential provider that will be used to authenticate with the
     * data plane service (AWS auth).
     *
     * @param credentials A provider of AWS credentials.
     */ Orchestration.prototype.setAwsCredentials = function(credentials) {
        this.dispatchManager.setAwsCredentials(credentials);
    };
    /**
     * Set custom session attributes to add them to all event metadata.
     *
     * @param payload object containing custom attribute data in the form of key, value pairs
     */ Orchestration.prototype.addSessionAttributes = function(sessionAttributes) {
        this.eventCache.addSessionAttributes(sessionAttributes);
    };
    /**
     * Add a telemetry plugin.
     *
     * @param plugin A plugin which adheres to the RUM web client's plugin interface.
     */ Orchestration.prototype.addPlugin = function(plugin) {
        this.pluginManager.addPlugin(plugin);
    };
    /**
     * Force the client to immediately dispatch events to the collector.
     */ Orchestration.prototype.dispatch = function() {
        this.dispatchManager.dispatchFetch();
    };
    /**
     * Force the client to immediately dispatch events to the collector using a beacon.
     */ Orchestration.prototype.dispatchBeacon = function() {
        this.dispatchManager.dispatchBeacon();
    };
    /**
     * When enabled, the client records and dispatches events.
     */ Orchestration.prototype.enable = function() {
        this.eventCache.enable();
        this.pluginManager.enable();
        this.dispatchManager.enable();
    };
    /**
     * When disabled, the client does not record or dispatch events.
     */ Orchestration.prototype.disable = function() {
        this.dispatchManager.disable();
        this.pluginManager.disable();
        this.eventCache.disable();
    };
    /**
     * @param allow when {@code false}, the RUM web client will not store cookies or use localstorage.
     */ Orchestration.prototype.allowCookies = function(allow) {
        this.config.allowCookies = allow;
    };
    /**
     * Update the current page the user is interacting with.
     *
     * @param payload Can be string or PageAttributes object
     * If string, payload is pageId (The unique ID for the page within the application).
     * If PageAttributes, payload contains pageId as well as page attributes to include in events with pageId
     */ Orchestration.prototype.recordPageView = function(payload) {
        this.eventCache.recordPageView(payload);
    };
    /**
     * Record an error using the JS error plugin.
     *
     * @param error An ErrorEvent, Error or primitive.
     */ Orchestration.prototype.recordError = function(error) {
        this.pluginManager.record((0, _jsErrorPlugin.JS_ERROR_EVENT_PLUGIN_ID), error);
    };
    /**
     * Update DOM plugin to record the (additional) provided DOM events.
     *
     * @param events
     */ Orchestration.prototype.registerDomEvents = function(events) {
        this.pluginManager.updatePlugin((0, _domEventPlugin.DOM_EVENT_PLUGIN_ID), events);
    };
    /**
     * Records a custom event.
     *
     * @param type A unique name for the type of event being recorded.
     * @param eventData A JSON object containing the event's attributes.
     */ Orchestration.prototype.recordEvent = function(eventType, eventData) {
        this.eventCache.recordEvent(eventType, eventData);
    };
    Orchestration.prototype.initEventCache = function(applicationId, applicationVersion) {
        return new (0, _eventCache.EventCache)({
            id: applicationId,
            version: applicationVersion
        }, this.config);
    };
    Orchestration.prototype.initDispatch = function(region) {
        var dispatch = new (0, _dispatch.Dispatch)(region, this.config.endpointUrl, this.eventCache, this.config);
        if (this.config.identityPoolId && this.config.guestRoleArn) dispatch.setAwsCredentials(new (0, _authentication.Authentication)(this.config).ChainAnonymousCredentialsProvider);
        else if (this.config.identityPoolId) dispatch.setAwsCredentials(new (0, _enhancedAuthentication.EnhancedAuthentication)(this.config).ChainAnonymousCredentialsProvider);
        return dispatch;
    };
    Orchestration.prototype.initPluginManager = function(applicationId, applicationVersion) {
        var BUILTIN_PLUGINS = this.constructBuiltinPlugins();
        var PLUGINS = __spreadArray(__spreadArray([], BUILTIN_PLUGINS, true), this.config.eventPluginsToLoad, true);
        var pluginContext = {
            applicationId: applicationId,
            applicationVersion: applicationVersion,
            config: this.config,
            record: this.eventCache.recordEvent,
            recordPageView: this.eventCache.recordPageView,
            getSession: this.eventCache.getSession
        };
        // Initialize PluginManager
        var pluginManager = new (0, _pluginManager.PluginManager)(pluginContext);
        // Load page view plugin
        if (!this.config.disableAutoPageView) pluginManager.addPlugin(new (0, _pageViewPlugin.PageViewPlugin)());
        // Load plugins
        PLUGINS.forEach(function(p) {
            pluginManager.addPlugin(p);
        });
        return pluginManager;
    };
    Orchestration.prototype.constructBuiltinPlugins = function() {
        var plugins = [];
        var functor = this.telemetryFunctor();
        this.config.telemetries.forEach(function(type) {
            if (typeof type === "string" && functor[type.toLowerCase()]) plugins = __spreadArray(__spreadArray([], plugins, true), functor[type.toLowerCase()]({}), true);
            else if (Array.isArray(type) && functor[type[0].toLowerCase()]) plugins = __spreadArray(__spreadArray([], plugins, true), functor[type[0].toLowerCase()](type[1]), true);
        });
        return plugins;
    };
    Orchestration.prototype.getDataPlaneEndpoint = function(region, partialConfig) {
        return partialConfig.endpoint ? partialConfig.endpoint : DEFAULT_ENDPOINT.replace(DEFAULT_REGION, region);
    };
    /**
     * Returns a functor which maps data collection categories to
     * instantiated plugins.
     */ Orchestration.prototype.telemetryFunctor = function() {
        var _a;
        return _a = {}, _a[TelemetryEnum.Errors] = function(config) {
            return [
                new (0, _jsErrorPlugin.JsErrorPlugin)(config)
            ];
        }, _a[TelemetryEnum.Performance] = function(config) {
            return [
                new (0, _navigationPlugin.NavigationPlugin)(config),
                new (0, _resourcePlugin.ResourcePlugin)(config),
                new (0, _webVitalsPlugin.WebVitalsPlugin)()
            ];
        }, _a[TelemetryEnum.Interaction] = function(config) {
            return [
                new (0, _domEventPlugin.DomEventPlugin)(config)
            ];
        }, _a[TelemetryEnum.Http] = function(config) {
            return [
                new (0, _xhrPlugin.XhrPlugin)(config),
                new (0, _fetchPlugin.FetchPlugin)(config)
            ];
        }, _a;
    };
    return Orchestration;
}();

},{"../dispatch/Authentication":"kC4sF","../dispatch/EnhancedAuthentication":"lzrP1","../plugins/PluginManager":"geUSX","../plugins/event-plugins/DomEventPlugin":"k2Foz","../plugins/event-plugins/JsErrorPlugin":"3RRFn","../event-cache/EventCache":"5Jqpe","../dispatch/Dispatch":"jStFc","../plugins/event-plugins/NavigationPlugin":"6lQiC","../plugins/event-plugins/ResourcePlugin":"1BSZE","../plugins/event-plugins/WebVitalsPlugin":"1da0w","../plugins/event-plugins/XhrPlugin":"2458V","../plugins/event-plugins/FetchPlugin":"fVkpt","../plugins/event-plugins/PageViewPlugin":"81fOo","../utils/constants":"7RiXG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kC4sF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Authentication", ()=>Authentication);
var _cognitoIdentityClient = require("./CognitoIdentityClient");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _stsClient = require("./StsClient");
var _constants = require("../utils/constants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var Authentication = /** @class */ function() {
    function Authentication(config) {
        var _this = this;
        /**
         * A credential provider which provides AWS credentials for an anonymous
         * (guest) user. These credentials are retrieved from the first successful
         * provider in a chain.
         *
         * Credentials are stored in and retrieved from localStorage. This prevents the client from having to
         * re-authenticate every time the client loads, which (1) improves the performance of the RUM web client and (2)
         * reduces the load on AWS services Cognito and STS.
         *
         * While storing credentials in localStorage puts the cookie at greater risk of being leaked through an
         * XSS attack, there is no impact if the credentials were to be leaked. This is because (1) the identity pool ID
         * and role ARN are public and (2) the credentials are for an anonymous (guest) user.
         *
         * Regarding (1), the identity pool ID and role ARN are, by necessity, public. These identifiers are shipped with
         * each application as part of Cognito's Basic (Classic) authentication flow. The identity pool ID and role ARN
         * are not secret.
         *
         * Regarding (2), the authentication chain implemented in this file only supports anonymous (guest)
         * authentication. When the Cognito authentication flow is executed, {@code AnonymousCognitoCredentialsProvider}
         * does not communicate with a login provider such as Amazon, Facebook or Google. Instead, it relies on (a) the
         * identity pool supporting unauthenticated identities and (b) the IAM role policy enabling login through the
         * identity pool. If the identity pool does not support unauthenticated identities, this authentication chain
         * will not succeed.
         *
         * Taken together, (1) and (2) mean that if these temporary credentials were to be leaked, the leaked credentials
         * would not allow a bad actor to gain access to anything which they did not already have public access to.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.ChainAnonymousCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.AnonymousCredentialsProvider().catch(this.AnonymousStorageCredentialsProvider).catch(this.AnonymousCognitoCredentialsProvider)
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from a member variable.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            resolve(_this.credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from localStorage.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousStorageCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var credentials;
                            try {
                                credentials = JSON.parse(localStorage.getItem((0, _constants.CRED_KEY)));
                            } catch (e) {
                                // Error retrieving, decoding or parsing the cred string -- abort
                                return reject();
                            }
                            // The expiration property of Credentials has a date type. Because the date was serialized as a string,
                            // we need to convert it back into a date, otherwise the AWS SDK signing middleware
                            // (@aws-sdk/middleware-signing) will throw an exception and no credentials will be returned.
                            _this.credentials = __assign(__assign({}, credentials), {
                                expiration: new Date(credentials.expiration)
                            });
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            _this.credentials = credentials;
                            resolve(credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are retrieved from Cognito's basic
         * (classic) authflow.
         *
         * See https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCognitoCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.cognitoIdentityClient.getId({
                            IdentityPoolId: this.config.identityPoolId
                        }).then(function(getIdResponse) {
                            return _this.cognitoIdentityClient.getOpenIdToken(getIdResponse);
                        }).then(function(getOpenIdTokenResponse) {
                            return _this.stsClient.assumeRoleWithWebIdentity({
                                RoleArn: _this.config.guestRoleArn,
                                RoleSessionName: "cwr",
                                WebIdentityToken: getOpenIdTokenResponse.Token
                            });
                        }).then(function(credentials) {
                            _this.credentials = credentials;
                            try {
                                localStorage.setItem((0, _constants.CRED_KEY), JSON.stringify(credentials));
                            } catch (e) {
                            // Ignore
                            }
                            return credentials;
                        })
                    ];
                });
            });
        };
        var region = config.identityPoolId.split(":")[0];
        this.config = config;
        this.stsClient = new (0, _stsClient.StsClient)({
            fetchRequestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
            region: region
        });
        this.cognitoIdentityClient = new (0, _cognitoIdentityClient.CognitoIdentityClient)({
            fetchRequestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
            region: region
        });
    }
    Authentication.prototype.renewCredentials = function() {
        if (!this.credentials || !this.credentials.expiration) return true;
        var renewalTime = new Date(this.credentials.expiration.getTime() - (0, _constants.CRED_RENEW_MS));
        return new Date() > renewalTime;
    };
    return Authentication;
}();

},{"./CognitoIdentityClient":"ebbej","@aws-sdk/fetch-http-handler":"jjn4j","./StsClient":"hduZN","../utils/constants":"7RiXG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ebbej":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromCognitoIdentityPool", ()=>fromCognitoIdentityPool);
parcelHelpers.export(exports, "CognitoIdentityClient", ()=>CognitoIdentityClient);
var _protocolHttp = require("@aws-sdk/protocol-http");
var _utils = require("./utils");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var METHOD = "POST";
var CONTENT_TYPE = "application/x-amz-json-1.1";
var PROTOCOL = "https:";
// Targets
var GET_ID_TARGET = "AWSCognitoIdentityService.GetId";
var GET_TOKEN_TARGET = "AWSCognitoIdentityService.GetOpenIdToken";
var GET_CREDENTIALS_TARGET = "AWSCognitoIdentityService.GetCredentialsForIdentity";
var fromCognitoIdentityPool = function(params) {
    return function() {
        return params.client.getCredentialsForIdentity(params.identityPoolId);
    };
};
var CognitoIdentityClient = /** @class */ function() {
    function CognitoIdentityClient(config) {
        var _this = this;
        this.getId = function(request) {
            return __awaiter(_this, void 0, void 0, function() {
                var requestPayload, idRequest, response, e_1;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestPayload = JSON.stringify(request);
                            idRequest = this.getHttpRequest(GET_ID_TARGET, requestPayload);
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(idRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, _utils.responseToJson)(response)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            e_1 = _a.sent();
                            throw new Error("CWR: Failed to retrieve Cognito identity: ".concat(e_1));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getOpenIdToken = function(request) {
            return __awaiter(_this, void 0, void 0, function() {
                var requestPayload, tokenRequest, response, e_2;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestPayload = JSON.stringify(request);
                            tokenRequest = this.getHttpRequest(GET_TOKEN_TARGET, requestPayload);
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(tokenRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, _utils.responseToJson)(response)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            e_2 = _a.sent();
                            throw new Error("CWR: Failed to retrieve Cognito OpenId token: ".concat(e_2));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getCredentialsForIdentity = function(identityId) {
            return __awaiter(_this, void 0, void 0, function() {
                var requestPayload, credentialRequest, response, Credentials, AccessKeyId, Expiration, SecretAccessKey, SessionToken, e_3;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestPayload = JSON.stringify({
                                IdentityId: identityId
                            });
                            credentialRequest = this.getHttpRequest(GET_CREDENTIALS_TARGET, requestPayload);
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(credentialRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, _utils.responseToJson)(response)
                            ];
                        case 2:
                            Credentials = _a.sent().Credentials;
                            AccessKeyId = Credentials.AccessKeyId, Expiration = Credentials.Expiration, SecretAccessKey = Credentials.SecretAccessKey, SessionToken = Credentials.SessionToken;
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretAccessKey,
                                    sessionToken: SessionToken,
                                    expiration: new Date(Expiration * 1000)
                                }
                            ];
                        case 3:
                            e_3 = _a.sent();
                            throw new Error("CWR: Failed to retrieve credentials for Cognito identity: ".concat(e_3));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getHttpRequest = function(target, payload) {
            return new (0, _protocolHttp.HttpRequest)({
                method: METHOD,
                headers: {
                    "content-type": CONTENT_TYPE,
                    "x-amz-target": target
                },
                protocol: PROTOCOL,
                hostname: _this.hostname,
                body: payload
            });
        };
        this.hostname = "cognito-identity.".concat(config.region, ".amazonaws.com");
        this.fetchRequestHandler = config.fetchRequestHandler;
    }
    return CognitoIdentityClient;
}();

},{"@aws-sdk/protocol-http":"adaIv","./utils":"bgsat","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"adaIv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _field = require("./Field");
parcelHelpers.exportAll(_field, exports);
var _fieldPosition = require("./FieldPosition");
parcelHelpers.exportAll(_fieldPosition, exports);
var _fields = require("./Fields");
parcelHelpers.exportAll(_fields, exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./Field":"hRghB","./FieldPosition":"2nMFo","./Fields":"guUV7","./httpHandler":"jhciF","./httpRequest":"ar6fZ","./httpResponse":"5a5JR","./isValidHostname":"7B1oo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hRghB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Field", ()=>Field);
var _fieldPosition = require("./FieldPosition");
class Field {
    constructor({ name, kind = (0, _fieldPosition.FieldPosition).HEADER, values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}

},{"./FieldPosition":"2nMFo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nMFo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldPosition", ()=>FieldPosition);
var FieldPosition;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})(FieldPosition || (FieldPosition = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"guUV7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fields", ()=>Fields);
class Fields {
    constructor({ fields = [], encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jhciF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ar6fZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
class HttpRequest {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        const cloned = new HttpRequest({
            ...this,
            headers: {
                ...this.headers
            }
        });
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    }
}
function cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5a5JR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
class HttpResponse {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7B1oo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bgsat":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "responseToJson", ()=>responseToJson);
parcelHelpers.export(exports, "responseToString", ()=>responseToString);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var responseToJson = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var value;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.body.getReader().read()
                    ];
                case 1:
                    value = _a.sent().value;
                    return [
                        2 /*return*/ ,
                        JSON.parse(String.fromCharCode.apply(null, value))
                    ];
            }
        });
    });
};
var responseToString = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var value;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.body.getReader().read()
                    ];
                case 1:
                    value = _a.sent().value;
                    return [
                        2 /*return*/ ,
                        String.fromCharCode.apply(null, value)
                    ];
            }
        });
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jjn4j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"iLUlh","./stream-collector":"jRbXC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iLUlh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
class FetchHttpHandler {
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    destroy() {}
    async handle(request, { abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, _querystringBuilder.buildQueryString)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port, method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body,
            headers: new Headers(request.headers),
            method: method
        };
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, _protocolHttp.HttpResponse)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body
                        })
                    }));
                return {
                    response: new (0, _protocolHttp.HttpResponse)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            abortSignal.onabort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    }
}

},{"@aws-sdk/protocol-http":"adaIv","@aws-sdk/querystring-builder":"kjmcN","./request-timeout":"5IGpQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kjmcN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, _utilUriEscape.escapeUri)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, _utilUriEscape.escapeUri)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, _utilUriEscape.escapeUri)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}

},{"@aws-sdk/util-uri-escape":"k6TcL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6TcL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"01XyW","./escape-uri-path":"kL7Wt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01XyW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
const escapeUri = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
const hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kL7Wt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
const escapeUriPath = (uri)=>uri.split("/").map((0, _escapeUri.escapeUri)).join("/");

},{"./escape-uri":"01XyW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5IGpQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jRbXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _utilBase64 = require("@aws-sdk/util-base64");
const streamCollector = (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
async function collectBlob(blob) {
    const base64 = await readToBase64(blob);
    const arrayBuffer = (0, _utilBase64.fromBase64)(base64);
    return new Uint8Array(arrayBuffer);
}
async function collectStream(stream) {
    let res = new Uint8Array(0);
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done, value } = await reader.read();
        if (value) {
            const prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
        }
        isDone = done;
    }
    return res;
}
function readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}

},{"@aws-sdk/util-base64":"ktPKD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktPKD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fromBase64 = require("./fromBase64");
parcelHelpers.exportAll(_fromBase64, exports);
var _toBase64 = require("./toBase64");
parcelHelpers.exportAll(_toBase64, exports);

},{"./fromBase64":"17H3u","./toBase64":"42IRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17H3u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
var _constantsBrowser = require("./constants.browser");
const fromBase64 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, _constantsBrowser.alphabetByEncoding))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, _constantsBrowser.alphabetByEncoding)[input[j]] << (limit - j) * (0, _constantsBrowser.bitsPerLetter);
            bitLength += (0, _constantsBrowser.bitsPerLetter);
        } else bits >>= (0, _constantsBrowser.bitsPerLetter);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, _constantsBrowser.bitsPerByte);
        const byteLength = Math.floor(bitLength / (0, _constantsBrowser.bitsPerByte));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, _constantsBrowser.bitsPerByte);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};

},{"./constants.browser":"bh1i8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bh1i8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alphabetByEncoding", ()=>alphabetByEncoding);
parcelHelpers.export(exports, "alphabetByValue", ()=>alphabetByValue);
parcelHelpers.export(exports, "bitsPerLetter", ()=>bitsPerLetter);
parcelHelpers.export(exports, "bitsPerByte", ()=>bitsPerByte);
parcelHelpers.export(exports, "maxLetterValue", ()=>maxLetterValue);
const alphabetByEncoding = {};
const alphabetByValue = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(let i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
const bitsPerLetter = 6;
const bitsPerByte = 8;
const maxLetterValue = 63;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"42IRI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var _constantsBrowser = require("./constants.browser");
function toBase64(input) {
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, _constantsBrowser.bitsPerByte);
            bitLength += (0, _constantsBrowser.bitsPerByte);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, _constantsBrowser.bitsPerLetter));
        bits <<= bitClusterCount * (0, _constantsBrowser.bitsPerLetter) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, _constantsBrowser.bitsPerLetter);
            str += (0, _constantsBrowser.alphabetByValue)[(bits & (0, _constantsBrowser.maxLetterValue) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"./constants.browser":"bh1i8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hduZN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StsClient", ()=>StsClient);
var _protocolHttp = require("@aws-sdk/protocol-http");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var METHOD = "POST";
var CONTENT_TYPE = "application/x-www-form-urlencoded";
var PROTOCOL = "https:";
var ACTION = "AssumeRoleWithWebIdentity";
var VERSION = "2011-06-15";
var StsClient = /** @class */ function() {
    function StsClient(config) {
        var _this = this;
        this.assumeRoleWithWebIdentity = function(request) {
            return __awaiter(_this, void 0, void 0, function() {
                var requestObject, encodedBody, STSRequest, response, xmlResponse, e_1;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestObject = __assign(__assign({}, request), {
                                Action: ACTION,
                                Version: VERSION
                            });
                            encodedBody = new URLSearchParams(Object.entries(requestObject)).toString();
                            STSRequest = new (0, _protocolHttp.HttpRequest)({
                                method: METHOD,
                                headers: {
                                    "content-type": CONTENT_TYPE,
                                    host: this.hostname
                                },
                                protocol: PROTOCOL,
                                hostname: this.hostname,
                                body: encodedBody
                            });
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(STSRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, _utils.responseToString)(response)
                            ];
                        case 2:
                            xmlResponse = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: xmlResponse.split("<AccessKeyId>")[1].split("</AccessKeyId>")[0],
                                    secretAccessKey: xmlResponse.split("<SecretAccessKey>")[1].split("</SecretAccessKey>")[0],
                                    sessionToken: xmlResponse.split("<SessionToken>")[1].split("</SessionToken>")[0],
                                    expiration: new Date(xmlResponse.split("<Expiration>")[1].split("</Expiration>")[0])
                                }
                            ];
                        case 3:
                            e_1 = _a.sent();
                            throw new Error("CWR: Failed to retrieve credentials from STS: ".concat(e_1));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.hostname = "sts.".concat(config.region, ".amazonaws.com");
        this.fetchRequestHandler = config.fetchRequestHandler;
    }
    return StsClient;
}();

},{"@aws-sdk/protocol-http":"adaIv","./utils":"bgsat","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7RiXG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRED_KEY", ()=>CRED_KEY);
parcelHelpers.export(exports, "SESSION_COOKIE_NAME", ()=>SESSION_COOKIE_NAME);
parcelHelpers.export(exports, "USER_COOKIE_NAME", ()=>USER_COOKIE_NAME);
parcelHelpers.export(exports, "CRED_RENEW_MS", ()=>CRED_RENEW_MS);
parcelHelpers.export(exports, "INSTALL_SCRIPT", ()=>INSTALL_SCRIPT);
parcelHelpers.export(exports, "INSTALL_MODULE", ()=>INSTALL_MODULE);
parcelHelpers.export(exports, "DEFAULT_PAGE_ATTRIBUTES", ()=>DEFAULT_PAGE_ATTRIBUTES);
var CRED_KEY = "cwr_c";
var SESSION_COOKIE_NAME = "cwr_s";
var USER_COOKIE_NAME = "cwr_u";
var CRED_RENEW_MS = 30000;
var INSTALL_SCRIPT = "arw-script";
var INSTALL_MODULE = "arw-module";
var DEFAULT_PAGE_ATTRIBUTES = [
    "pageId",
    "pageTags"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lzrP1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnhancedAuthentication", ()=>EnhancedAuthentication);
var _cognitoIdentityClient = require("./CognitoIdentityClient");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _constants = require("../utils/constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var EnhancedAuthentication = /** @class */ function() {
    function EnhancedAuthentication(config) {
        var _this = this;
        /**
         * A credential provider which provides AWS credentials for an anonymous
         * (guest) user. These credentials are retrieved from the first successful
         * provider in a chain.
         *
         * Credentials are stored in and retrieved from localStorage. This prevents the client from having to
         * re-authenticate every time the client loads, which (1) improves the performance of the RUM web client and (2)
         * reduces the load on AWS services Cognito and STS.
         *
         * While storing credentials in localStorage puts the credential at greater risk of being leaked through an
         * XSS attack, there is no impact if the credentials were to be leaked. This is because (1) the identity pool ID
         * and role ARN are public and (2) the credentials are for an anonymous (guest) user.
         *
         * Regarding (1), the identity pool ID and role ARN are, by necessity, public. These identifiers are shipped with
         * each application as part of Cognito's Basic (Classic) authentication flow. The identity pool ID and role ARN
         * are not secret.
         *
         * Regarding (2), the authentication chain implemented in this file only supports anonymous (guest)
         * authentication. When the Cognito authentication flow is executed, {@code AnonymousCognitoCredentialsProvider}
         * does not communicate with a login provider such as Amazon, Facebook or Google. Instead, it relies on (a) the
         * identity pool supporting unauthenticated identities and (b) the IAM role policy enabling login through the
         * identity pool. If the identity pool does not support unauthenticated identities, this authentication chain
         * will not succeed.
         *
         * Taken together, (1) and (2) mean that if these temporary credentials were to be leaked, the leaked credentials
         * would not allow a bad actor to gain access to anything which they did not already have public access to.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.ChainAnonymousCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.AnonymousCredentialsProvider().catch(this.AnonymousStorageCredentialsProvider).catch(this.AnonymousCognitoCredentialsProvider)
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from a member variable.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            resolve(_this.credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from localStorage.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousStorageCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var credentials;
                            try {
                                credentials = JSON.parse(localStorage.getItem((0, _constants.CRED_KEY)));
                            } catch (e) {
                                // Error decoding or parsing the cookie -- abort
                                reject();
                            }
                            // The expiration property of Credentials has a date type. Because the date was serialized as a string,
                            // we need to convert it back into a date, otherwise the AWS SDK signing middleware
                            // (@aws-sdk/middleware-signing) will throw an exception and no credentials will be returned.
                            credentials.expiration = new Date(credentials.expiration);
                            _this.credentials = credentials;
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            _this.credentials = credentials;
                            resolve(credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are retrieved from Cognito's enhanced
         * authflow.
         *
         * See https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCognitoCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var credentialProvider;
                var _this = this;
                return __generator(this, function(_a) {
                    credentialProvider = (0, _cognitoIdentityClient.fromCognitoIdentityPool)({
                        client: this.cognitoIdentityClient,
                        identityPoolId: this.config.identityPoolId
                    });
                    return [
                        2 /*return*/ ,
                        credentialProvider().then(function(credentials) {
                            _this.credentials = credentials;
                            try {
                                localStorage.setItem((0, _constants.CRED_KEY), JSON.stringify(credentials));
                            } catch (e) {
                            // Ignore
                            }
                            return credentials;
                        })
                    ];
                });
            });
        };
        var region = config.identityPoolId.split(":")[0];
        this.config = config;
        this.cognitoIdentityClient = new (0, _cognitoIdentityClient.CognitoIdentityClient)({
            fetchRequestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
            region: region
        });
    }
    EnhancedAuthentication.prototype.renewCredentials = function() {
        if (!this.credentials || !this.credentials.expiration) return true;
        var renewalTime = new Date(this.credentials.expiration.getTime() - (0, _constants.CRED_RENEW_MS));
        return new Date() > renewalTime;
    };
    return EnhancedAuthentication;
}();

},{"./CognitoIdentityClient":"ebbej","@aws-sdk/fetch-http-handler":"jjn4j","../utils/constants":"7RiXG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"geUSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PluginManager", ()=>PluginManager);
var _internalPlugin = require("./InternalPlugin");
/**
 * The plugin manager maintains a list of plugins
 * and notifies plugins of configuration or lifecycle changes.
 */ var PluginManager = /** @class */ function() {
    function PluginManager(context) {
        this.context = context;
        this.plugins = new Map();
    }
    /**
     * Add an event plugin to PluginManager and initialize the plugin.
     *
     * @param plugin The plugin which adheres to the RUM web client's plugin interface.
     */ PluginManager.prototype.addPlugin = function(plugin) {
        var pluginId = plugin.getPluginId();
        if (this.hasPlugin(pluginId)) throw new Error('Plugin "'.concat(pluginId, '" already defined in the PluginManager'));
        this.plugins.set(pluginId, plugin);
        // initialize plugin
        plugin.load(this.context);
    };
    /**
     * Update an event plugin
     *
     * @param pluginId
     * @param updateWith The config to update the plugin with.
     */ PluginManager.prototype.updatePlugin = function(pluginId, updateWith) {
        var _a;
        var plugin = this.getPlugin(pluginId);
        (_a = plugin === null || plugin === void 0 ? void 0 : plugin.update) === null || _a === void 0 || _a.call(plugin, updateWith);
    };
    /**
     * Enable all event plugins.
     */ PluginManager.prototype.enable = function() {
        this.plugins.forEach(function(p) {
            return p.enable();
        });
    };
    /**
     * Disable all event plugins.
     */ PluginManager.prototype.disable = function() {
        this.plugins.forEach(function(p) {
            return p.disable();
        });
    };
    /**
     * Return if a plugin exists.
     *
     * @param pluginId a unique identifier for the plugin
     */ PluginManager.prototype.hasPlugin = function(pluginId) {
        return Boolean(this.getPlugin(pluginId));
    };
    /**
     * Manually record data using a plugin.
     *
     * @param pluginId The unique identifier for the plugin being configured.
     * @param data The data to be recorded by the plugin.
     */ PluginManager.prototype.record = function(pluginId, data) {
        var plugin = this.getPlugin(pluginId);
        if ((plugin === null || plugin === void 0 ? void 0 : plugin.record) instanceof Function) plugin.record(data);
        else throw new Error("AWS RUM Client record: Invalid plugin ID");
    };
    PluginManager.prototype.getPlugin = function(id) {
        var _a;
        return (_a = this.plugins.get(id)) !== null && _a !== void 0 ? _a : this.plugins.get((0, _internalPlugin.InternalPlugin).generatePluginId(id));
    };
    return PluginManager;
}();

},{"./InternalPlugin":"78Kz0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"78Kz0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPlugin", ()=>InternalPlugin);
var _constant = require("./utils/constant");
var InternalPlugin = /** @class */ function() {
    function InternalPlugin(name) {
        this.enabled = true;
        this.pluginId = InternalPlugin.generatePluginId(name);
    }
    InternalPlugin.generatePluginId = function(name) {
        return "".concat(InternalPlugin.idPrefix, ".").concat(name);
    };
    InternalPlugin.prototype.load = function(context) {
        var _a;
        this.context = context;
        (_a = this.onload) === null || _a === void 0 || _a.call(this);
    };
    InternalPlugin.prototype.getPluginId = function() {
        return this.pluginId;
    };
    InternalPlugin.idPrefix = (0, _constant.RUM_AWS_PREFIX);
    return InternalPlugin;
}();

},{"./utils/constant":"iL2Vg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iL2Vg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNKNOWN", ()=>UNKNOWN);
parcelHelpers.export(exports, "RUM_AMZ_PREFIX", ()=>RUM_AMZ_PREFIX);
parcelHelpers.export(exports, "RUM_AWS_PREFIX", ()=>RUM_AWS_PREFIX);
parcelHelpers.export(exports, "HTTP_EVENT_TYPE", ()=>HTTP_EVENT_TYPE);
parcelHelpers.export(exports, "XRAY_TRACE_EVENT_TYPE", ()=>XRAY_TRACE_EVENT_TYPE);
parcelHelpers.export(exports, "LCP_EVENT_TYPE", ()=>LCP_EVENT_TYPE);
parcelHelpers.export(exports, "FID_EVENT_TYPE", ()=>FID_EVENT_TYPE);
parcelHelpers.export(exports, "CLS_EVENT_TYPE", ()=>CLS_EVENT_TYPE);
parcelHelpers.export(exports, "PERFORMANCE_NAVIGATION_EVENT_TYPE", ()=>PERFORMANCE_NAVIGATION_EVENT_TYPE);
parcelHelpers.export(exports, "PERFORMANCE_RESOURCE_EVENT_TYPE", ()=>PERFORMANCE_RESOURCE_EVENT_TYPE);
parcelHelpers.export(exports, "DOM_EVENT_TYPE", ()=>DOM_EVENT_TYPE);
parcelHelpers.export(exports, "JS_ERROR_EVENT_TYPE", ()=>JS_ERROR_EVENT_TYPE);
parcelHelpers.export(exports, "PAGE_VIEW_EVENT_TYPE", ()=>PAGE_VIEW_EVENT_TYPE);
parcelHelpers.export(exports, "SESSION_START_EVENT_TYPE", ()=>SESSION_START_EVENT_TYPE);
var UNKNOWN = "unknown";
var RUM_AMZ_PREFIX = "com.amazon.rum";
var RUM_AWS_PREFIX = "com.amazonaws.rum";
var HTTP_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".http_event");
var XRAY_TRACE_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".xray_trace_event");
var LCP_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".largest_contentful_paint_event");
var FID_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".first_input_delay_event");
var CLS_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".cumulative_layout_shift_event");
var PERFORMANCE_NAVIGATION_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".performance_navigation_event");
var PERFORMANCE_RESOURCE_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".performance_resource_event");
var DOM_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".dom_event");
var JS_ERROR_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".js_error_event");
var PAGE_VIEW_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".page_view_event");
var SESSION_START_EVENT_TYPE = "".concat(RUM_AMZ_PREFIX, ".session_start_event");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2Foz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOM_EVENT_PLUGIN_ID", ()=>DOM_EVENT_PLUGIN_ID);
parcelHelpers.export(exports, "DomEventPlugin", ()=>DomEventPlugin);
var _internalPlugin = require("../InternalPlugin");
var _constant = require("../utils/constant");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var DOM_EVENT_PLUGIN_ID = "dom-event";
var defaultConfig = {
    interactionId: function() {
        return "";
    },
    enableMutationObserver: false,
    events: []
};
var DomEventPlugin = /** @class */ function(_super) {
    __extends(DomEventPlugin, _super);
    function DomEventPlugin(config) {
        var _this = _super.call(this, DOM_EVENT_PLUGIN_ID) || this;
        _this.enabled = false;
        _this.eventListenerMap = new Map();
        _this.config = __assign(__assign({}, defaultConfig), config);
        return _this;
    }
    DomEventPlugin.getElementInfo = function(event) {
        var elementInfo = {
            name: "UNKNOWN"
        };
        if (event.target instanceof Node) elementInfo.name = event.target.nodeName;
        if (event.target instanceof Element && event.target.id) elementInfo.id = event.target.id;
        return elementInfo;
    };
    DomEventPlugin.prototype.enable = function() {
        var _this = this;
        if (document.readyState !== "complete") {
            window.addEventListener("load", function() {
                return _this.enable();
            });
            return;
        }
        if (this.enabled) return;
        this.addListeners();
        if (this.config.enableMutationObserver) this.observeDOMMutation();
        this.enabled = true;
    };
    DomEventPlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.removeListeners();
        if (this.observer) this.observer.disconnect();
        this.enabled = false;
    };
    DomEventPlugin.prototype.update = function(events) {
        var _this = this;
        events.forEach(function(domEvent) {
            _this.addEventHandler(domEvent);
            _this.config.events.push(domEvent);
        });
    };
    DomEventPlugin.prototype.onload = function() {
        this.enable();
    };
    DomEventPlugin.prototype.removeListeners = function() {
        var _this = this;
        this.config.events.forEach(function(domEvent) {
            return _this.removeEventHandler(domEvent);
        });
    };
    DomEventPlugin.prototype.addListeners = function() {
        var _this = this;
        this.config.events.forEach(function(domEvent) {
            return _this.addEventHandler(domEvent);
        });
    };
    DomEventPlugin.prototype.getEventListener = function(cssLocator) {
        var _this = this;
        return function(event) {
            var _a;
            var elementInfo = DomEventPlugin.getElementInfo(event);
            var interactionId = _this.config.interactionId(event);
            var eventData = __assign(__assign(__assign({
                version: "1.1.0",
                event: event.type,
                element: elementInfo.name
            }, elementInfo.id ? {
                elementId: elementInfo.id
            } : {}), interactionId ? {
                interactionId: interactionId
            } : {}), cssLocator ? {
                cssLocator: cssLocator
            } : {});
            if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) _this.context.record((0, _constant.DOM_EVENT_TYPE), eventData);
        };
    };
    DomEventPlugin.prototype.addEventHandler = function(domEvent) {
        var eventType = domEvent.event;
        var eventListener = this.getEventListener(domEvent.cssLocator);
        var identifiedElementList = [];
        var elementEventListenerList = this.eventListenerMap.has(domEvent) ? this.eventListenerMap.get(domEvent) : [];
        // first add event listener to all elements identified by the CSS locator
        if (domEvent.cssLocator) {
            var cssLocatedElements = document.querySelectorAll(domEvent.cssLocator);
            cssLocatedElements.forEach(function(element) {
                identifiedElementList.push(element);
            });
        } else if (domEvent.elementId) {
            var identifiedElement = document.getElementById(domEvent.elementId);
            if (identifiedElement) identifiedElementList.push(identifiedElement);
        } else if (domEvent.element) identifiedElementList.push(domEvent.element);
        identifiedElementList.forEach(function(element) {
            element.addEventListener(eventType, eventListener);
            elementEventListenerList.push({
                element: element,
                eventListener: eventListener
            });
        });
        this.eventListenerMap.set(domEvent, elementEventListenerList);
    };
    DomEventPlugin.prototype.removeEventHandler = function(domEvent) {
        var elementEventListenerList = this.eventListenerMap.get(domEvent);
        if (elementEventListenerList) {
            elementEventListenerList.forEach(function(elementEventListener) {
                var element = elementEventListener.element;
                var eventListener = elementEventListener.eventListener;
                element.removeEventListener(domEvent.event, eventListener);
            });
            this.eventListenerMap.delete(domEvent);
        }
    };
    DomEventPlugin.prototype.observeDOMMutation = function() {
        var _this = this;
        this.observer = new MutationObserver(function() {
            _this.removeListeners();
            _this.addListeners();
        });
        //  we track only changes to nodes/DOM elements, not attributes or characterData
        this.observer.observe(document, {
            childList: true,
            subtree: true
        });
    };
    return DomEventPlugin;
}((0, _internalPlugin.InternalPlugin));

},{"../InternalPlugin":"78Kz0","../utils/constant":"iL2Vg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3RRFn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JS_ERROR_EVENT_PLUGIN_ID", ()=>JS_ERROR_EVENT_PLUGIN_ID);
parcelHelpers.export(exports, "JsErrorPlugin", ()=>JsErrorPlugin);
var _internalPlugin = require("../InternalPlugin");
var _constant = require("../utils/constant");
var _jsErrorUtils = require("../utils/js-error-utils");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var JS_ERROR_EVENT_PLUGIN_ID = "js-error";
var defaultConfig = {
    stackTraceLength: 1000,
    ignore: function() {
        return false;
    }
};
var JsErrorPlugin = /** @class */ function(_super) {
    __extends(JsErrorPlugin, _super);
    function JsErrorPlugin(config) {
        var _this = _super.call(this, JS_ERROR_EVENT_PLUGIN_ID) || this;
        _this.eventHandler = function(errorEvent) {
            if (!_this.config.ignore(errorEvent)) _this.recordJsErrorEvent(errorEvent);
        };
        _this.promiseRejectEventHandler = function(event) {
            if (!_this.config.ignore(event)) _this.recordJsErrorEvent({
                type: event.type,
                error: event.reason
            });
        };
        _this.config = __assign(__assign({}, defaultConfig), config);
        return _this;
    }
    JsErrorPlugin.prototype.enable = function() {
        if (this.enabled) return;
        this.addEventHandler();
        this.enabled = true;
    };
    JsErrorPlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.removeEventHandler();
        this.enabled = false;
    };
    JsErrorPlugin.prototype.record = function(error) {
        if (error instanceof ErrorEvent) this.recordJsErrorEvent(error);
        else this.recordJsErrorEvent({
            type: "error",
            error: error
        });
    };
    JsErrorPlugin.prototype.onload = function() {
        this.addEventHandler();
    };
    JsErrorPlugin.prototype.recordJsErrorEvent = function(error) {
        var _a;
        (_a = this.context) === null || _a === void 0 || _a.record((0, _constant.JS_ERROR_EVENT_TYPE), (0, _jsErrorUtils.errorEventToJsErrorEvent)(error, this.config.stackTraceLength));
    };
    JsErrorPlugin.prototype.addEventHandler = function() {
        window.addEventListener("error", this.eventHandler);
        window.addEventListener("unhandledrejection", this.promiseRejectEventHandler);
    };
    JsErrorPlugin.prototype.removeEventHandler = function() {
        window.removeEventListener("error", this.eventHandler);
        window.removeEventListener("unhandledrejection", this.promiseRejectEventHandler);
    };
    return JsErrorPlugin;
}((0, _internalPlugin.InternalPlugin));

},{"../InternalPlugin":"78Kz0","../utils/constant":"iL2Vg","../utils/js-error-utils":"c5nK7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c5nK7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isErrorPrimitive", ()=>isErrorPrimitive);
parcelHelpers.export(exports, "errorEventToJsErrorEvent", ()=>errorEventToJsErrorEvent);
var isObject = function(error) {
    var type = typeof error;
    return (type === "object" || type === "function") && !!error;
};
var buildBaseJsErrorEvent = function(errorEvent) {
    var rumEvent = {
        version: "1.0.0",
        type: "undefined",
        message: "undefined"
    };
    if (errorEvent.type !== undefined) rumEvent.type = errorEvent.type;
    if (errorEvent.message !== undefined) rumEvent.message = errorEvent.message;
    if (errorEvent.filename !== undefined) rumEvent.filename = errorEvent.filename;
    if (errorEvent.lineno !== undefined) rumEvent.lineno = errorEvent.lineno;
    if (errorEvent.colno !== undefined) rumEvent.colno = errorEvent.colno;
    return rumEvent;
};
var appendErrorPrimitiveDetails = function(rumEvent, error) {
    // Keep unhandledrejection as type as it will write to rumEvent.message
    if (rumEvent.type !== "unhandledrejection") rumEvent.type = error.toString();
    rumEvent.message = error.toString();
};
var appendErrorObjectDetails = function(rumEvent, error, stackTraceLength) {
    // error may extend Error here, but it is not guaranteed (i.e., it could
    // be any object)
    if (error.name) rumEvent.type = error.name;
    if (error.message) rumEvent.message = error.message;
    if (error.fileName) rumEvent.filename = error.fileName;
    if (error.lineNumber) rumEvent.lineno = error.lineNumber;
    if (error.columnNumber) rumEvent.colno = error.columnNumber;
    if (stackTraceLength && error.stack) rumEvent.stack = error.stack.length > stackTraceLength ? error.stack.substring(0, stackTraceLength) + "..." : error.stack;
};
var isErrorPrimitive = function(error) {
    return error !== Object(error) && error !== undefined && error !== null;
};
var errorEventToJsErrorEvent = function(errorEvent, stackTraceLength) {
    var rumEvent = buildBaseJsErrorEvent(errorEvent);
    var error = errorEvent.error;
    if (isObject(error)) appendErrorObjectDetails(rumEvent, error, stackTraceLength);
    else if (isErrorPrimitive(error)) appendErrorPrimitiveDetails(rumEvent, error);
    return rumEvent;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Jqpe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventCache", ()=>EventCache);
var _sessionManager = require("../sessions/SessionManager");
var _uuid = require("uuid");
var _pageManager = require("../sessions/PageManager");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var webClientVersion = "1.14.0";
/**
 * A cache which stores events generated by telemetry plugins.
 *
 * The event cache stores meta data and events until they are dispatched to the
 * data plane. The event cache removes the oldest event once the cache is full
 * and a new event is added.
 */ var EventCache = /** @class */ function() {
    /**
     * @param applicationDetails Application identity and version.
     * @param batchLimit The maximum number of events that will be returned in a batch.
     * @param eventCacheSize  The maximum number of events the cache can contain before dropping events.
     * @param sessionManager  The sessionManager returns user id, session id and handles session timeout.
     * @param pageManager The pageManager returns page id.
     */ function EventCache(applicationDetails, config) {
        var _this = this;
        this.events = [];
        /**
         * Update the current page interaction for the session.
         */ this.recordPageView = function(payload) {
            if (_this.isCurrentUrlAllowed()) _this.pageManager.recordPageView(payload);
        };
        /**
         * Add an event to the cache and reset the session timer.
         *
         * If the session is being recorded, the event will be recorded.
         * If the session is not being recorded, the event will not be recorded.
         *
         * @param type The event schema.
         */ this.recordEvent = function(type, eventData) {
            if (!_this.enabled) return;
            if (_this.isCurrentUrlAllowed()) {
                var session = _this.sessionManager.getSession();
                _this.sessionManager.incrementSessionEventCount();
                if (_this.canRecord(session)) _this.addRecordToCache(type, eventData);
            }
        };
        /**
         * Returns the current session (1) if a session exists and (2) if the
         * current URL is allowed. Returns undefined otherwise.
         */ this.getSession = function() {
            if (_this.isCurrentUrlAllowed()) return _this.sessionManager.getSession();
            return undefined;
        };
        /**
         * Add a session start event to the cache.
         */ this.recordSessionInitEvent = function(session, type, eventData) {
            if (!_this.enabled) return;
            _this.sessionManager.incrementSessionEventCount();
            if (_this.canRecord(session)) _this.addRecordToCache(type, eventData);
        };
        this.canRecord = function(session) {
            return session.record && (session.eventCount <= _this.config.sessionEventLimit || _this.config.sessionEventLimit <= 0);
        };
        /**
         * Add an event to the cache.
         *
         * @param type The event schema.
         */ this.addRecordToCache = function(type, eventData) {
            if (!_this.enabled) return;
            if (_this.events.length === _this.config.eventCacheSize) // Make room in the cache by dropping the oldest event.
            _this.events.shift();
            // The data plane service model (i.e., LogEvents) does not adhere to the
            // RUM agent data model, where sessions and pages are first class
            // objects with their own attribute sets. Instead, we store session
            // attributes and page attributes together as 'meta data'.
            var metaData = __assign(__assign(__assign({}, _this.sessionManager.getAttributes()), _this.pageManager.getAttributes()), {
                version: "1.0.0",
                "aws:client": _this.installationMethod,
                "aws:clientVersion": webClientVersion
            });
            _this.events.push({
                details: JSON.stringify(eventData),
                id: (0, _uuid.v4)(),
                metadata: JSON.stringify(metaData),
                timestamp: new Date(),
                type: type
            });
        };
        this.appMonitorDetails = applicationDetails;
        this.config = config;
        this.enabled = true;
        this.pageManager = new (0, _pageManager.PageManager)(config, this.recordEvent);
        this.sessionManager = new (0, _sessionManager.SessionManager)(applicationDetails, config, this.recordSessionInitEvent, this.pageManager);
        this.installationMethod = config.client;
    }
    /**
     * The event cache will record new events or new meta data.
     */ EventCache.prototype.enable = function() {
        this.enabled = true;
    };
    /**
     * The event cache will not record new events or new meta data. Events and
     * meta data which are already in the cache will still be accessible.
     */ EventCache.prototype.disable = function() {
        this.enabled = false;
    };
    /**
     * Returns true if there are one or more events in the cache.
     */ EventCache.prototype.hasEvents = function() {
        return this.events.length !== 0;
    };
    /**
     * Removes and returns the next batch of events.
     */ EventCache.prototype.getEventBatch = function() {
        var rumEvents = [];
        if (this.events.length === 0) return rumEvents;
        if (this.events.length <= this.config.batchLimit) {
            // Return all events.
            rumEvents = this.events;
            this.events = [];
        } else // Dispatch the front of the array and retain the back of the array.
        rumEvents = this.events.splice(0, this.config.batchLimit);
        return rumEvents;
    };
    /**
     * Returns an object containing the AppMonitor ID and application version.
     */ EventCache.prototype.getAppMonitorDetails = function() {
        return this.appMonitorDetails;
    };
    /**
     * Returns an object containing the session ID and user ID.
     */ EventCache.prototype.getUserDetails = function() {
        return {
            userId: this.sessionManager.getUserId(),
            sessionId: this.sessionManager.getSession().sessionId
        };
    };
    /**
     * Set custom session attributes to add them to all event metadata.
     *
     * @param payload object containing custom attribute data in the form of key, value pairs
     */ EventCache.prototype.addSessionAttributes = function(sessionAttributes) {
        this.sessionManager.addSessionAttributes(sessionAttributes);
    };
    /**
     * Returns {@code true} if the current url matches one of the allowedPages
     * and does not match any of the deniedPages; returns {@code false}
     * otherwise.
     */ EventCache.prototype.isCurrentUrlAllowed = function() {
        var location = document.location.toString();
        var exclude = this.config.pagesToExclude.some(function(re) {
            return re.test(location);
        });
        var include = this.config.pagesToInclude.some(function(re) {
            return re.test(location);
        });
        return include && !exclude;
    };
    return EventCache;
}();

},{"../sessions/SessionManager":"lbc6U","uuid":"jPA13","../sessions/PageManager":"eLEMg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lbc6U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NIL_UUID", ()=>NIL_UUID);
parcelHelpers.export(exports, "UNKNOWN", ()=>UNKNOWN);
parcelHelpers.export(exports, "DESKTOP_DEVICE_TYPE", ()=>DESKTOP_DEVICE_TYPE);
parcelHelpers.export(exports, "WEB_PLATFORM_TYPE", ()=>WEB_PLATFORM_TYPE);
parcelHelpers.export(exports, "SESSION_START_EVENT_TYPE", ()=>SESSION_START_EVENT_TYPE);
parcelHelpers.export(exports, "RUM_SESSION_START", ()=>RUM_SESSION_START);
parcelHelpers.export(exports, "RUM_SESSION_EXPIRE", ()=>RUM_SESSION_EXPIRE);
parcelHelpers.export(exports, "SessionManager", ()=>SessionManager);
var _cookiesUtils = require("../utils/cookies-utils");
var _uuid = require("uuid");
var _uaParserJs = require("ua-parser-js");
var _constants = require("../utils/constants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var NIL_UUID = "00000000-0000-0000-0000-000000000000";
var UNKNOWN = "unknown";
var DESKTOP_DEVICE_TYPE = "desktop";
var WEB_PLATFORM_TYPE = "web";
var SESSION_START_EVENT_TYPE = "com.amazon.rum.session_start_event";
var RUM_SESSION_START = "rum_session_start";
var RUM_SESSION_EXPIRE = "rum_session_expire";
/**
 * The session handler handles user id and session id.
 *
 * A session is the {user id, session id} tuple which groups events that occur on a single browser over a continuous
 * period of time. A session begins when no session exists or the last session has expired. If user id does not exist,
 * session handler will assign a new one and store it in cookie. If session id does not exist or has expired, session
 * handler will assign a new one and store it in cookie. Session handler detects user interactions and updates session
 * id expiration time.
 */ var SessionManager = /** @class */ function() {
    function SessionManager(appMonitorDetails, config, record, pageManager) {
        this.appMonitorDetails = appMonitorDetails;
        this.config = config;
        this.record = record;
        this.pageManager = pageManager;
        // Initialize the session to the nil session
        this.session = {
            sessionId: NIL_UUID,
            record: this.sample(),
            eventCount: 0
        };
        // Initialize or restore the user
        this.initializeUser();
        // Collect the user agent and domain
        this.collectAttributes();
        // Set custom session attributes
        this.addSessionAttributes(this.config.sessionAttributes);
        // Attempt to restore the previous session
        this.getSessionFromCookie();
    }
    /**
     * Returns the session ID. If no session ID exists, one will be created.
     */ SessionManager.prototype.getSession = function() {
        if (this.session.sessionId === NIL_UUID) // The session does not exist. Create a new one.
        this.createSession();
        else if (this.session.sessionId !== NIL_UUID && new Date() > this.sessionExpiry) // The session has expired. Create a new one.
        this.createSession();
        return this.session;
    };
    SessionManager.prototype.getAttributes = function() {
        return this.attributes;
    };
    /**
     * Adds custom session attributes to the session's attributes
     *
     * @param sessionAttributes object containing custom attribute data in the form of key, value pairs
     */ SessionManager.prototype.addSessionAttributes = function(sessionAttributes) {
        this.attributes = __assign(__assign({}, sessionAttributes), this.attributes);
    };
    SessionManager.prototype.getUserId = function() {
        if (this.useCookies()) return this.userId;
        return NIL_UUID;
    };
    SessionManager.prototype.incrementSessionEventCount = function() {
        this.session.eventCount++;
        this.renewSession();
    };
    SessionManager.prototype.initializeUser = function() {
        var userId = "";
        this.userExpiry = new Date();
        this.userExpiry.setDate(this.userExpiry.getDate() + this.config.userIdRetentionDays);
        if (this.config.userIdRetentionDays <= 0) // Use the 'nil' UUID when the user ID will not be retained
        this.userId = "00000000-0000-0000-0000-000000000000";
        else if (this.useCookies()) {
            userId = this.getUserIdCookie();
            this.userId = userId ? userId : (0, _uuid.v4)();
            this.createOrRenewUserCookie(userId, this.userExpiry);
        } else this.userId = (0, _uuid.v4)();
    };
    SessionManager.prototype.createOrRenewSessionCookie = function(session, expires) {
        if (btoa) (0, _cookiesUtils.storeCookie)(this.sessionCookieName(), btoa(JSON.stringify(session)), this.config.cookieAttributes, undefined, expires);
    };
    SessionManager.prototype.createOrRenewUserCookie = function(userId, expires) {
        (0, _cookiesUtils.storeCookie)((0, _constants.USER_COOKIE_NAME), userId, this.config.cookieAttributes, undefined, expires);
    };
    SessionManager.prototype.getUserIdCookie = function() {
        return (0, _cookiesUtils.getCookie)((0, _constants.USER_COOKIE_NAME));
    };
    SessionManager.prototype.getSessionFromCookie = function() {
        if (this.useCookies()) {
            var cookie = (0, _cookiesUtils.getCookie)(this.sessionCookieName());
            if (cookie && atob) try {
                this.session = JSON.parse(atob(cookie));
                this.pageManager.resumeSession(this.session.page);
            } catch (e) {
            // Error decoding or parsing the cookie -- ignore
            }
        }
    };
    SessionManager.prototype.storeSessionAsCookie = function() {
        if (this.useCookies() && this.config.userIdRetentionDays > 0) this.createOrRenewUserCookie(this.userId, this.userExpiry);
        if (this.useCookies()) // Set the user cookie in case useCookies() has changed from false to true.
        this.createOrRenewSessionCookie(this.session, this.sessionExpiry);
    };
    SessionManager.prototype.createSession = function() {
        this.session = {
            sessionId: (0, _uuid.v4)(),
            record: this.sample(),
            eventCount: 0
        };
        this.session.page = this.pageManager.getPage();
        this.sessionExpiry = new Date(new Date().getTime() + this.config.sessionLengthSeconds * 1000);
        this.storeSessionAsCookie();
        this.record(this.session, SESSION_START_EVENT_TYPE, {
            version: "1.0.0"
        });
    };
    SessionManager.prototype.renewSession = function() {
        this.sessionExpiry = new Date(new Date().getTime() + this.config.sessionLengthSeconds * 1000);
        this.session.page = this.pageManager.getPage();
        this.storeSessionAsCookie();
    };
    SessionManager.prototype.collectAttributes = function() {
        var ua = new (0, _uaParserJs.UAParser)(navigator.userAgent).getResult();
        this.attributes = {
            browserLanguage: navigator.language,
            browserName: ua.browser.name ? ua.browser.name : UNKNOWN,
            browserVersion: ua.browser.version ? ua.browser.version : UNKNOWN,
            osName: ua.os.name ? ua.os.name : UNKNOWN,
            osVersion: ua.os.version ? ua.os.version : UNKNOWN,
            // Possible device types include {console, mobile, tablet, smarttv, wearable, embedded}. If the device
            // type is undefined, there was no information indicating the device is anything other than a desktop,
            // so we assume the device is a desktop.
            deviceType: ua.device.type ? ua.device.type : DESKTOP_DEVICE_TYPE,
            // This client is used exclusively in web applications.
            platformType: WEB_PLATFORM_TYPE,
            domain: window.location.hostname
        };
    };
    /**
     * Returns true when cookies should be used to store user ID and session ID.
     */ SessionManager.prototype.useCookies = function() {
        return navigator.cookieEnabled && this.config.allowCookies;
    };
    /**
     * Returns {@code true} when the session has been selected to be recorded.
     */ SessionManager.prototype.sample = function() {
        return Math.random() < this.config.sessionSampleRate;
    };
    SessionManager.prototype.sessionCookieName = function() {
        if (this.config.cookieAttributes.unique) return "".concat((0, _constants.SESSION_COOKIE_NAME), "_").concat(this.appMonitorDetails.id);
        return 0, _constants.SESSION_COOKIE_NAME;
    };
    return SessionManager;
}();

},{"../utils/cookies-utils":"cBJIR","uuid":"jPA13","ua-parser-js":"c23ma","../utils/constants":"7RiXG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cBJIR":[function(require,module,exports) {
/**
 * Stores a cookie.
 *
 * @param name The cookie's name.
 * @param value The cookie's value.
 * @param attributes The domain where the cookie will be stored.
 * @param ttl Time to live -- expiry date is current date + ttl (do not use with {@code expires}).
 * @param expires The expiry date for the cookie (do not use with {@code ttl})
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storeCookie", ()=>storeCookie);
parcelHelpers.export(exports, "getExpiryDate", ()=>getExpiryDate);
parcelHelpers.export(exports, "removeCookie", ()=>removeCookie);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
var storeCookie = function(name, value, attributes, ttl, expires) {
    var cookie = name + "=";
    cookie += value || "";
    if (expires !== undefined) cookie += "; Expires=".concat(expires.toUTCString());
    else if (ttl !== undefined) cookie += "; Expires=".concat(getExpiryDate(ttl).toUTCString());
    cookie += "; Domain=".concat(attributes.domain);
    cookie += "; Path=".concat(attributes.path);
    cookie += "; SameSite=".concat(attributes.sameSite);
    cookie += attributes.secure ? "; Secure" : "";
    document.cookie = cookie;
};
var getExpiryDate = function(ttl) {
    return new Date(new Date().getTime() + ttl * 1000);
};
var removeCookie = function(name, attributes) {
    var cookie = name + "=";
    cookie += "; Expires=".concat(new Date(0));
    cookie += "; Domain=".concat(attributes.domain);
    cookie += "; Path=".concat(attributes.path);
    cookie += "; SameSite=".concat(attributes.sameSite);
    cookie += attributes.secure ? "Secure" : "";
    document.cookie = cookie;
};
var getCookie = function(name) {
    var cookies = document.cookie.split("; ");
    for(var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++){
        var cookie = cookies_1[_i];
        var split = cookie.split("=");
        if (split[0] === name) return split[1];
    }
    return "";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPA13":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"2Pisj","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Pisj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"lgFPz","./rng.js":"61vCw","./stringify.js":"lVfmf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgFPz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61vCw":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lVfmf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"iMoZD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMoZD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"h3geG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h3geG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c23ma":[function(require,module,exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /ios;fbsv\/([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

},{}],"eLEMg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageManager", ()=>PageManager);
var _virtualPageLoadTimer = require("../sessions/VirtualPageLoadTimer");
var _constant = require("../plugins/utils/constant");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * The page manager keeps the state of the current page and interaction level.
 *
 * A page is a unique view (user interface) of the application. For 'multi page' applications (i.e., 'classic' web
 * applications that have multiple html files), the page changes when the user navigates to a new web page. For
 * 'single page' applications (i.e., 'ajax' web applications that have a single html file), the page changes when (1)
 * the popstate event emitted, or (2) the application indicates a new page has loaded using the RUM agent API.
 *
 * The interaction level is the order of a page in the sequence of pages sorted by the time they were viewed.
 */ var PageManager = /** @class */ function() {
    function PageManager(config, record) {
        this.TIMEOUT = 1000;
        this.config = config;
        this.record = record;
        this.page = undefined;
        this.resumed = false;
        this.recordInteraction = false;
        this.virtualPageLoadTimer = new (0, _virtualPageLoadTimer.VirtualPageLoadTimer)(this, config, record);
    }
    PageManager.prototype.getPage = function() {
        return this.page;
    };
    PageManager.prototype.getAttributes = function() {
        return this.attributes;
    };
    PageManager.prototype.resumeSession = function(page) {
        this.recordInteraction = true;
        if (page) {
            this.page = page;
            this.resumed = true;
        }
    };
    PageManager.prototype.recordPageView = function(payload) {
        var pageId;
        if (typeof payload === "string") pageId = payload;
        else pageId = payload.pageId;
        if (this.useCookies()) this.recordInteraction = true;
        if (!this.page) this.createLandingPage(pageId);
        else if (this.page.pageId !== pageId) this.createNextPage(this.page, pageId);
        else if (this.resumed) {
            // Update attributes state in PageManager for event metadata
            this.collectAttributes(this.page, typeof payload === "object" ? payload : undefined);
            return;
        } else // The view has not changed.
        return;
        // this.page is guaranteed to have been initialized
        // Attributes will be added to all events as meta data
        this.collectAttributes(this.page, typeof payload === "object" ? payload : undefined);
        // The SessionManager will update its cookie with the new page
        this.recordPageViewEvent(this.page);
    };
    PageManager.prototype.createNextPage = function(currentPage, pageId) {
        var startTime = Date.now();
        var interactionTime = this.virtualPageLoadTimer.latestInteractionTime;
        // The latest interaction time (latest) is not guaranteed to be the
        // interaction that triggered the route change (actual). There are two
        // cases to consider:
        //
        // 1. Latest is older than actual. This can happen if the user navigates
        // with the browser back/forward button, or if the interaction is not a
        // click/keyup event.
        //
        // 2. Latest is newer than actual. This can happen if the user clicks or
        // types in the time between actual and when recordPageView is called.
        //
        // We believe that case (1) has a high risk of skewing route change
        // timing metrics because (a) browser navigation is common and (b) there
        // is no limit on when the latest interaction may have occurred. To
        // help mitigate this, if the route change is already longer than 1000ms,
        // then we do not bother timing the route change.
        //
        // We do not believe that case (2) has a high risk of skewing route
        // change timing, and therefore ignore case (2).
        if (!this.resumed && startTime - interactionTime <= this.TIMEOUT) {
            startTime = interactionTime;
            this.virtualPageLoadTimer.startTiming();
        }
        this.timeOnParentPage = startTime - currentPage.start;
        this.resumed = false;
        this.page = {
            pageId: pageId,
            parentPageId: currentPage.pageId,
            interaction: currentPage.interaction + 1,
            referrer: document.referrer,
            referrerDomain: this.getDomainFromReferrer(),
            start: startTime
        };
    };
    PageManager.prototype.createLandingPage = function(pageId) {
        this.page = {
            pageId: pageId,
            interaction: 0,
            referrer: document.referrer,
            referrerDomain: this.getDomainFromReferrer(),
            start: Date.now()
        };
    };
    PageManager.prototype.collectAttributes = function(page, customPageAttributes) {
        this.attributes = {
            title: document.title,
            pageId: page.pageId
        };
        if (this.recordInteraction) {
            this.attributes.interaction = page.interaction;
            if (page.parentPageId !== undefined) this.attributes.parentPageId = page.parentPageId;
        }
        if (customPageAttributes === null || customPageAttributes === void 0 ? void 0 : customPageAttributes.pageTags) this.attributes["pageTags"] = customPageAttributes["pageTags"];
        if (customPageAttributes === null || customPageAttributes === void 0 ? void 0 : customPageAttributes.pageAttributes) this.attributes = __assign(__assign({}, customPageAttributes.pageAttributes), this.attributes);
    };
    PageManager.prototype.createPageViewEvent = function(page) {
        var pageViewEvent = {
            version: "1.0.0",
            pageId: page.pageId
        };
        if (this.recordInteraction) {
            pageViewEvent.interaction = page.interaction;
            pageViewEvent.pageInteractionId = page.pageId + "-" + page.interaction;
            if (page.parentPageId !== undefined) {
                pageViewEvent.parentPageInteractionId = page.parentPageId + "-" + (page.interaction - 1);
                pageViewEvent.timeOnParentPage = this.timeOnParentPage;
            }
            pageViewEvent.referrer = document.referrer;
            pageViewEvent.referrerDomain = this.getDomainFromReferrer();
        }
        return pageViewEvent;
    };
    PageManager.prototype.recordPageViewEvent = function(page) {
        this.record((0, _constant.PAGE_VIEW_EVENT_TYPE), this.createPageViewEvent(page));
    };
    /**
     * Returns true when cookies should be used to store user ID and session ID.
     */ PageManager.prototype.useCookies = function() {
        return navigator.cookieEnabled && this.config.allowCookies;
    };
    /*
    Parses the domain from the referrer, if it is available
    */ PageManager.prototype.getDomainFromReferrer = function() {
        try {
            return new URL(document.referrer).hostname;
        } catch (e) {
            return document.referrer === "localhost" ? document.referrer : "";
        }
    };
    return PageManager;
}();

},{"../sessions/VirtualPageLoadTimer":"2nkTy","../plugins/utils/constant":"iL2Vg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nkTy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualPageLoadTimer", ()=>VirtualPageLoadTimer);
var _constant = require("../plugins/utils/constant");
var _monkeyPatched = require("../plugins/MonkeyPatched");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Maintains the core logic for virtual page load timing functionality.
 * (1) Holds all virtual page load timing related resources
 * (2) Intercepts outgoing XMLHttpRequests and Fetch requests and listens for DOM changes
 * (3) Records virtual page load
 */ var VirtualPageLoadTimer = /** @class */ function(_super) {
    __extends(VirtualPageLoadTimer, _super);
    function VirtualPageLoadTimer(pageManager, config, record) {
        var _this = _super.call(this, "virtual-page-load-timer") || this;
        _this.sendWrapper = function() {
            var self = _this;
            return function(original) {
                return function() {
                    self.recordXhr(this);
                    this.addEventListener("loadend", self.endTracking);
                    return original.apply(this, arguments);
                };
            };
        };
        /**
         * Removes the current event from either requestBuffer or ongoingRequests set.
         *
         * @param event
         */ _this.endTracking = function(e) {
            var currTime = Date.now();
            var xhr = e.target;
            xhr.removeEventListener("loadend", _this.endTracking);
            _this.removeXhr(xhr, currTime);
        };
        _this.fetch = function(original, thisArg, argsArray) {
            return original.apply(thisArg, argsArray).catch(function(error) {
                throw error;
            }).finally(_this.decrementFetchCounter);
        };
        /**
         * Increment the fetch counter in PageManager when fetch is beginning
         */ _this.fetchWrapper = function() {
            var self = _this;
            return function(original) {
                return function(input, init) {
                    self.fetchCounter += 1;
                    return self.fetch(original, this, arguments);
                };
            };
        };
        _this.decrementFetchCounter = function() {
            if (!_this.isPageLoaded) _this.latestEndTime = Date.now();
            _this.fetchCounter -= 1;
        };
        /**
         * Checks whether the virtual page is still being loaded.
         * If completed:
         * (1) Clear the timers
         * (2) Record data using NavigationEvent
         * (3) Indicate current page has finished loading
         */ _this.checkLoadStatus = function() {
            if (_this.ongoingRequests.size === 0 && _this.fetchCounter === 0) {
                clearInterval(_this.periodicCheckerId);
                clearTimeout(_this.timeoutCheckerId);
                _this.domMutationObserver.disconnect();
                _this.recordRouteChangeNavigationEvent(_this.pageManager.getPage());
                _this.periodicCheckerId = undefined;
                _this.timeoutCheckerId = undefined;
                _this.isPageLoaded = true;
            }
        };
        /** Clears timers and disconnects observer to stop page timing. */ _this.declareTimeout = function() {
            clearInterval(_this.periodicCheckerId);
            _this.periodicCheckerId = undefined;
            _this.timeoutCheckerId = undefined;
            _this.domMutationObserver.disconnect();
            _this.isPageLoaded = true;
        };
        _this.resetInterval = function() {
            _this.latestEndTime = Date.now();
            clearInterval(_this.periodicCheckerId);
            _this.periodicCheckerId = setInterval(_this.checkLoadStatus, _this.config.routeChangeComplete);
        };
        _this.moveItemsFromBuffer = function(item) {
            _this.ongoingRequests.add(item);
        };
        _this.updateLatestInteractionTime = function(e) {
            _this.latestInteractionTime = Date.now();
        };
        _this.periodicCheckerId = undefined;
        _this.timeoutCheckerId = undefined;
        _this.domMutationObserver = new MutationObserver(_this.resetInterval);
        _this.ongoingRequests = new Set();
        _this.requestBuffer = new Set();
        _this.fetchCounter = 0;
        _this.isPageLoaded = true;
        _this.latestEndTime = 0;
        _this.latestInteractionTime = 0;
        _this.config = config;
        _this.pageManager = pageManager;
        _this.record = record;
        _this.enable();
        // Start tracking the timestamps
        document.addEventListener("mousedown", _this.updateLatestInteractionTime);
        document.addEventListener("keydown", _this.updateLatestInteractionTime);
        return _this;
    }
    Object.defineProperty(VirtualPageLoadTimer.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: XMLHttpRequest.prototype,
                    name: "send",
                    wrapper: this.sendWrapper
                },
                {
                    nodule: window,
                    name: "fetch",
                    wrapper: this.fetchWrapper
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    /** Initializes timing related resources for current page. */ VirtualPageLoadTimer.prototype.startTiming = function() {
        this.latestEndTime = Date.now();
        // Clean up existing timer objects and mutationObserver
        if (this.periodicCheckerId) clearInterval(this.periodicCheckerId);
        if (this.timeoutCheckerId) clearTimeout(this.timeoutCheckerId);
        this.domMutationObserver.disconnect();
        // Initialize timer objects and start observing
        this.periodicCheckerId = setInterval(this.checkLoadStatus, this.config.routeChangeComplete);
        this.timeoutCheckerId = setTimeout(this.declareTimeout, this.config.routeChangeTimeout);
        // observing the add/delete of nodes
        this.domMutationObserver.observe(document, {
            subtree: true,
            childList: true,
            attributes: false,
            characterData: false
        });
        // Indicate page has not loaded, and carry over buffered requests.
        this.isPageLoaded = false;
        this.requestBuffer.forEach(this.moveItemsFromBuffer);
        this.requestBuffer.clear();
    };
    VirtualPageLoadTimer.prototype.recordXhr = function(item) {
        var page = this.pageManager.getPage();
        if (page && this.isPageLoaded === false) this.ongoingRequests.add(item);
        else this.requestBuffer.add(item);
    };
    VirtualPageLoadTimer.prototype.removeXhr = function(item, currTime) {
        var page = this.pageManager.getPage();
        if (page && this.ongoingRequests.has(item)) {
            this.ongoingRequests.delete(item);
            this.latestEndTime = currTime;
        } else if (this.requestBuffer.has(item)) this.requestBuffer.delete(item);
    };
    VirtualPageLoadTimer.prototype.recordRouteChangeNavigationEvent = function(page) {
        var virtualPageNavigationEvent = {
            version: "1.0.0",
            initiatorType: "route_change",
            navigationType: "navigate",
            startTime: page.start,
            duration: this.latestEndTime - page.start
        };
        if (this.record) this.record((0, _constant.PERFORMANCE_NAVIGATION_EVENT_TYPE), virtualPageNavigationEvent);
    };
    return VirtualPageLoadTimer;
}((0, _monkeyPatched.MonkeyPatched));

},{"../plugins/utils/constant":"iL2Vg","../plugins/MonkeyPatched":"1UnKu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1UnKu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonkeyPatched", ()=>MonkeyPatched);
var _shimmer = require("shimmer");
var _internalPlugin = require("./InternalPlugin");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var MonkeyPatched = /** @class */ function(_super) {
    __extends(MonkeyPatched, _super);
    function MonkeyPatched() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enable = _this.patch.bind(_this, true);
        _this.disable = _this.patch.bind(_this, false);
        _this.enabled = false;
        return _this;
    }
    MonkeyPatched.prototype.patchAll = function() {
        var wrap = _shimmer.wrap.bind(_shimmer);
        for(var _i = 0, _a = this.patches; _i < _a.length; _i++){
            var patch = _a[_i];
            wrap(patch.nodule, patch.name, patch.wrapper());
        }
    };
    MonkeyPatched.prototype.unpatchAll = function() {
        var unwrap = _shimmer.unwrap.bind(_shimmer);
        for(var _i = 0, _a = this.patches; _i < _a.length; _i++){
            var patch = _a[_i];
            unwrap(patch.nodule, patch.name);
        }
    };
    MonkeyPatched.prototype.patch = function(shouldPatch) {
        if (shouldPatch === void 0) shouldPatch = true;
        if (this.enabled !== shouldPatch) {
            this.enabled = shouldPatch;
            if (shouldPatch) this.patchAll();
            else this.unpatchAll();
        }
    };
    return MonkeyPatched;
}((0, _internalPlugin.InternalPlugin));

},{"shimmer":"gY2z3","./InternalPlugin":"78Kz0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gY2z3":[function(require,module,exports) {
"use strict";
function isFunction(funktion) {
    return typeof funktion === "function";
}
// Default to complaining loudly when things don't go according to plan.
var logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
// Keep initialization idempotent.
function shimmer(options) {
    if (options && options.logger) {
        if (!isFunction(options.logger)) logger("new logger isn't a function, not replacing");
        else logger = options.logger;
    }
}
function wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        logger("no original function " + name + " to wrap");
        return;
    }
    if (!wrapper) {
        logger("no wrapper function");
        logger(new Error().stack);
        return;
    }
    if (!isFunction(nodule[name]) || !isFunction(wrapper)) {
        logger("original object and wrapper must be functions");
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    defineProperty(wrapped, "__original", original);
    defineProperty(wrapped, "__unwrap", function() {
        if (nodule[name] === wrapped) defineProperty(nodule, name, original);
    });
    defineProperty(wrapped, "__wrapped", true);
    defineProperty(nodule, name, wrapped);
    return wrapped;
}
function massWrap(nodules, names, wrapper) {
    if (!nodules) {
        logger("must provide one or more modules to patch");
        logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        logger("must provide one or more functions to wrap on modules");
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            wrap(nodule, name, wrapper);
        });
    });
}
function unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        logger("no function to unwrap.");
        logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) logger("no original to unwrap to -- has " + name + " already been unwrapped?");
    else return nodule[name].__unwrap();
}
function massUnwrap(nodules, names) {
    if (!nodules) {
        logger("must provide one or more modules to patch");
        logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        logger("must provide one or more functions to unwrap on modules");
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            unwrap(nodule, name);
        });
    });
}
shimmer.wrap = wrap;
shimmer.massWrap = massWrap;
shimmer.unwrap = unwrap;
shimmer.massUnwrap = massUnwrap;
module.exports = shimmer;

},{}],"jStFc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dispatch", ()=>Dispatch);
var _dataPlaneClient = require("./DataPlaneClient");
var _beaconHttpHandler = require("./BeaconHttpHandler");
var _fetchHttpHandler = require("./FetchHttpHandler");
var _uuid = require("uuid");
var _retryHttpHandler = require("./RetryHttpHandler");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var NO_CRED_MSG = "CWR: Cannot dispatch; no AWS credentials.";
var Dispatch = /** @class */ function() {
    function Dispatch(region, endpoint, eventCache, config) {
        var _this = this;
        /**
         * Send meta data and events to the AWS RUM data plane service via fetch.
         */ this.dispatchFetch = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    if (this.doRequest()) return [
                        2 /*return*/ ,
                        this.rum.sendFetch(this.createRequest()).catch(this.handleReject)
                    ];
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        /**
         * Send meta data and events to the AWS RUM data plane service via beacon.
         */ this.dispatchBeacon = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var request_1;
                var _this = this;
                return __generator(this, function(_a) {
                    if (this.doRequest()) {
                        request_1 = this.createRequest();
                        return [
                            2 /*return*/ ,
                            this.rum.sendBeacon(request_1).catch(function() {
                                return _this.rum.sendFetch(request_1);
                            })
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        /**
         * Send meta data and events to the AWS RUM data plane service via fetch.
         *
         * Returns undefined on failure.
         */ this.dispatchFetchFailSilent = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    return [
                        2 /*return*/ ,
                        this.dispatchFetch().catch(function() {})
                    ];
                });
            });
        };
        /**
         * Send meta data and events to the AWS RUM data plane service via beacon.
         *
         * Returns undefined on failure.
         */ this.dispatchBeaconFailSilent = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    return [
                        2 /*return*/ ,
                        this.dispatchBeacon().catch(function() {})
                    ];
                });
            });
        };
        this.handleReject = function(e) {
            // The handler has run out of retries. We adhere to our convention to
            // fail safe by disabling dispatch. This ensures that we will not
            // continue to attempt requests when the problem is not recoverable.
            _this.disable();
            throw e;
        };
        /**
         * The default method for creating data plane service clients.
         *
         * @param endpoint Service endpoint.
         * @param region  Service region.
         * @param credentials AWS credentials.
         */ this.defaultClientBuilder = function(endpoint, region, credentials) {
            return new (0, _dataPlaneClient.DataPlaneClient)({
                fetchRequestHandler: new (0, _retryHttpHandler.RetryHttpHandler)(new (0, _fetchHttpHandler.FetchHttpHandler)({
                    fetchFunction: _this.config.fetchFunction
                }), _this.config.retries),
                beaconRequestHandler: new (0, _beaconHttpHandler.BeaconHttpHandler)(),
                endpoint: endpoint,
                region: region,
                credentials: credentials
            });
        };
        this.region = region;
        this.endpoint = endpoint;
        this.eventCache = eventCache;
        this.enabled = true;
        this.buildClient = config.clientBuilder || this.defaultClientBuilder;
        this.config = config;
        this.startDispatchTimer();
        if (config.signing) this.rum = {
            sendFetch: function() {
                return Promise.reject(new Error(NO_CRED_MSG));
            },
            sendBeacon: function() {
                return Promise.reject(new Error(NO_CRED_MSG));
            }
        };
        else this.rum = this.buildClient(this.endpoint, this.region, undefined);
    }
    /**
     * Dispatch will send requests to data plane.
     */ Dispatch.prototype.enable = function() {
        this.enabled = true;
        this.startDispatchTimer();
    };
    /**
     * Dispatch will not send requests to data plane.
     */ Dispatch.prototype.disable = function() {
        this.stopDispatchTimer();
        this.enabled = false;
    };
    /**
     * Set the authentication token that will be used to authenticate with the
     * data plane service (AWS auth).
     *
     * @param credentials A set of AWS credentials from the application's authflow.
     */ Dispatch.prototype.setAwsCredentials = function(credentialProvider) {
        this.rum = this.buildClient(this.endpoint, this.region, credentialProvider);
        if (typeof credentialProvider === "function") // In case a beacon in the first dispatch, we must pre-fetch credentials into a cookie so there is no delay
        // to fetch credentials while the page is closing.
        credentialProvider();
    };
    /**
     * Automatically dispatch cached events.
     */ Dispatch.prototype.startDispatchTimer = function() {
        document.addEventListener("visibilitychange", // The page is moving to the hidden state, which means it may be
        // unloaded. The sendBeacon API would typically be used in this
        // case. However, ad-blockers prevent sendBeacon from functioning.
        // We therefore have two bad options:
        //
        // (1) Use sendBeacon. Data will be lost when ad blockers are
        //     used and the page loses visibility
        // (2) Use fetch. Data will be lost when the page is unloaded
        //     before fetch completes
        //
        // A third option is to send both, however this would increase
        // bandwitch and require deduping server side.
        this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        // Using 'pagehide' is redundant most of the time (visibilitychange is
        // always fired before pagehide) but older browsers may support
        // 'pagehide' but not 'visibilitychange'.
        document.addEventListener("pagehide", this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        if (this.config.dispatchInterval <= 0 || this.dispatchTimerId) return;
        this.dispatchTimerId = window.setInterval(this.dispatchFetchFailSilent, this.config.dispatchInterval);
    };
    /**
     * Stop automatically dispatching cached events.
     */ Dispatch.prototype.stopDispatchTimer = function() {
        document.removeEventListener("visibilitychange", this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        document.removeEventListener("pagehide", this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        if (this.dispatchTimerId) {
            window.clearInterval(this.dispatchTimerId);
            this.dispatchTimerId = undefined;
        }
    };
    Dispatch.prototype.doRequest = function() {
        return this.enabled && this.eventCache.hasEvents();
    };
    Dispatch.prototype.createRequest = function() {
        return {
            BatchId: (0, _uuid.v4)(),
            AppMonitorDetails: this.eventCache.getAppMonitorDetails(),
            UserDetails: this.eventCache.getUserDetails(),
            RumEvents: this.eventCache.getEventBatch()
        };
    };
    return Dispatch;
}();

},{"./DataPlaneClient":"fP8d9","./BeaconHttpHandler":"69qfQ","./FetchHttpHandler":"hpinX","uuid":"jPA13","./RetryHttpHandler":"kXCYX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fP8d9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataPlaneClient", ()=>DataPlaneClient);
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _sha256Js = require("@aws-crypto/sha256-js");
var _protocolHttp = require("@aws-sdk/protocol-http");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var SERVICE = "rum";
var METHOD = "POST";
var CONTENT_TYPE_JSON = "application/json";
var CONTENT_TYPE_TEXT = "text/plain;charset=UTF-8";
var REQUEST_PRESIGN_ARGS = {
    expiresIn: 60
};
var DataPlaneClient = /** @class */ function() {
    function DataPlaneClient(config) {
        var _this = this;
        this.sendFetch = function(putRumEventsRequest) {
            return __awaiter(_this, void 0, void 0, function() {
                var options, request, httpResponse;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getHttpRequestOptions(putRumEventsRequest, CONTENT_TYPE_JSON)
                            ];
                        case 1:
                            options = _a.sent();
                            request = new (0, _protocolHttp.HttpRequest)(options);
                            if (!this.awsSigV4) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.awsSigV4.sign(request)
                            ];
                        case 2:
                            request = _a.sent();
                            _a.label = 3;
                        case 3:
                            httpResponse = this.config.fetchRequestHandler.handle(request);
                            return [
                                2 /*return*/ ,
                                httpResponse
                            ];
                    }
                });
            });
        };
        this.sendBeacon = function(putRumEventsRequest) {
            return __awaiter(_this, void 0, void 0, function() {
                var options, request, httpResponse;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getHttpRequestOptions(putRumEventsRequest, CONTENT_TYPE_TEXT)
                            ];
                        case 1:
                            options = _a.sent();
                            request = new (0, _protocolHttp.HttpRequest)(options);
                            if (!this.awsSigV4) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.awsSigV4.presign(request, REQUEST_PRESIGN_ARGS)
                            ];
                        case 2:
                            request = _a.sent();
                            _a.label = 3;
                        case 3:
                            httpResponse = this.config.beaconRequestHandler.handle(request);
                            return [
                                2 /*return*/ ,
                                httpResponse
                            ];
                    }
                });
            });
        };
        this.getHttpRequestOptions = function(putRumEventsRequest, contentType) {
            return __awaiter(_this, void 0, void 0, function() {
                var serializedRequest, path, options, _a, _b, _c;
                var _d, _e;
                return __generator(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            serializedRequest = JSON.stringify(serializeRequest(putRumEventsRequest));
                            path = this.config.endpoint.pathname.replace(/\/$/, "");
                            options = {
                                method: METHOD,
                                protocol: this.config.endpoint.protocol,
                                headers: {
                                    "content-type": contentType,
                                    host: this.config.endpoint.host
                                },
                                hostname: this.config.endpoint.hostname,
                                path: "".concat(path, "/appmonitors/").concat(putRumEventsRequest.AppMonitorDetails.id),
                                body: serializedRequest
                            };
                            if (!this.awsSigV4) return [
                                3 /*break*/ ,
                                2
                            ];
                            _a = [
                                __assign({}, options)
                            ];
                            _d = {};
                            _b = [
                                __assign({}, options.headers)
                            ];
                            _e = {};
                            _c = "X-Amz-Content-Sha256";
                            return [
                                4 /*yield*/ ,
                                hashAndEncode(serializedRequest)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                __assign.apply(void 0, _a.concat([
                                    (_d.headers = __assign.apply(void 0, _b.concat([
                                        (_e[_c] = _f.sent(), _e)
                                    ])), _d)
                                ]))
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                options
                            ];
                    }
                });
            });
        };
        this.config = config;
        if (config.credentials) this.awsSigV4 = new (0, _signatureV4.SignatureV4)({
            applyChecksum: true,
            credentials: config.credentials,
            region: config.region,
            service: SERVICE,
            uriEscapePath: true,
            sha256: (0, _sha256Js.Sha256)
        });
    }
    return DataPlaneClient;
}();
var serializeRequest = function(request) {
    //  If we were using the AWS SDK client here then the serialization would be handled for us through a generated
    //  serialization/deserialization library. However, since much of the generated code is unnecessary, we do the
    //  serialization ourselves with this function.
    var serializedRumEvents = [];
    request.RumEvents.forEach(function(e) {
        return serializedRumEvents.push(serializeEvent(e));
    });
    var serializedRequest = {
        BatchId: request.BatchId,
        AppMonitorDetails: request.AppMonitorDetails,
        UserDetails: request.UserDetails,
        RumEvents: serializedRumEvents
    };
    return serializedRequest;
};
var serializeEvent = function(event) {
    return {
        id: event.id,
        // Dates must be converted to timestamps before serialization.
        timestamp: Math.round(event.timestamp.getTime() / 1000),
        type: event.type,
        metadata: event.metadata,
        details: event.details
    };
};
var hashAndEncode = function(payload) {
    return __awaiter(void 0, void 0, void 0, function() {
        var sha256, _a;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    sha256 = new (0, _sha256Js.Sha256)();
                    sha256.update(payload);
                    _a = (0, _utilHexEncoding.toHex);
                    return [
                        4 /*yield*/ ,
                        sha256.digest()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            _b.sent()
                        ]).toLowerCase()
                    ];
            }
        });
    });
};

},{"@aws-sdk/util-hex-encoding":"48ew1","@aws-sdk/signature-v4":"1OesF","@aws-crypto/sha256-js":"caSy1","@aws-sdk/protocol-http":"adaIv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"48ew1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
const SHORT_TO_HEX = {};
const HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function toHex(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1OesF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>(0, _getCanonicalHeaders.getCanonicalHeaders));
parcelHelpers.export(exports, "getCanonicalQuery", ()=>(0, _getCanonicalQuery.getCanonicalQuery));
parcelHelpers.export(exports, "getPayloadHash", ()=>(0, _getPayloadHash.getPayloadHash));
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>(0, _moveHeadersToQuery.moveHeadersToQuery));
parcelHelpers.export(exports, "prepareRequest", ()=>(0, _prepareRequest.prepareRequest));
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"aI0h0","./getCanonicalHeaders":"iAO3w","./getCanonicalQuery":"69cEw","./getPayloadHash":"kJmGV","./moveHeadersToQuery":"jJPsw","./prepareRequest":"eRBMf","./credentialDerivation":"lyoMf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aI0h0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _eventstreamCodec = require("@aws-sdk/eventstream-codec");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _utilUtf8 = require("@aws-sdk/util-utf8");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
class SignatureV4 {
    constructor({ applyChecksum, credentials, region, service, sha256, uriEscapePath = true }){
        this.headerMarshaller = new (0, _eventstreamCodec.HeaderMarshaller)((0, _utilUtf8.toUtf8), (0, _utilUtf8.fromUtf8));
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate = new Date(), expiresIn = 3600, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate, shortDate } = formatDate(signingDate);
        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService ?? this.service);
        const request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
            unhoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
        const canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
        request.query[0, _constants.SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers, payload }, { signingDate = new Date(), priorSignature, signingRegion, signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate, longDate } = formatDate(signingDate);
        const scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, _getPayloadHash.getPayloadHash)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, _utilHexEncoding.toHex)(await hash.digest());
        const stringToSign = [
            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate,
            signingRegion: region,
            signingService
        });
    }
    async signMessage(signableMessage, { signingDate = new Date(), signingRegion, signingService }) {
        const promise = this.signEvent({
            headers: this.headerMarshaller.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate,
            signingRegion,
            signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature
            };
        });
    }
    async signString(stringToSign, { signingDate = new Date(), signingRegion, signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate } = formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, _utilUtf8.toUint8Array)(stringToSign));
        return (0, _utilHexEncoding.toHex)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate = new Date(), signableHeaders, unsignableHeaders, signingRegion, signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, _prepareRequest.prepareRequest)(requestToSign);
        const { longDate, shortDate } = formatDate(signingDate);
        const scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService ?? this.service);
        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
        const payloadHash = await (0, _getPayloadHash.getPayloadHash)(request, this.sha256);
        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
        const canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, _constants.AUTH_HEADER] = `${0, _constants.ALGORITHM_IDENTIFIER} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, _getCanonicalQuery.getCanonicalQuery)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, _utilUtf8.toUint8Array)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, _constants.ALGORITHM_IDENTIFIER}
${longDate}
${credentialScope}
${(0, _utilHexEncoding.toHex)(hashedRequest)}`;
    }
    getCanonicalPath({ path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, _utilUtf8.toUint8Array)(stringToSign));
        return (0, _utilHexEncoding.toHex)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
}
const formatDate = (now)=>{
    const longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");

},{"@aws-sdk/eventstream-codec":"a5CLG","@aws-sdk/util-hex-encoding":"48ew1","@aws-sdk/util-middleware":"6Toa2","@aws-sdk/util-utf8":"99O4b","./constants":"8Az8j","./credentialDerivation":"lyoMf","./getCanonicalHeaders":"iAO3w","./getCanonicalQuery":"69cEw","./getPayloadHash":"kJmGV","./headerUtil":"agYCq","./moveHeadersToQuery":"jJPsw","./prepareRequest":"eRBMf","./utilDate":"et5Oh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a5CLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamCodec = require("./EventStreamCodec");
parcelHelpers.exportAll(_eventStreamCodec, exports);
var _headerMarshaller = require("./HeaderMarshaller");
parcelHelpers.exportAll(_headerMarshaller, exports);
var _int64 = require("./Int64");
parcelHelpers.exportAll(_int64, exports);
var _message = require("./Message");
parcelHelpers.exportAll(_message, exports);
var _messageDecoderStream = require("./MessageDecoderStream");
parcelHelpers.exportAll(_messageDecoderStream, exports);
var _messageEncoderStream = require("./MessageEncoderStream");
parcelHelpers.exportAll(_messageEncoderStream, exports);
var _smithyMessageDecoderStream = require("./SmithyMessageDecoderStream");
parcelHelpers.exportAll(_smithyMessageDecoderStream, exports);
var _smithyMessageEncoderStream = require("./SmithyMessageEncoderStream");
parcelHelpers.exportAll(_smithyMessageEncoderStream, exports);

},{"./EventStreamCodec":"59aCG","./HeaderMarshaller":"ixgSp","./Int64":"49qai","./Message":"bDR9p","./MessageDecoderStream":"haB5l","./MessageEncoderStream":"1NZ9m","./SmithyMessageDecoderStream":"U2ytk","./SmithyMessageEncoderStream":"gn3mB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"59aCG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamCodec", ()=>EventStreamCodec);
var _crc32 = require("@aws-crypto/crc32");
var _headerMarshaller = require("./HeaderMarshaller");
var _splitMessage = require("./splitMessage");
class EventStreamCodec {
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, _headerMarshaller.HeaderMarshaller)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, _crc32.Crc32)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers, body } = (0, _splitMessage.splitMessage)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
}

},{"@aws-crypto/crc32":"fg6Ce","./HeaderMarshaller":"ixgSp","./splitMessage":"f7EE2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fg6Ce":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = exports.Crc32 = exports.crc32 = void 0;
var tslib_1 = require("625b2e433d473f50");
var util_1 = require("4503c024a6d5a246");
function crc32(data) {
    return new Crc32().update(data).digest();
}
exports.crc32 = crc32;
var Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = tslib_1.__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
exports.Crc32 = Crc32;
// prettier-ignore
var a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
var aws_crc32_1 = require("7e2887d04bddab92");
Object.defineProperty(exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return aws_crc32_1.AwsCrc32;
    }
});

},{"625b2e433d473f50":"gN78y","4503c024a6d5a246":"k2O8V","7e2887d04bddab92":"59Q40"}],"gN78y":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2O8V":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("557ff27f8d90f07d");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("6232e45558883315");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("b2e5a5f3626fe5ea");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("be4090d813f7e19");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"557ff27f8d90f07d":"57JyI","6232e45558883315":"3K0NT","b2e5a5f3626fe5ea":"a2nwT","be4090d813f7e19":"gAMlw"}],"57JyI":[function(require,module,exports) {
var Buffer = require("f43a27ff15165185").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("4b37e189f3b1936c");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"f43a27ff15165185":"l5Twm","4b37e189f3b1936c":"cVhYD"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"cVhYD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
const fromUtf8 = (input)=>typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
const toUtf8 = (input)=>typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);

},{"./pureJs":"avK5s","./whatwgEncodingApi":"9PJy6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avK5s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
const fromUtf8 = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const toUtf8 = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9PJy6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3K0NT":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"a2nwT":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"gAMlw":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"59Q40":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = void 0;
var tslib_1 = require("6e5554bb30b250f7");
var util_1 = require("80bf73f87f1a2fa7");
var index_1 = require("169572e7f35827aa");
var AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new index_1.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash)) return;
        this.crc32.update((0, util_1.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
            return tslib_1.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, util_1.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new index_1.Crc32();
    };
    return AwsCrc32;
}();
exports.AwsCrc32 = AwsCrc32;

},{"6e5554bb30b250f7":"gN78y","80bf73f87f1a2fa7":"k2O8V","169572e7f35827aa":"fg6Ce"}],"ixgSp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderMarshaller", ()=>HeaderMarshaller);
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _int64 = require("./Int64");
class HeaderMarshaller {
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, _int64.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, _utilHexEncoding.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: LONG_TAG,
                        value: new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: TIMESTAMP_TAG,
                        value: new Date(new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: UUID_TAG,
                        value: `${(0, _utilHexEncoding.toHex)(uuidBytes.subarray(0, 4))}-${(0, _utilHexEncoding.toHex)(uuidBytes.subarray(4, 6))}-${(0, _utilHexEncoding.toHex)(uuidBytes.subarray(6, 8))}-${(0, _utilHexEncoding.toHex)(uuidBytes.subarray(8, 10))}-${(0, _utilHexEncoding.toHex)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
}
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
const BOOLEAN_TAG = "boolean";
const BYTE_TAG = "byte";
const SHORT_TAG = "short";
const INT_TAG = "integer";
const LONG_TAG = "long";
const BINARY_TAG = "binary";
const STRING_TAG = "string";
const TIMESTAMP_TAG = "timestamp";
const UUID_TAG = "uuid";
const UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

},{"@aws-sdk/util-hex-encoding":"48ew1","./Int64":"49qai","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"49qai":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Int64", ()=>Int64);
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
class Int64 {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) negate(bytes);
        return new Int64(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) negate(bytes);
        return parseInt((0, _utilHexEncoding.toHex)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

},{"@aws-sdk/util-hex-encoding":"48ew1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7EE2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitMessage", ()=>splitMessage);
var _crc32 = require("@aws-crypto/crc32");
const PRELUDE_MEMBER_LENGTH = 4;
const PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
const CHECKSUM_LENGTH = 4;
const MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage({ byteLength, byteOffset, buffer }) {
    if (byteLength < MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32(PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32(PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - CHECKSUM_LENGTH, false);
    const checksummer = new (0, _crc32.Crc32)().update(new Uint8Array(buffer, byteOffset, PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH, byteLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
    };
}

},{"@aws-crypto/crc32":"fg6Ce","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDR9p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haB5l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageDecoderStream", ()=>MessageDecoderStream);
class MessageDecoderStream {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1NZ9m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageEncoderStream", ()=>MessageEncoderStream);
class MessageEncoderStream {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"U2ytk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmithyMessageDecoderStream", ()=>SmithyMessageDecoderStream);
class SmithyMessageDecoderStream {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gn3mB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmithyMessageEncoderStream", ()=>SmithyMessageEncoderStream);
class SmithyMessageEncoderStream {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Toa2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _normalizeProvider = require("./normalizeProvider");
parcelHelpers.exportAll(_normalizeProvider, exports);

},{"./normalizeProvider":"eRgym","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRgym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeProvider", ()=>normalizeProvider);
const normalizeProvider = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99O4b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fromUtf8 = require("./fromUtf8");
parcelHelpers.exportAll(_fromUtf8, exports);
var _toUint8Array = require("./toUint8Array");
parcelHelpers.exportAll(_toUint8Array, exports);
var _toUtf8 = require("./toUtf8");
parcelHelpers.exportAll(_toUtf8, exports);

},{"./fromUtf8":"5QbyZ","./toUint8Array":"ha2Kz","./toUtf8":"7YIAJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QbyZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
const fromUtf8 = (input)=>new TextEncoder().encode(input);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ha2Kz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toUint8Array", ()=>toUint8Array);
var _fromUtf8 = require("./fromUtf8");
const toUint8Array = (data)=>{
    if (typeof data === "string") return (0, _fromUtf8.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

},{"./fromUtf8":"5QbyZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7YIAJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
const toUtf8 = (input)=>new TextDecoder("utf-8").decode(input);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Az8j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", ()=>ALGORITHM_IDENTIFIER_V4A);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
const ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
const CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
const AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
const SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
const EXPIRES_QUERY_PARAM = "X-Amz-Expires";
const SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
const TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
const REGION_SET_PARAM = "X-Amz-Region-Set";
const AUTH_HEADER = "authorization";
const AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
const DATE_HEADER = "date";
const GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
const SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
const SHA256_HEADER = "x-amz-content-sha256";
const TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
const HOST_HEADER = "host";
const ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const PROXY_HEADER_PATTERN = /^proxy-/;
const SEC_HEADER_PATTERN = /^sec-/;
const UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
const ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
const ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
const EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
const UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
const MAX_CACHE_SIZE = 50;
const KEY_TYPE_IDENTIFIER = "aws4_request";
const MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lyoMf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilUtf8 = require("@aws-sdk/util-utf8");
var _constants = require("./constants");
const signingKeyCache = {};
const cacheQueue = [];
const createScope = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, _constants.KEY_TYPE_IDENTIFIER}`;
const getSigningKey = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, _utilHexEncoding.toHex)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in signingKeyCache) return signingKeyCache[cacheKey];
    cacheQueue.push(cacheKey);
    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, _constants.KEY_TYPE_IDENTIFIER)
    ])key = await hmac(sha256Constructor, key, signable);
    return signingKeyCache[cacheKey] = key;
};
const clearCredentialCache = ()=>{
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach((cacheKey)=>{
        delete signingKeyCache[cacheKey];
    });
};
const hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, _utilUtf8.toUint8Array)(data));
    return hash.digest();
};

},{"@aws-sdk/util-hex-encoding":"48ew1","@aws-sdk/util-utf8":"99O4b","./constants":"8Az8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iAO3w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _constants = require("./constants");
const getCanonicalHeaders = ({ headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || unsignableHeaders?.has(canonicalHeaderName) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};

},{"./constants":"8Az8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"69cEw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
const getCanonicalQuery = ({ query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query).sort()){
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) continue;
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") serialized[key] = `${(0, _utilUriEscape.escapeUri)(key)}=${(0, _utilUriEscape.escapeUri)(value)}`;
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce((encoded, value)=>encoded.concat([
                `${(0, _utilUriEscape.escapeUri)(key)}=${(0, _utilUriEscape.escapeUri)(value)}`
            ]), []).join("&");
    }
    return keys.map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};

},{"@aws-sdk/util-uri-escape":"k6TcL","./constants":"8Az8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJmGV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilUtf8 = require("@aws-sdk/util-utf8");
var _constants = require("./constants");
const getPayloadHash = async ({ headers, body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, _utilUtf8.toUint8Array)(body));
        return (0, _utilHexEncoding.toHex)(await hashCtor.digest());
    }
    return 0, _constants.UNSIGNED_PAYLOAD;
};

},{"@aws-sdk/is-array-buffer":"bewxH","@aws-sdk/util-hex-encoding":"48ew1","@aws-sdk/util-utf8":"99O4b","./constants":"8Az8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bewxH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
const isArrayBuffer = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agYCq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
parcelHelpers.export(exports, "getHeaderValue", ()=>getHeaderValue);
parcelHelpers.export(exports, "deleteHeader", ()=>deleteHeader);
const hasHeader = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const getHeaderValue = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const deleteHeader = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jJPsw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _cloneRequest = require("./cloneRequest");
const moveHeadersToQuery = (request, options = {})=>{
    const { headers, query = {} } = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers,
        query
    };
};

},{"./cloneRequest":"b6QWl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6QWl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
parcelHelpers.export(exports, "cloneQuery", ()=>cloneQuery);
const cloneRequest = ({ headers, query, ...rest })=>({
        ...rest,
        headers: {
            ...headers
        },
        query: query ? cloneQuery(query) : undefined
    });
const cloneQuery = (query)=>Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRBMf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
const prepareRequest = (request)=>{
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    for (const headerName of Object.keys(request.headers))if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};

},{"./cloneRequest":"b6QWl","./constants":"8Az8j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"et5Oh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
const iso8601 = (time)=>toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const toDate = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"caSy1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("55a0c88016adf0b");
tslib_1.__exportStar(require("b3f772825ac9a55e"), exports);

},{"55a0c88016adf0b":"gN78y","b3f772825ac9a55e":"burDD"}],"burDD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("b81e2e8d18e47446");
var constants_1 = require("d8e1bd0255b943a0");
var RawSha256_1 = require("dee12c42c12ba240");
var util_1 = require("86d7503c3396b374");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
            return tslib_1.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"b81e2e8d18e47446":"gN78y","d8e1bd0255b943a0":"9wIKb","dee12c42c12ba240":"6MAGZ","86d7503c3396b374":"hl7S1"}],"9wIKb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"6MAGZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("500f15b1eed913e4");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"500f15b1eed913e4":"9wIKb"}],"hl7S1":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("29496fd80c0a4b80");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("d5a5cacaa86339e3");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("fbe75532b11bde1f");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("766b0cbc97ca8bae");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"29496fd80c0a4b80":"dW5QX","d5a5cacaa86339e3":"e42Qa","fbe75532b11bde1f":"6baWU","766b0cbc97ca8bae":"4Obwl"}],"dW5QX":[function(require,module,exports) {
var Buffer = require("b672a03e9e61767d").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("a5de32e731829768");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"b672a03e9e61767d":"l5Twm","a5de32e731829768":"cVhYD"}],"e42Qa":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"6baWU":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"4Obwl":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"69qfQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BeaconHttpHandler", ()=>BeaconHttpHandler);
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var BeaconHttpHandler = /** @class */ function() {
    function BeaconHttpHandler() {}
    BeaconHttpHandler.prototype.handle = function(request) {
        var queued = this.sendBeacon(request);
        return new Promise(function(resolve, reject) {
            if (queued) resolve({
                response: new (0, _protocolHttp.HttpResponse)({
                    statusCode: 200
                })
            });
            else reject();
        });
    };
    BeaconHttpHandler.prototype.sendBeacon = function(signedRequest) {
        var path = signedRequest.path;
        if (signedRequest.query) {
            var queryString = (0, _querystringBuilder.buildQueryString)(signedRequest.query);
            if (queryString) path += "?".concat(queryString);
        }
        var port = signedRequest.port;
        var url = "".concat(signedRequest.protocol, "//").concat(signedRequest.hostname).concat(port ? ":".concat(port) : "").concat(path);
        return navigator.sendBeacon(url, signedRequest.body);
    };
    return BeaconHttpHandler;
}();

},{"@aws-sdk/protocol-http":"adaIv","@aws-sdk/querystring-builder":"kjmcN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hpinX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, fetchFunction = _b.fetchFunction, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
        this.fetchFunction = fetchFunction;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, _querystringBuilder.buildQueryString)(request.query);
            if (queryString) path += "?".concat(queryString);
        }
        var port = request.port, method = request.method;
        var url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions.signal = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            this.fetchFunction.apply(window, [
                fetchRequest
            ]).then(function(response) {
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                for(var _i = 0, _a = fetchHeaders.entries(); _i < _a.length; _i++){
                    var pair = _a[_i];
                    transformedHeaders[pair[0]] = pair[1];
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, _protocolHttp.HttpResponse)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, _protocolHttp.HttpResponse)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();

},{"@aws-sdk/protocol-http":"adaIv","@aws-sdk/querystring-builder":"kjmcN","./request-timeout":"3IHBq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3IHBq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
var requestTimeout = function(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXCYX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RetryHttpHandler", ()=>RetryHttpHandler);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * An HttpHandler which wraps other HttpHandlers to retry requests.
 *
 * Requests will be retried if (1) there is an error (e.g., with the network or
 * credentials) and the promise rejects, or (2) the response status is not 2xx.
 */ var RetryHttpHandler = /** @class */ function() {
    function RetryHttpHandler(handler, retries, backoff) {
        if (backoff === void 0) backoff = function(n) {
            return n * 2000;
        };
        this.isStatusCode2xx = function(statusCode) {
            return statusCode >= 200 && statusCode < 300;
        };
        this.handler = handler;
        this.retries = retries;
        this.backoff = backoff;
    }
    RetryHttpHandler.prototype.handle = function(request) {
        return __awaiter(this, void 0, void 0, function() {
            var retriesLeft, response, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        retriesLeft = this.retries;
                        _a.label = 1;
                    case 1:
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.handler.handle(request)
                        ];
                    case 3:
                        response = _a.sent();
                        if (this.isStatusCode2xx(response.response.statusCode)) return [
                            2 /*return*/ ,
                            response
                        ];
                        throw new Error("".concat(response.response.statusCode));
                    case 4:
                        e_1 = _a.sent();
                        if (!retriesLeft) throw e_1;
                        retriesLeft--;
                        return [
                            4 /*yield*/ ,
                            this.sleep(this.backoff(this.retries - retriesLeft))
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RetryHttpHandler.prototype.sleep = function(milliseconds) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        return setTimeout(resolve, milliseconds);
                    })
                ];
            });
        });
    };
    return RetryHttpHandler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lQiC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NAVIGATION_EVENT_PLUGIN_ID", ()=>NAVIGATION_EVENT_PLUGIN_ID);
parcelHelpers.export(exports, "NavigationPlugin", ()=>NavigationPlugin);
var _internalPlugin = require("../InternalPlugin");
var _constant = require("../utils/constant");
var _performanceUtils = require("../utils/performance-utils");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var NAVIGATION_EVENT_PLUGIN_ID = "navigation";
var NAVIGATION = "navigation";
var LOAD = "load";
/**
 * This plugin records performance timing events generated during every page load/re-load activity.
 * Paint, resource and performance event types make sense only if all or none are included.
 * For RUM, these event types are inter-dependent. So they are recorded under one plugin.
 */ var NavigationPlugin = /** @class */ function(_super) {
    __extends(NavigationPlugin, _super);
    function NavigationPlugin(config) {
        var _this = _super.call(this, NAVIGATION_EVENT_PLUGIN_ID) || this;
        /**
         * Use Navigation timing Level 1 for all browsers by default -
         * https://developer.mozilla.org/en-US/docs/Web/API/Performance/timing
         *
         * If browser provides support, use Navigation Timing Level 2 specification -
         * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
         *
         * Only the current document resource is included in the performance timeline;
         * there is only one PerformanceNavigationTiming object in the performance timeline.
         * https://www.w3.org/TR/navigation-timing-2/
         */ _this.eventListener = function() {
            if (performance.getEntriesByType(NAVIGATION).length === 0) _this.performanceNavigationEventHandlerTimingLevel1();
            else {
                var navigationObserver = new PerformanceObserver(function(list) {
                    list.getEntries().filter(function(e) {
                        return e.entryType === NAVIGATION;
                    }).filter(function(e) {
                        return !_this.config.ignore(e);
                    }).forEach(function(event) {
                        _this.performanceNavigationEventHandlerTimingLevel2(event);
                    });
                });
                navigationObserver.observe({
                    entryTypes: [
                        NAVIGATION
                    ]
                });
            }
        };
        /**
         * W3C specification: https://www.w3.org/TR/navigation-timing/#sec-navigation-timing-interface
         */ _this.performanceNavigationEventHandlerTimingLevel1 = function() {
            var recordNavigation = function() {
                var _a;
                var entryData = performance.timing;
                var origin = entryData.navigationStart;
                var eventDataNavigationTimingLevel1 = {
                    version: "1.0.0",
                    initiatorType: "navigation",
                    startTime: 0,
                    unloadEventStart: entryData.unloadEventStart > 0 ? entryData.unloadEventStart - origin : 0,
                    promptForUnload: entryData.unloadEventEnd - entryData.unloadEventStart,
                    redirectStart: entryData.redirectStart > 0 ? entryData.redirectStart - origin : 0,
                    redirectTime: entryData.redirectEnd - entryData.redirectStart,
                    fetchStart: entryData.fetchStart > 0 ? entryData.fetchStart - origin : 0,
                    domainLookupStart: entryData.domainLookupStart > 0 ? entryData.domainLookupStart - origin : 0,
                    dns: entryData.domainLookupEnd - entryData.domainLookupStart,
                    connectStart: entryData.connectStart > 0 ? entryData.connectStart - origin : 0,
                    connect: entryData.connectEnd - entryData.connectStart,
                    secureConnectionStart: entryData.secureConnectionStart > 0 ? entryData.secureConnectionStart - origin : 0,
                    tlsTime: entryData.secureConnectionStart > 0 ? entryData.connectEnd - entryData.secureConnectionStart : 0,
                    requestStart: entryData.requestStart > 0 ? entryData.requestStart - origin : 0,
                    timeToFirstByte: entryData.responseStart - entryData.requestStart,
                    responseStart: entryData.responseStart > 0 ? entryData.responseStart - origin : 0,
                    responseTime: entryData.responseStart > 0 ? entryData.responseEnd - entryData.responseStart : 0,
                    domInteractive: entryData.domInteractive > 0 ? entryData.domInteractive - origin : 0,
                    domContentLoadedEventStart: entryData.domContentLoadedEventStart > 0 ? entryData.domContentLoadedEventStart - origin : 0,
                    domContentLoaded: entryData.domContentLoadedEventEnd - entryData.domContentLoadedEventStart,
                    domComplete: entryData.domComplete > 0 ? entryData.domComplete - origin : 0,
                    domProcessingTime: entryData.loadEventStart - entryData.responseEnd,
                    loadEventStart: entryData.loadEventStart > 0 ? entryData.loadEventStart - origin : 0,
                    loadEventTime: entryData.loadEventEnd - entryData.loadEventStart,
                    duration: entryData.loadEventEnd - entryData.navigationStart,
                    navigationTimingLevel: 1
                };
                if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) _this.context.record((0, _constant.PERFORMANCE_NAVIGATION_EVENT_TYPE), eventDataNavigationTimingLevel1);
            };
            // Timeout is required for loadEventEnd to complete
            setTimeout(recordNavigation, 0);
        };
        /**
         * W3C specification: https://www.w3.org/TR/navigation-timing-2/#bib-navigation-timing
         */ _this.performanceNavigationEventHandlerTimingLevel2 = function(entryData) {
            var _a;
            var eventDataNavigationTimingLevel2 = {
                version: "1.0.0",
                initiatorType: entryData.initiatorType,
                navigationType: entryData.type,
                startTime: entryData.startTime,
                unloadEventStart: entryData.unloadEventStart,
                promptForUnload: entryData.unloadEventEnd - entryData.unloadEventStart,
                redirectCount: entryData.redirectCount,
                redirectStart: entryData.redirectStart,
                redirectTime: entryData.redirectEnd - entryData.redirectStart,
                workerStart: entryData.workerStart,
                workerTime: entryData.workerStart > 0 ? entryData.fetchStart - entryData.workerStart : 0,
                fetchStart: entryData.fetchStart,
                domainLookupStart: entryData.domainLookupStart,
                dns: entryData.domainLookupEnd - entryData.domainLookupStart,
                nextHopProtocol: entryData.nextHopProtocol,
                connectStart: entryData.connectStart,
                connect: entryData.connectEnd - entryData.connectStart,
                secureConnectionStart: entryData.secureConnectionStart,
                tlsTime: entryData.secureConnectionStart > 0 ? entryData.connectEnd - entryData.secureConnectionStart : 0,
                requestStart: entryData.requestStart,
                timeToFirstByte: entryData.responseStart - entryData.requestStart,
                responseStart: entryData.responseStart,
                responseTime: entryData.responseStart > 0 ? entryData.responseEnd - entryData.responseStart : 0,
                domInteractive: entryData.domInteractive,
                domContentLoadedEventStart: entryData.domContentLoadedEventStart,
                domContentLoaded: entryData.domContentLoadedEventEnd - entryData.domContentLoadedEventStart,
                domComplete: entryData.domComplete,
                domProcessingTime: entryData.loadEventStart - entryData.responseEnd,
                loadEventStart: entryData.loadEventStart,
                loadEventTime: entryData.loadEventEnd - entryData.loadEventStart,
                duration: entryData.duration,
                headerSize: entryData.transferSize - entryData.encodedBodySize,
                transferSize: entryData.transferSize,
                compressionRatio: entryData.encodedBodySize > 0 ? entryData.decodedBodySize / entryData.encodedBodySize : 0,
                navigationTimingLevel: 2
            };
            if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) _this.context.record((0, _constant.PERFORMANCE_NAVIGATION_EVENT_TYPE), eventDataNavigationTimingLevel2);
        };
        _this.config = __assign(__assign({}, (0, _performanceUtils.defaultPerformancePluginConfig)), config);
        return _this;
    }
    NavigationPlugin.prototype.enable = function() {
        if (this.enabled) return;
        this.enabled = true;
        window.addEventListener(LOAD, this.eventListener);
    };
    NavigationPlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.eventListener) window.removeEventListener(LOAD, this.eventListener);
    };
    /**
     * Use the loadEventEnd field from window.performance to check if the website
     * has loaded already.
     *
     * @returns boolean
     */ NavigationPlugin.prototype.hasTheWindowLoadEventFired = function() {
        if (window.performance && window.performance.getEntriesByType(NAVIGATION).length) {
            var navData = window.performance.getEntriesByType(NAVIGATION)[0];
            return Boolean(navData.loadEventEnd);
        }
        return false;
    };
    /**
     * loadEventEnd is populated as 0 if the web page has not loaded completely, even though LOAD has been fired.
     * As a result, if loadEventEnd is populated, we can ignore eventListener and record the data directly.
     * On the other hand, if not, we have to use eventListener to initializes PerformanceObserver.
     * PerformanceObserver will act as a second check for the final load timings.
     */ NavigationPlugin.prototype.onload = function() {
        var _this = this;
        if (this.enabled) {
            if (this.hasTheWindowLoadEventFired()) window.performance.getEntriesByType(NAVIGATION).filter(function(e) {
                return !_this.config.ignore(e);
            }).forEach(function(event) {
                return _this.performanceNavigationEventHandlerTimingLevel2(event);
            });
            else window.addEventListener(LOAD, this.eventListener);
        }
    };
    return NavigationPlugin;
}((0, _internalPlugin.InternalPlugin));

},{"../InternalPlugin":"78Kz0","../utils/constant":"iL2Vg","../utils/performance-utils":"6Zy3z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Zy3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIgnore", ()=>defaultIgnore);
parcelHelpers.export(exports, "defaultPerformancePluginConfig", ()=>defaultPerformancePluginConfig);
var _commonUtils = require("../../utils/common-utils");
var defaultIgnore = function(entry) {
    return entry.entryType === "resource" && !/^https?:/.test(entry.name);
};
var defaultPerformancePluginConfig = {
    eventLimit: 10,
    ignore: defaultIgnore,
    recordAllTypes: [
        (0, _commonUtils.ResourceType).DOCUMENT,
        (0, _commonUtils.ResourceType).SCRIPT
    ],
    sampleTypes: [
        (0, _commonUtils.ResourceType).STYLESHEET,
        (0, _commonUtils.ResourceType).IMAGE,
        (0, _commonUtils.ResourceType).FONT,
        (0, _commonUtils.ResourceType).OTHER
    ]
};

},{"../../utils/common-utils":"gA3kJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gA3kJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceType", ()=>ResourceType);
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
parcelHelpers.export(exports, "getResourceFileType", ()=>getResourceFileType);
parcelHelpers.export(exports, "httpStatusText", ()=>httpStatusText);
var ResourceType;
(function(ResourceType) {
    ResourceType["OTHER"] = "other";
    ResourceType["STYLESHEET"] = "stylesheet";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["SCRIPT"] = "script";
    ResourceType["IMAGE"] = "image";
    ResourceType["FONT"] = "font";
})(ResourceType || (ResourceType = {}));
var extensions = [
    {
        name: ResourceType.STYLESHEET,
        list: [
            "css",
            "less"
        ]
    },
    {
        name: ResourceType.DOCUMENT,
        list: [
            "htm",
            "html",
            "ts",
            "doc",
            "docx",
            "pdf",
            "xls",
            "xlsx"
        ]
    },
    {
        name: ResourceType.SCRIPT,
        list: [
            "js"
        ]
    },
    {
        name: ResourceType.IMAGE,
        list: [
            "ai",
            "bmp",
            "gif",
            "ico",
            "jpeg",
            "jpg",
            "png",
            "ps",
            "psd",
            "svg",
            "tif",
            "tiff"
        ]
    },
    {
        name: ResourceType.FONT,
        list: [
            "fnt",
            "fon",
            "otf",
            "ttf",
            "woff"
        ]
    }
];
var shuffle = function(a) {
    for(var i = a.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var v = a[i];
        a[i] = a[j];
        a[j] = v;
    }
};
var getResourceFileType = function(url) {
    var filename = url.substring(url.lastIndexOf("/") + 1);
    var extension = filename.substring(filename.lastIndexOf(".") + 1).split(/[?#]/)[0];
    var ext = ResourceType.OTHER;
    extensions.forEach(function(type) {
        if (type.list.indexOf(extension) > -1) ext = type.name;
    });
    return ext;
};
var httpStatusText = {
    "0": "Abort Request",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "306": "Unused",
    "307": "Temporary Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Required",
    "413": "Request Entry Too Large",
    "414": "Request-URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Requested Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": 'I"m a teapot',
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BSZE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RESOURCE_EVENT_PLUGIN_ID", ()=>RESOURCE_EVENT_PLUGIN_ID);
parcelHelpers.export(exports, "ResourcePlugin", ()=>ResourcePlugin);
var _internalPlugin = require("../InternalPlugin");
var _commonUtils = require("../../utils/common-utils");
var _constant = require("../utils/constant");
var _performanceUtils = require("../utils/performance-utils");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var RESOURCE_EVENT_PLUGIN_ID = "resource";
var RESOURCE = "resource";
var LOAD = "load";
/**
 * This plugin records resource performance timing events generated during every page load/re-load.
 */ var ResourcePlugin = /** @class */ function(_super) {
    __extends(ResourcePlugin, _super);
    function ResourcePlugin(config) {
        var _this = _super.call(this, RESOURCE_EVENT_PLUGIN_ID) || this;
        _this.resourceEventListener = function(event) {
            var recordAll = [];
            var sample = [];
            var eventCount = 0;
            var resourceObserver = new PerformanceObserver(function(list) {
                list.getEntries().filter(function(e) {
                    return e.entryType === RESOURCE;
                }).filter(function(e) {
                    return !_this.config.ignore(e);
                }).forEach(function(event) {
                    // Out of n resource events, x events are recorded using Observer API
                    var type = (0, _commonUtils.getResourceFileType)(event.name);
                    if (_this.config.recordAllTypes.includes(type)) recordAll.push(event);
                    else if (_this.config.sampleTypes.includes(type)) sample.push(event);
                });
            });
            resourceObserver.observe({
                entryTypes: [
                    RESOURCE
                ]
            });
            // Remaining (n-x) resource events are recorded using getEntriesByType API.
            // Note: IE11 browser does not support Performance Observer API. Handle the failure gracefully
            var events = performance.getEntriesByType(RESOURCE);
            if (events !== undefined && events.length > 0) events.filter(function(e) {
                return !_this.config.ignore(e);
            }).forEach(function(event) {
                var type = (0, _commonUtils.getResourceFileType)(event.name);
                if (_this.config.recordAllTypes.includes(type)) recordAll.push(event);
                else if (_this.config.sampleTypes.includes(type)) sample.push(event);
            });
            // Record events for resources in recordAllTypes
            (0, _commonUtils.shuffle)(recordAll);
            while(recordAll.length > 0 && eventCount < _this.config.eventLimit){
                _this.recordResourceEvent(recordAll.pop());
                eventCount++;
            }
            // Record events sampled from resources in sample
            (0, _commonUtils.shuffle)(sample);
            while(sample.length > 0 && eventCount < _this.config.eventLimit){
                _this.recordResourceEvent(sample.pop());
                eventCount++;
            }
        };
        _this.recordResourceEvent = function(entryData) {
            var _a;
            var pathRegex = /.*\/application\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/events/;
            var entryUrl = new URL(entryData.name);
            if (entryUrl.host === _this.context.config.endpointUrl.host && pathRegex.test(entryUrl.pathname)) // Ignore calls to PutRumEvents (i.e., the CloudWatch RUM data
            // plane), otherwise we end up in an infinite loop of recording
            // PutRumEvents.
            return;
            if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) {
                var eventData = {
                    version: "1.0.0",
                    initiatorType: entryData.initiatorType,
                    duration: entryData.duration,
                    fileType: (0, _commonUtils.getResourceFileType)(entryData.name),
                    transferSize: entryData.transferSize
                };
                if (_this.context.config.recordResourceUrl) eventData.targetUrl = entryData.name;
                _this.context.record((0, _constant.PERFORMANCE_RESOURCE_EVENT_TYPE), eventData);
            }
        };
        _this.config = __assign(__assign({}, (0, _performanceUtils.defaultPerformancePluginConfig)), config);
        return _this;
    }
    ResourcePlugin.prototype.enable = function() {
        if (this.enabled) return;
        this.enabled = true;
        window.addEventListener(LOAD, this.resourceEventListener);
    };
    ResourcePlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.resourceEventListener) window.removeEventListener(LOAD, this.resourceEventListener);
    };
    ResourcePlugin.prototype.onload = function() {
        window.addEventListener(LOAD, this.resourceEventListener);
    };
    return ResourcePlugin;
}((0, _internalPlugin.InternalPlugin));

},{"../InternalPlugin":"78Kz0","../../utils/common-utils":"gA3kJ","../utils/constant":"iL2Vg","../utils/performance-utils":"6Zy3z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1da0w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEB_VITAL_EVENT_PLUGIN_ID", ()=>WEB_VITAL_EVENT_PLUGIN_ID);
parcelHelpers.export(exports, "WebVitalsPlugin", ()=>WebVitalsPlugin);
var _internalPlugin = require("../InternalPlugin");
var _webVitals = require("web-vitals");
var _constant = require("../utils/constant");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var WEB_VITAL_EVENT_PLUGIN_ID = "web-vitals";
var WebVitalsPlugin = /** @class */ function(_super) {
    __extends(WebVitalsPlugin, _super);
    function WebVitalsPlugin() {
        return _super.call(this, WEB_VITAL_EVENT_PLUGIN_ID) || this;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    WebVitalsPlugin.prototype.enable = function() {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    WebVitalsPlugin.prototype.disable = function() {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    WebVitalsPlugin.prototype.configure = function(config) {};
    WebVitalsPlugin.prototype.getWebVitalData = function(webVitalData, eventType) {
        var _a;
        var webVitalEvent = {
            version: "1.0.0",
            value: webVitalData.value
        };
        (_a = this.context) === null || _a === void 0 || _a.record(eventType, webVitalEvent);
    };
    WebVitalsPlugin.prototype.onload = function() {
        var _this = this;
        (0, _webVitals.onLCP)(function(data) {
            return _this.getWebVitalData(data, (0, _constant.LCP_EVENT_TYPE));
        });
        (0, _webVitals.onFID)(function(data) {
            return _this.getWebVitalData(data, (0, _constant.FID_EVENT_TYPE));
        });
        (0, _webVitals.onCLS)(function(data) {
            return _this.getWebVitalData(data, (0, _constant.CLS_EVENT_TYPE));
        });
    };
    return WebVitalsPlugin;
}((0, _internalPlugin.InternalPlugin));

},{"../InternalPlugin":"78Kz0","web-vitals":"7WohC","../utils/constant":"iL2Vg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WohC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLSThresholds", ()=>w);
parcelHelpers.export(exports, "FCPThresholds", ()=>L);
parcelHelpers.export(exports, "FIDThresholds", ()=>D);
parcelHelpers.export(exports, "INPThresholds", ()=>j);
parcelHelpers.export(exports, "LCPThresholds", ()=>U);
parcelHelpers.export(exports, "TTFBThresholds", ()=>X);
parcelHelpers.export(exports, "getCLS", ()=>S);
parcelHelpers.export(exports, "getFCP", ()=>b);
parcelHelpers.export(exports, "getFID", ()=>x);
parcelHelpers.export(exports, "getINP", ()=>Q);
parcelHelpers.export(exports, "getLCP", ()=>W);
parcelHelpers.export(exports, "getTTFB", ()=>Z);
parcelHelpers.export(exports, "onCLS", ()=>S);
parcelHelpers.export(exports, "onFCP", ()=>b);
parcelHelpers.export(exports, "onFID", ()=>x);
parcelHelpers.export(exports, "onINP", ()=>Q);
parcelHelpers.export(exports, "onLCP", ()=>W);
parcelHelpers.export(exports, "onTTFB", ()=>Z);
var e, n, t, r, i, a = -1, o = function(e) {
    addEventListener("pageshow", function(n) {
        n.persisted && (a = n.timeStamp, e(n));
    }, !0);
}, c = function() {
    return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, u = function() {
    var e = c();
    return e && e.activationStart || 0;
}, f = function(e, n) {
    var t = c(), r = "navigate";
    a >= 0 ? r = "back-forward-cache" : t && (document.prerendering || u() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-")));
    return {
        name: e,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: r
    };
}, s = function(e, n, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var r = new PerformanceObserver(function(e) {
                Promise.resolve().then(function() {
                    n(e.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: e,
                buffered: !0
            }, t || {})), r;
        }
    } catch (e) {}
}, d = function(e, n, t, r) {
    var i, a;
    return function(o) {
        n.value >= 0 && (o || r) && ((a = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = a, n.rating = function(e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
        }(n.value, t), e(n));
    };
}, l = function(e) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return e();
        });
    });
}, p = function(e) {
    var n = function(n) {
        "pagehide" !== n.type && "hidden" !== document.visibilityState || e(n);
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, v = function(e) {
    var n = !1;
    return function(t) {
        n || (e(t), n = !0);
    };
}, m = -1, h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, g = function(e) {
    "hidden" === document.visibilityState && m > -1 && (m = "visibilitychange" === e.type ? e.timeStamp : 0, T());
}, y = function() {
    addEventListener("visibilitychange", g, !0), addEventListener("prerenderingchange", g, !0);
}, T = function() {
    removeEventListener("visibilitychange", g, !0), removeEventListener("prerenderingchange", g, !0);
}, E = function() {
    return m < 0 && (m = h(), y(), o(function() {
        setTimeout(function() {
            m = h(), y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return m;
        }
    };
}, C = function(e) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return e();
    }, !0) : e();
}, L = [
    1800,
    3e3
], b = function(e, n) {
    n = n || {}, C(function() {
        var t, r = E(), i = f("FCP"), a = s("paint", function(e) {
            e.forEach(function(e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - u(), 0), i.entries.push(e), t(!0)));
            });
        });
        a && (t = d(e, i, L, n.reportAllChanges), o(function(r) {
            i = f("FCP"), t = d(e, i, L, n.reportAllChanges), l(function() {
                i.value = performance.now() - r.timeStamp, t(!0);
            });
        }));
    });
}, w = [
    .1,
    .25
], S = function(e, n) {
    n = n || {}, b(v(function() {
        var t, r = f("CLS", 0), i = 0, a = [], c = function(e) {
            e.forEach(function(e) {
                if (!e.hadRecentInput) {
                    var n = a[0], t = a[a.length - 1];
                    i && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (i += e.value, a.push(e)) : (i = e.value, a = [
                        e
                    ]);
                }
            }), i > r.value && (r.value = i, r.entries = a, t());
        }, u = s("layout-shift", c);
        u && (t = d(e, r, w, n.reportAllChanges), p(function() {
            c(u.takeRecords()), t(!0);
        }), o(function() {
            i = 0, r = f("CLS", 0), t = d(e, r, w, n.reportAllChanges), l(function() {
                return t();
            });
        }), setTimeout(t, 0));
    }));
}, A = {
    passive: !0,
    capture: !0
}, I = new Date, P = function(r, i) {
    e || (e = i, n = r, t = new Date, k(removeEventListener), F());
}, F = function() {
    if (n >= 0 && n < t - I) {
        var i = {
            entryType: "first-input",
            name: e.type,
            target: e.target,
            cancelable: e.cancelable,
            startTime: e.timeStamp,
            processingStart: e.timeStamp + n
        };
        r.forEach(function(e) {
            e(i);
        }), r = [];
    }
}, M = function(e) {
    if (e.cancelable) {
        var n = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, n) {
            var t = function() {
                P(e, n), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", t, A), removeEventListener("pointercancel", r, A);
            };
            addEventListener("pointerup", t, A), addEventListener("pointercancel", r, A);
        }(n, e) : P(n, e);
    }
}, k = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return e(n, M, A);
    });
}, D = [
    100,
    300
], x = function(t, i) {
    i = i || {}, C(function() {
        var a, c = E(), u = f("FID"), l = function(e) {
            e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
        }, m = function(e) {
            e.forEach(l);
        }, h = s("first-input", m);
        a = d(t, u, D, i.reportAllChanges), h && p(v(function() {
            m(h.takeRecords()), h.disconnect();
        })), h && o(function() {
            var o;
            u = f("FID"), a = d(t, u, D, i.reportAllChanges), r = [], n = -1, e = null, k(addEventListener), o = l, r.push(o), F();
        });
    });
}, B = 0, R = 1 / 0, H = 0, N = function(e) {
    e.forEach(function(e) {
        e.interactionId && (R = Math.min(R, e.interactionId), H = Math.max(H, e.interactionId), B = H ? (H - R) / 7 + 1 : 0);
    });
}, O = function() {
    return i ? B : performance.interactionCount || 0;
}, q = function() {
    "interactionCount" in performance || i || (i = s("event", N, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, j = [
    200,
    500
], _ = 0, z = function() {
    return O() - _;
}, G = [], J = {}, K = function(e) {
    var n = G[G.length - 1], t = J[e.interactionId];
    if (t || G.length < 10 || e.duration > n.latency) {
        if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
        else {
            var r = {
                id: e.interactionId,
                latency: e.duration,
                entries: [
                    e
                ]
            };
            J[r.id] = r, G.push(r);
        }
        G.sort(function(e, n) {
            return n.latency - e.latency;
        }), G.splice(10).forEach(function(e) {
            delete J[e.id];
        });
    }
}, Q = function(e, n) {
    n = n || {}, C(function() {
        q();
        var t, r = f("INP"), i = function(e) {
            e.forEach(function(e) {
                (e.interactionId && K(e), "first-input" === e.entryType) && !G.some(function(n) {
                    return n.entries.some(function(n) {
                        return e.duration === n.duration && e.startTime === n.startTime;
                    });
                }) && K(e);
            });
            var n, i = (n = Math.min(G.length - 1, Math.floor(z() / 50)), G[n]);
            i && i.latency !== r.value && (r.value = i.latency, r.entries = i.entries, t());
        }, a = s("event", i, {
            durationThreshold: n.durationThreshold || 40
        });
        t = d(e, r, j, n.reportAllChanges), a && (a.observe({
            type: "first-input",
            buffered: !0
        }), p(function() {
            i(a.takeRecords()), r.value < 0 && z() > 0 && (r.value = 0, r.entries = []), t(!0);
        }), o(function() {
            G = [], _ = O(), r = f("INP"), t = d(e, r, j, n.reportAllChanges);
        }));
    });
}, U = [
    2500,
    4e3
], V = {}, W = function(e, n) {
    n = n || {}, C(function() {
        var t, r = E(), i = f("LCP"), a = function(e) {
            var n = e[e.length - 1];
            n && n.startTime < r.firstHiddenTime && (i.value = Math.max(n.startTime - u(), 0), i.entries = [
                n
            ], t());
        }, c = s("largest-contentful-paint", a);
        if (c) {
            t = d(e, i, U, n.reportAllChanges);
            var m = v(function() {
                V[i.id] || (a(c.takeRecords()), c.disconnect(), V[i.id] = !0, t(!0));
            });
            [
                "keydown",
                "click"
            ].forEach(function(e) {
                addEventListener(e, m, !0);
            }), p(m), o(function(r) {
                i = f("LCP"), t = d(e, i, U, n.reportAllChanges), l(function() {
                    i.value = performance.now() - r.timeStamp, V[i.id] = !0, t(!0);
                });
            });
        }
    });
}, X = [
    800,
    1800
], Y = function e(n) {
    document.prerendering ? C(function() {
        return e(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return e(n);
    }, !0) : setTimeout(n, 0);
}, Z = function(e, n) {
    n = n || {};
    var t = f("TTFB"), r = d(e, t, X, n.reportAllChanges);
    Y(function() {
        var i = c();
        if (i) {
            var a = i.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - u(), 0), t.entries = [
                i
            ], r(!0), o(function() {
                t = f("TTFB", 0), (r = d(e, t, X, n.reportAllChanges))(!0);
            });
        }
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2458V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XHR_PLUGIN_ID", ()=>XHR_PLUGIN_ID);
parcelHelpers.export(exports, "XhrPlugin", ()=>XhrPlugin);
var _monkeyPatched = require("../MonkeyPatched");
var _httpUtils = require("../utils/http-utils");
var _xhrError = require("../../errors/XhrError");
var _constant = require("../utils/constant");
var _jsErrorUtils = require("../utils/js-error-utils");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var XHR_PLUGIN_ID = "xhr";
/**
 * A plugin which initiates and records AWS X-Ray traces for XML HTTP requests (XMLHttpRequest).
 *
 * The XMLHttpRequest API is monkey patched using shimmer so all calls to XMLHttpRequest are intercepted. Only calls
 * to URLs which are on the allowlist and are not on the denylist are traced and recorded.
 *
 * The XHR events we use (i.e., onload, onerror, onabort, ontimeout) are only
 * supported by newer browsers. If we want to support older browsers we will
 * need to detect older browsers and use the onreadystatechange event.
 *
 * For example, the following sequence events occur for each case:
 *
 * Case 1: Request succeeds events
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 2, status = 200)
 * readystatechange (state = 3, status = 200)
 * readystatechange (state = 4, status = 200)
 * load
 * loadend
 *
 * Case 2: Request fails because of invalid domain or CORS failure
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 4, status = 0)
 * error
 * loadend
 *
 * Case 3: Request fails because of timeout
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 4, status = 0)
 * timeout
 * loadend
 *
 * Case 4: Request is aborted
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 2, status = 200)
 * readystatechange (state = 3, status = 200)
 * readystatechange (state = 4, status = 0)
 * abort
 * loadend
 *
 * See
 * - https://xhr.spec.whatwg.org/#event-handlers.
 * - https://xhr.spec.whatwg.org/#events
 */ var XhrPlugin = /** @class */ function(_super) {
    __extends(XhrPlugin, _super);
    function XhrPlugin(config) {
        var _this = _super.call(this, XHR_PLUGIN_ID) || this;
        _this.addXRayTraceIdHeader = function() {
            return _this.config.addXRayTraceIdHeader;
        };
        _this.isTracingEnabled = function() {
            return _this.context.config.enableXRay;
        };
        _this.isSessionRecorded = function() {
            var _a;
            return ((_a = _this.context.getSession()) === null || _a === void 0 ? void 0 : _a.record) || false;
        };
        _this.handleXhrLoadEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            if (xhrDetails) {
                var endTimee = (0, _httpUtils.epochTime)();
                xhrDetails.trace.end_time = endTimee;
                xhrDetails.trace.subsegments[0].end_time = endTimee;
                xhrDetails.trace.subsegments[0].http.response = {
                    status: xhr.status
                };
                if ((0, _httpUtils.is429)(xhr.status)) {
                    xhrDetails.trace.subsegments[0].throttle = true;
                    xhrDetails.trace.throttle = true;
                } else if ((0, _httpUtils.is4xx)(xhr.status)) {
                    xhrDetails.trace.subsegments[0].error = true;
                    xhrDetails.trace.error = true;
                } else if ((0, _httpUtils.is5xx)(xhr.status)) {
                    xhrDetails.trace.subsegments[0].fault = true;
                    xhrDetails.trace.fault = true;
                }
                var clStr = xhr.getResponseHeader("Content-Length");
                var cl = clStr ? parseInt(clStr, 10) : NaN;
                if (!isNaN(cl)) xhrDetails.trace.subsegments[0].http.response.content_length = cl;
                _this.recordTraceEvent(xhrDetails.trace);
                _this.recordHttpEventWithResponse(xhrDetails, xhr);
            }
        };
        _this.handleXhrErrorEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            var errorName = "XMLHttpRequest error";
            var errorMessage = xhr.statusText ? xhr.status.toString() + ": " + xhr.statusText : xhr.status.toString();
            if (xhrDetails) {
                var endTime = (0, _httpUtils.epochTime)();
                // Guidance from X-Ray documentation:
                // > Record errors in segments when your application returns an
                // > error to the user, and in subsegments when a downstream call
                // > returns an error.
                xhrDetails.trace.fault = true;
                xhrDetails.trace.end_time = endTime;
                xhrDetails.trace.subsegments[0].end_time = endTime;
                xhrDetails.trace.subsegments[0].fault = true;
                xhrDetails.trace.subsegments[0].cause = {
                    exceptions: [
                        {
                            type: errorName,
                            message: errorMessage
                        }
                    ]
                };
                _this.recordTraceEvent(xhrDetails.trace);
                _this.recordHttpEventWithError(xhrDetails, new (0, _xhrError.XhrError)(errorMessage));
            }
        };
        _this.handleXhrAbortEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            var errorName = "XMLHttpRequest abort";
            _this.handleXhrDetailsOnError(xhrDetails, errorName);
        };
        _this.handleXhrTimeoutEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            var errorName = "XMLHttpRequest timeout";
            _this.handleXhrDetailsOnError(xhrDetails, errorName);
        };
        _this.initializeTrace = function(xhrDetails) {
            var startTime = (0, _httpUtils.epochTime)();
            xhrDetails.trace = (0, _httpUtils.createXRayTraceEvent)(_this.config.logicalServiceName, startTime);
            xhrDetails.trace.subsegments.push((0, _httpUtils.createXRaySubsegment)((0, _httpUtils.requestInfoToHostname)(xhrDetails.url), startTime, {
                request: {
                    method: xhrDetails.method,
                    url: xhrDetails.url,
                    traced: true
                }
            }));
        };
        _this.sendWrapper = function() {
            var self = _this;
            return function(original) {
                return function() {
                    var xhrDetails = self.xhrMap.get(this);
                    if (xhrDetails) {
                        this.addEventListener("load", self.handleXhrLoadEvent);
                        this.addEventListener("error", self.handleXhrErrorEvent);
                        this.addEventListener("abort", self.handleXhrAbortEvent);
                        this.addEventListener("timeout", self.handleXhrTimeoutEvent);
                        self.initializeTrace(xhrDetails);
                        if (self.isTracingEnabled() && self.addXRayTraceIdHeader() && self.isSessionRecorded()) this.setRequestHeader((0, _httpUtils.X_AMZN_TRACE_ID), (0, _httpUtils.getAmznTraceIdHeaderValue)(xhrDetails.trace.trace_id, xhrDetails.trace.subsegments[0].id));
                    }
                    return original.apply(this, arguments);
                };
            };
        };
        _this.openWrapper = function() {
            var self = _this;
            return function(original) {
                return function(method, url, async) {
                    if ((0, _httpUtils.isUrlAllowed)(url, self.config)) self.xhrMap.set(this, {
                        url: url,
                        method: method,
                        async: async
                    });
                    return original.apply(this, arguments);
                };
            };
        };
        _this.config = __assign(__assign({}, (0, _httpUtils.defaultConfig)), config);
        _this.xhrMap = new Map();
        return _this;
    }
    XhrPlugin.prototype.onload = function() {
        this.enable();
    };
    Object.defineProperty(XhrPlugin.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: XMLHttpRequest.prototype,
                    name: "send",
                    wrapper: this.sendWrapper
                },
                {
                    nodule: XMLHttpRequest.prototype,
                    name: "open",
                    wrapper: this.openWrapper
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    XhrPlugin.prototype.handleXhrDetailsOnError = function(xhrDetails, errorName) {
        if (xhrDetails) {
            var endTime = (0, _httpUtils.epochTime)();
            xhrDetails.trace.end_time = endTime;
            xhrDetails.trace.subsegments[0].end_time = endTime;
            xhrDetails.trace.subsegments[0].error = true;
            xhrDetails.trace.subsegments[0].cause = {
                exceptions: [
                    {
                        type: errorName
                    }
                ]
            };
            this.recordTraceEvent(xhrDetails.trace);
            this.recordHttpEventWithError(xhrDetails, errorName);
        }
    };
    XhrPlugin.prototype.statusOk = function(status) {
        return status >= 200 && status < 300;
    };
    XhrPlugin.prototype.recordHttpEventWithResponse = function(xhrDetails, xhr) {
        if (this.config.recordAllRequests || !this.statusOk(xhr.status)) this.context.record((0, _constant.HTTP_EVENT_TYPE), {
            version: "1.0.0",
            request: {
                method: xhrDetails.method,
                url: xhrDetails.url
            },
            response: {
                status: xhr.status,
                statusText: xhr.statusText
            }
        });
    };
    XhrPlugin.prototype.recordHttpEventWithError = function(xhrDetails, error) {
        var httpEvent = {
            version: "1.0.0",
            request: {
                method: xhrDetails.method,
                url: xhrDetails.url
            }
        };
        httpEvent.error = (0, _jsErrorUtils.errorEventToJsErrorEvent)({
            type: "error",
            error: error
        }, this.config.stackTraceLength);
        this.context.record((0, _constant.HTTP_EVENT_TYPE), httpEvent);
    };
    XhrPlugin.prototype.recordTraceEvent = function(trace) {
        if (this.isTracingEnabled() && this.isSessionRecorded()) this.context.record((0, _constant.XRAY_TRACE_EVENT_TYPE), trace);
    };
    return XhrPlugin;
}((0, _monkeyPatched.MonkeyPatched));

},{"../MonkeyPatched":"1UnKu","../utils/http-utils":"9xG8S","../../errors/XhrError":"k4lE9","../utils/constant":"iL2Vg","../utils/js-error-utils":"c5nK7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9xG8S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "byteToHex", ()=>byteToHex);
parcelHelpers.export(exports, "X_AMZN_TRACE_ID", ()=>X_AMZN_TRACE_ID);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "is4xx", ()=>is4xx);
parcelHelpers.export(exports, "is5xx", ()=>is5xx);
parcelHelpers.export(exports, "is429", ()=>is429);
parcelHelpers.export(exports, "isUrlAllowed", ()=>isUrlAllowed);
parcelHelpers.export(exports, "epochTime", ()=>epochTime);
parcelHelpers.export(exports, "createXRayTraceEventHttp", ()=>createXRayTraceEventHttp);
parcelHelpers.export(exports, "createXRayTraceEvent", ()=>createXRayTraceEvent);
parcelHelpers.export(exports, "createXRaySubsegment", ()=>createXRaySubsegment);
parcelHelpers.export(exports, "requestInfoToHostname", ()=>requestInfoToHostname);
parcelHelpers.export(exports, "addAmznTraceIdHeaderToInit", ()=>addAmznTraceIdHeaderToInit);
parcelHelpers.export(exports, "addAmznTraceIdHeaderToHeaders", ()=>addAmznTraceIdHeaderToHeaders);
parcelHelpers.export(exports, "getAmznTraceIdHeaderValue", ()=>getAmznTraceIdHeaderValue);
parcelHelpers.export(exports, "resourceToUrlString", ()=>resourceToUrlString);
var _random = require("../../utils/random");
var byteToHex = [];
for(var i = 0; i < 256; i++)byteToHex[i] = (i + 0x100).toString(16).substr(1);
var X_AMZN_TRACE_ID = "X-Amzn-Trace-Id";
var defaultConfig = {
    logicalServiceName: "rum.aws.amazon.com",
    urlsToInclude: [
        /.*/
    ],
    urlsToExclude: [
        // Cognito endpoints https://docs.aws.amazon.com/general/latest/gr/cognito_identity.html
        /cognito\-identity\.([^\.]*\.)?amazonaws\.com/,
        // STS endpoints https://docs.aws.amazon.com/general/latest/gr/sts.html
        /sts\.([^\.]*\.)?amazonaws\.com/
    ],
    stackTraceLength: 200,
    recordAllRequests: false,
    addXRayTraceIdHeader: false
};
var is4xx = function(status) {
    return Math.floor(status / 100) === 4;
};
var is5xx = function(status) {
    return Math.floor(status / 100) === 5;
};
var is429 = function(status) {
    return status === 429;
};
var isUrlAllowed = function(url, config) {
    var include = config.urlsToInclude.some(function(urlPattern) {
        return urlPattern.test(url);
    });
    var exclude = config.urlsToExclude.some(function(urlPattern) {
        return urlPattern.test(url);
    });
    return include && !exclude;
};
var epochTime = function() {
    return Date.now() / 1000;
};
var createXRayTraceEventHttp = function(input, init, traced) {
    var http = {
        request: {}
    };
    http.request.method = (init === null || init === void 0 ? void 0 : init.method) ? init.method : "GET";
    http.request.traced = traced;
    http.request.url = resourceToUrlString(input);
    return http;
};
var createXRayTraceEvent = function(name, startTime, http) {
    var traceEvent = {
        version: "1.0.0",
        name: name,
        origin: "AWS::RUM::AppMonitor",
        id: generateSegmentId(),
        start_time: startTime,
        trace_id: generateTraceId(),
        end_time: undefined,
        subsegments: [],
        in_progress: false
    };
    if (http) traceEvent.http = http;
    return traceEvent;
};
var createXRaySubsegment = function(name, startTime, http) {
    var subsegment = {
        id: generateSegmentId(),
        name: name,
        start_time: startTime,
        end_time: undefined,
        in_progress: false,
        namespace: name.endsWith("amazonaws.com") ? "aws" : "remote"
    };
    if (http) subsegment.http = http;
    return subsegment;
};
var requestInfoToHostname = function(request) {
    try {
        if (request.hostname) return request.hostname;
        else if (request.url) return new URL(request.url).hostname;
        else return new URL(request.toString()).hostname;
    } catch (e) {
        // The URL could not be parsed. This library's convention is to fail
        // silently to limit the risk of impacting the application being
        // monitored.  We will use the hostname of the current page instead.
        return window.location.hostname;
    }
};
var addAmznTraceIdHeaderToInit = function(init, traceId, segmentId) {
    if (!init.headers) init.headers = {};
    init.headers[X_AMZN_TRACE_ID] = getAmznTraceIdHeaderValue(traceId, segmentId);
};
var addAmznTraceIdHeaderToHeaders = function(headers, traceId, segmentId) {
    headers.set(X_AMZN_TRACE_ID, getAmznTraceIdHeaderValue(traceId, segmentId));
};
var getAmznTraceIdHeaderValue = function(traceId, segmentId) {
    return "Root=" + traceId + ";Parent=" + segmentId + ";Sampled=1";
};
var resourceToUrlString = function(resource) {
    return resource.url ? resource.url : resource.toString();
};
/**
 * Generate a globally unique trace ID.
 *
 * See https://docs.aws.amazon.com/xray/latest/devguide/xray-api-sendingdata.html
 *
 * @returns a trace id with the form '1-[unix epoch time in 8 hex digits]-[random in 24 hex digits]'
 */ var generateTraceId = function() {
    return "1-".concat(hexTime(), "-").concat(guid());
};
/**
 * Generate a segment ID that is unique within a trace.
 *
 * See https://docs.aws.amazon.com/xray/latest/devguide/xray-api-sendingdata.html
 *
 * @returns a segment id, which is 16 random hex digits
 */ var generateSegmentId = function() {
    var randomBytes = new Uint8Array(8);
    (0, _random.getRandomValues)(randomBytes);
    return uint8ArrayToHexString(randomBytes);
};
var hexTime = function() {
    return Math.floor(Date.now() / 1000).toString(16);
};
var guid = function() {
    var randomBytes = new Uint8Array(12);
    (0, _random.getRandomValues)(randomBytes);
    return uint8ArrayToHexString(randomBytes);
};
var uint8ArrayToHexString = function(bytes) {
    var hexString = "";
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < bytes.length; i++)hexString += byteToHex[bytes[i]];
    return hexString;
};

},{"../../utils/random":"P5snb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"P5snb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRandomValues", ()=>getRandomValues);
var getRandomValues = function(holder) {
    if (crypto) return crypto.getRandomValues(holder);
    else if (msCrypto) return msCrypto.getRandomValues(holder);
    else throw new Error("No crypto library found.");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k4lE9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XhrError", ()=>XhrError);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var XhrError = /** @class */ function(_super) {
    __extends(XhrError, _super);
    function XhrError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "XMLHttpRequest error";
        return _this;
    }
    return XhrError;
}(Error);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fVkpt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FETCH_PLUGIN_ID", ()=>FETCH_PLUGIN_ID);
parcelHelpers.export(exports, "FetchPlugin", ()=>FetchPlugin);
var _monkeyPatched = require("../MonkeyPatched");
var _httpUtils = require("../utils/http-utils");
var _constant = require("../utils/constant");
var _jsErrorUtils = require("../utils/js-error-utils");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FETCH_PLUGIN_ID = "fetch";
/**
 * A plugin which initiates and records AWS X-Ray traces for fetch HTTP requests.
 *
 * The fetch API is monkey patched using shimmer so all calls to fetch are intercepted. Only calls to URLs which are
 * on the allowlist and are not on the denylist are traced and recorded.
 */ var FetchPlugin = /** @class */ function(_super) {
    __extends(FetchPlugin, _super);
    function FetchPlugin(config) {
        var _this = _super.call(this, FETCH_PLUGIN_ID) || this;
        _this.isTracingEnabled = function() {
            return _this.context.config.enableXRay;
        };
        _this.isSessionRecorded = function() {
            var _a;
            return ((_a = _this.context.getSession()) === null || _a === void 0 ? void 0 : _a.record) || false;
        };
        _this.beginTrace = function(input, init, argsArray) {
            var startTime = (0, _httpUtils.epochTime)();
            var http = (0, _httpUtils.createXRayTraceEventHttp)(input, init, true);
            var xRayTraceEvent = (0, _httpUtils.createXRayTraceEvent)(_this.config.logicalServiceName, startTime);
            var subsegment = (0, _httpUtils.createXRaySubsegment)((0, _httpUtils.requestInfoToHostname)(input), startTime, http);
            xRayTraceEvent.subsegments.push(subsegment);
            if (_this.config.addXRayTraceIdHeader) _this.addXRayTraceIdHeader(input, init, argsArray, xRayTraceEvent);
            return xRayTraceEvent;
        };
        _this.addXRayTraceIdHeader = function(input, init, argsArray, xRayTraceEvent) {
            if (input.headers) return (0, _httpUtils.addAmznTraceIdHeaderToHeaders)(input.headers, xRayTraceEvent.trace_id, xRayTraceEvent.subsegments[0].id);
            if (!init) {
                init = {};
                [].push.call(argsArray, init);
            }
            (0, _httpUtils.addAmznTraceIdHeaderToInit)(init, xRayTraceEvent.trace_id, xRayTraceEvent.subsegments[0].id);
        };
        _this.endTrace = function(xRayTraceEvent, response, error) {
            if (xRayTraceEvent) {
                var endTime = (0, _httpUtils.epochTime)();
                xRayTraceEvent.subsegments[0].end_time = endTime;
                xRayTraceEvent.end_time = endTime;
                if (response) {
                    xRayTraceEvent.subsegments[0].http.response = {
                        status: response.status
                    };
                    if ((0, _httpUtils.is429)(response.status)) {
                        xRayTraceEvent.subsegments[0].throttle = true;
                        xRayTraceEvent.throttle = true;
                    } else if ((0, _httpUtils.is4xx)(response.status)) {
                        xRayTraceEvent.subsegments[0].error = true;
                        xRayTraceEvent.error = true;
                    } else if ((0, _httpUtils.is5xx)(response.status)) {
                        xRayTraceEvent.subsegments[0].fault = true;
                        xRayTraceEvent.fault = true;
                    }
                    var clStr = response.headers.get("Content-Length");
                    var cl = clStr ? parseInt(clStr, 10) : NaN;
                    if (!isNaN(cl)) xRayTraceEvent.subsegments[0].http.response.content_length = cl;
                }
                if (error) {
                    // Guidance from X-Ray documentation:
                    // > Record errors in segments when your application returns an
                    // > error to the user, and in subsegments when a downstream call
                    // > returns an error.
                    xRayTraceEvent.fault = true;
                    xRayTraceEvent.subsegments[0].fault = true;
                    if (error instanceof Object) _this.appendErrorCauseFromObject(xRayTraceEvent.subsegments[0], error);
                    else if ((0, _jsErrorUtils.isErrorPrimitive)(error)) _this.appendErrorCauseFromPrimitive(xRayTraceEvent.subsegments[0], error.toString());
                }
                _this.context.record((0, _constant.XRAY_TRACE_EVENT_TYPE), xRayTraceEvent);
            }
        };
        _this.createHttpEvent = function(input, init) {
            var request = input;
            return {
                version: "1.0.0",
                request: {
                    url: (0, _httpUtils.resourceToUrlString)(input),
                    method: (init === null || init === void 0 ? void 0 : init.method) ? init.method : request.method ? request.method : "GET"
                }
            };
        };
        _this.recordHttpEventWithResponse = function(httpEvent, response) {
            if (_this.config.recordAllRequests || !response.ok) {
                httpEvent.response = {
                    status: response.status,
                    statusText: response.statusText
                };
                _this.context.record((0, _constant.HTTP_EVENT_TYPE), httpEvent);
            }
        };
        _this.recordHttpEventWithError = function(httpEvent, error) {
            httpEvent.error = (0, _jsErrorUtils.errorEventToJsErrorEvent)({
                type: "error",
                error: error
            }, _this.config.stackTraceLength);
            _this.context.record((0, _constant.HTTP_EVENT_TYPE), httpEvent);
        };
        _this.fetch = function(original, thisArg, argsArray, input, init) {
            var httpEvent = _this.createHttpEvent(input, init);
            var trace;
            if (!(0, _httpUtils.isUrlAllowed)((0, _httpUtils.resourceToUrlString)(input), _this.config)) return original.apply(thisArg, argsArray);
            if (_this.isTracingEnabled() && _this.isSessionRecorded()) trace = _this.beginTrace(input, init, argsArray);
            return original.apply(thisArg, argsArray).then(function(response) {
                _this.endTrace(trace, response, undefined);
                _this.recordHttpEventWithResponse(httpEvent, response);
                return response;
            }).catch(function(error) {
                _this.endTrace(trace, undefined, error);
                _this.recordHttpEventWithError(httpEvent, error);
                throw error;
            });
        };
        _this.fetchWrapper = function() {
            var self = _this;
            return function(original) {
                return function(input, init) {
                    return self.fetch(original, this, arguments, input, init);
                };
            };
        };
        _this.config = __assign(__assign({}, (0, _httpUtils.defaultConfig)), config);
        return _this;
    }
    Object.defineProperty(FetchPlugin.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: window,
                    name: "fetch",
                    wrapper: this.fetchWrapper
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    FetchPlugin.prototype.onload = function() {
        this.enable();
    };
    FetchPlugin.prototype.appendErrorCauseFromPrimitive = function(subsegment, error) {
        subsegment.cause = {
            exceptions: [
                {
                    type: error
                }
            ]
        };
    };
    FetchPlugin.prototype.appendErrorCauseFromObject = function(subsegment, error) {
        subsegment.cause = {
            exceptions: [
                {
                    type: error.name,
                    message: error.message
                }
            ]
        };
    };
    return FetchPlugin;
}((0, _monkeyPatched.MonkeyPatched));

},{"../MonkeyPatched":"1UnKu","../utils/http-utils":"9xG8S","../utils/constant":"iL2Vg","../utils/js-error-utils":"c5nK7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"81fOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PAGE_EVENT_PLUGIN_ID", ()=>PAGE_EVENT_PLUGIN_ID);
parcelHelpers.export(exports, "PageViewPlugin", ()=>PageViewPlugin);
var _orchestration = require("../../orchestration/Orchestration");
var _monkeyPatched = require("../MonkeyPatched");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var PAGE_EVENT_PLUGIN_ID = "page-view";
/**
 * A plugin which records page view transitions.
 *
 * When a session is initialized, the PageManager records the landing page. When
 * subsequent pages are viewed, this plugin updates the page.
 */ var PageViewPlugin = /** @class */ function(_super) {
    __extends(PageViewPlugin, _super);
    function PageViewPlugin() {
        var _this = _super.call(this, PAGE_EVENT_PLUGIN_ID) || this;
        _this.pushState = function() {
            var self = _this;
            return function(original) {
                return function(data, title, url) {
                    var retVal = original.apply(this, arguments);
                    self.recordPageView();
                    return retVal;
                };
            };
        };
        _this.replaceState = function() {
            var self = _this;
            return function(original) {
                return function(data, title, url) {
                    var retVal = original.apply(this, arguments);
                    self.recordPageView();
                    return retVal;
                };
            };
        };
        _this.popstateListener = function(event) {
            _this.recordPageView();
        };
        _this.recordPageView = function() {
            _this.context.recordPageView(_this.createIdForCurrentPage());
        };
        _this.enable();
        return _this;
    }
    PageViewPlugin.prototype.onload = function() {
        this.addListener();
        this.recordPageView();
    };
    Object.defineProperty(PageViewPlugin.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: History.prototype,
                    name: "pushState",
                    wrapper: this.pushState
                },
                {
                    nodule: History.prototype,
                    name: "replaceState",
                    wrapper: this.replaceState
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    PageViewPlugin.prototype.addListener = function() {
        // popstate will fire under the following conditions:
        // (1) The history back, forward or go APIs are used
        // (2) The URI's fragment (hash) changes
        window.addEventListener("popstate", this.popstateListener);
    };
    PageViewPlugin.prototype.createIdForCurrentPage = function() {
        var path = window.location.pathname;
        var hash = window.location.hash;
        switch(this.context.config.pageIdFormat){
            case (0, _orchestration.PageIdFormatEnum).PathAndHash:
                if (path && hash) return path + hash;
                else if (path) return path;
                else if (hash) return hash;
                return "";
            case (0, _orchestration.PageIdFormatEnum).Hash:
                return hash ? hash : "";
            case (0, _orchestration.PageIdFormatEnum).Path:
            default:
                return path ? path : "";
        }
    };
    return PageViewPlugin;
}((0, _monkeyPatched.MonkeyPatched));

},{"../../orchestration/Orchestration":"7WQDS","../MonkeyPatched":"1UnKu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9KpGA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pumsprovider = require("@amzn/PassportUserManagementUIAssets/dist/PUMSProvider");
var _pumsproviderDefault = parcelHelpers.interopDefault(_pumsprovider);
var _appLayout = require("@amzn/meridian/app-layout");
var _appLayoutDefault = parcelHelpers.interopDefault(_appLayout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _lpHeader = require("../components/LpHeader");
var _lpHeaderDefault = parcelHelpers.interopDefault(_lpHeader);
var _footer = require("../components/homePage/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _withIntl = require("../hoc/withIntl");
var _withIntlDefault = parcelHelpers.interopDefault(_withIntl);
var _routes = require("../routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
var _authorizedPageUtils = require("../utils/authorizedPageUtils");
var _sideNavMenu = require("./SideNavMenu");
var _sideNavMenuDefault = parcelHelpers.interopDefault(_sideNavMenu);
var _topBar = require("./TopBar");
var _topBarDefault = parcelHelpers.interopDefault(_topBar);
var _unAuthorizedAlert = require("./UnAuthorizedAlert");
var _unAuthorizedAlertDefault = parcelHelpers.interopDefault(_unAuthorizedAlert);
const Layout = ({ isLoading })=>{
    const [sideMenuState, setSideMenuState] = (0, _react.useState)(false);
    const { pathname } = (0, _reactRouter.useLocation)();
    const showLpHeader = (0, _authorizedPageUtils.shouldRenderHeader)(pathname);
    const onToggleSideMenu = (0, _react.useCallback)(()=>{
        setSideMenuState(!sideMenuState);
    }, [
        sideMenuState
    ]);
    const onCloseSideMenu = (0, _react.useCallback)(()=>{
        setSideMenuState(false);
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appLayoutDefault.default), {
        headerComponent: (0, _topBarDefault.default),
        sidebarComponent: (0, _sideNavMenuDefault.default),
        footerComponent: (0, _footerDefault.default)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pumsproviderDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _topBarDefault.default), {
        onClick: onToggleSideMenu
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideNavMenuDefault.default), {
        isMenuOpened: sideMenuState,
        onClose: onCloseSideMenu
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unAuthorizedAlertDefault.default), null), showLpHeader && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _lpHeaderDefault.default), null), !isLoading && (0, _routesDefault.default), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _footerDefault.default), null));
};
exports.default = (0, _withIntlDefault.default)(Layout);

},{"@amzn/PassportUserManagementUIAssets/dist/PUMSProvider":"f63ez","@amzn/meridian/app-layout":"77YTK","react":"6uln9","react-router":"i3TiW","../components/LpHeader":"1cj09","../components/homePage/Footer":"4i8wU","../hoc/withIntl":"7tU2V","../routes":"aqqjz","../utils/authorizedPageUtils":"8Nt2u","./SideNavMenu":"iYac6","./TopBar":"6gMzn","./UnAuthorizedAlert":"hMwza","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f63ez":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _store = require("./store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var PUMSProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        store: (0, _storeDefault.default)
    }, children);
};
exports.default = PUMSProvider;
PUMSProvider.propTypes = {};

},{"react":"6uln9","react-redux":"3qqlL","./store":"4AzAU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4AzAU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var _reduxObservable = require("redux-observable");
var _reduxLogger = require("redux-logger");
var _reduxLoggerDefault = parcelHelpers.interopDefault(_reduxLogger);
var _rootEpic = require("../epics/rootEpic");
var _rootEpicDefault = parcelHelpers.interopDefault(_rootEpic);
var _reducers = require("../reducers");
var _reducersDefault = parcelHelpers.interopDefault(_reducers);
var _services = require("../services");
var _servicesDefault = parcelHelpers.interopDefault(_services);
var _routerMiddleware = require("./middlewares/routerMiddleware");
var _routerMiddlewareDefault = parcelHelpers.interopDefault(_routerMiddleware);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ref, ref1;
var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)({
    dependencies: (0, _servicesDefault.default)
});
var middlewares = [
    (0, _reduxThunkDefault.default),
    (0, _routerMiddlewareDefault.default),
    epicMiddleware
];
if (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.host) === null || ref1 === void 0 ? void 0 : ref1.includes("localhost")) middlewares.push((0, _reduxLoggerDefault.default));
var store = (0, _redux.createStore)((0, _reducersDefault.default), (0, _redux.applyMiddleware).apply(void 0, _toConsumableArray(middlewares)));
epicMiddleware.run((0, _rootEpicDefault.default));
exports.default = store;

},{"redux":"8WK1P","redux-thunk":"hu2f1","redux-observable":"1ybGk","redux-logger":"lNEN9","../epics/rootEpic":"5EyEY","../reducers":"g8vao","../services":"9YUe1","./middlewares/routerMiddleware":"6Ek32","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8WK1P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}

},{"@babel/runtime/helpers/esm/objectSpread2":"dMcSe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMcSe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, _definePropertyJsDefault.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

},{"./defineProperty.js":"fpbwK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpbwK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hu2f1":[function(require,module,exports) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ybGk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>(0, _createEpicMiddleware.createEpicMiddleware));
parcelHelpers.export(exports, "ActionsObservable", ()=>(0, _actionsObservable.ActionsObservable));
parcelHelpers.export(exports, "StateObservable", ()=>(0, _stateObservable.StateObservable));
parcelHelpers.export(exports, "combineEpics", ()=>(0, _combineEpics.combineEpics));
parcelHelpers.export(exports, "ofType", ()=>(0, _operators.ofType));
var _createEpicMiddleware = require("./createEpicMiddleware");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _combineEpics = require("./combineEpics");
var _operators = require("./operators");

},{"./createEpicMiddleware":"lt3Rq","./ActionsObservable":false,"./StateObservable":false,"./combineEpics":"l2W6L","./operators":"8VlfM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lt3Rq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>createEpicMiddleware);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _console = require("./utils/console");
function createEpicMiddleware() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // This isn't great. RxJS doesn't publicly export the constructor for
    // QueueScheduler nor QueueAction, so we reach in. We need to do this because
    // we don't want our internal queuing mechanism to be on the same queue as any
    // other RxJS code outside of redux-observable internals.
    var QueueScheduler = (0, _rxjs.queueScheduler).constructor;
    var uniqueQueueScheduler = new QueueScheduler((0, _rxjs.queueScheduler).SchedulerAction);
    var epic$ = new (0, _rxjs.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        var actionSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var stateSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var action$ = new (0, _actionsObservable.ActionsObservable)(actionSubject$);
        var state$ = new (0, _stateObservable.StateObservable)(stateSubject$, store.getState());
        var result$ = epic$.pipe((0, _operators.map)(function(epic) {
            var output$ = "dependencies" in options ? epic(action$, state$, options.dependencies) : epic(action$, state$);
            if (!output$) throw new TypeError('Your root Epic "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        }), (0, _operators.mergeMap)(function(output$) {
            return (0, _rxjs.from)(output$).pipe((0, _operators.subscribeOn)(uniqueQueueScheduler), (0, _operators.observeOn)(uniqueQueueScheduler));
        }));
        result$.subscribe(store.dispatch);
        return function(next) {
            return function(action) {
                // Downstream middleware gets the action first,
                // which includes their reducers, so state is
                // updated before epics receive the action
                var result = next(action);
                // It's important to update the state$ before we emit
                // the action because otherwise it would be stale
                stateSubject$.next(store.getState());
                actionSubject$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.run = function(rootEpic) {
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

},{"rxjs":"ctXY8","rxjs/operators":"eRfPW","./ActionsObservable":"fpKjx","./StateObservable":"38SGX","./utils/console":"2y79S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ctXY8":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":"8jGVG","./internal/observable/ConnectableObservable":false,"./internal/operators/groupBy":false,"./internal/symbol/observable":false,"./internal/Subject":"eCd0Y","./internal/BehaviorSubject":false,"./internal/ReplaySubject":false,"./internal/AsyncSubject":false,"./internal/scheduler/asap":false,"./internal/scheduler/async":false,"./internal/scheduler/queue":"dB7LS","./internal/scheduler/animationFrame":false,"./internal/scheduler/VirtualTimeScheduler":false,"./internal/Scheduler":false,"./internal/Subscription":false,"./internal/Subscriber":false,"./internal/Notification":false,"./internal/util/pipe":false,"./internal/util/noop":false,"./internal/util/identity":false,"./internal/util/isObservable":false,"./internal/util/ArgumentOutOfRangeError":false,"./internal/util/EmptyError":false,"./internal/util/ObjectUnsubscribedError":false,"./internal/util/UnsubscriptionError":false,"./internal/util/TimeoutError":false,"./internal/observable/bindCallback":false,"./internal/observable/bindNodeCallback":false,"./internal/observable/combineLatest":false,"./internal/observable/concat":false,"./internal/observable/defer":false,"./internal/observable/empty":false,"./internal/observable/forkJoin":false,"./internal/observable/from":"sJ6h2","./internal/observable/fromEvent":false,"./internal/observable/fromEventPattern":false,"./internal/observable/generate":false,"./internal/observable/iif":false,"./internal/observable/interval":false,"./internal/observable/merge":"89dHK","./internal/observable/never":false,"./internal/observable/of":"gjdo9","./internal/observable/onErrorResumeNext":false,"./internal/observable/pairs":false,"./internal/observable/partition":false,"./internal/observable/race":false,"./internal/observable/range":false,"./internal/observable/throwError":false,"./internal/observable/timer":false,"./internal/observable/using":false,"./internal/observable/zip":false,"./internal/scheduled/scheduled":false,"./internal/config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8jGVG":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"8kTDm","./util/toSubscriber":"8j8Ea","./symbol/observable":"jNHKg","./util/pipe":"3SFYK","./config":"lcSHh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8kTDm":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"3WQni","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3WQni":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"7ny2u","./util/isFunction":"hw69O","./Observer":"9qutW","./Subscription":"1X691","../internal/symbol/rxSubscriber":"jgeB6","./config":"lcSHh","./util/hostReportError":"hDHiL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ny2u":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hw69O":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qutW":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"lcSHh","./util/hostReportError":"hDHiL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lcSHh":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDHiL":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1X691":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"7cfqc","./util/isObject":"lT4pY","./util/isFunction":"hw69O","./util/UnsubscriptionError":"lSnCO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cfqc":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lT4pY":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSnCO":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgeB6":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8j8Ea":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"3WQni","../symbol/rxSubscriber":"jgeB6","../Observer":"9qutW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jNHKg":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3SFYK":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"ksAYz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ksAYz":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eCd0Y":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"7ny2u","./Observable":"8jGVG","./Subscriber":"3WQni","./Subscription":"1X691","./util/ObjectUnsubscribedError":"fTtES","./SubjectSubscription":"e5DMW","../internal/symbol/rxSubscriber":"jgeB6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fTtES":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e5DMW":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"7ny2u","./Subscription":"1X691","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bIyCP":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = /*@__PURE__*/ new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"C85e1","./AsapScheduler":"1kbK0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"C85e1":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var _asyncAction = require("./AsyncAction");
var AsapAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, _immediate.Immediate).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, _immediate.Immediate).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"7ny2u","../util/Immediate":"lv1gg","./AsyncAction":"64PKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lv1gg":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"64PKy":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var AsyncAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"7ny2u","./Action":"8NFEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NFEz":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"7ny2u","../Subscription":"1X691","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1kbK0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"7ny2u","./AsyncScheduler":"9h6Hy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9h6Hy":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"7ny2u","../Scheduler":"57u7O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57u7O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var Scheduler = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dB7LS":[function(require,module,exports) {
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = /*@__PURE__*/ new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"jfpad","./QueueScheduler":"iORha","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfpad":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"7ny2u","./AsyncAction":"64PKy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iORha":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"7ny2u","./AsyncScheduler":"9h6Hy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"alzak":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var NotificationKind;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, _of.of)(this.value);
            case "E":
                return (0, _throwError.throwError)(this.error);
            case "C":
                return (0, _empty.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

},{"./observable/empty":"3r3oz","./observable/of":"gjdo9","./observable/throwError":"fuxhQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3r3oz":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = /*@__PURE__*/ new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"8jGVG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjdo9":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _isScheduler = require("../util/isScheduler");
var _fromArray = require("./fromArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        args.pop();
        return (0, _scheduleArray.scheduleArray)(args, scheduler);
    } else return (0, _fromArray.fromArray)(args);
}

},{"../util/isScheduler":"7Vgls","./fromArray":"XL0tX","../scheduled/scheduleArray":"9SGkg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Vgls":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
function isScheduler(value) {
    return value && typeof value.schedule === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XL0tX":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromArray", ()=>fromArray);
var _observable = require("../Observable");
var _subscribeToArray = require("../util/subscribeToArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function fromArray(input, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)((0, _subscribeToArray.subscribeToArray)(input));
    else return (0, _scheduleArray.scheduleArray)(input, scheduler);
}

},{"../Observable":"8jGVG","../util/subscribeToArray":"lCrDm","../scheduled/scheduleArray":"9SGkg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lCrDm":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SGkg":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"8jGVG","../Subscription":"1X691","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fuxhQ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
function throwError(error, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

},{"../Observable":"8jGVG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sJ6h2":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"8jGVG","../util/subscribeTo":"bfTtw","../scheduled/scheduled":"elTM8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfTtw":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"lCrDm","./subscribeToPromise":"cAkDH","./subscribeToIterable":"6h6I6","./subscribeToObservable":"I5cbU","./isArrayLike":"hdJHF","./isPromise":"jpmXR","./isObject":"lT4pY","../symbol/iterator":"24laF","../symbol/observable":"jNHKg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cAkDH":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"hDHiL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6h6I6":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"24laF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"24laF":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"I5cbU":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"jNHKg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdJHF":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpmXR":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"elTM8":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"ilrkS","./schedulePromise":"kXm5j","./scheduleArray":"9SGkg","./scheduleIterable":"1kBm1","../util/isInteropObservable":"4xthZ","../util/isPromise":"jpmXR","../util/isArrayLike":"hdJHF","../util/isIterable":"iZkeg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilrkS":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"8jGVG","../Subscription":"1X691","../symbol/observable":"jNHKg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXm5j":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"8jGVG","../Subscription":"1X691","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1kBm1":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"8jGVG","../Subscription":"1X691","../symbol/iterator":"24laF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4xthZ":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"jNHKg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZkeg":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"24laF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"89dHK":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _observable = require("../Observable");
var _isScheduler = require("../util/isScheduler");
var _mergeAll = require("../operators/mergeAll");
var _fromArray = require("./fromArray");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, _isScheduler.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, _observable.Observable)) return observables[0];
    return (0, _mergeAll.mergeAll)(concurrent)((0, _fromArray.fromArray)(observables, scheduler));
}

},{"../Observable":"8jGVG","../util/isScheduler":"7Vgls","../operators/mergeAll":"gWGq3","./fromArray":"XL0tX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWGq3":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"dKXP4","../util/identity":"ksAYz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dKXP4":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
parcelHelpers.export(exports, "MergeMapOperator", ()=>MergeMapOperator);
parcelHelpers.export(exports, "MergeMapSubscriber", ()=>MergeMapSubscriber);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(mergeMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new MergeMapOperator(project, concurrent));
    };
}
var MergeMapOperator = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));
var flatMap = mergeMap;

},{"tslib":"7ny2u","./map":"c9Dj4","../observable/from":"sJ6h2","../innerSubscribe":"2VMKc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c9Dj4":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"7ny2u","../Subscriber":"3WQni","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2VMKc":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

},{"tslib":"7ny2u","./Subscriber":"3WQni","./Observable":"8jGVG","./util/subscribeTo":"bfTtw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRfPW":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":false,"../internal/operators/auditTime":false,"../internal/operators/buffer":false,"../internal/operators/bufferCount":false,"../internal/operators/bufferTime":false,"../internal/operators/bufferToggle":false,"../internal/operators/bufferWhen":false,"../internal/operators/catchError":"1otW6","../internal/operators/combineAll":false,"../internal/operators/combineLatest":false,"../internal/operators/concat":false,"../internal/operators/concatAll":false,"../internal/operators/concatMap":false,"../internal/operators/concatMapTo":false,"../internal/operators/count":false,"../internal/operators/debounce":false,"../internal/operators/debounceTime":false,"../internal/operators/defaultIfEmpty":false,"../internal/operators/delay":false,"../internal/operators/delayWhen":false,"../internal/operators/dematerialize":false,"../internal/operators/distinct":false,"../internal/operators/distinctUntilChanged":false,"../internal/operators/distinctUntilKeyChanged":false,"../internal/operators/elementAt":false,"../internal/operators/endWith":false,"../internal/operators/every":false,"../internal/operators/exhaust":false,"../internal/operators/exhaustMap":false,"../internal/operators/expand":false,"../internal/operators/filter":"cEX4c","../internal/operators/finalize":false,"../internal/operators/find":false,"../internal/operators/findIndex":false,"../internal/operators/first":false,"../internal/operators/groupBy":false,"../internal/operators/ignoreElements":false,"../internal/operators/isEmpty":false,"../internal/operators/last":false,"../internal/operators/map":"c9Dj4","../internal/operators/mapTo":false,"../internal/operators/materialize":false,"../internal/operators/max":false,"../internal/operators/merge":false,"../internal/operators/mergeAll":false,"../internal/operators/mergeMap":"dKXP4","../internal/operators/mergeMapTo":false,"../internal/operators/mergeScan":false,"../internal/operators/min":false,"../internal/operators/multicast":false,"../internal/operators/observeOn":"hpILr","../internal/operators/onErrorResumeNext":false,"../internal/operators/pairwise":false,"../internal/operators/partition":false,"../internal/operators/pluck":false,"../internal/operators/publish":false,"../internal/operators/publishBehavior":false,"../internal/operators/publishLast":false,"../internal/operators/publishReplay":false,"../internal/operators/race":false,"../internal/operators/reduce":false,"../internal/operators/repeat":false,"../internal/operators/repeatWhen":false,"../internal/operators/retry":false,"../internal/operators/retryWhen":false,"../internal/operators/refCount":false,"../internal/operators/sample":false,"../internal/operators/sampleTime":false,"../internal/operators/scan":false,"../internal/operators/sequenceEqual":false,"../internal/operators/share":false,"../internal/operators/shareReplay":false,"../internal/operators/single":false,"../internal/operators/skip":false,"../internal/operators/skipLast":false,"../internal/operators/skipUntil":false,"../internal/operators/skipWhile":false,"../internal/operators/startWith":false,"../internal/operators/subscribeOn":"28ef5","../internal/operators/switchAll":false,"../internal/operators/switchMap":"17cau","../internal/operators/switchMapTo":false,"../internal/operators/take":false,"../internal/operators/takeLast":false,"../internal/operators/takeUntil":false,"../internal/operators/takeWhile":false,"../internal/operators/tap":false,"../internal/operators/throttle":false,"../internal/operators/throttleTime":false,"../internal/operators/throwIfEmpty":false,"../internal/operators/timeInterval":false,"../internal/operators/timeout":false,"../internal/operators/timeoutWith":false,"../internal/operators/timestamp":false,"../internal/operators/toArray":false,"../internal/operators/window":false,"../internal/operators/windowCount":false,"../internal/operators/windowTime":false,"../internal/operators/windowToggle":false,"../internal/operators/windowWhen":false,"../internal/operators/withLatestFrom":false,"../internal/operators/zip":false,"../internal/operators/zipAll":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1otW6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"7ny2u","../innerSubscribe":"2VMKc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cEX4c":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var FilterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"7ny2u","../Subscriber":"3WQni","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hpILr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
parcelHelpers.export(exports, "ObserveOnOperator", ()=>ObserveOnOperator);
parcelHelpers.export(exports, "ObserveOnSubscriber", ()=>ObserveOnSubscriber);
parcelHelpers.export(exports, "ObserveOnMessage", ()=>ObserveOnMessage);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var ObserveOnSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, _notification.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, _notification.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, _subscriber.Subscriber));
var ObserveOnMessage = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

},{"tslib":"7ny2u","../Subscriber":"3WQni","../Notification":"alzak","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"28ef5":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _subscribeOnObservable = require("../observable/SubscribeOnObservable");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, _subscribeOnObservable.SubscribeOnObservable)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

},{"../observable/SubscribeOnObservable":"1OfFT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1OfFT":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscribeOnObservable", ()=>SubscribeOnObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _asap = require("../scheduler/asap");
var _isNumeric = require("../util/isNumeric");
var SubscribeOnObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, _isNumeric.isNumeric)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, _asap.asap);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, _observable.Observable));

},{"tslib":"7ny2u","../Observable":"8jGVG","../scheduler/asap":"bIyCP","../util/isNumeric":"khdpT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khdpT":[function(require,module,exports) {
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
var _isArray = require("./isArray");
function isNumeric(val) {
    return !(0, _isArray.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

},{"./isArray":"7cfqc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17cau":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"7ny2u","./map":"c9Dj4","../observable/from":"sJ6h2","../innerSubscribe":"2VMKc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpKjx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionsObservable", ()=>ActionsObservable);
var _rxjs = require("rxjs");
var _operators = require("./operators");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ActionsObservable = function(_Observable) {
    _inherits(ActionsObservable, _Observable);
    _createClass(ActionsObservable, null, [
        {
            key: "of",
            value: function of() {
                return new this((0, _rxjs.of).apply(undefined, arguments));
            }
        },
        {
            key: "from",
            value: function from(actions, scheduler) {
                return new this((0, _rxjs.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        _classCallCheck(this, ActionsObservable);
        var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    _createClass(ActionsObservable, [
        {
            key: "lift",
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: "ofType",
            value: function ofType() {
                return (0, _operators.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, _rxjs.Observable));

},{"rxjs":"ctXY8","./operators":"8VlfM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VlfM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ofType", ()=>ofType);
var _operators = require("rxjs/operators");
var keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === "function" && type === key.toString();
};
var ofType = function ofType() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function(source) {
        return source.pipe((0, _operators.filter)(function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if (keyHasType(type, keys[i])) return true;
            }
            return false;
        }));
    };
};

},{"rxjs/operators":"eRfPW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38SGX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StateObservable", ()=>StateObservable);
var _rxjs = require("rxjs");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var StateObservable = function(_Observable) {
    _inherits(StateObservable, _Observable);
    function StateObservable(stateSubject, initialState) {
        _classCallCheck(this, StateObservable);
        var _this = _possibleConstructorReturn(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function(subscriber) {
            var subscription = _this.__notifier.subscribe(subscriber);
            if (subscription && !subscription.closed) subscriber.next(_this.value);
            return subscription;
        }));
        _this.value = initialState;
        _this.__notifier = new (0, _rxjs.Subject)();
        _this.__subscription = stateSubject.subscribe(function(value) {
            // We only want to update state$ if it has actually changed since
            // redux requires reducers use immutability patterns.
            // This is basically what distinctUntilChanged() does but it's so simple
            // we don't need to pull that code in
            if (value !== _this.value) {
                _this.value = value;
                _this.__notifier.next(value);
            }
        });
        return _this;
    }
    return StateObservable;
}((0, _rxjs.Observable));

},{"rxjs":"ctXY8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2y79S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetDeprecationsSeen", ()=>resetDeprecationsSeen);
parcelHelpers.export(exports, "deprecate", ()=>deprecate);
parcelHelpers.export(exports, "warn", ()=>warn);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var deprecationsSeen = {};
var resetDeprecationsSeen = function resetDeprecationsSeen() {
    deprecationsSeen = {};
};
var consoleWarn = (typeof console === "undefined" ? "undefined" : _typeof(console)) === "object" && typeof console.warn === "function" ? function() {
    var _console;
    return (_console = console).warn.apply(_console, arguments);
} : function() {};
var deprecate = function deprecate(msg) {
    if (!deprecationsSeen[msg]) {
        deprecationsSeen[msg] = true;
        consoleWarn("redux-observable | DEPRECATION: " + msg);
    }
};
var warn = function warn(msg) {
    consoleWarn("redux-observable | WARNING: " + msg);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2W6L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineEpics", ()=>combineEpics);
var _rxjs = require("rxjs");
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var combineEpics = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    var merger = function merger() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, _rxjs.merge).apply(undefined, _toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        })));
    };
    // Technically the `name` property on Function's are supposed to be read-only.
    // While some JS runtimes allow it anyway (so this is useful in debugging)
    // some actually throw an exception when you attempt to do so.
    try {
        Object.defineProperty(merger, "name", {
            value: "combineEpics(" + epics.map(function(epic) {
                return epic.name || "<anonymous>";
            }).join(", ") + ")"
        });
    } catch (e) {}
    return merger;
};

},{"rxjs":"ctXY8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNEN9":[function(require,module,exports) {
var global = arguments[3];
!function(e, t) {
    t(exports);
}(this, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{}],"5EyEY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduxObservable = require("redux-observable");
var _userManagementEpics = require("./userManagementEpics");
var _apiLoadingEpic = require("./apiLoadingEpic");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var epics = (0, _reduxObservable.combineEpics).apply(void 0, _toConsumableArray((0, _userManagementEpics.userManagementEpics)).concat([
    (0, _apiLoadingEpic.apiLoadingEpic)
]));
exports.default = epics;

},{"redux-observable":"1ybGk","./userManagementEpics":"299yB","./apiLoadingEpic":"bNNSY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"299yB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userManagementEpics", ()=>userManagementEpics);
var _acceptInvitationEpic = require("./acceptInvitationEpic");
var _confirmInvitationEpic = require("./confirmInvitationEpic");
var _createInvitationEpic = require("./createInvitationEpic");
var _deactivateUserEpic = require("./deactivateUserEpic");
var _deactivateUserEpicDefault = parcelHelpers.interopDefault(_deactivateUserEpic);
var _deleteInvitationEpic = require("./deleteInvitationEpic");
var _fetchRequestedUserDetailsEpic = require("./fetchRequestedUserDetailsEpic");
var _fetchRequestedUserDetailsEpicDefault = parcelHelpers.interopDefault(_fetchRequestedUserDetailsEpic);
var _getDeactivatedUsersEpic = require("./getDeactivatedUsersEpic");
var _getDeactivatedUsersEpicDefault = parcelHelpers.interopDefault(_getDeactivatedUsersEpic);
var _getInvitedUsersForLogisticsPartyEpic = require("./getInvitedUsersForLogisticsPartyEpic");
var _getUserProfileInfoEpic = require("./getUserProfileInfoEpic");
var _getUsersForLogisticsPartyEpic = require("./getUsersForLogisticsPartyEpic");
var _resendInvitationEpic = require("./resendInvitationEpic");
var _updateUserLocaleEpic = require("./updateUserLocaleEpic");
var _updateUserProfileInfoEpic = require("./updateUserProfileInfoEpic");
var userManagementEpics = [
    (0, _getUserProfileInfoEpic.getUserProfileInfoEpic),
    (0, _updateUserProfileInfoEpic.updateUserProfileInfoEpic),
    (0, _acceptInvitationEpic.acceptInvitationEpic),
    (0, _confirmInvitationEpic.confirmInvitationEpic),
    (0, _createInvitationEpic.createInvitationEpic),
    (0, _deleteInvitationEpic.deleteInvitationEpic),
    (0, _getInvitedUsersForLogisticsPartyEpic.getInvitedUsersForLogisticsPartyEpic),
    (0, _getUsersForLogisticsPartyEpic.getUsersForLogisticsPartyEpic),
    (0, _resendInvitationEpic.resendInvitationEpic),
    (0, _updateUserLocaleEpic.updateUserLocaleEpic),
    (0, _getDeactivatedUsersEpicDefault.default),
    (0, _deactivateUserEpicDefault.default),
    (0, _fetchRequestedUserDetailsEpicDefault.default)
];
exports.default = userManagementEpics;

},{"./acceptInvitationEpic":"9uLba","./confirmInvitationEpic":"k2I7V","./createInvitationEpic":"dLMoy","./deactivateUserEpic":"ioFZy","./deleteInvitationEpic":"8iQeX","./fetchRequestedUserDetailsEpic":"9dT6r","./getDeactivatedUsersEpic":"iqrev","./getInvitedUsersForLogisticsPartyEpic":"2nwfA","./getUserProfileInfoEpic":"8lBTg","./getUsersForLogisticsPartyEpic":"01zoK","./resendInvitationEpic":"4WkuN","./updateUserLocaleEpic":"iFLrM","./updateUserProfileInfoEpic":"a1Ju1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9uLba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "acceptInvitationEpic", ()=>acceptInvitationEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _error = require("../../../constants/error");
var acceptInvitationEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.ACCEPT_INVITATION_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.acceptInvitation(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.acceptInvitation).success(response.invitationStatus), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.ACCEPT_INVITATION_SUCCESS),
                body: "accept_invitation_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? (0, _error.errorBodyForCodeMap)[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return (0, _rxjs.of)((0, _userManagementActions.acceptInvitation).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.ACCEPT_INVITATION_FAILURE),
                body: errBody || "accept_invitation_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = acceptInvitationEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../constants/error":"3yLbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fIUa9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserProfileInfo", ()=>getUserProfileInfo);
parcelHelpers.export(exports, "updateUserProfileInfo", ()=>updateUserProfileInfo);
parcelHelpers.export(exports, "updateUserLocaleAction", ()=>updateUserLocaleAction);
parcelHelpers.export(exports, "acceptInvitation", ()=>acceptInvitation);
parcelHelpers.export(exports, "createInvitation", ()=>createInvitation);
parcelHelpers.export(exports, "resendInvitation", ()=>resendInvitation);
parcelHelpers.export(exports, "confirmInvitation", ()=>confirmInvitation);
parcelHelpers.export(exports, "deleteInvitation", ()=>deleteInvitation);
parcelHelpers.export(exports, "getUsersForLogisticsParty", ()=>getUsersForLogisticsParty);
parcelHelpers.export(exports, "getInvitedUsersForLogisticsParty", ()=>getInvitedUsersForLogisticsParty);
parcelHelpers.export(exports, "createInvitationSuccessReset", ()=>createInvitationSuccessReset);
parcelHelpers.export(exports, "deactivateUser", ()=>deactivateUser);
parcelHelpers.export(exports, "getDeactivatedUsers", ()=>getDeactivatedUsers);
parcelHelpers.export(exports, "fetchUserDetailsAction", ()=>fetchUserDetailsAction);
var _typesafeActions = require("typesafe-actions");
var _actionTypes = require("./actionTypes");
var getUserProfileInfo = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_USER_PROFILE_INFO_ACTIONS_REQUEST), (0, _actionTypes.GET_USER_PROFILE_INFO_ACTIONS_SUCCESS), (0, _actionTypes.GET_USER_PROFILE_INFO_ACTIONS_FAILURE))();
var updateUserProfileInfo = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.UPDATE_USER_PROFILE_INFO_REQUEST), (0, _actionTypes.UPDATE_USER_PROFILE_INFO_SUCCESS), (0, _actionTypes.UPDATE_USER_PROFILE_INFO_FAILURE))();
var updateUserLocaleAction = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.UPDATE_USER_LOCALE_REQUEST), (0, _actionTypes.UPDATE_USER_LOCALE_SUCCESS), (0, _actionTypes.UPDATE_USER_LOCALE_FAILURE))();
var acceptInvitation = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.ACCEPT_INVITATION_REQUEST), (0, _actionTypes.ACCEPT_INVITATION_SUCCESS), (0, _actionTypes.ACCEPT_INVITATION_FAILURE))();
var createInvitation = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.CREATE_INVITATION_REQUEST), (0, _actionTypes.CREATE_INVITATION_SUCCESS), (0, _actionTypes.CREATE_INVITATION_FAILURE))();
var resendInvitation = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.RESEND_INVITATION_REQUEST), (0, _actionTypes.RESEND_INVITATION_SUCCESS), (0, _actionTypes.RESEND_INVITATION_FAILURE))();
var confirmInvitation = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.CONFIRM_INVITATION_REQUEST), (0, _actionTypes.CONFIRM_INVITATION_SUCCESS), (0, _actionTypes.CONFIRM_INVITATION_FAILURE))();
var deleteInvitation = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.DELETE_INVITATION_REQUEST), (0, _actionTypes.DELETE_INVITATION_SUCCESS), (0, _actionTypes.DELETE_INVITATION_FAILURE))();
var getUsersForLogisticsParty = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_REQUEST), (0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS), (0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_FAILURE))();
var getInvitedUsersForLogisticsParty = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST), (0, _actionTypes.GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS), (0, _actionTypes.GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE))();
var createInvitationSuccessReset = (0, _typesafeActions.createAction)((0, _actionTypes.CREATE_INVITATION_SUCCESS_RESET))();
var deactivateUser = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.DEACTIVATE_USER_REQUEST), (0, _actionTypes.DEACTIVATE_USER_SUCCESS), (0, _actionTypes.DEACTIVATE_USER_FAILURE))();
var getDeactivatedUsers = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.GET_DEACTIVATED_USERS_REQUEST), (0, _actionTypes.GET_DEACTIVATED_USERS_SUCCESS), (0, _actionTypes.GET_DEACTIVATED_USERS_FAILURE))();
var fetchUserDetailsAction = (0, _typesafeActions.createAsyncAction)((0, _actionTypes.FETCH_USER_DETAILS_REQUEST), (0, _actionTypes.FETCH_USER_DETAILS_SUCCESS), (0, _actionTypes.FETCH_USER_DETAILS_FAILURE))();
exports.default = {
    getUserProfileInfo: getUserProfileInfo,
    updateUserProfileInfo: updateUserProfileInfo
};

},{"typesafe-actions":"58Ftw","./actionTypes":"bnUpG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58Ftw":[function(require,module,exports) {
!function(n, t) {
    t(exports);
}(this, function(n) {
    "use strict";
    function t(n) {
        return null == n;
    }
    function r(n) {
        throw new Error("Argument " + n + " is empty.");
    }
    function e(n) {
        return "function" == typeof n && "getType" in n;
    }
    function i(n) {
        throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
    }
    function o(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if (null == n.getType) throw new Error("Argument contains array with invalid element at index " + t + ', it should be an action-creator instance from "typesafe-actions"');
    }
    function u(n) {
        return "string" == typeof n || "symbol" == typeof n;
    }
    function a(n) {
        return !u(n);
    }
    function c(n) {
        throw new Error("Argument " + n + " is invalid, it should be an action type of type: string | symbol");
    }
    function f(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument contains array with invalid element at index " + t + ", it should be of type: string | symbol");
    }
    function s(n, e, o, u) {
        return t(n) && r(1), a(n) && i(1), {
            type: n,
            payload: e,
            meta: o,
            error: u
        };
    }
    function y(n, e) {
        t(n) && r(1), a(n) && c(1);
        return Object.assign(function() {
            var t = null != e ? e.apply(void 0, arguments) : void 0;
            return Object.assign({
                type: n
            }, t);
        }, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    function l(n, e, i) {
        return t(n) && r(1), a(n) && c(1), function() {
            return y(n, function() {
                var n = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1];
                return null == e && null == i || (n = null != e ? e.apply(void 0, arguments) : void 0, t = null != i ? i.apply(void 0, arguments) : void 0), Object.assign({}, void 0 !== n && {
                    payload: n
                }, {}, void 0 !== t && {
                    meta: t
                });
            });
        };
    }
    function p(n) {
        return t(n) && r(1), e(n) || i(1), n.getType();
    }
    function d(n, e) {
        t(n) && r(1), a(n) && c(1);
        var i = null != e ? e(n) : function() {
            return {
                type: n
            };
        };
        return Object.assign(i, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    var g = {
        createAction: function(n, t) {
            var r = null == t ? function() {
                return s(n);
            } : t(s.bind(null, n));
            return Object.assign(r, {
                getType: function() {
                    return n;
                },
                toString: function() {
                    return n;
                }
            });
        },
        createCustomAction: d,
        createStandardAction: function(n) {
            return t(n) && r(1), a(n) && c(1), Object.assign(function() {
                return d(n, function(n) {
                    return function(t, r) {
                        return {
                            type: n,
                            payload: t,
                            meta: r
                        };
                    };
                });
            }, {
                map: function(t) {
                    return d(n, function(n) {
                        return function(r, e) {
                            return Object.assign(t(r, e), {
                                type: n
                            });
                        };
                    });
                }
            });
        }
    };
    n.action = s, n.createAction = l, n.createAsyncAction = function(n, t, r, e) {
        return function() {
            var i = [
                n,
                t,
                r,
                e
            ].map(function(n, t) {
                return Array.isArray(n) ? l(n[0], n[1], n[2])() : "string" == typeof n || "symbol" == typeof n ? l(n)() : void (t < 3 && function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action type of "string | symbol" or a tuple of "[string | symbol, Function, Function?]"');
                }(t));
            });
            return {
                request: i[0],
                success: i[1],
                failure: i[2],
                cancel: i[3]
            };
        };
    }, n.createCustomAction = y, n.createReducer = function n(t, r) {
        void 0 === r && (r = {});
        var i = Object.assign({}, r), o = function(r, o) {
            var a = Array.isArray(r) ? r : [
                r
            ], c = {};
            return a.map(function(n, t) {
                return e(n) ? p(n) : u(n) ? n : function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
                }(t + 1);
            }).forEach(function(n) {
                return c[n] = o;
            }), n(t, Object.assign({}, i, {}, c));
        };
        return Object.assign(function(n, r) {
            if (void 0 === n && (n = t), i.hasOwnProperty(r.type)) {
                var e = i[r.type];
                if ("function" != typeof e) throw Error('Reducer under "' + r.type + '" key is not a valid reducer');
                return e(n, r);
            }
            return n;
        }, {
            handlers: Object.assign({}, i),
            handleAction: o,
            handleType: o
        });
    }, n.deprecated = g, n.getType = p, n.isActionOf = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(o);
        var u = function(n) {
            return i.some(function(t) {
                return n.type === t.getType();
            });
        };
        return void 0 === e ? u : u(e);
    }, n.isOfType = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(f);
        var o = function(n) {
            return i.includes(n.type);
        };
        return void 0 === e ? o : o(e);
    };
});

},{}],"bnUpG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SLICE", ()=>SLICE);
parcelHelpers.export(exports, "GET_USER_PROFILE_INFO_ACTIONS_REQUEST", ()=>GET_USER_PROFILE_INFO_ACTIONS_REQUEST);
parcelHelpers.export(exports, "GET_USER_PROFILE_INFO_ACTIONS_SUCCESS", ()=>GET_USER_PROFILE_INFO_ACTIONS_SUCCESS);
parcelHelpers.export(exports, "GET_USER_PROFILE_INFO_ACTIONS_FAILURE", ()=>GET_USER_PROFILE_INFO_ACTIONS_FAILURE);
parcelHelpers.export(exports, "UPDATE_USER_PROFILE_INFO_ACTION_TYPE", ()=>UPDATE_USER_PROFILE_INFO_ACTION_TYPE);
parcelHelpers.export(exports, "UPDATE_USER_PROFILE_INFO_REQUEST", ()=>UPDATE_USER_PROFILE_INFO_REQUEST);
parcelHelpers.export(exports, "UPDATE_USER_PROFILE_INFO_SUCCESS", ()=>UPDATE_USER_PROFILE_INFO_SUCCESS);
parcelHelpers.export(exports, "UPDATE_USER_PROFILE_INFO_FAILURE", ()=>UPDATE_USER_PROFILE_INFO_FAILURE);
parcelHelpers.export(exports, "UPDATE_USER_LOCALE_ACTION_TYPE", ()=>UPDATE_USER_LOCALE_ACTION_TYPE);
parcelHelpers.export(exports, "UPDATE_USER_LOCALE_REQUEST", ()=>UPDATE_USER_LOCALE_REQUEST);
parcelHelpers.export(exports, "UPDATE_USER_LOCALE_SUCCESS", ()=>UPDATE_USER_LOCALE_SUCCESS);
parcelHelpers.export(exports, "UPDATE_USER_LOCALE_FAILURE", ()=>UPDATE_USER_LOCALE_FAILURE);
parcelHelpers.export(exports, "ACCEPT_INVITATION_ACTION_TYPE", ()=>ACCEPT_INVITATION_ACTION_TYPE);
parcelHelpers.export(exports, "ACCEPT_INVITATION_REQUEST", ()=>ACCEPT_INVITATION_REQUEST);
parcelHelpers.export(exports, "ACCEPT_INVITATION_SUCCESS", ()=>ACCEPT_INVITATION_SUCCESS);
parcelHelpers.export(exports, "ACCEPT_INVITATION_FAILURE", ()=>ACCEPT_INVITATION_FAILURE);
parcelHelpers.export(exports, "CREATE_INVITATION_ACTION_TYPE", ()=>CREATE_INVITATION_ACTION_TYPE);
parcelHelpers.export(exports, "CREATE_INVITATION_REQUEST", ()=>CREATE_INVITATION_REQUEST);
parcelHelpers.export(exports, "CREATE_INVITATION_SUCCESS", ()=>CREATE_INVITATION_SUCCESS);
parcelHelpers.export(exports, "CREATE_INVITATION_FAILURE", ()=>CREATE_INVITATION_FAILURE);
parcelHelpers.export(exports, "CREATE_INVITATION_SUCCESS_RESET", ()=>CREATE_INVITATION_SUCCESS_RESET);
parcelHelpers.export(exports, "RESEND_INVITATION_ACTION_TYPE", ()=>RESEND_INVITATION_ACTION_TYPE);
parcelHelpers.export(exports, "RESEND_INVITATION_REQUEST", ()=>RESEND_INVITATION_REQUEST);
parcelHelpers.export(exports, "RESEND_INVITATION_SUCCESS", ()=>RESEND_INVITATION_SUCCESS);
parcelHelpers.export(exports, "RESEND_INVITATION_FAILURE", ()=>RESEND_INVITATION_FAILURE);
parcelHelpers.export(exports, "DELETE_INVITATION_ACTION_TYPE", ()=>DELETE_INVITATION_ACTION_TYPE);
parcelHelpers.export(exports, "DELETE_INVITATION_REQUEST", ()=>DELETE_INVITATION_REQUEST);
parcelHelpers.export(exports, "DELETE_INVITATION_SUCCESS", ()=>DELETE_INVITATION_SUCCESS);
parcelHelpers.export(exports, "DELETE_INVITATION_FAILURE", ()=>DELETE_INVITATION_FAILURE);
parcelHelpers.export(exports, "CONFIRM_INVITATION_ACTION_TYPE", ()=>CONFIRM_INVITATION_ACTION_TYPE);
parcelHelpers.export(exports, "CONFIRM_INVITATION_REQUEST", ()=>CONFIRM_INVITATION_REQUEST);
parcelHelpers.export(exports, "CONFIRM_INVITATION_SUCCESS", ()=>CONFIRM_INVITATION_SUCCESS);
parcelHelpers.export(exports, "CONFIRM_INVITATION_FAILURE", ()=>CONFIRM_INVITATION_FAILURE);
parcelHelpers.export(exports, "GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE", ()=>GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE);
parcelHelpers.export(exports, "GET_USERS_FOR_LOGISTICS_PARTY_REQUEST", ()=>GET_USERS_FOR_LOGISTICS_PARTY_REQUEST);
parcelHelpers.export(exports, "GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS", ()=>GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS);
parcelHelpers.export(exports, "GET_USERS_FOR_LOGISTICS_PARTY_FAILURE", ()=>GET_USERS_FOR_LOGISTICS_PARTY_FAILURE);
parcelHelpers.export(exports, "GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE", ()=>GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE);
parcelHelpers.export(exports, "GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST", ()=>GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST);
parcelHelpers.export(exports, "GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS", ()=>GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS);
parcelHelpers.export(exports, "GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE", ()=>GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE);
parcelHelpers.export(exports, "DEACTIVATE_USER_ACTION_TYPE", ()=>DEACTIVATE_USER_ACTION_TYPE);
parcelHelpers.export(exports, "DEACTIVATE_USER_REQUEST", ()=>DEACTIVATE_USER_REQUEST);
parcelHelpers.export(exports, "DEACTIVATE_USER_SUCCESS", ()=>DEACTIVATE_USER_SUCCESS);
parcelHelpers.export(exports, "DEACTIVATE_USER_FAILURE", ()=>DEACTIVATE_USER_FAILURE);
parcelHelpers.export(exports, "GET_DEACTIVATED_USERS_ACTION_TYPE", ()=>GET_DEACTIVATED_USERS_ACTION_TYPE);
parcelHelpers.export(exports, "GET_DEACTIVATED_USERS_REQUEST", ()=>GET_DEACTIVATED_USERS_REQUEST);
parcelHelpers.export(exports, "GET_DEACTIVATED_USERS_SUCCESS", ()=>GET_DEACTIVATED_USERS_SUCCESS);
parcelHelpers.export(exports, "GET_DEACTIVATED_USERS_FAILURE", ()=>GET_DEACTIVATED_USERS_FAILURE);
parcelHelpers.export(exports, "FETCH_USER_DETAILS", ()=>FETCH_USER_DETAILS);
parcelHelpers.export(exports, "FETCH_USER_DETAILS_REQUEST", ()=>FETCH_USER_DETAILS_REQUEST);
parcelHelpers.export(exports, "FETCH_USER_DETAILS_SUCCESS", ()=>FETCH_USER_DETAILS_SUCCESS);
parcelHelpers.export(exports, "FETCH_USER_DETAILS_FAILURE", ()=>FETCH_USER_DETAILS_FAILURE);
var SLICE = "userManagement";
// getUserProfileInfo action types.
var GET_USER_PROFILE_INFO_ACTIONS = "".concat(SLICE, "/GET_USER_PROFILE_INFO_ACTIONS");
var GET_USER_PROFILE_INFO_ACTIONS_REQUEST = "".concat(GET_USER_PROFILE_INFO_ACTIONS, "/REQUEST");
var GET_USER_PROFILE_INFO_ACTIONS_SUCCESS = "".concat(GET_USER_PROFILE_INFO_ACTIONS, "/SUCCESS");
var GET_USER_PROFILE_INFO_ACTIONS_FAILURE = "".concat(GET_USER_PROFILE_INFO_ACTIONS, "/FAILURE");
var UPDATE_USER_PROFILE_INFO_ACTION_TYPE = "".concat(SLICE, "/UPDATE_USER_PROFILE_INFO");
var UPDATE_USER_PROFILE_INFO_REQUEST = "".concat(UPDATE_USER_PROFILE_INFO_ACTION_TYPE, "_REQUEST");
var UPDATE_USER_PROFILE_INFO_SUCCESS = "".concat(UPDATE_USER_PROFILE_INFO_ACTION_TYPE, "_SUCCESS");
var UPDATE_USER_PROFILE_INFO_FAILURE = "".concat(UPDATE_USER_PROFILE_INFO_ACTION_TYPE, "_FAILURE");
var UPDATE_USER_LOCALE_ACTION_TYPE = "".concat(SLICE, "/UPDATE_USER_LOCALE");
var UPDATE_USER_LOCALE_REQUEST = "".concat(UPDATE_USER_LOCALE_ACTION_TYPE, "_REQUEST");
var UPDATE_USER_LOCALE_SUCCESS = "".concat(UPDATE_USER_LOCALE_ACTION_TYPE, "_SUCCESS");
var UPDATE_USER_LOCALE_FAILURE = "".concat(UPDATE_USER_LOCALE_ACTION_TYPE, "_FAILURE");
var ACCEPT_INVITATION_ACTION_TYPE = "".concat(SLICE, "/ACCEPT_INVITATION");
var ACCEPT_INVITATION_REQUEST = "".concat(ACCEPT_INVITATION_ACTION_TYPE, "_REQUEST");
var ACCEPT_INVITATION_SUCCESS = "".concat(ACCEPT_INVITATION_ACTION_TYPE, "_SUCCESS");
var ACCEPT_INVITATION_FAILURE = "".concat(ACCEPT_INVITATION_ACTION_TYPE, "_FAILURE");
var CREATE_INVITATION_ACTION_TYPE = "".concat(SLICE, "/CREATE_INVITATION");
var CREATE_INVITATION_REQUEST = "".concat(CREATE_INVITATION_ACTION_TYPE, "_REQUEST");
var CREATE_INVITATION_SUCCESS = "".concat(CREATE_INVITATION_ACTION_TYPE, "_SUCCESS");
var CREATE_INVITATION_FAILURE = "".concat(CREATE_INVITATION_ACTION_TYPE, "_FAILURE");
var CREATE_INVITATION_SUCCESS_RESET = "".concat(CREATE_INVITATION_ACTION_TYPE, "_SUCCESS_RESET");
var RESEND_INVITATION_ACTION_TYPE = "".concat(SLICE, "/RESEND_INVITATION");
var RESEND_INVITATION_REQUEST = "".concat(RESEND_INVITATION_ACTION_TYPE, "_REQUEST");
var RESEND_INVITATION_SUCCESS = "".concat(RESEND_INVITATION_ACTION_TYPE, "_SUCCESS");
var RESEND_INVITATION_FAILURE = "".concat(RESEND_INVITATION_ACTION_TYPE, "_FAILURE");
var DELETE_INVITATION_ACTION_TYPE = "".concat(SLICE, "/DELETE_INVITATION");
var DELETE_INVITATION_REQUEST = "".concat(DELETE_INVITATION_ACTION_TYPE, "_REQUEST");
var DELETE_INVITATION_SUCCESS = "".concat(DELETE_INVITATION_ACTION_TYPE, "_SUCCESS");
var DELETE_INVITATION_FAILURE = "".concat(DELETE_INVITATION_ACTION_TYPE, "_FAILURE");
var CONFIRM_INVITATION_ACTION_TYPE = "".concat(SLICE, "/CONFIRM_INVITATION");
var CONFIRM_INVITATION_REQUEST = "".concat(CONFIRM_INVITATION_ACTION_TYPE, "_REQUEST");
var CONFIRM_INVITATION_SUCCESS = "".concat(CONFIRM_INVITATION_ACTION_TYPE, "_SUCCESS");
var CONFIRM_INVITATION_FAILURE = "".concat(CONFIRM_INVITATION_ACTION_TYPE, "_FAILURE");
var GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE = "".concat(SLICE, "/GET_USERS_FOR_LOGISTICS_PARTY");
var GET_USERS_FOR_LOGISTICS_PARTY_REQUEST = "".concat(GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_REQUEST");
var GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS = "".concat(GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_SUCCESS");
var GET_USERS_FOR_LOGISTICS_PARTY_FAILURE = "".concat(GET_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_FAILURE");
var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE = "".concat(SLICE, "/GET_INVITED_USERS_FOR_LOGISTICS_PARTY");
var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST = "".concat(GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_REQUEST");
var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS = "".concat(GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_SUCCESS");
var GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE = "".concat(GET_INVITED_USERS_FOR_LOGISTICS_PARTY_ACTION_TYPE, "_FAILURE");
var DEACTIVATE_USER_ACTION_TYPE = "".concat(SLICE, "/DEACTIVATE_USER_ACTION_TYPE");
var DEACTIVATE_USER_REQUEST = "".concat(DEACTIVATE_USER_ACTION_TYPE, "_REQUEST");
var DEACTIVATE_USER_SUCCESS = "".concat(DEACTIVATE_USER_ACTION_TYPE, "_SUCCESS");
var DEACTIVATE_USER_FAILURE = "".concat(DEACTIVATE_USER_ACTION_TYPE, "_FAILURE");
var GET_DEACTIVATED_USERS_ACTION_TYPE = "".concat(SLICE, "/GET_DEACTIVATED_USES_ACTION_TYPE");
var GET_DEACTIVATED_USERS_REQUEST = "".concat(GET_DEACTIVATED_USERS_ACTION_TYPE, "_REQUEST");
var GET_DEACTIVATED_USERS_SUCCESS = "".concat(GET_DEACTIVATED_USERS_ACTION_TYPE, "_SUCCESS");
var GET_DEACTIVATED_USERS_FAILURE = "".concat(GET_DEACTIVATED_USERS_ACTION_TYPE, "_FAILURE");
var FETCH_USER_DETAILS = "".concat(SLICE, "/FETCH_USER_DETAILS");
var FETCH_USER_DETAILS_REQUEST = "".concat(FETCH_USER_DETAILS, "_REQUEST");
var FETCH_USER_DETAILS_SUCCESS = "".concat(FETCH_USER_DETAILS, "_SUCCESS");
var FETCH_USER_DETAILS_FAILURE = "".concat(FETCH_USER_DETAILS, "_FAILURE");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wsCu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Action to handle notification addition.
 */ parcelHelpers.export(exports, "addNotification", ()=>addNotification);
/**
 * Action to handle notification closures.
 */ parcelHelpers.export(exports, "closeNotification", ()=>closeNotification);
/**
 * Action to push to a different route.
 */ parcelHelpers.export(exports, "pushRoute", ()=>pushRoute);
parcelHelpers.export(exports, "startRequestLoading", ()=>startRequestLoading);
parcelHelpers.export(exports, "endRequestLoading", ()=>endRequestLoading);
parcelHelpers.export(exports, "openDeactivateUserModal", ()=>openDeactivateUserModal);
parcelHelpers.export(exports, "closeDeactivateUserModal", ()=>closeDeactivateUserModal);
var _uuid = require("uuid");
var _types = require("./types");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function addNotification(config) {
    return {
        type: (0, _types.ADD_NOTIFICATION),
        payload: _objectSpread({
            id: (0, _uuid.v4)()
        }, config)
    };
}
function closeNotification(id) {
    return {
        type: (0, _types.CLOSE_NOTIFICATION),
        payload: id
    };
}
function pushRoute(history, route) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return {
        type: (0, _types.PUSH_ROUTE),
        payload: {
            history: history,
            route: route,
            delay: delay
        }
    };
}
var startRequestLoading = function(payload) {
    return {
        type: (0, _types.START_REQUEST_LOADING),
        payload: payload
    };
};
var endRequestLoading = function(payload) {
    return {
        type: (0, _types.END_REQUEST_LOADING),
        payload: payload
    };
};
var openDeactivateUserModal = function(payload) {
    return {
        type: (0, _types.OPEN_DEACTIVATE_USERS_MODAL),
        payload: payload
    };
};
var closeDeactivateUserModal = function() {
    return {
        type: (0, _types.CLOSE_DEACTIVATE_USERS_MODAL)
    };
};

},{"uuid":"9wInJ","./types":"dlLnM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9wInJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"9qg7i","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qg7i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"hX7zu","./stringify.js":"53CCh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hX7zu":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"53CCh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"gQQaP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gQQaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"4tB9J","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tB9J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dlLnM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SLICE", ()=>SLICE);
parcelHelpers.export(exports, "PUSH_ROUTE", ()=>PUSH_ROUTE);
parcelHelpers.export(exports, "ADD_NOTIFICATION", ()=>ADD_NOTIFICATION);
parcelHelpers.export(exports, "CLOSE_NOTIFICATION", ()=>CLOSE_NOTIFICATION);
parcelHelpers.export(exports, "START_REQUEST_LOADING", ()=>START_REQUEST_LOADING);
parcelHelpers.export(exports, "END_REQUEST_LOADING", ()=>END_REQUEST_LOADING);
parcelHelpers.export(exports, "NotificationTypeEnum", ()=>NotificationTypeEnum);
parcelHelpers.export(exports, "DEFAULT_NOTIFICATION_CLOSE_TIMEOUT", ()=>DEFAULT_NOTIFICATION_CLOSE_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_ROUTE_CHANGE_TIMEOUT", ()=>DEFAULT_ROUTE_CHANGE_TIMEOUT);
parcelHelpers.export(exports, "OPEN_DEACTIVATE_USERS_MODAL", ()=>OPEN_DEACTIVATE_USERS_MODAL);
parcelHelpers.export(exports, "CLOSE_DEACTIVATE_USERS_MODAL", ()=>CLOSE_DEACTIVATE_USERS_MODAL);
var SLICE = "ui";
var PUSH_ROUTE = "".concat(SLICE, "/PUSH_ROUTE");
var ADD_NOTIFICATION = "".concat(SLICE, "/ADD_NOTIFICATION");
var CLOSE_NOTIFICATION = "".concat(SLICE, "/CLOSE_NOTIFICATION");
var START_REQUEST_LOADING = "".concat(SLICE, "/START_REQUEST_LOADING");
var END_REQUEST_LOADING = "".concat(SLICE, "/END_REQUEST_LOADING");
var NotificationTypeEnum = Object.freeze({
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning"
});
var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
var DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;
var OPEN_DEACTIVATE_USERS_MODAL = "".concat(SLICE, "/OPEN_DEACTIVATE_USERS_MODAL");
var CLOSE_DEACTIVATE_USERS_MODAL = "".concat(SLICE, "/CLOSE_DEACTIVATE_USERS_MODAL");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yLbD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorBodyForCodeMap", ()=>errorBodyForCodeMap);
parcelHelpers.export(exports, "UNAUTHORIZED_ERROR_MSG_FRAGMENT", ()=>UNAUTHORIZED_ERROR_MSG_FRAGMENT);
parcelHelpers.export(exports, "deactivateUserErrorCodes", ()=>deactivateUserErrorCodes);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var _obj;
var errorBodyForCodeMap = (_obj = {}, _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).INVITATION_ALREADY_EXISTS, "create_invitation_notifications.invitation_already_exists"), _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).ALLOWED_DOMAINS_NOT_MATCHED, "create_invitation_notifications.allowed_domains_not_matched"), _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).INVITED_USER_ALREADY_AUTHORIZED, "confirm_invitation_notifications.invited_user_already_authorized"), _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).INVITATION_ALREADY_COMPLETED, "delete_invitation_notifications.invitation_already_completed"), _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).INVITATION_IS_ACCEPTED_BY_DIFFERENT_CUSTOMER, "accept_invitation_notifications.invitation_accepted_by_different_customer"), _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).INVITATION_IS_ALREADY_ACCEPTED, "accept_invitation_notifications.invitation_already_accepted"), _defineProperty(_obj, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).ACCEPTED_USER_IS_ALREADY_AUTHORIZED, "accept_invitation_notifications.accepted_user_already_authorized"), _obj);
var UNAUTHORIZED_ERROR_MSG_FRAGMENT = "does not have enough permissions for operations: GetUsersForLogisticsParty";
var deactivateUserErrorCodes = _defineProperty({}, (0, _coralComAmazonPassportusermanagementservice.ErrorCode).DEACTIVATING_ADMIN_USER_ERROR, "manage_users.deactivate_user.error_codes.admin_deactivation_error");

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fKUeT":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _acceptInvitationRequest = require("./AcceptInvitationRequest");
parcelHelpers.exportAll(_acceptInvitationRequest, exports);
var _acceptInvitationResponse = require("./AcceptInvitationResponse");
parcelHelpers.exportAll(_acceptInvitationResponse, exports);
var _amazonEmployeeIdentifier = require("./AmazonEmployeeIdentifier");
parcelHelpers.exportAll(_amazonEmployeeIdentifier, exports);
var _baseRequest = require("./BaseRequest");
parcelHelpers.exportAll(_baseRequest, exports);
var _confirmInvitationRequest = require("./ConfirmInvitationRequest");
parcelHelpers.exportAll(_confirmInvitationRequest, exports);
var _confirmInvitationResponse = require("./ConfirmInvitationResponse");
parcelHelpers.exportAll(_confirmInvitationResponse, exports);
var _createInvitationRequest = require("./CreateInvitationRequest");
parcelHelpers.exportAll(_createInvitationRequest, exports);
var _createInvitationResponse = require("./CreateInvitationResponse");
parcelHelpers.exportAll(_createInvitationResponse, exports);
var _deactivateUserRequest = require("./DeactivateUserRequest");
parcelHelpers.exportAll(_deactivateUserRequest, exports);
var _deactivateUserResponse = require("./DeactivateUserResponse");
parcelHelpers.exportAll(_deactivateUserResponse, exports);
var _deleteInvitationRequest = require("./DeleteInvitationRequest");
parcelHelpers.exportAll(_deleteInvitationRequest, exports);
var _deleteInvitationResponse = require("./DeleteInvitationResponse");
parcelHelpers.exportAll(_deleteInvitationResponse, exports);
var _deliveryStatus = require("./DeliveryStatus");
parcelHelpers.exportAll(_deliveryStatus, exports);
var _emailInvitationChannelInfo = require("./EmailInvitationChannelInfo");
parcelHelpers.exportAll(_emailInvitationChannelInfo, exports);
var _errorCode = require("./ErrorCode");
parcelHelpers.exportAll(_errorCode, exports);
var _exceptionDetails = require("./ExceptionDetails");
parcelHelpers.exportAll(_exceptionDetails, exports);
var _externalCustomerIdentifier = require("./ExternalCustomerIdentifier");
parcelHelpers.exportAll(_externalCustomerIdentifier, exports);
var _getAnalyticsMetricsRequest = require("./GetAnalyticsMetricsRequest");
parcelHelpers.exportAll(_getAnalyticsMetricsRequest, exports);
var _getAnalyticsMetricsResponse = require("./GetAnalyticsMetricsResponse");
parcelHelpers.exportAll(_getAnalyticsMetricsResponse, exports);
var _getDeactivatedUsersRequest = require("./GetDeactivatedUsersRequest");
parcelHelpers.exportAll(_getDeactivatedUsersRequest, exports);
var _getDeactivatedUsersResponse = require("./GetDeactivatedUsersResponse");
parcelHelpers.exportAll(_getDeactivatedUsersResponse, exports);
var _getInvitationRequest = require("./GetInvitationRequest");
parcelHelpers.exportAll(_getInvitationRequest, exports);
var _getInvitationResponse = require("./GetInvitationResponse");
parcelHelpers.exportAll(_getInvitationResponse, exports);
var _getInvitedUsersForLogisticsPartyRequest = require("./GetInvitedUsersForLogisticsPartyRequest");
parcelHelpers.exportAll(_getInvitedUsersForLogisticsPartyRequest, exports);
var _getInvitedUsersForLogisticsPartyResponse = require("./GetInvitedUsersForLogisticsPartyResponse");
parcelHelpers.exportAll(_getInvitedUsersForLogisticsPartyResponse, exports);
var _getRequestedUserProfileInfoRequest = require("./GetRequestedUserProfileInfoRequest");
parcelHelpers.exportAll(_getRequestedUserProfileInfoRequest, exports);
var _getRequestedUserProfileInfoResponse = require("./GetRequestedUserProfileInfoResponse");
parcelHelpers.exportAll(_getRequestedUserProfileInfoResponse, exports);
var _getUserProfileInfoRequest = require("./GetUserProfileInfoRequest");
parcelHelpers.exportAll(_getUserProfileInfoRequest, exports);
var _getUserProfileInfoResponse = require("./GetUserProfileInfoResponse");
parcelHelpers.exportAll(_getUserProfileInfoResponse, exports);
var _getUsersForLogisticsPartyRequest = require("./GetUsersForLogisticsPartyRequest");
parcelHelpers.exportAll(_getUsersForLogisticsPartyRequest, exports);
var _getUsersForLogisticsPartyResponse = require("./GetUsersForLogisticsPartyResponse");
parcelHelpers.exportAll(_getUsersForLogisticsPartyResponse, exports);
var _invitationChannelInfo = require("./InvitationChannelInfo");
parcelHelpers.exportAll(_invitationChannelInfo, exports);
var _invitationStatus = require("./InvitationStatus");
parcelHelpers.exportAll(_invitationStatus, exports);
var _invitedUser = require("./InvitedUser");
parcelHelpers.exportAll(_invitedUser, exports);
var _invitedUserList = require("./InvitedUserList");
parcelHelpers.exportAll(_invitedUserList, exports);
var _locale = require("./Locale");
parcelHelpers.exportAll(_locale, exports);
var _localeUserFriendlyString = require("./LocaleUserFriendlyString");
parcelHelpers.exportAll(_localeUserFriendlyString, exports);
var _metric = require("./Metric");
parcelHelpers.exportAll(_metric, exports);
var _metricList = require("./MetricList");
parcelHelpers.exportAll(_metricList, exports);
var _passportUserManagementService = require("./PassportUserManagementService");
parcelHelpers.exportAll(_passportUserManagementService, exports);
var _pumsinvalidRequestException = require("./PUMSInvalidRequestException");
parcelHelpers.exportAll(_pumsinvalidRequestException, exports);
var _pumsrecoverableException = require("./PUMSRecoverableException");
parcelHelpers.exportAll(_pumsrecoverableException, exports);
var _pumsunAuthorizedException = require("./PUMSUnAuthorizedException");
parcelHelpers.exportAll(_pumsunAuthorizedException, exports);
var _pumsunrecoverableException = require("./PUMSUnrecoverableException");
parcelHelpers.exportAll(_pumsunrecoverableException, exports);
var _requestedPermissions = require("./RequestedPermissions");
parcelHelpers.exportAll(_requestedPermissions, exports);
var _requestedPermissionsList = require("./RequestedPermissionsList");
parcelHelpers.exportAll(_requestedPermissionsList, exports);
var _resendInvitationRequest = require("./ResendInvitationRequest");
parcelHelpers.exportAll(_resendInvitationRequest, exports);
var _resendInvitationResponse = require("./ResendInvitationResponse");
parcelHelpers.exportAll(_resendInvitationResponse, exports);
var _timeZone = require("./TimeZone");
parcelHelpers.exportAll(_timeZone, exports);
var _updateUserProfileInfoRequest = require("./UpdateUserProfileInfoRequest");
parcelHelpers.exportAll(_updateUserProfileInfoRequest, exports);
var _updateUserProfileInfoResponse = require("./UpdateUserProfileInfoResponse");
parcelHelpers.exportAll(_updateUserProfileInfoResponse, exports);
var _user = require("./User");
parcelHelpers.exportAll(_user, exports);
var _userAuthInput = require("./UserAuthInput");
parcelHelpers.exportAll(_userAuthInput, exports);
var _userAuthOutput = require("./UserAuthOutput");
parcelHelpers.exportAll(_userAuthOutput, exports);
var _userDeactivationStatus = require("./UserDeactivationStatus");
parcelHelpers.exportAll(_userDeactivationStatus, exports);
var _userDeactivationType = require("./UserDeactivationType");
parcelHelpers.exportAll(_userDeactivationType, exports);
var _userIdentifier = require("./UserIdentifier");
parcelHelpers.exportAll(_userIdentifier, exports);
var _userList = require("./UserList");
parcelHelpers.exportAll(_userList, exports);

},{"./AcceptInvitationRequest":"2cYp2","./AcceptInvitationResponse":"7M5i5","./AmazonEmployeeIdentifier":"fmi7L","./BaseRequest":"6LRnc","./ConfirmInvitationRequest":"HIkVz","./ConfirmInvitationResponse":"eixtm","./CreateInvitationRequest":"4rtx3","./CreateInvitationResponse":"kNbgG","./DeactivateUserRequest":"1OFUm","./DeactivateUserResponse":"2tx3W","./DeleteInvitationRequest":"fsAgs","./DeleteInvitationResponse":"8T376","./DeliveryStatus":"a0JpJ","./EmailInvitationChannelInfo":"5diCv","./ErrorCode":"8nAo8","./ExceptionDetails":"7QDtq","./ExternalCustomerIdentifier":"gCF5A","./GetAnalyticsMetricsRequest":"8xagX","./GetAnalyticsMetricsResponse":"amBn5","./GetDeactivatedUsersRequest":"60Yvp","./GetDeactivatedUsersResponse":"l9L20","./GetInvitationRequest":"7FXPd","./GetInvitationResponse":"eljkr","./GetInvitedUsersForLogisticsPartyRequest":"eJWkf","./GetInvitedUsersForLogisticsPartyResponse":"63kp1","./GetRequestedUserProfileInfoRequest":"6cG7z","./GetRequestedUserProfileInfoResponse":"9XnTI","./GetUserProfileInfoRequest":"edz9Y","./GetUserProfileInfoResponse":"03JcB","./GetUsersForLogisticsPartyRequest":"4G3nh","./GetUsersForLogisticsPartyResponse":"1BV5O","./InvitationChannelInfo":"jn64L","./InvitationStatus":"1neV1","./InvitedUser":"1xXfs","./InvitedUserList":"8TcoB","./Locale":"i9Xqc","./LocaleUserFriendlyString":"brsQl","./Metric":"8HeCR","./MetricList":"hcfma","./PassportUserManagementService":"5hYNC","./PUMSInvalidRequestException":"6fPvb","./PUMSRecoverableException":"bm76L","./PUMSUnAuthorizedException":"1sxlQ","./PUMSUnrecoverableException":"8Hwtd","./RequestedPermissions":"1YQ2K","./RequestedPermissionsList":"KUbt7","./ResendInvitationRequest":"dm3PJ","./ResendInvitationResponse":"eWYfm","./TimeZone":"kyolR","./UpdateUserProfileInfoRequest":"i4EKJ","./UpdateUserProfileInfoResponse":"28Kz3","./User":"1oWxo","./UserAuthInput":"lxtFa","./UserAuthOutput":"5R2if","./UserDeactivationStatus":"aLvW3","./UserDeactivationType":"avKdE","./UserIdentifier":"e0jDb","./UserList":"3hrDR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cYp2":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to accept a invitation.
 **/ parcelHelpers.export(exports, "AcceptInvitationRequest", ()=>AcceptInvitationRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AcceptInvitationRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAcceptinvitationrequest", ()=>validateAcceptinvitationrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class AcceptInvitationRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AcceptInvitationRequest#clone(obj: PlainObjectFrom<AcceptInvitationRequest>) method.
     */ constructor(__invitationId, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.invitationId = __invitationId;
    }
    /**
     * Create a shallow clone of AcceptInvitationRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AcceptInvitationRequest(obj.invitationId, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new AcceptInvitationRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
AcceptInvitationRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#AcceptInvitationRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AcceptInvitationRequest);
function validateAcceptinvitationrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LRnc":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This object is to capture common attributes such as user session attributes for all the requests.
 * For external users this will be populated from Mons and for internal users this will be populated by TransPassportWebServer.
 **/ parcelHelpers.export(exports, "BaseRequest", ()=>BaseRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BaseRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBaserequest", ()=>validateBaserequest);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _serializer = require("@amzn/ihm-js-coral-client/serializer");
class BaseRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BaseRequest#clone(obj: PlainObjectFrom<BaseRequest>) method.
     */ constructor(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super();
        this.customerId = __customerId;
        this.customerRights = __customerRights;
        this.internalUserAttributes = __internalUserAttributes;
        this.logisticsPartyId = __logisticsPartyId;
        this.userAlias = __userAlias;
    }
    /**
     * Create a shallow clone of BaseRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BaseRequest(obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== BaseRequest.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new BaseRequest((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== BaseRequest.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
BaseRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#BaseRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BaseRequest);
function validateBaserequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@amzn/ihm-js-coral-client/serializer":"ikaAd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7M5i5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns invitation status based on the input.
 **/ parcelHelpers.export(exports, "AcceptInvitationResponse", ()=>AcceptInvitationResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AcceptInvitationResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAcceptinvitationresponse", ()=>validateAcceptinvitationresponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class AcceptInvitationResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AcceptInvitationResponse#clone(obj: PlainObjectFrom<AcceptInvitationResponse>) method.
     */ constructor(__invitationStatus){
        super();
        this.invitationStatus = __invitationStatus;
    }
    /**
     * Create a shallow clone of AcceptInvitationResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AcceptInvitationResponse(obj.invitationStatus);
    }
    static fromJson(data) {
        return new AcceptInvitationResponse((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus));
    }
    static toJson(data) {
        return Object.assign({
            invitationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus)
        });
    }
}
AcceptInvitationResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#AcceptInvitationResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AcceptInvitationResponse);
function validateAcceptinvitationresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fmi7L":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to uniquely identifying a internal amazon employee.
 **/ parcelHelpers.export(exports, "AmazonEmployeeIdentifier", ()=>AmazonEmployeeIdentifier);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AmazonEmployeeIdentifier] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAmazonemployeeidentifier", ()=>validateAmazonemployeeidentifier);
var _userIdentifier = require("./UserIdentifier");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class AmazonEmployeeIdentifier extends (0, _userIdentifier.UserIdentifier) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AmazonEmployeeIdentifier#clone(obj: PlainObjectFrom<AmazonEmployeeIdentifier>) method.
     */ constructor(__amazonAlias){
        super();
        this.amazonAlias = __amazonAlias;
    }
    /**
     * Create a shallow clone of AmazonEmployeeIdentifier from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AmazonEmployeeIdentifier(obj.amazonAlias);
    }
    static fromJson(data) {
        return new AmazonEmployeeIdentifier((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.amazonAlias));
    }
    static toJson(data) {
        return Object.assign({
            amazonAlias: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.amazonAlias)
        });
    }
}
AmazonEmployeeIdentifier.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#AmazonEmployeeIdentifier";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AmazonEmployeeIdentifier);
function validateAmazonemployeeidentifier(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserIdentifier":"e0jDb","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0jDb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to uniquely identifying a user for the system.
 **/ parcelHelpers.export(exports, "UserIdentifier", ()=>UserIdentifier);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserIdentifier] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUseridentifier", ()=>validateUseridentifier);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _serializer = require("@amzn/ihm-js-coral-client/serializer");
class UserIdentifier extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UserIdentifier#clone(obj: PlainObjectFrom<UserIdentifier>) method.
     */ static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== UserIdentifier.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        // Attempting to deserialize an Abstract type without its fullyQualifiedTypeName (__type).
        throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== UserIdentifier.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        // Attempting to serialize an Abstract type without its fullyQualifiedTypeName
        throw new (0, _serializer.CoralDeserializationTypeError)(UserIdentifier.fullyQualifiedTypeName);
    }
}
UserIdentifier.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#UserIdentifier";
function validateUseridentifier(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@amzn/ihm-js-coral-client/serializer":"ikaAd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"HIkVz":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to confirm a invitation.
 **/ parcelHelpers.export(exports, "ConfirmInvitationRequest", ()=>ConfirmInvitationRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ConfirmInvitationRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateConfirminvitationrequest", ()=>validateConfirminvitationrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ConfirmInvitationRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ConfirmInvitationRequest#clone(obj: PlainObjectFrom<ConfirmInvitationRequest>) method.
     */ constructor(__invitationId, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.invitationId = __invitationId;
    }
    /**
     * Create a shallow clone of ConfirmInvitationRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ConfirmInvitationRequest(obj.invitationId, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new ConfirmInvitationRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
ConfirmInvitationRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#ConfirmInvitationRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ConfirmInvitationRequest);
function validateConfirminvitationrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eixtm":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns invitation status based on the input.
 **/ parcelHelpers.export(exports, "ConfirmInvitationResponse", ()=>ConfirmInvitationResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ConfirmInvitationResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateConfirminvitationresponse", ()=>validateConfirminvitationresponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ConfirmInvitationResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ConfirmInvitationResponse#clone(obj: PlainObjectFrom<ConfirmInvitationResponse>) method.
     */ constructor(__invitationStatus){
        super();
        this.invitationStatus = __invitationStatus;
    }
    /**
     * Create a shallow clone of ConfirmInvitationResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ConfirmInvitationResponse(obj.invitationStatus);
    }
    static fromJson(data) {
        return new ConfirmInvitationResponse((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus));
    }
    static toJson(data) {
        return Object.assign({
            invitationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus)
        });
    }
}
ConfirmInvitationResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#ConfirmInvitationResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ConfirmInvitationResponse);
function validateConfirminvitationresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4rtx3":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to create a invitation.
 * requestedPermissionsList: If the invited user accepts the invitation, permissions will be assigned.
 **/ parcelHelpers.export(exports, "CreateInvitationRequest", ()=>CreateInvitationRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CreateInvitationRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCreateinvitationrequest", ()=>validateCreateinvitationrequest);
var _requestedPermissionsList = require("./RequestedPermissionsList");
var _baseRequest = require("./BaseRequest");
var _invitationChannelInfo = require("./InvitationChannelInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CreateInvitationRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CreateInvitationRequest#clone(obj: PlainObjectFrom<CreateInvitationRequest>) method.
     */ constructor(__invitationChannelInfo, __locale, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __requestedPermissionsList, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.invitationChannelInfo = __invitationChannelInfo;
        this.locale = __locale;
        this.requestedPermissionsList = __requestedPermissionsList;
    }
    /**
     * Create a shallow clone of CreateInvitationRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CreateInvitationRequest(obj.invitationChannelInfo, obj.locale, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.requestedPermissionsList, obj.userAlias);
    }
    static fromJson(data) {
        return new CreateInvitationRequest((0, _invitationChannelInfo.InvitationChannelInfo).fromJson(data.invitationChannelInfo), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.locale), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _requestedPermissionsList.RequestedPermissionsList).fromJson($$val))(data.requestedPermissionsList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            invitationChannelInfo: (0, _invitationChannelInfo.InvitationChannelInfo).toJson(data.invitationChannelInfo),
            locale: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.locale),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            requestedPermissionsList: (($$val)=>$$val == undefined ? null : (0, _requestedPermissionsList.RequestedPermissionsList).toJson($$val))(data.requestedPermissionsList),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
CreateInvitationRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#CreateInvitationRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreateInvitationRequest);
function validateCreateinvitationrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequestedPermissionsList":"KUbt7","./BaseRequest":"6LRnc","./InvitationChannelInfo":"jn64L","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"KUbt7":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of requested permissions for invited user
 **/ parcelHelpers.export(exports, "RequestedPermissionsList", ()=>RequestedPermissionsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestedPermissionsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequestedpermissionslist", ()=>validateRequestedpermissionslist);
var _requestedPermissions = require("./RequestedPermissions");
class RequestedPermissionsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(RequestedPermissionsList.prototype));
    }
    static fromJson(data) {
        return new RequestedPermissionsList(data.map((datum)=>(0, _requestedPermissions.RequestedPermissions).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _requestedPermissions.RequestedPermissions).toJson(datum));
    }
}
function validateRequestedpermissionslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequestedPermissions":"1YQ2K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1YQ2K":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission requested for invited user.
 **/ parcelHelpers.export(exports, "RequestedPermissions", ()=>RequestedPermissions);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestedPermissions] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequestedpermissions", ()=>validateRequestedpermissions);
var _coralComAmazonPassportaccessmanagementcore = require("@amzn/coral_com-amazon-passportaccessmanagementcore");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RequestedPermissions extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestedPermissions#clone(obj: PlainObjectFrom<RequestedPermissions>) method.
     */ constructor(__operationList, __permissionKeyList){
        super();
        this.operationList = __operationList;
        this.permissionKeyList = __permissionKeyList;
    }
    /**
     * Create a shallow clone of RequestedPermissions from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestedPermissions(obj.operationList, obj.permissionKeyList);
    }
    static fromJson(data) {
        return new RequestedPermissions(_coralComAmazonPassportaccessmanagementcore.OperationList.fromJson(data.operationList), _coralComAmazonPassportaccessmanagementcore.PermissionKeyList.fromJson(data.permissionKeyList));
    }
    static toJson(data) {
        return Object.assign({
            operationList: _coralComAmazonPassportaccessmanagementcore.OperationList.toJson(data.operationList),
            permissionKeyList: _coralComAmazonPassportaccessmanagementcore.PermissionKeyList.toJson(data.permissionKeyList)
        });
    }
}
RequestedPermissions.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#RequestedPermissions";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RequestedPermissions);
function validateRequestedpermissions(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral_com-amazon-passportaccessmanagementcore":"6eB7O","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6eB7O":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _admin = require("./Admin");
parcelHelpers.exportAll(_admin, exports);
var _assignPermissionsToUser = require("./AssignPermissionsToUser");
parcelHelpers.exportAll(_assignPermissionsToUser, exports);
var _assignPermissionsToUserStatus = require("./AssignPermissionsToUserStatus");
parcelHelpers.exportAll(_assignPermissionsToUserStatus, exports);
var _assignUserInput = require("./AssignUserInput");
parcelHelpers.exportAll(_assignUserInput, exports);
var _assignUserList = require("./AssignUserList");
parcelHelpers.exportAll(_assignUserList, exports);
var _assignUserStatusList = require("./AssignUserStatusList");
parcelHelpers.exportAll(_assignUserStatusList, exports);
var _auditEvent = require("./AuditEvent");
parcelHelpers.exportAll(_auditEvent, exports);
var _auditEventsList = require("./AuditEventsList");
parcelHelpers.exportAll(_auditEventsList, exports);
var _authorizedUserList = require("./AuthorizedUserList");
parcelHelpers.exportAll(_authorizedUserList, exports);
var _baseAssignUserInput = require("./BaseAssignUserInput");
parcelHelpers.exportAll(_baseAssignUserInput, exports);
var _baseDeAssignUserInput = require("./BaseDeAssignUserInput");
parcelHelpers.exportAll(_baseDeAssignUserInput, exports);
var _batchAssignUserInput = require("./BatchAssignUserInput");
parcelHelpers.exportAll(_batchAssignUserInput, exports);
var _batchAssignUserOutput = require("./BatchAssignUserOutput");
parcelHelpers.exportAll(_batchAssignUserOutput, exports);
var _batchDeAssignUserInput = require("./BatchDeAssignUserInput");
parcelHelpers.exportAll(_batchDeAssignUserInput, exports);
var _batchDeAssignUserOutput = require("./BatchDeAssignUserOutput");
parcelHelpers.exportAll(_batchDeAssignUserOutput, exports);
var _caseCategoryPermissionKey = require("./CaseCategoryPermissionKey");
parcelHelpers.exportAll(_caseCategoryPermissionKey, exports);
var _caseResolverGroupPermissionKey = require("./CaseResolverGroupPermissionKey");
parcelHelpers.exportAll(_caseResolverGroupPermissionKey, exports);
var _createCustomOperationInput = require("./CreateCustomOperationInput");
parcelHelpers.exportAll(_createCustomOperationInput, exports);
var _createPAMRoleMappingInput = require("./CreatePAMRoleMappingInput");
parcelHelpers.exportAll(_createPAMRoleMappingInput, exports);
var _creationStatus = require("./CreationStatus");
parcelHelpers.exportAll(_creationStatus, exports);
var _deactivateUserInput = require("./DeactivateUserInput");
parcelHelpers.exportAll(_deactivateUserInput, exports);
var _deactivateUserOutput = require("./DeactivateUserOutput");
parcelHelpers.exportAll(_deactivateUserOutput, exports);
var _deAssignPermissionsToUser = require("./DeAssignPermissionsToUser");
parcelHelpers.exportAll(_deAssignPermissionsToUser, exports);
var _deAssignPermissionsToUserStatus = require("./DeAssignPermissionsToUserStatus");
parcelHelpers.exportAll(_deAssignPermissionsToUserStatus, exports);
var _deAssignUserInput = require("./DeAssignUserInput");
parcelHelpers.exportAll(_deAssignUserInput, exports);
var _deAssignUserList = require("./DeAssignUserList");
parcelHelpers.exportAll(_deAssignUserList, exports);
var _deAssignUserStatusList = require("./DeAssignUserStatusList");
parcelHelpers.exportAll(_deAssignUserStatusList, exports);
var _deleteCustomOperationInput = require("./DeleteCustomOperationInput");
parcelHelpers.exportAll(_deleteCustomOperationInput, exports);
var _disableExternalTermForLogisticPartyInput = require("./DisableExternalTermForLogisticPartyInput");
parcelHelpers.exportAll(_disableExternalTermForLogisticPartyInput, exports);
var _disableExternalTermForLogisticPartyOutput = require("./DisableExternalTermForLogisticPartyOutput");
parcelHelpers.exportAll(_disableExternalTermForLogisticPartyOutput, exports);
var _enableExternalEntityForLogisticPartyInput = require("./EnableExternalEntityForLogisticPartyInput");
parcelHelpers.exportAll(_enableExternalEntityForLogisticPartyInput, exports);
var _enableExternalEntityForLogisticPartyOutput = require("./EnableExternalEntityForLogisticPartyOutput");
parcelHelpers.exportAll(_enableExternalEntityForLogisticPartyOutput, exports);
var _enableExternalTermForLogisticPartyInput = require("./EnableExternalTermForLogisticPartyInput");
parcelHelpers.exportAll(_enableExternalTermForLogisticPartyInput, exports);
var _enableExternalTermForLogisticPartyOutput = require("./EnableExternalTermForLogisticPartyOutput");
parcelHelpers.exportAll(_enableExternalTermForLogisticPartyOutput, exports);
var _enableSubscriptionForLogisticsPartyInput = require("./EnableSubscriptionForLogisticsPartyInput");
parcelHelpers.exportAll(_enableSubscriptionForLogisticsPartyInput, exports);
var _enableSubscriptionForLogisticsPartyOutput = require("./EnableSubscriptionForLogisticsPartyOutput");
parcelHelpers.exportAll(_enableSubscriptionForLogisticsPartyOutput, exports);
var _entityList = require("./EntityList");
parcelHelpers.exportAll(_entityList, exports);
var _entityPermissions = require("./EntityPermissions");
parcelHelpers.exportAll(_entityPermissions, exports);
var _entityPermissionsList = require("./EntityPermissionsList");
parcelHelpers.exportAll(_entityPermissionsList, exports);
var _eventPermissionKey = require("./EventPermissionKey");
parcelHelpers.exportAll(_eventPermissionKey, exports);
var _eventTermPermissionKey = require("./EventTermPermissionKey");
parcelHelpers.exportAll(_eventTermPermissionKey, exports);
var _getAuditEventsInput = require("./GetAuditEventsInput");
parcelHelpers.exportAll(_getAuditEventsInput, exports);
var _getAuditEventsOutput = require("./GetAuditEventsOutput");
parcelHelpers.exportAll(_getAuditEventsOutput, exports);
var _getAuthorizedPermissionsInput = require("./GetAuthorizedPermissionsInput");
parcelHelpers.exportAll(_getAuthorizedPermissionsInput, exports);
var _getAuthorizedPermissionsOutput = require("./GetAuthorizedPermissionsOutput");
parcelHelpers.exportAll(_getAuthorizedPermissionsOutput, exports);
var _getPermissionRequestsInput = require("./GetPermissionRequestsInput");
parcelHelpers.exportAll(_getPermissionRequestsInput, exports);
var _getPermissionRequestsOutput = require("./GetPermissionRequestsOutput");
parcelHelpers.exportAll(_getPermissionRequestsOutput, exports);
var _isUserAuthorizedInput = require("./IsUserAuthorizedInput");
parcelHelpers.exportAll(_isUserAuthorizedInput, exports);
var _isUserAuthorizedOutput = require("./IsUserAuthorizedOutput");
parcelHelpers.exportAll(_isUserAuthorizedOutput, exports);
var _listAllOperationsOutput = require("./ListAllOperationsOutput");
parcelHelpers.exportAll(_listAllOperationsOutput, exports);
var _listAllPermissionsForEntityInput = require("./ListAllPermissionsForEntityInput");
parcelHelpers.exportAll(_listAllPermissionsForEntityInput, exports);
var _listAllPermissionsForEntityOutput = require("./ListAllPermissionsForEntityOutput");
parcelHelpers.exportAll(_listAllPermissionsForEntityOutput, exports);
var _listAuthorizedGroupsInput = require("./ListAuthorizedGroupsInput");
parcelHelpers.exportAll(_listAuthorizedGroupsInput, exports);
var _listAuthorizedGroupsOutput = require("./ListAuthorizedGroupsOutput");
parcelHelpers.exportAll(_listAuthorizedGroupsOutput, exports);
var _listAuthorizedOperationsInput = require("./ListAuthorizedOperationsInput");
parcelHelpers.exportAll(_listAuthorizedOperationsInput, exports);
var _listAuthorizedOperationsOutput = require("./ListAuthorizedOperationsOutput");
parcelHelpers.exportAll(_listAuthorizedOperationsOutput, exports);
var _listAuthorizedPermissionKeysInput = require("./ListAuthorizedPermissionKeysInput");
parcelHelpers.exportAll(_listAuthorizedPermissionKeysInput, exports);
var _listAuthorizedPermissionKeysOutput = require("./ListAuthorizedPermissionKeysOutput");
parcelHelpers.exportAll(_listAuthorizedPermissionKeysOutput, exports);
var _listAuthorizedUsersInput = require("./ListAuthorizedUsersInput");
parcelHelpers.exportAll(_listAuthorizedUsersInput, exports);
var _listAuthorizedUsersOutput = require("./ListAuthorizedUsersOutput");
parcelHelpers.exportAll(_listAuthorizedUsersOutput, exports);
var _listEnabledExternalEntitiesForLogisticPartyInput = require("./ListEnabledExternalEntitiesForLogisticPartyInput");
parcelHelpers.exportAll(_listEnabledExternalEntitiesForLogisticPartyInput, exports);
var _listEnabledExternalEntitiesForLogisticPartyOutput = require("./ListEnabledExternalEntitiesForLogisticPartyOutput");
parcelHelpers.exportAll(_listEnabledExternalEntitiesForLogisticPartyOutput, exports);
var _listEnabledExternalTermsForLogisticPartyInput = require("./ListEnabledExternalTermsForLogisticPartyInput");
parcelHelpers.exportAll(_listEnabledExternalTermsForLogisticPartyInput, exports);
var _listEnabledExternalTermsForLogisticPartyOutput = require("./ListEnabledExternalTermsForLogisticPartyOutput");
parcelHelpers.exportAll(_listEnabledExternalTermsForLogisticPartyOutput, exports);
var _operationList = require("./OperationList");
parcelHelpers.exportAll(_operationList, exports);
var _pamcoreInvalidRequestException = require("./PAMCoreInvalidRequestException");
parcelHelpers.exportAll(_pamcoreInvalidRequestException, exports);
var _pamcoreRecoverableException = require("./PAMCoreRecoverableException");
parcelHelpers.exportAll(_pamcoreRecoverableException, exports);
var _pamcoreUnrecoverableException = require("./PAMCoreUnrecoverableException");
parcelHelpers.exportAll(_pamcoreUnrecoverableException, exports);
var _pamrolesMapping = require("./PAMRolesMapping");
parcelHelpers.exportAll(_pamrolesMapping, exports);
var _passportAccessManagementCore = require("./PassportAccessManagementCore");
parcelHelpers.exportAll(_passportAccessManagementCore, exports);
var _permission = require("./Permission");
parcelHelpers.exportAll(_permission, exports);
var _permissionEntityType = require("./PermissionEntityType");
parcelHelpers.exportAll(_permissionEntityType, exports);
var _permissionKey = require("./PermissionKey");
parcelHelpers.exportAll(_permissionKey, exports);
var _permissionKeyList = require("./PermissionKeyList");
parcelHelpers.exportAll(_permissionKeyList, exports);
var _permissionList = require("./PermissionList");
parcelHelpers.exportAll(_permissionList, exports);
var _permissionRequest = require("./PermissionRequest");
parcelHelpers.exportAll(_permissionRequest, exports);
var _permissionRequestsList = require("./PermissionRequestsList");
parcelHelpers.exportAll(_permissionRequestsList, exports);
var _permissionRequestStatus = require("./PermissionRequestStatus");
parcelHelpers.exportAll(_permissionRequestStatus, exports);
var _permissionRequestStatusList = require("./PermissionRequestStatusList");
parcelHelpers.exportAll(_permissionRequestStatusList, exports);
var _putPermissionRequestsInput = require("./PutPermissionRequestsInput");
parcelHelpers.exportAll(_putPermissionRequestsInput, exports);
var _putPermissionRequestsOutput = require("./PutPermissionRequestsOutput");
parcelHelpers.exportAll(_putPermissionRequestsOutput, exports);
var _queriedBy = require("./QueriedBy");
parcelHelpers.exportAll(_queriedBy, exports);
var _requestedBy = require("./RequestedBy");
parcelHelpers.exportAll(_requestedBy, exports);
var _requestedFor = require("./RequestedFor");
parcelHelpers.exportAll(_requestedFor, exports);
var _right = require("./Right");
parcelHelpers.exportAll(_right, exports);
var _rightsList = require("./RightsList");
parcelHelpers.exportAll(_rightsList, exports);
var _role = require("./Role");
parcelHelpers.exportAll(_role, exports);
var _roleNameToValueMapping = require("./RoleNameToValueMapping");
parcelHelpers.exportAll(_roleNameToValueMapping, exports);
var _scpermissionKey = require("./SCPermissionKey");
parcelHelpers.exportAll(_scpermissionKey, exports);
var _sctermPermissionKey = require("./SCTermPermissionKey");
parcelHelpers.exportAll(_sctermPermissionKey, exports);
var _spcaseCategoryPermissionKey = require("./SPCaseCategoryPermissionKey");
parcelHelpers.exportAll(_spcaseCategoryPermissionKey, exports);
var _spcaseResolverGroupPermissionKey = require("./SPCaseResolverGroupPermissionKey");
parcelHelpers.exportAll(_spcaseResolverGroupPermissionKey, exports);
var _specificationKey = require("./SpecificationKey");
parcelHelpers.exportAll(_specificationKey, exports);
var _sppermissionKey = require("./SPPermissionKey");
parcelHelpers.exportAll(_sppermissionKey, exports);
var _spservicePermissionKey = require("./SPServicePermissionKey");
parcelHelpers.exportAll(_spservicePermissionKey, exports);
var _spserviceTermPermissionKey = require("./SPServiceTermPermissionKey");
parcelHelpers.exportAll(_spserviceTermPermissionKey, exports);
var _spspecificationPermissionKey = require("./SPSpecificationPermissionKey");
parcelHelpers.exportAll(_spspecificationPermissionKey, exports);
var _sptermPermissionKey = require("./SPTermPermissionKey");
parcelHelpers.exportAll(_sptermPermissionKey, exports);
var _sptermSpecificationPermissionKey = require("./SPTermSpecificationPermissionKey");
parcelHelpers.exportAll(_sptermSpecificationPermissionKey, exports);
var _status = require("./Status");
parcelHelpers.exportAll(_status, exports);
var _termPermissionKey = require("./TermPermissionKey");
parcelHelpers.exportAll(_termPermissionKey, exports);
var _termSpecificationPermissionKey = require("./TermSpecificationPermissionKey");
parcelHelpers.exportAll(_termSpecificationPermissionKey, exports);
var _updatePermissionRequestInput = require("./UpdatePermissionRequestInput");
parcelHelpers.exportAll(_updatePermissionRequestInput, exports);
var _updatePermissionRequestOutput = require("./UpdatePermissionRequestOutput");
parcelHelpers.exportAll(_updatePermissionRequestOutput, exports);
var _user = require("./User");
parcelHelpers.exportAll(_user, exports);
var _userType = require("./UserType");
parcelHelpers.exportAll(_userType, exports);

},{"./Admin":"grhmN","./AssignPermissionsToUser":"i5oTv","./AssignPermissionsToUserStatus":"6iWKB","./AssignUserInput":"3oawK","./AssignUserList":"2okKk","./AssignUserStatusList":"lE2nP","./AuditEvent":"4V01e","./AuditEventsList":"4P4Wp","./AuthorizedUserList":"7jhGP","./BaseAssignUserInput":"894rG","./BaseDeAssignUserInput":"8j2t9","./BatchAssignUserInput":"iFjYJ","./BatchAssignUserOutput":"4zHrS","./BatchDeAssignUserInput":"gePIC","./BatchDeAssignUserOutput":"gkDXW","./CaseCategoryPermissionKey":"iFUAU","./CaseResolverGroupPermissionKey":"1JqxU","./CreateCustomOperationInput":"6C2mM","./CreatePAMRoleMappingInput":"gSEA6","./CreationStatus":"iq11l","./DeactivateUserInput":"lUqhB","./DeactivateUserOutput":"3cqXj","./DeAssignPermissionsToUser":"bXMQK","./DeAssignPermissionsToUserStatus":"jPbyr","./DeAssignUserInput":"5sG77","./DeAssignUserList":"3pECq","./DeAssignUserStatusList":"cXmE3","./DeleteCustomOperationInput":"kgpSb","./DisableExternalTermForLogisticPartyInput":"fTgpt","./DisableExternalTermForLogisticPartyOutput":"j2x6l","./EnableExternalEntityForLogisticPartyInput":"6XOd1","./EnableExternalEntityForLogisticPartyOutput":"kVd1L","./EnableExternalTermForLogisticPartyInput":"auygu","./EnableExternalTermForLogisticPartyOutput":"2ucI1","./EnableSubscriptionForLogisticsPartyInput":"arsYo","./EnableSubscriptionForLogisticsPartyOutput":"lvzVx","./EntityList":"hGdNn","./EntityPermissions":"5S00x","./EntityPermissionsList":"8sRey","./EventPermissionKey":"3aOXz","./EventTermPermissionKey":"2jD6S","./GetAuditEventsInput":"jK2GY","./GetAuditEventsOutput":"bzd2T","./GetAuthorizedPermissionsInput":"dhSK1","./GetAuthorizedPermissionsOutput":"aajit","./GetPermissionRequestsInput":"76Hvq","./GetPermissionRequestsOutput":"fqN0w","./IsUserAuthorizedInput":"9Jyc8","./IsUserAuthorizedOutput":"01rXE","./ListAllOperationsOutput":"1mevH","./ListAllPermissionsForEntityInput":"5qglB","./ListAllPermissionsForEntityOutput":"fxOi9","./ListAuthorizedGroupsInput":"3w3Bn","./ListAuthorizedGroupsOutput":"57pmJ","./ListAuthorizedOperationsInput":"lSHha","./ListAuthorizedOperationsOutput":"3iiVL","./ListAuthorizedPermissionKeysInput":"ib9L5","./ListAuthorizedPermissionKeysOutput":"9IK7X","./ListAuthorizedUsersInput":"3g72S","./ListAuthorizedUsersOutput":"eUpPg","./ListEnabledExternalEntitiesForLogisticPartyInput":"kTNba","./ListEnabledExternalEntitiesForLogisticPartyOutput":"5xDL9","./ListEnabledExternalTermsForLogisticPartyInput":"duJ7U","./ListEnabledExternalTermsForLogisticPartyOutput":"8amvq","./OperationList":"1Jkj5","./PAMCoreInvalidRequestException":"DA6bv","./PAMCoreRecoverableException":"3TYr5","./PAMCoreUnrecoverableException":"bEBAa","./PAMRolesMapping":"igzDQ","./PassportAccessManagementCore":"8KgwC","./Permission":"yA4xO","./PermissionEntityType":"1HTmW","./PermissionKey":"jW9S8","./PermissionKeyList":"kzggn","./PermissionList":"2l0hE","./PermissionRequest":"IzI8O","./PermissionRequestsList":"ktYTo","./PermissionRequestStatus":"iLlFM","./PermissionRequestStatusList":"95ZbU","./PutPermissionRequestsInput":"cfKjq","./PutPermissionRequestsOutput":"9X2FY","./QueriedBy":"gru4f","./RequestedBy":"kYX85","./RequestedFor":"7VjXp","./Right":"cpbmv","./RightsList":"353Tl","./Role":"4i1wK","./RoleNameToValueMapping":"jK1Yq","./SCPermissionKey":"1jV9e","./SCTermPermissionKey":"48B1V","./SPCaseCategoryPermissionKey":"h14qy","./SPCaseResolverGroupPermissionKey":"fOdPU","./SpecificationKey":"aicnO","./SPPermissionKey":"i4wus","./SPServicePermissionKey":"z4u9v","./SPServiceTermPermissionKey":"lB208","./SPSpecificationPermissionKey":"8tqyJ","./SPTermPermissionKey":"1olDJ","./SPTermSpecificationPermissionKey":"gOxXU","./Status":"8RGRn","./TermPermissionKey":"4Wa8X","./TermSpecificationPermissionKey":"6ARX4","./UpdatePermissionRequestInput":"3TEFQ","./UpdatePermissionRequestOutput":"eo7K5","./User":"4Ihn2","./UserType":"gBqzN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grhmN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Structure to capture the user in PAM who will be able to give permissions to Users.
 **/ parcelHelpers.export(exports, "Admin", ()=>Admin);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Admin] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAdmin", ()=>validateAdmin);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class Admin extends (0, _user.User) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Admin#clone(obj: PlainObjectFrom<Admin>) method.
     */ /**
     * Create a shallow clone of Admin from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Admin(obj.userId, obj.userType);
    }
    static fromJson(data) {
        return new Admin((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType));
    }
    static toJson(data) {
        return Object.assign({
            userId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId),
            userType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType)
        });
    }
}
Admin.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#Admin";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Admin);
function validateAdmin(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Ihn2":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Structure to capture the user in PAM who will be assigned and de-assigned to roles.
 * UserType is not required, it will be assumed as individual user by default.
 **/ parcelHelpers.export(exports, "User", ()=>User);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [User] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUser", ()=>validateUser);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class User extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the User#clone(obj: PlainObjectFrom<User>) method.
     */ constructor(__userId, __userType){
        super();
        this.userId = __userId;
        this.userType = __userType;
    }
    /**
     * Create a shallow clone of User from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new User(obj.userId, obj.userType);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== User.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new User((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== User.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            userId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId),
            userType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType)
        });
    }
}
User.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#User";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(User);
function validateUser(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1r6qG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _handlers = require("./handlers");
parcelHelpers.exportAll(_handlers, exports);
var _interceptors = require("./interceptors");
parcelHelpers.exportAll(_interceptors, exports);
var _model = require("./model");
parcelHelpers.exportAll(_model, exports);

},{"./client":"7E92U","./handlers":"bwP8Z","./interceptors":"4U6Ze","./model":"kyL0A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7E92U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clientFactory = require("./client-factory");
parcelHelpers.exportAll(_clientFactory, exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _configFactory = require("./config-factory");
parcelHelpers.exportAll(_configFactory, exports);
var _partitionCoralClientConfigFactory = require("./partition-coral-client-config-factory");
parcelHelpers.exportAll(_partitionCoralClientConfigFactory, exports);
var _coralRequest = require("./coral-request");
parcelHelpers.exportAll(_coralRequest, exports);
var _coralResponse = require("./coral-response");
parcelHelpers.exportAll(_coralResponse, exports);
var _errors = require("./errors");
parcelHelpers.exportAll(_errors, exports);

},{"./client-factory":"lAcVW","./client":"ek7cO","./config-factory":"ciC1s","./partition-coral-client-config-factory":"2avkN","./coral-request":"bDHdj","./coral-response":"7ySqE","./errors":"9r0me","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lAcVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A repository of instantiated CoralClients.
 *
 * Applications may want to create a singleton instance of this class as an easy
 * way to maintain a list of global interceptors, default qualifier, and the
 * list of available service configurations.
 */ parcelHelpers.export(exports, "CoralClientFactory", ()=>CoralClientFactory);
var _errors = require("./errors");
var _interceptingHandler = require("../interceptors/intercepting-handler");
class CoralClientFactory {
    constructor(clientConfigFactories, qualifier, handler, globalInterceptors = []){
        this.qualifier = qualifier;
        this.chain = new (0, _interceptingHandler.InterceptingHandler)(handler, globalInterceptors);
        this.clientConfigFactoryRegistry = new Map(clientConfigFactories.map((factory)=>{
            return [
                factory.service,
                factory
            ];
        }));
        this.clientRegistry = new Map;
    }
    /**
     * Create a new instance of a given CoralClient.
     *
     * Will always instantiate a new object, and will *not* persist that instance
     * in the client registry.
     */ create(Constructor, qualifier = this.qualifier) {
        const configFactory = this.getConfigFactoryForService(Constructor.serviceName);
        return new Constructor(configFactory.getConfigForQualifier(qualifier), this.chain);
    }
    /**
     * Return an instance of the given CoralClient for a given (or default) qualifier.
     *
     * This will re-use an existing instance if one was already created for the
     * given CoralClient type with the given qualifier. If no such object exists,
     * a new client will be created and persisted for later re-use.
     */ get(Constructor, qualifier = this.qualifier) {
        const qualifiedClientRegistry = this.clientRegistry.get(qualifier) || new Map;
        const registeredClient = qualifiedClientRegistry.get(Constructor);
        if (registeredClient) return registeredClient;
        const client = this.create(Constructor, qualifier);
        qualifiedClientRegistry.set(Constructor, client);
        this.clientRegistry.set(qualifier, qualifiedClientRegistry);
        return client;
    }
    getConfigFactoryForService(serviceName) {
        const configFactory = this.clientConfigFactoryRegistry.get(serviceName);
        if (!configFactory) throw new (0, _errors.CoralClientConfigNotFound)(serviceName);
        return configFactory;
    }
}

},{"./errors":"9r0me","../interceptors/intercepting-handler":"7k2Ku","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9r0me":[function(require,module,exports) {
// tslint:disable:max-classes-per-file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralClientConfigNotFound", ()=>CoralClientConfigNotFound);
/**
 * Catch-all exception for Coral operations when an unmodeled exception is received
 * or if a network failure occurs.
 *
 * Clients can access the <i>receivedException</i> property to inspect the
 * underlying error, and <i>status</i> to inspect the response status.
 */ parcelHelpers.export(exports, "UnknownCoralError", ()=>UnknownCoralError);
/**
 * Exception indicating that an `input` string expected to be JSON but was actually not.
 */ parcelHelpers.export(exports, "JsonParsingException", ()=>JsonParsingException);
class CoralClientConfigNotFound extends ReferenceError {
    constructor(service, { qualifier, key } = {}){
        const keyClause = key ? `, key: "${key}"` : "";
        const qualifierClause = qualifier ? ` with qualifier "${qualifier}"` : "";
        const message = `[CoralClientConfigNotFound] No config found for ` + `${service}${qualifierClause}${keyClause}`;
        super(message);
        // as of TS2.1, extending built-ins like Error require a little extra
        // boilerplate to work properly. In TS2.2 this boilerplate was reduced, but
        // it's still necessary. For more, see:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class UnknownCoralError extends Error {
    constructor(receivedException, status){
        super("[UnknownCoralError] Encountered unknown coral exception");
        this.receivedException = receivedException;
        this.status = status;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class JsonParsingException extends Error {
    constructor(input, e){
        super("[JsonParsingException] Could not parse the response as JSON: " + `${input.substr(0, JsonParsingException.MAX_INPUT_LENGTH)}, original exception: ${e.message}`);
        this.input = input;
        this.e = e;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
JsonParsingException.MAX_INPUT_LENGTH = 1000; // prevent extra long errors from clogging the logs

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7k2Ku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Compose a list of interceptors with a given CoralHandler to produce a chain
 * of interceptors which will each be called before the handler finally is
 * called to handle the request.
 */ parcelHelpers.export(exports, "InterceptingHandler", ()=>InterceptingHandler);
class InterceptorRequestHandler {
    constructor(next, interceptor){
        this.next = next;
        this.interceptor = interceptor;
    }
    handle(request) {
        return this.interceptor.intercept(request, this.next);
    }
}
class InterceptingHandler {
    constructor(handler, interceptors){
        this.handler = handler;
        this.handlerChain = interceptors.reduceRight((next, interceptor)=>{
            return new InterceptorRequestHandler(next, interceptor);
        }, this.handler);
    }
    handle(request) {
        return this.handlerChain.handle(request);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ek7cO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Framework-agnostic abstract Coral service client. Service-specific clients
 * will be generated as concrete subclasses.
 *
 * The structure of this client is heavily influenced by the Angular HttpClient,
 * while remaining framework-agnostic.
 *
 * The handler is responsible for consuming requests and producing responses.
 * When supporting interceptors, this will be an instance of
 * InterceptingRequestHandler -- see CoralClientFactory for an example.
 *
 * (see https://angular.io/guide/http#intercepting-requests-and-responses for
 * more general info on interceptors)
 */ parcelHelpers.export(exports, "CoralClient", ()=>CoralClient);
var _coralRequest = require("./coral-request");
class CoralClient {
    constructor(config, handler){
        this.config = config;
        this.handler = handler;
    }
    /**
     * Make a Coral service request.
     */ call(operation, data) {
        const { assembly, serviceName } = this.constructor;
        const headers = this.constructHeaders(assembly, serviceName, operation);
        return this.handler.handle(new (0, _coralRequest.CoralRequest)({
            body: data,
            config: this.config,
            headers,
            operation,
            serviceName,
            url: this.config.httpEndpoint.url
        }));
    }
    constructHeaders(assembly, serviceName, operation) {
        return [
            [
                "Content-Encoding",
                "amz-1.0"
            ],
            [
                "Content-Type",
                "application/json;charset=UTF-8"
            ],
            [
                "X-Amz-Target",
                `${assembly}.${serviceName}.${operation}`
            ]
        ];
    }
}

},{"./coral-request":"bDHdj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDHdj":[function(require,module,exports) {
/**
 * Coral clients need a framework-agnostic request class that can be easily
 * copied (to support e.g. serialization, auth, etc.)
 *
 * The spec-compliant Request class falls short, as there is no easy way to copy
 * it -- in particular, the body can only be read once and is only available
 * asynchronously.
 *
 * The CoralRequest can also simplify some constituent types (e.g. headers), while
 * also ensuring certain default values (POST method, include credentials).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralRequest", ()=>CoralRequest);
class CoralRequest {
    constructor(init){
        Object.assign(this, init);
        // explicit assignment avoids compiler warning that readonly properties
        // are not definitely set in the constructor.
        this.config = init.config;
        this.credentials = init.credentials || "include";
        this.headers = init.headers;
        this.operation = init.operation;
        this.method = init.method || "POST";
        this.serviceName = init.serviceName;
        this.url = init.url;
    }
    /**
     * Clone the request with one or more updated properties.
     *
     * By default, `signal` will not be shared with the cloned request -- if that
     * behavior is desirable, do `request.clone({signal: request.signal})`
     */ clone(update) {
        // by default, do not share signals between requests.
        return new CoralRequest(Object.assign(Object.assign(Object.assign({}, this), {
            signal: null
        }), update));
    }
    /**
     * Convert to a native HTML-spec-compliant Request instance.
     */ toNativeRequest() {
        return new Request(this.url, Object.assign({}, this));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ciC1s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Config factory backed by key-value pairs where the key is the qualifier and the value is CoralConfigSchema instance.
 */ parcelHelpers.export(exports, "CoralClientConfigFactory", ()=>CoralClientConfigFactory);
var _errors = require("./errors");
function hasRequiredFields(config) {
    return config != null && config.httpEndpoint != null && config.httpEndpoint.url != null;
}
class CoralClientConfigFactory {
    constructor(service, configs){
        this.service = service;
        this.getConfigForQualifier = (qualifier)=>{
            const config = configs[qualifier];
            if (hasRequiredFields(config)) return config;
            throw new (0, _errors.CoralClientConfigNotFound)(this.service, {
                qualifier
            });
        };
    }
}

},{"./errors":"9r0me","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2avkN":[function(require,module,exports) {
/**
 * Wrap config to operate on partitioned endpoints.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PartitionCoralClientConfigFactory", ()=>PartitionCoralClientConfigFactory);
class PartitionCoralClientConfigFactory {
    constructor(partition, factory){
        this.service = factory.service;
        this.getConfigForQualifier = (qualifier)=>{
            const config = factory.getConfigForQualifier(qualifier);
            return Object.assign(Object.assign({}, config), {
                httpEndpoint: Object.assign(Object.assign({}, config.httpEndpoint), {
                    url: config.httpEndpoint.url.replace(/\bPARTITION\b/, partition)
                })
            });
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ySqE":[function(require,module,exports) {
/**
 * Framework-agnostic generic Coral response, allowing individual operations
 * to return properly-typed response bodies.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralResponse", ()=>CoralResponse);
class CoralResponse {
    constructor(init){
        this.body = init.body || null;
        this.headers = init.headers || [];
        this.status = init.status;
        this.statusText = init.statusText;
        this.url = init.url || null;
        this.ok = init.ok;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwP8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHandler = require("./fetch-handler");
parcelHelpers.exportAll(_fetchHandler, exports);
var _handler = require("./handler");
parcelHelpers.exportAll(_handler, exports);

},{"./fetch-handler":"gH01v","./handler":"l2cMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gH01v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handle Coral requests using the Fetch API, producing an Observable of the
 * response.
 *
 * When the Observable is unsubscribed, the request will be aborted (if
 * it hasn't already completed).
 *
 * The handler is constructed with a fetch implementation where the default is
 * the global *fetch* implementation. Clients may choose to provide their own
 * implementation (eg. SentryFetch, node-fetch), if required.
 * This handler would just handle the json responses in body. In case of empty
 * body or non valid json body, it would throw error.
 */ parcelHelpers.export(exports, "CoralFetchHandler", ()=>CoralFetchHandler);
var _rxjs = require("rxjs");
var _client = require("../client");
var global = arguments[3];
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const fetchThis = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : window;
class CoralFetchHandler {
    constructor(fetchImpl = fetch.bind(fetchThis)){
        this.fetchImpl = fetchImpl;
    }
    handle(request) {
        return new (0, _rxjs.Observable)((observer)=>{
            const controller = new AbortController;
            // Convert body to JSON string
            const body = !request.body || typeof request.body === "string" ? request.body : JSON.stringify(request.body);
            const abortableRequest = request.clone({
                body,
                signal: controller.signal
            });
            this.fetchImpl(abortableRequest.toNativeRequest()).then((response)=>__awaiter(this, void 0, void 0, function*() {
                    const responseText = yield response.text();
                    const responseBody = responseText.length ? parseJsonOrThrow(responseText) : undefined;
                    const headers = Array.from(response.headers.entries());
                    return new (0, _client.CoralResponse)({
                        headers,
                        body: responseBody,
                        status: response.status,
                        ok: response.ok,
                        url: response.url,
                        statusText: response.statusText
                    });
                })).then(observer.next.bind(observer)).catch(observer.error.bind(observer)).finally(observer.complete.bind(observer));
            // Return a function to be called when the Observable is unsubscribed.
            return ()=>controller.abort();
        });
    }
}
/**
 * Helper function that parses JSON and returns the parsed object.
 * If it fails, the function throws a custom exception capturing the exact input (for debugging purposes).
 * @param input - a string of JSON to parse
 */ function parseJsonOrThrow(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        throw new (0, _client.JsonParsingException)(input, e);
    }
}

},{"rxjs":"gxhPq","../client":"7E92U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2cMl":[function(require,module,exports) {
/**
 * Handles CoralRequests, producing observable CoralResponses.
 *
 * Based on Angular's HttpHandler interface. While this class is fully
 * framework-agnostic, the Angular documenation may be useful for understanding
 * how handlers are used.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralHandler", ()=>CoralHandler);
class CoralHandler {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4U6Ze":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interceptingHandler = require("./intercepting-handler");
parcelHelpers.exportAll(_interceptingHandler, exports);
var _interceptor = require("./interceptor");
parcelHelpers.exportAll(_interceptor, exports);
var _coralClientHttpBindingInterceptor = require("./coral-client-http-binding-interceptor");
parcelHelpers.exportAll(_coralClientHttpBindingInterceptor, exports);
var _coralClientSerdesInterceptor = require("./coral-client-serdes-interceptor");
parcelHelpers.exportAll(_coralClientSerdesInterceptor, exports);
var _retryInterceptor = require("./retry-interceptor");
parcelHelpers.exportAll(_retryInterceptor, exports);
var _tapInterceptor = require("./tap-interceptor");
parcelHelpers.exportAll(_tapInterceptor, exports);
var _timeoutInterceptor = require("./timeout-interceptor");
parcelHelpers.exportAll(_timeoutInterceptor, exports);
var _aws4HmacSha256Interceptor = require("./aws4-hmac-sha256-interceptor");
parcelHelpers.exportAll(_aws4HmacSha256Interceptor, exports);

},{"./intercepting-handler":"7k2Ku","./interceptor":"2oCia","./coral-client-http-binding-interceptor":"3BdfF","./coral-client-serdes-interceptor":"8CMNN","./retry-interceptor":"cMKQ5","./tap-interceptor":"1rwPj","./timeout-interceptor":"awr3K","./aws4-hmac-sha256-interceptor":"8Zr5i","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2oCia":[function(require,module,exports) {
/**
 * Intercepts CoralRequests, produces observable CoralResponses. Typically this will
 * involve passing execution to the handler, which will produce the response.
 *
 * Based on Angular's HttpInterceptor interface. While this class is fully
 * framework-agnostic, the Angular documenation may be useful for understanding
 * how interceptors are used.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralInterceptor", ()=>CoralInterceptor);
class CoralInterceptor {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3BdfF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Interceptor that handles HTTP requests based on the Coral operation bindings.
 *
 * @see https://w.amazon.com/bin/view/Coral/Manual/HttpBinding/
 */ parcelHelpers.export(exports, "CoralClientHttpBindingInterceptor", ()=>CoralClientHttpBindingInterceptor);
var _url = require("core-js-pure/features/url");
var _urlDefault = parcelHelpers.interopDefault(_url);
var _urlSearchParams = require("core-js-pure/features/url-search-params");
var _urlSearchParamsDefault = parcelHelpers.interopDefault(_urlSearchParams);
var _interceptor = require("./interceptor");
class CoralClientHttpBindingInterceptor extends (0, _interceptor.CoralInterceptor) {
    constructor(bindings = {}){
        super();
        this.bindings = bindings;
    }
    intercept(request, next) {
        const operationName = request.operation;
        const coralOperationHttpBinding = this.bindings[operationName];
        // Don't bother intercepting if the operation has not been configured.
        if (!coralOperationHttpBinding) return next.handle(request);
        // Determine the path of the operation
        const path = this.resolvePath(coralOperationHttpBinding, request);
        // Create a new request with the updated path and method properties.
        // If the HTTP method does not support a body, remove it from the request.
        const newRequest = request.clone({
            body: this.supportsHttpBody(coralOperationHttpBinding.method) ? request.body : null,
            method: coralOperationHttpBinding.method,
            url: this.constructUrl(request.url, path)
        });
        return next.handle(newRequest);
    }
    /*
     * The modeled path can contain Labels, eg. getBeer/{beerId}/?brewery={breweryId}
     *
     * This method fetches the 'beerId' and 'breweryId' properties from the request body, substitutes the values
     * in the URL path, and returns a new path.
     *
     * In the above case, the method will resolve the beerId and breweryId properties from the request body.
     *
     * If the label cannot be resolved with a primitive value, it is replaced with an empty string, unless the label
     * makes up the entirety of a query parameter value. In that case, the query parameter is excluded from the
     * resolved path entirely.
     */ resolvePath(coralOperationHttpBinding, request) {
        // a prefix is necessary because the URL API only parses absolute URLs
        const urlPrefix = "http://placeholder" + (coralOperationHttpBinding.path.startsWith("/") ? "" : "/");
        // Extract everything before the query string out of the raw URL and do label find/replace before
        // parsing with the URL API to avoid the '{' and '}' characters for labels getting URL-encoded. Otherwise,
        // the label find/replace that depends on these characters would break.
        // See section 3.6 here: http://www.faqs.org/rfcs/rfc3986.html
        const [pathTemplate, ...remainingURLComponents] = coralOperationHttpBinding.path.split("?");
        const path = this.replaceLabels(pathTemplate, coralOperationHttpBinding, request);
        const url = new (0, _urlDefault.default)(`${urlPrefix}${[
            path,
            ...remainingURLComponents
        ].join("?")}`);
        // for the query string, we require more complex logic to potentially omit parameters with no resolved value
        // from the URL
        url.search = this.resolveQuery(url.searchParams, coralOperationHttpBinding, request);
        return url.toString().replace(urlPrefix, "");
    }
    replaceLabels(template, coralOperationHttpBinding, request) {
        // tslint:disable-next-line:no-let The path is generated by resolving the labels.
        let value = template;
        const labels = this.findLabels(value);
        if (!labels || labels.length === 0) return value;
        // No label transformations are available, return what we have.
        if (!coralOperationHttpBinding.labelTransformations) return value;
        labels.forEach((label)=>{
            const labelValue = this.resolveLabel(label, coralOperationHttpBinding, request) || "";
            value = value.replace(label, `${labelValue}`);
        });
        return value;
    }
    findLabels(s) {
        // The regex match extracts the '{}' groups into a list.
        return s.match(/{([a-zA-Z]+)}/g);
    }
    resolveQuery(query, coralOperationHttpBinding, request) {
        const newQuery = new (0, _urlSearchParamsDefault.default)();
        for (const [key, value] of query){
            const newValue = this.replaceLabelsInQueryParam(value, coralOperationHttpBinding, request);
            if (newValue !== undefined) newQuery.append(key, newValue);
        }
        return newQuery.toString();
    }
    replaceLabelsInQueryParam(template, coralOperationHttpBinding, request) {
        const labels = this.findLabels(template);
        if (labels && labels.length === 1 && labels[0] === template) // If there is one label in the query parameter value and the label makes up the entire query parameter,
        // simply resolve the parameter to that value. If we cannot resolve the label to a primitive value,
        // the undefined result returned from here will result in that parameter not getting included in the final path.
        return this.resolveLabel(labels[0], coralOperationHttpBinding, request);
        else // Otherwise do simple find/replace as we would for any other segment of the url.
        return this.replaceLabels(template, coralOperationHttpBinding, request);
    }
    resolveLabel(label, coralOperationHttpBinding, request) {
        // Remove the braces
        const labelProperty = label.replace(/{|}/g, "");
        // Fetch the request property name that should be substituted for the label. The label string itself is used as a fallback.
        // tslint:disable-next-line:no-non-null-assertion Non-null check on labelTransformations is performed in resolvePath().
        const labelTransformationProperty = coralOperationHttpBinding.labelTransformations[labelProperty] || labelProperty;
        const body = request.body;
        // The body is missing the required property, nothing to substitute.
        if (!body || !body.hasOwnProperty || !body.hasOwnProperty(labelTransformationProperty)) return;
        const labelPropertyValue = body[labelTransformationProperty];
        // For now, object values (including Arrays) are not supported for substitution.
        if (typeof labelPropertyValue === "object") return;
        return labelPropertyValue;
    }
    supportsHttpBody(method) {
        return ![
            "GET",
            "HEAD"
        ].includes(method);
    }
    constructUrl(url, path) {
        const urlPrefix = url.endsWith("/") ? url : url + "/";
        const pathSuffix = path.startsWith("/") ? path.substring(1) : path;
        return urlPrefix + pathSuffix;
    }
}

},{"core-js-pure/features/url":"gBYa6","core-js-pure/features/url-search-params":"h9MeM","./interceptor":"2oCia","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8CMNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralClientSerdesInterceptor", ()=>CoralClientSerdesInterceptor);
var _operators = require("rxjs/operators");
var _client = require("../client");
var _model = require("../model");
class CoralClientSerdesInterceptor {
    constructor(operations = {}, syntheticExceptions = []){
        this.operations = operations;
        this.syntheticExceptions = syntheticExceptions;
    }
    intercept(request, next) {
        const response = next.handle(this.withSerializedBody(request));
        const coralOperation = this.operations[request.operation];
        if (!coralOperation) return response;
        return response.pipe((0, _operators.map)((response)=>{
            const body = response.body;
            if (response.ok) {
                const deserializationFn = coralOperation.deserializationFn;
                return new (0, _client.CoralResponse)(Object.assign(Object.assign({}, response), {
                    body: deserializationFn ? deserializationFn(body) : body
                }));
            } else {
                const exception = [].concat(this.syntheticExceptions).concat(coralOperation.modelledExceptions).find((errorConstructor)=>errorConstructor.fullyQualifiedTypeName === body.__type);
                if (exception) // tslint:disable-next-line:no-non-null-assertion
                throw new (0, _client.CoralResponse)(Object.assign(Object.assign({}, response), {
                    body: exception.fromJson(body)
                }));
                // Unmodelled Exception
                throw new (0, _client.CoralResponse)(Object.assign(Object.assign({}, response), {
                    body: new (0, _client.UnknownCoralError)(body, response.status)
                }));
            }
        }));
    }
    withSerializedBody(request) {
        const coralOperation = this.operations[request.operation];
        if (!coralOperation) return request;
        const serializationFn = coralOperation.serializationFn;
        if (serializationFn) return request.clone({
            body: serializationFn(request.body)
        });
        else {
            if (!request.body || !(request.body instanceof (0, _model.CoralModel))) return request;
            const body = request.body.constructor.toJson(request.body);
            return request.clone({
                body
            });
        }
    }
}

},{"rxjs/operators":"ggrIi","../client":"7E92U","../model":"kyL0A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kyL0A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralModel = require("./coral-model");
parcelHelpers.exportAll(_coralModel, exports);
var _modelRegistry = require("./model-registry");
parcelHelpers.exportAll(_modelRegistry, exports);

},{"./coral-model":"bwUvS","./model-registry":"3SP4b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwUvS":[function(require,module,exports) {
/**
 * Base implementation of a Coral model class.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralModel", ()=>CoralModel);
class CoralModel {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3SP4b":[function(require,module,exports) {
/**
 * Registry of CoralModelConstructor instances that can be used by serialization utilities to identify an abstract type.
 *
 * CoralModelConstructor instances are de-duped by their `fullyQualifiedTypeName` value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modelRegistrySingleton", ()=>modelRegistrySingleton);
class ModelRegistry {
    constructor(){
        this.lookupByFullyQualifiedTypeName = new Map();
    }
    /**
     * Add the type to the registry, if it doesn't already exist.
     *
     * @param ctor CoralModelConstructor
     */ registerType(ctor) {
        const __type = ctor.fullyQualifiedTypeName;
        if (!this.lookupByFullyQualifiedTypeName.has(__type)) this.lookupByFullyQualifiedTypeName.set(__type, ctor);
    }
    /**
     *
     * @param __type string
     * @return the constructor previously registered with the given type name, or undefined if it wasn't previously registered
     */ getConstructorByTypeName(__type) {
        return this.lookupByFullyQualifiedTypeName.get(__type);
    }
}
const modelRegistrySingleton = new ModelRegistry();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cMKQ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Implementation of the "Decorrelated Jitter" strategy described here:
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter
 */ parcelHelpers.export(exports, "CoralRetryInterceptor", ()=>CoralRetryInterceptor);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
class CoralRetryInterceptor {
    /**
     * @param options
     * @param options.doNotRetryHttpStatuses
     * @param options.maxDelay 0 default delay, any negative values will be set to 0
     * @param options.maxRetries Defaults to 3
     * @param options.seedDelay 0 default delay, any negative values will be set to 0
     */ constructor(options = {}){
        this.options = Object.assign({
            doNotRetryHttpStatuses: [],
            maxDelay: 0,
            maxRetries: 3,
            seedDelay: 0
        }, options);
        this.options.maxDelay = Math.max(0, this.options.maxDelay);
        this.options.seedDelay = Math.max(0, this.options.seedDelay);
    }
    intercept(request, next) {
        let delay = this.options.seedDelay;
        return next.handle(request).pipe((0, _operators.retryWhen)((errors)=>{
            return errors.pipe((0, _operators.mergeMap)((error, i)=>{
                const currentAttempt = i + 1;
                if (currentAttempt >= this.options.maxRetries || error && error.status && this.options.doNotRetryHttpStatuses.includes(error.status)) return (0, _rxjs.throwError)(error);
                delay = Math.min(this.options.maxDelay, Math.max(this.options.seedDelay, delay * 3 * Math.random()));
                return (0, _rxjs.timer)(delay);
            }));
        }));
    }
}

},{"rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1rwPj":[function(require,module,exports) {
/**
 * Generic interceptor allowing the instantiator to "tap" into the interceptor
 * chain in order to perform some non-mutating operation on the request and
 * response.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TapRequestInterceptor", ()=>TapRequestInterceptor);
class TapRequestInterceptor {
    constructor(tap){
        this.tap = tap;
    }
    intercept(request, next) {
        const response = next.handle(request);
        this.tap(request, response);
        return response;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awr3K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Impose a client-side request timeout.
 *
 * The interceptor will use timeout values specified in the request config, if available.
 * In this case, the timeout value provided to the constructor is used as a fallback, if a matching
 * entry could not be determined.
 *
 * The expected format for timeouts in client configuration is:
 *
 * @example
 * {
 *   timeouts: {
 *     BeerService/GetAllBeers: 5000,
 *     BeerService/CreateBeer: 2500,
 *     BeerService/*: 1000 // wildcard
 *   }
 * }
 *
 * If used *before* CoralRetryInterceptor in the interceptor chain, this will
 * set a total timeout for the entire request (i.e. all retries combined). If
 * used after CoralRetryInterceptor it will timeout each individual attempt.
 *
 * @example
 * new InterceptingRequestHandler(
 *   new FetchRequestHandler(),
 *   [
 *     new CoralTimeoutInterceptor(10000), // timeout the entire request
 *     new CoralRetryInterceptor(),
 *     new CoralTimeoutInterceptor(1000), // timeout each retry attempt
 *   ]
 * )
 */ parcelHelpers.export(exports, "CoralTimeoutInterceptor", ()=>CoralTimeoutInterceptor);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../client");
class CoralTimeoutInterceptor {
    constructor(fallbackTimeoutMs){
        this.fallbackTimeoutMs = fallbackTimeoutMs;
    }
    intercept(request, next) {
        return next.handle(request).pipe((0, _operators.timeout)(this.getTimeoutMs(request)), (0, _operators.catchError)((error)=>{
            if (error.name === "TimeoutError") return (0, _rxjs.throwError)(new (0, _client.CoralResponse)({
                ok: false,
                status: 408,
                statusText: "Request Timeout"
            }));
            else return (0, _rxjs.throwError)(error);
        }));
    }
    getTimeoutMs(request) {
        const config = request.config;
        if (!config.timeouts || !config.timeouts.operationTimeouts) return this.fallbackTimeoutMs;
        // If timeout values are defined in the client config, match by operation name (preferred) or wildcard (*) entry (fallback).
        const operation = request.operation;
        const timeoutByOperation = Object.entries(config.timeouts.operationTimeouts).filter((entry)=>{
            // Key format: $serviceName/$operationName
            const operationNameWithTimeout = entry[0].split("/")[1];
            return operationNameWithTimeout === "*" || operationNameWithTimeout === operation;
        }).sort((first)=>{
            // Sort so that timeout values matched by operationName are in the front of the list whereas wildcard entries are in the back.
            return first[0].split("/")[1] === "*" ? 1 : -1;
        });
        // If there is a timeout value for the operation or a wildcard entry exists, the first value in the array should be selected.
        if (timeoutByOperation.length > 0) return timeoutByOperation[0][1];
        // If there is no match, return the fallback timeout value.
        return this.fallbackTimeoutMs;
    }
}

},{"rxjs":"gxhPq","rxjs/operators":"ggrIi","../client":"7E92U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Zr5i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sign requests using the aws4-hmac-sha256 HTTP signing scheme.
 */ parcelHelpers.export(exports, "Aws4HmacSha256Interceptor", ()=>Aws4HmacSha256Interceptor);
var _signatureV4Universal = require("@aws-sdk/signature-v4-universal");
var _urlParserUniversal = require("@aws-sdk/url-parser-universal");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _cached = require("../common/cached");
var _interceptor = require("./interceptor");
/** Convert headers from list to map. */ const toHeaderBag = (headers)=>headers.reduce((headers, [header, ...values])=>Object.assign(Object.assign({}, headers), {
            [header]: values.join(", ")
        }), {});
/** Convert headers from map to list. */ const toHeaderList = (headers)=>Object.entries(headers);
class Aws4HmacSha256Interceptor extends (0, _interceptor.CoralInterceptor) {
    constructor(credentialsProvider){
        super();
        this.credentials = (0, _rxjs.defer)(credentialsProvider).pipe((0, _cached.cached)((credentials)=>credentials.expiration === undefined ? new Date(8640000000000000) : new Date(credentials.expiration * 1000 - 60000)));
    }
    intercept(request, next) {
        const httpSigning = request.config.httpSigning;
        if (!httpSigning || httpSigning.scheme !== "aws4-hmac-sha256") return next.handle(request);
        return this.credentials.pipe((0, _operators.take)(1), (0, _operators.mergeMap)((credentials)=>{
            const signer = new (0, _signatureV4Universal.SignatureV4)({
                service: httpSigning.service,
                region: httpSigning.region,
                credentials
            });
            const endpoint = (0, _urlParserUniversal.parseUrl)(request.url);
            const body = typeof request.body === "string" ? request.body : JSON.stringify(request.body);
            return signer.sign(Object.assign(Object.assign({}, endpoint), {
                body,
                method: request.method,
                headers: toHeaderBag(request.headers)
            }), {
                signingDate: request.signingDate
            });
        }), (0, _operators.mergeMap)((signedRequest)=>next.handle(request.clone({
                body: signedRequest.body,
                headers: toHeaderList(signedRequest.headers)
            }))));
    }
}

},{"@aws-sdk/signature-v4-universal":"7ppPU","@aws-sdk/url-parser-universal":"eVxk4","rxjs":"gxhPq","rxjs/operators":"ggrIi","../common/cached":"azNay","./interceptor":"2oCia","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"azNay":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cached", ()=>cached);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const cached = (getExpires)=>(observable)=>{
        let cachedValue;
        let cachedExpires;
        // Need to share the observable to ensure that concurrent subscriptions to
        // expired content result in just one subscription to the source. The shared
        // observable completes after caching the new value value, ensuring that a
        // new source subscription will be created the next time the shared
        // observable is used (after the cache expires again).
        const shared = observable.pipe((0, _operators.take)(1), (0, _operators.tap)((value)=>{
            cachedValue = value;
            cachedExpires = getExpires(value);
        }), (0, _operators.share)());
        return new (0, _rxjs.Observable)((subscriber)=>{
            if (cachedExpires === undefined || (0, _rxjs.asyncScheduler).now() >= cachedExpires.getTime()) return shared.subscribe(subscriber);
            else {
                subscriber.next(cachedValue);
                subscriber.complete();
                return ()=>{};
            }
        });
    };

},{"rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aTp5N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("./errors");
parcelHelpers.exportAll(_errors, exports);

},{"./errors":"lG7p1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lG7p1":[function(require,module,exports) {
// tslint:disable:max-classes-per-file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoralDeserializationTypeError", ()=>CoralDeserializationTypeError);
parcelHelpers.export(exports, "CoralSerializationTypeError", ()=>CoralSerializationTypeError);
class CoralDeserializationTypeError extends TypeError {
    constructor(receivedType = "undefined", expectedType = "undefined"){
        const message = `[CoralDeserializationTypeError] Cannot deserialize received type
    "${receivedType}" to type "${expectedType}"`;
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class CoralSerializationTypeError extends TypeError {
    constructor(receivedType = "undefined", expectedType = "undefined"){
        const message = `[CoralSerializationTypeError] Cannot serialize received type
    "${receivedType}" to type "${expectedType}"`;
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i5oTv":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssignPermissionsToUser", ()=>AssignPermissionsToUser);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AssignPermissionsToUser] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAssignpermissionstouser", ()=>validateAssignpermissionstouser);
var _user = require("./User");
var _baseAssignUserInput = require("./BaseAssignUserInput");
var _operationList = require("./OperationList");
var _permissionKeyList = require("./PermissionKeyList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class AssignPermissionsToUser extends (0, _baseAssignUserInput.BaseAssignUserInput) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AssignPermissionsToUser#clone(obj: PlainObjectFrom<AssignPermissionsToUser>) method.
     */ constructor(__operationList, __permissionKeyList, __user, __expiryDate){
        super(__user, __expiryDate);
        this.operationList = __operationList;
        this.permissionKeyList = __permissionKeyList;
    }
    /**
     * Create a shallow clone of AssignPermissionsToUser from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AssignPermissionsToUser(obj.operationList, obj.permissionKeyList, obj.user, obj.expiryDate);
    }
    static fromJson(data) {
        return new AssignPermissionsToUser((0, _operationList.OperationList).fromJson(data.operationList), (0, _permissionKeyList.PermissionKeyList).fromJson(data.permissionKeyList), (0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.expiryDate));
    }
    static toJson(data) {
        return Object.assign({
            operationList: (0, _operationList.OperationList).toJson(data.operationList),
            permissionKeyList: (0, _permissionKeyList.PermissionKeyList).toJson(data.permissionKeyList),
            user: (0, _user.User).toJson(data.user),
            expiryDate: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.expiryDate)
        });
    }
}
AssignPermissionsToUser.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#AssignPermissionsToUser";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AssignPermissionsToUser);
function validateAssignpermissionstouser(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./BaseAssignUserInput":"894rG","./OperationList":"1Jkj5","./PermissionKeyList":"kzggn","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"894rG":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseAssignUserInput", ()=>BaseAssignUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BaseAssignUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBaseassignuserinput", ()=>validateBaseassignuserinput);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class BaseAssignUserInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BaseAssignUserInput#clone(obj: PlainObjectFrom<BaseAssignUserInput>) method.
     */ constructor(__user, __expiryDate){
        super();
        this.user = __user;
        this.expiryDate = __expiryDate;
    }
    /**
     * Create a shallow clone of BaseAssignUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BaseAssignUserInput(obj.user, obj.expiryDate);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== BaseAssignUserInput.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new BaseAssignUserInput((0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.expiryDate));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== BaseAssignUserInput.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            user: (0, _user.User).toJson(data.user),
            expiryDate: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.expiryDate)
        });
    }
}
BaseAssignUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#BaseAssignUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BaseAssignUserInput);
function validateBaseassignuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Jkj5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * OperationList - Specifies list of operations.
 **/ parcelHelpers.export(exports, "OperationList", ()=>OperationList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [OperationList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateOperationlist", ()=>validateOperationlist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class OperationList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(OperationList.prototype));
    }
    static fromJson(data) {
        return new OperationList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateOperationlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kzggn":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * PermissionKeyList - Specifies list of permission keys.
 **/ parcelHelpers.export(exports, "PermissionKeyList", ()=>PermissionKeyList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionKeyList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionkeylist", ()=>validatePermissionkeylist);
var _permissionKey = require("./PermissionKey");
class PermissionKeyList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(PermissionKeyList.prototype));
    }
    static fromJson(data) {
        return new PermissionKeyList(data.map((datum)=>(0, _permissionKey.PermissionKey).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _permissionKey.PermissionKey).toJson(datum));
    }
}
function validatePermissionkeylist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jW9S8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract structure to capture the permission key. Various Specific Permission Keys will inherit this Permission
 * Key to Define Granular level permissions.
 **/ parcelHelpers.export(exports, "PermissionKey", ()=>PermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionkey", ()=>validatePermissionkey);
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class PermissionKey extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PermissionKey#clone(obj: PlainObjectFrom<PermissionKey>) method.
     */ static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== PermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new PermissionKey();
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== PermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({});
    }
}
PermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PermissionKey);
function validatePermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6iWKB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssignPermissionsToUserStatus", ()=>AssignPermissionsToUserStatus);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AssignPermissionsToUserStatus] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAssignpermissionstouserstatus", ()=>validateAssignpermissionstouserstatus);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class AssignPermissionsToUserStatus extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AssignPermissionsToUserStatus#clone(obj: PlainObjectFrom<AssignPermissionsToUserStatus>) method.
     */ constructor(__operation, __permissionKey, __userid, __errorMsg, __success){
        super();
        this.operation = __operation;
        this.permissionKey = __permissionKey;
        this.userid = __userid;
        this.errorMsg = __errorMsg;
        this.success = __success;
    }
    /**
     * Create a shallow clone of AssignPermissionsToUserStatus from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AssignPermissionsToUserStatus(obj.operation, obj.permissionKey, obj.userid, obj.errorMsg, obj.success);
    }
    static fromJson(data) {
        return new AssignPermissionsToUserStatus((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _user.User).fromJson(data.userid), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorMsg), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.success));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            userid: (0, _user.User).toJson(data.userid),
            errorMsg: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorMsg),
            success: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.success)
        });
    }
}
AssignPermissionsToUserStatus.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#AssignPermissionsToUserStatus";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AssignPermissionsToUserStatus);
function validateAssignpermissionstouserstatus(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3oawK":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssignUserInput", ()=>AssignUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AssignUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAssignuserinput", ()=>validateAssignuserinput);
var _user = require("./User");
var _baseAssignUserInput = require("./BaseAssignUserInput");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class AssignUserInput extends (0, _baseAssignUserInput.BaseAssignUserInput) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AssignUserInput#clone(obj: PlainObjectFrom<AssignUserInput>) method.
     */ constructor(__createdBy, __operation, __permissionKey, __user, __expiryDate){
        super(__user, __expiryDate);
        this.createdBy = __createdBy;
        this.operation = __operation;
        this.permissionKey = __permissionKey;
    }
    /**
     * Create a shallow clone of AssignUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AssignUserInput(obj.createdBy, obj.operation, obj.permissionKey, obj.user, obj.expiryDate);
    }
    static fromJson(data) {
        return new AssignUserInput((0, _user.User).fromJson(data.createdBy), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.expiryDate));
    }
    static toJson(data) {
        return Object.assign({
            createdBy: (0, _user.User).toJson(data.createdBy),
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            user: (0, _user.User).toJson(data.user),
            expiryDate: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.expiryDate)
        });
    }
}
AssignUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#AssignUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AssignUserInput);
function validateAssignuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./BaseAssignUserInput":"894rG","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2okKk":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * AssignUserList - Specifies list of users with list of operations.
 **/ parcelHelpers.export(exports, "AssignUserList", ()=>AssignUserList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AssignUserList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAssignuserlist", ()=>validateAssignuserlist);
var _assignPermissionsToUser = require("./AssignPermissionsToUser");
class AssignUserList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AssignUserList.prototype));
    }
    static fromJson(data) {
        return new AssignUserList(data.map((datum)=>(0, _assignPermissionsToUser.AssignPermissionsToUser).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _assignPermissionsToUser.AssignPermissionsToUser).toJson(datum));
    }
}
function validateAssignuserlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AssignPermissionsToUser":"i5oTv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lE2nP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * AssignUserStatusList - Specifies response list of BatchAssignUser API.
 **/ parcelHelpers.export(exports, "AssignUserStatusList", ()=>AssignUserStatusList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AssignUserStatusList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAssignuserstatuslist", ()=>validateAssignuserstatuslist);
var _assignPermissionsToUserStatus = require("./AssignPermissionsToUserStatus");
class AssignUserStatusList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AssignUserStatusList.prototype));
    }
    static fromJson(data) {
        return new AssignUserStatusList(data.map((datum)=>(0, _assignPermissionsToUserStatus.AssignPermissionsToUserStatus).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _assignPermissionsToUserStatus.AssignPermissionsToUserStatus).toJson(datum));
    }
}
function validateAssignuserstatuslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AssignPermissionsToUserStatus":"6iWKB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4V01e":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An object which contains details of a particular event such as Event Description (Event Type, Operation and Term)
 * , Target User, User who does the modification, Date and Time of the event
 **/ parcelHelpers.export(exports, "AuditEvent", ()=>AuditEvent);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AuditEvent] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAuditevent", ()=>validateAuditevent);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class AuditEvent extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AuditEvent#clone(obj: PlainObjectFrom<AuditEvent>) method.
     */ constructor(__eventType, __modifiedBy, __operation, __targetUser, __term, __timeStamp){
        super();
        this.eventType = __eventType;
        this.modifiedBy = __modifiedBy;
        this.operation = __operation;
        this.targetUser = __targetUser;
        this.term = __term;
        this.timeStamp = __timeStamp;
    }
    /**
     * Create a shallow clone of AuditEvent from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AuditEvent(obj.eventType, obj.modifiedBy, obj.operation, obj.targetUser, obj.term, obj.timeStamp);
    }
    static fromJson(data) {
        return new AuditEvent((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.eventType), (($$val)=>$$val == undefined ? undefined : (0, _user.User).fromJson($$val))(data.modifiedBy), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.operation), (($$val)=>$$val == undefined ? undefined : (0, _user.User).fromJson($$val))(data.targetUser), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.timeStamp));
    }
    static toJson(data) {
        return Object.assign({
            eventType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.eventType),
            modifiedBy: (($$val)=>$$val == undefined ? null : (0, _user.User).toJson($$val))(data.modifiedBy),
            operation: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.operation),
            targetUser: (($$val)=>$$val == undefined ? null : (0, _user.User).toJson($$val))(data.targetUser),
            term: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term),
            timeStamp: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.timeStamp)
        });
    }
}
AuditEvent.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#AuditEvent";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AuditEvent);
function validateAuditevent(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4P4Wp":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * AuditEventsList - Specifies a list of audit-events for a specific Logistics Provider
 **/ parcelHelpers.export(exports, "AuditEventsList", ()=>AuditEventsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AuditEventsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAuditeventslist", ()=>validateAuditeventslist);
var _auditEvent = require("./AuditEvent");
class AuditEventsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AuditEventsList.prototype));
    }
    static fromJson(data) {
        return new AuditEventsList(data.map((datum)=>(0, _auditEvent.AuditEvent).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _auditEvent.AuditEvent).toJson(datum));
    }
}
function validateAuditeventslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AuditEvent":"4V01e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jhGP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * AuthorizedUserList - Specifies list of authorized users on the role.
 **/ parcelHelpers.export(exports, "AuthorizedUserList", ()=>AuthorizedUserList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AuthorizedUserList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAuthorizeduserlist", ()=>validateAuthorizeduserlist);
var _user = require("./User");
class AuthorizedUserList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AuthorizedUserList.prototype));
    }
    static fromJson(data) {
        return new AuthorizedUserList(data.map((datum)=>(0, _user.User).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _user.User).toJson(datum));
    }
}
function validateAuthorizeduserlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8j2t9":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseDeAssignUserInput", ()=>BaseDeAssignUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BaseDeAssignUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBasedeassignuserinput", ()=>validateBasedeassignuserinput);
var _user = require("./User");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class BaseDeAssignUserInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BaseDeAssignUserInput#clone(obj: PlainObjectFrom<BaseDeAssignUserInput>) method.
     */ constructor(__user){
        super();
        this.user = __user;
    }
    /**
     * Create a shallow clone of BaseDeAssignUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BaseDeAssignUserInput(obj.user);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== BaseDeAssignUserInput.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new BaseDeAssignUserInput((0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== BaseDeAssignUserInput.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            user: (0, _user.User).toJson(data.user)
        });
    }
}
BaseDeAssignUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#BaseDeAssignUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BaseDeAssignUserInput);
function validateBasedeassignuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFjYJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchAssignUserInput", ()=>BatchAssignUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BatchAssignUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBatchassignuserinput", ()=>validateBatchassignuserinput);
var _user = require("./User");
var _assignUserList = require("./AssignUserList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class BatchAssignUserInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BatchAssignUserInput#clone(obj: PlainObjectFrom<BatchAssignUserInput>) method.
     */ constructor(__createdBy, __assignUserList){
        super();
        this.createdBy = __createdBy;
        this.assignUserList = __assignUserList;
    }
    /**
     * Create a shallow clone of BatchAssignUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BatchAssignUserInput(obj.createdBy, obj.assignUserList);
    }
    static fromJson(data) {
        return new BatchAssignUserInput((0, _user.User).fromJson(data.createdBy), (($$val)=>$$val == undefined ? undefined : (0, _assignUserList.AssignUserList).fromJson($$val))(data.assignUserList));
    }
    static toJson(data) {
        return Object.assign({
            createdBy: (0, _user.User).toJson(data.createdBy),
            assignUserList: (($$val)=>$$val == undefined ? null : (0, _assignUserList.AssignUserList).toJson($$val))(data.assignUserList)
        });
    }
}
BatchAssignUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#BatchAssignUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BatchAssignUserInput);
function validateBatchassignuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./AssignUserList":"2okKk","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zHrS":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchAssignUserOutput", ()=>BatchAssignUserOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BatchAssignUserOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBatchassignuseroutput", ()=>validateBatchassignuseroutput);
var _assignUserStatusList = require("./AssignUserStatusList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class BatchAssignUserOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BatchAssignUserOutput#clone(obj: PlainObjectFrom<BatchAssignUserOutput>) method.
     */ constructor(__assignUserStatusList){
        super();
        this.assignUserStatusList = __assignUserStatusList;
    }
    /**
     * Create a shallow clone of BatchAssignUserOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BatchAssignUserOutput(obj.assignUserStatusList);
    }
    static fromJson(data) {
        return new BatchAssignUserOutput((0, _assignUserStatusList.AssignUserStatusList).fromJson(data.assignUserStatusList));
    }
    static toJson(data) {
        return Object.assign({
            assignUserStatusList: (0, _assignUserStatusList.AssignUserStatusList).toJson(data.assignUserStatusList)
        });
    }
}
BatchAssignUserOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#BatchAssignUserOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BatchAssignUserOutput);
function validateBatchassignuseroutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AssignUserStatusList":"lE2nP","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gePIC":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchDeAssignUserInput", ()=>BatchDeAssignUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BatchDeAssignUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBatchdeassignuserinput", ()=>validateBatchdeassignuserinput);
var _user = require("./User");
var _deAssignUserList = require("./DeAssignUserList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class BatchDeAssignUserInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BatchDeAssignUserInput#clone(obj: PlainObjectFrom<BatchDeAssignUserInput>) method.
     */ constructor(__deAssignUserList, __updatedBy){
        super();
        this.deAssignUserList = __deAssignUserList;
        this.updatedBy = __updatedBy;
    }
    /**
     * Create a shallow clone of BatchDeAssignUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BatchDeAssignUserInput(obj.deAssignUserList, obj.updatedBy);
    }
    static fromJson(data) {
        return new BatchDeAssignUserInput((($$val)=>$$val == undefined ? undefined : (0, _deAssignUserList.DeAssignUserList).fromJson($$val))(data.deAssignUserList), (($$val)=>$$val == undefined ? undefined : (0, _user.User).fromJson($$val))(data.updatedBy));
    }
    static toJson(data) {
        return Object.assign({
            deAssignUserList: (($$val)=>$$val == undefined ? null : (0, _deAssignUserList.DeAssignUserList).toJson($$val))(data.deAssignUserList),
            updatedBy: (($$val)=>$$val == undefined ? null : (0, _user.User).toJson($$val))(data.updatedBy)
        });
    }
}
BatchDeAssignUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#BatchDeAssignUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BatchDeAssignUserInput);
function validateBatchdeassignuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./DeAssignUserList":"3pECq","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3pECq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * DeAssignUserList - Specifies list of users with list of operations.
 **/ parcelHelpers.export(exports, "DeAssignUserList", ()=>DeAssignUserList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeAssignUserList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeassignuserlist", ()=>validateDeassignuserlist);
var _deAssignPermissionsToUser = require("./DeAssignPermissionsToUser");
class DeAssignUserList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(DeAssignUserList.prototype));
    }
    static fromJson(data) {
        return new DeAssignUserList(data.map((datum)=>(0, _deAssignPermissionsToUser.DeAssignPermissionsToUser).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _deAssignPermissionsToUser.DeAssignPermissionsToUser).toJson(datum));
    }
}
function validateDeassignuserlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./DeAssignPermissionsToUser":"bXMQK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXMQK":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeAssignPermissionsToUser", ()=>DeAssignPermissionsToUser);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeAssignPermissionsToUser] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeassignpermissionstouser", ()=>validateDeassignpermissionstouser);
var _baseDeAssignUserInput = require("./BaseDeAssignUserInput");
var _user = require("./User");
var _operationList = require("./OperationList");
var _permissionKeyList = require("./PermissionKeyList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DeAssignPermissionsToUser extends (0, _baseDeAssignUserInput.BaseDeAssignUserInput) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeAssignPermissionsToUser#clone(obj: PlainObjectFrom<DeAssignPermissionsToUser>) method.
     */ constructor(__operationList, __permissionKeyList, __user){
        super(__user);
        this.operationList = __operationList;
        this.permissionKeyList = __permissionKeyList;
    }
    /**
     * Create a shallow clone of DeAssignPermissionsToUser from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeAssignPermissionsToUser(obj.operationList, obj.permissionKeyList, obj.user);
    }
    static fromJson(data) {
        return new DeAssignPermissionsToUser((0, _operationList.OperationList).fromJson(data.operationList), (0, _permissionKeyList.PermissionKeyList).fromJson(data.permissionKeyList), (0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            operationList: (0, _operationList.OperationList).toJson(data.operationList),
            permissionKeyList: (0, _permissionKeyList.PermissionKeyList).toJson(data.permissionKeyList),
            user: (0, _user.User).toJson(data.user)
        });
    }
}
DeAssignPermissionsToUser.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DeAssignPermissionsToUser";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeAssignPermissionsToUser);
function validateDeassignpermissionstouser(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseDeAssignUserInput":"8j2t9","./User":"4Ihn2","./OperationList":"1Jkj5","./PermissionKeyList":"kzggn","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gkDXW":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchDeAssignUserOutput", ()=>BatchDeAssignUserOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BatchDeAssignUserOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBatchdeassignuseroutput", ()=>validateBatchdeassignuseroutput);
var _deAssignUserStatusList = require("./DeAssignUserStatusList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class BatchDeAssignUserOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BatchDeAssignUserOutput#clone(obj: PlainObjectFrom<BatchDeAssignUserOutput>) method.
     */ constructor(__deAssignUserStatusList){
        super();
        this.deAssignUserStatusList = __deAssignUserStatusList;
    }
    /**
     * Create a shallow clone of BatchDeAssignUserOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BatchDeAssignUserOutput(obj.deAssignUserStatusList);
    }
    static fromJson(data) {
        return new BatchDeAssignUserOutput((0, _deAssignUserStatusList.DeAssignUserStatusList).fromJson(data.deAssignUserStatusList));
    }
    static toJson(data) {
        return Object.assign({
            deAssignUserStatusList: (0, _deAssignUserStatusList.DeAssignUserStatusList).toJson(data.deAssignUserStatusList)
        });
    }
}
BatchDeAssignUserOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#BatchDeAssignUserOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BatchDeAssignUserOutput);
function validateBatchdeassignuseroutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./DeAssignUserStatusList":"cXmE3","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXmE3":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * DeAssignUserStatusList - Specifies response list of BatchDeAssignUser API.
 **/ parcelHelpers.export(exports, "DeAssignUserStatusList", ()=>DeAssignUserStatusList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeAssignUserStatusList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeassignuserstatuslist", ()=>validateDeassignuserstatuslist);
var _deAssignPermissionsToUserStatus = require("./DeAssignPermissionsToUserStatus");
class DeAssignUserStatusList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(DeAssignUserStatusList.prototype));
    }
    static fromJson(data) {
        return new DeAssignUserStatusList(data.map((datum)=>(0, _deAssignPermissionsToUserStatus.DeAssignPermissionsToUserStatus).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _deAssignPermissionsToUserStatus.DeAssignPermissionsToUserStatus).toJson(datum));
    }
}
function validateDeassignuserstatuslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./DeAssignPermissionsToUserStatus":"jPbyr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPbyr":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeAssignPermissionsToUserStatus", ()=>DeAssignPermissionsToUserStatus);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeAssignPermissionsToUserStatus] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeassignpermissionstouserstatus", ()=>validateDeassignpermissionstouserstatus);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DeAssignPermissionsToUserStatus extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeAssignPermissionsToUserStatus#clone(obj: PlainObjectFrom<DeAssignPermissionsToUserStatus>) method.
     */ constructor(__operation, __permissionKey, __userid, __errorMsg, __success){
        super();
        this.operation = __operation;
        this.permissionKey = __permissionKey;
        this.userid = __userid;
        this.errorMsg = __errorMsg;
        this.success = __success;
    }
    /**
     * Create a shallow clone of DeAssignPermissionsToUserStatus from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeAssignPermissionsToUserStatus(obj.operation, obj.permissionKey, obj.userid, obj.errorMsg, obj.success);
    }
    static fromJson(data) {
        return new DeAssignPermissionsToUserStatus((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _user.User).fromJson(data.userid), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorMsg), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.success));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            userid: (0, _user.User).toJson(data.userid),
            errorMsg: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorMsg),
            success: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.success)
        });
    }
}
DeAssignPermissionsToUserStatus.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DeAssignPermissionsToUserStatus";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeAssignPermissionsToUserStatus);
function validateDeassignpermissionstouserstatus(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFUAU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Case Category used in Case Management Service. This permission key is used for granting
 * access to the cases that belong to a category for all service providers.
 * Model ref for Category :- https:\/\/tiny.amazon.com\/1moexsej\/CAMSCommonModels\/category
 **/ parcelHelpers.export(exports, "CaseCategoryPermissionKey", ()=>CaseCategoryPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CaseCategoryPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCasecategorypermissionkey", ()=>validateCasecategorypermissionkey);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class CaseCategoryPermissionKey extends (0, _permissionKey.PermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CaseCategoryPermissionKey#clone(obj: PlainObjectFrom<CaseCategoryPermissionKey>) method.
     */ constructor(__category){
        super();
        this.category = __category;
    }
    /**
     * Create a shallow clone of CaseCategoryPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CaseCategoryPermissionKey(obj.category);
    }
    static fromJson(data) {
        return new CaseCategoryPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.category));
    }
    static toJson(data) {
        return Object.assign({
            category: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.category)
        });
    }
}
CaseCategoryPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#CaseCategoryPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CaseCategoryPermissionKey);
function validateCasecategorypermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JqxU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Case Resolver Groups used in Case Management Service.
 * This permission key is used for granting permissions to tech teams (for example:- ctt-manifest-team) to the cases
 * assigned to their resolver group for all service providers.
 * Model ref for ResolverGroup :- https:\/\/tiny.amazon.com\/3x6jmsy0\/CAMSCommonModels\/resolverGroup
 **/ parcelHelpers.export(exports, "CaseResolverGroupPermissionKey", ()=>CaseResolverGroupPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CaseResolverGroupPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCaseresolvergrouppermissionkey", ()=>validateCaseresolvergrouppermissionkey);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class CaseResolverGroupPermissionKey extends (0, _permissionKey.PermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CaseResolverGroupPermissionKey#clone(obj: PlainObjectFrom<CaseResolverGroupPermissionKey>) method.
     */ constructor(__resolverGroup){
        super();
        this.resolverGroup = __resolverGroup;
    }
    /**
     * Create a shallow clone of CaseResolverGroupPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CaseResolverGroupPermissionKey(obj.resolverGroup);
    }
    static fromJson(data) {
        return new CaseResolverGroupPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.resolverGroup));
    }
    static toJson(data) {
        return Object.assign({
            resolverGroup: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.resolverGroup)
        });
    }
}
CaseResolverGroupPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#CaseResolverGroupPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CaseResolverGroupPermissionKey);
function validateCaseresolvergrouppermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6C2mM":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateCustomOperationInput", ()=>CreateCustomOperationInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CreateCustomOperationInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCreatecustomoperationinput", ()=>validateCreatecustomoperationinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class CreateCustomOperationInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CreateCustomOperationInput#clone(obj: PlainObjectFrom<CreateCustomOperationInput>) method.
     */ constructor(__createdBy, __operation){
        super();
        this.createdBy = __createdBy;
        this.operation = __operation;
    }
    /**
     * Create a shallow clone of CreateCustomOperationInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CreateCustomOperationInput(obj.createdBy, obj.operation);
    }
    static fromJson(data) {
        return new CreateCustomOperationInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.createdBy), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation));
    }
    static toJson(data) {
        return Object.assign({
            createdBy: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.createdBy),
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation)
        });
    }
}
CreateCustomOperationInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#CreateCustomOperationInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreateCustomOperationInput);
function validateCreatecustomoperationinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSEA6":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreatePAMRoleMappingInput", ()=>CreatePAMRoleMappingInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CreatePAMRoleMappingInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCreatepamrolemappinginput", ()=>validateCreatepamrolemappinginput);
var _role = require("./Role");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class CreatePAMRoleMappingInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CreatePAMRoleMappingInput#clone(obj: PlainObjectFrom<CreatePAMRoleMappingInput>) method.
     */ constructor(__role, __subscriptionTier, __subscriptionType){
        super();
        this.role = __role;
        this.subscriptionTier = __subscriptionTier;
        this.subscriptionType = __subscriptionType;
    }
    /**
     * Create a shallow clone of CreatePAMRoleMappingInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CreatePAMRoleMappingInput(obj.role, obj.subscriptionTier, obj.subscriptionType);
    }
    static fromJson(data) {
        return new CreatePAMRoleMappingInput((0, _role.Role).fromJson(data.role), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.subscriptionTier), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.subscriptionType));
    }
    static toJson(data) {
        return Object.assign({
            role: (0, _role.Role).toJson(data.role),
            subscriptionTier: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.subscriptionTier),
            subscriptionType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.subscriptionType)
        });
    }
}
CreatePAMRoleMappingInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#CreatePAMRoleMappingInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreatePAMRoleMappingInput);
function validateCreatepamrolemappinginput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Role":"4i1wK","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4i1wK":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A collection of rights granted to an Actor to enable them to perform action on resources.
 **/ parcelHelpers.export(exports, "Role", ()=>Role);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Role] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRole", ()=>validateRole);
var _rightsList = require("./RightsList");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class Role extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Role#clone(obj: PlainObjectFrom<Role>) method.
     */ constructor(__entity, __rightsList, __roleName){
        super();
        this.entity = __entity;
        this.rightsList = __rightsList;
        this.roleName = __roleName;
    }
    /**
     * Create a shallow clone of Role from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Role(obj.entity, obj.rightsList, obj.roleName);
    }
    static fromJson(data) {
        return new Role((0, _permissionKey.PermissionKey).fromJson(data.entity), (0, _rightsList.RightsList).fromJson(data.rightsList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.roleName));
    }
    static toJson(data) {
        return Object.assign({
            entity: (0, _permissionKey.PermissionKey).toJson(data.entity),
            rightsList: (0, _rightsList.RightsList).toJson(data.rightsList),
            roleName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.roleName)
        });
    }
}
Role.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#Role";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Role);
function validateRole(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RightsList":"353Tl","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"353Tl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * RightsList - Specifies a list of rights
 * For now, this can go up to a maximum of 4 rights corresponding to 4 existing permissions.
 **/ parcelHelpers.export(exports, "RightsList", ()=>RightsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RightsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRightslist", ()=>validateRightslist);
var _right = require("./Right");
class RightsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(RightsList.prototype));
    }
    static fromJson(data) {
        return new RightsList(data.map((datum)=>(0, _right.Right).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _right.Right).toJson(datum));
    }
}
function validateRightslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Right":"cpbmv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cpbmv":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A token specific to an application that gates access to data or features on Passport.
 **/ parcelHelpers.export(exports, "Right", ()=>Right);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Right] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRight", ()=>validateRight);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class Right extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Right#clone(obj: PlainObjectFrom<Right>) method.
     */ constructor(__permission, __rightName){
        super();
        this.permission = __permission;
        this.rightName = __rightName;
    }
    /**
     * Create a shallow clone of Right from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Right(obj.permission, obj.rightName);
    }
    static fromJson(data) {
        return new Right((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.permission), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.rightName));
    }
    static toJson(data) {
        return Object.assign({
            permission: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.permission),
            rightName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.rightName)
        });
    }
}
Right.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#Right";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Right);
function validateRight(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iq11l":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * This represents the different types of Response message for PutPermissionRequests API
 * (EXISTING\/SUCCESS\/PENDING\/FAILURE)
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreationStatus", ()=>CreationStatus);
var CreationStatus;
(function(CreationStatus) {
    CreationStatus["EXISTING"] = "EXISTING";
    CreationStatus["SUCCESS"] = "SUCCESS";
    CreationStatus["PENDING"] = "PENDING";
    CreationStatus["FAILURE"] = "FAILURE";
})(CreationStatus || (CreationStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lUqhB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeactivateUserInput", ()=>DeactivateUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeactivateUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeactivateuserinput", ()=>validateDeactivateuserinput);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DeactivateUserInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeactivateUserInput#clone(obj: PlainObjectFrom<DeactivateUserInput>) method.
     */ constructor(__user, __deactivatedBy, __permissionKey){
        super();
        this.user = __user;
        this.deactivatedBy = __deactivatedBy;
        this.permissionKey = __permissionKey;
    }
    /**
     * Create a shallow clone of DeactivateUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeactivateUserInput(obj.user, obj.deactivatedBy, obj.permissionKey);
    }
    static fromJson(data) {
        return new DeactivateUserInput((0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _user.User).fromJson($$val))(data.deactivatedBy), (($$val)=>$$val == undefined ? undefined : (0, _permissionKey.PermissionKey).fromJson($$val))(data.permissionKey));
    }
    static toJson(data) {
        return Object.assign({
            user: (0, _user.User).toJson(data.user),
            deactivatedBy: (($$val)=>$$val == undefined ? null : (0, _user.User).toJson($$val))(data.deactivatedBy),
            permissionKey: (($$val)=>$$val == undefined ? null : (0, _permissionKey.PermissionKey).toJson($$val))(data.permissionKey)
        });
    }
}
DeactivateUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DeactivateUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeactivateUserInput);
function validateDeactivateuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3cqXj":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeactivateUserOutput", ()=>DeactivateUserOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeactivateUserOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeactivateuseroutput", ()=>validateDeactivateuseroutput);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DeactivateUserOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeactivateUserOutput#clone(obj: PlainObjectFrom<DeactivateUserOutput>) method.
     */ constructor(__userid, __errorMsg, __success){
        super();
        this.userid = __userid;
        this.errorMsg = __errorMsg;
        this.success = __success;
    }
    /**
     * Create a shallow clone of DeactivateUserOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeactivateUserOutput(obj.userid, obj.errorMsg, obj.success);
    }
    static fromJson(data) {
        return new DeactivateUserOutput((0, _user.User).fromJson(data.userid), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorMsg), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.success));
    }
    static toJson(data) {
        return Object.assign({
            userid: (0, _user.User).toJson(data.userid),
            errorMsg: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorMsg),
            success: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.success)
        });
    }
}
DeactivateUserOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DeactivateUserOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeactivateUserOutput);
function validateDeactivateuseroutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5sG77":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeAssignUserInput", ()=>DeAssignUserInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeAssignUserInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeassignuserinput", ()=>validateDeassignuserinput);
var _baseDeAssignUserInput = require("./BaseDeAssignUserInput");
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DeAssignUserInput extends (0, _baseDeAssignUserInput.BaseDeAssignUserInput) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeAssignUserInput#clone(obj: PlainObjectFrom<DeAssignUserInput>) method.
     */ constructor(__operation, __permissionKey, __user, __updatedBy){
        super(__user);
        this.operation = __operation;
        this.permissionKey = __permissionKey;
        this.updatedBy = __updatedBy;
    }
    /**
     * Create a shallow clone of DeAssignUserInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeAssignUserInput(obj.operation, obj.permissionKey, obj.user, obj.updatedBy);
    }
    static fromJson(data) {
        return new DeAssignUserInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _user.User).fromJson($$val))(data.updatedBy));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            user: (0, _user.User).toJson(data.user),
            updatedBy: (($$val)=>$$val == undefined ? null : (0, _user.User).toJson($$val))(data.updatedBy)
        });
    }
}
DeAssignUserInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DeAssignUserInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeAssignUserInput);
function validateDeassignuserinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseDeAssignUserInput":"8j2t9","./User":"4Ihn2","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kgpSb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteCustomOperationInput", ()=>DeleteCustomOperationInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeleteCustomOperationInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeletecustomoperationinput", ()=>validateDeletecustomoperationinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DeleteCustomOperationInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeleteCustomOperationInput#clone(obj: PlainObjectFrom<DeleteCustomOperationInput>) method.
     */ constructor(__operation, __updatedBy){
        super();
        this.operation = __operation;
        this.updatedBy = __updatedBy;
    }
    /**
     * Create a shallow clone of DeleteCustomOperationInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeleteCustomOperationInput(obj.operation, obj.updatedBy);
    }
    static fromJson(data) {
        return new DeleteCustomOperationInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.updatedBy));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            updatedBy: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.updatedBy)
        });
    }
}
DeleteCustomOperationInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DeleteCustomOperationInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeleteCustomOperationInput);
function validateDeletecustomoperationinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fTgpt":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisableExternalTermForLogisticPartyInput", ()=>DisableExternalTermForLogisticPartyInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DisableExternalTermForLogisticPartyInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDisableexternaltermforlogisticpartyinput", ()=>validateDisableexternaltermforlogisticpartyinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DisableExternalTermForLogisticPartyInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DisableExternalTermForLogisticPartyInput#clone(obj: PlainObjectFrom<DisableExternalTermForLogisticPartyInput>) method.
     */ constructor(__logisticsPartyId, __term){
        super();
        this.logisticsPartyId = __logisticsPartyId;
        this.term = __term;
    }
    /**
     * Create a shallow clone of DisableExternalTermForLogisticPartyInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DisableExternalTermForLogisticPartyInput(obj.logisticsPartyId, obj.term);
    }
    static fromJson(data) {
        return new DisableExternalTermForLogisticPartyInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
DisableExternalTermForLogisticPartyInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DisableExternalTermForLogisticPartyInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DisableExternalTermForLogisticPartyInput);
function validateDisableexternaltermforlogisticpartyinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j2x6l":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisableExternalTermForLogisticPartyOutput", ()=>DisableExternalTermForLogisticPartyOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DisableExternalTermForLogisticPartyOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDisableexternaltermforlogisticpartyoutput", ()=>validateDisableexternaltermforlogisticpartyoutput);
var _ihmJsCoralClient = require("ihm-js-coral-client");
class DisableExternalTermForLogisticPartyOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DisableExternalTermForLogisticPartyOutput#clone(obj: PlainObjectFrom<DisableExternalTermForLogisticPartyOutput>) method.
     */ static fromJson(data) {
        return new DisableExternalTermForLogisticPartyOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
DisableExternalTermForLogisticPartyOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#DisableExternalTermForLogisticPartyOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DisableExternalTermForLogisticPartyOutput);
function validateDisableexternaltermforlogisticpartyoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6XOd1":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnableExternalEntityForLogisticPartyInput", ()=>EnableExternalEntityForLogisticPartyInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EnableExternalEntityForLogisticPartyInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEnableexternalentityforlogisticpartyinput", ()=>validateEnableexternalentityforlogisticpartyinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EnableExternalEntityForLogisticPartyInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EnableExternalEntityForLogisticPartyInput#clone(obj: PlainObjectFrom<EnableExternalEntityForLogisticPartyInput>) method.
     */ constructor(__entity, __entityType, __logisticsPartyId){
        super();
        this.entity = __entity;
        this.entityType = __entityType;
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of EnableExternalEntityForLogisticPartyInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EnableExternalEntityForLogisticPartyInput(obj.entity, obj.entityType, obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new EnableExternalEntityForLogisticPartyInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.entity), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.entityType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            entity: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.entity),
            entityType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.entityType),
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId)
        });
    }
}
EnableExternalEntityForLogisticPartyInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EnableExternalEntityForLogisticPartyInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EnableExternalEntityForLogisticPartyInput);
function validateEnableexternalentityforlogisticpartyinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVd1L":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnableExternalEntityForLogisticPartyOutput", ()=>EnableExternalEntityForLogisticPartyOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EnableExternalEntityForLogisticPartyOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEnableexternalentityforlogisticpartyoutput", ()=>validateEnableexternalentityforlogisticpartyoutput);
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EnableExternalEntityForLogisticPartyOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EnableExternalEntityForLogisticPartyOutput#clone(obj: PlainObjectFrom<EnableExternalEntityForLogisticPartyOutput>) method.
     */ static fromJson(data) {
        return new EnableExternalEntityForLogisticPartyOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
EnableExternalEntityForLogisticPartyOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EnableExternalEntityForLogisticPartyOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EnableExternalEntityForLogisticPartyOutput);
function validateEnableexternalentityforlogisticpartyoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"auygu":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnableExternalTermForLogisticPartyInput", ()=>EnableExternalTermForLogisticPartyInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EnableExternalTermForLogisticPartyInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEnableexternaltermforlogisticpartyinput", ()=>validateEnableexternaltermforlogisticpartyinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EnableExternalTermForLogisticPartyInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EnableExternalTermForLogisticPartyInput#clone(obj: PlainObjectFrom<EnableExternalTermForLogisticPartyInput>) method.
     */ constructor(__logisticsPartyId, __term){
        super();
        this.logisticsPartyId = __logisticsPartyId;
        this.term = __term;
    }
    /**
     * Create a shallow clone of EnableExternalTermForLogisticPartyInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EnableExternalTermForLogisticPartyInput(obj.logisticsPartyId, obj.term);
    }
    static fromJson(data) {
        return new EnableExternalTermForLogisticPartyInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
EnableExternalTermForLogisticPartyInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EnableExternalTermForLogisticPartyInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EnableExternalTermForLogisticPartyInput);
function validateEnableexternaltermforlogisticpartyinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ucI1":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnableExternalTermForLogisticPartyOutput", ()=>EnableExternalTermForLogisticPartyOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EnableExternalTermForLogisticPartyOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEnableexternaltermforlogisticpartyoutput", ()=>validateEnableexternaltermforlogisticpartyoutput);
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EnableExternalTermForLogisticPartyOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EnableExternalTermForLogisticPartyOutput#clone(obj: PlainObjectFrom<EnableExternalTermForLogisticPartyOutput>) method.
     */ static fromJson(data) {
        return new EnableExternalTermForLogisticPartyOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
EnableExternalTermForLogisticPartyOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EnableExternalTermForLogisticPartyOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EnableExternalTermForLogisticPartyOutput);
function validateEnableexternaltermforlogisticpartyoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"arsYo":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnableSubscriptionForLogisticsPartyInput", ()=>EnableSubscriptionForLogisticsPartyInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EnableSubscriptionForLogisticsPartyInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEnablesubscriptionforlogisticspartyinput", ()=>validateEnablesubscriptionforlogisticspartyinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EnableSubscriptionForLogisticsPartyInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EnableSubscriptionForLogisticsPartyInput#clone(obj: PlainObjectFrom<EnableSubscriptionForLogisticsPartyInput>) method.
     */ constructor(__logisticsPartyId, __term){
        super();
        this.logisticsPartyId = __logisticsPartyId;
        this.term = __term;
    }
    /**
     * Create a shallow clone of EnableSubscriptionForLogisticsPartyInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EnableSubscriptionForLogisticsPartyInput(obj.logisticsPartyId, obj.term);
    }
    static fromJson(data) {
        return new EnableSubscriptionForLogisticsPartyInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            term: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term)
        });
    }
}
EnableSubscriptionForLogisticsPartyInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EnableSubscriptionForLogisticsPartyInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EnableSubscriptionForLogisticsPartyInput);
function validateEnablesubscriptionforlogisticspartyinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvzVx":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnableSubscriptionForLogisticsPartyOutput", ()=>EnableSubscriptionForLogisticsPartyOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EnableSubscriptionForLogisticsPartyOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEnablesubscriptionforlogisticspartyoutput", ()=>validateEnablesubscriptionforlogisticspartyoutput);
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EnableSubscriptionForLogisticsPartyOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EnableSubscriptionForLogisticsPartyOutput#clone(obj: PlainObjectFrom<EnableSubscriptionForLogisticsPartyOutput>) method.
     */ static fromJson(data) {
        return new EnableSubscriptionForLogisticsPartyOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
EnableSubscriptionForLogisticsPartyOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EnableSubscriptionForLogisticsPartyOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EnableSubscriptionForLogisticsPartyOutput);
function validateEnablesubscriptionforlogisticspartyoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGdNn":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of Entities (Term\/Category\/ResolverGroup etc.)
 **/ parcelHelpers.export(exports, "EntityList", ()=>EntityList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EntityList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEntitylist", ()=>validateEntitylist);
var _coralComAmazonCarrierlogisticsCasemanagementserviceCommonModel = require("@amzn/coral_com-amazon-carrierlogistics-casemanagementservice-common-model");
var _coralComAmazonTransCmsCore = require("@amzn/coral_com-amazon-trans-cms-core");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EntityList extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EntityList#clone(obj: PlainObjectFrom<EntityList>) method.
     */ constructor(__categoryList, __termList){
        super();
        this.categoryList = __categoryList;
        this.termList = __termList;
    }
    /**
     * Create a shallow clone of EntityList from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EntityList(obj.categoryList, obj.termList);
    }
    static fromJson(data) {
        return new EntityList((($$val)=>$$val == undefined ? undefined : _coralComAmazonCarrierlogisticsCasemanagementserviceCommonModel.CategoryList.fromJson($$val))(data.categoryList), (($$val)=>$$val == undefined ? undefined : _coralComAmazonTransCmsCore.TermList.fromJson($$val))(data.termList));
    }
    static toJson(data) {
        return Object.assign({
            categoryList: (($$val)=>$$val == undefined ? null : _coralComAmazonCarrierlogisticsCasemanagementserviceCommonModel.CategoryList.toJson($$val))(data.categoryList),
            termList: (($$val)=>$$val == undefined ? null : _coralComAmazonTransCmsCore.TermList.toJson($$val))(data.termList)
        });
    }
}
EntityList.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EntityList";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EntityList);
function validateEntitylist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral_com-amazon-carrierlogistics-casemanagementservice-common-model":"2VuIO","@amzn/coral_com-amazon-trans-cms-core":"flfuH","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2VuIO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _category = require("./Category");
parcelHelpers.exportAll(_category, exports);
var _categoryList = require("./CategoryList");
parcelHelpers.exportAll(_categoryList, exports);
var _resolverGroup = require("./ResolverGroup");
parcelHelpers.exportAll(_resolverGroup, exports);
var _resolverGroupList = require("./ResolverGroupList");
parcelHelpers.exportAll(_resolverGroupList, exports);

},{"./Category":"8YpIN","./CategoryList":"ez4XZ","./ResolverGroup":"fuZgc","./ResolverGroupList":"dMaqc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8YpIN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * This represents list of case categories supported by case management service. The following are the list of categories
 * with description:-
 * 1) MANIFEST: This category involves in handling manifest related issues. Few examples :-
 * a) Manifest file not found, i.e., The whole manifest file is not received by carrier
 * b) Item received without data, i.e., some packages were physically received by carrier but no shipment
 * information received in manifest
 * c) Missing articles, i.e., some packages were not physically received but there are shipment information
 * in received manifest
 *
 * 2) TRANSPORTATION_FINANCIAL_DISPUTES: This category handles cases that involves 3P carriers payment related issues.
 * It includes research and resolution for reconciliation exceptions between
 * 3P carriers and Amazon.
 *
 * 3) TRANSPORTATION_OPERATIONS: This category deals with transportation issues related to operations,
 * which are encountered by third-party carriers. For instance, a scenario where
 * the vehicle responsible for transporting packages arrives late at the Fulfillment
 * Center or Carrier Hub.
 *
 * 4) NON_PERFORMANCE_COMPENSATION: This category deals with issues  pertaining to performance-related reports
 * aligned with pre-defined Key Performance Indicators (KPIs) outlined in the
 * contract between Amazon and the Carrier.
 *
 * 5) LABEL : This category addresses problems related to labels, such as unreadable text, missing fields,
 * or labels that are cut and not scannable.
 *
 * 6) LAUNCHES : This category pertains to issues related to launches, such as a lane launch or a station launch.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Category", ()=>Category);
var Category;
(function(Category) {
    Category["MANIFEST"] = "MANIFEST";
    Category["TRANSPORTATION_FINANCIAL_DISPUTES"] = "TRANSPORTATION_FINANCIAL_DISPUTES";
    Category["TRANSPORTATION_OPERATIONS"] = "TRANSPORTATION_OPERATIONS";
    Category["NON_PERFORMANCE_COMPENSATION"] = "NON_PERFORMANCE_COMPENSATION";
    Category["LABEL"] = "LABEL";
    Category["LAUNCHES"] = "LAUNCHES";
})(Category || (Category = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ez4XZ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CategoryList", ()=>CategoryList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CategoryList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCategorylist", ()=>validateCategorylist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class CategoryList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(CategoryList.prototype));
    }
    static fromJson(data) {
        return new CategoryList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateCategorylist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fuZgc":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * Resolver group is team or a group of teams who are involved in resolving cases of a particular type on passport
 * case management portal. The following are the list of resolver groups with description:-
 * 1) ECCF_CONFIG: <!--TODO: Add document for ECCF_CONFIG-->
 * 2) NOC : Network Operations Center(NOC) is a resolver group which represents team that supports daily operation issues based on different alignments with
 * the carrier manager team in different regions
 *
 * 3) TRANSPORTATION_FINANCE_CONTROLLERSHIP : This team handles financial related disputes between 3P carriers and Amazon.
 *
 * 4) CARRIER_MANAGER: This resolver group represents carrier managers, and is used for granting access to carrier managers
 * to handle specific cases which requires only carrier managers to involve in.
 *
 * 5) CTT_MANIFEST: This resolver group represents tech team who are involved in resolving cases related to manifest issues
 * when front-line team fails to resolve the case and pass it over to tech team.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResolverGroup", ()=>ResolverGroup);
var ResolverGroup;
(function(ResolverGroup) {
    ResolverGroup["ECCF_CONFIG"] = "eccf-config-team";
    ResolverGroup["NOC"] = "noc-team";
    ResolverGroup["TRANSPORTATION_FINANCE_CONTROLLERSHIP"] = "transportation-finance-controllership-team";
    ResolverGroup["CARRIER_MANAGER"] = "carrier-manager";
    ResolverGroup["CTT_MANIFEST"] = "ctt-manifest-team";
})(ResolverGroup || (ResolverGroup = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMaqc":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResolverGroupList", ()=>ResolverGroupList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ResolverGroupList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateResolvergrouplist", ()=>validateResolvergrouplist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class ResolverGroupList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ResolverGroupList.prototype));
    }
    static fromJson(data) {
        return new ResolverGroupList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateResolvergrouplist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flfuH":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseChange = require("./BaseChange");
parcelHelpers.exportAll(_baseChange, exports);
var _baseChangeList = require("./BaseChangeList");
parcelHelpers.exportAll(_baseChangeList, exports);
var _changeKey = require("./ChangeKey");
parcelHelpers.exportAll(_changeKey, exports);
var _changeKeyList = require("./ChangeKeyList");
parcelHelpers.exportAll(_changeKeyList, exports);
var _countryLocation = require("./CountryLocation");
parcelHelpers.exportAll(_countryLocation, exports);
var _location = require("./Location");
parcelHelpers.exportAll(_location, exports);
var _spdomainKey = require("./SPDomainKey");
parcelHelpers.exportAll(_spdomainKey, exports);
var _spServiceDomainKey = require("./SpServiceDomainKey");
parcelHelpers.exportAll(_spServiceDomainKey, exports);
var _term = require("./Term");
parcelHelpers.exportAll(_term, exports);
var _termChange = require("./TermChange");
parcelHelpers.exportAll(_termChange, exports);
var _termChangeList = require("./TermChangeList");
parcelHelpers.exportAll(_termChangeList, exports);
var _termDomainKey = require("./TermDomainKey");
parcelHelpers.exportAll(_termDomainKey, exports);
var _termList = require("./TermList");
parcelHelpers.exportAll(_termList, exports);

},{"./BaseChange":"5M8R6","./BaseChangeList":"g8nvB","./ChangeKey":"4esbw","./ChangeKeyList":"cYeXg","./CountryLocation":"jmIli","./Location":"hawMB","./SPDomainKey":"95fnc","./SpServiceDomainKey":"6jhxO","./Term":"iWIEQ","./TermChange":"ccZHp","./TermChangeList":"63z76","./TermDomainKey":"2zkBb","./TermList":"f0VIC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5M8R6":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a Term, List of Term Change Keys and the corresponding Base Version.
 * Term represents the term for which the change is being made.
 * Captures the definition which is to be validated and set by the Term Services. The term
 * changeKeyList represents the set of Change keys mapped to the base Version.
 * The new version is returned to CMS as response of Submit Change API in ChangeVersionMap
 **/ parcelHelpers.export(exports, "BaseChange", ()=>BaseChange);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BaseChange] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBasechange", ()=>validateBasechange);
var _changeKeyList = require("./ChangeKeyList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class BaseChange extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BaseChange#clone(obj: PlainObjectFrom<BaseChange>) method.
     */ constructor(__changeKeyList, __term, __baseVersion){
        super();
        this.changeKeyList = __changeKeyList;
        this.term = __term;
        this.baseVersion = __baseVersion;
    }
    /**
     * Create a shallow clone of BaseChange from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BaseChange(obj.changeKeyList, obj.term, obj.baseVersion);
    }
    static fromJson(data) {
        return new BaseChange((0, _changeKeyList.ChangeKeyList).fromJson(data.changeKeyList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.baseVersion));
    }
    static toJson(data) {
        return Object.assign({
            changeKeyList: (0, _changeKeyList.ChangeKeyList).toJson(data.changeKeyList),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            baseVersion: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.baseVersion)
        });
    }
}
BaseChange.fullyQualifiedTypeName = "com.amazon.trans.cms.core#BaseChange";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BaseChange);
function validateBasechange(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ChangeKeyList":"cYeXg","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYeXg":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeKeyList", ()=>ChangeKeyList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ChangeKeyList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateChangekeylist", ()=>validateChangekeylist);
var _changeKey = require("./ChangeKey");
class ChangeKeyList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ChangeKeyList.prototype));
    }
    static fromJson(data) {
        return new ChangeKeyList(data.map((datum)=>(0, _changeKey.ChangeKey).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _changeKey.ChangeKey).toJson(datum));
    }
}
function validateChangekeylist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ChangeKey":"4esbw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4esbw":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeKey", ()=>ChangeKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ChangeKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateChangekey", ()=>validateChangekey);
var _termDomainKey = require("./TermDomainKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ChangeKey extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ChangeKey#clone(obj: PlainObjectFrom<ChangeKey>) method.
     */ constructor(__termDomainKey, __termSpecificationKey){
        super();
        this.termDomainKey = __termDomainKey;
        this.termSpecificationKey = __termSpecificationKey;
    }
    /**
     * Create a shallow clone of ChangeKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ChangeKey(obj.termDomainKey, obj.termSpecificationKey);
    }
    static fromJson(data) {
        return new ChangeKey((0, _termDomainKey.TermDomainKey).fromJson(data.termDomainKey), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.termSpecificationKey));
    }
    static toJson(data) {
        return Object.assign({
            termDomainKey: (0, _termDomainKey.TermDomainKey).toJson(data.termDomainKey),
            termSpecificationKey: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.termSpecificationKey)
        });
    }
}
ChangeKey.fullyQualifiedTypeName = "com.amazon.trans.cms.core#ChangeKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ChangeKey);
function validateChangekey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TermDomainKey":"2zkBb","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zkBb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract structure to capture the term key. This is used in conjunction with TermSpecificKey to uniquely
 * identify a term specification. For e.g. a label page is identified using TermDomainKey (service-provider,
 * service) and TermSpecificKey (page id).
 **/ parcelHelpers.export(exports, "TermDomainKey", ()=>TermDomainKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermDomainKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermdomainkey", ()=>validateTermdomainkey);
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class TermDomainKey extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TermDomainKey#clone(obj: PlainObjectFrom<TermDomainKey>) method.
     */ static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== TermDomainKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new TermDomainKey();
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== TermDomainKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({});
    }
}
TermDomainKey.fullyQualifiedTypeName = "com.amazon.trans.cms.core#TermDomainKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TermDomainKey);
function validateTermdomainkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8nvB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseChangeList", ()=>BaseChangeList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BaseChangeList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBasechangelist", ()=>validateBasechangelist);
var _baseChange = require("./BaseChange");
class BaseChangeList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(BaseChangeList.prototype));
    }
    static fromJson(data) {
        return new BaseChangeList(data.map((datum)=>(0, _baseChange.BaseChange).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _baseChange.BaseChange).toJson(datum));
    }
}
function validateBasechangelist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseChange":"5M8R6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmIli":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * CountryLocation is a specific implementation of Location to capture details at country level.
 **/ parcelHelpers.export(exports, "CountryLocation", ()=>CountryLocation);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CountryLocation] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCountrylocation", ()=>validateCountrylocation);
var _location = require("./Location");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class CountryLocation extends (0, _location.Location) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CountryLocation#clone(obj: PlainObjectFrom<CountryLocation>) method.
     */ constructor(__countryCode){
        super();
        this.countryCode = __countryCode;
    }
    /**
     * Create a shallow clone of CountryLocation from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CountryLocation(obj.countryCode);
    }
    static fromJson(data) {
        return new CountryLocation((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.countryCode));
    }
    static toJson(data) {
        return Object.assign({
            countryCode: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.countryCode)
        });
    }
}
CountryLocation.fullyQualifiedTypeName = "com.amazon.trans.cms.core#CountryLocation";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CountryLocation);
function validateCountrylocation(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Location":"hawMB","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hawMB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Location is an abstract structure to define any geographical\/political entity.
 * Please refer: https:\/\/w.amazon.com\/bin\/view\/Transportation\/Passport\/PassportCoreServices\/ODPairTDKModelling for more details.
 **/ parcelHelpers.export(exports, "Location", ()=>Location);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Location] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateLocation", ()=>validateLocation);
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class Location extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Location#clone(obj: PlainObjectFrom<Location>) method.
     */ static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== Location.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new Location();
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== Location.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({});
    }
}
Location.fullyQualifiedTypeName = "com.amazon.trans.cms.core#Location";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Location);
function validateLocation(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95fnc":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Term Domain Key includes Service Provider. Example terms- EDI config, Tracking api end-point
 *
 * @deprecated
 **/ parcelHelpers.export(exports, "SPDomainKey", ()=>SPDomainKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPDomainKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpdomainkey", ()=>validateSpdomainkey);
var _termDomainKey = require("./TermDomainKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class SPDomainKey extends (0, _termDomainKey.TermDomainKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPDomainKey#clone(obj: PlainObjectFrom<SPDomainKey>) method.
     */ constructor(__logisticsPartyId){
        super();
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of SPDomainKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPDomainKey(obj.logisticsPartyId);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== SPDomainKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new SPDomainKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== SPDomainKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId)
        });
    }
}
SPDomainKey.fullyQualifiedTypeName = "com.amazon.trans.cms.core#SPDomainKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPDomainKey);
function validateSpdomainkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TermDomainKey":"2zkBb","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6jhxO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Term Domain Key includes Service provider and Service. Example terms- label spec, tracking id, manifest spec
 *
 * @deprecated
 **/ parcelHelpers.export(exports, "SpServiceDomainKey", ()=>SpServiceDomainKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SpServiceDomainKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpservicedomainkey", ()=>validateSpservicedomainkey);
var _coralComAmazonShippingLogisticsservice = require("@amzn/coral_com-amazon-shipping-logisticsservice");
var _spdomainKey = require("./SPDomainKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SpServiceDomainKey extends (0, _spdomainKey.SPDomainKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SpServiceDomainKey#clone(obj: PlainObjectFrom<SpServiceDomainKey>) method.
     */ constructor(__logisticsPartyId, __serviceId){
        super(__logisticsPartyId);
        this.serviceId = __serviceId;
    }
    /**
     * Create a shallow clone of SpServiceDomainKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SpServiceDomainKey(obj.logisticsPartyId, obj.serviceId);
    }
    static fromJson(data) {
        return new SpServiceDomainKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), _coralComAmazonShippingLogisticsservice.LogisticsServiceIdentifier.fromJson(data.serviceId));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            serviceId: _coralComAmazonShippingLogisticsservice.LogisticsServiceIdentifier.toJson(data.serviceId)
        });
    }
}
SpServiceDomainKey.fullyQualifiedTypeName = "com.amazon.trans.cms.core#SpServiceDomainKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SpServiceDomainKey);
function validateSpservicedomainkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral_com-amazon-shipping-logisticsservice":"hwZYS","./SPDomainKey":"95fnc","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hwZYS":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _logisticsServiceIdentifier = require("./LogisticsServiceIdentifier");
parcelHelpers.exportAll(_logisticsServiceIdentifier, exports);
var _serviceIdNamespace = require("./ServiceIdNamespace");
parcelHelpers.exportAll(_serviceIdNamespace, exports);

},{"./LogisticsServiceIdentifier":"cRG7T","./ServiceIdNamespace":"fJ2HZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cRG7T":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This entity captures the logistics function provided by the service provider. Logistics service can be the
 * basic activity of shipping, sorting, custom filling, freight forwarding etc. augmented with add-ons such as
 * age verification, COD, signed delivery etc. A service definition would be captured using primitive attributes
 * like transit times, package type etc in Logistics Service Authority.
 * Here, we just need ServiceId as a reference to a service defined in LSA. The consumers of the entity need to
 * resolve the actual service definition by calling LSA if any attributes are required.
 *
 * Some of the examples of logistics services are UPS Next Day, UPS Next Day Air, Royal Mail Tracked 24.
 *
 * Refer Conceptual Data Model in LSA doc for complete service definition:
 * https:\/\/amazon.awsapps.com\/workdocs\/index.html#\/document\/844fd1f442b95672c72a1f2d938065b8ad3d939c10b7190d472eab7b943bae83
 **/ parcelHelpers.export(exports, "LogisticsServiceIdentifier", ()=>LogisticsServiceIdentifier);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [LogisticsServiceIdentifier] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateLogisticsserviceidentifier", ()=>validateLogisticsserviceidentifier);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class LogisticsServiceIdentifier extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the LogisticsServiceIdentifier#clone(obj: PlainObjectFrom<LogisticsServiceIdentifier>) method.
     */ constructor(__serviceIdNamespace, __serviceIdValue){
        super();
        this.serviceIdNamespace = __serviceIdNamespace;
        this.serviceIdValue = __serviceIdValue;
    }
    /**
     * Create a shallow clone of LogisticsServiceIdentifier from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new LogisticsServiceIdentifier(obj.serviceIdNamespace, obj.serviceIdValue);
    }
    static fromJson(data) {
        return new LogisticsServiceIdentifier((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.serviceIdNamespace), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.serviceIdValue));
    }
    static toJson(data) {
        return Object.assign({
            serviceIdNamespace: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.serviceIdNamespace),
            serviceIdValue: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.serviceIdValue)
        });
    }
}
LogisticsServiceIdentifier.fullyQualifiedTypeName = "com.amazon.shipping.logisticsservice#LogisticsServiceIdentifier";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(LogisticsServiceIdentifier);
function validateLogisticsserviceidentifier(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fJ2HZ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * Refers to the name of the system to be used to resolve the service id.
 * LOGISTICS_SERVICE_AUTHORITY :
 * https:\/\/amazon.awsapps.com\/workdocs\/index.html#\/document\/844fd1f442b95672c72a1f2d938065b8ad3d939c10b7190d472eab7b943bae83
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceIdNamespace", ()=>ServiceIdNamespace);
var ServiceIdNamespace;
(function(ServiceIdNamespace) {
    ServiceIdNamespace["LOGISTICS_SERVICE_AUTHORITY"] = "LOGISTICS_SERVICE_AUTHORITY";
})(ServiceIdNamespace || (ServiceIdNamespace = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iWIEQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * Defines various terms and artifacts needed for a logistics service.
 *
 * Note: doesn't capture all terms, 'll keep adding as we go, update length of TermList with change in terms.
 *
 * LOGISTICS_PARTY_PROFILE --> Term to capture the profile of a Logistics Party
 * LOGISTICS_SERVICE_PROFILE --> Term to capture the profile of a Logistics Service
 * LOGISTICS_AGREEMENT_PROFILE --> Term to capture the profile of a Logistics Agreement
 * SHIP_METHOD_PRIMITIVES --> Term to capture the mapping of ship methods to Logistics Services and the associated
 * Value Added Services corresponding to each ship method.
 * LABEL_SPECIFICATION --> Term to capture the specifications of label to be used by different Logistics
 * Services during lifecycle of the container requests for the container
 * SERVICE_CONSUMER_LABEL_SPECIFICATION --> This term represents the label specifications required for non
 * transportation aspects, like fulfillment, advertisements or promotions by service consumer. Transportation
 * systems need to understand this term since there is only one physical label generated with the combination of
 * LABEL_SPECIFICATION and SERVICE_CONSUMER_LABEL_SPECIFICATION
 * SP_REFERENCE_ID_SPECIFICATION --> Term to capture the Service Provider's Reference ID's specifications
 * SP_REFERENCE_ID_RANGE --> Term to capture the range to be used to generate a SP Reference ID for a logistics
 * agreement
 * SPTR_COMMUNICATION_DOCUMENTS_SPECIFICATION --> This term is deprecating as Manifesting is working on distinguish
 * templates between the carrier's based on associated LogisticAgreement, as part of this DocumentSet term TDK
 * is being migrated to ServiceAgreement level, so introducing new term SPTR_COMMUNICATION_DOCUMENT_SET_SPECIFICATION
 * as part of TDK migration strategy, will remove this from model after complete migration to new term.
 * SPTR_COMMUNICATION_DOCUMENT_SET_SPECIFICATION --> This term is to capture the specification of the documents sent
 * to SP to communicate Transportation Request (Sp TR) on ServiceAgreement level. Depending on SP's use cases,
 * these documents may be generated together or may be generated separately. The specification will contain details
 * of the list of documents that needs to be generated together. Details include documents' batching criteria,
 * individual templates, file formats and so on.
 * TRANSPORTATION_CONNECTIVITY_SPECIFICATION --> This term is to capture the specifications of the connectivity
 * channels used to communicate with logistic providers for exchange of data(through documents\/messages which might
 * include event codes, acknowledgements etc.)  between service providers and service consumers. The users can choose
 * to configure connectivity using any of the protocols like AS2, HTTPS, SFTP or API, S3 etc. The specification will
 * contain details of the connectivity configuration like endpoints, protocol, auth schemes etc., that are used for
 * establishing transmission channel. Once the connectivity endpoints are created, the association of the connectivity
 * endpoints with the dependent terms shall be handled by the corresponding CTT dependent term like Manifesting
 * DocumentSet\/Shiptrack\/Invoice etc.
 * SPTR_COMMUNICATION_TRIGGER_SPECIFICATION --> This term is to capture the specifications of the manifesting triggers on
 * when to generate sptr_document_sets for a Logistic Party. Transportation Triggers will be mapped to events that can be
 * easily understood by carrier (say SHIPMENT_ASSIGNED to SLAM event, DEPARTED to trailer depart, etc) along with their
 * node details from which carrier can choose upon. Users can map manifest trigger with the required sptr_document_sets
 * that need to be generated and also control the timing for manifest transmission for the given sptr_document_set.
 * Absolute schedule (say 3 PM everyday) or relative schedule (say within 15 min from the trigger).
 * SHIPMENT_TRACKING_SPECIFICATION --> This term will capture the configurations required for fetching tracking
 * details from carriers. TrackingConfigurationStore will persist the configurations required for fetching tracking
 * details from carriers. As an example, the carrier translation logic, the carrier endpoint details and the channels
 * supported by the carrier would be persisted in the TrackingConfigurationStore.
 * SP_ROUTE_PLAN_SPECIFICATION --> This term will capture the specification required for generating the Service Provider's
 * routing network plan. The specification will contain schema of the network, schema of the routing files and other
 * configurations required to generate the routing network plan.
 * SP_ROUTE_PLAN_DATA --> This term will capture the routing information provided by the Service Provider,
 * which will be used to generate the routing network plan.
 * ZONE_COVERAGE --> This term is for logistics service network zone coverage. Zone coverage
 * defines the areas of physical locations within certain distance from an origin. It represents the geographies
 * where a carrier can deliver\/handover\/pickup package.
 * TRANSPORTATION_FORECAST --> This term will provide transportation forecast information like expected
 * number of packages, volume to carriers for upcoming days\/weeks which is used for their capacity and network
 * planning.
 * LOGISTICS_RELATIONSHIP_IDENTIFIER -> This term will capture the relationship identifiers of all logistics agreements
 * like accountId, sender Identifier, rate identifier etc . The term will only store relationship attribute defined
 * under agreement, it will not manage agreement profile data like services used, rates, coverage etc.
 * LOGISTICS_SERVICE_SCHEDULES -> This term defines the schedules for pickup, delivery, processing and holidays for a Logistics Service.
 * LOGISTICS_SERVICE_TRANSIT_TIME -> This term will store, provide and maintain transit times for
 * logistics services. Currently, this term only supports Service Provider transit time use-cases.
 * SPTR_COMMUNICATION_TRANSMISSION_ID_SPECIFICATION -> This term is used to capture the prefix-suffix format of specification which will be used in
 * generation of Carrier Manifest Id. One specification can be mapped to multiple manifest id's.
 * SPTR_COMMUNICATION_TRANSMISSION_ID_RULES -> This term is used to capture the rules\/conditions which will be mapped against the specifications
 * configured under SPTR_COMMUNICATION_TRANSMISSION_ID_SPECIFICATION.
 * SP_PACKAGE_VOLUME ->  This term will provide information about service provider actual package volume flowing
 * in the transportation network for a logistic party. This will help carrier operators to plan their capacity and
 * monitor the network health which will help carriers to improve delivery performance.
 * TRANSPORTATION_ADHOC_CAPACITY_REQUEST -> This term will be used to compute and create truck procurement requests
 * on a periodic basis. It also helps to manage the communication regarding the created requests between 3rd
 * party carriers and amazon internal teams (control tower, carrier managers, etc).
 * SP_UNDELIVERABLE_PACKAGE_HANDLING_SPECIFICATION -> This term will capture undeliverable package handling
 * specification for a logistics agreement required for generation of undeliverable package address and
 * handling instructions utilised by operators to inject package back to Amazon transportation system.
 * SP_NON_PERFORMANCE_COMPENSATION -> This term will be used to manage the communication between 3rd party
 * carriers and amazon internal teams (control tower, carrier managers, procurement manager) to reach alignment
 * on Performance related reports based on pre-defined KPI's - as per contract between Amazon and the Carrier.
 * SP_INVOICE_MANAGEMENT -> This term will provide different type of reports generated during\/post processing
 * of transportation invoices from service providers. Examples : Invoice dispute files, Invoice reconciliation
 * files etc., Note: To update the documentation when we use this Term for more use cases of transportation
 * financial system.
 * SP_PERFORMANCE_MANAGEMENT -> This term will be used to provide visibility to 3rd party Carriers via dashboards and insights on
 * their performance with respect to pre-defined KPI's (Key Performance Indicators) in the contract between Amazon and the Carrier.
 * This term will be responsible to collect feedback from the carrier on the bad performing areas (lanes\/zips etc.) and generate
 * actions for the carrier manager to protect the network safeguarding retail customer promise.
 * TRANS_COGNITECT -> This term enables users to define and automate business processes that typically require human intuition.
 * It leverages the cognitive abilities of Large Language Models (LLMs) to replace human effort.
 * It provides the capability to define a multistep process to automate tasks while enforcing guardrails and best practices for working with LLMs.
 * It can be used for a variety of tasks such as Summarization, Information Extraction, Text Generation and Q\/A.
 * For example, it facilitates the extraction of contractual clauses from third-party carrier contracts.
 * RUBIKS -> This term simplifies and expedites the resolution of package-related issues.
 * This allows 3P Partners to directly interface with Amazon to resolve package related issues. Ex: package missort.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Term", ()=>Term);
var Term;
(function(Term) {
    Term["LOGISTICS_PARTY_PROFILE"] = "LOGISTICS_PARTY_PROFILE";
    Term["LOGISTICS_SERVICE_PROFILE"] = "LOGISTICS_SERVICE_PROFILE";
    Term["LOGISTICS_AGREEMENT_PROFILE"] = "LOGISTICS_AGREEMENT_PROFILE";
    Term["SHIP_METHOD_PRIMITIVES"] = "SHIP_METHOD_PRIMITIVES";
    Term["LABEL_SPECIFICATION"] = "SHIPPING_LABEL_SPECIFICATION";
    Term["SERVICE_CONSUMER_LABEL_SPECIFICATION"] = "SERVICE_CONSUMER_LABEL_SPECIFICATION";
    Term["TRACKING_ID_SPECIFICATION"] = "TRACKING_ID_SPECIFICATION";
    Term["SP_REFERENCE_ID_SPECIFICATION"] = "SP_REFERENCE_ID_SPECIFICATION";
    Term["SP_REFERENCE_ID_RANGE"] = "SP_REFERENCE_ID_RANGE";
    Term["SPTR_COMMUNICATION_DOCUMENTS_SPECIFICATION"] = "SPTR_COMMUNICATION_DOCUMENTS_SPECIFICATION";
    Term["SPTR_COMMUNICATION_DOCUMENT_SET_SPECIFICATION"] = "SPTR_COMMUNICATION_DOCUMENT_SET_SPECIFICATION";
    Term["TRANSPORTATION_CONNECTIVITY_SPECIFICATION"] = "TRANSPORTATION_CONNECTIVITY_SPECIFICATION";
    Term["SPTR_COMMUNICATION_TRIGGER_SPECIFICATION"] = "SPTR_COMMUNICATION_TRIGGER_SPECIFICATION";
    Term["SHIPMENT_TRACKING_SPECIFICATION"] = "SHIPMENT_TRACKING_SPECIFICATION";
    Term["SP_ROUTE_PLAN_SPECIFICATION"] = "SP_ROUTE_PLAN_SPECIFICATION";
    Term["SP_ROUTE_PLAN_DATA"] = "SP_ROUTE_PLAN_DATA";
    Term["ZONE_COVERAGE"] = "ZONE_COVERAGE";
    Term["TRANSPORTATION_FORECAST"] = "TRANSPORTATION_FORECAST";
    Term["LOGISTICS_RELATIONSHIP_IDENTIFIER"] = "LOGISTICS_RELATIONSHIP_IDENTIFIER";
    Term["LOGISTICS_SERVICE_SCHEDULES"] = "LOGISTICS_SERVICE_SCHEDULES";
    Term["LOGISTICS_SERVICE_TRANSIT_TIME"] = "LOGISTICS_SERVICE_TRANSIT_TIME";
    Term["SPTR_COMMUNICATION_TRANSMISSION_ID_SPECIFICATION"] = "SPTR_COMMUNICATION_TRANSMISSION_ID_SPECIFICATION";
    Term["SPTR_COMMUNICATION_TRANSMISSION_ID_RULES"] = "SPTR_COMMUNICATION_TRANSMISSION_ID_RULES";
    Term["SP_PACKAGE_VOLUME"] = "SP_PACKAGE_VOLUME";
    Term["TRANSPORTATION_ADHOC_CAPACITY_REQUEST"] = "TRANSPORTATION_ADHOC_CAPACITY_REQUEST";
    Term["SP_UNDELIVERABLE_PACKAGE_HANDLING_SPECIFICATION"] = "SP_UNDELIVERABLE_PACKAGE_HANDLING_SPECIFICATION";
    Term["SP_NON_PERFORMANCE_COMPENSATION"] = "SP_NON_PERFORMANCE_COMPENSATION";
    Term["SP_INVOICE_MANAGEMENT"] = "SP_INVOICE_MANAGEMENT";
    Term["SP_PERFORMANCE_MANAGEMENT"] = "SP_PERFORMANCE_MANAGEMENT";
    Term["TRANS_COGNITECT"] = "TRANS_COGNITECT";
    Term["RUBIKS"] = "RUBIKS";
})(Term || (Term = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccZHp":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Captures the details of a change which is already validated by and set in the term
 * Term represents the term for which the change is being made.
 * changeKeyList represents the set of Change keys mapped to the new Version
 * baseVersion represents the base version on which the change was made.
 * newVersion represents the identifier of the change in term service. The new version is returned to CMS as
 * response of Submit Change API in ChangeVersionMap
 **/ parcelHelpers.export(exports, "TermChange", ()=>TermChange);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermChange] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermchange", ()=>validateTermchange);
var _changeKeyList = require("./ChangeKeyList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class TermChange extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TermChange#clone(obj: PlainObjectFrom<TermChange>) method.
     */ constructor(__changeKeyList, __newVersion, __term, __baseVersion){
        super();
        this.changeKeyList = __changeKeyList;
        this.newVersion = __newVersion;
        this.term = __term;
        this.baseVersion = __baseVersion;
    }
    /**
     * Create a shallow clone of TermChange from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TermChange(obj.changeKeyList, obj.newVersion, obj.term, obj.baseVersion);
    }
    static fromJson(data) {
        return new TermChange((0, _changeKeyList.ChangeKeyList).fromJson(data.changeKeyList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.newVersion), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.baseVersion));
    }
    static toJson(data) {
        return Object.assign({
            changeKeyList: (0, _changeKeyList.ChangeKeyList).toJson(data.changeKeyList),
            newVersion: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.newVersion),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            baseVersion: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.baseVersion)
        });
    }
}
TermChange.fullyQualifiedTypeName = "com.amazon.trans.cms.core#TermChange";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TermChange);
function validateTermchange(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ChangeKeyList":"cYeXg","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"63z76":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TermChangeList", ()=>TermChangeList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermChangeList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermchangelist", ()=>validateTermchangelist);
var _termChange = require("./TermChange");
class TermChangeList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(TermChangeList.prototype));
    }
    static fromJson(data) {
        return new TermChangeList(data.map((datum)=>(0, _termChange.TermChange).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _termChange.TermChange).toJson(datum));
    }
}
function validateTermchangelist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TermChange":"ccZHp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f0VIC":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TermList", ()=>TermList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermlist", ()=>validateTermlist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class TermList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(TermList.prototype));
    }
    static fromJson(data) {
        return new TermList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateTermlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5S00x":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An object which represents the permissions that are assigned to an entity.
 **/ parcelHelpers.export(exports, "EntityPermissions", ()=>EntityPermissions);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EntityPermissions] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEntitypermissions", ()=>validateEntitypermissions);
var _permissionList = require("./PermissionList");
var _permissionKey = require("./PermissionKey");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EntityPermissions extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EntityPermissions#clone(obj: PlainObjectFrom<EntityPermissions>) method.
     */ constructor(__entity, __permissionList){
        super();
        this.entity = __entity;
        this.permissionList = __permissionList;
    }
    /**
     * Create a shallow clone of EntityPermissions from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EntityPermissions(obj.entity, obj.permissionList);
    }
    static fromJson(data) {
        return new EntityPermissions((0, _permissionKey.PermissionKey).fromJson(data.entity), (0, _permissionList.PermissionList).fromJson(data.permissionList));
    }
    static toJson(data) {
        return Object.assign({
            entity: (0, _permissionKey.PermissionKey).toJson(data.entity),
            permissionList: (0, _permissionList.PermissionList).toJson(data.permissionList)
        });
    }
}
EntityPermissions.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EntityPermissions";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EntityPermissions);
function validateEntitypermissions(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionList":"2l0hE","./PermissionKey":"jW9S8","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2l0hE":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * PermissionList - Specifies a list of permissions
 **/ parcelHelpers.export(exports, "PermissionList", ()=>PermissionList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionlist", ()=>validatePermissionlist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class PermissionList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(PermissionList.prototype));
    }
    static fromJson(data) {
        return new PermissionList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validatePermissionlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8sRey":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * EntityPermissionsList - Specifies a list of EntityPermission
 **/ parcelHelpers.export(exports, "EntityPermissionsList", ()=>EntityPermissionsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EntityPermissionsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEntitypermissionslist", ()=>validateEntitypermissionslist);
var _entityPermissions = require("./EntityPermissions");
class EntityPermissionsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(EntityPermissionsList.prototype));
    }
    static fromJson(data) {
        return new EntityPermissionsList(data.map((datum)=>(0, _entityPermissions.EntityPermissions).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _entityPermissions.EntityPermissions).toJson(datum));
    }
}
function validateEntitypermissionslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityPermissions":"5S00x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3aOXz":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Event classification.
 **/ parcelHelpers.export(exports, "EventPermissionKey", ()=>EventPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EventPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEventpermissionkey", ()=>validateEventpermissionkey);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class EventPermissionKey extends (0, _permissionKey.PermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EventPermissionKey#clone(obj: PlainObjectFrom<EventPermissionKey>) method.
     */ constructor(__event){
        super();
        this.event = __event;
    }
    /**
     * Create a shallow clone of EventPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EventPermissionKey(obj.event);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== EventPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new EventPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.event));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== EventPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            event: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.event)
        });
    }
}
EventPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EventPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EventPermissionKey);
function validateEventpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jD6S":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Event classification and term.
 **/ parcelHelpers.export(exports, "EventTermPermissionKey", ()=>EventTermPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EventTermPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEventtermpermissionkey", ()=>validateEventtermpermissionkey);
var _eventPermissionKey = require("./EventPermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class EventTermPermissionKey extends (0, _eventPermissionKey.EventPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EventTermPermissionKey#clone(obj: PlainObjectFrom<EventTermPermissionKey>) method.
     */ constructor(__event, __term){
        super(__event);
        this.term = __term;
    }
    /**
     * Create a shallow clone of EventTermPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EventTermPermissionKey(obj.event, obj.term);
    }
    static fromJson(data) {
        return new EventTermPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.event), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            event: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.event),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
EventTermPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#EventTermPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EventTermPermissionKey);
function validateEventtermpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EventPermissionKey":"3aOXz","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jK2GY":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetAuditEventsInput", ()=>GetAuditEventsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuditEventsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauditeventsinput", ()=>validateGetauditeventsinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class GetAuditEventsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuditEventsInput#clone(obj: PlainObjectFrom<GetAuditEventsInput>) method.
     */ constructor(__logisticsPartyId, __queriedBy, __endTime, __paginationLimit, __paginationToken, __startTime){
        super();
        this.logisticsPartyId = __logisticsPartyId;
        this.queriedBy = __queriedBy;
        this.endTime = __endTime;
        this.paginationLimit = __paginationLimit;
        this.paginationToken = __paginationToken;
        this.startTime = __startTime;
    }
    /**
     * Create a shallow clone of GetAuditEventsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuditEventsInput(obj.logisticsPartyId, obj.queriedBy, obj.endTime, obj.paginationLimit, obj.paginationToken, obj.startTime);
    }
    static fromJson(data) {
        return new GetAuditEventsInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queriedBy), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.endTime), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.paginationLimit), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.paginationToken), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.startTime));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            queriedBy: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queriedBy),
            endTime: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.endTime),
            paginationLimit: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.paginationLimit),
            paginationToken: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.paginationToken),
            startTime: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.startTime)
        });
    }
}
GetAuditEventsInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#GetAuditEventsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuditEventsInput);
function validateGetauditeventsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzd2T":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetAuditEventsOutput", ()=>GetAuditEventsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuditEventsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauditeventsoutput", ()=>validateGetauditeventsoutput);
var _auditEventsList = require("./AuditEventsList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class GetAuditEventsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuditEventsOutput#clone(obj: PlainObjectFrom<GetAuditEventsOutput>) method.
     */ constructor(__auditEventsList, __paginationToken){
        super();
        this.auditEventsList = __auditEventsList;
        this.paginationToken = __paginationToken;
    }
    /**
     * Create a shallow clone of GetAuditEventsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuditEventsOutput(obj.auditEventsList, obj.paginationToken);
    }
    static fromJson(data) {
        return new GetAuditEventsOutput((0, _auditEventsList.AuditEventsList).fromJson(data.auditEventsList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.paginationToken));
    }
    static toJson(data) {
        return Object.assign({
            auditEventsList: (0, _auditEventsList.AuditEventsList).toJson(data.auditEventsList),
            paginationToken: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.paginationToken)
        });
    }
}
GetAuditEventsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#GetAuditEventsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuditEventsOutput);
function validateGetauditeventsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AuditEventsList":"4P4Wp","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dhSK1":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetAuthorizedPermissionsInput", ()=>GetAuthorizedPermissionsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedPermissionsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauthorizedpermissionsinput", ()=>validateGetauthorizedpermissionsinput);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class GetAuthorizedPermissionsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedPermissionsInput#clone(obj: PlainObjectFrom<GetAuthorizedPermissionsInput>) method.
     */ constructor(__entity, __user){
        super();
        this.entity = __entity;
        this.user = __user;
    }
    /**
     * Create a shallow clone of GetAuthorizedPermissionsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuthorizedPermissionsInput(obj.entity, obj.user);
    }
    static fromJson(data) {
        return new GetAuthorizedPermissionsInput((0, _permissionKey.PermissionKey).fromJson(data.entity), (0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            entity: (0, _permissionKey.PermissionKey).toJson(data.entity),
            user: (0, _user.User).toJson(data.user)
        });
    }
}
GetAuthorizedPermissionsInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#GetAuthorizedPermissionsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuthorizedPermissionsInput);
function validateGetauthorizedpermissionsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aajit":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetAuthorizedPermissionsOutput", ()=>GetAuthorizedPermissionsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAuthorizedPermissionsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetauthorizedpermissionsoutput", ()=>validateGetauthorizedpermissionsoutput);
var _entityPermissionsList = require("./EntityPermissionsList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class GetAuthorizedPermissionsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAuthorizedPermissionsOutput#clone(obj: PlainObjectFrom<GetAuthorizedPermissionsOutput>) method.
     */ constructor(__entityPermissionsList){
        super();
        this.entityPermissionsList = __entityPermissionsList;
    }
    /**
     * Create a shallow clone of GetAuthorizedPermissionsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAuthorizedPermissionsOutput(obj.entityPermissionsList);
    }
    static fromJson(data) {
        return new GetAuthorizedPermissionsOutput((0, _entityPermissionsList.EntityPermissionsList).fromJson(data.entityPermissionsList));
    }
    static toJson(data) {
        return Object.assign({
            entityPermissionsList: (0, _entityPermissionsList.EntityPermissionsList).toJson(data.entityPermissionsList)
        });
    }
}
GetAuthorizedPermissionsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#GetAuthorizedPermissionsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAuthorizedPermissionsOutput);
function validateGetauthorizedpermissionsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityPermissionsList":"8sRey","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"76Hvq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetPermissionRequestsInput", ()=>GetPermissionRequestsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetPermissionRequestsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetpermissionrequestsinput", ()=>validateGetpermissionrequestsinput);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class GetPermissionRequestsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetPermissionRequestsInput#clone(obj: PlainObjectFrom<GetPermissionRequestsInput>) method.
     */ constructor(__permissionKey, __user){
        super();
        this.permissionKey = __permissionKey;
        this.user = __user;
    }
    /**
     * Create a shallow clone of GetPermissionRequestsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetPermissionRequestsInput(obj.permissionKey, obj.user);
    }
    static fromJson(data) {
        return new GetPermissionRequestsInput((0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            user: (0, _user.User).toJson(data.user)
        });
    }
}
GetPermissionRequestsInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#GetPermissionRequestsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetPermissionRequestsInput);
function validateGetpermissionrequestsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqN0w":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetPermissionRequestsOutput", ()=>GetPermissionRequestsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetPermissionRequestsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetpermissionrequestsoutput", ()=>validateGetpermissionrequestsoutput);
var _permissionRequestsList = require("./PermissionRequestsList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class GetPermissionRequestsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetPermissionRequestsOutput#clone(obj: PlainObjectFrom<GetPermissionRequestsOutput>) method.
     */ constructor(__permissionRequestsList){
        super();
        this.permissionRequestsList = __permissionRequestsList;
    }
    /**
     * Create a shallow clone of GetPermissionRequestsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetPermissionRequestsOutput(obj.permissionRequestsList);
    }
    static fromJson(data) {
        return new GetPermissionRequestsOutput((0, _permissionRequestsList.PermissionRequestsList).fromJson(data.permissionRequestsList));
    }
    static toJson(data) {
        return Object.assign({
            permissionRequestsList: (0, _permissionRequestsList.PermissionRequestsList).toJson(data.permissionRequestsList)
        });
    }
}
GetPermissionRequestsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#GetPermissionRequestsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetPermissionRequestsOutput);
function validateGetpermissionrequestsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionRequestsList":"ktYTo","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktYTo":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * PermissionRequestsList - Specifies a list of Permission Requests.
 **/ parcelHelpers.export(exports, "PermissionRequestsList", ()=>PermissionRequestsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionRequestsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionrequestslist", ()=>validatePermissionrequestslist);
var _permissionRequest = require("./PermissionRequest");
class PermissionRequestsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(PermissionRequestsList.prototype));
    }
    static fromJson(data) {
        return new PermissionRequestsList(data.map((datum)=>(0, _permissionRequest.PermissionRequest).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _permissionRequest.PermissionRequest).toJson(datum));
    }
}
function validatePermissionrequestslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionRequest":"IzI8O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IzI8O":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An object which contains details of a particular Permission Request such as pr-id, permissionKey,
 * logisticsPartyId, timeStamp, requestedBy, requestedFor, admin, permission, status
 **/ parcelHelpers.export(exports, "PermissionRequest", ()=>PermissionRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionrequest", ()=>validatePermissionrequest);
var _requestedFor = require("./RequestedFor");
var _permissionKey = require("./PermissionKey");
var _admin = require("./Admin");
var _requestedBy = require("./RequestedBy");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PermissionRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PermissionRequest#clone(obj: PlainObjectFrom<PermissionRequest>) method.
     */ constructor(__admin, __logisticsPartyId, __pRId, __permission, __permissionKey, __requestedBy, __requestedFor, __status, __timeStamp){
        super();
        this.admin = __admin;
        this.logisticsPartyId = __logisticsPartyId;
        this.pRId = __pRId;
        this.permission = __permission;
        this.permissionKey = __permissionKey;
        this.requestedBy = __requestedBy;
        this.requestedFor = __requestedFor;
        this.status = __status;
        this.timeStamp = __timeStamp;
    }
    /**
     * Create a shallow clone of PermissionRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PermissionRequest(obj.admin, obj.logisticsPartyId, obj.pRId, obj.permission, obj.permissionKey, obj.requestedBy, obj.requestedFor, obj.status, obj.timeStamp);
    }
    static fromJson(data) {
        return new PermissionRequest((($$val)=>$$val == undefined ? undefined : (0, _admin.Admin).fromJson($$val))(data.admin), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pRId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.permission), (($$val)=>$$val == undefined ? undefined : (0, _permissionKey.PermissionKey).fromJson($$val))(data.permissionKey), (($$val)=>$$val == undefined ? undefined : (0, _requestedBy.RequestedBy).fromJson($$val))(data.requestedBy), (($$val)=>$$val == undefined ? undefined : (0, _requestedFor.RequestedFor).fromJson($$val))(data.requestedFor), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.status), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.timeStamp));
    }
    static toJson(data) {
        return Object.assign({
            admin: (($$val)=>$$val == undefined ? null : (0, _admin.Admin).toJson($$val))(data.admin),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            pRId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pRId),
            permission: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.permission),
            permissionKey: (($$val)=>$$val == undefined ? null : (0, _permissionKey.PermissionKey).toJson($$val))(data.permissionKey),
            requestedBy: (($$val)=>$$val == undefined ? null : (0, _requestedBy.RequestedBy).toJson($$val))(data.requestedBy),
            requestedFor: (($$val)=>$$val == undefined ? null : (0, _requestedFor.RequestedFor).toJson($$val))(data.requestedFor),
            status: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.status),
            timeStamp: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.timeStamp)
        });
    }
}
PermissionRequest.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PermissionRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PermissionRequest);
function validatePermissionrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequestedFor":"7VjXp","./PermissionKey":"jW9S8","./Admin":"grhmN","./RequestedBy":"kYX85","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VjXp":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Structure to capture the user in PAM for whom the permissions are being requested.
 **/ parcelHelpers.export(exports, "RequestedFor", ()=>RequestedFor);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestedFor] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequestedfor", ()=>validateRequestedfor);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class RequestedFor extends (0, _user.User) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestedFor#clone(obj: PlainObjectFrom<RequestedFor>) method.
     */ /**
     * Create a shallow clone of RequestedFor from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestedFor(obj.userId, obj.userType);
    }
    static fromJson(data) {
        return new RequestedFor((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType));
    }
    static toJson(data) {
        return Object.assign({
            userId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId),
            userType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType)
        });
    }
}
RequestedFor.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#RequestedFor";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RequestedFor);
function validateRequestedfor(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kYX85":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Structure to capture the user in PAM who will request for permissions for themselves or someone else.
 **/ parcelHelpers.export(exports, "RequestedBy", ()=>RequestedBy);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequestedBy] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequestedby", ()=>validateRequestedby);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class RequestedBy extends (0, _user.User) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequestedBy#clone(obj: PlainObjectFrom<RequestedBy>) method.
     */ /**
     * Create a shallow clone of RequestedBy from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequestedBy(obj.userId, obj.userType);
    }
    static fromJson(data) {
        return new RequestedBy((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType));
    }
    static toJson(data) {
        return Object.assign({
            userId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userId),
            userType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType)
        });
    }
}
RequestedBy.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#RequestedBy";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RequestedBy);
function validateRequestedby(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Jyc8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsUserAuthorizedInput", ()=>IsUserAuthorizedInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [IsUserAuthorizedInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateIsuserauthorizedinput", ()=>validateIsuserauthorizedinput);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class IsUserAuthorizedInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the IsUserAuthorizedInput#clone(obj: PlainObjectFrom<IsUserAuthorizedInput>) method.
     */ constructor(__operation, __permissionKey, __user){
        super();
        this.operation = __operation;
        this.permissionKey = __permissionKey;
        this.user = __user;
    }
    /**
     * Create a shallow clone of IsUserAuthorizedInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new IsUserAuthorizedInput(obj.operation, obj.permissionKey, obj.user);
    }
    static fromJson(data) {
        return new IsUserAuthorizedInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (($$val)=>$$val == undefined ? undefined : (0, _user.User).fromJson($$val))(data.user));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            user: (($$val)=>$$val == undefined ? null : (0, _user.User).toJson($$val))(data.user)
        });
    }
}
IsUserAuthorizedInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#IsUserAuthorizedInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(IsUserAuthorizedInput);
function validateIsuserauthorizedinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01rXE":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsUserAuthorizedOutput", ()=>IsUserAuthorizedOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [IsUserAuthorizedOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateIsuserauthorizedoutput", ()=>validateIsuserauthorizedoutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class IsUserAuthorizedOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the IsUserAuthorizedOutput#clone(obj: PlainObjectFrom<IsUserAuthorizedOutput>) method.
     */ constructor(__authorized){
        super();
        this.authorized = __authorized;
    }
    /**
     * Create a shallow clone of IsUserAuthorizedOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new IsUserAuthorizedOutput(obj.authorized);
    }
    static fromJson(data) {
        return new IsUserAuthorizedOutput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.authorized));
    }
    static toJson(data) {
        return Object.assign({
            authorized: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.authorized)
        });
    }
}
IsUserAuthorizedOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#IsUserAuthorizedOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(IsUserAuthorizedOutput);
function validateIsuserauthorizedoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mevH":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAllOperationsOutput", ()=>ListAllOperationsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAllOperationsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListalloperationsoutput", ()=>validateListalloperationsoutput);
var _operationList = require("./OperationList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAllOperationsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAllOperationsOutput#clone(obj: PlainObjectFrom<ListAllOperationsOutput>) method.
     */ constructor(__operationList){
        super();
        this.operationList = __operationList;
    }
    /**
     * Create a shallow clone of ListAllOperationsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAllOperationsOutput(obj.operationList);
    }
    static fromJson(data) {
        return new ListAllOperationsOutput((($$val)=>$$val == undefined ? undefined : (0, _operationList.OperationList).fromJson($$val))(data.operationList));
    }
    static toJson(data) {
        return Object.assign({
            operationList: (($$val)=>$$val == undefined ? null : (0, _operationList.OperationList).toJson($$val))(data.operationList)
        });
    }
}
ListAllOperationsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAllOperationsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAllOperationsOutput);
function validateListalloperationsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./OperationList":"1Jkj5","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5qglB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAllPermissionsForEntityInput", ()=>ListAllPermissionsForEntityInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAllPermissionsForEntityInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListallpermissionsforentityinput", ()=>validateListallpermissionsforentityinput);
var _permissionKey = require("./PermissionKey");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAllPermissionsForEntityInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAllPermissionsForEntityInput#clone(obj: PlainObjectFrom<ListAllPermissionsForEntityInput>) method.
     */ constructor(__entity){
        super();
        this.entity = __entity;
    }
    /**
     * Create a shallow clone of ListAllPermissionsForEntityInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAllPermissionsForEntityInput(obj.entity);
    }
    static fromJson(data) {
        return new ListAllPermissionsForEntityInput((0, _permissionKey.PermissionKey).fromJson(data.entity));
    }
    static toJson(data) {
        return Object.assign({
            entity: (0, _permissionKey.PermissionKey).toJson(data.entity)
        });
    }
}
ListAllPermissionsForEntityInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAllPermissionsForEntityInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAllPermissionsForEntityInput);
function validateListallpermissionsforentityinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxOi9":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAllPermissionsForEntityOutput", ()=>ListAllPermissionsForEntityOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAllPermissionsForEntityOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListallpermissionsforentityoutput", ()=>validateListallpermissionsforentityoutput);
var _entityPermissionsList = require("./EntityPermissionsList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAllPermissionsForEntityOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAllPermissionsForEntityOutput#clone(obj: PlainObjectFrom<ListAllPermissionsForEntityOutput>) method.
     */ constructor(__entityPermissionsList){
        super();
        this.entityPermissionsList = __entityPermissionsList;
    }
    /**
     * Create a shallow clone of ListAllPermissionsForEntityOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAllPermissionsForEntityOutput(obj.entityPermissionsList);
    }
    static fromJson(data) {
        return new ListAllPermissionsForEntityOutput((0, _entityPermissionsList.EntityPermissionsList).fromJson(data.entityPermissionsList));
    }
    static toJson(data) {
        return Object.assign({
            entityPermissionsList: (0, _entityPermissionsList.EntityPermissionsList).toJson(data.entityPermissionsList)
        });
    }
}
ListAllPermissionsForEntityOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAllPermissionsForEntityOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAllPermissionsForEntityOutput);
function validateListallpermissionsforentityoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityPermissionsList":"8sRey","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3w3Bn":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedGroupsInput", ()=>ListAuthorizedGroupsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedGroupsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedgroupsinput", ()=>validateListauthorizedgroupsinput);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedGroupsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedGroupsInput#clone(obj: PlainObjectFrom<ListAuthorizedGroupsInput>) method.
     */ constructor(__operation, __user, __permissionKey){
        super();
        this.operation = __operation;
        this.user = __user;
        this.permissionKey = __permissionKey;
    }
    /**
     * Create a shallow clone of ListAuthorizedGroupsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedGroupsInput(obj.operation, obj.user, obj.permissionKey);
    }
    static fromJson(data) {
        return new ListAuthorizedGroupsInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _permissionKey.PermissionKey).fromJson($$val))(data.permissionKey));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            user: (0, _user.User).toJson(data.user),
            permissionKey: (($$val)=>$$val == undefined ? null : (0, _permissionKey.PermissionKey).toJson($$val))(data.permissionKey)
        });
    }
}
ListAuthorizedGroupsInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedGroupsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedGroupsInput);
function validateListauthorizedgroupsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57pmJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedGroupsOutput", ()=>ListAuthorizedGroupsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedGroupsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedgroupsoutput", ()=>validateListauthorizedgroupsoutput);
var _authorizedUserList = require("./AuthorizedUserList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedGroupsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedGroupsOutput#clone(obj: PlainObjectFrom<ListAuthorizedGroupsOutput>) method.
     */ constructor(__authorizedGroups){
        super();
        this.authorizedGroups = __authorizedGroups;
    }
    /**
     * Create a shallow clone of ListAuthorizedGroupsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedGroupsOutput(obj.authorizedGroups);
    }
    static fromJson(data) {
        return new ListAuthorizedGroupsOutput((($$val)=>$$val == undefined ? undefined : (0, _authorizedUserList.AuthorizedUserList).fromJson($$val))(data.authorizedGroups));
    }
    static toJson(data) {
        return Object.assign({
            authorizedGroups: (($$val)=>$$val == undefined ? null : (0, _authorizedUserList.AuthorizedUserList).toJson($$val))(data.authorizedGroups)
        });
    }
}
ListAuthorizedGroupsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedGroupsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedGroupsOutput);
function validateListauthorizedgroupsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AuthorizedUserList":"7jhGP","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSHha":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedOperationsInput", ()=>ListAuthorizedOperationsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedOperationsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedoperationsinput", ()=>validateListauthorizedoperationsinput);
var _user = require("./User");
var _permissionKey = require("./PermissionKey");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedOperationsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedOperationsInput#clone(obj: PlainObjectFrom<ListAuthorizedOperationsInput>) method.
     */ constructor(__permissionKey, __user){
        super();
        this.permissionKey = __permissionKey;
        this.user = __user;
    }
    /**
     * Create a shallow clone of ListAuthorizedOperationsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedOperationsInput(obj.permissionKey, obj.user);
    }
    static fromJson(data) {
        return new ListAuthorizedOperationsInput((0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            user: (0, _user.User).toJson(data.user)
        });
    }
}
ListAuthorizedOperationsInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedOperationsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedOperationsInput);
function validateListauthorizedoperationsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","./PermissionKey":"jW9S8","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3iiVL":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedOperationsOutput", ()=>ListAuthorizedOperationsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedOperationsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedoperationsoutput", ()=>validateListauthorizedoperationsoutput);
var _operationList = require("./OperationList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedOperationsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedOperationsOutput#clone(obj: PlainObjectFrom<ListAuthorizedOperationsOutput>) method.
     */ constructor(__operationList){
        super();
        this.operationList = __operationList;
    }
    /**
     * Create a shallow clone of ListAuthorizedOperationsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedOperationsOutput(obj.operationList);
    }
    static fromJson(data) {
        return new ListAuthorizedOperationsOutput((($$val)=>$$val == undefined ? undefined : (0, _operationList.OperationList).fromJson($$val))(data.operationList));
    }
    static toJson(data) {
        return Object.assign({
            operationList: (($$val)=>$$val == undefined ? null : (0, _operationList.OperationList).toJson($$val))(data.operationList)
        });
    }
}
ListAuthorizedOperationsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedOperationsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedOperationsOutput);
function validateListauthorizedoperationsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./OperationList":"1Jkj5","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ib9L5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedPermissionKeysInput", ()=>ListAuthorizedPermissionKeysInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedPermissionKeysInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedpermissionkeysinput", ()=>validateListauthorizedpermissionkeysinput);
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedPermissionKeysInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedPermissionKeysInput#clone(obj: PlainObjectFrom<ListAuthorizedPermissionKeysInput>) method.
     */ constructor(__operation, __user){
        super();
        this.operation = __operation;
        this.user = __user;
    }
    /**
     * Create a shallow clone of ListAuthorizedPermissionKeysInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedPermissionKeysInput(obj.operation, obj.user);
    }
    static fromJson(data) {
        return new ListAuthorizedPermissionKeysInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            user: (0, _user.User).toJson(data.user)
        });
    }
}
ListAuthorizedPermissionKeysInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedPermissionKeysInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedPermissionKeysInput);
function validateListauthorizedpermissionkeysinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"4Ihn2","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IK7X":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedPermissionKeysOutput", ()=>ListAuthorizedPermissionKeysOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedPermissionKeysOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedpermissionkeysoutput", ()=>validateListauthorizedpermissionkeysoutput);
var _permissionKeyList = require("./PermissionKeyList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedPermissionKeysOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedPermissionKeysOutput#clone(obj: PlainObjectFrom<ListAuthorizedPermissionKeysOutput>) method.
     */ constructor(__permissionKeyList){
        super();
        this.permissionKeyList = __permissionKeyList;
    }
    /**
     * Create a shallow clone of ListAuthorizedPermissionKeysOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedPermissionKeysOutput(obj.permissionKeyList);
    }
    static fromJson(data) {
        return new ListAuthorizedPermissionKeysOutput((($$val)=>$$val == undefined ? undefined : (0, _permissionKeyList.PermissionKeyList).fromJson($$val))(data.permissionKeyList));
    }
    static toJson(data) {
        return Object.assign({
            permissionKeyList: (($$val)=>$$val == undefined ? null : (0, _permissionKeyList.PermissionKeyList).toJson($$val))(data.permissionKeyList)
        });
    }
}
ListAuthorizedPermissionKeysOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedPermissionKeysOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedPermissionKeysOutput);
function validateListauthorizedpermissionkeysoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKeyList":"kzggn","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3g72S":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedUsersInput", ()=>ListAuthorizedUsersInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedUsersInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedusersinput", ()=>validateListauthorizedusersinput);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedUsersInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedUsersInput#clone(obj: PlainObjectFrom<ListAuthorizedUsersInput>) method.
     */ constructor(__operation, __permissionKey, __userType){
        super();
        this.operation = __operation;
        this.permissionKey = __permissionKey;
        this.userType = __userType;
    }
    /**
     * Create a shallow clone of ListAuthorizedUsersInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedUsersInput(obj.operation, obj.permissionKey, obj.userType);
    }
    static fromJson(data) {
        return new ListAuthorizedUsersInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType));
    }
    static toJson(data) {
        return Object.assign({
            operation: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.operation),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            userType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType)
        });
    }
}
ListAuthorizedUsersInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedUsersInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedUsersInput);
function validateListauthorizedusersinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eUpPg":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListAuthorizedUsersOutput", ()=>ListAuthorizedUsersOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListAuthorizedUsersOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListauthorizedusersoutput", ()=>validateListauthorizedusersoutput);
var _authorizedUserList = require("./AuthorizedUserList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListAuthorizedUsersOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListAuthorizedUsersOutput#clone(obj: PlainObjectFrom<ListAuthorizedUsersOutput>) method.
     */ constructor(__authorizedUserList){
        super();
        this.authorizedUserList = __authorizedUserList;
    }
    /**
     * Create a shallow clone of ListAuthorizedUsersOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListAuthorizedUsersOutput(obj.authorizedUserList);
    }
    static fromJson(data) {
        return new ListAuthorizedUsersOutput((($$val)=>$$val == undefined ? undefined : (0, _authorizedUserList.AuthorizedUserList).fromJson($$val))(data.authorizedUserList));
    }
    static toJson(data) {
        return Object.assign({
            authorizedUserList: (($$val)=>$$val == undefined ? null : (0, _authorizedUserList.AuthorizedUserList).toJson($$val))(data.authorizedUserList)
        });
    }
}
ListAuthorizedUsersOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListAuthorizedUsersOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListAuthorizedUsersOutput);
function validateListauthorizedusersoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AuthorizedUserList":"7jhGP","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kTNba":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListEnabledExternalEntitiesForLogisticPartyInput", ()=>ListEnabledExternalEntitiesForLogisticPartyInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListEnabledExternalEntitiesForLogisticPartyInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListenabledexternalentitiesforlogisticpartyinput", ()=>validateListenabledexternalentitiesforlogisticpartyinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListEnabledExternalEntitiesForLogisticPartyInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListEnabledExternalEntitiesForLogisticPartyInput#clone(obj: PlainObjectFrom<ListEnabledExternalEntitiesForLogisticPartyInput>) method.
     */ constructor(__logisticsPartyId){
        super();
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of ListEnabledExternalEntitiesForLogisticPartyInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListEnabledExternalEntitiesForLogisticPartyInput(obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new ListEnabledExternalEntitiesForLogisticPartyInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId)
        });
    }
}
ListEnabledExternalEntitiesForLogisticPartyInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListEnabledExternalEntitiesForLogisticPartyInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListEnabledExternalEntitiesForLogisticPartyInput);
function validateListenabledexternalentitiesforlogisticpartyinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xDL9":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListEnabledExternalEntitiesForLogisticPartyOutput", ()=>ListEnabledExternalEntitiesForLogisticPartyOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListEnabledExternalEntitiesForLogisticPartyOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListenabledexternalentitiesforlogisticpartyoutput", ()=>validateListenabledexternalentitiesforlogisticpartyoutput);
var _entityList = require("./EntityList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListEnabledExternalEntitiesForLogisticPartyOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListEnabledExternalEntitiesForLogisticPartyOutput#clone(obj: PlainObjectFrom<ListEnabledExternalEntitiesForLogisticPartyOutput>) method.
     */ constructor(__entityList){
        super();
        this.entityList = __entityList;
    }
    /**
     * Create a shallow clone of ListEnabledExternalEntitiesForLogisticPartyOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListEnabledExternalEntitiesForLogisticPartyOutput(obj.entityList);
    }
    static fromJson(data) {
        return new ListEnabledExternalEntitiesForLogisticPartyOutput((($$val)=>$$val == undefined ? undefined : (0, _entityList.EntityList).fromJson($$val))(data.entityList));
    }
    static toJson(data) {
        return Object.assign({
            entityList: (($$val)=>$$val == undefined ? null : (0, _entityList.EntityList).toJson($$val))(data.entityList)
        });
    }
}
ListEnabledExternalEntitiesForLogisticPartyOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListEnabledExternalEntitiesForLogisticPartyOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListEnabledExternalEntitiesForLogisticPartyOutput);
function validateListenabledexternalentitiesforlogisticpartyoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityList":"hGdNn","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"duJ7U":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListEnabledExternalTermsForLogisticPartyInput", ()=>ListEnabledExternalTermsForLogisticPartyInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListEnabledExternalTermsForLogisticPartyInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListenabledexternaltermsforlogisticpartyinput", ()=>validateListenabledexternaltermsforlogisticpartyinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListEnabledExternalTermsForLogisticPartyInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListEnabledExternalTermsForLogisticPartyInput#clone(obj: PlainObjectFrom<ListEnabledExternalTermsForLogisticPartyInput>) method.
     */ constructor(__logisticsPartyId){
        super();
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of ListEnabledExternalTermsForLogisticPartyInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListEnabledExternalTermsForLogisticPartyInput(obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new ListEnabledExternalTermsForLogisticPartyInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId)
        });
    }
}
ListEnabledExternalTermsForLogisticPartyInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListEnabledExternalTermsForLogisticPartyInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListEnabledExternalTermsForLogisticPartyInput);
function validateListenabledexternaltermsforlogisticpartyinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8amvq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListEnabledExternalTermsForLogisticPartyOutput", ()=>ListEnabledExternalTermsForLogisticPartyOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ListEnabledExternalTermsForLogisticPartyOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateListenabledexternaltermsforlogisticpartyoutput", ()=>validateListenabledexternaltermsforlogisticpartyoutput);
var _coralComAmazonTransCmsCore = require("@amzn/coral_com-amazon-trans-cms-core");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class ListEnabledExternalTermsForLogisticPartyOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ListEnabledExternalTermsForLogisticPartyOutput#clone(obj: PlainObjectFrom<ListEnabledExternalTermsForLogisticPartyOutput>) method.
     */ constructor(__termList){
        super();
        this.termList = __termList;
    }
    /**
     * Create a shallow clone of ListEnabledExternalTermsForLogisticPartyOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ListEnabledExternalTermsForLogisticPartyOutput(obj.termList);
    }
    static fromJson(data) {
        return new ListEnabledExternalTermsForLogisticPartyOutput((($$val)=>$$val == undefined ? undefined : _coralComAmazonTransCmsCore.TermList.fromJson($$val))(data.termList));
    }
    static toJson(data) {
        return Object.assign({
            termList: (($$val)=>$$val == undefined ? null : _coralComAmazonTransCmsCore.TermList.toJson($$val))(data.termList)
        });
    }
}
ListEnabledExternalTermsForLogisticPartyOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#ListEnabledExternalTermsForLogisticPartyOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ListEnabledExternalTermsForLogisticPartyOutput);
function validateListenabledexternaltermsforlogisticpartyoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral_com-amazon-trans-cms-core":"flfuH","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DA6bv":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception is thrown if the request is invalid. Non-retryable on same input. This exception is for
 * validations that cannot be supported by coral models, eg. expiryDate must be greater than current date.
 **/ parcelHelpers.export(exports, "PAMCoreInvalidRequestException", ()=>PAMCoreInvalidRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PAMCoreInvalidRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePamcoreinvalidrequestexception", ()=>validatePamcoreinvalidrequestexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PAMCoreInvalidRequestException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PAMCoreInvalidRequestException#clone(obj: PlainObjectFrom<PAMCoreInvalidRequestException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of PAMCoreInvalidRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PAMCoreInvalidRequestException(obj.message);
    }
    static fromJson(data) {
        return new PAMCoreInvalidRequestException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PAMCoreInvalidRequestException.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PAMCoreInvalidRequestException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PAMCoreInvalidRequestException);
function validatePamcoreinvalidrequestexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TYr5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception is thrown on an error in the service. Retryable.
 **/ parcelHelpers.export(exports, "PAMCoreRecoverableException", ()=>PAMCoreRecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PAMCoreRecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePamcorerecoverableexception", ()=>validatePamcorerecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PAMCoreRecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PAMCoreRecoverableException#clone(obj: PlainObjectFrom<PAMCoreRecoverableException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of PAMCoreRecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PAMCoreRecoverableException(obj.message);
    }
    static fromJson(data) {
        return new PAMCoreRecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PAMCoreRecoverableException.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PAMCoreRecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PAMCoreRecoverableException);
function validatePamcorerecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEBAa":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception is thrown on an error in the service or its dependencies. Non-retryable.
 **/ parcelHelpers.export(exports, "PAMCoreUnrecoverableException", ()=>PAMCoreUnrecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PAMCoreUnrecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePamcoreunrecoverableexception", ()=>validatePamcoreunrecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PAMCoreUnrecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PAMCoreUnrecoverableException#clone(obj: PlainObjectFrom<PAMCoreUnrecoverableException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of PAMCoreUnrecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PAMCoreUnrecoverableException(obj.message);
    }
    static fromJson(data) {
        return new PAMCoreUnrecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PAMCoreUnrecoverableException.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PAMCoreUnrecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PAMCoreUnrecoverableException);
function validatePamcoreunrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"igzDQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An object which contains mapping between seller central enities such as rights and roles to Passport entities
 * such as permission key and permission.
 **/ parcelHelpers.export(exports, "PAMRolesMapping", ()=>PAMRolesMapping);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PAMRolesMapping] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePamrolesmapping", ()=>validatePamrolesmapping);
var _roleNameToValueMapping = require("./RoleNameToValueMapping");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PAMRolesMapping extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PAMRolesMapping#clone(obj: PlainObjectFrom<PAMRolesMapping>) method.
     */ constructor(__roleNameToValueMapping){
        super();
        this.roleNameToValueMapping = __roleNameToValueMapping;
    }
    /**
     * Create a shallow clone of PAMRolesMapping from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PAMRolesMapping(obj.roleNameToValueMapping);
    }
    static fromJson(data) {
        return new PAMRolesMapping((0, _roleNameToValueMapping.RoleNameToValueMapping).fromJson(data.roleNameToValueMapping));
    }
    static toJson(data) {
        return Object.assign({
            roleNameToValueMapping: (0, _roleNameToValueMapping.RoleNameToValueMapping).toJson(data.roleNameToValueMapping)
        });
    }
}
PAMRolesMapping.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PAMRolesMapping";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PAMRolesMapping);
function validatePamrolesmapping(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RoleNameToValueMapping":"jK1Yq","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jK1Yq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An object that map role name keys to Role values.
 **/ parcelHelpers.export(exports, "RoleNameToValueMapping", ()=>RoleNameToValueMapping);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RoleNameToValueMapping] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRolenametovaluemapping", ()=>validateRolenametovaluemapping);
var _role = require("./Role");
class RoleNameToValueMapping {
    constructor(options){
        for (const key of Object.keys(options))this[key] = options[key];
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data))obj[key] = (0, _role.Role).fromJson(data[key]);
        return new RoleNameToValueMapping(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map))data[key] = (0, _role.Role).toJson(map[key]);
        return data;
    }
}
function validateRolenametovaluemapping(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Role":"4i1wK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8KgwC":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "passportAccessManagementCoreSerdesInterceptor", ()=>passportAccessManagementCoreSerdesInterceptor);
/**
 * Passport Access Management Core Service contains APIs to configure and access\/query user permissions.
 *
 * The APIs are of 2 types:
 * 1) Configuration: These APIs will be used to configure PAM Operations like EDIT, VIEW etc. and manage user
 * assignment and de-assignment on these operations for some defined resource (Permission Key). PAM Web
 * Server\/UI will call these APIs to perform configuration.
 * 2) Access\/Enforcement: These APIs will be used to query user access on the operations for some resource
 * (permission key) and will be used by Passport Tenant applications to enforce user access control.
 *
 * Contains all the operations and models for Passport Access Management Core Service as defined in the wiki
 * https:\/\/w.amazon.com\/bin\/view\/Transportation\/Passport\/EndUserInterface\/HighLevelDesigns\/UserAccessManagement
 **/ parcelHelpers.export(exports, "PassportAccessManagementCore", ()=>PassportAccessManagementCore);
var _coralComAmazonCoralAvailability = require("@amzn/coral_com-amazon-coral-availability");
var _coralComAmazonCoralServiceBsf = require("@amzn/coral_com-amazon-coral-service-bsf");
var _coralComAmazonCoralClient = require("@amzn/coral_com-amazon-coral-client");
var _coralComAmazonCoralService = require("@amzn/coral_com-amazon-coral-service");
var _getPermissionRequestsInput = require("./GetPermissionRequestsInput");
var _listAuthorizedPermissionKeysInput = require("./ListAuthorizedPermissionKeysInput");
var _batchDeAssignUserOutput = require("./BatchDeAssignUserOutput");
var _listEnabledExternalEntitiesForLogisticPartyOutput = require("./ListEnabledExternalEntitiesForLogisticPartyOutput");
var _listAllPermissionsForEntityOutput = require("./ListAllPermissionsForEntityOutput");
var _deactivateUserInput = require("./DeactivateUserInput");
var _deAssignUserInput = require("./DeAssignUserInput");
var _batchAssignUserOutput = require("./BatchAssignUserOutput");
var _listEnabledExternalEntitiesForLogisticPartyInput = require("./ListEnabledExternalEntitiesForLogisticPartyInput");
var _batchDeAssignUserInput = require("./BatchDeAssignUserInput");
var _updatePermissionRequestOutput = require("./UpdatePermissionRequestOutput");
var _getAuthorizedPermissionsOutput = require("./GetAuthorizedPermissionsOutput");
var _deleteCustomOperationInput = require("./DeleteCustomOperationInput");
var _putPermissionRequestsOutput = require("./PutPermissionRequestsOutput");
var _listEnabledExternalTermsForLogisticPartyOutput = require("./ListEnabledExternalTermsForLogisticPartyOutput");
var _isUserAuthorizedOutput = require("./IsUserAuthorizedOutput");
var _batchAssignUserInput = require("./BatchAssignUserInput");
var _isUserAuthorizedInput = require("./IsUserAuthorizedInput");
var _enableSubscriptionForLogisticsPartyOutput = require("./EnableSubscriptionForLogisticsPartyOutput");
var _enableExternalTermForLogisticPartyInput = require("./EnableExternalTermForLogisticPartyInput");
var _listEnabledExternalTermsForLogisticPartyInput = require("./ListEnabledExternalTermsForLogisticPartyInput");
var _listAuthorizedGroupsOutput = require("./ListAuthorizedGroupsOutput");
var _deactivateUserOutput = require("./DeactivateUserOutput");
var _listAuthorizedUsersOutput = require("./ListAuthorizedUsersOutput");
var _pamcoreUnrecoverableException = require("./PAMCoreUnrecoverableException");
var _getAuditEventsOutput = require("./GetAuditEventsOutput");
var _pamcoreRecoverableException = require("./PAMCoreRecoverableException");
var _enableExternalEntityForLogisticPartyOutput = require("./EnableExternalEntityForLogisticPartyOutput");
var _listAllOperationsOutput = require("./ListAllOperationsOutput");
var _assignUserInput = require("./AssignUserInput");
var _updatePermissionRequestInput = require("./UpdatePermissionRequestInput");
var _enableExternalEntityForLogisticPartyInput = require("./EnableExternalEntityForLogisticPartyInput");
var _putPermissionRequestsInput = require("./PutPermissionRequestsInput");
var _disableExternalTermForLogisticPartyInput = require("./DisableExternalTermForLogisticPartyInput");
var _getAuditEventsInput = require("./GetAuditEventsInput");
var _createCustomOperationInput = require("./CreateCustomOperationInput");
var _listAuthorizedUsersInput = require("./ListAuthorizedUsersInput");
var _listAllPermissionsForEntityInput = require("./ListAllPermissionsForEntityInput");
var _disableExternalTermForLogisticPartyOutput = require("./DisableExternalTermForLogisticPartyOutput");
var _pamcoreInvalidRequestException = require("./PAMCoreInvalidRequestException");
var _getPermissionRequestsOutput = require("./GetPermissionRequestsOutput");
var _enableSubscriptionForLogisticsPartyInput = require("./EnableSubscriptionForLogisticsPartyInput");
var _listAuthorizedPermissionKeysOutput = require("./ListAuthorizedPermissionKeysOutput");
var _createPAMRoleMappingInput = require("./CreatePAMRoleMappingInput");
var _listAuthorizedGroupsInput = require("./ListAuthorizedGroupsInput");
var _getAuthorizedPermissionsInput = require("./GetAuthorizedPermissionsInput");
var _enableExternalTermForLogisticPartyOutput = require("./EnableExternalTermForLogisticPartyOutput");
var _listAuthorizedOperationsInput = require("./ListAuthorizedOperationsInput");
var _listAuthorizedOperationsOutput = require("./ListAuthorizedOperationsOutput");
var _coralComAmazonCoralServiceJms = require("@amzn/coral_com-amazon-coral-service-jms");
var _coralComAmazonCoralValidate = require("@amzn/coral_com-amazon-coral-validate");
var _coralComAmazonCoralServiceHttp = require("@amzn/coral_com-amazon-coral-service-http");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const passportAccessManagementCoreSerdesInterceptor = new (0, _ihmJsCoralClient.CoralClientSerdesInterceptor)({
    AssignUser: {
        serializationFn: (0, _assignUserInput.AssignUserInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    BatchAssignUser: {
        deserializationFn: (0, _batchAssignUserOutput.BatchAssignUserOutput).fromJson,
        serializationFn: (0, _batchAssignUserInput.BatchAssignUserInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    BatchDeAssignUser: {
        deserializationFn: (0, _batchDeAssignUserOutput.BatchDeAssignUserOutput).fromJson,
        serializationFn: (0, _batchDeAssignUserInput.BatchDeAssignUserInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    CreateCustomOperation: {
        serializationFn: (0, _createCustomOperationInput.CreateCustomOperationInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    CreatePAMRoleMapping: {
        serializationFn: (0, _createPAMRoleMappingInput.CreatePAMRoleMappingInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    DeactivateUser: {
        deserializationFn: (0, _deactivateUserOutput.DeactivateUserOutput).fromJson,
        serializationFn: (0, _deactivateUserInput.DeactivateUserInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    DeAssignUser: {
        serializationFn: (0, _deAssignUserInput.DeAssignUserInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    DeleteCustomOperation: {
        serializationFn: (0, _deleteCustomOperationInput.DeleteCustomOperationInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    DisableExternalTermForLogisticParty: {
        deserializationFn: (0, _disableExternalTermForLogisticPartyOutput.DisableExternalTermForLogisticPartyOutput).fromJson,
        serializationFn: (0, _disableExternalTermForLogisticPartyInput.DisableExternalTermForLogisticPartyInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    EnableExternalEntityForLogisticParty: {
        deserializationFn: (0, _enableExternalEntityForLogisticPartyOutput.EnableExternalEntityForLogisticPartyOutput).fromJson,
        serializationFn: (0, _enableExternalEntityForLogisticPartyInput.EnableExternalEntityForLogisticPartyInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    EnableExternalTermForLogisticParty: {
        deserializationFn: (0, _enableExternalTermForLogisticPartyOutput.EnableExternalTermForLogisticPartyOutput).fromJson,
        serializationFn: (0, _enableExternalTermForLogisticPartyInput.EnableExternalTermForLogisticPartyInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    EnableSubscriptionForLogisticsParty: {
        deserializationFn: (0, _enableSubscriptionForLogisticsPartyOutput.EnableSubscriptionForLogisticsPartyOutput).fromJson,
        serializationFn: (0, _enableSubscriptionForLogisticsPartyInput.EnableSubscriptionForLogisticsPartyInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    GetAuditEvents: {
        deserializationFn: (0, _getAuditEventsOutput.GetAuditEventsOutput).fromJson,
        serializationFn: (0, _getAuditEventsInput.GetAuditEventsInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    GetAuthorizedPermissions: {
        deserializationFn: (0, _getAuthorizedPermissionsOutput.GetAuthorizedPermissionsOutput).fromJson,
        serializationFn: (0, _getAuthorizedPermissionsInput.GetAuthorizedPermissionsInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    GetPermissionRequests: {
        deserializationFn: (0, _getPermissionRequestsOutput.GetPermissionRequestsOutput).fromJson,
        serializationFn: (0, _getPermissionRequestsInput.GetPermissionRequestsInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    IsUserAuthorized: {
        deserializationFn: (0, _isUserAuthorizedOutput.IsUserAuthorizedOutput).fromJson,
        serializationFn: (0, _isUserAuthorizedInput.IsUserAuthorizedInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListAllOperations: {
        deserializationFn: (0, _listAllOperationsOutput.ListAllOperationsOutput).fromJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListAllPermissionsForEntity: {
        deserializationFn: (0, _listAllPermissionsForEntityOutput.ListAllPermissionsForEntityOutput).fromJson,
        serializationFn: (0, _listAllPermissionsForEntityInput.ListAllPermissionsForEntityInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListAuthorizedGroups: {
        deserializationFn: (0, _listAuthorizedGroupsOutput.ListAuthorizedGroupsOutput).fromJson,
        serializationFn: (0, _listAuthorizedGroupsInput.ListAuthorizedGroupsInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListAuthorizedOperations: {
        deserializationFn: (0, _listAuthorizedOperationsOutput.ListAuthorizedOperationsOutput).fromJson,
        serializationFn: (0, _listAuthorizedOperationsInput.ListAuthorizedOperationsInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListAuthorizedPermissionKeys: {
        deserializationFn: (0, _listAuthorizedPermissionKeysOutput.ListAuthorizedPermissionKeysOutput).fromJson,
        serializationFn: (0, _listAuthorizedPermissionKeysInput.ListAuthorizedPermissionKeysInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListAuthorizedUsers: {
        deserializationFn: (0, _listAuthorizedUsersOutput.ListAuthorizedUsersOutput).fromJson,
        serializationFn: (0, _listAuthorizedUsersInput.ListAuthorizedUsersInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListEnabledExternalEntitiesForLogisticParty: {
        deserializationFn: (0, _listEnabledExternalEntitiesForLogisticPartyOutput.ListEnabledExternalEntitiesForLogisticPartyOutput).fromJson,
        serializationFn: (0, _listEnabledExternalEntitiesForLogisticPartyInput.ListEnabledExternalEntitiesForLogisticPartyInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    ListEnabledExternalTermsForLogisticParty: {
        deserializationFn: (0, _listEnabledExternalTermsForLogisticPartyOutput.ListEnabledExternalTermsForLogisticPartyOutput).fromJson,
        serializationFn: (0, _listEnabledExternalTermsForLogisticPartyInput.ListEnabledExternalTermsForLogisticPartyInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    PutPermissionRequests: {
        deserializationFn: (0, _putPermissionRequestsOutput.PutPermissionRequestsOutput).fromJson,
        serializationFn: (0, _putPermissionRequestsInput.PutPermissionRequestsInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    },
    UpdatePermissionRequest: {
        deserializationFn: (0, _updatePermissionRequestOutput.UpdatePermissionRequestOutput).fromJson,
        serializationFn: (0, _updatePermissionRequestInput.UpdatePermissionRequestInput).toJson,
        modelledExceptions: [
            (0, _pamcoreRecoverableException.PAMCoreRecoverableException),
            (0, _pamcoreInvalidRequestException.PAMCoreInvalidRequestException),
            (0, _pamcoreUnrecoverableException.PAMCoreUnrecoverableException)
        ]
    }
}, [
    _coralComAmazonCoralAvailability.BackOffException,
    _coralComAmazonCoralAvailability.ThrottlingException,
    _coralComAmazonCoralClient.ClientUnavailableException,
    _coralComAmazonCoralClient.HttpConnectionTimeoutException,
    _coralComAmazonCoralClient.HttpFailureException,
    _coralComAmazonCoralClient.HttpTimeoutException,
    _coralComAmazonCoralServiceBsf.InvalidCodigoMessageException,
    _coralComAmazonCoralServiceHttp.HeaderMisclassificationException,
    _coralComAmazonCoralServiceHttp.HttpNotFoundException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.InvalidMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.MissingMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingRequiredHeaderException,
    _coralComAmazonCoralServiceJms.MessageProcessingException,
    _coralComAmazonCoralServiceJms.MessagePublishException,
    _coralComAmazonCoralService.AccessDeniedException,
    _coralComAmazonCoralService.DelegationException,
    _coralComAmazonCoralService.ExpiredTokenException,
    _coralComAmazonCoralService.IncompleteSignatureException,
    _coralComAmazonCoralService.InternalFailure,
    _coralComAmazonCoralService.InvalidAwsQueryStringException,
    _coralComAmazonCoralService.InvalidParameterCombinationException,
    _coralComAmazonCoralService.InvalidParameterValueException,
    _coralComAmazonCoralService.InvalidQueryParameterException,
    _coralComAmazonCoralService.InvalidQueryStringException,
    _coralComAmazonCoralService.InvalidSignatureException,
    _coralComAmazonCoralService.MalformedHttpRequestException,
    _coralComAmazonCoralService.MissingActionException,
    _coralComAmazonCoralService.MissingAuthenticationTokenException,
    _coralComAmazonCoralService.MissingRequiredParameterException,
    _coralComAmazonCoralService.NotAuthorizedException,
    _coralComAmazonCoralService.RequestAbortedException,
    _coralComAmazonCoralService.RequestEntityTooLargeException,
    _coralComAmazonCoralService.RequestExpiredException,
    _coralComAmazonCoralService.RequestTimeoutException,
    _coralComAmazonCoralService.SerializationException,
    _coralComAmazonCoralService.ServiceUnavailableException,
    _coralComAmazonCoralService.SubscriptionRequiredException,
    _coralComAmazonCoralService.TimeoutException,
    _coralComAmazonCoralService.TransmutationException,
    _coralComAmazonCoralService.UnknownOperationException,
    _coralComAmazonCoralService.UnrecognizedClientException,
    _coralComAmazonCoralService.UnsupportedMediaTypeException,
    _coralComAmazonCoralValidate.ValidationException
]);
class PassportAccessManagementCore extends (0, _ihmJsCoralClient.CoralClient) {
    constructor(config, handler){
        const serdesHandler = new (0, _ihmJsCoralClient.InterceptingHandler)(handler, [
            passportAccessManagementCoreSerdesInterceptor
        ]);
        super(config, serdesHandler);
    }
    /**
     * This Operation grants user permission to perform a operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/ assignUser(request) {
        return super.call("AssignUser", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation grants batch user permission to perform a operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/ batchAssignUser(request) {
        return super.call("BatchAssignUser", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _batchAssignUserOutput.BatchAssignUserOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type BatchAssignUserOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation removes batch user permission to perform an operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/ batchDeAssignUser(request) {
        return super.call("BatchDeAssignUser", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _batchDeAssignUserOutput.BatchDeAssignUserOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type BatchDeAssignUserOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation creates a custom operation.
     * Sample custom operation: REVIEW
     **/ createCustomOperation(request) {
        return super.call("CreateCustomOperation", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation creates a mapping between seller central enities such as rights and roles to Passport entities
     * such as permission key and permission.
     **/ createPAMRoleMapping(request) {
        return super.call("CreatePAMRoleMapping", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation removes all the existing permissions of a user.
     * If the permission key does not have logisticsPartyId in it, permissions are removed
     * for all logisticsPartyIds for that user.
     **/ deactivateUser(request) {
        return super.call("DeactivateUser", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _deactivateUserOutput.DeactivateUserOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type DeactivateUserOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation revokes user permission to perform a operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/ deAssignUser(request) {
        return super.call("DeAssignUser", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation deletes the custom created operation.
     * Sample custom operation: REVIEW
     **/ deleteCustomOperation(request) {
        return super.call("DeleteCustomOperation", request).pipe((0, _operators.map)(()=>undefined), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This is an operational api which will disable the LP to manage the permissions on the external terms. Internally
     * this operation unsubscribes the LP Id to the given term in SCAuth.
     **/ disableExternalTermForLogisticParty(request) {
        return super.call("DisableExternalTermForLogisticParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _disableExternalTermForLogisticPartyOutput.DisableExternalTermForLogisticPartyOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type DisableExternalTermForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This operation will enable an entity for a logistics party i.e. creates an active subscription for the entity
     * in ScAuth for the partnerId provided.
     **/ enableExternalEntityForLogisticParty(request) {
        return super.call("EnableExternalEntityForLogisticParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _enableExternalEntityForLogisticPartyOutput.EnableExternalEntityForLogisticPartyOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type EnableExternalEntityForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This operation will enable the LP to manage the permissions on the external terms. Internally this operation subscribes the LP Id to the given term in SCAuth.
     **/ enableExternalTermForLogisticParty(request) {
        return super.call("EnableExternalTermForLogisticParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _enableExternalTermForLogisticPartyOutput.EnableExternalTermForLogisticPartyOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type EnableExternalTermForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This operation allows the LP to manage permissions for external terms. Internally, this operation subscribes
     * the LP Id to the specified term in SCAuth.It also subscribes LP to the default
     * subscription types if they are not already subscribed.
     **/ enableSubscriptionForLogisticsParty(request) {
        return super.call("EnableSubscriptionForLogisticsParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _enableSubscriptionForLogisticsPartyOutput.EnableSubscriptionForLogisticsPartyOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type EnableSubscriptionForLogisticsPartyOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation returns a list of audit events for a specific Logistics Provider with pagination
     **/ getAuditEvents(request) {
        return super.call("GetAuditEvents", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getAuditEventsOutput.GetAuditEventsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type GetAuditEventsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation returns the permissions that a user has on resources. The current ListAuthorizedOperations
     * allows us to return the permissions user has on a single resource. Modelling the output as an
     * entityPermissionsList allows us to send permissions of all the entities within the hierarchy.
     *
     * Note: Named this as GetAuthorizedPermissions instead of ListAuthorizedOperationsExternal with the intent of
     * migrating the functionality of existing API ListAuthorizedOperations into this API in the future.
     *
     * Input : SPPermissionKey {"logisticParty": "BNI"}, "user": { "userId": "user A", "userType": "EXTERNAL" },
     * Output : [
     * {
     * "entityPermissionsList": [
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "SHIPPING_LABEL_SPECIFICATION" },
     * "permissionList": [ "VIEW", "EDIT" ]
     * },
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "TRANSPORTATION_FORECAST" },
     * "permissionList": [ "VIEW" ]
     * }
     * ]
     * },...
     * ]
     **/ getAuthorizedPermissions(request) {
        return super.call("GetAuthorizedPermissions", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getAuthorizedPermissionsOutput.GetAuthorizedPermissionsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type GetAuthorizedPermissionsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation retrieves the Permission Requests Details from the DDB table (PermissionRequestsTable)
     **/ getPermissionRequests(request) {
        return super.call("GetPermissionRequests", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getPermissionRequestsOutput.GetPermissionRequestsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type GetPermissionRequestsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation checks whether a user has permission to perform an operation on the permission key.
     * Internal usecase:
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     * External usecases:
     * 1) Sample operation : EDIT, Sample permission key: {Logistics Party (DHL), Term Labelling}, Sample User: {User : "user A", userType: "EXTERNAL"}
     * 2) Sample operation : EDIT, Sample permission key: {Logistics Party (DHL), Term Labelling}, rightsList: [labelling_view, labelling_edit]
     **/ isUserAuthorized(request) {
        return super.call("IsUserAuthorized", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _isUserAuthorizedOutput.IsUserAuthorizedOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type IsUserAuthorizedOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation queries all operations (including custom operations) created in PAM Core.
     * Sample operation: EDIT.
     **/ listAllOperations() {
        return super.call("ListAllOperations").pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listAllOperationsOutput.ListAllOperationsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAllOperationsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Given an entity at a higher level on the hierarchy, this Operation returns the possible permissions that can
     * exist on resources within the lower level. For example, the terms which are enabled differ from logisticParty
     * to logisticParty. Given a logisticParty, this operation returns the possible permissions which can be
     * assigned to different terms.
     *
     * Input : SPPermissionKey {"logisticParty": "BNI"}
     * Output : [
     * {
     * "entityPermissionsList": [
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "SHIPPING_LABEL_SPECIFICATION" },
     * "permissionList": [ "VIEW", "EDIT", "REVIEW", "ADMIN]
     * },
     * {
     * "entity": { "classType": "SPTermPermissionKey", "logisticParty": "BNI", "term": "TRANSPORTATION_FORECAST" },
     * "permissionList": [ "VIEW", "EDIT", "REVIEW", "ADMIN]
     * }
     * ]
     * },...
     * ]
     **/ listAllPermissionsForEntity(request) {
        return super.call("ListAllPermissionsForEntity", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listAllPermissionsForEntityOutput.ListAllPermissionsForEntityOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAllPermissionsForEntityOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation returns the groups that the user is member of in PAM resources.
     *
     * The need for this API is, when a user opens passport we need the groups info that the user is part of
     * to make corresponding calls to other services and load all the relevant CR's on dashboard. We cannot
     * user other existing PAM API's because when we open passport we do not have any information other than the
     * user accessing the passport.
     *
     * Input : {{User : "user A", userType: "PRINCIPAL"}, operation : "VIEW"}
     * Output : {"VIEW" : [{userId : "group A", userType: "POSIX"}]}
     * Description : 'user A' is member of 'group A' posix group.
     **/ listAuthorizedGroups(request) {
        return super.call("ListAuthorizedGroups", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listAuthorizedGroupsOutput.ListAuthorizedGroupsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedGroupsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation queries all Operations that the user is authorized on a permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     *
     * @deprecated
     **/ listAuthorizedOperations(request) {
        return super.call("ListAuthorizedOperations", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listAuthorizedOperationsOutput.ListAuthorizedOperationsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedOperationsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation queries all permission keys that the user is authorized to perform an operation on.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/ listAuthorizedPermissionKeys(request) {
        return super.call("ListAuthorizedPermissionKeys", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listAuthorizedPermissionKeysOutput.ListAuthorizedPermissionKeysOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedPermissionKeysOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation queries all the users who have permission to perform an operation on the permission key.
     * Sample operation: EDIT, Sample permission key: Logistics Party (DHL)
     **/ listAuthorizedUsers(request) {
        return super.call("ListAuthorizedUsers", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listAuthorizedUsersOutput.ListAuthorizedUsersOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListAuthorizedUsersOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Provides a list of the external entities (Terms\/Categories etc) which are enabled for managing
     * permissions for the given logisticPartyId and permission Key.
     **/ listEnabledExternalEntitiesForLogisticParty(request) {
        return super.call("ListEnabledExternalEntitiesForLogisticParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listEnabledExternalEntitiesForLogisticPartyOutput.ListEnabledExternalEntitiesForLogisticPartyOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListEnabledExternalEntitiesForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Lists the external terms which are enabled for managing permissions of the LP Id.
     **/ listEnabledExternalTermsForLogisticParty(request) {
        return super.call("ListEnabledExternalTermsForLogisticParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _listEnabledExternalTermsForLogisticPartyOutput.ListEnabledExternalTermsForLogisticPartyOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type ListEnabledExternalTermsForLogisticPartyOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation stores the Permission Requests from a User in the DDB table (PermissionRequestsTable)
     **/ putPermissionRequests(request) {
        return super.call("PutPermissionRequests", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _putPermissionRequestsOutput.PutPermissionRequestsOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type PutPermissionRequestsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * This Operation updates the status of a Permission Request in the DDB table (PermissionRequestsTable)
     **/ updatePermissionRequest(request) {
        return super.call("UpdatePermissionRequest", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _updatePermissionRequestOutput.UpdatePermissionRequestOutput))) throw new TypeError(`[PassportAccessManagementCore] Expected response body to be of type UpdatePermissionRequestOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
}
PassportAccessManagementCore.assembly = "com.amazon.passportaccessmanagementcore";
PassportAccessManagementCore.serviceName = "PassportAccessManagementCore";

},{"@amzn/coral_com-amazon-coral-availability":"XcIbm","@amzn/coral_com-amazon-coral-service-bsf":"cXsMq","@amzn/coral_com-amazon-coral-client":"5x6ZW","@amzn/coral_com-amazon-coral-service":"17IVk","./GetPermissionRequestsInput":"76Hvq","./ListAuthorizedPermissionKeysInput":"ib9L5","./BatchDeAssignUserOutput":"gkDXW","./ListEnabledExternalEntitiesForLogisticPartyOutput":"5xDL9","./ListAllPermissionsForEntityOutput":"fxOi9","./DeactivateUserInput":"lUqhB","./DeAssignUserInput":"5sG77","./BatchAssignUserOutput":"4zHrS","./ListEnabledExternalEntitiesForLogisticPartyInput":"kTNba","./BatchDeAssignUserInput":"gePIC","./UpdatePermissionRequestOutput":"eo7K5","./GetAuthorizedPermissionsOutput":"aajit","./DeleteCustomOperationInput":"kgpSb","./PutPermissionRequestsOutput":"9X2FY","./ListEnabledExternalTermsForLogisticPartyOutput":"8amvq","./IsUserAuthorizedOutput":"01rXE","./BatchAssignUserInput":"iFjYJ","./IsUserAuthorizedInput":"9Jyc8","./EnableSubscriptionForLogisticsPartyOutput":"lvzVx","./EnableExternalTermForLogisticPartyInput":"auygu","./ListEnabledExternalTermsForLogisticPartyInput":"duJ7U","./ListAuthorizedGroupsOutput":"57pmJ","./DeactivateUserOutput":"3cqXj","./ListAuthorizedUsersOutput":"eUpPg","./PAMCoreUnrecoverableException":"bEBAa","./GetAuditEventsOutput":"bzd2T","./PAMCoreRecoverableException":"3TYr5","./EnableExternalEntityForLogisticPartyOutput":"kVd1L","./ListAllOperationsOutput":"1mevH","./AssignUserInput":"3oawK","./UpdatePermissionRequestInput":"3TEFQ","./EnableExternalEntityForLogisticPartyInput":"6XOd1","./PutPermissionRequestsInput":"cfKjq","./DisableExternalTermForLogisticPartyInput":"fTgpt","./GetAuditEventsInput":"jK2GY","./CreateCustomOperationInput":"6C2mM","./ListAuthorizedUsersInput":"3g72S","./ListAllPermissionsForEntityInput":"5qglB","./DisableExternalTermForLogisticPartyOutput":"j2x6l","./PAMCoreInvalidRequestException":"DA6bv","./GetPermissionRequestsOutput":"fqN0w","./EnableSubscriptionForLogisticsPartyInput":"arsYo","./ListAuthorizedPermissionKeysOutput":"9IK7X","./CreatePAMRoleMappingInput":"gSEA6","./ListAuthorizedGroupsInput":"3w3Bn","./GetAuthorizedPermissionsInput":"dhSK1","./EnableExternalTermForLogisticPartyOutput":"2ucI1","./ListAuthorizedOperationsInput":"lSHha","./ListAuthorizedOperationsOutput":"3iiVL","@amzn/coral_com-amazon-coral-service-jms":"6RZKg","@amzn/coral_com-amazon-coral-validate":"dF4p4","@amzn/coral_com-amazon-coral-service-http":"hKSuo","ihm-js-coral-client":"1r6qG","rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eo7K5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdatePermissionRequestOutput", ()=>UpdatePermissionRequestOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UpdatePermissionRequestOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUpdatepermissionrequestoutput", ()=>validateUpdatepermissionrequestoutput);
var _ihmJsCoralClient = require("ihm-js-coral-client");
class UpdatePermissionRequestOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UpdatePermissionRequestOutput#clone(obj: PlainObjectFrom<UpdatePermissionRequestOutput>) method.
     */ static fromJson(data) {
        return new UpdatePermissionRequestOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
UpdatePermissionRequestOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#UpdatePermissionRequestOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpdatePermissionRequestOutput);
function validateUpdatepermissionrequestoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9X2FY":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutPermissionRequestsOutput", ()=>PutPermissionRequestsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PutPermissionRequestsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePutpermissionrequestsoutput", ()=>validatePutpermissionrequestsoutput);
var _requestedFor = require("./RequestedFor");
var _permissionRequestStatusList = require("./PermissionRequestStatusList");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PutPermissionRequestsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PutPermissionRequestsOutput#clone(obj: PlainObjectFrom<PutPermissionRequestsOutput>) method.
     */ constructor(__permissionRequestStatusList, __requestedFor){
        super();
        this.permissionRequestStatusList = __permissionRequestStatusList;
        this.requestedFor = __requestedFor;
    }
    /**
     * Create a shallow clone of PutPermissionRequestsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PutPermissionRequestsOutput(obj.permissionRequestStatusList, obj.requestedFor);
    }
    static fromJson(data) {
        return new PutPermissionRequestsOutput((0, _permissionRequestStatusList.PermissionRequestStatusList).fromJson(data.permissionRequestStatusList), (0, _requestedFor.RequestedFor).fromJson(data.requestedFor));
    }
    static toJson(data) {
        return Object.assign({
            permissionRequestStatusList: (0, _permissionRequestStatusList.PermissionRequestStatusList).toJson(data.permissionRequestStatusList),
            requestedFor: (0, _requestedFor.RequestedFor).toJson(data.requestedFor)
        });
    }
}
PutPermissionRequestsOutput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PutPermissionRequestsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PutPermissionRequestsOutput);
function validatePutpermissionrequestsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequestedFor":"7VjXp","./PermissionRequestStatusList":"95ZbU","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"95ZbU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * PermissionRequestStatusList - Specifies response list of PutPermissionRequests API.
 **/ parcelHelpers.export(exports, "PermissionRequestStatusList", ()=>PermissionRequestStatusList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionRequestStatusList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionrequeststatuslist", ()=>validatePermissionrequeststatuslist);
var _permissionRequestStatus = require("./PermissionRequestStatus");
class PermissionRequestStatusList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(PermissionRequestStatusList.prototype));
    }
    static fromJson(data) {
        return new PermissionRequestStatusList(data.map((datum)=>(0, _permissionRequestStatus.PermissionRequestStatus).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _permissionRequestStatus.PermissionRequestStatus).toJson(datum));
    }
}
function validatePermissionrequeststatuslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionRequestStatus":"iLlFM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iLlFM":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An object which contains details regarding the Status of a particular Permission Request for specific LP
 **/ parcelHelpers.export(exports, "PermissionRequestStatus", ()=>PermissionRequestStatus);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PermissionRequestStatus] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePermissionrequeststatus", ()=>validatePermissionrequeststatus);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PermissionRequestStatus extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PermissionRequestStatus#clone(obj: PlainObjectFrom<PermissionRequestStatus>) method.
     */ constructor(__creationStatus, __permission, __permissionKey){
        super();
        this.creationStatus = __creationStatus;
        this.permission = __permission;
        this.permissionKey = __permissionKey;
    }
    /**
     * Create a shallow clone of PermissionRequestStatus from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PermissionRequestStatus(obj.creationStatus, obj.permission, obj.permissionKey);
    }
    static fromJson(data) {
        return new PermissionRequestStatus((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.creationStatus), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.permission), (($$val)=>$$val == undefined ? undefined : (0, _permissionKey.PermissionKey).fromJson($$val))(data.permissionKey));
    }
    static toJson(data) {
        return Object.assign({
            creationStatus: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.creationStatus),
            permission: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.permission),
            permissionKey: (($$val)=>$$val == undefined ? null : (0, _permissionKey.PermissionKey).toJson($$val))(data.permissionKey)
        });
    }
}
PermissionRequestStatus.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PermissionRequestStatus";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PermissionRequestStatus);
function validatePermissionrequeststatus(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TEFQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdatePermissionRequestInput", ()=>UpdatePermissionRequestInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UpdatePermissionRequestInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUpdatepermissionrequestinput", ()=>validateUpdatepermissionrequestinput);
var _requestedFor = require("./RequestedFor");
var _permissionKey = require("./PermissionKey");
var _admin = require("./Admin");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class UpdatePermissionRequestInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UpdatePermissionRequestInput#clone(obj: PlainObjectFrom<UpdatePermissionRequestInput>) method.
     */ constructor(__admin, __pRId, __permission, __permissionKey, __requestedFor, __status){
        super();
        this.admin = __admin;
        this.pRId = __pRId;
        this.permission = __permission;
        this.permissionKey = __permissionKey;
        this.requestedFor = __requestedFor;
        this.status = __status;
    }
    /**
     * Create a shallow clone of UpdatePermissionRequestInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UpdatePermissionRequestInput(obj.admin, obj.pRId, obj.permission, obj.permissionKey, obj.requestedFor, obj.status);
    }
    static fromJson(data) {
        return new UpdatePermissionRequestInput((0, _admin.Admin).fromJson(data.admin), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.pRId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.permission), (0, _permissionKey.PermissionKey).fromJson(data.permissionKey), (0, _requestedFor.RequestedFor).fromJson(data.requestedFor), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.status));
    }
    static toJson(data) {
        return Object.assign({
            admin: (0, _admin.Admin).toJson(data.admin),
            pRId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.pRId),
            permission: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.permission),
            permissionKey: (0, _permissionKey.PermissionKey).toJson(data.permissionKey),
            requestedFor: (0, _requestedFor.RequestedFor).toJson(data.requestedFor),
            status: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.status)
        });
    }
}
UpdatePermissionRequestInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#UpdatePermissionRequestInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpdatePermissionRequestInput);
function validateUpdatepermissionrequestinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequestedFor":"7VjXp","./PermissionKey":"jW9S8","./Admin":"grhmN","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cfKjq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutPermissionRequestsInput", ()=>PutPermissionRequestsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PutPermissionRequestsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePutpermissionrequestsinput", ()=>validatePutpermissionrequestsinput);
var _entityPermissionsList = require("./EntityPermissionsList");
var _requestedFor = require("./RequestedFor");
var _requestedBy = require("./RequestedBy");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class PutPermissionRequestsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PutPermissionRequestsInput#clone(obj: PlainObjectFrom<PutPermissionRequestsInput>) method.
     */ constructor(__entityPermissionsList, __requestedBy, __requestedFor){
        super();
        this.entityPermissionsList = __entityPermissionsList;
        this.requestedBy = __requestedBy;
        this.requestedFor = __requestedFor;
    }
    /**
     * Create a shallow clone of PutPermissionRequestsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PutPermissionRequestsInput(obj.entityPermissionsList, obj.requestedBy, obj.requestedFor);
    }
    static fromJson(data) {
        return new PutPermissionRequestsInput((0, _entityPermissionsList.EntityPermissionsList).fromJson(data.entityPermissionsList), (0, _requestedBy.RequestedBy).fromJson(data.requestedBy), (0, _requestedFor.RequestedFor).fromJson(data.requestedFor));
    }
    static toJson(data) {
        return Object.assign({
            entityPermissionsList: (0, _entityPermissionsList.EntityPermissionsList).toJson(data.entityPermissionsList),
            requestedBy: (0, _requestedBy.RequestedBy).toJson(data.requestedBy),
            requestedFor: (0, _requestedFor.RequestedFor).toJson(data.requestedFor)
        });
    }
}
PutPermissionRequestsInput.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#PutPermissionRequestsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PutPermissionRequestsInput);
function validatePutpermissionrequestsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./EntityPermissionsList":"8sRey","./RequestedFor":"7VjXp","./RequestedBy":"kYX85","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"yA4xO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * This represents the different types of permission that can be assigned to Actors.
 *
 * TODO: We are currently using Operation for this, but it is modeled as a String. Creating this enum with an
 * action item to replace all current occurrences of Operation with Permission
 * https:\/\/issues.amazon.com\/issues\/PECS-891
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Permission", ()=>Permission);
var Permission;
(function(Permission) {
    Permission["ACCESS"] = "ACCESS";
    Permission["VIEW"] = "VIEW";
    Permission["EDIT"] = "EDIT";
    Permission["REVIEW"] = "REVIEW";
    Permission["ADMIN"] = "ADMIN";
})(Permission || (Permission = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HTmW":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * This represents the type of permission entity. Example: Can be a Term or a Case Category
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PermissionEntityType", ()=>PermissionEntityType);
var PermissionEntityType;
(function(PermissionEntityType) {
    PermissionEntityType["TERM"] = "TERM";
    PermissionEntityType["CASE_CATEGORY"] = "CASE_CATEGORY";
    PermissionEntityType["RESOLVER_GROUP"] = "RESOLVER_GROUP";
})(PermissionEntityType || (PermissionEntityType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gru4f":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * String for identifying the entity that is querying the audit-data (INTERNAL\/EXTERNAL) INTERNAL->Passport |
 * EXTERNAL->CarrierLogistics
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueriedBy", ()=>QueriedBy);
var QueriedBy;
(function(QueriedBy) {
    QueriedBy["INTERNAL"] = "INTERNAL";
    QueriedBy["EXTERNAL"] = "EXTERNAL";
})(QueriedBy || (QueriedBy = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1jV9e":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Consumer.
 **/ parcelHelpers.export(exports, "SCPermissionKey", ()=>SCPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SCPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateScpermissionkey", ()=>validateScpermissionkey);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class SCPermissionKey extends (0, _permissionKey.PermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SCPermissionKey#clone(obj: PlainObjectFrom<SCPermissionKey>) method.
     */ constructor(__logisticsPartyId){
        super();
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of SCPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SCPermissionKey(obj.logisticsPartyId);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== SCPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new SCPermissionKey((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== SCPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId)
        });
    }
}
SCPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SCPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SCPermissionKey);
function validateScpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"48B1V":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Consumer and Term.
 **/ parcelHelpers.export(exports, "SCTermPermissionKey", ()=>SCTermPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SCTermPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSctermpermissionkey", ()=>validateSctermpermissionkey);
var _scpermissionKey = require("./SCPermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SCTermPermissionKey extends (0, _scpermissionKey.SCPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SCTermPermissionKey#clone(obj: PlainObjectFrom<SCTermPermissionKey>) method.
     */ constructor(__term, __logisticsPartyId){
        super(__logisticsPartyId);
        this.term = __term;
    }
    /**
     * Create a shallow clone of SCTermPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SCTermPermissionKey(obj.term, obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new SCTermPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId)
        });
    }
}
SCTermPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SCTermPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SCTermPermissionKey);
function validateSctermpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SCPermissionKey":"1jV9e","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h14qy":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider and Case Category used in Case Management Service. This permission key
 * is used for granting permissions to carrier managers and external users to allow access to the cases that belong to a
 * category and a service provider.
 **/ parcelHelpers.export(exports, "SPCaseCategoryPermissionKey", ()=>SPCaseCategoryPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPCaseCategoryPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpcasecategorypermissionkey", ()=>validateSpcasecategorypermissionkey);
var _sppermissionKey = require("./SPPermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SPCaseCategoryPermissionKey extends (0, _sppermissionKey.SPPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPCaseCategoryPermissionKey#clone(obj: PlainObjectFrom<SPCaseCategoryPermissionKey>) method.
     */ constructor(__category, __logisticsPartyId){
        super(__logisticsPartyId);
        this.category = __category;
    }
    /**
     * Create a shallow clone of SPCaseCategoryPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPCaseCategoryPermissionKey(obj.category, obj.logisticsPartyId);
    }
    static fromJson(data) {
        return new SPCaseCategoryPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.category), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId));
    }
    static toJson(data) {
        return Object.assign({
            category: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.category),
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId)
        });
    }
}
SPCaseCategoryPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPCaseCategoryPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPCaseCategoryPermissionKey);
function validateSpcasecategorypermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPPermissionKey":"i4wus","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4wus":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider.
 **/ parcelHelpers.export(exports, "SPPermissionKey", ()=>SPPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSppermissionkey", ()=>validateSppermissionkey);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class SPPermissionKey extends (0, _permissionKey.PermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPPermissionKey#clone(obj: PlainObjectFrom<SPPermissionKey>) method.
     */ constructor(__logisticsPartyId){
        super();
        this.logisticsPartyId = __logisticsPartyId;
    }
    /**
     * Create a shallow clone of SPPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPPermissionKey(obj.logisticsPartyId);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== SPPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new SPPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== SPPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId)
        });
    }
}
SPPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPPermissionKey);
function validateSppermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fOdPU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider and Case Resolver Group used in Case Management Service.
 * This permission key is used for granting permissions to front-liner teams (for example:- noc-team) to the cases
 * assigned to their resolver group for a service provider.
 **/ parcelHelpers.export(exports, "SPCaseResolverGroupPermissionKey", ()=>SPCaseResolverGroupPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPCaseResolverGroupPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpcaseresolvergrouppermissionkey", ()=>validateSpcaseresolvergrouppermissionkey);
var _sppermissionKey = require("./SPPermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SPCaseResolverGroupPermissionKey extends (0, _sppermissionKey.SPPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPCaseResolverGroupPermissionKey#clone(obj: PlainObjectFrom<SPCaseResolverGroupPermissionKey>) method.
     */ constructor(__logisticsPartyId, __resolverGroup){
        super(__logisticsPartyId);
        this.resolverGroup = __resolverGroup;
    }
    /**
     * Create a shallow clone of SPCaseResolverGroupPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPCaseResolverGroupPermissionKey(obj.logisticsPartyId, obj.resolverGroup);
    }
    static fromJson(data) {
        return new SPCaseResolverGroupPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.resolverGroup));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            resolverGroup: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.resolverGroup)
        });
    }
}
SPCaseResolverGroupPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPCaseResolverGroupPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPCaseResolverGroupPermissionKey);
function validateSpcaseresolvergrouppermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPPermissionKey":"i4wus","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aicnO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Custom key-value pair that denotes the type of specification for which the permission is given, and it's corresponding
 * value.
 **/ parcelHelpers.export(exports, "SpecificationKey", ()=>SpecificationKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SpecificationKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpecificationkey", ()=>validateSpecificationkey);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SpecificationKey extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SpecificationKey#clone(obj: PlainObjectFrom<SpecificationKey>) method.
     */ constructor(__specificationType, __specificationValue){
        super();
        this.specificationType = __specificationType;
        this.specificationValue = __specificationValue;
    }
    /**
     * Create a shallow clone of SpecificationKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SpecificationKey(obj.specificationType, obj.specificationValue);
    }
    static fromJson(data) {
        return new SpecificationKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.specificationType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.specificationValue));
    }
    static toJson(data) {
        return Object.assign({
            specificationType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.specificationType),
            specificationValue: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.specificationValue)
        });
    }
}
SpecificationKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SpecificationKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SpecificationKey);
function validateSpecificationkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"z4u9v":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider and Service.
 **/ parcelHelpers.export(exports, "SPServicePermissionKey", ()=>SPServicePermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPServicePermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpservicepermissionkey", ()=>validateSpservicepermissionkey);
var _sppermissionKey = require("./SPPermissionKey");
var _coralComAmazonShippingLogisticsservice = require("@amzn/coral_com-amazon-shipping-logisticsservice");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class SPServicePermissionKey extends (0, _sppermissionKey.SPPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPServicePermissionKey#clone(obj: PlainObjectFrom<SPServicePermissionKey>) method.
     */ constructor(__logisticsPartyId, __serviceId){
        super(__logisticsPartyId);
        this.serviceId = __serviceId;
    }
    /**
     * Create a shallow clone of SPServicePermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPServicePermissionKey(obj.logisticsPartyId, obj.serviceId);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== SPServicePermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new SPServicePermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), _coralComAmazonShippingLogisticsservice.LogisticsServiceIdentifier.fromJson(data.serviceId));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== SPServicePermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            serviceId: _coralComAmazonShippingLogisticsservice.LogisticsServiceIdentifier.toJson(data.serviceId)
        });
    }
}
SPServicePermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPServicePermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPServicePermissionKey);
function validateSpservicepermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPPermissionKey":"i4wus","@amzn/coral_com-amazon-shipping-logisticsservice":"hwZYS","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lB208":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider, Service and Term.
 **/ parcelHelpers.export(exports, "SPServiceTermPermissionKey", ()=>SPServiceTermPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPServiceTermPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpservicetermpermissionkey", ()=>validateSpservicetermpermissionkey);
var _spservicePermissionKey = require("./SPServicePermissionKey");
var _coralComAmazonShippingLogisticsservice = require("@amzn/coral_com-amazon-shipping-logisticsservice");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SPServiceTermPermissionKey extends (0, _spservicePermissionKey.SPServicePermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPServiceTermPermissionKey#clone(obj: PlainObjectFrom<SPServiceTermPermissionKey>) method.
     */ constructor(__logisticsPartyId, __serviceId, __term){
        super(__logisticsPartyId, __serviceId);
        this.term = __term;
    }
    /**
     * Create a shallow clone of SPServiceTermPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPServiceTermPermissionKey(obj.logisticsPartyId, obj.serviceId, obj.term);
    }
    static fromJson(data) {
        return new SPServiceTermPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), _coralComAmazonShippingLogisticsservice.LogisticsServiceIdentifier.fromJson(data.serviceId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            serviceId: _coralComAmazonShippingLogisticsservice.LogisticsServiceIdentifier.toJson(data.serviceId),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
SPServiceTermPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPServiceTermPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPServiceTermPermissionKey);
function validateSpservicetermpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPServicePermissionKey":"z4u9v","@amzn/coral_com-amazon-shipping-logisticsservice":"hwZYS","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tqyJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider, Term and SpecificationKey
 **/ parcelHelpers.export(exports, "SPSpecificationPermissionKey", ()=>SPSpecificationPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPSpecificationPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSpspecificationpermissionkey", ()=>validateSpspecificationpermissionkey);
var _sppermissionKey = require("./SPPermissionKey");
var _specificationKey = require("./SpecificationKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SPSpecificationPermissionKey extends (0, _sppermissionKey.SPPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPSpecificationPermissionKey#clone(obj: PlainObjectFrom<SPSpecificationPermissionKey>) method.
     */ constructor(__logisticsPartyId, __specificationKey){
        super(__logisticsPartyId);
        this.specificationKey = __specificationKey;
    }
    /**
     * Create a shallow clone of SPSpecificationPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPSpecificationPermissionKey(obj.logisticsPartyId, obj.specificationKey);
    }
    static fromJson(data) {
        return new SPSpecificationPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _specificationKey.SpecificationKey).fromJson(data.specificationKey));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            specificationKey: (0, _specificationKey.SpecificationKey).toJson(data.specificationKey)
        });
    }
}
SPSpecificationPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPSpecificationPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPSpecificationPermissionKey);
function validateSpspecificationpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPPermissionKey":"i4wus","./SpecificationKey":"aicnO","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1olDJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider and Term.
 **/ parcelHelpers.export(exports, "SPTermPermissionKey", ()=>SPTermPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPTermPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSptermpermissionkey", ()=>validateSptermpermissionkey);
var _sppermissionKey = require("./SPPermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class SPTermPermissionKey extends (0, _sppermissionKey.SPPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPTermPermissionKey#clone(obj: PlainObjectFrom<SPTermPermissionKey>) method.
     */ constructor(__logisticsPartyId, __term){
        super(__logisticsPartyId);
        this.term = __term;
    }
    /**
     * Create a shallow clone of SPTermPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPTermPermissionKey(obj.logisticsPartyId, obj.term);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== SPTermPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new SPTermPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== SPTermPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
SPTermPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPTermPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPTermPermissionKey);
function validateSptermpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPPermissionKey":"i4wus","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOxXU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider, Term and SpecificationKey
 **/ parcelHelpers.export(exports, "SPTermSpecificationPermissionKey", ()=>SPTermSpecificationPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SPTermSpecificationPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSptermspecificationpermissionkey", ()=>validateSptermspecificationpermissionkey);
var _sptermPermissionKey = require("./SPTermPermissionKey");
var _specificationKey = require("./SpecificationKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class SPTermSpecificationPermissionKey extends (0, _sptermPermissionKey.SPTermPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SPTermSpecificationPermissionKey#clone(obj: PlainObjectFrom<SPTermSpecificationPermissionKey>) method.
     */ constructor(__logisticsPartyId, __specificationKey, __term){
        super(__logisticsPartyId, __term);
        this.specificationKey = __specificationKey;
    }
    /**
     * Create a shallow clone of SPTermSpecificationPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SPTermSpecificationPermissionKey(obj.logisticsPartyId, obj.specificationKey, obj.term);
    }
    static fromJson(data) {
        return new SPTermSpecificationPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (0, _specificationKey.SpecificationKey).fromJson(data.specificationKey), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            specificationKey: (0, _specificationKey.SpecificationKey).toJson(data.specificationKey),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
SPTermSpecificationPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#SPTermSpecificationPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SPTermSpecificationPermissionKey);
function validateSptermspecificationpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SPTermPermissionKey":"1olDJ","./SpecificationKey":"aicnO","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8RGRn":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * This represents the different types of Status for a Permission Request (PENDING\/REJECTED\/ACCEPTED)
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Status", ()=>Status);
var Status;
(function(Status) {
    Status["PENDING"] = "PENDING";
    Status["REJECTED"] = "REJECTED";
    Status["ACCEPTED"] = "ACCEPTED";
})(Status || (Status = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Wa8X":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes term.
 **/ parcelHelpers.export(exports, "TermPermissionKey", ()=>TermPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermpermissionkey", ()=>validateTermpermissionkey);
var _permissionKey = require("./PermissionKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
var _serializer = require("ihm-js-coral-client/serializer");
class TermPermissionKey extends (0, _permissionKey.PermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TermPermissionKey#clone(obj: PlainObjectFrom<TermPermissionKey>) method.
     */ constructor(__term){
        super();
        this.term = __term;
    }
    /**
     * Create a shallow clone of TermPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TermPermissionKey(obj.term);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== TermPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new TermPermissionKey((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== TermPermissionKey.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
TermPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#TermPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TermPermissionKey);
function validateTermpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./PermissionKey":"jW9S8","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","ihm-js-coral-client/serializer":"aTp5N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ARX4":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Permission Key includes Service Provider, Term and SpecificationKey
 **/ parcelHelpers.export(exports, "TermSpecificationPermissionKey", ()=>TermSpecificationPermissionKey);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermSpecificationPermissionKey] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermspecificationpermissionkey", ()=>validateTermspecificationpermissionkey);
var _termPermissionKey = require("./TermPermissionKey");
var _specificationKey = require("./SpecificationKey");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("ihm-js-coral-client");
class TermSpecificationPermissionKey extends (0, _termPermissionKey.TermPermissionKey) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TermSpecificationPermissionKey#clone(obj: PlainObjectFrom<TermSpecificationPermissionKey>) method.
     */ constructor(__specificationKey, __term){
        super(__term);
        this.specificationKey = __specificationKey;
    }
    /**
     * Create a shallow clone of TermSpecificationPermissionKey from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TermSpecificationPermissionKey(obj.specificationKey, obj.term);
    }
    static fromJson(data) {
        return new TermSpecificationPermissionKey((0, _specificationKey.SpecificationKey).fromJson(data.specificationKey), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            specificationKey: (0, _specificationKey.SpecificationKey).toJson(data.specificationKey),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
TermSpecificationPermissionKey.fullyQualifiedTypeName = "com.amazon.passportaccessmanagementcore#TermSpecificationPermissionKey";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TermSpecificationPermissionKey);
function validateTermspecificationpermissionkey(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TermPermissionKey":"4Wa8X","./SpecificationKey":"aicnO","@amzn/coral-typescript-types-pieces":"9PLBl","ihm-js-coral-client":"1r6qG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBqzN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * This represents different user types supported in PAM.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserType", ()=>UserType);
var UserType;
(function(UserType) {
    UserType["PRINCIPAL"] = "PRINCIPAL";
    UserType["LDAP"] = "LDAP";
    UserType["POSIX"] = "POSIX";
    UserType["TEAM"] = "TEAM";
    UserType["EXTERNAL"] = "EXTERNAL";
})(UserType || (UserType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jn64L":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to capture invitation channel along with the channel details for the invitation.
 **/ parcelHelpers.export(exports, "InvitationChannelInfo", ()=>InvitationChannelInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvitationChannelInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInvitationchannelinfo", ()=>validateInvitationchannelinfo);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _serializer = require("@amzn/ihm-js-coral-client/serializer");
class InvitationChannelInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvitationChannelInfo#clone(obj: PlainObjectFrom<InvitationChannelInfo>) method.
     */ static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== InvitationChannelInfo.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        // Attempting to deserialize an Abstract type without its fullyQualifiedTypeName (__type).
        throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== InvitationChannelInfo.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        // Attempting to serialize an Abstract type without its fullyQualifiedTypeName
        throw new (0, _serializer.CoralDeserializationTypeError)(InvitationChannelInfo.fullyQualifiedTypeName);
    }
}
InvitationChannelInfo.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#InvitationChannelInfo";
function validateInvitationchannelinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@amzn/ihm-js-coral-client/serializer":"ikaAd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kNbgG":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a invitation id to uniquely identifying a invitation.
 **/ parcelHelpers.export(exports, "CreateInvitationResponse", ()=>CreateInvitationResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CreateInvitationResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCreateinvitationresponse", ()=>validateCreateinvitationresponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CreateInvitationResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CreateInvitationResponse#clone(obj: PlainObjectFrom<CreateInvitationResponse>) method.
     */ constructor(__invitationId){
        super();
        this.invitationId = __invitationId;
    }
    /**
     * Create a shallow clone of CreateInvitationResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CreateInvitationResponse(obj.invitationId);
    }
    static fromJson(data) {
        return new CreateInvitationResponse((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId));
    }
    static toJson(data) {
        return Object.assign({
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId)
        });
    }
}
CreateInvitationResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#CreateInvitationResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreateInvitationResponse);
function validateCreateinvitationresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1OFUm":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input required for deactivating the user.
 **/ parcelHelpers.export(exports, "DeactivateUserRequest", ()=>DeactivateUserRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeactivateUserRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeactivateuserrequest", ()=>validateDeactivateuserrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DeactivateUserRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeactivateUserRequest#clone(obj: PlainObjectFrom<DeactivateUserRequest>) method.
     */ constructor(__customerIdToDeactivate, __userDeactivationType, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.customerIdToDeactivate = __customerIdToDeactivate;
        this.userDeactivationType = __userDeactivationType;
    }
    /**
     * Create a shallow clone of DeactivateUserRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeactivateUserRequest(obj.customerIdToDeactivate, obj.userDeactivationType, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new DeactivateUserRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.customerIdToDeactivate), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userDeactivationType), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            customerIdToDeactivate: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.customerIdToDeactivate),
            userDeactivationType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.userDeactivationType),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
DeactivateUserRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#DeactivateUserRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeactivateUserRequest);
function validateDeactivateuserrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tx3W":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the timestamp and deactivation status when user deletion is completed in the system.
 **/ parcelHelpers.export(exports, "DeactivateUserResponse", ()=>DeactivateUserResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeactivateUserResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeactivateuserresponse", ()=>validateDeactivateuserresponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DeactivateUserResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeactivateUserResponse#clone(obj: PlainObjectFrom<DeactivateUserResponse>) method.
     */ constructor(__deactivateCompletionTimestamp, __userDeactivationStatus){
        super();
        this.deactivateCompletionTimestamp = __deactivateCompletionTimestamp;
        this.userDeactivationStatus = __userDeactivationStatus;
    }
    /**
     * Create a shallow clone of DeactivateUserResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeactivateUserResponse(obj.deactivateCompletionTimestamp, obj.userDeactivationStatus);
    }
    static fromJson(data) {
        return new DeactivateUserResponse((0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate(data.deactivateCompletionTimestamp), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userDeactivationStatus));
    }
    static toJson(data) {
        return Object.assign({
            deactivateCompletionTimestamp: (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson(data.deactivateCompletionTimestamp),
            userDeactivationStatus: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userDeactivationStatus)
        });
    }
}
DeactivateUserResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#DeactivateUserResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeactivateUserResponse);
function validateDeactivateuserresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fsAgs":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to delete a invitation.
 **/ parcelHelpers.export(exports, "DeleteInvitationRequest", ()=>DeleteInvitationRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeleteInvitationRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeleteinvitationrequest", ()=>validateDeleteinvitationrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DeleteInvitationRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeleteInvitationRequest#clone(obj: PlainObjectFrom<DeleteInvitationRequest>) method.
     */ constructor(__invitationId, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.invitationId = __invitationId;
    }
    /**
     * Create a shallow clone of DeleteInvitationRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeleteInvitationRequest(obj.invitationId, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new DeleteInvitationRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
DeleteInvitationRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#DeleteInvitationRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeleteInvitationRequest);
function validateDeleteinvitationrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8T376":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns invitation status based on the input.
 **/ parcelHelpers.export(exports, "DeleteInvitationResponse", ()=>DeleteInvitationResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeleteInvitationResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeleteinvitationresponse", ()=>validateDeleteinvitationresponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DeleteInvitationResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeleteInvitationResponse#clone(obj: PlainObjectFrom<DeleteInvitationResponse>) method.
     */ constructor(__invitationStatus){
        super();
        this.invitationStatus = __invitationStatus;
    }
    /**
     * Create a shallow clone of DeleteInvitationResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeleteInvitationResponse(obj.invitationStatus);
    }
    static fromJson(data) {
        return new DeleteInvitationResponse((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus));
    }
    static toJson(data) {
        return Object.assign({
            invitationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus)
        });
    }
}
DeleteInvitationResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#DeleteInvitationResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeleteInvitationResponse);
function validateDeleteinvitationresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a0JpJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeliveryStatus", ()=>DeliveryStatus);
var DeliveryStatus;
(function(DeliveryStatus) {
    DeliveryStatus["SENT"] = "sent";
    DeliveryStatus["DELIVERED"] = "delivered";
    DeliveryStatus["BOUNCED"] = "bounced";
    DeliveryStatus["FAILED"] = "failed";
})(DeliveryStatus || (DeliveryStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5diCv":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to capture email address of the invitee for the email invitation channel.
 **/ parcelHelpers.export(exports, "EmailInvitationChannelInfo", ()=>EmailInvitationChannelInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EmailInvitationChannelInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEmailinvitationchannelinfo", ()=>validateEmailinvitationchannelinfo);
var _invitationChannelInfo = require("./InvitationChannelInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class EmailInvitationChannelInfo extends (0, _invitationChannelInfo.InvitationChannelInfo) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EmailInvitationChannelInfo#clone(obj: PlainObjectFrom<EmailInvitationChannelInfo>) method.
     */ constructor(__inviteeEmail){
        super();
        this.inviteeEmail = __inviteeEmail;
    }
    /**
     * Create a shallow clone of EmailInvitationChannelInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EmailInvitationChannelInfo(obj.inviteeEmail);
    }
    static fromJson(data) {
        return new EmailInvitationChannelInfo((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.inviteeEmail));
    }
    static toJson(data) {
        return Object.assign({
            inviteeEmail: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.inviteeEmail)
        });
    }
}
EmailInvitationChannelInfo.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#EmailInvitationChannelInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EmailInvitationChannelInfo);
function validateEmailinvitationchannelinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InvitationChannelInfo":"jn64L","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nAo8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * Defines the type of errors that have occurred in the service.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
var ErrorCode;
(function(ErrorCode) {
    ErrorCode["INVITATION_ALREADY_EXISTS"] = "INVITATION_ALREADY_EXISTS";
    ErrorCode["INVITED_USER_ALREADY_AUTHORIZED"] = "INVITED_USER_ALREADY_AUTHORIZED";
    ErrorCode["ACCEPTED_USER_IS_ALREADY_AUTHORIZED"] = "ACCEPTED_USER_IS_ALREADY_AUTHORIZED";
    ErrorCode["INVITATION_IS_ACCEPTED_BY_DIFFERENT_CUSTOMER"] = "INVITATION_IS_ACCEPTED_BY_DIFFERENT_CUSTOMER";
    ErrorCode["INVITATION_IS_ALREADY_ACCEPTED"] = "INVITATION_IS_ALREADY_ACCEPTED";
    ErrorCode["INVITATION_ALREADY_COMPLETED"] = "INVITATION_ALREADY_COMPLETED";
    ErrorCode["ALLOWED_DOMAINS_NOT_MATCHED"] = "ALLOWED_DOMAINS_NOT_MATCHED";
    ErrorCode["DEACTIVATING_ADMIN_USER_ERROR"] = "DEACTIVATING_ADMIN_USER_ERROR";
    ErrorCode["ASSIGN_PERMISSION_FAILURE"] = "ASSIGN_PERMISSION_FAILURE";
    ErrorCode["USER_IS_NOT_AUTHORIZED"] = "USER_IS_NOT_AUTHORIZED";
    ErrorCode["USER_DOES_NOT_EXIST"] = "USER_DOES_NOT_EXIST";
    ErrorCode["USER_IS_DEACTIVATED"] = "USER_IS_DEACTIVATED";
})(ErrorCode || (ErrorCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QDtq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Contains additional details pertaining to exception that has occurred.
 **/ parcelHelpers.export(exports, "ExceptionDetails", ()=>ExceptionDetails);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ExceptionDetails] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateExceptiondetails", ()=>validateExceptiondetails);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ExceptionDetails extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ExceptionDetails#clone(obj: PlainObjectFrom<ExceptionDetails>) method.
     */ constructor(__errorCode){
        super();
        this.errorCode = __errorCode;
    }
    /**
     * Create a shallow clone of ExceptionDetails from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ExceptionDetails(obj.errorCode);
    }
    static fromJson(data) {
        return new ExceptionDetails((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode));
    }
    static toJson(data) {
        return Object.assign({
            errorCode: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode)
        });
    }
}
ExceptionDetails.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#ExceptionDetails";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ExceptionDetails);
function validateExceptiondetails(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCF5A":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to uniquely identifying a external customer.
 **/ parcelHelpers.export(exports, "ExternalCustomerIdentifier", ()=>ExternalCustomerIdentifier);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ExternalCustomerIdentifier] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateExternalcustomeridentifier", ()=>validateExternalcustomeridentifier);
var _userIdentifier = require("./UserIdentifier");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ExternalCustomerIdentifier extends (0, _userIdentifier.UserIdentifier) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ExternalCustomerIdentifier#clone(obj: PlainObjectFrom<ExternalCustomerIdentifier>) method.
     */ constructor(__customerId){
        super();
        this.customerId = __customerId;
    }
    /**
     * Create a shallow clone of ExternalCustomerIdentifier from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ExternalCustomerIdentifier(obj.customerId);
    }
    static fromJson(data) {
        return new ExternalCustomerIdentifier((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.customerId));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.customerId)
        });
    }
}
ExternalCustomerIdentifier.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#ExternalCustomerIdentifier";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ExternalCustomerIdentifier);
function validateExternalcustomeridentifier(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserIdentifier":"e0jDb","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xagX":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to get analytics metrics for this service. Keeping it empty for now for future requirements.
 **/ parcelHelpers.export(exports, "GetAnalyticsMetricsRequest", ()=>GetAnalyticsMetricsRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAnalyticsMetricsRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetanalyticsmetricsrequest", ()=>validateGetanalyticsmetricsrequest);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetAnalyticsMetricsRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAnalyticsMetricsRequest#clone(obj: PlainObjectFrom<GetAnalyticsMetricsRequest>) method.
     */ static fromJson(data) {
        return new GetAnalyticsMetricsRequest();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
GetAnalyticsMetricsRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetAnalyticsMetricsRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAnalyticsMetricsRequest);
function validateGetanalyticsmetricsrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amBn5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns all the analytics metrics at a LP level.
 **/ parcelHelpers.export(exports, "GetAnalyticsMetricsResponse", ()=>GetAnalyticsMetricsResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetAnalyticsMetricsResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetanalyticsmetricsresponse", ()=>validateGetanalyticsmetricsresponse);
var _metricList = require("./MetricList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetAnalyticsMetricsResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetAnalyticsMetricsResponse#clone(obj: PlainObjectFrom<GetAnalyticsMetricsResponse>) method.
     */ constructor(__metricList){
        super();
        this.metricList = __metricList;
    }
    /**
     * Create a shallow clone of GetAnalyticsMetricsResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetAnalyticsMetricsResponse(obj.metricList);
    }
    static fromJson(data) {
        return new GetAnalyticsMetricsResponse((0, _metricList.MetricList).fromJson(data.metricList));
    }
    static toJson(data) {
        return Object.assign({
            metricList: (0, _metricList.MetricList).toJson(data.metricList)
        });
    }
}
GetAnalyticsMetricsResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetAnalyticsMetricsResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetAnalyticsMetricsResponse);
function validateGetanalyticsmetricsresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./MetricList":"hcfma","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hcfma":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of Metric.
 **/ parcelHelpers.export(exports, "MetricList", ()=>MetricList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MetricList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateMetriclist", ()=>validateMetriclist);
var _metric = require("./Metric");
class MetricList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(MetricList.prototype));
    }
    static fromJson(data) {
        return new MetricList(data.map((datum)=>(0, _metric.Metric).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _metric.Metric).toJson(datum));
    }
}
function validateMetriclist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Metric":"8HeCR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8HeCR":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Defines the metric which needs to be captured. All the metrics are defined at LogisticsParty level.
 **/ parcelHelpers.export(exports, "Metric", ()=>Metric);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Metric] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateMetric", ()=>validateMetric);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Metric extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Metric#clone(obj: PlainObjectFrom<Metric>) method.
     */ constructor(__logisticsPartyId, __metricName, __metricValue){
        super();
        this.logisticsPartyId = __logisticsPartyId;
        this.metricName = __metricName;
        this.metricValue = __metricValue;
    }
    /**
     * Create a shallow clone of Metric from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Metric(obj.logisticsPartyId, obj.metricName, obj.metricValue);
    }
    static fromJson(data) {
        return new Metric((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.metricName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.metricValue));
    }
    static toJson(data) {
        return Object.assign({
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            metricName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.metricName),
            metricValue: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.metricValue)
        });
    }
}
Metric.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#Metric";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Metric);
function validateMetric(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"60Yvp":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input required to fetch the list of deactivated users.
 **/ parcelHelpers.export(exports, "GetDeactivatedUsersRequest", ()=>GetDeactivatedUsersRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetDeactivatedUsersRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetdeactivatedusersrequest", ()=>validateGetdeactivatedusersrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetDeactivatedUsersRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetDeactivatedUsersRequest#clone(obj: PlainObjectFrom<GetDeactivatedUsersRequest>) method.
     */ constructor(__customerId, __customerRights, __fetchInternalUsers, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.fetchInternalUsers = __fetchInternalUsers;
    }
    /**
     * Create a shallow clone of GetDeactivatedUsersRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetDeactivatedUsersRequest(obj.customerId, obj.customerRights, obj.fetchInternalUsers, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new GetDeactivatedUsersRequest((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.fetchInternalUsers), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            fetchInternalUsers: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.fetchInternalUsers),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
GetDeactivatedUsersRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetDeactivatedUsersRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetDeactivatedUsersRequest);
function validateGetdeactivatedusersrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l9L20":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns list of deactivated users on the platform.
 **/ parcelHelpers.export(exports, "GetDeactivatedUsersResponse", ()=>GetDeactivatedUsersResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetDeactivatedUsersResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetdeactivatedusersresponse", ()=>validateGetdeactivatedusersresponse);
var _userList = require("./UserList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetDeactivatedUsersResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetDeactivatedUsersResponse#clone(obj: PlainObjectFrom<GetDeactivatedUsersResponse>) method.
     */ constructor(__userList){
        super();
        this.userList = __userList;
    }
    /**
     * Create a shallow clone of GetDeactivatedUsersResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetDeactivatedUsersResponse(obj.userList);
    }
    static fromJson(data) {
        return new GetDeactivatedUsersResponse((0, _userList.UserList).fromJson(data.userList));
    }
    static toJson(data) {
        return Object.assign({
            userList: (0, _userList.UserList).toJson(data.userList)
        });
    }
}
GetDeactivatedUsersResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetDeactivatedUsersResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetDeactivatedUsersResponse);
function validateGetdeactivatedusersresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserList":"3hrDR","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3hrDR":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of users.
 **/ parcelHelpers.export(exports, "UserList", ()=>UserList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUserlist", ()=>validateUserlist);
var _user = require("./User");
class UserList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(UserList.prototype));
    }
    static fromJson(data) {
        return new UserList(data.map((datum)=>(0, _user.User).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _user.User).toJson(datum));
    }
}
function validateUserlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"1oWxo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1oWxo":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to capture User profile attributes. Only userIdentifier is the required attribute for this.
 * All other attributes will be populated based on the client use cases basis.
 **/ parcelHelpers.export(exports, "User", ()=>User);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [User] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUser", ()=>validateUser);
var _userIdentifier = require("./UserIdentifier");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class User extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the User#clone(obj: PlainObjectFrom<User>) method.
     */ constructor(__userIdentifier, __auditVersion, __defaultLocale, __defaultTimezone, __designation, __email, __fullName, __isUserDeactivated, __textPhoneNumber, __userDeactivatedTimestamp){
        super();
        this.userIdentifier = __userIdentifier;
        this.auditVersion = __auditVersion;
        this.defaultLocale = __defaultLocale;
        this.defaultTimezone = __defaultTimezone;
        this.designation = __designation;
        this.email = __email;
        this.fullName = __fullName;
        this.isUserDeactivated = __isUserDeactivated;
        this.textPhoneNumber = __textPhoneNumber;
        this.userDeactivatedTimestamp = __userDeactivatedTimestamp;
    }
    /**
     * Create a shallow clone of User from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new User(obj.userIdentifier, obj.auditVersion, obj.defaultLocale, obj.defaultTimezone, obj.designation, obj.email, obj.fullName, obj.isUserDeactivated, obj.textPhoneNumber, obj.userDeactivatedTimestamp);
    }
    static fromJson(data) {
        return new User((0, _userIdentifier.UserIdentifier).fromJson(data.userIdentifier), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.auditVersion), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.defaultLocale), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.defaultTimezone), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.designation), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.email), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.fullName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isUserDeactivated), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.textPhoneNumber), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.userDeactivatedTimestamp));
    }
    static toJson(data) {
        return Object.assign({
            userIdentifier: (0, _userIdentifier.UserIdentifier).toJson(data.userIdentifier),
            auditVersion: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.auditVersion),
            defaultLocale: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.defaultLocale),
            defaultTimezone: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.defaultTimezone),
            designation: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.designation),
            email: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.email),
            fullName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.fullName),
            isUserDeactivated: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isUserDeactivated),
            textPhoneNumber: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.textPhoneNumber),
            userDeactivatedTimestamp: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.userDeactivatedTimestamp)
        });
    }
}
User.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#User";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(User);
function validateUser(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserIdentifier":"e0jDb","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FXPd":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to get a invitation.
 **/ parcelHelpers.export(exports, "GetInvitationRequest", ()=>GetInvitationRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetInvitationRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetinvitationrequest", ()=>validateGetinvitationrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetInvitationRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetInvitationRequest#clone(obj: PlainObjectFrom<GetInvitationRequest>) method.
     */ constructor(__invitationId, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.invitationId = __invitationId;
    }
    /**
     * Create a shallow clone of GetInvitationRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetInvitationRequest(obj.invitationId, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new GetInvitationRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
GetInvitationRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetInvitationRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInvitationRequest);
function validateGetinvitationrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eljkr":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns invited user for a given invitation id.
 **/ parcelHelpers.export(exports, "GetInvitationResponse", ()=>GetInvitationResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetInvitationResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetinvitationresponse", ()=>validateGetinvitationresponse);
var _invitedUser = require("./InvitedUser");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetInvitationResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetInvitationResponse#clone(obj: PlainObjectFrom<GetInvitationResponse>) method.
     */ constructor(__invitedUser){
        super();
        this.invitedUser = __invitedUser;
    }
    /**
     * Create a shallow clone of GetInvitationResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetInvitationResponse(obj.invitedUser);
    }
    static fromJson(data) {
        return new GetInvitationResponse((0, _invitedUser.InvitedUser).fromJson(data.invitedUser));
    }
    static toJson(data) {
        return Object.assign({
            invitedUser: (0, _invitedUser.InvitedUser).toJson(data.invitedUser)
        });
    }
}
GetInvitationResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetInvitationResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInvitationResponse);
function validateGetinvitationresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InvitedUser":"1xXfs","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xXfs":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is to capture details for a invitation sent to a user.
 **/ parcelHelpers.export(exports, "InvitedUser", ()=>InvitedUser);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvitedUser] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInviteduser", ()=>validateInviteduser);
var _invitationChannelInfo = require("./InvitationChannelInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class InvitedUser extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InvitedUser#clone(obj: PlainObjectFrom<InvitedUser>) method.
     */ constructor(__deliveryStatus, __invitationChannelInfo, __invitationId, __invitationStatus, __invitationTimestamp, __logisticsPartyId, __acceptanceEmail){
        super();
        this.deliveryStatus = __deliveryStatus;
        this.invitationChannelInfo = __invitationChannelInfo;
        this.invitationId = __invitationId;
        this.invitationStatus = __invitationStatus;
        this.invitationTimestamp = __invitationTimestamp;
        this.logisticsPartyId = __logisticsPartyId;
        this.acceptanceEmail = __acceptanceEmail;
    }
    /**
     * Create a shallow clone of InvitedUser from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InvitedUser(obj.deliveryStatus, obj.invitationChannelInfo, obj.invitationId, obj.invitationStatus, obj.invitationTimestamp, obj.logisticsPartyId, obj.acceptanceEmail);
    }
    static fromJson(data) {
        return new InvitedUser((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.deliveryStatus), (0, _invitationChannelInfo.InvitationChannelInfo).fromJson(data.invitationChannelInfo), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate(data.invitationTimestamp), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.acceptanceEmail));
    }
    static toJson(data) {
        return Object.assign({
            deliveryStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.deliveryStatus),
            invitationChannelInfo: (0, _invitationChannelInfo.InvitationChannelInfo).toJson(data.invitationChannelInfo),
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId),
            invitationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus),
            invitationTimestamp: (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson(data.invitationTimestamp),
            logisticsPartyId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsPartyId),
            acceptanceEmail: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.acceptanceEmail)
        });
    }
}
InvitedUser.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#InvitedUser";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(InvitedUser);
function validateInviteduser(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InvitationChannelInfo":"jn64L","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJWkf":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to get invited users for a logistics party.
 **/ parcelHelpers.export(exports, "GetInvitedUsersForLogisticsPartyRequest", ()=>GetInvitedUsersForLogisticsPartyRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetInvitedUsersForLogisticsPartyRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetinvitedusersforlogisticspartyrequest", ()=>validateGetinvitedusersforlogisticspartyrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetInvitedUsersForLogisticsPartyRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetInvitedUsersForLogisticsPartyRequest#clone(obj: PlainObjectFrom<GetInvitedUsersForLogisticsPartyRequest>) method.
     */ /**
     * Create a shallow clone of GetInvitedUsersForLogisticsPartyRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetInvitedUsersForLogisticsPartyRequest(obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new GetInvitedUsersForLogisticsPartyRequest((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
GetInvitedUsersForLogisticsPartyRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetInvitedUsersForLogisticsPartyRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInvitedUsersForLogisticsPartyRequest);
function validateGetinvitedusersforlogisticspartyrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"63kp1":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns list of invited users for a logistics party.
 **/ parcelHelpers.export(exports, "GetInvitedUsersForLogisticsPartyResponse", ()=>GetInvitedUsersForLogisticsPartyResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetInvitedUsersForLogisticsPartyResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetinvitedusersforlogisticspartyresponse", ()=>validateGetinvitedusersforlogisticspartyresponse);
var _invitedUserList = require("./InvitedUserList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetInvitedUsersForLogisticsPartyResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetInvitedUsersForLogisticsPartyResponse#clone(obj: PlainObjectFrom<GetInvitedUsersForLogisticsPartyResponse>) method.
     */ constructor(__invitedUserList){
        super();
        this.invitedUserList = __invitedUserList;
    }
    /**
     * Create a shallow clone of GetInvitedUsersForLogisticsPartyResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetInvitedUsersForLogisticsPartyResponse(obj.invitedUserList);
    }
    static fromJson(data) {
        return new GetInvitedUsersForLogisticsPartyResponse((0, _invitedUserList.InvitedUserList).fromJson(data.invitedUserList));
    }
    static toJson(data) {
        return Object.assign({
            invitedUserList: (0, _invitedUserList.InvitedUserList).toJson(data.invitedUserList)
        });
    }
}
GetInvitedUsersForLogisticsPartyResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetInvitedUsersForLogisticsPartyResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInvitedUsersForLogisticsPartyResponse);
function validateGetinvitedusersforlogisticspartyresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InvitedUserList":"8TcoB","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TcoB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of Invited users.
 **/ parcelHelpers.export(exports, "InvitedUserList", ()=>InvitedUserList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InvitedUserList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInviteduserlist", ()=>validateInviteduserlist);
var _invitedUser = require("./InvitedUser");
class InvitedUserList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(InvitedUserList.prototype));
    }
    static fromJson(data) {
        return new InvitedUserList(data.map((datum)=>(0, _invitedUser.InvitedUser).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _invitedUser.InvitedUser).toJson(datum));
    }
}
function validateInviteduserlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InvitedUser":"1xXfs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cG7z":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to get user profile information of requested user.
 **/ parcelHelpers.export(exports, "GetRequestedUserProfileInfoRequest", ()=>GetRequestedUserProfileInfoRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetRequestedUserProfileInfoRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetrequesteduserprofileinforequest", ()=>validateGetrequesteduserprofileinforequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetRequestedUserProfileInfoRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetRequestedUserProfileInfoRequest#clone(obj: PlainObjectFrom<GetRequestedUserProfileInfoRequest>) method.
     */ constructor(__requestedUserId, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.requestedUserId = __requestedUserId;
    }
    /**
     * Create a shallow clone of GetRequestedUserProfileInfoRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetRequestedUserProfileInfoRequest(obj.requestedUserId, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new GetRequestedUserProfileInfoRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.requestedUserId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            requestedUserId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.requestedUserId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
GetRequestedUserProfileInfoRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetRequestedUserProfileInfoRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetRequestedUserProfileInfoRequest);
function validateGetrequesteduserprofileinforequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9XnTI":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns user profile information for requested user identifier.
 **/ parcelHelpers.export(exports, "GetRequestedUserProfileInfoResponse", ()=>GetRequestedUserProfileInfoResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetRequestedUserProfileInfoResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetrequesteduserprofileinforesponse", ()=>validateGetrequesteduserprofileinforesponse);
var _user = require("./User");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetRequestedUserProfileInfoResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetRequestedUserProfileInfoResponse#clone(obj: PlainObjectFrom<GetRequestedUserProfileInfoResponse>) method.
     */ constructor(__user){
        super();
        this.user = __user;
    }
    /**
     * Create a shallow clone of GetRequestedUserProfileInfoResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetRequestedUserProfileInfoResponse(obj.user);
    }
    static fromJson(data) {
        return new GetRequestedUserProfileInfoResponse((0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            user: (0, _user.User).toJson(data.user)
        });
    }
}
GetRequestedUserProfileInfoResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetRequestedUserProfileInfoResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetRequestedUserProfileInfoResponse);
function validateGetrequesteduserprofileinforesponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"1oWxo","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"edz9Y":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to get user profile information.
 **/ parcelHelpers.export(exports, "GetUserProfileInfoRequest", ()=>GetUserProfileInfoRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetUserProfileInfoRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetuserprofileinforequest", ()=>validateGetuserprofileinforequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetUserProfileInfoRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetUserProfileInfoRequest#clone(obj: PlainObjectFrom<GetUserProfileInfoRequest>) method.
     */ /**
     * Create a shallow clone of GetUserProfileInfoRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetUserProfileInfoRequest(obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new GetUserProfileInfoRequest((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
GetUserProfileInfoRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetUserProfileInfoRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetUserProfileInfoRequest);
function validateGetuserprofileinforequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"03JcB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns user profile information for a given user identifier.
 **/ parcelHelpers.export(exports, "GetUserProfileInfoResponse", ()=>GetUserProfileInfoResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetUserProfileInfoResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetuserprofileinforesponse", ()=>validateGetuserprofileinforesponse);
var _user = require("./User");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetUserProfileInfoResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetUserProfileInfoResponse#clone(obj: PlainObjectFrom<GetUserProfileInfoResponse>) method.
     */ constructor(__user){
        super();
        this.user = __user;
    }
    /**
     * Create a shallow clone of GetUserProfileInfoResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetUserProfileInfoResponse(obj.user);
    }
    static fromJson(data) {
        return new GetUserProfileInfoResponse((0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            user: (0, _user.User).toJson(data.user)
        });
    }
}
GetUserProfileInfoResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetUserProfileInfoResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetUserProfileInfoResponse);
function validateGetuserprofileinforesponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"1oWxo","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4G3nh":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to get verified users for a logistics party.
 **/ parcelHelpers.export(exports, "GetUsersForLogisticsPartyRequest", ()=>GetUsersForLogisticsPartyRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetUsersForLogisticsPartyRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetusersforlogisticspartyrequest", ()=>validateGetusersforlogisticspartyrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetUsersForLogisticsPartyRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetUsersForLogisticsPartyRequest#clone(obj: PlainObjectFrom<GetUsersForLogisticsPartyRequest>) method.
     */ constructor(__customerId, __customerRights, __fetchInternalUsers, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.fetchInternalUsers = __fetchInternalUsers;
    }
    /**
     * Create a shallow clone of GetUsersForLogisticsPartyRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetUsersForLogisticsPartyRequest(obj.customerId, obj.customerRights, obj.fetchInternalUsers, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new GetUsersForLogisticsPartyRequest((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.fetchInternalUsers), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            fetchInternalUsers: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.fetchInternalUsers),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
GetUsersForLogisticsPartyRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetUsersForLogisticsPartyRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetUsersForLogisticsPartyRequest);
function validateGetusersforlogisticspartyrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BV5O":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns list of verified users for a logistics party.
 **/ parcelHelpers.export(exports, "GetUsersForLogisticsPartyResponse", ()=>GetUsersForLogisticsPartyResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetUsersForLogisticsPartyResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGetusersforlogisticspartyresponse", ()=>validateGetusersforlogisticspartyresponse);
var _userList = require("./UserList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetUsersForLogisticsPartyResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetUsersForLogisticsPartyResponse#clone(obj: PlainObjectFrom<GetUsersForLogisticsPartyResponse>) method.
     */ constructor(__userList){
        super();
        this.userList = __userList;
    }
    /**
     * Create a shallow clone of GetUsersForLogisticsPartyResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetUsersForLogisticsPartyResponse(obj.userList);
    }
    static fromJson(data) {
        return new GetUsersForLogisticsPartyResponse((0, _userList.UserList).fromJson(data.userList));
    }
    static toJson(data) {
        return Object.assign({
            userList: (0, _userList.UserList).toJson(data.userList)
        });
    }
}
GetUsersForLogisticsPartyResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#GetUsersForLogisticsPartyResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetUsersForLogisticsPartyResponse);
function validateGetusersforlogisticspartyresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./UserList":"3hrDR","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1neV1":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvitationStatus", ()=>InvitationStatus);
var InvitationStatus;
(function(InvitationStatus) {
    InvitationStatus["CREATED"] = "created";
    InvitationStatus["DELIVERED"] = "delivered";
    InvitationStatus["PENDING_AUTHORIZATION"] = "pendingAuthorization";
    InvitationStatus["DENIED"] = "denied";
    InvitationStatus["DELETED"] = "deleted";
    InvitationStatus["EXPIRED"] = "expired";
    InvitationStatus["AUTO_AUTHORIZED"] = "autoAuthorized";
    InvitationStatus["MANUAL_AUTHORIZED"] = "manualAuthorized";
    InvitationStatus["OPEN"] = "OPEN";
    InvitationStatus["ACCEPTED"] = "ACCEPTED";
    InvitationStatus["DIFFERENT_EMAIL_PENDING_CONFIRM"] = "DIFFERENT_EMAIL_PENDING_CONFIRM";
    InvitationStatus["CANCELLED"] = "CANCELLED";
})(InvitationStatus || (InvitationStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i9Xqc":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Locale", ()=>Locale);
var Locale;
(function(Locale) {
    Locale["EN"] = "EN";
    Locale["EN_US"] = "en_US";
    Locale["FR_FR"] = "fr_FR";
    Locale["IT_IT"] = "it_IT";
    Locale["ES_ES"] = "es_ES";
})(Locale || (Locale = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brsQl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocaleUserFriendlyString", ()=>LocaleUserFriendlyString);
var LocaleUserFriendlyString;
(function(LocaleUserFriendlyString) {
    LocaleUserFriendlyString["EN_US"] = "English";
    LocaleUserFriendlyString["FR_FR"] = "Fran\xe7ais";
    LocaleUserFriendlyString["IT_IT"] = "Italiano";
    LocaleUserFriendlyString["ES_ES"] = "Espa\xf1ol";
})(LocaleUserFriendlyString || (LocaleUserFriendlyString = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5hYNC":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "passportUserManagementServiceSerdesInterceptor", ()=>passportUserManagementServiceSerdesInterceptor);
parcelHelpers.export(exports, "passportUserManagementServiceHttpBindingInterceptor", ()=>passportUserManagementServiceHttpBindingInterceptor);
/**
 * This service is to allow registration of new Logistics Party’s users onto passport as well as mange their profile
 * information.
 * This service will also be responsible for sending the invite to external Logistics Party’s users.
 * For more info:
 * https:\/\/w.amazon.com\/bin\/view\/Transportation\/Passport\/PassportCoreServices\/PassportUserManagement\/
 **/ parcelHelpers.export(exports, "PassportUserManagementService", ()=>PassportUserManagementService);
var _coralComAmazonCoralAvailability = require("@amzn/coral_com-amazon-coral-availability");
var _coralComAmazonCoralServiceBsf = require("@amzn/coral_com-amazon-coral-service-bsf");
var _coralComAmazonCoralService = require("@amzn/coral_com-amazon-coral-service");
var _coralComAmazonCoralClient = require("@amzn/coral_com-amazon-coral-client");
var _acceptInvitationResponse = require("./AcceptInvitationResponse");
var _confirmInvitationResponse = require("./ConfirmInvitationResponse");
var _deactivateUserResponse = require("./DeactivateUserResponse");
var _resendInvitationResponse = require("./ResendInvitationResponse");
var _getInvitationRequest = require("./GetInvitationRequest");
var _userAuthInput = require("./UserAuthInput");
var _getUsersForLogisticsPartyRequest = require("./GetUsersForLogisticsPartyRequest");
var _deleteInvitationRequest = require("./DeleteInvitationRequest");
var _getInvitedUsersForLogisticsPartyRequest = require("./GetInvitedUsersForLogisticsPartyRequest");
var _updateUserProfileInfoRequest = require("./UpdateUserProfileInfoRequest");
var _createInvitationResponse = require("./CreateInvitationResponse");
var _getUsersForLogisticsPartyResponse = require("./GetUsersForLogisticsPartyResponse");
var _getDeactivatedUsersResponse = require("./GetDeactivatedUsersResponse");
var _getUserProfileInfoResponse = require("./GetUserProfileInfoResponse");
var _pumsunAuthorizedException = require("./PUMSUnAuthorizedException");
var _getDeactivatedUsersRequest = require("./GetDeactivatedUsersRequest");
var _confirmInvitationRequest = require("./ConfirmInvitationRequest");
var _deactivateUserRequest = require("./DeactivateUserRequest");
var _getRequestedUserProfileInfoResponse = require("./GetRequestedUserProfileInfoResponse");
var _pumsinvalidRequestException = require("./PUMSInvalidRequestException");
var _resendInvitationRequest = require("./ResendInvitationRequest");
var _createInvitationRequest = require("./CreateInvitationRequest");
var _deleteInvitationResponse = require("./DeleteInvitationResponse");
var _getAnalyticsMetricsRequest = require("./GetAnalyticsMetricsRequest");
var _acceptInvitationRequest = require("./AcceptInvitationRequest");
var _getUserProfileInfoRequest = require("./GetUserProfileInfoRequest");
var _getInvitedUsersForLogisticsPartyResponse = require("./GetInvitedUsersForLogisticsPartyResponse");
var _getRequestedUserProfileInfoRequest = require("./GetRequestedUserProfileInfoRequest");
var _pumsrecoverableException = require("./PUMSRecoverableException");
var _getAnalyticsMetricsResponse = require("./GetAnalyticsMetricsResponse");
var _updateUserProfileInfoResponse = require("./UpdateUserProfileInfoResponse");
var _userAuthOutput = require("./UserAuthOutput");
var _getInvitationResponse = require("./GetInvitationResponse");
var _pumsunrecoverableException = require("./PUMSUnrecoverableException");
var _coralComAmazonCoralValidate = require("@amzn/coral_com-amazon-coral-validate");
var _coralComAmazonCoralServiceJms = require("@amzn/coral_com-amazon-coral-service-jms");
var _coralComAmazonCoralServiceHttp = require("@amzn/coral_com-amazon-coral-service-http");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const passportUserManagementServiceSerdesInterceptor = new (0, _ihmJsCoralClient.CoralClientSerdesInterceptor)({
    AcceptInvitation: {
        deserializationFn: (0, _acceptInvitationResponse.AcceptInvitationResponse).fromJson,
        serializationFn: (0, _acceptInvitationRequest.AcceptInvitationRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    ConfirmInvitation: {
        deserializationFn: (0, _confirmInvitationResponse.ConfirmInvitationResponse).fromJson,
        serializationFn: (0, _confirmInvitationRequest.ConfirmInvitationRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    CreateInvitation: {
        deserializationFn: (0, _createInvitationResponse.CreateInvitationResponse).fromJson,
        serializationFn: (0, _createInvitationRequest.CreateInvitationRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    DeactivateUser: {
        deserializationFn: (0, _deactivateUserResponse.DeactivateUserResponse).fromJson,
        serializationFn: (0, _deactivateUserRequest.DeactivateUserRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    DeleteInvitation: {
        deserializationFn: (0, _deleteInvitationResponse.DeleteInvitationResponse).fromJson,
        serializationFn: (0, _deleteInvitationRequest.DeleteInvitationRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetAnalyticsMetrics: {
        deserializationFn: (0, _getAnalyticsMetricsResponse.GetAnalyticsMetricsResponse).fromJson,
        serializationFn: (0, _getAnalyticsMetricsRequest.GetAnalyticsMetricsRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetDeactivatedUsers: {
        deserializationFn: (0, _getDeactivatedUsersResponse.GetDeactivatedUsersResponse).fromJson,
        serializationFn: (0, _getDeactivatedUsersRequest.GetDeactivatedUsersRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetInvitation: {
        deserializationFn: (0, _getInvitationResponse.GetInvitationResponse).fromJson,
        serializationFn: (0, _getInvitationRequest.GetInvitationRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetInvitedUsersForLogisticsParty: {
        deserializationFn: (0, _getInvitedUsersForLogisticsPartyResponse.GetInvitedUsersForLogisticsPartyResponse).fromJson,
        serializationFn: (0, _getInvitedUsersForLogisticsPartyRequest.GetInvitedUsersForLogisticsPartyRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetRequestedUserProfileInfo: {
        deserializationFn: (0, _getRequestedUserProfileInfoResponse.GetRequestedUserProfileInfoResponse).fromJson,
        serializationFn: (0, _getRequestedUserProfileInfoRequest.GetRequestedUserProfileInfoRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetUserProfileInfo: {
        deserializationFn: (0, _getUserProfileInfoResponse.GetUserProfileInfoResponse).fromJson,
        serializationFn: (0, _getUserProfileInfoRequest.GetUserProfileInfoRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    GetUsersForLogisticsParty: {
        deserializationFn: (0, _getUsersForLogisticsPartyResponse.GetUsersForLogisticsPartyResponse).fromJson,
        serializationFn: (0, _getUsersForLogisticsPartyRequest.GetUsersForLogisticsPartyRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    ResendInvitation: {
        deserializationFn: (0, _resendInvitationResponse.ResendInvitationResponse).fromJson,
        serializationFn: (0, _resendInvitationRequest.ResendInvitationRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    UpdateUserProfileInfo: {
        deserializationFn: (0, _updateUserProfileInfoResponse.UpdateUserProfileInfoResponse).fromJson,
        serializationFn: (0, _updateUserProfileInfoRequest.UpdateUserProfileInfoRequest).toJson,
        modelledExceptions: [
            (0, _pumsunAuthorizedException.PUMSUnAuthorizedException),
            (0, _pumsunrecoverableException.PUMSUnrecoverableException),
            (0, _pumsinvalidRequestException.PUMSInvalidRequestException),
            (0, _pumsrecoverableException.PUMSRecoverableException)
        ]
    },
    UserAuth: {
        deserializationFn: (0, _userAuthOutput.UserAuthOutput).fromJson,
        serializationFn: (0, _userAuthInput.UserAuthInput).toJson,
        modelledExceptions: []
    }
}, [
    _coralComAmazonCoralAvailability.BackOffException,
    _coralComAmazonCoralAvailability.ThrottlingException,
    _coralComAmazonCoralClient.ClientUnavailableException,
    _coralComAmazonCoralClient.HttpConnectionTimeoutException,
    _coralComAmazonCoralClient.HttpFailureException,
    _coralComAmazonCoralClient.HttpTimeoutException,
    _coralComAmazonCoralServiceBsf.InvalidCodigoMessageException,
    _coralComAmazonCoralServiceHttp.HeaderMisclassificationException,
    _coralComAmazonCoralServiceHttp.HttpNotFoundException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.InvalidMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.MissingMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingRequiredHeaderException,
    _coralComAmazonCoralServiceJms.MessageProcessingException,
    _coralComAmazonCoralServiceJms.MessagePublishException,
    _coralComAmazonCoralService.AccessDeniedException,
    _coralComAmazonCoralService.DelegationException,
    _coralComAmazonCoralService.ExpiredTokenException,
    _coralComAmazonCoralService.IncompleteSignatureException,
    _coralComAmazonCoralService.InternalFailure,
    _coralComAmazonCoralService.InvalidAwsQueryStringException,
    _coralComAmazonCoralService.InvalidParameterCombinationException,
    _coralComAmazonCoralService.InvalidParameterValueException,
    _coralComAmazonCoralService.InvalidQueryParameterException,
    _coralComAmazonCoralService.InvalidQueryStringException,
    _coralComAmazonCoralService.InvalidSignatureException,
    _coralComAmazonCoralService.MalformedHttpRequestException,
    _coralComAmazonCoralService.MissingActionException,
    _coralComAmazonCoralService.MissingAuthenticationTokenException,
    _coralComAmazonCoralService.MissingRequiredParameterException,
    _coralComAmazonCoralService.NotAuthorizedException,
    _coralComAmazonCoralService.RequestAbortedException,
    _coralComAmazonCoralService.RequestEntityTooLargeException,
    _coralComAmazonCoralService.RequestExpiredException,
    _coralComAmazonCoralService.RequestTimeoutException,
    _coralComAmazonCoralService.SerializationException,
    _coralComAmazonCoralService.ServiceUnavailableException,
    _coralComAmazonCoralService.SubscriptionRequiredException,
    _coralComAmazonCoralService.TimeoutException,
    _coralComAmazonCoralService.TransmutationException,
    _coralComAmazonCoralService.UnknownOperationException,
    _coralComAmazonCoralService.UnrecognizedClientException,
    _coralComAmazonCoralService.UnsupportedMediaTypeException,
    _coralComAmazonCoralValidate.ValidationException
]);
const passportUserManagementServiceHttpBindingInterceptor = new (0, _ihmJsCoralClient.CoralClientHttpBindingInterceptor)({
    AcceptInvitation: {
        method: "POST",
        path: "/invites/acceptances/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId"
        }
    },
    ConfirmInvitation: {
        method: "POST",
        path: "/invitations/confirmations/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId"
        }
    },
    CreateInvitation: {
        method: "POST",
        path: "/invitations"
    },
    DeactivateUser: {
        method: "DELETE",
        path: "/user/deactivate"
    },
    DeleteInvitation: {
        method: "DELETE",
        path: "/invitations/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId"
        }
    },
    GetAnalyticsMetrics: {
        method: "GET",
        path: "/pums/metrics"
    },
    GetDeactivatedUsers: {
        method: "POST",
        path: "/users/deactivated?fetchInternalUsers={fetchInternalUsers}",
        labelTransformations: {
            fetchInternalUsers: "fetchInternalUsers"
        }
    },
    GetInvitation: {
        method: "GET",
        path: "/invitations/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId"
        }
    },
    GetInvitedUsersForLogisticsParty: {
        method: "POST",
        path: "/lps/invitees"
    },
    GetRequestedUserProfileInfo: {
        method: "POST",
        path: "/user/authorized"
    },
    GetUserProfileInfo: {
        method: "GET",
        path: "/user"
    },
    GetUsersForLogisticsParty: {
        method: "POST",
        path: "/lps/users?fetchInternalUsers={fetchInternalUsers}",
        labelTransformations: {
            fetchInternalUsers: "fetchInternalUsers"
        }
    },
    ResendInvitation: {
        method: "POST",
        path: "/invitations/resends/{invitationId}",
        labelTransformations: {
            invitationId: "invitationId"
        }
    },
    UpdateUserProfileInfo: {
        method: "POST",
        path: "/user?mons_sel_locale={monsSelectLocale}",
        labelTransformations: {
            monsSelectLocale: "monsSelectLocale"
        }
    },
    UserAuth: {
        method: "GET",
        path: "/user/auth?origin={origin}",
        labelTransformations: {
            origin: "origin"
        }
    }
});
class PassportUserManagementService extends (0, _ihmJsCoralClient.CoralClient) {
    constructor(config, handler){
        const serdesHandler = new (0, _ihmJsCoralClient.InterceptingHandler)(handler, [
            passportUserManagementServiceSerdesInterceptor
        ]);
        super(config, serdesHandler);
    }
    /**
     * Accepts an invitation. This gives a user a basic set of rights on the passport platform for the logistics
     * party(com.amazon.trans.agreement.v1#LogisticsParty) specified in the invitation.
     * If the accepted user's contact information doesn't match with the contact information specified in the invite
     * then the invite will be marked as pending for manual approval.
     **/ acceptInvitation(request) {
        return super.call("AcceptInvitation", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _acceptInvitationResponse.AcceptInvitationResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type AcceptInvitationResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Approves an accepted invitation for a specific user to become a LogisticsParty's
     * (com.amazon.trans.agreement.v1#LogisticsParty) user on the passport platform.
     **/ confirmInvitation(request) {
        return super.call("ConfirmInvitation", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _confirmInvitationResponse.ConfirmInvitationResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type ConfirmInvitationResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Creates an invitation to become a LogisticsParty's (com.amazon.trans.agreement.v1#LogisticsParty)
     * user on the passport platform. This will send a notification to the invited user on the specified channel.
     **/ createInvitation(request) {
        return super.call("CreateInvitation", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _createInvitationResponse.CreateInvitationResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type CreateInvitationResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * API for deactivating an existing user from the carrierlogistics platform. Usually admin for a LP can
     * deactivate another non-Admin user from the platform.
     **/ deactivateUser(request) {
        return super.call("DeactivateUser", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _deactivateUserResponse.DeactivateUserResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type DeactivateUserResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Revokes an invitation, making it unusable for the previously invited customer.
     * This API will be used by the inviting customer to decline the invitation.
     **/ deleteInvitation(request) {
        return super.call("DeleteInvitation", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _deleteInvitationResponse.DeleteInvitationResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type DeleteInvitationResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Operational API to return analytics metrics for all the externalized Logistics Parties.
     **/ getAnalyticsMetrics(request) {
        return super.call("GetAnalyticsMetrics", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getAnalyticsMetricsResponse.GetAnalyticsMetricsResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetAnalyticsMetricsResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Returns a list of deactivated users on the platform.
     **/ getDeactivatedUsers(request) {
        return super.call("GetDeactivatedUsers", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getDeactivatedUsersResponse.GetDeactivatedUsersResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetDeactivatedUsersResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Returns a single invitation for a given invitation id.
     **/ getInvitation(request) {
        return super.call("GetInvitation", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getInvitationResponse.GetInvitationResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetInvitationResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Returns a list of all invited customers invited for a Logistics party(com.amazon.trans.agreement.v1#LogisticsParty)
     **/ getInvitedUsersForLogisticsParty(request) {
        return super.call("GetInvitedUsersForLogisticsParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getInvitedUsersForLogisticsPartyResponse.GetInvitedUsersForLogisticsPartyResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetInvitedUsersForLogisticsPartyResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Returns user profile information of requested user.
     **/ getRequestedUserProfileInfo(request) {
        return super.call("GetRequestedUserProfileInfo", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getRequestedUserProfileInfoResponse.GetRequestedUserProfileInfoResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetRequestedUserProfileInfoResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Returns user profile information for a given user identifier.
     **/ getUserProfileInfo(request) {
        return super.call("GetUserProfileInfo", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getUserProfileInfoResponse.GetUserProfileInfoResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetUserProfileInfoResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Return a list of verified users for the Logistics party(com.amazon.trans.agreement.v1#LogisticsParty).
     **/ getUsersForLogisticsParty(request) {
        return super.call("GetUsersForLogisticsParty", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getUsersForLogisticsPartyResponse.GetUsersForLogisticsPartyResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type GetUsersForLogisticsPartyResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * For an existing invitation, sends a new notification to an invited customer.
     **/ resendInvitation(request) {
        return super.call("ResendInvitation", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _resendInvitationResponse.ResendInvitationResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type ResendInvitationResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * Updates user profile information.
     **/ updateUserProfileInfo(request) {
        return super.call("UpdateUserProfileInfo", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _updateUserProfileInfoResponse.UpdateUserProfileInfoResponse))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type UpdateUserProfileInfoResponse. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * API takes client origin as input and then gives a redirection
     **/ userAuth(request) {
        return super.call("UserAuth", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _userAuthOutput.UserAuthOutput))) throw new TypeError(`[PassportUserManagementService] Expected response body to be of type UserAuthOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
}
PassportUserManagementService.assembly = "com.amazon.passportusermanagementservice";
PassportUserManagementService.serviceName = "PassportUserManagementService";

},{"@amzn/coral_com-amazon-coral-availability":"XcIbm","@amzn/coral_com-amazon-coral-service-bsf":"cXsMq","@amzn/coral_com-amazon-coral-service":"17IVk","@amzn/coral_com-amazon-coral-client":"5x6ZW","./AcceptInvitationResponse":"7M5i5","./ConfirmInvitationResponse":"eixtm","./DeactivateUserResponse":"2tx3W","./ResendInvitationResponse":"eWYfm","./GetInvitationRequest":"7FXPd","./UserAuthInput":"lxtFa","./GetUsersForLogisticsPartyRequest":"4G3nh","./DeleteInvitationRequest":"fsAgs","./GetInvitedUsersForLogisticsPartyRequest":"eJWkf","./UpdateUserProfileInfoRequest":"i4EKJ","./CreateInvitationResponse":"kNbgG","./GetUsersForLogisticsPartyResponse":"1BV5O","./GetDeactivatedUsersResponse":"l9L20","./GetUserProfileInfoResponse":"03JcB","./PUMSUnAuthorizedException":"1sxlQ","./GetDeactivatedUsersRequest":"60Yvp","./ConfirmInvitationRequest":"HIkVz","./DeactivateUserRequest":"1OFUm","./GetRequestedUserProfileInfoResponse":"9XnTI","./PUMSInvalidRequestException":"6fPvb","./ResendInvitationRequest":"dm3PJ","./CreateInvitationRequest":"4rtx3","./DeleteInvitationResponse":"8T376","./GetAnalyticsMetricsRequest":"8xagX","./AcceptInvitationRequest":"2cYp2","./GetUserProfileInfoRequest":"edz9Y","./GetInvitedUsersForLogisticsPartyResponse":"63kp1","./GetRequestedUserProfileInfoRequest":"6cG7z","./PUMSRecoverableException":"bm76L","./GetAnalyticsMetricsResponse":"amBn5","./UpdateUserProfileInfoResponse":"28Kz3","./UserAuthOutput":"5R2if","./GetInvitationResponse":"eljkr","./PUMSUnrecoverableException":"8Hwtd","@amzn/coral_com-amazon-coral-validate":"dF4p4","@amzn/coral_com-amazon-coral-service-jms":"6RZKg","@amzn/coral_com-amazon-coral-service-http":"hKSuo","@amzn/ihm-js-coral-client":"eOj61","rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eWYfm":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns invitation status based on the input.
 **/ parcelHelpers.export(exports, "ResendInvitationResponse", ()=>ResendInvitationResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ResendInvitationResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateResendinvitationresponse", ()=>validateResendinvitationresponse);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ResendInvitationResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ResendInvitationResponse#clone(obj: PlainObjectFrom<ResendInvitationResponse>) method.
     */ constructor(__invitationStatus){
        super();
        this.invitationStatus = __invitationStatus;
    }
    /**
     * Create a shallow clone of ResendInvitationResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ResendInvitationResponse(obj.invitationStatus);
    }
    static fromJson(data) {
        return new ResendInvitationResponse((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus));
    }
    static toJson(data) {
        return Object.assign({
            invitationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationStatus)
        });
    }
}
ResendInvitationResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#ResendInvitationResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ResendInvitationResponse);
function validateResendinvitationresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lxtFa":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input for UserAuth Api
 **/ parcelHelpers.export(exports, "UserAuthInput", ()=>UserAuthInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserAuthInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUserauthinput", ()=>validateUserauthinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UserAuthInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UserAuthInput#clone(obj: PlainObjectFrom<UserAuthInput>) method.
     */ constructor(__origin){
        super();
        this.origin = __origin;
    }
    /**
     * Create a shallow clone of UserAuthInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UserAuthInput(obj.origin);
    }
    static fromJson(data) {
        return new UserAuthInput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.origin));
    }
    static toJson(data) {
        return Object.assign({
            origin: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.origin)
        });
    }
}
UserAuthInput.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#UserAuthInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UserAuthInput);
function validateUserauthinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i4EKJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to update user profile information. Not all profile attributes supports update.
 **/ parcelHelpers.export(exports, "UpdateUserProfileInfoRequest", ()=>UpdateUserProfileInfoRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UpdateUserProfileInfoRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUpdateuserprofileinforequest", ()=>validateUpdateuserprofileinforequest);
var _baseRequest = require("./BaseRequest");
var _user = require("./User");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UpdateUserProfileInfoRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UpdateUserProfileInfoRequest#clone(obj: PlainObjectFrom<UpdateUserProfileInfoRequest>) method.
     */ constructor(__user, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __monsSelectLocale, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.user = __user;
        this.monsSelectLocale = __monsSelectLocale;
    }
    /**
     * Create a shallow clone of UpdateUserProfileInfoRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UpdateUserProfileInfoRequest(obj.user, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.monsSelectLocale, obj.userAlias);
    }
    static fromJson(data) {
        return new UpdateUserProfileInfoRequest((0, _user.User).fromJson(data.user), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.monsSelectLocale), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            user: (0, _user.User).toJson(data.user),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            monsSelectLocale: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.monsSelectLocale),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
UpdateUserProfileInfoRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#UpdateUserProfileInfoRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpdateUserProfileInfoRequest);
function validateUpdateuserprofileinforequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","./User":"1oWxo","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1sxlQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception is thrown if the user doesn't have required permissions to perform the operation.
 **/ parcelHelpers.export(exports, "PUMSUnAuthorizedException", ()=>PUMSUnAuthorizedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PUMSUnAuthorizedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePumsunauthorizedexception", ()=>validatePumsunauthorizedexception);
var _exceptionDetails = require("./ExceptionDetails");
var _pumsunrecoverableException = require("./PUMSUnrecoverableException");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class PUMSUnAuthorizedException extends (0, _pumsunrecoverableException.PUMSUnrecoverableException) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PUMSUnAuthorizedException#clone(obj: PlainObjectFrom<PUMSUnAuthorizedException>) method.
     */ /**
     * Create a shallow clone of PUMSUnAuthorizedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PUMSUnAuthorizedException(obj.exceptionDetails, obj.message);
    }
    static fromJson(data) {
        return new PUMSUnAuthorizedException((($$val)=>$$val == undefined ? undefined : (0, _exceptionDetails.ExceptionDetails).fromJson($$val))(data.exceptionDetails), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            exceptionDetails: (($$val)=>$$val == undefined ? null : (0, _exceptionDetails.ExceptionDetails).toJson($$val))(data.exceptionDetails),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PUMSUnAuthorizedException.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#PUMSUnAuthorizedException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PUMSUnAuthorizedException);
function validatePumsunauthorizedexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ExceptionDetails":"7QDtq","./PUMSUnrecoverableException":"8Hwtd","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Hwtd":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception is thrown when there is any non-recoverable exception from PassportUserManagementService dependencies
 * or when this service encounters non-recoverable processing errors. Clients should not retry on this exception.
 **/ parcelHelpers.export(exports, "PUMSUnrecoverableException", ()=>PUMSUnrecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PUMSUnrecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePumsunrecoverableexception", ()=>validatePumsunrecoverableexception);
var _exceptionDetails = require("./ExceptionDetails");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _serializer = require("@amzn/ihm-js-coral-client/serializer");
class PUMSUnrecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PUMSUnrecoverableException#clone(obj: PlainObjectFrom<PUMSUnrecoverableException>) method.
     */ constructor(__exceptionDetails, __message){
        super();
        this.exceptionDetails = __exceptionDetails;
        this.message = __message;
    }
    /**
     * Create a shallow clone of PUMSUnrecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PUMSUnrecoverableException(obj.exceptionDetails, obj.message);
    }
    static fromJson(data) {
        if (typeof data.__type === "string" && data.__type !== PUMSUnrecoverableException.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(data.__type);
            if (ctor) return ctor.fromJson(data);
            else throw new (0, _serializer.CoralDeserializationTypeError)(data.__type);
        }
        return new PUMSUnrecoverableException((($$val)=>$$val == undefined ? undefined : (0, _exceptionDetails.ExceptionDetails).fromJson($$val))(data.exceptionDetails), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        const __type = data.constructor.fullyQualifiedTypeName;
        if (__type !== PUMSUnrecoverableException.fullyQualifiedTypeName) {
            const ctor = (0, _ihmJsCoralClient.modelRegistrySingleton).getConstructorByTypeName(__type);
            if (ctor) return Object.assign({
                __type: ctor.fullyQualifiedTypeName
            }, ctor.toJson(data));
            else throw new (0, _serializer.CoralSerializationTypeError)(__type);
        }
        return Object.assign({
            exceptionDetails: (($$val)=>$$val == undefined ? null : (0, _exceptionDetails.ExceptionDetails).toJson($$val))(data.exceptionDetails),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PUMSUnrecoverableException.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#PUMSUnrecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PUMSUnrecoverableException);
function validatePumsunrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ExceptionDetails":"7QDtq","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@amzn/ihm-js-coral-client/serializer":"ikaAd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6fPvb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception is thrown if the request is invalid. Clients should not retry on this exception.
 **/ parcelHelpers.export(exports, "PUMSInvalidRequestException", ()=>PUMSInvalidRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PUMSInvalidRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePumsinvalidrequestexception", ()=>validatePumsinvalidrequestexception);
var _exceptionDetails = require("./ExceptionDetails");
var _pumsunrecoverableException = require("./PUMSUnrecoverableException");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class PUMSInvalidRequestException extends (0, _pumsunrecoverableException.PUMSUnrecoverableException) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PUMSInvalidRequestException#clone(obj: PlainObjectFrom<PUMSInvalidRequestException>) method.
     */ /**
     * Create a shallow clone of PUMSInvalidRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PUMSInvalidRequestException(obj.exceptionDetails, obj.message);
    }
    static fromJson(data) {
        return new PUMSInvalidRequestException((($$val)=>$$val == undefined ? undefined : (0, _exceptionDetails.ExceptionDetails).fromJson($$val))(data.exceptionDetails), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            exceptionDetails: (($$val)=>$$val == undefined ? null : (0, _exceptionDetails.ExceptionDetails).toJson($$val))(data.exceptionDetails),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PUMSInvalidRequestException.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#PUMSInvalidRequestException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PUMSInvalidRequestException);
function validatePumsinvalidrequestexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ExceptionDetails":"7QDtq","./PUMSUnrecoverableException":"8Hwtd","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dm3PJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Input needed to resend a invitation.
 **/ parcelHelpers.export(exports, "ResendInvitationRequest", ()=>ResendInvitationRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ResendInvitationRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateResendinvitationrequest", ()=>validateResendinvitationrequest);
var _baseRequest = require("./BaseRequest");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ResendInvitationRequest extends (0, _baseRequest.BaseRequest) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ResendInvitationRequest#clone(obj: PlainObjectFrom<ResendInvitationRequest>) method.
     */ constructor(__invitationId, __customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias){
        super(__customerId, __customerRights, __internalUserAttributes, __logisticsPartyId, __userAlias);
        this.invitationId = __invitationId;
    }
    /**
     * Create a shallow clone of ResendInvitationRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ResendInvitationRequest(obj.invitationId, obj.customerId, obj.customerRights, obj.internalUserAttributes, obj.logisticsPartyId, obj.userAlias);
    }
    static fromJson(data) {
        return new ResendInvitationRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias));
    }
    static toJson(data) {
        return Object.assign({
            invitationId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.invitationId),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            customerRights: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerRights),
            internalUserAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.internalUserAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            userAlias: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userAlias)
        });
    }
}
ResendInvitationRequest.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#ResendInvitationRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ResendInvitationRequest);
function validateResendinvitationrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./BaseRequest":"6LRnc","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bm76L":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This exception indicates that there was a fault at the PassportUserManagementService side and can be retried for
 * successful execution.
 **/ parcelHelpers.export(exports, "PUMSRecoverableException", ()=>PUMSRecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [PUMSRecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validatePumsrecoverableexception", ()=>validatePumsrecoverableexception);
var _exceptionDetails = require("./ExceptionDetails");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class PUMSRecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the PUMSRecoverableException#clone(obj: PlainObjectFrom<PUMSRecoverableException>) method.
     */ constructor(__exceptionDetails, __message){
        super();
        this.exceptionDetails = __exceptionDetails;
        this.message = __message;
    }
    /**
     * Create a shallow clone of PUMSRecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new PUMSRecoverableException(obj.exceptionDetails, obj.message);
    }
    static fromJson(data) {
        return new PUMSRecoverableException((($$val)=>$$val == undefined ? undefined : (0, _exceptionDetails.ExceptionDetails).fromJson($$val))(data.exceptionDetails), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            exceptionDetails: (($$val)=>$$val == undefined ? null : (0, _exceptionDetails.ExceptionDetails).toJson($$val))(data.exceptionDetails),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
PUMSRecoverableException.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#PUMSRecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(PUMSRecoverableException);
function validatePumsrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ExceptionDetails":"7QDtq","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"28Kz3":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns updated user profile information for a given user identifier.
 **/ parcelHelpers.export(exports, "UpdateUserProfileInfoResponse", ()=>UpdateUserProfileInfoResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UpdateUserProfileInfoResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUpdateuserprofileinforesponse", ()=>validateUpdateuserprofileinforesponse);
var _user = require("./User");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UpdateUserProfileInfoResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UpdateUserProfileInfoResponse#clone(obj: PlainObjectFrom<UpdateUserProfileInfoResponse>) method.
     */ constructor(__user){
        super();
        this.user = __user;
    }
    /**
     * Create a shallow clone of UpdateUserProfileInfoResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UpdateUserProfileInfoResponse(obj.user);
    }
    static fromJson(data) {
        return new UpdateUserProfileInfoResponse((0, _user.User).fromJson(data.user));
    }
    static toJson(data) {
        return Object.assign({
            user: (0, _user.User).toJson(data.user)
        });
    }
}
UpdateUserProfileInfoResponse.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#UpdateUserProfileInfoResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpdateUserProfileInfoResponse);
function validateUpdateuserprofileinforesponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./User":"1oWxo","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5R2if":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Emits required cors headers and redirect location for the incoming request of UserAuth Api
 * allowedOrigin - Origins that are allow listed for cross origin resource sharing.
 * allowedMethod - Http Methods that are allow listed for cross origin resource sharing.
 * allowedHeader - Http headers that are allow listed for cross origin resource sharing.
 * location - Redirect location for the client to support http 302 status
 **/ parcelHelpers.export(exports, "UserAuthOutput", ()=>UserAuthOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UserAuthOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUserauthoutput", ()=>validateUserauthoutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UserAuthOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UserAuthOutput#clone(obj: PlainObjectFrom<UserAuthOutput>) method.
     */ constructor(__allowedHeader, __allowedMethod, __allowedOrigin, __httpStatus, __location){
        super();
        this.allowedHeader = __allowedHeader;
        this.allowedMethod = __allowedMethod;
        this.allowedOrigin = __allowedOrigin;
        this.httpStatus = __httpStatus;
        this.location = __location;
    }
    /**
     * Create a shallow clone of UserAuthOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UserAuthOutput(obj.allowedHeader, obj.allowedMethod, obj.allowedOrigin, obj.httpStatus, obj.location);
    }
    static fromJson(data) {
        return new UserAuthOutput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.allowedHeader), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.allowedMethod), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.allowedOrigin), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.httpStatus), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.location));
    }
    static toJson(data) {
        return Object.assign({
            allowedHeader: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.allowedHeader),
            allowedMethod: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.allowedMethod),
            allowedOrigin: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.allowedOrigin),
            httpStatus: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.httpStatus),
            location: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.location)
        });
    }
}
UserAuthOutput.fullyQualifiedTypeName = "com.amazon.passportusermanagementservice#UserAuthOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UserAuthOutput);
function validateUserauthoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kyolR":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeZone", ()=>TimeZone);
var TimeZone;
(function(TimeZone) {
    TimeZone["UTC"] = "UTC";
})(TimeZone || (TimeZone = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLvW3":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * Status of the user deactivation.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserDeactivationStatus", ()=>UserDeactivationStatus);
var UserDeactivationStatus;
(function(UserDeactivationStatus) {
    UserDeactivationStatus["COMPLETED"] = "COMPLETED";
    UserDeactivationStatus["NO_DATA"] = "NO_DATA";
})(UserDeactivationStatus || (UserDeactivationStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"avKdE":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * User deactivation initiator type.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserDeactivationType", ()=>UserDeactivationType);
var UserDeactivationType;
(function(UserDeactivationType) {
    UserDeactivationType["CL_ADMIN_INITIATED"] = "CL_ADMIN_INITIATED";
    UserDeactivationType["PASSPORT_ADMIN_INITIATED"] = "PASSPORT_ADMIN_INITIATED";
    UserDeactivationType["SANDFIRE_INITIATED"] = "SANDFIRE_INITIATED";
    UserDeactivationType["PNS_HARD_BOUNCE_INITIATED"] = "PNS_HARD_BOUNCE_INITIATED";
})(UserDeactivationType || (UserDeactivationType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2I7V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "confirmInvitationEpic", ()=>confirmInvitationEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _error = require("../../../constants/error");
var confirmInvitationEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.CONFIRM_INVITATION_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.confirmInvitation(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            var ref;
            return (0, _rxjs.of)((0, _userManagementActions.confirmInvitation).success(response.invitationStatus), (0, _userManagementActions.getInvitedUsersForLogisticsParty).request({
                logisticsPartyId: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.logisticsPartyId
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.CONFIRM_INVITATION_SUCCESS),
                body: "confirm_invitation_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? (0, _error.errorBodyForCodeMap)[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return (0, _rxjs.of)((0, _userManagementActions.confirmInvitation).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.CONFIRM_INVITATION_FAILURE),
                body: errBody || "confirm_invitation_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = confirmInvitationEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../constants/error":"3yLbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dLMoy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvitationEpic", ()=>createInvitationEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _error = require("../../../constants/error");
var createInvitationEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.CREATE_INVITATION_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.createInvitation(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            var ref;
            return (0, _rxjs.of)((0, _userManagementActions.createInvitation).success(response.invitationId), (0, _userManagementActions.getInvitedUsersForLogisticsParty).request({
                logisticsPartyId: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.logisticsPartyId
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.CREATE_INVITATION_SUCCESS),
                body: "create_invitation_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? (0, _error.errorBodyForCodeMap)[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return (0, _rxjs.of)((0, _userManagementActions.createInvitation).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.CREATE_INVITATION_FAILURE),
                body: errBody || "create_invitation_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = createInvitationEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../constants/error":"3yLbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ioFZy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deactivateUserEpic", ()=>deactivateUserEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _error = require("../../../constants/error");
var deactivateUserEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.DEACTIVATE_USER_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.deactivateUser(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            var ref;
            return (0, _rxjs.of)((0, _userManagementActions.deactivateUser).success(response), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.DEACTIVATE_USER_SUCCESS),
                body: "deactivate_user_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }), (0, _ui.closeDeactivateUserModal)(), (0, _userManagementActions.getUsersForLogisticsParty).request({
                logisticsPartyId: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.logisticsPartyId
            }));
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? (0, _error.deactivateUserErrorCodes)[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return (0, _rxjs.of)((0, _userManagementActions.deactivateUser).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.DEACTIVATE_USER_FAILURE),
                body: errBody || "deactivate_user_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = deactivateUserEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../constants/error":"3yLbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iQeX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteInvitationEpic", ()=>deleteInvitationEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _error = require("../../../constants/error");
var deleteInvitationEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.DELETE_INVITATION_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.deleteInvitation(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            var ref;
            return (0, _rxjs.of)((0, _userManagementActions.deleteInvitation).success(response.invitationStatus), (0, _userManagementActions.getInvitedUsersForLogisticsParty).request({
                logisticsPartyId: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.logisticsPartyId
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.DELETE_INVITATION_SUCCESS),
                body: "delete_invitation_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? (0, _error.errorBodyForCodeMap)[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return (0, _rxjs.of)((0, _userManagementActions.deleteInvitation).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.DELETE_INVITATION_FAILURE),
                body: errBody || "delete_invitation_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = deleteInvitationEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../constants/error":"3yLbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9dT6r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchRequestedUserDetailsEpic", ()=>fetchRequestedUserDetailsEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var fetchRequestedUserDetailsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.FETCH_USER_DETAILS_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.fetchRequestedUserDetails(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.fetchUserDetailsAction).success({
                requestedUserId: action.payload.requestedUserId,
                requestedUserDetails: response.user
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _userManagementActions.fetchUserDetailsAction).failure({
                requestedUserId: action.payload.requestedUserId
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.FETCH_USER_DETAILS_FAILURE),
                body: "fetch_user_details.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = fetchRequestedUserDetailsEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqrev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDeactivatedUsersEpic", ()=>getDeactivatedUsersEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _userManagementActions = require("../../../actions/userManagementActions");
var getDeactivatedUsersEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_DEACTIVATED_USERS_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.getDeactivatedUsers(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.getDeactivatedUsers).success(response));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _userManagementActions.getDeactivatedUsers).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.GET_DEACTIVATED_USERS_FAILURE),
                body: "get_deactivated_users_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = getDeactivatedUsersEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/userManagementActions":"fIUa9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nwfA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInvitedUsersForLogisticsPartyEpic", ()=>getInvitedUsersForLogisticsPartyEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var getInvitedUsersForLogisticsPartyEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_INVITED_USERS_FOR_LOGISTICS_PARTY_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.getInvitedUsersForLogisticsParty(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.getInvitedUsersForLogisticsParty).success(response.invitedUserList));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _userManagementActions.getInvitedUsersForLogisticsParty).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.GET_INVITED_USERS_FOR_LOGISTICS_PARTY_FAILURE),
                body: "get_users_logistics_party_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = getInvitedUsersForLogisticsPartyEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lBTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserProfileInfoEpic", ()=>getUserProfileInfoEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _routes = require("../../../routes");
var getUserProfileInfoEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_USER_PROFILE_INFO_ACTIONS_REQUEST)), (0, _operators.switchMap)(function(action) {
        var history = action.payload.history;
        return (0, _rxjs.from)(api.userManagementServices.getUserProfileInfo().pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.getUserProfileInfo).success(response.user));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _userManagementActions.getUserProfileInfo).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.GET_USER_PROFILE_INFO_ACTIONS_FAILURE),
                body: "get_user_profile_info_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }), (0, _ui.pushRoute)(history, (0, _routes.HOME), (0, _types.DEFAULT_ROUTE_CHANGE_TIMEOUT)));
        })));
    }));
};
exports.default = getUserProfileInfoEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../routes":"gLiUu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gLiUu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HOME", ()=>HOME);
parcelHelpers.export(exports, "profileBasePath", ()=>profileBasePath);
parcelHelpers.export(exports, "pageRoutes", ()=>pageRoutes);
parcelHelpers.export(exports, "invitationBasePath", ()=>invitationBasePath);
parcelHelpers.export(exports, "acceptInvitation", ()=>acceptInvitation);
parcelHelpers.export(exports, "hashPaths", ()=>hashPaths);
parcelHelpers.export(exports, "PUMS_AUTHENTICATION_PATH", ()=>PUMS_AUTHENTICATION_PATH);
parcelHelpers.export(exports, "PUMS_FEDERATE_REDIRECT_CURRENT_PATH", ()=>PUMS_FEDERATE_REDIRECT_CURRENT_PATH);
parcelHelpers.export(exports, "PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH", ()=>PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH);
parcelHelpers.export(exports, "PUMS_NAV_LINK", ()=>PUMS_NAV_LINK);
parcelHelpers.export(exports, "PUMS_NAV_MANAGE_USERS_PAGE_LINK", ()=>PUMS_NAV_MANAGE_USERS_PAGE_LINK);
parcelHelpers.export(exports, "INTERNAL_LP_DETAILS_PATH", ()=>INTERNAL_LP_DETAILS_PATH);
var _env = require("./config/env");
var HOME = "/";
var profileBasePath = "";
var pageRoutes = {
    PROFILE_PAGE: "".concat(profileBasePath, "/profile/"),
    PROFILE_EDIT: "".concat(profileBasePath, "/profile/edit"),
    MANAGE_USERS_PAGE: "/account/permissions",
    NAME_EDIT_ROUTE: "/name",
    DESIGNATION_EDIT_ROUTE: "/designation",
    MANAGE_PERMISSIONS_PATH: "/account/manage-permissions/",
    VIEW_PROFILE: "".concat(profileBasePath, "/profile/view/:customerId")
};
var invitationBasePath = "/invitation";
var acceptInvitation = "".concat(invitationBasePath, "/accept");
var hashPaths = {
    USERS: "#/overview/users",
    OPEN_INVITATIONS: "#/overview/users/invitations",
    DEACTIVATED_USERS: "#/overview/users/deactivated"
};
var PUMS_AUTHENTICATION_PATH = "user/auth";
var PUMS_FEDERATE_REDIRECT_CURRENT_PATH = "?origin=".concat(window.location.href);
var PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH = "?origin=".concat(window.location.origin + pageRoutes.MANAGE_USERS_PAGE);
var PUMS_NAV_LINK = (0, _env.getAuthEnvUrlForPassport)() + PUMS_AUTHENTICATION_PATH + PUMS_FEDERATE_REDIRECT_CURRENT_PATH;
var PUMS_NAV_MANAGE_USERS_PAGE_LINK = (0, _env.getAuthEnvUrlForPassport)() + PUMS_AUTHENTICATION_PATH + PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH;
var INTERNAL_LP_DETAILS_PATH = "/logisticsProviders/:lpId";

},{"./config/env":"fQSIj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQSIj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAuthEnvUrlForPassport", ()=>getAuthEnvUrlForPassport);
var _coralConfigPassportUserManagementService = require("@amzn/coral-config_passport-user-management-service");
var _endpointConfig = require("./endpointConfig");
var getEnv = function() {
    var url = window.location.href;
    var env;
    if (url.includes((0, _endpointConfig.URL_PREFIXES_DEPRECATED).BETA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_CORAL_CONFIG).BETA_CONFIG_DEPRECATED;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES_DEPRECATED).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_CORAL_CONFIG).GAMMA_CONFIG_DEPRECATED;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES_DEPRECATED).PROD_URL_PREFIX)) env = (0, _endpointConfig.PUMS_CORAL_CONFIG).PROD_CONFIG_DEPRECATED;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_CORAL_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_CORAL_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.PUMS_CORAL_CONFIG).PROD_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).PROD_CONFIG;
    else env = (0, _endpointConfig.PUMS_CORAL_CONFIG).LOCAL_DEV;
    return env;
};
var getAuthEnvUrlForPassport = function() {
    var ref, ref1;
    var url = window.location.href;
    var env;
    if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).PROD_CONFIG;
    else env = (0, _endpointConfig.PUMS_PASSPORT_CORAL_CONFIG).BETA_CONFIG;
    var requiredUrl = (ref = (0, _coralConfigPassportUserManagementService.PassportUserManagementServiceClientConfigFactory).getConfigForQualifier(env)) === null || ref === void 0 ? void 0 : (ref1 = ref.httpEndpoint) === null || ref1 === void 0 ? void 0 : ref1.url;
    return requiredUrl;
};
var isProd = function() {
    var env = getEnv();
    return env === (0, _endpointConfig.PUMS_CORAL_CONFIG).PROD_CONFIG;
};
var envHelper = {
    getEnv: getEnv,
    isProd: isProd
};
exports.default = envHelper;

},{"@amzn/coral-config_passport-user-management-service":"5yzWf","./endpointConfig":"3t4Ox","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5yzWf":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _passportUserManagementServiceClientConfigFactory = require("./PassportUserManagementServiceClientConfigFactory");
parcelHelpers.exportAll(_passportUserManagementServiceClientConfigFactory, exports);

},{"./PassportUserManagementServiceClientConfigFactory":"a1oD7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a1oD7":[function(require,module,exports) {
/* This file was automatically generated by CoralTypeScriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PassportUserManagementServiceClientConfigFactory", ()=>PassportUserManagementServiceClientConfigFactory);
var _client = require("@amzn/ihm-js-coral-client/client");
const PassportUserManagementServiceClientConfigFactory = new (0, _client.CoralClientConfigFactory)("PassportUserManagementService", {
    "Passport.GammaDeprecated.USAmazon": {
        httpEndpoint: {
            url: "https://carrierhub-gamma.aka.amazon.com/"
        }
    },
    "master.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.gamma.pums.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "master.passport.USAmazon": {
        httpEndpoint: {
            url: "https://mons.gamma.passport.transportation.a2z.com/"
        }
    },
    "Base.Beta": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.beta.pums.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Carrierlogistics.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.integ.amazon.com/"
        }
    },
    "Passport.ProdDeprecated.USAmazon": {
        httpEndpoint: {
            url: "https://carrierhub.amazon.com/"
        }
    },
    "masterDeprecated.passport.USAmazon": {
        httpEndpoint: {
            url: "https://carrierhub-gamma.aka.amazon.com/"
        }
    },
    "Passport.BetaDeprecated.USAmazon": {
        httpEndpoint: {
            url: "https://carrierhub.integ.amazon.com/"
        }
    },
    "Carrierlogistics.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.amazon.com/"
        }
    },
    "testDeprecated.passport.USAmazon": {
        httpEndpoint: {
            url: "https://carrierhub.integ.amazon.com/"
        }
    },
    "test.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.beta.pums.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "prod.passport.USAmazon": {
        httpEndpoint: {
            url: "https://mons.prod.passport.transportation.a2z.com/"
        }
    },
    "test.passport.USAmazon": {
        httpEndpoint: {
            url: "https://mons.beta.passport.transportation.a2z.com/"
        }
    },
    "desktop.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "http://localhost:3000/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Passport.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://mons.gamma.passport.transportation.a2z.com/"
        }
    },
    "Base.Development": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "http://localhost:3000/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Gamma": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.gamma.pums.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    Base: {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "prod.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.prod.pums.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Passport.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://mons.beta.passport.transportation.a2z.com/"
        }
    },
    "Passport.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://mons.prod.passport.transportation.a2z.com/"
        }
    },
    "Carrierlogistics.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics-gamma.aka.amazon.com/"
        }
    },
    "prodDeprecated.passport.USAmazon": {
        httpEndpoint: {
            url: "https://carrierhub.amazon.com/"
        }
    },
    "Base.Prod": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 40,
            allIdleTimeout: 55000,
            maxConnectionsPerHost: 20,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.prod.pums.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "PassportUserManagementService/*": 5000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    }
});

},{"@amzn/ihm-js-coral-client/client":"7JSEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3t4Ox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PASSPORT_URL_PREFIXES", ()=>PASSPORT_URL_PREFIXES);
parcelHelpers.export(exports, "URL_PREFIXES_DEPRECATED", ()=>URL_PREFIXES_DEPRECATED);
parcelHelpers.export(exports, "URL_PREFIXES", ()=>URL_PREFIXES);
parcelHelpers.export(exports, "PUMS_CORAL_CONFIG", ()=>PUMS_CORAL_CONFIG);
parcelHelpers.export(exports, "PUMS_PASSPORT_CORAL_CONFIG", ()=>PUMS_PASSPORT_CORAL_CONFIG);
var PASSPORT_URL_PREFIXES = {
    BETA_URL_PREFIX: "beta.passport.transportation",
    GAMMA_URL_PREFIX: "gamma.passport.transportation",
    PROD_URL_PREFIX: "passport.transportation"
};
var URL_PREFIXES_DEPRECATED = {
    BETA_URL_PREFIX: "carrierhub.integ",
    GAMMA_URL_PREFIX: "carrierhub-gamma.aka",
    PROD_URL_PREFIX: "carrierhub.amazon"
};
var URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon"
};
var PUMS_CORAL_CONFIG = {
    // deprecated config will be removed
    BETA_CONFIG_DEPRECATED: "Passport.BetaDeprecated.USAmazon",
    GAMMA_CONFIG_DEPRECATED: "Passport.GammaDeprecated.USAmazon",
    PROD_CONFIG_DEPRECATED: "Passport.ProdDeprecated.USAmazon",
    BETA_CONFIG: "Carrierlogistics.Beta.USAmazon",
    GAMMA_CONFIG: "Carrierlogistics.Gamma.USAmazon",
    PROD_CONFIG: "Carrierlogistics.Prod.USAmazon",
    LOCAL_DEV: "Base.Development"
};
var PUMS_PASSPORT_CORAL_CONFIG = {
    BETA_CONFIG: "Passport.Beta.USAmazon",
    GAMMA_CONFIG: "Passport.Gamma.USAmazon",
    PROD_CONFIG: "Passport.Prod.USAmazon"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01zoK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUsersForLogisticsPartyEpic", ()=>getUsersForLogisticsPartyEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _routes = require("../../../routes");
var _types = require("../../../actions/ui/types");
var _ui = require("../../../actions/ui");
var _error = require("../../../constants/error");
var _isSiteExternal = require("../../../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var getUsersForLogisticsPartyEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _payload = action.payload, _history = _payload.history, history = _history === void 0 ? null : _history, logisticsPartyId = _payload.logisticsPartyId;
        return api.userManagementServices.getUsersForLogisticsParty({
            logisticsPartyId: logisticsPartyId
        }).pipe((0, _operators.map)(function(response) {
            return (0, _userManagementActions.getUsersForLogisticsParty).success(response.userList);
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errorActions = [
                (0, _userManagementActions.getUsersForLogisticsParty).failure(err)
            ];
            // TODO: temporarily kept this error msg fragment to compute if user dont have permission for GetUsersForLogisticsParty
            // Ideally 403 status should be used for unauthorized but currently 500 status is being sent by API
            var isUnauthorized = err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.includes((0, _error.UNAUTHORIZED_ERROR_MSG_FRAGMENT));
            if (history && (0, _isSiteExternalDefault.default)()) errorActions.push((0, _ui.pushRoute)(history, (0, _routes.pageRoutes).PROFILE_PAGE, (0, _types.DEFAULT_ROUTE_CHANGE_TIMEOUT)));
            errorActions.push((0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_FAILURE),
                body: isUnauthorized ? "get_users_logistics_party_notifications.unauthorized" : "get_users_logistics_party_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
            return (0, _rxjs.of).apply(void 0, _toConsumableArray(errorActions));
        }));
    }));
};
exports.default = getUsersForLogisticsPartyEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../routes":"gLiUu","../../../actions/ui/types":"dlLnM","../../../actions/ui":"7wsCu","../../../constants/error":"3yLbD","../../../utils/isSiteExternal":"76p21","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"76p21":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("../constants");
var isSiteExternal = function() {
    var url = window.location.href;
    return url.includes((0, _constants.EXTERNAL_PASSPORT_APP_DOMAIN_NAME));
};
exports.default = isSiteExternal;

},{"../constants":"aOASK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aOASK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_ACCOUNT_ID_PARAM", ()=>GLOBAL_ACCOUNT_ID_PARAM);
parcelHelpers.export(exports, "INVITATION_ID_PARAM", ()=>INVITATION_ID_PARAM);
parcelHelpers.export(exports, "ELLIPSIS", ()=>ELLIPSIS);
parcelHelpers.export(exports, "DATE_FORMAT", ()=>DATE_FORMAT);
parcelHelpers.export(exports, "TIME_FORMAT", ()=>TIME_FORMAT);
parcelHelpers.export(exports, "DATE_TIME_FORMAT", ()=>DATE_TIME_FORMAT);
parcelHelpers.export(exports, "FAILED_TO_FETCH_ERR_MESSAGES", ()=>FAILED_TO_FETCH_ERR_MESSAGES);
parcelHelpers.export(exports, "EXTERNAL_PASSPORT_APP_DOMAIN_NAME", ()=>EXTERNAL_PASSPORT_APP_DOMAIN_NAME);
var GLOBAL_ACCOUNT_ID_PARAM = "globalAccountId";
var INVITATION_ID_PARAM = "invitationId";
var ELLIPSIS = "...";
var DATE_FORMAT = "dd MMM yyyy";
var TIME_FORMAT = "HH:mm";
var DATE_TIME_FORMAT = "".concat(DATE_FORMAT, " ").concat(TIME_FORMAT);
var FAILED_TO_FETCH_ERR_MESSAGES = [
    "Failed to fetch",
    "Load failed",
    "NetworkError when attempting to fetch resource."
];
var EXTERNAL_PASSPORT_APP_DOMAIN_NAME = "carrierlogistics";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4WkuN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resendInvitationEpic", ()=>resendInvitationEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _error = require("../../../constants/error");
var resendInvitationEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.RESEND_INVITATION_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.resendInvitation(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.resendInvitation).success(response.invitationStatus), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.RESEND_INVITATION_SUCCESS),
                body: "resend_invitation_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? (0, _error.errorBodyForCodeMap)[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return (0, _rxjs.of)((0, _userManagementActions.resendInvitation).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.RESEND_INVITATION_FAILURE),
                body: errBody || "resend_invitation_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = resendInvitationEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../constants/error":"3yLbD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFLrM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateUserLocaleEpic", ()=>updateUserLocaleEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var updateUserLocaleEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.UPDATE_USER_LOCALE_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.updateUserProfileInfo(_objectSpread({}, action.payload, {
            monsSelectLocale: action.payload.defaultLocale
        })).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.updateUserLocaleAction).success(response.user));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _userManagementActions.updateUserLocaleAction).failure(err));
        })));
    }));
};
exports.default = updateUserLocaleEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a1Ju1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateUserProfileInfoEpic", ()=>updateUserProfileInfoEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _userManagementActions = require("../../../actions/userManagementActions");
var _actionTypes = require("../../../actions/userManagementActions/actionTypes");
var updateUserProfileInfoEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _actionTypes.UPDATE_USER_PROFILE_INFO_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.userManagementServices.updateUserProfileInfo(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _userManagementActions.updateUserProfileInfo).success(response.user), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _actionTypes.UPDATE_USER_PROFILE_INFO_SUCCESS),
                body: "update_user_profile_info_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _userManagementActions.updateUserProfileInfo).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _actionTypes.UPDATE_USER_PROFILE_INFO_FAILURE),
                body: "update_user_profile_info_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = updateUserProfileInfoEpic;

},{"redux-observable":"1ybGk","rxjs":"ctXY8","rxjs/operators":"eRfPW","../../../actions/ui":"7wsCu","../../../actions/ui/types":"dlLnM","../../../actions/userManagementActions":"fIUa9","../../../actions/userManagementActions/actionTypes":"bnUpG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNNSY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiLoadingEpic", ()=>apiLoadingEpic);
var _operators = require("rxjs/operators");
var _ui = require("../actions/ui");
var _apiLoading = require("../utils/apiLoading");
var _apiLoading1 = require("../constants/apiLoading");
var apiLoadingEpic = function(action$) {
    return action$.pipe((0, _operators.filter)(function(action) {
        return (0, _apiLoading1.requestFlowActionsRegex).test(action.type);
    }), (0, _operators.map)(function(action) {
        var type = action.type;
        var isRequestBeingSent = (0, _apiLoading1.requestActionRegex).test(type);
        var call = (0, _apiLoading.getCall)(type);
        if (isRequestBeingSent) return (0, _ui.startRequestLoading)(call);
        return (0, _ui.endRequestLoading)(call);
    }));
};
exports.default = apiLoadingEpic;

},{"rxjs/operators":"eRfPW","../actions/ui":"7wsCu","../utils/apiLoading":"7cP5m","../constants/apiLoading":"hIENn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cP5m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get the name of the call being made.
 * Replace /(_REQUEST|_SUCCESS|_FAILURE)$/ with empty string
 *
 * @param {string} action
 * @returns {string}
 */ parcelHelpers.export(exports, "getCall", ()=>getCall);
var _apiLoading = require("../constants/apiLoading");
function getCall(action) {
    return action.replace((0, _apiLoading.requestFlowActionsRegex), "");
}
exports.default = {
    getCall: getCall
};

},{"../constants/apiLoading":"hIENn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hIENn":[function(require,module,exports) {
// To match strings ending with REQUEST | SUCCESS | FAILURE
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestFlowActionsRegex", ()=>requestFlowActionsRegex);
parcelHelpers.export(exports, "requestActionRegex", ()=>requestActionRegex);
parcelHelpers.export(exports, "SEARCH_USER_API_DEBOUNCE_MS", ()=>SEARCH_USER_API_DEBOUNCE_MS);
var requestFlowActionsRegex = /(_REQUEST|_SUCCESS|_FAILURE)$/;
var requestActionRegex = /_REQUEST$/;
var SEARCH_USER_API_DEBOUNCE_MS = 500;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8vao":[function(require,module,exports) {
/*
 * Root reducer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _ui = require("./ui");
var _uiDefault = parcelHelpers.interopDefault(_ui);
var _userManagementReducer = require("./userManagementReducer");
var rootReducer = (0, _redux.combineReducers)({
    userManagement: (0, _userManagementReducer.userManagementReducer),
    ui: (0, _uiDefault.default)
});
exports.default = rootReducer;

},{"redux":"8WK1P","./ui":"2Spgd","./userManagementReducer":"jv1j7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Spgd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>ui);
var _lodash = require("lodash");
var _types = require("../../actions/ui/types");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var initialState = {
    loading: false,
    pendingRequests: [],
    notifications: [],
    deactivateUserModal: {
        isOpen: false,
        userToDeactivate: null
    }
};
function ui() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 0, _types.ADD_NOTIFICATION:
            return _objectSpread({}, state, {
                notifications: _toConsumableArray(state.notifications).concat([
                    action.payload
                ])
            });
        case 0, _types.CLOSE_NOTIFICATION:
            return _objectSpread({}, state, {
                notifications: state.notifications.filter(function(param) {
                    var id = param.id;
                    return id !== action.payload;
                })
            });
        case 0, _types.START_REQUEST_LOADING:
            return _objectSpread({}, state, {
                pendingRequests: (0, _lodash.uniq)(_toConsumableArray(state.pendingRequests).concat([
                    action.payload
                ]))
            });
        case 0, _types.END_REQUEST_LOADING:
            return _objectSpread({}, state, {
                pendingRequests: state.pendingRequests.filter(function(call) {
                    return call !== action.payload;
                })
            });
        case 0, _types.OPEN_DEACTIVATE_USERS_MODAL:
            return _objectSpread({}, state, {
                deactivateUserModal: {
                    isOpen: true,
                    userToDeactivate: action.payload
                }
            });
        case 0, _types.CLOSE_DEACTIVATE_USERS_MODAL:
            return _objectSpread({}, state, {
                deactivateUserModal: {
                    isOpen: false,
                    userToDeactivate: null
                }
            });
        default:
            return state;
    }
}

},{"lodash":"6tRyo","../../actions/ui/types":"dlLnM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6tRyo":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"jv1j7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "userManagementReducer", ()=>userManagementReducer);
/* eslint-disable import/prefer-default-export */ var _actionTypes = require("../../actions/userManagementActions/actionTypes");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var initialState = {
    user: {},
    invitationStatus: {
        status: "",
        error: false
    },
    requestedUserProfileDetails: {},
    usersList: [],
    usersListError: false,
    invitationsList: [],
    createInvitationSuccess: false,
    deactivatedUsersList: null
};
function userManagementReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, ref2 = arguments.length > 1 ? arguments[1] : void 0, type = ref2.type, payload = ref2.payload;
    switch(type){
        case 0, _actionTypes.GET_USER_PROFILE_INFO_ACTIONS_SUCCESS:
            return _objectSpread({}, state, {
                user: payload.user
            });
        case 0, _actionTypes.UPDATE_USER_PROFILE_INFO_SUCCESS:
        case 0, _actionTypes.UPDATE_USER_LOCALE_SUCCESS:
            return _objectSpread({}, state, {
                user: payload
            });
        case 0, _actionTypes.ACCEPT_INVITATION_SUCCESS:
            return _objectSpread({}, state, {
                invitationStatus: {
                    status: payload,
                    error: false
                }
            });
        case 0, _actionTypes.ACCEPT_INVITATION_FAILURE:
            return _objectSpread({}, state, {
                invitationStatus: {
                    status: "",
                    error: true
                }
            });
        case 0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_REQUEST:
            return _objectSpread({}, state, {
                usersListError: false
            });
        case 0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS:
            return _objectSpread({}, state, {
                usersList: payload || []
            });
        case 0, _actionTypes.GET_USERS_FOR_LOGISTICS_PARTY_FAILURE:
            return _objectSpread({}, state, {
                usersListError: true
            });
        case 0, _actionTypes.GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS:
            var ref1;
            return _objectSpread({}, state, {
                invitationsList: (payload === null || payload === void 0 ? void 0 : payload.length) ? payload.map(function(invitation) {
                    var ref;
                    return _objectSpread({}, invitation, {
                        inviteeEmail: (ref1 = invitation === null || invitation === void 0 ? void 0 : (ref = invitation.invitationChannelInfo) === null || ref === void 0 ? void 0 : ref.inviteeEmail) !== null && ref1 !== void 0 ? ref1 : ""
                    });
                }) : []
            });
        case 0, _actionTypes.CREATE_INVITATION_SUCCESS:
            return _objectSpread({}, state, {
                createInvitationSuccess: true
            });
        case 0, _actionTypes.CREATE_INVITATION_SUCCESS_RESET:
            return _objectSpread({}, state, {
                createInvitationSuccess: false
            });
        case 0, _actionTypes.DEACTIVATE_USER_SUCCESS:
            return _objectSpread({}, state, {
                deactivatedUsersList: null,
                usersList: null
            });
        case 0, _actionTypes.GET_DEACTIVATED_USERS_SUCCESS:
            return _objectSpread({}, state, {
                deactivatedUsersList: payload.userList
            });
        case 0, _actionTypes.GET_DEACTIVATED_USERS_FAILURE:
            return _objectSpread({}, state, {
                deactivatedUsersList: undefined
            });
        case 0, _actionTypes.FETCH_USER_DETAILS_SUCCESS:
            var requestedUserId = payload.requestedUserId, requestedUserDetails = payload.requestedUserDetails;
            return _objectSpread({}, state, {
                requestedUserProfileDetails: _objectSpread({}, state.requestedUserProfileDetails, _defineProperty({}, requestedUserId, requestedUserDetails))
            });
        case 0, _actionTypes.FETCH_USER_DETAILS_FAILURE:
            var requestedUserId1 = payload.requestedUserId;
            return _objectSpread({}, state, {
                requestedUserProfileDetails: _objectSpread({}, state.requestedUserProfileDetails, _defineProperty({}, requestedUserId1, {}))
            });
        default:
            return state;
    }
}

},{"../../actions/userManagementActions/actionTypes":"bnUpG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9YUe1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _userManagementService = require("./userManagementService");
exports.default = {
    api: {
        userManagementServices: _userManagementService
    }
};

},{"./userManagementService":"cnnQO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cnnQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserProfileInfo", ()=>getUserProfileInfo);
parcelHelpers.export(exports, "updateUserProfileInfo", ()=>updateUserProfileInfo);
parcelHelpers.export(exports, "acceptInvitation", ()=>acceptInvitation);
parcelHelpers.export(exports, "createInvitation", ()=>createInvitation);
parcelHelpers.export(exports, "resendInvitation", ()=>resendInvitation);
parcelHelpers.export(exports, "deleteInvitation", ()=>deleteInvitation);
parcelHelpers.export(exports, "confirmInvitation", ()=>confirmInvitation);
parcelHelpers.export(exports, "getUsersForLogisticsParty", ()=>getUsersForLogisticsParty);
parcelHelpers.export(exports, "getInvitedUsersForLogisticsParty", ()=>getInvitedUsersForLogisticsParty);
parcelHelpers.export(exports, "deactivateUser", ()=>deactivateUser);
parcelHelpers.export(exports, "getDeactivatedUsers", ()=>getDeactivatedUsers);
parcelHelpers.export(exports, "fetchRequestedUserDetails", ()=>fetchRequestedUserDetails);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _passportUserManagementServiceClient = require("../../clients/PassportUserManagementServiceClient");
var _passportUserManagementServiceClientDefault = parcelHelpers.interopDefault(_passportUserManagementServiceClient);
var _env = require("../../config/env");
var _envDefault = parcelHelpers.interopDefault(_env);
var _isSiteExternal = require("../../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var isExternal = (0, _isSiteExternalDefault.default)();
function getUserProfileInfo() {
    var getUserProfileInfoInput = (0, _coralComAmazonPassportusermanagementservice.GetUserProfileInfoRequest).clone({});
    return (0, _passportUserManagementServiceClientDefault.default).getUserProfileInfo(getUserProfileInfoInput);
}
function updateUserProfileInfo(param) {
    var userIdentifier = param.userIdentifier, designation = param.designation, email = param.email, fullName = param.fullName, textPhoneNumber = param.textPhoneNumber, auditVersion = param.auditVersion, defaultLocale = param.defaultLocale, monsSelectLocale = param.monsSelectLocale;
    var user = (0, _coralComAmazonPassportusermanagementservice.User).clone(_objectSpread({
        userIdentifier: userIdentifier,
        designation: designation,
        email: email,
        fullName: fullName,
        textPhoneNumber: textPhoneNumber,
        auditVersion: auditVersion
    }, defaultLocale ? {
        defaultLocale: defaultLocale
    } : {}));
    var updateUserProfileInfoRequest = (0, _coralComAmazonPassportusermanagementservice.UpdateUserProfileInfoRequest).clone(_objectSpread({
        user: user
    }, {
        monsSelectLocale: monsSelectLocale
    }));
    return (0, _passportUserManagementServiceClientDefault.default).updateUserProfileInfo(updateUserProfileInfoRequest);
}
function acceptInvitation(request) {
    return (0, _passportUserManagementServiceClientDefault.default).acceptInvitation(request);
}
function createInvitation(param) {
    var invitationChannelInfo = param.invitationChannelInfo, locale = param.locale, requestedPermissionsList = param.requestedPermissionsList, logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).createInvitation((0, _coralComAmazonPassportusermanagementservice.CreateInvitationRequest).clone(_objectSpread({
        invitationChannelInfo: invitationChannelInfo,
        locale: locale,
        requestedPermissionsList: requestedPermissionsList
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function resendInvitation(param) {
    var invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).resendInvitation((0, _coralComAmazonPassportusermanagementservice.ResendInvitationRequest).clone(_objectSpread({
        invitationId: invitationId
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function deleteInvitation(param) {
    var invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).deleteInvitation((0, _coralComAmazonPassportusermanagementservice.DeleteInvitationRequest).clone(_objectSpread({
        invitationId: invitationId
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function confirmInvitation(param) {
    var invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).confirmInvitation((0, _coralComAmazonPassportusermanagementservice.ConfirmInvitationRequest).clone(_objectSpread({
        invitationId: invitationId
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function getUsersForLogisticsParty(param) {
    var logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).getUsersForLogisticsParty((0, _coralComAmazonPassportusermanagementservice.GetUsersForLogisticsPartyRequest).clone(_objectSpread({
        fetchInternalUsers: !(0, _envDefault.default).isProd()
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function getInvitedUsersForLogisticsParty(param) {
    var logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).getInvitedUsersForLogisticsParty((0, _coralComAmazonPassportusermanagementservice.GetInvitedUsersForLogisticsPartyRequest).clone(_objectSpread({}, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function deactivateUser(deactivateUserRequest) {
    return (0, _passportUserManagementServiceClientDefault.default).deactivateUser(deactivateUserRequest);
}
function getDeactivatedUsers(param) {
    var logisticsPartyId = param.logisticsPartyId;
    return (0, _passportUserManagementServiceClientDefault.default).getDeactivatedUsers((0, _coralComAmazonPassportusermanagementservice.GetDeactivatedUsersRequest).clone(_objectSpread({
        fetchInternalUsers: !(0, _envDefault.default).isProd()
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
function fetchRequestedUserDetails(param) {
    var requestedUserId = param.requestedUserId;
    return (0, _passportUserManagementServiceClientDefault.default).getRequestedUserProfileInfo((0, _coralComAmazonPassportusermanagementservice.GetRequestedUserProfileInfoRequest).clone({
        requestedUserId: requestedUserId
    }));
}

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","../../clients/PassportUserManagementServiceClient":"gacPC","../../config/env":"fQSIj","../../utils/isSiteExternal":"76p21","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gacPC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralConfigPassportUserManagementService = require("@amzn/coral-config_passport-user-management-service");
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _env = require("../config/env");
var _envDefault = parcelHelpers.interopDefault(_env);
var _acceptInvitationRequest = require("../models/AcceptInvitationRequest");
var _acceptInvitationRequestDefault = parcelHelpers.interopDefault(_acceptInvitationRequest);
var _createInvitationRequest = require("../models/CreateInvitationRequest");
var _createInvitationRequestDefault = parcelHelpers.interopDefault(_createInvitationRequest);
var _getDeactivatedUsersResponse = require("../models/GetDeactivatedUsersResponse");
var _getDeactivatedUsersResponseDefault = parcelHelpers.interopDefault(_getDeactivatedUsersResponse);
var _getInvitedUsersForLogisticsPartyResponse = require("../models/GetInvitedUsersForLogisticsPartyResponse");
var _getInvitedUsersForLogisticsPartyResponseDefault = parcelHelpers.interopDefault(_getInvitedUsersForLogisticsPartyResponse);
var _getRequestedUserProfileInfoResponse = require("../models/GetRequestedUserProfileInfoResponse");
var _getRequestedUserProfileInfoResponseDefault = parcelHelpers.interopDefault(_getRequestedUserProfileInfoResponse);
var _getUserProfileInfoResponse = require("../models/GetUserProfileInfoResponse");
var _getUserProfileInfoResponseDefault = parcelHelpers.interopDefault(_getUserProfileInfoResponse);
var _getUsersForLogisticsPartyResponse = require("../models/GetUsersForLogisticsPartyResponse");
var _getUsersForLogisticsPartyResponseDefault = parcelHelpers.interopDefault(_getUsersForLogisticsPartyResponse);
var _updateUserProfileInfoRequest = require("../models/UpdateUserProfileInfoRequest");
var _updateUserProfileInfoRequestDefault = parcelHelpers.interopDefault(_updateUserProfileInfoRequest);
var _updateUserProfileInfoResponse = require("../models/UpdateUserProfileInfoResponse");
var _updateUserProfileInfoResponseDefault = parcelHelpers.interopDefault(_updateUserProfileInfoResponse);
var _isSiteExternal = require("../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
var _passportRequestOptionsInterceptor = require("./PassportRequestOptionsInterceptor");
var _passportRequestOptionsInterceptorDefault = parcelHelpers.interopDefault(_passportRequestOptionsInterceptor);
var _requestOptionsInterceptor = require("./RequestOptionsInterceptor");
var _requestOptionsInterceptorDefault = parcelHelpers.interopDefault(_requestOptionsInterceptor);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
var clientFactory = new (0, _ihmJsCoralClient.CoralClientFactory)([
    (0, _coralConfigPassportUserManagementService.PassportUserManagementServiceClientConfigFactory)
], (0, _envDefault.default).getEnv(), new (0, _ihmJsCoralClient.InterceptingHandler)(new (0, _ihmJsCoralClient.CoralFetchHandler)(), [
    (0, _coralComAmazonPassportusermanagementservice.passportUserManagementServiceHttpBindingInterceptor),
    (0, _isSiteExternalDefault.default)() ? new (0, _requestOptionsInterceptorDefault.default)() : new (0, _passportRequestOptionsInterceptorDefault.default)()
]));
/**
 * Custom web server to override serialization/deserialization
 */ var CustomWebServer = /*#__PURE__*/ function(PassportUserManagementService1) {
    "use strict";
    _inherits(CustomWebServer, PassportUserManagementService1);
    var _super = _createSuper(CustomWebServer);
    function CustomWebServer(config, handler) {
        _classCallCheck(this, CustomWebServer);
        var _this;
        _this = _super.call(this, config, handler);
        _this.handler.handlerChain.interceptor.operations.GetUserProfileInfo.deserializationFn = (0, _getUserProfileInfoResponseDefault.default).fromJson;
        _this.handler.handlerChain.interceptor.operations.UpdateUserProfileInfo.serializationFn = (0, _updateUserProfileInfoRequestDefault.default).toJson;
        // to handle inheritacne in coral models
        _this.handler.handlerChain.interceptor.operations.UpdateUserProfileInfo.deserializationFn = (0, _updateUserProfileInfoResponseDefault.default).fromJson;
        _this.handler.handlerChain.interceptor.operations.AcceptInvitation.serializationFn = (0, _acceptInvitationRequestDefault.default).toJson;
        _this.handler.handlerChain.interceptor.operations.GetUsersForLogisticsParty.deserializationFn = (0, _getUsersForLogisticsPartyResponseDefault.default).fromJson;
        _this.handler.handlerChain.interceptor.operations.GetInvitedUsersForLogisticsParty.deserializationFn = (0, _getInvitedUsersForLogisticsPartyResponseDefault.default).fromJson;
        _this.handler.handlerChain.interceptor.operations.CreateInvitation.serializationFn = (0, _createInvitationRequestDefault.default).toJson;
        _this.handler.handlerChain.interceptor.operations.GetDeactivatedUsers.deserializationFn = (0, _getDeactivatedUsersResponseDefault.default).fromJson;
        _this.handler.handlerChain.interceptor.operations.GetRequestedUserProfileInfo.deserializationFn = (0, _getRequestedUserProfileInfoResponseDefault.default).fromJson;
        return _this;
    }
    return CustomWebServer;
}((0, _coralComAmazonPassportusermanagementservice.PassportUserManagementService));
var passportUserManagementServiceClient = clientFactory.get(CustomWebServer);
exports.default = passportUserManagementServiceClient;

},{"@amzn/coral-config_passport-user-management-service":"5yzWf","@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../config/env":"fQSIj","../models/AcceptInvitationRequest":"5ZMK9","../models/CreateInvitationRequest":"kvC2B","../models/GetDeactivatedUsersResponse":"1BH3X","../models/GetInvitedUsersForLogisticsPartyResponse":"adSST","../models/GetRequestedUserProfileInfoResponse":"gYa9P","../models/GetUserProfileInfoResponse":"72U9w","../models/GetUsersForLogisticsPartyResponse":"8W6Fb","../models/UpdateUserProfileInfoRequest":"gjaRn","../models/UpdateUserProfileInfoResponse":"gntNZ","../utils/isSiteExternal":"76p21","./PassportRequestOptionsInterceptor":"l16jW","./RequestOptionsInterceptor":"jbU1l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ZMK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var AcceptInvitationRequest = /*#__PURE__*/ function(AcceptInvitationRequestCore1) {
    "use strict";
    _inherits(AcceptInvitationRequest, AcceptInvitationRequestCore1);
    var _super = _createSuper(AcceptInvitationRequest);
    function AcceptInvitationRequest() {
        _classCallCheck(this, AcceptInvitationRequest);
        return _super.apply(this, arguments);
    }
    AcceptInvitationRequest.clone = function clone(param) {
        var lpId = param.lpId, invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
        return {
            logisticsPartyId: logisticsPartyId,
            lpId: lpId,
            invitationId: invitationId
        };
    };
    AcceptInvitationRequest.toJson = function toJson(param) {
        var lpId = param.lpId, invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
        return AcceptInvitationRequest.clone({
            logisticsPartyId: logisticsPartyId,
            lpId: lpId,
            invitationId: invitationId
        });
    };
    return AcceptInvitationRequest;
}((0, _coralComAmazonPassportusermanagementservice.AcceptInvitationRequest));
AcceptInvitationRequest.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).AcceptInvitationRequest;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AcceptInvitationRequest);
exports.default = AcceptInvitationRequest;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"52IAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FULLY_QUALIFIED_TYPE_NAMES", ()=>FULLY_QUALIFIED_TYPE_NAMES);
var FULLY_QUALIFIED_TYPE_NAMES = {
    GetUserProfileInfoResponse: "com.amazon.passportusermanagementservice#GetUserProfileInfoResponse",
    UserIdentifier: "com.amazon.passportusermanagementservice#ExternalCustomerIdentifier",
    UpdateUserProfileInfoRequest: "com.amazon.passportusermanagementservice#UpdateUserProfileInfoRequest",
    UpdateUserProfileInfoResponse: "com.amazon.passportusermanagementservice#UpdateUserProfileInfoResponse",
    AcceptInvitationRequest: "com.amazon.passportusermanagementservice#AcceptInvitationRequest",
    GetInvitedUsersForLogisticsPartyResponse: "com.amazon.passportusermanagementservice#GetInvitedUsersForLogisticsPartyResponse",
    GetUsersForLogisticsPartyResponse: "com.amazon.passportusermanagementservice#GetUsersForLogisticsPartyResponse",
    CreateInvitationRequest: "com.amazon.passportusermanagementservice#CreateInvitationRequest",
    EmailInvitationChannelInfo: "EmailInvitationChannelInfo:http://internal.amazon.com/coral/com.amazon.passportusermanagementservice/",
    GetDeactivatedUsers: "com.amazon.passportusermanagementservice#GetDeactivatedUsersResponse",
    GetRequestedUserProfileInfoResponse: "com.amazon.passportusermanagementservice#GetRequestedUserProfileInfoResponse"
};
exports.default = FULLY_QUALIFIED_TYPE_NAMES;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kvC2B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var CreateInvitationRequest = /*#__PURE__*/ function(CreateInvitationRequestCore1) {
    "use strict";
    _inherits(CreateInvitationRequest, CreateInvitationRequestCore1);
    var _super = _createSuper(CreateInvitationRequest);
    function CreateInvitationRequest() {
        _classCallCheck(this, CreateInvitationRequest);
        return _super.apply(this, arguments);
    }
    CreateInvitationRequest.toJson = function toJson(param) {
        var invitationChannelInfo = param.invitationChannelInfo, locale = param.locale, requestedPermissionsList = param.requestedPermissionsList, logisticsPartyId = param.logisticsPartyId;
        var ref3, ref1, ref2;
        return new CreateInvitationRequest(_objectSpread({}, invitationChannelInfo, {
            __type: (0, _coralOperationTypesDefault.default).EmailInvitationChannelInfo
        }), locale, null, null, null, logisticsPartyId, (ref2 = requestedPermissionsList === null || requestedPermissionsList === void 0 ? void 0 : requestedPermissionsList.map(function(requestedPermissions) {
            var ref5;
            return _objectSpread({}, requestedPermissions ? _objectSpread({}, requestedPermissions, {
                permissionKeyList: (ref1 = requestedPermissions === null || requestedPermissions === void 0 ? void 0 : (ref5 = requestedPermissions.permissionKeyList) === null || ref5 === void 0 ? void 0 : ref5.map(function(permissionKey) {
                    var ref, ref4;
                    return _objectSpread({}, permissionKey, {
                        __type: (ref3 = (ref = Object.getPrototypeOf(permissionKey)) === null || ref === void 0 ? void 0 : (ref4 = ref.constructor) === null || ref4 === void 0 ? void 0 : ref4.fullyQualifiedTypeName) !== null && ref3 !== void 0 ? ref3 : ""
                    });
                })) !== null && ref1 !== void 0 ? ref1 : []
            }) : {});
        })) !== null && ref2 !== void 0 ? ref2 : []);
    };
    return CreateInvitationRequest;
}((0, _coralComAmazonPassportusermanagementservice.CreateInvitationRequest));
CreateInvitationRequest.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).CreateInvitationRequest;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreateInvitationRequest);
exports.default = CreateInvitationRequest;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BH3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetDeactivatedUsersResponse = /*#__PURE__*/ function(GetDeactivatedUsersResponseCore1) {
    "use strict";
    _inherits(GetDeactivatedUsersResponse, GetDeactivatedUsersResponseCore1);
    var _super = _createSuper(GetDeactivatedUsersResponse);
    function GetDeactivatedUsersResponse() {
        _classCallCheck(this, GetDeactivatedUsersResponse);
        return _super.apply(this, arguments);
    }
    GetDeactivatedUsersResponse.fromJson = function fromJson(param) {
        var userList = param.userList;
        return GetDeactivatedUsersResponse.clone({
            userList: userList
        });
    };
    return GetDeactivatedUsersResponse;
}((0, _coralComAmazonPassportusermanagementservice.GetDeactivatedUsersResponse));
GetDeactivatedUsersResponse.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).GetDeactivatedUsers;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetDeactivatedUsersResponse);
exports.default = GetDeactivatedUsersResponse;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"adSST":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetInvitedUsersForLogisticsPartyResponse = /*#__PURE__*/ function(GetInvitedUsersForLogisticsPartyResponseCore1) {
    "use strict";
    _inherits(GetInvitedUsersForLogisticsPartyResponse, GetInvitedUsersForLogisticsPartyResponseCore1);
    var _super = _createSuper(GetInvitedUsersForLogisticsPartyResponse);
    function GetInvitedUsersForLogisticsPartyResponse() {
        _classCallCheck(this, GetInvitedUsersForLogisticsPartyResponse);
        return _super.apply(this, arguments);
    }
    GetInvitedUsersForLogisticsPartyResponse.fromJson = function fromJson(param) {
        var invitedUserList = param.invitedUserList;
        return GetInvitedUsersForLogisticsPartyResponse.clone({
            invitedUserList: invitedUserList
        });
    };
    return GetInvitedUsersForLogisticsPartyResponse;
}((0, _coralComAmazonPassportusermanagementservice.GetInvitedUsersForLogisticsPartyResponse));
GetInvitedUsersForLogisticsPartyResponse.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).GetInvitedUsersForLogisticsPartyResponse;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetInvitedUsersForLogisticsPartyResponse);
exports.default = GetInvitedUsersForLogisticsPartyResponse;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYa9P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetRequestedUserProfileInfoResponse = /*#__PURE__*/ function(GetRequestedUserProfileInfoResponseCore1) {
    "use strict";
    _inherits(GetRequestedUserProfileInfoResponse, GetRequestedUserProfileInfoResponseCore1);
    var _super = _createSuper(GetRequestedUserProfileInfoResponse);
    function GetRequestedUserProfileInfoResponse() {
        _classCallCheck(this, GetRequestedUserProfileInfoResponse);
        return _super.apply(this, arguments);
    }
    GetRequestedUserProfileInfoResponse.fromJson = function fromJson(param) {
        var user = param.user;
        return GetRequestedUserProfileInfoResponse.clone({
            user: user
        });
    };
    return GetRequestedUserProfileInfoResponse;
}((0, _coralComAmazonPassportusermanagementservice.GetRequestedUserProfileInfoResponse));
GetRequestedUserProfileInfoResponse.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).GetRequestedUserProfileInfoResponse;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetRequestedUserProfileInfoResponse);
exports.default = GetRequestedUserProfileInfoResponse;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"72U9w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetUserProfileInfoResponse = /*#__PURE__*/ function(GetUserProfileInfoResponseCore1) {
    "use strict";
    _inherits(GetUserProfileInfoResponse, GetUserProfileInfoResponseCore1);
    var _super = _createSuper(GetUserProfileInfoResponse);
    function GetUserProfileInfoResponse() {
        _classCallCheck(this, GetUserProfileInfoResponse);
        return _super.apply(this, arguments);
    }
    GetUserProfileInfoResponse.fromJson = function fromJson(param) {
        var user = param.user;
        return new GetUserProfileInfoResponse({
            user: user
        });
    };
    return GetUserProfileInfoResponse;
}((0, _coralComAmazonPassportusermanagementservice.GetUserProfileInfoResponse));
GetUserProfileInfoResponse.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).GetUserProfileInfoResponse;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetUserProfileInfoResponse);
exports.default = GetUserProfileInfoResponse;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8W6Fb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetUsersForLogisticsPartyResponse = /*#__PURE__*/ function(GetUsersForLogisticsPartyResponseCore1) {
    "use strict";
    _inherits(GetUsersForLogisticsPartyResponse, GetUsersForLogisticsPartyResponseCore1);
    var _super = _createSuper(GetUsersForLogisticsPartyResponse);
    function GetUsersForLogisticsPartyResponse() {
        _classCallCheck(this, GetUsersForLogisticsPartyResponse);
        return _super.apply(this, arguments);
    }
    GetUsersForLogisticsPartyResponse.fromJson = function fromJson(param) {
        var userList = param.userList;
        return GetUsersForLogisticsPartyResponse.clone({
            userList: userList
        });
    };
    return GetUsersForLogisticsPartyResponse;
}((0, _coralComAmazonPassportusermanagementservice.GetUsersForLogisticsPartyResponse));
GetUsersForLogisticsPartyResponse.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).GetUsersForLogisticsPartyResponse;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetUsersForLogisticsPartyResponse);
exports.default = GetUsersForLogisticsPartyResponse;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjaRn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var UpdateUserProfileInfoRequest = /*#__PURE__*/ function(UpdateUserProfileInfoRequestCore1) {
    "use strict";
    _inherits(UpdateUserProfileInfoRequest, UpdateUserProfileInfoRequestCore1);
    var _super = _createSuper(UpdateUserProfileInfoRequest);
    function UpdateUserProfileInfoRequest() {
        _classCallCheck(this, UpdateUserProfileInfoRequest);
        return _super.apply(this, arguments);
    }
    UpdateUserProfileInfoRequest.toJson = function toJson(param) {
        var user = param.user, monsSelectLocale = param.monsSelectLocale;
        return {
            user: user,
            monsSelectLocale: monsSelectLocale
        };
    };
    return UpdateUserProfileInfoRequest;
}((0, _coralComAmazonPassportusermanagementservice.UpdateUserProfileInfoRequest));
UpdateUserProfileInfoRequest.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).UpdateUserProfileInfoRequest;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpdateUserProfileInfoRequest);
exports.default = UpdateUserProfileInfoRequest;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gntNZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralOperationTypes = require("../constants/coralOperationTypes");
var _coralOperationTypesDefault = parcelHelpers.interopDefault(_coralOperationTypes);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var UpdateUserProfileInfoResponse = /*#__PURE__*/ function(UpdateUserProfileInfoResponseCore1) {
    "use strict";
    _inherits(UpdateUserProfileInfoResponse, UpdateUserProfileInfoResponseCore1);
    var _super = _createSuper(UpdateUserProfileInfoResponse);
    function UpdateUserProfileInfoResponse() {
        _classCallCheck(this, UpdateUserProfileInfoResponse);
        return _super.apply(this, arguments);
    }
    UpdateUserProfileInfoResponse.fromJson = function fromJson(param) {
        var user = param.user;
        return new UpdateUserProfileInfoResponse(user);
    };
    return UpdateUserProfileInfoResponse;
}((0, _coralComAmazonPassportusermanagementservice.UpdateUserProfileInfoResponse));
UpdateUserProfileInfoResponse.fullyQualifiedTypeName = (0, _coralOperationTypesDefault.default).UpdateUserProfileInfoResponse;
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UpdateUserProfileInfoResponse);
exports.default = UpdateUserProfileInfoResponse;

},{"@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","@amzn/ihm-js-coral-client":"eOj61","../constants/coralOperationTypes":"52IAf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l16jW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable no-unused-vars */ var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _index = require("@amzn/carrierlogistics-commons/dist/constants/index");
var _csrf = require("@amzn/carrierlogistics-commons/dist/utils/csrf");
var _csrfDefault = parcelHelpers.interopDefault(_csrf);
var _isSiteExternal = require("../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
var _routes = require("../routes");
var _constants = require("../constants");
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
// This class is used during client construction, and helps to intercept
// the headers during request handling for the passport external App.
var RequestOptionsInterceptorForPassport = /*#__PURE__*/ function(CoralInterceptor1) {
    "use strict";
    _inherits(RequestOptionsInterceptorForPassport, CoralInterceptor1);
    var _super = _createSuper(RequestOptionsInterceptorForPassport);
    function RequestOptionsInterceptorForPassport() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, RequestOptionsInterceptorForPassport);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    var _proto = RequestOptionsInterceptorForPassport.prototype;
    /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
    _proto.intercept = function intercept(request, next) {
        // Adding required header
        var headers = [
            [
                "Accept",
                "application/json"
            ],
            [
                "Content-Type",
                "application/json"
            ],
            [
                (0, _index.CSRF_TOKEN_ID),
                (0, _csrfDefault.default)()
            ]
        ];
        var postData = request.body;
        // To fix `TypeError: Request constructor: HEAD or GET Request cannot have a body.`
        // Added check to not send stringified body
        var modifiedRequest = request.clone(_objectSpread({
            headers: headers,
            credentials: "include"
        }, ![
            "GET",
            "HEAD"
        ].includes(request === null || request === void 0 ? void 0 : request.method) ? {
            body: JSON.stringify(postData)
        } : {}));
        return (0, _rxjs.from)(next.handle(modifiedRequest)).pipe((0, _operators.map)(function(response) {
            var responseHeaders = response.headers;
            return new (0, _ihmJsCoralClient.CoralResponse)(response);
        }), (0, _operators.catchError)(function(err) {
            if (!(0, _isSiteExternalDefault.default)() && (err === null || err === void 0 ? void 0 : err.message) && (0, _constants.FAILED_TO_FETCH_ERR_MESSAGES).includes(err === null || err === void 0 ? void 0 : err.message)) // Only applicable for internal Passport UI
            // To address Cookie expire issue in pums but once cookie expire, mons returned the request with cors issue
            // In case of err with Failed to Fetch, 403 forbidden status come but this can't be captured in fetch
            // Failed to Fetch can be caused by multiple issue like incorrect url or http methods or CORS issue
            // Since we use CORAL models, issue like incorrect url or http methods is avoided as signature is
            // always same in both UI and backend as models is deployed in both pipelines so only thing left is
            // CORS which can be solved by directly setting the pums mons backend URL with redirect URI
            // Handled the cases for other browsers as well for Chrome, FireFox, Safari, Edge
            window.location.href = (0, _routes.PUMS_NAV_LINK);
            return new (0, _ihmJsCoralClient.CoralResponse)(err);
        }));
    };
    return RequestOptionsInterceptorForPassport;
}((0, _ihmJsCoralClient.CoralInterceptor));
exports.default = RequestOptionsInterceptorForPassport;

},{"rxjs":"ctXY8","rxjs/operators":"eRfPW","@amzn/ihm-js-coral-client":"eOj61","@amzn/carrierlogistics-commons/dist/constants/index":"bDvom","@amzn/carrierlogistics-commons/dist/utils/csrf":"3Fofe","../utils/isSiteExternal":"76p21","../routes":"gLiUu","../constants":"aOASK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bDvom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSRF_TOKEN_ID", ()=>CSRF_TOKEN_ID);
var CSRF_TOKEN_ID = "anti-csrftoken-a2z";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Fofe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCsrfToken", ()=>getCsrfToken);
var _constants = require("../constants");
var getCsrfToken = function() {
    var csrfTokenMeta = document.querySelector("meta[name='".concat((0, _constants.CSRF_TOKEN_ID), "']"));
    var ref;
    return (ref = csrfTokenMeta === null || csrfTokenMeta === void 0 ? void 0 : csrfTokenMeta.getAttribute("content")) !== null && ref !== void 0 ? ref : "";
};
exports.default = getCsrfToken;

},{"../constants":"bDvom","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbU1l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _csrf = require("@amzn/carrierlogistics-commons/dist/utils/csrf");
var _csrfDefault = parcelHelpers.interopDefault(_csrf);
var _requestHeaderConfig = require("../config/requestHeaderConfig");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
var RequestOptionsInterceptor = /*#__PURE__*/ function(CoralInterceptor1) {
    "use strict";
    _inherits(RequestOptionsInterceptor, CoralInterceptor1);
    var _super = _createSuper(RequestOptionsInterceptor);
    function RequestOptionsInterceptor() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, RequestOptionsInterceptor);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    var _proto = RequestOptionsInterceptor.prototype;
    /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns {CoralResponse} response
   */ // eslint-disable-next-line class-methods-use-this
    _proto.intercept = function intercept(request, next) {
        var ref4;
        // Adding required header
        var headers = [
            [
                "Accept",
                "application/json"
            ],
            [
                "Content-Type",
                "application/json"
            ],
            [
                (0, _requestHeaderConfig.CSRF_TOKEN_ID),
                (ref4 = (0, _csrfDefault.default)()) !== null && ref4 !== void 0 ? ref4 : ""
            ]
        ];
        var modifiedRequest = request.clone({
            headers: headers,
            credentials: "same-origin"
        });
        return (0, _rxjs.from)(next.handle(modifiedRequest)).pipe((0, _operators.map)(function(response) {
            var responseHeaders = response.headers;
            var ref;
            var ref1 = _slicedToArray((ref = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.find(function(param) {
                var _param = _slicedToArray(param, 1), k = _param[0];
                return k === (0, _requestHeaderConfig.MONS_CUSTOMER_ID_HEADER);
            })) !== null && ref !== void 0 ? ref : [
                (0, _requestHeaderConfig.MONS_CUSTOMER_ID_HEADER),
                ""
            ], 2), monsCustomerId = ref1[1];
            var ref2;
            var ref3 = _slicedToArray((ref2 = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.find(function(param) {
                var _param = _slicedToArray(param, 1), k = _param[0];
                return k === (0, _requestHeaderConfig.CSRF_TOKEN_ID);
            })) !== null && ref2 !== void 0 ? ref2 : [
                (0, _requestHeaderConfig.CSRF_TOKEN_ID),
                ""
            ], 2), csrfToken = ref3[1];
            // Adding monsCustomerId to session storage for future reference in apis.
            sessionStorage.setItem((0, _requestHeaderConfig.MONS_CUSTOMER_ID_SESSION), monsCustomerId);
            sessionStorage.setItem((0, _requestHeaderConfig.CSRF_TOKEN_ID), csrfToken);
            return new (0, _ihmJsCoralClient.CoralResponse)(response);
        }));
    };
    return RequestOptionsInterceptor;
}((0, _ihmJsCoralClient.CoralInterceptor));
exports.default = RequestOptionsInterceptor;

},{"rxjs":"ctXY8","rxjs/operators":"eRfPW","@amzn/ihm-js-coral-client":"eOj61","@amzn/carrierlogistics-commons/dist/utils/csrf":"3Fofe","../config/requestHeaderConfig":"hmppL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hmppL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MONS_CUSTOMER_ID_HEADER", ()=>MONS_CUSTOMER_ID_HEADER);
parcelHelpers.export(exports, "MONS_CUSTOMER_ID_SESSION", ()=>MONS_CUSTOMER_ID_SESSION);
parcelHelpers.export(exports, "CSRF_TOKEN_ID", ()=>CSRF_TOKEN_ID);
var MONS_CUSTOMER_ID_HEADER = "_debug_amz-mons-customer";
var MONS_CUSTOMER_ID_SESSION = "monsCustomerId";
var CSRF_TOKEN_ID = "anti-csrftoken-a2z";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Ek32":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types = require("../../actions/ui/types");
/**
 * custom middleware to route on action dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */ function createRouterMiddleware() {
    return function() {
        return function(next) {
            return function(action) {
                var type = action.type;
                if (type === (0, _types.PUSH_ROUTE)) {
                    var _payload = action.payload, history = _payload.history, route = _payload.route, _delay = _payload.delay, delay = _delay === void 0 ? 0 : _delay;
                    setTimeout(function() {
                        return history.push(route);
                    }, delay);
                }
                return next(action);
            };
        };
    };
}
var routerMiddleware = createRouterMiddleware();
exports.default = routerMiddleware;

},{"../../actions/ui/types":"dlLnM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"77YTK":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("9df8735037ab95e3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "appLayoutContentId", {
    enumerable: true,
    get: function get() {
        return _appLayout.appLayoutContentId;
    }
});
exports["default"] = void 0;
var _appLayout = _interopRequireWildcard(require("90ccc77787a18ab"));
var _default = _appLayout["default"];
exports["default"] = _default;

},{"9df8735037ab95e3":"4RXTR","90ccc77787a18ab":"hjXZD"}],"hjXZD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("52ae50a678d633b0");
var _interopRequireWildcard = require("495ca11a5c17bb15");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appLayoutContentId = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("1cde7f2fda29c323"));
var _propTypes = _interopRequireDefault(require("c96b5e8358f20419"));
var _emotion = require("f3590a3f40e96a4");
var _find = _interopRequireDefault(require("ec2a60e6765abc6"));
var _uniqueId = _interopRequireDefault(require("dd0c5156a2386d22"));
var _skipNavigationLink = _interopRequireDefault(require("baec7828659a9dce"));
var _theme = require("e4a31d95ace9f595");
var _box = _interopRequireDefault(require("cd6282713d34ddee"));
var _propTypes2 = _interopRequireDefault(require("db8d18f35f9dd671"));
var _isElementOf = _interopRequireDefault(require("b8715851ddc4b69"));
var _token = require("3ca9d5ba11dfe7da");
var _functional = require("823e87038d54c022");
var appLayoutContentId = (0, _uniqueId["default"])("app-layout-content-"); // Remove the default margin on the body tag
exports.appLayoutContentId = appLayoutContentId;
(0, _emotion.injectGlobal)({
    body: {
        margin: 0
    }
});
/**
 * These styles are applied to the outer element of the app layout, whatever
 * that ends up being (e.g. just the content, the content locked up with a
 * masthead, etc.)
 */ var styles = (0, _functional.memoize)(function(backgroundColor) {
    return (0, _emotion.css)({
        backgroundColor: backgroundColor,
        height: "100vh",
        "@media print": {
            height: "auto"
        }
    });
});
/**
 * These styles are applied to the scrollable content area. This will either be
 * just the app content, or a lockup of the app content and the app footer.
 */ var scrollerStyles = (0, _functional.memoize)(function(alwaysShowScrollbar) {
    return (0, _emotion.css)({
        overflowY: alwaysShowScrollbar ? "scroll" : "auto",
        outline: "none",
        "@media print": {
            overflowY: "visible"
        }
    });
});
/**
 * These styles are applied to a container with the content as the first child
 * and the app footer as the second child. The goal is to float the footer down
 * to the very bottom of the container.
 */ var footerLockupStyles = (0, _emotion.css)({
    // Lockup container styles
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // Content styles
    "& > *:first-child": {
        flex: "auto",
        flexShrink: 0
    },
    // Footer styles
    "& > *:last-child": {
        flexShrink: 0,
        "@media print": {
            display: "none"
        }
    }
});
/**
 * These styles are applied to a container with the sidebar as the first child
 * and the content (or content + footer) as the second child. The goal is to
 * arrange the sidebar to the left of the content and to keep both children at
 * full height.
 */ var sidebarLockupStyles = (0, _emotion.css)({
    // Lockup container styles
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    overflow: "hidden",
    // Sidebar styles
    "& > *:first-child": {
        display: "flex",
        alignItems: "stretch",
        flexShrink: 0,
        "@media print": {
            display: "none"
        }
    },
    // Content/footer styles
    "& > *:last-child": {
        flex: "auto"
    }
});
/**
 * These styles are applied to a container with the header as the first child
 * and the content (or content/footer/sidebar lockup) as the second child. The
 * goal is to stack the elements vertically with the header taking up only the
 * space it needs and the content taking up the rest of the space.
 */ var headerLockupStyles = (0, _emotion.css)({
    // Lockup container styles
    display: "flex",
    flexDirection: "column",
    // Header styles
    "& > *:first-child": {
        flexShrink: 0,
        "@media print": {
            display: "none"
        }
    },
    // Content/footer/sidebar styles
    "& > *:last-child": {
        flex: "auto"
    }
});
/**
 * Use this component at the root of your application to position a header,
 * sidebar, and footer region (or any subset of those regions) around a
 * scrollable content region.
 *
 * The AppLayout component accepts components for all regions (header, sidebar,
 * footer, and content) as children. The headerComponent, sidebarComponent, and
 * footerComponent props are used to identify which components should be placed
 * in which regions. All other components will be placed in the content region.
 *
 * The scrollable content area is given a unique id that makes it easy to query
 * in the DOM, allowing you to manually set the scroll position if necessary.
 * This id can be fetched by importing `appLayoutContentId` from the app-layout
 * module.
 *
 * Note that only one instance of AppLayout can be rendered at a time.
 */ function AppLayout(props) {
    var children = _react["default"].Children.toArray(props.children);
    var header = (0, _find["default"])(children, (0, _isElementOf["default"])(props.headerComponent));
    var sidebar = (0, _find["default"])(children, (0, _isElementOf["default"])(props.sidebarComponent));
    var footer = (0, _find["default"])(children, (0, _isElementOf["default"])(props.footerComponent));
    var t = (0, _theme.useTheme)();
    var backgroundColor = (0, _react.useMemo)(function() {
        return (0, _token.getToken)(t.tokens, "themeBackground", [
            props.backgroundColor,
            "default"
        ]) || props.backgroundColor;
    }, [
        t,
        props.backgroundColor
    ]); // Wrap the app content
    var content = /*#__PURE__*/ _react["default"].createElement(_box["default"], {
        tag: "main",
        spacingInset: props.spacingInset
    }, children.filter(function(child) {
        return child !== header && child !== sidebar && child !== footer;
    })); // If we have a footer, create a vertical lockup of that below the content.
    var footerLockup = footer ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: footerLockupStyles
    }, content, footer) : content; // Add an id to the content or footer/content lockup. This can be used to
    // target the content with a skip navigation link, and to query the element
    // via JS in order to set the scroll position of the content.
    var scroller = /*#__PURE__*/ _react["default"].cloneElement(footerLockup, {
        id: appLayoutContentId,
        tabIndex: "-1",
        className: (0, _emotion.cx)(footerLockup.props.className, scrollerStyles(props.alwaysShowScrollbar))
    }); // If we have a sidebar, create a horizontal lockup of that to the left of
    // the content.
    var sidebarLockup = sidebar ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: sidebarLockupStyles
    }, /*#__PURE__*/ _react["default"].createElement("div", null, sidebar), scroller) : scroller; // If we have a header, create a vertical lockup of that above the content.
    var headerLockup = header ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: headerLockupStyles
    }, /*#__PURE__*/ _react["default"].createElement("div", null, header), sidebarLockup) : sidebarLockup; // Add our root styles to whatever element ended up being the outer wrapper.
    return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, header || sidebar ? /*#__PURE__*/ _react["default"].createElement(_skipNavigationLink["default"], {
        targetId: appLayoutContentId
    }, props.skipNavigationMessage) : null, /*#__PURE__*/ _react["default"].cloneElement(headerLockup, {
        className: (0, _emotion.cx)(headerLockup.props.className, styles(backgroundColor))
    }));
}
AppLayout.propTypes = {};
AppLayout.defaultProps = {
    alwaysShowScrollbar: true,
    skipNavigationMessage: "Skip to main content.",
    spacingInset: "none"
};
var _default = AppLayout;
exports["default"] = _default;

},{"52ae50a678d633b0":"5qxSW","495ca11a5c17bb15":"4RXTR","1cde7f2fda29c323":"6uln9","c96b5e8358f20419":"9Mqtv","f3590a3f40e96a4":"1BAMo","ec2a60e6765abc6":"b6TZs","dd0c5156a2386d22":"4Lekm","baec7828659a9dce":"eXXuM","e4a31d95ace9f595":"dJlcb","cd6282713d34ddee":"dxZXY","db8d18f35f9dd671":"b6Ogh","b8715851ddc4b69":"i2KEV","3ca9d5ba11dfe7da":"bebc4","823e87038d54c022":"hze9s"}],"b6TZs":[function(require,module,exports) {
var createFind = require("6c8a73b87955b79c"), findIndex = require("22d3d2313f695feb");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"6c8a73b87955b79c":"ksBTL","22d3d2313f695feb":"a1880"}],"ksBTL":[function(require,module,exports) {
var baseIteratee = require("82d2b5bfd942b5f2"), isArrayLike = require("f3bc699e6a08eddd"), keys = require("e1ed555892b1697c");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"82d2b5bfd942b5f2":"iYUay","f3bc699e6a08eddd":"gSsVl","e1ed555892b1697c":"8QtRK"}],"a1880":[function(require,module,exports) {
var baseFindIndex = require("81c3feef8e9c6120"), baseIteratee = require("dc5547119332ddb0"), toInteger = require("ae51cd746fd3735e");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"81c3feef8e9c6120":"7JT1u","dc5547119332ddb0":"iYUay","ae51cd746fd3735e":"j7eMm"}],"7JT1u":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"j7eMm":[function(require,module,exports) {
var toFinite = require("b90409f7f8c9f91d");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"b90409f7f8c9f91d":"a6Tgt"}],"a6Tgt":[function(require,module,exports) {
var toNumber = require("e52cd24c2b199f6e");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"e52cd24c2b199f6e":"2g9IH"}],"2g9IH":[function(require,module,exports) {
var isObject = require("2b63f9792e895067"), isSymbol = require("700caff375f0e44c");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"2b63f9792e895067":"5e0ks","700caff375f0e44c":"41pUa"}],"4Lekm":[function(require,module,exports) {
var toString = require("d51ae677a760d56e");
/** Used to generate unique IDs. */ var idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
}
module.exports = uniqueId;

},{"d51ae677a760d56e":"jihDg"}],"eXXuM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5ab4afd99de1ea92");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _skipNavigationLink = _interopRequireDefault(require("5a8f28d18c33e5f0"));
var _default = _skipNavigationLink["default"];
exports["default"] = _default;

},{"5ab4afd99de1ea92":"5qxSW","5a8f28d18c33e5f0":"l91DX"}],"l91DX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7f77d222bb5452d1");
var _interopRequireWildcard = require("150340da3702e00");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("bd2d1424e73611ad"));
var _propTypes = _interopRequireDefault(require("18d0a5163b7c1cbf"));
var _emotion = require("de2cdfb139a304c2");
var _spacing = require("3faa6aafc9bb6dc6");
var _elevation = require("d8b7e10e4f220a4d");
var _button = _interopRequireDefault(require("1259dae61ac571a0"));
var _visuallyHidden = _interopRequireDefault(require("a8dcf4b44ddfe694"));
var styles = (0, _emotion.css)({
    position: "fixed",
    top: _spacing.spacingMedium,
    left: _spacing.spacingMedium,
    zIndex: _elevation.elevationPopover,
    "&:not(:focus)": _visuallyHidden["default"]
});
/**
 * Use this component to add a "skip navigation" accessibility link to your app.
 * A skip navigation link allows keyboard users to quickly skip over long lists
 * of navigation items (links, buttons, etc.) to the main page content. These
 * links should be placed before any other focuseable elements on the page so
 * that they come first in the tab order. Read more about skip navigation links
 * here: https://webaim.org/techniques/skipnav/.
 *
 * NOTE: The AppLayout component comes pre-packaged with a SkipNavigationLink.
 * We recommend using that component to handle your application layout if
 * possible.
 */ var SkipNavigationLink = /*#__PURE__*/ _react["default"].memo(function(_ref) {
    var targetId = _ref.targetId, children = _ref.children;
    var onClick = (0, _react.useCallback)(function() {
        var targetElement = document.querySelector("#".concat(targetId));
        if (targetElement) targetElement.focus();
    }, [
        targetId
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: "secondary",
        onClick: onClick,
        className: styles
    }, children);
});
SkipNavigationLink.displayName = "SkipNavigationLink";
SkipNavigationLink.propTypes = {};
var _default = SkipNavigationLink;
exports["default"] = _default;

},{"7f77d222bb5452d1":"5qxSW","150340da3702e00":"4RXTR","bd2d1424e73611ad":"6uln9","18d0a5163b7c1cbf":"9Mqtv","de2cdfb139a304c2":"1BAMo","3faa6aafc9bb6dc6":"8D3is","d8b7e10e4f220a4d":"dKmTh","1259dae61ac571a0":"k0QSK","a8dcf4b44ddfe694":"kk7IH"}],"k0QSK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7df64f4160bfb003");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _button = _interopRequireDefault(require("53c313945809457f"));
var _default = _button["default"];
exports["default"] = _default;

},{"7df64f4160bfb003":"5qxSW","53c313945809457f":"fCkQw"}],"fCkQw":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2cbfbb9348eeb047");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("1096b2412f469846"));
var _react = _interopRequireDefault(require("6e35ee6938c3606c"));
var _propTypes = _interopRequireDefault(require("6c29b559ce1de016"));
var _emotion = require("5fedfa68de99f5de");
var _button = _interopRequireDefault(require("144e92fff67ca9be"));
var _theme = require("6aff079c6b7bed09");
var _clickable = _interopRequireDefault(require("a50a6566450d0103"));
var _useFocus2 = _interopRequireDefault(require("5178469a13dab1ea"));
var _icon = _interopRequireDefault(require("c6cb3d17c745aa87"));
var _buttonStyles = require("7ac50201b7fa47a9");
var _text = _interopRequireDefault(require("3244d843045112cb"));
var _token = require("488f3ecc95f67849");
var _isColorDark = _interopRequireDefault(require("c054cb25e43187f9"));
var _isElementOf = _interopRequireDefault(require("a4b8c1bf54c6b0f0"));
var _filterPropsByPrefix = _interopRequireDefault(require("203aa0c239bd185"));
var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, type = _ref.type, focus = _ref.focus, disabled = _ref.disabled, minWidth = _ref.minWidth, _ref$backdropColor = _ref.backdropColor, backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor, iconOnly = _ref.iconOnly, circular = _ref.circular;
    var state = disabled ? "disabled" : "default";
    var linkOrIcon = type === "link" || type === "icon";
    var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
    var borderColor = t("borderColor", [
        type,
        state
    ]);
    var borderWidth = borderColor ? t("borderWidth") : 0;
    var borderStyle = borderColor ? "solid" : undefined;
    var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
    return (0, _emotion.css)((0, _text["default"])(t, {
        fontSize: size
    }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
        type: type,
        backdrop: backdrop
    }) : (0, _buttonStyles.defaultStyles)(t, {
        type: type,
        backdrop: backdrop
    }), {
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        outline: "none",
        position: "relative",
        minWidth: minWidth,
        height: t("height", size),
        // Make icon-only buttons square w/ no padding and all other buttons
        // flexible with padding.
        width: iconOnly ? t("height", size) : undefined,
        flexShrink: iconOnly ? 0 : undefined,
        padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
        transition: t.transitionCss("motion", [
            "color",
            "background-color",
            "border-color"
        ]),
        borderRadius: borderRadius,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        whiteSpace: "nowrap",
        // HACK: IE11 will only show a pseudo element on a button if
        // overflow is set to visible, and our focus ring is displayed with a
        // pseudo element.
        overflow: "visible",
        "& > * + *": {
            marginLeft: t("spacingInsetHorizontal", size)
        },
        ":hover": !disabled ? (0, _buttonStyles.hoverStyles)(t, {
            type: type,
            backdrop: backdrop
        }) : undefined,
        ":active": !disabled ? (0, _buttonStyles.activeStyles)(t, {
            type: type,
            backdrop: backdrop
        }) : undefined
    }, !disabled ? (0, _buttonStyles.focusStyles)(t, {
        focus: focus,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        backdropColor: backdropColor,
        linkOrIcon: linkOrIcon
    }) : undefined);
}, [
    "size",
    "type",
    "focus",
    "disabled",
    "backdropColor",
    "minWidth",
    "iconOnly",
    "circular"
]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.
var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
    var arr = _react["default"].Children.toArray(children);
    return arr.length > 1 ? arr.map(function(child, index) {
        return typeof child === "string" ? /*#__PURE__*/ _react["default"].createElement("span", {
            key: index
        }, child) : child;
    }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */ var Button = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_button["default"], "button"); // Does the button contain only an icon (no text)?
    var iconOnly = _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon/link buttons so that they're offset from the
    // edge of the icon/text (which is visible), not the edge of the button
    // element (which is not visible). The magic "24" for the icon variant is the
    // size of a standard icon. By subtracting that from the height of the button
    // and dividing by 2 we get the distance between the invisible edge of the
    // button and the visible edge of the icon.
    var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : props.type === "link" ? -(t("height", props.size) - t("fontSize", props.size)) / 2 : undefined;
    var _useFocus = (0, _useFocus2["default"])(props), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
        ref: ref,
        className: (0, _emotion.cx)(styles(t, {
            type: props.type,
            size: props.size,
            disabled: props.disabled,
            circular: props.circular,
            backdropColor: props.backdropColor,
            minWidth: props.minWidth,
            focus: focus && focusTrigger === "keyboard",
            iconOnly: iconOnly
        }), props.className),
        disabled: props.disabled,
        id: props.id,
        href: props.href,
        rel: props.rel,
        target: props.target,
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        propagateClickEvent: props.propagateClickEvent,
        tabIndex: props.tabIndex,
        download: props.download,
        submit: props.submit,
        "aria-hidden": props["aria-hidden"] || undefined,
        "aria-label": props.label || undefined,
        "mdn-popover-offset": popoverOffset
    }, focusProps), wrapStringSiblingsInSpans(props.children));
});
Button.displayName = "Button";
Button.propTypes = {};
Button.defaultProps = {
    propagateClickEvent: true,
    size: "medium",
    type: "primary"
};
var _default = Button;
exports["default"] = _default;

},{"2cbfbb9348eeb047":"5qxSW","1096b2412f469846":"fAmfl","6e35ee6938c3606c":"6uln9","6c29b559ce1de016":"9Mqtv","5fedfa68de99f5de":"1BAMo","144e92fff67ca9be":"4wQlF","6aff079c6b7bed09":"dJlcb","a50a6566450d0103":"iWCwP","5178469a13dab1ea":"7jVM9","c6cb3d17c745aa87":"8MgRY","7ac50201b7fa47a9":"6sNQL","3244d843045112cb":"g6RQX","488f3ecc95f67849":"bebc4","c054cb25e43187f9":"9CoI3","a4b8c1bf54c6b0f0":"i2KEV","203aa0c239bd185":"7Pq5E"}],"iWCwP":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d187c8e1380c30ae");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _clickable = _interopRequireDefault(require("850138131927f2e"));
var _default = _clickable["default"];
exports["default"] = _default;

},{"d187c8e1380c30ae":"5qxSW","850138131927f2e":"dWfan"}],"dWfan":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("585fe53489f08b39");
var _interopRequireDefault = require("113748401079c340");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("47740d0a8a989c7a"));
var _react = _interopRequireWildcard(require("492eee1611ba39c1"));
var _propTypes = _interopRequireDefault(require("d38f9833442f58a0"));
var _emotion = require("7317e42f85118f5a");
var _keycode = _interopRequireDefault(require("8f9bbf0d6ca13970"));
var _noop = _interopRequireDefault(require("4833e0a028d110a7"));
var _buttonReset = _interopRequireDefault(require("2a5c724ed9055032"));
var _linkReset = _interopRequireDefault(require("a23d4053ff2adbb1"));
var _functional = require("d71dccf507537c8a");
var _cxMemoized = _interopRequireDefault(require("b24c8bdd9af05eb3"));
var _filterPropsByPrefix = _interopRequireDefault(require("5cfd2bea9010f03"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _functional.memoizeByKeys)(function(_ref) {
    var tag = _ref.tag, disabled = _ref.disabled;
    return (0, _emotion.css)({
        button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
            // HACK: IE offsets the contents of buttons on mouse down (in the active
            // state) to create a faux 3D effect. These styles are applied to every
            // child of  the button in order to counter this effect so that we are
            // the masters of our own button-content-position-destiny.
            "& > *": {
                position: "relative"
            }
        }),
        a: _linkReset["default"]
    }[tag], {
        cursor: disabled ? "not-allowed" : "pointer",
        outline: "none"
    });
}, [
    "tag",
    "disabled"
]);
var getPropsForNativeLink = function getPropsForNativeLink(props) {
    return {
        href: props.disabled ? undefined : props.href,
        target: props.target,
        rel: props.rel,
        "aria-disabled": props.disabled || undefined,
        role: props.role !== "link" ? props.role : undefined,
        tabIndex: props.disabled ? "-1" : props.tabIndex,
        onClick: props.onClick
    };
};
var getPropsForNativeButton = function getPropsForNativeButton(props) {
    return {
        disabled: props.disabled || undefined,
        type: props.submit ? "submit" : "button",
        role: props.role !== "button" ? props.role : undefined,
        tabIndex: props.tabIndex,
        onClick: props.onClick
    };
};
var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
    return {
        href: props.disabled ? undefined : props.href,
        target: props.target,
        rel: props.rel,
        "aria-disabled": props.disabled || undefined,
        tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
        role: props.role,
        onKeyDown: function onKeyDown(event) {
            var key = (0, _keycode["default"])(event);
            var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links
            if (focus && key === "enter") props.onClick(event);
             // Disable scrolling on space-key-down for buttons
            if (focus && key === "space" && props.role === "button") event.preventDefault();
        },
        onKeyUp: props.role === "button" ? function(event) {
            var key = (0, _keycode["default"])(event);
            var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons
            if (focus && key === "space") // NOTE: event.preventDefault() will have already been called at
            // this point to keep the space key from triggering a scroll
            // (see `onKeyDown` above), so instead of passing the original
            // event this will pass a mock event that looks like it hasn't
            // had preventDefault() called.
            props.onClick({
                defaultPrevented: false,
                preventDefault: _noop["default"]
            });
        } : undefined,
        onClick: props.onClick
    };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */ var simulateLinkClick = function simulateLinkClick(linkAttributes) {
    // Create a link element that we can click
    var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
    // React normally does this for us, but the DOM doesn't so we have to do it
    // manually to avoid things like `download="undefined"` in the DOM.
    Object.assign(link, Object.keys(linkAttributes).reduce(function(result, key) {
        if (linkAttributes[key] !== undefined) result[key] = linkAttributes[key];
        return result;
    }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
    // FF)
    document.body.appendChild(link); // Trigger a click on the link
    link.click(); // Remove the link from the dom.
    document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */ var Clickable = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var onClick = props.onClick, href = props.href, target = props.target, submit = props.submit, disabled = props.disabled, rel = props.rel, download = props.download, tabIndex = props.tabIndex, propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
    // DOM
    var nativeRole = href && !submit ? "link" : "button";
    var role = props.role !== undefined ? props.role : nativeRole;
    var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-",
        "mdn-",
        "aria-"
    ]); // What happens when the Clickable is clicked. Pretty key.
    var onClickTag = (0, _react.useCallback)(function(event) {
        // If the default event behavior was already prevented (e.g. by a nested
        // Clickable inside this one) then don't do anything
        if (!event.defaultPrevented) {
            var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
            // custom onClick handler, or do not have any native browser behavior.
            // This keeps any parent Clickable elements higher up in the DOM tree from
            // also handling the event. This doesn't stop propagation though - other
            // elements may want to react to the event even if its default behavior
            // was cancelled.
            if (disabled || onClick || !nativeBehavior) event.preventDefault();
             // If we were explicitly told to stop propagation on the event then
            // do so now
            if (!propagateClickEvent) event.stopPropagation();
             // If we're not disabled then handle the click
            if (!disabled) {
                // If the element has native behavior and we don't have a custom
                // onClick handler, then fall back to the native behavior (and stop
                // propagation to keep anyone else from handling the click).
                if (nativeBehavior && !onClick) event.stopPropagation();
                else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) simulateLinkClick({
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    download: download
                });
                else if (onClick) onClick(href);
                else if (href) simulateLinkClick({
                    href: href,
                    target: target,
                    rel: rel,
                    download: download
                });
            }
        }
    }, [
        onClick,
        href,
        target,
        submit,
        disabled,
        tag,
        rel,
        download,
        propagateClickEvent
    ]); // Generate props that are specific to the tag we're rendering (e.g. a link,
    // a button, and a div will all require different props in order to acheive
    // a particular behavior). Memoize these to reduce the number of large objects
    // created on each render.
    var clickableProps = (0, _react.useMemo)(function() {
        var props = {
            onClick: onClickTag,
            role: role,
            disabled: disabled,
            href: href,
            rel: rel,
            target: target,
            tabIndex: tabIndex,
            submit: submit
        };
        return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
    }, [
        tag,
        onClickTag,
        role,
        disabled,
        href,
        rel,
        target,
        tabIndex,
        submit
    ]); // HACK: Wrap string children in a span so that the IE positioning
    // hack (see the button styles above) can take effect
    var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function(child) {
        return typeof child !== "string";
    }).length === 0;
    return /*#__PURE__*/ _react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        onMouseMove: props.onMouseMove,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        id: props.id,
        download: props.download,
        title: props.title,
        className: (0, _cxMemoized["default"])(styles({
            tag: tag,
            disabled: props.disabled
        }), props.className),
        ref: ref
    }), applyIE11StyleHack ? /*#__PURE__*/ _react["default"].createElement("span", null, props.children) : props.children);
});
Clickable.displayName = "Clickable";
Clickable.propTypes = {};
Clickable.defaultProps = {
    propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

},{"585fe53489f08b39":"4RXTR","113748401079c340":"5qxSW","47740d0a8a989c7a":"avcfc","492eee1611ba39c1":"6uln9","d38f9833442f58a0":"9Mqtv","7317e42f85118f5a":"1BAMo","8f9bbf0d6ca13970":"4THh2","4833e0a028d110a7":"hxHyu","2a5c724ed9055032":"eH0Hx","a23d4053ff2adbb1":"5rZtK","d71dccf507537c8a":"hze9s","b24c8bdd9af05eb3":"5KZHn","5cfd2bea9010f03":"7Pq5E"}],"4THh2":[function(require,module,exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && "object" === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ("number" === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === "string") {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === "number") return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes["f" + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes["numpad " + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

},{}],"hxHyu":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"eH0Hx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var buttonReset = {
    display: "inline-block",
    padding: 0,
    border: 0,
    outline: "none",
    backgroundColor: "transparent",
    textAlign: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    WebkitAppearance: "none",
    WebkitMarginBefore: 0,
    WebkitMarginAfter: 0,
    WebkitMarginStart: 0,
    WebkitMarginEnd: 0,
    "::-moz-focus-inner": {
        border: 0
    }
};
var _default = buttonReset;
exports["default"] = _default;

},{}],"5rZtK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var linkReset = {
    display: "inline-block",
    outline: "none",
    textDecoration: "none",
    color: "inherit",
    cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

},{}],"7jVM9":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a3133ed34865e9e9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _useFocus = _interopRequireDefault(require("6110156c9cf278b2"));
var _default = _useFocus["default"];
exports["default"] = _default;

},{"a3133ed34865e9e9":"5qxSW","6110156c9cf278b2":"6DdGv"}],"6DdGv":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1f778a2b9de4c161");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("50e8330a53a6c96e"));
var _react = require("8f57c1e8dbc86422");
var _noop = _interopRequireDefault(require("b73dbad2449b90b7"));
/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */ /**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */ /**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */ /**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */ var useFocus = function useFocus() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, disabled = _ref.disabled, multipleNodes = _ref.multipleNodes, _ref$onBlur = _ref.onBlur, onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur, _ref$onFocus = _ref.onFocus, onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;
    var _useState = (0, _react.useState)([
        false,
        null
    ]), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2), focus = _useState2$[0], focusDescendent = _useState2$[1], setFocus = _useState2[1];
    var focusedNode = (0, _react.useRef)();
    var blurTimeout = (0, _react.useRef)();
    var onFocus = (0, _react.useCallback)(function(event) {
        clearTimeout(blurTimeout.current);
        focusedNode.current = event ? event.target : undefined;
        var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;
        if (!focus || focusDescendent !== nextFocusDescendent) setFocus([
            true,
            nextFocusDescendent
        ]);
        if (!focus) onFocusCallback(event, getInteractionDevice());
    }, [
        onFocusCallback,
        focus,
        focusDescendent
    ]);
    var onBlurComplete = (0, _react.useCallback)(function(event) {
        setFocus([
            false,
            false
        ]);
        onBlurCallback(event, getInteractionDevice());
    }, [
        onBlurCallback
    ]);
    var onBlur = (0, _react.useCallback)(function(event) {
        if (event && multipleNodes) {
            clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
            // multiple elements. Instead, wait briefly using setTimeout to see if
            // onFocus is called for another element we're tracking. If it is then
            // we consider the state to still be focused, otherwise we can move ahead
            // and call `onBlurComplete`.
            event.persist();
            blurTimeout.current = setTimeout(function() {
                if (event.target === focusedNode.current) onBlurComplete(event);
            }, 0);
        } else onBlurComplete(event);
    }, [
        onBlurComplete,
        multipleNodes
    ]);
    var focusProps = (0, _react.useMemo)(function() {
        return {
            onFocus: onFocus,
            onBlur: onBlur
        };
    }, [
        onFocus,
        onBlur
    ]);
    (0, _react.useEffect)(function() {
        // When the node(s) are focused and we flip from enabled to disabled, clear
        // the focus (see the docs for the disabled param re: why this is
        // necessary).
        if (focus && disabled) setFocus([
            false,
            false
        ]);
         // Clear the timeout when unmounting
        return function() {
            return clearTimeout(blurTimeout.current);
        };
    }, [
        focus,
        disabled
    ]);
    return {
        focus: focus,
        focusProps: focusProps,
        focusDescendent: focusDescendent,
        focusTrigger: getInteractionDevice()
    };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */ var getInteractionDevice = function() {
    var device = "keyboard";
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("mousedown", function() {
            return device = "mouse";
        }, true);
        window.addEventListener("keydown", function() {
            return device = "keyboard";
        }, true);
    }
    return function() {
        return device;
    };
}();
var _default = useFocus;
exports["default"] = _default;

},{"1f778a2b9de4c161":"5qxSW","50e8330a53a6c96e":"4QArz","8f57c1e8dbc86422":"6uln9","b73dbad2449b90b7":"hxHyu"}],"4QArz":[function(require,module,exports) {
var arrayWithHoles = require("f6547f843e603599");
var iterableToArrayLimit = require("561bf30541c70281");
var unsupportedIterableToArray = require("d1fd07f650b01c26");
var nonIterableRest = require("3b6bbe8b8de933d4");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray;

},{"f6547f843e603599":"aT1u4","561bf30541c70281":"h2EFc","d1fd07f650b01c26":"7sxQU","3b6bbe8b8de933d4":"fclSV"}],"aT1u4":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles;

},{}],"h2EFc":[function(require,module,exports) {
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = _iterableToArrayLimit;

},{}],"7sxQU":[function(require,module,exports) {
var arrayLikeToArray = require("6bdf641ac5a35fc2");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray;

},{"6bdf641ac5a35fc2":"fVGpd"}],"fVGpd":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray;

},{}],"fclSV":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest;

},{}],"8MgRY":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7a828561e438ad31");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _icon = _interopRequireDefault(require("d7a6a6dfee55e657"));
var _default = _icon["default"];
exports["default"] = _default;

},{"7a828561e438ad31":"5qxSW","d7a6a6dfee55e657":"2yyzX"}],"2yyzX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("40f179ca95fe5a6c");
var _interopRequireWildcard = require("131c5e0aff52e0fa");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("32b1ddc71f6ac35e"));
var _propTypes = _interopRequireDefault(require("353863d73aeae37a"));
var _emotion = require("bf57b6356cb8ce74");
var _token = require("bdb32c0c1cbc5597");
var _functional = require("c7914642a4342f5a");
var _cxMemoized = _interopRequireDefault(require("a6d5809bf35cc0da"));
var styles = (0, _functional.memoize)(function(size) {
    return (0, _emotion.css)({
        position: "relative",
        flexShrink: 0,
        display: "inline-block",
        width: size,
        height: size,
        verticalAlign: "middle",
        // Don't show the icon's label
        fontSize: 0,
        // Center the icon image
        "& svg": {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%) translateX(-50%)"
        }
    });
});
var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};
var Icon = /*#__PURE__*/ _react["default"].memo(/*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens), data = _getIconFromTokens.data, width = _getIconFromTokens.width, height = _getIconFromTokens.height;
    var svg = decodeURIComponent(data.replace(/^data:image\/svg\+xml,/, "")) // Add aria-hidden="true" so that screen readers ignore the underlying svg
    // (we label the parent span) and focusable="false" because IE11 defaults
    // to adding SVGs to the tab order
    .replace(/<svg/, '<svg aria-hidden="true" focusable="false"');
    var html = (0, _react.useMemo)(function() {
        return {
            __html: svg
        };
    }, [
        svg
    ]);
    var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
    var simpleChildren = props.children === undefined || typeof props.children === "string";
    return /*#__PURE__*/ _react["default"].createElement("span", {
        role: "img",
        "aria-hidden": !props.children ? true : undefined,
        "aria-label": simpleChildren ? props.children : undefined,
        className: (0, _cxMemoized["default"])(styles(size), props.className),
        tabIndex: props.tabIndex,
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        ref: ref,
        dangerouslySetInnerHTML: simpleChildren ? html : undefined
    }, simpleChildren ? null : /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement("span", {
        dangerouslySetInnerHTML: html
    }), props.children));
}), shouldNotUpdate);
Icon.sizes = {
    small: 16,
    large: 24
};
Icon.displayName = "Icon";
Icon.propTypes = {};
Icon.sizes = {
    small: 16,
    large: 24
};
var _default = Icon;
exports["default"] = _default;

},{"40f179ca95fe5a6c":"5qxSW","131c5e0aff52e0fa":"4RXTR","32b1ddc71f6ac35e":"6uln9","353863d73aeae37a":"9Mqtv","bf57b6356cb8ce74":"1BAMo","bdb32c0c1cbc5597":"bebc4","c7914642a4342f5a":"hze9s","a6d5809bf35cc0da":"5KZHn"}],"6sNQL":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6fecd1df87382b0f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disabledStyles = exports.defaultStyles = exports.focusStyles = exports.hoverStyles = exports.activeStyles = void 0;
var _focusRing = _interopRequireDefault(require("1cb603a88b3bb1d"));
var getStyles = function getStyles(t, _ref) {
    var type = _ref.type, backdrop = _ref.backdrop, state = _ref.state;
    return {
        color: t("foregroundColor", [
            type,
            backdrop,
            state
        ]),
        backgroundColor: t("backgroundColor", [
            type,
            backdrop,
            state
        ]),
        borderColor: t("borderColor", [
            type,
            state
        ])
    };
};
var activeStyles = function activeStyles(t, _ref2) {
    var type = _ref2.type, backdrop = _ref2.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "pressed"
    });
};
exports.activeStyles = activeStyles;
var hoverStyles = function hoverStyles(t, _ref3) {
    var type = _ref3.type, backdrop = _ref3.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "hover"
    });
};
exports.hoverStyles = hoverStyles;
var defaultStyles = function defaultStyles(t, _ref4) {
    var type = _ref4.type, backdrop = _ref4.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "default"
    });
};
exports.defaultStyles = defaultStyles;
var disabledStyles = function disabledStyles(t, _ref5) {
    var type = _ref5.type, backdrop = _ref5.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "disabled"
    });
};
exports.disabledStyles = disabledStyles;
var focusStyles = function focusStyles(t, _ref6) {
    var focus = _ref6.focus, borderWidth = _ref6.borderWidth, borderRadius = _ref6.borderRadius, backdropColor = _ref6.backdropColor, linkOrIcon = _ref6.linkOrIcon;
    return (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        gapColor: backdropColor,
        dropShadow: !linkOrIcon,
        offset: t("focusOutlineOffset")
    });
};
exports.focusStyles = focusStyles;

},{"6fecd1df87382b0f":"5qxSW","1cb603a88b3bb1d":"5Dvm2"}],"5Dvm2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("503d57f0abb2447c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("3b88618712245718"));
var _focusRing = _interopRequireDefault(require("36adbb12365c5ad8"));
var _elevation = require("46ca24c6e688727a");
var _token = require("ada6acf1bcefb53c");
/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */ var focusRing = function focusRing(themeTokens, _ref) {
    var _ref2;
    var focus = _ref.focus, error = _ref.error, dropShadow = _ref.dropShadow, gapColor = _ref.gapColor, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius, _ref$hoverSelector = _ref.hoverSelector, hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector;
    var tokens = (0, _focusRing["default"])(themeTokens);
    var state = focus ? "focus" : error ? "error" : undefined;
    var width = (0, _token.getToken)(tokens, "focusRingWidth");
    var color = (0, _token.getToken)(tokens, "focusRingColor", state);
    var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
    // element then use an inset box shadow.
    var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
    var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
    return _ref2 = {
        // The focuseable element needs to be relatively positioned so that we can
        // absolutely position the focus ring
        position: "relative",
        // If the ring entirely overlaps the focused element's border, turn the
        // element's border off to avoid artifacts near the rounded corners
        borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
    }, (0, _defineProperty2["default"])(_ref2, hoverSelector, dropShadowCss && !color ? {
        boxShadow: dropShadowCss
    } : undefined), (0, _defineProperty2["default"])(_ref2, hoverSelector.split(",").map(function(selector) {
        return "".concat(selector.trim(), ":after");
    }).join(", "), dropShadowCss && state === "error" ? {
        boxShadow: dropShadowAndGapShadowCss
    } : undefined), (0, _defineProperty2["default"])(_ref2, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref2, "&:after", color ? {
        content: "''",
        pointerEvents: "none",
        position: "absolute",
        top: -offset - borderWidth,
        right: -offset - borderWidth,
        bottom: -offset - borderWidth,
        left: -offset - borderWidth,
        border: "".concat(width, "px solid ").concat(color),
        borderRadius: typeof borderRadius === "string" ? borderRadius.split(" ").map(function(radius) {
            var r = parseInt(radius);
            return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
        }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0,
        boxShadow: state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss
    } : undefined), _ref2;
};
var _default = focusRing;
exports["default"] = _default;

},{"503d57f0abb2447c":"5qxSW","3b88618712245718":"avcfc","36adbb12365c5ad8":"dixtu","46ca24c6e688727a":"dKmTh","ada6acf1bcefb53c":"bebc4"}],"9CoI3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
    var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal
    var r = decimal >> 16 & 0xff; // extract red
    var g = decimal >> 8 & 0xff; // extract green
    var b = decimal >> 0 & 0xff; // extract blue
    return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};
var isColorDark = function isColorDark(hex) {
    return getBrightness(hex) < 128;
};
var _default = isColorDark;
exports["default"] = _default;

},{}],"i2KEV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 * import Radio from "@amzn/meridian/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */ var isSameComponent = function isSameComponent(a, b) {
    if (!a || !b) // Bail if either component wasn't provided
    return false;
    else {
        var aName, bName;
        // Just check if the components reference the same class/function.
        return a === b;
    }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */ var isElementOf = function isElementOf(component) {
    return function(element) {
        if (!component || !element) // Bail if either the component or element wasn't provided
        return false;
        else if (element.type && element.type.WrappedComponent) // If the element's component has a static WrappedComponent property, assume
        // we're working with a HoC and compare the wrapped component instead of the
        // HoC component. The connect HoC from redux uses this pattern, so this
        // check ensures that isElementOf works correctly on redux-connected
        // components.
        return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
        else // If WrappedComonent isn't set do a normal comparison of element.type
        // (the component that element was instantiated from) and component.
        return isSameComponent(element.type, component);
    };
};
var _default = isElementOf;
exports["default"] = _default;

},{}],"kk7IH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// These styles are helpful for visually hiding an element while still allowing
// the user to interact with it (e.g. hide an input but allow the user to focus
// on it by clicking on an associated label). Simply applying "display: none" to
// an input will tell the browser to ignore it completely and the user will not
// be able to interact with it at all. Having an invisible yet interactive
// element is useful for creating custom styled inputs that are backed by their
// native html counterparts under the hood or for presenting information to
// screen-readers only.
var visuallyHidden = {
    clip: "rect(0 0 0 0)",
    overflow: "hidden",
    position: "fixed",
    pointerEvents: "none",
    border: 0,
    width: 1,
    height: 1,
    opacity: 0
};
var _default = visuallyHidden;
exports["default"] = _default;

},{}],"1cj09":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _loader = require("@amzn/meridian/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _index = require("@amzn/carrierlogistics-commons/dist/hooks/authorisation/index");
var _breadcrumb = require("@amzn/meridian/breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _lodash = require("lodash");
var _css = require("@emotion/css");
var _reactIntl = require("react-intl");
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
const LpHeader = ()=>{
    const lpSelected = (0, _index.useSelectedLp)();
    const showLoader = !lpSelected?.logisticsPartyName;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, showLoader ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loaderDefault.default), {
        size: "medium"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _css.css)`
            padding: 1rem 2rem;
          `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumb.BreadcrumbGroup), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbDefault.default), {
        onClick: (0, _lodash.noop)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _css.css)`
                  cursor: initial;
                `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "carrier_selected"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbDefault.default), {
        onClick: (0, _lodash.noop)
    }, lpSelected.logisticsPartyName))));
};
exports.default = LpHeader;

},{"react":"6uln9","@amzn/meridian/row":"ba4AQ","@amzn/meridian/loader":"1Ez7s","@amzn/carrierlogistics-commons/dist/hooks/authorisation/index":"jz3IT","@amzn/meridian/breadcrumb":"aQkpR","lodash":"3hMBK","@emotion/css":"awUBr","react-intl":"4kbQW","@amzn/meridian/text":"hj2bM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ba4AQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c8b28f8d212978b1");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _row = _interopRequireDefault(require("fc5b9d9430c21ccb"));
var _default = _row["default"];
exports["default"] = _default;

},{"c8b28f8d212978b1":"5qxSW","fc5b9d9430c21ccb":"akbvZ"}],"akbvZ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9b4b36ce4ea6ff77");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.gridColumns = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("d6f1cba739b2c8d2"));
var _react = _interopRequireDefault(require("36d17b52aba3e543"));
var _propTypes = _interopRequireDefault(require("e61fba2eb5980d9"));
var _emotion = require("b23f388c06340df4");
var _box = _interopRequireDefault(require("949ec053dd0ff5c2"));
var _propTypes2 = _interopRequireDefault(require("a8b537e436c8539d"));
var _parsers = require("153b49997ddfa8f4");
var _functional = require("5bf136f09ac7ea8");
var _cxMemoized = _interopRequireDefault(require("b2088ee3cf86e082"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var gridColumns = 12; // Turns a raw width value (a string or number) into an object with fields
// containing the type of width and the parsed width values
exports.gridColumns = gridColumns;
var parseWidth = function parseWidth(width) {
    return typeof width === "string" && /^grid-/.test(width) ? {
        type: "grid",
        // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
        // "grid-4" to 0.3333)
        value: Math.floor(10000 * parseInt(width.substr(5)) / gridColumns) / 10000
    } : typeof width === "string" && /^[0-9.]+%\s*$/.test(width) ? {
        type: "percentage",
        // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
        // to 0.3333)
        value: Math.floor(100 * parseFloat(width)) / 10000
    } : width === "fit" || width === "fill" ? {
        type: "flex",
        value: width
    } : width !== undefined && width !== null && width !== "" ? {
        type: "css",
        value: width
    } : {
        type: "empty",
        value: null
    };
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)
var wrapContainerStyles = (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch"
});
var rowStyles = function rowStyles(widths) {
    return (0, _functional.memoizeByKeys)(function(_ref) {
        var wrap = _ref.wrap, spacing = _ref.spacing, alignmentHorizontal = _ref.alignmentHorizontal, alignmentVertical = _ref.alignmentVertical, reverse = _ref.reverse;
        var spacingValues = (0, _parsers.parseSpacing)(spacing);
        var verticalSpacing = spacingValues[0];
        var horizontalSpacing = spacingValues[1] || verticalSpacing;
        return (0, _emotion.css)((0, _defineProperty2["default"])({
            width: wrap === "none" ? undefined : "calc(100% + ".concat(horizontalSpacing, "px)"),
            display: "flex",
            flexDirection: reverse ? "row-reverse" : "row",
            flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
            alignItems: {
                top: "flex-start",
                bottom: "flex-end"
            }[alignmentVertical] || alignmentVertical,
            justifyContent: {
                left: "flex-start",
                right: "flex-end",
                justify: "space-between"
            }[alignmentHorizontal] || alignmentHorizontal,
            // Reset the extra margins caused by the children on the right/bottom
            // edges. We can't do a simple reset on the first/last child because
            // there may be any number of children on the right/bottom edges if the
            // row wraps.
            margin: wrap === "none" ? undefined : "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0"),
            // Set margins and widths on the children of the row. Use !important to
            // override any existing styles.
            "& > *": {
                // Make sure that any borders or padding applied to the child don't throw
                // of the widths that we apply
                boxSizing: "border-box !important",
                // Set margins for horizontal spacing and vertical spacing if the row is
                // allowed to wrap (and clear other margins)
                margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
            }
        }, "& > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
            marginRight: "0 !important"
        } : undefined), // index in the dom matches the widths's index in the array. If we've
        // got a single height, apply that to all children.
        Array.isArray(widths) ? widths.reduce(function(result, width, index) {
            result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
                width: width,
                wrap: wrap,
                horizontalSpacing: horizontalSpacing
            });
            return result;
        }, {}) : {
            "& > *": childStyles({
                width: widths,
                wrap: wrap,
                horizontalSpacing: horizontalSpacing
            })
        });
    }, [
        "wrap",
        "spacing",
        "alignmentHorizontal",
        "alignmentVertical",
        "reverse"
    ]);
};
var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);
var childStyles = function childStyles(_ref2) {
    var rawWidth = _ref2.width, wrap = _ref2.wrap, horizontalSpacing = _ref2.horizontalSpacing;
    var width = parseWidth(rawWidth);
    return {
        // Stretch the child to fill remaining space if the width is "fill"
        flex: width.type === "flex" && width.value === "fill" ? "1 !important" : undefined,
        // Ensure that the child isn't smashed by flexbox if it has an explicit
        // width set.
        flexShrink: width.type === "grid" || width.type === "percentage" || width.type === "flex" && width.value === "fit" || width.type === "css" && width.value !== "auto" ? "0 !important" : undefined,
        width: width.type === "grid" || width.type === "percentage" ? // specified percentage of the row's width (e.g. 50%) but subtract the
        // gutter spacing from the width to ensure there's enough room for the
        // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
        // subtract the full gutter width since each element has a full gutter
        // to its right (the extra gutter on the right edge of the row is
        // removed with a negative margin on the parent element). For rows
        // that don't wrap the last element doesn't have a gutter to its
        // right, so things are a bit more complicated. In this case there's
        // one less gutter than there are elements in the row (e.g. 3 elements
        // have 2 gutters between them) so subtracting a full gutter from each
        // element's width would be too much. We have to spread out this saved
        // saved gutter space proportional to the percentage of the row that
        // the element takes up. For example if a row has two elements that
        // each take up 50% of the row with a single 16px gutter between them,
        // then we'd subtract 50% of the 16px gutter from each element giving
        // us a final width of 50% - 8px for each element.
        "calc(".concat(width.value * 100, "% - ").concat(horizontalSpacing - (wrap === "none" ? width.value * horizontalSpacing : 0), "px) !important") : width.type === "css" ? "".concat(width.value).concat(typeof width.value === "number" ? "px" : "", " !important") : undefined
    };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */ var Row = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    // A row with an explicit height cannot wrap
    var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array or scalar
    // for the "widths" property
    var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
    var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
        wrap: wrap
    })); // Apply the row styles to an extra div inside the box so margins that are
    // applied to the box (e.g. if the row is nested in another row) don't
    // conflict with the margins that are applied by `rowStyles`.
    return /*#__PURE__*/ _react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
        className: wrap === "none" ? (0, _cxMemoized["default"])(rowStyles, props.className) : (0, _cxMemoized["default"])(wrapContainerStyles, props.className),
        ref: ref
    }), wrap === "none" ? props.children : /*#__PURE__*/ _react["default"].createElement("div", {
        className: rowStyles
    }, props.children));
});
Row.displayName = "Row";
Row.propTypes = {};
Row.defaultProps = {
    wrap: "none",
    spacing: "medium",
    alignmentVertical: "center",
    alignmentHorizontal: "left"
};
var _default = Row;
exports["default"] = _default;

},{"9b4b36ce4ea6ff77":"5qxSW","d6f1cba739b2c8d2":"avcfc","36d17b52aba3e543":"6uln9","e61fba2eb5980d9":"9Mqtv","b23f388c06340df4":"1BAMo","949ec053dd0ff5c2":"dxZXY","a8b537e436c8539d":"b6Ogh","153b49997ddfa8f4":"iZdRW","5bf136f09ac7ea8":"hze9s","b2088ee3cf86e082":"5KZHn"}],"jz3IT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorisedDSPs", ()=>(0, _useAuthorizedDSPs.useAuthorisedDSPs));
parcelHelpers.export(exports, "useAuthorisedEntities", ()=>(0, _useAuthorisedEntities.useAuthorisedEntities));
parcelHelpers.export(exports, "useAuthorisedLps", ()=>(0, _useAuthorisedLps.useAuthorisedLps));
parcelHelpers.export(exports, "useLogisticParties", ()=>(0, _useLogisticParties.useLogisticParties));
parcelHelpers.export(exports, "useLpAccessRights", ()=>(0, _useLpAccessRights.useLpAccessRights));
parcelHelpers.export(exports, "useSelectedLp", ()=>(0, _useSelectedLp.useSelectedLp));
parcelHelpers.export(exports, "useTermAccessRights", ()=>(0, _useTermAccessRights.useTermAccessRights));
var _useAuthorisedEntities = require("./useAuthorisedEntities");
var _useAuthorisedLps = require("./useAuthorisedLps");
var _useAuthorizedDSPs = require("./useAuthorizedDSPs");
var _useLogisticParties = require("./useLogisticParties");
var _useLpAccessRights = require("./useLpAccessRights");
var _useSelectedLp = require("./useSelectedLp");
var _useTermAccessRights = require("./useTermAccessRights");

},{"./useAuthorisedEntities":"8sDqO","./useAuthorisedLps":"4ldfJ","./useAuthorizedDSPs":"9LZzF","./useLogisticParties":"hp4T8","./useLpAccessRights":"jqrBt","./useSelectedLp":"hA2Nq","./useTermAccessRights":"c64aJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ldfJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorisedLps", ()=>useAuthorisedLps);
var _useLogisticParties = require("./useLogisticParties");
var _useLogisticPartiesDefault = parcelHelpers.interopDefault(_useLogisticParties);
function useAuthorisedLps() {
    var logisticParties = (0, _useLogisticPartiesDefault.default)();
    return logisticParties === null || logisticParties === void 0 ? void 0 : logisticParties.authorizedLps;
}
exports.default = useAuthorisedLps;

},{"./useLogisticParties":"hp4T8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9LZzF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorisedDSPs", ()=>useAuthorisedDSPs);
var _useLogisticParties = require("./useLogisticParties");
var _useLogisticPartiesDefault = parcelHelpers.interopDefault(_useLogisticParties);
function useAuthorisedDSPs() {
    var logisticParties = (0, _useLogisticPartiesDefault.default)();
    return logisticParties === null || logisticParties === void 0 ? void 0 : logisticParties.authorizedDSPs;
}
exports.default = useAuthorisedDSPs;

},{"./useLogisticParties":"hp4T8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aQkpR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2197ec88e6076872");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BreadcrumbGroup", {
    enumerable: true,
    get: function get() {
        return _breadcrumbGroup["default"];
    }
});
exports["default"] = void 0;
var _breadcrumbGroup = _interopRequireDefault(require("c4064c8e9f2bf3d6"));
var _breadcrumb = _interopRequireDefault(require("d1920545a96e51f3"));
var _default = _breadcrumb["default"];
exports["default"] = _default;

},{"2197ec88e6076872":"5qxSW","c4064c8e9f2bf3d6":"hwJpJ","d1920545a96e51f3":"8cp96"}],"hwJpJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("764b863e1446266d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("5af13311df086803"));
var _propTypes = _interopRequireDefault(require("78c1dd0978725f94"));
var _emotion = require("6070797205bba985");
var _breadcrumb = _interopRequireDefault(require("df3a1e4dbb495f99"));
var _context = _interopRequireDefault(require("ea6409a4ef06584d"));
var _theme = require("f8ff24b5789596dd");
var _listReset = _interopRequireDefault(require("98a49966790d5e40"));
var _functional = require("eb4b634a966e01e0");
var styles = (0, _emotion.css)(_listReset["default"], {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
var getContextValue = (0, _functional.memoizeCurry)(function(t, selected) {
    return {
        t: t,
        selected: selected
    };
}, 1);
/**
 * Used to group a set of breadcrumbs.
 */ function BreadcrumbGroup(props) {
    var t = (0, _theme.useTheme)(_breadcrumb["default"], "breadcrumb");
    var breadcrumbs = _react["default"].Children.toArray(props.children);
    var lastIndex = breadcrumbs.length - 1;
    return /*#__PURE__*/ _react["default"].createElement("ul", {
        className: styles
    }, breadcrumbs.map(function(breadcrumb, index) {
        return /*#__PURE__*/ _react["default"].createElement(_context["default"].Provider, {
            key: index,
            value: getContextValue(t)(index === lastIndex)
        }, breadcrumb);
    }));
}
BreadcrumbGroup.propTypes = {};
var _default = BreadcrumbGroup;
exports["default"] = _default;

},{"764b863e1446266d":"5qxSW","5af13311df086803":"6uln9","78c1dd0978725f94":"9Mqtv","6070797205bba985":"1BAMo","df3a1e4dbb495f99":"dYSka","ea6409a4ef06584d":"2UZbQ","f8ff24b5789596dd":"dJlcb","98a49966790d5e40":"3Ja6h","eb4b634a966e01e0":"hze9s"}],"dYSka":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        breadcrumbForegroundColorDefault: tokens.themeForegroundAccentDefault,
        breadcrumbForegroundColorHover: tokens.themeForegroundAccentHover,
        breadcrumbForegroundColorPressed: tokens.themeForegroundAccentPressed,
        breadcrumbForegroundColorSelected: tokens.themeForegroundPrimaryDefault,
        breadcrumbSeparatorColor: tokens.themeBorderSecondaryDefault,
        breadcrumbSpacingHorizontal: 24,
        breadcrumbFontSize: 14,
        breadcrumbLineHeight: "20px",
        breadcrumbMotionDuration: "100ms",
        breadcrumbMotionFunction: "ease"
    };
};

},{}],"2UZbQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = require("357f55d943d03458");
var _default = /*#__PURE__*/ (0, _react.createContext)({});
exports["default"] = _default;

},{"357f55d943d03458":"6uln9"}],"3Ja6h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var listReset = {
    listStyle: "none",
    padding: 0,
    margin: 0
};
var _default = listReset;
exports["default"] = _default;

},{}],"8cp96":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("4260b2febb3efed4");
var _interopRequireDefault = require("1047c266173a48b0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("3cf9c01bcf0e65d2"));
var _react = _interopRequireWildcard(require("8e21c082b38586ff"));
var _propTypes = _interopRequireDefault(require("c0aba6054201111"));
var _emotion = require("5a4a97c6052fefe8");
var _chevronRightSmall = _interopRequireDefault(require("2778f9cc36e98633"));
var _context = _interopRequireDefault(require("9a887c1d8baa14a4"));
var _useFocus2 = _interopRequireDefault(require("23f0518004028189"));
var _clickable = _interopRequireDefault(require("d46011e3f1f83a61"));
var _tooltip = _interopRequireDefault(require("59403124487da189"));
var _text = _interopRequireDefault(require("8c7bba05316220d6"));
var _noTextWrap = _interopRequireDefault(require("d4b7eeb5cebc343d"));
var _focusRing = _interopRequireDefault(require("83a0a2d13c246024"));
var _getIconCss = _interopRequireDefault(require("df3b306b00a11522"));
var _token = require("f924715c7422ea2a");
var _filterPropsByPrefix = _interopRequireDefault(require("908176ec40779b11"));
var chevronIcon = (0, _token.getIconFromTokens)(_chevronRightSmall["default"]);
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var focus = _ref.focus, selected = _ref.selected;
    return (0, _emotion.css)((0, _text["default"])(t), {
        // This helps with the absolutely-positioned chevron icon.
        position: "relative",
        // Set a min width of 0 to allow truncation of text inside a flex child.
        // This does not work in IE11.
        // See: https://stackoverflow.com/a/36247448/2747759
        minWidth: 0,
        // Add spacing between breadcrumbs
        "li + &": {
            marginLeft: t("spacingHorizontal")
        },
        // Add an chevron icon to the left of the breadcrumb (unless it's the
        // first one).
        "li + &:before": {
            content: "''",
            display: "block",
            width: t("spacingHorizontal"),
            height: chevronIcon.height,
            backgroundImage: (0, _getIconCss["default"])(chevronIcon.data, t("separatorColor")),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            // Center the icon just to the left of the breadcrumb
            position: "absolute",
            right: "100%",
            top: "50%",
            marginTop: -(chevronIcon.height / 2)
        },
        "& > a, & > button": (0, _emotion.css)(_noTextWrap["default"], {
            display: "block",
            color: t("foregroundColor", selected ? "selected" : "default"),
            cursor: selected ? "default" : "pointer",
            transition: t.transitionCss("motion", "color"),
            ":hover": !selected ? {
                color: t("foregroundColorHover")
            } : undefined,
            ":active": !selected ? {
                color: t("foregroundColorPressed")
            } : undefined
        })
    }, (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        offset: 4
    }));
}, [
    "focus",
    "selected"
]);
/**
 * Used to render a single breadcrumb in a group of breadcrumbs. Place this as
 * a child of the BreadcrumbGroup component.
 */ var Breadcrumb = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var truncate = props.truncate, children = props.children;
    var _useContext = (0, _react.useContext)(_context["default"]), t = _useContext.t, selected = _useContext.selected;
    var _useFocus = (0, _useFocus2["default"])(), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]); // Wrap the breadcrumb in a tooltip if the `truncate` prop is set to true.
    var MaybeTooltip = (0, _react.useCallback)(function(props) {
        return truncate ? /*#__PURE__*/ _react["default"].createElement(_tooltip["default"], (0, _extends2["default"])({
            title: children,
            position: "bottom"
        }, props)) : /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, props);
    }, [
        truncate,
        children
    ]);
    return /*#__PURE__*/ _react["default"].createElement("li", {
        className: styles(t, {
            focus: focus && focusTrigger === "keyboard",
            selected: selected
        })
    }, /*#__PURE__*/ _react["default"].createElement(MaybeTooltip, null, /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
        "aria-current": selected ? "page" : undefined,
        disabled: selected,
        href: props.href,
        onClick: props.onClick,
        ref: ref
    }), props.truncate ? "\u2026" : props.children)));
});
Breadcrumb.displayName = "Breadcrumb";
Breadcrumb.propTypes = {};
var _default = Breadcrumb;
exports["default"] = _default;

},{"4260b2febb3efed4":"4RXTR","1047c266173a48b0":"5qxSW","3cf9c01bcf0e65d2":"fAmfl","8e21c082b38586ff":"6uln9","c0aba6054201111":"9Mqtv","5a4a97c6052fefe8":"1BAMo","2778f9cc36e98633":"4EdS9","9a887c1d8baa14a4":"2UZbQ","23f0518004028189":"7jVM9","d46011e3f1f83a61":"iWCwP","59403124487da189":"6eaDA","8c7bba05316220d6":"g6RQX","d4b7eeb5cebc343d":"9CFwe","83a0a2d13c246024":"5Dvm2","df3b306b00a11522":"dVcs8","f924715c7422ea2a":"bebc4","908176ec40779b11":"7Pq5E"}],"4EdS9":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconChevronRightSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
    iconChevronRightSmallWidth: 6,
    iconChevronRightSmallHeight: 10
};

},{}],"6eaDA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9d23f6d4e9d2498");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _tooltip = _interopRequireDefault(require("2b38ac57ba24ba0c"));
var _default = _tooltip["default"];
exports["default"] = _default;

},{"9d23f6d4e9d2498":"5qxSW","2b38ac57ba24ba0c":"bdPK3"}],"bdPK3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("35ee5099db0542fa");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("c4ecadda6e30b4fb"));
var _classCallCheck2 = _interopRequireDefault(require("9b402858a4a5e822"));
var _createClass2 = _interopRequireDefault(require("639ef394c935bbf9"));
var _assertThisInitialized2 = _interopRequireDefault(require("93475ca741af9655"));
var _inherits2 = _interopRequireDefault(require("f8dae779ad439446"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("c3f19589f8566436"));
var _getPrototypeOf2 = _interopRequireDefault(require("f32de4a9b358127e"));
var _defineProperty2 = _interopRequireDefault(require("d624b4ca790ae580"));
var _react = _interopRequireDefault(require("ab89239e1e5de356"));
var _reactDom = _interopRequireDefault(require("1c21f01855e6679a"));
var _propTypes = _interopRequireDefault(require("900f3637a75619dc"));
var _emotion = require("da853be1c06de974");
var _popover = _interopRequireDefault(require("1f2b14c02063c926"));
var _elevation = require("9a22db8d5a67c3f2");
var _theme = require("e671591f168d25d");
var _popoverBody = _interopRequireDefault(require("8118b2ebe96add26"));
var _popoverController = _interopRequireDefault(require("72c530fa82d63cae"));
var _utils = require("7f141384b2016095");
var _token = require("f5f8f409001034b1");
var _functional = require("c6221b2ca13343d2");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = (0, _functional.memoize)(function(maxWidth) {
    return (0, _emotion.css)({
        overflowWrap: "break-word",
        pointerEvents: "none",
        maxWidth: maxWidth
    });
});
/**
 * Add a tooltip to an element. A note on accessibility: tooltips should only be
 * added to elements that are focuseable. This allows keyboard users to open the
 * tooltip by tabbing to the tooltip's anchor node. Otherwise keyboard users
 * would not be able to open the tooltip. This means that *tooltips should not
 * be anchored to disabled elements directly*, since disabled elements generally
 * can't be focused. If you need to add context to a disabled element, consider
 * anchoring the tooltip to a help icon near the element:
 *
 * ```
 * <Row>
 *   <Button disabled={true}>Submit</Button>
 *   <Tooltip title="You can't perform this action, move along." position="right">
 *     <Icon tokens={helpIconTokens} tabIndex={0}>Help tooltip</Icon>
 *   </Tooltip>
 * </Row>
 * ```
 *
 * Alternatively you can wrap the disabled element in a non-disabled element to
 * ensure keyboard users can open the tooltip:
 *
 * ```
 * <Tooltip title="You can't perform this action, move along." position="right">
 *   <span tabIndex="0">
 *     <Button disabled={true}>Submit</Button>
 *   </span>
 * </Tooltip>
 * ```
 */ var Tooltip = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Tooltip, _React$Component);
    var _super = _createSuper(Tooltip);
    function Tooltip() {
        var _this;
        (0, _classCallCheck2["default"])(this, Tooltip);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            hover: false,
            focus: false
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOpen", function() {
            return _this.props.open === undefined ? _this.state.hover || _this.state.focus : _this.props.open;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorNode", function(node) {
            if (node && node !== _this.anchorNode) {
                /* eslint-disable-next-line react/no-find-dom-node */ _this.anchorNode = _reactDom["default"].findDOMNode(node); // If the Tooltip is managing state internally then bind the event
                // listeners that trigger internal state changes
                if (_this.props.open === undefined) _this.addEventListeners();
                 // If the Tooltip is supposed to be open then force an update so it
                // re-renders with the anchor node
                if (_this.isOpen()) _this.forceUpdate();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addEventListeners", function() {
            // Remove any existing event listeners to ensure we don't accidentally stack
            // multiple listeners
            _this.removeEventListeners();
            if (_this.anchorNode) {
                _this.anchorNode.addEventListener("mouseenter", _this.onMouseEnterAnchor); // NOTE: This *must* be bound using a native event listener because of a bug
                // in React: https://github.com/facebook/react/issues/4251
                _this.anchorNode.addEventListener("mouseleave", _this.onMouseLeaveAnchor);
                _this.anchorNode.addEventListener("focus", _this.onFocusAnchor, true);
                _this.anchorNode.addEventListener("blur", _this.onBlurAnchor, true);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeEventListeners", function() {
            if (_this.anchorNode) {
                _this.anchorNode.removeEventListener("mouseenter", _this.onMouseEnterAnchor);
                _this.anchorNode.removeEventListener("mouseleave", _this.onMouseLeaveAnchor);
                _this.anchorNode.removeEventListener("focus", _this.onFocusAnchor, true);
                _this.anchorNode.removeEventListener("blur", _this.onBlurAnchor, true);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterAnchor", function() {
            return _this.setState({
                hover: true
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveAnchor", function() {
            return _this.setState({
                hover: false,
                focus: false
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusAnchor", function() {
            return _this.setState({
                focus: true
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurAnchor", function() {
            return _this.setState({
                focus: false
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(Tooltip, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // If we're moving from state being managed via the `open` prop to state
                // being managed internally, bind the event listeners that trigger internal
                // state changes
                if (prevProps.open === undefined && this.props.open !== undefined) this.addEventListeners();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, title = _this$props.title, position = _this$props.position, maxWidth = _this$props.maxWidth, children = _this$props.children;
                var anchorNode = this.anchorNode;
                var oppositePosition = (0, _utils.flipAlignment)(position);
                var vertical = position === "top" || position === "bottom";
                var popover = /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _popover["default"],
                    map: (0, _token.getTokenHelper)("popover"),
                    key: "popover"
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_popoverController["default"], {
                        open: _this2.isOpen(),
                        anchorNode: anchorNode,
                        anchorOrigin: vertical ? "".concat(position, " center") : "center ".concat(position),
                        popoverOrigin: vertical ? "".concat(oppositePosition, " center") : "center ".concat(oppositePosition),
                        offsetVertical: vertical ? t("offsetWithArrow") : 0,
                        offsetHorizontal: vertical ? 0 : t("offsetWithArrow")
                    }, function(_ref) {
                        var popoverStyle = _ref.popoverStyle, popoverOrigin = _ref.popoverOrigin, anchorOrigin = _ref.anchorOrigin, anchorRect = _ref.anchorRect;
                        return /*#__PURE__*/ _react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({
                            style: popoverStyle,
                            type: "fill",
                            spacingInset: "small",
                            zIndex: _elevation.elevationTooltip,
                            className: styles(maxWidth)
                        }, _popoverBody["default"].generateArrowProps({
                            popoverOrigin: popoverOrigin,
                            anchorOrigin: anchorOrigin,
                            anchorRect: anchorRect
                        })), title);
                    });
                });
                var child = _react["default"].Children.only(children);
                return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].cloneElement(child, {
                    ref: this.updateAnchorNode
                }), popover);
            }
        }
    ]);
    return Tooltip;
}(_react["default"].Component);
Tooltip.propTypes = {};
Tooltip.defaultProps = {
    maxWidth: 300
};
var _default = Tooltip;
exports["default"] = _default;

},{"35ee5099db0542fa":"5qxSW","c4ecadda6e30b4fb":"fAmfl","9b402858a4a5e822":"aqLjQ","639ef394c935bbf9":"8X7ov","93475ca741af9655":"fA0LA","f8dae779ad439446":"hAMmu","c3f19589f8566436":"37tJc","f32de4a9b358127e":"cE6Se","d624b4ca790ae580":"avcfc","ab89239e1e5de356":"6uln9","1c21f01855e6679a":"b8T3j","900f3637a75619dc":"9Mqtv","da853be1c06de974":"1BAMo","1f2b14c02063c926":"lnaFx","9a22db8d5a67c3f2":"dKmTh","e671591f168d25d":"dJlcb","8118b2ebe96add26":"j1EaB","72c530fa82d63cae":"4IZFM","7f141384b2016095":"gBO50","f5f8f409001034b1":"bebc4","c6221b2ca13343d2":"hze9s"}],"lnaFx":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        popoverForegroundColorOutline: tokens.themeForegroundPrimaryDefault,
        popoverForegroundColorFill: "#FFFFFF",
        popoverBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
        popoverBackgroundColorFill: "#252829",
        popoverBorderWidth: 1,
        popoverBorderRadius: 4,
        popoverBorderColorOutline: tokens.themeBorderSecondaryDefault,
        popoverBorderColorFill: tokens.themeBorderAlternateDefault,
        popoverSpacingInsetVerticalSmall: 8,
        popoverSpacingInsetVerticalMedium: 12,
        popoverSpacingInsetHorizontalSmall: 8,
        popoverSpacingInsetHorizontalMedium: 12,
        popoverArrowWidth: 16,
        popoverArrowHeight: 8,
        popoverHeaderSpacingHorizontal: 8,
        popoverHeaderFontWeight: 600,
        popoverDropShadowOffsetX: 0,
        popoverDropShadowOffsetY: 1,
        popoverDropShadowBlur: 2,
        popoverDropShadowSpread: 0,
        popoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
        popoverMotionDuration: "150ms",
        popoverMotionFunction: "ease",
        popoverClosedScale: 90,
        popoverOffsetWithArrow: 16,
        popoverOffsetWithoutArrow: 8
    };
};

},{}],"j1EaB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8b7f7567f94ffac1");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _popoverBody = _interopRequireDefault(require("827effe1c4a8216e"));
var _default = _popoverBody["default"];
exports["default"] = _default;

},{"8b7f7567f94ffac1":"5qxSW","827effe1c4a8216e":"kiBRC"}],"kiBRC":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("218c98b4bb869a7c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("20b352768c5403ac"));
var _react = _interopRequireDefault(require("17aa30c203cc124b"));
var _propTypes = _interopRequireDefault(require("22b8bed776b14962"));
var _capitalize = _interopRequireDefault(require("ead2512ccd6346b5"));
var _emotion = require("d229d5221d609a5");
var _popover = _interopRequireDefault(require("339f674b005cb3dd"));
var _elevation = require("4d167db7880c9400");
var _theme = require("c2219bdb1cd2e88f");
var _utils = require("179e9bcd66957473");
var _token = require("6d007c599f3cc741");
var _cxMemoized = _interopRequireDefault(require("44e9f570951cfdd7"));
var _text = _interopRequireDefault(require("480c2f626a066dea"));
var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]), popoverArrowWidth = _getUnthemedTokens.popoverArrowWidth; // Takes an edge (e.g. "top") and turns it into a CSS border property (e.g.
// "borderTop").
var edgeToBorder = function edgeToBorder(edge) {
    return "border".concat((0, _capitalize["default"])(edge));
}; // Takes an edge (e.g. "top") and a CSS length (e.g. "5px") and creates a
// CSS translation function (e.g. "translateY(5px)") that can be added to an
// element  via the CSS "transform" property.
var edgeToTransform = function edgeToTransform(edge, amount) {
    return "translate".concat(edge === "left" || edge === "right" ? "X" : "Y", "(").concat(amount, ")");
}; // These styles are used to create the little arrow that points away from the
// popover. The method used to create the triangles involves psuedo elements
// with different transparent borders applied to certain sides. A good demo of
// this method can be found here: https://codepen.io/chriscoyier/pen/lotjh. The
// benefit of this method is that it doesn't require any images, but the
// downside is that you can't apply a border to the triangle. To get around
// this a border is faked by placing a slightly offset background-colored
// triangle (the :after pseudo element) on top of a border-colored triangle (the
// :before pseudo element).
var arrowStyles = function arrowStyles(t, _ref) {
    var _afterBefore, _before, _after;
    var type = _ref.type, arrowPosition = _ref.arrowPosition, arrowAlignment = _ref.arrowAlignment, arrowOffset = _ref.arrowOffset;
    var backgroundColor = t("backgroundColor", type);
    var borderColor = t("borderColor", type);
    var borderWidth = t("borderWidth");
    var arrowHeight = t("arrowHeight");
    var arrowWidthHalf = t("arrowWidth") / 2; // This is the edge of the popover (either "top" or "left") that is parallel
    // to the direction the arrow is pointing.
    var arrowParallelEdge = arrowPosition === "top" || arrowPosition === "bottom" ? "left" : "top"; // This is the edge of the popover that is opposite the edge that the arrow
    // is positioned on.
    var arrowOppositeEdge = (0, _utils.flipAlignment)(arrowPosition); // This uses maths to determine how far we have to scoot the fill triangle
    // along its axis to reveal exactly `borderWidth` pixels of the border
    // triangle along a line that is perpendicular to the edges of both triangles.
    var fillTriangleOffset = borderWidth / Math.sin(Math.atan(arrowWidthHalf / arrowHeight)); // This translates the arrow in the direction orthogonal to the direction that
    // the arrow is pointing (i.e. left/right for an arrow pointing up/down or
    // up/down for an arrow pointing left/right).
    var orthogonalTransform = ({
        top: [
            "".concat(arrowOffset, "px")
        ],
        left: [
            "".concat(arrowOffset, "px")
        ],
        right: [
            "-".concat(arrowOffset, "px"),
            "-100%"
        ],
        bottom: [
            "-".concat(arrowOffset, "px"),
            "-100%"
        ],
        center: [
            "".concat(arrowOffset, "px"),
            "-50%"
        ]
    })[arrowAlignment].map(function(amount) {
        return edgeToTransform(arrowParallelEdge, amount);
    }).join(" ");
    return (0, _emotion.css)({
        "&:after, &:before": (_afterBefore = {
            content: "''",
            position: "absolute",
            height: 0,
            width: 0
        }, (0, _defineProperty2["default"])(_afterBefore, arrowOppositeEdge, "100%"), (0, _defineProperty2["default"])(_afterBefore, arrowParallelEdge, {
            top: 0,
            left: 0,
            right: "100%",
            bottom: "100%",
            center: "50%"
        }[arrowAlignment]), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder(arrowParallelEdge), "".concat(arrowWidthHalf, "px solid transparent")), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder((0, _utils.flipAlignment)(arrowParallelEdge)), "".concat(arrowWidthHalf, "px solid transparent")), _afterBefore),
        // This creates a triangle with a background color that is the same color as
        // the popover's border.
        "&:before": (_before = {}, (0, _defineProperty2["default"])(_before, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(borderColor)), (0, _defineProperty2["default"])(_before, "transform", orthogonalTransform), _before),
        // If the popover has a border then this creates a triangle that is the same
        // color as the popover's background color. This triangle is displayed on
        // top of the border colored triangle but is scooted back just a bit to
        // reveal enough of the border triangle to create a faux border around
        // itself.
        "&:after": (_after = {}, (0, _defineProperty2["default"])(_after, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(backgroundColor)), (0, _defineProperty2["default"])(_after, "transform", "".concat(orthogonalTransform, " ").concat(edgeToTransform(arrowOppositeEdge, "".concat(arrowOppositeEdge === "top" || arrowOppositeEdge === "left" ? "-" : "").concat(fillTriangleOffset, "px")))), _after)
    });
};
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var type = _ref2.type, spacingInset = _ref2.spacingInset, zIndex = _ref2.zIndex, minWidth = _ref2.minWidth, maxWidth = _ref2.maxWidth, arrowPosition = _ref2.arrowPosition, arrowAlignment = _ref2.arrowAlignment, arrowOffset = _ref2.arrowOffset, allowOverflow = _ref2.allowOverflow;
    var borderColor = t("borderColor", type);
    return (0, _emotion.css)((0, _text["default"])(t, {
        color: type
    }), {
        display: "inline-block",
        position: "relative",
        outline: "none",
        zIndex: zIndex,
        minWidth: minWidth,
        maxWidth: maxWidth,
        // Children wrapper styles
        "& > div": {
            // If this is used with the PopoverController component then a max
            // width and height will be set on the outer element of this
            // component. Setting the max width and height to "inherit" here will
            // constrain this inner element to the same width/height as its parent
            // (oddly enough max width/height "100%" won't work because CSS). This
            // ensures that scrollbars will be shown for content that overflows.
            // Without these styles this element just extends outside of its
            // parent.
            maxHeight: allowOverflow ? "inherit" : undefined,
            maxWidth: allowOverflow ? "inherit" : undefined,
            overflow: allowOverflow ? "auto" : "hidden",
            padding: "".concat(t("spacingInsetVertical", spacingInset), "px ").concat(t("spacingInsetHorizontal", spacingInset), "px"),
            backgroundColor: t("backgroundColor", type),
            borderColor: borderColor,
            borderWidth: borderColor ? t("borderWidth") : undefined,
            borderStyle: borderColor ? "solid" : undefined,
            borderRadius: t("borderRadius"),
            boxShadow: t.boxShadowCss("dropShadow")
        }
    }, arrowPosition ? arrowStyles(t, {
        type: type,
        arrowPosition: arrowPosition,
        arrowAlignment: arrowAlignment,
        arrowOffset: arrowOffset
    }) : undefined);
}, [
    "type",
    "spacingInset",
    "zIndex",
    "maxWidth",
    "minWidth",
    "arrowPosition",
    "arrowAlignment",
    "arrowOffset",
    "allowOverflow"
]);
var PopoverBody = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_popover["default"], "popover");
    return /*#__PURE__*/ _react["default"].createElement("div", {
        onKeyDown: props.onKeyDown,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        tabIndex: props.tabIndex,
        style: props.style,
        className: (0, _cxMemoized["default"])(styles(t, props), props.className),
        role: props.tabIndex ? "dialog" : "tooltip",
        "aria-labelledby": props.labelledById,
        "aria-expanded": props.open,
        ref: ref
    }, /*#__PURE__*/ _react["default"].createElement("div", null, props.children));
}); // This helper generates the arrow props that are necessary to point a popover
// arrow at a particular anchor
PopoverBody.generateArrowProps = function(_ref3) {
    var popoverOrigin = _ref3.popoverOrigin, anchorOrigin = _ref3.anchorOrigin, anchorRect = _ref3.anchorRect;
    var vertical = popoverOrigin.y !== anchorOrigin.y && popoverOrigin.y === (0, _utils.flipAlignment)(anchorOrigin.y);
    var arrowAlignment = vertical ? popoverOrigin.x : popoverOrigin.y;
    return {
        arrowAlignment: arrowAlignment,
        arrowPosition: vertical ? popoverOrigin.y : popoverOrigin.x,
        arrowOffset: arrowAlignment !== "center" ? anchorRect[vertical ? "width" : "height"] / 2 - popoverArrowWidth / 2 : 0
    };
};
PopoverBody.displayName = "PopoverBody";
PopoverBody.propTypes = {};
PopoverBody.defaultProps = {
    open: true,
    type: "outline",
    arrowAlignment: "center",
    arrowOffset: 0,
    spacingInset: "small",
    zIndex: _elevation.elevationPopover
};
var _default = PopoverBody;
exports["default"] = _default;

},{"218c98b4bb869a7c":"5qxSW","20b352768c5403ac":"avcfc","17aa30c203cc124b":"6uln9","22b8bed776b14962":"9Mqtv","ead2512ccd6346b5":"8jaXJ","d229d5221d609a5":"1BAMo","339f674b005cb3dd":"lnaFx","4d167db7880c9400":"dKmTh","c2219bdb1cd2e88f":"dJlcb","179e9bcd66957473":"gBO50","6d007c599f3cc741":"bebc4","44e9f570951cfdd7":"5KZHn","480c2f626a066dea":"g6RQX"}],"8jaXJ":[function(require,module,exports) {
var toString = require("4769f7231617fc39"), upperFirst = require("76186119a48a09e3");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize(string) {
    return upperFirst(toString(string).toLowerCase());
}
module.exports = capitalize;

},{"4769f7231617fc39":"jihDg","76186119a48a09e3":"fgUbC"}],"fgUbC":[function(require,module,exports) {
var createCaseFirst = require("187c02d88eda6c82");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst("toUpperCase");
module.exports = upperFirst;

},{"187c02d88eda6c82":"8vE6B"}],"8vE6B":[function(require,module,exports) {
var castSlice = require("ad32686b71a1a4cb"), hasUnicode = require("b20574ba5ed087ed"), stringToArray = require("75a7e3369de8aa48"), toString = require("a2ff2d2fb7efa318");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"ad32686b71a1a4cb":"7axR9","b20574ba5ed087ed":"bpdpE","75a7e3369de8aa48":"3KFgu","a2ff2d2fb7efa318":"jihDg"}],"7axR9":[function(require,module,exports) {
var baseSlice = require("2f071255e0219767");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"2f071255e0219767":"897Ad"}],"897Ad":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"bpdpE":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"3KFgu":[function(require,module,exports) {
var asciiToArray = require("a0101a362c5d339b"), hasUnicode = require("6c2802bdb8560a5c"), unicodeToArray = require("da52e8333d943282");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"a0101a362c5d339b":"9Bjy2","6c2802bdb8560a5c":"bpdpE","da52e8333d943282":"kJuOQ"}],"9Bjy2":[function(require,module,exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split("");
}
module.exports = asciiToArray;

},{}],"kJuOQ":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"gBO50":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b06aa29adaa90d8e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBestOrigin = exports.getAvailableSpace = exports.flipOrigin = exports.flipAlignment = void 0;
var _defineProperty2 = _interopRequireDefault(require("3898363ba577cf11"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Flip an alignment string (e.g. from "top" to "bottom" etc)
 */ var flipAlignment = function flipAlignment(alignment) {
    return ({
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left",
        center: "center"
    })[alignment];
};
/**
 * Flip an origin (in the form of { x: "left", y: "bottom"}) across either one
 * or both axis.
 */ exports.flipAlignment = flipAlignment;
var flipOrigin = function flipOrigin(origin, flipX, flipY) {
    return {
        x: flipX ? flipAlignment(origin.x) : origin.x,
        y: flipY ? flipAlignment(origin.y) : origin.y
    };
};
/**
 * Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
 * any arbitrary extra space, and an axis, determine how much space is available
 * in the viewport along the provided axis to render a popover.
 */ exports.flipOrigin = flipOrigin;
var getAvailableSpaceOnAxis = function getAvailableSpaceOnAxis(axis, _ref) {
    var anchorOrigin = _ref.anchorOrigin, popoverOrigin = _ref.popoverOrigin, anchorRect = _ref.anchorRect, viewportRect = _ref.viewportRect, extraSpace = _ref.extraSpace;
    var edge = axis === "x" ? "left" : "top";
    var dimension = axis === "x" ? "width" : "height";
    var oppositeEdge = flipAlignment(edge); // Determine the position along the requested axis in the viewport that
    // represents the edge of the available space for the popover
    var popoverEdge = anchorOrigin[axis] === edge ? anchorRect[edge] : anchorOrigin[axis] === oppositeEdge ? anchorRect[edge] + anchorRect[dimension] : anchorOrigin[axis] === "center" ? anchorRect[edge] + anchorRect[dimension] / 2 : undefined; // Calculate the available space along the requested axis that the popover can
    // use to render
    var availableSpace = popoverOrigin[axis] === edge ? viewportRect[dimension] - popoverEdge - extraSpace[axis] : popoverOrigin[axis] === oppositeEdge ? popoverEdge - extraSpace[axis] : popoverOrigin[axis] === "center" ? 2 * (Math.min(viewportRect[dimension] - popoverEdge, popoverEdge) - extraSpace[axis]) : undefined;
    return Math.max(0, availableSpace);
}; // Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
// and any arbitrary extra space, determine how much space is available in the
// viewport to render a popover.
var getAvailableSpace = function getAvailableSpace(args) {
    return {
        x: getAvailableSpaceOnAxis("x", args),
        y: getAvailableSpaceOnAxis("y", args)
    };
};
/**
 * Given an axis and a bunch of other information, this determines the
 * transform that, when applied to the popover and anchor origins, will result
 * in the best origins to display the popover. The transform will either be a
 * shift left or right (or up or down) along the axis (e.g. center -> left or
 * center -> right) or a flip across the axis entirely (to the other side of the
 * anchor).
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 */ exports.getAvailableSpace = getAvailableSpace;
var getBestOriginTransformOnAxis = function getBestOriginTransformOnAxis(axis, args) {
    var getSpace = function getSpace(anchorOrigin, popoverOrigin) {
        return getAvailableSpaceOnAxis(axis, _objectSpread(_objectSpread({}, args), {}, {
            anchorOrigin: anchorOrigin,
            popoverOrigin: popoverOrigin
        }));
    };
    var edge = axis === "x" ? "left" : "top";
    var dimension = axis === "x" ? "width" : "height";
    var oppositeEdge = flipAlignment(edge);
    var spaceWithPreferredOrigin = getSpace(args.anchorOrigin, args.popoverOrigin);
    var preferredOriginIsGood = spaceWithPreferredOrigin >= args.popoverRect[dimension]; // If the popover is center-aligned on the anchor then try shifting it
    // left/right or up/down (depending on the axis)
    var tryShift = args.popoverOrigin[axis] === "center" && args.anchorOrigin[axis] === "center" && !preferredOriginIsGood;
    var spaceShiftedStart = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge))) : 0;
    var spaceShiftedEnd = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge))) : 0;
    var shift = spaceShiftedStart > spaceWithPreferredOrigin && spaceShiftedStart > spaceShiftedEnd ? edge : spaceShiftedEnd > spaceWithPreferredOrigin ? oppositeEdge : undefined; // If shifting didn't work then try flipping the popover over the axis
    // entirely (to the other side of the anchor).
    var tryFlip = !preferredOriginIsGood && !shift;
    var flip = tryFlip && getSpace(flipOrigin(args.anchorOrigin, axis === "x", axis === "y"), flipOrigin(args.popoverOrigin, axis === "x", axis === "y")) > spaceWithPreferredOrigin;
    return shift ? {
        type: "shift",
        axis: axis,
        alignment: shift
    } : flip ? {
        type: "flip",
        axis: axis
    } : {
        type: "none"
    };
};
/**
 * This is used to apply a transform from `getBestOriginTransformOnAxis` to an
 * origin object.
 */ var transformOrigin = function transformOrigin(transform, origin) {
    switch(transform.type){
        case "shift":
            return _objectSpread(_objectSpread({}, origin), {}, (0, _defineProperty2["default"])({}, transform.axis, transform.alignment));
        case "flip":
            return flipOrigin(origin, transform.axis === "x", transform.axis === "y");
        default:
            return origin;
    }
};
/**
 * Determine the anchor and popover origins that will work best for displaying
 * the popover. If there is enough space to show the popover at the origins
 * requested by the user then that will always be treated as the best option.
 * If there is not enough space at those origins *and* there are alternate
 * origins that will buy us more space, the origins that will give us the most
 * space are treated as the best option.
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 *
 * Note that a popover may be shifted side to side or flipped over it's anchor
 * entirely, but it will never moved to an adjacent side (e.g. from the left to
 * the top). Designers/developers should be able to choose good enough defaults
 * for their popovers that this kind of transform won't be necessary to render
 * the popovers within the viewport.
 */ var getBestOrigin = function getBestOrigin(args) {
    // Determine the transforms along the x and y axis that will result in the
    // best display of the popover (not running off any edges of the viewport).
    var transformX = getBestOriginTransformOnAxis("x", args);
    var transformY = getBestOriginTransformOnAxis("y", args); // Apply the transforms to both the anchor origin and the popover origin
    var bestAnchorOrigin = transformOrigin(transformY, transformOrigin(transformX, args.anchorOrigin));
    var bestPopoverOrigin = transformOrigin(transformY, transformOrigin(transformX, args.popoverOrigin)); // Return the new origins along with the available space that they obtained
    // for the popover
    return {
        anchorOrigin: bestAnchorOrigin,
        popoverOrigin: bestPopoverOrigin,
        availableSpace: getAvailableSpace(_objectSpread(_objectSpread({}, args), {}, {
            anchorOrigin: bestAnchorOrigin,
            popoverOrigin: bestPopoverOrigin
        }))
    };
};
exports.getBestOrigin = getBestOrigin;

},{"b06aa29adaa90d8e":"5qxSW","3898363ba577cf11":"avcfc"}],"4IZFM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("dcf57ca0a024b439");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _popoverController = _interopRequireDefault(require("5b47495c0901943e"));
var _default = _popoverController["default"];
exports["default"] = _default;

},{"dcf57ca0a024b439":"5qxSW","5b47495c0901943e":"98zTK"}],"98zTK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b58a8425aa1ca5da");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("5c50284adb703c8e"));
var _classCallCheck2 = _interopRequireDefault(require("69d4f1948a641ad2"));
var _createClass2 = _interopRequireDefault(require("73d951650c0bcedf"));
var _assertThisInitialized2 = _interopRequireDefault(require("3cce7982c9833c42"));
var _inherits2 = _interopRequireDefault(require("c7663a0d774f9049"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("5f12088c8d8dd8cf"));
var _getPrototypeOf2 = _interopRequireDefault(require("686930d6a5b4182e"));
var _defineProperty2 = _interopRequireDefault(require("c92ff36eeb630980"));
var _react = _interopRequireDefault(require("130b6599d2a80ea4"));
var _reactDom = _interopRequireDefault(require("6995890f9ddb217d"));
var _propTypes = _interopRequireDefault(require("9124242d5ec68bfe"));
var _noop = _interopRequireDefault(require("6ccb13e754b63e40"));
var _popover = _interopRequireDefault(require("86f5c4b7a1f99a1"));
var _utils = require("fc6cdc6ca757846e");
var _portal = _interopRequireDefault(require("afe261e9c9e06179"));
var _transitionController = _interopRequireDefault(require("4131931269eb3334"));
var _propTypes2 = _interopRequireDefault(require("9f7b39f31a0be6d0"));
var _parsers = require("d14bef845f5ffacb");
var _addDebouncedEventListener = _interopRequireDefault(require("3e5658dd89b66b76"));
var _waitAnimationFrame = _interopRequireDefault(require("94b9dd1369901513"));
var _nodeBounds = require("6fedeeb0277e77e2");
var _token = require("5cc13ce3b7819173");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// The closest a popover can be shown to the edge of the viewport
var viewportPadding = 16; // Grab the popover motion duration and function from our tokens.
var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]), popoverMotionDuration = _getUnthemedTokens.popoverMotionDuration, popoverMotionFunction = _getUnthemedTokens.popoverMotionFunction, popoverClosedScale = _getUnthemedTokens.popoverClosedScale;
/**
 * Styles
 */ // NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.
var styles = function styles(_ref) {
    var shrinkToFit = _ref.shrinkToFit, offsetHorizontal = _ref.offsetHorizontal, offsetVertical = _ref.offsetVertical, maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, anchorRect = _ref.anchorRect, viewportRect = _ref.viewportRect, state = _ref.state, anchorOrigin = _ref.anchorOrigin, popoverOrigin = _ref.popoverOrigin, availableSpace = _ref.availableSpace;
    // The distance to offset the popover from the anchor's left edge (changes
    // based on the anchor origin).
    var offsetFromAnchorLeft = {
        left: -offsetHorizontal,
        center: anchorRect.width / 2 + offsetHorizontal,
        right: anchorRect.width + offsetHorizontal
    }[anchorOrigin.x]; // The distance to offset the popover from the anchor's top edge (changes
    // based on the anchor origin).
    var offsetFromAnchorTop = {
        top: -offsetVertical,
        center: anchorRect.height / 2 + offsetVertical,
        bottom: anchorRect.height + offsetVertical
    }[anchorOrigin.y];
    return {
        position: "fixed",
        boxSizing: "border-box",
        // Anchor the popover's position from its bottom edge if it's anchored at
        // the bottom. This ensures long content forces the popover to expand
        // downwards.
        top: state !== "exited" && popoverOrigin.y !== "bottom" ? anchorRect.top + offsetFromAnchorTop - viewportPadding : undefined,
        // Anchor the popover's position from its bottom edge if it's anchored at
        // the bottom. This ensures long content forces the popover to expand
        // upwards.
        bottom: state !== "exited" && popoverOrigin.y === "bottom" ? viewportRect.height - anchorRect.top - offsetFromAnchorTop - viewportPadding : undefined,
        // Anchor the popover's position from its left edge if it's anchored at the
        // the left or center. This ensures long content forces the popover to
        // expand to the right.
        left: state !== "exited" && popoverOrigin.x !== "right" ? anchorRect.left + offsetFromAnchorLeft - viewportPadding : undefined,
        // Anchor the popover's position from its right edge if it's anchored at the
        // right. This ensures long content forces the popover to expand to the left.
        right: state !== "exited" && popoverOrigin.x === "right" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft - viewportPadding : undefined,
        transformOrigin: "".concat(popoverOrigin.y, " ").concat(popoverOrigin.x),
        opacity: state === "exited" || state === "exiting" ? 0 : 1,
        // For popovers that are anchored at their center, apply a transform to
        // ensure that the popover is positioned correctly and that long content
        // forces it to expand from the center.
        transform: "translateY(".concat(popoverOrigin.y === "center" ? "-50%" : "0%", ") translateX(").concat(popoverOrigin.x === "center" ? "-50%" : "0%", ") scale(").concat(state === "exited" || state === "exiting" ? popoverClosedScale / 100 : 1, ")"),
        transition: state === "entering" || state === "entered" || state === "exiting" ? "transform ".concat(popoverMotionDuration, " ").concat(popoverMotionFunction, ", opacity ").concat(popoverMotionDuration, " ").concat(popoverMotionFunction) : undefined,
        visibility: state === "exited" ? "hidden" : "visible",
        // Add margin on every side to make sure that the viewport padding is
        // maintained
        margin: viewportPadding,
        // If the user has specified a maxHeight then use that. If the popover is
        // open and the `shrinkToFit` prop is set then also constrain by the
        // available vertical space.
        maxHeight: state !== "exited" && shrinkToFit ? Math.min(maxHeight || availableSpace.y, availableSpace.y) : maxHeight,
        // If the user has specified a maxWidth then use that. If the popover is
        // open and the `shrinkToFit` prop is set then also constrain by the
        // available horizontal space.
        maxWidth: state !== "exited" && shrinkToFit ? Math.min(maxWidth || availableSpace.x, availableSpace.x) : maxWidth
    };
};
/**
 * This component handles the positioning of popover content in relation to
 * another element (the "anchor" element). It allows you to "stick" the popover
 * to the anchor element.
 *
 * This component has two real benefits over a simple absolute-positing strategy
 * for popover content. First, it renders popover content at the root of the DOM
 * using portals. This allows popovers to break out of the anchor element's
 * parent containers regardless of any overflow/scroll styles on those
 * containers. Second, this component will automatically re-position and re-size
 * the popover content based on the available space in the viewport. This
 * ensures that the content in the popover will be as accessible to the user as
 * possible.
 *
 * This component does not actually render anything to the DOM. It simply
 * generates the styles necessary to correctly position the popover. The styles
 * are passed via render props to the component's children so that the user can
 * render the popover exactly how they want to. This requires that the user set
 * the style prop on their popover element to the `popoverStyle` render prop
 * returned by this component.
 */ var PopoverController = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(PopoverController, _React$Component);
    var _super = _createSuper(PopoverController);
    function PopoverController() {
        var _this;
        (0, _classCallCheck2["default"])(this, PopoverController);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            // Should we render the popover's children? We don't when the popover is
            // closed to avoid unnecessary work.
            render: false,
            // The bounding rectangle for the anchor node.
            anchorRect: _nodeBounds.emptyNodeBounds,
            // The bounding rectangle for the popover node.
            popoverRect: _nodeBounds.emptyNodeBounds,
            // The bounding rectangle for the viewport.
            viewportRect: _nodeBounds.emptyNodeBounds
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorRect", function() {
            var _this$props = _this.props, open = _this$props.open, anchorNode = _this$props.anchorNode;
            if (open) {
                /* eslint-disable-next-line react/no-find-dom-node */ var anchorDomNode = _reactDom["default"].findDOMNode(anchorNode);
                var anchorRect = (0, _nodeBounds.getNodeBounds)(anchorDomNode);
                if (!(0, _nodeBounds.compareNodeBounds)(anchorRect, _this.state.anchorRect)) _this.setState({
                    anchorRect: anchorRect
                });
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateViewportRect", function() {
            var viewportRect = (0, _nodeBounds.getNodeBounds)(window);
            if (!(0, _nodeBounds.compareNodeBounds)(viewportRect, _this.state.viewportRect)) _this.setState({
                viewportRect: viewportRect
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePopoverRect", function() {
            var popoverRect = (0, _nodeBounds.getNodeBounds)(_this.popoverNode);
            if (!(0, _nodeBounds.compareNodeBounds)(popoverRect, _this.state.popoverRect)) _this.setState({
                popoverRect: popoverRect
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResizeWindow", function() {
            _this.updateViewportRect();
            _this.updateAnchorRect();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function(event) {
            var open = _this.props.open;
            var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this), popoverNode = _assertThisInitialize.popoverNode; // If the popover is open and the scroll event came from *outside* the
            // popover then assume the anchor element moved (and an update is needed for
            // the anchor rect).
            if (open && (!popoverNode || !popoverNode.contains(event.target))) _this.updateAnchorRect();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function(done) {
            _this.props.onBeforeOpen();
            _this.setState({
                render: true
            }, function() {
                // Give the children a chance to settle before poking through the DOM
                _this.cancelAnimationFrame = (0, _waitAnimationFrame["default"])(function() {
                    /* eslint-disable-next-line react/no-find-dom-node */ _this.popoverNode = _reactDom["default"].findDOMNode((0, _assertThisInitialized2["default"])(_this));
                    _this.updateViewportRect();
                    _this.updateAnchorRect();
                    _this.updatePopoverRect();
                    _this.addEventListeners();
                    done();
                });
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function(done) {
            _this.props.onOpen(_this.popoverNode);
            done();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function() {
            _this.props.onClose(_this.popoverNode);
            _this.removeEventListeners();
            _this.setState({
                render: false
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(PopoverController, [
        {
            key: "addEventListeners",
            value: function addEventListeners() {
                // Remove any existing event listeners just to be safe
                this.removeEventListeners(); // Listen for *any* scroll event in the document
                this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.onScroll, true)); // Listen for resize events from the window
                this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.onResizeWindow));
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                this.eventListeners.forEach(function(removeListener) {
                    return removeListener();
                });
                this.eventListeners = [];
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (this.props.open && Boolean(this.props.anchorNode)) /* eslint-disable-next-line react/no-find-dom-node */ this.onBeforeOpen(function() {
                    return _this2.onOpen(_noop["default"]);
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeEventListeners();
                if (this.cancelAnimationFrame) this.cancelAnimationFrame();
                clearTimeout(this.blurTimeout);
                clearTimeout(this.animationTimeout);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var anchorNode = this.props.anchorNode;
                if (anchorNode !== prevProps.anchorNode) this.updateAnchorRect();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, props = (0, _objectWithoutProperties2["default"])(_this$props2, [
                    "children"
                ]);
                var _this$state = this.state, anchorRect = _this$state.anchorRect, popoverRect = _this$state.popoverRect, viewportRect = _this$state.viewportRect, render = _this$state.render;
                var _getBestOrigin = (0, _utils.getBestOrigin)({
                    anchorOrigin: (0, _parsers.parseAlignment)(this.props.anchorOrigin),
                    popoverOrigin: (0, _parsers.parseAlignment)(this.props.popoverOrigin),
                    extraSpace: {
                        x: props.offsetHorizontal + viewportPadding,
                        y: props.offsetVertical + viewportPadding
                    },
                    anchorRect: anchorRect,
                    popoverRect: popoverRect,
                    viewportRect: viewportRect
                }), anchorOrigin = _getBestOrigin.anchorOrigin, popoverOrigin = _getBestOrigin.popoverOrigin, availableSpace = _getBestOrigin.availableSpace;
                return /*#__PURE__*/ _react["default"].createElement(_transitionController["default"], {
                    "in": props.open && Boolean(props.anchorNode),
                    duration: parseInt(popoverMotionDuration),
                    onBeforeEnter: this.onBeforeOpen,
                    onEnter: this.onOpen,
                    onAfterExit: this.onAfterClose
                }, function(state) {
                    return render ? /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, children({
                        popoverState: state,
                        popoverStyle: styles({
                            shrinkToFit: props.shrinkToFit,
                            offsetHorizontal: props.offsetHorizontal,
                            offsetVertical: props.offsetVertical,
                            maxHeight: props.maxHeight,
                            maxWidth: props.maxWidth,
                            state: state,
                            anchorOrigin: anchorOrigin,
                            popoverOrigin: popoverOrigin,
                            anchorRect: anchorRect,
                            popoverRect: popoverRect,
                            viewportRect: viewportRect,
                            availableSpace: availableSpace
                        }),
                        popoverOrigin: popoverOrigin,
                        anchorOrigin: anchorOrigin,
                        anchorRect: anchorRect
                    })) : null;
                });
            }
        }
    ]);
    return PopoverController;
}(_react["default"].Component);
(0, _defineProperty2["default"])(PopoverController, "defaultProps", {
    offsetHorizontal: 0,
    offsetVertical: 0,
    onBeforeOpen: _noop["default"],
    onOpen: _noop["default"],
    onClose: _noop["default"]
});
PopoverController.propTypes = {};
var _default = PopoverController;
exports["default"] = _default;

},{"b58a8425aa1ca5da":"5qxSW","5c50284adb703c8e":"DlKuU","69d4f1948a641ad2":"aqLjQ","73d951650c0bcedf":"8X7ov","3cce7982c9833c42":"fA0LA","c7663a0d774f9049":"hAMmu","5f12088c8d8dd8cf":"37tJc","686930d6a5b4182e":"cE6Se","c92ff36eeb630980":"avcfc","130b6599d2a80ea4":"6uln9","6995890f9ddb217d":"b8T3j","9124242d5ec68bfe":"9Mqtv","6ccb13e754b63e40":"hxHyu","86f5c4b7a1f99a1":"lnaFx","fc6cdc6ca757846e":"gBO50","afe261e9c9e06179":"kr8m8","4131931269eb3334":"5fxtO","9f7b39f31a0be6d0":"b6Ogh","d14bef845f5ffacb":"iZdRW","3e5658dd89b66b76":"a2cMr","94b9dd1369901513":"oJLwr","6fedeeb0277e77e2":"c8pLh","5cc13ce3b7819173":"bebc4"}],"DlKuU":[function(require,module,exports) {
var objectWithoutPropertiesLoose = require("656740bbf321fc77");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = _objectWithoutProperties;

},{"656740bbf321fc77":"izh3e"}],"izh3e":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose;

},{}],"kr8m8":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5241cb19fb55a164");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _portal = _interopRequireDefault(require("1af6543caef63bfa"));
var _default = _portal["default"];
exports["default"] = _default;

},{"5241cb19fb55a164":"5qxSW","1af6543caef63bfa":"hODtQ"}],"hODtQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c24fb8bc4cd185b6");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("91b5dd1a3f6fae7d"));
var _createClass2 = _interopRequireDefault(require("a45f43cfdd4f9bc4"));
var _inherits2 = _interopRequireDefault(require("7eb2946df3e35b13"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("37e45b72d94a7032"));
var _getPrototypeOf2 = _interopRequireDefault(require("2facc04529e9ef7d"));
var _react = _interopRequireDefault(require("c8048644d01bdf19"));
var _propTypes = _interopRequireDefault(require("2133ed2fcd9caf99"));
var _reactDom = _interopRequireDefault(require("d723a6966931d5f9"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var Portal = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Portal, _React$Component);
    var _super = _createSuper(Portal);
    function Portal() {
        (0, _classCallCheck2["default"])(this, Portal);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(Portal, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
            }
        },
        {
            key: "render",
            value: function render() {
                if (!canUseDOM) return null;
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement("div");
                    document.body.appendChild(this.defaultNode);
                }
                return /*#__PURE__*/ _reactDom["default"].createPortal(this.props.children, this.props.node || this.defaultNode);
            }
        }
    ]);
    return Portal;
}(_react["default"].Component);
Portal.propTypes = {};
var _default = Portal;
exports["default"] = _default;

},{"c24fb8bc4cd185b6":"5qxSW","91b5dd1a3f6fae7d":"aqLjQ","a45f43cfdd4f9bc4":"8X7ov","7eb2946df3e35b13":"hAMmu","37e45b72d94a7032":"37tJc","2facc04529e9ef7d":"cE6Se","c8048644d01bdf19":"6uln9","2133ed2fcd9caf99":"9Mqtv","d723a6966931d5f9":"b8T3j"}],"5fxtO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f30591ba698bae49");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _transitionController = _interopRequireDefault(require("a6eed2ed92fde3af"));
var _default = _transitionController["default"];
exports["default"] = _default;

},{"f30591ba698bae49":"5qxSW","a6eed2ed92fde3af":"d9Oqt"}],"d9Oqt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e88400316166a28b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("a2e4dd3f4139e39f"));
var _createClass2 = _interopRequireDefault(require("ae269aff4d39d000"));
var _assertThisInitialized2 = _interopRequireDefault(require("85a912f96e198275"));
var _inherits2 = _interopRequireDefault(require("92bf773432d47737"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("53ddc3dd2c598703"));
var _getPrototypeOf2 = _interopRequireDefault(require("36ed4098d3d41fe"));
var _defineProperty2 = _interopRequireDefault(require("5a23c28b14b3a87d"));
var _react = _interopRequireDefault(require("36255ebd4bbdff7c"));
var _propTypes = _interopRequireDefault(require("388d0fead27a30a9"));
var _noop = _interopRequireDefault(require("5054a90082d54e2a"));
var _waitAnimationFrame = _interopRequireDefault(require("322652859fc0ae8b"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var noopWithCallback = function noopWithCallback(callback) {
    return callback();
};
/**
 * This component makes it easy to apply complex transitions to elements. You
 * tell it whether the children should be transitioned in or out and what the
 * duration of the transition should be. It will provide you with the state of
 * the transition via a render prop. The state may be one of four values:
 * "entering", "entered", "exiting", or "exited". Six lifecycle hooks are
 * available: onBeforeEnter, onEnter, onAfterEnter, onBeforeExit, onExit, and
 * onAfterExit.
 */ var TransitionController = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(TransitionController, _React$Component);
    var _super = _createSuper(TransitionController);
    function TransitionController() {
        var _this;
        (0, _classCallCheck2["default"])(this, TransitionController);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            state: _this.props["in"] ? "entered" : "exited"
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelWait", _noop["default"]);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callback", _noop["default"]);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitAnimationFrame", function(callback, skip) {
            if (skip) callback();
            else {
                _this.cancelWait();
                _this.cancelWait = (0, _waitAnimationFrame["default"])(callback);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitDuration", function(callback) {
            var timeout;
            _this.cancelWait();
            _this.cancelWait = function() {
                return clearTimeout(timeout);
            };
            timeout = setTimeout(callback, _this.props.duration);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withCallback", function(func) {
            return function(callback) {
                _this.callback = callback;
                func(function() {
                    if (_this.callback === callback) callback();
                });
            };
        });
        return _this;
    }
    (0, _createClass2["default"])(TransitionController, [
        {
            key: "transition",
            /**
     * This orchestrates a transition. The basic flow is:
     * 1) cancel any existing timeouts
     * 2) call onBefore
     * 3) wait for a single animation frame *if* onBefore is defined (so that the
     *    DOM has a chance to settle)
     * 4) update the state to transitioning
     * 5) wait for a single animation frame *if* onTransition is defined (so that
     *    the DOM has a chance to settle)
     * 6) call onTransition
     * 7) wait for the duration of the animation
     * 8) update the state to transitioned
     * 9) wait for a single animation frame
     * 10) call onAfter
     */ value: function transition(_ref) {
                var _this2 = this;
                var onBefore = _ref.onBefore, onTransition = _ref.onTransition, onAfter = _ref.onAfter, stateDuring = _ref.stateDuring, stateAfter = _ref.stateAfter;
                var onBeforeWithCallback = this.withCallback(onBefore);
                var onTransitionWithCallback = this.withCallback(onTransition);
                this.cancelWait();
                onBeforeWithCallback(function() {
                    return _this2.waitAnimationFrame(function() {
                        return _this2.setState({
                            state: stateDuring
                        }, function() {
                            return _this2.waitAnimationFrame(function() {
                                return onTransitionWithCallback(function() {
                                    return _this2.waitDuration(function() {
                                        return _this2.setState({
                                            state: stateAfter
                                        }, _this2.waitAnimationFrame(onAfter, onAfter === _noop["default"]));
                                    });
                                });
                            }, // provided
                            onTransition === noopWithCallback);
                        });
                    }, onBefore === noopWithCallback);
                });
            }
        },
        {
            key: "transitionIn",
            value: function transitionIn() {
                this.transition({
                    onBefore: this.props.onBeforeEnter,
                    onTransition: this.props.onEnter,
                    onAfter: this.props.onAfterEnter,
                    stateDuring: "entering",
                    stateAfter: "entered"
                });
            }
        },
        {
            key: "transitionOut",
            value: function transitionOut() {
                this.transition({
                    onBefore: this.props.onBeforeExit,
                    onTransition: this.props.onExit,
                    onAfter: this.props.onAfterExit,
                    stateDuring: "exiting",
                    stateAfter: "exited"
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props["in"] && !prevProps["in"]) this.transitionIn();
                else if (!this.props["in"] && prevProps["in"]) this.transitionOut();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelWait();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children(this.state.state);
            }
        }
    ]);
    return TransitionController;
}(_react["default"].Component);
(0, _defineProperty2["default"])(TransitionController, "defaultProps", {
    onBeforeEnter: noopWithCallback,
    onEnter: noopWithCallback,
    onAfterEnter: _noop["default"],
    onBeforeExit: noopWithCallback,
    onExit: noopWithCallback,
    onAfterExit: _noop["default"]
});
TransitionController.propTypes = {};
var _default = TransitionController;
exports["default"] = _default;

},{"e88400316166a28b":"5qxSW","a2e4dd3f4139e39f":"aqLjQ","ae269aff4d39d000":"8X7ov","85a912f96e198275":"fA0LA","92bf773432d47737":"hAMmu","53ddc3dd2c598703":"37tJc","36ed4098d3d41fe":"cE6Se","5a23c28b14b3a87d":"avcfc","36255ebd4bbdff7c":"6uln9","388d0fead27a30a9":"9Mqtv","5054a90082d54e2a":"hxHyu","322652859fc0ae8b":"oJLwr"}],"oJLwr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// Executes code after waiting at least one whole animation frame. This is
// helpful when you want to allow DOM updates to settle before triggering
// something like a css transition. This returns a function that can be used to
// cancel the callback.
var waitAnimationFrame = function waitAnimationFrame(callback) {
    var frame = requestAnimationFrame(function() {
        frame = requestAnimationFrame(callback);
    });
    return function() {
        return cancelAnimationFrame(frame);
    };
};
var _default = waitAnimationFrame;
exports["default"] = _default;

},{}],"a2cMr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var addDebouncedEventListener = function addDebouncedEventListener(node, event, listener, options) {
    var timeout = null;
    var debouncedListener = function debouncedListener(event) {
        window.cancelAnimationFrame(timeout);
        if (window && window.requestAnimationFrame) timeout = window.requestAnimationFrame(function() {
            return listener(event);
        });
    };
    if (node && node.addEventListener) node.addEventListener(event, debouncedListener, options);
    return function() {
        window.cancelAnimationFrame(timeout);
        if (node && node.removeEventListener) node.removeEventListener(event, debouncedListener, options);
    };
};
var _default = addDebouncedEventListener;
exports["default"] = _default;

},{}],"c8pLh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNodeBounds = exports.compareNodeBounds = exports.emptyNodeBounds = void 0;
var emptyNodeBounds = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
};
exports.emptyNodeBounds = emptyNodeBounds;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Check to see if two rectangles, defined by top/left origin and width/height,
 * are equal.
 */ var compareNodeBounds = function compareNodeBounds(a, b) {
    return a === b || a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
};
/**
 * This returns a rectangle from a DOM node that represents the size and
 * position of the node relative to the viewport. If the node does not exist
 * then an empty rectangle is returned. Note that the width and height do not
 * take any CSS scale transforms into account.
 */ exports.compareNodeBounds = compareNodeBounds;
var getNodeBounds = function getNodeBounds(node) {
    if (!canUseDOM) return emptyNodeBounds;
    else if (node === window) {
        var width = window.innerWidth;
        var height = window.innerHeight;
        return {
            top: 0,
            left: 0,
            width: width,
            height: height
        };
    } else if (node === document.documentElement) {
        // For the document element, getBoundingClientRect() will return scroll
        // offset instead of actual position for top/left values (in all browsers
        // except edge). This is inconsistent with the function's behavior for other
        // nodes (in all browsers except edge). Resolve this by just assuming the
        // top/left of the document element is 0/0 (true in all cases except for
        // when the "html" tag has been repositioned with CSS, which is rare).
        var _node$getBoundingClie = node.getBoundingClientRect(), _width = _node$getBoundingClie.width, _height = _node$getBoundingClie.height;
        return {
            top: 0,
            left: 0,
            width: _width,
            height: _height
        };
    } else if (node && node.getBoundingClientRect) {
        // For normal nodes, get the width and height from offsetWidth and
        // offsetHeight instead of getBoundingClientRect. This will ignore any CSS
        // scale transforms that are applied.
        var _width2 = node.offsetWidth;
        var _height2 = node.offsetHeight;
        var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top, left = _node$getBoundingClie2.left;
        return {
            top: top,
            left: left,
            width: _width2,
            height: _height2
        };
    } else return emptyNodeBounds;
};
exports.getNodeBounds = getNodeBounds;

},{}],"9CFwe":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var noTextWrap = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};
var _default = noTextWrap;
exports["default"] = _default;

},{}],"dVcs8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Generate a CSS value for an encoded svg icon. This essentially just sets the
 * color and wraps the data in a "url()".
 *
 * @example
 * getIconCss(data, "#000")
 */ var getIconCss = function getIconCss(data, color) {
    return data && color ? 'url("'.concat(data.replace(new RegExp("currentColor", "g"), // this change: https://www.chromestatus.com/feature/5656049583390720
    color.replace(new RegExp("#", "g"), "%23")), '")') : "none";
};
var _default = getIconCss;
exports["default"] = _default;

},{}],"3hMBK":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"awUBr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _emotionCssCreateInstanceEsmJs = require("../create-instance/dist/emotion-css-create-instance.esm.js");
var _emotionCssCreateInstanceEsmJsDefault = parcelHelpers.interopDefault(_emotionCssCreateInstanceEsmJs);
var _cache = require("@emotion/cache");
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
var _createEmotion = (0, _emotionCssCreateInstanceEsmJsDefault.default)({
    key: "css"
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

},{"../create-instance/dist/emotion-css-create-instance.esm.js":"bmBhN","@emotion/cache":"dJbf5","@emotion/serialize":"2Iv9c","@emotion/utils":"firjl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmBhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createEmotion);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};

},{"@emotion/cache":"dJbf5","@emotion/serialize":"2Iv9c","@emotion/utils":"firjl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJbf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"8lIuE","stylis":"lfeQC","@emotion/weak-memoize":"9scve","@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8lIuE":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfeQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9scve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dMybP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Iv9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"2ma2h","@emotion/unitless":"dfdEh","@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ma2h":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfdEh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"firjl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kbQW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _intl.createIntlCache));
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>(0, _intl.UnsupportedFormatterError));
parcelHelpers.export(exports, "InvalidConfigError", ()=>(0, _intl.InvalidConfigError));
parcelHelpers.export(exports, "MissingDataError", ()=>(0, _intl.MissingDataError));
parcelHelpers.export(exports, "MessageFormatError", ()=>(0, _intl.MessageFormatError));
parcelHelpers.export(exports, "MissingTranslationError", ()=>(0, _intl.MissingTranslationError));
parcelHelpers.export(exports, "ReactIntlErrorCode", ()=>(0, _intl.IntlErrorCode));
parcelHelpers.export(exports, "ReactIntlError", ()=>(0, _intl.IntlError));
parcelHelpers.export(exports, "FormattedNumberParts", ()=>(0, _createFormattedComponent.FormattedNumberParts));
parcelHelpers.export(exports, "FormattedListParts", ()=>(0, _createFormattedComponent.FormattedListParts));
parcelHelpers.export(exports, "FormattedDateTimeRange", ()=>(0, _dateTimeRangeDefault.default));
parcelHelpers.export(exports, "FormattedMessage", ()=>(0, _messageDefault.default));
parcelHelpers.export(exports, "FormattedPlural", ()=>(0, _pluralDefault.default));
parcelHelpers.export(exports, "FormattedRelativeTime", ()=>(0, _relativeDefault.default));
parcelHelpers.export(exports, "IntlContext", ()=>(0, _injectIntl.Context));
parcelHelpers.export(exports, "IntlProvider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "RawIntlProvider", ()=>(0, _injectIntl.Provider));
parcelHelpers.export(exports, "createIntl", ()=>(0, _provider.createIntl));
parcelHelpers.export(exports, "injectIntl", ()=>(0, _injectIntlDefault.default));
parcelHelpers.export(exports, "useIntl", ()=>(0, _useIntlDefault.default));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
parcelHelpers.export(exports, "FormattedDate", ()=>FormattedDate);
parcelHelpers.export(exports, "FormattedTime", ()=>FormattedTime);
parcelHelpers.export(exports, "FormattedNumber", ()=>FormattedNumber);
parcelHelpers.export(exports, "FormattedList", ()=>FormattedList);
parcelHelpers.export(exports, "FormattedDisplayName", ()=>FormattedDisplayName);
parcelHelpers.export(exports, "FormattedDateParts", ()=>FormattedDateParts);
parcelHelpers.export(exports, "FormattedTimeParts", ()=>FormattedTimeParts);
var _createFormattedComponent = require("./src/components/createFormattedComponent");
var _injectIntl = require("./src/components/injectIntl");
var _injectIntlDefault = parcelHelpers.interopDefault(_injectIntl);
var _useIntl = require("./src/components/useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var _provider = require("./src/components/provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _relative = require("./src/components/relative");
var _relativeDefault = parcelHelpers.interopDefault(_relative);
var _plural = require("./src/components/plural");
var _pluralDefault = parcelHelpers.interopDefault(_plural);
var _message = require("./src/components/message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _dateTimeRange = require("./src/components/dateTimeRange");
var _dateTimeRangeDefault = parcelHelpers.interopDefault(_dateTimeRange);
var _intl = require("@formatjs/intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
var FormattedDate = (0, _createFormattedComponent.createFormattedComponent)("formatDate");
var FormattedTime = (0, _createFormattedComponent.createFormattedComponent)("formatTime");
var FormattedNumber = (0, _createFormattedComponent.createFormattedComponent)("formatNumber");
var FormattedList = (0, _createFormattedComponent.createFormattedComponent)("formatList");
var FormattedDisplayName = (0, _createFormattedComponent.createFormattedComponent)("formatDisplayName");
var FormattedDateParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)("formatDate");
var FormattedTimeParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)("formatTime");

},{"./src/components/createFormattedComponent":"kxRWy","./src/components/injectIntl":false,"./src/components/useIntl":"aJp54","./src/components/provider":"iNpMu","./src/components/relative":false,"./src/components/plural":false,"./src/components/message":"3Utln","./src/components/dateTimeRange":false,"@formatjs/intl":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kxRWy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormattedNumberParts", ()=>FormattedNumberParts);
parcelHelpers.export(exports, "FormattedListParts", ()=>FormattedListParts);
parcelHelpers.export(exports, "createFormattedDateTimePartsComponent", ()=>createFormattedDateTimePartsComponent);
parcelHelpers.export(exports, "createFormattedComponent", ()=>createFormattedComponent);
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
var FormattedListParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || _react.Fragment;
        return _react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

},{"tslib":"bPrBj","react":"6uln9","./useIntl":"aJp54","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPrBj":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aJp54":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIntl);
var _react = require("react");
var _injectIntl = require("./injectIntl");
var _utils = require("../utils");
function useIntl() {
    var intl = _react.useContext((0, _injectIntl.Context));
    (0, _utils.invariantIntlContext)(intl);
    return intl;
}

},{"react":"6uln9","./injectIntl":"gtgLE","../utils":"jC2XK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gtgLE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "default", ()=>injectIntl);
var _tslib = require("tslib");
var _react = require("react");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _utils = require("../utils");
function getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var IntlContext = _react.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return _react.createElement(IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, _utils.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return _react.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, _hoistNonReactStaticsDefault.default)(_react.forwardRef(function(props, ref) {
        return _react.createElement(WithIntl, (0, _tslib.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, _hoistNonReactStaticsDefault.default)(WithIntl, WrappedComponent);
}

},{"tslib":"bPrBj","react":"6uln9","hoist-non-react-statics":"3bvdc","../utils":"jC2XK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jC2XK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariantIntlContext", ()=>invariantIntlContext);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ parcelHelpers.export(exports, "assignUniqueKeysToParts", ()=>assignUniqueKeysToParts);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
var _tslib = require("tslib");
var _react = require("react");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intl = require("@formatjs/intl");
function invariantIntlContext(intl) {
    (0, _ecma402Abstract.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _intl.DEFAULT_INTL_CONFIG)), {
    textComponent: _react.Fragment
});
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(_react.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

},{"tslib":"bPrBj","react":"6uln9","@formatjs/ecma402-abstract":"1h4cB","@formatjs/intl":"7MiVb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1h4cB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_formatToParts", ()=>(0, _formatToPartsDefault.default));
parcelHelpers.export(exports, "getInternalSlot", ()=>(0, _utils.getInternalSlot));
parcelHelpers.export(exports, "getMultiInternalSlots", ()=>(0, _utils.getMultiInternalSlots));
parcelHelpers.export(exports, "isLiteralPart", ()=>(0, _utils.isLiteralPart));
parcelHelpers.export(exports, "setInternalSlot", ()=>(0, _utils.setInternalSlot));
parcelHelpers.export(exports, "setMultiInternalSlots", ()=>(0, _utils.setMultiInternalSlots));
parcelHelpers.export(exports, "getMagnitude", ()=>(0, _utils.getMagnitude));
parcelHelpers.export(exports, "defineProperty", ()=>(0, _utils.defineProperty));
parcelHelpers.export(exports, "isMissingLocaleDataError", ()=>(0, _data.isMissingLocaleDataError));
parcelHelpers.export(exports, "invariant", ()=>(0, _utils.invariant));
var _canonicalizeLocaleList = require("./CanonicalizeLocaleList");
parcelHelpers.exportAll(_canonicalizeLocaleList, exports);
var _canonicalizeTimeZoneName = require("./CanonicalizeTimeZoneName");
parcelHelpers.exportAll(_canonicalizeTimeZoneName, exports);
var _coerceOptionsToObject = require("./CoerceOptionsToObject");
parcelHelpers.exportAll(_coerceOptionsToObject, exports);
var _getNumberOption = require("./GetNumberOption");
parcelHelpers.exportAll(_getNumberOption, exports);
var _getOption = require("./GetOption");
parcelHelpers.exportAll(_getOption, exports);
var _getOptionsObject = require("./GetOptionsObject");
parcelHelpers.exportAll(_getOptionsObject, exports);
var _isSanctionedSimpleUnitIdentifier = require("./IsSanctionedSimpleUnitIdentifier");
parcelHelpers.exportAll(_isSanctionedSimpleUnitIdentifier, exports);
var _isValidTimeZoneName = require("./IsValidTimeZoneName");
parcelHelpers.exportAll(_isValidTimeZoneName, exports);
var _isWellFormedCurrencyCode = require("./IsWellFormedCurrencyCode");
parcelHelpers.exportAll(_isWellFormedCurrencyCode, exports);
var _isWellFormedUnitIdentifier = require("./IsWellFormedUnitIdentifier");
parcelHelpers.exportAll(_isWellFormedUnitIdentifier, exports);
var _computeExponent = require("./NumberFormat/ComputeExponent");
parcelHelpers.exportAll(_computeExponent, exports);
var _computeExponentForMagnitude = require("./NumberFormat/ComputeExponentForMagnitude");
parcelHelpers.exportAll(_computeExponentForMagnitude, exports);
var _currencyDigits = require("./NumberFormat/CurrencyDigits");
parcelHelpers.exportAll(_currencyDigits, exports);
var _formatNumericToParts = require("./NumberFormat/FormatNumericToParts");
parcelHelpers.exportAll(_formatNumericToParts, exports);
var _formatNumericToString = require("./NumberFormat/FormatNumericToString");
parcelHelpers.exportAll(_formatNumericToString, exports);
var _initializeNumberFormat = require("./NumberFormat/InitializeNumberFormat");
parcelHelpers.exportAll(_initializeNumberFormat, exports);
var _partitionNumberPattern = require("./NumberFormat/PartitionNumberPattern");
parcelHelpers.exportAll(_partitionNumberPattern, exports);
var _setNumberFormatDigitOptions = require("./NumberFormat/SetNumberFormatDigitOptions");
parcelHelpers.exportAll(_setNumberFormatDigitOptions, exports);
var _setNumberFormatUnitOptions = require("./NumberFormat/SetNumberFormatUnitOptions");
parcelHelpers.exportAll(_setNumberFormatUnitOptions, exports);
var _toRawFixed = require("./NumberFormat/ToRawFixed");
parcelHelpers.exportAll(_toRawFixed, exports);
var _toRawPrecision = require("./NumberFormat/ToRawPrecision");
parcelHelpers.exportAll(_toRawPrecision, exports);
var _formatToParts = require("./NumberFormat/format_to_parts");
var _formatToPartsDefault = parcelHelpers.interopDefault(_formatToParts);
var _partitionPattern = require("./PartitionPattern");
parcelHelpers.exportAll(_partitionPattern, exports);
var _supportedLocales = require("./SupportedLocales");
parcelHelpers.exportAll(_supportedLocales, exports);
var _utils = require("./utils");
var _data = require("./data");
var _relativeTime = require("./types/relative-time");
parcelHelpers.exportAll(_relativeTime, exports);
var _dateTime = require("./types/date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _list = require("./types/list");
parcelHelpers.exportAll(_list, exports);
var _pluralRules = require("./types/plural-rules");
parcelHelpers.exportAll(_pluralRules, exports);
var _number = require("./types/number");
parcelHelpers.exportAll(_number, exports);
var _displaynames = require("./types/displaynames");
parcelHelpers.exportAll(_displaynames, exports);
var _262 = require("./262");
parcelHelpers.exportAll(_262, exports);

},{"./CanonicalizeLocaleList":false,"./CanonicalizeTimeZoneName":false,"./CoerceOptionsToObject":false,"./GetNumberOption":false,"./GetOption":false,"./GetOptionsObject":false,"./IsSanctionedSimpleUnitIdentifier":false,"./IsValidTimeZoneName":false,"./IsWellFormedCurrencyCode":false,"./IsWellFormedUnitIdentifier":false,"./NumberFormat/ComputeExponent":false,"./NumberFormat/ComputeExponentForMagnitude":false,"./NumberFormat/CurrencyDigits":false,"./NumberFormat/FormatNumericToParts":false,"./NumberFormat/FormatNumericToString":false,"./NumberFormat/InitializeNumberFormat":false,"./NumberFormat/PartitionNumberPattern":false,"./NumberFormat/SetNumberFormatDigitOptions":false,"./NumberFormat/SetNumberFormatUnitOptions":false,"./NumberFormat/ToRawFixed":false,"./NumberFormat/ToRawPrecision":false,"./NumberFormat/format_to_parts":false,"./PartitionPattern":false,"./SupportedLocales":false,"./utils":"8dy8J","./data":false,"./types/relative-time":false,"./types/date-time":false,"./types/list":false,"./types/plural-rules":false,"./types/number":false,"./types/displaynames":false,"./262":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8dy8J":[function(require,module,exports) {
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMagnitude", ()=>getMagnitude);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "setInternalSlot", ()=>setInternalSlot);
parcelHelpers.export(exports, "setMultiInternalSlots", ()=>setMultiInternalSlots);
parcelHelpers.export(exports, "getInternalSlot", ()=>getInternalSlot);
parcelHelpers.export(exports, "getMultiInternalSlots", ()=>getMultiInternalSlots);
parcelHelpers.export(exports, "isLiteralPart", ()=>isLiteralPart);
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ parcelHelpers.export(exports, "defineProperty", ()=>defineProperty);
parcelHelpers.export(exports, "UNICODE_EXTENSION_SEQUENCE_REGEX", ()=>UNICODE_EXTENSION_SEQUENCE_REGEX);
parcelHelpers.export(exports, "invariant", ()=>invariant);
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7MiVb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _utils.createIntlCache));
parcelHelpers.export(exports, "filterProps", ()=>(0, _utils.filterProps));
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>(0, _utils.DEFAULT_INTL_CONFIG));
parcelHelpers.export(exports, "createFormatters", ()=>(0, _utils.createFormatters));
parcelHelpers.export(exports, "getNamedFormat", ()=>(0, _utils.getNamedFormat));
parcelHelpers.export(exports, "formatMessage", ()=>(0, _message.formatMessage));
parcelHelpers.export(exports, "formatDate", ()=>(0, _dateTime.formatDate));
parcelHelpers.export(exports, "formatDateToParts", ()=>(0, _dateTime.formatDateToParts));
parcelHelpers.export(exports, "formatTime", ()=>(0, _dateTime.formatTime));
parcelHelpers.export(exports, "formatTimeToParts", ()=>(0, _dateTime.formatTimeToParts));
parcelHelpers.export(exports, "formatDisplayName", ()=>(0, _displayName.formatDisplayName));
parcelHelpers.export(exports, "formatList", ()=>(0, _list.formatList));
parcelHelpers.export(exports, "formatPlural", ()=>(0, _plural.formatPlural));
parcelHelpers.export(exports, "formatRelativeTime", ()=>(0, _relativeTime.formatRelativeTime));
parcelHelpers.export(exports, "formatNumber", ()=>(0, _number.formatNumber));
parcelHelpers.export(exports, "formatNumberToParts", ()=>(0, _number.formatNumberToParts));
parcelHelpers.export(exports, "createIntl", ()=>(0, _createIntl.createIntl));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
var _types = require("./src/types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./src/utils");
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _message = require("./src/message");
var _dateTime = require("./src/dateTime");
var _displayName = require("./src/displayName");
var _list = require("./src/list");
var _plural = require("./src/plural");
var _relativeTime = require("./src/relativeTime");
var _number = require("./src/number");
var _createIntl = require("./src/create-intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}

},{"./src/types":false,"./src/utils":"g2sF1","./src/error":false,"./src/message":"bW8ad","./src/dateTime":false,"./src/displayName":false,"./src/list":false,"./src/plural":false,"./src/relativeTime":false,"./src/number":false,"./src/create-intl":"WfS8d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g2sF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
parcelHelpers.export(exports, "createIntlCache", ()=>createIntlCache);
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ parcelHelpers.export(exports, "createFormatters", ()=>createFormatters);
parcelHelpers.export(exports, "getNamedFormat", ()=>getNamedFormat);
var _tslib = require("tslib");
var _intlMessageformat = require("intl-messageformat");
var _fastMemoize = require("@formatjs/fast-memoize");
var _fastMemoizeDefault = parcelHelpers.interopDefault(_fastMemoize);
var _error = require("./error");
function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var defaultErrorHandler = function(error) {};
var defaultWarnHandler = function(warning) {};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createFormatters(cache) {
    if (cache === void 0) cache = createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, _fastMemoizeDefault.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getNumberFormat = (0, _fastMemoizeDefault.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getPluralRules = (0, _fastMemoizeDefault.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, _fastMemoizeDefault.default)(function(message, locales, overrideFormats, opts) {
            return new (0, _intlMessageformat.IntlMessageFormat)(message, locales, overrideFormats, (0, _tslib.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getRelativeTimeFormat: (0, _fastMemoizeDefault.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, _fastMemoizeDefault.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDisplayNames: (0, _fastMemoizeDefault.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, _error.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

},{"tslib":"70O5z","intl-messageformat":"6Ddzo","@formatjs/fast-memoize":"9CHYl","./error":"4uoON","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"70O5z":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Ddzo":[function(require,module,exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("./src/core");
var _formatters = require("./src/formatters");
parcelHelpers.exportAll(_formatters, exports);
parcelHelpers.exportAll(_core, exports);
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
exports.default = (0, _core.IntlMessageFormat);

},{"./src/core":"5AhHB","./src/formatters":"jcRRA","./src/error":"kcRrQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5AhHB":[function(require,module,exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", ()=>IntlMessageFormat);
var _tslib = require("tslib");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _fastMemoize = require("@formatjs/fast-memoize");
var _fastMemoizeDefault = parcelHelpers.interopDefault(_fastMemoize);
var _formatters = require("./formatters");
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, _tslib.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, _fastMemoizeDefault.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDateTimeFormat: (0, _fastMemoizeDefault.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: (0, _fastMemoizeDefault.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
var IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, _formatters.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, _formatters.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, _icuMessageformatParser.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

},{"tslib":"4KLw1","@formatjs/icu-messageformat-parser":"4MOWY","@formatjs/fast-memoize":"9CHYl","./formatters":"jcRRA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4KLw1":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4MOWY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
var _tslib = require("tslib");
var _error = require("./error");
var _parser = require("./parser");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
function pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, _types.isSelectElement)(el) || (0, _types.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            pruneLocation(el.options[k].value);
        }
        else if ((0, _types.isNumberElement)(el) && (0, _types.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, _types.isDateElement)(el) || (0, _types.isTimeElement)(el)) && (0, _types.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, _types.isTagElement)(el)) pruneLocation(el.children);
    });
}
function parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, _tslib.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, _parser.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, _error.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) pruneLocation(result.val);
    return result.val;
}

},{"tslib":"5hqFa","./error":"5rGAM","./parser":"1K1JD","./types":"bYFhP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5hqFa":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5rGAM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorKind", ()=>ErrorKind);
var ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1K1JD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _tslib = require("tslib");
var _error = require("./error");
var _types = require("./types");
var _regexGenerated = require("./regex.generated");
var _icuSkeletonParser = require("@formatjs/icu-skeleton-parser");
var _dateTimePatternGenerator = require("./date-time-pattern-generator");
var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*$"));
function createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec("a")) === null || _a === void 0 ? void 0 : _a[0]) === "a";
} catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var fromEntries = // native
hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var codePointAt = hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var trimStart = hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace(SPACE_SEPARATOR_START_REGEX, "");
};
var trimEnd = hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace(SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = codePointAt(s, index);
        if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, match);
};
var Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, _types.TYPE).pound,
                    location: createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !_isAlpha(this.char())) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, _types.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, _error.ErrorKind).UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && _isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, _error.ErrorKind).EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, _types.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = trimEnd(result.val);
                    if (style.length === 0) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, _types.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, _error.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, _dateTimePatternGenerator.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, _types.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, _types.TYPE).date : (0, _types.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, _types.TYPE).number : argType === "date" ? (0, _types.TYPE).date : (0, _types.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, _tslib.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, _types.TYPE).select,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, _types.TYPE).plural,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, _error.ErrorKind).INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, _error.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, _icuSkeletonParser.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, _error.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, _types.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, _error.ErrorKind).MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && _isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function _isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function _isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

},{"tslib":"5hqFa","./error":"5rGAM","./types":"bYFhP","./regex.generated":"3TDBt","@formatjs/icu-skeleton-parser":"e77tm","./date-time-pattern-generator":"99CXH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYFhP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", ()=>TYPE);
parcelHelpers.export(exports, "SKELETON_TYPE", ()=>SKELETON_TYPE);
/**
 * Type Guards
 */ parcelHelpers.export(exports, "isLiteralElement", ()=>isLiteralElement);
parcelHelpers.export(exports, "isArgumentElement", ()=>isArgumentElement);
parcelHelpers.export(exports, "isNumberElement", ()=>isNumberElement);
parcelHelpers.export(exports, "isDateElement", ()=>isDateElement);
parcelHelpers.export(exports, "isTimeElement", ()=>isTimeElement);
parcelHelpers.export(exports, "isSelectElement", ()=>isSelectElement);
parcelHelpers.export(exports, "isPluralElement", ()=>isPluralElement);
parcelHelpers.export(exports, "isPoundElement", ()=>isPoundElement);
parcelHelpers.export(exports, "isTagElement", ()=>isTagElement);
parcelHelpers.export(exports, "isNumberSkeleton", ()=>isNumberSkeleton);
parcelHelpers.export(exports, "isDateTimeSkeleton", ()=>isDateTimeSkeleton);
parcelHelpers.export(exports, "createLiteralElement", ()=>createLiteralElement);
parcelHelpers.export(exports, "createNumberElement", ()=>createNumberElement);
var TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TDBt":[function(require,module,exports) {
// @generated from regex-gen.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPACE_SEPARATOR_REGEX", ()=>SPACE_SEPARATOR_REGEX);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e77tm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dateTime = require("./date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _number = require("./number");
parcelHelpers.exportAll(_number, exports);

},{"./date-time":"6Vpse","./number":"2HjnM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Vpse":[function(require,module,exports) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ parcelHelpers.export(exports, "parseDateTimeSkeleton", ()=>parseDateTimeSkeleton);
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2HjnM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNumberSkeletonFromString", ()=>parseNumberSkeletonFromString);
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ parcelHelpers.export(exports, "parseNumberSkeleton", ()=>parseNumberSkeleton);
var _tslib = require("tslib");
var _regexGenerated = require("./regex.generated");
function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, _regexGenerated.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace(SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace(INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace(FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

},{"tslib":"2bpZn","./regex.generated":"hjYCj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2bpZn":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hjYCj":[function(require,module,exports) {
// @generated from regex-gen.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99CXH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ parcelHelpers.export(exports, "getBestPattern", ()=>getBestPattern);
var _timeDataGenerated = require("./time-data.generated");
function getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, _timeDataGenerated.timeData)[regionTag || ""] || (0, _timeDataGenerated.timeData)[languageTag || ""] || (0, _timeDataGenerated.timeData)["".concat(languageTag, "-001")] || (0, _timeDataGenerated.timeData)["001"];
    return hourCycles[0];
}

},{"./time-data.generated":"g1BSV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1BSV":[function(require,module,exports) {
// @generated from time-data-gen.ts
// prettier-ignore  
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeData", ()=>timeData);
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CHYl":[function(require,module,exports) {
//
// Main
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
parcelHelpers.export(exports, "strategies", ()=>strategies);
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    }
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jcRRA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PART_TYPE", ()=>PART_TYPE);
parcelHelpers.export(exports, "isFormatXMLElementFn", ()=>isFormatXMLElementFn);
// TODO(skeleton): add skeleton support
parcelHelpers.export(exports, "formatToParts", ()=>formatToParts);
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _error = require("./error");
var PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === "function";
}
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, _icuMessageformatParser.isLiteralElement)(els[0])) return [
        {
            type: PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, _icuMessageformatParser.isLiteralElement)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, _icuMessageformatParser.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, _error.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, _icuMessageformatParser.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? PART_TYPE.literal : PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, _icuMessageformatParser.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, _icuMessageformatParser.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) throw new (0, _error.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? PART_TYPE.literal : PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, _icuMessageformatParser.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, _icuMessageformatParser.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, _error.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, _error.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

},{"@formatjs/icu-messageformat-parser":"4MOWY","./error":"kcRrQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcRrQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "FormatError", ()=>FormatError);
parcelHelpers.export(exports, "InvalidValueError", ()=>InvalidValueError);
parcelHelpers.export(exports, "InvalidValueTypeError", ()=>InvalidValueTypeError);
parcelHelpers.export(exports, "MissingValueError", ()=>MissingValueError);
var _tslib = require("tslib");
var ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var InvalidValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError);
var InvalidValueTypeError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError);
var MissingValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError);

},{"tslib":"4KLw1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4uoON":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlErrorCode", ()=>IntlErrorCode);
parcelHelpers.export(exports, "IntlError", ()=>IntlError);
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>UnsupportedFormatterError);
parcelHelpers.export(exports, "InvalidConfigError", ()=>InvalidConfigError);
parcelHelpers.export(exports, "MissingDataError", ()=>MissingDataError);
parcelHelpers.export(exports, "IntlFormatError", ()=>IntlFormatError);
parcelHelpers.export(exports, "MessageFormatError", ()=>MessageFormatError);
parcelHelpers.export(exports, "MissingTranslationError", ()=>MissingTranslationError);
var _tslib = require("tslib");
var IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var UnsupportedFormatterError = /** @class */ function(_super) {
    (0, _tslib.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError);
var InvalidConfigError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError);
var MissingDataError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError);
var IntlFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError);
var MessageFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError);
var MissingTranslationError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError);

},{"tslib":"70O5z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bW8ad":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatMessage", ()=>formatMessage);
var _tslib = require("tslib");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, _tslib.__assign)((0, _tslib.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, _intlMessageformat.IntlMessageFormat).formats;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, mfFormats), f1), {
        date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, _ecma402Abstract.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, _icuMessageformatParser.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultRichTextElements), values || {});
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, _error.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, _error.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, _tslib.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

},{"tslib":"70O5z","@formatjs/ecma402-abstract":"1h4cB","intl-messageformat":"6Ddzo","./error":"4uoON","@formatjs/icu-messageformat-parser":"4MOWY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"42IQ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "formatDateTimeRange", ()=>formatDateTimeRange);
parcelHelpers.export(exports, "formatDateToParts", ()=>formatDateToParts);
parcelHelpers.export(exports, "formatTimeToParts", ()=>formatTimeToParts);
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, _tslib.__assign)((0, _tslib.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, _utils.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

},{"tslib":"70O5z","./utils":"g2sF1","./error":"4uoON","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"itLCB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDisplayName", ()=>formatDisplayName);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, _intlMessageformat.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

},{"./utils":"g2sF1","intl-messageformat":"6Ddzo","./error":"4uoON","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6tqJ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatList", ()=>formatList);
parcelHelpers.export(exports, "formatListToParts", ()=>formatListToParts);
var _tslib = require("tslib");
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, _intlMessageformat.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, _tslib.__assign)((0, _tslib.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

},{"tslib":"70O5z","./utils":"g2sF1","intl-messageformat":"6Ddzo","./error":"4uoON","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYE0n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPlural", ()=>formatPlural);
var _utils = require("./utils");
var _error = require("./error");
var _intlMessageformat = require("intl-messageformat");
var PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, _intlMessageformat.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

},{"./utils":"g2sF1","./error":"4uoON","intl-messageformat":"6Ddzo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7C04j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelativeTime", ()=>formatRelativeTime);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, _utils.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, _intlMessageformat.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    try {
        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

},{"./utils":"g2sF1","intl-messageformat":"6Ddzo","./error":"4uoON","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kPI6D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatNumber", ()=>formatNumber);
parcelHelpers.export(exports, "formatNumberToParts", ()=>formatNumberToParts);
var _utils = require("./utils");
var _error = require("./error");
var NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, _utils.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, _error.IntlError)((0, _error.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

},{"./utils":"g2sF1","./error":"4uoON","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"WfS8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var _number = require("./number");
var _relativeTime = require("./relativeTime");
var _dateTime = require("./dateTime");
var _plural = require("./plural");
var _message = require("./message");
var _list = require("./list");
var _displayName = require("./displayName");
function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function createIntl(config, cache) {
    var formatters = (0, _utils.createFormatters)(cache);
    var resolvedConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, _error.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    verifyConfigMessages(resolvedConfig);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, _number.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, _number.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, _relativeTime.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, _dateTime.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, _dateTime.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, _dateTime.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, _dateTime.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, _dateTime.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, _plural.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, _list.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, _list.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, _displayName.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

},{"tslib":"70O5z","./utils":"g2sF1","./error":"4uoON","./number":"kPI6D","./relativeTime":"7C04j","./dateTime":"42IQ3","./plural":"cYE0n","./message":"bW8ad","./list":"6tqJ0","./displayName":"itLCB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNpMu":[function(require,module,exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _react = require("react");
var _injectIntl = require("./injectIntl");
var _utils = require("../utils");
var _intl = require("@formatjs/intl");
var _intlMessageformat = require("intl-messageformat");
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, _intlMessageformat.isFormatXMLElementFn)(v) ? (0, _utils.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, _intl.formatMessage).apply(void 0, (0, _tslib.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return _react.Children.toArray(chunks);
    return chunks;
};
var createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, _tslib.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, _intl.createIntl)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, coreIntl), {
        formatMessage: formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var IntlProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, _intl.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0, _utils.shallowEqual)(prevConfig, config)) return {
            intl: createIntl(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, _utils.invariantIntlContext)(this.state.intl);
        return _react.createElement((0, _injectIntl.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, _utils.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}(_react.PureComponent);
exports.default = IntlProvider;

},{"tslib":"bPrBj","react":"6uln9","./injectIntl":"gtgLE","../utils":"jC2XK","@formatjs/intl":"7MiVb","intl-messageformat":"6Ddzo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Utln":[function(require,module,exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var _utils = require("../utils");
function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, _tslib.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, _tslib.__rest)(nextProps, [
        "values"
    ]);
    return (0, _utils.shallowEqual)(nextValues, values) && (0, _utils.shallowEqual)(otherProps, nextOtherProps);
}
function FormattedMessage(props) {
    var intl = (0, _useIntlDefault.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? _react.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return _react.createElement(Component, null, _react.Children.toArray(nodes));
    return _react.createElement(_react.Fragment, null, nodes);
}
FormattedMessage.displayName = "FormattedMessage";
var MemoizedFormattedMessage = _react.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
exports.default = MemoizedFormattedMessage;

},{"tslib":"bPrBj","react":"6uln9","./useIntl":"aJp54","../utils":"jC2XK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hj2bM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d10747c347eed232");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _text = _interopRequireDefault(require("b22e8d6bfd0d105b"));
var _default = _text["default"];
exports["default"] = _default;

},{"d10747c347eed232":"5qxSW","b22e8d6bfd0d105b":"djkLm"}],"djkLm":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e330615708e89cfc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("44b4025bb50994c4"));
var _react = _interopRequireDefault(require("1c8f0f0615aabbf7"));
var _propTypes = _interopRequireDefault(require("8dc69d4761c96da4"));
var _text = _interopRequireDefault(require("e6321e89b22f7153"));
var _getTextStyles = _interopRequireDefault(require("4706ef13ed79f969"));
var _theme = require("45e55f78e367f68c");
var _cxMemoized = _interopRequireDefault(require("ba096a2a109472ee"));
var _filterPropsByPrefix = _interopRequireDefault(require("8b9e4a3017b07fe8"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * This component can be used to apply Meridian text styles to the UI. Text
 * styles will cascade to descendent Text, Heading, and Link components as well
 * as native HTML elements, but not to other Meridian components that define
 * their own text styles.
 */ var Text = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var children = props.children;
    var t = (0, _theme.useTheme)(_text["default"], "text");
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
        id: props.id,
        className: (0, _cxMemoized["default"])((0, _getTextStyles["default"])(t, props), props.className),
        title: props.title === undefined && props.truncate && typeof children === "string" ? children : props.title,
        "mdn-text": "",
        ref: ref
    }), children);
});
Text.displayName = "Text";
Text.propTypes = {};
Text.defaultProps = {
    tag: "p"
};
var _default = Text;
exports["default"] = _default;

},{"e330615708e89cfc":"5qxSW","44b4025bb50994c4":"avcfc","1c8f0f0615aabbf7":"6uln9","8dc69d4761c96da4":"9Mqtv","e6321e89b22f7153":"9Sdvg","4706ef13ed79f969":"6Ysc6","45e55f78e367f68c":"dJlcb","ba096a2a109472ee":"5KZHn","8b9e4a3017b07fe8":"7Pq5E"}],"6Ysc6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("35685b7ed4324bda");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("5b6b03c8a32784b2"));
var _token = require("95741c8df3247762");
var _emotion = require("1bf7343786f9537e");
var _noTextWrap = _interopRequireDefault(require("60c14cf8515b896d"));
/**
 * Pass in a token helper for text tokens
 * (e.g. getTokenHelper("text")(themedTextTokens)) and any text props.
 */ var getTextStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var _css;
    var fontFamily = _ref.fontFamily, color = _ref.color, type = _ref.type, transform = _ref.transform, alignment = _ref.alignment, tag = _ref.tag, truncate = _ref.truncate, breakWord = _ref.breakWord;
    return (0, _emotion.css)(// with no parent and no props and this is what you'll get.
    {
        fontFamily: t("fontFamilyAmazonEmber"),
        fontWeight: t("fontWeightB300"),
        fontSize: t("fontSizeB300"),
        lineHeight: t("lineHeightB300"),
        color: t("colorPrimary")
    }, // <Text /> component inside another <Text /> component and the descendant
    // component will inherit from the ancestor instead of falling back to the
    // default styles.
    {
        "[mdn-text] &": {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            color: "inherit"
        }
    }, // styles using the component's props. The :not() selector is added to
    // increase the specificity of the styles so they override everything else
    // without resorting to !important.
    {
        "&:not(#mdn-specificity-hack)": {
            fontFamily: fontFamily ? t("fontFamily", fontFamily) : undefined,
            fontWeight: type ? t("fontWeight", type) : undefined,
            fontSize: type ? t("fontSize", type) : undefined,
            lineHeight: type ? t("lineHeight", type) : undefined,
            color: color ? t("color", color) : undefined
        }
    }, (_css = {
        textTransform: transform,
        textAlign: alignment ? alignment : undefined,
        // Clear the default margin on tags like "p"
        margin: 0,
        // If a single word is too wide for the element then allow the browser
        // to break it up at an arbitrary location. A hyphen will not be
        // added. This won't look great, but is better than the word flowing
        // off the edge of the element and potentially getting
        // clipped/obscured.
        overflowWrap: breakWord ? "break-word" : undefined,
        // HACK: Overflow wrap for IE11
        wordWrap: breakWord ? "break-word" : undefined
    }, (0, _defineProperty2["default"])(_css, tag === "ul" ? "&" : "& ul", {
        paddingLeft: t("listSpacingHorizontal"),
        listStyleType: "disc",
        "& ul": {
            paddingLeft: t("listSpacingHorizontal"),
            listStyleType: "circle",
            "& ul": {
                listStyleType: "square"
            }
        }
    }), (0, _defineProperty2["default"])(_css, tag === "ol" ? "&" : "& ol", {
        paddingLeft: t("listSpacingHorizontal"),
        listStyleType: "decimal",
        "& ol": {
            paddingLeft: t("listSpacingHorizontal"),
            listStyleType: "lower-alpha",
            "& ol": {
                listStyleType: "lower-roman"
            }
        }
    }), (0, _defineProperty2["default"])(_css, "".concat(tag === "ul" || tag === "ol" ? "& > * + *, " : "", "& ul > * + *, & ol > * + *"), {
        paddingTop: t("listSpacingVertical")
    }), _css), truncate ? _noTextWrap["default"] : undefined);
}, [
    "fontFamily",
    "color",
    "type",
    "transform",
    "alignment",
    "tag",
    "truncate",
    "breakWord"
]);
var _default = getTextStyles;
exports["default"] = _default;

},{"35685b7ed4324bda":"5qxSW","5b6b03c8a32784b2":"avcfc","95741c8df3247762":"bebc4","1bf7343786f9537e":"1BAMo","60c14cf8515b896d":"9CFwe"}],"4i8wU":[function(require,module,exports) {
// import CookieBanner from '@amzn/carrier-logistics-common-ui-assets/dist/components/Molecules/CookieBanner';
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _responsive = require("@amzn/meridian/responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _navigationalRoutes = require("../../config/navigationalRoutes");
var _analytics1 = require("../../constants/analytics");
var _useNavigateToSpecifiedRoute = require("../../hooks/useNavigateToSpecifiedRoute");
var _useNavigateToSpecifiedRouteDefault = parcelHelpers.interopDefault(_useNavigateToSpecifiedRoute);
const Footer = ()=>{
    const { navigateToSpecifiedRoute } = (0, _useNavigateToSpecifiedRouteDefault.default)();
    const onConditionsOfUseClick = (0, _react.useCallback)(()=>{
        navigateToSpecifiedRoute((0, _navigationalRoutes.TERMS_PATH));
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.CONDITIONS_OF_USE_BUTTON)
            }
        });
    }, [
        navigateToSpecifiedRoute
    ]);
    const onPrivacyNoticeClick = (0, _react.useCallback)(()=>{
        navigateToSpecifiedRoute((0, _navigationalRoutes.PRIVACY_POLICY_PATH));
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.PRIVACY_NOTICE_BUTTON)
            }
        });
    }, [
        navigateToSpecifiedRoute
    ]);
    const fontSizeForFooter = (0, _react.useMemo)(()=>({
            fontSize: "12px"
        }), []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        alignmentHorizontal: "center",
        wrap: "down"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        type: "link",
        onClick: onConditionsOfUseClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: fontSizeForFooter
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.footer.conditions_of_use_button"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        type: "link",
        onClick: onPrivacyNoticeClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: fontSizeForFooter
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.footer.privacy_notice_button"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveDefault.default), {
        query: "min-width",
        props: {
            label: {
                default: "",
                [(0, _breakpoints.DEVICE_WIDTHS).TABLET]: "|"
            }
        }
    }, ({ label })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null, label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: fontSizeForFooter
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.footer.copyright_text"
    })))));
};
exports.default = Footer;

},{"@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/meridian/button":"k0QSK","@amzn/meridian/responsive":"l7U3k","@amzn/meridian/row":"ba4AQ","@amzn/meridian/text":"hj2bM","react":"6uln9","react-intl":"4kbQW","../../config/navigationalRoutes":"32s8M","../../constants/analytics":"zH2LJ","../../hooks/useNavigateToSpecifiedRoute":"3G87j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hl6Ce":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BUTTON_CLICK", ()=>BUTTON_CLICK);
parcelHelpers.export(exports, "DROPDOWN_CLICK", ()=>DROPDOWN_CLICK);
parcelHelpers.export(exports, "DROPDOWN_ITEM_CLICK", ()=>DROPDOWN_ITEM_CLICK);
var BUTTON_CLICK = "BUTTON_CLICK";
var DROPDOWN_CLICK = "DROPDOWN_CLICK";
var DROPDOWN_ITEM_CLICK = "DROPDOWN_ITEM_CLICK";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"65vIt":[function(require,module,exports) {
/**
 * Break-Points for the devices
 */ // Todo - discuss with UX team to get the correct breakpoints
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEVICE_WIDTHS", ()=>DEVICE_WIDTHS);
var DEVICE_WIDTHS = {
    MOBILE: "520px",
    TABLET: "800px",
    DESKTOP: "1024px"
};
exports.default = DEVICE_WIDTHS;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l7U3k":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bf8e4a443cd319e0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _responsive = _interopRequireDefault(require("e3934b907823f8c6"));
var _default = _responsive["default"];
exports["default"] = _default;

},{"bf8e4a443cd319e0":"5qxSW","e3934b907823f8c6":"FDHIR"}],"FDHIR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("fd0cfce874268bf3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("ca29fef5dea3d48f"));
var _classCallCheck2 = _interopRequireDefault(require("831ab481cb9fb76b"));
var _createClass2 = _interopRequireDefault(require("efbcf7cbc1222437"));
var _inherits2 = _interopRequireDefault(require("e33e7e08c81a2d9"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("1a3c087d00ed5aa8"));
var _getPrototypeOf2 = _interopRequireDefault(require("2e2010d08a8e1f34"));
var _react = _interopRequireDefault(require("6a74c4f1ae291fc7"));
var _propTypes = _interopRequireDefault(require("bc0eb191c8bbd848"));
var _matchMedia = _interopRequireDefault(require("6c8af8d3cbb41a08"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This looks through an object of nested objects and returns a flat array
 * containing all the unique keys found in the nested objects.
 */ var getUniqueNestedObjectKeys = function getUniqueNestedObjectKeys(props) {
    return Object.keys(props) // Get the keys of each nested object
    .map(function(prop) {
        return Object.keys(props[prop]);
    }) // Flatten the keys into one array
    .reduce(function(result, keys) {
        return result.concat(keys);
    }, []) // Filter out duplicate keys
    .filter(function(value, index, keys) {
        return keys.indexOf(value) === index;
    });
};
/**
 * Sort an array according to it's numeric values
 */ var sortNumeric = function sortNumeric(arr, direction) {
    arr.sort(function(a, b) {
        return (parseFloat(a) - parseFloat(b)) * (direction === "descending" ? -1 : 1);
    });
    return arr;
};
/* eslint-disable react/prop-types */ /**
 * This component allows you to respond to the state of media features such as
 * viewport width, viewport aspect ratio, and device orientation. This is
 * similar to "media queries for JavaScript" (and it's even powered by media
 * queries behind the scenes), but it's a lot more powerful. Instead of only
 * allowing you to toggle something on or off based on a matching media query,
 * it allows you to set set any JavaScript variable based on the various states
 * of a media feature. You can use this functionality to do things that are not
 * possible with plain CSS media queries like:
 *   - render entirely different component trees based on viewport size
 *   - pass different props to a component based on viewport width
 *   - change the location of elements in the DOM based on device orientation
 *
 * NOTE: The props passed to this component cannot be changed after the
 * component is first instantiated.
 *
 * ```
 * // Renders "red" below the 1000px breakpoint, "blue" at or above the 1000px
 * // breakpoint but below the 1500px breakpoint, and "green" at or above the
 * // 1500px breakpoint. Renders 12px font below the 1500px breakpoint and 24px
 * // at or above the 1500px breakpoint.
 * <Responsive
 *   query="min-width"
 *   props={{
 *     color: { default: "red", "1000px": "blue", "1500px": "green" },
 *     fontSize: { default: 12, "1500px": 24 },
 *   }}
 * >
 *   {({ color, fontSize }) => (
 *     <div style={{ fontSize }}>My fav color is {color}</div>
 *.  )}
 * </Responsive>
 * ```
 */ var ResponsiveClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(ResponsiveClass, _React$Component);
    var _super = _createSuper(ResponsiveClass);
    function ResponsiveClass(props) {
        var _this;
        (0, _classCallCheck2["default"])(this, ResponsiveClass);
        _this = _super.call(this, props); // Extract the media condition from the "query" prop
        var condition = /^min-/.test(props.query) ? "min" : /^max-/.test(props.query) ? "max" : null; // Extract the media feature from the "query" prop
        var feature = condition ? props.query.replace(new RegExp("^".concat(condition, "-")), "") : props.query; // Extract a list of unique breakpoints from the keys of the "props" prop.
        // Don't include the "default" since that's not something we can actually
        // query for (we'll fallback to that manually if no breakpoint matches)
        var breakpoints = getUniqueNestedObjectKeys(props.props).filter(function(key) {
            return key !== "default";
        }); // Sort the breakpoints according to the media query condition so that later
        // on we can just take the last matching breakpoint and know that that's the
        // min/max matching breakpoint
        var sortedBreakpoints = condition ? sortNumeric(breakpoints, condition === "min" ? "ascending" : "descending") : breakpoints; // This is an object of `MediaQueryList` instances (or mock instances - see
        // `matchMedia`) keyed by the breakpoints that they're matching against (e.g.
        // `{ "0px": mediaQueryA, "1000px": mediaQueryB }`).
        _this.mediaQueries = sortedBreakpoints.map(function(breakpoint) {
            var mediaQuery = (0, _matchMedia["default"])({
                feature: feature,
                condition: condition,
                fallback: props.fallback,
                breakpoint: breakpoint
            });
            var listener = function listener() {
                return _this.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
            };
            return {
                breakpoint: breakpoint,
                mediaQuery: mediaQuery,
                startListening: function startListening() {
                    return mediaQuery.addListener(listener);
                },
                stopListening: function stopListening() {
                    return mediaQuery.removeListener(listener);
                }
            };
        }); // Save off the list of prop names for each access later
        _this.propNames = Object.keys(props.props); // State is an object keyed by breakpoint that includes the match state of
        // the media query for that breakpoint (e.g. if the query is "min-width",
        // we're listening at the breakpoints "0px" and "1000px", adn the viewport
        // width is "500px" then the state object would be:
        // { "0px": true, "1000px": false }
        _this.state = _this.mediaQueries.reduce(function(result, _ref) {
            var breakpoint = _ref.breakpoint, mediaQuery = _ref.mediaQuery;
            // If a fallback prop is present, match against that for the intial
            // state. This ensures that that the same value is used during server
            // rendering and during the initial rehydrating render on the client.
            result[breakpoint] = _this.props.fallback ? mediaQuery.matchesFallback : mediaQuery.matches;
            return result;
        }, {});
        return _this;
    }
    (0, _createClass2["default"])(ResponsiveClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.mediaQueries.forEach(function(_ref2) {
                    var mediaQuery = _ref2.mediaQuery, breakpoint = _ref2.breakpoint, startListening = _ref2.startListening;
                    // Start listening for future state changes
                    startListening(); // If we matched against the fallback prop on the initial render, but the
                    // actual match is different, then update the state now and trigger a
                    // re-render
                    if (_this2.props.fallback && mediaQuery.matches !== mediaQuery.matchesFallback) // Note: React batches state updates in lifecycle methods so we'll only
                    // get one re-render no matter how many breakpoints we have to update.
                    _this2.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mediaQueries.forEach(function(_ref3) {
                    var stopListening = _ref3.stopListening;
                    return stopListening();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                // Choose the best value from "props" based on the state of our media
                // queries. If no match is found then return the "default" value (or
                // undefined if there is no default).
                var props = this.propNames.reduce(function(result, propName) {
                    var prop = _this3.props.props[propName];
                    var value = _this3.mediaQueries.reduce(function(result, _ref4) {
                        var breakpoint = _ref4.breakpoint;
                        return _this3.state[breakpoint] && prop[breakpoint] !== undefined ? prop[breakpoint] : result;
                    }, prop["default"]);
                    result[propName] = value;
                    return result;
                }, {});
                return this.props.children(props);
            }
        }
    ]);
    return ResponsiveClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change
var Responsive = function Responsive(props) {
    return /*#__PURE__*/ _react["default"].createElement(ResponsiveClass, props);
};
Responsive.displayName = "Responsive";
Responsive.propTypes = {};
var _default = Responsive;
exports["default"] = _default;

},{"fd0cfce874268bf3":"5qxSW","ca29fef5dea3d48f":"avcfc","831ab481cb9fb76b":"aqLjQ","efbcf7cbc1222437":"8X7ov","e33e7e08c81a2d9":"hAMmu","1a3c087d00ed5aa8":"37tJc","2e2010d08a8e1f34":"cE6Se","6a74c4f1ae291fc7":"6uln9","bc0eb191c8bbd848":"9Mqtv","6c8af8d3cbb41a08":"fm7H4"}],"fm7H4":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c1f0ef5761e28575");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _noop = _interopRequireDefault(require("631d6ce88377bfe"));
var _functional = require("a462e28c392e32b6");
/**
 * Attempt to convert a media query breakpoint to a number. If we received a
 * breakpoint like "5/10" (e.g. an aspect ratio) then run the math (e.g. "5/10"
 * => 0.5), otherwise just parse as a float (e.g. "5rem" => 5).
 */ var breakpointToNumber = function breakpointToNumber(str) {
    return /^\s?[0-9.]+\s?\/\s?[0-9.]+\s?$/.test(str) ? parseFloat(str.split("/")[0]) / parseFloat(str.split("/")[1]) : parseFloat(str);
};
var matchesFallback = function matchesFallback(_ref) {
    var condition = _ref.condition, breakpoint = _ref.breakpoint, fallback = _ref.fallback;
    return fallback === undefined ? false : condition === "min" ? breakpointToNumber(breakpoint) <= breakpointToNumber(fallback) : condition === "max" ? breakpointToNumber(breakpoint) >= breakpointToNumber(fallback) : breakpoint === fallback;
};
/**
 * A wrapper around `window.matchMedia`. If `window.matchMedia` is available
 * then a media query will be constructed and passed to `window.matchMedia` to
 * create a `MediaQueryList` instance. If we're in an env where
 * `window.matchMedia` is not available (e.g. NodeJS) then this will return a
 * mock MediaQueryList that matches against the provided fallback.
 */ var matchMedia = typeof window !== "undefined" && window.matchMedia ? (0, _functional.memoizeByKeys)(function(_ref2) {
    var condition = _ref2.condition, breakpoint = _ref2.breakpoint, feature = _ref2.feature, fallback = _ref2.fallback;
    // Build up a standard media query (e.g. `(min-width: 1000px)`) if
    // we have access to window.matchMedia
    var matchMedia = window.matchMedia("(".concat(condition ? "".concat(condition, "-") : "").concat(feature, ": ").concat(breakpoint, ")")); // Tack on the a property indicating whether the fallback matches.
    // This is helpful for situations where you're on the client, but want
    // to know what the match state would have been on the server (i.e.
    // when re-hydrating server-rendered markup on the client with React).
    matchMedia.matchesFallback = matchesFallback({
        condition: condition,
        breakpoint: breakpoint,
        fallback: fallback
    });
    return matchMedia;
}, [
    "feature",
    "condition",
    "breakpoint",
    "fallback"
]) : function(args) {
    var matches = matchesFallback(args);
    return {
        // If we don't have access to `window.matchMedia` then "matches" will be
        // set statically based on the provided "fallback".
        matches: matches,
        // Mock out these functions for parity with the `MediaQueryList`
        // instance returned if `window.matchMedia` is available
        matchesFallback: matches,
        addListener: _noop["default"],
        removeListener: _noop["default"]
    };
};
var _default = matchMedia;
exports["default"] = _default;

},{"c1f0ef5761e28575":"5qxSW","631d6ce88377bfe":"hxHyu","a462e28c392e32b6":"hze9s"}],"32s8M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HOME", ()=>HOME);
parcelHelpers.export(exports, "LANDING_PAGE", ()=>LANDING_PAGE);
parcelHelpers.export(exports, "FAQ_PAGE_PATH", ()=>FAQ_PAGE_PATH);
parcelHelpers.export(exports, "GET_STARTED_PATH", ()=>GET_STARTED_PATH);
parcelHelpers.export(exports, "TERMS_PATH", ()=>TERMS_PATH);
parcelHelpers.export(exports, "PRIVACY_NOTICE_PATH", ()=>PRIVACY_NOTICE_PATH);
parcelHelpers.export(exports, "TERMS_CONDITIONS_OF_USE_PATH", ()=>TERMS_CONDITIONS_OF_USE_PATH);
parcelHelpers.export(exports, "PRIVACY_POLICY_PATH", ()=>PRIVACY_POLICY_PATH);
parcelHelpers.export(exports, "CONDITIONS_OF_USE_FOR_EXTERNAL_APP", ()=>CONDITIONS_OF_USE_FOR_EXTERNAL_APP);
parcelHelpers.export(exports, "HELP_PAGE", ()=>HELP_PAGE);
parcelHelpers.export(exports, "CUSTOMER_SERVICE_PAGE", ()=>CUSTOMER_SERVICE_PAGE);
parcelHelpers.export(exports, "EXTERNAL_PASSPORT_APP_DOMAIN_DEPRECATED", ()=>EXTERNAL_PASSPORT_APP_DOMAIN_DEPRECATED);
parcelHelpers.export(exports, "EXTERNAL_PASSPORT_APP_DOMAIN", ()=>EXTERNAL_PASSPORT_APP_DOMAIN);
parcelHelpers.export(exports, "EXTERNAL_PASSPORT_APP_DOMAINS", ()=>EXTERNAL_PASSPORT_APP_DOMAINS);
parcelHelpers.export(exports, "CMS_PATH", ()=>CMS_PATH);
parcelHelpers.export(exports, "PROFILE_PAGE", ()=>PROFILE_PAGE);
parcelHelpers.export(exports, "MANAGE_USERS_PAGE", ()=>MANAGE_USERS_PAGE);
parcelHelpers.export(exports, "AUTH_PORTAL_FOOTER_PATH", ()=>AUTH_PORTAL_FOOTER_PATH);
parcelHelpers.export(exports, "FORECAST_PATH", ()=>FORECAST_PATH);
parcelHelpers.export(exports, "APP_INVITATION_PATH", ()=>APP_INVITATION_PATH);
parcelHelpers.export(exports, "PARTNER_PICKER_PATH", ()=>PARTNER_PICKER_PATH);
parcelHelpers.export(exports, "USER_SESSION_API_PATH", ()=>USER_SESSION_API_PATH);
parcelHelpers.export(exports, "NPC_PATH", ()=>NPC_PATH);
parcelHelpers.export(exports, "DEFAULT_USER_AUTHENTICATED_PAGE", ()=>DEFAULT_USER_AUTHENTICATED_PAGE);
parcelHelpers.export(exports, "CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH", ()=>CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH);
parcelHelpers.export(exports, "REPORTS_SHARING_PATH", ()=>REPORTS_SHARING_PATH);
parcelHelpers.export(exports, "PAM_PATH", ()=>PAM_PATH);
parcelHelpers.export(exports, "PICKER_PATH", ()=>PICKER_PATH);
parcelHelpers.export(exports, "ACCOUNTS_PATH", ()=>ACCOUNTS_PATH);
parcelHelpers.export(exports, "CASE_MANAGEMENT_PATH", ()=>CASE_MANAGEMENT_PATH);
parcelHelpers.export(exports, "PERFORMANCE_INSIGHTS_PATH", ()=>PERFORMANCE_INSIGHTS_PATH);
parcelHelpers.export(exports, "PERFORMANCE_DASHBOARD_PATH", ()=>PERFORMANCE_DASHBOARD_PATH);
parcelHelpers.export(exports, "CSAT_SURVEY_PATH", ()=>CSAT_SURVEY_PATH);
parcelHelpers.export(exports, "RUBIKS_PATH", ()=>RUBIKS_PATH);
const HOME = "/";
const LANDING_PAGE = "/landing-page";
const FAQ_PAGE_PATH = "/faq";
const GET_STARTED_PATH = "/get-started";
const TERMS_PATH = "/terms";
const PRIVACY_NOTICE_PATH = "https://www.amazon.com/gp/help/customer/display.html?ie=UTF8&nodeId=201909010";
const TERMS_CONDITIONS_OF_USE_PATH = "/terms#conditionsOfUse";
const PRIVACY_POLICY_PATH = "/privacy-notice";
const CONDITIONS_OF_USE_FOR_EXTERNAL_APP = "https://www.amazon.fr/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou";
const HELP_PAGE = "https://www.amazon.com/gp/help/customer/display.html";
const CUSTOMER_SERVICE_PAGE = "https://www.amazon.com/gp/help/customer/account-issues/ref=ap_cs_forgot_pwd?ie=UTF8";
const EXTERNAL_PASSPORT_APP_DOMAIN_DEPRECATED = "carrierhub";
const EXTERNAL_PASSPORT_APP_DOMAIN = "carrierlogistics";
const EXTERNAL_PASSPORT_APP_DOMAINS = [
    EXTERNAL_PASSPORT_APP_DOMAIN,
    EXTERNAL_PASSPORT_APP_DOMAIN_DEPRECATED
];
const CMS_PATH = "/dashboard/cms";
const PROFILE_PAGE = "/profile";
const MANAGE_USERS_PAGE = "/account/permissions";
const AUTH_PORTAL_FOOTER_PATH = "/gp/";
const FORECAST_PATH = "/logisticsProviders/:lpId/forecast";
const APP_INVITATION_PATH = "/invitation";
const PARTNER_PICKER_PATH = "/dashboard/forecast";
const USER_SESSION_API_PATH = "/user";
const NPC_PATH = "/dashboard/performance-management";
const DEFAULT_USER_AUTHENTICATED_PAGE = LANDING_PAGE;
const CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH = "/dashboard/capacity-management";
const REPORTS_SHARING_PATH = "/reports/:reportTermPath/:reportTypePath";
const PAM_PATH = "/account/manage-permissions/:customerId";
const PICKER_PATH = "/global-picker";
const ACCOUNTS_PATH = "/account";
const CASE_MANAGEMENT_PATH = "/dashboard/case-management";
const PERFORMANCE_INSIGHTS_PATH = "/dashboard/performance-insights";
const PERFORMANCE_DASHBOARD_PATH = "/dashboard/performance-dashboard";
const CSAT_SURVEY_PATH = "/feedback/survey";
const RUBIKS_PATH = "/dashboard/problem-solve";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"zH2LJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONDITIONS_OF_USE_REGION_BUTTON", ()=>CONDITIONS_OF_USE_REGION_BUTTON);
parcelHelpers.export(exports, "LANGUAGE_DROPDOWN_CLICK", ()=>LANGUAGE_DROPDOWN_CLICK);
parcelHelpers.export(exports, "DROPDOWN_CLICK", ()=>DROPDOWN_CLICK);
parcelHelpers.export(exports, "SETTINGS_BUTTON_CLICK", ()=>SETTINGS_BUTTON_CLICK);
parcelHelpers.export(exports, "PRIVACY_BUTTON_REGION", ()=>PRIVACY_BUTTON_REGION);
parcelHelpers.export(exports, "CONDITIONS_OF_USE_BUTTON", ()=>CONDITIONS_OF_USE_BUTTON);
parcelHelpers.export(exports, "PRIVACY_NOTICE_BUTTON", ()=>PRIVACY_NOTICE_BUTTON);
parcelHelpers.export(exports, "SIDE_NAV_MENU_BUTTON", ()=>SIDE_NAV_MENU_BUTTON);
parcelHelpers.export(exports, "HEADER_FAQ_BUTTON", ()=>HEADER_FAQ_BUTTON);
parcelHelpers.export(exports, "HEADER_GET_STARTED_BUTTON", ()=>HEADER_GET_STARTED_BUTTON);
parcelHelpers.export(exports, "MY_PROFILE_CLICK", ()=>MY_PROFILE_CLICK);
parcelHelpers.export(exports, "MANAGE_USERS_CLICK", ()=>MANAGE_USERS_CLICK);
parcelHelpers.export(exports, "HEADER_SIGN_IN_BUTTON", ()=>HEADER_SIGN_IN_BUTTON);
parcelHelpers.export(exports, "SIGN_OUT_BUTTON", ()=>SIGN_OUT_BUTTON);
parcelHelpers.export(exports, "SIGN_UP_BUTTON", ()=>SIGN_UP_BUTTON);
parcelHelpers.export(exports, "LP_SELECT_DROPDOWN_ITEM_CLICK", ()=>LP_SELECT_DROPDOWN_ITEM_CLICK);
parcelHelpers.export(exports, "LOCALE_DROPDOWN_ITEM_CLICK", ()=>LOCALE_DROPDOWN_ITEM_CLICK);
const CONDITIONS_OF_USE_REGION_BUTTON = "CONDITIONS_OF_USE_REGION_BUTTON";
const LANGUAGE_DROPDOWN_CLICK = "LANGUAGE_DROPDOWN_CLICK";
const DROPDOWN_CLICK = "DROPDOWN_CLICK";
const SETTINGS_BUTTON_CLICK = "SETTINGS_BUTTON_CLICK";
const PRIVACY_BUTTON_REGION = "PRIVACY_BUTTON_REGION";
const CONDITIONS_OF_USE_BUTTON = "CONDITIONS_OF_USE_BUTTON";
const PRIVACY_NOTICE_BUTTON = "PRIVACY_NOTICE_BUTTON";
const SIDE_NAV_MENU_BUTTON = "SIDE_NAV_MENU_BUTTON";
const HEADER_FAQ_BUTTON = "HEADER_FAQ_BUTTON";
const HEADER_GET_STARTED_BUTTON = "HEADER_GET_STARTED_BUTTON";
const MY_PROFILE_CLICK = "MY_PROFILE_CLICK";
const MANAGE_USERS_CLICK = "MANAGE_USERS_CLICK";
const HEADER_SIGN_IN_BUTTON = "HEADER_SIGN_IN_BUTTON";
const SIGN_OUT_BUTTON = "SIGN_OUT_BUTTON";
const SIGN_UP_BUTTON = "SIGN_UP_BUTTON";
const LP_SELECT_DROPDOWN_ITEM_CLICK = "LP_SELECT_DROPDOWN_ITEM_CLICK";
const LOCALE_DROPDOWN_ITEM_CLICK = "LOCALE_DROPDOWN_ITEM_CLICK";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3G87j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
/**
 * provides callback to navigating to desired route..
 */ function useNavigateToSpecifiedRoute() {
    const history = (0, _reactRouterDom.useHistory)();
    const navigateToSpecifiedRoute = (0, _react.useCallback)((path)=>{
        history.push(path);
    }, [
        history
    ]);
    return {
        navigateToSpecifiedRoute
    };
}
exports.default = useNavigateToSpecifiedRoute;

},{"react":"6uln9","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7tU2V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _carrierLogisticsCommonsContext = require("@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsContext");
var _carrierLogisticsCommonsContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsContext);
var _carrierLogisticsCommonsDispatchContext = require("@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsDispatchContext");
var _carrierLogisticsCommonsDispatchContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsDispatchContext);
var _flattenObject = require("../utils/flattenObject");
var _flattenObjectDefault = parcelHelpers.interopDefault(_flattenObject);
var _i18N = require("../config/i18n");
var _localeUtils = require("../utils/localeUtils");
/**
 * Wrap component with IntlProvider
 */ const withIntl = (WrappedComponent)=>(props)=>{
        const { localization: { locale = (0, _i18N.DEFAULT_LOCALE) } } = (0, _react.useContext)((0, _carrierLogisticsCommonsContextDefault.default));
        const { localisationDispatch } = (0, _react.useContext)((0, _carrierLogisticsCommonsDispatchContextDefault.default));
        (0, _react.useEffect)(()=>{
            const localeFromLocaleStorage = (0, _localeUtils.getLocaleFromLocalStorage)();
            if (localeFromLocaleStorage) localisationDispatch?.dispatchStoreLocale(localeFromLocaleStorage.replace("_", "-"));
            else if (window.navigator.language) localisationDispatch?.dispatchStoreLocale((0, _localeUtils.getSupportedLocaleForDeviceLocale)());
        }, []);
        const messages = (0, _react.useMemo)(()=>locale === (0, _i18N.DEFAULT_LOCALE) ? (0, _i18N.flattenDefaultLocaleMessages) : {
                ...(0, _i18N.flattenDefaultLocaleMessages),
                ...(0, _flattenObjectDefault.default)((0, _i18N.getTranslations)(locale))
            }, [
            locale
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, _i18N.DEFAULT_LOCALE)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, props));
    };
exports.default = withIntl;

},{"react":"6uln9","react-intl":"4kbQW","@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsContext":"kTkCE","@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsDispatchContext":"dmv1W","../utils/flattenObject":"3kbEy","../config/i18n":"i9CgO","../utils/localeUtils":"cEqPz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kbEy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const flattenObject = (obj, prefix = "")=>Object.keys(obj).reduce((acc, key)=>{
        const nestedPath = prefix.length ? `${prefix}.` : "";
        if (typeof obj[key] === "object") Object.assign(acc, flattenObject(obj[key], nestedPath + key));
        else acc[nestedPath + key] = obj[key];
        return acc;
    }, {});
exports.default = flattenObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i9CgO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>DEFAULT_LOCALE);
parcelHelpers.export(exports, "LOCALES_MESSAGES_MAP", ()=>LOCALES_MESSAGES_MAP);
parcelHelpers.export(exports, "flattenDefaultLocaleMessages", ()=>flattenDefaultLocaleMessages);
parcelHelpers.export(exports, "getTranslations", ()=>getTranslations);
var _carrierLogisticsUIAssetsEnUSPuffJson = require("./translations/CarrierLogisticsUIAssets-en-US.puff.json");
var _carrierLogisticsUIAssetsEnUSPuffJsonDefault = parcelHelpers.interopDefault(_carrierLogisticsUIAssetsEnUSPuffJson);
var _carrierLogisticsUIAssetsFrFRPuffJson = require("./translations/CarrierLogisticsUIAssets-fr-FR.puff.json");
var _carrierLogisticsUIAssetsFrFRPuffJsonDefault = parcelHelpers.interopDefault(_carrierLogisticsUIAssetsFrFRPuffJson);
var _carrierLogisticsUIAssetsItITPuffJson = require("./translations/CarrierLogisticsUIAssets-it-IT.puff.json");
var _carrierLogisticsUIAssetsItITPuffJsonDefault = parcelHelpers.interopDefault(_carrierLogisticsUIAssetsItITPuffJson);
var _carrierLogisticsUIAssetsEsESPuffJson = require("./translations/CarrierLogisticsUIAssets-es-ES.puff.json");
var _carrierLogisticsUIAssetsEsESPuffJsonDefault = parcelHelpers.interopDefault(_carrierLogisticsUIAssetsEsESPuffJson);
var _enJson = require("./en.json");
var _enJsonDefault = parcelHelpers.interopDefault(_enJson);
var _flattenObject = require("../../utils/flattenObject");
var _flattenObjectDefault = parcelHelpers.interopDefault(_flattenObject);
var _unflattenObject = require("../../utils/unflattenObject");
var _unflattenObjectDefault = parcelHelpers.interopDefault(_unflattenObject);
const DEFAULT_LOCALE = "en-US";
const LOCALES_MESSAGES_MAP = {
    "en-US": (0, _carrierLogisticsUIAssetsEnUSPuffJsonDefault.default),
    "fr-FR": (0, _carrierLogisticsUIAssetsFrFRPuffJsonDefault.default),
    "it-IT": (0, _carrierLogisticsUIAssetsItITPuffJsonDefault.default),
    "es-ES": (0, _carrierLogisticsUIAssetsEsESPuffJsonDefault.default)
};
const flattenDefaultLocaleMessages = (0, _flattenObjectDefault.default)((0, _enJsonDefault.default));
const getTranslations = (locale)=>{
    return (0, _unflattenObjectDefault.default)(LOCALES_MESSAGES_MAP[locale]?.resources, "-");
};

},{"./translations/CarrierLogisticsUIAssets-en-US.puff.json":"javpJ","./translations/CarrierLogisticsUIAssets-fr-FR.puff.json":"dIVfl","./translations/CarrierLogisticsUIAssets-it-IT.puff.json":"a8o6E","./translations/CarrierLogisticsUIAssets-es-ES.puff.json":"dog57","./en.json":"edyIo","../../utils/flattenObject":"3kbEy","../../utils/unflattenObject":"hgcsB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"javpJ":[function(require,module,exports) {
module.exports = JSON.parse('{"resources":{"dev_app-title":"CarrierLogistics UI","lp-header_name":"Logistic provider name","lp-header_country":"Registration Country","lp-view_owner":"View Owner/Admin","lp-request_permissions":"Request Permissions","lp-admins_lp":"Admins of this LP:","lp-request_permissions_for_lp":"Please reach out to the admin to request permissions","lp-no_admins":"No admins available for this LP","managePermissions-ok_button":"Ok","permissions-permissions":"Permissions","error_page-heading":"Something went wrong!!","error_page-content":"Please ensure that you are connected to VPN/have an active internet connection.","top_bar-frequently_asked_questions_button":"Frequently Asked Questions","top_bar-get_started_button":"Get started","top_bar-sign_in_button":"Sign in","top_bar-settings_menu-my_profile":"My profile","top_bar-settings_menu-accounts":"Accounts","top_bar-settings_menu-manage_users":"Manage Users","top_bar-settings_menu-sign_out":"Sign out","top_bar-select_lp":"Select an account","top_bar-loading_lps":"Loading accounts...","top_bar-language_toggle_supported":"Only English language is supported for this page. Other language support for this page is coming soon.","home_page-sidebar_label":"Home","home_page-wallpaper_content_block-heading":"Manage your Amazon operations, the smart way","home_page-wallpaper_content_block-content":"Carriers can now view their capacity forecasts, plan adhoc capacity and analyze performance with automated reports, delivered to their doorsteps.","home_page-wallpaper_content_block-get_started_button":"Get started","home_page-wallpaper_content-heading":"Advancing how you manage your operations","home_page-wallpaper_content-body":"We blend advanced technology with 20+ years of insights to help you improve your operations \u2015simply and reliably. With the power of Amazon behind your wheels, you have a partner that\'s here to support your needs of today and help you navigate the road ahead.","home_page-wallpaper_content-sub1-title":"Future-ready platform","home_page-wallpaper_content-sub1-body":"Our platform will scale seamlessly with your operations, and address all your future needs, starting with providing visibility into shipment volume forecasts, adhoc capacity change requests, and claims related to performance on agreed-upon KPIs.","home_page-wallpaper_content-sub2-title":"Safe & Secure","home_page-wallpaper_content-sub2-body":"We know your data privacy is important, that\'s why we do not share your info with any other logistic parties. We are third party security (TPS) compliant.","home_page-wallpaper_content-sub3-title":"Transparent 2-way channel","home_page-wallpaper_content-sub3-body":"We understand transparency is they key for fostering an environment of trust, and enable you to provide feedback on all reports and insights provided. We have a team working 24x7 to ensure this feedback is acted upon swiftly. ","home_page-why_amazon-title":"WHAT ARE THE BENEFITS OF JOINING AMAZON CARRIER LOGISTICS?","home_page-why_amazon-benefits-one_stop-title":"ONE STOP SHOP FOR YOUR OPERATIONS NEEDS","home_page-why_amazon-benefits-one_stop-description":"Manage end-to-end operations lifecycle through one platform","home_page-why_amazon-benefits-reduced_costs-title":"REDUCED COSTS","home_page-why_amazon-benefits-reduced_costs-description":"Plan your capacity and manage exceptions with data-backed insights to optimize operations","home_page-why_amazon-benefits-performance_vis-title":"PERFORMANCE VISIBILITY","home_page-why_amazon-benefits-performance_vis-description":"Use our real time reports to analyse your pertormance and boost your business","home_page-faq_section-header":"FREQUENTLY ASKED QUESTIONS","home_page-faq_section-drilldown-q1-title":"What capabilities are currently enabled through Amazon Carrier Logistics?","home_page-faq_section-drilldown-q1-ans":"Amazon Carrier Logistics currently enables the registered carriers to download and view package count/ volume forecasts and plan their capacity accordingly. Carriers will also receive an e-mail notification every time a new forecast is generated. ","home_page-faq_section-drilldown-q2-title":"What capabilities are planned to launch on Amazon Carrier Logistics in 2023?","home_page-faq_section-drilldown-q2-ans":"Amazon Carrier Logistics will soon enable carriers to view adhoc capacity change requests created based on real-time analysis for each lane. Amazon Carrier Logistics will also allow the carriers to analyze their performance on all KPIs, which are part of their contract. Carriers will be able to approve/ reject any misses highlighted for their performance.  ","home_page-faq_section-drilldown-q3-title":"Is my data secure? ","home_page-faq_section-drilldown-q3-ans":"Amazon follows strict data protection regulations to ensure your data is safe. We are third party security (TPS) compliant and always keep your data and privacy protected. Managing operations via. Amazon Carrier Logistics does not give any other customers visibility or access into your data.","home_page-faq_section-drilldown-q4-title":"Who can I contact if I encounter a problem while downloading package counts/ volume forecasts? ","home_page-faq_section-drilldown-q4-ans":"Reach out to your Amazon account manager and inform them of the issue. Your account manager will revert to your issues within 48 working hours of receiving the issue. ","home_page-faq_section-see_all_faqs_button":"See all FAQs","home_page-footer-conditions_of_use_button":"Conditions of Use","home_page-footer-privacy_notice_button":"Privacy Notice","home_page-footer-copyright_text":"\xa9 1996-2022, Amazon.com, Inc. or its affiliates","faq_page-header":"FREQUENTLY ASKED QUESTIONS","faq_page-tabs-all":"All","faq_page-tabs-onboarding":"Onboarding","faq_page-tabs-safetyAndPerformance":"Safety and Performance","faq_page-tabs-payments":"Payments","faq_page-onboarding-load_req_que":"What are the requirements to carry loads for Amazon?","faq_page-onboarding-load_req_ans-line1":"In order to join Amazon\u2019s freight network, you must meet the following minimum requirements:","faq_page-onboarding-load_req_ans-line1_sub-sub1":"An active DOT number with interstate authority and a valid MC number","faq_page-onboarding-load_req_ans-line1_sub-sub2":"A \u201CCarrier\u201D entity type that is Authorized for Property and for Hire","faq_page-onboarding-load_req_ans-line1_sub-sub3":"A Federal Motor Carrier Safety Administration (FMCSA) Safety Rating of \u201CSatisfactory,\u201D \u201CNone,\u201D or \u201CNot Rated\u201D","faq_page-onboarding-load_req_ans-line1_sub-sub4":"Behavior Analysis and Safety Improvement Categories (BASIC) scores:","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub1":"Unsafe Driving below 60%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub2":"HOS Compliance below 60%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub3":"Vehicle Maintenance below 75%","faq_page-onboarding-amazon_monitor_compliance_que":"How does Amazon monitor carrier compliance?","faq_page-onboarding-amazon_monitor_compliance_ans":"Amazon uses a variety of tools, including our internal compliance teams and a third-party compliance monitoring service, to validate and continually monitor carrier compliance.","faq_page-safety_and_performance-service_level_expectations_que":"What are the service level expectations?","faq_page-safety_and_performance-service_level_expectations_ans-line1":"Amazon requires that carriers ensure the highest level of safety and performance, including:","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub1":"Compliance with safety, DOT and insurance requirements","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub2":"On-time delivery to delight our customer promise.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub3":"Consistent tender acceptance.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub4":"Execute loads using Carrier Logistics technology","faq_page-safety_and_performance-track_my_performance_que":"How can I track my performance?","faq_page-safety_and_performance-track_my_performance_ans":"Amazon provides a transparent performance scorecard in the Carrier Logistics portal. You can review your performance for all of your loads, in order to continuously improve and have the opportunity to grow your business with Amazon.","faq_page-safety_and_performance-amazon_prioritize_safety_que":"How does Amazon prioritize safety?","faq_page-safety_and_performance-amazon_prioritize_safety_ans":"Safety for your drivers, Amazon employees, and the public is Amazon\u2019s first priority. Safety standards must be followed on the road, behind the wheel, in the yard, or in an Amazon facility. We expect you to report any unsafe acts or conditions immediately to Amazon management. There is nothing more important than your safety and the safety of others.","faq_page-payments-completed_loads_payments_que":"When will I get paid for completed loads?","faq_page-payments-completed_loads_payments_ans":"Payment cycle runs weekly from Sunday-Saturday. Everything completed before 23:59 Saturday will be paid out the following week on Friday.","faq_page-payments-submit_invoice_que":"How do I submit an invoice for a load?","faq_page-payments-submit_invoice_ans":"Carrier Logistics will generate invoices automatically. You will be able to review all invoices and payments in Carrier Logistics portal.","faq_page-all_faqs-q1":"What capabilities are currently enabled through Amazon Carrier Logistics?","faq_page-all_faqs-a1-legend":"Amazon Carrier Logistics currently enables the registered carriers to download and view package count/ volume forecasts and plan their capacity accordingly. Carriers will also receive an e-mail notification every time a new forecast is generated. ","faq_page-all_faqs-a1-p1":"Forecasting - Carriers can download and view package count or volume forecasts and plan their capacity accordingly. Carriers will also receive an e-mail notification every time a new forecast is generated. ","faq_page-all_faqs-a1-p2":"Capacity Management - Carriers can review and respond to ad-hoc capacity requests. Carrier Logistics will automatically send notifications and timely reminders for these requests.","faq_page-all_faqs-a1-p3":"Performance Management - Carriers can download and review performance reports. Carriers will also be able to query reported misses. ","faq_page-all_faqs-q2":"What capabilities are planned to launch on Amazon Carrier Logistics in 2023?","faq_page-all_faqs-a2":"Amazon Carrier Logistics will soon enable carriers to view adhoc capacity change requests created based on real-time analysis for each lane. Amazon Carrier Logistics will also allow the carriers to analyze their performance on all KPIs, which are part of their contract. Carriers will be able to approve/ reject any misses highlighted for their performance.","faq_page-all_faqs-q3":"Is my data secure? ","faq_page-all_faqs-a3-p1":"We know that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly. For more information about how we treat your information, you may read the Carrier Logistics Privacy Notice {link}","faq_page-all_faqs-a3-link":"here.","faq_page-all_faqs-a3-p2":"When you choose to use Carrier Logistics, your use and any dispute over privacy is subject to this Notice and our {link}, including limitations on damages, resolution of disputes, and the jurisdiction whose law applies . If you have any concern about privacy at Amazon, please contact us with a thorough description, and we will try to resolve it.","faq_page-all_faqs-a3-conditions":" Conditions of Use","faq_page-all_faqs-q4":"Who can I contact if I encounter a problem on the portal? ","faq_page-all_faqs-a4":"Reach out to your Amazon account manager and inform them of the issue. Your account manager will respond within 48 working hours of receiving your communication. ","faq_page-all_faqs-q5":"Can I give access for Amazon Carrier Logistics to other employees/ contractors of my organization? ","faq_page-all_faqs-a5":"No, only authorized personnel will be able to access and use Amazon Carrier Logistics. To provide access to other personnel in your company, please reach out to your Amazon account manager.","faq_page-all_faqs-q6":"What if I need to request new package volume/ count forecasts? ","faq_page-all_faqs-a6":"Reach out to your Amazon account manager and inform them of your requirements.","get_started_page-header":"GET STARTED","get_started_page-content":"Thank you for your interest. If you have received an invitation from Amazon to register on Amazon Carrier Logistics, please proceed to create an Amazon account. If you are a carrier providing logistics services to Amazon, but have not received your invitation to register, we will approach you soon. You can also contact your account manager at Amazon to know more about registering on Amazon Carrier Logistics.","get_started_page-requirements-header":"REQUIREMENTS","get_started_page-requirements-content-line1":"An active DOT number with interstate authority and a valid MC number","get_started_page-requirements-content-line2":"A \u201CCarrier\u201D entity type that is Authorized for Property and for Hire","get_started_page-requirements-content-line3":"A Federal Motor Carrier Safety Administration (FMCSA) Safety Rating of \u201CSatisfactory,\u201D \u201CNone,\u201D or \u201CNot Rated\u201D","get_started_page-requirements-content-line4":"All required insurance policies including:","get_started_page-requirements-content-line4_sub-sub1":"Commercial General Liability not less than $1,000,000 per occurrence and $2,000,000 in the aggregate","get_started_page-requirements-content-line4_sub-sub2":"Auto Liability not less than $1,000,000 per occurrence, including a trailer replacement coverage of $50,000","get_started_page-requirements-content-line4_sub-sub3":"Cargo coverage of least $100,000","get_started_page-requirements-content-line4_sub-sub4":"Workers\u2019 Compensation insurance in all jurisdictions where your company operates","get_started_page-requirements-content-line4_sub-sub5":"Employer Liability not less than $100,000 per occurrence","get_started_page-sign_up-create_new_account_content":"Create a new account, or sign in to haul with Amazon.","get_started_page-sign_up-create_new_account_button":"Create an Amazon account","get_started_page-sign_up-sign_in_button":"Sign In","terms_conditions_page-usage_content":"Use of Amazon Carrier Logistics in France is governed by the Conditions of Use below. The Conditions of Use are presented in English and French. In the event of any conflict or discrepancy between the French translated version of these Conditions of Use and the English language version, the English language version controls.","terms_conditions_page-conditions_of_use_heading-us":"CONDITIONS OF USE (English)","terms_conditions_page-conditions_of_use_heading-fr":"CONDITIONS D\u2019UTILISATION (French)","terms_conditions_page-conditions_of_use-us-last_updated":"November 17, 2022","terms_conditions_page-conditions_of_use-us-intro_heading":"Welcome to Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-us-intro_content":"Amazon EU Sarl and/or its affiliates (\\"Amazon\\") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the \\"website\\"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively \\"Amazon Services\\"). Please see our Privacy Notice and our Cookies Notice to understand how we collect and process your personal information through Amazon Services. Amazon provides the Amazon Services subject to the conditions set out on this page. \u201CAmazon Carrier Logistics\u201D is the trading name for Amazon.","terms_conditions_page-conditions_of_use-us-welcome_content":"Please read these conditions carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these conditions. We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service (\\"Service Terms\\"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.","terms_conditions_page-conditions_of_use-fr-last_updated":"Le 17 novembre 2022","terms_conditions_page-conditions_of_use-fr-intro_heading":"Bienvenue sur Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-fr-intro_content":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab Amazon \xbb) vous fournissent des fonctionnalit\xe9s de site web et d\u2019autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab site web \xbb), utilisez les produits, ou services Amazon, utilisez les applications Amazon pour mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\u2019un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab Services Amazon \xbb). Veuillez consulter notre Avis de confidentialit\xe9 et notre Avis sur les cookies pour comprendre comment nous recueillons et traitons vos informations personnelles par le biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab Amazon Carrier Logistics \xbb est le nom commercial d\u2019Amazon.","terms_conditions_page-conditions_of_use-fr-welcome_content":"Veuillez lire attentivement les pr\xe9sentes conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces conditions. Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab Conditions du Service \xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de service, ces derni\xe8res pr\xe9vaudront.","privacy_page-usage_content":"Use of Amazon Carrier Logistics in France is governed by the Privacy Notice below. The Privacy Notice is presented in English and French. In the event of any conflict or discrepancy between the French translated version of this Privacy Notice and the English language version, the English language version controls.","privacy_page-heading-us":"Privacy Notice (English)","privacy_page-heading-fr":"Privacy Notice (French)","lp_dropdown-not_found":"No Logistic parties found.","no_permissions":"No permissions to view this section. Try switching to a different logistic party.","carrier_selected":"Carrier ","conditions_of_use-p1":"January 18, 2022","conditions_of_use-p2":"Welcome to Amazon Carrier Logistics.","conditions_of_use-p3-p1":"Amazon EU Sarl and/or its affiliates (\\"Amazon\\") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the \\"Website\\"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively \\"Amazon Services\\"). Please see our","conditions_of_use-p3-l1":"Privacy Notice","conditions_of_use-p3-p2":"and our","conditions_of_use-p3-l2":"Cookies Notice","conditions_of_use-p3-p3":"to understand how we collect and process your personal information through Amazon Services. Amazon provides the Amazon Services subject to the conditions set out on this page. \u201CAmazon Carrier Logistics\u201D is the trading name for Amazon.","conditions_of_use-p4":"Conditions of Use","conditions_of_use-p5-p1":"Please read these conditions carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these conditions.","conditions_of_use-p5-p2":"We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service (\\"Service Terms\\"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.","conditions_of_use-p6":"1. ELECTRONIC COMMUNICATIONS","conditions_of_use-p7":"When you use any Amazon Service or send e-mails to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the Website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communications be in writing, unless mandatory applicable laws specifically require a different form of communication.","conditions_of_use-p8":"2. RECOMMENDATIONS AND PERSONALISATION","conditions_of_use-p9":"As part of the Amazon Services, we will recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalise your experience.","conditions_of_use-p10":"3. COPYRIGHT, AUTHORS\' RIGHTS AND DATABASE RIGHTS","conditions_of_use-p11":"All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by Luxembourg and international copyright, authors\' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by Luxembourg and international copyright and database right laws.","conditions_of_use-p12":"You may not extract and/or re-utilise parts of the content of any Amazon Service without our express written consent. In particular, you may not utilise any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilisation any substantial parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.","conditions_of_use-p13":"4. TRADEMARKS","conditions_of_use-l1":"Click here to see a non-exhaustive list of Amazon trademarks","conditions_of_use-p14":". In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon\'s trademarks and trade dress may not be used in connection with any product or service that is not Amazon\'s, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.","conditions_of_use-p15":"5. PATENTS","conditions_of_use-p16":"One or more patents owned by Amazon apply to the Amazon Services and to the features and services accessible via the Amazon Services. Portions of the Amazon Services operate under license of one or more patents.","conditions_of_use-p17":"6. LICENCE AND ACCESS","conditions_of_use-p18":"Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable licence to access and make personal and non-commercial use of the Amazon Services. This licence does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.","conditions_of_use-p19":"All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other \\"hidden text\\" utilising Amazon\'s names or trademarks without our express written consent.","conditions_of_use-p20":"You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licences granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.","conditions_of_use-p21":"7. YOUR ACCOUNT","conditions_of_use-p22":"You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account. If you use any Amazon Service you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorised manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. You can access your information in the\xa0Your Account\xa0section of the Website.","conditions_of_use-p23":"You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance, inconvenience or anxiety.","conditions_of_use-p24":"We reserve the right to refuse any Amazon Services or terminate accounts if your behaviour gives justified reason to do so. This will in particular be the case if you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are all accessible on the Website. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.","conditions_of_use-p25":"8. REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT","conditions_of_use-p26-p1":"Where the functionality exists to do so, if visitors post reviews, comments and other content; send other communications; and submit suggestions, ideas, comments, questions or other information, the content must not be illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and must not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of \\"spam\\". You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but not, in the absence of a valid","conditions_of_use-p26-p2":", the obligation) to remove or edit such content. If you believe that any content on or advertised for sale on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate","conditions_of_use-p26-p3":"and we will respond.","conditions_of_use-l2":"Report Infringement Form","conditions_of_use-p27":"If you post customer reviews, comments, customer questions or answers, or other content generated by you for display on the Website (including any images, video or audio, all together \\"content\\", you grant Amazon (a) a non-exclusive, royalty-free licence to use, reproduce, publish, make available, translate and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.","conditions_of_use-p28":"You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.","conditions_of_use-p29-p1":"You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as at the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content","conditions_of_use-p29-p2":"arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly.","conditions_of_use-p30":"9. INTELLECTUAL PROPERTY CLAIMS","conditions_of_use-p31":"Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been used in a way that gives rise to concerns of infringement, please follow our","conditions_of_use-p32":"10. AMAZON SOFTWARE TERMS","conditions_of_use-p33":"In addition to these Conditions of Use, the following Software Terms\xa0apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the \\"Amazon Software\\"):","conditions_of_use-p34-p1":"Use of the Amazon Software.","conditions_of_use-p34-p2":"You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by these Conditions of Use, these Software Terms, and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use, or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by Luxembourg and international copyright laws.","conditions_of_use-p34-p3":"Use of Third Party Services.","conditions_of_use-p34-p4":"When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties.","conditions_of_use-p34-p5":"No Reverse Engineering.","conditions_of_use-p34-p6":"Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorise any other person to copy, modify, reverse engineer, decompile or disassemble, or otherwise tamper with, the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software.","conditions_of_use-p34-p7":"Updates.","conditions_of_use-p34-p8":"In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you.","conditions_of_use-p35":"11. OUR LIABILITY","conditions_of_use-p36":"We will do our utmost to ensure that availability of the Amazon Services will be uninterrupted and that transmissions will be error-free. However, due to the nature of the internet, this cannot be guaranteed. Also, your access to Amazon Services may also be occasionally suspended or restricted to allow for repairs, maintenance, or the introduction of new facilities or services. We will attempt to limit the frequency and duration of any such suspension or restriction.","conditions_of_use-p37":"Amazon will not be responsible for (i) losses that were not caused by any breach on our part, or (ii) any business loss (including loss of profits, revenue, contracts, anticipated savings, data, goodwill or wasted expenditure), or (iii) any indirect or consequential losses that were not foreseeable to both you and us when you commenced using the Amazon Services.","conditions_of_use-p38":"We will not be held responsible for any delay or failure to comply with our obligations under these conditions if the delay or failure arises from any cause which is beyond our reasonable control.","conditions_of_use-p39":"The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above limitations may not apply to you and you might have additional rights.","conditions_of_use-p40":"Nothing in these conditions limits or excludes our responsibility for fraudulent representations made by us or for death or personal injury caused by our negligence or wilful misconduct.","conditions_of_use-p41":"12. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY","conditions_of_use-p42":"THE AMAZON SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES ARE PROVIDED BY AMAZON ON AN \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING. AMAZON MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE AMAZON SERVICES OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES, UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. YOU EXPRESSLY AGREE THAT YOUR USE OF THE AMAZON SERVICES IS AT YOUR SOLE RISK. TO THE FULL EXTENT PERMISSIBLE BY LAW, AMAZON DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. AMAZON DOES NOT WARRANT THAT THE AMAZON SERVICES; INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES; AMAZON\u2019S SERVERS; OR ELECTRONIC COMMUNICATIONS SENT FROM AMAZON ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, AMAZON WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY AMAZON SERVICE OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY AMAZON SERVICE, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING.","conditions_of_use-p43":"13. APPLICABLE LAW","conditions_of_use-p44":"If you are in an EU member state, these conditions are governed by and construed in accordance with the laws of Grand Duchy of Luxembourg, and the application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. We both agree to submit to the exclusive jurisdiction of the courts of the city of Luxembourg.","conditions_of_use-p45":"If you are in the United Kingdom, you agree that the laws of England and Wales, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon. The application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. You irrevocably submit to the exclusive jurisdiction of the courts of England. Any dispute or claim relating in any way to your use of the Website will be resolved by bringing a claim before a relevant competent court in England. You waive all objections to the jurisdiction and venue of such courts.","conditions_of_use-p46-p1":"If you would like to bring a matter to our attention, please\xa0","conditions_of_use-p46-l1":"contact us","conditions_of_use-p47":"14. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE","conditions_of_use-p48":"We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.","conditions_of_use-p49":"15. WAIVER","conditions_of_use-p50":"If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.","conditions_of_use-p51":"16. OUR CONTACT DETAILS","conditions_of_use-p52":"This Website is owned and maintained by Amazon EU Sarl:","conditions_of_use-p53":"17. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS","conditions_of_use-p54-p1":"If you believe that your intellectual property rights have been infringed, please submit your complaint using our online\xa0","conditions_of_use-p54-p2":". This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims","conditions_of_use-p55":"Upon receipt of a complaint we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint.","conditions_of_use-p56-p1":"Important Warning:","conditions_of_use-p56-p2":"giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions.","privacy_notice-p1":"Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.","privacy_notice-p2":"Any personal information provided to or to be gathered by Carrier Logistics is controlled by Amazon EU Sarl the data controller, of ","privacy_notice-p4":"We receive, use and store any information you provide to Carrier Logistics through your use of this site. We maintain physical, electronic and procedural safeguards in connection with the collection, storage and disclosure of your information.","privacy_notice-p5":"We use your information to process your application and to communicate with you. We share your information only as described in this Privacy Notice and with Amazon (who are either subject to this Privacy Notice or follow practices at least as protective as those described in this Privacy Notice). We may also release information when we believe it is appropriate to comply with the law; to enforce or apply our Conditions of Use; to protect the rights, property or safety of Carrier Logistics, our users or others; or to conduct background checks with third party companies which are not within Amazon. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction; however, this does not include selling, renting, sharing or otherwise disclosing your information for commercial or marketing purposes.","privacy_notice-p6":"Carrier Logistics complies with applicable laws implementing the so-called \u2018EU Cookies Directive\u2019. Using this site with your browser settings adjusted to accept cookies tells us that you consent to our use of cookies but we only use cookies which we consider to be strictly necessary. The \u2018Help\u2019 feature on most browsers will tell you how to prevent your browser from accepting new cookies, how to have the browser notify you when you receive a new cookie and how to disable cookies altogether.","privacy_notice-p7":"Our business changes constantly and our Privacy Notice and Conditions of Use may also change. You should check our site frequently to see any recent changes.","privacy_notice-p8":"For questions on this Privacy Notice, please contact the company at the address given above.","sidebar_labels-forecast":"Forecast","sidebar_labels-rubiks":"Package Error Correction","sidebar_labels-adhoc_capacity":"Adhoc Capacity","sidebar_labels-performance":"Performance","sidebar_labels-case_management":"Case Dashboard","sidebar_labels-npc":"NPC","sidebar_labels-performance_insights":"Insights","sidebar_labels-performance_dashboard":"Dashboard","support":"Support","unauthorized-title":"No Permissions: ","unauthorized-message":"Thank you for accepting the invitation to join Carrier Logistics. To get started, please contact your carrier administrator to request the necessary access permissions.","feedback-description":"Thank you for taking time to fill in this feedback. This will not take more than 1 minute of your valuable time.","feedback-confirmation_message":"Thank You! We appreciate your feedback."}}');

},{}],"dIVfl":[function(require,module,exports) {
module.exports = JSON.parse('{"resources":{"dev_app-title":"Interface utilisateur de Carrier Logistics","lp-header_name":"Nom du fournisseur logistique","lp-header_country":"Pays d\'enregistrement","lp-view_owner":"Afficher le propri\xe9taire/l\u2019administrateur","lp-request_permissions":"Demander des autorisations","lp-admins_lp":"Administrateurs de ce fournisseur logistique\xa0:","lp-request_permissions_for_lp":"Contactez l\'administrateur pour demander des autorisations","lp-no_admins":"Aucun administrateur disponible pour ce fournisseur logistique","managePermissions-ok_button":"OK","permissions-permissions":"Autorisations","error_page-heading":"Une erreur s\'est produite.","error_page-content":"Assurez-vous que vous \xeates connect\xe9 \xe0 un VPN et disposez d\'une connexion Internet active.","top_bar-frequently_asked_questions_button":"Foire aux questions","top_bar-get_started_button":"Commencer","top_bar-sign_in_button":"S\'identifier","top_bar-settings_menu-my_profile":"Mon profil","top_bar-settings_menu-accounts":"Comptes","top_bar-settings_menu-manage_users":"G\xe9rer les utilisateurs","top_bar-settings_menu-sign_out":"Se d\xe9connecter","top_bar-select_lp":"S\xe9lectionner un compte","top_bar-loading_lps":"Chargement des comptes...","top_bar-language_toggle_supported":"Cette page n\'est disponible qu\'en anglais. Cette page sera bient\xf4t disponible dans d\'autres langues.","home_page-sidebar_label":"Accueil","home_page-wallpaper_content_block-heading":"G\xe9rez vos op\xe9rations Amazon de mani\xe8re intelligente","home_page-wallpaper_content_block-content":"Les transporteurs peuvent d\xe9sormais consulter leurs pr\xe9visions de volume, planifier des capacit\xe9s ad hoc et analyser leurs performances gr\xe2ce \xe0 des rapports automatis\xe9s.","home_page-wallpaper_content_block-get_started_button":"Commencer","home_page-wallpaper_content-heading":"Am\xe9liorer la fa\xe7on dont vous g\xe9rez vos op\xe9rations","home_page-wallpaper_content-body":"Nous associons une technologie de pointe \xe0 plus de 20\xa0ans d\'exp\xe9rience pour vous aider \xe0 am\xe9liorer vos op\xe9rations de fa\xe7on simple et fiable. Avec la puissance d\'Amazon \xe0 votre service, vous disposez un partenaire qui est l\xe0 pour r\xe9pondre \xe0 vos besoins actuels et vous accompagner sur la route du succ\xe8s.","home_page-wallpaper_content-sub1-title":"Une plateforme pr\xeate pour l\'avenir","home_page-wallpaper_content-sub1-body":"Notre plateforme s\'adaptera parfaitement \xe0 la taille de vos op\xe9rations et r\xe9pondra \xe0 tous vos besoins futurs, en commen\xe7ant par vous fournir une meilleure visibilit\xe9 sur les pr\xe9visions des volumes d\'exp\xe9ditions, en vous donnant la possibilit\xe9 de modifier des demandes de capacit\xe9 ad hoc et d\u2019adresser des r\xe9clamations concernant vos performances sur la base de KPI convenus.","home_page-wallpaper_content-sub2-title":"S\xfbr et s\xe9curis\xe9","home_page-wallpaper_content-sub2-body":"Nous savons que la confidentialit\xe9 de vos donn\xe9es est importante, c\'est pourquoi nous ne partageons pas vos informations avec d\'autres partenaires logistiques. Nous agissons en conformit\xe9 avec les r\xe8gles de s\xe9curit\xe9 vis-\xe0-vis des tiers (TPS).","home_page-wallpaper_content-sub3-title":"Canal bidirectionnel transparent","home_page-wallpaper_content-sub3-body":"Nous sommes conscients que la transparence est essentielle pour promouvoir un environnement de confiance. Vous pouvez fournir des commentaires sur tous les rapports et informations fournis. Nous disposons d\u2019une \xe9quipe qui travaille 24\xa0heures sur 24, 7\xa0jours sur 7 afin de nous assurer que ces commentaires sont rapidement pris en compte. ","home_page-why_amazon-title":"QUELS SONT LES AVANTAGES \xc0 REJOINDRE AMAZON CARRIER LOGISTICS\xa0?","home_page-why_amazon-benefits-one_stop-title":"UN GUICHET UNIQUE POUR VOS BESOINS OP\xc9RATIONNELS","home_page-why_amazon-benefits-one_stop-description":"G\xe9rez le cycle de vie de vos op\xe9rations de bout en bout via une seule plateforme","home_page-why_amazon-benefits-reduced_costs-title":"CO\xdbTS R\xc9DUITS","home_page-why_amazon-benefits-reduced_costs-description":"Planifiez votre capacit\xe9 et g\xe9rez les situations exceptionnelles gr\xe2ce \xe0 des informations \xe9tay\xe9es par des donn\xe9es pour optimiser vos op\xe9rations","home_page-why_amazon-benefits-performance_vis-title":"VISIBILIT\xc9 DES PERFORMANCES","home_page-why_amazon-benefits-performance_vis-description":"Utilisez nos rapports en temps r\xe9el pour analyser vos performances et dynamiser votre activit\xe9","home_page-faq_section-header":"FOIRE AUX QUESTIONS","home_page-faq_section-drilldown-q1-title":"Quelles sont actuellement les fonctionnalit\xe9s rendues accessibles par Amazon Carrier Logistics\xa0?","home_page-faq_section-drilldown-q1-ans":"Amazon Carrier Logistics permet actuellement aux transporteurs inscrits d\u2019avoir acc\xe8s aux donn\xe9es suivantes :","home_page-faq_section-drilldown-q2-title":"Quelles fonctionnalit\xe9s doivent \xeatre lanc\xe9es sur Amazon Carrier Logistics en\xa02023\xa0?","home_page-faq_section-drilldown-q2-ans":"Amazon Carrier Logistics permettra bient\xf4t aux transporteurs de consulter les demandes de modification de capacit\xe9 ad hoc cr\xe9\xe9es sur la base de l\u2019analyse en temps r\xe9el pour chaque voie. Amazon Carrier Logistics permettra \xe9galement aux transporteurs d\'analyser leurs performances vis-\xe0-vis de tous les KPI qui font partie de leur contrat. Les transporteurs auront la possibilit\xe9 d\'approuver ou de rejeter tout manquement mis en \xe9vidence dans leurs performances.  ","home_page-faq_section-drilldown-q3-title":"Mes donn\xe9es sont-elles s\xe9curis\xe9es\xa0? ","home_page-faq_section-drilldown-q3-ans":"Amazon respecte des r\xe9glementations strictes en mati\xe8re de protection des donn\xe9es afin de garantir la s\xe9curit\xe9 de vos donn\xe9es. Nous agissons en conformit\xe9 avec les r\xe8gles de s\xe9curit\xe9 vis-\xe0-vis des tiers (TPS) et nous prot\xe9geons toujours vos donn\xe9es et votre confidentialit\xe9. La gestion des op\xe9rations via Amazon Carrier Logistics ne permet \xe0 aucun autre client de voir vos donn\xe9es ou d\u2019y acc\xe9der.","home_page-faq_section-drilldown-q4-title":"Qui puis-je contacter si je rencontre un probl\xe8me lors du t\xe9l\xe9chargement des pr\xe9visions de nombre de colis ou de volume\xa0? ","home_page-faq_section-drilldown-q4-ans":"Contactez votre gestionnaire de compte chez Amazon et informez-le du probl\xe8me. Votre gestionnaire de compte prendra en charge votre probl\xe8me dans les 48\xa0heures ouvrables suivant la r\xe9ception de votre message. ","home_page-faq_section-see_all_faqs_button":"Voir toutes les FAQ","home_page-footer-conditions_of_use_button":"Conditions d\'utilisation","home_page-footer-privacy_notice_button":"D\xe9claration de confidentialit\xe9","home_page-footer-copyright_text":"\xa9 1996-2022, Amazon.com, Inc. ou ses soci\xe9t\xe9s affili\xe9es","faq_page-header":"FOIRE AUX QUESTIONS","faq_page-tabs-all":"Tout","faq_page-tabs-onboarding":"Int\xe9gration","faq_page-tabs-safetyAndPerformance":"S\xe9curit\xe9 et performances","faq_page-tabs-payments":"Paiements","faq_page-onboarding-load_req_que":"Quelles sont les exigences relatives au transport de chargements pour Amazon\xa0?","faq_page-onboarding-load_req_ans-line1":"Pour rejoindre le r\xe9seau de fret d\'Amazon, vous devez r\xe9pondre aux exigences minimales suivantes\xa0:","faq_page-onboarding-load_req_ans-line1_sub-sub1":"Un num\xe9ro DOT actif avec autorit\xe9 inter\xe9tatique et un num\xe9ro MC valide","faq_page-onboarding-load_req_ans-line1_sub-sub2":"Une entit\xe9 de type \xab\xa0transporteur\xa0\xbb qui est autoris\xe9e \xe0 la propri\xe9t\xe9 et \xe0 la location","faq_page-onboarding-load_req_ans-line1_sub-sub3":"Un indice de s\xe9curit\xe9 \xe9valu\xe9 comme \xab\xa0satisfaisant\xa0\xbb, \xab\xa0aucun\xa0\xbb ou \xab\xa0non v\xe9rifi\xe9\xa0\xbb par la FMCSA (administration f\xe9d\xe9rale de la s\xe9curit\xe9 des transporteurs routiers).","faq_page-onboarding-load_req_ans-line1_sub-sub4":"Scores des cat\xe9gories d\'analyse du comportement et d\'am\xe9lioration de la s\xe9curit\xe9 (BASIC)\xa0:","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub1":"Conduite dangereuse en dessous de 60%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub2":"Conformit\xe9 aux heures de service inf\xe9rieure \xe0 60%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub3":"Entretien du v\xe9hicule inf\xe9rieur \xe0 75%","faq_page-onboarding-amazon_monitor_compliance_que":"Comment la conformit\xe9 des transporteurs est-elle contr\xf4l\xe9e par Amazon\xa0?","faq_page-onboarding-amazon_monitor_compliance_ans":"Amazon utilise divers outils, notamment ses \xe9quipes de conformit\xe9 internes et un service tiers de surveillance de la conformit\xe9, afin de contr\xf4ler et valider en permanence la conformit\xe9 des transporteurs.","faq_page-safety_and_performance-service_level_expectations_que":"Quelles sont les attentes en mati\xe8re de niveau de service\xa0?","faq_page-safety_and_performance-service_level_expectations_ans-line1":"Amazon exige des transporteurs qu\'ils garantissent le plus haut niveau de s\xe9curit\xe9 et de performances, notamment\xa0:","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub1":"Conformit\xe9 aux crit\xe8res du DOT (d\xe9partement des transports am\xe9ricain) et aux exigences de s\xe9curit\xe9 et d\'assurance","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub2":"Livraison \xe0 temps pour honorer la promesse faite \xe0 nos clients.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub3":"Acceptation constante des offres.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub4":"Effectuez des chargements gr\xe2ce \xe0 la technologie Carrier Logistics","faq_page-safety_and_performance-track_my_performance_que":"Comment puis-je suivre mes performances\xa0?","faq_page-safety_and_performance-track_my_performance_ans":"Amazon fournit un tableau de performance transparent sur le portail Carrier Logistics. Vous pouvez \xe9valuer vos performances pour tous vos chargements afin de vous am\xe9liorer continuellement et d\'avoir la possibilit\xe9 de d\xe9velopper votre activit\xe9 aupr\xe8s d\u2019Amazon.","faq_page-safety_and_performance-amazon_prioritize_safety_que":"Quelles sont les priorit\xe9s d\'Amazon en mati\xe8re de s\xe9curit\xe9\xa0?","faq_page-safety_and_performance-amazon_prioritize_safety_ans":"La s\xe9curit\xe9 de vos conducteurs, des employ\xe9s d\'Amazon et du public est la priorit\xe9 absolue d\'Amazon. Les normes de s\xe9curit\xe9 doivent \xeatre respect\xe9es sur la route, au volant, dans les zones de chargement et dans les installations Amazon. Nous attendons de vous que vous signaliez imm\xe9diatement tout acte ou situation dangereux \xe0 la direction d\'Amazon. Rien n\'est plus important que votre s\xe9curit\xe9 et celle des autres.","faq_page-payments-completed_loads_payments_que":"Quand serai-je pay\xe9 pour les chargements termin\xe9s\xa0?","faq_page-payments-completed_loads_payments_ans":"Le cycle de paiement est hebdomadaire, du dimanche au samedi. Toute t\xe2che termin\xe9e avant le samedi \xe0 23\xa0h\xa059 sera pay\xe9e le vendredi de la semaine suivante.","faq_page-payments-submit_invoice_que":"Comment soumettre une facture pour un chargement\xa0?","faq_page-payments-submit_invoice_ans":"Carrier Logistics g\xe9n\xe9rera automatiquement les factures. Vous pourrez passer en revue toutes les factures et tous les paiements sur le portail Carrier Logistics.","faq_page-all_faqs-q1":"Quelles sont actuellement les fonctionnalit\xe9s rendues accessibles par Amazon Carrier Logistics\xa0?","faq_page-all_faqs-a1-legend":"Amazon Carrier Logistics permet actuellement aux transporteurs inscrits d\u2019avoir acc\xe8s aux donn\xe9es suivantes :","faq_page-all_faqs-a1-p1":"Pr\xe9visions\xa0: les transporteurs peuvent t\xe9l\xe9charger et consulter les pr\xe9visions de nombre de colis ou de volume afin de pouvoir planifier leur capacit\xe9 en cons\xe9quence. Les transporteurs recevront \xe9galement une notification par e-mail chaque fois qu\'une nouvelle pr\xe9vision sera g\xe9n\xe9r\xe9e. ","faq_page-all_faqs-a1-p2":"Gestion de la capacit\xe9\xa0: les transporteurs peuvent examiner les demandes de capacit\xe9 ad hoc et y r\xe9pondre. Carrier Logistics enverra automatiquement des notifications et des rappels dans les d\xe9lais pour ces demandes.","faq_page-all_faqs-a1-p3":"Gestion des performances\xa0: les transporteurs peuvent t\xe9l\xe9charger et examiner des rapports de performance. Les transporteurs seront \xe9galement en mesure de demander des informations sur les manquements signal\xe9s. ","faq_page-all_faqs-q2":"Quelles fonctionnalit\xe9s doivent \xeatre lanc\xe9es sur Amazon Carrier Logistics en\xa02023\xa0?","faq_page-all_faqs-a2":"Amazon Carrier Logistics permettra bient\xf4t aux transporteurs de consulter les demandes de modification de capacit\xe9 ad hoc cr\xe9\xe9es sur la base de l\u2019analyse en temps r\xe9el pour chaque voie. Amazon Carrier Logistics permettra \xe9galement aux transporteurs d\'analyser leurs performances vis-\xe0-vis de tous les KPI qui font partie de leur contrat. Les transporteurs auront la possibilit\xe9 d\'approuver ou de rejeter tout manquement mis en \xe9vidence dans leurs performances.","faq_page-all_faqs-q3":"Mes donn\xe9es sont-elles s\xe9curis\xe9es\xa0? ","faq_page-all_faqs-a3-p1":"Nous savons que vous vous souciez de la fa\xe7on dont nous utilisons et partageons les informations vous concernant, et nous appr\xe9cions la confiance que vous nous accordez pour le faire de fa\xe7on prudente et r\xe9fl\xe9chie. Pour plus d\'informations sur la fa\xe7on dont nous traitons vos informations, vous pouvez lire la d\xe9claration de confidentialit\xe9 de Carrier Logistics {link}","faq_page-all_faqs-a3-link":"ici.","faq_page-all_faqs-a3-p2":"Lorsque vous choisissez d\'utiliser Carrier Logistics, votre utilisation et tout litige relatif \xe0 la confidentialit\xe9 sont soumis \xe0 la pr\xe9sente d\xe9claration et \xe0 nos {link}, y compris en mati\xe8re de restrictions des dommages, de r\xe9solution des litiges et de juridiction dont la loi s\'applique. Si vous avez la moindre pr\xe9occupation concernant la confidentialit\xe9 chez Amazon, contactez-nous en nous fournissant une description d\xe9taill\xe9e et nous essaierons d\'y rem\xe9dier.","faq_page-all_faqs-a3-conditions":" Conditions d\'utilisation","faq_page-all_faqs-q4":"Qui puis-je contacter en cas de probl\xe8me sur le portail\xa0? ","faq_page-all_faqs-a4":"Contactez votre gestionnaire de compte chez Amazon et informez-le du probl\xe8me. Votre gestionnaire de compte r\xe9pondra dans les 48\xa0heures ouvrables suivant la r\xe9ception de votre communication. ","faq_page-all_faqs-q5":"Puis-je donner acc\xe8s \xe0 Amazon Carrier Logistics \xe0 d\'autres employ\xe9s ou sous-traitants de mon organisation\xa0? ","faq_page-all_faqs-a5":"Non, seul le personnel autoris\xe9 aura acc\xe8s \xe0 Amazon Carrier Logistics et \xe0 son utilisation. Pour fournir l\u2019acc\xe8s \xe0 d\'autres membres du personnel de votre entreprise, contactez votre gestionnaire de compte chez Amazon.","faq_page-all_faqs-q6":"Et si je dois demander de nouvelles pr\xe9visions de nombre de colis ou de volume\xa0? ","faq_page-all_faqs-a6":"Contactez votre gestionnaire de compte chez Amazon et informez-le de vos besoins.","get_started_page-header":"COMMENCER","get_started_page-content":"Nous vous remercions de votre int\xe9r\xeat. Si vous avez re\xe7u une invitation de la part d\'Amazon pour vous inscrire sur Amazon Carrier Logistics, proc\xe9dez \xe0 la cr\xe9ation d\u2019un compte Amazon. Si vous \xeates un transporteur qui fournit des services logistiques \xe0 Amazon mais que vous n\'avez pas re\xe7u d\'invitation \xe0 vous inscrire, nous vous contacterons bient\xf4t. Vous pouvez \xe9galement contacter votre gestionnaire de compte chez Amazon pour en savoir plus sur l\'inscription sur Amazon Carrier Logistics.","get_started_page-requirements-header":"EXIGENCES","get_started_page-requirements-content-line1":"Un num\xe9ro DOT actif avec autorit\xe9 inter\xe9tatique et un num\xe9ro MC valide","get_started_page-requirements-content-line2":"Une entit\xe9 de type \xab\xa0transporteur\xa0\xbb qui est autoris\xe9e \xe0 la propri\xe9t\xe9 et \xe0 la location","get_started_page-requirements-content-line3":"Un indice de s\xe9curit\xe9 \xe9valu\xe9 comme \xab\xa0satisfaisant\xa0\xbb, \xab\xa0aucun\xa0\xbb ou \xab\xa0non v\xe9rifi\xe9\xa0\xbb par la FMCSA (administration f\xe9d\xe9rale de la s\xe9curit\xe9 des transporteurs routiers).","get_started_page-requirements-content-line4":"Toutes les polices d\'assurance requises, y compris\xa0:","get_started_page-requirements-content-line4_sub-sub1":"Responsabilit\xe9 civile g\xe9n\xe9rale commerciale d\u2019au moins 1\xa0000\xa0000\xa0$ par accident et 2\xa0000\xa0000\xa0$ au total","get_started_page-requirements-content-line4_sub-sub2":"Responsabilit\xe9 civile automobile d\'au moins 1\xa0000\xa0000\xa0$ par accident qui inclut une couverture de remplacement de remorque de 50\xa0000\xa0$","get_started_page-requirements-content-line4_sub-sub3":"Couverture de fret d\'au moins 100\xa0000\xa0$","get_started_page-requirements-content-line4_sub-sub4":"Assurance en cas d\u2019accidents du travail dans toutes les juridictions o\xf9 votre entreprise exerce ses activit\xe9s","get_started_page-requirements-content-line4_sub-sub5":"Responsabilit\xe9 civile de l\'employeur d\'au moins 100\xa0000\xa0$ par accident","get_started_page-sign_up-create_new_account_content":"Cr\xe9ez un nouveau compte ou identifiez-vous pour effectuer des transports avec Amazon.","get_started_page-sign_up-create_new_account_button":"Cr\xe9er un compte Amazon","get_started_page-sign_up-sign_in_button":"S\'identifier","terms_conditions_page-usage_content":"L\'utilisation d\'Amazon Carrier Logistics en France est r\xe9gie par les conditions d\u2019utilisation ci-dessous. Les conditions d\'utilisation sont pr\xe9sent\xe9es en anglais et en fran\xe7ais. En cas de conflit ou de divergence entre la version traduite en fran\xe7ais et la version en langue anglaise des pr\xe9sentes conditions d\u2019utilisation, la version anglaise pr\xe9vaut.","terms_conditions_page-conditions_of_use_heading-us":"CONDITIONS D\'UTILISATION (anglais)","terms_conditions_page-conditions_of_use_heading-fr":"CONDITIONS D\'UTILISATION (fran\xe7ais)","terms_conditions_page-conditions_of_use-us-last_updated":"Le 17 novembre 2022","terms_conditions_page-conditions_of_use-us-intro_heading":"Bienvenue sur Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-us-intro_content":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab\xa0Amazon\xa0\xbb) vous fournissent des fonctionnalit\xe9s de site Web et d\'autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab\xa0site Web\xa0\xbb), utilisez les produits ou services Amazon, utilisez les applications Amazon pour mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\'un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab\xa0Services Amazon\xa0\xbb). Consultez notre d\xe9claration de confidentialit\xe9 et notre avis sur les cookies pour comprendre comment nous recueillons et traitons vos informations personnelles par le biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab\xa0Amazon Carrier Logistics\xa0\xbb est le nom commercial d\'Amazon.","terms_conditions_page-conditions_of_use-us-welcome_content":"Lisez attentivement les pr\xe9sentes conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces conditions. Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab\xa0Conditions du Service\xa0\xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de service, ces derni\xe8res pr\xe9vaudront.","terms_conditions_page-conditions_of_use-fr-last_updated":"Le 17\xa0novembre\xa02022","terms_conditions_page-conditions_of_use-fr-intro_heading":"Bienvenue sur Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-fr-intro_content":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab Amazon \xbb) vous fournissent des fonctionnalit\xe9s de site web et d\u2019autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab site web \xbb), utilisez les produits, ou services Amazon, utilisez les applications Amazon pour mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\u2019un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab Services Amazon \xbb). Veuillez consulter notre Avis de confidentialit\xe9 et notre Avis sur les cookies pour comprendre comment nous recueillons et traitons vos informations personnelles par le biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab Amazon Carrier Logistics \xbb est le nom commercial d\u2019Amazon.","terms_conditions_page-conditions_of_use-fr-welcome_content":"Veuillez lire attentivement les pr\xe9sentes conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces conditions. Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab Conditions du Service \xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de service, ces derni\xe8res pr\xe9vaudront.","privacy_page-usage_content":"L\'utilisation d\'Amazon Carrier Logistics en France est r\xe9gie par la d\xe9claration de confidentialit\xe9 ci-dessous. La d\xe9claration de confidentialit\xe9 est pr\xe9sent\xe9e en anglais et en fran\xe7ais. En cas de conflit ou de divergence entre la version traduite en fran\xe7ais et la version en langue anglaise de la pr\xe9sente d\xe9claration de confidentialit\xe9, la version anglaise pr\xe9vaut.","privacy_page-heading-us":"D\xe9claration de confidentialit\xe9 (anglais)","privacy_page-heading-fr":"D\xe9claration de confidentialit\xe9 (fran\xe7ais)","lp_dropdown-not_found":"Aucun partenaire logistique n\u2019a \xe9t\xe9 trouv\xe9.","no_permissions":"Aucune autorisation n\u2019est requise pour consulter cette section. Essayez de passer \xe0 un autre partenaire logistique.","carrier_selected":"Transporteur ","conditions_of_use-p1":"18 janvier 2022","conditions_of_use-p2":"Bienvenue sur Amazon Carrier Logistics.","conditions_of_use-p3-p1":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab\xa0Amazon\xa0\xbb) vous fournissent des fonctionnalit\xe9s de site Web et d\'autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab\xa0Site Web\xa0\xbb), utilisez les produits ou services Amazon, utilisez les applications Amazon pour appareil mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\'un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab\xa0Services Amazon\xa0\xbb). Consultez la section suivante\xa0:","conditions_of_use-p3-l1":"D\xe9claration de confidentialit\xe9","conditions_of_use-p3-p2":"et nos","conditions_of_use-p3-l2":"Avis sur les cookies","conditions_of_use-p3-p3":"pour comprendre comment nous collectons et traitons vos informations personnelles par les biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab\xa0Amazon Carrier Logistics\xa0\xbb est le nom commercial d\'Amazon.","conditions_of_use-p4":"Conditions d\'utilisation","conditions_of_use-p5-p1":"Lisez attentivement les pr\xe9sentes Conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces Conditions.","conditions_of_use-p5-p2":"Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab\xa0Conditions du Service\xa0\xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de Service, ces derni\xe8res pr\xe9vaudront.","conditions_of_use-p6":"1. COMMUNICATIONS \xc9LECTRONIQUES","conditions_of_use-p7":"Lorsque vous utilisez un Service Amazon ou que vous nous envoyez des e-mails, vous communiquez avec nous par voie \xe9lectronique. Nous communiquerons avec vous par voie \xe9lectronique de diff\xe9rentes mani\xe8res, notamment par e-mail, SMS, notifications push int\xe9gr\xe9es \xe0 l\'application ou en publiant des messages \xe9lectroniques ou des communications sur le site Web ou via les autres Services Amazon. \xc0 des fins contractuelles, vous convenez que tous les accords, notifications, divulgations et autres communications que nous vous fournissons par voie \xe9lectronique satisfont \xe0 toute exigence l\xe9gale selon laquelle ces communications doivent \xeatre faites par \xe9crit, \xe0 moins que les lois contraignantes applicables n\'exigent sp\xe9cifiquement une forme de communication diff\xe9rente.","conditions_of_use-p8":"2. RECOMMANDATIONS ET PERSONNALISATION","conditions_of_use-p9":"Dans le cadre des Services Amazon, nous vous recommanderons des fonctionnalit\xe9s, produits et services, y compris des publicit\xe9s tierces susceptibles de vous int\xe9resser, nous identifierons vos pr\xe9f\xe9rences et personnaliserons votre exp\xe9rience.","conditions_of_use-p10":"3. DROITS D\'AUTEUR ET DROITS RELATIFS AUX BASES DE DONN\xc9ES","conditions_of_use-p11":"Tout le contenu inclus ou mis \xe0 votre disposition par le biais d\u2019un Service Amazon, tel que le texte, les graphiques, les logos, les ic\xf4nes de bouton, les images, les clips audio, les t\xe9l\xe9chargements num\xe9riques et les compilations de donn\xe9es, est la propri\xe9t\xe9 d\'Amazon ou de ses fournisseurs de contenu et est prot\xe9g\xe9 par les lois luxembourgeoises et internationales relatives aux droits d\u2019auteur et aux droits relatifs aux bases de donn\xe9es. La compilation de tout le contenu inclus ou mis \xe0 disposition par le biais d\'un Service Amazon est la propri\xe9t\xe9 exclusive d\'Amazon et est prot\xe9g\xe9e par les lois luxembourgeoises et internationales relatives aux droits d\u2019auteur et aux droits relatifs aux bases de donn\xe9es.","conditions_of_use-p12":"Vous n\'\xeates pas autoris\xe9 \xe0 extraire et/ou \xe0 r\xe9utiliser des parties du contenu d\'un Service Amazon sans notre consentement \xe9crit explicite. En particulier, vous n\u2019\xeates pas autoris\xe9 \xe0 utiliser des outils d\'exploration de donn\xe9es, des robots ou tout autre outil similaire de collecte et d\'extraction de donn\xe9es pour extraire (une ou plusieurs fois) tout contenu cons\xe9quent d\u2019un Service Amazon \xe0 des fins de r\xe9utilisation sans notre consentement \xe9crit explicite. Vous n\u2019\xeates pas non plus autoris\xe9 \xe0 cr\xe9er et/ou publier une base de donn\xe9es contenant des parties cons\xe9quentes d\'un Service Amazon (par ex. nos prix) sans notre consentement \xe9crit explicite.","conditions_of_use-p13":"4. MARQUES D\xc9POS\xc9ES","conditions_of_use-l1":"Cliquez ici pour consulter une liste non exhaustive des marques d\xe9pos\xe9es d\u2019Amazon","conditions_of_use-p14":". En outre, les graphiques, logos, en-t\xeates de page, ic\xf4nes de boutons, scripts et noms de service inclus ou mis \xe0 disposition par le biais des Services Amazon constituent des marques d\xe9pos\xe9es ou des pr\xe9sentations commerciales d\'Amazon. Les marques d\xe9pos\xe9es et pr\xe9sentations commerciales d\'Amazon ne doivent pas \xeatre utilis\xe9es en relation avec des produits ou services qui ne sont pas ceux d\'Amazon, d\'une mani\xe8re susceptible de cr\xe9er de la confusion chez les clients ou d\'une mani\xe8re qui d\xe9nigre ou discr\xe9dite Amazon. Toutes les autres marques d\xe9pos\xe9es n\'appartenant pas \xe0 Amazon qui apparaissent dans le cadre des Services Amazon sont la propri\xe9t\xe9 de leurs propri\xe9taires respectifs, qui peuvent ou non \xeatre affili\xe9s ou reli\xe9s \xe0 Amazon, ou sponsoris\xe9s par Amazon.","conditions_of_use-p15":"5. BREVETS","conditions_of_use-p16":"Un ou plusieurs brevets d\xe9tenus par Amazon s\'appliquent aux Services Amazon et aux fonctionnalit\xe9s et services accessibles par le biais des Services Amazon. Des parties des Services Amazon peuvent fonctionner sous licence d\'un ou de plusieurs brevets.","conditions_of_use-p17":"6. LICENCE ET ACC\xc8S","conditions_of_use-p18":"Sous r\xe9serve du respect des pr\xe9sentes Conditions d\'utilisation et Conditions de Service applicables et du paiement de tous les frais applicables, Amazon ou ses fournisseurs de contenu vous accordent une licence limit\xe9e, non exclusive, non transf\xe9rable et non sous-licenciable vous permettant d\'acc\xe9der aux Services Amazon et d\'en faire un usage personnel et non commercial. Cette licence n\'inclut aucune revente ou utilisation commerciale d\u2019un Service Amazon ou de ses contenus\xa0; aucune collecte ni utilisation des descriptions ou prix\xa0; aucune utilisation d\xe9riv\xe9e du Service Amazon ou de son contenu\xa0; aucun t\xe9l\xe9chargement ou copie d\'informations de compte au profit d\u2019un autre marchand\xa0; ni aucune utilisation d\'exploration de donn\xe9es, de robots ou d\'outils similaires de collecte et d\'extraction de donn\xe9es.","conditions_of_use-p19":"Tous les droits qui ne vous sont pas express\xe9ment accord\xe9s dans les pr\xe9sentes Conditions d\'utilisation ou dans les Conditions de Service sont r\xe9serv\xe9s et conserv\xe9s par Amazon ou ses conc\xe9dants de licence, fournisseurs, \xe9diteurs, d\xe9tenteurs de droits ou autres fournisseurs de contenu. Le Service Amazon ou toute partie du Service Amazon ne peut \xeatre reproduit, dupliqu\xe9, copi\xe9, vendu, revendu, visit\xe9 ou exploit\xe9 de toute autre mani\xe8re \xe0 des fins commerciales sans notre consentement \xe9crit explicite. Vous ne pouvez pas encadrer ou utiliser de techniques d\'encadrement (\xab\xa0framing\xa0\xbb) pour inclure une marque d\xe9pos\xe9e, un logo ou d\'autres informations exclusives (y compris des images, du texte, une mise en page ou un formulaire) d\'Amazon sans notre consentement \xe9crit explicite. Vous ne pouvez pas utiliser de balises m\xe9ta ou tout autre \xab\xa0texte masqu\xe9\xa0\xbb utilisant le nom ou les marques d\xe9pos\xe9es d\'Amazon sans notre consentement \xe9crit explicite.","conditions_of_use-p20":"Vous n\'\xeates pas autoris\xe9 \xe0 utiliser les Services Amazon \xe0 mauvais escient. Vous ne pouvez utiliser les Services Amazon que dans les limites autoris\xe9es par la loi. En cas de non-respect des pr\xe9sentes Conditions d\'utilisation ou de toutes Conditions de Service, les licences accord\xe9es par Amazon prendront fin.","conditions_of_use-p21":"7. VOTRE COMPTE","conditions_of_use-p22":"Pour utiliser les Services Amazon, vous pouvez \xeatre amen\xe9 \xe0 disposer d\u2019un compte Amazon propre et \xe0 devoir vous connecter \xe0 ce compte. Si vous utilisez un Service Amazon, vous \xeates tenu de pr\xe9server la confidentialit\xe9 de votre compte et de votre mot de passe et de restreindre l\'acc\xe8s \xe0 votre ordinateur. Dans la mesure permise par la loi applicable, vous acceptez d\'assumer la responsabilit\xe9 de toutes les activit\xe9s effectu\xe9es avec votre compte ou votre mot de passe. Vous devez prendre toutes les mesures n\xe9cessaires pour garantir la confidentialit\xe9 et la s\xe9curit\xe9 de votre mot de passe, et nous informer imm\xe9diatement si vous avez des raisons de croire que votre mot de passe est connu de quelqu\'un d\'autre ou s\'il est utilis\xe9 de mani\xe8re non autoris\xe9e, ou s\u2019il est susceptible de l\u2019\xeatre. Vous \xeates responsable de la v\xe9racit\xe9 et de l\u2019exhaustivit\xe9 des informations que vous nous fournissez. Il vous revient de nous informer de toute modification des informations fournies. Vous pouvez acc\xe9der \xe0 vos informations dans la section Votre compte du site Web.","conditions_of_use-p23":"Vous ne devez pas utiliser un Service Amazon\xa0: (i) d\'une mani\xe8re entra\xeenant ou \xe9tant susceptible d\u2019entra\xeener l\'interruption, l\'endommagement ou la perturbation de tout acc\xe8s \xe0 celui-ci, ou (ii) \xe0 des fins frauduleuses, ou en relation avec une infraction p\xe9nale ou toute autre activit\xe9 ill\xe9gale, ou (iii) pour provoquer de la g\xeane, des d\xe9sagr\xe9ments ou de la peur.","conditions_of_use-p24":"Nous nous r\xe9servons le droit de refuser l\u2019acc\xe8s \xe0 tout Service Amazon ou de proc\xe9der \xe0 une r\xe9siliation de compte si votre comportement le justifie. Ce sera notamment le cas si vous enfreignez les lois applicables, les dispositions contractuelles applicables, nos directives ou nos politiques, qui sont toutes accessibles sur le site Web. Nonobstant toute limitation ou r\xe9siliation, vous disposerez d\u2019un acc\xe8s au contenu et aux services que vous avez achet\xe9s jusqu\'\xe0 cette date.","conditions_of_use-p25":"8. AVIS, COMMENTAIRES, COMMUNICATIONS ET AUTRES CONTENUS","conditions_of_use-p26-p1":"Lorsque les fonctionnalit\xe9s le permettent, les visiteurs peuvent publier des avis, commentaires et autres contenus, et soumettre des suggestions, id\xe9es, commentaires, questions ou autres informations, tant que le contenu n\'est pas ill\xe9gal, obsc\xe8ne, mena\xe7ant, diffamatoire, intrusif dans la vie priv\xe9e, ne porte pas atteinte aux droits de propri\xe9t\xe9 intellectuelle ou n\u2019est pas autrement pr\xe9judiciable \xe0 des tiers ou r\xe9pr\xe9hensible, et ne contient pas de virus logiciels, campagnes politiques, sollicitations commerciales, cha\xeenes de lettres, publipostages en masse ou toute forme de \xab\xa0spam\xa0\xbb ou pourriel. Vous ne pouvez pas utiliser de fausse adresse e-mail, usurper l\'identit\xe9 d\'une personne ou d\'une entit\xe9, ou induire en erreur quant \xe0 l\'origine d\'une carte ou d\'un autre contenu. Nous nous r\xe9servons le droit (mais non, en l\'absence d\'un","conditions_of_use-p26-p2":", l\'obligation) de supprimer ou modifier ce contenu. Si vous pensez qu\'un contenu publi\xe9 ou annonc\xe9 \xe0 la vente sur un Service Amazon comporte une mention diffamatoire, ou que vos droits de propri\xe9t\xe9 intellectuelle sont viol\xe9s par un article ou une information sur un Service Amazon, informez-nous en. Pour cela, remplissez et soumettez le formulaire appropri\xe9","conditions_of_use-p26-p3":"et nous apporterons une r\xe9ponse.","conditions_of_use-l2":"Formulaire de signalement d\'infraction","conditions_of_use-p27":"Si vous publiez des commentaires client, avis, questions ou r\xe9ponses client, ou tout autre contenu que vous g\xe9n\xe9rez afin de l\u2019afficher sur le site Web (y compris des images, des vid\xe9os ou des fichiers audio, tous regroup\xe9s sous le terme \xab\xa0contenu\xa0\xbb), vous accordez \xe0 Amazon (a) une licence non exclusive et libre de droits pour utiliser, reproduire, publier, mettre \xe0 disposition, traduire et modifier ce contenu dans le monde entier (y compris le droit de sous-licencier ces droits \xe0 des tiers) et (b) le droit d\'utiliser le nom que vous soumettez en relation avec ce contenu. Cette disposition n\u2019implique aucun transfert de droit moral.","conditions_of_use-p28":"Vous avez la possibilit\xe9 de supprimer votre contenu de la vue du public ou, lorsque cette fonctionnalit\xe9 est propos\xe9e, de modifier les param\xe8tres de visibilit\xe9 pour que votre contenu ne soit montr\xe9 qu\'aux personnes que vous autorisez \xe0 y acc\xe9der.","conditions_of_use-p29-p1":"Vous confirmez et garantissez la d\xe9tention et le contr\xf4le de l\u2019ensemble des droits concernant le contenu que vous publiez\xa0; qu\'\xe0 la date de publication du contenu ou du mat\xe9riel\xa0: (i) le contenu et le mat\xe9riel sont exacts\xa0; et (ii) l\'utilisation du contenu et du mat\xe9riel que vous fournissez ne viole aucune politique ou directive applicable et ne portera pr\xe9judice \xe0 aucune personne ou entit\xe9 (ce qui inclut l\u2019absence de caract\xe8re diffamatoire du contenu ou mat\xe9riel). Vous acceptez d\'indemniser Amazon pour toutes les r\xe9clamations d\xe9pos\xe9es par un tiers contre Amazon en rapport avec le contenu et le mat\xe9riel que vous fournissez, sauf dans la mesure o\xf9 toute responsabilit\xe9 d\xe9coulerait de notre manquement \xe0 supprimer correctement le contenu apr\xe8s avoir \xe9t\xe9 avertis de son caract\xe8re ill\xe9gal","conditions_of_use-p29-p2":"d\xe9coulant du contenu que vous nous avez communiqu\xe9, ou se basant sur celui-ci. En supprimant du contenu de la vue du public, vous retirez \xe0 Amazon sa licence lui permettant de publier et de mettre ce contenu \xe0 la disposition du public.","conditions_of_use-p30":"9. R\xc9CLAMATIONS RELATIVES AUX DROITS DE PROPRI\xc9T\xc9 INTELLECTUELLE","conditions_of_use-p31":"Amazon respecte la propri\xe9t\xe9 intellectuelle d\u2019autrui. Si vous pensez que vos droits de propri\xe9t\xe9 intellectuelle ont \xe9t\xe9 utilis\xe9s d\'une mani\xe8re laissant craindre leur violation, r\xe9f\xe9rez-vous \xe0 la section suivante\xa0:","conditions_of_use-p32":"10. CONDITIONS DU LOGICIEL AMAZON","conditions_of_use-p33":"Outre les pr\xe9sentes Conditions d\'utilisation, les Conditions du logiciel suivantes s\'appliquent \xe0 tout logiciel (y compris toute mise \xe0 jour ou mise \xe0 niveau du logiciel et toute documentation associ\xe9e) que nous mettons parfois \xe0 votre disposition pour que vous puissiez utiliser les Services Amazon (le \xab\xa0Logiciel Amazon\xa0\xbb)\xa0:","conditions_of_use-p34-p1":"Utilisation du logiciel Amazon.","conditions_of_use-p34-p2":"Vous \xeates autoris\xe9 \xe0 utiliser le Logiciel Amazon uniquement pour utiliser et profiter des Services Amazon tels que fournis par Amazon et conform\xe9ment aux pr\xe9sentes Conditions d\'utilisation, aux pr\xe9sentes Conditions du logiciel et \xe0 toutes autres Conditions de Service. Vous n\'\xeates pas autoris\xe9 \xe0 int\xe9grer une quelconque partie du Logiciel Amazon dans vos propres programmes ou \xe0 en compiler une quelconque partie en combinaison avec vos propres programmes, \xe0 le transf\xe9rer pour l\'utiliser avec un autre service, ou \xe0 vendre, louer, pr\xeater, distribuer ou sous-licencier le Logiciel Amazon, ni attribuer de quelque mani\xe8re que ce soit des droits sur le Logiciel Amazon en tout ou en partie. Vous n\'\xeates pas autoris\xe9 \xe0 utiliser le Logiciel Amazon \xe0 des fins ill\xe9gales. Nous pouvons cesser toute fourniture d\u2019un quelconque Logiciel Amazon et mettre fin \xe0 votre droit d\'utilisation de ce Logiciel \xe0 tout moment. En cas de non-respect de l\'une des pr\xe9sentes Conditions du logiciel, Conditions d\'utilisation ou autres Conditions de Service, vous perdrez automatiquement vos droits d\'utilisation du Logiciel Amazon et ceux-ci seront r\xe9sili\xe9s sans pr\xe9avis de notre part. Des conditions tierces suppl\xe9mentaires contenues dans ou distribu\xe9es avec certains Logiciels Amazon sp\xe9cifiquement identifi\xe9es dans la documentation associ\xe9e peuvent s\'appliquer auxdits Logiciels Amazon (ou \xe0 un logiciel int\xe9gr\xe9 aux Logiciels Amazon). En cas de conflit avec les pr\xe9sentes Conditions d\'utilisation, ces conditions tierces s\u2019appliqueront \xe0 l\u2019utilisation desdits logiciels. Tous les logiciels utilis\xe9s pour tout Service Amazon sont la propri\xe9t\xe9 d\'Amazon ou de ses fournisseurs de logiciels et sont prot\xe9g\xe9s par les lois luxembourgeoises et internationales relatives au droit d\u2019auteur.","conditions_of_use-p34-p3":"Utilisation de services tiers.","conditions_of_use-p34-p4":"Lorsque vous utilisez le Logiciel Amazon, vous pouvez \xe9galement utiliser les services d\'un ou de plusieurs tiers, tels qu\'un op\xe9rateur de t\xe9l\xe9phonie mobile ou un fournisseur de plateforme mobile. Votre utilisation de ces services tiers peut \xeatre soumise aux politiques, conditions d\'utilisation et frais distincts de ces tiers.","conditions_of_use-p34-p5":"Interdiction de r\xe9tro-ing\xe9nierie.","conditions_of_use-p34-p6":"Sauf autorisation expresse en vertu de la loi contraignante applicable, vous ne pouvez pas, et vous n\'encouragerez, n\'aiderez ou n\'autoriserez aucune autre personne \xe0 copier, modifier, r\xe9tro-concevoir, d\xe9compiler, d\xe9sassembler ou alt\xe9rer de quelque mani\xe8re que ce soit, le Logiciel Amazon, que ce soit en tout ou en partie, ou \xe0 cr\xe9er des \u0153uvres d\xe9riv\xe9es \xe0 partir du Logiciel Amazon.","conditions_of_use-p34-p7":"Mises \xe0 jour.","conditions_of_use-p34-p8":"Pour maintenir le Logiciel Amazon \xe0 jour, nous pouvons proposer des actualisations automatiques ou manuelles \xe0 tout moment et sans pr\xe9avis.","conditions_of_use-p35":"11. NOTRE RESPONSABILIT\xc9","conditions_of_use-p36":"Nous ferons tout notre possible pour garantir une disponibilit\xe9 continue des Services Amazon et des transmissions sans perturbations. Nous ne pouvons toutefois le garantir en raison de la nature d\'Internet. Par ailleurs, votre acc\xe8s aux Services Amazon peut \xe9galement parfois \xeatre suspendu ou restreint pour permettre des corrections, des op\xe9rations de maintenance ou la mise en place de nouvelles installations ou de nouveaux services. Nous ferons notre possible pour limiter la fr\xe9quence et la dur\xe9e de telles suspensions ou restrictions.","conditions_of_use-p37":"Amazon ne sera pas responsable (i) des pertes qui n\'ont pas \xe9t\xe9 caus\xe9es par une quelconque violation de notre part, ou (ii) de toute perte commerciale (y compris la perte de profits, de revenus, de contrats, d\'\xe9conomies anticip\xe9es, de donn\xe9es, de client\xe8le ou toute d\xe9pense inutile), ou (iii) de toute perte indirecte ou cons\xe9cutive qui n\'\xe9tait pr\xe9visible ni pour vous ni pour nous lorsque vous avez commenc\xe9 \xe0 utiliser les Services Amazon.","conditions_of_use-p38":"Nous ne serons pas tenus responsables de tout retard ou manquement \xe0 respecter nos obligations en vertu des pr\xe9sentes Conditions si ce retard ou ce manquement r\xe9sulte d\'une cause ind\xe9pendante de notre contr\xf4le raisonnable.","conditions_of_use-p39":"Les lois de certains pays n\'autorisent pas une partie ou l\u2019ensemble des restrictions d\xe9crites ci-dessus. Si ces lois s\'appliquent \xe0 vous, une partie ou l\u2019ensemble des restrictions ci-dessus peuvent ne pas s\'appliquer \xe0 votre personne et vous pourriez disposez de droits suppl\xe9mentaires.","conditions_of_use-p40":"Aucune disposition des pr\xe9sentes Conditions ne limite ou n\'exclut notre responsabilit\xe9 en cas de d\xe9clarations frauduleuses de notre part ou en cas de d\xe9c\xe8s ou de blessures corporelles caus\xe9s par notre n\xe9gligence ou notre faute intentionnelle.","conditions_of_use-p41":"12. CLAUSE DE NON-RESPONSABILIT\xc9 EN MATI\xc8RE DE GARANTIES ET LIMITATION DE RESPONSABILIT\xc9","conditions_of_use-p42":"LES SERVICES AMAZON ET TOUTES LES INFORMATIONS, LE CONTENU, LE MAT\xc9RIEL, LES PRODUITS (Y COMPRIS LES LOGICIELS) ET TOUS AUTRES SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS DES SERVICES AMAZON SONT FOURNIS PAR AMAZON \xab\xa0TELS QUELS\xa0\xbb ET \xab\xa0TELS QUE DISPONIBLES\xa0\xbb, SAUF INDICATION CONTRAIRE. AMAZON N\u2019OFFRE AUCUNE ASSURANCE OU GARANTIE DE QUELQUE NATURE QUE CE SOIT, EXPRESSE OU IMPLICITE, QUANT AU FONCTIONNEMENT DES SERVICES AMAZON OU AUX INFORMATIONS, AU CONTENU, AUX MAT\xc9RIAUX, AUX PRODUITS (Y COMPRIS LES LOGICIELS) OU \xc0 TOUS SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS DES SERVICES AMAZON, SAUF INDICATION CONTRAIRE DANS L\'ACCORD. VOUS ACCEPTEZ EXPRESS\xc9MENT D\u2019UTILISER LES SERVICES AMAZON \xc0 VOS RISQUES ET P\xc9RILS. DANS LE RESPECT DES DISPOSITIONS L\xc9GALES, AMAZON D\xc9CLINE TOUTE GARANTIE, EXPRESSE OU IMPLICITE, Y COMPRIS, MAIS SANS S\'Y LIMITER, LES GARANTIES IMPLICITES DE QUALIT\xc9 MARCHANDE ET D\'AD\xc9QUATION \xc0 UN USAGE PARTICULIER. AMAZON NE GARANTIT PAS QUE LES SERVICES AMAZON, LES INFORMATIONS, LE CONTENU, LES MAT\xc9RIAUX, LES PRODUITS (Y COMPRIS LES LOGICIELS) OU TOUS SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS DES SERVICES AMAZON, DE SES SERVEURS OU DES COMMUNICATIONS \xc9LECTRONIQUES ENVOY\xc9ES PAR AMAZON SONT EXEMPTS DE VIRUS OU D\'AUTRES COMPOSANTS NUISIBLES. DANS TOUTE LA MESURE PERMISE PAR LA LOI, AMAZON D\xc9CLINE TOUTE RESPONSABILIT\xc9 EN CAS DE DOMMAGES DE QUELQUE NATURE QUE CE SOIT R\xc9SULTANT DE L\'UTILISATION D\u2019UN SERVICE AMAZON OU D\u2019INFORMATIONS, CONTENUS, MAT\xc9RIELS, PRODUITS (Y COMPRIS LES LOGICIELS) OU TOUS SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS D\u2019UN SERVICE AMAZON, Y COMPRIS, MAIS SANS S\'Y LIMITER, LES DOMMAGES DIRECTS, INDIRECTS, ACCESSOIRES, PUNITIFS ET CONS\xc9CUTIFS, SAUF INDICATION \xc9CRITE CONTRAIRE.","conditions_of_use-p43":"13. LOI APPLICABLE","conditions_of_use-p44":"Si vous vous trouvez dans un \xc9tat membre de l\'UE, ces Conditions sont r\xe9gies et interpr\xe9t\xe9es conform\xe9ment aux lois du Grand-Duch\xe9 de Luxembourg. L\'application de la Convention des Nations Unies sur les contrats de vente internationale de marchandises est express\xe9ment exclue. Les deux parties acceptent de se soumettre \xe0 la comp\xe9tence exclusive des tribunaux de la ville de Luxembourg.","conditions_of_use-p45":"Depuis le Royaume-Uni, vous acceptez que les lois de l\'Angleterre et du Pays de Galles, sans \xe9gard aux principes de conflit de lois, r\xe9gissent les pr\xe9sentes Conditions d\u2019utilisation et tout litige de quelque nature que ce soit pouvant survenir entre vous et Amazon. L\'application de la Convention des Nations Unies sur les contrats de vente internationale de marchandises est express\xe9ment exclue. Vous vous soumettez irr\xe9vocablement \xe0 la juridiction exclusive des tribunaux d\'Angleterre. Tout litige ou toute r\xe9clamation li\xe9 de quelque mani\xe8re que ce soit \xe0 votre utilisation du Site Web sera r\xe9solu en pr\xe9sentant une plainte devant un tribunal comp\xe9tent en Angleterre. Vous renoncez \xe0 toute objection quant \xe0 la comp\xe9tence et \xe0 l\u2019endroit de ces tribunaux.","conditions_of_use-p46-p1":"Si vous souhaitez porter une question \xe0 notre attention,\xa0","conditions_of_use-p46-l1":"contactez-nous","conditions_of_use-p47":"14. MODIFICATIONS DU SERVICE OU DES CONDITIONS D\'UTILISATION","conditions_of_use-p48":"Nous nous r\xe9servons le droit de modifier \xe0 tout moment les Services Amazon, politiques et conditions g\xe9n\xe9rales, y compris les pr\xe9sentes Conditions d\u2019utilisation et de Service. Au moment de votre utilisation des Services Amazon, vous serez soumis aux conditions g\xe9n\xe9rales, politiques et Conditions d\'utilisation en vigueur. Si une des pr\xe9sentes Conditions d\u2019utilisation est jug\xe9e invalide, nulle ou, pour quelque raison que ce soit, inapplicable, cette condition sera consid\xe9r\xe9e comme dissociable et n\'affectera pas la validit\xe9 et l\'applicabilit\xe9 de toute autre condition.","conditions_of_use-p49":"15. RENONCIATION","conditions_of_use-p50":"Si vous enfreignez les pr\xe9sentes Conditions d\u2019utilisation et que nous ne prenons aucune mesure, nous pourrons toujours exercer nos droits et recours dans tout autre cas o\xf9 vous violeriez lesdites Conditions d\u2019utilisation.","conditions_of_use-p51":"16. NOS COORDONN\xc9ES","conditions_of_use-p52":"Ce Site Web est d\xe9tenu et g\xe9r\xe9 par Amazon EU Sarl\xa0:","conditions_of_use-p53":"17. AVIS ET PROC\xc9DURE DE R\xc9CLAMATION EN CAS DE VIOLATION DE DROITS","conditions_of_use-p54-p1":"Si vous pensez que vos droits de propri\xe9t\xe9 intellectuelle ont \xe9t\xe9 viol\xe9s, d\xe9posez une plainte en ligne en utilisant notre\xa0","conditions_of_use-p54-p2":". Ce formulaire peut \xeatre utilis\xe9 pour signaler tous les types de r\xe9clamations relatives aux droits de propri\xe9t\xe9 intellectuelle, y compris, mais sans s\'y limiter, les r\xe9clamations relatives aux droits d\'auteur, aux marques d\xe9pos\xe9es, aux dessins et aux brevets","conditions_of_use-p55":"\xc0 la r\xe9ception d\'une plainte, nous pouvons prendre certaines mesures, notamment supprimer des informations ou \xe9l\xe9ments sp\xe9cifiques. Dans des circonstances appropri\xe9es, nous pouvons mettre fin aux droits d\u2019acc\xe8s en cas de violations r\xe9p\xe9t\xe9es. Toutes ces mesures sont prises sans aucune reconnaissance de responsabilit\xe9 et sans porter atteinte aux droits, recours ou d\xe9fenses, qui sont tous express\xe9ment r\xe9serv\xe9s. Cela inclut la transmission de la plainte aux parties impliqu\xe9es dans la fourniture du contenu pr\xe9sum\xe9 en infraction. Vous acceptez d\'indemniser Amazon pour toutes les r\xe9clamations d\xe9pos\xe9es par un tiers contre Amazon \xe0 la suite ou en relation avec le d\xe9p\xf4t d\'une plainte.","conditions_of_use-p56-p1":"Avertissement important\xa0:","conditions_of_use-p56-p2":"la fourniture d\'informations fausses, trompeuses ou inexactes dans le formulaire de notification \xe0 Amazon peut engager votre responsabilit\xe9 civile et/ou p\xe9nale. En cas de questions, contactez un conseiller juridique.","privacy_notice-p1":"Carrier Logistics sait que vous vous souciez de la mani\xe8re dont vos informations personnelles sont utilis\xe9es et partag\xe9es, et nous vous remercions de la confiance que vous nous accordez pour les utiliser avec prudence et discernement.","privacy_notice-p2":"Toutes les informations personnelles fournies ou devant \xeatre collect\xe9es par Carrier Logistics sont contr\xf4l\xe9es par Amazon EU Sarl, le responsable du traitement, de ","privacy_notice-p4":"Nous recevons, utilisons et stockons toutes les informations que vous fournissez \xe0 Carrier Logistics dans le cadre de votre utilisation de ce site. Nous conservons des sauvegardes physiques, \xe9lectroniques et proc\xe9durales en lien avec la collecte, le stockage et la divulgation des informations personnelles des clients.","privacy_notice-p5":"Nous utilisons vos informations pour traiter votre demande et communiquer avec vous. Nous partageons vos informations uniquement comme d\xe9crit dans la pr\xe9sente d\xe9claration de confidentialit\xe9 et avec Amazon (qui est soit soumis \xe0 la pr\xe9sente d\xe9claration de confidentialit\xe9, soit suit des pratiques au moins aussi protectrices que celles d\xe9crites dans la pr\xe9sente d\xe9claration de confidentialit\xe9). Nous pouvons \xe9galement divulguer des informations lorsque nous pensons que cela est appropri\xe9 pour nous conformer \xe0 la loi, pour faire respecter ou appliquer nos Conditions d\u2019utilisation, pour prot\xe9ger les droits, la propri\xe9t\xe9 ou la s\xe9curit\xe9 de Carrier Logistics, de nos utilisateurs ou d\u2019autres personnes, ou pour effectuer des v\xe9rifications d\u2019ant\xe9c\xe9dents aupr\xe8s de soci\xe9t\xe9s tierces qui ne font pas partie d\u2019Amazon. Cela inclut l\'\xe9change d\'informations avec d\'autres soci\xe9t\xe9s et organisations pour la protection contre la fraude et la r\xe9duction du risque en mati\xe8re de cr\xe9dit\xa0; toutefois, cela n\'inclut pas la vente, la location, le partage ou toute autre divulgation de vos informations \xe0 des fins commerciales ou marketing.","privacy_notice-p6":"Carrier Logistics se conforme aux lois applicables mettant en \u0153uvre la \xab\xa0directive europ\xe9enne sur les cookies\xa0\xbb. L\'utilisation de ce site avec les param\xe8tres de votre navigateur r\xe9gl\xe9s pour accepter les cookies nous indique que vous acceptez notre utilisation des cookies, mais nous n\'utilisons que les cookies que nous consid\xe9rons comme strictement n\xe9cessaires. La fonction \xab\xa0Aide\xa0\xbb de la plupart des navigateurs vous indiquera comment emp\xeacher votre navigateur d\'accepter de nouveaux cookies, comment demander au navigateur de vous avertir lorsque vous recevez un nouveau cookie et comment d\xe9sactiver compl\xe8tement les cookies.","privacy_notice-p7":"Nos activit\xe9s \xe9voluent constamment et notre d\xe9claration de confidentialit\xe9 et nos Conditions d\u2019utilisation peuvent \xe9galement changer. Nous vous invitons \xe0 consulter fr\xe9quemment notre site pour prendre connaissance des modifications r\xe9centes.","privacy_notice-p8":"Pour toute question sur la pr\xe9sente d\xe9claration de confidentialit\xe9, contactez la soci\xe9t\xe9 \xe0 l\'adresse indiqu\xe9e ci-dessus.","sidebar_labels-forecast":"Pr\xe9visions","sidebar_labels-rubiks":"Correction d\'erreurs concernant le colis","sidebar_labels-adhoc_capacity":"Capacit\xe9 ad hoc","sidebar_labels-performance":"Performances","sidebar_labels-case_management":"Tableau de bord des dossiers","sidebar_labels-npc":"NPC","sidebar_labels-performance_insights":"Informations","sidebar_labels-performance_dashboard":"Tableau de bord","support":"Assistance","unauthorized-title":"Aucune autorisation\xa0: ","unauthorized-message":"Merci d\'avoir accept\xe9 l\'invitation \xe0 rejoindre Carrier Logistics. Pour commencer, contactez l\'administrateur de votre op\xe9rateur pour demander les autorisations d\'acc\xe8s n\xe9cessaires.","feedback-description":"Merci d\'avoir pris le temps de remplir ce commentaire. Cela ne vous prendra pas plus d\'une minute de votre pr\xe9cieux temps.","feedback-confirmation_message":"Merci. Nous appr\xe9cions vos commentaires."}}');

},{}],"a8o6E":[function(require,module,exports) {
module.exports = JSON.parse('{"resources":{"dev_app-title":"Interfaccia utente Carrier Logistics","lp-header_name":"Nome del fornitore di servizi logistici","lp-header_country":"Paese di registrazione","lp-view_owner":"Visualizza proprietario/amministratore","lp-request_permissions":"Richiedi autorizzazioni","lp-admins_lp":"Amministratori di questo LP:","lp-request_permissions_for_lp":"Contatta l\'amministratore per richiedere le autorizzazioni","lp-no_admins":"Nessun amministratore disponibile per questo LP","managePermissions-ok_button":"Ok","permissions-permissions":"Autorizzazioni","error_page-heading":"Si \xe8 verificato un problema!","error_page-content":"Assicurati di essere connesso alla VPN o di avere una connessione Internet attiva.","top_bar-frequently_asked_questions_button":"Domande frequenti","top_bar-get_started_button":"Inizia","top_bar-sign_in_button":"Accedi","top_bar-settings_menu-my_profile":"Il mio profilo","top_bar-settings_menu-accounts":"Account","top_bar-settings_menu-manage_users":"Gestisci utenti","top_bar-settings_menu-sign_out":"Esci","top_bar-select_lp":"Seleziona un account","top_bar-loading_lps":"Caricamento degli account in corso...","top_bar-language_toggle_supported":"In questa pagina \xe8 supportata solo la lingua inglese. Il supporto di altre lingue per questa pagina sar\xe0 disponibile a breve.","home_page-sidebar_label":"Home","home_page-wallpaper_content_block-heading":"Gestisci le tue operazioni Amazon in modo intelligente","home_page-wallpaper_content_block-content":"I corrieri possono ora visualizzare le previsioni di capacit\xe0, pianificare la capacit\xe0 ad hoc e analizzare le performance con report automatizzati, consegnati direttamente a casa loro.","home_page-wallpaper_content_block-get_started_button":"Inizia","home_page-wallpaper_content-heading":"Miglioramento del modo in cui gestisci le tue operazioni","home_page-wallpaper_content-body":"Uniamo tecnologia avanzata con oltre 20 anni di conoscenze per aiutarti a migliorare le tue operazioni in modo semplice e affidabile. Con la potenza di Amazon alle tue spalle, hai un partner pronto a soddisfare le tue esigenze odierne e ad aiutarti a orientarti verso il futuro.","home_page-wallpaper_content-sub1-title":"Piattaforma pronta per il futuro","home_page-wallpaper_content-sub1-body":"La nostra piattaforma si adatter\xe0 perfettamente alle tue operazioni e soddisfer\xe0 tutte le tue esigenze future, a partire dalla visibilit\xe0 delle previsioni del volume delle spedizioni, delle richieste di modifica della capacit\xe0 ad hoc e dei reclami relativi alle prestazioni in base ai KPI concordati.","home_page-wallpaper_content-sub2-title":"Sicuro e protetto","home_page-wallpaper_content-sub2-body":"Sappiamo che la privacy dei tuoi dati \xe8 importante, ecco perch\xe9 non condividiamo le tue informazioni con esterni. Siamo conformi alla sicurezza di terze parti (TPS).","home_page-wallpaper_content-sub3-title":"Canale bidirezionale trasparente","home_page-wallpaper_content-sub3-body":"Comprendiamo che la trasparenza \xe8 fondamentale per promuovere un ambiente di fiducia e ti consentiamo di fornire feedback su tutti i report e gli approfondimenti forniti. Abbiamo un team che lavora 24 ore su 24, 7 giorni su 7 per garantire che questi feedback vengano presi in considerazione rapidamente.","home_page-why_amazon-title":"QUALI SONO I VANTAGGI DELL\'ADESIONE AD AMAZON CARRIER LOGISTICS?","home_page-why_amazon-benefits-one_stop-title":"UNO SPORTELLO UNICO PER LE TUE ESIGENZE OPERATIVE","home_page-why_amazon-benefits-one_stop-description":"Gestisci l\'intero ciclo di vita delle operazioni tramite un\'unica piattaforma","home_page-why_amazon-benefits-reduced_costs-title":"COSTI RIDOTTI","home_page-why_amazon-benefits-reduced_costs-description":"Pianifica la tua capacit\xe0 e gestisci le eccezioni con approfondimenti basati sui dati per ottimizzare le operazioni","home_page-why_amazon-benefits-performance_vis-title":"VISIBILIT\xc0 DELLE PERFORMANCE","home_page-why_amazon-benefits-performance_vis-description":"Usa i nostri report in tempo reale per analizzare le tue performance e incrementare il tuo business","home_page-faq_section-header":"DOMANDE FREQUENTI","home_page-faq_section-drilldown-q1-title":"Quali funzionalit\xe0 sono attualmente abilitate tramite Amazon Carrier Logistics?","home_page-faq_section-drilldown-q1-ans":"Amazon Carrier Logistics attualmente consente ai corrieri registrati di scaricare e visualizzare le previsioni del numero e del volume dei pacchi e pianificare la propria capacit\xe0 di conseguenza. I corrieri riceveranno inoltre una notifica via e-mail ogni volta che viene generata una nuova previsione. ","home_page-faq_section-drilldown-q2-title":"Quali funzionalit\xe0 sono previste per il lancio su Amazon Carrier Logistics nel 2023?","home_page-faq_section-drilldown-q2-ans":"Amazon Carrier Logistics consentir\xe0 presto ai corrieri di visualizzare le richieste di modifica della capacit\xe0 ad hoc create sulla base di analisi in tempo reale per ciascuna corsia. Amazon Carrier Logistics consentir\xe0 inoltre ai corrieri di analizzare le proprie performance su tutti i KPI, che fanno parte del loro contratto. I corrieri potranno approvare/rifiutare eventuali perdite evidenziate per le loro prestazioni.  ","home_page-faq_section-drilldown-q3-title":"I miei dati sono al sicuro? ","home_page-faq_section-drilldown-q3-ans":"Amazon segue rigide normative sulla protezione dei dati per garantire che i tuoi dati siano al sicuro. Siamo conformi alla sicurezza di terze parti (TPS) e proteggiamo sempre i tuoi dati e la tua privacy. Gestione delle operazioni tramite. Amazon Carrier Logistics non offre ad altri clienti visibilit\xe0 o accesso ai tuoi dati.","home_page-faq_section-drilldown-q4-title":"A chi posso rivolgermi in caso di problemi durante il download del numero dei pacchi/delle previsioni di volume? ","home_page-faq_section-drilldown-q4-ans":"Contatta il tuo account manager Amazon e informalo del problema. Il tuo account manager si occuper\xe0 dei tuoi problemi entro 48 ore lavorative dalla ricezione del problema. ","home_page-faq_section-see_all_faqs_button":"Vedi tutte le domande frequenti","home_page-footer-conditions_of_use_button":"Condizioni d\'uso","home_page-footer-privacy_notice_button":"Informativa sulla privacy","home_page-footer-copyright_text":"\xa9 1996-2022, Amazon.com, Inc. o societ\xe0 affiliate","faq_page-header":"DOMANDE FREQUENTI","faq_page-tabs-all":"Tutto","faq_page-tabs-onboarding":"Onboarding","faq_page-tabs-safetyAndPerformance":"Sicurezza e performance","faq_page-tabs-payments":"Pagamenti","faq_page-onboarding-load_req_que":"Quali sono i requisiti per trasportare carichi per Amazon?","faq_page-onboarding-load_req_ans-line1":"Per entrare a far parte della rete di trasporto di Amazon, devi soddisfare i seguenti requisiti minimi:","faq_page-onboarding-load_req_ans-line1_sub-sub1":"Un numero DOT attivo presso un\u2019autorit\xe0 interstatale e un numero MC valido","faq_page-onboarding-load_req_ans-line1_sub-sub2":"Un tipo di entit\xe0 \u201CCorriere\u201D autorizzata per la propriet\xe0 e il noleggio","faq_page-onboarding-load_req_ans-line1_sub-sub3":"Una valutazione di sicurezza della Federal Motor Carrier Safety Administration (FMCSA) di \u201CSoddisfacente\u201D, \u201CNessuno\u201D o \u201CNon classificato\u201D","faq_page-onboarding-load_req_ans-line1_sub-sub4":"Punteggi delle categorie di analisi del comportamento e miglioramento della sicurezza (BASIC):","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub1":"Guida non sicura al di sotto del 60%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub2":"Conformit\xe0 HOS inferiore al 60%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub3":"Manutenzione del veicolo inferiore al 75%","faq_page-onboarding-amazon_monitor_compliance_que":"In che modo Amazon monitora la conformit\xe0 dei corrieri?","faq_page-onboarding-amazon_monitor_compliance_ans":"Amazon usa una variet\xe0 di strumenti, tra cui i nostri team interni di conformit\xe0 e un servizio di monitoraggio della conformit\xe0 di terze parti, per convalidare e monitorare continuamente la conformit\xe0 dei corrieri.","faq_page-safety_and_performance-service_level_expectations_que":"Quali sono le aspettative relative al livello di servizio?","faq_page-safety_and_performance-service_level_expectations_ans-line1":"Amazon richiede che i corrieri garantiscano il massimo livello di sicurezza e performance, tra cui:","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub1":"Conformit\xe0 ai requisiti di sicurezza, DOT e assicurativi","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub2":"Consegna puntuale per soddisfare la promessa ai nostri clienti.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub3":"Accettazione coerente dell\'offerta.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub4":"Gestisci i carichi usando la tecnologia Carrier Logistics","faq_page-safety_and_performance-track_my_performance_que":"Come posso monitorare le mie performance?","faq_page-safety_and_performance-track_my_performance_ans":"Amazon fornisce una scheda di valutazione trasparente delle performance nel portale Carrier Logistics. Puoi esaminare le tue performance per tutti i tuoi carichi, al fine di migliorare continuamente e avere l\'opportunit\xe0 di far crescere la tua attivit\xe0 con Amazon.","faq_page-safety_and_performance-amazon_prioritize_safety_que":"In che modo Amazon d\xe0 priorit\xe0 alla sicurezza?","faq_page-safety_and_performance-amazon_prioritize_safety_ans":"La sicurezza dei tuoi autisti, dei dipendenti Amazon e del pubblico \xe8 la prima priorit\xe0 di Amazon. Gli standard di sicurezza devono essere rispettati su strada, al volante, in cortile o in una struttura Amazon. Ci aspettiamo che tu segnali immediatamente eventuali azioni o condizioni non sicure alla direzione di Amazon. Non c\'\xe8 niente di pi\xf9 importante della tua sicurezza e di quella degli altri.","faq_page-payments-completed_loads_payments_que":"Quando ricever\xf2 il pagamento per i carichi completati?","faq_page-payments-completed_loads_payments_ans":"Il ciclo di pagamento \xe8 settimanale da domenica a sabato. Tutto ci\xf2 che \xe8 stato completato prima delle 23:59 di sabato verr\xe0 pagato il venerd\xec della settimana successiva.","faq_page-payments-submit_invoice_que":"Come posso inviare una fattura per un carico?","faq_page-payments-submit_invoice_ans":"Carrier Logistics generer\xe0 le fatture automaticamente. Potrai rivedere tutte le fatture e i pagamenti nel portale Carrier Logistics.","faq_page-all_faqs-q1":"Quali funzionalit\xe0 sono attualmente abilitate tramite Amazon Carrier Logistics?","faq_page-all_faqs-a1-legend":"Amazon Carrier Logistics attualmente consente ai corrieri registrati di scaricare e visualizzare le previsioni del numero e del volume dei pacchi e pianificare la propria capacit\xe0 di conseguenza. I corrieri riceveranno inoltre una notifica via e-mail ogni volta che viene generata una nuova previsione. ","faq_page-all_faqs-a1-p1":"Previsioni: i corrieri possono scaricare e visualizzare le previsioni relative al numero o al volume dei pacchi e pianificare la loro capacit\xe0 di conseguenza. I corrieri riceveranno inoltre una notifica via e-mail ogni volta che viene generata una nuova previsione. ","faq_page-all_faqs-a1-p2":"Gestione della capacit\xe0: i corrieri possono esaminare e rispondere alle richieste di capacit\xe0 ad hoc. Carrier Logistics invier\xe0 automaticamente notifiche e promemoria tempestivi per queste richieste.","faq_page-all_faqs-a1-p3":"Gestione delle performance: i corrieri possono scaricare e rivedere i report sulle performance. I corrieri saranno inoltre in grado di analizzare gli errori riscontrati.","faq_page-all_faqs-q2":"Quali funzionalit\xe0 sono previste per il lancio su Amazon Carrier Logistics nel 2023?","faq_page-all_faqs-a2":"Amazon Carrier Logistics consentir\xe0 presto ai corrieri di visualizzare le richieste di modifica della capacit\xe0 ad hoc create sulla base di analisi in tempo reale per ciascuna corsia. Amazon Carrier Logistics consentir\xe0 inoltre ai corrieri di analizzare le proprie performance su tutti i KPI, che fanno parte del loro contratto. I corrieri potranno approvare/rifiutare eventuali perdite evidenziate per le loro prestazioni.","faq_page-all_faqs-q3":"I miei dati sono al sicuro? ","faq_page-all_faqs-a3-p1":"Sappiamo che per te \xe8 importante il modo in cui le tue informazioni vengono utilizzate e condivise, e apprezziamo la fiducia riposta in noi per farlo con attenzione e responsabilit\xe0. Per ulteriori informazioni su come trattiamo le tue informazioni, puoi leggere l\'Informativa sulla privacy di Carrier Logistics {link}","faq_page-all_faqs-a3-link":"qui.","faq_page-all_faqs-a3-p2":"Quando scegli di usare Carrier Logistics, il tuo utilizzo e qualsiasi controversia sulla privacy sono soggetti alla presente Informativa e alla nostra {link}, comprese le limitazioni ai danni, la soluzione delle controversie e la giurisdizione di cui si applica la legge. Se hai dubbi sulla privacy in Amazon, contattaci con una descrizione completa e cercheremo di risolverli.","faq_page-all_faqs-a3-conditions":" Condizioni d\u2019uso","faq_page-all_faqs-q4":"A chi posso rivolgermi se riscontro un problema sul portale? ","faq_page-all_faqs-a4":"Contatta il tuo account manager Amazon e informalo del problema. Il tuo account manager risponder\xe0 entro 48 ore lavorative dalla ricezione della comunicazione. ","faq_page-all_faqs-q5":"Posso concedere l\'accesso ad Amazon Carrier Logistics ad altri dipendenti/appaltatori della mia organizzazione? ","faq_page-all_faqs-a5":"No, solo il personale autorizzato potr\xe0 accedere e utilizzare Amazon Carrier Logistics. Per consentire l\'accesso ad altro personale della tua azienda, contatta il tuo account manager Amazon.","faq_page-all_faqs-q6":"Cosa succede se ho bisogno di richiedere nuove previsioni sul volume/numero dei pacchi? ","faq_page-all_faqs-a6":"Contatta il tuo account manager Amazon e informalo delle tue esigenze.","get_started_page-header":"INIZIA","get_started_page-content":"Grazie per l\u2019interesse. Se hai ricevuto un invito da Amazon a registrarti su Amazon Carrier Logistics, procedi con la creazione di un account Amazon. Se sei un corriere che fornisce servizi logistici ad Amazon, ma non hai ricevuto l\'invito a registrarti, ti contatteremo al pi\xf9 presto. Puoi anche contattare il tuo account manager di Amazon per saperne di pi\xf9 sulla registrazione su Amazon Carrier Logistics.","get_started_page-requirements-header":"REQUISITI","get_started_page-requirements-content-line1":"Un numero DOT attivo presso un\u2019autorit\xe0 interstatale e un numero MC valido","get_started_page-requirements-content-line2":"Un tipo di entit\xe0 \u201CCorriere\u201D autorizzata per la propriet\xe0 e il noleggio","get_started_page-requirements-content-line3":"Una valutazione di sicurezza della Federal Motor Carrier Safety Administration (FMCSA) di \u201CSoddisfacente\u201D, \u201CNessuno\u201D o \u201CNon classificato\u201D","get_started_page-requirements-content-line4":"Tutte le polizze assicurative richieste, tra cui:","get_started_page-requirements-content-line4_sub-sub1":"Responsabilit\xe0 commerciale generale non inferiore a 1.000.000 $ per evento e 2.000.000 $ in totale","get_started_page-requirements-content-line4_sub-sub2":"Responsabilit\xe0 civile auto non inferiore a 1.000.000 $ per evento, inclusa una copertura per la sostituzione del rimorchio pari a 50.000 $","get_started_page-requirements-content-line4_sub-sub3":"Copertura del carico per almeno 100.000 $","get_started_page-requirements-content-line4_sub-sub4":"Assicurazione per il risarcimento dei lavoratori in tutte le giurisdizioni in cui opera la tua azienda","get_started_page-requirements-content-line4_sub-sub5":"Responsabilit\xe0 del datore di lavoro non inferiore a 100.000 $ per evento","get_started_page-sign_up-create_new_account_content":"Crea un nuovo account o accedi per effettuare trasporti con Amazon.","get_started_page-sign_up-create_new_account_button":"Crea un account Amazon","get_started_page-sign_up-sign_in_button":"Accedi","terms_conditions_page-usage_content":"L\'uso di Amazon Carrier Logistics in Francia \xe8 regolato dalle Condizioni d\'uso riportate di seguito. Le Condizioni d\'uso sono fornite in inglese e francese. In caso di conflitto o discrepanza tra la versione tradotta in francese delle presenti Condizioni d\'uso e la versione in lingua inglese, prevale la versione in lingua inglese.","terms_conditions_page-conditions_of_use_heading-us":"CONDIZIONI D\'USO (inglese)","terms_conditions_page-conditions_of_use_heading-fr":"CONDITIONS D\u2019UTILISATION (francese)","terms_conditions_page-conditions_of_use-us-last_updated":"17 novembre 2022","terms_conditions_page-conditions_of_use-us-intro_heading":"Benvenuto in Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-us-intro_content":"Amazon Services LLC. e/o le sue societ\xe0 affiliate (\u201CAmazon\u201D) ti forniscono le funzionalit\xe0 del sito web e altri prodotti e servizi quando visiti carrierlogistics.amazon.com (il \u201Csito web\u201D), usi prodotti o servizi Amazon, usi le applicazioni Amazon per dispositivi mobili o usi software fornito da Amazon in relazione a quanto sopra descritto (collettivamente \u201CServizi Amazon\u201D). Consulta la nostra Informativa sulla privacy e la nostra Informativa sui cookie per capire come raccogliamo e trattiamo le tue informazioni personali tramite i Servizi Amazon. Amazon fornisce i Servizi Amazon in base alle condizioni stabilite in questa pagina. \u201CAmazon Carrier Logistics\u201D \xe8 il nome commerciale di Amazon.","terms_conditions_page-conditions_of_use-us-welcome_content":"Leggi attentamente queste condizioni prima di usare i Servizi Amazon. Usando i Servizi Amazon, indichi la tua accettazione ad essere vincolato dalle presenti condizioni. Offriamo un\'ampia gamma di Servizi Amazon, e a volte potrebbero essere applicati termini aggiuntivi. Quando usi un Servizio Amazon, sarai inoltre soggetto ai termini, alle linee guida e alle condizioni applicabili a tale Servizio Amazon (\u201CTermini di servizio\u201D). Se le presenti Condizioni d\'uso risultano in contrasto con i Termini di Servizio, prevarranno tali Termini di Servizio.","terms_conditions_page-conditions_of_use-fr-last_updated":"Le 17 novembre 2022","terms_conditions_page-conditions_of_use-fr-intro_heading":"Bienvenue sur Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-fr-intro_content":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab Amazon \xbb) vous fournissent des fonctionnalit\xe9s de site web et d\u2019autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab site web \xbb), utilisez les produits, ou services Amazon, utilisez les applications Amazon pour mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\u2019un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab Services Amazon \xbb). Veuillez consulter notre Avis de confidentialit\xe9 et notre Avis sur les cookies pour comprendre comment nous recueillons et traitons vos informations personnelles par le biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab Amazon Carrier Logistics \xbb est le nom commercial d\u2019Amazon.","terms_conditions_page-conditions_of_use-fr-welcome_content":"Veuillez lire attentivement les pr\xe9sentes conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces conditions. Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab Conditions du Service \xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de service, ces derni\xe8res pr\xe9vaudront.","privacy_page-usage_content":"L\'uso di Amazon Carrier Logistics in Francia \xe8 regolato dall\'Informativa sulla privacy riportata di seguito. L\'Informativa sulla privacy \xe8 fornita in inglese e francese. In caso di conflitto o discrepanza tra la versione tradotta in francese e quella in inglese della presente Informativa sulla privacy, prevale la versione in lingua inglese.","privacy_page-heading-us":"Informativa sulla privacy (inglese)","privacy_page-heading-fr":"Informativa sulla privacy (francese)","lp_dropdown-not_found":"Nessuna parte logistica trovata.","no_permissions":"Non possiedi l\u2019autorizzazione per visualizzare questa sezione. Prova a passare a un\u2019altra parte logistica.","carrier_selected":"Corriere ","conditions_of_use-p1":"18 gennaio 2022","conditions_of_use-p2":"Benvenuto in Amazon Carrier Logistics.","conditions_of_use-p3-p1":"Amazon EU Sarl e/o le sue societ\xe0 affiliate (\\"Amazon\\") ti forniscono le funzionalit\xe0 del sito web e altri prodotti e servizi quando visiti carrierlogistics.amazon.com (il \\"Sito web\\"), usi prodotti o servizi Amazon, usi le applicazioni Amazon per dispositivi mobili o usi software fornito da Amazon in relazione a quanto sopra descritto (collettivamente \\"Servizi Amazon\\"). Consulta la nostra","conditions_of_use-p3-l1":"Informativa sulla privacy","conditions_of_use-p3-p2":"e","conditions_of_use-p3-l2":"Informativa sui cookie","conditions_of_use-p3-p3":"per capire come raccogliamo ed elaboriamo le tue informazioni personali tramite i Servizi Amazon. Amazon fornisce i Servizi Amazon sulla base delle condizioni stabilite in questa pagina. \\"Amazon Carrier Logistics\\" \xe8 il nome commerciale di Amazon.","conditions_of_use-p4":"Condizioni d\'uso","conditions_of_use-p5-p1":"Leggi attentamente queste condizioni prima di usare i Servizi Amazon. Usando i Servizi Amazon, indichi la tua accettazione ad essere vincolato dalle presenti condizioni.","conditions_of_use-p5-p2":"Offriamo un\'ampia gamma di Servizi Amazon che, a volte, potrebbero essere soggetti a termini aggiuntivi. Quando usi un Servizio Amazon, sarai inoltre soggetto ai termini, alle linee guida e alle condizioni applicabili a tale Servizio Amazon (\\"Termini del Servizio\\"). Se le presenti Condizioni d\'uso risultano in contrasto con i Termini del Servizio, prevarranno tali Termini del Servizio.","conditions_of_use-p6":"1. COMUNICAZIONI ELETTRONICHE","conditions_of_use-p7":"Quando utilizzi un Amazon Services o ci invii e-mail, comunichi con noi elettronicamente. Comunicheremo con te elettronicamente in vari modi, ad esempio tramite e-mail, SMS, avvisi push in-app o pubblicando messaggi o comunicazioni e-mail sul Sito web o tramite gli altri Servizi Amazon. Ai fini contrattuali, accetti che tutti gli accordi, gli avvisi, le divulgazioni e le altre comunicazioni che forniamo elettronicamente soddisfano qualsiasi requisito legale che tali comunicazioni siano in forma scritta, a meno che le leggi obbligatorie applicabili richiedano specificamente una forma di comunicazione diversa.","conditions_of_use-p8":"2. CONSIGLI E PERSONALIZZAZIONE","conditions_of_use-p9":"All\'interno dei Servizi Amazon, ti consiglieremo funzionalit\xe0, prodotti e servizi, inclusi annunci di terze parti che potrebbero interessarti, identificheremo le tue preferenze e personalizzeremo la tua esperienza.","conditions_of_use-p10":"3. COPYRIGHT, DIRITTI D\'AUTORE E DIRITTI SULLE BANCHE DATI","conditions_of_use-p11":"Tutti i contenuti inclusi o resi disponibili tramite qualsiasi Servizio Amazon, come testo, grafica, loghi, icone dei pulsanti, immagini, clip audio, download digitali e raccolte di dati, sono di propriet\xe0 di Amazon o dei suoi fornitori di contenuti e sono protetti dalle leggi del Lussemburgo e internazionali sul copyright, sui diritti d\'autore e sui diritti dei database. La compilazione di tutti i contenuti inclusi o resi disponibili tramite qualsiasi Servizio Amazon \xe8 di propriet\xe0 esclusiva di Amazon ed \xe8 protetta dalle leggi lussemburghesi e internazionali sul copyright e sui diritti dei database.","conditions_of_use-p12":"Non puoi estrarre e/o riutilizzare parti del contenuto di alcun Servizio Amazon senza il nostro esplicito consenso scritto. In particolare, non puoi utilizzare alcun data mining, robot o strumenti simili di raccolta ed estrazione dei dati per estrarre (in una o pi\xf9 volte) parti sostanziali del contenuto di qualsiasi Servizio Amazon, senza il nostro esplicito consenso scritto. Inoltre, non puoi creare e/o pubblicare un tuo database che includa parti sostanziali di qualsiasi Servizio Amazon (ad es. i nostri prezzi) senza il nostro esplicito consenso scritto.","conditions_of_use-p13":"4. MARCHI COMMERCIALI","conditions_of_use-l1":"Fai clic qui per visualizzare un elenco non esaustivo dei marchi commerciali di Amazon","conditions_of_use-p14":". Inoltre, la grafica, i loghi, le intestazioni delle pagine, le icone dei pulsanti, gli script e i nomi dei servizi inclusi o resi disponibili tramite qualsiasi Servizio Amazon sono marchi o segni distintivi di Amazon. I marchi o le immagini commerciali di Amazon non possono essere utilizzati in connessione con altri prodotti o servizi che non siano di Amazon, in qualsiasi maniera che possa confondere i clienti o apportare discredito o sollevare dubbi su Amazon. Tutti gli altri marchi commerciali non di propriet\xe0 Amazon che compaiono su Servizi Amazon sono di propriet\xe0 dei rispettivi titolari, che possono o meno essere affiliati a, connessi a o sponsorizzati da Amazon.","conditions_of_use-p15":"5. BREVETTI","conditions_of_use-p16":"I Servizi Amazon e le funzionalit\xe0 e i servizi accessibili tramite i Servizi Amazon si basano su uno o pi\xf9 brevetti di propriet\xe0 di Amazon. Parti dei Servizi Amazon operano su licenza di uno o pi\xf9 brevetti.","conditions_of_use-p17":"6. LICENZA E ACCESSO","conditions_of_use-p18":"Fatto salvo il rispetto delle presenti Condizioni d\'uso e di eventuali Termini del Servizio, oltre al pagamento di eventuali commissioni applicabili, Amazon o i suoi fornitori di contenuti concedono all\'utente una licenza limitata, non esclusiva, non trasferibile e non cedibile in sublicenza per accedere a e utilizzare i Servizi Amazon in modo personale e non commerciale. Questa licenza non include nessuna possibilit\xe0 di rivendita o uso commerciale di uno qualsiasi dei Servizi Amazon o dei suoi contenuti, nessuna raccolta e nessun utilizzo delle descrizioni o dei prezzi, nessun uso derivato di uno qualsiasi dei Servizi Amazon o dei suoi contenuti, nessun download, copia delle informazioni dell\'account a beneficio di altri venditori e nessun uso di data mining, robot o strumenti simili per la raccolta e l\'estrazione di dati.","conditions_of_use-p19":"Tutti i diritti non espressamente concessi all\'utente nelle presenti Condizioni d\'uso o nei Termini del servizio sono riservati e mantenuti da Amazon o dai suoi licenziatari, fornitori, editori, titolari dei diritti o altri fornitori di contenuti. I Servizi Amazon o una loro qualsiasi parte di non pu\xf2 essere riprodotto, duplicato, copiato, venduto, rivenduto, visitato o altrimenti sfruttato per qualsiasi scopo commerciale senza l\'espresso consenso scritto di Amazon. Non puoi includere in un frame o utilizzare altre tecniche di framing per racchiudere marchi commerciali, logo o altre informazioni proprietarie (incluse immagini, testo, impaginazione o moduli) di Amazon senza un esplicito consenso scritto. Non puoi utilizzare metatag o altro \\"testo nascosto\\" che utilizzi i nomi o i marchi di Amazon senza il nostro esplicito consenso scritto.","conditions_of_use-p20":"Non \xe8 possibile utilizzare i Servizi Amazon in modo improprio. \xc8 possibile utilizzare i Servizi Amazon solo in conformit\xe0 a quanto consentito dalla legge. Le licenze concesse da Amazon sono da considerarsi annullate qualora non rispetti le presenti Condizioni d\'uso o i Termini del Servizio.","conditions_of_use-p21":"7. IL TUO ACCOUNT","conditions_of_use-p22":"Per utilizzare determinati Servizi Amazon potrebbe essere necessario disporre di un account Amazon personale e potrebbe essere necessario effettuare l\'accesso all\'account. Se utilizzi un Servizio Amazon, sei responsabile del mantenimento della riservatezza del tuo account e della tua password e della limitazione dell\'accesso al tuo computer e, nella misura consentita dalla legge applicabile, accetti di assumerti la responsabilit\xe0 di tutte le attivit\xe0 svolte con il tuo account o la tua password. Dovresti adottare tutte le misure necessarie per garantire che la password sia mantenuta riservata e sicura e dovresti informarci immediatamente se hai motivo di credere che la tua password sia nota a qualcun altro, o se la password \xe8 o \xe8 probabile che venga utilizzata in modo non autorizzato. Sei responsabile di garantire che i dati che ci fornisci siano corretti e completi e di informarci di eventuali modifiche alle informazioni che ci hai fornito. Puoi accedere alle tue informazioni nella sezione Il mio account del Sito web.","conditions_of_use-p23":"Non devi utilizzare alcun Servizio Amazon: (i) in alcun modo che causi o possa causare l\'interruzione, il danneggiamento o la compromissione di qualsiasi Servizio Amazon o dell\'accesso ad esso, o (ii) per scopi fraudolenti, o in relazione a un reato o altra attivit\xe0 illegale, o (iii) per causare fastidio, disagio o ansia.","conditions_of_use-p24":"Ci riserviamo il diritto di rifiutare qualsiasi Servizio Amazon o chiudere gli account se il tuo comportamento fornisce un motivo giustificato per farlo. Ci\xf2 si verificher\xe0 in particolare in caso di violazione delle leggi applicabili, delle disposizioni contrattuali applicabili, delle nostre linee guida o delle nostre politiche, tutte accessibili sul Sito web. Nonostante tali limitazioni o cessazioni, continuerai ad avere accesso ai contenuti e ai servizi da te acquistati fino a quel momento.","conditions_of_use-p25":"8. RECENSIONI, COMMENTI, COMUNICAZIONI E ALTRI CONTENUTI","conditions_of_use-p26-p1":"Laddove esista la funzionalit\xe0 necessaria, se i visitatori pubblicano recensioni, commenti e altri contenuti, inviano altre comunicazioni e inviano suggerimenti, idee, commenti, domande o altre informazioni, i contenuti non devono essere illegali, osceni, offensivi, minacciosi, diffamatori, invasivi della privacy, in violazione dei diritti di propriet\xe0 intellettuale o altrimenti dannosi per terzi o discutibili e non devono contenere virus software, campagne politiche, commerciali sollecitazioni, lettere a catena, invii di massa o qualsiasi forma di \\"spam\\". Non \xe8 consentito utilizzare un indirizzo e-mail falso, impersonare un individuo o un\'entit\xe0 o altrimenti fuorviare il ricevente sull\'origine di una scheda o di qualsiasi altro contenuto. Ci riserviamo il diritto (ma non in assenza di un valido","conditions_of_use-p26-p2":", l\'obbligo) di rimuovere o modificare tali contenuti. Se ritieni che qualsiasi contenuto in vendita o pubblicizzato su qualsiasi Servizio Amazon contenga una dichiarazione diffamatoria o che i tuoi diritti di propriet\xe0 intellettuale siano stati violati da un articolo o da informazioni su qualsiasi Servizio Amazon, comunicacelo compilando e inviando l\'apposito modulo","conditions_of_use-p26-p3":"e risponderemo.","conditions_of_use-l2":"Modulo di segnalazione di violazione","conditions_of_use-p27":"Se pubblichi recensioni, commenti, domande o risposte dei clienti o altri contenuti da te generati per la visualizzazione sul Sito web (comprese immagini, video o audio, tutti insieme i \\"contenuti\\"), concedi ad Amazon (a) una licenza non esclusiva e gratuita per utilizzare, riprodurre, pubblicare, rendere disponibili, tradurre e modificare tali contenuti in tutto il mondo (incluso il diritto di concedere in sublicenza questi diritti a terzi) e (b) il diritto di utilizzare il nome che invii in relazione a tali contenuti. Nessun diritto morale viene trasferito da questa disposizione.","conditions_of_use-p28":"Puoi eliminare i tuoi contenuti dalla visualizzazione pubblica o, laddove tale funzionalit\xe0 sia offerta, modificare le impostazioni in modo che vengano mostrati solo alle persone a cui concedi l\'accesso.","conditions_of_use-p29-p1":"Dichiari e garantisci di possedere o controllare in altro modo tutti i diritti sui contenuti che pubblichi e che, alla data di pubblicazione del contenuto o del materiale: (i) il contenuto e il materiale sono accurati e (ii) l\'uso del contenuto e del materiale fornito non viola alcuna politica o linea guida applicabile e non causer\xe0 danni a persone o entit\xe0 (incluso il fatto che il contenuto o il materiale non sia diffamatorio). Accetti di risarcire Amazon per tutti i reclami presentati da terzi contro Amazon derivanti da o in relazione ai contenuti e al materiale che fornisci, tranne nella misura in cui qualsiasi responsabilit\xe0 derivi dalla nostra mancata rimozione corretta del contenuto quando viene informata della natura illegale del contenuto","conditions_of_use-p29-p2":"derivanti da, sulla base di o provenienti dai contenuti che ci hai comunicato. Eliminando i contenuti dalla visualizzazione pubblica, si revoca la licenza che consente ad Amazon di pubblicare e rendere disponibili tali contenuti al pubblico.","conditions_of_use-p30":"9. RIVENDICAZIONI DELLA PROPRIET\xc0 INTELLETTUALE","conditions_of_use-p31":"Amazon rispetta i diritti di propriet\xe0 intellettuale altrui. Se ritieni che i tuoi diritti di propriet\xe0 intellettuale siano stati utilizzati in modo da dare adito a timori di violazione, segui il nostro","conditions_of_use-p32":"10. TERMINI DEL SOFTWARE AMAZON","conditions_of_use-p33":"Oltre alle presenti Condizioni d\'uso, i seguenti Termini del software si applicano a qualsiasi software (inclusi eventuali aggiornamenti o upgrade del software e qualsiasi documentazione correlata) che mettiamo a tua disposizione di volta in volta per l\'utilizzo in relazione ai Servizi Amazon (il \\"Software Amazon\\"):","conditions_of_use-p34-p1":"Utilizzo del Software Amazon.","conditions_of_use-p34-p2":"Puoi utilizzare il Software Amazon esclusivamente allo scopo di consentirti di utilizzare e usufruire dei Servizi Amazon forniti da Amazon e come consentito dalle presenti Condizioni d\'uso, dai presenti Termini del software e da eventuali Termini del servizio. Non puoi incorporare alcuna parte del Software Amazon nei tuoi programmi o compilare alcuna parte di esso in combinazione con i tuoi programmi, trasferirlo per utilizzarlo con un altro servizio o vendere, noleggiare, prestare, prestare, distribuire o concedere in sublicenza il Software Amazon o assegnare in altro modo alcun diritto al Software Amazon del tutto o in parte. Non puoi utilizzare il software Amazon per scopi illegali. Possiamo cessare di fornire qualsiasi Software Amazon e possiamo revocare il tuo diritto di utilizzare qualsiasi Software Amazon in qualsiasi momento. I tuoi diritti di utilizzo del Software Amazon cesseranno automaticamente senza preavviso da parte nostra in caso di mancato rispetto di uno qualsiasi dei presenti Termini del software, delle Condizioni d\'uso o di qualsiasi altro termine del servizio. Ulteriori termini di terze parti contenuti o distribuiti con determinati Software Amazon che sono specificamente identificati nella relativa documentazione possono applicarsi a tale Software Amazon (o al software incorporato nel Software Amazon) e regoleranno l\'uso di tale software in caso di conflitto con le presenti Condizioni d\'uso. Tutto il software utilizzato in qualsiasi Servizio Amazon \xe8 di propriet\xe0 di Amazon o dei suoi fornitori di software e protetto dalle leggi del Lussemburgo e internazionali sul copyright.","conditions_of_use-p34-p3":"Uso dei servizi di terzi.","conditions_of_use-p34-p4":"Quando utilizzi il Software Amazon, potresti anche utilizzare i servizi di una o pi\xf9 terze parti, come un operatore wireless o un fornitore di piattaforme per dispositivi mobili. L\'utilizzo da parte tua di questi servizi di terze parti pu\xf2 essere soggetto a informative, termini di utilizzo e tariffe separate di tali terze parti.","conditions_of_use-p34-p5":"Divieto di reverse engineering.","conditions_of_use-p34-p6":"Salvo quanto esplicitamente consentito dalla legge imperativa applicabile, non puoi incoraggiare, assistere o autorizzare nessun\'altra persona a copiare, modificare, decodificare, decompilare o disassemblare o manomettere in altro modo il Software Amazon, in tutto o in parte, o creare opere derivate da o del Software Amazon.","conditions_of_use-p34-p7":"Aggiornamenti.","conditions_of_use-p34-p8":"Per mantenere aggiornato il software Amazon, possiamo offrire aggiornamenti automatici o manuali in qualsiasi momento e senza preavviso.","conditions_of_use-p35":"11. LA NOSTRA RESPONSABILIT\xc0","conditions_of_use-p36":"Faremo del nostro meglio per garantire che la disponibilit\xe0 dei Servizi Amazon sia ininterrotta e che le trasmissioni siano prive di errori. Tuttavia, a causa della natura di Internet, ci\xf2 non pu\xf2 essere garantito. Inoltre, l\'accesso ai Servizi Amazon pu\xf2 essere occasionalmente sospeso o limitato per consentire riparazioni, manutenzione o l\'introduzione di nuove strutture o servizi. Cercheremo di limitare la frequenza e la durata di tali sospensioni o restrizioni.","conditions_of_use-p37":"Amazon non sar\xe0 responsabile per (i) perdite che non siano state causate da alcuna violazione da parte nostra o (ii) qualsiasi perdita aziendale (inclusa perdita di profitti, ricavi, contratti, risparmi previsti, dati, avviamento o spese sprecate) o (iii) perdite indirette o consequenziali che non erano prevedibili sia per te che per noi quando hai iniziato a utilizzare i Servizi Amazon.","conditions_of_use-p38":"Amazon non \xe8 da ritenersi responsabile per qualsiasi ritardo o per il mancato rispetto degli obblighi previsti in questi termini se il ritardo o il mancato rispetto dei termini si verifica per cause che vanno oltre il ragionevole controllo di Amazon.","conditions_of_use-p39":"Le leggi di alcuni paesi non consentono alcune o tutte le limitazioni sopra descritte. Se queste leggi sono applicabili, alcune o tutte le limitazioni di cui sopra potrebbero non essere applicabili a te e potresti godere di diritti aggiuntivi.","conditions_of_use-p40":"Nulla in queste condizioni limita o esclude la nostra responsabilit\xe0 per le dichiarazioni fraudolente da noi presentate o per morte o lesioni personali causate da nostra negligenza o cattiva condotta dolosa.","conditions_of_use-p41":"12. ESCLUSIONE DI GARANZIA E LIMITAZIONE DI RESPONSABILIT\xc0","conditions_of_use-p42":"I SERVIZI AMAZON E TUTTE LE INFORMAZIONI, I CONTENUTI, I MATERIALI, I PRODOTTI (INCLUSO IL SOFTWARE) E GLI ALTRI SERVIZI INCLUSI O ALTRIMENTI RESI DISPONIBILI TRAMITE I SERVIZI AMAZON SONO FORNITI DA AMAZON \\"NELLO STATO IN CUI SI TROVANO\\" E \\"COME DISPONIBILI\\", SALVO DIVERSAMENTE SPECIFICATO IN FORMA SCRITTA. AMAZON NON RILASCIA DICHIARAZIONI O GARANZIE DI ALCUN TIPO, ESPLICITE O IMPLICITE, SUL FUNZIONAMENTO DEI SERVIZI AMAZON O SU INFORMAZIONI, CONTENUTI, MATERIALI, PRODOTTI (INCLUSO IL SOFTWARE) O ALTRI SERVIZI INCLUSI O ALTRIMENTI RESI DISPONIBILI TRAMITE I SERVIZI AMAZON, SALVO DIVERSA INDICAZIONE NEL CONTRATTO. L\'UTENTE ACCETTA ESPRESSAMENTE CHE L\'UTILIZZO DEI SERVIZI AMAZON SIA A SUO ESCLUSIVO RISCHIO. NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, AMAZON DECLINA TUTTE LE GARANZIE ESPRESSE O IMPLICITE, INCLUSE, A TITOLO ESEMPLIFICATIVO MA NON ESAUSTIVO, LE GARANZIE IMPLICITE DI COMMERCIABILIT\xc0 E IDONEIT\xc0 PER UNO SCOPO PARTICOLARE. AMAZON NON GARANTISCE CHE I SERVIZI AMAZON, LE INFORMAZIONI, I CONTENUTI, I MATERIALI, I PRODOTTI (INCLUSO IL SOFTWARE) O ALTRI SERVIZI INCLUSI O RESI DISPONIBILI TRAMITE I SERVIZI AMAZON, I SERVER DI AMAZON O LE COMUNICAZIONI ELETTRONICHE INVIATE DA AMAZON SIANO PRIVI DI VIRUS O DI ALTRI COMPONENTI DANNOSI. NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, AMAZON NON SAR\xc0 RESPONSABILE PER EVENTUALI DANNI DI QUALSIASI TIPO DERIVANTI DALL\'USO DI UNO QUALSIASI DEI SERVIZI AMAZON O DA QUALSIASI INFORMAZIONE, CONTENUTO, MATERIALE, PRODOTTO (INCLUSO IL SOFTWARE) O ALTRI SERVIZI INCLUSI O RESI DISPONIBILI TRAMITE UNO QUALSIASI DEI SERVIZI AMAZON INCLUSI, A TITOLO ESEMPLIFICATIVO, DANNI DIRETTI, INDIRETTI, INCIDENTALI, PUNITIVI E CONSEQUENZIALI, SALVO DIVERSAMENTE SPECIFICATO IN FORMA SCRITTA.","conditions_of_use-p43":"13. LEGGE APPLICABILE","conditions_of_use-p44":"Se ti trovi in uno stato membro dell\'UE, queste condizioni sono regolate e interpretate in conformit\xe0 con le leggi del Granducato di Lussemburgo e l\'applicazione della Convenzione delle Nazioni Unite sui contratti per la vendita internazionale di merci \xe8 espressamente esclusa. Entrambi accettiamo di sottometterci alla giurisdizione esclusiva dei tribunali della citt\xe0 di Lussemburgo.","conditions_of_use-p45":"Se ti trovi nel Regno Unito, accetti che le leggi di Inghilterra e Galles, indipendentemente dai principi di conflitto di leggi, regoleranno le presenti Condizioni d\'uso e qualsiasi controversia di qualsiasi tipo che potrebbe insorgere tra te e Amazon. L\'applicazione della Convenzione delle Nazioni Unite sui contratti di vendita internazionale di merci \xe8 espressamente esclusa. L\'utente si sottopone irrevocabilmente alla giurisdizione esclusiva dei tribunali d\'Inghilterra. Qualsiasi contestazione o reclamo relativo in qualsiasi modo all\'utilizzo del Sito web sar\xe0 risolta in un tribunale competente in Inghilterra. L\'utente rinuncia a tutte le obiezioni alla giurisdizione e alla sede di tali tribunali.","conditions_of_use-p46-p1":"Se desideri portare una questione alla nostra attenzione,\xa0","conditions_of_use-p46-l1":"contattaci","conditions_of_use-p47":"14. MODIFICHE AL SERVIZIO O MODIFICHE ALLE CONDIZIONI D\'USO","conditions_of_use-p48":"Ci riserviamo il diritto di apportare modifiche a qualsiasi servizio, politica, termine e condizione Amazon, comprese le presenti Condizioni d\'uso e i Termini del servizio, in qualsiasi momento. Sarai soggetto ai termini e alle condizioni, alle politiche e alle condizioni d\'uso in vigore al momento dell\'utilizzo dei Servizi Amazon. Qualora qualsiasi Condizione d\'uso sia da ritenersi non valida, nulla o per qualsiasi motivo non applicabile, tale condizione sar\xe0 da ritenersi separata e non influir\xe0 sulla validit\xe0 e l\'applicabilit\xe0 delle altre condizioni.","conditions_of_use-p49":"15. RINUNCIA","conditions_of_use-p50":"Qualora non intraprendessimo alcuna azione in caso di violazione delle presenti Condizioni d\'uso da parte dell\'utente, avremo comunque il diritto di utilizzare i nostri diritti e rimedi in qualsiasi altra situazione in cui l\'utente violi le presenti Condizioni d\'uso.","conditions_of_use-p51":"16. I NOSTRI DATI DI CONTATTO","conditions_of_use-p52":"Questo Sito web \xe8 di propriet\xe0 e gestito da Amazon EU Sarl:","conditions_of_use-p53":"17. AVVISO E PROCEDURA PER PRESENTARE RECLAMI RELATIVI A VIOLAZIONI DEI DIRITTI","conditions_of_use-p54-p1":"Se ritieni che i tuoi diritti di propriet\xe0 intellettuale siano stati violati, invia il tuo reclamo utilizzando il nostro sito online\xa0","conditions_of_use-p54-p2":". Questo modulo pu\xf2 essere utilizzato per segnalare tutti i tipi di reclami sulla propriet\xe0 intellettuale, incluse, a titolo esemplificativo, rivendicazioni relative a copyright, marchi, design e brevetti","conditions_of_use-p55":"Al ricevimento di un reclamo, possiamo intraprendere determinate azioni, tra cui la rimozione di informazioni o di un elemento e la cessazione dei trasgressori recidivi in circostanze appropriate. Tutte queste azioni vengono intraprese senza alcuna ammissione di responsabilit\xe0 e senza pregiudizio per i diritti, i rimedi o le difese, tutti espressamente riservati. Ci\xf2 include l\'inoltro del reclamo alle parti coinvolte nella fornitura del contenuto in presunta violazione. L\'utente accetta di risarcire Amazon per tutti i reclami presentati da terzi contro Amazon derivanti da o in relazione alla presentazione di un reclamo.","conditions_of_use-p56-p1":"Avviso importante:","conditions_of_use-p56-p2":"fornire ad Amazon informazioni false, fuorvianti o imprecise nel Modulo di notifica pu\xf2 comportare responsabilit\xe0 civili e/o penali. In caso di domande, \xe8 necessario contattare un consulente legale.","privacy_notice-p1":"Conoscendo il valore dei dati personali dei propri clienti, Carrier Logistics garantisce un trattamento riservato e confidenziale.","privacy_notice-p2":"Qualsiasi informazione personale fornita a o raccolta da Carrier Logistics \xe8 controllata da Amazon EU Sarl, il titolare del trattamento, di ","privacy_notice-p4":"Riceviamo, utilizziamo e archiviamo tutte le informazioni fornite a Carrier Logistics attraverso l\'utilizzo di questo sito. Adottiamo misure di protezione fisiche, elettroniche e procedurali per la raccolta, la memorizzazione e la diffusione delle informazioni personali.","privacy_notice-p5":"Utilizziamo le informazioni dell\'utente per l\'elaborazione delle sue richieste e per le comunicazioni. Condividiamo le informazioni dell\'utente solo come descritto nella presente Informativa sulla privacy e con Amazon (che \xe8 soggetta a questa stessa Informativa sulla privacy o adotta misure che garantiscono una protezione di livello almeno pari a quello descritto nella presente Informativa sulla privacy). Potremmo, inoltre, rilasciare informazioni qualora lo ritenessimo opportuno per rispettare la legge, applicare o far rispettare i nostri Termini e Condizioni d\'uso, proteggere i diritti, la propriet\xe0 o la sicurezza di Carrier Logistics, dei nostri utenti o di terze parti o condurre controlli sui precedenti con societ\xe0 terze che non fanno parte di Amazon. Ci\xf2 include lo scambio di informazioni con altre societ\xe0 e organizzazioni per la protezione dalle frodi e la riduzione del rischio di credito. Ci\xf2 non include tuttavia la vendita, il noleggio, la condivisione o la divulgazione delle informazioni per scopi commerciali o di marketing.","privacy_notice-p6":"Carrier Logistics rispetta le leggi applicabili che implementano la cosiddetta \\"Direttiva UE sui cookie\\". Utilizzando questo sito attraverso un browser con le impostazioni dei cookie attive, acconsenti al nostro utilizzo dei cookie, il quale \xe8 limitato a quelli che riteniamo strettamente necessari. Attraverso la funzione \\"Aiuto\\" sulla maggior parte dei browser l\'utente potr\xe0 evitare che questo accetti nuovi cookie, venire avvisato quando ne riceve di nuovi o disabilitarli completamente.","privacy_notice-p7":"La nostra attivit\xe0 cambia costantemente e anche la nostra Informativa sulla privacy e le Condizioni d\'uso possono cambiare. Controlla frequentemente il sito per scoprire eventuali modifiche recenti.","privacy_notice-p8":"Per domande sulla presente Informativa sulla privacy, contatta l\'azienda all\'indirizzo specificato sopra.","sidebar_labels-forecast":"Previsione","sidebar_labels-rubiks":"Correzione errore pacco","sidebar_labels-adhoc_capacity":"Capacit\xe0 ad hoc","sidebar_labels-performance":"Performance","sidebar_labels-case_management":"Dashboard casi","sidebar_labels-npc":"NPC","sidebar_labels-performance_insights":"Approfondimenti","sidebar_labels-performance_dashboard":"Dashboard","support":"Supporto","unauthorized-title":"Nessuna autorizzazione: ","unauthorized-message":"Grazie per aver accettato l\u2019invito a entrare a far parte di Carrier Logistics. Per iniziare, contatta l\u2019amministratore del tuo corriere per richiedere le autorizzazioni di accesso necessarie.","feedback-description":"Grazie per aver dedicato del tempo a compilare questi commenti. Questo non richieder\xe0 pi\xf9 di 1 minuto del tuo prezioso tempo.","feedback-confirmation_message":"Grazie! Apprezziamo i tuoi commenti."}}');

},{}],"dog57":[function(require,module,exports) {
module.exports = JSON.parse('{"resources":{"dev_app-title":"Interfaz de usuario de Carrier Logistics","lp-header_name":"Nombre del proveedor log\xedstico","lp-header_country":"Pa\xeds de registro","lp-view_owner":"Ver propietario/administrador","lp-request_permissions":"Solicitar permisos","lp-admins_lp":"Administradores de este LP:","lp-request_permissions_for_lp":"Ponte en contacto con el administrador para solicitar permisos","lp-no_admins":"No hay administradores disponibles para este LP","managePermissions-ok_button":"Vale","permissions-permissions":"Permisos","error_page-heading":"Se ha producido un error.","error_page-content":"Aseg\xfarate de estar conectado a una VPN o de tener una conexi\xf3n a Internet activa.","top_bar-frequently_asked_questions_button":"Preguntas frecuentes","top_bar-get_started_button":"Comenzar","top_bar-sign_in_button":"Iniciar sesi\xf3n","top_bar-settings_menu-my_profile":"Mi perfil","top_bar-settings_menu-accounts":"Cuentas","top_bar-settings_menu-manage_users":"Administrar usuarios","top_bar-settings_menu-sign_out":"Cerrar sesi\xf3n","top_bar-select_lp":"Seleccionar una cuenta","top_bar-loading_lps":"Cargando cuentas...","top_bar-language_toggle_supported":"Esta p\xe1gina solo admite el ingl\xe9s. Esta p\xe1gina admitir\xe1 otros idiomas pr\xf3ximamente.","home_page-sidebar_label":"Inicio","home_page-wallpaper_content_block-heading":"Administra tus operaciones en Amazon de forma inteligente","home_page-wallpaper_content_block-content":"Los transportistas ya pueden ver sus previsiones de capacidad, planificar la capacidad sobre la marcha y analizar el rendimiento mediante informes automatizados que reciben directamente.","home_page-wallpaper_content_block-get_started_button":"Comenzar","home_page-wallpaper_content-heading":"Mejora la gesti\xf3n de tus operaciones","home_page-wallpaper_content-body":"Combinamos tecnolog\xeda avanzada con m\xe1s de 20 a\xf1os de experiencia para ayudarte a mejorar tus actividades profesionales de manera sencilla y fiable. Con el apoyo de Amazon, contar\xe1s con un socio que satisfar\xe1 tus necesidades actuales y te ayudar\xe1 a avanzar en el futuro.","home_page-wallpaper_content-sub1-title":"Plataforma preparada para el futuro","home_page-wallpaper_content-sub1-body":"A medida que tus actividades vayan incrementando, nuestra plataforma se adaptar\xe1 a tu volumen y abordar\xe1 todas tus necesidades futuras sin dificultad, empezando por ofrecer informaci\xf3n sobre las previsiones del volumen, las solicitudes de modificaci\xf3n de capacidad y las reclamaciones relacionadas con los indicadores de rendimiento acordados (KPI).","home_page-wallpaper_content-sub2-title":"Seguridad y protecci\xf3n","home_page-wallpaper_content-sub2-body":"Sabemos que la privacidad de tus datos es importante y por ello no compartimos tu informaci\xf3n con ninguna otra entidad log\xedstica. Cumplimos con las normas de seguridad de terceros (TPS).","home_page-wallpaper_content-sub3-title":"Canal de transparencia bidireccional","home_page-wallpaper_content-sub3-body":"Somos conscientes de que la transparencia es la clave para fomentar un entorno de confianza, as\xed que te damos la oportunidad de darnos tu opini\xf3n sobre todos los informes y la informaci\xf3n que te ofrecemos. Contamos con un equipo que trabaja las 24 horas del d\xeda, los 7 d\xedas de la semana para garantizar que se act\xfae en consecuencia con respecto a estos comentarios.","home_page-why_amazon-title":"\xbfCU\xc1LES SON LAS VENTAJAS DE UNIRSE A AMAZON CARRIER LOGISTICS?","home_page-why_amazon-benefits-one_stop-title":"VENTANILLA \xdaNICA PARA TUS NECESIDADES OPERATIVAS","home_page-why_amazon-benefits-one_stop-description":"Gestiona todo el ciclo de vida de las operaciones mediante una sola plataforma","home_page-why_amazon-benefits-reduced_costs-title":"COSTES REDUCIDOS","home_page-why_amazon-benefits-reduced_costs-description":"Planifica tu capacidad y gestiona las excepciones con informaci\xf3n basada en datos para optimizar las operaciones","home_page-why_amazon-benefits-performance_vis-title":"VISIBILIDAD DE RENDIMIENTO","home_page-why_amazon-benefits-performance_vis-description":"Utiliza nuestros informes en tiempo real para analizar tu rendimiento e impulsar tu negocio","home_page-faq_section-header":"PREGUNTAS FRECUENTES","home_page-faq_section-drilldown-q1-title":"\xbfQu\xe9 competencias tiene Amazon Carrier Logistics actualmente?","home_page-faq_section-drilldown-q1-ans":"Actualmente, Amazon Carrier Logistics permite a los transportistas registrados descargar y ver las previsiones sobre el volumen o recuento de paquetes y planificar su capacidad en consecuencia. Los transportistas tambi\xe9n recibir\xe1n una notificaci\xf3n por correo electr\xf3nico cada vez que se genere una nueva previsi\xf3n. ","home_page-faq_section-drilldown-q2-title":"\xbfQu\xe9 capacidades se prev\xe9 lanzar en Amazon Carrier Logistics para 2023?","home_page-faq_section-drilldown-q2-ans":"Amazon Carrier Logistics pronto permitir\xe1 a los transportistas ver las solicitudes de cambio de capacidad sobre la marcha generadas en funci\xf3n del an\xe1lisis en tiempo real de cada carril. Amazon Carrier Logistics tambi\xe9n permitir\xe1 a los transportistas analizar su rendimiento en relaci\xf3n con todos los KPI que forman parte de su contrato. Los transportistas podr\xe1n aprobar o rechazar cualquier error destacado en relaci\xf3n con su rendimiento.  ","home_page-faq_section-drilldown-q3-title":"\xbfEst\xe1n mis datos debidamente protegidos? ","home_page-faq_section-drilldown-q3-ans":"Amazon sigue estrictas normas de protecci\xf3n de datos para garantizar la seguridad de tus datos. Cumplimos con las normas de seguridad de terceros (TPS) y siempre protegemos tus datos y tu privacidad. Gestionar las operaciones mediante Amazon Carrier Logistics no proporcionar\xe1 a ning\xfan otro cliente visibilidad ni acceso a tus datos.","home_page-faq_section-drilldown-q4-title":"\xbfCon qui\xe9n puedo ponerme en contacto si tengo alg\xfan problema al descargar las previsiones sobre el volumen o recuento de paquetes? ","home_page-faq_section-drilldown-q4-ans":"Ponte en contacto con tu administrador de cuenta de Amazon e inf\xf3rmale del problema. El administrador de la cuenta tratar\xe1 tus problemas en un plazo de 48\xa0horas h\xe1biles tras recibirlos. ","home_page-faq_section-see_all_faqs_button":"Ver todas las preguntas frecuentes","home_page-footer-conditions_of_use_button":"Condiciones de uso","home_page-footer-privacy_notice_button":"Aviso de privacidad","home_page-footer-copyright_text":"\xa9 1996-2022, Amazon.com, Inc. o sus filiales","faq_page-header":"PREGUNTAS FRECUENTES","faq_page-tabs-all":"Todo","faq_page-tabs-onboarding":"Incorporaci\xf3n","faq_page-tabs-safetyAndPerformance":"Seguridad y rendimiento","faq_page-tabs-payments":"Pagos","faq_page-onboarding-load_req_que":"\xbfCu\xe1les son los requisitos para transportar cargas en Amazon?","faq_page-onboarding-load_req_ans-line1":"Para unirte a la red de transporte de Amazon, debes cumplir los siguientes requisitos m\xednimos:","faq_page-onboarding-load_req_ans-line1_sub-sub1":"Un n\xfamero DOT activo con autoridad interestatal y un n\xfamero MC v\xe1lido","faq_page-onboarding-load_req_ans-line1_sub-sub2":"Un tipo de entidad \u201Ctransportista\u201D autorizada para la propiedad y el alquiler","faq_page-onboarding-load_req_ans-line1_sub-sub3":"Una calificaci\xf3n de seguridad de la Administraci\xf3n Federal de Seguridad de Autotransportes (FMCSA) de \u201CSatisfactorio\u201D, \u201CNinguno\u201D o \u201CNo calificado\u201D","faq_page-onboarding-load_req_ans-line1_sub-sub4":"Puntuaciones de las Categor\xedas de An\xe1lisis del Comportamiento y Mejora de la Seguridad (BASIC):","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub1":"Conducci\xf3n no segura por debajo del 60\xa0%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub2":"Cumplimiento de las horas de servicio (HOS) por debajo del 60\xa0%","faq_page-onboarding-load_req_ans-line1_sub-sub4_sub-sub3":"Mantenimiento del veh\xedculo por debajo del 75\xa0%","faq_page-onboarding-amazon_monitor_compliance_que":"\xbfC\xf3mo supervisa Amazon el cumplimiento del transportista?","faq_page-onboarding-amazon_monitor_compliance_ans":"Amazon emplea diversas herramientas (incluidos nuestros equipos de cumplimiento internos y un servicio externo de supervisi\xf3n de cumplimiento) para validar y supervisar continuamente el cumplimiento de los transportistas.","faq_page-safety_and_performance-service_level_expectations_que":"\xbfQu\xe9 expectativas hay con respecto al nivel de servicio?","faq_page-safety_and_performance-service_level_expectations_ans-line1":"Amazon exige que los transportistas garanticen el m\xe1ximo gradol de seguridad y rendimiento. Esto incluye:","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub1":"Cumplimiento de los requisitos de seguridad, DOT y seguro","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub2":"Entrega puntual para cumplir nuestra promesa al cliente.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub3":"Aceptaci\xf3n coherente de ofertas.","faq_page-safety_and_performance-service_level_expectations_ans-line1_sub-sub4":"Ejecutar cargas con la tecnolog\xeda de Carrier Logistics","faq_page-safety_and_performance-track_my_performance_que":"\xbfC\xf3mo puedo hacer un seguimiento de mi desempe\xf1o?","faq_page-safety_and_performance-track_my_performance_ans":"Amazon proporciona un cuadro de puntuaci\xf3n de rendimiento transparente en el portal de Carrier Logistics. Puedes consultar el rendimiento de todas tus cargas para mejorar continuamente y tener la oportunidad de hacer crecer tu negocio con Amazon.","faq_page-safety_and_performance-amazon_prioritize_safety_que":"\xbfC\xf3mo prioriza Amazon la seguridad?","faq_page-safety_and_performance-amazon_prioritize_safety_ans":"La seguridad de los conductores, los empleados de Amazon y el p\xfablico es la mayor prioridad de Amazon. Se deben seguir las normas de seguridad en la carretera, al volante, en el almac\xe9n y en las instalaciones y centros de Amazon. Esperamos que informes inmediatamente a la direcci\xf3n de Amazon sobre cualquier acto o condici\xf3n que no sean seguros. No hay nada m\xe1s importante que tu seguridad y la de los dem\xe1s.","faq_page-payments-completed_loads_payments_que":"\xbfCu\xe1ndo se me pagar\xe1 por las cargas terminadas?","faq_page-payments-completed_loads_payments_ans":"El ciclo de pagos se realiza semanalmente de domingo a s\xe1bado. Todas las operaciones que se efect\xfaen antes de las 23:59 del s\xe1bado se pagar\xe1n el viernes de la semana siguiente.","faq_page-payments-submit_invoice_que":"\xbfC\xf3mo presento una factura para una carga?","faq_page-payments-submit_invoice_ans":"Carrier Logistics generar\xe1 las facturas autom\xe1ticamente. Podr\xe1s consultar todas las facturas y pagos en el portal de Carrier Logistics.","faq_page-all_faqs-q1":"\xbfQu\xe9 competencias tiene Amazon Carrier Logistics actualmente?","faq_page-all_faqs-a1-legend":"Actualmente, Amazon Carrier Logistics permite a los transportistas registrados descargar y ver las previsiones sobre el volumen o recuento de paquetes y planificar su capacidad en consecuencia. Los transportistas tambi\xe9n recibir\xe1n una notificaci\xf3n por correo electr\xf3nico cada vez que se genere una nueva previsi\xf3n. ","faq_page-all_faqs-a1-p1":"Previsi\xf3n: los transportistas pueden descargar y ver las previsiones sobre el volumen o recuento de paquetes y planificar su capacidad en consecuencia. Los transportistas tambi\xe9n recibir\xe1n una notificaci\xf3n por correo electr\xf3nico cada vez que se genere una nueva previsi\xf3n. ","faq_page-all_faqs-a1-p2":"Administraci\xf3n de la capacidad: los transportistas pueden revisar y responder a las solicitudes de capacidad sobre la marcha. Carrier Logistics enviar\xe1 autom\xe1ticamente notificaciones y recordatorios puntuales para estas solicitudes.","faq_page-all_faqs-a1-p3":"Administraci\xf3n del rendimiento: los transportistas pueden descargar y revisar los informes de rendimiento. Los transportistas tambi\xe9n podr\xe1n consultar las denuncias de incidencias. ","faq_page-all_faqs-q2":"\xbfQu\xe9 capacidades se prev\xe9 lanzar en Amazon Carrier Logistics para 2023?","faq_page-all_faqs-a2":"Amazon Carrier Logistics pronto permitir\xe1 a los transportistas ver las solicitudes de cambio de capacidad sobre la marcha generadas en funci\xf3n del an\xe1lisis en tiempo real de cada carril. Amazon Carrier Logistics tambi\xe9n permitir\xe1 a los transportistas analizar su rendimiento en relaci\xf3n con todos los KPI que forman parte de su contrato. Los transportistas podr\xe1n aprobar o rechazar cualquier error destacado en relaci\xf3n con su rendimiento.","faq_page-all_faqs-q3":"\xbfEst\xe1n mis datos debidamente protegidos? ","faq_page-all_faqs-a3-p1":"Sabemos que te preocupa el modo en el que tus datos se utilizan y comparten, por lo que te agradecemos que conf\xedes en que lo haremos con cuidado y confidencialidad. Para obtener m\xe1s informaci\xf3n sobre c\xf3mo tratamos tu informaci\xf3n, puedes leer el Aviso de privacidad de Carrier Logistics {link}","faq_page-all_faqs-a3-link":"aqu\xed.","faq_page-all_faqs-a3-p2":"Cuando elijas utilizar Carrier Logistics, el uso que hagas y cualquier disputa sobre la privacidad estar\xe1n sujetos a este Aviso y al siguiente documento: {link}. En estas disposiciones quedan incluidas las limitaciones en materia de da\xf1os, la resoluci\xf3n de disputas y la jurisdicci\xf3n cuya legislaci\xf3n se aplique. Si tienes cualquier duda sobre la privacidad en Amazon, ponte en contacto con nosotros con una descripci\xf3n detallada e intentaremos resolverla.","faq_page-all_faqs-a3-conditions":" Condiciones de uso","faq_page-all_faqs-q4":"\xbfCon qui\xe9n puedo ponerme en contacto si tengo un problema en el portal? ","faq_page-all_faqs-a4":"Ponte en contacto con tu administrador de cuenta de Amazon e inf\xf3rmale del problema. El administrador de cuenta responder\xe1 en un plazo de 48\xa0horas h\xe1biles a partir de la recepci\xf3n de tu comunicaci\xf3n. ","faq_page-all_faqs-q5":"\xbfPuedo dar acceso a Amazon Carrier Logistics a otros empleados o contratistas de mi organizaci\xf3n? ","faq_page-all_faqs-a5":"No, el acceso o uso a Amazon Carrier Logistics est\xe1 restringido exclusivamente al personal autorizado. Para facilitar el acceso a otros miembros del personal de tu empresa, ponte en contacto con tu administrador de cuenta de Amazon.","faq_page-all_faqs-q6":"\xbfQu\xe9 pasa si necesito solicitar las previsiones sobre el volumen o recuento de paquetes? ","faq_page-all_faqs-a6":"Ponte en contacto con tu administrador de cuenta de Amazon e inf\xf3rmale de tus necesidades.","get_started_page-header":"COMENZAR","get_started_page-content":"Gracias por tu inter\xe9s. Si has recibido una invitaci\xf3n de Amazon para registrarte en Amazon Carrier Logistics, crea una cuenta de Amazon para continuar. Si eres transportista que presta servicios de log\xedstica a Amazon, pero no has recibido tu invitaci\xf3n para registrarte, nos pondremos en contacto contigo en breve. Tambi\xe9n puedes ponerte en contacto con tu administrador de cuenta en Amazon para obtener m\xe1s informaci\xf3n sobre c\xf3mo registrarte en Amazon Carrier Logistics.","get_started_page-requirements-header":"REQUISITOS","get_started_page-requirements-content-line1":"Un n\xfamero DOT activo con autoridad interestatal y un n\xfamero MC v\xe1lido","get_started_page-requirements-content-line2":"Un tipo de entidad \u201Ctransportista\u201D autorizada para la propiedad y el alquiler","get_started_page-requirements-content-line3":"Una calificaci\xf3n de seguridad de la Administraci\xf3n Federal de Seguridad de Autotransportes (FMCSA) de \u201CSatisfactorio\u201D, \u201CNinguno\u201D o \u201CNo calificado\u201D","get_started_page-requirements-content-line4":"Todas las p\xf3lizas de seguro pertinentes, incluidas las siguientes:","get_started_page-requirements-content-line4_sub-sub1":"Responsabilidad comercial general no inferior a 1\xa0000\xa0000\xa0$ por suceso y 2\xa0000\xa0000\xa0$ en total","get_started_page-requirements-content-line4_sub-sub2":"Responsabilidad civil de autom\xf3viles no inferior a 1\xa0000\xa0000\xa0$ por incidente, incluida una cobertura de reemplazo de remolques de 50\xa0000\xa0$","get_started_page-requirements-content-line4_sub-sub3":"Cobertura de carga de al menos 100\xa0000\xa0$","get_started_page-requirements-content-line4_sub-sub4":"Seguro de compensaci\xf3n laboral en todas las jurisdicciones en las que opera tu empresa","get_started_page-requirements-content-line4_sub-sub5":"Responsabilidad del empleador no inferior a 100\xa0000\xa0$ por suceso","get_started_page-sign_up-create_new_account_content":"Crea una cuenta nueva o inicia sesi\xf3n en Haul con Amazon.","get_started_page-sign_up-create_new_account_button":"Crear una cuenta de Amazon","get_started_page-sign_up-sign_in_button":"Iniciar sesi\xf3n","terms_conditions_page-usage_content":"El uso de Amazon Carrier Logistics en Francia se rige por las Condiciones de uso que se indican a continuaci\xf3n. Las Condiciones de uso se presentan en ingl\xe9s y franc\xe9s. En caso de conflicto o discrepancia entre la versi\xf3n traducida al franc\xe9s de estas Condiciones de uso y la versi\xf3n en ingl\xe9s, prevalecer\xe1 la versi\xf3n en ingl\xe9s.","terms_conditions_page-conditions_of_use_heading-us":"CONDICIONES DE USO (ingl\xe9s)","terms_conditions_page-conditions_of_use_heading-fr":"CONDITIONS D\u2019UTILISATION (franc\xe9s)","terms_conditions_page-conditions_of_use-us-last_updated":"17 de noviembre de 2022","terms_conditions_page-conditions_of_use-us-intro_heading":"Te damos la bienvenida a Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-us-intro_content":"Amazon EU Sarl o sus filiales (\u201CAmazon\u201D) proporcionan funciones del sitio web y otros productos y servicios cuando visitas o carrierlogistics.amazon.com (el \u201Csitio web\u201D), utilizas productos o servicios de Amazon, utilizas aplicaciones de Amazon para m\xf3viles o utilizas software proporcionado por Amazon en relaci\xf3n con cualquiera de los anteriores (colectivamente, \u201CServicios de Amazon\u201D). Consulta nuestro Aviso de privacidad y nuestro Aviso de cookies para conocer c\xf3mo recopilamos y procesamos tu informaci\xf3n personal a trav\xe9s de Amazon Services. Amazon presta los Servicios de Amazon de conformidad con las condiciones dispuestas en esta p\xe1gina. \u201CAmazon Carrier Logistics\u201D es el nombre comercial de Amazon.","terms_conditions_page-conditions_of_use-us-welcome_content":"Consulta estas condiciones detenidamente antes de utilizar Amazon Services. Al utilizar Amazon Services, declaras que aceptas regirte por estas condiciones. Ofrecemos una amplia gama de Servicios de Amazon y, a veces, pueden aplicarse t\xe9rminos adicionales. Cuando utilices un Servicio de Amazon, tambi\xe9n estar\xe1s sujeto a los t\xe9rminos, directrices y condiciones aplicables a ese Servicio de Amazon (\u201CCondiciones del servicio\u201D). Si estas Condiciones de uso entran en conflicto con los T\xe9rminos de servicio, dichos T\xe9rminos de servicio prevalecer\xe1n.","terms_conditions_page-conditions_of_use-fr-last_updated":"Le 17 novembre 2022","terms_conditions_page-conditions_of_use-fr-intro_heading":"Bienvenue sur Amazon Carrier Logistics. ","terms_conditions_page-conditions_of_use-fr-intro_content":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab Amazon \xbb) vous fournissent des fonctionnalit\xe9s de site web et d\u2019autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab site web \xbb), utilisez les produits, ou services Amazon, utilisez les applications Amazon pour mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\u2019un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab Services Amazon \xbb). Veuillez consulter notre Avis de confidentialit\xe9 et notre Avis sur les cookies pour comprendre comment nous recueillons et traitons vos informations personnelles par le biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab Amazon Carrier Logistics \xbb est le nom commercial d\u2019Amazon.","terms_conditions_page-conditions_of_use-fr-welcome_content":"Veuillez lire attentivement les pr\xe9sentes conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces conditions. Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab Conditions du Service \xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de service, ces derni\xe8res pr\xe9vaudront.","privacy_page-usage_content":"El uso de Amazon Carrier Logistics en Francia se rige por el siguiente Aviso de privacidad. El Aviso de privacidad se presenta en ingl\xe9s y franc\xe9s. En caso de existir conflicto o discrepancia entre la versi\xf3n traducida al franc\xe9s de este Aviso de privacidad y la versi\xf3n en ingl\xe9s, prevalecer\xe1 la versi\xf3n en ingl\xe9s.","privacy_page-heading-us":"Aviso de privacidad (ingl\xe9s)","privacy_page-heading-fr":"Aviso de privacidad (franc\xe9s)","lp_dropdown-not_found":"No se han encontrado grupos log\xedsticos.","no_permissions":"No hay permisos para ver esta secci\xf3n. Intenta cambiar a un grupo log\xedstico distinto.","carrier_selected":"Transportista ","conditions_of_use-p1":"18 de enero de 2022","conditions_of_use-p2":"Te damos la bienvenida a Amazon Carrier Logistics.","conditions_of_use-p3-p1":"Amazon EU Sarl o sus filiales (\u201CAmazon\u201D) te proporcionan funciones del sitio web y otros productos y servicios cuando visitas carrierlogistics.amazon.com (el \u201Csitio web\u201D), utilizas productos o Servicios de Amazon, utilizas aplicaciones de Amazon para m\xf3viles o utilizas software proporcionado por Amazon en relaci\xf3n con cualquiera de los anteriores (colectivamente, \u201CServicios de Amazon\u201D). Visita nuestro","conditions_of_use-p3-l1":"Aviso de privacidad","conditions_of_use-p3-p2":"y nuestro","conditions_of_use-p3-l2":"Aviso sobre cookies","conditions_of_use-p3-p3":"para saber c\xf3mo recopilamos y tramitamos tu informaci\xf3n personal mediante los Servicios de Amazon. Amazon presta los Servicios de Amazon de conformidad con las condiciones dispuestas en la presente p\xe1gina. \u201CAmazon Carrier Logistics\u201D es el nombre comercial de Amazon.","conditions_of_use-p4":"Condiciones de uso","conditions_of_use-p5-p1":"Consulta las presentes condiciones detenidamente antes de utilizar los Servicios de Amazon. Al utilizar los Servicios de Amazon, declaras que aceptas regirte por estas condiciones.","conditions_of_use-p5-p2":"Ofrecemos una amplia gama de Servicios de Amazon y, a veces, pueden aplicarse condiciones adicionales. Cuando utilices un Servicio de Amazon, tambi\xe9n estar\xe1s sujeto a los t\xe9rminos, directrices y condiciones aplicables a ese Servicio de Amazon (\u201CCondiciones del servicio\u201D). Si las presentes Condiciones de uso entran en conflicto con las Condiciones de servicio, dichas Condiciones de servicio prevalecer\xe1n.","conditions_of_use-p6":"1. COMUNICACIONES ELECTR\xd3NICAS","conditions_of_use-p7":"Cuando utilizas cualquier Servicio de Amazon o nos env\xedas correos electr\xf3nicos, te comunicas con nosotros de forma electr\xf3nica. Nos comunicaremos contigo electr\xf3nicamente de diversas formas, por ejemplo, por correo electr\xf3nico, mensajes de texto, avisos push en la aplicaci\xf3n o publicando mensajes o comunicaciones por correo electr\xf3nico en el sitio web o a trav\xe9s de los dem\xe1s Servicios de Amazon. A efectos contractuales, aceptas que todos los acuerdos, avisos, divulgaciones y otras comunicaciones que te proporcionemos electr\xf3nicamente cumplen con cualquier requisito legal de que dichas comunicaciones se realicen por escrito, a menos que las leyes obligatorias aplicables exijan espec\xedficamente una forma de comunicaci\xf3n diferente.","conditions_of_use-p8":"2. RECOMENDACIONES Y PERSONALIZACI\xd3N","conditions_of_use-p9":"Como parte de los Servicios de Amazon, recomendaremos funciones, productos y servicios, incluidos anuncios de terceros que puedan interesarte, identificaremos tus preferencias y personalizaremos tu experiencia.","conditions_of_use-p10":"3. COPYRIGHT, DERECHOS DE AUTOR Y DERECHOS RELATIVOS A BASES DE DATOS","conditions_of_use-p11":"Todo el contenido incluido o disponible mediante cualquier Servicio de Amazon, como texto, gr\xe1ficos, logotipos, iconos de botones, im\xe1genes, clips de audio, descargas digitales y recopilaciones de datos, es propiedad de Amazon o de sus proveedores de contenido y est\xe1 protegido por las leyes luxemburguesas e internacionales de derechos de autor, derechos de autor y derechos de bases de datos. La recopilaci\xf3n de todo el contenido incluido o disponible por medio de cualquier Servicio de Amazon es propiedad exclusiva de Amazon y est\xe1 protegida por las leyes luxemburguesas e internacionales de derechos de autor y derechos de bases de datos.","conditions_of_use-p12":"No puedes extraer ni reutilizar partes del contenido de ning\xfan Servicio de Amazon sin nuestro consentimiento expreso por escrito. En concreto, no puedes utilizar ninguna herramienta de miner\xeda de datos, robots o herramientas similares de recopilaci\xf3n y extracci\xf3n de datos para extraer (ya sea una o varias veces) partes sustanciales del contenido de cualquier Servicio de Amazon con fines de reutilizaci\xf3n, sin nuestro consentimiento expreso por escrito. Tampoco puedes crear ni publicar tu propia base de datos que incluya partes importantes de cualquier Servicio de Amazon (p. ej., nuestros precios) sin nuestro consentimiento expreso por escrito.","conditions_of_use-p13":"4. MARCAS REGISTRADAS","conditions_of_use-l1":"Haz clic aqu\xed para ver una lista no exhaustiva de marcas comerciales de Amazon","conditions_of_use-p14":". Adem\xe1s, los gr\xe1ficos, los logotipos, los encabezados de p\xe1gina, los iconos de botones, los scripts y los nombres de servicios incluidos o disponibles a trav\xe9s de cualquier Servicio de Amazon son marcas comerciales o im\xe1genes comerciales de Amazon. Las marcas comerciales e im\xe1genes comerciales de Amazon no pueden utilizarse correlativamente con ning\xfan producto o servicio que no sea de Amazon de ninguna manera que pueda causar confusi\xf3n entre los clientes o desacredite o perjudique a Amazon. Todas las dem\xe1s marcas comerciales que no pertenezcan a Amazon y que aparezcan en cualquier Servicio de Amazon son propiedad de sus respectivos due\xf1os, que pueden estar o no afiliados, vinculados o patrocinados por Amazon.","conditions_of_use-p15":"5. PATENTES","conditions_of_use-p16":"Se aplican una o m\xe1s patentes propiedad de Amazon en los Servicios de Amazon y en las funciones y servicios accesibles a trav\xe9s de los Servicios de Amazon. Algunas partes de los Servicios de Amazon operan bajo licencia de una o m\xe1s patentes.","conditions_of_use-p17":"6. LICENCIA Y ACCESO","conditions_of_use-p18":"Sujeto a tu cumplimiento de las presentes Condiciones de uso y de las Condiciones de servicio pertinentes, as\xed como al pago de las tarifas aplicables, Amazon o sus proveedores de contenido te otorgan una licencia limitada, no exclusiva, intransferible y no sublicenciable para acceder a los Servicios de Amazon y realizar un uso personal y no comercial de ellos. Esta licencia prev\xe9 la reventa ni el uso comercial de ning\xfan Servicio de Amazon o su contenido; la recopilaci\xf3n y el uso de descripciones o precios; ning\xfan uso derivado de ning\xfan Servicio de Amazon o su contenido; la descarga o copia de la informaci\xf3n de la cuenta para beneficio de otro comerciante; ni el uso de miner\xeda de datos, robots o herramientas similares de recopilaci\xf3n y extracci\xf3n de datos.","conditions_of_use-p19":"Todos los derechos que no se te conceden expresamente en las presentes Condiciones de uso y cualesquiera Condiciones de servicio son reservados y retenidos por Amazon o sus licenciantes, proveedores, editores y titulares de derechos, u otros proveedores de contenido. Ning\xfan Servicio de Amazon, ni ninguna parte de ning\xfan Servicio de Amazon, puede ser reproducido, duplicado, copiado, vendido, revendido, visitado o explotado de otro modo para ning\xfan prop\xf3sito comercial sin el consentimiento expreso por escrito de Amazon. No podr\xe1s utilizar frames o t\xe9cnicas de uso de frames para incluir marcas comerciales, logotipos u otra informaci\xf3n exclusiva (como im\xe1genes, texto, dise\xf1os de p\xe1gina o formatos) de Amazon sin el consentimiento expreso por escrito. No puedes usar metaetiquetas ni ning\xfan otro \u201Ctexto oculto\u201D en el que se haga uso los nombres o marcas comerciales de Amazon sin nuestro consentimiento expreso por escrito.","conditions_of_use-p20":"No puedes hacer un uso indebido de los Servicios de Amazon. Puedes utilizar los Servicios de Amazon solo en la medida en la lo permita la legislaci\xf3n pertinente. Las licencias otorgadas por Amazon se rescindir\xe1n si no cumples con las presentes Condiciones de uso o con cualquiera de las Condiciones de servicio.","conditions_of_use-p21":"7. TU CUENTA","conditions_of_use-p22":"Es posible que necesites tu propia cuenta de Amazon para usar ciertos Servicios de Amazon y que tengas que iniciar sesi\xf3n en la cuenta. Si utilizas cualquier Servicio de Amazon, es responsabilidad tuya mantener la confidencialidad de tu cuenta y tu contrase\xf1a, y de restringir el acceso a tu equipo inform\xe1tico y, en la medida en que lo permita la legislaci\xf3n aplicable, aceptas la responsabilidad de todas las actividades que se lleven a cabo con tu cuenta o contrase\xf1a. Debes tomar todas las medidas necesarias para garantizar la confidencialidad y seguridad continuas de la contrase\xf1a, y debes informarnos inmediatamente si tienes alg\xfan motivo para creer que alguien m\xe1s conoce tu contrase\xf1a, o si la contrase\xf1a se est\xe1 utilizando o es probable que se utilice de manera no autorizada. Es responsabilidad tuya garantizar que los datos y detalles que nos facilites sean fieles y correctos y est\xe9n completos, as\xed como de informarnos de cualquier cambio en la informaci\xf3n que nos hayas proporcionado. Puedes acceder a tu informaci\xf3n en la secci\xf3n Mi cuenta del sitio web.","conditions_of_use-p23":"No debes utilizar ning\xfan Servicio de Amazon: i. de forma que cause, o pueda provocar, que un Servicio de Amazon o cualquier acceso al mismo se interrumpa, da\xf1e o deteriore de alguna manera; o ii. con fines fraudulentos o en relaci\xf3n con un delito u otra actividad ilegal; o iii. para causar molestias, inconvenientes o ansiedad.","conditions_of_use-p24":"Nos reservamos el derecho de rechazar cualquier Servicio de Amazon o rescindir cuentas si tu comportamiento da motivos justificados para hacerlo. Este ser\xe1 el caso, en particular, si infringes la legislaci\xf3n pertinente, las disposiciones contractuales aplicables, nuestras directrices o nuestras pol\xedticas, a las que se puede acceder en el sitio web. Sin perjuicio de dicha limitaci\xf3n o rescisi\xf3n, seguir\xe1s teniendo acceso al contenido y los servicios que haya adquirido hasta ese momento.","conditions_of_use-p25":"8. RESE\xd1AS, COMENTARIOS, COMUNICACIONES Y OTRO CONTENIDO","conditions_of_use-p26-p1":"Si se dispone de capacidad o funci\xf3n para hacerlo, si los visitantes publican rese\xf1as, comentarios y otro contenido; env\xedan otras comunicaciones; y env\xedan sugerencias, ideas, comentarios, preguntas u otra informaci\xf3n, el contenido correspondiente no debe ser ilegal, obsceno, abusivo, amenazante, difamatorio o invasivo de la privacidad, ni infringir los derechos de propiedad intelectual ni da\xf1ar de otro modo a terceros ni censurable y no debe constar de virus de software, campa\xf1as pol\xedticas, solicitudes comerciales, cadenas cartas, correos masivos o cualquier forma de correo no deseado o \u201Cspam\u201D ni incluir o incorporar cualesquiera de estos elementos. No puedes usar direcciones de correo electr\xf3nico falsas, suplantar a personas o entidades, ni enga\xf1ar de manera alguna con respecto a la fuente de tarjetas u otro contenido. Nos reservamos el derecho (pero no, a falta de un documento v\xe1lido","conditions_of_use-p26-p2":", la obligaci\xf3n) de eliminar o editar dicho contenido. Si crees que alg\xfan contenido de un Servicio de Amazon o que se anuncia para su venta contiene una declaraci\xf3n difamatoria o que un producto o informaci\xf3n de alg\xfan Servicio de Amazon est\xe1n infringiendo tus derechos de propiedad intelectual, av\xedsanos rellenando y enviando los correspondientes","conditions_of_use-p26-p3":"y responderemos.","conditions_of_use-l2":"Formulario de denuncia de infracci\xf3n","conditions_of_use-p27":"Si publicas rese\xf1as de clientes, comentarios, preguntas o respuestas de clientes u otro contenido generado por ti para mostrarlo en el sitio web (incluidas im\xe1genes, v\xeddeos o audio, en conjunto \u201Ccontenido\u201D), concedes a Amazon: a. una licencia no exclusiva y libre de regal\xedas para usar, reproducir, publicar, poner a disposici\xf3n, traducir y modificar dicho contenido en todo el mundo (incluido el derecho a sublicenciar estos derechos a terceros); y b. el derecho a usar el nombre que env\xedes en relaci\xf3n con dicho contenido. Esta disposici\xf3n no transfiere ning\xfan derecho moral.","conditions_of_use-p28":"Puedes eliminar tu contenido de la vista p\xfablica o, cuando se ofrezca dicha funcionalidad, cambiar la configuraci\xf3n para que solo se muestre a las personas a las que concedas acceso.","conditions_of_use-p29-p1":"Declaras y garantizas que posees o controlas todos los derechos sobre el contenido que publicas; que, en la fecha en que se publica el contenido o el material: i. el contenido y el material son exactos; y ii. el uso del contenido y el material que facilitas no suponen infracci\xf3n de ninguna pol\xedtica o normativa aplicable y no provocar\xe1 da\xf1os o perjuicios a ninguna persona o entidad, incluida la ausencia de car\xe1cter difamatorio de dicho contenido o material. Aceptas indemnizar a Amazon por todas las reclamaciones interpuestas por un tercero contra Amazon relacionadas con el contenido y el material que facilites o est\xe9n relacionadas con ellos, excepto en la medida en que surja cualquier responsabilidad por nuestra incapacidad para eliminar el contenido correctamente cuando se nos notifique la naturaleza ilegal del contenido","conditions_of_use-p29-p2":"que surja o se base en el contenido que nos has comunicado o que se origine a partir de este. Al eliminar el contenido de la vista p\xfablica, retiras tu licencia para que Amazon publique y ponga a disposici\xf3n del p\xfablico ese contenido.","conditions_of_use-p30":"9. RECLAMACIONES DE PROPIEDAD INTELECTUAL","conditions_of_use-p31":"Amazon respeta la propiedad intelectual de otros. Si crees que tus derechos de propiedad intelectual se han utilizado de una manera que suscita preocupaci\xf3n por una infracci\xf3n, sigue nuestras","conditions_of_use-p32":"10. CONDICIONES DE SOFTWARE DE AMAZON","conditions_of_use-p33":"Adem\xe1s de las presentes Condiciones de uso, los siguientes T\xe9rminos de software se aplican a cualquier software (incluidas las actualizaciones o mejoras del software y cualquier documentaci\xf3n relacionada) que pongamos a tu disposici\xf3n de vez en cuando para tu uso en relaci\xf3n con los Servicios de Amazon (el \u201CSoftware de Amazon\u201D):","conditions_of_use-p34-p1":"Uso del software de Amazon.","conditions_of_use-p34-p2":"Puedes utilizar el Software de Amazon \xfanicamente con el fin de permitirte utilizar los Servicios de Amazon seg\xfan lo dispuesto por Amazon y seg\xfan lo permitido por las presentes Condiciones de uso y cualquier Condiciones de servicio. No puedes incorporar ninguna parte del Software de Amazon a tus propios programas ni compilar ninguna parte de este con tus propios programas, transferirlo para su uso con otro servicio, ni vender, alquilar, arrendar, prestar, distribuir o sublicenciar el Software de Amazon, ni ceder ning\xfan derecho sobre el Software de Amazon en su totalidad o en parte. No puedes utilizar el Software de Amazon para ninguna finalidad ilegal. Podemos dejar de proporcionar cualquier Software de Amazon y podemos rescindir tu derecho a utilizar cualquier Software de Amazon en cualquier momento. Tus derechos de uso del Software de Amazon se rescindir\xe1n autom\xe1ticamente sin previo aviso por nuestra parte si no cumples alguno de estos t\xe9rminos del software, las Condiciones de uso o cualquier otro T\xe9rmino del servicio. Es posible que se apliquen a ese Software de Amazon (o al software incorporado al Software de Amazon) otros t\xe9rminos de terceros que se incluyan en determinado Software de Amazon o que se distribuyan con \xe9l y que regir\xe1n el uso de dicho software en caso de conflicto con las presentes Condiciones de uso. Todo el software utilizado en cualquier Servicio de Amazon es propiedad de Amazon o de sus proveedores de software y est\xe1 protegido por las leyes de derechos de autor internacionales y de Luxemburgo.","conditions_of_use-p34-p3":"Uso de servicios de terceros.","conditions_of_use-p34-p4":"Cuando utilices el Software de Amazon, es posible que tambi\xe9n est\xe9s utilizando los servicios de uno o m\xe1s terceros, como un operador de servicios de telefon\xeda m\xf3vil o un proveedor de software para telefon\xeda m\xf3vil. El uso de estos servicios de terceros puede estar sujeto a las pol\xedticas, T\xe9rminos de uso y tarifas espec\xedficas de dichos terceros.","conditions_of_use-p34-p5":"Prohibici\xf3n de ingenier\xeda inversa.","conditions_of_use-p34-p6":"A menos que lo permita expl\xedcitamente la legislaci\xf3n de obligado cumplimiento y en vigor aplicable, no podr\xe1s copiar, modificar, aplicar ingenier\xeda inversa, descompilar o desensamblar o manipular de otro modo el Software de Amazon, ya sea en su totalidad o en parte, ni crear obras derivadas del Software de Amazon, ni tampoco alentar a hacerlo, contribuir a hacerlo ni autorizar a cualquier persona que lleve a cabo cualesquiera de estas actividades.","conditions_of_use-p34-p7":"Actualizaciones.","conditions_of_use-p34-p8":"Para poder mantener el Software de Amazon actualizado, podemos ofrecer actualizaciones autom\xe1ticas o manuales en cualquier momento y sin previo aviso.","conditions_of_use-p35":"11. NUESTRA RESPONSABILIDAD","conditions_of_use-p36":"Haremos todo lo posible para garantizar que la disponibilidad de los Servicios de Amazon sea ininterrumpida y que las transmisiones est\xe9n libres de errores. Sin embargo, debido a la naturaleza de Internet, esto no se puede garantizar. Adem\xe1s, tu acceso a los Servicios de Amazon tambi\xe9n puede suspenderse o restringirse ocasionalmente para permitir llevar a cabo labores de reparaci\xf3n o mantenimiento o la incorporaci\xf3n de nuevas instalaciones o servicios. Intentaremos limitar la frecuencia y la duraci\xf3n de dichas suspensiones o restricciones.","conditions_of_use-p37":"Amazon no ser\xe1 responsable de: i. las p\xe9rdidas que no hayan sido causadas por ning\xfan incumplimiento por nuestra parte; ni ii ninguna p\xe9rdida empresarial (incluida la p\xe9rdida de beneficios, ingresos, contratos, ahorros anticipados, datos, fondo de comercio o malgastos; ni iii. ninguna p\xe9rdida indirecta o consecuente que no pudi\xe9ramos prever ni t\xfa ni nosotros cuando empezaste a utilizar los Servicios de Amazon.","conditions_of_use-p38":"No nos haremos responsables de ning\xfan retraso o incumplimiento de nuestras obligaciones en virtud de las presentes condiciones si el retraso o el incumplimiento se deben a una causa que est\xe9 fuera de nuestro control razonable.","conditions_of_use-p39":"Las leyes de algunos pa\xedses no permiten algunas o todas las limitaciones indicadas anteriormente. Si debes cumplir con esta legislaci\xf3n, es posible que algunas o todas las limitaciones anteriores no se apliquen en tu caso y que tengas derechos adicionales.","conditions_of_use-p40":"Nada de lo dispuesto en las presentes condiciones limita ni excluye nuestra responsabilidad por las declaraciones fraudulentas que realicemos o por la muerte o las lesiones personales causadas por nuestra negligencia o mala conducta deliberada.","conditions_of_use-p41":"12. EXENCI\xd3N DE GARANT\xcdAS Y LIMITACI\xd3N DE RESPONSABILIDAD","conditions_of_use-p42":"LOS SERVICIOS DE AMAZON Y TODA LA INFORMACI\xd3N, EL CONTENIDO, LOS MATERIALES, LOS PRODUCTOS (INCLUIDO EL SOFTWARE) Y OTROS SERVICIOS INCLUIDOS EN LOS SERVICIOS DE AMAZON O DISPONIBLES MEDIANTE ELLOS SON PRESTADOS POR AMAZON \u201CTAL Y COMO SON\u201D Y \u201CTAL COMO SE ENCUENTRAN DISPONIBLES\u201D, A MENOS QUE SE ESPECIFIQUE LO CONTRARIO POR ESCRITO. AMAZON NO HACE NINGUNA DECLARACI\xd3N O GARANT\xcdA DE NING\xdaN TIPO, EXPRESA O IMPL\xcdCITA, EN CUANTO A LA PRESTACI\xd3N DE LOS SERVICIOS DE AMAZON, O LA INFORMACI\xd3N, EL CONTENIDO, LOS MATERIALES, LOS PRODUCTOS (INCLUIDO EL SOFTWARE) U OTROS SERVICIOS INCLUIDOS O PUESTOS A TU DISPOSICI\xd3N MEDIANTE LOS SERVICIOS DE AMAZON, A MENOS QUE SE ESPECIFIQUE LO CONTRARIO POR ESCRITO. ACEPTAS EXPRESAMENTE QUE TU USO DE LOS SERVICIOS DE AMAZON CORRE BAJO TU PROPIO RIESGO. EN LA MEDIDA EN QUE LO PERMITA LA LEY, AMAZON NO SE HACE RESPONSABLE DE NING\xdaN TIPO DE GARANT\xcdA, IMPL\xcdCITA O EXPL\xcdCITA, LO QUE INCLUYE, ENTRE OTRAS, GARANT\xcdAS IMPL\xcdCITAS DE COMERCIABILIDAD E IDONEIDAD PARA UN FIN DETERMINADO. AMAZON NO GARANTIZA QUE LOS SERVICIOS DE AMAZON, LA INFORMACI\xd3N, EL CONTENIDO, LOS MATERIALES, LOS PRODUCTOS (INCLUIDO EL SOFTWARE) U OTROS SERVICIOS INCLUIDOS O DISPONIBLES MEDIANTE LOS SERVICIOS DE AMAZON, LOS SERVIDORES DE AMAZON O LAS COMUNICACIONES ELECTR\xd3NICAS ENVIADAS DESDE AMAZON, EST\xc9N LIBRES DE VIRUS U OTROS COMPONENTES PERNICIOSOS. EN LA MEDIDA EN QUE LO PERMITA LA LEY, AMAZON NO SER\xc1 RESPONSABLE POR NING\xdaN DA\xd1O DE NING\xdaN TIPO QUE SURJA DEL USO DE CUALQUIER SERVICIO DE AMAZON, O DE CUALQUIER INFORMACI\xd3N, CONTENIDO, MATERIALES, PRODUCTOS (INCLUIDO EL SOFTWARE) U OTROS SERVICIOS INCLUIDOS EN O PUESTOS A TU DISPOSICI\xd3N A TRAV\xc9S DE CUALQUIER SERVICIO DE AMAZON, INCLUYENDO, PERO NO LIMITADO A, DA\xd1OS DIRECTOS, INDIRECTOS, INCIDENTALES, PUNITIVOS Y CONSECUENTES, A MENOS QUE SE ESPECIFIQUE OTRA COSA POR ESCRITO.","conditions_of_use-p43":"13. LEGISLACI\xd3N APLICABLE","conditions_of_use-p44":"Si te encuentras en un estado miembro de la UE, las presentes condiciones se rigen e interpretan de conformidad con las leyes del Gran Ducado de Luxemburgo, y se excluye expresamente la aplicaci\xf3n de la Convenci\xf3n de las Naciones Unidas sobre los Contratos de Compraventa Internacional de Mercader\xedas. Ambos aceptamos someternos a la jurisdicci\xf3n exclusiva de los tribunales de la ciudad de Luxemburgo.","conditions_of_use-p45":"Si te encuentras en el Reino Unido, aceptas que las leyes de Inglaterra y Gales, sin tener en cuenta los principios de conflicto de leyes, regir\xe1n las presentes Condiciones de uso y cualquier disputa de cualquier tipo que pueda surgir entre t\xfa y Amazon. La aplicaci\xf3n de la Convenci\xf3n de las Naciones Unidas sobre los Contratos de Compraventa Internacional de Mercader\xedas est\xe1 expresamente excluida. Te sometes irrevocablemente a la jurisdicci\xf3n exclusiva de los tribunales de Inglaterra. Cualquier disputa o reclamaci\xf3n relacionada de alguna manera con tu uso del Sitio web se resolver\xe1 mediante presentaci\xf3n de una reclamaci\xf3n ante un tribunal competente en Inglaterra. Renuncias a todas las objeciones a la jurisdicci\xf3n y competencia de dichos tribunales.","conditions_of_use-p46-p1":"Si deseas poner un asunto en nuestro conocimiento\xa0","conditions_of_use-p46-l1":"contacta con nosotros","conditions_of_use-p47":"14. CAMBIOS EN EL SERVICIO O MODIFICACIONES DE LAS CONDICIONES DE USO","conditions_of_use-p48":"Nos reservamos el derecho de realizar cambios en cualquier momento en los servicios, las pol\xedticas, los t\xe9rminos y condiciones de Amazon, incluidas las presentes Condiciones de uso y las Condiciones de servicio. Estar\xe1s sujeto a los T\xe9rminos y condiciones, las pol\xedticas y las Condiciones de uso vigentes en el momento en que utilices los Servicios de Amazon. Si alguna de las presentes Condiciones de uso fuera considerada no v\xe1lida, nula o inaplicable por cualquier motivo, dicha condici\xf3n se considerar\xe1 divisible y no afectar\xe1 a la validez y aplicabilidad de cualquier condici\xf3n restante.","conditions_of_use-p49":"15. RENUNCIA","conditions_of_use-p50":"Si incumples las presentes Condiciones de uso y no tomamos ninguna medida, seguiremos teniendo derecho a hacer uso de nuestros derechos y recursos en cualquier otra situaci\xf3n en la que infrinjas las presentes Condiciones de uso.","conditions_of_use-p51":"16. NUESTROS DETALLES DE CONTACTO","conditions_of_use-p52":"Este sitio web es propiedad de Amazon EU Sarl, que se encarga asimismo de su mantenimiento:","conditions_of_use-p53":"17. NOTIFICACI\xd3N Y PROCEDIMIENTO PARA PRESENTAR RECLAMACIONES DE INFRACCI\xd3N DE DERECHOS","conditions_of_use-p54-p1":"Si crees que se han infringido tus derechos de propiedad intelectual, env\xeda tu queja mediante nuestra p\xe1gina en l\xednea\xa0","conditions_of_use-p54-p2":". El presente formulario se puede utilizar para efectuar todo tipo de reclamaciones sobre propiedad intelectual, incluidas las relativas a copyright, marcas registradas, dise\xf1o y reclamaciones sobre patentes","conditions_of_use-p55":"Tras recibir una queja, podemos tomar ciertas medidas, como eliminar informaci\xf3n o un producto y cesar nuestra vinculaci\xf3n con los infractores reincidentes en las circunstancias apropiadas. Todas estas acciones se toman sin admitir responsabilidad alguna y sin perjuicio de cualquier derecho, recurso o defensa, todos los cuales est\xe1n expresamente reservados. Esto incluye enviar la queja a las partes involucradas en la provisi\xf3n del contenido supuestamente infractor. Aceptas indemnizar a Amazon por todas las reclamaciones interpuestas por un tercero contra Amazon que surjan de la presentaci\xf3n de una queja o est\xe9n relacionadas con ella.","conditions_of_use-p56-p1":"Advertencia importante:","conditions_of_use-p56-p2":"proporcionar informaci\xf3n falsa, enga\xf1osa o inexacta en el formulario de notificaci\xf3n a Amazon puede dar lugar a responsabilidades civiles o penales. Ponte en contacto con un asesor legal si tienes alguna pregunta.","privacy_notice-p1":"Carrier Logistics entiende tu preocupaci\xf3n por c\xf3mo se utiliza y se comparte tu informaci\xf3n personal y te agradecemos que conf\xedes en que trataremos tus datos de forma cuidadosa y confidencial.","privacy_notice-p2":"Cualquier informaci\xf3n personal facilitada a Carrier Logistics o que este vaya a recopilar est\xe1 controlada por Amazon EU Sarl, el controlador de datos, de ","privacy_notice-p4":"Recibimos, utilizamos y almacenamos cualquier informaci\xf3n que proporciones a Carrier Logistics a trav\xe9s del uso de este sitio. Contamos con sistemas de seguridad f\xedsicos, electr\xf3nicos y de procedimientos en la recogida, almacenamiento y divulgaci\xf3n de tus datos personales.","privacy_notice-p5":"Usamos tus datos para tramitar tu solicitud y comunicarnos contigo. Compartimos tus datos solo como se describe en este Aviso de privacidad y con Amazon (que est\xe1 sujeta a este Aviso de privacidad o sigue pr\xe1cticas que son, al menos, tan protectoras como las descritas en este Aviso de privacidad). Tambi\xe9n divulgamos informaci\xf3n cuando lo consideramos necesario para cumplir la ley; ejecutar o aplicar nuestras Condiciones de uso; para proteger los derechos, la propiedad y la seguridad de Carrier Logistics, nuestros usuarios u otras partes interesadas, o para llevar a cabo comprobaciones de antecedentes con terceros que no forman parte de Amazon. Entre estas cuestiones se encuentran el intercambio de informaci\xf3n con otras empresas y organizaciones para evitar fraudes y estafas y reducir el riesgo de sufrir impagos; sin embargo, no se incluyen la venta, el alquiler, el intercambio u otro tipo de revelaci\xf3n de tus datos personales con fines comerciales o mercadot\xe9cnicos.","privacy_notice-p6":"Carrier Logistics cumple con las la legislaci\xf3n pertinente mediante la que se dispone la denominada \u201CDirectiva de cookies de la UE\u201D. Al utilizar este sitio web con el navegador configurado para aceptar las cookies, comunicas que nos autorizas a utilizar cookies, pero solo usaremos aquellas que consideremos estrictamente necesarias. La funcionalidad de ayuda de la mayor\xeda de los navegadores te indicar\xe1 c\xf3mo evitar que tu navegador acepte nuevas cookies, c\xf3mo hacer que el navegador te avise cuando reciba una nueva cookie y c\xf3mo deshabilitar las cookies por completo.","privacy_notice-p7":"Nuestras operaciones y actividades comerciales est\xe1n en continuo cambio y nuestro Aviso de privacidad y nuestras Condiciones de uso tambi\xe9n pueden sufrir modificaciones. Debes consultar peri\xf3dicamente nuestro sitio web para saber si ha habido alg\xfan cambio reciente.","privacy_notice-p8":"Si tienes preguntas sobre este Aviso de Privacidad, ponte en contacto con la empresa en la direcci\xf3n indicada arriba.","sidebar_labels-forecast":"Previsi\xf3n de volumen","sidebar_labels-rubiks":"Correcci\xf3n de errores de paquetes","sidebar_labels-adhoc_capacity":"Capacidad ad hoc","sidebar_labels-performance":"Rendimiento","sidebar_labels-case_management":"Panel de control de casos","sidebar_labels-npc":"NPC","sidebar_labels-performance_insights":"Insights","sidebar_labels-performance_dashboard":"Panel de control","support":"Soporte","unauthorized-title":"Sin permisos: ","unauthorized-message":"Gracias por aceptar la invitaci\xf3n para unirte a Carrier Logistics. Para empezar, ponte en contacto con el administrador del transportista para solicitar los permisos de acceso necesarios.","feedback-description":"Gracias por tomarte el tiempo de hacer este comentario. Esto no te llevar\xe1 m\xe1s de 1\xa0minuto de tu valioso tiempo.","feedback-confirmation_message":"\xa1Gracias! Agradecemos y valoramos tus comentarios."}}');

},{}],"edyIo":[function(require,module,exports) {
module.exports = JSON.parse('{"dev_app":{"title":"CarrierLogistics UI"},"lp":{"header_name":"Logistic provider name","header_country":"Registration Country","view_owner":"View Owner/Admin","request_permissions":"Request Permissions","admins_lp":"Admins of this LP:","request_permissions_for_lp":"Please reach out to the admin to request permissions","no_admins":"No admins available for this LP"},"managePermissions":{"ok_button":"Ok"},"permissions":{"permissions":"Permissions"},"error_page":{"heading":"Something went wrong!!","content":"Please ensure that you are connected to VPN/have an active internet connection."},"top_bar":{"frequently_asked_questions_button":"Frequently Asked Questions","get_started_button":"Get started","sign_in_button":"Sign in","settings_menu":{"my_profile":"My profile","accounts":"Accounts","manage_users":"Manage Users","sign_out":"Sign out"},"select_lp":"Select an account","loading_lps":"Loading accounts...","language_toggle_supported":"Only English language is supported for this page. Other language support for this page is coming soon."},"home_page":{"sidebar_label":"Home","wallpaper_content_block":{"heading":"Manage your Amazon operations, the smart way","content":"Carriers can now view their capacity forecasts, plan adhoc capacity and analyze performance with automated reports, delivered to their doorsteps.","get_started_button":"Get started"},"wallpaper_content":{"heading":"Advancing how you manage your operations","body":"We blend advanced technology with 20+ years of insights to help you improve your operations \u2015simply and reliably. With the power of Amazon behind your wheels, you have a partner that\'s here to support your needs of today and help you navigate the road ahead.","sub1":{"title":"Future-ready platform","body":"Our platform will scale seamlessly with your operations, and address all your future needs, starting with providing visibility into shipment volume forecasts, adhoc capacity change requests, and claims related to performance on agreed-upon KPIs."},"sub2":{"title":"Safe & Secure","body":"We know your data privacy is important, that\'s why we do not share your info with any other logistic parties. We are third party security (TPS) compliant."},"sub3":{"title":"Transparent 2-way channel","body":"We understand transparency is they key for fostering an environment of trust, and enable you to provide feedback on all reports and insights provided. We have a team working 24x7 to ensure this feedback is acted upon swiftly. "}},"why_amazon":{"title":"WHAT ARE THE BENEFITS OF JOINING AMAZON CARRIER LOGISTICS?","benefits":{"one_stop":{"title":"ONE STOP SHOP FOR YOUR OPERATIONS NEEDS","description":"Manage end-to-end operations lifecycle through one platform"},"reduced_costs":{"title":"REDUCED COSTS","description":"Plan your capacity and manage exceptions with data-backed insights to optimize operations"},"performance_vis":{"title":"PERFORMANCE VISIBILITY","description":"Use our real time reports to analyse your pertormance and boost your business"}}},"faq_section":{"header":"FREQUENTLY ASKED QUESTIONS","drilldown":{"q1":{"title":"What capabilities are currently enabled through Amazon Carrier Logistics?","ans":"Amazon Carrier Logistics currently enables the registered carriers to download and view package count/ volume forecasts and plan their capacity accordingly. Carriers will also receive an e-mail notification every time a new forecast is generated. "},"q2":{"title":"What capabilities are planned to launch on Amazon Carrier Logistics in 2023?","ans":"Amazon Carrier Logistics will soon enable carriers to view adhoc capacity change requests created based on real-time analysis for each lane. Amazon Carrier Logistics will also allow the carriers to analyze their performance on all KPIs, which are part of their contract. Carriers will be able to approve/ reject any misses highlighted for their performance.  "},"q3":{"title":"Is my data secure? ","ans":"Amazon follows strict data protection regulations to ensure your data is safe. We are third party security (TPS) compliant and always keep your data and privacy protected. Managing operations via. Amazon Carrier Logistics does not give any other customers visibility or access into your data."},"q4":{"title":"Who can I contact if I encounter a problem while downloading package counts/ volume forecasts? ","ans":"Reach out to your Amazon account manager and inform them of the issue. Your account manager will revert to your issues within 48 working hours of receiving the issue. "}},"see_all_faqs_button":"See all FAQs"},"footer":{"conditions_of_use_button":"Conditions of Use","privacy_notice_button":"Privacy Notice","copyright_text":"\xa9 1996-2022, Amazon.com, Inc. or its affiliates"}},"faq_page":{"header":"FREQUENTLY ASKED QUESTIONS","tabs":{"all":"All","onboarding":"Onboarding","safetyAndPerformance":"Safety and Performance","payments":"Payments"},"onboarding":{"load_req_que":"What are the requirements to carry loads for Amazon?","load_req_ans":{"line1":"In order to join Amazon\u2019s freight network, you must meet the following minimum requirements:","line1_sub":{"sub1":"An active DOT number with interstate authority and a valid MC number","sub2":"A \u201CCarrier\u201D entity type that is Authorized for Property and for Hire","sub3":"A Federal Motor Carrier Safety Administration (FMCSA) Safety Rating of \u201CSatisfactory,\u201D \u201CNone,\u201D or \u201CNot Rated\u201D","sub4":"Behavior Analysis and Safety Improvement Categories (BASIC) scores:","sub4_sub":{"sub1":"Unsafe Driving below 60%","sub2":"HOS Compliance below 60%","sub3":"Vehicle Maintenance below 75%"}}},"amazon_monitor_compliance_que":"How does Amazon monitor carrier compliance?","amazon_monitor_compliance_ans":"Amazon uses a variety of tools, including our internal compliance teams and a third-party compliance monitoring service, to validate and continually monitor carrier compliance."},"safety_and_performance":{"service_level_expectations_que":"What are the service level expectations?","service_level_expectations_ans":{"line1":"Amazon requires that carriers ensure the highest level of safety and performance, including:","line1_sub":{"sub1":"Compliance with safety, DOT and insurance requirements","sub2":"On-time delivery to delight our customer promise.","sub3":"Consistent tender acceptance.","sub4":"Execute loads using Carrier Logistics technology"}},"track_my_performance_que":"How can I track my performance?","track_my_performance_ans":"Amazon provides a transparent performance scorecard in the Carrier Logistics portal. You can review your performance for all of your loads, in order to continuously improve and have the opportunity to grow your business with Amazon.","amazon_prioritize_safety_que":"How does Amazon prioritize safety?","amazon_prioritize_safety_ans":"Safety for your drivers, Amazon employees, and the public is Amazon\u2019s first priority. Safety standards must be followed on the road, behind the wheel, in the yard, or in an Amazon facility. We expect you to report any unsafe acts or conditions immediately to Amazon management. There is nothing more important than your safety and the safety of others."},"payments":{"completed_loads_payments_que":"When will I get paid for completed loads?","completed_loads_payments_ans":"Payment cycle runs weekly from Sunday-Saturday. Everything completed before 23:59 Saturday will be paid out the following week on Friday.","submit_invoice_que":"How do I submit an invoice for a load?","submit_invoice_ans":"Carrier Logistics will generate invoices automatically. You will be able to review all invoices and payments in Carrier Logistics portal."},"all_faqs":{"q1":"What capabilities are currently enabled through Amazon Carrier Logistics?","a1":{"legend":"Amazon Carrier Logistics currently enables the registered carriers to download and view package count/ volume forecasts and plan their capacity accordingly. Carriers will also receive an e-mail notification every time a new forecast is generated. ","p1":"Forecasting - Carriers can download and view package count or volume forecasts and plan their capacity accordingly. Carriers will also receive an e-mail notification every time a new forecast is generated. ","p2":"Capacity Management - Carriers can review and respond to ad-hoc capacity requests. Carrier Logistics will automatically send notifications and timely reminders for these requests.","p3":"Performance Management - Carriers can download and review performance reports. Carriers will also be able to query reported misses. "},"q2":"What capabilities are planned to launch on Amazon Carrier Logistics in 2023?","a2":"Amazon Carrier Logistics will soon enable carriers to view adhoc capacity change requests created based on real-time analysis for each lane. Amazon Carrier Logistics will also allow the carriers to analyze their performance on all KPIs, which are part of their contract. Carriers will be able to approve/ reject any misses highlighted for their performance.","q3":"Is my data secure? ","a3":{"p1":"We know that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly. For more information about how we treat your information, you may read the Carrier Logistics Privacy Notice {link}","link":"here.","p2":"When you choose to use Carrier Logistics, your use and any dispute over privacy is subject to this Notice and our {link}, including limitations on damages, resolution of disputes, and the jurisdiction whose law applies . If you have any concern about privacy at Amazon, please contact us with a thorough description, and we will try to resolve it.","conditions":" Conditions of Use"},"q4":"Who can I contact if I encounter a problem on the portal? ","a4":"Reach out to your Amazon account manager and inform them of the issue. Your account manager will respond within 48 working hours of receiving your communication. ","q5":"Can I give access for Amazon Carrier Logistics to other employees/ contractors of my organization? ","a5":"No, only authorized personnel will be able to access and use Amazon Carrier Logistics. To provide access to other personnel in your company, please reach out to your Amazon account manager.","q6":"What if I need to request new package volume/ count forecasts? ","a6":"Reach out to your Amazon account manager and inform them of your requirements."}},"get_started_page":{"header":"GET STARTED","content":"Thank you for your interest. If you have received an invitation from Amazon to register on Amazon Carrier Logistics, please proceed to create an Amazon account. If you are a carrier providing logistics services to Amazon, but have not received your invitation to register, we will approach you soon. You can also contact your account manager at Amazon to know more about registering on Amazon Carrier Logistics.","requirements":{"header":"REQUIREMENTS","content":{"line1":"An active DOT number with interstate authority and a valid MC number","line2":"A \u201CCarrier\u201D entity type that is Authorized for Property and for Hire","line3":"A Federal Motor Carrier Safety Administration (FMCSA) Safety Rating of \u201CSatisfactory,\u201D \u201CNone,\u201D or \u201CNot Rated\u201D","line4":"All required insurance policies including:","line4_sub":{"sub1":"Commercial General Liability not less than $1,000,000 per occurrence and $2,000,000 in the aggregate","sub2":"Auto Liability not less than $1,000,000 per occurrence, including a trailer replacement coverage of $50,000","sub3":"Cargo coverage of least $100,000","sub4":"Workers\u2019 Compensation insurance in all jurisdictions where your company operates","sub5":"Employer Liability not less than $100,000 per occurrence"}}},"sign_up":{"create_new_account_content":"Create a new account, or sign in to haul with Amazon.","create_new_account_button":"Create an Amazon account","sign_in_button":"Sign In"}},"terms_conditions_page":{"usage_content":"Use of Amazon Carrier Logistics in France is governed by the Conditions of Use below. The Conditions of Use are presented in English and French. In the event of any conflict or discrepancy between the French translated version of these Conditions of Use and the English language version, the English language version controls.","conditions_of_use_heading":{"us":"CONDITIONS OF USE (English)","fr":"CONDITIONS D\u2019UTILISATION (French)"},"conditions_of_use":{"us":{"last_updated":"November 17, 2022","intro_heading":"Welcome to Amazon Carrier Logistics. ","intro_content":"Amazon EU Sarl and/or its affiliates (\\"Amazon\\") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the \\"website\\"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively \\"Amazon Services\\"). Please see our Privacy Notice and our Cookies Notice to understand how we collect and process your personal information through Amazon Services. Amazon provides the Amazon Services subject to the conditions set out on this page. \u201CAmazon Carrier Logistics\u201D is the trading name for Amazon.","welcome_content":"Please read these conditions carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these conditions. We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service (\\"Service Terms\\"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control."},"fr":{"last_updated":"Le 17 novembre 2022","intro_heading":"Bienvenue sur Amazon Carrier Logistics. ","intro_content":"Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab Amazon \xbb) vous fournissent des fonctionnalit\xe9s de site web et d\u2019autres produits et services lorsque vous visitez carrierlogistics.amazon.com (le \xab site web \xbb), utilisez les produits, ou services Amazon, utilisez les applications Amazon pour mobile, ou utilisez un logiciel fourni par Amazon en relation avec l\u2019un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab Services Amazon \xbb). Veuillez consulter notre Avis de confidentialit\xe9 et notre Avis sur les cookies pour comprendre comment nous recueillons et traitons vos informations personnelles par le biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab Amazon Carrier Logistics \xbb est le nom commercial d\u2019Amazon.","welcome_content":"Veuillez lire attentivement les pr\xe9sentes conditions avant d\u2019utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u2019\xeatre li\xe9 par ces conditions. Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u2019appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab Conditions du Service \xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u2019utilisation et les Conditions de service, ces derni\xe8res pr\xe9vaudront."}}},"privacy_page":{"usage_content":"Use of Amazon Carrier Logistics in France is governed by the Privacy Notice below. The Privacy Notice is presented in English and French. In the event of any conflict or discrepancy between the French translated version of this Privacy Notice and the English language version, the English language version controls.","heading":{"us":"Privacy Notice (English)","fr":"Privacy Notice (French)"}},"lp_dropdown":{"not_found":"No Logistic parties found."},"no_permissions":"No permissions to view this section. Try switching to a different logistic party.","carrier_selected":"Carrier ","conditions_of_use":{"p1":"January 18, 2022","p2":"Welcome to Amazon Carrier Logistics.","p3":{"p1":"Amazon EU Sarl and/or its affiliates (\\"Amazon\\") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the \\"Website\\"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively \\"Amazon Services\\"). Please see our","l1":"Privacy Notice","p2":"and our","l2":"Cookies Notice","p3":"to understand how we collect and process your personal information through Amazon Services. Amazon provides the Amazon Services subject to the conditions set out on this page. \u201CAmazon Carrier Logistics\u201D is the trading name for Amazon."},"p4":"Conditions of Use","p5":{"p1":"Please read these conditions carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these conditions.","p2":"We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service (\\"Service Terms\\"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control."},"p6":"1. ELECTRONIC COMMUNICATIONS","p7":"When you use any Amazon Service or send e-mails to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the Website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communications be in writing, unless mandatory applicable laws specifically require a different form of communication.","p8":"2. RECOMMENDATIONS AND PERSONALISATION","p9":"As part of the Amazon Services, we will recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalise your experience.","p10":"3. COPYRIGHT, AUTHORS\' RIGHTS AND DATABASE RIGHTS","p11":"All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by Luxembourg and international copyright, authors\' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by Luxembourg and international copyright and database right laws.","p12":"You may not extract and/or re-utilise parts of the content of any Amazon Service without our express written consent. In particular, you may not utilise any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilisation any substantial parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.","p13":"4. TRADEMARKS","l1":"Click here to see a non-exhaustive list of Amazon trademarks","p14":". In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon\'s trademarks and trade dress may not be used in connection with any product or service that is not Amazon\'s, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.","p15":"5. PATENTS","p16":"One or more patents owned by Amazon apply to the Amazon Services and to the features and services accessible via the Amazon Services. Portions of the Amazon Services operate under license of one or more patents.","p17":"6. LICENCE AND ACCESS","p18":"Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable licence to access and make personal and non-commercial use of the Amazon Services. This licence does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.","p19":"All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other \\"hidden text\\" utilising Amazon\'s names or trademarks without our express written consent.","p20":"You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licences granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.","p21":"7. YOUR ACCOUNT","p22":"You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account. If you use any Amazon Service you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorised manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. You can access your information in the\xa0Your Account\xa0section of the Website.","p23":"You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance, inconvenience or anxiety.","p24":"We reserve the right to refuse any Amazon Services or terminate accounts if your behaviour gives justified reason to do so. This will in particular be the case if you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are all accessible on the Website. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.","p25":"8. REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT","p26":{"p1":"Where the functionality exists to do so, if visitors post reviews, comments and other content; send other communications; and submit suggestions, ideas, comments, questions or other information, the content must not be illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and must not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of \\"spam\\". You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but not, in the absence of a valid","p2":", the obligation) to remove or edit such content. If you believe that any content on or advertised for sale on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate","p3":"and we will respond."},"l2":"Report Infringement Form","p27":"If you post customer reviews, comments, customer questions or answers, or other content generated by you for display on the Website (including any images, video or audio, all together \\"content\\", you grant Amazon (a) a non-exclusive, royalty-free licence to use, reproduce, publish, make available, translate and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.","p28":"You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.","p29":{"p1":"You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as at the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content","p2":"arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly."},"p30":"9. INTELLECTUAL PROPERTY CLAIMS","p31":"Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been used in a way that gives rise to concerns of infringement, please follow our","p32":"10. AMAZON SOFTWARE TERMS","p33":"In addition to these Conditions of Use, the following Software Terms\xa0apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the \\"Amazon Software\\"):","p34":{"p1":"Use of the Amazon Software.","p2":"You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by these Conditions of Use, these Software Terms, and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use, or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by Luxembourg and international copyright laws.","p3":"Use of Third Party Services.","p4":"When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties.","p5":"No Reverse Engineering.","p6":"Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorise any other person to copy, modify, reverse engineer, decompile or disassemble, or otherwise tamper with, the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software.","p7":"Updates.","p8":"In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you."},"p35":"11. OUR LIABILITY","p36":"We will do our utmost to ensure that availability of the Amazon Services will be uninterrupted and that transmissions will be error-free. However, due to the nature of the internet, this cannot be guaranteed. Also, your access to Amazon Services may also be occasionally suspended or restricted to allow for repairs, maintenance, or the introduction of new facilities or services. We will attempt to limit the frequency and duration of any such suspension or restriction.","p37":"Amazon will not be responsible for (i) losses that were not caused by any breach on our part, or (ii) any business loss (including loss of profits, revenue, contracts, anticipated savings, data, goodwill or wasted expenditure), or (iii) any indirect or consequential losses that were not foreseeable to both you and us when you commenced using the Amazon Services.","p38":"We will not be held responsible for any delay or failure to comply with our obligations under these conditions if the delay or failure arises from any cause which is beyond our reasonable control.","p39":"The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above limitations may not apply to you and you might have additional rights.","p40":"Nothing in these conditions limits or excludes our responsibility for fraudulent representations made by us or for death or personal injury caused by our negligence or wilful misconduct.","p41":"12. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY","p42":"THE AMAZON SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES ARE PROVIDED BY AMAZON ON AN \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING. AMAZON MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE AMAZON SERVICES OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES, UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. YOU EXPRESSLY AGREE THAT YOUR USE OF THE AMAZON SERVICES IS AT YOUR SOLE RISK. TO THE FULL EXTENT PERMISSIBLE BY LAW, AMAZON DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. AMAZON DOES NOT WARRANT THAT THE AMAZON SERVICES; INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES; AMAZON\u2019S SERVERS; OR ELECTRONIC COMMUNICATIONS SENT FROM AMAZON ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, AMAZON WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY AMAZON SERVICE OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY AMAZON SERVICE, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING.","p43":"13. APPLICABLE LAW","p44":"If you are in an EU member state, these conditions are governed by and construed in accordance with the laws of Grand Duchy of Luxembourg, and the application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. We both agree to submit to the exclusive jurisdiction of the courts of the city of Luxembourg.","p45":"If you are in the United Kingdom, you agree that the laws of England and Wales, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon. The application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. You irrevocably submit to the exclusive jurisdiction of the courts of England. Any dispute or claim relating in any way to your use of the Website will be resolved by bringing a claim before a relevant competent court in England. You waive all objections to the jurisdiction and venue of such courts.","p46":{"p1":"If you would like to bring a matter to our attention, please\xa0","l1":"contact us"},"p47":"14. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE","p48":"We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.","p49":"15. WAIVER","p50":"If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.","p51":"16. OUR CONTACT DETAILS","p52":"This Website is owned and maintained by Amazon EU Sarl:","p53":"17. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS","p54":{"p1":"If you believe that your intellectual property rights have been infringed, please submit your complaint using our online\xa0","p2":". This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims"},"p55":"Upon receipt of a complaint we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint.","p56":{"p1":"Important Warning:","p2":"giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions."}},"privacy_notice":{"p1":"Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.","p2":"Any personal information provided to or to be gathered by Carrier Logistics is controlled by Amazon EU Sarl the data controller, of ","p4":"We receive, use and store any information you provide to Carrier Logistics through your use of this site. We maintain physical, electronic and procedural safeguards in connection with the collection, storage and disclosure of your information.","p5":"We use your information to process your application and to communicate with you. We share your information only as described in this Privacy Notice and with Amazon (who are either subject to this Privacy Notice or follow practices at least as protective as those described in this Privacy Notice). We may also release information when we believe it is appropriate to comply with the law; to enforce or apply our Conditions of Use; to protect the rights, property or safety of Carrier Logistics, our users or others; or to conduct background checks with third party companies which are not within Amazon. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction; however, this does not include selling, renting, sharing or otherwise disclosing your information for commercial or marketing purposes.","p6":"Carrier Logistics complies with applicable laws implementing the so-called \u2018EU Cookies Directive\u2019. Using this site with your browser settings adjusted to accept cookies tells us that you consent to our use of cookies but we only use cookies which we consider to be strictly necessary. The \u2018Help\u2019 feature on most browsers will tell you how to prevent your browser from accepting new cookies, how to have the browser notify you when you receive a new cookie and how to disable cookies altogether.","p7":"Our business changes constantly and our Privacy Notice and Conditions of Use may also change. You should check our site frequently to see any recent changes.","p8":"For questions on this Privacy Notice, please contact the company at the address given above."},"sidebar_labels":{"forecast":"Forecast","rubiks":"Problem Solve","adhoc_capacity":"Adhoc Capacity","performance":"Performance","case_management":"Case Dashboard","npc":"NPC","performance_insights":"Insights","performance_dashboard":"Dashboard"},"support":"Support","unauthorized":{"title":"No Permissions: ","message":"Thank you for accepting the invitation to join Carrier Logistics. To get started, please contact your carrier administrator to request the necessary access permissions."},"feedback":{"description":"Thank you for taking time to fill in this feedback. This will not take more than 1 minute of your valuable time.","confirmation_message":"Thank You! We appreciate your feedback."},"service_provider_type":{"dsp":"Delivery Service Providers","lp":"Logistics Parties"},"service_provider_options":{"dsp":"Delivery Service Providers"},"service_provider_tags":{"dsp_tag":"DSP"}}');

},{}],"hgcsB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const unflattenObj = (data, separator = "-")=>{
    const result = {};
    for(var i in data){
        var keys = i.split(separator);
        keys.reduce((r, e, j)=>r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? keys.length - 1 == j ? data[i] : {} : []), result);
    }
    return result;
};
exports.default = unflattenObj;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cEqPz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLocaleForAuthPortal", ()=>setLocaleForAuthPortal);
parcelHelpers.export(exports, "setLocaleToLocalStorage", ()=>setLocaleToLocalStorage);
parcelHelpers.export(exports, "getLocaleFromLocalStorage", ()=>getLocaleFromLocalStorage);
parcelHelpers.export(exports, "getSupportedLocaleForDeviceLocale", ()=>getSupportedLocaleForDeviceLocale);
var _cookieUtils = require("./cookieUtils");
var _env = require("../config/env");
var _localisation = require("../constants/localisation");
var _i18N = require("../config/i18n");
const setLocaleForAuthPortal = (locale)=>{
    if ((0, _env.isBeta)() || (0, _env.isLocal)()) (0, _cookieUtils.setCookie)((0, _localisation.LANGUAGE_CODE_COOKIE_NAME).BETA, locale);
    else if ((0, _env.isGamma)()) (0, _cookieUtils.setCookie)((0, _localisation.LANGUAGE_CODE_COOKIE_NAME).GAMMA, locale);
    else if ((0, _env.isProd)()) (0, _cookieUtils.setCookie)((0, _localisation.LANGUAGE_CODE_COOKIE_NAME).PROD, locale);
};
const setLocaleToLocalStorage = (locale)=>{
    localStorage.setItem((0, _localisation.LOCALE_LOCAL_STORAGE_KEY), locale);
};
const getLocaleFromLocalStorage = ()=>localStorage.getItem((0, _localisation.LOCALE_LOCAL_STORAGE_KEY));
const getSupportedLocaleForDeviceLocale = ()=>{
    const { language } = window.navigator;
    return language && Object.keys((0, _i18N.LOCALES_MESSAGES_MAP)).find((locale)=>{
        const deviceLanguageParts = language.split("-");
        return locale.startsWith(deviceLanguageParts[0]);
    }) || (0, _i18N.DEFAULT_LOCALE);
};

},{"./cookieUtils":"4RW9j","../config/env":"318XE","../constants/localisation":"gxvnc","../config/i18n":"i9CgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4RW9j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setCookie", ()=>setCookie);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
var _window = require("./window");
var _windowDefault = parcelHelpers.interopDefault(_window);
function setCookie(name, value) {
    (0, _windowDefault.default).document.cookie = `${name}=${value || ""}`;
}
function getCookie(name) {
    return `; ${(0, _windowDefault.default).document.cookie}`.split(`; ${name}=`).pop().split(";")[0];
}

},{"./window":"4IKui","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4IKui":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = window;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"318XE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBeta", ()=>isBeta);
parcelHelpers.export(exports, "isLocal", ()=>isLocal);
parcelHelpers.export(exports, "isGamma", ()=>isGamma);
parcelHelpers.export(exports, "isProd", ()=>isProd);
var _endpointConfig = require("./endpointConfig");
const isBeta = ()=>{
    const url = window.location.href;
    if (url.includes((0, _endpointConfig.URL_PREFIXES).BETA_URL_PREFIX)) return true;
    return false;
};
const isLocal = ()=>{
    const url = window.location.href;
    if (url.includes((0, _endpointConfig.URL_PREFIXES).LOCAL_URL_PREFIX)) return true;
    return false;
};
const isGamma = ()=>{
    const url = window.location.href;
    if (url.includes((0, _endpointConfig.URL_PREFIXES).GAMMA_URL_PREFIX)) return true;
    return false;
};
const isProd = ()=>{
    const url = window.location.href;
    if (url.includes((0, _endpointConfig.URL_PREFIXES).PROD_URL_PREFIX)) return true;
    return false;
};

},{"./endpointConfig":"5BcCr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5BcCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URL_PREFIXES", ()=>URL_PREFIXES);
const URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon",
    LOCAL_URL_PREFIX: "localhost"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxvnc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGUAGE_CODE_COOKIE_NAME", ()=>LANGUAGE_CODE_COOKIE_NAME);
parcelHelpers.export(exports, "LOCALE_LOCAL_STORAGE_KEY", ()=>LOCALE_LOCAL_STORAGE_KEY);
parcelHelpers.export(exports, "LANGUAGE_TOGGLE_UNSUPPORTED", ()=>LANGUAGE_TOGGLE_UNSUPPORTED);
const LANGUAGE_CODE_COOKIE_NAME = {
    BETA: "lc-tacbus",
    GAMMA: "lc-main",
    PROD: "lc-main"
};
const LOCALE_LOCAL_STORAGE_KEY = "defaultLocale";
const LANGUAGE_TOGGLE_UNSUPPORTED = "Only English language is supported for this page. Other language support for this page is coming soon.";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqqjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _authPortalFooterLinksPage = require("./components/AuthPortalFooterLinksPage");
var _authPortalFooterLinksPageDefault = parcelHelpers.interopDefault(_authPortalFooterLinksPage);
var _centeredLoader = require("./components/CenteredLoader");
var _centeredLoaderDefault = parcelHelpers.interopDefault(_centeredLoader);
var _navigationalRoutes = require("./config/navigationalRoutes");
var _routeConfig = require("./routeConfig");
var _routeConfigDefault = parcelHelpers.interopDefault(_routeConfig);
var _homePage = require("./pages/HomePage");
var _homePageDefault = parcelHelpers.interopDefault(_homePage);
exports.default = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Suspense), {
    fallback: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _centeredLoaderDefault.default), null)
}, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Switch), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Route), {
    exact: true,
    path: (0, _navigationalRoutes.HOME),
    component: (0, _homePageDefault.default)
}), (0, _routeConfigDefault.default).map(({ path, component })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Route), {
        path: path,
        component: component
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Route), {
    path: (0, _navigationalRoutes.AUTH_PORTAL_FOOTER_PATH),
    component: (0, _authPortalFooterLinksPageDefault.default)
}), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Route), {
    render: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Redirect), {
            to: (0, _navigationalRoutes.HOME)
        })
})));

},{"react":"6uln9","react-router-dom":"5fzqq","./components/AuthPortalFooterLinksPage":"dXgrt","./components/CenteredLoader":"8fWBA","./config/navigationalRoutes":"32s8M","./routeConfig":"9yJqt","./pages/HomePage":"z8QQE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXgrt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _navigationalRoutes = require("../config/navigationalRoutes");
var _privacyPage = require("../pages/PrivacyPage");
var _privacyPageDefault = parcelHelpers.interopDefault(_privacyPage);
var _termsAndConditionsPage = require("../pages/TermsAndConditionsPage");
var _termsAndConditionsPageDefault = parcelHelpers.interopDefault(_termsAndConditionsPage);
const AuthPortalFooterLinksPage = ()=>{
    const history = (0, _reactRouter.useHistory)();
    const location = (0, _reactRouter.useLocation)();
    const { pathname } = location;
    if (pathname.includes("condition")) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _termsAndConditionsPageDefault.default), null);
    if (pathname.includes("privacy")) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _privacyPageDefault.default), null);
    if (pathname.includes("forgot_pwd") || pathname.includes("/help/customer")) {
        window.location.href = (0, _navigationalRoutes.CUSTOMER_SERVICE_PAGE);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
    }
    history.push((0, _navigationalRoutes.HOME));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
};
exports.default = AuthPortalFooterLinksPage;

},{"react":"6uln9","react-router":"i3TiW","../config/navigationalRoutes":"32s8M","../pages/PrivacyPage":"i6Urd","../pages/TermsAndConditionsPage":"7ESC2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i6Urd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _privacyNotice = require("../components/PrivacyNotice");
var _privacyNoticeDefault = parcelHelpers.interopDefault(_privacyNotice);
var _indexCss = require("../styles/index.css");
const PrivacyPage = ()=>{
    const pageRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        pageRef.current.scrollIntoView();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: pageRef,
        style: {
            position: "relative",
            backgroundColor: "#f3f3f3",
            height: "100%",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        alignmentHorizontal: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        maxWidth: (0, _breakpoints.DEVICE_WIDTHS).DESKTOP,
        type: "outline",
        backgroundColor: "white",
        spacingInset: "large large large large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _privacyNoticeDefault.default), null))));
};
exports.default = PrivacyPage;

},{"@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/meridian/column":"jFRKf","react":"6uln9","../components/PrivacyNotice":"ghvIX","../styles/index.css":"bnaDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ghvIX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emotion = require("emotion");
var _marked = require("marked");
var _heading = require("@amzn/meridian/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _box = require("@amzn/meridian/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _divider = require("@amzn/meridian/divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _privacyNotice = require("../constants/privacyNotice");
var _conditionOfUsePrivacyNoticePopup = require("./molecules/ConditionOfUsePrivacyNoticePopup");
var _conditionOfUsePrivacyNoticePopupDefault = parcelHelpers.interopDefault(_conditionOfUsePrivacyNoticePopup);
var _spanButton = require("./atoms/SpanButton");
var _spanButtonDefault = parcelHelpers.interopDefault(_spanButton);
var _common = require("../constants/common");
var _analytics1 = require("../constants/analytics");
const PrivacyNotice = ()=>{
    const [translationPopupOpen, setTranslationPopupOpen] = (0, _react.useState)(false);
    const [popupContent, setPopupContent] = (0, _react.useState)("");
    const onTranslationPopupOpen = (locale, country)=>{
        setPopupContent((0, _marked.marked).parse((0, _privacyNotice.privacyNoticeContentCountryMap)[country][locale]));
        setTranslationPopupOpen(true);
    };
    const onTranslationPopupClose = ()=>{
        setPopupContent("");
        setTranslationPopupOpen(false);
    };
    const euPrivacyNoticeRef = (0, _react.useRef)();
    const usPrivacyNoticeRef = (0, _react.useRef)();
    const auPrivacyNoticeRef = (0, _react.useRef)();
    const caPrivacyNoticeRef = (0, _react.useRef)();
    const aePrivacyNoticeRef = (0, _react.useRef)();
    const brPrivacyNoticeRef = (0, _react.useRef)();
    const inPrivacyNoticeRef = (0, _react.useRef)();
    const mxPrivacyNoticeRef = (0, _react.useRef)();
    const countryRefMap = {
        [(0, _common.COUNTRY_MAP).EU]: euPrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).US]: usPrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).AU]: auPrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).CA]: caPrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).AE]: aePrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).BR]: brPrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).IN]: inPrivacyNoticeRef,
        [(0, _common.COUNTRY_MAP).MX]: mxPrivacyNoticeRef
    };
    const onPrivacyNoticeNavButtonLink = (type)=>{
        if (countryRefMap[type].current?.scrollIntoView) countryRefMap[type].current.scrollIntoView({
            behavior: "smooth"
        });
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.PRIVACY_BUTTON_REGION)
            },
            extra_properties: {
                name: type
            }
        });
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _conditionOfUsePrivacyNoticePopupDefault.default), {
        innerHtmlBodyContent: popupContent,
        open: translationPopupOpen,
        modalTitle: "Privacy Notice",
        onClose: onTranslationPopupClose
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("article", {
        className: (0, _emotion.css)`
          & {
            font-family: AmazonEmber-Regular, Amazon Ember;
          }
        `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        level: 1,
        type: "d50",
        className: (0, _emotion.css)`
            font-weight: 400 !important;
          `
    }, "Privacy Notice"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0"
    }, Object.keys((0, _privacyNotice.privacyNoticeTitle)).map((type)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            className: (0, _emotion.css)`
                  & {
                    padding: 4px;
                  }
                `,
            type: "link",
            onClick: ()=>onPrivacyNoticeNavButtonLink(type)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[type]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: euPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).EU])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "September 19, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "French")), "Les Politique de Confidentialit\xe9 d'Amazon Carrier Logistics sont disponibles ci-dessous en anglais. Vous trouverez \xe9galement des liens vers les traductions", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR)
    }, "en fran\xe7ais"), ",", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES)
    }, "en espagnol"), " ", "et", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).IT_IT)
    }, "en italien"), " ", "de ces documents. En cas de conflit ou de divergence entre une version traduite de ces Politique de Confidentialit\xe9 et la version anglaise, la version anglaise pr\xe9vaut."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Italian")), "Le le informazioni sulla privacy (Informativa sulla Privacy) di Amazon Carrier Logistics sono riportate di seguito in inglese. Vengono inoltre forniti i link alle traduzioni in lingua", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR)
    }, "francese"), ",", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES)
    }, "spagnola"), " ", "e", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).IT_IT)
    }, "italiana"), ". In caso di conflitto o discrepanza tra una versione tradotta dell\u2019Informativa sulla Privacy e la versione in lingua inglese, prevale la versione in lingua inglese."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Spanish")), "El Aviso de Privacidad de Amazon Carrier Logistics se presentan a continuaci\xf3n en Ingl\xe9s. Nosotros tambi\xe9n proporcionamos enlaces a las traducciones en", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR)
    }, "Franc\xe9s"), ",", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES)
    }, "Espa\xf1ol"), " ", "e", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).IT_IT)
    }, "Italiano"), ". En caso de discrepancia entre una versi\xf3n traducida de este Aviso de Privacidad y la versi\xf3n en Ingl\xe9s, esta \xfaltima prevalecer\xe1."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "English")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.euPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: usPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).US])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "September 19, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.usPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: auPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).AU])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "October 18, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.auPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: caPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).CA])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "December 28, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.caPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: aePrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).AE])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "February 28, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.aePrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: brPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).BR])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "March 14, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.brPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: inPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).IN])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "February 12, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.inPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: mxPrivacyNoticeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _privacyNotice.privacyNoticeTitle)[(0, _common.COUNTRY_MAP).MX])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "March 26, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked).parse((0, _privacyNotice.mxPrivacyNotice)[(0, _common.LOCALES_MAP).EN_US])
        }
    }))));
};
exports.default = PrivacyNotice;

},{"react":"6uln9","emotion":"1BAMo","marked":"aMa9j","@amzn/meridian/heading":"8qIYS","@amzn/meridian/box":"dxZXY","@amzn/meridian/row":"ba4AQ","@amzn/meridian/button":"k0QSK","@amzn/meridian/divider":"1prIe","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","../constants/privacyNotice":"2xzqL","./molecules/ConditionOfUsePrivacyNoticePopup":"kg9Nq","./atoms/SpanButton":"1ifmR","../constants/common":"4gLZS","../constants/analytics":"zH2LJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMa9j":[function(require,module,exports) {
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function getDefaults() {
        return {
            async: false,
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: "",
            highlight: null,
            hooks: null,
            langPrefix: "language-",
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    exports1.defaults = getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = new RegExp(escapeTest.source, "g");
    var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    var escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    /**
   * @param {string} html
   */ function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    var caret = /(^|[^\[])\^/g;
    /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */ function edit(regex, opt) {
        regex = typeof regex === "string" ? regex : regex.source;
        opt = opt || "";
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, "$1");
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */ function cleanUrl(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, "").toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    /**
   * @param {string} base
   * @param {string} href
   */ function resolveUrl(base, href) {
        if (!baseUrls[" " + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[" " + base] = base + "/";
            else baseUrls[" " + base] = rtrim(base, "/", true);
        }
        base = baseUrls[" " + base];
        var relativeBase = base.indexOf(":") === -1;
        if (href.substring(0, 2) === "//") {
            if (relativeBase) return href;
            return base.replace(protocol, "$1") + href;
        } else if (href.charAt(0) === "/") {
            if (relativeBase) return href;
            return base.replace(domain, "$1") + href;
        } else return base + href;
    }
    var noopTest = {
        exec: function noopTest() {}
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        var i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    }
    /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */ function rtrim(str, c, invert) {
        var l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        var suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    // copied from https://stackoverflow.com/a/5450113/806777
    /**
   * @param {string} pattern
   * @param {number} count
   */ function repeatString(pattern, count) {
        if (count < 1) return "";
        var result = "";
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    function outputLink(cap, link, raw, lexer) {
        var href = link.href;
        var title = link.title ? escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            var token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split("\n").map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
   * Tokenizer
   */ var Tokenizer = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, "$1") : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *>[ \t]?/gm, "");
                var top = this.lexer.state.top;
                this.lexer.state.top = true;
                var tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: "blockquote",
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
                var bull = cap[1].trim();
                var isordered = bull.length > 1;
                var list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[	 ][^\\n]*)?(?:\\n|$))");
                // Check if current bullet point can start a new List Item
                while(src){
                    endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    line = cap[2].split("\n", 1)[0].replace(/^\t+/, function(t) {
                        return " ".repeat(3 * t.length);
                    });
                    nextLine = src.split("\n", 1)[0];
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimLeft();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        // Items begin with at most one blank line
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))");
                        var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
                        var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
                        var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");
                        // Check if following lines should be included in List Item
                        while(src){
                            rawLine = src.split("\n", 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) // Dedent if possible
                            itemContents += "\n" + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) // Check if current line is blank
                            blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimRight();
                list.items[list.items.length - 1].text = itemContents.trimRight();
                list.raw = list.raw.trimRight();
                var l = list.items.length;
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(i = 0; i < l; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        var spacers = list.items[i].tokens.filter(function(t) {
                            return t.type === "space";
                        });
                        var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                            return /\n.*\n/.test(t.raw);
                        });
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(i = 0; i < l; i++)list.items[i].loose = true;
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) {
                var token = {
                    type: "html",
                    raw: cap[0],
                    pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
                    text: cap[0]
                };
                if (this.options.sanitize) {
                    var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
                    token.type = "paragraph";
                    token.text = text;
                    token.tokens = this.lexer.inline(text);
                }
                return token;
            }
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                var tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                var href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "";
                var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: "table",
                    header: splitCells(cap[1]).map(function(c) {
                        return {
                            text: c
                        };
                    }),
                    align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i, j, k, row;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = "right";
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = "center";
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = "left";
                        else item.align[i] = null;
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map(function(c) {
                        return {
                            text: c
                        };
                    });
                    // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                    // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                    }
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                var text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        };
        _proto.escape = function escape$1(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: escape(cap[1])
            };
        };
        _proto.tag = function tag(src) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: this.options.sanitize ? "text" : "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                var href = cap[2];
                var title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                    title: title ? title.replace(this.rules.inline._escapes, "$1") : title
                }, cap[0], this.lexer);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, " ");
                link = links[link.toLowerCase()];
                if (!link) {
                    var text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = "";
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || "";
            if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        var _text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: _text,
                            tokens: this.lexer.inlineTokens(_text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    var text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, " ");
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === "@") {
                    text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === "@") {
                    text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (this.lexer.state.inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
                else text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    /**
   * Block-Level Grammar
   */ var block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block.normal = _extends({}, block);
    /**
   * GFM Block Grammar
   */ block.gfm = _extends({}, block.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("table", block.gfm.table) // interrupt paragraphs with table
    .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block.pedantic = _extends({}, block.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: "reflink|nolink(?!\\()",
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
            rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    };
    // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    // lookbehind is not available on Safari as of version 16
    // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
    inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
    inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "g").replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline.normal = _extends({}, inline);
    /**
   * Pedantic Inline Grammar
   */ inline.pedantic = _extends({}, inline.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline.gfm = _extends({}, inline.normal, {
        escape: edit(inline.escape).replace("])", "~|])").getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline.breaks = _extends({}, inline.gfm, {
        br: edit(inline.br).replace("{2,}", "*").getRegex(),
        text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    /**
   * smartypants text replacement
   * @param {string} text
   */ function smartypants(text) {
        return text// em-dashes
        .replace(/---/g, "\u2014")// en-dashes
        .replace(/--/g, "\u2013")// opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")// closing singles & apostrophes
        .replace(/'/g, "\u2019")// opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")// closing doubles
        .replace(/"/g, "\u201D")// ellipses
        .replace(/\.{3}/g, "\u2026");
    }
    /**
   * mangle email addresses
   * @param {string} text
   */ function mangle(text) {
        var out = "", i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = "x" + ch.toString(16);
            out += "&#" + ch + ";";
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        } /**
     * Static Lex Inline Method
     */ ;
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        } /**
     * Preprocessing
     */ ;
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, "\n");
            this.blockTokens(src, this.tokens);
            var next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        } /**
     * Lexing
     */ ;
        _proto.blockTokens = function blockTokens(src, tokens) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
            else src = src.replace(/^( *)(\t+)/gm, function(_, leading, tabs) {
                return leading + "    ".repeat(tabs.length);
            });
            var token, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        };
        _proto.inline = function inline(src, tokens) {
            if (tokens === void 0) tokens = [];
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        } /**
     * Lexing/Compiling
     */ ;
        _proto.inlineTokens = function inlineTokens(src, tokens) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            var token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null){
                maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
                this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
            }
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this2
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    /**
   * Renderer
   */ var Renderer = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || "").match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? _code : escape(_code, true)) + "</code></pre>\n";
            return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + "</code></pre>\n";
        } /**
     * @param {string} quote
     */ ;
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        } /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */ ;
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) {
                var id = this.options.headerPrefix + slugger.slug(raw);
                return "<h" + level + ' id="' + id + '">' + text + "</h" + level + ">\n";
            }
            // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        } /**
     * @param {string} text
     */ ;
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
        } /**
     * @param {string} text
     */ ;
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        } /**
     * @param {string} header
     * @param {string} body
     */ ;
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        } /**
     * @param {string} content
     */ ;
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? "th" : "td";
            var tag = flags.align ? "<" + type + ' align="' + flags.align + '">' : "<" + type + ">";
            return tag + content + ("</" + type + ">\n");
        } /**
     * span level renderer
     * @param {string} text
     */ ;
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        } /**
     * @param {string} text
     */ ;
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        } /**
     * @param {string} text
     */ ;
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? "<br/>" : "<br>";
        } /**
     * @param {string} text
     */ ;
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<img src="' + href + '" alt="' + text + '"';
            if (title) out += ' title="' + title + '"';
            out += this.options.xhtml ? "/>" : ">";
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return "" + text;
        };
        _proto.image = function image(href, title, text) {
            return "" + text;
        };
        _proto.br = function br() {
            return "";
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        /**
     * @param {string} value
     */ var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim()// remove html tags
            .replace(/<[!\/a-z].*?>/ig, "")// remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
        } /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */ ;
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + "-" + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        } /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */ ;
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    /**
   * Parsing & Compiling
   */ var Parser = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer();
            this.slugger = new Slugger();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        } /**
     * Static Parse Inline Method
     */ ;
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        } /**
     * Parse Loop
     */ ;
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = "", i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case "code":
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case "table":
                        header = "";
                        // header
                        cell = "";
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = "";
                        l2 = token.rows.length;
                        for(j = 0; j < l2; j++){
                            row = token.rows[j];
                            cell = "";
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case "blockquote":
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case "list":
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = "";
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = "";
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: "text",
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case "html":
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case "text":
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === "text"){
                            token = tokens[++i];
                            body += "\n" + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        } /**
     * Parse Inline Tokens
     */ ;
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = "", i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        out += renderer.text(token.text);
                        break;
                    case "html":
                        out += renderer.html(token.text);
                        break;
                    case "link":
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case "image":
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case "strong":
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case "em":
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case "codespan":
                        out += renderer.codespan(token.text);
                        break;
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case "text":
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Hooks = /*#__PURE__*/ function() {
        function Hooks(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Hooks.prototype;
        /**
     * Process markdown before marked
     */ _proto.preprocess = function preprocess(markdown) {
            return markdown;
        } /**
     * Process HTML after marked is finished
     */ ;
        _proto.postprocess = function postprocess(html) {
            return html;
        };
        return Hooks;
    }();
    Hooks.passThroughHooks = new Set([
        "preprocess",
        "postprocess"
    ]);
    function onError(silent, async, callback) {
        return function(e) {
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                var msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                if (callback) {
                    callback(null, msg);
                    return;
                }
                return msg;
            }
            if (async) return Promise.reject(e);
            if (callback) {
                callback(e);
                return;
            }
            throw e;
        };
    }
    function parseMarkdown(lexer, parser) {
        return function(src, opt, callback) {
            if (typeof opt === "function") {
                callback = opt;
                opt = null;
            }
            var origOpt = _extends({}, opt);
            opt = _extends({}, marked.defaults, origOpt);
            var throwError = onError(opt.silent, opt.async, callback);
            // throw error in case of non string input
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            checkSanitizeDeprecation(opt);
            if (opt.hooks) opt.hooks.options = opt;
            if (callback) {
                var highlight = opt.highlight;
                var tokens;
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    tokens = lexer(src, opt);
                } catch (e) {
                    return throwError(e);
                }
                var done = function done(err) {
                    var out;
                    if (!err) try {
                        if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                        out = parser(tokens, opt);
                        if (opt.hooks) out = opt.hooks.postprocess(out);
                    } catch (e) {
                        err = e;
                    }
                    opt.highlight = highlight;
                    return err ? throwError(err) : callback(null, out);
                };
                if (!highlight || highlight.length < 3) return done();
                delete opt.highlight;
                if (!tokens.length) return done();
                var pending = 0;
                marked.walkTokens(tokens, function(token) {
                    if (token.type === "code") {
                        pending++;
                        setTimeout(function() {
                            highlight(token.text, token.lang, function(err, code) {
                                if (err) return done(err);
                                if (code != null && code !== token.text) {
                                    token.text = code;
                                    token.escaped = true;
                                }
                                pending--;
                                if (pending === 0) done();
                            });
                        }, 0);
                    }
                });
                if (pending === 0) done();
                return;
            }
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src) {
                return lexer(src, opt);
            }).then(function(tokens) {
                return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function() {
                    return tokens;
                }) : tokens;
            }).then(function(tokens) {
                return parser(tokens, opt);
            }).then(function(html) {
                return opt.hooks ? opt.hooks.postprocess(html) : html;
            })["catch"](throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                var _tokens = lexer(src, opt);
                if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
                var html = parser(_tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    /**
   * Marked
   */ function marked(src, opt, callback) {
        return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        marked.defaults = _extends({}, marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = exports1.defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args.forEach(function(pack) {
            // copy options to new object
            var opts = _extends({}, pack);
            // set async to true if it was set to true before
            opts.async = marked.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error("extension name required");
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) (function() {
                var hooks = marked.defaults.hooks || new Hooks();
                var _loop3 = function _loop3(prop) {
                    var prevHook = hooks[prop];
                    if (Hooks.passThroughHooks.has(prop)) hooks[prop] = function(arg) {
                        if (marked.defaults.async) return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function(ret) {
                            return prevHook.call(hooks, ret);
                        });
                        var ret = pack.hooks[prop].call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[prop] = function() {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        var ret = pack.hooks[prop].apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                };
                for(var prop in pack.hooks)_loop3(prop);
                opts.hooks = hooks;
            })();
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var _walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    var values = [];
                    values.push(pack.walkTokens.call(this, token));
                    if (_walkTokens) values = values.concat(_walkTokens.call(this, token));
                    return values;
                };
            }
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var values = [];
        var _loop4 = function _loop4() {
            var token = _step.value;
            values = values.concat(callback.call(marked, token));
            switch(token.type){
                case "table":
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        values = values.concat(marked.walkTokens(cell.tokens, callback));
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            values = values.concat(marked.walkTokens(_cell.tokens, callback));
                        }
                    }
                    break;
                case "list":
                    values = values.concat(marked.walkTokens(token.items, callback));
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        values = values.concat(marked.walkTokens(token[childTokens], callback));
                    });
                    else if (token.tokens) values = values.concat(marked.walkTokens(token.tokens, callback));
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop4();
        return values;
    };
    /**
   * Parse Inline
   * @param {string} src
   */ marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.Hooks = Hooks;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = Parser.parse;
    var lexer = Lexer.lex;
    exports1.Hooks = Hooks;
    exports1.Lexer = Lexer;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.Slugger = Slugger;
    exports1.TextRenderer = TextRenderer;
    exports1.Tokenizer = Tokenizer;
    exports1.getDefaults = getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});

},{}],"8qIYS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("438f81f1e1ea5c39");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _heading = _interopRequireDefault(require("c4b5c5a5b4a7e50f"));
var _default = _heading["default"];
exports["default"] = _default;

},{"438f81f1e1ea5c39":"5qxSW","c4b5c5a5b4a7e50f":"iszix"}],"iszix":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("28d0c3d397adc9b5");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("11df0b796ddb27b4"));
var _propTypes = _interopRequireDefault(require("dcf070447aa48ca1"));
var _text = _interopRequireDefault(require("1d95907dfa11c1aa"));
function Heading(props) {
    return /*#__PURE__*/ _react["default"].createElement(_text["default"], {
        type: props.type ? props.type : "h".concat(7 - props.level, "00"),
        tag: "h".concat(props.level),
        id: props.id,
        color: props.color,
        alignment: props.alignment,
        transform: props.transform,
        truncate: props.truncate,
        fontFamily: props.fontFamily,
        className: props.className
    }, props.children);
}
Heading.propTypes = {};
var _default = Heading;
exports["default"] = _default;

},{"28d0c3d397adc9b5":"5qxSW","11df0b796ddb27b4":"6uln9","dcf070447aa48ca1":"9Mqtv","1d95907dfa11c1aa":"hj2bM"}],"1prIe":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("64d73d9937ab3fad");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _divider = _interopRequireDefault(require("31037c8a673a73fc"));
var _default = _divider["default"];
exports["default"] = _default;

},{"64d73d9937ab3fad":"5qxSW","31037c8a673a73fc":"18IpR"}],"18IpR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("60c185002f8cc5db");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("79dee477b0882ae1"));
var _propTypes = _interopRequireDefault(require("f7eb6616cb973fe8"));
var _emotion = require("92bdd232b8f560eb");
var _spacing = _interopRequireDefault(require("6504286ca4a28043"));
var _divider = _interopRequireDefault(require("590bc10183491803"));
var _theme = require("8c5b7d5c301a59bd");
var _token = require("5006fbb9712ce847");
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, spacingBefore = _ref.spacingBefore, spacingAfter = _ref.spacingAfter;
    return (0, _emotion.css)({
        width: "100%",
        height: t("size", size),
        // min-height protects against parent styling that might
        // squash the "normal" height with margins and flex (like Column)
        minHeight: t("size", size),
        backgroundColor: t("color"),
        marginTop: (0, _token.getToken)(_spacing["default"], "spacing", spacingBefore),
        marginBottom: (0, _token.getToken)(_spacing["default"], "spacing", spacingAfter),
        border: "none"
    });
}, [
    "size",
    "spacingBefore",
    "spacingAfter"
]);
function Divider(props) {
    var t = (0, _theme.useTheme)(_divider["default"], "divider");
    return /*#__PURE__*/ _react["default"].createElement("hr", {
        className: styles(t, props)
    });
}
Divider.propTypes = {};
Divider.defaultProps = {
    size: "medium",
    spacingBefore: "none",
    spacingAfter: "none"
};
var _default = Divider;
exports["default"] = _default;

},{"60c185002f8cc5db":"5qxSW","79dee477b0882ae1":"6uln9","f7eb6616cb973fe8":"9Mqtv","92bdd232b8f560eb":"1BAMo","6504286ca4a28043":"8D3is","590bc10183491803":"ev5H1","8c5b7d5c301a59bd":"dJlcb","5006fbb9712ce847":"bebc4"}],"ev5H1":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        dividerColor: tokens.themeBorderSecondaryDefault,
        dividerSizeSmall: 1,
        dividerSizeMedium: 2,
        dividerSizeLarge: 4,
        dividerSizeXlarge: 8
    };
};

},{}],"2xzqL":[function(require,module,exports) {
/* eslint-disable no-irregular-whitespace */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "euPrivacyNotice", ()=>euPrivacyNotice);
parcelHelpers.export(exports, "usPrivacyNotice", ()=>usPrivacyNotice);
parcelHelpers.export(exports, "auPrivacyNotice", ()=>auPrivacyNotice);
parcelHelpers.export(exports, "caPrivacyNotice", ()=>caPrivacyNotice);
parcelHelpers.export(exports, "aePrivacyNotice", ()=>aePrivacyNotice);
parcelHelpers.export(exports, "inPrivacyNotice", ()=>inPrivacyNotice);
parcelHelpers.export(exports, "brPrivacyNotice", ()=>brPrivacyNotice);
parcelHelpers.export(exports, "mxPrivacyNotice", ()=>mxPrivacyNotice);
parcelHelpers.export(exports, "privacyNoticeTitle", ()=>privacyNoticeTitle);
parcelHelpers.export(exports, "privacyNoticeContentCountryMap", ()=>privacyNoticeContentCountryMap);
var _common = require("./common");
const euPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.

Any personal information provided to or to be gathered by Carrier Logistics is controlled by Amazon EU Sarl the data controller, of 38 Avenue John F. Kennedy, Luxembourg, 1855, Luxembourg.

We receive, use and store any information you provide to Carrier Logistics through your use of this site. We maintain physical, electronic and procedural safeguards in connection with the collection, storage and disclosure of your information.

We use your information to process your application and to communicate with you. We share your information only as described in this Privacy Notice and with Amazon (who are either subject to this Privacy Notice or follow practices at least as protective as those described in this Privacy Notice). We may also release information when we believe it is appropriate to comply with the law; to enforce or apply our Conditions of Use; to protect the rights, property or safety of Carrier Logistics, our users or others; or to conduct background checks with third party companies which are not within Amazon. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction; however, this does not include selling, renting, sharing or otherwise disclosing your information for commercial or marketing purposes.

Carrier Logistics complies with applicable laws implementing the so-called \u{2018}EU Cookies Directive\u{2019}. Using this site with your browser settings adjusted to accept cookies tells us that you consent to our use of cookies but we only use cookies which we consider to be strictly necessary. The \u{2018}Help\u{2019} feature on most browsers will tell you how to prevent your browser from accepting new cookies, how to have the browser notify you when you receive a new cookie and how to disable cookies altogether.

Our business changes constantly and our Privacy Notice and Conditions of Use may also change. You should check our site frequently to see any recent changes.

For questions on this Privacy Notice, please contact the company at the address given above.
        `,
    [(0, _common.LOCALES_MAP).IT_IT]: `
17 luglio 2022

Carrier Logistics sa che avete a cuore il modo in cui i dati che vi riguardano vengono utilizzati e condivisi, e apprezziamo la vostra fiducia sul fatto che lo faremo in modo attento e avveduto.

Qualsiasi dato personale fornito a o raccolto da Carrier Logistics \xe8 trattato da Amazon EU Sarl, il titolare del trattamento, con sede al n. 38 di Avenue John F. Kennedy, Luxembourg, 1855, Luxembourg.

Riceviamo, trattiamo e conserviamo tutti i dati forniti a Carrier Logistics attraverso l'utilizzo di questo sito. Adottiamo misure di sicurezza fisiche, elettroniche e procedurali per la raccolta, la conservazione e la diffusione dei dati personali.

Utilizziamo i dati dell'utente per l'elaborazione delle sue richieste e per le comunicazioni. Condividiamo i dati dell'utente solo come descritto nella presente Informativa sulla privacy e con Amazon (che \xe8 soggetta a questa stessa Informativa sulla privacy o adotta misure che garantiscono una protezione di livello almeno pari a quello descritto nella presente Informativa sulla privacy). Potremmo, inoltre, rendere pubblici i dati qualora lo ritenessimo opportuno per rispettare la legge, applicare o far rispettare le nostre Condizioni Generali d\u{2019}Uso, proteggere i diritti, la propriet\xe0 o la sicurezza di Carrier Logistics, dei nostri utenti o di terze parti o condurre controlli sui precedenti con societ\xe0 terze che non fanno parte di Amazon. Ci\xf2 include lo scambio di dati con altre societ\xe0 e organizzazioni per la protezione dalle frodi e la riduzione del rischio di credito. Ci\xf2 non include tuttavia la vendita, il noleggio, la condivisione o la divulgazione dei dati per scopi commerciali o di marketing.

Carrier Logistics rispetta le leggi applicabili che implementano la cosiddetta "Direttiva UE sui cookie". Utilizzando questo sito attraverso un browser con le impostazioni dei cookie attive, acconsenti al nostro utilizzo dei cookie, il quale \xe8 limitato a quelli che riteniamo strettamente necessari. Attraverso la funzione "Aiuto" sulla maggior parte dei browser l'utente potr\xe0 evitare che questo accetti nuovi cookie, essere avvisato quando ne riceve di nuovi o disabilitare completamente i cookie.

La nostra attivit\xe0 cambia costantemente e anche la nostra Informativa sulla privacy e le Condizioni Generali d'Uso possono cambiare. Controlla frequentemente il sito per scoprire eventuali modifiche recenti.

Per domande sulla presente Informativa sulla privacy, contatta l'azienda all'indirizzo specificato sopra.
        `,
    [(0, _common.LOCALES_MAP).FR_FR]: `
  17 juillet 2023

Carrier Logistics sait que vous vous souciez de la mani\xe8re dont vos informations personnelles sont utilis\xe9es et partag\xe9es, et nous vous remercions de la confiance que vous nous accordez pour les utiliser de mani\xe8re raisonnable.

Toutes les informations personnelles fournies ou devant \xeatre collect\xe9es par Carrier Logistics sont trait\xe9es par Amazon EU Sarl, le responsable du traitement, 38 Avenue John F. Kennedy, Luxembourg, 1855, Luxembourg.

Nous recevons, utilisons et stockons toutes les informations que vous fournissez \xe0 Carrier Logistics dans le cadre de votre utilisation de ce site. Nous mettons en place des mesures de s\xe9curit\xe9 physiques, \xe9lectroniques et proc\xe9durales en lien avec la collecte, la conservation et la divulgation des informations personnelles des clients.

Nous utilisons vos informations pour traiter votre demande et communiquer avec vous. Nous partageons vos informations uniquement comme d\xe9crit dans la pr\xe9sente politique de confidentialit\xe9 et avec Amazon (qui est soit soumis \xe0 la pr\xe9sente politique de confidentialit\xe9, soit suit des pratiques au moins aussi protectrices que celles d\xe9crites dans la pr\xe9sente politique de confidentialit\xe9). Nous pouvons \xe9galement divulguer des informations lorsque nous pensons que cela est appropri\xe9 pour nous conformer \xe0 la loi, pour faire respecter ou appliquer nos Conditions d\u{2019}utilisation, pour prot\xe9ger les droits, la propri\xe9t\xe9 ou la s\xe9curit\xe9 de Carrier Logistics, de nos utilisateurs ou d\u{2019}autres personnes, ou pour effectuer des v\xe9rifications d\u{2019}ant\xe9c\xe9dents aupr\xe8s de soci\xe9t\xe9s tierces qui ne font pas partie d\u{2019}Amazon. Cela inclut l'\xe9change d'informations avec d'autres soci\xe9t\xe9s et organisations pour la protection contre la fraude et la r\xe9duction du risque en mati\xe8re de cr\xe9dit ; toutefois, cela n'inclut pas la vente, la location, le partage ou toute autre divulgation de vos informations \xe0 des fins commerciales ou marketing.

Carrier Logistics se conforme aux lois applicables mettant en \u{153}uvre la \xab directive europ\xe9enne sur les cookies \xbb. L'utilisation de ce site avec les param\xe8tres de votre navigateur r\xe9gl\xe9s pour accepter les cookies nous indique que vous acceptez notre utilisation des cookies, mais nous n'utilisons que les cookies que nous consid\xe9rons comme strictement n\xe9cessaires. La fonction \xab Aide \xbb de la plupart des navigateurs vous indiquera comment emp\xeacher votre navigateur d'accepter de nouveaux cookies, comment demander au navigateur de vous avertir lorsque vous recevez un nouveau cookie et comment d\xe9sactiver compl\xe8tement les cookies.

Nos activit\xe9s \xe9voluent constamment et notre politique de confidentialit\xe9 et nos Conditions d\u{2019}utilisation peuvent \xe9galement changer. Nous vous invitons \xe0 consulter fr\xe9quemment notre site pour prendre connaissance des modifications r\xe9centes.

Pour toute question sur la pr\xe9sente politique de confidentialit\xe9, contactez la soci\xe9t\xe9 \xe0 l'adresse indiqu\xe9e ci-dessus.
`,
    [(0, _common.LOCALES_MAP).ES_ES]: `
  17 de julio de 2023

Aviso de Privacidad

Carrier Logistics entiende tu preocupaci\xf3n por c\xf3mo se utiliza y se comparte tu informaci\xf3n personal y te agradecemos que  conf\xedes en que  trataremos tus datos de forma cuidadosa y con\u{FB01}dencial.

Cualquier informaci\xf3n personal facilitada a Carrier Logistics o que  este vaya a recopilar est\xe1 controlada por Amazon  EU Sarl, el responsable del tratamiento, de 38 Avenue  John  F. Kennedy, Luxemburgo, 1855, Luxemburgo.

Recibimos, utilizamos y almacenamos cualquier informaci\xf3n que  proporciones a Carrier Logistics a trav\xe9s del uso de este sitio. Contamos con sistemas de seguridad f\xedsicos, electr\xf3nicos y de procedimientos en la recogida, almacenamiento y divulgaci\xf3n de tus datos personales.

Usamos tus datos para  tramitar tu solicitud y comunicarnos contigo. Compartimos tus datos solo como  se describe en este Aviso de Privacidad y con Amazon  (que est\xe1 sujeta a este Aviso de Privacidad o sigue  pr\xe1cticas que  son, al menos, tan protectoras como  las descritas en este Aviso de Privacidad). Tambi\xe9n divulgamos informaci\xf3n cuando lo consideramos necesario para  cumplir con la ley; ejecutar o aplicar  nuestras Condiciones de Uso; para  proteger los derechos, la propiedad y la seguridad de Carrier Logistics, nuestros usuarios u otras partes interesadas, o para  llevar a cabo  comprobaciones de antecedentes con terceros que  no forman parte de Amazon.  Entre estas cuestiones se encuentran el intercambio de informaci\xf3n con otras empresas y organizaciones para  evitar fraudes y estafas y reducir el riesgo de sufrir impagos; sin embargo, no se incluyen la venta, el alquiler, el intercambio u otro tipo de revelaci\xf3n de tus datos personales con \u{FB01}nes  comerciales o mercadot\xe9cnicos.

Carrier Logistics cumple con la legislaci\xf3n pertinente mediante la que  se transpone la denominada \u{201C}Directiva de cookies de la UE\u{201D}. Al utilizar este sitio web con el navegador con\u{FB01}gurado para  aceptar las cookies,  comunicas que  nos autorizas a utilizar cookies,  pero solo usaremos aquellas que  consideremos estrictamente necesarias. La funcionalidad de ayuda de la mayor\xeda de los navegadores te indicar\xe1 c\xf3mo  evitar que  tu navegador acepte nuevas cookies,  c\xf3mo  hacer que  el navegador te avise cuando reciba  una  nueva cookie y c\xf3mo  deshabilitar las cookies por completo.

Nuestras operaciones y actividades comerciales est\xe1n en continuo cambio y nuestro Aviso de Privacidad y nuestras Condiciones de Uso tambi\xe9n pueden sufrir modi\u{FB01}caciones. Debes  consultar peri\xf3dicamente nuestro sitio web para  saber si ha habido alg\xfan cambio reciente.

Si tienes preguntas sobre este Aviso de Privacidad, ponte en contacto con la empresa en la direcci\xf3n indicada arriba.
  `
};
const usPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.

If you have an account on www.amazon.com and an Amazon.com cookie, information gathered by Carrier Logistics may be correlated with any personally identifiable information that Amazon has and used by Carrier Logistics and Amazon to improve the services we offer.

Carrier Logistics follows the same information practices as Amazon, and information we collect is subject to the Amazon\xa0[Privacy Notice](https://www.amazon.com/gp/help/customer/display.html?nodeId=468496). By visiting our site, you are accepting the practices described in the Amazon\xa0[Privacy Notice](https://www.amazon.com/gp/help/customer/display.html?nodeId=468496). 
  `
};
const auPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.

If you have an account on www.amazon.com and an Amazon.com cookie, information gathered by Carrier Logistics may be correlated with any personally identifiable information that Amazon has and used by Carrier Logistics and Amazon to improve the services we offer.

Carrier Logistics follows the same information practices as Amazon, and information we collect, use, disclose and otherwise handle is subject to the Amazon\xa0[Privacy Notice](https://www.amazon.com/gp/help/customer/display.html?nodeId=468496). By visiting our site and/or providing us with your personal information, you are accepting the practices described in the Amazon\xa0[Privacy Notice](https://www.amazon.com/gp/help/customer/display.html?nodeId=468496). 
  `
};
const caPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly\.

If you have an account on www\.Amazon\.com\.ca and an Amazon\.com cookie, information gathered by Carrier Logistics may be correlated with any personally identifiable information that Amazon has and used by Carrier Logistics and Amazon to improve the services we offer\.

Carrier Logistics follows the same information practices as Amazon\.com\.ca, and information we collect is subject to the Amazon [Privacy Notice](https://www.amazon.ca/gp/help/customer/display.html?nodeId=201909010)\. By visiting our site, you are accepting the practices described in the Amazon [Privacy Notice](https://www.amazon.ca/gp/help/customer/display.html?nodeId=201909010)\.
  `
};
const aePrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.

If you have an account on www.amazon.ae and an Amazon.com cookie, information gathered by Carrier Logistics may be correlated with any personally identifiable information that Amazon has and used by Carrier Logistics and Amazon to improve the services we offer.

Carrier Logistics follows the same information practices as Amazon, and information we collect, use, disclose and otherwise handle is subject to the Amazon [Privacy Notice](https://www.amazon.ae/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy). By visiting our site and/or providing us with your personal information, you are accepting the practices described in the Amazon [Privacy Notice](https://www.amazon.ae/gp/help/customer/display.html?nodeId=201909010&ref_=footer_privacy).`
};
const inPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `We at Carrier Logistics, know that you care about your personal data, and how it is used and shared, and we appreciate your trust that we will do so carefully and sensibly\. This Privacy Notice will help you understand what personal data we collect, why we collect it and how we use it\. 

We receive, use and store any information you provide to Carrier Logistics through your use of this website\. We maintain physical, electronic and procedural safeguards in connection with the collection, storage and disclosure of your information\. We may also share your information if we believe it is appropriate to \(i\) comply with the applicable law; or \(ii\) to enforce or apply our Conditions of Use; or \(iii\) to protect the rights, property or safety of Carrier Logistics, our users or others; or \(iv\) to conduct background checks with third party companies which are not within Amazon\. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction\. However, this does not include selling, renting, sharing or otherwise disclosing your information for commercial or marketing purposes\. Our business changes constantly and our Privacy Notice and Terms and Conditions may also change\.

You have the right to object to certain uses of your personal data including the use of your personal data for direct marketing\. Carrier Logistics follows the same information practices as Amazon, and information we collect is subject to the Amazon Privacy Notice\. 

By visiting our site, you are accepting the practices described in the [Amazon Privacy Notice](https://www.amazon.in/gp/help/customer/display.html?nodeId=200534380&ref_=footer_privacy)\. Please take a moment to familiarise yourself with our privacy practices and let us know if you have any questions or suggestion by sending us an email to Customer Care\.`
};
const brPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.

Any personal information provided to or to be gathered by Carrier Logistics is controlled by Amazon Servi\xe7os de Varejo do Brasil Ltda. the data controller, of 2.041 Av. Presidente Juscelino Kubitschek, Tower E, 18th floor - Vila Nova Concei\xe7\xe3o, S\xe3o Paulo/SP \u{2013} Brazil.

We receive, use and store any information you provide to Carrier Logistics through your use of this site. We maintain physical, electronic and procedural safeguards in connection with the collection, storage and disclosure of your information.

We use your information to process your application and to communicate with you. We share your information only as described in this Privacy Notice and with Amazon (who are either subject to this Privacy Notice or follow practices at least as protective as those described in this Privacy Notice). We may also release information when we believe it is appropriate to comply with the law; to enforce or apply our Conditions of Use; to protect the rights, property or safety of Carrier Logistics, our users or others; or to conduct background checks with third party companies which are not within Amazon. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction; however, this does not include selling, renting, sharing or otherwise disclosing your information for commercial or marketing purposes.

Using this site with your browser settings adjusted to accept cookies tells us that you consent to our use of cookies but we only use cookies which we consider to be strictly necessary. The \u{2018}Help\u{2019} feature on most browsers will tell you how to prevent your browser from accepting new cookies, how to have the browser notify you when you receive a new cookie and how to disable cookies altogether.

Our business changes constantly and our Privacy Notice and Conditions of Use may also change. You should check our site frequently to see any recent changes.

For questions on this Privacy Notice, please contact the company at the address given above. 
`
};
const mxPrivacyNotice = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Carrier Logistics knows that you care how information about you is used and shared, and we appreciate your trust that we will do so carefully and sensibly.

If you have an account on www.amazon.com.mx and an Amazon.com cookie, information gathered by Carrier Logistics may be correlated with any personally identifiable information that Amazon has and used by Carrier Logistics and Amazon to improve the services we offer.

Carrier Logistics follows the same information practices as Amazon, and information we collect, use, disclose and otherwise handle is subject to the Amazon [Privacy Notice](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy). By visiting our site and/or providing us with your personal information, you are accepting the practices described in the Amazon [Privacy Notice](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy).`
};
const privacyNoticeTitle = {
    [(0, _common.COUNTRY_MAP).EU]: "Privacy Notice (EU)",
    [(0, _common.COUNTRY_MAP).US]: "Privacy Notice (US)",
    [(0, _common.COUNTRY_MAP).AU]: "Privacy Notice (AU)",
    [(0, _common.COUNTRY_MAP).CA]: "Privacy Notice (CA)",
    [(0, _common.COUNTRY_MAP).AE]: "Privacy Notice (AE)",
    [(0, _common.COUNTRY_MAP).BR]: "Privacy Notice (BR)",
    [(0, _common.COUNTRY_MAP).IN]: "Privacy Notice (IN)",
    [(0, _common.COUNTRY_MAP).MX]: "Privacy Notice (MX)"
};
const privacyNoticeContentCountryMap = {
    [(0, _common.COUNTRY_MAP).EU]: euPrivacyNotice,
    [(0, _common.COUNTRY_MAP).US]: usPrivacyNotice,
    [(0, _common.COUNTRY_MAP).AU]: auPrivacyNotice,
    [(0, _common.COUNTRY_MAP).CA]: caPrivacyNotice,
    [(0, _common.COUNTRY_MAP).AE]: aePrivacyNotice,
    [(0, _common.COUNTRY_MAP).BR]: brPrivacyNotice,
    [(0, _common.COUNTRY_MAP).IN]: inPrivacyNotice,
    [(0, _common.COUNTRY_MAP).MX]: mxPrivacyNotice
};

},{"./common":"4gLZS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4gLZS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COUNTRY_MAP", ()=>COUNTRY_MAP);
parcelHelpers.export(exports, "LOCALES_MAP", ()=>LOCALES_MAP);
parcelHelpers.export(exports, "INTERNAL_USER_IDENTIFIER", ()=>INTERNAL_USER_IDENTIFIER);
const COUNTRY_MAP = {
    EU: "EU",
    US: "US",
    AU: "AU",
    CA: "CA",
    AE: "AE",
    BR: "BR",
    IN: "IN",
    MX: "MX"
};
const LOCALES_MAP = {
    FR_FR: "fr-FR",
    EN_US: "en-US",
    ES_ES: "es-ES",
    IT_IT: "it-IT"
};
const INTERNAL_USER_IDENTIFIER = "@amazon.com";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kg9Nq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emotion = require("emotion");
var _modal = require("@amzn/meridian/modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
const ConditionOfUsePrivacyNoticePopup = ({ innerHtmlBodyContent, open, onClose, modalTitle })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalDefault.default), {
        title: modalTitle,
        open: open,
        onClose: onClose,
        scrollContainer: "viewport",
        closeLabel: "Close"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _emotion.css)`
          & {
            font-family: AmazonEmber-Regular, Amazon Ember;
          }
        `,
        dangerouslySetInnerHTML: {
            __html: innerHtmlBodyContent
        }
    }));
};
exports.default = ConditionOfUsePrivacyNoticePopup;

},{"react":"6uln9","emotion":"1BAMo","@amzn/meridian/modal":"DAqKT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DAqKT":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("298db97ef1812a7f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalFooter", {
    enumerable: true,
    get: function get() {
        return _modalFooter["default"];
    }
});
exports["default"] = void 0;
var _modal = _interopRequireDefault(require("c2232b826b6066ef"));
var _modalFooter = _interopRequireDefault(require("bad7acf197d97d"));
var _default = _modal["default"];
exports["default"] = _default;

},{"298db97ef1812a7f":"5qxSW","c2232b826b6066ef":"vfehJ","bad7acf197d97d":"dtj8h"}],"vfehJ":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("ff9b8d49acc11862");
var _interopRequireDefault = require("aba1447ed63686c7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("99af5a1bdcee20b0"));
var _defineProperty2 = _interopRequireDefault(require("24d79a0384e507ed"));
var _react = _interopRequireWildcard(require("da67b0f8e448177e"));
var _propTypes = _interopRequireDefault(require("5f88ff1b153834b2"));
var _modal = _interopRequireDefault(require("748b22adb7187f04"));
var _modalBox = _interopRequireWildcard(require("460bfd1939a50b6a"));
var _theme = require("225bbd42f795165");
var _scrim = _interopRequireDefault(require("dc3b7565d608b386"));
var _portal = _interopRequireDefault(require("9563042d3128dc28"));
var _responsive = _interopRequireDefault(require("3e06b4a1876aed7"));
var _animateMount = _interopRequireWildcard(require("6faaa6e17ca153c6"));
var _propTypes2 = _interopRequireDefault(require("d0a36a41ec3e1cd1"));
var _emotion = require("67275b98f347afb0");
var _onDirectClick = _interopRequireDefault(require("67d59bfc26be7f97"));
var AnimateFadeScaleWithMount = (0, _animateMount["default"])(_animateMount.AnimateFadeScale);
/**
 * The scrim is the vertical scroll container, and uses flexbox to center the
 * modal in the viewport.
 */ var scrimStyles = (0, _emotion.css)({
    display: "flex",
    alignItems: "center",
    overflow: "auto"
});
/**
 * This wrapper uses margin "auto" to center the modal, but sets a max width and
 * height which force the modal to overflow to the bottom/right of the viewport
 * instead of oveflowing all sides (which looks funky and makes the top/left
 * content inaccessible). For details see:
 * https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
 */ var outerWrapperStyles = (0, _emotion.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "auto"
});
/**
 * The inner wrapper applies a margin around the modal to ensure a certain
 * amount of scrim is always shown. Applying the margin here as opposed to on
 * the outer wrapper ensures that the margin below the modal is preserved even
 * if the modal overflows the viewport and requires scrolling (otherwise the
 * padding would disappear due to this problem:
 * https://www.brunildo.org/test/overscrollback.html).
 */ var innerWrapperStyles = (0, _emotion.css)({
    padding: "".concat(_modalBox.scrimSpacingVertical, "vh ").concat(_modalBox.scrimSpacingHorizontal, "vw"),
    // HACK: IE11 will only respect the max-height property of the modal if the
    // modal's parent is a flex column. See:
    // https://stackoverflow.com/questions/44635857/flexbox-max-height-issue-with-ie11
    display: "flex",
    flexDirection: "column"
});
/**
 * Don't bother updating the modal if it's persisting in a closed state.
 */ var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return !prevProps.open && !nextProps.open;
};
/**
 * Render a modal in the viewport. On desktop the modal will be shown with a
 * scrim behind it. On mobile the modal will be shown fullscreen. Only one modal
 * should be rendered at a time.
 *
 * NOTE: Do not mount a Modal inside an interactive element. The Modal's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Modal will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Modal being counted as a click on the element
 * where the Modal was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */ var Modal = /*#__PURE__*/ _react["default"].memo(function(props) {
    var t = (0, _theme.useTheme)(_modal["default"], "modal");
    var scrimRef = (0, _react.useRef)();
    var anchorRef = (0, _react.useRef)(); // We want an onClose callback, but only if props.onClose is defined
    var onCloseProp = props.onClose;
    var onCloseCallback = (0, _react.useCallback)(function() {
        if (anchorRef.current && anchorRef.current.focus) anchorRef.current.focus();
        onCloseProp();
    }, [
        onCloseProp,
        anchorRef
    ]);
    var onCloseMaybe = onCloseProp ? onCloseCallback : undefined;
    (0, _react.useEffect)(function() {
        if (props.open) // Remember the node that the modal was opened from. We'll try to focus on
        // this when the modal is closed. We put this logic in a side effect rather
        // then the `modalRef` callback b/c by the time that callback is called
        // it's too late and the `activeElement` might already be an auto-focused
        // element inside of the modal - negating the benefit of remembering which
        // node caused the modal to open.
        anchorRef.current = document.activeElement;
    }, [
        props.open
    ]);
    var modalRef = (0, _react.useCallback)(function(modalNode) {
        if (modalNode) {
            // Get the active element and check if it's inside of the modal
            var activeElementInsideModal = modalNode.contains(document.activeElement);
            if (!activeElementInsideModal) {
                // Focus the first node in the Modal
                modalNode.focus(); // Reset the scroll position of the scrim to counteract the browser
                // auto-scrolling to the focused node. Note that we have to wait one
                // event loop for this to work (otherwise we'd be resetting the scroll
                // *before* the browser auto-scrolls).
                // Prevent the browser from scrolling to the focused node to avoid a
                // jitter when the modal opens.
                // TODO: Update this to use the "preventScroll" focus option when Safari
                // implements that and we drop support for IE11.
                if (scrimRef.current) setTimeout(function() {
                    scrimRef.current.scrollTop = 0;
                    scrimRef.current.scrollLeft = 0;
                }, 0);
            }
        }
    }, []);
    return /*#__PURE__*/ _react["default"].createElement(AnimateFadeScaleWithMount, {
        open: props.open,
        duration: t("motionDuration"),
        easing: t("motionFunction"),
        onOpen: props.onOpen
    }, function(_ref) {
        var className = _ref.className, onTransitionEnd = _ref.onTransitionEnd, open = _ref.open;
        return /*#__PURE__*/ _react["default"].createElement(_responsive["default"], {
            query: "min-width",
            props: {
                fullscreen: (0, _defineProperty2["default"])({
                    "default": true
                }, "".concat(t("floatingBreakpoint"), "px"), false)
            }
        }, function(_ref2) {
            var fullscreen = _ref2.fullscreen;
            var modal = /*#__PURE__*/ _react["default"].createElement(_modalBox["default"], (0, _extends2["default"])({}, props, {
                onClose: onCloseMaybe,
                t: t,
                scrollContainer: props.scrollContainer,
                fullscreen: fullscreen,
                className: className,
                onTransitionEnd: onTransitionEnd,
                ref: modalRef
            }));
            return /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, fullscreen ? modal : /*#__PURE__*/ _react["default"].createElement(_scrim["default"], {
                open: props.open || open,
                className: scrimStyles,
                onClick: onCloseMaybe,
                ref: scrimRef
            }, /*#__PURE__*/ _react["default"].createElement("div", {
                className: outerWrapperStyles
            }, /*#__PURE__*/ _react["default"].createElement("div", {
                className: innerWrapperStyles,
                onMouseDown: // applied to keep the modal away from the
                // edges of the viewport. This padding appears
                // as scrim space to the user, but it blocks
                // clicks to the scrim so we have to add the
                // click-to-close behavior here as well
                (0, _onDirectClick["default"])(onCloseMaybe)
            }, modal))));
        });
    });
}, shouldNotUpdate);
Modal.displayName = "Modal";
Modal.propTypes = {};
Modal.defaultProps = {
    closeButtonPropagateClickEvent: true,
    closeLabel: "Close",
    bodySpacingInset: "medium",
    scrollContainer: "viewport"
};
var _default = Modal;
exports["default"] = _default;

},{"ff9b8d49acc11862":"4RXTR","aba1447ed63686c7":"5qxSW","99af5a1bdcee20b0":"fAmfl","24d79a0384e507ed":"avcfc","da67b0f8e448177e":"6uln9","5f88ff1b153834b2":"9Mqtv","748b22adb7187f04":"jNAqq","460bfd1939a50b6a":"9KQLY","225bbd42f795165":"dJlcb","dc3b7565d608b386":"ftCSx","9563042d3128dc28":"kr8m8","3e06b4a1876aed7":"l7U3k","6faaa6e17ca153c6":"f4bM9","d0a36a41ec3e1cd1":"b6Ogh","67275b98f347afb0":"1BAMo","67d59bfc26be7f97":"iHMHx"}],"jNAqq":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        modalMobileCloseButtonSpacingTop: 4,
        modalMobileCloseButtonSpacingRight: 2,
        modalMotionDuration: "300ms",
        modalMotionFunction: "ease",
        modalBorderWidth: 1,
        modalBorderRadius: 4,
        modalHeaderForegroundColor: "#FFFFFF",
        modalHeaderBackgroundColor: "#252829",
        modalHeaderFontWeight: 600,
        modalHeaderMinHeight: 48,
        modalHeaderSpacingInsetTop: 8,
        modalHeaderSpacingInsetRight: 40,
        modalHeaderSpacingInsetBottom: 8,
        modalHeaderSpacingInsetLeft: 16,
        modalCloseButtonSpacingTop: 8,
        modalCloseButtonSpacingRight: 8,
        modalBodyBackgroundColor: tokens.themeBackgroundPrimaryDefault,
        modalFooterSpacingInset: 16,
        modalFooterBorderWidth: 1,
        modalFooterBorderRadius: 0,
        modalFooterBorderColor: tokens.themeBorderTertiaryDefault,
        modalDropShadowOffsetX: 0,
        modalDropShadowOffsetY: 2,
        modalDropShadowBlur: 4,
        modalDropShadowSpread: 0,
        modalDropShadowColor: "rgba(11, 12, 12, 0.16)",
        modalFloatingBreakpoint: 721
    };
};

},{}],"9KQLY":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("bfc025ae4d3da2a8");
var _interopRequireDefault = require("23760ff95199fb1f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scrimSpacingHorizontal = exports.scrimSpacingVertical = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("5fb56fe9e9f76407"));
var _defineProperty2 = _interopRequireDefault(require("fc023f43f8ad4e0b"));
var _react = _interopRequireWildcard(require("94e59862cdadbd17"));
var _propTypes = _interopRequireDefault(require("d4b8f165203ba53"));
var _keycode = _interopRequireDefault(require("8c4b574d23fbaf98"));
var _close = _interopRequireDefault(require("b5a2ea6e5f938d97"));
var _elevation = require("d08ebbadf35aa1c2");
var _uniqueId = _interopRequireDefault(require("97cb75f7733ef164"));
var _modalFooter = _interopRequireDefault(require("22f6dec63449fe40"));
var _button = _interopRequireDefault(require("8d70a198f4930db5"));
var _icon = _interopRequireDefault(require("3a84077f97681376"));
var _focusTrap = _interopRequireDefault(require("299efd1cae327527"));
var _propTypes2 = _interopRequireDefault(require("8a639f15d9311cf2"));
var _parsers = require("eda109d3b25f2c35");
var _emotion = require("8926b86ba0e2aa6e");
var _isElementOf = _interopRequireDefault(require("ce49af842637e6f0"));
var _text = _interopRequireDefault(require("a8d2d5b25f08a99b"));
var _useFocus2 = _interopRequireDefault(require("b6cffdc93a0e155a"));
var _focusRing = _interopRequireDefault(require("7d46d0fcf5d4a5b8"));
var _filterPropsByPrefix = _interopRequireDefault(require("b3e993e95a617021"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var closeButtonWidth = 32; // px
var scrimSpacingVertical = 10; // vh
exports.scrimSpacingVertical = scrimSpacingVertical;
var scrimSpacingHorizontal = 10; //vw
exports.scrimSpacingHorizontal = scrimSpacingHorizontal;
var isFooter = (0, _isElementOf["default"])(_modalFooter["default"]);
var isNotFooter = function isNotFooter(child) {
    return !isFooter(child);
};
var styles = function styles(t, _ref) {
    var focus = _ref.focus, scrollContainer = _ref.scrollContainer, fullscreen = _ref.fullscreen, width = _ref.width, bodySpacingInset = _ref.bodySpacingInset, showTitle = _ref.showTitle, showCloseButton = _ref.showCloseButton;
    var padding = (0, _parsers.parseSpacing)(bodySpacingInset);
    return (0, _emotion.css)(/**
   * Fullscreen vs non-fullscreen styles
   */ fullscreen ? {
        // Fullscreen modals aren't shown in a scrim so we've got to handle
        // layout here
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: _elevation.elevationModal,
        // Use momentum scrolling on iOS. See:
        // https://css-tricks.com/snippets/css/momentum-scrolling-on-ios-overflow-elements/
        overflowY: "scroll",
        WebkitOverflowScrolling: "touch"
    } : {
        // Apply the user-provided width if we're not showing a fullscreen
        // modal
        width: width,
        // This allows the absolutely-positioned close button to anchor itself
        // to the modal
        position: "relative",
        boxShadow: t.boxShadowCss("dropShadow"),
        maxHeight: scrollContainer === "modal" ? "".concat(100 - scrimSpacingVertical * 2, "vh") : undefined,
        maxWidth: "".concat(100 - scrimSpacingHorizontal * 2, "vw"),
        borderRadius: t("borderRadius")
    }, focus ? (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        borderRadius: t("borderRadius")
    }) : {}, {
        /**
     * Common styles
     */ display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: t("bodyBackgroundColor"),
        outline: "none",
        /**
     * Header styles
     */ "& > header": (0, _emotion.css)((0, _text["default"])(t), {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            minHeight: t("headerMinHeight"),
            paddingTop: t("headerSpacingInsetTop"),
            paddingRight: t("headerSpacingInsetRight"),
            paddingBottom: t("headerSpacingInsetBottom"),
            paddingLeft: t("headerSpacingInsetLeft"),
            backgroundColor: t("headerBackgroundColor"),
            color: t("headerForegroundColor"),
            fontWeight: t("headerFontWeight")
        }),
        /**
     * Body styles
     */ "& > div": {
            padding: (0, _parsers.parseSpacing)(bodySpacingInset).map(function(value) {
                return "".concat(value, "px");
            }).join(" "),
            // Add extra right-padding on modals with no title and a close button
            paddingRight: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined,
            overflowY: scrollContainer === "modal" ? "auto" : undefined,
            overflowX: "auto",
            // In fullscreen mode the body should fill up any screen space not used by
            // the header or footer
            flex: fullscreen ? "auto" : undefined
        },
        /**
     * Footer styles
     */ "& > footer": {
            borderTop: t.borderCss("footerBorder"),
            padding: t("footerSpacingInset")
        }
    });
};
var closeButtonStyles = function closeButtonStyles(t) {
    return (0, _emotion.css)({
        position: "absolute",
        top: t("closeButtonSpacingTop"),
        right: t("closeButtonSpacingRight"),
        zIndex: _elevation.elevationForeground
    });
};
/* eslint-disable react/prop-types, react/display-name */ // The element we use at the root of the modal depends on
// the presence of an `onSubmit` prop. If the method
// is present, the modal uses a <form> element, else
// a <div>
var ModalBoxRoot = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(props.onSubmit ? "form" : "div", _objectSpread(_objectSpread({}, props), {}, {
        tabIndex: 0,
        ref: ref
    }));
});
/* eslint-enable react/prop-types, react/display-name */ /**
 * This component can be used to render a modal for your application
 */ var ModalBox = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var onClose = props.onClose, onSubmitForm = props.onSubmitForm, formAction = props.formAction, formMethod = props.formMethod;
    var id = (0, _react.useMemo)(function() {
        return (0, _uniqueId["default"])("modal-");
    }, []);
    var headerId = props.title ? "".concat(id, "-header") : undefined;
    var footer = _react["default"].Children.toArray(props.children).filter(isFooter)[0];
    var _useFocus = (0, _useFocus2["default"])(props), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps, focusDescendent = _useFocus.focusDescendent; // Call the onClose handler if the esc key is pressed
    var onKeyDownDocument = (0, _react.useCallback)(function(event) {
        if ((0, _keycode["default"])(event) === "esc") onClose();
    }, [
        onClose
    ]); // Bind the onKeyDownDocument handler to the window
    (0, _react.useEffect)(function() {
        if (onClose) window.addEventListener("keydown", onKeyDownDocument);
        return function() {
            return window.removeEventListener("keydown", onKeyDownDocument);
        };
    }, [
        onClose,
        onKeyDownDocument
    ]);
    var onSubmit = (0, _react.useCallback)(function(event) {
        if (!formAction && !formMethod) event.preventDefault();
        onSubmitForm();
    }, [
        formAction,
        formMethod,
        onSubmitForm
    ]);
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/ _react["default"].createElement(ModalBoxRoot, (0, _extends2["default"])({}, passThroughProps, focusProps, {
        className: (0, _emotion.cx)(props.className, styles(props.t, {
            focus: focus && focusTrigger === "keyboard" && !focusDescendent,
            scrollContainer: props.scrollContainer,
            width: props.width,
            fullscreen: props.fullscreen,
            bodySpacingInset: props.bodySpacingInset,
            showTitle: Boolean(props.title),
            showCloseButton: Boolean(onClose)
        })),
        onTransitionEnd: props.onTransitionEnd,
        onSubmit: onSubmitForm ? onSubmit : undefined,
        action: props.formAction,
        method: props.formMethod,
        "aria-labelledby": headerId,
        "aria-describedby": props.describedById,
        "aria-modal": true,
        ref: ref
    }), props.title ? /*#__PURE__*/ _react["default"].createElement("header", {
        id: headerId
    }, props.title) : null, onClose ? /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        onClick: onClose,
        size: "small",
        type: "icon",
        backdropColor: props.title ? props.t("headerBackgroundColor") : props.t("bodyBackgroundColor"),
        className: closeButtonStyles(props.t),
        propagateClickEvent: props.closeButtonPropagateClickEvent
    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: _close["default"]
    }, props.closeLabel)) : null, /*#__PURE__*/ _react["default"].createElement("div", null, _react["default"].Children.toArray(props.children).filter(isNotFooter)), footer ? footer : null));
});
ModalBox.displayName = "ModalBox";
ModalBox.propTypes = {};
var _default = ModalBox;
exports["default"] = _default;

},{"bfc025ae4d3da2a8":"4RXTR","23760ff95199fb1f":"5qxSW","5fb56fe9e9f76407":"fAmfl","fc023f43f8ad4e0b":"avcfc","94e59862cdadbd17":"6uln9","d4b8f165203ba53":"9Mqtv","8c4b574d23fbaf98":"4THh2","b5a2ea6e5f938d97":"2AQYC","d08ebbadf35aa1c2":"dKmTh","97cb75f7733ef164":"4Lekm","22f6dec63449fe40":"dtj8h","8d70a198f4930db5":"k0QSK","3a84077f97681376":"8MgRY","299efd1cae327527":"aDJea","8a639f15d9311cf2":"b6Ogh","eda109d3b25f2c35":"iZdRW","8926b86ba0e2aa6e":"1BAMo","ce49af842637e6f0":"i2KEV","a8d2d5b25f08a99b":"g6RQX","b6cffdc93a0e155a":"7jVM9","7d46d0fcf5d4a5b8":"5Dvm2","b3e993e95a617021":"7Pq5E"}],"dtj8h":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bc2e6cf5ccd28021");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("73e0de82473dec8e"));
var _propTypes = _interopRequireDefault(require("1b4bb332943f4eb2"));
/**
 * This component is used to render a footer in your Modal. It is meant to
 * be used with Modals of type "scrollableRegion," and without it modals of
 * those type will not render correctly.
 */ var ModalFooter = function ModalFooter(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ _react["default"].createElement("footer", null, children);
};
ModalFooter.propTypes = {};
var _default = ModalFooter;
exports["default"] = _default;

},{"bc2e6cf5ccd28021":"5qxSW","73e0de82473dec8e":"6uln9","1b4bb332943f4eb2":"9Mqtv"}],"aDJea":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e94310af938ad8da");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _focusTrap = _interopRequireDefault(require("a6100baf59e8f3ff"));
var _default = _focusTrap["default"];
exports["default"] = _default;

},{"e94310af938ad8da":"5qxSW","a6100baf59e8f3ff":"axoQ2"}],"axoQ2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("cda8fcada9c8e6cf");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("da7b1f61c2ef07f9"));
var _createClass2 = _interopRequireDefault(require("f895bc618b10f940"));
var _assertThisInitialized2 = _interopRequireDefault(require("19ecb8c67c936576"));
var _inherits2 = _interopRequireDefault(require("dba195b5c5c49b7c"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("1b66d90b35d0813a"));
var _getPrototypeOf2 = _interopRequireDefault(require("e713aed06cd938be"));
var _defineProperty2 = _interopRequireDefault(require("eac8a0ad613b438b"));
var _react = _interopRequireDefault(require("c3520f68e731f095"));
var _propTypes = _interopRequireDefault(require("f05cc53886748b48"));
var _reactDom = _interopRequireDefault(require("46fc5125aa12ee75"));
var _keycode = _interopRequireDefault(require("3eb9ac5a277d073e"));
var _includes = _interopRequireDefault(require("30aed996dfb7f43e"));
var _find = _interopRequireDefault(require("f0c6b48192858457"));
var _findLast = _interopRequireDefault(require("3ac6d389f21f39ca"));
var _noop = _interopRequireDefault(require("110f816e5909064d"));
var _focus = require("6a49a933729442b5");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This component allows you to trap the keyboard focus within a particular
 * section of the DOM (the component's children). An optional onBeforeBlur event
 * handler can be defined that allows you to execute custom behavior when the
 * user attempts to move the focus outside of the trap by pressing the tab key.
 *
 * NOTE: This component only handles keyboard focus. If the mouse is used to
 * move focus outside of the trap then the trap will not prevent the focus
 * change and onBeforeBlur will not be called.
 *
 * NOTE: This component must be wrapped around a single element to work
 * properly.
 *
 * NOTE: This component only manages focus for elements that are
 * descendents in the real DOM. This means that it will ignore any portals
 * nested inside of it in the virtual DOM.
 */ var FocusTrap = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(FocusTrap, _React$Component);
    var _super = _createSuper(FocusTrap);
    function FocusTrap() {
        var _this;
        (0, _classCallCheck2["default"])(this, FocusTrap);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootNode", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function(event) {
            if ((0, _keycode["default"])(event) === "tab") {
                var _getBoundingFocusNode = (0, _focus.getBoundingFocusNodes)(_this.rootNode), startNodes = _getBoundingFocusNode.startNodes, endNodes = _getBoundingFocusNode.endNodes;
                var willBlur = _this.willBlur(event, startNodes, endNodes);
                var allowBlur = willBlur && _this.props.onBeforeBlur(willBlur);
                var firstFocusNode = (0, _find["default"])(startNodes, _focus.canKeyboardFocusNode);
                var lastFocusNode = (0, _findLast["default"])(endNodes, _focus.canKeyboardFocusNode); // If onBeforeBlur returned nothing then loop the focus ourselves
                if (willBlur === -1 && allowBlur === undefined && lastFocusNode) lastFocusNode.focus();
                if (willBlur === 1 && allowBlur === undefined && firstFocusNode) firstFocusNode.focus();
                 // If allowBlur was not explicitly set to true then cancel the default event
                // behavior
                if (willBlur && allowBlur !== true) event.preventDefault();
            }
        });
        return _this;
    }
    (0, _createClass2["default"])(FocusTrap, [
        {
            key: "focus",
            value: function focus() {
                var node = (0, _focus.getKeyboardFocusNodes)(this.rootNode)[0];
                if (node) node.focus();
            }
        },
        {
            key: "focusEnd",
            value: function focusEnd() {
                var nodes = (0, _focus.getKeyboardFocusNodes)(this.rootNode);
                var node = nodes[nodes.length - 1];
                if (node) node.focus();
            }
        },
        {
            key: "willBlur",
            value: function willBlur(event, startNodes, endNodes) {
                var key = (0, _keycode["default"])(event);
                var target = event.target, shiftKey = event.shiftKey;
                return (0, _includes["default"])(endNodes, target) && key === "tab" && !shiftKey ? 1 : (0, _includes["default"])(startNodes, target) && key === "tab" && shiftKey ? -1 : 0;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                /* eslint-disable-next-line react/no-find-dom-node */ this.rootNode = _reactDom["default"].findDOMNode(this);
                this.rootNode.addEventListener("keydown", this.onKeyDown);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.rootNode.removeEventListener("keydown", this.onKeyDown);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return FocusTrap;
}(_react["default"].Component);
(0, _defineProperty2["default"])(FocusTrap, "defaultProps", {
    onBeforeBlur: _noop["default"]
});
FocusTrap.propTypes = {};
var _default = FocusTrap;
exports["default"] = _default;

},{"cda8fcada9c8e6cf":"5qxSW","da7b1f61c2ef07f9":"aqLjQ","f895bc618b10f940":"8X7ov","19ecb8c67c936576":"fA0LA","dba195b5c5c49b7c":"hAMmu","1b66d90b35d0813a":"37tJc","e713aed06cd938be":"cE6Se","eac8a0ad613b438b":"avcfc","c3520f68e731f095":"6uln9","f05cc53886748b48":"9Mqtv","46fc5125aa12ee75":"b8T3j","3eb9ac5a277d073e":"4THh2","30aed996dfb7f43e":"dT4OH","f0c6b48192858457":"b6TZs","3ac6d389f21f39ca":"1RzVs","110f816e5909064d":"hxHyu","6a49a933729442b5":"jzxGB"}],"dT4OH":[function(require,module,exports) {
var baseIndexOf = require("6f4c179a1b30a2d0"), isArrayLike = require("87457f552a321e25"), isString = require("6d09a98cdac31bf9"), toInteger = require("439a4dd0c6e87aee"), values = require("6732be81ca900c99");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
    return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
module.exports = includes;

},{"6f4c179a1b30a2d0":"cLR56","87457f552a321e25":"gSsVl","6d09a98cdac31bf9":"dkaos","439a4dd0c6e87aee":"j7eMm","6732be81ca900c99":"f1t65"}],"cLR56":[function(require,module,exports) {
var baseFindIndex = require("867c6bbcfeb0f6e4"), baseIsNaN = require("aa027d71574a84c0"), strictIndexOf = require("aec84341916c7b49");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"867c6bbcfeb0f6e4":"7JT1u","aa027d71574a84c0":"BRFUw","aec84341916c7b49":"7WmUG"}],"BRFUw":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"7WmUG":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"dkaos":[function(require,module,exports) {
var baseGetTag = require("fc52aa681f3bcb02"), isArray = require("7a7f2e70fffd9ddf"), isObjectLike = require("b6f37dcf4c5ccbf5");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"fc52aa681f3bcb02":"dAnT2","7a7f2e70fffd9ddf":"8FU35","b6f37dcf4c5ccbf5":"fXvWZ"}],"f1t65":[function(require,module,exports) {
var baseValues = require("af55877c849a3a9b"), keys = require("92c9ed7fdf1f4e6a");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"af55877c849a3a9b":"53BbH","92c9ed7fdf1f4e6a":"8QtRK"}],"53BbH":[function(require,module,exports) {
var arrayMap = require("850d9aeafafeb541");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"850d9aeafafeb541":"1mxKX"}],"1RzVs":[function(require,module,exports) {
var createFind = require("9dbc1d39d50a7093"), findLastIndex = require("b7d42f400521948");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var findLast = createFind(findLastIndex);
module.exports = findLast;

},{"9dbc1d39d50a7093":"ksBTL","b7d42f400521948":"6mtOp"}],"6mtOp":[function(require,module,exports) {
var baseFindIndex = require("272042feef154218"), baseIteratee = require("8c7e810c166030a6"), toInteger = require("569fad422e2bcdd2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}
module.exports = findLastIndex;

},{"272042feef154218":"7JT1u","8c7e810c166030a6":"iYUay","569fad422e2bcdd2":"j7eMm"}],"jzxGB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("25e687e41dae3a06");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBoundingFocusNodes = exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("cd32dec30c07303a"));
var _findIndex = _interopRequireDefault(require("e0b05a73f059ec12"));
var _findLastIndex = _interopRequireDefault(require("f867f3368110393f"));
var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Returns true if a node can be focused
 */ var canFocusNode = function canFocusNode(node) {
    return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};
exports.canFocusNode = canFocusNode;
var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
    return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};
exports.canKeyboardFocusNode = canKeyboardFocusNode;
var getFocusNodes = function getFocusNodes(node) {
    return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};
exports.getFocusNodes = getFocusNodes;
var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
    return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */ exports.getKeyboardFocusNodes = getKeyboardFocusNodes;
var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
    var nodes = [
        canFocusNode(node) ? node : undefined
    ].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
    var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
    var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
    var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
    var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
    return {
        startNodes: startNodes,
        endNodes: endNodes
    };
};
exports.getBoundingFocusNodes = getBoundingFocusNodes;

},{"25e687e41dae3a06":"5qxSW","cd32dec30c07303a":"cbgE8","e0b05a73f059ec12":"a1880","f867f3368110393f":"6mtOp"}],"cbgE8":[function(require,module,exports) {
var arrayWithoutHoles = require("714f22363fd0ef33");
var iterableToArray = require("ba1223643812215a");
var unsupportedIterableToArray = require("73bd6597f56adf15");
var nonIterableSpread = require("380fe9be8cbd0096");
function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray;

},{"714f22363fd0ef33":"fsLVu","ba1223643812215a":"5hxTf","73bd6597f56adf15":"7sxQU","380fe9be8cbd0096":"eFhXc"}],"fsLVu":[function(require,module,exports) {
var arrayLikeToArray = require("a153019476911bd2");
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles;

},{"a153019476911bd2":"fVGpd"}],"5hxTf":[function(require,module,exports) {
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
module.exports = _iterableToArray;

},{}],"eFhXc":[function(require,module,exports) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread;

},{}],"ftCSx":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("eecb56bceb858600");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _scrim = _interopRequireDefault(require("3cdd6ff58315e78a"));
var _default = _scrim["default"];
exports["default"] = _default;

},{"eecb56bceb858600":"5qxSW","3cdd6ff58315e78a":"dmyYH"}],"dmyYH":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("302acca062f50129");
var _interopRequireDefault = require("8b75a3090abb2017");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("1e5dd12648de424c"));
var _propTypes = _interopRequireDefault(require("40cd7e476f043e0d"));
var _emotion = require("66748dd4f836b796");
var _scrim = _interopRequireDefault(require("348b4d3afe1f7458"));
var _theme = require("643b20e5972feeca");
var _animateMount = _interopRequireWildcard(require("eecc7c2ef8be5dfb"));
var _onDirectClick = _interopRequireDefault(require("27b9fe045349c293"));
var AnimateFadeWithMount = (0, _animateMount["default"])(_animateMount.AnimateFade);
var styles = function styles(t) {
    return (0, _emotion.css)({
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: t("elevation"),
        backgroundColor: t("backgroundColor")
    });
};
/**
 * Don't bother updating the scrim if it's persisting in a closed state.
 */ var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return !prevProps.open && !nextProps.open;
};
var Scrim = /*#__PURE__*/ _react["default"].memo(/*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_scrim["default"], "scrim");
    return /*#__PURE__*/ _react["default"].createElement(AnimateFadeWithMount, {
        open: props.open,
        onOpen: props.onOpen,
        duration: props.duration || t("motionTiming"),
        easing: props.easing || t("motionFunction"),
        type: "fade"
    }, function(_ref) {
        var className = _ref.className, onTransitionEnd = _ref.onTransitionEnd;
        return(/*#__PURE__*/ // Regarding role=none, see:
        // https://www.scottohara.me/blog/2018/05/05/hidden-vs-none.html#what-does-rolenone-and-rolepresentation-do
        _react["default"].createElement("div", {
            role: "none",
            className: (0, _emotion.cx)(className, styles(t), props.className),
            onTransitionEnd: onTransitionEnd,
            onMouseDown: (0, _onDirectClick["default"])(props.onClick),
            ref: ref
        }, props.children));
    });
}), shouldNotUpdate);
Scrim.displayName = "Scrim";
Scrim.propTypes = {};
Scrim.defaultProps = {
    open: false,
    className: null
};
var _default = Scrim;
exports["default"] = _default;

},{"302acca062f50129":"4RXTR","8b75a3090abb2017":"5qxSW","1e5dd12648de424c":"6uln9","40cd7e476f043e0d":"9Mqtv","66748dd4f836b796":"1BAMo","348b4d3afe1f7458":"i5KEc","643b20e5972feeca":"dJlcb","eecc7c2ef8be5dfb":"f4bM9","27b9fe045349c293":"iHMHx"}],"f4bM9":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6d1e159db74bc53f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnimateFade", {
    enumerable: true,
    get: function get() {
        return _animateFade["default"];
    }
});
Object.defineProperty(exports, "AnimateSlideIn", {
    enumerable: true,
    get: function get() {
        return _animateSlideIn["default"];
    }
});
Object.defineProperty(exports, "AnimateFadeScale", {
    enumerable: true,
    get: function get() {
        return _animateFadeScale["default"];
    }
});
exports["default"] = void 0;
var _withAnimateMount = _interopRequireDefault(require("cc54889a42a71b80"));
var _animateFade = _interopRequireDefault(require("68bf5059cd2cee2c"));
var _animateSlideIn = _interopRequireDefault(require("87b4119fa8572bd8"));
var _animateFadeScale = _interopRequireDefault(require("b9f7ff74588c1097"));
var _default = _withAnimateMount["default"];
exports["default"] = _default;

},{"6d1e159db74bc53f":"5qxSW","cc54889a42a71b80":"b3wo9","68bf5059cd2cee2c":"4aoef","87b4119fa8572bd8":"vd71g","b9f7ff74588c1097":"yNOQB"}],"b3wo9":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a422eb1a4eb89a4e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("9ae88e7b548e93bc"));
var _classCallCheck2 = _interopRequireDefault(require("9aeb9067310b9795"));
var _createClass2 = _interopRequireDefault(require("7210569638952c5b"));
var _assertThisInitialized2 = _interopRequireDefault(require("63b7c79b33f92d23"));
var _inherits2 = _interopRequireDefault(require("b10430e9ce49baed"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("c182b9d440835a68"));
var _getPrototypeOf2 = _interopRequireDefault(require("5acf25bf725fb523"));
var _defineProperty2 = _interopRequireDefault(require("d01149def2029031"));
var _react = _interopRequireDefault(require("9946f6f316f35d18"));
var _propTypes = _interopRequireDefault(require("26c384261d24991"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// Provides the WrappedComponent's displayName
// for easy debugging
var getsDisplayName = function getsDisplayName(WrappedComponent) {
    return WrappedComponent.getsDisplayName || WrappedComponent.name || "Component";
};
var withAnimateMount = function withAnimateMount(WrappedComponent) {
    var _class, _temp;
    /**
   * This is a higher order component that provides a consistent API to easily
   * create animations to be used for elements that need to be added and
   * removed to the DOM dynamically. Receives an animation component and returns a
   * wrapped, composed component.
   */ return _temp = _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inherits2["default"])(WithAnimateMount, _React$Component);
        var _super = _createSuper(WithAnimateMount);
        function WithAnimateMount() {
            var _this;
            (0, _classCallCheck2["default"])(this, WithAnimateMount);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
                show: false
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
                if (typeof _this.props.onOpen !== "undefined" && _this.state.show) _this.props.onOpen();
                 // Remount the node when the open prop is true
                _this.setState({
                    show: true
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
                if (!_this.props.open) _this.setState({
                    show: false
                });
            });
            return _this;
        }
        (0, _createClass2["default"])(WithAnimateMount, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.open) this.updateStateOnOpen();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (!prevProps.open && this.props.open) this.updateStateOnOpen();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, open = _this$props.open, animateToHeight = _this$props.animateToHeight;
                    var animateToHeightProps = typeof animateToHeight !== "undefined" ? {
                        animateToHeight: animateToHeight
                    } : null;
                    return this.state.show && /*#__PURE__*/ _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
                        duration: duration,
                        easing: easing,
                        open: open,
                        updateStateOnOpen: this.updateStateOnOpen,
                        transitionEnd: this.transitionEnd
                    }, animateToHeightProps), children);
                }
            }
        ]);
        return WithAnimateMount;
    }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "propTypes", {
        /**
     * A function that returns the elements to animate.
     */ children: _propTypes["default"].func.isRequired,
        /**
     * If true the children will be mounted, otherwise they will be unmounted.
     */ open: _propTypes["default"].bool.isRequired,
        /**
     * Only applies to height based transitions. Allows for cases when the
     * desired effect is animating height to a value that's different than
     * the element's scrollHeight.
     */ animateToHeight: _propTypes["default"].oneOfType([
            _propTypes["default"].string,
            _propTypes["default"].number
        ]),
        /**
     * The duration of the animation. This should be a valid CSS animation
     * duration (e.g. `"100ms"` or `"1s"`).
     */ duration: _propTypes["default"].string,
        /**
     * The easing function of the animation. This should be a valid CSS easing
     * function (e.g. `"linear"` or `"ease"`).
     */ easing: _propTypes["default"].string,
        /**
     * The function provided here will be called if the component transitions
     * from a closed state to an open state, or if it is mounted in an open
     * state. Note that this is called as soon as the state changes, which
     * occurs *before* the elements being mounted are actually available in
     * the DOM.
     */ onOpen: _propTypes["default"].func
    }), (0, _defineProperty2["default"])(_class, "defaultProps", {
        duration: "150ms",
        easing: "ease",
        open: false
    }), (0, _defineProperty2["default"])(_class, "displayName", "WithAnimateMount(".concat(getsDisplayName(WrappedComponent), ")")), _temp;
};
var _default = withAnimateMount;
exports["default"] = _default;

},{"a422eb1a4eb89a4e":"5qxSW","9ae88e7b548e93bc":"fAmfl","9aeb9067310b9795":"aqLjQ","7210569638952c5b":"8X7ov","63b7c79b33f92d23":"fA0LA","b10430e9ce49baed":"hAMmu","c182b9d440835a68":"37tJc","5acf25bf725fb523":"cE6Se","d01149def2029031":"avcfc","9946f6f316f35d18":"6uln9","26c384261d24991":"9Mqtv"}],"4aoef":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2ccadc05abb9d548");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("f7b21705f3e09eaa"));
var _createClass2 = _interopRequireDefault(require("6778517512b5dea7"));
var _assertThisInitialized2 = _interopRequireDefault(require("98abdd738368146b"));
var _inherits2 = _interopRequireDefault(require("db53df865939c365"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("4197bd43c3725911"));
var _getPrototypeOf2 = _interopRequireDefault(require("491f16f60d5c1997"));
var _defineProperty2 = _interopRequireDefault(require("e84841954f8473c1"));
var _react = _interopRequireDefault(require("aefc1cbe73257ea4"));
var _propTypes = _interopRequireDefault(require("88e6d6d547bc4790"));
var _emotion = require("85ca9e4e2c7b9a89");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(opacity, duration, easing) {
    return (0, _emotion.css)({
        opacity: opacity,
        transition: "opacity ".concat(duration, " ").concat(easing)
    });
};
var AnimateFade = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateFade, _React$Component);
    var _super = _createSuper(AnimateFade);
    function AnimateFade() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateFade);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            opacity: 0
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Set state to trigger intro animation
            _this.timer = setTimeout(_this.updateStateOnMount, 0);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            // Update state for unmount animation
            _this.setState({
                opacity: 0
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            // Update state for mount animation
            _this.setState({
                opacity: 1
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
            if (!_this.props.open) // Tell the wrapper component to remove the node on transition end when
            // the open prop is false
            _this.props.transitionEnd();
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateFade, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
                else if (!prevProps.open && this.props.open) this.updateStateOnMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clear our timer to prevent leaks
                clearTimeout(this.timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var opacity = this.state.opacity;
                var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, className = _this$props.className;
                var styles = mountStyled(opacity, duration, easing);
                return children({
                    className: (0, _emotion.cx)(className, styles),
                    onTransitionEnd: this.transitionEnd
                });
            }
        }
    ]);
    return AnimateFade;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateFade, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateFade.propTypes = {};
var _default = AnimateFade;
exports["default"] = _default;

},{"2ccadc05abb9d548":"5qxSW","f7b21705f3e09eaa":"aqLjQ","6778517512b5dea7":"8X7ov","98abdd738368146b":"fA0LA","db53df865939c365":"hAMmu","4197bd43c3725911":"37tJc","491f16f60d5c1997":"cE6Se","e84841954f8473c1":"avcfc","aefc1cbe73257ea4":"6uln9","88e6d6d547bc4790":"9Mqtv","85ca9e4e2c7b9a89":"1BAMo"}],"vd71g":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2dcf19b7e6bddc41");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("d91cf45056f218b6"));
var _createClass2 = _interopRequireDefault(require("162eee54f9d7b7b8"));
var _assertThisInitialized2 = _interopRequireDefault(require("423a40bb672a237c"));
var _inherits2 = _interopRequireDefault(require("77808ce77288b9c3"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("3f710939d5e0e2f8"));
var _getPrototypeOf2 = _interopRequireDefault(require("c5f69cd6fc1a1fb5"));
var _defineProperty2 = _interopRequireDefault(require("b52304aa68546628"));
var _react = _interopRequireDefault(require("9cd1fb317ec523ac"));
var _propTypes = _interopRequireDefault(require("ad22e6b43f91a293"));
var _emotion = require("3314e39fccef95f8");
var _waitAnimationFrame = _interopRequireDefault(require("23bd04fbc0ef7106"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(_ref) {
    var open = _ref.open, height = _ref.height, duration = _ref.duration, easing = _ref.easing;
    return (0, _emotion.css)({
        transform: "translateY(".concat(open ? "0" : "100%", ")"),
        height: height,
        overflow: "auto",
        transition: "transform ".concat(duration, " ").concat(easing)
    });
};
var AnimateSlideIn = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateSlideIn, _React$Component);
    var _super = _createSuper(AnimateSlideIn);
    function AnimateSlideIn() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateSlideIn);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            open: false
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMounted", false);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Wait one animation frame so that the DOM can settle after mounting the
            // element, then set the state to trigger the mount animation
            (0, _waitAnimationFrame["default"])(_this.updateStateOnMount);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            return _this.setState({
                open: false
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            if (_this.isMounted) _this.setState({
                open: true
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateSlideIn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.isMounted = true;
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.open && this.props.open) this.updateStateOnOpen();
                else if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.isMounted = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var state = this.state;
                var props = this.props;
                var styles = mountStyled({
                    open: state.open,
                    duration: props.duration,
                    easing: props.easing,
                    height: props.animateToHeight
                });
                return props.children({
                    open: state.open,
                    className: (0, _emotion.cx)(props.className, styles),
                    onTransitionEnd: this.props.transitionEnd
                });
            }
        }
    ]);
    return AnimateSlideIn;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateSlideIn, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateSlideIn.propTypes = {};
var _default = AnimateSlideIn;
exports["default"] = _default;

},{"2dcf19b7e6bddc41":"5qxSW","d91cf45056f218b6":"aqLjQ","162eee54f9d7b7b8":"8X7ov","423a40bb672a237c":"fA0LA","77808ce77288b9c3":"hAMmu","3f710939d5e0e2f8":"37tJc","c5f69cd6fc1a1fb5":"cE6Se","b52304aa68546628":"avcfc","9cd1fb317ec523ac":"6uln9","ad22e6b43f91a293":"9Mqtv","3314e39fccef95f8":"1BAMo","23bd04fbc0ef7106":"oJLwr"}],"yNOQB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6922a0775711c67");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("e59382acdde3480d"));
var _createClass2 = _interopRequireDefault(require("974f4c9e4c3415c9"));
var _assertThisInitialized2 = _interopRequireDefault(require("b89dff1f1bf3c44"));
var _inherits2 = _interopRequireDefault(require("97db0277cc5ee583"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("12d5f6657c627a13"));
var _getPrototypeOf2 = _interopRequireDefault(require("d048a7d11bf87ef5"));
var _defineProperty2 = _interopRequireDefault(require("fd69c8e74da16c8d"));
var _react = _interopRequireDefault(require("920288a0b4c03b15"));
var _propTypes = _interopRequireDefault(require("e2930997c405e21a"));
var _emotion = require("d6e97ca7db311b89");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(opacity, scale, duration, easing) {
    return (0, _emotion.css)({
        opacity: opacity,
        transform: "scale(".concat(scale, ")"),
        transition: "opacity ".concat(duration, " ").concat(easing, ", transform ").concat(duration, " ").concat(easing)
    });
};
var AnimateFadeScale = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateFadeScale, _React$Component);
    var _super = _createSuper(AnimateFadeScale);
    function AnimateFadeScale() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateFadeScale);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            opacity: 0,
            scale: 0.75
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Set state to trigger intro animation
            _this.timer = setTimeout(_this.updateStateOnMount, 0);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            // Update state for unmount animation
            _this.setState({
                opacity: 0,
                scale: 0.75
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            // Update state for mount animation
            _this.setState({
                opacity: 1,
                scale: 1
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
            if (!_this.props.open) // Tell the wrapper component to remove the node on transition end when
            // the open prop is false
            _this.props.transitionEnd();
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateFadeScale, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
                else if (!prevProps.open && this.props.open) this.updateStateOnMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clear our timer to prevent leaks
                clearTimeout(this.timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, opacity = _this$state.opacity, scale = _this$state.scale;
                var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, className = _this$props.className;
                var styles = mountStyled(opacity, scale, duration, easing);
                return children({
                    open: opacity !== 0,
                    className: (0, _emotion.cx)(className, styles),
                    onTransitionEnd: this.transitionEnd
                });
            }
        }
    ]);
    return AnimateFadeScale;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateFadeScale, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateFadeScale.propTypes = {};
var _default = AnimateFadeScale;
exports["default"] = _default;

},{"6922a0775711c67":"5qxSW","e59382acdde3480d":"aqLjQ","974f4c9e4c3415c9":"8X7ov","b89dff1f1bf3c44":"fA0LA","97db0277cc5ee583":"hAMmu","12d5f6657c627a13":"37tJc","d048a7d11bf87ef5":"cE6Se","fd69c8e74da16c8d":"avcfc","920288a0b4c03b15":"6uln9","e2930997c405e21a":"9Mqtv","d6e97ca7db311b89":"1BAMo"}],"iHMHx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * WHAT: This function makes it easy to detect a direct click on an element. It
 * will only trigger if both the mouse down and mouse up parts of the click
 * occurr directly on the element itself, and not the element's children.
 *
 * WHY: Listening for a direct click on an element, excluding its children, is
 * pretty tricky. You could try comparing event.target to event.currentTarget in
 * a click handler bound directly to the element, but that would still fire if
 * the click started on another element. For example if the user moused down on
 * a child element, moused over to the parent element, and released then a click
 * even would be fired on the parent where event.target was the same as
 * event.currentTarget. This same limitation applies to the method of trying to
 * call event.stopPropagation on click events from children to keep them from
 * bubbling up to parents. See https://sim.amazon.com/issues/MRDN-592 for why
 * triggering a click that started on another element can be problematic.

 * HOW: Usage of this utility is a little weird, but it's the only consistent
 * solution I could find to the problem. This function's only argument is the
 * onClick handler that should be called when a direct click is made. However
 * instead of returning some sort of more robust click handler it returns a
 * mouse down handler. This handler should be passed to the onMouseDown prop of
 * the element. For example:
 *
 * ```
 * const onClick = () => console.log("clicked directly on div!")
 *
 * // NOTE: onClick can't change after this point as onDirectClick stores it in
 * // memory. If onClick may change just inline this in your jsx (e.g.
 * // `onMouseDown={onDirectClick(onClick)}`).
 * const onMouseDown = onDirectClick(onClick)
 *
 * <div onMouseDown={onMouseDown}>
 *   <p>Clicking on this will not trigger a "direct" click on the parent</p>
 * </div>
 * ```
 *
 * Not super intuitive, but it works. This allows the utility to start listening
 * for clicks only when the user mouses down on the element, avoiding the
 * situation where a mousedown on another element, then a mouseover to our
 * element, then a mouse up would fire a click.
 */ var onDirectClick = function onDirectClick(callback) {
    // Listeners to add when the user mouses down on our element.
    var addListeners = function addListeners(node) {
        node.addEventListener("click", onClick);
        node.addEventListener("mouseout", onMouseOut);
    }; // Listeners to remove when the user finishes their click or mouses out of
    // the element.
    var removeListeners = function removeListeners(node) {
        node.removeEventListener("click", onClick);
        node.removeEventListener("mouseout", onMouseOut);
    }; // This is the final "direct" click handler.
    var onClick = function onClick(event) {
        removeListeners(event.target);
        callback(event);
    }; // If the user mouses out clear our listeners (and stop listening for a click
    // event, as it would no longer be directly on the element).
    var onMouseOut = function onMouseOut(event) {
        return removeListeners(event.target);
    }; // If the user mouses down directly on the element that this event is bound
    // to then start listening for a click event to finish things off.
    var onMouseDown = function onMouseDown(event) {
        if (event.target === event.currentTarget) addListeners(event.target);
    };
    return callback ? onMouseDown : undefined;
};
var _default = onDirectClick;
exports["default"] = _default;

},{}],"1ifmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emotion = require("emotion");
const SpanButton = ({ onClick, children })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _emotion.css)`
        cursor: pointer;
        color: #077398;
      `,
        onClick: onClick
    }, children);
};
exports.default = SpanButton;

},{"react":"6uln9","emotion":"1BAMo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnaDs":[function() {},{}],"7ESC2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _conditionsOfUse = require("../components/ConditionsOfUse");
var _conditionsOfUseDefault = parcelHelpers.interopDefault(_conditionsOfUse);
var _indexCss = require("../styles/index.css");
const TermsAndConditionsPage = ()=>{
    const pageRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        pageRef.current.scrollIntoView();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: pageRef,
        style: {
            position: "relative",
            backgroundColor: "#f3f3f3",
            height: "100%",
            overflow: "auto"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        alignmentHorizontal: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        maxWidth: (0, _breakpoints.DEVICE_WIDTHS).DESKTOP,
        type: "outline",
        backgroundColor: "white",
        spacingInset: "large large large large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _conditionsOfUseDefault.default), null))), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: "conditionsOfUse-end"
    }));
};
exports.default = TermsAndConditionsPage;

},{"@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/meridian/column":"jFRKf","react":"6uln9","../components/ConditionsOfUse":"cv5UJ","../styles/index.css":"bnaDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cv5UJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emotion = require("emotion");
var _heading = require("@amzn/meridian/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _divider = require("@amzn/meridian/divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _box = require("@amzn/meridian/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _conditionsOfUse = require("../constants/conditionsOfUse");
var _conditionOfUsePrivacyNoticePopup = require("./molecules/ConditionOfUsePrivacyNoticePopup");
var _conditionOfUsePrivacyNoticePopupDefault = parcelHelpers.interopDefault(_conditionOfUsePrivacyNoticePopup);
var _spanButton = require("./atoms/SpanButton");
var _spanButtonDefault = parcelHelpers.interopDefault(_spanButton);
var _marked = require("../utils/marked");
var _markedDefault = parcelHelpers.interopDefault(_marked);
var _common = require("../constants/common");
var _analytics1 = require("../constants/analytics");
const ConditionsOfUse = ()=>{
    const [translationPopupOpen, setTranslationPopupOpen] = (0, _react.useState)(false);
    const [popupContent, setPopupContent] = (0, _react.useState)("");
    const onTranslationPopupOpen = (locale, country)=>{
        setPopupContent((0, _markedDefault.default).parse((0, _conditionsOfUse.conditionOfUseContentCountryMap)[country][locale]));
        setTranslationPopupOpen(true);
    };
    const onTranslationPopupClose = ()=>{
        setPopupContent("");
        setTranslationPopupOpen(false);
    };
    const euConditionsOfUseRef = (0, _react.useRef)();
    const usConditionsOfUseRef = (0, _react.useRef)();
    const auConditionsOfUseRef = (0, _react.useRef)();
    const caConditionsOfUseRef = (0, _react.useRef)();
    const aeConditionsOfUseRef = (0, _react.useRef)();
    const brConditionsOfUseRef = (0, _react.useRef)();
    const inConditionsOfUseRef = (0, _react.useRef)();
    const mxConditionsOfUseRef = (0, _react.useRef)();
    const countryRefMap = {
        [(0, _common.COUNTRY_MAP).EU]: euConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).US]: usConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).AU]: auConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).CA]: caConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).AE]: aeConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).BR]: brConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).IN]: inConditionsOfUseRef,
        [(0, _common.COUNTRY_MAP).MX]: mxConditionsOfUseRef
    };
    const onConditionsOfUseNavButtonLink = (type)=>{
        if (countryRefMap[type].current?.scrollIntoView) countryRefMap[type].current.scrollIntoView({
            behavior: "smooth"
        });
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.CONDITIONS_OF_USE_REGION_BUTTON)
            },
            extra_properties: {
                name: type
            }
        });
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _conditionOfUsePrivacyNoticePopupDefault.default), {
        innerHtmlBodyContent: popupContent,
        open: translationPopupOpen,
        modalTitle: "Condition of Use",
        onClose: onTranslationPopupClose
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("article", {
        className: (0, _emotion.css)`
          & {
            font-family: AmazonEmber-Regular, Amazon Ember;
          }
        `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), {
        level: 1,
        type: "d50",
        className: (0, _emotion.css)`
            font-weight: 400 !important;
          `
    }, "Conditions of Use"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0"
    }, Object.keys((0, _conditionsOfUse.conditionsOfUseTitle)).map((type)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            className: (0, _emotion.css)`
                  & {
                    padding: 4px;
                  }
                `,
            type: "link",
            onClick: ()=>onConditionsOfUseNavButtonLink(type)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[type]))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: euConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).EU])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "September 19, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "French")), "Les Conditions d'Utilisation d'Amazon Carrier Logistics sont disponibles ci-dessous en anglais. Vous trouverez \xe9galement des liens vers les traductions", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR, (0, _common.COUNTRY_MAP).EU)
    }, "en fran\xe7ais"), ",", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES, (0, _common.COUNTRY_MAP).EU)
    }, "en espagnol"), " ", "et", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).IT_IT, (0, _common.COUNTRY_MAP).EU)
    }, "en italien"), " ", "de ces documents. En cas de conflit ou de divergence entre une version traduite de ces Conditions d'Utilisation et la version anglaise, la version anglaise pr\xe9vaut."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Italian")), "Le Condizioni d'uso di Amazon Carrier Logistics sono riportate di seguito in inglese. Vengono inoltre forniti i link alle traduzioni in lingua", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR, (0, _common.COUNTRY_MAP).EU)
    }, "francese"), ",", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES, (0, _common.COUNTRY_MAP).EU)
    }, "spagnola"), " ", "e", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).IT_IT, (0, _common.COUNTRY_MAP).EU)
    }, "italiana"), ". In caso di conflitto o discrepanza tra una versione tradotta delle Condizioni d'uso e la versione in lingua inglese, prevale la versione in lingua inglese."), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Spanish")), "Las Condiciones de Uso de Amazon Carrier Logistics se presentan a continuaci\xf3n en Ingl\xe9s. Nosotros tambi\xe9n proporcionamos enlaces a las traducciones en", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR, (0, _common.COUNTRY_MAP).EU)
    }, "Franc\xe9s"), ",", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES, (0, _common.COUNTRY_MAP).EU)
    }, "Espa\xf1ol"), " ", "e", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).IT_IT, (0, _common.COUNTRY_MAP).EU)
    }, "Italiano"), ". En caso de discrepancia entre una versi\xf3n traducida de estas Condiciones de Uso y la versi\xf3n en Ingl\xe9s, esta \xfaltima prevalecer\xe1."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "English")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.euConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: usConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).US])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "September 19, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.usConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: auConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).AU])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "October 18, 2023"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.auConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: caConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).CA])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "January 24, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "French")), "Les Conditions d'Utilisation d'Amazon Carrier Logistics sont disponibles ci-dessous en anglais. Vous trouverez \xe9galement des liens vers les traductions", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).FR_FR, (0, _common.COUNTRY_MAP).CA)
    }, "en fran\xe7ais"), " ", "de ces documents. En cas de conflit ou de divergence entre une version traduite de ces Conditions d'Utilisation et la version anglaise, la version anglaise pr\xe9vaut."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "English")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.caConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: aeConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).AE])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "February 28, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.aeConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: brConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).BR])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "March 14, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.brConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: inConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).IN])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "March 26, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.inConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        spacingInset: "400 0",
        ref: mxConditionsOfUseRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("u", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("b", null, (0, _conditionsOfUse.conditionsOfUseTitle)[(0, _common.COUNTRY_MAP).MX])), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "March 26, 2024"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "Spanish")), "Las Condiciones de Uso de Amazon Carrier Logistics se presentan a continuaci\xf3n en Ingl\xe9s. Nosotros tambi\xe9n proporcionamos enlaces a las traducciones en", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spanButtonDefault.default), {
        onClick: ()=>onTranslationPopupOpen((0, _common.LOCALES_MAP).ES_ES, (0, _common.COUNTRY_MAP).MX)
    }, "Espa\xf1ol"), ". En caso de discrepancia entre una versi\xf3n traducida de estas Condiciones de Uso y la versi\xf3n en Ingl\xe9s, esta \xfaltima prevalecer\xe1."), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("strong", null, "English")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, _markedDefault.default).parse((0, _conditionsOfUse.mxConditionsOfUse)[(0, _common.LOCALES_MAP).EN_US])
        }
    }))));
};
exports.default = ConditionsOfUse;

},{"react":"6uln9","emotion":"1BAMo","@amzn/meridian/heading":"8qIYS","@amzn/meridian/divider":"1prIe","@amzn/meridian/box":"dxZXY","@amzn/meridian/button":"k0QSK","@amzn/meridian/row":"ba4AQ","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","../constants/conditionsOfUse":"2vR55","./molecules/ConditionOfUsePrivacyNoticePopup":"kg9Nq","./atoms/SpanButton":"1ifmR","../utils/marked":"1zMo8","../constants/common":"4gLZS","../constants/analytics":"zH2LJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2vR55":[function(require,module,exports) {
/* eslint-disable no-irregular-whitespace */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "euConditionsOfUse", ()=>euConditionsOfUse);
parcelHelpers.export(exports, "usConditionsOfUse", ()=>usConditionsOfUse);
parcelHelpers.export(exports, "auConditionsOfUse", ()=>auConditionsOfUse);
parcelHelpers.export(exports, "caConditionsOfUse", ()=>caConditionsOfUse);
parcelHelpers.export(exports, "aeConditionsOfUse", ()=>aeConditionsOfUse);
parcelHelpers.export(exports, "brConditionsOfUse", ()=>brConditionsOfUse);
parcelHelpers.export(exports, "inConditionsOfUse", ()=>inConditionsOfUse);
parcelHelpers.export(exports, "mxConditionsOfUse", ()=>mxConditionsOfUse);
parcelHelpers.export(exports, "conditionsOfUseTitle", ()=>conditionsOfUseTitle);
parcelHelpers.export(exports, "conditionOfUseContentCountryMap", ()=>conditionOfUseContentCountryMap);
var _common = require("./common");
const euConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `

Welcome to Amazon Carrier Logistics. 

Amazon EU Sarl and/or its affiliates ("Amazon") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the "Website"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "Amazon Services"). Please see our\xa0[Privacy Notice](/privacy-notice) and our\xa0[Cookies Notice](https://www.amazon.com/gp/help/customer/display.html/?nodeId=201890250) to understand how we collect and process your personal information through Amazon Services. Amazon provides the Amazon Services subject to the conditions set out on this page. \u{201C}Amazon Carrier Logistics\u{201D} is the trading name for Amazon.

**Conditions of Use**

**Please read these conditions carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these conditions.**\xa0We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.

**1. ELECTRONIC COMMUNICATIONS**

When you use any Amazon Service or send e-mails to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the Website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communications be in writing, unless mandatory applicable laws specifically require a different form of communication.

**2. RECOMMENDATIONS AND PERSONALISATION**

As part of the Amazon Services, we will recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalise your experience.

**3. COPYRIGHT, AUTHORS' RIGHTS AND DATABASE RIGHTS**

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by Luxembourg and international copyright, authors' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by Luxembourg and international copyright and database right laws.

You may not extract and/or re-utilise parts of the content of any Amazon Service without our express written consent. In particular, you may not utilise any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilisation any substantial parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.

**4. TRADEMARKS**

[Click here to see a non-exhaustive list of Amazon trademarks](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910). In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

**5. PATENTS**

One or more patents owned by Amazon apply to the Amazon Services and to the features and services accessible via the Amazon Services. Portions of the Amazon Services operate under license of one or more patents.\xa0

**6. LICENCE AND ACCESS**

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable licence to access and make personal and non-commercial use of the Amazon Services. This licence does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilising Amazon's names or trademarks without our express written consent.

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licences granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

**7. YOUR ACCOUNT**

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account. If you use any Amazon Service you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorised manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. You can access your information in the\xa0Your Account\xa0section of the Website. 

You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance, inconvenience or anxiety.

We reserve the right to refuse any Amazon Services or terminate accounts if your behaviour gives justified reason to do so. This will in particular be the case if you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are all accessible on the Website. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.

**8. REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT**

Where the functionality exists to do so, if visitors post reviews, comments and other content; send other communications; and submit suggestions, ideas, comments, questions or other information, the content must not be illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and must not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of "spam". You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but not, in the absence of a valid\xa0[Report Infringement Form](https://www.amazon.com/report/infringement/signin), the obligation) to remove or edit such content. If you believe that any content on or advertised for sale on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate\xa0[Report Infringement Form](https://www.amazon.com/report/infringement/signin) and we will respond.

If you post customer reviews, comments, customer questions or answers, or other content generated by you for display on the Website (including any images, video or audio, all together "content", you grant Amazon (a) a non-exclusive, royalty-free licence to use, reproduce, publish, make available, translate and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.

You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as at the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content ([Report Infringement Form](https://www.amazon.com/report/infringement/signin)) arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly.

**9. INTELLECTUAL PROPERTY CLAIMS**

Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been used in a way that gives rise to concerns of infringement, please follow our\xa0[Report Infringement Form](https://www.amazon.com/report/infringement/signin).

**10. AMAZON SOFTWARE TERMS**

In addition to these Conditions of Use, the following Software Terms\xa0apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the "Amazon Software"):

1. **Use of the Amazon Software.**\xa0You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by these Conditions of Use, these Software Terms, and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use, or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by Luxembourg and international copyright laws.

1. **Use of Third Party Services.**\xa0When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties.

1. **No Reverse Engineering.**\xa0Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorise any other person to copy, modify, reverse engineer, decompile or disassemble, or otherwise tamper with, the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software.

1. **Updates.**\xa0In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you.

**11. OUR LIABILITY**

We will do our utmost to ensure that availability of the Amazon Services will be uninterrupted and that transmissions will be error-free. However, due to the nature of the internet, this cannot be guaranteed. Also, your access to Amazon Services may also be occasionally suspended or restricted to allow for repairs, maintenance, or the introduction of new facilities or services. We will attempt to limit the frequency and duration of any such suspension or restriction.

Amazon will not be responsible for (i) losses that were not caused by any breach on our part, or (ii) any business loss (including loss of profits, revenue, contracts, anticipated savings, data, goodwill or wasted expenditure), or (iii) any indirect or consequential losses that were not foreseeable to both you and us when you commenced using the Amazon Services.

We will not be held responsible for any delay or failure to comply with our obligations under these conditions if the delay or failure arises from any cause which is beyond our reasonable control. 

The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above limitations may not apply to you and you might have additional rights.

Nothing in these conditions limits or excludes our responsibility for fraudulent representations made by us or for death or personal injury caused by our negligence or wilful misconduct.

**12. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY**

THE AMAZON SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES ARE PROVIDED BY AMAZON ON AN \u{201C}AS IS\u{201D} AND \u{201C}AS AVAILABLE\u{201D} BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING. AMAZON MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE AMAZON SERVICES OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES, UNLESS OTHERWISE SPECIFIED IN THE AGREEMENT. YOU EXPRESSLY AGREE THAT YOUR USE OF THE AMAZON SERVICES IS AT YOUR SOLE RISK. TO THE FULL EXTENT PERMISSIBLE BY LAW, AMAZON DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. AMAZON DOES NOT WARRANT THAT THE AMAZON SERVICES; INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES; AMAZON\u{2019}S SERVERS; OR ELECTRONIC COMMUNICATIONS SENT FROM AMAZON ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, AMAZON WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY AMAZON SERVICE OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY AMAZON SERVICE, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING.

**13. APPLICABLE LAW**

If you are in an EU member state, these conditions are governed by and construed in accordance with the laws of Grand Duchy of Luxembourg, and the application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. We both agree to submit to the exclusive jurisdiction of the courts of the city of Luxembourg.   

If you are in the United Kingdom, you agree that the laws of England and Wales, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon. The application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. You irrevocably submit to the exclusive jurisdiction of the courts of England. Any dispute or claim relating in any way to your use of the Website will be resolved by bringing a claim before a relevant competent court in England. You waive all objections to the jurisdiction and venue of such courts.

If you would like to bring a matter to our attention, please\xa0[contact us](mailto:carrierlogistics-admin@amazon.com).

**14. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE**

We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.

**15. WAIVER**

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

**16. OUR CONTACT DETAILS**

This Website is owned and maintained by Amazon EU Sarl: 

38 Avenue John F. Kennedy

Luxembourg, 1855 

Luxembourg

**17. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS**

If you believe that your intellectual property rights have been infringed, please submit your complaint using our online\xa0[Report Infringement Form](https://www.amazon.com/report/infringement/signin). This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims

Upon receipt of a complaint we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint.

**Important Warning:**\xa0giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions.
        `,
    [(0, _common.LOCALES_MAP).ES_ES]: `
  17 de julio de 2023

Te damos la bienvenida a Amazon Carrier Logistics.

Amazon EU Sarl o sus \u{FB01}liales  (\u{201C}Amazon\u{201D}) te proporcionan funciones del sitio web y otros productos y servicios  cuando visitas carrierlogistics.amazon.com (el \u{201C}Sitio Web\u{201D}), utilizas productos o Servicios de Amazon,  utilizas aplicaciones de Amazon  para  m\xf3viles o utilizas software proporcionado por Amazon  en relaci\xf3n con cualquiera de los anteriores (colectivamente, \u{201C}Servicios de Amazon\u{201D}).

Visita nuestro  [Aviso de privacidad ](/privacy-notice)y nuestro  [Aviso sobre cookies ](https://www.amazon.com/gp/help/customer/display.html/?nodeId=201890250)para  saber c\xf3mo  recopilamos y tramitamos tu informaci\xf3n personal mediante los Servicios de Amazon.  Amazon presta los Servicios de Amazon  de conformidad con las condiciones dispuestas en la presente p\xe1gina. \u{201C}Amazon Carrier Logistics\u{201D} es el nombre comercial de Amazon.

__Condiciones de uso__

__Consulta  las presentes condiciones detenidamente antes de utilizar los Servicios de Amazon.  Al utilizar los Servicios de Amazon, declaras que aceptas regirte  por estas condiciones.__ Ofrecemos una amplia gama de Servicios de Amazon y, a veces, pueden aplicarse condiciones adicionales. Cuando utilices un Servicio de Amazon, tambi\xe9n estar\xe1s sujeto a los t\xe9rminos, directrices y condiciones aplicables a ese Servicio de Amazon (\u{201C}Condiciones del Servicio\u{201D}). Si las presentes Condiciones de Uso entran en con\u{FB02}icto con las Condiciones de Servicio, dichas Condiciones de Servicio prevalecer\xe1n.

__1. COMUNICACIONES ELECTR\xd3NICAS__

Cuando utilizas cualquier Servicio de Amazon o nos env\xedas correos electr\xf3nicos, te comunicas con nosotros de forma electr\xf3nica. Nos comunicaremos contigo electr\xf3nicamente de diversas formas, por ejemplo, por correo electr\xf3nico, mensajes de texto, notificaciones push en la aplicaci\xf3n o publicando mensajes o comunicaciones por correo electr\xf3nico en el Sitio Web o a trav\xe9s de los dem\xe1s Servicios de Amazon.  A efectos contractuales, aceptas que todos los acuerdos, avisos, divulgaciones y otras comunicaciones que te proporcionemos electr\xf3nicamente cumplen con cualquier requisito legal  de que  dichas  comunicaciones se realicen por escrito, a menos que  las leyes obligatorias aplicables exijan espec\xed\u{FB01}camente una  forma de comunicaci\xf3n diferente.

__2. RECOMENDACIONES Y PERSONALIZACI\xd3N__

Como parte de los Servicios de Amazon, recomendaremos funciones, productos y servicios, incluidos anuncios de terceros que puedan interesarte, identi\u{FB01}caremos tus preferencias y personalizaremos tu experiencia.

__3. COPYRIGHT, DERECHOS DE AUTOR Y DERECHOS RELATIVOS A BASES DE DATOS__

Todo el contenido incluido o disponible mediante cualquier Servicio de Amazon, como texto, gr\xe1\u{FB01}cos, logotipos, iconos  de botones, im\xe1genes, clips de audio,  descargas digitales y recopilaciones de datos, es propiedad de Amazon  o de sus proveedores de contenido y est\xe1 protegido por las leyes luxemburguesas e internacionales de derechos de autor, derechos de autor y derechos de bases de datos. La recopilaci\xf3n de todo el contenido incluido o disponible por medio de cualquier Servicio de Amazon es propiedad exclusiva de Amazon y est\xe1 protegida por las leyes luxemburguesas e internacionales de derechos de autor y derechos de bases de datos.

__4. MARCAS REGISTRADAS__

[Haz clic aqu\xed para ver una lista no exhaustiva de marcas comerciales de Amazon](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910).  Adem\xe1s, los gr\xe1\u{FB01}cos, los logotipos, los encabezados de p\xe1gina, los iconos  de botones, los scripts y los nombres de servicios  incluidos o disponibles a trav\xe9s de cualquier Servicio de Amazon son marcas comerciales o im\xe1genes comerciales de Amazon.  Las marcas comerciales e im\xe1genes comerciales de Amazon no pueden utilizarse en conexi\xf3n con ning\xfan producto o servicio que no sea de Amazon  de ninguna manera que pueda causar confusi\xf3n entre los clientes o desacredite o perjudique a Amazon.  Todas las dem\xe1s marcas comerciales que no pertenezcan a Amazon y que aparezcan en cualquier Servicio de Amazon son propiedad de sus respectivos due\xf1os, que pueden estar o no a\u{FB01}liados, vinculados o patrocinados por Amazon.

__5. PATENTES__

Se aplican una o m\xe1s patentes propiedad de Amazon en los Servicios de Amazon y en las funciones y servicios accesibles a trav\xe9s de los Servicios de Amazon.  Algunas partes de los Servicios de Amazon operan bajo licencia de una o m\xe1s patentes.

__6. LICENCIA Y ACCESO__

Sujeto a tu cumplimiento de las presentes Condiciones de Uso y de las Condiciones de Servicio pertinentes, as\xed como al pago de las tarifas aplicables, Amazon  o sus proveedores de contenido te otorgan una  licencia limitada, no exclusiva,  intransferible y no sublicenciable para  acceder a los Servicios de Amazon  y realizar un uso personal y no comercial de ellos. Esta licencia no incluye la reventa ni el uso comercial de ning\xfan Servicio de Amazon o su contenido; la recopilaci\xf3n y el uso de descripciones o precios;  ning\xfan uso derivado de ning\xfan Servicio de Amazon  o su contenido; la descarga o copia  de la informaci\xf3n de la cuenta para  bene\u{FB01}cio de otro comerciante; ni el uso de miner\xeda de datos, robots o herramientas similares de recopilaci\xf3n y extracci\xf3n de datos.

Todos los derechos que no se te conceden expresamente en las presentes Condiciones de Uso y cualesquiera Condiciones de Servicio son reservados y retenidos por Amazon  o sus licenciantes, proveedores, editores y titulares de derechos, u otros proveedores de contenido. Ning\xfan Servicio de Amazon, ni ninguna parte de ning\xfan Servicio de Amazon, puede ser reproducido, duplicado, copiado, vendido, revendido, visitado o explotado de otro modo para ning\xfan prop\xf3sito comercial sin el consentimiento expreso por escrito

No puedes hacer un uso indebido de los Servicios de Amazon.  Puedes utilizar los Servicios de Amazon solo en la medida en la que lo permita la legislaci\xf3n pertinente. Las licencias otorgadas por Amazon  se rescindir\xe1n si no cumples con las presentes Condiciones de uso o con cualquiera de las Condiciones de servicio.

__7. TU CUENTA__

Es posible que necesites tu propia cuenta de Amazon para usar ciertos Servicios de Amazon y que tengas que iniciar sesi\xf3n en la cuenta. Si utilizas cualquier Servicio de Amazon, es responsabilidad tuya mantener la con\u{FB01}dencialidad de tu cuenta y tu contrase\xf1a, y de restringir el acceso a tu equipo inform\xe1tico y, en la medida en que lo permita la legislaci\xf3n aplicable, aceptas la responsabilidad de todas las actividades que se lleven a cabo con tu cuenta o contrase\xf1a. Debes tomar todas las medidas necesarias para garantizar la con\u{FB01}dencialidad y seguridad continuas de la contrase\xf1a, y debes informarnos inmediatamente si tienes alg\xfan motivo para creer que alguien m\xe1s conoce tu contrase\xf1a, o si la contrase\xf1a se est\xe1 utilizando o es probable que se utilice de manera no autorizada. Es responsabilidad tuya garantizar que los datos y detalles que nos facilites sean \u{FB01}eles y correctos y est\xe9n completos, as\xed como de informarnos de cualquier cambio en la informaci\xf3n que nos hayas proporcionado. Puedes acceder a tu informaci\xf3n en la secci\xf3n Mi Cuenta del Sitio Web.

No debes utilizar ning\xfan Servicio de Amazon:  (i) de forma que  cause,  o pueda provocar, que  un Servicio de Amazon  o cualquier acceso al mismo se interrumpa, da\xf1e o deteriore de alguna manera; o (ii) con \u{FB01}nes  fraudulentos o en relaci\xf3n con un delito u otra actividad ilegal; o (iii) para  causar molestias, inconvenientes o ansiedad.

Nos reservamos el derecho de rechazar cualquier Servicio de Amazon o rescindir cuentas si tu comportamiento da motivos justi\u{FB01}cados para  hacerlo. Este ser\xe1  el caso, en particular, si infringes la legislaci\xf3n pertinente, las disposiciones contractuales aplicables, nuestras directrices o nuestras pol\xedticas, a las que  se puede acceder en el Sitio Web. Sin perjuicio de dicha limitaci\xf3n o rescisi\xf3n, seguir\xe1s teniendo acceso al contenido y los servicios  que  haya  adquirido hasta ese momento.

__8. RESE\xd1AS, COMENTARIOS, COMUNICACIONES Y OTRO CONTENIDO__

Si se dispone de capacidad o funci\xf3n para  hacerlo, si los visitantes publican rese\xf1as, comentarios y otro contenido; env\xedan otras comunicaciones; y env\xedan sugerencias, ideas,  comentarios, preguntas u otra informaci\xf3n, el contenido correspondiente no debe ser ilegal, obsceno, abusivo, amenazante, difamatorio o invasivo  de la privacidad, ni infringir  los derechos de propiedad intelectual ni da\xf1ar de otro modo a terceros ni censurable y no debe consitir ni contener virus inform\xe1tico, campa\xf1as pol\xedticas, solicitudes comerciales, cadenas cartas, correos masivos o cualquier forma de correo no deseado o \u{201C}spam\u{201D}  ni incluir o incorporar cualesquiera de estos elementos. No puedes usar direcciones de correo electr\xf3nico falsas,  suplantar a personas o entidades, ni enga\xf1ar de manera alguna con respecto a la fuente de tarjetas u otro contenido. Nos reservamos el derecho (pero  no, a falta de un documento v\xe1lido [Formulario de denuncia de infracci\xf3n](https://www.amazon.com/report/infringement/signin), la obligaci\xf3n) de eliminar o editar dicho  contenido. Si crees  que  alg\xfan contenido de un Servicio de Amazon  o que  se anuncia para  su venta contiene una  declaraci\xf3n difamatoria o que  un producto o informaci\xf3n de alg\xfan Servicio de Amazon  est\xe1n infringiendo tus derechos de propiedad intelectual, av\xedsanos rellenando y enviando los correspondientes [Formulario de denuncia de infracci\xf3n ](https://www.amazon.com/report/infringement/signin)y responderemos.

Puedes eliminar tu contenido de la vista p\xfablica o, cuando se ofrezca dicha  funcionalidad, cambiar la con\u{FB01}guraci\xf3n para  que  solo se muestre a las personas a las que  concedas acceso.

Declaras y garantizas que  posees o controlas todos los derechos sobre el contenido que  publicas; que,  en la fecha en que  se publica el contenido o el material: (i) el contenido y el material son exactos; y (ii) el uso del contenido y el material que  facilitas no suponen infracci\xf3n de ninguna pol\xedtica o normativa aplicable y no provocar\xe1 da\xf1os o perjuicios a ninguna persona o entidad, incluida  la ausencia de car\xe1cter difamatorio de dicho  contenido o material. Aceptas indemnizar a Amazon  por todas las reclamaciones interpuestas por un tercero contra Amazon  relacionadas con el contenido y el material que  facilites o est\xe9n relacionadas con ellos, excepto en la medida en que  surja cualquier responsabilidad por nuestra incapacidad para  eliminar el contenido correctamente cuando se nos noti\u{FB01}que la naturaleza ilegal del contenido ([Formulario de denuncia de infracci\xf3n](https://www.amazon.com/report/infringement/signin)) que  surja o se base  en el contenido que  nos has comunicado o que  se origine a partir de este. Al eliminar el contenido de la vista p\xfablica, retiras tu licencia para  que Amazon  publique y ponga a disposici\xf3n del p\xfablico ese contenido.

__9. RECLAMACIONES DE PROPIEDAD INTELECTUAL__

Amazon  respeta la propiedad intelectual de otros. Si crees  que  tus derechos de propiedad intelectual se han  utilizado de una manera que  suscita preocupaci\xf3n por una  infracci\xf3n, sigue  nuestro  [Formulario de denuncia de infracci\xf3n](https://www.amazon.com/report/infringement/signin).

__10. CONDICIONES DE SOFTWARE DE AMAZON__

Adem\xe1s de las presentes Condiciones de Uso, los siguientes T\xe9rminos de Software se aplican a cualquier software (incluidas las actualizaciones o mejoras del software y cualquier documentaci\xf3n relacionada) que  pongamos a tu disposici\xf3n de vez en cuando para  tu uso en relaci\xf3n con los Servicios de Amazon  (el \u{201C}Software de Amazon\u{201D}):

2. __Uso de Servicios de Terceros.__ Cuando utilices el Software de Amazon,  es posible que  tambi\xe9n est\xe9s utilizando los servicios  de uno  o m\xe1s terceros, como  un operador de servicios  de telefon\xeda m\xf3vil o un proveedor de software para  telefon\xeda m\xf3vil. El uso de estos servicios  de terceros puede estar sujeto a las pol\xedticas, t\xe9rminos de uso y tarifas espec\xed\u{FB01}cas de dichos  terceros.

3. __Prohibici\xf3n de Ingenier\xeda Inversa.__ A menos que  lo permita expl\xedcitamente la legislaci\xf3n de obligado cumplimiento y en vigor aplicable, no podr\xe1s copiar,  modi\u{FB01}car, aplicar  ingenier\xeda inversa, descompilar o desensamblar o manipular de otro modo el Software de Amazon,  ya sea en su totalidad o en parte, ni crear  obras derivadas del Software de Amazon,  ni tampoco alentar a hacerlo, contribuir a hacerlo ni autorizar a cualquier persona que  lleve a cabo  cualesquiera de estas actividades.

4. __Actualizaciones.__ Para  poder mantener el Software de Amazon  actualizado, podemos ofrecer actualizaciones autom\xe1ticas o manuales en cualquier momento y sin previo  aviso.

__11. NUESTRA RESPONSABILIDAD__

Haremos todo lo posible para  garantizar que  la disponibilidad de los Servicios de Amazon  sea ininterrumpida y que  las transmisiones est\xe9n libres de errores. Sin embargo, debido a la naturaleza de Internet, esto no se puede garantizar. Adem\xe1s, tu acceso a los Servicios de Amazon  tambi\xe9n puede suspenderse o restringirse ocasionalmente para  permitir llevar a cabo  labores de reparaci\xf3n o mantenimiento o la incorporaci\xf3n de nuevas instalaciones o servicios.  Intentaremos limitar la frecuencia y la duraci\xf3n de dichas  suspensiones o restricciones.

Amazon  no ser\xe1  responsable de: (i) las p\xe9rdidas que  no hayan sido causadas por ning\xfan incumplimiento por nuestra parte; ni (ii) ninguna p\xe9rdida empresarial (incluida  la p\xe9rdida de bene\u{FB01}cios, ingresos, contratos, ahorros anticipados, datos, fondo de comercio o malgastos); ni (iii) ninguna p\xe9rdida indirecta o consecuente que  no pudi\xe9ramos prever ni t\xfa ni nosotros cuando empezaste a utilizar los Servicios de Amazon.

Las leyes de algunos pa\xedses no permiten algunas o todas las limitaciones indicadas anteriormente. Si debes cumplir con esta legislaci\xf3n, es posible que  algunas o todas las limitaciones anteriores no se apliquen en tu caso y que  tengas derechos adicionales.

Nada de lo dispuesto en las presentes condiciones limita ni excluye  nuestra responsabilidad por las declaraciones fraudulentas que realicemos o por la muerte o las lesiones personales causadas por nuestra negligencia o mala  conducta deliberada.

__12. EXENCI\xd3N DE GARANT\xcdAS Y LIMITACI\xd3N DE RESPONSABILIDAD__

LOS SERVICIOS DE AMAZON Y TODA LA INFORMACI\xd3N, EL CONTENIDO,  LOS MATERIALES, LOS PRODUCTOS (INCLUIDO EL SOFTWARE)  Y OTROS SERVICIOS INCLUIDOS EN LOS SERVICIOS DE AMAZON O DISPONIBLES MEDIANTE ELLOS SON PRESTADOS POR AMAZON  \u{201C}TAL Y COMO SON\u{201D} Y \u{201C}TAL COMO SE ENCUENTRAN DISPONIBLES\u{201D}, A MENOS QUE SE ESPECIFIQUE LO CONTRARIO POR ESCRITO. AMAZON NO HACE NINGUNA DECLARACI\xd3N O GARANT\xcdA DE NING\xdaN TIPO, EXPRESA O IMPL\xcdCITA, EN CUANTO A LA PRESTACI\xd3N DE LOS SERVICIOS DE AMAZON, O LA INFORMACI\xd3N, EL CONTENIDO,  LOS MATERIALES, LOS PRODUCTOS (INCLUIDO EL SOFTWARE)  U OTROS SERVICIOS INCLUIDOS O PUESTOS A TU DISPOSICI\xd3N  MEDIANTE LOS SERVICIOS DE AMAZON, A MENOS QUE SE ESPECIFIQUE LO CONTRARIO POR ESCRITO. ACEPTAS EXPRESAMENTE QUE TU USO DE LOS SERVICIOS DE AMAZON CORRE BAJO TU PROPIO RIESGO. EN LA MEDIDA EN QUE LO PERMITA LA LEY, AMAZON  NO SE HACE RESPONSABLE DE NING\xdaN TIPO DE GARANT\xcdA, IMPL\xcdCITA O EXPL\xcdCITA, LO QUE INCLUYE, ENTRE OTRAS, GARANT\xcdAS IMPL\xcdCITAS DE COMERCIABILIDAD E IDONEIDAD PARA UN FIN DETERMINADO. AMAZON NO GARANTIZA QUE LOS SERVICIOS DE AMAZON, LA INFORMACI\xd3N, EL CONTENIDO,  LOS MATERIALES, LOS PRODUCTOS (INCLUIDO EL SOFTWARE)  U OTROS SERVICIOS INCLUIDOS O DISPONIBLES MEDIANTE LOS SERVICIOS DE AMAZON, LOS SERVIDORES DE AMAZON O LAS COMUNICACIONES  ELECTR\xd3NICAS ENVIADAS DESDE AMAZON, EST\xc9N LIBRES DE VIRUS U OTROS COMPONENTES PERNICIOSOS. EN LA MEDIDA EN QUE LO PERMITA

LA LEY, AMAZON  NO SER\xc1 RESPONSABLE POR NING\xdaN DA\xd1O DE NING\xdaN TIPO QUE SURJA DEL USO DE CUALQUIER SERVICIO DE AMAZON, O DE CUALQUIER INFORMACI\xd3N, CONTENIDO, MATERIALES, PRODUCTOS (INCLUIDO EL SOFTWARE)  U OTROS SERVICIOS INCLUIDOS EN O PUESTOS A TU DISPOSICI\xd3N A TRAV\xc9S DE CUALQUIER SERVICIO DE AMAZON, INCLUYENDO, PERO

NO LIMITADO A, DA\xd1OS DIRECTOS, INDIRECTOS, INCIDENTALES, PUNITIVOS Y CONSECUENTES,  A MENOS QUE SE ESPECIFIQUE OTRA COSA POR ESCRITO.

__13. LEGISLACI\xd3N APLICABLE__

Si te encuentras en un estado miembro de la UE, las presentes condiciones se rigen  e interpretan de conformidad con las leyes del Gran Ducado de Luxemburgo, y se excluye  expresamente la aplicaci\xf3n de la Convenci\xf3n de las Naciones Unidas  sobre los Contratos de Compraventa Internacional de Mercader\xedas. Ambos aceptamos someternos a la jurisdicci\xf3n exclusiva  de los tribunales de la ciudad de Luxemburgo.

Si deseas poner un asunto en nuestro conocimiento [contacta con nosotros](mailto:carrierlogistics-admin@amazon.com).

__14. CAMBIOS EN EL SERVICIO  O MODIFICACIONES DE LAS CONDICIONES DE USO__

Nos reservamos el derecho de realizar cambios en cualquier momento en los servicios,  las pol\xedticas, los t\xe9rminos y condiciones de Amazon,  incluidas las presentes Condiciones de Uso y las Condiciones de Servicio. Estar\xe1s sujeto a los t\xe9rminos y condiciones, las pol\xedticas y las Condiciones de Uso vigentes en el momento en que  utilices los Servicios de Amazon.  Si alguna de las presentes Condiciones de Uso fuera considerada no v\xe1lida,  nula  o inaplicable por cualquier motivo, dicha  condici\xf3n se considerar\xe1 divisible  y no afectar\xe1 a la validez  y aplicabilidad de cualquier condici\xf3n restante.

__15. RENUNCIA__

Si incumples las presentes Condiciones de Uso y no tomamos ninguna medida, seguiremos teniendo derecho a hacer uso de nuestros derechos y recursos en cualquier otra situaci\xf3n en la que  infrinjas  las presentes Condiciones de Uso.

__16. NUESTROS DETALLES DE CONTACTO__

Este Sitio Web es propiedad de Amazon  EU Sarl, que  se encarga asimismo de su mantenimiento:

38 Avenue  John  F. Kennedy

Luxemburgo, 1855

Luxemburgo

__17. NOTIFICACI\xd3N Y PROCEDIMIENTO PARA PRESENTAR RECLAMACIONES DE INFRACCI\xd3N DE DERECHOS__

Si crees  que  se han  infringido tus derechos de propiedad intelectual, env\xeda tu queja mediante nuestra p\xe1gina en l\xednea  [Formulario de denuncia de infracci\xf3n](https://www.amazon.com/report/infringement/signin). El presente formulario se puede utilizar para  efectuar todo tipo de reclamaciones sobre propiedadintelectual, incluidas las relativas a copyright, marcas registradas, dise\xf1o y reclamaciones sobre patentes

__Advertencia Importante:__ proporcionar informaci\xf3n falsa,  enga\xf1osa o inexacta en el formulario de noti\u{FB01}caci\xf3n a Amazon  puede dar lugar  a responsabilidades civiles o penales. Ponte en contacto con un asesor legal  si tienes alguna pregunta.
`,
    [(0, _common.LOCALES_MAP).FR_FR]: `
  17 juillet 2023

Bienvenue sur Amazon Carrier Logistics.

Amazon EU Sarl et/ou ses soci\xe9t\xe9s affili\xe9es (\xab Amazon \xbb) vous fournissent des fonctionnalit\xe9s de site Web et d'autres produits et services lorsque vous visitez [carrierlogistics.amazon.com](http://carrierlogistics.amazon.com) (le \xab Site Web \xbb), utilisez les produits ou services Amazon, utilisez les applications Amazon pour appareil mobile, ou utilisez un logiciel fourni par Amazon en relation avec l'un des \xe9l\xe9ments pr\xe9c\xe9dents (collectivement, les \xab Services Amazon \xbb). Consultez la section suivante : [Politique de confidentialit\xe9](/privacy-notice) et notre [Politique sur les cookies](https://www.amazon.com/gp/help/customer/display.html/?nodeId=201890250) pour comprendre comment nous collectons et traitons vos informations personnelles par les biais des Services Amazon. Amazon fournit les Services Amazon sous r\xe9serve des conditions \xe9nonc\xe9es sur cette page. \xab Amazon Carrier Logistics \xbb est le nom commercial d'Amazon.

__Conditions d'utilisation__

__Lisez attentivement les pr\xe9sentes Conditions avant d\u{2019}utiliser les Services Amazon. En utilisant les Services Amazon, vous acceptez d\u{2019}\xeatre li\xe9 par ces Conditions.__ Nous proposons une large gamme de Services Amazon, et des conditions suppl\xe9mentaires peuvent parfois s\u{2019}appliquer. Lorsque vous utilisez un Service Amazon, vous \xeates \xe9galement soumis aux conditions g\xe9n\xe9rales applicables \xe0 ce Service Amazon (\xab Conditions du Service \xbb). En cas de contradiction entre les pr\xe9sentes Conditions d\u{2019}utilisation et les Conditions de Service, ces derni\xe8res pr\xe9vaudront.

1. __COMMUNICATIONS \xc9LECTRONIQUES__

Lorsque vous utilisez un Service Amazon ou que vous nous envoyez des e-mails, vous communiquez avec nous par voie \xe9lectronique. Nous communiquerons avec vous par voie \xe9lectronique de diff\xe9rentes mani\xe8res, notamment par e-mail, SMS, notifications push int\xe9gr\xe9es \xe0 l'application ou en publiant des messages \xe9lectroniques ou des communications sur le site Web ou via les autres Services Amazon. \xc0 des fins contractuelles, vous convenez que tous les accords, notifications, d\xe9clarations et autres communications que nous vous fournissons par voie \xe9lectronique satisfont \xe0 toute exigence l\xe9gale selon laquelle ces communications doivent \xeatre faites par \xe9crit, \xe0 moins que les lois applicables n'exigent sp\xe9cifiquement une forme de communication diff\xe9rente.

2. __RECOMMANDATIONS ET PERSONNALISATION__

Dans le cadre des Services Amazon, nous vous recommanderons des fonctionnalit\xe9s, produits et services, y compris des publicit\xe9s tierces susceptibles de vous int\xe9resser, nous identifierons vos pr\xe9f\xe9rences et personnaliserons votre exp\xe9rience.

3. __DROITS D'AUTEUR ET DROITS RELATIFS AUX BASES DE DONN\xc9ES__

Tout le contenu inclus ou mis \xe0 votre disposition par le biais d\u{2019}un Service Amazon, tel que le texte, les graphiques, les logos, les ic\xf4nes de bouton, les images, les clips audio, les t\xe9l\xe9chargements num\xe9riques et les compilations de donn\xe9es, est la propri\xe9t\xe9 d'Amazon ou de ses fournisseurs de contenu et est prot\xe9g\xe9 par les lois luxembourgeoises et internationales relatives aux droits d\u{2019}auteur et aux droits relatifs aux bases de donn\xe9es. La compilation de tout le contenu inclus ou mis \xe0 disposition par le biais d'un Service Amazon est la propri\xe9t\xe9 exclusive d'Amazon et est prot\xe9g\xe9e par les lois luxembourgeoises et internationales relatives aux droits d\u{2019}auteur et aux droits relatifs aux bases de donn\xe9es.

Vous n'\xeates pas autoris\xe9 \xe0 extraire et/ou \xe0 r\xe9utiliser des parties du contenu d'un Service Amazon sans notre consentement \xe9crit expr\xe8s. En particulier, vous n\u{2019}\xeates pas autoris\xe9 \xe0 utiliser des outils d'exploration de donn\xe9es, des robots ou tout autre outil similaire de collecte et d'extraction de donn\xe9es pour extraire (une ou plusieurs fois) tout contenu substantiel d\u{2019}un Service Amazon \xe0 des fins de r\xe9utilisation sans notre consentement \xe9crit expr\xe8s. Vous n\u{2019}\xeates pas non plus autoris\xe9 \xe0 cr\xe9er et/ou publier une base de donn\xe9es contenant des parties substantielles d'un Service Amazon (par ex. nos prix) sans notre consentement \xe9crit expr\xe8s.

4. __MARQUES__

[Cliquez ici pour consulter une liste non exhaustive des marques d\u{2019}Amazon](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910). En outre, les graphismes, logos, en-t\xeates, ic\xf4nes de boutons, programmes et noms des services inclus ou mis \xe0 disposition par l'interm\xe9diaire d'un Service Amazon sont des marques d'Amazon. Les marques d'Amazon ne peuvent pas \xeatre utilis\xe9es dans le cadre d'un produit ou d'un service qui n'est pas celui d'Amazon, d'une mani\xe8re susceptible de cr\xe9er une confusion chez les clients ou d'une mani\xe8re qui d\xe9nigre ou discr\xe9dite Amazon. Toutes les autres marques n'appartenant pas \xe0 Amazon apparaissant dans le cadre des Services Amazon sont la propri\xe9t\xe9 de leurs d\xe9tenteurs respectifs, qui peuvent ou non \xeatre affili\xe9s, reli\xe9s ou sponsoris\xe9s par Amazon.

5. __BREVETS__

Un ou plusieurs brevets d\xe9tenus par Amazon s'appliquent aux Services Amazon et aux fonctionnalit\xe9s et services accessibles par le biais des Services Amazon. Des parties des Services Amazon peuvent fonctionner sous licence d'un ou de plusieurs brevets.

6. __LICENCE ET ACC\xc8S__

Sous r\xe9serve du respect des pr\xe9sentes Conditions d'utilisation et Conditions de Service applicables et d\u{2019}\xe9ventuelles redevances applicables, Amazon ou ses fournisseurs de contenu vous conc\xe8dent une licence limit\xe9e, non exclusive, non transf\xe9rable et non susceptible de sous-licence vous permettant d'acc\xe9der aux Services Amazon et d'en faire un usage personnel et non commercial. Cette licence ne permet pas la revente ou l\u{2019}utilisation commerciale d\u{2019}un Service Amazon ou de ses contenus ; la collecte et l\u{2019}utilisation des descriptions ou prix ; toute utilisation d\xe9tourn\xe9e du Service Amazon ou de son contenu ; le t\xe9l\xe9chargement ou la copie

d'informations d\u{2019}un compte au profit d\u{2019}un autre commer\xe7ant ; l\u{2019}utilisation d'exploration de donn\xe9es, de robots ou d'outils similaires de collecte et d'extraction de donn\xe9es.

Tous les droits qui ne vous sont pas express\xe9ment conc\xe9d\xe9s dans les pr\xe9sentes Conditions d'utilisation ou dans les Conditions de Service sont conserv\xe9s par Amazon ou ses conc\xe9dants de licence, fournisseurs, \xe9diteurs, titulaires de droits ou autres fournisseurs de contenu. Aucun Service Amazon, ni aucune partie d'un Service Amazon ne peut \xeatre reproduit, dupliqu\xe9, copi\xe9, vendu, revendu, visit\xe9 ou exploit\xe9 de toute autre mani\xe8re \xe0 des fins commerciales sans notre consentement \xe9crit expr\xe8s. Vous ne pouvez pas encadrer ou utiliser de techniques d'encadrement (\xab framing \xbb) pour inclure une marque, un logo ou d'autres informations (y compris des images, du texte, une mise en page ou un formulaire) propri\xe9t\xe9s d'Amazon sans notre consentement \xe9crit expr\xe8s. Vous ne pouvez pas utiliser de balises m\xe9ta ou tout autre \xab texte masqu\xe9 \xbb utilisant le nom ou les marques d'Amazon sans notre consentement \xe9crit expr\xe8s.

Vous n'\xeates pas autoris\xe9 \xe0 utiliser les Services Amazon de mani\xe8re abusive. Vous ne pouvez utiliser les Services Amazon que dans les limites autoris\xe9es par la loi. En cas de non-respect des pr\xe9sentes Conditions d'utilisation ou de toutes Conditions de Service, les licences conc\xe9d\xe9es par Amazon prendront fin.

7. __VOTRE COMPTE__

Pour utiliser les Services Amazon, vous pouvez \xeatre amen\xe9 \xe0 disposer d\u{2019}un compte Amazon propre et \xe0 devoir vous connecter \xe0 ce compte. Si vous utilisez un Service Amazon, vous \xeates tenu de pr\xe9server la confidentialit\xe9 de votre compte et de votre mot de passe et de restreindre l'acc\xe8s \xe0 votre ordinateur. Dans la mesure permise par la loi applicable, vous acceptez d'assumer la responsabilit\xe9 de toutes les activit\xe9s effectu\xe9es avec votre compte ou votre mot de passe. Vous devez prendre toutes les mesures n\xe9cessaires pour garantir la confidentialit\xe9 et la s\xe9curit\xe9 de votre mot de passe, et nous informer imm\xe9diatement si vous avez des raisons de croire que votre mot de passe est connu de quelqu'un d'autre ou s'il est utilis\xe9 de mani\xe8re non autoris\xe9e, ou s\u{2019}il est susceptible de l\u{2019}\xeatre. Vous \xeates responsable de la v\xe9racit\xe9 et de l\u{2019}exhaustivit\xe9 des informations que vous nous fournissez. Il vous revient de nous informer de toute modification des informations fournies. Vous pouvez acc\xe9der \xe0 vos informations dans la section Votre compte du site Web.

Vous ne devez pas utiliser un Service Amazon : (i) d'une mani\xe8re entra\xeenant ou \xe9tant susceptible d\u{2019}entra\xeener l'interruption, l'endommagement ou la perturbation de tout acc\xe8s \xe0 celui-ci, ou (ii) \xe0 des fins frauduleuses, ou en relation avec une infraction p\xe9nale ou toute autre activit\xe9 ill\xe9gale, ou (iii) pour provoquer des nuisances, des d\xe9sagr\xe9ments ou d'autres troubles.

Nous nous r\xe9servons le droit de refuser l\u{2019}acc\xe8s \xe0 tout Service Amazon ou de proc\xe9der \xe0 une r\xe9siliation de compte si votre comportement le justifie. Ce sera notamment le cas si vous enfreignez les lois applicables, les dispositions contractuelles applicables, nos directives ou nos politiques, qui sont toutes accessibles sur le site Web. Nonobstant toute limitation ou r\xe9siliation, vous disposerez d\u{2019}un acc\xe8s au contenu et aux services que vous avez achet\xe9s jusqu'\xe0 cette date.

8. __AVIS, COMMENTAIRES, COMMUNICATIONS ET AUTRES CONTENUS__

Lorsque les fonctionnalit\xe9s le permettent, les visiteurs peuvent publier des avis, commentaires et autres contenus, et soumettre des suggestions, id\xe9es, commentaires, questions ou autres informations, tant que le contenu n'est pas ill\xe9gal, obsc\xe8ne, mena\xe7ant, diffamatoire, ne porte ni atteinte \xe0 la vie priv\xe9e ni aux droits de propri\xe9t\xe9 intellectuelle ou ne nuit pas \xe0 des tiers ou est r\xe9pr\xe9hensible, et ne contient pas de virus logiciels, de messages politiques, de d\xe9marchages commerciales, de cha\xeenes d\u{2019}e-mails, d\u{2019}envois massifs de publication ou toute forme de \xab spam \xbb ou pourriel. Vous ne pouvez pas utiliser de fausse adresse e-mail, usurper l'identit\xe9 d'une personne ou d'une entit\xe9, ou induire en erreur quant \xe0 l'origine d'une carte professionnelle ou d'un autre contenu. Nous nous r\xe9servons le droit (mais pas l'obligation, en l'absence d'un [Formulaire de signalement d'infraction valide](https://www.amazon.com/report/infringement/signin)) de supprimer ou modifier ce contenu. Si vous estimez qu'un contenu publi\xe9 ou mis en vente sur un Service Amazon contient des \xe9l\xe9ments diffamatoires, ou qu\u{2019}il y a une atteinte \xe0 vos droits de propri\xe9t\xe9 intellectuelle par un article ou une information sur un Service Amazon, veuillez-nous le notifier en remplissant et en nous soumettant le [Formulaire de signalement d'infraction](https://www.amazon.com/report/infringement/signin) appropri\xe9 et nous vous apporterons une r\xe9ponse.

Si vous publiez des avis client, des commentaires, des questions ou des r\xe9ponses, ou tout autre contenu que vous g\xe9n\xe9rez afin de l\u{2019}afficher sur le site Web (y compris des images, des vid\xe9os ou des fichiers audio, d\xe9sign\xe9s par le terme \xab contenu \xbb), vous accordez \xe0 Amazon (a) une licence non exclusive et libre de droits pour utiliser, reproduire, publier, mettre \xe0 disposition, traduire et modifier ce contenu dans le monde entier (y compris le droit de sous-licencier ces droits \xe0 des tiers) et (b) le droit d'utiliser le nom que vous indiquez dans le cadre de ce contenu. Aucun droit moral n'est transf\xe9r\xe9 par cette disposition.

Vous avez la possibilit\xe9 de rendre indisponible au public votre contenu ou, lorsque cette fonctionnalit\xe9 est propos\xe9e, de modifier les param\xe8tres de visibilit\xe9 afin que votre contenu ne soit visible que par les personnes \xe0 qui vous en autorisez l'acc\xe8s.

Vous confirmez et garantissez que vous d\xe9tenez l\u{2019}ensemble des droits sur le contenu que vous publiez ; qu'\xe0 la date de publication du contenu ou des informations : (i) le contenu et les informations sont exacts ; et (ii) l'utilisation du contenu et des informations que vous fournissez ne viole aucune disposition ou directive applicable et ne portera pr\xe9judice \xe0 aucune personne ou entit\xe9 (ce qui inclut l\u{2019}absence de caract\xe8re diffamatoire du contenu ou des informations). Vous acceptez d'indemniser Amazon de toute r\xe9clamation introduite par un tiers contre Amazon en rapport avec le contenu et les informations que vous fournissez, sauf dans la mesure o\xf9 la responsabilit\xe9 d\xe9coulerait de notre manquement \xe0 supprimer correctement le contenu apr\xe8s avoir \xe9t\xe9 notifi\xe9s de son caract\xe8re ill\xe9gal ([Formulaire de signalement d'infraction](https://www.amazon.com/report/infringement/signin)) r\xe9sultant du contenu que vous nous avez communiqu\xe9, ou se basant sur celui-ci. En rendant indisponible un contenu au public, vous retirez \xe0 Amazon sa licence lui permettant de publier et de mettre ce contenu \xe0 la disposition du public.

9. __R\xc9CLAMATIONS RELATIVES AUX DROITS DE PROPRI\xc9T\xc9 INTELLECTUELLE__

Amazon respecte la propri\xe9t\xe9 intellectuelle d\u{2019}autrui. Si vous pensez que vos droits de propri\xe9t\xe9 intellectuelle ont \xe9t\xe9 utilis\xe9s d'une mani\xe8re laissant craindre leur violation, r\xe9f\xe9rez-vous \xe0 la section suivante : [Formulaire de signalement d'infraction](https://www.amazon.com/report/infringement/signin). 

10. __CONDITIONS DU LOGICIEL AMAZON__

Outre les pr\xe9sentes Conditions d'utilisation, les Conditions du logiciel suivantes s'appliquent \xe0 tout logiciel (y compris toute mise \xe0 jour ou mise \xe0 niveau du logiciel et toute documentation associ\xe9e) que nous mettons parfois \xe0 votre disposition pour que vous

puissiez utiliser les Services Amazon (le \xab Logiciel Amazon \xbb) :

1. __Utilisation du logiciel Amazon.__ Vous \xeates autoris\xe9 \xe0 utiliser le Logiciel Amazon uniquement pour utiliser et profiter des Services Amazon tels que fournis par Amazon et conform\xe9ment aux pr\xe9sentes Conditions d'utilisation, aux pr\xe9sentes Conditions du logiciel et \xe0 toutes autres Conditions de Service. Vous n'\xeates pas autoris\xe9 \xe0 int\xe9grer une quelconque partie du Logiciel Amazon dans vos propres programmes ou \xe0 en compiler une quelconque partie en combinaison avec vos propres programmes, \xe0 le transf\xe9rer pour l'utiliser avec un autre service, ou \xe0 vendre, louer, pr\xeater, distribuer ou sous-licencier le Logiciel Amazon, ni attribuer de quelque mani\xe8re que ce soit des droits sur le Logiciel Amazon en tout ou en partie. Vous n'\xeates pas autoris\xe9 \xe0 utiliser le Logiciel Amazon \xe0 des fins ill\xe9gales. Nous pouvons cesser toute fourniture d\u{2019}un quelconque Logiciel Amazon et mettre fin \xe0 votre droit d'utilisation de ce Logiciel \xe0 tout moment. En cas de non-respect de l'une des pr\xe9sentes Conditions du logiciel, Conditions d'utilisation ou autres Conditions de Service, vous perdrez automatiquement vos droits d'utilisation du Logiciel Amazon et ceux-ci seront r\xe9sili\xe9s sans pr\xe9avis de notre part. Des conditions tierces suppl\xe9mentaires inclues ou distribu\xe9es avec certains Logiciels Amazon sp\xe9cifiquement identifi\xe9es dans la documentation associ\xe9e peuvent s'appliquer auxdits Logiciels Amazon (ou \xe0 un logiciel int\xe9gr\xe9 aux Logiciels Amazon). En cas de conflit avec les pr\xe9sentes Conditions d'utilisation, ces conditions tierces s\u{2019}appliqueront \xe0 l\u{2019}utilisation desdits logiciels. Tous les logiciels utilis\xe9s pour tout Service Amazon sont la propri\xe9t\xe9 d'Amazon ou de ses fournisseurs de logiciels et sont prot\xe9g\xe9s par les lois luxembourgeoises et internationales relatives au droit d\u{2019}auteur.
2. __Utilisation de services tiers.__ Lorsque vous utilisez le Logiciel Amazon, vous pouvez \xe9galement utiliser les services d'un ou de plusieurs tiers, tels qu'un op\xe9rateur de t\xe9l\xe9phonie mobile ou un fournisseur de plateforme mobile. Votre utilisation de ces services tiers peut \xeatre soumise aux politiques, conditions d'utilisation et frais distincts de ces tiers.
3. __Interdiction de r\xe9tro-ing\xe9nierie.__ Sauf autorisation expresse en vertu de la loi applicable, vous ne pouvez pas, et vous n'encouragerez, n'aiderez ou n'autoriserez aucune autre personne \xe0 copier, modifier, r\xe9tro-concevoir, d\xe9compiler, d\xe9sassembler ou alt\xe9rer de quelque mani\xe8re que ce soit, le Logiciel Amazon, que ce soit en tout ou en partie, ou \xe0 cr\xe9er des \u{153}uvres d\xe9riv\xe9es \xe0 partir du Logiciel Amazon.
4. __Mises \xe0 jour.__ Pour maintenir le Logiciel Amazon \xe0 jour, nous pouvons proposer des actualisations automatiques ou manuelles \xe0 tout moment et sans pr\xe9avis.

__11. NOTRE RESPONSABILIT\xc9__

Nous ferons tout notre possible pour garantir une disponibilit\xe9 continue des Services Amazon et des communications sans perturbations. Nous ne pouvons toutefois le garantir en raison de la nature d'Internet. Par ailleurs, votre acc\xe8s aux Services Amazon peut \xe9galement parfois \xeatre suspendu ou restreint pour permettre des corrections, des op\xe9rations de maintenance ou la mise en place de nouvelles fonctionnalit\xe9s ou de nouveaux services. Nous ferons notre possible pour limiter la fr\xe9quence et la dur\xe9e de telles suspensions ou restrictions.

Amazon ne sera pas responsable (i) des pertes qui n'ont pas \xe9t\xe9 caus\xe9es par un manquement de notre part, ou (ii) de toute perte commerciale (y compris la perte de profits, de revenus, de contrats, manque \xe0 gagner, de donn\xe9es, de client\xe8le ou toute d\xe9pense inutile), ou (iii) de toute perte directe ou indirecte qui n'\xe9tait pas pr\xe9visible pour vous comme pour nous lorsque vous avez commenc\xe9 \xe0 utiliser les Services Amazon.

Nous ne serons pas tenus responsables de tout retard ou manquement \xe0 respecter nos obligations en vertu des pr\xe9sentes Conditions si ce retard ou ce manquement r\xe9sulte d'une cause \xe9chappant \xe0 notre contr\xf4le raisonnable.

Les lois de certains pays n'autorisent pas tout ou partie des limitations d\xe9crites ci-dessus. Si ces lois vous sont applicables, il se peut que tout ou partie des limitations susmentionn\xe9es ne vous concernent pas et vous pourriez disposez de droits suppl\xe9mentaires.

Aucune disposition des pr\xe9sentes Conditions ne limite ou n'exclut notre responsabilit\xe9 en cas de d\xe9clarations frauduleuses de notre part ou en cas de d\xe9c\xe8s ou de blessures corporelles caus\xe9s par un acte de n\xe9gligence ou une faute de notre part.

12. __CLAUSE DE NON-RESPONSABILIT\xc9 EN MATI\xc8RE DE GARANTIES ET LIMITATION DE RESPONSABILIT\xc9__

LES SERVICES AMAZON ET TOUTES LES INFORMATIONS, LE CONTENU, LE MAT\xc9RIEL, LES PRODUITS (Y COMPRIS LES LOGICIELS) ET TOUS AUTRES SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS DES SERVICES AMAZON SONT FOURNIS PAR AMAZON \xab TELS QUELS \xbb ET \xab TELS QUE DISPONIBLES \xbb, SAUF INDICATION CONTRAIRE. AMAZON N\u{2019}OFFRE AUCUNE ASSURANCE OU GARANTIE DE QUELQUE NATURE QUE CE SOIT, EXPRESSE OU IMPLICITE, QUANT AU FONCTIONNEMENT DES SERVICES

AMAZON OU AUX INFORMATIONS, AU CONTENU, AUX MAT\xc9RIAUX, AUX PRODUITS (Y COMPRIS LES LOGICIELS) OU \xc0 TOUS SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS DES SERVICES AMAZON, SAUF INDICATION CONTRAIRE DANS L'ACCORD. VOUS ACCEPTEZ EXPRESS\xc9MENT D\u{2019}UTILISER LES SERVICES AMAZON \xc0 VOS RISQUES ET P\xc9RILS. DANS LE RESPECT DES DISPOSITIONS L\xc9GALES, AMAZON D\xc9CLINE TOUTE GARANTIE, EXPRESSE OU IMPLICITE, Y COMPRIS, MAIS SANS S'Y LIMITER, LES GARANTIES IMPLICITES DE QUALIT\xc9 MARCHANDE ET D'AD\xc9QUATION \xc0 UN USAGE PARTICULIER. AMAZON NE GARANTIT PAS QUE LES SERVICES AMAZON, LES INFORMATIONS, LE CONTENU, LES MAT\xc9RIAUX, LES PRODUITS (Y COMPRIS LES LOGICIELS) OU TOUS SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS DES SERVICES AMAZON, DE SES SERVEURS OU DES

COMMUNICATIONS \xc9LECTRONIQUES ENVOY\xc9ES PAR AMAZON SONT EXEMPTS DE VIRUS OU D'AUTRES COMPOSANTS NUISIBLES. DANS TOUTE LA MESURE PERMISE PAR LA LOI, AMAZON D\xc9CLINE TOUTE RESPONSABILIT\xc9 EN CAS DE DOMMAGES DE QUELQUE NATURE QUE CE SOIT R\xc9SULTANT DE L'UTILISATION D\u{2019}UN SERVICE AMAZON OU D\u{2019}INFORMATIONS, CONTENUS, MAT\xc9RIELS, PRODUITS (Y COMPRIS LES LOGICIELS) OU TOUS SERVICES INCLUS OU MIS \xc0 VOTRE DISPOSITION PAR LE BIAIS D\u{2019}UN SERVICE AMAZON, Y COMPRIS, MAIS SANS S'Y LIMITER, LES DOMMAGES DIRECTS, INDIRECTS, ACCESSOIRES, PUNITIFS ET CONS\xc9CUTIFS, SAUF INDICATION \xc9CRITE CONTRAIRE.

13. __LOI APPLICABLE__

Si vous vous trouvez dans un \xc9tat membre de l'UE, ces Conditions sont r\xe9gies et interpr\xe9t\xe9es conform\xe9ment aux lois du Grand-Duch\xe9 de Luxembourg. L'application de la Convention des Nations Unies sur les contrats de vente internationale de marchandises est express\xe9ment exclue. Les deux parties acceptent de se soumettre \xe0 la comp\xe9tence exclusive des tribunaux de la ville de

Luxembourg.

Depuis le Royaume-Uni, vous acceptez que les lois de l'Angleterre et du Pays de Galles, sans \xe9gard aux principes de conflit de lois, r\xe9gissent les pr\xe9sentes Conditions d\u{2019}utilisation et tout litige de quelque nature que ce soit pouvant survenir entre vous et Amazon. L'application de la Convention des Nations Unies sur les contrats de vente internationale de marchandises est express\xe9ment exclue. Vous vous soumettez irr\xe9vocablement \xe0 la juridiction exclusive des tribunaux d'Angleterre. Tout litige ou toute r\xe9clamation li\xe9 de quelque mani\xe8re que ce soit \xe0 votre utilisation du Site Web sera r\xe9solu en pr\xe9sentant une plainte devant un tribunal comp\xe9tent en Angleterre. Vous renoncez \xe0 toute objection quant \xe0 la comp\xe9tence et \xe0 l\u{2019}endroit de ces tribunaux.

En cas de question ou de r\xe9clamation, [contactez-nous](mailto:carrierlogistics-admin@amazon.com).

14. __MODIFICATIONS DU SERVICE OU DES CONDITIONS D'UTILISATION__

Nous nous r\xe9servons le droit de modifier \xe0 tout moment les Services Amazon, politiques et conditions g\xe9n\xe9rales, y compris les pr\xe9sentes Conditions d\u{2019}utilisation et de Service. Au moment de votre utilisation des Services Amazon, vous serez soumis aux conditions g\xe9n\xe9rales, politiques et Conditions d'utilisation en vigueur. Si une des pr\xe9sentes Conditions d\u{2019}utilisation est jug\xe9e invalide, nulle ou, pour quelque raison que ce soit, inapplicable, cette condition sera consid\xe9r\xe9e comme ind\xe9pendante et n'affectera pas la validit\xe9 et l'applicabilit\xe9 de toute autre condition.

15. __RENONCIATION__

Si vous enfreignez les pr\xe9sentes Conditions d\u{2019}utilisation et que nous ne prenons aucune mesure, nous pourrons toujours exercer nos droits et recours dans tout autre cas o\xf9 vous violeriez lesdites Conditions d\u{2019}utilisation.

16. __NOS COORDONN\xc9ES__

Ce Site Web est d\xe9tenu et g\xe9r\xe9 par Amazon EU Sarl :

38 Avenue John F. Kennedy

Luxembourg, 1855

Luxembourg

17. __AVIS ET PROC\xc9DURE DE R\xc9CLAMATION EN CAS DE VIOLATION DE DROITS__

Si vous pensez que vos droits de propri\xe9t\xe9 intellectuelle ont \xe9t\xe9 viol\xe9s, d\xe9posez une plainte en ligne en utilisant notre [Formulaire de signalement d'infraction](https://www.amazon.com/report/infringement/signin).[ Ce formulaire peut \xeatre utilis\xe9 pour signaler tous les types de r\xe9clamations relatives aux droits de propri\xe9t\xe9](https://www.amazon.com/report/infringement/signin) intellectuelle, y compris, mais sans s'y limiter, les r\xe9clamations relatives aux droits d'auteur, aux marques d\xe9pos\xe9es, aux dessins et aux brevets

\xc0 la r\xe9ception d'une plainte, nous pouvons prendre certaines mesures, notamment supprimer des informations ou \xe9l\xe9ments sp\xe9cifiques. Dans des circonstances appropri\xe9es, nous pouvons mettre fin aux droits d\u{2019}acc\xe8s en cas de violations r\xe9p\xe9t\xe9es. Toutes ces mesures sont prises sans aucune reconnaissance de responsabilit\xe9 et sans constituer une renonciation aux recours possibles. Cela inclut la transmission de la plainte aux parties impliqu\xe9es dans la fourniture du contenu pr\xe9sum\xe9 en infraction. Vous acceptez d'indemniser Amazon pour toutes les r\xe9clamations d\xe9pos\xe9es par un tiers contre Amazon \xe0 la suite ou en relation avec le d\xe9p\xf4t d'une plainte.

__Avertissement important :__ la fourniture d'informations fausses, trompeuses ou inexactes dans le formulaire de notification \xe0 Amazon peut engager votre responsabilit\xe9 civile et/ou p\xe9nale. En cas de questions, contactez un conseiller juridique.

`,
    [(0, _common.LOCALES_MAP).IT_IT]: `
  17 luglio 2022

Benvenuto in Amazon Carrier Logistics.

Amazon EU Sarl e/o le sue societ\xe0 affiliate ("Amazon") ti forniscono funzionalit\xe0 del sito web e altri prodotti e servizi quando visiti carrierlogistics.amazon.com (il "Sito web"), utilizzi prodotti o servizi Amazon, utilizzi le applicazioni Amazon per dispositivi mobili o utilizzi software forniti da Amazon in relazione a quanto sopra descritto (collettivamente "Servizi Amazon"). Consulta la nostra Informativa sulla privacy e Informativa sui cookie per capire come raccogliamo e trattiamo i tuoi dati personali tramite i Servizi Amazon. Amazon fornisce i Servizi Amazon sulla base delle condizioni stabilite in questa pagina. "Amazon Carrier Logistics" \xe8 il nome commerciale di Amazon.

__Condizioni Generali d'Uso__

__Leggi attentamente queste condizioni prima di usare i Servizi Amazon. Usando i Servizi Amazon, indichi la tua accettazione ad essere vincolato dalle presenti Condizioni.__ Offriamo un'ampia gamma di Servizi Amazon che, a volte, potrebbero essere soggetti a termini aggiuntivi. Quando usi un Servizio Amazon, sarai inoltre soggetto ai termini, alle linee guida e alle condizioni applicabili a tale Servizio Amazon ("Termini del Servizio"). Se le presenti Condizioni d'uso risultano in contrasto con i Termini del Servizio, prevarranno tali Termini del Servizio.

__1. COMUNICAZIONI ELETTRONICHE__

Quando utilizzi un Servizio Amazon o ci invii e-mail, comunichi con noi elettronicamente. Comunicheremo con te elettronicamente in vari modi, ad esempio tramite e-mail, SMS, avvisi push in-app o pubblicando messaggi o comunicazioni e-mail sul Sito web o tramite gli altri Servizi Amazon. Ai fini contrattuali, accetti che tutti gli accordi, gli avvisi, le divulgazioni e le altre comunicazioni che forniamo elettronicamente soddisfano qualsiasi requisito legale che prevede che tali comunicazioni siano in forma scritta, a meno che le leggi applicabili richiedano specificamente una forma di comunicazione diversa.

__2. CONSIGLI E PERSONALIZZAZIONE__

Nell\u{2019}ambito dei Servizi Amazon, ti consiglieremo funzionalit\xe0, prodotti e servizi, inclusi annunci di terze parti che potrebbero interessarti, identificheremo le tue preferenze e personalizzeremo la tua esperienza.

__3. DIRITTI D'AUTORE E DIRITTI SULLE BANCHE DATI__

Tutti i contenuti inclusi o resi disponibili tramite qualsiasi Servizio Amazon, come testo, grafica, loghi, icone dei pulsanti, immagini, clip audio, download digitali e raccolte di dati, sono di propriet\xe0 di Amazon o dei suoi fornitori di contenuti e sono protetti dalle leggi del Lussemburgo e internazionali sul copyright, sui diritti d'autore e sui diritti delle banche dati. L\u{2019}elenco di tutti i contenuti inclusi o resi disponibili tramite qualsiasi Servizio Amazon \xe8 di propriet\xe0 esclusiva di Amazon ed \xe8 protetto dalle leggi lussemburghesi e internazionali in materia di diritto d\u{2019}autore e di diritti sulle banche dati.

Non puoi estrarre e/o riutilizzare parti del contenuto di alcuno dei Servizi Amazon senza il nostro esplicito consenso scritto. In particolare, non puoi utilizzare alcun data mining, robot o strumenti simili di raccolta ed estrazione dei dati per estrarre (in una o pi\xf9 volte) per riutilizzare qualsiasi parte sostanziale del contenuto di qualsiasi Servizio Amazon, senza il nostro esplicito consenso scritto. Inoltre, non puoi creare e/o pubblicare un tuo database che includa parti sostanziali di qualsiasi Servizio Amazon (ad es. i nostri prezzi) senza il nostro esplicito consenso scritto.

__4. MARCHI__

[Fai clic qui per visualizzare un elenco non esaustivo dei marchi commerciali di Amazon](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910). Inoltre, la grafica, i loghi, le intestazioni delle pagine, le icone dei pulsanti, gli script e i nomi dei servizi inclusi o resi disponibili tramite qualsiasi Servizio Amazon sono marchi o segni distintivi di Amazon. I marchi o le immagini commerciali di Amazon non possono essere utilizzati in connessione con altri prodotti o servizi che non siano di Amazon, in qualsiasi maniera che possa generare confusione i clienti o denigrare o screditare su Amazon. Tutti gli altri marchi non di propriet\xe0 di Amazon che compaiono su Servizi Amazon sono di propriet\xe0 dei rispettivi titolari, che possono o meno essere affiliati a, connessi a o sponsorizzati da Amazon.

__5. BREVETTI__

I Servizi Amazon e le funzionalit\xe0 e i servizi accessibili tramite i Servizi Amazon si basano su uno o pi\xf9 brevetti di propriet\xe0 di Amazon. Parti dei Servizi Amazon operano su licenza di uno o pi\xf9 brevetti.

__6. LICENZA E ACCESSO__

A condizione che tu rispetti le presenti Condizioni Generali d'Uso, i Termini del Servizio applicabili, e che tu provveda al pagamento di qualsiasi tariffa applicabile, Amazon o il suo fornitore di contenuti ti concedono una licenza limitata, non esclusiva, non trasferibile e non sublicenziabile per accedere ai Servizi Amazon e farne un uso personale e non commerciale. Questa licenza non include alcun diritto di rivendita o uso commerciale di ciascun Servizio Amazon o dei suoi contenuti, n\xe9 il diritto di raccogliere e utilizzare liste, descrizioni o prezzi, fare un uso derivato dei Servizi Amazon o dei loro contenuti, effettuare qualsiasi tipo di download o copia di informazioni dell'account a vantaggio di un altro rivenditore o utilizzare data mining, robot o simili dispositivi di acquisizione ed estrazione dati.

Tutti i diritti non espressamente conferiti dalle presenti Condizioni Generali d'Uso o dai Termini del Servizio restano in capo ad Amazon o ai suoi licenzianti, fornitori, editori, titolari di diritti o altri fornitori di contenuti. Non \xe8 possibile riprodurre, duplicare, copiare, vendere, rivendere, far visionare o in ogni altro modo utilizzare per qualsiasi uso commerciale i Servizi Amazon in tutto o in parte senza il nostro espresso consenso scritto. Non \xe8 possibile procedere al framing o utilizzare tecniche di framing per appropriarsi indebitamente di qualsiasi marchio, logo o altra informazione proprietaria (inclusi immagini, testo, impostazioni di pagina, o formato) di Amazon in assenza di un espresso consenso scritto da parte nostra. Non \xe8 possibile utilizzare alcun meta tag o ogni altro "testo nascosto" usando il nome o i marchi di Amazon senza l'espresso consenso scritto da parte nostra.

Non devi utilizzare in maniera impropria i Servizi Amazon. Potrai utilizzare i Servizi Amazon esclusivamente nei limiti previsti dalla legge. La violazione delle presenti Condizioni Generali d'Uso o dei Termini del Servizio comporter\xe0 la revoca della licenza rilasciata da Amazon.

__7. IL TUO ACCOUNT__

Potresti aver bisogno del tuo account Amazon per usare certi Servizi Amazon e potresti aver bisogno di accedere al tuo account. Se utilizzi un Servizio Amazon, sei responsabile del mantenimento della riservatezza del tuo account e della tua password e della limitazione dell'accesso al tuo computer e, nella misura consentita dalla legge applicabile, accetti di assumerti la responsabilit\xe0 di tutte le attivit\xe0 svolte con il tuo account o la tua password. Dovresti adottare tutte le misure necessarie per garantire che la password sia mantenuta riservata e sicura e dovresti informarci immediatamente se hai motivo di credere che la tua password sia nota a qualcun altro, o se la password \xe8 o \xe8 probabile che venga utilizzata in modo non autorizzato. Sei responsabile di garantire che i dati che ci fornisci siano corretti e completi e di informarci di eventuali modifiche alle informazioni che ci hai fornito. Puoi accedere alle tue informazioni nella sezione \u{201C}Il mio account\u{201D} del Sito web.

Non devi utilizzare alcun Servizio Amazon: (i) in alcun modo che causi o possa causare l'interruzione, il danneggiamento o la compromissione di qualsiasi Servizio Amazon o dell'accesso ad esso, o (ii) per scopi fraudolenti, o in relazione a un reato o altra attivit\xe0 illegale, o (iii) per arrecare disturbo, pregiudizio o apprensione.

Ci riserviamo il diritto di impedire l\u{2019}accesso a qualsiasi Servizio Amazon o chiudere gli account se il tuo comportamento fornisce un motivo giustificato per farlo. Ci\xf2 si verificher\xe0 in particolare in caso di violazione della normativa vigente, delle disposizioni contrattuali applicabili, delle nostre linee guida o delle nostre politiche, tutte accessibili sul Sito web. Nonostante tali limitazioni o cessazioni, continuerai ad avere accesso ai contenuti e ai servizi da te acquistati fino a quel momento.

__8. RECENSIONI, COMMENTI, COMUNICAZIONI E ALTRI CONTENUTI__

Laddove esista la funzionalit\xe0 necessaria, se i visitatori pubblicano recensioni, commenti e altri contenuti, inviano altre comunicazioni e inviano suggerimenti, idee, commenti, domande o altre informazioni, i contenuti non devono essere illegali, osceni, offensivi, minacciosi, diffamatori, invasivi della privacy, in violazione dei diritti di propriet\xe0 intellettuale o altrimenti dannosi per terzi o deplorevoli e non devono consistere in o contenere virus, campagne politiche, sollecitazioni commerciali, lettere a catena (c.d. catene di Sant\u{2019}Antonio), invii di massa o qualsiasi forma di "spam". Non \xe8 consentito utilizzare un indirizzo e-mail falso, impersonare un individuo o un'entit\xe0 o altrimenti fuorviare il ricevente sull'origine di una scheda o di qualsiasi altro contenuto. Ci riserviamo il diritto (ma non abbiamo alcun obbligo in mancanza di un  [Modulo di segnalazione di violazione](https://www.amazon.com/report/infringement/signin) validamente compilato) di rimuovere o modificare tali contenuti. Se ritieni che qualsiasi contenuto in vendita o pubblicizzato su qualsiasi Servizio Amazon contenga una dichiarazione diffamatoria o che i tuoi diritti di propriet\xe0 intellettuale siano stati violati da un oggetto o da un\u{2019}informazione su qualsiasi Servizio Amazon, comunicacelo compilando e inviando l'apposito [Modulo di segnalazione di violazione](https://www.amazon.com/report/infringement/signin) e risponderemo.

Se pubblichi recensioni, commenti, domande o risposte dei clienti o altri contenuti da te generati per la visualizzazione sul Sito web (comprese immagini, video o audio, tutti insieme i "contenuti"), concedi ad Amazon (a) una licenza non esclusiva e gratuita per utilizzare, riprodurre, pubblicare, rendere disponibili, tradurre e modificare tali contenuti in tutto il mondo (incluso il diritto di concedere in sublicenza questi diritti a terzi) e (b) il diritto di utilizzare il nome che invii in relazione a tali contenuti. Sono fatti salvi i tuoi diritti morali d\u{2019}autore.

Puoi cancellare i tuoi contenuti dalla visualizzazione pubblica o, laddove tale funzionalit\xe0 sia offerta, modificare le impostazioni in modo che vengano mostrati solo alle persone a cui concedi l'accesso.

Dichiari e garantisci di avere, personalmente o comunque in altro modo, tutti i diritti sui contenuti che pubblichi e che, alla data di pubblicazione del contenuto o del materiale: (i) il contenuto e il materiale sono accurati e (ii) l'uso del contenuto e del materiale fornito non viola alcuna politica o linea guida applicabile e non causer\xe0 danni a persone o entit\xe0 (incluso il fatto che il contenuto o il materiale non sia diffamatorio). Accetti di risarcire Amazon per tutti i reclami presentati da terzi contro Amazon derivanti da o in relazione ai contenuti e al materiale che fornisci, fatti salvi i casi in cui eventuali responsabilit\xe0 siano riconducibili alla mancata rimozione di contenuti segnalati ad Amazon come illeciti ([Modulo di segnalazione di violazione](https://www.amazon.com/report/infringement/signin)) e derivanti da, sulla base di o provenienti dai contenuti che ci hai comunicato. Eliminando i contenuti dalla visualizzazione pubblica, si revoca la licenza che consente ad Amazon di pubblicare e rendere disponibili tali contenuti al pubblico.

__9. RIVENDICAZIONI DELLA PROPRIET\xc0 INTELLETTUALE__

Amazon rispetta i diritti di propriet\xe0 intellettuale altrui. Se ritieni che i tuoi diritti di propriet\xe0 intellettuale siano stati utilizzati in modo da dare luogo a possibili violazioni, segui la procedura per il nostro [Modulo di segnalazione di violazione](https://www.amazon.com/report/infringement/signin).

__10. TERMINI DEL SOFTWARE AMAZON__

Oltre alle presenti Condizioni Generali d'Uso, i seguenti Termini del software si applicano a qualsiasi software (inclusi eventuali aggiornamenti o upgrade del software e qualsiasi documentazione correlata) che mettiamo a tua disposizione di volta in volta per l'utilizzo in relazione ai Servizi Amazon (il "Software Amazon"):

1. __Utilizzo del Software Amazon.__ Puoi utilizzare il Software Amazon esclusivamente allo scopo di consentirti di utilizzare e usufruire dei Servizi Amazon forniti da Amazon e come consentito dalle presenti Condizioni Generali d'Uso, dai presenti Termini del software e da eventuali Termini del Servizio. Non puoi incorporare alcuna parte del Software Amazon nei tuoi programmi o compilare alcuna parte di esso in combinazione con i tuoi programmi, trasferirlo per utilizzarlo con un altro servizio o vendere, noleggiare, dare in affitto, distribuire o concedere in sublicenza il Software Amazon o assegnare in altro modo alcun diritto al Software Amazon del tutto o in parte. Non puoi utilizzare il software Amazon per scopi illegali. Possiamo interrompere la fornitura di qualsiasi Software Amazon e possiamo revocare il tuo diritto di utilizzare qualsiasi Software Amazon in qualsiasi momento. I tuoi diritti di utilizzo del Software Amazon cesseranno automaticamente senza preavviso da parte nostra in caso di mancato rispetto di uno qualsiasi dei presenti Termini del software Amazon, delle Condizioni Generali d'Uso o di qualsiasi altro Termine del Servizio. Il Software Amazon (o software incorporati nel Software Amazon) potrebbe essere soggetto all'applicazione di termini e condizioni aggiuntivi di terzi, contenuti o distribuiti unitamente ad alcuni Software Amazon e indicati nella relativa documentazione e regoleranno l'uso di tale software in caso di conflitto con le presenti Condizioni Generali d'Uso. Tutti i software utilizzati in ogni Servizio Amazon sono di propriet\xe0 di Amazon o dei suoi fornitori di software e sono protetti dalle leggi del Lussemburgo e internazionali sul diritto d\u{2019}autore. 

2. __Uso dei servizi di terzi.__ Quando utilizzi il Software Amazon, potresti anche utilizzare i servizi di una o pi\xf9 terze parti, come un operatore wireless o un fornitore di piattaforme per dispositivi mobili. L'utilizzo da parte tua di questi servizi di terze parti pu\xf2 essere soggetto a informative, termini di utilizzo e tariffe separate di tali terze parti. 

3. __Divieto di reverse engineering.__ Salvo quanto esplicitamente consentito dalla legge applicabile, non puoi incoraggiare, assistere o autorizzare nessun'altra persona a copiare, modificare, decodificare, decompilare o disassemblare o manomettere in altro modo il Software Amazon, in tutto o in parte, o creare opere derivate da o del Software Amazon. 

4. __Aggiornamenti.__ Per mantenere aggiornato il software Amazon, possiamo offrire aggiornamenti automatici o manuali in qualsiasi momento e senza preavviso.

__11. LA NOSTRA RESPONSABILIT\xc0__

Faremo del nostro meglio per assicurare che la disponibilit\xe0 dei Servizi Amazon sia ininterrotta e che le trasmissioni siano prive di errori. Tuttavia, a causa della natura di Internet, ci\xf2 non pu\xf2 essere garantito. Inoltre, l'accesso ai Servizi Amazon pu\xf2 essere occasionalmente sospeso o limitato per consentire riparazioni, manutenzione o l'introduzione di nuove funzionalit\xe0 o servizi. Cercheremo di limitare la frequenza e la durata di tali sospensioni o restrizioni.

Amazon non sar\xe0 responsabile per (i) perdite che non siano state causate da alcuna violazione da parte nostra o (ii) qualsiasi perdita aziendale (inclusa perdita di profitti, ricavi, contratti, risparmi previsti, dati, avviamento o spese inutilmente sostenute) o (iii) perdite indirette o consequenziali che non erano prevedibili sia per te che per noi quando hai iniziato a utilizzare i Servizi Amazon.

Amazon non \xe8 da ritenersi responsabile per qualsiasi ritardo o per il mancato rispetto degli obblighi previsti in questi termini se il ritardo o il mancato rispetto dei termini si verifica per cause che vanno oltre il ragionevole controllo di Amazon.

Le leggi di alcuni paesi non consentono alcune o tutte le limitazioni sopra descritte. Se queste leggi si applicano al tuo caso, alcune delle o tutte le limitazioni di cui sopra potrebbero non essere applicabili a te e potresti godere di diritti aggiuntivi.

Nulla in queste condizioni limita o esclude la nostra responsabilit\xe0 per le dichiarazioni fraudolente da noi presentate o per morte o lesioni personali causate da nostra grave negligenza o dolo.

__12. ESCLUSIONE DI GARANZIA E LIMITAZIONE DI RESPONSABILIT\xc0__

I SERVIZI AMAZON E TUTTE LE INFORMAZIONI, I CONTENUTI, I MATERIALI, I PRODOTTI (INCLUSI I SOFTWARE) E GLI ALTRI SERVIZI INCLUSI O ALTRIMENTI RESI DISPONIBILI TRAMITE I SERVIZI AMAZON SONO FORNITI DA AMAZON "NELLO STATO IN CUI SITROVANO" E "COME DISPONIBILI", SALVO DIVERSAMENTE SPECIFICATO IN FORMA SCRITTA. AMAZON NON RILASCIA DICHIARAZIONI O GARANZIE DI ALCUN TIPO, ESPLICITE O IMPLICITE, SUL FUNZIONAMENTO DEI SERVIZI AMAZON O SU INFORMAZIONI, CONTENUTI, MATERIALI, PRODOTTI (INCLUSI I SOFTWARE) O ALTRI SERVIZI INCLUSI O ALTRIMENTI RESI DISPONIBILI TRAMITE I SERVIZI AMAZON, SALVO DIVERSA INDICAZIONE NEL CONTRATTO. IN QUANTO UTENTE ACCETTI ESPRESSAMENTE CHE L'UTILIZZO DEI SERVIZI AMAZON \xc8 A TUO ESCLUSIVO RISCHIO. NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, AMAZON DECLINA TUTTE LE GARANZIE ESPRESSE O IMPLICITE, INCLUSE, A TITOLO ESEMPLIFICATIVO MA NON ESAUSTIVO, LE GARANZIE IMPLICITE DI COMMERCIABILIT\xc0 E IDONEIT\xc0 PER UNO SCOPO PARTICOLARE. AMAZON NON GARANTISCE CHE I SERVIZI AMAZON, LE INFORMAZIONI, I CONTENUTI, I MATERIALI, I PRODOTTI (INCLUSI I SOFTWARE) O ALTRI SERVIZI INCLUSI O RESI DISPONIBILI TRAMITE I SERVIZI AMAZON, I SERVER DI AMAZON O LE COMUNICAZIONI ELETTRONICHE INVIATE DA AMAZON SIANO PRIVI DI VIRUS O DI ALTRI COMPONENTI DANNOSI. NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, AMAZON NON SAR\xc0 RESPONSABILE PER EVENTUALI DANNI DI QUALSIASI TIPO DERIVANTI DALL'USO DI UNO QUALSIASI DEI SERVIZI AMAZON O DA QUALSIASI INFORMAZIONE, CONTENUTO, MATERIALE, PRODOTTO (INCLUSI I SOFTWARE) O ALTRI SERVIZI INCLUSI O RESI DISPONIBILI TRAMITE UNO QUALSIASI DEI SERVIZI AMAZON INCLUSI, A TITOLO ESEMPLIFICATIVO, DANNI DIRETTI, INDIRETTI, INCIDENTALI, PUNITIVI E CONSEQUENZIALI, SALVO DIVERSAMENTE SPECIFICATO IN FORMA SCRITTA.

__13. LEGGE APPLICABILE__

Se ti trovi in uno stato membro dell'UE, queste condizioni sono regolate e interpretate in conformit\xe0 con le leggi del Granducato di Lussemburgo e l'applicazione della Convenzione delle Nazioni Unite sui contratti per la vendita internazionale di merci \xe8 espressamente esclusa. Entrambi accettiamo di sottometterci alla giurisdizione esclusiva dei tribunali della Citt\xe0 di Lussemburgo.

Se ti trovi nel Regno Unito, accetti che le leggi di Inghilterra e Galles, indipendentemente dai principi di conflitto di leggi, regoleranno le presenti Condizioni Generali d'Uso e qualsiasi controversia di qualsiasi tipo che potrebbe insorgere tra te e Amazon. L'applicazione della Convenzione delle Nazioni Unite sui contratti di vendita internazionale di merci \xe8 espressamente esclusa.

Quale utente ti sottoponi irrevocabilmente alla giurisdizione esclusiva dei tribunali d'Inghilterra. Qualsiasi contestazione o reclamo relativo in qualsiasi modo all'utilizzo del Sito web sar\xe0 risolta in un tribunale competente in Inghilterra. Rinuncia a tutte le obiezioni relative alla giurisdizione e alla sede di tali tribunali.

Se desideri portare una questione alla nostra attenzione, [contattaci](mailto:carrierlogistics-admin@amazon.com).

__14. MODIFICHE AL SERVIZIO O MODIFICHE ALLE CONDIZIONI GENERALI D'USO__

Ci riserviamo il diritto di apportare modifiche a qualsiasi servizio, politica, termine e condizione Amazon, comprese le presenti Condizioni Generali d'Uso e i Termini del Servizio, in qualsiasi momento. Sarai soggetto ai termini e alle condizioni, alle politiche e alle Condizioni Generali d'Uso in vigore al momento dell'utilizzo dei Servizi Amazon. Qualora qualsiasi condizione d'uso sia da ritenersi non valida, nulla o per qualsiasi motivo non applicabile, tale condizione sar\xe0 da ritenersi separata e non influir\xe0 sulla validit\xe0 e l'applicabilit\xe0 delle altre condizioni.

__15. RINUNCIA__

In caso di inadempimento da parte tua alle presenti Condizioni Generali d'Uso, il mancato esercizio da parte nostra del diritto di agire nei tuoi confronti, non rappresenta una nostra rinuncia al diritto di utilizzare i nostri diritti e rimedi nel caso in cui tu violi le presenti Condizioni Generali d'Uso.

__16. I NOSTRI DATI DI CONTATTO__

Questo Sito web \xe8 di propriet\xe0 e gestito da Amazon EU Sarl:

38 Avenue John F. Kennedy

Luxembourg, 1855

Luxembourg

__17. AVVISO E PROCEDURA PER PRESENTARE RECLAMI RELATIVI A VIOLAZIONI DEI DIRITTI__

Se ritieni che i tuoi diritti di propriet\xe0 intellettuale siano stati violati, invia il tuo reclamo utilizzando il nostro sito online [Modulo di segnalazione di violazione](https://www.amazon.com/report/infringement/signin). Questo modulo pu\xf2 essere utilizzato per segnalare tutti i tipi di reclami sulla propriet\xe0 intellettuale, incluse, a titolo esemplificativo, rivendicazioni relative a diritto d\u{2019}autore, marchi, design e brevetti.

Al ricevimento di un reclamo, possiamo intraprendere determinate azioni, tra cui la rimozione di informazioni o di un articolo e chiudere un account in caso di ripetute violazioni ove ricorrano le condizioni. Tutte queste azioni vengono intraprese senza che ci\xf2 implichi alcuna ammissione di responsabilit\xe0 e senza pregiudizio per i nostri diritti, rimedi o difese, che ci riserviamo espressamente di esercitare. Ci\xf2 include l'inoltro del reclamo alle parti coinvolte nella fornitura del contenuto in presunta violazione. Ti impegni a tenere indenne Amazon da tutte le azioni di terzi contro Amazon derivanti da o connesse con l\u{2019}invio di una segnalazione.

`
};
const usConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Welcome to Amazon Carrier Logistics. 

Amazon.com Services LLC and/or its affiliates ("Amazon") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the "Website"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "Amazon Services"). Amazon provides the Amazon Services subject to the conditions set out on this page. 

__Conditions of Use__

__Please read these conditions carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these conditions.__\xa0We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.  Please review our [Privacy Notice](/privacy-notice) , which also governs your use of Amazon Services, to understand our practices.  

__ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service or send e-mails to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the Website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communications be in writing. 

__COPYRIGHT__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software is the property of Amazon or its content suppliers and is protected by United States and international copyright laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by United States and international copyright laws.

__TRADEMARKS__

[Click here to see a non-exhaustive list of Amazon trademarks](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910). In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon in the US and other countries. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

__LICENCE AND ACCESS__

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make personal and non-commercial use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of any third party; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose, other than those expressly required in order to receive the Amazon Services, without the express written consent of Amazon. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's names or trademarks without our express written consent. 

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account. If you use any Amazon Service you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorized manner. We reserve the right to refuse service, terminate accounts, terminate your rights to use Amazon Services or remove or edit content in its sole discretion.

__REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT__

Where the functionality exists to do so, if visitors post reviews, comments and other content; send other communications; and submit suggestions, ideas, comments, questions or other information, the content must not be illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and must not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of "spam." You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but not the obligation) to remove or edit such content, but do not regularly review posted content. 

If you do post content or submit material, and unless we indicated otherwise, you grant Amazon (a) a non-exclusive, royalty-free, perpetual, irrevocable and fully sublicensable right to use, reproduce, publish, make available, translate, modify, adapt, perform, create derivative works from, distribute and display such content throughout the world in any media and (b) the right to use the name that you submit in connection with such content. 

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as at the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply. Amazon has the right but not the obligation to monitor and edit or remove any activity of content.  Amazon takes no responsibility and assumes no liability for any content posted by you or any third party.

__INTELLECTUAL PROPERTY CLAIMS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights are being infringed, please follow our\xa0[Report Infringement Form](https://www.amazon.com/report/infringement/signin).

__APP PERMISSIONS__

When you use apps created by Amazon, you may grant certain permissions to us for your device.  Most mobile devices provide you with information about these permissions.  To learn more about these permissions, click here.

__SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are the subject of U.S. sanctions or of sanctions consistent with U.S. law imposed by the governments of the country where you are using Amazon Services. You must comply with all U.S. or other export and re-export restrictions that may apply to goods, software (including Amazon Software), technology, and services.

__OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses.  We are not responsible for examining or evaluating, and we do not warrant the offerings of, any of these businesses or individuals (including the content of their Web sites).  Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties.  You should carefully review their privacy statements and other conditions of use.

__DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY__

THE AMAZON SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES ARE PROVIDED BY AMAZON ON AN \u{201C}AS IS\u{201D} AND \u{201C}AS AVAILABLE\u{201D} BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING. AMAZON MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE AMAZON SERVICES OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES, UNLESS OTHERWISE SPECIFIED IN WRITING. YOU EXPRESSLY AGREE THAT YOUR USE OF THE AMAZON SERVICES IS AT YOUR SOLE RISK. 

TO THE FULL EXTENT PERMISSIBLE BY LAW, AMAZON DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. AMAZON DOES NOT WARRANT THAT THE AMAZON SERVICES, INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES, AMAZON\u{2019}S SERVERS, OR ELECTRONIC COMMUNICATIONS SENT FROM AMAZON ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, AMAZON WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY AMAZON SERVICE OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY AMAZON SERVICE, INCLUDING BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING.

__DISPUTES__

This Agreement is governed by the U.S. Federal Arbitration Act, applicable U.S. federal law, and Washington state law, without reference to any applicable conflict of laws rules. __Any dispute arising out of or relating to your use of Carrier Logistics will be resolved by binding arbitration, rather than in court.__ There is no judge or jury in arbitration, and court review of an arbitration award is limited. However, an arbitrator can award the same damages and relief as a court (including injunctive and declaratory relief or statutory damages), and must follow the terms of this Agreement as a court would. Before you may begin an arbitration proceeding, you must send a letter notifying us of your intent to pursue arbitration and describing your claim to Amazon\u{2019}s registered agent Corporation Service Company, 300 Deschutes Way SW, Suite 304, Tumwater, WA 98501. The arbitration will be conducted by the American Arbitration Association (AAA) under its Commercial Arbitration Rules. <a id="_Hlk122535802"></a>You and Amazon each agree that the underlying award in arbitration may be appealed pursuant to the AAA\u{2019}s Optional Appellate Arbitration Rules. The AAA\u{2019}s rules are available at www.adr.org or by calling 1-800-778-7879. Payment of all filing, administration and arbitrator fees will be governed by the AAA\u{2019}s Commercial Fee Schedule. Arbitration conducted in person will be in King County, Washington or at another mutually agreed location. __You and Amazon each agree that, to the maximum extent permitted by applicable law, any dispute resolution proceedings will be conducted only on an individual basis and not in a class, collective, consolidated, or representative action.__ If for any reason a claim proceeds in court rather than in arbitration your company and Amazon each waive any right to a jury trial. Your company and Amazon also both agree that your company or Amazon may bring suit in court to enjoin infringement or other misuse of intellectual property rights.

__APPLICABLE LAW__

By using any Amazon Service, you agree that the U.S. Federal Arbitration Act, applicable federal law, and Washington state law, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon.

__ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE__

We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.

__WAIVER__

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

__OUR ADDRESS__

Amazon.com, Inc.

P.O. Box 81226

Seattle, WA 98108-1226

__NOTICE AND PROCEDURE FOR MAKING CLAIMS OF INTELLECTUAL PROPERTY INFRINGEMENT__

If you believe that your intellectual property rights have been infringed, please submit your complaint using our online [form](https://www.amazon.com/report/infringement). This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, and patent claims.

We respond quickly to the concerns of rights owners about any alleged infringement, and we terminate repeat infringers in appropriate circumstances.

We offer the following alternative to our online form for copyright complaints only. You may submit written claims of copyright infringement to our Copyright Agent at:\xa0

Copyright Agent

Amazon.com Legal Department

P.O. Box 81226

Seattle, WA 98108

phone: (206) 266-4064

e-mail: copyright@amazon.com

Courier address:

Copyright Agent

Amazon.com Legal Department

2021 7th Avenue

Seattle, WA 98121

USA

Written claims concerning copyright infringement must include the following information: 

- A physical or electronic signature of the person authorized to act on behalf of the owner of the copyright interest; 
- A description of the copyrighted work that you claim has been infringed upon; 
- A description of where the material that you claim is infringing is located on the site; 
- Your address, telephone number, and e-mail address; 
- A statement by you that you have a good-faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law; and 
- A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf. 

__Important Warning:__\xa0giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions. 

__ADDITIONAL AMAZON SOFTWARE TERMS__

The following terms (\u{201C}Software Terms\u{201D}) apply to any software (including any updates or upgrades to the software) and any related documentation we make available to you in connection with Amazon Services (the "Amazon Software"). 

1. __Use of the Amazon Software.__ You may use Amazon Software solely for purposes of enabling you to use the Amazon Services as provided by Amazon, and as permitted by these Conditions of Use and any Service Terms. You may not incorporate any portion of the Amazon Software into other programs or compile any portion of it in combination with other programs, or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, distribute, assign any rights to, or license the Amazon Software in whole or in part. All software used in any Amazon Service is the property of Amazon or its software suppliers and is protected by United States and international copyright laws. 
2. __Use of Third-Party Services.__ When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile software provider. Your use of these third-party services may be subject to the separate policies, terms of use, and fees of these third parties. 
3. \xa0__No Reverse Engineering.__ You may not reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part. 
4. __Updates.__ We may offer automatic or manual updates to the Amazon Software at any time and without notice to you. 
5. \xa0__Government End Users.__ If you are a U.S. Government end user, we are licensing the Amazon Software to you as a "Commercial Item" as that term is defined in the U.S. Code of Federal Regulations (see 48 C.F.R. \xa7 2.101), and the rights we grant you to the Amazon Software are the same as the rights we grant to all others under these Conditions of Use. 
6. __Conflicts.__ In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict.
  `
};
const auConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
  Welcome to Amazon Carrier Logistics. 

Amazon.com Services LLC and/or its affiliates ("Amazon") provide website features and other products and services to you when you visit [carrierlogistics.amazon.com](/) (the "Website"), use Amazon products, or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "Amazon Services"). Please see our [Privacy Notice](/privacy-notice) and our [Cookies Notice](https://www.amazon.com.au/gp/help/customer/display.html?nodeId=201890250), to understand how we collect and process your personal information through Amazon Services.   Amazon provides the Amazon Services subject to the Conditions of Use set out on this page. 

__Conditions of Use__

__Please read these Conditions of Use carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these Conditions of Use.__\xa0We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.  

__THE AUSTRALIAN CONSUMER LAW__

Australian consumers and businesses have certain rights under the Australian Consumer Law ("__ACL__"). These Conditions of Use are not intended to affect your rights as an Australian consumer under the ACL.

__ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service or send e-mails to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the Website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communications be in writing, unless mandatory applicable laws specifically require a different form of communication. 

__COPYRIGHT, AUTHORS\u{2019} RIGHTS AND DATABASE RIGHTS__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by Australian and international copyright laws, authors\u{2019} rights and database laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by Australian and international copyright and database right laws.

You may not extract and/or re-utilize parts of the content of any Amazon Service without our express written consent. In particular, you may not utilise any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilisation any substantial parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.

__TRADEMARKS__

[Click here to see a non-exhaustive list of Amazon trademarks](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910). In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon in the US and other countries, including Australia. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

__LICENCE AND ACCESS__

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of any third party; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose, other than those expressly required in order to receive the Amazon Services, without the express written consent of Amazon. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's names or trademarks without our express written consent. 

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account. If you use any Amazon Service you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law or except where caused by our breach of these Conditions of Use, you are responsible for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorized manner. 

If we have concerns with your Amazon Account, or activity relating to your Amazon Account, or if you are in breach of applicable laws, these Conditions of Use, or the relevant Service Terms, we reserve the right to take action, including without limitation by (i) restricting, suspending, terminating or refusing any Amazon Service, (ii) suspending or restricting access to your Amazon Account, (iii) terminating your Amazon Account; or (iv) removing or editing content you post using your Amazon Account. The action we elect to take and any notice you may receive, and any opportunity to rectify will vary depending on the Amazon Service, the circumstances and our reasonable assessment of relevant factors. Any action taken in accordance with (i)- (iv) above may, result in suspension or termination of other Amazon Services.  At any time, you may, in accordance with the applicable Service Terms and using the tools and settings we make available to you for each Amazon Service, cease using any Amazon Service, terminate your account or the Amazon Service, or remove or edit certain content and material you post (each as permitted by that Amazon Service).

__REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT__

Where the functionality exists to do so, if visitors post reviews, comments and other content; send other communications; and submit suggestions, ideas, comments, questions or other information, the content must not be illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and must not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of "spam." You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but not the obligation) to remove or edit such content, but do not regularly review posted content. 

If you do post content or submit material, and unless we indicated otherwise, you grant Amazon (a) a non-exclusive, royalty-free, perpetual, irrevocable and fully sublicensable right to use, reproduce, publish, make available, translate, modify, adapt, perform, create derivative works from, distribute and display such content throughout the world in any media and (b) the right to use the name that you submit in connection with such content. 

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as at the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply complies with these Conditions of Use and any applicable Service Terms and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content arising out of or on the grounds of, or originating from the content that you have communicated to us. Amazon has the right but not the obligation to monitor and edit or remove any activity of content.  Amazon takes no responsibility and assumes no liability for any content posted by you or any third party.

__INTELLECTUAL PROPERTY CLAIMS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights are being infringed, please follow our\xa0[Report Infringement Form](https://www.amazon.com/report/infringement/signin).

__APP PERMISSIONS__

When you use apps created by Amazon, you may grant certain permissions to us for your device.  Most mobile devices provide you with information about these permissions.  To learn more about these permissions, [click here](/faq).

__SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are the subject of U.S. sanctions or of sanctions consistent with U.S. law imposed by the governments of the country where you are using Amazon Services. You must comply with all U.S. or other export and re-export restrictions that may apply to goods, software (including Amazon Software), technology, and services.

__OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses.  We are not responsible for examining or evaluating, and we do not warrant the offerings of, any of these businesses or individuals (including the content of their Web sites).  Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties.  You should carefully review their privacy statements and other conditions of use.

__DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY__

The Amazon Services and all information, content, materials, products (including software) and other services included on or otherwise made available to you through the Amazon Services are provided by Amazon on an \u{201C}as is\u{201D} and \u{201C}as available\u{201D} basis, unless otherwise specified in these Conditions of Use. Amazon makes no representations or warranties of any kind, express or implied, as to the operation of the Amazon Services or the information, content, materials, products (including software) or other services included on or otherwise made available to you through the Amazon Services. You expressly agree that your use of the Amazon Services  is at your sole risk. 

To the full extent permissible by law, Amazon disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. Amazon does not warrant that the Amazon Services, information, content, materials, products (including software) or other services included on or otherwise made available to you through the Amazon Services, Amazon's servers, or electronic communications sent from Amazon are free of viruses or other harmful components. To the fullest extent permissible by law, Amazon will not be liable for any damages of any kind arising from the use of any Amazon Service or from any information, content, materials, products (including software) or other services included on or otherwise made available to you through any Amazon Service, including but not limited to direct, indirect, incidental, punitive, and consequential damages, unless otherwise specified in writing.

Nothing in these Conditions of Use or the applicable Service Terms is intended to (i) override any express commitments Amazon gives to you for particular Amazon Services (for example, commitments Amazon gives to provide a refund of fees in certain circumstances) ; (ii) exclude, restrict or modify any right or remedy you have in statute including under the Australian Consumer Law or otherwise to the extent that that right or remedy cannot be excluded, restricted or modified under law; or (iii)  <a id="_Hlk140089809"></a>limit or exclude our liability to you for losses, to the extent such loss is caused by our gross negligence or criminal conduct; or (iv) require any indemnity you provide to us under these Conditions of Use or any applicable Service Terms to extend to losses to the extent caused by our gross negligence or criminal conduct. Any disclaimer, exclusion, or limitation in these conditions applies as provided for in these conditions to the full extent permitted by law and subject to any such non excludable right or remedy.

__APPLICABLE LAW AND DISPUTES__

The laws of New South Wales govern these Conditions of Use and any dispute of any sort that might arise between the parties. Any dispute relating in any way to these Conditions of Use will only be adjudicated in the courts of New South Wales. Each party consents to the exclusive jurisdiction and venue in these courts. Notwithstanding the foregoing, either party may seek injunctive relief in any state, federal, or national court of competent jurisdiction for any actual or alleged infringement of such party's, its affiliates' or any third party's intellectual property or other proprietary rights. 

__ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE__

We reserve the right to cease providing any Amazon Service, or any part thereof, to discontinue any Amazon Service and to make changes to any Amazon Services, including adding or removing content from Amazon Services at any time. Where we make a materially adverse change to an Amazon Service, as reasonably determined by us, we will provide advance notice to you.  Your access to Amazon Services may be suspended or restricted without notice in accordance with these Conditions of Use and the applicable Service Terms, including, without limitation, for legal, regulatory, fraud and abuse prevention or security reasons and as reasonably necessary for our business operations, including without limitation to allow for repairs, maintenance or the introduction of new features or services.

We reserve the right to make changes to any Amazon Services, Conditions of Use and Service Terms at any time by posting the changes on the website or application that is used to provide the Amazon Services. Where we make a materially adverse change to these Conditions of Use or any applicable Service Terms, as reasonably determined by us, Amazon will provide advance notice to you. You will be subject to the Conditions of Use and Service Terms made available to you on the relevant website or application at the time that you use the Amazon Services. You may at any time, cease using any Amazon Services, terminate your account or the relevant Amazon Service including in the event of any such change.

If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.

__WAIVER__

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

__OUR ADDRESS__

Amazon.com, Inc.

2 Park Street

Sydney, NSW 2000

__NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENT__

If you believe that your intellectual property rights have been infringed, please submit your complaint using our online Report Infringement [form](https://www.amazon.com/report/infringement). This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, and patent claims.

Upon receipt of a complaint we may take certain actions, including removing information or an item, and termination where Amazon, acting reasonably in the circumstances, objectively verifies you have repeatedly breached to Conditions of Use or Service Terms. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint arising out of your conduct or content.

__Important Warning:__\xa0giving false, misleading or inaccurate information in the Report Infringement Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions. 

__ADDITIONAL AMAZON SOFTWARE TERMS__

The following terms (\u{201C}Software Terms\u{201D}) apply to any software (including any updates or upgrades to the software) and any related documentation we make available to you in connection with Amazon Services (the "Amazon Software"). 

1. __Use of the Amazon Software.__ You may use Amazon Software solely for purposes of enabling you to use the Amazon Services as provided by Amazon, and as permitted by these Conditions of Use and any Service Terms. You may not incorporate any portion of the Amazon Software into other programs or compile any portion of it in combination with other programs, or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, distribute, assign any rights to, or license the Amazon Software in whole or in part. All software used in any Amazon Service is the property of Amazon or its software suppliers and is protected by Australian and international copyright laws. 
2. __Use of Third-Party Services.__ When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile software provider. Your use of these third-party services may be subject to the separate policies, terms of use, and fees of these third parties. 
3. \xa0__No Reverse Engineering.__ You may not reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part. 
4. __Updates.__ We may offer automatic or manual updates to the Amazon Software at any time and without notice to you. 
5. __Conflicts.__ In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict. 
`
};
const caConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
Welcome to Amazon Carrier Logistics. Amazon.com.ca, ULC, and/or its affiliates ("Amazon") provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the "Website"), use Amazon products or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively, "Amazon Services"). Amazon provides the Amazon Services subject to the following conditions. By using the Amazon Services, you agree, on behalf of yourself and others who use any Amazon Service under your account, to the following conditions.

__Conditions of Use__

__By using Amazon Services, you agree to these conditions. Please read them carefully.__ 

We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service, you will also be subject to the guidelines, terms and agreements applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control. We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service (for example, Your Profile, Gift Cards, Amazon Video, Your Media Library, Amazon devices, or [Amazon applications](https://www.amazon.ca/gp/help/customer/display.html?nodeId=201889260)), you will also be subject to the guidelines, terms and agreements applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.

__PRIVACY__

Please review our [Privacy Notice](/privacy-notice), which also governs your use of the Amazon Services, to understand our practices.

__ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service, or send emails, text messages, and other communications from your desktop or mobile device to us, you may be communicating with us electronically. You consent to receive communications from us electronically, such as emails, texts, mobile push notices, or notices and messages on this site or through the other Amazon Services, such as our Message Centre, and you can retain copies of these communications for your records. You agree that all agreements, notices, disclosures, and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.

__COPYRIGHT__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software is the property of Amazon or its content suppliers and protected by Canadian and international copyright laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and protected by Canadian and international copyright laws.

__TRADEMARKS__

[Click here to see a non-exhaustive list of Amazon trademarks](https://www.amazon.ca/gp/help/customer/display.html?nodeId=201909280). In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon.com, Inc., or its affiliates, in the United States and other countries. Amazon.com, Inc.'s or its affiliates trademarks and trade dress may not be used in connection with any product or service that is not Amazon.com, Inc.'s or its affiliates', in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits Amazon.com, Inc. or its affiliates. All other trademarks not owned by Amazon.com, Inc. or its affiliates that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.com, Inc. or its affiliates.

__LICENSE AND ACCESS__

Subject to your compliance with these Conditions of Use and any Service Terms, and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make personal and non-commercial use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any product listings, descriptions, or prices; any derivative use of any Amazon Service or its contents; any downloading copying, or other use of account information for the benefit of any third party; or any use of data mining, robots, or similar data-gathering and extraction tools.  You may not use any output generated from the Amazon Services to develop machine learning models or related technology. All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rightsholders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without the express written consent of Amazon. You may not frame or utilize framing techniques to enclose any trademark, logo, or other proprietary information (including images, text, page layout, or form) of Amazon without express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's name or trademarks without the express written consent of Amazon. You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your account, and you agree to accept responsibility for all activities that occur under your account or password. Amazon reserves the right to refuse service, terminate accounts, terminate your rights to use Amazon Services, or remove or edit content in its sole discretion.

__REVIEWS, COMMENTS, COMMUNICATIONS, AND OTHER CONTENT__

Where the functionality exists to do so, you may post reviews, comments, and other content; and submit suggestions, ideas, comments, questions, or other information, so long as the content is not illegal, obscene, threatening, defamatory, invasive of privacy, infringing of intellectual property rights (including publicity rights), or otherwise injurious to third parties or objectionable, and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings, or any form of "spam" or unsolicited commercial electronic messages. You may not use a false email address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. Amazon reserves the right (but not the obligation) to remove or edit such content, but does not regularly review posted content.

If you do post content or submit material, and unless we indicate otherwise, you grant Amazon a nonexclusive, royalty-free, perpetual, irrevocable, and fully sublicensable right to use, reproduce, modify, adapt, publish, perform, translate, create derivative works from, distribute and display such content throughout the world in any media. You grant Amazon and sublicensees the right to use the name that you submit in connection with such content, if they choose. You represent and warrant that you own or otherwise control all of the rights to the content that you post; that the content is accurate; that use of the content you supply does not violate this policy and will not cause injury to any person or entity; and that you will indemnify Amazon for all claims resulting from content you supply. Amazon has the right but not the obligation to monitor and edit or remove any activity or content. Amazon takes no responsibility and assumes no liability for any content posted by you or any third party.

__INTELLECTUAL PROPERTY COMPLAINTS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights are being infringed, please follow our [Notice and Procedure for Making Claims of Copyright Infringement](https://www.amazon.ca/gp/help/customer/display.html?nodeId=918816&ref_=footer_cou#GUID-6E4B8D4E-A506-4715-9F50-0DA58AA4F448__SECTION_740D5E8CBB724060850E98E10CBD877B).

__APP PERMISSIONS__

When you use apps created by Amazon, you may grant certain permissions to us for your device. Most mobile devices provide you with information about these permissions. To learn more about these permissions, [click here](https://www.amazon.ca/gp/help/customer/display.html?nodeId=GRFTMVHP4HXMESSP).

__SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are the subject of U.S. sanctions or of sanctions consistent with U.S. law imposed by the governments of the country where you are using Amazon Services. You must comply with all U.S. or other export and re-export restrictions that may apply to goods, software (including Amazon Software), technology, and services.

__OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any of these businesses or individuals (including the content of their Web sites). Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties. You should carefully review their privacy statements and other conditions of use.

__DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY__

THE LAWS OF CERTAIN JURISDICTIONS, INCLUDING QUEBEC'S CONSUMER PROTECTION ACT, DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR CONDITIONS OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE BELOW DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MIGHT NOT APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.

THE AMAZON SERVICES AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES ARE PROVIDED BY AMAZON ON AN "AS IS" AND "AS AVAILABLE" BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING. AMAZON MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE AMAZON SERVICES OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES, UNLESS OTHERWISE SPECIFIED IN WRITING. YOU EXPRESSLY AGREE THAT YOUR USE OF THE AMAZON SERVICES IS AT YOUR SOLE RISK.

TO THE FULL EXTENT PERMISSIBLE BY LAW, AMAZON DISCLAIMS ALL WARRANTIES AND CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. AMAZON DOES NOT WARRANT THAT THE AMAZON SERVICES, INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE AMAZON SERVICES; AMAZON\u{2019}S SERVERS OR ELECTRONIC COMMUNICATIONS SENT FROM AMAZON ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. TO THE FULL EXTENT PERMISSIBLE BY LAW, AMAZON WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY AMAZON SERVICE OR FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY AMAZON SERVICE, INCLUDING, BUT NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING.

__DISPUTES__

__Any dispute or claim relating in any way to these Conditions of Use or your use of any Amazon Service will be resolved by binding arbitration, rather than in court,__ except that either party may elect to proceed in small claims court in the United States if the claims qualify under applicable law. The United States Federal Arbitration Act and federal arbitration law apply to these Conditions of Use.

__There is no judge or jury in arbitration, and court review of an arbitration award is limited. However, an arbitrator can award the same damages and relief as a court (including injunctive and declaratory relief or statutory damages), and must follow the terms of these Conditions of Use as a court would.__

Before you may begin an arbitration proceeding, you must send a letter notifying us of your intent to pursue arbitration and describing your claim to our registered agent Corporation Service Company, 300 Deschutes Way SW, Suite 304, Tumwater, WA 98501. The arbitration will be conducted by the American Arbitration Association ("AAA") under its Commercial Arbitration Rules. Payment of all filing, administration and arbitrator fees will be governed by the AAA\u{2019}s Commercial Fee Schedule. You and we each agree that the underlying award in arbitration may be appealed pursuant to the AAA\u{2019}s Optional Appellate Arbitration Rules. The AAA's rules and fee schedules are available at [www.adr.org](http://www.adr.org) or by calling 1-800-778-7879 (in the United States). 

__You and we each agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated or representative action.__\xa0If for any reason a claim proceeds in court rather than in arbitration,\xa0__we each waive any right to a jury trial__ and you and we agree that any such suit may proceed only in state or Federal court in King County, Washington.

__APPLICABLE LAW__

By using any Amazon Service, you agree that the U.S. Federal Arbitration Act, applicable U.S. federal law, and the laws of the state of Washington, United States, without regard to principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon relating to these Conditions of Use or any Amazon Service, except to the extent Canadian federal or provincial law says otherwise.

__GOVERNING LANGUAGE__

It is the express wish of the parties that these Conditions of Use be drawn up in English. In the event of any inconsistency, discrepancy or conflict between the English version of these Conditions of Use and their translation in another language, the English version shall prevail. 

__SITE POLICIES, MODIFICATION, AND SEVERABILITY__

Please review our other policies posted on the Amazon site. These policies also govern your use of Amazon Services. We reserve the right to make changes to our site, policies, Service Terms, and these Conditions of Use at any time. If any of these conditions shall be deemed invalid, void, or for any reason unenforceable, that condition shall be deemed severable and shall not affect the validity and enforceability of any remaining condition.

__OUR ADDRESS__

__Our Address__

40 King Street West 47th Floor

Toronto, ON, M5H 3Y2

Canada

__Our Mailing Address__

Amazon.com.ca ULC c/o Amazon.com Services LLC

P.O. Box 81226 

Seattle, WA 98108-1226 

USA

__ADDITIONAL AMAZON SOFTWARE TERMS__

The following terms ("Software Terms") apply to any software (including any updates or upgrades to the software) and any related documentation we make available to you in connection with Amazon Services (the "Amazon Software").

1. __Use of the Amazon Software__. You may use Amazon Software solely for purposes of enabling you to use the Amazon Services as provided by Amazon, and as permitted by these Conditions of Use and any Service Terms. You may not incorporate any portion of the Amazon Software into other programs or compile any portion of it in combination with other programs, or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, distribute, assign any rights to, or license the Amazon Software in whole or in part. All software used in any Amazon Service is the property of Amazon or its software suppliers and is protected by Canadian and international copyright laws.
2. __Use of Third-Party Services__. When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile software provider. Your use of these third-party services may be subject to the separate policies, terms of use, and fees of these third parties.
3. __No Reverse Engineering__. You may not reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part.
4. __Updates__. We may offer automatic or manual updates to the Amazon Software at any time and without notice to you.
5. __Conflicts__. In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict.

__NOTICE AND PROCEDURE FOR MAKING CLAIMS OF INTELLECTUAL PROPERTY INFRINGEMENT__

If you believe that your intellectual property rights have been infringed, please submit your complaint using our [online form](https://www.amazon.ca/report/infringement). This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, and patent claims.

We respond quickly to the concerns of rights owners about any alleged infringement, and we terminate repeat infringers in appropriate circumstances.

We offer the following alternative to our online form for copyright complaints only. You may submit written claims of copyright infringement to our Copyright Agent at:

Copyright Agent

Amazon Legal Department

P.O. Box 81226

Seattle, WA 98108

USA

Phone: (206) 266-4064

Email: [copyright@amazon.com](mailto:copyright@amazon.com)

Courier address:

Copyright Agent

Amazon Legal Department

2021 7th Avenue

Seattle, WA 98121

USA

Written claims concerning copyright infringement must include the following information:

- A physical or electronic signature of the person authorized to act on behalf of the owner of the copyright interest;
- A description of the copyrighted work that you claim has been infringed upon;
- A description of where the material that you claim is infringing is located on the site;
- Your address, telephone number, and email address;
- A statement by you that you have a good-faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;
- A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.
 `,
    [(0, _common.LOCALES_MAP).FR_FR]: `
24\xa0janvier 2024

Bienvenue chez Amazon Carrier Logistics. Amazon.com.ca, ULC, et/ou les soci\xe9t\xe9s de son groupe (\xab\xa0Amazon\xa0\xbb) mettent \xe0 votre disposition des fonctionnalit\xe9s de site Web et d\u{2019}autres produits et services lorsque vous visitez le site carrierlogistics.amazon.com (le \xab\xa0Site\xa0\xbb) ou que vos utilisez des produits ou des services d\u{2019}Amazon, les applications mobiles Amazon ou des logiciels fournis par Amazon dans le contexte d\u{2019}une telle visite ou utilisation (collectivement, les \xab\xa0services Amazon\xa0\xbb). La fourniture par Amazon des services Amazon est r\xe9gie par les conditions suivantes. En utilisant les services Amazon, vous acceptez les conditions suivantes, en votre propre nom et au nom de toute autre personne qui utilise tout service d\u{2019}Amazon \xe0 partir de votre compte.

__Conditions g\xe9n\xe9rales d\u{2019}utilisation__

__En utilisant les services Amazon, vous acceptez les pr\xe9sentes conditions. Veuillez les lire avec attention.__ 

Nous offrons toute une gamme de services Amazon; dans certains cas, des modalit\xe9s additionnelles peuvent s\u{2019}appliquer. Lorsque vous utiliserez un service Amazon, vous serez \xe9galement assujetti(e) aux r\xe8gles, modalit\xe9s et ententes applicables \xe0 ce service (les \xab\xa0conditions particuli\xe8res d\u{2019}utilisation\xa0\xbb). En cas d\u{2019}incompatibilit\xe9 entre les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et les Conditions particuli\xe8res d\u{2019}utilisation, les Conditions particuli\xe8res d\u{2019}utilisation pr\xe9vaudront. Nous offrons toute une gamme de services Amazon; dans certains cas, des modalit\xe9s additionnelles peuvent s\u{2019}appliquer. Lorsque vous utiliserez un services Amazon (p.\xa0ex., Votre profil, les cartes-cadeaux, Amazon Video, Votre biblioth\xe8que num\xe9rique, les appareils Amazon ou les applications Amazon), vous serez \xe9galement assujetti(e) aux r\xe8gles, modalit\xe9s et ententes applicables \xe0 ce service Amazon (les \xab\xa0Conditions particuli\xe8res d\u{2019}utilisation\xa0\xbb). En cas d\u{2019}incompatibilit\xe9 entre les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et les Conditions particuli\xe8res d\u{2019}utilisation, les Conditions particuli\xe8res d\u{2019}utilisation pr\xe9vaudront.

__CONFIDENTIALIT\xc9__

Veuillez lire notre D\xe9claration de confidentialit\xe9, qui r\xe9git \xe9galement l\u{2019}utilisation que vous faites des services Amazon, pour prendre connaissance de nos pratiques.

__COMMUNICATIONS \xc9LECTRONIQUES__

Lorsque vous utilisez un service Amazon ou que vous nous envoyez un courriel, un message texte ou toute autre communication \xe0 partir de votre ordinateur ou de votre appareil mobile, vous communiquez avec nous par voie \xe9lectronique. Vous consentez \xe0 recevoir des communications \xe9lectroniques de notre part, comme des courriels, des messages textes, des notifications pouss\xe9es mobiles ou des avis et des messages affich\xe9s sur le pr\xe9sent site ou transmis par l\u{2019}interm\xe9diaire d\u{2019}autres Services Amazon (p. ex., notre Centre de messagerie). Vous pouvez conserver des copies de ces communications dans vos dossiers.  Vous convenez que la fourniture par voie \xe9lectronique de tout avis, entente, information ou autre communication satisfait \xe0 toute exigence juridique qu\u{2019}une communication s\u{2019}effectue par \xe9crit.

__DROIT D\u{2019}AUTEUR__

Tout le contenu figurant dans un service Amazon ou accessible via un service Amazon, comme les \xe9l\xe9ments textuels ou graphiques, les logos, les ic\xf4nes, les images, les clips audio, les t\xe9l\xe9chargements num\xe9riques, les compilations de donn\xe9es et les logiciels, est la propri\xe9t\xe9 d\u{2019}Amazon ou de ses fournisseurs de contenu, et est prot\xe9g\xe9 par les lois canadiennes et internationales en mati\xe8re de droit d\u{2019}auteur. Toute compilation de tout contenu figurant dans un service Amazon ou accessible via un service Amazon est la propri\xe9t\xe9 exclusive d\u{2019}Amazon et est prot\xe9g\xe9e par les lois canadiennes et internationales en mati\xe8re de droit d\u{2019}auteur.

__MARQUES DE COMMERCE__

Cliquez ici pour une liste non exhaustive des marques de commerce d\u{2019}Amazon. Outre ces marques, les \xe9l\xe9ments graphiques, logos, en-t\xeates de page, ic\xf4nes, scripts et appellations de services figurant dans un service Amazon ou accessibles via un service Amazon sont des marques de commerce ou la pr\xe9sentation commerciale d\u{2019}Amazon.com, Inc., ou des soci\xe9t\xe9s de son groupe aux \xc9tats-Unis et dans d\u{2019}autres pays. Il est interdit d\u{2019}utiliser toute marque de commerce ou pr\xe9sentation commerciale d\u{2019}Amazon.com, Inc., ou des soci\xe9t\xe9s de son groupe relativement \xe0 tout produit ou service qui n\u{2019}est pas un produit ou service d\u{2019}Amazon ou des soci\xe9t\xe9s de son groupe d\u{2019}une mani\xe8re susceptible de porter des clients \xe0 confusion ou d\u{2019}une mani\xe8re qui d\xe9nigre ou discr\xe9dite Amazon.com, Inc., ou une soci\xe9t\xe9 de son groupe. Toutes les marques de commerce n\u{2019}appartenant pas \xe0 Amazon.com, Inc., ou aux soci\xe9t\xe9s de son groupe qui figurent dans tout service Amazon sont la propri\xe9t\xe9 de leurs titulaires respectifs, qui peuvent \xeatre ou non affili\xe9s ou li\xe9s \xe0 Amazon ou \xe0 des soci\xe9t\xe9s de son groupe ou commandit\xe9s par celles-ci.

__LICENCE ET ACC\xc8S__

Sous r\xe9serve du respect des pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et de toutes Conditions particuli\xe8res d\u{2019}utilisation applicables et du paiement des frais applicables, le cas \xe9ch\xe9ant, Amazon ou ses fournisseurs de contenu vous accordent une licence d\u{2019}acc\xe8s et d\u{2019}utilisation personnelle et non commerciale sur les services Amazon, qui est limit\xe9e, non exclusive et non transf\xe9rable et ne peut pas donner lieu \xe0 l\u{2019}octroi d\u{2019}une sous-licence. Cette licence exclut la revente ou l\u{2019}utilisation commerciale de tout service Amazon ou du contenu de tout service Amazon, la collecte et l\u{2019}utilisation de toute fiche produit ou de la description ou du prix de tout produit, l\u{2019}utilisation d\xe9riv\xe9e de tout service Amazon ou du contenu de tout service Amazon, le t\xe9l\xe9chargement, la reproduction ou toute autre utilisation des informations sur les comptes au b\xe9n\xe9fice d\u{2019}un tiers et l\u{2019}utilisation d\u{2019}outils d\u{2019}exploration, d\u{2019}indexation, de collecte et d\u{2019}extraction de donn\xe9es.   Il est interdit d\u{2019}utiliser toute donn\xe9e ou tout r\xe9sultat g\xe9n\xe9r\xe9 par les services Amazon pour d\xe9velopper des mod\xe8les d\u{2019}apprentissage automatique ou des technologies connexes. Amazon ou ses conc\xe9dants de licence, fournisseurs, \xe9diteurs, titulaires de droits ou autres fournisseurs de contenu conservent et se r\xe9servent tous les droits qui ne vous sont pas express\xe9ment accord\xe9s par les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation ou par toutes Conditions particuli\xe8res d\u{2019}utilisation applicables le cas \xe9ch\xe9ant. Aucun service Amazon ne peut \xeatre reproduit, dupliqu\xe9, copi\xe9, vendu, revendu, visit\xe9 ou autrement exploit\xe9 \xe0 quelque fin commerciale que ce soit, en tout ou en partie, sans le consentement \xe9crit expr\xe8s d\u{2019}Amazon. Il est interdit d\u{2019}utiliser toute technique de cadrage sur toute marque de commerce, tout logo ou toute autre information exclusive d\u{2019}Amazon (y compris les images, le texte, la mise en page ou la forme), sans le consentement \xe9crit expr\xe8s d\u{2019}Amazon. Il est interdit d\u{2019}utiliser le nom ou les marques de commerce d\u{2019}Amazon dans toute balise M\xe9ta ou tout autre texte masqu\xe9, sans le consentement \xe9crit expr\xe8s d\u{2019}Amazon. Tout usage abusif des services Amazon est interdit. Vous ne pouvez utiliser les Services Amazon que conform\xe9ment \xe0 la loi. Le non-respect des pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation ou de toutes Conditions particuli\xe8res d\u{2019}utilisation applicables, le cas \xe9ch\xe9ant, entra\xeene la r\xe9siliation des licences accord\xe9es par Amazon.

__VOTRE COMPTE__

Vous pourriez avoir besoin de votre propre compte Amazon pour utiliser certains services Amazon et vous pourriez devoir vous connecter. Vous avez la responsabilit\xe9 de pr\xe9server la confidentialit\xe9 de votre compte et de votre mot de passe, et de limiter l\u{2019}acc\xe8s \xe0 votre compte, et vous vous engagez \xe0 assumer la responsabilit\xe9 de toutes les activit\xe9s r\xe9alis\xe9es \xe0 partir de votre compte ou au moyen de votre mot de passe. Amazon se r\xe9serve le droit de refuser de servir un client, de fermer un compte, de mettre fin \xe0 vos droits d\u{2019}utiliser les services Amazon ou de supprimer ou de modifier tout contenu, \xe0 son enti\xe8re discr\xe9tion.

__AVIS, COMMENTAIRES, COMMUNICATIONS ET AUTRE CONTENU__

Lorsqu\u{2019}il y a une fonctionnalit\xe9 \xe0 cette fin, vous pouvez publier des avis, commentaires et autres, et soumettre des suggestions, id\xe9es, commentaires, questions et autres informations, \xe0 condition que votre publication ou soumission ne soit pas ill\xe9gale, obsc\xe8ne, mena\xe7ante ou diffamatoire, ne porte pas atteinte \xe0 la vie priv\xe9e, n\u{2019}enfreigne aucun droit de propri\xe9t\xe9 intellectuelle (y compris les droits de publicit\xe9) et ne soit pas pr\xe9judiciable \xe0 un tiers ou r\xe9pr\xe9hensible de toute autre mani\xe8re, qu\u{2019}elle soit exempte de virus informatique et qu\u{2019}elle ne contienne pas et ne constitue pas un discours politique, une sollicitation commerciale, une cha\xeene de courriels, un publipostage ou toute autre forme de pourriel ou de message \xe9lectronique commercial non sollicit\xe9. Il est interdit d\u{2019}utiliser une fausse adresse \xe9lectronique, de se faire passer pour toute autre personne ou entit\xe9 ou d\u{2019}induire autrui en erreur quant \xe0 l\u{2019}origine d\u{2019}une carte ou d\u{2019}un autre contenu de toute autre mani\xe8re. Amazon a le droit (mais non l\u{2019}obligation) de supprimer ou de modifier un tel contenu, mais ne contr\xf4le pas r\xe9guli\xe8rement le contenu qui est affich\xe9.

Lorsque vous publiez un contenu ou soumettez un document ou renseignement, sauf indication contraire de notre part, vous donnez \xe0 Amazon le droit d\u{2019}utiliser, de reproduire, de modifier, d\u{2019}adapter, de publier, de repr\xe9senter, de traduire, de diffuser et d\u{2019}afficher ce contenu, ou d\u{2019}en tirer des \u{153}uvres d\xe9riv\xe9es, partout dans le monde et sur tout support, ce droit \xe9tant non exclusif, libre de redevances, perp\xe9tuel, irr\xe9vocable et assorti du droit d\u{2019}octroyer des sous-licences. Vous donnez \xe0 Amazon et \xe0 ses sous-licenci\xe9s le droit d\u{2019}utiliser le nom que vous soumettez en lien avec ce contenu, s\u{2019}ils le souhaitent. Vous d\xe9clarez et garantissez que vous \xeates propri\xe9taire du contenu que vous publiez ou que vous contr\xf4lez tous les droits sur ce contenu d\u{2019}une autre mani\xe8re, que ce contenu est exact, que l\u{2019}utilisation du contenu fourni n\u{2019}enfreint pas la pr\xe9sente politique et ne causera aucun pr\xe9judice \xe0 quelque personne ou entit\xe9 que ce soit et que vous indemniserez Amazon de toute r\xe9clamation d\xe9coulant du contenu que vous fournissez. Amazon a le droit, mais non l\u{2019}obligation, de surveiller et de modifier ou de supprimer tout contenu ou toute activit\xe9.  Amazon n\u{2019}assume aucune responsabilit\xe9 quant au contenu qui est publi\xe9 par vous ou par un tiers.

__PLAINTES EN MATI\xc8RE DE PROPRI\xc9T\xc9 INTELLECTUELLE__

Amazon respecte les droits de propri\xe9t\xe9 intellectuelle d\u{2019}autrui. Si vous estimez que vos droits de propri\xe9t\xe9 intellectuelle sont enfreints, veuillez vous reporter \xe0 la rubrique Avis et proc\xe9dure de d\xe9p\xf4t de plainte pour violation de droits de propri\xe9t\xe9 intellectuelle.

__AUTORISATIONS RELATIVES AUX APPLICATIONS__

Lorsque vous utilisez une application cr\xe9\xe9e par Amazon, vous pourriez nous accorder certaines autorisations concernant votre appareil. La plupart des appareils mobiles vous fournissent des renseignements sur ces autorisations. Pour en savoir plus sur ces autorisations, cliquez ici.

__POLITIQUE SUR LES SANCTIONS ET L\u{2019}EXPORTATION__

Si vous faites l\u{2019}objet de sanctions impos\xe9es par les \xc9tats-Unis ou de sanctions conformes au droit am\xe9ricain impos\xe9es par le gouvernement du pays depuis lequel vous utilisez les services Amazon, il vous est interdit d\u{2019}utiliser tout service Amazon. Vous devez vous conformer \xe0 toutes les restrictions en mati\xe8re d\u{2019}exportation et de r\xe9exportation impos\xe9es par les \xc9tats-Unis ou d\u{2019}autres pays relativement aux produits, aux logiciels (y compris les logiciels Amazon), aux technologies et aux services.

__AUTRES ENTREPRISES__

Nous pourrions afficher des liens vers les sites de soci\xe9t\xe9s de notre groupe et de certaines autres entreprises. Nous n\u{2019}avons pas la responsabilit\xe9 de contr\xf4ler ou d\u{2019}\xe9valuer les services et produits offerts par ces entreprises ou particuliers (y compris le contenu de leurs sites Web) et nous ne donnons aucune garantie \xe0 cet \xe9gard. Amazon n\u{2019}assume aucune responsabilit\xe9 quant aux actes, aux produits et au contenu de ces parties ou de tout autre tiers. Nous vous conseillons de lire attentivement les d\xe9clarations de confidentialit\xe9 et autres conditions d\u{2019}utilisation des parties ou autres tiers en question.

__EXON\xc9RATION DE GARANTIES ET LIMITATION DE RESPONSABILIT\xc9__

LES LOIS DE CERTAINS TERRITOIRES, Y COMPRIS LA LOI SUR LA PROTECTION DU CONSOMMATEUR DU QU\xc9BEC, NE PERMETTENT AUCUNE RESTRICTION QUANT AUX GARANTIES OU CONDITIONS IMPLICITES NI AUCUNE EXCLUSION OU LIMITATION DE RESPONSABILIT\xc9 QUANT \xc0 CERTAINS DOMMAGES. SI CES LOIS S\u{2019}APPLIQUENT \xc0 VOTRE ENDROIT, TOUT OU PARTIE DES EXON\xc9RATIONS, EXCLUSIONS OU LIMITATIONS \xc9NONC\xc9ES CI-DESSOUS POURRAIT NE PAS S\u{2019}APPLIQUER \xc0 VOTRE ENDROIT ET VOUS POURRIEZ DISPOSER DE DROITS ADDITIONNELS.

LES SERVICES AMAZON ET L\u{2019}INT\xc9GRALIT\xc9 DES RENSEIGNEMENTS, DU CONTENU, DES DOCUMENTS, DES PRODUITS (Y COMPRIS LES LOGICIELS) ET DES AUTRES SERVICES FIGURANT DANS LES SERVICES AMAZON, FAISANT PARTIE DES SERVICES AMAZON OU ACCESSIBLES VIA LES SERVICES AMAZON SONT FOURNIS PAR AMAZON \xab\xa0EN L\u{2019}\xc9TAT\xa0\xbb ET \xab\xa0EN FONCTION DES DISPONIBILIT\xc9S\xa0\xbb, SAUF STIPULATION \xc9CRITE EXPRESSE \xc0 L\u{2019}EFFET CONTRAIRE. AMAZON NE FAIT AUCUNE D\xc9CLARATION NI NE DONNE AUCUNE GARANTIE QUELLE QU\u{2019}ELLE SOIT, EXPLICITE OU IMPLICITE, QUANT AU FONCTIONNEMENT DES SERVICES AMAZON OU AUX RENSEIGNEMENTS, AU CONTENU, AUX DOCUMENTS, AUX PRODUITS (Y COMPRIS LES LOGICIELS) OU AUX SERVICES FIGURANT DANS LES SERVICES AMAZON, FAISANT PARTIE DES SERVICES AMAZON OU ACCESSIBLES VIA LES SERVICES AMAZON, SAUF STIPULATION \xc9CRITE EXPRESSE \xc0 L\u{2019}EFFET CONTRAIRE. VOUS CONVENEZ EXPRESS\xc9MENT QUE VOUS UTILISEZ LES SERVICES AMAZON \xc0 VOS PROPRES RISQUES.

DANS TOUTE LA MESURE PERMISE PAR LA LOI, AMAZON EXCLUT TOUTE GARANTIE OU CONDITION, EXPRESSE OU IMPLICITE (Y COMPRIS LES GARANTIES IMPLICITES DE QUALIT\xc9 MARCHANDE ET DE CONVENANCE PR\xc9CISE). AMAZON NE GARANTIT PAS L\u{2019}ABSENCE DE VIRUS OU D\u{2019}AUTRES \xc9L\xc9MENTS NOCIFS DANS LES SERVICES AMAZON, DANS LES RENSEIGNEMENTS, LE CONTENU, LES DOCUMENTS, LES PRODUITS (Y COMPRIS LES LOGICIELS) OU LES AUTRES SERVICES FIGURANT DANS LES SERVICES AMAZON, FAISANT PARTIE DES SERVICES AMAZON OU ACCESSIBLES VIA LES SERVICES AMAZON, SUR SES SERVEURS OU DANS LES COMMUNICATIONS \xc9LECTRONIQUES PROVENANT D\u{2019}AMAZON. DANS TOUTE LA MESURE PERMISE PAR LA LOI, AMAZON D\xc9CLINE TOUTE RESPONSABILIT\xc9 \xc0 L\u{2019}\xc9GARD DES DOMMAGES DE QUELQUE TYPE QUE CE SOIT QUI POURRAIENT D\xc9COULER DE L\u{2019}UTILISATION DES SERVICES AMAZON OU DES RENSEIGNEMENTS, DU CONTENU, DES DOCUMENTS, DES PRODUITS (Y COMPRIS LES LOGICIELS) OU D\u{2019}AUTRES SERVICES FIGURANT DANS LES SERVICES AMAZON, FAISANT PARTIE DES SERVICES AMAZON OU ACCESSIBLES VIA LES SERVICES AMAZON, NOTAMMENT LES DOMMAGES DIRECTS, INDIRECTS, ACCESSOIRES OU PUNITIFS, SAUF STIPULATION \xc9CRITE EXPRESSE \xc0 L\u{2019}EFFET CONTRAIRE.

__DIFF\xc9RENDS__

__Toute r\xe9clamation ou tout diff\xe9rend li\xe9 de quelque mani\xe8re que ce soit aux pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation ou \xe0 l\u{2019}utilisation que vous faites d\u{2019}un service Amazon sera tranch\xe9 par voie d\u{2019}arbitrage contraignant, plut\xf4t que par voie judiciaire__, \xe0 moins que l\u{2019}une des parties ne choisisse de proc\xe9der devant une cour des petites cr\xe9ances aux \xc9tats-Unis si la r\xe9clamation ou le diff\xe9rend y est admissible en vertu du droit applicable. Les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation sont r\xe9gies par la loi am\xe9ricaine intitul\xe9e \xab\xa0*Federal Arbitration Act*\xa0\xbb et par les lois f\xe9d\xe9rales en mati\xe8re d\u{2019}arbitrage.

__Il n\u{2019}y a ni juge ni jury dans le cadre d\u{2019}un arbitrage et le droit \xe0 la r\xe9vision judiciaire d\u{2019}une sentence arbitrale est restreint. Cependant, l\u{2019}arbitre peut ordonner les m\xeames dommages-int\xe9r\xeats et mesures de r\xe9paration qu\u{2019}un tribunal judiciaire (y compris une injonction et un jugement d\xe9claratoire ou des dommages-int\xe9r\xeats d\u{2019}origine l\xe9gislative) et doit appliquer les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation comme le ferait un tribunal judiciaire.__

Avant d\u{2019}engager une proc\xe9dure d\u{2019}arbitrage, vous devez envoyer une lettre nous avisant de votre intention d\u{2019}engager une proc\xe9dure d\u{2019}arbitrage et d\xe9crivant votre r\xe9clamation \xe0 notre repr\xe9sentant enregistr\xe9\xa0: Corporation Service Company, 300 Deschutes Way SW, Suite 304, Tumwater, WA 98501. L\u{2019}arbitrage sera men\xe9 par l\u{2019}American Arbitration Association (AAA) conform\xe9ment \xe0 ses r\xe8gles d\u{2019}arbitrage commercial, intitul\xe9es \xab\xa0*Commercial Arbitration Rules*\xa0\xbb. Le paiement des tous les frais de d\xe9p\xf4t, de gestion et d\u{2019}arbitrage sera r\xe9gi par le tarif de l\u{2019}AAA en mati\xe8re commerciale, intitul\xe9 \xab\xa0Commercial Fee Schedule\xa0\xbb. Chacun de nous (c.-\xe0-d. vous et nous) convient que la sentence arbitrale pourra faire l\u{2019}objet d\u{2019}un appel conform\xe9ment aux r\xe8gles de l\u{2019}AAA en la mati\xe8re, intitul\xe9es \xab\xa0*Optional Appellate Arbitration Rules*\xa0\xbb. Vous pouvez obtenir les r\xe8gles et les tarifs de l\u{2019}AAA en consultant le www.adr.org ou en appelant le 1\xa0(800)\xa0778-7879 (aux \xc9tats-Unis). 

__Chacun de nous convient que les diff\xe9rends ne seront r\xe9gl\xe9s que sur une base individuelle et non dans le cadre d\u{2019}une action collective, d\u{2019}instances r\xe9unies ou d\u{2019}une action repr\xe9sentative.__\xa0Si, pour quelque raison que ce soit, une r\xe9clamation proc\xe8de devant un tribunal judiciaire plut\xf4t que par arbitrage, __chacun de nous renonce \xe0 son droit \xe0 un proc\xe8s devant jury__ et convient que le seul for comp\xe9tent est un tribunal \xe9tatique ou f\xe9d\xe9ral du King County (\xc9tat de Washington).

__DROIT APPLICABLE__

En utilisant un service Amazon, vous convenez que les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et tout diff\xe9rent quel qu\u{2019}il soit qui pourrait na\xeetre entre vous et Amazon \xe0 cet \xe9gard ou relativement \xe0 tout service Amazon seront r\xe9gis par la *Federal Arbitration Act* (\xc9tats-Unis), les lois f\xe9d\xe9rales am\xe9ricaines applicables et les lois de l\u{2019}\xc9tat de Washington (\xc9tats-Unis), sans \xe9gard aux principes de conflit de lois, sauf dans la mesure o\xf9 les lois f\xe9d\xe9rales ou provinciales du Canada en disposent autrement.

__LANGUE__

Les parties ont express\xe9ment choisi que les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation soient r\xe9dig\xe9es en anglais. En cas d\u{2019}incoh\xe9rence, de divergence ou de conflit entre la version anglaise des pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et leur traduction dans une autre langue, la version anglaise pr\xe9vaudra. 

__POLITIQUES DU SITE, MODIFICATIONS ET DIVISIBILIT\xc9__

Veuillez lire nos autres politiques, qui sont affich\xe9es sur le site Amazon. Ces politiques r\xe9gissent \xe9galement l\u{2019}utilisation que vous faites des services Amazon. Nous nous r\xe9servons le droit de modifier notre site, nos politiques, les Conditions g\xe9n\xe9rales d\u{2019}utilisation et les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation en tout temps. Si toute disposition des pr\xe9sentes \xe9tait jug\xe9e invalide, nulle ou non ex\xe9cutoire pour quelque raison que ce soit, elle sera consid\xe9r\xe9e comme divisible et cette invalidit\xe9, cette nullit\xe9 ou ce caract\xe8re non ex\xe9cutoire sera sans effet sur la validit\xe9 et le caract\xe8re ex\xe9cutoire des autres dispositions.

__NOTRE ADRESSE__

__Notre adresse__

40 King Street West 47th Floor

Toronto, ON, M5H 3Y2

Canada

__Notre adresse postale__

Amazon.com.ca ULC c/o Amazon.com Services LLC

P.O. Box\xa081226 

Seattle, WA\xa098108-1226 

\xc9TATS-UNIS

__CONDITIONS ADDITIONNELLES PROPRES AUX LOGICIELS AMAZON__

Les dispositions suivantes (les \xab\xa0Conditions d\u{2019}utilisation des logiciels\xa0\xbb) s\u{2019}appliquent concernant les logiciels (y compris les mises \xe0 jour ou les mises \xe0 niveau des logiciels) et les documents connexes que nous mettons \xe0 votre disposition dans le contexte des services Amazon (les \xab\xa0logiciels Amazon\xa0\xbb).

1. __Utilisation des logiciels Amazon__ Vous ne pouvez utiliser les logiciels Amazon qu\u{2019}aux fins d\u{2019}utiliser les Services Amazon tels qu\u{2019}ils sont fournis par Amazon et dans le respect des pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et de toutes Conditions particuli\xe8res d\u{2019}utilisation applicables, le cas \xe9ch\xe9ant. Il est interdit d\u{2019}int\xe9grer toute partie des logiciels Amazon \xe0 d\u{2019}autres programmes, de combiner toute partie des logiciels Amazon \xe0 d\u{2019}autres programmes lors d\u{2019}une compilation, ou de copier (sauf afin d\u{2019}exercer les droits conf\xe9r\xe9s par le pr\xe9sent article), de modifier ou de distribuer de toute autre mani\xe8re tout ou partie des logiciels Amazon, de cr\xe9er des \u{153}uvres d\xe9riv\xe9es \xe0 partir de tout ou partie des logiciels Amazon ou de c\xe9der des droits ou d\u{2019}octroyer une licence sur tout ou partie des logiciels Amazon. Tous les logiciels utilis\xe9s dans le cadre d\u{2019}un service Amazon sont la propri\xe9t\xe9 d\u{2019}Amazon ou de ses fournisseurs de logiciels et sont prot\xe9g\xe9s par les lois canadiennes et internationales en mati\xe8re de droit d\u{2019}auteur.
2. __Utilisation de services tiers__. Lorsque vous utilisez les logiciels Amazon, il est possible que vous utilisiez \xe9galement les services d\u{2019}un ou de plusieurs tiers (p. ex., un op\xe9rateur de r\xe9seau mobile ou un fournisseur de logiciels pour appareils mobiles). L\u{2019}utilisation que vous faites de ces services tiers peut \xeatre assujettie \xe0 des politiques et des conditions d\u{2019}utilisation distinctes adopt\xe9es par ces tiers et \xe0 des frais impos\xe9s par ces tiers.
3. __R\xe9troing\xe9nierie interdite.__ Il est interdit de d\xe9sosser, de d\xe9compiler, de d\xe9sassembler ou d\u{2019}alt\xe9rer tout ou partie des logiciels Amazon ou de contourner quelque mesure de s\xe9curit\xe9 que ce soit qui s\u{2019}y rapporte.
4. __Mises \xe0 jour__. Nous pouvons offrir des mises \xe0 jour automatiques ou manuelles des logiciels Amazon en tout temps, sans vous en aviser.
5. __Incompatibilit\xe9__. En cas d\u{2019}incompatibilit\xe9 entre les pr\xe9sentes Conditions g\xe9n\xe9rales d\u{2019}utilisation et d\u{2019}autres dispositions r\xe9gissant toute partie des logiciels Amazon, qu\u{2019}elles \xe9manent d\u{2019}Amazon ou d\u{2019}un tiers (p. ex., les dispositions d\u{2019}une licence sur un logiciel libre), ces autres dispositions pr\xe9vaudront \xe0 l\u{2019}\xe9gard de la partie en question dans la mesure de l\u{2019}incompatibilit\xe9.

__AVIS ET PROC\xc9DURE DE D\xc9P\xd4T DE PLAINTE POUR VIOLATION DE DROITS DE PROPRI\xc9T\xc9 INTELLECTUELLE__

Si vous estimez que vos droits de propri\xe9t\xe9 intellectuelle ont \xe9t\xe9 enfreints, veuillez soumettre votre plainte en utilisant notre formulaire en ligne. Ce formulaire peut \xeatre utilis\xe9 pour signaler une atteinte \xe0 tout type de droits de propri\xe9t\xe9 intellectuelle, notamment concernant un droit d\u{2019}auteur, une marque de commerce ou un brevet.

Nous r\xe9pondons rapidement aux all\xe9gations d\u{2019}atteinte \xe0 un droit de propri\xe9t\xe9 intellectuelle faites par les titulaires de droits et mettons fin aux droits des contrefacteurs r\xe9cidivistes lorsque les circonstances s\u{2019}y pr\xeatent.

Dans le cas d\u{2019}une plainte relative \xe0 un droit d\u{2019}auteur, au lieu d\u{2019}utiliser notre formulaire en ligne, vous pouvez aussi soumettre votre plainte par \xe9crit \xe0 notre agent des droits d\u{2019}auteur, \xe0 l\u{2019}adresse suivante\xa0:

Copyright Agent

Amazon Legal Department

P.O. Box\xa081226

Seattle, WA\xa098108

\xc9TATS-UNIS

T\xe9l\xe9phone\xa0: (206)\xa0266-4064

Courriel\xa0: copyright@amazon.com

Par messager\xa0:

Copyright Agent

Amazon Legal Department

2021 7th Avenue

Seattle, WA\xa098121

\xc9TATS-UNIS

Les plaintes concernant la violation d\u{2019}un droit d\u{2019}auteur faites par \xe9crit doivent comprendre les renseignements suivants\xa0:

- la signature manuscrite ou \xe9lectronique de la personne autoris\xe9e \xe0 agir pour le compte du titulaire du droit d\u{2019}auteur;
- la description de l\u{2019}\u{153}uvre prot\xe9g\xe9e par le droit d\u{2019}auteur dont vous all\xe9guez la violation;
- la description de l\u{2019}emplacement de l\u{2019}\xe9l\xe9ment contrevenant, selon vous, au droit d\u{2019}auteur sur notre site;
- votre adresse, votre num\xe9ro de t\xe9l\xe9phone et votre adresse \xe9lectronique;
- une d\xe9claration de votre part selon laquelle vous croyez de bonne foi que l\u{2019}utilisation contest\xe9e n\u{2019}est pas autoris\xe9e par le titulaire du droit d\u{2019}auteur, par son mandataire ou par la loi;
- une d\xe9claration que vous faites sous peine de parjure selon laquelle 1) les renseignements susmentionn\xe9s figurant dans votre plainte sont exacts et 2) vous \xeates le titulaire du droit d\u{2019}auteur ou \xeates autoris\xe9(e) \xe0 agir pour le compte de celui-ci.
 
  `
};
const aeConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
  Welcome to Amazon Carrier Logistics.

Souq.com FZ LLC and/or its affiliates ("Amazon", \u{201C}us\u{201D}, \u{201C}we\u{201D} or \u{201C}our\u{201D}) provide website features and other products and services to you when you visit carrierlogistics.amazon.com   (the \u{201C}website\u{201D}), use Amazon products or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "Amazon Services"). Please see our [Privacy Notice](/privacy-notice) and our [Cookies Notice](https://www.amazon.ae/gp/help/customer/display.html/?nodeId=201890250) to understand how we collect and process your personal information through Amazon Services. Amazon provides Amazon Services subject to the Conditions of Use set out on this page.

__Conditions of Use__

__Please read these Conditions of Use carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these Conditions of Use.__ We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.

__1. ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service or send e-mails, text messages or other communications from any device to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communication be in writing, unless mandatory applicable laws specifically require a different form of communication.

__2. RECOMMENDATIONS AND PERSONALISATION__

As part of the Amazon Services, we may recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalize your experience. You can find out more about our interest-based ads [here](https://www.amazon.ae/gp/help/customer/display.html?nodeId=202075050&ref_=footer_ads).

__3. COPYRIGHT, AUTHORS' RIGHTS AND DATABASE RIGHTS__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by local and international copyright, authors' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by local and international copyright and database right laws.

You may not extract and/or re-utilize parts of the content of any Amazon Service without our express written consent. In particular, you may not utilize any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilization any parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.

__4. TRADEMARKS__

[Click here to see a non-exhaustive list of Amazon trademarks](https://www.amazon.ae/gp/help/customer/display.html?nodeId=201909280). These and other trademarks that appear in any Amazon Service are trademarks of Amazon and may be registered in [insert applicable country] or in certain other countries. In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

__5. LICENSE AND ACCESS__

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any, product listings, descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's names or trademarks without our express written consent.

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__6. YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account and have a valid payment method associated with it.

<a id="_Hlk112947971"></a>If there is a problem charging your selected payment method, we may charge any other valid payment method associated with your account. 

If you use any Amazon Service, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorized manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. You can access your information in the Your Account section of the Website.

You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance or inconvenience.

We reserve the right to refuse any Amazon Services, terminate accounts, terminate your rights to use any Amazon Service, remove or edit content at our sole discretion. This will in particular be the case if we have reason to believe that you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are made available to you from time to time or accessible on the website, or have conducted an unlawful, abusive, or otherwise inappropriate act. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.

__7. REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT__

Where the functionality exists to do so, visitors may post reviews, comments and other content; send communications; and submit suggestions, ideas, comments, questions or other information, as long as the content is not illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of "spam". You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but do not, in the absence of a valid [Report Infringement Notice Form](https://www.amazon.ae/report/infringement/signin), assume the obligation) to remove or edit such content. If you believe that any content on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate [Report Infringement Notice Form](https://www.amazon.ae/report/infringement/signin) and we will respond.

If you post reviews, comments, questions or answers, or other content generated by you for display on the website (including any images, video or audio, all together "content"), you grant Amazon (a) a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable license and right to use, reproduce, publish, make available, translate, adapt, publish, translate, create derivative works from, distribute, display and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.

You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as of the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly. Amazon has the right but not the obligation to monitor and edit or remove any activity or content. Amazon takes no responsibility and assumes no liability for any content posted by you or any third party.

__8. AMAZON SOFTWARE TERMS__

In addition to these Conditions of Use, the terms found under Additional Amazon Software Terms apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the "Amazon Software").

__9. APP PERMISSIONS__

When you use apps created by Amazon, you may grant certain permissions to us for your device. Most mobile devices provide you with information about these permissions.

__10. SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are subject to sanctions or otherwise designated on any list of prohibited or restricted parties or owned or controlled by such a party, including but not limited to the lists maintained by the United States, United Nations Security Council, the European Union or its member states, or by any government authority in the country where you are using Amazon Services. In connection with the Service Terms and these Conditions of Use, you will comply with all applicable import, re-import, sanctions, anti-boycott, export, and re-export control laws, such as the Export Administration Regulations, the International Traffic in Arms Regulations, and economic sanctions programs administered by the Office of Foreign Assets Control. You understand that some of the software, technology or related information that you and your employees or contractors may have access to may be subject to export control laws and regulations (the "Export Controlled Materials"). You will not, without our prior written approval, allow any of your employees or contractors to have access to or use of any Export Controlled Materials if such access or use would require an export license.

__11. OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses. We are not responsible for examining or evaluating, and we do not warrant the offerings of any of these businesses or individuals (including the content of their web sites). Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties. You should carefully review their privacy statements and other conditions of use.

__12. OUR LIABILITY__

The website and all information, content, materials, products (including any software) and services included on or otherwise made available to you through the website are provided by Amazon on an \u{201C}as is\u{201D} and \u{201C}as available\u{201D} basis, unless otherwise specified in the Service Terms or these Conditions of Use. Amazon makes no representations or warranties of any kind, express or implied, as to the operation of the website or the information, content, materials, products (including any software) or services included on or otherwise made available to you through the website, unless otherwise specified in the Service Terms or these Conditions of Use. You expressly agree that your use of the website is at your sole risk. To the full extent permissible by applicable law, Amazon disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. Amazon does not warrant that the website; information, content, materials, products (including any software) or services included on or otherwise made available to you through the website; its servers; or e-mail sent from Amazon are free of viruses or other harmful components. Amazon will not be liable for any damages of any kind arising from the use of the website or from any information, content, materials, products (including software) or services included on or otherwise made available to you through the website, including but not limited to direct, indirect, incidental, punitive, and consequential damages, unless otherwise specified in the Service Terms or these Conditions of Use. The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above disclaimers, exclusions, or limitations may not apply to you, and you might have additional rights.

__13. INDEMNITY AND RELEASE__

To the full extent permissible by law, you agree to indemnify and hold harmless Souq.com FZ LLC, its subsidiaries, affiliates and their respective officers, directors, agents and employees, from any claim or demand, or actions including reasonable attorney's fees, made by any third party or penalty imposed due to or arising out of your breach of these Conditions of Use or your violation of any law, rules, regulations or the rights of a third party. To the full extent permissible by law, you hereby expressly Souq.com FZ LLC and/or its affiliates and/or any of its officers and representatives from any cost, damage, liability or other consequence and specifically waiver any claims or demands that you may have in this behalf under any statute, contract or otherwise.

__14. EVENTS BEYOND REASONABLE CONTROL__

Amazon will not be held responsible for any delay or failure to comply with its obligations under these conditions if the delay or failure arises from any cause which is beyond its reasonable control. This condition does not affect your statutory rights.

<a id="_Hlk153187673"></a>__15. APPLICABLE LAW AND DISPUTES__

<a id="_Hlk113275495"></a><a id="_Hlk153187698"></a>By using any Amazon Service, you agree the laws of the Dubai International Finance Center (\u{201C}DIFC\u{201D}), without regard to the principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon.  The application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded.

If any dispute, claim, difference or controversy arising out of, relating to or having any connection with your use of the Amazon Services (for the purpose of this section, a \u{201C}Dispute\u{201D}) qualifies for determination through the DIFC Small Claims Tribunal (\u{201C}SCT\u{201D}), then the SCT shall have exclusive jurisdiction to settle any such Dispute. For Disputes that do not qualify for determination through the SCT, the courts of the DIFC shall have exclusive jurisdiction to settle such Dispute and each party submits to the exclusive jurisdiction of the courts of the DIFC. For the purposes of this section, you waive any objection to either the courts of the DIFC or the SCT, as applicable, on the grounds that either of them is an inconvenient or inappropriate forum to settle any Dispute.

__16. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE__

We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.

We reserve the right to make changes to any Amazon Services Conditions of Use and Service Terms at any time by posting the changes on the website or application that is used to provide the Amazon Services. Where we make a materially adverse change to these Conditions of Use or any applicable Service Terms, as reasonably determined by us, Amazon will provide advance notice to you.    You will be subject to the Conditions of Use and Service Terms made available to you on the relevant website or application at the time that you use the Amazon Services. You may at any time, cease using any Amazon Services, terminate your account or the relevant Amazon Service including in the event of any such change.

__17. WAIVER__

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

__18. OUR ADDRESS__

<a id="_Hlk113277577"></a>Souq.com FZ LLC

Zone C-FL3

3rd Floor

Dubai Properties Headquarters

Dubai, United Arab Emirates.

__19. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been infringed, please submit your complaint using our online Report Infringement Notice Form. This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims. 

Upon receipt of a complaint, we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint 

__Important Warning:__ giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions. 

__ADDITIONAL AMAZON SOFTWARE TERMS__

1. __Use of the Amazon Software.__ You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by the Conditions of Use, these Software Terms and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, or assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by local and international copyright laws. 
2. __Use of Third Party Services.__ When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties. 
3. __No Reverse Engineering.__ Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorize any other person to copy, modify, reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software. 
4. __Updates.__ In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you. 
5. __Conflicts.__\xa0In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict

 `
};
const brConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
  Welcome to the Amazon Carrier Logistics Brazil website.

Amazon Servi\xe7os de Varejo do Brasil Ltda.  and/or its affiliates ("Amazon", \u{201C}us\u{201D}, \u{201C}we\u{201D} or \u{201C}our\u{201D}) provide website features and other products and services to you when you visit carrierlogistics.amazon.com.br (the \u{201C}website\u{201D}), use Amazon products or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "Amazon Services"). Please see our [Privacy Notice](/privacy-notice) and our [Cookies Notice](https://www.amazon.com.br/gp/help/customer/display.html?nodeId=201890250&ref_=footer_cookies) to understand how we collect and process your personal information through Amazon Services. Amazon provides Amazon Services subject to the Conditions of Use set out on this page.  \u{201C}Amazon Carrier Logistics\u{201D}.

__Conditions of Use__

__Please read these Conditions of Use carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these Conditions of Use.__ We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.

__1. ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service or send e-mails, text messages or other communications from any device] to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communication be in writing, unless mandatory applicable laws specifically require a different form of communication.

__2. RECOMMENDATIONS AND PERSONALISATION__

As part of the Amazon Services, we may recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalize your experience.

__3. COPYRIGHT, AUTHORS' RIGHTS AND DATABASE RIGHTS__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by Brazilian and international copyright, authors' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by Brazilian and international copyright and database right laws.

You may not extract and/or re-utilize parts of the content of any Amazon Service without our express written consent. In particular, you may not utilize any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilization any parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.

__4. TRADEMARKS__

[Click here](https://www.amazon.com.br/gp/help/customer/display.html?nodeId=201283930) to see a non-exhaustive list of Amazon trademarks. These and other trademarks that appear in any Amazon Service are trademarks of Amazon and may be registered in [insert applicable country] or in certain other countries. In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

__5. LICENSE AND ACCESS__

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any, product listings, descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's names or trademarks without our express written consent.

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__6. YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account and have a valid payment method associated with it.

If there is a problem charging your selected payment method, we may charge any other valid payment method associated with your account. 

If you use any Amazon Service, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorized manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. Please see our [Help Page](https://www.amazon.com.br/gp/help/customer/display.html?nodeId=GXPU3YPMBZQRWZK2) to access your personal information. 

You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance or inconvenience.

We reserve the right to refuse any Amazon Services, terminate accounts, terminate your rights to use any Amazon Service, remove or edit content at our sole discretion. This will in particular be the case if we have reason to believe that you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are made available to you from time to time or accessible on the website, or have conducted an unlawful, abusive, or otherwise inappropriate act. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.

__7. REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT__

Where the functionality exists to do so, visitors may post reviews, comments and other content; send communications; and submit suggestions, ideas, comments, questions or other information, as long as the content is not illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of "spam". You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but do not, in the absence of a valid [Report Infringement Notice Form](https://www.amazon.com.br/report/infringement/signin), assume the obligation) to remove or edit such content. If you believe that any content on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate [Report Infringement Notice Form](https://www.amazon.com.br/report/infringement/signin) and we will respond.

If you post reviews, comments, questions or answers, or other content generated by you for display on the website (including any images, video or audio, all together "content"), you grant Amazon (a) a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable license and right to use, reproduce, publish, make available, translate, adapt, publish, translate, create derivative works from, distribute, display and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.

You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as of the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content (see [help page](https://www.amazon.com.br/gp/help/customer/display.html?ref_=hp_gcs_csd_d2_000_7_GLHXEX85MENUE4XF_ntKeX3dga2&nodeId=GLHXEX85MENUE4XF&qid=1710279603568&sr=7#GUID-E766DD87-689E-44A6-B0A5-5643821DF787__SECTION_F10DD42B52F0419EAD13F152FF7F5B63)) arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly. 

__8. AMAZON SOFTWARE TERMS__

In addition to these Conditions of Use, the terms found under Additional Amazon Software Terms apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the "Amazon Software").

__9. APP PERMISSIONS__

When you use apps created by Amazon, you may grant certain permissions to us for your device. Most mobile devices provide you with information about these permissions.

__10. SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are subject to sanctions or otherwise designated on any list of prohibited or restricted parties or owned or controlled by such a party, including but not limited to the lists maintained by the United States, United Nations Security Council, the European Union or its member states, or by any government authority in the country where you are using Amazon Services. In connection with the Service Terms and these Conditions of Use, you will comply with all applicable import, re-import, sanctions, anti-boycott, export, and re-export control laws, such as the Export Administration Regulations, the International Traffic in Arms Regulations, and economic sanctions programs administered by the Office of Foreign Assets Control. You understand that some of the software, technology or related information that you and your employees or contractors may have access to may be subject to export control laws and regulations (the "Export Controlled Materials"). You will not, without our prior written approval, allow any of your employees or contractors to have access to or use of any Export Controlled Materials if such access or use would require an export license.

__11. OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses. We are not responsible for examining or evaluating, and we do not warrant the offerings of any of these businesses or individuals (including the content of their web sites). Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties. You should carefully review their privacy statements and other conditions of use.

__12. OUR LIABILITY__

The website and all information, content, materials, products (including any software) and services included on or otherwise made available to you through the website are provided by Amazon on an \u{201C}as is\u{201D} and \u{201C}as available\u{201D} basis, unless otherwise specified in the Service Terms or these Conditions of Use. Amazon makes no representations or warranties of any kind, express or implied, as to the operation of the website or the information, content, materials, products (including any software) or services included on or otherwise made available to you through the website, unless otherwise specified in the Service Terms or these Conditions of Use. You expressly agree that your use of the website is at your sole risk. To the full extent permissible by applicable law, Amazon disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. Amazon does not warrant that the website; information, content, materials, products (including any software) or services included on or otherwise made available to you through the website; its servers; or e-mail sent from Amazon are free of viruses or other harmful components. Amazon will not be liable for any damages of any kind arising from the use of the website or from any information, content, materials, products (including software) or services included on or otherwise made available to you through the website, including but not limited to direct, indirect, incidental, punitive, and consequential damages, unless otherwise specified in the Service Terms or these Conditions of Use. The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above disclaimers, exclusions, or limitations may not apply to you, and you might have additional rights.

__13. INDEMNITY AND RELEASE__

To the full extent permissible by law, you agree to indemnify and hold harmless Amazon Servi\xe7os de Varejo do Brasil Ltda., its subsidiaries, affiliates and their respective officers, directors, agents and employees, from any claim or demand, or actions including reasonable attorney's fees, made by any third party or penalty imposed due to or arising out of your breach of these Conditions of Use or your violation of any law, rules, regulations or the rights of a third party. To the full extent permissible by law, you hereby expressly release Amazon Servi\xe7os de Varejo do Brasil Ltda. and/or its affiliates and/or any of its officers and representatives from any cost, damage, liability or other consequence and specifically waiver any claims or demands that you may have in this behalf under any statute, contract or otherwise.

__14. EVENTS BEYOND REASONABLE CONTROL__

Amazon will not be held responsible for any delay or failure to comply with its obligations under these conditions if the delay or failure arises from any cause which is beyond its reasonable control. This condition does not affect your statutory rights.

__15. APPLICABLE LAW AND DISPUTES__

By using any Amazon Service you agree the laws of Brazil, without regard to the principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon.  The application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. 

Any and all disputes, controversies and claims arising out of, connected with, or relating in any way to your use of the Amazon Services, including its arbitrability (collectively, \u{201C}Disputes\u{201D} and each, a \u{201C}Dispute\u{201D}), must, at the written request of either party, be referred to and finally settled by binding arbitration (\u{201C}Arbitration\u{201D}) pursuant to the Rules of Arbitration of the International Chamber of Commerce (the \u{201C}ICC\u{201D}) (the \u{201C}ICC Rules\u{201D}). The Arbitration will be decided by a 3-member panel (the \u{201C}Tribunal\u{201D}) appointed in accordance with the ICC Rules. The seat of the Arbitration will be S\xe3o Paulo, Brazil. The language to be used in the Arbitration will be the English language; provided, however, that any party to the Arbitration may submit testimony or documentary evidence in a language other than English if such party provides the other party(ies) with advance written notice thereof and, upon request of the Tribunal or any other party to the Arbitration, furnishes a translation or interpretation into English of any such testimony or documentary evidence. Wherever the procedures of this Section and the ICC Rules are in conflict, the procedures of this Section will apply. The award rendered by the Tribunal (the \u{201C}Award\u{201D}) will be (a) in writing, in the English language, signed by the arbitrators, stating the reasons upon which the Award is based, (b) rendered as soon as practicable after conclusion of the Arbitration, and (c) final and binding upon the parties to the Arbitration. THE PARTIES HEREBY WAIVE ANY RIGHTS THAT THEY MAY HAVE TO BRING DISPUTES FOR RESOLUTION BEFORE ANY OTHER COURT, TRIBUNAL OR FORUM AND THEY AGREE NOT TO INITIATE ANY ACTIONS OR PROCEEDINGS FOR THE RESOLUTION OF DISPUTES IN ANY OTHER COURT, TRIBUNAL OR FORUM. Irrespective of which party prevails in the Arbitration, the Award will provide that: (a) claimant(s) and respondent(s) will each pay half of the fees and expenses of the arbitrators, the ICC administrative expenses fixed by the ICC, and the fees and expenses of any experts appointed by the Tribunal; and (b) each party will bear its own legal and other costs incurred in connection with the Arbitration. Notwithstanding the foregoing, the Tribunal may require such costs be borne in such other manner as the Tribunal determines is required in order for the arbitration clause to be enforceable under applicable law. Any Award will be final and binding upon the parties to the Arbitration and will not be subject to appeal, review or impingement by a court or other tribunal. The Parties agree that the arbitral decision or Award may be enforced against the Parties to the Arbitration or their assets wherever they may be found, and that, when needed, a judgment upon the Award may be entered in any court having jurisdiction thereof. If any party to the Arbitration proceeding fails or refuses to voluntarily comply with any arbitral decision or Award within 30 (thirty) days after the date on which it receives notice of the decision or Award, any other party may immediately take the necessary measures for the enforcement of such decision or Award, before a competent judge of the domicile of such refusing party or before any other court of competent jurisdiction. Further, if any prevailing party is required to retain counsel to enforce the arbitral decision or Award, the party against whom the decision or Award is made will reimburse the prevailing party for all reasonable fees and expenses incurred and paid to said counsel for such service. Without prejudice to the validity of this arbitration clause, the parties elect the venue of the judicial district of S\xe3o Paulo, State of S\xe3o Paulo, Brazil, and expressly waive any other, when and if necessary for the exclusive purpose of: (a) enforcing obligations for which judicial enforcement is immediately available; (b) obtaining orders for specific performance or injunctive relief of a preventive, temporary, or permanent nature, and/or to ensure the existence and effectiveness of the arbitration proceeding; and/or (c) processing a request for specific performance or other order, it being agreed that, once the specific performance or order has been obtained, the Tribunal to be formed or already formed, as applicable, will regain full and exclusive jurisdiction to decide on any and all issues, whether relating to procedure or merit, that may have led to the request for the order or specific performance, and the respective judicial proceeding will be adjourned until a partial or final decision is rendered by the Tribunal on the issue. The processing of any legal action according to this clause will not result in any waiver of arbitration or of the jurisdiction of the Tribunal. The parties are not barred from applying to any competent judicial authority for interim, or conservatory or enforcement measures, including the granting of a temporary restraining order or other temporary or preliminary relief, when the granting of such measures is essential to assure the applicant of the enforcement of any rights which have been granted to it by virtue of these Conditions of Use or of the Award. The application of a party to a judicial authority for such measures or for the implementation of any such measures ordered by the Tribunal is not inconsistent with the election of an arbitration tribunal and will not be deemed to be an infringement or a waiver of the arbitration agreement and will not affect the relevant powers reserved to the Tribunal. All judicial measures shall be decided by the Courts of S\xe3o Paulo, State of S\xe3o Paulo, Brazil.

__16. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE__

We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.

__17. WAIVER__

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

__18. OUR CONTACT DETAILS__

This website is owned and maintained by Amazon Servi\xe7os de Varejo do Brasil Ltda.

Avenida Presidente Juscelino Kubitschek, 2041- Torre E - 18\xba Andar - S\xe3o Paulo/SP, CEP 04543-011

__19. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been infringed, please submit your complaint using our online Report Infringement Notice Form. This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims. 

Upon receipt of a complaint, we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint.

__Important Warning:__ giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions. 

__ADDITIONAL AMAZON SOFTWARE TERMS__

1. __Use of the Amazon Software.__ You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by the Conditions of Use, these Software Terms and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, or assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by Brazilian and international copyright laws. 
2. __Use of Third Party Services.__ When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties. 
3. __No Reverse Engineering.__ Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorize any other person to copy, modify, reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software. 
4. __Updates.__ In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you. 
5. __Conflicts.__\xa0In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict.

  `
};
const inConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
  Welcome to the Amazon Carrier Logistics India website.

Amazon Transportation Services Private Limited and/or its affiliates ("__Amazon", \u{201C}us\u{201D}, \u{201C}we\u{201D} or \u{201C}our\u{201D}__) provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the "__website__"), use Amazon products or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "__Amazon Services__"). Please see our [Privacy Notice](/privacy-notice) and our [Cookies Notice](https://www.amazon.in/gp/help/customer/display.html?ref_=hp_left_v4_sib&nodeId=G201890250) to understand how we collect and process your personal information through Amazon Services. Amazon provides Amazon Services subject to the Conditions of Use set out on this page.   Amazon Carrier Logistics the trading name for Amazon.

__Conditions of Use__

__Please read these Conditions of Use carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these Conditions of Use.__ We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("__Service Terms__"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.

__1. ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service or send e-mails, text messages or other communications from any device] to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communication be in writing, unless mandatory applicable laws specifically require a different form of communication.

__2. RECOMMENDATIONS AND PERSONALISATION__

As part of the Amazon Services, we may recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalize your experience.

__3. COPYRIGHT, AUTHORS' RIGHTS AND DATABASE RIGHTS__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by applicable copyright laws in India and international copyright, authors' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by applicable copyright laws in India and international copyright and database right laws.

You may not extract and/or re-utilize parts of the content of any Amazon Service without our express written consent. In particular, you may not utilize any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilization any parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.

__4. TRADEMARKS__

 [Read here](https://www.amazon.com/gp/help/customer/display.html/?nodeId=200738910)  to see a non-exhaustive list of Amazon trademarks. These and other trademarks that appear in any Amazon Service are trademarks of Amazon and may be registered in India or in certain other countries. In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

__5. LICENSE AND ACCESS__

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any, product listings, descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's names or trademarks without our express written consent.

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__6. YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account.

If you use any Amazon Service, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorized manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. Please see our  [Privacy Notice ](https://www.amazon.in/gp/help/customer/display.html?nodeId=200534380&ref_=footer_privacy) Page to access your personal information.] 

You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance or inconvenience.

We reserve the right to refuse any Amazon Services, terminate accounts, terminate your rights to use any Amazon Service, remove or edit content at our sole discretion. This will in particular be the case if we have reason to believe that you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are made available to you from time to time or accessible on the website, or have conducted an unlawful, abusive, or otherwise inappropriate act. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.

__7. REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT__

Where the functionality exists to do so, visitors may post reviews, comments and other content; send communications; and submit suggestions, ideas, comments, questions or other information, as long as the content is not illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of "spam". You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but do not, in the absence of a valid Report [Infringement](https://www.amazon.com/report/infringement) Form , assume the obligation) to remove or edit such content. If you believe that any content on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate Report [Infringement](https://www.amazon.com/report/infringement) Form and we will respond.

If you post reviews, comments, questions or answers, or other content generated by you for display on the website (including any images, video or audio, all together "content"), you grant Amazon (a) a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable license and right to use, reproduce, publish, make available, translate, adapt, publish, translate, create derivative works from, distribute, display and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.

You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as of the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content ( Report [Infringement](https://www.amazon.com/report/infringement) Form ) arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly. 

__8. AMAZON SOFTWARE TERMS__

In addition to these Conditions of Use, the terms found under Additional Amazon Software Terms apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the "Amazon Software").

__9. APP PERMISSIONS__

When you use apps or websites created or owned by Amazon, you may grant certain permissions to us for your device. Most mobile devices provide you with information about these permissions.

__10. SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are subject to sanctions or otherwise designated on any list of prohibited or restricted parties or owned or controlled by such a party, including but not limited to the lists maintained by the United States, United Nations Security Council, the European Union or its member states, or by any government authority in the country where you are using Amazon Services. In connection with the Service Terms and these Conditions of Use, you will comply with all applicable import, re-import, sanctions, anti-boycott, export, and re-export control laws, such as the Export Administration Regulations, the International Traffic in Arms Regulations, and economic sanctions programs administered by the Office of Foreign Assets Control. You understand that some of the software, technology or related information that you and your employees or contractors may have access to may be subject to export control laws and regulations (the "Export Controlled Materials"). You will not, without our prior written approval, allow any of your employees or contractors to have access to or use of any Export Controlled Materials if such access or use would require an export license.

__11. OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses. We are not responsible for examining or evaluating, and we do not warrant the offerings of any of these businesses or individuals (including the content of their web sites). Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties. You should carefully review their privacy statements and other conditions of use.

__12. OUR LIABILITY__

The website and all information, content, materials, products (including any software) and services included on or otherwise made available to you through the website are provided by Amazon on an \u{201C}as is\u{201D} and \u{201C}as available\u{201D} basis, unless otherwise specified in the Service Terms or these Conditions of Use. Amazon makes no representations or warranties of any kind, express or implied, as to the operation of the website or the information, content, materials, products (including any software) or services included on or otherwise made available to you through the website, unless otherwise specified in the Service Terms or these Conditions of Use. You expressly agree that your use of the website is at your sole risk. To the full extent permissible by applicable law, Amazon disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. Amazon does not warrant that the website; information, content, materials, products (including any software) or services included on or otherwise made available to you through the website; its servers; or e-mail sent from Amazon are free of viruses or other harmful components. Amazon will not be liable for any damages of any kind arising from the use of the website or from any information, content, materials, products (including software) or services included on or otherwise made available to you through the website, including but not limited to direct, indirect, incidental, punitive, and consequential damages, unless otherwise specified in the Service Terms or these Conditions of Use. The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above disclaimers, exclusions, or limitations may not apply to you, and you might have additional rights.

__13. INDEMNITY AND RELEASE__

To the full extent permissible by law, you agree to indemnify and hold harmless Amazon Transportation Services Private Limited, its subsidiaries, affiliates and their respective officers, directors, agents and employees, from any claim or demand, or actions including reasonable attorney's fees, made by any third party or penalty imposed due to or arising out of your breach of these Conditions of Use or your violation of any law, rules, regulations or the rights of a third party. To the full extent permissible by law, you hereby expressly release Amazon Transportation Services Private Limited and/or its affiliates and/or any of its officers and representatives from any cost, damage, liability or other consequence and specifically waiver any claims or demands that you may have in this behalf under any statute, contract or otherwise.

__14. EVENTS BEYOND REASONABLE CONTROL__

Amazon will not be held responsible for any delay or failure to comply with its obligations under these conditions if the delay or failure arises from any cause which is beyond its reasonable control. This condition does not affect your statutory rights

__15. APPLICABLE LAW AND DISPUTES__

These Conditions of Use are governed by and construed in accordance with the laws of India. You agree, as we do, to submit to the exclusive jurisdiction of the courts at Bangalore. 

Any dispute or claim relating in any way to your use of the website if not resolved within 45 (forty five) will be resolved by binding arbitration, rather than in court. All disputes to be adjudicated by an arbitrator to be appointed by Amazon. The Indian Arbitration and Conciliation Act, 1996 (as may be in force from time to time) thereunder shall apply to these conditions.  
  
To begin an arbitration proceeding, you must send a letter requesting arbitration and describing your claim to Amazon at its address as mentioned in this Condition of Use. It is hereby clarified that, demand for arbitration under this Conditions of Use must be made in writing, must describe the demanding party\u{2019}s claim, and must be delivered to the other party by hand or by speed post.

The arbitration proceedings shall be conducted in English and the venue of the arbitration shall be Bangalore, India. The arbitral proceedings will be conducted in accordance with the fast-track procedure specified under the Arbitration and Conciliation Act, 1996. 

__You and Amazon each agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, collective, consolidated or representative action__. 

You and Amazon also both agree that you or Amazon may bring suit in court to enjoin infringement or other misuse of intellectual property rights.

__16. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE__

We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.

__17. WAIVER__

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

__18. GRIEVANCE REDRESSAL AND OUR CONTACT DETAILS__

This website is owned and maintained by Amazon Transportation Services Private Limited. If You have any questions, any grievance or queries regarding these Terms or the Amazon Services, please contact Us at carrierlogistics-support@amazon.com. 

__19. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been infringed, please submit your complaint using our online Report Infringement Notice Form. This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims. 

Upon receipt of a complaint, we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint.

__Important Warning:__ giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions. 

__ADDITIONAL AMAZON SOFTWARE TERMS__

1. __Use of the Amazon Software.__ You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by the Conditions of Use, these Software Terms and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, or assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by applicable laws in India  and international copyright laws. 
2. __Use of Third Party Services.__ When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties. 
3. __No Reverse Engineering.__ Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorize any other person to copy, modify, reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software. 
4. __Updates.__ In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you. 
5. __Conflicts.__\xa0In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict.

`
};
const mxConditionsOfUse = {
    [(0, _common.LOCALES_MAP).EN_US]: `
  Welcome to the Carrier Logistics Mexico website.

Servicios Comerciales Amazon M\xe9xico, S. de R.L. de C.V. and/or its affiliates ("Amazon", \u{201C}us\u{201D}, \u{201C}we\u{201D} or \u{201C}our\u{201D}), located at Blvd. Manuel \xc1vila Camacho 261, piso 5, Polanco I Secc, Miguel Hidalgo, 11510, Ciudad de M\xe9xico,  provide website features and other products and services to you when you visit carrierlogistics.amazon.com (the \u{201C}website\u{201D}), use Amazon products or services, use Amazon applications for mobile, or use software provided by Amazon in connection with any of the foregoing (collectively "Amazon Services"). Please see our [Privacy Notice](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy) and our [Cookies Notice](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=202056980) to understand how we collect and process your personal information through Amazon Services. Amazon provides Amazon Services subject to the Conditions of Use set out on this page.  

__Conditions of Use__

__Please read these Conditions of Use carefully before using Amazon Services. By using Amazon Services, you signify your agreement to be bound by these Conditions of Use.__ We offer a wide range of Amazon Services, and sometimes additional terms may apply. When you use an Amazon Service you will also be subject to the terms, guidelines and conditions applicable to that Amazon Service ("Service Terms"). If these Conditions of Use are inconsistent with the Service Terms, those Service Terms will control.

__1. ELECTRONIC COMMUNICATIONS__

When you use any Amazon Service or send e-mails, text messages or other communications from any device to us, you are communicating with us electronically. We will communicate with you electronically in a variety of ways, such as by e-mail, text, in-app push notices or by posting e-mail messages or communications on the website or through the other Amazon Services. For contractual purposes, you agree that all agreements, notices, disclosures and other communications that we provide you electronically satisfy any legal requirement that such communication be in writing, unless mandatory applicable laws specifically require a different form of communication.

__2. RECOMMENDATIONS AND PERSONALISATION__

As part of the Amazon Services, we may recommend features, products, and services, including third party ads that might be of interest to you, identify your preferences, and personalize your experience.

__3. COPYRIGHT, AUTHORS' RIGHTS AND DATABASE RIGHTS__

All content included in or made available through any Amazon Service, such as text, graphics, logos, button icons, images, audio clips, digital downloads and data compilations is the property of Amazon or its content suppliers and is protected by Mexican and international copyright, authors' rights and database right laws. The compilation of all content included in or made available through any Amazon Service is the exclusive property of Amazon and is protected by Mexican and international copyright and database right laws.

You may not extract and/or re-utilize parts of the content of any Amazon Service without our express written consent. In particular, you may not utilize any data mining, robots, or similar data gathering and extraction tools to extract (whether once or many times) for re-utilization any parts of the content of any Amazon Service, without our express written consent. You may also not create and/or publish your own database that features substantial parts of any Amazon Service (e.g. our prices) without our express written consent.

__4. TRADEMARKS__

[Click here](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=201909280) to see a non-exhaustive list of Amazon trademarks. These and other trademarks that appear in any Amazon Service are trademarks of Amazon and may be registered in Mexico or in certain other countries. In addition, graphics, logos, page headers, button icons, scripts, and service names included in or made available through any Amazon Service are trademarks or trade dress of Amazon. Amazon's trademarks and trade dress may not be used in connection with any product or service that is not Amazon's, in any manner that is likely to cause confusion among customers or in any manner that disparages or discredits Amazon. All other trademarks not owned by Amazon that appear in any Amazon Service are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by Amazon.

__5. LICENSE AND ACCESS__

Subject to your compliance with these Conditions of Use and applicable Service Terms and your payment of any applicable fees, Amazon or its content providers grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and make use of the Amazon Services. This license does not include any resale or commercial use of any Amazon Service or its contents; any collection and use of any, product listings, descriptions or prices; any derivative use of any Amazon Service or its contents; any downloading or copying of account information for the benefit of another merchant; or any use of data mining, robots, or similar data gathering and extraction tools.

All rights not expressly granted to you in these Conditions of Use or any Service Terms are reserved and retained by Amazon or its licensors, suppliers, publishers, rights holders, or other content providers. No Amazon Service, nor any part of any Amazon Service, may be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without our express written consent. You may not frame or use framing techniques to enclose any trademark, logo or other proprietary information (including images, text, page layout, or form) of Amazon without our express written consent. You may not use any meta tags or any other "hidden text" utilizing Amazon's names or trademarks without our express written consent.

You may not misuse the Amazon Services. You may use the Amazon Services only as permitted by law. The licenses granted by Amazon terminate if you do not comply with these Conditions of Use or any Service Terms.

__6. YOUR ACCOUNT__

You may need your own Amazon account to use certain Amazon Services, and you may be required to be logged into the account and have a valid payment method associated with it.

<a id="_Hlk112947971"></a>If there is a problem charging your selected payment method, we may charge any other valid payment method associated with your account. 

If you use any Amazon Service, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and to the extent permitted by applicable law you agree to accept responsibility for all activities that occur under your account or password. You should take all necessary steps to ensure that the password is kept confidential and secure and should inform us immediately if you have any reason to believe that your password has become known to anyone else, or if the password is being, or is likely to be used in an unauthorized manner. You are responsible for ensuring that the details you provide us with are correct and complete, and for informing us of any changes to the information you have provided. Please see our Protecting Your Privacy [Help Page](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy) to access your personal information.

You must not use any Amazon Service: (i) in any way that causes, or is likely to cause, any Amazon Service, or any access to it to be interrupted, damaged or impaired in any way, or (ii) for fraudulent purposes, or in connection with a criminal offence or other unlawful activity, or (iii) to cause annoyance or inconvenience.

We reserve the right to refuse any Amazon Services, terminate accounts, terminate your rights to use any Amazon Service, remove or edit content at our sole discretion. This will in particular be the case if we have reason to believe that you are in breach of applicable laws, applicable contractual provisions, our guidelines or our policies, which are made available to you from time to time or accessible on the website, or have conducted an unlawful, abusive, or otherwise inappropriate act. Notwithstanding any such limitation or termination, you will continue to have access to content and services purchased by you up to that point.]

__7.REVIEWS, COMMENTS, COMMUNICATIONS AND OTHER CONTENT__

Where the functionality exists to do so, visitors may post reviews, comments and other content; send communications; and submit suggestions, ideas, comments, questions or other information, as long as the content is not illegal, obscene, abusive, threatening, defamatory, invasive of privacy, infringing of intellectual property rights, or otherwise injurious to third parties or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of \u{201C}spam\u{201D}. You may not use a false e-mail address, impersonate any person or entity, or otherwise mislead as to the origin of a card or other content. We reserve the right (but do not, in the absence of a valid [Report Infringement Notice Form](https://www.amazon.com.mx/report/infringement/signin), assume the obligation) to remove or edit such content. If you believe that any content on any Amazon Service contains a defamatory statement, or that your intellectual property rights are being infringed by an item or information on any Amazon Service, please notify us by completing and submitting the appropriate [Report Infringement Notice Form](https://www.amazon.com.mx/report/infringement/signin) and we will respond.

If you post reviews, comments, questions or answers, or other content generated by you for display on the website (including any images, video or audio, all together \u{201C}content\u{201D}), you grant Amazon (a) a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable license and right to use, reproduce, publish, make available, translate, adapt, publish, translate, create derivative works from, distribute, display and modify such content throughout the world (including the right to sublicense these rights to third parties) and (b) the right to use the name that you submit in connection with such content. No moral rights are transferred by this provision.

You may delete your content from public view or, where such functionality is offered, change settings so that it is only shown to people to whom you grant access.

You represent and warrant that you own or otherwise control all of the rights to the content that you post; that, as of the date that the content or material is posted: (i) the content and material is accurate; and (ii) use of the content and material you supply does not breach any applicable policies or guidelines and will not cause injury to any person or entity (including that the content or material is not defamatory). You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the content and material you supply except to the extent that any liability arises from our failure to properly remove the content when it is notified of the illegal nature of the content (Notice of Defamatory Content Form) arising out of or on the grounds of, or originating from the content that you have communicated to us. By deleting content from public view, you withdraw your license for Amazon to publish and make available that content publicly.] 

__8. AMAZON SOFTWARE TERMS__

In addition to these Conditions of Use, the terms found under Additional Amazon Software Terms apply to any software (including any updates or upgrades to the software and any related documentation) that we make available to you from time to time for your use in connection with Amazon Services (the \u{201C}Amazon Software\u{201D}).

__9. APP PERMISSIONS__

When you use apps created by Amazon, you may grant certain permissions to us for your device. Most mobile devices provide you with information about these permissions.

__10. SANCTIONS AND EXPORT POLICY__

You may not use any Amazon Service if you are subject to sanctions or otherwise designated on any list of prohibited or restricted parties or owned or controlled by such a party, including but not limited to the lists maintained by the United States, United Nations Security Council, the European Union or its member states, or by any government authority in the country where you are using Amazon Services. In connection with the Service Terms and these Conditions of Use, you will comply with all applicable import, re-import, sanctions, anti-boycott, export, and re-export control laws, such as the Export Administration Regulations, the International Traffic in Arms Regulations, and economic sanctions programs administered by the Office of Foreign Assets Control. You understand that some of the software, technology or related information that you and your employees or contractors may have access to may be subject to export control laws and regulations (the \u{201C}Export Controlled Materials\u{201D}). You will not, without our prior written approval, allow any of your employees or contractors to have access to or use of any Export Controlled Materials if such access or use would require an export license.

__11. OTHER BUSINESSES__

We may provide links to the sites of affiliated companies and certain other businesses. We are not responsible for examining or evaluating, and we do not warrant the offerings of any of these businesses or individuals (including the content of their web sites). Amazon does not assume any responsibility or liability for the actions, product, and content of all these and any other third parties. You should carefully review their privacy statements and other conditions of use.

__12. OUR LIABILITY__

The website and all information, content, materials, products (including any software) and services included on or otherwise made available to you through the website are provided by Amazon on an \u{201C}as is\u{201D} and \u{201C}as available\u{201D} basis, unless otherwise specified in the Service Terms or these Conditions of Use. Amazon makes no representations or warranties of any kind, express or implied, as to the operation of the website or the information, content, materials, products (including any software) or services included on or otherwise made available to you through the website, unless otherwise specified in the Service Terms or these Conditions of Use. You expressly agree that your use of the website is at your sole risk. To the full extent permissible by applicable law, Amazon disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. Amazon does not warrant that the website; information, content, materials, products (including any software) or services included on or otherwise made available to you through the website; its servers; or e-mail sent from Amazon are free of viruses or other harmful components. Amazon will not be liable for any damages of any kind arising from the use of the website or from any information, content, materials, products (including software) or services included on or otherwise made available to you through the website, including but not limited to direct, indirect, incidental, punitive, and consequential damages, unless otherwise specified in the Service Terms or these Conditions of Use. The laws of some countries do not allow some or all of the limitations described above. If these laws apply to you, some or all of the above disclaimers, exclusions, or limitations may not apply to you, and you might have additional rights.

__13. INDEMNITY AND RELEASE__

To the full extent permissible by law, you agree to indemnify and hold harmless Amazon its subsidiaries, affiliates and their respective officers, directors, agents and employees, from any claim or demand, or actions including reasonable attorney\u{2019}s fees, made by any third party or penalty imposed due to or arising out of your breach of these Conditions of Use or your violation of any law, rules, regulations or the rights of a third party. To the full extent permissible by law, you hereby expressly release Amazon and/or its affiliates and/or any of its officers and representatives from any cost, damage, liability or other consequence and specifically waiver any claims or demands that you may have in this behalf under any statute, contract or otherwise.

__14. EVENTS BEYOND REASONABLE CONTROL__

Amazon will not be held responsible for any delay or failure to comply with its obligations under these conditions if the delay or failure arises from any cause which is beyond its reasonable control. This condition does not affect your statutory rights.

__15. APPLICABLE LAW AND DISPUTES__

By using any Amazon Service you agree the laws of Mexico, without regard to the principles of conflict of laws, will govern these Conditions of Use and any dispute of any sort that might arise between you and Amazon.  The application of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. 

 

__Any dispute or claim arising out of or relating in any way to your use of the Amazon Services will be resolved by binding arbitration, rather than in court__, pursuant to the Rules of Arbitration of the International Chamber of Commerce (the \u{201C}ICC\u{201D}) in effect on the Effective Date (the \u{201C}ICC Rules\u{201D}), by three arbitrators appointed in accordance with the said ICC Rules. The place of arbitration shall be Mexico City, the language of the arbitration shall be English. Each party submits to the laws of Mexico and to the jurisdiction and venue of the state or federal courts located in Mexico City, Mexico, for purposes of permitted applications of injunctive or other provisional relief, and for any litigation ancillary to arbitration, including without limitation, litigation or to compel arbitration or enforce an arbitral award.

__You and Amazon each agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, collective, consolidated or representative action__. You and Amazon also both agree that you or Amazon may bring suit in court to enjoin infringement or other misuse of intellectual property rights.

__16. ALTERATIONS TO SERVICE OR AMENDMENTS TO THE CONDITIONS OF USE__

We reserve the right to make changes to any Amazon Services, policies, terms and conditions including these Conditions of Use, and Service Terms at any time. You will be subject to the terms and conditions, policies and Conditions of Use in force at the time that you use the Amazon Services. If any of these Conditions of Use is deemed invalid, void, or for any reason unenforceable, that condition will be deemed severable and will not affect the validity and enforceability of any remaining condition.]

__17. WAIVER__

If you breach these Conditions of Use and we take no action, we will still be entitled to use our rights and remedies in any other situation where you breach these Conditions of Use.

__18. OUR CONTACT DETAILS__

This website is owned and maintained by Amazon You may provide notices to us regarding the use of the Amazon Services by pre-paid post requiring signature on receipt or personal delivery to our address or e-mail, as communicated between the parties when you use the Amazon Services and pursuant to the terms set forth in Section 1 of this Conditions of Use. Notices to Amazon will be effective when received by us.

__19. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF RIGHT INFRINGEMENTS__

Amazon respects the intellectual property of others. If you believe that your intellectual property rights have been infringed, please submit your complaint using our online Report Infringement Notice Form. This form may be used to report all types of intellectual property claims including, but not limited to, copyright, trademark, design and patent claims. 

Upon receipt of a complaint, we may take certain actions, including removing information or an item, and termination of repeat infringers in appropriate circumstances. All such actions are taken without any admission as to liability and without prejudice to any rights, remedies or defenses, all of which are expressly reserved. This includes forwarding the complaint to the parties involved in the provision of the allegedly infringing content. You agree to indemnify Amazon for all claims brought by a third party against Amazon arising out of or in connection with the submission of a complaint arising out of your conduct or content.

__Important Warning:__ giving false, misleading or inaccurate information in the Notice Form to Amazon may result in civil and/or criminal liability. You should contact a legal advisor should you have any questions. 

__ADDITIONAL AMAZON SOFTWARE TERMS__

1. __Use of the Amazon Software.__ You may use Amazon Software solely for purposes of enabling you to use and enjoy the Amazon Services as provided by Amazon, and as permitted by the Conditions of Use, these Software Terms and any Service Terms. You may not incorporate any portion of the Amazon Software into your own programs or compile any portion of it in combination with your own programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license the Amazon Software or otherwise copy (except to exercise rights granted in this section), modify, create derivative works of, or assign any rights to the Amazon Software in whole or in part. You may not use the Amazon Software for any illegal purpose. We may cease providing any Amazon Software and we may terminate your right to use any Amazon Software at any time. Your rights to use the Amazon Software will automatically terminate without notice from us if you fail to comply with any of these Software Terms, the Conditions of Use or any other Service Terms. Additional third party terms contained within or distributed with certain Amazon Software that are specifically identified in related documentation may apply to that Amazon Software (or software incorporated with the Amazon Software) and will govern the use of such software in the event of a conflict with these Conditions of Use. All software used in any Amazon Service is the property of Amazon or its software suppliers and protected by Mexican and international copyright laws. 
2. __Use of Third Party Services.__ When you use the Amazon Software, you may also be using the services of one or more third parties, such as a wireless carrier or a mobile platform provider. Your use of these third party services may be subject to the separate policies, terms of use, and fees of these third parties. 
3. __No Reverse Engineering.__ Unless explicitly permitted under applicable mandatory law, you may not, and you will not encourage, assist or authorize any other person to copy, modify, reverse engineer, decompile or disassemble, tamper with, or bypass any security associated with the Amazon Software, whether in whole or in part, or create any derivative works from or of the Amazon Software. 
4. __Updates.__ In order to keep the Amazon Software up-to-date, we may offer automatic or manual updates at any time and without notice to you. 
5. __Conflicts.__\xa0In the event of any conflict between these Conditions of Use and any other Amazon or third-party terms applicable to any portion of Amazon Software, such as open-source license terms, such other terms will control as to that portion of the Amazon Software and to the extent of the conflict.

`,
    [(0, _common.LOCALES_MAP).ES_ES]: `
  Bienvenido a la p\xe1gina web de Carrier Logistics M\xe9xico.

 Servicios Comerciales Amazon M\xe9xico, S. de R.L. de C.V. y/o sus filiales (\u{201C}Amazon\u{201D}, \u{201C}nosotros\u{201D}, \u{201C}nos\u{201D} o \u{201C}nuestro/a/s\u{201D}) ubicados en Blvd. Manuel \xc1vila Camacho 261, piso 5, Polanco I Secc, Miguel Hidalgo, 11510, Ciudad de M\xe9xico, le proporcionan funciones de la p\xe1gina web y otros productos y servicios cuando visita carrierlogistics.amazon.com (la \u{201C}p\xe1gina web\u{201D}), utiliza productos o servicios de Amazon, utiliza aplicaciones de Amazon para tel\xe9fonos celulares o utiliza software proporcionado por Amazon en relaci\xf3n con cualquiera de los anteriores (conjuntamente \u{201C}Servicios de Amazon\u{201D}). Por favor, consulte nuestro [Aviso de Privacidad](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy) y nuestro [Aviso de Cookies](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=202056980) para entender c\xf3mo recogemos y tratamos su informaci\xf3n personal a trav\xe9s de los Servicios de Amazon. Amazon presta los Servicios de Amazon con sujeci\xf3n a las Condiciones de Uso establecidas en la presente p\xe1gina. 

__Condiciones de Uso__

__Lea atentamente las presentes Condiciones de Uso antes de utilizar los Servicios de Amazon. Al utilizar los Servicios de Amazon, usted acepta quedar vinculado por las presentes Condiciones de Uso.__ Ofrecemos una amplia gama de Servicios de Amazon y, en ocasiones, pueden aplicarse condiciones adicionales. Cuando utilice un Servicio Amazon tambi\xe9n estar\xe1 sujeto a los t\xe9rminos, directrices y condiciones aplicables a dicho Servicio Amazon (Condiciones de Servicio\u{201D}). Si las presentes Condiciones de Uso son incompatibles con las Condiciones de Servicio, prevalecer\xe1n dichas Condiciones de Servicio.

__1. COMUNICACIONES ELECTR\xd3NICAS__

Cuando utilice cualquier Servicio de Amazon o nos env\xede correos electr\xf3nicos, mensajes de texto u otras comunicaciones desde cualquier dispositivo, se estar\xe1 comunicando con nosotros electr\xf3nicamente. Nos comunicaremos con usted electr\xf3nicamente de diversas formas, como por correo electr\xf3nico, mensajes de texto, notificaciones *push* dentro de la aplicaci\xf3n o mediante la publicaci\xf3n de mensajes de correo electr\xf3nico o comunicaciones en la p\xe1gina web o a trav\xe9s de los dem\xe1s Servicios de Amazon. Para efectos contractuales, usted acepta que todos los acuerdos, avisos, divulgaciones y otras comunicaciones que le proporcionemos electr\xf3nicamente satisfacen cualquier requisito legal que exija que dicha comunicaci\xf3n se realice por escrito, a menos que las leyes aplicables obligatorias exijan espec\xedficamente una forma diferente de comunicaci\xf3n.

__2. RECOMENDACIONES Y PERSONALIZACI\xd3N__

Como parte de los Servicios de Amazon, podemos recomendarle funciones, productos y servicios, incluidos anuncios de terceros que puedan ser de su inter\xe9s, identificar sus preferencias y personalizar su experiencia.

__3. DERECHOS DE AUTOR Y DERECHOS DE BASES DE DATOS__

Todo el contenido incluido o puesto a disposici\xf3n a trav\xe9s de cualquier Servicio de Amazon, tales como textos, gr\xe1ficos, logotipos, iconos de botones, im\xe1genes, clips de audio, descargas digitales y compilaciones de datos, son propiedad de Amazon o de sus proveedores de contenidos y est\xe1n protegidos por las leyes mexicanas y por las leyes internacionales sobre propiedad intelectual, derechos de autor y derechos sobre bases de datos. La compilaci\xf3n de todo el contenido incluido o puesto a disposici\xf3n a trav\xe9s de cualquier Servicio de Amazon es propiedad exclusiva de Amazon y est\xe1 protegida por las leyes mexicanas y las leyes internacionales sobre derechos de autor y derechos sobre bases de datos.

No podr\xe1 extraer y/o reutilizar partes del contenido de cualquier Servicio de Amazon sin nuestro consentimiento expreso por escrito. En particular, no podr\xe1 utilizar herramientas de extracci\xf3n de datos, robots o herramientas similares de recopilaci\xf3n y extracci\xf3n de datos para extraer (una o varias veces) partes del contenido de cualquier Servicio de Amazon para su reutilizaci\xf3n sin nuestro consentimiento expreso por escrito. Tampoco podr\xe1 crear y/o publicar su propia base de datos que contenga partes sustanciales de cualquier Servicio de Amazon (por ejemplo, nuestros precios) sin nuestro consentimiento expreso por escrito.

__4. MARCAS__

Haga [clic aqu\xed](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=201909280) para ver una lista no exhaustiva de las marcas comerciales de Amazon. Estas y otras marcas comerciales que aparecen en cualquier Servicio de Amazon son marcas comerciales de Amazon y pueden estar registradas en M\xe9xico o en algunos otros pa\xedses. Adem\xe1s, los gr\xe1ficos, logotipos, encabezados de p\xe1gina, iconos de botones, scripts y nombres de servicios incluidos o puestos a disposici\xf3n a trav\xe9s de cualquier Servicio de Amazon son marcas comerciales o im\xe1genes de marca de Amazon. Las marcas registradas y la imagen comercial de Amazon no podr\xe1n utilizarse en relaci\xf3n con ning\xfan producto o servicio que no sea de Amazon, de ninguna manera que pueda causar confusi\xf3n entre los clientes o de ninguna manera que menosprecie o desacredite a Amazon. Todas las dem\xe1s marcas comerciales que no sean propiedad de Amazon y que aparezcan en cualquier Servicio de Amazon son propiedad de sus respectivos propietarios, que pueden o no estar afiliados, conectados o patrocinados por Amazon.

__5. LICENCIA Y ACCESO__

Sujeto al cumplimiento por su parte de las presentes Condiciones de Uso y de las Condiciones de Servicio aplicables y al pago por su parte de las tarifas aplicables, Amazon o sus proveedores de contenidos le conceden una licencia limitada, no exclusiva, intransferible y no sublicenciable para acceder a los Servicios de Amazon y hacer uso de los mismos. La presente licencia no incluye la reventa o el uso comercial de los Servicios de Amazon o de su contenido; la recopilaci\xf3n y el uso de listados de productos, descripciones o precios; el uso derivado de los Servicios de Amazon o de su contenido; la descarga o copia de informaci\xf3n de cuenta en beneficio de otro comerciante; ni el uso de herramientas de extracci\xf3n de datos, robots o herramientas similares de recopilaci\xf3n y extracci\xf3n de datos.

Todos los derechos que no le sean expresamente concedidos en las presentes Condiciones de Uso o en cualesquiera Condiciones de Servicio quedan reservados y retenidos por Amazon o sus licenciantes, proveedores, editores, titulares de derechos u otros proveedores de contenidos. Ning\xfan Servicio de Amazon, ni ninguna parte de cualquier Servicio de Amazon, podr\xe1 reproducirse, duplicarse, copiarse, venderse, revenderse, visitarse o explotarse de cualquier otro modo con fines comerciales sin nuestro consentimiento expreso por escrito. No podr\xe1 enmarcar o utilizar t\xe9cnicas de enmarcado para adjuntar cualquier marca comercial, logotipo u otra informaci\xf3n de propiedad (incluyendo im\xe1genes, texto, dise\xf1o de p\xe1gina o forma) de Amazon sin nuestro consentimiento expreso por escrito. No podr\xe1 utilizar metaetiquetas ni ning\xfan otro \u{201C}texto oculto" utilizando los nombres o marca\u{201C} comerciales de Amazon sin nuestro consentimiento expreso por escrito.

No podr\xe1 hacer un uso indebido de los Servicios de Amazon. S\xf3lo podr\xe1 utilizar los Servicios de Amazon en la medida en que lo permita la ley. Las licencias concedidas por Amazon se extinguir\xe1n si usted incumple las presentes Condiciones de Uso o cualquiera de las Condiciones de Servicio.

__6. SU CUENTA__

Es posible que necesite su propia cuenta de Amazon para utilizar determinados Servicios de Amazon, y es posible que se le solicite que inicie sesi\xf3n en la cuenta y que tenga asociada una forma de pago v\xe1lida.

Si hay alg\xfan problema con el cobro a trav\xe9s de la forma de pago seleccionada, podemos cobrar a trav\xe9s de cualquier otra forma de pago v\xe1lida asociada a su cuenta. 

Si utiliza cualquier Servicio de Amazon, usted es responsable de mantener la confidencialidad de su cuenta y contrase\xf1a y de restringir el acceso a su computadora y, en la medida en que lo permita la legislaci\xf3n aplicable, acepta la responsabilidad de todas las actividades que se produzcan bajo su cuenta o contrase\xf1a. Deber\xe1 tomar todas las medidas necesarias para garantizar la confidencialidad y seguridad de la contrase\xf1a e informarnos inmediatamente si tiene motivos para creer que su contrase\xf1a ha llegado a conocimiento de otra persona, o si la contrase\xf1a se est\xe1 utilizando, o es probable que se utilice, de forma no autorizada. Usted es responsable de asegurarse de que los datos que nos proporciona son correctos y completos, y de informarnos de cualquier cambio en la informaci\xf3n que nos ha proporcionado. Consulte nuestra p\xe1gina de ayuda denominada [Protecci\xf3n de su Privacidad](https://www.amazon.com.mx/gp/help/customer/display.html?nodeId=468496&ref_=footer_privacy) para acceder a su informaci\xf3n personal. 

No deber\xe1 utilizar ning\xfan Servicio de Amazon: (i) de forma que cause o pueda causar la interrupci\xf3n, el da\xf1o o el menoscabo de cualquier Servicio de Amazon o del acceso al mismo, o (ii) con fines fraudulentos o en relaci\xf3n con un delito penal u otra actividad ilegal, o (iii) para causar molestias o inconvenientes.

Nos reservamos el derecho a denegar cualquier Servicio de Amazon, cancelar cuentas, cancelar sus derechos a utilizar cualquier Servicio de Amazon, eliminar o editar contenidos a nuestra entera discreci\xf3n. Este ser\xe1 el caso, en particular, si tenemos motivos para creer que usted est\xe1 incumpliendo la legislaci\xf3n aplicable, las disposiciones contractuales aplicables, nuestras directrices o nuestras pol\xedticas, que se ponen a su disposici\xf3n peri\xf3dicamente o a las que puede acceder en la p\xe1gina web, o que ha llevado a cabo un acto il\xedcito, abusivo o inapropiado de cualquier otro modo. A pesar de dicha limitaci\xf3n o rescisi\xf3n, seguir\xe1 teniendo acceso al contenido y servicios adquiridos por usted hasta ese momento].

__7. RESE\xd1AS, COMENTARIOS, COMUNICACIONES Y OTRO CONTENIDO__

Cuando exista la funcionalidad para ello, los visitantes podr\xe1n publicar rese\xf1as, comentarios y otros contenidos; enviar comunicaciones; y remitir sugerencias, ideas, comentarios, preguntas u otra informaci\xf3n, siempre y cuando el contenido no sea ilegal, obsceno, abusivo, amenazador, difamatorio, invasivo de la privacidad, infractor de los derechos de propiedad intelectual, o de otro modo perjudicial para terceros u objetable y no consista en o contenga virus de software, campa\xf1as pol\xedticas, solicitudes comerciales, cartas en cadena, correos masivos o cualquier forma de "spam". No podr\xe1 utilizar una direcci\xf3n de correo electr\xf3nico falsa, hacerse pasar por otra persona o entidad, o inducir a error sobre el origen de una tarjeta u otro contenido. Nos reservamos el derecho (pero no asumimos la obligaci\xf3n, en ausencia de un Formulario v\xe1lido de [Aviso de Infracci\xf3n](https://www.amazon.com.mx/report/infringement/signin)) de eliminar o editar dichos contenidos. Si cree que cualquier contenido de cualquier Servicio Amazon contiene una declaraci\xf3n difamatoria, o que sus derechos de propiedad intelectual est\xe1n siendo infringidos por un art\xedculo o informaci\xf3n de cualquier Servicio Amazon, le rogamos que nos lo notifique cumplimentando y enviando el correspondiente Formulario de [Aviso de Infracci\xf3n](https://www.amazon.com.mx/report/infringement/signin) y le responderemos.

Si usted publica rese\xf1as, comentarios, preguntas o respuestas, u otros contenidos generados por usted para su exhibici\xf3n en la p\xe1gina web (incluyendo cualquier imagen, v\xeddeo o audio, en conjunto "contenidos"), usted otorga a Amazon (a) una licencia y derecho no exclusivo, exento de regal\xedas, perpetuo, irrevocable y totalmente sublicenciable para utilizar, reproducir, publicar, poner a disposici\xf3n, traducir, adaptar, publicar, traducir, crear obras derivadas, distribuir, mostrar y modificar dicho contenido en todo el mundo (incluido el derecho a sublicenciar estos derechos a terceros) y (b) el derecho a utilizar el nombre que usted env\xede en relaci\xf3n con dicho contenido. Esta disposici\xf3n no transfiere ning\xfan derecho moral.

Puede eliminar su contenido de la vista p\xfablica o, cuando se ofrezca esta funcionalidad, cambiar la configuraci\xf3n para que solo se muestre a las personas a las que usted conceda acceso.

Usted declara y garantiza que posee o controla de otro modo todos los derechos sobre el contenido que publica; que, en la fecha en que se publica el contenido o material: (i) el contenido y material es exacto; y (ii) el uso del contenido y material que usted suministra no infringe ninguna pol\xedtica o directriz aplicable y no causar\xe1 perjuicio a ninguna persona o entidad (incluido que el contenido o material no es difamatorio). Usted se compromete a indemnizar a Amazon por todas las reclamaciones interpuestas por un tercero contra Amazon que se deriven o est\xe9n relacionadas con el contenido y el material que usted suministre, salvo en la medida en que cualquier responsabilidad se derive de nuestra incapacidad para eliminar adecuadamente el contenido cuando se nos notifique el car\xe1cter ilegal del mismo ( Formulario de Aviso de Contenido Difamatorio ) que se derive o tenga su origen en el contenido que usted nos haya comunicado. Al eliminar el contenido de la vista p\xfablica, usted retira su licencia para que Amazon publique y ponga a disposici\xf3n del p\xfablico dicho contenido]. 

__8. T\xc9RMINOS DEL SOFTWARE AMAZON__

Adem\xe1s de las presentes Condiciones de Uso, los t\xe9rminos que se encuentran en Condiciones Adicionales del Software de Amazon se aplican a cualquier software (incluidas las actualizaciones o mejoras del software y cualquier documentaci\xf3n relacionada) que pongamos a su disposici\xf3n ocasionalmente para su uso en relaci\xf3n con los Servicios de Amazon (el "Software de Amazon").

__9. PERMISOS DE LA APLICACI\xd3N__

Cuando utiliza aplicaciones creadas por Amazon, puede concedernos determinados permisos para su dispositivo. La mayor\xeda de los tel\xe9fonos celulares le proporcionan informaci\xf3n sobre estos permisos.

__10. SANCIONES Y POL\xcdTICA DE EXPORTACI\xd3N__

No podr\xe1 utilizar ninguno de los Servicios de Amazon si est\xe1 sujeto a sanciones o est\xe1 incluido en alguna lista de partes prohibidas o restringidas, o si es propiedad o est\xe1 bajo el control de alguna de dichas partes, incluidas, a t\xedtulo meramente enunciativo y no limitativo, las listas creadas por los Estados Unidos, el Consejo de Seguridad de las Naciones Unidas, la Uni\xf3n Europea o sus estados miembros, o por cualquier autoridad gubernamental del pa\xeds en el que est\xe9 utilizando los Servicios de Amazon. En relaci\xf3n con las Condiciones de Servicio y las presentes Condiciones de Uso, usted cumplir\xe1 todas las leyes aplicables de control de importaciones, reimportaciones, sanciones, antiboicot, exportaciones y reexportaciones, tales como el Reglamento de Administraci\xf3n de Exportaciones, el Reglamento de Tr\xe1fico Internacional de Armas y los programas de sanciones econ\xf3micas administrados por la Oficina de Control de Activos Extranjeros. Usted entiende que parte del software, la tecnolog\xeda o la informaci\xf3n relacionada a la que usted y sus empleados o contratistas puedan tener acceso puede estar sujeta a las leyes y reglamentos de control de exportaciones (los "Materiales Controlados a la Exportaci\xf3n"). Usted no permitir\xe1, sin nuestra aprobaci\xf3n previa por escrito, que ninguno de sus empleados o contratistas tenga acceso o utilice ning\xfan Material Controlado a la Exportaci\xf3n si dicho acceso o uso requiere una licencia de exportaci\xf3n.

__11. OTROS NEGOCIOS__

Podemos proporcionar enlaces a los sitios de empresas afiliadas y otros negocios. No somos responsables de examinar o evaluar, ni garantizamos las ofertas de ninguna de estos negocios o particulares (incluido el contenido de sus sitios web). Amazon no asume responsabilidad alguna por las acciones, productos y contenidos de todas estas y cualesquiera otras terceras partes. Le recomendamos que revise detenidamente sus avisos de privacidad y otras condiciones de uso.

__12. NUESTRA RESPONSABILIDAD__

La p\xe1gina web y toda la informaci\xf3n, contenido, materiales, productos (incluido cualquier software) y servicios incluidos o puestos a su disposici\xf3n a trav\xe9s de la p\xe1gina web son proporcionados por Amazon "tal cual" y "seg\xfan disponibilidad", salvo que se especifique lo contrario en las Condiciones de Servicio o en las presentes Condiciones de Uso. Amazon no declara ni ofrece garant\xedas de ning\xfan tipo, expresas o impl\xedcitas, en relaci\xf3n con el funcionamiento de la p\xe1gina web o la informaci\xf3n, contenido, materiales, productos (incluido cualquier software) o servicios incluidos en la p\xe1gina web o puestos a su disposici\xf3n a trav\xe9s de la misma, salvo que se especifique lo contrario en las Condiciones de Servicio o en las presentes Condiciones de Uso. Usted acepta expresamente que utiliza el sitio web por su cuenta y riesgo. En la medida en que lo permita la legislaci\xf3n aplicable, Amazon renuncia a todas las garant\xedas, expresas o impl\xedcitas, incluidas, a t\xedtulo meramente enunciativo y no limitativo, las garant\xedas impl\xedcitas de comerciabilidad e idoneidad para un fin determinado. Amazon no garantiza que la p\xe1gina web; la informaci\xf3n, el contenido, los materiales, los productos (incluido cualquier software) o los servicios incluidos o puestos a su disposici\xf3n a trav\xe9s de la p\xe1gina web; sus servidores; o el correo electr\xf3nico enviado desde Amazon est\xe9n libres de virus u otros componentes da\xf1inos. Amazon no ser\xe1 responsable de los da\xf1os y perjuicios de cualquier naturaleza derivados del uso de la p\xe1gina web o de cualquier informaci\xf3n, contenido, materiales, productos (incluido el software) o servicios incluidos en la p\xe1gina web o puestos a su disposici\xf3n a trav\xe9s de la misma, incluidos, a t\xedtulo meramente enunciativo y no limitativo, los da\xf1os y perjuicios directos, indirectos, incidentales, punitivos y consecuentes, salvo que se especifique lo contrario en las Condiciones de Servicio o en las presentes Condiciones de Uso. Las leyes de algunos pa\xedses no permiten algunas o todas las limitaciones descritas anteriormente. Si estas leyes son de aplicaci\xf3n en su caso, es posible que algunas o todas las renuncias, exclusiones o limitaciones anteriores no le sean de aplicaci\xf3n, y podr\xeda tener derechos adicionales]. 

__13. INDEMNIZACI\xd3N Y LIBERACI\xd3N__

En la medida en que la ley lo permita, usted acepta indemnizar y eximir de responsabilidad a Amazon, sus filiales, empresas asociadas y sus respectivos directivos, administradores, agentes y empleados, frente a cualquier reclamaci\xf3n o demanda, o acci\xf3n, incluidos los honorarios razonables de abogados, interpuesta por un tercero o sanci\xf3n impuesta debido al incumplimiento por su parte de las presentes Condiciones de Uso o a la infracci\xf3n por su parte de cualquier ley, norma o reglamento o de los derechos de un tercero. En la medida en que la ley lo permita, por la presente exonera expresamente a Amazon y/o a sus filiales y/o a cualquiera de sus directivos y representantes de cualquier coste, da\xf1o, responsabilidad u otra consecuencia y renuncia espec\xedficamente a cualquier reclamaci\xf3n o demanda que pueda tener en este sentido en virtud de cualquier ley, contrato o de cualquier otro modo.

__14. CAUSAS DE FUERZA MAYOR__

Amazon no ser\xe1 responsable de ning\xfan retraso o incumplimiento de sus obligaciones en virtud de las presentes condiciones si dicho retraso o incumplimiento se debe a una causa que exceda su control razonable. Esta condici\xf3n no afecta sus derechos legales.

__15. LEY APLICABLE Y DISPUTAS__

Al utilizar cualquier Servicio de Amazon, usted acepta que las leyes de M\xe9xico, sin tener en cuenta los principios de conflicto de leyes, regir\xe1n las presentes Condiciones de Uso y cualquier disputa de cualquier tipo que pueda surgir entre usted y Amazon.  Queda expresamente excluida la aplicaci\xf3n de la Convenci\xf3n de las Naciones Unidas sobre los Contratos de Compraventa Internacional de Mercader\xedas. 

__Cualquier controversia o reclamaci\xf3n que surja o se relacione de cualquier forma con el uso que usted haga de los Servicios de Amazon ser\xe1 resuelta mediante arbitraje vinculante, en lugar de ante un tribunal__, de conformidad con el Reglamento de Arbitraje de la C\xe1mara de Comercio Internacional (la "CCI") vigente en la Fecha de Entrada en Vigor (el "Reglamento de la CCI"), por tres \xe1rbitros designados de conformidad con dicho Reglamento de la CCI. La sede del arbitraje ser\xe1 la Ciudad de M\xe9xico, el idioma del arbitraje ser\xe1 el ingl\xe9s. Cada una de las partes se somete a las leyes de M\xe9xico y a la jurisdicci\xf3n y competencia de los tribunales estatales o federales ubicados en la Ciudad de M\xe9xico, M\xe9xico, para efectos de las solicitudes permitidas de medidas cautelares u otras medidas provisionales, y para cualquier litigio accesorio al arbitraje, incluyendo sin limitaci\xf3n, litigios o para obligar al arbitraje o hacer cumplir un laudo arbitral.

__Tanto usted como Amazon acuerdan que cualquier procedimiento de resoluci\xf3n de conflictos se llevar\xe1 a cabo \xfanicamente a t\xedtulo individual y no en el marco de una acci\xf3n colectiva, consolidada o representativa__. Asimismo, usted y Amazon acuerdan que usted o Amazon podr\xe1n interponer una demanda ante los tribunales para prohibir la infracci\xf3n u otro uso indebido de los derechos de propiedad intelectual.

__16. ALTERACIONES DEL SERVICIO O MODIFICACIONES DE LAS CONDICIONES DE USO__

Nos reservamos el derecho a modificar en cualquier momento los Servicios de Amazon, sus pol\xedticas, t\xe9rminos y condiciones, incluidas las presentes Condiciones de Uso y las Condiciones del Servicio. Usted estar\xe1 sujeto a los t\xe9rminos y condiciones, pol\xedticas y Condiciones de Uso vigentes en el momento en que utilice los Servicios de Amazon. Si alguna de las presentes Condiciones de Uso se considera inv\xe1lida, nula o, por cualquier motivo, inaplicable, dicha condici\xf3n se considerar\xe1 separable y no afectar\xe1 a la validez y aplicabilidad de las condiciones restantes].

__17. RENUNCIA__

Si incumple estas Condiciones de Uso y no tomamos ninguna medida, seguiremos teniendo derecho a utilizar nuestros derechos y recursos en cualquier otra situaci\xf3n en la que incumpla estas Condiciones de Uso.

__18. NUESTROS DATOS DE CONTACTO__

Este sitio web es propiedad y est\xe1 mantenido por Amazon Podr\xe1 enviarnos avisos relativos a la utilizaci\xf3n de los Servicios de Amazon por correo postal prepagado con firma de recepci\xf3n o entrega personal a nuestra direcci\xf3n o correo electr\xf3nico, seg\xfan se comunique entre las partes cuando utilice los Servicios de Amazon y de conformidad con los t\xe9rminos establecidos en la Secci\xf3n 1 de las presentes Condiciones de Uso. Lo Avisos de Amazon surtir\xe1n efecto cuando las recibamos].

__19. AVISO Y PROCEDIMIENTO PARA PRESENTAR RECLAMACIONES POR INFRACCI\xd3N DE DERECHOS__

Amazon respeta la propiedad intelectual de terceros. Si cree que se han infringido sus derechos de propiedad intelectual, presente su reclamaci\xf3n utilizando nuestro Formulario de Aviso de Infracci\xf3n en l\xednea. Este formulario puede utilizarse para notificar todo tipo de reclamaciones de propiedad intelectual, incluidas, entre otras, reclamaciones de derechos de autor, marcas comerciales, dise\xf1os y patentes. 

Tras la recepci\xf3n de una queja, podemos tomar ciertas medidas, incluida la eliminaci\xf3n de informaci\xf3n o de un elemento, y la terminaci\xf3n de los infractores reincidentes en las circunstancias apropiadas. Todas estas medidas se adoptan sin admisi\xf3n de responsabilidad y sin perjuicio de los derechos, recursos o defensas, todos los cuales quedan expresamente reservados. Esto incluye la transmisi\xf3n de la reclamaci\xf3n a las partes implicadas en el suministro del contenido presuntamente infractor. Usted se compromete a indemnizar a Amazon por todas las reclamaciones interpuestas por un tercero contra Amazon derivadas o relacionadas con la presentaci\xf3n de una reclamaci\xf3n de su conducta o contenido].

__Advertencia importante:__ facilitar informaci\xf3n falsa, enga\xf1osa o inexacta en el Formulario de Aviso a Amazon puede dar lugar a responsabilidad civil y/o penal. En caso de duda, p\xf3ngase en contacto con un asesor jur\xeddico. 

__CONDICIONES ADICIONALES DEL SOFTWARE AMAZON__

1. __Uso del Software de Amazon.__ Usted podr\xe1 utilizar el Software de Amazon \xfanicamente a efectos de permitirle utilizar y disfrutar de los Servicios de Amazon tal y como los presta Amazon, y seg\xfan lo permitido por las Condiciones de Uso, las presentes Condiciones del Software y cualesquiera Condiciones de Servicio. No podr\xe1 incorporar ninguna parte del Software de Amazon a sus propios programas ni compilar ninguna parte del mismo en combinaci\xf3n con sus propios programas, transferirlo para su utilizaci\xf3n con otro servicio, ni vender, alquilar, arrendar, prestar, distribuir o sublicenciar el Software de Amazon o copiar de cualquier otro modo (salvo para ejercer los derechos concedidos en el presente apartado), modificar, crear obras derivadas o ceder cualquier derecho sobre el Software de Amazon en su totalidad o en parte. No podr\xe1 utilizar el Software de Amazon para ning\xfan fin ilegal. Podremos dejar de suministrar cualquier Software de Amazon y podremos rescindir su derecho a utilizar cualquier Software de Amazon en cualquier momento. Sus derechos de utilizaci\xf3n del Software de Amazon se extinguir\xe1n autom\xe1ticamente sin previo aviso por nuestra parte si incumple cualquiera de las presentes Condiciones del Software, las Condiciones de Uso o cualesquiera otras Condiciones del Servicio. Las condiciones adicionales de terceros contenidas o distribuidas con determinado Software de Amazon que se identifiquen espec\xedficamente en la documentaci\xf3n relacionada podr\xe1n aplicarse a dicho Software de Amazon (o software incorporado con el Software de Amazon) y regir\xe1n el uso de dicho software en caso de conflicto con las presentes Condiciones de Uso. Todo el software utilizado en cualquier Servicio de Amazon es propiedad de Amazon o de sus proveedores de software y est\xe1 protegido por las leyes mexicanas y las leyes internacionales de derechos de autor. 
2. __Uso de Servicios de Terceros.__ Cuando utilice el Software de Amazon, es posible que tambi\xe9n utilice los servicios de uno o varios terceros, como un operador de telefon\xeda celular o un proveedor de plataformas m\xf3viles. La utilizaci\xf3n por su parte de estos servicios de terceros puede estar sujeta a las pol\xedticas, Condiciones de Uso y tarifas de dichos terceros. 
3. __Prohibida la ingenier\xeda inversa.__ A menos que est\xe9 expl\xedcitamente permitido en virtud de la legislaci\xf3n obligatoria aplicable, usted no podr\xe1, y no alentar\xe1, ayudar\xe1 ni autorizar\xe1 a ninguna otra persona a copiar, modificar, realizar ingenier\xeda inversa, descompilar o desensamblar, manipular o eludir cualquier seguridad asociada con el Software de Amazon, ya sea en su totalidad o en parte, o crear cualquier trabajo derivado de o del Software de Amazon. 
4. __Actualizaciones.__ Con el fin de mantener actualizado el Software de Amazon, podremos ofrecerle actualizaciones autom\xe1ticas o manuales en cualquier momento y sin previo aviso. 
5. __Conflictos.__ En caso de conflicto entre las presentes Condiciones de Uso y cualesquiera otras condiciones de Amazon o de terceros aplicables a cualquier parte del Software de Amazon, como las condiciones de licencia de c\xf3digo abierto, dichas condiciones prevalecer\xe1n en lo que respecta a dicha parte del Software de Amazon y en la medida del conflicto.

`
};
const conditionsOfUseTitle = {
    [(0, _common.COUNTRY_MAP).EU]: "Condition of Use (EU)",
    [(0, _common.COUNTRY_MAP).US]: "Condition of Use (US)",
    [(0, _common.COUNTRY_MAP).AU]: "Condition of Use (AU)",
    [(0, _common.COUNTRY_MAP).CA]: "Condition of Use (CA)",
    [(0, _common.COUNTRY_MAP).AE]: "Condition of Use (AE)",
    [(0, _common.COUNTRY_MAP).BR]: "Condition of Use (BR)",
    [(0, _common.COUNTRY_MAP).IN]: "Condition of Use (IN)",
    [(0, _common.COUNTRY_MAP).MX]: "Condition of Use (MX)"
};
const conditionOfUseContentCountryMap = {
    [(0, _common.COUNTRY_MAP).EU]: euConditionsOfUse,
    [(0, _common.COUNTRY_MAP).US]: usConditionsOfUse,
    [(0, _common.COUNTRY_MAP).AU]: auConditionsOfUse,
    [(0, _common.COUNTRY_MAP).CA]: caConditionsOfUse,
    [(0, _common.COUNTRY_MAP).AE]: aeConditionsOfUse,
    [(0, _common.COUNTRY_MAP).BR]: brConditionsOfUse,
    [(0, _common.COUNTRY_MAP).IN]: inConditionsOfUse,
    [(0, _common.COUNTRY_MAP).MX]: mxConditionsOfUse
};

},{"./common":"4gLZS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zMo8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _marked = require("marked");
const renderer = new (0, _marked.marked).Renderer();
const linkRenderer = renderer.link;
/**
 *  Added target blank markdown link handler as it is not out of box supported by marked js
 *  Ref: https://github.com/markedjs/marked/issues/655#issuecomment-712380889
 * */ renderer.link = (href, title, text)=>{
    const html = linkRenderer.call(renderer, href, title, text);
    return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};
(0, _marked.marked).setOptions({
    renderer
});
exports.default = (0, _marked.marked);

},{"marked":"aMa9j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnaDs":[function() {},{}],"9yJqt":[function(require,module,exports) {
/* eslint-disable import/no-extraneous-dependencies */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _navigationalRoutes = require("./config/navigationalRoutes");
var _landingPage = require("./pages/LandingPage");
var _landingPageDefault = parcelHelpers.interopDefault(_landingPage);
var _privacyPage = require("./pages/PrivacyPage");
var _privacyPageDefault = parcelHelpers.interopDefault(_privacyPage);
// Lazy loaded modules/pages
const FaqPage = /*#__PURE__*/ (0, _react.lazy)(()=>require("19e7d1dc04b2dd84"));
const GetStartedPage = /*#__PURE__*/ (0, _react.lazy)(()=>require("344d14051fafb415"));
const TermsAndConditionsPage = /*#__PURE__*/ (0, _react.lazy)(()=>require("25a851652aed5bc2"));
const ForecastComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("6f86465475cfaef5"));
const UserComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("902f165ad9d3d250"));
const LandingPage = /*#__PURE__*/ (0, _react.lazy)(()=>require("efae23887eb1dad3"));
const NPCManagementComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("5a67792b67c47720"));
const CapacityManagementComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("d65b538027e43d33"));
const PAMSelfServeUIComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("cc34d01a77663120"));
const CaseManagementComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("e7b908d99d786c07"));
const CarrierPerformanceInsactComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("edfd0d691bdcfef5"));
const TransReportsCenterUIComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("e8c032cd0987d271"));
const CarrierPerformanceDashboardComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("f69fcaad42509253"));
const CSATSurvey = /*#__PURE__*/ (0, _react.lazy)(()=>require("d94440ff7e13b470"));
const RubiksUIComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("1039c4b10b6fd1e3"));
const CMSUIComponent = /*#__PURE__*/ (0, _react.lazy)(()=>require("ca1eea681a098098"));
const routeConfig = [
    {
        path: (0, _navigationalRoutes.FAQ_PAGE_PATH),
        component: FaqPage,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.CMS_PATH),
        component: CMSUIComponent,
        isLanguageToggleSupported: false
    },
    {
        path: (0, _navigationalRoutes.GET_STARTED_PATH),
        component: GetStartedPage,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.TERMS_PATH),
        component: TermsAndConditionsPage,
        isLanguageToggleSupported: false,
        isLanguageToggleHidden: true
    },
    {
        path: (0, _navigationalRoutes.PRIVACY_POLICY_PATH),
        component: (0, _privacyPageDefault.default),
        isLanguageToggleSupported: false,
        isLanguageToggleHidden: true
    },
    {
        path: (0, _navigationalRoutes.PROFILE_PAGE),
        component: UserComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.FORECAST_PATH),
        component: ForecastComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.CASE_MANAGEMENT_PATH),
        component: CaseManagementComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.APP_INVITATION_PATH),
        component: UserComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.PARTNER_PICKER_PATH),
        component: ForecastComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.MANAGE_USERS_PAGE),
        component: UserComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.LANDING_PAGE),
        component: (0, _landingPageDefault.default),
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.PICKER_PATH),
        component: LandingPage,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.NPC_PATH),
        component: NPCManagementComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH),
        component: CapacityManagementComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.PAM_PATH),
        component: PAMSelfServeUIComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.PERFORMANCE_INSIGHTS_PATH),
        component: CarrierPerformanceInsactComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.REPORTS_SHARING_PATH),
        component: TransReportsCenterUIComponent,
        isLanguageToggleSupported: false
    },
    {
        path: (0, _navigationalRoutes.PERFORMANCE_DASHBOARD_PATH),
        component: CarrierPerformanceDashboardComponent,
        isLanguageToggleSupported: true
    },
    {
        path: (0, _navigationalRoutes.CSAT_SURVEY_PATH),
        component: CSATSurvey,
        isLanguageToggleSupported: false
    },
    {
        path: (0, _navigationalRoutes.RUBIKS_PATH),
        component: RubiksUIComponent,
        isLanguageToggleSupported: true
    }
];
exports.default = routeConfig;

},{"react":"6uln9","./config/navigationalRoutes":"32s8M","./pages/LandingPage":"haLHN","./pages/PrivacyPage":"i6Urd","19e7d1dc04b2dd84":"AiNkJ","344d14051fafb415":"5d88c","25a851652aed5bc2":"95X3u","6f86465475cfaef5":"bQ5Im","902f165ad9d3d250":"lOMI4","efae23887eb1dad3":"6ORu5","5a67792b67c47720":"9K5Uj","d65b538027e43d33":"lKV8t","cc34d01a77663120":"hyr9l","e7b908d99d786c07":"2juuD","edfd0d691bdcfef5":"8odu6","e8c032cd0987d271":"aiM2W","f69fcaad42509253":"giwRU","d94440ff7e13b470":"jd4zk","1039c4b10b6fd1e3":"bP4Va","ca1eea681a098098":"adgsj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haLHN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useSideNavItems = require("../hooks/useSideNavItems");
var _useSideNavItemsDefault = parcelHelpers.interopDefault(_useSideNavItems);
const LandingPage = /*#__PURE__*/ (0, _react.lazy)(()=>require("6a8654ec3e53c603"));
const LandingPageComponent = ()=>{
    const sideNavItems = (0, _useSideNavItemsDefault.default)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(LandingPage, {
        config: sideNavItems.slice(1)
    });
};
exports.default = LandingPageComponent;

},{"react":"6uln9","../hooks/useSideNavItems":"hUlio","6a8654ec3e53c603":"6ORu5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUlio":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSideNavItems", ()=>useSideNavItems);
var _index = require("@amzn/carrierlogistics-commons/dist/hooks/authorisation/index");
var _lodash = require("lodash");
var _reactIntl = require("react-intl");
var _sideMenuNavItems = require("../config/sideMenuNavItems");
var _authorization = require("../constants/authorization");
const useSideNavItems = ()=>{
    const authorizedEntities = (0, _index.useAuthorisedEntities)();
    const lpSelected = (0, _index.useSelectedLp)();
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const entitiesWithPermissions = (0, _sideMenuNavItems.sideNavItemsExternal).map(({ ...config })=>{
        const label = formatMessage({
            id: config.label
        });
        let { childNodes } = config;
        let hasAuthorizedChild = false;
        if (childNodes) childNodes = childNodes.map((node)=>{
            const formattedLabel = formatMessage({
                id: node.label
            });
            const isChildAuthorized = authorizedEntities?.[node.pamPermKey]?.length && authorizedEntities?.[lpSelected.lpId]?.includes((0, _authorization.AUTHORIZATION).ACCESS);
            hasAuthorizedChild = isChildAuthorized ? true : hasAuthorizedChild;
            return {
                ...node,
                label: formattedLabel,
                isAuthorized: isChildAuthorized
            };
        });
        if ((0, _lodash.isEmpty)(lpSelected)) return {
            isAuthorized: false,
            ...config,
            label
        };
        const isAuthorized = authorizedEntities?.[config.pamPermKey]?.length && authorizedEntities?.[lpSelected.lpId]?.includes((0, _authorization.AUTHORIZATION).ACCESS) || hasAuthorizedChild;
        return {
            isAuthorized,
            ...config,
            label,
            childNodes
        };
    });
    const HOME_PAGE_CONFIGURATION_UNMODIFIED = (0, _sideMenuNavItems.sideNavItemsExternal)[0];
    entitiesWithPermissions[0] = {
        ...HOME_PAGE_CONFIGURATION_UNMODIFIED,
        label: formatMessage({
            id: HOME_PAGE_CONFIGURATION_UNMODIFIED.label
        })
    };
    // The first item in sidebar is Home, which doesnt have permissions
    return entitiesWithPermissions;
};
exports.default = useSideNavItems;

},{"@amzn/carrierlogistics-commons/dist/hooks/authorisation/index":"jz3IT","lodash":"3hMBK","react-intl":"4kbQW","../config/sideMenuNavItems":"cekZL","../constants/authorization":"82KJ8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cekZL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sideNavItemsExternal", ()=>sideNavItemsExternal);
parcelHelpers.export(exports, "sideNavSupportItemsExternal", ()=>sideNavSupportItemsExternal);
var _releaseControl = require("@amzn/passportweb-CarrierPerformanceInsactUIAssets/dist/utils/releaseControl");
var _navigationalRoutes = require("./navigationalRoutes");
const sideNavItemsExternal = [
    {
        link: "/landing-page",
        label: "home_page.sidebar_label",
        isAuthorized: true
    },
    {
        link: "/dashboard/forecast",
        label: "sidebar_labels.forecast",
        pamPermKey: "TRANSPORTATION_FORECAST"
    },
    {
        link: "/dashboard/capacity-management",
        label: "sidebar_labels.adhoc_capacity",
        isDisabled: false,
        pamPermKey: "TRANSPORTATION_ADHOC_CAPACITY_REQUEST"
    },
    {
        link: (0, _navigationalRoutes.RUBIKS_PATH),
        label: "sidebar_labels.rubiks",
        pamPermKey: "RUBIKS"
    },
    {
        link: "#",
        label: "sidebar_labels.performance",
        children: true,
        isDisabled: false,
        childNodes: [
            {
                link: "/dashboard/performance-management",
                label: "sidebar_labels.npc",
                children: false,
                isDisabled: false,
                pamPermKey: "SP_NON_PERFORMANCE_COMPENSATION"
            },
            {
                link: "/dashboard/performance-insights",
                label: "sidebar_labels.performance_insights",
                children: false,
                isDisabled: (0, _releaseControl.isPerformanceInsightsTabDisabled)(),
                pamPermKey: "SP_PERFORMANCE_MANAGEMENT"
            },
            {
                link: "/dashboard/performance-dashboard",
                label: "sidebar_labels.performance_dashboard",
                children: false,
                isDisabled: false,
                pamPermKey: "SP_PERFORMANCE_MANAGEMENT"
            }
        ]
    }
];
const sideNavSupportItemsExternal = [
    {
        link: (0, _navigationalRoutes.CASE_MANAGEMENT_PATH),
        label: "sidebar_labels.case_management",
        isDisabled: false
    }
];
exports.default = {
    sideNavItemsExternal,
    sideNavSupportItemsExternal
};

},{"@amzn/passportweb-CarrierPerformanceInsactUIAssets/dist/utils/releaseControl":"hBiWS","./navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBiWS":[function(require,module,exports) {
/**
 * Provides a configuration boolean flag to show or hide the term tab into Passport UI
 */ // eslint-disable-next-line import/prefer-default-export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPerformanceInsightsTabDisabled", ()=>isPerformanceInsightsTabDisabled);
function isPerformanceInsightsTabDisabled() {
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82KJ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTHORIZATION", ()=>AUTHORIZATION);
var _coralComAmazonPassportaccessmanagementcore = require("@amzn/coral_com-amazon-passportaccessmanagementcore");
const AUTHORIZATION = {
    ADMIN: (0, _coralComAmazonPassportaccessmanagementcore.Permission).ADMIN,
    ACCESS: (0, _coralComAmazonPassportaccessmanagementcore.Permission).ACCESS
};

},{"@amzn/coral_com-amazon-passportaccessmanagementcore":"6eB7O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ORu5":[function(require,module,exports) {
module.exports = Promise.all([
    require("c727755e5ee506bc")(require("109e78017b6f8c6").resolve("3SBi9")),
    require("b4253eade9983d1e")(require("109e78017b6f8c6").resolve("bK6HD"))
]).then(()=>module.bundle.root("4RYq4"));

},{"c727755e5ee506bc":"bpdkb","109e78017b6f8c6":"fyJL2","b4253eade9983d1e":"hpx0h"}],"AiNkJ":[function(require,module,exports) {
module.exports = Promise.all([
    require("378e0ec3dde698ab")(require("c1cb68b84d14fba2").resolve("cLGu5")),
    require("378e0ec3dde698ab")(require("c1cb68b84d14fba2").resolve("3ssas"))
]).then(()=>module.bundle.root("23JTh"));

},{"378e0ec3dde698ab":"hpx0h","c1cb68b84d14fba2":"fyJL2"}],"5d88c":[function(require,module,exports) {
module.exports = require("c1d0f95c7f7c1d6a")(require("b8fb8a15e9e5db8c").resolve("6hTlK")).then(()=>module.bundle.root("bFczb"));

},{"c1d0f95c7f7c1d6a":"hpx0h","b8fb8a15e9e5db8c":"fyJL2"}],"95X3u":[function(require,module,exports) {
module.exports = Promise.resolve(module.bundle.root("7ESC2"));

},{}],"bQ5Im":[function(require,module,exports) {
module.exports = Promise.all([
    require("6cd0f82192f5c344")(require("dc1ba27baf8b4d75").resolve("aA5no")),
    require("ea05b5be18db212d")(require("dc1ba27baf8b4d75").resolve("eFIgP"))
]).then(()=>module.bundle.root("f7LuO"));

},{"6cd0f82192f5c344":"bpdkb","dc1ba27baf8b4d75":"fyJL2","ea05b5be18db212d":"hpx0h"}],"lOMI4":[function(require,module,exports) {
module.exports = Promise.all([
    require("cf33b2a5ff706076")(require("83649cc98a391411").resolve("dw3kp")),
    require("cf33b2a5ff706076")(require("83649cc98a391411").resolve("aS05c"))
]).then(()=>module.bundle.root("lgprW"));

},{"cf33b2a5ff706076":"hpx0h","83649cc98a391411":"fyJL2"}],"9K5Uj":[function(require,module,exports) {
module.exports = require("e9670c695adc8862")(require("57fa58b2c572f5ab").resolve("28BY8")).then(()=>module.bundle.root("iK7gn"));

},{"e9670c695adc8862":"hpx0h","57fa58b2c572f5ab":"fyJL2"}],"lKV8t":[function(require,module,exports) {
module.exports = Promise.all([
    require("183dfe5c08bfd438")(require("3b9ee993b2259632").resolve("1FX65")),
    require("183dfe5c08bfd438")(require("3b9ee993b2259632").resolve("hESBw")),
    require("183dfe5c08bfd438")(require("3b9ee993b2259632").resolve("dNdIW"))
]).then(()=>module.bundle.root("3Psgz"));

},{"183dfe5c08bfd438":"hpx0h","3b9ee993b2259632":"fyJL2"}],"hyr9l":[function(require,module,exports) {
module.exports = Promise.all([
    require("1668be365f12fcba")(require("5ed304630f2b0780").resolve("dw3kp")),
    require("1668be365f12fcba")(require("5ed304630f2b0780").resolve("2e0h3"))
]).then(()=>module.bundle.root("iZpU8"));

},{"1668be365f12fcba":"hpx0h","5ed304630f2b0780":"fyJL2"}],"2juuD":[function(require,module,exports) {
module.exports = require("72f56665e0f32da6")(require("d6b83ea3d415f9c7").resolve("6fy7K")).then(()=>module.bundle.root("cmALU"));

},{"72f56665e0f32da6":"hpx0h","d6b83ea3d415f9c7":"fyJL2"}],"8odu6":[function(require,module,exports) {
module.exports = Promise.all([
    require("63c1597d69a7d33c")(require("6014df29e959c9a4").resolve("aAN1h")),
    require("63c1597d69a7d33c")(require("6014df29e959c9a4").resolve("njwYn"))
]).then(()=>module.bundle.root("8kYXW"));

},{"63c1597d69a7d33c":"hpx0h","6014df29e959c9a4":"fyJL2"}],"aiM2W":[function(require,module,exports) {
module.exports = require("60af3451e97cd429")(require("d664f20c4969b2e8").resolve("hoLUv")).then(()=>module.bundle.root("8DeTY"));

},{"60af3451e97cd429":"hpx0h","d664f20c4969b2e8":"fyJL2"}],"giwRU":[function(require,module,exports) {
module.exports = Promise.all([
    require("d29baf3fd6c2177d")(require("432a2af652ae3599").resolve("aAN1h")),
    require("d29baf3fd6c2177d")(require("432a2af652ae3599").resolve("hESBw")),
    require("d29baf3fd6c2177d")(require("432a2af652ae3599").resolve("cLGu5")),
    require("d29baf3fd6c2177d")(require("432a2af652ae3599").resolve("eMGuZ"))
]).then(()=>module.bundle.root("d5xY0"));

},{"d29baf3fd6c2177d":"hpx0h","432a2af652ae3599":"fyJL2"}],"jd4zk":[function(require,module,exports) {
module.exports = require("290f066cb13c0dc2")(require("cc2ec1512a90b302").resolve("lyhBi")).then(()=>module.bundle.root("hYdjZ"));

},{"290f066cb13c0dc2":"hpx0h","cc2ec1512a90b302":"fyJL2"}],"bP4Va":[function(require,module,exports) {
module.exports = Promise.all([
    require("4ef80ccffdc5dcf8")(require("f04a4d3a55943eea").resolve("dpL4C")),
    require("a2f93f1c88a76ac1")(require("f04a4d3a55943eea").resolve("1FX65")),
    require("a2f93f1c88a76ac1")(require("f04a4d3a55943eea").resolve("8DfDx"))
]).then(()=>module.bundle.root("jQjGG"));

},{"4ef80ccffdc5dcf8":"bpdkb","f04a4d3a55943eea":"fyJL2","a2f93f1c88a76ac1":"hpx0h"}],"adgsj":[function(require,module,exports) {
module.exports = Promise.all([
    require("81ff1c70c501b3b0")(require("bb45b329aa8698c4").resolve("dmTY2")),
    require("5532334e320a5cfe")(require("bb45b329aa8698c4").resolve("3XQab"))
]).then(()=>module.bundle.root("5VuL6"));

},{"81ff1c70c501b3b0":"bpdkb","bb45b329aa8698c4":"fyJL2","5532334e320a5cfe":"hpx0h"}],"z8QQE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _emotion = require("emotion");
var _carrierLogisticsBackgroundImgPng = require("../images/carrierLogisticsBackgroundImg.png");
var _carrierLogisticsBackgroundImgPngDefault = parcelHelpers.interopDefault(_carrierLogisticsBackgroundImgPng);
var _indexCss = require("../styles/index.css");
var _wallpaperContentBlock = require("../components/homePage/WallpaperContentBlock");
var _wallpaperContentBlockDefault = parcelHelpers.interopDefault(_wallpaperContentBlock);
var _splashscreen = require("../components/Splashscreen");
var _splashscreenDefault = parcelHelpers.interopDefault(_splashscreen);
var _wallpaperContent = require("../components/homePage/WallpaperContent");
var _wallpaperContentDefault = parcelHelpers.interopDefault(_wallpaperContent);
var _frequentlyAskedQuestions = require("../components/homePage/FrequentlyAskedQuestions");
var _frequentlyAskedQuestionsDefault = parcelHelpers.interopDefault(_frequentlyAskedQuestions);
var _whyAmazonContentBlock = require("../components/homePage/WhyAmazonContentBlock");
var _whyAmazonContentBlockDefault = parcelHelpers.interopDefault(_whyAmazonContentBlock);
var _externalPassportUIConstants = require("../constants/externalPassportUIConstants");
var _useUserSession = require("../hooks/useUserSession");
var _useUserSessionDefault = parcelHelpers.interopDefault(_useUserSession);
const HomePage = ()=>{
    const { isUserSessionLoading } = (0, _useUserSessionDefault.default)();
    return isUserSessionLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _splashscreenDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _emotion.css)`
        max-width: ${(0, _externalPassportUIConstants.CONTAINER_SIZE_IN_PX)};
        margin: auto;
        position: relative;
      `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        alignmentHorizontal: "center",
        spacingInset: "none",
        spacing: "none",
        backgroundColor: "#055D7B"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
        className: (0, _emotion.css)`
            width: 100%;
            max-height: 40rem;
          `,
        src: (0, _carrierLogisticsBackgroundImgPngDefault.default),
        alt: "Logo"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wallpaperContentBlockDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        alignmentHorizontal: "center",
        spacingInset: "none",
        spacing: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _whyAmazonContentBlockDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wallpaperContentDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        alignmentHorizontal: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _frequentlyAskedQuestionsDefault.default), null)));
};
exports.default = HomePage;

},{"react":"6uln9","@amzn/meridian/column":"jFRKf","emotion":"1BAMo","../images/carrierLogisticsBackgroundImg.png":"3Qiws","../styles/index.css":"bnaDs","../components/homePage/WallpaperContentBlock":"1Gthw","../components/Splashscreen":"6MPWi","../components/homePage/WallpaperContent":"D6sLD","../components/homePage/FrequentlyAskedQuestions":"1vTd3","../components/homePage/WhyAmazonContentBlock":"bW0Ju","../constants/externalPassportUIConstants":"gaxjj","../hooks/useUserSession":"7kw97","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Qiws":[function(require,module,exports) {
module.exports = require("a8ccd0f19145e57e").getBundleURL("ciDtH") + "carrierLogisticsBackgroundImg.412c8757.png";

},{"a8ccd0f19145e57e":"c7Tr5"}],"bnaDs":[function() {},{}],"1Gthw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _reactIntl = require("react-intl");
var _css = require("@emotion/css");
var _useNavigateToSpecifiedRoute = require("../../hooks/useNavigateToSpecifiedRoute");
var _useNavigateToSpecifiedRouteDefault = parcelHelpers.interopDefault(_useNavigateToSpecifiedRoute);
var _navigationalRoutes = require("../../config/navigationalRoutes");
const WallpaperContentBlock = ()=>{
    const { navigateToSpecifiedRoute } = (0, _useNavigateToSpecifiedRouteDefault.default)();
    const onGetStartedClick = (0, _react.useCallback)(()=>{
        navigateToSpecifiedRoute((0, _navigationalRoutes.GET_STARTED_PATH));
    }, [
        navigateToSpecifiedRoute
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "wallpaperBlockContent"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        alignmentHorizontal: "center",
        backgroundColor: "#055D7B"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        alignmentHorizontal: "center",
        spacingInset: "medium large none large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        color: "inverted",
        type: "h400",
        fontFamily: "amazonEmberDisplay"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            color: "#FFFFFF"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content_block.heading"
    })))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        alignmentHorizontal: "center",
        spacingInset: "none large none large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        color: "inverted",
        type: "b300",
        fontFamily: "amazonEmber"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content_block.content"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        spacingInset: "none large medium large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        onClick: onGetStartedClick,
        className: (0, _css.css)`
              &:hover {
                background-color: white;
                color: #055d7b;
              }
            `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content_block.get_started_button"
    }))))));
};
exports.default = WallpaperContentBlock;

},{"react":"6uln9","@amzn/meridian/button":"k0QSK","@amzn/meridian/column":"jFRKf","@amzn/meridian/row":"ba4AQ","@amzn/meridian/text":"hj2bM","react-intl":"4kbQW","@emotion/css":"awUBr","../../hooks/useNavigateToSpecifiedRoute":"3G87j","../../config/navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MPWi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _clLogoSvg = require("../images/cl-logo.svg");
var _clLogoSvgDefault = parcelHelpers.interopDefault(_clLogoSvg);
var _splashscreenLogoPng = require("../images/splashscreen-logo.png");
var _splashscreenLogoPngDefault = parcelHelpers.interopDefault(_splashscreenLogoPng);
const Wrapper = (0, _styledDefault.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
`;
const OverlayBackground = (0, _styledDefault.default)(Wrapper)`
  position: fixed;
  overflow: hidden;
  background: white;
  z-index: 26;
`;
const Image = (0, _styledDefault.default).img`
  width: 16.25rem;
  height: auto;
  z-index: 1;
`;
const RelativeBox = (0, _styledDefault.default).div`
  position: relative;
  height: 40px;
`;
const TypeWriterEffect = (0, _styledDefault.default).div`
  z-index: 2;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  overflow: hidden;
  background: white;
  transform: scale(1.3);
  animation: typing 1s steps(40, end);
  animation-iteration-count: 1;
  @keyframes typing {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;
const Logo = (0, _styledDefault.default).div`
  margin: 0 auto;
  width: 16.25rem;
  height: 16.25rem;
  background: #232f3e;
  position: relative;
  border-radius: 50px;

  animation: opacity-in 1.5s;
  animation-iteration-count: 1;

  @keyframes opacity-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const ScaledColumn = (0, _styledDefault.default)((0, _columnDefault.default))`
  transform: scale(0.5);
  -moz-transform: scale(0.5);
`;
const SplashScreen = ()=>{
    (0, _react.useLayoutEffect)(()=>{
        document.body.style.height = "100%";
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.height = "auto";
            document.body.style.overflow = "auto";
        };
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(OverlayBackground, {
        absolute: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ScaledColumn, {
        spacing: "small"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Logo, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Image, {
        src: (0, _splashscreenLogoPngDefault.default)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(RelativeBox, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(TypeWriterEffect, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Image, {
        src: (0, _clLogoSvgDefault.default)
    })))));
};
exports.default = SplashScreen;

},{"react":"6uln9","@emotion/styled":"45i57","@amzn/meridian/column":"jFRKf","../images/cl-logo.svg":"bKAQK","../images/splashscreen-logo.png":"laXo5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"45i57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newStyled);
var _emotionStyledBaseBrowserEsmJs = require("../base/dist/emotion-styled-base.browser.esm.js");
var _emotionStyledBaseBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseBrowserEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var newStyled = (0, _emotionStyledBaseBrowserEsmJsDefault.default).bind();
tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    newStyled[tagName] = newStyled(tagName);
});

},{"../base/dist/emotion-styled-base.browser.esm.js":"lSuFu","@babel/runtime/helpers/extends":"4iKIP","react":"6uln9","@emotion/is-prop-valid":"8Sfn2","@emotion/react":"djZKr","@emotion/utils":"firjl","@emotion/serialize":"2Iv9c","@emotion/use-insertion-effect-with-fallbacks":"8D2zh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSuFu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, _react1.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react.useContext((0, _react1.ThemeContext));
            }
            if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ _react.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"fW5l8","react":"6uln9","@emotion/is-prop-valid":"8Sfn2","@emotion/react":"djZKr","@emotion/utils":"firjl","@emotion/serialize":"2Iv9c","@emotion/use-insertion-effect-with-fallbacks":"8D2zh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Sfn2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"dMybP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"djZKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElement43C6Fea0BrowserEsmJs = require("./emotion-element-43c6fea0.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement43C6Fea0BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement43C6Fea0BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement43C6Fea0BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T)));
    if (!(0, _emotionElement43C6Fea0BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"./emotion-element-43c6fea0.browser.esm.js":"9hftb","react":"6uln9","@emotion/utils":"firjl","@emotion/use-insertion-effect-with-fallbacks":"8D2zh","@emotion/serialize":"2Iv9c","@emotion/cache":"dJbf5","@babel/runtime/helpers/extends":"4iKIP","@emotion/weak-memoize":"9scve","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"8wO4V","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9hftb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: "css"
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== "css" && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"6uln9","@emotion/cache":"dJbf5","@babel/runtime/helpers/esm/extends":"fW5l8","@emotion/weak-memoize":"9scve","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"8wO4V","@emotion/utils":"firjl","@emotion/serialize":"2Iv9c","@emotion/use-insertion-effect-with-fallbacks":"8D2zh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wO4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8D2zh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iKIP":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"bKAQK":[function(require,module,exports) {
module.exports = require("f7339d68fdc2b015").getBundleURL("ciDtH") + "cl-logo.0b052307.svg";

},{"f7339d68fdc2b015":"c7Tr5"}],"laXo5":[function(require,module,exports) {
module.exports = require("87b52f86e34582d3").getBundleURL("ciDtH") + "splashscreen-logo.26d9f900.png";

},{"87b52f86e34582d3":"c7Tr5"}],"D6sLD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _reactIntl = require("react-intl");
const WallpaperContent = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        width: "100%",
        backgroundColor: "white",
        spacingInset: "medium"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "h600"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.heading"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "b300",
        fontFamily: "amazonEmber"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.body"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "h300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.sub1.title"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "b300",
        fontFamily: "amazonEmber"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.sub1.body"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "h300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.sub2.title"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "b300",
        fontFamily: "amazonEmber"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.sub2.body"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "h300"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.sub3.title"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "b300",
        fontFamily: "amazonEmber"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.wallpaper_content.sub3.body"
    })));
exports.default = WallpaperContent;

},{"react":"6uln9","@amzn/meridian/column":"jFRKf","@amzn/meridian/row":"ba4AQ","@amzn/meridian/text":"hj2bM","react-intl":"4kbQW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1vTd3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactIntl = require("react-intl");
var _css = require("@emotion/css");
var _controlledExpander = require("../commons/ControlledExpander");
var _controlledExpanderDefault = parcelHelpers.interopDefault(_controlledExpander);
var _useNavigateToSpecifiedRoute = require("../../hooks/useNavigateToSpecifiedRoute");
var _useNavigateToSpecifiedRouteDefault = parcelHelpers.interopDefault(_useNavigateToSpecifiedRoute);
var _navigationalRoutes = require("../../config/navigationalRoutes");
const FrequentlyAskedQuestions = ()=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const { navigateToSpecifiedRoute } = (0, _useNavigateToSpecifiedRouteDefault.default)();
    const onFAQClick = (0, _react.useCallback)(()=>{
        navigateToSpecifiedRoute((0, _navigationalRoutes.FAQ_PAGE_PATH));
    }, [
        navigateToSpecifiedRoute
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
        type: "fill",
        backgroundColor: "#055D7B",
        spacingInset: "large",
        spacing: "medium",
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "h600",
        color: "inverted",
        id: "faq"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.faq_section.header"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "faqDrillDown"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controlledExpanderDefault.default), {
        title: formatMessage({
            id: "home_page.faq_section.drilldown.q1.title"
        }),
        type: "list"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        color: "inverted"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a1.legend"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a1.p1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a1.p2"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a1.p3"
    })))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "faqDrillDown"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controlledExpanderDefault.default), {
        title: formatMessage({
            id: "home_page.faq_section.drilldown.q3.title"
        }),
        type: "list"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        color: "inverted"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a3.p1",
        values: {
            link: /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                href: "https://carrierlogistics.integ.amazon.com/privacy-notice",
                target: "_blank",
                rel: "noreferrer"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
                id: "faq_page.all_faqs.a3.link"
            }))
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        color: "inverted"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a3.p2",
        values: {
            link: /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                href: "https://carrierlogistics.integ.amazon.com/terms",
                target: "_blank",
                rel: "noreferrer"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
                id: "faq_page.all_faqs.a3.conditions"
            }))
        }
    }))))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "faqDrillDown"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controlledExpanderDefault.default), {
        title: formatMessage({
            id: "faq_page.all_faqs.q4"
        }),
        type: "list"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "b300",
        color: "inverted"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "faq_page.all_faqs.a4"
    })))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        spacingInset: "small small large xsmall"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        type: "secondary",
        className: (0, _css.css)`
            & {
              background-color: white;
              border-radius: 4px;
              color: #055d7b;
              font-weight: bold;
            }
            &:hover {
              background-color: #eee;
              color: #055d7b;
            }
          `,
        onClick: onFAQClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.faq_section.see_all_faqs_button"
    })))));
};
exports.default = FrequentlyAskedQuestions;

},{"react":"6uln9","@amzn/meridian/column":"jFRKf","@amzn/meridian/row":"ba4AQ","@amzn/meridian/text":"hj2bM","@amzn/meridian/button":"k0QSK","react-intl":"4kbQW","@emotion/css":"awUBr","../commons/ControlledExpander":"fivR5","../../hooks/useNavigateToSpecifiedRoute":"3G87j","../../config/navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fivR5":[function(require,module,exports) {
/* eslint-disable react/jsx-props-no-spreading */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _expander = require("@amzn/meridian/expander");
var _expanderDefault = parcelHelpers.interopDefault(_expander);
const ControlledExpander = (props)=>{
    const [open, setOpen] = (0, _react.useState)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _expanderDefault.default), {
        open: open,
        onChange: setOpen,
        ...props
    });
};
exports.default = ControlledExpander;

},{"react":"6uln9","@amzn/meridian/expander":"68nsj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"68nsj":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6692632d87c629ef");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _expander = _interopRequireDefault(require("586058d69787d406"));
var _default = _expander["default"];
exports["default"] = _default;

},{"6692632d87c629ef":"5qxSW","586058d69787d406":"4jpYx"}],"4jpYx":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("9b9d26e67d9e8372");
var _interopRequireDefault = require("107719f9fcce2892");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("2a7b96a6180b831"));
var _react = _interopRequireWildcard(require("1edbfec760fe55ea"));
var _propTypes = _interopRequireDefault(require("43938bdb373f23b4"));
var _emotion = require("c0b5123691cefc90");
var _theme = require("5af198bc2f6c7be4");
var _clickable = _interopRequireDefault(require("340a7ecd5a12c9ad"));
var _icon = _interopRequireDefault(require("8839d2dea87f16c1"));
var _expanderController = _interopRequireDefault(require("1e18831356a10126"));
var _useFocus2 = _interopRequireDefault(require("5563332752c3a0b5"));
var _focusRing = _interopRequireDefault(require("c34b98af56ca9b44"));
var _token = require("ead13ca65497fa2a");
var _functional = require("ed36ec29d1b25eca");
var _text = _interopRequireDefault(require("88d8dd6cabb735d8"));
var _cxMemoized = _interopRequireDefault(require("66b30dd57d65bb70"));
var _expander = _interopRequireDefault(require("3fc8eb4148fc41bb"));
var _chevronRightSmall = _interopRequireDefault(require("76336d9acae7dd7e"));
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var type = _ref.type;
    return (0, _emotion.css)((0, _text["default"])(t), {
        position: "relative",
        borderBottom: type === "section" ? t.borderCss("border") : undefined,
        border: type === "box" ? t.borderCss("border") : undefined,
        borderRadius: t("borderRadius", type),
        backgroundColor: t("backgroundColor", type)
    });
}, [
    "type"
]);
var iconStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var open = _ref2.open, focus = _ref2.focus;
    return (0, _emotion.css)({
        marginRight: t("spacingHorizontal"),
        transform: "rotate(".concat(open ? 90 : 0, "deg)"),
        transition: "transform ".concat(t("motionDuration"), " ").concat(t("motionIconFunction"))
    }, (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        offset: 8
    }));
}, [
    "open",
    "focus"
]);
var handleStyles = (0, _token.memoizeTokenStyles)(function(t, _ref3) {
    var type = _ref3.type;
    var colorType = type === "section" || type === "list" ? "default" : "inline";
    var spacingV = t("spacingVertical");
    var spacingH = t("spacingHorizontal");
    return (0, _emotion.css)({
        // Make the whole width of the expander clickable for block-level expanders,
        // otherwise only make the visible content clickable
        display: type === "box" || type === "section" ? "flex" : "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        color: t("foregroundColor", [
            colorType,
            "default"
        ]),
        ":hover": {
            color: t("foregroundColor", [
                colorType,
                "hover"
            ])
        },
        ":active": {
            color: t("foregroundColor", [
                colorType,
                "pressed"
            ])
        },
        padding: type === "box" ? "".concat(spacingV, "px ").concat(spacingH, "px") : type === "section" ? "".concat(spacingV, "px ").concat(spacingH, "px ").concat(spacingV, "px 0") : "".concat(spacingV, "px 0")
    });
}, [
    "type"
]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function(t, _ref4) {
    var type = _ref4.type, open = _ref4.open;
    var spacingV = t("spacingVertical");
    var spacingH = t("spacingHorizontal");
    var spacingRight = type === "section" || type === "box" ? spacingH : 0;
    var spacingLeft = spacingH * (type === "box" ? 2 : 1) + _icon["default"].sizes.small;
    return (0, _emotion.css)({
        boxSizing: "border-box",
        padding: "0 ".concat(spacingRight, "px ").concat(spacingV, "px ").concat(spacingLeft, "px"),
        opacity: open ? 1 : 0,
        transition: "opacity ".concat(t("motionDuration"), " ").concat(t("motionChildContentFunction"))
    });
}, [
    "type",
    "open"
]);
var titleStyles = (0, _functional.memoize)(function(type) {
    return type === "box" || type === "section" ? (0, _emotion.css)({
        flex: "auto"
    }) : undefined;
});
function Expander(_ref5) {
    var title = _ref5.title, children = _ref5.children, open = _ref5.open, id = _ref5.id, type = _ref5.type, alwaysRenderChildren = _ref5.alwaysRenderChildren, onChange = _ref5.onChange;
    var t = (0, _theme.useTheme)(_expander["default"], "expander");
    var handleOnChange = (0, _react.useCallback)(function() {
        onChange(!open);
    }, [
        open,
        onChange
    ]);
    var _useFocus = (0, _useFocus2["default"])(), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, {
            type: type
        })
    }, /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
        tag: "div",
        id: id,
        onClick: handleOnChange,
        "aria-expanded": open,
        className: handleStyles(t, {
            type: type
        })
    }), /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: _chevronRightSmall["default"],
        open: open,
        className: iconStyles(t, {
            open: open,
            focus: focus && focusTrigger === "keyboard"
        })
    }), /*#__PURE__*/ _react["default"].createElement("span", {
        className: titleStyles(type)
    }, title)), /*#__PURE__*/ _react["default"].createElement(_expanderController["default"], {
        open: open,
        direction: "down",
        motionDuration: parseInt(t("motionDuration")),
        motionDelay: t("motionDelay"),
        motionFunction: t("motionChildContentFunction"),
        alwaysRenderChildren: alwaysRenderChildren
    }, function(_ref6) {
        var containerProps = _ref6.containerProps, contentProps = _ref6.contentProps;
        return /*#__PURE__*/ _react["default"].createElement("div", containerProps, /*#__PURE__*/ _react["default"].createElement("div", {
            ref: contentProps.ref,
            className: (0, _cxMemoized["default"])(contentProps.className, childrenStyles(t, {
                type: type,
                open: open
            }))
        }, children));
    }));
}
Expander.propTypes = {};
Expander.defaultProps = {
    type: "section",
    open: false
};
var _default = Expander;
exports["default"] = _default;

},{"9b9d26e67d9e8372":"4RXTR","107719f9fcce2892":"5qxSW","2a7b96a6180b831":"fAmfl","1edbfec760fe55ea":"6uln9","43938bdb373f23b4":"9Mqtv","c0b5123691cefc90":"1BAMo","5af198bc2f6c7be4":"dJlcb","340a7ecd5a12c9ad":"iWCwP","8839d2dea87f16c1":"8MgRY","1e18831356a10126":"aETlj","5563332752c3a0b5":"7jVM9","c34b98af56ca9b44":"5Dvm2","ead13ca65497fa2a":"bebc4","ed36ec29d1b25eca":"hze9s","88d8dd6cabb735d8":"g6RQX","66b30dd57d65bb70":"5KZHn","3fc8eb4148fc41bb":"jO6Bj","76336d9acae7dd7e":"4EdS9"}],"aETlj":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("937d12d178b5ef7b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _expanderController = _interopRequireDefault(require("fae0ebc6cd6eaf83"));
var _default = _expanderController["default"];
exports["default"] = _default;

},{"937d12d178b5ef7b":"5qxSW","fae0ebc6cd6eaf83":"lMgxp"}],"lMgxp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a252895f13c05f2c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("d922329148d47139"));
var _classCallCheck2 = _interopRequireDefault(require("ef6b6d087409ae28"));
var _createClass2 = _interopRequireDefault(require("410e9bf4084ca203"));
var _assertThisInitialized2 = _interopRequireDefault(require("26d2ebd100b4342c"));
var _inherits2 = _interopRequireDefault(require("bcf0e4f8aaede480"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("5b509819a39c0829"));
var _getPrototypeOf2 = _interopRequireDefault(require("dbfb7c17ea4f918c"));
var _defineProperty2 = _interopRequireDefault(require("5375512273c5c302"));
var _react = _interopRequireDefault(require("803b07f130ecc2a6"));
var _propTypes = _interopRequireDefault(require("c7f8faa26489a0d8"));
var _emotion = require("e5af9c8abc6992d2");
var _transitionController = _interopRequireDefault(require("36d3f9d8a776f159"));
var _waitAnimationFrame = _interopRequireDefault(require("79f0117d2b1071e0"));
var _functional = require("eae6b1fc20fc0d7b");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var getSizeProperty = function getSizeProperty(direction) {
    return ({
        left: "width",
        right: "width",
        up: "height",
        down: "height"
    })[direction];
}; // The container element sets the width or height of the expander and handles
// the expanding and collapsing motion.
var containerStyles = (0, _functional.memoizeByKeys)(function(_ref) {
    var _css;
    var state = _ref.state, direction = _ref.direction, size = _ref.size, motionDuration = _ref.motionDuration, motionFunction = _ref.motionFunction, closedSize = _ref.closedSize;
    return (0, _emotion.css)({
        left: {
            // Horizontal expanders are inline-flex to ensure they shrink to fit
            // their children's width (vertical expanders shrink to fit by default
            // 'cause that's how CSS layout works).
            display: "inline-flex",
            // The up/left expanders use row/column-reverse so that content is fixed
            // to the bottom/right edges instead of top/left (the default).
            // NOTE: justifyContent: "flex-end" would work here instead *except* for
            // a bug in IE11: https://stackoverflow.com/questions/32885534/how-to-make-flex-end-work-in-ie11
            flexDirection: "row-reverse"
        },
        right: {
            display: "inline-flex",
            flexDirection: "row"
        },
        up: {
            display: "flex",
            flexDirection: "column-reverse"
        },
        down: {
            display: "flex",
            flexDirection: "column"
        }
    }[direction], (_css = {
        // Don't let a flex parent squish the expander
        flexShrink: 0
    }, (0, _defineProperty2["default"])(_css, getSizeProperty(direction), state === "entering" || state === "entered" ? size : closedSize), (0, _defineProperty2["default"])(_css, "overflow", "hidden"), (0, _defineProperty2["default"])(_css, "transition", motionDuration && motionFunction ? "".concat(getSizeProperty(direction), " ").concat(motionDuration, "ms ").concat(motionFunction) : undefined), (0, _defineProperty2["default"])(_css, "visibility", state === "exited" && closedSize === 0 ? "hidden" : undefined), (0, _defineProperty2["default"])(_css, "maxWidth", state === "exited" && (direction === "left" || direction === "right") ? closedSize : undefined), _css));
}, [
    "state",
    "direction",
    "size",
    "motionDuration",
    "motionFunction",
    "closedSize"
]); // The content element automatically holds its dimensions, even when the
// container is collapsed, so that the container knows what size to animate to.
var contentStyles = (0, _functional.memoize)(function(direction) {
    var _css2;
    return (0, _emotion.css)((_css2 = {}, (0, _defineProperty2["default"])(_css2, getSizeProperty(direction), "max-content"), (0, _defineProperty2["default"])(_css2, "flexShrink", 0), (0, _defineProperty2["default"])(_css2, "transform", "translateZ(0)"), _css2));
});
/* eslint-disable react/prop-types */ /**
 * This component makes it easy to animate the size of a content block from 0 to
 * "auto" and back. It handles some nice things like expanding in various
 * directions, keeping children out of the tab order when collapsed, setting an
 * aria-hidden attribute when collapsed, and correctly handling situations when
 * the dimensions of the expander contents change on the fly.
 *
 * This component doesn't render anything to the DOM itself, but it needs at
 * least two nested elements to work. To make this happen it requires that you
 * pass in children as a function. It will call that function, passing it an
 * object containing two more objects keyed under "containerProps" and
 * "contentProps". These objects should be passed through as props to two nested
 * elements by your children function (with the container element as the root of
 * the expander and the content element as the only child of the container).
 * This allows you to take advantage of the expander functionality while
 * maintaining maximum control over the DOM. Example:
 *
 * ```
 * <ExpanderController>
 *   {({ containerProps, contentProps }) => (
 *     <div {...containerProps}>
 *       <div {...contentProps}>
 *         My expandable content here...
 *       <div>
 *     </div>
 *   )}
 * </ExpanderController>
 * ```
 *
 * NOTE: Horizontal ExpanderControllers are inline elements, so extra attention
 * may be needed to avoid unwanted whitespace around them. A couple tricks for
 * removing whitespace include setting `font-size: 0` or `display: flex` on an
 * inline element's parent.
 */ var ExpanderControllerClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(ExpanderControllerClass, _React$Component);
    var _super = _createSuper(ExpanderControllerClass);
    function ExpanderControllerClass() {
        var _this;
        (0, _classCallCheck2["default"])(this, ExpanderControllerClass);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            size: undefined,
            render: _this.props.open || _this.props.alwaysRenderChildren
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContentRef", function(node) {
            return _this.contentRef = node;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelFixSize", function() {});
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixSize", function(done) {
            return _this.setState({
                size: _this.contentRef && _this.contentRef.getBoundingClientRect()[getSizeProperty(_this.props.direction)]
            }, done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function(done) {
            if (!_this.state.render) // If the children aren't rendered yet, do so and then give them a chance
            // to settle before poking through the DOM
            _this.setState({
                render: true
            }, function() {
                _this.cancelFixSize = (0, _waitAnimationFrame["default"])(function() {
                    return _this.fixSize(done);
                });
            });
            else _this.fixSize(done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterOpen", function() {
            _this.setState({
                size: undefined
            });
            if (_this.props.onAfterOpen) _this.props.onAfterOpen();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeClose", function(done) {
            _this.cancelFixSize();
            _this.fixSize(done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function() {
            if (!_this.props.alwaysRenderChildren) _this.setState({
                render: false
            });
            if (_this.props.onAfterClose) _this.props.onAfterClose();
        });
        return _this;
    }
    (0, _createClass2["default"])(ExpanderControllerClass, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelFixSize();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, children = _this$props.children, props = (0, _objectWithoutProperties2["default"])(_this$props, [
                    "children"
                ]);
                var _this$state = this.state, size = _this$state.size, render = _this$state.render;
                return /*#__PURE__*/ _react["default"].createElement(_transitionController["default"], {
                    "in": props.open,
                    duration: props.motionDuration && props.motionFunction ? props.motionDuration : 0,
                    onBeforeEnter: this.onBeforeOpen,
                    onAfterEnter: this.onAfterOpen,
                    onBeforeExit: this.onBeforeClose,
                    onAfterExit: this.onAfterClose
                }, function(state) {
                    return render ? children({
                        state: state,
                        containerProps: {
                            className: containerStyles(_objectSpread(_objectSpread({}, props), {}, {
                                state: state,
                                size: size
                            })),
                            "aria-hidden": !props.closedSize && !props.open
                        },
                        contentProps: {
                            className: contentStyles(props.direction),
                            ref: _this2.updateContentRef
                        }
                    }) : null;
                });
            }
        }
    ]);
    return ExpanderControllerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change
var ExpanderController = function ExpanderController(props) {
    return /*#__PURE__*/ _react["default"].createElement(ExpanderControllerClass, props);
};
ExpanderController.propTypes = {};
ExpanderController.defaultProps = {
    closedSize: 0
};
var _default = ExpanderController;
exports["default"] = _default;

},{"a252895f13c05f2c":"5qxSW","d922329148d47139":"DlKuU","ef6b6d087409ae28":"aqLjQ","410e9bf4084ca203":"8X7ov","26d2ebd100b4342c":"fA0LA","bcf0e4f8aaede480":"hAMmu","5b509819a39c0829":"37tJc","dbfb7c17ea4f918c":"cE6Se","5375512273c5c302":"avcfc","803b07f130ecc2a6":"6uln9","c7f8faa26489a0d8":"9Mqtv","e5af9c8abc6992d2":"1BAMo","36d3f9d8a776f159":"5fxtO","79f0117d2b1071e0":"oJLwr","eae6b1fc20fc0d7b":"hze9s"}],"jO6Bj":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        expanderMobileSpacingInset: 16,
        expanderMobileTitleHeight: 48,
        expanderMobileTitleFontSize: 16,
        expanderMobileTitleBackgroundColorPressed: tokens.themeBackgroundOverlayPressed,
        expanderMobileTitleBackgroundOpacityPressed: 16,
        expanderMobileValueFontSize: 14,
        expanderMobileForegroundColorDefaultDefault: tokens.themeForegroundPrimaryDefault,
        expanderMobileForegroundColorDefaultDisabled: tokens.themeBorderSecondaryDefault,
        expanderMobileForegroundColorInlineDefault: tokens.themeForegroundAccentDefault,
        expanderMobileForegroundColorInlinePressed: tokens.themeForegroundAccentPressed,
        expanderMobileForegroundColorInlineDisabled: tokens.themeBorderAccentDisabled,
        expanderSpacingVertical: 10,
        expanderSpacingHorizontal: 20,
        expanderForegroundColorDefaultDefault: tokens.themeForegroundPrimaryDefault,
        expanderForegroundColorDefaultHover: tokens.themeForegroundAccentHover,
        expanderForegroundColorDefaultPressed: tokens.themeForegroundAccentPressed,
        expanderForegroundColorDefaultDisabled: tokens.themeBorderAccentDisabled,
        expanderForegroundColorInlineDefault: tokens.themeForegroundAccentDefault,
        expanderForegroundColorInlineHover: tokens.themeForegroundAccentHover,
        expanderForegroundColorInlinePressed: tokens.themeForegroundAccentPressed,
        expanderForegroundColorInlineDisabled: tokens.themeBorderAccentDisabled,
        expanderBackgroundColorBox: tokens.themeBackgroundPrimaryDefault,
        expanderBorderWidth: 1,
        expanderBorderColor: tokens.themeBorderSecondaryDefault,
        expanderBorderRadius: 0,
        expanderBorderRadiusBox: 4,
        expanderMotionDelay: "100ms",
        expanderMotionDuration: "200ms",
        expanderMotionIconFunction: "ease",
        expanderMotionChildContentFunction: "ease"
    };
};

},{}],"bW0Ju":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _box = require("@amzn/meridian/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _responsive = require("@amzn/meridian/responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _css = require("@emotion/css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _oneStopSvg = require("../../images/one_stop.svg");
var _oneStopSvgDefault = parcelHelpers.interopDefault(_oneStopSvg);
var _performanceVisSvg = require("../../images/performance_vis.svg");
var _performanceVisSvgDefault = parcelHelpers.interopDefault(_performanceVisSvg);
var _reducedCostSvg = require("../../images/reduced_cost.svg");
var _reducedCostSvgDefault = parcelHelpers.interopDefault(_reducedCostSvg);
const WhyAmazonContentBlock = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), {
        alignmentHorizontal: "center",
        backgroundColor: "#f0f1f2",
        spacingInset: "500"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        alignment: "center",
        type: "h600",
        fontFamily: "amazonEmber",
        className: (0, _css.css)`
        letter-spacing: -1px;
        font-weight: 500 !important;
        margin-bottom: 32px !important;
      `
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "home_page.why_amazon.title"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveDefault.default), {
        query: "max-width",
        props: {
            wrap: {
                default: "none",
                [(0, _breakpoints.DEVICE_WIDTHS).TABLET]: "down"
            },
            alignmentHorizontal: {
                default: "justify",
                [(0, _breakpoints.DEVICE_WIDTHS).TABLET]: "center"
            }
        }
    }, ({ wrap, alignmentHorizontal })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
            width: "100%",
            alignmentHorizontal: alignmentHorizontal,
            alignmentVertical: "top",
            spacing: "600",
            wrap: wrap
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
            alignmentHorizontal: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: (0, _oneStopSvgDefault.default),
            height: "96px",
            alt: "Logo"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
            alignment: "center",
            type: "h300",
            fontFamily: "amazonEmber"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "home_page.why_amazon.benefits.one_stop.title"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
            alignment: "center",
            type: "b100",
            fontFamily: "amazonEmber"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "home_page.why_amazon.benefits.one_stop.description"
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
            alignmentHorizontal: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: (0, _reducedCostSvgDefault.default),
            height: "96px",
            alt: "Logo"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
            alignment: "center",
            type: "h300",
            fontFamily: "amazonEmber",
            className: (0, _css.css)`
                margin-bottom: 40px !important;
              `
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "home_page.why_amazon.benefits.reduced_costs.title"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
            alignment: "center",
            type: "b100",
            fontFamily: "amazonEmber"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "home_page.why_amazon.benefits.reduced_costs.description"
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
            alignmentHorizontal: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: (0, _performanceVisSvgDefault.default),
            height: "96px",
            alt: "Logo"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
            alignment: "center",
            type: "h300",
            fontFamily: "amazonEmber",
            className: (0, _css.css)`
                margin-bottom: 40px !important;
              `
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "home_page.why_amazon.benefits.performance_vis.title"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
            alignment: "center",
            type: "b100",
            fontFamily: "amazonEmber"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "home_page.why_amazon.benefits.performance_vis.description"
        }))))));
exports.default = WhyAmazonContentBlock;

},{"@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/meridian/box":"dxZXY","@amzn/meridian/column":"jFRKf","@amzn/meridian/responsive":"l7U3k","@amzn/meridian/row":"ba4AQ","@amzn/meridian/text":"hj2bM","@emotion/css":"awUBr","react":"6uln9","react-intl":"4kbQW","../../images/one_stop.svg":"7pYTd","../../images/performance_vis.svg":"dcMw8","../../images/reduced_cost.svg":"jgOEt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7pYTd":[function(require,module,exports) {
module.exports = require("eaf25b980995b1f0").getBundleURL("ciDtH") + "one_stop.ffd588e5.svg";

},{"eaf25b980995b1f0":"c7Tr5"}],"dcMw8":[function(require,module,exports) {
module.exports = require("18115bd0f2736d61").getBundleURL("ciDtH") + "performance_vis.fb76a3b6.svg";

},{"18115bd0f2736d61":"c7Tr5"}],"jgOEt":[function(require,module,exports) {
module.exports = require("83a34cdaf0e9f518").getBundleURL("ciDtH") + "reduced_cost.c12a1781.svg";

},{"83a34cdaf0e9f518":"c7Tr5"}],"gaxjj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTAINER_SIZE_IN_PX", ()=>CONTAINER_SIZE_IN_PX);
parcelHelpers.export(exports, "MONS_OVERRIDE_COOKIE", ()=>MONS_OVERRIDE_COOKIE);
parcelHelpers.export(exports, "SITE_QUERY_PARAM", ()=>SITE_QUERY_PARAM);
parcelHelpers.export(exports, "MONS_DIRECTOR_ID_QUERY_PARAM", ()=>MONS_DIRECTOR_ID_QUERY_PARAM);
const CONTAINER_SIZE_IN_PX = "1025px";
const MONS_OVERRIDE_COOKIE = "mons-override";
const SITE_QUERY_PARAM = "site";
const MONS_DIRECTOR_ID_QUERY_PARAM = "mons_sel_dir_paid";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7kw97":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// When a user signs in a particular browser, his default page should be
// profile page as long as his session is valid. Hence on the very first page load, calling user api
// '/user' api returns {redirected=FALSE} if user session is valid.
// '/user' api return {redirected=TRUE} if session expired/invalid/null.
parcelHelpers.export(exports, "useUserSession", ()=>useUserSession);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _navigationalRoutes = require("../config/navigationalRoutes");
var _window = require("../utils/window");
var _windowDefault = parcelHelpers.interopDefault(_window);
function useUserSession() {
    const [isUserSessionLoading, setUserSessionLoading] = (0, _reactDefault.default).useState(true);
    const history = (0, _reactRouter.useHistory)();
    (0, _react.useEffect)(()=>{
        const USER_API_ENDPOINT = (0, _windowDefault.default).location.origin + (0, _navigationalRoutes.USER_SESSION_API_PATH);
        const isExternalSite = (0, _navigationalRoutes.EXTERNAL_PASSPORT_APP_DOMAINS).some((domainName)=>(0, _windowDefault.default).location.href.includes(domainName));
        if ((0, _windowDefault.default).location.pathname !== (0, _navigationalRoutes.HOME) || !isExternalSite) {
            setUserSessionLoading(false);
            return;
        }
        (0, _windowDefault.default).fetch(USER_API_ENDPOINT).then((res)=>{
            // pushing to the default profile page as session is valid
            if (res.ok && !res.redirected) history.push((0, _navigationalRoutes.DEFAULT_USER_AUTHENTICATED_PAGE));
        }).finally(()=>{
            setUserSessionLoading(false);
        });
    }, [
        history
    ]);
    return {
        isUserSessionLoading
    };
}
exports.default = useUserSession;

},{"react":"6uln9","react-router":"i3TiW","../config/navigationalRoutes":"32s8M","../utils/window":"4IKui","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Nt2u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAuthorizedPage", ()=>isAuthorizedPage);
parcelHelpers.export(exports, "shouldRenderHeader", ()=>shouldRenderHeader);
parcelHelpers.export(exports, "hasAccessToAtleastOneTerm", ()=>hasAccessToAtleastOneTerm);
parcelHelpers.export(exports, "isANonSignedInPage", ()=>isANonSignedInPage);
var _reactRouter = require("react-router");
var _nonSignedInPageRoutes = require("../config/nonSignedInPageRoutes");
var _nonSignedInPageRoutesDefault = parcelHelpers.interopDefault(_nonSignedInPageRoutes);
const isAuthorizedPage = (pathname)=>(0, _nonSignedInPageRoutes.authorizedPages).some((path)=>{
        const match = (0, _reactRouter.matchPath)(pathname, {
            path
        });
        return match?.path === path || pathname.includes(path);
    });
const shouldRenderHeader = (pathname)=>(0, _nonSignedInPageRoutes.pagesWithLpHeader).some((path)=>{
        const match = (0, _reactRouter.matchPath)(pathname, {
            path
        });
        return match?.path === path || pathname?.includes(path);
    });
const hasAccessToAtleastOneTerm = (authorizedEntities)=>{
    const terms = Object.keys(authorizedEntities);
    return terms.length > 1;
};
const isANonSignedInPage = (pathname)=>pathname === "/" ? true : (0, _nonSignedInPageRoutesDefault.default).some((path)=>pathname.includes(path));

},{"react-router":"i3TiW","../config/nonSignedInPageRoutes":"6YOyO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YOyO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonSignedInPageRoutes", ()=>nonSignedInPageRoutes);
parcelHelpers.export(exports, "showUnAuthorizedAlert", ()=>showUnAuthorizedAlert);
parcelHelpers.export(exports, "authorizedPages", ()=>authorizedPages);
parcelHelpers.export(exports, "exceptedAuthorizedPages", ()=>exceptedAuthorizedPages);
parcelHelpers.export(exports, "pagesWithLpHeader", ()=>pagesWithLpHeader);
var _termUtils = require("../utils/termUtils");
var _env = require("./env");
var _navigationalRoutes = require("./navigationalRoutes");
const nonSignedInPageRoutes = [
    "faq",
    "terms",
    "get-started",
    "privacy-notice"
];
const showUnAuthorizedAlert = [
    (0, _navigationalRoutes.LANDING_PAGE),
    (0, _navigationalRoutes.PROFILE_PAGE)
];
const authorizedPages = (0, _env.isLocal)() ? [
    "/account",
    ...(0, _termUtils.termPaths)
] : [
    "/account",
    (0, _navigationalRoutes.CASE_MANAGEMENT_PATH),
    (0, _navigationalRoutes.NPC_PATH),
    (0, _navigationalRoutes.PERFORMANCE_INSIGHTS_PATH),
    (0, _navigationalRoutes.REPORTS_SHARING_PATH),
    (0, _navigationalRoutes.PERFORMANCE_DASHBOARD_PATH),
    ...(0, _termUtils.termPaths)
];
const exceptedAuthorizedPages = [
    "/permission/denied",
    "/account",
    (0, _navigationalRoutes.CASE_MANAGEMENT_PATH),
    (0, _navigationalRoutes.REPORTS_SHARING_PATH)
];
const pagesWithLpHeader = [
    (0, _navigationalRoutes.ACCOUNTS_PATH),
    (0, _navigationalRoutes.PARTNER_PICKER_PATH),
    (0, _navigationalRoutes.CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH),
    (0, _navigationalRoutes.NPC_PATH),
    (0, _navigationalRoutes.CASE_MANAGEMENT_PATH),
    (0, _navigationalRoutes.PERFORMANCE_INSIGHTS_PATH),
    (0, _navigationalRoutes.REPORTS_SHARING_PATH),
    (0, _navigationalRoutes.PERFORMANCE_DASHBOARD_PATH)
];
// Todo : reuse the LpHeader on all the term pages
exports.default = nonSignedInPageRoutes;

},{"../utils/termUtils":"1xYQM","./env":"318XE","./navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xYQM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "termPaths", ()=>termPaths);
parcelHelpers.export(exports, "termNames", ()=>termNames);
var _sideMenuNavItems = require("../config/sideMenuNavItems");
const termPaths = (0, _sideMenuNavItems.sideNavItemsExternal).reduce((acc, { link })=>{
    acc.push(link);
    return acc;
}, []);
const termNames = (0, _sideMenuNavItems.sideNavItemsExternal).reduce((acc, { label })=>{
    acc.push(label);
    return acc;
}, []);

},{"../config/sideMenuNavItems":"cekZL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iYac6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _blueDark = require("@amzn/meridian-tokens/theme/blue-dark");
var _blueDarkDefault = parcelHelpers.interopDefault(_blueDark);
var _responsive = require("@amzn/meridian/responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _sideMenu = require("@amzn/meridian/side-menu");
var _sideMenuDefault = parcelHelpers.interopDefault(_sideMenu);
var _theme = require("@amzn/meridian/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _transReportsCenterProvider = require("@amzn/trans-reports-center-ui-assets/dist/TransReportsCenterProvider");
var _transReportsCenterProviderDefault = parcelHelpers.interopDefault(_transReportsCenterProvider);
var _useSideNavMenuItems = require("@amzn/trans-reports-center-ui-assets/dist/hooks/useSideNavMenuItems");
var _useSideNavMenuItemsDefault = parcelHelpers.interopDefault(_useSideNavMenuItems);
var _lodash = require("lodash");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sideNavSupport = require("../components/SideNavSupport");
var _sideNavSupportDefault = parcelHelpers.interopDefault(_sideNavSupport);
var _lpDropdown = require("../components/molecules/LpDropdown");
var _lpDropdownDefault = parcelHelpers.interopDefault(_lpDropdown);
var _analytics1 = require("../constants/analytics");
var _useSideNavItems = require("../hooks/useSideNavItems");
var _useSideNavItemsDefault = parcelHelpers.interopDefault(_useSideNavItems);
var _authorizedPageUtils = require("../utils/authorizedPageUtils");
var _languageToggleModule = require("./LanguageToggleModule");
var _languageToggleModuleDefault = parcelHelpers.interopDefault(_languageToggleModule);
const SideNavMenu = ({ isMenuOpened, onClose })=>{
    const { pathname = "" } = (0, _reactRouterDom.useLocation)();
    const sideNavItems = (0, _useSideNavItemsDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const handleRouting = (item)=>{
        history.push(item.link);
    };
    const [expandParentTab, setExpandParentTab] = (0, _react.useState)(null);
    const { sideMenuNavItems: transReportsCenterSideNavMenuItems } = (0, _useSideNavMenuItemsDefault.default)();
    const isNonSignedInPage = (0, _authorizedPageUtils.isANonSignedInPage)(pathname);
    const handleItemClick = (item)=>{
        if (item.children) setExpandParentTab(expandParentTab === item.link ? null : item.link);
        else handleRouting(item);
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.SIDE_NAV_MENU_BUTTON)
            },
            extra_properties: {
                name: item.link
            }
        });
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveDefault.default), {
        query: "min-width",
        props: {
            isSmallScreen: {
                default: true,
                [(0, _breakpoints.DEVICE_WIDTHS).DESKTOP]: false
            }
        }
    }, ({ isSmallScreen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _themeDefault.default), {
            tokens: (0, _blueDarkDefault.default)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenuDefault.default), {
            open: isMenuOpened,
            closeLabel: "Close",
            onClose: onClose,
            width: "15rem"
        }, isSmallScreen && (0, _authorizedPageUtils.isAuthorizedPage)(pathname) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
            key: "lp-dropdown",
            onClick: (0, _lodash.noop)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _lpDropdownDefault.default), null)), [
            ...sideNavItems,
            ...transReportsCenterSideNavMenuItems
        ].map((item)=>{
            if (item.isDisabled) return null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
                key: item.link,
                selected: pathname.includes(item.link),
                open: expandParentTab === item.link,
                onClick: ()=>handleItemClick(item),
                disabled: !item.isAuthorized
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), null, item.label)), item.children && item.childNodes.map((child)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
                    key: child.link,
                    selected: pathname.includes(child.link),
                    onClick: ()=>{
                        handleRouting(child);
                    },
                    disabled: !child.isAuthorized
                }, child.label)));
        }), isSmallScreen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _languageToggleModuleDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideNavSupportDefault.default), null))));
};
SideNavMenu.propTypes = {
    isMenuOpened: (0, _propTypesDefault.default).bool.isRequired,
    onClose: (0, _propTypesDefault.default).func.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _transReportsCenterProviderDefault.default)(SideNavMenu));

},{"@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/meridian-tokens/theme/blue-dark":"cJyKg","@amzn/meridian/responsive":"l7U3k","@amzn/meridian/row":"ba4AQ","@amzn/meridian/side-menu":"40yrh","@amzn/meridian/theme":"dJlcb","@amzn/trans-reports-center-ui-assets/dist/TransReportsCenterProvider":"bTdf3","@amzn/trans-reports-center-ui-assets/dist/hooks/useSideNavMenuItems":"gPaS8","lodash":"3hMBK","prop-types":"6FKs7","react":"6uln9","react-router-dom":"5fzqq","../components/SideNavSupport":"6IjqE","../components/molecules/LpDropdown":"2P2ct","../constants/analytics":"zH2LJ","../hooks/useSideNavItems":"hUlio","../utils/authorizedPageUtils":"8Nt2u","./LanguageToggleModule":"gkJqv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJyKg":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    themeForegroundPrimaryDefault: "#FFFFFF",
    themeForegroundPrimaryFocus: "#7CCEE9",
    themeForegroundPrimaryError: "#FF7494",
    themeForegroundPrimaryDisabled: "#6C7778",
    themeForegroundSecondaryDefault: "#BBC0C1",
    themeForegroundSecondaryDisabled: "#485050",
    themeForegroundTertiaryDefault: "#949C9C",
    themeForegroundTertiaryHover: "#BBC0C1",
    themeForegroundTertiaryPressed: "#E7E9E9",
    themeForegroundTertiaryDisabled: "#5B5F5F",
    themeForegroundInvertedDefault: "#232F3E",
    themeForegroundAccentDefault: "#47C2EC",
    themeForegroundAccentHover: "#7CCEE9",
    themeForegroundAccentPressed: "#B9E8F7",
    themeForegroundAccentDisabled: "#204B5A",
    themeBorderPrimaryDefault: "#E7E9E9",
    themeBorderPrimaryDisabled: "#485050",
    themeBorderPrimaryFocus: "#077398",
    themeBorderPrimaryError: "#FF7494",
    themeBorderPrimaryWarning: "#FEF2B8",
    themeBorderSecondaryDefault: "#6C7778",
    themeBorderSecondaryFocus: "#00A8E1",
    themeBorderTertiaryDefault: "#485050",
    themeBorderAlternateDefault: "#6C7778",
    themeBorderAccentDefault: "#00A8E1",
    themeBorderAccentHover: "#47C2EC",
    themeBorderAccentPressed: "#7CCEE9",
    themeBorderAccentDisabled: "#24586A",
    themeBorderAccentPreselected: "#055D7B",
    themeBorderAlternateAccentDefault: "#00A8E1",
    themeBackgroundPrimaryDefault: "#0B0C0C",
    themeBackgroundPrimaryDisabled: "#252829",
    themeBackgroundSecondaryDefault: "#252829",
    themeBackgroundSecondaryError: "#AD0A30",
    themeBackgroundSecondaryWarning: "#FAD000",
    themeBackgroundTertiaryDefault: "#485050",
    themeBackgroundTertiaryHover: "#6C7778",
    themeBackgroundTertiaryPressed: "#949C9C",
    themeBackgroundTertiaryDisabled: "#323838",
    themeBackgroundAlternatePrimaryDefault: "#252829",
    themeBackgroundAlternatePrimarySelected: "#485050",
    themeBackgroundAlternatePrimaryHover: "#6C7778",
    themeBackgroundAlternatePrimaryPressed: "#949C9C",
    themeBackgroundAlternateSecondaryDefault: "#0B0C0C",
    themeBackgroundAlternateTertiaryDefault: "#485050",
    themeBackgroundAlternateTertiaryFocus: "#252829",
    themeBackgroundAccentDefault: "#055D7B",
    themeBackgroundAccentDisabled: "#14181D",
    themeBackgroundInvertedDefault: "#FFFFFF",
    themeBackgroundOverlayDefault: "rgba(108, 119, 120, 0.5)",
    themeBackgroundOverlayPressed: "rgba(255, 255, 255, 0.16)",
    themePalette50: "#E5F6FB",
    themePalette100: "#B9E8F7",
    themePalette200: "#7CCEE9",
    themePalette300: "#47C2EC",
    themePalette400: "#00A8E1",
    themePalette500: "#077398",
    themePalette600: "#055D7B",
    themePalette700: "#03384B",
    themePalette800: "#01222D",
    themePaletteMuted100: "#C1DEE8",
    themePaletteMuted200: "#90C5D7",
    themePaletteMuted300: "#86A4AF",
    themePaletteMuted400: "#204B5A",
    themePaletteMuted500: "#24586A",
    themePaletteMuted600: "#14181D",
    _themeColorScaleCategorical: [
        "#36C2B4",
        "#EB64D7",
        "#FF8F00",
        "#8169F8",
        "#FCC201",
        "#FF5A94",
        "#708090"
    ],
    _themeColorScaleComparison: [
        "#47B120",
        "#EE5A46"
    ],
    _themeColorScaleViolet: [
        "#3E36BB",
        "#614FD9",
        "#8169F8",
        "#A588FF",
        "#C9A8FF",
        "#DDC8FF"
    ],
    _themeColorScalePurple: [
        "#8C297D",
        "#C54FB4",
        "#EB64D7",
        "#EC88DC",
        "#ECA8E0",
        "#E9C6E4"
    ],
    _themeColorScalePink: [
        "#BA1750",
        "#DC3C71",
        "#FF5A94",
        "#FF8CAF",
        "#FFB5CA",
        "#FFDBE5"
    ],
    _themeColorScaleTangerine: [
        "#A45C0A",
        "#D4780C",
        "#FF8F00",
        "#FFAE5D",
        "#FFCB96",
        "#FFE5CB"
    ],
    _themeColorScaleGold: [
        "#BF8E00",
        "#DAA500",
        "#FCC201",
        "#FFDB86",
        "#FFE8B1",
        "#FFF4D9"
    ],
    _themeColorScaleTurquoise: [
        "#1B5F5B",
        "#227D74",
        "#2C9F93",
        "#36C2B4",
        "#78D9CF",
        "#C3E9E7"
    ],
    _themeColorScaleForest: [
        "#005C00",
        "#348118",
        "#47B120",
        "#7EC55E",
        "#ABD994",
        "#D6ECC9"
    ],
    _themeColorScaleCrimson: [
        "#AF1F18",
        "#DE1B1B",
        "#EE5A46",
        "#F98771",
        "#FFB09F",
        "#FFD9CF"
    ],
    _themeColorScaleSlate: [
        "#434C54",
        "#596571",
        "#708090",
        "#929EAB",
        "#B6BDC6",
        "#DADEE2"
    ],
    _themeColorScaleDiverging: [
        "#2C9F93",
        "#36C2B4",
        "#78D9CF",
        "#C3E9E7",
        "#FFF4D9",
        "#FFE8B1",
        "#FFDB86",
        "#FCC201"
    ],
    _themeColorScaleDivergingWithMiddle: [
        "#C54FB4",
        "#EB64D7",
        "#EC88DC",
        "#ECA8E0",
        "#FFF4D9",
        "#78D9CF",
        "#36C2B4",
        "#2C9F93",
        "#227D74"
    ]
};

},{}],"40yrh":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6020b3648d5a7d35");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SideMenuTitle", {
    enumerable: true,
    get: function get() {
        return _sideMenuTitle["default"];
    }
});
Object.defineProperty(exports, "SideMenuLink", {
    enumerable: true,
    get: function get() {
        return _sideMenuLink["default"];
    }
});
Object.defineProperty(exports, "SideMenuSpacer", {
    enumerable: true,
    get: function get() {
        return _sideMenuSpacer["default"];
    }
});
exports["default"] = void 0;
var _sideMenu = _interopRequireDefault(require("c04a6c2f1e740c90"));
var _sideMenuTitle = _interopRequireDefault(require("5cd8ec217326541"));
var _sideMenuLink = _interopRequireDefault(require("8f675aa66082e617"));
var _sideMenuSpacer = _interopRequireDefault(require("69509f31a314431e"));
var _default = _sideMenu["default"];
exports["default"] = _default;

},{"6020b3648d5a7d35":"5qxSW","c04a6c2f1e740c90":"4PWN1","5cd8ec217326541":"en45R","8f675aa66082e617":"aXkQO","69509f31a314431e":"9VX9y"}],"4PWN1":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("7968b699dc44d39a");
var _interopRequireDefault = require("214a347dfb182add");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("420743cea470ab11"));
var _react = _interopRequireWildcard(require("1de4a4c6d24bccdc"));
var _propTypes = _interopRequireDefault(require("71df9a93e57115cf"));
var _emotion = require("bd90ca55f8bc286");
var _uniqueId = _interopRequireDefault(require("3d4eab9888cc5aa8"));
var _sideMenu = _interopRequireDefault(require("d18d741cd7813b64"));
var _close = _interopRequireDefault(require("94e4bb718e4277d0"));
var _menu = _interopRequireDefault(require("f86e0c8196bf4608"));
var _context = require("f554b35b32d4bb00");
var _sideMenuLink = _interopRequireDefault(require("95ca2f12fcceba76"));
var _sideMenuTitle = _interopRequireDefault(require("5c8b1e68f0f20af6"));
var _sideMenuSpacer = _interopRequireDefault(require("11a6a838fcf4f102"));
var _sheet = _interopRequireDefault(require("f6aa1fca8d2ff234"));
var _row = _interopRequireDefault(require("81d7575549eae83e"));
var _button = _interopRequireDefault(require("23d30efcd3261c3b"));
var _icon = _interopRequireDefault(require("67031fe2db159be7"));
var _theme = require("f0b6170440174da6");
var _listReset = _interopRequireDefault(require("804f486970555184"));
var _text = _interopRequireDefault(require("ce14e4802901ebe3"));
var _isElementOf = _interopRequireDefault(require("9ad6fe7929e775b2"));
var _isElementOfAny = _interopRequireDefault(require("e0206bed5c2f992e"));
var SKINNY_COLLAPSED_WIDTH = 64;
var navStyles = function navStyles(t, _ref) {
    var width = _ref.width, minWidth = _ref.minWidth, maxWidth = _ref.maxWidth;
    return (0, _emotion.css)((0, _text["default"])(t), {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth,
        // HACK: Safari randomly fails to paint the nav unless you add this...
        transform: "translateZ(0)"
    });
};
var headerStyles = (0, _emotion.css)({
    flexShrink: 0
});
var bodyStyles = function bodyStyles(_ref2) {
    var useSkinnyBar = _ref2.useSkinnyBar;
    return (0, _emotion.css)(_listReset["default"], {
        alignSelf: useSkinnyBar ? "flex-end" : undefined,
        width: useSkinnyBar ? SKINNY_COLLAPSED_WIDTH : undefined,
        overflow: useSkinnyBar ? "hidden" : undefined,
        flex: "auto"
    });
};
var footerStyles = function footerStyles(t) {
    return (0, _emotion.css)({
        flexShrink: 0,
        padding: t("footerSpacingInset")
    });
};
var titleWrapperStyles = function titleWrapperStyles(_ref3) {
    var useSkinnyBar = _ref3.useSkinnyBar;
    return (0, _emotion.css)({
        visibility: useSkinnyBar ? "hidden" : undefined
    });
};
var sheetStyles = function sheetStyles(t) {
    return (0, _emotion.css)({
        zIndex: t("elevation")
    });
}; // Gets the state ("open" or "close") for the side menu button
// as well as if it should show or not.
var getButtonState = function getButtonState(_ref4) {
    var open = _ref4.open, onOpen = _ref4.onOpen, onClose = _ref4.onClose;
    var onlyClose = onClose && !onOpen;
    var onlyOpen = onOpen && !onClose;
    var state = onlyClose ? "close" : onlyOpen ? "open" : open ? "close" : "open";
    var show = onlyOpen || onlyClose || open ? onClose : onOpen;
    return [
        state,
        show
    ];
};
/* eslint-disable react/prop-types */ var SideMenuButton = function SideMenuButton(_ref5) {
    var open = _ref5.open, onOpen = _ref5.onOpen, onClose = _ref5.onClose, t = _ref5.t, openLabel = _ref5.openLabel, closeLabel = _ref5.closeLabel;
    var _getButtonState = getButtonState({
        open: open,
        onOpen: onOpen,
        onClose: onClose
    }), _getButtonState2 = (0, _slicedToArray2["default"])(_getButtonState, 2), state = _getButtonState2[0], show = _getButtonState2[1];
    var _ref6 = state === "close" ? [
        _close["default"],
        onClose,
        closeLabel
    ] : [
        _menu["default"],
        onOpen,
        openLabel
    ], _ref7 = (0, _slicedToArray2["default"])(_ref6, 3), iconTokens = _ref7[0], onClick = _ref7[1], label = _ref7[2];
    return show ? /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: "icon",
        onClick: onClick,
        size: "small",
        backdropColor: t("backgroundColor"),
        label: label
    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: iconTokens
    })) : null;
};
/* eslint-enable react/prop-types */ /**
 * This component can be used to render a side navigation bar for your
 * application.
 */ var SideMenu = function SideMenu(props) {
    var t = (0, _theme.useTheme)(_sideMenu["default"], "sideMenu");
    var id = (0, _react.useMemo)(function() {
        return (0, _uniqueId["default"])("side-menu-");
    }, []);
    var isTitle = (0, _react.useMemo)(function() {
        return (0, _isElementOf["default"])(props.titleComponent);
    }, [
        props.titleComponent
    ]);
    var isLink = (0, _react.useMemo)(function() {
        return (0, _isElementOfAny["default"])(props.linkComponents);
    }, [
        props.linkComponents
    ]);
    var isSpacer = (0, _react.useMemo)(function() {
        return (0, _isElementOf["default"])(_sideMenuSpacer["default"]);
    }, []);
    var type = props.type;
    /**
   * Extracts all of the links and spacer components from a children object and returns them
   * as an array.
   */ var getLinksWithSpacers = function getLinksWithSpacers(children, requireIcon) {
        return _react["default"].Children.toArray(children).filter(function(child) {
            // If we are requiring links to use an icon, filter out links that
            // don't have `collapsedIcon` a prop set.
            // TODO: deprecate collapsedIcon in 6.0
            var validLink = requireIcon ? child.props.collapsedIcon || child.props.icon : true;
            return isLink(child) && validLink || isSpacer(child);
        });
    };
    return /*#__PURE__*/ _react["default"].createElement(_sheet["default"], {
        open: props.open,
        type: props.type === "overlay" ? "overlay" : "push",
        side: "left",
        closedSize: type === "skinny" ? SKINNY_COLLAPSED_WIDTH : 0,
        backgroundColor: t("backgroundColor"),
        motionDuration: parseInt(t("motionExpandDuration")),
        motionFunction: t("motionExpandFunction"),
        className: sheetStyles(t),
        spacingInset: "none",
        onClose: props.onClose
    }, function(_ref8) {
        var expanderState = _ref8.expanderState;
        var useSkinnyBar = expanderState === "exited" && type === "skinny"; // Pull out the title and footer children
        var childrenArray = _react["default"].Children.toArray(props.children);
        var title = childrenArray.filter(isTitle)[0] || /*#__PURE__*/ _react["default"].createElement("span", null);
        var footerChildren = childrenArray.filter(function(child) {
            return !isTitle(child) && !isLink(child) && !isSpacer(child);
        }); // Pull out all the link children with spacers.
        var linksWithSpacers = getLinksWithSpacers(props.children, useSkinnyBar).map(function(child) {
            return isLink(child) ? /*#__PURE__*/ _react["default"].cloneElement(child, {
                linkComponents: child.props.linkComponents || props.linkComponents
            }) : child;
        }); // This is true if the side menu's links contain more links nested inside
        // of them. When we are using icon labels, however, always use false.
        var withGrandchildren = useSkinnyBar ? false : linksWithSpacers.filter(function(link) {
            return getLinksWithSpacers(link.props.children).length > 0;
        }).length > 0;
        return /*#__PURE__*/ _react["default"].createElement(_context.Provider, {
            value: {
                siblingsWithChildren: withGrandchildren,
                useIconLabel: useSkinnyBar,
                sideMenuOpen: props.open,
                id: id,
                t: t
            }
        }, /*#__PURE__*/ _react["default"].createElement("nav", {
            className: navStyles(t, props),
            "aria-labelledby": "".concat(id, "-title")
        }, /*#__PURE__*/ _react["default"].createElement(_row["default"], {
            spacingInset: "medium",
            spacing: "medium",
            alignmentVertical: "top",
            alignmentHorizontal: "justify",
            className: headerStyles
        }, /*#__PURE__*/ _react["default"].createElement("div", {
            className: titleWrapperStyles({
                useSkinnyBar: useSkinnyBar
            })
        }, title), /*#__PURE__*/ _react["default"].createElement(SideMenuButton, {
            t: t,
            open: props.open,
            onOpen: props.onOpen,
            onClose: props.onClose,
            openLabel: props.openLabel,
            closeLabel: props.closeLabel
        })), /*#__PURE__*/ _react["default"].createElement("ul", {
            className: bodyStyles({
                useSkinnyBar: useSkinnyBar
            }),
            role: "tree"
        }, linksWithSpacers), useSkinnyBar ? null : /*#__PURE__*/ _react["default"].createElement("div", {
            className: footerStyles(t)
        }, footerChildren)));
    });
};
SideMenu.propTypes = {};
SideMenu.defaultProps = {
    open: true,
    closeLabel: "Close",
    openLabel: "Open",
    titleComponent: _sideMenuTitle["default"],
    linkComponents: [
        _sideMenuLink["default"]
    ],
    maxWidth: 340,
    type: "default"
};
var _default = SideMenu;
exports["default"] = _default;

},{"7968b699dc44d39a":"4RXTR","214a347dfb182add":"5qxSW","420743cea470ab11":"4QArz","1de4a4c6d24bccdc":"6uln9","71df9a93e57115cf":"9Mqtv","bd90ca55f8bc286":"1BAMo","3d4eab9888cc5aa8":"4Lekm","d18d741cd7813b64":"rfifq","94e4bb718e4277d0":"2AQYC","f86e0c8196bf4608":"8Kse9","f554b35b32d4bb00":"fZ3zG","95ca2f12fcceba76":"aXkQO","5c8b1e68f0f20af6":"en45R","11a6a838fcf4f102":"9VX9y","f6aa1fca8d2ff234":"7qDip","81d7575549eae83e":"ba4AQ","23d30efcd3261c3b":"k0QSK","67031fe2db159be7":"8MgRY","f0b6170440174da6":"dJlcb","804f486970555184":"3Ja6h","ce14e4802901ebe3":"g6RQX","9ad6fe7929e775b2":"i2KEV","e0206bed5c2f992e":"bFGvy"}],"rfifq":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        sideMenuElevation: 50,
        sideMenuBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
        sideMenuFooterSpacingInset: 24,
        sideMenuMotionExpandDuration: "300ms",
        sideMenuMotionExpandFunction: "ease",
        sideMenuMotionInteractDuration: "100ms",
        sideMenuMotionInteractFunction: "ease",
        sideMenuLinkForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
        sideMenuLinkForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
        sideMenuLinkBackgroundColorDefault: "rgba(0, 0, 0, 0)",
        sideMenuLinkBackgroundColorSelected: tokens.themeBackgroundAlternatePrimarySelected,
        sideMenuLinkBackgroundColorHover: tokens.themeBackgroundAlternatePrimaryHover,
        sideMenuLinkBackgroundColorPressed: tokens.themeBackgroundAlternatePrimaryPressed,
        sideMenuLinkIndicatorColor: tokens.themeBorderAccentDefault,
        sideMenuLinkIndicatorColorDefault: "rgba(0, 0, 0, 0)",
        sideMenuLinkIndicatorColorPressed: tokens.themeBorderAccentPressed,
        sideMenuLinkIndicatorColorSelected: tokens.themeBorderAccentDefault,
        sideMenuLinkIndicatorWidth: 4,
        sideMenuLinkIndicatorSpacing: 4,
        sideMenuLinkIndicatorBorderRadius: 999,
        sideMenuLinkSpacingHorizontal: 8,
        sideMenuLinkSpacingInsetVertical: 8,
        sideMenuLinkSpacingInsetHorizontal: 24,
        sideMenuBorderWidth: 1,
        sideMenuBorderRadius: 0,
        sideMenuBorderColor: tokens.themeBorderSecondaryDefault,
        sideMenuSpacerHeight: 32
    };
};

},{}],"8Kse9":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconMenuData: "data:image/svg+xml,%3csvg width='16' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round'%3e%3cpath d='M1 7h13.95M1 13h13.95M1 1h13.95'/%3e%3c/g%3e%3c/svg%3e",
    iconMenuWidth: 16,
    iconMenuHeight: 14
};

},{}],"fZ3zG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Consumer = exports.Provider = void 0;
var _react = require("c54a2c9390824cbe");
var _createContext = /*#__PURE__*/ (0, _react.createContext)({}), Provider = _createContext.Provider, Consumer = _createContext.Consumer;
exports.Consumer = Consumer;
exports.Provider = Provider;

},{"c54a2c9390824cbe":"6uln9"}],"aXkQO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a05327fff7b4e740");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("f5d1a7ec0429fd45"));
var _classCallCheck2 = _interopRequireDefault(require("e141d9dc4219f8d1"));
var _createClass2 = _interopRequireDefault(require("a67fe334f28b40d7"));
var _assertThisInitialized2 = _interopRequireDefault(require("d17d3c1e3167ee5c"));
var _inherits2 = _interopRequireDefault(require("7e391c56d2d4cbde"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("bc83a25d9e6072be"));
var _getPrototypeOf2 = _interopRequireDefault(require("737876565679e3b7"));
var _defineProperty2 = _interopRequireDefault(require("754e50d575c36bc1"));
var _react = _interopRequireDefault(require("3b03d2853d0b3d0d"));
var _propTypes = _interopRequireDefault(require("9204f32dbbe2a802"));
var _emotion = require("2cacb4a990cb6129");
var _uniqueId = _interopRequireDefault(require("3ee3093b8efde72d"));
var _chevronRightSmall = _interopRequireDefault(require("385674094535fdb9"));
var _context = require("dd9f45d87aba4ba9");
var _focus = _interopRequireDefault(require("adaf7cf61c4edafa"));
var _clickable = _interopRequireDefault(require("a239a044861950a6"));
var _icon = _interopRequireDefault(require("9870572fe43fb7a3"));
var _row = _interopRequireDefault(require("ae7f4232c1f86852"));
var _sideMenuSpacer = _interopRequireDefault(require("d099ace38de90626"));
var _expanderController = _interopRequireDefault(require("4015427b8a983859"));
var _token = require("4c91ec500a467698");
var _isElementOfAny = _interopRequireDefault(require("8949ceabf34adb0d"));
var _isElementOf = _interopRequireDefault(require("7eda9484bdefa9e5"));
var _focusRing = _interopRequireDefault(require("4a4baec609cd59e5"));
var _listReset = _interopRequireDefault(require("7b3bafa9d10eb0ca"));
var _text = _interopRequireDefault(require("452014c53509e735"));
var _filterPropsByPrefix = _interopRequireDefault(require("ee738f10fb15b208"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var focus = _ref.focus, selected = _ref.selected, disabled = _ref.disabled;
    return (0, _emotion.css)({
        display: "block",
        boxSizing: "border-box",
        minHeight: "".concat(parseInt(t("linkSpacingInsetVertical")) * 2 + parseInt((0, _text["default"])(t).lineHeight.split("px")[0]), "px"),
        width: "100%",
        color: t("linkForegroundColor", disabled ? "disabled" : "default"),
        backgroundColor: t("linkBackgroundColor", selected ? "selected" : "default"),
        transition: t.transitionCss("motionInteract", "background-color"),
        ":hover": !disabled ? {
            backgroundColor: t("linkBackgroundColorHover")
        } : undefined,
        ":active": !disabled ? {
            backgroundColor: t("linkBackgroundColorPressed")
        } : undefined
    }, (0, _focusRing["default"])(t.tokens, {
        offset: 0,
        focus: focus
    }));
}, [
    "focus",
    "selected",
    "disabled"
]);
var contentStyles = (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box"
});
var indicatorStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var selected = _ref2.selected;
    return (0, _emotion.css)({
        flexShrink: 0,
        margin: t("linkIndicatorSpacing"),
        width: t("linkIndicatorWidth"),
        alignSelf: "stretch",
        backgroundColor: selected ? t("linkIndicatorColor") : "transparent",
        borderRadius: t("linkIndicatorBorderRadius"),
        transition: t.transitionCss("motionInteract", "background-color")
    });
}, [
    "selected"
]);
var spacerStyles = (0, _token.memoizeTokenStyles)(function(t, _ref3) {
    var depth = _ref3.depth, siblingsWithChildren = _ref3.siblingsWithChildren, open = _ref3.open, useIconLabel = _ref3.useIconLabel;
    var insetSpacing = t("linkSpacingInsetHorizontal");
    var indicatorWidth = t("linkIndicatorWidth") + t("linkIndicatorSpacing") * 2;
    return (0, _emotion.css)({
        minWidth: useIconLabel ? 8 // magic number based off the ol' 👀
         : siblingsWithChildren ? insetSpacing : insetSpacing - indicatorWidth,
        marginLeft: depth > 0 ? (depth + 1) * insetSpacing : 0,
        transform: open ? "rotate(90deg)" : "rogate(0deg)",
        transition: t.transitionCss("motionExpand", "transform")
    });
}, [
    "depth",
    "siblingsWithChildren",
    "open",
    "useIconLabel"
]);
var iconLabelMountAnimation = (0, _emotion.keyframes)({
    from: {
        transform: "translateX(-100%)"
    },
    to: {
        transform: "translateX(0%)"
    }
});
var labelStyles = (0, _token.memoizeTokenStyles)(function(t, _ref4) {
    var siblingsWithChildren = _ref4.siblingsWithChildren, _ref4$animate = _ref4.animate, animate = _ref4$animate === void 0 ? false : _ref4$animate;
    return (0, _emotion.css)({
        paddingTop: t("linkSpacingInsetVertical"),
        paddingRight: t("linkSpacingInsetHorizontal"),
        paddingBottom: t("linkSpacingInsetVertical"),
        paddingLeft: siblingsWithChildren ? t("linkSpacingHorizontal") : 0,
        // TODO: put animation duration in its own token
        animation: animate ? "".concat(iconLabelMountAnimation, " 100ms") : undefined
    });
}, [
    "siblingsWithChildren",
    "animate"
]);
/**
 * This component can be used to render a navigational link. Place this as a
 * child of the SideMenu component.
 */ var SideMenuLink = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SideMenuLink, _React$Component);
    var _super = _createSuper(SideMenuLink);
    function SideMenuLink() {
        var _this;
        (0, _classCallCheck2["default"])(this, SideMenuLink);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("side-menu-link-"));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isLink", (0, _isElementOfAny["default"])(_this.props.linkComponents));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isSpacer", (0, _isElementOf["default"])(_sideMenuSpacer["default"]));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLinksWithSpacers", function(children) {
            return _react["default"].Children.toArray(children).filter(function(child) {
                return _this.isLink(child) || _this.isSpacer(child);
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(SideMenuLink, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var icon = props.icon;
                var id = this.id;
                var label = _react["default"].Children.toArray(props.children).filter(function(element) {
                    return !_this2.isLink(element) && !_this2.isSpacer(element);
                });
                var children = this.getLinksWithSpacers(props.children);
                var withChildren = children.length > 0; // This is true if the children object contains any links that have more
                // links nested inside of them.
                var withGrandchildren = children.filter(function(link) {
                    return _this2.getLinksWithSpacers(link.props.children).length > 0;
                }).length > 0;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_context.Consumer, null, function(_ref5) {
                    var t = _ref5.t, siblingsWithChildren = _ref5.siblingsWithChildren, useIconLabel = _ref5.useIconLabel, _ref5$depth = _ref5.depth, depth = _ref5$depth === void 0 ? 0 : _ref5$depth;
                    return /*#__PURE__*/ _react["default"].createElement(_focus["default"], null, function(_ref6) {
                        var focus = _ref6.focus, focusProps = _ref6.focusProps, focusTrigger = _ref6.focusTrigger;
                        return /*#__PURE__*/ _react["default"].createElement("li", {
                            role: "treeitem",
                            "aria-current": props.selected ? "page" : undefined,
                            "aria-level": depth + 1,
                            "aria-selected": focus,
                            "aria-expanded": withChildren && props.open,
                            "aria-controls": "".concat(id, "-links")
                        }, /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
                            className: styles(t, {
                                focus: focus && focusTrigger === "keyboard",
                                selected: props.selected,
                                disabled: props.disabled
                            }),
                            href: props.href,
                            onClick: props.onClick,
                            disabled: props.disabled,
                            target: props.target,
                            rel: props.rel
                        }), /*#__PURE__*/ _react["default"].createElement("div", {
                            className: contentStyles,
                            id: "".concat(id, "-label")
                        }, /*#__PURE__*/ _react["default"].createElement("div", {
                            className: indicatorStyles(t, props)
                        }), withChildren && !useIconLabel ? /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                            tokens: _chevronRightSmall["default"],
                            className: spacerStyles(t, {
                                open: props.open,
                                siblingsWithChildren: siblingsWithChildren,
                                depth: depth
                            })
                        }) : /*#__PURE__*/ _react["default"].createElement("div", {
                            className: spacerStyles(t, {
                                siblingsWithChildren: siblingsWithChildren,
                                depth: depth,
                                useIconLabel: useIconLabel
                            })
                        }), useIconLabel ? /*#__PURE__*/ _react["default"].createElement("span", {
                            className: labelStyles(t, {
                                siblingsWithChildren: siblingsWithChildren,
                                animate: true
                            })
                        }, props.icon ? /*#__PURE__*/ _react["default"].createElement(_row["default"], {
                            widths: [
                                24
                            ]
                        }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                            tokens: icon
                        }, label)) : props.collapsedIcon ? /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                            tokens: props.collapsedIcon
                        }, label) : null) : /*#__PURE__*/ _react["default"].createElement("span", {
                            className: labelStyles(t, {
                                siblingsWithChildren: siblingsWithChildren
                            })
                        }, icon ? /*#__PURE__*/ _react["default"].createElement(_row["default"], {
                            widths: [
                                24,
                                "fill"
                            ]
                        }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                            tokens: icon
                        }), " ", /*#__PURE__*/ _react["default"].createElement("span", null, label)) : label))), withChildren ? /*#__PURE__*/ _react["default"].createElement(_context.Provider, {
                            value: {
                                t: t,
                                siblingsWithChildren: withGrandchildren,
                                depth: depth + 1
                            }
                        }, /*#__PURE__*/ _react["default"].createElement(_expanderController["default"], {
                            open: props.open,
                            direction: "down",
                            motionDuration: parseInt(t("motionExpandDuration")),
                            motionFunction: t("motionExpandFunction"),
                            alwaysRenderChildren: true
                        }, function(_ref7) {
                            var containerProps = _ref7.containerProps, contentProps = _ref7.contentProps;
                            return /*#__PURE__*/ _react["default"].createElement("div", containerProps, /*#__PURE__*/ _react["default"].createElement("ul", (0, _extends2["default"])({}, contentProps, {
                                className: (0, _emotion.cx)((0, _emotion.css)(_listReset["default"]), contentProps.className),
                                role: "group",
                                id: "".concat(id, "-links"),
                                "aria-labelledby": "".concat(id, "-label")
                            }), children));
                        })) : null);
                    });
                });
            }
        }
    ]);
    return SideMenuLink;
}(_react["default"].Component);
SideMenuLink.propTypes = {};
var _default = SideMenuLink;
exports["default"] = _default;

},{"a05327fff7b4e740":"5qxSW","f5d1a7ec0429fd45":"fAmfl","e141d9dc4219f8d1":"aqLjQ","a67fe334f28b40d7":"8X7ov","d17d3c1e3167ee5c":"fA0LA","7e391c56d2d4cbde":"hAMmu","bc83a25d9e6072be":"37tJc","737876565679e3b7":"cE6Se","754e50d575c36bc1":"avcfc","3b03d2853d0b3d0d":"6uln9","9204f32dbbe2a802":"9Mqtv","2cacb4a990cb6129":"1BAMo","3ee3093b8efde72d":"4Lekm","385674094535fdb9":"4EdS9","dd9f45d87aba4ba9":"fZ3zG","adaf7cf61c4edafa":"8iPDd","a239a044861950a6":"iWCwP","9870572fe43fb7a3":"8MgRY","ae7f4232c1f86852":"ba4AQ","d099ace38de90626":"9VX9y","4015427b8a983859":"aETlj","4c91ec500a467698":"bebc4","8949ceabf34adb0d":"bFGvy","7eda9484bdefa9e5":"i2KEV","4a4baec609cd59e5":"5Dvm2","7b3bafa9d10eb0ca":"3Ja6h","452014c53509e735":"g6RQX","ee738f10fb15b208":"7Pq5E"}],"8iPDd":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f7a706662f8b19b3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _focus = _interopRequireDefault(require("71f8b429686c5b9a"));
var _default = _focus["default"];
exports["default"] = _default;

},{"f7a706662f8b19b3":"5qxSW","71f8b429686c5b9a":"jNmbJ"}],"jNmbJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5044391a47a44261");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("19f08d14e9598a76"));
var _useFocus = _interopRequireDefault(require("78c7ba52574aadde"));
/**
 * NOTE: This component is deprecated. Use the useFocus hook instead.
 */ var Focus = function Focus(_ref) {
    var children = _ref.children, disabled = _ref.disabled, multipleTargets = _ref.multipleTargets, onBlur = _ref.onBlur, onFocus = _ref.onFocus;
    var focus = (0, _useFocus["default"])({
        disabled: disabled,
        multipleNodes: multipleTargets,
        onBlur: onBlur,
        onFocus: onFocus
    });
    return children(focus);
};
Focus.displayName = "Focus";
Focus.propTypes = {
    children: _propTypes["default"].func.isRequired,
    /**
   * A bug in React means that onBlur is not called when an element with focus
   * is disabled. This prop allows you to manually inform the Focus component
   * when the element(s) that it manages are disabled so that it can turn off
   * its internal focus state. See: https://github.com/facebook/react/issues/9142
   */ disabled: _propTypes["default"].bool,
    /**
   * Turn this on if you are using this component to track the focus of
   * multiple elements.
   */ multipleTargets: _propTypes["default"].bool,
    /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */ onBlur: _propTypes["default"].func,
    /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */ onFocus: _propTypes["default"].func
};
var _default = Focus;
exports["default"] = _default;

},{"5044391a47a44261":"5qxSW","19f08d14e9598a76":"9Mqtv","78c7ba52574aadde":"7jVM9"}],"9VX9y":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("35348a5fe30798cb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("c4bb75cbbaf0cda6"));
var _emotion = require("92f5a90f5e99aba2");
var _context = require("dc83fc998364a8ca");
var sideMenuSpacerStyles = function sideMenuSpacerStyles(t) {
    return (0, _emotion.css)({
        display: "block",
        width: 0,
        height: t("spacerHeight")
    });
};
/**
 * This component can be used to add spacing between links in a side menu. Place this as a
 * child of the SideMenu component.
 */ var SideMenuSpacer = function SideMenuSpacer() {
    return /*#__PURE__*/ _react["default"].createElement(_context.Consumer, null, function(_ref) {
        var t = _ref.t;
        return /*#__PURE__*/ _react["default"].createElement("div", {
            className: sideMenuSpacerStyles(t)
        });
    });
};
var _default = SideMenuSpacer;
exports["default"] = _default;

},{"35348a5fe30798cb":"5qxSW","c4bb75cbbaf0cda6":"6uln9","92f5a90f5e99aba2":"1BAMo","dc83fc998364a8ca":"fZ3zG"}],"bFGvy":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("978cd382b2d5ef4d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _isElementOf = _interopRequireDefault(require("b0165c374d72cf45"));
/**
 * Determines if an element is an instance of any one component from a list of
 * components.
 */ var isElementOfAny = function isElementOfAny(components) {
    return function(element) {
        return [].concat(components).some(function(component) {
            return (0, _isElementOf["default"])(component)(element);
        });
    };
};
var _default = isElementOfAny;
exports["default"] = _default;

},{"978cd382b2d5ef4d":"5qxSW","b0165c374d72cf45":"i2KEV"}],"en45R":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5a9df404c5d200a2");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("f4aabedb839e1a2e"));
var _classCallCheck2 = _interopRequireDefault(require("22fea1fa35e04cde"));
var _createClass2 = _interopRequireDefault(require("2c2b361c034c99e"));
var _inherits2 = _interopRequireDefault(require("14eb65c95120e0ca"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("57689b5074780c6c"));
var _getPrototypeOf2 = _interopRequireDefault(require("e350ba80e409afec"));
var _react = _interopRequireDefault(require("ef0aebf23fa1339b"));
var _propTypes = _interopRequireDefault(require("43948b81182ab206"));
var _emotion = require("d90dd72abd017591");
var _context = require("d93a111f82a4aae9");
var _focus = _interopRequireDefault(require("9b8ec02189559abc"));
var _clickable = _interopRequireDefault(require("1766ed79999c49f4"));
var _focusRing = _interopRequireDefault(require("3f1d04bb229adc26"));
var _filterPropsByPrefix = _interopRequireDefault(require("c0742239c13027d0"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = function styles(t, _ref) {
    var focus = _ref.focus;
    return (0, _emotion.css)({
        display: "block",
        borderRadius: 4,
        "& img": {
            display: "block"
        }
    }, (0, _focusRing["default"])(t.tokens, {
        offset: 4,
        focus: focus,
        borderRadius: 4
    }));
};
/**
 * This component can be used to render a logo/title lockup. Place this as a
 * child of the SideMenu component.
 */ var SideMenuTitle = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SideMenuTitle, _React$Component);
    var _super = _createSuper(SideMenuTitle);
    function SideMenuTitle() {
        (0, _classCallCheck2["default"])(this, SideMenuTitle);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(SideMenuTitle, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, href = _this$props.href, onClick = _this$props.onClick, children = _this$props.children, rel = _this$props.rel, target = _this$props.target;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_focus["default"], null, function(_ref2) {
                    var focus = _ref2.focus, focusProps = _ref2.focusProps, focusTrigger = _ref2.focusTrigger;
                    return /*#__PURE__*/ _react["default"].createElement(_context.Consumer, null, function(_ref3) {
                        var t = _ref3.t, id = _ref3.id;
                        return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
                            className: styles(t, {
                                focus: focus && focusTrigger === "keyboard"
                            }),
                            id: "".concat(id, "-title"),
                            href: href,
                            onClick: onClick,
                            rel: rel,
                            target: target
                        }), children);
                    });
                });
            }
        }
    ]);
    return SideMenuTitle;
}(_react["default"].Component);
SideMenuTitle.propTypes = {};
var _default = SideMenuTitle;
exports["default"] = _default;

},{"5a9df404c5d200a2":"5qxSW","f4aabedb839e1a2e":"fAmfl","22fea1fa35e04cde":"aqLjQ","2c2b361c034c99e":"8X7ov","14eb65c95120e0ca":"hAMmu","57689b5074780c6c":"37tJc","e350ba80e409afec":"cE6Se","ef0aebf23fa1339b":"6uln9","43948b81182ab206":"9Mqtv","d90dd72abd017591":"1BAMo","d93a111f82a4aae9":"fZ3zG","9b8ec02189559abc":"8iPDd","1766ed79999c49f4":"iWCwP","3f1d04bb229adc26":"5Dvm2","c0742239c13027d0":"7Pq5E"}],"7qDip":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4013aab33f179e47");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _sheet = _interopRequireDefault(require("f8b96e19c21ca507"));
var _default = _sheet["default"];
exports["default"] = _default;

},{"4013aab33f179e47":"5qxSW","f8b96e19c21ca507":"4oHil"}],"4oHil":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("341ce9e84ba9685");
var _interopRequireDefault = require("c85376e240c3c770");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("f8f40dcb96e64c3c"));
var _defineProperty2 = _interopRequireDefault(require("327401a9227bcff"));
var _react = _interopRequireWildcard(require("295836a909382f98"));
var _keycode = _interopRequireDefault(require("79c3eb51a25d361e"));
var _emotion = require("f51f20121dfcb2bf");
var _propTypes = _interopRequireDefault(require("7eef1c7026b32325"));
var _sheet = _interopRequireDefault(require("9371aa2fd19004fa"));
var _scrim = _interopRequireDefault(require("a606cc0e897c49cf"));
var _theme = require("485eb37aee1eb7ff");
var _expanderController = _interopRequireDefault(require("3c6e04638e521f96"));
var _scrim2 = _interopRequireDefault(require("585605f9e221d547"));
var _portal = _interopRequireDefault(require("dffbebf831eea89c"));
var _focusTrap = _interopRequireDefault(require("8ab4463583f12d36"));
var _useFocus2 = _interopRequireDefault(require("4b82c42b3750ce6"));
var _focus = require("f342a75b3e911e89");
var _token = require("c0f2cb281d3f9aa2");
var _parsers = require("a557da6ebb828dc8");
var _filterPropsByPrefix = _interopRequireDefault(require("e3c5de22437213c3"));
var borderSides = {
    left: "borderRight",
    right: "borderLeft",
    bottom: "borderTop"
};
var containerStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var _css;
    var side = _ref.side, spacingInset = _ref.spacingInset, backgroundColor = _ref.backgroundColor;
    return (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, borderSides[side], t.borderCss("border")), (0, _defineProperty2["default"])(_css, "& > div", {
        backgroundColor: backgroundColor,
        padding: "".concat((0, _parsers.parseSpacing)(spacingInset), "px"),
        outline: "none",
        overflowY: "auto",
        boxSizing: "border-box",
        maxHeight: side === "bottom" ? "calc(100vh - ".concat(t("minimumPageReveal"), "px)") : undefined
    }), _css));
}, [
    "side",
    "spacingInset",
    "backgroundColor"
]);
var modalStyles = function modalStyles(tScrim, t, _ref2) {
    var _ref3;
    var side = _ref2.side;
    return (0, _emotion.css)({
        zIndex: tScrim("elevation") - 1,
        position: "fixed",
        boxShadow: "".concat(t("shadowOffset", [
            side,
            "x"
        ]), "px ").concat(t("shadowOffset", [
            side,
            "y"
        ]), "px ").concat(t("shadow", "blur"), "px ").concat(t("shadow", "spread"), "px ").concat(t("shadow", "color"), "}")
    }, side === "bottom" ? {
        bottom: 0,
        left: 0,
        right: 0
    } : (_ref3 = {
        top: 0
    }, (0, _defineProperty2["default"])(_ref3, side, 0), (0, _defineProperty2["default"])(_ref3, "bottom", 0), _ref3));
};
var overlayScrimStyles = function overlayScrimStyles(_ref4) {
    var tScrim = _ref4.tScrim;
    return (0, _emotion.css)({
        zIndex: tScrim("elevation") - 2
    });
}; // Overlay expanders are put into a portal
var OverlayExpanderController = function OverlayExpanderController(props) {
    return /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, /*#__PURE__*/ _react["default"].createElement(_expanderController["default"], props));
};
/**
 * This component renders a sheet that enters/exits on a particular side of
 * the screen. The sheet can appear as a overlay above other components or
 * displace surrounding components.
 *
 * @since 5.x
 */ var Sheet = function Sheet(props) {
    var open = props.open, side = props.side, onClose = props.onClose, spacingInset = props.spacingInset, onOpen = props.onOpen; // Always render children if closed size is set greater than 0 or
    // we're explicitly told via props
    var alwaysRenderChildren = props.closedSize !== undefined && props.closedSize > 0 || props.alwaysRenderChildren; // If we're always visible, force type to be push
    var type = alwaysRenderChildren ? "push" : props.type;
    var t = (0, _theme.useTheme)(_sheet["default"], "sheet");
    var tScrim = (0, _theme.useTheme)(_scrim["default"], "scrim");
    var hasMounted = (0, _react.useRef)(false);
    var contentRef = (0, _react.useRef)(); // DOM node wrapping sheet content
    var anchorRef = (0, _react.useRef)(); // DOM element that originally opened sheet
    var initializeContentRef = (0, _react.useCallback)(function(contentProps) {
        return function(element) {
            contentRef.current = element;
            contentProps.ref(element);
        };
    }, []);
    var backgroundColor = (0, _react.useMemo)(function() {
        return (0, _token.getToken)(t.tokens, "themeBackground", [
            props.backgroundColor,
            "default"
        ]) || props.backgroundColor;
    }, [
        t,
        props.backgroundColor
    ]); // Put "overlay" sheets, which are essentially modals, in an expander that has built
    // in portal and focus trap.
    var Expander = (0, _react.useCallback)(function(props) {
        return /*#__PURE__*/ _react["default"].createElement(type === "overlay" ? OverlayExpanderController : _expanderController["default"], props);
    }, [
        type
    ]); // Put "overlay" sheets, which are essentially modals, in a focus trap
    var SheetWrapper = (0, _react.useCallback)(function(props) {
        return /*#__PURE__*/ _react["default"].createElement(type === "overlay" ? _focusTrap["default"] : _react["default"].Fragment, props);
    }, [
        type
    ]); // Overlay sheets are essentially modals. Here we add an keyboard listener
    // that closes the sheet when the user presses the "esc" key.
    // https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal
    (0, _react.useEffect)(function() {
        if (type === "overlay" && onClose) {
            var onKeyDown = function onKeyDown(e) {
                if ((0, _keycode["default"])(e) === "esc") onClose();
            };
            window.addEventListener("keydown", onKeyDown);
            return function() {
                return window.removeEventListener("keydown", onKeyDown);
            };
        }
    }, [
        type,
        onClose
    ]); // On open, move focus to the first focusable element. On close, move focus
    // back to the original element that opened the sheet.
    var onAfterOpen = (0, _react.useCallback)(function() {
        // Run this effect only after the component has mounted. Else, sheet
        // that load as `open` will immediately take over the active element.
        if (hasMounted.current && contentRef.current) {
            var firstFocusableNode = (0, _focus.getKeyboardFocusNodes)(contentRef.current)[0];
            if (firstFocusableNode) firstFocusableNode.focus();
            else contentRef.current.focus();
        }
    }, []); // On close, return focus to where it was before the bottom sheet was opened.
    var onAfterClose = (0, _react.useCallback)(function() {
        if (anchorRef.current) anchorRef.current.focus();
    }, []); // When opening, record which element opened the sheet
    (0, _react.useEffect)(function() {
        if (open) anchorRef.current = document.activeElement;
        hasMounted.current = true;
    }, [
        open
    ]);
    (0, _react.useEffect)(function() {
        if (open && onOpen) onOpen();
    }, [
        open,
        onOpen
    ]);
    var _useFocus = (0, _useFocus2["default"])({
        multipleNodes: true,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }), focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(Expander, {
        open: open,
        direction: side === "bottom" ? "down" : side,
        motionDuration: props.motionDuration || parseInt(t("motionTiming")),
        motionFunction: props.motionFunction || t("motionFunction"),
        onAfterOpen: onAfterOpen,
        onAfterClose: onAfterClose,
        alwaysRenderChildren: alwaysRenderChildren,
        closedSize: props.closedSize
    }, function(_ref5) {
        var state = _ref5.state, containerProps = _ref5.containerProps, contentProps = _ref5.contentProps;
        // The children of a sheet might be interested in the state of the expander
        // to dynamically hide/show components for various stages. For example, skinny
        // SideMenu shows different links based on the expander state.
        var children = typeof props.children === "function" ? props.children({
            expanderState: state
        }) : props.children;
        return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(SheetWrapper, null, /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
            className: (0, _emotion.cx)(props.className, containerStyles(t, {
                side: side,
                spacingInset: spacingInset,
                backgroundColor: backgroundColor
            }), type === "overlay" ? modalStyles(tScrim, t, {
                side: side
            }) : undefined, containerProps.className)
        }), /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: contentProps.className,
            id: props.id,
            ref: initializeContentRef(contentProps),
            role: type === "overlay" ? "dialog" : undefined,
            "aria-modal": type === "overlay" ? true : undefined,
            tabIndex: "-1",
            "aria-labelledby": props.labelledById,
            "aria-describedby": props.describedById,
            onKeyDown: props.onKeyDown
        }), children))), type === "overlay" ? /*#__PURE__*/ _react["default"].createElement(_scrim2["default"], {
            className: overlayScrimStyles({
                tScrim: tScrim
            }),
            onClick: props.onClose,
            open: state === "entering" || state === "entered",
            duration: t("motionTiming")
        }) : null);
    });
};
Sheet.displayName = "Sheet";
Sheet.propTypes = {};
Sheet.defaultProps = {
    type: "push",
    open: false,
    side: "right",
    spacingInset: "medium",
    backgroundColor: "alternatePrimary"
};
var _default = Sheet;
exports["default"] = _default;

},{"341ce9e84ba9685":"4RXTR","c85376e240c3c770":"5qxSW","f8f40dcb96e64c3c":"fAmfl","327401a9227bcff":"avcfc","295836a909382f98":"6uln9","79c3eb51a25d361e":"4THh2","f51f20121dfcb2bf":"1BAMo","7eef1c7026b32325":"9Mqtv","9371aa2fd19004fa":"gloX6","a606cc0e897c49cf":"i5KEc","485eb37aee1eb7ff":"dJlcb","3c6e04638e521f96":"aETlj","585605f9e221d547":"ftCSx","dffbebf831eea89c":"kr8m8","8ab4463583f12d36":"aDJea","4b82c42b3750ce6":"7jVM9","f342a75b3e911e89":"jzxGB","c0f2cb281d3f9aa2":"bebc4","a557da6ebb828dc8":"iZdRW","e3c5de22437213c3":"7Pq5E"}],"bTdf3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _store = require("./store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var TransReportsCenterProvider = function(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
            store: (0, _storeDefault.default)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, props));
    };
};
exports.default = TransReportsCenterProvider;

},{"react":"6uln9","react-redux":"3qqlL","./store":"yXXeu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"yXXeu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var _reduxObservable = require("redux-observable");
var _reduxLogger = require("redux-logger");
var _reduxLoggerDefault = parcelHelpers.interopDefault(_reduxLogger);
var _rootEpic = require("../epics/rootEpic");
var _rootEpicDefault = parcelHelpers.interopDefault(_rootEpic);
var _reducers = require("../reducers");
var _reducersDefault = parcelHelpers.interopDefault(_reducers);
var _services = require("../services");
var _servicesDefault = parcelHelpers.interopDefault(_services);
var _completeBulkFileUploadMiddleware = require("../middlewares/completeBulkFileUploadMiddleware");
var _completeBulkFileUploadMiddlewareDefault = parcelHelpers.interopDefault(_completeBulkFileUploadMiddleware);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _window_location_host, _window_location, _window;
var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)({
    dependencies: (0, _servicesDefault.default)
});
var middlewares = [
    (0, _reduxThunkDefault.default),
    (0, _completeBulkFileUploadMiddlewareDefault.default),
    epicMiddleware
];
if ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : (_window_location_host = _window_location.host) === null || _window_location_host === void 0 ? void 0 : _window_location_host.includes("localhost")) middlewares.push((0, _reduxLoggerDefault.default));
var store = (0, _redux.createStore)((0, _reducersDefault.default), (0, _redux.applyMiddleware).apply(void 0, _to_consumable_array(middlewares)));
epicMiddleware.run((0, _rootEpicDefault.default));
exports.default = store;

},{"redux":"5nGOx","redux-thunk":"1VcZx","redux-observable":"4cxuH","redux-logger":"1cPhu","../epics/rootEpic":"yzi6G","../reducers":"fOqfj","../services":"iYcmV","../middlewares/completeBulkFileUploadMiddleware":"2Ipxb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5nGOx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"ck7vH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ck7vH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"jNdB2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jNdB2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(obj, key, value) {
    key = (0, _toPropertyKeyJsDefault.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"./toPropertyKey.js":"gh0Ro","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gh0Ro":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"lxQ1b","./toPrimitive.js":"79HSH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lxQ1b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"79HSH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"lxQ1b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1VcZx":[function(require,module,exports) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4cxuH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>(0, _createEpicMiddleware.createEpicMiddleware));
parcelHelpers.export(exports, "ActionsObservable", ()=>(0, _actionsObservable.ActionsObservable));
parcelHelpers.export(exports, "StateObservable", ()=>(0, _stateObservable.StateObservable));
parcelHelpers.export(exports, "combineEpics", ()=>(0, _combineEpics.combineEpics));
parcelHelpers.export(exports, "ofType", ()=>(0, _operators.ofType));
var _createEpicMiddleware = require("./createEpicMiddleware");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _combineEpics = require("./combineEpics");
var _operators = require("./operators");

},{"./createEpicMiddleware":"2xqem","./ActionsObservable":false,"./StateObservable":false,"./combineEpics":"JhNpq","./operators":"6lWWS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2xqem":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>createEpicMiddleware);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _console = require("./utils/console");
function createEpicMiddleware() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // This isn't great. RxJS doesn't publicly export the constructor for
    // QueueScheduler nor QueueAction, so we reach in. We need to do this because
    // we don't want our internal queuing mechanism to be on the same queue as any
    // other RxJS code outside of redux-observable internals.
    var QueueScheduler = (0, _rxjs.queueScheduler).constructor;
    var uniqueQueueScheduler = new QueueScheduler((0, _rxjs.queueScheduler).SchedulerAction);
    var epic$ = new (0, _rxjs.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        var actionSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var stateSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var action$ = new (0, _actionsObservable.ActionsObservable)(actionSubject$);
        var state$ = new (0, _stateObservable.StateObservable)(stateSubject$, store.getState());
        var result$ = epic$.pipe((0, _operators.map)(function(epic) {
            var output$ = "dependencies" in options ? epic(action$, state$, options.dependencies) : epic(action$, state$);
            if (!output$) throw new TypeError('Your root Epic "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        }), (0, _operators.mergeMap)(function(output$) {
            return (0, _rxjs.from)(output$).pipe((0, _operators.subscribeOn)(uniqueQueueScheduler), (0, _operators.observeOn)(uniqueQueueScheduler));
        }));
        result$.subscribe(store.dispatch);
        return function(next) {
            return function(action) {
                // Downstream middleware gets the action first,
                // which includes their reducers, so state is
                // updated before epics receive the action
                var result = next(action);
                // It's important to update the state$ before we emit
                // the action because otherwise it would be stale
                stateSubject$.next(store.getState());
                actionSubject$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.run = function(rootEpic) {
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

},{"rxjs":"cdYcx","rxjs/operators":"b5gYA","./ActionsObservable":"hDUKB","./StateObservable":"5iHit","./utils/console":"aZB1z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cdYcx":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":"5BalU","./internal/observable/ConnectableObservable":false,"./internal/operators/groupBy":false,"./internal/symbol/observable":false,"./internal/Subject":"lhh3G","./internal/BehaviorSubject":false,"./internal/ReplaySubject":false,"./internal/AsyncSubject":false,"./internal/scheduler/asap":false,"./internal/scheduler/async":false,"./internal/scheduler/queue":"aioBJ","./internal/scheduler/animationFrame":false,"./internal/scheduler/VirtualTimeScheduler":false,"./internal/Scheduler":false,"./internal/Subscription":false,"./internal/Subscriber":false,"./internal/Notification":false,"./internal/util/pipe":false,"./internal/util/noop":false,"./internal/util/identity":false,"./internal/util/isObservable":false,"./internal/util/ArgumentOutOfRangeError":false,"./internal/util/EmptyError":false,"./internal/util/ObjectUnsubscribedError":false,"./internal/util/UnsubscriptionError":false,"./internal/util/TimeoutError":false,"./internal/observable/bindCallback":false,"./internal/observable/bindNodeCallback":false,"./internal/observable/combineLatest":false,"./internal/observable/concat":false,"./internal/observable/defer":false,"./internal/observable/empty":false,"./internal/observable/forkJoin":"01xiP","./internal/observable/from":"hEwWR","./internal/observable/fromEvent":false,"./internal/observable/fromEventPattern":false,"./internal/observable/generate":false,"./internal/observable/iif":false,"./internal/observable/interval":false,"./internal/observable/merge":"gXIL9","./internal/observable/never":false,"./internal/observable/of":"4tU9B","./internal/observable/onErrorResumeNext":false,"./internal/observable/pairs":false,"./internal/observable/partition":false,"./internal/observable/race":false,"./internal/observable/range":false,"./internal/observable/throwError":false,"./internal/observable/timer":"26v0W","./internal/observable/using":false,"./internal/observable/zip":false,"./internal/scheduled/scheduled":false,"./internal/config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5BalU":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"2uHAZ","./util/toSubscriber":"31tjT","./symbol/observable":"ezIqa","./util/pipe":"67tzN","./config":"hsvEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2uHAZ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"bxmZC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bxmZC":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"8E6ff","./util/isFunction":"3lMYg","./Observer":"dIZ6J","./Subscription":"2Dz81","../internal/symbol/rxSubscriber":"3dtSm","./config":"hsvEz","./util/hostReportError":"gUfqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8E6ff":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3lMYg":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dIZ6J":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"hsvEz","./util/hostReportError":"gUfqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hsvEz":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gUfqq":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Dz81":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"4QOPa","./util/isObject":"jTbAr","./util/isFunction":"3lMYg","./util/UnsubscriptionError":"2QSgt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4QOPa":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jTbAr":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QSgt":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3dtSm":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"31tjT":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"bxmZC","../symbol/rxSubscriber":"3dtSm","../Observer":"dIZ6J","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezIqa":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"67tzN":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"bfuo0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfuo0":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lhh3G":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"8E6ff","./Observable":"5BalU","./Subscriber":"bxmZC","./Subscription":"2Dz81","./util/ObjectUnsubscribedError":"i1b8r","./SubjectSubscription":"9S2Un","../internal/symbol/rxSubscriber":"3dtSm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i1b8r":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9S2Un":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"8E6ff","./Subscription":"2Dz81","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4K09K":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = /*@__PURE__*/ new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"2UPWO","./AsapScheduler":"jhCWD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2UPWO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var _asyncAction = require("./AsyncAction");
var AsapAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, _immediate.Immediate).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, _immediate.Immediate).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"8E6ff","../util/Immediate":"3l4SJ","./AsyncAction":"6F5DP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3l4SJ":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6F5DP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var AsyncAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"8E6ff","./Action":"d9Tls","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d9Tls":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"8E6ff","../Subscription":"2Dz81","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jhCWD":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"8E6ff","./AsyncScheduler":"ecJTp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ecJTp":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"8E6ff","../Scheduler":"hEHV0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEHV0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var Scheduler = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"94U4j":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = /*@__PURE__*/ new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"6F5DP","./AsyncScheduler":"ecJTp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aioBJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = /*@__PURE__*/ new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"ePYKr","./QueueScheduler":"jqbse","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePYKr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"8E6ff","./AsyncAction":"6F5DP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqbse":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"8E6ff","./AsyncScheduler":"ecJTp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tsl4":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var NotificationKind;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, _of.of)(this.value);
            case "E":
                return (0, _throwError.throwError)(this.error);
            case "C":
                return (0, _empty.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

},{"./observable/empty":"6ZjxW","./observable/of":"4tU9B","./observable/throwError":"bLfw3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZjxW":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = /*@__PURE__*/ new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"5BalU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tU9B":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _isScheduler = require("../util/isScheduler");
var _fromArray = require("./fromArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        args.pop();
        return (0, _scheduleArray.scheduleArray)(args, scheduler);
    } else return (0, _fromArray.fromArray)(args);
}

},{"../util/isScheduler":"c33VH","./fromArray":"4d1wO","../scheduled/scheduleArray":"f3bRV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c33VH":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
function isScheduler(value) {
    return value && typeof value.schedule === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4d1wO":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromArray", ()=>fromArray);
var _observable = require("../Observable");
var _subscribeToArray = require("../util/subscribeToArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function fromArray(input, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)((0, _subscribeToArray.subscribeToArray)(input));
    else return (0, _scheduleArray.scheduleArray)(input, scheduler);
}

},{"../Observable":"5BalU","../util/subscribeToArray":"1PoqW","../scheduled/scheduleArray":"f3bRV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1PoqW":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f3bRV":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"5BalU","../Subscription":"2Dz81","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bLfw3":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
function throwError(error, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

},{"../Observable":"5BalU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9lCri":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>ArgumentOutOfRangeError);
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"01xiP":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forkJoin", ()=>forkJoin);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _map = require("../operators/map");
var _isObject = require("../util/isObject");
var _from = require("./from");
function forkJoin() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 1) {
        var first_1 = sources[0];
        if ((0, _isArray.isArray)(first_1)) return forkJoinInternal(first_1, null);
        if ((0, _isObject.isObject)(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function(key) {
                return first_1[key];
            }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === "function") {
        var resultSelector_1 = sources.pop();
        sources = sources.length === 1 && (0, _isArray.isArray)(sources[0]) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe((0, _map.map)(function(args) {
            return resultSelector_1.apply(void 0, args);
        }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new (0, _observable.Observable)(function(subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function(i) {
            var source = (0, _from.from)(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function(value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function(err) {
                    return subscriber.error(err);
                },
                complete: function() {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) subscriber.next(keys ? keys.reduce(function(result, key, i) {
                            return result[key] = values[i], result;
                        }, {}) : values);
                        subscriber.complete();
                    }
                }
            }));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
    });
}

},{"../Observable":"5BalU","../util/isArray":"4QOPa","../operators/map":"ddt0B","../util/isObject":"jTbAr","./from":"hEwWR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ddt0B":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"8E6ff","../Subscriber":"bxmZC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hEwWR":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"5BalU","../util/subscribeTo":"72HHK","../scheduled/scheduled":"fECgA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"72HHK":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"1PoqW","./subscribeToPromise":"knsCy","./subscribeToIterable":"cStDB","./subscribeToObservable":"50Yxc","./isArrayLike":"npf9F","./isPromise":"3QrSU","./isObject":"jTbAr","../symbol/iterator":"29otW","../symbol/observable":"ezIqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knsCy":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"gUfqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cStDB":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"29otW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29otW":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50Yxc":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"ezIqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"npf9F":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QrSU":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fECgA":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"7t2HS","./schedulePromise":"cpCuu","./scheduleArray":"f3bRV","./scheduleIterable":"4nNUo","../util/isInteropObservable":"274Mi","../util/isPromise":"3QrSU","../util/isArrayLike":"npf9F","../util/isIterable":"7lu1N","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7t2HS":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"5BalU","../Subscription":"2Dz81","../symbol/observable":"ezIqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cpCuu":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"5BalU","../Subscription":"2Dz81","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nNUo":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"5BalU","../Subscription":"2Dz81","../symbol/iterator":"29otW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"274Mi":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"ezIqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7lu1N":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"29otW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXIL9":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _observable = require("../Observable");
var _isScheduler = require("../util/isScheduler");
var _mergeAll = require("../operators/mergeAll");
var _fromArray = require("./fromArray");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, _isScheduler.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, _observable.Observable)) return observables[0];
    return (0, _mergeAll.mergeAll)(concurrent)((0, _fromArray.fromArray)(observables, scheduler));
}

},{"../Observable":"5BalU","../util/isScheduler":"c33VH","../operators/mergeAll":"jlLES","./fromArray":"4d1wO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlLES":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"5zTLX","../util/identity":"bfuo0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5zTLX":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
parcelHelpers.export(exports, "MergeMapOperator", ()=>MergeMapOperator);
parcelHelpers.export(exports, "MergeMapSubscriber", ()=>MergeMapSubscriber);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(mergeMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new MergeMapOperator(project, concurrent));
    };
}
var MergeMapOperator = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));
var flatMap = mergeMap;

},{"tslib":"8E6ff","./map":"ddt0B","../observable/from":"hEwWR","../innerSubscribe":"3g0X3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3g0X3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

},{"tslib":"8E6ff","./Subscriber":"bxmZC","./Observable":"5BalU","./util/subscribeTo":"72HHK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26v0W":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    var period = -1;
    if ((0, _isNumeric.isNumeric)(periodOrScheduler)) period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    else if ((0, _isScheduler.isScheduler)(periodOrScheduler)) scheduler = periodOrScheduler;
    if (!(0, _isScheduler.isScheduler)(scheduler)) scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isNumeric.isNumeric)(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule(dispatch, due, {
            index: 0,
            period: period,
            subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) return;
    else if (period === -1) return subscriber.complete();
    state.index = index + 1;
    this.schedule(state, period);
}

},{"../Observable":"5BalU","../scheduler/async":"94U4j","../util/isNumeric":"cSFBg","../util/isScheduler":"c33VH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cSFBg":[function(require,module,exports) {
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
var _isArray = require("./isArray");
function isNumeric(val) {
    return !(0, _isArray.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

},{"./isArray":"4QOPa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b5gYA":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":false,"../internal/operators/auditTime":false,"../internal/operators/buffer":false,"../internal/operators/bufferCount":false,"../internal/operators/bufferTime":false,"../internal/operators/bufferToggle":false,"../internal/operators/bufferWhen":false,"../internal/operators/catchError":"eLRxk","../internal/operators/combineAll":false,"../internal/operators/combineLatest":false,"../internal/operators/concat":false,"../internal/operators/concatAll":false,"../internal/operators/concatMap":false,"../internal/operators/concatMapTo":false,"../internal/operators/count":false,"../internal/operators/debounce":false,"../internal/operators/debounceTime":false,"../internal/operators/defaultIfEmpty":false,"../internal/operators/delay":"3nFUi","../internal/operators/delayWhen":false,"../internal/operators/dematerialize":false,"../internal/operators/distinct":false,"../internal/operators/distinctUntilChanged":false,"../internal/operators/distinctUntilKeyChanged":false,"../internal/operators/elementAt":false,"../internal/operators/endWith":false,"../internal/operators/every":false,"../internal/operators/exhaust":false,"../internal/operators/exhaustMap":false,"../internal/operators/expand":false,"../internal/operators/filter":"egRkq","../internal/operators/finalize":false,"../internal/operators/find":false,"../internal/operators/findIndex":false,"../internal/operators/first":false,"../internal/operators/groupBy":false,"../internal/operators/ignoreElements":false,"../internal/operators/isEmpty":false,"../internal/operators/last":false,"../internal/operators/map":"ddt0B","../internal/operators/mapTo":false,"../internal/operators/materialize":false,"../internal/operators/max":false,"../internal/operators/merge":false,"../internal/operators/mergeAll":false,"../internal/operators/mergeMap":"5zTLX","../internal/operators/mergeMapTo":false,"../internal/operators/mergeScan":false,"../internal/operators/min":false,"../internal/operators/multicast":false,"../internal/operators/observeOn":"9ju3X","../internal/operators/onErrorResumeNext":false,"../internal/operators/pairwise":false,"../internal/operators/partition":false,"../internal/operators/pluck":false,"../internal/operators/publish":false,"../internal/operators/publishBehavior":false,"../internal/operators/publishLast":false,"../internal/operators/publishReplay":false,"../internal/operators/race":false,"../internal/operators/reduce":false,"../internal/operators/repeat":false,"../internal/operators/repeatWhen":false,"../internal/operators/retry":false,"../internal/operators/retryWhen":false,"../internal/operators/refCount":false,"../internal/operators/sample":false,"../internal/operators/sampleTime":false,"../internal/operators/scan":false,"../internal/operators/sequenceEqual":false,"../internal/operators/share":false,"../internal/operators/shareReplay":false,"../internal/operators/single":false,"../internal/operators/skip":false,"../internal/operators/skipLast":false,"../internal/operators/skipUntil":false,"../internal/operators/skipWhile":false,"../internal/operators/startWith":false,"../internal/operators/subscribeOn":"kWmMS","../internal/operators/switchAll":false,"../internal/operators/switchMap":"8iPSA","../internal/operators/switchMapTo":false,"../internal/operators/take":"cTJU4","../internal/operators/takeLast":false,"../internal/operators/takeUntil":"lPhji","../internal/operators/takeWhile":false,"../internal/operators/tap":false,"../internal/operators/throttle":false,"../internal/operators/throttleTime":false,"../internal/operators/throwIfEmpty":false,"../internal/operators/timeInterval":false,"../internal/operators/timeout":false,"../internal/operators/timeoutWith":false,"../internal/operators/timestamp":false,"../internal/operators/toArray":false,"../internal/operators/window":false,"../internal/operators/windowCount":false,"../internal/operators/windowTime":false,"../internal/operators/windowToggle":false,"../internal/operators/windowWhen":false,"../internal/operators/withLatestFrom":false,"../internal/operators/zip":false,"../internal/operators/zipAll":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eLRxk":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"8E6ff","../innerSubscribe":"3g0X3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3nFUi":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    var absoluteDelay = (0, _isDate.isDate)(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
var DelayOperator = /*@__PURE__*/ function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
var DelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification((0, _notification.Notification).createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}((0, _subscriber.Subscriber));
var DelayMessage = /*@__PURE__*/ function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

},{"tslib":"8E6ff","../scheduler/async":"94U4j","../util/isDate":"5TkwX","../Subscriber":"bxmZC","../Notification":"9tsl4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TkwX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"egRkq":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var FilterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"8E6ff","../Subscriber":"bxmZC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ju3X":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
parcelHelpers.export(exports, "ObserveOnOperator", ()=>ObserveOnOperator);
parcelHelpers.export(exports, "ObserveOnSubscriber", ()=>ObserveOnSubscriber);
parcelHelpers.export(exports, "ObserveOnMessage", ()=>ObserveOnMessage);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var ObserveOnSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, _notification.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, _notification.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, _subscriber.Subscriber));
var ObserveOnMessage = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

},{"tslib":"8E6ff","../Subscriber":"bxmZC","../Notification":"9tsl4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kWmMS":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _subscribeOnObservable = require("../observable/SubscribeOnObservable");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, _subscribeOnObservable.SubscribeOnObservable)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

},{"../observable/SubscribeOnObservable":"6v3yu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6v3yu":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscribeOnObservable", ()=>SubscribeOnObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _asap = require("../scheduler/asap");
var _isNumeric = require("../util/isNumeric");
var SubscribeOnObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, _isNumeric.isNumeric)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, _asap.asap);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, _observable.Observable));

},{"tslib":"8E6ff","../Observable":"5BalU","../scheduler/asap":"4K09K","../util/isNumeric":"cSFBg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iPSA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"8E6ff","./map":"ddt0B","../observable/from":"hEwWR","../innerSubscribe":"3g0X3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cTJU4":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function take(count) {
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeOperator(count));
    };
}
var TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var TakeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"8E6ff","../Subscriber":"bxmZC","../util/ArgumentOutOfRangeError":"9lCri","../observable/empty":"6ZjxW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lPhji":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeUntil", ()=>takeUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function takeUntil(notifier) {
    return function(source) {
        return source.lift(new TakeUntilOperator(notifier));
    };
}
var TakeUntilOperator = /*@__PURE__*/ function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = (0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(takeUntilSubscriber));
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}();
var TakeUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function() {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {};
    return TakeUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"8E6ff","../innerSubscribe":"3g0X3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDUKB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionsObservable", ()=>ActionsObservable);
var _rxjs = require("rxjs");
var _operators = require("./operators");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ActionsObservable = function(_Observable) {
    _inherits(ActionsObservable, _Observable);
    _createClass(ActionsObservable, null, [
        {
            key: "of",
            value: function of() {
                return new this((0, _rxjs.of).apply(undefined, arguments));
            }
        },
        {
            key: "from",
            value: function from(actions, scheduler) {
                return new this((0, _rxjs.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        _classCallCheck(this, ActionsObservable);
        var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    _createClass(ActionsObservable, [
        {
            key: "lift",
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: "ofType",
            value: function ofType() {
                return (0, _operators.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, _rxjs.Observable));

},{"rxjs":"cdYcx","./operators":"6lWWS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lWWS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ofType", ()=>ofType);
var _operators = require("rxjs/operators");
var keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === "function" && type === key.toString();
};
var ofType = function ofType() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function(source) {
        return source.pipe((0, _operators.filter)(function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if (keyHasType(type, keys[i])) return true;
            }
            return false;
        }));
    };
};

},{"rxjs/operators":"b5gYA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iHit":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StateObservable", ()=>StateObservable);
var _rxjs = require("rxjs");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var StateObservable = function(_Observable) {
    _inherits(StateObservable, _Observable);
    function StateObservable(stateSubject, initialState) {
        _classCallCheck(this, StateObservable);
        var _this = _possibleConstructorReturn(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function(subscriber) {
            var subscription = _this.__notifier.subscribe(subscriber);
            if (subscription && !subscription.closed) subscriber.next(_this.value);
            return subscription;
        }));
        _this.value = initialState;
        _this.__notifier = new (0, _rxjs.Subject)();
        _this.__subscription = stateSubject.subscribe(function(value) {
            // We only want to update state$ if it has actually changed since
            // redux requires reducers use immutability patterns.
            // This is basically what distinctUntilChanged() does but it's so simple
            // we don't need to pull that code in
            if (value !== _this.value) {
                _this.value = value;
                _this.__notifier.next(value);
            }
        });
        return _this;
    }
    return StateObservable;
}((0, _rxjs.Observable));

},{"rxjs":"cdYcx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aZB1z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetDeprecationsSeen", ()=>resetDeprecationsSeen);
parcelHelpers.export(exports, "deprecate", ()=>deprecate);
parcelHelpers.export(exports, "warn", ()=>warn);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var deprecationsSeen = {};
var resetDeprecationsSeen = function resetDeprecationsSeen() {
    deprecationsSeen = {};
};
var consoleWarn = (typeof console === "undefined" ? "undefined" : _typeof(console)) === "object" && typeof console.warn === "function" ? function() {
    var _console;
    return (_console = console).warn.apply(_console, arguments);
} : function() {};
var deprecate = function deprecate(msg) {
    if (!deprecationsSeen[msg]) {
        deprecationsSeen[msg] = true;
        consoleWarn("redux-observable | DEPRECATION: " + msg);
    }
};
var warn = function warn(msg) {
    consoleWarn("redux-observable | WARNING: " + msg);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"JhNpq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineEpics", ()=>combineEpics);
var _rxjs = require("rxjs");
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var combineEpics = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    var merger = function merger() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, _rxjs.merge).apply(undefined, _toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        })));
    };
    // Technically the `name` property on Function's are supposed to be read-only.
    // While some JS runtimes allow it anyway (so this is useful in debugging)
    // some actually throw an exception when you attempt to do so.
    try {
        Object.defineProperty(merger, "name", {
            value: "combineEpics(" + epics.map(function(epic) {
                return epic.name || "<anonymous>";
            }).join(", ") + ")"
        });
    } catch (e) {}
    return merger;
};

},{"rxjs":"cdYcx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cPhu":[function(require,module,exports) {
var global = arguments[3];
!function(e, t) {
    t(exports);
}(this, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof global ? "undefined" : N(global)) && global ? global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{}],"yzi6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduxObservable = require("redux-observable");
var _apiLoadingEpic = require("./apiLoadingEpic");
var _reportsCenterEpics = require("./reportsCenterEpics");
var _reportsCenterEpicsDefault = parcelHelpers.interopDefault(_reportsCenterEpics);
var _generateReportEpics = require("./generateReportEpics");
var _generateReportEpicsDefault = parcelHelpers.interopDefault(_generateReportEpics);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var epics = (0, _reduxObservable.combineEpics).apply(void 0, _to_consumable_array((0, _reportsCenterEpicsDefault.default)).concat(_to_consumable_array((0, _generateReportEpicsDefault.default)), [
    (0, _apiLoadingEpic.apiLoadingEpic)
]));
exports.default = epics;

},{"redux-observable":"4cxuH","./apiLoadingEpic":"eKn4k","./reportsCenterEpics":"17wkl","./generateReportEpics":"eEyuv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eKn4k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiLoadingEpic", ()=>apiLoadingEpic);
var _operators = require("rxjs/operators");
var _ui = require("../actions/ui");
var _apiLoading = require("../utils/apiLoading");
var _apiLoading1 = require("../constants/apiLoading");
var apiLoadingEpic = function(action$) {
    return action$.pipe((0, _operators.filter)(function(action) {
        return (0, _apiLoading1.requestFlowActionsRegex).test(action.type);
    }), (0, _operators.map)(function(action) {
        var type = action.type;
        var isRequestBeingSent = (0, _apiLoading1.requestActionRegex).test(type);
        var call = (0, _apiLoading.getCall)(type);
        if (isRequestBeingSent) return (0, _ui.startRequestLoading)(call);
        return (0, _ui.endRequestLoading)(call);
    }));
};
exports.default = apiLoadingEpic;

},{"rxjs/operators":"b5gYA","../actions/ui":"9VSZL","../utils/apiLoading":"53XPt","../constants/apiLoading":"5bSWf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VSZL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Action to handle notification addition.
 */ parcelHelpers.export(exports, "addNotification", ()=>addNotification);
/**
 * Action to handle notification closures.
 */ parcelHelpers.export(exports, "closeNotification", ()=>closeNotification);
/**
 * Action to push to a different route.
 */ parcelHelpers.export(exports, "pushRoute", ()=>pushRoute);
parcelHelpers.export(exports, "startRequestLoading", ()=>startRequestLoading);
parcelHelpers.export(exports, "endRequestLoading", ()=>endRequestLoading);
parcelHelpers.export(exports, "openModalAction", ()=>openModalAction);
parcelHelpers.export(exports, "closeModalAction", ()=>closeModalAction);
parcelHelpers.export(exports, "updateFormValue", ()=>updateFormValue);
parcelHelpers.export(exports, "resetFormValue", ()=>resetFormValue);
parcelHelpers.export(exports, "setTabValue", ()=>setTabValue);
parcelHelpers.export(exports, "getTabValue", ()=>getTabValue);
var _uuid = require("uuid");
var _types = require("./types");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function addNotification(config) {
    return {
        type: (0, _types.ADD_NOTIFICATION),
        payload: _object_spread({
            id: (0, _uuid.v4)()
        }, config)
    };
}
function closeNotification(id) {
    return {
        type: (0, _types.CLOSE_NOTIFICATION),
        payload: id
    };
}
function pushRoute(history, route) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return {
        type: (0, _types.PUSH_ROUTE),
        payload: {
            history: history,
            route: route,
            delay: delay
        }
    };
}
var startRequestLoading = function(payload) {
    return {
        type: (0, _types.START_REQUEST_LOADING),
        payload: payload
    };
};
var endRequestLoading = function(payload) {
    return {
        type: (0, _types.END_REQUEST_LOADING),
        payload: payload
    };
};
var openModalAction = function(payload) {
    return {
        type: (0, _types.OPEN_UI_MODAL),
        payload: payload
    };
};
var closeModalAction = function() {
    var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "",
        payload: {}
    };
    return {
        type: (0, _types.CLOSE_UI_MODAL),
        payload: payload
    };
};
var updateFormValue = function(payload) {
    return {
        type: (0, _types.UPDATE_FORM_VALUE),
        payload: payload
    };
};
var resetFormValue = function(payload) {
    return {
        type: (0, _types.RESET_FORM_VALUES),
        payload: payload
    };
};
var setTabValue = function(payload) {
    return {
        type: (0, _types.UPDATE_TAB_VALUE),
        payload: payload
    };
};
var getTabValue = function(payload) {
    return {
        type: (0, _types.GET_TAB_VALUE),
        payload: payload
    };
};

},{"uuid":"9ummq","./types":"hP7mC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ummq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"KhsNM","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"KhsNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"hfhdj","./stringify.js":"4wxtN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfhdj":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wxtN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"kZWLo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZWLo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"4IqWD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4IqWD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hP7mC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SLICE", ()=>SLICE);
parcelHelpers.export(exports, "PUSH_ROUTE", ()=>PUSH_ROUTE);
parcelHelpers.export(exports, "ADD_NOTIFICATION", ()=>ADD_NOTIFICATION);
parcelHelpers.export(exports, "CLOSE_NOTIFICATION", ()=>CLOSE_NOTIFICATION);
parcelHelpers.export(exports, "START_REQUEST_LOADING", ()=>START_REQUEST_LOADING);
parcelHelpers.export(exports, "END_REQUEST_LOADING", ()=>END_REQUEST_LOADING);
parcelHelpers.export(exports, "UI_MODAL", ()=>UI_MODAL);
parcelHelpers.export(exports, "OPEN_UI_MODAL", ()=>OPEN_UI_MODAL);
parcelHelpers.export(exports, "CLOSE_UI_MODAL", ()=>CLOSE_UI_MODAL);
parcelHelpers.export(exports, "UPLOAD_FILES_MODAL", ()=>UPLOAD_FILES_MODAL);
parcelHelpers.export(exports, "FOLDER_CREATE_MODAL", ()=>FOLDER_CREATE_MODAL);
parcelHelpers.export(exports, "DELETE_REPORT_MODAL", ()=>DELETE_REPORT_MODAL);
parcelHelpers.export(exports, "UPLOAD_REPORT_MODAL", ()=>UPLOAD_REPORT_MODAL);
parcelHelpers.export(exports, "APPROVE_REPORT_MODAL", ()=>APPROVE_REPORT_MODAL);
parcelHelpers.export(exports, "REJECT_REPORT_MODAL", ()=>REJECT_REPORT_MODAL);
parcelHelpers.export(exports, "NotificationTypeEnum", ()=>NotificationTypeEnum);
parcelHelpers.export(exports, "DEFAULT_NOTIFICATION_CLOSE_TIMEOUT", ()=>DEFAULT_NOTIFICATION_CLOSE_TIMEOUT);
parcelHelpers.export(exports, "POLLING_NOTIFICATION_CLOSE_TIMEOUT", ()=>POLLING_NOTIFICATION_CLOSE_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_ROUTE_CHANGE_TIMEOUT", ()=>DEFAULT_ROUTE_CHANGE_TIMEOUT);
parcelHelpers.export(exports, "FORM", ()=>FORM);
parcelHelpers.export(exports, "UPDATE_FORM_VALUE", ()=>UPDATE_FORM_VALUE);
parcelHelpers.export(exports, "RESET_FORM_VALUES", ()=>RESET_FORM_VALUES);
parcelHelpers.export(exports, "TAB_VALUE", ()=>TAB_VALUE);
parcelHelpers.export(exports, "UPDATE_TAB_VALUE", ()=>UPDATE_TAB_VALUE);
parcelHelpers.export(exports, "GET_TAB_VALUE", ()=>GET_TAB_VALUE);
var SLICE = "ui";
var PUSH_ROUTE = "".concat(SLICE, "/PUSH_ROUTE");
var ADD_NOTIFICATION = "".concat(SLICE, "/ADD_NOTIFICATION");
var CLOSE_NOTIFICATION = "".concat(SLICE, "/CLOSE_NOTIFICATION");
var START_REQUEST_LOADING = "".concat(SLICE, "/START_REQUEST_LOADING");
var END_REQUEST_LOADING = "".concat(SLICE, "/END_REQUEST_LOADING");
var UI_MODAL = "UI_MODAL";
var OPEN_UI_MODAL = "".concat(SLICE, "/OPEN_").concat(UI_MODAL);
var CLOSE_UI_MODAL = "".concat(SLICE, "/CLOSE_").concat(UI_MODAL);
var UPLOAD_FILES_MODAL = "UPLOAD_FILES_MODAL";
var FOLDER_CREATE_MODAL = "FOLDER_CREATE_MODAL";
var DELETE_REPORT_MODAL = "DELETE_REPORT_MODAL";
var UPLOAD_REPORT_MODAL = "UPLOAD_REPORT_MODAL";
var APPROVE_REPORT_MODAL = "APPROVE_REPORT_MODAL";
var REJECT_REPORT_MODAL = "REJECT_REPORT_MODAL";
var NotificationTypeEnum = Object.freeze({
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning"
});
var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
var POLLING_NOTIFICATION_CLOSE_TIMEOUT = 10000;
var DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;
var FORM = "FORM";
var UPDATE_FORM_VALUE = "".concat(SLICE, "/UPDATE_").concat(FORM);
var RESET_FORM_VALUES = "".concat(SLICE, "/RESET_").concat(FORM);
var TAB_VALUE = "TAB_VALUE";
var UPDATE_TAB_VALUE = "".concat(SLICE, "/UPDATE_").concat(TAB_VALUE);
var GET_TAB_VALUE = "".concat(SLICE, "/GET_").concat(TAB_VALUE);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"53XPt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get the name of the call being made.
 * Replace /(_REQUEST|_SUCCESS|_FAILURE)$/ with empty string
 *
 * @param {string} action
 * @returns {string}
 */ parcelHelpers.export(exports, "getCall", ()=>getCall);
var _apiLoading = require("../constants/apiLoading");
function getCall(action) {
    return action.replace((0, _apiLoading.requestFlowActionsRegex), "");
}
exports.default = {
    getCall: getCall
};

},{"../constants/apiLoading":"5bSWf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bSWf":[function(require,module,exports) {
// To match strings ending with REQUEST | SUCCESS | FAILURE
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestFlowActionsRegex", ()=>requestFlowActionsRegex);
parcelHelpers.export(exports, "requestActionRegex", ()=>requestActionRegex);
parcelHelpers.export(exports, "SEARCH_USER_API_DEBOUNCE_MS", ()=>SEARCH_USER_API_DEBOUNCE_MS);
var requestFlowActionsRegex = /(_REQUEST|_SUCCESS|_FAILURE)$/;
var requestActionRegex = /_REQUEST$/;
var SEARCH_USER_API_DEBOUNCE_MS = 500;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17wkl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportsCenterEpics", ()=>reportsCenterEpics);
var _downloadReportEpic = require("./downloadReportEpic");
var _getTermReportConfigsEpic = require("./getTermReportConfigsEpic");
var _searchReportsEpic = require("./searchReportsEpic");
var _searchReportsEpicDefault = parcelHelpers.interopDefault(_searchReportsEpic);
var _initiateBulkUploadFilesEpic = require("./initiateBulkUploadFilesEpic");
var _initiateBulkUploadFilesEpicDefault = parcelHelpers.interopDefault(_initiateBulkUploadFilesEpic);
var _filePartsUploadEpic = require("./filePartsUploadEpic");
var _filePartsUploadEpicDefault = parcelHelpers.interopDefault(_filePartsUploadEpic);
var _completeBulkUploadFilesEpic = require("./completeBulkUploadFilesEpic");
var _completeBulkUploadFilesEpicDefault = parcelHelpers.interopDefault(_completeBulkUploadFilesEpic);
var _uploadFileFolderEpic = require("./uploadFileFolderEpic");
var _uploadFileFolderEpicDefault = parcelHelpers.interopDefault(_uploadFileFolderEpic);
var _deleteReportEpic = require("./deleteReportEpic");
var _deleteReportEpicDefault = parcelHelpers.interopDefault(_deleteReportEpic);
var _bulkDownloadReportsEpic = require("./bulkDownloadReportsEpic");
var _bulkDownloadReportsEpicDefault = parcelHelpers.interopDefault(_bulkDownloadReportsEpic);
var _downloadReportPresignedURLEpic = require("./downloadReportPresignedURLEpic");
var _downloadReportPresignedURLEpicDefault = parcelHelpers.interopDefault(_downloadReportPresignedURLEpic);
var _getReportDetailsEpic = require("./getReportDetailsEpic");
var _getReportDetailsEpicDefault = parcelHelpers.interopDefault(_getReportDetailsEpic);
var _approveReportEpic = require("./approveReportEpic");
var _approveReportEpicDefault = parcelHelpers.interopDefault(_approveReportEpic);
var _rejectReportEpic = require("./rejectReportEpic");
var _rejectReportEpicDefault = parcelHelpers.interopDefault(_rejectReportEpic);
var _getReportDetailsPollingEpic = require("./getReportDetailsPollingEpic");
var _getReportDetailsPollingEpicDefault = parcelHelpers.interopDefault(_getReportDetailsPollingEpic);
var _getPresignedUrlEpic = require("./getPresignedUrlEpic");
var _getPresignedUrlEpicDefault = parcelHelpers.interopDefault(_getPresignedUrlEpic);
var reportsCenterEpics = [
    (0, _getTermReportConfigsEpic.getTermReportConfigsEpic),
    (0, _downloadReportEpic.downloadReportEpic),
    (0, _searchReportsEpicDefault.default),
    (0, _initiateBulkUploadFilesEpicDefault.default),
    (0, _filePartsUploadEpicDefault.default),
    (0, _completeBulkUploadFilesEpicDefault.default),
    (0, _uploadFileFolderEpicDefault.default),
    (0, _deleteReportEpicDefault.default),
    (0, _bulkDownloadReportsEpicDefault.default),
    (0, _downloadReportPresignedURLEpicDefault.default),
    (0, _getReportDetailsEpicDefault.default),
    (0, _approveReportEpicDefault.default),
    (0, _rejectReportEpicDefault.default),
    (0, _getReportDetailsPollingEpicDefault.default),
    (0, _getPresignedUrlEpicDefault.default)
];
exports.default = reportsCenterEpics;

},{"./downloadReportEpic":"cMdaU","./getTermReportConfigsEpic":"5tDjP","./searchReportsEpic":"ibL1N","./initiateBulkUploadFilesEpic":"3fxiW","./filePartsUploadEpic":"15Kyt","./completeBulkUploadFilesEpic":"8P5q2","./uploadFileFolderEpic":"6OQ8J","./deleteReportEpic":"jeg0e","./bulkDownloadReportsEpic":"dsfME","./downloadReportPresignedURLEpic":"5A6TJ","./getReportDetailsEpic":"hdtkm","./approveReportEpic":"cY9eV","./rejectReportEpic":"1rrkH","./getReportDetailsPollingEpic":"P0UJf","./getPresignedUrlEpic":"1UUOO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cMdaU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadReportEpic", ()=>downloadReportEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _errorCodeMessages = require("../../../config/errorCodeMessages");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
var downloadReportEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.DOWNLOAD_REPORT_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.downloadReport((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.downloadReportInput).pipe((0, _operators.mergeMap)(function(response) {
            var _action_payload;
            return (0, _rxjs.of)((0, _actions.downloadReport).success(_object_spread_props(_object_spread({}, response || {}), {
                downloadType: action.payload.downloadType,
                supportingDocumentKey: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.supportingDocumentKey
            })));
        }), (0, _operators.catchError)(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return (0, _rxjs.of)((0, _actions.downloadReport).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.DOWNLOAD_REPORT_FAILURE),
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = (0, _errorCodeMessages.reportsCenterErrorCodes)[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "download_report_notifications.failure" : "download_report_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = downloadReportEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../config/errorCodeMessages":"bhWLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"20R3C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SLICE", ()=>SLICE);
parcelHelpers.export(exports, "SEARCH_REPORTS_REQUEST", ()=>SEARCH_REPORTS_REQUEST);
parcelHelpers.export(exports, "SEARCH_REPORTS_SUCCESS", ()=>SEARCH_REPORTS_SUCCESS);
parcelHelpers.export(exports, "SEARCH_REPORTS_FAILURE", ()=>SEARCH_REPORTS_FAILURE);
parcelHelpers.export(exports, "DOWNLOAD_REPORT_REQUEST", ()=>DOWNLOAD_REPORT_REQUEST);
parcelHelpers.export(exports, "DOWNLOAD_REPORT_SUCCESS", ()=>DOWNLOAD_REPORT_SUCCESS);
parcelHelpers.export(exports, "DOWNLOAD_REPORT_FAILURE", ()=>DOWNLOAD_REPORT_FAILURE);
parcelHelpers.export(exports, "GET_TERM_REPORT_CONFIGS_REQUEST", ()=>GET_TERM_REPORT_CONFIGS_REQUEST);
parcelHelpers.export(exports, "GET_TERM_REPORT_CONFIGS_SUCCESS", ()=>GET_TERM_REPORT_CONFIGS_SUCCESS);
parcelHelpers.export(exports, "GET_TERM_REPORT_CONFIGS_FAILURE", ()=>GET_TERM_REPORT_CONFIGS_FAILURE);
parcelHelpers.export(exports, "SELECT_LP", ()=>SELECT_LP);
parcelHelpers.export(exports, "SET_SEARCH_REPORTS_PAGE_SIZE", ()=>SET_SEARCH_REPORTS_PAGE_SIZE);
parcelHelpers.export(exports, "SET_CURRENT_FOLDER_PATH", ()=>SET_CURRENT_FOLDER_PATH);
parcelHelpers.export(exports, "SET_CURRENT_PAGE", ()=>SET_CURRENT_PAGE);
parcelHelpers.export(exports, "RESET_IS_TRIGGER_SEARCH_REPORT", ()=>RESET_IS_TRIGGER_SEARCH_REPORT);
parcelHelpers.export(exports, "SET_REPORT_SELECTION", ()=>SET_REPORT_SELECTION);
parcelHelpers.export(exports, "SET_SORT_CRITERIA", ()=>SET_SORT_CRITERIA);
parcelHelpers.export(exports, "RESET_REPORT_LIST", ()=>RESET_REPORT_LIST);
parcelHelpers.export(exports, "SET_FILTER_SHEET_OPEN", ()=>SET_FILTER_SHEET_OPEN);
parcelHelpers.export(exports, "SET_FILTERS", ()=>SET_FILTERS);
parcelHelpers.export(exports, "INITIATE_BULK_UPLOAD_FILES_REQUEST", ()=>INITIATE_BULK_UPLOAD_FILES_REQUEST);
parcelHelpers.export(exports, "INITIATE_BULK_UPLOAD_FILES_SUCCESS", ()=>INITIATE_BULK_UPLOAD_FILES_SUCCESS);
parcelHelpers.export(exports, "INITIATE_BULK_UPLOAD_FILES_FAILURE", ()=>INITIATE_BULK_UPLOAD_FILES_FAILURE);
parcelHelpers.export(exports, "FILE_PARTS_UPLOAD_REQUEST", ()=>FILE_PARTS_UPLOAD_REQUEST);
parcelHelpers.export(exports, "FILE_PARTS_UPLOAD_SUCCESS", ()=>FILE_PARTS_UPLOAD_SUCCESS);
parcelHelpers.export(exports, "FILE_PARTS_UPLOAD_FAILURE", ()=>FILE_PARTS_UPLOAD_FAILURE);
parcelHelpers.export(exports, "COMPLETE_BULK_UPLOAD_FILES_REQUEST", ()=>COMPLETE_BULK_UPLOAD_FILES_REQUEST);
parcelHelpers.export(exports, "COMPLETE_BULK_UPLOAD_FILES_SUCCESS", ()=>COMPLETE_BULK_UPLOAD_FILES_SUCCESS);
parcelHelpers.export(exports, "COMPLETE_BULK_UPLOAD_FILES_FAILURE", ()=>COMPLETE_BULK_UPLOAD_FILES_FAILURE);
parcelHelpers.export(exports, "RESET_BULK_FILES_PART_STATE", ()=>RESET_BULK_FILES_PART_STATE);
parcelHelpers.export(exports, "UPLOAD_FILE_FOLDER_REQUEST", ()=>UPLOAD_FILE_FOLDER_REQUEST);
parcelHelpers.export(exports, "UPLOAD_FILE_FOLDER_SUCCESS", ()=>UPLOAD_FILE_FOLDER_SUCCESS);
parcelHelpers.export(exports, "UPLOAD_FILE_FOLDER_FAILURE", ()=>UPLOAD_FILE_FOLDER_FAILURE);
parcelHelpers.export(exports, "DELETE_REPORT_REQUEST", ()=>DELETE_REPORT_REQUEST);
parcelHelpers.export(exports, "DELETE_REPORT_SUCCESS", ()=>DELETE_REPORT_SUCCESS);
parcelHelpers.export(exports, "DELETE_REPORT_FAILURE", ()=>DELETE_REPORT_FAILURE);
parcelHelpers.export(exports, "BULK_DOWNLOAD_REPORTS_REQUEST", ()=>BULK_DOWNLOAD_REPORTS_REQUEST);
parcelHelpers.export(exports, "BULK_DOWNLOAD_REPORTS_SUCCESS", ()=>BULK_DOWNLOAD_REPORTS_SUCCESS);
parcelHelpers.export(exports, "BULK_DOWNLOAD_REPORTS_FAILURE", ()=>BULK_DOWNLOAD_REPORTS_FAILURE);
parcelHelpers.export(exports, "GENERATE_REPORT_ASYNC_REQUEST", ()=>GENERATE_REPORT_ASYNC_REQUEST);
parcelHelpers.export(exports, "GENERATE_REPORT_ASYNC_SUCCESS", ()=>GENERATE_REPORT_ASYNC_SUCCESS);
parcelHelpers.export(exports, "GENERATE_REPORT_ASYNC_FAILURE", ()=>GENERATE_REPORT_ASYNC_FAILURE);
parcelHelpers.export(exports, "RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC", ()=>RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC);
parcelHelpers.export(exports, "PREVIEW_ENABLED", ()=>PREVIEW_ENABLED);
parcelHelpers.export(exports, "GENERATE_PRESIGNED_URL_REQUEST", ()=>GENERATE_PRESIGNED_URL_REQUEST);
parcelHelpers.export(exports, "GENERATE_PRESIGNED_URL_SUCCESS", ()=>GENERATE_PRESIGNED_URL_SUCCESS);
parcelHelpers.export(exports, "GENERATE_PRESIGNED_URL_FAILURE", ()=>GENERATE_PRESIGNED_URL_FAILURE);
parcelHelpers.export(exports, "SET_DDU_LIST", ()=>SET_DDU_LIST);
parcelHelpers.export(exports, "GET_DOWNLOAD_REPORT_URL_REQUEST", ()=>GET_DOWNLOAD_REPORT_URL_REQUEST);
parcelHelpers.export(exports, "GET_DOWNLOAD_REPORT_URL_SUCCESS", ()=>GET_DOWNLOAD_REPORT_URL_SUCCESS);
parcelHelpers.export(exports, "GET_DOWNLOAD_REPORT_URL_FAILURE", ()=>GET_DOWNLOAD_REPORT_URL_FAILURE);
parcelHelpers.export(exports, "FETCH_DATA_FROM_PRESIGNED_URL_REQUEST", ()=>FETCH_DATA_FROM_PRESIGNED_URL_REQUEST);
parcelHelpers.export(exports, "FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS", ()=>FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS);
parcelHelpers.export(exports, "FETCH_DATA_FROM_PRESIGNED_URL_FAILURE", ()=>FETCH_DATA_FROM_PRESIGNED_URL_FAILURE);
parcelHelpers.export(exports, "GET_REPORT_DETAILS_REQUEST", ()=>GET_REPORT_DETAILS_REQUEST);
parcelHelpers.export(exports, "GET_REPORT_DETAILS_SUCCESS", ()=>GET_REPORT_DETAILS_SUCCESS);
parcelHelpers.export(exports, "GET_REPORT_DETAILS_FAILURE", ()=>GET_REPORT_DETAILS_FAILURE);
parcelHelpers.export(exports, "RESET_GET_REPORT_DETAILS", ()=>RESET_GET_REPORT_DETAILS);
parcelHelpers.export(exports, "START_GET_REPORT_DETAILS_POLLING_REQUEST", ()=>START_GET_REPORT_DETAILS_POLLING_REQUEST);
parcelHelpers.export(exports, "STOP_GET_REPORT_DETAILS_POLLING_REQUEST", ()=>STOP_GET_REPORT_DETAILS_POLLING_REQUEST);
parcelHelpers.export(exports, "APPROVE_REPORT_REQUEST", ()=>APPROVE_REPORT_REQUEST);
parcelHelpers.export(exports, "APPROVE_REPORT_SUCCESS", ()=>APPROVE_REPORT_SUCCESS);
parcelHelpers.export(exports, "APPROVE_REPORT_FAILURE", ()=>APPROVE_REPORT_FAILURE);
parcelHelpers.export(exports, "REJECT_REPORT_REQUEST", ()=>REJECT_REPORT_REQUEST);
parcelHelpers.export(exports, "REJECT_REPORT_SUCCESS", ()=>REJECT_REPORT_SUCCESS);
parcelHelpers.export(exports, "REJECT_REPORT_FAILURE", ()=>REJECT_REPORT_FAILURE);
parcelHelpers.export(exports, "GET_PRESIGNED_URL_REQUEST", ()=>GET_PRESIGNED_URL_REQUEST);
parcelHelpers.export(exports, "GET_PRESIGNED_URL_SUCCESS", ()=>GET_PRESIGNED_URL_SUCCESS);
parcelHelpers.export(exports, "GET_PRESIGNED_URL_FAILURE", ()=>GET_PRESIGNED_URL_FAILURE);
var SLICE = "reportsCenter";
var SEARCH_REPORTS = "".concat(SLICE, "/SEARCH_REPORTS");
var SEARCH_REPORTS_REQUEST = "".concat(SEARCH_REPORTS, "_REQUEST");
var SEARCH_REPORTS_SUCCESS = "".concat(SEARCH_REPORTS, "_SUCCESS");
var SEARCH_REPORTS_FAILURE = "".concat(SEARCH_REPORTS, "_FAILURE");
var DOWNLOAD_REPORT = "".concat(SLICE, "/DOWNLOAD_REPORT");
var DOWNLOAD_REPORT_REQUEST = "".concat(DOWNLOAD_REPORT, "_REQUEST");
var DOWNLOAD_REPORT_SUCCESS = "".concat(DOWNLOAD_REPORT, "_SUCCESS");
var DOWNLOAD_REPORT_FAILURE = "".concat(DOWNLOAD_REPORT, "_FAILURE");
var GET_TERM_REPORT_CONFIGS = "".concat(SLICE, "/GET_TERM_REPORT_CONFIGS");
var GET_TERM_REPORT_CONFIGS_REQUEST = "".concat(GET_TERM_REPORT_CONFIGS, "_REQUEST");
var GET_TERM_REPORT_CONFIGS_SUCCESS = "".concat(GET_TERM_REPORT_CONFIGS, "_SUCCESS");
var GET_TERM_REPORT_CONFIGS_FAILURE = "".concat(GET_TERM_REPORT_CONFIGS, "_FAILURE");
var SELECT_LP = "".concat(SLICE, "/SELECT_LP");
var SET_SEARCH_REPORTS_PAGE_SIZE = "".concat(SLICE, "/SET_SEARCH_REPORTS_PAGE_SIZE");
var SET_CURRENT_FOLDER_PATH = "".concat(SLICE, "/SET_CURRENT_FOLDER_PATH");
var SET_CURRENT_PAGE = "".concat(SLICE, "/SET_CURRENT_PAGE");
var RESET_IS_TRIGGER_SEARCH_REPORT = "".concat(SLICE, "/RESET_IS_TRIGGER_SEARCH_REPORT");
var SET_REPORT_SELECTION = "".concat(SLICE, "/SET_REPORT_SELECTION");
var SET_SORT_CRITERIA = "".concat(SLICE, "/SET_SORT_CRITERIA");
var RESET_REPORT_LIST = "".concat(SLICE, "/RESET_REPORT_LIST");
var SET_FILTER_SHEET_OPEN = "".concat(SLICE, "/SET_FILTER_SHEET_OPEN");
var SET_FILTERS = "".concat(SLICE, "/SET_FILTERS");
var INITIATE_BULK_UPLOAD_FILES = "".concat(SLICE, "/INITIATE_BULK_UPLOAD_FILES");
var INITIATE_BULK_UPLOAD_FILES_REQUEST = "".concat(INITIATE_BULK_UPLOAD_FILES, "_REQUEST");
var INITIATE_BULK_UPLOAD_FILES_SUCCESS = "".concat(INITIATE_BULK_UPLOAD_FILES, "_SUCCESS");
var INITIATE_BULK_UPLOAD_FILES_FAILURE = "".concat(INITIATE_BULK_UPLOAD_FILES, "_FAILURE");
var FILE_PARTS_UPLOAD = "".concat(SLICE, "/FILE_PARTS_UPLOAD");
var FILE_PARTS_UPLOAD_REQUEST = "".concat(FILE_PARTS_UPLOAD, "_REQUEST");
var FILE_PARTS_UPLOAD_SUCCESS = "".concat(FILE_PARTS_UPLOAD, "_SUCCESS");
var FILE_PARTS_UPLOAD_FAILURE = "".concat(FILE_PARTS_UPLOAD, "_FAILURE");
var COMPLETE_BULK_UPLOAD_FILES = "".concat(SLICE, "/COMPLETE_BULK_UPLOAD_FILES");
var COMPLETE_BULK_UPLOAD_FILES_REQUEST = "".concat(COMPLETE_BULK_UPLOAD_FILES, "_REQUEST");
var COMPLETE_BULK_UPLOAD_FILES_SUCCESS = "".concat(COMPLETE_BULK_UPLOAD_FILES, "_SUCCESS");
var COMPLETE_BULK_UPLOAD_FILES_FAILURE = "".concat(COMPLETE_BULK_UPLOAD_FILES, "_FAILURE");
var RESET_BULK_FILES_PART_STATE = "".concat(SLICE, "/RESET_BULK_FILES_PART_STATE");
var UPLOAD_FILE_FOLDER = "".concat(SLICE, "/UPLOAD_FILE_FOLDER");
var UPLOAD_FILE_FOLDER_REQUEST = "".concat(UPLOAD_FILE_FOLDER, "_REQUEST");
var UPLOAD_FILE_FOLDER_SUCCESS = "".concat(UPLOAD_FILE_FOLDER, "_SUCCESS");
var UPLOAD_FILE_FOLDER_FAILURE = "".concat(UPLOAD_FILE_FOLDER, "_FAILURE");
var DELETE_REPORT = "".concat(SLICE, "/DELETE_REPORT");
var DELETE_REPORT_REQUEST = "".concat(DELETE_REPORT, "_REQUEST");
var DELETE_REPORT_SUCCESS = "".concat(DELETE_REPORT, "_SUCCESS");
var DELETE_REPORT_FAILURE = "".concat(DELETE_REPORT, "_FAILURE");
var BULK_DOWNLOAD_REPORTS = "".concat(SLICE, "/BULK_DOWNLOAD_REPORTS");
var BULK_DOWNLOAD_REPORTS_REQUEST = "".concat(BULK_DOWNLOAD_REPORTS, "_REQUEST");
var BULK_DOWNLOAD_REPORTS_SUCCESS = "".concat(BULK_DOWNLOAD_REPORTS, "_SUCCESS");
var BULK_DOWNLOAD_REPORTS_FAILURE = "".concat(BULK_DOWNLOAD_REPORTS, "_FAILURE");
var GENERATE_REPORT_ASYNC = "".concat(SLICE, "/GENERATE_REPORT_ASYNC");
var GENERATE_REPORT_ASYNC_REQUEST = "".concat(GENERATE_REPORT_ASYNC, "_REQUEST");
var GENERATE_REPORT_ASYNC_SUCCESS = "".concat(GENERATE_REPORT_ASYNC, "_SUCCESS");
var GENERATE_REPORT_ASYNC_FAILURE = "".concat(GENERATE_REPORT_ASYNC, "_FAILURE");
var RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC = "".concat(SLICE, "/RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC");
var PREVIEW_ENABLED = "".concat(SLICE, "/PREVIEW_ENABLED");
var GENERATE_PRESIGNED_URL = "".concat(SLICE, "/GENERATE_PRESIGNED_URL");
var GENERATE_PRESIGNED_URL_REQUEST = "".concat(GENERATE_PRESIGNED_URL, "_REQUEST");
var GENERATE_PRESIGNED_URL_SUCCESS = "".concat(GENERATE_PRESIGNED_URL, "_SUCCESS");
var GENERATE_PRESIGNED_URL_FAILURE = "".concat(GENERATE_PRESIGNED_URL, "_FAILURE");
var SET_DDU_LIST = "".concat(GENERATE_PRESIGNED_URL, "_SET_DDU_LIST");
var GET_DOWNLOAD_REPORT_URL = "".concat(SLICE, "/GET_DOWNLOAD_REPORT_URL");
var GET_DOWNLOAD_REPORT_URL_REQUEST = "".concat(GET_DOWNLOAD_REPORT_URL, "_REQUEST");
var GET_DOWNLOAD_REPORT_URL_SUCCESS = "".concat(GET_DOWNLOAD_REPORT_URL, "_SUCCESS");
var GET_DOWNLOAD_REPORT_URL_FAILURE = "".concat(GET_DOWNLOAD_REPORT_URL, "_FAILURE");
var FETCH_DATA_FROM_PRESIGNED_URL = "".concat(SLICE, "/FETCH_DATA_FROM_PRESIGNED_URL");
var FETCH_DATA_FROM_PRESIGNED_URL_REQUEST = "".concat(FETCH_DATA_FROM_PRESIGNED_URL, "_REQUEST");
var FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS = "".concat(FETCH_DATA_FROM_PRESIGNED_URL, "_SUCCESS");
var FETCH_DATA_FROM_PRESIGNED_URL_FAILURE = "".concat(FETCH_DATA_FROM_PRESIGNED_URL, "_FAILURE");
var GET_REPORT_DETAILS = "".concat(SLICE, "/GET_REPORT_DETAILS");
var GET_REPORT_DETAILS_REQUEST = "".concat(GET_REPORT_DETAILS, "_REQUEST");
var GET_REPORT_DETAILS_SUCCESS = "".concat(GET_REPORT_DETAILS, "_SUCCESS");
var GET_REPORT_DETAILS_FAILURE = "".concat(GET_REPORT_DETAILS, "_FAILURE");
var RESET_GET_REPORT_DETAILS = "".concat(SLICE, "/RESET_GET_REPORT_DETAILS");
var GET_REPORT_DETAILS_POLLING = "GET_REPORT_DETAILS_POLLING";
var START_GET_REPORT_DETAILS_POLLING_REQUEST = "".concat(SLICE, "/START_").concat(GET_REPORT_DETAILS_POLLING, "_REQUEST");
var STOP_GET_REPORT_DETAILS_POLLING_REQUEST = "".concat(SLICE, "/STOP_").concat(GET_REPORT_DETAILS_POLLING, "_REQUEST");
var APPROVE_REPORT = "".concat(SLICE, "/APPROVE_REPORT");
var APPROVE_REPORT_REQUEST = "".concat(APPROVE_REPORT, "_REQUEST");
var APPROVE_REPORT_SUCCESS = "".concat(APPROVE_REPORT, "_SUCCESS");
var APPROVE_REPORT_FAILURE = "".concat(APPROVE_REPORT, "_FAILURE");
var REJECT_REPORT = "".concat(SLICE, "/REJECT_REPORT");
var REJECT_REPORT_REQUEST = "".concat(REJECT_REPORT, "_REQUEST");
var REJECT_REPORT_SUCCESS = "".concat(REJECT_REPORT, "_SUCCESS");
var REJECT_REPORT_FAILURE = "".concat(REJECT_REPORT, "_FAILURE");
var GET_PRESIGNED_URL = "".concat(SLICE, "/GET_PRESIGNED_URL");
var GET_PRESIGNED_URL_REQUEST = "".concat(GET_PRESIGNED_URL, "_REQUEST");
var GET_PRESIGNED_URL_SUCCESS = "".concat(GET_PRESIGNED_URL, "_SUCCESS");
var GET_PRESIGNED_URL_FAILURE = "".concat(GET_PRESIGNED_URL, "_FAILURE");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lbye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchReports", ()=>searchReports);
parcelHelpers.export(exports, "downloadReport", ()=>downloadReport);
parcelHelpers.export(exports, "bulkDownloadReports", ()=>bulkDownloadReports);
parcelHelpers.export(exports, "setReportSelection", ()=>setReportSelection);
parcelHelpers.export(exports, "getTermReportConfigs", ()=>getTermReportConfigs);
parcelHelpers.export(exports, "selectLp", ()=>selectLp);
parcelHelpers.export(exports, "setSearchReportsPageSize", ()=>setSearchReportsPageSize);
parcelHelpers.export(exports, "setCurrentFolderPath", ()=>setCurrentFolderPath);
parcelHelpers.export(exports, "setCurrentPage", ()=>setCurrentPage);
parcelHelpers.export(exports, "setSortCriteria", ()=>setSortCriteria);
parcelHelpers.export(exports, "resetReportsList", ()=>resetReportsList);
parcelHelpers.export(exports, "setFilterSheetOpenAction", ()=>setFilterSheetOpenAction);
parcelHelpers.export(exports, "setFiltersAction", ()=>setFiltersAction);
parcelHelpers.export(exports, "initiateBulkUploadFilesAction", ()=>initiateBulkUploadFilesAction);
parcelHelpers.export(exports, "filePartsUploadAction", ()=>filePartsUploadAction);
parcelHelpers.export(exports, "completeBulkUploadFilesAction", ()=>completeBulkUploadFilesAction);
parcelHelpers.export(exports, "resetBulkFilesPartState", ()=>resetBulkFilesPartState);
parcelHelpers.export(exports, "resetIsTriggerSearchReportState", ()=>resetIsTriggerSearchReportState);
parcelHelpers.export(exports, "uploadFileFolderAction", ()=>uploadFileFolderAction);
parcelHelpers.export(exports, "deleteReportAction", ()=>deleteReportAction);
parcelHelpers.export(exports, "generateReportAsync", ()=>generateReportAsync);
parcelHelpers.export(exports, "resetIsTriggerGenerateReportAsync", ()=>resetIsTriggerGenerateReportAsync);
parcelHelpers.export(exports, "reportPreviewEnabled", ()=>reportPreviewEnabled);
parcelHelpers.export(exports, "generatePresignedUrl", ()=>generatePresignedUrl);
parcelHelpers.export(exports, "setDDUList", ()=>setDDUList);
parcelHelpers.export(exports, "downloadReportPresignedURL", ()=>downloadReportPresignedURL);
parcelHelpers.export(exports, "fetchDataFromPresignedURL", ()=>fetchDataFromPresignedURL);
parcelHelpers.export(exports, "getReportDetailsAction", ()=>getReportDetailsAction);
parcelHelpers.export(exports, "resetGetReportDetailsState", ()=>resetGetReportDetailsState);
parcelHelpers.export(exports, "approveReportAction", ()=>approveReportAction);
parcelHelpers.export(exports, "rejectReportAction", ()=>rejectReportAction);
parcelHelpers.export(exports, "startReportDetailsPollingAction", ()=>startReportDetailsPollingAction);
parcelHelpers.export(exports, "stopReportDetailsPollingAction", ()=>stopReportDetailsPollingAction);
parcelHelpers.export(exports, "getPresignedUrl", ()=>getPresignedUrl);
var _typesafeActions = require("typesafe-actions");
var _types = require("./types");
var searchReports = (0, _typesafeActions.createAsyncAction)((0, _types.SEARCH_REPORTS_REQUEST), (0, _types.SEARCH_REPORTS_SUCCESS), (0, _types.SEARCH_REPORTS_FAILURE))();
var downloadReport = (0, _typesafeActions.createAsyncAction)((0, _types.DOWNLOAD_REPORT_REQUEST), (0, _types.DOWNLOAD_REPORT_SUCCESS), (0, _types.DOWNLOAD_REPORT_FAILURE))();
var bulkDownloadReports = (0, _typesafeActions.createAsyncAction)((0, _types.BULK_DOWNLOAD_REPORTS_REQUEST), (0, _types.BULK_DOWNLOAD_REPORTS_SUCCESS), (0, _types.BULK_DOWNLOAD_REPORTS_FAILURE))();
var setReportSelection = (0, _typesafeActions.createAction)((0, _types.SET_REPORT_SELECTION))();
var getTermReportConfigs = (0, _typesafeActions.createAsyncAction)((0, _types.GET_TERM_REPORT_CONFIGS_REQUEST), (0, _types.GET_TERM_REPORT_CONFIGS_SUCCESS), (0, _types.GET_TERM_REPORT_CONFIGS_FAILURE))();
var selectLp = (0, _typesafeActions.createAction)((0, _types.SELECT_LP))();
var setSearchReportsPageSize = (0, _typesafeActions.createAction)((0, _types.SET_SEARCH_REPORTS_PAGE_SIZE))();
var setCurrentFolderPath = (0, _typesafeActions.createAction)((0, _types.SET_CURRENT_FOLDER_PATH))();
var setCurrentPage = (0, _typesafeActions.createAction)((0, _types.SET_CURRENT_PAGE))();
var setSortCriteria = (0, _typesafeActions.createAction)((0, _types.SET_SORT_CRITERIA))();
var resetReportsList = (0, _typesafeActions.createAction)((0, _types.RESET_REPORT_LIST))();
var setFilterSheetOpenAction = (0, _typesafeActions.createAction)((0, _types.SET_FILTER_SHEET_OPEN))();
var setFiltersAction = (0, _typesafeActions.createAction)((0, _types.SET_FILTERS))();
var initiateBulkUploadFilesAction = (0, _typesafeActions.createAsyncAction)((0, _types.INITIATE_BULK_UPLOAD_FILES_REQUEST), (0, _types.INITIATE_BULK_UPLOAD_FILES_SUCCESS), (0, _types.INITIATE_BULK_UPLOAD_FILES_FAILURE))();
var filePartsUploadAction = (0, _typesafeActions.createAsyncAction)((0, _types.FILE_PARTS_UPLOAD_REQUEST), (0, _types.FILE_PARTS_UPLOAD_SUCCESS), (0, _types.FILE_PARTS_UPLOAD_FAILURE))();
var completeBulkUploadFilesAction = (0, _typesafeActions.createAsyncAction)((0, _types.COMPLETE_BULK_UPLOAD_FILES_REQUEST), (0, _types.COMPLETE_BULK_UPLOAD_FILES_SUCCESS), (0, _types.COMPLETE_BULK_UPLOAD_FILES_FAILURE))();
var resetBulkFilesPartState = (0, _typesafeActions.createAction)((0, _types.RESET_BULK_FILES_PART_STATE))();
var resetIsTriggerSearchReportState = (0, _typesafeActions.createAction)((0, _types.RESET_IS_TRIGGER_SEARCH_REPORT))();
var uploadFileFolderAction = (0, _typesafeActions.createAsyncAction)((0, _types.UPLOAD_FILE_FOLDER_REQUEST), (0, _types.UPLOAD_FILE_FOLDER_SUCCESS), (0, _types.UPLOAD_FILE_FOLDER_FAILURE))();
var deleteReportAction = (0, _typesafeActions.createAsyncAction)((0, _types.DELETE_REPORT_REQUEST), (0, _types.DELETE_REPORT_SUCCESS), (0, _types.DELETE_REPORT_FAILURE))();
var generateReportAsync = (0, _typesafeActions.createAsyncAction)((0, _types.GENERATE_REPORT_ASYNC_REQUEST), (0, _types.GENERATE_REPORT_ASYNC_SUCCESS), (0, _types.GENERATE_REPORT_ASYNC_FAILURE))();
var resetIsTriggerGenerateReportAsync = (0, _typesafeActions.createAction)((0, _types.RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC))();
var reportPreviewEnabled = (0, _typesafeActions.createAction)((0, _types.PREVIEW_ENABLED))();
var generatePresignedUrl = (0, _typesafeActions.createAsyncAction)((0, _types.GENERATE_PRESIGNED_URL_REQUEST), (0, _types.GENERATE_PRESIGNED_URL_SUCCESS), (0, _types.GENERATE_PRESIGNED_URL_FAILURE))();
var setDDUList = (0, _typesafeActions.createAction)((0, _types.SET_DDU_LIST))();
var downloadReportPresignedURL = (0, _typesafeActions.createAsyncAction)((0, _types.GET_DOWNLOAD_REPORT_URL_REQUEST), (0, _types.GET_DOWNLOAD_REPORT_URL_SUCCESS), (0, _types.GET_DOWNLOAD_REPORT_URL_FAILURE))();
var fetchDataFromPresignedURL = (0, _typesafeActions.createAsyncAction)((0, _types.FETCH_DATA_FROM_PRESIGNED_URL_REQUEST), (0, _types.FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS), (0, _types.FETCH_DATA_FROM_PRESIGNED_URL_FAILURE))();
var getReportDetailsAction = (0, _typesafeActions.createAsyncAction)((0, _types.GET_REPORT_DETAILS_REQUEST), (0, _types.GET_REPORT_DETAILS_SUCCESS), (0, _types.GET_REPORT_DETAILS_FAILURE))();
var resetGetReportDetailsState = (0, _typesafeActions.createAction)((0, _types.RESET_GET_REPORT_DETAILS))();
var approveReportAction = (0, _typesafeActions.createAsyncAction)((0, _types.APPROVE_REPORT_REQUEST), (0, _types.APPROVE_REPORT_SUCCESS), (0, _types.APPROVE_REPORT_FAILURE))();
var rejectReportAction = (0, _typesafeActions.createAsyncAction)((0, _types.REJECT_REPORT_REQUEST), (0, _types.REJECT_REPORT_SUCCESS), (0, _types.REJECT_REPORT_FAILURE))();
var startReportDetailsPollingAction = (0, _typesafeActions.createAction)((0, _types.START_GET_REPORT_DETAILS_POLLING_REQUEST))();
var stopReportDetailsPollingAction = (0, _typesafeActions.createAction)((0, _types.STOP_GET_REPORT_DETAILS_POLLING_REQUEST))();
var getPresignedUrl = (0, _typesafeActions.createAsyncAction)((0, _types.GET_PRESIGNED_URL_REQUEST), (0, _types.GET_PRESIGNED_URL_SUCCESS), (0, _types.GET_PRESIGNED_URL_FAILURE))();

},{"typesafe-actions":"hqctR","./types":"20R3C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hqctR":[function(require,module,exports) {
!function(n, t) {
    t(exports);
}(this, function(n) {
    "use strict";
    function t(n) {
        return null == n;
    }
    function r(n) {
        throw new Error("Argument " + n + " is empty.");
    }
    function e(n) {
        return "function" == typeof n && "getType" in n;
    }
    function i(n) {
        throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
    }
    function o(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if (null == n.getType) throw new Error("Argument contains array with invalid element at index " + t + ', it should be an action-creator instance from "typesafe-actions"');
    }
    function u(n) {
        return "string" == typeof n || "symbol" == typeof n;
    }
    function a(n) {
        return !u(n);
    }
    function c(n) {
        throw new Error("Argument " + n + " is invalid, it should be an action type of type: string | symbol");
    }
    function f(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument contains array with invalid element at index " + t + ", it should be of type: string | symbol");
    }
    function s(n, e, o, u) {
        return t(n) && r(1), a(n) && i(1), {
            type: n,
            payload: e,
            meta: o,
            error: u
        };
    }
    function y(n, e) {
        t(n) && r(1), a(n) && c(1);
        return Object.assign(function() {
            var t = null != e ? e.apply(void 0, arguments) : void 0;
            return Object.assign({
                type: n
            }, t);
        }, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    function l(n, e, i) {
        return t(n) && r(1), a(n) && c(1), function() {
            return y(n, function() {
                var n = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1];
                return null == e && null == i || (n = null != e ? e.apply(void 0, arguments) : void 0, t = null != i ? i.apply(void 0, arguments) : void 0), Object.assign({}, void 0 !== n && {
                    payload: n
                }, {}, void 0 !== t && {
                    meta: t
                });
            });
        };
    }
    function p(n) {
        return t(n) && r(1), e(n) || i(1), n.getType();
    }
    function d(n, e) {
        t(n) && r(1), a(n) && c(1);
        var i = null != e ? e(n) : function() {
            return {
                type: n
            };
        };
        return Object.assign(i, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    var g = {
        createAction: function(n, t) {
            var r = null == t ? function() {
                return s(n);
            } : t(s.bind(null, n));
            return Object.assign(r, {
                getType: function() {
                    return n;
                },
                toString: function() {
                    return n;
                }
            });
        },
        createCustomAction: d,
        createStandardAction: function(n) {
            return t(n) && r(1), a(n) && c(1), Object.assign(function() {
                return d(n, function(n) {
                    return function(t, r) {
                        return {
                            type: n,
                            payload: t,
                            meta: r
                        };
                    };
                });
            }, {
                map: function(t) {
                    return d(n, function(n) {
                        return function(r, e) {
                            return Object.assign(t(r, e), {
                                type: n
                            });
                        };
                    });
                }
            });
        }
    };
    n.action = s, n.createAction = l, n.createAsyncAction = function(n, t, r, e) {
        return function() {
            var i = [
                n,
                t,
                r,
                e
            ].map(function(n, t) {
                return Array.isArray(n) ? l(n[0], n[1], n[2])() : "string" == typeof n || "symbol" == typeof n ? l(n)() : void (t < 3 && function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action type of "string | symbol" or a tuple of "[string | symbol, Function, Function?]"');
                }(t));
            });
            return {
                request: i[0],
                success: i[1],
                failure: i[2],
                cancel: i[3]
            };
        };
    }, n.createCustomAction = y, n.createReducer = function n(t, r) {
        void 0 === r && (r = {});
        var i = Object.assign({}, r), o = function(r, o) {
            var a = Array.isArray(r) ? r : [
                r
            ], c = {};
            return a.map(function(n, t) {
                return e(n) ? p(n) : u(n) ? n : function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
                }(t + 1);
            }).forEach(function(n) {
                return c[n] = o;
            }), n(t, Object.assign({}, i, {}, c));
        };
        return Object.assign(function(n, r) {
            if (void 0 === n && (n = t), i.hasOwnProperty(r.type)) {
                var e = i[r.type];
                if ("function" != typeof e) throw Error('Reducer under "' + r.type + '" key is not a valid reducer');
                return e(n, r);
            }
            return n;
        }, {
            handlers: Object.assign({}, i),
            handleAction: o,
            handleType: o
        });
    }, n.deprecated = g, n.getType = p, n.isActionOf = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(o);
        var u = function(n) {
            return i.some(function(t) {
                return n.type === t.getType();
            });
        };
        return void 0 === e ? u : u(e);
    }, n.isOfType = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(f);
        var o = function(n) {
            return i.includes(n.type);
        };
        return void 0 === e ? o : o(e);
    };
});

},{}],"bhWLv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportsCenterErrorCodes", ()=>reportsCenterErrorCodes);
var reportsCenterErrorCodes = {
    DEFAULT: "error_messages.default",
    MISSING_REPORT_RECORD: "download_report_notifications.missing_report",
    MISSING_REPORT: "download_report_notifications.missing_report",
    MISSING_VIEW_PERMISSIONS: "error_messages.missing_view_permission",
    MISSING_EDIT_PERMISSIONS: "error_messages.missing_edit_permission",
    MISSING_REPORT_CONFIGURATION: "error_messages.missing_report_configuration"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5tDjP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTermReportConfigsEpic", ()=>getTermReportConfigsEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var getTermReportConfigsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.GET_TERM_REPORT_CONFIGS_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.reportsCenterService.getTermReportConfigs(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            var _response_termReportConfigurationsList;
            return (0, _rxjs.of)((0, _actions.getTermReportConfigs).success((_response_termReportConfigurationsList = response === null || response === void 0 ? void 0 : response.termReportConfigurationsList) !== null && _response_termReportConfigurationsList !== void 0 ? _response_termReportConfigurationsList : []));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.getTermReportConfigs).failure(err));
        })));
    }));
};
exports.default = getTermReportConfigsEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ibL1N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchReportsEpic", ()=>searchReportsEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _errorCodeMessages = require("../../../config/errorCodeMessages");
var searchReportsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.SEARCH_REPORTS_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.searchReports((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.reqPayload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.resetIsTriggerSearchReportState)(), (0, _actions.searchReports).success(response));
        }), (0, _operators.catchError)(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return (0, _rxjs.of)((0, _actions.resetIsTriggerSearchReportState)(), (0, _actions.searchReports).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.SEARCH_REPORTS_FAILURE),
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = (0, _errorCodeMessages.reportsCenterErrorCodes)[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "search_reports_notifications.failure" : "search_reports_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = searchReportsEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../config/errorCodeMessages":"bhWLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3fxiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initiateBulkUploadFilesEpic", ()=>initiateBulkUploadFilesEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var _upload = require("../../../constants/upload");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/ui/types");
var _errorCodeMessages = require("../../../config/errorCodeMessages");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var initiateBulkUploadFilesEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.INITIATE_BULK_UPLOAD_FILES_REQUEST)), (0, _operators.switchMap)(function(param) {
        var payload = param.payload;
        var initiateBatchReportUploadInput = payload.initiateBatchReportUploadInput, files = payload.files;
        return (0, _rxjs.from)(api.reportsCenterService.initiateBatchReportUpload(initiateBatchReportUploadInput).pipe((0, _operators.mergeMap)(function(initiateBatchReportUploadOutput) {
            var _ref = initiateBatchReportUploadOutput || {}, initiateUploadResponseList = _ref.InitiateUploadResponseList;
            var parallelPartsUploadObservables = initiateUploadResponseList.map(function(initiateUploadResponse, index) {
                var requiredFile = files[index];
                var partUploadRequests = [];
                var sentSize = 0;
                if (requiredFile) initiateUploadResponse.partPresignedURLs.forEach(function(partPresignedURL, index) {
                    sentSize = index * (0, _upload.CHUNKS_SIZE);
                    partUploadRequests.push(api.reportsCenterService.uploadWithS3PresignedUrl({
                        file: requiredFile.slice(sentSize, sentSize + (0, _upload.CHUNKS_SIZE)),
                        s3presignedUrl: partPresignedURL
                    }));
                });
                return {
                    partUploadRequests: partUploadRequests,
                    uploadId: initiateUploadResponse.uploadId,
                    reportId: initiateUploadResponse === null || initiateUploadResponse === void 0 ? void 0 : initiateUploadResponse.reportId,
                    partPresignedURLs: initiateUploadResponse.partPresignedURLs,
                    key: initiateBatchReportUploadInput.InitiateUploadRequestList[index].key,
                    supportingDocumentInfo: initiateBatchReportUploadInput.InitiateUploadRequestList[index].supportingDocumentInfo,
                    logisticsPartyId: initiateBatchReportUploadInput.logisticsPartyId,
                    reportType: initiateBatchReportUploadInput.reportType,
                    term: initiateBatchReportUploadInput.term
                };
            });
            var filePartsUploadActions = parallelPartsUploadObservables.map(function(parallelPartsUploadObservable) {
                return (0, _actions.filePartsUploadAction).request(parallelPartsUploadObservable);
            });
            return (0, _rxjs.of).apply(void 0, [
                (0, _actions.initiateBulkUploadFilesAction).success({
                    initiateBatchReportUploadOutput: initiateBatchReportUploadOutput
                })
            ].concat(_to_consumable_array(filePartsUploadActions)));
        }), (0, _operators.catchError)(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return (0, _rxjs.of)((0, _actions.initiateBulkUploadFilesAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).ERROR,
                action: (0, _types.INITIATE_BULK_UPLOAD_FILES_FAILURE),
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = (0, _errorCodeMessages.reportsCenterErrorCodes)[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "initiate_upload_files_notifications.failure" : "initiate_upload_files_notifications.failure",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = initiateBulkUploadFilesEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../constants/upload":"lSFPs","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../config/errorCodeMessages":"bhWLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lSFPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHUNKS_SIZE", ()=>CHUNKS_SIZE);
parcelHelpers.export(exports, "UPLOAD_STATUS", ()=>UPLOAD_STATUS);
parcelHelpers.export(exports, "DEFAULT_ACCEPTED_FILE_TYPES", ()=>DEFAULT_ACCEPTED_FILE_TYPES);
parcelHelpers.export(exports, "FILE_COUNT_LIMIT", ()=>FILE_COUNT_LIMIT);
parcelHelpers.export(exports, "FILE_SIZE_LIMIT", ()=>FILE_SIZE_LIMIT);
parcelHelpers.export(exports, "FILE_SIZE_LIMIT_GB", ()=>FILE_SIZE_LIMIT_GB);
parcelHelpers.export(exports, "SUPPORTING_DOCUMENTS_FILE_SIZE_LIMIT", ()=>SUPPORTING_DOCUMENTS_FILE_SIZE_LIMIT);
parcelHelpers.export(exports, "SUPPORTING_DOCUMENTS_FILE_SIZE_LIMIT_MB", ()=>SUPPORTING_DOCUMENTS_FILE_SIZE_LIMIT_MB);
parcelHelpers.export(exports, "SUPPORTING_FILES_COUNT_LIMIT", ()=>SUPPORTING_FILES_COUNT_LIMIT);
parcelHelpers.export(exports, "SUPPORTING_DOCUMENTS_FILE_TYPES", ()=>SUPPORTING_DOCUMENTS_FILE_TYPES);
parcelHelpers.export(exports, "SAMPLE_FILE_TEMPLATE", ()=>SAMPLE_FILE_TEMPLATE);
parcelHelpers.export(exports, "EXCEL_UPLOAD_FIELDS", ()=>EXCEL_UPLOAD_FIELDS);
var CHUNKS_SIZE = 262144000; // 250MB
var UPLOAD_STATUS = {
    IN_PROGRESS: "IN_PROGRESS",
    FAILURE: "FAILURE",
    SUCCESS: "SUCCESS"
};
var DEFAULT_ACCEPTED_FILE_TYPES = ".txt,.xlsx,.xls,.csv,.pdf,.png,.jpg,.jpeg";
var FILE_COUNT_LIMIT = 20;
var FILE_SIZE_LIMIT = 5368709120; // 5 GB
var FILE_SIZE_LIMIT_GB = 5; // 5 GB
var SUPPORTING_DOCUMENTS_FILE_SIZE_LIMIT = 5242880; // 5 MB
var SUPPORTING_DOCUMENTS_FILE_SIZE_LIMIT_MB = 5; // 5 MB
var SUPPORTING_FILES_COUNT_LIMIT = 2;
var SUPPORTING_DOCUMENTS_FILE_TYPES = ".eml,.pdf,.png,.jpg,.jpeg";
var SAMPLE_FILE_TEMPLATE = "EDI_INV_NUMBER,ACCOUNT_NUMBER,AMAZON_REF_ID,CARRIER_REF_ID,CHARGE_X_AMOUNT,CHARGE_X_CODE,INV_NUMBER,SCAC,AMAZON_CREDIT_NOTE_IDENTIFIER,AMAZON_VAT_ID,ARN,ASIN,BILL_ADDRESS_LINE_1,BILL_ADDRESS_LINE_2,BILL_CITY,BILL_COMPANY,BILL_COUNTRY_CODE,BILL_NAME,BILL_POSTAL_CODE,BILL_STATE,BOLN,CARRIER_ADDRESS_LINE_1,CARRIER_ADDRESS_LINE_2,CARRIER_CITY,CARRIER_COMPANY,CARRIER_COUNTRY_CODE,CARRIER_NAME,CARRIER_POSTAL_CODE,CARRIER_STATE,CARRIER_VAT_ID,CHARGE_X_PREVIOUS_SERVICE_ID,CHARGE_X_PREVIOUS_TRANSACTION_ID,CONSIGMENT,CORRECTED_ADDRESS_LINE_1,CORRECTED_ADDRESS_LINE_2,CORRECTED_CITY,CORRECTED_COMPANY,CORRECTED_COUNTRY_CODE,CORRECTED_NAME,CORRECTED_POSTAL_CODE,CORRECTED_STATE,CURRENCY_CODE,DELIVERED_DATE,DELIVERED_POINT,DESTINATION_ZIP5,DIM_HEIGHT,DIM_LENGTH,DIM_WIDTH,DISCOUNT,DISTANCE,DISTANCE_UNIT,DOCUMENT_TYPE_CODE,FREIGHT_CLASS,FREIGHT_TERM,FROM_ADDRESS_LINE_1,FROM_ADDRESS_LINE_2,FROM_CITY,FROM_COMPANY,FROM_COUNTRY_CODE,FROM_NAME,FROM_POSTAL_CODE,FROM_STATE,HOURS,INV_BARCODE,INV_BASE_AMT,INV_DATE,INV_FET_AMT,INV_FET_PCT,INV_TAX_X_AMOUNT,INV_TAX_X_NAME,INV_TAX_X_PERCENTAGE,INV_TAX_X_TAXABLE_AMOUNT,INV_TOTAL_AMT,INV_VAT_AMT,INV_VAT_PCT,INVOICE_WEIGHT,ISA,ITEM_CLASS,LENGTH_UNIT_OF_MEASURE,LI_BASE_AMT,LI_TOTAL_AMT,LI_VAT_AMT,LI_VAT_PCT,LINE_ITEM_ID,MILES,MINIMUM_CHARGE,ORIGIN_ZIP5,PACKAGE_COUNT,PACKAGE_WEIGHT,PICKUP_DATE,PICKUP_POINT,PICKUP_TIME,PO_NUMBER,PO_QUANTITY,PO_UNIT,PREVIOUS_CONTAINER_ID,PREVIOUS_INV_NUMBER,PREVIOUS_INV_VERSION,SHIP_ADDRESS_LINE_1,SHIP_ADDRESS_LINE_2,SHIP_CITY,SHIP_COMPANY,SHIP_COUNTRY_CODE,SHIP_NAME,SHIP_POSTAL_CODE,SHIP_STATE,SHIPPER_ACCOUNT,STOP_OVERS,TAX_X_AMOUNT,TAX_X_NAME,TAX_X_PERCENTAGE,TAX_X_TAXABLE_AMOUNT,TO_ADDRESS_LINE_1,TO_ADDRESS_LINE_2,TO_CITY,TO_COUNTRY_CODE,TO_NAME,TO_POSTAL_CODE,TO_STATE,VAT_CURRENCY_CODE,VEHICLE_TYPE,WEIGHT_UNIT_OF_MEASURE,ZONE";
var EXCEL_UPLOAD_FIELDS = {
    reasonForUpload: "reasonForUpload",
    template: "template"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"15Kyt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filePartsUploadEpic", ()=>filePartsUploadEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var filePartsUploadEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.FILE_PARTS_UPLOAD_REQUEST)), (0, _operators.mergeMap)(function(param) {
        var payload = param.payload;
        var partUploadRequests = payload.partUploadRequests, key = payload.key;
        // forkJoin works like Promise.all()
        return (0, _rxjs.forkJoin)(partUploadRequests).pipe((0, _operators.mergeMap)(function(response) {
            if (response.includes(false)) return (0, _rxjs.of)((0, _actions.filePartsUploadAction).failure({
                key: key
            }));
            var eTags = [];
            response.forEach(function(res) {
                var _res_xhr_getResponseHeader;
                eTags.push((_res_xhr_getResponseHeader = res.xhr.getResponseHeader("ETag")) === null || _res_xhr_getResponseHeader === void 0 ? void 0 : _res_xhr_getResponseHeader.replaceAll('"', ""));
            });
            return (0, _rxjs.of)((0, _actions.filePartsUploadAction).success({
                eTags: eTags,
                key: key
            }));
        }));
    }));
};
exports.default = filePartsUploadEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8P5q2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "completeBulkUploadFilesEpic", ()=>completeBulkUploadFilesEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/ui/types");
var _constants = require("../../../constants");
var completeBulkUploadFilesEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.COMPLETE_BULK_UPLOAD_FILES_REQUEST)), (0, _operators.switchMap)(function(param) {
        var payload = param.payload;
        var completeBatchReportUploadInput = payload.completeBatchReportUploadInput;
        return (0, _rxjs.from)(api.reportsCenterService.completeBatchReportUpload(completeBatchReportUploadInput).pipe((0, _operators.delay)((0, _constants.BACKEND_SYNC_DELAY)), (0, _operators.mergeMap)(function(completeBatchReportUploadOutput) {
            return (0, _rxjs.of)((0, _actions.completeBulkUploadFilesAction).success({
                completeBatchReportUploadOutput: completeBatchReportUploadOutput
            }), (0, _ui.closeModalAction)({
                type: (0, _types1.UPLOAD_FILES_MODAL)
            }), (0, _ui.closeModalAction)({
                type: (0, _types1.UPLOAD_REPORT_MODAL)
            }), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).SUCCESS,
                action: (0, _types.COMPLETE_BULK_UPLOAD_FILES_SUCCESS),
                body: "complete_upload_files_notifications.success",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.completeBulkUploadFilesAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).ERROR,
                action: (0, _types.COMPLETE_BULK_UPLOAD_FILES_FAILURE),
                body: "complete_upload_files_notifications.failure",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = completeBulkUploadFilesEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../constants":"bsj5K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bsj5K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REPORTS_LIST_PAGE_SIZE_OPTIONS", ()=>REPORTS_LIST_PAGE_SIZE_OPTIONS);
parcelHelpers.export(exports, "DEFAULT_REPORTS_LIST_PAGE_SIZE", ()=>DEFAULT_REPORTS_LIST_PAGE_SIZE);
parcelHelpers.export(exports, "ELLIPSIS", ()=>ELLIPSIS);
parcelHelpers.export(exports, "START_WORKFLOW_STATE", ()=>START_WORKFLOW_STATE);
parcelHelpers.export(exports, "SLASH", ()=>SLASH);
parcelHelpers.export(exports, "BACKEND_SYNC_DELAY", ()=>BACKEND_SYNC_DELAY);
parcelHelpers.export(exports, "MERIDIAN_DATE_FORMAT", ()=>MERIDIAN_DATE_FORMAT);
parcelHelpers.export(exports, "UI_DATE_FORMAT", ()=>UI_DATE_FORMAT);
parcelHelpers.export(exports, "SP_PERFORMANCE_MANAGEMENT", ()=>SP_PERFORMANCE_MANAGEMENT);
parcelHelpers.export(exports, "EXCEL_INVOICE_REPORTS", ()=>EXCEL_INVOICE_REPORTS);
parcelHelpers.export(exports, "FREQUENCY_TO_POLL_GET_MILLI_SECS", ()=>FREQUENCY_TO_POLL_GET_MILLI_SECS);
parcelHelpers.export(exports, "MAX_ALLOWED_POLLS_BEFORE_TIMEOUT", ()=>MAX_ALLOWED_POLLS_BEFORE_TIMEOUT);
var REPORTS_LIST_PAGE_SIZE_OPTIONS = [
    5,
    10,
    20,
    30,
    50
];
var DEFAULT_REPORTS_LIST_PAGE_SIZE = 20;
var ELLIPSIS = "...";
var START_WORKFLOW_STATE = "START";
var SLASH = "/";
var BACKEND_SYNC_DELAY = 2000;
var MERIDIAN_DATE_FORMAT = "yyyy-MM-dd";
var UI_DATE_FORMAT = "dd/MM/yyyy";
var SP_PERFORMANCE_MANAGEMENT = "SP_PERFORMANCE_MANAGEMENT";
var EXCEL_INVOICE_REPORTS = "EXCEL_INVOICE_REPORTS";
var FREQUENCY_TO_POLL_GET_MILLI_SECS = 5000;
var MAX_ALLOWED_POLLS_BEFORE_TIMEOUT = 36;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6OQ8J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uploadFileFolderEpic", ()=>uploadFileFolderEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _constants = require("../../../constants");
var uploadFileFolderEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.UPLOAD_FILE_FOLDER_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.reportsCenterService.uploadReport(action.payload.uploadReportInput).pipe((0, _operators.delay)((0, _constants.BACKEND_SYNC_DELAY)), (0, _operators.mergeMap)(function(response) {
            var _action_payload_uploadReportInput, _action_payload;
            return (0, _rxjs.of)((0, _actions.uploadFileFolderAction).success(response), (0, _ui.closeModalAction)({
                type: (0, _types.FOLDER_CREATE_MODAL)
            }), (0, _actions.setCurrentFolderPath)((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_uploadReportInput = _action_payload.uploadReportInput) === null || _action_payload_uploadReportInput === void 0 ? void 0 : _action_payload_uploadReportInput.objectKey));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.uploadFileFolderAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.UPLOAD_FILE_FOLDER_FAILURE),
                body: "upload_file_folder_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = uploadFileFolderEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../constants":"bsj5K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jeg0e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteReportEpic", ()=>deleteReportEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _constants = require("../../../constants");
var deleteReportEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.DELETE_REPORT_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.deleteReport((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.deleteReportInput).pipe((0, _operators.delay)((0, _constants.BACKEND_SYNC_DELAY)), (0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.deleteReportAction).success(response), (0, _ui.closeModalAction)({
                type: (0, _types.DELETE_REPORT_MODAL)
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _types1.DELETE_REPORT_SUCCESS),
                body: "delete_report_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.deleteReportAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.DELETE_REPORT_FAILURE),
                body: "delete_report_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = deleteReportEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../constants":"bsj5K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dsfME":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bulkDownloadReportsEpic", ()=>bulkDownloadReportsEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _errorCodeMessages = require("../../../config/errorCodeMessages");
var bulkDownloadReportsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.BULK_DOWNLOAD_REPORTS_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload_reportIds, _action_payload;
        var downloadReportRequests = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_reportIds = _action_payload.reportIds) === null || _action_payload_reportIds === void 0 ? void 0 : _action_payload_reportIds.map(function(reportId) {
            var _action_payload, _action_payload1, _action_payload2;
            return api.reportsCenterService.downloadReport({
                logisticsPartyId: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.logisticsPartyId,
                term: (_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.term,
                reportType: (_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : _action_payload2.reportType,
                reportId: reportId
            }).pipe((0, _operators.catchError)(function(err) {
                var _err_receivedException, _err_receivedException1;
                var _reportsCenterErrorCodes_err_receivedException_errorCode;
                return (0, _rxjs.of)((0, _actions.downloadReport).failure(err), (0, _ui.addNotification)({
                    type: (0, _types.NotificationTypeEnum).ERROR,
                    action: (0, _types1.BULK_DOWNLOAD_REPORTS_FAILURE),
                    body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = (0, _errorCodeMessages.reportsCenterErrorCodes)[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "download_report_notifications.failure" : "download_report_notifications.failure",
                    timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
                }));
            }));
        });
        return (0, _rxjs.forkJoin)(downloadReportRequests).pipe((0, _operators.mergeMap)(function(response) {
            if (response) // TODO: Figure out a better way for bulk download
            response.forEach(function(fileDownloadDetails) {
                if (fileDownloadDetails === null || fileDownloadDetails === void 0 ? void 0 : fileDownloadDetails.downloadUrl) window.open(fileDownloadDetails === null || fileDownloadDetails === void 0 ? void 0 : fileDownloadDetails.downloadUrl, "_blank");
            });
            return (0, _rxjs.of)((0, _actions.bulkDownloadReports).success(), (0, _actions.setReportSelection)([]));
        }));
    }));
};
exports.default = bulkDownloadReportsEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../config/errorCodeMessages":"bhWLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5A6TJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadReportPresignedURLEpic", ()=>downloadReportPresignedURLEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _errorCodeMessages = require("../../../config/errorCodeMessages");
var downloadReportPresignedURLEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.GET_DOWNLOAD_REPORT_URL_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.reportsCenterService.downloadReport(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.downloadReportPresignedURL).success(response), (0, _actions.fetchDataFromPresignedURL).request({
                presignedUrl: response === null || response === void 0 ? void 0 : response.downloadUrl
            }));
        }), (0, _operators.catchError)(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return (0, _rxjs.of)((0, _actions.downloadReportPresignedURL).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.GET_DOWNLOAD_REPORT_URL_FAILURE),
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = (0, _errorCodeMessages.reportsCenterErrorCodes)[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "download_report_notifications.failure" : "download_report_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = downloadReportPresignedURLEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../config/errorCodeMessages":"bhWLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdtkm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getReportDetailsEpic", ()=>getReportDetailsEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var _errorCodeMessages = require("../../../config/errorCodeMessages");
var getReportDetailsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.GET_REPORT_DETAILS_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.searchReports((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.getReportDetailsInput).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.getReportDetailsAction).success(response));
        }), (0, _operators.catchError)(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return (0, _rxjs.of)((0, _actions.getReportDetailsAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.GET_REPORT_DETAILS_FAILURE),
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = (0, _errorCodeMessages.reportsCenterErrorCodes)[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "get_report_details_notifications.failure" : "get_report_details_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = getReportDetailsEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../config/errorCodeMessages":"bhWLv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cY9eV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "approveReportEpic", ()=>approveReportEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var approveReportEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.APPROVE_REPORT_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.approveReport((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.approveReportInput).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.approveReportAction).success(response), (0, _ui.closeModalAction)({
                type: (0, _types.APPROVE_REPORT_MODAL)
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _types1.APPROVE_REPORT_SUCCESS),
                body: "approve_report_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.approveReportAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.APPROVE_REPORT_FAILURE),
                body: "approve_report_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = approveReportEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1rrkH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rejectReportEpic", ()=>rejectReportEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ui = require("../../../actions/ui");
var _types = require("../../../actions/ui/types");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var rejectReportEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.REJECT_REPORT_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.rejectReport((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.rejectReportInput).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.rejectReportAction).success(response), (0, _ui.closeModalAction)({
                type: (0, _types.REJECT_REPORT_MODAL)
            }), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).SUCCESS,
                action: (0, _types1.REJECT_REPORT_SUCCESS),
                body: "reject_report_notifications.success",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.rejectReportAction).failure(err), (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                action: (0, _types1.REJECT_REPORT_FAILURE),
                body: "reject_report_notifications.failure",
                timeout: (0, _types.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = rejectReportEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","../../../actions/types":"20R3C","../../../actions":"4lbye","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"P0UJf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getReportDetailsPollingEpic", ()=>getReportDetailsPollingEpic);
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _constants = require("../../../constants");
var _types = require("../../../actions/ui/types");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/types");
var _actions = require("../../../actions");
var getReportDetailsPollingEpic = function(action$) {
    var stopPolling$ = action$.pipe((0, _reduxObservable.ofType)((0, _types1.STOP_GET_REPORT_DETAILS_POLLING_REQUEST)));
    return action$.pipe((0, _reduxObservable.ofType)((0, _types1.START_GET_REPORT_DETAILS_POLLING_REQUEST)), (0, _operators.switchMap)(function(param) {
        var payload = param.payload;
        return (0, _rxjs.timer)(0, (0, _constants.FREQUENCY_TO_POLL_GET_MILLI_SECS)).pipe((0, _operators.take)((0, _constants.MAX_ALLOWED_POLLS_BEFORE_TIMEOUT) + 1), (0, _operators.takeUntil)(stopPolling$), (0, _operators.map)(function(pollCount) {
            if (pollCount === (0, _constants.MAX_ALLOWED_POLLS_BEFORE_TIMEOUT)) return (0, _ui.addNotification)({
                type: (0, _types.NotificationTypeEnum).ERROR,
                body: "get_report_details_polling_notifications.polling_timed_out",
                timeout: (0, _types.POLLING_NOTIFICATION_CLOSE_TIMEOUT)
            });
            return (0, _actions.getReportDetailsAction).request(payload);
        }));
    }));
};
exports.default = getReportDetailsPollingEpic;

},{"redux-observable":"4cxuH","rxjs/operators":"b5gYA","rxjs":"cdYcx","../../../constants":"bsj5K","../../../actions/ui/types":"hP7mC","../../../actions/ui":"9VSZL","../../../actions/types":"20R3C","../../../actions":"4lbye","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1UUOO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPresignedUrlEpic", ()=>getPresignedUrlEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/ui/types");
var getPresignedUrlEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.GET_PRESIGNED_URL_REQUEST)), (0, _operators.switchMap)(function(action) {
        var _action_payload;
        return (0, _rxjs.from)(api.reportsCenterService.generatePresignedUrl((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.getPresignedUrlInput).pipe((0, _operators.mergeMap)(function(response) {
            var _action_payload;
            if ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.triggerDownload) window.open(response === null || response === void 0 ? void 0 : response.presignedUrl, "_blank");
            var _response_presignedUrl;
            return (0, _rxjs.of)((0, _actions.getPresignedUrl).success((_response_presignedUrl = response === null || response === void 0 ? void 0 : response.presignedUrl) !== null && _response_presignedUrl !== void 0 ? _response_presignedUrl : []));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.getPresignedUrl).failure(err), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).ERROR,
                action: (0, _types.GET_PRESIGNED_URL_FAILURE),
                body: "error_messages.default",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = getPresignedUrlEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eEyuv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateReportEpics", ()=>generateReportEpics);
var _fetchDataFromPresignedURLEpic = require("./fetchDataFromPresignedURLEpic");
var _generateReportAsyncEpic = require("./generateReportAsyncEpic");
var _getDDUOptionsEpic = require("./getDDUOptionsEpic");
var _getDDUOptionsEpicDefault = parcelHelpers.interopDefault(_getDDUOptionsEpic);
var generateReportEpics = [
    (0, _generateReportAsyncEpic.generateReportAsyncEpic),
    (0, _getDDUOptionsEpicDefault.default),
    (0, _fetchDataFromPresignedURLEpic.fetchDataFromPresignedURLEpic)
];
exports.default = generateReportEpics;

},{"./fetchDataFromPresignedURLEpic":"lUm6q","./generateReportAsyncEpic":"gOdWr","./getDDUOptionsEpic":"6TY4T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lUm6q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchDataFromPresignedURLEpic", ()=>fetchDataFromPresignedURLEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _actions = require("../../../actions");
var _types = require("../../../actions/types");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/ui/types");
var fetchDataFromPresignedURLEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.FETCH_DATA_FROM_PRESIGNED_URL_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.reportsCenterService.downloadWithS3PresignedUrl(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.fetchDataFromPresignedURL).success(response));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.fetchDataFromPresignedURL).failure(err), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).ERROR,
                action: (0, _types.FETCH_DATA_FROM_PRESIGNED_URL_FAILURE),
                body: "error_messages.default",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = fetchDataFromPresignedURLEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions":"4lbye","../../../actions/types":"20R3C","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOdWr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateReportAsyncEpic", ()=>generateReportAsyncEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/ui/types");
var generateReportAsyncEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.GENERATE_REPORT_ASYNC_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.reportsCenterService.generateReportAsync(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            return (0, _rxjs.of)((0, _actions.generateReportAsync).success(response), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).SUCCESS,
                action: (0, _types.GENERATE_REPORT_ASYNC_SUCCESS),
                body: "generate_report_notifications.success",
                timeout: 15000
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.generateReportAsync).failure(err), (0, _actions.resetIsTriggerGenerateReportAsync)(), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).ERROR,
                action: (0, _types.GENERATE_REPORT_ASYNC_FAILURE),
                body: "error_messages.default",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = generateReportAsyncEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6TY4T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePresignedUrlEpic", ()=>generatePresignedUrlEpic);
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var _ui = require("../../../actions/ui");
var _types1 = require("../../../actions/ui/types");
var generatePresignedUrlEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe((0, _reduxObservable.ofType)((0, _types.GENERATE_PRESIGNED_URL_REQUEST)), (0, _operators.switchMap)(function(action) {
        return (0, _rxjs.from)(api.reportsCenterService.generatePresignedUrl(action.payload).pipe((0, _operators.mergeMap)(function(response) {
            var _response_presignedUrl;
            return (0, _rxjs.of)((0, _actions.generatePresignedUrl).success((_response_presignedUrl = response === null || response === void 0 ? void 0 : response.presignedUrl) !== null && _response_presignedUrl !== void 0 ? _response_presignedUrl : []), (0, _actions.fetchDataFromPresignedURL).request({
                presignedUrl: response === null || response === void 0 ? void 0 : response.presignedUrl
            }));
        }), (0, _operators.catchError)(function(err) {
            return (0, _rxjs.of)((0, _actions.generatePresignedUrl).failure(err), (0, _ui.addNotification)({
                type: (0, _types1.NotificationTypeEnum).ERROR,
                action: (0, _types.GENERATE_PRESIGNED_URL_FAILURE),
                body: "error_messages.default",
                timeout: (0, _types1.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT)
            }));
        })));
    }));
};
exports.default = generatePresignedUrlEpic;

},{"redux-observable":"4cxuH","rxjs":"cdYcx","rxjs/operators":"b5gYA","../../../actions/types":"20R3C","../../../actions":"4lbye","../../../actions/ui":"9VSZL","../../../actions/ui/types":"hP7mC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fOqfj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _reportsCenterReducer = require("./reportsCenterReducer");
var _ui = require("./ui");
var _uiDefault = parcelHelpers.interopDefault(_ui);
var _generateReportReducer = require("./generateReportReducer");
var rootReducer = (0, _redux.combineReducers)({
    reportsCenter: (0, _reportsCenterReducer.reportsCenterReducer),
    generateReport: (0, _generateReportReducer.generateReportReducer),
    ui: (0, _uiDefault.default)
});
exports.default = rootReducer;

},{"redux":"5nGOx","./reportsCenterReducer":"bdkLu","./ui":"7ogp4","./generateReportReducer":"d3cYD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdkLu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "reportsCenterReducer", ()=>reportsCenterReducer);
var _types = require("../../actions/types");
var _constants = require("../../constants");
var _upload = require("../../constants/upload");
var _search = require("../../constants/search");
var _download = require("../../constants/download");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
var initialState = {
    reportsList: [],
    reportsListTotalRecords: 0,
    searchReportsPageSize: (0, _constants.DEFAULT_REPORTS_LIST_PAGE_SIZE),
    termReportConfigs: null,
    getTermReportConfigsError: false,
    downloadedReport: null,
    lpSelected: "",
    bulkFilesPartsUpload: {},
    isTriggerSearchReport: false,
    currentFolderPath: "",
    currentPage: 1,
    selectedReports: [],
    sortCriteria: (0, _search.DEFAULT_SORT_CRITERIA),
    isPreviewEnabled: false,
    downloadReportPresignedURL: null,
    reportDetails: null,
    filterSheetOpen: false,
    filters: {},
    isGetReportDetailsPolling: false
};
function reportsCenterReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, _ref = arguments.length > 1 ? arguments[1] : void 0, type = _ref.type, payload = _ref.payload;
    switch(type){
        case 0, _types.SEARCH_REPORTS_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                reportsListTotalRecords: 0
            });
        case 0, _types.SEARCH_REPORTS_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                reportsList: payload.reportList,
                reportsListTotalRecords: payload.totalRecords
            });
        case 0, _types.GET_TERM_REPORT_CONFIGS_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                getTermReportConfigsError: false
            });
        case 0, _types.GET_TERM_REPORT_CONFIGS_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                termReportConfigs: payload
            });
        case 0, _types.GET_TERM_REPORT_CONFIGS_FAILURE:
            return _object_spread_props(_object_spread({}, state), {
                getTermReportConfigsError: true
            });
        case 0, _types.DOWNLOAD_REPORT_SUCCESS:
            var _Object_values;
            var _payload_supportingDocumentUrls;
            if ((payload === null || payload === void 0 ? void 0 : payload.downloadType) === (0, _download.DOWNLOAD_TYPE).SUPPORTING_DOCUMENTS && ((_Object_values = Object.values((_payload_supportingDocumentUrls = payload === null || payload === void 0 ? void 0 : payload.supportingDocumentUrls) !== null && _payload_supportingDocumentUrls !== void 0 ? _payload_supportingDocumentUrls : {})) === null || _Object_values === void 0 ? void 0 : _Object_values.length)) {
                var _Object_values1;
                var _payload_supportingDocumentUrls1;
                (_Object_values1 = Object.values((_payload_supportingDocumentUrls1 = payload === null || payload === void 0 ? void 0 : payload.supportingDocumentUrls) !== null && _payload_supportingDocumentUrls1 !== void 0 ? _payload_supportingDocumentUrls1 : {})) === null || _Object_values1 === void 0 || _Object_values1.forEach(function(downloadUrl, index) {
                    if (payload === null || payload === void 0 ? void 0 : payload.supportingDocumentKey) {
                        var _Object_keys_index, _Object_keys;
                        var _payload_supportingDocumentUrls;
                        if ((_Object_keys = Object.keys((_payload_supportingDocumentUrls = payload === null || payload === void 0 ? void 0 : payload.supportingDocumentUrls) !== null && _payload_supportingDocumentUrls !== void 0 ? _payload_supportingDocumentUrls : {})) === null || _Object_keys === void 0 ? void 0 : (_Object_keys_index = _Object_keys[index]) === null || _Object_keys_index === void 0 ? void 0 : _Object_keys_index.endsWith(payload === null || payload === void 0 ? void 0 : payload.supportingDocumentKey)) window.open(downloadUrl, "_blank");
                    } else window.open(downloadUrl, "_blank");
                });
            } else if ((payload === null || payload === void 0 ? void 0 : payload.downloadType) === (0, _download.DOWNLOAD_TYPE).REPORT && (payload === null || payload === void 0 ? void 0 : payload.downloadUrl)) window.open(payload === null || payload === void 0 ? void 0 : payload.downloadUrl, "_blank");
            return _object_spread_props(_object_spread({}, state), {
                downloadedReport: payload
            });
        case 0, _types.SELECT_LP:
            return _object_spread_props(_object_spread({}, state), {
                lpSelected: payload,
                currentPage: 1,
                currentFolderPath: "",
                selectedReports: []
            });
        case 0, _types.RESET_REPORT_LIST:
            return _object_spread_props(_object_spread({}, state), {
                reportsList: [],
                reportsListTotalRecords: 0
            });
        case 0, _types.SET_CURRENT_FOLDER_PATH:
            return _object_spread_props(_object_spread({}, state), {
                currentFolderPath: payload,
                currentPage: 1,
                selectedReports: []
            });
        case 0, _types.SET_CURRENT_PAGE:
            return _object_spread_props(_object_spread({}, state), {
                currentPage: payload,
                selectedReports: []
            });
        case 0, _types.SET_SEARCH_REPORTS_PAGE_SIZE:
            return _object_spread_props(_object_spread({}, state), {
                searchReportsPageSize: payload,
                currentPage: 1
            });
        case 0, _types.FILE_PARTS_UPLOAD_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                bulkFilesPartsUpload: _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload), _define_property({}, payload.key, {
                    status: (0, _upload.UPLOAD_STATUS).IN_PROGRESS,
                    uploadId: payload.uploadId,
                    reportId: payload.reportId,
                    supportingDocumentInfo: payload.supportingDocumentInfo,
                    partPresignedURLs: payload.partPresignedURLs,
                    key: payload.key,
                    logisticsPartyId: payload.logisticsPartyId,
                    reportType: payload.reportType,
                    term: payload.term
                }))
            });
        case 0, _types.FILE_PARTS_UPLOAD_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                bulkFilesPartsUpload: _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload), _define_property({}, payload.key, _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload[payload.key] || {}), {
                    status: (0, _upload.UPLOAD_STATUS).SUCCESS,
                    eTags: payload.eTags
                })))
            });
        case 0, _types.RESET_IS_TRIGGER_SEARCH_REPORT:
            return _object_spread_props(_object_spread({}, state), {
                isTriggerSearchReport: false
            });
        case 0, _types.FILE_PARTS_UPLOAD_FAILURE:
            return _object_spread_props(_object_spread({}, state), {
                bulkFilesPartsUpload: _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload), _define_property({}, payload.key, _object_spread_props(_object_spread({}, state.bulkFilesPartsUpload[payload.key] || {}), {
                    status: (0, _upload.UPLOAD_STATUS).FAILURE
                })))
            });
        case 0, _types.COMPLETE_BULK_UPLOAD_FILES_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                isTriggerSearchReport: true,
                bulkFilesPartsUpload: {},
                selectedReports: []
            });
        case 0, _types.RESET_BULK_FILES_PART_STATE:
            return _object_spread_props(_object_spread({}, state), {
                bulkFilesPartsUpload: {}
            });
        case 0, _types.DELETE_REPORT_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                isTriggerSearchReport: true,
                selectedReports: []
            });
        case 0, _types.UPLOAD_FILE_FOLDER_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                isTriggerSearchReport: true,
                selectedReports: []
            });
        case 0, _types.SET_REPORT_SELECTION:
            return _object_spread_props(_object_spread({}, state), {
                selectedReports: payload
            });
        case 0, _types.SET_SORT_CRITERIA:
            return _object_spread_props(_object_spread({}, state), {
                sortCriteria: payload
            });
        case 0, _types.PREVIEW_ENABLED:
            return _object_spread_props(_object_spread({}, state), {
                isPreviewEnabled: payload
            });
        case 0, _types.GET_DOWNLOAD_REPORT_URL_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                downloadReportPresignedURL: null
            });
        case 0, _types.GET_DOWNLOAD_REPORT_URL_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                downloadReportPresignedURL: payload
            });
        case 0, _types.START_GET_REPORT_DETAILS_POLLING_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                isGetReportDetailsPolling: true
            });
        case 0, _types.STOP_GET_REPORT_DETAILS_POLLING_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                isGetReportDetailsPolling: false
            });
        case 0, _types.GET_REPORT_DETAILS_SUCCESS:
            var _payload_reportList;
            return _object_spread_props(_object_spread({}, state), {
                reportDetails: (payload === null || payload === void 0 ? void 0 : (_payload_reportList = payload.reportList) === null || _payload_reportList === void 0 ? void 0 : _payload_reportList.length) ? payload.reportList[0] : null
            });
        case 0, _types.RESET_GET_REPORT_DETAILS:
            return _object_spread_props(_object_spread({}, state), {
                reportDetails: null
            });
        case 0, _types.SET_FILTER_SHEET_OPEN:
            return _object_spread_props(_object_spread({}, state), {
                filterSheetOpen: payload
            });
        case 0, _types.SET_FILTERS:
            return _object_spread_props(_object_spread({}, state), {
                filters: payload
            });
        default:
            return state;
    }
}

},{"../../actions/types":"20R3C","../../constants":"bsj5K","../../constants/upload":"lSFPs","../../constants/search":"gUsyN","../../constants/download":"b2kDX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gUsyN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SORT_CRITERIA", ()=>DEFAULT_SORT_CRITERIA);
parcelHelpers.export(exports, "TABLE_SORT_DIRECTION_SORT_ORDER_MAP", ()=>TABLE_SORT_DIRECTION_SORT_ORDER_MAP);
parcelHelpers.export(exports, "INVERTED_TABLE_SORT_DIRECTION_SORT_ORDER_MAP", ()=>INVERTED_TABLE_SORT_DIRECTION_SORT_ORDER_MAP);
parcelHelpers.export(exports, "TABLE_SORT_COLUMN_SORT_ORDER_MAP", ()=>TABLE_SORT_COLUMN_SORT_ORDER_MAP);
parcelHelpers.export(exports, "INVERTED_TABLE_SORT_COLUMN_SORT_ORDER_MAP", ()=>INVERTED_TABLE_SORT_COLUMN_SORT_ORDER_MAP);
parcelHelpers.export(exports, "TABLE_COLUMNS_TYPE_TIME", ()=>TABLE_COLUMNS_TYPE_TIME);
parcelHelpers.export(exports, "TABLE_COLUMNS_TYPE_STATUS", ()=>TABLE_COLUMNS_TYPE_STATUS);
parcelHelpers.export(exports, "TABLE_COLUMNS_SORATABLE", ()=>TABLE_COLUMNS_SORATABLE);
parcelHelpers.export(exports, "TABLE_COLUMN_TYPE_TIME_HEADER_SUFFIX", ()=>TABLE_COLUMN_TYPE_TIME_HEADER_SUFFIX);
parcelHelpers.export(exports, "TABLE_COLUMNS", ()=>TABLE_COLUMNS);
parcelHelpers.export(exports, "LP_DROPDOWN_ALLOWED_PATHS", ()=>LP_DROPDOWN_ALLOWED_PATHS);
parcelHelpers.export(exports, "REPORT_STATUSES", ()=>REPORT_STATUSES);
var _coralComAmazonTransreportscenterservice = require("@amzn/coral_com-amazon-transreportscenterservice");
var _dateUtils = require("../utils/dateUtils");
var _invert = require("lodash/invert");
var _invertDefault = parcelHelpers.interopDefault(_invert);
var _routes = require("./routes");
var DEFAULT_SORT_CRITERIA = (0, _coralComAmazonTransreportscenterservice.SortCriteria).clone({
    sortField: (0, _coralComAmazonTransreportscenterservice.SortCriteriaField).LAST_UPDATED_TIME,
    sortOrder: (0, _coralComAmazonTransreportscenterservice.SortOrder).DESC
});
var TABLE_SORT_DIRECTION_SORT_ORDER_MAP = {
    ascending: (0, _coralComAmazonTransreportscenterservice.SortOrder).ASC,
    descending: (0, _coralComAmazonTransreportscenterservice.SortOrder).DESC
};
var INVERTED_TABLE_SORT_DIRECTION_SORT_ORDER_MAP = (0, _invertDefault.default)(TABLE_SORT_DIRECTION_SORT_ORDER_MAP);
var TABLE_SORT_COLUMN_SORT_ORDER_MAP = {
    lastUpdatedTime: (0, _coralComAmazonTransreportscenterservice.SortCriteriaField).LAST_UPDATED_TIME,
    reportRecordLastUpdatedTime: (0, _coralComAmazonTransreportscenterservice.SortCriteriaField).REPORT_RECORD_LAST_UPDATED_TIME,
    recordCreationTime: (0, _coralComAmazonTransreportscenterservice.SortCriteriaField).REPORT_RECORD_CREATION_TIME
};
var INVERTED_TABLE_SORT_COLUMN_SORT_ORDER_MAP = (0, _invertDefault.default)(TABLE_SORT_COLUMN_SORT_ORDER_MAP);
var TABLE_COLUMNS_TYPE_TIME = [
    "lastUpdatedTime",
    "creationTime"
];
var TABLE_COLUMNS_TYPE_STATUS = [
    "reportStatus"
];
var TABLE_COLUMNS_SORATABLE = [
    "lastUpdatedTime"
];
var TABLE_COLUMN_TYPE_TIME_HEADER_SUFFIX = " (".concat((0, _dateUtils.getTimeZone)(), ")");
var TABLE_COLUMNS = [
    {
        columnDisplayName: "reports_list_page.report_name",
        valuePathStructure: "reportName"
    },
    {
        columnDisplayName: "reports_list_page.published_on",
        valuePathStructure: "lastUpdatedTime"
    }
];
var LP_DROPDOWN_ALLOWED_PATHS = [
    (0, _routes.REPORTS_LIST_PATH)
];
var REPORT_STATUSES = Object.keys((0, _coralComAmazonTransreportscenterservice.ReportStatus)).filter(function(status) {
    return ![
        (0, _coralComAmazonTransreportscenterservice.ReportStatus).PENDING,
        (0, _coralComAmazonTransreportscenterservice.ReportStatus).PUBLISHED,
        (0, _coralComAmazonTransreportscenterservice.ReportStatus).INGESTION_PENDING,
        (0, _coralComAmazonTransreportscenterservice.ReportStatus).APPROVAL_CREATED
    ].includes(status);
});

},{"@amzn/coral_com-amazon-transreportscenterservice":"j45ae","../utils/dateUtils":"l61P0","lodash/invert":"FqTpe","./routes":"7ZcBY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j45ae":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionMetadata = require("./ActionMetadata");
parcelHelpers.exportAll(_actionMetadata, exports);
var _actionMetadataList = require("./ActionMetadataList");
parcelHelpers.exportAll(_actionMetadataList, exports);
var _additionalApprovalAttribute = require("./AdditionalApprovalAttribute");
parcelHelpers.exportAll(_additionalApprovalAttribute, exports);
var _additionalApprovalAttributesList = require("./AdditionalApprovalAttributesList");
parcelHelpers.exportAll(_additionalApprovalAttributesList, exports);
var _approvalAttribute = require("./ApprovalAttribute");
parcelHelpers.exportAll(_approvalAttribute, exports);
var _approvalDecision = require("./ApprovalDecision");
parcelHelpers.exportAll(_approvalDecision, exports);
var _approvalDecisionInfo = require("./ApprovalDecisionInfo");
parcelHelpers.exportAll(_approvalDecisionInfo, exports);
var _approvalStatus = require("./ApprovalStatus");
parcelHelpers.exportAll(_approvalStatus, exports);
var _approvalWorkflowInfo = require("./ApprovalWorkflowInfo");
parcelHelpers.exportAll(_approvalWorkflowInfo, exports);
var _approveReportInput = require("./ApproveReportInput");
parcelHelpers.exportAll(_approveReportInput, exports);
var _approveReportOutput = require("./ApproveReportOutput");
parcelHelpers.exportAll(_approveReportOutput, exports);
var _attribute = require("./Attribute");
parcelHelpers.exportAll(_attribute, exports);
var _attributeList = require("./AttributeList");
parcelHelpers.exportAll(_attributeList, exports);
var _attributeValueList = require("./AttributeValueList");
parcelHelpers.exportAll(_attributeValueList, exports);
var _beer = require("./Beer");
parcelHelpers.exportAll(_beer, exports);
var _beerList = require("./BeerList");
parcelHelpers.exportAll(_beerList, exports);
var _beerListDefinition = require("./beerListDefinition");
parcelHelpers.exportAll(_beerListDefinition, exports);
var _buildDataPipelinesInput = require("./BuildDataPipelinesInput");
parcelHelpers.exportAll(_buildDataPipelinesInput, exports);
var _buildDataPipelinesOutput = require("./BuildDataPipelinesOutput");
parcelHelpers.exportAll(_buildDataPipelinesOutput, exports);
var _completeBatchReportUploadInput = require("./CompleteBatchReportUploadInput");
parcelHelpers.exportAll(_completeBatchReportUploadInput, exports);
var _completeBatchReportUploadOutput = require("./CompleteBatchReportUploadOutput");
parcelHelpers.exportAll(_completeBatchReportUploadOutput, exports);
var _completeUploadRequest = require("./CompleteUploadRequest");
parcelHelpers.exportAll(_completeUploadRequest, exports);
var _completeUploadRequestList = require("./CompleteUploadRequestList");
parcelHelpers.exportAll(_completeUploadRequestList, exports);
var _compositeSearchCriteria = require("./CompositeSearchCriteria");
parcelHelpers.exportAll(_compositeSearchCriteria, exports);
var _compositeSearchCriteriaOperator = require("./CompositeSearchCriteriaOperator");
parcelHelpers.exportAll(_compositeSearchCriteriaOperator, exports);
var _createReportApprovalInput = require("./CreateReportApprovalInput");
parcelHelpers.exportAll(_createReportApprovalInput, exports);
var _createReportApprovalOutput = require("./CreateReportApprovalOutput");
parcelHelpers.exportAll(_createReportApprovalOutput, exports);
var _dateFieldTypeConstraints = require("./DateFieldTypeConstraints");
parcelHelpers.exportAll(_dateFieldTypeConstraints, exports);
var _datePickerFormFieldControlTypeConstraints = require("./DatePickerFormFieldControlTypeConstraints");
parcelHelpers.exportAll(_datePickerFormFieldControlTypeConstraints, exports);
var _deleteReportInput = require("./DeleteReportInput");
parcelHelpers.exportAll(_deleteReportInput, exports);
var _deleteReportOutput = require("./DeleteReportOutput");
parcelHelpers.exportAll(_deleteReportOutput, exports);
var _dependencyException = require("./DependencyException");
parcelHelpers.exportAll(_dependencyException, exports);
var _downloadReportInput = require("./DownloadReportInput");
parcelHelpers.exportAll(_downloadReportInput, exports);
var _downloadReportOutput = require("./DownloadReportOutput");
parcelHelpers.exportAll(_downloadReportOutput, exports);
var _equalsSearchCriteria = require("./EqualsSearchCriteria");
parcelHelpers.exportAll(_equalsSearchCriteria, exports);
var _errorCode = require("./ErrorCode");
parcelHelpers.exportAll(_errorCode, exports);
var _etagsList = require("./ETagsList");
parcelHelpers.exportAll(_etagsList, exports);
var _fieldType = require("./FieldType");
parcelHelpers.exportAll(_fieldType, exports);
var _fieldTypeConstraints = require("./FieldTypeConstraints");
parcelHelpers.exportAll(_fieldTypeConstraints, exports);
var _fieldValueList = require("./FieldValueList");
parcelHelpers.exportAll(_fieldValueList, exports);
var _fileControlTypeConstraints = require("./FileControlTypeConstraints");
parcelHelpers.exportAll(_fileControlTypeConstraints, exports);
var _flowType = require("./FlowType");
parcelHelpers.exportAll(_flowType, exports);
var _form = require("./Form");
parcelHelpers.exportAll(_form, exports);
var _formField = require("./FormField");
parcelHelpers.exportAll(_formField, exports);
var _formFieldControlType = require("./FormFieldControlType");
parcelHelpers.exportAll(_formFieldControlType, exports);
var _formFieldControlTypeConstraints = require("./FormFieldControlTypeConstraints");
parcelHelpers.exportAll(_formFieldControlTypeConstraints, exports);
var _formFieldList = require("./FormFieldList");
parcelHelpers.exportAll(_formFieldList, exports);
var _formFieldValueList = require("./FormFieldValueList");
parcelHelpers.exportAll(_formFieldValueList, exports);
var _formList = require("./FormList");
parcelHelpers.exportAll(_formList, exports);
var _generatePresignedUrlInput = require("./GeneratePresignedUrlInput");
parcelHelpers.exportAll(_generatePresignedUrlInput, exports);
var _generatePresignedUrlOutput = require("./GeneratePresignedUrlOutput");
parcelHelpers.exportAll(_generatePresignedUrlOutput, exports);
var _generateReportAsyncInput = require("./GenerateReportAsyncInput");
parcelHelpers.exportAll(_generateReportAsyncInput, exports);
var _generateReportAsyncOutput = require("./GenerateReportAsyncOutput");
parcelHelpers.exportAll(_generateReportAsyncOutput, exports);
var _generateReportSyncInput = require("./GenerateReportSyncInput");
parcelHelpers.exportAll(_generateReportSyncInput, exports);
var _generateReportSyncOutput = require("./GenerateReportSyncOutput");
parcelHelpers.exportAll(_generateReportSyncOutput, exports);
var _getTermReportConfigsInput = require("./GetTermReportConfigsInput");
parcelHelpers.exportAll(_getTermReportConfigsInput, exports);
var _getTermReportConfigsOutput = require("./GetTermReportConfigsOutput");
parcelHelpers.exportAll(_getTermReportConfigsOutput, exports);
var _ingestionWorkflowInfo = require("./IngestionWorkflowInfo");
parcelHelpers.exportAll(_ingestionWorkflowInfo, exports);
var _initiateBatchReportUploadInput = require("./InitiateBatchReportUploadInput");
parcelHelpers.exportAll(_initiateBatchReportUploadInput, exports);
var _initiateBatchReportUploadOutput = require("./InitiateBatchReportUploadOutput");
parcelHelpers.exportAll(_initiateBatchReportUploadOutput, exports);
var _initiateUploadRequest = require("./InitiateUploadRequest");
parcelHelpers.exportAll(_initiateUploadRequest, exports);
var _initiateUploadRequestList = require("./InitiateUploadRequestList");
parcelHelpers.exportAll(_initiateUploadRequestList, exports);
var _initiateUploadResponse = require("./InitiateUploadResponse");
parcelHelpers.exportAll(_initiateUploadResponse, exports);
var _initiateUploadResponseList = require("./InitiateUploadResponseList");
parcelHelpers.exportAll(_initiateUploadResponseList, exports);
var _lookupKeyList = require("./LookupKeyList");
parcelHelpers.exportAll(_lookupKeyList, exports);
var _lplookUpKeyType = require("./LPLookUpKeyType");
parcelHelpers.exportAll(_lplookUpKeyType, exports);
var _lplookUpValues = require("./LPLookUpValues");
parcelHelpers.exportAll(_lplookUpValues, exports);
var _matchAnySearchCriteria = require("./MatchAnySearchCriteria");
parcelHelpers.exportAll(_matchAnySearchCriteria, exports);
var _objectType = require("./ObjectType");
parcelHelpers.exportAll(_objectType, exports);
var _rangeSearchCriteria = require("./RangeSearchCriteria");
parcelHelpers.exportAll(_rangeSearchCriteria, exports);
var _rejectReportInput = require("./RejectReportInput");
parcelHelpers.exportAll(_rejectReportInput, exports);
var _rejectReportOutput = require("./RejectReportOutput");
parcelHelpers.exportAll(_rejectReportOutput, exports);
var _report = require("./Report");
parcelHelpers.exportAll(_report, exports);
var _reportAction = require("./ReportAction");
parcelHelpers.exportAll(_reportAction, exports);
var _reportAdditionalInfo = require("./ReportAdditionalInfo");
parcelHelpers.exportAll(_reportAdditionalInfo, exports);
var _reportConfig = require("./ReportConfig");
parcelHelpers.exportAll(_reportConfig, exports);
var _reportConfigList = require("./ReportConfigList");
parcelHelpers.exportAll(_reportConfigList, exports);
var _reportFeature = require("./ReportFeature");
parcelHelpers.exportAll(_reportFeature, exports);
var _reportFeaturesList = require("./ReportFeaturesList");
parcelHelpers.exportAll(_reportFeaturesList, exports);
var _reportFormat = require("./ReportFormat");
parcelHelpers.exportAll(_reportFormat, exports);
var _reportFormatList = require("./ReportFormatList");
parcelHelpers.exportAll(_reportFormatList, exports);
var _reportFormatValidationConfig = require("./ReportFormatValidationConfig");
parcelHelpers.exportAll(_reportFormatValidationConfig, exports);
var _reportHistoryDashboardColumn = require("./ReportHistoryDashboardColumn");
parcelHelpers.exportAll(_reportHistoryDashboardColumn, exports);
var _reportHistoryDashboardColumnsList = require("./ReportHistoryDashboardColumnsList");
parcelHelpers.exportAll(_reportHistoryDashboardColumnsList, exports);
var _reportList = require("./ReportList");
parcelHelpers.exportAll(_reportList, exports);
var _reportMetadata = require("./ReportMetadata");
parcelHelpers.exportAll(_reportMetadata, exports);
var _reportPageConfig = require("./ReportPageConfig");
parcelHelpers.exportAll(_reportPageConfig, exports);
var _reportStatus = require("./ReportStatus");
parcelHelpers.exportAll(_reportStatus, exports);
var _reportTypePagesConfig = require("./ReportTypePagesConfig");
parcelHelpers.exportAll(_reportTypePagesConfig, exports);
var _reportUploadActionConfig = require("./ReportUploadActionConfig");
parcelHelpers.exportAll(_reportUploadActionConfig, exports);
var _reportUploadStatus = require("./ReportUploadStatus");
parcelHelpers.exportAll(_reportUploadStatus, exports);
var _reportWorkflowConfig = require("./ReportWorkflowConfig");
parcelHelpers.exportAll(_reportWorkflowConfig, exports);
var _reportWorkflowInfo = require("./ReportWorkflowInfo");
parcelHelpers.exportAll(_reportWorkflowInfo, exports);
var _reportWorkflowInfoList = require("./ReportWorkflowInfoList");
parcelHelpers.exportAll(_reportWorkflowInfoList, exports);
var _reportWorkflowTaskCompleteNotification = require("./ReportWorkflowTaskCompleteNotification");
parcelHelpers.exportAll(_reportWorkflowTaskCompleteNotification, exports);
var _reportWorkflowTaskNotification = require("./ReportWorkflowTaskNotification");
parcelHelpers.exportAll(_reportWorkflowTaskNotification, exports);
var _requiredApproverInfo = require("./RequiredApproverInfo");
parcelHelpers.exportAll(_requiredApproverInfo, exports);
var _requiredApproversList = require("./RequiredApproversList");
parcelHelpers.exportAll(_requiredApproversList, exports);
var _requiredApproverToDecisionStatus = require("./RequiredApproverToDecisionStatus");
parcelHelpers.exportAll(_requiredApproverToDecisionStatus, exports);
var _requiredApproverToDecisionStatusList = require("./RequiredApproverToDecisionStatusList");
parcelHelpers.exportAll(_requiredApproverToDecisionStatusList, exports);
var _s3ObjectInfo = require("./S3ObjectInfo");
parcelHelpers.exportAll(_s3ObjectInfo, exports);
var _searchCriteria = require("./SearchCriteria");
parcelHelpers.exportAll(_searchCriteria, exports);
var _searchCriteriaField = require("./SearchCriteriaField");
parcelHelpers.exportAll(_searchCriteriaField, exports);
var _searchCriteriaList = require("./SearchCriteriaList");
parcelHelpers.exportAll(_searchCriteriaList, exports);
var _searchReportsHistoryUIConfig = require("./SearchReportsHistoryUIConfig");
parcelHelpers.exportAll(_searchReportsHistoryUIConfig, exports);
var _searchReportsInput = require("./SearchReportsInput");
parcelHelpers.exportAll(_searchReportsInput, exports);
var _searchReportsOutput = require("./SearchReportsOutput");
parcelHelpers.exportAll(_searchReportsOutput, exports);
var _selectFormFieldControlTypeConstraints = require("./SelectFormFieldControlTypeConstraints");
parcelHelpers.exportAll(_selectFormFieldControlTypeConstraints, exports);
var _sortCriteria = require("./SortCriteria");
parcelHelpers.exportAll(_sortCriteria, exports);
var _sortCriteriaField = require("./SortCriteriaField");
parcelHelpers.exportAll(_sortCriteriaField, exports);
var _sortCriteriaList = require("./SortCriteriaList");
parcelHelpers.exportAll(_sortCriteriaList, exports);
var _sortOrder = require("./SortOrder");
parcelHelpers.exportAll(_sortOrder, exports);
var _stringFieldTypeConstraints = require("./StringFieldTypeConstraints");
parcelHelpers.exportAll(_stringFieldTypeConstraints, exports);
var _supportingDocumentConfig = require("./SupportingDocumentConfig");
parcelHelpers.exportAll(_supportingDocumentConfig, exports);
var _supportingDocumentConfigList = require("./SupportingDocumentConfigList");
parcelHelpers.exportAll(_supportingDocumentConfigList, exports);
var _supportingDocumentInfo = require("./SupportingDocumentInfo");
parcelHelpers.exportAll(_supportingDocumentInfo, exports);
var _supportingDocumentURLMap = require("./SupportingDocumentURLMap");
parcelHelpers.exportAll(_supportingDocumentURLMap, exports);
var _termReportConfigurations = require("./TermReportConfigurations");
parcelHelpers.exportAll(_termReportConfigurations, exports);
var _termReportConfigurationsList = require("./TermReportConfigurationsList");
parcelHelpers.exportAll(_termReportConfigurationsList, exports);
var _transReportsCenterService = require("./TransReportsCenterService");
parcelHelpers.exportAll(_transReportsCenterService, exports);
var _trcsinvalidRequestException = require("./TRCSInvalidRequestException");
parcelHelpers.exportAll(_trcsinvalidRequestException, exports);
var _trcsrecoverableException = require("./TRCSRecoverableException");
parcelHelpers.exportAll(_trcsrecoverableException, exports);
var _trcsunauthorizedException = require("./TRCSUnauthorizedException");
parcelHelpers.exportAll(_trcsunauthorizedException, exports);
var _trcsunrecoverableException = require("./TRCSUnrecoverableException");
parcelHelpers.exportAll(_trcsunrecoverableException, exports);
var _uploadReportInput = require("./UploadReportInput");
parcelHelpers.exportAll(_uploadReportInput, exports);
var _uploadReportOutput = require("./UploadReportOutput");
parcelHelpers.exportAll(_uploadReportOutput, exports);
var _urllist = require("./URLList");
parcelHelpers.exportAll(_urllist, exports);
var _userType = require("./UserType");
parcelHelpers.exportAll(_userType, exports);
var _validationConfig = require("./ValidationConfig");
parcelHelpers.exportAll(_validationConfig, exports);
var _validationWorkflowInfo = require("./ValidationWorkflowInfo");
parcelHelpers.exportAll(_validationWorkflowInfo, exports);

},{"./ActionMetadata":"5l7wG","./ActionMetadataList":"aihjT","./AdditionalApprovalAttribute":"4xLnw","./AdditionalApprovalAttributesList":"7jTpP","./ApprovalAttribute":"ceork","./ApprovalDecision":"bxvRV","./ApprovalDecisionInfo":"5qC8Z","./ApprovalStatus":"8YLUU","./ApprovalWorkflowInfo":"gEQOb","./ApproveReportInput":"aKcFr","./ApproveReportOutput":"axAzo","./Attribute":"5bgfz","./AttributeList":"a31Of","./AttributeValueList":"bl25O","./Beer":"99wEG","./BeerList":"spuJj","./beerListDefinition":"bkU9h","./BuildDataPipelinesInput":"1rbwU","./BuildDataPipelinesOutput":"7R4kd","./CompleteBatchReportUploadInput":"hXyB6","./CompleteBatchReportUploadOutput":"9WgUN","./CompleteUploadRequest":"8xnN5","./CompleteUploadRequestList":"gpmOB","./CompositeSearchCriteria":"7Idxi","./CompositeSearchCriteriaOperator":"zkaUZ","./CreateReportApprovalInput":"czmqe","./CreateReportApprovalOutput":"jLzHG","./DateFieldTypeConstraints":"ixGLP","./DatePickerFormFieldControlTypeConstraints":"amp4y","./DeleteReportInput":"dP3Tl","./DeleteReportOutput":"aCUxM","./DependencyException":"ewwej","./DownloadReportInput":"k2IK4","./DownloadReportOutput":"j61BD","./EqualsSearchCriteria":"6ZwAx","./ErrorCode":"iJiw7","./ETagsList":"4P7ei","./FieldType":"6K4j6","./FieldTypeConstraints":"ceLQA","./FieldValueList":"hK5J4","./FileControlTypeConstraints":"8w5MR","./FlowType":"7e386","./Form":"ff3QN","./FormField":"5AubO","./FormFieldControlType":"1aH5C","./FormFieldControlTypeConstraints":"icxK5","./FormFieldList":"emWa5","./FormFieldValueList":"2590j","./FormList":"7gKUz","./GeneratePresignedUrlInput":"hbuR8","./GeneratePresignedUrlOutput":"i3ssu","./GenerateReportAsyncInput":"iPQ3g","./GenerateReportAsyncOutput":"fdIlq","./GenerateReportSyncInput":"kreQO","./GenerateReportSyncOutput":"cQiIH","./GetTermReportConfigsInput":"8v8yU","./GetTermReportConfigsOutput":"8N5nJ","./IngestionWorkflowInfo":"9eC17","./InitiateBatchReportUploadInput":"bmroK","./InitiateBatchReportUploadOutput":"2LGu6","./InitiateUploadRequest":"6cycX","./InitiateUploadRequestList":"1JeSJ","./InitiateUploadResponse":"lH6Pu","./InitiateUploadResponseList":"2elXe","./LookupKeyList":"hefoT","./LPLookUpKeyType":"aSTSY","./LPLookUpValues":"3sdWb","./MatchAnySearchCriteria":"k7cUU","./ObjectType":"bhkbZ","./RangeSearchCriteria":"34nvC","./RejectReportInput":"2HrXn","./RejectReportOutput":"6epqY","./Report":"2e78w","./ReportAction":"8oSeC","./ReportAdditionalInfo":"gOPcz","./ReportConfig":"l2slz","./ReportConfigList":"kRMHK","./ReportFeature":"4iZVh","./ReportFeaturesList":"cmLeP","./ReportFormat":"hmPf5","./ReportFormatList":"7qkK0","./ReportFormatValidationConfig":"4wsFv","./ReportHistoryDashboardColumn":"ksHQh","./ReportHistoryDashboardColumnsList":"gRbhZ","./ReportList":"kbdAQ","./ReportMetadata":"c86my","./ReportPageConfig":"2hq1K","./ReportStatus":"7uVgk","./ReportTypePagesConfig":"5AuzB","./ReportUploadActionConfig":"5J3uP","./ReportUploadStatus":"l2bYU","./ReportWorkflowConfig":"aFoHb","./ReportWorkflowInfo":"hVTCm","./ReportWorkflowInfoList":"3xb5j","./ReportWorkflowTaskCompleteNotification":"6pBs2","./ReportWorkflowTaskNotification":"65pPJ","./RequiredApproverInfo":"5Y2n0","./RequiredApproversList":"aRftg","./RequiredApproverToDecisionStatus":"a86Ru","./RequiredApproverToDecisionStatusList":"17ljf","./S3ObjectInfo":"hVvOf","./SearchCriteria":"7a5KV","./SearchCriteriaField":"hbHxS","./SearchCriteriaList":"jR5dI","./SearchReportsHistoryUIConfig":"jl9TO","./SearchReportsInput":"k2iZh","./SearchReportsOutput":"eerRQ","./SelectFormFieldControlTypeConstraints":"jjOTd","./SortCriteria":"2kPfN","./SortCriteriaField":"apO8k","./SortCriteriaList":"kNM27","./SortOrder":"jEA60","./StringFieldTypeConstraints":"lcGhi","./SupportingDocumentConfig":"ibSv7","./SupportingDocumentConfigList":"cM7Jm","./SupportingDocumentInfo":"ed7Ch","./SupportingDocumentURLMap":"bta6X","./TermReportConfigurations":"cyH9o","./TermReportConfigurationsList":"1ACHs","./TransReportsCenterService":"fPAuM","./TRCSInvalidRequestException":"7Mnrr","./TRCSRecoverableException":"bWUiG","./TRCSUnauthorizedException":"dtH3n","./TRCSUnrecoverableException":"9oPeh","./UploadReportInput":"eendP","./UploadReportOutput":"1dfyl","./URLList":"bewFl","./UserType":"loO60","./ValidationConfig":"851vy","./ValidationWorkflowInfo":"iaR6j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5l7wG":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents the metadata for Action performed on report
 * actionType:  Represents different actions that can be performed on a report
 * flowType: Represents different flow types
 * userType:  Represents different types of users
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ActionMetadata", ()=>ActionMetadata);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ActionMetadata] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateActionmetadata", ()=>validateActionmetadata);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ActionMetadata extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ActionMetadata#clone(obj: PlainObjectFrom<ActionMetadata>) method.
     */ constructor(__actionType, __flowType, __userType){
        super();
        this.actionType = __actionType;
        this.flowType = __flowType;
        this.userType = __userType;
    }
    /**
     * Create a shallow clone of ActionMetadata from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ActionMetadata(obj.actionType, obj.flowType, obj.userType);
    }
    static fromJson(data) {
        return new ActionMetadata((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.actionType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.flowType), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType));
    }
    static toJson(data) {
        return Object.assign({
            actionType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.actionType),
            flowType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.flowType),
            userType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userType)
        });
    }
}
ActionMetadata.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ActionMetadata";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ActionMetadata);
function validateActionmetadata(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aihjT":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMetadataList", ()=>ActionMetadataList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ActionMetadataList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateActionmetadatalist", ()=>validateActionmetadatalist);
var _actionMetadata = require("./ActionMetadata");
class ActionMetadataList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ActionMetadataList.prototype));
    }
    static fromJson(data) {
        return new ActionMetadataList(data.map((datum)=>(0, _actionMetadata.ActionMetadata).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _actionMetadata.ActionMetadata).toJson(datum));
    }
}
function validateActionmetadatalist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ActionMetadata":"5l7wG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4xLnw":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents additional attributes information required in approval flow
 * key - represents the name of the attribute
 * value - represents the value of the attribute
 * type - represents type of the the attribute
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "AdditionalApprovalAttribute", ()=>AdditionalApprovalAttribute);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AdditionalApprovalAttribute] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAdditionalapprovalattribute", ()=>validateAdditionalapprovalattribute);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class AdditionalApprovalAttribute extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the AdditionalApprovalAttribute#clone(obj: PlainObjectFrom<AdditionalApprovalAttribute>) method.
     */ constructor(__key, __type, __value){
        super();
        this.key = __key;
        this.type = __type;
        this.value = __value;
    }
    /**
     * Create a shallow clone of AdditionalApprovalAttribute from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new AdditionalApprovalAttribute(obj.key, obj.type, obj.value);
    }
    static fromJson(data) {
        return new AdditionalApprovalAttribute((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.type), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.value));
    }
    static toJson(data) {
        return Object.assign({
            key: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key),
            type: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.type),
            value: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.value)
        });
    }
}
AdditionalApprovalAttribute.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#AdditionalApprovalAttribute";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(AdditionalApprovalAttribute);
function validateAdditionalapprovalattribute(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jTpP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdditionalApprovalAttributesList", ()=>AdditionalApprovalAttributesList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AdditionalApprovalAttributesList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAdditionalapprovalattributeslist", ()=>validateAdditionalapprovalattributeslist);
var _additionalApprovalAttribute = require("./AdditionalApprovalAttribute");
class AdditionalApprovalAttributesList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AdditionalApprovalAttributesList.prototype));
    }
    static fromJson(data) {
        return new AdditionalApprovalAttributesList(data.map((datum)=>(0, _additionalApprovalAttribute.AdditionalApprovalAttribute).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _additionalApprovalAttribute.AdditionalApprovalAttribute).toJson(datum));
    }
}
function validateAdditionalapprovalattributeslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AdditionalApprovalAttribute":"4xLnw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ceork":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents different approval attributes.
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApprovalAttribute", ()=>ApprovalAttribute);
var ApprovalAttribute;
(function(ApprovalAttribute) {
    ApprovalAttribute["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
})(ApprovalAttribute || (ApprovalAttribute = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bxvRV":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents Approval decision attributes
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApprovalDecision", ()=>ApprovalDecision);
var ApprovalDecision;
(function(ApprovalDecision) {
    ApprovalDecision["APPROVED"] = "APPROVED";
    ApprovalDecision["REJECTED"] = "REJECTED";
    ApprovalDecision["EXPIRED"] = "EXPIRED";
    ApprovalDecision["CANCELED"] = "CANCELED";
})(ApprovalDecision || (ApprovalDecision = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5qC8Z":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents information about the approval process.
 * approvalDecision - Decision made regarding the approval.
 * approvalDecisionReason - Reason for the approval decision.
 * approvalDecisionBy - Alias who approved the report.
 * approvalDecisionTime - Timestamp when the approval decision was made.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ApprovalDecisionInfo", ()=>ApprovalDecisionInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ApprovalDecisionInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateApprovaldecisioninfo", ()=>validateApprovaldecisioninfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ApprovalDecisionInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ApprovalDecisionInfo#clone(obj: PlainObjectFrom<ApprovalDecisionInfo>) method.
     */ constructor(__approvalDecision, __approvalDecisionBy, __approvalDecisionTime, __approvalDecisionReason){
        super();
        this.approvalDecision = __approvalDecision;
        this.approvalDecisionBy = __approvalDecisionBy;
        this.approvalDecisionTime = __approvalDecisionTime;
        this.approvalDecisionReason = __approvalDecisionReason;
    }
    /**
     * Create a shallow clone of ApprovalDecisionInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ApprovalDecisionInfo(obj.approvalDecision, obj.approvalDecisionBy, obj.approvalDecisionTime, obj.approvalDecisionReason);
    }
    static fromJson(data) {
        return new ApprovalDecisionInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalDecision), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalDecisionBy), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalDecisionTime), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.approvalDecisionReason));
    }
    static toJson(data) {
        return Object.assign({
            approvalDecision: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalDecision),
            approvalDecisionBy: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalDecisionBy),
            approvalDecisionTime: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalDecisionTime),
            approvalDecisionReason: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.approvalDecisionReason)
        });
    }
}
ApprovalDecisionInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ApprovalDecisionInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ApprovalDecisionInfo);
function validateApprovaldecisioninfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8YLUU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents Approval status attributes
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApprovalStatus", ()=>ApprovalStatus);
var ApprovalStatus;
(function(ApprovalStatus) {
    ApprovalStatus["APPROVAL_COMPLETED"] = "APPROVAL_COMPLETED";
    ApprovalStatus["APPROVAL_CREATED"] = "APPROVAL_CREATED";
    ApprovalStatus["APPROVAL_PENDING"] = "APPROVAL_PENDING";
    ApprovalStatus["APPROVAL_CREATION_IN_PROGRESS"] = "APPROVAL_CREATION_IN_PROGRESS";
    ApprovalStatus["APPROVAL_IN_PROGRESS"] = "APPROVAL_IN_PROGRESS";
})(ApprovalStatus || (ApprovalStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gEQOb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents information about the approval workflow.
 * reportApprovalCreationStatus - Status of the approval creation.
 * reportApprovalStatus - Current status of the approval.
 * additionalApprovalAttributesList - List of additional attributes required for approval.
 * requiredApproverToDecisionStatusMap - Holds the info about requiredApprover and their decision status.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ApprovalWorkflowInfo", ()=>ApprovalWorkflowInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ApprovalWorkflowInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateApprovalworkflowinfo", ()=>validateApprovalworkflowinfo);
var _requiredApproverToDecisionStatusList = require("./RequiredApproverToDecisionStatusList");
var _additionalApprovalAttributesList = require("./AdditionalApprovalAttributesList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ApprovalWorkflowInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ApprovalWorkflowInfo#clone(obj: PlainObjectFrom<ApprovalWorkflowInfo>) method.
     */ constructor(__reportApprovalCreationStatus, __reportApprovalStatus, __requiredApproverToDecisionStatus, __additionalApprovalAttributesList){
        super();
        this.reportApprovalCreationStatus = __reportApprovalCreationStatus;
        this.reportApprovalStatus = __reportApprovalStatus;
        this.requiredApproverToDecisionStatus = __requiredApproverToDecisionStatus;
        this.additionalApprovalAttributesList = __additionalApprovalAttributesList;
    }
    /**
     * Create a shallow clone of ApprovalWorkflowInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ApprovalWorkflowInfo(obj.reportApprovalCreationStatus, obj.reportApprovalStatus, obj.requiredApproverToDecisionStatus, obj.additionalApprovalAttributesList);
    }
    static fromJson(data) {
        return new ApprovalWorkflowInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportApprovalCreationStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportApprovalStatus), (0, _requiredApproverToDecisionStatusList.RequiredApproverToDecisionStatusList).fromJson(data.requiredApproverToDecisionStatus), (($$val)=>$$val == undefined ? undefined : (0, _additionalApprovalAttributesList.AdditionalApprovalAttributesList).fromJson($$val))(data.additionalApprovalAttributesList));
    }
    static toJson(data) {
        return Object.assign({
            reportApprovalCreationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportApprovalCreationStatus),
            reportApprovalStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportApprovalStatus),
            requiredApproverToDecisionStatus: (0, _requiredApproverToDecisionStatusList.RequiredApproverToDecisionStatusList).toJson(data.requiredApproverToDecisionStatus),
            additionalApprovalAttributesList: (($$val)=>$$val == undefined ? null : (0, _additionalApprovalAttributesList.AdditionalApprovalAttributesList).toJson($$val))(data.additionalApprovalAttributesList)
        });
    }
}
ApprovalWorkflowInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ApprovalWorkflowInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ApprovalWorkflowInfo);
function validateApprovalworkflowinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequiredApproverToDecisionStatusList":"17ljf","./AdditionalApprovalAttributesList":"7jTpP","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17ljf":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequiredApproverToDecisionStatusList", ()=>RequiredApproverToDecisionStatusList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequiredApproverToDecisionStatusList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequiredapprovertodecisionstatuslist", ()=>validateRequiredapprovertodecisionstatuslist);
var _requiredApproverToDecisionStatus = require("./RequiredApproverToDecisionStatus");
class RequiredApproverToDecisionStatusList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(RequiredApproverToDecisionStatusList.prototype));
    }
    static fromJson(data) {
        return new RequiredApproverToDecisionStatusList(data.map((datum)=>(0, _requiredApproverToDecisionStatus.RequiredApproverToDecisionStatus).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _requiredApproverToDecisionStatus.RequiredApproverToDecisionStatus).toJson(datum));
    }
}
function validateRequiredapprovertodecisionstatuslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequiredApproverToDecisionStatus":"a86Ru","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a86Ru":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents the map between required approvers and their decision status.
 * RequiredApproverInfo - Represents the RequiredApproverInfo
 * ApprovalDecisionInfo - Represents the approval information.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "RequiredApproverToDecisionStatus", ()=>RequiredApproverToDecisionStatus);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequiredApproverToDecisionStatus] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequiredapprovertodecisionstatus", ()=>validateRequiredapprovertodecisionstatus);
var _approvalDecisionInfo = require("./ApprovalDecisionInfo");
var _requiredApproverInfo = require("./RequiredApproverInfo");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RequiredApproverToDecisionStatus extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequiredApproverToDecisionStatus#clone(obj: PlainObjectFrom<RequiredApproverToDecisionStatus>) method.
     */ constructor(__requiredApproverInfo, __approvalDecisionInfo){
        super();
        this.requiredApproverInfo = __requiredApproverInfo;
        this.approvalDecisionInfo = __approvalDecisionInfo;
    }
    /**
     * Create a shallow clone of RequiredApproverToDecisionStatus from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequiredApproverToDecisionStatus(obj.requiredApproverInfo, obj.approvalDecisionInfo);
    }
    static fromJson(data) {
        return new RequiredApproverToDecisionStatus((0, _requiredApproverInfo.RequiredApproverInfo).fromJson(data.requiredApproverInfo), (($$val)=>$$val == undefined ? undefined : (0, _approvalDecisionInfo.ApprovalDecisionInfo).fromJson($$val))(data.approvalDecisionInfo));
    }
    static toJson(data) {
        return Object.assign({
            requiredApproverInfo: (0, _requiredApproverInfo.RequiredApproverInfo).toJson(data.requiredApproverInfo),
            approvalDecisionInfo: (($$val)=>$$val == undefined ? null : (0, _approvalDecisionInfo.ApprovalDecisionInfo).toJson($$val))(data.approvalDecisionInfo)
        });
    }
}
RequiredApproverToDecisionStatus.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#RequiredApproverToDecisionStatus";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RequiredApproverToDecisionStatus);
function validateRequiredapprovertodecisionstatus(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ApprovalDecisionInfo":"5qC8Z","./RequiredApproverInfo":"5Y2n0","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Y2n0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents the Required Approver Info
 * requiredApprover - Represents the required approver.
 * approverLevel - Represents the approver level.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "RequiredApproverInfo", ()=>RequiredApproverInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequiredApproverInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequiredapproverinfo", ()=>validateRequiredapproverinfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RequiredApproverInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RequiredApproverInfo#clone(obj: PlainObjectFrom<RequiredApproverInfo>) method.
     */ constructor(__requiredApprover, __approverLevel){
        super();
        this.requiredApprover = __requiredApprover;
        this.approverLevel = __approverLevel;
    }
    /**
     * Create a shallow clone of RequiredApproverInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RequiredApproverInfo(obj.requiredApprover, obj.approverLevel);
    }
    static fromJson(data) {
        return new RequiredApproverInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.requiredApprover), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.approverLevel));
    }
    static toJson(data) {
        return Object.assign({
            requiredApprover: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.requiredApprover),
            approverLevel: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.approverLevel)
        });
    }
}
RequiredApproverInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#RequiredApproverInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RequiredApproverInfo);
function validateRequiredapproverinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKcFr":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for ApproveReport API:
 *
 * reportId: Unique identifier representing the report to be accepted.
 * approvalReason: Comment providing the reason for approving report.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ApproveReportInput", ()=>ApproveReportInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ApproveReportInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateApprovereportinput", ()=>validateApprovereportinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ApproveReportInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ApproveReportInput#clone(obj: PlainObjectFrom<ApproveReportInput>) method.
     */ constructor(__reportId, __reportType, __term, __approvalReason, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.reportId = __reportId;
        this.reportType = __reportType;
        this.term = __term;
        this.approvalReason = __approvalReason;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of ApproveReportInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ApproveReportInput(obj.reportId, obj.reportType, obj.term, obj.approvalReason, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new ApproveReportInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.approvalReason), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            approvalReason: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.approvalReason),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
ApproveReportInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ApproveReportInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ApproveReportInput);
function validateApprovereportinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"axAzo":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for ApproveReport API:
 * reportId: Unique identifier representing the accepted report.
 * approvalStatus: Status of the report approval (e.g., 'Approved').
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ApproveReportOutput", ()=>ApproveReportOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ApproveReportOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateApprovereportoutput", ()=>validateApprovereportoutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ApproveReportOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ApproveReportOutput#clone(obj: PlainObjectFrom<ApproveReportOutput>) method.
     */ constructor(__approvalStatus, __reportId){
        super();
        this.approvalStatus = __approvalStatus;
        this.reportId = __reportId;
    }
    /**
     * Create a shallow clone of ApproveReportOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ApproveReportOutput(obj.approvalStatus, obj.reportId);
    }
    static fromJson(data) {
        return new ApproveReportOutput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId));
    }
    static toJson(data) {
        return Object.assign({
            approvalStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalStatus),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId)
        });
    }
}
ApproveReportOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ApproveReportOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ApproveReportOutput);
function validateApprovereportoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bgfz":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents the dynamic attributes that are used in report generation
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "Attribute", ()=>Attribute);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Attribute] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAttribute", ()=>validateAttribute);
var _attributeValueList = require("./AttributeValueList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Attribute extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Attribute#clone(obj: PlainObjectFrom<Attribute>) method.
     */ constructor(__attributeName, __attributeType, __attributeValueList){
        super();
        this.attributeName = __attributeName;
        this.attributeType = __attributeType;
        this.attributeValueList = __attributeValueList;
    }
    /**
     * Create a shallow clone of Attribute from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Attribute(obj.attributeName, obj.attributeType, obj.attributeValueList);
    }
    static fromJson(data) {
        return new Attribute((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.attributeName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.attributeType), (0, _attributeValueList.AttributeValueList).fromJson(data.attributeValueList));
    }
    static toJson(data) {
        return Object.assign({
            attributeName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.attributeName),
            attributeType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.attributeType),
            attributeValueList: (0, _attributeValueList.AttributeValueList).toJson(data.attributeValueList)
        });
    }
}
Attribute.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#Attribute";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Attribute);
function validateAttribute(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AttributeValueList":"bl25O","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bl25O":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttributeValueList", ()=>AttributeValueList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AttributeValueList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAttributevaluelist", ()=>validateAttributevaluelist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class AttributeValueList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AttributeValueList.prototype));
    }
    static fromJson(data) {
        return new AttributeValueList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateAttributevaluelist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a31Of":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttributeList", ()=>AttributeList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [AttributeList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateAttributelist", ()=>validateAttributelist);
var _attribute = require("./Attribute");
class AttributeList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(AttributeList.prototype));
    }
    static fromJson(data) {
        return new AttributeList(data.map((datum)=>(0, _attribute.Attribute).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _attribute.Attribute).toJson(datum));
    }
}
function validateAttributelist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Attribute":"5bgfz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"99wEG":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Beer", ()=>Beer);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Beer] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBeer", ()=>validateBeer);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Beer extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Beer#clone(obj: PlainObjectFrom<Beer>) method.
     */ constructor(__name, __beerCompanyName, __beerId, __beerTypeName, __description){
        super();
        this.name = __name;
        this.beerCompanyName = __beerCompanyName;
        this.beerId = __beerId;
        this.beerTypeName = __beerTypeName;
        this.description = __description;
    }
    /**
     * Create a shallow clone of Beer from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Beer(obj.name, obj.beerCompanyName, obj.beerId, obj.beerTypeName, obj.description);
    }
    static fromJson(data) {
        return new Beer((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.name), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerCompanyName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerTypeName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.description));
    }
    static toJson(data) {
        return Object.assign({
            name: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.name),
            beerCompanyName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerCompanyName),
            beerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerId),
            beerTypeName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.beerTypeName),
            description: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.description)
        });
    }
}
Beer.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#Beer";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Beer);
function validateBeer(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"spuJj":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BeerList", ()=>BeerList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BeerList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBeerlist", ()=>validateBeerlist);
var _beerListDefinition = require("./beerListDefinition");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class BeerList extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BeerList#clone(obj: PlainObjectFrom<BeerList>) method.
     */ constructor(__beers){
        super();
        this.beers = __beers;
    }
    /**
     * Create a shallow clone of BeerList from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BeerList(obj.beers);
    }
    static fromJson(data) {
        return new BeerList((($$val)=>$$val == undefined ? undefined : (0, _beerListDefinition.beerListDefinition).fromJson($$val))(data.beers));
    }
    static toJson(data) {
        return Object.assign({
            beers: (($$val)=>$$val == undefined ? null : (0, _beerListDefinition.beerListDefinition).toJson($$val))(data.beers)
        });
    }
}
BeerList.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#BeerList";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BeerList);
function validateBeerlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./beerListDefinition":"bkU9h","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bkU9h":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "beerListDefinition", ()=>beerListDefinition);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [beerListDefinition] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBeerlistdefinition", ()=>validateBeerlistdefinition);
var _beer = require("./Beer");
class beerListDefinition extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(beerListDefinition.prototype));
    }
    static fromJson(data) {
        return new beerListDefinition(data.map((datum)=>(0, _beer.Beer).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _beer.Beer).toJson(datum));
    }
}
function validateBeerlistdefinition(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Beer":"99wEG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1rbwU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for BuildDataPipelines API
 * Takes input as Term and ReportType and builds all data pipelines required as per the ReportType configuration done
 * already.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "BuildDataPipelinesInput", ()=>BuildDataPipelinesInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BuildDataPipelinesInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBuilddatapipelinesinput", ()=>validateBuilddatapipelinesinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class BuildDataPipelinesInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BuildDataPipelinesInput#clone(obj: PlainObjectFrom<BuildDataPipelinesInput>) method.
     */ constructor(__reportType, __term){
        super();
        this.reportType = __reportType;
        this.term = __term;
    }
    /**
     * Create a shallow clone of BuildDataPipelinesInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new BuildDataPipelinesInput(obj.reportType, obj.term);
    }
    static fromJson(data) {
        return new BuildDataPipelinesInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term));
    }
    static toJson(data) {
        return Object.assign({
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term)
        });
    }
}
BuildDataPipelinesInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#BuildDataPipelinesInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BuildDataPipelinesInput);
function validateBuilddatapipelinesinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7R4kd":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for  BuildDataPipelines API
 * Keeping it empty for now for future extensibility
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "BuildDataPipelinesOutput", ()=>BuildDataPipelinesOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [BuildDataPipelinesOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateBuilddatapipelinesoutput", ()=>validateBuilddatapipelinesoutput);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class BuildDataPipelinesOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the BuildDataPipelinesOutput#clone(obj: PlainObjectFrom<BuildDataPipelinesOutput>) method.
     */ static fromJson(data) {
        return new BuildDataPipelinesOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
BuildDataPipelinesOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#BuildDataPipelinesOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(BuildDataPipelinesOutput);
function validateBuilddatapipelinesoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hXyB6":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for CompleteBatchReportUpload API
 * term , ReportType - represents the Term and Report Type for which the report upload is completed
 * CompleteUploadRequestList - resprents list of CompleteUploadRequest each for one report
 * Each CompleteUploadRequest consists of list of eTags of the parts that are uploaded successfully,
 * corresponding key and uploadId for the report
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "CompleteBatchReportUploadInput", ()=>CompleteBatchReportUploadInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CompleteBatchReportUploadInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCompletebatchreportuploadinput", ()=>validateCompletebatchreportuploadinput);
var _completeUploadRequestList = require("./CompleteUploadRequestList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CompleteBatchReportUploadInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CompleteBatchReportUploadInput#clone(obj: PlainObjectFrom<CompleteBatchReportUploadInput>) method.
     */ constructor(__CompleteUploadRequestList, __reportType, __term, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.CompleteUploadRequestList = __CompleteUploadRequestList;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of CompleteBatchReportUploadInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CompleteBatchReportUploadInput(obj.CompleteUploadRequestList, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new CompleteBatchReportUploadInput((0, _completeUploadRequestList.CompleteUploadRequestList).fromJson(data.CompleteUploadRequestList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            CompleteUploadRequestList: (0, _completeUploadRequestList.CompleteUploadRequestList).toJson(data.CompleteUploadRequestList),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
CompleteBatchReportUploadInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#CompleteBatchReportUploadInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CompleteBatchReportUploadInput);
function validateCompletebatchreportuploadinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./CompleteUploadRequestList":"gpmOB","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gpmOB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompleteUploadRequestList", ()=>CompleteUploadRequestList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CompleteUploadRequestList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCompleteuploadrequestlist", ()=>validateCompleteuploadrequestlist);
var _completeUploadRequest = require("./CompleteUploadRequest");
class CompleteUploadRequestList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(CompleteUploadRequestList.prototype));
    }
    static fromJson(data) {
        return new CompleteUploadRequestList(data.map((datum)=>(0, _completeUploadRequest.CompleteUploadRequest).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _completeUploadRequest.CompleteUploadRequest).toJson(datum));
    }
}
function validateCompleteuploadrequestlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./CompleteUploadRequest":"8xnN5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xnN5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>eTags: represents the list of entity tags obtained for each uploaded part, this list should be in the order of
 * partNumbers
 * uploadId: represents ID for the initiated multipart upload
 * key: represents the unique report key\/path for report that is uploaded
 * supportingDocumentInfo: Represents the information regarding supporting document
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "CompleteUploadRequest", ()=>CompleteUploadRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CompleteUploadRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCompleteuploadrequest", ()=>validateCompleteuploadrequest);
var _supportingDocumentInfo = require("./SupportingDocumentInfo");
var _etagsList = require("./ETagsList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CompleteUploadRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CompleteUploadRequest#clone(obj: PlainObjectFrom<CompleteUploadRequest>) method.
     */ constructor(__eTags, __key, __uploadId, __reportId, __supportingDocumentInfo){
        super();
        this.eTags = __eTags;
        this.key = __key;
        this.uploadId = __uploadId;
        this.reportId = __reportId;
        this.supportingDocumentInfo = __supportingDocumentInfo;
    }
    /**
     * Create a shallow clone of CompleteUploadRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CompleteUploadRequest(obj.eTags, obj.key, obj.uploadId, obj.reportId, obj.supportingDocumentInfo);
    }
    static fromJson(data) {
        return new CompleteUploadRequest((0, _etagsList.ETagsList).fromJson(data.eTags), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.uploadId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportId), (($$val)=>$$val == undefined ? undefined : (0, _supportingDocumentInfo.SupportingDocumentInfo).fromJson($$val))(data.supportingDocumentInfo));
    }
    static toJson(data) {
        return Object.assign({
            eTags: (0, _etagsList.ETagsList).toJson(data.eTags),
            key: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key),
            uploadId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.uploadId),
            reportId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportId),
            supportingDocumentInfo: (($$val)=>$$val == undefined ? null : (0, _supportingDocumentInfo.SupportingDocumentInfo).toJson($$val))(data.supportingDocumentInfo)
        });
    }
}
CompleteUploadRequest.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#CompleteUploadRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CompleteUploadRequest);
function validateCompleteuploadrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SupportingDocumentInfo":"ed7Ch","./ETagsList":"4P7ei","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ed7Ch":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>parentKey: A NonBlankString representing the key of the parent document.
 * This field establishes a relationship between the current document and its parent.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SupportingDocumentInfo", ()=>SupportingDocumentInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SupportingDocumentInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSupportingdocumentinfo", ()=>validateSupportingdocumentinfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SupportingDocumentInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SupportingDocumentInfo#clone(obj: PlainObjectFrom<SupportingDocumentInfo>) method.
     */ constructor(__parentKey){
        super();
        this.parentKey = __parentKey;
    }
    /**
     * Create a shallow clone of SupportingDocumentInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SupportingDocumentInfo(obj.parentKey);
    }
    static fromJson(data) {
        return new SupportingDocumentInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.parentKey));
    }
    static toJson(data) {
        return Object.assign({
            parentKey: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.parentKey)
        });
    }
}
SupportingDocumentInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SupportingDocumentInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SupportingDocumentInfo);
function validateSupportingdocumentinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4P7ei":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ETagsList", ()=>ETagsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ETagsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEtagslist", ()=>validateEtagslist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class ETagsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ETagsList.prototype));
    }
    static fromJson(data) {
        return new ETagsList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateEtagslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9WgUN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for CompleteBatchReportUpload API.
 * Keeping this empty for now for further extensibility
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "CompleteBatchReportUploadOutput", ()=>CompleteBatchReportUploadOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CompleteBatchReportUploadOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCompletebatchreportuploadoutput", ()=>validateCompletebatchreportuploadoutput);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CompleteBatchReportUploadOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CompleteBatchReportUploadOutput#clone(obj: PlainObjectFrom<CompleteBatchReportUploadOutput>) method.
     */ static fromJson(data) {
        return new CompleteBatchReportUploadOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
CompleteBatchReportUploadOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#CompleteBatchReportUploadOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CompleteBatchReportUploadOutput);
function validateCompletebatchreportuploadoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Idxi":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Combination of multiple SearchCriteria with provided CompositeSearchCriteriaOperator (Ex: AND\/OR).<\/p>
 **/ parcelHelpers.export(exports, "CompositeSearchCriteria", ()=>CompositeSearchCriteria);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CompositeSearchCriteria] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCompositesearchcriteria", ()=>validateCompositesearchcriteria);
var _searchCriteriaList = require("./SearchCriteriaList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CompositeSearchCriteria extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CompositeSearchCriteria#clone(obj: PlainObjectFrom<CompositeSearchCriteria>) method.
     */ constructor(__compositeSearchCriteriaOperator, __searchCriteriaList){
        super();
        this.compositeSearchCriteriaOperator = __compositeSearchCriteriaOperator;
        this.searchCriteriaList = __searchCriteriaList;
    }
    /**
     * Create a shallow clone of CompositeSearchCriteria from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CompositeSearchCriteria(obj.compositeSearchCriteriaOperator, obj.searchCriteriaList);
    }
    static fromJson(data) {
        return new CompositeSearchCriteria((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.compositeSearchCriteriaOperator), (0, _searchCriteriaList.SearchCriteriaList).fromJson(data.searchCriteriaList));
    }
    static toJson(data) {
        return Object.assign({
            compositeSearchCriteriaOperator: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.compositeSearchCriteriaOperator),
            searchCriteriaList: (0, _searchCriteriaList.SearchCriteriaList).toJson(data.searchCriteriaList)
        });
    }
}
CompositeSearchCriteria.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#CompositeSearchCriteria";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CompositeSearchCriteria);
function validateCompositesearchcriteria(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SearchCriteriaList":"jR5dI","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jR5dI":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchCriteriaList", ()=>SearchCriteriaList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SearchCriteriaList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSearchcriterialist", ()=>validateSearchcriterialist);
var _searchCriteria = require("./SearchCriteria");
class SearchCriteriaList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(SearchCriteriaList.prototype));
    }
    static fromJson(data) {
        return new SearchCriteriaList(data.map((datum)=>(0, _searchCriteria.SearchCriteria).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _searchCriteria.SearchCriteria).toJson(datum));
    }
}
function validateSearchcriterialist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SearchCriteria":"7a5KV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7a5KV":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Holds different types of search criteria. Only one of them can be used at a time<\/p>
 **/ parcelHelpers.export(exports, "SearchCriteria", ()=>SearchCriteria);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SearchCriteria] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSearchcriteria", ()=>validateSearchcriteria);
var _rangeSearchCriteria = require("./RangeSearchCriteria");
var _compositeSearchCriteria = require("./CompositeSearchCriteria");
var _equalsSearchCriteria = require("./EqualsSearchCriteria");
var _matchAnySearchCriteria = require("./MatchAnySearchCriteria");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SearchCriteria extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SearchCriteria#clone(obj: PlainObjectFrom<SearchCriteria>) method.
     */ constructor(__compositeSearchCriteria, __equalsSearchCriteria, __matchAnySearchCriteria, __rangeSearchCriteria){
        super();
        this.compositeSearchCriteria = __compositeSearchCriteria;
        this.equalsSearchCriteria = __equalsSearchCriteria;
        this.matchAnySearchCriteria = __matchAnySearchCriteria;
        this.rangeSearchCriteria = __rangeSearchCriteria;
    }
    /**
     * Create a shallow clone of SearchCriteria from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SearchCriteria(obj.compositeSearchCriteria, obj.equalsSearchCriteria, obj.matchAnySearchCriteria, obj.rangeSearchCriteria);
    }
    static fromJson(data) {
        return new SearchCriteria((($$val)=>$$val == undefined ? undefined : (0, _compositeSearchCriteria.CompositeSearchCriteria).fromJson($$val))(data.compositeSearchCriteria), (($$val)=>$$val == undefined ? undefined : (0, _equalsSearchCriteria.EqualsSearchCriteria).fromJson($$val))(data.equalsSearchCriteria), (($$val)=>$$val == undefined ? undefined : (0, _matchAnySearchCriteria.MatchAnySearchCriteria).fromJson($$val))(data.matchAnySearchCriteria), (($$val)=>$$val == undefined ? undefined : (0, _rangeSearchCriteria.RangeSearchCriteria).fromJson($$val))(data.rangeSearchCriteria));
    }
    static toJson(data) {
        return Object.assign({
            compositeSearchCriteria: (($$val)=>$$val == undefined ? null : (0, _compositeSearchCriteria.CompositeSearchCriteria).toJson($$val))(data.compositeSearchCriteria),
            equalsSearchCriteria: (($$val)=>$$val == undefined ? null : (0, _equalsSearchCriteria.EqualsSearchCriteria).toJson($$val))(data.equalsSearchCriteria),
            matchAnySearchCriteria: (($$val)=>$$val == undefined ? null : (0, _matchAnySearchCriteria.MatchAnySearchCriteria).toJson($$val))(data.matchAnySearchCriteria),
            rangeSearchCriteria: (($$val)=>$$val == undefined ? null : (0, _rangeSearchCriteria.RangeSearchCriteria).toJson($$val))(data.rangeSearchCriteria)
        });
    }
}
SearchCriteria.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SearchCriteria";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SearchCriteria);
function validateSearchcriteria(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RangeSearchCriteria":"34nvC","./CompositeSearchCriteria":"7Idxi","./EqualsSearchCriteria":"6ZwAx","./MatchAnySearchCriteria":"k7cUU","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"34nvC":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>     Criteria which specifies that field value should be in the range of provided startValue and endValue.
 * Range is inclusive of startValue and endValue.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "RangeSearchCriteria", ()=>RangeSearchCriteria);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RangeSearchCriteria] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRangesearchcriteria", ()=>validateRangesearchcriteria);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RangeSearchCriteria extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RangeSearchCriteria#clone(obj: PlainObjectFrom<RangeSearchCriteria>) method.
     */ constructor(__endValue, __field, __startValue){
        super();
        this.endValue = __endValue;
        this.field = __field;
        this.startValue = __startValue;
    }
    /**
     * Create a shallow clone of RangeSearchCriteria from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RangeSearchCriteria(obj.endValue, obj.field, obj.startValue);
    }
    static fromJson(data) {
        return new RangeSearchCriteria((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.endValue), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.field), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.startValue));
    }
    static toJson(data) {
        return Object.assign({
            endValue: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.endValue),
            field: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.field),
            startValue: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.startValue)
        });
    }
}
RangeSearchCriteria.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#RangeSearchCriteria";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RangeSearchCriteria);
function validateRangesearchcriteria(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZwAx":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Criteria to match provided field to corresponding value<\/p>
 **/ parcelHelpers.export(exports, "EqualsSearchCriteria", ()=>EqualsSearchCriteria);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [EqualsSearchCriteria] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateEqualssearchcriteria", ()=>validateEqualssearchcriteria);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class EqualsSearchCriteria extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the EqualsSearchCriteria#clone(obj: PlainObjectFrom<EqualsSearchCriteria>) method.
     */ constructor(__field, __value){
        super();
        this.field = __field;
        this.value = __value;
    }
    /**
     * Create a shallow clone of EqualsSearchCriteria from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new EqualsSearchCriteria(obj.field, obj.value);
    }
    static fromJson(data) {
        return new EqualsSearchCriteria((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.field), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.value));
    }
    static toJson(data) {
        return Object.assign({
            field: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.field),
            value: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.value)
        });
    }
}
EqualsSearchCriteria.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#EqualsSearchCriteria";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(EqualsSearchCriteria);
function validateEqualssearchcriteria(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7cUU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Criteria to match provided field to any of the values provided in valueList.<\/p>
 **/ parcelHelpers.export(exports, "MatchAnySearchCriteria", ()=>MatchAnySearchCriteria);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [MatchAnySearchCriteria] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateMatchanysearchcriteria", ()=>validateMatchanysearchcriteria);
var _fieldValueList = require("./FieldValueList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class MatchAnySearchCriteria extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the MatchAnySearchCriteria#clone(obj: PlainObjectFrom<MatchAnySearchCriteria>) method.
     */ constructor(__field, __valueList){
        super();
        this.field = __field;
        this.valueList = __valueList;
    }
    /**
     * Create a shallow clone of MatchAnySearchCriteria from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new MatchAnySearchCriteria(obj.field, obj.valueList);
    }
    static fromJson(data) {
        return new MatchAnySearchCriteria((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.field), (0, _fieldValueList.FieldValueList).fromJson(data.valueList));
    }
    static toJson(data) {
        return Object.assign({
            field: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.field),
            valueList: (0, _fieldValueList.FieldValueList).toJson(data.valueList)
        });
    }
}
MatchAnySearchCriteria.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#MatchAnySearchCriteria";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(MatchAnySearchCriteria);
function validateMatchanysearchcriteria(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FieldValueList":"hK5J4","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hK5J4":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldValueList", ()=>FieldValueList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FieldValueList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFieldvaluelist", ()=>validateFieldvaluelist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class FieldValueList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FieldValueList.prototype));
    }
    static fromJson(data) {
        return new FieldValueList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateFieldvaluelist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"zkaUZ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Logical operator to combine two or more SearchCriteria.<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompositeSearchCriteriaOperator", ()=>CompositeSearchCriteriaOperator);
var CompositeSearchCriteriaOperator;
(function(CompositeSearchCriteriaOperator) {
    CompositeSearchCriteriaOperator["AND"] = "AND";
    CompositeSearchCriteriaOperator["OR"] = "OR";
})(CompositeSearchCriteriaOperator || (CompositeSearchCriteriaOperator = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czmqe":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for  CreateReportApproval API
 * reportId: Unique identifier representing a report.
 * expirationDate: Timestamp indicating when this approval will expire.
 * requiredApprovers: POSIX group containing the list of approvers.
 * additionalApprovalAttributesList: List holds any additional information related to the approval.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "CreateReportApprovalInput", ()=>CreateReportApprovalInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CreateReportApprovalInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCreatereportapprovalinput", ()=>validateCreatereportapprovalinput);
var _additionalApprovalAttributesList = require("./AdditionalApprovalAttributesList");
var _requiredApproversList = require("./RequiredApproversList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CreateReportApprovalInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CreateReportApprovalInput#clone(obj: PlainObjectFrom<CreateReportApprovalInput>) method.
     */ constructor(__expirationDate, __reportId, __reportType, __requiredApprovers, __term, __additionalApprovalAttributesList, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.expirationDate = __expirationDate;
        this.reportId = __reportId;
        this.reportType = __reportType;
        this.requiredApprovers = __requiredApprovers;
        this.term = __term;
        this.additionalApprovalAttributesList = __additionalApprovalAttributesList;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of CreateReportApprovalInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CreateReportApprovalInput(obj.expirationDate, obj.reportId, obj.reportType, obj.requiredApprovers, obj.term, obj.additionalApprovalAttributesList, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new CreateReportApprovalInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.expirationDate), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _requiredApproversList.RequiredApproversList).fromJson(data.requiredApprovers), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _additionalApprovalAttributesList.AdditionalApprovalAttributesList).fromJson($$val))(data.additionalApprovalAttributesList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            expirationDate: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.expirationDate),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            requiredApprovers: (0, _requiredApproversList.RequiredApproversList).toJson(data.requiredApprovers),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            additionalApprovalAttributesList: (($$val)=>$$val == undefined ? null : (0, _additionalApprovalAttributesList.AdditionalApprovalAttributesList).toJson($$val))(data.additionalApprovalAttributesList),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
CreateReportApprovalInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#CreateReportApprovalInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreateReportApprovalInput);
function validateCreatereportapprovalinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AdditionalApprovalAttributesList":"7jTpP","./RequiredApproversList":"aRftg","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aRftg":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequiredApproversList", ()=>RequiredApproversList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RequiredApproversList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRequiredapproverslist", ()=>validateRequiredapproverslist);
var _requiredApproverInfo = require("./RequiredApproverInfo");
class RequiredApproversList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(RequiredApproversList.prototype));
    }
    static fromJson(data) {
        return new RequiredApproversList(data.map((datum)=>(0, _requiredApproverInfo.RequiredApproverInfo).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _requiredApproverInfo.RequiredApproverInfo).toJson(datum));
    }
}
function validateRequiredapproverslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./RequiredApproverInfo":"5Y2n0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jLzHG":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for  CreateReportApproval API
 * reportId: Unique identifier representing a report.
 * approvalReportCreationStatus: Status of the approval report (e.g., 'ApprovalCreated').
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "CreateReportApprovalOutput", ()=>CreateReportApprovalOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [CreateReportApprovalOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateCreatereportapprovaloutput", ()=>validateCreatereportapprovaloutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class CreateReportApprovalOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the CreateReportApprovalOutput#clone(obj: PlainObjectFrom<CreateReportApprovalOutput>) method.
     */ constructor(__reportApprovalCreationStatus, __reportId){
        super();
        this.reportApprovalCreationStatus = __reportApprovalCreationStatus;
        this.reportId = __reportId;
    }
    /**
     * Create a shallow clone of CreateReportApprovalOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new CreateReportApprovalOutput(obj.reportApprovalCreationStatus, obj.reportId);
    }
    static fromJson(data) {
        return new CreateReportApprovalOutput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportApprovalCreationStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId));
    }
    static toJson(data) {
        return Object.assign({
            reportApprovalCreationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportApprovalCreationStatus),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId)
        });
    }
}
CreateReportApprovalOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#CreateReportApprovalOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(CreateReportApprovalOutput);
function validateCreatereportapprovaloutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ixGLP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds different constraints applicable for Date Field type.
 * dateFormat - Format of the data. Ex: YYYY-MM-DD
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "DateFieldTypeConstraints", ()=>DateFieldTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DateFieldTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDatefieldtypeconstraints", ()=>validateDatefieldtypeconstraints);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DateFieldTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DateFieldTypeConstraints#clone(obj: PlainObjectFrom<DateFieldTypeConstraints>) method.
     */ constructor(__dateFormat){
        super();
        this.dateFormat = __dateFormat;
    }
    /**
     * Create a shallow clone of DateFieldTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DateFieldTypeConstraints(obj.dateFormat);
    }
    static fromJson(data) {
        return new DateFieldTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.dateFormat));
    }
    static toJson(data) {
        return Object.assign({
            dateFormat: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.dateFormat)
        });
    }
}
DateFieldTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DateFieldTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DateFieldTypeConstraints);
function validateDatefieldtypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amp4y":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds different constraints applicable for DatePicker field control type.
 * maxPastAllowedDays - specifies the maximum past date allowed to pick
 * maxFutureAllowedDays -  specifies the maximum future date allowed to pick
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "DatePickerFormFieldControlTypeConstraints", ()=>DatePickerFormFieldControlTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DatePickerFormFieldControlTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDatepickerformfieldcontroltypeconstraints", ()=>validateDatepickerformfieldcontroltypeconstraints);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DatePickerFormFieldControlTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DatePickerFormFieldControlTypeConstraints#clone(obj: PlainObjectFrom<DatePickerFormFieldControlTypeConstraints>) method.
     */ constructor(__maxFutureAllowedDays, __maxPastAllowedDays){
        super();
        this.maxFutureAllowedDays = __maxFutureAllowedDays;
        this.maxPastAllowedDays = __maxPastAllowedDays;
    }
    /**
     * Create a shallow clone of DatePickerFormFieldControlTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DatePickerFormFieldControlTypeConstraints(obj.maxFutureAllowedDays, obj.maxPastAllowedDays);
    }
    static fromJson(data) {
        return new DatePickerFormFieldControlTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.maxFutureAllowedDays), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.maxPastAllowedDays));
    }
    static toJson(data) {
        return Object.assign({
            maxFutureAllowedDays: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.maxFutureAllowedDays),
            maxPastAllowedDays: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.maxPastAllowedDays)
        });
    }
}
DatePickerFormFieldControlTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DatePickerFormFieldControlTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DatePickerFormFieldControlTypeConstraints);
function validateDatepickerformfieldcontroltypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dP3Tl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for DeleteReport API
 * reportId - Unique identifier for a report
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "DeleteReportInput", ()=>DeleteReportInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeleteReportInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeletereportinput", ()=>validateDeletereportinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DeleteReportInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeleteReportInput#clone(obj: PlainObjectFrom<DeleteReportInput>) method.
     */ constructor(__reportId, __reportType, __term, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.reportId = __reportId;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of DeleteReportInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DeleteReportInput(obj.reportId, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new DeleteReportInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
DeleteReportInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DeleteReportInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeleteReportInput);
function validateDeletereportinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCUxM":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for DeleteReport API
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "DeleteReportOutput", ()=>DeleteReportOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DeleteReportOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDeletereportoutput", ()=>validateDeletereportoutput);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DeleteReportOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DeleteReportOutput#clone(obj: PlainObjectFrom<DeleteReportOutput>) method.
     */ static fromJson(data) {
        return new DeleteReportOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
DeleteReportOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DeleteReportOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DeleteReportOutput);
function validateDeletereportoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewwej":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on a database (or other dependency) error<\/p>
 **/ parcelHelpers.export(exports, "DependencyException", ()=>DependencyException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DependencyException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDependencyexception", ()=>validateDependencyexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DependencyException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DependencyException#clone(obj: PlainObjectFrom<DependencyException>) method.
     */ constructor(__message){
        super();
        this.message = __message;
    }
    /**
     * Create a shallow clone of DependencyException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DependencyException(obj.message);
    }
    static fromJson(data) {
        return new DependencyException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
DependencyException.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DependencyException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DependencyException);
function validateDependencyexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2IK4":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for DownloadReport API
 * reportId - Unique identifier for a report
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "DownloadReportInput", ()=>DownloadReportInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DownloadReportInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDownloadreportinput", ()=>validateDownloadreportinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DownloadReportInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DownloadReportInput#clone(obj: PlainObjectFrom<DownloadReportInput>) method.
     */ constructor(__reportId, __reportType, __term, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.reportId = __reportId;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of DownloadReportInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DownloadReportInput(obj.reportId, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new DownloadReportInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
DownloadReportInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DownloadReportInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DownloadReportInput);
function validateDownloadreportinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j61BD":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Output for DownloadReport API
 * downloadUrl - s3 presigned url for the report
 * reportName - represents name of the report
 * reportFormat - represents report format, ex: xlsx<\/p>
 **/ parcelHelpers.export(exports, "DownloadReportOutput", ()=>DownloadReportOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [DownloadReportOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateDownloadreportoutput", ()=>validateDownloadreportoutput);
var _supportingDocumentURLMap = require("./SupportingDocumentURLMap");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class DownloadReportOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the DownloadReportOutput#clone(obj: PlainObjectFrom<DownloadReportOutput>) method.
     */ constructor(__downloadUrl, __reportFormat, __reportName, __supportingDocumentUrls){
        super();
        this.downloadUrl = __downloadUrl;
        this.reportFormat = __reportFormat;
        this.reportName = __reportName;
        this.supportingDocumentUrls = __supportingDocumentUrls;
    }
    /**
     * Create a shallow clone of DownloadReportOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new DownloadReportOutput(obj.downloadUrl, obj.reportFormat, obj.reportName, obj.supportingDocumentUrls);
    }
    static fromJson(data) {
        return new DownloadReportOutput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.downloadUrl), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportFormat), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportName), (($$val)=>$$val == undefined ? undefined : (0, _supportingDocumentURLMap.SupportingDocumentURLMap).fromJson($$val))(data.supportingDocumentUrls));
    }
    static toJson(data) {
        return Object.assign({
            downloadUrl: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.downloadUrl),
            reportFormat: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportFormat),
            reportName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportName),
            supportingDocumentUrls: (($$val)=>$$val == undefined ? null : (0, _supportingDocumentURLMap.SupportingDocumentURLMap).toJson($$val))(data.supportingDocumentUrls)
        });
    }
}
DownloadReportOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#DownloadReportOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(DownloadReportOutput);
function validateDownloadreportoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SupportingDocumentURLMap":"bta6X","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bta6X":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>key - key will be supporting document path
 * value - value will be S3 pre-signed URL of supporting document
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SupportingDocumentURLMap", ()=>SupportingDocumentURLMap);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SupportingDocumentURLMap] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSupportingdocumenturlmap", ()=>validateSupportingdocumenturlmap);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class SupportingDocumentURLMap {
    constructor(options){
        for (const key of Object.keys(options))this[key] = options[key];
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data))obj[key] = (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data[key]);
        return new SupportingDocumentURLMap(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map))data[key] = (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(map[key]);
        return data;
    }
}
function validateSupportingdocumenturlmap(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iJiw7":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Holds error codes - specifies the type of error
 * DEPENDENCY_FAILURE - Failures occurred due to reporting system dependency service failures.
 * DRYAD_DEPENDENCY_FAILURE - Failures occurred due to reporting system dependency Dryad service.
 * INTERNAL_FAILURE - Failures occurred due to any missing data\/unexpected cases in reporting system.
 * CLIENT_FAILURE - Failures occurred due to any client error - Invalid inputs, Not Authorized to access etc.,
 * MISSING_REPORT: Failure occurred because the requested report is not present in source.
 * MISSING_REPORT_RECORD: Failure occurred because the record or entry for a report is not present in the DB.
 * MISSING_REPORT_CONFIGURATION: Failure occurred because the configuration for term is not present.
 * MISSING_VIEW_PERMISSIONS: Failure occurred because the VIEW permissions to perform an action is not
 * present.
 * MISSING_EDIT_PERMISSIONS: Failure occurred because the EDIT permissions to perform an action is not
 * present.
 * Note : To add more error codes when required.
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
var ErrorCode;
(function(ErrorCode) {
    ErrorCode["DEPENDENCY_FAILURE"] = "DEPENDENCY_FAILURE";
    ErrorCode["DRYAD_DEPENDENCY_FAILURE"] = "DRYAD_DEPENDENCY_FAILURE";
    ErrorCode["INTERNAL_FAILURE"] = "INTERNAL_FAILURE";
    ErrorCode["CLIENT_FAILURE"] = "CLIENT_FAILURE";
    ErrorCode["MISSING_REPORT"] = "MISSING_REPORT";
    ErrorCode["MISSING_REPORT_RECORD"] = "MISSING_REPORT_RECORD";
    ErrorCode["MISSING_REPORT_CONFIGURATION"] = "MISSING_REPORT_CONFIGURATION";
    ErrorCode["MISSING_VIEW_PERMISSIONS"] = "MISSING_VIEW_PERMISSIONS";
    ErrorCode["MISSING_EDIT_PERMISSIONS"] = "MISSING_EDIT_PERMISSIONS";
})(ErrorCode || (ErrorCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6K4j6":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents different data types of fields.
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldType", ()=>FieldType);
var FieldType;
(function(FieldType) {
    FieldType["STRING"] = "STRING";
    FieldType["DATE"] = "DATE";
    FieldType["NUMBER"] = "NUMBER";
})(FieldType || (FieldType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ceLQA":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Specifies different constraints to be applied on the field. Different field types can have
 * different constraints and only one of them will be used at a time based on field type.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "FieldTypeConstraints", ()=>FieldTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FieldTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFieldtypeconstraints", ()=>validateFieldtypeconstraints);
var _dateFieldTypeConstraints = require("./DateFieldTypeConstraints");
var _stringFieldTypeConstraints = require("./StringFieldTypeConstraints");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FieldTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FieldTypeConstraints#clone(obj: PlainObjectFrom<FieldTypeConstraints>) method.
     */ constructor(__dateFieldTypeConstraints, __stringFieldTypeConstraints){
        super();
        this.dateFieldTypeConstraints = __dateFieldTypeConstraints;
        this.stringFieldTypeConstraints = __stringFieldTypeConstraints;
    }
    /**
     * Create a shallow clone of FieldTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FieldTypeConstraints(obj.dateFieldTypeConstraints, obj.stringFieldTypeConstraints);
    }
    static fromJson(data) {
        return new FieldTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _dateFieldTypeConstraints.DateFieldTypeConstraints).fromJson($$val))(data.dateFieldTypeConstraints), (($$val)=>$$val == undefined ? undefined : (0, _stringFieldTypeConstraints.StringFieldTypeConstraints).fromJson($$val))(data.stringFieldTypeConstraints));
    }
    static toJson(data) {
        return Object.assign({
            dateFieldTypeConstraints: (($$val)=>$$val == undefined ? null : (0, _dateFieldTypeConstraints.DateFieldTypeConstraints).toJson($$val))(data.dateFieldTypeConstraints),
            stringFieldTypeConstraints: (($$val)=>$$val == undefined ? null : (0, _stringFieldTypeConstraints.StringFieldTypeConstraints).toJson($$val))(data.stringFieldTypeConstraints)
        });
    }
}
FieldTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#FieldTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FieldTypeConstraints);
function validateFieldtypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./DateFieldTypeConstraints":"ixGLP","./StringFieldTypeConstraints":"lcGhi","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lcGhi":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds different constraints applicable for String Field type.
 * regexPattern - Regex pattern data should hold
 * minLength - minimum length of the data
 * maxLength - maximum length of the data
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "StringFieldTypeConstraints", ()=>StringFieldTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [StringFieldTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateStringfieldtypeconstraints", ()=>validateStringfieldtypeconstraints);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class StringFieldTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the StringFieldTypeConstraints#clone(obj: PlainObjectFrom<StringFieldTypeConstraints>) method.
     */ constructor(__maxLength, __minLength, __regexPattern){
        super();
        this.maxLength = __maxLength;
        this.minLength = __minLength;
        this.regexPattern = __regexPattern;
    }
    /**
     * Create a shallow clone of StringFieldTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new StringFieldTypeConstraints(obj.maxLength, obj.minLength, obj.regexPattern);
    }
    static fromJson(data) {
        return new StringFieldTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.maxLength), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.minLength), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.regexPattern));
    }
    static toJson(data) {
        return Object.assign({
            maxLength: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.maxLength),
            minLength: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.minLength),
            regexPattern: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.regexPattern)
        });
    }
}
StringFieldTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#StringFieldTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(StringFieldTypeConstraints);
function validateStringfieldtypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8w5MR":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds different constraints applicable for File field control type.
 * multiFilesUploadAllowed - specifies if multiple files can be uploaded
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "FileControlTypeConstraints", ()=>FileControlTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FileControlTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFilecontroltypeconstraints", ()=>validateFilecontroltypeconstraints);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FileControlTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FileControlTypeConstraints#clone(obj: PlainObjectFrom<FileControlTypeConstraints>) method.
     */ constructor(__multiFilesUploadAllowed){
        super();
        this.multiFilesUploadAllowed = __multiFilesUploadAllowed;
    }
    /**
     * Create a shallow clone of FileControlTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FileControlTypeConstraints(obj.multiFilesUploadAllowed);
    }
    static fromJson(data) {
        return new FileControlTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.multiFilesUploadAllowed));
    }
    static toJson(data) {
        return Object.assign({
            multiFilesUploadAllowed: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.multiFilesUploadAllowed)
        });
    }
}
FileControlTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#FileControlTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FileControlTypeConstraints);
function validateFilecontroltypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7e386":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents different flow types
 * EXTERNAL - Represents CarrierLogistics flow
 * INTERNAL - Represents Passport flow
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlowType", ()=>FlowType);
var FlowType;
(function(FlowType) {
    FlowType["INTERNAL"] = "INTERNAL";
    FlowType["EXTERNAL"] = "EXTERNAL";
})(FlowType || (FlowType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ff3QN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents a Form with different fields where data is filled by the user for report data generation.
 * formDisplayName - UI Display name of the Form
 * formFields - holds all fields related info of a Form
 * queryId - holds id of the query which needs to be executed for Report data generation
 * displayReportData - indicates whether the report data has to be shown on UI directly vs file download. If the
 * expected report data is less in size (example: &lt; 5 number of rows), we allow this to be true.
 * searchReportsHistoryEnabled - indicates whether the reports history dashboard has to be enabled for the user.
 * searchReportsHistoryUIConfig - if searchReportsHistoryEnabled is true, this config provides the info used by UI
 * client to display the dashboard
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "Form", ()=>Form);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Form] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateForm", ()=>validateForm);
var _formFieldList = require("./FormFieldList");
var _searchReportsHistoryUIConfig = require("./SearchReportsHistoryUIConfig");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Form extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Form#clone(obj: PlainObjectFrom<Form>) method.
     */ constructor(__displayReportData, __formDisplayName, __formFields, __queryId, __searchReportsHistoryEnabled, __searchReportsHistoryUIConfig){
        super();
        this.displayReportData = __displayReportData;
        this.formDisplayName = __formDisplayName;
        this.formFields = __formFields;
        this.queryId = __queryId;
        this.searchReportsHistoryEnabled = __searchReportsHistoryEnabled;
        this.searchReportsHistoryUIConfig = __searchReportsHistoryUIConfig;
    }
    /**
     * Create a shallow clone of Form from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Form(obj.displayReportData, obj.formDisplayName, obj.formFields, obj.queryId, obj.searchReportsHistoryEnabled, obj.searchReportsHistoryUIConfig);
    }
    static fromJson(data) {
        return new Form((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.displayReportData), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.formDisplayName), (0, _formFieldList.FormFieldList).fromJson(data.formFields), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queryId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.searchReportsHistoryEnabled), (($$val)=>$$val == undefined ? undefined : (0, _searchReportsHistoryUIConfig.SearchReportsHistoryUIConfig).fromJson($$val))(data.searchReportsHistoryUIConfig));
    }
    static toJson(data) {
        return Object.assign({
            displayReportData: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.displayReportData),
            formDisplayName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.formDisplayName),
            formFields: (0, _formFieldList.FormFieldList).toJson(data.formFields),
            queryId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queryId),
            searchReportsHistoryEnabled: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.searchReportsHistoryEnabled),
            searchReportsHistoryUIConfig: (($$val)=>$$val == undefined ? null : (0, _searchReportsHistoryUIConfig.SearchReportsHistoryUIConfig).toJson($$val))(data.searchReportsHistoryUIConfig)
        });
    }
}
Form.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#Form";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Form);
function validateForm(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FormFieldList":"emWa5","./SearchReportsHistoryUIConfig":"jl9TO","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"emWa5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormFieldList", ()=>FormFieldList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FormFieldList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFormfieldlist", ()=>validateFormfieldlist);
var _formField = require("./FormField");
class FormFieldList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FormFieldList.prototype));
    }
    static fromJson(data) {
        return new FormFieldList(data.map((datum)=>(0, _formField.FormField).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _formField.FormField).toJson(datum));
    }
}
function validateFormfieldlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FormField":"5AubO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5AubO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds information related to a field in the Report Form.
 * displayName - display name of the field
 * fieldName - holds corresponding DB attribute name for this field
 * fieldType - specifies the field data type. Example: string, date etc.,
 * fieldConstraints - specifies different constraints to be applied on the field. Different field types can have
 * different constraints.
 * fieldControlType - specifies the UI form field control type. Example: text input, select, radio button etc.,
 * fieldControlTypeConstraints - specifies different constraints to be applied on the field control type. Different
 * field control types can have different constraints.
 * isRequiredField - represents weather a field is mandatory or not
 * queryDynamicParameterName - holds this field's corresponding dynamic parameter name used in the ReportForm query
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "FormField", ()=>FormField);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FormField] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFormfield", ()=>validateFormfield);
var _fieldTypeConstraints = require("./FieldTypeConstraints");
var _formFieldControlTypeConstraints = require("./FormFieldControlTypeConstraints");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FormField extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FormField#clone(obj: PlainObjectFrom<FormField>) method.
     */ constructor(__displayName, __fieldControlType, __fieldName, __fieldType, __fieldConstraints, __fieldControlTypeConstraints, __isRequiredField, __queryDynamicParameterName){
        super();
        this.displayName = __displayName;
        this.fieldControlType = __fieldControlType;
        this.fieldName = __fieldName;
        this.fieldType = __fieldType;
        this.fieldConstraints = __fieldConstraints;
        this.fieldControlTypeConstraints = __fieldControlTypeConstraints;
        this.isRequiredField = __isRequiredField;
        this.queryDynamicParameterName = __queryDynamicParameterName;
    }
    /**
     * Create a shallow clone of FormField from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FormField(obj.displayName, obj.fieldControlType, obj.fieldName, obj.fieldType, obj.fieldConstraints, obj.fieldControlTypeConstraints, obj.isRequiredField, obj.queryDynamicParameterName);
    }
    static fromJson(data) {
        return new FormField((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.displayName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fieldControlType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fieldName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fieldType), (($$val)=>$$val == undefined ? undefined : (0, _fieldTypeConstraints.FieldTypeConstraints).fromJson($$val))(data.fieldConstraints), (($$val)=>$$val == undefined ? undefined : (0, _formFieldControlTypeConstraints.FormFieldControlTypeConstraints).fromJson($$val))(data.fieldControlTypeConstraints), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isRequiredField), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.queryDynamicParameterName));
    }
    static toJson(data) {
        return Object.assign({
            displayName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.displayName),
            fieldControlType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fieldControlType),
            fieldName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fieldName),
            fieldType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.fieldType),
            fieldConstraints: (($$val)=>$$val == undefined ? null : (0, _fieldTypeConstraints.FieldTypeConstraints).toJson($$val))(data.fieldConstraints),
            fieldControlTypeConstraints: (($$val)=>$$val == undefined ? null : (0, _formFieldControlTypeConstraints.FormFieldControlTypeConstraints).toJson($$val))(data.fieldControlTypeConstraints),
            isRequiredField: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isRequiredField),
            queryDynamicParameterName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.queryDynamicParameterName)
        });
    }
}
FormField.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#FormField";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FormField);
function validateFormfield(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FieldTypeConstraints":"ceLQA","./FormFieldControlTypeConstraints":"icxK5","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"icxK5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Specifies different constraints to be applied on the field control type. Different
 * field control types can have different constraints and only one of them will be used at a time based on field
 * control type.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "FormFieldControlTypeConstraints", ()=>FormFieldControlTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FormFieldControlTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFormfieldcontroltypeconstraints", ()=>validateFormfieldcontroltypeconstraints);
var _fileControlTypeConstraints = require("./FileControlTypeConstraints");
var _datePickerFormFieldControlTypeConstraints = require("./DatePickerFormFieldControlTypeConstraints");
var _selectFormFieldControlTypeConstraints = require("./SelectFormFieldControlTypeConstraints");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class FormFieldControlTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the FormFieldControlTypeConstraints#clone(obj: PlainObjectFrom<FormFieldControlTypeConstraints>) method.
     */ constructor(__datePickerFormFieldControlTypeConstraints, __fileControlTypeConstraints, __selectFormFieldControlTypeConstraints){
        super();
        this.datePickerFormFieldControlTypeConstraints = __datePickerFormFieldControlTypeConstraints;
        this.fileControlTypeConstraints = __fileControlTypeConstraints;
        this.selectFormFieldControlTypeConstraints = __selectFormFieldControlTypeConstraints;
    }
    /**
     * Create a shallow clone of FormFieldControlTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new FormFieldControlTypeConstraints(obj.datePickerFormFieldControlTypeConstraints, obj.fileControlTypeConstraints, obj.selectFormFieldControlTypeConstraints);
    }
    static fromJson(data) {
        return new FormFieldControlTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _datePickerFormFieldControlTypeConstraints.DatePickerFormFieldControlTypeConstraints).fromJson($$val))(data.datePickerFormFieldControlTypeConstraints), (($$val)=>$$val == undefined ? undefined : (0, _fileControlTypeConstraints.FileControlTypeConstraints).fromJson($$val))(data.fileControlTypeConstraints), (($$val)=>$$val == undefined ? undefined : (0, _selectFormFieldControlTypeConstraints.SelectFormFieldControlTypeConstraints).fromJson($$val))(data.selectFormFieldControlTypeConstraints));
    }
    static toJson(data) {
        return Object.assign({
            datePickerFormFieldControlTypeConstraints: (($$val)=>$$val == undefined ? null : (0, _datePickerFormFieldControlTypeConstraints.DatePickerFormFieldControlTypeConstraints).toJson($$val))(data.datePickerFormFieldControlTypeConstraints),
            fileControlTypeConstraints: (($$val)=>$$val == undefined ? null : (0, _fileControlTypeConstraints.FileControlTypeConstraints).toJson($$val))(data.fileControlTypeConstraints),
            selectFormFieldControlTypeConstraints: (($$val)=>$$val == undefined ? null : (0, _selectFormFieldControlTypeConstraints.SelectFormFieldControlTypeConstraints).toJson($$val))(data.selectFormFieldControlTypeConstraints)
        });
    }
}
FormFieldControlTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#FormFieldControlTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(FormFieldControlTypeConstraints);
function validateFormfieldcontroltypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FileControlTypeConstraints":"8w5MR","./DatePickerFormFieldControlTypeConstraints":"amp4y","./SelectFormFieldControlTypeConstraints":"jjOTd","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jjOTd":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds different constraints applicable for Select field control type.
 * multiSelectAllowed - specifies if multi select is allowed for the field
 * defaultValueList - holds default values of the select list
 * s3ObjectInfo - holds the S3 object info that contains default values.
 * queryId - holds id of query to be executed in case field values need to be fetched dynamically.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SelectFormFieldControlTypeConstraints", ()=>SelectFormFieldControlTypeConstraints);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SelectFormFieldControlTypeConstraints] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSelectformfieldcontroltypeconstraints", ()=>validateSelectformfieldcontroltypeconstraints);
var _formFieldValueList = require("./FormFieldValueList");
var _s3ObjectInfo = require("./S3ObjectInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SelectFormFieldControlTypeConstraints extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SelectFormFieldControlTypeConstraints#clone(obj: PlainObjectFrom<SelectFormFieldControlTypeConstraints>) method.
     */ constructor(__defaultValueList, __multiSelectAllowed, __queryId, __s3ObjectInfo){
        super();
        this.defaultValueList = __defaultValueList;
        this.multiSelectAllowed = __multiSelectAllowed;
        this.queryId = __queryId;
        this.s3ObjectInfo = __s3ObjectInfo;
    }
    /**
     * Create a shallow clone of SelectFormFieldControlTypeConstraints from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SelectFormFieldControlTypeConstraints(obj.defaultValueList, obj.multiSelectAllowed, obj.queryId, obj.s3ObjectInfo);
    }
    static fromJson(data) {
        return new SelectFormFieldControlTypeConstraints((($$val)=>$$val == undefined ? undefined : (0, _formFieldValueList.FormFieldValueList).fromJson($$val))(data.defaultValueList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.multiSelectAllowed), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.queryId), (($$val)=>$$val == undefined ? undefined : (0, _s3ObjectInfo.S3ObjectInfo).fromJson($$val))(data.s3ObjectInfo));
    }
    static toJson(data) {
        return Object.assign({
            defaultValueList: (($$val)=>$$val == undefined ? null : (0, _formFieldValueList.FormFieldValueList).toJson($$val))(data.defaultValueList),
            multiSelectAllowed: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.multiSelectAllowed),
            queryId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.queryId),
            s3ObjectInfo: (($$val)=>$$val == undefined ? null : (0, _s3ObjectInfo.S3ObjectInfo).toJson($$val))(data.s3ObjectInfo)
        });
    }
}
SelectFormFieldControlTypeConstraints.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SelectFormFieldControlTypeConstraints";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SelectFormFieldControlTypeConstraints);
function validateSelectformfieldcontroltypeconstraints(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FormFieldValueList":"2590j","./S3ObjectInfo":"hVvOf","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2590j":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormFieldValueList", ()=>FormFieldValueList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FormFieldValueList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFormfieldvaluelist", ()=>validateFormfieldvaluelist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class FormFieldValueList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FormFieldValueList.prototype));
    }
    static fromJson(data) {
        return new FormFieldValueList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateFormfieldvaluelist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVvOf":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds information related to S3 Dataset.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "S3ObjectInfo", ()=>S3ObjectInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [S3ObjectInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateS3objectinfo", ()=>validateS3objectinfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class S3ObjectInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the S3ObjectInfo#clone(obj: PlainObjectFrom<S3ObjectInfo>) method.
     */ constructor(__bucketName, __key, __region){
        super();
        this.bucketName = __bucketName;
        this.key = __key;
        this.region = __region;
    }
    /**
     * Create a shallow clone of S3ObjectInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new S3ObjectInfo(obj.bucketName, obj.key, obj.region);
    }
    static fromJson(data) {
        return new S3ObjectInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.bucketName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.region));
    }
    static toJson(data) {
        return Object.assign({
            bucketName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.bucketName),
            key: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key),
            region: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.region)
        });
    }
}
S3ObjectInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#S3ObjectInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(S3ObjectInfo);
function validateS3objectinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jl9TO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds the info used by UI client to display the reports history dashboard.
 * dashboardColumnsList - holds different columns to be displayed on Dashboard
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SearchReportsHistoryUIConfig", ()=>SearchReportsHistoryUIConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SearchReportsHistoryUIConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSearchreportshistoryuiconfig", ()=>validateSearchreportshistoryuiconfig);
var _reportHistoryDashboardColumnsList = require("./ReportHistoryDashboardColumnsList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SearchReportsHistoryUIConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SearchReportsHistoryUIConfig#clone(obj: PlainObjectFrom<SearchReportsHistoryUIConfig>) method.
     */ constructor(__dashboardColumnsList){
        super();
        this.dashboardColumnsList = __dashboardColumnsList;
    }
    /**
     * Create a shallow clone of SearchReportsHistoryUIConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SearchReportsHistoryUIConfig(obj.dashboardColumnsList);
    }
    static fromJson(data) {
        return new SearchReportsHistoryUIConfig((($$val)=>$$val == undefined ? undefined : (0, _reportHistoryDashboardColumnsList.ReportHistoryDashboardColumnsList).fromJson($$val))(data.dashboardColumnsList));
    }
    static toJson(data) {
        return Object.assign({
            dashboardColumnsList: (($$val)=>$$val == undefined ? null : (0, _reportHistoryDashboardColumnsList.ReportHistoryDashboardColumnsList).toJson($$val))(data.dashboardColumnsList)
        });
    }
}
SearchReportsHistoryUIConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SearchReportsHistoryUIConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SearchReportsHistoryUIConfig);
function validateSearchreportshistoryuiconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportHistoryDashboardColumnsList":"gRbhZ","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gRbhZ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportHistoryDashboardColumnsList", ()=>ReportHistoryDashboardColumnsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportHistoryDashboardColumnsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReporthistorydashboardcolumnslist", ()=>validateReporthistorydashboardcolumnslist);
var _reportHistoryDashboardColumn = require("./ReportHistoryDashboardColumn");
class ReportHistoryDashboardColumnsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ReportHistoryDashboardColumnsList.prototype));
    }
    static fromJson(data) {
        return new ReportHistoryDashboardColumnsList(data.map((datum)=>(0, _reportHistoryDashboardColumn.ReportHistoryDashboardColumn).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _reportHistoryDashboardColumn.ReportHistoryDashboardColumn).toJson(datum));
    }
}
function validateReporthistorydashboardcolumnslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportHistoryDashboardColumn":"ksHQh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ksHQh":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds report history dashboard columns related information.
 * columnDisplayName - holds column display Name in the dashboard
 * valuePathStructure - holds column value structure, value is derived from 'Report' record data.
 * Example: metadata.startDate (which is read from Report data)
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportHistoryDashboardColumn", ()=>ReportHistoryDashboardColumn);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportHistoryDashboardColumn] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReporthistorydashboardcolumn", ()=>validateReporthistorydashboardcolumn);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportHistoryDashboardColumn extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportHistoryDashboardColumn#clone(obj: PlainObjectFrom<ReportHistoryDashboardColumn>) method.
     */ constructor(__columnDisplayName, __valuePathStructure){
        super();
        this.columnDisplayName = __columnDisplayName;
        this.valuePathStructure = __valuePathStructure;
    }
    /**
     * Create a shallow clone of ReportHistoryDashboardColumn from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportHistoryDashboardColumn(obj.columnDisplayName, obj.valuePathStructure);
    }
    static fromJson(data) {
        return new ReportHistoryDashboardColumn((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.columnDisplayName), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.valuePathStructure));
    }
    static toJson(data) {
        return Object.assign({
            columnDisplayName: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.columnDisplayName),
            valuePathStructure: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.valuePathStructure)
        });
    }
}
ReportHistoryDashboardColumn.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportHistoryDashboardColumn";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportHistoryDashboardColumn);
function validateReporthistorydashboardcolumn(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1aH5C":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents different UI form field controls like Select, RadioButton, Date Picker etc.,
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormFieldControlType", ()=>FormFieldControlType);
var FormFieldControlType;
(function(FormFieldControlType) {
    FormFieldControlType["SELECT"] = "SELECT";
    FormFieldControlType["DATE_PICKER"] = "DATE_PICKER";
    FormFieldControlType["LINK"] = "LINK";
    FormFieldControlType["FILE"] = "FILE";
    FormFieldControlType["TEXT"] = "TEXT";
})(FormFieldControlType || (FormFieldControlType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7gKUz":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormList", ()=>FormList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [FormList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateFormlist", ()=>validateFormlist);
var _form = require("./Form");
class FormList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(FormList.prototype));
    }
    static fromJson(data) {
        return new FormList(data.map((datum)=>(0, _form.Form).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _form.Form).toJson(datum));
    }
}
function validateFormlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Form":"ff3QN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbuR8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GeneratePresignedUrl API
 * Takes s3 details as input such as bucket name, key and region.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GeneratePresignedUrlInput", ()=>GeneratePresignedUrlInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GeneratePresignedUrlInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGeneratepresignedurlinput", ()=>validateGeneratepresignedurlinput);
var _s3ObjectInfo = require("./S3ObjectInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GeneratePresignedUrlInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GeneratePresignedUrlInput#clone(obj: PlainObjectFrom<GeneratePresignedUrlInput>) method.
     */ constructor(__reportType, __s3ObjectInfo, __term, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.reportType = __reportType;
        this.s3ObjectInfo = __s3ObjectInfo;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of GeneratePresignedUrlInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GeneratePresignedUrlInput(obj.reportType, obj.s3ObjectInfo, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new GeneratePresignedUrlInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _s3ObjectInfo.S3ObjectInfo).fromJson(data.s3ObjectInfo), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            s3ObjectInfo: (0, _s3ObjectInfo.S3ObjectInfo).toJson(data.s3ObjectInfo),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
GeneratePresignedUrlInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GeneratePresignedUrlInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GeneratePresignedUrlInput);
function validateGeneratepresignedurlinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./S3ObjectInfo":"hVvOf","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3ssu":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>Output for GeneratePresignedUrl API
 * downloadUrl - s3 presigned url for the report<\/p>
 **/ parcelHelpers.export(exports, "GeneratePresignedUrlOutput", ()=>GeneratePresignedUrlOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GeneratePresignedUrlOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGeneratepresignedurloutput", ()=>validateGeneratepresignedurloutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GeneratePresignedUrlOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GeneratePresignedUrlOutput#clone(obj: PlainObjectFrom<GeneratePresignedUrlOutput>) method.
     */ constructor(__presignedUrl){
        super();
        this.presignedUrl = __presignedUrl;
    }
    /**
     * Create a shallow clone of GeneratePresignedUrlOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GeneratePresignedUrlOutput(obj.presignedUrl);
    }
    static fromJson(data) {
        return new GeneratePresignedUrlOutput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.presignedUrl));
    }
    static toJson(data) {
        return Object.assign({
            presignedUrl: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.presignedUrl)
        });
    }
}
GeneratePresignedUrlOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GeneratePresignedUrlOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GeneratePresignedUrlOutput);
function validateGeneratepresignedurloutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iPQ3g":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GenerateReportAsync API
 * ReportInformation, LogisticsParty (optional)- Takes the term, reportType and LP for which the report is generated
 * UserInformation - Used to capture details on who generates the report
 * QueryId - Holds id of the query which needs to be executed for Report data generation
 * DynamicAttributes - optional dynamic attributes
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GenerateReportAsyncInput", ()=>GenerateReportAsyncInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GenerateReportAsyncInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGeneratereportasyncinput", ()=>validateGeneratereportasyncinput);
var _attributeList = require("./AttributeList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GenerateReportAsyncInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GenerateReportAsyncInput#clone(obj: PlainObjectFrom<GenerateReportAsyncInput>) method.
     */ constructor(__queryId, __reportType, __term, __customerId, __dynamicAttributes, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.queryId = __queryId;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.dynamicAttributes = __dynamicAttributes;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of GenerateReportAsyncInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GenerateReportAsyncInput(obj.queryId, obj.reportType, obj.term, obj.customerId, obj.dynamicAttributes, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new GenerateReportAsyncInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queryId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _attributeList.AttributeList).fromJson($$val))(data.dynamicAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            queryId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queryId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            dynamicAttributes: (($$val)=>$$val == undefined ? null : (0, _attributeList.AttributeList).toJson($$val))(data.dynamicAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
GenerateReportAsyncInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GenerateReportAsyncInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GenerateReportAsyncInput);
function validateGeneratereportasyncinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AttributeList":"a31Of","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fdIlq":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GenerateReportAsync API
 * ReportId - Id of the report generated
 * ReportGenerationTriggerTime - time when report generation began. This is essentially reportRecordCreationTime.
 * ReportMetadata - metadata containing additional details that were used to generate the report.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GenerateReportAsyncOutput", ()=>GenerateReportAsyncOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GenerateReportAsyncOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGeneratereportasyncoutput", ()=>validateGeneratereportasyncoutput);
var _reportMetadata = require("./ReportMetadata");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GenerateReportAsyncOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GenerateReportAsyncOutput#clone(obj: PlainObjectFrom<GenerateReportAsyncOutput>) method.
     */ constructor(__reportGenerationTriggerTime, __reportId, __reportMetadata){
        super();
        this.reportGenerationTriggerTime = __reportGenerationTriggerTime;
        this.reportId = __reportId;
        this.reportMetadata = __reportMetadata;
    }
    /**
     * Create a shallow clone of GenerateReportAsyncOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GenerateReportAsyncOutput(obj.reportGenerationTriggerTime, obj.reportId, obj.reportMetadata);
    }
    static fromJson(data) {
        return new GenerateReportAsyncOutput((0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate(data.reportGenerationTriggerTime), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (($$val)=>$$val == undefined ? undefined : (0, _reportMetadata.ReportMetadata).fromJson($$val))(data.reportMetadata));
    }
    static toJson(data) {
        return Object.assign({
            reportGenerationTriggerTime: (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson(data.reportGenerationTriggerTime),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportMetadata: (($$val)=>$$val == undefined ? null : (0, _reportMetadata.ReportMetadata).toJson($$val))(data.reportMetadata)
        });
    }
}
GenerateReportAsyncOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GenerateReportAsyncOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GenerateReportAsyncOutput);
function validateGeneratereportasyncoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportMetadata":"c86my","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c86my":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents additional metadata info related to the report like report generation params etc.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportMetadata", ()=>ReportMetadata);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportMetadata] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportmetadata", ()=>validateReportmetadata);
var _attributeList = require("./AttributeList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportMetadata extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportMetadata#clone(obj: PlainObjectFrom<ReportMetadata>) method.
     */ constructor(__reportGenerationDynamicAttributes){
        super();
        this.reportGenerationDynamicAttributes = __reportGenerationDynamicAttributes;
    }
    /**
     * Create a shallow clone of ReportMetadata from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportMetadata(obj.reportGenerationDynamicAttributes);
    }
    static fromJson(data) {
        return new ReportMetadata((($$val)=>$$val == undefined ? undefined : (0, _attributeList.AttributeList).fromJson($$val))(data.reportGenerationDynamicAttributes));
    }
    static toJson(data) {
        return Object.assign({
            reportGenerationDynamicAttributes: (($$val)=>$$val == undefined ? null : (0, _attributeList.AttributeList).toJson($$val))(data.reportGenerationDynamicAttributes)
        });
    }
}
ReportMetadata.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportMetadata";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportMetadata);
function validateReportmetadata(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AttributeList":"a31Of","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kreQO":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GenerateReportSync API
 * ReportInformation, LogisticsParty (optional) - Takes the term, reportType and LP for which the report is generated
 * UserInformation - Used to capture details on who generates the report
 * QueryId - Holds id of the query which needs to be executed for Report data generation
 * DynamicAttributes - optional dynamic attributes
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GenerateReportSyncInput", ()=>GenerateReportSyncInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GenerateReportSyncInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGeneratereportsyncinput", ()=>validateGeneratereportsyncinput);
var _attributeList = require("./AttributeList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GenerateReportSyncInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GenerateReportSyncInput#clone(obj: PlainObjectFrom<GenerateReportSyncInput>) method.
     */ constructor(__queryId, __reportType, __term, __customerId, __dynamicAttributes, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.queryId = __queryId;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.dynamicAttributes = __dynamicAttributes;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of GenerateReportSyncInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GenerateReportSyncInput(obj.queryId, obj.reportType, obj.term, obj.customerId, obj.dynamicAttributes, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new GenerateReportSyncInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queryId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _attributeList.AttributeList).fromJson($$val))(data.dynamicAttributes), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            queryId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.queryId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            dynamicAttributes: (($$val)=>$$val == undefined ? null : (0, _attributeList.AttributeList).toJson($$val))(data.dynamicAttributes),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
GenerateReportSyncInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GenerateReportSyncInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GenerateReportSyncInput);
function validateGeneratereportsyncinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./AttributeList":"a31Of","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cQiIH":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GenerateReportSync API
 * Report - The generated report as a CSV blob
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GenerateReportSyncOutput", ()=>GenerateReportSyncOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GenerateReportSyncOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGeneratereportsyncoutput", ()=>validateGeneratereportsyncoutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GenerateReportSyncOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GenerateReportSyncOutput#clone(obj: PlainObjectFrom<GenerateReportSyncOutput>) method.
     */ constructor(__report){
        super();
        this.report = __report;
    }
    /**
     * Create a shallow clone of GenerateReportSyncOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GenerateReportSyncOutput(obj.report);
    }
    static fromJson(data) {
        return new GenerateReportSyncOutput((0, _coralTypescriptTypesPieces.SerdesUtils).jsonToBlob(data.report));
    }
    static toJson(data) {
        return Object.assign({
            report: (0, _coralTypescriptTypesPieces.SerdesUtils).blobToJson(data.report)
        });
    }
}
GenerateReportSyncOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GenerateReportSyncOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GenerateReportSyncOutput);
function validateGeneratereportsyncoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8v8yU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for GetTermReportConfigs API
 * term - Represents the term for which all available report type configurations should be fetched.
 * If no term is provided, configurations for all terms will be returned.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetTermReportConfigsInput", ()=>GetTermReportConfigsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetTermReportConfigsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGettermreportconfigsinput", ()=>validateGettermreportconfigsinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetTermReportConfigsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetTermReportConfigsInput#clone(obj: PlainObjectFrom<GetTermReportConfigsInput>) method.
     */ constructor(__customerId, __logisticsPartyId, __partnerAccountId, __term, __userSessionAttributes){
        super();
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.term = __term;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of GetTermReportConfigsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetTermReportConfigsInput(obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.term, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new GetTermReportConfigsInput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            term: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.term),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
GetTermReportConfigsInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GetTermReportConfigsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetTermReportConfigsInput);
function validateGettermreportconfigsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8N5nJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for GetTermReportConfigs API
 * termReportConfigurationsList - hold all term report configuration If term is not specified in input,
 * else provide the term report configuration of the specified term.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "GetTermReportConfigsOutput", ()=>GetTermReportConfigsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [GetTermReportConfigsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateGettermreportconfigsoutput", ()=>validateGettermreportconfigsoutput);
var _termReportConfigurationsList = require("./TermReportConfigurationsList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class GetTermReportConfigsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the GetTermReportConfigsOutput#clone(obj: PlainObjectFrom<GetTermReportConfigsOutput>) method.
     */ constructor(__termReportConfigurationsList){
        super();
        this.termReportConfigurationsList = __termReportConfigurationsList;
    }
    /**
     * Create a shallow clone of GetTermReportConfigsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new GetTermReportConfigsOutput(obj.termReportConfigurationsList);
    }
    static fromJson(data) {
        return new GetTermReportConfigsOutput((0, _termReportConfigurationsList.TermReportConfigurationsList).fromJson(data.termReportConfigurationsList));
    }
    static toJson(data) {
        return Object.assign({
            termReportConfigurationsList: (0, _termReportConfigurationsList.TermReportConfigurationsList).toJson(data.termReportConfigurationsList)
        });
    }
}
GetTermReportConfigsOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#GetTermReportConfigsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(GetTermReportConfigsOutput);
function validateGettermreportconfigsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TermReportConfigurationsList":"1ACHs","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ACHs":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TermReportConfigurationsList", ()=>TermReportConfigurationsList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermReportConfigurationsList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermreportconfigurationslist", ()=>validateTermreportconfigurationslist);
var _termReportConfigurations = require("./TermReportConfigurations");
class TermReportConfigurationsList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(TermReportConfigurationsList.prototype));
    }
    static fromJson(data) {
        return new TermReportConfigurationsList(data.map((datum)=>(0, _termReportConfigurations.TermReportConfigurations).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _termReportConfigurations.TermReportConfigurations).toJson(datum));
    }
}
function validateTermreportconfigurationslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./TermReportConfigurations":"cyH9o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cyH9o":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>TermReportConfigurations holds list of report configuration for a specific term.
 * term - Represents term name
 * termDisplayName - Represents the display name of the term.
 * termUrlPath - Represents url path for Term
 * reportConfigList - Represents the list of report configurations for the term.<\/p>
 **/ parcelHelpers.export(exports, "TermReportConfigurations", ()=>TermReportConfigurations);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TermReportConfigurations] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTermreportconfigurations", ()=>validateTermreportconfigurations);
var _reportConfigList = require("./ReportConfigList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TermReportConfigurations extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TermReportConfigurations#clone(obj: PlainObjectFrom<TermReportConfigurations>) method.
     */ constructor(__reportConfigList, __term, __termDisplayName, __termUrlPath){
        super();
        this.reportConfigList = __reportConfigList;
        this.term = __term;
        this.termDisplayName = __termDisplayName;
        this.termUrlPath = __termUrlPath;
    }
    /**
     * Create a shallow clone of TermReportConfigurations from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TermReportConfigurations(obj.reportConfigList, obj.term, obj.termDisplayName, obj.termUrlPath);
    }
    static fromJson(data) {
        return new TermReportConfigurations((0, _reportConfigList.ReportConfigList).fromJson(data.reportConfigList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.termDisplayName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.termUrlPath));
    }
    static toJson(data) {
        return Object.assign({
            reportConfigList: (0, _reportConfigList.ReportConfigList).toJson(data.reportConfigList),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            termDisplayName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.termDisplayName),
            termUrlPath: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.termUrlPath)
        });
    }
}
TermReportConfigurations.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#TermReportConfigurations";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TermReportConfigurations);
function validateTermreportconfigurations(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportConfigList":"kRMHK","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kRMHK":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportConfigList", ()=>ReportConfigList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportConfigList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportconfiglist", ()=>validateReportconfiglist);
var _reportConfig = require("./ReportConfig");
class ReportConfigList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ReportConfigList.prototype));
    }
    static fromJson(data) {
        return new ReportConfigList(data.map((datum)=>(0, _reportConfig.ReportConfig).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _reportConfig.ReportConfig).toJson(datum));
    }
}
function validateReportconfiglist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportConfig":"l2slz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2slz":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Holds a report type configuration.
 * reportTypeDisplayName - Represents display name of report type.
 * featuresList - Holds the features opted for a Term and Report Type. Order of the features in the list is also
 * maintained.
 * reportType - Represents type of report like INVOICE_RECONCILIATION_FILES, INVOICE_DISUPTE_FILES.
 * reportTypeUrlPath - Represents url path for Report type.
 * reportWorkflowConfig - represents the workflow config for the report. Workflow config represents all possible
 * actions for a given workflow state
 * reportFolderViewConfig - represents if the folder view is to be enabled for this report
 * reportFormats - represents the list of report formats that are allowed
 * reportTypePagesConfig - config used by UI client to build Report generation pages dynamically.
 * isExternalAllowed - Represents weather the report type to be accessed in CarrierLogistics UI. If the value is true
 * or null reportType will be accessed in CarrierLogistics UI. If the value is false reportType access will
 * be restricted to Carrier Logistics UI
 * Note : Added only attributes which are required by client as of today.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportConfig", ()=>ReportConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportconfig", ()=>validateReportconfig);
var _reportFormatList = require("./ReportFormatList");
var _reportWorkflowConfig = require("./ReportWorkflowConfig");
var _validationConfig = require("./ValidationConfig");
var _reportTypePagesConfig = require("./ReportTypePagesConfig");
var _reportFeaturesList = require("./ReportFeaturesList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportConfig#clone(obj: PlainObjectFrom<ReportConfig>) method.
     */ constructor(__featuresList, __reportType, __reportTypeDisplayName, __reportTypeUrlPath, __isExternalAllowed, __logisticsPartyId, __reportFolderViewConfig, __reportFormats, __reportTypeDescription, __reportTypePagesConfig, __reportWorkflowConfig, __validationConfig){
        super();
        this.featuresList = __featuresList;
        this.reportType = __reportType;
        this.reportTypeDisplayName = __reportTypeDisplayName;
        this.reportTypeUrlPath = __reportTypeUrlPath;
        this.isExternalAllowed = __isExternalAllowed;
        this.logisticsPartyId = __logisticsPartyId;
        this.reportFolderViewConfig = __reportFolderViewConfig;
        this.reportFormats = __reportFormats;
        this.reportTypeDescription = __reportTypeDescription;
        this.reportTypePagesConfig = __reportTypePagesConfig;
        this.reportWorkflowConfig = __reportWorkflowConfig;
        this.validationConfig = __validationConfig;
    }
    /**
     * Create a shallow clone of ReportConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportConfig(obj.featuresList, obj.reportType, obj.reportTypeDisplayName, obj.reportTypeUrlPath, obj.isExternalAllowed, obj.logisticsPartyId, obj.reportFolderViewConfig, obj.reportFormats, obj.reportTypeDescription, obj.reportTypePagesConfig, obj.reportWorkflowConfig, obj.validationConfig);
    }
    static fromJson(data) {
        return new ReportConfig((0, _reportFeaturesList.ReportFeaturesList).fromJson(data.featuresList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportTypeDisplayName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportTypeUrlPath), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isExternalAllowed), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportFolderViewConfig), (($$val)=>$$val == undefined ? undefined : (0, _reportFormatList.ReportFormatList).fromJson($$val))(data.reportFormats), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportTypeDescription), (($$val)=>$$val == undefined ? undefined : (0, _reportTypePagesConfig.ReportTypePagesConfig).fromJson($$val))(data.reportTypePagesConfig), (($$val)=>$$val == undefined ? undefined : (0, _reportWorkflowConfig.ReportWorkflowConfig).fromJson($$val))(data.reportWorkflowConfig), (($$val)=>$$val == undefined ? undefined : (0, _validationConfig.ValidationConfig).fromJson($$val))(data.validationConfig));
    }
    static toJson(data) {
        return Object.assign({
            featuresList: (0, _reportFeaturesList.ReportFeaturesList).toJson(data.featuresList),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            reportTypeDisplayName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportTypeDisplayName),
            reportTypeUrlPath: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportTypeUrlPath),
            isExternalAllowed: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.isExternalAllowed),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            reportFolderViewConfig: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportFolderViewConfig),
            reportFormats: (($$val)=>$$val == undefined ? null : (0, _reportFormatList.ReportFormatList).toJson($$val))(data.reportFormats),
            reportTypeDescription: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportTypeDescription),
            reportTypePagesConfig: (($$val)=>$$val == undefined ? null : (0, _reportTypePagesConfig.ReportTypePagesConfig).toJson($$val))(data.reportTypePagesConfig),
            reportWorkflowConfig: (($$val)=>$$val == undefined ? null : (0, _reportWorkflowConfig.ReportWorkflowConfig).toJson($$val))(data.reportWorkflowConfig),
            validationConfig: (($$val)=>$$val == undefined ? null : (0, _validationConfig.ValidationConfig).toJson($$val))(data.validationConfig)
        });
    }
}
ReportConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportConfig);
function validateReportconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportFormatList":"7qkK0","./ReportWorkflowConfig":"aFoHb","./ValidationConfig":"851vy","./ReportTypePagesConfig":"5AuzB","./ReportFeaturesList":"cmLeP","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7qkK0":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportFormatList", ()=>ReportFormatList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportFormatList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportformatlist", ()=>validateReportformatlist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class ReportFormatList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ReportFormatList.prototype));
    }
    static fromJson(data) {
        return new ReportFormatList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateReportformatlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aFoHb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>This map represents the report workflow
 * Key - Represents the workflow state
 * value - Represents the allowed actions metadata for a given workflow state
 * Ex:
 * workflowConfig: {
 * START: [
 * {
 * actionType: DOWNLOAD,
 * flowType: INTERNAL
 * },
 * {
 * actionType: DOWNLOAD,
 * flowType: EXTERNAL
 * }
 * ],
 * INTERNAL_UPLOAD_SYSTEM: [
 * {
 * actionType: DOWNLOAD,
 * flowType: INTERNAL
 * },
 * {
 * actionType: DOWNLOAD,
 * flowType: EXTERNAL
 * }
 * ]
 * }
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportWorkflowConfig", ()=>ReportWorkflowConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportWorkflowConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportworkflowconfig", ()=>validateReportworkflowconfig);
var _actionMetadataList = require("./ActionMetadataList");
class ReportWorkflowConfig {
    constructor(options){
        for (const key of Object.keys(options))this[key] = options[key];
    }
    static fromJson(data) {
        const obj = {};
        for (const key of Object.keys(data))obj[key] = (0, _actionMetadataList.ActionMetadataList).fromJson(data[key]);
        return new ReportWorkflowConfig(obj);
    }
    static toJson(map) {
        const data = {};
        for (const key of Object.keys(map))data[key] = (0, _actionMetadataList.ActionMetadataList).toJson(map[key]);
        return data;
    }
}
function validateReportworkflowconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ActionMetadataList":"aihjT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"851vy":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code> reportFormatValidationConfig: Represents the configuration for validating the format of the report.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ValidationConfig", ()=>ValidationConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ValidationConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateValidationconfig", ()=>validateValidationconfig);
var _reportFormatValidationConfig = require("./ReportFormatValidationConfig");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ValidationConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ValidationConfig#clone(obj: PlainObjectFrom<ValidationConfig>) method.
     */ constructor(__reportFormatValidationConfig){
        super();
        this.reportFormatValidationConfig = __reportFormatValidationConfig;
    }
    /**
     * Create a shallow clone of ValidationConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ValidationConfig(obj.reportFormatValidationConfig);
    }
    static fromJson(data) {
        return new ValidationConfig((($$val)=>$$val == undefined ? undefined : (0, _reportFormatValidationConfig.ReportFormatValidationConfig).fromJson($$val))(data.reportFormatValidationConfig));
    }
    static toJson(data) {
        return Object.assign({
            reportFormatValidationConfig: (($$val)=>$$val == undefined ? null : (0, _reportFormatValidationConfig.ReportFormatValidationConfig).toJson($$val))(data.reportFormatValidationConfig)
        });
    }
}
ValidationConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ValidationConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ValidationConfig);
function validateValidationconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportFormatValidationConfig":"4wsFv","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4wsFv":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>reportFormats: A required list of acceptable formats for the report document.
 * supportingDocumentFormats: A list of acceptable formats for supporting documents.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportFormatValidationConfig", ()=>ReportFormatValidationConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportFormatValidationConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportformatvalidationconfig", ()=>validateReportformatvalidationconfig);
var _reportFormatList = require("./ReportFormatList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportFormatValidationConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportFormatValidationConfig#clone(obj: PlainObjectFrom<ReportFormatValidationConfig>) method.
     */ constructor(__reportFormats, __supportingDocumentFormats){
        super();
        this.reportFormats = __reportFormats;
        this.supportingDocumentFormats = __supportingDocumentFormats;
    }
    /**
     * Create a shallow clone of ReportFormatValidationConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportFormatValidationConfig(obj.reportFormats, obj.supportingDocumentFormats);
    }
    static fromJson(data) {
        return new ReportFormatValidationConfig((0, _reportFormatList.ReportFormatList).fromJson(data.reportFormats), (($$val)=>$$val == undefined ? undefined : (0, _reportFormatList.ReportFormatList).fromJson($$val))(data.supportingDocumentFormats));
    }
    static toJson(data) {
        return Object.assign({
            reportFormats: (0, _reportFormatList.ReportFormatList).toJson(data.reportFormats),
            supportingDocumentFormats: (($$val)=>$$val == undefined ? null : (0, _reportFormatList.ReportFormatList).toJson($$val))(data.supportingDocumentFormats)
        });
    }
}
ReportFormatValidationConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportFormatValidationConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportFormatValidationConfig);
function validateReportformatvalidationconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportFormatList":"7qkK0","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5AuzB":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>reportPageConfig - config used by UI client to build Report generation page dynamically.
 * reportDashboardPageConfig - config used by search Dashboard to build report dashboard page dynamically
 * reportUploadActionConfig - config used by UI client to make upload form dynamic.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportTypePagesConfig", ()=>ReportTypePagesConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportTypePagesConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReporttypepagesconfig", ()=>validateReporttypepagesconfig);
var _reportPageConfig = require("./ReportPageConfig");
var _reportUploadActionConfig = require("./ReportUploadActionConfig");
var _searchReportsHistoryUIConfig = require("./SearchReportsHistoryUIConfig");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportTypePagesConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportTypePagesConfig#clone(obj: PlainObjectFrom<ReportTypePagesConfig>) method.
     */ constructor(__reportDashboardPageConfig, __reportGenerationPageConfig, __reportUploadActionConfig){
        super();
        this.reportDashboardPageConfig = __reportDashboardPageConfig;
        this.reportGenerationPageConfig = __reportGenerationPageConfig;
        this.reportUploadActionConfig = __reportUploadActionConfig;
    }
    /**
     * Create a shallow clone of ReportTypePagesConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportTypePagesConfig(obj.reportDashboardPageConfig, obj.reportGenerationPageConfig, obj.reportUploadActionConfig);
    }
    static fromJson(data) {
        return new ReportTypePagesConfig((($$val)=>$$val == undefined ? undefined : (0, _searchReportsHistoryUIConfig.SearchReportsHistoryUIConfig).fromJson($$val))(data.reportDashboardPageConfig), (($$val)=>$$val == undefined ? undefined : (0, _reportPageConfig.ReportPageConfig).fromJson($$val))(data.reportGenerationPageConfig), (($$val)=>$$val == undefined ? undefined : (0, _reportUploadActionConfig.ReportUploadActionConfig).fromJson($$val))(data.reportUploadActionConfig));
    }
    static toJson(data) {
        return Object.assign({
            reportDashboardPageConfig: (($$val)=>$$val == undefined ? null : (0, _searchReportsHistoryUIConfig.SearchReportsHistoryUIConfig).toJson($$val))(data.reportDashboardPageConfig),
            reportGenerationPageConfig: (($$val)=>$$val == undefined ? null : (0, _reportPageConfig.ReportPageConfig).toJson($$val))(data.reportGenerationPageConfig),
            reportUploadActionConfig: (($$val)=>$$val == undefined ? null : (0, _reportUploadActionConfig.ReportUploadActionConfig).toJson($$val))(data.reportUploadActionConfig)
        });
    }
}
ReportTypePagesConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportTypePagesConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportTypePagesConfig);
function validateReporttypepagesconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportPageConfig":"2hq1K","./ReportUploadActionConfig":"5J3uP","./SearchReportsHistoryUIConfig":"jl9TO","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2hq1K":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Config used by UI client to build Report generation page dynamically.
 * The basic supported template has: Form with few fields - data to be provided by user and report generation options.
 * forms - We support multiple forms for a ReportType. This field holds all forms information.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportPageConfig", ()=>ReportPageConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportPageConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportpageconfig", ()=>validateReportpageconfig);
var _formList = require("./FormList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportPageConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportPageConfig#clone(obj: PlainObjectFrom<ReportPageConfig>) method.
     */ constructor(__forms){
        super();
        this.forms = __forms;
    }
    /**
     * Create a shallow clone of ReportPageConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportPageConfig(obj.forms);
    }
    static fromJson(data) {
        return new ReportPageConfig((0, _formList.FormList).fromJson(data.forms));
    }
    static toJson(data) {
        return Object.assign({
            forms: (0, _formList.FormList).toJson(data.forms)
        });
    }
}
ReportPageConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportPageConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportPageConfig);
function validateReportpageconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FormList":"7gKUz","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5J3uP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>uploadActionConstraints: Represents the type of upload.
 * formFields: holds all fields related info of a upload Form
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportUploadActionConfig", ()=>ReportUploadActionConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportUploadActionConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportuploadactionconfig", ()=>validateReportuploadactionconfig);
var _formFieldList = require("./FormFieldList");
var _formFieldControlTypeConstraints = require("./FormFieldControlTypeConstraints");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportUploadActionConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportUploadActionConfig#clone(obj: PlainObjectFrom<ReportUploadActionConfig>) method.
     */ constructor(__uploadActionConstraints, __formFields){
        super();
        this.uploadActionConstraints = __uploadActionConstraints;
        this.formFields = __formFields;
    }
    /**
     * Create a shallow clone of ReportUploadActionConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportUploadActionConfig(obj.uploadActionConstraints, obj.formFields);
    }
    static fromJson(data) {
        return new ReportUploadActionConfig((0, _formFieldControlTypeConstraints.FormFieldControlTypeConstraints).fromJson(data.uploadActionConstraints), (($$val)=>$$val == undefined ? undefined : (0, _formFieldList.FormFieldList).fromJson($$val))(data.formFields));
    }
    static toJson(data) {
        return Object.assign({
            uploadActionConstraints: (0, _formFieldControlTypeConstraints.FormFieldControlTypeConstraints).toJson(data.uploadActionConstraints),
            formFields: (($$val)=>$$val == undefined ? null : (0, _formFieldList.FormFieldList).toJson($$val))(data.formFields)
        });
    }
}
ReportUploadActionConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportUploadActionConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportUploadActionConfig);
function validateReportuploadactionconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./FormFieldList":"emWa5","./FormFieldControlTypeConstraints":"icxK5","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmLeP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportFeaturesList", ()=>ReportFeaturesList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportFeaturesList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportfeatureslist", ()=>validateReportfeatureslist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class ReportFeaturesList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ReportFeaturesList.prototype));
    }
    static fromJson(data) {
        return new ReportFeaturesList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateReportfeatureslist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9eC17":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents information about the ingestion workflow.
 * reportIngestionStatus - Status of the report ingestion.
 * reportIngestionFailureReason - Reason for ingestion failure, if any.
 * reportIngestionTime - Timestamp when the report was ingested.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "IngestionWorkflowInfo", ()=>IngestionWorkflowInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [IngestionWorkflowInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateIngestionworkflowinfo", ()=>validateIngestionworkflowinfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class IngestionWorkflowInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the IngestionWorkflowInfo#clone(obj: PlainObjectFrom<IngestionWorkflowInfo>) method.
     */ constructor(__reportIngestionStatus, __reportIngestionTime, __reportIngestionFailureReason){
        super();
        this.reportIngestionStatus = __reportIngestionStatus;
        this.reportIngestionTime = __reportIngestionTime;
        this.reportIngestionFailureReason = __reportIngestionFailureReason;
    }
    /**
     * Create a shallow clone of IngestionWorkflowInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new IngestionWorkflowInfo(obj.reportIngestionStatus, obj.reportIngestionTime, obj.reportIngestionFailureReason);
    }
    static fromJson(data) {
        return new IngestionWorkflowInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportIngestionStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportIngestionTime), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportIngestionFailureReason));
    }
    static toJson(data) {
        return Object.assign({
            reportIngestionStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportIngestionStatus),
            reportIngestionTime: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportIngestionTime),
            reportIngestionFailureReason: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportIngestionFailureReason)
        });
    }
}
IngestionWorkflowInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#IngestionWorkflowInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(IngestionWorkflowInfo);
function validateIngestionworkflowinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmroK":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for InitiateBatchReportUpload API
 * InitiateUploadRequestList - represents the list of upload requests, each request for one report
 * Each upload request contains key(path) of the uploaded report, total parts of the report and content type of the
 * report
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "InitiateBatchReportUploadInput", ()=>InitiateBatchReportUploadInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InitiateBatchReportUploadInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInitiatebatchreportuploadinput", ()=>validateInitiatebatchreportuploadinput);
var _initiateUploadRequestList = require("./InitiateUploadRequestList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class InitiateBatchReportUploadInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InitiateBatchReportUploadInput#clone(obj: PlainObjectFrom<InitiateBatchReportUploadInput>) method.
     */ constructor(__InitiateUploadRequestList, __reportType, __term, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.InitiateUploadRequestList = __InitiateUploadRequestList;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of InitiateBatchReportUploadInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InitiateBatchReportUploadInput(obj.InitiateUploadRequestList, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new InitiateBatchReportUploadInput((0, _initiateUploadRequestList.InitiateUploadRequestList).fromJson(data.InitiateUploadRequestList), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            InitiateUploadRequestList: (0, _initiateUploadRequestList.InitiateUploadRequestList).toJson(data.InitiateUploadRequestList),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
InitiateBatchReportUploadInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#InitiateBatchReportUploadInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(InitiateBatchReportUploadInput);
function validateInitiatebatchreportuploadinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InitiateUploadRequestList":"1JeSJ","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JeSJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InitiateUploadRequestList", ()=>InitiateUploadRequestList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InitiateUploadRequestList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInitiateuploadrequestlist", ()=>validateInitiateuploadrequestlist);
var _initiateUploadRequest = require("./InitiateUploadRequest");
class InitiateUploadRequestList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(InitiateUploadRequestList.prototype));
    }
    static fromJson(data) {
        return new InitiateUploadRequestList(data.map((datum)=>(0, _initiateUploadRequest.InitiateUploadRequest).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _initiateUploadRequest.InitiateUploadRequest).toJson(datum));
    }
}
function validateInitiateuploadrequestlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InitiateUploadRequest":"6cycX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cycX":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>key: represents the unique key\/path of the report that is being uploaded
 * totalParts: represents the total number of parts in the whole report
 * contentType: standard MIME type representing the format of report data
 * uploadRequestAdditionalInfo: Represents the additional information uploaded for each request
 * This includes any supplementary data such as additional comments and the reason for uploading the files
 * supportingDocumentInfo: Represents the information regarding supporting document
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "InitiateUploadRequest", ()=>InitiateUploadRequest);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InitiateUploadRequest] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInitiateuploadrequest", ()=>validateInitiateuploadrequest);
var _supportingDocumentInfo = require("./SupportingDocumentInfo");
var _reportAdditionalInfo = require("./ReportAdditionalInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class InitiateUploadRequest extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InitiateUploadRequest#clone(obj: PlainObjectFrom<InitiateUploadRequest>) method.
     */ constructor(__contentType, __key, __totalParts, __supportingDocumentInfo, __uploadRequestAdditionalInfo){
        super();
        this.contentType = __contentType;
        this.key = __key;
        this.totalParts = __totalParts;
        this.supportingDocumentInfo = __supportingDocumentInfo;
        this.uploadRequestAdditionalInfo = __uploadRequestAdditionalInfo;
    }
    /**
     * Create a shallow clone of InitiateUploadRequest from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InitiateUploadRequest(obj.contentType, obj.key, obj.totalParts, obj.supportingDocumentInfo, obj.uploadRequestAdditionalInfo);
    }
    static fromJson(data) {
        return new InitiateUploadRequest((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.contentType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.totalParts), (($$val)=>$$val == undefined ? undefined : (0, _supportingDocumentInfo.SupportingDocumentInfo).fromJson($$val))(data.supportingDocumentInfo), (($$val)=>$$val == undefined ? undefined : (0, _reportAdditionalInfo.ReportAdditionalInfo).fromJson($$val))(data.uploadRequestAdditionalInfo));
    }
    static toJson(data) {
        return Object.assign({
            contentType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.contentType),
            key: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.key),
            totalParts: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.totalParts),
            supportingDocumentInfo: (($$val)=>$$val == undefined ? null : (0, _supportingDocumentInfo.SupportingDocumentInfo).toJson($$val))(data.supportingDocumentInfo),
            uploadRequestAdditionalInfo: (($$val)=>$$val == undefined ? null : (0, _reportAdditionalInfo.ReportAdditionalInfo).toJson($$val))(data.uploadRequestAdditionalInfo)
        });
    }
}
InitiateUploadRequest.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#InitiateUploadRequest";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(InitiateUploadRequest);
function validateInitiateuploadrequest(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SupportingDocumentInfo":"ed7Ch","./ReportAdditionalInfo":"gOPcz","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOPcz":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>comments: Represents any additional comments provided during the upload process.
 * reasonForUpload: Represents the reason provided for uploading the files.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportAdditionalInfo", ()=>ReportAdditionalInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportAdditionalInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportadditionalinfo", ()=>validateReportadditionalinfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportAdditionalInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportAdditionalInfo#clone(obj: PlainObjectFrom<ReportAdditionalInfo>) method.
     */ constructor(__comments, __reasonForUpload){
        super();
        this.comments = __comments;
        this.reasonForUpload = __reasonForUpload;
    }
    /**
     * Create a shallow clone of ReportAdditionalInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportAdditionalInfo(obj.comments, obj.reasonForUpload);
    }
    static fromJson(data) {
        return new ReportAdditionalInfo((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.comments), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reasonForUpload));
    }
    static toJson(data) {
        return Object.assign({
            comments: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.comments),
            reasonForUpload: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reasonForUpload)
        });
    }
}
ReportAdditionalInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportAdditionalInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportAdditionalInfo);
function validateReportadditionalinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2LGu6":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for InitiateBatchReportUpload API
 * InitiateUploadResponseList - Represents the list of upload responses one for each report
 * Each upload response contains the list of presigned URLs one for each part and corresponding uploadId for each
 * report
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "InitiateBatchReportUploadOutput", ()=>InitiateBatchReportUploadOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InitiateBatchReportUploadOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInitiatebatchreportuploadoutput", ()=>validateInitiatebatchreportuploadoutput);
var _initiateUploadResponseList = require("./InitiateUploadResponseList");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class InitiateBatchReportUploadOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InitiateBatchReportUploadOutput#clone(obj: PlainObjectFrom<InitiateBatchReportUploadOutput>) method.
     */ constructor(__InitiateUploadResponseList){
        super();
        this.InitiateUploadResponseList = __InitiateUploadResponseList;
    }
    /**
     * Create a shallow clone of InitiateBatchReportUploadOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InitiateBatchReportUploadOutput(obj.InitiateUploadResponseList);
    }
    static fromJson(data) {
        return new InitiateBatchReportUploadOutput((0, _initiateUploadResponseList.InitiateUploadResponseList).fromJson(data.InitiateUploadResponseList));
    }
    static toJson(data) {
        return Object.assign({
            InitiateUploadResponseList: (0, _initiateUploadResponseList.InitiateUploadResponseList).toJson(data.InitiateUploadResponseList)
        });
    }
}
InitiateBatchReportUploadOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#InitiateBatchReportUploadOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(InitiateBatchReportUploadOutput);
function validateInitiatebatchreportuploadoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InitiateUploadResponseList":"2elXe","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2elXe":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InitiateUploadResponseList", ()=>InitiateUploadResponseList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InitiateUploadResponseList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInitiateuploadresponselist", ()=>validateInitiateuploadresponselist);
var _initiateUploadResponse = require("./InitiateUploadResponse");
class InitiateUploadResponseList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(InitiateUploadResponseList.prototype));
    }
    static fromJson(data) {
        return new InitiateUploadResponseList(data.map((datum)=>(0, _initiateUploadResponse.InitiateUploadResponse).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _initiateUploadResponse.InitiateUploadResponse).toJson(datum));
    }
}
function validateInitiateuploadresponselist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./InitiateUploadResponse":"lH6Pu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lH6Pu":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>partPresignedURLs: represents the list of presigned URLs to upload each part
 * uploadId: represents ID for the initiated multipart upload
 * reportId: Id generated for report uploaded
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "InitiateUploadResponse", ()=>InitiateUploadResponse);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [InitiateUploadResponse] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateInitiateuploadresponse", ()=>validateInitiateuploadresponse);
var _urllist = require("./URLList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class InitiateUploadResponse extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the InitiateUploadResponse#clone(obj: PlainObjectFrom<InitiateUploadResponse>) method.
     */ constructor(__partPresignedURLs, __uploadId, __reportId){
        super();
        this.partPresignedURLs = __partPresignedURLs;
        this.uploadId = __uploadId;
        this.reportId = __reportId;
    }
    /**
     * Create a shallow clone of InitiateUploadResponse from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new InitiateUploadResponse(obj.partPresignedURLs, obj.uploadId, obj.reportId);
    }
    static fromJson(data) {
        return new InitiateUploadResponse((0, _urllist.URLList).fromJson(data.partPresignedURLs), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.uploadId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportId));
    }
    static toJson(data) {
        return Object.assign({
            partPresignedURLs: (0, _urllist.URLList).toJson(data.partPresignedURLs),
            uploadId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.uploadId),
            reportId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportId)
        });
    }
}
InitiateUploadResponse.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#InitiateUploadResponse";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(InitiateUploadResponse);
function validateInitiateuploadresponse(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./URLList":"bewFl","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bewFl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "URLList", ()=>URLList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [URLList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUrllist", ()=>validateUrllist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class URLList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(URLList.prototype));
    }
    static fromJson(data) {
        return new URLList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateUrllist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hefoT":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LookupKeyList", ()=>LookupKeyList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [LookupKeyList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateLookupkeylist", ()=>validateLookupkeylist);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
class LookupKeyList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(LookupKeyList.prototype));
    }
    static fromJson(data) {
        return new LookupKeyList(data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(datum));
    }
}
function validateLookupkeylist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSTSY":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents LPLookKeyType Attributes
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LPLookUpKeyType", ()=>LPLookUpKeyType);
var LPLookUpKeyType;
(function(LPLookUpKeyType) {
    LPLookUpKeyType["TFS_SCAC_ID"] = "TFS_SCAC_ID";
})(LPLookUpKeyType || (LPLookUpKeyType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3sdWb":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents lookup values for the logistics party.
 * type - Represents type of the lookup key.
 * valueList - Represents list of lookup keys.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "LPLookUpValues", ()=>LPLookUpValues);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [LPLookUpValues] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateLplookupvalues", ()=>validateLplookupvalues);
var _lookupKeyList = require("./LookupKeyList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class LPLookUpValues extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the LPLookUpValues#clone(obj: PlainObjectFrom<LPLookUpValues>) method.
     */ constructor(__type, __valueList){
        super();
        this.type = __type;
        this.valueList = __valueList;
    }
    /**
     * Create a shallow clone of LPLookUpValues from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new LPLookUpValues(obj.type, obj.valueList);
    }
    static fromJson(data) {
        return new LPLookUpValues((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.type), (0, _lookupKeyList.LookupKeyList).fromJson(data.valueList));
    }
    static toJson(data) {
        return Object.assign({
            type: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.type),
            valueList: (0, _lookupKeyList.LookupKeyList).toJson(data.valueList)
        });
    }
}
LPLookUpValues.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#LPLookUpValues";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(LPLookUpValues);
function validateLplookupvalues(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./LookupKeyList":"hefoT","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bhkbZ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Represents the differernt type of objects like File, Folder etc
 * FILE - Represents a file object
 * FOLDER - Represents a folder object<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectType", ()=>ObjectType);
var ObjectType;
(function(ObjectType) {
    ObjectType["FILE"] = "FILE";
    ObjectType["FOLDER"] = "FOLDER";
})(ObjectType || (ObjectType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2HrXn":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for RejectReport API:
 *
 * reportId: Unique identifier representing the report to be rejected.
 * rejectionReason: Comment providing the reason for rejection.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "RejectReportInput", ()=>RejectReportInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RejectReportInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRejectreportinput", ()=>validateRejectreportinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RejectReportInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RejectReportInput#clone(obj: PlainObjectFrom<RejectReportInput>) method.
     */ constructor(__reportId, __reportType, __term, __customerId, __logisticsPartyId, __partnerAccountId, __rejectionReason, __userSessionAttributes){
        super();
        this.reportId = __reportId;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.rejectionReason = __rejectionReason;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of RejectReportInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RejectReportInput(obj.reportId, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.rejectionReason, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new RejectReportInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.rejectionReason), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            rejectionReason: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.rejectionReason),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
RejectReportInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#RejectReportInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RejectReportInput);
function validateRejectreportinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6epqY":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for RejectReport API:
 *
 * reportId: Unique identifier representing the rejected report.
 * approvalStatus: Status of the report approval (e.g., 'Rejected').
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "RejectReportOutput", ()=>RejectReportOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [RejectReportOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateRejectreportoutput", ()=>validateRejectreportoutput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class RejectReportOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the RejectReportOutput#clone(obj: PlainObjectFrom<RejectReportOutput>) method.
     */ constructor(__approvalStatus, __reportId){
        super();
        this.approvalStatus = __approvalStatus;
        this.reportId = __reportId;
    }
    /**
     * Create a shallow clone of RejectReportOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new RejectReportOutput(obj.approvalStatus, obj.reportId);
    }
    static fromJson(data) {
        return new RejectReportOutput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId));
    }
    static toJson(data) {
        return Object.assign({
            approvalStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.approvalStatus),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId)
        });
    }
}
RejectReportOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#RejectReportOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(RejectReportOutput);
function validateRejectreportoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2e78w":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents a Report record.
 * reportId - unique identifier of the Report
 * reportName - represents name of the report
 * reportFormat - represents report format, ex: xlsx
 * reportStatus - represents status of the report
 * featuresList - represents the features opted for related Term and Report Type of this report when this report got
 * created. Order of the features opted is also maintained, used by the UI client to enable the options\/determine the
 * workflow.
 * auditVersion - current version of report
 * creationTime - represents report creation timestamp
 * lastUpdatedTime - represents report last updated timestamp
 * createdBy - represents user(or system) who created the report
 * lastUpdatedBy - represents user(or system) who last modified the report record
 * reportSize -  represents size of report in bytes
 * reportUploadStatus - represents upload status of the report in the multipart upload flow
 * reportCurrentWorkflowState - represents the current report workflow state
 * reportWorkflow Config - represents the report workflow config
 * reportObjectType - represents the report object
 * Note : Not all fields are marked as required as these fields information need not be set in response in external
 * flow.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "Report", ()=>Report);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [Report] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReport", ()=>validateReport);
var _reportWorkflowConfig = require("./ReportWorkflowConfig");
var _supportingDocumentConfigList = require("./SupportingDocumentConfigList");
var _reportMetadata = require("./ReportMetadata");
var _reportWorkflowInfoList = require("./ReportWorkflowInfoList");
var _reportAdditionalInfo = require("./ReportAdditionalInfo");
var _reportFeaturesList = require("./ReportFeaturesList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class Report extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the Report#clone(obj: PlainObjectFrom<Report>) method.
     */ constructor(__auditVersion, __reportFormat, __reportId, __reportName, __reportStatus, __additionalReportInfo, __createdBy, __creationTime, __featuresList, __lastUpdatedBy, __lastUpdatedTime, __queryId, __recordCreationTime, __recordLastUpdatedTime, __reportCurrentWorkflowState, __reportMetadata, __reportObjectType, __reportSize, __reportUploadStatus, __reportWorkflowConfig, __reportWorkflowInfo, __supportingDocumentInfo){
        super();
        this.auditVersion = __auditVersion;
        this.reportFormat = __reportFormat;
        this.reportId = __reportId;
        this.reportName = __reportName;
        this.reportStatus = __reportStatus;
        this.additionalReportInfo = __additionalReportInfo;
        this.createdBy = __createdBy;
        this.creationTime = __creationTime;
        this.featuresList = __featuresList;
        this.lastUpdatedBy = __lastUpdatedBy;
        this.lastUpdatedTime = __lastUpdatedTime;
        this.queryId = __queryId;
        this.recordCreationTime = __recordCreationTime;
        this.recordLastUpdatedTime = __recordLastUpdatedTime;
        this.reportCurrentWorkflowState = __reportCurrentWorkflowState;
        this.reportMetadata = __reportMetadata;
        this.reportObjectType = __reportObjectType;
        this.reportSize = __reportSize;
        this.reportUploadStatus = __reportUploadStatus;
        this.reportWorkflowConfig = __reportWorkflowConfig;
        this.reportWorkflowInfo = __reportWorkflowInfo;
        this.supportingDocumentInfo = __supportingDocumentInfo;
    }
    /**
     * Create a shallow clone of Report from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new Report(obj.auditVersion, obj.reportFormat, obj.reportId, obj.reportName, obj.reportStatus, obj.additionalReportInfo, obj.createdBy, obj.creationTime, obj.featuresList, obj.lastUpdatedBy, obj.lastUpdatedTime, obj.queryId, obj.recordCreationTime, obj.recordLastUpdatedTime, obj.reportCurrentWorkflowState, obj.reportMetadata, obj.reportObjectType, obj.reportSize, obj.reportUploadStatus, obj.reportWorkflowConfig, obj.reportWorkflowInfo, obj.supportingDocumentInfo);
    }
    static fromJson(data) {
        return new Report((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.auditVersion), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportFormat), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportName), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportStatus), (($$val)=>$$val == undefined ? undefined : (0, _reportAdditionalInfo.ReportAdditionalInfo).fromJson($$val))(data.additionalReportInfo), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.createdBy), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.creationTime), (($$val)=>$$val == undefined ? undefined : (0, _reportFeaturesList.ReportFeaturesList).fromJson($$val))(data.featuresList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.lastUpdatedBy), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.lastUpdatedTime), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.queryId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.recordCreationTime), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).jsonToDate($$val))(data.recordLastUpdatedTime), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportCurrentWorkflowState), (($$val)=>$$val == undefined ? undefined : (0, _reportMetadata.ReportMetadata).fromJson($$val))(data.reportMetadata), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportObjectType), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportSize), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportUploadStatus), (($$val)=>$$val == undefined ? undefined : (0, _reportWorkflowConfig.ReportWorkflowConfig).fromJson($$val))(data.reportWorkflowConfig), (($$val)=>$$val == undefined ? undefined : (0, _reportWorkflowInfoList.ReportWorkflowInfoList).fromJson($$val))(data.reportWorkflowInfo), (($$val)=>$$val == undefined ? undefined : (0, _supportingDocumentConfigList.SupportingDocumentConfigList).fromJson($$val))(data.supportingDocumentInfo));
    }
    static toJson(data) {
        return Object.assign({
            auditVersion: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.auditVersion),
            reportFormat: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportFormat),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportName: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportName),
            reportStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportStatus),
            additionalReportInfo: (($$val)=>$$val == undefined ? null : (0, _reportAdditionalInfo.ReportAdditionalInfo).toJson($$val))(data.additionalReportInfo),
            createdBy: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.createdBy),
            creationTime: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.creationTime),
            featuresList: (($$val)=>$$val == undefined ? null : (0, _reportFeaturesList.ReportFeaturesList).toJson($$val))(data.featuresList),
            lastUpdatedBy: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.lastUpdatedBy),
            lastUpdatedTime: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.lastUpdatedTime),
            queryId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.queryId),
            recordCreationTime: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.recordCreationTime),
            recordLastUpdatedTime: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).dateToJson($$val))(data.recordLastUpdatedTime),
            reportCurrentWorkflowState: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportCurrentWorkflowState),
            reportMetadata: (($$val)=>$$val == undefined ? null : (0, _reportMetadata.ReportMetadata).toJson($$val))(data.reportMetadata),
            reportObjectType: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportObjectType),
            reportSize: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportSize),
            reportUploadStatus: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.reportUploadStatus),
            reportWorkflowConfig: (($$val)=>$$val == undefined ? null : (0, _reportWorkflowConfig.ReportWorkflowConfig).toJson($$val))(data.reportWorkflowConfig),
            reportWorkflowInfo: (($$val)=>$$val == undefined ? null : (0, _reportWorkflowInfoList.ReportWorkflowInfoList).toJson($$val))(data.reportWorkflowInfo),
            supportingDocumentInfo: (($$val)=>$$val == undefined ? null : (0, _supportingDocumentConfigList.SupportingDocumentConfigList).toJson($$val))(data.supportingDocumentInfo)
        });
    }
}
Report.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#Report";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(Report);
function validateReport(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportWorkflowConfig":"aFoHb","./SupportingDocumentConfigList":"cM7Jm","./ReportMetadata":"c86my","./ReportWorkflowInfoList":"3xb5j","./ReportAdditionalInfo":"gOPcz","./ReportFeaturesList":"cmLeP","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cM7Jm":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SupportingDocumentConfigList", ()=>SupportingDocumentConfigList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SupportingDocumentConfigList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSupportingdocumentconfiglist", ()=>validateSupportingdocumentconfiglist);
var _supportingDocumentConfig = require("./SupportingDocumentConfig");
class SupportingDocumentConfigList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(SupportingDocumentConfigList.prototype));
    }
    static fromJson(data) {
        return new SupportingDocumentConfigList(data.map((datum)=>(0, _supportingDocumentConfig.SupportingDocumentConfig).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _supportingDocumentConfig.SupportingDocumentConfig).toJson(datum));
    }
}
function validateSupportingdocumentconfiglist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SupportingDocumentConfig":"ibSv7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ibSv7":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SupportingDocumentConfig", ()=>SupportingDocumentConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SupportingDocumentConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSupportingdocumentconfig", ()=>validateSupportingdocumentconfig);
var _reportAdditionalInfo = require("./ReportAdditionalInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SupportingDocumentConfig extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SupportingDocumentConfig#clone(obj: PlainObjectFrom<SupportingDocumentConfig>) method.
     */ constructor(__path, __uploadStatus, __additionalInfo){
        super();
        this.path = __path;
        this.uploadStatus = __uploadStatus;
        this.additionalInfo = __additionalInfo;
    }
    /**
     * Create a shallow clone of SupportingDocumentConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SupportingDocumentConfig(obj.path, obj.uploadStatus, obj.additionalInfo);
    }
    static fromJson(data) {
        return new SupportingDocumentConfig((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.path), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.uploadStatus), (($$val)=>$$val == undefined ? undefined : (0, _reportAdditionalInfo.ReportAdditionalInfo).fromJson($$val))(data.additionalInfo));
    }
    static toJson(data) {
        return Object.assign({
            path: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.path),
            uploadStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.uploadStatus),
            additionalInfo: (($$val)=>$$val == undefined ? null : (0, _reportAdditionalInfo.ReportAdditionalInfo).toJson($$val))(data.additionalInfo)
        });
    }
}
SupportingDocumentConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SupportingDocumentConfig";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SupportingDocumentConfig);
function validateSupportingdocumentconfig(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportAdditionalInfo":"gOPcz","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3xb5j":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportWorkflowInfoList", ()=>ReportWorkflowInfoList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportWorkflowInfoList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportworkflowinfolist", ()=>validateReportworkflowinfolist);
var _reportWorkflowInfo = require("./ReportWorkflowInfo");
class ReportWorkflowInfoList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ReportWorkflowInfoList.prototype));
    }
    static fromJson(data) {
        return new ReportWorkflowInfoList(data.map((datum)=>(0, _reportWorkflowInfo.ReportWorkflowInfo).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _reportWorkflowInfo.ReportWorkflowInfo).toJson(datum));
    }
}
function validateReportworkflowinfolist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportWorkflowInfo":"hVTCm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVTCm":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents workflow information related to the report.
 * validationWorkflowInfo - Information about the validation workflow.
 * approvalWorkflowInfo - Information about the approval workflow.
 * ingestionWorkflowInfo - Information about the ingestion workflow.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportWorkflowInfo", ()=>ReportWorkflowInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportWorkflowInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportworkflowinfo", ()=>validateReportworkflowinfo);
var _validationWorkflowInfo = require("./ValidationWorkflowInfo");
var _approvalWorkflowInfo = require("./ApprovalWorkflowInfo");
var _ingestionWorkflowInfo = require("./IngestionWorkflowInfo");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportWorkflowInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportWorkflowInfo#clone(obj: PlainObjectFrom<ReportWorkflowInfo>) method.
     */ constructor(__approvalWorkflowInfo, __ingestionWorkflowInfo, __validationWorkflowInfo){
        super();
        this.approvalWorkflowInfo = __approvalWorkflowInfo;
        this.ingestionWorkflowInfo = __ingestionWorkflowInfo;
        this.validationWorkflowInfo = __validationWorkflowInfo;
    }
    /**
     * Create a shallow clone of ReportWorkflowInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportWorkflowInfo(obj.approvalWorkflowInfo, obj.ingestionWorkflowInfo, obj.validationWorkflowInfo);
    }
    static fromJson(data) {
        return new ReportWorkflowInfo((($$val)=>$$val == undefined ? undefined : (0, _approvalWorkflowInfo.ApprovalWorkflowInfo).fromJson($$val))(data.approvalWorkflowInfo), (($$val)=>$$val == undefined ? undefined : (0, _ingestionWorkflowInfo.IngestionWorkflowInfo).fromJson($$val))(data.ingestionWorkflowInfo), (($$val)=>$$val == undefined ? undefined : (0, _validationWorkflowInfo.ValidationWorkflowInfo).fromJson($$val))(data.validationWorkflowInfo));
    }
    static toJson(data) {
        return Object.assign({
            approvalWorkflowInfo: (($$val)=>$$val == undefined ? null : (0, _approvalWorkflowInfo.ApprovalWorkflowInfo).toJson($$val))(data.approvalWorkflowInfo),
            ingestionWorkflowInfo: (($$val)=>$$val == undefined ? null : (0, _ingestionWorkflowInfo.IngestionWorkflowInfo).toJson($$val))(data.ingestionWorkflowInfo),
            validationWorkflowInfo: (($$val)=>$$val == undefined ? null : (0, _validationWorkflowInfo.ValidationWorkflowInfo).toJson($$val))(data.validationWorkflowInfo)
        });
    }
}
ReportWorkflowInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportWorkflowInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportWorkflowInfo);
function validateReportworkflowinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ValidationWorkflowInfo":"iaR6j","./ApprovalWorkflowInfo":"gEQOb","./IngestionWorkflowInfo":"9eC17","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iaR6j":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents information about the validation workflow.
 * validationFailureReason - Reason for validation failure, if any.
 * reportValidationTimeStamp - Timestamp when the report was validated.
 * reportValidationStatus - Status of the report validation.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ValidationWorkflowInfo", ()=>ValidationWorkflowInfo);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ValidationWorkflowInfo] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateValidationworkflowinfo", ()=>validateValidationworkflowinfo);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ValidationWorkflowInfo extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ValidationWorkflowInfo#clone(obj: PlainObjectFrom<ValidationWorkflowInfo>) method.
     */ constructor(__reportValidationStatus, __reportValidationTimeStamp, __validationFailureReason){
        super();
        this.reportValidationStatus = __reportValidationStatus;
        this.reportValidationTimeStamp = __reportValidationTimeStamp;
        this.validationFailureReason = __validationFailureReason;
    }
    /**
     * Create a shallow clone of ValidationWorkflowInfo from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ValidationWorkflowInfo(obj.reportValidationStatus, obj.reportValidationTimeStamp, obj.validationFailureReason);
    }
    static fromJson(data) {
        return new ValidationWorkflowInfo((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportValidationStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportValidationTimeStamp), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.validationFailureReason));
    }
    static toJson(data) {
        return Object.assign({
            reportValidationStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportValidationStatus),
            reportValidationTimeStamp: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportValidationTimeStamp),
            validationFailureReason: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.validationFailureReason)
        });
    }
}
ValidationWorkflowInfo.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ValidationWorkflowInfo";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ValidationWorkflowInfo);
function validateValidationworkflowinfo(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8oSeC":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents the actions performed on report
 * UPLOAD - ReportUpload
 * DOWNLOAD - ReportDownload
 * CREATE_FOLDER - ReportFolder creation
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportAction", ()=>ReportAction);
var ReportAction;
(function(ReportAction) {
    ReportAction["UPLOAD"] = "UPLOAD";
    ReportAction["DOWNLOAD"] = "DOWNLOAD";
    ReportAction["CREATE_FOLDER"] = "CREATE_FOLDER";
})(ReportAction || (ReportAction = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iZVh":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents different features supported by this system like Downloads, Upload by external users, Updates by
 * external users, Approvals etc.,
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportFeature", ()=>ReportFeature);
var ReportFeature;
(function(ReportFeature) {
    ReportFeature["DOWNLOAD"] = "DOWNLOAD";
})(ReportFeature || (ReportFeature = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hmPf5":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Represents different Report formats supported by this system<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportFormat", ()=>ReportFormat);
var ReportFormat;
(function(ReportFormat) {
    ReportFormat["EXCEL"] = "xlsx";
    ReportFormat["PLAIN_TEXT"] = "txt";
})(ReportFormat || (ReportFormat = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbdAQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportList", ()=>ReportList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportlist", ()=>validateReportlist);
var _report = require("./Report");
class ReportList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(ReportList.prototype));
    }
    static fromJson(data) {
        return new ReportList(data.map((datum)=>(0, _report.Report).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _report.Report).toJson(datum));
    }
}
function validateReportlist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./Report":"2e78w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7uVgk":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents status of the reports like NEW, PENDING_APPROVAL, PUBLISHED etc.,
 * Note: doesn't capture all status, will keep adding when required.
 * PUBLISHED - Report has been published to external users by internal users or vice versa.
 * VALIDATION_COMPLETED - Report has been validated both internally and by the client.
 * VALIDATION_PENDING - Report has been validated internally and is waiting for client validations to be performed.
 * VALIDATION_FAILED - Report validation has failed either at the client or internally.
 * APPROVAL_CREATED - Approval document related to the report has been created.
 * APPROVAL_PENDING - Approval related to the report is in a pending state.
 * APPROVAL_COMPLETED - Approval related to the report has been approved.
 * INGESTION_PENDING - Report is being ingested at the client end.
 * INGESTION_COMPLETED - Report has been successfully ingested at the client end.
 * INGESTION_FAILED - Report ingestion has failed at the client end.
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportStatus", ()=>ReportStatus);
var ReportStatus;
(function(ReportStatus) {
    ReportStatus["PUBLISHED"] = "PUBLISHED";
    ReportStatus["PENDING"] = "PENDING";
    ReportStatus["VALIDATION_COMPLETED"] = "VALIDATION_COMPLETED";
    ReportStatus["VALIDATION_PENDING"] = "VALIDATION_PENDING";
    ReportStatus["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    ReportStatus["APPROVAL_CREATED"] = "APPROVAL_CREATED";
    ReportStatus["APPROVAL_PENDING"] = "APPROVAL_PENDING";
    ReportStatus["APPROVAL_COMPLETED"] = "APPROVAL_COMPLETED";
    ReportStatus["INGESTION_PENDING"] = "INGESTION_PENDING";
    ReportStatus["INGESTION_COMPLETED"] = "INGESTION_COMPLETED";
    ReportStatus["INGESTION_FAILED"] = "INGESTION_FAILED";
    ReportStatus["APPROVAL_REJECTED"] = "APPROVAL_REJECTED";
})(ReportStatus || (ReportStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2bYU":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents report upload status like IN_PROGRESS , COMPLETED
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportUploadStatus", ()=>ReportUploadStatus);
var ReportUploadStatus;
(function(ReportUploadStatus) {
    ReportUploadStatus["PENDING"] = "PENDING";
    ReportUploadStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ReportUploadStatus["COMPLETED"] = "COMPLETED";
    ReportUploadStatus["IN_VALIDATION"] = "IN_VALIDATION";
    ReportUploadStatus["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    ReportUploadStatus["FAILED"] = "FAILED";
})(ReportUploadStatus || (ReportUploadStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6pBs2":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents the notification sent by the client to TRCS notifying the status of the workflow.
 * reportId - Unique identifier for the report.
 * reportWorkflowInfo - Workflow information related to the report.
 * reportStatus - Final status of the report.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportWorkflowTaskCompleteNotification", ()=>ReportWorkflowTaskCompleteNotification);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportWorkflowTaskCompleteNotification] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportworkflowtaskcompletenotification", ()=>validateReportworkflowtaskcompletenotification);
var _reportWorkflowInfo = require("./ReportWorkflowInfo");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportWorkflowTaskCompleteNotification extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportWorkflowTaskCompleteNotification#clone(obj: PlainObjectFrom<ReportWorkflowTaskCompleteNotification>) method.
     */ constructor(__reportId, __reportStatus, __reportWorkflowInfo){
        super();
        this.reportId = __reportId;
        this.reportStatus = __reportStatus;
        this.reportWorkflowInfo = __reportWorkflowInfo;
    }
    /**
     * Create a shallow clone of ReportWorkflowTaskCompleteNotification from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportWorkflowTaskCompleteNotification(obj.reportId, obj.reportStatus, obj.reportWorkflowInfo);
    }
    static fromJson(data) {
        return new ReportWorkflowTaskCompleteNotification((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportStatus), (0, _reportWorkflowInfo.ReportWorkflowInfo).fromJson(data.reportWorkflowInfo));
    }
    static toJson(data) {
        return Object.assign({
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportStatus),
            reportWorkflowInfo: (0, _reportWorkflowInfo.ReportWorkflowInfo).toJson(data.reportWorkflowInfo)
        });
    }
}
ReportWorkflowTaskCompleteNotification.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportWorkflowTaskCompleteNotification";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportWorkflowTaskCompleteNotification);
function validateReportworkflowtaskcompletenotification(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportWorkflowInfo":"hVTCm","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"65pPJ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Represents the notification TRCS will sent to client notifying the status of the workflow.
 * reportId - holds unique identifier for the report.
 * reportCreationDate - holds timestamp when the report was created.
 * term - Term associated with the report.
 * reportType - Represents type of the report.
 * logisticsParty - Represents Logistics party of the report.
 * lpLookUpValues - Represents Lookup values for the logistics party.
 * countryCode - Represents the Logistics party Country code.
 * additionalReportInfo - Represents additional information about the report.
 * reportWorkflowInfo - Represents workflow information related to the report.
 * reportStatus - Represents current status of the report.
 * reportLink - Represents Pre-Signed URL to access the report.
 * supportingDocumentLink - Represents Map of supporting document URLs.
 * reportCreatedBy - Represents Alias\/CustomerId who created the report.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "ReportWorkflowTaskNotification", ()=>ReportWorkflowTaskNotification);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportWorkflowTaskNotification] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateReportworkflowtasknotification", ()=>validateReportworkflowtasknotification);
var _lplookUpValues = require("./LPLookUpValues");
var _reportAdditionalInfo = require("./ReportAdditionalInfo");
var _reportWorkflowInfo = require("./ReportWorkflowInfo");
var _supportingDocumentURLMap = require("./SupportingDocumentURLMap");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class ReportWorkflowTaskNotification extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportWorkflowTaskNotification#clone(obj: PlainObjectFrom<ReportWorkflowTaskNotification>) method.
     */ constructor(__countryCode, __logisticsParty, __reportCreatedBy, __reportCreationDate, __reportId, __reportLink, __reportRegion, __reportStatus, __reportType, __reportWorkflowInfo, __term, __additionalReportInfo, __lpLookUpValues, __supportingDocumentLink){
        super();
        this.countryCode = __countryCode;
        this.logisticsParty = __logisticsParty;
        this.reportCreatedBy = __reportCreatedBy;
        this.reportCreationDate = __reportCreationDate;
        this.reportId = __reportId;
        this.reportLink = __reportLink;
        this.reportRegion = __reportRegion;
        this.reportStatus = __reportStatus;
        this.reportType = __reportType;
        this.reportWorkflowInfo = __reportWorkflowInfo;
        this.term = __term;
        this.additionalReportInfo = __additionalReportInfo;
        this.lpLookUpValues = __lpLookUpValues;
        this.supportingDocumentLink = __supportingDocumentLink;
    }
    /**
     * Create a shallow clone of ReportWorkflowTaskNotification from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new ReportWorkflowTaskNotification(obj.countryCode, obj.logisticsParty, obj.reportCreatedBy, obj.reportCreationDate, obj.reportId, obj.reportLink, obj.reportRegion, obj.reportStatus, obj.reportType, obj.reportWorkflowInfo, obj.term, obj.additionalReportInfo, obj.lpLookUpValues, obj.supportingDocumentLink);
    }
    static fromJson(data) {
        return new ReportWorkflowTaskNotification((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.countryCode), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsParty), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportCreatedBy), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportCreationDate), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportLink), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportRegion), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportStatus), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _reportWorkflowInfo.ReportWorkflowInfo).fromJson(data.reportWorkflowInfo), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _reportAdditionalInfo.ReportAdditionalInfo).fromJson($$val))(data.additionalReportInfo), (($$val)=>$$val == undefined ? undefined : (0, _lplookUpValues.LPLookUpValues).fromJson($$val))(data.lpLookUpValues), (($$val)=>$$val == undefined ? undefined : (0, _supportingDocumentURLMap.SupportingDocumentURLMap).fromJson($$val))(data.supportingDocumentLink));
    }
    static toJson(data) {
        return Object.assign({
            countryCode: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.countryCode),
            logisticsParty: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.logisticsParty),
            reportCreatedBy: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportCreatedBy),
            reportCreationDate: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportCreationDate),
            reportId: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportId),
            reportLink: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportLink),
            reportRegion: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportRegion),
            reportStatus: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportStatus),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            reportWorkflowInfo: (0, _reportWorkflowInfo.ReportWorkflowInfo).toJson(data.reportWorkflowInfo),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            additionalReportInfo: (($$val)=>$$val == undefined ? null : (0, _reportAdditionalInfo.ReportAdditionalInfo).toJson($$val))(data.additionalReportInfo),
            lpLookUpValues: (($$val)=>$$val == undefined ? null : (0, _lplookUpValues.LPLookUpValues).toJson($$val))(data.lpLookUpValues),
            supportingDocumentLink: (($$val)=>$$val == undefined ? null : (0, _supportingDocumentURLMap.SupportingDocumentURLMap).toJson($$val))(data.supportingDocumentLink)
        });
    }
}
ReportWorkflowTaskNotification.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportWorkflowTaskNotification";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(ReportWorkflowTaskNotification);
function validateReportworkflowtasknotification(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./LPLookUpValues":"3sdWb","./ReportAdditionalInfo":"gOPcz","./ReportWorkflowInfo":"hVTCm","./SupportingDocumentURLMap":"bta6X","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbHxS":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Holds allowed filters for searching reports<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchCriteriaField", ()=>SearchCriteriaField);
var SearchCriteriaField;
(function(SearchCriteriaField) {
    SearchCriteriaField["SERVICE_PROVIDER_ID"] = "SERVICE_PROVIDER_ID";
    SearchCriteriaField["TERM"] = "TERM";
    SearchCriteriaField["REPORT_TYPE"] = "REPORT_TYPE";
    SearchCriteriaField["REPORT_STATUS"] = "REPORT_STATUS";
    SearchCriteriaField["REPORT_PARENT_PATH"] = "REPORT_PARENT_PATH";
    SearchCriteriaField["CREATED_BY"] = "CREATED_BY";
    SearchCriteriaField["QUERY_ID"] = "QUERY_ID";
})(SearchCriteriaField || (SearchCriteriaField = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2iZh":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for SearchReports API
 *
 * term, reportType - reprsents the Term and Report Type for which reports need to be fetched. Each Term can own
 * multiple report types.
 * Example -  Term: SP_INVOICE_MANAGEMENT owns Report Types : INVOICE_RECONCILIATION_FILES, INVOICE_DISUPTE_FILES
 *
 * lpAttributesKey - Reports can be mapped at attributes related to logistics party. This is a optional field used
 * to fetch reports at attribute level granularity.
 * Example - LP1 + SCAC1, LP1 + SCAC2 have different reports mapped.
 *
 * pageSize - represents number of reports to be fetched in a page
 * pageId - represents identifier of the page to be fetched. If pageId is null, the first page is fetched.
 * offset - specifies number of records to be skipped for paginated results
 *
 * searchCriteria - Represents serach criteria for reports
 * sortCriteriaList - Specifies the sorting criteria for the reports obtained, allows results to be sorted on
 * multiple fields. If not provided, reports fetched does not follow any specific order. Currently supporting
 * sort only on single criteria
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SearchReportsInput", ()=>SearchReportsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SearchReportsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSearchreportsinput", ()=>validateSearchreportsinput);
var _searchCriteria = require("./SearchCriteria");
var _sortCriteriaList = require("./SortCriteriaList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SearchReportsInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SearchReportsInput#clone(obj: PlainObjectFrom<SearchReportsInput>) method.
     */ constructor(__pageSize, __reportType, __term, __customerId, __logisticsPartyId, __lpAttributesKey, __offset, __pageId, __partnerAccountId, __searchCriteria, __sortCriteriaList, __userSessionAttributes){
        super();
        this.pageSize = __pageSize;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.lpAttributesKey = __lpAttributesKey;
        this.offset = __offset;
        this.pageId = __pageId;
        this.partnerAccountId = __partnerAccountId;
        this.searchCriteria = __searchCriteria;
        this.sortCriteriaList = __sortCriteriaList;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of SearchReportsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SearchReportsInput(obj.pageSize, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.lpAttributesKey, obj.offset, obj.pageId, obj.partnerAccountId, obj.searchCriteria, obj.sortCriteriaList, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new SearchReportsInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.pageSize), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.lpAttributesKey), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.offset), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pageId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _searchCriteria.SearchCriteria).fromJson($$val))(data.searchCriteria), (($$val)=>$$val == undefined ? undefined : (0, _sortCriteriaList.SortCriteriaList).fromJson($$val))(data.sortCriteriaList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            pageSize: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.pageSize),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            lpAttributesKey: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.lpAttributesKey),
            offset: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.offset),
            pageId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.pageId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            searchCriteria: (($$val)=>$$val == undefined ? null : (0, _searchCriteria.SearchCriteria).toJson($$val))(data.searchCriteria),
            sortCriteriaList: (($$val)=>$$val == undefined ? null : (0, _sortCriteriaList.SortCriteriaList).toJson($$val))(data.sortCriteriaList),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
SearchReportsInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SearchReportsInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SearchReportsInput);
function validateSearchreportsinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SearchCriteria":"7a5KV","./SortCriteriaList":"kNM27","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kNM27":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortCriteriaList", ()=>SortCriteriaList);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SortCriteriaList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSortcriterialist", ()=>validateSortcriterialist);
var _sortCriteria = require("./SortCriteria");
class SortCriteriaList extends Array {
    constructor(param){
        if (typeof param === "number") super(param);
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(SortCriteriaList.prototype));
    }
    static fromJson(data) {
        return new SortCriteriaList(data.map((datum)=>(0, _sortCriteria.SortCriteria).fromJson(datum)));
    }
    static toJson(data) {
        return data.map((datum)=>(0, _sortCriteria.SortCriteria).toJson(datum));
    }
}
function validateSortcriterialist(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./SortCriteria":"2kPfN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kPfN":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>     Holds the sorting criteria for search.
 * sortField - field on which results need to be sorted.
 * sortOrder - specifies the sort order, ascending or descending.
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SortCriteria", ()=>SortCriteria);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SortCriteria] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSortcriteria", ()=>validateSortcriteria);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SortCriteria extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SortCriteria#clone(obj: PlainObjectFrom<SortCriteria>) method.
     */ constructor(__sortField, __sortOrder){
        super();
        this.sortField = __sortField;
        this.sortOrder = __sortOrder;
    }
    /**
     * Create a shallow clone of SortCriteria from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SortCriteria(obj.sortField, obj.sortOrder);
    }
    static fromJson(data) {
        return new SortCriteria((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.sortField), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.sortOrder));
    }
    static toJson(data) {
        return Object.assign({
            sortField: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.sortField),
            sortOrder: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.sortOrder)
        });
    }
}
SortCriteria.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SortCriteria";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SortCriteria);
function validateSortcriteria(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eerRQ":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Output for SearchReports API
 * reportList - reports fetched for given input
 * nextPageId - represents identifier for the next page. If nextPageId is null, this is the last page available for
 * given input.
 * totalRecords - total number of reports fetched for given input
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "SearchReportsOutput", ()=>SearchReportsOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SearchReportsOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateSearchreportsoutput", ()=>validateSearchreportsoutput);
var _reportList = require("./ReportList");
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class SearchReportsOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SearchReportsOutput#clone(obj: PlainObjectFrom<SearchReportsOutput>) method.
     */ constructor(__nextPageId, __reportList, __totalRecords){
        super();
        this.nextPageId = __nextPageId;
        this.reportList = __reportList;
        this.totalRecords = __totalRecords;
    }
    /**
     * Create a shallow clone of SearchReportsOutput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new SearchReportsOutput(obj.nextPageId, obj.reportList, obj.totalRecords);
    }
    static fromJson(data) {
        return new SearchReportsOutput((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.nextPageId), (($$val)=>$$val == undefined ? undefined : (0, _reportList.ReportList).fromJson($$val))(data.reportList), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.totalRecords));
    }
    static toJson(data) {
        return Object.assign({
            nextPageId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.nextPageId),
            reportList: (($$val)=>$$val == undefined ? null : (0, _reportList.ReportList).toJson($$val))(data.reportList),
            totalRecords: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.totalRecords)
        });
    }
}
SearchReportsOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SearchReportsOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(SearchReportsOutput);
function validateSearchreportsoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"./ReportList":"kbdAQ","@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"apO8k":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Holds allowed sort fields on search of reports<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortCriteriaField", ()=>SortCriteriaField);
var SortCriteriaField;
(function(SortCriteriaField) {
    SortCriteriaField["LAST_UPDATED_TIME"] = "LAST_UPDATED_TIME";
    SortCriteriaField["REPORT_PATH"] = "REPORT_PATH";
    SortCriteriaField["REPORT_RECORD_LAST_UPDATED_TIME"] = "REPORT_RECORD_LAST_UPDATED_TIME";
    SortCriteriaField["REPORT_RECORD_CREATION_TIME"] = "REPORT_RECORD_CREATION_TIME";
})(SortCriteriaField || (SortCriteriaField = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jEA60":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <p>Holds different sort orders<\/p>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortOrder", ()=>SortOrder);
var SortOrder;
(function(SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fPAuM":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transReportsCenterServiceSerdesInterceptor", ()=>transReportsCenterServiceSerdesInterceptor);
parcelHelpers.export(exports, "transReportsCenterServiceHttpBindingInterceptor", ()=>transReportsCenterServiceHttpBindingInterceptor);
parcelHelpers.export(exports, "TransReportsCenterService", ()=>TransReportsCenterService);
var _coralComAmazonCoralAvailability = require("@amzn/coral_com-amazon-coral-availability");
var _rejectReportOutput = require("./RejectReportOutput");
var _buildDataPipelinesInput = require("./BuildDataPipelinesInput");
var _initiateBatchReportUploadOutput = require("./InitiateBatchReportUploadOutput");
var _createReportApprovalOutput = require("./CreateReportApprovalOutput");
var _downloadReportInput = require("./DownloadReportInput");
var _trcsrecoverableException = require("./TRCSRecoverableException");
var _completeBatchReportUploadInput = require("./CompleteBatchReportUploadInput");
var _uploadReportOutput = require("./UploadReportOutput");
var _searchReportsOutput = require("./SearchReportsOutput");
var _trcsunauthorizedException = require("./TRCSUnauthorizedException");
var _trcsinvalidRequestException = require("./TRCSInvalidRequestException");
var _initiateBatchReportUploadInput = require("./InitiateBatchReportUploadInput");
var _generateReportSyncInput = require("./GenerateReportSyncInput");
var _trcsunrecoverableException = require("./TRCSUnrecoverableException");
var _createReportApprovalInput = require("./CreateReportApprovalInput");
var _generatePresignedUrlOutput = require("./GeneratePresignedUrlOutput");
var _generateReportAsyncInput = require("./GenerateReportAsyncInput");
var _generateReportAsyncOutput = require("./GenerateReportAsyncOutput");
var _completeBatchReportUploadOutput = require("./CompleteBatchReportUploadOutput");
var _rejectReportInput = require("./RejectReportInput");
var _searchReportsInput = require("./SearchReportsInput");
var _getTermReportConfigsInput = require("./GetTermReportConfigsInput");
var _getTermReportConfigsOutput = require("./GetTermReportConfigsOutput");
var _buildDataPipelinesOutput = require("./BuildDataPipelinesOutput");
var _uploadReportInput = require("./UploadReportInput");
var _dependencyException = require("./DependencyException");
var _approveReportInput = require("./ApproveReportInput");
var _deleteReportInput = require("./DeleteReportInput");
var _approveReportOutput = require("./ApproveReportOutput");
var _beerList = require("./BeerList");
var _generateReportSyncOutput = require("./GenerateReportSyncOutput");
var _beer = require("./Beer");
var _deleteReportOutput = require("./DeleteReportOutput");
var _generatePresignedUrlInput = require("./GeneratePresignedUrlInput");
var _downloadReportOutput = require("./DownloadReportOutput");
var _coralComAmazonCoralServiceBsf = require("@amzn/coral_com-amazon-coral-service-bsf");
var _coralComAmazonCoralClient = require("@amzn/coral_com-amazon-coral-client");
var _coralComAmazonCoralService = require("@amzn/coral_com-amazon-coral-service");
var _coralComAmazonCoralServiceJms = require("@amzn/coral_com-amazon-coral-service-jms");
var _coralComAmazonCoralValidate = require("@amzn/coral_com-amazon-coral-validate");
var _coralComAmazonCoralServiceHttp = require("@amzn/coral_com-amazon-coral-service-http");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const transReportsCenterServiceSerdesInterceptor = new (0, _ihmJsCoralClient.CoralClientSerdesInterceptor)({
    ApproveReport: {
        deserializationFn: (0, _approveReportOutput.ApproveReportOutput).fromJson,
        serializationFn: (0, _approveReportInput.ApproveReportInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    BuildDataPipelines: {
        deserializationFn: (0, _buildDataPipelinesOutput.BuildDataPipelinesOutput).fromJson,
        serializationFn: (0, _buildDataPipelinesInput.BuildDataPipelinesInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    CompleteBatchReportUpload: {
        deserializationFn: (0, _completeBatchReportUploadOutput.CompleteBatchReportUploadOutput).fromJson,
        serializationFn: (0, _completeBatchReportUploadInput.CompleteBatchReportUploadInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    CreateBeer: {
        deserializationFn: (0, _beer.Beer).fromJson,
        serializationFn: (0, _beer.Beer).toJson,
        modelledExceptions: [
            (0, _dependencyException.DependencyException)
        ]
    },
    CreateReportApproval: {
        deserializationFn: (0, _createReportApprovalOutput.CreateReportApprovalOutput).fromJson,
        serializationFn: (0, _createReportApprovalInput.CreateReportApprovalInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    DeleteReport: {
        deserializationFn: (0, _deleteReportOutput.DeleteReportOutput).fromJson,
        serializationFn: (0, _deleteReportInput.DeleteReportInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    DownloadReport: {
        deserializationFn: (0, _downloadReportOutput.DownloadReportOutput).fromJson,
        serializationFn: (0, _downloadReportInput.DownloadReportInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    GeneratePresignedUrl: {
        deserializationFn: (0, _generatePresignedUrlOutput.GeneratePresignedUrlOutput).fromJson,
        serializationFn: (0, _generatePresignedUrlInput.GeneratePresignedUrlInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    GenerateReportAsync: {
        deserializationFn: (0, _generateReportAsyncOutput.GenerateReportAsyncOutput).fromJson,
        serializationFn: (0, _generateReportAsyncInput.GenerateReportAsyncInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    GenerateReportSync: {
        deserializationFn: (0, _generateReportSyncOutput.GenerateReportSyncOutput).fromJson,
        serializationFn: (0, _generateReportSyncInput.GenerateReportSyncInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    GetAllBeers: {
        deserializationFn: (0, _beerList.BeerList).fromJson,
        modelledExceptions: [
            (0, _dependencyException.DependencyException)
        ]
    },
    GetTermReportConfigs: {
        deserializationFn: (0, _getTermReportConfigsOutput.GetTermReportConfigsOutput).fromJson,
        serializationFn: (0, _getTermReportConfigsInput.GetTermReportConfigsInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    InitiateBatchReportUpload: {
        deserializationFn: (0, _initiateBatchReportUploadOutput.InitiateBatchReportUploadOutput).fromJson,
        serializationFn: (0, _initiateBatchReportUploadInput.InitiateBatchReportUploadInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    RejectReport: {
        deserializationFn: (0, _rejectReportOutput.RejectReportOutput).fromJson,
        serializationFn: (0, _rejectReportInput.RejectReportInput).toJson,
        modelledExceptions: []
    },
    SearchReports: {
        deserializationFn: (0, _searchReportsOutput.SearchReportsOutput).fromJson,
        serializationFn: (0, _searchReportsInput.SearchReportsInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    },
    UploadReport: {
        deserializationFn: (0, _uploadReportOutput.UploadReportOutput).fromJson,
        serializationFn: (0, _uploadReportInput.UploadReportInput).toJson,
        modelledExceptions: [
            (0, _trcsunrecoverableException.TRCSUnrecoverableException),
            (0, _trcsunauthorizedException.TRCSUnauthorizedException),
            (0, _trcsinvalidRequestException.TRCSInvalidRequestException),
            (0, _trcsrecoverableException.TRCSRecoverableException)
        ]
    }
}, [
    _coralComAmazonCoralAvailability.BackOffException,
    _coralComAmazonCoralAvailability.ThrottlingException,
    _coralComAmazonCoralClient.ClientUnavailableException,
    _coralComAmazonCoralClient.HttpConnectionTimeoutException,
    _coralComAmazonCoralClient.HttpFailureException,
    _coralComAmazonCoralClient.HttpTimeoutException,
    _coralComAmazonCoralServiceBsf.InvalidCodigoMessageException,
    _coralComAmazonCoralServiceHttp.HeaderMisclassificationException,
    _coralComAmazonCoralServiceHttp.HttpNotFoundException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeException,
    _coralComAmazonCoralServiceHttp.InvalidAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.InvalidMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingAuthSchemeParameterException,
    _coralComAmazonCoralServiceHttp.MissingMessageDigestException,
    _coralComAmazonCoralServiceHttp.MissingRequiredHeaderException,
    _coralComAmazonCoralServiceJms.MessageProcessingException,
    _coralComAmazonCoralServiceJms.MessagePublishException,
    _coralComAmazonCoralService.AccessDeniedException,
    _coralComAmazonCoralService.DelegationException,
    _coralComAmazonCoralService.ExpiredTokenException,
    _coralComAmazonCoralService.IncompleteSignatureException,
    _coralComAmazonCoralService.InternalFailure,
    _coralComAmazonCoralService.InvalidAwsQueryStringException,
    _coralComAmazonCoralService.InvalidParameterCombinationException,
    _coralComAmazonCoralService.InvalidParameterValueException,
    _coralComAmazonCoralService.InvalidQueryParameterException,
    _coralComAmazonCoralService.InvalidQueryStringException,
    _coralComAmazonCoralService.InvalidSignatureException,
    _coralComAmazonCoralService.MalformedHttpRequestException,
    _coralComAmazonCoralService.MissingActionException,
    _coralComAmazonCoralService.MissingAuthenticationTokenException,
    _coralComAmazonCoralService.MissingRequiredParameterException,
    _coralComAmazonCoralService.NotAuthorizedException,
    _coralComAmazonCoralService.RequestAbortedException,
    _coralComAmazonCoralService.RequestEntityTooLargeException,
    _coralComAmazonCoralService.RequestExpiredException,
    _coralComAmazonCoralService.RequestTimeoutException,
    _coralComAmazonCoralService.SerializationException,
    _coralComAmazonCoralService.ServiceUnavailableException,
    _coralComAmazonCoralService.SubscriptionRequiredException,
    _coralComAmazonCoralService.TimeoutException,
    _coralComAmazonCoralService.TransmutationException,
    _coralComAmazonCoralService.UnknownOperationException,
    _coralComAmazonCoralService.UnrecognizedClientException,
    _coralComAmazonCoralService.UnsupportedMediaTypeException,
    _coralComAmazonCoralValidate.ValidationException
]);
const transReportsCenterServiceHttpBindingInterceptor = new (0, _ihmJsCoralClient.CoralClientHttpBindingInterceptor)({
    ApproveReport: {
        method: "POST",
        path: "/trcs/v1/reports/approve-report"
    },
    BuildDataPipelines: {
        method: "POST",
        path: "/trcs/v1/data-pipelines"
    },
    CompleteBatchReportUpload: {
        method: "POST",
        path: "/trcs/v1/reports/complete-batch-upload"
    },
    CreateReportApproval: {
        method: "POST",
        path: "/trcs/v1/reports/create-approval"
    },
    DeleteReport: {
        method: "POST",
        path: "/trcs/v1/reports/delete"
    },
    DownloadReport: {
        method: "POST",
        path: "/trcs/v1/reports/download"
    },
    GeneratePresignedUrl: {
        method: "POST",
        path: "/trcs/v1/generate-url"
    },
    GenerateReportAsync: {
        method: "POST",
        path: "/trcs/v1/reports/generate-async"
    },
    GenerateReportSync: {
        method: "POST",
        path: "/trcs/v1/reports/generate-sync"
    },
    GetTermReportConfigs: {
        method: "POST",
        path: "/trcs/v1/report-configs"
    },
    InitiateBatchReportUpload: {
        method: "POST",
        path: "/trcs/v1/reports/batch-upload"
    },
    RejectReport: {
        method: "POST",
        path: "/trcs/v1/reports/reject-report"
    },
    SearchReports: {
        method: "POST",
        path: "/trcs/v1/reports/search"
    },
    UploadReport: {
        method: "POST",
        path: "/trcs/v1/reports/upload"
    }
});
class TransReportsCenterService extends (0, _ihmJsCoralClient.CoralClient) {
    constructor(config, handler){
        const serdesHandler = new (0, _ihmJsCoralClient.InterceptingHandler)(handler, [
            transReportsCenterServiceSerdesInterceptor
        ]);
        super(config, serdesHandler);
    }
    /**
     * <pre><code>API to approve the uploaded document.
     * <\/code><\/pre>
     **/ approveReport(request) {
        return super.call("ApproveReport", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _approveReportOutput.ApproveReportOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type ApproveReportOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <pre><code>API  to build data pipelines for given term and reportType.
     * <\/code><\/pre>
     **/ buildDataPipelines(request) {
        return super.call("BuildDataPipelines", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _buildDataPipelinesOutput.BuildDataPipelinesOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type BuildDataPipelinesOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API called to complete report multipart upload
     * Till this API is called report upload is not considered to be completed
     * Takes eTags of the parts of each report that are uploaded successfully along with unique uploadId<\/p>
     **/ completeBatchReportUpload(request) {
        return super.call("CompleteBatchReportUpload", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _completeBatchReportUploadOutput.CompleteBatchReportUploadOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type CompleteBatchReportUploadOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>Create a new beer<\/p>
     **/ createBeer(request) {
        return super.call("CreateBeer", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _beer.Beer))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type Beer. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <pre><code>API to create approval request for report uploaded.
     * <\/code><\/pre>
     **/ createReportApproval(request) {
        return super.call("CreateReportApproval", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _createReportApprovalOutput.CreateReportApprovalOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type CreateReportApprovalOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <pre><code>For given input deletes report and its record.
     * <\/code><\/pre>
     **/ deleteReport(request) {
        return super.call("DeleteReport", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _deleteReportOutput.DeleteReportOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type DeleteReportOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API to download the report<\/p>
     **/ downloadReport(request) {
        return super.call("DownloadReport", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _downloadReportOutput.DownloadReportOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type DownloadReportOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <pre><code>API to generate pre-signed URL for given S3 details.
     * <\/code><\/pre>
     **/ generatePresignedUrl(request) {
        return super.call("GeneratePresignedUrl", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _generatePresignedUrlOutput.GeneratePresignedUrlOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GeneratePresignedUrlOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API to generate report asynchronously.<\/p>
     **/ generateReportAsync(request) {
        return super.call("GenerateReportAsync", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _generateReportAsyncOutput.GenerateReportAsyncOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GenerateReportAsyncOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API to generate report synchronously.<\/p>
     **/ generateReportSync(request) {
        return super.call("GenerateReportSync", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _generateReportSyncOutput.GenerateReportSyncOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GenerateReportSyncOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>Get a list of all of the beers in the system<\/p>
     **/ getAllBeers() {
        return super.call("GetAllBeers").pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _beerList.BeerList))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type BeerList. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API to fetch all available report types configurations of a term<\/p>
     **/ getTermReportConfigs(request) {
        return super.call("GetTermReportConfigs", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _getTermReportConfigsOutput.GetTermReportConfigsOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type GetTermReportConfigsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API to initiate Batch report uploads
     * Each report of the Batch is uploaded via mutlipart upload
     * Takes list of each report specific input and returns list of presigned URLs to upload each part of the report<\/p>
     **/ initiateBatchReportUpload(request) {
        return super.call("InitiateBatchReportUpload", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _initiateBatchReportUploadOutput.InitiateBatchReportUploadOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type InitiateBatchReportUploadOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <pre><code>API to reject the uploaded document.
     * <\/code><\/pre>
     **/ rejectReport(request) {
        return super.call("RejectReport", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _rejectReportOutput.RejectReportOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type RejectReportOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <pre><code>Fetches reports information for given search input. Its a paginated API.
     * Note: Keeping the verb as POST to support additional search inputs in future
     * <\/code><\/pre>
     **/ searchReports(request) {
        return super.call("SearchReports", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _searchReportsOutput.SearchReportsOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type SearchReportsOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
    /**
     * <p>API  to initiate report upload
     * This upload can be used to either upload a file or folder object<\/p>
     **/ uploadReport(request) {
        return super.call("UploadReport", request).pipe((0, _operators.map)(({ body })=>{
            if (!(body instanceof (0, _uploadReportOutput.UploadReportOutput))) throw new TypeError(`[TransReportsCenterService] Expected response body to be of type UploadReportOutput. Got ${body && body.constructor.name}`);
            return body;
        }), (0, _operators.catchError)((error)=>(0, _rxjs.throwError)(typeof error === "object" && error !== null && error.constructor.name === (0, _ihmJsCoralClient.CoralResponse).name && error.body !== undefined ? error.body : error)));
    }
}
TransReportsCenterService.assembly = "com.amazon.transreportscenterservice";
TransReportsCenterService.serviceName = "TransReportsCenterService";

},{"@amzn/coral_com-amazon-coral-availability":"XcIbm","./RejectReportOutput":"6epqY","./BuildDataPipelinesInput":"1rbwU","./InitiateBatchReportUploadOutput":"2LGu6","./CreateReportApprovalOutput":"jLzHG","./DownloadReportInput":"k2IK4","./TRCSRecoverableException":"bWUiG","./CompleteBatchReportUploadInput":"hXyB6","./UploadReportOutput":"1dfyl","./SearchReportsOutput":"eerRQ","./TRCSUnauthorizedException":"dtH3n","./TRCSInvalidRequestException":"7Mnrr","./InitiateBatchReportUploadInput":"bmroK","./GenerateReportSyncInput":"kreQO","./TRCSUnrecoverableException":"9oPeh","./CreateReportApprovalInput":"czmqe","./GeneratePresignedUrlOutput":"i3ssu","./GenerateReportAsyncInput":"iPQ3g","./GenerateReportAsyncOutput":"fdIlq","./CompleteBatchReportUploadOutput":"9WgUN","./RejectReportInput":"2HrXn","./SearchReportsInput":"k2iZh","./GetTermReportConfigsInput":"8v8yU","./GetTermReportConfigsOutput":"8N5nJ","./BuildDataPipelinesOutput":"7R4kd","./UploadReportInput":"eendP","./DependencyException":"ewwej","./ApproveReportInput":"aKcFr","./DeleteReportInput":"dP3Tl","./ApproveReportOutput":"axAzo","./BeerList":"spuJj","./GenerateReportSyncOutput":"cQiIH","./Beer":"99wEG","./DeleteReportOutput":"aCUxM","./GeneratePresignedUrlInput":"hbuR8","./DownloadReportOutput":"j61BD","@amzn/coral_com-amazon-coral-service-bsf":"cXsMq","@amzn/coral_com-amazon-coral-client":"5x6ZW","@amzn/coral_com-amazon-coral-service":"17IVk","@amzn/coral_com-amazon-coral-service-jms":"6RZKg","@amzn/coral_com-amazon-coral-validate":"dF4p4","@amzn/coral_com-amazon-coral-service-http":"hKSuo","@amzn/ihm-js-coral-client":"eOj61","rxjs":"gxhPq","rxjs/operators":"ggrIi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bWUiG":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on a retryable error in the service, e.g. throttled from underlying service<\/p>
 **/ parcelHelpers.export(exports, "TRCSRecoverableException", ()=>TRCSRecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TRCSRecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTrcsrecoverableexception", ()=>validateTrcsrecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TRCSRecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TRCSRecoverableException#clone(obj: PlainObjectFrom<TRCSRecoverableException>) method.
     */ constructor(__errorCode, __message){
        super();
        this.errorCode = __errorCode;
        this.message = __message;
    }
    /**
     * Create a shallow clone of TRCSRecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TRCSRecoverableException(obj.errorCode, obj.message);
    }
    static fromJson(data) {
        return new TRCSRecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            errorCode: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TRCSRecoverableException.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#TRCSRecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TRCSRecoverableException);
function validateTrcsrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1dfyl":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Outpur for  UploadReport API
 * Keeping it empty for now for future extensibility
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "UploadReportOutput", ()=>UploadReportOutput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UploadReportOutput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUploadreportoutput", ()=>validateUploadreportoutput);
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UploadReportOutput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UploadReportOutput#clone(obj: PlainObjectFrom<UploadReportOutput>) method.
     */ static fromJson(data) {
        return new UploadReportOutput();
    }
    static toJson(data) {
        return Object.assign({});
    }
}
UploadReportOutput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#UploadReportOutput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UploadReportOutput);
function validateUploadreportoutput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dtH3n":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown if the user isn't authorized to perform the operation. Non-retryable.<\/p>
 **/ parcelHelpers.export(exports, "TRCSUnauthorizedException", ()=>TRCSUnauthorizedException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TRCSUnauthorizedException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTrcsunauthorizedexception", ()=>validateTrcsunauthorizedexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TRCSUnauthorizedException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TRCSUnauthorizedException#clone(obj: PlainObjectFrom<TRCSUnauthorizedException>) method.
     */ constructor(__errorCode, __message){
        super();
        this.errorCode = __errorCode;
        this.message = __message;
    }
    /**
     * Create a shallow clone of TRCSUnauthorizedException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TRCSUnauthorizedException(obj.errorCode, obj.message);
    }
    static fromJson(data) {
        return new TRCSUnauthorizedException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            errorCode: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TRCSUnauthorizedException.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#TRCSUnauthorizedException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TRCSUnauthorizedException);
function validateTrcsunauthorizedexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Mnrr":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown if the request is invalid. Non-retryable.<\/p>
 **/ parcelHelpers.export(exports, "TRCSInvalidRequestException", ()=>TRCSInvalidRequestException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TRCSInvalidRequestException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTrcsinvalidrequestexception", ()=>validateTrcsinvalidrequestexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TRCSInvalidRequestException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TRCSInvalidRequestException#clone(obj: PlainObjectFrom<TRCSInvalidRequestException>) method.
     */ constructor(__errorCode, __message){
        super();
        this.errorCode = __errorCode;
        this.message = __message;
    }
    /**
     * Create a shallow clone of TRCSInvalidRequestException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TRCSInvalidRequestException(obj.errorCode, obj.message);
    }
    static fromJson(data) {
        return new TRCSInvalidRequestException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            errorCode: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TRCSInvalidRequestException.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#TRCSInvalidRequestException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TRCSInvalidRequestException);
function validateTrcsinvalidrequestexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9oPeh":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <p>This exception is thrown on non-retryable error in the service or its dependencies.<\/p>
 **/ parcelHelpers.export(exports, "TRCSUnrecoverableException", ()=>TRCSUnrecoverableException);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [TRCSUnrecoverableException] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateTrcsunrecoverableexception", ()=>validateTrcsunrecoverableexception);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class TRCSUnrecoverableException extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the TRCSUnrecoverableException#clone(obj: PlainObjectFrom<TRCSUnrecoverableException>) method.
     */ constructor(__errorCode, __message){
        super();
        this.errorCode = __errorCode;
        this.message = __message;
    }
    /**
     * Create a shallow clone of TRCSUnrecoverableException from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new TRCSUnrecoverableException(obj.errorCode, obj.message);
    }
    static fromJson(data) {
        return new TRCSUnrecoverableException((($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message));
    }
    static toJson(data) {
        return Object.assign({
            errorCode: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.errorCode),
            message: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.message)
        });
    }
}
TRCSUnrecoverableException.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#TRCSUnrecoverableException";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(TRCSUnrecoverableException);
function validateTrcsunrecoverableexception(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eendP":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * <pre><code>Input for UploadReport API
 * ReportInformation, LogisticsPartyInformation - takes the term, reportType and LP for which the report is uploaded
 * UserInformation - takes the user identifier who performed the upload
 * objectKey - Represents a identifier to represent object(file\/folder) name
 * objectType - Represents type of object that is to be stored it can be either file or folder
 * <\/code><\/pre>
 **/ parcelHelpers.export(exports, "UploadReportInput", ()=>UploadReportInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [UploadReportInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */ parcelHelpers.export(exports, "validateUploadreportinput", ()=>validateUploadreportinput);
var _coralTypescriptTypesPieces = require("@amzn/coral-typescript-types-pieces");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
class UploadReportInput extends (0, _ihmJsCoralClient.CoralModel) {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the UploadReportInput#clone(obj: PlainObjectFrom<UploadReportInput>) method.
     */ constructor(__objectKey, __objectType, __reportType, __term, __customerId, __logisticsPartyId, __partnerAccountId, __userSessionAttributes){
        super();
        this.objectKey = __objectKey;
        this.objectType = __objectType;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.partnerAccountId = __partnerAccountId;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of UploadReportInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */ static clone(obj) {
        return new UploadReportInput(obj.objectKey, obj.objectType, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.partnerAccountId, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new UploadReportInput((0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.objectKey), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.objectType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType), (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId), (($$val)=>$$val == undefined ? undefined : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            objectKey: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.objectKey),
            objectType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.objectType),
            reportType: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.reportType),
            term: (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction(data.term),
            customerId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.logisticsPartyId),
            partnerAccountId: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.partnerAccountId),
            userSessionAttributes: (($$val)=>$$val == undefined ? null : (0, _coralTypescriptTypesPieces.SerdesUtils).identityFunction($$val))(data.userSessionAttributes)
        });
    }
}
UploadReportInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#UploadReportInput";
// Register concrete types for serialization/deserialization
(0, _ihmJsCoralClient.modelRegistrySingleton).registerType(UploadReportInput);
function validateUploadreportinput(data) {
    // TODO: Actually implement this!
    return data;
}

},{"@amzn/coral-typescript-types-pieces":"9PLBl","@amzn/ihm-js-coral-client":"eOj61","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loO60":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ /**
 * <pre><code>Represents different types of users
 * SYSTEM is one userType
 * Any regular internal\/external user is not specifically represented
 * <\/code><\/pre>
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserType", ()=>UserType);
var UserType;
(function(UserType) {
    UserType["SYSTEM"] = "SYSTEM";
})(UserType || (UserType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l61P0":[function(require,module,exports) {
/* eslint-disable import/prefer-default-export */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATE_FNS_LOCALE_MAP", ()=>DATE_FNS_LOCALE_MAP);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatDateInTimezone", ()=>formatDateInTimezone);
parcelHelpers.export(exports, "getTimeZone", ()=>getTimeZone);
parcelHelpers.export(exports, "isBlockedDateInCalendar", ()=>isBlockedDateInCalendar);
var _dateFnsTz = require("date-fns-tz");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _fr = require("date-fns/locale/fr");
var _frDefault = parcelHelpers.interopDefault(_fr);
var _es = require("date-fns/locale/es");
var _esDefault = parcelHelpers.interopDefault(_es);
var _it = require("date-fns/locale/it");
var _itDefault = parcelHelpers.interopDefault(_it);
var _enUS = require("date-fns/locale/en-US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _dateFns = require("date-fns");
var _isAfter = require("date-fns/isAfter");
var _isAfterDefault = parcelHelpers.interopDefault(_isAfter);
var _parse = require("date-fns/parse");
var _parseDefault = parcelHelpers.interopDefault(_parse);
var _addDays = require("date-fns/addDays");
var _addDaysDefault = parcelHelpers.interopDefault(_addDays);
var _subDays = require("date-fns/subDays");
var _subDaysDefault = parcelHelpers.interopDefault(_subDays);
var DATE_FNS_LOCALE_MAP = {
    "fr-FR": (0, _frDefault.default),
    "es-ES": (0, _esDefault.default),
    "it-IT": (0, _itDefault.default),
    "en-US": (0, _enUSDefault.default)
};
var MERIDIAN_DATE_FORMAT = "yyyy-MM-dd";
var formatDate = function(dateObj, dateFormat, locale) {
    return (0, _formatDefault.default)(dateObj, dateFormat, locale && DATE_FNS_LOCALE_MAP[locale] ? {
        locale: DATE_FNS_LOCALE_MAP[locale]
    } : {});
};
var formatDateInTimezone = function(dateObj, dateFormat, locale) {
    if (!dateObj) return null;
    var formattedDate = (0, _dateFnsTz.formatInTimeZone)(dateObj, Intl.DateTimeFormat().resolvedOptions().timeZone, dateFormat, locale && DATE_FNS_LOCALE_MAP[locale] ? {
        locale: DATE_FNS_LOCALE_MAP[locale]
    } : {});
    return formattedDate;
};
var getTimeZone = function() {
    return new Date().toLocaleTimeString("en-us", {
        timeZoneName: "short"
    }).split(" ")[2];
};
var isBlockedDateInCalendar = function(date, startDate, maxFutureAllowedDays, maxPastAllowedDays) {
    var parsedStartDate = (0, _parseDefault.default)(startDate, MERIDIAN_DATE_FORMAT, new Date());
    var parsedEndDate = (0, _parseDefault.default)(date, MERIDIAN_DATE_FORMAT, new Date());
    var nextMaximumFutureAllowedDate = (0, _addDaysDefault.default)(parsedStartDate, maxFutureAllowedDays);
    var nextMaximumPastAllowedDate = (0, _subDaysDefault.default)(parsedStartDate, maxPastAllowedDays);
    return (0, _isAfterDefault.default)(parsedEndDate, nextMaximumFutureAllowedDate) || (0, _dateFns.isBefore)(parsedEndDate, nextMaximumPastAllowedDate);
};

},{"date-fns-tz":"43K2R","date-fns/format":"b9DSZ","date-fns/locale/fr":"26FQf","date-fns/locale/es":"79bz9","date-fns/locale/it":"8hoz9","date-fns/locale/en-US":"gUDTl","date-fns":"fzDXE","date-fns/isAfter":"l2ElT","date-fns/parse":"252RG","date-fns/addDays":"eocuc","date-fns/subDays":"gTu4p","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43K2R":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "formatInTimeZone", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "getTimezoneOffset", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "utcToZonedTime", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "zonedTimeToUtc", ()=>(0, _indexJsDefault5.default));
var _indexJs = require("./format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatInTimeZone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./getTimezoneOffset/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./toDate/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./utcToZonedTime/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./zonedTimeToUtc/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);

},{"./format/index.js":false,"./formatInTimeZone/index.js":"2nk7a","./getTimezoneOffset/index.js":false,"./toDate/index.js":false,"./utcToZonedTime/index.js":false,"./zonedTimeToUtc/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9K4Uj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("date-fns/format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match(tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, _indexJsDefault2.default)(dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, _indexJsDefault1.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, _indexJsDefault.default)(dirtyDate, formatStr, options);
}

},{"date-fns/format/index.js":"aUsXt","./formatters/index.js":"beoLK","../toDate/index.js":"hI5JN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUsXt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a98e38c995f3533e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = format;
var _index = _interopRequireDefault(require("b5473fb4df81d536"));
var _index2 = _interopRequireDefault(require("9cb6ab658136da6"));
var _index3 = _interopRequireDefault(require("a3be2b285cb1b177"));
var _index4 = _interopRequireDefault(require("188c84d4045b6f8c"));
var _index5 = _interopRequireDefault(require("52609f954c40cb47"));
var _index6 = _interopRequireDefault(require("a1ac1aa8754cb504"));
var _index7 = require("49e02d8906c01ba5");
var _index8 = _interopRequireDefault(require("75d4c9218912c5f1"));
var _index9 = _interopRequireDefault(require("322bdc75b8564357"));
var _index10 = require("cf60f6209186c12e");
var _index11 = _interopRequireDefault(require("245aadee0b8a720d"));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _index10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
    var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _index3.default)(dirtyDate);
    if (!(0, _index.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _index6.default)(originalDate);
    var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = _index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = _index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

},{"a98e38c995f3533e":"bgdmM","b5473fb4df81d536":"aGzqc","9cb6ab658136da6":"9CAzK","a3be2b285cb1b177":"4OGJ4","188c84d4045b6f8c":"5qI4O","52609f954c40cb47":"cgjDI","a1ac1aa8754cb504":"kedEg","49e02d8906c01ba5":"7UENF","75d4c9218912c5f1":"lvVsu","322bdc75b8564357":"grDIX","cf60f6209186c12e":"e7HJi","245aadee0b8a720d":"dtHe9"}],"bgdmM":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aGzqc":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("641e153f83b785fc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValid;
var _index = _interopRequireDefault(require("ff6e87732b0957c9"));
var _index2 = _interopRequireDefault(require("ee9cafcacb117e32"));
var _index3 = _interopRequireDefault(require("89e099ab2a55700c"));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(dirtyDate) {
    (0, _index3.default)(1, arguments);
    if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = exports.default;

},{"641e153f83b785fc":"bgdmM","ff6e87732b0957c9":"hrvja","ee9cafcacb117e32":"4OGJ4","89e099ab2a55700c":"grDIX"}],"hrvja":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4c193d175c0b2c36").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isDate;
var _typeof2 = _interopRequireDefault(require("62c87d340f738b3b"));
var _index = _interopRequireDefault(require("fa87f042cb1177e1"));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function isDate(value) {
    (0, _index.default)(1, arguments);
    return value instanceof Date || (0, _typeof2.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
module.exports = exports.default;

},{"4c193d175c0b2c36":"bgdmM","62c87d340f738b3b":"bOGL2","fa87f042cb1177e1":"grDIX"}],"bOGL2":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"grDIX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requiredArgs;
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
module.exports = exports.default;

},{}],"4OGJ4":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5f36b4adaaf28e17").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toDate;
var _typeof2 = _interopRequireDefault(require("cdcbff423c40dd0f"));
var _index = _interopRequireDefault(require("26b626c133140e61"));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    (0, _index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeof2.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = exports.default;

},{"5f36b4adaaf28e17":"bgdmM","cdcbff423c40dd0f":"bOGL2","26b626c133140e61":"grDIX"}],"9CAzK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("dd048806052a8c8e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subMilliseconds;
var _index = _interopRequireDefault(require("d7791bb4ac50b085"));
var _index2 = _interopRequireDefault(require("946abb8e497c9755"));
var _index3 = _interopRequireDefault(require("d738b819519556a7"));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index2.default)(2, arguments);
    var amount = (0, _index3.default)(dirtyAmount);
    return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

},{"dd048806052a8c8e":"bgdmM","d7791bb4ac50b085":"72F8k","946abb8e497c9755":"grDIX","d738b819519556a7":"lvVsu"}],"72F8k":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f4e910182137eea0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addMilliseconds;
var _index = _interopRequireDefault(require("dc4971cb195f3856"));
var _index2 = _interopRequireDefault(require("6780e23b78698c99"));
var _index3 = _interopRequireDefault(require("67a50d4b949d8288"));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var timestamp = (0, _index2.default)(dirtyDate).getTime();
    var amount = (0, _index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = exports.default;

},{"f4e910182137eea0":"bgdmM","dc4971cb195f3856":"lvVsu","6780e23b78698c99":"4OGJ4","67a50d4b949d8288":"grDIX"}],"lvVsu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toInteger;
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

},{}],"5qI4O":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b17ca4050a0a373b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("a30f9192a07cb7df"));
var _index2 = _interopRequireDefault(require("c7be6b55e3b2620e"));
var _index3 = _interopRequireDefault(require("c471522e05af0067"));
var _index4 = _interopRequireDefault(require("d0425c5ff01ac938"));
var _index5 = _interopRequireDefault(require("7b014f453a736e21"));
var _index6 = _interopRequireDefault(require("c0cf094305fe97f1"));
var _index7 = _interopRequireDefault(require("6fd0fe72e73da8b9"));
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return _index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _index3.default)(date);
        // Padding
        return (0, _index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return _index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _index4.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _index2.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return _index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _index.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return _index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return _index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return _index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return _index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return _index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index6.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"b17ca4050a0a373b":"bgdmM","a30f9192a07cb7df":"11B8a","c7be6b55e3b2620e":"ksMlW","c471522e05af0067":"aDURN","d0425c5ff01ac938":"4Axkp","7b014f453a736e21":"6AzWm","c0cf094305fe97f1":"iwIWp","6fd0fe72e73da8b9":"1XD1J"}],"11B8a":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9f604f2a4cfdb896").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCDayOfYear;
var _index = _interopRequireDefault(require("f1ab3f2a00a107b9"));
var _index2 = _interopRequireDefault(require("bcc5cf5ed4d18d3e"));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

},{"9f604f2a4cfdb896":"bgdmM","f1ab3f2a00a107b9":"4OGJ4","bcc5cf5ed4d18d3e":"grDIX"}],"ksMlW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("dbda0f16b7ccbfd4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeek;
var _index = _interopRequireDefault(require("15a2a082ae48606b"));
var _index2 = _interopRequireDefault(require("2476a71ae870ef4d"));
var _index3 = _interopRequireDefault(require("af4b2584e12a2bc5"));
var _index4 = _interopRequireDefault(require("59d0e536a5ca5ac"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"dbda0f16b7ccbfd4":"bgdmM","15a2a082ae48606b":"4OGJ4","2476a71ae870ef4d":"7eJJW","af4b2584e12a2bc5":"fZ0jJ","59d0e536a5ca5ac":"grDIX"}],"7eJJW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("95363b04d45f29b2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeek;
var _index = _interopRequireDefault(require("fcbca9e0914de18"));
var _index2 = _interopRequireDefault(require("6c5ee53941fa8f5a"));
function startOfUTCISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"95363b04d45f29b2":"bgdmM","fcbca9e0914de18":"4OGJ4","6c5ee53941fa8f5a":"grDIX"}],"fZ0jJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9b692c0ae53d47c4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(require("105ec017646b2cf2"));
var _index2 = _interopRequireDefault(require("ccb91dec31bea451"));
var _index3 = _interopRequireDefault(require("8c4668fb272debd1"));
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _index2.default)(fourthOfJanuary);
    return date;
}
module.exports = exports.default;

},{"9b692c0ae53d47c4":"bgdmM","105ec017646b2cf2":"aDURN","ccb91dec31bea451":"7eJJW","8c4668fb272debd1":"grDIX"}],"aDURN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8614cbbac774c655").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeekYear;
var _index = _interopRequireDefault(require("f0d0aa9983f388a9"));
var _index2 = _interopRequireDefault(require("bd3161af858a5338"));
var _index3 = _interopRequireDefault(require("2d266f1cb5305b69"));
function getUTCISOWeekYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"8614cbbac774c655":"bgdmM","f0d0aa9983f388a9":"4OGJ4","bd3161af858a5338":"grDIX","2d266f1cb5305b69":"7eJJW"}],"4Axkp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8ec64864fe627d47").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeek;
var _index = _interopRequireDefault(require("731678606724c8f2"));
var _index2 = _interopRequireDefault(require("5d27a270e13bfc3a"));
var _index3 = _interopRequireDefault(require("8cec471cde2804fd"));
var _index4 = _interopRequireDefault(require("3f5476b7ec5c0ea8"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"8ec64864fe627d47":"bgdmM","731678606724c8f2":"4OGJ4","5d27a270e13bfc3a":"i1us7","8cec471cde2804fd":"5UhuW","3f5476b7ec5c0ea8":"grDIX"}],"i1us7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("961b98cbd3b1264a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeek;
var _index = _interopRequireDefault(require("6a4dcc05fc5343d7"));
var _index2 = _interopRequireDefault(require("880e741e62f45f70"));
var _index3 = _interopRequireDefault(require("87c78786a1dc218d"));
var _index4 = require("72697f1d676b157d");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"961b98cbd3b1264a":"bgdmM","6a4dcc05fc5343d7":"4OGJ4","880e741e62f45f70":"grDIX","87c78786a1dc218d":"lvVsu","72697f1d676b157d":"e7HJi"}],"e7HJi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{}],"5UhuW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2c8f7e3cb230c5fa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeekYear;
var _index = _interopRequireDefault(require("4dfa8a662424f706"));
var _index2 = _interopRequireDefault(require("abc86a30d5a3e59f"));
var _index3 = _interopRequireDefault(require("87b236b5608a8c21"));
var _index4 = _interopRequireDefault(require("d2362eba3b04172f"));
var _index5 = require("c4330e143015079b");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _index3.default)(firstWeek, options);
    return date;
}
module.exports = exports.default;

},{"2c8f7e3cb230c5fa":"bgdmM","4dfa8a662424f706":"6AzWm","abc86a30d5a3e59f":"grDIX","87b236b5608a8c21":"i1us7","d2362eba3b04172f":"lvVsu","c4330e143015079b":"e7HJi"}],"6AzWm":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7bf4a84a7e1af5e4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeekYear;
var _index = _interopRequireDefault(require("8617cedafbd50a64"));
var _index2 = _interopRequireDefault(require("7df38ff033110a76"));
var _index3 = _interopRequireDefault(require("3c8b45cec3befaad"));
var _index4 = _interopRequireDefault(require("34119aa88038f909"));
var _index5 = require("e3bac03bf942ca6c");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"7bf4a84a7e1af5e4":"bgdmM","8617cedafbd50a64":"4OGJ4","7df38ff033110a76":"grDIX","3c8b45cec3befaad":"i1us7","34119aa88038f909":"lvVsu","e3bac03bf942ca6c":"e7HJi"}],"iwIWp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
module.exports = exports.default;

},{}],"1XD1J":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("eb085ad47d69f777").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("900ee4a02d1d303c"));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
    }
};
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"eb085ad47d69f777":"bgdmM","900ee4a02d1d303c":"iwIWp"}],"cgjDI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;

},{}],"kedEg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

},{}],"7UENF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{}],"dtHe9":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("474974e8e6338cdb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("7f87abbaf8084b8d"));
var _default = _index.default;
exports.default = _default;
module.exports = exports.default;

},{"474974e8e6338cdb":"bgdmM","7f87abbaf8084b8d":"72trQ"}],"72trQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7f80ca2527503ba5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("453594d885759083"));
var _index2 = _interopRequireDefault(require("449951c0ea18fd49"));
var _index3 = _interopRequireDefault(require("27c4d15604ffcd77"));
var _index4 = _interopRequireDefault(require("aa281ef3031832ae"));
var _index5 = _interopRequireDefault(require("52fed2843376bdde"));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: _index.default,
    formatLong: _index2.default,
    formatRelative: _index3.default,
    localize: _index4.default,
    match: _index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var _default = locale;
exports.default = _default;
module.exports = exports.default;

},{"7f80ca2527503ba5":"bgdmM","453594d885759083":"jbeu5","449951c0ea18fd49":"4ThuO","27c4d15604ffcd77":"7nunS","aa281ef3031832ae":"byvJp","52fed2843376bdde":"2KPY7"}],"jbeu5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var _default = formatDistance;
exports.default = _default;
module.exports = exports.default;

},{}],"4ThuO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("44f1af5e07e638ea").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("267b9827de66b6c7"));
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _index.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _index.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _index.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
var _default = formatLong;
exports.default = _default;
module.exports = exports.default;

},{"44f1af5e07e638ea":"bgdmM","267b9827de66b6c7":"jMtyj"}],"jMtyj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildFormatLongFn;
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = exports.default;

},{}],"7nunS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
var _default = formatRelative;
exports.default = _default;
module.exports = exports.default;

},{}],"byvJp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("739f0fc95b8b35e4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("ac947941a773c1a"));
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _index.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _index.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _index.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _index.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _index.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var _default = localize;
exports.default = _default;
module.exports = exports.default;

},{"739f0fc95b8b35e4":"bgdmM","ac947941a773c1a":"32t2L"}],"32t2L":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildLocalizeFn;
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = exports.default;

},{}],"2KPY7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("42eef49daf92a054").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("d5af416791e254c4"));
var _index2 = _interopRequireDefault(require("b187ecbaa1b682af"));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _index2.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _index.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _index.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _index.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _index.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _index.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var _default = match;
exports.default = _default;
module.exports = exports.default;

},{"42eef49daf92a054":"bgdmM","d5af416791e254c4":"eQ8sg","b187ecbaa1b682af":"37Ph8"}],"eQ8sg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchFn;
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = exports.default;

},{}],"37Ph8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = exports.default;

},{}],"beoLK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../_lib/tzIntlTimeZoneName/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../_lib/tzParseTimezone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_MINUTE = 60000;
var formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        var originalDate = options._originalDate || date;
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return (0, _indexJsDefault.default)("short", originalDate, options);
            // Long
            case "zzzz":
            default:
                return (0, _indexJsDefault.default)("long", originalDate, options);
        }
    }
};
function getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, _indexJsDefault1.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError("Invalid time zone specified: " + timeZone);
    return timeZoneOffset;
}
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
function formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimeter);
}
function formatTimezoneShort(offset, dirtyDelimeter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimeter = dirtyDelimeter || "";
    return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}
exports.default = formatters;

},{"../../_lib/tzIntlTimeZoneName/index.js":"a4kHB","../../_lib/tzParseTimezone/index.js":"eF5XR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a4kHB":[function(require,module,exports) {
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzIntlTimeZoneName);
function tzIntlTimeZoneName(length, date, options) {
    var dtf = getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}
function partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === "timeZoneName") return formatted[i].value;
    }
}
function hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : "";
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        "en-US"
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eF5XR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzParseTimezone);
var _indexJs = require("../tzTokenizeDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../newDateUTC/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone(hours)) return NaN;
        return -(hours * MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        var minutes = parseInt(token[2], 10);
        if (!validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
        return hours > 0 ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : toUtcDate(date);
        var offset = calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function toUtcDate(date) {
    return (0, _indexJsDefault1.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
    var tokens = (0, _indexJsDefault.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, _indexJsDefault1.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
    if (validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

},{"../tzTokenizeDate/index.js":"5lbU2","../newDateUTC/index.js":"kU0dT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5lbU2":[function(require,module,exports) {
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzTokenizeDate);
function tzTokenizeDate(date, timeZone) {
    var dtf = getDateTimeFormat(timeZone);
    return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
var typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {};
function getDateTimeFormat(timeZone) {
    if (!dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: "America/New_York",
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return dtfCache[timeZone];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kU0dT":[function(require,module,exports) {
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newDateUTC);
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hI5JN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _indexJs = require("date-fns/_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/tzPattern/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, _indexJsDefault3.default)
};
function toDate(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _indexJsDefault.default)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") return new Date(argument);
    else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, _indexJsDefault2.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time));
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function splitDateString(dateString) {
    var dateStrings = {};
    var parts = patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var patternYYY = patterns.YYY[additionalDigits];
    var patternYYYYY = patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!validateWeekDate(year, week)) return new Date(NaN);
        return dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!validateTime(hours)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!validateTime(hours, minutes)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = isLeapYearIndex(year);
        if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

},{"date-fns/_lib/toInteger/index.js":"lvVsu","date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js":"kedEg","../_lib/tzParseTimezone/index.js":"eF5XR","../_lib/tzPattern/index.js":"jEpIP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jEpIP":[function(require,module,exports) {
/** Regex to identify the presence of a time zone specifier in a date string */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
exports.default = tzPattern;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nk7a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatInTimeZone);
var _indexJs = require("date-fns/_lib/cloneObject/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../format/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../utcToZonedTime/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatInTimeZone(date, timeZone, formatStr, options) {
    var extendedOptions = (0, _indexJsDefault.default)(options);
    extendedOptions.timeZone = timeZone;
    return (0, _indexJsDefault1.default)((0, _indexJsDefault2.default)(date, timeZone), formatStr, extendedOptions);
}

},{"date-fns/_lib/cloneObject/index.js":"bPOxo","../format/index.js":"9K4Uj","../utcToZonedTime/index.js":"4DkPN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPOxo":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("83e402fbf7cdb6fb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cloneObject;
var _index = _interopRequireDefault(require("273666816426a0da"));
function cloneObject(object) {
    return (0, _index.default)({}, object);
}
module.exports = exports.default;

},{"83e402fbf7cdb6fb":"bgdmM","273666816426a0da":"eEKFn"}],"eEKFn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = assign;
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = exports.default;

},{}],"4DkPN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcToZonedTime);
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function utcToZonedTime(dirtyDate, timeZone, options) {
    var date = (0, _indexJsDefault1.default)(dirtyDate, options);
    var offsetMilliseconds = (0, _indexJsDefault.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

},{"../_lib/tzParseTimezone/index.js":"eF5XR","../toDate/index.js":"hI5JN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9DSZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"7QFv9","../subMilliseconds/index.js":"8zyDj","../toDate/index.js":"iFBHH","../_lib/format/formatters/index.js":"l2Mku","../_lib/format/longFormatters/index.js":"9wtda","../_lib/getTimezoneOffsetInMilliseconds/index.js":"k3vm9","../_lib/protectedTokens/index.js":"2jtNP","../_lib/toInteger/index.js":"dtPsm","../_lib/requiredArgs/index.js":"jbEgO","../_lib/defaultOptions/index.js":"jhGjX","../_lib/defaultLocale/index.js":"4z9dz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QFv9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"4JSM6","../toDate/index.js":"iFBHH","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4JSM6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"@babel/runtime/helpers/esm/typeof":"lxQ1b","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbEgO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFBHH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"lxQ1b","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8zyDj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"650rj","../_lib/requiredArgs/index.js":"jbEgO","../_lib/toInteger/index.js":"dtPsm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"650rj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"dtPsm","../toDate/index.js":"iFBHH","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dtPsm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2Mku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"cFtOm","../../../_lib/getUTCISOWeek/index.js":"2mugz","../../../_lib/getUTCISOWeekYear/index.js":"7JyfR","../../../_lib/getUTCWeek/index.js":"g62DL","../../../_lib/getUTCWeekYear/index.js":"1hOCG","../../addLeadingZeros/index.js":"8Qxv4","../lightFormatters/index.js":"2VjNa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFtOm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mugz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"iFBHH","../startOfUTCISOWeek/index.js":"ksGwR","../startOfUTCISOWeekYear/index.js":"8afzb","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ksGwR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8afzb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"7JyfR","../startOfUTCISOWeek/index.js":"ksGwR","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JyfR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","../startOfUTCISOWeek/index.js":"ksGwR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g62DL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"iFBHH","../startOfUTCWeek/index.js":"90AOX","../startOfUTCWeekYear/index.js":"feKtm","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"90AOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","../toInteger/index.js":"dtPsm","../defaultOptions/index.js":"jhGjX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jhGjX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"feKtm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"1hOCG","../requiredArgs/index.js":"jbEgO","../startOfUTCWeek/index.js":"90AOX","../toInteger/index.js":"dtPsm","../defaultOptions/index.js":"jhGjX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1hOCG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","../startOfUTCWeek/index.js":"90AOX","../toInteger/index.js":"dtPsm","../defaultOptions/index.js":"jhGjX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Qxv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2VjNa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"8Qxv4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9wtda":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3vm9":[function(require,module,exports) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jtNP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4z9dz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"gUDTl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gUDTl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"f2Pfd","./_lib/formatLong/index.js":"3bdml","./_lib/formatRelative/index.js":"f2Xme","./_lib/localize/index.js":"1B2u5","./_lib/match/index.js":"5JtIQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2Pfd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bdml":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"3f2s9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3f2s9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2Xme":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1B2u5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"bGAS2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bGAS2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5JtIQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"9525U","../../../_lib/buildMatchPatternFn/index.js":"7wDe9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9525U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wDe9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26FQf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var locale = {
    code: "fr",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2FwRN","./_lib/formatLong/index.js":"7DtmV","./_lib/formatRelative/index.js":"3chiW","./_lib/localize/index.js":"bhWyX","./_lib/match/index.js":"3ddug","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2FwRN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7DtmV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"3f2s9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3chiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bhWyX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
var dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return "0";
    var feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"bGAS2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ddug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"9525U","../../../_lib/buildMatchPatternFn/index.js":"7wDe9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"79bz9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: "es",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9t92x","./_lib/formatLong/index.js":"6RaqP","./_lib/formatRelative/index.js":"he00p","./_lib/localize/index.js":"FJ9tS","./_lib/match/index.js":"lDkCC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9t92x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RaqP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"3f2s9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"he00p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    else return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FJ9tS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
var dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"bGAS2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lDkCC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"7wDe9","../../../_lib/buildMatchFn/index.js":"9525U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8hoz9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var locale = {
    code: "it",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jKzUh","./_lib/formatLong/index.js":"lcPXv","./_lib/formatRelative/index.js":"hXczV","./_lib/localize/index.js":"4ewSH","./_lib/match/index.js":"geqPl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKzUh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lcPXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"3f2s9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hXczV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function _lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + weekdays[day] + " scorso alle' p";
    }
}
function thisWeek(day) {
    return "'" + weekdays[day] + " alle' p";
}
function _nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + weekdays[day] + " prossimo alle' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: "P"
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"5Qw47","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Qw47":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameUTCWeek);
var _indexJs = require("../requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault.default)(2, arguments);
    var dateLeftStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

},{"../requiredArgs/index.js":"jbEgO","../startOfUTCWeek/index.js":"90AOX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ewSH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
var dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"bGAS2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"geqPl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"9525U","../../../_lib/buildMatchPatternFn/index.js":"7wDe9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fzDXE":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "addBusinessDays", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "addDays", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "addHours", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "addISOWeekYears", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "addMilliseconds", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "addMinutes", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "addMonths", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "addQuarters", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "addSeconds", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "addWeeks", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "addYears", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "areIntervalsOverlapping", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "closestIndexTo", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "closestTo", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "compareAsc", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "compareDesc", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "daysToWeeks", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "differenceInBusinessDays", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "differenceInCalendarDays", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "differenceInCalendarQuarters", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "differenceInCalendarWeeks", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "differenceInCalendarYears", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "differenceInDays", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "differenceInHours", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "differenceInISOWeekYears", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "differenceInMilliseconds", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "differenceInMinutes", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "differenceInMonths", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "differenceInQuarters", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "differenceInSeconds", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "differenceInWeeks", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "differenceInYears", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "eachDayOfInterval", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "eachHourOfInterval", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "eachMinuteOfInterval", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "eachMonthOfInterval", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "eachQuarterOfInterval", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "eachWeekOfInterval", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "eachWeekendOfInterval", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "eachWeekendOfMonth", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "eachWeekendOfYear", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "eachYearOfInterval", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "endOfDay", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "endOfDecade", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "endOfHour", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "endOfISOWeek", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "endOfISOWeekYear", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "endOfMinute", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "endOfMonth", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "endOfQuarter", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "endOfSecond", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "endOfToday", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "endOfTomorrow", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "endOfWeek", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "endOfYear", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "endOfYesterday", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "format", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "formatDistance", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "formatDistanceStrict", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "formatDistanceToNow", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "formatDistanceToNowStrict", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "formatDuration", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "formatISO", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "formatISO9075", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "formatISODuration", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "formatRFC3339", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "formatRFC7231", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "formatRelative", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "fromUnixTime", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "getDate", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "getDay", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "getDayOfYear", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "getDaysInMonth", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "getDaysInYear", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "getDecade", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "getDefaultOptions", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "getHours", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "getISODay", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "getISOWeek", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "getISOWeekYear", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "getISOWeeksInYear", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "getMilliseconds", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "getMinutes", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "getMonth", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "getQuarter", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "getSeconds", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "getTime", ()=>(0, _indexJsDefault92.default));
parcelHelpers.export(exports, "getUnixTime", ()=>(0, _indexJsDefault93.default));
parcelHelpers.export(exports, "getWeek", ()=>(0, _indexJsDefault94.default));
parcelHelpers.export(exports, "getWeekOfMonth", ()=>(0, _indexJsDefault95.default));
parcelHelpers.export(exports, "getWeekYear", ()=>(0, _indexJsDefault96.default));
parcelHelpers.export(exports, "getWeeksInMonth", ()=>(0, _indexJsDefault97.default));
parcelHelpers.export(exports, "getYear", ()=>(0, _indexJsDefault98.default));
parcelHelpers.export(exports, "hoursToMilliseconds", ()=>(0, _indexJsDefault99.default));
parcelHelpers.export(exports, "hoursToMinutes", ()=>(0, _indexJsDefault100.default));
parcelHelpers.export(exports, "hoursToSeconds", ()=>(0, _indexJsDefault101.default));
parcelHelpers.export(exports, "intervalToDuration", ()=>(0, _indexJsDefault102.default));
parcelHelpers.export(exports, "intlFormat", ()=>(0, _indexJsDefault103.default));
parcelHelpers.export(exports, "intlFormatDistance", ()=>(0, _indexJsDefault104.default));
parcelHelpers.export(exports, "isAfter", ()=>(0, _indexJsDefault105.default));
parcelHelpers.export(exports, "isBefore", ()=>(0, _indexJsDefault106.default));
parcelHelpers.export(exports, "isDate", ()=>(0, _indexJsDefault107.default));
parcelHelpers.export(exports, "isEqual", ()=>(0, _indexJsDefault108.default));
parcelHelpers.export(exports, "isExists", ()=>(0, _indexJsDefault109.default));
parcelHelpers.export(exports, "isFirstDayOfMonth", ()=>(0, _indexJsDefault110.default));
parcelHelpers.export(exports, "isFriday", ()=>(0, _indexJsDefault111.default));
parcelHelpers.export(exports, "isFuture", ()=>(0, _indexJsDefault112.default));
parcelHelpers.export(exports, "isLastDayOfMonth", ()=>(0, _indexJsDefault113.default));
parcelHelpers.export(exports, "isLeapYear", ()=>(0, _indexJsDefault114.default));
parcelHelpers.export(exports, "isMatch", ()=>(0, _indexJsDefault115.default));
parcelHelpers.export(exports, "isMonday", ()=>(0, _indexJsDefault116.default));
parcelHelpers.export(exports, "isPast", ()=>(0, _indexJsDefault117.default));
parcelHelpers.export(exports, "isSameDay", ()=>(0, _indexJsDefault118.default));
parcelHelpers.export(exports, "isSameHour", ()=>(0, _indexJsDefault119.default));
parcelHelpers.export(exports, "isSameISOWeek", ()=>(0, _indexJsDefault120.default));
parcelHelpers.export(exports, "isSameISOWeekYear", ()=>(0, _indexJsDefault121.default));
parcelHelpers.export(exports, "isSameMinute", ()=>(0, _indexJsDefault122.default));
parcelHelpers.export(exports, "isSameMonth", ()=>(0, _indexJsDefault123.default));
parcelHelpers.export(exports, "isSameQuarter", ()=>(0, _indexJsDefault124.default));
parcelHelpers.export(exports, "isSameSecond", ()=>(0, _indexJsDefault125.default));
parcelHelpers.export(exports, "isSameWeek", ()=>(0, _indexJsDefault126.default));
parcelHelpers.export(exports, "isSameYear", ()=>(0, _indexJsDefault127.default));
parcelHelpers.export(exports, "isSaturday", ()=>(0, _indexJsDefault128.default));
parcelHelpers.export(exports, "isSunday", ()=>(0, _indexJsDefault129.default));
parcelHelpers.export(exports, "isThisHour", ()=>(0, _indexJsDefault130.default));
parcelHelpers.export(exports, "isThisISOWeek", ()=>(0, _indexJsDefault131.default));
parcelHelpers.export(exports, "isThisMinute", ()=>(0, _indexJsDefault132.default));
parcelHelpers.export(exports, "isThisMonth", ()=>(0, _indexJsDefault133.default));
parcelHelpers.export(exports, "isThisQuarter", ()=>(0, _indexJsDefault134.default));
parcelHelpers.export(exports, "isThisSecond", ()=>(0, _indexJsDefault135.default));
parcelHelpers.export(exports, "isThisWeek", ()=>(0, _indexJsDefault136.default));
parcelHelpers.export(exports, "isThisYear", ()=>(0, _indexJsDefault137.default));
parcelHelpers.export(exports, "isThursday", ()=>(0, _indexJsDefault138.default));
parcelHelpers.export(exports, "isToday", ()=>(0, _indexJsDefault139.default));
parcelHelpers.export(exports, "isTomorrow", ()=>(0, _indexJsDefault140.default));
parcelHelpers.export(exports, "isTuesday", ()=>(0, _indexJsDefault141.default));
parcelHelpers.export(exports, "isValid", ()=>(0, _indexJsDefault142.default));
parcelHelpers.export(exports, "isWednesday", ()=>(0, _indexJsDefault143.default));
parcelHelpers.export(exports, "isWeekend", ()=>(0, _indexJsDefault144.default));
parcelHelpers.export(exports, "isWithinInterval", ()=>(0, _indexJsDefault145.default));
parcelHelpers.export(exports, "isYesterday", ()=>(0, _indexJsDefault146.default));
parcelHelpers.export(exports, "lastDayOfDecade", ()=>(0, _indexJsDefault147.default));
parcelHelpers.export(exports, "lastDayOfISOWeek", ()=>(0, _indexJsDefault148.default));
parcelHelpers.export(exports, "lastDayOfISOWeekYear", ()=>(0, _indexJsDefault149.default));
parcelHelpers.export(exports, "lastDayOfMonth", ()=>(0, _indexJsDefault150.default));
parcelHelpers.export(exports, "lastDayOfQuarter", ()=>(0, _indexJsDefault151.default));
parcelHelpers.export(exports, "lastDayOfWeek", ()=>(0, _indexJsDefault152.default));
parcelHelpers.export(exports, "lastDayOfYear", ()=>(0, _indexJsDefault153.default));
parcelHelpers.export(exports, "lightFormat", ()=>(0, _indexJsDefault154.default));
parcelHelpers.export(exports, "max", ()=>(0, _indexJsDefault155.default));
parcelHelpers.export(exports, "milliseconds", ()=>(0, _indexJsDefault156.default));
parcelHelpers.export(exports, "millisecondsToHours", ()=>(0, _indexJsDefault157.default));
parcelHelpers.export(exports, "millisecondsToMinutes", ()=>(0, _indexJsDefault158.default));
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>(0, _indexJsDefault159.default));
parcelHelpers.export(exports, "min", ()=>(0, _indexJsDefault160.default));
parcelHelpers.export(exports, "minutesToHours", ()=>(0, _indexJsDefault161.default));
parcelHelpers.export(exports, "minutesToMilliseconds", ()=>(0, _indexJsDefault162.default));
parcelHelpers.export(exports, "minutesToSeconds", ()=>(0, _indexJsDefault163.default));
parcelHelpers.export(exports, "monthsToQuarters", ()=>(0, _indexJsDefault164.default));
parcelHelpers.export(exports, "monthsToYears", ()=>(0, _indexJsDefault165.default));
parcelHelpers.export(exports, "nextDay", ()=>(0, _indexJsDefault166.default));
parcelHelpers.export(exports, "nextFriday", ()=>(0, _indexJsDefault167.default));
parcelHelpers.export(exports, "nextMonday", ()=>(0, _indexJsDefault168.default));
parcelHelpers.export(exports, "nextSaturday", ()=>(0, _indexJsDefault169.default));
parcelHelpers.export(exports, "nextSunday", ()=>(0, _indexJsDefault170.default));
parcelHelpers.export(exports, "nextThursday", ()=>(0, _indexJsDefault171.default));
parcelHelpers.export(exports, "nextTuesday", ()=>(0, _indexJsDefault172.default));
parcelHelpers.export(exports, "nextWednesday", ()=>(0, _indexJsDefault173.default));
parcelHelpers.export(exports, "parse", ()=>(0, _indexJsDefault174.default));
parcelHelpers.export(exports, "parseISO", ()=>(0, _indexJsDefault175.default));
parcelHelpers.export(exports, "parseJSON", ()=>(0, _indexJsDefault176.default));
parcelHelpers.export(exports, "previousDay", ()=>(0, _indexJsDefault177.default));
parcelHelpers.export(exports, "previousFriday", ()=>(0, _indexJsDefault178.default));
parcelHelpers.export(exports, "previousMonday", ()=>(0, _indexJsDefault179.default));
parcelHelpers.export(exports, "previousSaturday", ()=>(0, _indexJsDefault180.default));
parcelHelpers.export(exports, "previousSunday", ()=>(0, _indexJsDefault181.default));
parcelHelpers.export(exports, "previousThursday", ()=>(0, _indexJsDefault182.default));
parcelHelpers.export(exports, "previousTuesday", ()=>(0, _indexJsDefault183.default));
parcelHelpers.export(exports, "previousWednesday", ()=>(0, _indexJsDefault184.default));
parcelHelpers.export(exports, "quartersToMonths", ()=>(0, _indexJsDefault185.default));
parcelHelpers.export(exports, "quartersToYears", ()=>(0, _indexJsDefault186.default));
parcelHelpers.export(exports, "roundToNearestMinutes", ()=>(0, _indexJsDefault187.default));
parcelHelpers.export(exports, "secondsToHours", ()=>(0, _indexJsDefault188.default));
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>(0, _indexJsDefault189.default));
parcelHelpers.export(exports, "secondsToMinutes", ()=>(0, _indexJsDefault190.default));
parcelHelpers.export(exports, "set", ()=>(0, _indexJsDefault191.default));
parcelHelpers.export(exports, "setDate", ()=>(0, _indexJsDefault192.default));
parcelHelpers.export(exports, "setDay", ()=>(0, _indexJsDefault193.default));
parcelHelpers.export(exports, "setDayOfYear", ()=>(0, _indexJsDefault194.default));
parcelHelpers.export(exports, "setDefaultOptions", ()=>(0, _indexJsDefault195.default));
parcelHelpers.export(exports, "setHours", ()=>(0, _indexJsDefault196.default));
parcelHelpers.export(exports, "setISODay", ()=>(0, _indexJsDefault197.default));
parcelHelpers.export(exports, "setISOWeek", ()=>(0, _indexJsDefault198.default));
parcelHelpers.export(exports, "setISOWeekYear", ()=>(0, _indexJsDefault199.default));
parcelHelpers.export(exports, "setMilliseconds", ()=>(0, _indexJsDefault200.default));
parcelHelpers.export(exports, "setMinutes", ()=>(0, _indexJsDefault201.default));
parcelHelpers.export(exports, "setMonth", ()=>(0, _indexJsDefault202.default));
parcelHelpers.export(exports, "setQuarter", ()=>(0, _indexJsDefault203.default));
parcelHelpers.export(exports, "setSeconds", ()=>(0, _indexJsDefault204.default));
parcelHelpers.export(exports, "setWeek", ()=>(0, _indexJsDefault205.default));
parcelHelpers.export(exports, "setWeekYear", ()=>(0, _indexJsDefault206.default));
parcelHelpers.export(exports, "setYear", ()=>(0, _indexJsDefault207.default));
parcelHelpers.export(exports, "startOfDay", ()=>(0, _indexJsDefault208.default));
parcelHelpers.export(exports, "startOfDecade", ()=>(0, _indexJsDefault209.default));
parcelHelpers.export(exports, "startOfHour", ()=>(0, _indexJsDefault210.default));
parcelHelpers.export(exports, "startOfISOWeek", ()=>(0, _indexJsDefault211.default));
parcelHelpers.export(exports, "startOfISOWeekYear", ()=>(0, _indexJsDefault212.default));
parcelHelpers.export(exports, "startOfMinute", ()=>(0, _indexJsDefault213.default));
parcelHelpers.export(exports, "startOfMonth", ()=>(0, _indexJsDefault214.default));
parcelHelpers.export(exports, "startOfQuarter", ()=>(0, _indexJsDefault215.default));
parcelHelpers.export(exports, "startOfSecond", ()=>(0, _indexJsDefault216.default));
parcelHelpers.export(exports, "startOfToday", ()=>(0, _indexJsDefault217.default));
parcelHelpers.export(exports, "startOfTomorrow", ()=>(0, _indexJsDefault218.default));
parcelHelpers.export(exports, "startOfWeek", ()=>(0, _indexJsDefault219.default));
parcelHelpers.export(exports, "startOfWeekYear", ()=>(0, _indexJsDefault220.default));
parcelHelpers.export(exports, "startOfYear", ()=>(0, _indexJsDefault221.default));
parcelHelpers.export(exports, "startOfYesterday", ()=>(0, _indexJsDefault222.default));
parcelHelpers.export(exports, "sub", ()=>(0, _indexJsDefault223.default));
parcelHelpers.export(exports, "subBusinessDays", ()=>(0, _indexJsDefault224.default));
parcelHelpers.export(exports, "subDays", ()=>(0, _indexJsDefault225.default));
parcelHelpers.export(exports, "subHours", ()=>(0, _indexJsDefault226.default));
parcelHelpers.export(exports, "subISOWeekYears", ()=>(0, _indexJsDefault227.default));
parcelHelpers.export(exports, "subMilliseconds", ()=>(0, _indexJsDefault228.default));
parcelHelpers.export(exports, "subMinutes", ()=>(0, _indexJsDefault229.default));
parcelHelpers.export(exports, "subMonths", ()=>(0, _indexJsDefault230.default));
parcelHelpers.export(exports, "subQuarters", ()=>(0, _indexJsDefault231.default));
parcelHelpers.export(exports, "subSeconds", ()=>(0, _indexJsDefault232.default));
parcelHelpers.export(exports, "subWeeks", ()=>(0, _indexJsDefault233.default));
parcelHelpers.export(exports, "subYears", ()=>(0, _indexJsDefault234.default));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJsDefault235.default));
parcelHelpers.export(exports, "weeksToDays", ()=>(0, _indexJsDefault236.default));
parcelHelpers.export(exports, "yearsToMonths", ()=>(0, _indexJsDefault237.default));
parcelHelpers.export(exports, "yearsToQuarters", ()=>(0, _indexJsDefault238.default));
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":false,"./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":false,"./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":false,"./addYears/index.js":false,"./areIntervalsOverlapping/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":false,"./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":false,"./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":false,"./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMonths/index.js":false,"./differenceInQuarters/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":false,"./eachHourOfInterval/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":false,"./endOfDecade/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":false,"./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":false,"./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfToday/index.js":false,"./endOfTomorrow/index.js":false,"./endOfWeek/index.js":false,"./endOfYear/index.js":false,"./endOfYesterday/index.js":false,"./format/index.js":"b9DSZ","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceToNow/index.js":false,"./formatDistanceToNowStrict/index.js":false,"./formatDuration/index.js":false,"./formatISO/index.js":false,"./formatISO9075/index.js":false,"./formatISODuration/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getDefaultOptions/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":false,"./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":false,"./getWeek/index.js":false,"./getWeekOfMonth/index.js":false,"./getWeekYear/index.js":false,"./getWeeksInMonth/index.js":false,"./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./isAfter/index.js":false,"./isBefore/index.js":"9HMdU","./isDate/index.js":false,"./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isFuture/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMonday/index.js":false,"./isPast/index.js":false,"./isSameDay/index.js":false,"./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":false,"./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameYear/index.js":false,"./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThisHour/index.js":false,"./isThisISOWeek/index.js":false,"./isThisMinute/index.js":false,"./isThisMonth/index.js":false,"./isThisQuarter/index.js":false,"./isThisSecond/index.js":false,"./isThisWeek/index.js":false,"./isThisYear/index.js":false,"./isThursday/index.js":false,"./isToday/index.js":false,"./isTomorrow/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":false,"./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":false,"./isYesterday/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":false,"./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":false,"./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":false,"./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":false,"./parseISO/index.js":false,"./parseJSON/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":false,"./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDefaultOptions/index.js":false,"./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":false,"./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekYear/index.js":false,"./setYear/index.js":false,"./startOfDay/index.js":false,"./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":false,"./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":false,"./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfToday/index.js":false,"./startOfTomorrow/index.js":false,"./startOfWeek/index.js":false,"./startOfWeekYear/index.js":false,"./startOfYear/index.js":false,"./startOfYesterday/index.js":false,"./sub/index.js":false,"./subBusinessDays/index.js":false,"./subDays/index.js":false,"./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":false,"./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":false,"./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"./constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eocuc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"dtPsm","../toDate/index.js":"iFBHH","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l2ElT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"iFBHH","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9HMdU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"iFBHH","../_lib/requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"252RG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"lxQ1b","@babel/runtime/helpers/esm/createForOfIteratorHelper":"6xHtO","../_lib/defaultLocale/index.js":"4z9dz","../subMilliseconds/index.js":"8zyDj","../toDate/index.js":"iFBHH","../_lib/assign/index.js":"jo4Tw","../_lib/format/longFormatters/index.js":"9wtda","../_lib/getTimezoneOffsetInMilliseconds/index.js":"k3vm9","../_lib/protectedTokens/index.js":"2jtNP","../_lib/toInteger/index.js":"dtPsm","../_lib/requiredArgs/index.js":"jbEgO","./_lib/Setter.js":"4hRd3","./_lib/parsers/index.js":"33zPl","../_lib/defaultOptions/index.js":"jhGjX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6xHtO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, _unsupportedIterableToArrayJsDefault.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"718so","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"718so":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
}

},{"./arrayLikeToArray.js":"kvSwK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kvSwK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jo4Tw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4hRd3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/defineProperty":"jNdB2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ddsex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02mEl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"gjEVH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjEVH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iay8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJsDefault.default)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJsDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, result);
    };
}

},{"./getPrototypeOf.js":"3rfId","./isNativeReflectConstruct.js":"fK7GQ","./possibleConstructorReturn.js":"2RipB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3rfId":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fK7GQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2RipB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeofJsDefault.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(self);
}

},{"./typeof.js":"lxQ1b","./assertThisInitialized.js":"ddsex","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lODZ6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fzT9g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, _toPropertyKeyJsDefault.default)(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

},{"./toPropertyKey.js":"gh0Ro","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33zPl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"lyREf","./YearParser.js":"fcmMW","./LocalWeekYearParser.js":"eRE6G","./ISOWeekYearParser.js":"ah2Dq","./ExtendedYearParser.js":"3Z4hr","./QuarterParser.js":"EYKFP","./StandAloneQuarterParser.js":"9tYlc","./MonthParser.js":"82DKT","./StandAloneMonthParser.js":"21b9v","./LocalWeekParser.js":"bYIwa","./ISOWeekParser.js":"g0M6y","./DateParser.js":"2W6qi","./DayOfYearParser.js":"8XL4l","./DayParser.js":"aMAgp","./LocalDayParser.js":"wAmka","./StandAloneLocalDayParser.js":"kegRV","./ISODayParser.js":"72JQ5","./AMPMParser.js":"5xDWa","./AMPMMidnightParser.js":"cnLx6","./DayPeriodParser.js":"5XaxH","./Hour1to12Parser.js":"e5OfZ","./Hour0to23Parser.js":"14oXs","./Hour0To11Parser.js":"1PCOJ","./Hour1To24Parser.js":"gkokI","./MinuteParser.js":"fCuQ2","./SecondParser.js":"8qNZd","./FractionOfSecondParser.js":"6DTF9","./ISOTimezoneWithZParser.js":"90K6R","./ISOTimezoneParser.js":"aSqcT","./TimestampSecondsParser.js":"fgqNt","./TimestampMillisecondsParser.js":"dsToU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lyREf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jtZsg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/defineProperty":"jNdB2","./Setter.js":"4hRd3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fcmMW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dNwmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"e3For","./constants.js":"6XhT2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e3For":[function(require,module,exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6XhT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRE6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","../../../_lib/getUTCWeekYear/index.js":"1hOCG","../../../_lib/startOfUTCWeek/index.js":"90AOX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ah2Dq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","../../../_lib/startOfUTCISOWeek/index.js":"ksGwR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Z4hr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"EYKFP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9tYlc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82DKT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../utils.js":"dNwmT","../Parser.js":"jtZsg","../constants.js":"6XhT2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21b9v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bYIwa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","../../../_lib/setUTCWeek/index.js":"7ZydA","../../../_lib/startOfUTCWeek/index.js":"90AOX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ZydA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"dtPsm","../../toDate/index.js":"iFBHH","../getUTCWeek/index.js":"g62DL","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g0M6y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","../../../_lib/setUTCISOWeek/index.js":"8PXq8","../../../_lib/startOfUTCISOWeek/index.js":"ksGwR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8PXq8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"dtPsm","../../toDate/index.js":"iFBHH","../getUTCISOWeek/index.js":"2mugz","../requiredArgs/index.js":"jbEgO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2W6qi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../utils.js":"dNwmT","../Parser.js":"jtZsg","../constants.js":"6XhT2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XL4l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMAgp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../../../_lib/setUTCDay/index.js":"jHbBu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jHbBu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","../toInteger/index.js":"dtPsm","../defaultOptions/index.js":"jhGjX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wAmka":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","../../../_lib/setUTCDay/index.js":"jHbBu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kegRV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","../../../_lib/setUTCDay/index.js":"jHbBu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"72JQ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","../../../_lib/setUTCISODay/index.js":"haHNH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haHNH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"iFBHH","../requiredArgs/index.js":"jbEgO","../toInteger/index.js":"dtPsm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xDWa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cnLx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XaxH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e5OfZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14oXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1PCOJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gkokI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fCuQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qNZd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6DTF9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"90K6R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aSqcT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../constants.js":"6XhT2","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fgqNt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dsToU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"lODZ6","@babel/runtime/helpers/esm/createClass":"fzT9g","@babel/runtime/helpers/esm/assertThisInitialized":"ddsex","@babel/runtime/helpers/esm/inherits":"02mEl","@babel/runtime/helpers/esm/createSuper":"4iay8","@babel/runtime/helpers/esm/defineProperty":"jNdB2","../Parser.js":"jtZsg","../utils.js":"dNwmT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gTu4p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subDays);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"eocuc","../_lib/requiredArgs/index.js":"jbEgO","../_lib/toInteger/index.js":"dtPsm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"FqTpe":[function(require,module,exports) {
var constant = require("c3f11ef32309fc98"), createInverter = require("612c2b4a290c49fb"), identity = require("f75120752b57f459");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var invert = createInverter(function(result, value, key) {
    if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
    result[value] = key;
}, constant(identity));
module.exports = invert;

},{"c3f11ef32309fc98":"hGKRd","612c2b4a290c49fb":"38Ov7","f75120752b57f459":"OuBGx"}],"hGKRd":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"38Ov7":[function(require,module,exports) {
var baseInverter = require("20fe1784337effd4");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = createInverter;

},{"20fe1784337effd4":"2CgG7"}],"2CgG7":[function(require,module,exports) {
var baseForOwn = require("5b34ccb60222d3af");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function baseInverter(object, setter, iteratee, accumulator) {
    baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = baseInverter;

},{"5b34ccb60222d3af":"3nSA2"}],"3nSA2":[function(require,module,exports) {
var baseFor = require("2cfb7e7cbd4a180d"), keys = require("fff143d96782af68");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"2cfb7e7cbd4a180d":"ktIuZ","fff143d96782af68":"47F9t"}],"ktIuZ":[function(require,module,exports) {
var createBaseFor = require("7949ca722c4fdfe4");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"7949ca722c4fdfe4":"37TDU"}],"37TDU":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"47F9t":[function(require,module,exports) {
var arrayLikeKeys = require("e871dd7fde0fdbf1"), baseKeys = require("6fc2436e9a740950"), isArrayLike = require("6507e4630625858");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"e871dd7fde0fdbf1":"9wSDp","6fc2436e9a740950":"boRZA","6507e4630625858":"hJDSL"}],"9wSDp":[function(require,module,exports) {
var baseTimes = require("873e3cea73e9b541"), isArguments = require("70be27aefb38af85"), isArray = require("81ed189964969725"), isBuffer = require("b4663e7af6474ca9"), isIndex = require("8926fdd179d146e"), isTypedArray = require("2cc069b32ead6223");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"873e3cea73e9b541":"dWBu3","70be27aefb38af85":"670BN","81ed189964969725":"2NPpZ","b4663e7af6474ca9":"j9X0J","8926fdd179d146e":"iKp01","2cc069b32ead6223":"coZgk"}],"dWBu3":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"670BN":[function(require,module,exports) {
var baseIsArguments = require("d2f5dca50e00e3af"), isObjectLike = require("a4438771a79cccb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"d2f5dca50e00e3af":"h6vVU","a4438771a79cccb9":"awAvi"}],"h6vVU":[function(require,module,exports) {
var baseGetTag = require("f1f0487e69d3ae20"), isObjectLike = require("5cc8ae07f071c0f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"f1f0487e69d3ae20":"l6BTI","5cc8ae07f071c0f8":"awAvi"}],"l6BTI":[function(require,module,exports) {
var Symbol = require("52b8f9b0e7f5205"), getRawTag = require("18982fb0b9749fbd"), objectToString = require("a62d2b53c8a020cb");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"52b8f9b0e7f5205":"6vqNa","18982fb0b9749fbd":"5PdPp","a62d2b53c8a020cb":"i1W5U"}],"6vqNa":[function(require,module,exports) {
var root = require("139183929918ca0c");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"139183929918ca0c":"bHldo"}],"bHldo":[function(require,module,exports) {
var freeGlobal = require("21be49c6f687cbaa");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"21be49c6f687cbaa":"fl1S5"}],"fl1S5":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"5PdPp":[function(require,module,exports) {
var Symbol = require("f6d1a85aed108baa");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"f6d1a85aed108baa":"6vqNa"}],"i1W5U":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"awAvi":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"2NPpZ":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"j9X0J":[function(require,module,exports) {
var root = require("2e3fdad77996d45c"), stubFalse = require("2dbc5d5c856b4972");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"2e3fdad77996d45c":"bHldo","2dbc5d5c856b4972":"8jGWW"}],"8jGWW":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"iKp01":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"coZgk":[function(require,module,exports) {
var baseIsTypedArray = require("58dae5cd32a31491"), baseUnary = require("3ca7aa78f9b81d18"), nodeUtil = require("aed5c6c6e507fa16");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"58dae5cd32a31491":"b74zJ","3ca7aa78f9b81d18":"aRdVr","aed5c6c6e507fa16":"9t8a3"}],"b74zJ":[function(require,module,exports) {
var baseGetTag = require("b5e15054b568f894"), isLength = require("4fa8749466d96b43"), isObjectLike = require("e88b8136a21bf8d8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"b5e15054b568f894":"l6BTI","4fa8749466d96b43":"3gLYG","e88b8136a21bf8d8":"awAvi"}],"3gLYG":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"aRdVr":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"9t8a3":[function(require,module,exports) {
var freeGlobal = require("2ba32a5c19e3b4a6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"2ba32a5c19e3b4a6":"fl1S5"}],"boRZA":[function(require,module,exports) {
var isPrototype = require("9b77837a0babf3f7"), nativeKeys = require("667fecaf66773e1a");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"9b77837a0babf3f7":"eradi","667fecaf66773e1a":"ELCe0"}],"eradi":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"ELCe0":[function(require,module,exports) {
var overArg = require("62770c48033c728d");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"62770c48033c728d":"9ldfa"}],"9ldfa":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"hJDSL":[function(require,module,exports) {
var isFunction = require("3ba014e7c6cb1ed5"), isLength = require("e6eb2d1352bef0b6");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"3ba014e7c6cb1ed5":"jSgNB","e6eb2d1352bef0b6":"3gLYG"}],"jSgNB":[function(require,module,exports) {
var baseGetTag = require("f3cefb9f5d62b8c3"), isObject = require("9035a6661f57a2a7");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"f3cefb9f5d62b8c3":"l6BTI","9035a6661f57a2a7":"7nJGe"}],"7nJGe":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"OuBGx":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"7ZcBY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REPORTS_SHARING_PATH_PREFIX", ()=>REPORTS_SHARING_PATH_PREFIX);
parcelHelpers.export(exports, "REPORTS_LIST_PATH", ()=>REPORTS_LIST_PATH);
parcelHelpers.export(exports, "REPORT_DETAIL_PAGE_PATH", ()=>REPORT_DETAIL_PAGE_PATH);
var REPORTS_SHARING_PATH_PREFIX = "/reports";
var REPORTS_LIST_PATH = "".concat(REPORTS_SHARING_PATH_PREFIX, "/:reportTermPath/:reportTypePath");
var REPORT_DETAIL_PAGE_PATH = "".concat(REPORTS_SHARING_PATH_PREFIX, "/:reportTermPath/:reportTypePath/:reportId");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b2kDX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOWNLOAD_TYPE", ()=>DOWNLOAD_TYPE);
var DOWNLOAD_TYPE = {
    REPORT: "REPORT",
    SUPPORTING_DOCUMENTS: "SUPPORTING_DOCUMENTS",
    ALL: "ALL"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ogp4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>ui);
var _lodash = require("lodash");
var _types = require("../../actions/ui/types");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var initialState = {
    loading: false,
    pendingRequests: [],
    notifications: [],
    form: {},
    currentSelectedTab: ""
};
function ui() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 0, _types.ADD_NOTIFICATION:
            return _object_spread_props(_object_spread({}, state), {
                notifications: _to_consumable_array(state.notifications).concat([
                    action.payload
                ])
            });
        case 0, _types.CLOSE_NOTIFICATION:
            return _object_spread_props(_object_spread({}, state), {
                notifications: state.notifications.filter(function(param) {
                    var id = param.id;
                    return id !== action.payload;
                })
            });
        case 0, _types.START_REQUEST_LOADING:
            return _object_spread_props(_object_spread({}, state), {
                pendingRequests: (0, _lodash.uniq)(_to_consumable_array(state.pendingRequests).concat([
                    action.payload
                ]))
            });
        case 0, _types.END_REQUEST_LOADING:
            return _object_spread_props(_object_spread({}, state), {
                pendingRequests: state.pendingRequests.filter(function(call) {
                    return call !== action.payload;
                })
            });
        case 0, _types.OPEN_UI_MODAL:
            return _object_spread_props(_object_spread({}, state), {
                openedModal: action.payload
            });
        case 0, _types.CLOSE_UI_MODAL:
            return _object_spread_props(_object_spread({}, state), {
                openedModal: {}
            });
        case 0, _types.UPDATE_FORM_VALUE:
            if (action.payload.queryDynamicParameterName.toLowerCase().includes("start")) {
                var _obj;
                return _object_spread_props(_object_spread({}, state), {
                    form: _object_spread_props(_object_spread({}, state.form), (_obj = {}, _define_property(_obj, action.payload.queryDynamicParameterName, {
                        value: action.payload.value,
                        fieldType: action.payload.fieldType
                    }), _define_property(_obj, action.payload.queryDynamicParameterName.replace("START", "END"), {
                        value: [],
                        fieldType: action.payload.fieldType
                    }), _obj))
                });
            }
            return _object_spread_props(_object_spread({}, state), {
                form: _object_spread_props(_object_spread({}, state.form), _define_property({}, action.payload.queryDynamicParameterName, {
                    value: action.payload.value,
                    fieldType: action.payload.fieldType
                }))
            });
        case 0, _types.RESET_FORM_VALUES:
            return _object_spread_props(_object_spread({}, state), {
                form: {}
            });
        case 0, _types.UPDATE_TAB_VALUE:
            return _object_spread_props(_object_spread({}, state), {
                currentSelectedTab: action.payload
            });
        default:
            return state;
    }
}

},{"lodash":"iqbfx","../../actions/ui/types":"hP7mC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iqbfx":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"d3cYD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "generateReportReducer", ()=>generateReportReducer);
var _types = require("../../actions/types");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
var initialState = {
    reportValue: [],
    generateReportError: false,
    isTriggerGenerateReport: false,
    presignedURL: "",
    generatePresignedURLError: false,
    dduList: [],
    csvData: "",
    isTriggerFetchDataFromPresignedURL: false
};
function generateReportReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, _ref = arguments.length > 1 ? arguments[1] : void 0, type = _ref.type, payload = _ref.payload;
    switch(type){
        case 0, _types.GENERATE_REPORT_ASYNC_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                generateReportError: false,
                reportValue: [],
                isTriggerGenerateReport: false
            });
        case 0, _types.GENERATE_REPORT_ASYNC_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                reportValue: payload,
                isTriggerGenerateReport: true
            });
        case 0, _types.GENERATE_REPORT_ASYNC_FAILURE:
            return _object_spread_props(_object_spread({}, state), {
                generateReportError: true,
                reportValue: [],
                isTriggerGenerateReport: true
            });
        case 0, _types.RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC:
            return _object_spread_props(_object_spread({}, state), {
                generateReportError: false,
                isTriggerGenerateReport: false
            });
        case 0, _types.GENERATE_PRESIGNED_URL_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                presignedURL: "",
                generatePresignedURLError: false
            });
        case 0, _types.GENERATE_PRESIGNED_URL_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                presignedURL: payload
            });
        case 0, _types.GENERATE_PRESIGNED_URL_FAILURE:
            return _object_spread_props(_object_spread({}, state), {
                generatePresignedURLError: true
            });
        case 0, _types.SET_DDU_LIST:
            return _object_spread_props(_object_spread({}, state), {
                dduList: payload
            });
        case 0, _types.FETCH_DATA_FROM_PRESIGNED_URL_REQUEST:
            return _object_spread_props(_object_spread({}, state), {
                csvData: "",
                isTriggerFetchDataFromPresignedURL: true
            });
        case 0, _types.FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS:
            return _object_spread_props(_object_spread({}, state), {
                csvData: payload,
                isTriggerFetchDataFromPresignedURL: false
            });
        default:
            return state;
    }
}

},{"../../actions/types":"20R3C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iYcmV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _service = require("./service");
exports.default = {
    api: {
        reportsCenterService: _service
    }
};

},{"./service":"jYLzY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYLzY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchReports", ()=>searchReports);
parcelHelpers.export(exports, "downloadReport", ()=>downloadReport);
parcelHelpers.export(exports, "getTermReportConfigs", ()=>getTermReportConfigs);
parcelHelpers.export(exports, "initiateBatchReportUpload", ()=>initiateBatchReportUpload);
parcelHelpers.export(exports, "completeBatchReportUpload", ()=>completeBatchReportUpload);
parcelHelpers.export(exports, "uploadReport", ()=>uploadReport);
parcelHelpers.export(exports, "deleteReport", ()=>deleteReport);
parcelHelpers.export(exports, "uploadWithS3PresignedUrl", ()=>uploadWithS3PresignedUrl);
parcelHelpers.export(exports, "generateReportAsync", ()=>generateReportAsync);
parcelHelpers.export(exports, "generatePresignedUrl", ()=>generatePresignedUrl);
parcelHelpers.export(exports, "downloadWithS3PresignedUrl", ()=>downloadWithS3PresignedUrl);
parcelHelpers.export(exports, "approveReport", ()=>approveReport);
parcelHelpers.export(exports, "rejectReport", ()=>rejectReport);
var _ajax = require("rxjs/ajax");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _coralComAmazonTransreportscenterservice = require("@amzn/coral_com-amazon-transreportscenterservice");
var _transReportsCenterServiceClient = require("../clients/TransReportsCenterServiceClient");
var _transReportsCenterServiceClientDefault = parcelHelpers.interopDefault(_transReportsCenterServiceClient);
var _isSiteExternal = require("../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function searchReports(param) {
    var term = param.term, reportType = param.reportType, lpAttributesKey = param.lpAttributesKey, pageSize = param.pageSize, logisticsPartyId = param.logisticsPartyId, searchCriteria = param.searchCriteria, sortCriteriaList = param.sortCriteriaList, offset = param.offset;
    var searchReportsInput = (0, _coralComAmazonTransreportscenterservice.SearchReportsInput).clone(_object_spread({
        offset: offset,
        term: term,
        reportType: reportType,
        lpAttributesKey: lpAttributesKey,
        pageSize: pageSize,
        searchCriteria: searchCriteria,
        sortCriteriaList: sortCriteriaList
    }, !(0, _isSiteExternalDefault.default)() ? {
        logisticsPartyId: logisticsPartyId
    } : {}));
    return (0, _transReportsCenterServiceClientDefault.default).searchReports(searchReportsInput);
}
function downloadReport(param) {
    var reportId = param.reportId, reportType = param.reportType, term = param.term, logisticsPartyId = param.logisticsPartyId;
    var downloadReportInput = (0, _coralComAmazonTransreportscenterservice.DownloadReportInput).clone({
        reportId: reportId,
        reportType: reportType,
        term: term,
        logisticsPartyId: logisticsPartyId
    });
    return (0, _transReportsCenterServiceClientDefault.default).downloadReport(downloadReportInput);
}
function getTermReportConfigs() {
    return (0, _transReportsCenterServiceClientDefault.default).getTermReportConfigs({});
}
function initiateBatchReportUpload(initiateBatchReportUploadInput) {
    return (0, _transReportsCenterServiceClientDefault.default).initiateBatchReportUpload(initiateBatchReportUploadInput);
}
function completeBatchReportUpload(completeBatchReportUploadInput) {
    return (0, _transReportsCenterServiceClientDefault.default).completeBatchReportUpload(completeBatchReportUploadInput);
}
function uploadReport(uploadReportInput) {
    return (0, _transReportsCenterServiceClientDefault.default).uploadReport(uploadReportInput);
}
var deleteReport = function(deleteReportInput) {
    return (0, _transReportsCenterServiceClientDefault.default).deleteReport(deleteReportInput);
};
var uploadWithS3PresignedUrl = function(param) {
    var s3presignedUrl = param.s3presignedUrl, file = param.file;
    return (0, _ajax.ajax)({
        method: "PUT",
        url: s3presignedUrl,
        headers: {
            "Content-Type": "application/octet-stream"
        },
        body: file
    }).pipe((0, _operators.map)(function(response) {
        return response;
    }), (0, _operators.catchError)(function(err) {
        return (0, _rxjs.of)(false);
    }));
};
var generateReportAsync = function(generateReportAsyncInput) {
    return (0, _transReportsCenterServiceClientDefault.default).generateReportAsync(generateReportAsyncInput);
};
var generatePresignedUrl = function(generatePresignedUrlInput) {
    return (0, _transReportsCenterServiceClientDefault.default).generatePresignedUrl(generatePresignedUrlInput);
};
var downloadWithS3PresignedUrl = function(param) {
    var presignedUrl = param.presignedUrl;
    return (0, _ajax.ajax)({
        url: presignedUrl,
        headers: {
            "Content-Type": "application/octet-stream"
        },
        responseType: "text"
    }).pipe((0, _operators.map)(function(response) {
        if (response.status !== 200) throw new Error("Network response was not ok");
        var csvData = response.response;
        return csvData;
    }), (0, _operators.catchError)(function() {
        return (0, _rxjs.of)(false);
    }));
};
var approveReport = function(approveReportInput) {
    return (0, _transReportsCenterServiceClientDefault.default).approveReport(approveReportInput);
};
var rejectReport = function(rejectReportInput) {
    return (0, _transReportsCenterServiceClientDefault.default).rejectReport(rejectReportInput);
};

},{"rxjs/ajax":"khMi0","rxjs/operators":"b5gYA","rxjs":"cdYcx","@amzn/coral_com-amazon-transreportscenterservice":"j45ae","../clients/TransReportsCenterServiceClient":"ccIxZ","../utils/isSiteExternal":"9c6XJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khMi0":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ajax", ()=>(0, _ajax.ajax));
parcelHelpers.export(exports, "AjaxResponse", ()=>(0, _ajaxObservable.AjaxResponse));
parcelHelpers.export(exports, "AjaxError", ()=>(0, _ajaxObservable.AjaxError));
parcelHelpers.export(exports, "AjaxTimeoutError", ()=>(0, _ajaxObservable.AjaxTimeoutError));
var _ajax = require("../internal/observable/dom/ajax");
var _ajaxObservable = require("../internal/observable/dom/AjaxObservable");

},{"../internal/observable/dom/ajax":"WLWg6","../internal/observable/dom/AjaxObservable":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"WLWg6":[function(require,module,exports) {
/** PURE_IMPORTS_START _AjaxObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ajax", ()=>ajax);
var _ajaxObservable = require("./AjaxObservable");
var ajax = /*@__PURE__*/ function() {
    return (0, _ajaxObservable.AjaxObservable).create;
}();

},{"./AjaxObservable":"14pCc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14pCc":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_.._util_root,_.._Observable,_.._Subscriber,_.._operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ajaxGet", ()=>ajaxGet);
parcelHelpers.export(exports, "ajaxPost", ()=>ajaxPost);
parcelHelpers.export(exports, "ajaxDelete", ()=>ajaxDelete);
parcelHelpers.export(exports, "ajaxPut", ()=>ajaxPut);
parcelHelpers.export(exports, "ajaxPatch", ()=>ajaxPatch);
parcelHelpers.export(exports, "ajaxGetJSON", ()=>ajaxGetJSON);
parcelHelpers.export(exports, "AjaxObservable", ()=>AjaxObservable);
parcelHelpers.export(exports, "AjaxSubscriber", ()=>AjaxSubscriber);
parcelHelpers.export(exports, "AjaxResponse", ()=>AjaxResponse);
parcelHelpers.export(exports, "AjaxError", ()=>AjaxError);
parcelHelpers.export(exports, "AjaxTimeoutError", ()=>AjaxTimeoutError);
var _tslib = require("tslib");
var _root = require("../../util/root");
var _observable = require("../../Observable");
var _subscriber = require("../../Subscriber");
var _map = require("../../operators/map");
function getCORSRequest() {
    if ((0, _root.root).XMLHttpRequest) return new (0, _root.root).XMLHttpRequest();
    else if (!!(0, _root.root).XDomainRequest) return new (0, _root.root).XDomainRequest();
    else throw new Error("CORS is not supported by your browser");
}
function getXMLHttpRequest() {
    if ((0, _root.root).XMLHttpRequest) return new (0, _root.root).XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                "Msxml2.XMLHTTP",
                "Microsoft.XMLHTTP",
                "Msxml2.XMLHTTP.4.0"
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new (0, _root.root).ActiveXObject(progId);
                break;
            } catch (e) {}
            return new (0, _root.root).ActiveXObject(progId);
        } catch (e) {
            throw new Error("XMLHttpRequest is not supported by your browser");
        }
    }
}
function ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new AjaxObservable({
        method: "GET",
        url: url,
        headers: headers
    });
}
function ajaxPost(url, body, headers) {
    return new AjaxObservable({
        method: "POST",
        url: url,
        body: body,
        headers: headers
    });
}
function ajaxDelete(url, headers) {
    return new AjaxObservable({
        method: "DELETE",
        url: url,
        headers: headers
    });
}
function ajaxPut(url, body, headers) {
    return new AjaxObservable({
        method: "PUT",
        url: url,
        body: body,
        headers: headers
    });
}
function ajaxPatch(url, body, headers) {
    return new AjaxObservable({
        method: "PATCH",
        url: url,
        body: body,
        headers: headers
    });
}
var mapResponse = /*@__PURE__*/ (0, _map.map)(function(x, index) {
    return x.response;
});
function ajaxGetJSON(url, headers) {
    return mapResponse(new AjaxObservable({
        method: "GET",
        url: url,
        responseType: "json",
        headers: headers
    }));
}
var AjaxObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        var _this = _super.call(this) || this;
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? getCORSRequest() : getXMLHttpRequest();
            },
            crossDomain: true,
            withCredentials: false,
            headers: {},
            method: "GET",
            responseType: "json",
            timeout: 0
        };
        if (typeof urlOrRequest === "string") request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        _this.request = request;
        return _this;
    }
    AjaxObservable.prototype._subscribe = function(subscriber) {
        return new AjaxSubscriber(subscriber, this.request);
    };
    AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = ajaxGet;
        create.post = ajaxPost;
        create.delete = ajaxDelete;
        create.put = ajaxPut;
        create.patch = ajaxPatch;
        create.getJSON = ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}((0, _observable.Observable));
var AjaxSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        var _this = _super.call(this, destination) || this;
        _this.request = request;
        _this.done = false;
        var headers = request.headers = request.headers || {};
        if (!request.crossDomain && !_this.getHeader(headers, "X-Requested-With")) headers["X-Requested-With"] = "XMLHttpRequest";
        var contentTypeHeader = _this.getHeader(headers, "Content-Type");
        if (!contentTypeHeader && !((0, _root.root).FormData && request.body instanceof (0, _root.root).FormData) && typeof request.body !== "undefined") headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
        request.body = _this.serializeBody(request.body, _this.getHeader(request.headers, "Content-Type"));
        _this.send();
        return _this;
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var result;
        try {
            result = new AjaxResponse(e, xhr, request);
        } catch (err) {
            return destination.error(err);
        }
        destination.next(result);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        try {
            var xhr = this.xhr = request.createXHR();
            this.setupEvents(xhr, request);
            if (user) xhr.open(method, url, async, user, password);
            else xhr.open(method, url, async);
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ("withCredentials" in xhr) xhr.withCredentials = !!request.withCredentials;
            this.setHeaders(xhr, headers);
            if (body) xhr.send(body);
            else xhr.send();
        } catch (err) {
            this.error(err);
        }
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === "string") return body;
        else if ((0, _root.root).FormData && body instanceof (0, _root.root).FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(";");
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case "application/x-www-form-urlencoded":
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join("&");
            case "application/json":
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.getHeader = function(headers, headerName) {
        for(var key in headers){
            if (key.toLowerCase() === headerName.toLowerCase()) return headers[key];
        }
        return undefined;
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            var error;
            try {
                error = new AjaxTimeoutError(this, request);
            } catch (err) {
                error = err;
            }
            subscriber.error(error);
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && "withCredentials" in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ((0, _root.root).XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                var error;
                try {
                    error = new AjaxError("ajax error", this, request);
                } catch (err) {
                    error = err;
                }
                subscriber.error(error);
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            return;
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
        function xhrLoad(e) {
            var _a = xhrLoad, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === "text" ? this.response || this.responseText : this.response;
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (status_1 < 400) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    var error = void 0;
                    try {
                        error = new AjaxError("ajax error " + status_1, this, request);
                    } catch (err) {
                        error = err;
                    }
                    subscriber.error(error);
                }
            }
        }
        xhr.onload = xhrLoad;
        xhrLoad.subscriber = this;
        xhrLoad.progressSubscriber = progressSubscriber;
        xhrLoad.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === "function") xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}((0, _subscriber.Subscriber));
var AjaxResponse = /*@__PURE__*/ function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
var AjaxErrorImpl = /*@__PURE__*/ function() {
    function AjaxErrorImpl(message, xhr, request) {
        Error.call(this);
        this.message = message;
        this.name = "AjaxError";
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
        return this;
    }
    AjaxErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return AjaxErrorImpl;
}();
var AjaxError = AjaxErrorImpl;
function parseJson(xhr) {
    if ("response" in xhr) return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || "null");
    else return JSON.parse(xhr.responseText || "null");
}
function parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case "json":
            return parseJson(xhr);
        case "xml":
            return xhr.responseXML;
        case "text":
        default:
            return "response" in xhr ? xhr.response : xhr.responseText;
    }
}
function AjaxTimeoutErrorImpl(xhr, request) {
    AjaxError.call(this, "ajax timeout", xhr, request);
    this.name = "AjaxTimeoutError";
    return this;
}
var AjaxTimeoutError = AjaxTimeoutErrorImpl;

},{"tslib":"8E6ff","../../util/root":"2AoEG","../../Observable":"5BalU","../../Subscriber":"bxmZC","../../operators/map":"ddt0B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2AoEG":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>_root);
var global = arguments[3];
var __window = typeof window !== "undefined" && window;
var __self = typeof self !== "undefined" && typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope && self;
var __global = typeof global !== "undefined" && global;
var _root = __window || __global || __self;
/*@__PURE__*/ (function() {
    if (!_root) throw /*@__PURE__*/ new Error("RxJS could not find any global context (window, self, global)");
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ccIxZ":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/no-useless-constructor */ /* eslint-disable import/no-extraneous-dependencies */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonTransreportscenterservice = require("@amzn/coral_com-amazon-transreportscenterservice");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _coralConfigTransReportsCenterService = require("@amzn/coral-config_trans-reports-center-service");
var _passportRequestOptionsInterceptor = require("./PassportRequestOptionsInterceptor");
var _passportRequestOptionsInterceptorDefault = parcelHelpers.interopDefault(_passportRequestOptionsInterceptor);
var _carrierLogisticsRequestOptionsInterceptor = require("./CarrierLogisticsRequestOptionsInterceptor");
var _carrierLogisticsRequestOptionsInterceptorDefault = parcelHelpers.interopDefault(_carrierLogisticsRequestOptionsInterceptor);
var _env = require("../config/env");
var _envDefault = parcelHelpers.interopDefault(_env);
var _externalModulePicker = require("../utils/externalModulePicker");
var _externalModulePickerDefault = parcelHelpers.interopDefault(_externalModulePicker);
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possible_constructor_return(this, result);
    };
}
var ResolvedRequestOptionsInterceptor = (0, _externalModulePickerDefault.default)((0, _carrierLogisticsRequestOptionsInterceptorDefault.default), (0, _passportRequestOptionsInterceptorDefault.default));
var clientFactory = new (0, _ihmJsCoralClient.CoralClientFactory)([
    (0, _coralConfigTransReportsCenterService.TransReportsCenterServiceClientConfigFactory)
], (0, _envDefault.default).getEnv(), new (0, _ihmJsCoralClient.InterceptingHandler)(new (0, _ihmJsCoralClient.CoralFetchHandler)(), [
    (0, _coralComAmazonTransreportscenterservice.transReportsCenterServiceHttpBindingInterceptor),
    new ResolvedRequestOptionsInterceptor()
]));
/**
 * Custom web server to override serialization/deserialization
 */ var CustomWebServer = /*#__PURE__*/ function(TransReportsCenterService) {
    "use strict";
    _inherits(CustomWebServer, TransReportsCenterService);
    var _super = _create_super(CustomWebServer);
    function CustomWebServer(config, handler) {
        _class_call_check(this, CustomWebServer);
        return _super.call(this, config, handler);
    }
    return CustomWebServer;
}((0, _coralComAmazonTransreportscenterservice.TransReportsCenterService));
var TransReportsCenterServiceClient = clientFactory.get(CustomWebServer);
exports.default = TransReportsCenterServiceClient;

},{"@amzn/coral_com-amazon-transreportscenterservice":"j45ae","@amzn/ihm-js-coral-client":"eOj61","@amzn/coral-config_trans-reports-center-service":"9nWO8","./PassportRequestOptionsInterceptor":"8CTEH","./CarrierLogisticsRequestOptionsInterceptor":"9jQwn","../config/env":"kf9Dc","../utils/externalModulePicker":"7Og5j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9nWO8":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transReportsCenterServiceClientConfigFactory = require("./TransReportsCenterServiceClientConfigFactory");
parcelHelpers.exportAll(_transReportsCenterServiceClientConfigFactory, exports);

},{"./TransReportsCenterServiceClientConfigFactory":"50Qdm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"50Qdm":[function(require,module,exports) {
/* This file was automatically generated by CoralTypeScriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransReportsCenterServiceClientConfigFactory", ()=>TransReportsCenterServiceClientConfigFactory);
var _client = require("@amzn/ihm-js-coral-client/client");
const TransReportsCenterServiceClientConfigFactory = new (0, _client.CoralClientConfigFactory)("TransReportsCenterService", {
    "master.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.gamma.trcs.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Gamma": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.gamma.trcs.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "master.passport.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.gamma.passport.transportation.a2z.com/"
        }
    },
    "Base.Beta": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.beta.trcs.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "prod.carrierlogistics.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.amazon.com/"
        }
    },
    "Carrierlogistics.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.integ.amazon.com/"
        }
    },
    Base: {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "prod.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.prod.trcs.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Carrierlogistics.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.amazon.com/"
        }
    },
    "test.carrierlogistics.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics.integ.amazon.com/"
        }
    },
    "master.carrierlogistics.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics-gamma.aka.amazon.com/"
        }
    },
    "Passport.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.beta.passport.transportation.a2z.com/"
        }
    },
    "test.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.beta.trcs.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "prod.passport.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.prod.passport.transportation.a2z.com/"
        }
    },
    "Passport.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.prod.passport.transportation.a2z.com/"
        }
    },
    "Carrierlogistics.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://carrierlogistics-gamma.aka.amazon.com/"
        }
    },
    "UI.Testing.Local": {
        httpEndpoint: {
            url: "http://localhost:3000/"
        }
    },
    "Passport.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.gamma.passport.transportation.a2z.com/"
        }
    },
    "test.passport.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.beta.passport.transportation.a2z.com/"
        }
    },
    "desktop.USAmazon": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "http://127.0.0.1:8080/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Development": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "http://127.0.0.1:8080/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    },
    "Base.Prod": {
        httpClient: {
            clientType: "netty4",
            requestQueueSize: 10,
            allIdleTimeout: 55000,
            connectionTimeout: 5000,
            sslMode: "retail.internal"
        },
        rpc: {
            encoding: "text",
            version: "v1"
        },
        httpEndpoint: {
            url: "https://iad.prod.trcs.transportation.amazon.dev/"
        },
        timeouts: {
            operationTimeouts: {
                "TransReportsCenterService/*": 10000
            }
        },
        inputValidation: {},
        protocols: [
            "rpc"
        ],
        cloudAuth: {
            enabled: "true"
        }
    }
});

},{"@amzn/ihm-js-coral-client/client":"7JSEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8CTEH":[function(require,module,exports) {
/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable no-unused-vars */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _getUser = require("../utils/auth/getUser");
var _getUserDefault = parcelHelpers.interopDefault(_getUser);
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possible_constructor_return(this, result);
    };
}
// This class is used during client construction, and helps to intercept
// the headers during request handling for the passport external App.
var RequestOptionsInterceptorForPassport = /*#__PURE__*/ function(CoralInterceptor) {
    "use strict";
    _inherits(RequestOptionsInterceptorForPassport, CoralInterceptor);
    var _super = _create_super(RequestOptionsInterceptorForPassport);
    function RequestOptionsInterceptorForPassport() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, RequestOptionsInterceptorForPassport);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    _create_class(RequestOptionsInterceptorForPassport, [
        {
            /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
            key: "intercept",
            value: function intercept(request, next) {
                return (0, _rxjs.from)((0, _getUserDefault.default)()).pipe((0, _operators.switchMap)(function(user) {
                    // Adding required header
                    var headers = [
                        [
                            "Accept",
                            "application/json"
                        ],
                        [
                            "Content-Type",
                            "application/json"
                        ]
                    ];
                    // If user is found add auth header
                    if (user) {
                        var authToken = user.id_token;
                        headers.push([
                            "authorization",
                            authToken
                        ]);
                    }
                    var modifiedRequest = request.clone({
                        headers: headers,
                        credentials: "same-origin"
                    });
                    return next.handle(modifiedRequest);
                }), (0, _operators.map)(function(response) {
                    return new (0, _ihmJsCoralClient.CoralResponse)(response);
                }));
            }
        }
    ]);
    return RequestOptionsInterceptorForPassport;
}((0, _ihmJsCoralClient.CoralInterceptor));
exports.default = RequestOptionsInterceptorForPassport;

},{"rxjs":"cdYcx","rxjs/operators":"b5gYA","@amzn/ihm-js-coral-client":"eOj61","../utils/auth/getUser":"gIPHY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gIPHY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jwtDecode = require("jwt-decode");
var _jwtDecodeDefault = parcelHelpers.interopDefault(_jwtDecode);
var _userManager = require("./userManager");
var _userManagerDefault = parcelHelpers.interopDefault(_userManager);
var _signIn = require("./signIn");
var _signInDefault = parcelHelpers.interopDefault(_signIn);
/**
 * Get the expiry of the token
 */ var getTokenExpiry = function(token) {
    var exp = (0, _jwtDecodeDefault.default)(token).exp;
    return exp;
};
/**
 * Checks if the token is expired
 */ var isTokenExpired = function(user) {
    var token = user.id_token;
    var exp = getTokenExpiry(token);
    // Check if current timestamp has exceeded exp timestamp
    var currentDateInSeconds = Math.floor(Date.now() / 1000);
    return currentDateInSeconds >= exp;
};
/**
 * Get the user
 * If the token has expired or user doesn't exists, then sign in the user
 */ var getUser = function() {
    return (0, _userManagerDefault.default)().then(function(userManager) {
        return userManager.getUser();
    }).then(function(user) {
        if (user && !isTokenExpired(user)) return user;
        return (0, _signInDefault.default)();
    });
};
exports.default = getUser;

},{"jwt-decode":"8adPr","./userManager":"1VM8f","./signIn":"3Ux1q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8adPr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidTokenError", ()=>n);
function e(e) {
    this.message = e;
}
e.prototype = new Error, e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent(r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return r(t);
    }
}
function n(e) {
    this.message = e;
}
function o(e, r) {
    if ("string" != typeof e) throw new n("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse(t(e.split(".")[o]));
    } catch (e) {
        throw new n("Invalid token specified: " + e.message);
    }
}
n.prototype = new Error, n.prototype.name = "InvalidTokenError";
exports.default = o;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1VM8f":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/camelcase */ /* eslint-disable import/no-named-as-default */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserManager", ()=>getUserManager);
var _oidcClient = require("oidc-client");
var _routes = require("../../config/routes");
var _getSettings = require("./getSettings");
var _getSettingsDefault = parcelHelpers.interopDefault(_getSettings);
var storedUserManager = null;
/**
 * Store the user manager and return it
 * @param {UserManager} userManager
 * @returns {UserManager}
 */ var storeUserManagerAndReturn = function(userManager) {
    storedUserManager = userManager;
    return userManager;
};
var getUserManager = function() {
    if (storedUserManager) return Promise.resolve(storedUserManager);
    return (0, _getSettingsDefault.default)().then(function(settings) {
        return storeUserManagerAndReturn(new (0, _oidcClient.UserManager)({
            authority: settings.oidc_authority,
            client_id: settings.oidc_client_id,
            redirect_uri: (0, _routes.redirectUri),
            silent_redirect_uri: (0, _routes.silentRedirectUri)
        }));
    });
};
// Export userManager
exports.default = getUserManager;

},{"oidc-client":"kN0fJ","../../config/routes":"e2CH4","./getSettings":"cBVdB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kN0fJ":[function(require,module,exports) {
!function t(e, r) {
    var n, i;
    module.exports = r();
}(this, function() {
    return function(t) {
        var e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var i = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = t, r.c = e, r.d = function(t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)r.d(n, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return n;
        }, r.n = function(t) {
            var e = t && t.__esModule ? function e() {
                return t.default;
            } : function e() {
                return t;
            };
            return r.d(e, "a", e), e;
        }, r.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 22);
    }([
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }();
            var i = {
                debug: function t() {},
                info: function t() {},
                warn: function t() {},
                error: function t() {}
            }, o = void 0, s = void 0;
            (e.Log = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.reset = function t() {
                    s = 3, o = i;
                }, t.debug = function t() {
                    if (s >= 4) {
                        for(var e = arguments.length, r = Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                        o.debug.apply(o, Array.from(r));
                    }
                }, t.info = function t() {
                    if (s >= 3) {
                        for(var e = arguments.length, r = Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                        o.info.apply(o, Array.from(r));
                    }
                }, t.warn = function t() {
                    if (s >= 2) {
                        for(var e = arguments.length, r = Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                        o.warn.apply(o, Array.from(r));
                    }
                }, t.error = function t() {
                    if (s >= 1) {
                        for(var e = arguments.length, r = Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                        o.error.apply(o, Array.from(r));
                    }
                }, n(t, null, [
                    {
                        key: "NONE",
                        get: function t() {
                            return 0;
                        }
                    },
                    {
                        key: "ERROR",
                        get: function t() {
                            return 1;
                        }
                    },
                    {
                        key: "WARN",
                        get: function t() {
                            return 2;
                        }
                    },
                    {
                        key: "INFO",
                        get: function t() {
                            return 3;
                        }
                    },
                    {
                        key: "DEBUG",
                        get: function t() {
                            return 4;
                        }
                    },
                    {
                        key: "level",
                        get: function t() {
                            return s;
                        },
                        set: function t(e) {
                            if (!(0 <= e && e <= 4)) throw new Error("Invalid log level");
                            s = e;
                        }
                    },
                    {
                        key: "logger",
                        get: function t() {
                            return o;
                        },
                        set: function t(e) {
                            if (!e.debug && e.info && (e.debug = e.info), !(e.debug && e.info && e.warn && e.error)) throw new Error("Invalid logger");
                            o = e;
                        }
                    }
                ]), t;
            }()).reset();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }();
            var i = {
                setInterval: function(t) {
                    function e(e, r) {
                        return t.apply(this, arguments);
                    }
                    return e.toString = function() {
                        return t.toString();
                    }, e;
                }(function(t, e) {
                    return setInterval(t, e);
                }),
                clearInterval: function(t) {
                    function e(e) {
                        return t.apply(this, arguments);
                    }
                    return e.toString = function() {
                        return t.toString();
                    }, e;
                }(function(t) {
                    return clearInterval(t);
                })
            }, o = !1, s = null;
            e.Global = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t._testing = function t() {
                    o = !0;
                }, t.setXMLHttpRequest = function t(e) {
                    s = e;
                }, n(t, null, [
                    {
                        key: "location",
                        get: function t() {
                            if (!o) return location;
                        }
                    },
                    {
                        key: "localStorage",
                        get: function t() {
                            if (!o && "undefined" != typeof window) return localStorage;
                        }
                    },
                    {
                        key: "sessionStorage",
                        get: function t() {
                            if (!o && "undefined" != typeof window) return sessionStorage;
                        }
                    },
                    {
                        key: "XMLHttpRequest",
                        get: function t() {
                            if (!o && "undefined" != typeof window) return s || XMLHttpRequest;
                        }
                    },
                    {
                        key: "timer",
                        get: function t() {
                            if (!o) return i;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.MetadataService = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(7);
            function s(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            var a = ".well-known/openid-configuration";
            e.MetadataService = function() {
                function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.JsonService;
                    if (s(this, t), !e) throw i.Log.error("MetadataService: No settings passed to MetadataService"), new Error("settings");
                    this._settings = e, this._jsonService = new r([
                        "application/jwk-set+json"
                    ]);
                }
                return t.prototype.resetSigningKeys = function t() {
                    this._settings = this._settings || {}, this._settings.signingKeys = void 0;
                }, t.prototype.getMetadata = function t() {
                    var e = this;
                    return this._settings.metadata ? (i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"), Promise.resolve(this._settings.metadata)) : this.metadataUrl ? (i.Log.debug("MetadataService.getMetadata: getting metadata from", this.metadataUrl), this._jsonService.getJson(this.metadataUrl).then(function(t) {
                        i.Log.debug("MetadataService.getMetadata: json received");
                        var r = e._settings.metadataSeed || {};
                        return e._settings.metadata = Object.assign({}, r, t), e._settings.metadata;
                    })) : (i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"), Promise.reject(new Error("No authority or metadataUrl configured on settings")));
                }, t.prototype.getIssuer = function t() {
                    return this._getMetadataProperty("issuer");
                }, t.prototype.getAuthorizationEndpoint = function t() {
                    return this._getMetadataProperty("authorization_endpoint");
                }, t.prototype.getUserInfoEndpoint = function t() {
                    return this._getMetadataProperty("userinfo_endpoint");
                }, t.prototype.getTokenEndpoint = function t() {
                    var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                    return this._getMetadataProperty("token_endpoint", e);
                }, t.prototype.getCheckSessionIframe = function t() {
                    return this._getMetadataProperty("check_session_iframe", !0);
                }, t.prototype.getEndSessionEndpoint = function t() {
                    return this._getMetadataProperty("end_session_endpoint", !0);
                }, t.prototype.getRevocationEndpoint = function t() {
                    return this._getMetadataProperty("revocation_endpoint", !0);
                }, t.prototype.getKeysEndpoint = function t() {
                    return this._getMetadataProperty("jwks_uri", !0);
                }, t.prototype._getMetadataProperty = function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return i.Log.debug("MetadataService.getMetadataProperty for: " + e), this.getMetadata().then(function(t) {
                        if (i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"), void 0 === t[e]) {
                            if (!0 === r) return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property " + e);
                            throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property " + e), new Error("Metadata does not contain property " + e);
                        }
                        return t[e];
                    });
                }, t.prototype.getSigningKeys = function t() {
                    var e = this;
                    return this._settings.signingKeys ? (i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"), Promise.resolve(this._settings.signingKeys)) : this._getMetadataProperty("jwks_uri").then(function(t) {
                        return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received", t), e._jsonService.getJson(t).then(function(t) {
                            if (i.Log.debug("MetadataService.getSigningKeys: key set received", t), !t.keys) throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"), new Error("Missing keys on keyset");
                            return e._settings.signingKeys = t.keys, e._settings.signingKeys;
                        });
                    });
                }, n(t, [
                    {
                        key: "metadataUrl",
                        get: function t() {
                            return this._metadataUrl || (this._settings.metadataUrl ? this._metadataUrl = this._settings.metadataUrl : (this._metadataUrl = this._settings.authority, this._metadataUrl && this._metadataUrl.indexOf(a) < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += a))), this._metadataUrl;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.UrlUtility = void 0;
            var n = r(0), i = r(1);
            e.UrlUtility = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.addQueryParam = function t(e, r, n) {
                    return e.indexOf("?") < 0 && (e += "?"), "?" !== e[e.length - 1] && (e += "&"), e += encodeURIComponent(r), e += "=", e += encodeURIComponent(n);
                }, t.parseUrlFragment = function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#", o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.Global;
                    "string" != typeof e && (e = o.location.href);
                    var s = e.lastIndexOf(r);
                    s >= 0 && (e = e.substr(s + 1)), "?" === r && (s = e.indexOf("#")) >= 0 && (e = e.substr(0, s));
                    for(var a, u = {}, c = /([^&=]+)=([^&]*)/g, h = 0; a = c.exec(e);)if (u[decodeURIComponent(a[1])] = decodeURIComponent(a[2].replace(/\+/g, " ")), h++ > 50) return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters", e), {
                        error: "Response exceeded expected number of parameters"
                    };
                    for(var l in u)return u;
                    return {};
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.JoseUtil = void 0;
            var n = r(26), i = function o(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(r(33));
            e.JoseUtil = (0, i.default)({
                jws: n.jws,
                KeyUtil: n.KeyUtil,
                X509: n.X509,
                crypto: n.crypto,
                hextob64u: n.hextob64u,
                b64tohex: n.b64tohex,
                AllowedSigningAlgs: n.AllowedSigningAlgs
            });
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.OidcClientSettings = void 0;
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, i = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), o = r(0), s = r(23), a = r(6), u = r(24), c = r(2);
            function h(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            var l = ".well-known/openid-configuration", f = "id_token", g = "openid", d = "client_secret_post";
            e.OidcClientSettings = function() {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.authority, i = e.metadataUrl, o = e.metadata, l = e.signingKeys, p = e.metadataSeed, v = e.client_id, y = e.client_secret, m = e.response_type, _ = void 0 === m ? f : m, S = e.scope, b = void 0 === S ? g : S, w = e.redirect_uri, F = e.post_logout_redirect_uri, E = e.client_authentication, x = void 0 === E ? d : E, A = e.prompt, k = e.display, P = e.max_age, C = e.ui_locales, T = e.acr_values, R = e.resource, I = e.response_mode, D = e.filterProtocolClaims, L = void 0 === D || D, N = e.loadUserInfo, U = void 0 === N || N, B = e.staleStateAge, O = void 0 === B ? 900 : B, j = e.clockSkew, M = void 0 === j ? 300 : j, H = e.clockService, V = void 0 === H ? new s.ClockService : H, K = e.userInfoJwtIssuer, q = void 0 === K ? "OP" : K, J = e.mergeClaims, W = void 0 !== J && J, z = e.stateStore, Y = void 0 === z ? new a.WebStorageStateStore : z, G = e.ResponseValidatorCtor, X = void 0 === G ? u.ResponseValidator : G, $ = e.MetadataServiceCtor, Q = void 0 === $ ? c.MetadataService : $, Z = e.extraQueryParams, tt = void 0 === Z ? {} : Z, et = e.extraTokenParams, rt = void 0 === et ? {} : et;
                    h(this, t), this._authority = r, this._metadataUrl = i, this._metadata = o, this._metadataSeed = p, this._signingKeys = l, this._client_id = v, this._client_secret = y, this._response_type = _, this._scope = b, this._redirect_uri = w, this._post_logout_redirect_uri = F, this._client_authentication = x, this._prompt = A, this._display = k, this._max_age = P, this._ui_locales = C, this._acr_values = T, this._resource = R, this._response_mode = I, this._filterProtocolClaims = !!L, this._loadUserInfo = !!U, this._staleStateAge = O, this._clockSkew = M, this._clockService = V, this._userInfoJwtIssuer = q, this._mergeClaims = !!W, this._stateStore = Y, this._validator = new X(this), this._metadataService = new Q(this), this._extraQueryParams = "object" === (void 0 === tt ? "undefined" : n(tt)) ? tt : {}, this._extraTokenParams = "object" === (void 0 === rt ? "undefined" : n(rt)) ? rt : {};
                }
                return t.prototype.getEpochTime = function t() {
                    return this._clockService.getEpochTime();
                }, i(t, [
                    {
                        key: "client_id",
                        get: function t() {
                            return this._client_id;
                        },
                        set: function t(e) {
                            if (this._client_id) throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."), new Error("client_id has already been assigned.");
                            this._client_id = e;
                        }
                    },
                    {
                        key: "client_secret",
                        get: function t() {
                            return this._client_secret;
                        }
                    },
                    {
                        key: "response_type",
                        get: function t() {
                            return this._response_type;
                        }
                    },
                    {
                        key: "scope",
                        get: function t() {
                            return this._scope;
                        }
                    },
                    {
                        key: "redirect_uri",
                        get: function t() {
                            return this._redirect_uri;
                        }
                    },
                    {
                        key: "post_logout_redirect_uri",
                        get: function t() {
                            return this._post_logout_redirect_uri;
                        }
                    },
                    {
                        key: "client_authentication",
                        get: function t() {
                            return this._client_authentication;
                        }
                    },
                    {
                        key: "prompt",
                        get: function t() {
                            return this._prompt;
                        }
                    },
                    {
                        key: "display",
                        get: function t() {
                            return this._display;
                        }
                    },
                    {
                        key: "max_age",
                        get: function t() {
                            return this._max_age;
                        }
                    },
                    {
                        key: "ui_locales",
                        get: function t() {
                            return this._ui_locales;
                        }
                    },
                    {
                        key: "acr_values",
                        get: function t() {
                            return this._acr_values;
                        }
                    },
                    {
                        key: "resource",
                        get: function t() {
                            return this._resource;
                        }
                    },
                    {
                        key: "response_mode",
                        get: function t() {
                            return this._response_mode;
                        }
                    },
                    {
                        key: "authority",
                        get: function t() {
                            return this._authority;
                        },
                        set: function t(e) {
                            if (this._authority) throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."), new Error("authority has already been assigned.");
                            this._authority = e;
                        }
                    },
                    {
                        key: "metadataUrl",
                        get: function t() {
                            return this._metadataUrl || (this._metadataUrl = this.authority, this._metadataUrl && this._metadataUrl.indexOf(l) < 0 && ("/" !== this._metadataUrl[this._metadataUrl.length - 1] && (this._metadataUrl += "/"), this._metadataUrl += l)), this._metadataUrl;
                        }
                    },
                    {
                        key: "metadata",
                        get: function t() {
                            return this._metadata;
                        },
                        set: function t(e) {
                            this._metadata = e;
                        }
                    },
                    {
                        key: "metadataSeed",
                        get: function t() {
                            return this._metadataSeed;
                        },
                        set: function t(e) {
                            this._metadataSeed = e;
                        }
                    },
                    {
                        key: "signingKeys",
                        get: function t() {
                            return this._signingKeys;
                        },
                        set: function t(e) {
                            this._signingKeys = e;
                        }
                    },
                    {
                        key: "filterProtocolClaims",
                        get: function t() {
                            return this._filterProtocolClaims;
                        }
                    },
                    {
                        key: "loadUserInfo",
                        get: function t() {
                            return this._loadUserInfo;
                        }
                    },
                    {
                        key: "staleStateAge",
                        get: function t() {
                            return this._staleStateAge;
                        }
                    },
                    {
                        key: "clockSkew",
                        get: function t() {
                            return this._clockSkew;
                        }
                    },
                    {
                        key: "userInfoJwtIssuer",
                        get: function t() {
                            return this._userInfoJwtIssuer;
                        }
                    },
                    {
                        key: "mergeClaims",
                        get: function t() {
                            return this._mergeClaims;
                        }
                    },
                    {
                        key: "stateStore",
                        get: function t() {
                            return this._stateStore;
                        }
                    },
                    {
                        key: "validator",
                        get: function t() {
                            return this._validator;
                        }
                    },
                    {
                        key: "metadataService",
                        get: function t() {
                            return this._metadataService;
                        }
                    },
                    {
                        key: "extraQueryParams",
                        get: function t() {
                            return this._extraQueryParams;
                        },
                        set: function t(e) {
                            "object" === (void 0 === e ? "undefined" : n(e)) ? this._extraQueryParams = e : this._extraQueryParams = {};
                        }
                    },
                    {
                        key: "extraTokenParams",
                        get: function t() {
                            return this._extraTokenParams;
                        },
                        set: function t(e) {
                            "object" === (void 0 === e ? "undefined" : n(e)) ? this._extraTokenParams = e : this._extraTokenParams = {};
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.WebStorageStateStore = void 0;
            var n = r(0), i = r(1);
            function o(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.WebStorageStateStore = function() {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.prefix, n = void 0 === r ? "oidc." : r, s = e.store, a = void 0 === s ? i.Global.localStorage : s;
                    o(this, t), this._store = a, this._prefix = n;
                }
                return t.prototype.set = function t(e, r) {
                    return n.Log.debug("WebStorageStateStore.set", e), e = this._prefix + e, this._store.setItem(e, r), Promise.resolve();
                }, t.prototype.get = function t(e) {
                    n.Log.debug("WebStorageStateStore.get", e), e = this._prefix + e;
                    var r = this._store.getItem(e);
                    return Promise.resolve(r);
                }, t.prototype.remove = function t(e) {
                    n.Log.debug("WebStorageStateStore.remove", e), e = this._prefix + e;
                    var r = this._store.getItem(e);
                    return this._store.removeItem(e), Promise.resolve(r);
                }, t.prototype.getAllKeys = function t() {
                    n.Log.debug("WebStorageStateStore.getAllKeys");
                    for(var e = [], r = 0; r < this._store.length; r++){
                        var i = this._store.key(r);
                        0 === i.indexOf(this._prefix) && e.push(i.substr(this._prefix.length));
                    }
                    return Promise.resolve(e);
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.JsonService = void 0;
            var n = r(0), i = r(1);
            function o(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.JsonService = function() {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.Global.XMLHttpRequest, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    o(this, t), e && Array.isArray(e) ? this._contentTypes = e.slice() : this._contentTypes = [], this._contentTypes.push("application/json"), n && this._contentTypes.push("application/jwt"), this._XMLHttpRequest = r, this._jwtHandler = n;
                }
                return t.prototype.getJson = function t(e, r) {
                    var i = this;
                    if (!e) throw n.Log.error("JsonService.getJson: No url passed"), new Error("url");
                    return n.Log.debug("JsonService.getJson, url: ", e), new Promise(function(t, o) {
                        var s = new i._XMLHttpRequest;
                        s.open("GET", e);
                        var a = i._contentTypes, u = i._jwtHandler;
                        s.onload = function() {
                            if (n.Log.debug("JsonService.getJson: HTTP response received, status", s.status), 200 === s.status) {
                                var r = s.getResponseHeader("Content-Type");
                                if (r) {
                                    var i = a.find(function(t) {
                                        if (r.startsWith(t)) return !0;
                                    });
                                    if ("application/jwt" == i) return void u(s).then(t, o);
                                    if (i) try {
                                        return void t(JSON.parse(s.responseText));
                                    } catch (t) {
                                        return n.Log.error("JsonService.getJson: Error parsing JSON response", t.message), void o(t);
                                    }
                                }
                                o(Error("Invalid response Content-Type: " + r + ", from URL: " + e));
                            } else o(Error(s.statusText + " (" + s.status + ")"));
                        }, s.onerror = function() {
                            n.Log.error("JsonService.getJson: network error"), o(Error("Network Error"));
                        }, r && (n.Log.debug("JsonService.getJson: token passed, setting Authorization header"), s.setRequestHeader("Authorization", "Bearer " + r)), s.send();
                    });
                }, t.prototype.postForm = function t(e, r, i) {
                    var o = this;
                    if (!e) throw n.Log.error("JsonService.postForm: No url passed"), new Error("url");
                    return n.Log.debug("JsonService.postForm, url: ", e), new Promise(function(t, s) {
                        var a = new o._XMLHttpRequest;
                        a.open("POST", e);
                        var u = o._contentTypes;
                        a.onload = function() {
                            if (n.Log.debug("JsonService.postForm: HTTP response received, status", a.status), 200 !== a.status) {
                                if (400 === a.status) {
                                    if (i = a.getResponseHeader("Content-Type")) {
                                        if (u.find(function(t) {
                                            if (i.startsWith(t)) return !0;
                                        })) try {
                                            var r = JSON.parse(a.responseText);
                                            if (r && r.error) return n.Log.error("JsonService.postForm: Error from server: ", r.error), void s(new Error(r.error));
                                        } catch (t) {
                                            return n.Log.error("JsonService.postForm: Error parsing JSON response", t.message), void s(t);
                                        }
                                    }
                                }
                                s(Error(a.statusText + " (" + a.status + ")"));
                            } else {
                                var i;
                                if ((i = a.getResponseHeader("Content-Type")) && u.find(function(t) {
                                    if (i.startsWith(t)) return !0;
                                })) try {
                                    return void t(JSON.parse(a.responseText));
                                } catch (t) {
                                    return n.Log.error("JsonService.postForm: Error parsing JSON response", t.message), void s(t);
                                }
                                s(Error("Invalid response Content-Type: " + i + ", from URL: " + e));
                            }
                        }, a.onerror = function() {
                            n.Log.error("JsonService.postForm: network error"), s(Error("Network Error"));
                        };
                        var c = "";
                        for(var h in r){
                            var l = r[h];
                            l && (c.length > 0 && (c += "&"), c += encodeURIComponent(h), c += "=", c += encodeURIComponent(l));
                        }
                        a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), void 0 !== i && a.setRequestHeader("Authorization", "Basic " + btoa(i)), a.send(c);
                    });
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SigninRequest = void 0;
            var n = r(0), i = r(3), o = r(13);
            e.SigninRequest = function() {
                function t(e) {
                    var r = e.url, s = e.client_id, a = e.redirect_uri, u = e.response_type, c = e.scope, h = e.authority, l = e.data, f = e.prompt, g = e.display, d = e.max_age, p = e.ui_locales, v = e.id_token_hint, y = e.login_hint, m = e.acr_values, _ = e.resource, S = e.response_mode, b = e.request, w = e.request_uri, F = e.extraQueryParams, E = e.request_type, x = e.client_secret, A = e.extraTokenParams, k = e.skipUserInfo;
                    if (function P(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), !r) throw n.Log.error("SigninRequest.ctor: No url passed"), new Error("url");
                    if (!s) throw n.Log.error("SigninRequest.ctor: No client_id passed"), new Error("client_id");
                    if (!a) throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"), new Error("redirect_uri");
                    if (!u) throw n.Log.error("SigninRequest.ctor: No response_type passed"), new Error("response_type");
                    if (!c) throw n.Log.error("SigninRequest.ctor: No scope passed"), new Error("scope");
                    if (!h) throw n.Log.error("SigninRequest.ctor: No authority passed"), new Error("authority");
                    var C = t.isOidc(u), T = t.isCode(u);
                    S || (S = t.isCode(u) ? "query" : null), this.state = new o.SigninState({
                        nonce: C,
                        data: l,
                        client_id: s,
                        authority: h,
                        redirect_uri: a,
                        code_verifier: T,
                        request_type: E,
                        response_mode: S,
                        client_secret: x,
                        scope: c,
                        extraTokenParams: A,
                        skipUserInfo: k
                    }), r = i.UrlUtility.addQueryParam(r, "client_id", s), r = i.UrlUtility.addQueryParam(r, "redirect_uri", a), r = i.UrlUtility.addQueryParam(r, "response_type", u), r = i.UrlUtility.addQueryParam(r, "scope", c), r = i.UrlUtility.addQueryParam(r, "state", this.state.id), C && (r = i.UrlUtility.addQueryParam(r, "nonce", this.state.nonce)), T && (r = i.UrlUtility.addQueryParam(r, "code_challenge", this.state.code_challenge), r = i.UrlUtility.addQueryParam(r, "code_challenge_method", "S256"));
                    var R = {
                        prompt: f,
                        display: g,
                        max_age: d,
                        ui_locales: p,
                        id_token_hint: v,
                        login_hint: y,
                        acr_values: m,
                        resource: _,
                        request: b,
                        request_uri: w,
                        response_mode: S
                    };
                    for(var I in R)R[I] && (r = i.UrlUtility.addQueryParam(r, I, R[I]));
                    for(var D in F)r = i.UrlUtility.addQueryParam(r, D, F[D]);
                    this.url = r;
                }
                return t.isOidc = function t(e) {
                    return !!e.split(/\s+/g).filter(function(t) {
                        return "id_token" === t;
                    })[0];
                }, t.isOAuth = function t(e) {
                    return !!e.split(/\s+/g).filter(function(t) {
                        return "token" === t;
                    })[0];
                }, t.isCode = function t(e) {
                    return !!e.split(/\s+/g).filter(function(t) {
                        return "code" === t;
                    })[0];
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.State = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = function s(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(r(14));
            function a(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.State = function() {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.id, n = e.data, i = e.created, s = e.request_type;
                    a(this, t), this._id = r || (0, o.default)(), this._data = n, this._created = "number" == typeof i && i > 0 ? i : parseInt(Date.now() / 1e3), this._request_type = s;
                }
                return t.prototype.toStorageString = function t() {
                    return i.Log.debug("State.toStorageString"), JSON.stringify({
                        id: this.id,
                        data: this.data,
                        created: this.created,
                        request_type: this.request_type
                    });
                }, t.fromStorageString = function e(r) {
                    return i.Log.debug("State.fromStorageString"), new t(JSON.parse(r));
                }, t.clearStaleState = function e(r, n) {
                    var o = Date.now() / 1e3 - n;
                    return r.getAllKeys().then(function(e) {
                        i.Log.debug("State.clearStaleState: got keys", e);
                        for(var n = [], s = function s(a) {
                            var c = e[a];
                            u = r.get(c).then(function(e) {
                                var n = !1;
                                if (e) try {
                                    var s = t.fromStorageString(e);
                                    i.Log.debug("State.clearStaleState: got item from key: ", c, s.created), s.created <= o && (n = !0);
                                } catch (t) {
                                    i.Log.error("State.clearStaleState: Error parsing state for key", c, t.message), n = !0;
                                }
                                else i.Log.debug("State.clearStaleState: no item in storage for key: ", c), n = !0;
                                if (n) return i.Log.debug("State.clearStaleState: removed item for key: ", c), r.remove(c);
                            }), n.push(u);
                        }, a = 0; a < e.length; a++){
                            var u;
                            s(a);
                        }
                        return i.Log.debug("State.clearStaleState: waiting on promise count:", n.length), Promise.all(n);
                    });
                }, n(t, [
                    {
                        key: "id",
                        get: function t() {
                            return this._id;
                        }
                    },
                    {
                        key: "data",
                        get: function t() {
                            return this._data;
                        }
                    },
                    {
                        key: "created",
                        get: function t() {
                            return this._created;
                        }
                    },
                    {
                        key: "request_type",
                        get: function t() {
                            return this._request_type;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.OidcClient = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(5), s = r(12), a = r(8), u = r(34), c = r(35), h = r(36), l = r(13), f = r(9);
            function g(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.OidcClient = function() {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    g(this, t), e instanceof o.OidcClientSettings ? this._settings = e : this._settings = new o.OidcClientSettings(e);
                }
                return t.prototype.createSigninRequest = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.response_type, o = r.scope, s = r.redirect_uri, u = r.data, c = r.state, h = r.prompt, l = r.display, f = r.max_age, g = r.ui_locales, d = r.id_token_hint, p = r.login_hint, v = r.acr_values, y = r.resource, m = r.request, _ = r.request_uri, S = r.response_mode, b = r.extraQueryParams, w = r.extraTokenParams, F = r.request_type, E = r.skipUserInfo, x = arguments[1];
                    i.Log.debug("OidcClient.createSigninRequest");
                    var A = this._settings.client_id;
                    n = n || this._settings.response_type, o = o || this._settings.scope, s = s || this._settings.redirect_uri, h = h || this._settings.prompt, l = l || this._settings.display, f = f || this._settings.max_age, g = g || this._settings.ui_locales, v = v || this._settings.acr_values, y = y || this._settings.resource, S = S || this._settings.response_mode, b = b || this._settings.extraQueryParams, w = w || this._settings.extraTokenParams;
                    var k = this._settings.authority;
                    return a.SigninRequest.isCode(n) && "code" !== n ? Promise.reject(new Error("OpenID Connect hybrid flow is not supported")) : this._metadataService.getAuthorizationEndpoint().then(function(t) {
                        i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint", t);
                        var r = new a.SigninRequest({
                            url: t,
                            client_id: A,
                            redirect_uri: s,
                            response_type: n,
                            scope: o,
                            data: u || c,
                            authority: k,
                            prompt: h,
                            display: l,
                            max_age: f,
                            ui_locales: g,
                            id_token_hint: d,
                            login_hint: p,
                            acr_values: v,
                            resource: y,
                            request: m,
                            request_uri: _,
                            extraQueryParams: b,
                            extraTokenParams: w,
                            request_type: F,
                            response_mode: S,
                            client_secret: e._settings.client_secret,
                            skipUserInfo: E
                        }), P = r.state;
                        return (x = x || e._stateStore).set(P.id, P.toStorageString()).then(function() {
                            return r;
                        });
                    });
                }, t.prototype.readSigninResponseState = function t(e, r) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    i.Log.debug("OidcClient.readSigninResponseState");
                    var o = "query" === this._settings.response_mode || !this._settings.response_mode && a.SigninRequest.isCode(this._settings.response_type), s = o ? "?" : "#", c = new u.SigninResponse(e, s);
                    if (!c.state) return i.Log.error("OidcClient.readSigninResponseState: No state in response"), Promise.reject(new Error("No state in response"));
                    r = r || this._stateStore;
                    var h = n ? r.remove.bind(r) : r.get.bind(r);
                    return h(c.state).then(function(t) {
                        if (!t) throw i.Log.error("OidcClient.readSigninResponseState: No matching state found in storage"), new Error("No matching state found in storage");
                        return {
                            state: l.SigninState.fromStorageString(t),
                            response: c
                        };
                    });
                }, t.prototype.processSigninResponse = function t(e, r) {
                    var n = this;
                    return i.Log.debug("OidcClient.processSigninResponse"), this.readSigninResponseState(e, r, !0).then(function(t) {
                        var e = t.state, r = t.response;
                        return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"), n._validator.validateSigninResponse(e, r);
                    });
                }, t.prototype.createSignoutRequest = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.id_token_hint, o = r.data, s = r.state, a = r.post_logout_redirect_uri, u = r.extraQueryParams, h = r.request_type, l = arguments[1];
                    return i.Log.debug("OidcClient.createSignoutRequest"), a = a || this._settings.post_logout_redirect_uri, u = u || this._settings.extraQueryParams, this._metadataService.getEndSessionEndpoint().then(function(t) {
                        if (!t) throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"), new Error("no end session endpoint");
                        i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint", t);
                        var r = new c.SignoutRequest({
                            url: t,
                            id_token_hint: n,
                            post_logout_redirect_uri: a,
                            data: o || s,
                            extraQueryParams: u,
                            request_type: h
                        }), f = r.state;
                        return f && (i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"), (l = l || e._stateStore).set(f.id, f.toStorageString())), r;
                    });
                }, t.prototype.readSignoutResponseState = function t(e, r) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    i.Log.debug("OidcClient.readSignoutResponseState");
                    var o = new h.SignoutResponse(e);
                    if (!o.state) return i.Log.debug("OidcClient.readSignoutResponseState: No state in response"), o.error ? (i.Log.warn("OidcClient.readSignoutResponseState: Response was error: ", o.error), Promise.reject(new s.ErrorResponse(o))) : Promise.resolve({
                        state: void 0,
                        response: o
                    });
                    var a = o.state;
                    r = r || this._stateStore;
                    var u = n ? r.remove.bind(r) : r.get.bind(r);
                    return u(a).then(function(t) {
                        if (!t) throw i.Log.error("OidcClient.readSignoutResponseState: No matching state found in storage"), new Error("No matching state found in storage");
                        return {
                            state: f.State.fromStorageString(t),
                            response: o
                        };
                    });
                }, t.prototype.processSignoutResponse = function t(e, r) {
                    var n = this;
                    return i.Log.debug("OidcClient.processSignoutResponse"), this.readSignoutResponseState(e, r, !0).then(function(t) {
                        var e = t.state, r = t.response;
                        return e ? (i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"), n._validator.validateSignoutResponse(e, r)) : (i.Log.debug("OidcClient.processSignoutResponse: No state from storage; skipping validating response"), r);
                    });
                }, t.prototype.clearStaleState = function t(e) {
                    return i.Log.debug("OidcClient.clearStaleState"), e = e || this._stateStore, f.State.clearStaleState(e, this.settings.staleStateAge);
                }, n(t, [
                    {
                        key: "_stateStore",
                        get: function t() {
                            return this.settings.stateStore;
                        }
                    },
                    {
                        key: "_validator",
                        get: function t() {
                            return this.settings.validator;
                        }
                    },
                    {
                        key: "_metadataService",
                        get: function t() {
                            return this.settings.metadataService;
                        }
                    },
                    {
                        key: "settings",
                        get: function t() {
                            return this._settings;
                        }
                    },
                    {
                        key: "metadataService",
                        get: function t() {
                            return this._metadataService;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.TokenClient = void 0;
            var n = r(7), i = r(2), o = r(0);
            function s(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.TokenClient = function() {
                function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;
                    if (s(this, t), !e) throw o.Log.error("TokenClient.ctor: No settings passed"), new Error("settings");
                    this._settings = e, this._jsonService = new r, this._metadataService = new a(this._settings);
                }
                return t.prototype.exchangeCode = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (r = Object.assign({}, r)).grant_type = r.grant_type || "authorization_code", r.client_id = r.client_id || this._settings.client_id, r.client_secret = r.client_secret || this._settings.client_secret, r.redirect_uri = r.redirect_uri || this._settings.redirect_uri;
                    var n = void 0, i = r._client_authentication || this._settings._client_authentication;
                    return delete r._client_authentication, r.code ? r.redirect_uri ? r.code_verifier ? r.client_id ? r.client_secret || "client_secret_basic" != i ? ("client_secret_basic" == i && (n = r.client_id + ":" + r.client_secret, delete r.client_id, delete r.client_secret), this._metadataService.getTokenEndpoint(!1).then(function(t) {
                        return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"), e._jsonService.postForm(t, r, n).then(function(t) {
                            return o.Log.debug("TokenClient.exchangeCode: response received"), t;
                        });
                    })) : (o.Log.error("TokenClient.exchangeCode: No client_secret passed"), Promise.reject(new Error("A client_secret is required"))) : (o.Log.error("TokenClient.exchangeCode: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeCode: No code_verifier passed"), Promise.reject(new Error("A code_verifier is required"))) : (o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"), Promise.reject(new Error("A redirect_uri is required"))) : (o.Log.error("TokenClient.exchangeCode: No code passed"), Promise.reject(new Error("A code is required")));
                }, t.prototype.exchangeRefreshToken = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (r = Object.assign({}, r)).grant_type = r.grant_type || "refresh_token", r.client_id = r.client_id || this._settings.client_id, r.client_secret = r.client_secret || this._settings.client_secret;
                    var n = void 0, i = r._client_authentication || this._settings._client_authentication;
                    return delete r._client_authentication, r.refresh_token ? r.client_id ? ("client_secret_basic" == i && (n = r.client_id + ":" + r.client_secret, delete r.client_id, delete r.client_secret), this._metadataService.getTokenEndpoint(!1).then(function(t) {
                        return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"), e._jsonService.postForm(t, r, n).then(function(t) {
                            return o.Log.debug("TokenClient.exchangeRefreshToken: response received"), t;
                        });
                    })) : (o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"), Promise.reject(new Error("A client_id is required"))) : (o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"), Promise.reject(new Error("A refresh_token is required")));
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.ErrorResponse = void 0;
            var n = r(0);
            function i(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function o(t, e) {
                if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }
            e.ErrorResponse = function(t) {
                function e() {
                    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, s = r.error, a = r.error_description, u = r.error_uri, c = r.state, h = r.session_state;
                    if (i(this, e), !s) throw n.Log.error("No error passed to ErrorResponse"), new Error("error");
                    var l = o(this, t.call(this, a || s));
                    return l.name = "ErrorResponse", l.error = s, l.error_description = a, l.error_uri = u, l.state = c, l.session_state = h, l;
                }
                return function r(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
                }(e, t), e;
            }(Error);
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SigninState = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(9), s = r(4), a = function u(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(r(14));
            function c(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function h(t, e) {
                if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }
            e.SigninState = function(t) {
                function e() {
                    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.nonce, i = r.authority, o = r.client_id, u = r.redirect_uri, l = r.code_verifier, f = r.response_mode, g = r.client_secret, d = r.scope, p = r.extraTokenParams, v = r.skipUserInfo;
                    c(this, e);
                    var y = h(this, t.call(this, arguments[0]));
                    if (!0 === n ? y._nonce = (0, a.default)() : n && (y._nonce = n), !0 === l ? y._code_verifier = (0, a.default)() + (0, a.default)() + (0, a.default)() : l && (y._code_verifier = l), y.code_verifier) {
                        var m = s.JoseUtil.hashString(y.code_verifier, "SHA256");
                        y._code_challenge = s.JoseUtil.hexToBase64Url(m);
                    }
                    return y._redirect_uri = u, y._authority = i, y._client_id = o, y._response_mode = f, y._client_secret = g, y._scope = d, y._extraTokenParams = p, y._skipUserInfo = v, y;
                }
                return function r(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
                }(e, t), e.prototype.toStorageString = function t() {
                    return i.Log.debug("SigninState.toStorageString"), JSON.stringify({
                        id: this.id,
                        data: this.data,
                        created: this.created,
                        request_type: this.request_type,
                        nonce: this.nonce,
                        code_verifier: this.code_verifier,
                        redirect_uri: this.redirect_uri,
                        authority: this.authority,
                        client_id: this.client_id,
                        response_mode: this.response_mode,
                        client_secret: this.client_secret,
                        scope: this.scope,
                        extraTokenParams: this.extraTokenParams,
                        skipUserInfo: this.skipUserInfo
                    });
                }, e.fromStorageString = function t(r) {
                    return i.Log.debug("SigninState.fromStorageString"), new e(JSON.parse(r));
                }, n(e, [
                    {
                        key: "nonce",
                        get: function t() {
                            return this._nonce;
                        }
                    },
                    {
                        key: "authority",
                        get: function t() {
                            return this._authority;
                        }
                    },
                    {
                        key: "client_id",
                        get: function t() {
                            return this._client_id;
                        }
                    },
                    {
                        key: "redirect_uri",
                        get: function t() {
                            return this._redirect_uri;
                        }
                    },
                    {
                        key: "code_verifier",
                        get: function t() {
                            return this._code_verifier;
                        }
                    },
                    {
                        key: "code_challenge",
                        get: function t() {
                            return this._code_challenge;
                        }
                    },
                    {
                        key: "response_mode",
                        get: function t() {
                            return this._response_mode;
                        }
                    },
                    {
                        key: "client_secret",
                        get: function t() {
                            return this._client_secret;
                        }
                    },
                    {
                        key: "scope",
                        get: function t() {
                            return this._scope;
                        }
                    },
                    {
                        key: "extraTokenParams",
                        get: function t() {
                            return this._extraTokenParams;
                        }
                    },
                    {
                        key: "skipUserInfo",
                        get: function t() {
                            return this._skipUserInfo;
                        }
                    }
                ]), e;
            }(o.State);
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function n() {
                return ("undefined" != i && null !== i && void 0 !== i.getRandomValues ? o : s)().replace(/-/g, "");
            };
            var i = "undefined" != typeof window ? window.crypto || window.msCrypto : null;
            function o() {
                return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(t) {
                    return (t ^ i.getRandomValues(new Uint8Array(1))[0] & 15 >> t / 4).toString(16);
                });
            }
            function s() {
                return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(t) {
                    return (t ^ 16 * Math.random() >> t / 4).toString(16);
                });
            }
            t.exports = e.default;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.User = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0);
            e.User = function() {
                function t(e) {
                    var r = e.id_token, n = e.session_state, i = e.access_token, o = e.refresh_token, s = e.token_type, a = e.scope, u = e.profile, c = e.expires_at, h = e.state;
                    !function l(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this.id_token = r, this.session_state = n, this.access_token = i, this.refresh_token = o, this.token_type = s, this.scope = a, this.profile = u, this.expires_at = c, this.state = h;
                }
                return t.prototype.toStorageString = function t() {
                    return i.Log.debug("User.toStorageString"), JSON.stringify({
                        id_token: this.id_token,
                        session_state: this.session_state,
                        access_token: this.access_token,
                        refresh_token: this.refresh_token,
                        token_type: this.token_type,
                        scope: this.scope,
                        profile: this.profile,
                        expires_at: this.expires_at
                    });
                }, t.fromStorageString = function e(r) {
                    return i.Log.debug("User.fromStorageString"), new t(JSON.parse(r));
                }, n(t, [
                    {
                        key: "expires_in",
                        get: function t() {
                            if (this.expires_at) {
                                var e = parseInt(Date.now() / 1e3);
                                return this.expires_at - e;
                            }
                        },
                        set: function t(e) {
                            var r = parseInt(e);
                            if ("number" == typeof r && r > 0) {
                                var n = parseInt(Date.now() / 1e3);
                                this.expires_at = n + r;
                            }
                        }
                    },
                    {
                        key: "expired",
                        get: function t() {
                            var e = this.expires_in;
                            if (void 0 !== e) return e <= 0;
                        }
                    },
                    {
                        key: "scopes",
                        get: function t() {
                            return (this.scope || "").split(" ");
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.AccessTokenEvents = void 0;
            var n = r(0), i = r(46);
            function o(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.AccessTokenEvents = function() {
                function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.accessTokenExpiringNotificationTime, n = void 0 === r ? 60 : r, s = e.accessTokenExpiringTimer, a = void 0 === s ? new i.Timer("Access token expiring") : s, u = e.accessTokenExpiredTimer, c = void 0 === u ? new i.Timer("Access token expired") : u;
                    o(this, t), this._accessTokenExpiringNotificationTime = n, this._accessTokenExpiring = a, this._accessTokenExpired = c;
                }
                return t.prototype.load = function t(e) {
                    if (e.access_token && void 0 !== e.expires_in) {
                        var r = e.expires_in;
                        if (n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:", r), r > 0) {
                            var i = r - this._accessTokenExpiringNotificationTime;
                            i <= 0 && (i = 1), n.Log.debug("AccessTokenEvents.load: registering expiring timer in:", i), this._accessTokenExpiring.init(i);
                        } else n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."), this._accessTokenExpiring.cancel();
                        var o = r + 1;
                        n.Log.debug("AccessTokenEvents.load: registering expired timer in:", o), this._accessTokenExpired.init(o);
                    } else this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
                }, t.prototype.unload = function t() {
                    n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"), this._accessTokenExpiring.cancel(), this._accessTokenExpired.cancel();
                }, t.prototype.addAccessTokenExpiring = function t(e) {
                    this._accessTokenExpiring.addHandler(e);
                }, t.prototype.removeAccessTokenExpiring = function t(e) {
                    this._accessTokenExpiring.removeHandler(e);
                }, t.prototype.addAccessTokenExpired = function t(e) {
                    this._accessTokenExpired.addHandler(e);
                }, t.prototype.removeAccessTokenExpired = function t(e) {
                    this._accessTokenExpired.removeHandler(e);
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.Event = void 0;
            var n = r(0);
            e.Event = function() {
                function t(e) {
                    !function r(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this._name = e, this._callbacks = [];
                }
                return t.prototype.addHandler = function t(e) {
                    this._callbacks.push(e);
                }, t.prototype.removeHandler = function t(e) {
                    var r = this._callbacks.findIndex(function(t) {
                        return t === e;
                    });
                    r >= 0 && this._callbacks.splice(r, 1);
                }, t.prototype.raise = function t() {
                    n.Log.debug("Event: Raising event: " + this._name);
                    for(var e = 0; e < this._callbacks.length; e++){
                        var r;
                        (r = this._callbacks)[e].apply(r, arguments);
                    }
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SessionMonitor = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(19), s = r(1);
            function a(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.SessionMonitor = function() {
                function t(e) {
                    var r = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.CheckSessionIFrame, u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.Global.timer;
                    if (a(this, t), !e) throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"), new Error("userManager");
                    this._userManager = e, this._CheckSessionIFrameCtor = n, this._timer = u, this._userManager.events.addUserLoaded(this._start.bind(this)), this._userManager.events.addUserUnloaded(this._stop.bind(this)), Promise.resolve(this._userManager.getUser().then(function(t) {
                        t ? r._start(t) : r._settings.monitorAnonymousSession && r._userManager.querySessionStatus().then(function(t) {
                            var e = {
                                session_state: t.session_state
                            };
                            t.sub && t.sid && (e.profile = {
                                sub: t.sub,
                                sid: t.sid
                            }), r._start(e);
                        }).catch(function(t) {
                            i.Log.error("SessionMonitor ctor: error from querySessionStatus:", t.message);
                        });
                    }).catch(function(t) {
                        i.Log.error("SessionMonitor ctor: error from getUser:", t.message);
                    }));
                }
                return t.prototype._start = function t(e) {
                    var r = this, n = e.session_state;
                    n && (e.profile ? (this._sub = e.profile.sub, this._sid = e.profile.sid, i.Log.debug("SessionMonitor._start: session_state:", n, ", sub:", this._sub)) : (this._sub = void 0, this._sid = void 0, i.Log.debug("SessionMonitor._start: session_state:", n, ", anonymous user")), this._checkSessionIFrame ? this._checkSessionIFrame.start(n) : this._metadataService.getCheckSessionIframe().then(function(t) {
                        if (t) {
                            i.Log.debug("SessionMonitor._start: Initializing check session iframe");
                            var e = r._client_id, o = r._checkSessionInterval, s = r._stopCheckSessionOnError;
                            r._checkSessionIFrame = new r._CheckSessionIFrameCtor(r._callback.bind(r), e, t, o, s), r._checkSessionIFrame.load().then(function() {
                                r._checkSessionIFrame.start(n);
                            });
                        } else i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata");
                    }).catch(function(t) {
                        i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:", t.message);
                    }));
                }, t.prototype._stop = function t() {
                    var e = this;
                    if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && (i.Log.debug("SessionMonitor._stop"), this._checkSessionIFrame.stop()), this._settings.monitorAnonymousSession) var r = this._timer.setInterval(function() {
                        e._timer.clearInterval(r), e._userManager.querySessionStatus().then(function(t) {
                            var r = {
                                session_state: t.session_state
                            };
                            t.sub && t.sid && (r.profile = {
                                sub: t.sub,
                                sid: t.sid
                            }), e._start(r);
                        }).catch(function(t) {
                            i.Log.error("SessionMonitor: error from querySessionStatus:", t.message);
                        });
                    }, 1e3);
                }, t.prototype._callback = function t() {
                    var e = this;
                    this._userManager.querySessionStatus().then(function(t) {
                        var r = !0;
                        t ? t.sub === e._sub ? (r = !1, e._checkSessionIFrame.start(t.session_state), t.sid === e._sid ? i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:", t.session_state) : (i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:", t.session_state), e._userManager.events._raiseUserSessionChanged())) : i.Log.debug("SessionMonitor._callback: Different subject signed into OP:", t.sub) : i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"), r && (e._sub ? (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"), e._userManager.events._raiseUserSignedOut()) : (i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed in event"), e._userManager.events._raiseUserSignedIn()));
                    }).catch(function(t) {
                        e._sub && (i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event", t.message), e._userManager.events._raiseUserSignedOut());
                    });
                }, n(t, [
                    {
                        key: "_settings",
                        get: function t() {
                            return this._userManager.settings;
                        }
                    },
                    {
                        key: "_metadataService",
                        get: function t() {
                            return this._userManager.metadataService;
                        }
                    },
                    {
                        key: "_client_id",
                        get: function t() {
                            return this._settings.client_id;
                        }
                    },
                    {
                        key: "_checkSessionInterval",
                        get: function t() {
                            return this._settings.checkSessionInterval;
                        }
                    },
                    {
                        key: "_stopCheckSessionOnError",
                        get: function t() {
                            return this._settings.stopCheckSessionOnError;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.CheckSessionIFrame = void 0;
            var n = r(0);
            function i(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.CheckSessionIFrame = function() {
                function t(e, r, n, o) {
                    var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
                    i(this, t), this._callback = e, this._client_id = r, this._url = n, this._interval = o || 2e3, this._stopOnError = s;
                    var a = n.indexOf("/", n.indexOf("//") + 2);
                    this._frame_origin = n.substr(0, a), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.style.display = "none", this._frame.width = 0, this._frame.height = 0, this._frame.src = n;
                }
                return t.prototype.load = function t() {
                    var e = this;
                    return new Promise(function(t) {
                        e._frame.onload = function() {
                            t();
                        }, window.document.body.appendChild(e._frame), e._boundMessageEvent = e._message.bind(e), window.addEventListener("message", e._boundMessageEvent, !1);
                    });
                }, t.prototype._message = function t(e) {
                    e.origin === this._frame_origin && e.source === this._frame.contentWindow && ("error" === e.data ? (n.Log.error("CheckSessionIFrame: error message from check session op iframe"), this._stopOnError && this.stop()) : "changed" === e.data ? (n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"), this.stop(), this._callback()) : n.Log.debug("CheckSessionIFrame: " + e.data + " message from check session op iframe"));
                }, t.prototype.start = function t(e) {
                    var r = this;
                    if (this._session_state !== e) {
                        n.Log.debug("CheckSessionIFrame.start"), this.stop(), this._session_state = e;
                        var i = function t() {
                            r._frame.contentWindow.postMessage(r._client_id + " " + r._session_state, r._frame_origin);
                        };
                        i(), this._timer = window.setInterval(i, this._interval);
                    }
                }, t.prototype.stop = function t() {
                    this._session_state = null, this._timer && (n.Log.debug("CheckSessionIFrame.stop"), window.clearInterval(this._timer), this._timer = null);
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.TokenRevocationClient = void 0;
            var n = r(0), i = r(2), o = r(1);
            function s(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            var a = "access_token", u = "refresh_token";
            e.TokenRevocationClient = function() {
                function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.XMLHttpRequest, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService;
                    if (s(this, t), !e) throw n.Log.error("TokenRevocationClient.ctor: No settings provided"), new Error("No settings provided.");
                    this._settings = e, this._XMLHttpRequestCtor = r, this._metadataService = new a(this._settings);
                }
                return t.prototype.revoke = function t(e, r) {
                    var i = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "access_token";
                    if (!e) throw n.Log.error("TokenRevocationClient.revoke: No token provided"), new Error("No token provided.");
                    if (o !== a && o != u) throw n.Log.error("TokenRevocationClient.revoke: Invalid token type"), new Error("Invalid token type.");
                    return this._metadataService.getRevocationEndpoint().then(function(t) {
                        if (t) {
                            n.Log.debug("TokenRevocationClient.revoke: Revoking " + o);
                            var s = i._settings.client_id, a = i._settings.client_secret;
                            return i._revoke(t, s, a, e, o);
                        }
                        if (r) throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"), new Error("Revocation not supported");
                    });
                }, t.prototype._revoke = function t(e, r, i, o, s) {
                    var a = this;
                    return new Promise(function(t, u) {
                        var c = new a._XMLHttpRequestCtor;
                        c.open("POST", e), c.onload = function() {
                            n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status", c.status), 200 === c.status ? t() : u(Error(c.statusText + " (" + c.status + ")"));
                        }, c.onerror = function() {
                            n.Log.debug("TokenRevocationClient.revoke: Network Error."), u("Network Error");
                        };
                        var h = "client_id=" + encodeURIComponent(r);
                        i && (h += "&client_secret=" + encodeURIComponent(i)), h += "&token_type_hint=" + encodeURIComponent(s), h += "&token=" + encodeURIComponent(o), c.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), c.send(h);
                    });
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.CordovaPopupWindow = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0);
            e.CordovaPopupWindow = function() {
                function t(e) {
                    var r = this;
                    !function n(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this._promise = new Promise(function(t, e) {
                        r._resolve = t, r._reject = e;
                    }), this.features = e.popupWindowFeatures || "location=no,toolbar=no,zoom=no", this.target = e.popupWindowTarget || "_blank", this.redirect_uri = e.startUrl, i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: " + this.redirect_uri);
                }
                return t.prototype._isInAppBrowserInstalled = function t(e) {
                    return [
                        "cordova-plugin-inappbrowser",
                        "cordova-plugin-inappbrowser.inappbrowser",
                        "org.apache.cordova.inappbrowser"
                    ].some(function(t) {
                        return e.hasOwnProperty(t);
                    });
                }, t.prototype.navigate = function t(e) {
                    if (e && e.url) {
                        if (!window.cordova) return this._error("cordova is undefined");
                        var r = window.cordova.require("cordova/plugin_list").metadata;
                        if (!1 === this._isInAppBrowserInstalled(r)) return this._error("InAppBrowser plugin not found");
                        this._popup = cordova.InAppBrowser.open(e.url, this.target, this.features), this._popup ? (i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"), this._exitCallbackEvent = this._exitCallback.bind(this), this._loadStartCallbackEvent = this._loadStartCallback.bind(this), this._popup.addEventListener("exit", this._exitCallbackEvent, !1), this._popup.addEventListener("loadstart", this._loadStartCallbackEvent, !1)) : this._error("Error opening popup window");
                    } else this._error("No url provided");
                    return this.promise;
                }, t.prototype._loadStartCallback = function t(e) {
                    0 === e.url.indexOf(this.redirect_uri) && this._success({
                        url: e.url
                    });
                }, t.prototype._exitCallback = function t(e) {
                    this._error(e);
                }, t.prototype._success = function t(e) {
                    this._cleanup(), i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"), this._resolve(e);
                }, t.prototype._error = function t(e) {
                    this._cleanup(), i.Log.error(e), this._reject(new Error(e));
                }, t.prototype.close = function t() {
                    this._cleanup();
                }, t.prototype._cleanup = function t() {
                    this._popup && (i.Log.debug("CordovaPopupWindow: cleaning up popup"), this._popup.removeEventListener("exit", this._exitCallbackEvent, !1), this._popup.removeEventListener("loadstart", this._loadStartCallbackEvent, !1), this._popup.close()), this._popup = null;
                }, n(t, [
                    {
                        key: "promise",
                        get: function t() {
                            return this._promise;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = r(0), i = r(10), o = r(5), s = r(6), a = r(37), u = r(38), c = r(16), h = r(2), l = r(48), f = r(49), g = r(19), d = r(20), p = r(18), v = r(1), y = r(15), m = r(50);
            e.default = {
                Version: m.Version,
                Log: n.Log,
                OidcClient: i.OidcClient,
                OidcClientSettings: o.OidcClientSettings,
                WebStorageStateStore: s.WebStorageStateStore,
                InMemoryWebStorage: a.InMemoryWebStorage,
                UserManager: u.UserManager,
                AccessTokenEvents: c.AccessTokenEvents,
                MetadataService: h.MetadataService,
                CordovaPopupNavigator: l.CordovaPopupNavigator,
                CordovaIFrameNavigator: f.CordovaIFrameNavigator,
                CheckSessionIFrame: g.CheckSessionIFrame,
                TokenRevocationClient: d.TokenRevocationClient,
                SessionMonitor: p.SessionMonitor,
                Global: v.Global,
                User: y.User
            }, t.exports = e.default;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            e.ClockService = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.prototype.getEpochTime = function t() {
                    return Promise.resolve(Date.now() / 1e3 | 0);
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.ResponseValidator = void 0;
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, i = r(0), o = r(2), s = r(25), a = r(11), u = r(12), c = r(4);
            function h(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            var l = [
                "nonce",
                "at_hash",
                "iat",
                "nbf",
                "exp",
                "aud",
                "iss",
                "c_hash"
            ];
            e.ResponseValidator = function() {
                function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.MetadataService, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s.UserInfoService, u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : c.JoseUtil, l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : a.TokenClient;
                    if (h(this, t), !e) throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"), new Error("settings");
                    this._settings = e, this._metadataService = new r(this._settings), this._userInfoService = new n(this._settings), this._joseUtil = u, this._tokenClient = new l(this._settings);
                }
                return t.prototype.validateSigninResponse = function t(e, r) {
                    var n = this;
                    return i.Log.debug("ResponseValidator.validateSigninResponse"), this._processSigninParams(e, r).then(function(t) {
                        return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"), n._validateTokens(e, t).then(function(t) {
                            return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"), n._processClaims(e, t).then(function(t) {
                                return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"), t;
                            });
                        });
                    });
                }, t.prototype.validateSignoutResponse = function t(e, r) {
                    return e.id !== r.state ? (i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"), Promise.reject(new Error("State does not match"))) : (i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"), r.state = e.data, r.error ? (i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error", r.error), Promise.reject(new u.ErrorResponse(r))) : Promise.resolve(r));
                }, t.prototype._processSigninParams = function t(e, r) {
                    if (e.id !== r.state) return i.Log.error("ResponseValidator._processSigninParams: State does not match"), Promise.reject(new Error("State does not match"));
                    if (!e.client_id) return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"), Promise.reject(new Error("No client_id on state"));
                    if (!e.authority) return i.Log.error("ResponseValidator._processSigninParams: No authority on state"), Promise.reject(new Error("No authority on state"));
                    if (this._settings.authority) {
                        if (this._settings.authority && this._settings.authority !== e.authority) return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"), Promise.reject(new Error("authority mismatch on settings vs. signin state"));
                    } else this._settings.authority = e.authority;
                    if (this._settings.client_id) {
                        if (this._settings.client_id && this._settings.client_id !== e.client_id) return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"), Promise.reject(new Error("client_id mismatch on settings vs. signin state"));
                    } else this._settings.client_id = e.client_id;
                    return i.Log.debug("ResponseValidator._processSigninParams: state validated"), r.state = e.data, r.error ? (i.Log.warn("ResponseValidator._processSigninParams: Response was error", r.error), Promise.reject(new u.ErrorResponse(r))) : e.nonce && !r.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"), Promise.reject(new Error("No id_token in response"))) : !e.nonce && r.id_token ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"), Promise.reject(new Error("Unexpected id_token in response"))) : e.code_verifier && !r.code ? (i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"), Promise.reject(new Error("No code in response"))) : !e.code_verifier && r.code ? (i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"), Promise.reject(new Error("Unexpected code in response"))) : (r.scope || (r.scope = e.scope), Promise.resolve(r));
                }, t.prototype._processClaims = function t(e, r) {
                    var n = this;
                    if (r.isOpenIdConnect) {
                        if (i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"), r.profile = this._filterProtocolClaims(r.profile), !0 !== e.skipUserInfo && this._settings.loadUserInfo && r.access_token) return i.Log.debug("ResponseValidator._processClaims: loading user info"), this._userInfoService.getClaims(r.access_token).then(function(t) {
                            return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"), t.sub !== r.profile.sub ? (i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in id_token"), Promise.reject(new Error("sub from user info endpoint does not match sub in id_token"))) : (r.profile = n._mergeClaims(r.profile, t), i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:", r.profile), r);
                        });
                        i.Log.debug("ResponseValidator._processClaims: not loading user info");
                    } else i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");
                    return Promise.resolve(r);
                }, t.prototype._mergeClaims = function t(e, r) {
                    var i = Object.assign({}, e);
                    for(var o in r){
                        var s = r[o];
                        Array.isArray(s) || (s = [
                            s
                        ]);
                        for(var a = 0; a < s.length; a++){
                            var u = s[a];
                            i[o] ? Array.isArray(i[o]) ? i[o].indexOf(u) < 0 && i[o].push(u) : i[o] !== u && ("object" === (void 0 === u ? "undefined" : n(u)) && this._settings.mergeClaims ? i[o] = this._mergeClaims(i[o], u) : i[o] = [
                                i[o],
                                u
                            ]) : i[o] = u;
                        }
                    }
                    return i;
                }, t.prototype._filterProtocolClaims = function t(e) {
                    i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:", e);
                    var r = Object.assign({}, e);
                    return this._settings._filterProtocolClaims ? (l.forEach(function(t) {
                        delete r[t];
                    }), i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered", r)) : i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"), r;
                }, t.prototype._validateTokens = function t(e, r) {
                    return r.code ? (i.Log.debug("ResponseValidator._validateTokens: Validating code"), this._processCode(e, r)) : r.id_token ? r.access_token ? (i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"), this._validateIdTokenAndAccessToken(e, r)) : (i.Log.debug("ResponseValidator._validateTokens: Validating id_token"), this._validateIdToken(e, r)) : (i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"), Promise.resolve(r));
                }, t.prototype._processCode = function t(e, r) {
                    var o = this, s = {
                        client_id: e.client_id,
                        client_secret: e.client_secret,
                        code: r.code,
                        redirect_uri: e.redirect_uri,
                        code_verifier: e.code_verifier
                    };
                    return e.extraTokenParams && "object" === n(e.extraTokenParams) && Object.assign(s, e.extraTokenParams), this._tokenClient.exchangeCode(s).then(function(t) {
                        for(var n in t)r[n] = t[n];
                        return r.id_token ? (i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"), o._validateIdTokenAttributes(e, r)) : (i.Log.debug("ResponseValidator._processCode: token response successful, returning response"), r);
                    });
                }, t.prototype._validateIdTokenAttributes = function t(e, r) {
                    var n = this;
                    return this._metadataService.getIssuer().then(function(t) {
                        var o = e.client_id, s = n._settings.clockSkew;
                        return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ", s), n._settings.getEpochTime().then(function(a) {
                            return n._joseUtil.validateJwtAttributes(r.id_token, t, o, s, a).then(function(t) {
                                return e.nonce && e.nonce !== t.nonce ? (i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : t.sub ? (r.profile = t, r) : (i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
                            });
                        });
                    });
                }, t.prototype._validateIdTokenAndAccessToken = function t(e, r) {
                    var n = this;
                    return this._validateIdToken(e, r).then(function(t) {
                        return n._validateAccessToken(t);
                    });
                }, t.prototype._getSigningKeyForJwt = function t(e) {
                    var r = this;
                    return this._metadataService.getSigningKeys().then(function(t) {
                        var n = e.header.kid;
                        if (!t) return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));
                        i.Log.debug("ResponseValidator._validateIdToken: Received signing keys");
                        var o = void 0;
                        if (n) o = t.filter(function(t) {
                            return t.kid === n;
                        })[0];
                        else {
                            if ((t = r._filterByAlg(t, e.header.alg)).length > 1) return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                            o = t[0];
                        }
                        return Promise.resolve(o);
                    });
                }, t.prototype._getSigningKeyForJwtWithSingleRetry = function t(e) {
                    var r = this;
                    return this._getSigningKeyForJwt(e).then(function(t) {
                        return t ? Promise.resolve(t) : (r._metadataService.resetSigningKeys(), r._getSigningKeyForJwt(e));
                    });
                }, t.prototype._validateIdToken = function t(e, r) {
                    var n = this;
                    if (!e.nonce) return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"), Promise.reject(new Error("No nonce on state"));
                    var o = this._joseUtil.parseJwt(r.id_token);
                    return o && o.header && o.payload ? e.nonce !== o.payload.nonce ? (i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"), Promise.reject(new Error("Invalid nonce in id_token"))) : this._metadataService.getIssuer().then(function(t) {
                        return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"), n._getSigningKeyForJwtWithSingleRetry(o).then(function(s) {
                            if (!s) return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));
                            var a = e.client_id, u = n._settings.clockSkew;
                            return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ", u), n._joseUtil.validateJwt(r.id_token, s, t, a, u).then(function() {
                                return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"), o.payload.sub ? (r.profile = o.payload, r) : (i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"), Promise.reject(new Error("No sub present in id_token")));
                            });
                        });
                    }) : (i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token", o), Promise.reject(new Error("Failed to parse id_token")));
                }, t.prototype._filterByAlg = function t(e, r) {
                    var n = null;
                    if (r.startsWith("RS")) n = "RSA";
                    else if (r.startsWith("PS")) n = "PS";
                    else {
                        if (!r.startsWith("ES")) return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ", r), [];
                        n = "EC";
                    }
                    return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ", n), e = e.filter(function(t) {
                        return t.kty === n;
                    }), i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ", n, e.length), e;
                }, t.prototype._validateAccessToken = function t(e) {
                    if (!e.profile) return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"), Promise.reject(new Error("No profile loaded from id_token"));
                    if (!e.profile.at_hash) return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"), Promise.reject(new Error("No at_hash in id_token"));
                    if (!e.id_token) return i.Log.error("ResponseValidator._validateAccessToken: No id_token"), Promise.reject(new Error("No id_token"));
                    var r = this._joseUtil.parseJwt(e.id_token);
                    if (!r || !r.header) return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token", r), Promise.reject(new Error("Failed to parse id_token"));
                    var n = r.header.alg;
                    if (!n || 5 !== n.length) return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n), Promise.reject(new Error("Unsupported alg: " + n));
                    var o = n.substr(2, 3);
                    if (!o) return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n, o), Promise.reject(new Error("Unsupported alg: " + n));
                    if (256 !== (o = parseInt(o)) && 384 !== o && 512 !== o) return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:", n, o), Promise.reject(new Error("Unsupported alg: " + n));
                    var s = "sha" + o, a = this._joseUtil.hashString(e.access_token, s);
                    if (!a) return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:", s), Promise.reject(new Error("Failed to validate at_hash"));
                    var u = a.substr(0, a.length / 2), c = this._joseUtil.hexToBase64Url(u);
                    return c !== e.profile.at_hash ? (i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash", c, e.profile.at_hash), Promise.reject(new Error("Failed to validate at_hash"))) : (i.Log.debug("ResponseValidator._validateAccessToken: success"), Promise.resolve(e));
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.UserInfoService = void 0;
            var n = r(7), i = r(2), o = r(0), s = r(4);
            function a(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.UserInfoService = function() {
                function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.JsonService, u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.MetadataService, c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : s.JoseUtil;
                    if (a(this, t), !e) throw o.Log.error("UserInfoService.ctor: No settings passed"), new Error("settings");
                    this._settings = e, this._jsonService = new r(void 0, void 0, this._getClaimsFromJwt.bind(this)), this._metadataService = new u(this._settings), this._joseUtil = c;
                }
                return t.prototype.getClaims = function t(e) {
                    var r = this;
                    return e ? this._metadataService.getUserInfoEndpoint().then(function(t) {
                        return o.Log.debug("UserInfoService.getClaims: received userinfo url", t), r._jsonService.getJson(t, e).then(function(t) {
                            return o.Log.debug("UserInfoService.getClaims: claims received", t), t;
                        });
                    }) : (o.Log.error("UserInfoService.getClaims: No token passed"), Promise.reject(new Error("A token is required")));
                }, t.prototype._getClaimsFromJwt = function t(e) {
                    var r = this;
                    try {
                        var n = this._joseUtil.parseJwt(e.responseText);
                        if (!n || !n.header || !n.payload) return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT", n), Promise.reject(new Error("Failed to parse id_token"));
                        var i = n.header.kid, s = void 0;
                        switch(this._settings.userInfoJwtIssuer){
                            case "OP":
                                s = this._metadataService.getIssuer();
                                break;
                            case "ANY":
                                s = Promise.resolve(n.payload.iss);
                                break;
                            default:
                                s = Promise.resolve(this._settings.userInfoJwtIssuer);
                        }
                        return s.then(function(t) {
                            return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:" + t), r._metadataService.getSigningKeys().then(function(s) {
                                if (!s) return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"), Promise.reject(new Error("No signing keys from metadata"));
                                o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys");
                                var a = void 0;
                                if (i) a = s.filter(function(t) {
                                    return t.kid === i;
                                })[0];
                                else {
                                    if ((s = r._filterByAlg(s, n.header.alg)).length > 1) return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"), Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));
                                    a = s[0];
                                }
                                if (!a) return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"), Promise.reject(new Error("No key matching kid or alg found in signing keys"));
                                var u = r._settings.client_id, c = r._settings.clockSkew;
                                return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ", c), r._joseUtil.validateJwt(e.responseText, a, t, u, c, void 0, !0).then(function() {
                                    return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"), n.payload;
                                });
                            });
                        });
                    } catch (t) {
                        return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response", t.message), void reject(t);
                    }
                }, t.prototype._filterByAlg = function t(e, r) {
                    var n = null;
                    if (r.startsWith("RS")) n = "RSA";
                    else if (r.startsWith("PS")) n = "PS";
                    else {
                        if (!r.startsWith("ES")) return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ", r), [];
                        n = "EC";
                    }
                    return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ", n), e = e.filter(function(t) {
                        return t.kty === n;
                    }), o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ", n, e.length), e;
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.AllowedSigningAlgs = e.b64tohex = e.hextob64u = e.crypto = e.X509 = e.KeyUtil = e.jws = void 0;
            var n = r(27);
            e.jws = n.jws, e.KeyUtil = n.KEYUTIL, e.X509 = n.X509, e.crypto = n.crypto, e.hextob64u = n.hextob64u, e.b64tohex = n.b64tohex, e.AllowedSigningAlgs = [
                "RS256",
                "RS384",
                "RS512",
                "PS256",
                "PS384",
                "PS512",
                "ES256",
                "ES384",
                "ES512"
            ];
        },
        function(t, e, r) {
            "use strict";
            (function(t) {
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, n = {
                    userAgent: !1
                }, i = {};
                /*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/ if (void 0 === o) var o = {};
                o.lang = {
                    extend: function t(e, r, i) {
                        if (!r || !e) throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");
                        var o = function t() {};
                        if (o.prototype = r.prototype, e.prototype = new o, e.prototype.constructor = e, e.superclass = r.prototype, r.prototype.constructor == Object.prototype.constructor && (r.prototype.constructor = r), i) {
                            var s;
                            for(s in i)e.prototype[s] = i[s];
                            var a = function t() {}, u = [
                                "toString",
                                "valueOf"
                            ];
                            try {
                                /MSIE/.test(n.userAgent) && (a = function t(e, r) {
                                    for(s = 0; s < u.length; s += 1){
                                        var n = u[s], i = r[n];
                                        "function" == typeof i && i != Object.prototype[n] && (e[n] = i);
                                    }
                                });
                            } catch (t) {}
                            a(e.prototype, i);
                        }
                    }
                };
                /*! CryptoJS v3.1.2 core-fix.js
 * code.google.com/p/crypto-js
 * (c) 2009-2013 by Jeff Mott. All rights reserved.
 * code.google.com/p/crypto-js/wiki/License
 * THIS IS FIX of 'core.js' to fix Hmac issue.
 * https://code.google.com/p/crypto-js/issues/detail?id=84
 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
 */ var s, a, u, c, h, l, f, g, d, p, v, y = y || (s = Math, u = (a = {}).lib = {}, c = u.Base = function() {
                    function t() {}
                    return {
                        extend: function e(r) {
                            t.prototype = this;
                            var n = new t;
                            return r && n.mixIn(r), n.hasOwnProperty("init") || (n.init = function() {
                                n.$super.init.apply(this, arguments);
                            }), n.init.prototype = n, n.$super = this, n;
                        },
                        create: function t() {
                            var e = this.extend();
                            return e.init.apply(e, arguments), e;
                        },
                        init: function t() {},
                        mixIn: function t(e) {
                            for(var r in e)e.hasOwnProperty(r) && (this[r] = e[r]);
                            e.hasOwnProperty("toString") && (this.toString = e.toString);
                        },
                        clone: function t() {
                            return this.init.prototype.extend(this);
                        }
                    };
                }(), h = u.WordArray = c.extend({
                    init: function t(e, r) {
                        e = this.words = e || [], this.sigBytes = null != r ? r : 4 * e.length;
                    },
                    toString: function t(e) {
                        return (e || f).stringify(this);
                    },
                    concat: function t(e) {
                        var r = this.words, n = e.words, i = this.sigBytes, o = e.sigBytes;
                        if (this.clamp(), i % 4) for(var s = 0; s < o; s++){
                            var a = n[s >>> 2] >>> 24 - s % 4 * 8 & 255;
                            r[i + s >>> 2] |= a << 24 - (i + s) % 4 * 8;
                        }
                        else for(s = 0; s < o; s += 4)r[i + s >>> 2] = n[s >>> 2];
                        return this.sigBytes += o, this;
                    },
                    clamp: function t() {
                        var e = this.words, r = this.sigBytes;
                        e[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, e.length = s.ceil(r / 4);
                    },
                    clone: function t() {
                        var e = c.clone.call(this);
                        return e.words = this.words.slice(0), e;
                    },
                    random: function t(e) {
                        for(var r = [], n = 0; n < e; n += 4)r.push(4294967296 * s.random() | 0);
                        return new h.init(r, e);
                    }
                }), l = a.enc = {}, f = l.Hex = {
                    stringify: function t(e) {
                        for(var r = e.words, n = e.sigBytes, i = [], o = 0; o < n; o++){
                            var s = r[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                            i.push((s >>> 4).toString(16)), i.push((15 & s).toString(16));
                        }
                        return i.join("");
                    },
                    parse: function t(e) {
                        for(var r = e.length, n = [], i = 0; i < r; i += 2)n[i >>> 3] |= parseInt(e.substr(i, 2), 16) << 24 - i % 8 * 4;
                        return new h.init(n, r / 2);
                    }
                }, g = l.Latin1 = {
                    stringify: function t(e) {
                        for(var r = e.words, n = e.sigBytes, i = [], o = 0; o < n; o++){
                            var s = r[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                            i.push(String.fromCharCode(s));
                        }
                        return i.join("");
                    },
                    parse: function t(e) {
                        for(var r = e.length, n = [], i = 0; i < r; i++)n[i >>> 2] |= (255 & e.charCodeAt(i)) << 24 - i % 4 * 8;
                        return new h.init(n, r);
                    }
                }, d = l.Utf8 = {
                    stringify: function t(e) {
                        try {
                            return decodeURIComponent(escape(g.stringify(e)));
                        } catch (t) {
                            throw new Error("Malformed UTF-8 data");
                        }
                    },
                    parse: function t(e) {
                        return g.parse(unescape(encodeURIComponent(e)));
                    }
                }, p = u.BufferedBlockAlgorithm = c.extend({
                    reset: function t() {
                        this._data = new h.init, this._nDataBytes = 0;
                    },
                    _append: function t(e) {
                        "string" == typeof e && (e = d.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes;
                    },
                    _process: function t(e) {
                        var r = this._data, n = r.words, i = r.sigBytes, o = this.blockSize, a = i / (4 * o), u = (a = e ? s.ceil(a) : s.max((0 | a) - this._minBufferSize, 0)) * o, c = s.min(4 * u, i);
                        if (u) {
                            for(var l = 0; l < u; l += o)this._doProcessBlock(n, l);
                            var f = n.splice(0, u);
                            r.sigBytes -= c;
                        }
                        return new h.init(f, c);
                    },
                    clone: function t() {
                        var e = c.clone.call(this);
                        return e._data = this._data.clone(), e;
                    },
                    _minBufferSize: 0
                }), u.Hasher = p.extend({
                    cfg: c.extend(),
                    init: function t(e) {
                        this.cfg = this.cfg.extend(e), this.reset();
                    },
                    reset: function t() {
                        p.reset.call(this), this._doReset();
                    },
                    update: function t(e) {
                        return this._append(e), this._process(), this;
                    },
                    finalize: function t(e) {
                        return e && this._append(e), this._doFinalize();
                    },
                    blockSize: 16,
                    _createHelper: function t(e) {
                        return function(t, r) {
                            return new e.init(r).finalize(t);
                        };
                    },
                    _createHmacHelper: function t(e) {
                        return function(t, r) {
                            return new v.HMAC.init(e, r).finalize(t);
                        };
                    }
                }), v = a.algo = {}, a);
                !function(t) {
                    var e, r = (e = y).lib, n = r.Base, i = r.WordArray;
                    (e = e.x64 = {}).Word = n.extend({
                        init: function t(e, r) {
                            this.high = e, this.low = r;
                        }
                    }), e.WordArray = n.extend({
                        init: function t(e, r) {
                            e = this.words = e || [], this.sigBytes = null != r ? r : 8 * e.length;
                        },
                        toX32: function t() {
                            for(var e = this.words, r = e.length, n = [], o = 0; o < r; o++){
                                var s = e[o];
                                n.push(s.high), n.push(s.low);
                            }
                            return i.create(n, this.sigBytes);
                        },
                        clone: function t() {
                            for(var e = n.clone.call(this), r = e.words = this.words.slice(0), i = r.length, o = 0; o < i; o++)r[o] = r[o].clone();
                            return e;
                        }
                    });
                }(), function() {
                    var t = y, e = t.lib.WordArray;
                    t.enc.Base64 = {
                        stringify: function t(e) {
                            var r = e.words, n = e.sigBytes, i = this._map;
                            e.clamp(), e = [];
                            for(var o = 0; o < n; o += 3)for(var s = (r[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (r[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | r[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, a = 0; 4 > a && o + .75 * a < n; a++)e.push(i.charAt(s >>> 6 * (3 - a) & 63));
                            if (r = i.charAt(64)) for(; e.length % 4;)e.push(r);
                            return e.join("");
                        },
                        parse: function t(r) {
                            var n = r.length, i = this._map;
                            (o = i.charAt(64)) && -1 != (o = r.indexOf(o)) && (n = o);
                            for(var o = [], s = 0, a = 0; a < n; a++)if (a % 4) {
                                var u = i.indexOf(r.charAt(a - 1)) << a % 4 * 2, c = i.indexOf(r.charAt(a)) >>> 6 - a % 4 * 2;
                                o[s >>> 2] |= (u | c) << 24 - s % 4 * 8, s++;
                            }
                            return e.create(o, s);
                        },
                        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
                    };
                }(), function(t) {
                    for(var e = y, r = (i = e.lib).WordArray, n = i.Hasher, i = e.algo, o = [], s = [], a = function t(e) {
                        return 4294967296 * (e - (0 | e)) | 0;
                    }, u = 2, c = 0; 64 > c;){
                        var h;
                        t: {
                            h = u;
                            for(var l = t.sqrt(h), f = 2; f <= l; f++)if (!(h % f)) {
                                h = !1;
                                break t;
                            }
                            h = !0;
                        }
                        h && (8 > c && (o[c] = a(t.pow(u, .5))), s[c] = a(t.pow(u, 1 / 3)), c++), u++;
                    }
                    var g = [];
                    i = i.SHA256 = n.extend({
                        _doReset: function t() {
                            this._hash = new r.init(o.slice(0));
                        },
                        _doProcessBlock: function t(e, r) {
                            for(var n = this._hash.words, i = n[0], o = n[1], a = n[2], u = n[3], c = n[4], h = n[5], l = n[6], f = n[7], d = 0; 64 > d; d++){
                                if (16 > d) g[d] = 0 | e[r + d];
                                else {
                                    var p = g[d - 15], v = g[d - 2];
                                    g[d] = ((p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3) + g[d - 7] + ((v << 15 | v >>> 17) ^ (v << 13 | v >>> 19) ^ v >>> 10) + g[d - 16];
                                }
                                p = f + ((c << 26 | c >>> 6) ^ (c << 21 | c >>> 11) ^ (c << 7 | c >>> 25)) + (c & h ^ ~c & l) + s[d] + g[d], v = ((i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22)) + (i & o ^ i & a ^ o & a), f = l, l = h, h = c, c = u + p | 0, u = a, a = o, o = i, i = p + v | 0;
                            }
                            n[0] = n[0] + i | 0, n[1] = n[1] + o | 0, n[2] = n[2] + a | 0, n[3] = n[3] + u | 0, n[4] = n[4] + c | 0, n[5] = n[5] + h | 0, n[6] = n[6] + l | 0, n[7] = n[7] + f | 0;
                        },
                        _doFinalize: function e() {
                            var r = this._data, n = r.words, i = 8 * this._nDataBytes, o = 8 * r.sigBytes;
                            return n[o >>> 5] |= 128 << 24 - o % 32, n[14 + (o + 64 >>> 9 << 4)] = t.floor(i / 4294967296), n[15 + (o + 64 >>> 9 << 4)] = i, r.sigBytes = 4 * n.length, this._process(), this._hash;
                        },
                        clone: function t() {
                            var e = n.clone.call(this);
                            return e._hash = this._hash.clone(), e;
                        }
                    });
                    e.SHA256 = n._createHelper(i), e.HmacSHA256 = n._createHmacHelper(i);
                }(Math), function() {
                    function t() {
                        return n.create.apply(n, arguments);
                    }
                    for(var e = y, r = e.lib.Hasher, n = (o = e.x64).Word, i = o.WordArray, o = e.algo, s = [
                        t(1116352408, 3609767458),
                        t(1899447441, 602891725),
                        t(3049323471, 3964484399),
                        t(3921009573, 2173295548),
                        t(961987163, 4081628472),
                        t(1508970993, 3053834265),
                        t(2453635748, 2937671579),
                        t(2870763221, 3664609560),
                        t(3624381080, 2734883394),
                        t(310598401, 1164996542),
                        t(607225278, 1323610764),
                        t(1426881987, 3590304994),
                        t(1925078388, 4068182383),
                        t(2162078206, 991336113),
                        t(2614888103, 633803317),
                        t(3248222580, 3479774868),
                        t(3835390401, 2666613458),
                        t(4022224774, 944711139),
                        t(264347078, 2341262773),
                        t(604807628, 2007800933),
                        t(770255983, 1495990901),
                        t(1249150122, 1856431235),
                        t(1555081692, 3175218132),
                        t(1996064986, 2198950837),
                        t(2554220882, 3999719339),
                        t(2821834349, 766784016),
                        t(2952996808, 2566594879),
                        t(3210313671, 3203337956),
                        t(3336571891, 1034457026),
                        t(3584528711, 2466948901),
                        t(113926993, 3758326383),
                        t(338241895, 168717936),
                        t(666307205, 1188179964),
                        t(773529912, 1546045734),
                        t(1294757372, 1522805485),
                        t(1396182291, 2643833823),
                        t(1695183700, 2343527390),
                        t(1986661051, 1014477480),
                        t(2177026350, 1206759142),
                        t(2456956037, 344077627),
                        t(2730485921, 1290863460),
                        t(2820302411, 3158454273),
                        t(3259730800, 3505952657),
                        t(3345764771, 106217008),
                        t(3516065817, 3606008344),
                        t(3600352804, 1432725776),
                        t(4094571909, 1467031594),
                        t(275423344, 851169720),
                        t(430227734, 3100823752),
                        t(506948616, 1363258195),
                        t(659060556, 3750685593),
                        t(883997877, 3785050280),
                        t(958139571, 3318307427),
                        t(1322822218, 3812723403),
                        t(1537002063, 2003034995),
                        t(1747873779, 3602036899),
                        t(1955562222, 1575990012),
                        t(2024104815, 1125592928),
                        t(2227730452, 2716904306),
                        t(2361852424, 442776044),
                        t(2428436474, 593698344),
                        t(2756734187, 3733110249),
                        t(3204031479, 2999351573),
                        t(3329325298, 3815920427),
                        t(3391569614, 3928383900),
                        t(3515267271, 566280711),
                        t(3940187606, 3454069534),
                        t(4118630271, 4000239992),
                        t(116418474, 1914138554),
                        t(174292421, 2731055270),
                        t(289380356, 3203993006),
                        t(460393269, 320620315),
                        t(685471733, 587496836),
                        t(852142971, 1086792851),
                        t(1017036298, 365543100),
                        t(1126000580, 2618297676),
                        t(1288033470, 3409855158),
                        t(1501505948, 4234509866),
                        t(1607167915, 987167468),
                        t(1816402316, 1246189591)
                    ], a = [], u = 0; 80 > u; u++)a[u] = t();
                    o = o.SHA512 = r.extend({
                        _doReset: function t() {
                            this._hash = new i.init([
                                new n.init(1779033703, 4089235720),
                                new n.init(3144134277, 2227873595),
                                new n.init(1013904242, 4271175723),
                                new n.init(2773480762, 1595750129),
                                new n.init(1359893119, 2917565137),
                                new n.init(2600822924, 725511199),
                                new n.init(528734635, 4215389547),
                                new n.init(1541459225, 327033209)
                            ]);
                        },
                        _doProcessBlock: function t(e, r) {
                            for(var n = (f = this._hash.words)[0], i = f[1], o = f[2], u = f[3], c = f[4], h = f[5], l = f[6], f = f[7], g = n.high, d = n.low, p = i.high, v = i.low, y = o.high, m = o.low, _ = u.high, S = u.low, b = c.high, w = c.low, F = h.high, E = h.low, x = l.high, A = l.low, k = f.high, P = f.low, C = g, T = d, R = p, I = v, D = y, L = m, N = _, U = S, B = b, O = w, j = F, M = E, H = x, V = A, K = k, q = P, J = 0; 80 > J; J++){
                                var W = a[J];
                                if (16 > J) var z = W.high = 0 | e[r + 2 * J], Y = W.low = 0 | e[r + 2 * J + 1];
                                else {
                                    z = ((Y = (z = a[J - 15]).high) >>> 1 | (G = z.low) << 31) ^ (Y >>> 8 | G << 24) ^ Y >>> 7;
                                    var G = (G >>> 1 | Y << 31) ^ (G >>> 8 | Y << 24) ^ (G >>> 7 | Y << 25), X = ((Y = (X = a[J - 2]).high) >>> 19 | ($ = X.low) << 13) ^ (Y << 3 | $ >>> 29) ^ Y >>> 6, $ = ($ >>> 19 | Y << 13) ^ ($ << 3 | Y >>> 29) ^ ($ >>> 6 | Y << 26), Q = (Y = a[J - 7]).high, Z = (tt = a[J - 16]).high, tt = tt.low;
                                    z = (z = (z = z + Q + ((Y = G + Y.low) >>> 0 < G >>> 0 ? 1 : 0)) + X + ((Y = Y + $) >>> 0 < $ >>> 0 ? 1 : 0)) + Z + ((Y = Y + tt) >>> 0 < tt >>> 0 ? 1 : 0);
                                    W.high = z, W.low = Y;
                                }
                                Q = B & j ^ ~B & H, tt = O & M ^ ~O & V, W = C & R ^ C & D ^ R & D;
                                var et = T & I ^ T & L ^ I & L, rt = (G = (C >>> 28 | T << 4) ^ (C << 30 | T >>> 2) ^ (C << 25 | T >>> 7), X = (T >>> 28 | C << 4) ^ (T << 30 | C >>> 2) ^ (T << 25 | C >>> 7), ($ = s[J]).high), nt = $.low;
                                Z = K + ((B >>> 14 | O << 18) ^ (B >>> 18 | O << 14) ^ (B << 23 | O >>> 9)) + (($ = q + ((O >>> 14 | B << 18) ^ (O >>> 18 | B << 14) ^ (O << 23 | B >>> 9))) >>> 0 < q >>> 0 ? 1 : 0), K = H, q = V, H = j, V = M, j = B, M = O, B = N + (Z = (Z = (Z = Z + Q + (($ = $ + tt) >>> 0 < tt >>> 0 ? 1 : 0)) + rt + (($ = $ + nt) >>> 0 < nt >>> 0 ? 1 : 0)) + z + (($ = $ + Y) >>> 0 < Y >>> 0 ? 1 : 0)) + ((O = U + $ | 0) >>> 0 < U >>> 0 ? 1 : 0) | 0, N = D, U = L, D = R, L = I, R = C, I = T, C = Z + (W = G + W + ((Y = X + et) >>> 0 < X >>> 0 ? 1 : 0)) + ((T = $ + Y | 0) >>> 0 < $ >>> 0 ? 1 : 0) | 0;
                            }
                            d = n.low = d + T, n.high = g + C + (d >>> 0 < T >>> 0 ? 1 : 0), v = i.low = v + I, i.high = p + R + (v >>> 0 < I >>> 0 ? 1 : 0), m = o.low = m + L, o.high = y + D + (m >>> 0 < L >>> 0 ? 1 : 0), S = u.low = S + U, u.high = _ + N + (S >>> 0 < U >>> 0 ? 1 : 0), w = c.low = w + O, c.high = b + B + (w >>> 0 < O >>> 0 ? 1 : 0), E = h.low = E + M, h.high = F + j + (E >>> 0 < M >>> 0 ? 1 : 0), A = l.low = A + V, l.high = x + H + (A >>> 0 < V >>> 0 ? 1 : 0), P = f.low = P + q, f.high = k + K + (P >>> 0 < q >>> 0 ? 1 : 0);
                        },
                        _doFinalize: function t() {
                            var e = this._data, r = e.words, n = 8 * this._nDataBytes, i = 8 * e.sigBytes;
                            return r[i >>> 5] |= 128 << 24 - i % 32, r[30 + (i + 128 >>> 10 << 5)] = Math.floor(n / 4294967296), r[31 + (i + 128 >>> 10 << 5)] = n, e.sigBytes = 4 * r.length, this._process(), this._hash.toX32();
                        },
                        clone: function t() {
                            var e = r.clone.call(this);
                            return e._hash = this._hash.clone(), e;
                        },
                        blockSize: 32
                    }), e.SHA512 = r._createHelper(o), e.HmacSHA512 = r._createHmacHelper(o);
                }(), function() {
                    var t = y, e = (i = t.x64).Word, r = i.WordArray, n = (i = t.algo).SHA512, i = i.SHA384 = n.extend({
                        _doReset: function t() {
                            this._hash = new r.init([
                                new e.init(3418070365, 3238371032),
                                new e.init(1654270250, 914150663),
                                new e.init(2438529370, 812702999),
                                new e.init(355462360, 4144912697),
                                new e.init(1731405415, 4290775857),
                                new e.init(2394180231, 1750603025),
                                new e.init(3675008525, 1694076839),
                                new e.init(1203062813, 3204075428)
                            ]);
                        },
                        _doFinalize: function t() {
                            var e = n._doFinalize.call(this);
                            return e.sigBytes -= 16, e;
                        }
                    });
                    t.SHA384 = n._createHelper(i), t.HmacSHA384 = n._createHmacHelper(i);
                }();
                /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ var m, _ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                function S(t) {
                    var e, r, n = "";
                    for(e = 0; e + 3 <= t.length; e += 3)r = parseInt(t.substring(e, e + 3), 16), n += _.charAt(r >> 6) + _.charAt(63 & r);
                    for(e + 1 == t.length ? (r = parseInt(t.substring(e, e + 1), 16), n += _.charAt(r << 2)) : e + 2 == t.length && (r = parseInt(t.substring(e, e + 2), 16), n += _.charAt(r >> 2) + _.charAt((3 & r) << 4)); (3 & n.length) > 0;)n += "=";
                    return n;
                }
                function b(t) {
                    var e, r, n, i = "", o = 0;
                    for(e = 0; e < t.length && "=" != t.charAt(e); ++e)(n = _.indexOf(t.charAt(e))) < 0 || (0 == o ? (i += R(n >> 2), r = 3 & n, o = 1) : 1 == o ? (i += R(r << 2 | n >> 4), r = 15 & n, o = 2) : 2 == o ? (i += R(r), i += R(n >> 2), r = 3 & n, o = 3) : (i += R(r << 2 | n >> 4), i += R(15 & n), o = 0));
                    return 1 == o && (i += R(r << 2)), i;
                }
                function w(t) {
                    var e, r = b(t), n = new Array;
                    for(e = 0; 2 * e < r.length; ++e)n[e] = parseInt(r.substring(2 * e, 2 * e + 2), 16);
                    return n;
                }
                function F(t, e, r) {
                    null != t && ("number" == typeof t ? this.fromNumber(t, e, r) : null == e && "string" != typeof t ? this.fromString(t, 256) : this.fromString(t, e));
                }
                function E() {
                    return new F(null);
                }
                "Microsoft Internet Explorer" == n.appName ? (F.prototype.am = function x(t, e, r, n, i, o) {
                    for(var s = 32767 & e, a = e >> 15; --o >= 0;){
                        var u = 32767 & this[t], c = this[t++] >> 15, h = a * u + c * s;
                        i = ((u = s * u + ((32767 & h) << 15) + r[n] + (1073741823 & i)) >>> 30) + (h >>> 15) + a * c + (i >>> 30), r[n++] = 1073741823 & u;
                    }
                    return i;
                }, m = 30) : "Netscape" != n.appName ? (F.prototype.am = function A(t, e, r, n, i, o) {
                    for(; --o >= 0;){
                        var s = e * this[t++] + r[n] + i;
                        i = Math.floor(s / 67108864), r[n++] = 67108863 & s;
                    }
                    return i;
                }, m = 26) : (F.prototype.am = function k(t, e, r, n, i, o) {
                    for(var s = 16383 & e, a = e >> 14; --o >= 0;){
                        var u = 16383 & this[t], c = this[t++] >> 14, h = a * u + c * s;
                        i = ((u = s * u + ((16383 & h) << 14) + r[n] + i) >> 28) + (h >> 14) + a * c, r[n++] = 268435455 & u;
                    }
                    return i;
                }, m = 28), F.prototype.DB = m, F.prototype.DM = (1 << m) - 1, F.prototype.DV = 1 << m;
                F.prototype.FV = Math.pow(2, 52), F.prototype.F1 = 52 - m, F.prototype.F2 = 2 * m - 52;
                var P, C, T = new Array;
                for(P = "0".charCodeAt(0), C = 0; C <= 9; ++C)T[P++] = C;
                for(P = "a".charCodeAt(0), C = 10; C < 36; ++C)T[P++] = C;
                for(P = "A".charCodeAt(0), C = 10; C < 36; ++C)T[P++] = C;
                function R(t) {
                    return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(t);
                }
                function I(t, e) {
                    var r = T[t.charCodeAt(e)];
                    return null == r ? -1 : r;
                }
                function D(t) {
                    var e = E();
                    return e.fromInt(t), e;
                }
                function L(t) {
                    var e, r = 1;
                    return 0 != (e = t >>> 16) && (t = e, r += 16), 0 != (e = t >> 8) && (t = e, r += 8), 0 != (e = t >> 4) && (t = e, r += 4), 0 != (e = t >> 2) && (t = e, r += 2), 0 != (e = t >> 1) && (t = e, r += 1), r;
                }
                function N(t) {
                    this.m = t;
                }
                function U(t) {
                    this.m = t, this.mp = t.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << t.DB - 15) - 1, this.mt2 = 2 * t.t;
                }
                function B(t, e) {
                    return t & e;
                }
                function O(t, e) {
                    return t | e;
                }
                function j(t, e) {
                    return t ^ e;
                }
                function M(t, e) {
                    return t & ~e;
                }
                function H(t) {
                    if (0 == t) return -1;
                    var e = 0;
                    return 0 == (65535 & t) && (t >>= 16, e += 16), 0 == (255 & t) && (t >>= 8, e += 8), 0 == (15 & t) && (t >>= 4, e += 4), 0 == (3 & t) && (t >>= 2, e += 2), 0 == (1 & t) && ++e, e;
                }
                function V(t) {
                    for(var e = 0; 0 != t;)t &= t - 1, ++e;
                    return e;
                }
                function K() {}
                function q(t) {
                    return t;
                }
                function J(t) {
                    this.r2 = E(), this.q3 = E(), F.ONE.dlShiftTo(2 * t.t, this.r2), this.mu = this.r2.divide(t), this.m = t;
                }
                N.prototype.convert = function W(t) {
                    return t.s < 0 || t.compareTo(this.m) >= 0 ? t.mod(this.m) : t;
                }, N.prototype.revert = function z(t) {
                    return t;
                }, N.prototype.reduce = function Y(t) {
                    t.divRemTo(this.m, null, t);
                }, N.prototype.mulTo = function G(t, e, r) {
                    t.multiplyTo(e, r), this.reduce(r);
                }, N.prototype.sqrTo = function X(t, e) {
                    t.squareTo(e), this.reduce(e);
                }, U.prototype.convert = function $(t) {
                    var e = E();
                    return t.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), t.s < 0 && e.compareTo(F.ZERO) > 0 && this.m.subTo(e, e), e;
                }, U.prototype.revert = function Q(t) {
                    var e = E();
                    return t.copyTo(e), this.reduce(e), e;
                }, U.prototype.reduce = function Z(t) {
                    for(; t.t <= this.mt2;)t[t.t++] = 0;
                    for(var e = 0; e < this.m.t; ++e){
                        var r = 32767 & t[e], n = r * this.mpl + ((r * this.mph + (t[e] >> 15) * this.mpl & this.um) << 15) & t.DM;
                        for(t[r = e + this.m.t] += this.m.am(0, n, t, e, 0, this.m.t); t[r] >= t.DV;)t[r] -= t.DV, t[++r]++;
                    }
                    t.clamp(), t.drShiftTo(this.m.t, t), t.compareTo(this.m) >= 0 && t.subTo(this.m, t);
                }, U.prototype.mulTo = function tt(t, e, r) {
                    t.multiplyTo(e, r), this.reduce(r);
                }, U.prototype.sqrTo = function et(t, e) {
                    t.squareTo(e), this.reduce(e);
                }, F.prototype.copyTo = function rt(t) {
                    for(var e = this.t - 1; e >= 0; --e)t[e] = this[e];
                    t.t = this.t, t.s = this.s;
                }, F.prototype.fromInt = function nt(t) {
                    this.t = 1, this.s = t < 0 ? -1 : 0, t > 0 ? this[0] = t : t < -1 ? this[0] = t + this.DV : this.t = 0;
                }, F.prototype.fromString = function it(t, e) {
                    var r;
                    if (16 == e) r = 4;
                    else if (8 == e) r = 3;
                    else if (256 == e) r = 8;
                    else if (2 == e) r = 1;
                    else if (32 == e) r = 5;
                    else {
                        if (4 != e) return void this.fromRadix(t, e);
                        r = 2;
                    }
                    this.t = 0, this.s = 0;
                    for(var n = t.length, i = !1, o = 0; --n >= 0;){
                        var s = 8 == r ? 255 & t[n] : I(t, n);
                        s < 0 ? "-" == t.charAt(n) && (i = !0) : (i = !1, 0 == o ? this[this.t++] = s : o + r > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - o) - 1) << o, this[this.t++] = s >> this.DB - o) : this[this.t - 1] |= s << o, (o += r) >= this.DB && (o -= this.DB));
                    }
                    8 == r && 0 != (128 & t[0]) && (this.s = -1, o > 0 && (this[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), i && F.ZERO.subTo(this, this);
                }, F.prototype.clamp = function ot() {
                    for(var t = this.s & this.DM; this.t > 0 && this[this.t - 1] == t;)--this.t;
                }, F.prototype.dlShiftTo = function st(t, e) {
                    var r;
                    for(r = this.t - 1; r >= 0; --r)e[r + t] = this[r];
                    for(r = t - 1; r >= 0; --r)e[r] = 0;
                    e.t = this.t + t, e.s = this.s;
                }, F.prototype.drShiftTo = function at(t, e) {
                    for(var r = t; r < this.t; ++r)e[r - t] = this[r];
                    e.t = Math.max(this.t - t, 0), e.s = this.s;
                }, F.prototype.lShiftTo = function ut(t, e) {
                    var r, n = t % this.DB, i = this.DB - n, o = (1 << i) - 1, s = Math.floor(t / this.DB), a = this.s << n & this.DM;
                    for(r = this.t - 1; r >= 0; --r)e[r + s + 1] = this[r] >> i | a, a = (this[r] & o) << n;
                    for(r = s - 1; r >= 0; --r)e[r] = 0;
                    e[s] = a, e.t = this.t + s + 1, e.s = this.s, e.clamp();
                }, F.prototype.rShiftTo = function ct(t, e) {
                    e.s = this.s;
                    var r = Math.floor(t / this.DB);
                    if (r >= this.t) e.t = 0;
                    else {
                        var n = t % this.DB, i = this.DB - n, o = (1 << n) - 1;
                        e[0] = this[r] >> n;
                        for(var s = r + 1; s < this.t; ++s)e[s - r - 1] |= (this[s] & o) << i, e[s - r] = this[s] >> n;
                        n > 0 && (e[this.t - r - 1] |= (this.s & o) << i), e.t = this.t - r, e.clamp();
                    }
                }, F.prototype.subTo = function ht(t, e) {
                    for(var r = 0, n = 0, i = Math.min(t.t, this.t); r < i;)n += this[r] - t[r], e[r++] = n & this.DM, n >>= this.DB;
                    if (t.t < this.t) {
                        for(n -= t.s; r < this.t;)n += this[r], e[r++] = n & this.DM, n >>= this.DB;
                        n += this.s;
                    } else {
                        for(n += this.s; r < t.t;)n -= t[r], e[r++] = n & this.DM, n >>= this.DB;
                        n -= t.s;
                    }
                    e.s = n < 0 ? -1 : 0, n < -1 ? e[r++] = this.DV + n : n > 0 && (e[r++] = n), e.t = r, e.clamp();
                }, F.prototype.multiplyTo = function lt(t, e) {
                    var r = this.abs(), n = t.abs(), i = r.t;
                    for(e.t = i + n.t; --i >= 0;)e[i] = 0;
                    for(i = 0; i < n.t; ++i)e[i + r.t] = r.am(0, n[i], e, i, 0, r.t);
                    e.s = 0, e.clamp(), this.s != t.s && F.ZERO.subTo(e, e);
                }, F.prototype.squareTo = function ft(t) {
                    for(var e = this.abs(), r = t.t = 2 * e.t; --r >= 0;)t[r] = 0;
                    for(r = 0; r < e.t - 1; ++r){
                        var n = e.am(r, e[r], t, 2 * r, 0, 1);
                        (t[r + e.t] += e.am(r + 1, 2 * e[r], t, 2 * r + 1, n, e.t - r - 1)) >= e.DV && (t[r + e.t] -= e.DV, t[r + e.t + 1] = 1);
                    }
                    t.t > 0 && (t[t.t - 1] += e.am(r, e[r], t, 2 * r, 0, 1)), t.s = 0, t.clamp();
                }, F.prototype.divRemTo = function gt(t, e, r) {
                    var n = t.abs();
                    if (!(n.t <= 0)) {
                        var i = this.abs();
                        if (i.t < n.t) return null != e && e.fromInt(0), void (null != r && this.copyTo(r));
                        null == r && (r = E());
                        var o = E(), s = this.s, a = t.s, u = this.DB - L(n[n.t - 1]);
                        u > 0 ? (n.lShiftTo(u, o), i.lShiftTo(u, r)) : (n.copyTo(o), i.copyTo(r));
                        var c = o.t, h = o[c - 1];
                        if (0 != h) {
                            var l = h * (1 << this.F1) + (c > 1 ? o[c - 2] >> this.F2 : 0), f = this.FV / l, g = (1 << this.F1) / l, d = 1 << this.F2, p = r.t, v = p - c, y = null == e ? E() : e;
                            for(o.dlShiftTo(v, y), r.compareTo(y) >= 0 && (r[r.t++] = 1, r.subTo(y, r)), F.ONE.dlShiftTo(c, y), y.subTo(o, o); o.t < c;)o[o.t++] = 0;
                            for(; --v >= 0;){
                                var m = r[--p] == h ? this.DM : Math.floor(r[p] * f + (r[p - 1] + d) * g);
                                if ((r[p] += o.am(0, m, r, v, 0, c)) < m) for(o.dlShiftTo(v, y), r.subTo(y, r); r[p] < --m;)r.subTo(y, r);
                            }
                            null != e && (r.drShiftTo(c, e), s != a && F.ZERO.subTo(e, e)), r.t = c, r.clamp(), u > 0 && r.rShiftTo(u, r), s < 0 && F.ZERO.subTo(r, r);
                        }
                    }
                }, F.prototype.invDigit = function dt() {
                    if (this.t < 1) return 0;
                    var t = this[0];
                    if (0 == (1 & t)) return 0;
                    var e = 3 & t;
                    return (e = (e = (e = (e = e * (2 - (15 & t) * e) & 15) * (2 - (255 & t) * e) & 255) * (2 - ((65535 & t) * e & 65535)) & 65535) * (2 - t * e % this.DV) % this.DV) > 0 ? this.DV - e : -e;
                }, F.prototype.isEven = function pt() {
                    return 0 == (this.t > 0 ? 1 & this[0] : this.s);
                }, F.prototype.exp = function vt(t, e) {
                    if (t > 4294967295 || t < 1) return F.ONE;
                    var r = E(), n = E(), i = e.convert(this), o = L(t) - 1;
                    for(i.copyTo(r); --o >= 0;)if (e.sqrTo(r, n), (t & 1 << o) > 0) e.mulTo(n, i, r);
                    else {
                        var s = r;
                        r = n, n = s;
                    }
                    return e.revert(r);
                }, F.prototype.toString = function yt(t) {
                    if (this.s < 0) return "-" + this.negate().toString(t);
                    var e;
                    if (16 == t) e = 4;
                    else if (8 == t) e = 3;
                    else if (2 == t) e = 1;
                    else if (32 == t) e = 5;
                    else {
                        if (4 != t) return this.toRadix(t);
                        e = 2;
                    }
                    var r, n = (1 << e) - 1, i = !1, o = "", s = this.t, a = this.DB - s * this.DB % e;
                    if (s-- > 0) for(a < this.DB && (r = this[s] >> a) > 0 && (i = !0, o = R(r)); s >= 0;)a < e ? (r = (this[s] & (1 << a) - 1) << e - a, r |= this[--s] >> (a += this.DB - e)) : (r = this[s] >> (a -= e) & n, a <= 0 && (a += this.DB, --s)), r > 0 && (i = !0), i && (o += R(r));
                    return i ? o : "0";
                }, F.prototype.negate = function mt() {
                    var t = E();
                    return F.ZERO.subTo(this, t), t;
                }, F.prototype.abs = function _t() {
                    return this.s < 0 ? this.negate() : this;
                }, F.prototype.compareTo = function St(t) {
                    var e = this.s - t.s;
                    if (0 != e) return e;
                    var r = this.t;
                    if (0 != (e = r - t.t)) return this.s < 0 ? -e : e;
                    for(; --r >= 0;)if (0 != (e = this[r] - t[r])) return e;
                    return 0;
                }, F.prototype.bitLength = function bt() {
                    return this.t <= 0 ? 0 : this.DB * (this.t - 1) + L(this[this.t - 1] ^ this.s & this.DM);
                }, F.prototype.mod = function wt(t) {
                    var e = E();
                    return this.abs().divRemTo(t, null, e), this.s < 0 && e.compareTo(F.ZERO) > 0 && t.subTo(e, e), e;
                }, F.prototype.modPowInt = function Ft(t, e) {
                    var r;
                    return r = t < 256 || e.isEven() ? new N(e) : new U(e), this.exp(t, r);
                }, F.ZERO = D(0), F.ONE = D(1), K.prototype.convert = q, K.prototype.revert = q, K.prototype.mulTo = function Et(t, e, r) {
                    t.multiplyTo(e, r);
                }, K.prototype.sqrTo = function xt(t, e) {
                    t.squareTo(e);
                }, J.prototype.convert = function At(t) {
                    if (t.s < 0 || t.t > 2 * this.m.t) return t.mod(this.m);
                    if (t.compareTo(this.m) < 0) return t;
                    var e = E();
                    return t.copyTo(e), this.reduce(e), e;
                }, J.prototype.revert = function kt(t) {
                    return t;
                }, J.prototype.reduce = function Pt(t) {
                    for(t.drShiftTo(this.m.t - 1, this.r2), t.t > this.m.t + 1 && (t.t = this.m.t + 1, t.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); t.compareTo(this.r2) < 0;)t.dAddOffset(1, this.m.t + 1);
                    for(t.subTo(this.r2, t); t.compareTo(this.m) >= 0;)t.subTo(this.m, t);
                }, J.prototype.mulTo = function Ct(t, e, r) {
                    t.multiplyTo(e, r), this.reduce(r);
                }, J.prototype.sqrTo = function Tt(t, e) {
                    t.squareTo(e), this.reduce(e);
                };
                var Rt = [
                    2,
                    3,
                    5,
                    7,
                    11,
                    13,
                    17,
                    19,
                    23,
                    29,
                    31,
                    37,
                    41,
                    43,
                    47,
                    53,
                    59,
                    61,
                    67,
                    71,
                    73,
                    79,
                    83,
                    89,
                    97,
                    101,
                    103,
                    107,
                    109,
                    113,
                    127,
                    131,
                    137,
                    139,
                    149,
                    151,
                    157,
                    163,
                    167,
                    173,
                    179,
                    181,
                    191,
                    193,
                    197,
                    199,
                    211,
                    223,
                    227,
                    229,
                    233,
                    239,
                    241,
                    251,
                    257,
                    263,
                    269,
                    271,
                    277,
                    281,
                    283,
                    293,
                    307,
                    311,
                    313,
                    317,
                    331,
                    337,
                    347,
                    349,
                    353,
                    359,
                    367,
                    373,
                    379,
                    383,
                    389,
                    397,
                    401,
                    409,
                    419,
                    421,
                    431,
                    433,
                    439,
                    443,
                    449,
                    457,
                    461,
                    463,
                    467,
                    479,
                    487,
                    491,
                    499,
                    503,
                    509,
                    521,
                    523,
                    541,
                    547,
                    557,
                    563,
                    569,
                    571,
                    577,
                    587,
                    593,
                    599,
                    601,
                    607,
                    613,
                    617,
                    619,
                    631,
                    641,
                    643,
                    647,
                    653,
                    659,
                    661,
                    673,
                    677,
                    683,
                    691,
                    701,
                    709,
                    719,
                    727,
                    733,
                    739,
                    743,
                    751,
                    757,
                    761,
                    769,
                    773,
                    787,
                    797,
                    809,
                    811,
                    821,
                    823,
                    827,
                    829,
                    839,
                    853,
                    857,
                    859,
                    863,
                    877,
                    881,
                    883,
                    887,
                    907,
                    911,
                    919,
                    929,
                    937,
                    941,
                    947,
                    953,
                    967,
                    971,
                    977,
                    983,
                    991,
                    997
                ], It = 67108864 / Rt[Rt.length - 1];
                /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function Dt() {
                    this.i = 0, this.j = 0, this.S = new Array;
                }
                F.prototype.chunkSize = function Lt(t) {
                    return Math.floor(Math.LN2 * this.DB / Math.log(t));
                }, F.prototype.toRadix = function Nt(t) {
                    if (null == t && (t = 10), 0 == this.signum() || t < 2 || t > 36) return "0";
                    var e = this.chunkSize(t), r = Math.pow(t, e), n = D(r), i = E(), o = E(), s = "";
                    for(this.divRemTo(n, i, o); i.signum() > 0;)s = (r + o.intValue()).toString(t).substr(1) + s, i.divRemTo(n, i, o);
                    return o.intValue().toString(t) + s;
                }, F.prototype.fromRadix = function Ut(t, e) {
                    this.fromInt(0), null == e && (e = 10);
                    for(var r = this.chunkSize(e), n = Math.pow(e, r), i = !1, o = 0, s = 0, a = 0; a < t.length; ++a){
                        var u = I(t, a);
                        u < 0 ? "-" == t.charAt(a) && 0 == this.signum() && (i = !0) : (s = e * s + u, ++o >= r && (this.dMultiply(n), this.dAddOffset(s, 0), o = 0, s = 0));
                    }
                    o > 0 && (this.dMultiply(Math.pow(e, o)), this.dAddOffset(s, 0)), i && F.ZERO.subTo(this, this);
                }, F.prototype.fromNumber = function Bt(t, e, r) {
                    if ("number" == typeof e) {
                        if (t < 2) this.fromInt(1);
                        else for(this.fromNumber(t, r), this.testBit(t - 1) || this.bitwiseTo(F.ONE.shiftLeft(t - 1), O, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);)this.dAddOffset(2, 0), this.bitLength() > t && this.subTo(F.ONE.shiftLeft(t - 1), this);
                    } else {
                        var n = new Array, i = 7 & t;
                        n.length = 1 + (t >> 3), e.nextBytes(n), i > 0 ? n[0] &= (1 << i) - 1 : n[0] = 0, this.fromString(n, 256);
                    }
                }, F.prototype.bitwiseTo = function Ot(t, e, r) {
                    var n, i, o = Math.min(t.t, this.t);
                    for(n = 0; n < o; ++n)r[n] = e(this[n], t[n]);
                    if (t.t < this.t) {
                        for(i = t.s & this.DM, n = o; n < this.t; ++n)r[n] = e(this[n], i);
                        r.t = this.t;
                    } else {
                        for(i = this.s & this.DM, n = o; n < t.t; ++n)r[n] = e(i, t[n]);
                        r.t = t.t;
                    }
                    r.s = e(this.s, t.s), r.clamp();
                }, F.prototype.changeBit = function jt(t, e) {
                    var r = F.ONE.shiftLeft(t);
                    return this.bitwiseTo(r, e, r), r;
                }, F.prototype.addTo = function Mt(t, e) {
                    for(var r = 0, n = 0, i = Math.min(t.t, this.t); r < i;)n += this[r] + t[r], e[r++] = n & this.DM, n >>= this.DB;
                    if (t.t < this.t) {
                        for(n += t.s; r < this.t;)n += this[r], e[r++] = n & this.DM, n >>= this.DB;
                        n += this.s;
                    } else {
                        for(n += this.s; r < t.t;)n += t[r], e[r++] = n & this.DM, n >>= this.DB;
                        n += t.s;
                    }
                    e.s = n < 0 ? -1 : 0, n > 0 ? e[r++] = n : n < -1 && (e[r++] = this.DV + n), e.t = r, e.clamp();
                }, F.prototype.dMultiply = function Ht(t) {
                    this[this.t] = this.am(0, t - 1, this, 0, 0, this.t), ++this.t, this.clamp();
                }, F.prototype.dAddOffset = function Vt(t, e) {
                    if (0 != t) {
                        for(; this.t <= e;)this[this.t++] = 0;
                        for(this[e] += t; this[e] >= this.DV;)this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
                    }
                }, F.prototype.multiplyLowerTo = function Kt(t, e, r) {
                    var n, i = Math.min(this.t + t.t, e);
                    for(r.s = 0, r.t = i; i > 0;)r[--i] = 0;
                    for(n = r.t - this.t; i < n; ++i)r[i + this.t] = this.am(0, t[i], r, i, 0, this.t);
                    for(n = Math.min(t.t, e); i < n; ++i)this.am(0, t[i], r, i, 0, e - i);
                    r.clamp();
                }, F.prototype.multiplyUpperTo = function qt(t, e, r) {
                    --e;
                    var n = r.t = this.t + t.t - e;
                    for(r.s = 0; --n >= 0;)r[n] = 0;
                    for(n = Math.max(e - this.t, 0); n < t.t; ++n)r[this.t + n - e] = this.am(e - n, t[n], r, 0, 0, this.t + n - e);
                    r.clamp(), r.drShiftTo(1, r);
                }, F.prototype.modInt = function Jt(t) {
                    if (t <= 0) return 0;
                    var e = this.DV % t, r = this.s < 0 ? t - 1 : 0;
                    if (this.t > 0) {
                        if (0 == e) r = this[0] % t;
                        else for(var n = this.t - 1; n >= 0; --n)r = (e * r + this[n]) % t;
                    }
                    return r;
                }, F.prototype.millerRabin = function Wt(t) {
                    var e = this.subtract(F.ONE), r = e.getLowestSetBit();
                    if (r <= 0) return !1;
                    var n = e.shiftRight(r);
                    (t = t + 1 >> 1) > Rt.length && (t = Rt.length);
                    for(var i = E(), o = 0; o < t; ++o){
                        i.fromInt(Rt[Math.floor(Math.random() * Rt.length)]);
                        var s = i.modPow(n, this);
                        if (0 != s.compareTo(F.ONE) && 0 != s.compareTo(e)) {
                            for(var a = 1; a++ < r && 0 != s.compareTo(e);)if (0 == (s = s.modPowInt(2, this)).compareTo(F.ONE)) return !1;
                            if (0 != s.compareTo(e)) return !1;
                        }
                    }
                    return !0;
                }, F.prototype.clone = /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function zt() {
                    var t = E();
                    return this.copyTo(t), t;
                }, F.prototype.intValue = function Yt() {
                    if (this.s < 0) {
                        if (1 == this.t) return this[0] - this.DV;
                        if (0 == this.t) return -1;
                    } else {
                        if (1 == this.t) return this[0];
                        if (0 == this.t) return 0;
                    }
                    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
                }, F.prototype.byteValue = function Gt() {
                    return 0 == this.t ? this.s : this[0] << 24 >> 24;
                }, F.prototype.shortValue = function Xt() {
                    return 0 == this.t ? this.s : this[0] << 16 >> 16;
                }, F.prototype.signum = function $t() {
                    return this.s < 0 ? -1 : this.t <= 0 || 1 == this.t && this[0] <= 0 ? 0 : 1;
                }, F.prototype.toByteArray = function Qt() {
                    var t = this.t, e = new Array;
                    e[0] = this.s;
                    var r, n = this.DB - t * this.DB % 8, i = 0;
                    if (t-- > 0) for(n < this.DB && (r = this[t] >> n) != (this.s & this.DM) >> n && (e[i++] = r | this.s << this.DB - n); t >= 0;)n < 8 ? (r = (this[t] & (1 << n) - 1) << 8 - n, r |= this[--t] >> (n += this.DB - 8)) : (r = this[t] >> (n -= 8) & 255, n <= 0 && (n += this.DB, --t)), 0 != (128 & r) && (r |= -256), 0 == i && (128 & this.s) != (128 & r) && ++i, (i > 0 || r != this.s) && (e[i++] = r);
                    return e;
                }, F.prototype.equals = function Zt(t) {
                    return 0 == this.compareTo(t);
                }, F.prototype.min = function te(t) {
                    return this.compareTo(t) < 0 ? this : t;
                }, F.prototype.max = function ee(t) {
                    return this.compareTo(t) > 0 ? this : t;
                }, F.prototype.and = function re(t) {
                    var e = E();
                    return this.bitwiseTo(t, B, e), e;
                }, F.prototype.or = function ne(t) {
                    var e = E();
                    return this.bitwiseTo(t, O, e), e;
                }, F.prototype.xor = function ie(t) {
                    var e = E();
                    return this.bitwiseTo(t, j, e), e;
                }, F.prototype.andNot = function oe(t) {
                    var e = E();
                    return this.bitwiseTo(t, M, e), e;
                }, F.prototype.not = function se() {
                    for(var t = E(), e = 0; e < this.t; ++e)t[e] = this.DM & ~this[e];
                    return t.t = this.t, t.s = ~this.s, t;
                }, F.prototype.shiftLeft = function ae(t) {
                    var e = E();
                    return t < 0 ? this.rShiftTo(-t, e) : this.lShiftTo(t, e), e;
                }, F.prototype.shiftRight = function ue(t) {
                    var e = E();
                    return t < 0 ? this.lShiftTo(-t, e) : this.rShiftTo(t, e), e;
                }, F.prototype.getLowestSetBit = function ce() {
                    for(var t = 0; t < this.t; ++t)if (0 != this[t]) return t * this.DB + H(this[t]);
                    return this.s < 0 ? this.t * this.DB : -1;
                }, F.prototype.bitCount = function he() {
                    for(var t = 0, e = this.s & this.DM, r = 0; r < this.t; ++r)t += V(this[r] ^ e);
                    return t;
                }, F.prototype.testBit = function le(t) {
                    var e = Math.floor(t / this.DB);
                    return e >= this.t ? 0 != this.s : 0 != (this[e] & 1 << t % this.DB);
                }, F.prototype.setBit = function fe(t) {
                    return this.changeBit(t, O);
                }, F.prototype.clearBit = function ge(t) {
                    return this.changeBit(t, M);
                }, F.prototype.flipBit = function de(t) {
                    return this.changeBit(t, j);
                }, F.prototype.add = function pe(t) {
                    var e = E();
                    return this.addTo(t, e), e;
                }, F.prototype.subtract = function ve(t) {
                    var e = E();
                    return this.subTo(t, e), e;
                }, F.prototype.multiply = function ye(t) {
                    var e = E();
                    return this.multiplyTo(t, e), e;
                }, F.prototype.divide = function me(t) {
                    var e = E();
                    return this.divRemTo(t, e, null), e;
                }, F.prototype.remainder = function _e(t) {
                    var e = E();
                    return this.divRemTo(t, null, e), e;
                }, F.prototype.divideAndRemainder = function Se(t) {
                    var e = E(), r = E();
                    return this.divRemTo(t, e, r), new Array(e, r);
                }, F.prototype.modPow = function be(t, e) {
                    var r, n, i = t.bitLength(), o = D(1);
                    if (i <= 0) return o;
                    r = i < 18 ? 1 : i < 48 ? 3 : i < 144 ? 4 : i < 768 ? 5 : 6, n = i < 8 ? new N(e) : e.isEven() ? new J(e) : new U(e);
                    var s = new Array, a = 3, u = r - 1, c = (1 << r) - 1;
                    if (s[1] = n.convert(this), r > 1) {
                        var h = E();
                        for(n.sqrTo(s[1], h); a <= c;)s[a] = E(), n.mulTo(h, s[a - 2], s[a]), a += 2;
                    }
                    var l, f, g = t.t - 1, d = !0, p = E();
                    for(i = L(t[g]) - 1; g >= 0;){
                        for(i >= u ? l = t[g] >> i - u & c : (l = (t[g] & (1 << i + 1) - 1) << u - i, g > 0 && (l |= t[g - 1] >> this.DB + i - u)), a = r; 0 == (1 & l);)l >>= 1, --a;
                        if ((i -= a) < 0 && (i += this.DB, --g), d) s[l].copyTo(o), d = !1;
                        else {
                            for(; a > 1;)n.sqrTo(o, p), n.sqrTo(p, o), a -= 2;
                            a > 0 ? n.sqrTo(o, p) : (f = o, o = p, p = f), n.mulTo(p, s[l], o);
                        }
                        for(; g >= 0 && 0 == (t[g] & 1 << i);)n.sqrTo(o, p), f = o, o = p, p = f, --i < 0 && (i = this.DB - 1, --g);
                    }
                    return n.revert(o);
                }, F.prototype.modInverse = function we(t) {
                    var e = t.isEven();
                    if (this.isEven() && e || 0 == t.signum()) return F.ZERO;
                    for(var r = t.clone(), n = this.clone(), i = D(1), o = D(0), s = D(0), a = D(1); 0 != r.signum();){
                        for(; r.isEven();)r.rShiftTo(1, r), e ? (i.isEven() && o.isEven() || (i.addTo(this, i), o.subTo(t, o)), i.rShiftTo(1, i)) : o.isEven() || o.subTo(t, o), o.rShiftTo(1, o);
                        for(; n.isEven();)n.rShiftTo(1, n), e ? (s.isEven() && a.isEven() || (s.addTo(this, s), a.subTo(t, a)), s.rShiftTo(1, s)) : a.isEven() || a.subTo(t, a), a.rShiftTo(1, a);
                        r.compareTo(n) >= 0 ? (r.subTo(n, r), e && i.subTo(s, i), o.subTo(a, o)) : (n.subTo(r, n), e && s.subTo(i, s), a.subTo(o, a));
                    }
                    return 0 != n.compareTo(F.ONE) ? F.ZERO : a.compareTo(t) >= 0 ? a.subtract(t) : a.signum() < 0 ? (a.addTo(t, a), a.signum() < 0 ? a.add(t) : a) : a;
                }, F.prototype.pow = function Fe(t) {
                    return this.exp(t, new K);
                }, F.prototype.gcd = function Ee(t) {
                    var e = this.s < 0 ? this.negate() : this.clone(), r = t.s < 0 ? t.negate() : t.clone();
                    if (e.compareTo(r) < 0) {
                        var n = e;
                        e = r, r = n;
                    }
                    var i = e.getLowestSetBit(), o = r.getLowestSetBit();
                    if (o < 0) return e;
                    for(i < o && (o = i), o > 0 && (e.rShiftTo(o, e), r.rShiftTo(o, r)); e.signum() > 0;)(i = e.getLowestSetBit()) > 0 && e.rShiftTo(i, e), (i = r.getLowestSetBit()) > 0 && r.rShiftTo(i, r), e.compareTo(r) >= 0 ? (e.subTo(r, e), e.rShiftTo(1, e)) : (r.subTo(e, r), r.rShiftTo(1, r));
                    return o > 0 && r.lShiftTo(o, r), r;
                }, F.prototype.isProbablePrime = function xe(t) {
                    var e, r = this.abs();
                    if (1 == r.t && r[0] <= Rt[Rt.length - 1]) {
                        for(e = 0; e < Rt.length; ++e)if (r[0] == Rt[e]) return !0;
                        return !1;
                    }
                    if (r.isEven()) return !1;
                    for(e = 1; e < Rt.length;){
                        for(var n = Rt[e], i = e + 1; i < Rt.length && n < It;)n *= Rt[i++];
                        for(n = r.modInt(n); e < i;)if (n % Rt[e++] == 0) return !1;
                    }
                    return r.millerRabin(t);
                }, F.prototype.square = function Ae() {
                    var t = E();
                    return this.squareTo(t), t;
                }, Dt.prototype.init = function ke(t) {
                    var e, r, n;
                    for(e = 0; e < 256; ++e)this.S[e] = e;
                    for(r = 0, e = 0; e < 256; ++e)r = r + this.S[e] + t[e % t.length] & 255, n = this.S[e], this.S[e] = this.S[r], this.S[r] = n;
                    this.i = 0, this.j = 0;
                }, Dt.prototype.next = function Pe() {
                    var t;
                    return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, t = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = t, this.S[t + this.S[this.i] & 255];
                };
                var Ce, Te, Re;
                /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function Ie() {
                    !function t(e) {
                        Te[Re++] ^= 255 & e, Te[Re++] ^= e >> 8 & 255, Te[Re++] ^= e >> 16 & 255, Te[Re++] ^= e >> 24 & 255, Re >= 256 && (Re -= 256);
                    }((new Date).getTime());
                }
                if (null == Te) {
                    var De;
                    if (Te = new Array, Re = 0, void 0 !== i && (void 0 !== i.crypto || void 0 !== i.msCrypto)) {
                        var Le = i.crypto || i.msCrypto;
                        if (Le.getRandomValues) {
                            var Ne = new Uint8Array(32);
                            for(Le.getRandomValues(Ne), De = 0; De < 32; ++De)Te[Re++] = Ne[De];
                        } else if ("Netscape" == n.appName && n.appVersion < "5") {
                            var Ue = i.crypto.random(32);
                            for(De = 0; De < Ue.length; ++De)Te[Re++] = 255 & Ue.charCodeAt(De);
                        }
                    }
                    for(; Re < 256;)De = Math.floor(65536 * Math.random()), Te[Re++] = De >>> 8, Te[Re++] = 255 & De;
                    Re = 0, Ie();
                }
                function Be() {
                    if (null == Ce) {
                        for(Ie(), (Ce = function t() {
                            return new Dt;
                        }()).init(Te), Re = 0; Re < Te.length; ++Re)Te[Re] = 0;
                        Re = 0;
                    }
                    return Ce.next();
                }
                function Oe() {}
                /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function je(t, e) {
                    return new F(t, e);
                }
                function Me(t, e, r) {
                    for(var n = "", i = 0; n.length < e;)n += r(String.fromCharCode.apply(String, t.concat([
                        (4278190080 & i) >> 24,
                        (16711680 & i) >> 16,
                        (65280 & i) >> 8,
                        255 & i
                    ]))), i += 1;
                    return n;
                }
                function He() {
                    this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
                }
                /*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function Ve(t, e) {
                    this.x = e, this.q = t;
                }
                function Ke(t, e, r, n) {
                    this.curve = t, this.x = e, this.y = r, this.z = null == n ? F.ONE : n, this.zinv = null;
                }
                function qe(t, e, r) {
                    this.q = t, this.a = this.fromBigInteger(e), this.b = this.fromBigInteger(r), this.infinity = new Ke(this, null, null);
                }
                Oe.prototype.nextBytes = function Je(t) {
                    var e;
                    for(e = 0; e < t.length; ++e)t[e] = Be();
                }, He.prototype.doPublic = function We(t) {
                    return t.modPowInt(this.e, this.n);
                }, He.prototype.setPublic = function ze(t, e) {
                    if (this.isPublic = !0, this.isPrivate = !1, "string" != typeof t) this.n = t, this.e = e;
                    else {
                        if (!(null != t && null != e && t.length > 0 && e.length > 0)) throw "Invalid RSA public key";
                        this.n = je(t, 16), this.e = parseInt(e, 16);
                    }
                }, He.prototype.encrypt = function Ye(t) {
                    var e = function r(t, e) {
                        if (e < t.length + 11) throw "Message too long for RSA";
                        for(var r = new Array, n = t.length - 1; n >= 0 && e > 0;){
                            var i = t.charCodeAt(n--);
                            i < 128 ? r[--e] = i : i > 127 && i < 2048 ? (r[--e] = 63 & i | 128, r[--e] = i >> 6 | 192) : (r[--e] = 63 & i | 128, r[--e] = i >> 6 & 63 | 128, r[--e] = i >> 12 | 224);
                        }
                        r[--e] = 0;
                        for(var o = new Oe, s = new Array; e > 2;){
                            for(s[0] = 0; 0 == s[0];)o.nextBytes(s);
                            r[--e] = s[0];
                        }
                        return r[--e] = 2, r[--e] = 0, new F(r);
                    }(t, this.n.bitLength() + 7 >> 3);
                    if (null == e) return null;
                    var n = this.doPublic(e);
                    if (null == n) return null;
                    var i = n.toString(16);
                    return 0 == (1 & i.length) ? i : "0" + i;
                }, He.prototype.encryptOAEP = function Ge(t, e, r) {
                    var n = function i(t, e, r, n) {
                        var i = br.crypto.MessageDigest, o = br.crypto.Util, s = null;
                        if (r || (r = "sha1"), "string" == typeof r && (s = i.getCanonicalAlgName(r), n = i.getHashLength(s), r = function t(e) {
                            return Nr(o.hashHex(Ur(e), s));
                        }), t.length + 2 * n + 2 > e) throw "Message too long for RSA";
                        var a, u = "";
                        for(a = 0; a < e - t.length - 2 * n - 2; a += 1)u += "\0";
                        var c = r("") + u + "\x01" + t, h = new Array(n);
                        (new Oe).nextBytes(h);
                        var l = Me(h, c.length, r), f = [];
                        for(a = 0; a < c.length; a += 1)f[a] = c.charCodeAt(a) ^ l.charCodeAt(a);
                        var g = Me(f, h.length, r), d = [
                            0
                        ];
                        for(a = 0; a < h.length; a += 1)d[a + 1] = h[a] ^ g.charCodeAt(a);
                        return new F(d.concat(f));
                    }(t, this.n.bitLength() + 7 >> 3, e, r);
                    if (null == n) return null;
                    var o = this.doPublic(n);
                    if (null == o) return null;
                    var s = o.toString(16);
                    return 0 == (1 & s.length) ? s : "0" + s;
                }, He.prototype.type = "RSA", Ve.prototype.equals = function Xe(t) {
                    return t == this || this.q.equals(t.q) && this.x.equals(t.x);
                }, Ve.prototype.toBigInteger = function $e() {
                    return this.x;
                }, Ve.prototype.negate = function Qe() {
                    return new Ve(this.q, this.x.negate().mod(this.q));
                }, Ve.prototype.add = function Ze(t) {
                    return new Ve(this.q, this.x.add(t.toBigInteger()).mod(this.q));
                }, Ve.prototype.subtract = function tr(t) {
                    return new Ve(this.q, this.x.subtract(t.toBigInteger()).mod(this.q));
                }, Ve.prototype.multiply = function er(t) {
                    return new Ve(this.q, this.x.multiply(t.toBigInteger()).mod(this.q));
                }, Ve.prototype.square = function rr() {
                    return new Ve(this.q, this.x.square().mod(this.q));
                }, Ve.prototype.divide = function nr(t) {
                    return new Ve(this.q, this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q));
                }, Ke.prototype.getX = function ir() {
                    return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
                }, Ke.prototype.getY = function or() {
                    return null == this.zinv && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
                }, Ke.prototype.equals = function sr(t) {
                    return t == this || (this.isInfinity() ? t.isInfinity() : t.isInfinity() ? this.isInfinity() : !!t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(F.ZERO) && t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(F.ZERO));
                }, Ke.prototype.isInfinity = function ar() {
                    return null == this.x && null == this.y || this.z.equals(F.ZERO) && !this.y.toBigInteger().equals(F.ZERO);
                }, Ke.prototype.negate = function ur() {
                    return new Ke(this.curve, this.x, this.y.negate(), this.z);
                }, Ke.prototype.add = function cr(t) {
                    if (this.isInfinity()) return t;
                    if (t.isInfinity()) return this;
                    var e = t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q), r = t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q);
                    if (F.ZERO.equals(r)) return F.ZERO.equals(e) ? this.twice() : this.curve.getInfinity();
                    var n = new F("3"), i = this.x.toBigInteger(), o = this.y.toBigInteger(), s = (t.x.toBigInteger(), t.y.toBigInteger(), r.square()), a = s.multiply(r), u = i.multiply(s), c = e.square().multiply(this.z), h = c.subtract(u.shiftLeft(1)).multiply(t.z).subtract(a).multiply(r).mod(this.curve.q), l = u.multiply(n).multiply(e).subtract(o.multiply(a)).subtract(c.multiply(e)).multiply(t.z).add(e.multiply(a)).mod(this.curve.q), f = a.multiply(this.z).multiply(t.z).mod(this.curve.q);
                    return new Ke(this.curve, this.curve.fromBigInteger(h), this.curve.fromBigInteger(l), f);
                }, Ke.prototype.twice = function hr() {
                    if (this.isInfinity()) return this;
                    if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();
                    var t = new F("3"), e = this.x.toBigInteger(), r = this.y.toBigInteger(), n = r.multiply(this.z), i = n.multiply(r).mod(this.curve.q), o = this.curve.a.toBigInteger(), s = e.square().multiply(t);
                    F.ZERO.equals(o) || (s = s.add(this.z.square().multiply(o)));
                    var a = (s = s.mod(this.curve.q)).square().subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.q), u = s.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(s.square().multiply(s)).mod(this.curve.q), c = n.square().multiply(n).shiftLeft(3).mod(this.curve.q);
                    return new Ke(this.curve, this.curve.fromBigInteger(a), this.curve.fromBigInteger(u), c);
                }, Ke.prototype.multiply = function lr(t) {
                    if (this.isInfinity()) return this;
                    if (0 == t.signum()) return this.curve.getInfinity();
                    var e, r = t, n = r.multiply(new F("3")), i = this.negate(), o = this, s = this.curve.q.subtract(t), a = s.multiply(new F("3")), u = new Ke(this.curve, this.x, this.y), c = u.negate();
                    for(e = n.bitLength() - 2; e > 0; --e){
                        o = o.twice();
                        var h = n.testBit(e);
                        h != r.testBit(e) && (o = o.add(h ? this : i));
                    }
                    for(e = a.bitLength() - 2; e > 0; --e){
                        u = u.twice();
                        var l = a.testBit(e);
                        l != s.testBit(e) && (u = u.add(l ? u : c));
                    }
                    return o;
                }, Ke.prototype.multiplyTwo = function fr(t, e, r) {
                    var n;
                    n = t.bitLength() > r.bitLength() ? t.bitLength() - 1 : r.bitLength() - 1;
                    for(var i = this.curve.getInfinity(), o = this.add(e); n >= 0;)i = i.twice(), t.testBit(n) ? i = r.testBit(n) ? i.add(o) : i.add(this) : r.testBit(n) && (i = i.add(e)), --n;
                    return i;
                }, qe.prototype.getQ = function gr() {
                    return this.q;
                }, qe.prototype.getA = function dr() {
                    return this.a;
                }, qe.prototype.getB = function pr() {
                    return this.b;
                }, qe.prototype.equals = function vr(t) {
                    return t == this || this.q.equals(t.q) && this.a.equals(t.a) && this.b.equals(t.b);
                }, qe.prototype.getInfinity = function yr() {
                    return this.infinity;
                }, qe.prototype.fromBigInteger = function mr(t) {
                    return new Ve(this.q, t);
                }, qe.prototype.decodePointHex = function _r(t) {
                    switch(parseInt(t.substr(0, 2), 16)){
                        case 0:
                            return this.infinity;
                        case 2:
                        case 3:
                            return null;
                        case 4:
                        case 6:
                        case 7:
                            var e = (t.length - 2) / 2, r = t.substr(2, e), n = t.substr(e + 2, e);
                            return new Ke(this, this.fromBigInteger(new F(r, 16)), this.fromBigInteger(new F(n, 16)));
                        default:
                            return null;
                    }
                }, /*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
 */ Ve.prototype.getByteLength = function() {
                    return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
                }, Ke.prototype.getEncoded = function(t) {
                    var e = function t(e, r) {
                        var n = e.toByteArrayUnsigned();
                        if (r < n.length) n = n.slice(n.length - r);
                        else for(; r > n.length;)n.unshift(0);
                        return n;
                    }, r = this.getX().toBigInteger(), n = this.getY().toBigInteger(), i = e(r, 32);
                    return t ? n.isEven() ? i.unshift(2) : i.unshift(3) : (i.unshift(4), i = i.concat(e(n, 32))), i;
                }, Ke.decodeFrom = function(t, e) {
                    e[0];
                    var r = e.length - 1, n = e.slice(1, 1 + r / 2), i = e.slice(1 + r / 2, 1 + r);
                    n.unshift(0), i.unshift(0);
                    var o = new F(n), s = new F(i);
                    return new Ke(t, t.fromBigInteger(o), t.fromBigInteger(s));
                }, Ke.decodeFromHex = function(t, e) {
                    e.substr(0, 2);
                    var r = e.length - 2, n = e.substr(2, r / 2), i = e.substr(2 + r / 2, r / 2), o = new F(n, 16), s = new F(i, 16);
                    return new Ke(t, t.fromBigInteger(o), t.fromBigInteger(s));
                }, Ke.prototype.add2D = function(t) {
                    if (this.isInfinity()) return t;
                    if (t.isInfinity()) return this;
                    if (this.x.equals(t.x)) return this.y.equals(t.y) ? this.twice() : this.curve.getInfinity();
                    var e = t.x.subtract(this.x), r = t.y.subtract(this.y).divide(e), n = r.square().subtract(this.x).subtract(t.x), i = r.multiply(this.x.subtract(n)).subtract(this.y);
                    return new Ke(this.curve, n, i);
                }, Ke.prototype.twice2D = function() {
                    if (this.isInfinity()) return this;
                    if (0 == this.y.toBigInteger().signum()) return this.curve.getInfinity();
                    var t = this.curve.fromBigInteger(F.valueOf(2)), e = this.curve.fromBigInteger(F.valueOf(3)), r = this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)), n = r.square().subtract(this.x.multiply(t)), i = r.multiply(this.x.subtract(n)).subtract(this.y);
                    return new Ke(this.curve, n, i);
                }, Ke.prototype.multiply2D = function(t) {
                    if (this.isInfinity()) return this;
                    if (0 == t.signum()) return this.curve.getInfinity();
                    var e, r = t, n = r.multiply(new F("3")), i = this.negate(), o = this;
                    for(e = n.bitLength() - 2; e > 0; --e){
                        o = o.twice();
                        var s = n.testBit(e);
                        s != r.testBit(e) && (o = o.add2D(s ? this : i));
                    }
                    return o;
                }, Ke.prototype.isOnCurve = function() {
                    var t = this.getX().toBigInteger(), e = this.getY().toBigInteger(), r = this.curve.getA().toBigInteger(), n = this.curve.getB().toBigInteger(), i = this.curve.getQ(), o = e.multiply(e).mod(i), s = t.multiply(t).multiply(t).add(r.multiply(t)).add(n).mod(i);
                    return o.equals(s);
                }, Ke.prototype.toString = function() {
                    return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")";
                }, Ke.prototype.validate = function() {
                    var t = this.curve.getQ();
                    if (this.isInfinity()) throw new Error("Point is at infinity.");
                    var e = this.getX().toBigInteger(), r = this.getY().toBigInteger();
                    if (e.compareTo(F.ONE) < 0 || e.compareTo(t.subtract(F.ONE)) > 0) throw new Error("x coordinate out of bounds");
                    if (r.compareTo(F.ONE) < 0 || r.compareTo(t.subtract(F.ONE)) > 0) throw new Error("y coordinate out of bounds");
                    if (!this.isOnCurve()) throw new Error("Point is not on the curve.");
                    if (this.multiply(t).isInfinity()) throw new Error("Point is not a scalar multiple of G.");
                    return !0;
                };
                /*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
 */ var Sr = function() {
                    var t = new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))', "g"), e = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"), n = {
                        '"': '"',
                        "/": "/",
                        "\\": "\\",
                        b: "\b",
                        f: "\f",
                        n: "\n",
                        r: "\r",
                        t: "	"
                    };
                    function i(t, e, r) {
                        return e ? n[e] : String.fromCharCode(parseInt(r, 16));
                    }
                    var o = new String(""), s = Object.hasOwnProperty;
                    return function(n, a) {
                        var u, c, h = n.match(t), l = h[0], f = !1;
                        "{" === l ? u = {} : "[" === l ? u = [] : (u = [], f = !0);
                        for(var g = [
                            u
                        ], d = 1 - f, p = h.length; d < p; ++d){
                            var v;
                            switch((l = h[d]).charCodeAt(0)){
                                default:
                                    (v = g[0])[c || v.length] = +l, c = void 0;
                                    break;
                                case 34:
                                    if (-1 !== (l = l.substring(1, l.length - 1)).indexOf("\\") && (l = l.replace(e, i)), v = g[0], !c) {
                                        if (!(v instanceof Array)) {
                                            c = l || o;
                                            break;
                                        }
                                        c = v.length;
                                    }
                                    v[c] = l, c = void 0;
                                    break;
                                case 91:
                                    v = g[0], g.unshift(v[c || v.length] = []), c = void 0;
                                    break;
                                case 93:
                                    g.shift();
                                    break;
                                case 102:
                                    (v = g[0])[c || v.length] = !1, c = void 0;
                                    break;
                                case 110:
                                    (v = g[0])[c || v.length] = null, c = void 0;
                                    break;
                                case 116:
                                    (v = g[0])[c || v.length] = !0, c = void 0;
                                    break;
                                case 123:
                                    v = g[0], g.unshift(v[c || v.length] = {}), c = void 0;
                                    break;
                                case 125:
                                    g.shift();
                            }
                        }
                        if (f) {
                            if (1 !== g.length) throw new Error;
                            u = u[0];
                        } else if (g.length) throw new Error;
                        if (a) u = function t(e, n) {
                            var i = e[n];
                            if (i && "object" === (void 0 === i ? "undefined" : r(i))) {
                                var o = null;
                                for(var u in i)if (s.call(i, u) && i !== e) {
                                    var c = t(i, u);
                                    void 0 !== c ? i[u] = c : (o || (o = []), o.push(u));
                                }
                                if (o) for(var h = o.length; --h >= 0;)delete i[o[h]];
                            }
                            return a.call(e, n, i);
                        }({
                            "": u
                        }, "");
                        return u;
                    };
                }();
                void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.asn1 && br.asn1 || (br.asn1 = {}), br.asn1.ASN1Util = new function() {
                    this.integerToByteHex = function(t) {
                        var e = t.toString(16);
                        return e.length % 2 == 1 && (e = "0" + e), e;
                    }, this.bigIntToMinTwosComplementsHex = function(t) {
                        var e = t.toString(16);
                        if ("-" != e.substr(0, 1)) e.length % 2 == 1 ? e = "0" + e : e.match(/^[0-7]/) || (e = "00" + e);
                        else {
                            var r = e.substr(1).length;
                            r % 2 == 1 ? r += 1 : e.match(/^[0-7]/) || (r += 2);
                            for(var n = "", i = 0; i < r; i++)n += "f";
                            e = new F(n, 16).xor(t).add(F.ONE).toString(16).replace(/^-/, "");
                        }
                        return e;
                    }, this.getPEMStringFromHex = function(t, e) {
                        return Mr(t, e);
                    }, this.newObject = function(t) {
                        var e = br.asn1, r = e.ASN1Object, n = e.DERBoolean, i = e.DERInteger, o = e.DERBitString, s = e.DEROctetString, a = e.DERNull, u = e.DERObjectIdentifier, c = e.DEREnumerated, h = e.DERUTF8String, l = e.DERNumericString, f = e.DERPrintableString, g = e.DERTeletexString, d = e.DERIA5String, p = e.DERUTCTime, v = e.DERGeneralizedTime, y = e.DERVisibleString, m = e.DERBMPString, _ = e.DERSequence, S = e.DERSet, b = e.DERTaggedObject, w = e.ASN1Util.newObject;
                        if (t instanceof e.ASN1Object) return t;
                        var F = Object.keys(t);
                        if (1 != F.length) throw new Error("key of param shall be only one.");
                        var E = F[0];
                        if (-1 == ":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":" + E + ":")) throw new Error("undefined key: " + E);
                        if ("bool" == E) return new n(t[E]);
                        if ("int" == E) return new i(t[E]);
                        if ("bitstr" == E) return new o(t[E]);
                        if ("octstr" == E) return new s(t[E]);
                        if ("null" == E) return new a(t[E]);
                        if ("oid" == E) return new u(t[E]);
                        if ("enum" == E) return new c(t[E]);
                        if ("utf8str" == E) return new h(t[E]);
                        if ("numstr" == E) return new l(t[E]);
                        if ("prnstr" == E) return new f(t[E]);
                        if ("telstr" == E) return new g(t[E]);
                        if ("ia5str" == E) return new d(t[E]);
                        if ("utctime" == E) return new p(t[E]);
                        if ("gentime" == E) return new v(t[E]);
                        if ("visstr" == E) return new y(t[E]);
                        if ("bmpstr" == E) return new m(t[E]);
                        if ("asn1" == E) return new r(t[E]);
                        if ("seq" == E) {
                            for(var x = t[E], A = [], k = 0; k < x.length; k++){
                                var P = w(x[k]);
                                A.push(P);
                            }
                            return new _({
                                array: A
                            });
                        }
                        if ("set" == E) {
                            for(x = t[E], A = [], k = 0; k < x.length; k++){
                                P = w(x[k]);
                                A.push(P);
                            }
                            return new S({
                                array: A
                            });
                        }
                        if ("tag" == E) {
                            var C = t[E];
                            if ("[object Array]" === Object.prototype.toString.call(C) && 3 == C.length) {
                                var T = w(C[2]);
                                return new b({
                                    tag: C[0],
                                    explicit: C[1],
                                    obj: T
                                });
                            }
                            return new b(C);
                        }
                    }, this.jsonToASN1HEX = function(t) {
                        return this.newObject(t).getEncodedHex();
                    };
                }, br.asn1.ASN1Util.oidHexToInt = function(t) {
                    for(var e = "", r = parseInt(t.substr(0, 2), 16), n = (e = Math.floor(r / 40) + "." + r % 40, ""), i = 2; i < t.length; i += 2){
                        var o = ("00000000" + parseInt(t.substr(i, 2), 16).toString(2)).slice(-8);
                        if (n += o.substr(1, 7), "0" == o.substr(0, 1)) e = e + "." + new F(n, 2).toString(10), n = "";
                    }
                    return e;
                }, br.asn1.ASN1Util.oidIntToHex = function(t) {
                    var e = function t(e) {
                        var r = e.toString(16);
                        return 1 == r.length && (r = "0" + r), r;
                    }, r = function t(r) {
                        var n = "", i = new F(r, 10).toString(2), o = 7 - i.length % 7;
                        7 == o && (o = 0);
                        for(var s = "", a = 0; a < o; a++)s += "0";
                        i = s + i;
                        for(a = 0; a < i.length - 1; a += 7){
                            var u = i.substr(a, 7);
                            a != i.length - 7 && (u = "1" + u), n += e(parseInt(u, 2));
                        }
                        return n;
                    };
                    if (!t.match(/^[0-9.]+$/)) throw "malformed oid string: " + t;
                    var n = "", i = t.split("."), o = 40 * parseInt(i[0]) + parseInt(i[1]);
                    n += e(o), i.splice(0, 2);
                    for(var s = 0; s < i.length; s++)n += r(i[s]);
                    return n;
                }, br.asn1.ASN1Object = function(t) {
                    this.params = null, this.getLengthHexFromValue = function() {
                        if (void 0 === this.hV || null == this.hV) throw new Error("this.hV is null or undefined");
                        if (this.hV.length % 2 == 1) throw new Error("value hex must be even length: n=0,v=" + this.hV);
                        var t = this.hV.length / 2, e = t.toString(16);
                        if (e.length % 2 == 1 && (e = "0" + e), t < 128) return e;
                        var r = e.length / 2;
                        if (r > 15) throw "ASN.1 length too long to represent by 8x: n = " + t.toString(16);
                        return (128 + r).toString(16) + e;
                    }, this.getEncodedHex = function() {
                        return (null == this.hTLV || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = !1), this.hTLV;
                    }, this.getValueHex = function() {
                        return this.getEncodedHex(), this.hV;
                    }, this.getFreshValueHex = function() {
                        return "";
                    }, this.setByParam = function(t) {
                        this.params = t;
                    }, null != t && null != t.tlv && (this.hTLV = t.tlv, this.isModified = !1);
                }, br.asn1.DERAbstractString = function(t) {
                    br.asn1.DERAbstractString.superclass.constructor.call(this);
                    this.getString = function() {
                        return this.s;
                    }, this.setString = function(t) {
                        this.hTLV = null, this.isModified = !0, this.s = t, this.hV = Dr(this.s).toLowerCase();
                    }, this.setStringHex = function(t) {
                        this.hTLV = null, this.isModified = !0, this.s = null, this.hV = t;
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    }, void 0 !== t && ("string" == typeof t ? this.setString(t) : void 0 !== t.str ? this.setString(t.str) : void 0 !== t.hex && this.setStringHex(t.hex));
                }, o.lang.extend(br.asn1.DERAbstractString, br.asn1.ASN1Object), br.asn1.DERAbstractTime = function(t) {
                    br.asn1.DERAbstractTime.superclass.constructor.call(this);
                    this.localDateToUTC = function(t) {
                        var e = t.getTime() + 6e4 * t.getTimezoneOffset();
                        return new Date(e);
                    }, this.formatDate = function(t, e, r) {
                        var n = this.zeroPadding, i = this.localDateToUTC(t), o = String(i.getFullYear());
                        "utc" == e && (o = o.substr(2, 2));
                        var s = o + n(String(i.getMonth() + 1), 2) + n(String(i.getDate()), 2) + n(String(i.getHours()), 2) + n(String(i.getMinutes()), 2) + n(String(i.getSeconds()), 2);
                        if (!0 === r) {
                            var a = i.getMilliseconds();
                            if (0 != a) {
                                var u = n(String(a), 3);
                                s = s + "." + (u = u.replace(/[0]+$/, ""));
                            }
                        }
                        return s + "Z";
                    }, this.zeroPadding = function(t, e) {
                        return t.length >= e ? t : new Array(e - t.length + 1).join("0") + t;
                    }, this.getString = function() {
                        return this.s;
                    }, this.setString = function(t) {
                        this.hTLV = null, this.isModified = !0, this.s = t, this.hV = Pr(t);
                    }, this.setByDateValue = function(t, e, r, n, i, o) {
                        var s = new Date(Date.UTC(t, e - 1, r, n, i, o, 0));
                        this.setByDate(s);
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    };
                }, o.lang.extend(br.asn1.DERAbstractTime, br.asn1.ASN1Object), br.asn1.DERAbstractStructured = function(t) {
                    br.asn1.DERAbstractString.superclass.constructor.call(this);
                    this.setByASN1ObjectArray = function(t) {
                        this.hTLV = null, this.isModified = !0, this.asn1Array = t;
                    }, this.appendASN1Object = function(t) {
                        this.hTLV = null, this.isModified = !0, this.asn1Array.push(t);
                    }, this.asn1Array = new Array, void 0 !== t && void 0 !== t.array && (this.asn1Array = t.array);
                }, o.lang.extend(br.asn1.DERAbstractStructured, br.asn1.ASN1Object), br.asn1.DERBoolean = function(t) {
                    br.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", this.hTLV = 0 == t ? "010100" : "0101ff";
                }, o.lang.extend(br.asn1.DERBoolean, br.asn1.ASN1Object), br.asn1.DERInteger = function(t) {
                    br.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.setByBigInteger = function(t) {
                        this.hTLV = null, this.isModified = !0, this.hV = br.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t);
                    }, this.setByInteger = function(t) {
                        var e = new F(String(t), 10);
                        this.setByBigInteger(e);
                    }, this.setValueHex = function(t) {
                        this.hV = t;
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    }, void 0 !== t && (void 0 !== t.bigint ? this.setByBigInteger(t.bigint) : void 0 !== t.int ? this.setByInteger(t.int) : "number" == typeof t ? this.setByInteger(t) : void 0 !== t.hex && this.setValueHex(t.hex));
                }, o.lang.extend(br.asn1.DERInteger, br.asn1.ASN1Object), br.asn1.DERBitString = function(t) {
                    if (void 0 !== t && void 0 !== t.obj) {
                        var e = br.asn1.ASN1Util.newObject(t.obj);
                        t.hex = "00" + e.getEncodedHex();
                    }
                    br.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(t) {
                        this.hTLV = null, this.isModified = !0, this.hV = t;
                    }, this.setUnusedBitsAndHexValue = function(t, e) {
                        if (t < 0 || 7 < t) throw "unused bits shall be from 0 to 7: u = " + t;
                        var r = "0" + t;
                        this.hTLV = null, this.isModified = !0, this.hV = r + e;
                    }, this.setByBinaryString = function(t) {
                        var e = 8 - (t = t.replace(/0+$/, "")).length % 8;
                        8 == e && (e = 0);
                        for(var r = 0; r <= e; r++)t += "0";
                        var n = "";
                        for(r = 0; r < t.length - 1; r += 8){
                            var i = t.substr(r, 8), o = parseInt(i, 2).toString(16);
                            1 == o.length && (o = "0" + o), n += o;
                        }
                        this.hTLV = null, this.isModified = !0, this.hV = "0" + e + n;
                    }, this.setByBooleanArray = function(t) {
                        for(var e = "", r = 0; r < t.length; r++)1 == t[r] ? e += "1" : e += "0";
                        this.setByBinaryString(e);
                    }, this.newFalseArray = function(t) {
                        for(var e = new Array(t), r = 0; r < t; r++)e[r] = !1;
                        return e;
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    }, void 0 !== t && ("string" == typeof t && t.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(t) : void 0 !== t.hex ? this.setHexValueIncludingUnusedBits(t.hex) : void 0 !== t.bin ? this.setByBinaryString(t.bin) : void 0 !== t.array && this.setByBooleanArray(t.array));
                }, o.lang.extend(br.asn1.DERBitString, br.asn1.ASN1Object), br.asn1.DEROctetString = function(t) {
                    if (void 0 !== t && void 0 !== t.obj) {
                        var e = br.asn1.ASN1Util.newObject(t.obj);
                        t.hex = e.getEncodedHex();
                    }
                    br.asn1.DEROctetString.superclass.constructor.call(this, t), this.hT = "04";
                }, o.lang.extend(br.asn1.DEROctetString, br.asn1.DERAbstractString), br.asn1.DERNull = function() {
                    br.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500";
                }, o.lang.extend(br.asn1.DERNull, br.asn1.ASN1Object), br.asn1.DERObjectIdentifier = function(t) {
                    br.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(t) {
                        this.hTLV = null, this.isModified = !0, this.s = null, this.hV = t;
                    }, this.setValueOidString = function(t) {
                        var e = function r(t) {
                            var e = function t(e) {
                                var r = e.toString(16);
                                return 1 == r.length && (r = "0" + r), r;
                            }, r = function t(r) {
                                var n = "", i = parseInt(r, 10).toString(2), o = 7 - i.length % 7;
                                7 == o && (o = 0);
                                for(var s = "", a = 0; a < o; a++)s += "0";
                                i = s + i;
                                for(a = 0; a < i.length - 1; a += 7){
                                    var u = i.substr(a, 7);
                                    a != i.length - 7 && (u = "1" + u), n += e(parseInt(u, 2));
                                }
                                return n;
                            };
                            try {
                                if (!t.match(/^[0-9.]+$/)) return null;
                                var n = "", i = t.split("."), o = 40 * parseInt(i[0], 10) + parseInt(i[1], 10);
                                n += e(o), i.splice(0, 2);
                                for(var s = 0; s < i.length; s++)n += r(i[s]);
                                return n;
                            } catch (t) {
                                return null;
                            }
                        }(t);
                        if (null == e) throw new Error("malformed oid string: " + t);
                        this.hTLV = null, this.isModified = !0, this.s = null, this.hV = e;
                    }, this.setValueName = function(t) {
                        var e = br.asn1.x509.OID.name2oid(t);
                        if ("" === e) throw new Error("DERObjectIdentifier oidName undefined: " + t);
                        this.setValueOidString(e);
                    }, this.setValueNameOrOid = function(t) {
                        t.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(t) : this.setValueName(t);
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    }, this.setByParam = function(t) {
                        "string" == typeof t ? this.setValueNameOrOid(t) : void 0 !== t.oid ? this.setValueNameOrOid(t.oid) : void 0 !== t.name ? this.setValueNameOrOid(t.name) : void 0 !== t.hex && this.setValueHex(t.hex);
                    }, void 0 !== t && this.setByParam(t);
                }, o.lang.extend(br.asn1.DERObjectIdentifier, br.asn1.ASN1Object), br.asn1.DEREnumerated = function(t) {
                    br.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(t) {
                        this.hTLV = null, this.isModified = !0, this.hV = br.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t);
                    }, this.setByInteger = function(t) {
                        var e = new F(String(t), 10);
                        this.setByBigInteger(e);
                    }, this.setValueHex = function(t) {
                        this.hV = t;
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    }, void 0 !== t && (void 0 !== t.int ? this.setByInteger(t.int) : "number" == typeof t ? this.setByInteger(t) : void 0 !== t.hex && this.setValueHex(t.hex));
                }, o.lang.extend(br.asn1.DEREnumerated, br.asn1.ASN1Object), br.asn1.DERUTF8String = function(t) {
                    br.asn1.DERUTF8String.superclass.constructor.call(this, t), this.hT = "0c";
                }, o.lang.extend(br.asn1.DERUTF8String, br.asn1.DERAbstractString), br.asn1.DERNumericString = function(t) {
                    br.asn1.DERNumericString.superclass.constructor.call(this, t), this.hT = "12";
                }, o.lang.extend(br.asn1.DERNumericString, br.asn1.DERAbstractString), br.asn1.DERPrintableString = function(t) {
                    br.asn1.DERPrintableString.superclass.constructor.call(this, t), this.hT = "13";
                }, o.lang.extend(br.asn1.DERPrintableString, br.asn1.DERAbstractString), br.asn1.DERTeletexString = function(t) {
                    br.asn1.DERTeletexString.superclass.constructor.call(this, t), this.hT = "14";
                }, o.lang.extend(br.asn1.DERTeletexString, br.asn1.DERAbstractString), br.asn1.DERIA5String = function(t) {
                    br.asn1.DERIA5String.superclass.constructor.call(this, t), this.hT = "16";
                }, o.lang.extend(br.asn1.DERIA5String, br.asn1.DERAbstractString), br.asn1.DERVisibleString = function(t) {
                    br.asn1.DERIA5String.superclass.constructor.call(this, t), this.hT = "1a";
                }, o.lang.extend(br.asn1.DERVisibleString, br.asn1.DERAbstractString), br.asn1.DERBMPString = function(t) {
                    br.asn1.DERBMPString.superclass.constructor.call(this, t), this.hT = "1e";
                }, o.lang.extend(br.asn1.DERBMPString, br.asn1.DERAbstractString), br.asn1.DERUTCTime = function(t) {
                    br.asn1.DERUTCTime.superclass.constructor.call(this, t), this.hT = "17", this.setByDate = function(t) {
                        this.hTLV = null, this.isModified = !0, this.date = t, this.s = this.formatDate(this.date, "utc"), this.hV = Pr(this.s);
                    }, this.getFreshValueHex = function() {
                        return void 0 === this.date && void 0 === this.s && (this.date = new Date, this.s = this.formatDate(this.date, "utc"), this.hV = Pr(this.s)), this.hV;
                    }, void 0 !== t && (void 0 !== t.str ? this.setString(t.str) : "string" == typeof t && t.match(/^[0-9]{12}Z$/) ? this.setString(t) : void 0 !== t.hex ? this.setStringHex(t.hex) : void 0 !== t.date && this.setByDate(t.date));
                }, o.lang.extend(br.asn1.DERUTCTime, br.asn1.DERAbstractTime), br.asn1.DERGeneralizedTime = function(t) {
                    br.asn1.DERGeneralizedTime.superclass.constructor.call(this, t), this.hT = "18", this.withMillis = !1, this.setByDate = function(t) {
                        this.hTLV = null, this.isModified = !0, this.date = t, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = Pr(this.s);
                    }, this.getFreshValueHex = function() {
                        return void 0 === this.date && void 0 === this.s && (this.date = new Date, this.s = this.formatDate(this.date, "gen", this.withMillis), this.hV = Pr(this.s)), this.hV;
                    }, void 0 !== t && (void 0 !== t.str ? this.setString(t.str) : "string" == typeof t && t.match(/^[0-9]{14}Z$/) ? this.setString(t) : void 0 !== t.hex ? this.setStringHex(t.hex) : void 0 !== t.date && this.setByDate(t.date), !0 === t.millis && (this.withMillis = !0));
                }, o.lang.extend(br.asn1.DERGeneralizedTime, br.asn1.DERAbstractTime), br.asn1.DERSequence = function(t) {
                    br.asn1.DERSequence.superclass.constructor.call(this, t), this.hT = "30", this.getFreshValueHex = function() {
                        for(var t = "", e = 0; e < this.asn1Array.length; e++)t += this.asn1Array[e].getEncodedHex();
                        return this.hV = t, this.hV;
                    };
                }, o.lang.extend(br.asn1.DERSequence, br.asn1.DERAbstractStructured), br.asn1.DERSet = function(t) {
                    br.asn1.DERSet.superclass.constructor.call(this, t), this.hT = "31", this.sortFlag = !0, this.getFreshValueHex = function() {
                        for(var t = new Array, e = 0; e < this.asn1Array.length; e++){
                            var r = this.asn1Array[e];
                            t.push(r.getEncodedHex());
                        }
                        return 1 == this.sortFlag && t.sort(), this.hV = t.join(""), this.hV;
                    }, void 0 !== t && void 0 !== t.sortflag && 0 == t.sortflag && (this.sortFlag = !1);
                }, o.lang.extend(br.asn1.DERSet, br.asn1.DERAbstractStructured), br.asn1.DERTaggedObject = function(t) {
                    br.asn1.DERTaggedObject.superclass.constructor.call(this);
                    var e = br.asn1;
                    this.hT = "a0", this.hV = "", this.isExplicit = !0, this.asn1Object = null, this.setASN1Object = function(t, e, r) {
                        this.hT = e, this.isExplicit = t, this.asn1Object = r, this.isExplicit ? (this.hV = this.asn1Object.getEncodedHex(), this.hTLV = null, this.isModified = !0) : (this.hV = null, this.hTLV = r.getEncodedHex(), this.hTLV = this.hTLV.replace(/^../, e), this.isModified = !1);
                    }, this.getFreshValueHex = function() {
                        return this.hV;
                    }, this.setByParam = function(t) {
                        null != t.tag && (this.hT = t.tag), null != t.explicit && (this.isExplicit = t.explicit), null != t.tage && (this.hT = t.tage, this.isExplicit = !0), null != t.tagi && (this.hT = t.tagi, this.isExplicit = !1), null != t.obj && (t.obj instanceof e.ASN1Object ? (this.asn1Object = t.obj, this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)) : "object" == r(t.obj) && (this.asn1Object = e.ASN1Util.newObject(t.obj), this.setASN1Object(this.isExplicit, this.hT, this.asn1Object)));
                    }, null != t && this.setByParam(t);
                }, o.lang.extend(br.asn1.DERTaggedObject, br.asn1.ASN1Object);
                var br, wr, Fr, Er = new function() {};
                function xr(t) {
                    for(var e = new Array, r = 0; r < t.length; r++)e[r] = t.charCodeAt(r);
                    return e;
                }
                function Ar(t) {
                    for(var e = "", r = 0; r < t.length; r++)e += String.fromCharCode(t[r]);
                    return e;
                }
                function kr(t) {
                    for(var e = "", r = 0; r < t.length; r++){
                        var n = t[r].toString(16);
                        1 == n.length && (n = "0" + n), e += n;
                    }
                    return e;
                }
                function Pr(t) {
                    return kr(xr(t));
                }
                function Cr(t) {
                    return t = (t = (t = t.replace(/\=/g, "")).replace(/\+/g, "-")).replace(/\//g, "_");
                }
                function Tr(t) {
                    return t.length % 4 == 2 ? t += "==" : t.length % 4 == 3 && (t += "="), t = (t = t.replace(/-/g, "+")).replace(/_/g, "/");
                }
                function Rr(t) {
                    return t.length % 2 == 1 && (t = "0" + t), Cr(S(t));
                }
                function Ir(t) {
                    return b(Tr(t));
                }
                function Dr(t) {
                    return qr(Gr(t));
                }
                function Lr(t) {
                    return decodeURIComponent(Jr(t));
                }
                function Nr(t) {
                    for(var e = "", r = 0; r < t.length - 1; r += 2)e += String.fromCharCode(parseInt(t.substr(r, 2), 16));
                    return e;
                }
                function Ur(t) {
                    for(var e = "", r = 0; r < t.length; r++)e += ("0" + t.charCodeAt(r).toString(16)).slice(-2);
                    return e;
                }
                function Br(t) {
                    return S(t);
                }
                function Or(t) {
                    var e = Br(t).replace(/(.{64})/g, "$1\r\n");
                    return e = e.replace(/\r\n$/, "");
                }
                function jr(t) {
                    return b(t.replace(/[^0-9A-Za-z\/+=]*/g, ""));
                }
                function Mr(t, e) {
                    return "-----BEGIN " + e + "-----\r\n" + Or(t) + "\r\n-----END " + e + "-----\r\n";
                }
                function Hr(t, e) {
                    if (-1 == t.indexOf("-----BEGIN ")) throw "can't find PEM header: " + e;
                    return jr(t = void 0 !== e ? (t = t.replace(new RegExp("^[^]*-----BEGIN " + e + "-----"), "")).replace(new RegExp("-----END " + e + "-----[^]*$"), "") : (t = t.replace(/^[^]*-----BEGIN [^-]+-----/, "")).replace(/-----END [^-]+-----[^]*$/, ""));
                }
                function Vr(t) {
                    var e, r, n, i, o, s, a, u, c, h, l;
                    if (l = t.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/)) return u = l[1], e = parseInt(u), 2 === u.length && (50 <= e && e < 100 ? e = 1900 + e : 0 <= e && e < 50 && (e = 2e3 + e)), r = parseInt(l[2]) - 1, n = parseInt(l[3]), i = parseInt(l[4]), o = parseInt(l[5]), s = parseInt(l[6]), a = 0, "" !== (c = l[7]) && (h = (c.substr(1) + "00").substr(0, 3), a = parseInt(h)), Date.UTC(e, r, n, i, o, s, a);
                    throw "unsupported zulu format: " + t;
                }
                function Kr(t) {
                    return ~~(Vr(t) / 1e3);
                }
                function qr(t) {
                    return t.replace(/%/g, "");
                }
                function Jr(t) {
                    return t.replace(/(..)/g, "%$1");
                }
                function Wr(t) {
                    var e = "malformed IPv6 address";
                    if (!t.match(/^[0-9A-Fa-f:]+$/)) throw e;
                    var r = (t = t.toLowerCase()).split(":").length - 1;
                    if (r < 2) throw e;
                    var n = ":".repeat(7 - r + 2), i = (t = t.replace("::", n)).split(":");
                    if (8 != i.length) throw e;
                    for(var o = 0; o < 8; o++)i[o] = ("0000" + i[o]).slice(-4);
                    return i.join("");
                }
                function zr(t) {
                    if (!t.match(/^[0-9A-Fa-f]{32}$/)) throw "malformed IPv6 address octet";
                    for(var e = (t = t.toLowerCase()).match(/.{1,4}/g), r = 0; r < 8; r++)e[r] = e[r].replace(/^0+/, ""), "" == e[r] && (e[r] = "0");
                    var n = (t = ":" + e.join(":") + ":").match(/:(0:){2,}/g);
                    if (null === n) return t.slice(1, -1);
                    var i = "";
                    for(r = 0; r < n.length; r++)n[r].length > i.length && (i = n[r]);
                    return (t = t.replace(i, "::")).slice(1, -1);
                }
                function Yr(t) {
                    var e = "malformed hex value";
                    if (!t.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/)) throw e;
                    if (8 != t.length) return 32 == t.length ? zr(t) : t;
                    try {
                        return parseInt(t.substr(0, 2), 16) + "." + parseInt(t.substr(2, 2), 16) + "." + parseInt(t.substr(4, 2), 16) + "." + parseInt(t.substr(6, 2), 16);
                    } catch (t) {
                        throw e;
                    }
                }
                function Gr(t) {
                    for(var e = encodeURIComponent(t), r = "", n = 0; n < e.length; n++)"%" == e[n] ? (r += e.substr(n, 3), n += 2) : r = r + "%" + Pr(e[n]);
                    return r;
                }
                function Xr(t) {
                    return !(t.length % 2 != 0 || !t.match(/^[0-9a-f]+$/) && !t.match(/^[0-9A-F]+$/));
                }
                function $r(t) {
                    return t.length % 2 == 1 ? "0" + t : t.substr(0, 1) > "7" ? "00" + t : t;
                }
                Er.getLblen = function(t, e) {
                    if ("8" != t.substr(e + 2, 1)) return 1;
                    var r = parseInt(t.substr(e + 3, 1));
                    return 0 == r ? -1 : 0 < r && r < 10 ? r + 1 : -2;
                }, Er.getL = function(t, e) {
                    var r = Er.getLblen(t, e);
                    return r < 1 ? "" : t.substr(e + 2, 2 * r);
                }, Er.getVblen = function(t, e) {
                    var r;
                    return "" == (r = Er.getL(t, e)) ? -1 : ("8" === r.substr(0, 1) ? new F(r.substr(2), 16) : new F(r, 16)).intValue();
                }, Er.getVidx = function(t, e) {
                    var r = Er.getLblen(t, e);
                    return r < 0 ? r : e + 2 * (r + 1);
                }, Er.getV = function(t, e) {
                    var r = Er.getVidx(t, e), n = Er.getVblen(t, e);
                    return t.substr(r, 2 * n);
                }, Er.getTLV = function(t, e) {
                    return t.substr(e, 2) + Er.getL(t, e) + Er.getV(t, e);
                }, Er.getTLVblen = function(t, e) {
                    return 2 + 2 * Er.getLblen(t, e) + 2 * Er.getVblen(t, e);
                }, Er.getNextSiblingIdx = function(t, e) {
                    return Er.getVidx(t, e) + 2 * Er.getVblen(t, e);
                }, Er.getChildIdx = function(t, e) {
                    var r, n, i, o = Er, s = [];
                    r = o.getVidx(t, e), n = 2 * o.getVblen(t, e), "03" == t.substr(e, 2) && (r += 2, n -= 2), i = 0;
                    for(var a = r; i <= n;){
                        var u = o.getTLVblen(t, a);
                        if ((i += u) <= n && s.push(a), a += u, i >= n) break;
                    }
                    return s;
                }, Er.getNthChildIdx = function(t, e, r) {
                    return Er.getChildIdx(t, e)[r];
                }, Er.getIdxbyList = function(t, e, r, n) {
                    var i, o, s = Er;
                    return 0 == r.length ? void 0 !== n && t.substr(e, 2) !== n ? -1 : e : (i = r.shift()) >= (o = s.getChildIdx(t, e)).length ? -1 : s.getIdxbyList(t, o[i], r, n);
                }, Er.getIdxbyListEx = function(t, e, r, n) {
                    var i, o, s = Er;
                    if (0 == r.length) return void 0 !== n && t.substr(e, 2) !== n ? -1 : e;
                    i = r.shift(), o = s.getChildIdx(t, e);
                    for(var a = 0, u = 0; u < o.length; u++){
                        var c = t.substr(o[u], 2);
                        if ("number" == typeof i && !s.isContextTag(c) && a == i || "string" == typeof i && s.isContextTag(c, i)) return s.getIdxbyListEx(t, o[u], r, n);
                        s.isContextTag(c) || a++;
                    }
                    return -1;
                }, Er.getTLVbyList = function(t, e, r, n) {
                    var i = Er, o = i.getIdxbyList(t, e, r, n);
                    return -1 == o || o >= t.length ? null : i.getTLV(t, o);
                }, Er.getTLVbyListEx = function(t, e, r, n) {
                    var i = Er, o = i.getIdxbyListEx(t, e, r, n);
                    return -1 == o ? null : i.getTLV(t, o);
                }, Er.getVbyList = function(t, e, r, n, i) {
                    var o, s, a = Er;
                    return -1 == (o = a.getIdxbyList(t, e, r, n)) || o >= t.length ? null : (s = a.getV(t, o), !0 === i && (s = s.substr(2)), s);
                }, Er.getVbyListEx = function(t, e, r, n, i) {
                    var o, s, a = Er;
                    return -1 == (o = a.getIdxbyListEx(t, e, r, n)) ? null : (s = a.getV(t, o), "03" == t.substr(o, 2) && !1 !== i && (s = s.substr(2)), s);
                }, Er.getInt = function(t, e, r) {
                    null == r && (r = -1);
                    try {
                        var n = t.substr(e, 2);
                        if ("02" != n && "03" != n) return r;
                        var i = Er.getV(t, e);
                        return "02" == n ? parseInt(i, 16) : function o(t) {
                            try {
                                var e = t.substr(0, 2);
                                if ("00" == e) return parseInt(t.substr(2), 16);
                                var r = parseInt(e, 16), n = t.substr(2), i = parseInt(n, 16).toString(2);
                                return "0" == i && (i = "00000000"), i = i.slice(0, 0 - r), parseInt(i, 2);
                            } catch (t) {
                                return -1;
                            }
                        }(i);
                    } catch (t) {
                        return r;
                    }
                }, Er.getOID = function(t, e, r) {
                    null == r && (r = null);
                    try {
                        return "06" != t.substr(e, 2) ? r : function n(t) {
                            if (!Xr(t)) return null;
                            try {
                                var e = [], r = t.substr(0, 2), n = parseInt(r, 16);
                                e[0] = new String(Math.floor(n / 40)), e[1] = new String(n % 40);
                                for(var i = t.substr(2), o = [], s = 0; s < i.length / 2; s++)o.push(parseInt(i.substr(2 * s, 2), 16));
                                var a = [], u = "";
                                for(s = 0; s < o.length; s++)128 & o[s] ? u += Qr((127 & o[s]).toString(2), 7) : (u += Qr((127 & o[s]).toString(2), 7), a.push(new String(parseInt(u, 2))), u = "");
                                var c = e.join(".");
                                return a.length > 0 && (c = c + "." + a.join(".")), c;
                            } catch (t) {
                                return null;
                            }
                        }(Er.getV(t, e));
                    } catch (t) {
                        return r;
                    }
                }, Er.getOIDName = function(t, e, r) {
                    null == r && (r = null);
                    try {
                        var n = Er.getOID(t, e, r);
                        if (n == r) return r;
                        var i = br.asn1.x509.OID.oid2name(n);
                        return "" == i ? n : i;
                    } catch (t) {
                        return r;
                    }
                }, Er.getString = function(t, e, r) {
                    null == r && (r = null);
                    try {
                        return Nr(Er.getV(t, e));
                    } catch (t) {
                        return r;
                    }
                }, Er.hextooidstr = function(t) {
                    var e = function t(e, r) {
                        return e.length >= r ? e : new Array(r - e.length + 1).join("0") + e;
                    }, r = [], n = t.substr(0, 2), i = parseInt(n, 16);
                    r[0] = new String(Math.floor(i / 40)), r[1] = new String(i % 40);
                    for(var o = t.substr(2), s = [], a = 0; a < o.length / 2; a++)s.push(parseInt(o.substr(2 * a, 2), 16));
                    var u = [], c = "";
                    for(a = 0; a < s.length; a++)128 & s[a] ? c += e((127 & s[a]).toString(2), 7) : (c += e((127 & s[a]).toString(2), 7), u.push(new String(parseInt(c, 2))), c = "");
                    var h = r.join(".");
                    return u.length > 0 && (h = h + "." + u.join(".")), h;
                }, Er.dump = function(t, e, r, n) {
                    var i = Er, o = i.getV, s = i.dump, a = i.getChildIdx, u = t;
                    t instanceof br.asn1.ASN1Object && (u = t.getEncodedHex());
                    var c = function t(e, r) {
                        return e.length <= 2 * r ? e : e.substr(0, r) + "..(total " + e.length / 2 + "bytes).." + e.substr(e.length - r, r);
                    };
                    void 0 === e && (e = {
                        ommit_long_octet: 32
                    }), void 0 === r && (r = 0), void 0 === n && (n = "");
                    var h, l = e.ommit_long_octet;
                    if ("01" == (h = u.substr(r, 2))) return "00" == (f = o(u, r)) ? n + "BOOLEAN FALSE\n" : n + "BOOLEAN TRUE\n";
                    if ("02" == h) return n + "INTEGER " + c(f = o(u, r), l) + "\n";
                    if ("03" == h) {
                        var f = o(u, r);
                        if (i.isASN1HEX(f.substr(2))) {
                            var g = n + "BITSTRING, encapsulates\n";
                            return g += s(f.substr(2), e, 0, n + "  ");
                        }
                        return n + "BITSTRING " + c(f, l) + "\n";
                    }
                    if ("04" == h) {
                        f = o(u, r);
                        if (i.isASN1HEX(f)) {
                            g = n + "OCTETSTRING, encapsulates\n";
                            return g += s(f, e, 0, n + "  ");
                        }
                        return n + "OCTETSTRING " + c(f, l) + "\n";
                    }
                    if ("05" == h) return n + "NULL\n";
                    if ("06" == h) {
                        var d = o(u, r), p = br.asn1.ASN1Util.oidHexToInt(d), v = br.asn1.x509.OID.oid2name(p), y = p.replace(/\./g, " ");
                        return "" != v ? n + "ObjectIdentifier " + v + " (" + y + ")\n" : n + "ObjectIdentifier (" + y + ")\n";
                    }
                    if ("0a" == h) return n + "ENUMERATED " + parseInt(o(u, r)) + "\n";
                    if ("0c" == h) return n + "UTF8String '" + Lr(o(u, r)) + "'\n";
                    if ("13" == h) return n + "PrintableString '" + Lr(o(u, r)) + "'\n";
                    if ("14" == h) return n + "TeletexString '" + Lr(o(u, r)) + "'\n";
                    if ("16" == h) return n + "IA5String '" + Lr(o(u, r)) + "'\n";
                    if ("17" == h) return n + "UTCTime " + Lr(o(u, r)) + "\n";
                    if ("18" == h) return n + "GeneralizedTime " + Lr(o(u, r)) + "\n";
                    if ("1a" == h) return n + "VisualString '" + Lr(o(u, r)) + "'\n";
                    if ("1e" == h) return n + "BMPString '" + Lr(o(u, r)) + "'\n";
                    if ("30" == h) {
                        if ("3000" == u.substr(r, 4)) return n + "SEQUENCE {}\n";
                        g = n + "SEQUENCE\n";
                        var m = e;
                        if ((2 == (b = a(u, r)).length || 3 == b.length) && "06" == u.substr(b[0], 2) && "04" == u.substr(b[b.length - 1], 2)) {
                            v = i.oidname(o(u, b[0]));
                            var _ = JSON.parse(JSON.stringify(e));
                            _.x509ExtName = v, m = _;
                        }
                        for(var S = 0; S < b.length; S++)g += s(u, m, b[S], n + "  ");
                        return g;
                    }
                    if ("31" == h) {
                        g = n + "SET\n";
                        var b = a(u, r);
                        for(S = 0; S < b.length; S++)g += s(u, e, b[S], n + "  ");
                        return g;
                    }
                    if (0 != (128 & (h = parseInt(h, 16)))) {
                        var w = 31 & h;
                        if (0 != (32 & h)) {
                            for(g = n + "[" + w + "]\n", b = a(u, r), S = 0; S < b.length; S++)g += s(u, e, b[S], n + "  ");
                            return g;
                        }
                        f = o(u, r);
                        if (Er.isASN1HEX(f)) {
                            var g = n + "[" + w + "]\n";
                            return g += s(f, e, 0, n + "  ");
                        }
                        return ("68747470" == f.substr(0, 8) || "subjectAltName" === e.x509ExtName && 2 == w) && (f = Lr(f)), g = n + "[" + w + "] " + f + "\n";
                    }
                    return n + "UNKNOWN(" + h + ") " + o(u, r) + "\n";
                }, Er.isContextTag = function(t, e) {
                    var r, n;
                    t = t.toLowerCase();
                    try {
                        r = parseInt(t, 16);
                    } catch (t) {
                        return -1;
                    }
                    if (void 0 === e) return 128 == (192 & r);
                    try {
                        return null != e.match(/^\[[0-9]+\]$/) && !((n = parseInt(e.substr(1, e.length - 1), 10)) > 31) && 128 == (192 & r) && (31 & r) == n;
                    } catch (t) {
                        return !1;
                    }
                }, Er.isASN1HEX = function(t) {
                    var e = Er;
                    if (t.length % 2 == 1) return !1;
                    var r = e.getVblen(t, 0), n = t.substr(0, 2), i = e.getL(t, 0);
                    return t.length - n.length - i.length == 2 * r;
                }, Er.checkStrictDER = function(t, e, r, n, i) {
                    var o = Er;
                    if (void 0 === r) {
                        if ("string" != typeof t) throw new Error("not hex string");
                        if (t = t.toLowerCase(), !br.lang.String.isHex(t)) throw new Error("not hex string");
                        r = t.length, i = (n = t.length / 2) < 128 ? 1 : Math.ceil(n.toString(16)) + 1;
                    }
                    if (o.getL(t, e).length > 2 * i) throw new Error("L of TLV too long: idx=" + e);
                    var s = o.getVblen(t, e);
                    if (s > n) throw new Error("value of L too long than hex: idx=" + e);
                    var a = o.getTLV(t, e), u = a.length - 2 - o.getL(t, e).length;
                    if (u !== 2 * s) throw new Error("V string length and L's value not the same:" + u + "/" + 2 * s);
                    if (0 === e && t.length != a.length) throw new Error("total length and TLV length unmatch:" + t.length + "!=" + a.length);
                    var c = t.substr(e, 2);
                    if ("02" === c) {
                        var h = o.getVidx(t, e);
                        if ("00" == t.substr(h, 2) && t.charCodeAt(h + 2) < 56) throw new Error("not least zeros for DER INTEGER");
                    }
                    if (32 & parseInt(c, 16)) {
                        for(var l = o.getVblen(t, e), f = 0, g = o.getChildIdx(t, e), d = 0; d < g.length; d++)f += o.getTLV(t, g[d]).length, o.checkStrictDER(t, g[d], r, n, i);
                        if (2 * l != f) throw new Error("sum of children's TLV length and L unmatch: " + 2 * l + "!=" + f);
                    }
                }, Er.oidname = function(t) {
                    var e = br.asn1;
                    br.lang.String.isHex(t) && (t = e.ASN1Util.oidHexToInt(t));
                    var r = e.x509.OID.oid2name(t);
                    return "" === r && (r = t), r;
                }, void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.lang && br.lang || (br.lang = {}), br.lang.String = function() {}, "function" == typeof t ? (e.utf8tob64u = wr = function e(r) {
                    return Cr(t.from(r, "utf8").toString("base64"));
                }, e.b64utoutf8 = Fr = function e(r) {
                    return t.from(Tr(r), "base64").toString("utf8");
                }) : (e.utf8tob64u = wr = function t(e) {
                    return Rr(qr(Gr(e)));
                }, e.b64utoutf8 = Fr = function t(e) {
                    return decodeURIComponent(Jr(Ir(e)));
                }), br.lang.String.isInteger = function(t) {
                    return !!t.match(/^[0-9]+$/) || !!t.match(/^-[0-9]+$/);
                }, br.lang.String.isHex = function(t) {
                    return Xr(t);
                }, br.lang.String.isBase64 = function(t) {
                    return !(!(t = t.replace(/\s+/g, "")).match(/^[0-9A-Za-z+\/]+={0,3}$/) || t.length % 4 != 0);
                }, br.lang.String.isBase64URL = function(t) {
                    return !t.match(/[+/=]/) && (t = Tr(t), br.lang.String.isBase64(t));
                }, br.lang.String.isIntegerArray = function(t) {
                    return !!(t = t.replace(/\s+/g, "")).match(/^\[[0-9,]+\]$/);
                }, br.lang.String.isPrintable = function(t) {
                    return null !== t.match(/^[0-9A-Za-z '()+,-./:=?]*$/);
                }, br.lang.String.isIA5 = function(t) {
                    return null !== t.match(/^[\x20-\x21\x23-\x7f]*$/);
                }, br.lang.String.isMail = function(t) {
                    return null !== t.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
                };
                var Qr = function t(e, r, n) {
                    return null == n && (n = "0"), e.length >= r ? e : new Array(r - e.length + 1).join(n) + e;
                };
                void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.crypto && br.crypto || (br.crypto = {}), br.crypto.Util = new function() {
                    this.DIGESTINFOHEAD = {
                        sha1: "3021300906052b0e03021a05000414",
                        sha224: "302d300d06096086480165030402040500041c",
                        sha256: "3031300d060960864801650304020105000420",
                        sha384: "3041300d060960864801650304020205000430",
                        sha512: "3051300d060960864801650304020305000440",
                        md2: "3020300c06082a864886f70d020205000410",
                        md5: "3020300c06082a864886f70d020505000410",
                        ripemd160: "3021300906052b2403020105000414"
                    }, this.DEFAULTPROVIDER = {
                        md5: "cryptojs",
                        sha1: "cryptojs",
                        sha224: "cryptojs",
                        sha256: "cryptojs",
                        sha384: "cryptojs",
                        sha512: "cryptojs",
                        ripemd160: "cryptojs",
                        hmacmd5: "cryptojs",
                        hmacsha1: "cryptojs",
                        hmacsha224: "cryptojs",
                        hmacsha256: "cryptojs",
                        hmacsha384: "cryptojs",
                        hmacsha512: "cryptojs",
                        hmacripemd160: "cryptojs",
                        MD5withRSA: "cryptojs/jsrsa",
                        SHA1withRSA: "cryptojs/jsrsa",
                        SHA224withRSA: "cryptojs/jsrsa",
                        SHA256withRSA: "cryptojs/jsrsa",
                        SHA384withRSA: "cryptojs/jsrsa",
                        SHA512withRSA: "cryptojs/jsrsa",
                        RIPEMD160withRSA: "cryptojs/jsrsa",
                        MD5withECDSA: "cryptojs/jsrsa",
                        SHA1withECDSA: "cryptojs/jsrsa",
                        SHA224withECDSA: "cryptojs/jsrsa",
                        SHA256withECDSA: "cryptojs/jsrsa",
                        SHA384withECDSA: "cryptojs/jsrsa",
                        SHA512withECDSA: "cryptojs/jsrsa",
                        RIPEMD160withECDSA: "cryptojs/jsrsa",
                        SHA1withDSA: "cryptojs/jsrsa",
                        SHA224withDSA: "cryptojs/jsrsa",
                        SHA256withDSA: "cryptojs/jsrsa",
                        MD5withRSAandMGF1: "cryptojs/jsrsa",
                        SHAwithRSAandMGF1: "cryptojs/jsrsa",
                        SHA1withRSAandMGF1: "cryptojs/jsrsa",
                        SHA224withRSAandMGF1: "cryptojs/jsrsa",
                        SHA256withRSAandMGF1: "cryptojs/jsrsa",
                        SHA384withRSAandMGF1: "cryptojs/jsrsa",
                        SHA512withRSAandMGF1: "cryptojs/jsrsa",
                        RIPEMD160withRSAandMGF1: "cryptojs/jsrsa"
                    }, this.CRYPTOJSMESSAGEDIGESTNAME = {
                        md5: y.algo.MD5,
                        sha1: y.algo.SHA1,
                        sha224: y.algo.SHA224,
                        sha256: y.algo.SHA256,
                        sha384: y.algo.SHA384,
                        sha512: y.algo.SHA512,
                        ripemd160: y.algo.RIPEMD160
                    }, this.getDigestInfoHex = function(t, e) {
                        if (void 0 === this.DIGESTINFOHEAD[e]) throw "alg not supported in Util.DIGESTINFOHEAD: " + e;
                        return this.DIGESTINFOHEAD[e] + t;
                    }, this.getPaddedDigestInfoHex = function(t, e, r) {
                        var n = this.getDigestInfoHex(t, e), i = r / 4;
                        if (n.length + 22 > i) throw "key is too short for SigAlg: keylen=" + r + "," + e;
                        for(var o = "0001", s = "00" + n, a = "", u = i - o.length - s.length, c = 0; c < u; c += 2)a += "ff";
                        return o + a + s;
                    }, this.hashString = function(t, e) {
                        return new br.crypto.MessageDigest({
                            alg: e
                        }).digestString(t);
                    }, this.hashHex = function(t, e) {
                        return new br.crypto.MessageDigest({
                            alg: e
                        }).digestHex(t);
                    }, this.sha1 = function(t) {
                        return this.hashString(t, "sha1");
                    }, this.sha256 = function(t) {
                        return this.hashString(t, "sha256");
                    }, this.sha256Hex = function(t) {
                        return this.hashHex(t, "sha256");
                    }, this.sha512 = function(t) {
                        return this.hashString(t, "sha512");
                    }, this.sha512Hex = function(t) {
                        return this.hashHex(t, "sha512");
                    }, this.isKey = function(t) {
                        return t instanceof He || t instanceof br.crypto.DSA || t instanceof br.crypto.ECDSA;
                    };
                }, br.crypto.Util.md5 = function(t) {
                    return new br.crypto.MessageDigest({
                        alg: "md5",
                        prov: "cryptojs"
                    }).digestString(t);
                }, br.crypto.Util.ripemd160 = function(t) {
                    return new br.crypto.MessageDigest({
                        alg: "ripemd160",
                        prov: "cryptojs"
                    }).digestString(t);
                }, br.crypto.Util.SECURERANDOMGEN = new Oe, br.crypto.Util.getRandomHexOfNbytes = function(t) {
                    var e = new Array(t);
                    return br.crypto.Util.SECURERANDOMGEN.nextBytes(e), kr(e);
                }, br.crypto.Util.getRandomBigIntegerOfNbytes = function(t) {
                    return new F(br.crypto.Util.getRandomHexOfNbytes(t), 16);
                }, br.crypto.Util.getRandomHexOfNbits = function(t) {
                    var e = t % 8, r = new Array((t - e) / 8 + 1);
                    return br.crypto.Util.SECURERANDOMGEN.nextBytes(r), r[0] = (255 << e & 255 ^ 255) & r[0], kr(r);
                }, br.crypto.Util.getRandomBigIntegerOfNbits = function(t) {
                    return new F(br.crypto.Util.getRandomHexOfNbits(t), 16);
                }, br.crypto.Util.getRandomBigIntegerZeroToMax = function(t) {
                    for(var e = t.bitLength();;){
                        var r = br.crypto.Util.getRandomBigIntegerOfNbits(e);
                        if (-1 != t.compareTo(r)) return r;
                    }
                }, br.crypto.Util.getRandomBigIntegerMinToMax = function(t, e) {
                    var r = t.compareTo(e);
                    if (1 == r) throw "biMin is greater than biMax";
                    if (0 == r) return t;
                    var n = e.subtract(t);
                    return br.crypto.Util.getRandomBigIntegerZeroToMax(n).add(t);
                }, br.crypto.MessageDigest = function(t) {
                    this.setAlgAndProvider = function(t, e) {
                        if (null !== (t = br.crypto.MessageDigest.getCanonicalAlgName(t)) && void 0 === e && (e = br.crypto.Util.DEFAULTPROVIDER[t]), -1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t) && "cryptojs" == e) {
                            try {
                                this.md = br.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create();
                            } catch (e) {
                                throw "setAlgAndProvider hash alg set fail alg=" + t + "/" + e;
                            }
                            this.updateString = function(t) {
                                this.md.update(t);
                            }, this.updateHex = function(t) {
                                var e = y.enc.Hex.parse(t);
                                this.md.update(e);
                            }, this.digest = function() {
                                return this.md.finalize().toString(y.enc.Hex);
                            }, this.digestString = function(t) {
                                return this.updateString(t), this.digest();
                            }, this.digestHex = function(t) {
                                return this.updateHex(t), this.digest();
                            };
                        }
                        if (-1 != ":sha256:".indexOf(t) && "sjcl" == e) {
                            try {
                                this.md = new sjcl.hash.sha256;
                            } catch (e) {
                                throw "setAlgAndProvider hash alg set fail alg=" + t + "/" + e;
                            }
                            this.updateString = function(t) {
                                this.md.update(t);
                            }, this.updateHex = function(t) {
                                var e = sjcl.codec.hex.toBits(t);
                                this.md.update(e);
                            }, this.digest = function() {
                                var t = this.md.finalize();
                                return sjcl.codec.hex.fromBits(t);
                            }, this.digestString = function(t) {
                                return this.updateString(t), this.digest();
                            }, this.digestHex = function(t) {
                                return this.updateHex(t), this.digest();
                            };
                        }
                    }, this.updateString = function(t) {
                        throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
                    }, this.updateHex = function(t) {
                        throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
                    }, this.digest = function() {
                        throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
                    }, this.digestString = function(t) {
                        throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
                    }, this.digestHex = function(t) {
                        throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
                    }, void 0 !== t && void 0 !== t.alg && (this.algName = t.alg, void 0 === t.prov && (this.provName = br.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName));
                }, br.crypto.MessageDigest.getCanonicalAlgName = function(t) {
                    return "string" == typeof t && (t = (t = t.toLowerCase()).replace(/-/, "")), t;
                }, br.crypto.MessageDigest.getHashLength = function(t) {
                    var e = br.crypto.MessageDigest, r = e.getCanonicalAlgName(t);
                    if (void 0 === e.HASHLENGTH[r]) throw "not supported algorithm: " + t;
                    return e.HASHLENGTH[r];
                }, br.crypto.MessageDigest.HASHLENGTH = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    ripemd160: 20
                }, br.crypto.Mac = function(t) {
                    this.setAlgAndProvider = function(t, e) {
                        if (null == (t = t.toLowerCase()) && (t = "hmacsha1"), "hmac" != (t = t.toLowerCase()).substr(0, 4)) throw "setAlgAndProvider unsupported HMAC alg: " + t;
                        void 0 === e && (e = br.crypto.Util.DEFAULTPROVIDER[t]), this.algProv = t + "/" + e;
                        var r = t.substr(4);
                        if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r) && "cryptojs" == e) {
                            try {
                                var n = br.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r];
                                this.mac = y.algo.HMAC.create(n, this.pass);
                            } catch (t) {
                                throw "setAlgAndProvider hash alg set fail hashAlg=" + r + "/" + t;
                            }
                            this.updateString = function(t) {
                                this.mac.update(t);
                            }, this.updateHex = function(t) {
                                var e = y.enc.Hex.parse(t);
                                this.mac.update(e);
                            }, this.doFinal = function() {
                                return this.mac.finalize().toString(y.enc.Hex);
                            }, this.doFinalString = function(t) {
                                return this.updateString(t), this.doFinal();
                            }, this.doFinalHex = function(t) {
                                return this.updateHex(t), this.doFinal();
                            };
                        }
                    }, this.updateString = function(t) {
                        throw "updateString(str) not supported for this alg/prov: " + this.algProv;
                    }, this.updateHex = function(t) {
                        throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
                    }, this.doFinal = function() {
                        throw "digest() not supported for this alg/prov: " + this.algProv;
                    }, this.doFinalString = function(t) {
                        throw "digestString(str) not supported for this alg/prov: " + this.algProv;
                    }, this.doFinalHex = function(t) {
                        throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
                    }, this.setPassword = function(t) {
                        if ("string" == typeof t) {
                            var e = t;
                            return t.length % 2 != 1 && t.match(/^[0-9A-Fa-f]+$/) || (e = Ur(t)), void (this.pass = y.enc.Hex.parse(e));
                        }
                        if ("object" != (void 0 === t ? "undefined" : r(t))) throw "KJUR.crypto.Mac unsupported password type: " + t;
                        e = null;
                        if (void 0 !== t.hex) {
                            if (t.hex.length % 2 != 0 || !t.hex.match(/^[0-9A-Fa-f]+$/)) throw "Mac: wrong hex password: " + t.hex;
                            e = t.hex;
                        }
                        if (void 0 !== t.utf8 && (e = Dr(t.utf8)), void 0 !== t.rstr && (e = Ur(t.rstr)), void 0 !== t.b64 && (e = b(t.b64)), void 0 !== t.b64u && (e = Ir(t.b64u)), null == e) throw "KJUR.crypto.Mac unsupported password type: " + t;
                        this.pass = y.enc.Hex.parse(e);
                    }, void 0 !== t && (void 0 !== t.pass && this.setPassword(t.pass), void 0 !== t.alg && (this.algName = t.alg, void 0 === t.prov && (this.provName = br.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)));
                }, br.crypto.Signature = function(t) {
                    var e = null;
                    if (this._setAlgNames = function() {
                        var t = this.algName.match(/^(.+)with(.+)$/);
                        t && (this.mdAlgName = t[1].toLowerCase(), this.pubkeyAlgName = t[2].toLowerCase(), "rsaandmgf1" == this.pubkeyAlgName && "sha" == this.mdAlgName && (this.mdAlgName = "sha1"));
                    }, this._zeroPaddingOfSignature = function(t, e) {
                        for(var r = "", n = e / 4 - t.length, i = 0; i < n; i++)r += "0";
                        return r + t;
                    }, this.setAlgAndProvider = function(t, e) {
                        if (this._setAlgNames(), "cryptojs/jsrsa" != e) throw new Error("provider not supported: " + e);
                        if (-1 != ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)) {
                            try {
                                this.md = new br.crypto.MessageDigest({
                                    alg: this.mdAlgName
                                });
                            } catch (t) {
                                throw new Error("setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + t);
                            }
                            this.init = function(t, e) {
                                var r = null;
                                try {
                                    r = void 0 === e ? Zr.getKey(t) : Zr.getKey(t, e);
                                } catch (t) {
                                    throw "init failed:" + t;
                                }
                                if (!0 === r.isPrivate) this.prvKey = r, this.state = "SIGN";
                                else {
                                    if (!0 !== r.isPublic) throw "init failed.:" + r;
                                    this.pubKey = r, this.state = "VERIFY";
                                }
                            }, this.updateString = function(t) {
                                this.md.updateString(t);
                            }, this.updateHex = function(t) {
                                this.md.updateHex(t);
                            }, this.sign = function() {
                                if (this.sHashHex = this.md.digest(), void 0 === this.prvKey && void 0 !== this.ecprvhex && void 0 !== this.eccurvename && void 0 !== br.crypto.ECDSA && (this.prvKey = new br.crypto.ECDSA({
                                    curve: this.eccurvename,
                                    prv: this.ecprvhex
                                })), this.prvKey instanceof He && "rsaandmgf1" === this.pubkeyAlgName) this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
                                else if (this.prvKey instanceof He && "rsa" === this.pubkeyAlgName) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
                                else if (this.prvKey instanceof br.crypto.ECDSA) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                                else {
                                    if (!(this.prvKey instanceof br.crypto.DSA)) throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
                                    this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                                }
                                return this.hSign;
                            }, this.signString = function(t) {
                                return this.updateString(t), this.sign();
                            }, this.signHex = function(t) {
                                return this.updateHex(t), this.sign();
                            }, this.verify = function(t) {
                                if (this.sHashHex = this.md.digest(), void 0 === this.pubKey && void 0 !== this.ecpubhex && void 0 !== this.eccurvename && void 0 !== br.crypto.ECDSA && (this.pubKey = new br.crypto.ECDSA({
                                    curve: this.eccurvename,
                                    pub: this.ecpubhex
                                })), this.pubKey instanceof He && "rsaandmgf1" === this.pubkeyAlgName) return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, t, this.mdAlgName, this.pssSaltLen);
                                if (this.pubKey instanceof He && "rsa" === this.pubkeyAlgName) return this.pubKey.verifyWithMessageHash(this.sHashHex, t);
                                if (void 0 !== br.crypto.ECDSA && this.pubKey instanceof br.crypto.ECDSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, t);
                                if (void 0 !== br.crypto.DSA && this.pubKey instanceof br.crypto.DSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, t);
                                throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
                            };
                        }
                    }, this.init = function(t, e) {
                        throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
                    }, this.updateString = function(t) {
                        throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
                    }, this.updateHex = function(t) {
                        throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
                    }, this.sign = function() {
                        throw "sign() not supported for this alg:prov=" + this.algProvName;
                    }, this.signString = function(t) {
                        throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
                    }, this.signHex = function(t) {
                        throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
                    }, this.verify = function(t) {
                        throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
                    }, this.initParams = t, void 0 !== t && (void 0 !== t.alg && (this.algName = t.alg, void 0 === t.prov ? this.provName = br.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = t.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), void 0 !== t.psssaltlen && (this.pssSaltLen = t.psssaltlen), void 0 !== t.prvkeypem)) {
                        if (void 0 !== t.prvkeypas) throw "both prvkeypem and prvkeypas parameters not supported";
                        try {
                            e = Zr.getKey(t.prvkeypem);
                            this.init(e);
                        } catch (t) {
                            throw "fatal error to load pem private key: " + t;
                        }
                    }
                }, br.crypto.Cipher = function(t) {}, br.crypto.Cipher.encrypt = function(t, e, r) {
                    if (e instanceof He && e.isPublic) {
                        var n = br.crypto.Cipher.getAlgByKeyAndName(e, r);
                        if ("RSA" === n) return e.encrypt(t);
                        if ("RSAOAEP" === n) return e.encryptOAEP(t, "sha1");
                        var i = n.match(/^RSAOAEP(\d+)$/);
                        if (null !== i) return e.encryptOAEP(t, "sha" + i[1]);
                        throw "Cipher.encrypt: unsupported algorithm for RSAKey: " + r;
                    }
                    throw "Cipher.encrypt: unsupported key or algorithm";
                }, br.crypto.Cipher.decrypt = function(t, e, r) {
                    if (e instanceof He && e.isPrivate) {
                        var n = br.crypto.Cipher.getAlgByKeyAndName(e, r);
                        if ("RSA" === n) return e.decrypt(t);
                        if ("RSAOAEP" === n) return e.decryptOAEP(t, "sha1");
                        var i = n.match(/^RSAOAEP(\d+)$/);
                        if (null !== i) return e.decryptOAEP(t, "sha" + i[1]);
                        throw "Cipher.decrypt: unsupported algorithm for RSAKey: " + r;
                    }
                    throw "Cipher.decrypt: unsupported key or algorithm";
                }, br.crypto.Cipher.getAlgByKeyAndName = function(t, e) {
                    if (t instanceof He) {
                        if (-1 != ":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(e)) return e;
                        if (null == e) return "RSA";
                        throw "getAlgByKeyAndName: not supported algorithm name for RSAKey: " + e;
                    }
                    throw "getAlgByKeyAndName: not supported algorithm name: " + e;
                }, br.crypto.OID = new function() {
                    this.oidhex2name = {
                        "2a864886f70d010101": "rsaEncryption",
                        "2a8648ce3d0201": "ecPublicKey",
                        "2a8648ce380401": "dsa",
                        "2a8648ce3d030107": "secp256r1",
                        "2b8104001f": "secp192k1",
                        "2b81040021": "secp224r1",
                        "2b8104000a": "secp256k1",
                        "2b81040023": "secp521r1",
                        "2b81040022": "secp384r1",
                        "2a8648ce380403": "SHA1withDSA",
                        "608648016503040301": "SHA224withDSA",
                        "608648016503040302": "SHA256withDSA"
                    };
                }, void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.crypto && br.crypto || (br.crypto = {}), br.crypto.ECDSA = function(t) {
                    var e = Error, n = F, i = Ke, o = br.crypto.ECDSA, s = br.crypto.ECParameterDB, a = o.getName, u = Er, c = u.getVbyListEx, h = u.isASN1HEX, l = new Oe;
                    this.type = "EC", this.isPrivate = !1, this.isPublic = !1, this.getBigRandom = function(t) {
                        return new n(t.bitLength(), l).mod(t.subtract(n.ONE)).add(n.ONE);
                    }, this.setNamedCurve = function(t) {
                        this.ecparams = s.getByName(t), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = t;
                    }, this.setPrivateKeyHex = function(t) {
                        this.isPrivate = !0, this.prvKeyHex = t;
                    }, this.setPublicKeyHex = function(t) {
                        this.isPublic = !0, this.pubKeyHex = t;
                    }, this.getPublicKeyXYHex = function() {
                        var t = this.pubKeyHex;
                        if ("04" !== t.substr(0, 2)) throw "this method supports uncompressed format(04) only";
                        var e = this.ecparams.keylen / 4;
                        if (t.length !== 2 + 2 * e) throw "malformed public key hex length";
                        var r = {};
                        return r.x = t.substr(2, e), r.y = t.substr(2 + e), r;
                    }, this.getShortNISTPCurveName = function() {
                        var t = this.curveName;
                        return "secp256r1" === t || "NIST P-256" === t || "P-256" === t || "prime256v1" === t ? "P-256" : "secp384r1" === t || "NIST P-384" === t || "P-384" === t ? "P-384" : null;
                    }, this.generateKeyPairHex = function() {
                        var t = this.ecparams.n, e = this.getBigRandom(t), r = this.ecparams.G.multiply(e), n = r.getX().toBigInteger(), i = r.getY().toBigInteger(), o = this.ecparams.keylen / 4, s = ("0000000000" + e.toString(16)).slice(-o), a = "04" + ("0000000000" + n.toString(16)).slice(-o) + ("0000000000" + i.toString(16)).slice(-o);
                        return this.setPrivateKeyHex(s), this.setPublicKeyHex(a), {
                            ecprvhex: s,
                            ecpubhex: a
                        };
                    }, this.signWithMessageHash = function(t) {
                        return this.signHex(t, this.prvKeyHex);
                    }, this.signHex = function(t, e) {
                        var r = new n(e, 16), i = this.ecparams.n, s = new n(t.substring(0, this.ecparams.keylen / 4), 16);
                        do var a = this.getBigRandom(i), u = this.ecparams.G.multiply(a).getX().toBigInteger().mod(i);
                        while (u.compareTo(n.ZERO) <= 0);
                        var c = a.modInverse(i).multiply(s.add(r.multiply(u))).mod(i);
                        return o.biRSSigToASN1Sig(u, c);
                    }, this.sign = function(t, e) {
                        var r = e, i = this.ecparams.n, o = n.fromByteArrayUnsigned(t);
                        do var s = this.getBigRandom(i), a = this.ecparams.G.multiply(s).getX().toBigInteger().mod(i);
                        while (a.compareTo(F.ZERO) <= 0);
                        var u = s.modInverse(i).multiply(o.add(r.multiply(a))).mod(i);
                        return this.serializeSig(a, u);
                    }, this.verifyWithMessageHash = function(t, e) {
                        return this.verifyHex(t, e, this.pubKeyHex);
                    }, this.verifyHex = function(t, e, r) {
                        try {
                            var s, a, u = o.parseSigHex(e);
                            s = u.r, a = u.s;
                            var c = i.decodeFromHex(this.ecparams.curve, r), h = new n(t.substring(0, this.ecparams.keylen / 4), 16);
                            return this.verifyRaw(h, s, a, c);
                        } catch (t) {
                            return !1;
                        }
                    }, this.verify = function(t, e, o) {
                        var s, a, u;
                        if (Bitcoin.Util.isArray(e)) {
                            var c = this.parseSig(e);
                            s = c.r, a = c.s;
                        } else {
                            if ("object" !== (void 0 === e ? "undefined" : r(e)) || !e.r || !e.s) throw "Invalid value for signature";
                            s = e.r, a = e.s;
                        }
                        if (o instanceof Ke) u = o;
                        else {
                            if (!Bitcoin.Util.isArray(o)) throw "Invalid format for pubkey value, must be byte array or ECPointFp";
                            u = i.decodeFrom(this.ecparams.curve, o);
                        }
                        var h = n.fromByteArrayUnsigned(t);
                        return this.verifyRaw(h, s, a, u);
                    }, this.verifyRaw = function(t, e, r, i) {
                        var o = this.ecparams.n, s = this.ecparams.G;
                        if (e.compareTo(n.ONE) < 0 || e.compareTo(o) >= 0) return !1;
                        if (r.compareTo(n.ONE) < 0 || r.compareTo(o) >= 0) return !1;
                        var a = r.modInverse(o), u = t.multiply(a).mod(o), c = e.multiply(a).mod(o);
                        return s.multiply(u).add(i.multiply(c)).getX().toBigInteger().mod(o).equals(e);
                    }, this.serializeSig = function(t, e) {
                        var r = t.toByteArraySigned(), n = e.toByteArraySigned(), i = [];
                        return i.push(2), i.push(r.length), (i = i.concat(r)).push(2), i.push(n.length), (i = i.concat(n)).unshift(i.length), i.unshift(48), i;
                    }, this.parseSig = function(t) {
                        var e;
                        if (48 != t[0]) throw new Error("Signature not a valid DERSequence");
                        if (2 != t[e = 2]) throw new Error("First element in signature must be a DERInteger");
                        var r = t.slice(e + 2, e + 2 + t[e + 1]);
                        if (2 != t[e += 2 + t[e + 1]]) throw new Error("Second element in signature must be a DERInteger");
                        var i = t.slice(e + 2, e + 2 + t[e + 1]);
                        return e += 2 + t[e + 1], {
                            r: n.fromByteArrayUnsigned(r),
                            s: n.fromByteArrayUnsigned(i)
                        };
                    }, this.parseSigCompact = function(t) {
                        if (65 !== t.length) throw "Signature has the wrong length";
                        var e = t[0] - 27;
                        if (e < 0 || e > 7) throw "Invalid signature type";
                        var r = this.ecparams.n;
                        return {
                            r: n.fromByteArrayUnsigned(t.slice(1, 33)).mod(r),
                            s: n.fromByteArrayUnsigned(t.slice(33, 65)).mod(r),
                            i: e
                        };
                    }, this.readPKCS5PrvKeyHex = function(t) {
                        if (!1 === h(t)) throw new Error("not ASN.1 hex string");
                        var e, r, n;
                        try {
                            e = c(t, 0, [
                                "[0]",
                                0
                            ], "06"), r = c(t, 0, [
                                1
                            ], "04");
                            try {
                                n = c(t, 0, [
                                    "[1]",
                                    0
                                ], "03");
                            } catch (t) {}
                        } catch (t) {
                            throw new Error("malformed PKCS#1/5 plain ECC private key");
                        }
                        if (this.curveName = a(e), void 0 === this.curveName) throw "unsupported curve name";
                        this.setNamedCurve(this.curveName), this.setPublicKeyHex(n), this.setPrivateKeyHex(r), this.isPublic = !1;
                    }, this.readPKCS8PrvKeyHex = function(t) {
                        if (!1 === h(t)) throw new e("not ASN.1 hex string");
                        var r, n, i;
                        try {
                            c(t, 0, [
                                1,
                                0
                            ], "06"), r = c(t, 0, [
                                1,
                                1
                            ], "06"), n = c(t, 0, [
                                2,
                                0,
                                1
                            ], "04");
                            try {
                                i = c(t, 0, [
                                    2,
                                    0,
                                    "[1]",
                                    0
                                ], "03");
                            } catch (t) {}
                        } catch (t) {
                            throw new e("malformed PKCS#8 plain ECC private key");
                        }
                        if (this.curveName = a(r), void 0 === this.curveName) throw new e("unsupported curve name");
                        this.setNamedCurve(this.curveName), this.setPublicKeyHex(i), this.setPrivateKeyHex(n), this.isPublic = !1;
                    }, this.readPKCS8PubKeyHex = function(t) {
                        if (!1 === h(t)) throw new e("not ASN.1 hex string");
                        var r, n;
                        try {
                            c(t, 0, [
                                0,
                                0
                            ], "06"), r = c(t, 0, [
                                0,
                                1
                            ], "06"), n = c(t, 0, [
                                1
                            ], "03");
                        } catch (t) {
                            throw new e("malformed PKCS#8 ECC public key");
                        }
                        if (this.curveName = a(r), null === this.curveName) throw new e("unsupported curve name");
                        this.setNamedCurve(this.curveName), this.setPublicKeyHex(n);
                    }, this.readCertPubKeyHex = function(t, r) {
                        if (!1 === h(t)) throw new e("not ASN.1 hex string");
                        var n, i;
                        try {
                            n = c(t, 0, [
                                0,
                                5,
                                0,
                                1
                            ], "06"), i = c(t, 0, [
                                0,
                                5,
                                1
                            ], "03");
                        } catch (t) {
                            throw new e("malformed X.509 certificate ECC public key");
                        }
                        if (this.curveName = a(n), null === this.curveName) throw new e("unsupported curve name");
                        this.setNamedCurve(this.curveName), this.setPublicKeyHex(i);
                    }, void 0 !== t && void 0 !== t.curve && (this.curveName = t.curve), void 0 === this.curveName && (this.curveName = "secp256r1"), this.setNamedCurve(this.curveName), void 0 !== t && (void 0 !== t.prv && this.setPrivateKeyHex(t.prv), void 0 !== t.pub && this.setPublicKeyHex(t.pub));
                }, br.crypto.ECDSA.parseSigHex = function(t) {
                    var e = br.crypto.ECDSA.parseSigHexInHexRS(t);
                    return {
                        r: new F(e.r, 16),
                        s: new F(e.s, 16)
                    };
                }, br.crypto.ECDSA.parseSigHexInHexRS = function(t) {
                    var e = Er, r = e.getChildIdx, n = e.getV;
                    if (e.checkStrictDER(t, 0), "30" != t.substr(0, 2)) throw new Error("signature is not a ASN.1 sequence");
                    var i = r(t, 0);
                    if (2 != i.length) throw new Error("signature shall have two elements");
                    var o = i[0], s = i[1];
                    if ("02" != t.substr(o, 2)) throw new Error("1st item not ASN.1 integer");
                    if ("02" != t.substr(s, 2)) throw new Error("2nd item not ASN.1 integer");
                    return {
                        r: n(t, o),
                        s: n(t, s)
                    };
                }, br.crypto.ECDSA.asn1SigToConcatSig = function(t) {
                    var e = br.crypto.ECDSA.parseSigHexInHexRS(t), r = e.r, n = e.s;
                    if ("00" == r.substr(0, 2) && r.length % 32 == 2 && (r = r.substr(2)), "00" == n.substr(0, 2) && n.length % 32 == 2 && (n = n.substr(2)), r.length % 32 == 30 && (r = "00" + r), n.length % 32 == 30 && (n = "00" + n), r.length % 32 != 0) throw "unknown ECDSA sig r length error";
                    if (n.length % 32 != 0) throw "unknown ECDSA sig s length error";
                    return r + n;
                }, br.crypto.ECDSA.concatSigToASN1Sig = function(t) {
                    if (t.length / 2 * 8 % 128 != 0) throw "unknown ECDSA concatinated r-s sig  length error";
                    var e = t.substr(0, t.length / 2), r = t.substr(t.length / 2);
                    return br.crypto.ECDSA.hexRSSigToASN1Sig(e, r);
                }, br.crypto.ECDSA.hexRSSigToASN1Sig = function(t, e) {
                    var r = new F(t, 16), n = new F(e, 16);
                    return br.crypto.ECDSA.biRSSigToASN1Sig(r, n);
                }, br.crypto.ECDSA.biRSSigToASN1Sig = function(t, e) {
                    var r = br.asn1, n = new r.DERInteger({
                        bigint: t
                    }), i = new r.DERInteger({
                        bigint: e
                    });
                    return new r.DERSequence({
                        array: [
                            n,
                            i
                        ]
                    }).getEncodedHex();
                }, br.crypto.ECDSA.getName = function(t) {
                    return "2b8104001f" === t ? "secp192k1" : "2a8648ce3d030107" === t ? "secp256r1" : "2b8104000a" === t ? "secp256k1" : "2b81040021" === t ? "secp224r1" : "2b81040022" === t ? "secp384r1" : -1 !== "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(t) ? "secp256r1" : -1 !== "|secp256k1|".indexOf(t) ? "secp256k1" : -1 !== "|secp224r1|NIST P-224|P-224|".indexOf(t) ? "secp224r1" : -1 !== "|secp384r1|NIST P-384|P-384|".indexOf(t) ? "secp384r1" : null;
                }, void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.crypto && br.crypto || (br.crypto = {}), br.crypto.ECParameterDB = new function() {
                    var t = {}, e = {};
                    function r(t) {
                        return new F(t, 16);
                    }
                    this.getByName = function(r) {
                        var n = r;
                        if (void 0 !== e[n] && (n = e[r]), void 0 !== t[n]) return t[n];
                        throw "unregistered EC curve name: " + n;
                    }, this.regist = function(n, i, o, s, a, u, c, h, l, f, g, d) {
                        t[n] = {};
                        var p = r(o), v = r(s), y = r(a), m = r(u), _ = r(c), S = new qe(p, v, y), b = S.decodePointHex("04" + h + l);
                        t[n].name = n, t[n].keylen = i, t[n].curve = S, t[n].G = b, t[n].n = m, t[n].h = _, t[n].oid = g, t[n].info = d;
                        for(var w = 0; w < f.length; w++)e[f[w]] = n;
                    };
                }, br.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field"), br.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field"), br.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field"), br.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []), br.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []), br.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []), br.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []), br.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", [
                    "NIST P-256",
                    "P-256",
                    "prime256v1"
                ]), br.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", [
                    "NIST P-384",
                    "P-384"
                ]), br.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", [
                    "NIST P-521",
                    "P-521"
                ]);
                var Zr = function() {
                    var t = function t(r, n, i) {
                        return e(y.AES, r, n, i);
                    }, e = function t(e, r, n, i) {
                        var o = y.enc.Hex.parse(r), s = y.enc.Hex.parse(n), a = y.enc.Hex.parse(i), u = {};
                        u.key = s, u.iv = a, u.ciphertext = o;
                        var c = e.decrypt(u, s, {
                            iv: a
                        });
                        return y.enc.Hex.stringify(c);
                    }, r = function t(e, r, i) {
                        return n(y.AES, e, r, i);
                    }, n = function t(e, r, n, i) {
                        var o = y.enc.Hex.parse(r), s = y.enc.Hex.parse(n), a = y.enc.Hex.parse(i), u = e.encrypt(o, s, {
                            iv: a
                        }), c = y.enc.Hex.parse(u.toString());
                        return y.enc.Base64.stringify(c);
                    }, i = {
                        "AES-256-CBC": {
                            proc: t,
                            eproc: r,
                            keylen: 32,
                            ivlen: 16
                        },
                        "AES-192-CBC": {
                            proc: t,
                            eproc: r,
                            keylen: 24,
                            ivlen: 16
                        },
                        "AES-128-CBC": {
                            proc: t,
                            eproc: r,
                            keylen: 16,
                            ivlen: 16
                        },
                        "DES-EDE3-CBC": {
                            proc: function t(r, n, i) {
                                return e(y.TripleDES, r, n, i);
                            },
                            eproc: function t(e, r, i) {
                                return n(y.TripleDES, e, r, i);
                            },
                            keylen: 24,
                            ivlen: 8
                        },
                        "DES-CBC": {
                            proc: function t(r, n, i) {
                                return e(y.DES, r, n, i);
                            },
                            eproc: function t(e, r, i) {
                                return n(y.DES, e, r, i);
                            },
                            keylen: 8,
                            ivlen: 8
                        }
                    }, o = function t(e) {
                        var r = {}, n = e.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));
                        n && (r.cipher = n[1], r.ivsalt = n[2]);
                        var i = e.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));
                        i && (r.type = i[1]);
                        var o = -1, s = 0;
                        -1 != e.indexOf("\r\n\r\n") && (o = e.indexOf("\r\n\r\n"), s = 2), -1 != e.indexOf("\n\n") && (o = e.indexOf("\n\n"), s = 1);
                        var a = e.indexOf("-----END");
                        if (-1 != o && -1 != a) {
                            var u = e.substring(o + 2 * s, a - s);
                            u = u.replace(/\s+/g, ""), r.data = u;
                        }
                        return r;
                    }, s = function t(e, r, n) {
                        for(var o = n.substring(0, 16), s = y.enc.Hex.parse(o), a = y.enc.Utf8.parse(r), u = i[e].keylen + i[e].ivlen, c = "", h = null;;){
                            var l = y.algo.MD5.create();
                            if (null != h && l.update(h), l.update(a), l.update(s), h = l.finalize(), (c += y.enc.Hex.stringify(h)).length >= 2 * u) break;
                        }
                        var f = {};
                        return f.keyhex = c.substr(0, 2 * i[e].keylen), f.ivhex = c.substr(2 * i[e].keylen, 2 * i[e].ivlen), f;
                    }, a = function t(e, r, n, o) {
                        var s = y.enc.Base64.parse(e), a = y.enc.Hex.stringify(s);
                        return (0, i[r].proc)(a, n, o);
                    };
                    return {
                        version: "1.0.0",
                        parsePKCS5PEM: function t(e) {
                            return o(e);
                        },
                        getKeyAndUnusedIvByPasscodeAndIvsalt: function t(e, r, n) {
                            return s(e, r, n);
                        },
                        decryptKeyB64: function t(e, r, n, i) {
                            return a(e, r, n, i);
                        },
                        getDecryptedKeyHex: function t(e, r) {
                            var n = o(e), i = (n.type, n.cipher), u = n.ivsalt, c = n.data, h = s(i, r, u).keyhex;
                            return a(c, i, h, u);
                        },
                        getEncryptedPKCS5PEMFromPrvKeyHex: function t(e, r, n, o, a) {
                            var u = "";
                            if (void 0 !== o && null != o || (o = "AES-256-CBC"), void 0 === i[o]) throw "KEYUTIL unsupported algorithm: " + o;
                            void 0 !== a && null != a || (a = (function t(e) {
                                var r = y.lib.WordArray.random(e);
                                return y.enc.Hex.stringify(r);
                            })(i[o].ivlen).toUpperCase());
                            var c = function t(e, r, n, o) {
                                return (0, i[r].eproc)(e, n, o);
                            }(r, o, s(o, n, a).keyhex, a);
                            u = "-----BEGIN " + e + " PRIVATE KEY-----\r\n";
                            return u += "Proc-Type: 4,ENCRYPTED\r\n", u += "DEK-Info: " + o + "," + a + "\r\n", u += "\r\n", u += c.replace(/(.{64})/g, "$1\r\n"), u += "\r\n-----END " + e + " PRIVATE KEY-----\r\n";
                        },
                        parseHexOfEncryptedPKCS8: function t(e) {
                            var r = Er, n = r.getChildIdx, i = r.getV, o = {}, s = n(e, 0);
                            if (2 != s.length) throw "malformed format: SEQUENCE(0).items != 2: " + s.length;
                            o.ciphertext = i(e, s[1]);
                            var a = n(e, s[0]);
                            if (2 != a.length) throw "malformed format: SEQUENCE(0.0).items != 2: " + a.length;
                            if ("2a864886f70d01050d" != i(e, a[0])) throw "this only supports pkcs5PBES2";
                            var u = n(e, a[1]);
                            if (2 != a.length) throw "malformed format: SEQUENCE(0.0.1).items != 2: " + u.length;
                            var c = n(e, u[1]);
                            if (2 != c.length) throw "malformed format: SEQUENCE(0.0.1.1).items != 2: " + c.length;
                            if ("2a864886f70d0307" != i(e, c[0])) throw "this only supports TripleDES";
                            o.encryptionSchemeAlg = "TripleDES", o.encryptionSchemeIV = i(e, c[1]);
                            var h = n(e, u[0]);
                            if (2 != h.length) throw "malformed format: SEQUENCE(0.0.1.0).items != 2: " + h.length;
                            if ("2a864886f70d01050c" != i(e, h[0])) throw "this only supports pkcs5PBKDF2";
                            var l = n(e, h[1]);
                            if (l.length < 2) throw "malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + l.length;
                            o.pbkdf2Salt = i(e, l[0]);
                            var f = i(e, l[1]);
                            try {
                                o.pbkdf2Iter = parseInt(f, 16);
                            } catch (t) {
                                throw "malformed format pbkdf2Iter: " + f;
                            }
                            return o;
                        },
                        getPBKDF2KeyHexFromParam: function t(e, r) {
                            var n = y.enc.Hex.parse(e.pbkdf2Salt), i = e.pbkdf2Iter, o = y.PBKDF2(r, n, {
                                keySize: 6,
                                iterations: i
                            });
                            return y.enc.Hex.stringify(o);
                        },
                        _getPlainPKCS8HexFromEncryptedPKCS8PEM: function t(e, r) {
                            var n = Hr(e, "ENCRYPTED PRIVATE KEY"), i = this.parseHexOfEncryptedPKCS8(n), o = Zr.getPBKDF2KeyHexFromParam(i, r), s = {};
                            s.ciphertext = y.enc.Hex.parse(i.ciphertext);
                            var a = y.enc.Hex.parse(o), u = y.enc.Hex.parse(i.encryptionSchemeIV), c = y.TripleDES.decrypt(s, a, {
                                iv: u
                            });
                            return y.enc.Hex.stringify(c);
                        },
                        getKeyFromEncryptedPKCS8PEM: function t(e, r) {
                            var n = this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e, r);
                            return this.getKeyFromPlainPrivatePKCS8Hex(n);
                        },
                        parsePlainPrivatePKCS8Hex: function t(e) {
                            var r = Er, n = r.getChildIdx, i = r.getV, o = {
                                algparam: null
                            };
                            if ("30" != e.substr(0, 2)) throw "malformed plain PKCS8 private key(code:001)";
                            var s = n(e, 0);
                            if (3 != s.length) throw "malformed plain PKCS8 private key(code:002)";
                            if ("30" != e.substr(s[1], 2)) throw "malformed PKCS8 private key(code:003)";
                            var a = n(e, s[1]);
                            if (2 != a.length) throw "malformed PKCS8 private key(code:004)";
                            if ("06" != e.substr(a[0], 2)) throw "malformed PKCS8 private key(code:005)";
                            if (o.algoid = i(e, a[0]), "06" == e.substr(a[1], 2) && (o.algparam = i(e, a[1])), "04" != e.substr(s[2], 2)) throw "malformed PKCS8 private key(code:006)";
                            return o.keyidx = r.getVidx(e, s[2]), o;
                        },
                        getKeyFromPlainPrivatePKCS8PEM: function t(e) {
                            var r = Hr(e, "PRIVATE KEY");
                            return this.getKeyFromPlainPrivatePKCS8Hex(r);
                        },
                        getKeyFromPlainPrivatePKCS8Hex: function t(e) {
                            var r, n = this.parsePlainPrivatePKCS8Hex(e);
                            if ("2a864886f70d010101" == n.algoid) r = new He;
                            else if ("2a8648ce380401" == n.algoid) r = new br.crypto.DSA;
                            else {
                                if ("2a8648ce3d0201" != n.algoid) throw "unsupported private key algorithm";
                                r = new br.crypto.ECDSA;
                            }
                            return r.readPKCS8PrvKeyHex(e), r;
                        },
                        _getKeyFromPublicPKCS8Hex: function t(e) {
                            var r, n = Er.getVbyList(e, 0, [
                                0,
                                0
                            ], "06");
                            if ("2a864886f70d010101" === n) r = new He;
                            else if ("2a8648ce380401" === n) r = new br.crypto.DSA;
                            else {
                                if ("2a8648ce3d0201" !== n) throw "unsupported PKCS#8 public key hex";
                                r = new br.crypto.ECDSA;
                            }
                            return r.readPKCS8PubKeyHex(e), r;
                        },
                        parsePublicRawRSAKeyHex: function t(e) {
                            var r = Er, n = r.getChildIdx, i = r.getV, o = {};
                            if ("30" != e.substr(0, 2)) throw "malformed RSA key(code:001)";
                            var s = n(e, 0);
                            if (2 != s.length) throw "malformed RSA key(code:002)";
                            if ("02" != e.substr(s[0], 2)) throw "malformed RSA key(code:003)";
                            if (o.n = i(e, s[0]), "02" != e.substr(s[1], 2)) throw "malformed RSA key(code:004)";
                            return o.e = i(e, s[1]), o;
                        },
                        parsePublicPKCS8Hex: function t(e) {
                            var r = Er, n = r.getChildIdx, i = r.getV, o = {
                                algparam: null
                            }, s = n(e, 0);
                            if (2 != s.length) throw "outer DERSequence shall have 2 elements: " + s.length;
                            var a = s[0];
                            if ("30" != e.substr(a, 2)) throw "malformed PKCS8 public key(code:001)";
                            var u = n(e, a);
                            if (2 != u.length) throw "malformed PKCS8 public key(code:002)";
                            if ("06" != e.substr(u[0], 2)) throw "malformed PKCS8 public key(code:003)";
                            if (o.algoid = i(e, u[0]), "06" == e.substr(u[1], 2) ? o.algparam = i(e, u[1]) : "30" == e.substr(u[1], 2) && (o.algparam = {}, o.algparam.p = r.getVbyList(e, u[1], [
                                0
                            ], "02"), o.algparam.q = r.getVbyList(e, u[1], [
                                1
                            ], "02"), o.algparam.g = r.getVbyList(e, u[1], [
                                2
                            ], "02")), "03" != e.substr(s[1], 2)) throw "malformed PKCS8 public key(code:004)";
                            return o.key = i(e, s[1]).substr(2), o;
                        }
                    };
                }();
                Zr.getKey = function(t, e, r) {
                    var n = (v = Er).getChildIdx, i = (v.getV, v.getVbyList), o = br.crypto, s = o.ECDSA, a = o.DSA, u = He, c = Hr, h = Zr;
                    if (void 0 !== u && t instanceof u) return t;
                    if (void 0 !== s && t instanceof s) return t;
                    if (void 0 !== a && t instanceof a) return t;
                    if (void 0 !== t.curve && void 0 !== t.xy && void 0 === t.d) return new s({
                        pub: t.xy,
                        curve: t.curve
                    });
                    if (void 0 !== t.curve && void 0 !== t.d) return new s({
                        prv: t.d,
                        curve: t.curve
                    });
                    if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 === t.d) return (P = new u).setPublic(t.n, t.e), P;
                    if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 !== t.p && void 0 !== t.q && void 0 !== t.dp && void 0 !== t.dq && void 0 !== t.co && void 0 === t.qi) return (P = new u).setPrivateEx(t.n, t.e, t.d, t.p, t.q, t.dp, t.dq, t.co), P;
                    if (void 0 === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 === t.p) return (P = new u).setPrivate(t.n, t.e, t.d), P;
                    if (void 0 !== t.p && void 0 !== t.q && void 0 !== t.g && void 0 !== t.y && void 0 === t.x) return (P = new a).setPublic(t.p, t.q, t.g, t.y), P;
                    if (void 0 !== t.p && void 0 !== t.q && void 0 !== t.g && void 0 !== t.y && void 0 !== t.x) return (P = new a).setPrivate(t.p, t.q, t.g, t.y, t.x), P;
                    if ("RSA" === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 === t.d) return (P = new u).setPublic(Ir(t.n), Ir(t.e)), P;
                    if ("RSA" === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d && void 0 !== t.p && void 0 !== t.q && void 0 !== t.dp && void 0 !== t.dq && void 0 !== t.qi) return (P = new u).setPrivateEx(Ir(t.n), Ir(t.e), Ir(t.d), Ir(t.p), Ir(t.q), Ir(t.dp), Ir(t.dq), Ir(t.qi)), P;
                    if ("RSA" === t.kty && void 0 !== t.n && void 0 !== t.e && void 0 !== t.d) return (P = new u).setPrivate(Ir(t.n), Ir(t.e), Ir(t.d)), P;
                    if ("EC" === t.kty && void 0 !== t.crv && void 0 !== t.x && void 0 !== t.y && void 0 === t.d) {
                        var l = (k = new s({
                            curve: t.crv
                        })).ecparams.keylen / 4, f = "04" + ("0000000000" + Ir(t.x)).slice(-l) + ("0000000000" + Ir(t.y)).slice(-l);
                        return k.setPublicKeyHex(f), k;
                    }
                    if ("EC" === t.kty && void 0 !== t.crv && void 0 !== t.x && void 0 !== t.y && void 0 !== t.d) {
                        l = (k = new s({
                            curve: t.crv
                        })).ecparams.keylen / 4, f = "04" + ("0000000000" + Ir(t.x)).slice(-l) + ("0000000000" + Ir(t.y)).slice(-l);
                        var g = ("0000000000" + Ir(t.d)).slice(-l);
                        return k.setPublicKeyHex(f), k.setPrivateKeyHex(g), k;
                    }
                    if ("pkcs5prv" === r) {
                        var d, p = t, v = Er;
                        if (9 === (d = n(p, 0)).length) (P = new u).readPKCS5PrvKeyHex(p);
                        else if (6 === d.length) (P = new a).readPKCS5PrvKeyHex(p);
                        else {
                            if (!(d.length > 2 && "04" === p.substr(d[1], 2))) throw "unsupported PKCS#1/5 hexadecimal key";
                            (P = new s).readPKCS5PrvKeyHex(p);
                        }
                        return P;
                    }
                    if ("pkcs8prv" === r) return P = h.getKeyFromPlainPrivatePKCS8Hex(t);
                    if ("pkcs8pub" === r) return h._getKeyFromPublicPKCS8Hex(t);
                    if ("x509pub" === r) return on.getPublicKeyFromCertHex(t);
                    if (-1 != t.indexOf("-END CERTIFICATE-", 0) || -1 != t.indexOf("-END X509 CERTIFICATE-", 0) || -1 != t.indexOf("-END TRUSTED CERTIFICATE-", 0)) return on.getPublicKeyFromCertPEM(t);
                    if (-1 != t.indexOf("-END PUBLIC KEY-")) {
                        var y = Hr(t, "PUBLIC KEY");
                        return h._getKeyFromPublicPKCS8Hex(y);
                    }
                    if (-1 != t.indexOf("-END RSA PRIVATE KEY-") && -1 == t.indexOf("4,ENCRYPTED")) {
                        var m = c(t, "RSA PRIVATE KEY");
                        return h.getKey(m, null, "pkcs5prv");
                    }
                    if (-1 != t.indexOf("-END DSA PRIVATE KEY-") && -1 == t.indexOf("4,ENCRYPTED")) {
                        var _ = i(R = c(t, "DSA PRIVATE KEY"), 0, [
                            1
                        ], "02"), S = i(R, 0, [
                            2
                        ], "02"), b = i(R, 0, [
                            3
                        ], "02"), w = i(R, 0, [
                            4
                        ], "02"), E = i(R, 0, [
                            5
                        ], "02");
                        return (P = new a).setPrivate(new F(_, 16), new F(S, 16), new F(b, 16), new F(w, 16), new F(E, 16)), P;
                    }
                    if (-1 != t.indexOf("-END EC PRIVATE KEY-") && -1 == t.indexOf("4,ENCRYPTED")) {
                        m = c(t, "EC PRIVATE KEY");
                        return h.getKey(m, null, "pkcs5prv");
                    }
                    if (-1 != t.indexOf("-END PRIVATE KEY-")) return h.getKeyFromPlainPrivatePKCS8PEM(t);
                    if (-1 != t.indexOf("-END RSA PRIVATE KEY-") && -1 != t.indexOf("4,ENCRYPTED")) {
                        var x = h.getDecryptedKeyHex(t, e), A = new He;
                        return A.readPKCS5PrvKeyHex(x), A;
                    }
                    if (-1 != t.indexOf("-END EC PRIVATE KEY-") && -1 != t.indexOf("4,ENCRYPTED")) {
                        var k, P = i(R = h.getDecryptedKeyHex(t, e), 0, [
                            1
                        ], "04"), C = i(R, 0, [
                            2,
                            0
                        ], "06"), T = i(R, 0, [
                            3,
                            0
                        ], "03").substr(2);
                        if (void 0 === br.crypto.OID.oidhex2name[C]) throw "undefined OID(hex) in KJUR.crypto.OID: " + C;
                        return (k = new s({
                            curve: br.crypto.OID.oidhex2name[C]
                        })).setPublicKeyHex(T), k.setPrivateKeyHex(P), k.isPublic = !1, k;
                    }
                    if (-1 != t.indexOf("-END DSA PRIVATE KEY-") && -1 != t.indexOf("4,ENCRYPTED")) {
                        var R;
                        _ = i(R = h.getDecryptedKeyHex(t, e), 0, [
                            1
                        ], "02"), S = i(R, 0, [
                            2
                        ], "02"), b = i(R, 0, [
                            3
                        ], "02"), w = i(R, 0, [
                            4
                        ], "02"), E = i(R, 0, [
                            5
                        ], "02");
                        return (P = new a).setPrivate(new F(_, 16), new F(S, 16), new F(b, 16), new F(w, 16), new F(E, 16)), P;
                    }
                    if (-1 != t.indexOf("-END ENCRYPTED PRIVATE KEY-")) return h.getKeyFromEncryptedPKCS8PEM(t, e);
                    throw new Error("not supported argument");
                }, Zr.generateKeypair = function(t, e) {
                    if ("RSA" == t) {
                        var r = e;
                        (s = new He).generate(r, "10001"), s.isPrivate = !0, s.isPublic = !0;
                        var n = new He, i = s.n.toString(16), o = s.e.toString(16);
                        return n.setPublic(i, o), n.isPrivate = !1, n.isPublic = !0, (a = {}).prvKeyObj = s, a.pubKeyObj = n, a;
                    }
                    if ("EC" == t) {
                        var s, a, u = e, c = new br.crypto.ECDSA({
                            curve: u
                        }).generateKeyPairHex();
                        return (s = new br.crypto.ECDSA({
                            curve: u
                        })).setPublicKeyHex(c.ecpubhex), s.setPrivateKeyHex(c.ecprvhex), s.isPrivate = !0, s.isPublic = !1, (n = new br.crypto.ECDSA({
                            curve: u
                        })).setPublicKeyHex(c.ecpubhex), n.isPrivate = !1, n.isPublic = !0, (a = {}).prvKeyObj = s, a.pubKeyObj = n, a;
                    }
                    throw "unknown algorithm: " + t;
                }, Zr.getPEM = function(t, e, r, n, i, o) {
                    var s = br, a = s.asn1, u = a.DERObjectIdentifier, c = a.DERInteger, h = a.ASN1Util.newObject, l = a.x509.SubjectPublicKeyInfo, f = s.crypto, g = f.DSA, d = f.ECDSA, p = He;
                    function v(t) {
                        return h({
                            seq: [
                                {
                                    int: 0
                                },
                                {
                                    int: {
                                        bigint: t.n
                                    }
                                },
                                {
                                    int: t.e
                                },
                                {
                                    int: {
                                        bigint: t.d
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.p
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.q
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.dmp1
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.dmq1
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.coeff
                                    }
                                }
                            ]
                        });
                    }
                    function m(t) {
                        return h({
                            seq: [
                                {
                                    int: 1
                                },
                                {
                                    octstr: {
                                        hex: t.prvKeyHex
                                    }
                                },
                                {
                                    tag: [
                                        "a0",
                                        !0,
                                        {
                                            oid: {
                                                name: t.curveName
                                            }
                                        }
                                    ]
                                },
                                {
                                    tag: [
                                        "a1",
                                        !0,
                                        {
                                            bitstr: {
                                                hex: "00" + t.pubKeyHex
                                            }
                                        }
                                    ]
                                }
                            ]
                        });
                    }
                    function _(t) {
                        return h({
                            seq: [
                                {
                                    int: 0
                                },
                                {
                                    int: {
                                        bigint: t.p
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.q
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.g
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.y
                                    }
                                },
                                {
                                    int: {
                                        bigint: t.x
                                    }
                                }
                            ]
                        });
                    }
                    if ((void 0 !== p && t instanceof p || void 0 !== g && t instanceof g || void 0 !== d && t instanceof d) && 1 == t.isPublic && (void 0 === e || "PKCS8PUB" == e)) return Mr(F = new l(t).getEncodedHex(), "PUBLIC KEY");
                    if ("PKCS1PRV" == e && void 0 !== p && t instanceof p && (void 0 === r || null == r) && 1 == t.isPrivate) return Mr(F = v(t).getEncodedHex(), "RSA PRIVATE KEY");
                    if ("PKCS1PRV" == e && void 0 !== d && t instanceof d && (void 0 === r || null == r) && 1 == t.isPrivate) {
                        var S = new u({
                            name: t.curveName
                        }).getEncodedHex(), b = m(t).getEncodedHex(), w = "";
                        return w += Mr(S, "EC PARAMETERS"), w += Mr(b, "EC PRIVATE KEY");
                    }
                    if ("PKCS1PRV" == e && void 0 !== g && t instanceof g && (void 0 === r || null == r) && 1 == t.isPrivate) return Mr(F = _(t).getEncodedHex(), "DSA PRIVATE KEY");
                    if ("PKCS5PRV" == e && void 0 !== p && t instanceof p && void 0 !== r && null != r && 1 == t.isPrivate) {
                        var F = v(t).getEncodedHex();
                        return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", F, r, n, o);
                    }
                    if ("PKCS5PRV" == e && void 0 !== d && t instanceof d && void 0 !== r && null != r && 1 == t.isPrivate) {
                        F = m(t).getEncodedHex();
                        return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", F, r, n, o);
                    }
                    if ("PKCS5PRV" == e && void 0 !== g && t instanceof g && void 0 !== r && null != r && 1 == t.isPrivate) {
                        F = _(t).getEncodedHex();
                        return void 0 === n && (n = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", F, r, n, o);
                    }
                    var E = function t(e, r) {
                        var n = x(e, r);
                        return new h({
                            seq: [
                                {
                                    seq: [
                                        {
                                            oid: {
                                                name: "pkcs5PBES2"
                                            }
                                        },
                                        {
                                            seq: [
                                                {
                                                    seq: [
                                                        {
                                                            oid: {
                                                                name: "pkcs5PBKDF2"
                                                            }
                                                        },
                                                        {
                                                            seq: [
                                                                {
                                                                    octstr: {
                                                                        hex: n.pbkdf2Salt
                                                                    }
                                                                },
                                                                {
                                                                    int: n.pbkdf2Iter
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    seq: [
                                                        {
                                                            oid: {
                                                                name: "des-EDE3-CBC"
                                                            }
                                                        },
                                                        {
                                                            octstr: {
                                                                hex: n.encryptionSchemeIV
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    octstr: {
                                        hex: n.ciphertext
                                    }
                                }
                            ]
                        }).getEncodedHex();
                    }, x = function t(e, r) {
                        var n = y.lib.WordArray.random(8), i = y.lib.WordArray.random(8), o = y.PBKDF2(r, n, {
                            keySize: 6,
                            iterations: 100
                        }), s = y.enc.Hex.parse(e), a = y.TripleDES.encrypt(s, o, {
                            iv: i
                        }) + "", u = {};
                        return u.ciphertext = a, u.pbkdf2Salt = y.enc.Hex.stringify(n), u.pbkdf2Iter = 100, u.encryptionSchemeAlg = "DES-EDE3-CBC", u.encryptionSchemeIV = y.enc.Hex.stringify(i), u;
                    };
                    if ("PKCS8PRV" == e && null != p && t instanceof p && 1 == t.isPrivate) {
                        var A = v(t).getEncodedHex();
                        F = h({
                            seq: [
                                {
                                    int: 0
                                },
                                {
                                    seq: [
                                        {
                                            oid: {
                                                name: "rsaEncryption"
                                            }
                                        },
                                        {
                                            null: !0
                                        }
                                    ]
                                },
                                {
                                    octstr: {
                                        hex: A
                                    }
                                }
                            ]
                        }).getEncodedHex();
                        return void 0 === r || null == r ? Mr(F, "PRIVATE KEY") : Mr(b = E(F, r), "ENCRYPTED PRIVATE KEY");
                    }
                    if ("PKCS8PRV" == e && void 0 !== d && t instanceof d && 1 == t.isPrivate) {
                        A = new h({
                            seq: [
                                {
                                    int: 1
                                },
                                {
                                    octstr: {
                                        hex: t.prvKeyHex
                                    }
                                },
                                {
                                    tag: [
                                        "a1",
                                        !0,
                                        {
                                            bitstr: {
                                                hex: "00" + t.pubKeyHex
                                            }
                                        }
                                    ]
                                }
                            ]
                        }).getEncodedHex(), F = h({
                            seq: [
                                {
                                    int: 0
                                },
                                {
                                    seq: [
                                        {
                                            oid: {
                                                name: "ecPublicKey"
                                            }
                                        },
                                        {
                                            oid: {
                                                name: t.curveName
                                            }
                                        }
                                    ]
                                },
                                {
                                    octstr: {
                                        hex: A
                                    }
                                }
                            ]
                        }).getEncodedHex();
                        return void 0 === r || null == r ? Mr(F, "PRIVATE KEY") : Mr(b = E(F, r), "ENCRYPTED PRIVATE KEY");
                    }
                    if ("PKCS8PRV" == e && void 0 !== g && t instanceof g && 1 == t.isPrivate) {
                        A = new c({
                            bigint: t.x
                        }).getEncodedHex(), F = h({
                            seq: [
                                {
                                    int: 0
                                },
                                {
                                    seq: [
                                        {
                                            oid: {
                                                name: "dsa"
                                            }
                                        },
                                        {
                                            seq: [
                                                {
                                                    int: {
                                                        bigint: t.p
                                                    }
                                                },
                                                {
                                                    int: {
                                                        bigint: t.q
                                                    }
                                                },
                                                {
                                                    int: {
                                                        bigint: t.g
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    octstr: {
                                        hex: A
                                    }
                                }
                            ]
                        }).getEncodedHex();
                        return void 0 === r || null == r ? Mr(F, "PRIVATE KEY") : Mr(b = E(F, r), "ENCRYPTED PRIVATE KEY");
                    }
                    throw new Error("unsupported object nor format");
                }, Zr.getKeyFromCSRPEM = function(t) {
                    var e = Hr(t, "CERTIFICATE REQUEST");
                    return Zr.getKeyFromCSRHex(e);
                }, Zr.getKeyFromCSRHex = function(t) {
                    var e = Zr.parseCSRHex(t);
                    return Zr.getKey(e.p8pubkeyhex, null, "pkcs8pub");
                }, Zr.parseCSRHex = function(t) {
                    var e = Er, r = e.getChildIdx, n = e.getTLV, i = {}, o = t;
                    if ("30" != o.substr(0, 2)) throw "malformed CSR(code:001)";
                    var s = r(o, 0);
                    if (s.length < 1) throw "malformed CSR(code:002)";
                    if ("30" != o.substr(s[0], 2)) throw "malformed CSR(code:003)";
                    var a = r(o, s[0]);
                    if (a.length < 3) throw "malformed CSR(code:004)";
                    return i.p8pubkeyhex = n(o, a[2]), i;
                }, Zr.getKeyID = function(t) {
                    var e = Zr, r = Er;
                    "string" == typeof t && -1 != t.indexOf("BEGIN ") && (t = e.getKey(t));
                    var n = Hr(e.getPEM(t)), i = r.getIdxbyList(n, 0, [
                        1
                    ]), o = r.getV(n, i).substring(2);
                    return br.crypto.Util.hashHex(o, "sha1");
                }, Zr.getJWKFromKey = function(t) {
                    var e = {};
                    if (t instanceof He && t.isPrivate) return e.kty = "RSA", e.n = Rr(t.n.toString(16)), e.e = Rr(t.e.toString(16)), e.d = Rr(t.d.toString(16)), e.p = Rr(t.p.toString(16)), e.q = Rr(t.q.toString(16)), e.dp = Rr(t.dmp1.toString(16)), e.dq = Rr(t.dmq1.toString(16)), e.qi = Rr(t.coeff.toString(16)), e;
                    if (t instanceof He && t.isPublic) return e.kty = "RSA", e.n = Rr(t.n.toString(16)), e.e = Rr(t.e.toString(16)), e;
                    if (t instanceof br.crypto.ECDSA && t.isPrivate) {
                        if ("P-256" !== (n = t.getShortNISTPCurveName()) && "P-384" !== n) throw "unsupported curve name for JWT: " + n;
                        var r = t.getPublicKeyXYHex();
                        return e.kty = "EC", e.crv = n, e.x = Rr(r.x), e.y = Rr(r.y), e.d = Rr(t.prvKeyHex), e;
                    }
                    if (t instanceof br.crypto.ECDSA && t.isPublic) {
                        var n;
                        if ("P-256" !== (n = t.getShortNISTPCurveName()) && "P-384" !== n) throw "unsupported curve name for JWT: " + n;
                        r = t.getPublicKeyXYHex();
                        return e.kty = "EC", e.crv = n, e.x = Rr(r.x), e.y = Rr(r.y), e;
                    }
                    throw "not supported key object";
                }, He.getPosArrayOfChildrenFromHex = function(t) {
                    return Er.getChildIdx(t, 0);
                }, He.getHexValueArrayOfChildrenFromHex = function(t) {
                    var e, r = Er.getV, n = r(t, (e = He.getPosArrayOfChildrenFromHex(t))[0]), i = r(t, e[1]), o = r(t, e[2]), s = r(t, e[3]), a = r(t, e[4]), u = r(t, e[5]), c = r(t, e[6]), h = r(t, e[7]), l = r(t, e[8]);
                    return (e = new Array).push(n, i, o, s, a, u, c, h, l), e;
                }, He.prototype.readPrivateKeyFromPEMString = function(t) {
                    var e = Hr(t), r = He.getHexValueArrayOfChildrenFromHex(e);
                    this.setPrivateEx(r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8]);
                }, He.prototype.readPKCS5PrvKeyHex = function(t) {
                    var e = He.getHexValueArrayOfChildrenFromHex(t);
                    this.setPrivateEx(e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]);
                }, He.prototype.readPKCS8PrvKeyHex = function(t) {
                    var e, r, n, i, o, s, a, u, c = Er, h = c.getVbyListEx;
                    if (!1 === c.isASN1HEX(t)) throw new Error("not ASN.1 hex string");
                    try {
                        e = h(t, 0, [
                            2,
                            0,
                            1
                        ], "02"), r = h(t, 0, [
                            2,
                            0,
                            2
                        ], "02"), n = h(t, 0, [
                            2,
                            0,
                            3
                        ], "02"), i = h(t, 0, [
                            2,
                            0,
                            4
                        ], "02"), o = h(t, 0, [
                            2,
                            0,
                            5
                        ], "02"), s = h(t, 0, [
                            2,
                            0,
                            6
                        ], "02"), a = h(t, 0, [
                            2,
                            0,
                            7
                        ], "02"), u = h(t, 0, [
                            2,
                            0,
                            8
                        ], "02");
                    } catch (t) {
                        throw new Error("malformed PKCS#8 plain RSA private key");
                    }
                    this.setPrivateEx(e, r, n, i, o, s, a, u);
                }, He.prototype.readPKCS5PubKeyHex = function(t) {
                    var e = Er, r = e.getV;
                    if (!1 === e.isASN1HEX(t)) throw new Error("keyHex is not ASN.1 hex string");
                    var n = e.getChildIdx(t, 0);
                    if (2 !== n.length || "02" !== t.substr(n[0], 2) || "02" !== t.substr(n[1], 2)) throw new Error("wrong hex for PKCS#5 public key");
                    var i = r(t, n[0]), o = r(t, n[1]);
                    this.setPublic(i, o);
                }, He.prototype.readPKCS8PubKeyHex = function(t) {
                    var e = Er;
                    if (!1 === e.isASN1HEX(t)) throw new Error("not ASN.1 hex string");
                    if ("06092a864886f70d010101" !== e.getTLVbyListEx(t, 0, [
                        0,
                        0
                    ])) throw new Error("not PKCS8 RSA public key");
                    var r = e.getTLVbyListEx(t, 0, [
                        1,
                        0
                    ]);
                    this.readPKCS5PubKeyHex(r);
                }, He.prototype.readCertPubKeyHex = function(t, e) {
                    var r, n;
                    (r = new on).readCertHex(t), n = r.getPublicKeyHex(), this.readPKCS8PubKeyHex(n);
                };
                var tn = new RegExp("[^0-9a-f]", "gi");
                function en(t, e) {
                    for(var r = "", n = e / 4 - t.length, i = 0; i < n; i++)r += "0";
                    return r + t;
                }
                function rn(t, e, r) {
                    for(var n = "", i = 0; n.length < e;)n += Nr(r(Ur(t + String.fromCharCode.apply(String, [
                        (4278190080 & i) >> 24,
                        (16711680 & i) >> 16,
                        (65280 & i) >> 8,
                        255 & i
                    ])))), i += 1;
                    return n;
                }
                function nn(t) {
                    for(var e in br.crypto.Util.DIGESTINFOHEAD){
                        var r = br.crypto.Util.DIGESTINFOHEAD[e], n = r.length;
                        if (t.substring(0, n) == r) return [
                            e,
                            t.substring(n)
                        ];
                    }
                    return [];
                }
                function on(t) {
                    var e, r = Er, n = r.getChildIdx, i = r.getV, o = r.getTLV, s = r.getVbyList, a = r.getVbyListEx, u = r.getTLVbyList, c = r.getTLVbyListEx, h = r.getIdxbyList, l = r.getIdxbyListEx, f = r.getVidx, g = r.oidname, d = r.hextooidstr, p = on, v = Hr;
                    try {
                        e = br.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
                    } catch (t) {}
                    this.HEX2STAG = {
                        "0c": "utf8",
                        13: "prn",
                        16: "ia5",
                        "1a": "vis",
                        "1e": "bmp"
                    }, this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function() {
                        return null === this.hex || 0 !== this.version ? this.version : "a003020102" !== u(this.hex, 0, [
                            0,
                            0
                        ]) ? (this.version = 1, this.foffset = -1, 1) : (this.version = 3, 3);
                    }, this.getSerialNumberHex = function() {
                        return a(this.hex, 0, [
                            0,
                            0
                        ], "02");
                    }, this.getSignatureAlgorithmField = function() {
                        var t = c(this.hex, 0, [
                            0,
                            1
                        ]);
                        return this.getAlgorithmIdentifierName(t);
                    }, this.getAlgorithmIdentifierName = function(t) {
                        for(var r in e)if (t === e[r]) return r;
                        return g(a(t, 0, [
                            0
                        ], "06"));
                    }, this.getIssuer = function() {
                        return this.getX500Name(this.getIssuerHex());
                    }, this.getIssuerHex = function() {
                        return u(this.hex, 0, [
                            0,
                            3 + this.foffset
                        ], "30");
                    }, this.getIssuerString = function() {
                        return p.hex2dn(this.getIssuerHex());
                    }, this.getSubject = function() {
                        return this.getX500Name(this.getSubjectHex());
                    }, this.getSubjectHex = function() {
                        return u(this.hex, 0, [
                            0,
                            5 + this.foffset
                        ], "30");
                    }, this.getSubjectString = function() {
                        return p.hex2dn(this.getSubjectHex());
                    }, this.getNotBefore = function() {
                        var t = s(this.hex, 0, [
                            0,
                            4 + this.foffset,
                            0
                        ]);
                        return t = t.replace(/(..)/g, "%$1"), t = decodeURIComponent(t);
                    }, this.getNotAfter = function() {
                        var t = s(this.hex, 0, [
                            0,
                            4 + this.foffset,
                            1
                        ]);
                        return t = t.replace(/(..)/g, "%$1"), t = decodeURIComponent(t);
                    }, this.getPublicKeyHex = function() {
                        return r.getTLVbyList(this.hex, 0, [
                            0,
                            6 + this.foffset
                        ], "30");
                    }, this.getPublicKeyIdx = function() {
                        return h(this.hex, 0, [
                            0,
                            6 + this.foffset
                        ], "30");
                    }, this.getPublicKeyContentIdx = function() {
                        var t = this.getPublicKeyIdx();
                        return h(this.hex, t, [
                            1,
                            0
                        ], "30");
                    }, this.getPublicKey = function() {
                        return Zr.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
                    }, this.getSignatureAlgorithmName = function() {
                        var t = u(this.hex, 0, [
                            1
                        ], "30");
                        return this.getAlgorithmIdentifierName(t);
                    }, this.getSignatureValueHex = function() {
                        return s(this.hex, 0, [
                            2
                        ], "03", !0);
                    }, this.verifySignature = function(t) {
                        var e = this.getSignatureAlgorithmField(), r = this.getSignatureValueHex(), n = u(this.hex, 0, [
                            0
                        ], "30"), i = new br.crypto.Signature({
                            alg: e
                        });
                        return i.init(t), i.updateHex(n), i.verify(r);
                    }, this.parseExt = function(t) {
                        var e, o, a;
                        if (void 0 === t) {
                            if (a = this.hex, 3 !== this.version) return -1;
                            e = h(a, 0, [
                                0,
                                7,
                                0
                            ], "30"), o = n(a, e);
                        } else {
                            a = Hr(t);
                            var u = h(a, 0, [
                                0,
                                3,
                                0,
                                0
                            ], "06");
                            if ("2a864886f70d01090e" != i(a, u)) return void (this.aExtInfo = new Array);
                            e = h(a, 0, [
                                0,
                                3,
                                0,
                                1,
                                0
                            ], "30"), o = n(a, e), this.hex = a;
                        }
                        this.aExtInfo = new Array;
                        for(var c = 0; c < o.length; c++){
                            var l = {
                                critical: !1
                            }, g = 0;
                            3 === n(a, o[c]).length && (l.critical = !0, g = 1), l.oid = r.hextooidstr(s(a, o[c], [
                                0
                            ], "06"));
                            var d = h(a, o[c], [
                                1 + g
                            ]);
                            l.vidx = f(a, d), this.aExtInfo.push(l);
                        }
                    }, this.getExtInfo = function(t) {
                        var e = this.aExtInfo, r = t;
                        if (t.match(/^[0-9.]+$/) || (r = br.asn1.x509.OID.name2oid(t)), "" !== r) {
                            for(var n = 0; n < e.length; n++)if (e[n].oid === r) return e[n];
                        }
                    }, this.getExtBasicConstraints = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("basicConstraints");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var n = {
                            extname: "basicConstraints"
                        };
                        if (e && (n.critical = !0), "3000" === t) return n;
                        if ("30030101ff" === t) return n.cA = !0, n;
                        if ("30060101ff02" === t.substr(0, 12)) {
                            var s = i(t, 10), a = parseInt(s, 16);
                            return n.cA = !0, n.pathLen = a, n;
                        }
                        throw new Error("hExtV parse error: " + t);
                    }, this.getExtKeyUsage = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("keyUsage");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var n = {
                            extname: "keyUsage"
                        };
                        return e && (n.critical = !0), n.names = this.getExtKeyUsageString(t).split(","), n;
                    }, this.getExtKeyUsageBin = function(t) {
                        if (void 0 === t) {
                            var e = this.getExtInfo("keyUsage");
                            if (void 0 === e) return "";
                            t = o(this.hex, e.vidx);
                        }
                        if (8 != t.length && 10 != t.length) throw new Error("malformed key usage value: " + t);
                        var r = "000000000000000" + parseInt(t.substr(6), 16).toString(2);
                        return 8 == t.length && (r = r.slice(-8)), 10 == t.length && (r = r.slice(-16)), "" == (r = r.replace(/0+$/, "")) && (r = "0"), r;
                    }, this.getExtKeyUsageString = function(t) {
                        for(var e = this.getExtKeyUsageBin(t), r = new Array, n = 0; n < e.length; n++)"1" == e.substr(n, 1) && r.push(on.KEYUSAGE_NAME[n]);
                        return r.join(",");
                    }, this.getExtSubjectKeyIdentifier = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("subjectKeyIdentifier");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var n = {
                            extname: "subjectKeyIdentifier"
                        };
                        e && (n.critical = !0);
                        var s = i(t, 0);
                        return n.kid = {
                            hex: s
                        }, n;
                    }, this.getExtAuthorityKeyIdentifier = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("authorityKeyIdentifier");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var s = {
                            extname: "authorityKeyIdentifier"
                        };
                        e && (s.critical = !0);
                        for(var a = n(t, 0), u = 0; u < a.length; u++){
                            var c = t.substr(a[u], 2);
                            if ("80" === c && (s.kid = {
                                hex: i(t, a[u])
                            }), "a1" === c) {
                                var h = o(t, a[u]), l = this.getGeneralNames(h);
                                s.issuer = l[0].dn;
                            }
                            "82" === c && (s.sn = {
                                hex: i(t, a[u])
                            });
                        }
                        return s;
                    }, this.getExtExtKeyUsage = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("extKeyUsage");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var s = {
                            extname: "extKeyUsage",
                            array: []
                        };
                        e && (s.critical = !0);
                        for(var a = n(t, 0), u = 0; u < a.length; u++)s.array.push(g(i(t, a[u])));
                        return s;
                    }, this.getExtExtKeyUsageName = function() {
                        var t = this.getExtInfo("extKeyUsage");
                        if (void 0 === t) return t;
                        var e = new Array, r = o(this.hex, t.vidx);
                        if ("" === r) return e;
                        for(var s = n(r, 0), a = 0; a < s.length; a++)e.push(g(i(r, s[a])));
                        return e;
                    }, this.getExtSubjectAltName = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("subjectAltName");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var n = {
                            extname: "subjectAltName",
                            array: []
                        };
                        return e && (n.critical = !0), n.array = this.getGeneralNames(t), n;
                    }, this.getExtIssuerAltName = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("issuerAltName");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var n = {
                            extname: "issuerAltName",
                            array: []
                        };
                        return e && (n.critical = !0), n.array = this.getGeneralNames(t), n;
                    }, this.getGeneralNames = function(t) {
                        for(var e = n(t, 0), r = [], i = 0; i < e.length; i++){
                            var s = this.getGeneralName(o(t, e[i]));
                            void 0 !== s && r.push(s);
                        }
                        return r;
                    }, this.getGeneralName = function(t) {
                        var e = t.substr(0, 2), r = i(t, 0), n = Nr(r);
                        return "81" == e ? {
                            rfc822: n
                        } : "82" == e ? {
                            dns: n
                        } : "86" == e ? {
                            uri: n
                        } : "87" == e ? {
                            ip: Yr(r)
                        } : "a4" == e ? {
                            dn: this.getX500Name(r)
                        } : void 0;
                    }, this.getExtSubjectAltName2 = function() {
                        var t, e, r, s = this.getExtInfo("subjectAltName");
                        if (void 0 === s) return s;
                        for(var a = new Array, u = o(this.hex, s.vidx), c = n(u, 0), h = 0; h < c.length; h++)r = u.substr(c[h], 2), t = i(u, c[h]), "81" === r && (e = Lr(t), a.push([
                            "MAIL",
                            e
                        ])), "82" === r && (e = Lr(t), a.push([
                            "DNS",
                            e
                        ])), "84" === r && (e = on.hex2dn(t, 0), a.push([
                            "DN",
                            e
                        ])), "86" === r && (e = Lr(t), a.push([
                            "URI",
                            e
                        ])), "87" === r && (e = Yr(t), a.push([
                            "IP",
                            e
                        ]));
                        return a;
                    }, this.getExtCRLDistributionPoints = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("cRLDistributionPoints");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var i = {
                            extname: "cRLDistributionPoints",
                            array: []
                        };
                        e && (i.critical = !0);
                        for(var s = n(t, 0), a = 0; a < s.length; a++){
                            var u = o(t, s[a]);
                            i.array.push(this.getDistributionPoint(u));
                        }
                        return i;
                    }, this.getDistributionPoint = function(t) {
                        for(var e = {}, r = n(t, 0), i = 0; i < r.length; i++){
                            var s = t.substr(r[i], 2), a = o(t, r[i]);
                            "a0" == s && (e.dpname = this.getDistributionPointName(a));
                        }
                        return e;
                    }, this.getDistributionPointName = function(t) {
                        for(var e = {}, r = n(t, 0), i = 0; i < r.length; i++){
                            var s = t.substr(r[i], 2), a = o(t, r[i]);
                            "a0" == s && (e.full = this.getGeneralNames(a));
                        }
                        return e;
                    }, this.getExtCRLDistributionPointsURI = function() {
                        var t = this.getExtInfo("cRLDistributionPoints");
                        if (void 0 === t) return t;
                        for(var e = new Array, r = n(this.hex, t.vidx), i = 0; i < r.length; i++)try {
                            var o = Lr(s(this.hex, r[i], [
                                0,
                                0,
                                0
                            ], "86"));
                            e.push(o);
                        } catch (t) {}
                        return e;
                    }, this.getExtAIAInfo = function() {
                        var t = this.getExtInfo("authorityInfoAccess");
                        if (void 0 === t) return t;
                        for(var e = {
                            ocsp: [],
                            caissuer: []
                        }, r = n(this.hex, t.vidx), i = 0; i < r.length; i++){
                            var o = s(this.hex, r[i], [
                                0
                            ], "06"), a = s(this.hex, r[i], [
                                1
                            ], "86");
                            "2b06010505073001" === o && e.ocsp.push(Lr(a)), "2b06010505073002" === o && e.caissuer.push(Lr(a));
                        }
                        return e;
                    }, this.getExtAuthorityInfoAccess = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("authorityInfoAccess");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var i = {
                            extname: "authorityInfoAccess",
                            array: []
                        };
                        e && (i.critical = !0);
                        for(var u = n(t, 0), c = 0; c < u.length; c++){
                            var h = a(t, u[c], [
                                0
                            ], "06"), l = Lr(s(t, u[c], [
                                1
                            ], "86"));
                            if ("2b06010505073001" == h) i.array.push({
                                ocsp: l
                            });
                            else {
                                if ("2b06010505073002" != h) throw new Error("unknown method: " + h);
                                i.array.push({
                                    caissuer: l
                                });
                            }
                        }
                        return i;
                    }, this.getExtCertificatePolicies = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("certificatePolicies");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var i = {
                            extname: "certificatePolicies",
                            array: []
                        };
                        e && (i.critical = !0);
                        for(var s = n(t, 0), a = 0; a < s.length; a++){
                            var u = o(t, s[a]), c = this.getPolicyInformation(u);
                            i.array.push(c);
                        }
                        return i;
                    }, this.getPolicyInformation = function(t) {
                        var e = {}, r = s(t, 0, [
                            0
                        ], "06");
                        e.policyoid = g(r);
                        var i = l(t, 0, [
                            1
                        ], "30");
                        if (-1 != i) {
                            e.array = [];
                            for(var a = n(t, i), u = 0; u < a.length; u++){
                                var c = o(t, a[u]), h = this.getPolicyQualifierInfo(c);
                                e.array.push(h);
                            }
                        }
                        return e;
                    }, this.getPolicyQualifierInfo = function(t) {
                        var e = {}, r = s(t, 0, [
                            0
                        ], "06");
                        if ("2b06010505070201" === r) {
                            var n = a(t, 0, [
                                1
                            ], "16");
                            e.cps = Nr(n);
                        } else if ("2b06010505070202" === r) {
                            var i = u(t, 0, [
                                1
                            ], "30");
                            e.unotice = this.getUserNotice(i);
                        }
                        return e;
                    }, this.getUserNotice = function(t) {
                        for(var e = {}, r = n(t, 0), i = 0; i < r.length; i++){
                            var s = o(t, r[i]);
                            "30" != s.substr(0, 2) && (e.exptext = this.getDisplayText(s));
                        }
                        return e;
                    }, this.getDisplayText = function(t) {
                        var e = {};
                        return e.type = ({
                            "0c": "utf8",
                            16: "ia5",
                            "1a": "vis",
                            "1e": "bmp"
                        })[t.substr(0, 2)], e.str = Nr(i(t, 0)), e;
                    }, this.getExtCRLNumber = function(t, e) {
                        var r = {
                            extname: "cRLNumber"
                        };
                        if (e && (r.critical = !0), "02" == t.substr(0, 2)) return r.num = {
                            hex: i(t, 0)
                        }, r;
                        throw new Error("hExtV parse error: " + t);
                    }, this.getExtCRLReason = function(t, e) {
                        var r = {
                            extname: "cRLReason"
                        };
                        if (e && (r.critical = !0), "0a" == t.substr(0, 2)) return r.code = parseInt(i(t, 0), 16), r;
                        throw new Error("hExtV parse error: " + t);
                    }, this.getExtOcspNonce = function(t, e) {
                        var r = {
                            extname: "ocspNonce"
                        };
                        e && (r.critical = !0);
                        var n = i(t, 0);
                        return r.hex = n, r;
                    }, this.getExtOcspNoCheck = function(t, e) {
                        var r = {
                            extname: "ocspNoCheck"
                        };
                        return e && (r.critical = !0), r;
                    }, this.getExtAdobeTimeStamp = function(t, e) {
                        if (void 0 === t && void 0 === e) {
                            var r = this.getExtInfo("adobeTimeStamp");
                            if (void 0 === r) return;
                            t = o(this.hex, r.vidx), e = r.critical;
                        }
                        var i = {
                            extname: "adobeTimeStamp"
                        };
                        e && (i.critical = !0);
                        var s = n(t, 0);
                        if (s.length > 1) {
                            var a = o(t, s[1]), u = this.getGeneralName(a);
                            null != u.uri && (i.uri = u.uri);
                        }
                        if (s.length > 2) {
                            var c = o(t, s[2]);
                            "0101ff" == c && (i.reqauth = !0), "010100" == c && (i.reqauth = !1);
                        }
                        return i;
                    }, this.getX500NameRule = function(t) {
                        for(var e = null, r = [], n = 0; n < t.length; n++)for(var i = t[n], o = 0; o < i.length; o++)r.push(i[o]);
                        for(n = 0; n < r.length; n++){
                            var s = r[n], a = s.ds, u = s.value, c = s.type;
                            if (a, "prn" != a && "utf8" != a && "ia5" != a) return "mixed";
                            if ("ia5" == a) {
                                if ("CN" != c) return "mixed";
                                if (br.lang.String.isMail(u)) continue;
                                return "mixed";
                            }
                            if ("C" == c) {
                                if ("prn" == a) continue;
                                return "mixed";
                            }
                            if (a, null == e) e = a;
                            else if (e !== a) return "mixed";
                        }
                        return null == e ? "prn" : e;
                    }, this.getX500Name = function(t) {
                        var e = this.getX500NameArray(t);
                        return {
                            array: e,
                            str: this.dnarraytostr(e)
                        };
                    }, this.getX500NameArray = function(t) {
                        for(var e = [], r = n(t, 0), i = 0; i < r.length; i++)e.push(this.getRDN(o(t, r[i])));
                        return e;
                    }, this.getRDN = function(t) {
                        for(var e = [], r = n(t, 0), i = 0; i < r.length; i++)e.push(this.getAttrTypeAndValue(o(t, r[i])));
                        return e;
                    }, this.getAttrTypeAndValue = function(t) {
                        var e = {
                            type: null,
                            value: null,
                            ds: null
                        }, r = n(t, 0), i = s(t, r[0], [], "06"), o = s(t, r[1], []), a = br.asn1.ASN1Util.oidHexToInt(i);
                        return e.type = br.asn1.x509.OID.oid2atype(a), e.value = Nr(o), e.ds = this.HEX2STAG[t.substr(r[1], 2)], e;
                    }, this.readCertPEM = function(t) {
                        this.readCertHex(v(t));
                    }, this.readCertHex = function(t) {
                        this.hex = t, this.getVersion();
                        try {
                            h(this.hex, 0, [
                                0,
                                7
                            ], "a3"), this.parseExt();
                        } catch (t) {}
                    }, this.getParam = function() {
                        var t = {};
                        return t.version = this.getVersion(), t.serial = {
                            hex: this.getSerialNumberHex()
                        }, t.sigalg = this.getSignatureAlgorithmField(), t.issuer = this.getIssuer(), t.notbefore = this.getNotBefore(), t.notafter = this.getNotAfter(), t.subject = this.getSubject(), t.sbjpubkey = Mr(this.getPublicKeyHex(), "PUBLIC KEY"), this.aExtInfo.length > 0 && (t.ext = this.getExtParamArray()), t.sighex = this.getSignatureValueHex(), t;
                    }, this.getExtParamArray = function(t) {
                        null == t && -1 != l(this.hex, 0, [
                            0,
                            "[3]"
                        ]) && (t = c(this.hex, 0, [
                            0,
                            "[3]",
                            0
                        ], "30"));
                        for(var e = [], r = n(t, 0), i = 0; i < r.length; i++){
                            var s = o(t, r[i]), a = this.getExtParam(s);
                            null != a && e.push(a);
                        }
                        return e;
                    }, this.getExtParam = function(t) {
                        var e = n(t, 0).length;
                        if (2 != e && 3 != e) throw new Error("wrong number elements in Extension: " + e + " " + t);
                        var r = d(s(t, 0, [
                            0
                        ], "06")), i = !1;
                        3 == e && "0101ff" == u(t, 0, [
                            1
                        ]) && (i = !0);
                        var o = u(t, 0, [
                            e - 1,
                            0
                        ]), a = void 0;
                        if ("2.5.29.14" == r ? a = this.getExtSubjectKeyIdentifier(o, i) : "2.5.29.15" == r ? a = this.getExtKeyUsage(o, i) : "2.5.29.17" == r ? a = this.getExtSubjectAltName(o, i) : "2.5.29.18" == r ? a = this.getExtIssuerAltName(o, i) : "2.5.29.19" == r ? a = this.getExtBasicConstraints(o, i) : "2.5.29.31" == r ? a = this.getExtCRLDistributionPoints(o, i) : "2.5.29.32" == r ? a = this.getExtCertificatePolicies(o, i) : "2.5.29.35" == r ? a = this.getExtAuthorityKeyIdentifier(o, i) : "2.5.29.37" == r ? a = this.getExtExtKeyUsage(o, i) : "1.3.6.1.5.5.7.1.1" == r ? a = this.getExtAuthorityInfoAccess(o, i) : "2.5.29.20" == r ? a = this.getExtCRLNumber(o, i) : "2.5.29.21" == r ? a = this.getExtCRLReason(o, i) : "1.3.6.1.5.5.7.48.1.2" == r ? a = this.getExtOcspNonce(o, i) : "1.3.6.1.5.5.7.48.1.5" == r ? a = this.getExtOcspNoCheck(o, i) : "1.2.840.113583.1.1.9.1" == r && (a = this.getExtAdobeTimeStamp(o, i)), null != a) return a;
                        var c = {
                            extname: r,
                            extn: o
                        };
                        return i && (c.critical = !0), c;
                    }, this.findExt = function(t, e) {
                        for(var r = 0; r < t.length; r++)if (t[r].extname == e) return t[r];
                        return null;
                    }, this.updateExtCDPFullURI = function(t, e) {
                        var r = this.findExt(t, "cRLDistributionPoints");
                        if (null != r && null != r.array) {
                            for(var n = r.array, i = 0; i < n.length; i++)if (null != n[i].dpname && null != n[i].dpname.full) for(var o = n[i].dpname.full, s = 0; s < o.length; s++){
                                var a = o[i];
                                null != a.uri && (a.uri = e);
                            }
                        }
                    }, this.updateExtAIAOCSP = function(t, e) {
                        var r = this.findExt(t, "authorityInfoAccess");
                        if (null != r && null != r.array) for(var n = r.array, i = 0; i < n.length; i++)null != n[i].ocsp && (n[i].ocsp = e);
                    }, this.updateExtAIACAIssuer = function(t, e) {
                        var r = this.findExt(t, "authorityInfoAccess");
                        if (null != r && null != r.array) for(var n = r.array, i = 0; i < n.length; i++)null != n[i].caissuer && (n[i].caissuer = e);
                    }, this.dnarraytostr = function(t) {
                        return "/" + t.map(function(t) {
                            return function e(t) {
                                return t.map(function(t) {
                                    return function e(t) {
                                        return t.type + "=" + t.value;
                                    }(t);
                                }).join("+");
                            }(t);
                        }).join("/");
                    }, this.getInfo = function() {
                        var t, e, r, n = function t(e) {
                            return JSON.stringify(e.array).replace(/[\[\]\{\}\"]/g, "");
                        }, i = function t(e) {
                            for(var r = "", n = e.array, i = 0; i < n.length; i++){
                                var o = n[i];
                                if (r += "    policy oid: " + o.policyoid + "\n", void 0 !== o.array) for(var s = 0; s < o.array.length; s++){
                                    var a = o.array[s];
                                    void 0 !== a.cps && (r += "    cps: " + a.cps + "\n");
                                }
                            }
                            return r;
                        }, o = function t(e) {
                            for(var r = "", n = e.array, i = 0; i < n.length; i++){
                                var o = n[i];
                                try {
                                    void 0 !== o.dpname.full[0].uri && (r += "    " + o.dpname.full[0].uri + "\n");
                                } catch (t) {}
                                try {
                                    void 0 !== o.dname.full[0].dn.hex && (r += "    " + on.hex2dn(o.dpname.full[0].dn.hex) + "\n");
                                } catch (t) {}
                            }
                            return r;
                        }, s = function t(e) {
                            for(var r = "", n = e.array, i = 0; i < n.length; i++){
                                var o = n[i];
                                void 0 !== o.caissuer && (r += "    caissuer: " + o.caissuer + "\n"), void 0 !== o.ocsp && (r += "    ocsp: " + o.ocsp + "\n");
                            }
                            return r;
                        };
                        if (t = "Basic Fields\n", t += "  serial number: " + this.getSerialNumberHex() + "\n", t += "  signature algorithm: " + this.getSignatureAlgorithmField() + "\n", t += "  issuer: " + this.getIssuerString() + "\n", t += "  notBefore: " + this.getNotBefore() + "\n", t += "  notAfter: " + this.getNotAfter() + "\n", t += "  subject: " + this.getSubjectString() + "\n", t += "  subject public key info: \n", t += "    key algorithm: " + (e = this.getPublicKey()).type + "\n", "RSA" === e.type && (t += "    n=" + $r(e.n.toString(16)).substr(0, 16) + "...\n", t += "    e=" + $r(e.e.toString(16)) + "\n"), null != (r = this.aExtInfo)) {
                            t += "X509v3 Extensions:\n";
                            for(var a = 0; a < r.length; a++){
                                var u = r[a], c = br.asn1.x509.OID.oid2name(u.oid);
                                "" === c && (c = u.oid);
                                var h = "";
                                if (!0 === u.critical && (h = "CRITICAL"), t += "  " + c + " " + h + ":\n", "basicConstraints" === c) {
                                    var l = this.getExtBasicConstraints();
                                    void 0 === l.cA ? t += "    {}\n" : (t += "    cA=true", void 0 !== l.pathLen && (t += ", pathLen=" + l.pathLen), t += "\n");
                                } else if ("keyUsage" === c) t += "    " + this.getExtKeyUsageString() + "\n";
                                else if ("subjectKeyIdentifier" === c) t += "    " + this.getExtSubjectKeyIdentifier().kid.hex + "\n";
                                else if ("authorityKeyIdentifier" === c) {
                                    var f = this.getExtAuthorityKeyIdentifier();
                                    void 0 !== f.kid && (t += "    kid=" + f.kid.hex + "\n");
                                } else {
                                    if ("extKeyUsage" === c) t += "    " + this.getExtExtKeyUsage().array.join(", ") + "\n";
                                    else if ("subjectAltName" === c) t += "    " + n(this.getExtSubjectAltName()) + "\n";
                                    else if ("cRLDistributionPoints" === c) t += o(this.getExtCRLDistributionPoints());
                                    else if ("authorityInfoAccess" === c) t += s(this.getExtAuthorityInfoAccess());
                                    else "certificatePolicies" === c && (t += i(this.getExtCertificatePolicies()));
                                }
                            }
                        }
                        return t += "signature algorithm: " + this.getSignatureAlgorithmName() + "\n", t += "signature: " + this.getSignatureValueHex().substr(0, 16) + "...\n";
                    }, "string" == typeof t && (-1 != t.indexOf("-----BEGIN") ? this.readCertPEM(t) : br.lang.String.isHex(t) && this.readCertHex(t));
                }
                He.prototype.sign = function(t, e) {
                    var r = function t(r) {
                        return br.crypto.Util.hashString(r, e);
                    }(t);
                    return this.signWithMessageHash(r, e);
                }, He.prototype.signWithMessageHash = function(t, e) {
                    var r = je(br.crypto.Util.getPaddedDigestInfoHex(t, e, this.n.bitLength()), 16);
                    return en(this.doPrivate(r).toString(16), this.n.bitLength());
                }, He.prototype.signPSS = function(t, e, r) {
                    var n = function t(r) {
                        return br.crypto.Util.hashHex(r, e);
                    }(Ur(t));
                    return void 0 === r && (r = -1), this.signWithMessageHashPSS(n, e, r);
                }, He.prototype.signWithMessageHashPSS = function(t, e, r) {
                    var n, i = Nr(t), o = i.length, s = this.n.bitLength() - 1, a = Math.ceil(s / 8), u = function t(r) {
                        return br.crypto.Util.hashHex(r, e);
                    };
                    if (-1 === r || void 0 === r) r = o;
                    else if (-2 === r) r = a - o - 2;
                    else if (r < -2) throw new Error("invalid salt length");
                    if (a < o + r + 2) throw new Error("data too long");
                    var c = "";
                    r > 0 && (c = new Array(r), (new Oe).nextBytes(c), c = String.fromCharCode.apply(String, c));
                    var h = Nr(u(Ur("\0\0\0\0\0\0\0\0" + i + c))), l = [];
                    for(n = 0; n < a - r - o - 2; n += 1)l[n] = 0;
                    var f = String.fromCharCode.apply(String, l) + "\x01" + c, g = rn(h, f.length, u), d = [];
                    for(n = 0; n < f.length; n += 1)d[n] = f.charCodeAt(n) ^ g.charCodeAt(n);
                    var p = 65280 >> 8 * a - s & 255;
                    for(d[0] &= ~p, n = 0; n < o; n++)d.push(h.charCodeAt(n));
                    return d.push(188), en(this.doPrivate(new F(d)).toString(16), this.n.bitLength());
                }, He.prototype.verify = function(t, e) {
                    var r = je(e = (e = e.replace(tn, "")).replace(/[ \n]+/g, ""), 16);
                    if (r.bitLength() > this.n.bitLength()) return 0;
                    var n = nn(this.doPublic(r).toString(16).replace(/^1f+00/, ""));
                    if (0 == n.length) return !1;
                    var i = n[0];
                    return n[1] == function t(e) {
                        return br.crypto.Util.hashString(e, i);
                    }(t);
                }, He.prototype.verifyWithMessageHash = function(t, e) {
                    if (e.length != Math.ceil(this.n.bitLength() / 4)) return !1;
                    var r = je(e, 16);
                    if (r.bitLength() > this.n.bitLength()) return 0;
                    var n = nn(this.doPublic(r).toString(16).replace(/^1f+00/, ""));
                    if (0 == n.length) return !1;
                    n[0];
                    return n[1] == t;
                }, He.prototype.verifyPSS = function(t, e, r, n) {
                    var i = function t(e) {
                        return br.crypto.Util.hashHex(e, r);
                    }(Ur(t));
                    return void 0 === n && (n = -1), this.verifyWithMessageHashPSS(i, e, r, n);
                }, He.prototype.verifyWithMessageHashPSS = function(t, e, r, n) {
                    if (e.length != Math.ceil(this.n.bitLength() / 4)) return !1;
                    var i, o = new F(e, 16), s = function t(e) {
                        return br.crypto.Util.hashHex(e, r);
                    }, a = Nr(t), u = a.length, c = this.n.bitLength() - 1, h = Math.ceil(c / 8);
                    if (-1 === n || void 0 === n) n = u;
                    else if (-2 === n) n = h - u - 2;
                    else if (n < -2) throw new Error("invalid salt length");
                    if (h < u + n + 2) throw new Error("data too long");
                    var l = this.doPublic(o).toByteArray();
                    for(i = 0; i < l.length; i += 1)l[i] &= 255;
                    for(; l.length < h;)l.unshift(0);
                    if (188 !== l[h - 1]) throw new Error("encoded message does not end in 0xbc");
                    var f = (l = String.fromCharCode.apply(String, l)).substr(0, h - u - 1), g = l.substr(f.length, u), d = 65280 >> 8 * h - c & 255;
                    if (0 != (f.charCodeAt(0) & d)) throw new Error("bits beyond keysize not zero");
                    var p = rn(g, f.length, s), v = [];
                    for(i = 0; i < f.length; i += 1)v[i] = f.charCodeAt(i) ^ p.charCodeAt(i);
                    v[0] &= ~d;
                    var y = h - u - n - 2;
                    for(i = 0; i < y; i += 1)if (0 !== v[i]) throw new Error("leftmost octets not zero");
                    if (1 !== v[y]) throw new Error("0x01 marker not found");
                    return g === Nr(s(Ur("\0\0\0\0\0\0\0\0" + a + String.fromCharCode.apply(String, v.slice(-n)))));
                }, He.SALT_LEN_HLEN = -1, He.SALT_LEN_MAX = -2, He.SALT_LEN_RECOVER = -2, on.hex2dn = function(t, e) {
                    if (void 0 === e && (e = 0), "30" !== t.substr(e, 2)) throw new Error("malformed DN");
                    for(var r = new Array, n = Er.getChildIdx(t, e), i = 0; i < n.length; i++)r.push(on.hex2rdn(t, n[i]));
                    return "/" + (r = r.map(function(t) {
                        return t.replace("/", "\\/");
                    })).join("/");
                }, on.hex2rdn = function(t, e) {
                    if (void 0 === e && (e = 0), "31" !== t.substr(e, 2)) throw new Error("malformed RDN");
                    for(var r = new Array, n = Er.getChildIdx(t, e), i = 0; i < n.length; i++)r.push(on.hex2attrTypeValue(t, n[i]));
                    return (r = r.map(function(t) {
                        return t.replace("+", "\\+");
                    })).join("+");
                }, on.hex2attrTypeValue = function(t, e) {
                    var r = Er, n = r.getV;
                    if (void 0 === e && (e = 0), "30" !== t.substr(e, 2)) throw new Error("malformed attribute type and value");
                    var i = r.getChildIdx(t, e);
                    2 !== i.length || t.substr(i[0], 2);
                    var o = n(t, i[0]), s = br.asn1.ASN1Util.oidHexToInt(o);
                    return br.asn1.x509.OID.oid2atype(s) + "=" + Nr(n(t, i[1]));
                }, on.getPublicKeyFromCertHex = function(t) {
                    var e = new on;
                    return e.readCertHex(t), e.getPublicKey();
                }, on.getPublicKeyFromCertPEM = function(t) {
                    var e = new on;
                    return e.readCertPEM(t), e.getPublicKey();
                }, on.getPublicKeyInfoPropOfCertPEM = function(t) {
                    var e, r, n = Er.getVbyList, i = {};
                    return i.algparam = null, (e = new on).readCertPEM(t), r = e.getPublicKeyHex(), i.keyhex = n(r, 0, [
                        1
                    ], "03").substr(2), i.algoid = n(r, 0, [
                        0,
                        0
                    ], "06"), "2a8648ce3d0201" === i.algoid && (i.algparam = n(r, 0, [
                        0,
                        1
                    ], "06")), i;
                }, on.KEYUSAGE_NAME = [
                    "digitalSignature",
                    "nonRepudiation",
                    "keyEncipherment",
                    "dataEncipherment",
                    "keyAgreement",
                    "keyCertSign",
                    "cRLSign",
                    "encipherOnly",
                    "decipherOnly"
                ], void 0 !== br && br || (e.KJUR = br = {}), void 0 !== br.jws && br.jws || (br.jws = {}), br.jws.JWS = function() {
                    var t = br.jws.JWS.isSafeJSONString;
                    this.parseJWS = function(e, r) {
                        if (void 0 === this.parsedJWS || !r && void 0 === this.parsedJWS.sigvalH) {
                            var n = e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
                            if (null == n) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
                            var i = n[1], o = n[2], s = n[3], a = i + "." + o;
                            if (this.parsedJWS = {}, this.parsedJWS.headB64U = i, this.parsedJWS.payloadB64U = o, this.parsedJWS.sigvalB64U = s, this.parsedJWS.si = a, !r) {
                                var u = Ir(s), c = je(u, 16);
                                this.parsedJWS.sigvalH = u, this.parsedJWS.sigvalBI = c;
                            }
                            var h = Fr(i), l = Fr(o);
                            if (this.parsedJWS.headS = h, this.parsedJWS.payloadS = l, !t(h, this.parsedJWS, "headP")) throw "malformed JSON string for JWS Head: " + h;
                        }
                    };
                }, br.jws.JWS.sign = function(t, e, n, i, o) {
                    var s, a, u, c = br, h = c.jws.JWS, l = h.readSafeJSONString, f = h.isSafeJSONString, g = c.crypto, d = (g.ECDSA, g.Mac), p = g.Signature, v = JSON;
                    if ("string" != typeof e && "object" != (void 0 === e ? "undefined" : r(e))) throw "spHeader must be JSON string or object: " + e;
                    if ("object" == (void 0 === e ? "undefined" : r(e)) && (a = e, s = v.stringify(a)), "string" == typeof e) {
                        if (!f(s = e)) throw "JWS Head is not safe JSON string: " + s;
                        a = l(s);
                    }
                    if (u = n, "object" == (void 0 === n ? "undefined" : r(n)) && (u = v.stringify(n)), "" != t && null != t || void 0 === a.alg || (t = a.alg), "" != t && null != t && void 0 === a.alg && (a.alg = t, s = v.stringify(a)), t !== a.alg) throw "alg and sHeader.alg doesn't match: " + t + "!=" + a.alg;
                    var y = null;
                    if (void 0 === h.jwsalg2sigalg[t]) throw "unsupported alg name: " + t;
                    y = h.jwsalg2sigalg[t];
                    var m = wr(s) + "." + wr(u), _ = "";
                    if ("Hmac" == y.substr(0, 4)) {
                        if (void 0 === i) throw "mac key shall be specified for HS* alg";
                        var S = new d({
                            alg: y,
                            prov: "cryptojs",
                            pass: i
                        });
                        S.updateString(m), _ = S.doFinal();
                    } else if (-1 != y.indexOf("withECDSA")) {
                        (w = new p({
                            alg: y
                        })).init(i, o), w.updateString(m);
                        var b = w.sign();
                        _ = br.crypto.ECDSA.asn1SigToConcatSig(b);
                    } else {
                        var w;
                        if ("none" != y) (w = new p({
                            alg: y
                        })).init(i, o), w.updateString(m), _ = w.sign();
                    }
                    return m + "." + Rr(_);
                }, br.jws.JWS.verify = function(t, e, n) {
                    var i, o = br, s = o.jws.JWS, a = s.readSafeJSONString, u = o.crypto, c = u.ECDSA, h = u.Mac, l = u.Signature;
                    void 0 !== r(He) && (i = He);
                    var f = t.split(".");
                    if (3 !== f.length) return !1;
                    var g = f[0] + "." + f[1], d = Ir(f[2]), p = a(Fr(f[0])), v = null, y = null;
                    if (void 0 === p.alg) throw "algorithm not specified in header";
                    if ((y = (v = p.alg).substr(0, 2), null != n && "[object Array]" === Object.prototype.toString.call(n) && n.length > 0) && -1 == (":" + n.join(":") + ":").indexOf(":" + v + ":")) throw "algorithm '" + v + "' not accepted in the list";
                    if ("none" != v && null === e) throw "key shall be specified to verify.";
                    if ("string" == typeof e && -1 != e.indexOf("-----BEGIN ") && (e = Zr.getKey(e)), !("RS" != y && "PS" != y || e instanceof i)) throw "key shall be a RSAKey obj for RS* and PS* algs";
                    if ("ES" == y && !(e instanceof c)) throw "key shall be a ECDSA obj for ES* algs";
                    var m = null;
                    if (void 0 === s.jwsalg2sigalg[p.alg]) throw "unsupported alg name: " + v;
                    if ("none" == (m = s.jwsalg2sigalg[v])) throw "not supported";
                    if ("Hmac" == m.substr(0, 4)) {
                        if (void 0 === e) throw "hexadecimal key shall be specified for HMAC";
                        var _ = new h({
                            alg: m,
                            pass: e
                        });
                        return _.updateString(g), d == _.doFinal();
                    }
                    if (-1 != m.indexOf("withECDSA")) {
                        var S, b = null;
                        try {
                            b = c.concatSigToASN1Sig(d);
                        } catch (t) {
                            return !1;
                        }
                        return (S = new l({
                            alg: m
                        })).init(e), S.updateString(g), S.verify(b);
                    }
                    return (S = new l({
                        alg: m
                    })).init(e), S.updateString(g), S.verify(d);
                }, br.jws.JWS.parse = function(t) {
                    var e, r, n, i = t.split("."), o = {};
                    if (2 != i.length && 3 != i.length) throw "malformed sJWS: wrong number of '.' splitted elements";
                    return e = i[0], r = i[1], 3 == i.length && (n = i[2]), o.headerObj = br.jws.JWS.readSafeJSONString(Fr(e)), o.payloadObj = br.jws.JWS.readSafeJSONString(Fr(r)), o.headerPP = JSON.stringify(o.headerObj, null, "  "), null == o.payloadObj ? o.payloadPP = Fr(r) : o.payloadPP = JSON.stringify(o.payloadObj, null, "  "), void 0 !== n && (o.sigHex = Ir(n)), o;
                }, br.jws.JWS.verifyJWT = function(t, e, n) {
                    var i = br.jws, o = i.JWS, s = o.readSafeJSONString, a = o.inArray, u = o.includedArray, c = t.split("."), h = c[0], l = c[1], f = (Ir(c[2]), s(Fr(h))), g = s(Fr(l));
                    if (void 0 === f.alg) return !1;
                    if (void 0 === n.alg) throw "acceptField.alg shall be specified";
                    if (!a(f.alg, n.alg)) return !1;
                    if (void 0 !== g.iss && "object" === r(n.iss) && !a(g.iss, n.iss)) return !1;
                    if (void 0 !== g.sub && "object" === r(n.sub) && !a(g.sub, n.sub)) return !1;
                    if (void 0 !== g.aud && "object" === r(n.aud)) {
                        if ("string" == typeof g.aud) {
                            if (!a(g.aud, n.aud)) return !1;
                        } else if ("object" == r(g.aud) && !u(g.aud, n.aud)) return !1;
                    }
                    var d = i.IntDate.getNow();
                    return void 0 !== n.verifyAt && "number" == typeof n.verifyAt && (d = n.verifyAt), void 0 !== n.gracePeriod && "number" == typeof n.gracePeriod || (n.gracePeriod = 0), !(void 0 !== g.exp && "number" == typeof g.exp && g.exp + n.gracePeriod < d) && !(void 0 !== g.nbf && "number" == typeof g.nbf && d < g.nbf - n.gracePeriod) && !(void 0 !== g.iat && "number" == typeof g.iat && d < g.iat - n.gracePeriod) && (void 0 === g.jti || void 0 === n.jti || g.jti === n.jti) && !!o.verify(t, e, n.alg);
                }, br.jws.JWS.includedArray = function(t, e) {
                    var n = br.jws.JWS.inArray;
                    if (null === t) return !1;
                    if ("object" !== (void 0 === t ? "undefined" : r(t))) return !1;
                    if ("number" != typeof t.length) return !1;
                    for(var i = 0; i < t.length; i++)if (!n(t[i], e)) return !1;
                    return !0;
                }, br.jws.JWS.inArray = function(t, e) {
                    if (null === e) return !1;
                    if ("object" !== (void 0 === e ? "undefined" : r(e))) return !1;
                    if ("number" != typeof e.length) return !1;
                    for(var n = 0; n < e.length; n++)if (e[n] == t) return !0;
                    return !1;
                }, br.jws.JWS.jwsalg2sigalg = {
                    HS256: "HmacSHA256",
                    HS384: "HmacSHA384",
                    HS512: "HmacSHA512",
                    RS256: "SHA256withRSA",
                    RS384: "SHA384withRSA",
                    RS512: "SHA512withRSA",
                    ES256: "SHA256withECDSA",
                    ES384: "SHA384withECDSA",
                    PS256: "SHA256withRSAandMGF1",
                    PS384: "SHA384withRSAandMGF1",
                    PS512: "SHA512withRSAandMGF1",
                    none: "none"
                }, br.jws.JWS.isSafeJSONString = function(t, e, n) {
                    var i = null;
                    try {
                        return "object" != (void 0 === (i = Sr(t)) ? "undefined" : r(i)) || i.constructor === Array ? 0 : (e && (e[n] = i), 1);
                    } catch (t) {
                        return 0;
                    }
                }, br.jws.JWS.readSafeJSONString = function(t) {
                    var e = null;
                    try {
                        return "object" != (void 0 === (e = Sr(t)) ? "undefined" : r(e)) || e.constructor === Array ? null : e;
                    } catch (t) {
                        return null;
                    }
                }, br.jws.JWS.getEncodedSignatureValueFromJWS = function(t) {
                    var e = t.match(/^[^.]+\.[^.]+\.([^.]+)$/);
                    if (null == e) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
                    return e[1];
                }, br.jws.JWS.getJWKthumbprint = function(t) {
                    if ("RSA" !== t.kty && "EC" !== t.kty && "oct" !== t.kty) throw "unsupported algorithm for JWK Thumprint";
                    var e = "{";
                    if ("RSA" === t.kty) {
                        if ("string" != typeof t.n || "string" != typeof t.e) throw "wrong n and e value for RSA key";
                        e += '"e":"' + t.e + '",', e += '"kty":"' + t.kty + '",', e += '"n":"' + t.n + '"}';
                    } else if ("EC" === t.kty) {
                        if ("string" != typeof t.crv || "string" != typeof t.x || "string" != typeof t.y) throw "wrong crv, x and y value for EC key";
                        e += '"crv":"' + t.crv + '",', e += '"kty":"' + t.kty + '",', e += '"x":"' + t.x + '",', e += '"y":"' + t.y + '"}';
                    } else if ("oct" === t.kty) {
                        if ("string" != typeof t.k) throw "wrong k value for oct(symmetric) key";
                        e += '"kty":"' + t.kty + '",', e += '"k":"' + t.k + '"}';
                    }
                    var r = Ur(e);
                    return Rr(br.crypto.Util.hashHex(r, "sha256"));
                }, br.jws.IntDate = {}, br.jws.IntDate.get = function(t) {
                    var e = br.jws.IntDate, r = e.getNow, n = e.getZulu;
                    if ("now" == t) return r();
                    if ("now + 1hour" == t) return r() + 3600;
                    if ("now + 1day" == t) return r() + 86400;
                    if ("now + 1month" == t) return r() + 2592e3;
                    if ("now + 1year" == t) return r() + 31536e3;
                    if (t.match(/Z$/)) return n(t);
                    if (t.match(/^[0-9]+$/)) return parseInt(t);
                    throw "unsupported format: " + t;
                }, br.jws.IntDate.getZulu = function(t) {
                    return Kr(t);
                }, br.jws.IntDate.getNow = function() {
                    return ~~(new Date / 1e3);
                }, br.jws.IntDate.intDate2UTCString = function(t) {
                    return new Date(1e3 * t).toUTCString();
                }, br.jws.IntDate.intDate2Zulu = function(t) {
                    var e = new Date(1e3 * t);
                    return ("0000" + e.getUTCFullYear()).slice(-4) + ("00" + (e.getUTCMonth() + 1)).slice(-2) + ("00" + e.getUTCDate()).slice(-2) + ("00" + e.getUTCHours()).slice(-2) + ("00" + e.getUTCMinutes()).slice(-2) + ("00" + e.getUTCSeconds()).slice(-2) + "Z";
                }, e.SecureRandom = Oe, e.rng_seed_time = Ie, e.BigInteger = F, e.RSAKey = He;
                var sn = br.crypto.EDSA;
                e.EDSA = sn;
                var an = br.crypto.DSA;
                e.DSA = an;
                var un = br.crypto.Signature;
                e.Signature = un;
                var cn = br.crypto.MessageDigest;
                e.MessageDigest = cn;
                var hn = br.crypto.Mac;
                e.Mac = hn;
                var ln = br.crypto.Cipher;
                e.Cipher = ln, e.KEYUTIL = Zr, e.ASN1HEX = Er, e.X509 = on, e.CryptoJS = y, e.b64tohex = b, e.b64toBA = w, e.stoBA = xr, e.BAtos = Ar, e.BAtohex = kr, e.stohex = Pr, e.stob64 = function fn(t) {
                    return S(Pr(t));
                }, e.stob64u = function gn(t) {
                    return Cr(S(Pr(t)));
                }, e.b64utos = function dn(t) {
                    return Ar(w(Tr(t)));
                }, e.b64tob64u = Cr, e.b64utob64 = Tr, e.hex2b64 = S, e.hextob64u = Rr, e.b64utohex = Ir, e.utf8tob64u = wr, e.b64utoutf8 = Fr, e.utf8tob64 = function pn(t) {
                    return S(qr(Gr(t)));
                }, e.b64toutf8 = function vn(t) {
                    return decodeURIComponent(Jr(b(t)));
                }, e.utf8tohex = Dr, e.hextoutf8 = Lr, e.hextorstr = Nr, e.rstrtohex = Ur, e.hextob64 = Br, e.hextob64nl = Or, e.b64nltohex = jr, e.hextopem = Mr, e.pemtohex = Hr, e.hextoArrayBuffer = function yn(t) {
                    if (t.length % 2 != 0) throw "input is not even length";
                    if (null == t.match(/^[0-9A-Fa-f]+$/)) throw "input is not hexadecimal";
                    for(var e = new ArrayBuffer(t.length / 2), r = new DataView(e), n = 0; n < t.length / 2; n++)r.setUint8(n, parseInt(t.substr(2 * n, 2), 16));
                    return e;
                }, e.ArrayBuffertohex = function mn(t) {
                    for(var e = "", r = new DataView(t), n = 0; n < t.byteLength; n++)e += ("00" + r.getUint8(n).toString(16)).slice(-2);
                    return e;
                }, e.zulutomsec = Vr, e.zulutosec = Kr, e.zulutodate = function _n(t) {
                    return new Date(Vr(t));
                }, e.datetozulu = function Sn(t, e, r) {
                    var n, i = t.getUTCFullYear();
                    if (e) {
                        if (i < 1950 || 2049 < i) throw "not proper year for UTCTime: " + i;
                        n = ("" + i).slice(-2);
                    } else n = ("000" + i).slice(-4);
                    if (n += ("0" + (t.getUTCMonth() + 1)).slice(-2), n += ("0" + t.getUTCDate()).slice(-2), n += ("0" + t.getUTCHours()).slice(-2), n += ("0" + t.getUTCMinutes()).slice(-2), n += ("0" + t.getUTCSeconds()).slice(-2), r) {
                        var o = t.getUTCMilliseconds();
                        0 !== o && (n += "." + (o = (o = ("00" + o).slice(-3)).replace(/0+$/g, "")));
                    }
                    return n += "Z";
                }, e.uricmptohex = qr, e.hextouricmp = Jr, e.ipv6tohex = Wr, e.hextoipv6 = zr, e.hextoip = Yr, e.iptohex = function bn(t) {
                    var e = "malformed IP address";
                    if (!(t = t.toLowerCase(t)).match(/^[0-9.]+$/)) {
                        if (t.match(/^[0-9a-f:]+$/) && -1 !== t.indexOf(":")) return Wr(t);
                        throw e;
                    }
                    var r = t.split(".");
                    if (4 !== r.length) throw e;
                    var n = "";
                    try {
                        for(var i = 0; i < 4; i++)n += ("0" + parseInt(r[i]).toString(16)).slice(-2);
                        return n;
                    } catch (t) {
                        throw e;
                    }
                }, e.encodeURIComponentAll = Gr, e.newline_toUnix = function wn(t) {
                    return t = t.replace(/\r\n/gm, "\n");
                }, e.newline_toDos = function Fn(t) {
                    return t = (t = t.replace(/\r\n/gm, "\n")).replace(/\n/gm, "\r\n");
                }, e.hextoposhex = $r, e.intarystrtohex = function En(t) {
                    t = (t = (t = t.replace(/^\s*\[\s*/, "")).replace(/\s*\]\s*$/, "")).replace(/\s*/g, "");
                    try {
                        return t.split(/,/).map(function(t, e, r) {
                            var n = parseInt(t);
                            if (n < 0 || 255 < n) throw "integer not in range 0-255";
                            return ("00" + n.toString(16)).slice(-2);
                        }).join("");
                    } catch (t) {
                        throw "malformed integer array string: " + t;
                    }
                }, e.strdiffidx = function t(e, r) {
                    var n = e.length;
                    e.length > r.length && (n = r.length);
                    for(var i = 0; i < n; i++)if (e.charCodeAt(i) != r.charCodeAt(i)) return i;
                    return e.length != r.length ? n : -1;
                }, e.KJUR = br;
                var xn = br.crypto;
                e.crypto = xn;
                var An = br.asn1;
                e.asn1 = An;
                var kn = br.jws;
                e.jws = kn;
                var Pn = br.lang;
                e.lang = Pn;
            }).call(this, r(28).Buffer);
        },
        function(t, e, r) {
            "use strict";
            (function(t) {
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ var n = r(30), i = r(31), o = r(32);
                function s() {
                    return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
                }
                function a(t, e) {
                    if (s() < e) throw new RangeError("Invalid typed array length");
                    return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
                }
                function u(t, e, r) {
                    if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);
                    if ("number" == typeof t) {
                        if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
                        return l(this, t);
                    }
                    return c(this, t, e, r);
                }
                function c(t, e, r, n) {
                    if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
                    return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function i(t, e, r, n) {
                        if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
                        if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                        e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
                        u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = f(t, e);
                        return t;
                    }(t, e, r, n) : "string" == typeof e ? function s(t, e, r) {
                        "string" == typeof r && "" !== r || (r = "utf8");
                        if (!u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                        var n = 0 | d(e, r), i = (t = a(t, n)).write(e, r);
                        i !== n && (t = t.slice(0, i));
                        return t;
                    }(t, e, r) : function c(t, e) {
                        if (u.isBuffer(e)) {
                            var r = 0 | g(e.length);
                            return 0 === (t = a(t, r)).length || e.copy(t, 0, 0, r), t;
                        }
                        if (e) {
                            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || function n(t) {
                                return t != t;
                            }(e.length) ? a(t, 0) : f(t, e);
                            if ("Buffer" === e.type && o(e.data)) return f(t, e.data);
                        }
                        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
                    }(t, e);
                }
                function h(t) {
                    if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
                    if (t < 0) throw new RangeError('"size" argument must not be negative');
                }
                function l(t, e) {
                    if (h(e), t = a(t, e < 0 ? 0 : 0 | g(e)), !u.TYPED_ARRAY_SUPPORT) for(var r = 0; r < e; ++r)t[r] = 0;
                    return t;
                }
                function f(t, e) {
                    var r = e.length < 0 ? 0 : 0 | g(e.length);
                    t = a(t, r);
                    for(var n = 0; n < r; n += 1)t[n] = 255 & e[n];
                    return t;
                }
                function g(t) {
                    if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
                    return 0 | t;
                }
                function d(t, e) {
                    if (u.isBuffer(t)) return t.length;
                    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
                    "string" != typeof t && (t = "" + t);
                    var r = t.length;
                    if (0 === r) return 0;
                    for(var n = !1;;)switch(e){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return r;
                        case "utf8":
                        case "utf-8":
                        case void 0:
                            return K(t).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return 2 * r;
                        case "hex":
                            return r >>> 1;
                        case "base64":
                            return q(t).length;
                        default:
                            if (n) return K(t).length;
                            e = ("" + e).toLowerCase(), n = !0;
                    }
                }
                function p(t, e, r) {
                    var n = !1;
                    if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                    if ((r >>>= 0) <= (e >>>= 0)) return "";
                    for(t || (t = "utf8");;)switch(t){
                        case "hex":
                            return I(this, e, r);
                        case "utf8":
                        case "utf-8":
                            return A(this, e, r);
                        case "ascii":
                            return T(this, e, r);
                        case "latin1":
                        case "binary":
                            return R(this, e, r);
                        case "base64":
                            return x(this, e, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return D(this, e, r);
                        default:
                            if (n) throw new TypeError("Unknown encoding: " + t);
                            t = (t + "").toLowerCase(), n = !0;
                    }
                }
                function v(t, e, r) {
                    var n = t[e];
                    t[e] = t[r], t[r] = n;
                }
                function y(t, e, r, n, i) {
                    if (0 === t.length) return -1;
                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                        if (i) return -1;
                        r = t.length - 1;
                    } else if (r < 0) {
                        if (!i) return -1;
                        r = 0;
                    }
                    if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : m(t, e, r, n, i);
                    if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : m(t, [
                        e
                    ], r, n, i);
                    throw new TypeError("val must be string, number or Buffer");
                }
                function m(t, e, r, n, i) {
                    var o, s = 1, a = t.length, u = e.length;
                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                        if (t.length < 2 || e.length < 2) return -1;
                        s = 2, a /= 2, u /= 2, r /= 2;
                    }
                    function c(t, e) {
                        return 1 === s ? t[e] : t.readUInt16BE(e * s);
                    }
                    if (i) {
                        var h = -1;
                        for(o = r; o < a; o++)if (c(t, o) === c(e, -1 === h ? 0 : o - h)) {
                            if (-1 === h && (h = o), o - h + 1 === u) return h * s;
                        } else -1 !== h && (o -= o - h), h = -1;
                    } else for(r + u > a && (r = a - u), o = r; o >= 0; o--){
                        for(var l = !0, f = 0; f < u; f++)if (c(t, o + f) !== c(e, f)) {
                            l = !1;
                            break;
                        }
                        if (l) return o;
                    }
                    return -1;
                }
                function _(t, e, r, n) {
                    r = Number(r) || 0;
                    var i = t.length - r;
                    n ? (n = Number(n)) > i && (n = i) : n = i;
                    var o = e.length;
                    if (o % 2 != 0) throw new TypeError("Invalid hex string");
                    n > o / 2 && (n = o / 2);
                    for(var s = 0; s < n; ++s){
                        var a = parseInt(e.substr(2 * s, 2), 16);
                        if (isNaN(a)) return s;
                        t[r + s] = a;
                    }
                    return s;
                }
                function S(t, e, r, n) {
                    return J(K(e, t.length - r), t, r, n);
                }
                function b(t, e, r, n) {
                    return J(function i(t) {
                        for(var e = [], r = 0; r < t.length; ++r)e.push(255 & t.charCodeAt(r));
                        return e;
                    }(e), t, r, n);
                }
                function w(t, e, r, n) {
                    return b(t, e, r, n);
                }
                function F(t, e, r, n) {
                    return J(q(e), t, r, n);
                }
                function E(t, e, r, n) {
                    return J(function i(t, e) {
                        for(var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s)n = (r = t.charCodeAt(s)) >> 8, i = r % 256, o.push(i), o.push(n);
                        return o;
                    }(e, t.length - r), t, r, n);
                }
                function x(t, e, r) {
                    return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
                }
                function A(t, e, r) {
                    r = Math.min(t.length, r);
                    for(var n = [], i = e; i < r;){
                        var o, s, a, u, c = t[i], h = null, l = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                        if (i + l <= r) switch(l){
                            case 1:
                                c < 128 && (h = c);
                                break;
                            case 2:
                                128 == (192 & (o = t[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (h = u);
                                break;
                            case 3:
                                o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (h = u);
                                break;
                            case 4:
                                o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (h = u);
                        }
                        null === h ? (h = 65533, l = 1) : h > 65535 && (h -= 65536, n.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), n.push(h), i += l;
                    }
                    return function f(t) {
                        var e = t.length;
                        if (e <= C) return String.fromCharCode.apply(String, t);
                        var r = "", n = 0;
                        for(; n < e;)r += String.fromCharCode.apply(String, t.slice(n, n += C));
                        return r;
                    }(n);
                }
                e.Buffer = u, e.SlowBuffer = function k(t) {
                    +t != t && (t = 0);
                    return u.alloc(+t);
                }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function P() {
                    try {
                        var t = new Uint8Array(1);
                        return t.__proto__ = {
                            __proto__: Uint8Array.prototype,
                            foo: function() {
                                return 42;
                            }
                        }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
                    } catch (t) {
                        return !1;
                    }
                }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function(t) {
                    return t.__proto__ = u.prototype, t;
                }, u.from = function(t, e, r) {
                    return c(null, t, e, r);
                }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
                    value: null,
                    configurable: !0
                })), u.alloc = function(t, e, r) {
                    return function n(t, e, r, i) {
                        return h(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof i ? a(t, e).fill(r, i) : a(t, e).fill(r) : a(t, e);
                    }(null, t, e, r);
                }, u.allocUnsafe = function(t) {
                    return l(null, t);
                }, u.allocUnsafeSlow = function(t) {
                    return l(null, t);
                }, u.isBuffer = function t(e) {
                    return !(null == e || !e._isBuffer);
                }, u.compare = function t(e, r) {
                    if (!u.isBuffer(e) || !u.isBuffer(r)) throw new TypeError("Arguments must be Buffers");
                    if (e === r) return 0;
                    for(var n = e.length, i = r.length, o = 0, s = Math.min(n, i); o < s; ++o)if (e[o] !== r[o]) {
                        n = e[o], i = r[o];
                        break;
                    }
                    return n < i ? -1 : i < n ? 1 : 0;
                }, u.isEncoding = function t(e) {
                    switch(String(e).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return !0;
                        default:
                            return !1;
                    }
                }, u.concat = function t(e, r) {
                    if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (0 === e.length) return u.alloc(0);
                    var n;
                    if (void 0 === r) for(r = 0, n = 0; n < e.length; ++n)r += e[n].length;
                    var i = u.allocUnsafe(r), s = 0;
                    for(n = 0; n < e.length; ++n){
                        var a = e[n];
                        if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                        a.copy(i, s), s += a.length;
                    }
                    return i;
                }, u.byteLength = d, u.prototype._isBuffer = !0, u.prototype.swap16 = function t() {
                    var e = this.length;
                    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(var r = 0; r < e; r += 2)v(this, r, r + 1);
                    return this;
                }, u.prototype.swap32 = function t() {
                    var e = this.length;
                    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(var r = 0; r < e; r += 4)v(this, r, r + 3), v(this, r + 1, r + 2);
                    return this;
                }, u.prototype.swap64 = function t() {
                    var e = this.length;
                    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(var r = 0; r < e; r += 8)v(this, r, r + 7), v(this, r + 1, r + 6), v(this, r + 2, r + 5), v(this, r + 3, r + 4);
                    return this;
                }, u.prototype.toString = function t() {
                    var e = 0 | this.length;
                    return 0 === e ? "" : 0 === arguments.length ? A(this, 0, e) : p.apply(this, arguments);
                }, u.prototype.equals = function t(e) {
                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                    return this === e || 0 === u.compare(this, e);
                }, u.prototype.inspect = function t() {
                    var r = "", n = e.INSPECT_MAX_BYTES;
                    return this.length > 0 && (r = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (r += " ... ")), "<Buffer " + r + ">";
                }, u.prototype.compare = function t(e, r, n, i, o) {
                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                    if (void 0 === r && (r = 0), void 0 === n && (n = e ? e.length : 0), void 0 === i && (i = 0), void 0 === o && (o = this.length), r < 0 || n > e.length || i < 0 || o > this.length) throw new RangeError("out of range index");
                    if (i >= o && r >= n) return 0;
                    if (i >= o) return -1;
                    if (r >= n) return 1;
                    if (this === e) return 0;
                    for(var s = (o >>>= 0) - (i >>>= 0), a = (n >>>= 0) - (r >>>= 0), c = Math.min(s, a), h = this.slice(i, o), l = e.slice(r, n), f = 0; f < c; ++f)if (h[f] !== l[f]) {
                        s = h[f], a = l[f];
                        break;
                    }
                    return s < a ? -1 : a < s ? 1 : 0;
                }, u.prototype.includes = function t(e, r, n) {
                    return -1 !== this.indexOf(e, r, n);
                }, u.prototype.indexOf = function t(e, r, n) {
                    return y(this, e, r, n, !0);
                }, u.prototype.lastIndexOf = function t(e, r, n) {
                    return y(this, e, r, n, !1);
                }, u.prototype.write = function t(e, r, n, i) {
                    if (void 0 === r) i = "utf8", n = this.length, r = 0;
                    else if (void 0 === n && "string" == typeof r) i = r, n = this.length, r = 0;
                    else {
                        if (!isFinite(r)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                        r |= 0, isFinite(n) ? (n |= 0, void 0 === i && (i = "utf8")) : (i = n, n = void 0);
                    }
                    var o = this.length - r;
                    if ((void 0 === n || n > o) && (n = o), e.length > 0 && (n < 0 || r < 0) || r > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    i || (i = "utf8");
                    for(var s = !1;;)switch(i){
                        case "hex":
                            return _(this, e, r, n);
                        case "utf8":
                        case "utf-8":
                            return S(this, e, r, n);
                        case "ascii":
                            return b(this, e, r, n);
                        case "latin1":
                        case "binary":
                            return w(this, e, r, n);
                        case "base64":
                            return F(this, e, r, n);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return E(this, e, r, n);
                        default:
                            if (s) throw new TypeError("Unknown encoding: " + i);
                            i = ("" + i).toLowerCase(), s = !0;
                    }
                }, u.prototype.toJSON = function t() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                var C = 4096;
                function T(t, e, r) {
                    var n = "";
                    r = Math.min(t.length, r);
                    for(var i = e; i < r; ++i)n += String.fromCharCode(127 & t[i]);
                    return n;
                }
                function R(t, e, r) {
                    var n = "";
                    r = Math.min(t.length, r);
                    for(var i = e; i < r; ++i)n += String.fromCharCode(t[i]);
                    return n;
                }
                function I(t, e, r) {
                    var n = t.length;
                    (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
                    for(var i = "", o = e; o < r; ++o)i += V(t[o]);
                    return i;
                }
                function D(t, e, r) {
                    for(var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2)i += String.fromCharCode(n[o] + 256 * n[o + 1]);
                    return i;
                }
                function L(t, e, r) {
                    if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
                    if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
                }
                function N(t, e, r, n, i, o) {
                    if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
                    if (r + n > t.length) throw new RangeError("Index out of range");
                }
                function U(t, e, r, n) {
                    e < 0 && (e = 65535 + e + 1);
                    for(var i = 0, o = Math.min(t.length - r, 2); i < o; ++i)t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
                }
                function B(t, e, r, n) {
                    e < 0 && (e = 4294967295 + e + 1);
                    for(var i = 0, o = Math.min(t.length - r, 4); i < o; ++i)t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
                }
                function O(t, e, r, n, i, o) {
                    if (r + n > t.length) throw new RangeError("Index out of range");
                    if (r < 0) throw new RangeError("Index out of range");
                }
                function j(t, e, r, n, o) {
                    return o || O(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
                }
                function M(t, e, r, n, o) {
                    return o || O(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
                }
                u.prototype.slice = function t(e, r) {
                    var n, i = this.length;
                    if ((e = ~~e) < 0 ? (e += i) < 0 && (e = 0) : e > i && (e = i), (r = void 0 === r ? i : ~~r) < 0 ? (r += i) < 0 && (r = 0) : r > i && (r = i), r < e && (r = e), u.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, r)).__proto__ = u.prototype;
                    else {
                        var o = r - e;
                        n = new u(o, void 0);
                        for(var s = 0; s < o; ++s)n[s] = this[s + e];
                    }
                    return n;
                }, u.prototype.readUIntLE = function t(e, r, n) {
                    e |= 0, r |= 0, n || L(e, r, this.length);
                    for(var i = this[e], o = 1, s = 0; ++s < r && (o *= 256);)i += this[e + s] * o;
                    return i;
                }, u.prototype.readUIntBE = function t(e, r, n) {
                    e |= 0, r |= 0, n || L(e, r, this.length);
                    for(var i = this[e + --r], o = 1; r > 0 && (o *= 256);)i += this[e + --r] * o;
                    return i;
                }, u.prototype.readUInt8 = function t(e, r) {
                    return r || L(e, 1, this.length), this[e];
                }, u.prototype.readUInt16LE = function t(e, r) {
                    return r || L(e, 2, this.length), this[e] | this[e + 1] << 8;
                }, u.prototype.readUInt16BE = function t(e, r) {
                    return r || L(e, 2, this.length), this[e] << 8 | this[e + 1];
                }, u.prototype.readUInt32LE = function t(e, r) {
                    return r || L(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                }, u.prototype.readUInt32BE = function t(e, r) {
                    return r || L(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                }, u.prototype.readIntLE = function t(e, r, n) {
                    e |= 0, r |= 0, n || L(e, r, this.length);
                    for(var i = this[e], o = 1, s = 0; ++s < r && (o *= 256);)i += this[e + s] * o;
                    return i >= (o *= 128) && (i -= Math.pow(2, 8 * r)), i;
                }, u.prototype.readIntBE = function t(e, r, n) {
                    e |= 0, r |= 0, n || L(e, r, this.length);
                    for(var i = r, o = 1, s = this[e + --i]; i > 0 && (o *= 256);)s += this[e + --i] * o;
                    return s >= (o *= 128) && (s -= Math.pow(2, 8 * r)), s;
                }, u.prototype.readInt8 = function t(e, r) {
                    return r || L(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                }, u.prototype.readInt16LE = function t(e, r) {
                    r || L(e, 2, this.length);
                    var n = this[e] | this[e + 1] << 8;
                    return 32768 & n ? 4294901760 | n : n;
                }, u.prototype.readInt16BE = function t(e, r) {
                    r || L(e, 2, this.length);
                    var n = this[e + 1] | this[e] << 8;
                    return 32768 & n ? 4294901760 | n : n;
                }, u.prototype.readInt32LE = function t(e, r) {
                    return r || L(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                }, u.prototype.readInt32BE = function t(e, r) {
                    return r || L(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                }, u.prototype.readFloatLE = function t(e, r) {
                    return r || L(e, 4, this.length), i.read(this, e, !0, 23, 4);
                }, u.prototype.readFloatBE = function t(e, r) {
                    return r || L(e, 4, this.length), i.read(this, e, !1, 23, 4);
                }, u.prototype.readDoubleLE = function t(e, r) {
                    return r || L(e, 8, this.length), i.read(this, e, !0, 52, 8);
                }, u.prototype.readDoubleBE = function t(e, r) {
                    return r || L(e, 8, this.length), i.read(this, e, !1, 52, 8);
                }, u.prototype.writeUIntLE = function t(e, r, n, i) {
                    (e = +e, r |= 0, n |= 0, i) || N(this, e, r, n, Math.pow(2, 8 * n) - 1, 0);
                    var o = 1, s = 0;
                    for(this[r] = 255 & e; ++s < n && (o *= 256);)this[r + s] = e / o & 255;
                    return r + n;
                }, u.prototype.writeUIntBE = function t(e, r, n, i) {
                    (e = +e, r |= 0, n |= 0, i) || N(this, e, r, n, Math.pow(2, 8 * n) - 1, 0);
                    var o = n - 1, s = 1;
                    for(this[r + o] = 255 & e; --o >= 0 && (s *= 256);)this[r + o] = e / s & 255;
                    return r + n;
                }, u.prototype.writeUInt8 = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[r] = 255 & e, r + 1;
                }, u.prototype.writeUInt16LE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & e, this[r + 1] = e >>> 8) : U(this, e, r, !0), r + 2;
                }, u.prototype.writeUInt16BE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = 255 & e) : U(this, e, r, !1), r + 2;
                }, u.prototype.writeUInt32LE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r + 3] = e >>> 24, this[r + 2] = e >>> 16, this[r + 1] = e >>> 8, this[r] = 255 & e) : B(this, e, r, !0), r + 4;
                }, u.prototype.writeUInt32BE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = 255 & e) : B(this, e, r, !1), r + 4;
                }, u.prototype.writeIntLE = function t(e, r, n, i) {
                    if (e = +e, r |= 0, !i) {
                        var o = Math.pow(2, 8 * n - 1);
                        N(this, e, r, n, o - 1, -o);
                    }
                    var s = 0, a = 1, u = 0;
                    for(this[r] = 255 & e; ++s < n && (a *= 256);)e < 0 && 0 === u && 0 !== this[r + s - 1] && (u = 1), this[r + s] = (e / a >> 0) - u & 255;
                    return r + n;
                }, u.prototype.writeIntBE = function t(e, r, n, i) {
                    if (e = +e, r |= 0, !i) {
                        var o = Math.pow(2, 8 * n - 1);
                        N(this, e, r, n, o - 1, -o);
                    }
                    var s = n - 1, a = 1, u = 0;
                    for(this[r + s] = 255 & e; --s >= 0 && (a *= 256);)e < 0 && 0 === u && 0 !== this[r + s + 1] && (u = 1), this[r + s] = (e / a >> 0) - u & 255;
                    return r + n;
                }, u.prototype.writeInt8 = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[r] = 255 & e, r + 1;
                }, u.prototype.writeInt16LE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & e, this[r + 1] = e >>> 8) : U(this, e, r, !0), r + 2;
                }, u.prototype.writeInt16BE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = 255 & e) : U(this, e, r, !1), r + 2;
                }, u.prototype.writeInt32LE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & e, this[r + 1] = e >>> 8, this[r + 2] = e >>> 16, this[r + 3] = e >>> 24) : B(this, e, r, !0), r + 4;
                }, u.prototype.writeInt32BE = function t(e, r, n) {
                    return e = +e, r |= 0, n || N(this, e, r, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = 255 & e) : B(this, e, r, !1), r + 4;
                }, u.prototype.writeFloatLE = function t(e, r, n) {
                    return j(this, e, r, !0, n);
                }, u.prototype.writeFloatBE = function t(e, r, n) {
                    return j(this, e, r, !1, n);
                }, u.prototype.writeDoubleLE = function t(e, r, n) {
                    return M(this, e, r, !0, n);
                }, u.prototype.writeDoubleBE = function t(e, r, n) {
                    return M(this, e, r, !1, n);
                }, u.prototype.copy = function t(e, r, n, i) {
                    if (n || (n = 0), i || 0 === i || (i = this.length), r >= e.length && (r = e.length), r || (r = 0), i > 0 && i < n && (i = n), i === n) return 0;
                    if (0 === e.length || 0 === this.length) return 0;
                    if (r < 0) throw new RangeError("targetStart out of bounds");
                    if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
                    if (i < 0) throw new RangeError("sourceEnd out of bounds");
                    i > this.length && (i = this.length), e.length - r < i - n && (i = e.length - r + n);
                    var o, s = i - n;
                    if (this === e && n < r && r < i) for(o = s - 1; o >= 0; --o)e[o + r] = this[o + n];
                    else if (s < 1e3 || !u.TYPED_ARRAY_SUPPORT) for(o = 0; o < s; ++o)e[o + r] = this[o + n];
                    else Uint8Array.prototype.set.call(e, this.subarray(n, n + s), r);
                    return s;
                }, u.prototype.fill = function t(e, r, n, i) {
                    if ("string" == typeof e) {
                        if ("string" == typeof r ? (i = r, r = 0, n = this.length) : "string" == typeof n && (i = n, n = this.length), 1 === e.length) {
                            var o = e.charCodeAt(0);
                            o < 256 && (e = o);
                        }
                        if (void 0 !== i && "string" != typeof i) throw new TypeError("encoding must be a string");
                        if ("string" == typeof i && !u.isEncoding(i)) throw new TypeError("Unknown encoding: " + i);
                    } else "number" == typeof e && (e &= 255);
                    if (r < 0 || this.length < r || this.length < n) throw new RangeError("Out of range index");
                    if (n <= r) return this;
                    var s;
                    if (r >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for(s = r; s < n; ++s)this[s] = e;
                    else {
                        var a = u.isBuffer(e) ? e : K(new u(e, i).toString()), c = a.length;
                        for(s = 0; s < n - r; ++s)this[s + r] = a[s % c];
                    }
                    return this;
                };
                var H = /[^+\/0-9A-Za-z-_]/g;
                function V(t) {
                    return t < 16 ? "0" + t.toString(16) : t.toString(16);
                }
                function K(t, e) {
                    var r;
                    e = e || 1 / 0;
                    for(var n = t.length, i = null, o = [], s = 0; s < n; ++s){
                        if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
                            if (!i) {
                                if (r > 56319) {
                                    (e -= 3) > -1 && o.push(239, 191, 189);
                                    continue;
                                }
                                if (s + 1 === n) {
                                    (e -= 3) > -1 && o.push(239, 191, 189);
                                    continue;
                                }
                                i = r;
                                continue;
                            }
                            if (r < 56320) {
                                (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                                continue;
                            }
                            r = 65536 + (i - 55296 << 10 | r - 56320);
                        } else i && (e -= 3) > -1 && o.push(239, 191, 189);
                        if (i = null, r < 128) {
                            if ((e -= 1) < 0) break;
                            o.push(r);
                        } else if (r < 2048) {
                            if ((e -= 2) < 0) break;
                            o.push(r >> 6 | 192, 63 & r | 128);
                        } else if (r < 65536) {
                            if ((e -= 3) < 0) break;
                            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                        } else {
                            if (!(r < 1114112)) throw new Error("Invalid code point");
                            if ((e -= 4) < 0) break;
                            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                        }
                    }
                    return o;
                }
                function q(t) {
                    return n.toByteArray(function e(t) {
                        if ((t = (function e(t) {
                            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
                        })(t).replace(H, "")).length < 2) return "";
                        for(; t.length % 4 != 0;)t += "=";
                        return t;
                    }(t));
                }
                function J(t, e, r, n) {
                    for(var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i)e[i + r] = t[i];
                    return i;
                }
            }).call(this, r(29));
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || new Function("return this")();
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            e.byteLength = function n(t) {
                var e = f(t), r = e[0], n = e[1];
                return 3 * (r + n) / 4 - n;
            }, e.toByteArray = function i(t) {
                var e, r, n = f(t), i = n[0], o = n[1], s = new u(function c(t, e, r) {
                    return 3 * (e + r) / 4 - r;
                }(0, i, o)), h = 0, l = o > 0 ? i - 4 : i;
                for(r = 0; r < l; r += 4)e = a[t.charCodeAt(r)] << 18 | a[t.charCodeAt(r + 1)] << 12 | a[t.charCodeAt(r + 2)] << 6 | a[t.charCodeAt(r + 3)], s[h++] = e >> 16 & 255, s[h++] = e >> 8 & 255, s[h++] = 255 & e;
                2 === o && (e = a[t.charCodeAt(r)] << 2 | a[t.charCodeAt(r + 1)] >> 4, s[h++] = 255 & e);
                1 === o && (e = a[t.charCodeAt(r)] << 10 | a[t.charCodeAt(r + 1)] << 4 | a[t.charCodeAt(r + 2)] >> 2, s[h++] = e >> 8 & 255, s[h++] = 255 & e);
                return s;
            }, e.fromByteArray = function o(t) {
                for(var e, r = t.length, n = r % 3, i = [], o = 16383, a = 0, u = r - n; a < u; a += o)i.push(g(t, a, a + o > u ? u : a + o));
                1 === n ? (e = t[r - 1], i.push(s[e >> 2] + s[e << 4 & 63] + "==")) : 2 === n && (e = (t[r - 2] << 8) + t[r - 1], i.push(s[e >> 10] + s[e >> 4 & 63] + s[e << 2 & 63] + "="));
                return i.join("");
            };
            for(var s = [], a = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = 0, l = c.length; h < l; ++h)s[h] = c[h], a[c.charCodeAt(h)] = h;
            function f(t) {
                var e = t.length;
                if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                var r = t.indexOf("=");
                return -1 === r && (r = e), [
                    r,
                    r === e ? 0 : 4 - r % 4
                ];
            }
            function g(t, e, r) {
                for(var n, i, o = [], a = e; a < r; a += 3)n = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), o.push(s[(i = n) >> 18 & 63] + s[i >> 12 & 63] + s[i >> 6 & 63] + s[63 & i]);
                return o.join("");
            }
            a["-".charCodeAt(0)] = 62, a["_".charCodeAt(0)] = 63;
        },
        function(t, e) {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ e.read = function(t, e, r, n, i) {
                var o, s, a = 8 * i - n - 1, u = (1 << a) - 1, c = u >> 1, h = -7, l = r ? i - 1 : 0, f = r ? -1 : 1, g = t[e + l];
                for(l += f, o = g & (1 << -h) - 1, g >>= -h, h += a; h > 0; o = 256 * o + t[e + l], l += f, h -= 8);
                for(s = o & (1 << -h) - 1, o >>= -h, h += n; h > 0; s = 256 * s + t[e + l], l += f, h -= 8);
                if (0 === o) o = 1 - c;
                else {
                    if (o === u) return s ? NaN : 1 / 0 * (g ? -1 : 1);
                    s += Math.pow(2, n), o -= c;
                }
                return (g ? -1 : 1) * s * Math.pow(2, o - n);
            }, e.write = function(t, e, r, n, i, o) {
                var s, a, u, c = 8 * o - i - 1, h = (1 << c) - 1, l = h >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = n ? 0 : o - 1, d = n ? 1 : -1, p = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + l >= 1 ? f / u : f * Math.pow(2, 1 - l)) * u >= 2 && (s++, u /= 2), s + l >= h ? (a = 0, s = h) : s + l >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += l) : (a = e * Math.pow(2, l - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + g] = 255 & a, g += d, a /= 256, i -= 8);
                for(s = s << i | a, c += i; c > 0; t[r + g] = 255 & s, g += d, s /= 256, c -= 8);
                t[r + g - d] |= 128 * p;
            };
        },
        function(t, e) {
            var r = {}.toString;
            t.exports = Array.isArray || function(t) {
                return "[object Array]" == r.call(t);
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = function n(t) {
                var e = t.jws, r = t.KeyUtil, n = t.X509, o = t.crypto, s = t.hextob64u, a = t.b64tohex, u = t.AllowedSigningAlgs;
                return function() {
                    function t() {
                        !function e(t, r) {
                            if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                        }(this, t);
                    }
                    return t.parseJwt = function t(r) {
                        i.Log.debug("JoseUtil.parseJwt");
                        try {
                            var n = e.JWS.parse(r);
                            return {
                                header: n.headerObj,
                                payload: n.payloadObj
                            };
                        } catch (t) {
                            i.Log.error(t);
                        }
                    }, t.validateJwt = function e(o, s, u, c, h, l, f) {
                        i.Log.debug("JoseUtil.validateJwt");
                        try {
                            if ("RSA" === s.kty) {
                                if (s.e && s.n) s = r.getKey(s);
                                else {
                                    if (!s.x5c || !s.x5c.length) return i.Log.error("JoseUtil.validateJwt: RSA key missing key material", s), Promise.reject(new Error("RSA key missing key material"));
                                    var g = a(s.x5c[0]);
                                    s = n.getPublicKeyFromCertHex(g);
                                }
                            } else {
                                if ("EC" !== s.kty) return i.Log.error("JoseUtil.validateJwt: Unsupported key type", s && s.kty), Promise.reject(new Error(s.kty));
                                if (!(s.crv && s.x && s.y)) return i.Log.error("JoseUtil.validateJwt: EC key missing key material", s), Promise.reject(new Error("EC key missing key material"));
                                s = r.getKey(s);
                            }
                            return t._validateJwt(o, s, u, c, h, l, f);
                        } catch (t) {
                            return i.Log.error(t && t.message || t), Promise.reject("JWT validation failed");
                        }
                    }, t.validateJwtAttributes = function e(r, n, o, s, a, u) {
                        s || (s = 0), a || (a = parseInt(Date.now() / 1e3));
                        var c = t.parseJwt(r).payload;
                        if (!c.iss) return i.Log.error("JoseUtil._validateJwt: issuer was not provided"), Promise.reject(new Error("issuer was not provided"));
                        if (c.iss !== n) return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token", c.iss), Promise.reject(new Error("Invalid issuer in token: " + c.iss));
                        if (!c.aud) return i.Log.error("JoseUtil._validateJwt: aud was not provided"), Promise.reject(new Error("aud was not provided"));
                        if (!(c.aud === o || Array.isArray(c.aud) && c.aud.indexOf(o) >= 0)) return i.Log.error("JoseUtil._validateJwt: Invalid audience in token", c.aud), Promise.reject(new Error("Invalid audience in token: " + c.aud));
                        if (c.azp && c.azp !== o) return i.Log.error("JoseUtil._validateJwt: Invalid azp in token", c.azp), Promise.reject(new Error("Invalid azp in token: " + c.azp));
                        if (!u) {
                            var h = a + s, l = a - s;
                            if (!c.iat) return i.Log.error("JoseUtil._validateJwt: iat was not provided"), Promise.reject(new Error("iat was not provided"));
                            if (h < c.iat) return i.Log.error("JoseUtil._validateJwt: iat is in the future", c.iat), Promise.reject(new Error("iat is in the future: " + c.iat));
                            if (c.nbf && h < c.nbf) return i.Log.error("JoseUtil._validateJwt: nbf is in the future", c.nbf), Promise.reject(new Error("nbf is in the future: " + c.nbf));
                            if (!c.exp) return i.Log.error("JoseUtil._validateJwt: exp was not provided"), Promise.reject(new Error("exp was not provided"));
                            if (c.exp < l) return i.Log.error("JoseUtil._validateJwt: exp is in the past", c.exp), Promise.reject(new Error("exp is in the past:" + c.exp));
                        }
                        return Promise.resolve(c);
                    }, t._validateJwt = function r(n, o, s, a, c, h, l) {
                        return t.validateJwtAttributes(n, s, a, c, h, l).then(function(t) {
                            try {
                                return e.JWS.verify(n, o, u) ? t : (i.Log.error("JoseUtil._validateJwt: signature validation failed"), Promise.reject(new Error("signature validation failed")));
                            } catch (t) {
                                return i.Log.error(t && t.message || t), Promise.reject(new Error("signature validation failed"));
                            }
                        });
                    }, t.hashString = function t(e, r) {
                        try {
                            return o.Util.hashString(e, r);
                        } catch (t) {
                            i.Log.error(t);
                        }
                    }, t.hexToBase64Url = function t(e) {
                        try {
                            return s(e);
                        } catch (t) {
                            i.Log.error(t);
                        }
                    }, t;
                }();
            };
            var i = r(0);
            t.exports = e.default;
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SigninResponse = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(3);
            function o(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            e.SigninResponse = function() {
                function t(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#";
                    o(this, t);
                    var n = i.UrlUtility.parseUrlFragment(e, r);
                    this.error = n.error, this.error_description = n.error_description, this.error_uri = n.error_uri, this.code = n.code, this.state = n.state, this.id_token = n.id_token, this.session_state = n.session_state, this.access_token = n.access_token, this.token_type = n.token_type, this.scope = n.scope, this.profile = void 0, this.expires_in = n.expires_in;
                }
                return n(t, [
                    {
                        key: "expires_in",
                        get: function t() {
                            if (this.expires_at) {
                                var e = parseInt(Date.now() / 1e3);
                                return this.expires_at - e;
                            }
                        },
                        set: function t(e) {
                            var r = parseInt(e);
                            if ("number" == typeof r && r > 0) {
                                var n = parseInt(Date.now() / 1e3);
                                this.expires_at = n + r;
                            }
                        }
                    },
                    {
                        key: "expired",
                        get: function t() {
                            var e = this.expires_in;
                            if (void 0 !== e) return e <= 0;
                        }
                    },
                    {
                        key: "scopes",
                        get: function t() {
                            return (this.scope || "").split(" ");
                        }
                    },
                    {
                        key: "isOpenIdConnect",
                        get: function t() {
                            return this.scopes.indexOf("openid") >= 0 || !!this.id_token;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SignoutRequest = void 0;
            var n = r(0), i = r(3), o = r(9);
            e.SignoutRequest = function t(e) {
                var r = e.url, s = e.id_token_hint, a = e.post_logout_redirect_uri, u = e.data, c = e.extraQueryParams, h = e.request_type;
                if (function l(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), !r) throw n.Log.error("SignoutRequest.ctor: No url passed"), new Error("url");
                for(var f in s && (r = i.UrlUtility.addQueryParam(r, "id_token_hint", s)), a && (r = i.UrlUtility.addQueryParam(r, "post_logout_redirect_uri", a), u && (this.state = new o.State({
                    data: u,
                    request_type: h
                }), r = i.UrlUtility.addQueryParam(r, "state", this.state.id))), c)r = i.UrlUtility.addQueryParam(r, f, c[f]);
                this.url = r;
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SignoutResponse = void 0;
            var n = r(3);
            e.SignoutResponse = function t(e) {
                !function r(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t);
                var i = n.UrlUtility.parseUrlFragment(e, "?");
                this.error = i.error, this.error_description = i.error_description, this.error_uri = i.error_uri, this.state = i.state;
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.InMemoryWebStorage = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0);
            e.InMemoryWebStorage = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this._data = {};
                }
                return t.prototype.getItem = function t(e) {
                    return i.Log.debug("InMemoryWebStorage.getItem", e), this._data[e];
                }, t.prototype.setItem = function t(e, r) {
                    i.Log.debug("InMemoryWebStorage.setItem", e), this._data[e] = r;
                }, t.prototype.removeItem = function t(e) {
                    i.Log.debug("InMemoryWebStorage.removeItem", e), delete this._data[e];
                }, t.prototype.key = function t(e) {
                    return Object.getOwnPropertyNames(this._data)[e];
                }, n(t, [
                    {
                        key: "length",
                        get: function t() {
                            return Object.getOwnPropertyNames(this._data).length;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.UserManager = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(10), s = r(39), a = r(15), u = r(45), c = r(47), h = r(18), l = r(8), f = r(20), g = r(11), d = r(4);
            function p(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function v(t, e) {
                if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }
            e.UserManager = function(t) {
                function e() {
                    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.SilentRenewService, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h.SessionMonitor, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : f.TokenRevocationClient, l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : g.TokenClient, y = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : d.JoseUtil;
                    p(this, e), r instanceof s.UserManagerSettings || (r = new s.UserManagerSettings(r));
                    var m = v(this, t.call(this, r));
                    return m._events = new u.UserManagerEvents(r), m._silentRenewService = new n(m), m.settings.automaticSilentRenew && (i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"), m.startSilentRenew()), m.settings.monitorSession && (i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"), m._sessionMonitor = new o(m)), m._tokenRevocationClient = new a(m._settings), m._tokenClient = new l(m._settings), m._joseUtil = y, m;
                }
                return function r(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
                }(e, t), e.prototype.getUser = function t() {
                    var e = this;
                    return this._loadUser().then(function(t) {
                        return t ? (i.Log.info("UserManager.getUser: user loaded"), e._events.load(t, !1), t) : (i.Log.info("UserManager.getUser: user not found in storage"), null);
                    });
                }, e.prototype.removeUser = function t() {
                    var e = this;
                    return this.storeUser(null).then(function() {
                        i.Log.info("UserManager.removeUser: user removed from storage"), e._events.unload();
                    });
                }, e.prototype.signinRedirect = function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (e = Object.assign({}, e)).request_type = "si:r";
                    var r = {
                        useReplaceToNavigate: e.useReplaceToNavigate
                    };
                    return this._signinStart(e, this._redirectNavigator, r).then(function() {
                        i.Log.info("UserManager.signinRedirect: successful");
                    });
                }, e.prototype.signinRedirectCallback = function t(e) {
                    return this._signinEnd(e || this._redirectNavigator.url).then(function(t) {
                        return t.profile && t.profile.sub ? i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinRedirectCallback: no sub"), t;
                    });
                }, e.prototype.signinPopup = function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (e = Object.assign({}, e)).request_type = "si:p";
                    var r = e.redirect_uri || this.settings.popup_redirect_uri || this.settings.redirect_uri;
                    return r ? (e.redirect_uri = r, e.display = "popup", this._signin(e, this._popupNavigator, {
                        startUrl: r,
                        popupWindowFeatures: e.popupWindowFeatures || this.settings.popupWindowFeatures,
                        popupWindowTarget: e.popupWindowTarget || this.settings.popupWindowTarget
                    }).then(function(t) {
                        return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinPopup: no sub")), t;
                    })) : (i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"), Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")));
                }, e.prototype.signinPopupCallback = function t(e) {
                    return this._signinCallback(e, this._popupNavigator).then(function(t) {
                        return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinPopupCallback: no sub")), t;
                    }).catch(function(t) {
                        i.Log.error(t.message);
                    });
                }, e.prototype.signinSilent = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return r = Object.assign({}, r), this._loadUser().then(function(t) {
                        return t && t.refresh_token ? (r.refresh_token = t.refresh_token, e._useRefreshToken(r)) : (r.request_type = "si:s", r.id_token_hint = r.id_token_hint || e.settings.includeIdTokenInSilentRenew && t && t.id_token, t && e._settings.validateSubOnSilentRenew && (i.Log.debug("UserManager.signinSilent, subject prior to silent renew: ", t.profile.sub), r.current_sub = t.profile.sub), e._signinSilentIframe(r));
                    });
                }, e.prototype._useRefreshToken = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return this._tokenClient.exchangeRefreshToken(r).then(function(t) {
                        return t ? t.access_token ? e._loadUser().then(function(r) {
                            if (r) {
                                var n = Promise.resolve();
                                return t.id_token && (n = e._validateIdTokenFromTokenRefreshToken(r.profile, t.id_token)), n.then(function() {
                                    return i.Log.debug("UserManager._useRefreshToken: refresh token response success"), r.id_token = t.id_token || r.id_token, r.access_token = t.access_token, r.refresh_token = t.refresh_token || r.refresh_token, r.expires_in = t.expires_in, e.storeUser(r).then(function() {
                                        return e._events.load(r), r;
                                    });
                                });
                            }
                            return null;
                        }) : (i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"), Promise.reject("No access token returned from token endpoint")) : (i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"), Promise.reject("No response returned from token endpoint"));
                    });
                }, e.prototype._validateIdTokenFromTokenRefreshToken = function t(e, r) {
                    var n = this;
                    return this._metadataService.getIssuer().then(function(t) {
                        return n.settings.getEpochTime().then(function(o) {
                            return n._joseUtil.validateJwtAttributes(r, t, n._settings.client_id, n._settings.clockSkew, o).then(function(t) {
                                return t ? t.sub !== e.sub ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"), Promise.reject(new Error("sub in id_token does not match current sub"))) : t.auth_time && t.auth_time !== e.auth_time ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"), Promise.reject(new Error("auth_time in id_token does not match original auth_time"))) : t.azp && t.azp !== e.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"), Promise.reject(new Error("azp in id_token does not match original azp"))) : !t.azp && e.azp ? (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"), Promise.reject(new Error("azp not in id_token, but present in original id_token"))) : void 0 : (i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"), Promise.reject(new Error("Failed to validate id_token")));
                            });
                        });
                    });
                }, e.prototype._signinSilentIframe = function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri;
                    return r ? (e.redirect_uri = r, e.prompt = e.prompt || "none", this._signin(e, this._iframeNavigator, {
                        startUrl: r,
                        silentRequestTimeout: e.silentRequestTimeout || this.settings.silentRequestTimeout
                    }).then(function(t) {
                        return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinSilent: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinSilent: no sub")), t;
                    })) : (i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
                }, e.prototype.signinSilentCallback = function t(e) {
                    return this._signinCallback(e, this._iframeNavigator).then(function(t) {
                        return t && (t.profile && t.profile.sub ? i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ", t.profile.sub) : i.Log.info("UserManager.signinSilentCallback: no sub")), t;
                    });
                }, e.prototype.signinCallback = function t(e) {
                    var r = this;
                    return this.readSigninResponseState(e).then(function(t) {
                        var n = t.state;
                        t.response;
                        return "si:r" === n.request_type ? r.signinRedirectCallback(e) : "si:p" === n.request_type ? r.signinPopupCallback(e) : "si:s" === n.request_type ? r.signinSilentCallback(e) : Promise.reject(new Error("invalid response_type in state"));
                    });
                }, e.prototype.signoutCallback = function t(e, r) {
                    var n = this;
                    return this.readSignoutResponseState(e).then(function(t) {
                        var i = t.state, o = t.response;
                        return i ? "so:r" === i.request_type ? n.signoutRedirectCallback(e) : "so:p" === i.request_type ? n.signoutPopupCallback(e, r) : Promise.reject(new Error("invalid response_type in state")) : o;
                    });
                }, e.prototype.querySessionStatus = function t() {
                    var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (r = Object.assign({}, r)).request_type = "si:s";
                    var n = r.redirect_uri || this.settings.silent_redirect_uri || this.settings.redirect_uri;
                    return n ? (r.redirect_uri = n, r.prompt = "none", r.response_type = r.response_type || this.settings.query_status_response_type, r.scope = r.scope || "openid", r.skipUserInfo = !0, this._signinStart(r, this._iframeNavigator, {
                        startUrl: n,
                        silentRequestTimeout: r.silentRequestTimeout || this.settings.silentRequestTimeout
                    }).then(function(t) {
                        return e.processSigninResponse(t.url).then(function(t) {
                            if (i.Log.debug("UserManager.querySessionStatus: got signin response"), t.session_state && t.profile.sub) return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ", t.profile.sub), {
                                session_state: t.session_state,
                                sub: t.profile.sub,
                                sid: t.profile.sid
                            };
                            i.Log.info("querySessionStatus successful, user not authenticated");
                        }).catch(function(t) {
                            if (t.session_state && e.settings.monitorAnonymousSession && ("login_required" == t.message || "consent_required" == t.message || "interaction_required" == t.message || "account_selection_required" == t.message)) return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for anonymous user"), {
                                session_state: t.session_state
                            };
                            throw t;
                        });
                    })) : (i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"), Promise.reject(new Error("No silent_redirect_uri configured")));
                }, e.prototype._signin = function t(e, r) {
                    var n = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    return this._signinStart(e, r, i).then(function(t) {
                        return n._signinEnd(t.url, e);
                    });
                }, e.prototype._signinStart = function t(e, r) {
                    var n = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    return r.prepare(o).then(function(t) {
                        return i.Log.debug("UserManager._signinStart: got navigator window handle"), n.createSigninRequest(e).then(function(e) {
                            return i.Log.debug("UserManager._signinStart: got signin request"), o.url = e.url, o.id = e.state.id, t.navigate(o);
                        }).catch(function(e) {
                            throw t.close && (i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"), t.close()), e;
                        });
                    });
                }, e.prototype._signinEnd = function t(e) {
                    var r = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return this.processSigninResponse(e).then(function(t) {
                        i.Log.debug("UserManager._signinEnd: got signin response");
                        var e = new a.User(t);
                        if (n.current_sub) {
                            if (n.current_sub !== e.profile.sub) return i.Log.debug("UserManager._signinEnd: current user does not match user returned from signin. sub from signin: ", e.profile.sub), Promise.reject(new Error("login_required"));
                            i.Log.debug("UserManager._signinEnd: current user matches user returned from signin");
                        }
                        return r.storeUser(e).then(function() {
                            return i.Log.debug("UserManager._signinEnd: user stored"), r._events.load(e), e;
                        });
                    });
                }, e.prototype._signinCallback = function t(e, r) {
                    i.Log.debug("UserManager._signinCallback");
                    var n = "query" === this._settings.response_mode || !this._settings.response_mode && l.SigninRequest.isCode(this._settings.response_type) ? "?" : "#";
                    return r.callback(e, void 0, n);
                }, e.prototype.signoutRedirect = function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (e = Object.assign({}, e)).request_type = "so:r";
                    var r = e.post_logout_redirect_uri || this.settings.post_logout_redirect_uri;
                    r && (e.post_logout_redirect_uri = r);
                    var n = {
                        useReplaceToNavigate: e.useReplaceToNavigate
                    };
                    return this._signoutStart(e, this._redirectNavigator, n).then(function() {
                        i.Log.info("UserManager.signoutRedirect: successful");
                    });
                }, e.prototype.signoutRedirectCallback = function t(e) {
                    return this._signoutEnd(e || this._redirectNavigator.url).then(function(t) {
                        return i.Log.info("UserManager.signoutRedirectCallback: successful"), t;
                    });
                }, e.prototype.signoutPopup = function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (e = Object.assign({}, e)).request_type = "so:p";
                    var r = e.post_logout_redirect_uri || this.settings.popup_post_logout_redirect_uri || this.settings.post_logout_redirect_uri;
                    return e.post_logout_redirect_uri = r, e.display = "popup", e.post_logout_redirect_uri && (e.state = e.state || {}), this._signout(e, this._popupNavigator, {
                        startUrl: r,
                        popupWindowFeatures: e.popupWindowFeatures || this.settings.popupWindowFeatures,
                        popupWindowTarget: e.popupWindowTarget || this.settings.popupWindowTarget
                    }).then(function() {
                        i.Log.info("UserManager.signoutPopup: successful");
                    });
                }, e.prototype.signoutPopupCallback = function t(e, r) {
                    void 0 === r && "boolean" == typeof e && (r = e, e = null);
                    return this._popupNavigator.callback(e, r, "?").then(function() {
                        i.Log.info("UserManager.signoutPopupCallback: successful");
                    });
                }, e.prototype._signout = function t(e, r) {
                    var n = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    return this._signoutStart(e, r, i).then(function(t) {
                        return n._signoutEnd(t.url);
                    });
                }, e.prototype._signoutStart = function t() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = this, n = arguments[1], o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    return n.prepare(o).then(function(t) {
                        return i.Log.debug("UserManager._signoutStart: got navigator window handle"), r._loadUser().then(function(n) {
                            return i.Log.debug("UserManager._signoutStart: loaded current user from storage"), (r._settings.revokeAccessTokenOnSignout ? r._revokeInternal(n) : Promise.resolve()).then(function() {
                                var s = e.id_token_hint || n && n.id_token;
                                return s && (i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"), e.id_token_hint = s), r.removeUser().then(function() {
                                    return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"), r.createSignoutRequest(e).then(function(e) {
                                        return i.Log.debug("UserManager._signoutStart: got signout request"), o.url = e.url, e.state && (o.id = e.state.id), t.navigate(o);
                                    });
                                });
                            });
                        }).catch(function(e) {
                            throw t.close && (i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"), t.close()), e;
                        });
                    });
                }, e.prototype._signoutEnd = function t(e) {
                    return this.processSignoutResponse(e).then(function(t) {
                        return i.Log.debug("UserManager._signoutEnd: got signout response"), t;
                    });
                }, e.prototype.revokeAccessToken = function t() {
                    var e = this;
                    return this._loadUser().then(function(t) {
                        return e._revokeInternal(t, !0).then(function(r) {
                            if (r) return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"), t.access_token = null, t.refresh_token = null, t.expires_at = null, t.token_type = null, e.storeUser(t).then(function() {
                                i.Log.debug("UserManager.revokeAccessToken: user stored"), e._events.load(t);
                            });
                        });
                    }).then(function() {
                        i.Log.info("UserManager.revokeAccessToken: access token revoked successfully");
                    });
                }, e.prototype._revokeInternal = function t(e, r) {
                    var n = this;
                    if (e) {
                        var o = e.access_token, s = e.refresh_token;
                        return this._revokeAccessTokenInternal(o, r).then(function(t) {
                            return n._revokeRefreshTokenInternal(s, r).then(function(e) {
                                return t || e || i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"), t || e;
                            });
                        });
                    }
                    return Promise.resolve(!1);
                }, e.prototype._revokeAccessTokenInternal = function t(e, r) {
                    return !e || e.indexOf(".") >= 0 ? Promise.resolve(!1) : this._tokenRevocationClient.revoke(e, r).then(function() {
                        return !0;
                    });
                }, e.prototype._revokeRefreshTokenInternal = function t(e, r) {
                    return e ? this._tokenRevocationClient.revoke(e, r, "refresh_token").then(function() {
                        return !0;
                    }) : Promise.resolve(!1);
                }, e.prototype.startSilentRenew = function t() {
                    this._silentRenewService.start();
                }, e.prototype.stopSilentRenew = function t() {
                    this._silentRenewService.stop();
                }, e.prototype._loadUser = function t() {
                    return this._userStore.get(this._userStoreKey).then(function(t) {
                        return t ? (i.Log.debug("UserManager._loadUser: user storageString loaded"), a.User.fromStorageString(t)) : (i.Log.debug("UserManager._loadUser: no user storageString"), null);
                    });
                }, e.prototype.storeUser = function t(e) {
                    if (e) {
                        i.Log.debug("UserManager.storeUser: storing user");
                        var r = e.toStorageString();
                        return this._userStore.set(this._userStoreKey, r);
                    }
                    return i.Log.debug("storeUser.storeUser: removing user"), this._userStore.remove(this._userStoreKey);
                }, n(e, [
                    {
                        key: "_redirectNavigator",
                        get: function t() {
                            return this.settings.redirectNavigator;
                        }
                    },
                    {
                        key: "_popupNavigator",
                        get: function t() {
                            return this.settings.popupNavigator;
                        }
                    },
                    {
                        key: "_iframeNavigator",
                        get: function t() {
                            return this.settings.iframeNavigator;
                        }
                    },
                    {
                        key: "_userStore",
                        get: function t() {
                            return this.settings.userStore;
                        }
                    },
                    {
                        key: "events",
                        get: function t() {
                            return this._events;
                        }
                    },
                    {
                        key: "_userStoreKey",
                        get: function t() {
                            return "user:" + this.settings.authority + ":" + this.settings.client_id;
                        }
                    }
                ]), e;
            }(o.OidcClient);
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.UserManagerSettings = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = (r(0), r(5)), o = r(40), s = r(41), a = r(43), u = r(6), c = r(1), h = r(8);
            function l(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function f(t, e) {
                if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }
            e.UserManagerSettings = function(t) {
                function e() {
                    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = r.popup_redirect_uri, i = r.popup_post_logout_redirect_uri, g = r.popupWindowFeatures, d = r.popupWindowTarget, p = r.silent_redirect_uri, v = r.silentRequestTimeout, y = r.automaticSilentRenew, m = void 0 !== y && y, _ = r.validateSubOnSilentRenew, S = void 0 !== _ && _, b = r.includeIdTokenInSilentRenew, w = void 0 === b || b, F = r.monitorSession, E = void 0 === F || F, x = r.monitorAnonymousSession, A = void 0 !== x && x, k = r.checkSessionInterval, P = void 0 === k ? 2e3 : k, C = r.stopCheckSessionOnError, T = void 0 === C || C, R = r.query_status_response_type, I = r.revokeAccessTokenOnSignout, D = void 0 !== I && I, L = r.accessTokenExpiringNotificationTime, N = void 0 === L ? 60 : L, U = r.redirectNavigator, B = void 0 === U ? new o.RedirectNavigator : U, O = r.popupNavigator, j = void 0 === O ? new s.PopupNavigator : O, M = r.iframeNavigator, H = void 0 === M ? new a.IFrameNavigator : M, V = r.userStore, K = void 0 === V ? new u.WebStorageStateStore({
                        store: c.Global.sessionStorage
                    }) : V;
                    l(this, e);
                    var q = f(this, t.call(this, arguments[0]));
                    return q._popup_redirect_uri = n, q._popup_post_logout_redirect_uri = i, q._popupWindowFeatures = g, q._popupWindowTarget = d, q._silent_redirect_uri = p, q._silentRequestTimeout = v, q._automaticSilentRenew = m, q._validateSubOnSilentRenew = S, q._includeIdTokenInSilentRenew = w, q._accessTokenExpiringNotificationTime = N, q._monitorSession = E, q._monitorAnonymousSession = A, q._checkSessionInterval = P, q._stopCheckSessionOnError = T, R ? q._query_status_response_type = R : arguments[0] && arguments[0].response_type ? q._query_status_response_type = h.SigninRequest.isOidc(arguments[0].response_type) ? "id_token" : "code" : q._query_status_response_type = "id_token", q._revokeAccessTokenOnSignout = D, q._redirectNavigator = B, q._popupNavigator = j, q._iframeNavigator = H, q._userStore = K, q;
                }
                return function r(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
                }(e, t), n(e, [
                    {
                        key: "popup_redirect_uri",
                        get: function t() {
                            return this._popup_redirect_uri;
                        }
                    },
                    {
                        key: "popup_post_logout_redirect_uri",
                        get: function t() {
                            return this._popup_post_logout_redirect_uri;
                        }
                    },
                    {
                        key: "popupWindowFeatures",
                        get: function t() {
                            return this._popupWindowFeatures;
                        }
                    },
                    {
                        key: "popupWindowTarget",
                        get: function t() {
                            return this._popupWindowTarget;
                        }
                    },
                    {
                        key: "silent_redirect_uri",
                        get: function t() {
                            return this._silent_redirect_uri;
                        }
                    },
                    {
                        key: "silentRequestTimeout",
                        get: function t() {
                            return this._silentRequestTimeout;
                        }
                    },
                    {
                        key: "automaticSilentRenew",
                        get: function t() {
                            return this._automaticSilentRenew;
                        }
                    },
                    {
                        key: "validateSubOnSilentRenew",
                        get: function t() {
                            return this._validateSubOnSilentRenew;
                        }
                    },
                    {
                        key: "includeIdTokenInSilentRenew",
                        get: function t() {
                            return this._includeIdTokenInSilentRenew;
                        }
                    },
                    {
                        key: "accessTokenExpiringNotificationTime",
                        get: function t() {
                            return this._accessTokenExpiringNotificationTime;
                        }
                    },
                    {
                        key: "monitorSession",
                        get: function t() {
                            return this._monitorSession;
                        }
                    },
                    {
                        key: "monitorAnonymousSession",
                        get: function t() {
                            return this._monitorAnonymousSession;
                        }
                    },
                    {
                        key: "checkSessionInterval",
                        get: function t() {
                            return this._checkSessionInterval;
                        }
                    },
                    {
                        key: "stopCheckSessionOnError",
                        get: function t() {
                            return this._stopCheckSessionOnError;
                        }
                    },
                    {
                        key: "query_status_response_type",
                        get: function t() {
                            return this._query_status_response_type;
                        }
                    },
                    {
                        key: "revokeAccessTokenOnSignout",
                        get: function t() {
                            return this._revokeAccessTokenOnSignout;
                        }
                    },
                    {
                        key: "redirectNavigator",
                        get: function t() {
                            return this._redirectNavigator;
                        }
                    },
                    {
                        key: "popupNavigator",
                        get: function t() {
                            return this._popupNavigator;
                        }
                    },
                    {
                        key: "iframeNavigator",
                        get: function t() {
                            return this._iframeNavigator;
                        }
                    },
                    {
                        key: "userStore",
                        get: function t() {
                            return this._userStore;
                        }
                    }
                ]), e;
            }(i.OidcClientSettings);
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.RedirectNavigator = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0);
            e.RedirectNavigator = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.prototype.prepare = function t() {
                    return Promise.resolve(this);
                }, t.prototype.navigate = function t(e) {
                    return e && e.url ? (e.useReplaceToNavigate ? window.location.replace(e.url) : window.location = e.url, Promise.resolve()) : (i.Log.error("RedirectNavigator.navigate: No url provided"), Promise.reject(new Error("No url provided")));
                }, n(t, [
                    {
                        key: "url",
                        get: function t() {
                            return window.location.href;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.PopupNavigator = void 0;
            var n = r(0), i = r(42);
            e.PopupNavigator = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.prototype.prepare = function t(e) {
                    var r = new i.PopupWindow(e);
                    return Promise.resolve(r);
                }, t.prototype.callback = function t(e, r, o) {
                    n.Log.debug("PopupNavigator.callback");
                    try {
                        return i.PopupWindow.notifyOpener(e, r, o), Promise.resolve();
                    } catch (t) {
                        return Promise.reject(t);
                    }
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.PopupWindow = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(3);
            e.PopupWindow = function() {
                function t(e) {
                    var r = this;
                    !function n(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this._promise = new Promise(function(t, e) {
                        r._resolve = t, r._reject = e;
                    });
                    var o = e.popupWindowTarget || "_blank", s = e.popupWindowFeatures || "location=no,toolbar=no,width=500,height=500,left=100,top=100;";
                    this._popup = window.open("", o, s), this._popup && (i.Log.debug("PopupWindow.ctor: popup successfully created"), this._checkForPopupClosedTimer = window.setInterval(this._checkForPopupClosed.bind(this), 500));
                }
                return t.prototype.navigate = function t(e) {
                    return this._popup ? e && e.url ? (i.Log.debug("PopupWindow.navigate: Setting URL in popup"), this._id = e.id, this._id && (window["popupCallback_" + e.id] = this._callback.bind(this)), this._popup.focus(), this._popup.window.location = e.url) : (this._error("PopupWindow.navigate: no url provided"), this._error("No url provided")) : this._error("PopupWindow.navigate: Error opening popup window"), this.promise;
                }, t.prototype._success = function t(e) {
                    i.Log.debug("PopupWindow.callback: Successful response from popup window"), this._cleanup(), this._resolve(e);
                }, t.prototype._error = function t(e) {
                    i.Log.error("PopupWindow.error: ", e), this._cleanup(), this._reject(new Error(e));
                }, t.prototype.close = function t() {
                    this._cleanup(!1);
                }, t.prototype._cleanup = function t(e) {
                    i.Log.debug("PopupWindow.cleanup"), window.clearInterval(this._checkForPopupClosedTimer), this._checkForPopupClosedTimer = null, delete window["popupCallback_" + this._id], this._popup && !e && this._popup.close(), this._popup = null;
                }, t.prototype._checkForPopupClosed = function t() {
                    this._popup && !this._popup.closed || this._error("Popup window closed");
                }, t.prototype._callback = function t(e, r) {
                    this._cleanup(r), e ? (i.Log.debug("PopupWindow.callback success"), this._success({
                        url: e
                    })) : (i.Log.debug("PopupWindow.callback: Invalid response from popup"), this._error("Invalid response from popup"));
                }, t.notifyOpener = function t(e, r, n) {
                    if (window.opener) {
                        if (e = e || window.location.href) {
                            var s = o.UrlUtility.parseUrlFragment(e, n);
                            if (s.state) {
                                var a = "popupCallback_" + s.state, u = window.opener[a];
                                u ? (i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"), u(e, r)) : i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener");
                            } else i.Log.warn("PopupWindow.notifyOpener: no state found in response url");
                        }
                    } else i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.");
                }, n(t, [
                    {
                        key: "promise",
                        get: function t() {
                            return this._promise;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.IFrameNavigator = void 0;
            var n = r(0), i = r(44);
            e.IFrameNavigator = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.prototype.prepare = function t(e) {
                    var r = new i.IFrameWindow(e);
                    return Promise.resolve(r);
                }, t.prototype.callback = function t(e) {
                    n.Log.debug("IFrameNavigator.callback");
                    try {
                        return i.IFrameWindow.notifyParent(e), Promise.resolve();
                    } catch (t) {
                        return Promise.reject(t);
                    }
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.IFrameWindow = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0);
            e.IFrameWindow = function() {
                function t(e) {
                    var r = this;
                    !function n(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this._promise = new Promise(function(t, e) {
                        r._resolve = t, r._reject = e;
                    }), this._boundMessageEvent = this._message.bind(this), window.addEventListener("message", this._boundMessageEvent, !1), this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "absolute", this._frame.width = 0, this._frame.height = 0, window.document.body.appendChild(this._frame);
                }
                return t.prototype.navigate = function t(e) {
                    if (e && e.url) {
                        var r = e.silentRequestTimeout || 1e4;
                        i.Log.debug("IFrameWindow.navigate: Using timeout of:", r), this._timer = window.setTimeout(this._timeout.bind(this), r), this._frame.src = e.url;
                    } else this._error("No url provided");
                    return this.promise;
                }, t.prototype._success = function t(e) {
                    this._cleanup(), i.Log.debug("IFrameWindow: Successful response from frame window"), this._resolve(e);
                }, t.prototype._error = function t(e) {
                    this._cleanup(), i.Log.error(e), this._reject(new Error(e));
                }, t.prototype.close = function t() {
                    this._cleanup();
                }, t.prototype._cleanup = function t() {
                    this._frame && (i.Log.debug("IFrameWindow: cleanup"), window.removeEventListener("message", this._boundMessageEvent, !1), window.clearTimeout(this._timer), window.document.body.removeChild(this._frame), this._timer = null, this._frame = null, this._boundMessageEvent = null);
                }, t.prototype._timeout = function t() {
                    i.Log.debug("IFrameWindow.timeout"), this._error("Frame window timed out");
                }, t.prototype._message = function t(e) {
                    if (i.Log.debug("IFrameWindow.message"), this._timer && e.origin === this._origin && e.source === this._frame.contentWindow && "string" == typeof e.data && (e.data.startsWith("http://") || e.data.startsWith("https://"))) {
                        var r = e.data;
                        r ? this._success({
                            url: r
                        }) : this._error("Invalid response from frame");
                    }
                }, t.notifyParent = function t(e) {
                    i.Log.debug("IFrameWindow.notifyParent"), (e = e || window.location.href) && (i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"), window.parent.postMessage(e, location.protocol + "//" + location.host));
                }, n(t, [
                    {
                        key: "promise",
                        get: function t() {
                            return this._promise;
                        }
                    },
                    {
                        key: "_origin",
                        get: function t() {
                            return location.protocol + "//" + location.host;
                        }
                    }
                ]), t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.UserManagerEvents = void 0;
            var n = r(0), i = r(16), o = r(17);
            e.UserManagerEvents = function(t) {
                function e(r) {
                    !function n(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                    var i = function s(t, e) {
                        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !e || "object" != typeof e && "function" != typeof e ? t : e;
                    }(this, t.call(this, r));
                    return i._userLoaded = new o.Event("User loaded"), i._userUnloaded = new o.Event("User unloaded"), i._silentRenewError = new o.Event("Silent renew error"), i._userSignedIn = new o.Event("User signed in"), i._userSignedOut = new o.Event("User signed out"), i._userSessionChanged = new o.Event("User session changed"), i;
                }
                return function r(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
                }(e, t), e.prototype.load = function e(r) {
                    var i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    n.Log.debug("UserManagerEvents.load"), t.prototype.load.call(this, r), i && this._userLoaded.raise(r);
                }, e.prototype.unload = function e() {
                    n.Log.debug("UserManagerEvents.unload"), t.prototype.unload.call(this), this._userUnloaded.raise();
                }, e.prototype.addUserLoaded = function t(e) {
                    this._userLoaded.addHandler(e);
                }, e.prototype.removeUserLoaded = function t(e) {
                    this._userLoaded.removeHandler(e);
                }, e.prototype.addUserUnloaded = function t(e) {
                    this._userUnloaded.addHandler(e);
                }, e.prototype.removeUserUnloaded = function t(e) {
                    this._userUnloaded.removeHandler(e);
                }, e.prototype.addSilentRenewError = function t(e) {
                    this._silentRenewError.addHandler(e);
                }, e.prototype.removeSilentRenewError = function t(e) {
                    this._silentRenewError.removeHandler(e);
                }, e.prototype._raiseSilentRenewError = function t(e) {
                    n.Log.debug("UserManagerEvents._raiseSilentRenewError", e.message), this._silentRenewError.raise(e);
                }, e.prototype.addUserSignedIn = function t(e) {
                    this._userSignedIn.addHandler(e);
                }, e.prototype.removeUserSignedIn = function t(e) {
                    this._userSignedIn.removeHandler(e);
                }, e.prototype._raiseUserSignedIn = function t() {
                    n.Log.debug("UserManagerEvents._raiseUserSignedIn"), this._userSignedIn.raise();
                }, e.prototype.addUserSignedOut = function t(e) {
                    this._userSignedOut.addHandler(e);
                }, e.prototype.removeUserSignedOut = function t(e) {
                    this._userSignedOut.removeHandler(e);
                }, e.prototype._raiseUserSignedOut = function t() {
                    n.Log.debug("UserManagerEvents._raiseUserSignedOut"), this._userSignedOut.raise();
                }, e.prototype.addUserSessionChanged = function t(e) {
                    this._userSessionChanged.addHandler(e);
                }, e.prototype.removeUserSessionChanged = function t(e) {
                    this._userSessionChanged.removeHandler(e);
                }, e.prototype._raiseUserSessionChanged = function t() {
                    n.Log.debug("UserManagerEvents._raiseUserSessionChanged"), this._userSessionChanged.raise();
                }, e;
            }(i.AccessTokenEvents);
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.Timer = void 0;
            var n = function() {
                function t(t, e) {
                    for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                    }
                }
                return function(e, r, n) {
                    return r && t(e.prototype, r), n && t(e, n), e;
                };
            }(), i = r(0), o = r(1), s = r(17);
            function a(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function u(t, e) {
                if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }
            e.Timer = function(t) {
                function e(r) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o.Global.timer, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                    a(this, e);
                    var s = u(this, t.call(this, r));
                    return s._timer = n, s._nowFunc = i || function() {
                        return Date.now() / 1e3;
                    }, s;
                }
                return function r(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
                }(e, t), e.prototype.init = function t(e) {
                    e <= 0 && (e = 1), e = parseInt(e);
                    var r = this.now + e;
                    if (this.expiration === r && this._timerHandle) i.Log.debug("Timer.init timer " + this._name + " skipping initialization since already initialized for expiration:", this.expiration);
                    else {
                        this.cancel(), i.Log.debug("Timer.init timer " + this._name + " for duration:", e), this._expiration = r;
                        var n = 5;
                        e < n && (n = e), this._timerHandle = this._timer.setInterval(this._callback.bind(this), 1e3 * n);
                    }
                }, e.prototype.cancel = function t() {
                    this._timerHandle && (i.Log.debug("Timer.cancel: ", this._name), this._timer.clearInterval(this._timerHandle), this._timerHandle = null);
                }, e.prototype._callback = function e() {
                    var r = this._expiration - this.now;
                    i.Log.debug("Timer.callback; " + this._name + " timer expires in:", r), this._expiration <= this.now && (this.cancel(), t.prototype.raise.call(this));
                }, n(e, [
                    {
                        key: "now",
                        get: function t() {
                            return parseInt(this._nowFunc());
                        }
                    },
                    {
                        key: "expiration",
                        get: function t() {
                            return this._expiration;
                        }
                    }
                ]), e;
            }(s.Event);
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.SilentRenewService = void 0;
            var n = r(0);
            e.SilentRenewService = function() {
                function t(e) {
                    !function r(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this._userManager = e;
                }
                return t.prototype.start = function t() {
                    this._callback || (this._callback = this._tokenExpiring.bind(this), this._userManager.events.addAccessTokenExpiring(this._callback), this._userManager.getUser().then(function(t) {}).catch(function(t) {
                        n.Log.error("SilentRenewService.start: Error from getUser:", t.message);
                    }));
                }, t.prototype.stop = function t() {
                    this._callback && (this._userManager.events.removeAccessTokenExpiring(this._callback), delete this._callback);
                }, t.prototype._tokenExpiring = function t() {
                    var e = this;
                    this._userManager.signinSilent().then(function(t) {
                        n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful");
                    }, function(t) {
                        n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:", t.message), e._userManager.events._raiseSilentRenewError(t);
                    });
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.CordovaPopupNavigator = void 0;
            var n = r(21);
            e.CordovaPopupNavigator = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.prototype.prepare = function t(e) {
                    var r = new n.CordovaPopupWindow(e);
                    return Promise.resolve(r);
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.CordovaIFrameNavigator = void 0;
            var n = r(21);
            e.CordovaIFrameNavigator = function() {
                function t() {
                    !function e(t, r) {
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                    }(this, t);
                }
                return t.prototype.prepare = function t(e) {
                    e.popupWindowFeatures = "hidden=yes";
                    var r = new n.CordovaPopupWindow(e);
                    return Promise.resolve(r);
                }, t;
            }();
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            e.Version = "1.11.5";
        }
    ]);
});

},{}],"e2CH4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "redirectPath", ()=>redirectPath);
parcelHelpers.export(exports, "redirectUri", ()=>redirectUri);
parcelHelpers.export(exports, "silentRedirectPath", ()=>silentRedirectPath);
parcelHelpers.export(exports, "silentRedirectUri", ()=>silentRedirectUri);
var origin = window.location.origin;
var redirectPath = "/auth";
var redirectUri = "".concat(origin).concat(redirectPath);
var silentRedirectPath = "/auth-silent";
var silentRedirectUri = "".concat(origin).concat(silentRedirectPath);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cBVdB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storeSettingsAndReturn", ()=>storeSettingsAndReturn);
parcelHelpers.export(exports, "getSettings", ()=>getSettings);
var _localSettings = require("../../config/localSettings");
var _localSettingsDefault = parcelHelpers.interopDefault(_localSettings);
var URL_SETTINGS = "/settings.json";
var storedSettings = null;
var storeSettingsAndReturn = function(settings) {
    storedSettings = settings;
    return settings;
};
var getSettings = function() {
    if (storedSettings) return Promise.resolve(storedSettings);
    return fetch(URL_SETTINGS).then(function(response) {
        return response.json();
    }).then(function(settings) {
        return storeSettingsAndReturn(settings);
    }).catch(function() {
        return storeSettingsAndReturn((0, _localSettingsDefault.default));
    });
};
exports.default = getSettings;

},{"../../config/localSettings":"bG95R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bG95R":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    apiEndpoint: "https://webapi.beta.passport.transportation.a2z.com",
    oidc_authority: "https://idp-integ.federate.amazon.com",
    oidc_client_id: "trans-passport-integ"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Ux1q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signIn", ()=>signIn);
var _userManager = require("./userManager");
var _userManagerDefault = parcelHelpers.interopDefault(_userManager);
var signIn = function() {
    return (0, _userManagerDefault.default)().then(function(userManager) {
        return userManager.signinSilent().then(function(user) {
            return user;
        }).catch(function() {
            return userManager.signinRedirect();
        });
    });
};
exports.default = signIn;

},{"./userManager":"1VM8f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9jQwn":[function(require,module,exports) {
/* eslint-disable import/no-extraneous-dependencies */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ihmJsCoralClient = require("@amzn/ihm-js-coral-client");
var _csrf = require("@amzn/carrierlogistics-commons/dist/utils/csrf");
var _csrfDefault = parcelHelpers.interopDefault(_csrf);
var _index = require("@amzn/carrierlogistics-commons/dist/constants/index");
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possible_constructor_return(this, result);
    };
}
/*
 * This class is used during client construction, and helps to
 * intercept the headers during request handling for the passport external App.
 */ var RequestOptionsInterceptorForCarrierLogistics = /*#__PURE__*/ function(CoralInterceptor) {
    "use strict";
    _inherits(RequestOptionsInterceptorForCarrierLogistics, CoralInterceptor);
    var _super = _create_super(RequestOptionsInterceptorForCarrierLogistics);
    function RequestOptionsInterceptorForCarrierLogistics() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, RequestOptionsInterceptorForCarrierLogistics);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    _create_class(RequestOptionsInterceptorForCarrierLogistics, [
        {
            /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
            key: "intercept",
            value: function intercept(request, next) {
                // Adding required header
                var headers = [
                    [
                        "Accept",
                        "application/json"
                    ],
                    [
                        "Content-Type",
                        "application/json"
                    ],
                    [
                        (0, _index.CSRF_TOKEN_ID),
                        (0, _csrfDefault.default)()
                    ]
                ];
                var modifiedRequest = request.clone({
                    headers: headers,
                    credentials: "same-origin"
                });
                return (0, _rxjs.from)(next.handle(modifiedRequest)).pipe((0, _operators.map)(function(response) {
                    var responseHeaders = response.headers;
                    return new (0, _ihmJsCoralClient.CoralResponse)(response);
                }));
            }
        }
    ]);
    return RequestOptionsInterceptorForCarrierLogistics;
}((0, _ihmJsCoralClient.CoralInterceptor));
exports.default = RequestOptionsInterceptorForCarrierLogistics;

},{"rxjs":"cdYcx","rxjs/operators":"b5gYA","@amzn/ihm-js-coral-client":"eOj61","@amzn/carrierlogistics-commons/dist/utils/csrf":"3Fofe","@amzn/carrierlogistics-commons/dist/constants/index":"bDvom","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kf9Dc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSiteExternal = require("../../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
var _endpointConfig = require("./endpointConfig");
var getEnv = function() {
    var url = window.location.href;
    var env;
    if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.PASSPORT_WS_CORAL_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.PASSPORT_WS_CORAL_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.PASSPORT_URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.PASSPORT_WS_CORAL_CONFIG).PROD_CONFIG;
    else if (url.includes((0, _endpointConfig.CARRIER_LOGISTICS_URL_PREFIXES).BETA_URL_PREFIX)) env = (0, _endpointConfig.CARRIER_LOGISTICS_WS_CONFIG).BETA_CONFIG;
    else if (url.includes((0, _endpointConfig.CARRIER_LOGISTICS_URL_PREFIXES).GAMMA_URL_PREFIX)) env = (0, _endpointConfig.CARRIER_LOGISTICS_WS_CONFIG).GAMMA_CONFIG;
    else if (url.includes((0, _endpointConfig.CARRIER_LOGISTICS_URL_PREFIXES).PROD_URL_PREFIX)) env = (0, _endpointConfig.CARRIER_LOGISTICS_WS_CONFIG).PROD_CONFIG;
    else if ((0, _isSiteExternalDefault.default)()) env = (0, _endpointConfig.CARRIER_LOGISTICS_WS_CONFIG).LOCAL_DEV;
    else env = (0, _endpointConfig.PASSPORT_WS_CORAL_CONFIG).LOCAL_DEV;
    return env;
};
var envHelper = {
    getEnv: getEnv
};
exports.default = envHelper;

},{"../../utils/isSiteExternal":"9c6XJ","./endpointConfig":"5mYfX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9c6XJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _externalSiteConstants = require("../constants/externalSiteConstants");
var isSiteExternal = function() {
    var url = window.location.href;
    return url.includes((0, _externalSiteConstants.EXTERNAL_PASSPORT_APP_DOMAIN_NAME));
};
exports.default = isSiteExternal;

},{"../constants/externalSiteConstants":"45S06","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"45S06":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EXTERNAL_PASSPORT_APP_DOMAIN_NAME", ()=>EXTERNAL_PASSPORT_APP_DOMAIN_NAME);
var EXTERNAL_PASSPORT_APP_DOMAIN_NAME = "carrierlogistics";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mYfX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PASSPORT_URL_PREFIXES", ()=>PASSPORT_URL_PREFIXES);
parcelHelpers.export(exports, "PASSPORT_WS_CORAL_CONFIG", ()=>PASSPORT_WS_CORAL_CONFIG);
parcelHelpers.export(exports, "CARRIER_LOGISTICS_URL_PREFIXES", ()=>CARRIER_LOGISTICS_URL_PREFIXES);
parcelHelpers.export(exports, "CARRIER_LOGISTICS_WS_CONFIG", ()=>CARRIER_LOGISTICS_WS_CONFIG);
var PASSPORT_URL_PREFIXES = {
    BETA_URL_PREFIX: "beta.passport",
    GAMMA_URL_PREFIX: "gamma.passport",
    PROD_URL_PREFIX: "passport.transportation"
};
var PASSPORT_WS_CORAL_CONFIG = {
    BETA_CONFIG: "Passport.Beta.USAmazon",
    GAMMA_CONFIG: "Passport.Gamma.USAmazon",
    PROD_CONFIG: "Passport.Prod.USAmazon",
    LOCAL_DEV: "Passport.Beta.USAmazon"
};
var CARRIER_LOGISTICS_URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon"
};
var CARRIER_LOGISTICS_WS_CONFIG = {
    BETA_CONFIG: "Carrierlogistics.Beta.USAmazon",
    GAMMA_CONFIG: "Carrierlogistics.Gamma.USAmazon",
    PROD_CONFIG: "Carrierlogistics.Prod.USAmazon",
    LOCAL_DEV: "UI.Testing.Local"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Og5j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSiteExternal = require("./isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
/**
 * Selects module based on the isExternal check.
 * @param externalModule
 * @param internalModule
 * @returns
 */ function externalModulePicker(externalModule, internalModule) {
    if ((0, _isSiteExternalDefault.default)()) return externalModule;
    return internalModule;
}
exports.default = externalModulePicker;

},{"./isSiteExternal":"9c6XJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ipxb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coralComAmazonTransreportscenterservice = require("@amzn/coral_com-amazon-transreportscenterservice");
var _types = require("../actions/types");
var _upload = require("../constants/upload");
var _actions = require("../actions");
/**
 * custom middleware to check authorization on dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */ function completeBulkFileUploadMiddleware(param) {
    var getState = param.getState;
    return function(next) {
        return function(action) {
            var _store_reportsCenter;
            var result = next(action);
            var store = getState();
            var type = action.type;
            var _store_reportsCenter_bulkFilesPartsUpload;
            var bulkFilesPartsUpload = (_store_reportsCenter_bulkFilesPartsUpload = store === null || store === void 0 ? void 0 : (_store_reportsCenter = store.reportsCenter) === null || _store_reportsCenter === void 0 ? void 0 : _store_reportsCenter.bulkFilesPartsUpload) !== null && _store_reportsCenter_bulkFilesPartsUpload !== void 0 ? _store_reportsCenter_bulkFilesPartsUpload : {};
            var bulkFilesKeys = Object.keys(bulkFilesPartsUpload);
            var bulkFilesUploadValues = Object.values(bulkFilesPartsUpload);
            var isBulkFilesPartUploadComplete = bulkFilesKeys.length && bulkFilesUploadValues.every(function(val) {
                return val.status === (0, _upload.UPLOAD_STATUS).SUCCESS;
            });
            if (type === (0, _types.FILE_PARTS_UPLOAD_SUCCESS) && isBulkFilesPartUploadComplete) {
                var completeBatchReportUploadInput = (0, _coralComAmazonTransreportscenterservice.CompleteBatchReportUploadInput).clone({
                    logisticsPartyId: bulkFilesUploadValues[0].logisticsPartyId,
                    reportType: bulkFilesUploadValues[0].reportType,
                    term: bulkFilesUploadValues[0].term,
                    CompleteUploadRequestList: (0, _coralComAmazonTransreportscenterservice.CompleteUploadRequestList).fromJson(bulkFilesUploadValues.map(function(bulkFilesUploadValue) {
                        return (0, _coralComAmazonTransreportscenterservice.CompleteUploadRequest).clone({
                            key: bulkFilesUploadValue.key,
                            uploadId: bulkFilesUploadValue.uploadId,
                            supportingDocumentInfo: bulkFilesUploadValue.supportingDocumentInfo,
                            eTags: bulkFilesUploadValue.eTags,
                            reportId: bulkFilesUploadValue.reportId
                        });
                    }))
                });
                return next((0, _actions.completeBulkUploadFilesAction).request({
                    completeBatchReportUploadInput: completeBatchReportUploadInput
                }));
            }
            return result;
        };
    };
}
exports.default = completeBulkFileUploadMiddleware;

},{"@amzn/coral_com-amazon-transreportscenterservice":"j45ae","../actions/types":"20R3C","../constants/upload":"lSFPs","../actions":"4lbye","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gPaS8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSideNavMenuItems", ()=>useSideNavMenuItems);
var _authorisation = require("@amzn/carrierlogistics-commons/dist/hooks/authorisation");
var _lodash = require("lodash");
var _useTermReportsConfig = require("./useTermReportsConfig");
var _useTermReportsConfigDefault = parcelHelpers.interopDefault(_useTermReportsConfig);
var _routes = require("../constants/routes");
var _authorization = require("../constants/authorization");
var _isSiteExternal = require("../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
var _dist = require("@amzn/LogisticPartyHelperLib/dist");
var _constants = require("../constants");
var _endpointConfig = require("../config/env/endpointConfig");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
var getSideMenuNavItems = function(termReportConfigList) {
    return termReportConfigList.map(function(termReportConfig) {
        // In case of report sharing, if user is not authorized for term
        // Below isAuthorized true for children report types is to handle the case when user has access to the term
        // Else if term's isAuthorized is false then all children is automatically disabled by UI component
        var children = termReportConfig === null || termReportConfig === void 0 ? void 0 : termReportConfig.reportConfigList.map(function(reportConfig) {
            var _reportConfig_isExternalAllowed;
            return {
                link: "".concat((0, _routes.REPORTS_SHARING_PATH_PREFIX), "/").concat(termReportConfig.termUrlPath, "/").concat(reportConfig.reportTypeUrlPath),
                label: reportConfig.reportTypeDisplayName,
                children: false,
                isAuthorized: true,
                isExternalAllowed: (_reportConfig_isExternalAllowed = reportConfig === null || reportConfig === void 0 ? void 0 : reportConfig.isExternalAllowed) !== null && _reportConfig_isExternalAllowed !== void 0 ? _reportConfig_isExternalAllowed : true
            };
        });
        return {
            label: termReportConfig.termDisplayName,
            link: "".concat((0, _routes.REPORTS_SHARING_PATH_PREFIX), "/").concat(termReportConfig.termUrlPath),
            pamPermKey: termReportConfig.term,
            children: true,
            childNodes: children,
            hide: false
        };
    });
};
var useSideNavMenuItems = function() {
    var termReportConfigs = (0, _useTermReportsConfigDefault.default)().termReportConfigs;
    var sideMenuNavItems = getSideMenuNavItems(termReportConfigs);
    if ((0, _isSiteExternalDefault.default)()) {
        var authorizedEntities = (0, _authorisation.useAuthorisedEntities)();
        var lpSelected = (0, _authorisation.useSelectedLp)();
        var entitiesWithPermissions = sideMenuNavItems.map(function(_param) {
            var config = _extends({}, _object_destructuring_empty(_param));
            var _authorizedEntities_config_pamPermKey, _authorizedEntities_lpSelected_lpId, _config_childNodes;
            if ((0, _lodash.isEmpty)(lpSelected)) return _object_spread({
                isAuthorized: false
            }, config);
            var url = window.location.href;
            var authorisedLPForSPPerformance = url.includes((0, _endpointConfig.CARRIER_LOGISTICS_URL_PREFIXES).BETA_URL_PREFIX) ? (0, _authorization.AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA) : (0, _authorization.AUTHORIZED_LP_FOR_SP_PERFORMANCE);
            // temp change for beta testing wil be replaced by AUTHORIZED_LP_FOR_SP_PERFORMANCE
            if (config.pamPermKey === (0, _constants.SP_PERFORMANCE_MANAGEMENT) && lpSelected.lpId !== authorisedLPForSPPerformance) return _object_spread({
                isAuthorized: false
            }, config);
            var isAuthorized = (authorizedEntities === null || authorizedEntities === void 0 ? void 0 : (_authorizedEntities_config_pamPermKey = authorizedEntities[config.pamPermKey]) === null || _authorizedEntities_config_pamPermKey === void 0 ? void 0 : _authorizedEntities_config_pamPermKey.length) && (authorizedEntities === null || authorizedEntities === void 0 ? void 0 : (_authorizedEntities_lpSelected_lpId = authorizedEntities[lpSelected.lpId]) === null || _authorizedEntities_lpSelected_lpId === void 0 ? void 0 : _authorizedEntities_lpSelected_lpId.includes((0, _authorization.AUTHORIZATION).ACCESS));
            // Filter out report types which are not allowed for external flow
            return _object_spread_props(_object_spread({
                isAuthorized: isAuthorized
            }, config), {
                childNodes: config === null || config === void 0 ? void 0 : (_config_childNodes = config.childNodes) === null || _config_childNodes === void 0 ? void 0 : _config_childNodes.filter(function(cNode) {
                    return cNode.isExternalAllowed;
                })
            });
        });
        return {
            sideMenuNavItems: entitiesWithPermissions
        };
    }
    //TODO: temp change will be deprecated once we are able to give permission based on report type
    var authorizedLps = (0, _dist.useAuthorizedLogisticParties)((0, _constants.SP_PERFORMANCE_MANAGEMENT), true).authorizedLps;
    var desiredLP = authorizedLps === null || authorizedLps === void 0 ? void 0 : authorizedLps.find(function(lp) {
        return lp.logisticsPartyId === (0, _authorization.AUTHORIZED_LP_FOR_SP_PERFORMANCE);
    });
    var filteredSideNavItems = (sideMenuNavItems === null || sideMenuNavItems === void 0 ? void 0 : sideMenuNavItems.filter(function(sideNavItem) {
        return sideNavItem.pamPermKey !== (0, _constants.SP_PERFORMANCE_MANAGEMENT);
    })) || [
        {}
    ];
    if (!(0, _lodash.isEmpty)(authorizedLps) && !desiredLP && !(0, _lodash.isEmpty)(filteredSideNavItems)) return {
        sideMenuNavItems: filteredSideNavItems
    };
    return {
        sideMenuNavItems: sideMenuNavItems
    };
};
exports.default = useSideNavMenuItems;

},{"@amzn/carrierlogistics-commons/dist/hooks/authorisation":"jz3IT","lodash":"iqbfx","./useTermReportsConfig":"3OK2w","../constants/routes":"7ZcBY","../constants/authorization":"7ZoYs","../utils/isSiteExternal":"9c6XJ","@amzn/LogisticPartyHelperLib/dist":"47Mku","../constants":"bsj5K","../config/env/endpointConfig":"5mYfX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3OK2w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _react = require("react");
var _selectors = require("../actions/selectors");
var _actions = require("../actions");
var _useApiLoading = require("./useApiLoading");
var _useApiLoadingDefault = parcelHelpers.interopDefault(_useApiLoading);
var _types = require("../actions/types");
var useTermReportsConfig = function() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var termReportConfigs = (0, _reactRedux.useSelector)((0, _selectors.termReportConfigsSelector));
    var getTermReportConfigsError = (0, _reactRedux.useSelector)((0, _selectors.getTermReportConfigsErrorSelector));
    var _useApiLoading = (0, _useApiLoadingDefault.default)((0, _types.GET_TERM_REPORT_CONFIGS_REQUEST)), isGetTermReportsConfigLoading = _useApiLoading.isRequestPending;
    var handleGetTermReportConfigs = (0, _react.useCallback)(function() {
        dispatch((0, _actions.getTermReportConfigs).request());
    }, [
        dispatch
    ]);
    (0, _react.useEffect)(function() {
        if (!(termReportConfigs === null || termReportConfigs === void 0 ? void 0 : termReportConfigs.length) && !getTermReportConfigsError) handleGetTermReportConfigs();
    }, []);
    return {
        termReportConfigs: termReportConfigs,
        handleGetTermReportConfigs: handleGetTermReportConfigs,
        isGetTermReportsConfigLoading: isGetTermReportsConfigLoading,
        getTermReportConfigsError: getTermReportConfigsError
    };
};
exports.default = useTermReportsConfig;

},{"react-redux":"3qqlL","react":"6uln9","../actions/selectors":"ik2T2","../actions":"4lbye","./useApiLoading":"d73qr","../actions/types":"20R3C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ik2T2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportsCenterStateSelector", ()=>reportsCenterStateSelector);
parcelHelpers.export(exports, "generateReportStateSelector", ()=>generateReportStateSelector);
parcelHelpers.export(exports, "lpSelectedSelector", ()=>lpSelectedSelector);
parcelHelpers.export(exports, "termReportConfigsSelector", ()=>termReportConfigsSelector);
parcelHelpers.export(exports, "getTermReportConfigsErrorSelector", ()=>getTermReportConfigsErrorSelector);
parcelHelpers.export(exports, "reportsListSelector", ()=>reportsListSelector);
parcelHelpers.export(exports, "reportsListTotalRecordsSelector", ()=>reportsListTotalRecordsSelector);
parcelHelpers.export(exports, "searchReportsPageSizeSelector", ()=>searchReportsPageSizeSelector);
parcelHelpers.export(exports, "bulkFilesPartsUploadSelector", ()=>bulkFilesPartsUploadSelector);
parcelHelpers.export(exports, "isTriggerSearchReportSelector", ()=>isTriggerSearchReportSelector);
parcelHelpers.export(exports, "currentFolderPathSelector", ()=>currentFolderPathSelector);
parcelHelpers.export(exports, "currentPageSelector", ()=>currentPageSelector);
parcelHelpers.export(exports, "selectedReportsSelector", ()=>selectedReportsSelector);
parcelHelpers.export(exports, "sortCriteriaSelector", ()=>sortCriteriaSelector);
parcelHelpers.export(exports, "getPresignedUrl", ()=>getPresignedUrl);
parcelHelpers.export(exports, "selectDDUList", ()=>selectDDUList);
parcelHelpers.export(exports, "getReportIdGenerated", ()=>getReportIdGenerated);
parcelHelpers.export(exports, "selectIsGenerateReportTriggered", ()=>selectIsGenerateReportTriggered);
parcelHelpers.export(exports, "getPresignedDownloadUrl", ()=>getPresignedDownloadUrl);
parcelHelpers.export(exports, "getCSVData", ()=>getCSVData);
parcelHelpers.export(exports, "isTriggerFetchDataFromPresignedURL", ()=>isTriggerFetchDataFromPresignedURL);
parcelHelpers.export(exports, "reportDetailsSelector", ()=>reportDetailsSelector);
parcelHelpers.export(exports, "filterSheetOpenSelector", ()=>filterSheetOpenSelector);
parcelHelpers.export(exports, "filtersSelector", ()=>filtersSelector);
parcelHelpers.export(exports, "isGetReportDetailsPollingSelector", ()=>isGetReportDetailsPollingSelector);
var _reselect = require("reselect");
var reportsCenterStateSelector = function(state) {
    return state.reportsCenter;
};
var generateReportStateSelector = function(state) {
    return state.generateReport;
};
var lpSelectedSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var lpSelected = param.lpSelected;
    return lpSelected;
});
var termReportConfigsSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(reportsCenterState) {
    var _reportsCenterState_termReportConfigs;
    return (_reportsCenterState_termReportConfigs = reportsCenterState === null || reportsCenterState === void 0 ? void 0 : reportsCenterState.termReportConfigs) !== null && _reportsCenterState_termReportConfigs !== void 0 ? _reportsCenterState_termReportConfigs : [];
});
var getTermReportConfigsErrorSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var getTermReportConfigsError = param.getTermReportConfigsError;
    return getTermReportConfigsError;
});
var reportsListSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var reportsList = param.reportsList;
    return reportsList;
});
var reportsListTotalRecordsSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(reportsCenterState) {
    var _reportsCenterState_reportsListTotalRecords;
    return (_reportsCenterState_reportsListTotalRecords = reportsCenterState === null || reportsCenterState === void 0 ? void 0 : reportsCenterState.reportsListTotalRecords) !== null && _reportsCenterState_reportsListTotalRecords !== void 0 ? _reportsCenterState_reportsListTotalRecords : [];
});
var searchReportsPageSizeSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var searchReportsPageSize = param.searchReportsPageSize;
    return searchReportsPageSize;
});
var bulkFilesPartsUploadSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var bulkFilesPartsUpload = param.bulkFilesPartsUpload;
    return bulkFilesPartsUpload;
});
var isTriggerSearchReportSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var isTriggerSearchReport = param.isTriggerSearchReport;
    return isTriggerSearchReport;
});
var currentFolderPathSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var currentFolderPath = param.currentFolderPath;
    return currentFolderPath;
});
var currentPageSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var currentPage = param.currentPage;
    return currentPage;
});
var selectedReportsSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var selectedReports = param.selectedReports;
    return selectedReports;
});
var sortCriteriaSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var sortCriteria = param.sortCriteria;
    return sortCriteria;
});
var getPresignedUrl = (0, _reselect.createSelector)(generateReportStateSelector, function(param) {
    var presignedURL = param.presignedURL;
    return presignedURL;
});
var selectDDUList = (0, _reselect.createSelector)(generateReportStateSelector, function(param) {
    var dduList = param.dduList;
    return dduList;
});
var getReportIdGenerated = (0, _reselect.createSelector)(generateReportStateSelector, function(param) {
    var reportValue = param.reportValue;
    return reportValue;
});
var selectIsGenerateReportTriggered = (0, _reselect.createSelector)(generateReportStateSelector, function(param) {
    var isTriggerGenerateReport = param.isTriggerGenerateReport;
    return isTriggerGenerateReport;
});
var getPresignedDownloadUrl = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var downloadReportPresignedURL = param.downloadReportPresignedURL;
    return downloadReportPresignedURL;
});
var getCSVData = (0, _reselect.createSelector)(generateReportStateSelector, function(param) {
    var csvData = param.csvData;
    return csvData;
});
var isTriggerFetchDataFromPresignedURL = (0, _reselect.createSelector)(generateReportStateSelector, function(param) {
    var isTriggerFetchDataFromPresignedURL = param.isTriggerFetchDataFromPresignedURL;
    return isTriggerFetchDataFromPresignedURL;
});
var reportDetailsSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var reportDetails = param.reportDetails;
    return reportDetails;
});
var filterSheetOpenSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var filterSheetOpen = param.filterSheetOpen;
    return filterSheetOpen;
});
var filtersSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var filters = param.filters;
    return filters;
});
var isGetReportDetailsPollingSelector = (0, _reselect.createSelector)(reportsCenterStateSelector, function(param) {
    var isGetReportDetailsPolling = param.isGetReportDetailsPolling;
    return isGetReportDetailsPolling;
});

},{"reselect":"1azTt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1azTt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"1JGWC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1JGWC":[function(require,module,exports) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d73qr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _selectors = require("../actions/ui/selectors");
var _apiLoading = require("../utils/apiLoading");
/**
 * Hook for checking if an action is in progress
 *
 * @param {string} action
 * @returns {{
 *  isRequestPending: boolean
 * }}
 */ function useApiLoading(action) {
    var pendingRequests = (0, _reactRedux.useSelector)((0, _selectors.pendingRequestsSelector));
    var call = (0, _apiLoading.getCall)(action);
    var isRequestPending = pendingRequests.includes(call);
    return {
        isRequestPending: isRequestPending
    };
}
exports.default = useApiLoading;

},{"react-redux":"3qqlL","../actions/ui/selectors":"9ww2i","../utils/apiLoading":"53XPt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ww2i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uiSelector", ()=>uiSelector);
parcelHelpers.export(exports, "notificationsSelector", ()=>notificationsSelector);
parcelHelpers.export(exports, "pendingRequestsSelector", ()=>pendingRequestsSelector);
parcelHelpers.export(exports, "openedModalSelector", ()=>openedModalSelector);
parcelHelpers.export(exports, "getFormValue", ()=>getFormValue);
parcelHelpers.export(exports, "getCurrentSelectedTabValue", ()=>getCurrentSelectedTabValue);
var _reselect = require("reselect");
var uiSelector = function(state) {
    return state.ui;
};
var notificationsSelector = (0, _reselect.createSelector)(uiSelector, function(param) {
    var notifications = param.notifications;
    return notifications;
});
var pendingRequestsSelector = (0, _reselect.createSelector)(uiSelector, function(param) {
    var pendingRequests = param.pendingRequests;
    return pendingRequests;
});
var openedModalSelector = (0, _reselect.createSelector)(uiSelector, function(param) {
    var openedModal = param.openedModal;
    return openedModal;
});
var getFormValue = (0, _reselect.createSelector)(uiSelector, function(param) {
    var form = param.form;
    return form;
});
var getCurrentSelectedTabValue = (0, _reselect.createSelector)(uiSelector, function(param) {
    var currentSelectedTab = param.currentSelectedTab;
    return currentSelectedTab;
});

},{"reselect":"1azTt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ZoYs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTHORIZATION", ()=>AUTHORIZATION);
parcelHelpers.export(exports, "AUTHORIZED_LP_FOR_SP_PERFORMANCE", ()=>AUTHORIZED_LP_FOR_SP_PERFORMANCE);
parcelHelpers.export(exports, "AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA", ()=>AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA);
var _coralComAmazonPassportaccessmanagementcore = require("@amzn/coral_com-amazon-passportaccessmanagementcore");
var AUTHORIZATION = {
    ADMIN: (0, _coralComAmazonPassportaccessmanagementcore.Permission).ADMIN,
    ACCESS: (0, _coralComAmazonPassportaccessmanagementcore.Permission).ACCESS
};
var AUTHORIZED_LP_FOR_SP_PERFORMANCE = "amzn1.pa.o.A2ST90WUWNWT4B";
var AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA = "amzn1.pa.o.A3GC6VBS8FRKVN";

},{"@amzn/coral_com-amazon-passportaccessmanagementcore":"6eB7O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"47Mku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthorizedLogisticParties", ()=>(0, _useAuthorizedLogisticPartiesDefault.default));
parcelHelpers.export(exports, "useDeliveryServiceProviderDetails", ()=>(0, _useDeliveryServiceProviderDetailsDefault.default));
parcelHelpers.export(exports, "useDeliveryServiceProviders", ()=>(0, _useDeliveryServiceProvidersDefault.default));
parcelHelpers.export(exports, "useLogisticParties", ()=>(0, _useLogisticPartiesDefault.default));
parcelHelpers.export(exports, "useLogisticPartyDetails", ()=>(0, _useLogisticPartyDetailsDefault.default));
var _useAuthorizedLogisticParties = require("./hooks/useAuthorizedLogisticParties");
var _useAuthorizedLogisticPartiesDefault = parcelHelpers.interopDefault(_useAuthorizedLogisticParties);
var _useDeliveryServiceProviderDetails = require("./hooks/useDeliveryServiceProviderDetails");
var _useDeliveryServiceProviderDetailsDefault = parcelHelpers.interopDefault(_useDeliveryServiceProviderDetails);
var _useDeliveryServiceProviders = require("./hooks/useDeliveryServiceProviders");
var _useDeliveryServiceProvidersDefault = parcelHelpers.interopDefault(_useDeliveryServiceProviders);
var _useLogisticParties = require("./hooks/useLogisticParties");
var _useLogisticPartiesDefault = parcelHelpers.interopDefault(_useLogisticParties);
var _useLogisticPartyDetails = require("./hooks/useLogisticPartyDetails");
var _useLogisticPartyDetailsDefault = parcelHelpers.interopDefault(_useLogisticPartyDetails);

},{"./hooks/useAuthorizedLogisticParties":"1mFr9","./hooks/useDeliveryServiceProviderDetails":"amiyC","./hooks/useDeliveryServiceProviders":"hC1Nb","./hooks/useLogisticParties":"eHtfr","./hooks/useLogisticPartyDetails":"k6PGF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1mFr9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _lpcontext = require("../context/LPContext");
var _lpcontextDefault = parcelHelpers.interopDefault(_lpcontext);
var _termsObserver = require("../utils/termsObserver");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/**
 * Selects and returns the LPDetails from context
 * @returns {LogisticPartyDetailsList , termsList, isFetchAuthorizedLogisticProvidersLoading}
 */ function useAuthorizedLogisticParties() {
    var term = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", userAuthRequired = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var termKey = "".concat(term, "#").concat(+userAuthRequired);
    var _useState = _sliced_to_array((0, _react.useState)((0, _termsObserver.termsStore)), 2), terms = _useState[0], setTerms = _useState[1];
    var _useContext = (0, _react.useContext)((0, _lpcontextDefault.default)), authorizedLps = _useContext.authorizedLps, isFetchAuthorizedLogisticProvidersLoading = _useContext.isFetchAuthorizedLogisticProvidersLoading;
    (0, _react.useEffect)(function() {
        if (!term && !userAuthRequired || (0, _termsObserver.termsStore).includes(termKey)) return;
        (0, _termsObserver.addTermIntoStore)(termKey);
        setTerms((0, _termsObserver.termsStore));
    }, [
        termKey,
        term,
        userAuthRequired
    ]);
    (0, _react.useEffect)(function() {
        var onTermStoreChange = function onTermStoreChange(updatedTermStore) {
            setTerms(_to_consumable_array(updatedTermStore));
        };
        (0, _termsObserver.subscribeToTermStore)(onTermStoreChange);
        return function() {
            (0, _termsObserver.unsubscribeFromTermStore)(onTermStoreChange);
        };
    }, []);
    var _authorizedLps_termKey;
    return {
        authorizedLps: (_authorizedLps_termKey = authorizedLps[termKey]) !== null && _authorizedLps_termKey !== void 0 ? _authorizedLps_termKey : [],
        terms: terms,
        isFetchAuthorizedLogisticProvidersLoading: isFetchAuthorizedLogisticProvidersLoading
    };
}
exports.default = useAuthorizedLogisticParties;

},{"react":"6uln9","../context/LPContext":"8BeAo","../utils/termsObserver":"8mHTg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8BeAo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var initialContextValue = {
    lps: [],
    dsps: [],
    authorizedLps: {},
    isFetchAuthorizedLogisticProvidersLoading: false,
    isFetchLogisticProvidersLoading: false
};
var LPContext = (0, _react.createContext)(initialContextValue);
exports.default = LPContext;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mHTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "termsStore", ()=>termsStore);
parcelHelpers.export(exports, "subscribeToTermStore", ()=>subscribeToTermStore);
parcelHelpers.export(exports, "addTermIntoStore", ()=>addTermIntoStore);
parcelHelpers.export(exports, "unsubscribeFromTermStore", ()=>unsubscribeFromTermStore);
var termsStore = [];
var termObservers = [];
function subscribeToTermStore(callBack) {
    termObservers.push(callBack);
}
function addTermIntoStore(term) {
    termsStore.push(term);
    termObservers.forEach(function(observer) {
        return observer(termsStore);
    });
}
function unsubscribeFromTermStore(callBack) {
    termObservers = termObservers.filter(function(observer) {
        return observer !== callBack;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"amiyC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useDeliveryServiceProviders = require("./useDeliveryServiceProviders");
var _useDeliveryServiceProvidersDefault = parcelHelpers.interopDefault(_useDeliveryServiceProviders);
/**
 * Wrapper over useDeliveryServiceProviders fn. Filters and provides the details of the required lpId.
 * @param lpId
 * @returns DeliveryServiceProviderDetails
 */ function useDeliveryServiceProviderDetails(dspId) {
    var deliveryServiceProviders = (0, _useDeliveryServiceProvidersDefault.default)();
    var dspDetails = (0, _react.useMemo)(function() {
        return deliveryServiceProviders.find(function(param) {
            var logisticsPartyId = param.logisticsPartyId;
            return logisticsPartyId === dspId;
        });
    }, [
        deliveryServiceProviders,
        dspId
    ]);
    return dspDetails || null;
}
exports.default = useDeliveryServiceProviderDetails;

},{"react":"6uln9","./useDeliveryServiceProviders":"hC1Nb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hC1Nb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _lpcontext = require("../context/LPContext");
var _lpcontextDefault = parcelHelpers.interopDefault(_lpcontext);
/**
 * Selects and returns the LPDetails from context
 * @returns DeliverServiceProviderDetailsList
 */ function useDeliveryServiceProviders() {
    var logisticParties = (0, _react.useContext)((0, _lpcontextDefault.default));
    return logisticParties.dsps;
}
exports.default = useDeliveryServiceProviders;

},{"react":"6uln9","../context/LPContext":"8BeAo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHtfr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _lpcontext = require("../context/LPContext");
var _lpcontextDefault = parcelHelpers.interopDefault(_lpcontext);
/**
 * Selects and returns the LPDetails from context
 * @returns LogisticPartyDetailsList
 */ function useLogisticParties() {
    var logisticParties = (0, _react.useContext)((0, _lpcontextDefault.default));
    return logisticParties.lps;
}
exports.default = useLogisticParties;

},{"react":"6uln9","../context/LPContext":"8BeAo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6PGF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useDeliveryServiceProviders = require("./useDeliveryServiceProviders");
var _useDeliveryServiceProvidersDefault = parcelHelpers.interopDefault(_useDeliveryServiceProviders);
var _useLogisticParties = require("./useLogisticParties");
var _useLogisticPartiesDefault = parcelHelpers.interopDefault(_useLogisticParties);
/**
 * Wrapper over useLogisticParties fn. Filters and provides the details of the required lpId.
 * @param lpId
 * @returns LogisticPartyDetails
 */ function useLogisticPartyDetails(lpId) {
    var logisticParties = (0, _useLogisticPartiesDefault.default)();
    var deliveryServiceProviders = (0, _useDeliveryServiceProvidersDefault.default)();
    var logisticPartyDetails = (0, _react.useMemo)(function() {
        return logisticParties.find(function(param) {
            var logisticsPartyId = param.logisticsPartyId;
            return logisticsPartyId === lpId;
        });
    }, [
        logisticParties,
        lpId
    ]);
    var deliveryServiceProviderDetails = (0, _react.useMemo)(function() {
        return deliveryServiceProviders.find(function(param) {
            var logisticsPartyId = param.logisticsPartyId;
            return logisticsPartyId === lpId;
        });
    }, [
        logisticParties,
        lpId
    ]);
    return logisticPartyDetails || deliveryServiceProviderDetails || null;
}
exports.default = useLogisticPartyDetails;

},{"react":"6uln9","./useDeliveryServiceProviders":"hC1Nb","./useLogisticParties":"eHtfr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6IjqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SupportNavMenu", ()=>SupportNavMenu);
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _divider = require("@amzn/meridian/divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _responsive = require("@amzn/meridian/responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _sideMenu = require("@amzn/meridian/side-menu");
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _css = require("@emotion/css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _sideMenuNavItems = require("../config/sideMenuNavItems");
var _feedbackModule = require("../containers/FeedbackModule");
var _feedbackModuleDefault = parcelHelpers.interopDefault(_feedbackModule);
var _inlineHelpModule = require("../containers/InlineHelpModule");
var _inlineHelpModuleDefault = parcelHelpers.interopDefault(_inlineHelpModule);
const SupportNavMenu = ()=>{
    const { pathname = "" } = (0, _reactRouterDom.useLocation)();
    const history = (0, _reactRouterDom.useHistory)();
    const handleRouting = (link)=>{
        history.push(link);
    };
    if ((0, _sideMenuNavItems.sideNavSupportItemsExternal)?.every(({ isDisabled })=>isDisabled)) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveDefault.default), {
        query: "min-width",
        props: {
            isSmallScreen: {
                default: true,
                [(0, _breakpoints.DEVICE_WIDTHS).DESKTOP]: false
            }
        }
    }, ({ isSmallScreen })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
            className: (0, _css.css)`
            & {
              padding: 0px;
              padding-top: 1rem;
            }
          `,
            spacingInset: "small",
            spacing: "small",
            alignment: "bottom"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "support"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dividerDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _css.css)`
              & {
                list-style: none;
              }
            `,
            style: {
                listStyle: "none"
            }
        }, (0, _sideMenuNavItems.sideNavSupportItemsExternal).map(({ link, isDisabled, label })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
                key: link,
                selected: pathname.includes(link),
                onClick: ()=>handleRouting(link),
                disabled: isDisabled
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
                id: label
            }))), isSmallScreen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
            alignmentVertical: "center",
            spacingInset: "300 0 0 0",
            alignmentHorizontal: "center",
            widths: [
                "40%",
                "8%",
                "40%"
            ]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _feedbackModuleDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _css.css)`
                    width: 2px; 
                    height: 30px;
                    background-color: white; 
                  `
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inlineHelpModuleDefault.default), null)))));
};
exports.default = SupportNavMenu;

},{"@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/meridian/column":"jFRKf","@amzn/meridian/divider":"1prIe","@amzn/meridian/responsive":"l7U3k","@amzn/meridian/row":"ba4AQ","@amzn/meridian/side-menu":"40yrh","@amzn/meridian/text":"hj2bM","@emotion/css":"awUBr","react":"6uln9","react-intl":"4kbQW","react-router-dom":"5fzqq","../config/sideMenuNavItems":"cekZL","../containers/FeedbackModule":"hGcLv","../containers/InlineHelpModule":"gv7Md","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGcLv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _feedback = require("../constants/feedback");
var _getFeedbackSubmissionURL = require("../utils/getFeedbackSubmissionURL");
var _getFeedbackSubmissionURLDefault = parcelHelpers.interopDefault(_getFeedbackSubmissionURL);
var _feedback1 = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback1);
const FeedbackModule = ()=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _feedbackDefault.default), {
        feedbackIntent: (0, _feedback.intentGeneral),
        applicationId: (0, _feedback.applicationId),
        description: formatMessage({
            id: (0, _feedback.description)
        }),
        feedbackSubmissionPageIdentifier: (0, _getFeedbackSubmissionURLDefault.default),
        confirmationMessage: formatMessage({
            id: (0, _feedback.confirmationMessage)
        }),
        displayMode: "dark"
    });
};
exports.default = FeedbackModule;

},{"react":"6uln9","react-intl":"4kbQW","../constants/feedback":"bgsCt","../utils/getFeedbackSubmissionURL":"14N84","./Feedback":"gkgRH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bgsCt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applicationId", ()=>applicationId);
parcelHelpers.export(exports, "intentGeneral", ()=>intentGeneral);
parcelHelpers.export(exports, "description", ()=>description);
parcelHelpers.export(exports, "confirmationMessage", ()=>confirmationMessage);
const applicationId = "CarrierLogistics";
const intentGeneral = "general";
const description = "feedback.description";
const confirmationMessage = "feedback.confirmation_message";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"14N84":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getFeedbackSubmissionURL() {
    return window.location.url;
}
exports.default = getFeedbackSubmissionURL;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gkgRH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _feedback = require("@amzn/TransCustomerFeedbackAggreatorServiceUIAssets/dist/exportable/feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _carrierLogisticsWebServerClient = require("@amzn/carrier-logistics-common-ui-assets/dist/clients/CarrierLogisticsWebServerClient");
var _carrierLogisticsWebServerClientDefault = parcelHelpers.interopDefault(_carrierLogisticsWebServerClient);
const Feedback = (0, _feedbackDefault.default)({
    client: (0, _carrierLogisticsWebServerClientDefault.default)
});
exports.default = Feedback;

},{"@amzn/TransCustomerFeedbackAggreatorServiceUIAssets/dist/exportable/feedback":"iT0DF","@amzn/carrier-logistics-common-ui-assets/dist/clients/CarrierLogisticsWebServerClient":"k0dpX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iT0DF":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("115c017034f2150a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _Feedback = _interopRequireDefault(require("c094f3d8fd299de1"));
var _TransCustomerFeedbackAggreatorServiceClient = require("b3ffad9688bbd067");
/** @typedef {import("@amzn/ihm-js-coral-client").CoralClientConfigFactory} CoralClientConfigFactory */ /** @typedef {import("@amzn/ihm-js-coral-client").CoralInterceptor} CoralInterceptor */ /**
 * Get the Feedback entry point after initializing the js client
 *
 * @param {{
 *    env: string,
 *    requestOptionsInterceptor: CoralInterceptor,
 *    client: any
 * }} clientOptions - JS client options for initializing the js client
 */ var feedback = function feedback(clientOptions) {
    // Initialize the service client
    var env = clientOptions.env, requestOptionsInterceptor = clientOptions.requestOptionsInterceptor, client = clientOptions.client;
    if (client) (0, _TransCustomerFeedbackAggreatorServiceClient.initCustomClient)(client);
    else (0, _TransCustomerFeedbackAggreatorServiceClient.initTransCustomerFeedbackAggreatorServiceClient)(env, requestOptionsInterceptor);
    return _Feedback["default"];
};
var _default = exports["default"] = feedback;

},{"115c017034f2150a":"bm29M","c094f3d8fd299de1":"fr9Nn","b3ffad9688bbd067":"kHzyo"}],"bm29M":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fr9Nn":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1269352125bbff6b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("7d092b042fa10eeb"));
var _propTypes = _interopRequireDefault(require("4f390bd31214f563"));
var _noop = _interopRequireDefault(require("7fe42e38d45afb98"));
var _FeedbackResponseState = require("5418b426c7aef4a9");
var _FeedbackQuestionsState = require("4a633a16e55867c8");
var _UIState = require("fd5de0056830c16a");
var _FeedbackConstants = require("2b38c03293c77b2c");
var _FeedbackForm = _interopRequireDefault(require("eeb5fc0bea9663cd"));
/**
 * This will be the entry point of the feedback service for host applications.
 * @param {string} intent - Intent of feedback, can be general or triggered. This is a required prop
 * @param {string} title - represents the title of the feedback form. Default value will be used if not provided as prop
 * @param {string} confirmationMessage - represents the confirmation message of feedback submission. Default value will be used if not provided as prop
 * @param {string} submitButtonSize - represents the size of the submit button on feedback form. Default value will be used if not provided as prop
 * @param {string} submitButtonType - represents the type of the submit button on feedback form. Default value will be used if not provided as prop
 * @param {string} submitButtonText - represents the text of the submit button on feedback form. Default value will be used if not provided as prop
 * @param {string} applicationId - The application Id where the feedback module is integrated
 * @param {string} feedbackSubmissionPageIdentifier - The identifier of the page from which feedback was submitted
 * @param {string} displayMode - flag to control darkMode.
 * @param {{ isTriggered: boolean, resetTrigger: () => any }} triggeredObj - Triggered object containing details about when feedback is triggered from outside and how to handle reset
 *
 * @returns - FeedbackForm containing the questionnaire provided and its type will be according to the intent passed.
 */ var Feedback = function Feedback(_ref) {
    var feedbackIntent = _ref.feedbackIntent, title = _ref.title, description = _ref.description, confirmationMessage = _ref.confirmationMessage, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText, applicationId = _ref.applicationId, feedbackSubmissionPageIdentifier = _ref.feedbackSubmissionPageIdentifier, triggeredObj = _ref.triggeredObj, userId = _ref.userId, isSkippable = _ref.isSkippable, prePopulate = _ref.prePopulate, displayMode = _ref.displayMode;
    return /*#__PURE__*/ _react["default"].createElement(_FeedbackQuestionsState.FeedbackQuestionsState, {
        feedbackIntent: feedbackIntent,
        applicationId: applicationId
    }, /*#__PURE__*/ _react["default"].createElement(_FeedbackResponseState.FeedbackResponseState, null, /*#__PURE__*/ _react["default"].createElement(_UIState.UIState, null, /*#__PURE__*/ _react["default"].createElement(_FeedbackForm["default"], {
        title: title,
        feedbackIntent: feedbackIntent,
        description: description,
        confirmationMessage: confirmationMessage,
        submitButtonSize: submitButtonSize,
        submitButtonType: submitButtonType,
        submitButtonText: submitButtonText,
        applicationId: applicationId,
        feedbackSubmissionPageIdentifier: feedbackSubmissionPageIdentifier,
        triggeredObj: triggeredObj,
        userId: userId,
        isSkippable: isSkippable,
        prePopulate: prePopulate,
        displayMode: displayMode
    }))));
};
Feedback.propTypes = {
    feedbackIntent: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string,
    description: _propTypes["default"].string,
    confirmationMessage: _propTypes["default"].string,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string,
    applicationId: _propTypes["default"].string.isRequired,
    feedbackSubmissionPageIdentifier: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].func
    ]),
    triggeredObj: _propTypes["default"].shape({
        isTriggered: _propTypes["default"].bool.isRequired,
        resetTrigger: _propTypes["default"].func.isRequired
    }),
    userId: _propTypes["default"].string,
    isSkippable: _propTypes["default"].bool,
    prePopulate: _propTypes["default"].object
};
Feedback.defaultProps = {
    title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
    description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
    confirmationMessage: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.confirmationMessage,
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text,
    feedbackSubmissionPageIdentifier: null,
    triggeredObj: {
        isTriggered: false,
        resetTrigger: _noop["default"]
    },
    userId: null,
    isSkippable: true,
    prePopulate: {}
};
var _default = exports["default"] = Feedback;

},{"1269352125bbff6b":"bm29M","7d092b042fa10eeb":"6uln9","4f390bd31214f563":"gJRKl","7fe42e38d45afb98":"lkfGU","5418b426c7aef4a9":"ijvRM","4a633a16e55867c8":"PEhUf","fd5de0056830c16a":"VKPbn","2b38c03293c77b2c":"filWO","eeb5fc0bea9663cd":"jpJWZ"}],"gJRKl":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("fa042016f4e81af")();

},{"fa042016f4e81af":"9uK2v"}],"9uK2v":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("f90aa75cb01dd317");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"f90aa75cb01dd317":"dkoqQ"}],"dkoqQ":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"lkfGU":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"ijvRM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ab07a11d3c435cbe");
var _typeof = require("bc741b4e31c8de77");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FeedbackResponseState = FeedbackResponseState;
exports.updateResponse = exports.feedbackResponse = void 0;
var _slicedToArray2 = _interopRequireDefault(require("8a63d7192e03ea35"));
var _react = _interopRequireWildcard(require("fdd9c3d226688e97"));
var _propTypes = _interopRequireDefault(require("d74803f8965e3025"));
var _feedbackResponse = _interopRequireDefault(require("2e9bf339bbd60b56"));
var _useQuestions2 = _interopRequireDefault(require("f0c6ac251f7cbeb"));
var _getFeedbackResponseInitialState = _interopRequireDefault(require("6e0a59005c0dd225"));
var _response = require("9aee72b54deb6482");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var feedbackResponse = exports.feedbackResponse = /*#__PURE__*/ _react["default"].createContext({
    answers: [],
    isAnonymous: false
});
var updateResponse = exports.updateResponse = /*#__PURE__*/ _react["default"].createContext();
function FeedbackResponseState(_ref) {
    var children = _ref.children;
    var _useQuestions = (0, _useQuestions2["default"])(), questions = _useQuestions.questions;
    var _useReducer = (0, _react.useReducer)(_feedbackResponse["default"], (0, _getFeedbackResponseInitialState["default"])(questions)), _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    (0, _react.useEffect)(function() {
        dispatch((0, _response.initializeResponse)(questions));
    }, [
        questions
    ]);
    return /*#__PURE__*/ _react["default"].createElement(feedbackResponse.Provider, {
        value: state
    }, /*#__PURE__*/ _react["default"].createElement(updateResponse.Provider, {
        value: dispatch
    }, children));
}
FeedbackResponseState.propTypes = {
    children: _propTypes["default"].node.isRequired
};

},{"ab07a11d3c435cbe":"bm29M","bc741b4e31c8de77":"8zjpU","8a63d7192e03ea35":"8uMk6","fdd9c3d226688e97":"6uln9","d74803f8965e3025":"gJRKl","2e9bf339bbd60b56":"aOt3v","f0c6ac251f7cbeb":"3eKaA","6e0a59005c0dd225":"91B2Y","9aee72b54deb6482":"azNAp"}],"8zjpU":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"8uMk6":[function(require,module,exports) {
var arrayWithHoles = require("a4c21a15cfb599aa");
var iterableToArrayLimit = require("82b3c8405c738ff8");
var unsupportedIterableToArray = require("8d87992a6979d9ff");
var nonIterableRest = require("bc6df6289dcad16e");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a4c21a15cfb599aa":"jPhVi","82b3c8405c738ff8":"4Z4b0","8d87992a6979d9ff":"bpiPM","bc6df6289dcad16e":"3vFUs"}],"jPhVi":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4Z4b0":[function(require,module,exports) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"bpiPM":[function(require,module,exports) {
var arrayLikeToArray = require("fa4a0776c1c32f8b");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"fa4a0776c1c32f8b":"fMNai"}],"fMNai":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3vFUs":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aOt3v":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ce7594c687367026");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("4d3d0209fa02adc0"));
var _type = require("b6e924866a96fc11");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var feedbackResponseReducer = function feedbackResponseReducer(state, _ref) {
    var type = _ref.type, payload = _ref.payload;
    var currentFeedbackState = state;
    switch(type){
        case _type.SET_STATE:
            return payload;
        case _type.SAVE_RESPONSE:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                answers: currentFeedbackState.answers.map(function(response) {
                    if (response.id === payload.id) return _objectSpread(_objectSpread({}, response), {}, {
                        answer: payload.answer
                    });
                    return response;
                })
            });
        default:
            return currentFeedbackState;
    }
};
var _default = exports["default"] = feedbackResponseReducer;

},{"ce7594c687367026":"bm29M","4d3d0209fa02adc0":"4mibS","b6e924866a96fc11":"aDZxg"}],"4mibS":[function(require,module,exports) {
var toPropertyKey = require("3c6c64132ef25e23");
function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"3c6c64132ef25e23":"cYU33"}],"cYU33":[function(require,module,exports) {
var _typeof = require("753d840f1161cf0e")["default"];
var toPrimitive = require("ac3a06a56d55ba1f");
function _toPropertyKey(arg) {
    var key = toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"753d840f1161cf0e":"8zjpU","ac3a06a56d55ba1f":"3fT7F"}],"3fT7F":[function(require,module,exports) {
var _typeof = require("b0ed600e2d572f4c")["default"];
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b0ed600e2d572f4c":"8zjpU"}],"aDZxg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SET_STATE = exports.SAVE_RESPONSE = void 0;
var SAVE_RESPONSE = exports.SAVE_RESPONSE = "SAVE_RESPONSE";
var SET_STATE = exports.SET_STATE = "SET_STATE";

},{}],"3eKaA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6c47ca85c9b683f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = require("3e8332e778c640ea");
var _FeedbackQuestionsState = _interopRequireDefault(require("1aae1872a2639ee3"));
/** @typedef {import("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1").Questionnaire} Questionnaire */ /**
 * Use questions hook
 *
 * @returns {{ questions: Questionnaire }}
 */ var useQuestions = function useQuestions() {
    var _useContext = (0, _react.useContext)(_FeedbackQuestionsState["default"]), questions = _useContext.questions;
    return {
        questions: questions
    };
};
var _default = exports["default"] = useQuestions;

},{"6c47ca85c9b683f":"bm29M","3e8332e778c640ea":"6uln9","1aae1872a2639ee3":"PEhUf"}],"PEhUf":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b2377914cf50c2e6");
var _typeof = require("89577a5e38b9df6c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.FeedbackQuestionsState = void 0;
var _slicedToArray2 = _interopRequireDefault(require("a1c668403547141e"));
var _noop = _interopRequireDefault(require("528ae33d29b41598"));
var _react = _interopRequireWildcard(require("b9855ba97fc66666"));
var _propTypes = _interopRequireDefault(require("1582a2f6f9fc9823"));
var _feedbackQuestions = _interopRequireDefault(require("fcb8ef363f029b0d"));
var _question = require("d199409bc95bb80d");
var _UIState = _interopRequireDefault(require("a9ed1185df389a8f"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var FeedbackQuestionsContext = /*#__PURE__*/ (0, _react.createContext)({
    questions: [],
    dispatch: _noop["default"]
});
var FeedbackQuestionsState = exports.FeedbackQuestionsState = function FeedbackQuestionsState(_ref) {
    var applicationId = _ref.applicationId, feedbackIntent = _ref.feedbackIntent, children = _ref.children;
    var _useReducer = (0, _react.useReducer)(_feedbackQuestions["default"], []), _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2), questions = _useReducer2[0], dispatch = _useReducer2[1];
    var _useContext = (0, _react.useContext)(_UIState["default"]), uiDispatch = _useContext.dispatch;
    (0, _react.useEffect)(function() {
        if (applicationId && feedbackIntent) (0, _question.getQuestions)(applicationId, feedbackIntent)(dispatch, uiDispatch);
    }, [
        applicationId,
        feedbackIntent
    ]);
    return /*#__PURE__*/ _react["default"].createElement(FeedbackQuestionsContext.Provider, {
        value: {
            questions: questions,
            dispatch: dispatch
        }
    }, children);
};
FeedbackQuestionsState.propTypes = {
    applicationId: _propTypes["default"].string.isRequired,
    feedbackIntent: _propTypes["default"].string.isRequired,
    children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = FeedbackQuestionsContext;

},{"b2377914cf50c2e6":"bm29M","89577a5e38b9df6c":"8zjpU","a1c668403547141e":"8uMk6","528ae33d29b41598":"lkfGU","b9855ba97fc66666":"6uln9","1582a2f6f9fc9823":"gJRKl","fcb8ef363f029b0d":"kUI7j","d199409bc95bb80d":"8PAst","a9ed1185df389a8f":"VKPbn"}],"kUI7j":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _type = require("f5c92162733c9940");
var feedbackQuestionsReducer = function feedbackQuestionsReducer(state, _ref) {
    var type = _ref.type, payload = _ref.payload;
    var currentFeedbackState = state;
    switch(type){
        case _type.UPDATE_QUESTIONNAIRE:
            return payload;
        default:
            return currentFeedbackState;
    }
};
var _default = exports["default"] = feedbackQuestionsReducer;

},{"f5c92162733c9940":"7cZdL"}],"7cZdL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPDATE_QUESTIONNAIRE = void 0;
// eslint-disable-next-line import/prefer-default-export
var UPDATE_QUESTIONNAIRE = exports.UPDATE_QUESTIONNAIRE = "UPDATE_QUESTIONNAIRE";

},{}],"8PAst":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("eeee60fd4c664254");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getQuestions = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("8d3bc65168a0d2b"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("cbe30e96b03e9e8c");
var _pickBy = _interopRequireDefault(require("ddb39d48ef98425e"));
var _type = require("b63cea162db27d74");
var _TransCustomerFeedbackAggreatorServiceClient = require("e627665c3737e96d");
var _type2 = require("ddaf871cf759b218");
var _FeedbackConstants = require("9653a5a36b474c68");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/** @typedef {{type: string, payload: any}} Action */ /**
 * Get questionnaire request action
 *
 * @param {string} applicationId
 * @param {string} feedbackIntent
 * @returns {(dispatch: Function) => Promise<Action>}
 */ var getQuestions = exports.getQuestions = function getQuestions(applicationId, feedbackIntent) {
    return function(dispatch, uiDispatch) {
        var getFeedbackQuestionnaireRequest = _coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireRequest === null || _coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireRequest === void 0 ? void 0 : _coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireRequest.clone({
            applicationId: applicationId,
            feedbackIntent: feedbackIntent
        });
        var client = (0, _TransCustomerFeedbackAggreatorServiceClient.getTransCustomerFeedbackAggreatorServiceClient)();
        uiDispatch({
            type: _type2.IS_GET_QUESTIONS_INPROGRESS,
            payload: true
        });
        return client.getDisplayableFeedbackQuestionnaire(getFeedbackQuestionnaireRequest).toPromise().then(function(_ref) {
            var questionnaire = _ref.questionnaire, display = _ref.display;
            if (feedbackIntent.includes(_FeedbackConstants.CSAT_SURVEY_FEEDBACKINTENT) && !display) uiDispatch({
                type: _type2.IS_SURVEY_ENABLED,
                payload: false
            });
            dispatch({
                type: _type.UPDATE_QUESTIONNAIRE,
                payload: questionnaire.map(function(question) {
                    return _objectSpread(_objectSpread({}, question), {}, {
                        questionType: (0, _pickBy["default"])(question.questionType, function(value) {
                            return value;
                        })
                    });
                })
            });
            uiDispatch({
                type: _type2.IS_GET_QUESTIONS_INPROGRESS,
                payload: false
            });
        })["catch"](function() {
            uiDispatch({
                type: _type2.SHOW_FAILURE_NOTIFICATION
            });
            uiDispatch({
                type: _type2.IS_GET_QUESTIONS_INPROGRESS,
                payload: false
            });
        });
    };
};
var _default = exports["default"] = {
    getQuestions: getQuestions
};

},{"eeee60fd4c664254":"bm29M","8d3bc65168a0d2b":"4mibS","cbe30e96b03e9e8c":"6278u","ddb39d48ef98425e":"kSyL9","b63cea162db27d74":"7cZdL","e627665c3737e96d":"kHzyo","ddaf871cf759b218":"hiJmi","9653a5a36b474c68":"filWO"}],"kSyL9":[function(require,module,exports) {
var arrayMap = require("6c9cbff137866c7a"), baseIteratee = require("c221958ac3849336"), basePickBy = require("b405a5532d203d09"), getAllKeysIn = require("3ba690dd9c0be212");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"6c9cbff137866c7a":"dqjbm","c221958ac3849336":"cImEN","b405a5532d203d09":"6pcdp","3ba690dd9c0be212":"94zjo"}],"dqjbm":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"cImEN":[function(require,module,exports) {
var baseMatches = require("d71b6d83863050d4"), baseMatchesProperty = require("7c9325876607fe2f"), identity = require("8f30439c4119b50d"), isArray = require("c7d501d293035022"), property = require("5d09d6ce03c6871a");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"d71b6d83863050d4":"2aT4B","7c9325876607fe2f":"8qaJB","8f30439c4119b50d":"CfD93","c7d501d293035022":"kvnX5","5d09d6ce03c6871a":"gQia2"}],"2aT4B":[function(require,module,exports) {
var baseIsMatch = require("ae39aa7c64963470"), getMatchData = require("1f43edd665feeec"), matchesStrictComparable = require("e6c511417827f7b5");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"ae39aa7c64963470":"dL63Y","1f43edd665feeec":"5jABy","e6c511417827f7b5":"f8ijr"}],"dL63Y":[function(require,module,exports) {
var Stack = require("f07d3e8d9272e069"), baseIsEqual = require("db40409052d906be");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"f07d3e8d9272e069":"56gsC","db40409052d906be":"idk7X"}],"56gsC":[function(require,module,exports) {
var ListCache = require("748e682f467a07c5"), stackClear = require("7f40f3fcc826bdb4"), stackDelete = require("e8bc69b9a16d3b3b"), stackGet = require("6131162b329ba529"), stackHas = require("49181391bab7fa7d"), stackSet = require("e4d2c6567929f63");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"748e682f467a07c5":"iaNZS","7f40f3fcc826bdb4":"8kfII","e8bc69b9a16d3b3b":"57wUN","6131162b329ba529":"4yyA1","49181391bab7fa7d":"6178f","e4d2c6567929f63":"gsV1O"}],"iaNZS":[function(require,module,exports) {
var listCacheClear = require("e4bb39d676bb9ac9"), listCacheDelete = require("8ec3353721460e58"), listCacheGet = require("7db95efc69155a71"), listCacheHas = require("afb5baf5d782b055"), listCacheSet = require("201187370ea67981");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"e4bb39d676bb9ac9":"8spNa","8ec3353721460e58":"7X0pS","7db95efc69155a71":"8P9G4","afb5baf5d782b055":"6UTpC","201187370ea67981":"4KD39"}],"8spNa":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"7X0pS":[function(require,module,exports) {
var assocIndexOf = require("2ac0e2b29721e831");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"2ac0e2b29721e831":"7sq1C"}],"7sq1C":[function(require,module,exports) {
var eq = require("4cce2a66ccc402cd");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"4cce2a66ccc402cd":"4xJYV"}],"4xJYV":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"8P9G4":[function(require,module,exports) {
var assocIndexOf = require("153297c7f4e74943");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"153297c7f4e74943":"7sq1C"}],"6UTpC":[function(require,module,exports) {
var assocIndexOf = require("6d1d65caa0f0f1ab");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"6d1d65caa0f0f1ab":"7sq1C"}],"4KD39":[function(require,module,exports) {
var assocIndexOf = require("c02e1a1b75010a8a");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"c02e1a1b75010a8a":"7sq1C"}],"8kfII":[function(require,module,exports) {
var ListCache = require("8b53d6e4ed546a57");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8b53d6e4ed546a57":"iaNZS"}],"57wUN":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"4yyA1":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"6178f":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"gsV1O":[function(require,module,exports) {
var ListCache = require("81308222434abc77"), Map = require("d52563ad4cbfd2e3"), MapCache = require("52c65cd36c69c469");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"81308222434abc77":"iaNZS","d52563ad4cbfd2e3":"45F64","52c65cd36c69c469":"ccvum"}],"45F64":[function(require,module,exports) {
var getNative = require("c42ec375a28ca109"), root = require("47b369834897c962");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"c42ec375a28ca109":"4J4bz","47b369834897c962":"cgh9e"}],"4J4bz":[function(require,module,exports) {
var baseIsNative = require("1106d666d24fb1e"), getValue = require("e6f2be9c68f644c7");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"1106d666d24fb1e":"feQfI","e6f2be9c68f644c7":"7QZvl"}],"feQfI":[function(require,module,exports) {
var isFunction = require("7f45e9df08643b2"), isMasked = require("d0acdb4d5db22db1"), isObject = require("31af7b54ae061bab"), toSource = require("d14c3bf4a728e5b0");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"7f45e9df08643b2":"5PtLv","d0acdb4d5db22db1":"8AAw0","31af7b54ae061bab":"bq7Fv","d14c3bf4a728e5b0":"dNjTV"}],"5PtLv":[function(require,module,exports) {
var baseGetTag = require("b052176f7a010b61"), isObject = require("eb2db56e0c4f388f");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"b052176f7a010b61":"6D8Tw","eb2db56e0c4f388f":"bq7Fv"}],"6D8Tw":[function(require,module,exports) {
var Symbol = require("8921346c477058bf"), getRawTag = require("4187160847a3e0c2"), objectToString = require("34167bbe6ea65800");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"8921346c477058bf":"2AYXZ","4187160847a3e0c2":"hgs6S","34167bbe6ea65800":"hnDbr"}],"2AYXZ":[function(require,module,exports) {
var root = require("8569cafea6a868e1");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"8569cafea6a868e1":"cgh9e"}],"cgh9e":[function(require,module,exports) {
var freeGlobal = require("31c9dbf8e961ba09");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"31c9dbf8e961ba09":"kLzcM"}],"kLzcM":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"hgs6S":[function(require,module,exports) {
var Symbol = require("ea6719c6e47b1e6");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"ea6719c6e47b1e6":"2AYXZ"}],"hnDbr":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"bq7Fv":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"8AAw0":[function(require,module,exports) {
var coreJsData = require("58e39facb7ab64e2");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"58e39facb7ab64e2":"sRY4G"}],"sRY4G":[function(require,module,exports) {
var root = require("1e29fba65e8d05cc");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"1e29fba65e8d05cc":"cgh9e"}],"dNjTV":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"7QZvl":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"ccvum":[function(require,module,exports) {
var mapCacheClear = require("aa282ac983bf0f22"), mapCacheDelete = require("3e1617659e847c10"), mapCacheGet = require("76f74c36071b5e3"), mapCacheHas = require("d4f4436ff693899f"), mapCacheSet = require("c3ef643e1e228c89");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"aa282ac983bf0f22":"l58QG","3e1617659e847c10":"dE5HW","76f74c36071b5e3":"dc3LV","d4f4436ff693899f":"Dq9MW","c3ef643e1e228c89":"iBe2Q"}],"l58QG":[function(require,module,exports) {
var Hash = require("49ba1a1e40fa8b39"), ListCache = require("37e380b166b66510"), Map = require("c3d48cfe351e492f");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"49ba1a1e40fa8b39":"bN4NW","37e380b166b66510":"iaNZS","c3d48cfe351e492f":"45F64"}],"bN4NW":[function(require,module,exports) {
var hashClear = require("9e4a882fb05446a9"), hashDelete = require("7149e17e6938226a"), hashGet = require("f5ca3aabb2a44dec"), hashHas = require("933bcbc867138816"), hashSet = require("9a830cee2cdcba8c");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"9e4a882fb05446a9":"9z1LY","7149e17e6938226a":"kkPHl","f5ca3aabb2a44dec":"k1bcJ","933bcbc867138816":"lF5b6","9a830cee2cdcba8c":"lCF57"}],"9z1LY":[function(require,module,exports) {
var nativeCreate = require("a0ed0d086e1fcd6e");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"a0ed0d086e1fcd6e":"VPwR0"}],"VPwR0":[function(require,module,exports) {
var getNative = require("54470f6234408bbd");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"54470f6234408bbd":"4J4bz"}],"kkPHl":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"k1bcJ":[function(require,module,exports) {
var nativeCreate = require("4b037562942a8a8f");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"4b037562942a8a8f":"VPwR0"}],"lF5b6":[function(require,module,exports) {
var nativeCreate = require("b7ec6fed3bdedee9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"b7ec6fed3bdedee9":"VPwR0"}],"lCF57":[function(require,module,exports) {
var nativeCreate = require("f07e326dd57f878");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"f07e326dd57f878":"VPwR0"}],"dE5HW":[function(require,module,exports) {
var getMapData = require("c8b066b68b709a61");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"c8b066b68b709a61":"bx0rc"}],"bx0rc":[function(require,module,exports) {
var isKeyable = require("2cf3664bb308d8a6");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"2cf3664bb308d8a6":"jZvvN"}],"jZvvN":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"dc3LV":[function(require,module,exports) {
var getMapData = require("ae510e9f823f3c25");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"ae510e9f823f3c25":"bx0rc"}],"Dq9MW":[function(require,module,exports) {
var getMapData = require("f987ae3fd447acda");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"f987ae3fd447acda":"bx0rc"}],"iBe2Q":[function(require,module,exports) {
var getMapData = require("fdd87bc99430e799");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"fdd87bc99430e799":"bx0rc"}],"idk7X":[function(require,module,exports) {
var baseIsEqualDeep = require("ae70305acd3efbec"), isObjectLike = require("c848c0114ef10df0");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"ae70305acd3efbec":"ffxnK","c848c0114ef10df0":"gQWyY"}],"ffxnK":[function(require,module,exports) {
var Stack = require("db904d35351dbd8d"), equalArrays = require("ae2fb0036090178a"), equalByTag = require("93da1c0808355a10"), equalObjects = require("7da45d2e3df70044"), getTag = require("f052872c9471557b"), isArray = require("4f592d551a48a163"), isBuffer = require("f7c85c92c69b23ba"), isTypedArray = require("bc9dd600dda44b3f");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"db904d35351dbd8d":"56gsC","ae2fb0036090178a":"5D03w","93da1c0808355a10":"5Bvbu","7da45d2e3df70044":"eI0wW","f052872c9471557b":"dFKXM","4f592d551a48a163":"kvnX5","f7c85c92c69b23ba":"7PenP","bc9dd600dda44b3f":"apyud"}],"5D03w":[function(require,module,exports) {
var SetCache = require("5846b890bf796071"), arraySome = require("6f0d629bda405a8e"), cacheHas = require("dab2394e8da4a653");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"5846b890bf796071":"iE7ct","6f0d629bda405a8e":"1jqVq","dab2394e8da4a653":"aeHzY"}],"iE7ct":[function(require,module,exports) {
var MapCache = require("cd0192eda23cfc28"), setCacheAdd = require("2eba61140614405c"), setCacheHas = require("2eb59b561c368f1c");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"cd0192eda23cfc28":"ccvum","2eba61140614405c":"3Byrt","2eb59b561c368f1c":"15rdY"}],"3Byrt":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"15rdY":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"1jqVq":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"aeHzY":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"5Bvbu":[function(require,module,exports) {
var Symbol = require("43d5734ae976e7cb"), Uint8Array = require("ef58ff1182a2a38f"), eq = require("cfbe41fc7d95f5cd"), equalArrays = require("4b59e35849436e6"), mapToArray = require("822154a2a2d5295"), setToArray = require("64a3e08cbd305c22");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"43d5734ae976e7cb":"2AYXZ","ef58ff1182a2a38f":"lxmew","cfbe41fc7d95f5cd":"4xJYV","4b59e35849436e6":"5D03w","822154a2a2d5295":"7nv4n","64a3e08cbd305c22":"cRttb"}],"lxmew":[function(require,module,exports) {
var root = require("cca301c594df2be");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"cca301c594df2be":"cgh9e"}],"7nv4n":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"cRttb":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"eI0wW":[function(require,module,exports) {
var getAllKeys = require("e91823c0d70af3bb");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"e91823c0d70af3bb":"h6MTf"}],"h6MTf":[function(require,module,exports) {
var baseGetAllKeys = require("52e119f06b1589"), getSymbols = require("d679ccccdd523263"), keys = require("575f1d21dbd17e36");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"52e119f06b1589":"4djmM","d679ccccdd523263":"br276","575f1d21dbd17e36":"u8A7t"}],"4djmM":[function(require,module,exports) {
var arrayPush = require("7e9d11fc5d9f46da"), isArray = require("6c41abad7b064e05");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"7e9d11fc5d9f46da":"fq6Gf","6c41abad7b064e05":"kvnX5"}],"fq6Gf":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"kvnX5":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"br276":[function(require,module,exports) {
var arrayFilter = require("4e2ef7de288cfe58"), stubArray = require("272800204c569a88");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"4e2ef7de288cfe58":"d0C6n","272800204c569a88":"U7oNd"}],"d0C6n":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"U7oNd":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"u8A7t":[function(require,module,exports) {
var arrayLikeKeys = require("6476d24083d32e79"), baseKeys = require("abeb09697efcb56c"), isArrayLike = require("a9c1243706b1a2fa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"6476d24083d32e79":"gvKED","abeb09697efcb56c":"isdgQ","a9c1243706b1a2fa":"9TOQ7"}],"gvKED":[function(require,module,exports) {
var baseTimes = require("8ea883f300ed6649"), isArguments = require("8977097ab97159da"), isArray = require("fc65cee69bcb4df"), isBuffer = require("db8e61d7912bf6a7"), isIndex = require("330d792d5c85a17a"), isTypedArray = require("db0e09424fc32abb");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"8ea883f300ed6649":"8b3YC","8977097ab97159da":"au1Ez","fc65cee69bcb4df":"kvnX5","db8e61d7912bf6a7":"7PenP","330d792d5c85a17a":"ed9t2","db0e09424fc32abb":"apyud"}],"8b3YC":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"au1Ez":[function(require,module,exports) {
var baseIsArguments = require("d4fe9fd3635eb29b"), isObjectLike = require("e07dfe50aa0d86f4");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"d4fe9fd3635eb29b":"2D6Sw","e07dfe50aa0d86f4":"gQWyY"}],"2D6Sw":[function(require,module,exports) {
var baseGetTag = require("a739ea050dfdf56e"), isObjectLike = require("f4441a68cca0b397");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"a739ea050dfdf56e":"6D8Tw","f4441a68cca0b397":"gQWyY"}],"gQWyY":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"7PenP":[function(require,module,exports) {
var root = require("b3296a507f183fca"), stubFalse = require("480e0c6218efdf2c");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"b3296a507f183fca":"cgh9e","480e0c6218efdf2c":"6rMEX"}],"6rMEX":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"ed9t2":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"apyud":[function(require,module,exports) {
var baseIsTypedArray = require("8d4bd70b60a6e305"), baseUnary = require("1c7c1317bef91c6e"), nodeUtil = require("cd795d469539a1e");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"8d4bd70b60a6e305":"iRvld","1c7c1317bef91c6e":"360pV","cd795d469539a1e":"7B5c6"}],"iRvld":[function(require,module,exports) {
var baseGetTag = require("ff9d84c1fc2003ac"), isLength = require("14f4781d968f7b02"), isObjectLike = require("c8c5b1a8b38b0f3b");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"ff9d84c1fc2003ac":"6D8Tw","14f4781d968f7b02":"3BSlg","c8c5b1a8b38b0f3b":"gQWyY"}],"3BSlg":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"360pV":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"7B5c6":[function(require,module,exports) {
var freeGlobal = require("6db29513c9f6d846");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"6db29513c9f6d846":"kLzcM"}],"isdgQ":[function(require,module,exports) {
var isPrototype = require("9e55f777a8e6e7af"), nativeKeys = require("1c013b341d28221b");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"9e55f777a8e6e7af":"aTQBb","1c013b341d28221b":"2Fsou"}],"aTQBb":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"2Fsou":[function(require,module,exports) {
var overArg = require("5e14044853bddd7d");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"5e14044853bddd7d":"hnJFj"}],"hnJFj":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"9TOQ7":[function(require,module,exports) {
var isFunction = require("729d4f6c3a548e88"), isLength = require("813b7baa96f62133");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"729d4f6c3a548e88":"5PtLv","813b7baa96f62133":"3BSlg"}],"dFKXM":[function(require,module,exports) {
var DataView = require("4cb23abfe6c44bd"), Map = require("b7265e93ab712e9d"), Promise = require("46220d032d6a8b9"), Set = require("70c2ebab0556c55c"), WeakMap = require("8b9c348d91bf2e63"), baseGetTag = require("ec282b7f3a17944a"), toSource = require("b7f8dd8417bd380a");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"4cb23abfe6c44bd":"5XKkx","b7265e93ab712e9d":"45F64","46220d032d6a8b9":"6omEM","70c2ebab0556c55c":"lgJjT","8b9c348d91bf2e63":"eKnxO","ec282b7f3a17944a":"6D8Tw","b7f8dd8417bd380a":"dNjTV"}],"5XKkx":[function(require,module,exports) {
var getNative = require("b2a8b4e078b43b1c"), root = require("6e8cf7ddaa3da88d");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"b2a8b4e078b43b1c":"4J4bz","6e8cf7ddaa3da88d":"cgh9e"}],"6omEM":[function(require,module,exports) {
var getNative = require("dbf9c3856d8ac809"), root = require("a4574a5e4ebb121b");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"dbf9c3856d8ac809":"4J4bz","a4574a5e4ebb121b":"cgh9e"}],"lgJjT":[function(require,module,exports) {
var getNative = require("dd0fd75318ecb8f"), root = require("41448e70f8d9f24a");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"dd0fd75318ecb8f":"4J4bz","41448e70f8d9f24a":"cgh9e"}],"eKnxO":[function(require,module,exports) {
var getNative = require("f6e9266ccf9e5667"), root = require("87165c8768a00bdc");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"f6e9266ccf9e5667":"4J4bz","87165c8768a00bdc":"cgh9e"}],"5jABy":[function(require,module,exports) {
var isStrictComparable = require("28dcc1318beacc79"), keys = require("b21efd8513fae192");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"28dcc1318beacc79":"l3NdZ","b21efd8513fae192":"u8A7t"}],"l3NdZ":[function(require,module,exports) {
var isObject = require("b0ffd6383c139199");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"b0ffd6383c139199":"bq7Fv"}],"f8ijr":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"8qaJB":[function(require,module,exports) {
var baseIsEqual = require("4600ff38e62a12af"), get = require("c707d7f568231d08"), hasIn = require("9ba26f6eb32cbf2"), isKey = require("5b491dd2ae361a4f"), isStrictComparable = require("27ad9a2db2ed5499"), matchesStrictComparable = require("4512f5db17ca924f"), toKey = require("bf1c9fdf32929f74");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"4600ff38e62a12af":"idk7X","c707d7f568231d08":"2LlrS","9ba26f6eb32cbf2":"kXrtH","5b491dd2ae361a4f":"kyw9o","27ad9a2db2ed5499":"l3NdZ","4512f5db17ca924f":"f8ijr","bf1c9fdf32929f74":"1ADQ6"}],"2LlrS":[function(require,module,exports) {
var baseGet = require("547af1879b5a7adb");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"547af1879b5a7adb":"19UjV"}],"19UjV":[function(require,module,exports) {
var castPath = require("a5c1d786d6db25ca"), toKey = require("44691e869c2c58d5");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"a5c1d786d6db25ca":"eHeAY","44691e869c2c58d5":"1ADQ6"}],"eHeAY":[function(require,module,exports) {
var isArray = require("bb7c981104ab0b76"), isKey = require("81fd6fcfee72691b"), stringToPath = require("3ef1a581434f317f"), toString = require("6fc9b13f627383f7");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"bb7c981104ab0b76":"kvnX5","81fd6fcfee72691b":"kyw9o","3ef1a581434f317f":"eItch","6fc9b13f627383f7":"bht63"}],"kyw9o":[function(require,module,exports) {
var isArray = require("abf8e0d54bbb615"), isSymbol = require("463be0189b543575");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"abf8e0d54bbb615":"kvnX5","463be0189b543575":"6fjdJ"}],"6fjdJ":[function(require,module,exports) {
var baseGetTag = require("1113862f9f605b72"), isObjectLike = require("247c7ae71f76f4dd");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"1113862f9f605b72":"6D8Tw","247c7ae71f76f4dd":"gQWyY"}],"eItch":[function(require,module,exports) {
var memoizeCapped = require("70d3f4cdb259086b");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"70d3f4cdb259086b":"fjnDL"}],"fjnDL":[function(require,module,exports) {
var memoize = require("1ed2c83cb5d3e166");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"1ed2c83cb5d3e166":"f2Vv7"}],"f2Vv7":[function(require,module,exports) {
var MapCache = require("96f2054f6f1a74b1");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"96f2054f6f1a74b1":"ccvum"}],"bht63":[function(require,module,exports) {
var baseToString = require("f19f2d1aaa3dbf21");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"f19f2d1aaa3dbf21":"82Jle"}],"82Jle":[function(require,module,exports) {
var Symbol = require("bb94a6ce492885fe"), arrayMap = require("b4f93e2a76603f5a"), isArray = require("20fe0fe2c3994538"), isSymbol = require("8ab5938aca4e31d4");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"bb94a6ce492885fe":"2AYXZ","b4f93e2a76603f5a":"dqjbm","20fe0fe2c3994538":"kvnX5","8ab5938aca4e31d4":"6fjdJ"}],"1ADQ6":[function(require,module,exports) {
var isSymbol = require("14120fa3548cbaa2");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"14120fa3548cbaa2":"6fjdJ"}],"kXrtH":[function(require,module,exports) {
var baseHasIn = require("253ca9c969c48b2"), hasPath = require("82565f50ccca3a5f");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"253ca9c969c48b2":"3nyvh","82565f50ccca3a5f":"erwKT"}],"3nyvh":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"erwKT":[function(require,module,exports) {
var castPath = require("12e0b9312faf64a0"), isArguments = require("3751319f3bbe6c9"), isArray = require("75634ba429782b96"), isIndex = require("fc17113ee6cf702a"), isLength = require("aef2e77e122e5a52"), toKey = require("ef06347447e37183");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"12e0b9312faf64a0":"eHeAY","3751319f3bbe6c9":"au1Ez","75634ba429782b96":"kvnX5","fc17113ee6cf702a":"ed9t2","aef2e77e122e5a52":"3BSlg","ef06347447e37183":"1ADQ6"}],"CfD93":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"gQia2":[function(require,module,exports) {
var baseProperty = require("5e6f534ab206227f"), basePropertyDeep = require("73ecfe433706d928"), isKey = require("ad48433e007d1568"), toKey = require("a42608359b213e7c");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"5e6f534ab206227f":"lDGch","73ecfe433706d928":"eKuyV","ad48433e007d1568":"kyw9o","a42608359b213e7c":"1ADQ6"}],"lDGch":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"eKuyV":[function(require,module,exports) {
var baseGet = require("a8e06a48501bc1ed");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"a8e06a48501bc1ed":"19UjV"}],"6pcdp":[function(require,module,exports) {
var baseGet = require("30288cbb7909643b"), baseSet = require("40b04a9b481eaac3"), castPath = require("591e006c3603ffe9");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"30288cbb7909643b":"19UjV","40b04a9b481eaac3":"5Sco1","591e006c3603ffe9":"eHeAY"}],"5Sco1":[function(require,module,exports) {
var assignValue = require("ea2d0eba3d337979"), castPath = require("6613230a888918ca"), isIndex = require("ea5341a8fda5dc7b"), isObject = require("7d5de5342e84299e"), toKey = require("14d261e19f5f1569");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"ea2d0eba3d337979":"FFWpb","6613230a888918ca":"eHeAY","ea5341a8fda5dc7b":"ed9t2","7d5de5342e84299e":"bq7Fv","14d261e19f5f1569":"1ADQ6"}],"FFWpb":[function(require,module,exports) {
var baseAssignValue = require("d16119bebb3b4111"), eq = require("ed58371805b5c115");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"d16119bebb3b4111":"5ht0Y","ed58371805b5c115":"4xJYV"}],"5ht0Y":[function(require,module,exports) {
var defineProperty = require("4f84e33da827f717");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"4f84e33da827f717":"4OZR6"}],"4OZR6":[function(require,module,exports) {
var getNative = require("5cdcd80c1af5eaaa");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"5cdcd80c1af5eaaa":"4J4bz"}],"94zjo":[function(require,module,exports) {
var baseGetAllKeys = require("5a3cea48b7d95458"), getSymbolsIn = require("d67ca4982a7b8691"), keysIn = require("8e7f428a2545134");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"5a3cea48b7d95458":"4djmM","d67ca4982a7b8691":"6ePNR","8e7f428a2545134":"jI1G1"}],"6ePNR":[function(require,module,exports) {
var arrayPush = require("282be241dffcf8b9"), getPrototype = require("4f9b7e1a253de2af"), getSymbols = require("e411de195d63ae21"), stubArray = require("5469971bb302c045");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"282be241dffcf8b9":"fq6Gf","4f9b7e1a253de2af":"agTKZ","e411de195d63ae21":"br276","5469971bb302c045":"U7oNd"}],"agTKZ":[function(require,module,exports) {
var overArg = require("488717089039156d");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"488717089039156d":"hnJFj"}],"jI1G1":[function(require,module,exports) {
var arrayLikeKeys = require("87f2841a779ea0fe"), baseKeysIn = require("f757c34cf809bbac"), isArrayLike = require("e96aadb2e9a05296");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"87f2841a779ea0fe":"gvKED","f757c34cf809bbac":"5yMqT","e96aadb2e9a05296":"9TOQ7"}],"5yMqT":[function(require,module,exports) {
var isObject = require("491db3daa4b85362"), isPrototype = require("b03ffc0ac8e7de2f"), nativeKeysIn = require("afad880d6f9f6ab2");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"491db3daa4b85362":"bq7Fv","b03ffc0ac8e7de2f":"aTQBb","afad880d6f9f6ab2":"jzNMt"}],"jzNMt":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"kHzyo":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9e4aa2f034e8b011");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initTransCustomerFeedbackAggreatorServiceClient = exports.initCustomClient = exports.getTransCustomerFeedbackAggreatorServiceClient = exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("56ba62f21b236fb5"));
var _classCallCheck2 = _interopRequireDefault(require("4f3bebc5760dd478"));
var _inherits2 = _interopRequireDefault(require("46c017c4d5325e81"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("85897110e11e7ff1"));
var _getPrototypeOf2 = _interopRequireDefault(require("18a956b96177d101"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("1f9a7a8f8f342e3");
var _coralConfig_transCustomerFeedbackAggreatorServiceLambda = require("e8841a1ccc0362f5");
var _ihmJsCoralClient = require("1754a24b1ced8188");
var _GetDisplayableFeedbackQuestionnaireResponse = _interopRequireDefault(require("af1eae81647b38ee"));
var _SubmitFeedbackRequest = _interopRequireDefault(require("f6d7fb0d1ca1790"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/** @typedef {import("@amzn/ihm-js-coral-client").CoralClientConfigFactory} CoralClientConfigFactory */ /** @typedef {import("@amzn/ihm-js-coral-client").CoralInterceptor} CoralInterceptor */ var transCustomerFeedbackAggreatorServiceClient = null;
/**
 * Initialize the TransCustomerFeedbackAggreatorServiceLambda client
 *
 * @param {string} env - String env
 * @param {CoralInterceptor} requestOptionsInterceptor - Interceptor
 */ var initTransCustomerFeedbackAggreatorServiceClient = exports.initTransCustomerFeedbackAggreatorServiceClient = function initTransCustomerFeedbackAggreatorServiceClient(env, requestOptionsInterceptor) {
    var clientFactory = new _ihmJsCoralClient.CoralClientFactory([
        _coralConfig_transCustomerFeedbackAggreatorServiceLambda.TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory
    ], env, new _ihmJsCoralClient.InterceptingHandler(new _ihmJsCoralClient.CoralFetchHandler(), [
        _coral_comAmazonTransFeedbackTcfaModelV.transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor,
        requestOptionsInterceptor
    ]));
    /**
   * Custom web server to override serialization/deserialization
   */ var CustomTransCustomerFeedbackAggreatorServiceLambda = /*#__PURE__*/ function(_TransCustomerFeedbac) {
        (0, _inherits2["default"])(CustomTransCustomerFeedbackAggreatorServiceLambda, _TransCustomerFeedbac);
        var _super = _createSuper(CustomTransCustomerFeedbackAggreatorServiceLambda);
        function CustomTransCustomerFeedbackAggreatorServiceLambda(config, handler) {
            var _this;
            (0, _classCallCheck2["default"])(this, CustomTransCustomerFeedbackAggreatorServiceLambda);
            _this = _super.call(this, config, handler);
            _this.handler.handlerChain.interceptor.operations.GetDisplayableFeedbackQuestionnaire.deserializationFn = _GetDisplayableFeedbackQuestionnaireResponse["default"].fromJson;
            _this.handler.handlerChain.interceptor.operations.SubmitFeedback.serializationFn = _SubmitFeedbackRequest["default"].toJson;
            return _this;
        }
        return (0, _createClass2["default"])(CustomTransCustomerFeedbackAggreatorServiceLambda);
    }(_coral_comAmazonTransFeedbackTcfaModelV.TransCustomerFeedbackAggreatorServiceLambda);
    transCustomerFeedbackAggreatorServiceClient = clientFactory.get(CustomTransCustomerFeedbackAggreatorServiceLambda);
};
var initCustomClient = exports.initCustomClient = function initCustomClient(client) {
    transCustomerFeedbackAggreatorServiceClient = client;
};
/**
 * Get the TransCustomerFeedbackAggreatorServiceLambda client if it has been initialized
 *
 * @returns {TransCustomerFeedbackAggreatorServiceLambda}
 */ var getTransCustomerFeedbackAggreatorServiceClient = exports.getTransCustomerFeedbackAggreatorServiceClient = function getTransCustomerFeedbackAggreatorServiceClient() {
    if (!transCustomerFeedbackAggreatorServiceClient) throw new Error("TransCustomerFeedbackAggreatorServiceClient not initialized");
    return transCustomerFeedbackAggreatorServiceClient;
};
var _default = exports["default"] = {
    initTransCustomerFeedbackAggreatorServiceClient: initTransCustomerFeedbackAggreatorServiceClient,
    getTransCustomerFeedbackAggreatorServiceClient: getTransCustomerFeedbackAggreatorServiceClient
};

},{"9e4aa2f034e8b011":"bm29M","56ba62f21b236fb5":"g3oHj","4f3bebc5760dd478":"dIj1v","46c017c4d5325e81":"3rTZc","85897110e11e7ff1":"jxVIQ","18a956b96177d101":"fCXB8","1f9a7a8f8f342e3":"6278u","e8841a1ccc0362f5":"52fXj","1754a24b1ced8188":"eOj61","af1eae81647b38ee":"lJuYp","f6d7fb0d1ca1790":"jLVE8"}],"g3oHj":[function(require,module,exports) {
var toPropertyKey = require("188a4a1704f335f1");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"188a4a1704f335f1":"cYU33"}],"dIj1v":[function(require,module,exports) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3rTZc":[function(require,module,exports) {
var setPrototypeOf = require("ca3674475018bde4");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"ca3674475018bde4":"hbANf"}],"hbANf":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jxVIQ":[function(require,module,exports) {
var _typeof = require("b33fd32119045900")["default"];
var assertThisInitialized = require("d3dc88cae8ea0a2");
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b33fd32119045900":"8zjpU","d3dc88cae8ea0a2":"7Zvgm"}],"7Zvgm":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fCXB8":[function(require,module,exports) {
function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"52fXj":[function(require,module,exports) {
/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transCustomerFeedbackAggreatorServiceLambdaClientConfigFactory = require("./TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory");
parcelHelpers.exportAll(_transCustomerFeedbackAggreatorServiceLambdaClientConfigFactory, exports);

},{"./TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory":"4i4ts","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4i4ts":[function(require,module,exports) {
/* This file was automatically generated by CoralTypeScriptTypesBuildLogic -- do not modify. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory", ()=>TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory);
var _client = require("@amzn/ihm-js-coral-client/client");
const TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory = new (0, _client.CoralClientConfigFactory)("TransCustomerFeedbackAggreatorServiceLambda", {
    "Passport.Prod.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.prod.passport.transportation.a2z.com/tcfa/"
        }
    },
    "Passport.Gamma.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.gamma.passport.transportation.a2z.com/tcfa/"
        }
    },
    "Passport.Beta.USAmazon": {
        httpEndpoint: {
            url: "https://webapi.beta.passport.transportation.a2z.com/tcfa/"
        }
    }
});

},{"@amzn/ihm-js-coral-client/client":"7JSEz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJuYp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c3688ac30cd1efda");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("e9b2d31bd5c76599"));
var _createClass2 = _interopRequireDefault(require("e4c50b25c155431"));
var _inherits2 = _interopRequireDefault(require("8b5297b2598a60c1"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("54154f79d299a4f2"));
var _getPrototypeOf2 = _interopRequireDefault(require("2bdeab78e92951c"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("a4f73ebfd7fbf042");
var _ihmJsCoralClient = require("2e31b45cc97d1c5");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Extended class to override the de-serialization behavior (fromJson)
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetDisplayableFeedbackQuestionnaireResponse = /*#__PURE__*/ function(_GetDisplayableFeedba) {
    (0, _inherits2["default"])(GetDisplayableFeedbackQuestionnaireResponse, _GetDisplayableFeedba);
    var _super = _createSuper(GetDisplayableFeedbackQuestionnaireResponse);
    function GetDisplayableFeedbackQuestionnaireResponse() {
        (0, _classCallCheck2["default"])(this, GetDisplayableFeedbackQuestionnaireResponse);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(GetDisplayableFeedbackQuestionnaireResponse, null, [
        {
            key: "fromJson",
            value: function fromJson(data) {
                return GetDisplayableFeedbackQuestionnaireResponse.clone(data);
            }
        }
    ]);
    return GetDisplayableFeedbackQuestionnaireResponse;
}(_coral_comAmazonTransFeedbackTcfaModelV.GetDisplayableFeedbackQuestionnaireResponse); // Register concrete types for serialization
_ihmJsCoralClient.modelRegistrySingleton.registerType(GetDisplayableFeedbackQuestionnaireResponse);
var _default = exports["default"] = GetDisplayableFeedbackQuestionnaireResponse;

},{"c3688ac30cd1efda":"bm29M","e9b2d31bd5c76599":"dIj1v","e4c50b25c155431":"g3oHj","8b5297b2598a60c1":"3rTZc","54154f79d299a4f2":"jxVIQ","2bdeab78e92951c":"fCXB8","a4f73ebfd7fbf042":"6278u","2e31b45cc97d1c5":"eOj61"}],"jLVE8":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b180985c016f4774");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("3fe062909a6e1bdf"));
var _createClass2 = _interopRequireDefault(require("acdd65e7fed45981"));
var _inherits2 = _interopRequireDefault(require("ca90570d9da9ed69"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("982924b1bfec2de9"));
var _getPrototypeOf2 = _interopRequireDefault(require("f99124411d900069"));
var _coral_comAmazonTransFeedbackTcfaModelV = require("74a1c8fba41fb1f");
var _ihmJsCoralClient = require("cd4a53df5ddd20ea");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Extended class to override the de-serialization behavior (fromJson)
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var SubmitFeedbackRequest = /*#__PURE__*/ function(_SubmitFeedbackReques) {
    (0, _inherits2["default"])(SubmitFeedbackRequest, _SubmitFeedbackReques);
    var _super = _createSuper(SubmitFeedbackRequest);
    function SubmitFeedbackRequest() {
        (0, _classCallCheck2["default"])(this, SubmitFeedbackRequest);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(SubmitFeedbackRequest, null, [
        {
            key: "toJson",
            value: function toJson(data) {
                return SubmitFeedbackRequest.clone(data);
            }
        }
    ]);
    return SubmitFeedbackRequest;
}(_coral_comAmazonTransFeedbackTcfaModelV.SubmitFeedbackRequest); // Register concrete types for serialization
_ihmJsCoralClient.modelRegistrySingleton.registerType(SubmitFeedbackRequest);
var _default = exports["default"] = SubmitFeedbackRequest;

},{"b180985c016f4774":"bm29M","3fe062909a6e1bdf":"dIj1v","acdd65e7fed45981":"g3oHj","ca90570d9da9ed69":"3rTZc","982924b1bfec2de9":"jxVIQ","f99124411d900069":"fCXB8","74a1c8fba41fb1f":"6278u","cd4a53df5ddd20ea":"eOj61"}],"hiJmi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHOW_SUCCESS_NOTIFICATION = exports.SHOW_FAILURE_NOTIFICATION = exports.IS_SURVEY_SUBMITTED = exports.IS_SURVEY_ENABLED = exports.IS_SUBMIT_INPROGRESS = exports.IS_GET_QUESTIONS_INPROGRESS = exports.HIDE_SUCCESS_NOTIFICATION = void 0;
var SHOW_SUCCESS_NOTIFICATION = exports.SHOW_SUCCESS_NOTIFICATION = "SHOW_SUCCESS_NOTIFICATION";
var HIDE_SUCCESS_NOTIFICATION = exports.HIDE_SUCCESS_NOTIFICATION = "HIDE_SUCCESS_NOTIFICATION";
var SHOW_FAILURE_NOTIFICATION = exports.SHOW_FAILURE_NOTIFICATION = "SHOW_FAILURE_NOTIFICATION";
// CSAT Survey
var IS_GET_QUESTIONS_INPROGRESS = exports.IS_GET_QUESTIONS_INPROGRESS = "IS_GET_QUESTIONS_INPROGRESS";
var IS_SUBMIT_INPROGRESS = exports.IS_SUBMIT_INPROGRESS = "IS_SUBMIT_INPROGRESS";
var IS_SURVEY_SUBMITTED = exports.IS_SURVEY_SUBMITTED = "IS_SUBMIT_SUBMITTED";
var IS_SURVEY_ENABLED = exports.IS_SURVEY_ENABLED = "IS_SURVEY_ENABLED";

},{}],"filWO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.textQuestionType = exports.silentRedirectUri = exports.silentRedirectPath = exports.redirectUri = exports.redirectPath = exports.ratingQuestionType = exports.multipleChoiceQuestionType = exports.URL_SETTINGS = exports.TEXT_QUESTION_RESPONSE_CHAR_LIMIT = exports.SUBMIT_BUTTON_PROPERTIES = exports.SIF_PROFILE_ID = exports.REQUIRED_QUESTION_TITLE = exports.PLACEHOLDERS = exports.GENERAL_FEEDBACK_QUESTIONS = exports.FEEDBACK_LINKS = exports.FEEDBACK_FORM_PROPERTIES = exports.CSAT_SURVEY_OPTIONAL_PAGE = exports.CSAT_SURVEY_MANDATORY_PAGE = exports.CSAT_SURVEY_FEEDBACKINTENT = exports.CSAT_SURVEY_APPLICATIONID_INTERNAL = exports.CSAT_SURVEY_APPLICATIONID_EXTERNAL = void 0;
var FEEDBACK_FORM_PROPERTIES = exports.FEEDBACK_FORM_PROPERTIES = {
    description: "Thank you for taking time to fill in this feedback. This will not take more than 1 minute of your valuable time.",
    title: "Feedback",
    confirmationMessage: "Thank You! We appreciate your feedback."
};
var REQUIRED_QUESTION_TITLE = exports.REQUIRED_QUESTION_TITLE = "Please answer all required question";
var FEEDBACK_LINKS = exports.FEEDBACK_LINKS = {
    skip: "Skip",
    submit: "Submit Feedback"
};
var PLACEHOLDERS = exports.PLACEHOLDERS = {
    multipleChoiceQuestionType: "Select an option",
    textQuestion: "Enter your valuable suggestions"
};
var SUBMIT_BUTTON_PROPERTIES = exports.SUBMIT_BUTTON_PROPERTIES = {
    text: "Submit",
    size: "medium",
    type: "primary"
};
var multipleChoiceQuestionType = exports.multipleChoiceQuestionType = {
    multipleChoiceQuestionType: {
        options: [
            {
                optionNumber: 1,
                optionValue: "Labeling"
            },
            {
                optionNumber: 2,
                optionValue: "Tracking"
            },
            {
                optionNumber: 3,
                optionValue: "Others"
            }
        ]
    }
};
var ratingQuestionType = exports.ratingQuestionType = {
    ratingQuestionType: {
        minRatingValue: 1,
        ratingInterval: 1,
        isVisualRatingType: true,
        numberOfIntervals: 5
    }
};
var textQuestionType = exports.textQuestionType = {
    textQuestionType: {
        wordLimit: 60
    }
};
var GENERAL_FEEDBACK_QUESTIONS = exports.GENERAL_FEEDBACK_QUESTIONS = [
    {
        questionText: "Please select a functionality you would like to provide feedback",
        questionId: "88a2021e-b2de-4440-b1b3-2d914786aae4",
        isMandatory: true,
        questionType: multipleChoiceQuestionType
    },
    {
        questionText: "How clearly does the interface communicate that it will help you complete the task that you wish to complete?",
        questionId: "6f799b02-0a6e-4b32-a759-3f677bba8bf0",
        isMandatory: true,
        questionType: ratingQuestionType
    },
    {
        questionText: "Do you have any suggestions to improve your experience?",
        questionId: "b0f3a7e8-94f7-409c-81aa-263f4189fd85",
        isMandatory: false,
        questionType: textQuestionType
    }
];
// This is a default limit if backend API has no char limit set
var TEXT_QUESTION_RESPONSE_CHAR_LIMIT = exports.TEXT_QUESTION_RESPONSE_CHAR_LIMIT = 1000;
// SIF profile ID
var SIF_PROFILE_ID = exports.SIF_PROFILE_ID = "TCFA_Profile";
// CSAT survey feedback pages
var CSAT_SURVEY_MANDATORY_PAGE = exports.CSAT_SURVEY_MANDATORY_PAGE = "csat_survey_mandatory_page";
var CSAT_SURVEY_OPTIONAL_PAGE = exports.CSAT_SURVEY_OPTIONAL_PAGE = "csat_survey_optional_page";
var CSAT_SURVEY_FEEDBACKINTENT = exports.CSAT_SURVEY_FEEDBACKINTENT = "survey";
var CSAT_SURVEY_APPLICATIONID_INTERNAL = exports.CSAT_SURVEY_APPLICATIONID_INTERNAL = "Passport";
var CSAT_SURVEY_APPLICATIONID_EXTERNAL = exports.CSAT_SURVEY_APPLICATIONID_EXTERNAL = "CarrierLogistics";
var URL_SETTINGS = exports.URL_SETTINGS = "/settings.json";
// Auth routes
var redirectPath = exports.redirectPath = "/auth";
var redirectUri = exports.redirectUri = "".concat(origin).concat(redirectPath);
var silentRedirectPath = exports.silentRedirectPath = "/auth-silent";
var silentRedirectUri = exports.silentRedirectUri = "".concat(origin).concat(silentRedirectPath);

},{}],"VKPbn":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("fb6f0d387b51dbae");
var _typeof = require("f83c00a43512f8ac");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.UIState = void 0;
var _slicedToArray2 = _interopRequireDefault(require("516712068105c42"));
var _noop = _interopRequireDefault(require("86ea5015de64ba93"));
var _react = _interopRequireWildcard(require("aa5f8a0beba89bd2"));
var _propTypes = _interopRequireDefault(require("925a7ef5124fb8b9"));
var _ui = _interopRequireDefault(require("2d18b8f79faae483"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var UIContext = /*#__PURE__*/ (0, _react.createContext)({
    state: {
        isSuccessNotificationShown: false,
        isFailureNotificationShown: false,
        isSubmitInProgress: false,
        isGetQuestionsInProgress: false,
        isSurveyEnabled: true,
        isSurveySubmitted: false
    },
    dispatch: _noop["default"]
});
var UIState = exports.UIState = function UIState(_ref) {
    var children = _ref.children;
    var _useReducer = (0, _react.useReducer)(_ui["default"], {
        isSuccessNotificationShown: false,
        isFailureNotificationShown: false,
        isSubmitInProgress: false,
        isGetQuestionsInProgress: false,
        isSurveyEnabled: true,
        isSurveySubmitted: false
    }), _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    return /*#__PURE__*/ _react["default"].createElement(UIContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        }
    }, children);
};
UIState.propTypes = {
    children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = UIContext;

},{"fb6f0d387b51dbae":"bm29M","f83c00a43512f8ac":"8zjpU","516712068105c42":"8uMk6","86ea5015de64ba93":"lkfGU","aa5f8a0beba89bd2":"6uln9","925a7ef5124fb8b9":"gJRKl","2d18b8f79faae483":"SCb0E"}],"SCb0E":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("fc17e3dd7a2b6f50");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("33ec70f7c533ddbd"));
var _type = require("b4c19e3529b764b9");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var feedbackQuestionsReducer = function feedbackQuestionsReducer(state, _ref) {
    var type = _ref.type, payload = _ref.payload;
    var currentFeedbackState = state;
    switch(type){
        case _type.SHOW_SUCCESS_NOTIFICATION:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isSuccessNotificationShown: true
            });
        case _type.HIDE_SUCCESS_NOTIFICATION:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isSuccessNotificationShown: false
            });
        case _type.SHOW_FAILURE_NOTIFICATION:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isFailureNotificationShown: true
            });
        case _type.IS_GET_QUESTIONS_INPROGRESS:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isGetQuestionsInProgress: payload
            });
        case _type.IS_SUBMIT_INPROGRESS:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isSubmitInProgress: payload
            });
        case _type.IS_SURVEY_ENABLED:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isSurveyEnabled: payload
            });
        case _type.IS_SURVEY_SUBMITTED:
            return _objectSpread(_objectSpread({}, currentFeedbackState), {}, {
                isSurveySubmitted: payload
            });
        default:
            return currentFeedbackState;
    }
};
var _default = exports["default"] = feedbackQuestionsReducer;

},{"fc17e3dd7a2b6f50":"bm29M","33ec70f7c533ddbd":"4mibS","b4c19e3529b764b9":"hiJmi"}],"91B2Y":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Get the response initial state from questions
 *
 * @param {{questionId: string, isMandatory: boolean}[]} questionnaire
 * @returns {{
 *    answers: { id: string, isMandatory: boolean, answer: any }[]
 * }}
 */ var getFeedbackResponseInitialState = function getFeedbackResponseInitialState(questionnaire) {
    var answers = questionnaire.map(function(_ref) {
        var questionId = _ref.questionId, isMandatory = _ref.isMandatory;
        return {
            id: questionId,
            isMandatory: isMandatory,
            answer: null
        };
    });
    return {
        answers: answers
    };
};
var _default = exports["default"] = getFeedbackResponseInitialState;

},{}],"azNAp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9e2af36932594962");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeResponse = initializeResponse;
exports.saveResponse = saveResponse;
exports.submitResponse = submitResponse;
var _type = require("bbd58bd4ef339514");
var _type2 = require("e291e4f5b771c377");
var _TransCustomerFeedbackAggreatorServiceClient = require("9a1c489b85593c38");
var _getFeedbackResponseInitialState = _interopRequireDefault(require("7e27bc235cc96241"));
var _FeedbackConstants = require("f4f6c8e9895ac004");
/** @typedef {import("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1").UserFeedback} UserFeedback */ /** @typedef {{type: string, payload: any}} Action */ function saveResponse(_ref) {
    var id = _ref.id, answer = _ref.answer;
    return {
        type: _type.SAVE_RESPONSE,
        payload: {
            id: id,
            answer: answer
        }
    };
}
/**
 * Init response from questions
 *
 * @param {{questionId: string, isMandatory: boolean}[]} questions
 * @returns {Action}
 */ function initializeResponse(questions) {
    return {
        type: _type.SET_STATE,
        payload: (0, _getFeedbackResponseInitialState["default"])(questions)
    };
}
/**
 * Submit response action
 *
 * @param {string} applicationId
 * @param {string} feedbackIntent
 * @param {UserFeedback} userFeedback
 * @returns {(dispatch: Function) => Promise<Action>}
 */ function submitResponse(applicationId, feedbackIntent, userFeedback, sifProfileId) {
    return function(dispatch) {
        var submitFeedbackRequest = {
            applicationId: applicationId,
            feedbackIntent: feedbackIntent,
            userFeedback: userFeedback,
            sifProfileId: sifProfileId
        };
        dispatch({
            type: _type2.IS_SUBMIT_INPROGRESS,
            payload: true
        });
        var client = (0, _TransCustomerFeedbackAggreatorServiceClient.getTransCustomerFeedbackAggreatorServiceClient)();
        return client.submitFeedback(submitFeedbackRequest).toPromise().then(function() {
            if (feedbackIntent.includes(_FeedbackConstants.CSAT_SURVEY_FEEDBACKINTENT)) dispatch({
                type: _type2.IS_SURVEY_SUBMITTED,
                payload: true
            });
            dispatch({
                type: _type2.SHOW_SUCCESS_NOTIFICATION
            });
            dispatch({
                type: _type2.IS_SUBMIT_INPROGRESS,
                payload: false
            });
        })["catch"](function() {
            dispatch({
                type: _type2.IS_SUBMIT_INPROGRESS,
                payload: false
            });
            dispatch({
                type: _type2.SHOW_FAILURE_NOTIFICATION
            });
        });
    };
}

},{"9e2af36932594962":"bm29M","bbd58bd4ef339514":"aDZxg","e291e4f5b771c377":"hiJmi","9a1c489b85593c38":"kHzyo","7e27bc235cc96241":"91B2Y","f4f6c8e9895ac004":"filWO"}],"jpJWZ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1c9c39bdd6b46a25");
var _typeof = require("36a7435a20aab447");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("5fe303eb8798b6d3"));
var _react = _interopRequireWildcard(require("6d6de20212a2c4e3"));
var _alert = _interopRequireDefault(require("35656419bbd2fe78"));
var _toaster = _interopRequireDefault(require("5e21667edba76a98"));
var _propTypes = _interopRequireDefault(require("e6c367ca1d955eec"));
var _FeedbackConstants = require("f5979975d4d074dc");
var _feedbackIntents = _interopRequireDefault(require("2cd433828977c1c4"));
var _GeneralFeedback = _interopRequireDefault(require("59c682d7d46566e6"));
var _TriggeredFeedback = _interopRequireDefault(require("29daebcceb778932"));
var _useResponse2 = _interopRequireDefault(require("a1b40feddaceaf0f"));
var _createUserResponseObject = _interopRequireDefault(require("bced79911570a01f"));
var _useQuestions2 = _interopRequireDefault(require("41274f8c9686ee0e"));
var _useNotification2 = _interopRequireDefault(require("207633a9a0a76dd2"));
var _isSiteExternal = require("fde1ffc5929cebb5");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var FeedbackForm = function FeedbackForm(_ref) {
    var feedbackIntent = _ref.feedbackIntent, title = _ref.title, description = _ref.description, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText, confirmationMessage = _ref.confirmationMessage, applicationId = _ref.applicationId, feedbackSubmissionPageIdentifier = _ref.feedbackSubmissionPageIdentifier, _ref$triggeredObj = _ref.triggeredObj, isTriggered = _ref$triggeredObj.isTriggered, resetTrigger = _ref$triggeredObj.resetTrigger, userId = _ref.userId, isSkippable = _ref.isSkippable, prePopulate = _ref.prePopulate, displayMode = _ref.displayMode;
    var isGeneralFeedback = feedbackIntent === _feedbackIntents["default"].General;
    var _useState = (0, _react.useState)(false), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, _react.useState)(0), _useState4 = (0, _slicedToArray2["default"])(_useState3, 2), startTime = _useState4[0], setStartTime = _useState4[1];
    var _useState5 = (0, _react.useState)(true), _useState6 = (0, _slicedToArray2["default"])(_useState5, 2), disabled = _useState6[0], setDisabled = _useState6[1];
    var _useResponse = (0, _useResponse2["default"])(), response = _useResponse.response, submitResponse = _useResponse.submitResponse, initializeResponse = _useResponse.initializeResponse;
    var _useQuestions = (0, _useQuestions2["default"])(), questions = _useQuestions.questions;
    var _useNotification = (0, _useNotification2["default"])(), toasts = _useNotification.toasts, onCloseToast = _useNotification.onCloseToast;
    // On first rendering set startTime to the current time if feedbackIntent is Triggered.
    (0, _react.useEffect)(function() {
        if (!isGeneralFeedback) setStartTime(Date.now());
    }, []);
    var requiredNotAnswered = function requiredNotAnswered(_ref2) {
        var isMandatory = _ref2.isMandatory, answer = _ref2.answer;
        return isMandatory && !(answer !== null && answer !== void 0 && answer.toString().trim());
    };
    (0, _react.useEffect)(function() {
        if (response.answers.some(requiredNotAnswered)) setDisabled(true);
        else setDisabled(false);
    }, [
        response
    ]);
    var onClickLink = (0, _react.useCallback)(function() {
        setOpen(true);
        setStartTime(Date.now()); // set startTime to current time when user clicks on submit feedback link.
    }, []);
    var onClose = function onClose() {
        setOpen(false);
        resetTrigger();
        initializeResponse(questions); // reset questions
    };
    var sifProfileId = (0, _isSiteExternal.isSiteExternal)() ? _FeedbackConstants.SIF_PROFILE_ID : undefined;
    var onClickFooterButton = (0, _react.useCallback)(function() {
        var timeTakenToRespond = Date.now() - startTime; // total time taken to respond
        // user response object which will be stored in backend
        var _createUserResponseOb = (0, _createUserResponseObject["default"])(response, questions, timeTakenToRespond, feedbackSubmissionPageIdentifier, userId), userFeedback = _createUserResponseOb.userFeedback;
        submitResponse(applicationId, feedbackIntent, userFeedback, sifProfileId);
        onClose();
    });
    return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, feedbackIntent === _feedbackIntents["default"].General ? /*#__PURE__*/ _react["default"].createElement(_GeneralFeedback["default"], {
        open: open,
        isDisabled: disabled,
        onClose: onClose,
        onClickLink: onClickLink,
        onClickFooterButton: onClickFooterButton,
        questions: questions,
        prePopulate: prePopulate,
        title: title,
        description: description,
        submitButtonSize: submitButtonSize,
        submitButtonType: submitButtonType,
        submitButtonText: submitButtonText,
        displayMode: displayMode
    }) : /*#__PURE__*/ _react["default"].createElement(_TriggeredFeedback["default"], {
        open: isTriggered,
        isDisabled: disabled,
        onClose: onClose,
        onClickFooterButton: onClickFooterButton,
        questions: questions,
        prePopulate: prePopulate,
        title: title,
        description: description,
        submitButtonSize: submitButtonSize,
        submitButtonType: submitButtonType,
        submitButtonText: submitButtonText,
        isSkippable: isSkippable
    }), /*#__PURE__*/ _react["default"].createElement(_toaster["default"], {
        toasts: toasts,
        onCloseToast: onCloseToast
    }, function() {
        return /*#__PURE__*/ _react["default"].createElement(_alert["default"], {
            toast: true,
            type: "success"
        }, confirmationMessage);
    }));
};
FeedbackForm.propTypes = {
    feedbackIntent: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string,
    description: _propTypes["default"].string,
    confirmationMessage: _propTypes["default"].string,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string,
    applicationId: _propTypes["default"].string.isRequired,
    feedbackSubmissionPageIdentifier: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].func
    ]),
    triggeredObj: _propTypes["default"].shape({
        isTriggered: _propTypes["default"].bool.isRequired,
        resetTrigger: _propTypes["default"].func.isRequired
    }).isRequired,
    userId: _propTypes["default"].string,
    isSkippable: _propTypes["default"].bool,
    prePopulate: _propTypes["default"].object.isRequired
};
FeedbackForm.defaultProps = {
    title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
    description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
    confirmationMessage: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.confirmationMessage,
    feedbackSubmissionPageIdentifier: null,
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text,
    userId: null,
    isSkippable: true
};
var _default = exports["default"] = FeedbackForm;

},{"1c9c39bdd6b46a25":"bm29M","36a7435a20aab447":"8zjpU","5fe303eb8798b6d3":"8uMk6","6d6de20212a2c4e3":"6uln9","35656419bbd2fe78":"gBzTs","5e21667edba76a98":"lrJOb","e6c367ca1d955eec":"gJRKl","f5979975d4d074dc":"filWO","2cd433828977c1c4":"fxXId","59c682d7d46566e6":"5Z2Wy","29daebcceb778932":"bvCa6","a1b40feddaceaf0f":"9TPqN","bced79911570a01f":"78qJ0","41274f8c9686ee0e":"3eKaA","207633a9a0a76dd2":"aVE3y","fde1ffc5929cebb5":"cslg4"}],"gBzTs":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6f1237b15f2e2fb0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _alert = _interopRequireDefault(require("58a9a34b15db2fef"));
var _default = _alert["default"];
exports["default"] = _default;

},{"6f1237b15f2e2fb0":"fk2Bw","58a9a34b15db2fef":"eIn2q"}],"fk2Bw":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault;

},{}],"eIn2q":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("4538c1ab24e4817b");
var _interopRequireDefault = require("b69e4b72946faffe");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("43381ccbf9540e85"));
var _react = _interopRequireWildcard(require("7c46f92acbde1345"));
var _propTypes = _interopRequireDefault(require("718159e401efe7ab"));
var _emotion = require("c49146f88c47cb52");
var _uniqueId = _interopRequireDefault(require("f1062f06aae3d5b9"));
var _alert = _interopRequireDefault(require("97aab9b573c83b12"));
var _alertErrorXlarge = _interopRequireDefault(require("b7090a3572c87647"));
var _alertErrorLarge = _interopRequireDefault(require("39175d68523825f3"));
var _alertErrorSmall = _interopRequireDefault(require("a05c57812b5d8418"));
var _alertInformationalLarge = _interopRequireDefault(require("27dd1df8540fdf5e"));
var _alertInformationalSmall = _interopRequireDefault(require("a88417c5ff09112"));
var _alertSuccessXlarge = _interopRequireDefault(require("c5b9e561fb631dd2"));
var _alertSuccessLarge = _interopRequireDefault(require("6bb58630a99fbf3e"));
var _alertSuccessSmall = _interopRequireDefault(require("e2699186e2637d6"));
var _alertWarningXlarge = _interopRequireDefault(require("8ba448b8fb3e18c3"));
var _alertWarningLarge = _interopRequireDefault(require("dfb95731fd4cb776"));
var _alertWarningSmall = _interopRequireDefault(require("8a8e12e5ade031b1"));
var _close = _interopRequireDefault(require("696bfeb036c8b09b"));
var _theme = require("6607875c11486f53");
var _button = _interopRequireDefault(require("72da49e1f7eb6a04"));
var _icon = _interopRequireDefault(require("7d3eb41795b4b7c"));
var _token = require("e15eb5291dadc390");
var _focus = require("ac4c9976d659c94d");
var _getIconCss = _interopRequireDefault(require("6fe2dc65b6cf9d64"));
var _text = _interopRequireDefault(require("502993b680d24879"));
var iconTokens = {
    small: {
        error: _alertErrorSmall["default"],
        informational: _alertInformationalSmall["default"],
        success: _alertSuccessSmall["default"],
        warning: _alertWarningSmall["default"]
    },
    medium: {
        error: _alertErrorSmall["default"],
        informational: _alertInformationalSmall["default"],
        success: _alertSuccessSmall["default"],
        warning: _alertWarningSmall["default"]
    },
    large: {
        error: _alertErrorLarge["default"],
        informational: _alertInformationalLarge["default"],
        success: _alertSuccessLarge["default"],
        warning: _alertWarningLarge["default"]
    },
    xlarge: {
        error: _alertErrorXlarge["default"],
        informational: _alertInformationalLarge["default"],
        success: _alertSuccessXlarge["default"],
        warning: _alertWarningXlarge["default"]
    }
};
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, type = _ref.type, toast = _ref.toast, width = _ref.width;
    var borderWidth = t("borderWidth", size);
    var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
    return (0, _emotion.css)({
        /**
     * Container styles
     */ boxSizing: "border-box",
        display: "flex",
        flexDirection: size === "xlarge" ? "column" : "row",
        alignItems: size === "xlarge" ? "center" : "flex-start",
        backgroundColor: t("backgroundColor", [
            size,
            type
        ]),
        borderWidth: borderWidth,
        borderColor: t("borderColor", type),
        borderStyle: borderWidth ? "solid" : undefined,
        borderRadius: t("borderRadius"),
        padding: t("spacingInset", size),
        width: width,
        boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
        "& > * + *": {
            marginLeft: t("spacingHorizontal", size)
        },
        /**
     * Icon styles
     */ "& > [role=img]": {
            flexShrink: 0,
            alignSelf: size === "xlarge" ? "center" : "stretch",
            backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [
                size,
                type
            ])),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: icon.width,
            // This ensures that the icon is vertically centered on the first line of
            // text for single-line alerts and on the first two lines of text for
            // multi-line alerts.
            minHeight: icon.height,
            maxHeight: icon.height * 2
        },
        /**
     * Title/message wrapper styles
     */ "& [mdn-text]": (0, _emotion.css)((0, _text["default"])(t, {
            fontSize: [
                "message",
                size
            ],
            fontWeight: "body",
            // TODO: This token should be renamed to "message"
            lineHeight: [
                "message",
                size
            ]
        }), {
            textAlign: size === "xlarge" ? "center" : "initial",
            color: t("foregroundColor", [
                size,
                type
            ]),
            flex: "auto",
            display: "flex",
            flexDirection: size === "xlarge" ? "column" : "row",
            // Allow the message to wrap below the title if it's too long to fit.
            flexWrap: "wrap"
        }),
        /**
     * Title styles
     */ "& [mdn-alert-title]": (0, _emotion.css)((0, _text["default"])(t, {
            fontSize: [
                "title",
                size
            ],
            fontWeight: "title",
            lineHeight: [
                "title",
                size
            ]
        }), {
            color: t("foregroundColor", [
                size,
                type
            ]),
            flexShrink: 0,
            fontWeight: t("fontWeightTitle"),
            marginRight: t("titleSpacingRight", size),
            marginTop: t("spacingVertical", size)
        }),
        /**
     * Message styles
     */ "& [mdn-alert-message]": {
            margin: 0,
            marginTop: t("spacingVertical", size),
            // Make the message fill the whole width of the alert, but keep it on
            // the same line as the title until it has to wrap.
            flex: "auto",
            flexShrink: 0,
            maxWidth: "100%"
        }
    });
}, [
    "size",
    "type",
    "toast",
    "width"
]);
var closeButtonStyles = function closeButtonStyles(t, _ref2) {
    var size = _ref2.size;
    return (0, _emotion.css)(size === "xlarge" ? {
        position: "absolute",
        top: t("closeButtonSpacing", size),
        right: t("closeButtonSpacing", size)
    } : {
        flexShrink: 0,
        margin: t("closeButtonSpacing", size) - t("spacingInset", size),
        marginLeft: t("spacingHorizontal", size)
    });
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */ function Alert(props) {
    var t = (0, _theme.useTheme)(_alert["default"], "alert");
    var idPrefix = (0, _react.useMemo)(function() {
        return (0, _uniqueId["default"])("alert-");
    }, []);
    var node = (0, _react.useRef)();
    var big = props.size === "large" || props.size === "xlarge";
    var title = big ? props.title : undefined;
    var titleId = title ? "".concat(idPrefix, "-title") : undefined;
    var childrenId = "".concat(idPrefix, "-children");
    var showCloseButton = props.onClose && props.size !== "small"; // If autoFocus is true then focus on the first interactive element in the
    // alert. This'll either be the first action rendered by the user or the
    // alert's close button if there are no actions.
    var autoFocus = props.autoFocus;
    (0, _react.useEffect)(function() {
        if (autoFocus) {
            var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current), _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1), firstFocusNode = _getKeyboardFocusNode2[0];
            if (firstFocusNode) firstFocusNode.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, props),
        ref: autoFocus ? node : undefined,
        role: showCloseButton ? "alertdialog" : "alert",
        "aria-labelledby": titleId,
        "aria-describedby": childrenId
    }, /*#__PURE__*/ _react["default"].createElement("div", {
        role: "img",
        "aria-hidden": "true"
    }), /*#__PURE__*/ _react["default"].createElement("div", {
        "mdn-text": ""
    }, title ? /*#__PURE__*/ _react["default"].createElement("div", {
        "mdn-alert-title": "",
        id: titleId
    }, title) : null, /*#__PURE__*/ _react["default"].createElement("div", {
        "mdn-alert-message": "",
        id: childrenId
    }, props.children)), showCloseButton ? /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: "icon",
        size: big ? "medium" : "small",
        onClick: props.onClose,
        backdropColor: t("backgroundColor", [
            props.size,
            props.type
        ]),
        className: closeButtonStyles(t, props)
    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: _close["default"]
    }, props.closeLabel)) : null);
}
Alert.propTypes = {};
Alert.defaultProps = {
    size: "large",
    type: "informational",
    closeLabel: "Dismiss"
};
var _default = Alert;
exports["default"] = _default;

},{"4538c1ab24e4817b":"k8mdG","b69e4b72946faffe":"fk2Bw","43381ccbf9540e85":"19SJN","7c46f92acbde1345":"6uln9","718159e401efe7ab":"cnMFu","c49146f88c47cb52":"4deck","f1062f06aae3d5b9":"4yTHb","97aab9b573c83b12":"hd8AG","b7090a3572c87647":"1qY3u","39175d68523825f3":"1bKKf","a05c57812b5d8418":"60zDg","27dd1df8540fdf5e":"5HZcC","a88417c5ff09112":"f5V7t","c5b9e561fb631dd2":"64MbA","6bb58630a99fbf3e":"dfQtq","e2699186e2637d6":"dUJtB","8ba448b8fb3e18c3":"g4mrT","dfb95731fd4cb776":"8sEIC","8a8e12e5ade031b1":"i8B7p","696bfeb036c8b09b":"2AQYC","6607875c11486f53":"eM9hO","72da49e1f7eb6a04":"gJQuD","7d3eb41795b4b7c":"jPx5F","e15eb5291dadc390":"atHRo","ac4c9976d659c94d":"iqUT6","6fe2dc65b6cf9d64":"33AK4","502993b680d24879":"13UMz"}],"k8mdG":[function(require,module,exports) {
var _typeof = require("92b9c6b465a01795");
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
module.exports = _interopRequireWildcard;

},{"92b9c6b465a01795":"2uZa5"}],"2uZa5":[function(require,module,exports) {
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
module.exports = _typeof;

},{}],"19SJN":[function(require,module,exports) {
var arrayWithHoles = require("d8aca68853db2efd");
var iterableToArrayLimit = require("3fce03cdad584695");
var unsupportedIterableToArray = require("fbc53bfba1de012a");
var nonIterableRest = require("2a8ee206c88f9f7b");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray;

},{"d8aca68853db2efd":"aTEZx","3fce03cdad584695":"8mRrk","fbc53bfba1de012a":"dutLm","2a8ee206c88f9f7b":"jPQXB"}],"aTEZx":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles;

},{}],"8mRrk":[function(require,module,exports) {
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = _iterableToArrayLimit;

},{}],"dutLm":[function(require,module,exports) {
var arrayLikeToArray = require("7b9222ae75c366e");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray;

},{"7b9222ae75c366e":"7qUYC"}],"7qUYC":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray;

},{}],"jPQXB":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest;

},{}],"cnMFu":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("dd8d67415777ec2b")();

},{"dd8d67415777ec2b":"jM3rh"}],"jM3rh":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("385641cc4f5511a2");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"385641cc4f5511a2":"jjbME"}],"jjbME":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"4deck":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _createEmotion = require("create-emotion");
var _createEmotionDefault = parcelHelpers.interopDefault(_createEmotion);
var _createEmotion1 = (0, _createEmotionDefault.default)(), flush = _createEmotion1.flush, hydrate = _createEmotion1.hydrate, cx = _createEmotion1.cx, merge = _createEmotion1.merge, getRegisteredStyles = _createEmotion1.getRegisteredStyles, injectGlobal = _createEmotion1.injectGlobal, keyframes = _createEmotion1.keyframes, css = _createEmotion1.css, sheet = _createEmotion1.sheet, cache = _createEmotion1.cache;

},{"create-emotion":"hsjuE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hsjuE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
exports.default = createEmotion;

},{"@emotion/cache":"cR7XV","@emotion/serialize":"jUrhM","@emotion/utils":"i75Hi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cR7XV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sheet = require("@emotion/sheet");
var _stylis = require("@emotion/stylis");
var _stylisDefault = parcelHelpers.interopDefault(_stylis);
var _weakMemoize = require("@emotion/weak-memoize");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = "/*|*/";
var needle = delimiter + "}";
function toSheet(block) {
    if (block) Sheet.current.insert(block + "}");
}
var Sheet = {
    current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? delimiter : "");
            }
        case -2:
            content.split(needle).forEach(toSheet);
    }
};
var createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, _stylisDefault.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
exports.default = createCache;

},{"@emotion/sheet":"5qK9c","@emotion/stylis":"7tjif","@emotion/weak-memoize":"69uxd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5qK9c":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7tjif":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
exports.default = stylis_min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"69uxd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
exports.default = weakMemoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUrhM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var shouldWarnAboutInterpolatingClassNameFromCss = true;
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"gV0HR","@emotion/unitless":"fK4SE","@emotion/memoize":"3o2Ts","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gV0HR":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
exports.default = murmur2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fK4SE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3o2Ts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i75Hi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yTHb":[function(require,module,exports) {
var toString = require("7438a61e1e5c6411");
/** Used to generate unique IDs. */ var idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
}
module.exports = uniqueId;

},{"7438a61e1e5c6411":"bI8Cb"}],"bI8Cb":[function(require,module,exports) {
var baseToString = require("33618effe49ff63f");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"33618effe49ff63f":"2OjPX"}],"2OjPX":[function(require,module,exports) {
var Symbol = require("d2763d3bcff34ffc"), arrayMap = require("1a067795a48b7ae0"), isArray = require("90312bcda854bb63"), isSymbol = require("7ed76cea01fcb668");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"d2763d3bcff34ffc":"5VUaA","1a067795a48b7ae0":"lLYVY","90312bcda854bb63":"6WNsH","7ed76cea01fcb668":"cGB8s"}],"5VUaA":[function(require,module,exports) {
var root = require("b27c24d0f3fd5d29");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"b27c24d0f3fd5d29":"9D9UF"}],"9D9UF":[function(require,module,exports) {
var freeGlobal = require("57d14317aa90c51");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"57d14317aa90c51":"duiN6"}],"duiN6":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"lLYVY":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"6WNsH":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"cGB8s":[function(require,module,exports) {
var baseGetTag = require("7202b971a26441ec"), isObjectLike = require("17117d8822f7f21");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"7202b971a26441ec":"8nzKY","17117d8822f7f21":"hSXky"}],"8nzKY":[function(require,module,exports) {
var Symbol = require("7344ad4380850165"), getRawTag = require("af2e187429791d51"), objectToString = require("46bdad5d01435b86");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"7344ad4380850165":"5VUaA","af2e187429791d51":"elzVz","46bdad5d01435b86":"8pqTp"}],"elzVz":[function(require,module,exports) {
var Symbol = require("ddb7b42271caf1f5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"ddb7b42271caf1f5":"5VUaA"}],"8pqTp":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"hSXky":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"hd8AG":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        alertMobileFontSizeTitleSmall: 14,
        alertMobileFontSizeTitleMedium: 14,
        alertMobileFontSizeTitleLarge: 16,
        alertMobileFontSizeTitleXlarge: 24,
        alertMobileFontSizeMessageSmall: 14,
        alertMobileFontSizeMessageMedium: 14,
        alertMobileFontSizeMessageLarge: 16,
        alertMobileFontSizeMessageXlarge: 16,
        alertMobileLineHeightTitleSmall: "16px",
        alertMobileLineHeightTitleMedium: "16px",
        alertMobileLineHeightTitleLarge: "24px",
        alertMobileLineHeightTitleXlarge: "32px",
        alertMobileLineHeightMessageSmall: "16px",
        alertMobileLineHeightMessageMedium: "16px",
        alertMobileLineHeightMessageLarge: "24px",
        alertMobileLineHeightMessageXlarge: "24px",
        alertMobileMessageSpacingInsetHorizontalLarge: 15,
        alertMobileMessageSpacingInsetVerticalLarge: 8,
        alertMobileCloseButtonSpacingLarge: 3,
        alertBackgroundColorMediumError: "#F9D5E2",
        alertBackgroundColorMediumWarning: "#FEF2B8",
        alertBackgroundColorMediumSuccess: "#DCF3A0",
        alertBackgroundColorMediumInformational: "#F0F1F2",
        alertBackgroundColorLargeError: "#F9D5E2",
        alertBackgroundColorLargeWarning: "#FEF2B8",
        alertBackgroundColorLargeSuccess: "#DCF3A0",
        alertBackgroundColorLargeInformational: "#F0F1F2",
        alertForegroundColorSmallDefault: tokens.themeForegroundPrimaryDefault,
        alertForegroundColorSmallError: tokens.themeForegroundPrimaryError,
        alertForegroundColorMediumDefault: "#232F3E",
        alertForegroundColorLargeDefault: "#232F3E",
        alertForegroundColorXlargeDefault: tokens.themeForegroundPrimaryDefault,
        alertFontSizeTitleSmall: 14,
        alertFontSizeTitleMedium: 14,
        alertFontSizeTitleLarge: 16,
        alertFontSizeTitleXlarge: 24,
        alertFontSizeMessageSmall: 14,
        alertFontSizeMessageMedium: 14,
        alertFontSizeMessageLarge: 16,
        alertFontSizeMessageXlarge: 16,
        alertFontWeightTitle: 600,
        alertFontWeightBody: 400,
        alertLineHeightTitleSmall: "16px",
        alertLineHeightTitleMedium: "16px",
        alertLineHeightTitleLarge: "24px",
        alertLineHeightTitleXlarge: "32px",
        alertLineHeightMessageSmall: "16px",
        alertLineHeightMessageMedium: "16px",
        alertLineHeightMessageLarge: "24px",
        alertLineHeightMessageXlarge: "24px",
        alertBorderWidthMedium: 1,
        alertBorderWidthLarge: 1,
        alertBorderRadius: 4,
        alertBorderColorError: "#CC0C39",
        alertBorderColorWarning: "#DCB700",
        alertBorderColorSuccess: "#98C91E",
        alertBorderColorInformational: "#BBC0C1",
        alertSpacingInsetMedium: 8,
        alertSpacingInsetLarge: 15,
        alertSpacingInsetXlarge: 15,
        alertSpacingHorizontalSmall: 8,
        alertSpacingHorizontalMedium: 8,
        alertSpacingHorizontalLarge: 16,
        alertSpacingHorizontalXlarge: 0,
        alertCloseButtonSpacingMedium: 0,
        alertCloseButtonSpacingLarge: 7,
        alertCloseButtonSpacingXlarge: 7,
        alertTitleSpacingRightDefault: 8,
        alertTitleSpacingRightXlarge: 0,
        alertSpacingVerticalXlarge: 24,
        alertMotionDuration: "200ms",
        alertMotionFunction: "ease",
        alertShadowColor: "rgba(11, 12, 12, 0.1)",
        alertShadowOffsetX: 0,
        alertShadowOffsetY: 8,
        alertShadowBlur: 16,
        alertShadowSpread: 0
    };
};

},{}],"1qY3u":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertErrorXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='8' fill='%23FF7494' cx='44' cy='44' r='40'/%3e%3cpath d='M44 58.667a5 5 0 100 10 5 5 0 000-10z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M44 23.333v18.334' stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertErrorXlargeWidth: 88,
    iconAlertErrorXlargeHeight: 88
};

},{}],"1bKKf":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertErrorLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='2' fill='%23FF7494' cx='12' cy='12' r='11'/%3e%3cpath d='M12 16.273A1.364 1.364 0 1012 19a1.364 1.364 0 000-2.727z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 7v5' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertErrorLargeWidth: 24,
    iconAlertErrorLargeHeight: 24
};

},{}],"60zDg":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertErrorSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23FF7494' fill-rule='nonzero' cx='8' cy='8' r='8'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23CC0C39' fill-rule='nonzero'/%3e%3cpath d='M8 4v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='12' r='1'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertErrorSmallWidth: 16,
    iconAlertErrorSmallHeight: 16
};

},{}],"5HZcC":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertInformationalLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3cpath d='M12 11v6M13 17h-2M12 11h-1' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='12' cy='8' r='1'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertInformationalLargeWidth: 24,
    iconAlertInformationalLargeHeight: 24
};

},{}],"f5V7t":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertInformationalSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' fill-rule='nonzero' cx='8' cy='8' r='7.5'/%3e%3cpath d='M8 7.063v3.75M8 7.063h-.938M8.938 10.813H7.062' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='4.25' r='1'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertInformationalSmallWidth: 16,
    iconAlertInformationalSmallHeight: 16
};

},{}],"64MbA":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertSuccessXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='44' cy='44' r='40.333'/%3e%3cpath d='M44 88c24.3 0 44-19.7 44-44S68.3 0 44 0 0 19.7 0 44s19.7 44 44 44zm0-7.333C23.75 80.667 7.333 64.25 7.333 44S23.75 7.333 44 7.333 80.667 23.75 80.667 44 64.25 80.667 44 80.667z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round' d='M22 44.061l14.65 14.66L62.358 33'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertSuccessXlargeWidth: 88,
    iconAlertSuccessXlargeHeight: 88
};

},{}],"dfQtq":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertSuccessLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M6 12.017l3.996 3.998L17.006 9'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertSuccessLargeWidth: 24,
    iconAlertSuccessLargeHeight: 24
};

},{}],"dUJtB":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertSuccessSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' fill-rule='nonzero' cx='7.97' cy='7.97' r='7.47'/%3e%3cpath d='M11.705 6.103l-4.669 4.669M7.036 10.772l-2.8-2.802' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3cpath d='M7.97 15.94A7.97 7.97 0 107.97 0a7.97 7.97 0 000 15.94zm0-1A6.97 6.97 0 117.97 1a6.97 6.97 0 010 13.94z' fill='%2398C91E' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertSuccessSmallWidth: 16,
    iconAlertSuccessSmallHeight: 16
};

},{}],"g4mrT":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertWarningXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M82.293 72.449L49.898 7.583A6.656 6.656 0 0043.996 4a6.656 6.656 0 00-5.902 3.583L5.699 72.449C1.756 80.29 7.605 84 11.273 84h65.67c3.494 0 9.29-3.814 5.35-11.551z' stroke='%23DCB700' stroke-width='8' fill='%23FCDE4D' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M43.57 62.333a4.583 4.583 0 100 9.167 4.583 4.583 0 000-9.167z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M43.57 36.667v14.666' stroke='%23232F3E' stroke-width='7.333' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertWarningXlargeWidth: 88,
    iconAlertWarningXlargeHeight: 88
};

},{}],"8sEIC":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertWarningLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z' fill='%23FCDE4D'/%3e%3cpath d='M14.518 1.538A2.837 2.837 0 0012 0a2.83 2.83 0 00-2.51 1.523L.574 19.377C-.698 21.905.87 24 3 24h18.06c2.083 0 3.631-2.133 2.364-4.627L14.518 1.538zm7.123 18.74c.552 1.084.09 1.722-.58 1.722H3c-.732 0-1.196-.62-.64-1.727l8.91-17.841a.83.83 0 011.465.015l8.901 17.823.004.007z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 10v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertWarningLargeWidth: 24,
    iconAlertWarningLargeHeight: 24
};

},{}],"i8B7p":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconAlertWarningSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M15.205 13.08L9.11.994A1.254 1.254 0 008 .326c-.467 0-.895.257-1.111.668L.794 13.08c-.742 1.462.358 2.153 1.048 2.153h12.356c.658 0 1.748-.71 1.007-2.153z' fill='%23FCDE4D'/%3e%3cpath d='M9.557.942a1.757 1.757 0 00-3.11-.007L.302 13.12C-.506 14.71.468 16 1.797 16h12.448c1.296 0 2.258-1.312 1.452-2.882L9.557.942zm4.688 14.077H1.797c-.644 0-1.072-.566-.62-1.456L7.32 1.384A.77.77 0 018 .981c.29 0 .553.159.685.41l6.138 12.17c.45.879.027 1.458-.577 1.458z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M8 11.667a1 1 0 100 2 1 1 0 000-2z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M8 6v3' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
    iconAlertWarningSmallWidth: 16,
    iconAlertWarningSmallHeight: 16
};

},{}],"eM9hO":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("cd623d6cbb68ef5a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function get() {
        return _theme.useTheme;
    }
});
Object.defineProperty(exports, "Style", {
    enumerable: true,
    get: function get() {
        return _theme.Style;
    }
});
exports["default"] = void 0;
require("46e6eb58a4029d9a");
var _theme = _interopRequireWildcard(require("a6436e2ebf7df675"));
var _default = _theme["default"];
exports["default"] = _default;

},{"cd623d6cbb68ef5a":"k8mdG","46e6eb58a4029d9a":"5AU6x","a6436e2ebf7df675":"9QVMp"}],"5AU6x":[function(require,module,exports) {
"use strict";
var _emotion = require("8d87d7079755104");
/**
 * Global styles
 */ (0, _emotion.injectGlobal)({
    /**
   * Set font smoothing technique
   *
   * On macOS the default font smoothing technique (subpixel antialiasing) is
   * optimized for dark text on light backgrounds. Unfortunately when applied to
   * light text on dark backgrounds this results in extra heavy, fuzzy text. The
   * following two properties turn off subpixel antialiasing in webkit browsers
   * and Firefox on macOS when the display's pixel density is high enough to
   * support full-pixel aliasing without decreasing text legibility.
   */ "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx)": {
        body: {
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale"
        }
    },
    /**
   * HACK: Fix html5 tags in IE11
   *
   * IE11 won't apply styles correctly to newer html5 tags that it doesn't
   * recognize unless they have a "display" property set.
   */ "main, nav, header, footer": {
        display: "block"
    }
});

},{"8d87d7079755104":"4deck"}],"9QVMp":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("45f3e1a1136f2ef2");
var _interopRequireDefault = require("3253ee27504f1c7f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Style = Style;
exports.ThemeContext = exports.useTheme = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("36531dabd28f2bd"));
var _react = _interopRequireWildcard(require("cd21de4c769113a9"));
var _propTypes = _interopRequireDefault(require("b9787c1f6882ec8f"));
var _blueLight = _interopRequireDefault(require("6d4f057f61c5a176"));
var _token = require("e463a913a9cf5868");
var _functional = require("c516e5fb6f8a8068");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Context for passing theme tokens down the tree.
 */ var ThemeContext = /*#__PURE__*/ (0, _react.createContext)(_blueLight["default"]);
/**
 * Merge two token objects together.
 */ exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function(a, b) {
    return _objectSpread(_objectSpread({}, a), b);
}, 1);
/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */ var applyTheme = (0, _functional.memoizeCurry)(function(themeTokens, tokens) {
    return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
/**
 * A hook that grants access to theme tokens. Optionally pass in themeable
 * tokens as a function or non-themeable tokens as an object to mix with the
 * theme tokens. If tokens are provided, a prefixKey can be passed to allow easier
 * selection of tokens with a common prefix. For example:
 *   const t = useTheme(buttonTokens, "button")
 *   const buttonBgColor = t("backgroundColor")
 */ var useTheme = function useTheme(tokens) {
    var prefixKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var _legacyHelperForBackwardsCompatibilityDoNotUse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var themeTokens = (0, _react.useContext)(ThemeContext);
    var currentTokens = applyTheme(themeTokens)(tokens);
    return typeof _legacyHelperForBackwardsCompatibilityDoNotUse === "function" ? _legacyHelperForBackwardsCompatibilityDoNotUse(currentTokens) : _legacyHelperForBackwardsCompatibilityDoNotUse ? currentTokens : (0, _token.getTokenHelper)(prefixKey)(currentTokens);
};
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */ exports.useTheme = useTheme;
function Theme(_ref) {
    var tokens = _ref.tokens, children = _ref.children;
    var contextTokens = (0, _react.useContext)(ThemeContext);
    var currentTokens = mergeTokens(contextTokens)(tokens);
    return /*#__PURE__*/ _react["default"].createElement(ThemeContext.Provider, {
        value: currentTokens
    }, children);
}
Theme.propTypes = {};
/**
 * IMPORTANT: For backwards-compatibility only! Use the "useTheme" hook instead.
 */ function Style(_ref2) {
    var tokens = _ref2.tokens, map = _ref2.map, children = _ref2.children;
    return children(useTheme(tokens, "", map || true));
}
Style.propTypes = {
    children: _propTypes["default"].func.isRequired,
    map: _propTypes["default"].func,
    tokens: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        _propTypes["default"].object
    ])
};
var _default = Theme;
exports["default"] = _default;

},{"45f3e1a1136f2ef2":"k8mdG","3253ee27504f1c7f":"fk2Bw","36531dabd28f2bd":"hcG56","cd21de4c769113a9":"6uln9","b9787c1f6882ec8f":"cnMFu","6d4f057f61c5a176":"9s5Kc","e463a913a9cf5868":"atHRo","c516e5fb6f8a8068":"eKpY2"}],"hcG56":[function(require,module,exports) {
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty;

},{}],"atHRo":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f1d7cc11e9f2e49d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.memoizeTokenStyles = exports.removeTokenPrefixes = exports.getUnthemedTokens = exports.getIconFromTokens = exports.getTokenHelper = exports.getToken = void 0;
var _pascalCase = _interopRequireDefault(require("d2e4fcdcdd997912"));
var _upperFirst = _interopRequireDefault(require("f038a18613e4cdd3"));
var _lowerFirst = _interopRequireDefault(require("8076e58721913b63"));
var _functional = require("448bbe65229cf1b0");
/**
 * Select a single token from a token object given a key (and optionally a
 * "suffix" key or list of suffix keys). If the token doesn't exist then an
 * attempt is made to replace the last suffix key with "default" and get the
 * value for that token. If that token also doesn't exist then `undefined` is
 * returned.
 *
 * @example
 * const tokens = {
 *   backgroundColorDefault: "#fff",
 *   backgroundColorHover: "#ccc",
 *   backgroundColorPressed: "#f00",
 * }
 * getToken(tokens, "backgroundColor", "active") // #fff
 * getTokens(tokens, "background", ["color", "pressed"]) // #f00
 * getToken(tokens, "myBackgroundColor") // undefined
 */ var getToken = function getToken(tokens, key, suffixKeys) {
    // If we got an array of suffix keys, turn them into a PascalCaseString and
    // look up the token
    if (suffixKeys && Array.isArray(suffixKeys)) {
        var value = tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys))];
        return value !== undefined ? value : tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys.slice(0, -1)), "Default")]; // If we got a single suffix key then upper case the first character and look
    // up the token
    } else if (suffixKeys) {
        var _value = tokens["".concat(key).concat((0, _upperFirst["default"])(suffixKeys))];
        return _value !== undefined ? _value : tokens["".concat(key, "Default")]; // If we didn't get any suffix keys then do a simple lookup
    } else return tokens[key];
};
/**
 * This will, given a root key and token object, return a special helper that
 * includes token utilities with those inputs already applied. Calling the
 * helper as a function is equivalent to calling `getToken`, but the helper also
 * includes several properties that make it easier to construct CSS from tokens.
 * This helper is useful when working with an object of tokens that all have the
 * same prefix.
 *
 * @example
 * const tokens = {
 *   buttonBorderWidth: 1,
 *   buttonBorderStyle: "dotted",
 *   buttonBorderColor: "#f00",
 * }
 * const t = getTokenHelper("button")(tokens)
 * t("borderWidth") // 1
 * t.borderCss("border") // "1px dotted #f00"
 * t.tokens === tokens // true
 *
 */ exports.getToken = getToken;
var getTokenHelper = (0, _functional.memoizeCurry)(function(prefixKey, tokens) {
    var helper = function helper(key, suffixKeys) {
        return getToken(tokens, prefixKey ? "".concat(prefixKey).concat((0, _upperFirst["default"])(key)) : key, suffixKeys);
    };
    helper.tokens = tokens; // Pass in "myBorder" and shorthand border css will be generated based on
    // "myBorderWidth" and "myBorderColor" tokens.
    helper.borderCss = function(key) {
        var width = helper(key, "width");
        var color = helper(key, "color");
        return width && color ? "".concat(width, "px solid ").concat(color) : undefined;
    }; // Pass in "myShadow" and shorthand box shadow css will be generated based on
    // "myShadowOffsetX", "myShadowOffsetY", "myShadowBlur", "myShadowSpread",
    // and "myShadowColor" tokens
    helper.boxShadowCss = function(key) {
        var color = helper(key, "color");
        return color ? "".concat(helper(key, "offsetX"), "px ").concat(helper(key, "offsetY"), "px ").concat(helper(key, "blur"), "px ").concat(helper(key, "spread"), "px ").concat(color) : undefined;
    }; // Pass in "myMotion" and a single css property or array of properties and
    // shorthand transition css will be generated that animates those properties
    // based on "myMotionFunction" and "myMotionDuration" tokens
    helper.transitionCss = function(key, properties) {
        var transition = "".concat(helper(key, "duration"), " ").concat(helper(key, "function"));
        return Array.isArray(properties) ? properties.map(function(property) {
            return "".concat(property, " ").concat(transition);
        }).join(", ") : "".concat(properties, " ").concat(transition);
    };
    return helper;
}, 1);
/**
 * Gets icon data from a set of icon tokens
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * getIconFromTokens(tokens)
 * ```
 */ exports.getTokenHelper = getTokenHelper;
var getIconFromTokens = function getIconFromTokens(tokens) {
    return Object.keys(tokens).reduce(function(result, key) {
        if (key.indexOf("Data") > 0) result.data = tokens[key];
        else if (key.indexOf("Width") > 0) result.width = tokens[key];
        else if (key.indexOf("Height") > 0) result.height = tokens[key];
        return result;
    }, {});
};
/**
 * If you pass in a function that returns themed tokens when given a theme
 * object (e.g. any of our "component" tokens), this will call that function
 * with an empty theme object and filter out any tokens that are undefined. This
 * is useful for quickly accessing unthemed component tokens. Use this sparingly
 * as what is and is not themed may change in the future and require a refactor
 * of any code using this function.
 */ exports.getIconFromTokens = getIconFromTokens;
var getUnthemedTokens = function getUnthemedTokens(tokens) {
    var unthemedTokens = tokens({});
    return Object.keys(unthemedTokens).reduce(function(result, key) {
        if (unthemedTokens[key] !== undefined) result[key] = unthemedTokens[key];
        return result;
    }, {});
};
/**
 * Takes an object of tokens and removes the prefix from each token name (object
 * key). The result is returned with the first character of the new keys
 * lowercased.
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * removetokenPrefixes(tokens, "iconCheckmark")
 * ```
 */ exports.getUnthemedTokens = getUnthemedTokens;
var removeTokenPrefixes = function removeTokenPrefixes(tokens, prefix) {
    var match = new RegExp("^".concat(prefix));
    return Object.keys(tokens).reduce(function(result, key) {
        if (match.test(key)) result[(0, _lowerFirst["default"])(key.replace(match, ""))] = tokens[key];
        return result;
    }, {});
};
/**
 * Memoize f(tokens, props) that is used extensively throughout meridian components,
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * @example
 * const style = memoizeTokenStyles((t, {a, b}) => css({a, b}), ["a", "b"])
 * style(tokens, {a, b})
 */ exports.removeTokenPrefixes = removeTokenPrefixes;
var memoizeTokenStyles = function memoizeTokenStyles(f, keys) {
    /* eslint-disable-next-line rulesdir/no-partial-memoization */ var fn = (0, _functional.memoize)(function(t) {
        return (0, _functional.memoizeByKeys)(function(props) {
            return f(t, props);
        }, keys);
    });
    return function(t, props) {
        return fn(t)(props);
    };
};
exports.memoizeTokenStyles = memoizeTokenStyles;

},{"f1d7cc11e9f2e49d":"fk2Bw","d2e4fcdcdd997912":"5BCpK","f038a18613e4cdd3":"bBqL7","8076e58721913b63":"hiVOQ","448bbe65229cf1b0":"eKpY2"}],"5BCpK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("93437112282854a8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _upperFirst = _interopRequireDefault(require("1fe4b45c36f858f0"));
var pascalCase = function pascalCase(strings) {
    return strings.map(_upperFirst["default"]).join("");
};
var _default = pascalCase;
exports["default"] = _default;

},{"93437112282854a8":"fk2Bw","1fe4b45c36f858f0":"bBqL7"}],"bBqL7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var upperFirst = function upperFirst(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};
var _default = upperFirst;
exports["default"] = _default;

},{}],"hiVOQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var lowerFirst = function lowerFirst(str) {
    return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
};
var _default = lowerFirst;
exports["default"] = _default;

},{}],"eKpY2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.memoize = memoize;
exports.memoizeCurry = memoizeCurry;
exports.memoizeByKeys = memoizeByKeys;
exports.memoizeArray = memoizeArray;
/**
 * Author: shekwong@
 */ var END = new Object();
/**
 * Memoize a function with one argument.
 *
 * @example
 * const square = a => a * a
 * const memoizedSquare = memoize(square)
 * memoizedSquare(2) // 4
 */ function memoize(f) {
    var memo = new Map();
    return function(i) {
        if (memo.has(i)) return memo.get(i);
        var result = f(i);
        memo.set(i, result);
        return result;
    };
}
/**
 * Memoize a function with N args by currying it
 *
 * @example
 * const multiply = (a, b) => a * b
 * const memoizedMultiply = memoize(multiply, 1)
 * memoizedMultiply(2)(3) // 6
 */ function memoizeCurry(f, depth) {
    var a = f;
    if (depth == 0) return memoize(a);
    return memoize(function(x) {
        return memoizeCurry(a.bind(null, x), depth - 1);
    });
}
/**
 * A helper function used by memoizeByKeys.
 */ function memoizeByKeysCurry(f, resolver, depth) {
    var a = f;
    if (depth == 0) return memoize(resolver);
    return memoize(function(x) {
        return memoizeByKeysCurry(a.bind(null, x), resolver, depth - 1);
    });
}
/**
 * Memoize a function that accepts an object as its only argument. You must
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * NOTE: This can only support properties in the object that are simple (e.g.
 * strings, numbers, booleans, not nested objects or arrays).
 *
 * @example
 * const multiply = ({ a, b }) => a * b
 * cont memoizedMultiply = memoizeByKeys(multiply, ["a", "b"])
 * memoizedMultiply({ a: 2, b: 3 }) // 6
 */ function memoizeByKeys(f, keys) {
    var args = undefined;
    var g = memoizeByKeysCurry(f, function() {
        return f(args);
    }, keys.length - 1);
    return function(a) {
        if (!a) {
            var _c = g;
            keys.forEach(function() {
                _c = _c(undefined);
            });
            return _c;
        }
        args = a;
        var c = g;
        keys.forEach(function(k) {
            c = c(args[k]);
        });
        return c;
    };
}
/**
 * A helper function used by memoizeArray.
 */ function memoizeByVarArgsCurry(f) {
    var a = f;
    return memoize(function(x) {
        return x === END ? a() : memoizeByVarArgsCurry(a.bind(null, x));
    });
}
/**
 * Memoize a function that accepts an array as its only argument.
 *
 * @example
 * const multiply = numbers => numbers.reduce((result, num) => result * num)
 * cont memoizedMultiply = memoizeArray(multiply)
 * memoizedMultiply([2, 3, 4]) // 24
 */ function memoizeArray(f) {
    var memoized = memoizeByVarArgsCurry(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return f(args);
    });
    return function(vals) {
        var g = memoized;
        vals.forEach(function(v) {
            g = g(v);
        });
        return g(END);
    };
}

},{}],"gJQuD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("49c06e9809b4e81");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _button = _interopRequireDefault(require("51e1615d4afe00c"));
var _default = _button["default"];
exports["default"] = _default;

},{"49c06e9809b4e81":"fk2Bw","51e1615d4afe00c":"hGlye"}],"hGlye":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("83b9527fb09ffddb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("7d3dd53e938a4bef"));
var _react = _interopRequireDefault(require("bf508f44b221178"));
var _propTypes = _interopRequireDefault(require("9c3900cc140e0fa1"));
var _emotion = require("a3afc2aba978d559");
var _button = _interopRequireDefault(require("8b29caa7443be27c"));
var _theme = require("cc4b41e7e30ee916");
var _clickable = _interopRequireDefault(require("bc120a48dd5fad31"));
var _useFocus2 = _interopRequireDefault(require("2970bef665b33ab4"));
var _icon = _interopRequireDefault(require("243ee9f738ed16b1"));
var _buttonStyles = require("dd3a3b43405dccc3");
var _text = _interopRequireDefault(require("4f303be68fd920ef"));
var _token = require("b8affac75887ccf4");
var _isColorDark = _interopRequireDefault(require("d59e55d83f78c4e"));
var _isElementOf = _interopRequireDefault(require("a15fe45c265d4d13"));
var _filterPropsByPrefix = _interopRequireDefault(require("b2064712813fdfd9"));
var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, type = _ref.type, focus = _ref.focus, disabled = _ref.disabled, minWidth = _ref.minWidth, _ref$backdropColor = _ref.backdropColor, backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor, iconOnly = _ref.iconOnly, circular = _ref.circular;
    var state = disabled ? "disabled" : "default";
    var linkOrIcon = type === "link" || type === "icon";
    var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
    var borderColor = t("borderColor", [
        type,
        state
    ]);
    var borderWidth = borderColor ? t("borderWidth") : 0;
    var borderStyle = borderColor ? "solid" : undefined;
    var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
    return (0, _emotion.css)((0, _text["default"])(t, {
        fontSize: size
    }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
        type: type,
        backdrop: backdrop
    }) : (0, _buttonStyles.defaultStyles)(t, {
        type: type,
        backdrop: backdrop
    }), {
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        outline: "none",
        position: "relative",
        minWidth: minWidth,
        height: t("height", size),
        // Make icon-only buttons square w/ no padding and all other buttons
        // flexible with padding.
        width: iconOnly ? t("height", size) : undefined,
        flexShrink: iconOnly ? 0 : undefined,
        padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
        transition: t.transitionCss("motion", [
            "color",
            "background-color",
            "border-color"
        ]),
        borderRadius: borderRadius,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        whiteSpace: "nowrap",
        // HACK: IE11 will only show a pseudo element on a button if
        // overflow is set to visible, and our focus ring is displayed with a
        // pseudo element.
        overflow: "visible",
        "& > * + *": {
            marginLeft: t("spacingInsetHorizontal", size)
        },
        ":hover": !disabled ? (0, _buttonStyles.hoverStyles)(t, {
            type: type,
            backdrop: backdrop
        }) : undefined,
        ":active": !disabled ? (0, _buttonStyles.activeStyles)(t, {
            type: type,
            backdrop: backdrop
        }) : undefined
    }, !disabled ? (0, _buttonStyles.focusStyles)(t, {
        focus: focus,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        backdropColor: backdropColor,
        linkOrIcon: linkOrIcon
    }) : undefined);
}, [
    "size",
    "type",
    "focus",
    "disabled",
    "backdropColor",
    "minWidth",
    "iconOnly",
    "circular"
]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.
var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
    var arr = _react["default"].Children.toArray(children);
    return arr.length > 1 ? arr.map(function(child, index) {
        return typeof child === "string" ? /*#__PURE__*/ _react["default"].createElement("span", {
            key: index
        }, child) : child;
    }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */ var Button = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_button["default"], "button"); // Does the button contain only an icon (no text)?
    var iconOnly = _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon/link buttons so that they're offset from the
    // edge of the icon/text (which is visible), not the edge of the button
    // element (which is not visible). The magic "24" for the icon variant is the
    // size of a standard icon. By subtracting that from the height of the button
    // and dividing by 2 we get the distance between the invisible edge of the
    // button and the visible edge of the icon.
    var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : props.type === "link" ? -(t("height", props.size) - t("fontSize", props.size)) / 2 : undefined;
    var _useFocus = (0, _useFocus2["default"])(props), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
        ref: ref,
        className: (0, _emotion.cx)(styles(t, {
            type: props.type,
            size: props.size,
            disabled: props.disabled,
            circular: props.circular,
            backdropColor: props.backdropColor,
            minWidth: props.minWidth,
            focus: focus && focusTrigger === "keyboard",
            iconOnly: iconOnly
        }), props.className),
        disabled: props.disabled,
        id: props.id,
        href: props.href,
        rel: props.rel,
        target: props.target,
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        propagateClickEvent: props.propagateClickEvent,
        tabIndex: props.tabIndex,
        download: props.download,
        submit: props.submit,
        "aria-hidden": props["aria-hidden"] || undefined,
        "aria-label": props.label || undefined,
        "mdn-popover-offset": popoverOffset
    }, focusProps), wrapStringSiblingsInSpans(props.children));
});
Button.displayName = "Button";
Button.propTypes = {};
Button.defaultProps = {
    propagateClickEvent: true,
    size: "medium",
    type: "primary"
};
var _default = Button;
exports["default"] = _default;

},{"83b9527fb09ffddb":"fk2Bw","7d3dd53e938a4bef":"ef0K4","bf508f44b221178":"6uln9","9c3900cc140e0fa1":"cnMFu","a3afc2aba978d559":"4deck","8b29caa7443be27c":"4wQlF","cc4b41e7e30ee916":"eM9hO","bc120a48dd5fad31":"iia1p","2970bef665b33ab4":"ZdEsX","243ee9f738ed16b1":"jPx5F","dd3a3b43405dccc3":"5UHfv","4f303be68fd920ef":"13UMz","b8affac75887ccf4":"atHRo","d59e55d83f78c4e":"jvUml","a15fe45c265d4d13":"brP3O","b2064712813fdfd9":"8cR2N"}],"ef0K4":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
module.exports = _extends;

},{}],"iia1p":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8ccefb3384b31d5f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _clickable = _interopRequireDefault(require("ee66378769806df9"));
var _default = _clickable["default"];
exports["default"] = _default;

},{"8ccefb3384b31d5f":"fk2Bw","ee66378769806df9":"7z2Cb"}],"7z2Cb":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("29c24114ce40343a");
var _interopRequireDefault = require("c736cd330f6d0250");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("85015ce458864edd"));
var _react = _interopRequireWildcard(require("4af0879e1dbae121"));
var _propTypes = _interopRequireDefault(require("46ec7fd4e315db73"));
var _emotion = require("3a33be26fffcf7a5");
var _keycode = _interopRequireDefault(require("fd873071987b0390"));
var _noop = _interopRequireDefault(require("95db726d0d21afa0"));
var _buttonReset = _interopRequireDefault(require("d5108d6a24b0d6b4"));
var _linkReset = _interopRequireDefault(require("21d040dd09c83805"));
var _functional = require("bdb4594af3edf23c");
var _cxMemoized = _interopRequireDefault(require("b1c0ef9c58df8d9e"));
var _filterPropsByPrefix = _interopRequireDefault(require("6114d110f0b43183"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _functional.memoizeByKeys)(function(_ref) {
    var tag = _ref.tag, disabled = _ref.disabled;
    return (0, _emotion.css)({
        button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
            // HACK: IE offsets the contents of buttons on mouse down (in the active
            // state) to create a faux 3D effect. These styles are applied to every
            // child of  the button in order to counter this effect so that we are
            // the masters of our own button-content-position-destiny.
            "& > *": {
                position: "relative"
            }
        }),
        a: _linkReset["default"]
    }[tag], {
        cursor: disabled ? "not-allowed" : "pointer",
        outline: "none"
    });
}, [
    "tag",
    "disabled"
]);
var getPropsForNativeLink = function getPropsForNativeLink(props) {
    return {
        href: props.disabled ? undefined : props.href,
        target: props.target,
        rel: props.rel,
        "aria-disabled": props.disabled || undefined,
        role: props.role !== "link" ? props.role : undefined,
        tabIndex: props.disabled ? "-1" : props.tabIndex,
        onClick: props.onClick
    };
};
var getPropsForNativeButton = function getPropsForNativeButton(props) {
    return {
        disabled: props.disabled || undefined,
        type: props.submit ? "submit" : "button",
        role: props.role !== "button" ? props.role : undefined,
        tabIndex: props.tabIndex,
        onClick: props.onClick
    };
};
var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
    return {
        href: props.disabled ? undefined : props.href,
        target: props.target,
        rel: props.rel,
        "aria-disabled": props.disabled || undefined,
        tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
        role: props.role,
        onKeyDown: function onKeyDown(event) {
            var key = (0, _keycode["default"])(event);
            var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links
            if (focus && key === "enter") props.onClick(event);
             // Disable scrolling on space-key-down for buttons
            if (focus && key === "space" && props.role === "button") event.preventDefault();
        },
        onKeyUp: props.role === "button" ? function(event) {
            var key = (0, _keycode["default"])(event);
            var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons
            if (focus && key === "space") // NOTE: event.preventDefault() will have already been called at
            // this point to keep the space key from triggering a scroll
            // (see `onKeyDown` above), so instead of passing the original
            // event this will pass a mock event that looks like it hasn't
            // had preventDefault() called.
            props.onClick({
                defaultPrevented: false,
                preventDefault: _noop["default"]
            });
        } : undefined,
        onClick: props.onClick
    };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */ var simulateLinkClick = function simulateLinkClick(linkAttributes) {
    // Create a link element that we can click
    var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
    // React normally does this for us, but the DOM doesn't so we have to do it
    // manually to avoid things like `download="undefined"` in the DOM.
    Object.assign(link, Object.keys(linkAttributes).reduce(function(result, key) {
        if (linkAttributes[key] !== undefined) result[key] = linkAttributes[key];
        return result;
    }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
    // FF)
    document.body.appendChild(link); // Trigger a click on the link
    link.click(); // Remove the link from the dom.
    document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */ var Clickable = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var onClick = props.onClick, href = props.href, target = props.target, submit = props.submit, disabled = props.disabled, rel = props.rel, download = props.download, tabIndex = props.tabIndex, propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
    // DOM
    var nativeRole = href && !submit ? "link" : "button";
    var role = props.role !== undefined ? props.role : nativeRole;
    var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-",
        "mdn-",
        "aria-"
    ]); // What happens when the Clickable is clicked. Pretty key.
    var onClickTag = (0, _react.useCallback)(function(event) {
        // If the default event behavior was already prevented (e.g. by a nested
        // Clickable inside this one) then don't do anything
        if (!event.defaultPrevented) {
            var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
            // custom onClick handler, or do not have any native browser behavior.
            // This keeps any parent Clickable elements higher up in the DOM tree from
            // also handling the event. This doesn't stop propagation though - other
            // elements may want to react to the event even if its default behavior
            // was cancelled.
            if (disabled || onClick || !nativeBehavior) event.preventDefault();
             // If we were explicitly told to stop propagation on the event then
            // do so now
            if (!propagateClickEvent) event.stopPropagation();
             // If we're not disabled then handle the click
            if (!disabled) {
                // If the element has native behavior and we don't have a custom
                // onClick handler, then fall back to the native behavior (and stop
                // propagation to keep anyone else from handling the click).
                if (nativeBehavior && !onClick) event.stopPropagation();
                else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) simulateLinkClick({
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    download: download
                });
                else if (onClick) onClick(href);
                else if (href) simulateLinkClick({
                    href: href,
                    target: target,
                    rel: rel,
                    download: download
                });
            }
        }
    }, [
        onClick,
        href,
        target,
        submit,
        disabled,
        tag,
        rel,
        download,
        propagateClickEvent
    ]); // Generate props that are specific to the tag we're rendering (e.g. a link,
    // a button, and a div will all require different props in order to acheive
    // a particular behavior). Memoize these to reduce the number of large objects
    // created on each render.
    var clickableProps = (0, _react.useMemo)(function() {
        var props = {
            onClick: onClickTag,
            role: role,
            disabled: disabled,
            href: href,
            rel: rel,
            target: target,
            tabIndex: tabIndex,
            submit: submit
        };
        return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
    }, [
        tag,
        onClickTag,
        role,
        disabled,
        href,
        rel,
        target,
        tabIndex,
        submit
    ]); // HACK: Wrap string children in a span so that the IE positioning
    // hack (see the button styles above) can take effect
    var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function(child) {
        return typeof child !== "string";
    }).length === 0;
    return /*#__PURE__*/ _react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        onMouseMove: props.onMouseMove,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        id: props.id,
        download: props.download,
        title: props.title,
        className: (0, _cxMemoized["default"])(styles({
            tag: tag,
            disabled: props.disabled
        }), props.className),
        ref: ref
    }), applyIE11StyleHack ? /*#__PURE__*/ _react["default"].createElement("span", null, props.children) : props.children);
});
Clickable.displayName = "Clickable";
Clickable.propTypes = {};
Clickable.defaultProps = {
    propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

},{"29c24114ce40343a":"k8mdG","c736cd330f6d0250":"fk2Bw","85015ce458864edd":"hcG56","4af0879e1dbae121":"6uln9","46ec7fd4e315db73":"cnMFu","3a33be26fffcf7a5":"4deck","fd873071987b0390":"bL2S4","95db726d0d21afa0":"7osqO","d5108d6a24b0d6b4":"izQ0Z","21d040dd09c83805":"1jWCk","bdb4594af3edf23c":"eKpY2","b1c0ef9c58df8d9e":"6U7id","6114d110f0b43183":"8cR2N"}],"bL2S4":[function(require,module,exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && "object" === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ("number" === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === "string") {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === "number") return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes["f" + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes["numpad " + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

},{}],"7osqO":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"izQ0Z":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var buttonReset = {
    display: "inline-block",
    padding: 0,
    border: 0,
    outline: "none",
    backgroundColor: "transparent",
    textAlign: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    WebkitAppearance: "none",
    WebkitMarginBefore: 0,
    WebkitMarginAfter: 0,
    WebkitMarginStart: 0,
    WebkitMarginEnd: 0,
    "::-moz-focus-inner": {
        border: 0
    }
};
var _default = buttonReset;
exports["default"] = _default;

},{}],"1jWCk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var linkReset = {
    display: "inline-block",
    outline: "none",
    textDecoration: "none",
    color: "inherit",
    cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

},{}],"6U7id":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _emotion = require("398114fb0d59e079");
var _functional = require("4e5872af069f880c");
var cxMemoizedCurried = (0, _functional.memoizeCurry)(_emotion.cx, 1);
/**
 * A memoized version of cx. Only supports two classes.
 */ var cxMemoized = function cxMemoized(a, b) {
    return cxMemoizedCurried(a)(b);
};
var _default = cxMemoized;
exports["default"] = _default;

},{"398114fb0d59e079":"4deck","4e5872af069f880c":"eKpY2"}],"8cR2N":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Takes an object of props and filters them down to only the props with names
 * that start with one of a given set of prefixes.
 */ var filterPropsByPrefix = function filterPropsByPrefix(props, prefixes) {
    return Object.keys(props).filter(function(name) {
        return prefixes.some(function(prefix) {
            return name.indexOf(prefix) === 0;
        });
    }).reduce(function(result, name) {
        result[name] = props[name];
        return result;
    }, {});
};
var _default = filterPropsByPrefix;
exports["default"] = _default;

},{}],"ZdEsX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("86e7d46be5052f2");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _useFocus = _interopRequireDefault(require("ac6a6404282c3202"));
var _default = _useFocus["default"];
exports["default"] = _default;

},{"86e7d46be5052f2":"fk2Bw","ac6a6404282c3202":"bPeWO"}],"bPeWO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9085e61ecf9a8c13");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("aec657fe048dbba6"));
var _react = require("9dcdb81fb07a7b72");
var _noop = _interopRequireDefault(require("dbb5a92124128f36"));
/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */ /**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */ /**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */ /**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */ var useFocus = function useFocus() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, disabled = _ref.disabled, multipleNodes = _ref.multipleNodes, _ref$onBlur = _ref.onBlur, onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur, _ref$onFocus = _ref.onFocus, onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;
    var _useState = (0, _react.useState)([
        false,
        null
    ]), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2), focus = _useState2$[0], focusDescendent = _useState2$[1], setFocus = _useState2[1];
    var focusedNode = (0, _react.useRef)();
    var blurTimeout = (0, _react.useRef)();
    var onFocus = (0, _react.useCallback)(function(event) {
        clearTimeout(blurTimeout.current);
        focusedNode.current = event ? event.target : undefined;
        var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;
        if (!focus || focusDescendent !== nextFocusDescendent) setFocus([
            true,
            nextFocusDescendent
        ]);
        if (!focus) onFocusCallback(event, getInteractionDevice());
    }, [
        onFocusCallback,
        focus,
        focusDescendent
    ]);
    var onBlurComplete = (0, _react.useCallback)(function(event) {
        setFocus([
            false,
            false
        ]);
        onBlurCallback(event, getInteractionDevice());
    }, [
        onBlurCallback
    ]);
    var onBlur = (0, _react.useCallback)(function(event) {
        if (event && multipleNodes) {
            clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
            // multiple elements. Instead, wait briefly using setTimeout to see if
            // onFocus is called for another element we're tracking. If it is then
            // we consider the state to still be focused, otherwise we can move ahead
            // and call `onBlurComplete`.
            event.persist();
            blurTimeout.current = setTimeout(function() {
                if (event.target === focusedNode.current) onBlurComplete(event);
            }, 0);
        } else onBlurComplete(event);
    }, [
        onBlurComplete,
        multipleNodes
    ]);
    var focusProps = (0, _react.useMemo)(function() {
        return {
            onFocus: onFocus,
            onBlur: onBlur
        };
    }, [
        onFocus,
        onBlur
    ]);
    (0, _react.useEffect)(function() {
        // When the node(s) are focused and we flip from enabled to disabled, clear
        // the focus (see the docs for the disabled param re: why this is
        // necessary).
        if (focus && disabled) setFocus([
            false,
            false
        ]);
         // Clear the timeout when unmounting
        return function() {
            return clearTimeout(blurTimeout.current);
        };
    }, [
        focus,
        disabled
    ]);
    return {
        focus: focus,
        focusProps: focusProps,
        focusDescendent: focusDescendent,
        focusTrigger: getInteractionDevice()
    };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */ var getInteractionDevice = function() {
    var device = "keyboard";
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("mousedown", function() {
            return device = "mouse";
        }, true);
        window.addEventListener("keydown", function() {
            return device = "keyboard";
        }, true);
    }
    return function() {
        return device;
    };
}();
var _default = useFocus;
exports["default"] = _default;

},{"9085e61ecf9a8c13":"fk2Bw","aec657fe048dbba6":"19SJN","9dcdb81fb07a7b72":"6uln9","dbb5a92124128f36":"7osqO"}],"jPx5F":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a27bcced5c610d2c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _icon = _interopRequireDefault(require("e6624cb29793268f"));
var _default = _icon["default"];
exports["default"] = _default;

},{"a27bcced5c610d2c":"fk2Bw","e6624cb29793268f":"iBbvG"}],"iBbvG":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8b1a465162f45067");
var _interopRequireWildcard = require("91cd7c1bb90bfee9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("535cd59dff250e36"));
var _propTypes = _interopRequireDefault(require("c0ffcc29b0b9e62d"));
var _emotion = require("7f6b1fc6eb8331c6");
var _token = require("6ad8e1b246cfec01");
var _functional = require("c3e59ba3ccd1b547");
var _cxMemoized = _interopRequireDefault(require("ef5f801d3a03c16e"));
var styles = (0, _functional.memoize)(function(size) {
    return (0, _emotion.css)({
        position: "relative",
        flexShrink: 0,
        display: "inline-block",
        width: size,
        height: size,
        verticalAlign: "middle",
        // Don't show the icon's label
        fontSize: 0,
        // Center the icon image
        "& svg": {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translateY(-50%) translateX(-50%)"
        }
    });
});
var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};
var Icon = /*#__PURE__*/ _react["default"].memo(/*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens), data = _getIconFromTokens.data, width = _getIconFromTokens.width, height = _getIconFromTokens.height;
    var svg = decodeURIComponent(data.replace(/^data:image\/svg\+xml,/, "")) // Add aria-hidden="true" so that screen readers ignore the underlying svg
    // (we label the parent span) and focusable="false" because IE11 defaults
    // to adding SVGs to the tab order
    .replace(/<svg/, '<svg aria-hidden="true" focusable="false"');
    var html = (0, _react.useMemo)(function() {
        return {
            __html: svg
        };
    }, [
        svg
    ]);
    var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
    var simpleChildren = props.children === undefined || typeof props.children === "string";
    return /*#__PURE__*/ _react["default"].createElement("span", {
        role: "img",
        "aria-hidden": !props.children ? true : undefined,
        "aria-label": simpleChildren ? props.children : undefined,
        className: (0, _cxMemoized["default"])(styles(size), props.className),
        tabIndex: props.tabIndex,
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        ref: ref,
        dangerouslySetInnerHTML: simpleChildren ? html : undefined
    }, simpleChildren ? null : /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement("span", {
        dangerouslySetInnerHTML: html
    }), props.children));
}), shouldNotUpdate);
Icon.sizes = {
    small: 16,
    large: 24
};
Icon.displayName = "Icon";
Icon.propTypes = {};
Icon.sizes = {
    small: 16,
    large: 24
};
var _default = Icon;
exports["default"] = _default;

},{"8b1a465162f45067":"fk2Bw","91cd7c1bb90bfee9":"k8mdG","535cd59dff250e36":"6uln9","c0ffcc29b0b9e62d":"cnMFu","7f6b1fc6eb8331c6":"4deck","6ad8e1b246cfec01":"atHRo","c3e59ba3ccd1b547":"eKpY2","ef5f801d3a03c16e":"6U7id"}],"5UHfv":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("95a1d52def2b9d30");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disabledStyles = exports.defaultStyles = exports.focusStyles = exports.hoverStyles = exports.activeStyles = void 0;
var _focusRing = _interopRequireDefault(require("3d604f34073d2d0a"));
var getStyles = function getStyles(t, _ref) {
    var type = _ref.type, backdrop = _ref.backdrop, state = _ref.state;
    return {
        color: t("foregroundColor", [
            type,
            backdrop,
            state
        ]),
        backgroundColor: t("backgroundColor", [
            type,
            backdrop,
            state
        ]),
        borderColor: t("borderColor", [
            type,
            state
        ])
    };
};
var activeStyles = function activeStyles(t, _ref2) {
    var type = _ref2.type, backdrop = _ref2.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "pressed"
    });
};
exports.activeStyles = activeStyles;
var hoverStyles = function hoverStyles(t, _ref3) {
    var type = _ref3.type, backdrop = _ref3.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "hover"
    });
};
exports.hoverStyles = hoverStyles;
var defaultStyles = function defaultStyles(t, _ref4) {
    var type = _ref4.type, backdrop = _ref4.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "default"
    });
};
exports.defaultStyles = defaultStyles;
var disabledStyles = function disabledStyles(t, _ref5) {
    var type = _ref5.type, backdrop = _ref5.backdrop;
    return getStyles(t, {
        type: type,
        backdrop: backdrop,
        state: "disabled"
    });
};
exports.disabledStyles = disabledStyles;
var focusStyles = function focusStyles(t, _ref6) {
    var focus = _ref6.focus, borderWidth = _ref6.borderWidth, borderRadius = _ref6.borderRadius, backdropColor = _ref6.backdropColor, linkOrIcon = _ref6.linkOrIcon;
    return (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        gapColor: backdropColor,
        dropShadow: !linkOrIcon,
        offset: t("focusOutlineOffset")
    });
};
exports.focusStyles = focusStyles;

},{"95a1d52def2b9d30":"fk2Bw","3d604f34073d2d0a":"7yXmF"}],"7yXmF":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d19be7c1cf14562b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("18fc298045a25259"));
var _focusRing = _interopRequireDefault(require("1ff3167106267e35"));
var _elevation = require("ee230d28487141ad");
var _token = require("f80e4766142b4945");
/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */ var focusRing = function focusRing(themeTokens, _ref) {
    var _ref2;
    var focus = _ref.focus, error = _ref.error, dropShadow = _ref.dropShadow, gapColor = _ref.gapColor, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, _ref$borderWidth = _ref.borderWidth, borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius, _ref$hoverSelector = _ref.hoverSelector, hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector;
    var tokens = (0, _focusRing["default"])(themeTokens);
    var state = focus ? "focus" : error ? "error" : undefined;
    var width = (0, _token.getToken)(tokens, "focusRingWidth");
    var color = (0, _token.getToken)(tokens, "focusRingColor", state);
    var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
    // element then use an inset box shadow.
    var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
    var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
    return _ref2 = {
        // The focuseable element needs to be relatively positioned so that we can
        // absolutely position the focus ring
        position: "relative",
        // If the ring entirely overlaps the focused element's border, turn the
        // element's border off to avoid artifacts near the rounded corners
        borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
    }, (0, _defineProperty2["default"])(_ref2, hoverSelector, dropShadowCss && !color ? {
        boxShadow: dropShadowCss
    } : undefined), (0, _defineProperty2["default"])(_ref2, hoverSelector.split(",").map(function(selector) {
        return "".concat(selector.trim(), ":after");
    }).join(", "), dropShadowCss && state === "error" ? {
        boxShadow: dropShadowAndGapShadowCss
    } : undefined), (0, _defineProperty2["default"])(_ref2, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref2, "&:after", color ? {
        content: "''",
        pointerEvents: "none",
        position: "absolute",
        top: -offset - borderWidth,
        right: -offset - borderWidth,
        bottom: -offset - borderWidth,
        left: -offset - borderWidth,
        border: "".concat(width, "px solid ").concat(color),
        borderRadius: typeof borderRadius === "string" ? borderRadius.split(" ").map(function(radius) {
            var r = parseInt(radius);
            return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
        }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0,
        boxShadow: state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss
    } : undefined), _ref2;
};
var _default = focusRing;
exports["default"] = _default;

},{"d19be7c1cf14562b":"fk2Bw","18fc298045a25259":"hcG56","1ff3167106267e35":"dixtu","ee230d28487141ad":"dKmTh","f80e4766142b4945":"atHRo"}],"13UMz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c85498dd2ce31cab");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _text = _interopRequireDefault(require("1c9b35106ceebd38"));
var text = function text(t) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var tokens = (0, _text["default"])(t.tokens);
    return {
        color: t("foregroundColor", keys.color) || t.tokens.themeForegroundPrimaryDefault,
        fontFamily: t("fontFamily", keys.fontFamily) || tokens.textFontFamilyAmazonEmber,
        fontSize: t("fontSize", keys.fontSize) || tokens.textFontSizeB300,
        fontWeight: t("fontWeight", keys.fontWeight) || tokens.textFontWeightB300,
        lineHeight: t("lineHeight", keys.lineHeight) || tokens.textLineHeightB300
    };
};
var _default = text;
exports["default"] = _default;

},{"c85498dd2ce31cab":"fk2Bw","1c9b35106ceebd38":"9Sdvg"}],"jvUml":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
    var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal
    var r = decimal >> 16 & 0xff; // extract red
    var g = decimal >> 8 & 0xff; // extract green
    var b = decimal >> 0 & 0xff; // extract blue
    return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};
var isColorDark = function isColorDark(hex) {
    return getBrightness(hex) < 128;
};
var _default = isColorDark;
exports["default"] = _default;

},{}],"brP3O":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 * import Radio from "@amzn/meridian/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */ var isSameComponent = function isSameComponent(a, b) {
    if (!a || !b) // Bail if either component wasn't provided
    return false;
    else {
        var aName, bName;
        // Just check if the components reference the same class/function.
        return a === b;
    }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */ var isElementOf = function isElementOf(component) {
    return function(element) {
        if (!component || !element) // Bail if either the component or element wasn't provided
        return false;
        else if (element.type && element.type.WrappedComponent) // If the element's component has a static WrappedComponent property, assume
        // we're working with a HoC and compare the wrapped component instead of the
        // HoC component. The connect HoC from redux uses this pattern, so this
        // check ensures that isElementOf works correctly on redux-connected
        // components.
        return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
        else // If WrappedComonent isn't set do a normal comparison of element.type
        // (the component that element was instantiated from) and component.
        return isSameComponent(element.type, component);
    };
};
var _default = isElementOf;
exports["default"] = _default;

},{}],"iqUT6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9dff2382c61b7c8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBoundingFocusNodes = exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("45aac99b29bcf3de"));
var _findIndex = _interopRequireDefault(require("827f242f8098281"));
var _findLastIndex = _interopRequireDefault(require("6762a99420d226f5"));
var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Returns true if a node can be focused
 */ var canFocusNode = function canFocusNode(node) {
    return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};
exports.canFocusNode = canFocusNode;
var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
    return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};
exports.canKeyboardFocusNode = canKeyboardFocusNode;
var getFocusNodes = function getFocusNodes(node) {
    return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};
exports.getFocusNodes = getFocusNodes;
var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
    return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */ exports.getKeyboardFocusNodes = getKeyboardFocusNodes;
var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
    var nodes = [
        canFocusNode(node) ? node : undefined
    ].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
    var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
    var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
    var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
    var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
    return {
        startNodes: startNodes,
        endNodes: endNodes
    };
};
exports.getBoundingFocusNodes = getBoundingFocusNodes;

},{"9dff2382c61b7c8":"fk2Bw","45aac99b29bcf3de":"d5WW9","827f242f8098281":"caIAP","6762a99420d226f5":"gr94G"}],"d5WW9":[function(require,module,exports) {
var arrayWithoutHoles = require("e0a46585c457482b");
var iterableToArray = require("9cbd7defa39cb86b");
var unsupportedIterableToArray = require("2db743c5b155b993");
var nonIterableSpread = require("aabd4824e68b2ead");
function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray;

},{"e0a46585c457482b":"fWZ8N","9cbd7defa39cb86b":"lduUk","2db743c5b155b993":"dutLm","aabd4824e68b2ead":"nuVhp"}],"fWZ8N":[function(require,module,exports) {
var arrayLikeToArray = require("b350cff0111f4cf2");
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles;

},{"b350cff0111f4cf2":"7qUYC"}],"lduUk":[function(require,module,exports) {
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
module.exports = _iterableToArray;

},{}],"nuVhp":[function(require,module,exports) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread;

},{}],"caIAP":[function(require,module,exports) {
var baseFindIndex = require("3516934061f278c"), baseIteratee = require("7d447839b827cf45"), toInteger = require("f0066e457202b032");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"3516934061f278c":"a7lSm","7d447839b827cf45":"3xVMK","f0066e457202b032":"9irPk"}],"a7lSm":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"3xVMK":[function(require,module,exports) {
var baseMatches = require("892db5e653994b3d"), baseMatchesProperty = require("fbb00f767ef871c"), identity = require("653f085338bf9e2c"), isArray = require("1c2ed4008c6694c8"), property = require("e0c1f98f80af41d7");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"892db5e653994b3d":"9V3EM","fbb00f767ef871c":"32Nfk","653f085338bf9e2c":"4Hzzf","1c2ed4008c6694c8":"6WNsH","e0c1f98f80af41d7":"cjGbD"}],"9V3EM":[function(require,module,exports) {
var baseIsMatch = require("cbcf0a2e5bc222a8"), getMatchData = require("8de393bcc6b3a41f"), matchesStrictComparable = require("83a9ca36a3b6807c");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"cbcf0a2e5bc222a8":"4R9o8","8de393bcc6b3a41f":"75J6J","83a9ca36a3b6807c":"hHzQd"}],"4R9o8":[function(require,module,exports) {
var Stack = require("f046174de698a1c2"), baseIsEqual = require("cc98b7e81bd532a7");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"f046174de698a1c2":"1PaXo","cc98b7e81bd532a7":"bi3RH"}],"1PaXo":[function(require,module,exports) {
var ListCache = require("e4c176d5e998282"), stackClear = require("75359c7620b6ee6f"), stackDelete = require("968b2124ba370a63"), stackGet = require("b2384d3860284159"), stackHas = require("fc082c8378e19831"), stackSet = require("72c8aa60b2daf9ef");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"e4c176d5e998282":"bqd8M","75359c7620b6ee6f":"8TRQE","968b2124ba370a63":"iDUpf","b2384d3860284159":"6sv0N","fc082c8378e19831":"7fzjX","72c8aa60b2daf9ef":"6C6bE"}],"bqd8M":[function(require,module,exports) {
var listCacheClear = require("c7c550d649031c71"), listCacheDelete = require("4d8d6b2753b72e3"), listCacheGet = require("b04f97a8e95bde85"), listCacheHas = require("493d0ba844760056"), listCacheSet = require("a4df531b136b753b");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"c7c550d649031c71":"koOoF","4d8d6b2753b72e3":"lxVIh","b04f97a8e95bde85":"a1Vvp","493d0ba844760056":"hTXc7","a4df531b136b753b":"03HN8"}],"koOoF":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"lxVIh":[function(require,module,exports) {
var assocIndexOf = require("618ace76bb4bc6ba");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"618ace76bb4bc6ba":"3G4KF"}],"3G4KF":[function(require,module,exports) {
var eq = require("267df46279a6aa4c");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"267df46279a6aa4c":"4rrYy"}],"4rrYy":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"a1Vvp":[function(require,module,exports) {
var assocIndexOf = require("e1d78d31287f6693");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"e1d78d31287f6693":"3G4KF"}],"hTXc7":[function(require,module,exports) {
var assocIndexOf = require("bdb2ea4b9fc11df3");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"bdb2ea4b9fc11df3":"3G4KF"}],"03HN8":[function(require,module,exports) {
var assocIndexOf = require("6d7a3abf7b0b27f8");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"6d7a3abf7b0b27f8":"3G4KF"}],"8TRQE":[function(require,module,exports) {
var ListCache = require("263eceb18513b314");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"263eceb18513b314":"bqd8M"}],"iDUpf":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"6sv0N":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"7fzjX":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"6C6bE":[function(require,module,exports) {
var ListCache = require("fd7c3a52e4782612"), Map = require("116a4ccd949f5db5"), MapCache = require("fc579b13a12a2d2a");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"fd7c3a52e4782612":"bqd8M","116a4ccd949f5db5":"fVjtR","fc579b13a12a2d2a":"blNRV"}],"fVjtR":[function(require,module,exports) {
var getNative = require("c9637fe8737db2ec"), root = require("18912c040291f033");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"c9637fe8737db2ec":"c1ipR","18912c040291f033":"9D9UF"}],"c1ipR":[function(require,module,exports) {
var baseIsNative = require("3c94999fa73d529"), getValue = require("235412b093fa0eb6");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"3c94999fa73d529":"5r2ZP","235412b093fa0eb6":"9MLCo"}],"5r2ZP":[function(require,module,exports) {
var isFunction = require("9fffb2a163d6ce7"), isMasked = require("e8bed4c338d939e4"), isObject = require("b8ad972dec00a1e6"), toSource = require("e6bb9c9d953d7bad");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"9fffb2a163d6ce7":"68TL1","e8bed4c338d939e4":"hSKme","b8ad972dec00a1e6":"1Khis","e6bb9c9d953d7bad":"5ZadQ"}],"68TL1":[function(require,module,exports) {
var baseGetTag = require("a22bdca4f295a7"), isObject = require("52e5eb80a85a49f7");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"a22bdca4f295a7":"8nzKY","52e5eb80a85a49f7":"1Khis"}],"1Khis":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"hSKme":[function(require,module,exports) {
var coreJsData = require("36d78572ac8f5990");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"36d78572ac8f5990":"c6zv7"}],"c6zv7":[function(require,module,exports) {
var root = require("c21962209dd57b9b");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"c21962209dd57b9b":"9D9UF"}],"5ZadQ":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"9MLCo":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"blNRV":[function(require,module,exports) {
var mapCacheClear = require("accd0e75f50ba45a"), mapCacheDelete = require("2f064444af5d4020"), mapCacheGet = require("cbea15c4d9a758d"), mapCacheHas = require("8bf95eb27252b3fb"), mapCacheSet = require("4e56702f5b77be0c");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"accd0e75f50ba45a":"eqm5F","2f064444af5d4020":"jPYpC","cbea15c4d9a758d":"irrfb","8bf95eb27252b3fb":"5w7TZ","4e56702f5b77be0c":"aYr2y"}],"eqm5F":[function(require,module,exports) {
var Hash = require("4d220d890b6bcc4c"), ListCache = require("ce1dfffea5b90fe4"), Map = require("2c1f49863049f891");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4d220d890b6bcc4c":"2ghrS","ce1dfffea5b90fe4":"bqd8M","2c1f49863049f891":"fVjtR"}],"2ghrS":[function(require,module,exports) {
var hashClear = require("96df15d2b56b2a19"), hashDelete = require("58100a014435cbe5"), hashGet = require("1da5b79abd582087"), hashHas = require("51990b86fa57a98b"), hashSet = require("2add47514f05a58");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"96df15d2b56b2a19":"8A6EC","58100a014435cbe5":"i4MyT","1da5b79abd582087":"le99L","51990b86fa57a98b":"VXRDU","2add47514f05a58":"1RG8D"}],"8A6EC":[function(require,module,exports) {
var nativeCreate = require("2d8dd714fce8fbf8");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"2d8dd714fce8fbf8":"bP9Se"}],"bP9Se":[function(require,module,exports) {
var getNative = require("5f876310dc612c97");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"5f876310dc612c97":"c1ipR"}],"i4MyT":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"le99L":[function(require,module,exports) {
var nativeCreate = require("8cd42219d463c2b2");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"8cd42219d463c2b2":"bP9Se"}],"VXRDU":[function(require,module,exports) {
var nativeCreate = require("139f5024312add88");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"139f5024312add88":"bP9Se"}],"1RG8D":[function(require,module,exports) {
var nativeCreate = require("4fb208abd9155323");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"4fb208abd9155323":"bP9Se"}],"jPYpC":[function(require,module,exports) {
var getMapData = require("20d584e5d66c4baf");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"20d584e5d66c4baf":"alyge"}],"alyge":[function(require,module,exports) {
var isKeyable = require("b6019f747876c03");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"b6019f747876c03":"luMgB"}],"luMgB":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"irrfb":[function(require,module,exports) {
var getMapData = require("55518e7139284e04");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"55518e7139284e04":"alyge"}],"5w7TZ":[function(require,module,exports) {
var getMapData = require("e12980d198f5fa5c");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"e12980d198f5fa5c":"alyge"}],"aYr2y":[function(require,module,exports) {
var getMapData = require("551510ace55baa99");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"551510ace55baa99":"alyge"}],"bi3RH":[function(require,module,exports) {
var baseIsEqualDeep = require("3498c291dc8bd4df"), isObjectLike = require("ba2fa268ecddec15");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"3498c291dc8bd4df":"i1Jr1","ba2fa268ecddec15":"hSXky"}],"i1Jr1":[function(require,module,exports) {
var Stack = require("f59a79ff5a75ad1c"), equalArrays = require("f666cdcceffef850"), equalByTag = require("d511f3f00fbd5fe4"), equalObjects = require("a00ce32cc876fb63"), getTag = require("7a189b3f1a618d2"), isArray = require("ca03b7415e28e7f9"), isBuffer = require("3a459261ae15d0dd"), isTypedArray = require("2e216d5705f008ba");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"f59a79ff5a75ad1c":"1PaXo","f666cdcceffef850":"lwGDb","d511f3f00fbd5fe4":"7G4pl","a00ce32cc876fb63":"jSQ5y","7a189b3f1a618d2":"gvWMS","ca03b7415e28e7f9":"6WNsH","3a459261ae15d0dd":"iiCdc","2e216d5705f008ba":"bXUmq"}],"lwGDb":[function(require,module,exports) {
var SetCache = require("b0386678c223888c"), arraySome = require("fdcfea72e24c4f34"), cacheHas = require("e906b686aa88b5ae");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"b0386678c223888c":"2Nz5N","fdcfea72e24c4f34":"a6pSz","e906b686aa88b5ae":"70WdO"}],"2Nz5N":[function(require,module,exports) {
var MapCache = require("3eef58cd823decb5"), setCacheAdd = require("ef1e0cd7c79035c4"), setCacheHas = require("4ff0ef58c72a2b18");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"3eef58cd823decb5":"blNRV","ef1e0cd7c79035c4":"9uvKr","4ff0ef58c72a2b18":"3ZDba"}],"9uvKr":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"3ZDba":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"a6pSz":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"70WdO":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7G4pl":[function(require,module,exports) {
var Symbol = require("63def57ff6df8492"), Uint8Array = require("5efe385afbba2f01"), eq = require("c60fa7a56130999b"), equalArrays = require("a04cedc5ca749239"), mapToArray = require("4ed32b15b7d2a84b"), setToArray = require("724f35efa04bbeba");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"63def57ff6df8492":"5VUaA","5efe385afbba2f01":"1obpt","c60fa7a56130999b":"4rrYy","a04cedc5ca749239":"lwGDb","4ed32b15b7d2a84b":"fky3R","724f35efa04bbeba":"iQZfN"}],"1obpt":[function(require,module,exports) {
var root = require("2147be0db23fb285");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"2147be0db23fb285":"9D9UF"}],"fky3R":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"iQZfN":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"jSQ5y":[function(require,module,exports) {
var getAllKeys = require("83e1981811d03afc");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"83e1981811d03afc":"5ikiI"}],"5ikiI":[function(require,module,exports) {
var baseGetAllKeys = require("ee72f87bc26ca0a6"), getSymbols = require("8b8a6f760638ffc0"), keys = require("bcdc86d2e95a0d33");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"ee72f87bc26ca0a6":"hHgdx","8b8a6f760638ffc0":"i16kq","bcdc86d2e95a0d33":"fuSIb"}],"hHgdx":[function(require,module,exports) {
var arrayPush = require("618fd3cb64218528"), isArray = require("5f538561d72331f5");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"618fd3cb64218528":"e2pL2","5f538561d72331f5":"6WNsH"}],"e2pL2":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"i16kq":[function(require,module,exports) {
var arrayFilter = require("4ba470b2bb6ee53c"), stubArray = require("7f7ff81e3e779da7");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"4ba470b2bb6ee53c":"1Mj0t","7f7ff81e3e779da7":"fjIVM"}],"1Mj0t":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"fjIVM":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"fuSIb":[function(require,module,exports) {
var arrayLikeKeys = require("bb2119abea51b9e6"), baseKeys = require("2ef311c09aeeaf1c"), isArrayLike = require("1e9a6c8a0b088a58");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"bb2119abea51b9e6":"jfhYp","2ef311c09aeeaf1c":"bPL37","1e9a6c8a0b088a58":"gnYyq"}],"jfhYp":[function(require,module,exports) {
var baseTimes = require("e4d6b88c12d8e9d3"), isArguments = require("d7bc6f2b2c2ab4de"), isArray = require("b7a763e8eb356722"), isBuffer = require("ceee816faf42b6c1"), isIndex = require("2e6473b3d20ca366"), isTypedArray = require("4ed421a009d95957");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"e4d6b88c12d8e9d3":"lG5Gc","d7bc6f2b2c2ab4de":"9J7Nu","b7a763e8eb356722":"6WNsH","ceee816faf42b6c1":"iiCdc","2e6473b3d20ca366":"bJIGk","4ed421a009d95957":"bXUmq"}],"lG5Gc":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"9J7Nu":[function(require,module,exports) {
var baseIsArguments = require("62431b133da34285"), isObjectLike = require("4da13dfec70875e9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"62431b133da34285":"3Y2Bw","4da13dfec70875e9":"hSXky"}],"3Y2Bw":[function(require,module,exports) {
var baseGetTag = require("de8a00c2119b87d3"), isObjectLike = require("14f2ecd7e4e3431a");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"de8a00c2119b87d3":"8nzKY","14f2ecd7e4e3431a":"hSXky"}],"iiCdc":[function(require,module,exports) {
var root = require("c79ccff24f317621"), stubFalse = require("b97a879fe656b12b");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"c79ccff24f317621":"9D9UF","b97a879fe656b12b":"BPQFR"}],"BPQFR":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"bJIGk":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"bXUmq":[function(require,module,exports) {
var baseIsTypedArray = require("85ee6cb65c07f2b6"), baseUnary = require("c19009c120d2dfa"), nodeUtil = require("b599bac31aa1c324");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"85ee6cb65c07f2b6":"kIYR6","c19009c120d2dfa":"9fdd1","b599bac31aa1c324":"9xtlN"}],"kIYR6":[function(require,module,exports) {
var baseGetTag = require("9e12649226bfa0f8"), isLength = require("bd8e696fb75ffb8d"), isObjectLike = require("cf2c204ee3e6d39e");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"9e12649226bfa0f8":"8nzKY","bd8e696fb75ffb8d":"jGkDi","cf2c204ee3e6d39e":"hSXky"}],"jGkDi":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"9fdd1":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"9xtlN":[function(require,module,exports) {
var freeGlobal = require("18698518e2ecd90f");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"18698518e2ecd90f":"duiN6"}],"bPL37":[function(require,module,exports) {
var isPrototype = require("71f5518e3d3c9159"), nativeKeys = require("ed3ffd449d071a8a");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"71f5518e3d3c9159":"jkqOx","ed3ffd449d071a8a":"ePcGX"}],"jkqOx":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"ePcGX":[function(require,module,exports) {
var overArg = require("c70e1168197232bd");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"c70e1168197232bd":"iEwiP"}],"iEwiP":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"gnYyq":[function(require,module,exports) {
var isFunction = require("d787589d11abedd1"), isLength = require("7bee54bb6480bd78");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"d787589d11abedd1":"68TL1","7bee54bb6480bd78":"jGkDi"}],"gvWMS":[function(require,module,exports) {
var DataView = require("b5e96dd52e383201"), Map = require("6c92ea10f64327cb"), Promise = require("ceec2c68a8bc32ca"), Set = require("c8b9a1236740acaf"), WeakMap = require("212b62c0f60bf16c"), baseGetTag = require("cd55b7e025255fbe"), toSource = require("b1d7637648b2eed9");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"b5e96dd52e383201":"ix3hc","6c92ea10f64327cb":"fVjtR","ceec2c68a8bc32ca":"6yzNG","c8b9a1236740acaf":"9fF8K","212b62c0f60bf16c":"H9N5I","cd55b7e025255fbe":"8nzKY","b1d7637648b2eed9":"5ZadQ"}],"ix3hc":[function(require,module,exports) {
var getNative = require("c5454dac004d518f"), root = require("18d281791cf1600d");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"c5454dac004d518f":"c1ipR","18d281791cf1600d":"9D9UF"}],"6yzNG":[function(require,module,exports) {
var getNative = require("f2847c8181abdc81"), root = require("b8c3800f27a809a9");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"f2847c8181abdc81":"c1ipR","b8c3800f27a809a9":"9D9UF"}],"9fF8K":[function(require,module,exports) {
var getNative = require("5810371fe57f86eb"), root = require("81140554dffa6979");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"5810371fe57f86eb":"c1ipR","81140554dffa6979":"9D9UF"}],"H9N5I":[function(require,module,exports) {
var getNative = require("b9bf3a38afc61602"), root = require("da8db84e6ff1c3e9");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"b9bf3a38afc61602":"c1ipR","da8db84e6ff1c3e9":"9D9UF"}],"75J6J":[function(require,module,exports) {
var isStrictComparable = require("977506c38a5a225f"), keys = require("6ec60ef3fac9a00e");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"977506c38a5a225f":"6fFbB","6ec60ef3fac9a00e":"fuSIb"}],"6fFbB":[function(require,module,exports) {
var isObject = require("223a68101ca7a5b4");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"223a68101ca7a5b4":"1Khis"}],"hHzQd":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"32Nfk":[function(require,module,exports) {
var baseIsEqual = require("af6919a281098cc3"), get = require("61df9974a7453eb7"), hasIn = require("1b05e8f9279a7784"), isKey = require("78e857d59332f36c"), isStrictComparable = require("aa311a8a45af2bdd"), matchesStrictComparable = require("69e7113ecb280fcd"), toKey = require("8883f35f84493b9e");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"af6919a281098cc3":"bi3RH","61df9974a7453eb7":"49gOP","1b05e8f9279a7784":"4xE5q","78e857d59332f36c":"tmqrP","aa311a8a45af2bdd":"6fFbB","69e7113ecb280fcd":"hHzQd","8883f35f84493b9e":"4dpx7"}],"49gOP":[function(require,module,exports) {
var baseGet = require("e8162214df8dcce4");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"e8162214df8dcce4":"jazmb"}],"jazmb":[function(require,module,exports) {
var castPath = require("9599db9a058e20fe"), toKey = require("3a75bea2f5db623b");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"9599db9a058e20fe":"bMQvl","3a75bea2f5db623b":"4dpx7"}],"bMQvl":[function(require,module,exports) {
var isArray = require("e5bba5143877774"), isKey = require("1644b1c374a9ab1a"), stringToPath = require("313e8145c2476682"), toString = require("cf5f602529b9f6e8");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"e5bba5143877774":"6WNsH","1644b1c374a9ab1a":"tmqrP","313e8145c2476682":"aiKD4","cf5f602529b9f6e8":"bI8Cb"}],"tmqrP":[function(require,module,exports) {
var isArray = require("db140fa844600b01"), isSymbol = require("14ddde78252d7cf4");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"db140fa844600b01":"6WNsH","14ddde78252d7cf4":"cGB8s"}],"aiKD4":[function(require,module,exports) {
var memoizeCapped = require("9debefb3f6f5c153");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"9debefb3f6f5c153":"hOz8D"}],"hOz8D":[function(require,module,exports) {
var memoize = require("c2b7b810675ebf57");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"c2b7b810675ebf57":"5masf"}],"5masf":[function(require,module,exports) {
var MapCache = require("4f5ab05b7545c2b7");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"4f5ab05b7545c2b7":"blNRV"}],"4dpx7":[function(require,module,exports) {
var isSymbol = require("3f14e0d87900e523");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"3f14e0d87900e523":"cGB8s"}],"4xE5q":[function(require,module,exports) {
var baseHasIn = require("9a77813335ab6e27"), hasPath = require("a927d315e5817c33");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9a77813335ab6e27":"jYfOi","a927d315e5817c33":"elUol"}],"jYfOi":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"elUol":[function(require,module,exports) {
var castPath = require("77dbbe4a4878f698"), isArguments = require("379243675e943332"), isArray = require("6ac1c868dbf6ac14"), isIndex = require("97513e467b7046a0"), isLength = require("c200e634a308ab16"), toKey = require("12be805dce8983b1");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"77dbbe4a4878f698":"bMQvl","379243675e943332":"9J7Nu","6ac1c868dbf6ac14":"6WNsH","97513e467b7046a0":"bJIGk","c200e634a308ab16":"jGkDi","12be805dce8983b1":"4dpx7"}],"4Hzzf":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"cjGbD":[function(require,module,exports) {
var baseProperty = require("8718a07ca63658a2"), basePropertyDeep = require("c85b1980ea24a869"), isKey = require("8ae46d30232eae10"), toKey = require("2c57adbe831f7549");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"8718a07ca63658a2":"a7Jk5","c85b1980ea24a869":"8HczD","8ae46d30232eae10":"tmqrP","2c57adbe831f7549":"4dpx7"}],"a7Jk5":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"8HczD":[function(require,module,exports) {
var baseGet = require("5530a9b791249ad8");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"5530a9b791249ad8":"jazmb"}],"9irPk":[function(require,module,exports) {
var toFinite = require("6a75b4db87cc30a8");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"6a75b4db87cc30a8":"bDOh0"}],"bDOh0":[function(require,module,exports) {
var toNumber = require("3a87a07b66c41c67");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"3a87a07b66c41c67":"4aPCo"}],"4aPCo":[function(require,module,exports) {
var isObject = require("fdb1ea03f337aaf0"), isSymbol = require("6879d45133769246");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"fdb1ea03f337aaf0":"1Khis","6879d45133769246":"cGB8s"}],"gr94G":[function(require,module,exports) {
var baseFindIndex = require("5184e01699e50950"), baseIteratee = require("556ff9bc10779253"), toInteger = require("bd9ab1b67e570a6");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}
module.exports = findLastIndex;

},{"5184e01699e50950":"a7lSm","556ff9bc10779253":"3xVMK","bd9ab1b67e570a6":"9irPk"}],"33AK4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * Generate a CSS value for an encoded svg icon. This essentially just sets the
 * color and wraps the data in a "url()".
 *
 * @example
 * getIconCss(data, "#000")
 */ var getIconCss = function getIconCss(data, color) {
    return data && color ? 'url("'.concat(data.replace(new RegExp("currentColor", "g"), // this change: https://www.chromestatus.com/feature/5656049583390720
    color.replace(new RegExp("#", "g"), "%23")), '")') : "none";
};
var _default = getIconCss;
exports["default"] = _default;

},{}],"lrJOb":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9efe1e4336dcd849");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _toaster = _interopRequireDefault(require("a976b78a70336e94"));
var _default = _toaster["default"];
exports["default"] = _default;

},{"9efe1e4336dcd849":"fk2Bw","a976b78a70336e94":"btW3b"}],"btW3b":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("921575253d661ef5");
var _interopRequireDefault = require("258e8fd4541f01e9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("98a2d6661e1cd1b3"));
var _slicedToArray2 = _interopRequireDefault(require("a8a282e76eb7aef7"));
var _react = _interopRequireWildcard(require("545c0681886ac760"));
var _propTypes = _interopRequireDefault(require("21732148030a0527"));
var _emotion = require("cea309ae6b8e36e1");
var _elevation = require("5c2a9bf8b5160b2a");
var _toast = _interopRequireDefault(require("9f8030c796fb0296"));
var _portal = _interopRequireDefault(require("e6e3438008e95f5"));
var _listReset = _interopRequireDefault(require("6f485add2dd95cec"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = function styles(alignmentHorizontal, position) {
    return (0, _emotion.css)(_listReset["default"], {
        position: position,
        top: 0,
        left: 0,
        right: 0,
        zIndex: _elevation.elevationModal + 1,
        // Turn off pointer events for the toast list container. This allows us to
        // stretch the container across the whole viewport without blocking
        // interaction with elements behind the container.
        pointerEvents: "none",
        "& > li": {
            display: "flex",
            flexDirection: "column",
            alignItems: {
                left: "flex-start",
                center: "center",
                right: "flex-end"
            }[alignmentHorizontal]
        },
        // Turn pointer events back on for the actual toast elements rendered by the
        // user of this component.
        "& > li > *": {
            pointerEvents: "all"
        }
    });
};
/**
 * Animate toasts in and out at the top of the viewport.
 *
 * @since 4.x
 */ var Toaster = function Toaster(props) {
    var toasts = props.toasts, onCloseToast = props.onCloseToast, children = props.children; // Keep mounted toasts in a ref (toasts will stay mounted after being removed
    // from the toasts prop while they animate out). Using a ref allows us to add
    // new toasts to the list of mounted toasts without an extra render (which
    // would be necessary if we used state to hold mounted toasts).
    var mountedToasts = (0, _react.useRef)([]); // Because mounted toasts are stored in a ref we have to manually update state
    // when we remove a toast from the list (after it animates out). This state
    // allows us to do that manual refresh.
    var _useState = (0, _react.useState)(), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), refresh = _useState2[1]; // Keep a ref to the latest value of onCloseToast. This is really important
    // because onCloseToast probably looks something like this:
    //   `const onCloseToast = id => toasts.filter(t => t.id !== id)`
    // If we call outdated versions of that kind of onCloseToast we could end up
    // bringing old toasts back to life and wreaking havoc on the current state.
    var onCloseToastRef = (0, _react.useRef)(onCloseToast);
    onCloseToastRef.current = onCloseToast; // Add new toasts and update existing toasts in mountedToasts
    toasts.forEach(function(toast) {
        // If the toast is new then add it to the *end* of the array. This prevents
        // toasts from being re-ordered after they're mounted. Start a timeout if
        // the toast requires it.
        if (!mountedToasts.current.some(function(mountedToast) {
            return mountedToast.toast.id === toast.id;
        })) mountedToasts.current.unshift({
            toast: _objectSpread(_objectSpread({}, toast), {}, {
                onClose: function onClose() {
                    return onCloseToastRef.current(toast.id);
                }
            }),
            timeout: toast.timeout && setTimeout(function() {
                return onCloseToastRef.current(toast.id);
            }, toast.timeout)
        });
    }); // Cleanup timeouts for any mounted toasts when the toaster unmounts.
    (0, _react.useEffect)(function() {
        return function() {
            return mountedToasts.current.forEach(function(_ref) {
                var timeout = _ref.timeout;
                return clearTimeout(timeout);
            });
        };
    }, []); // Put the Toaster in a wrapper when position is fixed to avoid potential
    // style clashes from ancestors
    var Wrapper = (0, _react.useMemo)(function() {
        return props.position === "fixed" ? _portal["default"] : _react["default"].Fragment;
    }, [
        props.position
    ]);
    return /*#__PURE__*/ _react["default"].createElement(Wrapper, null, /*#__PURE__*/ _react["default"].createElement("ul", {
        className: styles(props.alignmentHorizontal, props.position)
    }, mountedToasts.current.map(function(_ref2) {
        var toast = _ref2.toast, timeout = _ref2.timeout;
        return /*#__PURE__*/ _react["default"].createElement(_toast["default"], {
            key: toast.id,
            exit: // trigger the exit animation.
            !toasts.some(function(_ref3) {
                var id = _ref3.id;
                return id === toast.id;
            }),
            onAfterExit: function onAfterExit() {
                // After a toast is finished animating out, remove it from the
                // mounted toasts list and force a refresh.
                clearTimeout(timeout);
                mountedToasts.current = mountedToasts.current.filter(function(mountedToast) {
                    return mountedToast.toast.id !== toast.id;
                });
                refresh({});
            }
        }, children(toast));
    })));
};
Toaster.displayName = "Toaster";
Toaster.propTypes = {};
Toaster.defaultProps = {
    alignmentHorizontal: "center",
    position: "fixed"
};
var _default = Toaster;
exports["default"] = _default;

},{"921575253d661ef5":"k8mdG","258e8fd4541f01e9":"fk2Bw","98a2d6661e1cd1b3":"hcG56","a8a282e76eb7aef7":"19SJN","545c0681886ac760":"6uln9","21732148030a0527":"cnMFu","cea309ae6b8e36e1":"4deck","5c2a9bf8b5160b2a":"dKmTh","9f8030c796fb0296":"bpx35","e6e3438008e95f5":"64SHp","6f485add2dd95cec":"4KoFT"}],"bpx35":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("f37bff4ce8aca5f8");
var _interopRequireDefault = require("1438c9a28098eb24");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("619198794f36d788"));
var _react = _interopRequireWildcard(require("9bb4ad662187c322"));
var _propTypes = _interopRequireDefault(require("e0af7f97557a25ba"));
var _emotion = require("c9fee8e3d66c96c0");
var _spacing = require("c11a223e8d6f79cf");
var _elevation = require("2366991d3e172813");
var _transitionController = _interopRequireDefault(require("1579067cd915648d"));
var _functional = require("a6f33f0f1bd738a0");
var styles = (0, _functional.memoizeByKeys)(function(_ref) {
    var state = _ref.state, height = _ref.height, motionDuration = _ref.motionDuration;
    return (0, _emotion.css)({
        // Stick the contents of the toast container to the bottom of the container
        // so that when we animate the height of the container the contents appear
        // to undergo a slide animation instead of a reveal animation.
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        "& > *": {
            flexShrink: 0
        },
        // Fade in and out
        opacity: state === "exited" || state === "exiting" ? 0 : 1,
        // Animate the height in and out
        height: state === "exiting" || state === "exited" ? 0 : height,
        paddingTop: state === "exiting" || state === "exited" ? 0 : _spacing.spacingMedium,
        paddingRight: _spacing.spacingMedium,
        paddingLeft: _spacing.spacingMedium,
        transition: "height ".concat(motionDuration, "ms ease, padding ").concat(motionDuration, "ms ease, opacity ").concat(motionDuration, "ms ease"),
        // Animate behind other toasts
        zIndex: state === "exiting" || state === "entering" ? _elevation.elevationBackground : _elevation.elevationForeground,
        position: "relative"
    });
}, [
    "state",
    "height",
    "motionDuration"
]);
/**
 * An internal container that applies toasty animation to its contents.
 */ var Toast = function Toast(_ref2) {
    var children = _ref2.children, exit = _ref2.exit, motionDuration = _ref2.motionDuration, onAfterExit = _ref2.onAfterExit;
    var ref = (0, _react.useRef)();
    var _useState = (0, _react.useState)(false), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, _react.useState)(), _useState4 = (0, _slicedToArray2["default"])(_useState3, 2), height = _useState4[0], setHeight = _useState4[1]; // Open the toast as soon as it's mounted
    (0, _react.useEffect)(function() {
        setOpen(true);
    }, []); // Close the toast when the exit prop flips to true
    (0, _react.useEffect)(function() {
        if (exit) setOpen(false);
    }, [
        exit
    ]); // Fix the height of the toast before animating (it's the year 2045 and you
    // still can't animate a dynamic height with CSS)
    var onBeforeTransition = (0, _react.useCallback)(function(done) {
        setHeight(ref.current.firstElementChild.getBoundingClientRect().height);
        done();
    }, []); // Unfix the height of the toast after animating it in. This allows the
    // toast's content to change height after mounting without messing anything
    // up.
    var onAfterEnter = (0, _react.useCallback)(function() {
        return setHeight(undefined);
    }, []);
    return /*#__PURE__*/ _react["default"].createElement(_transitionController["default"], {
        "in": open,
        duration: motionDuration,
        onBeforeEnter: onBeforeTransition,
        onBeforeExit: onBeforeTransition,
        onAfterEnter: onAfterEnter,
        onAfterExit: onAfterExit
    }, function(state) {
        return /*#__PURE__*/ _react["default"].createElement("li", {
            className: styles({
                state: state,
                height: height,
                motionDuration: motionDuration
            }),
            ref: ref
        }, children);
    });
};
Toast.displayName = "Toast";
Toast.propTypes = {};
Toast.defaultProps = {
    motionDuration: 200
};
var _default = Toast;
exports["default"] = _default;

},{"f37bff4ce8aca5f8":"k8mdG","1438c9a28098eb24":"fk2Bw","619198794f36d788":"19SJN","9bb4ad662187c322":"6uln9","e0af7f97557a25ba":"cnMFu","c9fee8e3d66c96c0":"4deck","c11a223e8d6f79cf":"8D3is","2366991d3e172813":"dKmTh","1579067cd915648d":"elia7","a6f33f0f1bd738a0":"eKpY2"}],"elia7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ed1662763d504a72");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _transitionController = _interopRequireDefault(require("c933d1e1f6caea9f"));
var _default = _transitionController["default"];
exports["default"] = _default;

},{"ed1662763d504a72":"fk2Bw","c933d1e1f6caea9f":"kdY1g"}],"kdY1g":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b0c05b018828a8c8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("b581130135c5593b"));
var _createClass2 = _interopRequireDefault(require("d3627fd4c6635dae"));
var _assertThisInitialized2 = _interopRequireDefault(require("3f0f7cfe54d75bd"));
var _inherits2 = _interopRequireDefault(require("368c4e15c7702b52"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("f7a7e8fcf30f9991"));
var _getPrototypeOf2 = _interopRequireDefault(require("4bb11828e6687379"));
var _defineProperty2 = _interopRequireDefault(require("667a36a54ff92335"));
var _react = _interopRequireDefault(require("3d44f711a0318cb0"));
var _propTypes = _interopRequireDefault(require("c43df4fdf0e16663"));
var _noop = _interopRequireDefault(require("4e6000cfc1e421d"));
var _waitAnimationFrame = _interopRequireDefault(require("9cf0cd1842df700d"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var noopWithCallback = function noopWithCallback(callback) {
    return callback();
};
/**
 * This component makes it easy to apply complex transitions to elements. You
 * tell it whether the children should be transitioned in or out and what the
 * duration of the transition should be. It will provide you with the state of
 * the transition via a render prop. The state may be one of four values:
 * "entering", "entered", "exiting", or "exited". Six lifecycle hooks are
 * available: onBeforeEnter, onEnter, onAfterEnter, onBeforeExit, onExit, and
 * onAfterExit.
 */ var TransitionController = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(TransitionController, _React$Component);
    var _super = _createSuper(TransitionController);
    function TransitionController() {
        var _this;
        (0, _classCallCheck2["default"])(this, TransitionController);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            state: _this.props["in"] ? "entered" : "exited"
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelWait", _noop["default"]);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callback", _noop["default"]);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitAnimationFrame", function(callback, skip) {
            if (skip) callback();
            else {
                _this.cancelWait();
                _this.cancelWait = (0, _waitAnimationFrame["default"])(callback);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitDuration", function(callback) {
            var timeout;
            _this.cancelWait();
            _this.cancelWait = function() {
                return clearTimeout(timeout);
            };
            timeout = setTimeout(callback, _this.props.duration);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withCallback", function(func) {
            return function(callback) {
                _this.callback = callback;
                func(function() {
                    if (_this.callback === callback) callback();
                });
            };
        });
        return _this;
    }
    (0, _createClass2["default"])(TransitionController, [
        {
            key: "transition",
            /**
     * This orchestrates a transition. The basic flow is:
     * 1) cancel any existing timeouts
     * 2) call onBefore
     * 3) wait for a single animation frame *if* onBefore is defined (so that the
     *    DOM has a chance to settle)
     * 4) update the state to transitioning
     * 5) wait for a single animation frame *if* onTransition is defined (so that
     *    the DOM has a chance to settle)
     * 6) call onTransition
     * 7) wait for the duration of the animation
     * 8) update the state to transitioned
     * 9) wait for a single animation frame
     * 10) call onAfter
     */ value: function transition(_ref) {
                var _this2 = this;
                var onBefore = _ref.onBefore, onTransition = _ref.onTransition, onAfter = _ref.onAfter, stateDuring = _ref.stateDuring, stateAfter = _ref.stateAfter;
                var onBeforeWithCallback = this.withCallback(onBefore);
                var onTransitionWithCallback = this.withCallback(onTransition);
                this.cancelWait();
                onBeforeWithCallback(function() {
                    return _this2.waitAnimationFrame(function() {
                        return _this2.setState({
                            state: stateDuring
                        }, function() {
                            return _this2.waitAnimationFrame(function() {
                                return onTransitionWithCallback(function() {
                                    return _this2.waitDuration(function() {
                                        return _this2.setState({
                                            state: stateAfter
                                        }, _this2.waitAnimationFrame(onAfter, onAfter === _noop["default"]));
                                    });
                                });
                            }, // provided
                            onTransition === noopWithCallback);
                        });
                    }, onBefore === noopWithCallback);
                });
            }
        },
        {
            key: "transitionIn",
            value: function transitionIn() {
                this.transition({
                    onBefore: this.props.onBeforeEnter,
                    onTransition: this.props.onEnter,
                    onAfter: this.props.onAfterEnter,
                    stateDuring: "entering",
                    stateAfter: "entered"
                });
            }
        },
        {
            key: "transitionOut",
            value: function transitionOut() {
                this.transition({
                    onBefore: this.props.onBeforeExit,
                    onTransition: this.props.onExit,
                    onAfter: this.props.onAfterExit,
                    stateDuring: "exiting",
                    stateAfter: "exited"
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props["in"] && !prevProps["in"]) this.transitionIn();
                else if (!this.props["in"] && prevProps["in"]) this.transitionOut();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelWait();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children(this.state.state);
            }
        }
    ]);
    return TransitionController;
}(_react["default"].Component);
(0, _defineProperty2["default"])(TransitionController, "defaultProps", {
    onBeforeEnter: noopWithCallback,
    onEnter: noopWithCallback,
    onAfterEnter: _noop["default"],
    onBeforeExit: noopWithCallback,
    onExit: noopWithCallback,
    onAfterExit: _noop["default"]
});
TransitionController.propTypes = {};
var _default = TransitionController;
exports["default"] = _default;

},{"b0c05b018828a8c8":"fk2Bw","b581130135c5593b":"5Yd3f","d3627fd4c6635dae":"6Jptv","3f0f7cfe54d75bd":"lMa5o","368c4e15c7702b52":"j4mqF","f7a7e8fcf30f9991":"krVd4","4bb11828e6687379":"8h5p9","667a36a54ff92335":"hcG56","3d44f711a0318cb0":"6uln9","c43df4fdf0e16663":"cnMFu","4e6000cfc1e421d":"7osqO","9cf0cd1842df700d":"fDQaK"}],"5Yd3f":[function(require,module,exports) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck;

},{}],"6Jptv":[function(require,module,exports) {
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
module.exports = _createClass;

},{}],"lMa5o":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized;

},{}],"j4mqF":[function(require,module,exports) {
var setPrototypeOf = require("65fb26549827db0");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits;

},{"65fb26549827db0":"iy34V"}],"iy34V":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf;

},{}],"krVd4":[function(require,module,exports) {
var _typeof = require("b85c2aac60d87035");
var assertThisInitialized = require("10d839669258731c");
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn;

},{"b85c2aac60d87035":"2uZa5","10d839669258731c":"lMa5o"}],"8h5p9":[function(require,module,exports) {
function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf;

},{}],"fDQaK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// Executes code after waiting at least one whole animation frame. This is
// helpful when you want to allow DOM updates to settle before triggering
// something like a css transition. This returns a function that can be used to
// cancel the callback.
var waitAnimationFrame = function waitAnimationFrame(callback) {
    var frame = requestAnimationFrame(function() {
        frame = requestAnimationFrame(callback);
    });
    return function() {
        return cancelAnimationFrame(frame);
    };
};
var _default = waitAnimationFrame;
exports["default"] = _default;

},{}],"64SHp":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("920e4d517debd6b0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _portal = _interopRequireDefault(require("9889daacb8742dbe"));
var _default = _portal["default"];
exports["default"] = _default;

},{"920e4d517debd6b0":"fk2Bw","9889daacb8742dbe":"7i38H"}],"7i38H":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5c2133804c6a2369");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("a2ca36157ec13ee3"));
var _createClass2 = _interopRequireDefault(require("830100ce8f905437"));
var _inherits2 = _interopRequireDefault(require("d47f457cf4e375d"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("632624c5a0576107"));
var _getPrototypeOf2 = _interopRequireDefault(require("26bc266c16f167be"));
var _react = _interopRequireDefault(require("37f2f54758b3149a"));
var _propTypes = _interopRequireDefault(require("583cd4c8227312ea"));
var _reactDom = _interopRequireDefault(require("b53183891aa0f437"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var Portal = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Portal, _React$Component);
    var _super = _createSuper(Portal);
    function Portal() {
        (0, _classCallCheck2["default"])(this, Portal);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(Portal, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.defaultNode) document.body.removeChild(this.defaultNode);
                this.defaultNode = null;
            }
        },
        {
            key: "render",
            value: function render() {
                if (!canUseDOM) return null;
                if (!this.props.node && !this.defaultNode) {
                    this.defaultNode = document.createElement("div");
                    document.body.appendChild(this.defaultNode);
                }
                return /*#__PURE__*/ _reactDom["default"].createPortal(this.props.children, this.props.node || this.defaultNode);
            }
        }
    ]);
    return Portal;
}(_react["default"].Component);
Portal.propTypes = {};
var _default = Portal;
exports["default"] = _default;

},{"5c2133804c6a2369":"fk2Bw","a2ca36157ec13ee3":"5Yd3f","830100ce8f905437":"6Jptv","d47f457cf4e375d":"j4mqF","632624c5a0576107":"krVd4","26bc266c16f167be":"8h5p9","37f2f54758b3149a":"6uln9","583cd4c8227312ea":"cnMFu","b53183891aa0f437":"b8T3j"}],"4KoFT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var listReset = {
    listStyle: "none",
    padding: 0,
    margin: 0
};
var _default = listReset;
exports["default"] = _default;

},{}],"fxXId":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.FeedBackIntent = void 0;
var FeedBackIntent = exports.FeedBackIntent = Object.freeze({
    General: "general",
    Triggered: "triggered"
});
var _default = exports["default"] = FeedBackIntent;

},{}],"5Z2Wy":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("18c3846cbcbe4ab0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("f9a7660cf6690de7"));
var _modal = _interopRequireDefault(require("1e34aa3fad13033d"));
var _column = _interopRequireDefault(require("edf3aac70434d27e"));
var _text = _interopRequireDefault(require("7a41662fb68782d6"));
var _divider = _interopRequireDefault(require("a3171e556c29cc2d"));
var _propTypes = _interopRequireDefault(require("ed7ac3efef04d6f6"));
var _FeedbackConstants = require("451fb89ec2605513");
var _RequiredQuestionTypeComponentList = _interopRequireDefault(require("e94c09b462f6e3e6"));
var _NonSkippableFooter = _interopRequireDefault(require("37895f2dd4adf62a"));
var _button = _interopRequireDefault(require("3d382ee5766443b2"));
var GeneralFeedback = function GeneralFeedback(_ref) {
    var open = _ref.open, isDisabled = _ref.isDisabled, onClose = _ref.onClose, onClickLink = _ref.onClickLink, onClickFooterButton = _ref.onClickFooterButton, title = _ref.title, description = _ref.description, questions = _ref.questions, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText, prePopulate = _ref.prePopulate, _ref$displayMode = _ref.displayMode, displayMode = _ref$displayMode === void 0 ? "light" : _ref$displayMode;
    var logoFillColor = displayMode === "dark" ? "white" : "black";
    return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        onClick: onClickLink,
        type: "icon"
    }, /*#__PURE__*/ _react["default"].createElement("span", {
        style: {
            fill: logoFillColor,
            marginTop: "2px"
        },
        "data-testid": "feedback-button"
    }, /*#__PURE__*/ _react["default"].createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ _react["default"].createElement("path", {
        d: "M39.6768 25.1688C40.0322 25.1688 40.3654 25.2625 40.6534 25.4267C40.9406 25.2627 41.2743 25.1688 41.6299 25.1688H46.0248C47.1163 25.1688 47.9999 26.0538 47.9999 27.1468V36.4328C47.9999 37.5249 47.1161 38.4108 46.0248 38.4108H41.6299C41.3434 38.4108 41.0712 38.3497 40.8254 38.2399L38.8719 41.9238L38.5685 44.5409C38.5486 44.8261 38.4625 45.1774 38.2562 45.5428L38.1603 45.7001C37.6978 46.4051 36.9186 46.8313 35.8825 46.8313C33.8541 46.8313 32.6242 44.9555 32.5493 42.8452L32.5457 42.6403L32.545 39.1678H26.4956L26.3334 39.1629C25.03 39.0783 24 37.9943 24 36.6683C24 36.0631 24.2148 35.5081 24.5723 35.0756C24.2978 34.675 24.1381 34.1905 24.1381 33.6688C24.1381 32.7789 24.602 31.998 25.301 31.555C25.1951 31.2809 25.1376 30.9815 25.1376 30.6688C25.1376 29.4374 26.0268 28.4143 27.1972 28.2071C27.1578 28.0346 27.1376 27.854 27.1376 27.6688C27.1376 26.2875 28.2553 25.1688 29.6353 25.1688H39.6768ZM39.6532 27.1688H29.6353C29.3588 27.1688 29.1358 27.392 29.1358 27.6688C29.1358 27.9142 29.3124 28.1184 29.5455 28.1607L29.6354 28.1688C30.1872 28.1688 30.6345 28.6165 30.6345 29.1688C30.6345 29.6816 30.2488 30.1043 29.7519 30.162L29.6353 30.1688H27.6353C27.3594 30.1688 27.1357 30.3925 27.1357 30.6688C27.1357 30.9445 27.3598 31.1688 27.6353 31.1688H28.6348C29.1866 31.1688 29.6339 31.6165 29.6339 32.1688C29.6339 32.6816 29.2482 33.1043 28.7513 33.162L28.6348 33.1688H26.6357C26.3593 33.1688 26.1362 33.392 26.1362 33.6688C26.1362 33.9142 26.3128 34.1184 26.5459 34.1607L26.6362 34.1688H27.6353C28.187 34.1688 28.6343 34.6165 28.6343 35.1688C28.6343 35.6816 28.2487 36.1043 27.7518 36.162L27.6353 36.1688H26.6357L26.5402 36.1674C26.5261 36.168 26.5119 36.1683 26.4976 36.1683C26.2216 36.1683 25.9981 36.3921 25.9981 36.6683C25.9981 36.945 26.2212 37.1683 26.4976 37.1683H33.5447C34.0571 37.1683 34.4793 37.5543 34.537 38.0516L34.5438 38.1683V42.6403C34.5438 43.8682 35.1427 44.8313 35.8825 44.8313C36.2416 44.8313 36.3949 44.7474 36.49 44.6024C36.5338 44.5357 36.5593 44.464 36.5715 44.4073L36.5795 44.3562L36.9092 41.5062C36.9187 41.4237 36.9385 41.3429 36.9679 41.2655L37.0192 41.1524L39.6533 36.1838L39.6532 27.1688ZM46.0012 27.1688L41.6514 27.1678V36.4098L46.0012 36.4108V27.1688Z",
        fill: logoFillColor
    }), /*#__PURE__*/ _react["default"].createElement("path", {
        d: "M12.1175 1.16849C14.146 1.16849 15.3757 3.04439 15.4506 5.15551L15.4542 5.36049L15.4539 8.83149H21.502C22.881 8.83149 23.9996 9.9512 23.9996 11.3315C23.9996 11.9365 23.7847 12.4915 23.4271 12.9241C23.7015 13.3245 23.8615 13.8094 23.8615 14.3315C23.8615 15.2207 23.3973 16.0017 22.6983 16.445C22.8042 16.7198 22.8615 17.0189 22.8615 17.3315C22.8615 18.5623 21.9729 19.5857 20.8024 19.7931C20.8419 19.9657 20.8621 20.1462 20.8621 20.3315C20.8621 21.712 19.7442 22.8315 18.3645 22.8315H8.32329C7.96802 22.8315 7.63465 22.7377 7.34658 22.5735C7.05905 22.7375 6.72539 22.8315 6.36979 22.8315H1.97507C0.883541 22.8315 0 21.9465 0 20.8535V11.5675C0 10.4753 0.883728 9.58949 1.97507 9.58949H6.36979C6.65625 9.58949 6.92848 9.65052 7.17422 9.76031L9.1277 6.07589L9.43153 3.45986C9.45142 3.17464 9.53755 2.82333 9.74374 2.45778L9.83962 2.3004C10.302 1.59502 11.0813 1.16849 12.1175 1.16849ZM20.3639 13.8315C19.8122 13.8315 19.3649 13.3838 19.3649 12.8315C19.3649 12.3187 19.7506 11.896 20.2474 11.8382L20.3639 11.8315H21.364L21.4498 11.8328C21.4671 11.8319 21.4845 11.8315 21.502 11.8315C21.7775 11.8315 22.0015 11.6072 22.0015 11.3315C22.0015 11.0558 21.7775 10.8315 21.502 10.8315H14.4552C13.9035 10.8315 13.4562 10.3838 13.4562 9.83149V5.36049C13.4562 4.13168 12.8573 3.16849 12.1175 3.16849C11.7586 3.16849 11.6054 3.25233 11.5102 3.39758C11.4663 3.46445 11.4408 3.53634 11.4285 3.59329L11.4205 3.64451L11.0909 6.49451C11.0813 6.57706 11.0615 6.65794 11.0321 6.73531L10.9808 6.84849L8.34586 11.8145V20.8305L18.3645 20.8315C18.6405 20.8315 18.864 20.6077 18.864 20.3315C18.864 20.0553 18.6405 19.8315 18.3645 19.8315C17.8127 19.8315 17.3655 19.3838 17.3655 18.8315C17.3655 18.2792 17.8127 17.8315 18.3645 17.8315H20.3639C20.6399 17.8315 20.8635 17.6077 20.8635 17.3315C20.8635 17.0553 20.6399 16.8315 20.3639 16.8315H19.3649C18.8132 16.8315 18.3659 16.3838 18.3659 15.8315C18.3659 15.3187 18.7516 14.896 19.2484 14.8382L19.3649 14.8315H21.364C21.6394 14.8315 21.8635 14.6072 21.8635 14.3315C21.8635 14.0558 21.6394 13.8315 21.364 13.8315H20.3639ZM6.34741 11.5889H1.99765V20.8309H6.34741V11.5889Z",
        fill: logoFillColor
    })))), /*#__PURE__*/ _react["default"].createElement(_modal["default"], {
        title: title,
        open: open,
        scrollContainer: "viewport",
        onClose: onClose // General feedback can be closed using a close button, but triggered feedback will not
        ,
        closeLabel: "Close",
        describedById: "modal-description",
        width: "700px"
    }, /*#__PURE__*/ _react["default"].createElement(_column["default"], {
        spacingInset: "medium"
    }, /*#__PURE__*/ _react["default"].createElement(_text["default"], {
        id: "modal-description"
    }, description), /*#__PURE__*/ _react["default"].createElement(_divider["default"], {
        size: "small"
    }), /*#__PURE__*/ _react["default"].createElement(_RequiredQuestionTypeComponentList["default"], {
        questions: questions,
        prePopulate: prePopulate
    })), /*#__PURE__*/ _react["default"].createElement(_NonSkippableFooter["default"], {
        isDisabled: isDisabled,
        onClickFooterButton: onClickFooterButton,
        submitButtonSize: submitButtonSize,
        submitButtonText: submitButtonText,
        submitButtonType: submitButtonType
    })));
};
GeneralFeedback.propTypes = {
    open: _propTypes["default"].bool.isRequired,
    isDisabled: _propTypes["default"].bool.isRequired,
    onClose: _propTypes["default"].func.isRequired,
    onClickLink: _propTypes["default"].func.isRequired,
    onClickFooterButton: _propTypes["default"].func.isRequired,
    questions: _propTypes["default"].array.isRequired,
    title: _propTypes["default"].string,
    description: _propTypes["default"].string,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string,
    prePopulate: _propTypes["default"].object.isRequired
};
GeneralFeedback.defaultProps = {
    title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
    description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text
};
var _default = exports["default"] = GeneralFeedback;

},{"18c3846cbcbe4ab0":"bm29M","f9a7660cf6690de7":"6uln9","1e34aa3fad13033d":"bUAK2","edf3aac70434d27e":"eInK6","7a41662fb68782d6":"6kD7p","a3171e556c29cc2d":"bON9z","ed7ac3efef04d6f6":"gJRKl","451fb89ec2605513":"filWO","e94c09b462f6e3e6":"dM4Li","37895f2dd4adf62a":"k5FHG","3d382ee5766443b2":"gJQuD"}],"bUAK2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7cb8ae608b7eda1a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalFooter", {
    enumerable: true,
    get: function get() {
        return _modalFooter["default"];
    }
});
exports["default"] = void 0;
var _modal = _interopRequireDefault(require("12a9a0ab9f8c4f11"));
var _modalFooter = _interopRequireDefault(require("dd6d397532a646d3"));
var _default = _modal["default"];
exports["default"] = _default;

},{"7cb8ae608b7eda1a":"fk2Bw","12a9a0ab9f8c4f11":"k4yIw","dd6d397532a646d3":"gctY3"}],"k4yIw":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("4bb4a10ead1acadd");
var _interopRequireDefault = require("f0e359f2d7c1ba18");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("417081af22cd4112"));
var _defineProperty2 = _interopRequireDefault(require("d80450fdace38c94"));
var _react = _interopRequireWildcard(require("daec08b09d054f18"));
var _propTypes = _interopRequireDefault(require("3fffd608029d49a4"));
var _modal = _interopRequireDefault(require("e4c5c18472f3451"));
var _modalBox = _interopRequireWildcard(require("cb8576d3fc51829b"));
var _theme = require("22713aad3e86980a");
var _scrim = _interopRequireDefault(require("17261e99ae459347"));
var _portal = _interopRequireDefault(require("2252f7a980df367a"));
var _responsive = _interopRequireDefault(require("5a4bc1f31c6124dc"));
var _animateMount = _interopRequireWildcard(require("62c27cd99b1c4360"));
var _propTypes2 = _interopRequireDefault(require("6b644257858633d5"));
var _emotion = require("db2aee71ffb118ea");
var _onDirectClick = _interopRequireDefault(require("3a9d36550a7a93c1"));
var AnimateFadeScaleWithMount = (0, _animateMount["default"])(_animateMount.AnimateFadeScale);
/**
 * The scrim is the vertical scroll container, and uses flexbox to center the
 * modal in the viewport.
 */ var scrimStyles = (0, _emotion.css)({
    display: "flex",
    alignItems: "center",
    overflow: "auto"
});
/**
 * This wrapper uses margin "auto" to center the modal, but sets a max width and
 * height which force the modal to overflow to the bottom/right of the viewport
 * instead of oveflowing all sides (which looks funky and makes the top/left
 * content inaccessible). For details see:
 * https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
 */ var outerWrapperStyles = (0, _emotion.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "auto"
});
/**
 * The inner wrapper applies a margin around the modal to ensure a certain
 * amount of scrim is always shown. Applying the margin here as opposed to on
 * the outer wrapper ensures that the margin below the modal is preserved even
 * if the modal overflows the viewport and requires scrolling (otherwise the
 * padding would disappear due to this problem:
 * https://www.brunildo.org/test/overscrollback.html).
 */ var innerWrapperStyles = (0, _emotion.css)({
    padding: "".concat(_modalBox.scrimSpacingVertical, "vh ").concat(_modalBox.scrimSpacingHorizontal, "vw"),
    // HACK: IE11 will only respect the max-height property of the modal if the
    // modal's parent is a flex column. See:
    // https://stackoverflow.com/questions/44635857/flexbox-max-height-issue-with-ie11
    display: "flex",
    flexDirection: "column"
});
/**
 * Don't bother updating the modal if it's persisting in a closed state.
 */ var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return !prevProps.open && !nextProps.open;
};
/**
 * Render a modal in the viewport. On desktop the modal will be shown with a
 * scrim behind it. On mobile the modal will be shown fullscreen. Only one modal
 * should be rendered at a time.
 *
 * NOTE: Do not mount a Modal inside an interactive element. The Modal's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Modal will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Modal being counted as a click on the element
 * where the Modal was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */ var Modal = /*#__PURE__*/ _react["default"].memo(function(props) {
    var t = (0, _theme.useTheme)(_modal["default"], "modal");
    var scrimRef = (0, _react.useRef)();
    var anchorRef = (0, _react.useRef)(); // We want an onClose callback, but only if props.onClose is defined
    var onCloseProp = props.onClose;
    var onCloseCallback = (0, _react.useCallback)(function() {
        if (anchorRef.current && anchorRef.current.focus) anchorRef.current.focus();
        onCloseProp();
    }, [
        onCloseProp,
        anchorRef
    ]);
    var onCloseMaybe = onCloseProp ? onCloseCallback : undefined;
    (0, _react.useEffect)(function() {
        if (props.open) // Remember the node that the modal was opened from. We'll try to focus on
        // this when the modal is closed. We put this logic in a side effect rather
        // then the `modalRef` callback b/c by the time that callback is called
        // it's too late and the `activeElement` might already be an auto-focused
        // element inside of the modal - negating the benefit of remembering which
        // node caused the modal to open.
        anchorRef.current = document.activeElement;
    }, [
        props.open
    ]);
    var modalRef = (0, _react.useCallback)(function(modalNode) {
        if (modalNode) {
            // Get the active element and check if it's inside of the modal
            var activeElementInsideModal = modalNode.contains(document.activeElement);
            if (!activeElementInsideModal) {
                // Focus the first node in the Modal
                modalNode.focus(); // Reset the scroll position of the scrim to counteract the browser
                // auto-scrolling to the focused node. Note that we have to wait one
                // event loop for this to work (otherwise we'd be resetting the scroll
                // *before* the browser auto-scrolls).
                // Prevent the browser from scrolling to the focused node to avoid a
                // jitter when the modal opens.
                // TODO: Update this to use the "preventScroll" focus option when Safari
                // implements that and we drop support for IE11.
                if (scrimRef.current) setTimeout(function() {
                    scrimRef.current.scrollTop = 0;
                    scrimRef.current.scrollLeft = 0;
                }, 0);
            }
        }
    }, []);
    return /*#__PURE__*/ _react["default"].createElement(AnimateFadeScaleWithMount, {
        open: props.open,
        duration: t("motionDuration"),
        easing: t("motionFunction"),
        onOpen: props.onOpen
    }, function(_ref) {
        var className = _ref.className, onTransitionEnd = _ref.onTransitionEnd, open = _ref.open;
        return /*#__PURE__*/ _react["default"].createElement(_responsive["default"], {
            query: "min-width",
            props: {
                fullscreen: (0, _defineProperty2["default"])({
                    "default": true
                }, "".concat(t("floatingBreakpoint"), "px"), false)
            }
        }, function(_ref2) {
            var fullscreen = _ref2.fullscreen;
            var modal = /*#__PURE__*/ _react["default"].createElement(_modalBox["default"], (0, _extends2["default"])({}, props, {
                onClose: onCloseMaybe,
                t: t,
                scrollContainer: props.scrollContainer,
                fullscreen: fullscreen,
                className: className,
                onTransitionEnd: onTransitionEnd,
                ref: modalRef
            }));
            return /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, fullscreen ? modal : /*#__PURE__*/ _react["default"].createElement(_scrim["default"], {
                open: props.open || open,
                className: scrimStyles,
                onClick: onCloseMaybe,
                ref: scrimRef
            }, /*#__PURE__*/ _react["default"].createElement("div", {
                className: outerWrapperStyles
            }, /*#__PURE__*/ _react["default"].createElement("div", {
                className: innerWrapperStyles,
                onMouseDown: // applied to keep the modal away from the
                // edges of the viewport. This padding appears
                // as scrim space to the user, but it blocks
                // clicks to the scrim so we have to add the
                // click-to-close behavior here as well
                (0, _onDirectClick["default"])(onCloseMaybe)
            }, modal))));
        });
    });
}, shouldNotUpdate);
Modal.displayName = "Modal";
Modal.propTypes = {};
Modal.defaultProps = {
    closeButtonPropagateClickEvent: true,
    closeLabel: "Close",
    bodySpacingInset: "medium",
    scrollContainer: "viewport"
};
var _default = Modal;
exports["default"] = _default;

},{"4bb4a10ead1acadd":"k8mdG","f0e359f2d7c1ba18":"fk2Bw","417081af22cd4112":"ef0K4","d80450fdace38c94":"hcG56","daec08b09d054f18":"6uln9","3fffd608029d49a4":"cnMFu","e4c5c18472f3451":"jNAqq","cb8576d3fc51829b":"dfs8f","22713aad3e86980a":"eM9hO","17261e99ae459347":"2kyXS","2252f7a980df367a":"64SHp","5a4bc1f31c6124dc":"54pOf","62c27cd99b1c4360":"3W2BX","6b644257858633d5":"ihBLX","db2aee71ffb118ea":"4deck","3a9d36550a7a93c1":"1RC46"}],"dfs8f":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("85973dc37c0159d3");
var _interopRequireDefault = require("4be731ec993bce41");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scrimSpacingHorizontal = exports.scrimSpacingVertical = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("132b264cd158a106"));
var _defineProperty2 = _interopRequireDefault(require("82d46ce774f1e01d"));
var _react = _interopRequireWildcard(require("4d7b7b98d097f45c"));
var _propTypes = _interopRequireDefault(require("aa96d6183f87986e"));
var _keycode = _interopRequireDefault(require("6ee82a48c3132714"));
var _close = _interopRequireDefault(require("2db034741da52a0d"));
var _elevation = require("ff475e80f8441e42");
var _uniqueId = _interopRequireDefault(require("c07b7ad23c9b33fa"));
var _modalFooter = _interopRequireDefault(require("1225f23f51bb833"));
var _button = _interopRequireDefault(require("48a8b40950c6c517"));
var _icon = _interopRequireDefault(require("4fd83997c4ab2f57"));
var _focusTrap = _interopRequireDefault(require("a50e433eb225f174"));
var _propTypes2 = _interopRequireDefault(require("b109e588a81570db"));
var _parsers = require("22a576d779a8768e");
var _emotion = require("cb342c97d05f29da");
var _isElementOf = _interopRequireDefault(require("5268dfdf3832108e"));
var _text = _interopRequireDefault(require("9aa29f5bc4751302"));
var _useFocus2 = _interopRequireDefault(require("6cbe7cce5ba2a4b0"));
var _focusRing = _interopRequireDefault(require("47c091bd52b52210"));
var _filterPropsByPrefix = _interopRequireDefault(require("584dcdcda94b1f42"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var closeButtonWidth = 32; // px
var scrimSpacingVertical = 10; // vh
exports.scrimSpacingVertical = scrimSpacingVertical;
var scrimSpacingHorizontal = 10; //vw
exports.scrimSpacingHorizontal = scrimSpacingHorizontal;
var isFooter = (0, _isElementOf["default"])(_modalFooter["default"]);
var isNotFooter = function isNotFooter(child) {
    return !isFooter(child);
};
var styles = function styles(t, _ref) {
    var focus = _ref.focus, scrollContainer = _ref.scrollContainer, fullscreen = _ref.fullscreen, width = _ref.width, bodySpacingInset = _ref.bodySpacingInset, showTitle = _ref.showTitle, showCloseButton = _ref.showCloseButton;
    var padding = (0, _parsers.parseSpacing)(bodySpacingInset);
    return (0, _emotion.css)(/**
   * Fullscreen vs non-fullscreen styles
   */ fullscreen ? {
        // Fullscreen modals aren't shown in a scrim so we've got to handle
        // layout here
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: _elevation.elevationModal,
        // Use momentum scrolling on iOS. See:
        // https://css-tricks.com/snippets/css/momentum-scrolling-on-ios-overflow-elements/
        overflowY: "scroll",
        WebkitOverflowScrolling: "touch"
    } : {
        // Apply the user-provided width if we're not showing a fullscreen
        // modal
        width: width,
        // This allows the absolutely-positioned close button to anchor itself
        // to the modal
        position: "relative",
        boxShadow: t.boxShadowCss("dropShadow"),
        maxHeight: scrollContainer === "modal" ? "".concat(100 - scrimSpacingVertical * 2, "vh") : undefined,
        maxWidth: "".concat(100 - scrimSpacingHorizontal * 2, "vw"),
        borderRadius: t("borderRadius")
    }, focus ? (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        borderRadius: t("borderRadius")
    }) : {}, {
        /**
     * Common styles
     */ display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: t("bodyBackgroundColor"),
        outline: "none",
        /**
     * Header styles
     */ "& > header": (0, _emotion.css)((0, _text["default"])(t), {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            minHeight: t("headerMinHeight"),
            paddingTop: t("headerSpacingInsetTop"),
            paddingRight: t("headerSpacingInsetRight"),
            paddingBottom: t("headerSpacingInsetBottom"),
            paddingLeft: t("headerSpacingInsetLeft"),
            backgroundColor: t("headerBackgroundColor"),
            color: t("headerForegroundColor"),
            fontWeight: t("headerFontWeight")
        }),
        /**
     * Body styles
     */ "& > div": {
            padding: (0, _parsers.parseSpacing)(bodySpacingInset).map(function(value) {
                return "".concat(value, "px");
            }).join(" "),
            // Add extra right-padding on modals with no title and a close button
            paddingRight: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined,
            overflowY: scrollContainer === "modal" ? "auto" : undefined,
            overflowX: "auto",
            // In fullscreen mode the body should fill up any screen space not used by
            // the header or footer
            flex: fullscreen ? "auto" : undefined
        },
        /**
     * Footer styles
     */ "& > footer": {
            borderTop: t.borderCss("footerBorder"),
            padding: t("footerSpacingInset")
        }
    });
};
var closeButtonStyles = function closeButtonStyles(t) {
    return (0, _emotion.css)({
        position: "absolute",
        top: t("closeButtonSpacingTop"),
        right: t("closeButtonSpacingRight"),
        zIndex: _elevation.elevationForeground
    });
};
/* eslint-disable react/prop-types, react/display-name */ // The element we use at the root of the modal depends on
// the presence of an `onSubmit` prop. If the method
// is present, the modal uses a <form> element, else
// a <div>
var ModalBoxRoot = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(props.onSubmit ? "form" : "div", _objectSpread(_objectSpread({}, props), {}, {
        tabIndex: 0,
        ref: ref
    }));
});
/* eslint-enable react/prop-types, react/display-name */ /**
 * This component can be used to render a modal for your application
 */ var ModalBox = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var onClose = props.onClose, onSubmitForm = props.onSubmitForm, formAction = props.formAction, formMethod = props.formMethod;
    var id = (0, _react.useMemo)(function() {
        return (0, _uniqueId["default"])("modal-");
    }, []);
    var headerId = props.title ? "".concat(id, "-header") : undefined;
    var footer = _react["default"].Children.toArray(props.children).filter(isFooter)[0];
    var _useFocus = (0, _useFocus2["default"])(props), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps, focusDescendent = _useFocus.focusDescendent; // Call the onClose handler if the esc key is pressed
    var onKeyDownDocument = (0, _react.useCallback)(function(event) {
        if ((0, _keycode["default"])(event) === "esc") onClose();
    }, [
        onClose
    ]); // Bind the onKeyDownDocument handler to the window
    (0, _react.useEffect)(function() {
        if (onClose) window.addEventListener("keydown", onKeyDownDocument);
        return function() {
            return window.removeEventListener("keydown", onKeyDownDocument);
        };
    }, [
        onClose,
        onKeyDownDocument
    ]);
    var onSubmit = (0, _react.useCallback)(function(event) {
        if (!formAction && !formMethod) event.preventDefault();
        onSubmitForm();
    }, [
        formAction,
        formMethod,
        onSubmitForm
    ]);
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/ _react["default"].createElement(ModalBoxRoot, (0, _extends2["default"])({}, passThroughProps, focusProps, {
        className: (0, _emotion.cx)(props.className, styles(props.t, {
            focus: focus && focusTrigger === "keyboard" && !focusDescendent,
            scrollContainer: props.scrollContainer,
            width: props.width,
            fullscreen: props.fullscreen,
            bodySpacingInset: props.bodySpacingInset,
            showTitle: Boolean(props.title),
            showCloseButton: Boolean(onClose)
        })),
        onTransitionEnd: props.onTransitionEnd,
        onSubmit: onSubmitForm ? onSubmit : undefined,
        action: props.formAction,
        method: props.formMethod,
        "aria-labelledby": headerId,
        "aria-describedby": props.describedById,
        "aria-modal": true,
        ref: ref
    }), props.title ? /*#__PURE__*/ _react["default"].createElement("header", {
        id: headerId
    }, props.title) : null, onClose ? /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        onClick: onClose,
        size: "small",
        type: "icon",
        backdropColor: props.title ? props.t("headerBackgroundColor") : props.t("bodyBackgroundColor"),
        className: closeButtonStyles(props.t),
        propagateClickEvent: props.closeButtonPropagateClickEvent
    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: _close["default"]
    }, props.closeLabel)) : null, /*#__PURE__*/ _react["default"].createElement("div", null, _react["default"].Children.toArray(props.children).filter(isNotFooter)), footer ? footer : null));
});
ModalBox.displayName = "ModalBox";
ModalBox.propTypes = {};
var _default = ModalBox;
exports["default"] = _default;

},{"85973dc37c0159d3":"k8mdG","4be731ec993bce41":"fk2Bw","132b264cd158a106":"ef0K4","82d46ce774f1e01d":"hcG56","4d7b7b98d097f45c":"6uln9","aa96d6183f87986e":"cnMFu","6ee82a48c3132714":"bL2S4","2db034741da52a0d":"2AQYC","ff475e80f8441e42":"dKmTh","c07b7ad23c9b33fa":"4yTHb","1225f23f51bb833":"gctY3","48a8b40950c6c517":"gJQuD","4fd83997c4ab2f57":"jPx5F","a50e433eb225f174":"K72GC","b109e588a81570db":"ihBLX","22a576d779a8768e":"aSMp2","cb342c97d05f29da":"4deck","5268dfdf3832108e":"brP3O","9aa29f5bc4751302":"13UMz","6cbe7cce5ba2a4b0":"ZdEsX","47c091bd52b52210":"7yXmF","584dcdcda94b1f42":"8cR2N"}],"gctY3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("666bd1ee87e3b308");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("3728b172b3b6427d"));
var _propTypes = _interopRequireDefault(require("947155b1e017d8cc"));
/**
 * This component is used to render a footer in your Modal. It is meant to
 * be used with Modals of type "scrollableRegion," and without it modals of
 * those type will not render correctly.
 */ var ModalFooter = function ModalFooter(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ _react["default"].createElement("footer", null, children);
};
ModalFooter.propTypes = {};
var _default = ModalFooter;
exports["default"] = _default;

},{"666bd1ee87e3b308":"fk2Bw","3728b172b3b6427d":"6uln9","947155b1e017d8cc":"cnMFu"}],"K72GC":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("828e782f27a3ac05");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _focusTrap = _interopRequireDefault(require("c577f4b6176f58d9"));
var _default = _focusTrap["default"];
exports["default"] = _default;

},{"828e782f27a3ac05":"fk2Bw","c577f4b6176f58d9":"cpZGz"}],"cpZGz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3aebcc18c112d122");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("ca703b1904a63715"));
var _createClass2 = _interopRequireDefault(require("609d28af47ecc8a0"));
var _assertThisInitialized2 = _interopRequireDefault(require("d87f055b288d9c95"));
var _inherits2 = _interopRequireDefault(require("e03b34be7c2f610e"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("ed226982895e43d1"));
var _getPrototypeOf2 = _interopRequireDefault(require("6898dca69e5d09b9"));
var _defineProperty2 = _interopRequireDefault(require("312ed71a7550284c"));
var _react = _interopRequireDefault(require("9539850f1aa0a0f7"));
var _propTypes = _interopRequireDefault(require("15573a338c3af8fe"));
var _reactDom = _interopRequireDefault(require("ea389e44e27795d5"));
var _keycode = _interopRequireDefault(require("3321cefb010d2494"));
var _includes = _interopRequireDefault(require("d02f748eda9691"));
var _find = _interopRequireDefault(require("1d9fa5dc58c1eaad"));
var _findLast = _interopRequireDefault(require("bd9ac1f0d896dc95"));
var _noop = _interopRequireDefault(require("e99074ec12ba0ef1"));
var _focus = require("aee3cf20ab334d74");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This component allows you to trap the keyboard focus within a particular
 * section of the DOM (the component's children). An optional onBeforeBlur event
 * handler can be defined that allows you to execute custom behavior when the
 * user attempts to move the focus outside of the trap by pressing the tab key.
 *
 * NOTE: This component only handles keyboard focus. If the mouse is used to
 * move focus outside of the trap then the trap will not prevent the focus
 * change and onBeforeBlur will not be called.
 *
 * NOTE: This component must be wrapped around a single element to work
 * properly.
 *
 * NOTE: This component only manages focus for elements that are
 * descendents in the real DOM. This means that it will ignore any portals
 * nested inside of it in the virtual DOM.
 */ var FocusTrap = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(FocusTrap, _React$Component);
    var _super = _createSuper(FocusTrap);
    function FocusTrap() {
        var _this;
        (0, _classCallCheck2["default"])(this, FocusTrap);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootNode", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function(event) {
            if ((0, _keycode["default"])(event) === "tab") {
                var _getBoundingFocusNode = (0, _focus.getBoundingFocusNodes)(_this.rootNode), startNodes = _getBoundingFocusNode.startNodes, endNodes = _getBoundingFocusNode.endNodes;
                var willBlur = _this.willBlur(event, startNodes, endNodes);
                var allowBlur = willBlur && _this.props.onBeforeBlur(willBlur);
                var firstFocusNode = (0, _find["default"])(startNodes, _focus.canKeyboardFocusNode);
                var lastFocusNode = (0, _findLast["default"])(endNodes, _focus.canKeyboardFocusNode); // If onBeforeBlur returned nothing then loop the focus ourselves
                if (willBlur === -1 && allowBlur === undefined && lastFocusNode) lastFocusNode.focus();
                if (willBlur === 1 && allowBlur === undefined && firstFocusNode) firstFocusNode.focus();
                 // If allowBlur was not explicitly set to true then cancel the default event
                // behavior
                if (willBlur && allowBlur !== true) event.preventDefault();
            }
        });
        return _this;
    }
    (0, _createClass2["default"])(FocusTrap, [
        {
            key: "focus",
            value: function focus() {
                var node = (0, _focus.getKeyboardFocusNodes)(this.rootNode)[0];
                if (node) node.focus();
            }
        },
        {
            key: "focusEnd",
            value: function focusEnd() {
                var nodes = (0, _focus.getKeyboardFocusNodes)(this.rootNode);
                var node = nodes[nodes.length - 1];
                if (node) node.focus();
            }
        },
        {
            key: "willBlur",
            value: function willBlur(event, startNodes, endNodes) {
                var key = (0, _keycode["default"])(event);
                var target = event.target, shiftKey = event.shiftKey;
                return (0, _includes["default"])(endNodes, target) && key === "tab" && !shiftKey ? 1 : (0, _includes["default"])(startNodes, target) && key === "tab" && shiftKey ? -1 : 0;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                /* eslint-disable-next-line react/no-find-dom-node */ this.rootNode = _reactDom["default"].findDOMNode(this);
                this.rootNode.addEventListener("keydown", this.onKeyDown);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.rootNode.removeEventListener("keydown", this.onKeyDown);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return FocusTrap;
}(_react["default"].Component);
(0, _defineProperty2["default"])(FocusTrap, "defaultProps", {
    onBeforeBlur: _noop["default"]
});
FocusTrap.propTypes = {};
var _default = FocusTrap;
exports["default"] = _default;

},{"3aebcc18c112d122":"fk2Bw","ca703b1904a63715":"5Yd3f","609d28af47ecc8a0":"6Jptv","d87f055b288d9c95":"lMa5o","e03b34be7c2f610e":"j4mqF","ed226982895e43d1":"krVd4","6898dca69e5d09b9":"8h5p9","312ed71a7550284c":"hcG56","9539850f1aa0a0f7":"6uln9","15573a338c3af8fe":"cnMFu","ea389e44e27795d5":"b8T3j","3321cefb010d2494":"bL2S4","d02f748eda9691":"lOqwL","1d9fa5dc58c1eaad":"2GWEB","bd9ac1f0d896dc95":"ibZ9Q","e99074ec12ba0ef1":"7osqO","aee3cf20ab334d74":"iqUT6"}],"lOqwL":[function(require,module,exports) {
var baseIndexOf = require("786fbf6569b2449c"), isArrayLike = require("efd9beda2572de23"), isString = require("e18dde566caaf0f"), toInteger = require("7f38ed4bc4d7e424"), values = require("e8eaacb73a63ffe");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
    return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
module.exports = includes;

},{"786fbf6569b2449c":"cbIxa","efd9beda2572de23":"gnYyq","e18dde566caaf0f":"jz6G3","7f38ed4bc4d7e424":"9irPk","e8eaacb73a63ffe":"3gNCR"}],"cbIxa":[function(require,module,exports) {
var baseFindIndex = require("2bcddd873584fc28"), baseIsNaN = require("3f1e772794c5f38d"), strictIndexOf = require("707059c8aacdfb2c");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"2bcddd873584fc28":"a7lSm","3f1e772794c5f38d":"9R4L6","707059c8aacdfb2c":"fJa7O"}],"9R4L6":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"fJa7O":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"jz6G3":[function(require,module,exports) {
var baseGetTag = require("597ce1e7cc2e1b32"), isArray = require("c8f9ab67bd30c52c"), isObjectLike = require("b1f471a3cf85787a");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"597ce1e7cc2e1b32":"8nzKY","c8f9ab67bd30c52c":"6WNsH","b1f471a3cf85787a":"hSXky"}],"3gNCR":[function(require,module,exports) {
var baseValues = require("859aea48babd6825"), keys = require("b0862aa293e0b8cf");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"859aea48babd6825":"g7PRt","b0862aa293e0b8cf":"fuSIb"}],"g7PRt":[function(require,module,exports) {
var arrayMap = require("87fdcbc3e0d789e0");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"87fdcbc3e0d789e0":"lLYVY"}],"2GWEB":[function(require,module,exports) {
var createFind = require("c441a24dcf782d1f"), findIndex = require("e52f4dbd7eaff150");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"c441a24dcf782d1f":"ijtOv","e52f4dbd7eaff150":"caIAP"}],"ijtOv":[function(require,module,exports) {
var baseIteratee = require("613764b10aaea558"), isArrayLike = require("ab77b8426fcf3a68"), keys = require("6482267d98c62075");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"613764b10aaea558":"3xVMK","ab77b8426fcf3a68":"gnYyq","6482267d98c62075":"fuSIb"}],"ibZ9Q":[function(require,module,exports) {
var createFind = require("6f7d5023e9eaa6d5"), findLastIndex = require("c520b61aabfd94c6");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var findLast = createFind(findLastIndex);
module.exports = findLast;

},{"6f7d5023e9eaa6d5":"ijtOv","c520b61aabfd94c6":"gr94G"}],"ihBLX":[function(require,module,exports) {
"use strict";
module.exports = require("86d7eb39c4ed97ea");

},{"86d7eb39c4ed97ea":"465Bm"}],"465Bm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var shim = function shim() {};
shim.isRequired = shim;
var getShim = function getShim() {
    return shim;
}; // Important!
// Keep this list in sync with production version in `./_prop-types.js`.
var size = shim;
var flexAlignment = getShim;
var spacing = getShim;
var alignment = shim;
var _default = {
    size: size,
    flexAlignment: flexAlignment,
    spacing: spacing,
    alignment: alignment
};
exports["default"] = _default;

},{}],"aSMp2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a7bc865cc5509ddb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseAlignment = exports.parseSpacing = void 0;
var _spacing = _interopRequireDefault(require("d311b7815839cdb5"));
var _token = require("d2dd88ae9e3e9292");
// Parses the value for a spacing prop. This turns a string of spacing names
// like "medium" or "small medium" into an array of spacing values like ["16px"]
// or ["8px", "16px"].
var parseSpacing = function parseSpacing(spacing) {
    return spacing ? spacing.split(" ").map(function(spacing) {
        return (0, _token.getToken)(_spacing["default"], "spacing", spacing) || 0;
    }) : [];
}; // Parses the value for a alignment prop. Given a valid alignment prop value
// this will return an array of two values representing x and y alignment
// respectively.
exports.parseSpacing = parseSpacing;
var parseAlignment = function parseAlignment(alignment) {
    var values = alignment.split(" ");
    return {
        x: values[1],
        y: values[0]
    };
};
exports.parseAlignment = parseAlignment;

},{"a7bc865cc5509ddb":"fk2Bw","d311b7815839cdb5":"8D3is","d2dd88ae9e3e9292":"atHRo"}],"2kyXS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("82df4dc8e66dd344");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _scrim = _interopRequireDefault(require("673d0e32d5bf5a49"));
var _default = _scrim["default"];
exports["default"] = _default;

},{"82df4dc8e66dd344":"fk2Bw","673d0e32d5bf5a49":"gqBjV"}],"gqBjV":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("b2c81bea3ea5af81");
var _interopRequireDefault = require("3f39c1af77f2c5b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("c81728dec0e91387"));
var _propTypes = _interopRequireDefault(require("ce067001f918cd4f"));
var _emotion = require("9f8883e31e76fbce");
var _scrim = _interopRequireDefault(require("f1890c6e165bf75c"));
var _theme = require("486e9194d05780a1");
var _animateMount = _interopRequireWildcard(require("941a80914b612f3a"));
var _onDirectClick = _interopRequireDefault(require("9f314d551b5d77d1"));
var AnimateFadeWithMount = (0, _animateMount["default"])(_animateMount.AnimateFade);
var styles = function styles(t) {
    return (0, _emotion.css)({
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: t("elevation"),
        backgroundColor: t("backgroundColor")
    });
};
/**
 * Don't bother updating the scrim if it's persisting in a closed state.
 */ var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return !prevProps.open && !nextProps.open;
};
var Scrim = /*#__PURE__*/ _react["default"].memo(/*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_scrim["default"], "scrim");
    return /*#__PURE__*/ _react["default"].createElement(AnimateFadeWithMount, {
        open: props.open,
        onOpen: props.onOpen,
        duration: props.duration || t("motionTiming"),
        easing: props.easing || t("motionFunction"),
        type: "fade"
    }, function(_ref) {
        var className = _ref.className, onTransitionEnd = _ref.onTransitionEnd;
        return(/*#__PURE__*/ // Regarding role=none, see:
        // https://www.scottohara.me/blog/2018/05/05/hidden-vs-none.html#what-does-rolenone-and-rolepresentation-do
        _react["default"].createElement("div", {
            role: "none",
            className: (0, _emotion.cx)(className, styles(t), props.className),
            onTransitionEnd: onTransitionEnd,
            onMouseDown: (0, _onDirectClick["default"])(props.onClick),
            ref: ref
        }, props.children));
    });
}), shouldNotUpdate);
Scrim.displayName = "Scrim";
Scrim.propTypes = {};
Scrim.defaultProps = {
    open: false,
    className: null
};
var _default = Scrim;
exports["default"] = _default;

},{"b2c81bea3ea5af81":"k8mdG","3f39c1af77f2c5b":"fk2Bw","c81728dec0e91387":"6uln9","ce067001f918cd4f":"cnMFu","9f8883e31e76fbce":"4deck","f1890c6e165bf75c":"i5KEc","486e9194d05780a1":"eM9hO","941a80914b612f3a":"3W2BX","9f314d551b5d77d1":"1RC46"}],"3W2BX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a052baf8cee80d6f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnimateFade", {
    enumerable: true,
    get: function get() {
        return _animateFade["default"];
    }
});
Object.defineProperty(exports, "AnimateSlideIn", {
    enumerable: true,
    get: function get() {
        return _animateSlideIn["default"];
    }
});
Object.defineProperty(exports, "AnimateFadeScale", {
    enumerable: true,
    get: function get() {
        return _animateFadeScale["default"];
    }
});
exports["default"] = void 0;
var _withAnimateMount = _interopRequireDefault(require("a3b63952b2cf0cbc"));
var _animateFade = _interopRequireDefault(require("8f519fbfd24e79a"));
var _animateSlideIn = _interopRequireDefault(require("23a5a05d5148e45b"));
var _animateFadeScale = _interopRequireDefault(require("1e98c96c5e928a73"));
var _default = _withAnimateMount["default"];
exports["default"] = _default;

},{"a052baf8cee80d6f":"fk2Bw","a3b63952b2cf0cbc":"366tA","8f519fbfd24e79a":"3vN9G","23a5a05d5148e45b":"5qAk0","1e98c96c5e928a73":"enm2V"}],"366tA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("124b3b0fe34360e3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("3fd4fe18cc7a4177"));
var _classCallCheck2 = _interopRequireDefault(require("6e8fefcea30761c1"));
var _createClass2 = _interopRequireDefault(require("fef4dbc863f53c2f"));
var _assertThisInitialized2 = _interopRequireDefault(require("2fcb38144c5a7b87"));
var _inherits2 = _interopRequireDefault(require("44ed510c25c54a69"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("bae26db2fe31ee62"));
var _getPrototypeOf2 = _interopRequireDefault(require("5408b8da7235c9cc"));
var _defineProperty2 = _interopRequireDefault(require("600d990899ce136b"));
var _react = _interopRequireDefault(require("fd5f156260efd62f"));
var _propTypes = _interopRequireDefault(require("4c52795c577a2fa8"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// Provides the WrappedComponent's displayName
// for easy debugging
var getsDisplayName = function getsDisplayName(WrappedComponent) {
    return WrappedComponent.getsDisplayName || WrappedComponent.name || "Component";
};
var withAnimateMount = function withAnimateMount(WrappedComponent) {
    var _class, _temp;
    /**
   * This is a higher order component that provides a consistent API to easily
   * create animations to be used for elements that need to be added and
   * removed to the DOM dynamically. Receives an animation component and returns a
   * wrapped, composed component.
   */ return _temp = _class = /*#__PURE__*/ function(_React$Component) {
        (0, _inherits2["default"])(WithAnimateMount, _React$Component);
        var _super = _createSuper(WithAnimateMount);
        function WithAnimateMount() {
            var _this;
            (0, _classCallCheck2["default"])(this, WithAnimateMount);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
                show: false
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
                if (typeof _this.props.onOpen !== "undefined" && _this.state.show) _this.props.onOpen();
                 // Remount the node when the open prop is true
                _this.setState({
                    show: true
                });
            });
            (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
                if (!_this.props.open) _this.setState({
                    show: false
                });
            });
            return _this;
        }
        (0, _createClass2["default"])(WithAnimateMount, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.open) this.updateStateOnOpen();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (!prevProps.open && this.props.open) this.updateStateOnOpen();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, open = _this$props.open, animateToHeight = _this$props.animateToHeight;
                    var animateToHeightProps = typeof animateToHeight !== "undefined" ? {
                        animateToHeight: animateToHeight
                    } : null;
                    return this.state.show && /*#__PURE__*/ _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
                        duration: duration,
                        easing: easing,
                        open: open,
                        updateStateOnOpen: this.updateStateOnOpen,
                        transitionEnd: this.transitionEnd
                    }, animateToHeightProps), children);
                }
            }
        ]);
        return WithAnimateMount;
    }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "propTypes", {
        /**
     * A function that returns the elements to animate.
     */ children: _propTypes["default"].func.isRequired,
        /**
     * If true the children will be mounted, otherwise they will be unmounted.
     */ open: _propTypes["default"].bool.isRequired,
        /**
     * Only applies to height based transitions. Allows for cases when the
     * desired effect is animating height to a value that's different than
     * the element's scrollHeight.
     */ animateToHeight: _propTypes["default"].oneOfType([
            _propTypes["default"].string,
            _propTypes["default"].number
        ]),
        /**
     * The duration of the animation. This should be a valid CSS animation
     * duration (e.g. `"100ms"` or `"1s"`).
     */ duration: _propTypes["default"].string,
        /**
     * The easing function of the animation. This should be a valid CSS easing
     * function (e.g. `"linear"` or `"ease"`).
     */ easing: _propTypes["default"].string,
        /**
     * The function provided here will be called if the component transitions
     * from a closed state to an open state, or if it is mounted in an open
     * state. Note that this is called as soon as the state changes, which
     * occurs *before* the elements being mounted are actually available in
     * the DOM.
     */ onOpen: _propTypes["default"].func
    }), (0, _defineProperty2["default"])(_class, "defaultProps", {
        duration: "150ms",
        easing: "ease",
        open: false
    }), (0, _defineProperty2["default"])(_class, "displayName", "WithAnimateMount(".concat(getsDisplayName(WrappedComponent), ")")), _temp;
};
var _default = withAnimateMount;
exports["default"] = _default;

},{"124b3b0fe34360e3":"fk2Bw","3fd4fe18cc7a4177":"ef0K4","6e8fefcea30761c1":"5Yd3f","fef4dbc863f53c2f":"6Jptv","2fcb38144c5a7b87":"lMa5o","44ed510c25c54a69":"j4mqF","bae26db2fe31ee62":"krVd4","5408b8da7235c9cc":"8h5p9","600d990899ce136b":"hcG56","fd5f156260efd62f":"6uln9","4c52795c577a2fa8":"cnMFu"}],"3vN9G":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1d3b182cbdf7d29c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("f5a9dccb9a861af2"));
var _createClass2 = _interopRequireDefault(require("9fc52d3719b2daf9"));
var _assertThisInitialized2 = _interopRequireDefault(require("41bd9e880fa77d94"));
var _inherits2 = _interopRequireDefault(require("fb5cff91ea11c13e"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("9dc094643d229d04"));
var _getPrototypeOf2 = _interopRequireDefault(require("405255b4f3980fbd"));
var _defineProperty2 = _interopRequireDefault(require("ea360361708d4767"));
var _react = _interopRequireDefault(require("18e3d531670ee442"));
var _propTypes = _interopRequireDefault(require("5a454d3e1596cd88"));
var _emotion = require("2458e123f0cd10a3");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(opacity, duration, easing) {
    return (0, _emotion.css)({
        opacity: opacity,
        transition: "opacity ".concat(duration, " ").concat(easing)
    });
};
var AnimateFade = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateFade, _React$Component);
    var _super = _createSuper(AnimateFade);
    function AnimateFade() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateFade);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            opacity: 0
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Set state to trigger intro animation
            _this.timer = setTimeout(_this.updateStateOnMount, 0);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            // Update state for unmount animation
            _this.setState({
                opacity: 0
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            // Update state for mount animation
            _this.setState({
                opacity: 1
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
            if (!_this.props.open) // Tell the wrapper component to remove the node on transition end when
            // the open prop is false
            _this.props.transitionEnd();
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateFade, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
                else if (!prevProps.open && this.props.open) this.updateStateOnMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clear our timer to prevent leaks
                clearTimeout(this.timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var opacity = this.state.opacity;
                var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, className = _this$props.className;
                var styles = mountStyled(opacity, duration, easing);
                return children({
                    className: (0, _emotion.cx)(className, styles),
                    onTransitionEnd: this.transitionEnd
                });
            }
        }
    ]);
    return AnimateFade;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateFade, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateFade.propTypes = {};
var _default = AnimateFade;
exports["default"] = _default;

},{"1d3b182cbdf7d29c":"fk2Bw","f5a9dccb9a861af2":"5Yd3f","9fc52d3719b2daf9":"6Jptv","41bd9e880fa77d94":"lMa5o","fb5cff91ea11c13e":"j4mqF","9dc094643d229d04":"krVd4","405255b4f3980fbd":"8h5p9","ea360361708d4767":"hcG56","18e3d531670ee442":"6uln9","5a454d3e1596cd88":"cnMFu","2458e123f0cd10a3":"4deck"}],"5qAk0":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b6ca93a650ee9ddd");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("f13b7b0292f13576"));
var _createClass2 = _interopRequireDefault(require("8891ec9536421352"));
var _assertThisInitialized2 = _interopRequireDefault(require("733b1698c6f9cf49"));
var _inherits2 = _interopRequireDefault(require("b2ac6603be4e8b25"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("bb8b9c2fe6924533"));
var _getPrototypeOf2 = _interopRequireDefault(require("7a725446766d2b32"));
var _defineProperty2 = _interopRequireDefault(require("6fc98b6c5b9e5a82"));
var _react = _interopRequireDefault(require("49a80492adc8f931"));
var _propTypes = _interopRequireDefault(require("adf3f9cb9f3fef9"));
var _emotion = require("ac4741cd51e4c7e0");
var _waitAnimationFrame = _interopRequireDefault(require("8ac5c8c555ede7cd"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(_ref) {
    var open = _ref.open, height = _ref.height, duration = _ref.duration, easing = _ref.easing;
    return (0, _emotion.css)({
        transform: "translateY(".concat(open ? "0" : "100%", ")"),
        height: height,
        overflow: "auto",
        transition: "transform ".concat(duration, " ").concat(easing)
    });
};
var AnimateSlideIn = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateSlideIn, _React$Component);
    var _super = _createSuper(AnimateSlideIn);
    function AnimateSlideIn() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateSlideIn);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            open: false
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMounted", false);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Wait one animation frame so that the DOM can settle after mounting the
            // element, then set the state to trigger the mount animation
            (0, _waitAnimationFrame["default"])(_this.updateStateOnMount);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            return _this.setState({
                open: false
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            if (_this.isMounted) _this.setState({
                open: true
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateSlideIn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.isMounted = true;
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.open && this.props.open) this.updateStateOnOpen();
                else if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.isMounted = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var state = this.state;
                var props = this.props;
                var styles = mountStyled({
                    open: state.open,
                    duration: props.duration,
                    easing: props.easing,
                    height: props.animateToHeight
                });
                return props.children({
                    open: state.open,
                    className: (0, _emotion.cx)(props.className, styles),
                    onTransitionEnd: this.props.transitionEnd
                });
            }
        }
    ]);
    return AnimateSlideIn;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateSlideIn, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateSlideIn.propTypes = {};
var _default = AnimateSlideIn;
exports["default"] = _default;

},{"b6ca93a650ee9ddd":"fk2Bw","f13b7b0292f13576":"5Yd3f","8891ec9536421352":"6Jptv","733b1698c6f9cf49":"lMa5o","b2ac6603be4e8b25":"j4mqF","bb8b9c2fe6924533":"krVd4","7a725446766d2b32":"8h5p9","6fc98b6c5b9e5a82":"hcG56","49a80492adc8f931":"6uln9","adf3f9cb9f3fef9":"cnMFu","ac4741cd51e4c7e0":"4deck","8ac5c8c555ede7cd":"fDQaK"}],"enm2V":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("512e287677ce35f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("1b8180ac51ed112b"));
var _createClass2 = _interopRequireDefault(require("d96eed120a1bbba6"));
var _assertThisInitialized2 = _interopRequireDefault(require("f88bef3cf52fe0ac"));
var _inherits2 = _interopRequireDefault(require("8dd0cdd3b9337be3"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("6bea127646db58de"));
var _getPrototypeOf2 = _interopRequireDefault(require("8195ec3289c7f94b"));
var _defineProperty2 = _interopRequireDefault(require("ab9bbb7063d83233"));
var _react = _interopRequireDefault(require("8eb76b06ecfdc10e"));
var _propTypes = _interopRequireDefault(require("e353f3e516512988"));
var _emotion = require("7ef66aa04cdcdcaf");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var mountStyled = function mountStyled(opacity, scale, duration, easing) {
    return (0, _emotion.css)({
        opacity: opacity,
        transform: "scale(".concat(scale, ")"),
        transition: "opacity ".concat(duration, " ").concat(easing, ", transform ").concat(duration, " ").concat(easing)
    });
};
var AnimateFadeScale = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(AnimateFadeScale, _React$Component);
    var _super = _createSuper(AnimateFadeScale);
    function AnimateFadeScale() {
        var _this;
        (0, _classCallCheck2["default"])(this, AnimateFadeScale);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            opacity: 0,
            scale: 0.75
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function() {
            // Tell the wrapper component to remount the node when the open prop is true
            _this.props.updateStateOnOpen(); // Set state to trigger intro animation
            _this.timer = setTimeout(_this.updateStateOnMount, 0);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function() {
            // Update state for unmount animation
            _this.setState({
                opacity: 0,
                scale: 0.75
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function() {
            // Update state for mount animation
            _this.setState({
                opacity: 1,
                scale: 1
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function() {
            if (!_this.props.open) // Tell the wrapper component to remove the node on transition end when
            // the open prop is false
            _this.props.transitionEnd();
        });
        return _this;
    }
    (0, _createClass2["default"])(AnimateFadeScale, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.open) this.updateStateOnOpen();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.open && !this.props.open) this.updateStateOnUnmount();
                else if (!prevProps.open && this.props.open) this.updateStateOnMount();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Clear our timer to prevent leaks
                clearTimeout(this.timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, opacity = _this$state.opacity, scale = _this$state.scale;
                var _this$props = this.props, children = _this$props.children, duration = _this$props.duration, easing = _this$props.easing, className = _this$props.className;
                var styles = mountStyled(opacity, scale, duration, easing);
                return children({
                    open: opacity !== 0,
                    className: (0, _emotion.cx)(className, styles),
                    onTransitionEnd: this.transitionEnd
                });
            }
        }
    ]);
    return AnimateFadeScale;
}(_react["default"].Component);
(0, _defineProperty2["default"])(AnimateFadeScale, "defaultProps", {
    duration: "150ms",
    easing: "ease"
});
AnimateFadeScale.propTypes = {};
var _default = AnimateFadeScale;
exports["default"] = _default;

},{"512e287677ce35f":"fk2Bw","1b8180ac51ed112b":"5Yd3f","d96eed120a1bbba6":"6Jptv","f88bef3cf52fe0ac":"lMa5o","8dd0cdd3b9337be3":"j4mqF","6bea127646db58de":"krVd4","8195ec3289c7f94b":"8h5p9","ab9bbb7063d83233":"hcG56","8eb76b06ecfdc10e":"6uln9","e353f3e516512988":"cnMFu","7ef66aa04cdcdcaf":"4deck"}],"1RC46":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
/**
 * WHAT: This function makes it easy to detect a direct click on an element. It
 * will only trigger if both the mouse down and mouse up parts of the click
 * occurr directly on the element itself, and not the element's children.
 *
 * WHY: Listening for a direct click on an element, excluding its children, is
 * pretty tricky. You could try comparing event.target to event.currentTarget in
 * a click handler bound directly to the element, but that would still fire if
 * the click started on another element. For example if the user moused down on
 * a child element, moused over to the parent element, and released then a click
 * even would be fired on the parent where event.target was the same as
 * event.currentTarget. This same limitation applies to the method of trying to
 * call event.stopPropagation on click events from children to keep them from
 * bubbling up to parents. See https://sim.amazon.com/issues/MRDN-592 for why
 * triggering a click that started on another element can be problematic.

 * HOW: Usage of this utility is a little weird, but it's the only consistent
 * solution I could find to the problem. This function's only argument is the
 * onClick handler that should be called when a direct click is made. However
 * instead of returning some sort of more robust click handler it returns a
 * mouse down handler. This handler should be passed to the onMouseDown prop of
 * the element. For example:
 *
 * ```
 * const onClick = () => console.log("clicked directly on div!")
 *
 * // NOTE: onClick can't change after this point as onDirectClick stores it in
 * // memory. If onClick may change just inline this in your jsx (e.g.
 * // `onMouseDown={onDirectClick(onClick)}`).
 * const onMouseDown = onDirectClick(onClick)
 *
 * <div onMouseDown={onMouseDown}>
 *   <p>Clicking on this will not trigger a "direct" click on the parent</p>
 * </div>
 * ```
 *
 * Not super intuitive, but it works. This allows the utility to start listening
 * for clicks only when the user mouses down on the element, avoiding the
 * situation where a mousedown on another element, then a mouseover to our
 * element, then a mouse up would fire a click.
 */ var onDirectClick = function onDirectClick(callback) {
    // Listeners to add when the user mouses down on our element.
    var addListeners = function addListeners(node) {
        node.addEventListener("click", onClick);
        node.addEventListener("mouseout", onMouseOut);
    }; // Listeners to remove when the user finishes their click or mouses out of
    // the element.
    var removeListeners = function removeListeners(node) {
        node.removeEventListener("click", onClick);
        node.removeEventListener("mouseout", onMouseOut);
    }; // This is the final "direct" click handler.
    var onClick = function onClick(event) {
        removeListeners(event.target);
        callback(event);
    }; // If the user mouses out clear our listeners (and stop listening for a click
    // event, as it would no longer be directly on the element).
    var onMouseOut = function onMouseOut(event) {
        return removeListeners(event.target);
    }; // If the user mouses down directly on the element that this event is bound
    // to then start listening for a click event to finish things off.
    var onMouseDown = function onMouseDown(event) {
        if (event.target === event.currentTarget) addListeners(event.target);
    };
    return callback ? onMouseDown : undefined;
};
var _default = onDirectClick;
exports["default"] = _default;

},{}],"54pOf":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("49ec88796dc443cc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _responsive = _interopRequireDefault(require("b00f35cde878e543"));
var _default = _responsive["default"];
exports["default"] = _default;

},{"49ec88796dc443cc":"fk2Bw","b00f35cde878e543":"dDyXf"}],"dDyXf":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9b7425eeb9949583");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("d439fac56839b2aa"));
var _classCallCheck2 = _interopRequireDefault(require("6a50982ade3f09c3"));
var _createClass2 = _interopRequireDefault(require("e5c5cf368f3b50bd"));
var _inherits2 = _interopRequireDefault(require("b4947b6ae0d933f4"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("6d37959f323a75e1"));
var _getPrototypeOf2 = _interopRequireDefault(require("8caf0ba4b69e383b"));
var _react = _interopRequireDefault(require("c5ca588ac645085a"));
var _propTypes = _interopRequireDefault(require("d70c819ae2e593ac"));
var _matchMedia = _interopRequireDefault(require("62d08c3c5e127c63"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This looks through an object of nested objects and returns a flat array
 * containing all the unique keys found in the nested objects.
 */ var getUniqueNestedObjectKeys = function getUniqueNestedObjectKeys(props) {
    return Object.keys(props) // Get the keys of each nested object
    .map(function(prop) {
        return Object.keys(props[prop]);
    }) // Flatten the keys into one array
    .reduce(function(result, keys) {
        return result.concat(keys);
    }, []) // Filter out duplicate keys
    .filter(function(value, index, keys) {
        return keys.indexOf(value) === index;
    });
};
/**
 * Sort an array according to it's numeric values
 */ var sortNumeric = function sortNumeric(arr, direction) {
    arr.sort(function(a, b) {
        return (parseFloat(a) - parseFloat(b)) * (direction === "descending" ? -1 : 1);
    });
    return arr;
};
/* eslint-disable react/prop-types */ /**
 * This component allows you to respond to the state of media features such as
 * viewport width, viewport aspect ratio, and device orientation. This is
 * similar to "media queries for JavaScript" (and it's even powered by media
 * queries behind the scenes), but it's a lot more powerful. Instead of only
 * allowing you to toggle something on or off based on a matching media query,
 * it allows you to set set any JavaScript variable based on the various states
 * of a media feature. You can use this functionality to do things that are not
 * possible with plain CSS media queries like:
 *   - render entirely different component trees based on viewport size
 *   - pass different props to a component based on viewport width
 *   - change the location of elements in the DOM based on device orientation
 *
 * NOTE: The props passed to this component cannot be changed after the
 * component is first instantiated.
 *
 * ```
 * // Renders "red" below the 1000px breakpoint, "blue" at or above the 1000px
 * // breakpoint but below the 1500px breakpoint, and "green" at or above the
 * // 1500px breakpoint. Renders 12px font below the 1500px breakpoint and 24px
 * // at or above the 1500px breakpoint.
 * <Responsive
 *   query="min-width"
 *   props={{
 *     color: { default: "red", "1000px": "blue", "1500px": "green" },
 *     fontSize: { default: 12, "1500px": 24 },
 *   }}
 * >
 *   {({ color, fontSize }) => (
 *     <div style={{ fontSize }}>My fav color is {color}</div>
 *.  )}
 * </Responsive>
 * ```
 */ var ResponsiveClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(ResponsiveClass, _React$Component);
    var _super = _createSuper(ResponsiveClass);
    function ResponsiveClass(props) {
        var _this;
        (0, _classCallCheck2["default"])(this, ResponsiveClass);
        _this = _super.call(this, props); // Extract the media condition from the "query" prop
        var condition = /^min-/.test(props.query) ? "min" : /^max-/.test(props.query) ? "max" : null; // Extract the media feature from the "query" prop
        var feature = condition ? props.query.replace(new RegExp("^".concat(condition, "-")), "") : props.query; // Extract a list of unique breakpoints from the keys of the "props" prop.
        // Don't include the "default" since that's not something we can actually
        // query for (we'll fallback to that manually if no breakpoint matches)
        var breakpoints = getUniqueNestedObjectKeys(props.props).filter(function(key) {
            return key !== "default";
        }); // Sort the breakpoints according to the media query condition so that later
        // on we can just take the last matching breakpoint and know that that's the
        // min/max matching breakpoint
        var sortedBreakpoints = condition ? sortNumeric(breakpoints, condition === "min" ? "ascending" : "descending") : breakpoints; // This is an object of `MediaQueryList` instances (or mock instances - see
        // `matchMedia`) keyed by the breakpoints that they're matching against (e.g.
        // `{ "0px": mediaQueryA, "1000px": mediaQueryB }`).
        _this.mediaQueries = sortedBreakpoints.map(function(breakpoint) {
            var mediaQuery = (0, _matchMedia["default"])({
                feature: feature,
                condition: condition,
                fallback: props.fallback,
                breakpoint: breakpoint
            });
            var listener = function listener() {
                return _this.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
            };
            return {
                breakpoint: breakpoint,
                mediaQuery: mediaQuery,
                startListening: function startListening() {
                    return mediaQuery.addListener(listener);
                },
                stopListening: function stopListening() {
                    return mediaQuery.removeListener(listener);
                }
            };
        }); // Save off the list of prop names for each access later
        _this.propNames = Object.keys(props.props); // State is an object keyed by breakpoint that includes the match state of
        // the media query for that breakpoint (e.g. if the query is "min-width",
        // we're listening at the breakpoints "0px" and "1000px", adn the viewport
        // width is "500px" then the state object would be:
        // { "0px": true, "1000px": false }
        _this.state = _this.mediaQueries.reduce(function(result, _ref) {
            var breakpoint = _ref.breakpoint, mediaQuery = _ref.mediaQuery;
            // If a fallback prop is present, match against that for the intial
            // state. This ensures that that the same value is used during server
            // rendering and during the initial rehydrating render on the client.
            result[breakpoint] = _this.props.fallback ? mediaQuery.matchesFallback : mediaQuery.matches;
            return result;
        }, {});
        return _this;
    }
    (0, _createClass2["default"])(ResponsiveClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.mediaQueries.forEach(function(_ref2) {
                    var mediaQuery = _ref2.mediaQuery, breakpoint = _ref2.breakpoint, startListening = _ref2.startListening;
                    // Start listening for future state changes
                    startListening(); // If we matched against the fallback prop on the initial render, but the
                    // actual match is different, then update the state now and trigger a
                    // re-render
                    if (_this2.props.fallback && mediaQuery.matches !== mediaQuery.matchesFallback) // Note: React batches state updates in lifecycle methods so we'll only
                    // get one re-render no matter how many breakpoints we have to update.
                    _this2.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mediaQueries.forEach(function(_ref3) {
                    var stopListening = _ref3.stopListening;
                    return stopListening();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                // Choose the best value from "props" based on the state of our media
                // queries. If no match is found then return the "default" value (or
                // undefined if there is no default).
                var props = this.propNames.reduce(function(result, propName) {
                    var prop = _this3.props.props[propName];
                    var value = _this3.mediaQueries.reduce(function(result, _ref4) {
                        var breakpoint = _ref4.breakpoint;
                        return _this3.state[breakpoint] && prop[breakpoint] !== undefined ? prop[breakpoint] : result;
                    }, prop["default"]);
                    result[propName] = value;
                    return result;
                }, {});
                return this.props.children(props);
            }
        }
    ]);
    return ResponsiveClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change
var Responsive = function Responsive(props) {
    return /*#__PURE__*/ _react["default"].createElement(ResponsiveClass, props);
};
Responsive.displayName = "Responsive";
Responsive.propTypes = {};
var _default = Responsive;
exports["default"] = _default;

},{"9b7425eeb9949583":"fk2Bw","d439fac56839b2aa":"hcG56","6a50982ade3f09c3":"5Yd3f","e5c5cf368f3b50bd":"6Jptv","b4947b6ae0d933f4":"j4mqF","6d37959f323a75e1":"krVd4","8caf0ba4b69e383b":"8h5p9","c5ca588ac645085a":"6uln9","d70c819ae2e593ac":"cnMFu","62d08c3c5e127c63":"1juMa"}],"1juMa":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8c39a74e17c1ec81");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _noop = _interopRequireDefault(require("52bcebfe8d005f64"));
var _functional = require("5bbd9d8aea3d4a3a");
/**
 * Attempt to convert a media query breakpoint to a number. If we received a
 * breakpoint like "5/10" (e.g. an aspect ratio) then run the math (e.g. "5/10"
 * => 0.5), otherwise just parse as a float (e.g. "5rem" => 5).
 */ var breakpointToNumber = function breakpointToNumber(str) {
    return /^\s?[0-9.]+\s?\/\s?[0-9.]+\s?$/.test(str) ? parseFloat(str.split("/")[0]) / parseFloat(str.split("/")[1]) : parseFloat(str);
};
var matchesFallback = function matchesFallback(_ref) {
    var condition = _ref.condition, breakpoint = _ref.breakpoint, fallback = _ref.fallback;
    return fallback === undefined ? false : condition === "min" ? breakpointToNumber(breakpoint) <= breakpointToNumber(fallback) : condition === "max" ? breakpointToNumber(breakpoint) >= breakpointToNumber(fallback) : breakpoint === fallback;
};
/**
 * A wrapper around `window.matchMedia`. If `window.matchMedia` is available
 * then a media query will be constructed and passed to `window.matchMedia` to
 * create a `MediaQueryList` instance. If we're in an env where
 * `window.matchMedia` is not available (e.g. NodeJS) then this will return a
 * mock MediaQueryList that matches against the provided fallback.
 */ var matchMedia = typeof window !== "undefined" && window.matchMedia ? (0, _functional.memoizeByKeys)(function(_ref2) {
    var condition = _ref2.condition, breakpoint = _ref2.breakpoint, feature = _ref2.feature, fallback = _ref2.fallback;
    // Build up a standard media query (e.g. `(min-width: 1000px)`) if
    // we have access to window.matchMedia
    var matchMedia = window.matchMedia("(".concat(condition ? "".concat(condition, "-") : "").concat(feature, ": ").concat(breakpoint, ")")); // Tack on the a property indicating whether the fallback matches.
    // This is helpful for situations where you're on the client, but want
    // to know what the match state would have been on the server (i.e.
    // when re-hydrating server-rendered markup on the client with React).
    matchMedia.matchesFallback = matchesFallback({
        condition: condition,
        breakpoint: breakpoint,
        fallback: fallback
    });
    return matchMedia;
}, [
    "feature",
    "condition",
    "breakpoint",
    "fallback"
]) : function(args) {
    var matches = matchesFallback(args);
    return {
        // If we don't have access to `window.matchMedia` then "matches" will be
        // set statically based on the provided "fallback".
        matches: matches,
        // Mock out these functions for parity with the `MediaQueryList`
        // instance returned if `window.matchMedia` is available
        matchesFallback: matches,
        addListener: _noop["default"],
        removeListener: _noop["default"]
    };
};
var _default = matchMedia;
exports["default"] = _default;

},{"8c39a74e17c1ec81":"fk2Bw","52bcebfe8d005f64":"7osqO","5bbd9d8aea3d4a3a":"eKpY2"}],"eInK6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b0e90021c2cb76d5");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _column = _interopRequireDefault(require("58c25c984c18c11f"));
var _default = _column["default"];
exports["default"] = _default;

},{"b0e90021c2cb76d5":"fk2Bw","58c25c984c18c11f":"ifxjN"}],"ifxjN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("83ced1d9727d3815");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("eecac809566f12fe"));
var _react = _interopRequireDefault(require("a23455f412e6f806"));
var _propTypes = _interopRequireDefault(require("e9adf10690fbb34f"));
var _emotion = require("af006938d0a1aa6e");
var _reduce = _interopRequireDefault(require("84c3c0afb09a7000"));
var _box = _interopRequireDefault(require("196b9808b051754"));
var _propTypes2 = _interopRequireDefault(require("568df581793abe26"));
var _parsers = require("29813b87c8e2f120");
var _functional = require("99053e027f674f95");
var _cxMemoized = _interopRequireDefault(require("ebe1f0324e7279c4"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = function styles(heights) {
    return (0, _functional.memoizeByKeys)(function(_ref) {
        var spacing = _ref.spacing, alignmentVertical = _ref.alignmentVertical, alignmentHorizontal = _ref.alignmentHorizontal;
        return (0, _emotion.css)({
            display: "flex",
            flexDirection: "column",
            justifyContent: {
                top: "flex-start",
                bottom: "flex-end",
                center: "center",
                justify: "space-between"
            }[alignmentVertical],
            alignItems: {
                left: "flex-start",
                right: "flex-end",
                center: "center",
                stretch: "stretch"
            }[alignmentHorizontal],
            // Set margins and heights on the children of the column. Use !important to
            // override any existing styles.
            "& > *": {
                // Make sure that any borders or padding applied to the child don't throw
                // of the heights that we apply
                boxSizing: "border-box !important",
                // Ensure that the correct bottom margin is set (and clear other margins)
                margin: "0 0 ".concat((0, _parsers.parseSpacing)(spacing)[0], "px 0 !important"),
                // Don't let the last child add extra space to the end of the column.
                ":last-child": {
                    margin: "0 !important"
                }
            }
        }, // whose index in the dom matches the height's index in the array. If
        // we've got a single height, apply that to all children.
        Array.isArray(heights) ? (0, _reduce["default"])(heights, function(result, height, index) {
            return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, "& > *:nth-child(".concat(parseInt(index) + 1, ")"), childStyles(height)));
        }, {}) : {
            "& > *": childStyles(heights)
        });
    }, [
        "spacing",
        "alignmentVertical",
        "alignmentHorizontal"
    ]);
};
var stylesWithUniqueWidths = (0, _functional.memoizeArray)(styles);
var stylesWithUniformWidths = (0, _functional.memoize)(styles);
var childStyles = function childStyles(height) {
    return {
        flex: height === "fill" ? "1 !important" : undefined,
        flexShrink: height && height !== "fill" && height !== "auto" ? "0 !important" : undefined,
        height: height !== "fill" && height !== "fit" && height !== undefined && height !== null && height !== "" ? "".concat(height).concat(typeof height === "number" ? "px" : "", " !important") : undefined
    };
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */ var Column = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    // We need to memoize differently based on whether we got an array or scalar
    // for the "heights" property
    var stylesFunc = Array.isArray(props.heights) ? stylesWithUniqueWidths : stylesWithUniformWidths;
    var styles = stylesFunc(props.heights)(props);
    return /*#__PURE__*/ _react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
        className: (0, _cxMemoized["default"])(styles, props.className),
        ref: ref
    }));
});
Column.displayName = "Column";
Column.propTypes = {};
Column.defaultProps = {
    spacing: "medium",
    alignmentVertical: "top",
    alignmentHorizontal: "stretch"
};
var _default = Column;
exports["default"] = _default;

},{"83ced1d9727d3815":"fk2Bw","eecac809566f12fe":"hcG56","a23455f412e6f806":"6uln9","e9adf10690fbb34f":"cnMFu","af006938d0a1aa6e":"4deck","84c3c0afb09a7000":"6z9jC","196b9808b051754":"4oeXM","568df581793abe26":"ihBLX","29813b87c8e2f120":"aSMp2","99053e027f674f95":"eKpY2","ebe1f0324e7279c4":"6U7id"}],"6z9jC":[function(require,module,exports) {
var arrayReduce = require("21cc1040b8f3879f"), baseEach = require("1bdb60cb2ffbba48"), baseIteratee = require("97dd7371cf6facb6"), baseReduce = require("b4b87f57620148f5"), isArray = require("5b045b04ba5aa368");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
module.exports = reduce;

},{"21cc1040b8f3879f":"1b9zp","1bdb60cb2ffbba48":"famkp","97dd7371cf6facb6":"3xVMK","b4b87f57620148f5":"9zRML","5b045b04ba5aa368":"6WNsH"}],"1b9zp":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"famkp":[function(require,module,exports) {
var baseForOwn = require("a44649a40e0d8c9e"), createBaseEach = require("96e25639cb0c2a4b");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"a44649a40e0d8c9e":"ce2Mo","96e25639cb0c2a4b":"boTo0"}],"ce2Mo":[function(require,module,exports) {
var baseFor = require("84ab6d675a5fcb17"), keys = require("7f7c6c1b75c398f1");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"84ab6d675a5fcb17":"c6zKi","7f7c6c1b75c398f1":"fuSIb"}],"c6zKi":[function(require,module,exports) {
var createBaseFor = require("3c1b1f935fcf8601");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"3c1b1f935fcf8601":"gHly8"}],"gHly8":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"boTo0":[function(require,module,exports) {
var isArrayLike = require("68d289a75738bcc8");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"68d289a75738bcc8":"gnYyq"}],"9zRML":[function(require,module,exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = baseReduce;

},{}],"4oeXM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bc1ab537bfecc278");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _box = _interopRequireDefault(require("91bc676b343c6799"));
var _default = _box["default"];
exports["default"] = _default;

},{"bc1ab537bfecc278":"fk2Bw","91bc676b343c6799":"6WR05"}],"6WR05":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5ee871965497c443");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("76220a52a585f589"));
var _react = _interopRequireDefault(require("fc7a5c20cf8b53c5"));
var _propTypes = _interopRequireDefault(require("ef5bee9bd0ae09c9"));
var _box = _interopRequireDefault(require("dc4ece83d44e99bc"));
var _emotion = require("9d3e4b14b1d91b69");
var _propTypes2 = _interopRequireDefault(require("74d50b3dd225bf95"));
var _parsers = require("d0c365d1a8c1b23");
var _theme = require("d88a87e554b84561");
var _token = require("235dad318362c837");
var _functional = require("b87bd4aad184455f");
var _cxMemoized = _interopRequireDefault(require("9eaed181c2a37999"));
var _filterPropsByPrefix = _interopRequireDefault(require("44567c90efc662e4"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _functional.memoizeByKeys)(function(_ref) {
    var backgroundColor = _ref.backgroundColor, borderColor = _ref.borderColor, borderWidth = _ref.borderWidth, borderRadius = _ref.borderRadius, width = _ref.width, height = _ref.height, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxWidth = _ref.maxWidth, maxHeight = _ref.maxHeight, overflowY = _ref.overflowY, spacingInset = _ref.spacingInset;
    return (0, _emotion.css)({
        boxSizing: "border-box",
        // If we have a border radius defined then clip content so that it doesn't
        // bleed out the corners
        overflow: borderRadius ? "hidden" : undefined,
        overflowY: overflowY ? overflowY : undefined,
        padding: (0, _parsers.parseSpacing)(spacingInset).map(function(value) {
            return "".concat(value, "px");
        }).join(" "),
        borderStyle: borderWidth && borderColor ? "solid" : undefined,
        borderWidth: borderWidth,
        borderColor: borderColor,
        borderRadius: borderRadius,
        backgroundColor: backgroundColor,
        width: width,
        height: height,
        minWidth: minWidth,
        maxWidth: maxWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    });
}, [
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "width",
    "height",
    "minWidth",
    "minHeight",
    "maxWidth",
    "maxHeight",
    "overflowY",
    "spacingInset"
]);
var themedStyles = (0, _functional.memoize)(function(t) {
    return (0, _functional.memoizeByKeys)(function(_ref2) {
        var type = _ref2.type, backgroundColor = _ref2.backgroundColor, width = _ref2.width, height = _ref2.height, minWidth = _ref2.minWidth, minHeight = _ref2.minHeight, maxWidth = _ref2.maxWidth, maxHeight = _ref2.maxHeight, overflowY = _ref2.overflowY, spacingInset = _ref2.spacingInset;
        return styles({
            backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [
                backgroundColor,
                "default"
            ]) || backgroundColor : t("backgroundColor", type),
            borderColor: t("borderColor", type),
            borderWidth: t("borderWidth"),
            borderRadius: t("borderRadius", type),
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            overflowY: overflowY,
            spacingInset: spacingInset
        });
    }, [
        "type",
        "backgroundColor",
        "width",
        "height",
        "minWidth",
        "minHeight",
        "maxWidth",
        "maxHeight",
        "overflowY",
        "spacingInset"
    ]);
});
/**
 * The Box component can also be used to visually separate part of the layout by
 * applying an outline or fill.
 *
 * It can also be used as a layout component (similar to the Row and Column
 * components) to apply width and inset padding to any part of the layout (with
 * or without an outline or fill).
 */ var Box = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return props.backgroundColor || props.type ? /*#__PURE__*/ _react["default"].createElement(ThemedBox, _objectSpread(_objectSpread({}, props), {}, {
        ref: ref
    }), props.children) : /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ])), {}, {
        className: (0, _cxMemoized["default"])(styles(props), props.className),
        id: props.id,
        tabIndex: props.tabIndex,
        ref: ref
    }), props.children);
});
Box.displayName = "Box";
Box.propTypes = {
    /**
   * Set the box's background color using a preset, or using a string
   * containing any valid CSS color.
   */ backgroundColor: _propTypes["default"].oneOfType([
        _propTypes["default"].oneOf([
            "primary",
            "secondary",
            "alternatePrimary",
            "alternateSecondary"
        ]),
        _propTypes["default"].string
    ]),
    /**
   * The elements to render inside the box.
   */ children: _propTypes["default"].node,
    /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */ className: _propTypes["default"].string,
    /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */ "data-*": _propTypes["default"].string,
    /**
   * Set the height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ height: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Adds an [id](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id) to the component.
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   *
   * @since 4.x
   */ id: _propTypes["default"].string,
    /**
   * Set the maximum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ maxHeight: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Set the maximum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ maxWidth: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Set the minimum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ minHeight: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Set the minimum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ minWidth: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   */ overflowY: _propTypes["default"].oneOf([
        "auto",
        "hidden",
        "scroll"
    ]),
    /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */ spacingInset: _propTypes2["default"].spacing(4),
    /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */ tabIndex: _propTypes["default"].string,
    /**
   * The HTML tag to use when rendering the component to the DOM.
   */ tag: _propTypes["default"].string,
    /**
   * The type of visuals to apply to the box. If this is omitted the box will
   * not have any decorative styles and can be used purely for layout purposes.
   */ type: _propTypes["default"].oneOf([
        "outline",
        "fill"
    ]),
    /**
   * Set the width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ width: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ])
};
Box.defaultProps = {
    tag: "div",
    spacingInset: "none"
};
/* eslint-disable react/prop-types */ /**
 * This component renders a themed box. This is only used if themed styles are
 * actually applied to the box. Otherwise we can skip all the extra work that
 * goes into theming.
 */ var ThemedBox = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_box["default"], "box");
    return /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ])), {}, {
        className: (0, _cxMemoized["default"])(themedStyles(t)(props), props.className),
        id: props.id,
        tabIndex: props.tabIndex,
        ref: ref
    }), props.children);
});
ThemedBox.displayName = "ThemedBox";
/* eslint-enable react/prop-types */ var _default = Box;
exports["default"] = _default;

},{"5ee871965497c443":"fk2Bw","76220a52a585f589":"hcG56","fc7a5c20cf8b53c5":"6uln9","ef5bee9bd0ae09c9":"cnMFu","dc4ece83d44e99bc":"6etQy","9d3e4b14b1d91b69":"4deck","74d50b3dd225bf95":"ihBLX","d0c365d1a8c1b23":"aSMp2","d88a87e554b84561":"eM9hO","235dad318362c837":"atHRo","b87bd4aad184455f":"eKpY2","9eaed181c2a37999":"6U7id","44567c90efc662e4":"8cR2N"}],"6kD7p":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("34dfed99743e455b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _text = _interopRequireDefault(require("169d528f6792c439"));
var _default = _text["default"];
exports["default"] = _default;

},{"34dfed99743e455b":"fk2Bw","169d528f6792c439":"hVdPB"}],"hVdPB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("44cb392a07b05f94");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("f796a72c5313b58"));
var _react = _interopRequireDefault(require("6bb4b2a3843ded3c"));
var _propTypes = _interopRequireDefault(require("5592469b600de95d"));
var _text = _interopRequireDefault(require("6ed8ce942419af71"));
var _getTextStyles = _interopRequireDefault(require("7bd3f1ebccafbb1"));
var _theme = require("532ff3561cccf778");
var _cxMemoized = _interopRequireDefault(require("c4e08a4d8714d88c"));
var _filterPropsByPrefix = _interopRequireDefault(require("7eeaeffb48a40c38"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * This component can be used to apply Meridian text styles to the UI. Text
 * styles will cascade to descendent Text, Heading, and Link components as well
 * as native HTML elements, but not to other Meridian components that define
 * their own text styles.
 */ var Text = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var children = props.children;
    var t = (0, _theme.useTheme)(_text["default"], "text");
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
        id: props.id,
        className: (0, _cxMemoized["default"])((0, _getTextStyles["default"])(t, props), props.className),
        title: props.title === undefined && props.truncate && typeof children === "string" ? children : props.title,
        "mdn-text": "",
        ref: ref
    }), children);
});
Text.displayName = "Text";
Text.propTypes = {};
Text.defaultProps = {
    tag: "p"
};
var _default = Text;
exports["default"] = _default;

},{"44cb392a07b05f94":"fk2Bw","f796a72c5313b58":"hcG56","6bb4b2a3843ded3c":"6uln9","5592469b600de95d":"cnMFu","6ed8ce942419af71":"9Sdvg","7bd3f1ebccafbb1":"2xZE6","532ff3561cccf778":"eM9hO","c4e08a4d8714d88c":"6U7id","7eeaeffb48a40c38":"8cR2N"}],"2xZE6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("fa4101a1d25e49de");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("b7b2aa802ecffded"));
var _token = require("ff84d35d0abcd126");
var _emotion = require("b28d6239f85406da");
var _noTextWrap = _interopRequireDefault(require("9d7c3f0244f3574f"));
/**
 * Pass in a token helper for text tokens
 * (e.g. getTokenHelper("text")(themedTextTokens)) and any text props.
 */ var getTextStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var _css;
    var fontFamily = _ref.fontFamily, color = _ref.color, type = _ref.type, transform = _ref.transform, alignment = _ref.alignment, tag = _ref.tag, truncate = _ref.truncate, breakWord = _ref.breakWord;
    return (0, _emotion.css)(// with no parent and no props and this is what you'll get.
    {
        fontFamily: t("fontFamilyAmazonEmber"),
        fontWeight: t("fontWeightB300"),
        fontSize: t("fontSizeB300"),
        lineHeight: t("lineHeightB300"),
        color: t("colorPrimary")
    }, // <Text /> component inside another <Text /> component and the descendant
    // component will inherit from the ancestor instead of falling back to the
    // default styles.
    {
        "[mdn-text] &": {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            color: "inherit"
        }
    }, // styles using the component's props. The :not() selector is added to
    // increase the specificity of the styles so they override everything else
    // without resorting to !important.
    {
        "&:not(#mdn-specificity-hack)": {
            fontFamily: fontFamily ? t("fontFamily", fontFamily) : undefined,
            fontWeight: type ? t("fontWeight", type) : undefined,
            fontSize: type ? t("fontSize", type) : undefined,
            lineHeight: type ? t("lineHeight", type) : undefined,
            color: color ? t("color", color) : undefined
        }
    }, (_css = {
        textTransform: transform,
        textAlign: alignment ? alignment : undefined,
        // Clear the default margin on tags like "p"
        margin: 0,
        // If a single word is too wide for the element then allow the browser
        // to break it up at an arbitrary location. A hyphen will not be
        // added. This won't look great, but is better than the word flowing
        // off the edge of the element and potentially getting
        // clipped/obscured.
        overflowWrap: breakWord ? "break-word" : undefined,
        // HACK: Overflow wrap for IE11
        wordWrap: breakWord ? "break-word" : undefined
    }, (0, _defineProperty2["default"])(_css, tag === "ul" ? "&" : "& ul", {
        paddingLeft: t("listSpacingHorizontal"),
        listStyleType: "disc",
        "& ul": {
            paddingLeft: t("listSpacingHorizontal"),
            listStyleType: "circle",
            "& ul": {
                listStyleType: "square"
            }
        }
    }), (0, _defineProperty2["default"])(_css, tag === "ol" ? "&" : "& ol", {
        paddingLeft: t("listSpacingHorizontal"),
        listStyleType: "decimal",
        "& ol": {
            paddingLeft: t("listSpacingHorizontal"),
            listStyleType: "lower-alpha",
            "& ol": {
                listStyleType: "lower-roman"
            }
        }
    }), (0, _defineProperty2["default"])(_css, "".concat(tag === "ul" || tag === "ol" ? "& > * + *, " : "", "& ul > * + *, & ol > * + *"), {
        paddingTop: t("listSpacingVertical")
    }), _css), truncate ? _noTextWrap["default"] : undefined);
}, [
    "fontFamily",
    "color",
    "type",
    "transform",
    "alignment",
    "tag",
    "truncate",
    "breakWord"
]);
var _default = getTextStyles;
exports["default"] = _default;

},{"fa4101a1d25e49de":"fk2Bw","b7b2aa802ecffded":"hcG56","ff84d35d0abcd126":"atHRo","b28d6239f85406da":"4deck","9d7c3f0244f3574f":"2PXpH"}],"2PXpH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var noTextWrap = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};
var _default = noTextWrap;
exports["default"] = _default;

},{}],"bON9z":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("53dcfcdde0dbd534");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _divider = _interopRequireDefault(require("f8678a3c20393b38"));
var _default = _divider["default"];
exports["default"] = _default;

},{"53dcfcdde0dbd534":"fk2Bw","f8678a3c20393b38":"2S2M0"}],"2S2M0":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ad720d96f3f12645");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("28287a191453cbbd"));
var _propTypes = _interopRequireDefault(require("30de54e271b0dd4e"));
var _emotion = require("d315867f6cca98ed");
var _spacing = _interopRequireDefault(require("200a1c245dca7674"));
var _divider = _interopRequireDefault(require("740371c4a605ca52"));
var _theme = require("2b3d7394ec0be460");
var _token = require("d02fa1ecc3b9be06");
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, spacingBefore = _ref.spacingBefore, spacingAfter = _ref.spacingAfter;
    return (0, _emotion.css)({
        width: "100%",
        height: t("size", size),
        // min-height protects against parent styling that might
        // squash the "normal" height with margins and flex (like Column)
        minHeight: t("size", size),
        backgroundColor: t("color"),
        marginTop: (0, _token.getToken)(_spacing["default"], "spacing", spacingBefore),
        marginBottom: (0, _token.getToken)(_spacing["default"], "spacing", spacingAfter),
        border: "none"
    });
}, [
    "size",
    "spacingBefore",
    "spacingAfter"
]);
function Divider(props) {
    var t = (0, _theme.useTheme)(_divider["default"], "divider");
    return /*#__PURE__*/ _react["default"].createElement("hr", {
        className: styles(t, props)
    });
}
Divider.propTypes = {};
Divider.defaultProps = {
    size: "medium",
    spacingBefore: "none",
    spacingAfter: "none"
};
var _default = Divider;
exports["default"] = _default;

},{"ad720d96f3f12645":"fk2Bw","28287a191453cbbd":"6uln9","30de54e271b0dd4e":"cnMFu","d315867f6cca98ed":"4deck","200a1c245dca7674":"8D3is","740371c4a605ca52":"ev5H1","2b3d7394ec0be460":"eM9hO","d02fa1ecc3b9be06":"atHRo"}],"dM4Li":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9d5a77db81b9e5ad");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("c27d0c32c5244db3"));
var _propTypes = _interopRequireDefault(require("8a51e56c48d6e355"));
var _RequiredQuestionTypeComponent = _interopRequireDefault(require("ff5cf43ae6fc58d2"));
function RequiredQuestionTypeComponentList(_ref) {
    var questions = _ref.questions, prePopulate = _ref.prePopulate;
    return questions.map(function(question) {
        var questionId = question.questionId;
        var _ref2 = prePopulate[questionId] || {}, value = _ref2.value;
        return /*#__PURE__*/ _react["default"].createElement(_RequiredQuestionTypeComponent["default"], {
            key: questionId,
            question: question,
            prePopulatedValue: value || ""
        });
    });
}
RequiredQuestionTypeComponentList.propTypes = {
    questions: _propTypes["default"].array.isRequired,
    prePopulate: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = RequiredQuestionTypeComponentList;

},{"9d5a77db81b9e5ad":"bm29M","c27d0c32c5244db3":"6uln9","8a51e56c48d6e355":"gJRKl","ff5cf43ae6fc58d2":"dv2UB"}],"dv2UB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("66ac9d1e0364f684");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("e0602cba1de94feb"));
var _divider = _interopRequireDefault(require("5fd7a6e205a5f1c"));
var _MultipleChoiceQuestion = _interopRequireDefault(require("80225fbe5f385495"));
var _TextQuestion = _interopRequireDefault(require("8827bb8109ead7b2"));
var _QuestionTypes = _interopRequireDefault(require("ed8e3fda96292032"));
var _StarRating = _interopRequireDefault(require("2f05cfce3aeb9c5a"));
var _FeedbackConstants = require("6caa1473bd263cb3");
var RequiredQuestionTypeComponent = function RequiredQuestionTypeComponent(_ref) {
    var _ref$question = _ref.question, questionText = _ref$question.questionText, questionId = _ref$question.questionId, isMandatory = _ref$question.isMandatory, questionType = _ref$question.questionType, prePopulatedValue = _ref.prePopulatedValue;
    var requiredComponent = null;
    switch(Object.keys(questionType)[0]){
        case _QuestionTypes["default"].MULTIPLE_CHOICE_QUESTION:
            requiredComponent = /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(_MultipleChoiceQuestion["default"], {
                question: questionText,
                id: questionId,
                isMandatory: isMandatory,
                functionalities: questionType.multipleChoiceQuestionType.options
            }), /*#__PURE__*/ _react["default"].createElement(_divider["default"], {
                size: "small"
            }));
            break;
        case _QuestionTypes["default"].RATING_QUESTION:
            requiredComponent = /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(_StarRating["default"], {
                question: questionText,
                id: questionId,
                isMandatory: isMandatory,
                minRatingValue: questionType.ratingQuestionType.minRatingValue,
                ratingInterval: questionType.ratingQuestionType.ratingInterval,
                numberOfIntervals: questionType.ratingQuestionType.numberOfIntervals
            }), /*#__PURE__*/ _react["default"].createElement(_divider["default"], {
                size: "small"
            }));
            break;
        case _QuestionTypes["default"].TEXT_QUESTION:
            requiredComponent = /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(_TextQuestion["default"], {
                question: questionText,
                id: questionId,
                isMandatory: isMandatory,
                limit: questionType.textQuestionType.charLimit || _FeedbackConstants.TEXT_QUESTION_RESPONSE_CHAR_LIMIT,
                prePopulatedValue: prePopulatedValue
            }), /*#__PURE__*/ _react["default"].createElement(_divider["default"], {
                size: "small"
            }));
            break;
        default:
            requiredComponent = /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null);
            break;
    }
    return requiredComponent;
};
var _default = exports["default"] = RequiredQuestionTypeComponent;

},{"66ac9d1e0364f684":"bm29M","e0602cba1de94feb":"6uln9","5fd7a6e205a5f1c":"bON9z","80225fbe5f385495":"c3K9F","8827bb8109ead7b2":"h6CwX","ed8e3fda96292032":"jpUxc","2f05cfce3aeb9c5a":"fcOXW","6caa1473bd263cb3":"filWO"}],"c3K9F":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9a974e3b46ae38b4");
var _typeof = require("61d9a03d0b33a1c4");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("42e334368b590f0a"));
var _react = _interopRequireWildcard(require("b03109d8e8bd3a5a"));
var _select = _interopRequireWildcard(require("918b989fc5fb9652"));
var _column = _interopRequireDefault(require("bdcad63da00867"));
var _propTypes = _interopRequireDefault(require("eb64963534d61645"));
var _FeedbackConstants = require("8a3766934954c735");
var _useResponse2 = _interopRequireDefault(require("cfab3617219b669d"));
var _formatAnswerBasedOnType = _interopRequireDefault(require("5e451bfe3ecd2cb9"));
var _Question = _interopRequireDefault(require("2992108ccfa316f9"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/**
 * MultipleChoiceQuestion component will be used to provide the ability to select an option from the provided list of options.
 * @param {string} question - Question Text
 * @param {string[]} functionalities - The values of functionalities to choose from
 * @param {string} [placeholder = "Select a functionality"] -  Placeholder text in the select box
 * @returns Meridian Select Component
 */ var MultipleChoiceQuestion = function MultipleChoiceQuestion(_ref) {
    var question = _ref.question, id = _ref.id, isMandatory = _ref.isMandatory, functionalities = _ref.functionalities, placeholder = _ref.placeholder, questionTextFormat = _ref.questionTextFormat;
    var _useState = (0, _react.useState)(), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var _useResponse = (0, _useResponse2["default"])(), saveFeedbackResponse = _useResponse.saveFeedbackResponse;
    var onChangeHandler = function onChangeHandler(functionality) {
        setValue(functionality);
        // This is array now in backend. Hence formating to array
        var funtionalityValue = (0, _formatAnswerBasedOnType["default"])(functionality, true);
        saveFeedbackResponse({
            id: id,
            answer: funtionalityValue
        });
    };
    return /*#__PURE__*/ _react["default"].createElement(_column["default"], {
        spacingInset: "xxsmall"
    }, /*#__PURE__*/ _react["default"].createElement(_Question["default"], {
        questionTextFormat: questionTextFormat,
        question: question,
        isMandatory: isMandatory
    }), /*#__PURE__*/ _react["default"].createElement(_select["default"], {
        id: "functionalities",
        value: value,
        onChange: function onChange(key) {
            return onChangeHandler(key);
        },
        placeholder: placeholder,
        width: 300,
        spacingInset: "medium"
    }, functionalities.map(function(_ref2) {
        var optionNumber = _ref2.optionNumber, optionValue = _ref2.optionValue;
        return /*#__PURE__*/ _react["default"].createElement(_select.SelectOption, {
            key: optionNumber,
            label: optionValue,
            value: optionNumber
        });
    })));
};
MultipleChoiceQuestion.propTypes = {
    question: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string.isRequired,
    isMandatory: _propTypes["default"].bool.isRequired,
    functionalities: _propTypes["default"].array.isRequired,
    placeholder: _propTypes["default"].string,
    questionTextFormat: _propTypes["default"].string
};
MultipleChoiceQuestion.defaultProps = {
    placeholder: _FeedbackConstants.PLACEHOLDERS.multipleChoiceQuestionType,
    questionTextFormat: ""
};
var _default = exports["default"] = MultipleChoiceQuestion;

},{"9a974e3b46ae38b4":"bm29M","61d9a03d0b33a1c4":"8zjpU","42e334368b590f0a":"8uMk6","b03109d8e8bd3a5a":"6uln9","918b989fc5fb9652":"4zaog","bdcad63da00867":"eInK6","eb64963534d61645":"gJRKl","8a3766934954c735":"filWO","cfab3617219b669d":"9TPqN","5e451bfe3ecd2cb9":"eNmlz","2992108ccfa316f9":"7fVae"}],"4zaog":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9522bbc0409238fc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SelectOption", {
    enumerable: true,
    get: function get() {
        return _selectOption["default"];
    }
});
exports["default"] = void 0;
var _select = _interopRequireDefault(require("30910cc463bfe15d"));
var _selectOption = _interopRequireDefault(require("27acd6f6aa02dcb8"));
var _default = _select["default"];
exports["default"] = _default;

},{"9522bbc0409238fc":"fk2Bw","30910cc463bfe15d":"eThaI","27acd6f6aa02dcb8":"kQzbK"}],"eThaI":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f334db4295f4564e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("5bc39ca7489c43fe"));
var _toConsumableArray2 = _interopRequireDefault(require("ead4e54143bd9a26"));
var _classCallCheck2 = _interopRequireDefault(require("2d3f57f67efcc7c0"));
var _createClass2 = _interopRequireDefault(require("1dd4b1225e660f10"));
var _assertThisInitialized2 = _interopRequireDefault(require("4a850bcb23399b60"));
var _inherits2 = _interopRequireDefault(require("8730813c039188f5"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("d801ae4362300f46"));
var _getPrototypeOf2 = _interopRequireDefault(require("ed088d71e6c8c201"));
var _defineProperty2 = _interopRequireDefault(require("d9da01175474c793"));
var _react = _interopRequireDefault(require("8c851cf2c90c7ba2"));
var _propTypes = _interopRequireDefault(require("42a90f9bd16e00a0"));
var _emotion = require("c106d24f3c5b0010");
var _keycode = _interopRequireDefault(require("3564341c501336b5"));
var _uniqueId = _interopRequireDefault(require("13f415b65b0101bf"));
var _find = _interopRequireDefault(require("3b0d056b57febe8f"));
var _noop = _interopRequireDefault(require("c5947c59dd6ae61b"));
var _escapeRegExp = _interopRequireDefault(require("8b137fc7d249da0a"));
var _chevronSelect = _interopRequireDefault(require("46c8de0f6ba3896d"));
var _select = _interopRequireDefault(require("943d329db3150af3"));
var _selectOptionList = _interopRequireDefault(require("d305ae319c71d6b8"));
var _selectOptionListContainer = _interopRequireDefault(require("f0cfdaa71846d0ef"));
var _utils = require("fc02e409f41f56c4");
var _inputBox = _interopRequireDefault(require("9d1af387656b08b6"));
var _focus = _interopRequireDefault(require("1c281faa84c4d35c"));
var _theme = require("f0c4981e476e7ac3");
var _responsive = _interopRequireDefault(require("47722e86dd4761bb"));
var _context = _interopRequireDefault(require("aceb4ad2670b6efb"));
var _token = require("1743b4734fd0979a");
var _text = _interopRequireDefault(require("c483a83b79b3c106"));
var _inputReset = _interopRequireDefault(require("882db61736dcab6a"));
var _noTextWrap = _interopRequireDefault(require("b96e80aa6ba94958"));
var _visuallyHidden = _interopRequireDefault(require("e3955aadec33bbba"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var width = _ref.width, minWidth = _ref.minWidth;
    return (0, _emotion.css)((0, _text["default"])(t), {
        outline: "none",
        position: "relative",
        width: width,
        // If an explicit width is set then don't allow the select to flex
        flex: width ? "none !important" : undefined,
        minWidth: minWidth
    });
}, [
    "width",
    "minWidth"
]);
var customSearchInputStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var disabled = _ref2.disabled, open = _ref2.open, empty = _ref2.empty;
    return (0, _emotion.css)((0, _inputReset["default"])({
        empty: empty,
        textColor: t("searchInputForegroundColorDefault"),
        placeholderColor: t("searchInputPlaceholderColor", disabled ? "disabled" : "default")
    }), // otherwise hide the input and show the label. Note that the input is
    // visually hidden but is still focuseable (so the user can tab to it).
    open ? {
        "& + div": {
            display: "none"
        }
    } : // focus/input reveal.
    _objectSpread(_objectSpread({}, _visuallyHidden["default"]), {}, {
        width: "auto",
        position: "initial"
    }));
}, [
    "disabled",
    "open",
    "empty"
]);
var valueLabelStyles = (0, _emotion.css)(_noTextWrap["default"]);
/* eslint-disable react/prop-types */ var SelectClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectClass, _React$Component);
    var _super = _createSuper(SelectClass);
    function SelectClass() {
        var _this;
        (0, _classCallCheck2["default"])(this, SelectClass);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            // Are the select options open?
            open: false,
            // This enables us to preselect an option in the option list. This is the
            // "default" because the internal state of the option list may change if the
            // user uses up/down arrow keys to manage the preselected index.
            defaultPreselectedIndex: undefined,
            // For this component, there are two types of searching:
            //   1) Custom searching is what happens when `onSearch` and `searchQuery`
            //      are passed in as props. This renders a search input inside the
            //      Select and allows the developer to filter options down according to
            //      any custom search algorithm.
            //   2) Native searching is what happens when no custom search props are
            //      passed. This search mimicks the behavior of native html selects -
            //      the search query is stored internally and the first option that
            //      matches the query (prefix matching only) is selected if the select
            //      is closed or "preselected" if the select is open.
            nativeSearchQuery: ""
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", _this.props.id || (0, _uniqueId["default"])("select-"));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "nativeSearchTimeout", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionListRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "customSearchInputRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function(ref) {
            _this.rootRef = ref; // If we are forwarding a ref, assign forwarded ref to root ref
            if (_this.props.forwardedRef) _this.props.forwardedRef.current = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOptionListRef", function(ref) {
            return _this.optionListRef = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateCustomSearchInputRef", function(ref) {
            return _this.customSearchInputRef = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMultiSelectable", function() {
            return Array.isArray(_this.props.value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isNativeSearching", function() {
            return /[\S]/.test(_this.state.nativeSearchQuery);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isCustomSearchable", function() {
            return Boolean(_this.props.onSearch);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function(_ref3) {
            var retainFocus = _ref3.retainFocus;
            var customSearchable = _this.isCustomSearchable();
            _this.setState({
                open: false,
                focus: retainFocus,
                defaultPreselectedIndex: undefined
            });
            if (customSearchable) _this.props.onSearch("");
             // Move focus back to the main node before closing the option list
            if (retainFocus) {
                if (_this.isCustomSearchable()) _this.customSearchInputRef.focus();
                else _this.rootRef.focus();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "nativeSearch", function(searchQuery) {
            var _this$props = _this.props, value = _this$props.value, onChange = _this$props.onChange, children = _this$props.children;
            var _this$state = _this.state, open = _this$state.open, defaultPreselectedIndex = _this$state.defaultPreselectedIndex;
            var options = (0, _utils.getOptionsFromChildren)(children).filter(function(_ref4) {
                var disabled = _ref4.disabled;
                return !disabled;
            });
            var selectedOption = (0, _find["default"])(options, function(option) {
                return (0, _utils.isOptionValueSelected)(value, option.value);
            }); // Look for the first option that starts with the full search query
            var searchQueryRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(searchQuery)), "i");
            var fullMatch = (0, _find["default"])(options, function(option) {
                return searchQueryRegExp.test(option.label);
            }); // Look for an option that starts with the last character typed. Sort the
            // options so that if the same character is typed repeatedly the focus
            // cycles through all matching options.
            var lastChar = searchQuery[searchQuery.length - 1];
            var lastCharRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(lastChar)), "i");
            var currentIndex = open ? defaultPreselectedIndex : selectedOption ? selectedOption.index : 0;
            var lastCharMatch = (0, _find["default"])([].concat((0, _toConsumableArray2["default"])(options.slice(currentIndex + 1)), (0, _toConsumableArray2["default"])(options.slice(0, currentIndex + 1))), function(option) {
                return lastCharRegExp.test(option.label);
            }); // Prefer a full match to a last character match
            var match = fullMatch || lastCharMatch; // If the select is expaneded and we have a match then focus it
            if (match && open) _this.setState({
                defaultPreselectedIndex: match.index
            });
            else if (match) onChange(_this.isMultiSelectable() ? [
                match.value
            ] : match.value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function(event) {
            var disabled = _this.props.disabled;
            var open = _this.state.open;
            var key = (0, _keycode["default"])(event); // HACK: Assume the key is "printable" (can be added to a search query) if
            // it's either of length 1 or a space.
            var printableKey = key && key.length === 1 ? key : key === "space" ? " " : undefined;
            var isNativeSearching = _this.isNativeSearching();
            var isCustomSearchable = _this.isCustomSearchable();
            var keyUsed = false; // If any character is typed that doesn't trigger behavior in the option
            // list (as indicated by event.defaultPrevented set to true) then make sure
            // the custom search input is focused
            if (isCustomSearchable && !event.defaultPrevented && _this.customSearchInputRef !== document.activeElement) _this.customSearchInputRef.focus();
             // If no custom search behavior is defined and a printable key was typed,
            // trigger the "native" search functionality that mimicks the browser
            if (!isCustomSearchable && printableKey) {
                var nativeSearchQuery = _this.state.nativeSearchQuery + printableKey;
                _this.setState({
                    nativeSearchQuery: nativeSearchQuery
                });
                _this.nativeSearch(nativeSearchQuery); // Reset the timeout that will the search query
                clearTimeout(_this.nativeSearchTimeout);
                _this.nativeSearchTimeout = window.setTimeout(function() {
                    return _this.setState({
                        nativeSearchQuery: "",
                        defaultPreselectedIndex: undefined
                    });
                }, SelectClass.nativeSearchTimeoutDuration);
                keyUsed = true;
            } // If no custmo search behavior is defined and backspace or delete was
            // pressed, clear the "native" search query
            if (!isCustomSearchable && (key === "backspace" || key === "delete")) {
                // Reset the timeout that will clears searc query and instead clear the
                // query immediately
                clearTimeout(_this.nativeSearchTimeout);
                _this.setState({
                    nativeSearchQuery: "",
                    defaultPreselectedIndex: undefined
                });
                keyUsed = true;
            } // If the user hits escape on an open select then close it
            if (open && key === "esc") {
                // Stop propagating the event upwards. This ensures that a parent element
                // (e.g. a modal) won't also handle the escape key.
                event.stopPropagation();
                _this.close({
                    retainFocus: true
                });
                keyUsed = true;
            } // If the user hits up, down, or backspace/delete/space (and they're not in
            // the middle of a search) on a collapsed select then open it
            if (!open && !disabled && (key === "up" || key === "down" || (key === "backspace" || key === "delete" || key === "space") && !isNativeSearching)) {
                _this.setState({
                    open: true
                });
                keyUsed = true;
            } // Disabled tabbing while the select is open
            if (open && key === "tab") keyUsed = true;
             // Don't perform the normal action associated with the key (e.g. scroll for
            // arrows/space) if the key was used for a select-related action
            if (keyUsed) event.preventDefault();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownOptionList", function(event) {
            // Prevent "space" from selecting an option when the user is searching
            if ((0, _keycode["default"])(event) === "space" && _this.isNativeSearching()) event.preventDefault();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownCustomSearchInput", function(event) {
            var key = (0, _keycode["default"])(event);
            var open = _this.state.open; // If the user presses an up/down arrow key when focused on an open
            // searchable select's search input, then transfer the focus to the option
            // list and immediately move the preselected index from the current option
            // to the next/previous option. This mimicks what would happen if the option
            // list was focused when the arrow key was pressed.
            if (open && (key === "down" || key === "up") && _this.optionListRef) {
                _this.setState({
                    defaultPreselectedIndex: _this.optionListRef.getNextPreselectedIndex(key === "down" ? 1 : -1)
                });
                _this.optionListRef.focus();
                event.preventDefault();
            } else if (open && key === "enter") {
                var firstOption = (0, _utils.getOptionsFromChildren)(_this.props.children)[0]; // Only select the first option if there's a search query
                if (firstOption && _this.props.searchQuery) _this.onClickOption(firstOption.value);
                 // Don't submit a form if the user presses enter on an open searchable
                // select
                event.preventDefault();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeCustomSearchInput", function(event) {
            var value = event.target.value;
            var defaultPreselectedIndex = _this.state.defaultPreselectedIndex; // Make sure the select is open if the user is typing in a search query
            if (!_this.state.open) _this.setState({
                open: true
            });
             // If we have a query, presleect the first option if it isn't already
            if (value && defaultPreselectedIndex !== 0) _this.setState({
                defaultPreselectedIndex: 0
            });
             // If we don't have a query, clear the preselected option
            if (!value && defaultPreselectedIndex !== -1) _this.setState({
                defaultPreselectedIndex: -1
            });
            _this.props.onSearch(value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownInputBox", function(event) {
            if (_this.isCustomSearchable()) {
                if (!_this.state.open) // If the user mouses down on a closed searchable select, open it
                _this.setState({
                    open: true
                });
                if (event.target !== _this.customSearchInputRef) {
                    // If the user mouses down on the input box of a custom searchable
                    // select, focus on the custom search input
                    _this.customSearchInputRef.focus();
                    event.preventDefault();
                }
            } else // If the user mouses down on a non-searchable select, toggle it
            _this.setState({
                open: !_this.state.open
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickOption", function(value) {
            if (_this.isMultiSelectable()) {
                // If the value is selected then deselect it, otherwise select it
                if ((0, _utils.isOptionValueSelected)(_this.props.value, value)) _this.props.onChange(_this.props.value.filter(function(v) {
                    return v !== value;
                }));
                else _this.props.onChange([].concat((0, _toConsumableArray2["default"])(_this.props.value), [
                    value
                ]));
            } else {
                _this.close({
                    retainFocus: true
                });
                _this.props.onChange(value);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpenPopover", function() {
            if (_this.optionListRef) _this.optionListRef.componentDidMount();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCloseBottomSheet", function() {
            return _this.close({
                retainFocus: true
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function(event) {
            _this.close({
                retainFocus: false
            });
            if (_this.props.onBlur) _this.props.onBlur(event);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function() {
            if (_this.state.defaultPreselectedIndex !== undefined) _this.setState({
                defaultPreselectedIndex: undefined
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(SelectClass, [
        {
            key: "componentDidMount",
            /**
     * Lifecycle hooks
     */ value: function componentDidMount() {
                if (this.props.autoFocus) {
                    // NOTE: React guarantees that callback refs will be resolved before
                    // componentDidMount is called, so this is safe.
                    if (this.isCustomSearchable()) this.customSearchInputRef.focus();
                    else this.rootRef.focus();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var open = this.state.open;
                var disabled = this.props.disabled && !prevProps.disabled; // Collapse the select if it was disabled while open
                if (disabled && open) this.close({
                    retainFocus: false
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Make sure we don't attempt to clear the searchQuery after the component
                // is gone
                clearTimeout(this.nativeSearchTimeout);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var _this$state2 = this.state, open = _this$state2.open, defaultPreselectedIndex = _this$state2.defaultPreselectedIndex;
                var isCustomSearchable = this.isCustomSearchable();
                var options = (0, _utils.getOptionsFromChildren)(props.children);
                var selectedOptions = options.filter(function(option) {
                    return (0, _utils.isOptionValueSelected)(props.value, option.value);
                });
                var valueLabel = props.valueLabel(selectedOptions) || "";
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _select["default"],
                    map: (0, _token.getTokenHelper)("select")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_focus["default"], {
                        onFocus: props.onFocus,
                        onBlur: _this2.onBlur,
                        multipleTargets: true
                    }, function(_ref5) {
                        var focus = _ref5.focus, focusProps = _ref5.focusProps;
                        return /*#__PURE__*/ _react["default"].createElement(_responsive["default"], {
                            query: "min-width",
                            fallback: "".concat(t("optionListPopoverBreakpoint"), "px"),
                            props: {
                                optionListContainerType: isCustomSearchable ? {
                                    "default": "popover"
                                } : (0, _defineProperty2["default"])({
                                    "default": "bottom-sheet"
                                }, "".concat(t("optionListPopoverBreakpoint"), "px"), "popover")
                            }
                        }, function(_ref7) {
                            var optionListContainerType = _ref7.optionListContainerType;
                            return /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({
                                tabIndex: props.disabled || isCustomSearchable ? undefined : "0",
                                id: _this2.id,
                                "aria-haspopup": "listbox",
                                "aria-expanded": open,
                                "aria-disabled": props.disabled,
                                "aria-placeholder": props.placeholder,
                                onKeyDown: props.disabled ? undefined : _this2.onKeyDown,
                                ref: _this2.updateRootRef,
                                className: styles(t, {
                                    width: props.width,
                                    minWidth: props.minWidth
                                })
                            }, focusProps), /*#__PURE__*/ _react["default"].createElement(_context["default"].Consumer, null, function(_ref8) {
                                var _ref8$suffixIconToken = _ref8.suffixIconTokens, suffixIconTokens = _ref8$suffixIconToken === void 0 ? _chevronSelect["default"] : _ref8$suffixIconToken;
                                return /*#__PURE__*/ _react["default"].createElement(_inputBox["default"], {
                                    label: props.label,
                                    htmlFor: _this2.id,
                                    empty: !valueLabel,
                                    focus: focus,
                                    suffixIconTokens: suffixIconTokens,
                                    animated: optionListContainerType === "popover",
                                    labelFloated: isCustomSearchable && open || Boolean(props.placeholder || valueLabel),
                                    disabled: props.disabled,
                                    size: props.size,
                                    prefix: props.prefix,
                                    suffix: props.suffix,
                                    error: props.error && !focus,
                                    cursor: isCustomSearchable && open ? "text" : "pointer",
                                    onMouseDown: props.disabled ? undefined : _this2.onMouseDownInputBox
                                }, isCustomSearchable ? /*#__PURE__*/ _react["default"].createElement("input", (0, _extends2["default"])({
                                    type: "search",
                                    onKeyDown: _this2.onKeyDownCustomSearchInput,
                                    className: customSearchInputStyles(t, {
                                        empty: _this2.props.searchQuery === undefined || _this2.props.searchQuery === "",
                                        open: open,
                                        disabled: props.disabled
                                    }),
                                    placeholder: props.placeholder,
                                    value: _this2.props.searchQuery || "",
                                    ref: _this2.updateCustomSearchInputRef,
                                    onChange: _this2.onChangeCustomSearchInput,
                                    disabled: props.disabled,
                                    autoComplete: "off"
                                }, focusProps)) : null, /*#__PURE__*/ _react["default"].createElement("div", {
                                    className: valueLabelStyles
                                }, valueLabel ? valueLabel : props.placeholder));
                            }), /*#__PURE__*/ _react["default"].createElement(_selectOptionListContainer["default"], {
                                type: optionListContainerType,
                                open: open,
                                popoverAnchorNode: _this2.rootRef,
                                popoverMaxHeight: props.popoverMaxHeight,
                                onOpenPopover: _this2.onOpenPopover,
                                onCloseBottomSheet: _this2.onCloseBottomSheet,
                                t: t
                            }, /*#__PURE__*/ _react["default"].createElement(_selectOptionList["default"], (0, _extends2["default"])({
                                open: open,
                                autoFocus: !isCustomSearchable,
                                value: props.value,
                                searchQuery: props.searchQuery,
                                defaultPreselectedIndex: defaultPreselectedIndex,
                                onChangePreselectedIndex: _this2.onChangePreselectedIndex,
                                onClickOption: _this2.onClickOption,
                                onKeyDown: _this2.onKeyDownOptionList,
                                ref: _this2.updateOptionListRef
                            }, focusProps), props.children)), props.name ? _this2.isMultiSelectable() ? props.value.map(function(value) {
                                return /*#__PURE__*/ _react["default"].createElement("input", {
                                    type: "hidden",
                                    key: value,
                                    name: "".concat(props.name, "[]"),
                                    value: value
                                });
                            }) : /*#__PURE__*/ _react["default"].createElement("input", {
                                type: "hidden",
                                name: props.name,
                                value: props.value || ""
                            }) : null);
                        });
                    });
                });
            }
        }
    ]);
    return SelectClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Forward ref to class component. TODO: update class component
// to functional component.
(0, _defineProperty2["default"])(SelectClass, "nativeSearchTimeoutDuration", 1000);
var Select = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(SelectClass, (0, _extends2["default"])({}, props, {
        forwardedRef: ref
    }));
});
Select.displayName = "Select";
Select.propTypes = {
    /**
   * A list of `SelectOption` elements that represent the choices to present to
   * the user.
   *
   * If no `SelectOption` elements are provided then any other elements passed here
   * will be rendered in place of them. This allows you to render things like a
   * loading indicator while waiting for asyncronously loaded options or a
   * message to the user when no options are available. Note that these elements
   * cannot contain anything interactive like links or buttons for accessibility
   * reasons.
   */ children: _propTypes["default"].node.isRequired,
    /**
   * If set to true then the select will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   */ autoFocus: _propTypes["default"].bool,
    /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */ disabled: _propTypes["default"].bool,
    /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */ error: _propTypes["default"].bool,
    /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */ id: _propTypes["default"].string,
    /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored.
   */ label: _propTypes["default"].string,
    /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */ minWidth: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */ name: _propTypes["default"].string,
    /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */ placeholder: _propTypes["default"].string,
    /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */ popoverMaxHeight: _propTypes["default"].number,
    /**
   * Static text to show in an end-cap prepended to the select.
   */ prefix: _propTypes["default"].string,
    /**
   * Pass the query obtained via the `onSearch` handler back to this prop to
   * update the query rendered by the Select.
   */ searchQuery: _propTypes["default"].string,
    /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */ size: _propTypes["default"].oneOf([
        "small",
        "medium",
        "large",
        "xlarge"
    ]),
    /**
   * Static text to show in an end-cap appended to the input.
   */ suffix: _propTypes["default"].string,
    /**
   * This is the value of the currently selected option. Provide a number or
   * string value for a single-selectable Select, or an array of numbers or
   * strings for a multi-selectable Select. The matching option will
   * automatically be highlighted in the select.
   */ value: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number,
        _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([
            _propTypes["default"].string,
            _propTypes["default"].number
        ]))
    ]),
    /**
   * This function generates the label that is shown in the Select's form
   * field to summarize the current value of the Select. This function
   * receives an array containing all of the selected options that are
   * provided as children to the Select component.
   *
   * The default function will return the selected option's label
   * if one selected option is found. If more than one selected option is
   * found it will return "X selected".
   *
   * If you are filtering the options in the Select (e.g. for a searchable
   * Select), you will have to provide your own function here that does not
   * rely on the array of options passed to this function. As stated above
   * that array will only include selected options *that are currently
   * rendered as children*, so it won't include any selected options that have
   * been filtered out of the current view.
   */ valueLabel: _propTypes["default"].func,
    /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ width: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */ onBlur: _propTypes["default"].func,
    /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */ onChange: _propTypes["default"].func,
    /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */ onFocus: _propTypes["default"].func,
    /**
   * This function makes the select "searchable". A searchable select allows
   * the user to type a query into a text input to search through options.
   *
   * This function will be called with the user's latest query, which should
   * be passed back to the `searchQuery` prop. Note that this will not
   * automatically filter the options in the select. That responsibility is
   * still up to the developer.
   */ onSearch: _propTypes["default"].func
};
Select.defaultProps = {
    onChange: _noop["default"],
    size: "medium",
    valueLabel: function valueLabel(options) {
        return options.length === 1 ? options[0].label : options.length > 0 ? "".concat(options.length, " selected") : "";
    }
};
var _default = Select;
exports["default"] = _default;

},{"f334db4295f4564e":"fk2Bw","5bc39ca7489c43fe":"ef0K4","ead4e54143bd9a26":"d5WW9","2d3f57f67efcc7c0":"5Yd3f","1dd4b1225e660f10":"6Jptv","4a850bcb23399b60":"lMa5o","8730813c039188f5":"j4mqF","d801ae4362300f46":"krVd4","ed088d71e6c8c201":"8h5p9","d9da01175474c793":"hcG56","8c851cf2c90c7ba2":"6uln9","42a90f9bd16e00a0":"cnMFu","c106d24f3c5b0010":"4deck","3564341c501336b5":"bL2S4","13f415b65b0101bf":"4yTHb","3b0d056b57febe8f":"2GWEB","c5947c59dd6ae61b":"7osqO","8b137fc7d249da0a":"k4DHf","46c8de0f6ba3896d":"8H7IN","943d329db3150af3":"3FkLK","d305ae319c71d6b8":"8Oozc","f0cfdaa71846d0ef":"5OopQ","fc02e409f41f56c4":"2wYHx","9d1af387656b08b6":"6Pkby","1c281faa84c4d35c":"4qxnS","f0c4981e476e7ac3":"eM9hO","47722e86dd4761bb":"54pOf","aceb4ad2670b6efb":"2YAMz","1743b4734fd0979a":"atHRo","c483a83b79b3c106":"13UMz","882db61736dcab6a":"20xFV","b96e80aa6ba94958":"2PXpH","e3955aadec33bbba":"4JPZf"}],"k4DHf":[function(require,module,exports) {
var toString = require("2743bbfc46684557");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function escapeRegExp(string) {
    string = toString(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
}
module.exports = escapeRegExp;

},{"2743bbfc46684557":"bI8Cb"}],"8H7IN":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconChevronSelectData: "data:image/svg+xml,%3csvg width='10' height='18' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill-rule='nonzero' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 13l4 4 4-4M9 5L5 1 1 5'/%3e%3c/g%3e%3c/svg%3e",
    iconChevronSelectWidth: 10,
    iconChevronSelectHeight: 18
};

},{}],"3FkLK":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        selectIosToolbarHeight: 44,
        selectIosToolbarBackgroundColor: tokens.themeBackgroundAlternateTertiaryFocus,
        selectIosToolbarForegroundColor: tokens.themeForegroundAccentDefault,
        selectIosToolbarBorderWidth: 1,
        selectIosToolbarBorderRadius: 0,
        selectIosToolbarBorderColor: tokens.themeBorderSecondaryDefault,
        selectIosToolbarSpacingHorizontal: 16,
        selectIosPickerMotionDuration: "200ms",
        selectIosPickerMotionFunction: "ease",
        selectOptionListElevation: 70,
        selectOptionListBorderWidth: 1,
        selectOptionListBorderRadius: 4,
        selectOptionListBorderColor: tokens.themeBorderPrimaryDefault,
        selectOptionListShadowOffsetX: 0,
        selectOptionListShadowOffsetY: 2,
        selectOptionListShadowBlur: 4,
        selectOptionListShadowSpread: 0,
        selectOptionListShadowColor: "rgba(11, 12, 12, 0.16)",
        selectOptionListPopoverOffsetVertical: 4,
        selectOptionListPopoverBreakpoint: 721,
        selectOptionListBackgroundColor: tokens.themeBackgroundPrimaryDefault,
        selectOptionListForegroundColor: tokens.themeForegroundPrimaryDefault,
        selectSearchInputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
        selectSearchInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
        selectSearchInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled
    };
};

},{}],"8Oozc":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("50c2127dbe096f0b");
var _interopRequireDefault = require("9cf60cf87fee4086");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("9a1e4cef2b81bd8"));
var _classCallCheck2 = _interopRequireDefault(require("c2fc30a1cf117439"));
var _createClass2 = _interopRequireDefault(require("3db4a3fbafb2db80"));
var _assertThisInitialized2 = _interopRequireDefault(require("84f25654446f0b34"));
var _inherits2 = _interopRequireDefault(require("d5b189ebf8ba9fb"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("cbd2f982f8c2b411"));
var _getPrototypeOf2 = _interopRequireDefault(require("d97db80851405b11"));
var _defineProperty2 = _interopRequireDefault(require("d3dd77674dc811c6"));
var _react = _interopRequireDefault(require("afba1a09010ad40a"));
var _propTypes = _interopRequireDefault(require("60fae22607f25747"));
var _utils = require("84320aebc3784f57");
var _optionList = _interopRequireWildcard(require("da6146c9dd307482"));
var _highlightSubstring = _interopRequireDefault(require("72f3923cfbe2270a"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var SelectOptionList = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectOptionList, _React$Component);
    var _super = _createSuper(SelectOptionList);
    function SelectOptionList() {
        var _this;
        (0, _classCallCheck2["default"])(this, SelectOptionList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function(event) {
            event.preventDefault();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCustomSearchHighlightSubstring", function(option) {
            return function() {
                return /*#__PURE__*/ _react["default"].createElement(_highlightSubstring["default"], {
                    match: _this.props.searchQuery
                }, option.label);
            };
        });
        return _this;
    }
    (0, _createClass2["default"])(SelectOptionList, [
        {
            key: "shouldComponentUpdate",
            /**
     * Only update if the option list will continue to be open. This prevents the
     * list contents from changing while the Select is in the process of closing,
     * which can be jarring to the user.
     */ value: function shouldComponentUpdate(nextProps) {
                return nextProps.open;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var options = (0, _utils.getOptionsFromChildren)(props.children);
                var nonOptionChildren = options.length > 0 ? [] : (0, _utils.getNonOptionsFromChildren)(props.children);
                return options.length ? /*#__PURE__*/ _react["default"].createElement(_optionList["default"], {
                    autoFocus: props.autoFocus,
                    onFocus: props.onFocus,
                    onBlur: props.onBlur,
                    onKeyDown: props.onKeyDown,
                    defaultPreselectedIndex: props.defaultPreselectedIndex,
                    onChangePreselectedIndex: props.onChangePreselectedIndex,
                    multiSelectable: Array.isArray(props.value),
                    ref: props.forwardedRef
                }, options.map(function(option) {
                    return /*#__PURE__*/ _react["default"].createElement(_optionList.OptionListItem, (0, _extends2["default"])({}, option.passThroughProps, {
                        key: option.value,
                        selected: (0, _utils.isOptionValueSelected)(props.value, option.value),
                        onClick: function onClick() {
                            return props.onClickOption(option.value);
                        },
                        label: option.label,
                        disabled: option.disabled
                    }), // passed, use our own query text rendering
                    props.searchQuery && option.children === undefined ? _this2.renderCustomSearchHighlightSubstring(option) : option.children);
                })) : nonOptionChildren.length ? /*#__PURE__*/ _react["default"].createElement("div", {
                    onMouseDown: this.onMouseDownNonOptionChildren
                }, nonOptionChildren) : null;
            }
        }
    ]);
    return SelectOptionList;
}(_react["default"].Component);
SelectOptionList.propTypes = {};
function forwardRef(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(SelectOptionList, (0, _extends2["default"])({}, props, {
        forwardedRef: ref
    }));
}
forwardRef.displayName = "SelectOptionList";
var _default = /*#__PURE__*/ _react["default"].forwardRef(forwardRef);
exports["default"] = _default;

},{"50c2127dbe096f0b":"k8mdG","9cf60cf87fee4086":"fk2Bw","9a1e4cef2b81bd8":"ef0K4","c2fc30a1cf117439":"5Yd3f","3db4a3fbafb2db80":"6Jptv","84f25654446f0b34":"lMa5o","d5b189ebf8ba9fb":"j4mqF","cbd2f982f8c2b411":"krVd4","d97db80851405b11":"8h5p9","d3dd77674dc811c6":"hcG56","afba1a09010ad40a":"6uln9","60fae22607f25747":"cnMFu","84320aebc3784f57":"2wYHx","da6146c9dd307482":"i85KN","72f3923cfbe2270a":"hCUvD"}],"2wYHx":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d022ad4ba3066804");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNonOptionsFromChildren = exports.getOptionsFromChildren = exports.isOptionValueSelected = exports.isOption = void 0;
var _react = _interopRequireDefault(require("63cf9e462bf732aa"));
var _selectOption = _interopRequireDefault(require("484faa063d8f9c7d"));
var _isElementOf = _interopRequireDefault(require("24a16951f87d5b2a"));
var _filterPropsByPrefix = _interopRequireDefault(require("83a7766bfb6a9113"));
var isOption = (0, _isElementOf["default"])(_selectOption["default"]);
exports.isOption = isOption;
var isOptionValueSelected = function isOptionValueSelected(selectedValue, optionValue) {
    return Array.isArray(selectedValue) ? selectedValue.indexOf(optionValue) !== -1 : selectedValue === optionValue;
};
exports.isOptionValueSelected = isOptionValueSelected;
var getOptionsFromChildren = function getOptionsFromChildren(children) {
    return _react["default"].Children.toArray(children).filter(isOption).map(function(child, index) {
        return {
            index: index,
            label: child.props.label.toString(),
            value: child.props.value,
            children: child.props.children,
            disabled: child.props.disabled,
            passThroughProps: (0, _filterPropsByPrefix["default"])(child.props, [
                "data-"
            ])
        };
    });
};
exports.getOptionsFromChildren = getOptionsFromChildren;
var getNonOptionsFromChildren = function getNonOptionsFromChildren(children) {
    return _react["default"].Children.toArray(children).filter(function(child) {
        return child && !isOption(child);
    });
};
exports.getNonOptionsFromChildren = getNonOptionsFromChildren;

},{"d022ad4ba3066804":"fk2Bw","63cf9e462bf732aa":"6uln9","484faa063d8f9c7d":"kQzbK","24a16951f87d5b2a":"brP3O","83a7766bfb6a9113":"8cR2N"}],"kQzbK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("103e0e1c9221b575");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("7495640cf6bfa9e7"));
var _createClass2 = _interopRequireDefault(require("c1d8ff166557fb39"));
var _inherits2 = _interopRequireDefault(require("31048fafc8e66db3"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("d07c2b3cc0d32be5"));
var _getPrototypeOf2 = _interopRequireDefault(require("5bedb3af207e2f3d"));
var _react = _interopRequireDefault(require("a7efa239bb26c603"));
var _propTypes = _interopRequireDefault(require("62c427ba8715d800"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 */ var SelectOption = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectOption, _React$Component);
    var _super = _createSuper(SelectOption);
    function SelectOption() {
        (0, _classCallCheck2["default"])(this, SelectOption);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(SelectOption, [
        {
            key: "render",
            value: function render() {
                // The top-level OptionListItem component is used to render this. See
                // ./select-option-list for the implementation.
                return null;
            }
        }
    ]);
    return SelectOption;
}(_react["default"].Component);
SelectOption.propTypes = {};
var _default = SelectOption;
exports["default"] = _default;

},{"103e0e1c9221b575":"fk2Bw","7495640cf6bfa9e7":"5Yd3f","c1d8ff166557fb39":"6Jptv","31048fafc8e66db3":"j4mqF","d07c2b3cc0d32be5":"krVd4","5bedb3af207e2f3d":"8h5p9","a7efa239bb26c603":"6uln9","62c427ba8715d800":"cnMFu"}],"i85KN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1928718b416f7686");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OptionListItem", {
    enumerable: true,
    get: function get() {
        return _optionListItem["default"];
    }
});
exports["default"] = void 0;
var _optionList = _interopRequireDefault(require("6b539c7f33dc0f62"));
var _optionListItem = _interopRequireDefault(require("6d5a50de50f88a80"));
var _default = _optionList["default"];
exports["default"] = _default;

},{"1928718b416f7686":"fk2Bw","6b539c7f33dc0f62":"eeIgK","6d5a50de50f88a80":"iMuIh"}],"eeIgK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("84bca9d87fa36a8b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("4268df1b14d771b8"));
var _createClass2 = _interopRequireDefault(require("a2155d6773921b73"));
var _assertThisInitialized2 = _interopRequireDefault(require("289fdd09bf0e85a5"));
var _inherits2 = _interopRequireDefault(require("17b5535299759da7"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("f91f8c85ab278aa2"));
var _getPrototypeOf2 = _interopRequireDefault(require("174829a1ef101bea"));
var _defineProperty2 = _interopRequireDefault(require("abf6bd9632b6176a"));
var _react = _interopRequireDefault(require("de103784b99fdb3c"));
var _reactDom = _interopRequireDefault(require("64e9663c1ed24ee2"));
var _propTypes = _interopRequireDefault(require("272eb55dd207b89a"));
var _keycode = _interopRequireDefault(require("a1b64aa2606210d7"));
var _emotion = require("836b5a3a81c5130b");
var _uniqueId = _interopRequireDefault(require("dea6fb4c0b3381a3"));
var _findIndex = _interopRequireDefault(require("fa3605506ab9b4bf"));
var _noop = _interopRequireDefault(require("41e0e61c410e9ae9"));
var _optionListItem = _interopRequireDefault(require("d25debaf4fa87d9e"));
var _theme = require("cdea6a0e6cd37b51");
var _token = require("48a7a4d6d6462067");
var _functional = require("381e19f3b08ee25");
var _text = _interopRequireDefault(require("fbaf154539d10e6a"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = (0, _functional.memoize)(function(t) {
    return (0, _emotion.css)((0, _text["default"])(t), {
        outline: "none",
        // Item styles
        "& [role=option]": {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            boxSizing: "border-box",
            padding: "".concat(t("spacingInsetVertical"), "px ").concat(t("spacingInsetHorizontal"), "px"),
            transition: t.transitionCss("motion", [
                "color",
                "background-color"
            ]),
            // Foreground and background color
            backgroundColor: t("backgroundColorDefault"),
            color: t("foregroundColorDefault"),
            "&[aria-selected=true]": {
                backgroundColor: t("backgroundColorSelected"),
                color: t("foregroundColorSelected")
            },
            "&[aria-current=true]": {
                backgroundColor: t("backgroundColorPreselected"),
                color: t("foregroundColorPreselected")
            },
            "&:active": {
                backgroundColor: t("backgroundColorPressed"),
                color: t("foregroundColorPressed")
            },
            "&[disabled], &[aria-disabled]": {
                backgroundColor: t("backgroundColorDisabled"),
                color: t("foregroundColorDisabled")
            }
        },
        // Children styles
        "& [role=option] > *:first-child": {
            flex: "auto"
        },
        // Selected indicator styles
        "&[aria-multiselectable=true] [role=option]": {
            "& > *:last-child": {
                flexShrink: 0,
                marginLeft: t("spacingInsetHorizontal"),
                color: t("indicatorColorDefault"),
                transition: t.transitionCss("motion", "color")
            },
            "&[aria-current=true] > *:last-child": {
                color: t("indicatorColorPreselected")
            },
            "&[aria-selected=true] > *:last-child": {
                color: t("indicatorColorSelected")
            },
            "&:active > *:last-child": {
                color: t("indicatorColorPressed")
            },
            "&[disabled][aria-selected=true] > *:last-child, &[aria-disabled][aria-selected=true] > *:last-child": {
                color: t("indicatorColorDisabled")
            }
        }
    });
});
/**
 * This component helps render a keyboard-friendly list of selectable options.
 */ var OptionList = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(OptionList, _React$Component);
    var _super = _createSuper(OptionList);
    function OptionList() {
        var _this;
        (0, _classCallCheck2["default"])(this, OptionList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            preselectedIndex: _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.props.defaultPreselectedIndex !== undefined ? _this.props.defaultPreselectedIndex : -1
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("option-list-"));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionDomNodes", []);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listDomNode", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateListDomNode", function(node) {
            return _this.listDomNode = node;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedIndex", function(options) {
            return (0, _findIndex["default"])(options, function(option) {
                return option && option.props.selected;
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPreselectedIndex", function() {
            return _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.state.preselectedIndex;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextPreselectedIndex", function(offset) {
            var options = _react["default"].Children.toArray(_this.props.children);
            var preselectedIndex = _this.getPreselectedIndex();
            var selectedIndex = _this.getSelectedIndex(options);
            var enabledIndices = options.reduce(function(result, option, index) {
                if (option && !option.props.disabled) result.push(index);
                return result;
            }, []);
            var firstIndex = enabledIndices[0];
            var lastIndex = enabledIndices[enabledIndices.length - 1]; // If we've got a preselected or a selected option then move to the prev or
            // next option in the list (depending on the value of offset).
            var currentIndex = preselectedIndex !== -1 ? preselectedIndex : selectedIndex;
            if (currentIndex !== -1) {
                var nextIndex = enabledIndices[enabledIndices.indexOf(currentIndex) + offset];
                return nextIndex !== undefined ? nextIndex : offset < 0 ? firstIndex : lastIndex; // If we don't have a preselected or selected option and we were trying to
            // move up, preselect the option at the bottom of the list.
            } else if (offset < 0) return lastIndex; // If we don't have a preselected or selected option and we were trying to
            else return firstIndex;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function(preselectedIndex) {
            if (_this.props.preselectedIndex === undefined) _this.setState({
                preselectedIndex: preselectedIndex
            });
            _this.props.onChangePreselectedIndex(preselectedIndex);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownContainer", function(event) {
            // Call the user's key down handler first. If they prevent the default event
            // behavior, don't run any of our code.
            _this.props.onKeyDown(event);
            if (!event.defaultPrevented) {
                var key = (0, _keycode["default"])(event);
                var keyUsed = false; // Move the preselection up or down in the list when the up arrow is pressed
                if (key === "up" || key === "down") {
                    var preselectedIndex = _this.getNextPreselectedIndex(key === "up" ? -1 : 1);
                    _this.onChangePreselectedIndex(preselectedIndex);
                    _this.scrollOptionIntoView(preselectedIndex);
                    keyUsed = true;
                } // Simulate a click on the current preselected option when enter or space is
                // pressed
                if (key === "enter" || key === "space") {
                    var _preselectedIndex = _this.getPreselectedIndex();
                    if (_preselectedIndex !== -1) _react["default"].Children.toArray(_this.props.children)[_preselectedIndex].props.onClick();
                    keyUsed = true;
                } // Don't perform the normal action associated with the key (i.e. scroll for
                // arrows) if the key was used for an option list action
                if (keyUsed) event.preventDefault();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionRef", function(index) {
            return function(domNode) {
                return(/* eslint-disable-next-line react/no-find-dom-node */ _this.optionDomNodes[index] = _reactDom["default"].findDOMNode(domNode));
            };
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollOptionIntoView", function(index) {
            var optionDomNode = _this.optionDomNodes[index];
            if (optionDomNode) optionDomNode.scrollIntoView(optionDomNode);
        });
        return _this;
    }
    (0, _createClass2["default"])(OptionList, [
        {
            key: "focus",
            value: function focus() {
                return this.listDomNode.focus();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Scroll the preselected or selected option into view on mount
                var preselectedIndex = this.getPreselectedIndex();
                if (preselectedIndex !== -1) this.scrollOptionIntoView(preselectedIndex);
                else {
                    var options = _react["default"].Children.toArray(this.props.children);
                    this.scrollOptionIntoView(this.getSelectedIndex(options));
                } // Focus on mount
                if (this.props.autoFocus) // NOTE: React guarantees that callback refs will be resolved before
                // componentDidMount is called, so this is safe.
                this.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, preselectedIndex = _this$props.preselectedIndex, defaultPreselectedIndex = _this$props.defaultPreselectedIndex; // If the preselected index was changed via props, update the internal state
                if (preselectedIndex !== undefined && preselectedIndex !== prevProps.preselectedIndex) this.setState({
                    preselectedIndex: preselectedIndex
                });
                else if (preselectedIndex === undefined && defaultPreselectedIndex !== undefined && defaultPreselectedIndex !== prevProps.defaultPreselectedIndex) {
                    this.setState({
                        preselectedIndex: defaultPreselectedIndex
                    }); // If the default was changed then scroll it into view. We don't do this
                    // if the `preselectedIndex` prop is changed because that means the parent
                    // component is fully managing state and will need to be responsible for
                    // managing scroll position as well.
                    this.scrollOptionIntoView(defaultPreselectedIndex);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var preselectedIndex = this.state.preselectedIndex;
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _optionListItem["default"],
                    map: (0, _token.getTokenHelper)("optionListItem")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement("div", {
                        ref: _this2.updateListDomNode,
                        onKeyDown: _this2.onKeyDownContainer,
                        tabIndex: "0",
                        role: "listbox",
                        "aria-multiselectable": props.multiSelectable,
                        "aria-activedescendant": preselectedIndex ? "".concat(_this2.id, "-option-").concat(preselectedIndex) : undefined,
                        onFocus: props.onFocus,
                        onBlur: props.onBlur,
                        className: styles(t)
                    }, _react["default"].Children.map(props.children, function(option, index) {
                        return option ? /*#__PURE__*/ _react["default"].cloneElement(option, {
                            ref: _this2.optionRef(index),
                            id: "".concat(_this2.id, "-option-").concat(index),
                            preselected: index === preselectedIndex,
                            showIndicator: props.multiSelectable,
                            onChangePreselected: function onChangePreselected(preselected) {
                                return _this2.onChangePreselectedIndex(preselected ? index : -1);
                            }
                        }) : null;
                    }));
                });
            }
        }
    ]);
    return OptionList;
}(_react["default"].Component);
(0, _defineProperty2["default"])(OptionList, "defaultProps", {
    onKeyDown: _noop["default"],
    onChangePreselectedIndex: _noop["default"]
});
OptionList.propTypes = {};
var _default = OptionList;
exports["default"] = _default;

},{"84bca9d87fa36a8b":"fk2Bw","4268df1b14d771b8":"5Yd3f","a2155d6773921b73":"6Jptv","289fdd09bf0e85a5":"lMa5o","17b5535299759da7":"j4mqF","f91f8c85ab278aa2":"krVd4","174829a1ef101bea":"8h5p9","abf6bd9632b6176a":"hcG56","de103784b99fdb3c":"6uln9","64e9663c1ed24ee2":"b8T3j","272eb55dd207b89a":"cnMFu","a1b64aa2606210d7":"bL2S4","836b5a3a81c5130b":"4deck","dea6fb4c0b3381a3":"4yTHb","fa3605506ab9b4bf":"caIAP","41e0e61c410e9ae9":"7osqO","d25debaf4fa87d9e":"akOZE","cdea6a0e6cd37b51":"eM9hO","48a7a4d6d6462067":"atHRo","381e19f3b08ee25":"eKpY2","fbaf154539d10e6a":"13UMz"}],"akOZE":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        optionListItemMobileSpacingInsetVertical: 16,
        optionListItemMobileSpacingInsetHorizontal: 16,
        optionListItemSpacingInsetVertical: 8,
        optionListItemSpacingInsetHorizontal: 12,
        optionListItemForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
        optionListItemForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
        optionListItemForegroundColorPreselected: tokens.themeForegroundInvertedDefault,
        optionListItemForegroundColorPressed: tokens.themeForegroundInvertedDefault,
        optionListItemForegroundColorSelected: tokens.themeForegroundInvertedDefault,
        optionListItemBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
        optionListItemBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
        optionListItemBackgroundColorPreselected: tokens.themeForegroundAccentHover,
        optionListItemBackgroundColorPressed: tokens.themeForegroundAccentPressed,
        optionListItemBackgroundColorSelected: tokens.themeForegroundAccentDefault,
        optionListItemIndicatorColorDefault: "rgba(0, 0, 0, 0)",
        optionListItemIndicatorColorDisabled: tokens.themeForegroundPrimaryDisabled,
        optionListItemIndicatorColorPreselected: tokens.themeForegroundAccentDefault,
        optionListItemIndicatorColorPressed: tokens.themeForegroundInvertedDefault,
        optionListItemIndicatorColorSelected: tokens.themeForegroundInvertedDefault,
        optionListItemMotionDuration: "100ms",
        optionListItemMotionFunction: "ease",
        optionListItemLineHeight: "24px"
    };
};

},{}],"iMuIh":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b1d6f1ab5b00e10f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("2cd4c8aa2008e757"));
var _classCallCheck2 = _interopRequireDefault(require("ad2fe75260ef3664"));
var _createClass2 = _interopRequireDefault(require("dc24731135dbe720"));
var _assertThisInitialized2 = _interopRequireDefault(require("cbe435a2a46f35a7"));
var _inherits2 = _interopRequireDefault(require("314a19ea5a6140be"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("410ae6fdced2110d"));
var _getPrototypeOf2 = _interopRequireDefault(require("2bea8b8d247912ac"));
var _defineProperty2 = _interopRequireDefault(require("92275287107aa36c"));
var _react = _interopRequireDefault(require("e45fe2b1f08fe318"));
var _propTypes = _interopRequireDefault(require("d524bd6bd830d5ce"));
var _checkLarge = _interopRequireDefault(require("fff170af2aa2226f"));
var _clickable = _interopRequireDefault(require("d569d062298e3195"));
var _icon = _interopRequireDefault(require("5a82a1c435a5c361"));
var _filterPropsByPrefix = _interopRequireDefault(require("fd3adfa58e0abc60"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var OptionListItem = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(OptionListItem, _React$Component);
    var _super = _createSuper(OptionListItem);
    function OptionListItem() {
        var _this;
        (0, _classCallCheck2["default"])(this, OptionListItem);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            preselected: _this.props.preselected,
            selected: _this.props.selected
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseX", 0);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseY", 0);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseMove", function(event) {
            if (!_this.props.preselected) _this.props.onChangePreselected(true);
             // Track the mouse position so we can detect whether `onMouseLeaveOption`
            // was triggered by a mouse move or by something else (e.g. scrolling).
            _this.mouseX = event.clientX;
            _this.mouseY = event.clientY;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnter", function(event) {
            // Track the mouse position so we can detect whether `onMouseLeaveOption`
            // was triggered by a mouse move or by something else (e.g. scrolling).
            _this.mouseX = event.clientX;
            _this.mouseY = event.clientY;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function(event) {
            // If the user has moused out of an option by moving their mouse (and not by
            // scrolling the option out from under their mouse) then blur it. Don't blur
            // if they haven't moved their mouse. This allows the user to use keyboard
            // navigation while their mouse cursor is resting over the list (otherwise
            // the mouse and keyboard end up fighting over control).
            if (_this.props.preselected && (event.clientX !== _this.mouseX || event.clientY !== _this.mouseY)) _this.props.onChangePreselected(false);
        });
        return _this;
    }
    (0, _createClass2["default"])(OptionListItem, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return nextProps.label !== this.props.label || nextProps.children !== this.props.children || nextProps.disabled !== this.props.disabled || nextProps.href !== this.props.href || nextProps.id !== this.props.id || nextState.selected !== this.state.selected || nextState.preselected !== this.state.preselected;
            }
        },
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this$state = this.state, selected = _this$state.selected, preselected = _this$state.preselected;
                var children = props.children ? props.children({
                    selected: selected,
                    preselected: preselected
                }) : props.label;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
                    disabled: props.disabled,
                    id: props.id,
                    href: props.href,
                    rel: props.rel,
                    target: props.target,
                    onClick: props.onClick,
                    onMouseMove: props.disabled ? undefined : this.onMouseMove,
                    onMouseEnter: props.disabled ? undefined : this.onMouseEnter,
                    onMouseLeave: props.disabled ? undefined : this.onMouseLeave,
                    role: "option",
                    "aria-selected": selected,
                    "aria-current": preselected ? "true" : undefined,
                    "aria-label": props.label,
                    tabIndex: "-1"
                }), /*#__PURE__*/ _react["default"].createElement("div", null, children), props.showIndicator ? /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                    tokens: _checkLarge["default"]
                }) : null);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var preselected = state.preselected, selected = state.selected;
                if (props.selected !== selected) // If the option was just selected or deselected then don't show the
                // preselected state
                return {
                    selected: props.selected,
                    preselected: false
                };
                else if (props.preselected !== preselected) // If the preselected prop was changed from on high then update the
                // internal preselected state to stay in sync
                return {
                    preselected: props.preselected
                };
                else return null;
            }
        }
    ]);
    return OptionListItem;
}(_react["default"].Component);
(0, _defineProperty2["default"])(OptionListItem, "defaultProps", {
    selected: false,
    preselected: false
});
OptionListItem.propTypes = {};
var _default = OptionListItem;
exports["default"] = _default;

},{"b1d6f1ab5b00e10f":"fk2Bw","2cd4c8aa2008e757":"ef0K4","ad2fe75260ef3664":"5Yd3f","dc24731135dbe720":"6Jptv","cbe435a2a46f35a7":"lMa5o","314a19ea5a6140be":"j4mqF","410ae6fdced2110d":"krVd4","2bea8b8d247912ac":"8h5p9","92275287107aa36c":"hcG56","e45fe2b1f08fe318":"6uln9","d524bd6bd830d5ce":"cnMFu","fff170af2aa2226f":"3Sg2u","d569d062298e3195":"iia1p","5a82a1c435a5c361":"jPx5F","fd3adfa58e0abc60":"8cR2N"}],"3Sg2u":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconCheckLargeData: "data:image/svg+xml,%3csvg width='13' height='9' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 4.017l3.996 3.998L12.006 1' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
    iconCheckLargeWidth: 13,
    iconCheckLargeHeight: 9
};

},{}],"hCUvD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9690f0eaf7dde463");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _highlightSubstring = _interopRequireDefault(require("7e5e287d4fee441e"));
var _default = _highlightSubstring["default"];
exports["default"] = _default;

},{"9690f0eaf7dde463":"fk2Bw","7e5e287d4fee441e":"bZFAG"}],"bZFAG":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("58c51ecfd47d9233");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("c84bf2cbb5de01fd"));
var _propTypes = _interopRequireDefault(require("c86eac4e2822b4a7"));
var _escapeRegExp = _interopRequireDefault(require("d11e318351378408"));
var _emotion = require("6384d5bb75d1fe2c");
var _typography = require("a2e1288720589cba");
var maxMatchLength = 100;
var defaultMatchedStyles = (0, _emotion.css)({
    fontWeight: _typography.typographyFontWeightH300
});
var makeSubstringWithMatch = function makeSubstringWithMatch(text, match) {
    return {
        text: text,
        match: match
    };
};
/**
 * Parses string into an ordered array of objects with substrings
 * and if was a match or not.
 * getSubstringWithMatchBool(/abc/g, "abc def abc")
 * [ {text: "abc", match: true},
 *   {text: "def", match: false},
 *   {text: "abc", match: true} ]
 */ var getSubstringsWithMatchBool = function getSubstringsWithMatchBool(regexp, string) {
    var substringsWithMatchBool = [];
    var startBeforeIndex = 0;
    var match;
    do {
        match = regexp.exec(string);
        if (match) {
            var length = match[0].length;
            var matchText = string.substr(match.index, length);
            var beforeText = string.substr(startBeforeIndex, match.index - startBeforeIndex);
            if (beforeText) substringsWithMatchBool.push(makeSubstringWithMatch(beforeText, false));
            substringsWithMatchBool.push(makeSubstringWithMatch(matchText, true));
            startBeforeIndex = match.index + length;
        } // Keep looking for matches if we previously found a match
    // and our regular expression is global (i.e. get all matches)
    }while (match && regexp.global); // If there's still some text leftover at the end, gobble it up
    if (startBeforeIndex < string.length) {
        var restText = string.substr(startBeforeIndex);
        substringsWithMatchBool.push(makeSubstringWithMatch(restText, false));
    }
    return substringsWithMatchBool;
};
var HighlightSubstring = function HighlightSubstring(_ref) {
    var children = _ref.children, match = _ref.match, className = _ref.className;
    var string = Array.isArray(children) ? children.join("") : children;
    var regexp = match instanceof RegExp ? match : new RegExp((0, _escapeRegExp["default"])(match.substr(0, maxMatchLength)), "i");
    var substrings = getSubstringsWithMatchBool(regexp, string);
    return /*#__PURE__*/ _react["default"].createElement("span", null, substrings.map(function(_ref2, index) {
        var text = _ref2.text, match = _ref2.match;
        return !match ? /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, {
            key: index
        }, text) : /*#__PURE__*/ _react["default"].createElement("span", {
            key: index,
            className: className
        }, text);
    }));
};
HighlightSubstring.propTypes = {};
HighlightSubstring.defaultProps = {
    className: defaultMatchedStyles
};
var _default = HighlightSubstring;
exports["default"] = _default;

},{"58c51ecfd47d9233":"fk2Bw","c84bf2cbb5de01fd":"6uln9","c86eac4e2822b4a7":"cnMFu","d11e318351378408":"k4DHf","6384d5bb75d1fe2c":"4deck","a2e1288720589cba":"jsBpN"}],"jsBpN":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports = {
    typographyFontSizeD300: 76,
    typographyFontSizeD200: 54,
    typographyFontSizeD100: 48,
    typographyFontSizeD50: 36,
    typographyFontSizeH600: 36,
    typographyFontSizeH500: 28,
    typographyFontSizeH400: 24,
    typographyFontSizeH300: 20,
    typographyFontSizeH200: 18,
    typographyFontSizeH100: 16,
    typographyFontSizeB500: 20,
    typographyFontSizeB400: 18,
    typographyFontSizeB300: 16,
    typographyFontSizeB200: 14,
    typographyFontSizeB100: 12,
    typographyFontWeightD300: 200,
    typographyFontWeightD200: 200,
    typographyFontWeightD100: 200,
    typographyFontWeightD50: 200,
    typographyFontWeightH600: 600,
    typographyFontWeightH500: 600,
    typographyFontWeightH400: 600,
    typographyFontWeightH300: 600,
    typographyFontWeightH200: 600,
    typographyFontWeightH100: 600,
    typographyFontWeightB500: 400,
    typographyFontWeightB400: 400,
    typographyFontWeightB300: 400,
    typographyFontWeightB200: 400,
    typographyFontWeightB100: 400,
    typographyLineHeightD300: "96px",
    typographyLineHeightD200: "64px",
    typographyLineHeightD100: "60px",
    typographyLineHeightD50: "48px",
    typographyLineHeightH600: "48px",
    typographyLineHeightH500: "36px",
    typographyLineHeightH400: "32px",
    typographyLineHeightH300: "24px",
    typographyLineHeightH200: "24px",
    typographyLineHeightH100: "20px",
    typographyLineHeightB500: "28px",
    typographyLineHeightB400: "28px",
    typographyLineHeightB300: "24px",
    typographyLineHeightB200: "20px",
    typographyLineHeightB100: "16px"
};

},{}],"5OopQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5203fdce1bc2367c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("69037fd34f60ce8b"));
var _createClass2 = _interopRequireDefault(require("40e65d90b63c5978"));
var _assertThisInitialized2 = _interopRequireDefault(require("2e8a8dfdc2b7e0c1"));
var _inherits2 = _interopRequireDefault(require("75598915832719c"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("b0cfea295b02ac21"));
var _getPrototypeOf2 = _interopRequireDefault(require("bfa44b8a14610e94"));
var _defineProperty2 = _interopRequireDefault(require("49457b19b6555d5"));
var _react = _interopRequireDefault(require("cbdd4d7995319d62"));
var _propTypes = _interopRequireDefault(require("76fb80022f76ae2d"));
var _emotion = require("acc254df0e0571e");
var _popoverController = _interopRequireDefault(require("c9f2fc2430c492bd"));
var _bottomSheet = _interopRequireDefault(require("64067c6e295282ee"));
var _token = require("9fac424284d95009");
var _text = _interopRequireDefault(require("9db0cbd40be7e7f5"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var popoverStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var anchorWidth = _ref.anchorWidth;
    return (0, _emotion.css)((0, _text["default"])(t), {
        boxSizing: "border-box",
        minWidth: anchorWidth,
        overflowY: "auto",
        outline: "none",
        backgroundColor: t("optionListBackgroundColor"),
        borderRadius: t("optionListBorderRadius"),
        border: t.borderCss("optionListBorder"),
        boxShadow: t.boxShadowCss("optionListShadow"),
        zIndex: t("optionListElevation")
    });
}, [
    "anchorWidth"
]);
var SelectOptionListContainer = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectOptionListContainer, _React$Component);
    var _super = _createSuper(SelectOptionListContainer);
    function SelectOptionListContainer() {
        var _this;
        (0, _classCallCheck2["default"])(this, SelectOptionListContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopover", function() {
            return /*#__PURE__*/ _react["default"].createElement(_popoverController["default"], {
                open: _this.props.open,
                anchorNode: _this.props.popoverAnchorNode,
                anchorOrigin: "bottom left",
                popoverOrigin: "top left",
                offsetVertical: _this.props.t("optionListPopoverOffsetVertical"),
                maxHeight: _this.props.popoverMaxHeight,
                shrinkToFit: true,
                onOpen: _this.props.onOpenPopover
            }, function(_ref2) {
                var popoverStyle = _ref2.popoverStyle, anchorRect = _ref2.anchorRect;
                return /*#__PURE__*/ _react["default"].createElement("div", {
                    style: popoverStyle,
                    className: popoverStyles(_this.props.t, {
                        anchorWidth: anchorRect.width
                    })
                }, _this.props.children);
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBottomSheet", function() {
            return /*#__PURE__*/ _react["default"].createElement(_bottomSheet["default"], {
                onClose: _this.props.onCloseBottomSheet,
                open: _this.props.open,
                type: "modal"
            }, _this.props.children);
        });
        return _this;
    }
    (0, _createClass2["default"])(SelectOptionListContainer, [
        {
            key: "render",
            value: function render() {
                return this.props.type === "popover" ? this.renderPopover() : this.renderBottomSheet();
            }
        }
    ]);
    return SelectOptionListContainer;
}(_react["default"].Component);
SelectOptionListContainer.propTypes = {};
var _default = SelectOptionListContainer;
exports["default"] = _default;

},{"5203fdce1bc2367c":"fk2Bw","69037fd34f60ce8b":"5Yd3f","40e65d90b63c5978":"6Jptv","2e8a8dfdc2b7e0c1":"lMa5o","75598915832719c":"j4mqF","b0cfea295b02ac21":"krVd4","bfa44b8a14610e94":"8h5p9","49457b19b6555d5":"hcG56","cbdd4d7995319d62":"6uln9","76fb80022f76ae2d":"cnMFu","acc254df0e0571e":"4deck","c9f2fc2430c492bd":"7BhWA","64067c6e295282ee":"bFX3A","9fac424284d95009":"atHRo","9db0cbd40be7e7f5":"13UMz"}],"7BhWA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("bed29fcea99313c0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _popoverController = _interopRequireDefault(require("fe1c23ef9221f3db"));
var _default = _popoverController["default"];
exports["default"] = _default;

},{"bed29fcea99313c0":"fk2Bw","fe1c23ef9221f3db":"llqmO"}],"llqmO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("d490174dfdffefbb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("518466e4b73e423e"));
var _classCallCheck2 = _interopRequireDefault(require("e185a31aaa5e2445"));
var _createClass2 = _interopRequireDefault(require("cfb1ef22ad8258d3"));
var _assertThisInitialized2 = _interopRequireDefault(require("d02f4c6ddeda1d40"));
var _inherits2 = _interopRequireDefault(require("a1c3fc1505445627"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("19e5daa480cf0ec1"));
var _getPrototypeOf2 = _interopRequireDefault(require("eafddc40fad820b9"));
var _defineProperty2 = _interopRequireDefault(require("8a930d1952303213"));
var _react = _interopRequireDefault(require("f83ba91cfda9b1ba"));
var _reactDom = _interopRequireDefault(require("da8900a3da9cce4e"));
var _propTypes = _interopRequireDefault(require("f5f07936b01f687a"));
var _noop = _interopRequireDefault(require("904e6d2c8e1a61a6"));
var _popover = _interopRequireDefault(require("aedc63c3d9b020e9"));
var _utils = require("ca05b16d3c473ef6");
var _portal = _interopRequireDefault(require("d9cabb4bf6293f7e"));
var _transitionController = _interopRequireDefault(require("9008f5d0c992a242"));
var _propTypes2 = _interopRequireDefault(require("3af7217137bd62d2"));
var _parsers = require("b96d114917c68243");
var _addDebouncedEventListener = _interopRequireDefault(require("56bcf612dd80fdc4"));
var _waitAnimationFrame = _interopRequireDefault(require("f05bfc7e1b4903e0"));
var _nodeBounds = require("591761b0ade43087");
var _token = require("db3abb05ef0fba92");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// The closest a popover can be shown to the edge of the viewport
var viewportPadding = 16; // Grab the popover motion duration and function from our tokens.
var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]), popoverMotionDuration = _getUnthemedTokens.popoverMotionDuration, popoverMotionFunction = _getUnthemedTokens.popoverMotionFunction, popoverClosedScale = _getUnthemedTokens.popoverClosedScale;
/**
 * Styles
 */ // NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.
var styles = function styles(_ref) {
    var shrinkToFit = _ref.shrinkToFit, offsetHorizontal = _ref.offsetHorizontal, offsetVertical = _ref.offsetVertical, maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, anchorRect = _ref.anchorRect, viewportRect = _ref.viewportRect, state = _ref.state, anchorOrigin = _ref.anchorOrigin, popoverOrigin = _ref.popoverOrigin, availableSpace = _ref.availableSpace;
    // The distance to offset the popover from the anchor's left edge (changes
    // based on the anchor origin).
    var offsetFromAnchorLeft = {
        left: -offsetHorizontal,
        center: anchorRect.width / 2 + offsetHorizontal,
        right: anchorRect.width + offsetHorizontal
    }[anchorOrigin.x]; // The distance to offset the popover from the anchor's top edge (changes
    // based on the anchor origin).
    var offsetFromAnchorTop = {
        top: -offsetVertical,
        center: anchorRect.height / 2 + offsetVertical,
        bottom: anchorRect.height + offsetVertical
    }[anchorOrigin.y];
    return {
        position: "fixed",
        boxSizing: "border-box",
        // Anchor the popover's position from its bottom edge if it's anchored at
        // the bottom. This ensures long content forces the popover to expand
        // downwards.
        top: state !== "exited" && popoverOrigin.y !== "bottom" ? anchorRect.top + offsetFromAnchorTop - viewportPadding : undefined,
        // Anchor the popover's position from its bottom edge if it's anchored at
        // the bottom. This ensures long content forces the popover to expand
        // upwards.
        bottom: state !== "exited" && popoverOrigin.y === "bottom" ? viewportRect.height - anchorRect.top - offsetFromAnchorTop - viewportPadding : undefined,
        // Anchor the popover's position from its left edge if it's anchored at the
        // the left or center. This ensures long content forces the popover to
        // expand to the right.
        left: state !== "exited" && popoverOrigin.x !== "right" ? anchorRect.left + offsetFromAnchorLeft - viewportPadding : undefined,
        // Anchor the popover's position from its right edge if it's anchored at the
        // right. This ensures long content forces the popover to expand to the left.
        right: state !== "exited" && popoverOrigin.x === "right" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft - viewportPadding : undefined,
        transformOrigin: "".concat(popoverOrigin.y, " ").concat(popoverOrigin.x),
        opacity: state === "exited" || state === "exiting" ? 0 : 1,
        // For popovers that are anchored at their center, apply a transform to
        // ensure that the popover is positioned correctly and that long content
        // forces it to expand from the center.
        transform: "translateY(".concat(popoverOrigin.y === "center" ? "-50%" : "0%", ") translateX(").concat(popoverOrigin.x === "center" ? "-50%" : "0%", ") scale(").concat(state === "exited" || state === "exiting" ? popoverClosedScale / 100 : 1, ")"),
        transition: state === "entering" || state === "entered" || state === "exiting" ? "transform ".concat(popoverMotionDuration, " ").concat(popoverMotionFunction, ", opacity ").concat(popoverMotionDuration, " ").concat(popoverMotionFunction) : undefined,
        visibility: state === "exited" ? "hidden" : "visible",
        // Add margin on every side to make sure that the viewport padding is
        // maintained
        margin: viewportPadding,
        // If the user has specified a maxHeight then use that. If the popover is
        // open and the `shrinkToFit` prop is set then also constrain by the
        // available vertical space.
        maxHeight: state !== "exited" && shrinkToFit ? Math.min(maxHeight || availableSpace.y, availableSpace.y) : maxHeight,
        // If the user has specified a maxWidth then use that. If the popover is
        // open and the `shrinkToFit` prop is set then also constrain by the
        // available horizontal space.
        maxWidth: state !== "exited" && shrinkToFit ? Math.min(maxWidth || availableSpace.x, availableSpace.x) : maxWidth
    };
};
/**
 * This component handles the positioning of popover content in relation to
 * another element (the "anchor" element). It allows you to "stick" the popover
 * to the anchor element.
 *
 * This component has two real benefits over a simple absolute-positing strategy
 * for popover content. First, it renders popover content at the root of the DOM
 * using portals. This allows popovers to break out of the anchor element's
 * parent containers regardless of any overflow/scroll styles on those
 * containers. Second, this component will automatically re-position and re-size
 * the popover content based on the available space in the viewport. This
 * ensures that the content in the popover will be as accessible to the user as
 * possible.
 *
 * This component does not actually render anything to the DOM. It simply
 * generates the styles necessary to correctly position the popover. The styles
 * are passed via render props to the component's children so that the user can
 * render the popover exactly how they want to. This requires that the user set
 * the style prop on their popover element to the `popoverStyle` render prop
 * returned by this component.
 */ var PopoverController = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(PopoverController, _React$Component);
    var _super = _createSuper(PopoverController);
    function PopoverController() {
        var _this;
        (0, _classCallCheck2["default"])(this, PopoverController);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            // Should we render the popover's children? We don't when the popover is
            // closed to avoid unnecessary work.
            render: false,
            // The bounding rectangle for the anchor node.
            anchorRect: _nodeBounds.emptyNodeBounds,
            // The bounding rectangle for the popover node.
            popoverRect: _nodeBounds.emptyNodeBounds,
            // The bounding rectangle for the viewport.
            viewportRect: _nodeBounds.emptyNodeBounds
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorRect", function() {
            var _this$props = _this.props, open = _this$props.open, anchorNode = _this$props.anchorNode;
            if (open) {
                /* eslint-disable-next-line react/no-find-dom-node */ var anchorDomNode = _reactDom["default"].findDOMNode(anchorNode);
                var anchorRect = (0, _nodeBounds.getNodeBounds)(anchorDomNode);
                if (!(0, _nodeBounds.compareNodeBounds)(anchorRect, _this.state.anchorRect)) _this.setState({
                    anchorRect: anchorRect
                });
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateViewportRect", function() {
            var viewportRect = (0, _nodeBounds.getNodeBounds)(window);
            if (!(0, _nodeBounds.compareNodeBounds)(viewportRect, _this.state.viewportRect)) _this.setState({
                viewportRect: viewportRect
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePopoverRect", function() {
            var popoverRect = (0, _nodeBounds.getNodeBounds)(_this.popoverNode);
            if (!(0, _nodeBounds.compareNodeBounds)(popoverRect, _this.state.popoverRect)) _this.setState({
                popoverRect: popoverRect
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResizeWindow", function() {
            _this.updateViewportRect();
            _this.updateAnchorRect();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function(event) {
            var open = _this.props.open;
            var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this), popoverNode = _assertThisInitialize.popoverNode; // If the popover is open and the scroll event came from *outside* the
            // popover then assume the anchor element moved (and an update is needed for
            // the anchor rect).
            if (open && (!popoverNode || !popoverNode.contains(event.target))) _this.updateAnchorRect();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function(done) {
            _this.props.onBeforeOpen();
            _this.setState({
                render: true
            }, function() {
                // Give the children a chance to settle before poking through the DOM
                _this.cancelAnimationFrame = (0, _waitAnimationFrame["default"])(function() {
                    /* eslint-disable-next-line react/no-find-dom-node */ _this.popoverNode = _reactDom["default"].findDOMNode((0, _assertThisInitialized2["default"])(_this));
                    _this.updateViewportRect();
                    _this.updateAnchorRect();
                    _this.updatePopoverRect();
                    _this.addEventListeners();
                    done();
                });
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function(done) {
            _this.props.onOpen(_this.popoverNode);
            done();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function() {
            _this.props.onClose(_this.popoverNode);
            _this.removeEventListeners();
            _this.setState({
                render: false
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(PopoverController, [
        {
            key: "addEventListeners",
            value: function addEventListeners() {
                // Remove any existing event listeners just to be safe
                this.removeEventListeners(); // Listen for *any* scroll event in the document
                this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.onScroll, true)); // Listen for resize events from the window
                this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.onResizeWindow));
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                this.eventListeners.forEach(function(removeListener) {
                    return removeListener();
                });
                this.eventListeners = [];
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (this.props.open && Boolean(this.props.anchorNode)) /* eslint-disable-next-line react/no-find-dom-node */ this.onBeforeOpen(function() {
                    return _this2.onOpen(_noop["default"]);
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeEventListeners();
                if (this.cancelAnimationFrame) this.cancelAnimationFrame();
                clearTimeout(this.blurTimeout);
                clearTimeout(this.animationTimeout);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var anchorNode = this.props.anchorNode;
                if (anchorNode !== prevProps.anchorNode) this.updateAnchorRect();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, props = (0, _objectWithoutProperties2["default"])(_this$props2, [
                    "children"
                ]);
                var _this$state = this.state, anchorRect = _this$state.anchorRect, popoverRect = _this$state.popoverRect, viewportRect = _this$state.viewportRect, render = _this$state.render;
                var _getBestOrigin = (0, _utils.getBestOrigin)({
                    anchorOrigin: (0, _parsers.parseAlignment)(this.props.anchorOrigin),
                    popoverOrigin: (0, _parsers.parseAlignment)(this.props.popoverOrigin),
                    extraSpace: {
                        x: props.offsetHorizontal + viewportPadding,
                        y: props.offsetVertical + viewportPadding
                    },
                    anchorRect: anchorRect,
                    popoverRect: popoverRect,
                    viewportRect: viewportRect
                }), anchorOrigin = _getBestOrigin.anchorOrigin, popoverOrigin = _getBestOrigin.popoverOrigin, availableSpace = _getBestOrigin.availableSpace;
                return /*#__PURE__*/ _react["default"].createElement(_transitionController["default"], {
                    "in": props.open && Boolean(props.anchorNode),
                    duration: parseInt(popoverMotionDuration),
                    onBeforeEnter: this.onBeforeOpen,
                    onEnter: this.onOpen,
                    onAfterExit: this.onAfterClose
                }, function(state) {
                    return render ? /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, children({
                        popoverState: state,
                        popoverStyle: styles({
                            shrinkToFit: props.shrinkToFit,
                            offsetHorizontal: props.offsetHorizontal,
                            offsetVertical: props.offsetVertical,
                            maxHeight: props.maxHeight,
                            maxWidth: props.maxWidth,
                            state: state,
                            anchorOrigin: anchorOrigin,
                            popoverOrigin: popoverOrigin,
                            anchorRect: anchorRect,
                            popoverRect: popoverRect,
                            viewportRect: viewportRect,
                            availableSpace: availableSpace
                        }),
                        popoverOrigin: popoverOrigin,
                        anchorOrigin: anchorOrigin,
                        anchorRect: anchorRect
                    })) : null;
                });
            }
        }
    ]);
    return PopoverController;
}(_react["default"].Component);
(0, _defineProperty2["default"])(PopoverController, "defaultProps", {
    offsetHorizontal: 0,
    offsetVertical: 0,
    onBeforeOpen: _noop["default"],
    onOpen: _noop["default"],
    onClose: _noop["default"]
});
PopoverController.propTypes = {};
var _default = PopoverController;
exports["default"] = _default;

},{"d490174dfdffefbb":"fk2Bw","518466e4b73e423e":"4vNTP","e185a31aaa5e2445":"5Yd3f","cfb1ef22ad8258d3":"6Jptv","d02f4c6ddeda1d40":"lMa5o","a1c3fc1505445627":"j4mqF","19e5daa480cf0ec1":"krVd4","eafddc40fad820b9":"8h5p9","8a930d1952303213":"hcG56","f83ba91cfda9b1ba":"6uln9","da8900a3da9cce4e":"b8T3j","f5f07936b01f687a":"cnMFu","904e6d2c8e1a61a6":"7osqO","aedc63c3d9b020e9":"lnaFx","ca05b16d3c473ef6":"6abrw","d9cabb4bf6293f7e":"64SHp","9008f5d0c992a242":"elia7","3af7217137bd62d2":"ihBLX","b96d114917c68243":"aSMp2","56bcf612dd80fdc4":"asAYl","f05bfc7e1b4903e0":"fDQaK","591761b0ade43087":"5w49g","db3abb05ef0fba92":"atHRo"}],"4vNTP":[function(require,module,exports) {
var objectWithoutPropertiesLoose = require("4555806b46b076b8");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = _objectWithoutProperties;

},{"4555806b46b076b8":"75UH8"}],"75UH8":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose;

},{}],"6abrw":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f06eccbb6d9f3a55");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBestOrigin = exports.getAvailableSpace = exports.flipOrigin = exports.flipAlignment = void 0;
var _defineProperty2 = _interopRequireDefault(require("40340d66e2c71cb1"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Flip an alignment string (e.g. from "top" to "bottom" etc)
 */ var flipAlignment = function flipAlignment(alignment) {
    return ({
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left",
        center: "center"
    })[alignment];
};
/**
 * Flip an origin (in the form of { x: "left", y: "bottom"}) across either one
 * or both axis.
 */ exports.flipAlignment = flipAlignment;
var flipOrigin = function flipOrigin(origin, flipX, flipY) {
    return {
        x: flipX ? flipAlignment(origin.x) : origin.x,
        y: flipY ? flipAlignment(origin.y) : origin.y
    };
};
/**
 * Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
 * any arbitrary extra space, and an axis, determine how much space is available
 * in the viewport along the provided axis to render a popover.
 */ exports.flipOrigin = flipOrigin;
var getAvailableSpaceOnAxis = function getAvailableSpaceOnAxis(axis, _ref) {
    var anchorOrigin = _ref.anchorOrigin, popoverOrigin = _ref.popoverOrigin, anchorRect = _ref.anchorRect, viewportRect = _ref.viewportRect, extraSpace = _ref.extraSpace;
    var edge = axis === "x" ? "left" : "top";
    var dimension = axis === "x" ? "width" : "height";
    var oppositeEdge = flipAlignment(edge); // Determine the position along the requested axis in the viewport that
    // represents the edge of the available space for the popover
    var popoverEdge = anchorOrigin[axis] === edge ? anchorRect[edge] : anchorOrigin[axis] === oppositeEdge ? anchorRect[edge] + anchorRect[dimension] : anchorOrigin[axis] === "center" ? anchorRect[edge] + anchorRect[dimension] / 2 : undefined; // Calculate the available space along the requested axis that the popover can
    // use to render
    var availableSpace = popoverOrigin[axis] === edge ? viewportRect[dimension] - popoverEdge - extraSpace[axis] : popoverOrigin[axis] === oppositeEdge ? popoverEdge - extraSpace[axis] : popoverOrigin[axis] === "center" ? 2 * (Math.min(viewportRect[dimension] - popoverEdge, popoverEdge) - extraSpace[axis]) : undefined;
    return Math.max(0, availableSpace);
}; // Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
// and any arbitrary extra space, determine how much space is available in the
// viewport to render a popover.
var getAvailableSpace = function getAvailableSpace(args) {
    return {
        x: getAvailableSpaceOnAxis("x", args),
        y: getAvailableSpaceOnAxis("y", args)
    };
};
/**
 * Given an axis and a bunch of other information, this determines the
 * transform that, when applied to the popover and anchor origins, will result
 * in the best origins to display the popover. The transform will either be a
 * shift left or right (or up or down) along the axis (e.g. center -> left or
 * center -> right) or a flip across the axis entirely (to the other side of the
 * anchor).
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 */ exports.getAvailableSpace = getAvailableSpace;
var getBestOriginTransformOnAxis = function getBestOriginTransformOnAxis(axis, args) {
    var getSpace = function getSpace(anchorOrigin, popoverOrigin) {
        return getAvailableSpaceOnAxis(axis, _objectSpread(_objectSpread({}, args), {}, {
            anchorOrigin: anchorOrigin,
            popoverOrigin: popoverOrigin
        }));
    };
    var edge = axis === "x" ? "left" : "top";
    var dimension = axis === "x" ? "width" : "height";
    var oppositeEdge = flipAlignment(edge);
    var spaceWithPreferredOrigin = getSpace(args.anchorOrigin, args.popoverOrigin);
    var preferredOriginIsGood = spaceWithPreferredOrigin >= args.popoverRect[dimension]; // If the popover is center-aligned on the anchor then try shifting it
    // left/right or up/down (depending on the axis)
    var tryShift = args.popoverOrigin[axis] === "center" && args.anchorOrigin[axis] === "center" && !preferredOriginIsGood;
    var spaceShiftedStart = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge))) : 0;
    var spaceShiftedEnd = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge))) : 0;
    var shift = spaceShiftedStart > spaceWithPreferredOrigin && spaceShiftedStart > spaceShiftedEnd ? edge : spaceShiftedEnd > spaceWithPreferredOrigin ? oppositeEdge : undefined; // If shifting didn't work then try flipping the popover over the axis
    // entirely (to the other side of the anchor).
    var tryFlip = !preferredOriginIsGood && !shift;
    var flip = tryFlip && getSpace(flipOrigin(args.anchorOrigin, axis === "x", axis === "y"), flipOrigin(args.popoverOrigin, axis === "x", axis === "y")) > spaceWithPreferredOrigin;
    return shift ? {
        type: "shift",
        axis: axis,
        alignment: shift
    } : flip ? {
        type: "flip",
        axis: axis
    } : {
        type: "none"
    };
};
/**
 * This is used to apply a transform from `getBestOriginTransformOnAxis` to an
 * origin object.
 */ var transformOrigin = function transformOrigin(transform, origin) {
    switch(transform.type){
        case "shift":
            return _objectSpread(_objectSpread({}, origin), {}, (0, _defineProperty2["default"])({}, transform.axis, transform.alignment));
        case "flip":
            return flipOrigin(origin, transform.axis === "x", transform.axis === "y");
        default:
            return origin;
    }
};
/**
 * Determine the anchor and popover origins that will work best for displaying
 * the popover. If there is enough space to show the popover at the origins
 * requested by the user then that will always be treated as the best option.
 * If there is not enough space at those origins *and* there are alternate
 * origins that will buy us more space, the origins that will give us the most
 * space are treated as the best option.
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 *
 * Note that a popover may be shifted side to side or flipped over it's anchor
 * entirely, but it will never moved to an adjacent side (e.g. from the left to
 * the top). Designers/developers should be able to choose good enough defaults
 * for their popovers that this kind of transform won't be necessary to render
 * the popovers within the viewport.
 */ var getBestOrigin = function getBestOrigin(args) {
    // Determine the transforms along the x and y axis that will result in the
    // best display of the popover (not running off any edges of the viewport).
    var transformX = getBestOriginTransformOnAxis("x", args);
    var transformY = getBestOriginTransformOnAxis("y", args); // Apply the transforms to both the anchor origin and the popover origin
    var bestAnchorOrigin = transformOrigin(transformY, transformOrigin(transformX, args.anchorOrigin));
    var bestPopoverOrigin = transformOrigin(transformY, transformOrigin(transformX, args.popoverOrigin)); // Return the new origins along with the available space that they obtained
    // for the popover
    return {
        anchorOrigin: bestAnchorOrigin,
        popoverOrigin: bestPopoverOrigin,
        availableSpace: getAvailableSpace(_objectSpread(_objectSpread({}, args), {}, {
            anchorOrigin: bestAnchorOrigin,
            popoverOrigin: bestPopoverOrigin
        }))
    };
};
exports.getBestOrigin = getBestOrigin;

},{"f06eccbb6d9f3a55":"fk2Bw","40340d66e2c71cb1":"hcG56"}],"asAYl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var addDebouncedEventListener = function addDebouncedEventListener(node, event, listener, options) {
    var timeout = null;
    var debouncedListener = function debouncedListener(event) {
        window.cancelAnimationFrame(timeout);
        if (window && window.requestAnimationFrame) timeout = window.requestAnimationFrame(function() {
            return listener(event);
        });
    };
    if (node && node.addEventListener) node.addEventListener(event, debouncedListener, options);
    return function() {
        window.cancelAnimationFrame(timeout);
        if (node && node.removeEventListener) node.removeEventListener(event, debouncedListener, options);
    };
};
var _default = addDebouncedEventListener;
exports["default"] = _default;

},{}],"5w49g":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNodeBounds = exports.compareNodeBounds = exports.emptyNodeBounds = void 0;
var emptyNodeBounds = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
};
exports.emptyNodeBounds = emptyNodeBounds;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Check to see if two rectangles, defined by top/left origin and width/height,
 * are equal.
 */ var compareNodeBounds = function compareNodeBounds(a, b) {
    return a === b || a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
};
/**
 * This returns a rectangle from a DOM node that represents the size and
 * position of the node relative to the viewport. If the node does not exist
 * then an empty rectangle is returned. Note that the width and height do not
 * take any CSS scale transforms into account.
 */ exports.compareNodeBounds = compareNodeBounds;
var getNodeBounds = function getNodeBounds(node) {
    if (!canUseDOM) return emptyNodeBounds;
    else if (node === window) {
        var width = window.innerWidth;
        var height = window.innerHeight;
        return {
            top: 0,
            left: 0,
            width: width,
            height: height
        };
    } else if (node === document.documentElement) {
        // For the document element, getBoundingClientRect() will return scroll
        // offset instead of actual position for top/left values (in all browsers
        // except edge). This is inconsistent with the function's behavior for other
        // nodes (in all browsers except edge). Resolve this by just assuming the
        // top/left of the document element is 0/0 (true in all cases except for
        // when the "html" tag has been repositioned with CSS, which is rare).
        var _node$getBoundingClie = node.getBoundingClientRect(), _width = _node$getBoundingClie.width, _height = _node$getBoundingClie.height;
        return {
            top: 0,
            left: 0,
            width: _width,
            height: _height
        };
    } else if (node && node.getBoundingClientRect) {
        // For normal nodes, get the width and height from offsetWidth and
        // offsetHeight instead of getBoundingClientRect. This will ignore any CSS
        // scale transforms that are applied.
        var _width2 = node.offsetWidth;
        var _height2 = node.offsetHeight;
        var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top, left = _node$getBoundingClie2.left;
        return {
            top: top,
            left: left,
            width: _width2,
            height: _height2
        };
    } else return emptyNodeBounds;
};
exports.getNodeBounds = getNodeBounds;

},{}],"bFX3A":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5f46f4ba46f72ef7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _bottomSheet = _interopRequireDefault(require("e615634a17196484"));
var _default = _bottomSheet["default"];
exports["default"] = _default;

},{"5f46f4ba46f72ef7":"fk2Bw","e615634a17196484":"hz7Ol"}],"hz7Ol":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("465e1f9aea15f399");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("8ed974555a0b4bb8"));
var _createClass2 = _interopRequireDefault(require("ee670455574643f0"));
var _inherits2 = _interopRequireDefault(require("2f3c5f1b5bec7489"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("5bb639181817dab2"));
var _getPrototypeOf2 = _interopRequireDefault(require("23df5716ac754f2"));
var _defineProperty2 = _interopRequireDefault(require("a7bc9efe2a3c018d"));
var _react = _interopRequireDefault(require("bcd243818904f340"));
var _propTypes = _interopRequireDefault(require("e30510ff9ceb50f9"));
var _emotion = require("2d7f5d232d51f133");
var _noop = _interopRequireDefault(require("9b7949d1b61ae1df"));
var _bottomSheet = _interopRequireDefault(require("adac2b81a3a3e9dc"));
var _close = _interopRequireDefault(require("8d88e8c75dc46a61"));
var _theme = require("b557740c4939fd31");
var _sheet = _interopRequireDefault(require("513e2b149e57165"));
var _button = _interopRequireDefault(require("db2a60fde48fa865"));
var _icon = _interopRequireDefault(require("c7a1512fdcdfd9fe"));
var _token = require("242b32fa49384072");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var buttonWrapperStyles = (0, _emotion.css)({
    textAlign: "right"
});
/**
 * Render an element that provides access to secondary information via a sheet
 * that slides up from the bottom of the viewport.
 *
 * NOTICE: BottomSheet will be deprecated in the next major release 6.x in favor
 * of using [Sheet](https://meridian.a2z.com/components/sheet/).
 */ var BottomSheet = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(BottomSheet, _React$Component);
    var _super = _createSuper(BottomSheet);
    function BottomSheet() {
        (0, _classCallCheck2["default"])(this, BottomSheet);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(BottomSheet, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _bottomSheet["default"],
                    map: (0, _token.getTokenHelper)("bottomSheet")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_sheet["default"], {
                        open: props.open,
                        type: "overlay",
                        side: "bottom",
                        spacingInset: props.type === "modalWithControls" ? "small" : "none",
                        backgroundColor: t("backgroundColor"),
                        motionDuration: parseInt(t("motionTiming")),
                        motionFunction: t("motionFunction"),
                        onClose: props.onClose,
                        onOpen: props.onOpen,
                        id: props.id,
                        labelledById: props.labelledById,
                        describedById: props.describedById,
                        onFocus: props.onFocus,
                        onBlur: props.onBlur,
                        onKeyDown: props.onKeyDown
                    }, props.type === "modalWithControls" ? /*#__PURE__*/ _react["default"].createElement("div", {
                        className: buttonWrapperStyles
                    }, /*#__PURE__*/ _react["default"].createElement(_button["default"], {
                        type: "icon",
                        onClick: props.onClose,
                        size: "small"
                    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                        tokens: _close["default"]
                    }, props.closeLabel))) : null, /*#__PURE__*/ _react["default"].createElement("div", null, props.children));
                });
            }
        }
    ]);
    return BottomSheet;
}(_react["default"].Component);
(0, _defineProperty2["default"])(BottomSheet, "defaultProps", {
    type: "modal",
    onOpen: _noop["default"],
    closeLabel: "Close"
});
BottomSheet.propTypes = {};
var _default = BottomSheet;
exports["default"] = _default;

},{"465e1f9aea15f399":"fk2Bw","8ed974555a0b4bb8":"5Yd3f","ee670455574643f0":"6Jptv","2f3c5f1b5bec7489":"j4mqF","5bb639181817dab2":"krVd4","23df5716ac754f2":"8h5p9","a7bc9efe2a3c018d":"hcG56","bcd243818904f340":"6uln9","e30510ff9ceb50f9":"cnMFu","2d7f5d232d51f133":"4deck","9b7949d1b61ae1df":"7osqO","adac2b81a3a3e9dc":"gvycM","8d88e8c75dc46a61":"2AQYC","b557740c4939fd31":"eM9hO","513e2b149e57165":"8SQYx","db2a60fde48fa865":"gJQuD","c7a1512fdcdfd9fe":"jPx5F","242b32fa49384072":"atHRo"}],"gvycM":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        bottomSheetMinHeight: 40,
        bottomSheetSpacingInset: 8,
        bottomSheetElevation: 60,
        bottomSheetMotionTiming: "200ms",
        bottomSheetMotionFunction: "ease",
        bottomSheetBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
        bottomSheetShadowOffsetX: 0,
        bottomSheetShadowOffsetY: -4,
        bottomSheetShadowBlur: 8,
        bottomSheetShadowSpread: 0,
        bottomSheetShadowColor: "rgba(11, 12, 12, 0.16)"
    };
};

},{}],"8SQYx":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5c24a2117381bc1d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _sheet = _interopRequireDefault(require("d12034142ec35031"));
var _default = _sheet["default"];
exports["default"] = _default;

},{"5c24a2117381bc1d":"fk2Bw","d12034142ec35031":"5rVh6"}],"5rVh6":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("d9cb5f054a2924d8");
var _interopRequireDefault = require("c496aa2072d5fab4");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("adcb7dd2d9e421be"));
var _defineProperty2 = _interopRequireDefault(require("21ad5279c7236062"));
var _react = _interopRequireWildcard(require("76ee1dec734aa79e"));
var _keycode = _interopRequireDefault(require("6137d346a7a5f8a0"));
var _emotion = require("556a260ced711881");
var _propTypes = _interopRequireDefault(require("31a3771c75839cb0"));
var _sheet = _interopRequireDefault(require("8612d9da10447704"));
var _scrim = _interopRequireDefault(require("6d3de5bd314f970e"));
var _theme = require("3f12ef2c0e5eb4ae");
var _expanderController = _interopRequireDefault(require("e62e14ad96b20ddd"));
var _scrim2 = _interopRequireDefault(require("63e73a749738761"));
var _portal = _interopRequireDefault(require("8c171576c7abca5f"));
var _focusTrap = _interopRequireDefault(require("7264ab14fbdf75e2"));
var _useFocus2 = _interopRequireDefault(require("23d762fe2ff7c94"));
var _focus = require("aec0908ef5c9c248");
var _token = require("4d9afc6cb76f4145");
var _parsers = require("22a1533a8c4c6f2b");
var _filterPropsByPrefix = _interopRequireDefault(require("33bc3a3ee34ec6e3"));
var borderSides = {
    left: "borderRight",
    right: "borderLeft",
    bottom: "borderTop"
};
var containerStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var _css;
    var side = _ref.side, spacingInset = _ref.spacingInset, backgroundColor = _ref.backgroundColor;
    return (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, borderSides[side], t.borderCss("border")), (0, _defineProperty2["default"])(_css, "& > div", {
        backgroundColor: backgroundColor,
        padding: "".concat((0, _parsers.parseSpacing)(spacingInset), "px"),
        outline: "none",
        overflowY: "auto",
        boxSizing: "border-box",
        maxHeight: side === "bottom" ? "calc(100vh - ".concat(t("minimumPageReveal"), "px)") : undefined
    }), _css));
}, [
    "side",
    "spacingInset",
    "backgroundColor"
]);
var modalStyles = function modalStyles(tScrim, t, _ref2) {
    var _ref3;
    var side = _ref2.side;
    return (0, _emotion.css)({
        zIndex: tScrim("elevation") - 1,
        position: "fixed",
        boxShadow: "".concat(t("shadowOffset", [
            side,
            "x"
        ]), "px ").concat(t("shadowOffset", [
            side,
            "y"
        ]), "px ").concat(t("shadow", "blur"), "px ").concat(t("shadow", "spread"), "px ").concat(t("shadow", "color"), "}")
    }, side === "bottom" ? {
        bottom: 0,
        left: 0,
        right: 0
    } : (_ref3 = {
        top: 0
    }, (0, _defineProperty2["default"])(_ref3, side, 0), (0, _defineProperty2["default"])(_ref3, "bottom", 0), _ref3));
};
var overlayScrimStyles = function overlayScrimStyles(_ref4) {
    var tScrim = _ref4.tScrim;
    return (0, _emotion.css)({
        zIndex: tScrim("elevation") - 2
    });
}; // Overlay expanders are put into a portal
var OverlayExpanderController = function OverlayExpanderController(props) {
    return /*#__PURE__*/ _react["default"].createElement(_portal["default"], null, /*#__PURE__*/ _react["default"].createElement(_expanderController["default"], props));
};
/**
 * This component renders a sheet that enters/exits on a particular side of
 * the screen. The sheet can appear as a overlay above other components or
 * displace surrounding components.
 *
 * @since 5.x
 */ var Sheet = function Sheet(props) {
    var open = props.open, side = props.side, onClose = props.onClose, spacingInset = props.spacingInset, onOpen = props.onOpen; // Always render children if closed size is set greater than 0 or
    // we're explicitly told via props
    var alwaysRenderChildren = props.closedSize !== undefined && props.closedSize > 0 || props.alwaysRenderChildren; // If we're always visible, force type to be push
    var type = alwaysRenderChildren ? "push" : props.type;
    var t = (0, _theme.useTheme)(_sheet["default"], "sheet");
    var tScrim = (0, _theme.useTheme)(_scrim["default"], "scrim");
    var hasMounted = (0, _react.useRef)(false);
    var contentRef = (0, _react.useRef)(); // DOM node wrapping sheet content
    var anchorRef = (0, _react.useRef)(); // DOM element that originally opened sheet
    var initializeContentRef = (0, _react.useCallback)(function(contentProps) {
        return function(element) {
            contentRef.current = element;
            contentProps.ref(element);
        };
    }, []);
    var backgroundColor = (0, _react.useMemo)(function() {
        return (0, _token.getToken)(t.tokens, "themeBackground", [
            props.backgroundColor,
            "default"
        ]) || props.backgroundColor;
    }, [
        t,
        props.backgroundColor
    ]); // Put "overlay" sheets, which are essentially modals, in an expander that has built
    // in portal and focus trap.
    var Expander = (0, _react.useCallback)(function(props) {
        return /*#__PURE__*/ _react["default"].createElement(type === "overlay" ? OverlayExpanderController : _expanderController["default"], props);
    }, [
        type
    ]); // Put "overlay" sheets, which are essentially modals, in a focus trap
    var SheetWrapper = (0, _react.useCallback)(function(props) {
        return /*#__PURE__*/ _react["default"].createElement(type === "overlay" ? _focusTrap["default"] : _react["default"].Fragment, props);
    }, [
        type
    ]); // Overlay sheets are essentially modals. Here we add an keyboard listener
    // that closes the sheet when the user presses the "esc" key.
    // https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal
    (0, _react.useEffect)(function() {
        if (type === "overlay" && onClose) {
            var onKeyDown = function onKeyDown(e) {
                if ((0, _keycode["default"])(e) === "esc") onClose();
            };
            window.addEventListener("keydown", onKeyDown);
            return function() {
                return window.removeEventListener("keydown", onKeyDown);
            };
        }
    }, [
        type,
        onClose
    ]); // On open, move focus to the first focusable element. On close, move focus
    // back to the original element that opened the sheet.
    var onAfterOpen = (0, _react.useCallback)(function() {
        // Run this effect only after the component has mounted. Else, sheet
        // that load as `open` will immediately take over the active element.
        if (hasMounted.current && contentRef.current) {
            var firstFocusableNode = (0, _focus.getKeyboardFocusNodes)(contentRef.current)[0];
            if (firstFocusableNode) firstFocusableNode.focus();
            else contentRef.current.focus();
        }
    }, []); // On close, return focus to where it was before the bottom sheet was opened.
    var onAfterClose = (0, _react.useCallback)(function() {
        if (anchorRef.current) anchorRef.current.focus();
    }, []); // When opening, record which element opened the sheet
    (0, _react.useEffect)(function() {
        if (open) anchorRef.current = document.activeElement;
        hasMounted.current = true;
    }, [
        open
    ]);
    (0, _react.useEffect)(function() {
        if (open && onOpen) onOpen();
    }, [
        open,
        onOpen
    ]);
    var _useFocus = (0, _useFocus2["default"])({
        multipleNodes: true,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }), focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(Expander, {
        open: open,
        direction: side === "bottom" ? "down" : side,
        motionDuration: props.motionDuration || parseInt(t("motionTiming")),
        motionFunction: props.motionFunction || t("motionFunction"),
        onAfterOpen: onAfterOpen,
        onAfterClose: onAfterClose,
        alwaysRenderChildren: alwaysRenderChildren,
        closedSize: props.closedSize
    }, function(_ref5) {
        var state = _ref5.state, containerProps = _ref5.containerProps, contentProps = _ref5.contentProps;
        // The children of a sheet might be interested in the state of the expander
        // to dynamically hide/show components for various stages. For example, skinny
        // SideMenu shows different links based on the expander state.
        var children = typeof props.children === "function" ? props.children({
            expanderState: state
        }) : props.children;
        return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(SheetWrapper, null, /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
            className: (0, _emotion.cx)(props.className, containerStyles(t, {
                side: side,
                spacingInset: spacingInset,
                backgroundColor: backgroundColor
            }), type === "overlay" ? modalStyles(tScrim, t, {
                side: side
            }) : undefined, containerProps.className)
        }), /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: contentProps.className,
            id: props.id,
            ref: initializeContentRef(contentProps),
            role: type === "overlay" ? "dialog" : undefined,
            "aria-modal": type === "overlay" ? true : undefined,
            tabIndex: "-1",
            "aria-labelledby": props.labelledById,
            "aria-describedby": props.describedById,
            onKeyDown: props.onKeyDown
        }), children))), type === "overlay" ? /*#__PURE__*/ _react["default"].createElement(_scrim2["default"], {
            className: overlayScrimStyles({
                tScrim: tScrim
            }),
            onClick: props.onClose,
            open: state === "entering" || state === "entered",
            duration: t("motionTiming")
        }) : null);
    });
};
Sheet.displayName = "Sheet";
Sheet.propTypes = {};
Sheet.defaultProps = {
    type: "push",
    open: false,
    side: "right",
    spacingInset: "medium",
    backgroundColor: "alternatePrimary"
};
var _default = Sheet;
exports["default"] = _default;

},{"d9cb5f054a2924d8":"k8mdG","c496aa2072d5fab4":"fk2Bw","adcb7dd2d9e421be":"ef0K4","21ad5279c7236062":"hcG56","76ee1dec734aa79e":"6uln9","6137d346a7a5f8a0":"bL2S4","556a260ced711881":"4deck","31a3771c75839cb0":"cnMFu","8612d9da10447704":"gloX6","6d3de5bd314f970e":"i5KEc","3f12ef2c0e5eb4ae":"eM9hO","e62e14ad96b20ddd":"73fmK","63e73a749738761":"2kyXS","8c171576c7abca5f":"64SHp","7264ab14fbdf75e2":"K72GC","23d762fe2ff7c94":"ZdEsX","aec0908ef5c9c248":"iqUT6","4d9afc6cb76f4145":"atHRo","22a1533a8c4c6f2b":"aSMp2","33bc3a3ee34ec6e3":"8cR2N"}],"73fmK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9485eaec264b16");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _expanderController = _interopRequireDefault(require("9b36e6e5fe473b4e"));
var _default = _expanderController["default"];
exports["default"] = _default;

},{"9485eaec264b16":"fk2Bw","9b36e6e5fe473b4e":"dBOHN"}],"dBOHN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9e0f876a62a4a33f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("36fc77a2a298b253"));
var _classCallCheck2 = _interopRequireDefault(require("64bbc85cd4c117c0"));
var _createClass2 = _interopRequireDefault(require("a2a601fca43f6b20"));
var _assertThisInitialized2 = _interopRequireDefault(require("5164bbe9e7836ce9"));
var _inherits2 = _interopRequireDefault(require("1d9e6249c089e1d"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("74bf8f8656910a8a"));
var _getPrototypeOf2 = _interopRequireDefault(require("c1358ad57bddf9e8"));
var _defineProperty2 = _interopRequireDefault(require("13db7efb6cb607a2"));
var _react = _interopRequireDefault(require("2596c419b71bd583"));
var _propTypes = _interopRequireDefault(require("a9bd181c404c4816"));
var _emotion = require("c3f6326ee8d7d470");
var _transitionController = _interopRequireDefault(require("c38de3c0ebdb4a50"));
var _waitAnimationFrame = _interopRequireDefault(require("cac6bd7bf4dd3140"));
var _functional = require("308a824389c88de8");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var getSizeProperty = function getSizeProperty(direction) {
    return ({
        left: "width",
        right: "width",
        up: "height",
        down: "height"
    })[direction];
}; // The container element sets the width or height of the expander and handles
// the expanding and collapsing motion.
var containerStyles = (0, _functional.memoizeByKeys)(function(_ref) {
    var _css;
    var state = _ref.state, direction = _ref.direction, size = _ref.size, motionDuration = _ref.motionDuration, motionFunction = _ref.motionFunction, closedSize = _ref.closedSize;
    return (0, _emotion.css)({
        left: {
            // Horizontal expanders are inline-flex to ensure they shrink to fit
            // their children's width (vertical expanders shrink to fit by default
            // 'cause that's how CSS layout works).
            display: "inline-flex",
            // The up/left expanders use row/column-reverse so that content is fixed
            // to the bottom/right edges instead of top/left (the default).
            // NOTE: justifyContent: "flex-end" would work here instead *except* for
            // a bug in IE11: https://stackoverflow.com/questions/32885534/how-to-make-flex-end-work-in-ie11
            flexDirection: "row-reverse"
        },
        right: {
            display: "inline-flex",
            flexDirection: "row"
        },
        up: {
            display: "flex",
            flexDirection: "column-reverse"
        },
        down: {
            display: "flex",
            flexDirection: "column"
        }
    }[direction], (_css = {
        // Don't let a flex parent squish the expander
        flexShrink: 0
    }, (0, _defineProperty2["default"])(_css, getSizeProperty(direction), state === "entering" || state === "entered" ? size : closedSize), (0, _defineProperty2["default"])(_css, "overflow", "hidden"), (0, _defineProperty2["default"])(_css, "transition", motionDuration && motionFunction ? "".concat(getSizeProperty(direction), " ").concat(motionDuration, "ms ").concat(motionFunction) : undefined), (0, _defineProperty2["default"])(_css, "visibility", state === "exited" && closedSize === 0 ? "hidden" : undefined), (0, _defineProperty2["default"])(_css, "maxWidth", state === "exited" && (direction === "left" || direction === "right") ? closedSize : undefined), _css));
}, [
    "state",
    "direction",
    "size",
    "motionDuration",
    "motionFunction",
    "closedSize"
]); // The content element automatically holds its dimensions, even when the
// container is collapsed, so that the container knows what size to animate to.
var contentStyles = (0, _functional.memoize)(function(direction) {
    var _css2;
    return (0, _emotion.css)((_css2 = {}, (0, _defineProperty2["default"])(_css2, getSizeProperty(direction), "max-content"), (0, _defineProperty2["default"])(_css2, "flexShrink", 0), (0, _defineProperty2["default"])(_css2, "transform", "translateZ(0)"), _css2));
});
/* eslint-disable react/prop-types */ /**
 * This component makes it easy to animate the size of a content block from 0 to
 * "auto" and back. It handles some nice things like expanding in various
 * directions, keeping children out of the tab order when collapsed, setting an
 * aria-hidden attribute when collapsed, and correctly handling situations when
 * the dimensions of the expander contents change on the fly.
 *
 * This component doesn't render anything to the DOM itself, but it needs at
 * least two nested elements to work. To make this happen it requires that you
 * pass in children as a function. It will call that function, passing it an
 * object containing two more objects keyed under "containerProps" and
 * "contentProps". These objects should be passed through as props to two nested
 * elements by your children function (with the container element as the root of
 * the expander and the content element as the only child of the container).
 * This allows you to take advantage of the expander functionality while
 * maintaining maximum control over the DOM. Example:
 *
 * ```
 * <ExpanderController>
 *   {({ containerProps, contentProps }) => (
 *     <div {...containerProps}>
 *       <div {...contentProps}>
 *         My expandable content here...
 *       <div>
 *     </div>
 *   )}
 * </ExpanderController>
 * ```
 *
 * NOTE: Horizontal ExpanderControllers are inline elements, so extra attention
 * may be needed to avoid unwanted whitespace around them. A couple tricks for
 * removing whitespace include setting `font-size: 0` or `display: flex` on an
 * inline element's parent.
 */ var ExpanderControllerClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(ExpanderControllerClass, _React$Component);
    var _super = _createSuper(ExpanderControllerClass);
    function ExpanderControllerClass() {
        var _this;
        (0, _classCallCheck2["default"])(this, ExpanderControllerClass);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            size: undefined,
            render: _this.props.open || _this.props.alwaysRenderChildren
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContentRef", function(node) {
            return _this.contentRef = node;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelFixSize", function() {});
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixSize", function(done) {
            return _this.setState({
                size: _this.contentRef && _this.contentRef.getBoundingClientRect()[getSizeProperty(_this.props.direction)]
            }, done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function(done) {
            if (!_this.state.render) // If the children aren't rendered yet, do so and then give them a chance
            // to settle before poking through the DOM
            _this.setState({
                render: true
            }, function() {
                _this.cancelFixSize = (0, _waitAnimationFrame["default"])(function() {
                    return _this.fixSize(done);
                });
            });
            else _this.fixSize(done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterOpen", function() {
            _this.setState({
                size: undefined
            });
            if (_this.props.onAfterOpen) _this.props.onAfterOpen();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeClose", function(done) {
            _this.cancelFixSize();
            _this.fixSize(done);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function() {
            if (!_this.props.alwaysRenderChildren) _this.setState({
                render: false
            });
            if (_this.props.onAfterClose) _this.props.onAfterClose();
        });
        return _this;
    }
    (0, _createClass2["default"])(ExpanderControllerClass, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelFixSize();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, children = _this$props.children, props = (0, _objectWithoutProperties2["default"])(_this$props, [
                    "children"
                ]);
                var _this$state = this.state, size = _this$state.size, render = _this$state.render;
                return /*#__PURE__*/ _react["default"].createElement(_transitionController["default"], {
                    "in": props.open,
                    duration: props.motionDuration && props.motionFunction ? props.motionDuration : 0,
                    onBeforeEnter: this.onBeforeOpen,
                    onAfterEnter: this.onAfterOpen,
                    onBeforeExit: this.onBeforeClose,
                    onAfterExit: this.onAfterClose
                }, function(state) {
                    return render ? children({
                        state: state,
                        containerProps: {
                            className: containerStyles(_objectSpread(_objectSpread({}, props), {}, {
                                state: state,
                                size: size
                            })),
                            "aria-hidden": !props.closedSize && !props.open
                        },
                        contentProps: {
                            className: contentStyles(props.direction),
                            ref: _this2.updateContentRef
                        }
                    }) : null;
                });
            }
        }
    ]);
    return ExpanderControllerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change
var ExpanderController = function ExpanderController(props) {
    return /*#__PURE__*/ _react["default"].createElement(ExpanderControllerClass, props);
};
ExpanderController.propTypes = {};
ExpanderController.defaultProps = {
    closedSize: 0
};
var _default = ExpanderController;
exports["default"] = _default;

},{"9e0f876a62a4a33f":"fk2Bw","36fc77a2a298b253":"4vNTP","64bbc85cd4c117c0":"5Yd3f","a2a601fca43f6b20":"6Jptv","5164bbe9e7836ce9":"lMa5o","1d9e6249c089e1d":"j4mqF","74bf8f8656910a8a":"krVd4","c1358ad57bddf9e8":"8h5p9","13db7efb6cb607a2":"hcG56","2596c419b71bd583":"6uln9","a9bd181c404c4816":"cnMFu","c3f6326ee8d7d470":"4deck","c38de3c0ebdb4a50":"elia7","cac6bd7bf4dd3140":"fDQaK","308a824389c88de8":"eKpY2"}],"6Pkby":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1e95bf2870bb5c37");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _inputBox = _interopRequireDefault(require("ca3ab4c53b6860a6"));
var _default = _inputBox["default"];
exports["default"] = _default;

},{"1e95bf2870bb5c37":"fk2Bw","ca3ab4c53b6860a6":"i0Nsy"}],"i0Nsy":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("59da870d6e5171f8");
var _interopRequireDefault = require("2aed21a356f6fc5f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("8b19bcf7202ef6a4"));
var _react = _interopRequireWildcard(require("b9bcc1ef466c62e1"));
var _propTypes = _interopRequireDefault(require("462126ade8ab03e9"));
var _emotion = require("d3eb989c18468b3c");
var _input = _interopRequireDefault(require("cfe60c18cfd9780c"));
var _context = _interopRequireDefault(require("16e57631db39b950"));
var _theme = require("cfb8f65bb23ce814");
var _getIconCss = _interopRequireDefault(require("596307b0812d5561"));
var _token = require("c73b3638af4820d0");
var _focusRing = _interopRequireDefault(require("bc7a5e5e3ee47c46"));
var _text = _interopRequireDefault(require("c71d64ac96a4bc58"));
var _noTextWrap = _interopRequireDefault(require("75f9b37c5166b82d"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Styles
 */ /* Styles for the root element */ var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var cursor = _ref.cursor, size = _ref.size, focus = _ref.focus, error = _ref.error, disabled = _ref.disabled, width = _ref.width;
    var state = disabled ? "disabled" : focus ? "focus" : error ? "error" : "default";
    return (0, _emotion.css)((0, _text["default"])(t, {
        fontSize: size,
        lineHeight: "default",
        color: disabled ? "disabled" : "default"
    }), {
        display: "flex",
        boxSizing: "border-box",
        flexDirection: "row",
        justifyContent: "stretch",
        cursor: disabled ? "not-allowed" : cursor,
        borderRadius: t("borderRadius"),
        backgroundColor: t("backgroundColor", state),
        height: t("height", size),
        maxWidth: t("widthMax"),
        width: width,
        outline: "none",
        // If an explicit width is set then don't allow the input to flex
        flex: width ? "none !important" : undefined,
        borderWidth: t("borderWidth"),
        borderColor: t("borderColor", state),
        borderStyle: "solid"
    }, !disabled ? (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        error: error,
        offset: 1,
        dropShadow: true,
        borderWidth: t("focusRingBorderWidth"),
        borderRadius: t("borderRadius")
    }) : undefined);
}, [
    "cursor",
    "size",
    "focus",
    "error",
    "disabled",
    "width"
]);
/* Styles for each segment of the input (e.g. an endcap, an icon, the input
container) */ var columnStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var size = _ref2.size, label = _ref2.label;
    var horizontalPadding = t("spacingInsetHorizontal");
    var verticalPadding = t("spacingInsetVertical", size); // If we have a label then reduce the top padding until the label is the same
    // number of pixels from the top as the original top padding when it's floated
    // down over the input
    var topPadding = label && verticalPadding > 0 ? verticalPadding - t("labelFloatDistance", size) : verticalPadding;
    return (0, _emotion.css)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "".concat(topPadding, "px ").concat(horizontalPadding, "px ").concat(verticalPadding, "px ").concat(horizontalPadding, "px")
    });
}, [
    "size",
    "label"
]);
var endcapBorderRadius = function endcapBorderRadius(radius, side) {
    return side === "left" ? "".concat(radius, "px 0 0 ").concat(radius, "px") : "0 ".concat(radius, "px ").concat(radius, "px 0");
};
var endcapBorderShadow = function endcapBorderShadow(t, _ref3) {
    var state = _ref3.state, side = _ref3.side;
    return side === "left" ? " 1px 0 0 0 ".concat(t("borderColor", state)) : "-1px 0 0 0 ".concat(t("borderColor", state));
};
/* Styles for the prefix/suffix caps on either end of the input */ var endcapStyles = (0, _token.memoizeTokenStyles)(function(t, _ref4) {
    var disabled = _ref4.disabled, side = _ref4.side, size = _ref4.size, label = _ref4.label;
    var state = disabled ? "disabled" : "default";
    return (0, _emotion.css)(columnStyles(t, {
        size: size,
        label: label
    }), {
        flexShrink: 0,
        backgroundColor: t("endcapBackgroundColor"),
        borderRadius: endcapBorderRadius(t("endcapBorderRadius"), side),
        boxShadow: endcapBorderShadow(t, {
            state: state,
            side: side
        })
    }, _noTextWrap["default"]);
}, [
    "disabled",
    "side",
    "size",
    "label"
]);
/* Styles for everything in-between the endcaps */ // since the aislestyle and columnstyle shares the same attributes
// we can memoize them together
var aisleStyles = (0, _token.memoizeTokenStyles)(function(t, _ref5) {
    var size = _ref5.size, label = _ref5.label;
    return (0, _emotion.css)(columnStyles(t, {
        size: size,
        label: label
    }), {
        flex: "auto",
        overflow: "hidden"
    });
}, [
    "size",
    "label"
]);
var labelStyles = (0, _token.memoizeTokenStyles)(function(t, _ref6) {
    var animated = _ref6.animated, focus = _ref6.focus, disabled = _ref6.disabled, floated = _ref6.floated, size = _ref6.size;
    var colorState = disabled ? "disabled" : focus ? "focus" : "default";
    return (0, _emotion.css)({
        display: "block",
        cursor: "inherit",
        color: t("labelColor", colorState),
        fontSize: t("labelFontSizeDefault"),
        marginBottom: t("spacingVertical"),
        transformOrigin: "top left",
        transform: floated ? "translateY(0px) scale(".concat(t("labelFontSizeFloated") / t("labelFontSizeDefault"), ")") : "translateY(".concat(t("labelFloatDistance", size), "px) scale(1)"),
        transition: animated ? t.transitionCss("labelMotion", [
            "color",
            "transform"
        ]) : undefined
    }, _noTextWrap["default"]);
}, [
    "animated",
    "focus",
    "disabled",
    "floated",
    "size"
]);
var iconStyles = (0, _token.memoizeTokenStyles)(function(t, _ref7) {
    var tokens = _ref7.tokens, disabled = _ref7.disabled, position = _ref7.position;
    var state = disabled ? "disabled" : "default";
    var _getIconFromTokens = (0, _token.getIconFromTokens)(tokens), width = _getIconFromTokens.width, data = _getIconFromTokens.data;
    return (0, _emotion.css)({
        flexShrink: 0,
        width: width,
        margin: position === "prefix" ? "0 0 0 ".concat(t("spacingInsetHorizontal"), "px") : "0 ".concat(t("spacingInsetHorizontal"), "px 0 0"),
        backgroundImage: (0, _getIconCss["default"])(data, t("foregroundColor", state)),
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    });
}, [
    "tokens",
    "disabled",
    "position"
]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function(t, _ref8) {
    var size = _ref8.size, disabled = _ref8.disabled, empty = _ref8.empty, label = _ref8.label, floated = _ref8.floated;
    var state = disabled ? "disabled" : "default";
    return (0, _emotion.css)({
        position: "relative",
        color: empty ? t("placeholderColor", state) : undefined,
        minHeight: t("lineHeight", size),
        lineHeight: t("lineHeight", size),
        opacity: label && !floated ? 0 : 1,
        pointerEvents: disabled ? "none" : undefined
    });
}, [
    "size",
    "disabled",
    "empty",
    "label",
    "floated"
]);
/**
 * Component
 */ function InputBox(props) {
    var t = (0, _theme.useTheme)(_input["default"], "input");
    var _useContext = (0, _react.useContext)(_context["default"]), onFocus = _useContext.onFocus, onBlur = _useContext.onBlur;
    var styleProps = _objectSpread(_objectSpread({}, props), {}, {
        // If we have a label then the size must be at least "xlarge"
        size: props.label && props.size !== "xlarge" && props.size !== "auto" ? "xlarge" : props.size,
        floated: !props.label || (props.labelFloated !== undefined ? props.labelFloated : !props.empty || props.focus)
    });
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, styleProps),
        onMouseDown: props.onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        tabIndex: "-1"
    }, props.prefix ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            side: "left"
        }))
    }, props.prefix) : null, props.prefixIconTokens ? /*#__PURE__*/ _react["default"].createElement("div", {
        role: "img",
        "aria-hidden": "true",
        className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            tokens: props.prefixIconTokens,
            position: "prefix"
        }))
    }) : null, /*#__PURE__*/ _react["default"].createElement("div", {
        className: aisleStyles(t, styleProps)
    }, props.label ? /*#__PURE__*/ _react["default"].createElement("label", {
        className: labelStyles(t, styleProps),
        htmlFor: props.htmlFor
    }, props.label) : null, /*#__PURE__*/ _react["default"].createElement("div", {
        className: childrenStyles(t, styleProps)
    }, props.children)), props.suffixIconTokens ? /*#__PURE__*/ _react["default"].createElement("div", {
        role: "img",
        "aria-hidden": "true",
        className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            tokens: props.suffixIconTokens,
            position: "suffix"
        }))
    }) : null, props.suffix ? typeof props.suffix === "string" ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            side: "right"
        }))
    }, props.suffix) : props.suffix : null);
}
InputBox.propTypes = {};
InputBox.defaultProps = {
    size: "medium",
    cursor: "default",
    animated: true
};
var _default = InputBox;
exports["default"] = _default;

},{"59da870d6e5171f8":"k8mdG","2aed21a356f6fc5f":"fk2Bw","8b19bcf7202ef6a4":"hcG56","b9bcc1ef466c62e1":"6uln9","462126ade8ab03e9":"cnMFu","d3eb989c18468b3c":"4deck","cfe60c18cfd9780c":"gtfqn","16e57631db39b950":"bkCh1","cfb8f65bb23ce814":"eM9hO","596307b0812d5561":"33AK4","c73b3638af4820d0":"atHRo","bc7a5e5e3ee47c46":"7yXmF","c71d64ac96a4bc58":"13UMz","75f9b37c5166b82d":"2PXpH"}],"gtfqn":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        inputSpacingVertical: 4,
        inputSpacingInsetVerticalDefault: 0,
        inputSpacingInsetVerticalAuto: 12,
        inputSpacingInsetHorizontal: 12,
        inputHeightSmall: 32,
        inputHeightMedium: 40,
        inputHeightLarge: 48,
        inputHeightXlarge: 60,
        inputLineHeightDefault: "20px",
        inputLineHeightAuto: "24px",
        inputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
        inputForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
        inputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
        inputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled,
        inputBorderWidth: 1,
        inputBorderRadius: 4,
        inputBorderColorDefault: tokens.themeBorderPrimaryDefault,
        inputBorderColorDisabled: tokens.themeBorderPrimaryDisabled,
        inputFocusRingBorderWidth: 1,
        inputFocusRingBorderRadius: 4,
        inputBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
        inputBackgroundColorDisabled: tokens.themeBackgroundPrimaryDisabled,
        inputFontSizeDefault: 16,
        inputFontSizeSmall: 14,
        inputEndcapBorderWidth: 1,
        inputEndcapBorderRadius: 4,
        inputEndcapBackgroundColor: tokens.themeBackgroundTertiaryDefault,
        inputLabelFontSizeDefault: 16,
        inputLabelFontSizeFloated: 14,
        inputLabelColorDefault: tokens.themeForegroundSecondaryDefault,
        inputLabelColorFocus: tokens.themeForegroundPrimaryFocus,
        inputLabelColorDisabled: tokens.themeForegroundPrimaryDisabled,
        inputLabelFloatDistanceXlarge: 12,
        inputLabelFloatDistanceAuto: 4,
        inputLabelMotionDuration: "150ms",
        inputLabelMotionFunction: "ease"
    };
};

},{}],"bkCh1":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ff097b245ae2eec");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("5b32643c1b1ee9e9"));
var _default = /*#__PURE__*/ _react["default"].createContext({});
exports["default"] = _default;

},{"ff097b245ae2eec":"fk2Bw","5b32643c1b1ee9e9":"6uln9"}],"4qxnS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("297ae6ed219b9718");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _focus = _interopRequireDefault(require("25c390df4167a8b1"));
var _default = _focus["default"];
exports["default"] = _default;

},{"297ae6ed219b9718":"fk2Bw","25c390df4167a8b1":"ljgQK"}],"ljgQK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("184eb1012748e7ea");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("b1e8917d8727cf15"));
var _useFocus = _interopRequireDefault(require("d572835d11935b2b"));
/**
 * NOTE: This component is deprecated. Use the useFocus hook instead.
 */ var Focus = function Focus(_ref) {
    var children = _ref.children, disabled = _ref.disabled, multipleTargets = _ref.multipleTargets, onBlur = _ref.onBlur, onFocus = _ref.onFocus;
    var focus = (0, _useFocus["default"])({
        disabled: disabled,
        multipleNodes: multipleTargets,
        onBlur: onBlur,
        onFocus: onFocus
    });
    return children(focus);
};
Focus.displayName = "Focus";
Focus.propTypes = {
    children: _propTypes["default"].func.isRequired,
    /**
   * A bug in React means that onBlur is not called when an element with focus
   * is disabled. This prop allows you to manually inform the Focus component
   * when the element(s) that it manages are disabled so that it can turn off
   * its internal focus state. See: https://github.com/facebook/react/issues/9142
   */ disabled: _propTypes["default"].bool,
    /**
   * Turn this on if you are using this component to track the focus of
   * multiple elements.
   */ multipleTargets: _propTypes["default"].bool,
    /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */ onBlur: _propTypes["default"].func,
    /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */ onFocus: _propTypes["default"].func
};
var _default = Focus;
exports["default"] = _default;

},{"184eb1012748e7ea":"fk2Bw","b1e8917d8727cf15":"cnMFu","d572835d11935b2b":"ZdEsX"}],"2YAMz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = require("f803ccbf5e364d7a");
var _default = /*#__PURE__*/ (0, _react.createContext)({});
exports["default"] = _default;

},{"f803ccbf5e364d7a":"6uln9"}],"20xFV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var inputReset = function inputReset(_ref) {
    var textColor = _ref.textColor, placeholderColor = _ref.placeholderColor, empty = _ref.empty;
    return {
        display: "block",
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        width: "100%",
        color: textColor,
        WebkitTextFillColor: empty ? placeholderColor : textColor,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        outline: "none",
        // Base built-in style resets
        WebkitAppearance: "none",
        MozAppearance: "textfield",
        // Remove the clear button from search inputs
        "::-ms-clear": {
            display: "none"
        },
        "::-ms-reveal": {
            display: "none"
        },
        "::-webkit-search-decoration": {
            display: "none"
        },
        "::-webkit-search-cancel-button": {
            display: "none"
        },
        "::-webkit-search-results-button": {
            display: "none"
        },
        "::-webkit-search-results-decoration ": {
            display: "none"
        },
        // Remove the built-in error outline
        ":invalid": {
            boxShadow: "none"
        },
        ":-moz-submit-invalid": {
            boxShadow: "none"
        },
        ":-moz-ui-invalid": {
            boxShadow: "none"
        },
        // Remove the numeric input up/down buttons in webkit
        "::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: "0"
        },
        "::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: "0"
        },
        // Set the placeholder colors
        "::-moz-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        ":-moz-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        "::-ms-input-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        ":-ms-input-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        "::-webkit-input-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        "::placeholder": {
            opacity: "1",
            color: placeholderColor
        }
    };
};
var _default = inputReset;
exports["default"] = _default;

},{}],"4JPZf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
// These styles are helpful for visually hiding an element while still allowing
// the user to interact with it (e.g. hide an input but allow the user to focus
// on it by clicking on an associated label). Simply applying "display: none" to
// an input will tell the browser to ignore it completely and the user will not
// be able to interact with it at all. Having an invisible yet interactive
// element is useful for creating custom styled inputs that are backed by their
// native html counterparts under the hood or for presenting information to
// screen-readers only.
var visuallyHidden = {
    clip: "rect(0 0 0 0)",
    overflow: "hidden",
    position: "fixed",
    pointerEvents: "none",
    border: 0,
    width: 1,
    height: 1,
    opacity: 0
};
var _default = visuallyHidden;
exports["default"] = _default;

},{}],"9TPqN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("aa05afefb9b8905c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = require("727d1965e91bba1a");
var _response = require("1de96290fb193c6c");
var _FeedbackResponseState = require("2c051fd13cdb69d8");
var _UIState = _interopRequireDefault(require("b8ddeb0e930c02b0"));
function useResponse() {
    var response = (0, _react.useContext)(_FeedbackResponseState.feedbackResponse);
    var responseDispatch = (0, _react.useContext)(_FeedbackResponseState.updateResponse);
    var _useContext = (0, _react.useContext)(_UIState["default"]), uiDispatch = _useContext.dispatch;
    var saveFeedbackResponse = (0, _react.useCallback)(function(id, answer) {
        var action = (0, _response.saveResponse)(id, answer);
        responseDispatch(action);
    }, [
        responseDispatch,
        response
    ]);
    var initializeResponse = (0, _react.useCallback)(function(questions) {
        var action = (0, _response.initializeResponse)(questions);
        responseDispatch(action);
    }, [
        _response.initializeResponse,
        responseDispatch
    ]);
    var submitResponse = (0, _react.useCallback)(function(applicationId, feedbackIntent, userFeedback, sifProfileId) {
        (0, _response.submitResponse)(applicationId, feedbackIntent, userFeedback, sifProfileId)(uiDispatch);
    });
    return {
        response: response,
        saveFeedbackResponse: saveFeedbackResponse,
        submitResponse: submitResponse,
        initializeResponse: initializeResponse
    };
}
var _default = exports["default"] = useResponse;

},{"aa05afefb9b8905c":"bm29M","727d1965e91bba1a":"6uln9","1de96290fb193c6c":"azNAp","2c051fd13cdb69d8":"ijvRM","b8ddeb0e930c02b0":"VKPbn"}],"eNmlz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("59b94cbd430088f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _isArray = _interopRequireDefault(require("525134ce5e4b455c"));
/**
 * This function translates the answer to array even if it is a single value
 * Reason: Backend model is configured such that it will always consider multiple choice question as array
 * Though this is used for only multi select , adding the isSelectType so that we can extend the same function for other cases
 */ function formatAnswerBasedOnType(answer, isSelectType) {
    if (isSelectType && !(0, _isArray["default"])(answer)) return [
        answer
    ];
    return answer;
}
var _default = exports["default"] = formatAnswerBasedOnType;

},{"59b94cbd430088f":"bm29M","525134ce5e4b455c":"kvnX5"}],"7fVae":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("de6e86f9216b1adc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("1ac285279642dd05"));
var _text = _interopRequireDefault(require("ec40c40b3b0e52f9"));
var _propTypes = _interopRequireDefault(require("231cf2ae7f9fbb96"));
var _colorStyles = _interopRequireDefault(require("2ebfb4905597d41c"));
var _cg = require("2b10a7d9d88f5266");
/* eslint-disable max-len */ var Question = function Question(_ref) {
    var questionTextFormat = _ref.questionTextFormat, question = _ref.question, isMandatory = _ref.isMandatory;
    return /*#__PURE__*/ _react["default"].createElement(_text["default"], {
        type: questionTextFormat
    }, question, isMandatory && /*#__PURE__*/ _react["default"].createElement(_cg.CgAsterisk, {
        "aria-label": "required",
        color: _colorStyles["default"].REQUIRED
    }));
};
Question.propTypes = {
    questionTextFormat: _propTypes["default"].string.isRequired,
    question: _propTypes["default"].string.isRequired,
    isMandatory: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = Question;

},{"de6e86f9216b1adc":"bm29M","1ac285279642dd05":"6uln9","ec40c40b3b0e52f9":"6kD7p","231cf2ae7f9fbb96":"gJRKl","2ebfb4905597d41c":"6qWVP","2b10a7d9d88f5266":"kvLMm"}],"6qWVP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.colorStyles = void 0;
var colorStyles = exports.colorStyles = Object.freeze({
    DEFAULT: "#e4e5e9",
    ANGRY: "#f64d52",
    SAD: "#FF8C00",
    NEUTRAL: "#FCD116",
    SMILE: "#C8F526",
    HAPPY: "#99CC32",
    REQUIRED: "#ff0000",
    STAR: "#f7c221"
});
var _default = exports["default"] = colorStyles;

},{}],"kvLMm":[function(require,module,exports) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CgAbstract", ()=>CgAbstract);
parcelHelpers.export(exports, "CgAddR", ()=>CgAddR);
parcelHelpers.export(exports, "CgAdd", ()=>CgAdd);
parcelHelpers.export(exports, "CgAdidas", ()=>CgAdidas);
parcelHelpers.export(exports, "CgAirplane", ()=>CgAirplane);
parcelHelpers.export(exports, "CgAlarm", ()=>CgAlarm);
parcelHelpers.export(exports, "CgAlbum", ()=>CgAlbum);
parcelHelpers.export(exports, "CgAlignBottom", ()=>CgAlignBottom);
parcelHelpers.export(exports, "CgAlignCenter", ()=>CgAlignCenter);
parcelHelpers.export(exports, "CgAlignLeft", ()=>CgAlignLeft);
parcelHelpers.export(exports, "CgAlignMiddle", ()=>CgAlignMiddle);
parcelHelpers.export(exports, "CgAlignRight", ()=>CgAlignRight);
parcelHelpers.export(exports, "CgAlignTop", ()=>CgAlignTop);
parcelHelpers.export(exports, "CgAnchor", ()=>CgAnchor);
parcelHelpers.export(exports, "CgAppleWatch", ()=>CgAppleWatch);
parcelHelpers.export(exports, "CgArrangeBack", ()=>CgArrangeBack);
parcelHelpers.export(exports, "CgArrangeFront", ()=>CgArrangeFront);
parcelHelpers.export(exports, "CgArrowAlignH", ()=>CgArrowAlignH);
parcelHelpers.export(exports, "CgArrowAlignV", ()=>CgArrowAlignV);
parcelHelpers.export(exports, "CgArrowBottomLeftO", ()=>CgArrowBottomLeftO);
parcelHelpers.export(exports, "CgArrowBottomLeftR", ()=>CgArrowBottomLeftR);
parcelHelpers.export(exports, "CgArrowBottomLeft", ()=>CgArrowBottomLeft);
parcelHelpers.export(exports, "CgArrowBottomRightO", ()=>CgArrowBottomRightO);
parcelHelpers.export(exports, "CgArrowBottomRightR", ()=>CgArrowBottomRightR);
parcelHelpers.export(exports, "CgArrowBottomRight", ()=>CgArrowBottomRight);
parcelHelpers.export(exports, "CgArrowDownO", ()=>CgArrowDownO);
parcelHelpers.export(exports, "CgArrowDownR", ()=>CgArrowDownR);
parcelHelpers.export(exports, "CgArrowDown", ()=>CgArrowDown);
parcelHelpers.export(exports, "CgArrowLeftO", ()=>CgArrowLeftO);
parcelHelpers.export(exports, "CgArrowLeftR", ()=>CgArrowLeftR);
parcelHelpers.export(exports, "CgArrowLeft", ()=>CgArrowLeft);
parcelHelpers.export(exports, "CgArrowLongDownC", ()=>CgArrowLongDownC);
parcelHelpers.export(exports, "CgArrowLongDownE", ()=>CgArrowLongDownE);
parcelHelpers.export(exports, "CgArrowLongDownL", ()=>CgArrowLongDownL);
parcelHelpers.export(exports, "CgArrowLongDownR", ()=>CgArrowLongDownR);
parcelHelpers.export(exports, "CgArrowLongDown", ()=>CgArrowLongDown);
parcelHelpers.export(exports, "CgArrowLongLeftC", ()=>CgArrowLongLeftC);
parcelHelpers.export(exports, "CgArrowLongLeftE", ()=>CgArrowLongLeftE);
parcelHelpers.export(exports, "CgArrowLongLeftL", ()=>CgArrowLongLeftL);
parcelHelpers.export(exports, "CgArrowLongLeftR", ()=>CgArrowLongLeftR);
parcelHelpers.export(exports, "CgArrowLongLeft", ()=>CgArrowLongLeft);
parcelHelpers.export(exports, "CgArrowLongRightC", ()=>CgArrowLongRightC);
parcelHelpers.export(exports, "CgArrowLongRightE", ()=>CgArrowLongRightE);
parcelHelpers.export(exports, "CgArrowLongRightL", ()=>CgArrowLongRightL);
parcelHelpers.export(exports, "CgArrowLongRightR", ()=>CgArrowLongRightR);
parcelHelpers.export(exports, "CgArrowLongRight", ()=>CgArrowLongRight);
parcelHelpers.export(exports, "CgArrowLongUpC", ()=>CgArrowLongUpC);
parcelHelpers.export(exports, "CgArrowLongUpE", ()=>CgArrowLongUpE);
parcelHelpers.export(exports, "CgArrowLongUpL", ()=>CgArrowLongUpL);
parcelHelpers.export(exports, "CgArrowLongUpR", ()=>CgArrowLongUpR);
parcelHelpers.export(exports, "CgArrowLongUp", ()=>CgArrowLongUp);
parcelHelpers.export(exports, "CgArrowRightO", ()=>CgArrowRightO);
parcelHelpers.export(exports, "CgArrowRightR", ()=>CgArrowRightR);
parcelHelpers.export(exports, "CgArrowRight", ()=>CgArrowRight);
parcelHelpers.export(exports, "CgArrowTopLeftO", ()=>CgArrowTopLeftO);
parcelHelpers.export(exports, "CgArrowTopLeftR", ()=>CgArrowTopLeftR);
parcelHelpers.export(exports, "CgArrowTopLeft", ()=>CgArrowTopLeft);
parcelHelpers.export(exports, "CgArrowTopRightO", ()=>CgArrowTopRightO);
parcelHelpers.export(exports, "CgArrowTopRightR", ()=>CgArrowTopRightR);
parcelHelpers.export(exports, "CgArrowTopRight", ()=>CgArrowTopRight);
parcelHelpers.export(exports, "CgArrowUpO", ()=>CgArrowUpO);
parcelHelpers.export(exports, "CgArrowUpR", ()=>CgArrowUpR);
parcelHelpers.export(exports, "CgArrowUp", ()=>CgArrowUp);
parcelHelpers.export(exports, "CgArrowsBreakeH", ()=>CgArrowsBreakeH);
parcelHelpers.export(exports, "CgArrowsBreakeV", ()=>CgArrowsBreakeV);
parcelHelpers.export(exports, "CgArrowsExchangeAltV", ()=>CgArrowsExchangeAltV);
parcelHelpers.export(exports, "CgArrowsExchangeAlt", ()=>CgArrowsExchangeAlt);
parcelHelpers.export(exports, "CgArrowsExchangeV", ()=>CgArrowsExchangeV);
parcelHelpers.export(exports, "CgArrowsExchange", ()=>CgArrowsExchange);
parcelHelpers.export(exports, "CgArrowsExpandDownLeft", ()=>CgArrowsExpandDownLeft);
parcelHelpers.export(exports, "CgArrowsExpandDownRight", ()=>CgArrowsExpandDownRight);
parcelHelpers.export(exports, "CgArrowsExpandLeftAlt", ()=>CgArrowsExpandLeftAlt);
parcelHelpers.export(exports, "CgArrowsExpandLeft", ()=>CgArrowsExpandLeft);
parcelHelpers.export(exports, "CgArrowsExpandRightAlt", ()=>CgArrowsExpandRightAlt);
parcelHelpers.export(exports, "CgArrowsExpandRight", ()=>CgArrowsExpandRight);
parcelHelpers.export(exports, "CgArrowsExpandUpLeft", ()=>CgArrowsExpandUpLeft);
parcelHelpers.export(exports, "CgArrowsExpandUpRight", ()=>CgArrowsExpandUpRight);
parcelHelpers.export(exports, "CgArrowsHAlt", ()=>CgArrowsHAlt);
parcelHelpers.export(exports, "CgArrowsH", ()=>CgArrowsH);
parcelHelpers.export(exports, "CgArrowsMergeAltH", ()=>CgArrowsMergeAltH);
parcelHelpers.export(exports, "CgArrowsMergeAltV", ()=>CgArrowsMergeAltV);
parcelHelpers.export(exports, "CgArrowsScrollH", ()=>CgArrowsScrollH);
parcelHelpers.export(exports, "CgArrowsScrollV", ()=>CgArrowsScrollV);
parcelHelpers.export(exports, "CgArrowsShrinkH", ()=>CgArrowsShrinkH);
parcelHelpers.export(exports, "CgArrowsShrinkV", ()=>CgArrowsShrinkV);
parcelHelpers.export(exports, "CgArrowsVAlt", ()=>CgArrowsVAlt);
parcelHelpers.export(exports, "CgArrowsV", ()=>CgArrowsV);
parcelHelpers.export(exports, "CgAssign", ()=>CgAssign);
parcelHelpers.export(exports, "CgAsterisk", ()=>CgAsterisk);
parcelHelpers.export(exports, "CgAtlasian", ()=>CgAtlasian);
parcelHelpers.export(exports, "CgAttachment", ()=>CgAttachment);
parcelHelpers.export(exports, "CgAttribution", ()=>CgAttribution);
parcelHelpers.export(exports, "CgAwards", ()=>CgAwards);
parcelHelpers.export(exports, "CgBackspace", ()=>CgBackspace);
parcelHelpers.export(exports, "CgBandAid", ()=>CgBandAid);
parcelHelpers.export(exports, "CgBatteryEmpty", ()=>CgBatteryEmpty);
parcelHelpers.export(exports, "CgBatteryFull", ()=>CgBatteryFull);
parcelHelpers.export(exports, "CgBattery", ()=>CgBattery);
parcelHelpers.export(exports, "CgBee", ()=>CgBee);
parcelHelpers.export(exports, "CgBell", ()=>CgBell);
parcelHelpers.export(exports, "CgBitbucket", ()=>CgBitbucket);
parcelHelpers.export(exports, "CgBlock", ()=>CgBlock);
parcelHelpers.export(exports, "CgBmw", ()=>CgBmw);
parcelHelpers.export(exports, "CgBoard", ()=>CgBoard);
parcelHelpers.export(exports, "CgBolt", ()=>CgBolt);
parcelHelpers.export(exports, "CgBookmark", ()=>CgBookmark);
parcelHelpers.export(exports, "CgBorderAll", ()=>CgBorderAll);
parcelHelpers.export(exports, "CgBorderBottom", ()=>CgBorderBottom);
parcelHelpers.export(exports, "CgBorderLeft", ()=>CgBorderLeft);
parcelHelpers.export(exports, "CgBorderRight", ()=>CgBorderRight);
parcelHelpers.export(exports, "CgBorderStyleDashed", ()=>CgBorderStyleDashed);
parcelHelpers.export(exports, "CgBorderStyleDotted", ()=>CgBorderStyleDotted);
parcelHelpers.export(exports, "CgBorderStyleSolid", ()=>CgBorderStyleSolid);
parcelHelpers.export(exports, "CgBorderTop", ()=>CgBorderTop);
parcelHelpers.export(exports, "CgBot", ()=>CgBot);
parcelHelpers.export(exports, "CgBowl", ()=>CgBowl);
parcelHelpers.export(exports, "CgBox", ()=>CgBox);
parcelHelpers.export(exports, "CgBoy", ()=>CgBoy);
parcelHelpers.export(exports, "CgBrackets", ()=>CgBrackets);
parcelHelpers.export(exports, "CgBriefcase", ()=>CgBriefcase);
parcelHelpers.export(exports, "CgBrowse", ()=>CgBrowse);
parcelHelpers.export(exports, "CgBrowser", ()=>CgBrowser);
parcelHelpers.export(exports, "CgBrush", ()=>CgBrush);
parcelHelpers.export(exports, "CgBulb", ()=>CgBulb);
parcelHelpers.export(exports, "CgCPlusPlus", ()=>CgCPlusPlus);
parcelHelpers.export(exports, "CgCalculator", ()=>CgCalculator);
parcelHelpers.export(exports, "CgCalendarDates", ()=>CgCalendarDates);
parcelHelpers.export(exports, "CgCalendarDue", ()=>CgCalendarDue);
parcelHelpers.export(exports, "CgCalendarNext", ()=>CgCalendarNext);
parcelHelpers.export(exports, "CgCalendarToday", ()=>CgCalendarToday);
parcelHelpers.export(exports, "CgCalendarTwo", ()=>CgCalendarTwo);
parcelHelpers.export(exports, "CgCalendar", ()=>CgCalendar);
parcelHelpers.export(exports, "CgCalibrate", ()=>CgCalibrate);
parcelHelpers.export(exports, "CgCamera", ()=>CgCamera);
parcelHelpers.export(exports, "CgCap", ()=>CgCap);
parcelHelpers.export(exports, "CgCaptions", ()=>CgCaptions);
parcelHelpers.export(exports, "CgCardClubs", ()=>CgCardClubs);
parcelHelpers.export(exports, "CgCardDiamonds", ()=>CgCardDiamonds);
parcelHelpers.export(exports, "CgCardHearts", ()=>CgCardHearts);
parcelHelpers.export(exports, "CgCardSpades", ()=>CgCardSpades);
parcelHelpers.export(exports, "CgCarousel", ()=>CgCarousel);
parcelHelpers.export(exports, "CgCast", ()=>CgCast);
parcelHelpers.export(exports, "CgChanel", ()=>CgChanel);
parcelHelpers.export(exports, "CgChart", ()=>CgChart);
parcelHelpers.export(exports, "CgCheckO", ()=>CgCheckO);
parcelHelpers.export(exports, "CgCheckR", ()=>CgCheckR);
parcelHelpers.export(exports, "CgCheck", ()=>CgCheck);
parcelHelpers.export(exports, "CgChevronDoubleDownO", ()=>CgChevronDoubleDownO);
parcelHelpers.export(exports, "CgChevronDoubleDownR", ()=>CgChevronDoubleDownR);
parcelHelpers.export(exports, "CgChevronDoubleDown", ()=>CgChevronDoubleDown);
parcelHelpers.export(exports, "CgChevronDoubleLeftO", ()=>CgChevronDoubleLeftO);
parcelHelpers.export(exports, "CgChevronDoubleLeftR", ()=>CgChevronDoubleLeftR);
parcelHelpers.export(exports, "CgChevronDoubleLeft", ()=>CgChevronDoubleLeft);
parcelHelpers.export(exports, "CgChevronDoubleRightO", ()=>CgChevronDoubleRightO);
parcelHelpers.export(exports, "CgChevronDoubleRightR", ()=>CgChevronDoubleRightR);
parcelHelpers.export(exports, "CgChevronDoubleRight", ()=>CgChevronDoubleRight);
parcelHelpers.export(exports, "CgChevronDoubleUpO", ()=>CgChevronDoubleUpO);
parcelHelpers.export(exports, "CgChevronDoubleUpR", ()=>CgChevronDoubleUpR);
parcelHelpers.export(exports, "CgChevronDoubleUp", ()=>CgChevronDoubleUp);
parcelHelpers.export(exports, "CgChevronDownO", ()=>CgChevronDownO);
parcelHelpers.export(exports, "CgChevronDownR", ()=>CgChevronDownR);
parcelHelpers.export(exports, "CgChevronDown", ()=>CgChevronDown);
parcelHelpers.export(exports, "CgChevronLeftO", ()=>CgChevronLeftO);
parcelHelpers.export(exports, "CgChevronLeftR", ()=>CgChevronLeftR);
parcelHelpers.export(exports, "CgChevronLeft", ()=>CgChevronLeft);
parcelHelpers.export(exports, "CgChevronRightO", ()=>CgChevronRightO);
parcelHelpers.export(exports, "CgChevronRightR", ()=>CgChevronRightR);
parcelHelpers.export(exports, "CgChevronRight", ()=>CgChevronRight);
parcelHelpers.export(exports, "CgChevronUpO", ()=>CgChevronUpO);
parcelHelpers.export(exports, "CgChevronUpR", ()=>CgChevronUpR);
parcelHelpers.export(exports, "CgChevronUp", ()=>CgChevronUp);
parcelHelpers.export(exports, "CgCircleci", ()=>CgCircleci);
parcelHelpers.export(exports, "CgClapperBoard", ()=>CgClapperBoard);
parcelHelpers.export(exports, "CgClipboard", ()=>CgClipboard);
parcelHelpers.export(exports, "CgCloseO", ()=>CgCloseO);
parcelHelpers.export(exports, "CgCloseR", ()=>CgCloseR);
parcelHelpers.export(exports, "CgClose", ()=>CgClose);
parcelHelpers.export(exports, "CgCloud", ()=>CgCloud);
parcelHelpers.export(exports, "CgCodeClimate", ()=>CgCodeClimate);
parcelHelpers.export(exports, "CgCodeSlash", ()=>CgCodeSlash);
parcelHelpers.export(exports, "CgCode", ()=>CgCode);
parcelHelpers.export(exports, "CgCoffee", ()=>CgCoffee);
parcelHelpers.export(exports, "CgCollage", ()=>CgCollage);
parcelHelpers.export(exports, "CgColorBucket", ()=>CgColorBucket);
parcelHelpers.export(exports, "CgColorPicker", ()=>CgColorPicker);
parcelHelpers.export(exports, "CgComedyCentral", ()=>CgComedyCentral);
parcelHelpers.export(exports, "CgComment", ()=>CgComment);
parcelHelpers.export(exports, "CgCommunity", ()=>CgCommunity);
parcelHelpers.export(exports, "CgComponents", ()=>CgComponents);
parcelHelpers.export(exports, "CgCompressLeft", ()=>CgCompressLeft);
parcelHelpers.export(exports, "CgCompressRight", ()=>CgCompressRight);
parcelHelpers.export(exports, "CgCompressV", ()=>CgCompressV);
parcelHelpers.export(exports, "CgCompress", ()=>CgCompress);
parcelHelpers.export(exports, "CgController", ()=>CgController);
parcelHelpers.export(exports, "CgCopy", ()=>CgCopy);
parcelHelpers.export(exports, "CgCopyright", ()=>CgCopyright);
parcelHelpers.export(exports, "CgCornerDoubleDownLeft", ()=>CgCornerDoubleDownLeft);
parcelHelpers.export(exports, "CgCornerDoubleDownRight", ()=>CgCornerDoubleDownRight);
parcelHelpers.export(exports, "CgCornerDoubleLeftDown", ()=>CgCornerDoubleLeftDown);
parcelHelpers.export(exports, "CgCornerDoubleLeftUp", ()=>CgCornerDoubleLeftUp);
parcelHelpers.export(exports, "CgCornerDoubleRightDown", ()=>CgCornerDoubleRightDown);
parcelHelpers.export(exports, "CgCornerDoubleRightUp", ()=>CgCornerDoubleRightUp);
parcelHelpers.export(exports, "CgCornerDoubleUpLeft", ()=>CgCornerDoubleUpLeft);
parcelHelpers.export(exports, "CgCornerDoubleUpRight", ()=>CgCornerDoubleUpRight);
parcelHelpers.export(exports, "CgCornerDownLeft", ()=>CgCornerDownLeft);
parcelHelpers.export(exports, "CgCornerDownRight", ()=>CgCornerDownRight);
parcelHelpers.export(exports, "CgCornerLeftDown", ()=>CgCornerLeftDown);
parcelHelpers.export(exports, "CgCornerLeftUp", ()=>CgCornerLeftUp);
parcelHelpers.export(exports, "CgCornerRightDown", ()=>CgCornerRightDown);
parcelHelpers.export(exports, "CgCornerRightUp", ()=>CgCornerRightUp);
parcelHelpers.export(exports, "CgCornerUpLeft", ()=>CgCornerUpLeft);
parcelHelpers.export(exports, "CgCornerUpRight", ()=>CgCornerUpRight);
parcelHelpers.export(exports, "CgCreditCard", ()=>CgCreditCard);
parcelHelpers.export(exports, "CgCrop", ()=>CgCrop);
parcelHelpers.export(exports, "CgCross", ()=>CgCross);
parcelHelpers.export(exports, "CgCrowdfire", ()=>CgCrowdfire);
parcelHelpers.export(exports, "CgCrown", ()=>CgCrown);
parcelHelpers.export(exports, "CgDanger", ()=>CgDanger);
parcelHelpers.export(exports, "CgDarkMode", ()=>CgDarkMode);
parcelHelpers.export(exports, "CgData", ()=>CgData);
parcelHelpers.export(exports, "CgDatabase", ()=>CgDatabase);
parcelHelpers.export(exports, "CgDebug", ()=>CgDebug);
parcelHelpers.export(exports, "CgDesignmodo", ()=>CgDesignmodo);
parcelHelpers.export(exports, "CgDesktop", ()=>CgDesktop);
parcelHelpers.export(exports, "CgDetailsLess", ()=>CgDetailsLess);
parcelHelpers.export(exports, "CgDetailsMore", ()=>CgDetailsMore);
parcelHelpers.export(exports, "CgDialpad", ()=>CgDialpad);
parcelHelpers.export(exports, "CgDice1", ()=>CgDice1);
parcelHelpers.export(exports, "CgDice2", ()=>CgDice2);
parcelHelpers.export(exports, "CgDice3", ()=>CgDice3);
parcelHelpers.export(exports, "CgDice4", ()=>CgDice4);
parcelHelpers.export(exports, "CgDice5", ()=>CgDice5);
parcelHelpers.export(exports, "CgDice6", ()=>CgDice6);
parcelHelpers.export(exports, "CgDigitalocean", ()=>CgDigitalocean);
parcelHelpers.export(exports, "CgDisc", ()=>CgDisc);
parcelHelpers.export(exports, "CgDisplayFlex", ()=>CgDisplayFlex);
parcelHelpers.export(exports, "CgDisplayFullwidth", ()=>CgDisplayFullwidth);
parcelHelpers.export(exports, "CgDisplayGrid", ()=>CgDisplayGrid);
parcelHelpers.export(exports, "CgDisplaySpacing", ()=>CgDisplaySpacing);
parcelHelpers.export(exports, "CgDistributeHorizontal", ()=>CgDistributeHorizontal);
parcelHelpers.export(exports, "CgDistributeVertical", ()=>CgDistributeVertical);
parcelHelpers.export(exports, "CgDockBottom", ()=>CgDockBottom);
parcelHelpers.export(exports, "CgDockLeft", ()=>CgDockLeft);
parcelHelpers.export(exports, "CgDockRight", ()=>CgDockRight);
parcelHelpers.export(exports, "CgDockWindow", ()=>CgDockWindow);
parcelHelpers.export(exports, "CgDolby", ()=>CgDolby);
parcelHelpers.export(exports, "CgDollar", ()=>CgDollar);
parcelHelpers.export(exports, "CgDribbble", ()=>CgDribbble);
parcelHelpers.export(exports, "CgDrive", ()=>CgDrive);
parcelHelpers.export(exports, "CgDropInvert", ()=>CgDropInvert);
parcelHelpers.export(exports, "CgDropOpacity", ()=>CgDropOpacity);
parcelHelpers.export(exports, "CgDrop", ()=>CgDrop);
parcelHelpers.export(exports, "CgDuplicate", ()=>CgDuplicate);
parcelHelpers.export(exports, "CgEditBlackPoint", ()=>CgEditBlackPoint);
parcelHelpers.export(exports, "CgEditContrast", ()=>CgEditContrast);
parcelHelpers.export(exports, "CgEditExposure", ()=>CgEditExposure);
parcelHelpers.export(exports, "CgEditFade", ()=>CgEditFade);
parcelHelpers.export(exports, "CgEditFlipH", ()=>CgEditFlipH);
parcelHelpers.export(exports, "CgEditFlipV", ()=>CgEditFlipV);
parcelHelpers.export(exports, "CgEditHighlight", ()=>CgEditHighlight);
parcelHelpers.export(exports, "CgEditMarkup", ()=>CgEditMarkup);
parcelHelpers.export(exports, "CgEditMask", ()=>CgEditMask);
parcelHelpers.export(exports, "CgEditNoise", ()=>CgEditNoise);
parcelHelpers.export(exports, "CgEditShadows", ()=>CgEditShadows);
parcelHelpers.export(exports, "CgEditStraight", ()=>CgEditStraight);
parcelHelpers.export(exports, "CgEditUnmask", ()=>CgEditUnmask);
parcelHelpers.export(exports, "CgEject", ()=>CgEject);
parcelHelpers.export(exports, "CgEnter", ()=>CgEnter);
parcelHelpers.export(exports, "CgErase", ()=>CgErase);
parcelHelpers.export(exports, "CgEreader", ()=>CgEreader);
parcelHelpers.export(exports, "CgEricsson", ()=>CgEricsson);
parcelHelpers.export(exports, "CgEthernet", ()=>CgEthernet);
parcelHelpers.export(exports, "CgEuro", ()=>CgEuro);
parcelHelpers.export(exports, "CgEventbrite", ()=>CgEventbrite);
parcelHelpers.export(exports, "CgExpand", ()=>CgExpand);
parcelHelpers.export(exports, "CgExport", ()=>CgExport);
parcelHelpers.export(exports, "CgExtensionAdd", ()=>CgExtensionAdd);
parcelHelpers.export(exports, "CgExtensionAlt", ()=>CgExtensionAlt);
parcelHelpers.export(exports, "CgExtensionRemove", ()=>CgExtensionRemove);
parcelHelpers.export(exports, "CgExtension", ()=>CgExtension);
parcelHelpers.export(exports, "CgExternal", ()=>CgExternal);
parcelHelpers.export(exports, "CgEyeAlt", ()=>CgEyeAlt);
parcelHelpers.export(exports, "CgEye", ()=>CgEye);
parcelHelpers.export(exports, "CgFacebook", ()=>CgFacebook);
parcelHelpers.export(exports, "CgFeed", ()=>CgFeed);
parcelHelpers.export(exports, "CgFigma", ()=>CgFigma);
parcelHelpers.export(exports, "CgFileAdd", ()=>CgFileAdd);
parcelHelpers.export(exports, "CgFileDocument", ()=>CgFileDocument);
parcelHelpers.export(exports, "CgFileRemove", ()=>CgFileRemove);
parcelHelpers.export(exports, "CgFile", ()=>CgFile);
parcelHelpers.export(exports, "CgFilm", ()=>CgFilm);
parcelHelpers.export(exports, "CgFilters", ()=>CgFilters);
parcelHelpers.export(exports, "CgFlagAlt", ()=>CgFlagAlt);
parcelHelpers.export(exports, "CgFlag", ()=>CgFlag);
parcelHelpers.export(exports, "CgFolderAdd", ()=>CgFolderAdd);
parcelHelpers.export(exports, "CgFolderRemove", ()=>CgFolderRemove);
parcelHelpers.export(exports, "CgFolder", ()=>CgFolder);
parcelHelpers.export(exports, "CgFontHeight", ()=>CgFontHeight);
parcelHelpers.export(exports, "CgFontSpacing", ()=>CgFontSpacing);
parcelHelpers.export(exports, "CgFormatBold", ()=>CgFormatBold);
parcelHelpers.export(exports, "CgFormatCenter", ()=>CgFormatCenter);
parcelHelpers.export(exports, "CgFormatColor", ()=>CgFormatColor);
parcelHelpers.export(exports, "CgFormatHeading", ()=>CgFormatHeading);
parcelHelpers.export(exports, "CgFormatIndentDecrease", ()=>CgFormatIndentDecrease);
parcelHelpers.export(exports, "CgFormatIndentIncrease", ()=>CgFormatIndentIncrease);
parcelHelpers.export(exports, "CgFormatItalic", ()=>CgFormatItalic);
parcelHelpers.export(exports, "CgFormatJustify", ()=>CgFormatJustify);
parcelHelpers.export(exports, "CgFormatLeft", ()=>CgFormatLeft);
parcelHelpers.export(exports, "CgFormatLineHeight", ()=>CgFormatLineHeight);
parcelHelpers.export(exports, "CgFormatRight", ()=>CgFormatRight);
parcelHelpers.export(exports, "CgFormatSeparator", ()=>CgFormatSeparator);
parcelHelpers.export(exports, "CgFormatSlash", ()=>CgFormatSlash);
parcelHelpers.export(exports, "CgFormatStrike", ()=>CgFormatStrike);
parcelHelpers.export(exports, "CgFormatText", ()=>CgFormatText);
parcelHelpers.export(exports, "CgFormatUnderline", ()=>CgFormatUnderline);
parcelHelpers.export(exports, "CgFormatUppercase", ()=>CgFormatUppercase);
parcelHelpers.export(exports, "CgFramer", ()=>CgFramer);
parcelHelpers.export(exports, "CgGames", ()=>CgGames);
parcelHelpers.export(exports, "CgGenderFemale", ()=>CgGenderFemale);
parcelHelpers.export(exports, "CgGenderMale", ()=>CgGenderMale);
parcelHelpers.export(exports, "CgGhostCharacter", ()=>CgGhostCharacter);
parcelHelpers.export(exports, "CgGhost", ()=>CgGhost);
parcelHelpers.export(exports, "CgGift", ()=>CgGift);
parcelHelpers.export(exports, "CgGirl", ()=>CgGirl);
parcelHelpers.export(exports, "CgGitBranch", ()=>CgGitBranch);
parcelHelpers.export(exports, "CgGitCommit", ()=>CgGitCommit);
parcelHelpers.export(exports, "CgGitFork", ()=>CgGitFork);
parcelHelpers.export(exports, "CgGitPull", ()=>CgGitPull);
parcelHelpers.export(exports, "CgGitter", ()=>CgGitter);
parcelHelpers.export(exports, "CgGlassAlt", ()=>CgGlassAlt);
parcelHelpers.export(exports, "CgGlass", ()=>CgGlass);
parcelHelpers.export(exports, "CgGlobeAlt", ()=>CgGlobeAlt);
parcelHelpers.export(exports, "CgGlobe", ()=>CgGlobe);
parcelHelpers.export(exports, "CgGoogleTasks", ()=>CgGoogleTasks);
parcelHelpers.export(exports, "CgGoogle", ()=>CgGoogle);
parcelHelpers.export(exports, "CgGym", ()=>CgGym);
parcelHelpers.export(exports, "CgHashtag", ()=>CgHashtag);
parcelHelpers.export(exports, "CgHeadset", ()=>CgHeadset);
parcelHelpers.export(exports, "CgHeart", ()=>CgHeart);
parcelHelpers.export(exports, "CgHello", ()=>CgHello);
parcelHelpers.export(exports, "CgHomeAlt", ()=>CgHomeAlt);
parcelHelpers.export(exports, "CgHomeScreen", ()=>CgHomeScreen);
parcelHelpers.export(exports, "CgHome", ()=>CgHome);
parcelHelpers.export(exports, "CgIcecream", ()=>CgIcecream);
parcelHelpers.export(exports, "CgIfDesign", ()=>CgIfDesign);
parcelHelpers.export(exports, "CgImage", ()=>CgImage);
parcelHelpers.export(exports, "CgImport", ()=>CgImport);
parcelHelpers.export(exports, "CgInbox", ()=>CgInbox);
parcelHelpers.export(exports, "CgIndieHackers", ()=>CgIndieHackers);
parcelHelpers.export(exports, "CgInfinity", ()=>CgInfinity);
parcelHelpers.export(exports, "CgInfo", ()=>CgInfo);
parcelHelpers.export(exports, "CgInpicture", ()=>CgInpicture);
parcelHelpers.export(exports, "CgInsertAfterO", ()=>CgInsertAfterO);
parcelHelpers.export(exports, "CgInsertAfterR", ()=>CgInsertAfterR);
parcelHelpers.export(exports, "CgInsertAfter", ()=>CgInsertAfter);
parcelHelpers.export(exports, "CgInsertBeforeO", ()=>CgInsertBeforeO);
parcelHelpers.export(exports, "CgInsertBeforeR", ()=>CgInsertBeforeR);
parcelHelpers.export(exports, "CgInsertBefore", ()=>CgInsertBefore);
parcelHelpers.export(exports, "CgInsights", ()=>CgInsights);
parcelHelpers.export(exports, "CgInstagram", ()=>CgInstagram);
parcelHelpers.export(exports, "CgInternal", ()=>CgInternal);
parcelHelpers.export(exports, "CgKey", ()=>CgKey);
parcelHelpers.export(exports, "CgKeyboard", ()=>CgKeyboard);
parcelHelpers.export(exports, "CgKeyhole", ()=>CgKeyhole);
parcelHelpers.export(exports, "CgLaptop", ()=>CgLaptop);
parcelHelpers.export(exports, "CgLastpass", ()=>CgLastpass);
parcelHelpers.export(exports, "CgLayoutGridSmall", ()=>CgLayoutGridSmall);
parcelHelpers.export(exports, "CgLayoutGrid", ()=>CgLayoutGrid);
parcelHelpers.export(exports, "CgLayoutList", ()=>CgLayoutList);
parcelHelpers.export(exports, "CgLayoutPin", ()=>CgLayoutPin);
parcelHelpers.export(exports, "CgLinear", ()=>CgLinear);
parcelHelpers.export(exports, "CgLink", ()=>CgLink);
parcelHelpers.export(exports, "CgListTree", ()=>CgListTree);
parcelHelpers.export(exports, "CgList", ()=>CgList);
parcelHelpers.export(exports, "CgLivePhoto", ()=>CgLivePhoto);
parcelHelpers.export(exports, "CgLoadbarAlt", ()=>CgLoadbarAlt);
parcelHelpers.export(exports, "CgLoadbarDoc", ()=>CgLoadbarDoc);
parcelHelpers.export(exports, "CgLoadbarSound", ()=>CgLoadbarSound);
parcelHelpers.export(exports, "CgLoadbar", ()=>CgLoadbar);
parcelHelpers.export(exports, "CgLockUnlock", ()=>CgLockUnlock);
parcelHelpers.export(exports, "CgLock", ()=>CgLock);
parcelHelpers.export(exports, "CgLogIn", ()=>CgLogIn);
parcelHelpers.export(exports, "CgLogOff", ()=>CgLogOff);
parcelHelpers.export(exports, "CgLogOut", ()=>CgLogOut);
parcelHelpers.export(exports, "CgLoupe", ()=>CgLoupe);
parcelHelpers.export(exports, "CgMagnet", ()=>CgMagnet);
parcelHelpers.export(exports, "CgMailForward", ()=>CgMailForward);
parcelHelpers.export(exports, "CgMailOpen", ()=>CgMailOpen);
parcelHelpers.export(exports, "CgMailReply", ()=>CgMailReply);
parcelHelpers.export(exports, "CgMail", ()=>CgMail);
parcelHelpers.export(exports, "CgMathDivide", ()=>CgMathDivide);
parcelHelpers.export(exports, "CgMathEqual", ()=>CgMathEqual);
parcelHelpers.export(exports, "CgMathMinus", ()=>CgMathMinus);
parcelHelpers.export(exports, "CgMathPercent", ()=>CgMathPercent);
parcelHelpers.export(exports, "CgMathPlus", ()=>CgMathPlus);
parcelHelpers.export(exports, "CgMaximizeAlt", ()=>CgMaximizeAlt);
parcelHelpers.export(exports, "CgMaximize", ()=>CgMaximize);
parcelHelpers.export(exports, "CgMaze", ()=>CgMaze);
parcelHelpers.export(exports, "CgMediaLive", ()=>CgMediaLive);
parcelHelpers.export(exports, "CgMediaPodcast", ()=>CgMediaPodcast);
parcelHelpers.export(exports, "CgMenuBoxed", ()=>CgMenuBoxed);
parcelHelpers.export(exports, "CgMenuCake", ()=>CgMenuCake);
parcelHelpers.export(exports, "CgMenuCheese", ()=>CgMenuCheese);
parcelHelpers.export(exports, "CgMenuGridO", ()=>CgMenuGridO);
parcelHelpers.export(exports, "CgMenuGridR", ()=>CgMenuGridR);
parcelHelpers.export(exports, "CgMenuHotdog", ()=>CgMenuHotdog);
parcelHelpers.export(exports, "CgMenuLeftAlt", ()=>CgMenuLeftAlt);
parcelHelpers.export(exports, "CgMenuLeft", ()=>CgMenuLeft);
parcelHelpers.export(exports, "CgMenuMotion", ()=>CgMenuMotion);
parcelHelpers.export(exports, "CgMenuOreos", ()=>CgMenuOreos);
parcelHelpers.export(exports, "CgMenuRightAlt", ()=>CgMenuRightAlt);
parcelHelpers.export(exports, "CgMenuRight", ()=>CgMenuRight);
parcelHelpers.export(exports, "CgMenuRound", ()=>CgMenuRound);
parcelHelpers.export(exports, "CgMenu", ()=>CgMenu);
parcelHelpers.export(exports, "CgMergeHorizontal", ()=>CgMergeHorizontal);
parcelHelpers.export(exports, "CgMergeVertical", ()=>CgMergeVertical);
parcelHelpers.export(exports, "CgMic", ()=>CgMic);
parcelHelpers.export(exports, "CgMicrobit", ()=>CgMicrobit);
parcelHelpers.export(exports, "CgMicrosoft", ()=>CgMicrosoft);
parcelHelpers.export(exports, "CgMiniPlayer", ()=>CgMiniPlayer);
parcelHelpers.export(exports, "CgMinimizeAlt", ()=>CgMinimizeAlt);
parcelHelpers.export(exports, "CgMinimize", ()=>CgMinimize);
parcelHelpers.export(exports, "CgModem", ()=>CgModem);
parcelHelpers.export(exports, "CgMonday", ()=>CgMonday);
parcelHelpers.export(exports, "CgMoon", ()=>CgMoon);
parcelHelpers.export(exports, "CgMoreAlt", ()=>CgMoreAlt);
parcelHelpers.export(exports, "CgMoreO", ()=>CgMoreO);
parcelHelpers.export(exports, "CgMoreR", ()=>CgMoreR);
parcelHelpers.export(exports, "CgMoreVerticalAlt", ()=>CgMoreVerticalAlt);
parcelHelpers.export(exports, "CgMoreVerticalO", ()=>CgMoreVerticalO);
parcelHelpers.export(exports, "CgMoreVerticalR", ()=>CgMoreVerticalR);
parcelHelpers.export(exports, "CgMoreVertical", ()=>CgMoreVertical);
parcelHelpers.export(exports, "CgMore", ()=>CgMore);
parcelHelpers.export(exports, "CgMouse", ()=>CgMouse);
parcelHelpers.export(exports, "CgMoveDown", ()=>CgMoveDown);
parcelHelpers.export(exports, "CgMoveLeft", ()=>CgMoveLeft);
parcelHelpers.export(exports, "CgMoveRight", ()=>CgMoveRight);
parcelHelpers.export(exports, "CgMoveTask", ()=>CgMoveTask);
parcelHelpers.export(exports, "CgMoveUp", ()=>CgMoveUp);
parcelHelpers.export(exports, "CgMusicNote", ()=>CgMusicNote);
parcelHelpers.export(exports, "CgMusicSpeaker", ()=>CgMusicSpeaker);
parcelHelpers.export(exports, "CgMusic", ()=>CgMusic);
parcelHelpers.export(exports, "CgNametag", ()=>CgNametag);
parcelHelpers.export(exports, "CgNotes", ()=>CgNotes);
parcelHelpers.export(exports, "CgNotifications", ()=>CgNotifications);
parcelHelpers.export(exports, "CgNpm", ()=>CgNpm);
parcelHelpers.export(exports, "CgOculus", ()=>CgOculus);
parcelHelpers.export(exports, "CgOpenCollective", ()=>CgOpenCollective);
parcelHelpers.export(exports, "CgOptions", ()=>CgOptions);
parcelHelpers.export(exports, "CgOrganisation", ()=>CgOrganisation);
parcelHelpers.export(exports, "CgOverflow", ()=>CgOverflow);
parcelHelpers.export(exports, "CgPacman", ()=>CgPacman);
parcelHelpers.export(exports, "CgPassword", ()=>CgPassword);
parcelHelpers.export(exports, "CgPathBack", ()=>CgPathBack);
parcelHelpers.export(exports, "CgPathCrop", ()=>CgPathCrop);
parcelHelpers.export(exports, "CgPathDivide", ()=>CgPathDivide);
parcelHelpers.export(exports, "CgPathExclude", ()=>CgPathExclude);
parcelHelpers.export(exports, "CgPathFront", ()=>CgPathFront);
parcelHelpers.export(exports, "CgPathIntersect", ()=>CgPathIntersect);
parcelHelpers.export(exports, "CgPathOutline", ()=>CgPathOutline);
parcelHelpers.export(exports, "CgPathTrim", ()=>CgPathTrim);
parcelHelpers.export(exports, "CgPathUnite", ()=>CgPathUnite);
parcelHelpers.export(exports, "CgPatreon", ()=>CgPatreon);
parcelHelpers.export(exports, "CgPaypal", ()=>CgPaypal);
parcelHelpers.export(exports, "CgPen", ()=>CgPen);
parcelHelpers.export(exports, "CgPentagonBottomLeft", ()=>CgPentagonBottomLeft);
parcelHelpers.export(exports, "CgPentagonBottomRight", ()=>CgPentagonBottomRight);
parcelHelpers.export(exports, "CgPentagonDown", ()=>CgPentagonDown);
parcelHelpers.export(exports, "CgPentagonLeft", ()=>CgPentagonLeft);
parcelHelpers.export(exports, "CgPentagonRight", ()=>CgPentagonRight);
parcelHelpers.export(exports, "CgPentagonTopLeft", ()=>CgPentagonTopLeft);
parcelHelpers.export(exports, "CgPentagonTopRight", ()=>CgPentagonTopRight);
parcelHelpers.export(exports, "CgPentagonUp", ()=>CgPentagonUp);
parcelHelpers.export(exports, "CgPerformance", ()=>CgPerformance);
parcelHelpers.export(exports, "CgPexels", ()=>CgPexels);
parcelHelpers.export(exports, "CgPhone", ()=>CgPhone);
parcelHelpers.export(exports, "CgPhotoscan", ()=>CgPhotoscan);
parcelHelpers.export(exports, "CgPiano", ()=>CgPiano);
parcelHelpers.export(exports, "CgPill", ()=>CgPill);
parcelHelpers.export(exports, "CgPinAlt", ()=>CgPinAlt);
parcelHelpers.export(exports, "CgPinBottom", ()=>CgPinBottom);
parcelHelpers.export(exports, "CgPinTop", ()=>CgPinTop);
parcelHelpers.export(exports, "CgPin", ()=>CgPin);
parcelHelpers.export(exports, "CgPlayBackwards", ()=>CgPlayBackwards);
parcelHelpers.export(exports, "CgPlayButtonO", ()=>CgPlayButtonO);
parcelHelpers.export(exports, "CgPlayButtonR", ()=>CgPlayButtonR);
parcelHelpers.export(exports, "CgPlayButton", ()=>CgPlayButton);
parcelHelpers.export(exports, "CgPlayForwards", ()=>CgPlayForwards);
parcelHelpers.export(exports, "CgPlayListAdd", ()=>CgPlayListAdd);
parcelHelpers.export(exports, "CgPlayListCheck", ()=>CgPlayListCheck);
parcelHelpers.export(exports, "CgPlayListRemove", ()=>CgPlayListRemove);
parcelHelpers.export(exports, "CgPlayListSearch", ()=>CgPlayListSearch);
parcelHelpers.export(exports, "CgPlayList", ()=>CgPlayList);
parcelHelpers.export(exports, "CgPlayPauseO", ()=>CgPlayPauseO);
parcelHelpers.export(exports, "CgPlayPauseR", ()=>CgPlayPauseR);
parcelHelpers.export(exports, "CgPlayPause", ()=>CgPlayPause);
parcelHelpers.export(exports, "CgPlayStopO", ()=>CgPlayStopO);
parcelHelpers.export(exports, "CgPlayStopR", ()=>CgPlayStopR);
parcelHelpers.export(exports, "CgPlayStop", ()=>CgPlayStop);
parcelHelpers.export(exports, "CgPlayTrackNextO", ()=>CgPlayTrackNextO);
parcelHelpers.export(exports, "CgPlayTrackNextR", ()=>CgPlayTrackNextR);
parcelHelpers.export(exports, "CgPlayTrackNext", ()=>CgPlayTrackNext);
parcelHelpers.export(exports, "CgPlayTrackPrevO", ()=>CgPlayTrackPrevO);
parcelHelpers.export(exports, "CgPlayTrackPrevR", ()=>CgPlayTrackPrevR);
parcelHelpers.export(exports, "CgPlayTrackPrev", ()=>CgPlayTrackPrev);
parcelHelpers.export(exports, "CgPlug", ()=>CgPlug);
parcelHelpers.export(exports, "CgPocket", ()=>CgPocket);
parcelHelpers.export(exports, "CgPokemon", ()=>CgPokemon);
parcelHelpers.export(exports, "CgPolaroid", ()=>CgPolaroid);
parcelHelpers.export(exports, "CgPoll", ()=>CgPoll);
parcelHelpers.export(exports, "CgPresentation", ()=>CgPresentation);
parcelHelpers.export(exports, "CgPrinter", ()=>CgPrinter);
parcelHelpers.export(exports, "CgProductHunt", ()=>CgProductHunt);
parcelHelpers.export(exports, "CgProfile", ()=>CgProfile);
parcelHelpers.export(exports, "CgPullClear", ()=>CgPullClear);
parcelHelpers.export(exports, "CgPushChevronDownO", ()=>CgPushChevronDownO);
parcelHelpers.export(exports, "CgPushChevronDownR", ()=>CgPushChevronDownR);
parcelHelpers.export(exports, "CgPushChevronDown", ()=>CgPushChevronDown);
parcelHelpers.export(exports, "CgPushChevronLeftO", ()=>CgPushChevronLeftO);
parcelHelpers.export(exports, "CgPushChevronLeftR", ()=>CgPushChevronLeftR);
parcelHelpers.export(exports, "CgPushChevronLeft", ()=>CgPushChevronLeft);
parcelHelpers.export(exports, "CgPushChevronRightO", ()=>CgPushChevronRightO);
parcelHelpers.export(exports, "CgPushChevronRightR", ()=>CgPushChevronRightR);
parcelHelpers.export(exports, "CgPushChevronRight", ()=>CgPushChevronRight);
parcelHelpers.export(exports, "CgPushChevronUpO", ()=>CgPushChevronUpO);
parcelHelpers.export(exports, "CgPushChevronUpR", ()=>CgPushChevronUpR);
parcelHelpers.export(exports, "CgPushChevronUp", ()=>CgPushChevronUp);
parcelHelpers.export(exports, "CgPushDown", ()=>CgPushDown);
parcelHelpers.export(exports, "CgPushLeft", ()=>CgPushLeft);
parcelHelpers.export(exports, "CgPushRight", ()=>CgPushRight);
parcelHelpers.export(exports, "CgPushUp", ()=>CgPushUp);
parcelHelpers.export(exports, "CgQr", ()=>CgQr);
parcelHelpers.export(exports, "CgQuoteO", ()=>CgQuoteO);
parcelHelpers.export(exports, "CgQuote", ()=>CgQuote);
parcelHelpers.export(exports, "CgRadioCheck", ()=>CgRadioCheck);
parcelHelpers.export(exports, "CgRadioChecked", ()=>CgRadioChecked);
parcelHelpers.export(exports, "CgRatio", ()=>CgRatio);
parcelHelpers.export(exports, "CgRead", ()=>CgRead);
parcelHelpers.export(exports, "CgReadme", ()=>CgReadme);
parcelHelpers.export(exports, "CgRecord", ()=>CgRecord);
parcelHelpers.export(exports, "CgRedo", ()=>CgRedo);
parcelHelpers.export(exports, "CgRemote", ()=>CgRemote);
parcelHelpers.export(exports, "CgRemoveR", ()=>CgRemoveR);
parcelHelpers.export(exports, "CgRemove", ()=>CgRemove);
parcelHelpers.export(exports, "CgRename", ()=>CgRename);
parcelHelpers.export(exports, "CgReorder", ()=>CgReorder);
parcelHelpers.export(exports, "CgRepeat", ()=>CgRepeat);
parcelHelpers.export(exports, "CgRing", ()=>CgRing);
parcelHelpers.export(exports, "CgRowFirst", ()=>CgRowFirst);
parcelHelpers.export(exports, "CgRowLast", ()=>CgRowLast);
parcelHelpers.export(exports, "CgRuler", ()=>CgRuler);
parcelHelpers.export(exports, "CgSandClock", ()=>CgSandClock);
parcelHelpers.export(exports, "CgScan", ()=>CgScan);
parcelHelpers.export(exports, "CgScreenMirror", ()=>CgScreenMirror);
parcelHelpers.export(exports, "CgScreenShot", ()=>CgScreenShot);
parcelHelpers.export(exports, "CgScreenWide", ()=>CgScreenWide);
parcelHelpers.export(exports, "CgScreen", ()=>CgScreen);
parcelHelpers.export(exports, "CgScrollH", ()=>CgScrollH);
parcelHelpers.export(exports, "CgScrollV", ()=>CgScrollV);
parcelHelpers.export(exports, "CgSearchFound", ()=>CgSearchFound);
parcelHelpers.export(exports, "CgSearchLoading", ()=>CgSearchLoading);
parcelHelpers.export(exports, "CgSearch", ()=>CgSearch);
parcelHelpers.export(exports, "CgSelectO", ()=>CgSelectO);
parcelHelpers.export(exports, "CgSelectR", ()=>CgSelectR);
parcelHelpers.export(exports, "CgSelect", ()=>CgSelect);
parcelHelpers.export(exports, "CgServer", ()=>CgServer);
parcelHelpers.export(exports, "CgServerless", ()=>CgServerless);
parcelHelpers.export(exports, "CgShapeCircle", ()=>CgShapeCircle);
parcelHelpers.export(exports, "CgShapeHalfCircle", ()=>CgShapeHalfCircle);
parcelHelpers.export(exports, "CgShapeHexagon", ()=>CgShapeHexagon);
parcelHelpers.export(exports, "CgShapeRhombus", ()=>CgShapeRhombus);
parcelHelpers.export(exports, "CgShapeSquare", ()=>CgShapeSquare);
parcelHelpers.export(exports, "CgShapeTriangle", ()=>CgShapeTriangle);
parcelHelpers.export(exports, "CgShapeZigzag", ()=>CgShapeZigzag);
parcelHelpers.export(exports, "CgShare", ()=>CgShare);
parcelHelpers.export(exports, "CgShield", ()=>CgShield);
parcelHelpers.export(exports, "CgShoppingBag", ()=>CgShoppingBag);
parcelHelpers.export(exports, "CgShoppingCart", ()=>CgShoppingCart);
parcelHelpers.export(exports, "CgShortcut", ()=>CgShortcut);
parcelHelpers.export(exports, "CgShutterstock", ()=>CgShutterstock);
parcelHelpers.export(exports, "CgSidebarOpen", ()=>CgSidebarOpen);
parcelHelpers.export(exports, "CgSidebarRight", ()=>CgSidebarRight);
parcelHelpers.export(exports, "CgSidebar", ()=>CgSidebar);
parcelHelpers.export(exports, "CgSignal", ()=>CgSignal);
parcelHelpers.export(exports, "CgSize", ()=>CgSize);
parcelHelpers.export(exports, "CgSketch", ()=>CgSketch);
parcelHelpers.export(exports, "CgSlack", ()=>CgSlack);
parcelHelpers.export(exports, "CgSleep", ()=>CgSleep);
parcelHelpers.export(exports, "CgSmartHomeBoiler", ()=>CgSmartHomeBoiler);
parcelHelpers.export(exports, "CgSmartHomeCooker", ()=>CgSmartHomeCooker);
parcelHelpers.export(exports, "CgSmartHomeHeat", ()=>CgSmartHomeHeat);
parcelHelpers.export(exports, "CgSmartHomeLight", ()=>CgSmartHomeLight);
parcelHelpers.export(exports, "CgSmartHomeRefrigerator", ()=>CgSmartHomeRefrigerator);
parcelHelpers.export(exports, "CgSmartHomeWashMachine", ()=>CgSmartHomeWashMachine);
parcelHelpers.export(exports, "CgSmartphoneChip", ()=>CgSmartphoneChip);
parcelHelpers.export(exports, "CgSmartphoneRam", ()=>CgSmartphoneRam);
parcelHelpers.export(exports, "CgSmartphoneShake", ()=>CgSmartphoneShake);
parcelHelpers.export(exports, "CgSmartphone", ()=>CgSmartphone);
parcelHelpers.export(exports, "CgSmileMouthOpen", ()=>CgSmileMouthOpen);
parcelHelpers.export(exports, "CgSmileNeutral", ()=>CgSmileNeutral);
parcelHelpers.export(exports, "CgSmileNoMouth", ()=>CgSmileNoMouth);
parcelHelpers.export(exports, "CgSmileNone", ()=>CgSmileNone);
parcelHelpers.export(exports, "CgSmileSad", ()=>CgSmileSad);
parcelHelpers.export(exports, "CgSmileUpside", ()=>CgSmileUpside);
parcelHelpers.export(exports, "CgSmile", ()=>CgSmile);
parcelHelpers.export(exports, "CgSoftwareDownload", ()=>CgSoftwareDownload);
parcelHelpers.export(exports, "CgSoftwareUpload", ()=>CgSoftwareUpload);
parcelHelpers.export(exports, "CgSortAz", ()=>CgSortAz);
parcelHelpers.export(exports, "CgSortZa", ()=>CgSortZa);
parcelHelpers.export(exports, "CgSpaceBetweenV", ()=>CgSpaceBetweenV);
parcelHelpers.export(exports, "CgSpaceBetween", ()=>CgSpaceBetween);
parcelHelpers.export(exports, "CgSpectrum", ()=>CgSpectrum);
parcelHelpers.export(exports, "CgSpinnerAlt", ()=>CgSpinnerAlt);
parcelHelpers.export(exports, "CgSpinnerTwoAlt", ()=>CgSpinnerTwoAlt);
parcelHelpers.export(exports, "CgSpinnerTwo", ()=>CgSpinnerTwo);
parcelHelpers.export(exports, "CgSpinner", ()=>CgSpinner);
parcelHelpers.export(exports, "CgSquare", ()=>CgSquare);
parcelHelpers.export(exports, "CgStack", ()=>CgStack);
parcelHelpers.export(exports, "CgStark", ()=>CgStark);
parcelHelpers.export(exports, "CgStopwatch", ()=>CgStopwatch);
parcelHelpers.export(exports, "CgStories", ()=>CgStories);
parcelHelpers.export(exports, "CgStudio", ()=>CgStudio);
parcelHelpers.export(exports, "CgStyle", ()=>CgStyle);
parcelHelpers.export(exports, "CgSun", ()=>CgSun);
parcelHelpers.export(exports, "CgSupport", ()=>CgSupport);
parcelHelpers.export(exports, "CgSwapVertical", ()=>CgSwapVertical);
parcelHelpers.export(exports, "CgSwap", ()=>CgSwap);
parcelHelpers.export(exports, "CgSweden", ()=>CgSweden);
parcelHelpers.export(exports, "CgSwiss", ()=>CgSwiss);
parcelHelpers.export(exports, "CgSync", ()=>CgSync);
parcelHelpers.export(exports, "CgTab", ()=>CgTab);
parcelHelpers.export(exports, "CgTag", ()=>CgTag);
parcelHelpers.export(exports, "CgTally", ()=>CgTally);
parcelHelpers.export(exports, "CgTapDouble", ()=>CgTapDouble);
parcelHelpers.export(exports, "CgTapSingle", ()=>CgTapSingle);
parcelHelpers.export(exports, "CgTemplate", ()=>CgTemplate);
parcelHelpers.export(exports, "CgTennis", ()=>CgTennis);
parcelHelpers.export(exports, "CgTerminal", ()=>CgTerminal);
parcelHelpers.export(exports, "CgTerrain", ()=>CgTerrain);
parcelHelpers.export(exports, "CgThermometer", ()=>CgThermometer);
parcelHelpers.export(exports, "CgThermostat", ()=>CgThermostat);
parcelHelpers.export(exports, "CgTikcode", ()=>CgTikcode);
parcelHelpers.export(exports, "CgTime", ()=>CgTime);
parcelHelpers.export(exports, "CgTimelapse", ()=>CgTimelapse);
parcelHelpers.export(exports, "CgTimer", ()=>CgTimer);
parcelHelpers.export(exports, "CgToday", ()=>CgToday);
parcelHelpers.export(exports, "CgToggleOff", ()=>CgToggleOff);
parcelHelpers.export(exports, "CgToggleOn", ()=>CgToggleOn);
parcelHelpers.export(exports, "CgToggleSquareOff", ()=>CgToggleSquareOff);
parcelHelpers.export(exports, "CgToggleSquare", ()=>CgToggleSquare);
parcelHelpers.export(exports, "CgToolbarBottom", ()=>CgToolbarBottom);
parcelHelpers.export(exports, "CgToolbarLeft", ()=>CgToolbarLeft);
parcelHelpers.export(exports, "CgToolbarRight", ()=>CgToolbarRight);
parcelHelpers.export(exports, "CgToolbarTop", ()=>CgToolbarTop);
parcelHelpers.export(exports, "CgToolbox", ()=>CgToolbox);
parcelHelpers.export(exports, "CgTouchpad", ()=>CgTouchpad);
parcelHelpers.export(exports, "CgTrack", ()=>CgTrack);
parcelHelpers.export(exports, "CgTranscript", ()=>CgTranscript);
parcelHelpers.export(exports, "CgTrashEmpty", ()=>CgTrashEmpty);
parcelHelpers.export(exports, "CgTrash", ()=>CgTrash);
parcelHelpers.export(exports, "CgTree", ()=>CgTree);
parcelHelpers.export(exports, "CgTrees", ()=>CgTrees);
parcelHelpers.export(exports, "CgTrello", ()=>CgTrello);
parcelHelpers.export(exports, "CgTrendingDown", ()=>CgTrendingDown);
parcelHelpers.export(exports, "CgTrending", ()=>CgTrending);
parcelHelpers.export(exports, "CgTrophy", ()=>CgTrophy);
parcelHelpers.export(exports, "CgTv", ()=>CgTv);
parcelHelpers.export(exports, "CgTwilio", ()=>CgTwilio);
parcelHelpers.export(exports, "CgTwitter", ()=>CgTwitter);
parcelHelpers.export(exports, "CgUiKit", ()=>CgUiKit);
parcelHelpers.export(exports, "CgUmbrella", ()=>CgUmbrella);
parcelHelpers.export(exports, "CgUnavailable", ()=>CgUnavailable);
parcelHelpers.export(exports, "CgUnblock", ()=>CgUnblock);
parcelHelpers.export(exports, "CgUndo", ()=>CgUndo);
parcelHelpers.export(exports, "CgUnfold", ()=>CgUnfold);
parcelHelpers.export(exports, "CgUnsplash", ()=>CgUnsplash);
parcelHelpers.export(exports, "CgUsbC", ()=>CgUsbC);
parcelHelpers.export(exports, "CgUsb", ()=>CgUsb);
parcelHelpers.export(exports, "CgUserAdd", ()=>CgUserAdd);
parcelHelpers.export(exports, "CgUserList", ()=>CgUserList);
parcelHelpers.export(exports, "CgUserRemove", ()=>CgUserRemove);
parcelHelpers.export(exports, "CgUser", ()=>CgUser);
parcelHelpers.export(exports, "CgUserlane", ()=>CgUserlane);
parcelHelpers.export(exports, "CgVercel", ()=>CgVercel);
parcelHelpers.export(exports, "CgViewCols", ()=>CgViewCols);
parcelHelpers.export(exports, "CgViewComfortable", ()=>CgViewComfortable);
parcelHelpers.export(exports, "CgViewDay", ()=>CgViewDay);
parcelHelpers.export(exports, "CgViewGrid", ()=>CgViewGrid);
parcelHelpers.export(exports, "CgViewList", ()=>CgViewList);
parcelHelpers.export(exports, "CgViewMonth", ()=>CgViewMonth);
parcelHelpers.export(exports, "CgViewSplit", ()=>CgViewSplit);
parcelHelpers.export(exports, "CgVinyl", ()=>CgVinyl);
parcelHelpers.export(exports, "CgVoicemailO", ()=>CgVoicemailO);
parcelHelpers.export(exports, "CgVoicemailR", ()=>CgVoicemailR);
parcelHelpers.export(exports, "CgVoicemail", ()=>CgVoicemail);
parcelHelpers.export(exports, "CgVolume", ()=>CgVolume);
parcelHelpers.export(exports, "CgWebcam", ()=>CgWebcam);
parcelHelpers.export(exports, "CgWebsite", ()=>CgWebsite);
parcelHelpers.export(exports, "CgWindows", ()=>CgWindows);
parcelHelpers.export(exports, "CgWorkAlt", ()=>CgWorkAlt);
parcelHelpers.export(exports, "CgYinyang", ()=>CgYinyang);
parcelHelpers.export(exports, "CgYoutube", ()=>CgYoutube);
parcelHelpers.export(exports, "CgZoomIn", ()=>CgZoomIn);
parcelHelpers.export(exports, "CgZoomOut", ()=>CgZoomOut);
var _lib = require("../lib");
function CgAbstract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5H19V19H16L16 8H5V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10 19C12.7614 19 15 16.7614 15 14C15 11.2386 12.7614 9 10 9C7.23858 9 5 11.2386 5 14C5 16.7614 7.23858 19 10 19ZM10 16C11.1046 16 12 15.1046 12 14C12 12.8954 11.1046 12 10 12C8.89543 12 8 12.8954 8 14C8 15.1046 8.89543 16 10 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAddR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C12.5523 6 13 6.44772 13 7V11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H11V7C11 6.44772 11.4477 6 12 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 22C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5ZM4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAdidas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.3294 19L0.731323 17.9641L5.06145 15.4641L7.1029 19H1.3294Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1858 19H9.4123L5.7935 12.7321L10.1236 10.2321L15.1858 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.2687 19H17.4952L10.8557 7.5L15.1858 5L23.2687 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAirplane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.00967 5.12761H11.0097C12.1142 5.12761 13.468 5.89682 14.0335 6.8457L16.5089 11H21.0097C21.562 11 22.0097 11.4477 22.0097 12C22.0097 12.5523 21.562 13 21.0097 13H16.4138L13.9383 17.1543C13.3729 18.1032 12.0191 18.8724 10.9145 18.8724H8.91454L12.4138 13H5.42485L3.99036 15.4529H1.99036L4.00967 12L4.00967 11.967L2.00967 8.54712H4.00967L5.44417 11H12.5089L9.00967 5.12761Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45887 2L1 6.01478L2.33826 7.50107L6.79713 3.48629L5.45887 2Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8H13V12H16V14H11V8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5411 2L23 6.01478L21.6617 7.50107L17.2029 3.48629L18.5411 2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V19ZM20 19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H10V12.0111L12.395 12.0112L14.0001 9.86419L15.6051 12.0112H18.0001L18 4H19C19.5523 4 20 4.44772 20 5V19ZM16 4H12V9.33585L14.0001 6.66046L16 9.33571V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10H17V16H13V10Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H7V16H11V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18H6V20H18V18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13H15V17H9V13Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H18V11H6V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13H14V17H8V13Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6H4V18H6V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H8V11H20V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9H17V15H13V9Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6H11V18H7V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15.9991 13.0039L9.99907 12.9911L9.99054 16.9911L15.9905 17.0039L15.9991 13.0039Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19.978 18.0021L20.0036 6.00214L18.0036 5.99788L17.978 17.9979L19.978 18.0021Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.9964 10.9851L15.9964 11.0107L16.0049 7.0107L4.00493 6.98512L3.9964 10.9851Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.0352 7.98797L13.0374 13.988L17.0374 13.9865L17.0352 7.98653L13.0352 7.98797Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17.9996 4.01189L5.99963 4.01837L6.00038 6.01837L18.0004 6.01189L17.9996 4.01189Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.0374 19.9864L11.0321 7.98637L7.03207 7.98813L7.03736 19.9881L11.0374 19.9864Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 6C15 7.30622 14.1652 8.41746 13 8.82929V16.874C14.7252 16.4299 16 14.8638 16 13H18C18 15.973 15.8377 18.441 13 18.917V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.917C8.16229 18.441 6 15.973 6 13H8C8 14.8638 9.27477 16.4299 11 16.874V8.82929C9.83481 8.41746 9 7.30622 9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6ZM12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAppleWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16.4975 5.02988C16.4973 5.07798 16.4959 5.12581 16.4934 5.17335C17.662 5.58332 18.5 6.69628 18.5 8.00496V9.00493H19.5V13.0049H18.5V16.005C18.5 17.3129 17.663 18.4254 16.4953 18.8359C16.4984 18.8919 16.5 18.9482 16.5 19.005C16.5 20.6618 15.1569 22.005 13.5 22.005H9.5C7.84315 22.005 6.5 20.6618 6.5 19.005C6.5 18.9482 6.50158 18.8919 6.50468 18.8359C5.33705 18.4254 4.5 17.3129 4.5 16.005V8.00496C4.5 6.69767 5.33618 5.58568 6.50286 5.17465C6.49907 5.11032 6.4973 5.04546 6.49763 4.98011C6.50587 3.32328 7.85569 1.98683 9.51252 1.99508L13.5125 2.01499C15.1693 2.02324 16.5058 3.37305 16.4975 5.02988ZM8.49764 5.00496H14.4975C14.4922 4.45954 14.0498 4.01769 13.5025 4.01496L9.50257 3.99505C8.95029 3.99231 8.50035 4.43779 8.4976 4.99006L8.49764 5.00496ZM15.7049 7.02596L11.4846 7.00496H7.5C6.94772 7.00496 6.5 7.45267 6.5 8.00496V16.005C6.5 16.5568 6.94696 17.0042 7.4986 17.005H15.5014C16.053 17.0042 16.5 16.5568 16.5 16.005V8.00496C16.5 7.52289 16.1589 7.12049 15.7049 7.02596ZM8.5 19.005C8.5 19.5572 8.94772 20.005 9.5 20.005H13.5C14.0523 20.005 14.5 19.5572 14.5 19.005H8.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrangeBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3H11V7H17V13H21V21H13V17H7V11H3V3ZM15 13H13V15H9V11H11V9H15V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrangeFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3H11V7H17V13H21V21H13V17H7V11H3V3ZM15 9H9V15H15V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowAlignH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7H11V17H13V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.99996 7.75732L7.41418 9.17154L5.58572 11L9.99996 11V13L5.58579 13L7.41418 14.8284L5.99996 16.2426L1.75732 12L5.99996 7.75732Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.2427L16.5858 14.8285L18.4143 13H14V11L18.4142 11L16.5858 9.17161L18 7.75739L22.2427 12L18 16.2427Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowAlignV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11L7 13H17V11H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75732 18L9.17154 16.5858L11 18.4143V14H13V18.4142L14.8284 16.5858L16.2426 18L12 22.2427L7.75732 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2427 5.99996L14.8285 7.41418L13 5.58572V9.99996H11L11 5.58579L9.17161 7.41418L7.75739 5.99996L12 1.75732L16.2427 5.99996Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowBottomLeftO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.0367L8.00002 10.0367L8 16.0367L14 16.0367L14 14.0367L11.4143 14.0366L16.7438 8.7071L15.3296 7.29289L10 12.6224L10 10.0367Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowBottomLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.0367H8V16.0367H14V14.0367H11.4142L16.7438 8.70712L15.3296 7.2929L10 12.6225V10.0367Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowBottomLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2426 7.17154L16.8284 5.75732L7.75739 14.8283L7.75739 10.2427H5.75739L5.75739 18.2427H13.7574V16.2427L9.17144 16.2427L18.2426 7.17154Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowBottomRightO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0367 10.0367H16.0367V16.0367H10.0367V14.0367H12.6225L7.29297 8.70713L8.70718 7.29291L14.0367 12.6225L14.0367 10.0367Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowBottomRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0367 10.0367H16.0367V16.0367H10.0367V14.0367H12.6225L7.29297 8.70713L8.70718 7.29292L14.0367 12.6225L14.0367 10.0367Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowBottomRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.75739 7.17154L7.1716 5.75732L16.2426 14.8283L16.2426 10.2427H18.2426L18.2426 18.2427H10.2426V16.2427L14.8285 16.2427L5.75739 7.17154Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowDownO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8285 12.0259L16.2427 13.4402L12 17.6828L7.7574 13.4402L9.17161 12.0259L11 13.8544V6.31724H13V13.8544L14.8285 12.0259Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19.7782 19.7782C15.4824 24.0739 8.51759 24.0739 4.22183 19.7782C-0.0739417 15.4824 -0.0739417 8.51759 4.22183 4.22183C8.51759 -0.0739419 15.4824 -0.0739419 19.7782 4.22183C24.0739 8.51759 24.0739 15.4824 19.7782 19.7782ZM18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.364Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowDownR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 12.0259L16.2426 13.4402L12 17.6828L7.75733 13.4402L9.17155 12.0259L11 13.8544V6.31724H13V13.8544L14.8284 12.0259Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0001 3.67157L13.0001 3.67157L13.0001 16.4999L16.2426 13.2574L17.6568 14.6716L12 20.3284L6.34314 14.6716L7.75735 13.2574L11.0001 16.5001L11.0001 3.67157Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLeftO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9481 14.8285L10.5339 16.2427L6.29122 12L10.5339 7.7574L11.9481 9.17161L10.1196 11H17.6568V13H10.1196L11.9481 14.8285Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.22183 19.7782C-0.0739419 15.4824 -0.0739419 8.51759 4.22183 4.22183C8.51759 -0.0739419 15.4824 -0.0739419 19.7782 4.22183C24.0739 8.51759 24.0739 15.4824 19.7782 19.7782C15.4824 24.0739 8.51759 24.0739 4.22183 19.7782ZM5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9481 14.8285L10.5339 16.2427L6.29126 12L10.5339 7.7574L11.9481 9.17161L10.1197 11H17.6568V13H10.1197L11.9481 14.8285Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19ZM19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongDownC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.9991 6.84976C9.83339 6.43819 8.99813 5.32671 8.99813 4.02014C8.99813 2.36329 10.3413 1.02014 11.9981 1.02014C13.655 1.02014 14.9981 2.36329 14.9981 4.02014C14.9981 5.32601 14.1638 6.43701 12.9991 6.84911L13.0121 19.1375L14.8244 17.315L16.2426 18.7253L12.0119 22.9799L7.75739 18.7491L9.16763 17.3309L11.0122 19.1652L10.9991 6.84976ZM11.9981 5.02014C11.4458 5.02014 10.9981 4.57243 10.9981 4.02014C10.9981 3.46786 11.4458 3.02014 11.9981 3.02014C12.5504 3.02014 12.9981 3.46786 12.9981 4.02014C12.9981 4.57243 12.5504 5.02014 11.9981 5.02014Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongDownE(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.998 1.02014H8.99801V7.02014H10.9991L11.012 19.1652L9.16751 17.3309L7.75726 18.7491L12.0118 22.9799L16.2427 18.7253L14.8246 17.315L13.012 19.1378L12.9991 7.02014H14.998V1.02014ZM10.998 3.02014H12.998V5.02014H10.998V3.02014Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongDownL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.99801 0.972107V2.97211H11.9983L10.998 2.97299L11.0124 19.2135L9.16751 17.379L7.75726 18.7972L12.0118 23.0279L16.2427 18.7734L14.8246 17.3632L13.0124 19.1856L12.998 2.97211H14.998V0.972107H8.99801Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongDownR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16.2416 4.64146L11.9989 0.398819L7.75629 4.64146L11.0003 7.88551L11.013 19.7865L9.16846 17.9523L7.75821 19.3704L12.0127 23.6012L16.2437 19.3466L14.8255 17.9363L13.013 19.7591L13.0003 7.8827L16.2416 4.64146ZM10.5847 4.64146L11.9989 3.22725L13.4131 4.64146L11.9989 6.05567L10.5847 4.64146Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0125 19.162L14.8246 17.3398L16.2427 18.7501L12.012 23.0046L7.75726 18.7739L9.16751 17.3557L11.0126 19.1905L10.998 0.997021L12.998 0.995422L13.0125 19.162Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongLeftC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.27 7.75737L1.0202 11.9928L5.25576 16.2426L6.67236 14.8308L4.85801 13.0103L17.1463 13.0525C17.5532 14.219 18.6604 15.0583 19.9663 15.0642C21.6231 15.0717 22.9723 13.7346 22.9798 12.0777C22.9872 10.4209 21.6501 9.07172 19.9933 9.06427C18.6867 9.05841 17.5715 9.88865 17.1547 11.0525L4.83934 11.0102L6.68182 9.17397L5.27 7.75737ZM18.9798 12.0598C18.9823 11.5075 19.432 11.0618 19.9843 11.0643C20.5366 11.0667 20.9823 11.5165 20.9798 12.0687C20.9773 12.621 20.5276 13.0667 19.9753 13.0642C19.423 13.0618 18.9773 12.612 18.9798 12.0598Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongLeftE(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.26323 7.75737L1.01343 11.9928L5.24893 16.2426L6.66553 14.8308L4.85123 13.0104L16.9685 13.0519L16.9596 15.0507L22.9595 15.0777L22.9865 9.07773L16.9865 9.05079L16.9775 11.0519L4.83252 11.0103L6.67505 9.17397L5.26323 7.75737ZM20.9775 11.0687L20.9685 13.0687L18.9685 13.0597L18.9775 11.0597L20.9775 11.0687Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongLeftL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.20837 7.75725L0.969116 12.0033L5.21515 16.2428L6.62823 14.8274L4.80949 13.0116L21.0229 13.0298L21.0189 15.0297L23.0189 15.0338L23.0309 9.03377L21.0309 9.02976L21.0249 12.019L21.0261 11.0298L4.78543 11.0115L6.62371 9.17033L5.20837 7.75725Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.64872 7.72528L0.398926 11.9608L4.63443 16.2105L6.05103 14.7987L4.23673 12.9783L16.1027 13.019L19.3585 16.2747L23.6011 12.0321L19.3585 7.78945L16.1289 11.019L4.21801 10.9782L6.06055 9.14188L4.64872 7.72528ZM17.9443 12.0321L19.3585 10.6179L20.7727 12.0321L19.3585 13.4463L17.9443 12.0321Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.02698 11.9929L5.26242 16.2426L6.67902 14.8308L4.85766 13.0033L22.9731 13.0012L22.9728 11.0012L4.85309 11.0033L6.6886 9.17398L5.27677 7.75739L1.02698 11.9929Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongRightC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.73 7.75739L22.9798 11.9929L18.7443 16.2426L17.3277 14.8308L19.142 13.0103L6.85364 13.0525C6.44678 14.219 5.33954 15.0584 4.03368 15.0642C2.37684 15.0717 1.02767 13.7346 1.02023 12.0777C1.01279 10.4209 2.34989 9.07173 4.00673 9.06429C5.31328 9.05842 6.4285 9.88867 6.84531 11.0525L19.1607 11.0103L17.3182 9.17398L18.73 7.75739ZM5.02019 12.0598C5.01771 11.5075 4.56799 11.0618 4.01571 11.0643C3.46343 11.0667 3.01773 11.5165 3.02021 12.0687C3.02269 12.621 3.47242 13.0667 4.02469 13.0642C4.57697 13.0618 5.02267 12.612 5.02019 12.0598Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongRightE(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22.9865 11.9929L18.7511 16.2426L17.3345 14.8308L19.1488 13.0104L7.0314 13.0519L7.04038 15.0507L1.04044 15.0777L1.01349 9.07773L7.01343 9.05079L7.02242 11.0519L19.1674 11.0103L17.3249 9.17398L18.7367 7.75739L22.9865 11.9929ZM3.02245 11.0687L3.03143 13.0687L5.03141 13.0597L5.02243 11.0597L3.02245 11.0687Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongRightL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.9164 7.75739L23.1662 11.9929L18.9305 16.2426L17.5139 14.8308L19.3325 13.0061L2.8338 13.0285V15.0299H0.833801V9.02988H2.8338V11.0285L19.3429 11.0061L17.5046 9.17398L18.9164 7.75739Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19.3514 7.72525L23.6012 11.9607L19.3655 16.2105L17.9489 14.7987L19.7633 12.9781L7.89744 13.0188L4.64151 16.2748L0.398865 12.0321L4.64151 7.78947L7.87093 11.0189L19.782 10.9781L17.9395 9.14185L19.3514 7.72525ZM4.64151 13.4463L6.05572 12.0321L4.64151 10.6179L3.22729 12.0321L4.64151 13.4463Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23.0677 11.9929L18.818 7.75739L17.4061 9.17398L19.2415 11.0032L0.932469 11.0012L0.932251 13.0012L19.2369 13.0032L17.4155 14.8308L18.8321 16.2426L23.0677 11.9929Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongUpC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.75751 5.23078L12.0321 1.02029L16.2425 5.29492L14.8177 6.69842L13.0141 4.86736L12.9427 17.1555C14.1054 17.5732 14.9345 18.6881 14.9283 19.994C14.9204 21.6508 13.5709 22.9876 11.9141 22.9797C10.2572 22.9718 8.92049 21.6223 8.92836 19.9655C8.93456 18.6589 9.77508 17.5514 10.9427 17.1454L11.0142 4.83017L9.161 6.65563L7.75751 5.23078ZM11.9331 18.9797C11.3808 18.9771 10.931 19.4227 10.9283 19.975C10.9257 20.5273 11.3713 20.9771 11.9236 20.9797C12.4759 20.9823 12.9257 20.5367 12.9283 19.9845C12.9309 19.4322 12.4853 18.9824 11.9331 18.9797Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongUpE(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0321 1.01318L16.2425 5.28781L14.8177 6.69131L13.014 4.86019L12.9436 16.9774L14.9425 16.9869L14.914 22.9868L8.91412 22.9583L8.9426 16.9584L10.9436 16.9679L11.0142 4.82318L9.16107 6.64852L7.75757 5.22367L12.0321 1.01318ZM10.9236 20.9678L12.9236 20.9773L12.9331 18.9773L10.9331 18.9678L10.9236 20.9678Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongUpL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0321 1.01865L16.2425 5.29327L14.8177 6.69677L13.0192 4.87094L12.9676 20.9813H14.9644V22.9813H8.96441V20.9813H10.9676L11.0194 4.82354L9.16107 6.65399L7.75757 5.22914L12.0321 1.01865Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongUpR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.79337 4.60945L12.0679 0.398956L16.2785 4.67358L14.8536 6.07708L13.0499 4.24596L12.9809 16.1324L16.2068 19.3584L11.9642 23.601L7.72156 19.3584L10.981 16.0989L11.0501 4.20883L9.19686 6.0343L7.79337 4.60945ZM11.9642 20.7726L13.3784 19.3584L11.9642 17.9442L10.55 19.3584L11.9642 20.7726Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowLongUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0321 1.01712L7.75751 5.22761L9.161 6.65246L11.0197 4.82165L10.9644 22.9768L12.9644 22.9829L13.0195 4.86974L14.8177 6.69525L16.2425 5.29175L12.0321 1.01712Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowRightO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0519 14.8285L13.4661 16.2427L17.7088 12L13.4661 7.7574L12.0519 9.17161L13.8804 11H6.34321V13H13.8803L12.0519 14.8285Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19.7782 19.7782C24.0739 15.4824 24.0739 8.51759 19.7782 4.22183C15.4824 -0.0739417 8.51759 -0.0739417 4.22183 4.22183C-0.0739417 8.51759 -0.0739417 15.4824 4.22183 19.7782C8.51759 24.0739 15.4824 24.0739 19.7782 19.7782ZM18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0519 14.8285L13.4661 16.2427L17.7087 12L13.4661 7.7574L12.0519 9.17161L13.8803 11H6.34318V13H13.8803L12.0519 14.8285Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5C2.79086 1 1 2.79086 1 5V19ZM5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowTopLeftO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13.9633H8V7.96331H14V9.96331H11.4142L16.7438 15.2929L15.3296 16.7071L10 11.3775L10 13.9633Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowTopLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13.9633H8V7.96331H14V9.96331H11.4142L16.7438 15.2929L15.3296 16.7071L10 11.3775L10 13.9633Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5C2.79086 1 1 2.79086 1 5V19ZM5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowTopLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4747 5.49475L13.4793 7.49475L8.92175 7.50541L18.5253 17.0896L17.1125 18.5052L7.48259 8.89473L7.49339 13.5088L5.49339 13.5134L5.47467 5.51345L13.4747 5.49475Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowTopRightO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.9633H16V7.96331H10V9.96331H12.5858L7.25623 15.2929L8.67044 16.7071L14 11.3775L14 13.9633Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowTopRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.9633H16V7.96331H10V9.96331H12.5858L7.25623 15.2929L8.67044 16.7071L14 11.3775V13.9633Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19ZM19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowTopRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowUpO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8285 11.9481L16.2427 10.5339L12 6.29122L7.7574 10.5339L9.17161 11.9481L11 10.1196V17.6568H13V10.1196L14.8285 11.9481Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19.7782 4.22183C15.4824 -0.0739415 8.51759 -0.0739422 4.22183 4.22183C-0.0739415 8.51759 -0.0739422 15.4824 4.22183 19.7782C8.51759 24.0739 15.4824 24.0739 19.7782 19.7782C24.0739 15.4824 24.0739 8.51759 19.7782 4.22183ZM18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowUpR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8543 11.9741L16.2686 10.5599L12.0259 6.31724L7.78327 10.5599L9.19749 11.9741L11.0259 10.1457V17.6828H13.0259V10.1457L14.8543 11.9741Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5C2.79086 1 1 2.79086 1 5V19ZM5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6568 8.96219L16.2393 10.3731L12.9843 7.10285L12.9706 20.7079L10.9706 20.7059L10.9843 7.13806L7.75404 10.3532L6.34314 8.93572L12.0132 3.29211L17.6568 8.96219Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsBreakeH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.24268 7H11.2427V11.0001H11.2477V13.0001H11.2427V17H9.24268V13.0001L4.82846 13L6.65685 14.8284L5.24264 16.2426L1 12L5.24264 7.75732L6.65685 9.17154L4.82839 11H9.24264L9.24268 7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2527 7.00012H13.2527V11.0001H13.2477V13.0001H13.2527V17.0001H15.2527V13.0001L19.667 13L17.8385 14.8285L19.2527 16.2427L23.4954 12L19.2527 7.75739L17.8385 9.17161L19.6669 11H15.2527L15.2527 7.00012Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsBreakeV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2427 5.24264L14.8285 6.65685L13 4.82839L13.0001 9.24268H17.0001V11.2427H7.00012V9.24268H11.0001L11 4.82846L9.17161 6.65685L7.75739 5.24264L12 1L16.2427 5.24264Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15.2527V13.2527H17V15.2527H13.0001L13 19.6669L14.8284 17.8385L16.2426 19.2527L12 23.4954L7.75732 19.2527L9.17154 17.8385L11 19.667V15.2527L7 15.2527Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExchangeAltV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9841 4.99255C12.9841 4.44027 13.4318 3.99255 13.9841 3.99255C14.3415 3.99255 14.6551 4.18004 14.8319 4.46202L17.5195 7.14964C17.9101 7.54016 17.9101 8.17333 17.5195 8.56385C17.129 8.95438 16.4958 8.95438 16.1053 8.56385L14.9841 7.44263V14.9926C14.9841 15.5448 14.5364 15.9926 13.9841 15.9926C13.4318 15.9926 12.9841 15.5448 12.9841 14.9926V5.042C12.984 5.03288 12.984 5.02376 12.9841 5.01464V4.99255Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0159 19.0074C11.0159 19.5597 10.5682 20.0074 10.0159 20.0074C9.6585 20.0074 9.3449 19.82 9.16807 19.538L6.48045 16.8504C6.08993 16.4598 6.08993 15.8267 6.48045 15.4361C6.87098 15.0456 7.50414 15.0456 7.89467 15.4361L9.01589 16.5574V9.00745C9.01589 8.45516 9.46361 8.00745 10.0159 8.00745C10.5682 8.00745 11.0159 8.45516 11.0159 9.00745V18.958C11.016 18.9671 11.016 18.9762 11.0159 18.9854V19.0074Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExchangeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.99255 11.0159C4.44027 11.0159 3.99255 10.5682 3.99255 10.0159C3.99255 9.6585 4.18004 9.3449 4.46202 9.16807L7.14964 6.48045C7.54016 6.08993 8.17333 6.08993 8.56385 6.48045C8.95438 6.87098 8.95438 7.50414 8.56385 7.89467L7.44263 9.0159L14.9926 9.01589C15.5448 9.01589 15.9926 9.46361 15.9926 10.0159C15.9926 10.5682 15.5448 11.0159 14.9926 11.0159L5.042 11.0159C5.03288 11.016 5.02376 11.016 5.01464 11.0159H4.99255Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0074 12.9841C19.5597 12.9841 20.0074 13.4318 20.0074 13.9841C20.0074 14.3415 19.82 14.6551 19.538 14.8319L16.8504 17.5195C16.4598 17.9101 15.8267 17.9101 15.4361 17.5195C15.0456 17.129 15.0456 16.4958 15.4361 16.1053L16.5574 14.9841H9.00745C8.45516 14.9841 8.00745 14.5364 8.00745 13.9841C8.00745 13.4318 8.45516 12.9841 9.00745 12.9841L18.958 12.9841C18.9671 12.984 18.9762 12.984 18.9854 12.9841H19.0074Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExchangeV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9842 15C12.9842 15.5523 13.4319 16 13.9842 16C14.3416 16 14.6552 15.8125 14.832 15.5305L17.5196 12.8429C17.9101 12.4524 17.9101 11.8192 17.5196 11.4287C17.1291 11.0382 16.4959 11.0382 16.1054 11.4287L14.9842 12.5499L14.9842 5C14.9842 4.44771 14.5364 4 13.9842 4C13.4319 4 12.9842 4.44772 12.9842 5L12.9842 14.9506C12.984 14.9597 12.984 14.9688 12.9842 14.9779V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.016 9C11.016 8.44771 10.5682 8 10.016 8C9.65856 8 9.34496 8.18748 9.16813 8.46947L6.48052 11.1571C6.08999 11.5476 6.08999 12.1808 6.48051 12.5713C6.87104 12.9618 7.5042 12.9618 7.89473 12.5713L9.01596 11.4501L9.01596 19C9.01596 19.5523 9.46367 20 10.016 20C10.5682 20 11.016 19.5523 11.016 19L11.016 9.04945C11.0161 9.04033 11.0161 9.03121 11.016 9.02208V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.99255 12.9841C4.44027 12.9841 3.99255 13.4318 3.99255 13.9841C3.99255 14.3415 4.18004 14.6551 4.46202 14.8319L7.14964 17.5195C7.54016 17.9101 8.17333 17.9101 8.56385 17.5195C8.95438 17.129 8.95438 16.4958 8.56385 16.1053L7.44263 14.9841H14.9926C15.5448 14.9841 15.9926 14.5364 15.9926 13.9841C15.9926 13.4318 15.5448 12.9841 14.9926 12.9841L5.042 12.9841C5.03288 12.984 5.02376 12.984 5.01464 12.9841H4.99255Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0074 11.0159C19.5597 11.0159 20.0074 10.5682 20.0074 10.0159C20.0074 9.6585 19.82 9.3449 19.538 9.16807L16.8504 6.48045C16.4598 6.08993 15.8267 6.08993 15.4361 6.48045C15.0456 6.87098 15.0456 7.50414 15.4361 7.89467L16.5574 9.01589L9.00745 9.01589C8.45516 9.01589 8.00745 9.46361 8.00745 10.0159C8.00745 10.5682 8.45516 11.0159 9.00745 11.0159L18.958 11.0159C18.9671 11.016 18.9762 11.016 18.9854 11.0159H19.0074Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 5C13 3.89543 13.8954 3 15 3H19C20.1046 3 21 3.89543 21 5V9C21 10.1046 20.1046 11 19 11H15C13.8954 11 13 10.1046 13 9V5ZM15 5H19V9H15V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13H3V21H11V19H6.41424L11.7782 13.6361C12.1687 13.2456 12.1687 12.6124 11.7782 12.2219C11.3876 11.8314 10.7545 11.8314 10.3639 12.2219L5 17.5858V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 5C11 3.89543 10.1046 3 9 3H5C3.89543 3 3 3.89543 3 5V9C3 10.1046 3.89543 11 5 11H9C10.1046 11 11 10.1046 11 9V5ZM9 5H5V9H9V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H21V21H13V19H17.5858L12.2218 13.6361C11.8313 13.2456 11.8313 12.6124 12.2218 12.2219C12.6124 11.8314 13.2455 11.8314 13.6361 12.2219L19 17.5858V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandLeftAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1005 2.10052V4.10052H5.51471L11.293 9.87878L9.87875 11.293L4.10046 5.51471L4.10046 10.1005H2.10046L2.10046 2.10052H10.1005Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.8995 13.8995H19.8995V18.4853L14.1212 12.707L12.707 14.1213L18.4853 19.8995H13.8995V21.8995H21.8995V13.8995Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2426 9.1716L14.8284 7.75739L7.7573 14.8285L9.17151 16.2427L16.2426 9.1716Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1005 4.10052V2.10052H2.10046L2.10046 10.1005H4.10046L4.10046 5.51471L9.87875 11.293L11.293 9.87878L5.51471 4.10052H10.1005Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8995 13.8995H21.8995V21.8995H13.8995V19.8995H18.4853L12.7071 14.1212L14.1213 12.707L19.8995 18.4853V13.8995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandRightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8995 2.10052V4.10052H18.4852L12.707 9.87878L14.1212 11.293L19.8995 5.51471V10.1005H21.8995V2.10052H13.8995Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.51468 19.8995H10.1005V21.8995H2.10046V13.8995H4.10046V18.4853L9.87872 12.707L11.2929 14.1213L5.51468 19.8995Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 7.75739L7.75732 9.1716L14.8284 16.2427L16.2426 14.8285L9.17154 7.75739Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8995 4.10052V2.10052H21.8995V10.1005H19.8995V5.51477L14.1213 11.293L12.7071 9.87878L18.4854 4.10052H13.8995Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.10046 13.8995H2.10046V21.8995H10.1005V19.8995H5.51468L11.2929 14.1212L9.87872 12.707L4.10046 18.4853V13.8995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11H3L3 3L11 3V5L6.41419 5L11.7781 10.3639C12.1686 10.7545 12.1686 11.3876 11.7781 11.7782C11.3876 12.1687 10.7544 12.1687 10.3639 11.7782L5 6.41424L5 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 13C20.1046 13 21 13.8954 21 15V19C21 20.1046 20.1046 21 19 21H15C13.8954 21 13 20.1046 13 19V15C13 13.8954 13.8954 13 15 13H19ZM19 15V19H15V15H19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsExpandUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5V3L21 3V11H19V6.41424L13.6361 11.7782C13.2456 12.1687 12.6124 12.1687 12.2219 11.7782C11.8314 11.3876 11.8314 10.7545 12.2219 10.3639L17.5858 5L13 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 13C3.89543 13 3 13.8954 3 15L3 19C3 20.1046 3.89543 21 5 21H9C10.1046 21 11 20.1046 11 19V15C11 13.8954 10.1046 13 9 13H5ZM5 15L5 19H9V15H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsHAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.24267 7.75735L5.65688 9.17157L3.82842 11H20.1716L18.3431 9.17157L19.7573 7.75735L24 12L19.7572 16.2426L18.343 14.8284L20.1714 13H3.82845L5.65685 14.8284L4.24264 16.2426L0 12L4.24267 7.75735Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.65698 9.17157L4.24276 7.75735L0.00012207 12L4.24276 16.2426L5.65698 14.8284L3.82858 13H10.0001V11H3.82851L5.65698 9.17157Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0001 11V13H20.1716L18.3432 14.8284L19.7574 16.2426L24.0001 12L19.7574 7.75735L18.3432 9.17157L20.1717 11H14.0001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsMergeAltH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5033 6H3.5033V11H7.6749L5.84644 9.17154L7.26066 7.75732L11.5033 12L7.26066 16.2426L5.84644 14.8284L7.67483 13H3.5033V18H1.5033V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.4967 6H22.4967V18H20.4967V13H16.3251L18.1536 14.8285L16.7393 16.2427L12.4967 12L16.7393 7.75739L18.1536 9.17161L16.3252 11H20.4967V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsMergeAltV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.5033V3.5033L13 3.5033V7.6749L14.8285 5.84644L16.2427 7.26066L12 11.5033L7.75739 7.26066L9.17161 5.84644L11 7.67483V3.5033L6 3.5033V1.5033L18 1.5033Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20.4967V22.4967H6V20.4967H11V16.3251L9.17154 18.1536L7.75732 16.7393L12 12.4967L16.2426 16.7393L14.8284 18.1536L13 16.3252V20.4967H18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsScrollH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3052 12L18.1299 9.17526L16.7157 7.76105L13.891 10.5858L13.8873 10.5821L12.4731 11.9963L12.4768 12L12.4731 12.0037L13.8873 13.4179L13.891 13.4142L16.7157 16.239L18.1299 14.8248L15.3052 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1091 10.5858L10.1128 10.5821L11.527 11.9963L11.5233 12L11.527 12.0037L10.1128 13.4179L10.1091 13.4142L7.28433 16.239L5.87012 14.8248L8.69487 12L5.87012 9.17526L7.28433 7.76105L10.1091 10.5858Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsScrollV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4142 10.1091L13.4179 10.1128L12.0037 11.527L12 11.5233L11.9963 11.527L10.5821 10.1128L10.5858 10.1091L7.76105 7.28433L9.17526 5.87012L12 8.69486L14.8247 5.87012L16.239 7.28433L13.4142 10.1091Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15.3052L14.8247 18.1299L16.239 16.7157L13.4142 13.891L13.4179 13.8873L12.0037 12.4731L12 12.4767L11.9963 12.4731L10.5821 13.8873L10.5858 13.891L7.76105 16.7157L9.17526 18.1299L12 15.3052Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsShrinkH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 7H3V17H1V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.44769 7.75732L9.86191 9.17154L8.03344 11H15.9664L14.138 9.17154L15.5522 7.75732L19.7948 12L15.5522 16.2426L14.138 14.8284L15.9664 13H8.03354L9.86194 14.8284L8.44773 16.2426L4.20505 12L8.44769 7.75732Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7H21V17H23V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsShrinkV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1V3L7 3V1L17 1Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2427 8.44772L14.8285 9.86194L13 8.03347L13 15.9665L14.8285 14.138L16.2427 15.5522L12 19.7949L7.75742 15.5522L9.17163 14.138L11 15.9664L11 8.03357L9.17163 9.86194L7.75742 8.44772L12 4.20508L16.2427 8.44772Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 23V21H7V23H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsVAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1716 6.45504L7.75739 5.04083L12 0.798187L16.2426 5.04083L14.8284 6.45504L13.0001 4.62667V19.3733L14.8284 17.5449L16.2426 18.9592L12 23.2018L7.75739 18.9592L9.1716 17.5449L11.0001 19.3734V4.62658L9.1716 6.45504Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgArrowsV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75739 5.04077L9.1716 6.45498L11.0001 4.62652V10H13.0001V4.62661L14.8284 6.45498L16.2426 5.04077L12 0.798126L7.75739 5.04077Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2426 18.9593L14.8284 17.545L13.0001 19.3734V14H11.0001V19.3735L9.1716 17.545L7.75739 18.9593L12 23.2019L16.2426 18.9593Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAssign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6H10V4H4V10H6V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18H6V14H4V20H10V18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6H18V10H20V4H14V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18H18V14H20V20H14V18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAsterisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H13V10.079L16.3413 7.73938L17.4885 9.37768L13.7434 12L17.4885 14.6223L16.3413 16.2606L13 13.921V18H11V13.921L7.65864 16.2606L6.51148 14.6223L10.2565 12L6.51147 9.37769L7.65863 7.73938L11 10.079V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAtlasian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": "0.8",
                    "d": "M8.50705 11.5562C8.19028 11.1038 7.78219 11.1585 7.59556 11.6783L5 18.9075H10.1778C10.6982 16.85 10.2481 14.0427 9.08063 12.3754L8.50705 11.5562Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8745 7.12641C11.6074 8.93603 11.1992 12.0835 11.9627 14.1565L13.7126 18.9074H18.9644L14.3673 6.42648C14.1764 5.90823 13.7649 5.85485 13.4481 6.30726L12.8745 7.12641Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAttachment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0C16.7614 0 19 2.23858 19 5V17C19 20.866 15.866 24 12 24C8.13401 24 5 20.866 5 17V9H7V17C7 19.7614 9.23858 22 12 22C14.7614 22 17 19.7614 17 17V5C17 3.34315 15.6569 2 14 2C12.3431 2 11 3.34315 11 5V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V6H15V17C15 18.6569 13.6569 20 12 20C10.3431 20 9 18.6569 9 17V5C9 2.23858 11.2386 0 14 0Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAttribution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8C6.74028 8 7.38663 7.5978 7.73244 7H14C15.1046 7 16 7.89543 16 9C16 10.1046 15.1046 11 14 11H10C7.79086 11 6 12.7909 6 15C6 17.2091 7.79086 19 10 19H16.2676C16.6134 19.5978 17.2597 20 18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C17.2597 16 16.6134 16.4022 16.2676 17H10C8.89543 17 8 16.1046 8 15C8 13.8954 8.89543 13 10 13H14C16.2091 13 18 11.2091 18 9C18 6.79086 16.2091 5 14 5H7.73244C7.38663 4.4022 6.74028 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgAwards(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 9C19 11.3787 17.8135 13.4804 16 14.7453V22H13.4142L12 20.5858L10.5858 22H8V14.7453C6.18652 13.4804 5 11.3787 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9ZM17 9C17 11.7614 14.7614 14 12 14C9.23858 14 7 11.7614 7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9ZM10 19.7573L12 17.7573L14 19.7574V15.7101C13.3663 15.8987 12.695 16 12 16C11.305 16 10.6337 15.8987 10 15.7101V19.7573Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7427 8.46448L19.1569 9.87869L17.0356 12L19.157 14.1214L17.7428 15.5356L15.6214 13.4142L13.5 15.5355L12.0858 14.1213L14.2072 12L12.0859 9.87878L13.5002 8.46457L15.6214 10.5858L17.7427 8.46448Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.58579 19L2.29289 12.7071C1.90237 12.3166 1.90237 11.6834 2.29289 11.2929L8.58579 5H22.5857V19H8.58579ZM9.41421 7L4.41421 12L9.41421 17H20.5857V7H9.41421Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBandAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9389 9.76478C11.7055 10.2653 11.1105 10.4819 10.61 10.2485C10.1094 10.0151 9.89288 9.42008 10.1263 8.91954C10.3597 8.419 10.9547 8.20244 11.4552 8.43585C11.9558 8.66925 12.1723 9.26423 11.9389 9.76478Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9195 13.8737C9.42004 14.1071 10.015 13.8905 10.2484 13.39C10.4818 12.8895 10.2653 12.2945 9.76474 12.0611C9.2642 11.8277 8.66922 12.0442 8.43581 12.5448C8.20241 13.0453 8.41896 13.6403 8.9195 13.8737Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8737 15.0805C13.6403 15.581 13.0453 15.7976 12.5447 15.5642C12.0442 15.3308 11.8276 14.7358 12.061 14.2352C12.2944 13.7347 12.8894 13.5181 13.39 13.7516C13.8905 13.985 14.1071 14.5799 13.8737 15.0805Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.2352 11.9389C14.7357 12.1723 15.3307 11.9558 15.5641 11.4552C15.7975 10.9547 15.581 10.3597 15.0804 10.1263C14.5799 9.89292 13.9849 10.1095 13.7515 10.61C13.5181 11.1106 13.7347 11.7055 14.2352 11.9389Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17.0714 1.12432C14.0682 -0.276119 10.4983 1.02321 9.09783 4.02645L4.02641 14.9021C2.62598 17.9054 3.92531 21.4753 6.92855 22.8757C9.93179 24.2761 13.5017 22.9768 14.9021 19.9736L19.9735 9.09787C21.374 6.09463 20.0746 2.52475 17.0714 1.12432ZM13.9347 17.3157L17.3157 10.0653L10.0652 6.6843L6.68427 13.9348L13.9347 17.3157ZM13.0895 19.1283L5.83903 15.7474C4.90541 17.7495 5.77163 20.1295 7.77379 21.0631C9.77595 21.9967 12.1559 21.1305 13.0895 19.1283ZM16.2262 2.93693C18.2283 3.87055 19.0945 6.25047 18.1609 8.25264L10.9104 4.87169C11.8441 2.86953 14.224 2.00331 16.2262 2.93693Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBatteryEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 6H5C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18H18C19.6569 18 21 16.6569 21 15C21.5523 15 22 14.5523 22 14V10C22 9.44772 21.5523 9 21 9C21 7.34315 19.6569 6 18 6ZM18 8H5C4.44772 8 4 8.44772 4 9V15C4 15.5523 4.44772 16 5 16H18C18.5523 16 19 15.5523 19 15V9C19 8.44772 18.5523 8 18 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15C5.44772 15 5 14.5523 5 14V10C5 9.44772 5.44772 9 6 9H17C17.5523 9 18 9.44772 18 10V14C18 14.5523 17.5523 15 17 15H6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 6H5C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18H18C19.6569 18 21 16.6569 21 15C21.5523 15 22 14.5523 22 14V10C22 9.44772 21.5523 9 21 9C21 7.34315 19.6569 6 18 6ZM18 8H5C4.44772 8 4 8.44772 4 9V15C4 15.5523 4.44772 16 5 16H18C18.5523 16 19 15.5523 19 15V9C19 8.44772 18.5523 8 18 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15C5.44772 15 5 14.5523 5 14V10C5 9.44772 5.44772 9 6 9H12V15H6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 6H5C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18H18C19.6569 18 21 16.6569 21 15C21.5523 15 22 14.5523 22 14V10C22 9.44772 21.5523 9 21 9C21 7.34315 19.6569 6 18 6ZM18 8H5C4.44772 8 4 8.44772 4 9V15C4 15.5523 4.44772 16 5 16H18C18.5523 16 19 15.5523 19 15V9C19 8.44772 18.5523 8 18 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17.9513 15.571C17.7695 17.2187 16.9205 18.6654 15.6805 19.635C15.332 20.4692 14.7092 21.1601 13.9247 21.5951C13.7025 22.4574 12.9196 23.0944 11.9879 23.0944C11.0562 23.0944 10.2733 22.4574 10.0511 21.5951C9.26672 21.1602 8.64392 20.4693 8.29547 19.6353C7.05955 18.6691 6.21203 17.229 6.02621 15.5883C4.93527 16.4161 3.37955 16.4118 2.28618 15.4944C1.01696 14.4294 0.851409 12.5371 1.91641 11.2679L6.00966 6.38975C6.27125 3.31753 8.84785 0.905579 11.9878 0.905579C15.1166 0.905579 17.6861 3.30046 17.9631 6.35711L22.0837 11.2679C23.1487 12.5371 22.9831 14.4294 21.7139 15.4944C20.613 16.4182 19.0433 16.4161 17.9513 15.571ZM15.6254 12.9056L13.9472 10.9056H10.0529L8.37467 12.9056H15.6254ZM17.9878 12.6095L19.0195 13.839C19.3745 14.2621 20.0053 14.3173 20.4283 13.9623C20.8514 13.6073 20.9066 12.9765 20.5516 12.5535L17.9878 9.49803V12.6095ZM15.9878 8.90558V6.90558C15.9878 4.69644 14.1969 2.90558 11.9878 2.90558C9.77865 2.90558 7.98779 4.69644 7.98779 6.90558V8.90558H15.9878ZM4.98059 13.839L5.98779 12.6387V9.52726L3.4485 12.5535C3.0935 12.9765 3.14869 13.6073 3.57176 13.9623C3.99483 14.3173 4.62559 14.2621 4.98059 13.839ZM11.9878 18.9056C9.77865 18.9056 7.98779 17.1147 7.98779 14.9056H15.9878C15.9878 17.1147 14.1969 18.9056 11.9878 18.9056Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 3V3.28988C16.8915 4.15043 19 6.82898 19 10V17H20V19H4V17H5V10C5 6.82898 7.10851 4.15043 10 3.28988V3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3ZM7 17H17V10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10V17ZM14 21V20H10V21C10 22.1046 10.8954 23 12 23C13.1046 23 14 22.1046 14 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBitbucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.5831 4.63507C4.03082 4.63507 3.66768 5.07472 3.77202 5.61706L6.22804 18.383C6.33238 18.9253 6.86468 19.3649 7.41696 19.3649H16.583C17.1353 19.3649 17.6676 18.9253 17.7719 18.383L20.2279 5.61706C20.3323 5.07472 19.9691 4.63507 19.4168 4.63507H4.5831ZM13.5449 14.3649L14.4549 9.63507H9.54504L10.455 14.3649H13.5449Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.46457 14.1213C8.07404 14.5118 8.07404 15.145 8.46457 15.5355C8.85509 15.926 9.48825 15.926 9.87878 15.5355L15.5356 9.87862C15.9262 9.4881 15.9262 8.85493 15.5356 8.46441C15.1451 8.07388 14.5119 8.07388 14.1214 8.46441L8.46457 14.1213Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569C20.781 14.5327 20.781 9.46734 17.6569 6.34315C14.5327 3.21895 9.46734 3.21895 6.34315 6.34315C3.21895 9.46734 3.21895 14.5327 6.34315 17.6569ZM16.2426 16.2426C13.8995 18.5858 10.1005 18.5858 7.75736 16.2426C5.41421 13.8995 5.41421 10.1005 7.75736 7.75736C10.1005 5.41421 13.8995 5.41421 16.2426 7.75736C18.5858 10.1005 18.5858 13.8995 16.2426 16.2426Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBmw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM5 12C5 15.866 8.13401 19 12 19V12H19C19 8.13401 15.866 5 12 5V12H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 4C3.79086 4 2 5.79086 2 8V16C2 18.2091 3.79086 20 6 20H18C20.2091 20 22 18.2091 22 16V8C22 5.79086 20.2091 4 18 4H6ZM14 6H10V18H14V6ZM16 6V18H18C19.1046 18 20 17.1046 20 16V8C20 6.89543 19.1046 6 18 6H16ZM6 18H8V6H6C4.89543 6 4 6.89543 4 8V16C4 17.1046 4.89543 18 6 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21.5L17.5 13L13 10L15 2.5L6.5 11L11 14L9 21.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 20H17.1717L12.7072 15.5354C12.3166 15.1449 11.6835 15.1449 11.2929 15.5354L6.82843 20L5 20V7C5 5.34315 6.34315 4 8 4H16C17.6569 4 19 5.34314 19 7V20ZM17 7C17 6.44772 16.5523 6 16 6H8C7.44772 6 7 6.44772 7 7V17L9.87873 14.1212C11.0503 12.9497 12.9498 12.9497 14.1214 14.1212L17 16.9999V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 6.5H17.5V17.5H6.5V6.5Z",
                    "stroke": "currentColor",
                    "strokeWidth": "3"
                }
            }
        ]
    })(props);
}
function CgBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H16V15H19V5H5V15H8V8Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H19V20H5V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8V16H9L9 19H19L19 5L9 5V8H16Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5L7 19H4L4 5L7 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16V8H15V5L5 5L5 19H15L15 16H8Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19L17 5L20 5L20 19H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderStyleDashed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11H8V13H4V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11H14V13H10V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H16V13H20V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderStyleDotted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11H1V13H3V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H5V13H7V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H11V13H9V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H13V13H15V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11H19V13H17V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11H21V13H23V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderStyleSolid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11H22V13H2V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H16V9L19 9L19 19L5 19L5 9L8 9V16Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7L19 7V4L5 4L5 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1254 13H10.1254V15H14.1254V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.12537 13C9.22994 13 10.1254 12.1046 10.1254 11C10.1254 9.89543 9.22994 9 8.12537 9C7.0208 9 6.12537 9.89543 6.12537 11C6.12537 12.1046 7.0208 13 8.12537 13ZM8.12537 11.5C8.40151 11.5 8.62537 11.2761 8.62537 11C8.62537 10.7239 8.40151 10.5 8.12537 10.5C7.84922 10.5 7.62537 10.7239 7.62537 11C7.62537 11.2761 7.84922 11.5 8.12537 11.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.1254 11C18.1254 12.1046 17.2299 13 16.1254 13C15.0208 13 14.1254 12.1046 14.1254 11C14.1254 9.89543 15.0208 9 16.1254 9C17.2299 9 18.1254 9.89543 18.1254 11ZM16.6254 11C16.6254 11.2761 16.4015 11.5 16.1254 11.5C15.8492 11.5 15.6254 11.2761 15.6254 11C15.6254 10.7239 15.8492 10.5 16.1254 10.5C16.4015 10.5 16.6254 10.7239 16.6254 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.74884 14.6663C3.73056 16.6421 5.76939 18 8.12537 18H16.1254C18.5654 18 20.6652 16.5435 21.6029 14.4525C22.3722 13.9093 22.8746 13.0133 22.8746 12C22.8746 10.9867 22.3722 10.0907 21.6029 9.54753C20.6652 7.45651 18.5654 6 16.1254 6H8.12537C5.76939 6 3.73056 7.3579 2.74884 9.33375C1.78448 9.83263 1.12537 10.8393 1.12537 12C1.12537 13.1607 1.78448 14.1674 2.74884 14.6663ZM8.12537 8H16.1254C17.5088 8 18.7282 8.70234 19.4465 9.76991C19.7227 10.4593 19.8746 11.2119 19.8746 12C19.8746 12.7881 19.7227 13.5407 19.4465 14.2301C18.7282 15.2977 17.5088 16 16.1254 16H8.12537C5.91623 16 4.12537 14.2091 4.12537 12C4.12537 9.79086 5.91623 8 8.12537 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBowl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20.5468 3.67162C20.1563 3.28109 19.5231 3.28109 19.1326 3.67162L13.7687 9.03555H2V11.0356H2.00842C2.22563 16.3663 6.61591 20.6213 12 20.6213C17.3841 20.6213 21.7744 16.3663 21.9916 11.0356H22V9.03555H16.5971L20.5468 5.08583C20.9374 4.69531 20.9374 4.06214 20.5468 3.67162ZM14.1762 11.0356C14.1806 11.0356 14.1851 11.0356 14.1896 11.0356H19.9895C19.7739 15.2613 16.2793 18.6213 12 18.6213C7.72066 18.6213 4.22609 15.2613 4.01054 11.0356H14.1762Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12C9.44769 12 9 12.4477 9 13C9 13.5523 9.44769 14 10 14H14C14.5522 14 15 13.5523 15 13C15 12.4477 14.5522 12 14 12H10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 2C2.34314 2 1 3.34314 1 5V19C1 20.6569 2.34314 22 4 22H20C21.6569 22 23 20.6569 23 19V5C23 3.34314 21.6569 2 20 2H4ZM20 4H4C3.44769 4 3 4.44769 3 5V8H21V5C21 4.44769 20.5522 4 20 4ZM3 19V10H21V19C21 19.5523 20.5522 20 20 20H4C3.44769 20 3 19.5523 3 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44771 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13C16 13.5523 15.5523 14 15 14C14.4477 14 14 13.5523 14 13C14 12.4477 14.4477 12 15 12C15.5523 12 16 12.4477 16 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 11.1637 19.8717 10.3574 19.6337 9.59973C18.7991 9.82556 17.9212 9.94604 17.0152 9.94604C13.2921 9.94604 10.0442 7.91139 8.32277 4.89334C5.75469 6.22486 4 8.90751 4 12C4 16.4183 7.58172 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBrackets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7V9H9V15H11V17H7V7H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H13V17H17V7H13V9H15V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11H10V13H14V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 5V4C7 2.89545 7.89539 2 9 2H15C16.1046 2 17 2.89545 17 4V5H20C21.6569 5 23 6.34314 23 8V18C23 19.6569 21.6569 21 20 21H4C2.34314 21 1 19.6569 1 18V8C1 6.34314 2.34314 5 4 5H7ZM9 4H15V5H9V4ZM4 7C3.44775 7 3 7.44769 3 8V14H21V8C21 7.44769 20.5522 7 20 7H4ZM3 18V16H21V18C21 18.5523 20.5522 19 20 19H4C3.44775 19 3 18.5523 3 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBrowse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.364 13.1214C15.2876 14.045 15.4831 15.4211 14.9504 16.5362L16.4853 18.0711C16.8758 18.4616 16.8758 19.0948 16.4853 19.4853C16.0948 19.8758 15.4616 19.8758 15.0711 19.4853L13.5361 17.9504C12.421 18.4831 11.045 18.2876 10.1213 17.364C8.94975 16.1924 8.94975 14.2929 10.1213 13.1214C11.2929 11.9498 13.1924 11.9498 14.364 13.1214ZM12.9497 15.9498C13.3403 15.5593 13.3403 14.9261 12.9497 14.5356C12.5592 14.145 11.9261 14.145 11.5355 14.5356C11.145 14.9261 11.145 15.5593 11.5355 15.9498C11.9261 16.3403 12.5592 16.3403 12.9497 15.9498Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5H16V7H8V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9H8V11H16V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 4C4 2.34315 5.34315 1 7 1H17C18.6569 1 20 2.34315 20 4V20C20 21.6569 18.6569 23 17 23H7C5.34315 23 4 21.6569 4 20V4ZM7 3H17C17.5523 3 18 3.44772 18 4V20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20V4C6 3.44772 6.44771 3 7 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBrowser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8C4.55228 8 5 7.55228 5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44771 6 9 6.44772 9 7C9 7.55228 9.44771 8 10 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34315 21 3 21H21C22.6569 21 24 19.6569 24 18V6C24 4.34315 22.6569 3 21 3H3ZM21 5H3C2.44772 5 2 5.44772 2 6V9H22V6C22 5.44772 21.5523 5 21 5ZM2 18V11H22V18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 11H18C18.5523 11 19 11.4477 19 12V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V12C5 11.4477 5.44772 11 6 11H9V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V11ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V13H7V18C7 18.5523 7.44772 19 8 19H9V16H11V19H13V16H15V19H16C16.5523 19 17 18.5523 17 18V13H13V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 9C4 11.9611 5.60879 14.5465 8 15.9297V15.9999C8 18.2091 9.79086 19.9999 12 19.9999C14.2091 19.9999 16 18.2091 16 15.9999V15.9297C18.3912 14.5465 20 11.9611 20 9C20 4.58172 16.4183 1 12 1C7.58172 1 4 4.58172 4 9ZM16 13.4722C17.2275 12.3736 18 10.777 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 10.777 6.7725 12.3736 8 13.4722L10 13.4713V16C10 17.1045 10.8954 17.9999 12 17.9999C13.1045 17.9999 14 17.1045 14 15.9999V13.4713L16 13.4722Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 21.0064V21C10.5883 21.3403 11.2714 21.5351 12 21.5351C12.7286 21.5351 13.4117 21.3403 14 21V21.0064C14 22.111 13.1046 23.0064 12 23.0064C10.8954 23.0064 10 22.111 10 21.0064Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCPlusPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.207 16.278C11.1241 17.343 9.63879 18 8 18C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6C9.67492 6 11.1896 6.6863 12.278 7.79303L13.6923 6.37878C12.2418 4.91014 10.2272 4 8 4C3.58172 4 0 7.58172 0 12C0 16.4183 3.58172 20 8 20C10.1911 20 12.1764 19.1192 13.6212 17.6923L12.207 16.278Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H13V11H11V13H13V15H15V13H17V11H15V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9H22V11H24V13H22V15H20V13H18V11H20V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7V7H17V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9H9V11H7V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13H7V15H9V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17H9V19H7V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9H11V11H13V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13H13V15H11V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17H11V19H13V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H17V11H15V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13H15V19H17V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3C3 1.89543 3.89543 1 5 1H19C20.1046 1 21 1.89543 21 3V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V3ZM5 3H19V21H5V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalendarDates(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM18 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalendarDue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8C7 7.44772 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16C13.1046 16 14 15.1046 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 15.1046 10.8954 16 12 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM18 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalendarNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.7249 16.5461L16.2249 13.9481L11.7249 11.35V12.9481H7.7749V14.9481H11.7249V16.5461Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM18 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalendarToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17C16.1046 17 17 16.1046 17 15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM5 18V7H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalendarTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9C7.44772 9 7 9.44771 7 10C7 10.5523 7.44772 11 8 11H16C16.5523 11 17 10.5523 17 10C17 9.44771 16.5523 9 16 9H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM5 18V7H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCalibrate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0503 5C14.51 5 16.7393 5.98676 18.3638 7.58602L14.1208 11.8291C13.5824 11.3154 12.8531 11 12.0503 11C11.1963 11 10.4256 11.3568 9.87927 11.9295L5.63623 7.68651C7.26871 6.0282 9.53941 5 12.0503 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0503 19C13.7071 19 15.0503 17.6569 15.0503 16C15.0503 14.3431 13.7071 13 12.0503 13C10.3934 13 9.05029 14.3431 9.05029 16C9.05029 17.6569 10.3934 19 12.0503 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 4.5V6.5H12V7.5H3C1.34315 7.5 0 8.84315 0 10.5V16.5C0 18.1569 1.34315 19.5 3 19.5H15C16.5731 19.5 17.8634 18.2892 17.9898 16.7487L24 17.5V9.5L17.9898 10.2513C17.8634 8.71078 16.5731 7.5 15 7.5H14V5.5C14 4.94772 13.5523 4.5 13 4.5H4ZM18 12.2656V14.7344L22 15.2344V11.7656L18 12.2656ZM16 10.5C16 9.94772 15.5523 9.5 15 9.5H3C2.44772 9.5 2 9.94772 2 10.5V16.5C2 17.0523 2.44772 17.5 3 17.5H15C15.5523 17.5 16 17.0523 16 16.5V10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 18V20H16V18H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.988 3.2203C13.9959 3.14796 14 3.07446 14 3C14 1.89543 13.1046 1 12 1C10.8954 1 10 1.89543 10 3C10 3.07446 10.0041 3.14796 10.012 3.2203C5.99799 4.12533 3 7.71255 3 12C3 12.3883 3.02459 12.7709 3.0723 13.1462C1.86949 13.5369 1 14.6669 1 16V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V16C23 14.6669 22.1305 13.5369 20.9277 13.1462C20.9754 12.7709 21 12.3883 21 12C21 7.71255 18.002 4.12533 13.988 3.2203ZM12 5C8.13401 5 5 8.13401 5 12C5 12.3402 5.02412 12.674 5.07063 13H18.9294C18.9759 12.674 19 12.3402 19 12C19 8.13401 15.866 5 12 5ZM3 16C3 15.4477 3.44772 15 4 15H20C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCaptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8V10H8V14H11V16H6V8H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8V10H15V14H18V16H13V8H18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5ZM4 18V6H20V18H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCardClubs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13C11 14.1046 10.1046 15 9 15C7.89543 15 7 14.1046 7 13C7 11.8954 7.89543 11 9 11C10.1046 11 11 11.8954 11 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15C16.1046 15 17 14.1046 17 13C17 11.8954 16.1046 11 15 11C13.8954 11 13 11.8954 13 13C13 14.1046 13.8954 15 15 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4C3 2.34315 4.34315 1 6 1H18C19.6569 1 21 2.34315 21 4V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM6 3H18C18.5523 3 19 3.44772 19 4V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCardDiamonds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.75736L7.75736 12L12 16.2426L16.2426 12L12 7.75736Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4C3 2.34315 4.34315 1 6 1H18C19.6569 1 21 2.34315 21 4V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM6 3H18C18.5523 3 19 3.44772 19 4V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCardHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.14648 12.2929C8.36544 11.5118 8.36544 10.2455 9.14648 9.46444C9.92753 8.68339 11.1939 8.68339 11.9749 9.46444L12 9.48955L12.0251 9.46449C12.8061 8.68345 14.0725 8.68345 14.8535 9.46449C15.6346 10.2455 15.6346 11.5119 14.8535 12.2929L12.0251 15.1213L12 15.0962L11.9749 15.1213L9.14648 12.2929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4C3 2.34315 4.34315 1 6 1H18C19.6569 1 21 2.34315 21 4V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM6 3H18C18.5523 3 19 3.44772 19 4V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCardSpades(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.14648 11.7071C8.36544 12.4882 8.36544 13.7545 9.14648 14.5356C9.92753 15.3166 11.1939 15.3166 11.9749 14.5356L12 14.5104L12.0251 14.5355C12.8061 15.3166 14.0725 15.3166 14.8535 14.5355C15.6346 13.7545 15.6346 12.4881 14.8535 11.7071L12.0251 8.87865L12 8.90377L11.9749 8.87871L9.14648 11.7071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V4C21 2.34315 19.6569 1 18 1H6C4.34315 1 3 2.34315 3 4V20ZM6 21H18C18.5523 21 19 20.5523 19 20V4C19 3.44772 18.5523 3 18 3H6C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCarousel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C2.34315 3 1 4.34315 1 6V10C1 11.6569 2.34315 13 4 13H20C21.6569 13 23 11.6569 23 10V6C23 4.34315 21.6569 3 20 3H4ZM20 5H4C3.44772 5 3 5.44772 3 6V10C3 10.5523 3.44772 11 4 11H20C20.5523 11 21 10.5523 21 10V6C21 5.44771 20.5523 5 20 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20C7 19.4477 7.44772 19 8 19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H4V8H2V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H15V18H20V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13C5.86599 13 9 16.134 9 20H7C7 17.2386 4.76142 15 2 15V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17C3.65685 17 5 18.3431 5 20H2V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9C8.07513 9 13 13.9249 13 20H11C11 15.0294 6.97056 11 2 11V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.07178 3.17291C4.32593 3.5202 2.72229 4.37738 1.46362 5.63605L3.59332 7.76575C4.43079 6.92835 5.4978 6.35803 6.65936 6.12695C7.53564 5.95264 8.43604 5.9773 9.29523 6.19452C9.0791 6.45056 8.87671 6.71936 8.68927 6.99988C7.70032 8.47992 7.17249 10.22 7.17249 12C7.17249 13.78 7.70032 15.5201 8.68927 17.0001C8.87671 17.2806 9.07916 17.5494 9.29529 17.8055C8.4361 18.0227 7.53564 18.0474 6.65936 17.873C5.4978 17.642 4.43079 17.0717 3.59332 16.2343L1.46362 18.364C2.72229 19.6226 4.32593 20.4798 6.07178 20.8271C7.81757 21.1743 9.6272 20.9961 11.2717 20.3149C11.5201 20.212 11.7632 20.0983 12.0001 19.9744C12.2369 20.0983 12.4799 20.212 12.7283 20.3149C14.3729 20.9961 16.1825 21.1743 17.9283 20.8271C19.6741 20.4798 21.2778 19.6226 22.5364 18.364L20.4067 16.2343C19.5693 17.0717 18.5023 17.642 17.3407 17.873C16.4644 18.0474 15.564 18.0227 14.7048 17.8055C14.9209 17.5494 15.1234 17.2806 15.3108 17.0001C16.2997 15.5201 16.8276 13.78 16.8276 12C16.8276 10.22 16.2997 8.47992 15.3108 6.99988C15.1234 6.71936 14.921 6.45056 14.7048 6.19452C15.564 5.9773 16.4644 5.95264 17.3407 6.12695C18.5023 6.35803 19.5693 6.92835 20.4067 7.76575L22.5364 5.63605C21.2778 4.37738 19.6741 3.5202 17.9283 3.17291C16.1825 2.82568 14.3729 3.00391 12.7283 3.68506C12.4799 3.78796 12.2369 3.90167 12.0001 4.02564C11.7632 3.90167 11.5201 3.78796 11.2717 3.68506C9.6272 3.00391 7.81757 2.82568 6.07178 3.17291ZM12.0001 7.7049C11.6994 7.99695 11.4288 8.32117 11.1935 8.67316C10.5356 9.6579 10.1844 10.8157 10.1844 12C10.1844 13.1843 10.5356 14.3421 11.1935 15.3268C11.4288 15.6788 11.6994 16.0031 12.0001 16.2951C12.3007 16.0031 12.5713 15.6788 12.8065 15.3268C13.4645 14.3421 13.8157 13.1843 13.8157 12C13.8157 10.8157 13.4645 9.6579 12.8065 8.67316C12.5713 8.32117 12.3007 7.99695 12.0001 7.7049Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22.775 8C22.9242 8.65461 23 9.32542 23 10H14V1C14.6746 1 15.3454 1.07584 16 1.22504C16.4923 1.33724 16.9754 1.49094 17.4442 1.68508C18.5361 2.13738 19.5282 2.80031 20.364 3.63604C21.1997 4.47177 21.8626 5.46392 22.3149 6.55585C22.5091 7.02455 22.6628 7.5077 22.775 8ZM20.7082 8C20.6397 7.77018 20.5593 7.54361 20.4672 7.32122C20.1154 6.47194 19.5998 5.70026 18.9497 5.05025C18.2997 4.40024 17.5281 3.88463 16.6788 3.53284C16.4564 3.44073 16.2298 3.36031 16 3.2918V8H20.7082Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 14C1 9.02944 5.02944 5 10 5C10.6746 5 11.3454 5.07584 12 5.22504V12H18.775C18.9242 12.6546 19 13.3254 19 14C19 18.9706 14.9706 23 10 23C5.02944 23 1 18.9706 1 14ZM16.8035 14H10V7.19648C6.24252 7.19648 3.19648 10.2425 3.19648 14C3.19648 17.7575 6.24252 20.8035 10 20.8035C13.7575 20.8035 16.8035 17.7575 16.8035 14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCheckO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.2426 16.3137L6 12.071L7.41421 10.6568L10.2426 13.4853L15.8995 7.8284L17.3137 9.24262L10.2426 16.3137Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCheckR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.2426 16.3137L6 12.071L7.41421 10.6568L10.2426 13.4853L15.8995 7.8284L17.3137 9.24262L10.2426 16.3137Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5858 13.4142L7.75735 10.5858L6.34314 12L10.5858 16.2427L17.6568 9.1716L16.2426 7.75739L10.5858 13.4142Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleDownO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75732 8.46448L9.17154 7.05026L12 9.87869L14.8284 7.05029L16.2426 8.46451L12 12.7071L7.75732 8.46448Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 11.2929L7.75732 12.7071L11.9999 16.9498L16.2426 12.7071L14.8284 11.2929L12 14.1213L9.17154 11.2929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleDownR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75732 8.46448L9.17154 7.05026L12 9.87869L14.8284 7.05029L16.2426 8.46451L12 12.7071L7.75732 8.46448Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 11.2929L7.75732 12.7071L11.9999 16.9498L16.2426 12.7071L14.8284 11.2929L12 14.1213L9.17154 11.2929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75735 5.63605L6.34314 7.05026L12 12.7071L17.6569 7.05029L16.2427 5.63608L12 9.87872L7.75735 5.63605Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.34314 12.7071L7.75735 11.2929L12 15.5356L16.2427 11.2929L17.6569 12.7071L12 18.364L6.34314 12.7071Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleLeftO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7071 9.1716L11.2929 7.75739L7.05024 12L11.2929 16.2426L12.7071 14.8284L9.87869 12L12.7071 9.1716Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5355 7.75739L16.9497 9.1716L14.1213 12L16.9497 14.8284L15.5355 16.2426L11.2929 12L15.5355 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7071 9.1716L11.2929 7.75739L7.05024 12L11.2929 16.2426L12.7071 14.8284L9.87869 12L12.7071 9.1716Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5355 7.75739L16.9497 9.1716L14.1213 12L16.9497 14.8284L15.5355 16.2426L11.2929 12L15.5355 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3639 7.75735L16.9497 6.34314L11.2929 12L16.9497 17.6568L18.3639 16.2426L14.1213 12L18.3639 7.75735Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2929 6.34314L12.7071 7.75735L8.46447 12L12.7071 16.2426L11.2929 17.6568L5.63605 12L11.2929 6.34314Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleRightO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.46448 7.75739L7.05026 9.1716L9.87869 12L7.05029 14.8284L8.46451 16.2426L12.7071 12L8.46448 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2929 9.1716L12.7071 7.75739L16.9498 12L12.7071 16.2426L11.2929 14.8284L14.1213 12L11.2929 9.1716Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.46448 7.75739L7.05026 9.1716L9.87869 12L7.05029 14.8284L8.46451 16.2426L12.7071 12L8.46448 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2929 9.1716L12.7071 7.75739L16.9498 12L12.7071 16.2426L11.2929 14.8284L14.1213 12L11.2929 9.1716Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 5C23 2.79086 21.2091 1 19 1H5C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5ZM19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.63605 7.75735L7.05026 6.34314L12.7071 12L7.05029 17.6568L5.63608 16.2426L9.87869 12L5.63605 7.75735Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7071 6.34314L11.2929 7.75735L15.5356 12L11.2929 16.2426L12.7072 17.6568L18.364 12L12.7071 6.34314Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleUpO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 12.7071L16.2426 11.2929L12 7.05027L7.75739 11.2929L9.1716 12.7071L12 9.87869L14.8284 12.7071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 16.9497L16.2426 15.5355L12 11.2929L7.75739 15.5355L9.1716 16.9497L12 14.1213L14.8284 16.9497Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleUpR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 12.4813L16.2426 11.067L12 6.82444L7.75732 11.0671L9.17154 12.4813L12 9.65286L14.8284 12.4813Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 16.7239L16.2426 15.3097L12 11.0671L7.75732 15.3097L9.17154 16.7239L12 13.8955L14.8284 16.7239Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 4.77411C23 2.56497 21.2091 0.774109 19 0.774109H5C2.79086 0.774109 1 2.56497 1 4.77411V18.7741C1 20.9832 2.79086 22.7741 5 22.7741H19C21.2091 22.7741 23 20.9832 23 18.7741V4.77411ZM19 2.77411H5C3.89543 2.77411 3 3.66954 3 4.77411V18.7741C3 19.8787 3.89543 20.7741 5 20.7741H19C20.1046 20.7741 21 19.8787 21 18.7741V4.77411C21 3.66954 20.1046 2.77411 19 2.77411Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDoubleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6569 11.2929L16.2427 12.7071L12 8.46444L7.75735 12.7071L6.34314 11.2929L12 5.63605L17.6569 11.2929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6569 16.9497L16.2427 18.3639L12 14.1213L7.75735 18.364L6.34314 16.9498L12 11.2929L17.6569 16.9497Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDownO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75745 10.5858L9.17166 9.17154L12.0001 12L14.8285 9.17157L16.2427 10.5858L12.0001 14.8284L7.75745 10.5858Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDownR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75739 10.5858L9.1716 9.17154L12 12L14.8284 9.17157L16.2426 10.5858L12 14.8284L7.75739 10.5858Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.34317 7.75732L4.92896 9.17154L12 16.2426L19.0711 9.17157L17.6569 7.75735L12 13.4142L6.34317 7.75732Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronLeftO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.75739L13.4142 9.1716L10.5858 12L13.4142 14.8285L12 16.2427L7.75736 12L12 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.75739L14.4142 9.1716L11.5858 12L14.4142 14.8284L13 16.2426L8.75736 12L13 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 1C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5C1 2.79086 2.79086 1 5 1H19ZM21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19L3 5C3 3.89543 3.89543 3 5 3L19 3C20.1046 3 21 3.89543 21 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronRightO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0858 7.75739L15.3284 12L11.0858 16.2427L9.67157 14.8285L12.5 12L9.67157 9.1716L11.0858 7.75739Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.4853 12.0451L12.2426 7.80249L10.8284 9.2167L13.6568 12.0451L10.8284 14.8736L12.2426 16.2878L16.4853 12.0451Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5858 6.34317L12 4.92896L19.0711 12L12 19.0711L10.5858 17.6569L16.2427 12L10.5858 6.34317Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronUpO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8285 14.8284L16.2427 13.4142L12.0001 9.17161L7.75745 13.4142L9.17166 14.8285L12.0001 12L14.8285 14.8284Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronUpR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8285 14.8284L16.2427 13.4142L12.0001 9.17161L7.75745 13.4142L9.17166 14.8285L12.0001 12L14.8285 14.8284Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5C2.79086 1 1 2.79086 1 5V19ZM5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6569 16.2427L19.0711 14.8285L12.0001 7.75739L4.92896 14.8285L6.34317 16.2427L12.0001 10.5858L17.6569 16.2427Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCircleci(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM4.14355 13.5165C4.85219 17.2096 8.10023 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C8.0886 4 4.83283 6.80704 4.13728 10.5165L6.72824 10.5071C7.37819 8.20738 9.49236 6.52222 12.0001 6.52222C15.0254 6.52222 17.4779 8.9747 17.4779 12C17.4779 15.0253 15.0254 17.4778 12.0001 17.4778C9.49752 17.4778 7.3869 15.7995 6.73228 13.5071L4.14355 13.5165ZM9.52234 12C9.52234 13.3684 10.6317 14.4778 12.0001 14.4778C13.3685 14.4778 14.4779 13.3684 14.4779 12C14.4779 10.6316 13.3685 9.52222 12.0001 9.52222C10.6317 9.52222 9.52234 10.6316 9.52234 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgClapperBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20.1702 3L20.1663 3.00453C21.7458 3.09084 23 4.39896 23 6V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6C1 4.34315 2.34315 3 4 3H20.1702ZM10.4764 5H16.4764L13.089 9H7.08899L10.4764 5ZM5.08899 9L8.47644 5H4C3.44772 5 3 5.44772 3 6V9H5.08899ZM3 11V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V11H3ZM21 9V6C21 5.44771 20.5523 5 20 5H18.4764L15.089 9H21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H15.9595C16.5118 13 16.9595 12.5523 16.9595 12C16.9595 11.4477 16.5118 11 15.9595 11H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.04053 15.0665C7.48824 15.0665 7.04053 15.5142 7.04053 16.0665C7.04053 16.6188 7.48824 17.0665 8.04053 17.0665H16C16.5523 17.0665 17 16.6188 17 16.0665C17 15.5142 16.5523 15.0665 16 15.0665H8.04053Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM7 5H5L5 19H19V5H17V6C17 7.65685 15.6569 9 14 9H10C8.34315 9 7 7.65685 7 6V5ZM9 5V6C9 6.55228 9.44772 7 10 7H14C14.5523 7 15 6.55228 15 6V5H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCloseO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3394 9.32245C16.7434 8.94589 16.7657 8.31312 16.3891 7.90911C16.0126 7.50509 15.3798 7.48283 14.9758 7.85938L12.0497 10.5866L9.32245 7.66048C8.94589 7.25647 8.31312 7.23421 7.90911 7.61076C7.50509 7.98731 7.48283 8.62008 7.85938 9.0241L10.5866 11.9502L7.66048 14.6775C7.25647 15.054 7.23421 15.6868 7.61076 16.0908C7.98731 16.4948 8.62008 16.5171 9.0241 16.1405L11.9502 13.4133L14.6775 16.3394C15.054 16.7434 15.6868 16.7657 16.0908 16.3891C16.4948 16.0126 16.5171 15.3798 16.1405 14.9758L13.4133 12.0497L16.3394 9.32245Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCloseR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3956 7.75734C16.7862 8.14786 16.7862 8.78103 16.3956 9.17155L13.4142 12.153L16.0896 14.8284C16.4802 15.2189 16.4802 15.8521 16.0896 16.2426C15.6991 16.6331 15.0659 16.6331 14.6754 16.2426L12 13.5672L9.32458 16.2426C8.93405 16.6331 8.30089 16.6331 7.91036 16.2426C7.51984 15.8521 7.51984 15.2189 7.91036 14.8284L10.5858 12.153L7.60436 9.17155C7.21383 8.78103 7.21383 8.14786 7.60436 7.75734C7.99488 7.36681 8.62805 7.36681 9.01857 7.75734L12 10.7388L14.9814 7.75734C15.372 7.36681 16.0051 7.36681 16.3956 7.75734Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H4ZM20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.738 19.9964C14.8186 19.9988 14.8994 20 14.9806 20C19.3989 20 22.9806 16.4183 22.9806 12C22.9806 7.58172 19.3989 4 14.9806 4C12.4542 4 10.2013 5.17108 8.73522 7H7.51941C3.92956 7 1.01941 9.91015 1.01941 13.5C1.01941 17.0899 3.92956 20 7.51941 20H14.5194C14.5926 20 14.6654 19.9988 14.738 19.9964ZM16.6913 17.721C19.0415 16.9522 20.9806 14.6815 20.9806 12C20.9806 8.68629 18.2943 6 14.9806 6C11.6669 6 8.98059 8.68629 8.98059 12H6.98059C6.98059 10.9391 7.1871 9.92643 7.56211 9H7.51941C5.03413 9 3.01941 11.0147 3.01941 13.5C3.01941 15.9853 5.03413 18 7.51941 18H14.5194C15.0691 18 15.9041 17.9014 16.6913 17.721Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCodeClimate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.49506 8.1109L3.1311 14.4749L4.54532 15.8891L9.49506 10.9393L14.4448 15.8891L15.859 14.4749L9.49506 8.1109Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5049 8.11092L12.5317 10.0842L13.9503 11.494L14.5049 10.9393L19.4547 15.8891L20.8689 14.4749L14.5049 8.11092Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCodeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.325 3.05011L8.66741 20.4323L10.5993 20.9499L15.2568 3.56775L13.325 3.05011Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.61197 18.3608L8.97136 16.9124L8.97086 16.8933L3.87657 12.1121L8.66699 7.00798L7.20868 5.63928L1.04956 12.2017L7.61197 18.3608Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.388 18.3608L15.0286 16.9124L15.0291 16.8933L20.1234 12.1121L15.333 7.00798L16.7913 5.63928L22.9504 12.2017L16.388 18.3608Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.95263 16.9123L8.59323 18.3608L2.03082 12.2016L8.18994 5.63922L9.64826 7.00791L4.85783 12.112L9.95212 16.8932L9.95263 16.9123Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0474 16.9123L15.4068 18.3608L21.9692 12.2016L15.8101 5.63922L14.3517 7.00791L19.1422 12.112L14.0479 16.8932L14.0474 16.9123Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.5C5.44772 2.5 5 2.94772 5 3.5V5.5C5 6.05228 5.44772 6.5 6 6.5C6.55228 6.5 7 6.05228 7 5.5V3.5C7 2.94772 6.55228 2.5 6 2.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 21.5C15.973 21.5 18.441 19.3377 18.917 16.5H19C21.2091 16.5 23 14.7091 23 12.5C23 10.2909 21.2091 8.5 19 8.5V7.5H1V15.5C1 18.8137 3.68629 21.5 7 21.5H13ZM3 9.5V15.5C3 17.7091 4.79086 19.5 7 19.5H13C15.2091 19.5 17 17.7091 17 15.5V9.5H3ZM21 12.5C21 13.6046 20.1046 14.5 19 14.5V10.5C20.1046 10.5 21 11.3954 21 12.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.5C9 2.94772 9.44771 2.5 10 2.5C10.5523 2.5 11 2.94772 11 3.5V5.5C11 6.05228 10.5523 6.5 10 6.5C9.44771 6.5 9 6.05228 9 5.5V3.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2.5C13.4477 2.5 13 2.94772 13 3.5V5.5C13 6.05228 13.4477 6.5 14 6.5C14.5523 6.5 15 6.05228 15 5.5V3.5C15 2.94772 14.5523 2.5 14 2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCollage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM13 4H17C17.5523 4 18 4.44772 18 5V13H13V4ZM13 15V20H17C17.5523 20 18 19.5523 18 19V15H13ZM11 4H7C6.44771 4 6 4.44772 6 5V8H11V4ZM6 19V10H11V20H7C6.44772 20 6 19.5523 6 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgColorBucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.20348 2.00378C9.46407 2.00378 10.5067 3.10742 10.6786 4.54241L19.1622 13.0259L11.384 20.8041C10.2124 21.9757 8.31291 21.9757 7.14134 20.8041L2.8987 16.5615C1.72713 15.3899 1.72713 13.4904 2.8987 12.3188L5.70348 9.51404V4.96099C5.70348 3.32777 6.82277 2.00378 8.20348 2.00378ZM8.70348 4.96099V6.51404L7.70348 7.51404V4.96099C7.70348 4.63435 7.92734 4.36955 8.20348 4.36955C8.47963 4.36955 8.70348 4.63435 8.70348 4.96099ZM8.70348 10.8754V9.34247L4.31291 13.733C3.92239 14.1236 3.92239 14.7567 4.31291 15.1473L8.55555 19.3899C8.94608 19.7804 9.57924 19.7804 9.96977 19.3899L16.3337 13.0259L10.7035 7.39569V10.8754C10.7035 10.9184 10.7027 10.9612 10.7012 11.0038H8.69168C8.69941 10.9625 8.70348 10.9195 8.70348 10.8754Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.8586 16.8749C15.687 18.0465 15.687 19.946 16.8586 21.1175C18.0302 22.2891 19.9297 22.2891 21.1013 21.1175C22.2728 19.946 22.2728 18.0465 21.1013 16.8749L18.9799 14.7536L16.8586 16.8749Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgColorPicker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3847 2.87868C19.2132 1.70711 17.3137 1.70711 16.1421 2.87868L14.0202 5.00052L13.313 4.29332C12.9225 3.9028 12.2894 3.9028 11.8988 4.29332C11.5083 4.68385 11.5083 5.31701 11.8988 5.70754L17.5557 11.3644C17.9462 11.7549 18.5794 11.7549 18.9699 11.3644C19.3604 10.9739 19.3604 10.3407 18.9699 9.95018L18.2629 9.24316L20.3847 7.12132C21.5563 5.94975 21.5563 4.05025 20.3847 2.87868Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.9297 7.09116L4.1515 14.8693C3.22786 15.793 3.03239 17.169 3.5651 18.2842L1.99994 19.8493L3.41415 21.2635L4.97931 19.6984C6.09444 20.2311 7.4705 20.0356 8.39414 19.112L16.1723 11.3338L11.9297 7.09116ZM13.3439 11.3338L11.9297 9.91959L5.56571 16.2835C5.17518 16.6741 5.17518 17.3072 5.56571 17.6978C5.95623 18.0883 6.5894 18.0883 6.97992 17.6978L13.3439 11.3338Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgComedyCentral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5445 19C14.4105 19 17.5445 15.866 17.5445 12C17.5445 8.13401 14.4105 5 10.5445 5C8.61148 5 6.86148 5.7835 5.59473 7.05025L3.47343 4.92896L3.45544 4.94694C5.26649 3.12672 7.7739 2 10.5445 2C16.0673 2 20.5445 6.47715 20.5445 12C20.5445 17.5228 16.0673 22 10.5445 22C7.78307 22 5.28308 20.8807 3.47343 19.0711L5.59475 16.9498C6.8615 18.2165 8.61149 19 10.5445 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5445 14C11.1376 14 11.6704 13.7418 12.0367 13.3317L14.1594 15.4544C13.249 16.4068 11.966 17 10.5445 17C7.78305 17 5.54447 14.7614 5.54447 12C5.54447 9.23858 7.78305 7 10.5445 7C11.966 7 13.249 7.59323 14.1594 8.54563L12.0367 10.6683C11.6704 10.2582 11.1376 10 10.5445 10C9.4399 10 8.54447 10.8954 8.54447 12C8.54447 13.1046 9.4399 14 10.5445 14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9H7V7H17V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13H17V11H7V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 18V2H22V18H16V22H14C11.7909 22 10 20.2091 10 18H2ZM12 16V18C12 19.1046 12.8954 20 14 20V16H20V4H4V16H12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCommunity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 17.456C11.2389 17.8053 10.3922 18 9.5 18C6.18629 18 3.5 15.3137 3.5 12C3.5 8.68629 6.18629 6 9.5 6C10.3922 6 11.2389 6.19474 12 6.54404C12.7611 6.19474 13.6078 6 14.5 6C17.8137 6 20.5 8.68629 20.5 12C20.5 15.3137 17.8137 18 14.5 18C13.6078 18 12.7611 17.8053 12 17.456ZM10.0003 15.969C9.83637 15.9895 9.66942 16 9.5 16C7.29086 16 5.5 14.2091 5.5 12C5.5 9.79086 7.29086 8 9.5 8C9.66942 8 9.83637 8.01053 10.0003 8.03098C9.06656 9.08871 8.5 10.4782 8.5 12C8.5 13.5218 9.06656 14.9113 10.0003 15.969ZM13.9998 8.03098C14.1636 8.01054 14.3306 8 14.5 8C16.7091 8 18.5 9.79086 18.5 12C18.5 14.2091 16.7091 16 14.5 16C14.3306 16 14.1636 15.9895 13.9998 15.969C14.9334 14.9113 15.5 13.5218 15.5 12C15.5 10.4782 14.9334 9.08872 13.9998 8.03098ZM12 8.87732C12.9145 9.61038 13.5 10.7368 13.5 12C13.5 13.2632 12.9145 14.3896 12 15.1227C11.0855 14.3896 10.5 13.2632 10.5 12C10.5 10.7368 11.0855 9.61038 12 8.87732Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgComponents(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.7572 6.3431L11.9998 2.10046L16.2425 6.3431L11.9998 10.5857L7.7572 6.3431ZM10.5856 6.3431L11.9998 4.92889L13.4141 6.3431L11.9998 7.75732L10.5856 6.3431Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.10046 11.9999L6.3431 7.75726L10.5857 11.9999L6.3431 16.2425L2.10046 11.9999ZM4.92889 11.9999L6.3431 10.5857L7.75732 11.9999L6.3431 13.4141L4.92889 11.9999Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.4142 11.9999L17.6568 16.2425L21.8995 11.9999L17.6568 7.75726L13.4142 11.9999ZM17.6568 10.5857L16.2426 11.9999L17.6568 13.4141L19.071 11.9999L17.6568 10.5857Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.7572 17.6569L11.9998 13.4142L16.2425 17.6569L11.9998 21.8995L7.7572 17.6569ZM10.5856 17.6569L11.9998 16.2427L13.4141 17.6569L11.9998 19.0711L10.5856 17.6569Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCompressLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.97867 9.45703L4.40883 9.45423L4.40726 11.4542L11.4073 11.4597L11.4127 4.45972L9.41274 4.45815L9.40992 8.05978L3.09616 1.76935L1.68457 3.18618L7.97867 9.45703Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5615 14.5521L19.5535 12.5521L12.5536 12.58L12.5814 19.5799L14.5814 19.572L14.5671 15.9706L20.9105 22.2307L22.3153 20.8071L15.9914 14.5663L19.5615 14.5521Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCompressRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.567 8.02947L20.9105 1.76929L22.3153 3.19282L15.9916 9.43352L19.5614 9.44772L19.5534 11.4477L12.5535 11.4199L12.5813 4.41992L14.5813 4.42788L14.567 8.02947Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.97879 14.5429L4.40886 14.5457L4.40729 12.5457L11.4073 12.5402L11.4128 19.5402L9.41277 19.5417L9.40995 15.9402L3.09623 22.2306L1.68463 20.8138L7.97879 14.5429Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCompressV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0338 7.3559L15.4999 4.85376L16.9244 6.25768L12.0107 11.2432L7.02515 6.32948L8.42907 4.90505L11.0329 7.47139L11.0834 0.843506L13.0833 0.858735L13.0338 7.3559Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5627 18.532L16.9749 17.1159L12.0184 12.1729L7.07543 17.1295L8.49159 18.5418L11.0762 15.95L11.1019 23.1566L13.1019 23.1495L13.0765 16.0528L15.5627 18.532Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.0954 8.42986L17.6711 7.02576L12.7568 12.0107L17.7417 16.925L19.1458 15.5007L16.644 13.0344L23.1411 13.0847L23.1565 11.0848L16.5286 11.0334L19.0954 8.42986Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.46742 15.5618L6.88341 16.9742L11.827 12.0183L6.87102 7.07476L5.45857 8.49074L8.04995 11.0756L0.843506 11.1004L0.850384 13.1004L7.94701 13.076L5.46742 15.5618Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgController(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 6.34313L16.2426 4.92892L12 0.686279L7.75735 4.92892L9.17156 6.34313L12 3.51471L14.8284 6.34313Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.92892 16.2426L6.34313 14.8284L3.51471 12L6.34313 9.17156L4.92892 7.75735L0.686279 12L4.92892 16.2426Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75735 19.0711L12 23.3137L16.2426 19.0711L14.8284 17.6568L12 20.4853L9.17156 17.6568L7.75735 19.0711Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6568 9.17156L20.4853 12L17.6568 14.8284L19.0711 16.2426L23.3137 12L19.0711 7.75735L17.6568 9.17156Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7H7V5H13V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H7V9H13V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15H13V13H7V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 19V1H17V5H21V23H7V19H3ZM15 17V3H5V17H15ZM17 7V19H9V21H19V7H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.392 10.4362L14.8106 9.0176C14.1031 8.38476 13.169 8 12.145 8C9.93588 8 8.14502 9.79086 8.14502 12C8.14502 14.2091 9.93588 16 12.145 16C13.2563 16 14.2617 15.5468 14.9866 14.8152L13.674 13.5026L13.4646 13.503C13.1124 13.8124 12.6506 14 12.145 14C11.0405 14 10.145 13.1046 10.145 12C10.145 10.8954 11.0405 10 12.145 10C12.6166 10 13.0501 10.1632 13.392 10.4362Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.2952 7.69432L16.1357 2.6377L21.1924 7.47821L19.8094 8.92296L17.3474 6.56617L17.5094 12.6C17.5805 15.25 15.49 17.456 12.8399 17.5271L6.91369 17.6863L9.20765 19.9335L7.80805 21.3622L2.80768 16.4636L7.70628 11.4632L9.13495 12.8628L6.75759 15.2896L12.7755 15.128C14.1005 15.0924 15.1458 13.9895 15.1102 12.6645L14.9519 6.76668L12.74 9.07732L11.2952 7.69432Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6004 7.67915L7.63814 2.74194L2.70093 7.7042L4.11871 9.11483L6.52249 6.69886L6.5075 12.7348C6.50092 15.3857 8.64461 17.5401 11.2956 17.5467L17.224 17.5614L14.9855 19.8638L16.4195 21.258L21.299 16.239L16.2801 11.3595L14.8859 12.7934L17.3217 15.1616L11.3015 15.1467C9.97605 15.1434 8.9042 14.0662 8.9075 12.7407L8.92214 6.84077L11.1898 9.09694L12.6004 7.67915Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleLeftDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.299 7.7609L16.2801 12.6405L14.8859 11.2065L17.3217 8.83829L11.3015 8.85324C9.97605 8.85653 8.9042 9.93371 8.9075 11.2592L8.92214 17.1591L11.1898 14.903L12.6004 16.3208L7.63814 21.258L2.70093 16.2957L4.11871 14.8851L6.52249 17.3011L6.5075 11.2652C6.50092 8.61419 8.64461 6.45983 11.2956 6.45325L17.224 6.43853L14.9855 4.1361L16.4195 2.74194L21.299 7.7609Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleLeftUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.78372 9.25045L6.36951 7.83624L10.6121 3.59363L14.8548 7.83627L13.4406 9.25048L10.6121 6.42205L7.78372 9.25045Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4406 13.4932L14.8548 12.0789L10.6121 7.83628L6.36951 12.0789L7.78372 13.4931L9.63052 11.6463V16.4063C9.63052 18.6155 11.4214 20.4063 13.6305 20.4063H17.6305V18.4063H13.6305C12.526 18.4063 11.6305 17.5109 11.6305 16.4063V11.6831L13.4406 13.4932Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleRightDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.69438 12.7048L2.63776 7.86424L7.47827 2.80762L8.92302 4.19062L6.56623 6.65263L12.6002 6.49061C15.2502 6.41945 17.4561 8.51002 17.5273 11.16L17.6864 17.0862L19.9335 14.7924L21.3622 16.192L16.4636 21.1924L11.4632 16.2938L12.8628 14.8651L15.2897 17.2426L15.1281 11.2245C15.0926 9.89945 13.9896 8.85417 12.6646 8.88974L6.76674 9.04811L9.07738 11.26L7.69438 12.7048Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleRightUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2163 9.25045L17.6305 7.83624L13.3879 3.59363L9.14526 7.83627L10.5595 9.25048L13.3879 6.42205L16.2163 9.25045Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5595 13.4932L9.14526 12.0789L13.3879 7.83628L17.6305 12.0789L16.2163 13.4931L14.3695 11.6463V16.4063C14.3695 18.6155 12.5786 20.4063 10.3695 20.4063H6.36951V18.4063H10.3695C11.4741 18.4063 12.3695 17.5109 12.3695 16.4063V11.6831L10.5595 13.4932Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25045 7.78369L7.83624 6.36948L3.59363 10.6121L7.83627 14.8547L9.25048 13.4405L6.42205 10.6121L9.25045 7.78369Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4932 13.4405L12.0789 14.8547L7.83627 10.6121L12.0789 6.36948L13.4931 7.78369L11.6463 9.63049L16.4063 9.63049C18.6155 9.63049 20.4063 11.4214 20.4063 13.6305L20.4063 17.6305L18.4063 17.6305L18.4063 13.6305C18.4063 12.5259 17.5109 11.6305 16.4063 11.6305L11.6831 11.6305L13.4932 13.4405Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDoubleUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7495 7.78369L16.1638 6.36948L20.4064 10.6121L16.1637 14.8547L14.7495 13.4405L17.5779 10.6121L14.7495 7.78369Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5068 13.4405L11.9211 14.8547L16.1637 10.6121L11.9211 6.36948L10.5069 7.78369L12.3537 9.63049L7.59366 9.63049C5.38452 9.63049 3.59366 11.4214 3.59366 13.6305L3.59366 17.6305L5.59366 17.6305L5.59366 13.6305C5.59366 12.5259 6.48909 11.6305 7.59366 11.6305L12.3169 11.6305L10.5068 13.4405Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.1495 13.4005C18.2541 13.4005 19.1495 12.5051 19.1495 11.4005V3.40051H21.1495V11.4005C21.1495 13.6097 19.3587 15.4005 17.1495 15.4005H6.84398L10.6286 19.1852L9.21443 20.5994L2.85046 14.2354L9.21443 7.87146L10.6286 9.28567L6.5138 13.4005H17.1495Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.85046 13.4005C5.74589 13.4005 4.85046 12.5051 4.85046 11.4005V3.40051H2.85046V11.4005C2.85046 13.6097 4.64132 15.4005 6.85046 15.4005H17.156L13.3714 19.1852L14.7856 20.5994L21.1495 14.2354L14.7856 7.87146L13.3714 9.28567L17.4862 13.4005H6.85046Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerLeftDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.6013 6.84996C10.6023 5.74539 11.4986 4.85079 12.6032 4.85181L20.6032 4.8592L20.605 2.8592L12.605 2.85181C10.3959 2.84977 8.60335 4.63897 8.60131 6.84811L8.59179 17.1538L4.81054 13.3656L3.39502 14.7785L9.7531 21.1483L16.1229 14.7902L14.71 13.3747L10.5915 17.4856L10.6013 6.84996Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerLeftUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.71 10.6254L16.1229 9.20989L9.7531 2.85181L3.39502 9.22164L4.81054 10.6346L8.59179 6.84631L8.60131 17.152C8.60335 19.3611 10.3959 21.1503 12.605 21.1483L20.605 21.1409L20.6032 19.1409L12.6032 19.1483C11.4986 19.1493 10.6023 18.2547 10.6013 17.1501L10.5915 6.51446L14.71 10.6254Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerRightDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3987 6.84996C13.3977 5.74539 12.5014 4.85079 11.3969 4.85181L3.39687 4.8592L3.39502 2.8592L11.395 2.85181C13.6042 2.84977 15.3967 4.63897 15.3987 6.84811L15.4082 17.1538L19.1895 13.3656L20.605 14.7785L14.2469 21.1483L7.87709 14.7902L9.28999 13.3747L13.4085 17.4856L13.3987 6.84996Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerRightUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.28999 10.6254L7.87709 9.20989L14.2469 2.85181L20.605 9.22164L19.1895 10.6346L15.4082 6.84631L15.3987 17.152C15.3967 19.3611 13.6042 21.1503 11.395 21.1483L3.39502 21.1409L3.39687 19.1409L11.3969 19.1483C12.5014 19.1493 13.3977 18.2547 13.3987 17.1501L13.4085 6.51446L9.28999 10.6254Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.6276 14.7219L9.21641 16.1391L2.83875 9.78892L9.18897 3.41125L10.6062 4.82242L6.82971 8.61526L17.1353 8.59304C19.3445 8.58828 21.1392 10.3753 21.144 12.5844L21.1612 20.5844L19.1612 20.5887L19.144 12.5887C19.1416 11.4841 18.2442 10.5907 17.1396 10.593L6.50391 10.616L10.6276 14.7219Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCornerUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.3724 14.7219L14.7835 16.1391L21.1612 9.78892L14.811 3.41125L13.3937 4.82242L17.1702 8.61526L6.86461 8.59304C4.65547 8.58828 2.86076 10.3753 2.85599 12.5844L2.83875 20.5844L4.83874 20.5887L4.85599 12.5887C4.85837 11.4841 5.75573 10.5907 6.8603 10.593L17.496 10.616L13.3724 14.7219Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9C4 8.44772 4.44772 8 5 8H9C9.55228 8 10 8.44772 10 9C10 9.55228 9.55228 10 9 10H5C4.44772 10 4 9.55228 4 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C1.79086 3 0 4.79086 0 7V17C0 19.2091 1.79086 21 4 21H20C22.2091 21 24 19.2091 24 17V7C24 4.79086 22.2091 3 20 3H4ZM20 5H4C2.89543 5 2 5.89543 2 7V14H22V7C22 5.89543 21.1046 5 20 5ZM22 16H2V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.93164 9.00891V16H15V20.0089H17V16H20.9316V14H17V7.00891H9.93164V3H7.93164V7.00891H4V9.00891H7.93164ZM9.93164 9.00891V14H15V9.00891H9.93164Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCross(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H11V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H13V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCrowdfire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 12C2 6.47715 6.47715 2 12 2V4H20V12H22C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM18 12H16V8H12V6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.5 6.09143L7.21997 10.8114L12.0005 6.03088L16.7811 10.8114L21.5 6.09245V14.9691C21.5 16.626 20.1569 17.9691 18.5 17.9691H5.5C3.84314 17.9691 2.5 16.626 2.5 14.9691V6.09143ZM19.5 10.9087V14.9691C19.5 15.5214 19.0523 15.9691 18.5 15.9691H5.5C4.94771 15.9691 4.5 15.5214 4.5 14.9691V10.9077L7.21997 13.6277L12.0005 8.84717L16.7811 13.6277L19.5 10.9087Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDanger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDarkMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4V8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16V20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgData(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 8.88916C13.6569 8.88916 15 10.2323 15 11.8892C15 13.1954 14.1652 14.3066 13 14.7185V19.8892H11V14.7185C9.83481 14.3066 9 13.1954 9 11.8892C9 10.2323 10.3431 8.88916 12 8.88916ZM12 10.8892C12.5523 10.8892 13 11.3369 13 11.8892C13 12.4414 12.5523 12.8892 12 12.8892C11.4477 12.8892 11 12.4414 11 11.8892C11 11.3369 11.4477 10.8892 12 10.8892Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05019 6.93938C5.78348 8.20612 5 9.9561 5 11.8891C5 14.0666 5.99426 16.0119 7.55355 17.2957L8.97712 15.8721C7.7757 14.9589 7 13.5146 7 11.8891C7 10.5084 7.55962 9.25841 8.46441 8.35359L7.05019 6.93938Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5355 8.35348C16.4403 9.25831 17 10.5083 17 11.8891C17 13.5146 16.2243 14.959 15.0228 15.8722L16.4463 17.2958C18.0057 16.012 19 14.0666 19 11.8891C19 9.95604 18.2165 8.20602 16.9497 6.93927L15.5355 8.35348Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11.8891C1 8.85152 2.23119 6.10155 4.22176 4.11095L5.63598 5.52516C4.00733 7.15383 3 9.40381 3 11.8891C3 14.3743 4.00733 16.6243 5.63597 18.2529L4.22175 19.6672C2.23119 17.6766 1 14.9266 1 11.8891Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7781 19.6673C21.7688 17.6767 23 14.9266 23 11.8891C23 8.85147 21.7688 6.10145 19.7781 4.11084L18.3639 5.52505C19.9926 7.15374 21 9.40376 21 11.8891C21 14.3744 19.9926 16.6244 18.3639 18.2531L19.7781 19.6673Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9V7H7V9H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9H19V7H9V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15V17H7V15H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17H9V15H19V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM4 5H20C20.5523 5 21 5.44772 21 6V11H3V6C3 5.44772 3.44772 5 4 5ZM3 13V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V13H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDebug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11C10 10.4477 10.4477 10 11 10H13C13.5523 10 14 10.4477 14 11C14 11.5523 13.5523 12 13 12H11C10.4477 12 10 11.5523 10 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.09447 4.74918C8.41606 4.03243 8 3.0648 8 2H10C10 3.10457 10.8954 4 12 4C13.1046 4 14 3.10457 14 2H16C16 3.0648 15.5839 4.03243 14.9055 4.74918C16.1782 5.45491 17.1673 6.6099 17.6586 8H19C19.5523 8 20 8.44772 20 9C20 9.55229 19.5523 10 19 10H18V12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H18V16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H17.6586C16.8349 20.3304 14.6124 22 12 22C9.38756 22 7.16508 20.3304 6.34141 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16H6V14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H6V10H5C4.44772 10 4 9.55229 4 9C4 8.44772 4.44772 8 5 8H6.34141C6.83274 6.6099 7.82181 5.45491 9.09447 4.74918ZM8 16V10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDesignmodo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 4.05444C4.23858 4.05444 2 6.29302 2 9.05444C2 11.8159 4.23858 14.0544 7 14.0544C9.76142 14.0544 12 11.8159 12 9.05444C12 6.29302 9.76142 4.05444 7 4.05444ZM5 9.05444C5 10.159 5.89543 11.0544 7 11.0544C8.10457 11.0544 9 10.159 9 9.05444C9 7.94987 8.10457 7.05444 7 7.05444C5.89543 7.05444 5 7.94987 5 9.05444Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10.5544H17V7.55444H22V10.5544Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5503 16.9457C12.6786 16.9457 13.6977 16.4786 14.4249 15.7272C14.4097 15.7429 14.3943 15.7585 14.3788 15.774L16.5001 17.8954C15.2334 19.1621 13.4834 19.9457 11.5503 19.9457C9.61734 19.9457 7.86734 19.1622 6.60059 17.8954L8.72191 15.7741C9.44576 16.498 10.4458 16.9457 11.5503 16.9457Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V6C23 4.34315 21.6569 3 20 3H4ZM20 5H4C3.44772 5 3 5.44772 3 6V7H21V6C21 5.44772 20.5523 5 20 5ZM3 18V9H21V18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDetailsLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9C2.44772 9 2 9.44772 2 10C2 10.5523 2.44772 11 3 11H21C21.5523 11 22 10.5523 22 10C22 9.44772 21.5523 9 21 9H3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDetailsMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8C2 7.44772 2.44772 7 3 7H21C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9H3C2.44772 9 2 8.55228 2 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15C2.44772 15 2 15.4477 2 16C2 16.5523 2.44772 17 3 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDialpad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 3H8.5V6H5.5V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 8H8.5V11H5.5V8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 13V16H8.5V13H5.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 3H13.5V6H10.5V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8V11H13.5V8H10.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 13H13.5V16H10.5V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 18V21H13.5V18H10.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 3H18.5V6H15.5V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8V11H18.5V8H15.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 13H18.5V16H15.5V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDice1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDice2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 14.9431C16.0954 14.9431 15.2 15.8385 15.2 16.9431C15.2 18.0477 16.0954 18.9431 17.2 18.9431C18.3045 18.9431 19.2 18.0477 19.2 16.9431C19.2 15.8385 18.3045 14.9431 17.2 14.9431Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.05518 7.05518C5.05518 5.95061 5.95061 5.05518 7.05518 5.05518C8.15975 5.05518 9.05518 5.95061 9.05518 7.05518C9.05518 8.15975 8.15975 9.05518 7.05518 9.05518C5.95061 9.05518 5.05518 8.15975 5.05518 7.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H4ZM20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDice3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9451 14.8921C15.8405 14.8921 14.9451 15.7875 14.9451 16.8921C14.9451 17.9967 15.8405 18.8921 16.9451 18.8921C18.0496 18.8921 18.9451 17.9967 18.9451 16.8921C18.9451 15.7875 18.0496 14.8921 16.9451 14.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.05518 7.05518C5.05518 5.95061 5.95061 5.05518 7.05518 5.05518C8.15975 5.05518 9.05518 5.95061 9.05518 7.05518C9.05518 8.15975 8.15975 9.05518 7.05518 9.05518C5.95061 9.05518 5.05518 8.15975 5.05518 7.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDice4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9451 5.05518C15.8405 5.05518 14.9451 5.95061 14.9451 7.05518C14.9451 8.15975 15.8405 9.05518 16.9451 9.05518C18.0496 9.05518 18.9451 8.15975 18.9451 7.05518C18.9451 5.95061 18.0496 5.05518 16.9451 5.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9451 16.8921C14.9451 15.7875 15.8405 14.8921 16.9451 14.8921C18.0496 14.8921 18.9451 15.7875 18.9451 16.8921C18.9451 17.9967 18.0496 18.8921 16.9451 18.8921C15.8405 18.8921 14.9451 17.9967 14.9451 16.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05518 14.8921C5.95061 14.8921 5.05518 15.7875 5.05518 16.8921C5.05518 17.9967 5.95061 18.8921 7.05518 18.8921C8.15975 18.8921 9.05518 17.9967 9.05518 16.8921C9.05518 15.7875 8.15975 14.8921 7.05518 14.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.05518 7.05518C5.05518 5.95061 5.95061 5.05518 7.05518 5.05518C8.15975 5.05518 9.05518 5.95061 9.05518 7.05518C9.05518 8.15975 8.15975 9.05518 7.05518 9.05518C5.95061 9.05518 5.05518 8.15975 5.05518 7.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H4ZM20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDice5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9451 7.05518C14.9451 5.95061 15.8405 5.05518 16.9451 5.05518C18.0496 5.05518 18.9451 5.95061 18.9451 7.05518C18.9451 8.15975 18.0496 9.05518 16.9451 9.05518C15.8405 9.05518 14.9451 8.15975 14.9451 7.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9451 14.8921C15.8405 14.8921 14.9451 15.7875 14.9451 16.8921C14.9451 17.9967 15.8405 18.8921 16.9451 18.8921C18.0496 18.8921 18.9451 17.9967 18.9451 16.8921C18.9451 15.7875 18.0496 14.8921 16.9451 14.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.05518 16.8921C5.05518 15.7875 5.95061 14.8921 7.05518 14.8921C8.15975 14.8921 9.05518 15.7875 9.05518 16.8921C9.05518 17.9967 8.15975 18.8921 7.05518 18.8921C5.95061 18.8921 5.05518 17.9967 5.05518 16.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05518 5.05518C5.95061 5.05518 5.05518 5.95061 5.05518 7.05518C5.05518 8.15975 5.95061 9.05518 7.05518 9.05518C8.15975 9.05518 9.05518 8.15975 9.05518 7.05518C9.05518 5.95061 8.15975 5.05518 7.05518 5.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 4C1 2.34315 2.34315 1 4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDice6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9451 5.05518C15.8405 5.05518 14.9451 5.95061 14.9451 7.05518C14.9451 8.15975 15.8405 9.05518 16.9451 9.05518C18.0496 9.05518 18.9451 8.15975 18.9451 7.05518C18.9451 5.95061 18.0496 5.05518 16.9451 5.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9451 16.8921C14.9451 15.7875 15.8405 14.8921 16.9451 14.8921C18.0496 14.8921 18.9451 15.7875 18.9451 16.8921C18.9451 17.9967 18.0496 18.8921 16.9451 18.8921C15.8405 18.8921 14.9451 17.9967 14.9451 16.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05518 14.8921C5.95061 14.8921 5.05518 15.7875 5.05518 16.8921C5.05518 17.9967 5.95061 18.8921 7.05518 18.8921C8.15975 18.8921 9.05518 17.9967 9.05518 16.8921C9.05518 15.7875 8.15975 14.8921 7.05518 14.8921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.05518 7.05518C5.05518 5.95061 5.95061 5.05518 7.05518 5.05518C8.15975 5.05518 9.05518 5.95061 9.05518 7.05518C9.05518 8.15975 8.15975 9.05518 7.05518 9.05518C5.95061 9.05518 5.05518 8.15975 5.05518 7.05518Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9451 9.97363C15.8405 9.97363 14.9451 10.8691 14.9451 11.9736C14.9451 13.0782 15.8405 13.9736 16.9451 13.9736C18.0496 13.9736 18.9451 13.0782 18.9451 11.9736C18.9451 10.8691 18.0496 9.97363 16.9451 9.97363Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.05518 11.9736C5.05518 10.8691 5.95061 9.97363 7.05518 9.97363C8.15975 9.97363 9.05518 10.8691 9.05518 11.9736C9.05518 13.0782 8.15975 13.9736 7.05518 13.9736C5.95061 13.9736 5.05518 13.0782 5.05518 11.9736Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4C23 2.34315 21.6569 1 20 1H4ZM20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDigitalocean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C8.68629 6 6 8.68629 6 12H1C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23V18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18V13H12V18H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18V22H7V18H3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18H1V16H3V18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12C5 8.13401 8.13401 5 12 5V7C9.23858 7 7 9.23858 7 12H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17C14.7614 17 17 14.7614 17 12H19C19 15.866 15.866 19 12 19V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDisplayFlex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17V7H8V17H6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7V17H18V7H16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 3H22V21H2V3ZM4 5V19H20V5H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDisplayFullwidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5H22V3H2V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21H22V19H2V21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 7V17H22V7H2ZM4 9H20V15H4V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDisplayGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7V11H11V7H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7H17V11H13V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13V17H17V13H13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13H11V17H7V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3H21V21H3V3ZM5 5V19H19V5H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDisplaySpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21V3H5V21H3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 3H17V21H7V3ZM9 5V19H15V5H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3V21H21V3H19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDistributeHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9H13V15H11V9Z",
                    "stroke": "currentColor",
                    "strokeOpacity": "0.5",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V19H7V5H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5V19H19V5H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDistributeVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H15V13H9V11Z",
                    "stroke": "currentColor",
                    "strokeOpacity": "0.5",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H5V5H19V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V17H19V19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDockBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 20V4H22V20H2ZM4 6H20V14H4V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDockLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4H22V20H2V4ZM8 6H20V18H8V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDockRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4H22V20H2V4ZM16 18V6H4V18H16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDockWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 20V4H22V20H2ZM20 6H6V16L20 16V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDolby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 4V20H24V4H0ZM10 12C10 9.79086 8.20914 8 6 8H4V16H6C8.20914 16 10 14.2091 10 12ZM18 16H20V8H18C15.7909 8 14 9.79086 14 12C14 14.2091 15.7909 16 18 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 19V22H13V19H14C16.2091 19 18 17.2091 18 15C18 12.7909 16.2091 11 14 11H13V7H15V9H17V5H13V2H11V5H10C7.79086 5 6 6.79086 6 9C6 11.2091 7.79086 13 10 13H11V17H9V15H7V19H11ZM13 17H14C15.1046 17 16 16.1046 16 15C16 13.8954 15.1046 13 14 13H13V17ZM11 11V7H10C8.89543 7 8 7.89543 8 9C8 10.1046 8.89543 11 10 11H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 11.9554V12.0446C1.01066 14.7301 1.98363 17.1885 3.59196 19.0931C4.05715 19.6439 4.57549 20.1485 5.13908 20.5987C5.70631 21.0519 6.31937 21.4501 6.97019 21.7853C7.90271 22.2656 8.91275 22.6165 9.97659 22.8143C10.5914 22.9286 11.2243 22.9918 11.8705 22.9993C11.9136 22.9998 11.9567 23 11.9999 23C15.6894 23 18.9547 21.1836 20.9502 18.3962C21.3681 17.8125 21.7303 17.1861 22.0291 16.525C22.6528 15.1448 22.9999 13.613 22.9999 12C22.9999 8.73978 21.5816 5.81084 19.3283 3.79653C18.8064 3.32998 18.2397 2.91249 17.6355 2.55132C15.9873 1.56615 14.0597 1 11.9999 1C11.888 1 11.7764 1.00167 11.6653 1.00499C9.99846 1.05479 8.42477 1.47541 7.0239 2.18719C6.07085 2.67144 5.19779 3.29045 4.42982 4.01914C3.7166 4.69587 3.09401 5.4672 2.58216 6.31302C2.22108 6.90969 1.91511 7.54343 1.6713 8.20718C1.24184 9.37631 1.00523 10.6386 1 11.9554ZM20.4812 15.0186C20.8171 14.075 20.9999 13.0588 20.9999 12C20.9999 9.54265 20.0151 7.31533 18.4186 5.6912C17.5975 7.05399 16.5148 8.18424 15.2668 9.0469C15.7351 10.2626 15.9886 11.5603 16.0045 12.8778C16.7692 13.0484 17.5274 13.304 18.2669 13.6488C19.0741 14.0252 19.8141 14.487 20.4812 15.0186ZM15.8413 14.8954C16.3752 15.0321 16.904 15.22 17.4217 15.4614C18.222 15.8346 18.9417 16.3105 19.5723 16.8661C18.0688 19.2008 15.5151 20.7953 12.5788 20.9817C13.5517 20.0585 14.3709 18.9405 14.972 17.6514C15.3909 16.7531 15.678 15.8272 15.8413 14.8954ZM13.9964 12.6219C13.9583 11.7382 13.7898 10.8684 13.5013 10.0408C10.6887 11.2998 7.36584 11.3765 4.35382 9.97197C4.01251 9.81281 3.68319 9.63837 3.36632 9.44983C3.12787 10.2584 2.99991 11.1142 2.99991 12C2.99991 13.9462 3.61763 15.748 4.6677 17.2203C6.83038 14.1875 10.3685 12.4987 13.9964 12.6219ZM6.047 18.7502C7.77258 16.059 10.7714 14.5382 13.8585 14.6191C13.723 15.3586 13.4919 16.093 13.1594 16.8062C12.3777 18.4825 11.1453 19.805 9.67385 20.6965C8.31043 20.3328 7.07441 19.6569 6.047 18.7502ZM11.9999 3C13.7846 3 15.4479 3.51946 16.847 4.41543C16.2113 5.54838 15.3593 6.4961 14.368 7.23057C13.3472 5.57072 11.8752 4.16433 10.027 3.21692C10.6619 3.07492 11.3222 3 11.9999 3ZM8.80619 4.84582C10.4462 5.61056 11.7474 6.80659 12.6379 8.23588C10.3464 9.24654 7.64722 9.30095 5.19906 8.15936C4.83384 7.98905 4.48541 7.79735 4.15458 7.58645C4.91365 6.24006 6.00929 5.10867 7.32734 4.30645C7.82672 4.44058 8.32138 4.61975 8.80619 4.84582Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C0.895431 8 0 8.89543 0 10V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V10C24 8.89543 23.1046 8 22 8H2ZM22 10H2L2 14H22V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDropInvert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0001 1.13611L5.63604 7.50002C2.12132 11.0147 2.12132 16.7132 5.63604 20.2279C7.39343 21.9853 9.69679 22.864 12.0001 22.864C12.288 22.864 12.5759 22.8502 12.8627 22.8228C14.8706 22.6306 16.8264 21.7657 18.3641 20.2279C21.8788 16.7132 21.8788 11.0147 18.3641 7.50002L12.0001 1.13611ZM7.05025 8.91423L12 3.96448L12.0001 20.864C10.2086 20.864 8.41711 20.1806 7.05025 18.8137C4.31658 16.0801 4.31658 11.6479 7.05025 8.91423Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDropOpacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15.9451 21.9559C12.5884 23.5927 8.42477 23.0167 5.63598 20.2279C2.12126 16.7132 2.12126 11.0147 5.63598 7.49995L11.9999 1.13599L18.3639 7.49995C19.2521 8.38814 19.9158 9.41578 20.3551 10.5124C21.6543 13.7553 20.9906 17.6012 18.364 20.2278C17.6381 20.9538 16.8189 21.5298 15.9451 21.9559ZM7.05019 8.91416L11.9999 3.96441L16.9497 8.91416C18.274 10.2385 18.9568 11.9615 18.998 13.6968H5.00192C5.04309 11.9615 5.72585 10.2385 7.05019 8.91416Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgDrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.34315 19.5208C3.21895 16.3966 3.21895 11.3312 6.34315 8.20705L12 2.5502L17.6569 8.20705C20.781 11.3312 20.781 16.3966 17.6569 19.5208C14.5327 22.645 9.46734 22.645 6.34315 19.5208Z",
                    "stroke": "currentColor",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function CgDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H7V3H21V17H19V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13V11H11V13H13V15H11V17H9V15H7V13H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 7H17V21H3V7ZM5 9H15V19H5V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditBlackPoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditContrast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18C10.4633 18 9.06151 17.4223 8 16.4722C6.7725 15.3736 6 13.777 6 12C6 10.223 6.7725 8.62643 8 7.52779C9.06151 6.57771 10.4633 6 12 6V18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditExposure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11 7V9H9V11H11V13H13V11H15V9H13V7H11ZM9 15V17H15V15H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditFade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12C8 10.5194 8.8044 9.22675 10 8.53513V15.4649C8.8044 14.7733 8 13.4806 8 12Z",
                    "stroke": "currentColor",
                    "strokeOpacity": "0.3",
                    "strokeWidth": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15.4649V8.53513C15.1956 9.22675 16 10.5194 16 12C16 13.4806 15.1956 14.7733 14 15.4649Z",
                    "stroke": "currentColor",
                    "strokeOpacity": "0.6",
                    "strokeWidth": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
                    "stroke": "currentColor",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function CgEditFlipH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7C18.5523 7 19 7.44772 19 8V16C19 16.5523 18.5523 17 18 17H15V19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5H15V7H18Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H11V21H13V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8C5 7.44772 5.44772 7 6 7H9V5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H9V17H6C5.44772 17 5 16.5523 5 16V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditFlipV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18C17 18.5523 16.5523 19 16 19L8 19C7.44772 19 7 18.5523 7 18L7 15L5 15L5 18C5 19.6569 6.34315 21 8 21L16 21C17.6569 21 19 19.6569 19 18V15L17 15V18Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5C16.5523 5 17 5.44772 17 6V9H19V6C19 4.34315 17.6569 3 16 3L8 3C6.34315 3 5 4.34315 5 6V9H7V6C7 5.44772 7.44772 5 8 5L16 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13V11L3 11V13H21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C10.7785 6 9.64223 6.36502 8.69435 6.99194H12V7.99194H7.53501C7.00911 8.57742 6.59669 9.26689 6.33237 10.0258H12V11.0258H6.07869C6.02692 11.3428 6 11.6683 6 12C6 12.3379 6.02793 12.6693 6.08161 12.9919H12V13.9919H6.33857C6.60189 14.7404 7.00941 15.4208 7.52779 16H12V17H8.68221C9.63251 17.6318 10.7733 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditMarkup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.5793 19.531C20.6758 17.698 22 15.0036 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 14.9616 3.28743 17.6225 5.33317 19.4535L6.99999 10.9738H9.17026L12 6.07251L14.8297 10.9738H17L18.5793 19.531ZM16.0919 21.1272L15.2056 12.9738H8.79438L7.90814 21.1272C9.15715 21.688 10.5421 22 12 22C13.4579 22 14.8428 21.688 16.0919 21.1272Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 22C6.47716 22 2 17.5228 2 12C2 6.47717 6.47716 2 12 2C17.5228 2 22 6.47717 22 12C22 17.5228 17.5228 22 12 22ZM9.0307 19.4308C9.01047 19.29 9 19.1462 9 19C9 17.3431 10.3431 16 12 16C13.6569 16 15 17.3431 15 19C15 19.1462 14.9895 19.29 14.9693 19.4308C16.9993 18.6189 18.619 16.9993 19.4308 14.9692C19.2901 14.9895 19.1463 15 19 15C17.3431 15 16 13.6569 16 12C16 10.3431 17.3431 9 19 9C19.0637 9 19.127 9.00195 19.1897 9.00586C19.271 9.01099 19.3514 9.01929 19.4308 9.03076C18.6189 7.00073 16.9993 5.3811 14.9693 4.56921C14.9895 4.70996 15 4.85376 15 5C15 6.65686 13.6569 8 12 8C10.3431 8 9 6.65686 9 5C9 4.85376 9.01048 4.70996 9.03072 4.56921C7.0007 5.3811 5.38106 7.00073 4.56915 9.03076C4.64857 9.01929 4.729 9.01099 4.8103 9.00586C4.87303 9.00195 4.93628 9 5 9C6.65686 9 8 10.3431 8 12C8 13.6569 6.65686 15 5 15C4.8537 15 4.70985 14.9895 4.56915 14.9692C5.38104 16.9993 7.00069 18.6189 9.0307 19.4308Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditNoise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4044 17.7657C10.419 17.7803 10.4329 17.7953 10.446 17.8108C10.1948 17.7439 9.95005 17.661 9.71293 17.5634C9.95429 17.5106 10.2167 17.578 10.4044 17.7657Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43574 16.705C8.40862 16.7321 8.37994 16.7567 8.34999 16.7788C7.95661 16.4775 7.60163 16.1285 7.29364 15.7406C7.31765 15.7068 7.3448 15.6746 7.37508 15.6443C7.66797 15.3514 8.14285 15.3514 8.43574 15.6443C8.72863 15.9372 8.72863 16.4121 8.43574 16.705Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.37104 13.6475C6.59701 13.8735 6.64864 14.2077 6.52594 14.4832C6.38527 14.1723 6.27034 13.8472 6.18387 13.5107C6.25129 13.5454 6.31455 13.591 6.37104 13.6475Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.37104 10.6753C6.29401 10.7523 6.2044 10.8091 6.10883 10.8456C6.18637 10.4523 6.30234 10.0728 6.45268 9.71119C6.66079 10.004 6.63357 10.4128 6.37104 10.6753Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.37508 8.70669C7.28995 8.62156 7.22957 8.52106 7.19392 8.41413C7.45907 8.06093 7.76228 7.73793 8.09747 7.45124C8.22139 7.48394 8.33858 7.54887 8.43574 7.64603C8.72863 7.93892 8.72863 8.41379 8.43574 8.70669C8.14285 8.99958 7.66797 8.99958 7.37508 8.70669Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.34371 6.76662C9.31335 6.73627 9.28614 6.70396 9.26208 6.6701C9.6881 6.45171 10.1437 6.28277 10.6212 6.17088C10.6397 6.38399 10.5675 6.60352 10.4044 6.76662C10.1115 7.05952 9.6366 7.05952 9.34371 6.76662Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.2872 17.8734C13.5967 17.8055 13.8973 17.7136 14.1868 17.6C13.9165 17.4914 13.5957 17.5466 13.3766 17.7657C13.3429 17.7993 13.3131 17.8354 13.2872 17.8734Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5312 16.8608C15.935 16.5658 16.3005 16.2216 16.619 15.8369C16.6005 15.8133 16.5803 15.7906 16.5586 15.7688C16.2657 15.4759 15.7908 15.4759 15.4979 15.7688C15.205 16.0617 15.205 16.5366 15.4979 16.8295C15.5088 16.8403 15.5199 16.8508 15.5312 16.8608Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.3654 14.6921C17.5637 14.2953 17.7194 13.8735 17.8264 13.4326C17.6636 13.451 17.5058 13.5227 17.3809 13.6475C17.0933 13.9351 17.0881 14.3982 17.3654 14.6921Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8911 10.8934C17.8032 10.4272 17.6613 9.98016 17.4722 9.55885C17.4507 9.57609 17.4299 9.59469 17.4099 9.61465C17.117 9.90755 17.117 10.3824 17.4099 10.6753C17.5439 10.8093 17.7159 10.882 17.8911 10.8934Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7556 8.35985C16.4971 8.02355 16.2038 7.71542 15.8811 7.44086C15.7407 7.46881 15.6068 7.5372 15.4979 7.64603C15.205 7.93892 15.205 8.41379 15.4979 8.70669C15.7908 8.99958 16.2657 8.99958 16.5586 8.70669C16.658 8.60729 16.7237 8.48694 16.7556 8.35985Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4373 6.76662C14.4906 6.71331 14.5342 6.65397 14.5681 6.59079C14.1273 6.38127 13.6569 6.22392 13.1649 6.12671C13.1317 6.35331 13.2022 6.59223 13.3766 6.76662C13.6695 7.05952 14.1444 7.05952 14.4373 6.76662Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5257 7.64603C12.8186 7.93892 12.8186 8.41379 12.5257 8.70669C12.2328 8.99958 11.7579 8.99958 11.465 8.70669C11.1721 8.41379 11.1721 7.93892 11.465 7.64603C11.7579 7.35313 12.2328 7.35313 12.5257 7.64603Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4044 9.61465C10.6973 9.90755 10.6973 10.3824 10.4044 10.6753C10.1115 10.9682 9.6366 10.9682 9.34371 10.6753C9.05081 10.3824 9.05081 9.90755 9.34371 9.61465C9.6366 9.32176 10.1115 9.32176 10.4044 9.61465Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43574 12.7967C8.72863 12.5038 8.72863 12.0289 8.43574 11.736C8.14285 11.4431 7.66797 11.4431 7.37508 11.736C7.08218 12.0289 7.08218 12.5038 7.37508 12.7967C7.66797 13.0895 8.14285 13.0895 8.43574 12.7967Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.4044 13.6475C10.6973 13.9404 10.6973 14.4153 10.4044 14.7082C10.1115 15.001 9.6366 15.001 9.34371 14.7082C9.05081 14.4153 9.05081 13.9404 9.34371 13.6475C9.6366 13.3546 10.1115 13.3546 10.4044 13.6475Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5257 12.7967C12.8186 12.5038 12.8186 12.0289 12.5257 11.736C12.2328 11.4431 11.7579 11.4431 11.465 11.736C11.1721 12.0289 11.1721 12.5038 11.465 12.7967C11.7579 13.0895 12.2328 13.0895 12.5257 12.7967Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4373 9.61465C14.7302 9.90755 14.7302 10.3824 14.4373 10.6753C14.1444 10.9682 13.6695 10.9682 13.3766 10.6753C13.0837 10.3824 13.0837 9.90755 13.3766 9.61465C13.6695 9.32176 14.1444 9.32176 14.4373 9.61465Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5586 12.7681C16.8515 12.4752 16.8515 12.0003 16.5586 11.7074C16.2657 11.4145 15.7908 11.4145 15.4979 11.7074C15.205 12.0003 15.205 12.4752 15.4979 12.7681C15.7908 13.061 16.2657 13.061 16.5586 12.7681Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.423 13.6902C14.7159 13.9831 14.7159 14.458 14.423 14.7509C14.1301 15.0438 13.6552 15.0438 13.3623 14.7509C13.0694 14.458 13.0694 13.9831 13.3623 13.6902C13.6552 13.3973 14.1301 13.3973 14.423 13.6902Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.3159 16.705C12.6088 16.4121 12.6088 15.9372 12.3159 15.6443C12.023 15.3514 11.5482 15.3514 11.2553 15.6443C10.9624 15.9372 10.9624 16.4121 11.2553 16.705C11.5482 16.9979 12.023 16.9979 12.3159 16.705Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditShadows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.3056 6.99194C14.3578 6.36502 13.2215 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C13.2267 18 14.3675 17.6318 15.3178 17H12V16H16.4722C16.9906 15.4208 17.3981 14.7404 17.6614 13.9919H12V12.9919H17.9184C17.9721 12.6693 18 12.3379 18 12C18 11.6683 17.9731 11.3428 17.9213 11.0258H12V10.0258H17.6676C17.4033 9.26689 16.9909 8.57742 16.465 7.99194H12V6.99194H15.3056Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditStraight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C15.866 4 19 7.13401 19 11H5C5 7.13401 8.13401 4 12 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13H1V11H5V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13C19 16.866 15.866 20 12 20C8.13401 20 5 16.866 5 13H19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13V11H23V13H19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEditUnmask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 13.6569 20.6569 15 19 15C17.3431 15 16 13.6569 16 12C16 10.3431 17.3431 9 19 9C20.6569 9 22 10.3431 22 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15C6.65685 15 8 13.6569 8 12C8 10.3431 6.65685 9 5 9C3.34315 9 2 10.3431 2 12C2 13.6569 3.34315 15 5 15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9498 14.3948L18.364 12.9805L12 6.61658L5.63605 12.9805L7.05026 14.3948L12 9.445L16.9498 14.3948Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.00014 17.3835H18.0001V15.3835H6.00014V17.3835Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgErase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.49997 12.8995C2.71892 13.6805 2.71892 14.9468 3.49997 15.7279L7.35785 19.5858H4.08576C3.53347 19.5858 3.08576 20.0335 3.08576 20.5858C3.08576 21.1381 3.53347 21.5858 4.08576 21.5858H20.0858C20.638 21.5858 21.0858 21.1381 21.0858 20.5858C21.0858 20.0335 20.638 19.5858 20.0858 19.5858H10.9558L20.4705 10.071C21.2516 9.28999 21.2516 8.02366 20.4705 7.24261L16.2279 2.99997C15.4468 2.21892 14.1805 2.21892 13.3995 2.99997L3.49997 12.8995ZM7.82579 11.4021L4.91418 14.3137L9.15683 18.5563L12.0684 15.6447L7.82579 11.4021ZM9.24 9.98787L13.4826 14.2305L19.0563 8.65683L14.8137 4.41418L9.24 9.98787Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEreader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9H19C19.5523 9 20 8.55228 20 8C20 7.44772 19.5523 7 19 7H16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12C15 11.4477 15.4477 11 16 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H16C15.4477 13 15 12.5523 15 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34315 21 3 21H21C22.6569 21 24 19.6569 24 18V6C24 4.34315 22.6569 3 21 3H3ZM21 5H13V19H21C21.5523 19 22 18.5523 22 18V6C22 5.44772 21.5523 5 21 5ZM3 5H11V19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEricsson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.71689 5.72315C6.71581 6.18996 6.2827 7.37992 6.74951 8.381C7.21632 9.38208 8.40628 9.81519 9.40736 9.34838L20.2831 4.27696C21.2841 3.81015 21.7172 2.62019 21.2504 1.61911C20.7836 0.618028 19.5937 0.184918 18.5926 0.651729L7.71689 5.72315Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.74951 15.381C4.2827 14.3799 4.71581 13.19 5.71689 12.7231L16.5926 7.65173C17.5937 7.18492 18.7836 7.61803 19.2504 8.61911C19.7172 9.62019 19.2841 10.8101 18.2831 11.277L7.40736 16.3484C6.40628 16.8152 5.21632 16.3821 4.74951 15.381Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.74951 22.381C2.2827 21.3799 2.71581 20.19 3.71689 19.7231L14.5926 14.6517C15.5937 14.1849 16.7836 14.618 17.2504 15.6191C17.7172 16.6202 17.2841 17.8101 16.2831 18.277L5.40736 23.3484C4.40628 23.8152 3.21632 23.3821 2.74951 22.381Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 0.5V20.5H11V23.5H13V20.5H20V0.5H4ZM18 2.5H6V8.5H10V14.5H14V8.5H18V2.5ZM6 18.5V10.5H8V16.5H16V10.5H18V18.5H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5535 15.5355C17.6487 16.4404 16.3987 17 15.018 17C13.1416 17 11.5066 15.9664 10.6513 14.4374H13.0323L13.7284 12.5625H10.0493C10.0286 12.3779 10.018 12.1902 10.018 12C10.018 11.8098 10.0286 11.6221 10.0493 11.4374H14.3362L15.0324 9.5625H10.6514C11.5066 8.0336 13.1416 7 15.018 7C16.3987 7 17.6487 7.55964 18.5535 8.46447L19.9677 7.05025C18.701 5.7835 16.951 5 15.018 5C12.0092 5 9.44381 6.89827 8.45407 9.5625H6.03241L5.33624 11.4374H8.04028C8.02552 11.623 8.018 11.8106 8.018 12C8.018 12.1894 8.02552 12.3769 8.04027 12.5625H4.72845L4.03229 14.4374H8.45404C9.44377 17.1017 12.0092 19 15.018 19C16.951 19 18.701 18.2165 19.9677 16.9497L18.5535 15.5355Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEventbrite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.6734 17.4378C12.3057 18.5419 9.5858 17.9679 7.85444 16.2039L21.8647 9.67074C21.7105 9.02969 21.4902 8.39446 21.2008 7.77376C18.8667 2.76836 12.9169 0.602811 7.91152 2.93687C2.90612 5.27092 0.740567 11.2207 3.07462 16.2261C5.40868 21.2315 11.3585 23.3971 16.3639 21.063C19.016 19.8263 20.8708 17.5746 21.6815 14.986H17.3424C16.7484 16.0235 15.8393 16.8941 14.6734 17.4378ZM9.60199 6.5621C7.23436 7.66615 5.92572 10.1185 6.16403 12.5786L16.4208 7.79583C14.6894 6.03194 11.9696 5.45805 9.60199 6.5621Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.3062 16.5933L12.2713 18.593L5.2724 18.4708L5.39457 11.4719L7.39426 11.5068L7.33168 15.092L15.2262 7.46833L11.6938 7.40668L11.7287 5.40698L18.7277 5.52915L18.6055 12.5281L16.6058 12.4932L16.6693 8.85507L8.72095 16.5307L12.3062 16.5933Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9498 5.96781L15.5356 7.38203L13 4.84646V17.0421H11V4.84653L8.46451 7.38203L7.05029 5.96781L12 1.01807L16.9498 5.96781Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20.9819V10.9819H9V8.98193H3V22.9819H21V8.98193H15V10.9819H19V20.9819H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExtensionAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4H18V6H20V8H18V10H16V8H14V6H16V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 12V6H4V20H18V12H12ZM6 8H10V12H6V8ZM10 14V18H6V14H10ZM16 14V18H12V14H16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExtensionAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5V19H13V13H19V5H5ZM11 7H7V11H11V7ZM11 13H7V17H11V13ZM13 11H17V7H13V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExtensionRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 11V5H4V19H18V11H12ZM6 7H10V11H6V7ZM10 13V17H6V13H10ZM16 13V17H12V13H16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H14V9H20V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 3H21V11H13V3ZM15 5H19V9H15V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 21V13H11V7H3V21H17ZM9 9H5V13H9V9ZM5 19L5 15H9V19H5ZM11 19V15H15V19H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgExternal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEyeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 3C6.40848 3 1.71018 6.82432 0.378052 12C1.71018 17.1757 6.40848 21 12 21C17.5915 21 22.2898 17.1757 23.6219 12C22.2898 6.82432 17.5915 3 12 3ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 3C17.5915 3 22.2898 6.82432 23.6219 12C22.2898 17.1757 17.5915 21 12 21C6.40848 21 1.71018 17.1757 0.378052 12C1.71018 6.82432 6.40848 3 12 3ZM12 19C7.52443 19 3.73132 16.0581 2.45723 12C3.73132 7.94186 7.52443 5 12 5C16.4756 5 20.2687 7.94186 21.5428 12C20.2687 16.0581 16.4756 19 12 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.19795 21.5H13.198V13.4901H16.8021L17.198 9.50977H13.198V7.5C13.198 6.94772 13.6457 6.5 14.198 6.5H17.198V2.5H14.198C11.4365 2.5 9.19795 4.73858 9.19795 7.5V9.50977H7.19795L6.80206 13.4901H9.19795V21.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.552 8C11.9997 8 11.552 8.44772 11.552 9C11.552 9.55228 11.9997 10 12.552 10H16.552C17.1043 10 17.552 9.55228 17.552 9C17.552 8.44772 17.1043 8 16.552 8H12.552Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.552 17C11.9997 17 11.552 17.4477 11.552 18C11.552 18.5523 11.9997 19 12.552 19H16.552C17.1043 19 17.552 18.5523 17.552 18C17.552 17.4477 17.1043 17 16.552 17H12.552Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.552 5C11.9997 5 11.552 5.44772 11.552 6C11.552 6.55228 11.9997 7 12.552 7H20.552C21.1043 7 21.552 6.55228 21.552 6C21.552 5.44772 21.1043 5 20.552 5H12.552Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.552 14C11.9997 14 11.552 14.4477 11.552 15C11.552 15.5523 11.9997 16 12.552 16H20.552C21.1043 16 21.552 15.5523 21.552 15C21.552 14.4477 21.1043 14 20.552 14H12.552Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.448 4.00208C2.89571 4.00208 2.448 4.44979 2.448 5.00208V10.0021C2.448 10.5544 2.89571 11.0021 3.448 11.0021H8.448C9.00028 11.0021 9.448 10.5544 9.448 10.0021V5.00208C9.448 4.44979 9.00028 4.00208 8.448 4.00208H3.448Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.448 12.9979C2.89571 12.9979 2.448 13.4456 2.448 13.9979V18.9979C2.448 19.5502 2.89571 19.9979 3.448 19.9979H8.448C9.00028 19.9979 9.448 19.5502 9.448 18.9979V13.9979C9.448 13.4456 9.00028 12.9979 8.448 12.9979H3.448Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2C6.84315 2 5.5 3.34315 5.5 5C5.5 6.65685 6.84315 8 8.5 8H15.5C17.1569 8 18.5 6.65685 18.5 5C18.5 3.34315 17.1569 2 15.5 2H8.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9C13.8431 9 12.5 10.3431 12.5 12C12.5 13.6569 13.8431 15 15.5 15C17.1569 15 18.5 13.6569 18.5 12C18.5 10.3431 17.1569 9 15.5 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 12C5.5 10.3431 6.84315 9 8.5 9H11.5V15H8.5C6.84315 15 5.5 13.6569 5.5 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16C6.84315 16 5.5 17.3431 5.5 19C5.5 20.6569 6.84315 22 8.5 22C10.1569 22 11.5 20.6569 11.5 19V16H8.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18V16H8V14H10V12H12V14H14V16H12V18H10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V9C21 5.13401 17.866 2 14 2H6ZM6 4H13V9H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4ZM15 4.10002C16.6113 4.4271 17.9413 5.52906 18.584 7H15V4.10002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFileDocument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18H17V16H7V18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14H7V12H17V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10H11V8H7V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V9C21 5.13401 17.866 2 14 2H6ZM6 4H13V9H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4ZM15 4.10002C16.6113 4.4271 17.9413 5.52906 18.584 7H15V4.10002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFileRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15H15V13H9V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V9C21 5.13401 17.866 2 14 2H6ZM6 4H13V9H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4ZM15 4.10002C16.6113 4.4271 17.9413 5.52906 18.584 7H15V4.10002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 5C3 3.34315 4.34315 2 6 2H14C17.866 2 21 5.13401 21 9V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM13 4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V9H13V4ZM18.584 7C17.9413 5.52906 16.6113 4.4271 15 4.10002V7H18.584Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8C17 7.44772 17.4477 7 18 7C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9C17.4477 9 17 8.55228 17 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13C17.4477 13 17 12.5523 17 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17C6.55228 17 7 16.5523 7 16C7 15.4477 6.55228 15 6 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V6C23 4.34315 21.6569 3 20 3H4ZM20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFilters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.70834 15.4397C5.92663 16.2928 7.3222 16.7038 8.70461 16.7063C9.17977 18.0045 10.0433 19.1753 11.2616 20.0284C14.4284 22.2458 18.7932 21.4762 21.0107 18.3093C23.2281 15.1425 22.4585 10.7777 19.2916 8.56024C18.0734 7.70719 16.6778 7.29621 15.2954 7.29371C14.8202 5.99552 13.9567 4.82467 12.7384 3.97161C9.57158 1.75417 5.20676 2.52381 2.98931 5.69064C0.771871 8.85748 1.54151 13.2223 4.70834 15.4397ZM5.8555 13.8014C6.6016 14.3239 7.44081 14.6142 8.28736 14.6875C8.20112 13.1725 8.60464 11.6187 9.54254 10.2793C10.4804 8.9398 11.8025 8.0292 13.2556 7.59209C12.8972 6.82166 12.3374 6.13235 11.5913 5.60992C9.32924 4.02603 6.21151 4.57577 4.62762 6.8378C3.04373 9.09982 3.59347 12.2176 5.8555 13.8014ZM18.1445 10.1985C17.3984 9.67611 16.5592 9.38581 15.7126 9.31251C15.7989 10.8275 15.3953 12.3813 14.4574 13.7207C13.5195 15.0602 12.1975 15.9708 10.7444 16.4079C11.1028 17.1783 11.6626 17.8676 12.4087 18.3901C14.6707 19.9739 17.7885 19.4242 19.3724 17.1622C20.9562 14.9002 20.4065 11.7824 18.1445 10.1985Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFlagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.4388 7L14.8387 4H7V10H14.8387L12.4388 7ZM19 12H7V22H5V2H19L15 7L19 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 21H6V11H12V13H20V5H13V3H4V21ZM12 5H6V9H13V11H18V7H12V5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14.5V16.5H13V14.5H15V12.5H13V10.5H11V12.5H9V14.5H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1.5C2.89543 1.5 2 2.39543 2 3.5V4.5C2 4.55666 2.00236 4.61278 2.00698 4.66825C0.838141 5.07811 0 6.19118 0 7.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V7.5C24 5.84315 22.6569 4.5 21 4.5H11.874C11.4299 2.77477 9.86384 1.5 8 1.5H4ZM9.73244 4.5C9.38663 3.9022 8.74028 3.5 8 3.5H4V4.5H9.73244ZM3 6.5C2.44772 6.5 2 6.94772 2 7.5V19.5C2 20.0523 2.44772 20.5 3 20.5H21C21.5523 20.5 22 20.0523 22 19.5V7.5C22 6.94772 21.5523 6.5 21 6.5H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFolderRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14.5V12.5H15V14.5H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1.5C2.89543 1.5 2 2.39543 2 3.5V4.5C2 4.55666 2.00236 4.61278 2.00698 4.66825C0.838141 5.07811 0 6.19118 0 7.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V7.5C24 5.84315 22.6569 4.5 21 4.5H11.874C11.4299 2.77477 9.86384 1.5 8 1.5H4ZM9.73244 4.5C9.38663 3.9022 8.74028 3.5 8 3.5H4V4.5H9.73244ZM3 6.5C2.44772 6.5 2 6.94772 2 7.5V19.5C2 20.0523 2.44772 20.5 3 20.5H21C21.5523 20.5 22 20.0523 22 19.5V7.5C22 6.94772 21.5523 6.5 21 6.5H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1.5C2.89543 1.5 2 2.39543 2 3.5V4.5C2 4.55666 2.00236 4.61278 2.00698 4.66825C0.838141 5.07811 0 6.19118 0 7.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V7.5C24 5.84315 22.6569 4.5 21 4.5H11.874C11.4299 2.77477 9.86384 1.5 8 1.5H4ZM9.73244 4.5C9.38663 3.9022 8.74028 3.5 8 3.5H4V4.5H9.73244ZM3 6.5C2.44772 6.5 2 6.94772 2 7.5V19.5C2 20.0523 2.44772 20.5 3 20.5H21C21.5523 20.5 22 20.0523 22 19.5V7.5C22 6.94772 21.5523 6.5 21 6.5H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFontHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5V3H3V5H21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V21H3V19H21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0001 7.37636C11.602 7.35207 11.2112 7.56874 11.0325 7.95204L7.65154 15.2025C7.41815 15.7031 7.6347 16.2981 8.13522 16.5315C8.63577 16.7649 9.23074 16.5484 9.46417 16.0477L9.95278 14.9999H14.0473L14.5359 16.0477C14.7693 16.5484 15.3643 16.7649 15.8648 16.5315C16.3654 16.2981 16.5819 15.7031 16.3485 15.2025L12.9676 7.95204C12.7888 7.56874 12.3981 7.35207 12.0001 7.37636ZM13.1147 12.9999H10.8854L12.0001 10.6095L13.1147 12.9999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFontSpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21H21V3H19L19 21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21H3V3H5L5 21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.46416 16.0479L9.95281 14.9999H14.0473L14.5359 16.0478C14.7693 16.5484 15.3643 16.7649 15.8649 16.5315C16.3654 16.2981 16.582 15.7031 16.3485 15.2026L12.9676 7.95213C12.7888 7.56877 12.398 7.35199 11.9999 7.37637C11.6019 7.35214 11.2112 7.5689 11.0325 7.95216L7.65155 15.2026C7.41814 15.7032 7.6347 16.2981 8.13524 16.5315C8.63578 16.7649 9.23076 16.5484 9.46416 16.0479ZM12.0001 10.6096L10.8854 12.9999H13.1147L12.0001 10.6096Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 4.504H7v14.992h6a4 4 0 0 0 .604-7.955A4 4 0 0 0 11 4.505Zm-2 2h2a2 2 0 1 1 0 4H9v-4Zm0 10.991v-4h4a2 2 0 1 1 0 4H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H20C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10C6 9.44772 6.44772 9 7 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11H7C6.44772 11 6 10.5523 6 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.9479 3.20946C12.7721 2.83236 12.391 2.61645 11.9997 2.63269C11.6086 2.61666 11.2278 2.83255 11.0521 3.20948L5.1354 15.8978C4.90199 16.3983 5.11855 16.9933 5.61909 17.2267C6.11963 17.4601 6.71461 17.2436 6.94801 16.743L8.39869 13.632H15.6013L17.052 16.743C17.2854 17.2435 17.8804 17.4601 18.3809 17.2267C18.8814 16.9933 19.098 16.3983 18.8646 15.8978L12.9479 3.20946ZM14.6687 11.632L12 5.909L9.33131 11.632H14.6687Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19.3682C5.44772 19.3682 5 19.816 5 20.3682C5 20.9205 5.44772 21.3682 6 21.3682H18C18.5523 21.3682 19 20.9205 19 20.3682C19 19.816 18.5523 19.3682 18 19.3682H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19V5H8V11H16V5H18V19H16V13H8V19H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatIndentDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H4V5H20V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H12V9H20V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15H20V13H12V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9L4 12L9 15V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17V19H20V17H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatIndentIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7H4V5H20V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H12V9H20V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15H20V13H12V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15L9 12L4 9V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17V19H20V17H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.4903 5.45801H17.4903L16.7788 7.32716H14.7788L11.2212 16.6729H13.2212L12.5097 18.5421H6.5097L7.22122 16.6729H9.22122L12.7788 7.32716H10.7788L11.4903 5.45801Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H20C20.5523 11 21 10.5523 21 10C21 9.44772 20.5523 9 20 9H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H12C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H12C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatLineHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.09668 6.99707H7.17358L4.17358 3.99707L1.17358 6.99707H3.09668V17.0031H1.15881L4.15881 20.0031L7.15881 17.0031H5.09668V6.99707Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.8412 7H8.84119V5H22.8412V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.8412 11H8.84119V9H22.8412V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.84119 15H22.8412V13H8.84119V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.8412 19H8.84119V17H22.8412V19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5H20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H12C11.4477 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9H20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14C21 13.4477 20.5523 13 20 13H4C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H20C20.5523 15 21 14.5523 21 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H12C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17H20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatSeparator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "opacity": "0.5"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M16 5C16.5523 5 17 4.55229 17 4C17 3.44772 16.5523 3 16 3H8C7.44771 3 7 3.44772 7 4C7 4.55228 7.44771 5 8 5L16 5Z",
                            "fill": "currentColor"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M16 7C16.5523 7 17 7.44772 17 8C17 8.55229 16.5523 9 16 9H8C7.44771 9 7 8.55229 7 8C7 7.44772 7.44771 7 8 7H16Z",
                            "fill": "currentColor"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M17 12C17 12.5523 16.5523 13 16 13L8 13C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11L16 11C16.5523 11 17 11.4477 17 12Z",
                            "fill": "currentColor"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19L8 19C7.44771 19 7 19.4477 7 20C7 20.5523 7.44771 21 8 21H16Z",
                            "fill": "currentColor"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M21 16C21 16.5523 20.5523 17 20 17L4 17C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15L20 15C20.5523 15 21 15.4477 21 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.526 6.10576C15.0265 6.33917 15.2667 6.88343 15.0625 7.3214L9.88541 18.4237C9.68118 18.8616 9.10985 19.0275 8.60931 18.7941C8.10877 18.5607 7.86857 18.0164 8.0728 17.5784L13.2499 6.47616C13.4541 6.03819 14.0254 5.87235 14.526 6.10576Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatStrike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7H17V5H7V7H11V10H13V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19V14H13V19H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13H19V11H5V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 3H3V6.5H4V4H6.5V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4V3H11V4H8.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4H15.5V3H13V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 3V4H20V6.5H21V3H17.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8.5H20V11H21V8.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13H20V15.5H21V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17.5H20V20H17.5V21H21V17.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 21V20H13V21H15.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21V20H8.5V21H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 21V20H4V17.5H3V21H6.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15.5H4V13H3V15.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11H4V8.5H3V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9.5H7V7.5H17V9.5H13V16.5H11V9.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10V4H8V10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10V4H18V10C18 13.3137 15.3137 16 12 16C8.68629 16 6 13.3137 6 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18C6.44772 18 6 18.4477 6 19C6 19.5523 6.44771 20 7 20H17C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18H7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFormatUppercase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 9H10V17H8V9H5V7H13V9ZM18 13H16V17H14V13H12V11H18V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgFramer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21L12 9L6 9L6 15L12 21Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9V3H6L12 9H6V15H18L12 9H18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4695 11.2929C15.0789 10.9024 14.4458 10.9024 14.0553 11.2929C13.6647 11.6834 13.6647 12.3166 14.0553 12.7071C14.4458 13.0976 15.0789 13.0976 15.4695 12.7071C15.86 12.3166 15.86 11.6834 15.4695 11.2929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1766 9.17156C16.5671 8.78103 17.2003 8.78103 17.5908 9.17156C17.9813 9.56208 17.9813 10.1952 17.5908 10.5858C17.2003 10.9763 16.5671 10.9763 16.1766 10.5858C15.7861 10.1952 15.7861 9.56208 16.1766 9.17156Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7121 11.2929C19.3216 10.9024 18.6885 10.9024 18.2979 11.2929C17.9074 11.6834 17.9074 12.3166 18.2979 12.7071C18.6885 13.0976 19.3216 13.0976 19.7121 12.7071C20.1027 12.3166 20.1027 11.6834 19.7121 11.2929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1766 13.4142C16.5671 13.0237 17.2003 13.0237 17.5908 13.4142C17.9813 13.8048 17.9813 14.4379 17.5908 14.8284C17.2003 15.219 16.5671 15.219 16.1766 14.8284C15.7861 14.4379 15.7861 13.8048 16.1766 13.4142Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13H4V11H6V9H8V11H10V13H8V15H6V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 5C3.13401 5 0 8.13401 0 12C0 15.866 3.13401 19 7 19H17C20.866 19 24 15.866 24 12C24 8.13401 20.866 5 17 5H7ZM17 7H7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGenderFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 3C9.23858 3 7 5.23858 7 8C7 10.419 8.71776 12.4367 11 12.9V15H8V17H11V21H13V17H16V15H13V12.9C15.2822 12.4367 17 10.419 17 8C17 5.23858 14.7614 3 12 3ZM9 8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGenderMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.1888 7L12.1909 5L19.1909 5.00746L19.1834 12.0075L17.1834 12.0053L17.1873 8.41678L14.143 11.4611C15.4612 13.4063 15.2587 16.0743 13.5355 17.7975C11.5829 19.7501 8.41709 19.7501 6.46447 17.7975C4.51184 15.8449 4.51184 12.6791 6.46447 10.7264C8.16216 9.02873 10.777 8.80709 12.7141 10.0615L15.7718 7.00382L12.1888 7ZM7.87868 12.1406C9.05025 10.9691 10.9497 10.9691 12.1213 12.1406C13.2929 13.3122 13.2929 15.2117 12.1213 16.3833C10.9497 17.5549 9.05025 17.5549 7.87868 16.3833C6.70711 15.2117 6.70711 13.3122 7.87868 12.1406Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGhostCharacter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9759 9C10.9759 9.55228 10.5282 10 9.97589 10C9.42361 10 8.97589 9.55228 8.97589 9C8.97589 8.44771 9.42361 8 9.97589 8C10.5282 8 10.9759 8.44771 10.9759 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9712 10C14.5235 10 14.9712 9.55228 14.9712 9C14.9712 8.44771 14.5235 8 13.9712 8C13.4189 8 12.9712 8.44771 12.9712 9C12.9712 9.55228 13.4189 10 13.9712 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 20.9999V10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10V21L7.82846 21L9.24264 19.5858L10.6569 21L13.3433 21L14.7574 19.5858L16.1717 21L19 20.9999ZM17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10V19L9.24264 16.7573L12 19.5147L14.7574 16.7573L17 18.9999V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H15V8H3V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8H17V4H21V8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10H21V14H3V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16H3V20H11V16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16V20H21V16H13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17.5354 2.87868C16.3638 1.70711 14.4644 1.70711 13.2928 2.87868L11.8786 4.29289C11.8183 4.35317 11.7611 4.41538 11.707 4.47931C11.653 4.41539 11.5958 4.3532 11.5355 4.29293L10.1213 2.87871C8.94975 1.70714 7.05025 1.70714 5.87868 2.87871C4.70711 4.05029 4.70711 5.94978 5.87868 7.12136L6.75732 8H1V14H3V22H21V14H23V8H16.6567L17.5354 7.12132C18.707 5.94975 18.707 4.05025 17.5354 2.87868ZM14.707 7.12132L16.1212 5.70711C16.5117 5.31658 16.5117 4.68342 16.1212 4.29289C15.7307 3.90237 15.0975 3.90237 14.707 4.29289L13.2928 5.70711C12.9023 6.09763 12.9023 6.7308 13.2928 7.12132C13.6833 7.51184 14.3165 7.51184 14.707 7.12132ZM10.1213 5.70714L8.70711 4.29293C8.31658 3.9024 7.68342 3.9024 7.29289 4.29293C6.90237 4.68345 6.90237 5.31662 7.29289 5.70714L8.70711 7.12136C9.09763 7.51188 9.7308 7.51188 10.1213 7.12136C10.5118 6.73083 10.5118 6.09767 10.1213 5.70714ZM21 10V12H3V10H21ZM12.9167 14H19V20H12.9167V14ZM11.0834 14V20H5V14H11.0834Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGirl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12C10 12.5523 9.55228 13 9 13C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11C9.55228 11 10 11.4477 10 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0244 2.00003L12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.74235 17.9425 2.43237 12.788 2.03059L12.7886 2.0282C12.5329 2.00891 12.278 1.99961 12.0244 2.00003ZM12 20C16.4183 20 20 16.4183 20 12C20 11.3014 19.9105 10.6237 19.7422 9.97775C16.1597 10.2313 12.7359 8.52461 10.7605 5.60246C9.31322 7.07886 7.2982 7.99666 5.06879 8.00253C4.38902 9.17866 4 10.5439 4 12C4 16.4183 7.58172 20 12 20ZM11.9785 4.00003L12.0236 4.00003L12 4L11.9785 4.00003Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGitBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3C7.89543 3 7 3.89543 7 5C7 5.74028 7.4022 6.38663 8 6.73244V17.2676C7.4022 17.6134 7 18.2597 7 19C7 20.1046 7.89543 21 9 21C9.74028 21 10.3866 20.5978 10.7324 20H11.9585C14.1676 20 15.9585 18.2091 15.9585 16V14.7324C16.5563 14.3866 16.9585 13.7403 16.9585 13C16.9585 11.8954 16.0631 11 14.9585 11C13.8539 11 12.9585 11.8954 12.9585 13C12.9585 13.7403 13.3607 14.3866 13.9585 14.7324V16C13.9585 17.1046 13.0631 18 11.9585 18H10.7324C10.5568 17.6964 10.3036 17.4432 10 17.2676V6.73244C10.5978 6.38663 11 5.74028 11 5C11 3.89543 10.1046 3 9 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGitCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V9.17071C14.1652 9.58254 15 10.6938 15 12C15 13.3062 14.1652 14.4175 13 14.8293V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V14.8293C9.83481 14.4175 9 13.3062 9 12C9 10.6938 9.83481 9.58254 11 9.17071V4ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGitFork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5C7 3.89543 7.89543 3 9 3C10.1046 3 11 3.89543 11 5C11 5.74028 10.5978 6.38663 10 6.73244V14.0396H11.7915C12.8961 14.0396 13.7915 13.1441 13.7915 12.0396V10.7838C13.1823 10.4411 12.7708 9.78837 12.7708 9.03955C12.7708 7.93498 13.6662 7.03955 14.7708 7.03955C15.8753 7.03955 16.7708 7.93498 16.7708 9.03955C16.7708 9.77123 16.3778 10.4111 15.7915 10.7598V12.0396C15.7915 14.2487 14.0006 16.0396 11.7915 16.0396H10V17.2676C10.5978 17.6134 11 18.2597 11 19C11 20.1046 10.1046 21 9 21C7.89543 21 7 20.1046 7 19C7 18.2597 7.4022 17.6134 8 17.2676V6.73244C7.4022 6.38663 7 5.74028 7 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGitPull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5C7 3.89543 7.89543 3 9 3C10.1046 3 11 3.89543 11 5C11 5.34168 10.9143 5.66336 10.7633 5.9447H11.3438C13.5529 5.9447 15.3438 7.73556 15.3438 9.9447V11.2244C15.9301 11.5731 16.323 12.213 16.323 12.9447C16.323 14.0493 15.4276 14.9447 14.323 14.9447C13.2184 14.9447 12.323 14.0493 12.323 12.9447C12.323 12.1959 12.7345 11.5432 13.3438 11.2004V9.9447C13.3438 8.84013 12.4483 7.9447 11.3438 7.9447H10V17.2676C10.5978 17.6134 11 18.2597 11 19C11 20.1046 10.1046 21 9 21C7.89543 21 7 20.1046 7 19C7 18.2597 7.4022 17.6134 8 17.2676V6.73244C7.4022 6.38663 7 5.74028 7 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1.5H7V14.5H5V1.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4.5H11V22.5H9V4.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4.5H13V22.5H15V4.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.5H19V14.5H17V4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGlassAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 2H19L17.3602 18.398C17.1557 20.4428 15.4351 22 13.38 22H10.62C8.56494 22 6.84428 20.4428 6.6398 18.398L5 2ZM7.50998 7L7.20998 4H16.79L16.49 7H7.50998ZM7.70998 9L8.62988 18.199C8.73212 19.2214 9.59245 20 10.62 20H13.38C14.4076 20 15.2679 19.2214 15.3701 18.199L16.29 9H7.70998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 10C17 12.419 15.2822 14.4367 13 14.9V17H15V19H9V17H11V14.9C8.71776 14.4367 7 12.419 7 10V5H17V10ZM15 7H9V10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGlobeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM14.8055 18.4151C17.1228 17.4003 18.7847 15.1667 18.9806 12.525C18.1577 12.9738 17.12 13.3418 15.9371 13.598C15.7882 15.4676 15.3827 17.1371 14.8055 18.4151ZM9.1945 5.58487C7.24725 6.43766 5.76275 8.15106 5.22208 10.244C5.4537 10.4638 5.84813 10.7341 6.44832 11.0008C6.89715 11.2003 7.42053 11.3798 8.00537 11.5297C8.05853 9.20582 8.50349 7.11489 9.1945 5.58487ZM10.1006 13.9108C10.2573 15.3675 10.5852 16.6202 10.9992 17.5517C11.2932 18.2133 11.5916 18.6248 11.8218 18.8439C11.9037 18.9219 11.9629 18.9634 12 18.9848C12.0371 18.9634 12.0963 18.9219 12.1782 18.8439C12.4084 18.6248 12.7068 18.2133 13.0008 17.5517C13.4148 16.6202 13.7427 15.3675 13.8994 13.9108C13.2871 13.9692 12.6516 14 12 14C11.3484 14 10.7129 13.9692 10.1006 13.9108ZM8.06286 13.598C8.21176 15.4676 8.61729 17.1371 9.1945 18.4151C6.8772 17.4003 5.21525 15.1666 5.01939 12.525C5.84231 12.9738 6.88001 13.3418 8.06286 13.598ZM13.9997 11.8896C13.369 11.9609 12.6993 12 12 12C11.3008 12 10.631 11.9609 10.0003 11.8896C10.0135 9.66408 10.4229 7.74504 10.9992 6.44832C11.2932 5.78673 11.5916 5.37516 11.8218 5.15605C11.9037 5.07812 11.9629 5.03659 12 5.01516C12.0371 5.03659 12.0963 5.07812 12.1782 5.15605C12.4084 5.37516 12.7068 5.78673 13.0008 6.44832C13.5771 7.74504 13.9865 9.66408 13.9997 11.8896ZM15.9946 11.5297C15.9415 9.20582 15.4965 7.11489 14.8055 5.58487C16.7528 6.43766 18.2373 8.15107 18.7779 10.244C18.5463 10.4638 18.1519 10.7341 17.5517 11.0008C17.1029 11.2003 16.5795 11.3798 15.9946 11.5297Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.85327 8C6.85327 5.23858 9.09185 3 11.8533 3C14.6147 3 16.8533 5.23858 16.8533 8C16.8533 10.7614 14.6147 13 11.8533 13C9.09185 13 6.85327 10.7614 6.85327 8ZM11.8533 11C10.1964 11 8.85327 9.65685 8.85327 8C8.85327 6.34315 10.1964 5 11.8533 5C13.5101 5 14.8533 6.34315 14.8533 8C14.8533 9.65685 13.5101 11 11.8533 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.1294C6.25216 14.2031 8.4189 15.6624 10.9414 15.9486V18H8.85327V20H14.8533V18H12.9414V15.9266C16.8449 15.3958 19.8532 12.0492 19.8532 8.00001C19.8532 6.43638 19.4046 4.97752 18.6291 3.74512L16.9253 4.79326C17.513 5.72084 17.8532 6.82069 17.8532 8.00001C17.8532 11.3137 15.167 14 11.8532 14C9.66611 14 7.75231 12.8298 6.70381 11.0813L5 12.1294Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGoogleTasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7679 5.71447C17.4779 4.86832 18.7394 4.75795 19.5856 5.46796C20.4317 6.17796 20.5421 7.43947 19.8321 8.28562L10.833 19.0102C10.123 19.8564 8.86153 19.9668 8.01538 19.2568C7.16923 18.5468 7.05886 17.2852 7.76886 16.4391L16.7679 5.71447Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12.7396C3 11.6351 3.89543 10.7396 5 10.7396C6.10457 10.7396 7 11.6351 7 12.7396C7 13.8442 6.10457 14.7396 5 14.7396C3.89543 14.7396 3 13.8442 3 12.7396Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12C6 15.3137 8.68629 18 12 18C14.6124 18 16.8349 16.3304 17.6586 14H12V10H21.8047V14H21.8C20.8734 18.5645 16.8379 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.445 2 18.4831 3.742 20.2815 6.39318L17.0039 8.68815C15.9296 7.06812 14.0895 6 12 6C8.68629 6 6 8.68629 6 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgGym(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2739 9.86883L16.8325 4.95392L18.4708 3.80676L21.9122 8.72167L20.2739 9.86883Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3901 12.4086L16.6694 9.95121L8.47783 15.687L10.1985 18.1444L8.56023 19.2916L3.97162 12.7383L5.60992 11.5912L7.33068 14.0487L15.5222 8.31291L13.8015 5.8554L15.4398 4.70825L20.0284 11.2615L18.3901 12.4086Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.7651 7.08331L22.4034 5.93616L21.2562 4.29785L19.6179 5.445L20.7651 7.08331Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.16753 19.046L3.72607 14.131L2.08777 15.2782L5.52923 20.1931L7.16753 19.046Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.38208 18.5549L2.74377 19.702L1.59662 18.0637L3.23492 16.9166L4.38208 18.5549Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHashtag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 4V8H4V10H8V14H4V16H8V20H10V16H14V20H16V16H20V14H16V10H20V8H16V4H14V8H10V4H8ZM14 14V10H10V14H14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 21C15.8954 21 15 20.1046 15 19V15C15 13.8954 15.8954 13 17 13H19V12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12V13H7C8.10457 13 9 13.8954 9 15V19C9 20.1046 8.10457 21 7 21H3V12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12V21H17ZM19 15H17V19H19V15ZM7 15H5V19H7V15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0122 5.57169L10.9252 4.48469C8.77734 2.33681 5.29493 2.33681 3.14705 4.48469C0.999162 6.63258 0.999162 10.115 3.14705 12.2629L11.9859 21.1017L11.9877 21.0999L12.014 21.1262L20.8528 12.2874C23.0007 10.1395 23.0007 6.65711 20.8528 4.50923C18.705 2.36134 15.2226 2.36134 13.0747 4.50923L12.0122 5.57169ZM11.9877 18.2715L16.9239 13.3352L18.3747 11.9342L18.3762 11.9356L19.4386 10.8732C20.8055 9.50635 20.8055 7.29028 19.4386 5.92344C18.0718 4.55661 15.8557 4.55661 14.4889 5.92344L12.0133 8.39904L12.006 8.3918L12.005 8.39287L9.51101 5.89891C8.14417 4.53207 5.92809 4.53207 4.56126 5.89891C3.19442 7.26574 3.19442 9.48182 4.56126 10.8487L7.10068 13.3881L7.10248 13.3863L11.9877 18.2715Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 12C17.5 13.576 16.8371 14.9972 15.7749 16C14.7899 16.9299 13.4615 17.5 12 17.5C10.5385 17.5 9.21007 16.9299 8.22506 16C7.16289 14.9972 6.5 13.576 6.5 12H17.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 7C1 3.68629 3.68629 1 7 1H17C20.3137 1 23 3.68629 23 7V17C23 20.3137 20.3137 23 17 23H1V7ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 22.8787C4.34315 22.8787 3 21.5355 3 19.8787V9.87866C3 9.84477 3.00169 9.81126 3.00498 9.77823H3C3 9.20227 3.2288 8.64989 3.63607 8.24262L9.87868 2.00002C11.0502 0.828445 12.9497 0.828445 14.1213 2.00002L20.3639 8.24264C20.7712 8.6499 21 9.20227 21 9.77823H20.995C20.9983 9.81126 21 9.84477 21 9.87866V19.8787C21 21.5355 19.6569 22.8787 18 22.8787H6ZM12.7071 3.41423L19 9.70713V19.8787C19 20.4309 18.5523 20.8787 18 20.8787H15V15.8787C15 14.2218 13.6569 12.8787 12 12.8787C10.3431 12.8787 9 14.2218 9 15.8787V20.8787H6C5.44772 20.8787 5 20.4309 5 19.8787V9.7072L11.2929 3.41423C11.6834 3.02371 12.3166 3.02371 12.7071 3.41423Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHomeScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5C10 5.55228 9.55228 6 9 6C8.44771 6 8 5.55228 8 5C8 4.44772 8.44771 4 9 4C9.55228 4 10 4.44772 10 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9C9.55228 9 10 8.55228 10 8C10 7.44772 9.55228 7 9 7C8.44771 7 8 7.44772 8 8C8 8.55228 8.44771 9 9 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19C10 19.5523 9.55228 20 9 20C8.44771 20 8 19.5523 8 19C8 18.4477 8.44771 18 9 18C9.55228 18 10 18.4477 10 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12C9.55228 12 10 11.5523 10 11C10 10.4477 9.55228 10 9 10C8.44771 10 8 10.4477 8 11C8 11.5523 8.44771 12 9 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 1C6.34315 1 5 2.34315 5 4V20C5 21.6569 6.34315 23 8 23H16C17.6569 23 19 21.6569 19 20V4C19 2.34315 17.6569 1 16 1H8ZM16 3H8C7.44771 3 7 3.44772 7 4V20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20V4C17 3.44772 16.5523 3 16 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M21 8.77217L14.0208 1.79299C12.8492 0.621414 10.9497 0.621413 9.77817 1.79299L3 8.57116V23.0858H10V17.0858C10 15.9812 10.8954 15.0858 12 15.0858C13.1046 15.0858 14 15.9812 14 17.0858V23.0858H21V8.77217ZM11.1924 3.2072L5 9.39959V21.0858H8V17.0858C8 14.8767 9.79086 13.0858 12 13.0858C14.2091 13.0858 16 14.8767 16 17.0858V21.0858H19V9.6006L12.6066 3.2072C12.2161 2.81668 11.5829 2.81668 11.1924 3.2072Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgIcecream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 17H19V8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8V17H9V20C9 21.6569 10.3431 23 12 23C13.6569 23 15 21.6569 15 20V17ZM17 15V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V15H11V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V15H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgIfDesign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5H14V19H10V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19V10H9V19H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H19V9H15V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H15V14H19V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 7C5.34315 7 4 8.34315 4 10C4 11.6569 5.34315 13 7 13C8.65685 13 10 11.6569 10 10C10 8.34315 8.65685 7 7 7ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3C1.34315 3 0 4.34315 0 6V18C0 19.6569 1.34315 21 3 21H21C22.6569 21 24 19.6569 24 18V6C24 4.34315 22.6569 3 21 3H3ZM21 5H3C2.44772 5 2 5.44772 2 6V18C2 18.5523 2.44772 19 3 19H7.31374L14.1924 12.1214C15.364 10.9498 17.2635 10.9498 18.435 12.1214L22 15.6863V6C22 5.44772 21.5523 5 21 5ZM21 19H10.1422L15.6066 13.5356C15.9971 13.145 16.6303 13.145 17.0208 13.5356L21.907 18.4217C21.7479 18.7633 21.4016 19 21 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9.98193V19.9819H19V9.98193H15V7.98193H21V21.9819H3V7.98193H9V9.98193H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.0001 2H11.0001V14.0531L8.46451 11.5175L7.05029 12.9317L12 17.8815L16.9498 12.9317L15.5356 11.5175L13.0001 14.053V2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V20C22 21.1046 21.1046 22 20 22H8.1477C8.09893 22.0036 8.04968 22.0054 8 22.0054H4C2.89543 22.0054 2 21.1099 2 20.0054V5ZM5 4H19C19.5523 4 20 4.44771 20 5V14H16C14.8954 14 14 14.8954 14 16V17H10V16.0054C10 14.9008 9.10457 14.0054 8 14.0054H4V5C4 4.44772 4.44771 4 5 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgIndieHackers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H7V18H4V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6H13V10.5H17V6H20V18H17V13.5H13V18H10V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInfinity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.12132 9.87868L10.2044 11.9617L10.2106 11.9555L11.6631 13.408L11.6693 13.4142L13.7907 15.5355C15.7433 17.4882 18.9091 17.4882 20.8617 15.5355C22.8144 13.5829 22.8144 10.4171 20.8617 8.46447C18.9091 6.51184 15.7433 6.51184 13.7907 8.46447L13.0773 9.17786L14.4915 10.5921L15.2049 9.87868C16.3764 8.70711 18.2759 8.70711 19.4475 9.87868C20.6191 11.0503 20.6191 12.9497 19.4475 14.1213C18.2759 15.2929 16.3764 15.2929 15.2049 14.1213L13.1326 12.0491L13.1263 12.0554L9.53553 8.46447C7.58291 6.51184 4.41709 6.51184 2.46447 8.46447C0.511845 10.4171 0.511845 13.5829 2.46447 15.5355C4.41709 17.4882 7.58291 17.4882 9.53553 15.5355L10.2488 14.8222L8.83463 13.408L8.12132 14.1213C6.94975 15.2929 5.05025 15.2929 3.87868 14.1213C2.70711 12.9497 2.70711 11.0503 3.87868 9.87868C5.05025 8.70711 6.94975 8.70711 8.12132 9.87868Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10.9794C11 10.4271 11.4477 9.97937 12 9.97937C12.5523 9.97937 13 10.4271 13 10.9794V16.9794C13 17.5317 12.5523 17.9794 12 17.9794C11.4477 17.9794 11 17.5317 11 16.9794V10.9794Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.05115C11.4477 6.05115 11 6.49886 11 7.05115C11 7.60343 11.4477 8.05115 12 8.05115C12.5523 8.05115 13 7.60343 13 7.05115C13 6.49886 12.5523 6.05115 12 6.05115Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInpicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12H14V17H20V12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6ZM3 6H21V18H3L3 6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsertAfterO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8C8.44772 8 8 8.44772 8 9C8 9.55229 8.44772 10 9 10H11V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V10H15C15.5523 10 16 9.55229 16 9C16 8.44772 15.5523 8 15 8H13V6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V8H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9C20 13.4183 16.4183 17 12 17C7.58172 17 4 13.4183 4 9ZM12 15C8.68629 15 6 12.3137 6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9C18 12.3137 15.3137 15 12 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20C4.44772 20 4 20.4477 4 21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsertAfterR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8C8.44772 8 8 8.44772 8 9C8 9.55229 8.44772 10 9 10H11V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V10H15C15.5523 10 16 9.55229 16 9C16 8.44772 15.5523 8 15 8H13V6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V8H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 4C4 2.34315 5.34315 1 7 1H17C18.6569 1 20 2.34315 20 4V14C20 15.6569 18.6569 17 17 17H7C5.34315 17 4 15.6569 4 14V4ZM7 3H17C17.5523 3 18 3.44772 18 4V14C18 14.5523 17.5523 15 17 15H7C6.44772 15 6 14.5523 6 14V4C6 3.44772 6.44772 3 7 3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20C4.44772 20 4 20.4477 4 21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsertAfter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C12.5523 4 13 4.44772 13 5V8H16C16.5523 8 17 8.44772 17 9C17 9.55228 16.5523 10 16 10H13V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V10H8C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8H11V5C11 4.44772 11.4477 4 12 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsertBeforeO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3C4.44772 3 4 2.55228 4 2C4 1.44772 4.44772 1 5 1H19C19.5523 1 20 1.44772 20 2C20 2.55228 19.5523 3 19 3H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13H11V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 14C4 18.4183 7.58172 22 12 22C16.4183 22 20 18.4183 20 14C20 9.58172 16.4183 6 12 6C7.58172 6 4 9.58172 4 14ZM12 8C8.68629 8 6 10.6863 6 14C6 17.3137 8.68629 20 12 20C15.3137 20 18 17.3137 18 14C18 10.6863 15.3137 8 12 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsertBeforeR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3C4.44772 3 4 2.55228 4 2C4 1.44772 4.44772 1 5 1H19C19.5523 1 20 1.44772 20 2C20 2.55228 19.5523 3 19 3H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13H11V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H7C5.34315 6 4 7.34315 4 9V19ZM17 20C17.5523 20 18 19.5523 18 19V9C18 8.44772 17.5523 8 17 8H7C6.44772 8 6 8.44772 6 9V19C6 19.5523 6.44772 20 7 20H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsertBefore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5C3 5.55228 3.44772 6 4 6H20C20.5523 6 21 5.55228 21 5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20C12.5523 20 13 19.5523 13 19V16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H13V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14H8C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H11V19C11 19.5523 11.4477 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInsights(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 8H19V20H5V10H9V4H15V8ZM13 6H11V18H13V6ZM15 10V18H17V10H15ZM9 12V18H7V12H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7ZM9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 1C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5ZM19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgInternal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.7084 4.41165L10.4586 14.6986H14.0488V16.6986H7.04883V9.69861H9.04883V13.2799L19.2916 3L20.7084 4.41165Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.70581V6.70581H5V18.7058H17V12.7058H19V20.7058H3V4.70581H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 8C4.34315 8 3 9.34315 3 11V13C3 14.6569 4.34315 16 6 16C7.65685 16 9 14.6569 9 13H15V15H17V13H18V15H20V11H9C9 9.34315 7.65685 8 6 8ZM7 13V11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11V13C5 13.5523 5.44772 14 6 14C6.55228 14 7 13.5523 7 13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgKeyhole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 12.8293C14.1652 12.4175 15 11.3062 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.3062 9.83481 12.4175 11 12.8293V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12.8293ZM11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H5C3.89543 16 3 15.1046 3 14V6ZM5 6H19V14H5V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18C1.44772 18 1 18.4477 1 19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19C23 18.4477 22.5523 18 22 18H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLastpass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6C20.4477 6 20 6.44771 20 7V17C20 17.5523 20.4477 18 21 18C21.5523 18 22 17.5523 22 17V7C22 6.44772 21.5523 6 21 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12C12 13.1046 11.1046 14 10 14C8.89543 14 8 13.1046 8 12C8 10.8954 8.89543 10 10 10C11.1046 10 12 10.8954 12 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLayoutGridSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7H9V9H7V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H13V9H11V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H15V9H17V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H9V13H7V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H11V13H13V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H17V13H15V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15H7V17H9V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15H13V17H11V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15H15V17H17V15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLayoutGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H7V11H11V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13H7V17H11V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13H17V17H13V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H13V11H17V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLayoutList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7V9H9V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13V11H9V13H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15V17H9V15H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15V17H17V15H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13V11H11V13H17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7V9H11V7H17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLayoutPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16.9307 4.01587H14.7655C14.3582 2.84239 13.2428 2 11.9307 2C10.6185 2 9.50313 2.84239 9.09581 4.01587H6.93066C5.27381 4.01587 3.93066 5.35901 3.93066 7.01587V9.21205C2.80183 9.64283 2 10.7357 2 12.0159C2 13.296 2.80183 14.3889 3.93066 14.8197V17.0159C3.93066 18.6727 5.27381 20.0159 6.93066 20.0159H9.08467C9.48247 21.2064 10.6064 22.0645 11.9307 22.0645C13.255 22.0645 14.3789 21.2064 14.7767 20.0159H16.9307C18.5875 20.0159 19.9307 18.6727 19.9307 17.0159V14.8446C21.095 14.4322 21.929 13.3214 21.929 12.0159C21.929 10.7103 21.095 9.5995 19.9307 9.18718V7.01587C19.9307 5.35901 18.5875 4.01587 16.9307 4.01587ZM5.93066 14.8687V17.0159C5.93066 17.5682 6.37838 18.0159 6.93066 18.0159H9.11902C9.54426 16.8761 10.6427 16.0645 11.9307 16.0645C13.2187 16.0645 14.3171 16.8761 14.7423 18.0159H16.9307C17.4829 18.0159 17.9307 17.5682 17.9307 17.0159V14.8458C16.7646 14.4344 15.929 13.3227 15.929 12.0159C15.929 10.709 16.7646 9.59732 17.9307 9.18597V7.01587C17.9307 6.46358 17.4829 6.01587 16.9307 6.01587H14.7543C14.338 7.17276 13.2309 8 11.9307 8C10.6304 8 9.52331 7.17276 9.10703 6.01587H6.93066C6.37838 6.01587 5.93066 6.46358 5.93066 7.01587V9.16302C7.13193 9.55465 8 10.6839 8 12.0159C8 13.3479 7.13193 14.4771 5.93066 14.8687Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLinear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.03509 12.9431C3.24245 14.9227 4.10472 16.8468 5.62188 18.364C7.13904 19.8811 9.0631 20.7434 11.0428 20.9508L3.03509 12.9431Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11.4938L12.4921 20.9858C13.2976 20.9407 14.0981 20.7879 14.8704 20.5273L3.4585 9.11548C3.19793 9.88771 3.0451 10.6883 3 11.4938Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.86722 8.10999L15.8758 20.1186C16.4988 19.8201 17.0946 19.4458 17.6493 18.9956L4.99021 6.33659C4.54006 6.89125 4.16573 7.487 3.86722 8.10999Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.66301 5.59517C9.18091 2.12137 14.8488 2.135 18.3498 5.63604C21.8508 9.13708 21.8645 14.8049 18.3907 18.3228L5.66301 5.59517Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 12L16.2426 13.4142L19.071 10.5858C20.6331 9.02365 20.6331 6.49099 19.071 4.9289C17.509 3.3668 14.9763 3.3668 13.4142 4.9289L10.5858 7.75732L12 9.17154L14.8284 6.34311C15.6095 5.56206 16.8758 5.56206 17.6568 6.34311C18.4379 7.12416 18.4379 8.39049 17.6568 9.17154L14.8284 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.8285L13.4142 16.2427L10.5858 19.0711C9.02372 20.6332 6.49106 20.6332 4.92896 19.0711C3.36686 17.509 3.36686 14.9764 4.92896 13.4143L7.75739 10.5858L9.1716 12L6.34317 14.8285C5.56212 15.6095 5.56212 16.8758 6.34317 17.6569C7.12422 18.4379 8.39055 18.4379 9.1716 17.6569L12 14.8285Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8285 10.5857C15.219 10.1952 15.219 9.56199 14.8285 9.17147C14.4379 8.78094 13.8048 8.78094 13.4142 9.17147L9.1716 13.4141C8.78107 13.8046 8.78107 14.4378 9.1716 14.8283C9.56212 15.2188 10.1953 15.2188 10.5858 14.8283L14.8285 10.5857Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgListTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 1H1V9H9V6H11V20H15V23H23V15H15V18H13V6H15V9H23V1H15V4H9V1ZM21 3H17V7H21V3ZM17 17H21V21H17V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20 4H4C3.44771 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V5C21 4.44771 20.5523 4 20 4ZM4 2C2.34315 2 1 3.34315 1 5V19C1 20.6569 2.34315 22 4 22H20C21.6569 22 23 20.6569 23 19V5C23 3.34315 21.6569 2 20 2H4ZM6 7H8V9H6V7ZM11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9H17C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7H11ZM8 11H6V13H8V11ZM10 12C10 11.4477 10.4477 11 11 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H11C10.4477 13 10 12.5523 10 12ZM8 15H6V17H8V15ZM10 16C10 15.4477 10.4477 15 11 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H11C10.4477 17 10 16.5523 10 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLivePhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9805 21.9525C12.6579 21.9839 12.3308 22 12 22C11.6692 22 11.3421 21.9839 11.0194 21.9525L11.2132 19.9619C11.4715 19.9871 11.7339 20 12 20C12.2661 20 12.5285 19.9871 12.7868 19.9619L12.9805 21.9525Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09617 21.5719L9.67608 19.6578C9.17124 19.5048 8.68725 19.3031 8.22951 19.058L7.28519 20.821C7.8578 21.1277 8.46374 21.3803 9.09617 21.5719Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.65597 19.7304L6.92562 18.1851C6.5202 17.852 6.14801 17.4798 5.81491 17.0744L4.2696 18.344C4.68539 18.8501 5.1499 19.3146 5.65597 19.7304Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.17901 16.7148L4.94204 15.7705C4.69686 15.3127 4.49516 14.8288 4.34221 14.3239L2.42813 14.9038C2.61974 15.5363 2.87231 16.1422 3.17901 16.7148Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.04746 12.9805L4.03806 12.7868C4.01292 12.5285 4 12.2661 4 12C4 11.7339 4.01292 11.4715 4.03806 11.2132L2.04746 11.0195C2.01607 11.3421 2 11.6692 2 12C2 12.3308 2.01607 12.6579 2.04746 12.9805Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.42813 9.09617L4.34221 9.67608C4.49517 9.17124 4.69686 8.68725 4.94204 8.22951L3.17901 7.28519C2.87231 7.8578 2.61974 8.46374 2.42813 9.09617Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.2696 5.65597L5.81491 6.92562C6.14801 6.5202 6.5202 6.14801 6.92562 5.81491L5.65597 4.2696C5.14991 4.68539 4.68539 5.1499 4.2696 5.65597Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.2852 3.17901L8.22951 4.94204C8.68726 4.69686 9.17124 4.49516 9.67608 4.34221L9.09617 2.42813C8.46374 2.61974 7.8578 2.87231 7.2852 3.17901Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0195 2.04746C11.3421 2.01607 11.6692 2 12 2C12.3308 2 12.6579 2.01607 12.9805 2.04746L12.7868 4.03806C12.5285 4.01292 12.2661 4 12 4C11.7339 4 11.4715 4.01292 11.2132 4.03806L11.0195 2.04746Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9038 2.42813L14.3239 4.34221C14.8288 4.49517 15.3127 4.69686 15.7705 4.94204L16.7148 3.17901C16.1422 2.87231 15.5363 2.61974 14.9038 2.42813Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.344 4.2696L17.0744 5.81491C17.4798 6.14801 17.852 6.5202 18.1851 6.92562L19.7304 5.65597C19.3146 5.14991 18.8501 4.68539 18.344 4.2696Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.821 7.2852L19.058 8.22951C19.3031 8.68726 19.5048 9.17124 19.6578 9.67608L21.5719 9.09617C21.3803 8.46374 21.1277 7.8578 20.821 7.2852Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9525 11.0195L19.9619 11.2132C19.9871 11.4715 20 11.7339 20 12C20 12.2661 19.9871 12.5285 19.9619 12.7868L21.9525 12.9806C21.9839 12.6579 22 12.3308 22 12C22 11.6692 21.9839 11.3421 21.9525 11.0195Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5719 14.9038L19.6578 14.3239C19.5048 14.8288 19.3031 15.3127 19.058 15.7705L20.821 16.7148C21.1277 16.1422 21.3803 15.5363 21.5719 14.9038Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7304 18.344L18.1851 17.0744C17.852 17.4798 17.4798 17.852 17.0744 18.1851L18.344 19.7304C18.8501 19.3146 19.3146 18.8501 19.7304 18.344Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7148 20.821L15.7705 19.058C15.3127 19.3031 14.8288 19.5048 14.3239 19.6578L14.9038 21.5719C15.5363 21.3803 16.1422 21.1277 16.7148 20.821Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLoadbarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "opacity": "0.3",
                    "x": "3",
                    "y": "10",
                    "width": "18",
                    "height": "4",
                    "rx": "2",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "10",
                    "width": "10",
                    "height": "4",
                    "rx": "2",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLoadbarDoc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 5H7C6.44772 5 6 5.44772 6 6V18C6 18.5523 6.44772 19 7 19H17C17.5523 19 18 18.5523 18 18V6C18 5.44772 17.5523 5 17 5ZM7 3C5.34315 3 4 4.34315 4 6V18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18V6C20 4.34315 18.6569 3 17 3H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7H16V9H8V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11H16V13H8V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15H13V17H8V15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLoadbarSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H13V18H11V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13H9V18H7V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H17V18H15V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLoadbar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "10",
                    "width": "18",
                    "height": "4",
                    "rx": "2",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLockUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 7H17C17 4.79086 15.2091 3 13 3C10.7909 3 9 4.79086 9 7V10H18C19.6569 10 21 11.3431 21 13V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V13C3 11.3431 4.34315 10 6 10H7V7C7 3.68629 9.68629 1 13 1C16.3137 1 19 3.68629 19 7ZM18 12H6C5.44772 12 5 12.4477 5 13V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V13C19 12.4477 18.5523 12 18 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 10.5C19.6569 10.5 21 11.8431 21 13.5V19.5C21 21.1569 19.6569 22.5 18 22.5H6C4.34315 22.5 3 21.1569 3 19.5V13.5C3 11.8431 4.34315 10.5 6 10.5V7.5C6 4.18629 8.68629 1.5 12 1.5C15.3137 1.5 18 4.18629 18 7.5V10.5ZM12 3.5C14.2091 3.5 16 5.29086 16 7.5V10.5H8V7.5C8 5.29086 9.79086 3.5 12 3.5ZM18 12.5H6C5.44772 12.5 5 12.9477 5 13.5V19.5C5 20.0523 5.44772 20.5 6 20.5H18C18.5523 20.5 19 20.0523 19 19.5V13.5C19 12.9477 18.5523 12.5 18 12.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLogIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4857 20H19.4857C20.5903 20 21.4857 19.1046 21.4857 18V6C21.4857 4.89543 20.5903 4 19.4857 4H15.4857V6H19.4857V18H15.4857V20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1582 17.385L8.73801 15.9768L12.6572 12.0242L3.51428 12.0242C2.96199 12.0242 2.51428 11.5765 2.51428 11.0242C2.51429 10.4719 2.962 10.0242 3.51429 10.0242L12.6765 10.0242L8.69599 6.0774L10.1042 4.6572L16.4951 10.9941L10.1582 17.385Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLogOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.00894C13.0002 3.45665 12.5527 3.00876 12.0004 3.00854C11.4481 3.00833 11.0002 3.45587 11 4.00815L10.9968 12.0116C10.9966 12.5639 11.4442 13.0118 11.9965 13.012C12.5487 13.0122 12.9966 12.5647 12.9968 12.0124L13 4.00894Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12.9917C4 10.7826 4.89541 8.7826 6.34308 7.33488L7.7573 8.7491C6.67155 9.83488 6 11.3349 6 12.9917C6 16.3054 8.68629 18.9917 12 18.9917C15.3137 18.9917 18 16.3054 18 12.9917C18 11.3348 17.3284 9.83482 16.2426 8.74903L17.6568 7.33481C19.1046 8.78253 20 10.7825 20 12.9917C20 17.41 16.4183 20.9917 12 20.9917C7.58172 20.9917 4 17.41 4 12.9917Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLogOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.51428 20H4.51428C3.40971 20 2.51428 19.1046 2.51428 18V6C2.51428 4.89543 3.40971 4 4.51428 4H8.51428V6H4.51428V18H8.51428V20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8418 17.385L15.262 15.9768L11.3428 12.0242L20.4857 12.0242C21.038 12.0242 21.4857 11.5765 21.4857 11.0242C21.4857 10.4719 21.038 10.0242 20.4857 10.0242L11.3236 10.0242L15.304 6.0774L13.8958 4.6572L7.5049 10.9941L13.8418 17.385Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgLoupe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V8H13V11H16V13H13V16H11V13H8V11H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 12C3 16.9706 7.02944 21 12 21H18C19.6569 21 21 19.6569 21 18V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2.5H4V5.5H8V2.5Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2.5H16V5.5H20V2.5Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7.5H4V13.5C4 17.9183 7.58172 21.5 12 21.5C16.4183 21.5 20 17.9183 20 13.5V7.5H16V13.5C16 15.7091 14.2091 17.5 12 17.5C9.79086 17.5 8 15.7091 8 13.5V7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMailForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.6378 15.529L15.052 16.9432L20.0018 11.9934L15.052 7.0437L13.6378 8.45791L16.1363 10.9564H7.99823C5.78909 10.9564 3.99823 12.7472 3.99823 14.9564V16.9564H5.99823V14.9564C5.99823 13.8518 6.89366 12.9564 7.99823 12.9564H16.2104L13.6378 15.529Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMailOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.05002 10.0151C2.79178 9.30708 2.94668 8.48233 3.51474 7.91427L9.8787 1.55031C11.0503 0.378738 12.9498 0.378738 14.1213 1.55031L20.4853 7.91427C21.0534 8.48239 21.2083 9.30727 20.9499 10.0154C20.9824 10.1139 20.9999 10.2191 20.9999 10.3285V21.3285C20.9999 22.4331 20.1045 23.3285 18.9999 23.3285H4.99994C3.89537 23.3285 2.99994 22.4331 2.99994 21.3285V10.3285C2.99994 10.219 3.01752 10.1137 3.05002 10.0151ZM4.92896 9.32848L11.2929 2.96452C11.6834 2.574 12.3166 2.574 12.7071 2.96452L19.0711 9.32848H19.0408V9.3588L12.7071 15.6924C12.3166 16.083 11.6834 16.083 11.2929 15.6924L4.92896 9.32848ZM18.9999 12.2281L14.1213 17.1067C12.9498 18.2782 11.0503 18.2782 9.8787 17.1067L4.99994 12.2279L4.99994 21.3285H18.9999V12.2281Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMailReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.3623 15.529L8.94804 16.9432L3.99829 11.9934L8.94804 7.0437L10.3623 8.45791L7.86379 10.9564H16.0018C18.2109 10.9564 20.0018 12.7472 20.0018 14.9564V16.9564H18.0018V14.9564C18.0018 13.8518 17.1063 12.9564 16.0018 12.9564H7.78965L10.3623 15.529Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.00977 5.83789C3.00977 5.28561 3.45748 4.83789 4.00977 4.83789H20C20.5523 4.83789 21 5.28561 21 5.83789V17.1621C21 18.2667 20.1046 19.1621 19 19.1621H5C3.89543 19.1621 3 18.2667 3 17.1621V6.16211C3 6.11449 3.00333 6.06765 3.00977 6.0218V5.83789ZM5 8.06165V17.1621H19V8.06199L14.1215 12.9405C12.9499 14.1121 11.0504 14.1121 9.87885 12.9405L5 8.06165ZM6.57232 6.80554H17.428L12.7073 11.5263C12.3168 11.9168 11.6836 11.9168 11.2931 11.5263L6.57232 6.80554Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMathDivide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C13.1046 19 14 18.1046 14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMathEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11H19C19.5523 11 20 10.5523 20 10C20 9.44771 19.5523 9 19 9H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H19C19.5523 15 20 14.5523 20 14C20 13.4477 19.5523 13 19 13H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMathMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMathPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.2426 6.34319C16.6331 5.95266 17.2663 5.95266 17.6568 6.34319C18.0474 6.73371 18.0474 7.36688 17.6568 7.7574L7.75734 17.6569C7.36681 18.0474 6.73365 18.0474 6.34313 17.6569C5.9526 17.2664 5.9526 16.6332 6.34313 16.2427L16.2426 6.34319Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.87866 9.87872C9.09761 10.6598 7.83128 10.6598 7.05023 9.87872C6.26918 9.09767 6.26918 7.83134 7.05023 7.05029C7.83128 6.26924 9.09761 6.26924 9.87866 7.05029C10.6597 7.83134 10.6597 9.09767 9.87866 9.87872Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1213 16.9498C14.9023 17.7308 16.1687 17.7308 16.9497 16.9498C17.7308 16.1687 17.7308 14.9024 16.9497 14.1214C16.1687 13.3403 14.9023 13.3403 14.1213 14.1214C13.3403 14.9024 13.3403 16.1687 14.1213 16.9498Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMathPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5C13 4.44772 12.5523 4 12 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMaximizeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H9V5H6.46173L11.3047 9.84298L9.8905 11.2572L5 6.3667V9H3V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21H9V19H6.3764L11.3046 14.0718L9.89038 12.6576L5 17.548V15H3V21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21H21V15H19V17.5244L14.1332 12.6576L12.719 14.0718L17.6472 19H15V21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H15V5H17.5619L12.7189 9.84301L14.1331 11.2572L19 6.39032V9H21V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H9V5H5V9H3V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21H9V19H5V15H3V21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21H21V15H19V19H15V21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H15V5H19V9H21V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.3709 9.59273L8.77816 7L1 14.7782L3.59272 17.3709L11.3709 9.59273Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2218 7L23 14.7782L20.424 17.3542L15.2218 12.152L10.0197 17.3542L7.44367 14.7782L15.2218 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMediaLive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMediaPodcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.6361 20.364C4.00738 18.7353 3 16.4853 3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14C21 16.4853 19.9926 18.7353 18.364 20.3639L19.7782 21.7782C21.7688 19.7875 23 17.0376 23 14C23 7.92487 18.0751 3 12 3C5.92487 3 1 7.92487 1 14C1 17.0376 2.23124 19.7876 4.22189 21.7782L5.6361 20.364Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9498 18.9497C18.2165 17.683 19 15.933 19 14C19 10.134 15.866 7 12 7C8.13401 7 5 10.134 5 14C5 15.933 5.78353 17.6831 7.05031 18.9498L8.46453 17.5356C7.55967 16.6308 7 15.3807 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14C17 15.3807 16.4404 16.6307 15.5356 17.5355L16.9498 18.9497Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1213 16.1213C14.6642 15.5784 15 14.8284 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 14.8285 9.33581 15.5785 9.87874 16.1214L11.293 14.7072C11.112 14.5262 11 14.2762 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14C13 14.2761 12.8881 14.5261 12.7071 14.7071L14.1213 16.1213Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuBoxed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.01562 6.98193C7.46334 6.98193 7.01562 7.43285 7.01562 7.98513C7.01562 8.53742 7.46334 8.98833 8.01563 8.98833H15.9659C16.5182 8.98833 16.9659 8.53742 16.9659 7.98513C16.9659 7.43285 16.5182 6.98193 15.9659 6.98193H8.01562Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.01562 12C7.01562 11.4477 7.46334 10.9968 8.01562 10.9968H15.9659C16.5182 10.9968 16.9659 11.4477 16.9659 12C16.9659 12.5523 16.5182 13.0032 15.9659 13.0032H8.01563C7.46334 13.0032 7.01562 12.5523 7.01562 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.0249 15.0122C7.47262 15.0122 7.0249 15.4631 7.0249 16.0154C7.0249 16.5677 7.47262 17.0186 8.0249 17.0186H15.9752C16.5275 17.0186 16.9752 16.5677 16.9752 16.0154C16.9752 15.4631 16.5275 15.0122 15.9752 15.0122H8.0249Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H19C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15C4 14.4477 4.44772 14 5 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H5C4.44772 16 4 15.5523 4 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuCheese(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18C3 17.4477 3.44772 17 4 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H10.2625L7.61456 15.6479L4.96662 13H4C3.44772 13 3 12.5523 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuGridO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6C8 7.10457 7.10457 8 6 8C4.89543 8 4 7.10457 4 6C4 4.89543 4.89543 4 6 4C7.10457 4 8 4.89543 8 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20C7.10457 20 8 19.1046 8 18C8 16.8954 7.10457 16 6 16C4.89543 16 4 16.8954 4 18C4 19.1046 4.89543 20 6 20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8C19.1046 8 20 7.10457 20 6C20 4.89543 19.1046 4 18 4C16.8954 4 16 4.89543 16 6C16 7.10457 16.8954 8 18 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuGridR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4H8V8H4V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10H8V14H4V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H4V20H8V16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4H14V8H10V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H10V14H14V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16H14V20H10V16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H16V8H20V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10H20V14H16V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16H16V20H20V16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuHotdog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6C5.34315 6 4 7.34315 4 9H20C20 7.34315 18.6569 6 17 6H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18C5.34315 18 4 16.6569 4 15H20C20 16.6569 18.6569 18 17 18H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuLeftAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5.99519C2 5.44556 2.44556 5 2.99519 5H11.0048C11.5544 5 12 5.44556 12 5.99519C12 6.54482 11.5544 6.99039 11.0048 6.99039H2.99519C2.44556 6.99039 2 6.54482 2 5.99519Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11.9998C2 11.4501 2.44556 11.0046 2.99519 11.0046H21.0048C21.5544 11.0046 22 11.4501 22 11.9998C22 12.5494 21.5544 12.9949 21.0048 12.9949H2.99519C2.44556 12.9949 2 12.5494 2 11.9998Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.99519 17.0096C2.44556 17.0096 2 17.4552 2 18.0048C2 18.5544 2.44556 19 2.99519 19H15.0048C15.5544 19 16 18.5544 16 18.0048C16 17.4552 15.5544 17.0096 15.0048 17.0096H2.99519Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuMotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18C3 17.4477 3.44772 17 4 17H12C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19H4C3.44772 19 3 18.5523 3 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuOreos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3C5.34315 3 4 4.34315 4 6H20C20 4.34315 18.6569 3 17 3H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11C5.34315 11 4 9.65685 4 8H20C20 9.65685 18.6569 11 17 11H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13C5.34315 13 4 14.3431 4 16H20C20 14.3431 18.6569 13 17 13H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21C5.34315 21 4 19.6569 4 18H20C20 19.6569 18.6569 21 17 21H7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuRightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H5C4.44772 7 4 6.55228 4 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18.0048C22 18.5544 21.5544 19 21.0048 19H12.9952C12.4456 19 12 18.5544 12 18.0048C12 17.4552 12.4456 17.0096 12.9952 17.0096H21.0048C21.5544 17.0096 22 17.4552 22 18.0048Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12.0002C22 12.5499 21.5544 12.9954 21.0048 12.9954H2.99519C2.44556 12.9954 2 12.5499 2 12.0002C2 11.4506 2.44556 11.0051 2.99519 11.0051H21.0048C21.5544 11.0051 22 11.4506 22 12.0002Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0048 6.99039C21.5544 6.99039 22 6.54482 22 5.99519C22 5.44556 21.5544 5 21.0048 5H8.99519C8.44556 5 8 5.44556 8 5.99519C8 6.54482 8.44556 6.99039 8.99519 6.99039H21.0048Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenuRound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6.9834C7.44772 6.9834 7 7.43111 7 7.9834C7 8.53568 7.44772 8.9834 8 8.9834H16C16.5523 8.9834 17 8.53568 17 7.9834C17 7.43111 16.5523 6.9834 16 6.9834H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.017C7.44772 15.017 7 15.4647 7 16.017C7 16.5693 7.44772 17.017 8 17.017H16C16.5523 17.017 17 16.5693 17 16.017C17 15.4647 16.5523 15.017 16 15.017H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.0322C2 11.4799 2.44772 11.0322 3 11.0322H21C21.5523 11.0322 22 11.4799 22 12.0322C22 12.5845 21.5523 13.0322 21 13.0322H3C2.44772 13.0322 2 12.5845 2 12.0322Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.0645C2.44772 17.0645 2 17.5122 2 18.0645C2 18.6167 2.44772 19.0645 3 19.0645H21C21.5523 19.0645 22 18.6167 22 18.0645C22 17.5122 21.5523 17.0645 21 17.0645H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMergeHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.9757L16.2426 4.73306L14.8284 3.31885L12 6.14727L9.17157 3.31885L7.75736 4.73306L12 8.9757Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11.9998C5 11.4475 5.44772 10.9997 6 10.9997H18C18.5523 10.9997 19 11.4475 19 11.9998C19 12.552 18.5523 12.9998 18 12.9998H6C5.44772 12.9998 5 12.552 5 11.9998Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15.0242L7.75736 19.2668L9.17157 20.681L12 17.8526L14.8284 20.681L16.2426 19.2668L12 15.0242Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMergeVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.97576 12L4.73312 7.75736L3.31891 9.17157L6.14734 12L3.31891 14.8284L4.73312 16.2426L8.97576 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9998 19C11.4475 19 10.9998 18.5523 10.9998 18V6C10.9998 5.44772 11.4475 5 11.9998 5C12.5521 5 12.9998 5.44772 12.9998 6V18C12.9998 18.5523 12.5521 19 11.9998 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.0242 12L19.2669 16.2426L20.6811 14.8284L17.8527 12L20.6811 9.17157L19.2669 7.75736L15.0242 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4V12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12V4ZM13 4V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12C18 14.973 15.8377 17.441 13 17.917V21H17V23H7V21H11V17.917C8.16229 17.441 6 14.973 6 12V9H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V9H18V12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMicrobit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 5C3.13401 5 0 8.13401 0 12C0 15.866 3.13401 19 7 19H17C20.866 19 24 15.866 24 12C24 8.13401 20.866 5 17 5H7ZM17 8H7C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16H17C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3H11V11H3V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13H11V21H3V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H21V11H13V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13H21V21H13V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMiniPlayer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V12.2676C18.7058 12.0974 18.3643 12 18 12H14C12.8954 12 12 12.8954 12 14V18C12 18.3643 12.0974 18.7058 12.2676 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMinimizeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.0735 2L21.4877 3.41421L15.6378 9.26416H18.1824V11.2642H12.1824V5.26416H14.1824V7.89111L20.0735 2Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1824 12.2642V18.2642H9.1824V15.8422L3.41421 21.6104L2 20.1962L7.93203 14.2642H5.1824V12.2642H11.1824Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9H3V7H7V3H9V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15H3V17H7V21H9V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15H15V21H17V17H21V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.00012H21V7.00012H17V3.00012H15V9.00012Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgModem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.6341C18 17.1864 17.5523 17.6341 17 17.6341C16.4477 17.6341 16 17.1864 16 16.6341C16 16.0819 16.4477 15.6341 17 15.6341C17.5523 15.6341 18 16.0819 18 16.6341Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.86603 3.13414C5.38773 2.858 4.77614 3.02187 4.5 3.50017C4.22386 3.97846 4.38773 4.59005 4.86603 4.86619L18.3205 12.6341H2V16.6341C2 18.8433 3.79086 20.6341 6 20.6341H18C20.2091 20.6341 22 18.8433 22 16.6341V12.6341L5.86603 3.13414ZM20 14.6341H4V16.6341C4 17.7387 4.89543 18.6341 6 18.6341H18C19.1046 18.6341 20 17.7387 20 16.6341V14.6341Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMonday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.77857 6.13915C7.7289 4.78193 9.59953 4.45209 10.9568 5.40242C12.314 6.35275 12.6438 8.22339 11.6935 9.58061L5.95771 17.7721C5.00738 19.1293 3.13674 19.4592 1.77953 18.5089C0.422312 17.5585 0.0924684 15.6879 1.0428 14.3307L6.77857 6.13915Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2678 6.22811C16.2182 4.8709 18.0888 4.54105 19.446 5.49138C20.8032 6.44172 21.1331 8.31235 20.1827 9.66957L14.447 17.8611C13.4966 19.2183 11.626 19.5481 10.2688 18.5978C8.91158 17.6475 8.58173 15.7768 9.53207 14.4196L15.2678 6.22811Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 18.8596C22.1569 18.8596 23.5 17.5165 23.5 15.8596C23.5 14.2028 22.1569 12.8596 20.5 12.8596C18.8431 12.8596 17.5 14.2028 17.5 15.8596C17.5 17.5165 18.8431 18.8596 20.5 18.8596Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.2256 2.00253C9.59172 1.94346 6.93894 2.9189 4.92893 4.92891C1.02369 8.83415 1.02369 15.1658 4.92893 19.071C8.83418 22.9763 15.1658 22.9763 19.0711 19.071C21.0811 17.061 22.0565 14.4082 21.9975 11.7743C21.9796 10.9772 21.8669 10.1818 21.6595 9.40643C21.0933 9.9488 20.5078 10.4276 19.9163 10.8425C18.5649 11.7906 17.1826 12.4053 15.9301 12.6837C14.0241 13.1072 12.7156 12.7156 12 12C11.2844 11.2844 10.8928 9.97588 11.3163 8.0699C11.5947 6.81738 12.2094 5.43511 13.1575 4.08368C13.5724 3.49221 14.0512 2.90664 14.5935 2.34046C13.8182 2.13305 13.0228 2.02041 12.2256 2.00253ZM17.6569 17.6568C18.9081 16.4056 19.6582 14.8431 19.9072 13.2186C16.3611 15.2643 12.638 15.4664 10.5858 13.4142C8.53361 11.362 8.73568 7.63895 10.7814 4.09281C9.1569 4.34184 7.59434 5.09193 6.34315 6.34313C3.21895 9.46732 3.21895 14.5326 6.34315 17.6568C9.46734 20.781 14.5327 20.781 17.6569 17.6568Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 5C0 3.34315 1.34315 2 3 2H21C22.6569 2 24 3.34315 24 5V19C24 20.6569 22.6569 22 21 22H3C1.34315 22 0 20.6569 0 19V5ZM3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44771 4 3 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreVerticalAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreVerticalO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C13.1046 19 14 18.1046 14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreVerticalR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C13.1046 19 14 18.1046 14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 3C2 1.34315 3.34315 0 5 0H19C20.6569 0 22 1.34315 22 3V21C22 22.6569 20.6569 24 19 24H5C3.34315 24 2 22.6569 2 21V3ZM5 2H19C19.5523 2 20 2.44771 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoreVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21ZM15 4C15 5.65685 13.6569 7 12 7C10.3431 7 9 5.65685 9 4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM12 23C13.6569 23 15 21.6569 15 20C15 18.3431 13.6569 17 12 17C10.3431 17 9 18.3431 9 20C9 21.6569 10.3431 23 12 23Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 15C6.65685 15 8 13.6569 8 12C8 10.3431 6.65685 9 5 9C3.34315 9 2 10.3431 2 12C2 13.6569 3.34315 15 5 15ZM5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 13.6569 20.6569 15 19 15C17.3431 15 16 13.6569 16 12C16 10.3431 17.3431 9 19 9C20.6569 9 22 10.3431 22 12ZM20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C11.4477 5 11 5.44772 11 6V10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10V6C13 5.44772 12.5523 5 12 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8V16C20 20.4183 16.4183 24 12 24C7.58172 24 4 20.4183 4 16V8ZM18 8V16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoveDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5H9V13H7V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H17V13H15V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0001 5H13.0001V14.9999H16.0355L12.0356 19.071L8.03564 14.9999H11.0001V5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoveLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 17V15H11.071V17H19.071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 9V7H11.071V9H19.071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 12.9999V10.9999H9.07109V7.96454L5 11.9644L9.07109 15.9644V12.9999H19.071Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoveRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17V15H13V17H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9V7H13V9H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.9999V10.9999H14.9999V7.96454L19.071 11.9644L14.9999 15.9644V12.9999H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoveTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.9641 7H10.9641V9H18.9641V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.82864V15.1714L9.9642 12L6 8.82864Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.9641 11H10.9641V13H18.9641V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9641 15H18.9641V17H10.9641V15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMoveUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19.071H15V11.071H17V19.071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19.071H7V11.071H9V19.071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9999 19.071H10.9999V9.07109H7.96454L11.9644 5L15.9644 9.07109H12.9999V19.071Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMusicNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 8.95439L17.6352 7.82736C19.0102 7.55235 20 6.34501 20 4.94274C20 3.08637 18.3017 1.69406 16.4813 2.05813L12.4117 2.87206C11.0094 3.15252 10 4.38376 10 5.8138V13.8895C9.41165 13.5492 8.72857 13.3544 8 13.3544C5.79086 13.3544 4 15.1453 4 17.3544C4 19.5635 5.79086 21.3544 8 21.3544C10.2091 21.3544 12 19.5635 12 17.3544V8.95439ZM16.8736 4.01929L12.8039 4.83322C12.3365 4.92671 12 5.33712 12 5.8138V6.91479L17.2429 5.8662C17.6831 5.77816 18 5.39165 18 4.94274C18 4.34846 17.4563 3.90274 16.8736 4.01929ZM10 17.3544C10 16.2498 9.10457 15.3544 8 15.3544C6.89543 15.3544 6 16.2498 6 17.3544C6 18.459 6.89543 19.3544 8 19.3544C9.10457 19.3544 10 18.459 10 17.3544Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMusicSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 18.939C14.2091 18.939 16 17.1482 16 14.939C16 12.7299 14.2091 10.939 12 10.939C9.79086 10.939 8 12.7299 8 14.939C8 17.1482 9.79086 18.939 12 18.939ZM12 16.939C13.1046 16.939 14 16.0436 14 14.939C14 13.8345 13.1046 12.939 12 12.939C10.8954 12.939 10 13.8345 10 14.939C10 16.0436 10.8954 16.939 12 16.939Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9.04401C13.1046 9.04401 14 8.14858 14 7.04401C14 5.93944 13.1046 5.04401 12 5.04401C10.8954 5.04401 10 5.93944 10 7.04401C10 8.14858 10.8954 9.04401 12 9.04401Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 1C5.34315 1 4 2.34315 4 4V20C4 21.6569 5.34315 23 7 23H17C18.6569 23 20 21.6569 20 20V4C20 2.34315 18.6569 1 17 1H7ZM17 3H7C6.44772 3 6 3.44772 6 4V20C6 20.5523 6.44772 21 7 21H17C17.5523 21 18 20.5523 18 20V4C18 3.44772 17.5523 3 17 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 6.00086C22 3.54932 19.8148 1.6746 17.3918 2.04737L10.3918 3.1243C8.44044 3.4245 7 5.1035 7 7.07778V15.8407C6.54537 15.6248 6.0368 15.5039 5.5 15.5039C3.567 15.5039 2 17.0709 2 19.0039C2 20.9369 3.567 22.5039 5.5 22.5039C7.43296 22.5039 8.99994 20.937 9 19.004V7.07778C9 6.09064 9.72022 5.25114 10.6959 5.10104L17.6959 4.02412C18.9074 3.83773 20 4.77509 20 6.00086V12.8407C19.5454 12.6248 19.0368 12.5039 18.5 12.5039C16.567 12.5039 15 14.0709 15 16.0039C15 17.9369 16.567 19.5039 18.5 19.5039C20.433 19.5039 21.9999 17.937 22 16.004V6.00086ZM20 16.0039C20 15.1755 19.3284 14.5039 18.5 14.5039C17.6716 14.5039 17 15.1755 17 16.0039C17 16.8323 17.6716 17.5039 18.5 17.5039C19.3284 17.5039 19.9999 16.8323 20 16.0039ZM7 19.0039C7 18.1755 6.32843 17.5039 5.5 17.5039C4.67157 17.5039 4 18.1755 4 19.0039C4 19.8323 4.67157 20.5039 5.5 20.5039C6.32839 20.5039 6.99994 19.8323 7 19.0039Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgNametag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14V20H10V18H6V14H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 9V15H15V9H9ZM13 11H11V13H13V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10V4H10V6H6V10H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V4H14V6H18V10H20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14V20H14V18H18V14H20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6C6 5.44772 6.44772 5 7 5H17C17.5523 5 18 5.44772 18 6C18 6.55228 17.5523 7 17 7H7C6.44771 7 6 6.55228 6 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10C6 9.44771 6.44772 9 7 9H17C17.5523 9 18 9.44771 18 10C18 10.5523 17.5523 11 17 11H7C6.44771 11 6 10.5523 6 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44771 15 7 15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18C6 17.4477 6.44772 17 7 17H11C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H7C6.44772 19 6 18.5523 6 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4C2 2.34315 3.34315 1 5 1H19C20.6569 1 22 2.34315 22 4V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V4ZM5 3H19C19.5523 3 20 3.44771 20 4V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4C4 3.44772 4.44771 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7C20 8.65685 18.6569 10 17 10C15.3431 10 14 8.65685 14 7C14 5.34315 15.3431 4 17 4C18.6569 4 20 5.34315 20 7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6H4V20H18V12H16V18H6V8H12V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 21C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5ZM6 18V6H18V18H15V9H12V18H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgOculus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16 10H8C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14H16C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10ZM8 6C4.68629 6 2 8.68629 2 12C2 15.3137 4.68629 18 8 18H16C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgOpenCollective(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6818 15.7529L18.8116 17.8827C20.1752 16.3052 21 14.249 21 12.0001C21 9.78747 20.2016 7.76133 18.8771 6.19409L16.7444 8.32671C17.5315 9.34177 18 10.6162 18 12.0001C18 13.4203 17.5066 14.7253 16.6818 15.7529Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6734 16.7445C14.6583 17.5315 13.3839 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C13.4202 6 14.7252 6.49344 15.7528 7.31823L17.8826 5.18843C16.3051 3.82482 14.2489 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C14.2126 21 16.2387 20.2016 17.806 18.8771L15.6734 16.7445Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgOptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 3C8.86384 3 10.4299 4.27477 10.874 6H19V8H10.874C10.4299 9.72523 8.86384 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3ZM7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 20C15.1362 20 13.5701 18.7252 13.126 17H5V15H13.126C13.5701 13.2748 15.1362 12 17 12C19.2091 12 21 13.7909 21 16C21 18.2091 19.2091 20 17 20ZM17 18C18.1046 18 19 17.1046 19 16C19 14.8954 18.1046 14 17 14C15.8954 14 15 14.8954 15 16C15 17.1046 15.8954 18 17 18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgOrganisation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15H19V17H17V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11H17V13H19V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 7H23V21H1V3H13V7ZM8 5H11V7H8V5ZM11 19V17H8V19H11ZM11 15V13H8V15H11ZM11 11V9H8V11H11ZM21 19V9H13V11H15V13H13V15H15V17H13V19H21ZM3 19V17H6V19H3ZM3 15H6V13H3V15ZM6 11V9H3V11H6ZM3 7H6V5H3V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": "0.2",
                    "d": "M22 11C22 13.6522 20.9464 16.1957 19.0711 18.0711C17.1957 19.9464 14.6522 21 12 21C9.34784 21 6.8043 19.9464 4.92893 18.0711C3.05357 16.1957 2 13.6522 2 11L22 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": "0.3",
                    "d": "M20 11C20 13.1217 19.1571 15.1566 17.6569 16.6569C16.1566 18.1571 14.1217 19 12 19C9.87827 19 7.84344 18.1571 6.34315 16.6569C4.84286 15.1566 4 13.1217 4 11L20 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11C20 8.87827 19.1571 6.84344 17.6569 5.34315C16.1566 3.84285 14.1217 3 12 3C9.87827 3 7.84344 3.84285 6.34315 5.34315C4.84286 6.84344 4 8.87827 4 11L20 11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPacman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0636 8C14.6159 8 15.0636 7.55228 15.0636 7C15.0636 6.44772 14.6159 6 14.0636 6C13.5113 6 13.0636 6.44772 13.0636 7C13.0636 7.55228 13.5113 8 14.0636 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 3C15.1523 3 17.1281 3.7555 18.6768 5.01576L20.124 6.46299L18.8288 7.75818L18.828 7.75738L14.5854 12L18.2236 15.6383L18.2224 15.6396L20.1273 17.5445L18.7144 18.9575L18.7122 18.9553C17.1583 20.2329 15.1687 21 13 21C8.02944 21 4 16.9706 4 12C4 7.02944 8.02944 3 13 3ZM11.7569 12L17.2893 17.5323C16.1044 18.4523 14.6162 19 13 19C9.13401 19 6 15.866 6 12C6 8.13401 9.13401 5 13 5C14.6162 5 16.1045 5.54772 17.2893 6.46768L11.7569 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPassword(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44771 11 8 11.4477 8 12C8 12.5523 8.44771 13 9 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12C14 12.5523 13.5523 13 13 13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11C13.5523 11 14 11.4477 14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H16V13H20V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 6C0.895431 6 0 6.89543 0 8V16C0 17.1046 0.89543 18 2 18H22C23.1046 18 24 17.1046 24 16V8C24 6.89543 23.1046 6 22 6H2ZM22 8H2L2 16H22V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 14H4V4H14V9H19V19H9V14ZM6 6H12V12H6V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "opacity": "0.5",
                    "x": "6",
                    "y": "6",
                    "width": "8",
                    "height": "8",
                    "stroke": "currentColor",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 9H19V19H9V9ZM15 11H17V17H11V15H15V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathDivide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5H15V9H9V15H5V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15V19H19V9H15V15H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10H14V14H10V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathExclude(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5H15V9H9V15H5V5ZM9 15V19H19V9H15V15H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5H15V9H19V19H9V15H5V5ZM11 11V17H17V11H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathIntersect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 5H5V15H9V19H19V9H15V5ZM13 7H7V13H9V9H13V7ZM17 17H11V15H15V11H17V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5H15V9H19V19H9V15H5V5ZM7 7H13V9H9V13H7V7ZM11 17H17V11H15V15H11V17ZM13 11H11V13H13V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathTrim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5H15V8H8V15H5V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9H9V19H19V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPathUnite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H5V15H9V19H19V9H15V5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPatreon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": "0.5",
                    "d": "M21 10C21 13.3137 18.3137 16 15 16C11.6863 16 9 13.3137 9 10C9 6.68629 11.6863 4 15 4C18.3137 4 21 6.68629 21 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4H7V20H3V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.47005 3.54443H14.4701C16.1089 3.54443 17.4146 4.31866 18.0963 5.51496C19.3165 6.38743 19.9427 7.91487 19.6082 9.65332C19.0865 12.365 16.425 14.5633 13.6636 14.5633H11.6636L10.5301 20.4553H6.39824L6.62891 19.2563H3.44727L6.47005 3.54443ZM8.0922 5.50842H14.0922C15.7491 5.50842 16.8385 6.82737 16.5254 8.45439C16.2124 10.0814 14.6155 11.4004 12.9587 11.4004H8.95866L7.82511 17.2923H5.82511L8.0922 5.50842Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M21.2635 2.29289C20.873 1.90237 20.2398 1.90237 19.8493 2.29289L18.9769 3.16525C17.8618 2.63254 16.4857 2.82801 15.5621 3.75165L4.95549 14.3582L10.6123 20.0151L21.2189 9.4085C22.1426 8.48486 22.338 7.1088 21.8053 5.99367L22.6777 5.12132C23.0682 4.7308 23.0682 4.09763 22.6777 3.70711L21.2635 2.29289ZM16.9955 10.8035L10.6123 17.1867L7.78392 14.3582L14.1671 7.9751L16.9955 10.8035ZM18.8138 8.98525L19.8047 7.99429C20.1953 7.60376 20.1953 6.9706 19.8047 6.58007L18.3905 5.16586C18 4.77534 17.3668 4.77534 16.9763 5.16586L15.9853 6.15683L18.8138 8.98525Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22.9502L4.12171 15.1717L9.77817 20.8289L2 22.9502Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonBottomLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.3301 9.23205L10 5L5 13.6603L8.33013 17.8923L13.6603 18.6603L18.6603 10L13.3301 9.23205ZM15.4512 11.5583L12.2531 11.0975L10.255 8.5583L7.40908 13.4876L9.40716 16.0268L12.6052 16.4876L15.4512 11.5583Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonBottomRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.3301 8.23205L13.6603 4L18.6603 12.6603L15.3301 16.8923L10 17.6603L5 9L10.3301 8.23205ZM8.20908 10.5583L11.4072 10.0975L13.4052 7.5583L16.2512 12.4876L14.2531 15.0268L11.055 15.4876L8.20908 10.5583Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 8L7 6V16L12 18.5L17 16V6L12 8ZM15 8.95407L12 10.1541L9 8.95407V14.7639L12 16.2639L15 14.7639V8.95407Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16 12L18 7H8L6 12L8 17H18L16 12ZM15.0459 15L13.8459 12L15.0459 9H9.35407L8.15407 12L9.35407 15H15.0459Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 12L6 7H16L18 12L16 17H6L8 12ZM8.95407 15L10.1541 12L8.95407 9H14.6459L15.8459 12L14.6459 15H8.95407Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonTopLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.3301 15.1601L11 19.3922L6 10.7319L9.33013 6.49988L14.6603 5.73193L19.6603 14.3922L14.3301 15.1601ZM16.4512 12.8339L13.2531 13.2947L11.255 15.8339L8.40908 10.9046L10.4072 8.36536L13.6052 7.90459L16.4512 12.8339Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonTopRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.3301 15.1601L5 14.3922L10 5.73193L15.3301 6.49988L18.6603 10.7319L13.6603 19.3922L10.3301 15.1601ZM13.4052 15.8339L11.4072 13.2947L8.20908 12.8339L11.055 7.90459L14.2531 8.36536L16.2512 10.9046L13.4052 15.8339Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPentagonUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 16L17 18V8L12 6L7 8V18L12 16ZM9 15.0459L12 13.8459L15 15.0459V9.35407L12 8.15407L9 9.35407V15.0459Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPerformance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 9V13.1707C9.83481 13.5825 9 14.6938 9 16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16C15 14.6938 14.1652 13.5825 13 13.1707V9H11ZM11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C15.866 5 19 8.13401 19 12V13H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V13H5V12C5 8.13401 8.13401 5 12 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPexels(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 5C12.7111 5 13.3875 5.14845 14 5.41604C15.7659 6.1876 17 7.94968 17 10C17 12.0503 15.7659 13.8124 14 14.584C13.3875 14.8516 12.7111 15 12 15V19H6V5H12ZM8 7V17H10V13H12L12.0032 12.9988C13.6427 13.0303 15.0746 11.6934 15.0443 9.95469L15.0375 9.56529C15.0121 8.10183 13.7882 6.94549 12.3257 7.00299L12.0203 7.00762L12 7H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12C22 10.6868 21.7413 9.38647 21.2388 8.1731C20.7362 6.95996 19.9997 5.85742 19.0711 4.92896C18.1425 4.00024 17.0401 3.26367 15.8268 2.76123C14.6136 2.25854 13.3132 2 12 2V4C13.0506 4 14.0909 4.20703 15.0615 4.60889C16.0321 5.01099 16.914 5.60034 17.6569 6.34326C18.3997 7.08594 18.989 7.96802 19.391 8.93848C19.7931 9.90918 20 10.9495 20 12H22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10V5C2 4.44775 2.44772 4 3 4H8C8.55228 4 9 4.44775 9 5V9C9 9.55225 8.55228 10 8 10H6C6 14.4182 9.58173 18 14 18V16C14 15.4478 14.4477 15 15 15H19C19.5523 15 20 15.4478 20 16V21C20 21.5522 19.5523 22 19 22H14C7.37259 22 2 16.6274 2 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5433 9.70386C17.8448 10.4319 18 11.2122 18 12H16.2C16.2 11.4485 16.0914 10.9023 15.8803 10.3928C15.6692 9.88306 15.3599 9.42017 14.9698 9.03027C14.5798 8.64014 14.1169 8.33081 13.6073 8.11963C13.0977 7.90869 12.5515 7.80005 12 7.80005V6C12.7879 6 13.5681 6.15527 14.2961 6.45679C15.024 6.7583 15.6855 7.2002 16.2426 7.75732C16.7998 8.31445 17.2418 8.97583 17.5433 9.70386Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPhotoscan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8C9.55228 8 10 7.55228 10 7C10 6.44772 9.55228 6 9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 3C18.1046 3 19 3.89543 19 5V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H17ZM12.4649 5H17V16H7L7 10.4649C7.58835 10.8052 8.27143 11 9 11C11.2091 11 13 9.20914 13 7C13 6.27143 12.8052 5.58835 12.4649 5ZM9 5C7.89543 5 7 5.89543 7 7C7 8.10457 7.89543 9 9 9C10.1046 9 11 8.10457 11 7C11 5.89543 10.1046 5 9 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPiano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 21C23.1046 21 24 20.1046 24 19V5C24 3.89543 23.1046 3 22 3H3C1.89543 3 1 3.89543 1 5V19C1 20.1046 1.89543 21 3 21H22ZM11 5H8.98486V13H7.98511V19H12V13H11V5ZM18.0151 19H22V5H19.0151V13H18.0151V19ZM17.0151 13H16.0151V5H14V13H13V19H17.0151V13ZM6.98511 19V13H5.98486V5H3L3 19H6.98511Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.6569 2.75736C15 0.414213 18.799 0.414214 21.1421 2.75736C23.4853 5.1005 23.4853 8.8995 21.1421 11.2426L11.2426 21.1421C8.89949 23.4853 5.1005 23.4853 2.75736 21.1421C0.414214 18.799 0.414213 15 2.75736 12.6569L12.6569 2.75736ZM19.7279 9.82843L15.4853 14.0711L9.82843 8.41421L14.0711 4.17157C15.6332 2.60948 18.1658 2.60948 19.7279 4.17157C21.29 5.73367 21.29 8.26633 19.7279 9.82843Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPinAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 9C18 11.973 15.8377 14.441 13 14.917V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V14.917C8.16229 14.441 6 11.973 6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9ZM12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPinBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 9C18 11.973 15.8377 14.441 13 14.917V20H16C16.5523 20 17 20.4477 17 21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20H11V14.917C8.16229 14.441 6 11.973 6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9ZM12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPinTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14C13.1046 14 14 14.8954 14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4C17 4.55228 16.5523 5 16 5H13V10.083C15.8377 10.559 18 13.027 18 16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16C6 13.027 8.16229 10.559 11 10.083V5H8ZM12 12C14.2091 12 16 13.7909 16 16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16C8 13.7909 9.79086 12 12 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16.2721 10.2721C16.2721 12.4813 14.4813 14.2721 12.2721 14.2721C10.063 14.2721 8.27214 12.4813 8.27214 10.2721C8.27214 8.06298 10.063 6.27212 12.2721 6.27212C14.4813 6.27212 16.2721 8.06298 16.2721 10.2721ZM14.2721 10.2721C14.2721 11.3767 13.3767 12.2721 12.2721 12.2721C11.1676 12.2721 10.2721 11.3767 10.2721 10.2721C10.2721 9.16755 11.1676 8.27212 12.2721 8.27212C13.3767 8.27212 14.2721 9.16755 14.2721 10.2721Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.79417 16.5183C2.19424 13.0909 2.05438 7.39409 5.48178 3.79417C8.90918 0.194243 14.6059 0.054383 18.2059 3.48178C21.8058 6.90918 21.9457 12.6059 18.5183 16.2059L12.3124 22.7241L5.79417 16.5183ZM17.0698 14.8268L12.243 19.8965L7.17324 15.0698C4.3733 12.404 4.26452 7.97318 6.93028 5.17324C9.59603 2.3733 14.0268 2.26452 16.8268 4.93028C19.6267 7.59603 19.7355 12.0268 17.0698 14.8268Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayBackwards(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7H5V17H2V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12L13.0023 7.00003V17L6 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0023 7.00003L14 12L21.0023 17V7.00003Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayButtonO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12L10 16.3301V7.66987L16 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayButtonR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3ZM5 1C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12L10 16.3301V7.66987L16 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12.3301L9 16.6603L9 8L15 12.3301Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayForwards(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.0023 17H18.0023V7H21.0023V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0023 12L10 17V7L17.0023 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17L9.00232 12L2 7V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayListAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5H14V7H2V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9H14V11H2V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13H2V15H10V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9H18V13H22V15H18V19H16V15H12V13H16V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayListCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6H3V8H15V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10H3V12H15V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14H11V16H3V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9905 15.025L13.4049 13.6106L15.526 15.7321L19.7687 11.4895L21.1829 12.9037L15.526 18.5606L11.9905 15.025Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayListRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9644 4.63379H3.96442V6.63379H15.9644V4.63379Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9644 8.63379H3.96442V10.6338H15.9644V8.63379Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.96442 12.6338H11.9644V14.6338H3.96442V12.6338Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9645 13.7093L14.3787 12.295L16.5 14.4163L18.6213 12.2951L20.0355 13.7093L17.9142 15.8305L20.0356 17.9519L18.6214 19.3661L16.5 17.2447L14.3786 19.3661L12.9644 17.9519L15.0858 15.8305L12.9645 13.7093Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayListSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.8787 4.87866H3.87872V6.87866H15.8787V4.87866Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.8787 8.87866H3.87872V10.8787H15.8787V8.87866Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.87872 12.8787H11.8787V14.8787H3.87872V12.8787Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.7574 12.7573C12.5858 13.9289 12.5858 15.8284 13.7574 17C14.681 17.9236 16.0571 18.1191 17.1722 17.5864L18.7071 19.1213L20.1213 17.7071L18.5864 16.1722C19.1191 15.057 18.9236 13.681 18 12.7573C16.8284 11.5858 14.9289 11.5858 13.7574 12.7573ZM15.1716 15.5858C15.5621 15.9763 16.1953 15.9763 16.5858 15.5858C16.9763 15.1952 16.9763 14.5621 16.5858 14.1716C16.1953 13.781 15.5621 13.781 15.1716 14.1716C14.7811 14.5621 14.7811 15.1952 15.1716 15.5858Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5H4V7H16V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9H4V11H16V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13H12V15H4V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16L14 13V19L20 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayPauseO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9H11V15H9V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H13V9H15V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayPauseR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9H11V15H9V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H13V9H15V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H8V17H11V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17H16V7H13V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayStopO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9V15H15V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayStopR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9V15H15V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7H17V17H7V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayTrackNextO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V9ZM13 12L7 15.4641V8.5359L13 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayTrackNextR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9C15 8.44772 15.4477 8 16 8C16.5523 8 17 8.44772 17 9V15C17 15.5523 16.5523 16 16 16C15.4477 16 15 15.5523 15 15V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12L8 15.4641V8.5359L14 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayTrackNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17L14 12L6 7V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7H15V12V17H18V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayTrackPrevO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 8C8.55228 8 9 8.44772 9 9V15C9 15.5523 8.55228 16 8 16C7.44771 16 7 15.5523 7 15V9C7 8.44772 7.44771 8 8 8ZM16 15.4641L10 12L16 8.5359V15.4641Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayTrackPrevR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 8C8.55228 8 9 8.44772 9 9V15C9 15.5523 8.55228 16 8 16C7.44771 16 7 15.5523 7 15V9C7 8.44772 7.44771 8 8 8ZM16 15.4641L10 12L16 8.5359V15.4641Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3ZM5 1C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlayTrackPrev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17L10 12L18 7V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H9V17H6V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 2C8.44771 2 8 2.44772 8 3V5C8 5.55228 8.44771 6 9 6C9.55229 6 10 5.55228 10 5V3C10 2.44772 9.55229 2 9 2ZM8 9H16V11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11V9ZM13 16.917C15.8377 16.441 18 13.973 18 11V7H6V11C6 13.973 8.16229 16.441 11 16.917V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V16.917ZM14 3C14 2.44772 14.4477 2 15 2C15.5523 2 16 2.44772 16 3V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4H21V11C21 15.9706 16.9706 20 12 20C7.02944 20 3 15.9706 3 11V4ZM1 2H23V11C23 17.0751 18.0751 22 12 22C5.92487 22 1 17.0751 1 11V2ZM11.2929 14.6935C11.6834 15.084 12.3166 15.084 12.7071 14.6935L16.9497 10.4508C17.3403 10.0603 17.3403 9.42714 16.9497 9.03661C16.5592 8.64609 15.9261 8.64609 15.5355 9.03661L12 12.5721L8.46447 9.03661C8.07394 8.64609 7.44078 8.64609 7.05025 9.03661C6.65973 9.42714 6.65973 10.0603 7.05025 10.4508L11.2929 14.6935Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPokemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM5.07089 13C5.55612 16.3923 8.47353 19 12 19C15.5265 19 18.4439 16.3923 18.9291 13H14.8293C14.4174 14.1652 13.3062 15 12 15C10.6938 15 9.58251 14.1652 9.17068 13H5.07089ZM18.9291 11C18.4439 7.60771 15.5265 5 12 5C8.47353 5 5.55612 7.60771 5.07089 11H9.17068C9.58251 9.83481 10.6938 9 12 9C13.3062 9 14.4174 9.83481 14.8293 11H18.9291ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPolaroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4ZM5 4H19V15H5V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 4H5C4.44771 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44771 19.5523 4 19 4ZM5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H13V17H11V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13H17V17H15V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10H9V17H7V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPresentation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM20 12H18C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12H4C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM4.25204 14H19.748C18.8599 17.4505 15.7277 20 12 20C8.27232 20 5.14012 17.4505 4.25204 14ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 4H16V6H8V4ZM18 6H22V18H18V22H6V18H2V6H6V2H18V6ZM20 16H18V14H6V16H4V8H20V16ZM8 16H16V20H8V16ZM8 10H6V12H8V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgProductHunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM9 16V8H13C14.6569 8 16 9.34315 16 11C16 12.6569 14.6569 14 13 14H11V16H9ZM14 11C14 11.5523 13.5523 12 13 12H11V10H13C13.5523 10 14 10.4477 14 11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9ZM14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 14.0902 3.71255 16.014 4.90798 17.5417C6.55245 15.3889 9.14627 14 12.0645 14C14.9448 14 17.5092 15.3531 19.1565 17.4583C20.313 15.9443 21 14.0524 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 21C9.84977 21 7.87565 20.2459 6.32767 18.9878C7.59352 17.1812 9.69106 16 12.0645 16C14.4084 16 16.4833 17.1521 17.7538 18.9209C16.1939 20.2191 14.1881 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPullClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2V16C2 17.1046 2.89543 18 4 18H20C21.1046 18 22 17.1046 22 16V6H20V16H4V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H18V14H6V12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8H6V10H18V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronDownO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V16H8V14H16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75732 8.70261L9.17153 7.2884L12 10.1168L14.8284 7.28842L16.2426 8.70264L11.9999 12.9453L7.75732 8.70261Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronDownR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 7.28839L7.75732 8.7026L11.9999 12.9453L16.2426 8.70263L14.8284 7.28842L12 10.1168L9.17154 7.28839Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.00001 14H16V16H8.00001V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7.41421L6.41421 6L12.0711 11.6569L17.7279 6L19.1421 7.41421L12.0711 14.4853L5 7.41421Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.3432H5V18.3432H19V16.3432Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronLeftO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16H8V8H10V16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.2974 7.75732L16.7116 9.17153L13.8832 12L16.7116 14.8284L15.2974 16.2426L11.0547 11.9999L15.2974 7.75732Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronLeftR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6743 9.1716L15.26 7.75739L11.0174 12L15.26 16.2426L16.6742 14.8284L13.8458 12L16.6743 9.1716Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.96265 8.00007V16.0001H7.96265V8.00007H9.96265Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.929 5L18.3432 6.41421L12.6863 12.0711L18.3432 17.7279L16.929 19.1421L9.85789 12.0711L16.929 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19V5H6V19H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronRightO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8H16V16H14V8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.70261 16.2427L7.2884 14.8285L10.1168 12L7.28842 9.17164L8.70264 7.75743L12.9453 12.0001L8.70261 16.2427Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronRightR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.64429 14.8284L9.0585 16.2426L13.3012 12L9.05853 7.75739L7.64432 9.1716L10.4727 12L7.64429 14.8284Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3559 16L14.3559 7.99996H16.3559V16H14.3559Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41421 5L6 6.41421L11.6569 12.0711L6 17.7279L7.41421 19.1421L14.4853 12.0711L7.41421 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3432 19V5H18.3432V19H16.3432Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronUpO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM8 10V8H16V10H8ZM16.2427 15.2974L14.8285 16.7116L12 13.8832L9.17164 16.7116L7.75743 15.2974L12.0001 11.0547L16.2427 15.2974Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronUpR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21ZM1 19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5C2.79086 1 1 2.79086 1 5V19ZM9.17154 16.7116L7.75732 15.2974L11.9999 11.0547L16.2426 15.2974L14.8284 16.7116L12 13.8832L9.17154 16.7116ZM8.00001 10H16V8H8.00001V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16.929L6.41421 18.3432L12.0711 12.6863L17.7279 18.3432L19.1421 16.929L12.0711 9.85789L5 16.929Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5V6H19V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0001 1H13.0001V15.4853L16.2428 12.2427L17.657 13.6569L12.0001 19.3137L6.34326 13.6569L7.75748 12.2427L11.0001 15.4853V1Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20.2877H6V22.2877H18V20.2877Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2877 11.0001V13.0001H7.80237L11.045 16.2428L9.63079 17.657L3.97394 12.0001L9.63079 6.34326L11.045 7.75748L7.80236 11.0001H22.2877Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18V6H1V18H3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 12.9999V10.9999H15.4853L12.2427 7.75724L13.6569 6.34303L19.3137 11.9999L13.6569 17.6567L12.2427 16.2425L15.4853 12.9999H1Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2877 6V18H22.2877V6H20.2877Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgPushUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.0001 22.2877H13.0001V7.80237L16.2428 11.045L17.657 9.63079L12.0001 3.97394L6.34326 9.63079L7.75748 11.045L11.0001 7.80236V22.2877ZM18 3H6V1H18V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgQr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 3H3V9H5V5H9V3ZM3 21V15H5V19H9V21H3ZM15 3V5H19V9H21V3H15ZM19 15H21V21H15V19H19V15ZM7 7H11V11H7V7ZM7 13H11V17H7V13ZM17 7H13V11H17V7ZM13 13H17V17H13V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgQuoteO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20 5H4V19H20V5ZM4 3C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.06723 9.19629H12.0672L9.93267 14.8038H6.93267L9.06723 9.19629Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.0672 9.19629H17.0672L14.9327 14.8038H11.9327L14.0672 9.19629Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.13456 9H12.1346L10 14.6075H7L9.13456 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1346 9H17.1346L15 14.6075H12L14.1346 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRadioCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRadioChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6V12H6V8L10 8V6H4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H14V16H18V12H20V18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 2C1.79086 2 0 3.79086 0 6V18C0 20.2091 1.79086 22 4 22H20C22.2091 22 24 20.2091 24 18V6C24 3.79086 22.2091 2 20 2H4ZM20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14ZM10.4649 10C9.77325 8.8044 8.48056 8 7 8C5.13616 8 3.57006 9.27477 3.12602 11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H3.12602C3.57006 14.7252 5.13616 16 7 16C9.20914 16 11 14.2091 11 12H13C13 14.2091 14.7909 16 17 16C18.8638 16 20.4299 14.7252 20.874 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H20.874C20.4299 9.27477 18.8638 8 17 8C15.5194 8 14.2267 8.8044 13.5351 10H10.4649ZM15 12C15 13.1046 15.8954 14 17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgReadme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 5.5H9C10.1046 5.5 11 6.39543 11 7.5V16.5C11 17.0523 10.5523 17.5 10 17.5H4C3.44772 17.5 3 17.0523 3 16.5V6.5C3 5.94772 3.44772 5.5 4 5.5ZM14 19.5C13.6494 19.5 13.3128 19.4398 13 19.3293V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V19.3293C10.6872 19.4398 10.3506 19.5 10 19.5H4C2.34315 19.5 1 18.1569 1 16.5V6.5C1 4.84315 2.34315 3.5 4 3.5H9C10.1947 3.5 11.2671 4.02376 12 4.85418C12.7329 4.02376 13.8053 3.5 15 3.5H20C21.6569 3.5 23 4.84315 23 6.5V16.5C23 18.1569 21.6569 19.5 20 19.5H14ZM13 7.5V16.5C13 17.0523 13.4477 17.5 14 17.5H20C20.5523 17.5 21 17.0523 21 16.5V6.5C21 5.94772 20.5523 5.5 20 5.5H15C13.8954 5.5 13 6.39543 13 7.5ZM5 7.5H9V9.5H5V7.5ZM15 7.5H19V9.5H15V7.5ZM19 10.5H15V12.5H19V10.5ZM5 10.5H9V12.5H5V10.5ZM19 13.5H15V15.5H19V13.5ZM5 13.5H9V15.5H5V13.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRecord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.1459 11.0499L12.9716 9.05752L15.3462 8.84977C14.4471 7.98322 13.2242 7.4503 11.8769 7.4503C9.11547 7.4503 6.87689 9.68888 6.87689 12.4503C6.87689 15.2117 9.11547 17.4503 11.8769 17.4503C13.6977 17.4503 15.2911 16.4771 16.1654 15.0224L18.1682 15.5231C17.0301 17.8487 14.6405 19.4503 11.8769 19.4503C8.0109 19.4503 4.87689 16.3163 4.87689 12.4503C4.87689 8.58431 8.0109 5.4503 11.8769 5.4503C13.8233 5.4503 15.5842 6.24474 16.853 7.52706L16.6078 4.72412L18.6002 4.5498L19.1231 10.527L13.1459 11.0499Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRemote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.0514 4.32178L18.4656 5.73599L14.223 9.97863L18.4656 14.2213L17.0514 15.6355L11.3946 9.97863L17.0514 4.32178Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.94864 19.6785L5.53442 18.2643L9.77706 14.0216L5.53442 9.77897L6.94864 8.36476L12.6055 14.0216L6.94864 19.6785Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRemoveR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRename(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10 4H8V6H5C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18H8V20H10V4ZM8 8V16H5C4.44772 16 4 15.5523 4 15V9C4 8.44772 4.44772 8 5 8H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16H12V18H19C20.6569 18 22 16.6569 22 15V9C22 7.34315 20.6569 6 19 6H12V8H19C19.5523 8 20 8.44771 20 9V15C20 15.5523 19.5523 16 19 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgReorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4C3 3.44772 3.44772 3 4 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H4C3.44772 5 3 4.55228 3 4Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 11.4477 3.44772 11 4 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16C3 15.4477 3.44772 15 4 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H4C3.44772 17 3 16.5523 3 16Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20C3 19.4477 3.44772 19 4 19H12C12.5523 19 13 19.4477 13 20C13 20.5523 12.5523 21 12 21H4C3.44772 21 3 20.5523 3 20Z",
                    "fill": "currentColor",
                    "fillOpacity": "0.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15.1707 9C15.5825 10.1652 16.6938 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.6938 5 15.5825 5.83481 15.1707 7H4C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9H15.1707ZM19 8C19 8.55228 18.5523 9 18 9C17.4477 9 17 8.55228 17 8C17 7.44772 17.4477 7 18 7C18.5523 7 19 7.44772 19 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.3701 7.99993L13.8701 10.598V8.99993H6.88989V12.9999H4.88989V6.99993H13.8701V5.40186L18.3701 7.99993Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1299 16.9999H19.1101V10.9999H17.1101V14.9999H10.1299V13.4019L5.62988 15.9999L10.1299 18.598V16.9999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.34326 3.68567C6.83159 3.19735 7.36734 2.78535 7.93569 2.44968C10.4352 0.97348 13.5651 0.97348 16.0645 2.44968C16.6329 2.78535 17.1686 3.19735 17.657 3.68567L12.0001 9.34253L6.34326 3.68567ZM12.0001 6.5141L9.4131 3.92709C11.0447 3.14768 12.9556 3.14768 14.5871 3.92709L12.0001 6.5141Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.6576C2 9.52653 3.43899 6.73156 5.69172 4.89796L7.11528 6.32152C5.22043 7.78449 4 10.0785 4 12.6576C4 17.0759 7.58172 20.6576 12 20.6576C16.4183 20.6576 20 17.0759 20 12.6576C20 10.0785 18.7796 7.78451 16.8847 6.32154L18.3083 4.89798C20.561 6.73158 22 9.52654 22 12.6576C22 18.1804 17.5228 22.6576 12 22.6576C6.47715 22.6576 2 18.1804 2 12.6576Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRowFirst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "opacity": "0.5"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H6Z",
                            "fill": "currentColor"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H6Z",
                            "fill": "currentColor"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8C5 7.44772 5.44772 7 6 7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRowLast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "opacity": "0.5"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H6Z",
                            "fill": "currentColor"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H6Z",
                            "fill": "currentColor"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16C5 16.5523 5.44772 17 6 17H18C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15H6C5.44772 15 5 15.4477 5 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C1.34315 6 0 7.34315 0 9V16C0 17.6569 1.34315 19 3 19H21C22.6569 19 24 17.6569 24 16V9C24 7.34315 22.6569 6 21 6H3ZM9 8H7V13C7 13.5523 6.55228 14 6 14C5.44772 14 5 13.5523 5 13V8H3C2.44772 8 2 8.44772 2 9V16C2 16.5523 2.44772 17 3 17H21C21.5523 17 22 16.5523 22 16V9C22 8.44772 21.5523 8 21 8H19V11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11V8H15V13C15 13.5523 14.5523 14 14 14C13.4477 14 13 13.5523 13 13V8H11V11C11 11.5523 10.5523 12 10 12C9.44771 12 9 11.5523 9 11V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSandClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6H11V7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 2V4H7V7C7 9.76142 9.23858 12 12 12C9.23858 12 7 14.2386 7 17V20H6V22H18V20H17V17C17 14.2386 14.7614 12 12 12C14.7614 12 17 9.76142 17 7V4H18V2H6ZM9 4H15V7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7V4ZM9 17V20H15V17C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3H13V21H11V3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8C5 7.44771 5.44772 7 6 7H9V5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H9V17H6C5.44772 17 5 16.5523 5 16V8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8C19 7.44771 18.5523 7 18 7H15V5H18C19.6569 5 21 6.34315 21 8V16C21 17.6569 19.6569 19 18 19H15V17H18C18.5523 17 19 16.5523 19 16V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScreenMirror(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8H19V14H16V16H21V6H3V16H8V14H5V8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.3301 19L12 13L7.66987 19H16.3301Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScreenShot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8V6H8V10H10V8H12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14H16V18H12V16H14V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3ZM6 20V4H18V20H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScreenWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 16H3C1.34315 16 0 14.6569 0 13V8C0 6.34315 1.34315 5 3 5H21C22.6569 5 24 6.34315 24 8V13C24 14.6569 22.6569 16 21 16H13V17H15C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H9C8.44771 19 8 18.5523 8 18C8 17.4477 8.44771 17 9 17H11V16ZM3 7H21C21.5523 7 22 7.44772 22 8V13C22 13.5523 21.5523 14 21 14H3C2.44772 14 2 13.5523 2 13V8C2 7.44772 2.44772 7 3 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 17H4C2.34315 17 1 15.6569 1 14V6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V14C23 15.6569 21.6569 17 20 17H13V19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19H11V17ZM4 5H20C20.5523 5 21 5.44772 21 6V14C21 14.5523 20.5523 15 20 15H4C3.44772 15 3 14.5523 3 14V6C3 5.44772 3.44772 5 4 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScrollH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.18188 9.17154L5.76766 7.75732L1.52502 12L5.76766 16.2426L7.18188 14.8284L4.35345 12L7.18188 9.17154Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.8181 14.8284L18.2323 16.2426L22.4749 12L18.2323 7.75733L16.8181 9.17155L19.6465 12L16.8181 14.8284Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.9999 12C14.9999 13.6569 13.6567 15 11.9999 15C10.343 15 8.99988 13.6569 8.99988 12C8.99988 10.3431 10.343 9 11.9999 9C13.6567 9 14.9999 10.3431 14.9999 12ZM12.9999 12C12.9999 12.5523 12.5522 13 11.9999 13C11.4476 13 10.9999 12.5523 10.9999 12C10.9999 11.4477 11.4476 11 11.9999 11C12.5522 11 12.9999 11.4477 12.9999 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgScrollV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 16.8182L7.75732 18.2324L12 22.475L16.2426 18.2324L14.8284 16.8182L12 19.6466L9.17154 16.8182Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.8284 7.182L16.2426 5.76779L12 1.52515L7.75733 5.76779L9.17155 7.182L12 4.35357L14.8284 7.182Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 9.00018C13.6569 9.00018 15 10.3433 15 12.0002C15 13.657 13.6569 15.0002 12 15.0002C10.3431 15.0002 9 13.657 9 12.0002C9 10.3433 10.3431 9.00018 12 9.00018ZM12 11.0002C12.5523 11.0002 13 11.4479 13 12.0002C13 12.5525 12.5523 13.0002 12 13.0002C11.4477 13.0002 11 12.5525 11 12.0002C11 11.4479 11.4477 11.0002 12 11.0002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSearchFound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.66542 10.2366L9.19751 8.951L10.4831 10.4831L13.5473 7.91194L14.8328 9.44402L10.2366 13.3007L7.66542 10.2366Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16.2071 4.89344C19.0923 7.77862 19.3131 12.3193 16.8693 15.4578C16.8846 15.4713 16.8996 15.4854 16.9143 15.5L21.1569 19.7427C21.5474 20.1332 21.5474 20.7664 21.1569 21.1569C20.7664 21.5474 20.1332 21.5474 19.7427 21.1569L15.5 16.9143C15.4854 16.8996 15.4713 16.8846 15.4578 16.8693C12.3193 19.3131 7.77862 19.0923 4.89344 16.2071C1.76924 13.083 1.76924 8.01763 4.89344 4.89344C8.01763 1.76924 13.083 1.76924 16.2071 4.89344ZM14.7929 14.7929C17.1361 12.4498 17.1361 8.6508 14.7929 6.30765C12.4498 3.96451 8.6508 3.96451 6.30765 6.30765C3.96451 8.6508 3.96451 12.4498 6.30765 14.7929C8.6508 17.1361 12.4498 17.1361 14.7929 14.7929Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSearchLoading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.55024 10.5503C8.55024 11.1026 8.10253 11.5503 7.55024 11.5503C6.99796 11.5503 6.55024 11.1026 6.55024 10.5503C6.55024 9.99801 6.99796 9.55029 7.55024 9.55029C8.10253 9.55029 8.55024 9.99801 8.55024 10.5503Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5502 11.5503C11.1025 11.5503 11.5502 11.1026 11.5502 10.5503C11.5502 9.99801 11.1025 9.55029 10.5502 9.55029C9.99796 9.55029 9.55024 9.99801 9.55024 10.5503C9.55024 11.1026 9.99796 11.5503 10.5502 11.5503Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5502 11.5503C14.1025 11.5503 14.5502 11.1026 14.5502 10.5503C14.5502 9.99801 14.1025 9.55029 13.5502 9.55029C12.998 9.55029 12.5502 9.99801 12.5502 10.5503C12.5502 11.1026 12.998 11.5503 13.5502 11.5503Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16.2071 4.89344C19.0922 7.7786 19.313 12.3192 16.8693 15.4577C16.8846 15.4712 16.8996 15.4853 16.9142 15.4999L21.1568 19.7426C21.5473 20.1331 21.5473 20.7663 21.1568 21.1568C20.7663 21.5473 20.1331 21.5473 19.7426 21.1568L15.5 16.9141C15.4853 16.8995 15.4713 16.8846 15.4578 16.8693C12.3193 19.3131 7.77858 19.0923 4.89338 16.2071C1.76918 13.083 1.76918 8.01763 4.89338 4.89344C8.01757 1.76924 13.0829 1.76924 16.2071 4.89344ZM6.30759 14.7929C8.65074 17.1361 12.4497 17.1361 14.7929 14.7929C17.136 12.4498 17.136 8.6508 14.7929 6.30765C12.4497 3.96451 8.65074 3.96451 6.30759 6.30765C3.96445 8.6508 3.96445 12.4498 6.30759 14.7929Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.319 14.4326C20.7628 11.2941 20.542 6.75347 17.6569 3.86829C14.5327 0.744098 9.46734 0.744098 6.34315 3.86829C3.21895 6.99249 3.21895 12.0578 6.34315 15.182C9.22833 18.0672 13.769 18.2879 16.9075 15.8442C16.921 15.8595 16.9351 15.8745 16.9497 15.8891L21.1924 20.1317C21.5829 20.5223 22.2161 20.5223 22.6066 20.1317C22.9971 19.7412 22.9971 19.1081 22.6066 18.7175L18.364 14.4749C18.3493 14.4603 18.3343 14.4462 18.319 14.4326ZM16.2426 5.28251C18.5858 7.62565 18.5858 11.4246 16.2426 13.7678C13.8995 16.1109 10.1005 16.1109 7.75736 13.7678C5.41421 11.4246 5.41421 7.62565 7.75736 5.28251C10.1005 2.93936 13.8995 2.93936 16.2426 5.28251Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSelectO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 11.508L7.75732 10.0938L12 5.85114L16.2426 10.0938L14.8284 11.508L12 8.67956L9.17154 11.508Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 12.492L7.75732 13.9062L12 18.1489L16.2426 13.9062L14.8284 12.492L12 15.3204L9.17154 12.492Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSelectR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 11.508L7.75732 10.0938L12 5.85113L16.2426 10.0938L14.8284 11.508L12 8.67956L9.17154 11.508Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17154 12.492L7.75732 13.9062L12 18.1489L16.2426 13.9062L14.8284 12.492L12 15.3204L9.17154 12.492Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9.65685L7.41421 11.0711L11.6569 6.82843L15.8995 11.0711L17.3137 9.65685L11.6569 4L6 9.65685Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14.4433L7.41421 13.0291L11.6569 17.2717L15.8995 13.0291L17.3137 14.4433L11.6569 20.1001L6 14.4433Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H15C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM7 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44771 4 7 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgServerless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.7872 6H5V9H10.6953L11.7872 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.96735 11H5V14H8.87544L9.96735 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.0038 14L12.0957 11H20V14H11.0038Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1475 16H5V19H7.05559L8.1475 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.18394 19L10.2759 16H20V19H9.18394Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8236 9L13.9156 6H20V9H12.8236Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeHalfCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20V17C13.2386 17 11 14.7614 11 12C11 9.23858 13.2386 7 16 7V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeHexagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 15.2348L12 18.5681L18 15.2348V8.76521L12 5.43188L6 8.76521V15.2348ZM12 2L3 7V17L12 22L21 17V7L12 2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeRhombus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 6.34315L6.34317 12L12 17.6569L17.6569 12L12 6.34315ZM2.10052 12L12 21.8995L21.8995 12L12 2.10051L2.10052 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 7H7V17H17V7ZM4 4V20H20V4H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.6603 5L3 20H20.3205L11.6603 5ZM11.6603 11L8.19615 17H15.1244L11.6603 11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShapeZigzag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.31212 9L1 10.5094L4.77355 13.7897L6.28297 15.1018L7.59509 13.5924L9.13456 11.8214L11.3988 13.7897L12.9082 15.1018L14.2203 13.5924L15.7584 11.823L18.0209 13.7897L19.5303 15.1018L20.8424 13.5924L22.8106 11.3283L21.3012 10.0162L19.333 12.2803L15.5594 9L14.2473 10.5094L14.249 10.5109L12.7109 12.2803L8.93736 9L8.05395 10.0163L6.08567 12.2803L2.31212 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 6.12549 15.0077 6.24919 15.0227 6.37063L8.08261 9.84066C7.54305 9.32015 6.80891 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15C6.80891 15 7.54305 14.6798 8.08261 14.1593L15.0227 17.6294C15.0077 17.7508 15 17.8745 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C17.1911 15 16.457 15.3202 15.9174 15.8407L8.97733 12.3706C8.99229 12.2492 9 12.1255 9 12C9 11.8745 8.99229 11.7508 8.97733 11.6294L15.9174 8.15934C16.457 8.67985 17.1911 9 18 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 8V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8H7ZM5 4H19V13C19 16.866 15.866 20 12 20C8.13401 20 5 16.866 5 13V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 4H19C19.5523 4 20 4.44771 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44771 4 5 4ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM12 12C9.23858 12 7 9.31371 7 6H9C9 8.56606 10.6691 10 12 10C13.3309 10 15 8.56606 15 6H17C17 9.31371 14.7614 12 12 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.79166 2H1V4H4.2184L6.9872 16.6776H7V17H20V16.7519L22.1932 7.09095L22.5308 6H6.6552L6.08485 3.38852L5.79166 2ZM19.9869 8H7.092L8.62081 15H18.3978L19.9869 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22C11.1046 22 12 21.1046 12 20C12 18.8954 11.1046 18 10 18C8.89543 18 8 18.8954 8 20C8 21.1046 8.89543 22 10 22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20C19 21.1046 18.1046 22 17 22C15.8954 22 15 21.1046 15 20C15 18.8954 15.8954 18 17 18C18.1046 18 19 18.8954 19 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1925 7.70711C15.8019 7.31658 15.1688 7.31658 14.7782 7.70711L7.70718 14.7782C7.31665 15.1687 7.31665 15.8019 7.70718 16.1924C8.0977 16.5829 8.73087 16.5829 9.12139 16.1924L16.1925 9.12132C16.583 8.7308 16.583 8.09763 16.1925 7.70711Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgShutterstock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17C12 17.5523 12.4477 18 13 18H17C17.5523 18 18 17.5523 18 17V13C18 12.4477 17.5523 12 17 12H16V16H12V17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6C11.5523 6 12 6.44772 12 7V8H8V12H7C6.44772 12 6 11.5523 6 11V7C6 6.44772 6.44772 6 7 6H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM19 4H5C4.44771 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44771 19.5523 4 19 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSidebarOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4H21V20H3V4ZM9 6H19V18H9V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSidebarRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 4H17V20H3V4ZM5 6H15V18H5V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H19V20H21V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M21 20H7V4H21V20ZM19 18H9V6H19V18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20H5V4H3V20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10C11.4477 10 11 10.4477 11 11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V11C13 10.4477 12.5523 10 12 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 6V4H20V20H12V18H8V16H4V8H8V6H12ZM14 6H18V18H14V6ZM12 8H10V16H12V8ZM8 10V14H6V10H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.20879 3H18.903L20.1118 10.2527L12.0559 21.1858L4 10.2527L5.20879 3ZM6.90304 5L6.11184 9.74726L12.0559 17.8142L18 9.74726L17.2088 5H6.90304Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.05592 8H16.0559V10H8.05592V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 10C13 11.1046 13.8954 12 15 12C16.1046 12 17 11.1046 17 10V5C17 3.89543 16.1046 3 15 3C13.8954 3 13 3.89543 13 5V10ZM5 8C3.89543 8 3 8.89543 3 10C3 11.1046 3.89543 12 5 12H10C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8H5ZM15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17H20C21.1046 17 22 16.1046 22 15C22 13.8954 21.1046 13 20 13H15ZM10 22C8.89543 22 8 21.1046 8 20L8 15C8 13.8954 8.89543 13 10 13C11.1046 13 12 13.8954 12 15V20C12 21.1046 11.1046 22 10 22ZM8 5C8 3.89543 8.89543 3 10 3C11.1046 3 12 3.89543 12 5V7H10C8.89543 7 8 6.10457 8 5ZM3 15C3 16.1046 3.89543 17 5 17C6.10457 17 7 16.1046 7 15V13H5C3.89543 13 3 13.8954 3 15ZM17 20C17 21.1046 16.1046 22 15 22C13.8954 22 13 21.1046 13 20V18H15C16.1046 18 17 18.8954 17 20ZM22 10C22 8.89543 21.1046 8 20 8C18.8954 8 18 8.89543 18 10V12H20C21.1046 12 22 11.1046 22 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSleep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM16.899 17C15.6364 18.2372 13.9073 19 12 19C10.0927 19 8.36355 18.2372 7.10102 17H16.899ZM18.3264 15C18.7583 14.0907 19 13.0736 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 13.0736 5.24169 14.0907 5.67363 15H18.3264Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartHomeBoiler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5C5 2.79086 6.79086 1 9 1H15C17.2091 1 19 2.79086 19 5V21H15.144L15.8865 22.9999H13.8865L13.144 21H11.144L11.8865 22.9999H9.88653L9.14397 21H5V5ZM9 3H15C16.1046 3 17 3.89543 17 5V7H7V5C7 3.89543 7.89543 3 9 3ZM7 9H17V19H7V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartHomeCooker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 16C15 17.6569 13.6569 19 12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 1H9V3H11V5H7C4.79086 5 3 6.79086 3 9V19C3 21.2091 4.79086 23 7 23H17C19.2091 23 21 21.2091 21 19V9C21 6.79086 19.2091 5 17 5H13V3H15V1ZM17 7H7C5.89543 7 5 7.89543 5 9H19C19 7.89543 18.1046 7 17 7ZM19 11H5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartHomeHeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H10V15H7C5.34315 15 4 13.6569 4 12C4 10.3431 5.34315 9 7 9H17C18.6569 9 20 10.3431 20 12C20 13.6569 18.6569 15 17 15H14V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 12C0 8.13401 3.13401 5 7 5H17C20.866 5 24 8.13401 24 12C24 15.866 20.866 19 17 19H7C3.13401 19 0 15.866 0 12ZM7 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartHomeLight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.03435 6.5C7.03435 3.73858 9.27293 1.5 12.0344 1.5C14.7958 1.5 17.0344 3.73858 17.0344 6.5V10.5C17.0344 13.2614 14.7958 15.5 12.0344 15.5C9.27293 15.5 7.03435 13.2614 7.03435 10.5V6.5ZM15.0344 6.5V10.5C15.0344 12.1569 13.6912 13.5 12.0344 13.5C10.3775 13.5 9.03435 12.1569 9.03435 10.5V6.5C9.03435 4.84315 10.3775 3.5 12.0344 3.5C13.6912 3.5 15.0344 4.84315 15.0344 6.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0344 16.5C11.4821 16.5 11.0344 16.9477 11.0344 17.5V21.5C11.0344 22.0523 11.4821 22.5 12.0344 22.5C12.5866 22.5 13.0344 22.0523 13.0344 21.5V17.5C13.0344 16.9477 12.5866 16.5 12.0344 16.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.74433 16.4397C7.93323 15.9207 8.50707 15.6531 9.02605 15.842C9.54502 16.0309 9.81261 16.6048 9.62372 17.1237L8.25564 20.8825C8.06675 21.4015 7.4929 21.6691 6.97393 21.4802C6.45495 21.2913 6.18736 20.7174 6.37625 20.1985L7.74433 16.4397Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.974 15.8421C14.4551 16.031 14.1875 16.6048 14.3764 17.1238L15.7445 20.8825C15.9333 21.4015 16.5072 21.6691 17.0262 21.4802C17.5451 21.2913 17.8127 20.7175 17.6238 20.1985L16.2558 16.4397C16.0669 15.9208 15.493 15.6532 14.974 15.8421Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartHomeRefrigerator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6V8C11 8.55228 10.5523 9 10 9C9.44772 9 9 8.55228 9 8V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13C9.44772 13 9 13.4477 9 14V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V14C11 13.4477 10.5523 13 10 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 4C5 2.34315 6.34315 1 8 1H16C17.6569 1 19 2.34315 19 4V20C19 21.6569 17.6569 23 16 23H8C6.34315 23 5 21.6569 5 20V4ZM8 3H16C16.5523 3 17 3.44772 17 4V10H7V4C7 3.44772 7.44772 3 8 3ZM7 12H17V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartHomeWashMachine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 4H18C18.5523 4 19 4.44772 19 5V8H5V5C5 4.44772 5.44771 4 6 4ZM19 19V10H5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19ZM3 5C3 3.34315 4.34315 2 6 2H18C19.6569 2 21 3.34315 21 5V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7H9C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5H7ZM14 7C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7ZM18 6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6C16 5.44772 16.4477 5 17 5C17.5523 5 18 5.44772 18 6ZM14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15ZM16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartphoneChip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 22C9 22.5523 8.55228 23 8 23C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21C8.55228 21 9 21.4477 9 22ZM13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22C11 21.4477 11.4477 21 12 21C12.5523 21 13 21.4477 13 22ZM16 23C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21C15.4477 21 15 21.4477 15 22C15 22.5523 15.4477 23 16 23Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 2C9 2.55228 8.55228 3 8 3C7.44772 3 7 2.55228 7 2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2ZM13 2C13 2.55228 12.5523 3 12 3C11.4477 3 11 2.55228 11 2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2ZM16 3C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3ZM9 22C9 22.5523 8.55228 23 8 23C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21C8.55228 21 9 21.4477 9 22ZM13 22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22C11 21.4477 11.4477 21 12 21C12.5523 21 13 21.4477 13 22ZM16 23C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21C15.4477 21 15 21.4477 15 22C15 22.5523 15.4477 23 16 23ZM23 16C23 15.4477 22.5523 15 22 15C21.4477 15 21 15.4477 21 16C21 16.5523 21.4477 17 22 17C22.5523 17 23 16.5523 23 16ZM23 12C23 11.4477 22.5523 11 22 11C21.4477 11 21 11.4477 21 12C21 12.5523 21.4477 13 22 13C22.5523 13 23 12.5523 23 12ZM22 7C22.5523 7 23 7.44771 23 8C23 8.55229 22.5523 9 22 9C21.4477 9 21 8.55229 21 8C21 7.44771 21.4477 7 22 7ZM2 15C2.55228 15 3 15.4477 3 16C3 16.5523 2.55228 17 2 17C1.44772 17 1 16.5523 1 16C1 15.4477 1.44772 15 2 15ZM2 11C2.55228 11 3 11.4477 3 12C3 12.5523 2.55228 13 2 13C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11ZM3 8C3 7.44771 2.55228 7 2 7C1.44772 7 1 7.44771 1 8C1 8.55229 1.44772 9 2 9C2.55228 9 3 8.55229 3 8ZM17 6H7C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6ZM7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7ZM14 10H10V14H14V10ZM8 8V16H16V8H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartphoneRam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4C5 4.55228 4.55228 5 4 5C3.44772 5 3 4.55228 3 4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4C17 4.55228 16.5523 5 16 5C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3C16.5523 3 17 3.44772 17 4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5C20.5523 5 21 4.55228 21 4C21 3.44772 20.5523 3 20 3C19.4477 3 19 3.44772 19 4C19 4.55228 19.4477 5 20 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19C4.55228 19 5 19.4477 5 20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19C16.5523 19 17 19.4477 17 20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12C5.55228 12 6 11.5523 6 11C6 10.4477 5.55228 10 5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 9C0 7.34315 1.34315 6 3 6H21C22.6569 6 24 7.34315 24 9V15C24 16.6569 22.6569 18 21 18H3C1.34315 18 0 16.6569 0 15V9ZM3 8H21C21.5523 8 22 8.44772 22 9V15C22 15.5523 21.5523 16 21 16H3C2.44772 16 2 15.5523 2 15V9C2 8.44772 2.44772 8 3 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartphoneShake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14H11V16H13V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 7C8 5.89543 8.89543 5 10 5H14C15.1046 5 16 5.89543 16 7V17C16 18.1046 15.1046 19 14 19H10C8.89543 19 8 18.1046 8 17V7ZM10 7H14V17H10V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9H20V15H18V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14H2V10H0V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15H4V9H6V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 10H22V14H24V10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmartphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16H11V18H13V16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 4C5 2.89543 5.89543 2 7 2H17C18.1046 2 19 2.89543 19 4V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V4ZM7 4H17V20H7L7 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmileMouthOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17C14.2091 17 16 15.2091 16 13H8C8 15.2091 9.79086 17 12 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9C9.55228 9 10 9.44772 10 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmileNeutral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmileNoMouth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9C9.55228 9 10 9.44772 10 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmileNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H9C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmileSad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmileUpside(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11H14C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11H8C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14C10 13.4477 9.55228 13 9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13H14C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13H8C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44771 8.44772 9 9 9C9.55228 9 10 9.44771 10 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11C15.5523 11 16 10.5523 16 10C16 9.44771 15.5523 9 15 9C14.4477 9 14 9.44771 14 10C14 10.5523 14.4477 11 15 11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSoftwareDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSoftwareUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14.9861C11 15.5384 11.4477 15.9861 12 15.9861C12.5523 15.9861 13 15.5384 13 14.9861V7.82831L16.2428 11.0711L17.657 9.65685L12.0001 4L6.34326 9.65685L7.75748 11.0711L11 7.82854V14.9861Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSortAz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8C6 7.44772 6.44772 7 7 7H17C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H7C6.44772 9 6 8.55228 6 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSortZa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 16C6 16.5523 6.44772 17 7 17H17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15H7C6.44772 15 6 15.4477 6 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12C8 12.5523 8.44772 13 9 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9C8.44772 11 8 11.4477 8 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9C10.4477 9 10 8.55229 10 8C10 7.44771 10.4477 7 11 7H13C13.5523 7 14 7.44771 14 8C14 8.55229 13.5523 9 13 9H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpaceBetweenV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5V9H19V5H17V7H7V5H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19V15H19V19H17V17H7V19H5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H17V13H7V11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpaceBetween(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5L15 5L15 19H19V17H17L17 7L19 7V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5L9 5L9 19H5L5 17H7L7 7H5L5 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7V17H11L11 7H13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpectrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16H16C16 11.5817 12.4183 8 8 8V12C10.2091 12 12 13.7909 12 16Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpinnerAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpinnerTwoAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C17.5228 22 22 17.5228 22 12H19C19 15.866 15.866 19 12 19V22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpinnerTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": "0.2",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C17.5228 22 22 17.5228 22 12H19C19 15.866 15.866 19 12 19V22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSpinner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": "0.2",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H10V14H14V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 9C5 6.79086 6.79086 5 9 5H15C17.2091 5 19 6.79086 19 9V15C19 17.2091 17.2091 19 15 19H9C6.79086 19 5 17.2091 5 15V9ZM9 8H15C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16H9C8.44772 16 8 15.5523 8 15V9C8 8.44772 8.44772 8 9 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4V16H22V2H8V4H20Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8V22H16V8H2ZM14 10H4V20H14V10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H5V5H19V19H17V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgStark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.17222 18.0249C5.81662 17.2862 4.69522 16.1661 3.95526 14.791C3.01664 13.0467 2.75847 11.0163 3.23071 9.0927C3.70295 7.16908 4.87201 5.48904 6.51164 4.37775C8.15127 3.26646 10.1449 2.80295 12.1066 3.07692L11.67 6.20259C10.4822 6.03669 9.2751 6.31735 8.28231 6.99024C7.28951 7.66312 6.58164 8.68039 6.2957 9.84514C6.00976 11.0099 6.16608 12.2393 6.73442 13.2954C7.18247 14.1281 7.86148 14.8063 8.6823 15.2536L14.8278 3.97537L17.4621 5.4108C18.8177 6.14946 19.9391 7.26961 20.679 8.64469C21.6177 10.3889 21.8758 12.4193 21.4036 14.343C20.9314 16.2666 19.7623 17.9466 18.1227 19.0579C16.483 20.1692 14.4894 20.6327 12.5277 20.3587L12.9643 17.2331C14.1521 17.399 15.3592 17.1183 16.352 16.4454C17.3448 15.7725 18.0527 14.7553 18.3386 13.5905C18.6245 12.4258 18.4682 11.1964 17.8999 10.1402C17.4518 9.30761 16.7728 8.62938 15.952 8.18212L9.80647 19.4604L7.17222 18.0249Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6214 2.55029L21.4498 5.37872L20.0356 6.79293L17.2071 3.96451L18.6214 2.55029Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.8225 8.60055H10.8225V12.6005H12.8225V8.60055Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.18633 18.8137C8.70105 22.3285 14.3995 22.3285 17.9143 18.8137C21.429 15.299 21.429 9.60055 17.9143 6.08583C14.3995 2.57111 8.70105 2.57111 5.18633 6.08583C1.67161 9.60054 1.67161 15.299 5.18633 18.8137ZM6.60054 17.3995C9.33422 20.1332 13.7664 20.1332 16.5 17.3995C19.2337 14.6659 19.2337 10.2337 16.5 7.50004C13.7664 4.76637 9.33422 4.76637 6.60054 7.50004C3.86688 10.2337 3.86688 14.6659 6.60054 17.3995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 6H9C8.44772 6 8 6.44772 8 7V17C8 17.5523 8.44772 18 9 18H15C15.5523 18 16 17.5523 16 17V7C16 6.44772 15.5523 6 15 6ZM9 4C7.34315 4 6 5.34315 6 7V17C6 18.6569 7.34315 20 9 20H15C16.6569 20 18 18.6569 18 17V7C18 5.34315 16.6569 4 15 4H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6C2 5.44772 2.44772 5 3 5C3.55228 5 4 5.44772 4 6V18C4 18.5523 3.55228 19 3 19C2.44772 19 2 18.5523 2 18V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6C20 5.44772 20.4477 5 21 5C21.5523 5 22 5.44772 22 6V18C22 18.5523 21.5523 19 21 19C20.4477 19 20 18.5523 20 18V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgStudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13H13V17H17V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3H21V21H3V3ZM5 5H19V19H5V5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 21V13H21V21H13ZM15 15H19L19 19H15V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 11L3 3L11 3V11H3ZM5 5L9 5V9L5 9L5 5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V12H16V8L12 8V6L18 6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18H6L6 12H8L8 16H12V18Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 0H13V4.06189C12.6724 4.02104 12.3387 4 12 4C11.6613 4 11.3276 4.02104 11 4.06189V0ZM7.0943 5.68018L4.22173 2.80761L2.80752 4.22183L5.6801 7.09441C6.09071 6.56618 6.56608 6.0908 7.0943 5.68018ZM4.06189 11H0V13H4.06189C4.02104 12.6724 4 12.3387 4 12C4 11.6613 4.02104 11.3276 4.06189 11ZM5.6801 16.9056L2.80751 19.7782L4.22173 21.1924L7.0943 18.3198C6.56608 17.9092 6.09071 17.4338 5.6801 16.9056ZM11 19.9381V24H13V19.9381C12.6724 19.979 12.3387 20 12 20C11.6613 20 11.3276 19.979 11 19.9381ZM16.9056 18.3199L19.7781 21.1924L21.1923 19.7782L18.3198 16.9057C17.9092 17.4339 17.4338 17.9093 16.9056 18.3199ZM19.9381 13H24V11H19.9381C19.979 11.3276 20 11.6613 20 12C20 12.3387 19.979 12.6724 19.9381 13ZM18.3198 7.0943L21.1923 4.22183L19.7781 2.80762L16.9056 5.6801C17.4338 6.09071 17.9092 6.56608 18.3198 7.0943Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.2607 21.9966C12.174 21.9988 12.0871 22 12 22C11.9128 22 11.8259 21.9988 11.7393 21.9966C7.68318 21.8928 4.22762 19.3738 2.7573 15.8242C1.74192 13.3674 1.7476 10.588 2.77433 8.13481C3.27688 6.93672 4.00599 5.85718 4.90808 4.94979L4.94983 4.90804C5.85259 4.01056 6.92574 3.28429 8.1165 2.78202C10.5894 1.74123 13.3958 1.73933 15.87 2.77633C17.0688 3.27993 18.1488 4.01042 19.0562 4.91407L19.0859 4.94373C19.9989 5.86054 20.7351 6.95351 21.2392 8.16721C21.7279 9.34662 21.9812 10.6006 21.999 11.8573C21.9997 11.9047 22 11.9523 22 12C22 12.0506 21.9996 12.1012 21.9989 12.1516C21.9376 16.2743 19.3814 19.7925 15.7731 21.2637C14.6481 21.7213 13.4566 21.9656 12.2607 21.9966ZM14.0322 15.4464L16.906 18.3202C14.0281 20.5599 9.97192 20.5599 7.09402 18.3202L9.96779 15.4464C11.2175 16.1845 12.7825 16.1845 14.0322 15.4464ZM8.55358 14.0322L5.67981 16.906C3.44007 14.0281 3.44007 9.97192 5.67981 7.09402L8.55358 9.96779C7.81548 11.2175 7.81548 12.7825 8.55358 14.0322ZM10.0824 12.5694C10.0773 12.5523 10.0725 12.5351 10.0679 12.5179C9.97738 12.179 9.97738 11.821 10.0679 11.4821C10.1556 11.1537 10.3282 10.8434 10.5858 10.5858C10.8299 10.3417 11.1213 10.1739 11.4306 10.0824C11.4477 10.0773 11.4649 10.0725 11.4821 10.0679C11.821 9.97738 12.179 9.97737 12.5179 10.0679C12.8463 10.1556 13.1566 10.3282 13.4142 10.5858C13.6583 10.8299 13.8261 11.1213 13.9176 11.4306C13.9227 11.4477 13.9275 11.4649 13.9321 11.4821C14.0226 11.821 14.0226 12.179 13.9321 12.5179C13.8444 12.8462 13.6718 13.1566 13.4142 13.4142C13.1701 13.6583 12.8787 13.8261 12.5694 13.9176C12.5523 13.9227 12.5351 13.9275 12.5179 13.9321C12.179 14.0226 11.821 14.0226 11.4821 13.9321C11.1538 13.8444 10.8434 13.6718 10.5858 13.4142C10.3417 13.1701 10.1739 12.8787 10.0824 12.5694ZM14.0322 8.55357C12.7825 7.81548 11.2175 7.81548 9.96779 8.55357L7.09402 5.6798C9.97192 3.44007 14.0281 3.44007 16.906 5.6798L14.0322 8.55357ZM18.3202 16.906C20.5599 14.0281 20.5599 9.97192 18.3202 7.09402L15.4464 9.96779C16.1845 11.2175 16.1845 12.7825 15.4464 14.0322L18.3202 16.906Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSwapVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16H13.5L13.5 10H15.5L15.5 16H17L14.5 19L12 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H9.5L9.5 14H11.5L11.5 8H13L10.5 5L8 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSwap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13V11.5H10V9.5H16V8L19 10.5L16 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17V15.5H14V13.5H8V12L5 14.5L8 17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSweden(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 4H10V11H23V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 13V20H10V13H23Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13V20H1V13H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11V4H8V11H1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSwiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3V21H21V3H3ZM14 7H10V10H7V14H10V17H14V14H17V10H14V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.56079 10.6418L6.35394 3.94971L8.25402 5.84979C11.7312 3.6588 16.3814 4.07764 19.41 7.1063L17.9958 8.52052C15.7536 6.27827 12.3686 5.87519 9.71551 7.31128L11.2529 8.84869L4.56079 10.6418Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4392 13.3581L17.646 20.0502L15.7459 18.1501C12.2688 20.3411 7.61857 19.9223 4.58991 16.8936L6.00413 15.4794C8.24638 17.7217 11.6313 18.1247 14.2844 16.6887L12.747 15.1512L19.4392 13.3581Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.9999 4C20.6568 4 21.9999 5.34315 21.9999 7V17C21.9999 18.6569 20.6568 20 18.9999 20H4.99994C3.34308 20 1.99994 18.6569 1.99994 17V7C1.99994 5.34315 3.34308 4 4.99994 4H18.9999ZM19.9999 9.62479H13C12.4478 9.62479 11.8442 9.20507 11.652 8.68732L10.6542 6H4.99994C4.44765 6 3.99994 6.44772 3.99994 7V17C3.99994 17.5523 4.44765 18 4.99994 18H18.9999C19.5522 18 19.9999 17.5523 19.9999 17V9.62479Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8V16C2 16.5523 2.44772 17 3 17H16.6202C16.9121 17 17.1895 16.8724 17.3795 16.6508L20.808 12.6508C21.129 12.2763 21.129 11.7237 20.808 11.3492L17.3795 7.34921C17.1895 7.12756 16.9121 7 16.6202 7H3C2.44772 7 2 7.44772 2 8ZM0 8V16C0 17.6569 1.34315 19 3 19H16.6202C17.496 19 18.328 18.6173 18.898 17.9524L22.3265 13.9524C23.2895 12.8289 23.2895 11.1711 22.3265 10.0476L18.898 6.04763C18.328 5.38269 17.496 5 16.6202 5H3C1.34315 5 0 6.34315 0 8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13ZM15 15C16.6569 15 18 13.6569 18 12C18 10.3431 16.6569 9 15 9C13.3431 9 12 10.3431 12 12C12 13.6569 13.3431 15 15 15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTally(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.66124 2.67117C3.71341 2.4 3.97956 2.18018 4.2557 2.18018H6.2557C6.53184 2.18018 6.71341 2.4 6.66124 2.67117L5.33877 9.54511C5.2866 9.81628 5.02045 10.0361 4.74431 10.0361H2.74431C2.46817 10.0361 2.2866 9.81628 2.33877 9.54511L3.66124 2.67117Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66124 2.67117C8.71341 2.4 8.97956 2.18018 9.2557 2.18018H11.2557C11.5318 2.18018 11.7134 2.4 11.6612 2.67117L8.07168 21.329C8.01951 21.6002 7.75336 21.82 7.47722 21.82H5.47722C5.20108 21.82 5.01951 21.6002 5.07168 21.329L8.66124 2.67117Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.6612 2.67117C13.7134 2.4 13.9796 2.18018 14.2557 2.18018H16.2557C16.5318 2.18018 16.7134 2.4 16.6612 2.67117L13.0717 21.329C13.0195 21.6002 12.7534 21.82 12.4772 21.82H10.4772C10.2011 21.82 10.0195 21.6002 10.0717 21.329L13.6612 2.67117Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6612 2.67117C18.7134 2.4 18.9796 2.18018 19.2557 2.18018H21.2557C21.5318 2.18018 21.7134 2.4 21.6612 2.67117L20.3388 9.54511C20.2866 9.81628 20.0205 10.0361 19.7443 10.0361H17.7443C17.4682 10.0361 17.2866 9.81628 17.3388 9.54511L18.6612 2.67117Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTapDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.9236 18V14C14.9236 12.3431 13.5804 11 11.9236 11C10.2667 11 8.92355 12.3431 8.92355 14V18C8.92355 19.6569 10.2667 21 11.9236 21C13.5804 21 14.9236 19.6569 14.9236 18ZM11.9236 9C9.16213 9 6.92355 11.2386 6.92355 14V18C6.92355 20.7614 9.16213 23 11.9236 23C14.685 23 16.9236 20.7614 16.9236 18V14C16.9236 11.2386 14.685 9 11.9236 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9236 14C10.9236 13.4477 11.3713 13 11.9236 13C12.4758 13 12.9236 13.4477 12.9236 14V17H10.9236V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.9235 1C14.7023 1 17.2164 2.13339 19.0286 3.96311L17.6144 5.37735C16.1641 3.90955 14.15 3 11.9235 3C9.77436 3 7.82311 3.84749 6.38577 5.22651L4.97131 3.81205C6.7708 2.07122 9.22207 1 11.9235 1Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.9233 5C13.5809 5 15.1038 5.5761 16.3029 6.53898L14.8768 7.9651C14.0493 7.35833 13.0281 7 11.9233 7C10.848 7 9.85204 7.33943 9.03662 7.91699L7.60779 6.48816C8.79686 5.55586 10.2952 5 11.9233 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTapSingle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.0491 3.11401C14.1927 3.11401 16.1393 3.95706 17.5756 5.32967L16.1609 6.74437C15.087 5.73346 13.6404 5.11401 12.0491 5.11401C10.4086 5.11401 8.92183 5.77243 7.83868 6.83944L6.42444 5.42519C7.86954 3.99627 9.85631 3.11401 12.0491 3.11401Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9767 11.886C10.9767 11.3337 11.4244 10.886 11.9767 10.886C12.529 10.886 12.9767 11.3337 12.9767 11.886V13.886H10.9767V11.886Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.9767 6.88599C9.21526 6.88599 6.97668 9.12456 6.97668 11.886V15.886C6.97668 18.6474 9.21526 20.886 11.9767 20.886C14.7381 20.886 16.9767 18.6474 16.9767 15.886V11.886C16.9767 9.12456 14.7381 6.88599 11.9767 6.88599ZM14.9767 15.886V11.886C14.9767 10.2291 13.6335 8.88599 11.9767 8.88599C10.3198 8.88599 8.97668 10.2291 8.97668 11.886V15.886C8.97668 17.5428 10.3198 18.886 11.9767 18.886C13.6335 18.886 14.9767 17.5428 14.9767 15.886Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTemplate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3V9H21V3H3ZM19 5H5V7H19V5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 11V21H11V11H3ZM9 13H5V19H9V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H13V13H21V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15H21V17H13V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19H13V21H21V19Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTennis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711C8.83418 22.9763 15.1658 22.9763 19.0711 19.0711ZM19.9426 11.0407C19.7364 9.32374 18.9745 7.6608 17.6569 6.34315C16.3343 5.0206 14.6639 4.25792 12.9402 4.0551L12.93 4.11139C12.1086 8.58308 8.58304 12.1086 4.11136 12.93L4.05511 12.9402C4.25793 14.6639 5.02061 16.3343 6.34315 17.6569C7.66079 18.9745 9.32373 19.7364 11.0407 19.9426C11.0449 19.9191 11.0491 19.8956 11.0534 19.8721C11.8748 15.4004 15.4003 11.8748 19.872 11.0534C19.8955 11.0491 19.9191 11.0449 19.9426 11.0407ZM19.872 13.4292V13.0951C16.5073 13.8586 13.8586 16.5073 13.095 19.8721H13.429C14.9777 19.5924 16.4598 18.8539 17.6569 17.6569C18.8539 16.4598 19.5923 14.9778 19.872 13.4292ZM4.11136 10.8884L4.11136 10.666C4.37766 9.08301 5.12159 7.5647 6.34315 6.34315C7.56465 5.12165 9.08288 4.37773 10.6658 4.11139L10.8883 4.11139C10.1248 7.47615 7.47612 10.1249 4.11136 10.8884Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.0333 14.8284L6.44751 16.2426L10.6902 12L6.44751 7.75733L5.0333 9.17155L7.86172 12L5.0333 14.8284Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14H11V16H15V14Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 2C0.895431 2 0 2.89543 0 4V20C0 21.1046 0.89543 22 2 22H22C23.1046 22 24 21.1046 24 20V4C24 2.89543 23.1046 2 22 2H2ZM22 4H2L2 20H22V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTerrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10L3 18H13L8 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5286 10.7543L13.5 6L21 18H15.0572L10.5286 10.7543Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9498 5.63615C17.3403 5.24563 17.9735 5.24563 18.364 5.63615C18.7545 6.02668 18.7545 6.65984 18.364 7.05037L11.2929 14.1214C10.9024 14.512 10.2693 14.512 9.87873 14.1214C9.48821 13.7309 9.48821 13.0977 9.87873 12.7072L16.9498 5.63615Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.82813 17.5862C9.7695 18.8725 12.4109 18.6603 14.1214 16.9499L21.1924 9.8788C23.1451 7.92617 23.1451 4.76035 21.1924 2.80773C19.2398 0.855106 16.074 0.855106 14.1214 2.80773L7.0503 9.8788C5.33984 11.5893 5.12771 14.2307 6.41392 16.172L2.80766 19.7783C2.41714 20.1688 2.41714 20.802 2.80766 21.1925C3.19819 21.583 3.83135 21.583 4.22188 21.1925L7.82813 17.5862ZM12.7072 15.5356L19.7782 8.46458C20.9498 7.29301 20.9498 5.39351 19.7782 4.22194C18.6067 3.05037 16.7072 3.05037 15.5356 4.22194L8.46452 11.293C7.29294 12.4646 7.29294 14.3641 8.46452 15.5356C9.63609 16.7072 11.5356 16.7072 12.7072 15.5356Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgThermostat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15 13.9997C16.2144 14.9119 17 16.3642 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 16.3642 7.78555 14.9119 9 13.9997V4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4V13.9997ZM13 4V15.1707C14.1652 15.5826 15 16.6938 15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18C9 16.6938 9.83481 15.5826 11 15.1707V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTikcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 5H5V9H9V5ZM3 3V11H11V3H3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M19 5H15V9H19V5ZM13 3V11H21V3H13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 15H5V19H9V15ZM3 13V21H11V13H3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13H15V21H13V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13H18V21H16V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H21V21H19V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H11V12H16V14H9V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTimelapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19C10.067 19 8.31704 18.2165 7.05029 16.9498L12 12L12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.07089C16.3923 5.55612 19 8.47353 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 9.96159 5.87128 8.12669 7.26175 6.84738L5.84658 5.43221C4.09461 7.0743 3 9.40932 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C11.662 3 11.3283 3.01863 11 3.05493V9.08551H13V5.07089Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.70711 8.70708C7.31658 9.0976 7.31658 9.73077 7.70711 10.1213L10.5355 12.9497C10.9261 13.3402 11.5592 13.3402 11.9497 12.9497C12.3403 12.5592 12.3403 11.926 11.9497 11.5355L9.12132 8.70708C8.7308 8.31655 8.09763 8.31655 7.70711 8.70708Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "opacity": "0.5",
                    "x": "7",
                    "y": "9",
                    "width": "10",
                    "height": "10",
                    "rx": "1",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18 3H6C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V4C19 3.44772 18.5523 3 18 3ZM6 1C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V4C21 2.34315 19.6569 1 18 1H6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6C7 5.44772 7.44772 5 8 5H12C12.5523 5 13 5.44772 13 6C13 6.55228 12.5523 7 12 7H8C7.44772 7 7 6.55228 7 6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 12C0 8.13401 3.13401 5 7 5H17C20.866 5 24 8.13401 24 12C24 15.866 20.866 19 17 19H7C3.13401 19 0 15.866 0 12ZM7 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15C5.34315 15 4 13.6569 4 12C4 10.3431 5.34315 9 7 9C8.65685 9 10 10.3431 10 12C10 13.6569 8.65685 15 7 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M24 12C24 8.13401 20.866 5 17 5H7C3.13401 5 0 8.13401 0 12C0 15.866 3.13401 19 7 19H17C20.866 19 24 15.866 24 12ZM17 7H7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToggleSquareOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9C14.4477 9 14 9.44772 14 10V14C14 14.5523 14.4477 15 15 15H19C19.5523 15 20 14.5523 20 14V10C20 9.44772 19.5523 9 19 9H15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 7C0 5.89543 0.895431 5 2 5H22C23.1046 5 24 5.89543 24 7V17C24 18.1046 23.1046 19 22 19H2C0.89543 19 0 18.1046 0 17V7ZM2 7H22V17H2L2 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToggleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9C9.55228 9 10 9.44772 10 10V14C10 14.5523 9.55228 15 9 15H5C4.44772 15 4 14.5523 4 14V10C4 9.44772 4.44772 9 5 9H9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M24 7C24 5.89543 23.1046 5 22 5H2C0.89543 5 0 5.89543 0 7V17C0 18.1046 0.895432 19 2 19H22C23.1046 19 24 18.1046 24 17V7ZM22 7H2V17H22V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToolbarBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13H6V15H18V13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM5 7H19C19.5523 7 20 7.44771 20 8V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V8C4 7.44772 4.44772 7 5 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToolbarLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9H6V15H8V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM5 7H19C19.5523 7 20 7.44771 20 8V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V8C4 7.44772 4.44772 7 5 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToolbarRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9H18V15H16V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 8C22 6.34315 20.6569 5 19 5H5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V8ZM19 7H5C4.44772 7 4 7.44771 4 8V16C4 16.5523 4.44772 17 5 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToolbarTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11H6V9H18V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V8C22 6.34315 20.6569 5 19 5H5C3.34315 5 2 6.34315 2 8V16ZM5 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7H5C4.44772 7 4 7.44771 4 8V16C4 16.5523 4.44772 17 5 17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgToolbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 5.5H20C21.1046 5.5 22 6.39543 22 7.5V19.5C22 20.6046 21.1046 21.5 20 21.5H4C2.89543 21.5 2 20.6046 2 19.5V7.5C2 6.39543 2.89543 5.5 4 5.5H7C7 3.84315 8.34315 2.5 10 2.5H14C15.6569 2.5 17 3.84315 17 5.5ZM14 4.5H10C9.44772 4.5 9 4.94772 9 5.5H15C15 4.94772 14.5523 4.5 14 4.5ZM20 7.5H4V9.5H20V7.5ZM4 19.5V11.5H7V13.5H11V11.5H13V13.5H17V11.5H20V19.5H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTouchpad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20 21C21.6569 21 23 19.6569 23 18V6C23 4.34315 21.6569 3 20 3H4C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20ZM4 5H20C20.5523 5 21 5.44772 21 6V14H3V6C3 5.44772 3.44772 5 4 5ZM3 16V18C3 18.5523 3.44772 19 4 19H11V16H3ZM13 19V16H21V18C21 18.5523 20.5523 19 20 19H13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 3C12.5523 3 13 3.44772 13 4V5.07089C16.0657 5.5094 18.4906 7.93431 18.9291 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.9291C18.4906 16.0657 16.0657 18.4906 13 18.9291V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.9291C7.93431 18.4906 5.5094 16.0657 5.07089 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H5.07089C5.5094 7.93431 7.93431 5.5094 11 5.07089V4C11 3.44772 11.4477 3 12 3ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTranscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16C5 15.4477 5.44772 15 6 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H6C5.44772 17 5 16.5523 5 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H18Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16C16 15.4477 16.4477 15 17 15H18C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H17C16.4477 17 16 16.5523 16 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V6C23 4.34315 21.6569 3 20 3H4ZM20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44771 20.5523 5 20 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrashEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 6V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V6H4C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H17ZM15 5H9V6H15V5ZM17 8H7V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 5V4C17 2.89543 16.1046 2 15 2H9C7.89543 2 7 2.89543 7 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H5V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H17ZM15 4H9V5H15V4ZM17 7H7V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9H11V17H9V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9H15V17H13V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 17.9C8.71776 17.4367 7 15.419 7 13V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V13C17 15.419 15.2822 17.4367 13 17.9V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V17.9ZM12 4C13.6569 4 15 5.34315 15 7V13C15 14.3062 14.1652 15.4175 13 15.8293V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V15.8293C9.83481 15.4175 9 14.3062 9 13V7C9 5.34315 10.3431 4 12 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrees(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.7401 16.3185C12.035 17.1126 11.0808 17.6806 10 17.9V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V17.9C5.71776 17.4367 4 15.419 4 13V7C4 4.23858 6.23858 2 9 2C11.6087 2 13.7508 3.99781 13.9797 6.54693C14.5726 6.1993 15.2631 6 16 6C18.2091 6 20 7.79086 20 10V14C20 15.8638 18.7252 17.4299 17 17.874V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V17.874C14.0747 17.6358 13.279 17.075 12.7401 16.3185ZM12 7V13C12 14.3062 11.1652 15.4175 10 15.8293V13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13V15.8293C6.83481 15.4175 6 14.3062 6 13V7C6 5.34315 7.34315 4 9 4C10.6569 4 12 5.34315 12 7ZM17 15.7324V13C17 12.4477 16.5523 12 16 12C15.4477 12 15 12.4477 15 13V15.7324C14.4022 15.3866 14 14.7403 14 14V10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10V14C18 14.7403 17.5978 15.3866 17 15.7324Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7C6 6.44771 6.44772 6 7 6H10C10.5523 6 11 6.44772 11 7V17C11 17.5523 10.5523 18 10 18H7C6.44772 18 6 17.5523 6 17V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7C13 6.44772 13.4477 6 14 6H17C17.5523 6 18 6.44772 18 7V13C18 13.5523 17.5523 14 17 14H14C13.4477 14 13 13.5523 13 13V7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM4 4H20V20H4V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrendingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.85104 8.10628L0.436829 9.52049L7.5079 16.5916L13.8719 10.2276L18.1145 14.4702L16.3721 16.2126L23.0642 18.0058L21.2711 11.3136L19.5287 13.056L13.8719 7.39917L7.5079 13.7631L1.85104 8.10628Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41421 16.4322L0 15.018L7.07107 7.94693L13.435 14.3109L17.6777 10.0682L15.9353 8.32587L22.6274 6.53271L20.8343 13.2248L19.0919 11.4825L13.435 17.1393L7.07107 10.7754L1.41421 16.4322Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 15.9C15.2822 15.4367 17 13.419 17 11V4H7V11C7 13.419 8.71776 15.4367 11 15.9V18H9V20H15V18H13V15.9ZM9 6H15V11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6H20V11H18V6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6H4V11H6V6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 6.11861L9.4131 4.70551L11.5371 6.82954L14.3667 4L15.7782 5.41151L13.3137 7.87598H18C19.1046 7.87598 20 8.77141 20 9.87598V16.876C20 17.9805 19.1046 18.876 18 18.876H6C4.89543 18.876 4 17.9805 4 16.876V9.87598C4 8.77141 4.89543 7.87598 6 7.87598H9.75736L8 6.11861ZM18 9.87598H6V16.876H18V9.87598Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19.876H16V20.876H8V19.876Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTwilio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9C17 10.1046 16.1046 11 15 11C13.8954 11 13 10.1046 13 9C13 7.89543 13.8954 7 15 7C16.1046 7 17 7.89543 17 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17C16.1046 17 17 16.1046 17 15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15C11 16.1046 10.1046 17 9 17C7.89543 17 7 16.1046 7 15C7 13.8954 7.89543 13 9 13C10.1046 13 11 13.8954 11 15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 3C9.10457 3 10 3.89543 10 5V8H16C17.1046 8 18 8.89543 18 10C18 11.1046 17.1046 12 16 12H10V14C10 15.6569 11.3431 17 13 17H16C17.1046 17 18 17.8954 18 19C18 20.1046 17.1046 21 16 21H13C9.13401 21 6 17.866 6 14V5C6 3.89543 6.89543 3 8 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUiKit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 6H10C9.44772 6 9 6.44772 9 7V17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17V7C15 6.44772 14.5523 6 14 6ZM10 4C8.34315 4 7 5.34315 7 7V17C7 18.6569 8.34315 20 10 20H14C15.6569 20 17 18.6569 17 17V7C17 5.34315 15.6569 4 14 4H10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.45936L3.4932 7.04156C1.6646 6.73679 0 8.14692 0 10.0007V14.918C0 16.7718 1.6646 18.1819 3.4932 17.8772L6 17.4594V15.4318L3.1644 15.9044C2.55487 16.006 2 15.5359 2 14.918V10.0007C2 9.3828 2.55487 8.91276 3.1644 9.01435L6 9.48695V7.45936Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7.45936L20.5068 7.04156C22.3354 6.73679 24 8.14692 24 10.0007V14.918C24 16.7718 22.3354 18.1819 20.5068 17.8772L18 17.4594V15.4318L20.8356 15.9044C21.4451 16.006 22 15.5359 22 14.918V10.0007C22 9.3828 21.4451 8.91276 20.8356 9.01435L18 9.48695V7.45936Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9V11H13.0187V20.5C13.0187 21.8807 11.8994 23 10.5187 23C9.13797 23 8.01868 21.8807 8.01868 20.5V17.8571H10.0187V20.5C10.0187 20.7761 10.2425 21 10.5187 21C10.7948 21 11.0187 20.7761 11.0187 20.5V11H4V9ZM12 3C15.3137 3 18 5.68629 18 9H6C6 5.68629 8.68629 3 12 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUnavailable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C2.12132 14.8492 2.12132 9.15076 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.364 5.63604ZM16.1925 17.6067L6.39327 7.80749C4.33767 10.5493 4.55666 14.4562 7.05025 16.9497C9.54384 19.4433 13.4507 19.6623 16.1925 17.6067ZM16.9497 7.05025C19.4433 9.54384 19.6623 13.4507 17.6067 16.1925L7.80749 6.39327C10.5493 4.33767 14.4562 4.55666 16.9497 7.05025Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUnblock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364ZM7.80749 17.6067C10.5493 19.6623 14.4562 19.4433 16.9497 16.9497C19.4433 14.4562 19.6623 10.5493 17.6067 7.80749L14.8284 10.5858C14.4379 10.9763 13.8047 10.9763 13.4142 10.5858C13.0237 10.1953 13.0237 9.5621 13.4142 9.17157L16.1925 6.39327C13.4507 4.33767 9.54384 4.55666 7.05025 7.05025C4.55666 9.54384 4.33767 13.4507 6.39327 16.1925L9.17157 13.4142C9.5621 13.0237 10.1953 13.0237 10.5858 13.4142C10.9763 13.8047 10.9763 14.4379 10.5858 14.8284L7.80749 17.6067Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.33929 4.46777H7.33929V7.02487C8.52931 6.08978 10.0299 5.53207 11.6607 5.53207C15.5267 5.53207 18.6607 8.66608 18.6607 12.5321C18.6607 16.3981 15.5267 19.5321 11.6607 19.5321C9.51025 19.5321 7.58625 18.5623 6.30219 17.0363L7.92151 15.8515C8.83741 16.8825 10.1732 17.5321 11.6607 17.5321C14.4222 17.5321 16.6607 15.2935 16.6607 12.5321C16.6607 9.77065 14.4222 7.53207 11.6607 7.53207C10.5739 7.53207 9.56805 7.87884 8.74779 8.46777L11.3393 8.46777V10.4678H5.33929V4.46777Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUnfold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUnsplash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4.5H9V8.5H15V4.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5H9V14.5H15V10.5H20V19.5H4V10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUsbC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 12C3 9.23858 5.23858 7 8 7H16C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17H8C5.23858 17 3 14.7614 3 12ZM8 9H16C17.6569 9 19 10.3431 19 12C19 13.6569 17.6569 15 16 15H8C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4.5H11V6.5H10V4.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5H13V6.5H14V4.5Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 8.5V1.5H17V8.5H19V19.5C19 21.1569 17.6569 22.5 16 22.5H8C6.34315 22.5 5 21.1569 5 19.5V8.5H7ZM9 3.5H15V8.5H9V3.5ZM17 10.5H7V19.5C7 20.0523 7.44772 20.5 8 20.5H16C16.5523 20.5 17 20.0523 17 19.5V10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUserAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7H20V9H22V11H20V13H18V11H16V9H18V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUserList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11H16V13H22V11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15H22V17H16V15Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7H16V9H22V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUserRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9H16V11H22V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7ZM14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15C16 14.4477 15.5523 14 15 14H9C8.44772 14 8 14.4477 8 15V21H6V15C6 13.3431 7.34315 12 9 12H15C16.6569 12 18 13.3431 18 15V21H16V15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgUserlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4H21V10H15V4Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12H3Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10C7.65685 10 9 8.65685 9 7C9 5.34315 7.65685 4 6 4C4.34315 4 3 5.34315 3 7C3 8.65685 4.34315 10 6 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgVercel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.9923 17.0225L11.9806 6.97729L6.00775 17.0225H17.9923Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewCols(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM16 7H19C19.5523 7 20 7.44771 20 8V16C20 16.5523 19.5523 17 19 17H16V7ZM14 7H10V17H14V7ZM8 17V7H5C4.44772 7 4 7.44772 4 8V16C4 16.5523 4.44772 17 5 17H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewComfortable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM5 7H19C19.5523 7 20 7.44771 20 8V11H4V8C4 7.44772 4.44772 7 5 7ZM4 13V16C4 16.5523 4.44772 17 5 17H8V13H4ZM10 17H19C19.5523 17 20 16.5523 20 16V13H10V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM13 7H19C19.5523 7 20 7.44771 20 8V11H13V7ZM11 7H5C4.44772 7 4 7.44772 4 8V11H11V7ZM4 13V16C4 16.5523 4.44772 17 5 17H11V13H4ZM13 17H19C19.5523 17 20 16.5523 20 16V13H13V17Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V8C22 6.34315 20.6569 5 19 5H5ZM8 7H5C4.44772 7 4 7.44772 4 8V9H8V7ZM10 7V9H14V7H10ZM16 7V9H20V8C20 7.44771 19.5523 7 19 7H16ZM14 11H10V13H14V11ZM16 13V11H20V13H16ZM14 15H10V17H14V15ZM16 17V15H20V16C20 16.5523 19.5523 17 19 17H16ZM8 17V15H4V16C4 16.5523 4.44772 17 5 17H8ZM8 13V11H4V13H8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V8C22 6.34315 20.6569 5 19 5H5ZM7 7H5C4.44772 7 4 7.44772 4 8V9H7V7ZM9 7V9H20V8C20 7.44771 19.5523 7 19 7H9ZM7 11H4V13H7V11ZM9 13V11H20V13H9ZM7 15H4V16C4 16.5523 4.44772 17 5 17H7V15ZM9 17V15H20V16C20 16.5523 19.5523 17 19 17H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewMonth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM17 7H19C19.5523 7 20 7.44771 20 8V9H17V7ZM15 7H13V9H15V7ZM11 7H9V9H11V7ZM7 7H5C4.44772 7 4 7.44772 4 8V9H7V7ZM4 11V13H7V11H4ZM4 15V16C4 16.5523 4.44772 17 5 17H7V15H4ZM9 17H11V15H9V17ZM13 17H15V15H13V17ZM17 17H19C19.5523 17 20 16.5523 20 16V15H17V17ZM20 13V11H17V13H20ZM11 13H9V11H11V13ZM15 13H13V11H15V13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgViewSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM13 7H19C19.5523 7 20 7.44771 20 8V16C20 16.5523 19.5523 17 19 17H13V7ZM11 7H5C4.44772 7 4 7.44772 4 8V16C4 16.5523 4.44772 17 5 17H11V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgVinyl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgVoicemailO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 12C11 12.3506 10.9398 12.6872 10.8293 13H13.1707C13.0602 12.6872 13 12.3506 13 12C13 10.3431 14.3431 9 16 9C17.6569 9 19 10.3431 19 12C19 13.6569 17.6569 15 16 15H8C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12ZM17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgVoicemailR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.5 12C11.5 12.3506 11.4398 12.6872 11.3293 13H13.6707C13.5602 12.6872 13.5 12.3506 13.5 12C13.5 10.3431 14.8431 9 16.5 9C18.1569 9 19.5 10.3431 19.5 12C19.5 13.6569 18.1569 15 16.5 15H8.5C6.84315 15 5.5 13.6569 5.5 12C5.5 10.3431 6.84315 9 8.5 9C10.1569 9 11.5 10.3431 11.5 12ZM9.5 12C9.5 12.5523 9.05228 13 8.5 13C7.94772 13 7.5 12.5523 7.5 12C7.5 11.4477 7.94772 11 8.5 11C9.05228 11 9.5 11.4477 9.5 12ZM17.5 12C17.5 12.5523 17.0523 13 16.5 13C15.9477 13 15.5 12.5523 15.5 12C15.5 11.4477 15.9477 11 16.5 11C17.0523 11 17.5 11.4477 17.5 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 8C1.5 6.34315 2.84315 5 4.5 5H19.5C21.1569 5 22.5 6.34315 22.5 8V16C22.5 17.6569 21.1569 19 19.5 19H4.5C2.84315 19 1.5 17.6569 1.5 16V8ZM4.5 7H19.5C20.0523 7 20.5 7.44772 20.5 8V16C20.5 16.5523 20.0523 17 19.5 17H4.5C3.94772 17 3.5 16.5523 3.5 16V8C3.5 7.44772 3.94772 7 4.5 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.0004 15C10.6281 14.1643 11 13.1256 11 12C11 9.23858 8.76142 7 6 7C3.23858 7 1 9.23858 1 12C1 14.7614 3.23858 17 6 17H18C20.7614 17 23 14.7614 23 12C23 9.23858 20.7614 7 18 7C15.2386 7 13 9.23858 13 12C13 13.1256 13.3719 14.1643 13.9996 15H10.0004ZM6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15ZM18 15C19.6569 15 21 13.6569 21 12C21 10.3431 19.6569 9 18 9C16.3431 9 15 10.3431 15 12C15 13.6569 16.3431 15 18 15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 12C24 16.4183 20.4183 20 16 20V18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6V4C20.4183 4 24 7.58172 24 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12C20 14.2091 18.2091 16 16 16V14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10V8C18.2091 8 20 9.79086 20 12Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 16L15 20V4L9 8H5C2.79086 8 1 9.79086 1 12C1 14.2091 2.79086 16 5 16H9ZM5 10H9L13 7.5V16.5L9 14H5C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgWebcam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13 14.9C15.2822 14.4367 17 12.419 17 10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10C7 12.419 8.71776 14.4367 11 14.9V17H7V19H17V17H13V14.9ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgWebsite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 7C13.4477 7 13 7.44772 13 8V16C13 16.5523 13.4477 17 14 17H18C18.5523 17 19 16.5523 19 16V8C19 7.44772 18.5523 7 18 7H14ZM17 9H15V15H17V9Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H10C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7H6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H6Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16C5 15.4477 5.44772 15 6 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H6C5.44772 17 5 16.5523 5 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V6C23 4.34315 21.6569 3 20 3H4ZM20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5.5485L10.1954 4.58174V11.6106L3.00672 11.6651L3 5.5485ZM10.1954 12.3909V19.4957L3.00571 18.5105L3.0053 12.3909H10.1954ZM11.1134 4.45599L20.9977 3V11.5334L11.1134 11.6106V4.45599ZM21 12.505L20.9977 21L11.1134 19.6466V12.505H21Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgWorkAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 7C17 5.34315 15.6569 4 14 4H10C8.34315 4 7 5.34315 7 7H6C4.34315 7 3 8.34315 3 10V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V10C21 8.34315 19.6569 7 18 7H17ZM14 6H10C9.44772 6 9 6.44772 9 7H15C15 6.44772 14.5523 6 14 6ZM6 9H18C18.5523 9 19 9.44772 19 10V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V10C5 9.44772 5.44772 9 6 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgYinyang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.2091 20 16 18.2091 16 16C16 13.7909 14.2091 12 12 12ZM14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 7H19C19.5523 7 20 7.44771 20 8V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V8C4 7.44772 4.44772 7 5 7ZM2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8ZM10 9L14 12L10 15V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15.3431 15.2426C17.6863 12.8995 17.6863 9.1005 15.3431 6.75736C13 4.41421 9.20101 4.41421 6.85786 6.75736C4.51472 9.1005 4.51472 12.8995 6.85786 15.2426C9.20101 17.5858 13 17.5858 15.3431 15.2426ZM16.7574 5.34315C19.6425 8.22833 19.8633 12.769 17.4195 15.9075C17.4348 15.921 17.4498 15.9351 17.4645 15.9497L21.7071 20.1924C22.0976 20.5829 22.0976 21.2161 21.7071 21.6066C21.3166 21.9971 20.6834 21.9971 20.2929 21.6066L16.0503 17.364C16.0356 17.3493 16.0215 17.3343 16.008 17.319C12.8695 19.7628 8.32883 19.542 5.44365 16.6569C2.31946 13.5327 2.31946 8.46734 5.44365 5.34315C8.56785 2.21895 13.6332 2.21895 16.7574 5.34315ZM10.1005 7H12.1005V10H15.1005V12H12.1005V15H10.1005V12H7.10052V10H10.1005V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function CgZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15.3431 15.2426C17.6863 12.8995 17.6863 9.1005 15.3431 6.75736C13 4.41421 9.20101 4.41421 6.85786 6.75736C4.51472 9.1005 4.51472 12.8995 6.85786 15.2426C9.20101 17.5858 13 17.5858 15.3431 15.2426ZM16.7574 5.34315C19.6425 8.22833 19.8633 12.769 17.4195 15.9075C17.4348 15.921 17.4498 15.9351 17.4645 15.9497L21.7071 20.1924C22.0976 20.5829 22.0976 21.2161 21.7071 21.6066C21.3166 21.9971 20.6834 21.9971 20.2929 21.6066L16.0503 17.364C16.0356 17.3493 16.0215 17.3343 16.008 17.319C12.8695 19.7628 8.32883 19.542 5.44365 16.6569C2.31946 13.5327 2.31946 8.46734 5.44365 5.34315C8.56785 2.21895 13.6332 2.21895 16.7574 5.34315ZM7.10052 10V12H15.1005V10L7.10052 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}

},{"../lib":"aq338","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aq338":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsManifest = require("./iconsManifest");
parcelHelpers.exportAll(_iconsManifest, exports);
var _iconBase = require("./iconBase");
parcelHelpers.exportAll(_iconBase, exports);
var _iconContext = require("./iconContext");
parcelHelpers.exportAll(_iconContext, exports);

},{"./iconsManifest":"8rMEq","./iconBase":"hniLq","./iconContext":"5CTVS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8rMEq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsManifest", ()=>IconsManifest);
var IconsManifest = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hniLq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenIcon", ()=>GenIcon);
parcelHelpers.export(exports, "IconBase", ()=>IconBase);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconContext = require("./iconContext");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, _reactDefault.default).createElement(node.tag, __assign({
            key: i
        }, node.attr), Tree2Element(node.child));
    });
}
function GenIcon(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, _reactDefault.default).createElement(IconBase, __assign({
            attr: __assign({}, data.attr)
        }, props), Tree2Element(data.child));
    };
}
function IconBase(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, _reactDefault.default).createElement("svg", __assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: __assign(__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, _reactDefault.default).createElement("title", null, title), props.children);
    };
    return (0, _iconContext.IconContext) !== undefined ? (0, _reactDefault.default).createElement((0, _iconContext.IconContext).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, _iconContext.DefaultContext));
}

},{"react":"6uln9","./iconContext":"5CTVS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5CTVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContext", ()=>DefaultContext);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = (0, _reactDefault.default).createContext && (0, _reactDefault.default).createContext(DefaultContext);

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6CwX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e51b2dc760e3303e");
var _typeof = require("32ac2e27ff8d8dd");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("ac1e1ec585de8447"));
var _react = _interopRequireWildcard(require("ba0f15bd8f55ac8c"));
var _textarea = _interopRequireDefault(require("b158c33fc809647b"));
var _text = _interopRequireDefault(require("2958f37767057442"));
var _column = _interopRequireDefault(require("1532513a941e9ab2"));
var _row = _interopRequireDefault(require("8100504093eb4bf5"));
var _propTypes = _interopRequireDefault(require("feec9494c9dc7aa1"));
var _cg = require("af83bf747591196b");
var _useResponse2 = _interopRequireDefault(require("f54750c7c5d408cb"));
var _FeedbackConstants = require("f008b6b5954cd9d2");
var _colorStyles = _interopRequireDefault(require("b8e4f663ab30b581"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
/**
 * TextQuestion component will be used to get users suggestions.
 * @param {string} question - Question text
 * @param {number} [limit = 60] - Maximum number of words a user can enter
 * @param {string} [label = ""]
 * @param {string} [placeholder = "Enter your valuable suggestions"]
 * @param {number} [rows = 4] - Used to define width of Textarea
 * @returns Meridian Textarea Component
 */ var TextQuestion = function TextQuestion(_ref) {
    var question = _ref.question, id = _ref.id, isMandatory = _ref.isMandatory, limit = _ref.limit, label = _ref.label, placeholder = _ref.placeholder, rows = _ref.rows, prePopulatedValue = _ref.prePopulatedValue;
    var _useState = (0, _react.useState)(""), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), content = _useState2[0], setContent = _useState2[1];
    var _useState3 = (0, _react.useState)(0), _useState4 = (0, _slicedToArray2["default"])(_useState3, 2), charCount = _useState4[0], setCharCount = _useState4[1];
    var _useResponse = (0, _useResponse2["default"])(), saveFeedbackResponse = _useResponse.saveFeedbackResponse, answers = _useResponse.response.answers;
    var limitCharacters = function limitCharacters(text) {
        var response;
        var trimmedText = text === null || text === void 0 ? void 0 : text.trim();
        if (trimmedText.length === 0) {
            response = "";
            setContent(trimmedText);
        } else if ((trimmedText === null || trimmedText === void 0 ? void 0 : trimmedText.length) > limit) {
            var updatedText = trimmedText.slice(0, limit);
            setContent(updatedText);
            setCharCount(limit);
            response = updatedText;
        } else {
            setContent(text);
            setCharCount(trimmedText.length);
            response = trimmedText;
        }
        saveFeedbackResponse({
            id: id,
            answer: response
        });
    };
    (0, _react.useEffect)(function() {
        if (prePopulatedValue) limitCharacters(prePopulatedValue);
    }, [
        prePopulatedValue,
        answers.length
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_column["default"], {
        spacingInset: "xxsmall"
    }, /*#__PURE__*/ _react["default"].createElement(_text["default"], null, question, " ", isMandatory && /*#__PURE__*/ _react["default"].createElement(_cg.CgAsterisk, {
        "aria-label": "required",
        color: _colorStyles["default"].REQUIRED
    })), /*#__PURE__*/ _react["default"].createElement(_textarea["default"], {
        rows: rows,
        value: content,
        onChange: function onChange(value) {
            return limitCharacters(value);
        },
        placeholder: placeholder,
        label: label,
        disabled: Boolean(prePopulatedValue)
    }), /*#__PURE__*/ _react["default"].createElement(_row["default"], {
        alignmentHorizontal: "right",
        widths: "fit"
    }, /*#__PURE__*/ _react["default"].createElement(_text["default"], null, charCount, "/", limit)));
};
TextQuestion.propTypes = {
    question: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string.isRequired,
    isMandatory: _propTypes["default"].bool.isRequired,
    limit: _propTypes["default"].number,
    label: _propTypes["default"].string,
    placeholder: _propTypes["default"].string,
    rows: _propTypes["default"].number,
    prePopulatedValue: _propTypes["default"].string
};
TextQuestion.defaultProps = {
    limit: 60,
    label: "",
    placeholder: _FeedbackConstants.PLACEHOLDERS.textQuestion,
    rows: 4,
    prePopulatedValue: ""
};
var _default = exports["default"] = TextQuestion;

},{"e51b2dc760e3303e":"bm29M","32ac2e27ff8d8dd":"8zjpU","ac1e1ec585de8447":"8uMk6","ba0f15bd8f55ac8c":"6uln9","b158c33fc809647b":"boGbM","2958f37767057442":"6kD7p","1532513a941e9ab2":"eInK6","8100504093eb4bf5":"gNI9h","feec9494c9dc7aa1":"gJRKl","af83bf747591196b":"kvLMm","f54750c7c5d408cb":"9TPqN","f008b6b5954cd9d2":"filWO","b8e4f663ab30b581":"6qWVP"}],"boGbM":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("43c1c0087cce471d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _textarea = _interopRequireDefault(require("d5d5c207a98007a1"));
var _default = _textarea["default"];
exports["default"] = _default;

},{"43c1c0087cce471d":"fk2Bw","d5d5c207a98007a1":"dG3SG"}],"dG3SG":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("c4551510ffbb4aa0");
var _interopRequireDefault = require("929b23e5f7c23017");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("d03774d6aca5f658"));
var _defineProperty2 = _interopRequireDefault(require("f236a9cf35f04183"));
var _react = _interopRequireWildcard(require("bfdd073c6d75bb1d"));
var _propTypes = _interopRequireDefault(require("52a5a1c0b13417b2"));
var _uniqueId = _interopRequireDefault(require("88d76ddf806a9f49"));
var _noop = _interopRequireDefault(require("1cf2c0e708a6fc7a"));
var _endsWith = _interopRequireDefault(require("5cf99641bc573ad2"));
var _emotion = require("f8d2053c039c2db7");
var _input = _interopRequireDefault(require("85cea5c5f9c49c4a"));
var _theme = require("8726a243f3f237f8");
var _inputBox = _interopRequireDefault(require("a38cd25462bdd170"));
var _useFocus2 = _interopRequireDefault(require("177850d932c9fe6e"));
var _token = require("9de6a369903cbaf");
var _inputReset = _interopRequireDefault(require("7f9bc35678687b0c"));
var _filterPropsByPrefix = _interopRequireDefault(require("f149e4321c733db1"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var sizeStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var label = _ref.label;
    var insetHorizontal = t("spacingInsetHorizontal");
    var insetVertical = t("spacingInsetVerticalAuto");
    return (0, _emotion.css)({
        lineHeight: t("lineHeightAuto"),
        minHeight: t("lineHeightAuto"),
        // Clear out the padding applied by input-box (except for the top padding
        // if we have a label)
        margin: "".concat(label ? 0 : -insetVertical, "px -").concat(insetHorizontal, "px -").concat(insetVertical, "px -").concat(insetHorizontal, "px"),
        // Re-apply the input-box padding inside the textarea. This ensures that
        // the textarea resize handle fits snug in the corner of the input-box and
        // that when scrolling the textarea content can go right up to the bottom
        // of the input-box.
        padding: "".concat(label ? 0 : insetVertical, "px ").concat(insetHorizontal, "px ").concat(insetVertical, "px ").concat(insetHorizontal, "px")
    });
}, [
    "label"
]);
var textareaStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var disabled = _ref2.disabled, empty = _ref2.empty, label = _ref2.label, resize = _ref2.resize;
    return (0, _emotion.css)((0, _inputReset["default"])({
        empty: empty,
        textColor: "inherit",
        placeholderColor: t("placeholderColor", disabled ? "disabled" : "default")
    }), {
        position: resize === "auto" ? "absolute" : undefined,
        height: resize === "auto" ? "100%" : undefined,
        boxSizing: resize === "auto" ? "border-box" : undefined,
        resize: "none",
        overflow: resize === "auto" ? "hidden" : "auto",
        overflowWrap: "break-word",
        // For IE, Edge, & Safari
        wordWrap: "break-word"
    }, sizeStyles(t, {
        label: label
    }));
}, [
    "disabled",
    "empty",
    "label",
    "resize"
]);
var autoResizeContainerStyles = (0, _token.memoizeTokenStyles)(function(t, _ref3) {
    var label = _ref3.label, rows = _ref3.rows;
    return (0, _emotion.css)({
        position: "relative",
        "& > div": {
            overflowWrap: "break-word",
            // For IE, Edge, & Safari
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
            pointerEvents: "none",
            opacity: 0,
            minHeight: "".concat(parseInt(t("lineHeightAuto")) * rows, "px")
        }
    }, sizeStyles(t, {
        label: label
    }));
}, [
    "label",
    "rows"
]); // This returns a value that will ensure the component always stays in a
// controlled state. Without this the underlying textarea element might end
// up in an uncontrolled state and the DOM and the component could get out of
// sync.
var getControlledValue = function getControlledValue(value) {
    return value === null || value === undefined ? "" : value;
}; // This returns a value that, when placed in the auto resize container, will
// force the component to the exact height needed to fit the textarea without
// scrolling.
var getAutoResizeValue = function getAutoResizeValue(value) {
    return(// trailing newline, but a textarea will. To ensure that our resize
    // container matches the textarea we have to add an extra newline if the
    // value ends in a newline.
    (0, _endsWith["default"])(value, "\n") ? "".concat(value, "\n") : value);
};
var Textarea = /*#__PURE__*/ _react["default"].forwardRef(function(props, forwardedRef) {
    var disabled = props.disabled, onChange = props.onChange;
    var t = (0, _theme.useTheme)(_input["default"], "input"); // Generate a unique id that can be used to reference this element in the DOM
    var id = (0, _react.useMemo)(function() {
        return props.id || (0, _uniqueId["default"])("textarea-");
    }, [
        props.id
    ]);
    var localRef = (0, _react.useRef)();
    var value = getControlledValue(props.value);
    var empty = value === "";
    var onChangeTextarea = (0, _react.useCallback)(function(event) {
        if (!disabled) onChange(event.target.value);
    }, [
        onChange,
        disabled
    ]); // Focus on the input anytime the user mouses down on the container. This
    // mimicks the default browser behavior when a user mouses down on an input.
    var onMouseDownContainer = (0, _react.useCallback)(function(event) {
        if (localRef.current && event.target !== localRef.current) {
            event.preventDefault();
            localRef.current.focus();
        }
    }, [
        localRef
    ]); // Assign the local and prop ref (if it exists) to the target ref (textarea)
    var assignRefs = (0, _react.useCallback)(function(targetRef) {
        localRef.current = targetRef;
        if (forwardedRef) forwardedRef.current = targetRef;
    }, [
        forwardedRef
    ]);
    var _useFocus = (0, _useFocus2["default"])(props), focus = _useFocus.focus, focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    var textarea = /*#__PURE__*/ _react["default"].createElement("textarea", (0, _extends2["default"])({}, passThroughProps, focusProps, {
        className: textareaStyles(t, _objectSpread(_objectSpread({}, props), {}, {
            empty: empty
        })),
        id: id,
        name: props.name,
        ref: assignRefs,
        value: value,
        rows: props.rows,
        placeholder: props.placeholder,
        disabled: props.disabled,
        autoFocus: props.autoFocus,
        onChange: onChangeTextarea,
        wrap: "on",
        autoComplete: props.autoFill ? undefined : "off"
    }));
    return /*#__PURE__*/ _react["default"].createElement(_inputBox["default"], {
        size: "auto",
        label: props.label,
        error: props.error,
        disabled: props.disabled,
        focus: focus,
        empty: empty,
        width: props.width,
        onMouseDown: onMouseDownContainer,
        htmlFor: id,
        cursor: "text"
    }, props.resize === "auto" ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: autoResizeContainerStyles(t, props)
    }, textarea, /*#__PURE__*/ _react["default"].createElement("div", null, getAutoResizeValue(value))) : textarea);
});
Textarea.displayName = "Textarea";
Textarea.propTypes = {};
Textarea.defaultProps = {
    resize: "auto",
    rows: 2,
    onFocus: _noop["default"],
    onBlur: _noop["default"],
    autoFill: true
};
var _default = Textarea;
exports["default"] = _default;

},{"c4551510ffbb4aa0":"k8mdG","929b23e5f7c23017":"fk2Bw","d03774d6aca5f658":"ef0K4","f236a9cf35f04183":"hcG56","bfdd073c6d75bb1d":"6uln9","52a5a1c0b13417b2":"cnMFu","88d76ddf806a9f49":"4yTHb","1cf2c0e708a6fc7a":"7osqO","5cf99641bc573ad2":"bs9LU","f8d2053c039c2db7":"4deck","85cea5c5f9c49c4a":"gtfqn","8726a243f3f237f8":"eM9hO","a38cd25462bdd170":"6Pkby","177850d932c9fe6e":"ZdEsX","9de6a369903cbaf":"atHRo","7f9bc35678687b0c":"20xFV","f149e4321c733db1":"8cR2N"}],"bs9LU":[function(require,module,exports) {
var baseClamp = require("a2994053d311d749"), baseToString = require("24e8a2518a12d38b"), toInteger = require("118c6d232fd6854a"), toString = require("467ca4b1c0032465");
/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function endsWith(string, target, position) {
    string = toString(string);
    target = baseToString(target);
    var length = string.length;
    position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
module.exports = endsWith;

},{"a2994053d311d749":"lUGcC","24e8a2518a12d38b":"2OjPX","118c6d232fd6854a":"9irPk","467ca4b1c0032465":"bI8Cb"}],"lUGcC":[function(require,module,exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = baseClamp;

},{}],"gNI9h":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b6a1c02a6afa1d27");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _row = _interopRequireDefault(require("982e8a0dfc031078"));
var _default = _row["default"];
exports["default"] = _default;

},{"b6a1c02a6afa1d27":"fk2Bw","982e8a0dfc031078":"2jevO"}],"2jevO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("377f8560309a46ba");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.gridColumns = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("a7573d6ebf9b1818"));
var _react = _interopRequireDefault(require("616e63432f3e327c"));
var _propTypes = _interopRequireDefault(require("dbe59e62dc2ae07e"));
var _emotion = require("89ab258ed5817860");
var _box = _interopRequireDefault(require("79544c922f89a70e"));
var _propTypes2 = _interopRequireDefault(require("7a9da0d5dfa022ec"));
var _parsers = require("ddb65ea03d758b6e");
var _functional = require("c1891298abfbbcbc");
var _cxMemoized = _interopRequireDefault(require("1396fc693eb34098"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var gridColumns = 12; // Turns a raw width value (a string or number) into an object with fields
// containing the type of width and the parsed width values
exports.gridColumns = gridColumns;
var parseWidth = function parseWidth(width) {
    return typeof width === "string" && /^grid-/.test(width) ? {
        type: "grid",
        // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
        // "grid-4" to 0.3333)
        value: Math.floor(10000 * parseInt(width.substr(5)) / gridColumns) / 10000
    } : typeof width === "string" && /^[0-9.]+%\s*$/.test(width) ? {
        type: "percentage",
        // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
        // to 0.3333)
        value: Math.floor(100 * parseFloat(width)) / 10000
    } : width === "fit" || width === "fill" ? {
        type: "flex",
        value: width
    } : width !== undefined && width !== null && width !== "" ? {
        type: "css",
        value: width
    } : {
        type: "empty",
        value: null
    };
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)
var wrapContainerStyles = (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch"
});
var rowStyles = function rowStyles(widths) {
    return (0, _functional.memoizeByKeys)(function(_ref) {
        var wrap = _ref.wrap, spacing = _ref.spacing, alignmentHorizontal = _ref.alignmentHorizontal, alignmentVertical = _ref.alignmentVertical, reverse = _ref.reverse;
        var spacingValues = (0, _parsers.parseSpacing)(spacing);
        var verticalSpacing = spacingValues[0];
        var horizontalSpacing = spacingValues[1] || verticalSpacing;
        return (0, _emotion.css)((0, _defineProperty2["default"])({
            width: wrap === "none" ? undefined : "calc(100% + ".concat(horizontalSpacing, "px)"),
            display: "flex",
            flexDirection: reverse ? "row-reverse" : "row",
            flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
            alignItems: {
                top: "flex-start",
                bottom: "flex-end"
            }[alignmentVertical] || alignmentVertical,
            justifyContent: {
                left: "flex-start",
                right: "flex-end",
                justify: "space-between"
            }[alignmentHorizontal] || alignmentHorizontal,
            // Reset the extra margins caused by the children on the right/bottom
            // edges. We can't do a simple reset on the first/last child because
            // there may be any number of children on the right/bottom edges if the
            // row wraps.
            margin: wrap === "none" ? undefined : "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0"),
            // Set margins and widths on the children of the row. Use !important to
            // override any existing styles.
            "& > *": {
                // Make sure that any borders or padding applied to the child don't throw
                // of the widths that we apply
                boxSizing: "border-box !important",
                // Set margins for horizontal spacing and vertical spacing if the row is
                // allowed to wrap (and clear other margins)
                margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
            }
        }, "& > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
            marginRight: "0 !important"
        } : undefined), // index in the dom matches the widths's index in the array. If we've
        // got a single height, apply that to all children.
        Array.isArray(widths) ? widths.reduce(function(result, width, index) {
            result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
                width: width,
                wrap: wrap,
                horizontalSpacing: horizontalSpacing
            });
            return result;
        }, {}) : {
            "& > *": childStyles({
                width: widths,
                wrap: wrap,
                horizontalSpacing: horizontalSpacing
            })
        });
    }, [
        "wrap",
        "spacing",
        "alignmentHorizontal",
        "alignmentVertical",
        "reverse"
    ]);
};
var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);
var childStyles = function childStyles(_ref2) {
    var rawWidth = _ref2.width, wrap = _ref2.wrap, horizontalSpacing = _ref2.horizontalSpacing;
    var width = parseWidth(rawWidth);
    return {
        // Stretch the child to fill remaining space if the width is "fill"
        flex: width.type === "flex" && width.value === "fill" ? "1 !important" : undefined,
        // Ensure that the child isn't smashed by flexbox if it has an explicit
        // width set.
        flexShrink: width.type === "grid" || width.type === "percentage" || width.type === "flex" && width.value === "fit" || width.type === "css" && width.value !== "auto" ? "0 !important" : undefined,
        width: width.type === "grid" || width.type === "percentage" ? // specified percentage of the row's width (e.g. 50%) but subtract the
        // gutter spacing from the width to ensure there's enough room for the
        // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
        // subtract the full gutter width since each element has a full gutter
        // to its right (the extra gutter on the right edge of the row is
        // removed with a negative margin on the parent element). For rows
        // that don't wrap the last element doesn't have a gutter to its
        // right, so things are a bit more complicated. In this case there's
        // one less gutter than there are elements in the row (e.g. 3 elements
        // have 2 gutters between them) so subtracting a full gutter from each
        // element's width would be too much. We have to spread out this saved
        // saved gutter space proportional to the percentage of the row that
        // the element takes up. For example if a row has two elements that
        // each take up 50% of the row with a single 16px gutter between them,
        // then we'd subtract 50% of the 16px gutter from each element giving
        // us a final width of 50% - 8px for each element.
        "calc(".concat(width.value * 100, "% - ").concat(horizontalSpacing - (wrap === "none" ? width.value * horizontalSpacing : 0), "px) !important") : width.type === "css" ? "".concat(width.value).concat(typeof width.value === "number" ? "px" : "", " !important") : undefined
    };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */ var Row = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    // A row with an explicit height cannot wrap
    var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array or scalar
    // for the "widths" property
    var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
    var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
        wrap: wrap
    })); // Apply the row styles to an extra div inside the box so margins that are
    // applied to the box (e.g. if the row is nested in another row) don't
    // conflict with the margins that are applied by `rowStyles`.
    return /*#__PURE__*/ _react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
        className: wrap === "none" ? (0, _cxMemoized["default"])(rowStyles, props.className) : (0, _cxMemoized["default"])(wrapContainerStyles, props.className),
        ref: ref
    }), wrap === "none" ? props.children : /*#__PURE__*/ _react["default"].createElement("div", {
        className: rowStyles
    }, props.children));
});
Row.displayName = "Row";
Row.propTypes = {};
Row.defaultProps = {
    wrap: "none",
    spacing: "medium",
    alignmentVertical: "center",
    alignmentHorizontal: "left"
};
var _default = Row;
exports["default"] = _default;

},{"377f8560309a46ba":"fk2Bw","a7573d6ebf9b1818":"hcG56","616e63432f3e327c":"6uln9","dbe59e62dc2ae07e":"cnMFu","89ab258ed5817860":"4deck","79544c922f89a70e":"4oeXM","7a9da0d5dfa022ec":"ihBLX","ddb65ea03d758b6e":"aSMp2","c1891298abfbbcbc":"eKpY2","1396fc693eb34098":"6U7id"}],"jpUxc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.QuestionTypes = void 0;
var QuestionTypes = exports.QuestionTypes = Object.freeze({
    MULTIPLE_CHOICE_QUESTION: "multipleChoiceQuestionType",
    RATING_QUESTION: "ratingQuestionType",
    TEXT_QUESTION: "textQuestionType"
});
var _default = exports["default"] = QuestionTypes;

},{}],"fcOXW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("691827308e79f695");
var _typeof = require("6ff88e0dc84f23");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("ed26a274d71f403f"));
var _slicedToArray2 = _interopRequireDefault(require("d2863934666f13a"));
var _react = _interopRequireWildcard(require("7e33c088787b28b0"));
var _row = _interopRequireDefault(require("3fdb03cc1b038b42"));
var _column = _interopRequireDefault(require("9904e93def6f8844"));
var _propTypes = _interopRequireDefault(require("9def3655fc659d27"));
var _im = require("c56b8a495ecbccca");
var _css = require("def990c015d04b03");
var _colorStyles = _interopRequireDefault(require("dfe098d3f09c083f"));
var _useResponse2 = _interopRequireDefault(require("9f813b24614045c8"));
var _getRatings = _interopRequireDefault(require("7f88e4214a9d81cd"));
var _Question = _interopRequireDefault(require("85406a3f1aa13845"));
var _templateObject, _templateObject2;
/* eslint-disable jsx-a11y/label-has-for */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable import/no-extraneous-dependencies */ function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var StarRating = function StarRating(_ref) {
    var question = _ref.question, responseForQuestion = _ref.responseForQuestion, id = _ref.id, isMandatory = _ref.isMandatory, minRatingValue = _ref.minRatingValue, ratingInterval = _ref.ratingInterval, questionTextFormat = _ref.questionTextFormat, numberOfIntervals = _ref.numberOfIntervals;
    var ratingAnswer = responseForQuestion.answer;
    var _useState = (0, _react.useState)(ratingAnswer), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), rating = _useState2[0], setRating = _useState2[1];
    var _useState3 = (0, _react.useState)(null), _useState4 = (0, _slicedToArray2["default"])(_useState3, 2), hoveredRating = _useState4[0], setHoveredRating = _useState4[1];
    var _useResponse = (0, _useResponse2["default"])(), saveFeedbackResponse = _useResponse.saveFeedbackResponse;
    var onClickHandler = function onClickHandler(value) {
        setRating(value);
        saveFeedbackResponse({
            id: id,
            answer: value
        });
    };
    var ratings = (0, _getRatings["default"])(minRatingValue, ratingInterval, numberOfIntervals);
    var setColour = function setColour(colorValue, ratingValue) {
        return rating >= ratingValue || hoveredRating >= ratingValue ? colorValue : _colorStyles["default"].DEFAULT;
    };
    return /*#__PURE__*/ _react["default"].createElement(_column["default"], {
        spacingInset: "xxsmall"
    }, /*#__PURE__*/ _react["default"].createElement(_Question["default"], {
        questionTextFormat: questionTextFormat,
        question: question,
        isMandatory: isMandatory
    }), /*#__PURE__*/ _react["default"].createElement(_row["default"], null, ratings.map(function(ratingVal) {
        return /*#__PURE__*/ _react["default"].createElement("label", {
            className: (0, _css.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([
                "\n              & > svg {\n                transition: color 0.5s ease-in-out;\n              }\n              &:hover {\n                transform: scale(1.5);\n                transition: all 0.2s ease-in-out;\n              }\n            "
            ])))
        }, /*#__PURE__*/ _react["default"].createElement("input", {
            type: "radio",
            onClick: function onClick() {
                return onClickHandler(ratingVal);
            },
            className: (0, _css.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])([
                "\n                & {\n                  display: none;\n                }\n              "
            ])))
        }), /*#__PURE__*/ _react["default"].createElement(_im.ImStarFull, {
            "aria-label": "star".concat(ratingVal),
            size: 50,
            color: setColour(_colorStyles["default"].STAR, ratingVal),
            onMouseEnter: function onMouseEnter() {
                return setHoveredRating(ratingVal);
            },
            onMouseLeave: function onMouseLeave() {
                return setHoveredRating(null);
            },
            style: {
                cursor: "pointer"
            }
        }));
    })));
};
StarRating.propTypes = {
    question: _propTypes["default"].string.isRequired,
    responseForQuestion: _propTypes["default"].object,
    id: _propTypes["default"].string.isRequired,
    isMandatory: _propTypes["default"].bool.isRequired,
    minRatingValue: _propTypes["default"].number,
    ratingInterval: _propTypes["default"].number,
    questionTextFormat: _propTypes["default"].string,
    numberOfIntervals: _propTypes["default"].number
};
StarRating.defaultProps = {
    minRatingValue: 1,
    responseForQuestion: {
        answer: null
    },
    ratingInterval: 1,
    questionTextFormat: "",
    numberOfIntervals: 5
};
var _default = exports["default"] = StarRating;

},{"691827308e79f695":"bm29M","6ff88e0dc84f23":"8zjpU","ed26a274d71f403f":"g2UEf","d2863934666f13a":"8uMk6","7e33c088787b28b0":"6uln9","3fdb03cc1b038b42":"gNI9h","9904e93def6f8844":"eInK6","9def3655fc659d27":"gJRKl","c56b8a495ecbccca":"5WAAl","def990c015d04b03":"awUBr","dfe098d3f09c083f":"6qWVP","9f813b24614045c8":"9TPqN","7f88e4214a9d81cd":"bnUVV","85406a3f1aa13845":"7fVae"}],"g2UEf":[function(require,module,exports) {
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5WAAl":[function(require,module,exports) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImHome", ()=>ImHome);
parcelHelpers.export(exports, "ImHome2", ()=>ImHome2);
parcelHelpers.export(exports, "ImHome3", ()=>ImHome3);
parcelHelpers.export(exports, "ImOffice", ()=>ImOffice);
parcelHelpers.export(exports, "ImNewspaper", ()=>ImNewspaper);
parcelHelpers.export(exports, "ImPencil", ()=>ImPencil);
parcelHelpers.export(exports, "ImPencil2", ()=>ImPencil2);
parcelHelpers.export(exports, "ImQuill", ()=>ImQuill);
parcelHelpers.export(exports, "ImPen", ()=>ImPen);
parcelHelpers.export(exports, "ImBlog", ()=>ImBlog);
parcelHelpers.export(exports, "ImEyedropper", ()=>ImEyedropper);
parcelHelpers.export(exports, "ImDroplet", ()=>ImDroplet);
parcelHelpers.export(exports, "ImPaintFormat", ()=>ImPaintFormat);
parcelHelpers.export(exports, "ImImage", ()=>ImImage);
parcelHelpers.export(exports, "ImImages", ()=>ImImages);
parcelHelpers.export(exports, "ImCamera", ()=>ImCamera);
parcelHelpers.export(exports, "ImHeadphones", ()=>ImHeadphones);
parcelHelpers.export(exports, "ImMusic", ()=>ImMusic);
parcelHelpers.export(exports, "ImPlay", ()=>ImPlay);
parcelHelpers.export(exports, "ImFilm", ()=>ImFilm);
parcelHelpers.export(exports, "ImVideoCamera", ()=>ImVideoCamera);
parcelHelpers.export(exports, "ImDice", ()=>ImDice);
parcelHelpers.export(exports, "ImPacman", ()=>ImPacman);
parcelHelpers.export(exports, "ImSpades", ()=>ImSpades);
parcelHelpers.export(exports, "ImClubs", ()=>ImClubs);
parcelHelpers.export(exports, "ImDiamonds", ()=>ImDiamonds);
parcelHelpers.export(exports, "ImBullhorn", ()=>ImBullhorn);
parcelHelpers.export(exports, "ImConnection", ()=>ImConnection);
parcelHelpers.export(exports, "ImPodcast", ()=>ImPodcast);
parcelHelpers.export(exports, "ImFeed", ()=>ImFeed);
parcelHelpers.export(exports, "ImMic", ()=>ImMic);
parcelHelpers.export(exports, "ImBook", ()=>ImBook);
parcelHelpers.export(exports, "ImBooks", ()=>ImBooks);
parcelHelpers.export(exports, "ImLibrary", ()=>ImLibrary);
parcelHelpers.export(exports, "ImFileText", ()=>ImFileText);
parcelHelpers.export(exports, "ImProfile", ()=>ImProfile);
parcelHelpers.export(exports, "ImFileEmpty", ()=>ImFileEmpty);
parcelHelpers.export(exports, "ImFilesEmpty", ()=>ImFilesEmpty);
parcelHelpers.export(exports, "ImFileText2", ()=>ImFileText2);
parcelHelpers.export(exports, "ImFilePicture", ()=>ImFilePicture);
parcelHelpers.export(exports, "ImFileMusic", ()=>ImFileMusic);
parcelHelpers.export(exports, "ImFilePlay", ()=>ImFilePlay);
parcelHelpers.export(exports, "ImFileVideo", ()=>ImFileVideo);
parcelHelpers.export(exports, "ImFileZip", ()=>ImFileZip);
parcelHelpers.export(exports, "ImCopy", ()=>ImCopy);
parcelHelpers.export(exports, "ImPaste", ()=>ImPaste);
parcelHelpers.export(exports, "ImStack", ()=>ImStack);
parcelHelpers.export(exports, "ImFolder", ()=>ImFolder);
parcelHelpers.export(exports, "ImFolderOpen", ()=>ImFolderOpen);
parcelHelpers.export(exports, "ImFolderPlus", ()=>ImFolderPlus);
parcelHelpers.export(exports, "ImFolderMinus", ()=>ImFolderMinus);
parcelHelpers.export(exports, "ImFolderDownload", ()=>ImFolderDownload);
parcelHelpers.export(exports, "ImFolderUpload", ()=>ImFolderUpload);
parcelHelpers.export(exports, "ImPriceTag", ()=>ImPriceTag);
parcelHelpers.export(exports, "ImPriceTags", ()=>ImPriceTags);
parcelHelpers.export(exports, "ImBarcode", ()=>ImBarcode);
parcelHelpers.export(exports, "ImQrcode", ()=>ImQrcode);
parcelHelpers.export(exports, "ImTicket", ()=>ImTicket);
parcelHelpers.export(exports, "ImCart", ()=>ImCart);
parcelHelpers.export(exports, "ImCoinDollar", ()=>ImCoinDollar);
parcelHelpers.export(exports, "ImCoinEuro", ()=>ImCoinEuro);
parcelHelpers.export(exports, "ImCoinPound", ()=>ImCoinPound);
parcelHelpers.export(exports, "ImCoinYen", ()=>ImCoinYen);
parcelHelpers.export(exports, "ImCreditCard", ()=>ImCreditCard);
parcelHelpers.export(exports, "ImCalculator", ()=>ImCalculator);
parcelHelpers.export(exports, "ImLifebuoy", ()=>ImLifebuoy);
parcelHelpers.export(exports, "ImPhone", ()=>ImPhone);
parcelHelpers.export(exports, "ImPhoneHangUp", ()=>ImPhoneHangUp);
parcelHelpers.export(exports, "ImAddressBook", ()=>ImAddressBook);
parcelHelpers.export(exports, "ImEnvelop", ()=>ImEnvelop);
parcelHelpers.export(exports, "ImPushpin", ()=>ImPushpin);
parcelHelpers.export(exports, "ImLocation", ()=>ImLocation);
parcelHelpers.export(exports, "ImLocation2", ()=>ImLocation2);
parcelHelpers.export(exports, "ImCompass", ()=>ImCompass);
parcelHelpers.export(exports, "ImCompass2", ()=>ImCompass2);
parcelHelpers.export(exports, "ImMap", ()=>ImMap);
parcelHelpers.export(exports, "ImMap2", ()=>ImMap2);
parcelHelpers.export(exports, "ImHistory", ()=>ImHistory);
parcelHelpers.export(exports, "ImClock", ()=>ImClock);
parcelHelpers.export(exports, "ImClock2", ()=>ImClock2);
parcelHelpers.export(exports, "ImAlarm", ()=>ImAlarm);
parcelHelpers.export(exports, "ImBell", ()=>ImBell);
parcelHelpers.export(exports, "ImStopwatch", ()=>ImStopwatch);
parcelHelpers.export(exports, "ImCalendar", ()=>ImCalendar);
parcelHelpers.export(exports, "ImPrinter", ()=>ImPrinter);
parcelHelpers.export(exports, "ImKeyboard", ()=>ImKeyboard);
parcelHelpers.export(exports, "ImDisplay", ()=>ImDisplay);
parcelHelpers.export(exports, "ImLaptop", ()=>ImLaptop);
parcelHelpers.export(exports, "ImMobile", ()=>ImMobile);
parcelHelpers.export(exports, "ImMobile2", ()=>ImMobile2);
parcelHelpers.export(exports, "ImTablet", ()=>ImTablet);
parcelHelpers.export(exports, "ImTv", ()=>ImTv);
parcelHelpers.export(exports, "ImDrawer", ()=>ImDrawer);
parcelHelpers.export(exports, "ImDrawer2", ()=>ImDrawer2);
parcelHelpers.export(exports, "ImBoxAdd", ()=>ImBoxAdd);
parcelHelpers.export(exports, "ImBoxRemove", ()=>ImBoxRemove);
parcelHelpers.export(exports, "ImDownload", ()=>ImDownload);
parcelHelpers.export(exports, "ImUpload", ()=>ImUpload);
parcelHelpers.export(exports, "ImFloppyDisk", ()=>ImFloppyDisk);
parcelHelpers.export(exports, "ImDrive", ()=>ImDrive);
parcelHelpers.export(exports, "ImDatabase", ()=>ImDatabase);
parcelHelpers.export(exports, "ImUndo", ()=>ImUndo);
parcelHelpers.export(exports, "ImRedo", ()=>ImRedo);
parcelHelpers.export(exports, "ImUndo2", ()=>ImUndo2);
parcelHelpers.export(exports, "ImRedo2", ()=>ImRedo2);
parcelHelpers.export(exports, "ImForward", ()=>ImForward);
parcelHelpers.export(exports, "ImReply", ()=>ImReply);
parcelHelpers.export(exports, "ImBubble", ()=>ImBubble);
parcelHelpers.export(exports, "ImBubbles", ()=>ImBubbles);
parcelHelpers.export(exports, "ImBubbles2", ()=>ImBubbles2);
parcelHelpers.export(exports, "ImBubble2", ()=>ImBubble2);
parcelHelpers.export(exports, "ImBubbles3", ()=>ImBubbles3);
parcelHelpers.export(exports, "ImBubbles4", ()=>ImBubbles4);
parcelHelpers.export(exports, "ImUser", ()=>ImUser);
parcelHelpers.export(exports, "ImUsers", ()=>ImUsers);
parcelHelpers.export(exports, "ImUserPlus", ()=>ImUserPlus);
parcelHelpers.export(exports, "ImUserMinus", ()=>ImUserMinus);
parcelHelpers.export(exports, "ImUserCheck", ()=>ImUserCheck);
parcelHelpers.export(exports, "ImUserTie", ()=>ImUserTie);
parcelHelpers.export(exports, "ImQuotesLeft", ()=>ImQuotesLeft);
parcelHelpers.export(exports, "ImQuotesRight", ()=>ImQuotesRight);
parcelHelpers.export(exports, "ImHourGlass", ()=>ImHourGlass);
parcelHelpers.export(exports, "ImSpinner", ()=>ImSpinner);
parcelHelpers.export(exports, "ImSpinner2", ()=>ImSpinner2);
parcelHelpers.export(exports, "ImSpinner3", ()=>ImSpinner3);
parcelHelpers.export(exports, "ImSpinner4", ()=>ImSpinner4);
parcelHelpers.export(exports, "ImSpinner5", ()=>ImSpinner5);
parcelHelpers.export(exports, "ImSpinner6", ()=>ImSpinner6);
parcelHelpers.export(exports, "ImSpinner7", ()=>ImSpinner7);
parcelHelpers.export(exports, "ImSpinner8", ()=>ImSpinner8);
parcelHelpers.export(exports, "ImSpinner9", ()=>ImSpinner9);
parcelHelpers.export(exports, "ImSpinner10", ()=>ImSpinner10);
parcelHelpers.export(exports, "ImSpinner11", ()=>ImSpinner11);
parcelHelpers.export(exports, "ImBinoculars", ()=>ImBinoculars);
parcelHelpers.export(exports, "ImSearch", ()=>ImSearch);
parcelHelpers.export(exports, "ImZoomIn", ()=>ImZoomIn);
parcelHelpers.export(exports, "ImZoomOut", ()=>ImZoomOut);
parcelHelpers.export(exports, "ImEnlarge", ()=>ImEnlarge);
parcelHelpers.export(exports, "ImShrink", ()=>ImShrink);
parcelHelpers.export(exports, "ImEnlarge2", ()=>ImEnlarge2);
parcelHelpers.export(exports, "ImShrink2", ()=>ImShrink2);
parcelHelpers.export(exports, "ImKey", ()=>ImKey);
parcelHelpers.export(exports, "ImKey2", ()=>ImKey2);
parcelHelpers.export(exports, "ImLock", ()=>ImLock);
parcelHelpers.export(exports, "ImUnlocked", ()=>ImUnlocked);
parcelHelpers.export(exports, "ImWrench", ()=>ImWrench);
parcelHelpers.export(exports, "ImEqualizer", ()=>ImEqualizer);
parcelHelpers.export(exports, "ImEqualizer2", ()=>ImEqualizer2);
parcelHelpers.export(exports, "ImCog", ()=>ImCog);
parcelHelpers.export(exports, "ImCogs", ()=>ImCogs);
parcelHelpers.export(exports, "ImHammer", ()=>ImHammer);
parcelHelpers.export(exports, "ImMagicWand", ()=>ImMagicWand);
parcelHelpers.export(exports, "ImAidKit", ()=>ImAidKit);
parcelHelpers.export(exports, "ImBug", ()=>ImBug);
parcelHelpers.export(exports, "ImPieChart", ()=>ImPieChart);
parcelHelpers.export(exports, "ImStatsDots", ()=>ImStatsDots);
parcelHelpers.export(exports, "ImStatsBars", ()=>ImStatsBars);
parcelHelpers.export(exports, "ImStatsBars2", ()=>ImStatsBars2);
parcelHelpers.export(exports, "ImTrophy", ()=>ImTrophy);
parcelHelpers.export(exports, "ImGift", ()=>ImGift);
parcelHelpers.export(exports, "ImGlass", ()=>ImGlass);
parcelHelpers.export(exports, "ImGlass2", ()=>ImGlass2);
parcelHelpers.export(exports, "ImMug", ()=>ImMug);
parcelHelpers.export(exports, "ImSpoonKnife", ()=>ImSpoonKnife);
parcelHelpers.export(exports, "ImLeaf", ()=>ImLeaf);
parcelHelpers.export(exports, "ImRocket", ()=>ImRocket);
parcelHelpers.export(exports, "ImMeter", ()=>ImMeter);
parcelHelpers.export(exports, "ImMeter2", ()=>ImMeter2);
parcelHelpers.export(exports, "ImHammer2", ()=>ImHammer2);
parcelHelpers.export(exports, "ImFire", ()=>ImFire);
parcelHelpers.export(exports, "ImLab", ()=>ImLab);
parcelHelpers.export(exports, "ImMagnet", ()=>ImMagnet);
parcelHelpers.export(exports, "ImBin", ()=>ImBin);
parcelHelpers.export(exports, "ImBin2", ()=>ImBin2);
parcelHelpers.export(exports, "ImBriefcase", ()=>ImBriefcase);
parcelHelpers.export(exports, "ImAirplane", ()=>ImAirplane);
parcelHelpers.export(exports, "ImTruck", ()=>ImTruck);
parcelHelpers.export(exports, "ImRoad", ()=>ImRoad);
parcelHelpers.export(exports, "ImAccessibility", ()=>ImAccessibility);
parcelHelpers.export(exports, "ImTarget", ()=>ImTarget);
parcelHelpers.export(exports, "ImShield", ()=>ImShield);
parcelHelpers.export(exports, "ImPower", ()=>ImPower);
parcelHelpers.export(exports, "ImSwitch", ()=>ImSwitch);
parcelHelpers.export(exports, "ImPowerCord", ()=>ImPowerCord);
parcelHelpers.export(exports, "ImClipboard", ()=>ImClipboard);
parcelHelpers.export(exports, "ImListNumbered", ()=>ImListNumbered);
parcelHelpers.export(exports, "ImList", ()=>ImList);
parcelHelpers.export(exports, "ImList2", ()=>ImList2);
parcelHelpers.export(exports, "ImTree", ()=>ImTree);
parcelHelpers.export(exports, "ImMenu", ()=>ImMenu);
parcelHelpers.export(exports, "ImMenu2", ()=>ImMenu2);
parcelHelpers.export(exports, "ImMenu3", ()=>ImMenu3);
parcelHelpers.export(exports, "ImMenu4", ()=>ImMenu4);
parcelHelpers.export(exports, "ImCloud", ()=>ImCloud);
parcelHelpers.export(exports, "ImCloudDownload", ()=>ImCloudDownload);
parcelHelpers.export(exports, "ImCloudUpload", ()=>ImCloudUpload);
parcelHelpers.export(exports, "ImCloudCheck", ()=>ImCloudCheck);
parcelHelpers.export(exports, "ImDownload2", ()=>ImDownload2);
parcelHelpers.export(exports, "ImUpload2", ()=>ImUpload2);
parcelHelpers.export(exports, "ImDownload3", ()=>ImDownload3);
parcelHelpers.export(exports, "ImUpload3", ()=>ImUpload3);
parcelHelpers.export(exports, "ImSphere", ()=>ImSphere);
parcelHelpers.export(exports, "ImEarth", ()=>ImEarth);
parcelHelpers.export(exports, "ImLink", ()=>ImLink);
parcelHelpers.export(exports, "ImFlag", ()=>ImFlag);
parcelHelpers.export(exports, "ImAttachment", ()=>ImAttachment);
parcelHelpers.export(exports, "ImEye", ()=>ImEye);
parcelHelpers.export(exports, "ImEyePlus", ()=>ImEyePlus);
parcelHelpers.export(exports, "ImEyeMinus", ()=>ImEyeMinus);
parcelHelpers.export(exports, "ImEyeBlocked", ()=>ImEyeBlocked);
parcelHelpers.export(exports, "ImBookmark", ()=>ImBookmark);
parcelHelpers.export(exports, "ImBookmarks", ()=>ImBookmarks);
parcelHelpers.export(exports, "ImSun", ()=>ImSun);
parcelHelpers.export(exports, "ImContrast", ()=>ImContrast);
parcelHelpers.export(exports, "ImBrightnessContrast", ()=>ImBrightnessContrast);
parcelHelpers.export(exports, "ImStarEmpty", ()=>ImStarEmpty);
parcelHelpers.export(exports, "ImStarHalf", ()=>ImStarHalf);
parcelHelpers.export(exports, "ImStarFull", ()=>ImStarFull);
parcelHelpers.export(exports, "ImHeart", ()=>ImHeart);
parcelHelpers.export(exports, "ImHeartBroken", ()=>ImHeartBroken);
parcelHelpers.export(exports, "ImMan", ()=>ImMan);
parcelHelpers.export(exports, "ImWoman", ()=>ImWoman);
parcelHelpers.export(exports, "ImManWoman", ()=>ImManWoman);
parcelHelpers.export(exports, "ImHappy", ()=>ImHappy);
parcelHelpers.export(exports, "ImHappy2", ()=>ImHappy2);
parcelHelpers.export(exports, "ImSmile", ()=>ImSmile);
parcelHelpers.export(exports, "ImSmile2", ()=>ImSmile2);
parcelHelpers.export(exports, "ImTongue", ()=>ImTongue);
parcelHelpers.export(exports, "ImTongue2", ()=>ImTongue2);
parcelHelpers.export(exports, "ImSad", ()=>ImSad);
parcelHelpers.export(exports, "ImSad2", ()=>ImSad2);
parcelHelpers.export(exports, "ImWink", ()=>ImWink);
parcelHelpers.export(exports, "ImWink2", ()=>ImWink2);
parcelHelpers.export(exports, "ImGrin", ()=>ImGrin);
parcelHelpers.export(exports, "ImGrin2", ()=>ImGrin2);
parcelHelpers.export(exports, "ImCool", ()=>ImCool);
parcelHelpers.export(exports, "ImCool2", ()=>ImCool2);
parcelHelpers.export(exports, "ImAngry", ()=>ImAngry);
parcelHelpers.export(exports, "ImAngry2", ()=>ImAngry2);
parcelHelpers.export(exports, "ImEvil", ()=>ImEvil);
parcelHelpers.export(exports, "ImEvil2", ()=>ImEvil2);
parcelHelpers.export(exports, "ImShocked", ()=>ImShocked);
parcelHelpers.export(exports, "ImShocked2", ()=>ImShocked2);
parcelHelpers.export(exports, "ImBaffled", ()=>ImBaffled);
parcelHelpers.export(exports, "ImBaffled2", ()=>ImBaffled2);
parcelHelpers.export(exports, "ImConfused", ()=>ImConfused);
parcelHelpers.export(exports, "ImConfused2", ()=>ImConfused2);
parcelHelpers.export(exports, "ImNeutral", ()=>ImNeutral);
parcelHelpers.export(exports, "ImNeutral2", ()=>ImNeutral2);
parcelHelpers.export(exports, "ImHipster", ()=>ImHipster);
parcelHelpers.export(exports, "ImHipster2", ()=>ImHipster2);
parcelHelpers.export(exports, "ImWondering", ()=>ImWondering);
parcelHelpers.export(exports, "ImWondering2", ()=>ImWondering2);
parcelHelpers.export(exports, "ImSleepy", ()=>ImSleepy);
parcelHelpers.export(exports, "ImSleepy2", ()=>ImSleepy2);
parcelHelpers.export(exports, "ImFrustrated", ()=>ImFrustrated);
parcelHelpers.export(exports, "ImFrustrated2", ()=>ImFrustrated2);
parcelHelpers.export(exports, "ImCrying", ()=>ImCrying);
parcelHelpers.export(exports, "ImCrying2", ()=>ImCrying2);
parcelHelpers.export(exports, "ImPointUp", ()=>ImPointUp);
parcelHelpers.export(exports, "ImPointRight", ()=>ImPointRight);
parcelHelpers.export(exports, "ImPointDown", ()=>ImPointDown);
parcelHelpers.export(exports, "ImPointLeft", ()=>ImPointLeft);
parcelHelpers.export(exports, "ImWarning", ()=>ImWarning);
parcelHelpers.export(exports, "ImNotification", ()=>ImNotification);
parcelHelpers.export(exports, "ImQuestion", ()=>ImQuestion);
parcelHelpers.export(exports, "ImPlus", ()=>ImPlus);
parcelHelpers.export(exports, "ImMinus", ()=>ImMinus);
parcelHelpers.export(exports, "ImInfo", ()=>ImInfo);
parcelHelpers.export(exports, "ImCancelCircle", ()=>ImCancelCircle);
parcelHelpers.export(exports, "ImBlocked", ()=>ImBlocked);
parcelHelpers.export(exports, "ImCross", ()=>ImCross);
parcelHelpers.export(exports, "ImCheckmark", ()=>ImCheckmark);
parcelHelpers.export(exports, "ImCheckmark2", ()=>ImCheckmark2);
parcelHelpers.export(exports, "ImSpellCheck", ()=>ImSpellCheck);
parcelHelpers.export(exports, "ImEnter", ()=>ImEnter);
parcelHelpers.export(exports, "ImExit", ()=>ImExit);
parcelHelpers.export(exports, "ImPlay2", ()=>ImPlay2);
parcelHelpers.export(exports, "ImPause", ()=>ImPause);
parcelHelpers.export(exports, "ImStop", ()=>ImStop);
parcelHelpers.export(exports, "ImPrevious", ()=>ImPrevious);
parcelHelpers.export(exports, "ImNext", ()=>ImNext);
parcelHelpers.export(exports, "ImBackward", ()=>ImBackward);
parcelHelpers.export(exports, "ImForward2", ()=>ImForward2);
parcelHelpers.export(exports, "ImPlay3", ()=>ImPlay3);
parcelHelpers.export(exports, "ImPause2", ()=>ImPause2);
parcelHelpers.export(exports, "ImStop2", ()=>ImStop2);
parcelHelpers.export(exports, "ImBackward2", ()=>ImBackward2);
parcelHelpers.export(exports, "ImForward3", ()=>ImForward3);
parcelHelpers.export(exports, "ImFirst", ()=>ImFirst);
parcelHelpers.export(exports, "ImLast", ()=>ImLast);
parcelHelpers.export(exports, "ImPrevious2", ()=>ImPrevious2);
parcelHelpers.export(exports, "ImNext2", ()=>ImNext2);
parcelHelpers.export(exports, "ImEject", ()=>ImEject);
parcelHelpers.export(exports, "ImVolumeHigh", ()=>ImVolumeHigh);
parcelHelpers.export(exports, "ImVolumeMedium", ()=>ImVolumeMedium);
parcelHelpers.export(exports, "ImVolumeLow", ()=>ImVolumeLow);
parcelHelpers.export(exports, "ImVolumeMute", ()=>ImVolumeMute);
parcelHelpers.export(exports, "ImVolumeMute2", ()=>ImVolumeMute2);
parcelHelpers.export(exports, "ImVolumeIncrease", ()=>ImVolumeIncrease);
parcelHelpers.export(exports, "ImVolumeDecrease", ()=>ImVolumeDecrease);
parcelHelpers.export(exports, "ImLoop", ()=>ImLoop);
parcelHelpers.export(exports, "ImLoop2", ()=>ImLoop2);
parcelHelpers.export(exports, "ImInfinite", ()=>ImInfinite);
parcelHelpers.export(exports, "ImShuffle", ()=>ImShuffle);
parcelHelpers.export(exports, "ImArrowUpLeft", ()=>ImArrowUpLeft);
parcelHelpers.export(exports, "ImArrowUp", ()=>ImArrowUp);
parcelHelpers.export(exports, "ImArrowUpRight", ()=>ImArrowUpRight);
parcelHelpers.export(exports, "ImArrowRight", ()=>ImArrowRight);
parcelHelpers.export(exports, "ImArrowDownRight", ()=>ImArrowDownRight);
parcelHelpers.export(exports, "ImArrowDown", ()=>ImArrowDown);
parcelHelpers.export(exports, "ImArrowDownLeft", ()=>ImArrowDownLeft);
parcelHelpers.export(exports, "ImArrowLeft", ()=>ImArrowLeft);
parcelHelpers.export(exports, "ImArrowUpLeft2", ()=>ImArrowUpLeft2);
parcelHelpers.export(exports, "ImArrowUp2", ()=>ImArrowUp2);
parcelHelpers.export(exports, "ImArrowUpRight2", ()=>ImArrowUpRight2);
parcelHelpers.export(exports, "ImArrowRight2", ()=>ImArrowRight2);
parcelHelpers.export(exports, "ImArrowDownRight2", ()=>ImArrowDownRight2);
parcelHelpers.export(exports, "ImArrowDown2", ()=>ImArrowDown2);
parcelHelpers.export(exports, "ImArrowDownLeft2", ()=>ImArrowDownLeft2);
parcelHelpers.export(exports, "ImArrowLeft2", ()=>ImArrowLeft2);
parcelHelpers.export(exports, "ImCircleUp", ()=>ImCircleUp);
parcelHelpers.export(exports, "ImCircleRight", ()=>ImCircleRight);
parcelHelpers.export(exports, "ImCircleDown", ()=>ImCircleDown);
parcelHelpers.export(exports, "ImCircleLeft", ()=>ImCircleLeft);
parcelHelpers.export(exports, "ImTab", ()=>ImTab);
parcelHelpers.export(exports, "ImMoveUp", ()=>ImMoveUp);
parcelHelpers.export(exports, "ImMoveDown", ()=>ImMoveDown);
parcelHelpers.export(exports, "ImSortAlphaAsc", ()=>ImSortAlphaAsc);
parcelHelpers.export(exports, "ImSortAlphaDesc", ()=>ImSortAlphaDesc);
parcelHelpers.export(exports, "ImSortNumericAsc", ()=>ImSortNumericAsc);
parcelHelpers.export(exports, "ImSortNumbericDesc", ()=>ImSortNumbericDesc);
parcelHelpers.export(exports, "ImSortAmountAsc", ()=>ImSortAmountAsc);
parcelHelpers.export(exports, "ImSortAmountDesc", ()=>ImSortAmountDesc);
parcelHelpers.export(exports, "ImCommand", ()=>ImCommand);
parcelHelpers.export(exports, "ImShift", ()=>ImShift);
parcelHelpers.export(exports, "ImCtrl", ()=>ImCtrl);
parcelHelpers.export(exports, "ImOpt", ()=>ImOpt);
parcelHelpers.export(exports, "ImCheckboxChecked", ()=>ImCheckboxChecked);
parcelHelpers.export(exports, "ImCheckboxUnchecked", ()=>ImCheckboxUnchecked);
parcelHelpers.export(exports, "ImRadioChecked", ()=>ImRadioChecked);
parcelHelpers.export(exports, "ImRadioChecked2", ()=>ImRadioChecked2);
parcelHelpers.export(exports, "ImRadioUnchecked", ()=>ImRadioUnchecked);
parcelHelpers.export(exports, "ImCrop", ()=>ImCrop);
parcelHelpers.export(exports, "ImMakeGroup", ()=>ImMakeGroup);
parcelHelpers.export(exports, "ImUngroup", ()=>ImUngroup);
parcelHelpers.export(exports, "ImScissors", ()=>ImScissors);
parcelHelpers.export(exports, "ImFilter", ()=>ImFilter);
parcelHelpers.export(exports, "ImFont", ()=>ImFont);
parcelHelpers.export(exports, "ImLigature", ()=>ImLigature);
parcelHelpers.export(exports, "ImLigature2", ()=>ImLigature2);
parcelHelpers.export(exports, "ImTextHeight", ()=>ImTextHeight);
parcelHelpers.export(exports, "ImTextWidth", ()=>ImTextWidth);
parcelHelpers.export(exports, "ImFontSize", ()=>ImFontSize);
parcelHelpers.export(exports, "ImBold", ()=>ImBold);
parcelHelpers.export(exports, "ImUnderline", ()=>ImUnderline);
parcelHelpers.export(exports, "ImItalic", ()=>ImItalic);
parcelHelpers.export(exports, "ImStrikethrough", ()=>ImStrikethrough);
parcelHelpers.export(exports, "ImOmega", ()=>ImOmega);
parcelHelpers.export(exports, "ImSigma", ()=>ImSigma);
parcelHelpers.export(exports, "ImPageBreak", ()=>ImPageBreak);
parcelHelpers.export(exports, "ImSuperscript", ()=>ImSuperscript);
parcelHelpers.export(exports, "ImSubscript", ()=>ImSubscript);
parcelHelpers.export(exports, "ImSuperscript2", ()=>ImSuperscript2);
parcelHelpers.export(exports, "ImSubscript2", ()=>ImSubscript2);
parcelHelpers.export(exports, "ImTextColor", ()=>ImTextColor);
parcelHelpers.export(exports, "ImPagebreak", ()=>ImPagebreak);
parcelHelpers.export(exports, "ImClearFormatting", ()=>ImClearFormatting);
parcelHelpers.export(exports, "ImTable", ()=>ImTable);
parcelHelpers.export(exports, "ImTable2", ()=>ImTable2);
parcelHelpers.export(exports, "ImInsertTemplate", ()=>ImInsertTemplate);
parcelHelpers.export(exports, "ImPilcrow", ()=>ImPilcrow);
parcelHelpers.export(exports, "ImLtr", ()=>ImLtr);
parcelHelpers.export(exports, "ImRtl", ()=>ImRtl);
parcelHelpers.export(exports, "ImSection", ()=>ImSection);
parcelHelpers.export(exports, "ImParagraphLeft", ()=>ImParagraphLeft);
parcelHelpers.export(exports, "ImParagraphCenter", ()=>ImParagraphCenter);
parcelHelpers.export(exports, "ImParagraphRight", ()=>ImParagraphRight);
parcelHelpers.export(exports, "ImParagraphJustify", ()=>ImParagraphJustify);
parcelHelpers.export(exports, "ImIndentIncrease", ()=>ImIndentIncrease);
parcelHelpers.export(exports, "ImIndentDecrease", ()=>ImIndentDecrease);
parcelHelpers.export(exports, "ImShare", ()=>ImShare);
parcelHelpers.export(exports, "ImNewTab", ()=>ImNewTab);
parcelHelpers.export(exports, "ImEmbed", ()=>ImEmbed);
parcelHelpers.export(exports, "ImEmbed2", ()=>ImEmbed2);
parcelHelpers.export(exports, "ImTerminal", ()=>ImTerminal);
parcelHelpers.export(exports, "ImShare2", ()=>ImShare2);
parcelHelpers.export(exports, "ImMail", ()=>ImMail);
parcelHelpers.export(exports, "ImMail2", ()=>ImMail2);
parcelHelpers.export(exports, "ImMail3", ()=>ImMail3);
parcelHelpers.export(exports, "ImMail4", ()=>ImMail4);
parcelHelpers.export(exports, "ImAmazon", ()=>ImAmazon);
parcelHelpers.export(exports, "ImGoogle", ()=>ImGoogle);
parcelHelpers.export(exports, "ImGoogle2", ()=>ImGoogle2);
parcelHelpers.export(exports, "ImGoogle3", ()=>ImGoogle3);
parcelHelpers.export(exports, "ImGooglePlus", ()=>ImGooglePlus);
parcelHelpers.export(exports, "ImGooglePlus2", ()=>ImGooglePlus2);
parcelHelpers.export(exports, "ImGooglePlus3", ()=>ImGooglePlus3);
parcelHelpers.export(exports, "ImHangouts", ()=>ImHangouts);
parcelHelpers.export(exports, "ImGoogleDrive", ()=>ImGoogleDrive);
parcelHelpers.export(exports, "ImFacebook", ()=>ImFacebook);
parcelHelpers.export(exports, "ImFacebook2", ()=>ImFacebook2);
parcelHelpers.export(exports, "ImInstagram", ()=>ImInstagram);
parcelHelpers.export(exports, "ImWhatsapp", ()=>ImWhatsapp);
parcelHelpers.export(exports, "ImSpotify", ()=>ImSpotify);
parcelHelpers.export(exports, "ImTelegram", ()=>ImTelegram);
parcelHelpers.export(exports, "ImTwitter", ()=>ImTwitter);
parcelHelpers.export(exports, "ImVine", ()=>ImVine);
parcelHelpers.export(exports, "ImVk", ()=>ImVk);
parcelHelpers.export(exports, "ImRenren", ()=>ImRenren);
parcelHelpers.export(exports, "ImSinaWeibo", ()=>ImSinaWeibo);
parcelHelpers.export(exports, "ImRss", ()=>ImRss);
parcelHelpers.export(exports, "ImRss2", ()=>ImRss2);
parcelHelpers.export(exports, "ImYoutube", ()=>ImYoutube);
parcelHelpers.export(exports, "ImYoutube2", ()=>ImYoutube2);
parcelHelpers.export(exports, "ImTwitch", ()=>ImTwitch);
parcelHelpers.export(exports, "ImVimeo", ()=>ImVimeo);
parcelHelpers.export(exports, "ImVimeo2", ()=>ImVimeo2);
parcelHelpers.export(exports, "ImLanyrd", ()=>ImLanyrd);
parcelHelpers.export(exports, "ImFlickr", ()=>ImFlickr);
parcelHelpers.export(exports, "ImFlickr2", ()=>ImFlickr2);
parcelHelpers.export(exports, "ImFlickr3", ()=>ImFlickr3);
parcelHelpers.export(exports, "ImFlickr4", ()=>ImFlickr4);
parcelHelpers.export(exports, "ImDribbble", ()=>ImDribbble);
parcelHelpers.export(exports, "ImBehance", ()=>ImBehance);
parcelHelpers.export(exports, "ImBehance2", ()=>ImBehance2);
parcelHelpers.export(exports, "ImDeviantart", ()=>ImDeviantart);
parcelHelpers.export(exports, "Im500Px", ()=>Im500Px);
parcelHelpers.export(exports, "ImSteam", ()=>ImSteam);
parcelHelpers.export(exports, "ImSteam2", ()=>ImSteam2);
parcelHelpers.export(exports, "ImDropbox", ()=>ImDropbox);
parcelHelpers.export(exports, "ImOnedrive", ()=>ImOnedrive);
parcelHelpers.export(exports, "ImGithub", ()=>ImGithub);
parcelHelpers.export(exports, "ImNpm", ()=>ImNpm);
parcelHelpers.export(exports, "ImBasecamp", ()=>ImBasecamp);
parcelHelpers.export(exports, "ImTrello", ()=>ImTrello);
parcelHelpers.export(exports, "ImWordpress", ()=>ImWordpress);
parcelHelpers.export(exports, "ImJoomla", ()=>ImJoomla);
parcelHelpers.export(exports, "ImEllo", ()=>ImEllo);
parcelHelpers.export(exports, "ImBlogger", ()=>ImBlogger);
parcelHelpers.export(exports, "ImBlogger2", ()=>ImBlogger2);
parcelHelpers.export(exports, "ImTumblr", ()=>ImTumblr);
parcelHelpers.export(exports, "ImTumblr2", ()=>ImTumblr2);
parcelHelpers.export(exports, "ImYahoo", ()=>ImYahoo);
parcelHelpers.export(exports, "ImYahoo2", ()=>ImYahoo2);
parcelHelpers.export(exports, "ImTux", ()=>ImTux);
parcelHelpers.export(exports, "ImAppleinc", ()=>ImAppleinc);
parcelHelpers.export(exports, "ImFinder", ()=>ImFinder);
parcelHelpers.export(exports, "ImAndroid", ()=>ImAndroid);
parcelHelpers.export(exports, "ImWindows", ()=>ImWindows);
parcelHelpers.export(exports, "ImWindows8", ()=>ImWindows8);
parcelHelpers.export(exports, "ImSoundcloud", ()=>ImSoundcloud);
parcelHelpers.export(exports, "ImSoundcloud2", ()=>ImSoundcloud2);
parcelHelpers.export(exports, "ImSkype", ()=>ImSkype);
parcelHelpers.export(exports, "ImReddit", ()=>ImReddit);
parcelHelpers.export(exports, "ImHackernews", ()=>ImHackernews);
parcelHelpers.export(exports, "ImWikipedia", ()=>ImWikipedia);
parcelHelpers.export(exports, "ImLinkedin", ()=>ImLinkedin);
parcelHelpers.export(exports, "ImLinkedin2", ()=>ImLinkedin2);
parcelHelpers.export(exports, "ImLastfm", ()=>ImLastfm);
parcelHelpers.export(exports, "ImLastfm2", ()=>ImLastfm2);
parcelHelpers.export(exports, "ImDelicious", ()=>ImDelicious);
parcelHelpers.export(exports, "ImStumbleupon", ()=>ImStumbleupon);
parcelHelpers.export(exports, "ImStumbleupon2", ()=>ImStumbleupon2);
parcelHelpers.export(exports, "ImStackoverflow", ()=>ImStackoverflow);
parcelHelpers.export(exports, "ImPinterest", ()=>ImPinterest);
parcelHelpers.export(exports, "ImPinterest2", ()=>ImPinterest2);
parcelHelpers.export(exports, "ImXing", ()=>ImXing);
parcelHelpers.export(exports, "ImXing2", ()=>ImXing2);
parcelHelpers.export(exports, "ImFlattr", ()=>ImFlattr);
parcelHelpers.export(exports, "ImFoursquare", ()=>ImFoursquare);
parcelHelpers.export(exports, "ImYelp", ()=>ImYelp);
parcelHelpers.export(exports, "ImPaypal", ()=>ImPaypal);
parcelHelpers.export(exports, "ImChrome", ()=>ImChrome);
parcelHelpers.export(exports, "ImFirefox", ()=>ImFirefox);
parcelHelpers.export(exports, "ImIe", ()=>ImIe);
parcelHelpers.export(exports, "ImEdge", ()=>ImEdge);
parcelHelpers.export(exports, "ImSafari", ()=>ImSafari);
parcelHelpers.export(exports, "ImOpera", ()=>ImOpera);
parcelHelpers.export(exports, "ImFilePdf", ()=>ImFilePdf);
parcelHelpers.export(exports, "ImFileOpenoffice", ()=>ImFileOpenoffice);
parcelHelpers.export(exports, "ImFileWord", ()=>ImFileWord);
parcelHelpers.export(exports, "ImFileExcel", ()=>ImFileExcel);
parcelHelpers.export(exports, "ImLibreoffice", ()=>ImLibreoffice);
parcelHelpers.export(exports, "ImHtmlFive", ()=>ImHtmlFive);
parcelHelpers.export(exports, "ImHtmlFive2", ()=>ImHtmlFive2);
parcelHelpers.export(exports, "ImCss3", ()=>ImCss3);
parcelHelpers.export(exports, "ImGit", ()=>ImGit);
parcelHelpers.export(exports, "ImCodepen", ()=>ImCodepen);
parcelHelpers.export(exports, "ImSvg", ()=>ImSvg);
parcelHelpers.export(exports, "ImIcoMoon", ()=>ImIcoMoon);
var _lib = require("../lib");
function ImHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.226l-8-6.21-8 6.21v-2.532l8-6.21 8 6.21zM14 9v6h-4v-4h-4v4h-4v-6l6-4.5z"
                }
            }
        ]
    })(props);
}
function ImHome2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.5l-8 8 1.5 1.5 1.5-1.5v6.5h4v-3h2v3h4v-6.5l1.5 1.5 1.5-1.5-8-8zM8 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"
                }
            }
        ]
    })(props);
}
function ImHome3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9.5l-3-3v-4.5h-2v2.5l-3-3-8 8v0.5h2v5h5v-3h2v3h5v-5h2z"
                }
            }
        ]
    })(props);
}
function ImOffice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16h8v-16h-8v16zM5 2h2v2h-2v-2zM5 6h2v2h-2v-2zM5 10h2v2h-2v-2zM1 2h2v2h-2v-2zM1 6h2v2h-2v-2zM1 10h2v2h-2v-2zM9 5h7v1h-7zM9 16h2v-4h3v4h2v-9h-7z"
                }
            }
        ]
    })(props);
}
function ImNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z"
                }
            }
        ]
    })(props);
}
function ImPencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z"
                }
            }
        ]
    })(props);
}
function ImPencil2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10l2-1 7-7-1-1-7 7-1 2zM4.52 13.548c-0.494-1.043-1.026-1.574-2.069-2.069l1.548-4.262 2-1.217 6-6h-3l-6 6-3 10 10-3 6-6v-3l-6 6-1.217 2z"
                }
            }
        ]
    })(props);
}
function ImQuill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16c2-6 7.234-16 16-16-4.109 3.297-6 11-9 11s-3 0-3 0l-3 5h-1z"
                }
            }
        ]
    })(props);
}
function ImPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.909 4.561l-4.47-4.47c-0.146-0.146-0.338-0.113-0.427 0.073l-0.599 1.248 4.175 4.175 1.248-0.599c0.186-0.089 0.219-0.282 0.073-0.427z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.615 2.115l-4.115 0.343c-0.273 0.034-0.501 0.092-0.58 0.449-0 0-0 0.001-0 0.001-1.116 5.36-4.92 10.591-4.92 10.591l0.896 0.896 4.25-4.25c-0.094-0.196-0.146-0.415-0.146-0.647 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.232 0-0.451-0.053-0.647-0.146l-4.25 4.25 0.896 0.896c0 0 5.231-3.804 10.591-4.92 0-0 0.001-0 0.001-0 0.357-0.078 0.415-0.306 0.449-0.58l0.343-4.115-4.269-4.269z"
                }
            }
        ]
    })(props);
}
function ImBlog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0v1.5c1.148 0 2.261 0.225 3.308 0.667 1.012 0.428 1.921 1.041 2.702 1.822s1.394 1.69 1.822 2.702c0.443 1.047 0.667 2.16 0.667 3.308h1.5c0-5.523-4.477-10-10-10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v1.5c1.469 0 2.85 0.572 3.889 1.611s1.611 2.42 1.611 3.889h1.5c0-3.866-3.134-7-7-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 6l-1 1-3.5 1-3 6.5 0.396 0.396 3.638-3.638c-0.022-0.083-0.034-0.169-0.034-0.259 0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1c-0.090 0-0.176-0.012-0.259-0.034l-3.638 3.638 0.396 0.396 6.5-3 1-3.5 1-1-2.5-2.5z"
                }
            }
        ]
    })(props);
}
function ImEyedropper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.414 0.586c-0.781-0.781-2.047-0.781-2.828 0l-2.689 2.689-1.896-1.896-2.121 2.121 1.663 1.663-7.377 7.377c-0.126 0.126-0.179 0.296-0.161 0.46h-0.004v2.5c0 0.276 0.224 0.5 0.5 0.5h2.5c0 0 0.042 0 0.063 0 0.144 0 0.288-0.055 0.398-0.165l7.377-7.377 1.663 1.663 2.121-2.121-1.896-1.896 2.689-2.689c0.781-0.781 0.781-2.047 0-2.828zM2.705 15h-1.705v-1.705l7.337-7.337 1.704 1.704-7.337 7.337z"
                }
            }
        ]
    })(props);
}
function ImDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397zM11.543 11.859c-0.684 1.301-2.075 2.141-3.543 2.141-0.861 0-1.696-0.29-2.377-0.791 0.207 0.027 0.416 0.041 0.627 0.041 1.835 0 3.573-1.050 4.428-2.676 0.701-1.333 0.64-2.716 0.373-3.818 0.227 0.44 0.42 0.878 0.576 1.311 0.353 0.985 0.625 2.443-0.084 3.791z"
                }
            }
        ]
    })(props);
}
function ImPaintFormat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"
                }
            }
        ]
    })(props);
}
function ImImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.998 2c0.001 0.001 0.001 0.001 0.002 0.002v11.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13h-12v-2l3.5-6 4 5h1l3.5-3z"
                }
            }
        ]
    })(props);
}
function ImImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-1v-1c0-0.55-0.45-1-1-1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h1v1c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM2 3v10h-0.998c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-12c-0.55 0-1 0.45-1 1v0zM17 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v11.996z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h-12v-2l3.5-6 4 5h1l3.5-3z"
                }
            }
        ]
    })(props);
}
function ImCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 9.5c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25-1.455-3.25-3.25-3.25-3.25 1.455-3.25 3.25zM15 4h-3.5c-0.25-1-0.5-2-1.5-2h-4c-1 0-1.25 1-1.5 2h-3.5c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM8 13.938c-2.451 0-4.438-1.987-4.438-4.438s1.987-4.438 4.438-4.438c2.451 0 4.438 1.987 4.438 4.438s-1.987 4.438-4.438 4.438zM15 7h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function ImHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z"
                }
            }
        ]
    })(props);
}
function ImMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-5.751l-8 1.778v7.722c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-9.751l9-2z"
                }
            }
        ]
    })(props);
}
function ImPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.331 2.502c-2.244-0.323-4.724-0.502-7.331-0.502s-5.087 0.179-7.331 0.502c-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM6 11v-6l5 3-5 3z"
                }
            }
        ]
    })(props);
}
function ImFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2v12h16v-12h-16zM3 13h-2v-2h2v2zM3 9h-2v-2h2v2zM3 5h-2v-2h2v2zM12 13h-8v-10h8v10zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM15 5h-2v-2h2v2zM6 5v6l4-3z"
                }
            }
        ]
    })(props);
}
function ImVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM0 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM12 9.5v-1.5c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-1.5l4 2.5v-7l-4 2.5zM10 12h-8v-3h8v3z"
                }
            }
        ]
    })(props);
}
function ImDice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.375 1.125 2.5 2.5 2.5h8c1.375 0 2.5-1.125 2.5-2.5v-8c0-1.375-1.125-2.5-2.5-2.5zM6.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM9.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.949 2c-0.233-1.138-1.245-2-2.449-2h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.204 0.862 2.216 2 2.449v-9.949c0-0.55 0.45-1 1-1h9.949z"
                }
            }
        ]
    })(props);
}
function ImPacman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.074 2.794c-1.467-1.71-3.644-2.794-6.074-2.794-4.418 0-8 3.582-8 8s3.582 8 8 8c2.43 0 4.607-1.084 6.074-2.794l-5.074-5.206 5.074-5.206zM11 1.884c0.616 0 1.116 0.499 1.116 1.116s-0.499 1.116-1.116 1.116-1.116-0.499-1.116-1.116c0-0.616 0.499-1.116 1.116-1.116z"
                }
            }
        ]
    })(props);
}
function ImSpades(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.775 5.44c-3.024-2.248-4.067-4.047-4.774-5.44v0c-0 0-0-0-0-0v0c-0.708 1.393-1.75 3.192-4.774 5.44-5.157 3.833-0.303 9.182 3.965 6.238-0.278 1.827-1.227 3.159-2.191 3.733v0.59h6v-0.59c-0.964-0.574-1.913-1.906-2.191-3.733 4.268 2.944 9.122-2.405 3.965-6.238z"
                }
            }
        ]
    })(props);
}
function ImClubs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.294 6.137c-0.922 0-1.751 0.384-2.341 1.011-0.25 0.265-0.684 0.58-1.153 0.856 0.22-0.842 0.917-1.902 1.4-2.367 0.619-0.596 1-1.435 1-2.367 0-1.795-1.429-3.252-3.2-3.271-1.771 0.019-3.2 1.475-3.2 3.271 0 0.932 0.38 1.771 1 2.367 0.484 0.465 1.18 1.525 1.4 2.367-0.469-0.277-0.903-0.591-1.153-0.856-0.59-0.627-1.419-1.011-2.341-1.011-1.787 0-3.236 1.463-3.236 3.271s1.448 3.271 3.236 3.271c0.923 0 1.751-0.396 2.341-1.023 0.263-0.279 0.726-0.627 1.223-0.916-0.047 2.308-1.149 4.003-2.271 4.67v0.59h6v-0.59c-1.122-0.668-2.224-2.363-2.271-4.67 0.498 0.289 0.961 0.637 1.223 0.916 0.59 0.626 1.419 1.023 2.341 1.023 1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z"
                }
            }
        ]
    })(props);
}
function ImDiamonds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0l-5 8 5 8 5-8z"
                }
            }
        ]
    })(props);
}
function ImBullhorn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.707c0-3.139-0.919-5.687-2.054-5.707 0.005-0 0.009-0 0.014-0h-1.296c0 0-3.044 2.287-7.425 3.184-0.134 0.708-0.219 1.551-0.219 2.523s0.085 1.816 0.219 2.523c4.382 0.897 7.425 3.184 7.425 3.184h1.296c-0.005 0-0.009-0-0.014-0.001 1.136-0.020 2.054-2.567 2.054-5.707zM13.513 11.551c-0.147 0-0.305-0.152-0.387-0.243-0.197-0.22-0.387-0.562-0.55-0.989-0.363-0.957-0.564-2.239-0.564-3.611s0.2-2.655 0.564-3.611c0.162-0.428 0.353-0.77 0.55-0.99 0.081-0.091 0.24-0.243 0.387-0.243s0.305 0.152 0.387 0.243c0.197 0.22 0.387 0.562 0.55 0.99 0.363 0.957 0.564 2.239 0.564 3.611s-0.2 2.655-0.564 3.611c-0.162 0.428-0.353 0.77-0.55 0.989-0.081 0.091-0.24 0.243-0.387 0.243zM3.935 6.707c0-0.812 0.060-1.6 0.173-2.33-0.74 0.102-1.39 0.161-2.193 0.161-1.048 0-1.048 0-1.048 0l-0.867 1.479v1.378l0.867 1.479c0 0 0 0 1.048 0 0.803 0 1.453 0.059 2.193 0.161-0.113-0.729-0.173-1.518-0.173-2.33zM5.752 10.034l-2-0.383 1.279 5.024c0.066 0.26 0.324 0.391 0.573 0.291l1.852-0.741c0.249-0.1 0.349-0.374 0.222-0.611l-1.926-3.581zM13.513 8.574c-0.057 0-0.118-0.059-0.149-0.094-0.076-0.085-0.149-0.217-0.212-0.381-0.14-0.369-0.217-0.863-0.217-1.392s0.077-1.023 0.217-1.392c0.063-0.165 0.136-0.297 0.212-0.381 0.031-0.035 0.092-0.094 0.149-0.094s0.118 0.059 0.149 0.094c0.076 0.085 0.149 0.217 0.212 0.381 0.14 0.369 0.217 0.863 0.217 1.392s-0.077 1.023-0.217 1.392c-0.063 0.165-0.136 0.297-0.212 0.381-0.031 0.035-0.092 0.094-0.149 0.094z"
                }
            }
        ]
    })(props);
}
function ImConnection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759zM2.929 7.929c1.889-1.889 4.4-2.929 7.071-2.929s5.182 1.040 7.071 2.929l-1.414 1.414c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343l-1.414-1.414zM15.45 2.101c1.667 0.705 3.164 1.715 4.45 3v0l-1.414 1.414c-2.267-2.266-5.28-3.515-8.485-3.515s-6.219 1.248-8.485 3.515l-1.414-1.414c1.285-1.285 2.783-2.295 4.45-3 1.727-0.73 3.56-1.101 5.45-1.101s3.723 0.37 5.45 1.101zM9 14c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
                }
            }
        ]
    })(props);
}
function ImPodcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 3.438 2.169 6.37 5.214 7.501l-0.214 0.499h6l-0.214-0.499c3.045-1.131 5.214-4.063 5.214-7.501zM7.606 9.919c-0.356-0.153-0.606-0.507-0.606-0.919 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.412-0.25 0.766-0.606 0.919l-0.394-0.919-0.394 0.919zM8.41 9.958c0.908-0.189 1.59-0.994 1.59-1.958 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.964 0.682 1.768 1.59 1.957l-1.166 2.721c-1.425-0.612-2.424-2.028-2.424-3.677 0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188c0 1.649-0.999 3.066-2.424 3.677l-1.166-2.72zM10.757 15.433l-1.155-2.695c1.976-0.668 3.398-2.537 3.398-4.738 0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.201 1.422 4.070 3.398 4.738l-1.155 2.695c-2.494-1.070-4.24-3.547-4.24-6.433 0-3.865 3.133-7.185 6.997-7.185s6.997 3.32 6.997 7.185c0 2.886-1.747 5.363-4.24 6.433z"
                }
            }
        ]
    })(props);
}
function ImFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.38 3.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM4.5 8c0 1.738 0.431 3.302 1.12 4.398-1.56-0.846-2.62-2.498-2.62-4.398s1.059-3.552 2.62-4.398c-0.689 1.096-1.12 2.66-1.12 4.398zM1.5 8c0 2.686 0.85 5.097 2.198 6.746-2.223-1.421-3.698-3.911-3.698-6.746s1.474-5.325 3.698-6.746c-1.348 1.649-2.198 4.060-2.198 6.746zM12.302 1.254c2.223 1.421 3.698 3.911 3.698 6.746s-1.474 5.325-3.698 6.746c1.348-1.649 2.198-4.060 2.198-6.746s-0.85-5.097-2.198-6.746z"
                }
            }
        ]
    })(props);
}
function ImMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11c1.381 0 2.5-1.119 2.5-2.5v-6c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v6c0 1.381 1.119 2.5 2.5 2.5zM11 7v1.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5v-1.5h-1v1.5c0 2.316 1.75 4.223 4 4.472v2.028h-2v1h5v-1h-2v-2.028c2.25-0.249 4-2.156 4-4.472v-1.5h-1z"
                }
            }
        ]
    })(props);
}
function ImBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z"
                }
            }
        ]
    })(props);
}
function ImBooks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15v-1h-1v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-1v1h-1v1h17v-1h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0h1l8 5v1h-17v-1l8-5z"
                }
            }
        ]
    })(props);
}
function ImFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 7h7v1h-7zM4 9h7v1h-7zM4 11h7v1h-7zM4 5h7v1h-7z"
                }
            }
        ]
    })(props);
}
function ImProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 9h7v1h-7zM4 11h7v1h-7zM5 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM7.5 6h-2c-0.825 0-1.5 0.45-1.5 1v1h5v-1c0-0.55-0.675-1-1.5-1z"
                }
            }
        ]
    })(props);
}
function ImFileEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImFilesEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 5.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 4.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-9.5c-0.136 0-0.25-0.114-0.25-0.25v-11.5c0-0.135 0.114-0.25 0.25-0.25 0 0 5.749-0 5.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v7.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z"
                }
            }
        ]
    })(props);
}
function ImFileText2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImFilePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h-10v-2l3-5 4.109 5 2.891-2v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImFileMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.817 6.113c-0.116-0.095-0.268-0.133-0.415-0.104l-5 1c-0.234 0.047-0.402 0.252-0.402 0.49v3.701c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-3.59l4-0.8v2.091c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-5c0-0.15-0.067-0.292-0.183-0.387z"
                }
            }
        ]
    })(props);
}
function ImFilePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6l5 3.5-5 3.5v-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h5v5h-5v-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10l3-2v5l-3-2z"
                }
            }
        ]
    })(props);
}
function ImFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-1.25v-1h-2v4.25zM7 12v1h-2v-1h2z"
                }
            }
        ]
    })(props);
}
function ImCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v-4h-7l-3 3v9h6v4h10v-12h-6zM3 1.414v1.586h-1.586l1.586-1.586zM1 11v-7h3v-3h5v3l-3 3v4h-5zM9 5.414v1.586h-1.586l1.586-1.586zM15 15h-8v-7h3v-3h5v10z"
                }
            }
        ]
    })(props);
}
function ImPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM8 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998zM13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-1v1h0.5v2h-3l-3 3v4h-4v-9h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h10v-11h-3zM9 6.414v1.586h-1.586l1.586-1.586zM15 15h-8v-6h3v-3h5v9z"
                }
            }
        ]
    })(props);
}
function ImStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-8-4-8 4 8 4 8-4zM8 2.328l5.345 2.672-5.345 2.672-5.345-2.672 5.345-2.672zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"
                }
            }
        ]
    })(props);
}
function ImFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2l2 2h7v11h-16v-13z"
                }
            }
        ]
    })(props);
}
function ImFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15l3-8h-13l-3 8zM2 6l-2 9v-13h4.5l2 2h6.5v2z"
                }
            }
        ]
    })(props);
}
function ImFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function ImFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-6v-2h6v2z"
                }
            }
        ]
    })(props);
}
function ImFolderDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 13.5l-3.5-3.5h2.5v-4h2v4h2.5l-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function ImFolderUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 7.5l3.5 3.5h-2.5v4h-2v-4h-2.5l3.5-3.5z"
                }
            }
        ]
    })(props);
}
function ImPriceTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function ImPriceTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75zM15.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8.5l8.5-8.5h-1.25c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l0.47-0.47-6.5-6.5z"
                }
            }
        ]
    })(props);
}
function ImBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2h2v10h-2zM3 2h1v10h-1zM5 2h1v10h-1zM8 2h1v10h-1zM12 2h1v10h-1zM15 2h1v10h-1zM10 2h0.5v10h-0.5zM7 2h0.5v10h-0.5zM13.5 2h0.5v10h-0.5zM0 13h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM15 13h1v1h-1zM12 13h2v1h-2zM7 13h2v1h-2z"
                }
            }
        ]
    })(props);
}
function ImQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z"
                }
            }
        ]
    })(props);
}
function ImTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5l2 2-4 4-2-2zM15.649 4.649l-1.149-1.149-0.5 0.5c-0.256 0.256-0.61 0.414-1 0.414-0.781 0-1.414-0.633-1.414-1.414 0-0.391 0.158-0.744 0.415-1l0.5-0.5-1.149-1.149c-0.468-0.468-1.235-0.468-1.703 0l-9.297 9.297c-0.468 0.468-0.468 1.235 0 1.703l1.149 1.149 0.499-0.499c0.256-0.256 0.61-0.415 1.001-0.415 0.781 0 1.414 0.633 1.414 1.414 0 0.391-0.158 0.744-0.415 1l-0.5 0.5 1.149 1.149c0.468 0.468 1.234 0.468 1.703 0l9.297-9.297c0.468-0.468 0.468-1.235 0-1.703zM7 13l-4-4 6-6 4 4-6 6z"
                }
            }
        ]
    })(props);
}
function ImCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v-6h-12c0-0.552-0.448-1-1-1h-3v1h2l0.751 6.438c-0.458 0.367-0.751 0.93-0.751 1.562 0 1.105 0.895 2 2 2h12v-1h-12c-0.552 0-1-0.448-1-1 0-0.003 0-0.007 0-0.010l13-1.99z"
                }
            }
        ]
    })(props);
}
function ImCoinDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM8 8v-2h2v-1h-2v-1h-1v1h-2v4h2v2h-2v1h2v1h1v-1h2l-0-4h-2zM7 8h-1v-2h1v2zM9 11h-1v-2h1v2z"
                }
            }
        ]
    })(props);
}
function ImCoinEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.482 10.068c-0.239-0.139-0.545-0.058-0.684 0.181-0.27 0.463-0.767 0.751-1.298 0.751h-2c-0.652 0-1.208-0.418-1.414-1h2.414c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.414c0.206-0.582 0.762-1 1.414-1h2c0.531 0 1.028 0.288 1.298 0.751 0.139 0.239 0.445 0.32 0.684 0.181s0.32-0.445 0.181-0.684c-0.448-0.77-1.277-1.249-2.162-1.249h-2c-1.207 0-2.217 0.86-2.45 2h-0.55c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v1h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.55c0.232 1.14 1.242 2 2.45 2h2c0.886 0 1.714-0.478 2.162-1.249 0.139-0.239 0.058-0.545-0.181-0.684z"
                }
            }
        ]
    })(props);
}
function ImCoinPound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11h-3.5v-2h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-0.5c0-0.827 0.673-1.5 1.5-1.5 0.534 0 1.032 0.288 1.3 0.75 0.138 0.239 0.444 0.321 0.683 0.182s0.321-0.444 0.182-0.683c-0.446-0.771-1.276-1.25-2.165-1.25-1.378 0-2.5 1.122-2.5 2.5v0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3h4.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"
                }
            }
        ]
    })(props);
}
function ImCoinYen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.066l1.482-2.223c0.153-0.23 0.091-0.54-0.139-0.693s-0.54-0.091-0.693 0.139l-1.584 2.376-1.584-2.376c-0.153-0.23-0.464-0.292-0.693-0.139s-0.292 0.464-0.139 0.693l1.482 2.223h-1.066c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5z"
                }
            }
        ]
    })(props);
}
function ImCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM1.5 3h13c0.271 0 0.5 0.229 0.5 0.5v1.5h-14v-1.5c0-0.271 0.229-0.5 0.5-0.5zM14.5 13h-13c-0.271 0-0.5-0.229-0.5-0.5v-4.5h14v4.5c0 0.271-0.229 0.5-0.5 0.5zM2 10h1v2h-1zM4 10h1v2h-1zM6 10h1v2h-1z"
                }
            }
        ]
    })(props);
}
function ImCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 5h-5v-1h5v1zM14 1h-5c-0.55 0-1 0.45-1 1v13c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-13c0-0.55-0.45-1-1-1zM14 10h-5v-1h5v1zM14 7h-5v-1h5v1zM6 9h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 13h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
                }
            }
        ]
    })(props);
}
function ImLifebuoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM14.468 10.679v0l-2.772-1.148c0.196-0.472 0.304-0.989 0.304-1.531s-0.108-1.059-0.304-1.531l2.772-1.148c0.342 0.825 0.532 1.73 0.532 2.679s-0.189 1.854-0.532 2.679v0zM10.679 1.532v0 0l-1.148 2.772c-0.472-0.196-0.989-0.304-1.531-0.304s-1.059 0.108-1.531 0.304l-1.148-2.772c0.825-0.342 1.73-0.532 2.679-0.532s1.854 0.189 2.679 0.532zM1.532 5.321l2.772 1.148c-0.196 0.472-0.304 0.989-0.304 1.531s0.108 1.059 0.304 1.531l-2.772 1.148c-0.342-0.825-0.532-1.73-0.532-2.679s0.189-1.854 0.532-2.679zM5.321 14.468l1.148-2.772c0.472 0.196 0.989 0.304 1.531 0.304s1.059-0.108 1.531-0.304l1.148 2.772c-0.825 0.342-1.73 0.532-2.679 0.532s-1.854-0.189-2.679-0.532z"
                }
            }
        ]
    })(props);
}
function ImPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
                }
            }
        ]
    })(props);
}
function ImPhoneHangUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.897 9c0.125 0.867 0.207 2.053-0.182 2.507-0.643 0.751-4.714 0.751-4.714-0.751 0-0.756 0.67-1.252 0.027-2.003-0.632-0.738-1.766-0.75-3.027-0.751s-2.394 0.012-3.027 0.751c-0.643 0.751 0.027 1.247 0.027 2.003 0 1.501-4.071 1.501-4.714 0.751-0.389-0.454-0.307-1.64-0.182-2.507 0.096-0.579 0.339-1.203 1.118-2 0-0 0-0 0-0 1.168-1.090 2.935-1.98 6.716-2v-0c0.021 0 0.042 0 0.063 0s0.041-0 0.063-0v0c3.781 0.019 5.548 0.91 6.716 2 0 0 0 0 0 0 0.778 0.797 1.022 1.421 1.118 2z"
                }
            }
        ]
    })(props);
}
function ImAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0v16h12v-16h-12zM9 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995v0zM12 12h-6v-1c0-1.105 0.895-2 2-2v0h2c1.105 0 2 0.895 2 2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h1.5v3h-1.5v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h1.5v3h-1.5v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h1.5v3h-1.5v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13h1.5v3h-1.5v-3z"
                }
            }
        ]
    })(props);
}
function ImEnvelop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v10c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-10c0-0.825-0.675-1.5-1.5-1.5zM6.23 8.6l-4.23 3.295v-7.838l4.23 4.543zM2.756 4h10.488l-5.244 3.938-5.244-3.938zM6.395 8.777l1.605 1.723 1.605-1.723 3.29 4.223h-9.79l3.29-4.223zM9.77 8.6l4.23-4.543v7.838l-4.23-3.295z"
                }
            }
        ]
    })(props);
}
function ImPushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function ImLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
                }
            }
        ]
    })(props);
}
function ImLocation2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0-1.070 0.867-1.938 1.938-1.938s1.938 0.867 1.938 1.938c0 1.070-0.867 1.938-1.938 1.938s-1.938-0.867-1.938-1.938z"
                }
            }
        ]
    })(props);
}
function ImCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 16c-0.036 0-0.072-0.004-0.108-0.012-0.229-0.051-0.392-0.254-0.392-0.488v-7.5h-7.5c-0.234 0-0.437-0.163-0.488-0.392s0.064-0.462 0.277-0.561l15-7c0.191-0.089 0.416-0.049 0.565 0.1s0.188 0.374 0.1 0.565l-7 15c-0.083 0.179-0.262 0.289-0.453 0.289zM2.754 7h5.746c0.276 0 0.5 0.224 0.5 0.5v5.746l5.465-11.712-11.712 5.465z"
                }
            }
        ]
    })(props);
}
function ImCompass2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5 1.712 0 3.269 0.662 4.43 1.744l-6.43 2.756-2.756 6.43c-1.082-1.161-1.744-2.718-1.744-4.43zM9.143 9.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5c-1.712 0-3.269-0.662-4.43-1.744l6.43-2.756 2.756-6.43c1.082 1.161 1.744 2.718 1.744 4.43 0 3.59-2.91 6.5-6.5 6.5z"
                }
            }
        ]
    })(props);
}
function ImMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3l5-2v12l-5 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0.5l5 3v11.5l-5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.5l4-3v12l-4 3z"
                }
            }
        ]
    })(props);
}
function ImMap2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 3l-5-2-5.5 2v12l5.5-2 5 2 5.5-2v-12l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6v-9.846zM1 3.7l4-1.455v9.872l-4 1.454v-9.872zM15 12.3l-4 1.455v-9.872l4-1.455v9.872z"
                }
            }
        ]
    })(props);
}
function ImHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c3.866 0 7 3.134 7 7s-3.134 7-7 7v-1.5c1.469 0 2.85-0.572 3.889-1.611s1.611-2.42 1.611-3.889c0-1.469-0.572-2.85-1.611-3.889s-2.42-1.611-3.889-1.611c-1.469 0-2.85 0.572-3.889 1.611-0.799 0.799-1.322 1.801-1.52 2.889h2.909l-3.5 4-3.5-4h2.571c0.485-3.392 3.402-6 6.929-6zM13 7v2h-4v-5h2v3z"
                }
            }
        ]
    })(props);
}
function ImClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            }
        ]
    })(props);
}
function ImClock2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function ImAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v-4h-1v5h4v-1z"
                }
            }
        ]
    })(props);
}
function ImBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.023 12.5c0-4.5-4-3.5-4-7 0-0.29-0.028-0.538-0.079-0.749-0.263-1.766-1.44-3.183-2.965-3.615 0.014-0.062 0.021-0.125 0.021-0.191 0-0.52-0.45-0.945-1-0.945s-1 0.425-1 0.945c0 0.065 0.007 0.129 0.021 0.191-1.71 0.484-2.983 2.208-3.020 4.273-0.001 0.030-0.001 0.060-0.001 0.091 0 3.5-4 2.5-4 7 0 1.191 2.665 2.187 6.234 2.439 0.336 0.631 1.001 1.061 1.766 1.061s1.43-0.43 1.766-1.061c3.568-0.251 6.234-1.248 6.234-2.439 0-0.004-0-0.007-0-0.011l0.024 0.011zM12.91 13.345c-0.847 0.226-1.846 0.389-2.918 0.479-0.089-1.022-0.947-1.824-1.992-1.824s-1.903 0.802-1.992 1.824c-1.072-0.090-2.071-0.253-2.918-0.479-1.166-0.311-1.724-0.659-1.928-0.845 0.204-0.186 0.762-0.534 1.928-0.845 1.356-0.362 3.1-0.561 4.91-0.561s3.554 0.199 4.91 0.561c1.166 0.311 1.724 0.659 1.928 0.845-0.204 0.186-0.762 0.534-1.928 0.845z"
                }
            }
        ]
    })(props);
}
function ImStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.019v-1.019h2v-1c0-0.552-0.448-1-1-1h-3c-0.552 0-1 0.448-1 1v1h2v1.019c-3.356 0.255-6 3.059-6 6.481 0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5c0-3.422-2.644-6.226-6-6.481zM11.036 13.036c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.907-0.907 2.101-1.422 3.377-1.462l-0.339 4.907c-0.029 0.411 0.195 0.591 0.497 0.591s0.527-0.18 0.497-0.591l-0.339-4.907c1.276 0.040 2.47 0.555 3.377 1.462 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536z"
                }
            }
        ]
    })(props);
}
function ImCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h2v2h-2zM8 6h2v2h-2zM11 6h2v2h-2zM2 12h2v2h-2zM5 12h2v2h-2zM8 12h2v2h-2zM5 9h2v2h-2zM8 9h2v2h-2zM11 9h2v2h-2zM2 9h2v2h-2zM13 0v1h-2v-1h-7v1h-2v-1h-2v16h15v-16h-2zM14 15h-13v-11h13v11z"
                }
            }
        ]
    })(props);
}
function ImPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1h8v2h-8v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h-14c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v4h8v-4h3c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM2 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function ImKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-16c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM10 4h2v2h-2v-2zM13 7v2h-2v-2h2zM7 4h2v2h-2v-2zM10 7v2h-2v-2h2zM4 4h2v2h-2v-2zM7 7v2h-2v-2h2zM2 4h1v2h-1v-2zM2 7h2v2h-2v-2zM3 12h-1v-2h1v2zM12 12h-8v-2h8v2zM16 12h-3v-2h3v2zM16 9h-2v-2h2v2zM16 6h-3v-2h3v2z"
                }
            }
        ]
    })(props);
}
function ImDisplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1z"
                }
            }
        ]
    })(props);
}
function ImLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z"
                }
            }
        ]
    })(props);
}
function ImMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 0h-7c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h7c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 0.75h4v0.5h-4v-0.5zM8 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM12 12h-8v-10h8v10z"
                }
            }
        ]
    })(props);
}
function ImMobile2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0h-9c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM7.5 15.278c-0.43 0-0.778-0.348-0.778-0.778s0.348-0.778 0.778-0.778 0.778 0.348 0.778 0.778-0.348 0.778-0.778 0.778zM12 13h-9v-11h9v11z"
                }
            }
        ]
    })(props);
}
function ImTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 0h-10c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h10c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7.5 15.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12 14h-9v-12h9v12z"
                }
            }
        ]
    })(props);
}
function ImTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.331 4.502c-1.388-0.199-2.865-0.344-4.407-0.425l2.576-2.576-1-1-3.509 3.509c-0.328-0.006-0.659-0.009-0.991-0.009v0l-4-4-1 1 3.034 3.034c-1.889 0.066-3.693 0.227-5.365 0.467-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM13.498 13.666c-1.683 0.215-3.543 0.334-5.498 0.334s-3.815-0.119-5.498-0.334c-0.323-1.122-0.502-2.362-0.502-3.666s0.179-2.543 0.502-3.666c1.683-0.215 3.543-0.334 5.498-0.334s3.815 0.119 5.498 0.334c0.323 1.122 0.502 2.362 0.502 3.666s-0.179 2.543-0.502 3.666z"
                }
            }
        ]
    })(props);
}
function ImDrawer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 8h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImDrawer2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
                }
            }
        ]
    })(props);
}
function ImBoxAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM8 13l-5-4h3v-3h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1h-11.172z"
                }
            }
        ]
    })(props);
}
function ImBoxRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM10 10v3h-4v-3h-3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1h-11.171z"
                }
            }
        ]
    })(props);
}
function ImDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9l4-4h-3v-4h-2v4h-3zM11.636 7.364l-1.121 1.121 4.064 1.515-6.579 2.453-6.579-2.453 4.064-1.515-1.121-1.121-4.364 1.636v4l8 3 8-3v-4z"
                }
            }
        ]
    })(props);
}
function ImUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h2v-4h3l-4-4-4 4h3zM10 6.75v1.542l4.579 1.708-6.579 2.453-6.579-2.453 4.579-1.708v-1.542l-6 2.25v4l8 3 8-3v-4z"
                }
            }
        ]
    })(props);
}
function ImFloppyDisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-14v16h16v-14l-2-2zM8 2h2v4h-2v-4zM14 14h-12v-12h1v5h9v-5h1.172l0.828 0.828v11.172z"
                }
            }
        ]
    })(props);
}
function ImDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 12h1v1h-1v-1zM15 2h-14l-1 8h16z"
                }
            }
        ]
    })(props);
}
function ImDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 1.119-8 2.5v2c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-2c0-1.381-3.582-2.5-8-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.5c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
                }
            }
        ]
    })(props);
}
function ImUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-2.209 0-4.209 0.896-5.657 2.343l-2.343-2.343v6h6l-2.243-2.243c1.086-1.086 2.586-1.757 4.243-1.757 3.314 0 6 2.686 6 6 0 1.792-0.786 3.401-2.032 4.5l1.323 1.5c1.661-1.466 2.709-3.611 2.709-6 0-4.418-3.582-8-8-8z"
                }
            }
        ]
    })(props);
}
function ImRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9c0 2.389 1.048 4.534 2.709 6l1.323-1.5c-1.246-1.099-2.031-2.708-2.031-4.5 0-3.314 2.686-6 6-6 1.657 0 3.157 0.672 4.243 1.757l-2.243 2.243h6v-6l-2.343 2.343c-1.448-1.448-3.448-2.343-5.657-2.343-4.418 0-8 3.582-8 8z"
                }
            }
        ]
    })(props);
}
function ImUndo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.904 16c1.777-3.219 2.076-8.13-4.904-7.966v3.966l-6-6 6-6v3.881c8.359-0.218 9.29 7.378 4.904 12.119z"
                }
            }
        ]
    })(props);
}
function ImRedo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3.881v-3.881l6 6-6 6v-3.966c-6.98-0.164-6.681 4.747-4.904 7.966-4.386-4.741-3.455-12.337 4.904-12.119z"
                }
            }
        ]
    })(props);
}
function ImForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.096 0c-1.777 3.219-2.076 8.13 4.904 7.966v-3.966l6 6-6 6v-3.881c-8.359 0.218-9.29-7.378-4.904-12.119z"
                }
            }
        ]
    })(props);
}
function ImReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z"
                }
            }
        ]
    })(props);
}
function ImBubble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                }
            }
        ]
    })(props);
}
function ImBubbles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM8 0c4.351 0 7.89 2.822 7.997 6.336-0.768-0.343-1.619-0.524-2.497-0.524-1.493 0-2.903 0.523-3.971 1.472-1.107 0.984-1.717 2.304-1.717 3.716 0 0.698 0.149 1.373 0.433 1.997-0.082 0.002-0.164 0.003-0.246 0.003-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                }
            }
        ]
    })(props);
}
function ImBubbles2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
                }
            }
        ]
    })(props);
}
function ImBubble2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3c-0.858 0-1.687 0.135-2.464 0.402-0.73 0.251-1.38 0.605-1.932 1.054-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.328 0.042 0.662 0.063 0.995 0.063 0.858 0 1.687-0.135 2.464-0.402 0.73-0.251 1.38-0.605 1.932-1.054 1.035-0.841 1.604-1.922 1.604-3.044s-0.57-2.203-1.604-3.044c-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402zM8 1v0c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
                }
            }
        ]
    })(props);
}
function ImBubbles3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM3.604 3.456c-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.327 0.042 0.662 0.063 0.994 0.063v2c-0.424-0-0.84-0.027-1.246-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336-0.642-0.286-1.341-0.46-2.067-0.509-0.18-0.876-0.709-1.7-1.535-2.371-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402s-1.687 0.135-2.464 0.402c-0.73 0.251-1.38 0.605-1.932 1.054z"
                }
            }
        ]
    })(props);
}
function ImBubbles4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 2c-0.792 0-1.556 0.124-2.272 0.369-0.671 0.23-1.267 0.554-1.773 0.963-0.938 0.759-1.455 1.731-1.455 2.737 0 0.562 0.157 1.109 0.467 1.623 0.323 0.537 0.811 1.028 1.41 1.421 0.476 0.312 0.796 0.812 0.881 1.374 0.014 0.094 0.025 0.188 0.034 0.282 0.043-0.039 0.085-0.080 0.127-0.122 0.377-0.376 0.886-0.583 1.411-0.583 0.084 0 0.167 0.005 0.251 0.016 0.303 0.038 0.611 0.058 0.918 0.058 0.792 0 1.556-0.124 2.272-0.369 0.671-0.23 1.267-0.554 1.774-0.963 0.938-0.759 1.455-1.731 1.455-2.737s-0.517-1.978-1.455-2.737c-0.506-0.41-1.103-0.734-1.774-0.963-0.716-0.245-1.48-0.369-2.272-0.369zM7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
                }
            }
        ]
    })(props);
}
function ImUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
                }
            }
        ]
    })(props);
}
function ImUsers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 18 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.112 12.427c0.864-0.565 1.939-0.994 3.122-1.256-0.235-0.278-0.449-0.588-0.633-0.922-0.475-0.863-0.726-1.813-0.726-2.748 0-1.344 0-2.614 0.478-3.653 0.464-1.008 1.299-1.633 2.488-1.867-0.264-1.195-0.968-1.98-2.841-1.98-3 0-3 2.015-3 4.5 0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h4.359c0.227-0.202 0.478-0.393 0.753-0.573z"
                }
            }
        ]
    })(props);
}
function ImUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
                }
            }
        ]
    })(props);
}
function ImUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-5v-1h5v1z"
                }
            }
        ]
    })(props);
}
function ImUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.5l-4.5 4.5-1.5-1.5-1 1 2.5 2.5 5.5-5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h5v-1.799c-1.050-0.613-2.442-1.033-4-1.16v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h7v-1z"
                }
            }
        ]
    })(props);
}
function ImUserTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM12.001 7h-0.553l-3.111 6.316 1.163-5.816-1.5-1.5-1.5 1.5 1.163 5.816-3.111-6.316h-0.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z"
                }
            }
        ]
    })(props);
}
function ImQuotesLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"
                }
            }
        ]
    })(props);
}
function ImQuotesRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043zM3.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043z"
                }
            }
        ]
    })(props);
}
function ImHourGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.39 8c2.152-1.365 3.61-3.988 3.61-7 0-0.339-0.019-0.672-0.054-1h-13.891c-0.036 0.328-0.054 0.661-0.054 1 0 3.012 1.457 5.635 3.609 7-2.152 1.365-3.609 3.988-3.609 7 0 0.339 0.019 0.672 0.054 1h13.891c0.036-0.328 0.054-0.661 0.054-1 0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214v-1.572c-2.247-0.817-3.5-3.294-3.5-6.214v0h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247 0.817 3.5 3.294 3.5 6.214h-11zM9.682 10.462c-1.12-0.635-1.181-1.459-1.182-1.959v-1.004c0-0.5 0.059-1.327 1.184-1.963 0.602-0.349 1.122-0.88 1.516-1.537h-6.4c0.395 0.657 0.916 1.188 1.518 1.538 1.12 0.635 1.181 1.459 1.182 1.959v1.004c0 0.5-0.059 1.327-1.184 1.963-1.135 0.659-1.98 1.964-2.236 3.537h7.839c-0.256-1.574-1.102-2.879-2.238-3.538z"
                }
            }
        ]
    })(props);
}
function ImSpinner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.243 3.757c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM13 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.243 12.243c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 14c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.757 12.243c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.257 3.757c0 0 0 0 0 0 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0.875 8c0-0.621 0.504-1.125 1.125-1.125s1.125 0.504 1.125 1.125c0 0.621-0.504 1.125-1.125 1.125s-1.125-0.504-1.125-1.125z"
                }
            }
        ]
    })(props);
}
function ImSpinner2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z"
                }
            }
        ]
    })(props);
}
function ImSpinner3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.736c-0.515 0-0.933-0.418-0.933-0.933v-2.798c0-0.515 0.418-0.933 0.933-0.933s0.933 0.418 0.933 0.933v2.798c0 0.515-0.418 0.933-0.933 0.933z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.577c-0.322 0-0.583-0.261-0.583-0.583v-2.798c0-0.322 0.261-0.583 0.583-0.583s0.583 0.261 0.583 0.583v2.798c0 0.322-0.261 0.583-0.583 0.583z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.902 5.24c-0.302 0-0.596-0.157-0.758-0.437l-1.399-2.423c-0.241-0.418-0.098-0.953 0.32-1.194s0.953-0.098 1.194 0.32l1.399 2.423c0.241 0.418 0.098 0.953-0.32 1.194-0.138 0.079-0.288 0.117-0.436 0.117z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.498 14.582c-0.181 0-0.358-0.094-0.455-0.262l-1.399-2.423c-0.145-0.251-0.059-0.572 0.192-0.717s0.572-0.059 0.717 0.192l1.399 2.423c0.145 0.251 0.059 0.572-0.192 0.717-0.083 0.048-0.173 0.070-0.262 0.070z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.365 6.718c-0.138 0-0.279-0.035-0.407-0.109l-2.423-1.399c-0.39-0.225-0.524-0.724-0.299-1.115s0.724-0.524 1.115-0.299l2.423 1.399c0.39 0.225 0.524 0.724 0.299 1.115-0.151 0.262-0.425 0.408-0.707 0.408z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.057 11.964c-0.079 0-0.159-0.020-0.233-0.063l-2.423-1.399c-0.223-0.129-0.299-0.414-0.171-0.637s0.414-0.299 0.637-0.171l2.423 1.399c0.223 0.129 0.299 0.414 0.171 0.637-0.086 0.15-0.243 0.233-0.404 0.233z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.803 8.758h-2.798c-0.418 0-0.758-0.339-0.758-0.758s0.339-0.758 0.758-0.758h2.798c0.419 0 0.758 0.339 0.758 0.758s-0.339 0.758-0.758 0.758z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.995 8.466c-0 0 0 0 0 0h-2.798c-0.258-0-0.466-0.209-0.466-0.466s0.209-0.466 0.466-0.466c0 0 0 0 0 0h2.798c0.258 0 0.466 0.209 0.466 0.466s-0.209 0.466-0.466 0.466z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.943 12.197c-0.242 0-0.477-0.125-0.606-0.35-0.193-0.335-0.079-0.762 0.256-0.955l2.423-1.399c0.335-0.193 0.762-0.079 0.955 0.256s0.079 0.762-0.256 0.955l-2.423 1.399c-0.11 0.064-0.23 0.094-0.349 0.094z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.635 6.368c-0.161 0-0.318-0.084-0.404-0.233-0.129-0.223-0.052-0.508 0.171-0.637l2.423-1.399c0.223-0.129 0.508-0.052 0.637 0.171s0.052 0.508-0.171 0.637l-2.423 1.399c-0.073 0.042-0.154 0.063-0.233 0.063z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.502 14.699c-0.109 0-0.219-0.028-0.32-0.086-0.307-0.177-0.412-0.569-0.235-0.876l1.399-2.423c0.177-0.307 0.569-0.412 0.876-0.235s0.412 0.569 0.235 0.876l-1.399 2.423c-0.119 0.206-0.334 0.321-0.556 0.321z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.098 4.832c-0.079 0-0.159-0.020-0.233-0.063-0.223-0.129-0.299-0.414-0.171-0.637l1.399-2.423c0.129-0.223 0.414-0.299 0.637-0.171s0.299 0.414 0.171 0.637l-1.399 2.423c-0.086 0.15-0.243 0.233-0.404 0.233z"
                }
            }
        ]
    })(props);
}
function ImSpinner4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8c0-0.19 0.011-0.378 0.032-0.563l-2.89-0.939c-0.092 0.487-0.141 0.989-0.141 1.502 0 2.3 0.971 4.374 2.526 5.833l1.786-2.458c-0.814-0.889-1.312-2.074-1.312-3.375zM13 8c0 1.301-0.497 2.486-1.312 3.375l1.786 2.458c1.555-1.459 2.526-3.533 2.526-5.833 0-0.513-0.049-1.015-0.141-1.502l-2.89 0.939c0.021 0.185 0.032 0.373 0.032 0.563zM9 3.1c1.436 0.292 2.649 1.199 3.351 2.435l2.89-0.939c-1.144-2.428-3.473-4.188-6.241-4.534v3.038zM3.649 5.535c0.702-1.236 1.914-2.143 3.351-2.435v-3.038c-2.769 0.345-5.097 2.105-6.241 4.534l2.89 0.939zM10.071 12.552c-0.631 0.288-1.332 0.448-2.071 0.448s-1.44-0.16-2.071-0.448l-1.786 2.458c1.144 0.631 2.458 0.99 3.857 0.99s2.713-0.359 3.857-0.99l-1.786-2.458z"
                }
            }
        ]
    })(props);
}
function ImSpinner5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 4c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zM12.773 12.773c-1.275 1.275-2.97 1.977-4.773 1.977s-3.498-0.702-4.773-1.977-1.977-2.97-1.977-4.773c0-1.803 0.702-3.498 1.977-4.773l1.061 1.061c0 0 0 0 0 0-2.047 2.047-2.047 5.378 0 7.425 0.992 0.992 2.31 1.538 3.712 1.538s2.721-0.546 3.712-1.538c2.047-2.047 2.047-5.378 0-7.425l1.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773z"
                }
            }
        ]
    })(props);
}
function ImSpinner6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12.359 8c0 0 0 0 0 0 0-0.906 0.735-1.641 1.641-1.641s1.641 0.735 1.641 1.641c0 0 0 0 0 0 0 0.906-0.735 1.641-1.641 1.641s-1.641-0.735-1.641-1.641zM10.757 12.243c0-0.821 0.665-1.486 1.486-1.486s1.486 0.665 1.486 1.486c0 0.821-0.665 1.486-1.486 1.486s-1.486-0.665-1.486-1.486zM6.654 14c0-0.743 0.603-1.346 1.346-1.346s1.346 0.603 1.346 1.346c0 0.743-0.603 1.346-1.346 1.346s-1.346-0.603-1.346-1.346zM2.538 12.243c0-0.673 0.546-1.219 1.219-1.219s1.219 0.546 1.219 1.219c0 0.673-0.546 1.219-1.219 1.219s-1.219-0.546-1.219-1.219zM0.896 8c0-0.61 0.494-1.104 1.104-1.104s1.104 0.494 1.104 1.104c0 0.61-0.494 1.104-1.104 1.104s-1.104-0.494-1.104-1.104zM2.757 3.757c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM14.054 3.757c0 1-0.811 1.811-1.812 1.811s-1.812-0.811-1.812-1.811c0-1.001 0.811-1.811 1.812-1.811s1.812 0.811 1.812 1.811z"
                }
            }
        ]
    })(props);
}
function ImSpinner7(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM13 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function ImSpinner8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c-2.137 0-4.146-0.832-5.657-2.343s-2.343-3.52-2.343-5.657c0-1.513 0.425-2.986 1.228-4.261 0.781-1.239 1.885-2.24 3.193-2.895l0.672 1.341c-1.063 0.533-1.961 1.347-2.596 2.354-0.652 1.034-0.997 2.231-0.997 3.461 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-0.345-2.426-0.997-3.461-0.635-1.008-1.533-1.822-2.596-2.354l0.672-1.341c1.308 0.655 2.412 1.656 3.193 2.895 0.803 1.274 1.228 2.748 1.228 4.261 0 2.137-0.832 4.146-2.343 5.657s-3.52 2.343-5.657 2.343z"
                }
            }
        ]
    })(props);
}
function ImSpinner9(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.355 0-7.898 3.481-7.998 7.812 0.092-3.779 2.966-6.812 6.498-6.812 3.59 0 6.5 3.134 6.5 7 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-4.418-3.582-8-8-8zM8 16c4.355 0 7.898-3.481 7.998-7.812-0.092 3.779-2.966 6.812-6.498 6.812-3.59 0-6.5-3.134-6.5-7 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 4.418 3.582 8 8 8z"
                }
            }
        ]
    })(props);
}
function ImSpinner10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.001 8.025l-0 0c0 0 0 0.001 0 0.003 0.002 0.061 0.009 0.12 0.021 0.177 0.003 0.027 0.007 0.057 0.011 0.090 0.003 0.029 0.007 0.061 0.011 0.095 0.006 0.040 0.012 0.083 0.019 0.128 0.013 0.090 0.028 0.189 0.045 0.296 0.021 0.101 0.044 0.21 0.068 0.326 0.011 0.058 0.028 0.117 0.044 0.178s0.032 0.123 0.049 0.188c0.009 0.032 0.016 0.065 0.027 0.097s0.021 0.065 0.031 0.098 0.043 0.134 0.065 0.203c0.006 0.017 0.011 0.035 0.017 0.052s0.013 0.034 0.019 0.052 0.026 0.070 0.039 0.105c0.027 0.070 0.053 0.142 0.081 0.215 0.031 0.071 0.062 0.144 0.094 0.218 0.016 0.037 0.032 0.074 0.048 0.111s0.035 0.073 0.053 0.111 0.073 0.148 0.11 0.224c0.039 0.075 0.081 0.149 0.123 0.224 0.021 0.037 0.042 0.075 0.063 0.113s0.045 0.074 0.068 0.112 0.093 0.149 0.14 0.224c0.198 0.295 0.417 0.587 0.66 0.864 0.245 0.275 0.511 0.535 0.792 0.775 0.284 0.236 0.582 0.452 0.886 0.642 0.306 0.188 0.619 0.349 0.928 0.487 0.078 0.032 0.156 0.063 0.232 0.095 0.038 0.015 0.076 0.032 0.115 0.046s0.077 0.027 0.115 0.041 0.151 0.054 0.226 0.078c0.075 0.022 0.15 0.044 0.224 0.066 0.037 0.011 0.073 0.022 0.109 0.031s0.073 0.018 0.109 0.027 0.143 0.035 0.213 0.052c0.070 0.014 0.139 0.027 0.207 0.040 0.034 0.006 0.067 0.013 0.101 0.019 0.017 0.003 0.033 0.006 0.049 0.009s0.033 0.005 0.049 0.007c0.066 0.009 0.13 0.018 0.192 0.027 0.031 0.004 0.062 0.009 0.093 0.013s0.061 0.006 0.091 0.009 0.118 0.010 0.174 0.015c0.056 0.005 0.111 0.011 0.164 0.012 0.004 0 0.007 0 0.011 0 0.010 0.544 0.453 0.982 1 0.982 0.008 0 0.017-0 0.025-0.001v0c0 0 0.001-0 0.004-0 0.061-0.002 0.12-0.009 0.177-0.021 0.027-0.003 0.057-0.007 0.090-0.011 0.029-0.003 0.061-0.007 0.095-0.011 0.040-0.006 0.083-0.012 0.128-0.019 0.090-0.013 0.189-0.028 0.296-0.045 0.101-0.021 0.21-0.044 0.326-0.068 0.058-0.011 0.117-0.028 0.178-0.044s0.123-0.033 0.188-0.049c0.032-0.009 0.065-0.016 0.097-0.027s0.065-0.021 0.098-0.031 0.134-0.043 0.203-0.065c0.017-0.006 0.035-0.011 0.052-0.017s0.034-0.013 0.052-0.019 0.070-0.026 0.105-0.039c0.070-0.027 0.142-0.053 0.215-0.081 0.071-0.031 0.144-0.062 0.218-0.094 0.037-0.016 0.074-0.032 0.111-0.048s0.073-0.035 0.111-0.053 0.148-0.073 0.224-0.11c0.075-0.039 0.149-0.081 0.224-0.123 0.037-0.021 0.075-0.042 0.113-0.063s0.074-0.045 0.112-0.068 0.149-0.093 0.224-0.14c0.295-0.197 0.587-0.417 0.864-0.66 0.275-0.245 0.535-0.511 0.775-0.792 0.236-0.284 0.452-0.582 0.642-0.886 0.188-0.306 0.349-0.619 0.487-0.928 0.032-0.078 0.063-0.156 0.095-0.232 0.015-0.038 0.032-0.076 0.046-0.115s0.027-0.077 0.040-0.115 0.054-0.151 0.078-0.226c0.022-0.075 0.044-0.15 0.066-0.224 0.011-0.037 0.022-0.073 0.031-0.109s0.018-0.073 0.027-0.109 0.035-0.143 0.052-0.213c0.014-0.070 0.027-0.139 0.040-0.207 0.006-0.034 0.013-0.067 0.019-0.101 0.003-0.017 0.006-0.033 0.009-0.049s0.005-0.033 0.007-0.050c0.009-0.065 0.018-0.13 0.027-0.192 0.004-0.031 0.009-0.062 0.013-0.093s0.006-0.061 0.009-0.091 0.010-0.118 0.015-0.174c0.005-0.056 0.011-0.111 0.012-0.165 0-0.008 0.001-0.016 0.001-0.025 0.55-0.002 0.996-0.449 0.996-1 0-0.008-0-0.017-0.001-0.025h0c0 0-0-0.001-0-0.003-0.002-0.061-0.009-0.12-0.021-0.177-0.003-0.027-0.007-0.057-0.011-0.090-0.003-0.029-0.007-0.061-0.011-0.095-0.006-0.040-0.012-0.083-0.019-0.128-0.013-0.090-0.028-0.189-0.045-0.296-0.021-0.101-0.044-0.21-0.068-0.326-0.011-0.058-0.028-0.117-0.044-0.178s-0.032-0.123-0.049-0.188c-0.009-0.032-0.016-0.065-0.027-0.097s-0.021-0.065-0.031-0.098-0.043-0.134-0.065-0.203c-0.005-0.017-0.011-0.035-0.017-0.052s-0.013-0.034-0.019-0.052-0.026-0.070-0.039-0.105c-0.027-0.070-0.053-0.142-0.081-0.215-0.031-0.071-0.062-0.144-0.094-0.218-0.016-0.037-0.032-0.074-0.048-0.111s-0.035-0.073-0.053-0.111-0.073-0.148-0.11-0.224c-0.039-0.075-0.081-0.149-0.123-0.224-0.021-0.037-0.042-0.075-0.063-0.113s-0.045-0.074-0.068-0.112-0.093-0.149-0.14-0.224c-0.197-0.295-0.417-0.587-0.66-0.864-0.245-0.275-0.511-0.535-0.792-0.775-0.284-0.236-0.582-0.452-0.886-0.642-0.306-0.188-0.619-0.349-0.928-0.487-0.078-0.032-0.156-0.063-0.232-0.095-0.038-0.015-0.076-0.032-0.115-0.046s-0.077-0.027-0.115-0.040-0.151-0.054-0.226-0.078c-0.075-0.022-0.15-0.044-0.224-0.066-0.037-0.010-0.073-0.022-0.109-0.031s-0.073-0.018-0.109-0.027-0.143-0.035-0.213-0.052c-0.070-0.014-0.139-0.027-0.207-0.040-0.034-0.006-0.067-0.013-0.101-0.019-0.017-0.003-0.033-0.006-0.049-0.009s-0.033-0.005-0.049-0.007c-0.066-0.009-0.13-0.018-0.192-0.027-0.031-0.004-0.062-0.009-0.093-0.013s-0.061-0.006-0.091-0.009-0.118-0.010-0.174-0.015c-0.056-0.005-0.111-0.011-0.164-0.012-0.013-0-0.026-0.001-0.039-0.001-0.010-0.543-0.454-0.981-0.999-0.981-0.008 0-0.017 0-0.025 0.001l-0-0c0 0-0.001 0-0.003 0-0.061 0.002-0.12 0.009-0.177 0.021-0.027 0.003-0.057 0.007-0.090 0.011-0.029 0.003-0.061 0.007-0.095 0.011-0.040 0.006-0.083 0.012-0.128 0.019-0.090 0.013-0.189 0.028-0.296 0.045-0.101 0.021-0.21 0.044-0.326 0.068-0.058 0.011-0.117 0.028-0.178 0.044s-0.123 0.033-0.188 0.049c-0.032 0.009-0.065 0.016-0.097 0.027s-0.065 0.021-0.098 0.031-0.134 0.043-0.203 0.065c-0.017 0.006-0.035 0.011-0.052 0.017s-0.034 0.013-0.052 0.019-0.070 0.026-0.105 0.039c-0.070 0.027-0.142 0.053-0.215 0.081-0.071 0.031-0.144 0.062-0.218 0.094-0.037 0.016-0.074 0.032-0.111 0.048s-0.073 0.035-0.111 0.053-0.148 0.073-0.224 0.11c-0.075 0.039-0.149 0.081-0.224 0.123-0.037 0.021-0.075 0.042-0.113 0.063s-0.074 0.045-0.112 0.068-0.149 0.093-0.224 0.14c-0.295 0.198-0.587 0.417-0.864 0.66-0.275 0.245-0.535 0.511-0.775 0.792-0.236 0.284-0.452 0.582-0.642 0.886-0.188 0.306-0.349 0.619-0.487 0.928-0.032 0.078-0.063 0.156-0.095 0.232-0.015 0.038-0.032 0.076-0.046 0.115s-0.027 0.077-0.040 0.115-0.054 0.151-0.078 0.226c-0.022 0.075-0.044 0.15-0.066 0.224-0.011 0.037-0.022 0.073-0.032 0.109s-0.018 0.073-0.027 0.109-0.035 0.143-0.052 0.213c-0.014 0.070-0.027 0.139-0.040 0.207-0.006 0.034-0.013 0.067-0.019 0.101-0.003 0.017-0.006 0.033-0.009 0.049s-0.005 0.033-0.007 0.050c-0.009 0.065-0.018 0.13-0.027 0.192-0.004 0.031-0.009 0.062-0.013 0.093s-0.006 0.061-0.009 0.091-0.010 0.118-0.015 0.174c-0.005 0.056-0.011 0.111-0.012 0.165-0 0.009-0.001 0.017-0.001 0.025-0.537 0.017-0.967 0.458-0.967 0.999 0 0.008 0 0.017 0.001 0.025zM1.149 7.011c0.001-0.003 0.001-0.006 0.002-0.009 0.010-0.051 0.026-0.102 0.040-0.155s0.030-0.107 0.045-0.163c0.008-0.028 0.015-0.056 0.024-0.084s0.019-0.057 0.028-0.086 0.038-0.116 0.058-0.176c0.005-0.015 0.010-0.030 0.015-0.045s0.012-0.030 0.017-0.045 0.023-0.060 0.035-0.091 0.048-0.123 0.073-0.186c0.028-0.062 0.056-0.125 0.084-0.189 0.014-0.032 0.028-0.064 0.043-0.096s0.032-0.064 0.048-0.096 0.065-0.128 0.098-0.194c0.034-0.065 0.073-0.128 0.109-0.194 0.018-0.032 0.037-0.065 0.056-0.098s0.040-0.064 0.061-0.096c0.041-0.064 0.082-0.129 0.124-0.194 0.176-0.255 0.369-0.506 0.583-0.744 0.217-0.236 0.451-0.459 0.697-0.665 0.25-0.202 0.511-0.385 0.776-0.547 0.268-0.159 0.541-0.294 0.808-0.41 0.068-0.027 0.135-0.053 0.202-0.079 0.033-0.013 0.066-0.027 0.099-0.038s0.067-0.022 0.1-0.033 0.131-0.045 0.196-0.065c0.065-0.018 0.13-0.036 0.194-0.054 0.032-0.009 0.063-0.019 0.095-0.026s0.063-0.014 0.094-0.021 0.123-0.028 0.184-0.042c0.061-0.011 0.12-0.021 0.179-0.032 0.029-0.005 0.058-0.010 0.087-0.015 0.014-0.003 0.029-0.005 0.043-0.008s0.029-0.003 0.043-0.005c0.056-0.007 0.112-0.014 0.166-0.020 0.027-0.003 0.053-0.007 0.080-0.010s0.053-0.004 0.078-0.006 0.102-0.007 0.15-0.011c0.049-0.003 0.095-0.008 0.142-0.008 0.091-0.002 0.177-0.004 0.256-0.006 0.073 0.003 0.14 0.005 0.2 0.007 0.030 0.001 0.058 0.002 0.085 0.002 0.033 0.002 0.064 0.004 0.093 0.006 0.033 0.002 0.063 0.004 0.091 0.006 0.051 0.008 0.103 0.012 0.156 0.012 0.007 0 0.015-0 0.022-0.001 0.002 0 0.004 0 0.004 0v-0c0.487-0.012 0.887-0.372 0.962-0.84 0.008 0.002 0.017 0.004 0.025 0.006 0.051 0.010 0.102 0.026 0.155 0.040s0.107 0.030 0.163 0.045c0.028 0.008 0.056 0.015 0.084 0.024s0.057 0.019 0.086 0.028 0.116 0.038 0.176 0.058c0.015 0.005 0.030 0.010 0.045 0.015s0.030 0.012 0.045 0.017 0.060 0.023 0.091 0.035 0.123 0.048 0.186 0.073c0.062 0.028 0.125 0.056 0.189 0.084 0.032 0.014 0.064 0.028 0.096 0.043s0.064 0.032 0.096 0.048 0.128 0.065 0.194 0.098c0.065 0.034 0.129 0.073 0.194 0.109 0.032 0.018 0.065 0.037 0.098 0.056s0.064 0.040 0.096 0.061 0.129 0.082 0.194 0.124c0.255 0.176 0.506 0.369 0.744 0.583 0.236 0.217 0.459 0.451 0.665 0.697 0.202 0.25 0.385 0.511 0.547 0.776 0.159 0.268 0.294 0.541 0.41 0.808 0.027 0.068 0.053 0.135 0.079 0.202 0.013 0.033 0.027 0.066 0.038 0.099s0.022 0.067 0.033 0.1 0.045 0.131 0.065 0.196c0.018 0.065 0.036 0.13 0.054 0.194 0.009 0.032 0.019 0.063 0.026 0.095s0.014 0.063 0.021 0.094 0.028 0.123 0.042 0.184c0.011 0.061 0.021 0.12 0.032 0.179 0.005 0.029 0.010 0.058 0.015 0.087 0.003 0.014 0.005 0.029 0.008 0.043s0.003 0.029 0.005 0.043c0.007 0.056 0.014 0.112 0.020 0.166 0.003 0.027 0.007 0.053 0.010 0.080s0.004 0.053 0.006 0.078 0.007 0.102 0.011 0.15c0.003 0.049 0.008 0.095 0.008 0.142 0.002 0.091 0.004 0.177 0.006 0.256-0.003 0.073-0.005 0.14-0.007 0.2-0.001 0.030-0.002 0.058-0.002 0.085-0.002 0.033-0.004 0.064-0.006 0.093-0.002 0.033-0.004 0.063-0.006 0.091-0.008 0.051-0.012 0.103-0.012 0.156 0 0.007 0 0.015 0.001 0.022-0 0.002-0 0.004-0 0.004h0c0.012 0.481 0.363 0.877 0.823 0.959-0.001 0.005-0.002 0.009-0.003 0.014-0.010 0.051-0.025 0.102-0.040 0.155s-0.030 0.107-0.045 0.163c-0.008 0.028-0.015 0.056-0.024 0.084s-0.019 0.057-0.028 0.086-0.039 0.116-0.058 0.176c-0.005 0.015-0.010 0.030-0.015 0.045s-0.012 0.030-0.017 0.045-0.023 0.060-0.035 0.091-0.048 0.123-0.073 0.186c-0.028 0.062-0.056 0.125-0.084 0.189-0.014 0.032-0.028 0.064-0.043 0.096s-0.032 0.064-0.048 0.096-0.065 0.128-0.098 0.194c-0.034 0.065-0.073 0.129-0.109 0.194-0.018 0.032-0.037 0.065-0.056 0.098s-0.040 0.064-0.061 0.096-0.082 0.129-0.124 0.194c-0.176 0.255-0.369 0.506-0.583 0.744-0.217 0.236-0.451 0.459-0.697 0.665-0.25 0.202-0.511 0.385-0.776 0.547-0.268 0.159-0.541 0.294-0.808 0.41-0.068 0.027-0.135 0.053-0.202 0.079-0.033 0.013-0.066 0.027-0.099 0.038s-0.067 0.022-0.1 0.033-0.131 0.045-0.196 0.065c-0.065 0.018-0.13 0.036-0.194 0.054-0.032 0.009-0.063 0.019-0.095 0.026s-0.063 0.014-0.094 0.021-0.123 0.028-0.184 0.042c-0.061 0.011-0.12 0.021-0.179 0.032-0.029 0.005-0.058 0.010-0.087 0.015-0.014 0.003-0.028 0.005-0.043 0.008s-0.029 0.003-0.043 0.005c-0.056 0.007-0.112 0.014-0.166 0.020-0.027 0.003-0.053 0.007-0.080 0.010s-0.053 0.004-0.078 0.006-0.102 0.007-0.15 0.011c-0.049 0.003-0.095 0.008-0.142 0.008-0.091 0.002-0.177 0.004-0.256 0.006-0.073-0.003-0.14-0.005-0.2-0.007-0.030-0.001-0.058-0.002-0.085-0.002-0.033-0.002-0.064-0.004-0.093-0.006-0.033-0.002-0.063-0.004-0.091-0.006-0.051-0.008-0.103-0.012-0.156-0.012-0.007 0-0.015 0-0.022 0.001-0.002-0-0.003-0-0.003-0v0c-0.484 0.012-0.883 0.369-0.961 0.834-0.050-0.010-0.101-0.025-0.153-0.039s-0.107-0.030-0.163-0.045c-0.028-0.008-0.056-0.015-0.084-0.024s-0.057-0.019-0.086-0.028-0.116-0.039-0.176-0.058c-0.015-0.005-0.030-0.010-0.045-0.015s-0.030-0.012-0.045-0.017-0.060-0.023-0.091-0.035-0.123-0.048-0.186-0.073c-0.062-0.028-0.125-0.056-0.189-0.084-0.032-0.014-0.064-0.028-0.096-0.043s-0.064-0.032-0.096-0.048-0.128-0.065-0.194-0.098c-0.065-0.034-0.129-0.073-0.194-0.109-0.032-0.018-0.065-0.037-0.098-0.056s-0.064-0.040-0.096-0.061c-0.064-0.041-0.129-0.082-0.194-0.124-0.255-0.175-0.506-0.369-0.744-0.583-0.236-0.217-0.459-0.451-0.665-0.697-0.202-0.25-0.385-0.511-0.547-0.776-0.159-0.268-0.294-0.541-0.41-0.808-0.027-0.068-0.053-0.135-0.079-0.202-0.013-0.033-0.027-0.066-0.038-0.099s-0.022-0.067-0.033-0.1-0.045-0.131-0.065-0.196c-0.018-0.065-0.036-0.13-0.054-0.194-0.009-0.032-0.019-0.063-0.026-0.095s-0.014-0.063-0.021-0.094-0.028-0.123-0.042-0.184c-0.011-0.061-0.021-0.12-0.032-0.179-0.005-0.029-0.010-0.058-0.015-0.087-0.003-0.014-0.005-0.028-0.008-0.043s-0.003-0.029-0.005-0.043c-0.007-0.056-0.014-0.112-0.020-0.166-0.003-0.027-0.007-0.053-0.010-0.080s-0.004-0.053-0.006-0.078-0.007-0.101-0.011-0.15c-0.003-0.049-0.008-0.095-0.008-0.142-0.002-0.091-0.004-0.177-0.006-0.256 0.003-0.073 0.005-0.14 0.007-0.2 0.001-0.030 0.002-0.058 0.002-0.085 0.002-0.033 0.004-0.064 0.006-0.093 0.002-0.033 0.004-0.063 0.006-0.091 0.008-0.051 0.012-0.103 0.012-0.156 0-0.007-0-0.015-0.001-0.022 0-0.002 0-0.003 0-0.003h-0c-0.012-0.49-0.377-0.893-0.851-0.964z"
                }
            }
        ]
    })(props);
}
function ImSpinner11(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.343-2.344v6z"
                }
            }
        ]
    })(props);
}
function ImBinoculars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 0h6v1h-6zM9 0h6v1h-6zM14.875 5h-0.875v-4h-4v4h-4v-4h-4v4h-0.875c-0.619 0-1.125 0.506-1.125 1.125v8.75c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-5.875h2v5.875c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-8.75c0-0.619-0.506-1.125-1.125-1.125zM5.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5zM8.5 8h-1c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM14.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5z"
                }
            }
        ]
    })(props);
}
function ImSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
                }
            }
        ]
    })(props);
}
function ImZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM7 3h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function ImZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM3 5h6v2h-6z"
                }
            }
        ]
    })(props);
}
function ImEnlarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 0h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 16h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
                }
            }
        ]
    })(props);
}
function ImShrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function ImEnlarge2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 0v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM7 10.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
                }
            }
        ]
    })(props);
}
function ImShrink2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM16 1.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
                }
            }
        ]
    })(props);
}
function ImKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 0c-2.761 0-5 2.239-5 5 0 0.313 0.029 0.619 0.084 0.916l-6.084 6.084v3c0 0.552 0.448 1 1 1h1v-1h2v-2h2v-2h2l1.298-1.298c0.531 0.192 1.105 0.298 1.702 0.298 2.761 0 5-2.239 5-5s-2.239-5-5-5zM12.498 5.002c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function ImKey2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.658 4.91l-1.58-1.58c-0.387-0.387-1.021-1.021-1.409-1.409l-1.58-1.58c-0.387-0.387-1.077-0.456-1.533-0.152l-4.319 2.88c-0.456 0.304-0.628 0.954-0.383 1.444l1.101 2.203c0.034 0.067 0.073 0.139 0.115 0.213l-5.571 5.571-0.5 3.5h3v-1h2v-2h2v-2h2v-1.112c0.1 0.060 0.196 0.113 0.284 0.157l2.203 1.101c0.49 0.245 1.14 0.072 1.444-0.383l2.88-4.319c0.304-0.456 0.236-1.146-0.152-1.533zM2.354 13.354l-0.707-0.707 4.868-4.868 0.707 0.707-4.868 4.868zM14.328 6.621l-0.707 0.707c-0.194 0.194-0.513 0.194-0.707 0l-4.243-4.243c-0.194-0.194-0.194-0.513 0-0.707l0.707-0.707c0.194-0.194 0.513-0.194 0.707 0l4.243 4.243c0.194 0.194 0.194 0.513 0 0.707z"
                }
            }
        ]
    })(props);
}
function ImLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z"
                }
            }
        ]
    })(props);
}
function ImUnlocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z"
                }
            }
        ]
    })(props);
}
function ImWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.671 12.779l-7.196-6.168c0.335-0.63 0.525-1.348 0.525-2.111 0-2.485-2.015-4.5-4.5-4.5-0.455 0-0.893 0.068-1.307 0.193l2.6 2.6c0.389 0.389 0.389 1.025 0 1.414l-1.586 1.586c-0.389 0.389-1.025 0.389-1.414 0l-2.6-2.6c-0.125 0.414-0.193 0.852-0.193 1.307 0 2.485 2.015 4.5 4.5 4.5 0.763 0 1.482-0.19 2.111-0.525l6.168 7.196c0.358 0.418 0.969 0.441 1.358 0.052l1.586-1.586c0.389-0.389 0.365-1-0.052-1.358z"
                }
            }
        ]
    })(props);
}
function ImEqualizer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v-0.25c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.337-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9zM4 4v-2h2v2h-2zM13 6.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-9v2h9v0.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h3v-2h-3v-0.25zM10 9v-2h2v2h-2zM7 11.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.338-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9v-0.25zM4 14v-2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function ImEqualizer2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v9h2v-9zM12 4h2v2h-2v-2zM9.25 13c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-9h-2v9h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v3h2v-3h0.25zM7 10h2v2h-2v-2zM4.25 7c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.413 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.337 0.75 0.75 0.75h0.25v9h2v-9h0.25zM2 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function ImCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 9.535c-0.839-1.454-0.335-3.317 1.127-4.164l-1.572-2.723c-0.449 0.263-0.972 0.414-1.529 0.414-1.68 0-3.042-1.371-3.042-3.062h-3.145c0.004 0.522-0.126 1.051-0.406 1.535-0.839 1.454-2.706 1.948-4.17 1.106l-1.572 2.723c0.453 0.257 0.845 0.634 1.123 1.117 0.838 1.452 0.336 3.311-1.12 4.16l1.572 2.723c0.448-0.261 0.967-0.41 1.522-0.41 1.675 0 3.033 1.362 3.042 3.046h3.145c-0.001-0.517 0.129-1.040 0.406-1.519 0.838-1.452 2.7-1.947 4.163-1.11l1.572-2.723c-0.45-0.257-0.839-0.633-1.116-1.113zM8 11.24c-1.789 0-3.24-1.45-3.24-3.24s1.45-3.24 3.24-3.24c1.789 0 3.24 1.45 3.24 3.24s-1.45 3.24-3.24 3.24z"
                }
            }
        ]
    })(props);
}
function ImCogs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.683 11.282l0.645-0.903-0.707-0.707-0.903 0.645c-0.168-0.094-0.347-0.168-0.535-0.222l-0.183-1.095h-1l-0.183 1.095c-0.188 0.053-0.368 0.128-0.535 0.222l-0.903-0.645-0.707 0.707 0.645 0.903c-0.094 0.168-0.168 0.347-0.222 0.535l-1.095 0.183v1l1.095 0.183c0.053 0.188 0.128 0.368 0.222 0.535l-0.645 0.903 0.707 0.707 0.903-0.645c0.168 0.094 0.347 0.168 0.535 0.222l0.183 1.095h1l0.183-1.095c0.188-0.053 0.368-0.128 0.535-0.222l0.903 0.645 0.707-0.707-0.645-0.903c0.094-0.168 0.168-0.347 0.222-0.535l1.095-0.182v-1l-1.095-0.183c-0.053-0.188-0.128-0.368-0.222-0.535zM3.5 13.5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM16 6v-1l-1.053-0.191c-0.019-0.126-0.044-0.25-0.074-0.372l0.899-0.58-0.383-0.924-1.046 0.226c-0.066-0.108-0.136-0.213-0.211-0.315l0.609-0.88-0.707-0.707-0.88 0.609c-0.102-0.074-0.207-0.145-0.315-0.211l0.226-1.046-0.924-0.383-0.58 0.899c-0.122-0.030-0.246-0.054-0.372-0.074l-0.191-1.053h-1l-0.191 1.053c-0.126 0.019-0.25 0.044-0.372 0.074l-0.58-0.899-0.924 0.383 0.226 1.046c-0.108 0.066-0.213 0.136-0.315 0.211l-0.88-0.609-0.707 0.707 0.609 0.88c-0.074 0.102-0.145 0.207-0.211 0.315l-1.046-0.226-0.383 0.924 0.899 0.58c-0.030 0.122-0.054 0.246-0.074 0.372l-1.053 0.191v1l1.053 0.191c0.019 0.126 0.044 0.25 0.074 0.372l-0.899 0.58 0.383 0.924 1.046-0.226c0.066 0.108 0.136 0.213 0.211 0.315l-0.609 0.88 0.707 0.707 0.88-0.609c0.102 0.074 0.207 0.145 0.315 0.211l-0.226 1.046 0.924 0.383 0.58-0.899c0.122 0.030 0.246 0.054 0.372 0.074l0.191 1.053h1l0.191-1.053c0.126-0.019 0.25-0.044 0.372-0.074l0.58 0.899 0.924-0.383-0.226-1.046c0.108-0.066 0.213-0.136 0.315-0.211l0.88 0.609 0.707-0.707-0.609-0.88c0.074-0.102 0.145-0.207 0.211-0.315l1.046 0.226 0.383-0.924-0.899-0.58c0.030-0.122 0.054-0.246 0.074-0.372l1.053-0.191zM10.5 7.675c-1.201 0-2.175-0.974-2.175-2.175s0.974-2.175 2.175-2.175 2.175 0.974 2.175 2.175c0 1.201-0.974 2.175-2.175 2.175z"
                }
            }
        ]
    })(props);
}
function ImHammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.781 12.953l-4.712-4.712c-0.292-0.292-0.769-0.292-1.061 0l-0.354 0.354-2.875-2.875 4.72-4.72h-5l-2.22 2.22-0.22-0.22h-1.061v1.061l0.22 0.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-0.354 0.354c-0.292 0.292-0.292 0.769 0 1.061l4.712 4.712c0.292 0.292 0.769 0.292 1.061 0l1.768-1.768c0.292-0.292 0.292-0.769 0-1.061z"
                }
            }
        ]
    })(props);
}
function ImMagicWand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3l-2-2h-1v1l2 2zM5 0h1v2h-1zM9 5h2v1h-2zM10 2v-1h-1l-2 2 1 1zM0 5h2v1h-2zM5 9h1v2h-1zM1 9v1h1l2-2-1-1zM15.781 13.781l-9.939-9.939c-0.292-0.292-0.769-0.292-1.061 0l-0.939 0.939c-0.292 0.292-0.292 0.769 0 1.061l9.939 9.939c0.292 0.292 0.769 0.292 1.061 0l0.939-0.939c0.292-0.292 0.292-0.769 0-1.061zM7.5 8.5l-3-3 1-1 3 3-1 1z"
                }
            }
        ]
    })(props);
}
function ImAidKit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h-3v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM6 2h4v2h-4v-2zM12 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function ImBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v-1h-3.020c-0.092-1.136-0.497-2.172-1.12-3.004h2.53l1.095-4.379-0.97-0.243-0.905 3.621h-2.729c-0.014-0.011-0.028-0.021-0.042-0.032 0.105-0.305 0.162-0.632 0.162-0.972 0-1.653-1.343-2.992-3-2.992s-3 1.34-3 2.992c0 0.34 0.057 0.667 0.162 0.972-0.014 0.011-0.028 0.021-0.042 0.032h-2.729l-0.905-3.621-0.97 0.243 1.095 4.379h2.53c-0.623 0.832-1.028 1.868-1.12 3.004h-3.020v1h3.021c0.059 0.713 0.242 1.388 0.526 1.996h-1.937l-1.095 4.379 0.97 0.243 0.905-3.621h1.756c0.917 1.219 2.303 1.996 3.854 1.996s2.937-0.777 3.854-1.996h1.756l0.905 3.621 0.97-0.243-1.095-4.379h-1.937c0.283-0.608 0.466-1.283 0.526-1.996h3.021z"
                }
            }
        ]
    })(props);
}
function ImPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v-7c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7c0-1.126-0.266-2.189-0.738-3.131l-6.262 3.131zM14.262 3.869c-1.149-2.294-3.521-3.869-6.262-3.869v7l6.262-3.131z"
                }
            }
        ]
    })(props);
}
function ImStatsDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14h14v2h-16v-16h2zM4.5 13c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.044 0 0.088 0.002 0.131 0.006l1.612-2.687c-0.154-0.235-0.243-0.517-0.243-0.819 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.302-0.090 0.583-0.243 0.819l1.612 2.687c0.043-0.004 0.087-0.006 0.131-0.006 0.033 0 0.066 0.001 0.099 0.004l2.662-4.658c-0.165-0.241-0.261-0.532-0.261-0.845 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5-0.033 0-0.066-0.001-0.099-0.004l-2.662 4.658c0.165 0.241 0.261 0.532 0.261 0.845 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.302 0.090-0.583 0.243-0.819l-1.612-2.687c-0.043 0.004-0.087 0.006-0.131 0.006s-0.088-0.002-0.131-0.006l-1.612 2.687c0.154 0.235 0.243 0.517 0.243 0.819 0 0.828-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function ImStatsBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 13h16v2h-16zM2 9h2v3h-2zM5 5h2v7h-2zM8 8h2v4h-2zM11 2h2v10h-2z"
                }
            }
        ]
    })(props);
}
function ImStatsBars2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 15h-3v-4h3v4zM9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 15h-3v-5h3v5zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 15h-3v-6h3v6z"
                }
            }
        ]
    })(props);
}
function ImTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z"
                }
            }
        ]
    })(props);
}
function ImGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM3.655 2.514c-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26-0.247-0.247-0.403-0.565-0.426-0.872zM7 15h-4v-6.5h4v6.5zM7 8h-5v-2h5v2zM13 15h-4v-6.5h4v6.5zM14 8h-5v-2h5v2z"
                }
            }
        ]
    })(props);
}
function ImGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.153 0.263c-0.087-0.162-0.256-0.263-0.44-0.263h-7.425c-0.184 0-0.353 0.101-0.44 0.263-0.554 1.032-0.847 2.237-0.847 3.487 0 1.647 0.506 3.2 1.424 4.374 0.71 0.907 1.601 1.508 2.576 1.753v5.123h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.123c0.975-0.244 1.866-0.846 2.576-1.753 0.918-1.174 1.424-2.727 1.424-4.374 0-1.249-0.293-2.455-0.847-3.487zM4.595 1h6.809c0.39 0.827 0.595 1.771 0.595 2.75 0 0.084-0.002 0.167-0.005 0.25h-7.991c-0.003-0.083-0.005-0.166-0.005-0.25-0-0.979 0.205-1.923 0.595-2.75z"
                }
            }
        ]
    })(props);
}
function ImGlass2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.893 2.809c0.118-0.151 0.14-0.355 0.057-0.527s-0.258-0.281-0.45-0.281h-11c-0.191 0-0.366 0.109-0.45 0.281s-0.062 0.377 0.057 0.527l4.893 6.228v5.963h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.963l4.893-6.228zM12.471 3l-1.571 2h-5.8l-1.571-2h8.943z"
                }
            }
        ]
    })(props);
}
function ImMug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h-3v-1.5c0-1.381-2.686-2.5-6-2.5s-6 1.119-6 2.5v10c0 1.381 2.686 2.5 6 2.5s6-1.119 6-2.5v-1.5h3c0.552 0 1-0.448 1-1v-5c0-0.552-0.448-1-1-1zM2.751 4.037c-0.578-0.19-0.928-0.394-1.116-0.537 0.188-0.143 0.538-0.347 1.116-0.537 0.905-0.298 2.059-0.463 3.249-0.463s2.344 0.164 3.249 0.463c0.578 0.19 0.928 0.394 1.116 0.537-0.188 0.143-0.538 0.347-1.116 0.537-0.905 0.298-2.059 0.463-3.249 0.463s-2.344-0.164-3.249-0.463zM14 10h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function ImSpoonKnife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655 0.985 3.042 2.308 3.406l-0.497 8.096c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.497-8.096c1.323-0.365 2.308-1.751 2.308-3.406 0-1.933-1.343-3.5-3-3.5zM13.583 0l-0.833 5h-0.625l-0.417-5h-0.417l-0.417 5h-0.625l-0.833-5h-0.417v6.5c0 0.276 0.224 0.5 0.5 0.5h1.302l-0.491 8.002c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.491-8.002h1.302c0.276 0 0.5-0.224 0.5-0.5v-6.5h-0.417z"
                }
            }
        ]
    })(props);
}
function ImLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.802 2.102c-1.73-1.311-4.393-2.094-7.124-2.094-3.377 0-6.129 1.179-7.549 3.235-0.667 0.965-1.036 2.109-1.097 3.398-0.054 1.148 0.139 2.418 0.573 3.784 1.482-4.444 5.622-7.923 10.395-7.923 0 0-4.466 1.175-7.274 4.816-0.002 0.002-0.039 0.048-0.103 0.136-0.564 0.754-1.055 1.612-1.423 2.583-0.623 1.482-1.2 3.515-1.2 5.965h2c0 0-0.304-1.91 0.224-4.106 0.873 0.118 1.654 0.177 2.357 0.177 1.839 0 3.146-0.398 4.115-1.252 0.868-0.765 1.347-1.794 1.854-2.882 0.774-1.663 1.651-3.547 4.198-5.002 0.146-0.083 0.24-0.234 0.251-0.402s-0.063-0.329-0.197-0.431z"
                }
            }
        ]
    })(props);
}
function ImRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1l-5 5h-3l-3 4c0 0 3.178-0.885 5.032-0.47l-5.032 6.47 6.592-5.127c0.919 2.104-0.592 5.127-0.592 5.127l4-3v-3l5-5 1-5-5 1z"
                }
            }
        ]
    })(props);
}
function ImMeter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c4.418 0 8 3.582 8 8 0 3.012-1.665 5.635-4.125 7h-7.75c-2.46-1.365-4.125-3.988-4.125-7 0-4.418 3.582-8 8-8zM12.53 13.53c1.21-1.21 1.876-2.819 1.876-4.53h-1.406v-1h1.329c-0.11-0.703-0.334-1.377-0.665-2h-1.664v-1h1.004c-0.147-0.184-0.306-0.361-0.475-0.53-0.722-0.722-1.587-1.251-2.53-1.559v1.089h-1v-1.329c-0.328-0.051-0.662-0.078-1-0.078s-0.672 0.026-1 0.078v1.329h-1v-1.089c-0.943 0.309-1.808 0.837-2.53 1.559-0.169 0.169-0.327 0.346-0.475 0.53h1.004v1h-1.664c-0.331 0.623-0.555 1.297-0.665 2h1.329v1h-1.406c0 1.711 0.666 3.32 1.876 4.53 0.167 0.167 0.343 0.324 0.524 0.47h3.006l0.571-8h0.857l0.571 8h3.006c0.182-0.146 0.357-0.303 0.524-0.47z"
                }
            }
        ]
    })(props);
}
function ImMeter2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.732 13.034c0.174-0.479 0.268-0.995 0.268-1.534 0-1.943-1.231-3.598-2.956-4.228 0.16-1.327 0.754-2.555 1.714-3.514 1.133-1.133 2.64-1.757 4.243-1.757s3.109 0.624 4.243 1.757c0.96 0.96 1.554 2.188 1.714 3.514-1.725 0.63-2.956 2.285-2.956 4.228 0 0.539 0.095 1.055 0.268 1.534-0.964 0.629-2.090 0.966-3.268 0.966s-2.304-0.338-3.268-0.966zM8.621 10.016c0.217 0.055 0.379 0.251 0.379 0.484v1c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1c0-0.233 0.162-0.43 0.379-0.484l0.371-7.016h0.5l0.371 7.016z"
                }
            }
        ]
    })(props);
}
function ImHammer2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.784 14.309l-8.572-7.804 0.399-0.4c0.326-0.327 0.503-0.75 0.53-1.181 0.016-0.007 0.031-0.014 0.046-0.023l1.609-1.006c0.218-0.256 0.202-0.66-0.036-0.898l-2.799-2.806c-0.237-0.238-0.641-0.254-0.896-0.036l-1.004 1.614c-0.008 0.015-0.015 0.031-0.022 0.046-0.43 0.027-0.852 0.204-1.178 0.531l-1.522 1.527c-0.327 0.327-0.503 0.75-0.53 1.181-0.016 0.007-0.031 0.014-0.046 0.023l-1.609 1.006c-0.218 0.256-0.202 0.66 0.036 0.898l2.799 2.806c0.237 0.238 0.641 0.254 0.896 0.036l1.004-1.614c0.008-0.015 0.015-0.031 0.023-0.046 0.43-0.027 0.852-0.204 1.178-0.531l0.442-0.443 7.783 8.596c0.226 0.249 0.573 0.289 0.773 0.089l0.787-0.789c0.199-0.2 0.159-0.549-0.089-0.775z"
                }
            }
        ]
    })(props);
}
function ImFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.016 16c-1.066-2.219-0.498-3.49 0.321-4.688 0.897-1.312 1.129-2.61 1.129-2.61s0.706 0.917 0.423 2.352c1.246-1.387 1.482-3.598 1.293-4.445 2.817 1.969 4.021 6.232 2.399 9.392 8.631-4.883 2.147-12.19 1.018-13.013 0.376 0.823 0.448 2.216-0.313 2.893-1.287-4.879-4.468-5.879-4.468-5.879 0.376 2.516-1.364 5.268-3.042 7.324-0.059-1.003-0.122-1.696-0.649-2.656-0.118 1.823-1.511 3.309-1.889 5.135-0.511 2.473 0.383 4.284 3.777 6.197z"
                }
            }
        ]
    })(props);
}
function ImLab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.942 12.57l-4.942-8.235v-3.335h0.5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h0.5v3.335l-4.942 8.235c-1.132 1.886-0.258 3.43 1.942 3.43h10c2.2 0 3.074-1.543 1.942-3.43zM3.766 10l3.234-5.39v-3.61h2v3.61l3.234 5.39h-8.468z"
                }
            }
        ]
    })(props);
}
function ImMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-4l1 9c0 1.657-1.343 3-3 3s-3-1.343-3-3l1-9h-4l-1 9c0 3.866 3.134 7 7 7s7-3.134 7-7l-1-9zM12.154 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-0.611-4.154-1.721c-1.096-1.096-1.705-2.548-1.72-4.095l0.564-5.075h1.736l-0.55 4.953v0.062c0 1.102 0.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-0.429 2.917-1.208c0.779-0.779 1.208-1.815 1.208-2.917v-0.062l-0.007-0.062-0.543-4.891h1.736l0.564 5.075c-0.015 1.547-0.625 2.999-1.72 4.095z"
                }
            }
        ]
    })(props);
}
function ImBin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-10h-11zM5 14h-1v-7h1v7zM7 14h-1v-7h1v7zM9 14h-1v-7h1v7zM11 14h-1v-7h1v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.25 2h-3.25v-1.25c0-0.412-0.338-0.75-0.75-0.75h-3.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-3.25c-0.413 0-0.75 0.337-0.75 0.75v1.25h13v-1.25c0-0.413-0.338-0.75-0.75-0.75zM9 2h-3v-0.987h3v0.987z"
                }
            }
        ]
    })(props);
}
function ImBin2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h10l1-11h-12zM10 2v-2h-4v2h-5v3l1-1h12l1 1v-3h-5zM9 2h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function ImBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h-4v-1c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v1h-4c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM6 3.002c0.001-0.001 0.001-0.001 0.002-0.002h3.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-4v-0.998zM15 8h-2v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-6v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-2v-1h14v1z"
                }
            }
        ]
    })(props);
}
function ImAirplane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9.999l-2.857-2.857 6.857-5.143-2-2-8.571 3.429-2.698-2.699c-0.778-0.778-1.864-0.964-2.414-0.414s-0.364 1.636 0.414 2.414l2.698 2.698-3.429 8.572 2 2 5.144-6.857 2.857 2.857v4h2l1-3 3-1v-2l-4 0z"
                }
            }
        ]
    })(props);
}
function ImTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9l-2-4h-3v-2c0-0.55-0.45-1-1-1h-9c-0.55 0-1 0.45-1 1v8l1 1h1.268c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h5.536c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h1.268v-3zM11 9v-3h2.073l1.5 3h-3.573z"
                }
            }
        ]
    })(props);
}
function ImRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h5l-4-16h-3l0.5 4h-3l0.5-4h-3l-4 16h5l0.5-4h5l0.5 4zM5.75 10l0.5-4h3.5l0.5 4h-4.5z"
                }
            }
        ]
    })(props);
}
function ImAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5l5.15-2.221-0.371-0.929-6.279 2.15h-1l-6.279-2.15-0.371 0.929 5.15 2.221v4l-2.051 6.634 0.935 0.355 2.902-6.489h0.429l2.902 6.489 0.935-0.355-2.051-6.634z"
                }
            }
        ]
    })(props);
}
function ImTarget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z"
                }
            }
        ]
    })(props);
}
function ImShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0l-7 2-7-2c0 0-0.070 0.808 0 2l7 2.189 7-2.189c0.070-1.192 0-2 0-2zM1.128 3.049c0.375 3.917 1.773 10.504 6.872 12.951 5.099-2.448 6.497-9.034 6.872-12.951l-6.872 2.584-6.872-2.584z"
                }
            }
        ]
    })(props);
}
function ImPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0l-6 8h6l-4 8 14-10h-8l6-6z"
                }
            }
        ]
    })(props);
}
function ImSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2.29v2.124c0.566 0.247 1.086 0.6 1.536 1.050 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.45-0.45 0.97-0.803 1.536-1.050v-2.124c-2.891 0.861-5 3.539-5 6.71 0 3.866 3.134 7 7 7s7-3.134 7-7c0-3.171-2.109-5.849-5-6.71zM7 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function ImPowerCord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.414l-1.414-1.414-2.793 2.793-1.586-1.586 2.793-2.793-1.414-1.414-2.793 2.793-1.793-1.793-1.354 1.353 8 8 1.354-1.353-1.793-1.793 2.793-2.793z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.407 10.528l-6.935-6.935c-1.497 1.795-3.196 4.57-2.022 6.957l-2.066 2.066c-0.486 0.486-0.486 1.282 0 1.768l0.232 0.232c0.486 0.486 1.282 0.486 1.768 0l2.066-2.066c2.387 1.174 5.161-0.524 6.957-2.022z"
                }
            }
        ]
    })(props);
}
function ImClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914z"
                }
            }
        ]
    })(props);
}
function ImListNumbered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13h10v2h-10zM6 7h10v2h-10zM6 1h10v2h-10zM3 0v4h-1v-3h-1v-1zM2 8.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM4 11v5h-3v-1h2v-1h-2v-1h2v-1h-2v-1z"
                }
            }
        ]
    })(props);
}
function ImList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z"
                }
            }
        ]
    })(props);
}
function ImList2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1h10v2h-10v-2zM6 7h10v2h-10v-2zM6 13h10v2h-10v-2zM0 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z"
                }
            }
        ]
    })(props);
}
function ImTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.25 12h-0.25v-3.25c0-0.965-0.785-1.75-1.75-1.75h-4.25v-2h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v2h-4.25c-0.965 0-1.75 0.785-1.75 1.75v3.25h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.337-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75zM3 15h-2v-2h2v2zM9 15h-2v-2h2v2zM7 4v-2h2v2h-2zM15 15h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function ImMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3h14v3h-14zM1 7h14v3h-14zM1 11h14v3h-14z"
                }
            }
        ]
    })(props);
}
function ImMenu2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9l3 3 3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 8l-3-3-3 3z"
                }
            }
        ]
    })(props);
}
function ImMenu3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 7l3 3 3-3z"
                }
            }
        ]
    })(props);
}
function ImMenu4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 22 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10l3-3 3 3z"
                }
            }
        ]
    })(props);
}
function ImCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10.274c0-1.283-0.886-2.358-2.078-2.648-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029l10.254-0c1.502-0.003 2.719-1.222 2.719-2.726z"
                }
            }
        ]
    })(props);
}
function ImCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.922 5.626c-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029h1.434l3.539 3.664 3.539-3.664 1.742-0c1.502-0.003 2.719-1.222 2.719-2.726 0-1.283-0.886-2.358-2.078-2.648zM8 13l-3-3h2v-3h2v3h2l-3 3z"
                }
            }
        ]
    })(props);
}
function ImCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.942 6.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h2v3h4v-3h3.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.253-2.058-2.461zM9 10v3h-2v-3h-2.5l3.5-3.5 3.5 3.5h-2.5z"
                }
            }
        ]
    })(props);
}
function ImCloudCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.942 8.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h9.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.252-2.058-2.461zM6.5 12l-2.5-2.5 1-1 1.5 1.5 3.5-3.5 1 1-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function ImDownload2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-2.5l-3.5 3.5-3.5-3.5h-2.5l-2 4v1h16v-1l-2-4zM0 14h16v1h-16v-1zM9 5v-4h-2v4h-3.5l4.5 4.5 4.5-4.5h-3.5z"
                }
            }
        ]
    })(props);
}
function ImUpload2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14h16v1h-16zM16 12v1h-16v-1l2-4h4v2h4v-2h4zM3.5 5l4.5-4.5 4.5 4.5h-3.5v4h-2v-4z"
                }
            }
        ]
    })(props);
}
function ImDownload3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7l-4 4-4-4h2.5v-6h3v6zM7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function ImUpload3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1zM3.5 5l4-4 4 4h-2.5v5h-3v-5z"
                }
            }
        ]
    })(props);
}
function ImSphere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM11.744 11c0.134-0.632 0.219-1.303 0.246-2h1.991c-0.052 0.691-0.213 1.361-0.479 2h-1.758zM3.256 6c-0.134 0.632-0.219 1.303-0.246 2h-1.991c0.052-0.691 0.213-1.361 0.479-2h1.758zM10.719 6c0.15 0.64 0.241 1.31 0.27 2h-2.989v-2h2.719zM8 5v-2.927c0.228 0.066 0.454 0.178 0.675 0.334 0.415 0.293 0.813 0.744 1.149 1.304 0.233 0.388 0.434 0.819 0.601 1.289h-2.426zM5.176 3.711c0.336-0.561 0.734-1.012 1.149-1.304 0.222-0.156 0.447-0.268 0.675-0.334v2.927h-2.426c0.168-0.47 0.369-0.901 0.601-1.289zM7 6v2h-2.989c0.029-0.69 0.12-1.36 0.27-2h2.719zM1.498 11c-0.266-0.639-0.427-1.309-0.479-2h1.991c0.028 0.697 0.112 1.368 0.246 2h-1.758zM4.011 9h2.989v2h-2.719c-0.15-0.64-0.241-1.31-0.27-2zM7 12v2.927c-0.228-0.066-0.454-0.178-0.675-0.334-0.415-0.293-0.813-0.744-1.149-1.304-0.233-0.388-0.434-0.819-0.602-1.289h2.426zM9.825 13.289c-0.336 0.561-0.734 1.012-1.149 1.304-0.222 0.156-0.447 0.268-0.675 0.334v-2.927h2.426c-0.168 0.47-0.369 0.901-0.602 1.289zM8 11v-2h2.989c-0.029 0.69-0.12 1.36-0.27 2h-2.719zM11.99 8c-0.028-0.697-0.112-1.368-0.246-2h1.758c0.267 0.639 0.427 1.309 0.479 2h-1.991zM12.979 5h-1.498c-0.291-0.918-0.693-1.723-1.177-2.366 0.665 0.318 1.267 0.744 1.792 1.27 0.336 0.336 0.631 0.702 0.883 1.096zM2.904 3.904c0.526-0.526 1.128-0.952 1.792-1.27-0.483 0.643-0.886 1.448-1.177 2.366h-1.498c0.252-0.394 0.547-0.761 0.883-1.096zM2.021 12h1.498c0.291 0.918 0.693 1.723 1.177 2.366-0.665-0.318-1.267-0.744-1.792-1.27-0.336-0.336-0.631-0.702-0.883-1.096zM12.096 13.096c-0.526 0.526-1.128 0.952-1.792 1.27 0.483-0.643 0.886-1.448 1.177-2.366h1.498c-0.252 0.394-0.547 0.761-0.883 1.096z"
                }
            }
        ]
    })(props);
}
function ImEarth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-0.984 0-1.92-0.203-2.769-0.57l3.643-4.098c0.081-0.092 0.126-0.21 0.126-0.332v-1.5c0-0.276-0.224-0.5-0.5-0.5-1.765 0-3.628-1.835-3.646-1.854-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.189 0.107 0.363 0.276 0.447l1.724 0.862v2.936c-1.813-1.265-3-3.366-3-5.745 0-1.074 0.242-2.091 0.674-3h1.826c0.133 0 0.26-0.053 0.354-0.146l2-2c0.094-0.094 0.146-0.221 0.146-0.354v-1.21c0.634-0.189 1.305-0.29 2-0.29 1.1 0 2.141 0.254 3.067 0.706-0.065 0.055-0.128 0.112-0.188 0.172-0.567 0.567-0.879 1.32-0.879 2.121s0.312 1.555 0.879 2.121c0.569 0.569 1.332 0.879 2.119 0.879 0.049 0 0.099-0.001 0.149-0.004 0.216 0.809 0.605 2.917-0.131 5.818-0.007 0.027-0.011 0.055-0.013 0.082-1.271 1.298-3.042 2.104-5.002 2.104z"
                }
            }
        ]
    })(props);
}
function ImLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.879 9.934c-0.208 0-0.416-0.079-0.575-0.238-1.486-1.486-1.486-3.905 0-5.392l3-3c0.72-0.72 1.678-1.117 2.696-1.117s1.976 0.397 2.696 1.117c1.486 1.487 1.486 3.905 0 5.392l-1.371 1.371c-0.317 0.317-0.832 0.317-1.149 0s-0.317-0.832 0-1.149l1.371-1.371c0.853-0.853 0.853-2.241 0-3.094-0.413-0.413-0.963-0.641-1.547-0.641s-1.134 0.228-1.547 0.641l-3 3c-0.853 0.853-0.853 2.241 0 3.094 0.317 0.317 0.317 0.832 0 1.149-0.159 0.159-0.367 0.238-0.575 0.238z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15.813c-1.018 0-1.976-0.397-2.696-1.117-1.486-1.486-1.486-3.905 0-5.392l1.371-1.371c0.317-0.317 0.832-0.317 1.149 0s0.317 0.832 0 1.149l-1.371 1.371c-0.853 0.853-0.853 2.241 0 3.094 0.413 0.413 0.962 0.641 1.547 0.641s1.134-0.228 1.547-0.641l3-3c0.853-0.853 0.853-2.241 0-3.094-0.317-0.317-0.317-0.832 0-1.149s0.832-0.317 1.149 0c1.486 1.486 1.486 3.905 0 5.392l-3 3c-0.72 0.72-1.678 1.117-2.696 1.117z"
                }
            }
        ]
    })(props);
}
function ImFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h2v16h-2v-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.047c1.291 0 2.415-0.312 3-0.773v-8c-0.585 0.461-1.709 0.773-3 0.773s-2.415-0.312-3-0.773v8c0.585 0.461 1.709 0.773 3 0.773z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0.508c-0.733-0.312-1.805-0.508-3-0.508-1.506 0-2.818 0.312-3.5 0.773v8c0.682-0.461 1.994-0.773 3.5-0.773 1.195 0 2.267 0.197 3 0.508v-8z"
                }
            }
        ]
    })(props);
}
function ImAttachment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.404 5.11l-1.015-1.014-5.075 5.074c-0.841 0.841-0.841 2.204 0 3.044s2.204 0.841 3.045 0l6.090-6.089c1.402-1.401 1.402-3.673 0-5.074s-3.674-1.402-5.075 0l-6.394 6.393c-0.005 0.005-0.010 0.009-0.014 0.013-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0c0.004-0.004 0.008-0.009 0.013-0.014l0.001 0.001 4.365-4.364-1.015-1.014-4.365 4.363c-0.005 0.004-0.009 0.009-0.013 0.013-1.392 1.392-3.656 1.392-5.048 0s-1.392-3.655 0-5.047c0.005-0.005 0.009-0.009 0.014-0.013l-0.001-0.001 6.395-6.393c0.839-0.84 2.205-0.84 3.045 0s0.839 2.205 0 3.044l-6.090 6.089c-0.28 0.28-0.735 0.28-1.015 0s-0.28-0.735 0-1.014l5.075-5.075z"
                }
            }
        ]
    })(props);
}
function ImEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function ImEyePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2h-2v-2h-2v2h-2v2h2v2h2v-2h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.498 6.969c0.288 0.32 0.55 0.665 0.782 1.031-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.011-0-0.022-0-0.032-1.708-0.44-2.973-1.979-2.999-3.817-0.329-0.037-0.662-0.057-1.001-0.057-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.276-0.55-0.604-1.069-0.979-1.548-0.457 0.268-0.973 0.449-1.523 0.517zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function ImEyeMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2h6v2h-6v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.599 5h-4.599v-1.944c-0.328-0.037-0.662-0.056-1-0.056-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.584-1.167-1.407-2.189-2.401-3zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM11.944 10.348c-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348z"
                }
            }
        ]
    })(props);
}
function ImEyeBlocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.78 0.22c-0.293-0.293-0.768-0.293-1.061 0l-3.159 3.159c-0.812-0.246-1.671-0.378-2.561-0.378-3.489 0-6.514 2.032-8 5 0.643 1.283 1.573 2.391 2.703 3.236l-2.484 2.484c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l13.5-13.5c0.293-0.293 0.293-0.768 0-1.061zM6.5 5c0.66 0 1.22 0.426 1.421 1.019l-1.902 1.902c-0.592-0.201-1.019-0.761-1.019-1.421 0-0.828 0.672-1.5 1.5-1.5zM1.721 8c0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 0.858 0.27 1.652 0.73 2.303l-0.952 0.952c-0.819-0.576-1.519-1.311-2.057-2.162z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.906c0-0.424-0.066-0.833-0.189-1.217l-5.028 5.028c0.384 0.123 0.793 0.189 1.217 0.189 2.209 0 4-1.791 4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.969 4.531l-1.084 1.084c0.020 0.012 0.040 0.024 0.059 0.037 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152-0.604 0-1.202-0.074-1.781-0.219l-1.201 1.201c0.933 0.335 1.937 0.518 2.982 0.518 3.489 0 6.514-2.032 8-5-0.703-1.405-1.752-2.6-3.031-3.469z"
                }
            }
        ]
    })(props);
}
function ImBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0v16l5-5 5 5v-16z"
                }
            }
        ]
    })(props);
}
function ImBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v14l5-5 5 5v-14zM12 0h-10v14l1-1v-12h9z"
                }
            }
        ]
    })(props);
}
function ImSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function ImContrast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM2 8c0-3.314 2.686-6 6-6v12c-3.314 0-6-2.686-6-6z"
                }
            }
        ]
    })(props);
}
function ImBrightnessContrast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zM8 10.5v-5c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5zM8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
                }
            }
        ]
    })(props);
}
function ImStarEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-3.492 1.836 0.667-3.888-2.825-2.753 3.904-0.567 1.746-3.537 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
                }
            }
        ]
    })(props);
}
function ImStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-0.015 0.008 0.015-8.918 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
                }
            }
        ]
    })(props);
}
function ImStarFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899z"
                }
            }
        ]
    })(props);
}
function ImHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 1c-1.682 0-3.129 1.368-3.799 2.797-0.671-1.429-2.118-2.797-3.8-2.797-2.318 0-4.2 1.882-4.2 4.2 0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.050 8-10.616 0-2.319-1.882-4.2-4.2-4.2z"
                }
            }
        ]
    })(props);
}
function ImHeartBroken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 1c2.318 0 4.2 1.882 4.2 4.2 0 4.566-4.935 5.982-8 10.616-3.243-4.663-8-5.9-8-10.616 0-2.319 1.882-4.2 4.2-4.2 0.943 0 1.812 0.43 2.512 1.060l-1.213 1.94 3.5 2-2 5 5.5-6-3.5-2 0.967-1.451c0.553-0.34 1.175-0.549 1.833-0.549z"
                }
            }
        ]
    })(props);
}
function ImMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
                }
            }
        ]
    })(props);
}
function ImWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
                }
            }
        ]
    })(props);
}
function ImManWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
                }
            }
        ]
    })(props);
}
function ImHappy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8 9.356c1.812 0 3.535-0.481 5-1.327-0.228 2.788-2.393 4.971-5 4.971s-4.772-2.186-5-4.973c1.465 0.845 3.188 1.329 5 1.329zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
                }
            }
        ]
    })(props);
}
function ImHappy2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM8 14c-2.607 0-4.772-2.186-5-4.973 1.465 0.846 3.188 1.329 5 1.329s3.535-0.481 5-1.327c-0.228 2.788-2.393 4.971-5 4.971z"
                }
            }
        ]
    })(props);
}
function ImSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.002 9.801l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699z"
                }
            }
        ]
    })(props);
}
function ImSmile2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
                }
            }
        ]
    })(props);
}
function ImTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM12 9v1h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8z"
                }
            }
        ]
    })(props);
}
function ImTongue2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM12 10h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8v1zM11 6c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z"
                }
            }
        ]
    })(props);
}
function ImSad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM4.998 12.199l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.413 0.973 4.288 2.427l-1.286 0.772c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699z"
                }
            }
        ]
    })(props);
}
function ImSad2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
                }
            }
        ]
    })(props);
}
function ImWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8.48 11.11c2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM5.5 5.805c-0.653 0-1.208 0.245-1.414 0.586-0.055-0.092-0.086-0.503-0.086-0.605 0-0.485 0.672-0.879 1.5-0.879s1.5 0.394 1.5 0.879c0 0.103-0.030 0.514-0.086 0.605-0.206-0.341-0.761-0.586-1.414-0.586z"
                }
            }
        ]
    })(props);
}
function ImWink2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5.5 4.876c0.932 0 1.594 0.349 1.594 0.895 0 0.116 0.060 0.672-0.003 0.775-0.232-0.384-0.856-0.659-1.591-0.659s-1.359 0.275-1.591 0.659c-0.062-0.103-0.003-0.659-0.003-0.775 0-0.546 0.662-0.895 1.594-0.895zM7.818 13c-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625 2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649z"
                }
            }
        ]
    })(props);
}
function ImGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM3 8v1c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-1h-10zM6 11.828c-0.415-0.148-0.796-0.388-1.118-0.71-0.569-0.569-0.882-1.321-0.882-2.118h2v2.828zM9 12h-2v-3h2v3zM11.118 11.118c-0.322 0.322-0.703 0.562-1.118 0.71v-2.828h2c0 0.797-0.313 1.549-0.882 2.118zM3.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.009 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261zM9.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.008 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261z"
                }
            }
        ]
    })(props);
}
function ImGrin2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261-0 0 0 0-0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM5 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261 0 0 0 0 0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM3 9h3v3.873c-1.72-0.447-3-2.018-3-3.873zM7 13v-4h2v4h-2zM10 12.873v-3.873h3c0 1.855-1.28 3.426-3 3.873z"
                }
            }
        ]
    })(props);
}
function ImCool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM12.5 4c0.275 0 0.5 0.225 0.5 0.5v1.5c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3zM8 12c1.456 0 2.731-0.778 3.43-1.942l0.857 0.515c-0.874 1.454-2.467 2.427-4.288 2.427-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334z"
                }
            }
        ]
    })(props);
}
function ImCool2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM8 13c-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334 1.456 0 2.731-0.778 3.43-1.942l0.858 0.515c-0.874 1.454-2.467 2.427-4.288 2.427zM13 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v1.5z"
                }
            }
        ]
    })(props);
}
function ImAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772zM11.985 4.379c0.067 0.268-0.096 0.539-0.364 0.606-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606z"
                }
            }
        ]
    })(props);
}
function ImAngry2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
                }
            }
        ]
    })(props);
}
function ImEvil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7c-0.552 0-1-0.448-1-1 0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1zM4.379 4.985c-0.268-0.067-0.431-0.338-0.364-0.606s0.338-0.431 0.606-0.364c0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334zM8 11.5c1.274 0 2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699zM16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            }
        ]
    })(props);
}
function ImEvil2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
                }
            }
        ]
    })(props);
}
function ImShocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM6 11c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
                }
            }
        ]
    })(props);
}
function ImShocked2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5zM8 13c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2zM11 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5z"
                }
            }
        ]
    })(props);
}
function ImBaffled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM5.5 4c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM10.5 4c-1.379 0-2.5 1.122-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.121-2.5-2.5-2.5v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11h4v1h-4v-1z"
                }
            }
        ]
    })(props);
}
function ImBaffled2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5zM10 12h-4v-1h4v1zM10.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function ImConfused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.345 10h1.014c0.144 1.133-0.507 2.258-1.624 2.665-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725z"
                }
            }
        ]
    })(props);
}
function ImConfused2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM10.735 12.665c-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725h1.014c0.144 1.133-0.507 2.258-1.624 2.665z"
                }
            }
        ]
    })(props);
}
function ImNeutral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM10 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM6 11h4v1h-4v-1z"
                }
            }
        ]
    })(props);
}
function ImNeutral2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM10 12h-4v-1h4v1zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1z"
                }
            }
        ]
    })(props);
}
function ImHipster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.561 8.439c-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.019 0.019 0.038 0.037 0.058 0.055 1.352 1.227 4.503-0.029 4.503-1.615-0.969 0.625-1.726 0.153-2.439-0.561z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.439 8.439c0.586-0.586 1.536-0.586 2.121 0s0.586 1.536 0 2.121c-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561z"
                }
            }
        ]
    })(props);
}
function ImHipster2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8.497 10.615c-0.020-0.018-0.039-0.036-0.058-0.055-0.293-0.293-0.439-0.677-0.439-1.060-0 0.384-0.146 0.768-0.439 1.060-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561 0.586-0.586 1.536-0.586 2.121 0 0.293 0.293 0.439 0.677 0.439 1.060 0-0.384 0.146-0.768 0.439-1.060 0.586-0.586 1.536-0.586 2.121 0 0.713 0.714 1.471 1.186 2.439 0.561 0 1.586-3.151 2.842-4.503 1.615z"
                }
            }
        ]
    })(props);
}
function ImWondering(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.652 9.4l0.351 1.2-6.828 2-0.351-1.2zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
                }
            }
        ]
    })(props);
}
function ImWondering2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM5.176 12.6l-0.351-1.2 6.828-2 0.351 1.2-6.828 2z"
                }
            }
        ]
    })(props);
}
function ImSleepy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5c0 1.381-0.895 2.5-2 2.5s-2-1.119-2-2.5c0-1.381 0.895-2.5 2-2.5s2 1.119 2 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                }
            }
        ]
    })(props);
}
function ImSleepy2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.854 5.166c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5s0.895-2.5 2-2.5 2 1.119 2 2.5-0.895 2.5-2 2.5zM11.854 5.166c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707z"
                }
            }
        ]
    })(props);
}
function ImFrustrated(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.724 4.428c-0.543-0.271-1.080-0.407-1.102-0.413-0.268-0.067-0.539 0.096-0.606 0.364s0.096 0.539 0.364 0.606c0.275 0.070 0.602 0.189 0.89 0.334-0.166 0.179-0.268 0.418-0.268 0.681 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.018-0.001-0.036-0.002-0.054-0.032-0.741-0.706-1.234-1.275-1.518z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM3.695 12.87c0.167 0.083 0.356 0.13 0.555 0.13h7.5c0.199 0 0.387-0.047 0.555-0.13-1.147 1.014-2.654 1.63-4.305 1.63s-3.158-0.616-4.305-1.63zM4 11.75v-1.5c0-0.136 0.114-0.25 0.25-0.25h1.75v2h-1.75c-0.136 0-0.25-0.114-0.25-0.25zM7 12v-2h2v2h-2zM10 12v-2h1.75c0.136 0 0.25 0.114 0.25 0.25v1.5c0 0.136-0.114 0.25-0.25 0.25h-1.75zM12.87 12.305c0.083-0.167 0.13-0.356 0.13-0.555v-1.5c0-0.689-0.561-1.25-1.25-1.25h-7.5c-0.689 0-1.25 0.561-1.25 1.25v1.5c0 0.199 0.047 0.387 0.13 0.555-1.014-1.147-1.63-2.654-1.63-4.305 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 1.651-0.616 3.158-1.63 4.305z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.379 4.015c-0.023 0.006-0.559 0.141-1.102 0.413-0.568 0.284-1.243 0.776-1.275 1.518-0.001 0.018-0.002 0.036-0.002 0.054 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.263-0.102-0.503-0.268-0.681 0.288-0.144 0.614-0.264 0.89-0.334 0.268-0.067 0.431-0.338 0.364-0.606s-0.338-0.431-0.606-0.364z"
                }
            }
        ]
    })(props);
}
function ImFrustrated2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.25v1.5c0 0.136 0.114 0.25 0.25 0.25h1.75v-2h-1.75c-0.136 0-0.25 0.114-0.25 0.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h2v2h-2v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.75 10h-1.75v2h1.75c0.136 0 0.25-0.114 0.25-0.25v-1.5c0-0.136-0.114-0.25-0.25-0.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.002 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM13 11.75c0 0.689-0.561 1.25-1.25 1.25h-7.5c-0.689 0-1.25-0.561-1.25-1.25v-1.5c0-0.689 0.561-1.25 1.25-1.25h7.5c0.689 0 1.25 0.561 1.25 1.25v1.5z"
                }
            }
        ]
    })(props);
}
function ImCrying(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 13.375c-0.128 0-0.256-0.049-0.354-0.146-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImCrying2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM9.854 13.229c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707zM12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.5v-2.5c0-0.827-0.673-1.5-1.5-1.5-0.267 0-0.518 0.070-0.736 0.193-0.267-0.417-0.734-0.693-1.264-0.693-0.384 0-0.734 0.145-1 0.383-0.266-0.238-0.616-0.383-1-0.383-0.175 0-0.344 0.030-0.5 0.086v-3.586c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5v6.167l-2.75-1.466c-0.227-0.131-0.486-0.201-0.75-0.201-0.827 0-1.5 0.673-1.5 1.5 0 0.412 0.164 0.796 0.461 1.082 0.004 0.004 0.008 0.007 0.012 0.011l3.737 3.407h-0.71c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-0.691l1.138-2.276c0.035-0.069 0.053-0.146 0.053-0.224zM14 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM14 9.382l-1.309 2.618h-5.997l-4.544-4.143c-0.097-0.095-0.15-0.221-0.15-0.357 0-0.276 0.224-0.5 0.5-0.5 0.085 0 0.166 0.020 0.239 0.061 0.008 0.005 0.017 0.010 0.025 0.014l3.5 1.866c0.155 0.083 0.342 0.078 0.492-0.012s0.243-0.253 0.243-0.429v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2.382z"
                }
            }
        ]
    })(props);
}
function ImPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15h2.5c0.827 0 1.5-0.673 1.5-1.5 0-0.267-0.070-0.518-0.193-0.736 0.417-0.267 0.693-0.734 0.693-1.264 0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1 0-0.175-0.030-0.344-0.086-0.5h3.586c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5h-6.167l1.466-2.75c0.131-0.227 0.201-0.486 0.201-0.75 0-0.827-0.673-1.5-1.5-1.5-0.412 0-0.796 0.164-1.082 0.461-0.004 0.004-0.007 0.008-0.011 0.012l-3.407 3.737v-0.71c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-0.691l2.276 1.138c0.069 0.035 0.146 0.053 0.224 0.053zM2.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM6.618 14l-2.618-1.309v-5.997l4.143-4.544c0.095-0.097 0.221-0.15 0.357-0.15 0.276 0 0.5 0.224 0.5 0.5 0 0.085-0.020 0.166-0.061 0.239-0.005 0.008-0.010 0.017-0.014 0.025l-1.866 3.5c-0.083 0.155-0.078 0.342 0.013 0.492s0.253 0.243 0.429 0.243h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.382z"
                }
            }
        ]
    })(props);
}
function ImPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6.5v2.5c0 0.827-0.673 1.5-1.5 1.5-0.267 0-0.518-0.070-0.736-0.193-0.267 0.417-0.734 0.693-1.264 0.693-0.384 0-0.734-0.145-1-0.383-0.266 0.238-0.616 0.383-1 0.383-0.175 0-0.344-0.030-0.5-0.086v3.586c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5v-6.167l-2.75 1.466c-0.227 0.131-0.486 0.201-0.75 0.201-0.827 0-1.5-0.673-1.5-1.5 0-0.412 0.164-0.796 0.461-1.082 0.004-0.004 0.008-0.007 0.012-0.011l3.737-3.407h-0.71c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5h-0.691l1.138 2.276c0.035 0.069 0.053 0.146 0.053 0.224zM14 2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.224 0.5-0.5zM14 6.618l-1.309-2.618h-5.997l-4.544 4.143c-0.097 0.095-0.15 0.221-0.15 0.357 0 0.276 0.224 0.5 0.5 0.5 0.085 0 0.166-0.020 0.239-0.061 0.008-0.005 0.017-0.010 0.025-0.014l3.5-1.866c0.155-0.083 0.342-0.078 0.492 0.013s0.243 0.253 0.243 0.429v7c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.382z"
                }
            }
        ]
    })(props);
}
function ImPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 15h-2.5c-0.827 0-1.5-0.673-1.5-1.5 0-0.267 0.070-0.518 0.193-0.736-0.417-0.267-0.693-0.734-0.693-1.264 0-0.384 0.145-0.734 0.383-1-0.238-0.266-0.383-0.616-0.383-1 0-0.175 0.030-0.344 0.086-0.5h-3.586c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h6.167l-1.466-2.75c-0.131-0.227-0.201-0.486-0.201-0.75 0-0.827 0.673-1.5 1.5-1.5 0.412 0 0.796 0.164 1.082 0.461 0.004 0.004 0.007 0.008 0.011 0.012l3.407 3.737v-0.71c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5v-0.691l-2.276 1.138c-0.069 0.035-0.146 0.053-0.224 0.053zM13.5 14c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5zM9.382 14l2.618-1.309v-5.997l-4.143-4.544c-0.095-0.097-0.221-0.15-0.357-0.15-0.276 0-0.5 0.224-0.5 0.5 0 0.085 0.020 0.166 0.061 0.239 0.005 0.008 0.010 0.017 0.014 0.025l1.866 3.5c0.083 0.155 0.078 0.342-0.012 0.492s-0.253 0.243-0.429 0.243h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.382z"
                }
            }
        ]
    })(props);
}
function ImWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.45l6.705 13.363h-13.409l6.705-13.363zM8 0c-0.345 0-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691h0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11c-0.552 0-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3c0 0.552-0.448 1-1 1z"
                }
            }
        ]
    })(props);
}
function ImNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8zM7 11h2v2h-2zM7 3h2v6h-2z"
                }
            }
        ]
    })(props);
}
function ImQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2h-2zM11 4c0.552 0 1 0.448 1 1v3l-3 2h-2v-1l3-2v-1h-5v-2h6zM8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8z"
                }
            }
        ]
    })(props);
}
function ImPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z"
                }
            }
        ]
    })(props);
}
function ImMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12h-4v-1h1v-3h-1v-1h3v4h1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            }
        ]
    })(props);
}
function ImCancelCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z"
                }
            }
        ]
    })(props);
}
function ImBlocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343s4.146-0.832 5.657-2.343c1.511-1.511 2.343-3.52 2.343-5.657s-0.832-4.146-2.343-5.657zM14 8c0 1.294-0.412 2.494-1.111 3.475l-8.364-8.364c0.981-0.699 2.181-1.111 3.475-1.111 3.308 0 6 2.692 6 6zM2 8c0-1.294 0.412-2.494 1.111-3.475l8.364 8.364c-0.981 0.699-2.181 1.111-3.475 1.111-3.308 0-6-2.692-6-6z"
                }
            }
        ]
    })(props);
}
function ImCross(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z"
                }
            }
        ]
    })(props);
}
function ImCheckmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z"
                }
            }
        ]
    })(props);
}
function ImCheckmark2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.21 14.339l-6.217-6.119 3.084-3.035 3.133 3.083 6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369-6.713 6.607-3.133-3.083-1.391 1.369z"
                }
            }
        ]
    })(props);
}
function ImSpellCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h2v3h1v-6c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v6h1v-3zM2 1h2v2h-2v-2zM15 1v-1h-3c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v-1h-3v-5h3zM10 2.5v-1.5c0-0.55-0.45-1-1-1h-3v7h3c0.55 0 1-0.45 1-1v-1.5c0-0.55-0.137-1-0.688-1 0.55 0 0.688-0.45 0.688-1zM9 6h-2v-2h2v2zM9 3h-2v-2h2v2zM13 9l-6.5 7-3.5-4.5 1.281-1.094 2.219 2.313 5.5-4.719z"
                }
            }
        ]
    })(props);
}
function ImEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h-5v-2h5v-2l3 3-3 3zM16 0v13l-6 3v-3h-6v-4h1v3h5v-9l4-2h-9v4h-1v-5z"
                }
            }
        ]
    })(props);
}
function ImExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z"
                }
            }
        ]
    })(props);
}
function ImPlay2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"
                }
            }
        ]
    })(props);
}
function ImPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"
                }
            }
        ]
    })(props);
}
function ImStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h6v6h-6z"
                }
            }
        ]
    })(props);
}
function ImPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8l4-3v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function ImNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM8 14.5c3.59 0 6.5-2.91 6.5-6.5s-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8l-4-3v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h-2v6h2v-6z"
                }
            }
        ]
    })(props);
}
function ImBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11 10.5l-3.5-2.5 3.5-2.5zM7 10.5l-3.5-2.5 3.5-2.5z"
                }
            }
        ]
    })(props);
}
function ImForward2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5.5l3.5 2.5-3.5 2.5zM9 5.5l3.5 2.5-3.5 2.5z"
                }
            }
        ]
    })(props);
}
function ImPlay3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l10 6-10 6z"
                }
            }
        ]
    })(props);
}
function ImPause2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h5v12h-5zM9 2h5v12h-5z"
                }
            }
        ]
    })(props);
}
function ImStop2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h12v12h-12z"
                }
            }
        ]
    })(props);
}
function ImBackward2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2.5v5l5-5v11l-5-5v5l-5.5-5.5z"
                }
            }
        ]
    })(props);
}
function ImForward3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.5v-5l-5 5v-11l5 5v-5l5.5 5.5z"
                }
            }
        ]
    })(props);
}
function ImFirst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14v-12h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5v5.5z"
                }
            }
        ]
    })(props);
}
function ImLast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2v12h-2v-5.5l-5 5v-5l-5 5v-11l5 5v-5l5 5v-5.5z"
                }
            }
        ]
    })(props);
}
function ImPrevious2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v-12h2v5.5l5-5v11l-5-5v5.5z"
                }
            }
        ]
    })(props);
}
function ImNext2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2v12h-2v-5.5l-5 5v-11l5 5v-5.5z"
                }
            }
        ]
    })(props);
}
function ImEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12h16v2h-16zM8 2l8 8h-16z"
                }
            }
        ]
    })(props);
}
function ImVolumeHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 17 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.907 14.407c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.369-1.369 2.123-3.19 2.123-5.127s-0.754-3.757-2.123-5.127c-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.653 1.653 2.563 3.85 2.563 6.187s-0.91 4.534-2.563 6.187c-0.146 0.146-0.338 0.22-0.53 0.22zM11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImVolumeMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImVolumeLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImVolumeMute2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.674v1.326h-1.326l-1.674-1.674-1.674 1.674h-1.326v-1.326l1.674-1.674-1.674-1.674v-1.326h1.326l1.674 1.674 1.674-1.674h1.326v1.326l-1.674 1.674 1.674 1.674z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImVolumeIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImVolumeDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8v2h-8v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
                }
            }
        ]
    })(props);
}
function ImLoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5h10v3l4-4-4-4v3h-12v6h2zM14 11h-10v-3l-4 4 4 4v-3h12v-6h-2z"
                }
            }
        ]
    })(props);
}
function ImLoop2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z"
                }
            }
        ]
    })(props);
}
function ImInfinite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.25 11.75c-1.002 0-1.943-0.39-2.652-1.098l-1.598-1.598-1.598 1.598c-0.708 0.708-1.65 1.098-2.652 1.098s-1.944-0.39-2.652-1.098c-0.708-0.708-1.098-1.65-1.098-2.652s0.39-1.943 1.098-2.652c0.708-0.708 1.65-1.098 2.652-1.098s1.943 0.39 2.652 1.098l1.598 1.598 1.598-1.598c0.708-0.708 1.65-1.098 2.652-1.098s1.944 0.39 2.652 1.098c0.708 0.708 1.098 1.65 1.098 2.652s-0.39 1.943-1.098 2.652c-0.708 0.708-1.65 1.098-2.652 1.098zM10.652 9.598c0.427 0.427 0.994 0.662 1.598 0.662s1.171-0.235 1.598-0.662c0.427-0.427 0.662-0.994 0.662-1.598s-0.235-1.171-0.662-1.598c-0.427-0.427-0.994-0.662-1.598-0.662s-1.171 0.235-1.598 0.662l-1.598 1.598 1.598 1.598zM3.75 5.74c-0.604 0-1.171 0.235-1.598 0.662s-0.662 0.994-0.662 1.598c0 0.604 0.235 1.171 0.662 1.598s0.994 0.662 1.598 0.662c0.604 0 1.171-0.235 1.598-0.662l1.598-1.598-1.598-1.598c-0.427-0.427-0.994-0.662-1.598-0.662v0z"
                }
            }
        ]
    })(props);
}
function ImShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11h-1.586l-2.5-2.5 2.5-2.5h1.586v2.5l3.5-3.5-3.5-3.5v2.5h-2c-0.265 0-0.52 0.105-0.707 0.293l-2.793 2.793-2.793-2.793c-0.188-0.188-0.442-0.293-0.707-0.293h-3v2h2.586l2.5 2.5-2.5 2.5h-2.586v2h3c0.265 0 0.52-0.105 0.707-0.293l2.793-2.793 2.793 2.793c0.188 0.188 0.442 0.293 0.707 0.293h2v2.5l3.5-3.5-3.5-3.5v2.5z"
                }
            }
        ]
    })(props);
}
function ImArrowUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5l4-4 8.5 8.5 3.5-3.5-8.5-8.5 4-4h-11.5v11.5z"
                }
            }
        ]
    })(props);
}
function ImArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.5l-7.5 7.5h4.5v8h6v-8h4.5z"
                }
            }
        ]
    })(props);
}
function ImArrowUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 0l4 4-8.5 8.5 3.5 3.5 8.5-8.5 4 4v-11.5h-11.5z"
                }
            }
        ]
    })(props);
}
function ImArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8l-7.5-7.5v4.5h-8v6h8v4.5z"
                }
            }
        ]
    })(props);
}
function ImArrowDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.5l-4 4-8.5-8.5-3.5 3.5 8.5 8.5-4 4h11.5v-11.5z"
                }
            }
        ]
    })(props);
}
function ImArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15.5l7.5-7.5h-4.5v-8h-6v8h-4.5z"
                }
            }
        ]
    })(props);
}
function ImArrowDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 16l-4-4 8.5-8.5-3.5-3.5-8.5 8.5-4-4v11.5h11.5z"
                }
            }
        ]
    })(props);
}
function ImArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.5 8l7.5 7.5v-4.5h8v-6h-8v-4.5z"
                }
            }
        ]
    })(props);
}
function ImArrowUpLeft2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 12.293l-8.293-8.293h3.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6c-0.404 0-0.769 0.244-0.924 0.617-0.051 0.124-0.076 0.254-0.076 0.383h-0.001v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-3.586l8.293 8.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.39 0.391-1.024 0-1.414z"
                }
            }
        ]
    })(props);
}
function ImArrowUp2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 6.293l-5-5c-0.39-0.391-1.024-0.391-1.414 0l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l3.293-3.293v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414z"
                }
            }
        ]
    })(props);
}
function ImArrowUpRight2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.707 13.707l8.293-8.293v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.404-0.244-0.769-0.617-0.924-0.124-0.051-0.254-0.076-0.383-0.076v-0.001h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.586l-8.293 8.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.39 0.391 1.024 0.391 1.414 0z"
                }
            }
        ]
    })(props);
}
function ImArrowRight2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707l5-5c0.391-0.39 0.391-1.024 0-1.414l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3.293 3.293h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.391 0.391 1.024 0.391 1.414 0z"
                }
            }
        ]
    })(props);
}
function ImArrowDownRight2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.293 3.707l8.293 8.293h-3.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h6c0.404 0 0.769-0.244 0.924-0.617 0.051-0.124 0.076-0.254 0.076-0.383h0.001v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.586l-8.293-8.293c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293c-0.391 0.39-0.391 1.024 0 1.414z"
                }
            }
        ]
    })(props);
}
function ImArrowDown2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 9.707l-5 5c-0.39 0.391-1.024 0.391-1.414 0l-5-5c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l3.293 3.293v-9.586c0-0.552 0.448-1 1-1s1 0.448 1 1v9.586l3.293-3.293c0.195-0.195 0.451-0.293 0.707-0.293s0.512 0.098 0.707 0.293c0.391 0.391 0.391 1.024 0 1.414z"
                }
            }
        ]
    })(props);
}
function ImArrowDownLeft2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.293 2.293l-8.293 8.293v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.383 0.076v0.001l6-0c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3.586l8.293-8.293c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707c-0.39-0.391-1.024-0.391-1.414 0v0z"
                }
            }
        ]
    })(props);
}
function ImArrowLeft2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z"
                }
            }
        ]
    })(props);
}
function ImCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.043 10.457l1.414-1.414-4.457-4.457-4.457 4.457 1.414 1.414 3.043-3.043z"
                }
            }
        ]
    })(props);
}
function ImCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z"
                }
            }
        ]
    })(props);
}
function ImCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.957 5.543l-1.414 1.414 4.457 4.457 4.457-4.457-1.414-1.414-3.043 3.043z"
                }
            }
        ]
    })(props);
}
function ImCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.457 4.957l-1.414-1.414-4.457 4.457 4.457 4.457 1.414-1.414-3.043-3.043z"
                }
            }
        ]
    })(props);
}
function ImTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h1v8h-1v-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8h1v8h-1v-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h11v2h-11v2.5l-3.5-3.5 3.5-3.5v2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h-11v-2h11v-2.5l3.5 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function ImMoveUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v6h1v-6h2.5l-3-3-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 7h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11v3h-3v-3h3zM6 10h-5v5h5v-5z"
                }
            }
        ]
    })(props);
}
function ImMoveDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v-6h-1v6h-2.5l3 3 3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h-3v-3h3zM6 3h-5v5h5v-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 10h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 14h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 14h1.5v1h-1.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11.5h1v1.5h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12h1v1.5h-1v-1.5z"
                }
            }
        ]
    })(props);
}
function ImSortAlphaAsc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 16h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.101 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 6.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 4l1.191-2.382 1.191 2.382h-2.382z"
                }
            }
        ]
    })(props);
}
function ImSortAlphaDesc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 7h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.102 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.947 15.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 13l1.191-2.382 1.191 2.382h-2.382z"
                }
            }
        ]
    })(props);
}
function ImSortNumericAsc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 9h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 10h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function ImSortNumbericDesc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 1h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function ImSortAmountAsc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h9v2h-9v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h7v2h-7v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h5v2h-5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0h3v2h-3v-2z"
                }
            }
        ]
    })(props);
}
function ImSortAmountDesc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0h9v2h-9v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h7v2h-7v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h5v2h-5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h3v2h-3v-2z"
                }
            }
        ]
    })(props);
}
function ImCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 14c-1.379 0-2.5-1.121-2.5-2.5v-1.5h-2v1.5c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5 1.122-2.5 2.5-2.5h1.5v-2h-1.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5v1.5h2v-1.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5h-1.5v2h1.5c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5zM10 10v1.5c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5h-1.5zM4.5 10c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5v-1.5h-1.5zM7 9h2v-2h-2v2zM10 6h1.5c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.673-1.5 1.5v1.5zM4.5 3c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5h1.5v-1.5c0-0.827-0.673-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function ImShift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 14h-5c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-2c-0.202 0-0.385-0.122-0.462-0.309s-0.035-0.402 0.108-0.545l5-5c0.195-0.195 0.512-0.195 0.707 0l5 5c0.143 0.143 0.186 0.358 0.108 0.545s-0.26 0.309-0.462 0.309h-2v5.5c0 0.276-0.224 0.5-0.5 0.5zM6 13h4v-5.5c0-0.276 0.224-0.5 0.5-0.5h1.293l-3.793-3.793-3.793 3.793h1.293c0.276 0 0.5 0.224 0.5 0.5v5.5z"
                }
            }
        ]
    })(props);
}
function ImCtrl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 7c-0.139 0-0.278-0.058-0.377-0.171l-3.124-3.57-3.124 3.57c-0.182 0.208-0.498 0.229-0.706 0.047s-0.229-0.498-0.047-0.706l3.5-4c0.095-0.108 0.232-0.171 0.376-0.171s0.281 0.062 0.376 0.171l3.5 4c0.182 0.208 0.161 0.524-0.047 0.706-0.095 0.083-0.212 0.124-0.329 0.124z"
                }
            }
        ]
    })(props);
}
function ImOpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 13h-4c-0.198 0-0.377-0.116-0.457-0.297l-3.868-8.703h-4.675c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.198 0 0.377 0.116 0.457 0.297l3.868 8.703h3.675c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 4h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImCheckboxChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 2.293 2.293 4.793-4.793 1.414 1.414-6.207 6.207z"
                }
            }
        ]
    })(props);
}
function ImCheckboxUnchecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
                }
            }
        ]
    })(props);
}
function ImRadioChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z"
                }
            }
        ]
    })(props);
}
function ImRadioChecked2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"
                }
            }
        ]
    })(props);
}
function ImRadioUnchecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
                }
            }
        ]
    })(props);
}
function ImCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4l3-3-1-1-3 3h-7v-3h-2v3h-3v2h3v8h8v3h2v-3h3v-2h-3v-7zM5 5h5l-5 5v-5zM6 11l5-5v5h-5z"
                }
            }
        ]
    })(props);
}
function ImMakeGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1zM11 3h2v2h-2v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM5 13h-2v-2h2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8h-1c-1.336 0-2.591-0.52-3.536-1.464s-1.464-2.2-1.464-3.536v-1c0-1.1-0.9-2-2-2h-4c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h1c1.336 0 2.591 0.52 3.536 1.464s1.464 2.2 1.464 3.536v1c0 1.1 0.9 2 2 2h4c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2zM15 14c0 0.265-0.105 0.515-0.295 0.705s-0.44 0.295-0.705 0.295h-4c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.44-0.295-0.705v-1c0-3.314-2.686-6-6-6h-1c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.441-0.295-0.705v-4c0-0.265 0.105-0.515 0.295-0.705s0.44-0.295 0.705-0.295h4c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v1c0 3.314 2.686 6 6 6h1c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v4z"
                }
            }
        ]
    })(props);
}
function ImUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.251 2.5l1.749-1.749v-0.751h-0.751l-1.749 1.749-1.749-1.749h-0.751v0.751l1.749 1.749-1.749 1.749v0.751h0.751l1.749-1.749 1.749 1.749h0.751v-0.751z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3h1v2h-1v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h2v1h-2v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 15h2v1h-2v-1z"
                }
            }
        ]
    })(props);
}
function ImScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.279 10.62c-1.042-1.628-2.829-2.345-3.992-1.601-0.1 0.064-0.193 0.138-0.277 0.218l-1.241-1.942 2.867-4.5c0.235-0.433 0.321-0.949 0.207-1.468-0.109-0.496-0.383-0.913-0.752-1.207l-0.192-0.122-3.398 5.314-3.398-5.314-0.192 0.122c-0.369 0.294-0.643 0.711-0.752 1.207-0.114 0.519-0.027 1.035 0.207 1.468l2.867 4.5-1.241 1.942c-0.085-0.081-0.177-0.154-0.277-0.218-1.163-0.744-2.95-0.028-3.992 1.601s-0.944 3.551 0.219 4.296c1.163 0.744 2.95 0.028 3.992-1.601l2.567-4.029 2.567 4.029c1.042 1.628 2.829 2.345 3.992 1.601s1.261-2.667 0.219-4.296zM3.67 12.507c-0.469 0.733-1.071 1.089-1.478 1.179-0 0-0 0-0 0-0.133 0.029-0.317 0.047-0.443-0.033-0.139-0.089-0.231-0.324-0.247-0.629-0.025-0.494 0.151-1.076 0.483-1.594 0.469-0.733 1.071-1.089 1.478-1.179 0.133-0.029 0.317-0.047 0.443 0.033 0.139 0.089 0.231 0.324 0.247 0.629 0.025 0.495-0.151 1.076-0.483 1.594zM7.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.498 13.023c-0.016 0.305-0.108 0.54-0.247 0.629-0.125 0.080-0.31 0.062-0.443 0.033 0 0 0 0-0 0-0.407-0.089-1.009-0.446-1.478-1.179-0.332-0.519-0.508-1.1-0.483-1.594 0.016-0.305 0.108-0.54 0.247-0.629 0.125-0.080 0.31-0.062 0.443-0.033 0.407 0.089 1.009 0.446 1.478 1.179 0.332 0.519 0.508 1.1 0.483 1.594z"
                }
            }
        ]
    })(props);
}
function ImFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 1.119-8 2.5v1.5l6 6v5c0 0.552 0.895 1 2 1s2-0.448 2-1v-5l6-6v-1.5c0-1.381-3.582-2.5-8-2.5zM1.475 2.169c0.374-0.213 0.9-0.416 1.52-0.586 1.374-0.376 3.152-0.583 5.005-0.583s3.631 0.207 5.005 0.583c0.62 0.17 1.146 0.372 1.52 0.586 0.247 0.141 0.38 0.26 0.442 0.331-0.062 0.071-0.195 0.19-0.442 0.331-0.374 0.213-0.9 0.416-1.52 0.586-1.374 0.376-3.152 0.583-5.005 0.583s-3.631-0.207-5.005-0.583c-0.62-0.17-1.146-0.372-1.52-0.586-0.247-0.141-0.38-0.26-0.442-0.331 0.062-0.071 0.195-0.19 0.442-0.331z"
                }
            }
        ]
    })(props);
}
function ImFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.494 0.253c-1.414 0-2.322-0.253-3.779-0.253-4.708 0-6.903 2.681-6.903 5.404 0 1.604 0.76 2.132 2.259 2.132-0.106-0.232-0.296-0.486-0.296-1.626 0-3.188 1.203-4.117 2.744-4.18 0 0-1.264 12.396-4.934 13.883v0.385h4.947l1.688-8h3.091l0.689-2h-3.358l0.812-3.847c0.929 0.19 1.837 0.38 2.618 0.38 0.971 0 1.858-0.296 2.343-2.533-0.591 0.19-1.224 0.253-1.921 0.253z"
                }
            }
        ]
    })(props);
}
function ImLigature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.622c0-0.001 0-0.001 0-0.002l-0.005-6.821-1.992 0.097h-3.936v-0.336c0-1.274 0.091-2.546 0.269-3.042 0.123-0.343 0.353-0.652 0.683-0.919 0.322-0.261 0.643-0.393 0.955-0.393 0.262 0 0.48 0.045 0.647 0.134 0.235 0.134 0.464 0.359 0.682 0.669 0.577 0.82 0.812 1.038 0.939 1.131 0.216 0.158 0.477 0.238 0.776 0.238 0.292 0 0.546-0.109 0.757-0.324 0.209-0.213 0.315-0.479 0.315-0.792 0-0.335-0.139-0.691-0.414-1.057-0.268-0.358-0.683-0.652-1.232-0.875-0.536-0.218-1.14-0.329-1.793-0.329-0.949 0-1.813 0.228-2.568 0.678-0.757 0.451-1.337 1.077-1.725 1.863-0.359 0.728-0.333 2.105-0.355 3.355h-1.965v1.116h1.962v5.073c0 1.12-0.342 1.422-0.472 1.583-0.179 0.222-0.509 0.455-0.944 0.455h-0.604v0.878h6.021v-0.878h-0.105c-1.424 0-1.828-0.154-1.828-1.888 0-0 0-0.001 0-0.001l-0.001-5.222h2.191c1.163 0 1.43 0.054 1.491 0.077 0.074 0.028 0.169 0.075 0.204 0.143 0.014 0.026 0.081 0.391 0.081 1.296v3.917c0 0.913-0.111 1.217-0.179 1.319-0.145 0.222-0.319 0.345-0.854 0.358v0.879h4.588v-0.873c-1.431 0-1.588-0.153-1.588-1.505z"
                }
            }
        ]
    })(props);
}
function ImLigature2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.364 14.335c-0.183 0-1.307-0.206-1.375-0.458-0.161-0.619-0.183-1.284-0.183-2.040v-8.453c0-1.261 0.252-1.994 0.252-1.994-0.023-0.115-0.138-0.367-0.275-0.367h-0.069c-0.069 0-0.871 0.504-1.605 0.504-0.596-0-0.967-0.527-1.655-0.527-2.892 0-4.249 2.349-4.249 5.672v0.173c0 0.069-0.046 0.138-0.115 0.138h-0.94c-0.115 0-0.344 0.642-0.344 0.94 0 0.092 0.023 0.137 0.069 0.137h1.215c0.069 0 0.115 0.092 0.115 0.16 0 2.040-0.023 4.052-0.023 4.052 0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.138 0.046-0.665-0.069-0.665-0.183 0-1.307-0.206-1.375-0.458-0.16-0.619-0.16-1.284-0.183-2.040v-3.639c0-0.069 0.069-0.138 0.138-0.138h2.361c0.16-0.321 0.275-0.711 0.275-0.917 0-0.138 0-0.16-0.115-0.16h-2.544c-0.046 0-0.115-0.069-0.115-0.115v-0.825c0-2.040 0.836-3.837 2.234-3.837 0.99 0 1.854 0.642 1.854 3.093 0 0 0 0 0 0 0.003 0.063 0.005 0.114 0.005 0.148v6.825c0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.137 0.046-0.665-0.069-0.665z"
                }
            }
        ]
    })(props);
}
function ImTextHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h2l-2.5 3-2.5-3h2v-8h-2l2.5-3 2.5 3h-2zM10 1v4l-1-2h-3v11h2v1h-6v-1h2v-11h-3l-1 2v-4z"
                }
            }
        ]
    })(props);
}
function ImTextWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14v2l-3-2.5 3-2.5v2h8v-2l3 2.5-3 2.5v-2zM13 1v4l-1-2h-3v7h2v1h-6v-1h2v-7h-3l-1 2v-4z"
                }
            }
        ]
    })(props);
}
function ImFontSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8h6v2h-2v6h-2v-6h-2zM15 4h-3.934v12h-2.133v-12h-3.934v-2h10z"
                }
            }
        ]
    })(props);
}
function ImBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.061 7.573c0.586-0.696 0.939-1.594 0.939-2.573 0-2.206-1.794-4-4-4h-5v14h6c2.206 0 4-1.794 4-4 0-1.452-0.778-2.726-1.939-3.427zM6 3h1.586c0.874 0 1.586 0.897 1.586 2s-0.711 2-1.586 2h-1.586v-4zM8.484 13h-2.484v-4h2.484c0.913 0 1.656 0.897 1.656 2s-0.743 2-1.656 2z"
                }
            }
        ]
    })(props);
}
function ImUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1h2v6.5c0 2.485-2.239 4.5-5 4.5s-5-2.015-5-4.5v-6.5h2v6.5c0 0.628 0.285 1.23 0.802 1.695 0.577 0.519 1.357 0.805 2.198 0.805s1.621-0.286 2.198-0.805c0.517-0.466 0.802-1.068 0.802-1.695v-6.5zM3 13h10v2h-10z"
                }
            }
        ]
    })(props);
}
function ImItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z"
                }
            }
        ]
    })(props);
}
function ImStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v1h-3.664c0.43 0.602 0.664 1.292 0.664 2 0 1.107-0.573 2.172-1.572 2.921-0.927 0.696-2.145 1.079-3.428 1.079s-2.501-0.383-3.428-1.079c-0.999-0.749-1.572-1.814-1.572-2.921h2c0 1.084 1.374 2 3 2s3-0.916 3-2c0-1.084-1.374-2-3-2h-8v-1h4.68c-0.037-0.026-0.073-0.052-0.108-0.079-0.999-0.749-1.572-1.814-1.572-2.921s0.573-2.172 1.572-2.921c0.927-0.696 2.145-1.079 3.428-1.079s2.501 0.383 3.428 1.079c0.999 0.749 1.572 1.814 1.572 2.921h-2c0-1.084-1.374-2-3-2s-3 0.916-3 2c0 1.084 1.374 2 3 2 1.234 0 2.407 0.354 3.32 1h4.68z"
                }
            }
        ]
    })(props);
}
function ImOmega(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h4l1-2v4h-6v-3.347c2.049-0.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973s-5.5 2.622-5.5 5.973c0 2.572 1.451 4.77 3.5 5.653v3.347h-6v-4l1 2h4v-0.509c-2.932-1.038-5-3.553-5-6.491 0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491v0.509z"
                }
            }
        ]
    })(props);
}
function ImSigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.713 11.48l0.694-1.48h0.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18v-3.547h15.313l0.688 4h-0.537l-0.293-0.607c-0.552-1.146-0.967-1.393-2.17-1.393h-10.344l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-0.65 2.713-1.52z"
                }
            }
        ]
    })(props);
}
function ImPageBreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8h2v1h-2zM3 8h3v1h-3zM7 8h2v1h-2zM10 8h3v1h-3zM14 8h2v1h-2zM13.75 0l0.25 7h-12l0.25-7h0.5l0.25 6h10l0.25-6zM2.25 16l-0.25-6h12l-0.25 6h-0.5l-0.25-5h-10l-0.25 5z"
                }
            }
        ]
    })(props);
}
function ImSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
                }
            }
        ]
    })(props);
}
function ImSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
                }
            }
        ]
    })(props);
}
function ImSuperscript2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM11 13l2.5-4 2.5 4h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 2h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
                }
            }
        ]
    })(props);
}
function ImSubscript2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM16 3l-2.5 4-2.5-4h5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 13h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
                }
            }
        ]
    })(props);
}
function ImTextColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM7.432 5h1.137l0.9 3h-2.937l0.9-3z"
                }
            }
        ]
    })(props);
}
function ImPagebreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6v-6h12v6h-1v-5h-10v5zM16 9v7h-12v-7h1v6h10v-6zM8 7h2v1h-2zM5 7h2v1h-2zM11 7h2v1h-2zM14 7h2v1h-2zM0 4.5l3 3-3 3z"
                }
            }
        ]
    })(props);
}
function ImClearFormatting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14h9v2h-9zM14 2h-4.727l-2.871 11h-2.067l2.871-11h-4.205v-2h11zM14.528 16l-2.028-2.028-2.028 2.028-0.972-0.972 2.028-2.028-2.028-2.028 0.972-0.972 2.028 2.028 2.028-2.028 0.972 0.972-2.028 2.028 2.028 2.028z"
                }
            }
        ]
    })(props);
}
function ImTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3v11h16v-11h-16zM6 10v-2h4v2h-4zM10 11v2h-4v-2h4zM10 5v2h-4v-2h4zM5 5v2h-4v-2h4zM1 8h4v2h-4v-2zM11 8h4v2h-4v-2zM11 7v-2h4v2h-4zM1 11h4v2h-4v-2zM11 13v-2h4v2h-4z"
                }
            }
        ]
    })(props);
}
function ImTable2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v14h16v-14h-16zM6 10v-3h4v3h-4zM10 11v3h-4v-3h4zM10 3v3h-4v-3h4zM5 3v3h-4v-3h4zM1 7h4v3h-4v-3zM11 7h4v3h-4v-3zM11 6v-3h4v3h-4zM1 11h4v3h-4v-3zM11 14v-3h4v3h-4z"
                }
            }
        ]
    })(props);
}
function ImInsertTemplate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h2v1h-2zM9 3h2v1h-2zM14 3v4h-3v-1h2v-2h-1v-1zM5 6h2v1h-2zM8 6h2v1h-2zM3 4v2h1v1h-2v-4h3v1zM6 9h2v1h-2zM9 9h2v1h-2zM14 9v4h-3v-1h2v-2h-1v-1zM5 12h2v1h-2zM8 12h2v1h-2zM3 10v2h1v1h-2v-4h3v1zM15 1h-14v14h14v-14zM16 0v0 16h-16v-16h16z"
                }
            }
        ]
    })(props);
}
function ImPilcrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0h8v2h-2v14h-2v-14h-2v14h-2v-8c-2.209 0-4-1.791-4-4s1.791-4 4-4z"
                }
            }
        ]
    })(props);
}
function ImLtr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM0 11l4-4-4-4z"
                }
            }
        ]
    })(props);
}
function ImRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM16 3l-4 4 4 4z"
                }
            }
        ]
    })(props);
}
function ImSection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.749 16c-0.771 0-1.424-0.225-1.939-0.669-0.519-0.447-0.782-0.969-0.782-1.552 0-0.283 0.103-0.527 0.307-0.726 0.207-0.202 0.465-0.309 0.748-0.309 0.281 0 0.534 0.1 0.732 0.29 0.195 0.187 0.294 0.435 0.294 0.736 0 0.177-0.029 0.372-0.086 0.58-0.056 0.206-0.068 0.312-0.068 0.364 0 0.058 0.014 0.126 0.121 0.199 0.199 0.138 0.439 0.204 0.732 0.204 0.353 0 0.667-0.123 0.962-0.375 0.29-0.249 0.431-0.505 0.431-0.782 0-0.308-0.082-0.575-0.252-0.816-0.287-0.402-0.826-0.874-1.603-1.401-1.248-0.835-2.079-1.559-2.54-2.211-0.358-0.511-0.539-1.061-0.539-1.636 0-0.579 0.19-1.155 0.564-1.713 0.32-0.477 0.794-0.908 1.41-1.283-0.33-0.355-0.577-0.689-0.736-0.995-0.201-0.387-0.303-0.787-0.303-1.189 0-0.747 0.295-1.393 0.878-1.92s1.31-0.795 2.161-0.795c0.783 0 1.441 0.22 1.956 0.654 0.521 0.439 0.785 0.952 0.785 1.524 0 0.292-0.109 0.553-0.324 0.776l-0.004 0.004c-0.125 0.124-0.353 0.271-0.735 0.271-0.299 0-0.561-0.098-0.758-0.283-0.196-0.184-0.296-0.405-0.296-0.656 0-0.108 0.027-0.272 0.084-0.515 0.028-0.115 0.042-0.221 0.042-0.316 0-0.162-0.058-0.285-0.183-0.39-0.129-0.108-0.314-0.161-0.565-0.161-0.389 0-0.708 0.118-0.975 0.361s-0.399 0.533-0.399 0.883c0 0.315 0.071 0.574 0.212 0.771 0.267 0.374 0.731 0.778 1.378 1.201 1.315 0.853 2.233 1.636 2.727 2.325 0.365 0.518 0.549 1.068 0.549 1.637 0 0.572-0.186 1.148-0.552 1.714-0.316 0.487-0.793 0.926-1.42 1.308 0.347 0.367 0.591 0.688 0.743 0.977 0.189 0.359 0.284 0.751 0.284 1.165 0 0.776-0.296 1.435-0.879 1.96s-1.31 0.79-2.161 0.79zM6.975 5.568c-0.753 0.452-1.12 0.972-1.12 1.583 0 0.356 0.102 0.674 0.31 0.973 0.311 0.436 0.926 0.97 1.825 1.583 0.381 0.259 0.724 0.511 1.025 0.751 0.767-0.461 1.14-0.974 1.14-1.565 0-0.322-0.127-0.668-0.378-1.030-0.263-0.378-0.826-0.872-1.674-1.467-0.443-0.306-0.821-0.583-1.128-0.827z"
                }
            }
        ]
    })(props);
}
function ImParagraphLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM0 4h10v2h-10zM0 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function ImParagraphCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM3 4h10v2h-10zM3 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function ImParagraphRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function ImParagraphJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM0 4h16v2h-16zM0 7h16v2h-16zM0 10h16v2h-16zM0 13h16v2h-16z"
                }
            }
        ]
    })(props);
}
function ImIndentIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM0 11v-6l4 3z"
                }
            }
        ]
    })(props);
}
function ImIndentDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM4 5v6l-4-3z"
                }
            }
        ]
    })(props);
}
function ImShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0 0 0.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zM11 12h-9v-6h1.967c0.158-0.186 0.327-0.365 0.508-0.534 0.687-0.644 1.509-1.135 2.439-1.466h-6.914v10h13v-4.197l-2 1.333v0.864z"
                }
            }
        ]
    })(props);
}
function ImNewTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1v12h12v-12h-12zM14 12h-10v-10h10v10zM2 14v-10.5l-1-1v12.5h12.5l-1-1h-10.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5v-6.5z"
                }
            }
        ]
    })(props);
}
function ImEmbed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function ImEmbed2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 20 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z"
                }
            }
        ]
    })(props);
}
function ImTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1v14h16v-14h-16zM15 14h-14v-12h14v12zM14 3h-12v10h12v-10zM7 8h-1v1h-1v1h-1v-1h1v-1h1v-1h-1v-1h-1v-1h1v1h1v1h1v1zM11 10h-3v-1h3v1z"
                }
            }
        ]
    })(props);
}
function ImShare2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 11c-0.706 0-1.342 0.293-1.797 0.763l-6.734-3.367c0.021-0.129 0.032-0.261 0.032-0.396s-0.011-0.267-0.032-0.396l6.734-3.367c0.455 0.47 1.091 0.763 1.797 0.763 1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.119-2.5 2.5c0 0.135 0.011 0.267 0.031 0.396l-6.734 3.367c-0.455-0.47-1.091-0.763-1.797-0.763-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5c0.706 0 1.343-0.293 1.797-0.763l6.734 3.367c-0.021 0.129-0.031 0.261-0.031 0.396 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5z"
                }
            }
        ]
    })(props);
}
function ImMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.467 1.2 2.667 2.667 2.667h10.666c1.468 0 2.667-1.2 2.667-2.667v-10.666c0-1.467-1.199-2.667-2.667-2.667zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
                }
            }
        ]
    })(props);
}
function ImMail2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM13.333 2c0.125 0 0.243 0.036 0.344 0.099l-5.678 4.694-5.677-4.694c0.101-0.063 0.219-0.099 0.344-0.099h10.666zM2.667 14c-0.030 0-0.060-0.002-0.089-0.006l3.525-4.89-0.457-0.457-3.646 3.646v-9.549l6 7.256 6-7.256v9.549l-3.646-3.646-0.457 0.457 3.525 4.89c-0.029 0.004-0.059 0.006-0.088 0.006h-10.666z"
                }
            }
        ]
    })(props);
}
function ImMail3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM2.854 13.854l-1.207-1.207 4-4 0.457 0.457-3.25 4.75zM2.396 3.104l0.457-0.457 5.146 4.146 5.146-4.146 0.457 0.457-5.604 6.604-5.604-6.604zM13.146 13.854l-3.25-4.75 0.457-0.457 4 4-1.207 1.207z"
                }
            }
        ]
    })(props);
}
function ImMail4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
                }
            }
        ]
    })(props);
}
function ImAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.463 13.831c-1.753 1.294-4.291 1.981-6.478 1.981-3.066 0-5.825-1.131-7.912-3.019-0.163-0.147-0.019-0.35 0.178-0.234 2.253 1.313 5.041 2.1 7.919 2.1 1.941 0 4.075-0.403 6.041-1.238 0.294-0.125 0.544 0.197 0.253 0.409z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.191 13c-0.225-0.287-1.481-0.137-2.047-0.069-0.172 0.019-0.197-0.128-0.044-0.238 1.003-0.703 2.647-0.5 2.838-0.266 0.194 0.238-0.050 1.884-0.991 2.672-0.144 0.122-0.281 0.056-0.219-0.103 0.216-0.528 0.688-1.709 0.463-1.997z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.053 11.838l0.003 0.003c0.387-0.341 1.084-0.95 1.478-1.278 0.156-0.125 0.128-0.334 0.006-0.509-0.353-0.488-0.728-0.884-0.728-1.784v-3c0-1.272 0.088-2.438-0.847-3.313-0.738-0.706-1.963-0.956-2.9-0.956-1.831 0-3.875 0.684-4.303 2.947-0.047 0.241 0.131 0.369 0.287 0.403l1.866 0.203c0.175-0.009 0.3-0.181 0.334-0.356 0.159-0.778 0.813-1.156 1.547-1.156 0.397 0 0.847 0.144 1.081 0.5 0.269 0.397 0.234 0.938 0.234 1.397v0.25c-1.116 0.125-2.575 0.206-3.619 0.666-1.206 0.522-2.053 1.584-2.053 3.147 0 2 1.259 3 2.881 3 1.369 0 2.116-0.322 3.172-1.403 0.35 0.506 0.463 0.753 1.103 1.284 0.147 0.078 0.328 0.072 0.456-0.044zM9.113 7.144c0 0.75 0.019 1.375-0.359 2.041-0.306 0.544-0.791 0.875-1.331 0.875-0.737 0-1.169-0.563-1.169-1.394 0-1.641 1.472-1.938 2.863-1.938v0.416z"
                }
            }
        ]
    })(props);
}
function ImGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.159 6.856v2.744h4.537c-0.184 1.178-1.372 3.45-4.537 3.45-2.731 0-4.959-2.262-4.959-5.050s2.228-5.050 4.959-5.050c1.553 0 2.594 0.663 3.188 1.234l2.172-2.091c-1.394-1.306-3.2-2.094-5.359-2.094-4.422 0-8 3.578-8 8s3.578 8 8 8c4.616 0 7.681-3.247 7.681-7.816 0-0.525-0.056-0.925-0.125-1.325l-7.556-0.003z"
                }
            }
        ]
    })(props);
}
function ImGoogle2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
                }
            }
        ]
    })(props);
}
function ImGoogle3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
                }
            }
        ]
    })(props);
}
function ImGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.091 7.147v1.747h2.888c-0.116 0.75-0.872 2.197-2.888 2.197-1.737 0-3.156-1.441-3.156-3.216s1.419-3.216 3.156-3.216c0.991 0 1.65 0.422 2.028 0.784l1.381-1.331c-0.888-0.828-2.037-1.331-3.409-1.331-2.816 0.003-5.091 2.278-5.091 5.094s2.275 5.091 5.091 5.091c2.937 0 4.888-2.066 4.888-4.975 0-0.334-0.037-0.591-0.081-0.844h-4.806z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1.5v-1.5h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5z"
                }
            }
        ]
    })(props);
}
function ImGooglePlus2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM14 8h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1z"
                }
            }
        ]
    })(props);
}
function ImGooglePlus3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM13 8v1h-1v-1h-1v-1h1v-1h1v1h1v1h-1z"
                }
            }
        ]
    })(props);
}
function ImHangouts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.997 0c-3.816 0-6.909 3.094-6.909 6.909 0 3.616 3.294 6.547 6.909 6.547v2.544c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3zM12 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3z"
                }
            }
        ]
    })(props);
}
function ImGoogleDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.844 10l-2.884 5h9.072l2.884-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.506 9l-4.619-8h-5.775l4.619 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.534 2l-4.534 7.856 2.888 5 4.534-7.856z"
                }
            }
        ]
    })(props);
}
function ImFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 3h2.5v-3h-2.5c-1.93 0-3.5 1.57-3.5 3.5v1.5h-2v3h2v8h3v-8h2.5l0.5-3h-3v-1.5c0-0.271 0.229-0.5 0.5-0.5z"
                }
            }
        ]
    })(props);
}
function ImFacebook2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h6.5v-7h-2v-2h2v-1c0-1.653 1.347-3 3-3h2v2h-2c-0.55 0-1 0.45-1 1v1h3l-0.5 2h-2.5v7h4.5c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function ImInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11 2.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v2c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-2zM8 5c1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.656 0-3-1.344-3-3s1.344-3 3-3zM14 13.5v0c0 0.275-0.225 0.5-0.5 0.5h-11c-0.275 0-0.5-0.225-0.5-0.5v0-6.5h1.1c-0.066 0.322-0.1 0.656-0.1 1 0 2.762 2.237 5 5 5s5-2.238 5-5c0-0.344-0.034-0.678-0.1-1h1.1v6.5z"
                }
            }
        ]
    })(props);
}
function ImWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.641 2.325c-1.497-1.5-3.488-2.325-5.609-2.325-4.369 0-7.925 3.556-7.925 7.928 0 1.397 0.366 2.763 1.059 3.963l-1.125 4.109 4.203-1.103c1.159 0.631 2.463 0.966 3.787 0.966h0.003c0 0 0 0 0 0 4.369 0 7.928-3.556 7.928-7.928 0-2.119-0.825-4.109-2.322-5.609zM8.034 14.525v0c-1.184 0-2.344-0.319-3.356-0.919l-0.241-0.144-2.494 0.653 0.666-2.431-0.156-0.25c-0.663-1.047-1.009-2.259-1.009-3.506 0-3.634 2.956-6.591 6.594-6.591 1.759 0 3.416 0.688 4.659 1.931 1.244 1.247 1.928 2.9 1.928 4.662-0.003 3.637-2.959 6.594-6.591 6.594zM11.647 9.588c-0.197-0.1-1.172-0.578-1.353-0.644s-0.313-0.1-0.447 0.1c-0.131 0.197-0.512 0.644-0.628 0.778-0.116 0.131-0.231 0.15-0.428 0.050s-0.838-0.309-1.594-0.984c-0.588-0.525-0.987-1.175-1.103-1.372s-0.013-0.306 0.088-0.403c0.091-0.088 0.197-0.231 0.297-0.347s0.131-0.197 0.197-0.331c0.066-0.131 0.034-0.247-0.016-0.347s-0.447-1.075-0.609-1.472c-0.159-0.388-0.325-0.334-0.447-0.341-0.116-0.006-0.247-0.006-0.378-0.006s-0.347 0.050-0.528 0.247c-0.181 0.197-0.694 0.678-0.694 1.653s0.709 1.916 0.809 2.050c0.1 0.131 1.397 2.134 3.384 2.991 0.472 0.203 0.841 0.325 1.128 0.419 0.475 0.15 0.906 0.128 1.247 0.078 0.381-0.056 1.172-0.478 1.338-0.941s0.166-0.859 0.116-0.941c-0.047-0.088-0.178-0.137-0.378-0.238z"
                }
            }
        ]
    })(props);
}
function ImSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.559-8-8-8zM11.681 11.559c-0.159 0.241-0.441 0.319-0.681 0.159-1.881-1.159-4.241-1.4-7.041-0.759-0.281 0.081-0.519-0.119-0.6-0.359-0.081-0.281 0.119-0.519 0.359-0.6 3.041-0.681 5.681-0.4 7.759 0.881 0.281 0.119 0.322 0.438 0.203 0.678zM12.641 9.359c-0.2 0.281-0.559 0.4-0.841 0.2-2.159-1.319-5.441-1.719-7.959-0.919-0.319 0.081-0.681-0.081-0.759-0.4-0.081-0.319 0.081-0.681 0.4-0.759 2.919-0.881 6.519-0.441 9 1.081 0.238 0.119 0.359 0.519 0.159 0.797zM12.719 7.119c-2.559-1.519-6.841-1.681-9.281-0.919-0.4 0.119-0.8-0.119-0.919-0.481-0.119-0.4 0.119-0.8 0.481-0.919 2.841-0.841 7.519-0.681 10.481 1.081 0.359 0.2 0.481 0.681 0.281 1.041-0.203 0.278-0.681 0.397-1.044 0.197z"
                }
            }
        ]
    })(props);
}
function ImTelegram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM11.931 5.484l-1.313 6.184c-0.091 0.441-0.356 0.544-0.725 0.341l-2-1.478-0.959 0.934c-0.112 0.109-0.2 0.2-0.4 0.2-0.259 0-0.216-0.097-0.303-0.344l-0.681-2.237-1.978-0.616c-0.428-0.131-0.431-0.425 0.097-0.634l7.706-2.975c0.35-0.159 0.691 0.084 0.556 0.625z"
                }
            }
        ]
    })(props);
}
function ImTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.538c-0.588 0.263-1.222 0.438-1.884 0.516 0.678-0.406 1.197-1.050 1.444-1.816-0.634 0.375-1.338 0.65-2.084 0.797-0.6-0.638-1.453-1.034-2.397-1.034-1.813 0-3.281 1.469-3.281 3.281 0 0.256 0.028 0.506 0.084 0.747-2.728-0.138-5.147-1.444-6.766-3.431-0.281 0.484-0.444 1.050-0.444 1.65 0 1.138 0.578 2.144 1.459 2.731-0.538-0.016-1.044-0.166-1.488-0.409 0 0.013 0 0.028 0 0.041 0 1.591 1.131 2.919 2.634 3.219-0.275 0.075-0.566 0.116-0.866 0.116-0.212 0-0.416-0.022-0.619-0.059 0.419 1.303 1.631 2.253 3.066 2.281-1.125 0.881-2.538 1.406-4.078 1.406-0.266 0-0.525-0.016-0.784-0.047 1.456 0.934 3.181 1.475 5.034 1.475 6.037 0 9.341-5.003 9.341-9.341 0-0.144-0.003-0.284-0.009-0.425 0.641-0.459 1.197-1.038 1.637-1.697z"
                }
            }
        ]
    })(props);
}
function ImVine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.012 7.953c-0.412 0.094-0.809 0.137-1.169 0.137-2.019 0-3.572-1.409-3.572-3.862 0-1.203 0.466-1.825 1.122-1.825 0.625 0 1.041 0.559 1.041 1.697 0 0.647-0.172 1.356-0.3 1.775 0 0 0.622 1.084 2.322 0.753 0.363-0.803 0.556-1.841 0.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-0.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016h-2.722c1.259 9.675 5.006 12.756 6 13.347 0.559 0.337 1.044 0.322 1.556 0.031 0.806-0.456 3.222-2.875 4.563-5.703 0.563 0 1.238-0.066 1.909-0.219v-1.906z"
                }
            }
        ]
    })(props);
}
function ImVk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.959 11.2l-1.463 0.022c0 0-0.316 0.063-0.728-0.222-0.547-0.375-1.063-1.353-1.466-1.225-0.406 0.128-0.394 1.006-0.394 1.006s0.003 0.188-0.091 0.287c-0.1 0.109-0.3 0.131-0.3 0.131h-0.653c0 0-1.444 0.088-2.716-1.238-1.388-1.444-2.612-4.309-2.612-4.309s-0.072-0.188 0.006-0.278c0.087-0.103 0.322-0.109 0.322-0.109l1.566-0.009c0 0 0.147 0.025 0.253 0.103 0.088 0.063 0.134 0.184 0.134 0.184s0.253 0.641 0.588 1.219c0.653 1.128 0.959 1.375 1.181 1.256 0.322-0.175 0.225-1.597 0.225-1.597s0.006-0.516-0.162-0.744c-0.131-0.178-0.378-0.231-0.484-0.244-0.088-0.013 0.056-0.216 0.244-0.309 0.281-0.138 0.778-0.147 1.366-0.141 0.456 0.003 0.591 0.034 0.769 0.075 0.541 0.131 0.356 0.634 0.356 1.841 0 0.388-0.069 0.931 0.209 1.109 0.119 0.078 0.412 0.012 1.147-1.234 0.347-0.591 0.609-1.284 0.609-1.284s0.056-0.125 0.144-0.178c0.091-0.053 0.213-0.037 0.213-0.037l1.647-0.009c0 0 0.494-0.059 0.575 0.166 0.084 0.234-0.184 0.781-0.856 1.678-1.103 1.472-1.228 1.334-0.309 2.184 0.875 0.813 1.056 1.209 1.088 1.259 0.356 0.6-0.406 0.647-0.406 0.647z"
                }
            }
        ]
    })(props);
}
function ImRenren(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.644 0.166c-3.769 0.634-6.644 3.913-6.644 7.862 0 1.963 0.713 3.759 1.887 5.15 2.791-1.35 4.744-4.406 4.756-7.966v-5.047z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.356 0.166c3.769 0.634 6.644 3.913 6.644 7.862 0 1.963-0.713 3.759-1.887 5.15-2.791-1.35-4.744-4.406-4.756-7.966v-5.047z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.972 10.041c-0.497 2.056-1.981 3.813-3.828 4.981 1.138 0.622 2.441 0.978 3.828 0.978s2.691-0.356 3.828-0.978c-1.847-1.169-3.331-2.925-3.828-4.981z"
                }
            }
        ]
    })(props);
}
function ImSinaWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.722 14.031c-2.65 0.262-4.938-0.938-5.109-2.675-0.172-1.741 1.837-3.359 4.484-3.622 2.65-0.263 4.938 0.938 5.106 2.675 0.175 1.741-1.834 3.362-4.481 3.622zM12.019 8.259c-0.225-0.069-0.381-0.113-0.262-0.409 0.256-0.644 0.281-1.197 0.003-1.594-0.519-0.741-1.941-0.703-3.569-0.019 0 0-0.513 0.222-0.381-0.181 0.25-0.806 0.213-1.478-0.178-1.869-0.884-0.884-3.234 0.034-5.25 2.050-1.506 1.503-2.381 3.106-2.381 4.491 0 2.644 3.394 4.253 6.713 4.253 4.35 0 7.247-2.528 7.247-4.534 0-1.216-1.022-1.903-1.941-2.188z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.909 3.416c-1.050-1.166-2.6-1.609-4.031-1.306v0c-0.331 0.072-0.541 0.397-0.469 0.725 0.072 0.331 0.394 0.541 0.725 0.469 1.019-0.216 2.119 0.1 2.866 0.928s0.95 1.956 0.628 2.944v0c-0.103 0.322 0.072 0.666 0.394 0.772 0.322 0.103 0.666-0.072 0.772-0.394v-0.003c0.45-1.381 0.166-2.969-0.884-4.134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.294 4.875c-0.512-0.569-1.269-0.784-1.963-0.634-0.284 0.059-0.466 0.344-0.406 0.628 0.063 0.284 0.344 0.466 0.625 0.403v0c0.341-0.072 0.709 0.034 0.959 0.309 0.25 0.278 0.319 0.656 0.209 0.987v0c-0.088 0.275 0.063 0.575 0.341 0.666 0.278 0.088 0.575-0.063 0.666-0.341 0.219-0.678 0.081-1.453-0.431-2.019z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.869 10.884c-0.094 0.159-0.297 0.234-0.456 0.169-0.159-0.063-0.206-0.244-0.116-0.397 0.094-0.153 0.291-0.228 0.447-0.169 0.156 0.056 0.213 0.234 0.125 0.397zM6.022 11.966c-0.256 0.409-0.806 0.588-1.219 0.4-0.406-0.184-0.528-0.659-0.272-1.059 0.253-0.397 0.784-0.575 1.194-0.403 0.416 0.178 0.55 0.65 0.297 1.063zM6.984 9.072c-1.259-0.328-2.684 0.3-3.231 1.409-0.559 1.131-0.019 2.391 1.253 2.803 1.319 0.425 2.875-0.228 3.416-1.447 0.534-1.197-0.131-2.425-1.438-2.766z"
                }
            }
        ]
    })(props);
}
function ImRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z"
                }
            }
        ]
    })(props);
}
function ImRss2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.359 12.988c-0.75 0-1.359-0.603-1.359-1.353 0-0.744 0.609-1.356 1.359-1.356 0.753 0 1.359 0.613 1.359 1.356 0 0.75-0.609 1.353-1.359 1.353zM7.772 13c0-1.278-0.497-2.481-1.397-3.381-0.903-0.903-2.1-1.4-3.375-1.4v-1.956c3.713 0 6.738 3.022 6.738 6.737h-1.966zM11.244 13c0-4.547-3.697-8.25-8.241-8.25v-1.956c5.625 0 10.203 4.581 10.203 10.206h-1.963z"
                }
            }
        ]
    })(props);
}
function ImYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.841 4.8c0 0-0.156-1.103-0.637-1.587-0.609-0.637-1.291-0.641-1.603-0.678-2.237-0.163-5.597-0.163-5.597-0.163h-0.006c0 0-3.359 0-5.597 0.163-0.313 0.038-0.994 0.041-1.603 0.678-0.481 0.484-0.634 1.587-0.634 1.587s-0.159 1.294-0.159 2.591v1.213c0 1.294 0.159 2.591 0.159 2.591s0.156 1.103 0.634 1.588c0.609 0.637 1.409 0.616 1.766 0.684 1.281 0.122 5.441 0.159 5.441 0.159s3.363-0.006 5.6-0.166c0.313-0.037 0.994-0.041 1.603-0.678 0.481-0.484 0.637-1.588 0.637-1.588s0.159-1.294 0.159-2.591v-1.213c-0.003-1.294-0.162-2.591-0.162-2.591zM6.347 10.075v-4.497l4.322 2.256-4.322 2.241z"
                }
            }
        ]
    })(props);
}
function ImYoutube2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 40 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.375 2.647c0.003-0.014 0.005-0.023 0.006-0.028l0.016-0.118-0.74-0.004c-0.668-0.004-0.873 0-0.891 0.017-0.009 0.008-0.24 0.885-0.651 2.473-0.196 0.758-0.361 1.363-0.367 1.345s-0.24-0.883-0.522-1.922c-0.281-1.039-0.517-1.894-0.524-1.901-0.010-0.010-0.906-0.014-1.632-0.008-0.105 0.001-0.164-0.205 0.938 3.299 0.152 0.485 0.381 1.172 0.507 1.526 0.146 0.408 0.25 0.724 0.321 0.987 0.126 0.501 0.13 0.815 0.103 1.182-0.032 0.423-0.036 3.413-0.005 3.463 0.024 0.038 1.425 0.056 1.558 0.020 0.021-0.006 0.035-0.026 0.045-0.139 0.033-0.097 0.036-0.484 0.036-2.090v-2.051l0.090-0.283c0.059-0.185 0.206-0.672 0.328-1.082s0.269-0.9 0.327-1.090c0.529-1.724 1.033-3.419 1.047-3.516l0.011-0.079z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.221 5.135l-0 0.107-0.017 0-0.009 2.953-0.009 2.863-0.229 0.233c-0.257 0.261-0.462 0.361-0.648 0.314-0.203-0.051-0.197 0.028-0.214-3.356l-0.016-3.115h-1.474v0.107h-0.017v3.38c0 3.621-0 3.619 0.184 3.982 0.146 0.29 0.36 0.431 0.725 0.479h0c0.481 0.064 1-0.154 1.481-0.622l0.209-0.203v0.351c0 0.303 0.009 0.353 0.064 0.368 0.090 0.025 1.206 0.027 1.326 0.002l0.1-0.021v-0.104l0.017-0.003v-7.736l-1.472 0.020z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.483 6.661c-0.14-0.599-0.401-1.002-0.832-1.28-0.676-0.437-1.449-0.484-2.165-0.13-0.522 0.258-0.859 0.686-1.032 1.314-0.021 0.075-0.036 0.138-0.047 0.231-0.044 0.222-0.049 0.552-0.061 2.093-0.018 2.374 0.010 2.656 0.307 3.195 0.292 0.529 0.897 0.917 1.556 0.997 0.198 0.024 0.6-0.013 0.832-0.078 0.525-0.146 1.029-0.561 1.252-1.032 0.096-0.204 0.154-0.345 0.189-0.604 0.065-0.353 0.070-0.925 0.070-2.381-0-1.857-0.006-2.060-0.068-2.326zM7.802 11.5c-0.124 0.094-0.34 0.135-0.515 0.098-0.135-0.029-0.318-0.241-0.374-0.434-0.070-0.241-0.075-3.594-0.015-4.251 0.1-0.329 0.378-0.501 0.682-0.419 0.237 0.064 0.358 0.212 0.427 0.523 0.051 0.231 0.057 0.518 0.046 2.207-0.007 1.12-0.011 1.668-0.048 1.962-0.037 0.185-0.099 0.235-0.203 0.315z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M35.944 8.346h0.712l-0.011-0.645c-0.011-0.592-0.020-0.659-0.099-0.82-0.125-0.253-0.309-0.366-0.601-0.366-0.351 0-0.573 0.17-0.678 0.518-0.045 0.148-0.092 1.167-0.058 1.255 0.019 0.049 0.121 0.058 0.735 0.058z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M31.184 6.879c-0.095-0.191-0.272-0.286-0.477-0.278-0.16 0.006-0.337 0.073-0.508 0.203l-0.127 0.097v4.634l0.127 0.097c0.288 0.22 0.604 0.266 0.822 0.12 0.086-0.058 0.142-0.137 0.186-0.263 0.057-0.164 0.062-0.375 0.055-2.325-0.008-2.032-0.012-2.152-0.078-2.285z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M40.014 4.791c-0.142-1.701-0.255-2.253-0.605-2.962-0.465-0.939-1.136-1.434-2.092-1.543-0.739-0.084-3.521-0.203-6.094-0.26-4.456-0.099-11.782 0.092-12.718 0.331-0.432 0.111-0.757 0.299-1.094 0.634-0.591 0.588-0.944 1.432-1.085 2.6-0.323 2.666-0.33 5.886-0.019 8.649 0.134 1.188 0.41 1.96 0.928 2.596 0.323 0.397 0.881 0.734 1.379 0.835 0.35 0.071 2.1 0.169 4.65 0.26 0.38 0.014 1.385 0.037 2.235 0.052 1.77 0.031 5.025 0.013 6.886-0.039 1.252-0.035 3.534-0.128 3.961-0.161 0.12-0.009 0.398-0.027 0.618-0.039 0.739-0.042 1.209-0.196 1.65-0.543 0.571-0.449 1.013-1.278 1.2-2.251 0.177-0.92 0.295-2.559 0.319-4.42 0.020-1.555-0.007-2.393-0.119-3.741zM22.27 4.175l-0.828 0.010-0.036 8.83-0.718 0.009c-0.555 0.008-0.724-0.001-0.737-0.036-0.010-0.025-0.021-2.016-0.026-4.424l-0.009-4.379-1.617-0.020v-1.38l4.779 0.019 0.020 1.36-0.828 0.010zM27.347 9.236v3.797h-1.308v-0.4c0-0.301-0.011-0.4-0.047-0.4-0.026 0-0.144 0.099-0.263 0.22-0.259 0.263-0.565 0.474-0.827 0.572-0.542 0.203-1.056 0.084-1.275-0.293-0.201-0.345-0.204-0.423-0.204-4.005v-3.29h1.307l0.010 3.098c0.010 3.044 0.011 3.1 0.084 3.224 0.097 0.164 0.244 0.209 0.478 0.144 0.138-0.038 0.232-0.105 0.455-0.327l0.282-0.28v-5.859h1.308v3.797zM32.449 12.491c-0.115 0.257-0.372 0.508-0.583 0.57-0.549 0.162-0.99 0.030-1.499-0.449-0.158-0.149-0.305-0.269-0.327-0.269-0.027 0-0.041 0.116-0.041 0.345v0.345h-1.308v-10.248h1.308v1.672c0 0.919 0.012 1.672 0.027 1.672s0.153-0.122 0.307-0.27c0.354-0.341 0.649-0.491 1.024-0.519 0.669-0.051 1.068 0.294 1.25 1.080 0.057 0.245 0.062 0.525 0.062 2.798-0 2.768-0 2.78-0.221 3.273zM37.984 10.971c-0.012 0.285-0.046 0.612-0.077 0.727-0.182 0.674-0.666 1.152-1.366 1.348-0.942 0.264-1.98-0.168-2.394-0.997-0.232-0.465-0.241-0.558-0.241-2.831 0-1.853 0.007-2.081 0.066-2.334 0.168-0.715 0.584-1.178 1.289-1.435 0.204-0.074 0.417-0.113 0.63-0.117 0.761-0.016 1.515 0.393 1.832 1.059 0.213 0.449 0.24 0.642 0.261 1.908l0.019 1.136-2.789 0.019-0.010 0.763c-0.015 1.077 0.058 1.408 0.349 1.603 0.244 0.165 0.62 0.152 0.824-0.027 0.192-0.168 0.246-0.349 0.265-0.877l0.017-0.463h1.347l-0.022 0.518z"
                }
            }
        ]
    })(props);
}
function ImTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0l-1.5 2.5v11.5h4v2h2l2-2h2.5l4.5-4.5v-9.5h-13.5zM13 8.5l-2.5 2.5h-2.5l-2 2v-2h-3v-9h10v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 4h1.5v4h-1.5v-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 4h1.5v4h-1.5v-4z"
                }
            }
        ]
    })(props);
}
function ImVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.994 4.281c-0.072 1.556-1.159 3.691-3.263 6.397-2.175 2.825-4.016 4.241-5.522 4.241-0.931 0-1.722-0.859-2.366-2.581-0.431-1.578-0.859-3.156-1.291-4.734-0.478-1.722-0.991-2.581-1.541-2.581-0.119 0-0.538 0.253-1.256 0.753l-0.753-0.969c0.791-0.694 1.569-1.388 2.334-2.081 1.053-0.909 1.844-1.387 2.372-1.438 1.244-0.119 2.013 0.731 2.3 2.553 0.309 1.966 0.525 3.188 0.647 3.666 0.359 1.631 0.753 2.447 1.184 2.447 0.334 0 0.838-0.528 1.509-1.588 0.669-1.056 1.028-1.862 1.078-2.416 0.097-0.912-0.262-1.372-1.078-1.372-0.384 0-0.778 0.088-1.184 0.263 0.787-2.575 2.287-3.825 4.506-3.753 1.641 0.044 2.416 1.109 2.322 3.194z"
                }
            }
        ]
    })(props);
}
function ImVimeo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13.463 5.313c-0.050 1.125-0.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-0.675 0-1.244-0.622-1.709-1.866-0.313-1.141-0.622-2.281-0.934-3.422-0.344-1.244-0.716-1.866-1.112-1.866-0.087 0-0.391 0.181-0.906 0.544l-0.544-0.7c0.572-0.5 1.134-1.003 1.687-1.503 0.763-0.656 1.331-1.003 1.712-1.038 0.9-0.087 1.453 0.528 1.662 1.844 0.225 1.422 0.381 2.303 0.469 2.65 0.259 1.178 0.544 1.766 0.856 1.766 0.241 0 0.606-0.381 1.091-1.147s0.744-1.347 0.778-1.747c0.069-0.659-0.191-0.991-0.778-0.991-0.278 0-0.563 0.063-0.856 0.191 0.569-1.859 1.653-2.766 3.256-2.712 1.188 0.034 1.747 0.803 1.678 2.309z"
                }
            }
        ]
    })(props);
}
function ImLanyrd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.85 12.012l-5.444 1.781c-1.244 0.406-1.369 0.341-1.931-1.4l-1.375-4.259c-0.328-1.009-1.328-3.728-1.497-4.25-0.313-0.969-0.313-1.022 1.516-1.616 1.431-0.469 1.491-0.453 2.009 1.163 0.419 1.3 0.688 2.35 1.119 3.678l1.172 3.625 3.744-1.225c0.738-0.244 0.984-0.231 1.194 0.678l0.15 0.688c0.175 0.797-0.228 1-0.656 1.137z"
                }
            }
        ]
    })(props);
}
function ImFlickr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5zM9 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function ImFlickr2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.5c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12.5 5v0c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5c0-1.933 1.567-3.5 3.5-3.5zM0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function ImFlickr3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function ImFlickr4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.606-8 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055-3.582-8.055-8-8.055zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function ImDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8v0zM14.747 9.094c-0.234-0.075-2.116-0.634-4.256-0.291 0.894 2.456 1.256 4.456 1.328 4.872 1.531-1.037 2.625-2.678 2.928-4.581v0zM10.669 14.3c-0.103-0.6-0.497-2.688-1.456-5.181-0.016 0.006-0.031 0.009-0.044 0.016-3.856 1.344-5.241 4.016-5.362 4.266 1.159 0.903 2.616 1.444 4.194 1.444 0.947 0 1.85-0.194 2.669-0.544v0zM2.922 12.578c0.156-0.266 2.031-3.369 5.553-4.509 0.088-0.028 0.178-0.056 0.269-0.081-0.172-0.388-0.359-0.778-0.553-1.159-3.409 1.022-6.722 0.978-7.022 0.975-0.003 0.069-0.003 0.138-0.003 0.209 0 1.753 0.666 3.356 1.756 4.566v0zM1.313 6.609c0.306 0.003 3.122 0.016 6.319-0.831-1.131-2.013-2.353-3.706-2.534-3.953-1.913 0.903-3.344 2.666-3.784 4.784v0zM6.4 1.366c0.188 0.253 1.431 1.944 2.55 4 2.431-0.909 3.459-2.294 3.581-2.469-1.206-1.072-2.794-1.722-4.531-1.722-0.55 0.003-1.088 0.069-1.6 0.191v0zM13.291 3.691c-0.144 0.194-1.291 1.663-3.816 2.694 0.159 0.325 0.313 0.656 0.453 0.991 0.050 0.119 0.1 0.234 0.147 0.353 2.275-0.284 4.534 0.172 4.759 0.219-0.016-1.612-0.594-3.094-1.544-4.256v0z"
                }
            }
        ]
    })(props);
}
function ImBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.641 3.206c0.472 0 0.897 0.041 1.284 0.125 0.388 0.081 0.716 0.219 0.994 0.406 0.275 0.188 0.487 0.438 0.644 0.75 0.15 0.309 0.225 0.697 0.225 1.156 0 0.497-0.112 0.909-0.338 1.241-0.228 0.331-0.559 0.6-1.003 0.813 0.606 0.175 1.053 0.481 1.353 0.916 0.3 0.438 0.444 0.963 0.444 1.581 0 0.5-0.097 0.928-0.287 1.291-0.194 0.366-0.456 0.662-0.778 0.891-0.325 0.231-0.7 0.4-1.119 0.509-0.416 0.109-0.844 0.166-1.287 0.166h-4.772v-9.844h4.641zM4.359 7.181c0.384 0 0.703-0.091 0.953-0.275 0.25-0.181 0.369-0.481 0.369-0.894 0-0.228-0.041-0.419-0.122-0.566-0.084-0.147-0.194-0.263-0.334-0.344-0.138-0.084-0.294-0.141-0.478-0.172-0.178-0.034-0.366-0.050-0.556-0.050h-2.025v2.3h2.194zM4.478 11.372c0.213 0 0.416-0.019 0.606-0.063 0.194-0.044 0.366-0.109 0.509-0.209 0.144-0.097 0.266-0.225 0.353-0.394 0.088-0.166 0.128-0.378 0.128-0.637 0-0.506-0.144-0.869-0.428-1.088-0.284-0.216-0.662-0.322-1.131-0.322h-2.35v2.709h2.313z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.331 11.338c0.294 0.287 0.716 0.431 1.266 0.431 0.394 0 0.738-0.1 1.022-0.3s0.456-0.412 0.522-0.631h1.725c-0.278 0.859-0.697 1.469-1.272 1.838-0.566 0.369-1.259 0.556-2.063 0.556-0.563 0-1.066-0.091-1.519-0.269-0.453-0.181-0.831-0.434-1.15-0.766-0.309-0.331-0.553-0.725-0.725-1.188-0.169-0.459-0.256-0.969-0.256-1.519 0-0.534 0.088-1.031 0.262-1.491 0.178-0.463 0.422-0.859 0.747-1.194s0.706-0.6 1.156-0.794c0.447-0.194 0.941-0.291 1.488-0.291 0.603 0 1.131 0.116 1.584 0.353 0.45 0.234 0.822 0.55 1.113 0.944s0.497 0.847 0.625 1.353c0.128 0.506 0.172 1.034 0.137 1.588h-5.147c0 0.559 0.188 1.094 0.484 1.378zM13.578 7.594c-0.231-0.256-0.628-0.397-1.106-0.397-0.313 0-0.572 0.053-0.778 0.159-0.203 0.106-0.369 0.237-0.497 0.394-0.125 0.156-0.213 0.325-0.262 0.503-0.050 0.172-0.081 0.331-0.091 0.469h3.188c-0.047-0.5-0.219-0.869-0.453-1.128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.444 4h3.991v0.972h-3.991v-0.972z"
                }
            }
        ]
    })(props);
}
function ImBehance2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.316 7.009c0.203-0.147 0.3-0.391 0.3-0.728 0-0.188-0.031-0.341-0.097-0.459-0.069-0.119-0.156-0.213-0.272-0.278-0.112-0.069-0.241-0.116-0.388-0.141-0.144-0.028-0.297-0.041-0.453-0.041h-1.647v1.869h1.781c0.313 0.003 0.572-0.072 0.775-0.222z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.594 8.697c-0.231-0.175-0.537-0.262-0.919-0.262h-1.916v2.203h1.878c0.175 0 0.338-0.016 0.494-0.050s0.297-0.088 0.416-0.169c0.119-0.078 0.216-0.184 0.287-0.319s0.106-0.309 0.106-0.519c0-0.412-0.116-0.706-0.347-0.884z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM10.488 4.209h3.241v0.791h-3.241v-0.791zM8.463 10.725c-0.156 0.297-0.369 0.537-0.631 0.725-0.266 0.188-0.569 0.325-0.909 0.416-0.338 0.091-0.688 0.134-1.044 0.134h-3.878v-7.997h3.769c0.381 0 0.728 0.034 1.044 0.1 0.313 0.066 0.581 0.178 0.806 0.331 0.222 0.153 0.397 0.356 0.522 0.609 0.122 0.25 0.184 0.566 0.184 0.938 0 0.403-0.091 0.737-0.275 1.006s-0.453 0.487-0.816 0.659c0.494 0.141 0.856 0.391 1.097 0.744 0.244 0.356 0.363 0.784 0.363 1.284 0.003 0.409-0.075 0.759-0.231 1.050zM14.991 9.488h-4.178c0 0.456 0.156 0.891 0.394 1.125 0.238 0.231 0.581 0.35 1.028 0.35 0.322 0 0.597-0.081 0.831-0.244 0.231-0.162 0.372-0.334 0.425-0.512h1.4c-0.225 0.697-0.566 1.194-1.031 1.494-0.459 0.3-1.022 0.45-1.675 0.45-0.456 0-0.866-0.075-1.234-0.219-0.369-0.147-0.675-0.353-0.934-0.622-0.253-0.269-0.447-0.591-0.588-0.966-0.137-0.372-0.209-0.787-0.209-1.234 0-0.434 0.072-0.838 0.213-1.213 0.144-0.375 0.344-0.7 0.606-0.969 0.262-0.272 0.575-0.487 0.938-0.647 0.363-0.156 0.762-0.234 1.206-0.234 0.491 0 0.919 0.094 1.287 0.287 0.366 0.191 0.666 0.447 0.903 0.769s0.403 0.688 0.509 1.1c0.103 0.406 0.137 0.834 0.109 1.284z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.134 7.247c-0.253 0-0.466 0.044-0.631 0.131s-0.3 0.194-0.403 0.319c-0.103 0.128-0.172 0.263-0.213 0.409-0.041 0.141-0.066 0.269-0.072 0.381h2.588c-0.037-0.406-0.178-0.706-0.366-0.916-0.194-0.213-0.512-0.325-0.903-0.325z"
                }
            }
        ]
    })(props);
}
function ImDeviantart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.953 2.909v-2.909h-2.909l-0.291 0.294-1.375 2.616-0.431 0.291h-4.9v3.994h2.694l0.241 0.291-2.934 5.606v2.909h2.909l0.291-0.294 1.375-2.616 0.431-0.291h4.9v-3.994h-2.694l-0.241-0.294z"
                }
            }
        ]
    })(props);
}
function Im500Px(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.953 10.512c0.003 0.009 0.088 0.238 0.134 0.353 0.263 0.622 0.641 1.184 1.122 1.666s1.041 0.859 1.666 1.122c0.647 0.272 1.331 0.412 2.037 0.412s1.394-0.137 2.037-0.412c0.625-0.262 1.184-0.641 1.666-1.122s0.859-1.041 1.122-1.666c0.272-0.647 0.412-1.331 0.412-2.037s-0.137-1.394-0.412-2.037c-0.262-0.625-0.641-1.184-1.122-1.666s-1.041-0.859-1.666-1.122c-0.647-0.272-1.331-0.413-2.037-0.413-0.716 0-1.431 0.144-2.066 0.413-0.509 0.216-1.372 0.769-1.875 1.291l-0.003 0.003v-4.313h7.241c0.262-0.003 0.262-0.372 0.262-0.491 0-0.122 0-0.487-0.266-0.491h-7.828c-0.213 0-0.344 0.178-0.344 0.341v6.066c0 0.197 0.244 0.338 0.472 0.384 0.444 0.094 0.544-0.047 0.653-0.197l0.016-0.019c0.166-0.247 0.681-0.766 0.688-0.772 0.806-0.806 1.884-1.25 3.037-1.25 1.147 0 2.222 0.444 3.028 1.25 0.809 0.809 1.256 1.881 1.256 3.019 0 1.141-0.444 2.216-1.25 3.019-0.794 0.794-1.906 1.25-3.047 1.25-0.772 0-1.519-0.206-2.159-0.597l0.003-3.688c0-0.491 0.213-1.028 0.572-1.431 0.409-0.463 0.972-0.716 1.588-0.716 0.594 0 1.15 0.225 1.566 0.634 0.409 0.406 0.637 0.95 0.637 1.528 0 1.231-0.969 2.197-2.206 2.197-0.238 0-0.672-0.106-0.691-0.109-0.25-0.075-0.356 0.272-0.391 0.387-0.134 0.441 0.069 0.528 0.109 0.541 0.397 0.125 0.659 0.147 1.003 0.147 1.747 0 3.169-1.422 3.169-3.169 0-1.734-1.422-3.144-3.166-3.144-0.856 0-1.659 0.328-2.263 0.919-0.575 0.566-0.903 1.319-0.903 2.069v0.019c-0.003 0.094-0.003 2.306-0.006 3.031l-0.003-0.003c-0.328-0.363-0.653-0.919-0.869-1.488-0.084-0.222-0.275-0.184-0.534-0.103-0.125 0.034-0.469 0.141-0.391 0.394v0zM7.675 9.647c0 0.106 0.097 0.2 0.156 0.253l0.019 0.019c0.1 0.097 0.194 0.147 0.281 0.147 0.072 0 0.116-0.034 0.131-0.050 0.044-0.041 0.537-0.544 0.588-0.591l0.553 0.55c0.050 0.056 0.106 0.088 0.172 0.088 0.088 0 0.184-0.053 0.284-0.156 0.238-0.244 0.119-0.375 0.063-0.438l-0.559-0.559 0.584-0.588c0.128-0.137 0.016-0.284-0.097-0.397-0.162-0.162-0.322-0.206-0.422-0.112l-0.581 0.581-0.588-0.588c-0.031-0.031-0.072-0.047-0.113-0.047-0.078 0-0.172 0.053-0.275 0.156-0.181 0.181-0.219 0.306-0.125 0.406l0.588 0.584-0.584 0.584c-0.053 0.050-0.078 0.103-0.075 0.156zM8.953 1.716c-0.938 0-1.938 0.191-2.669 0.506-0.078 0.031-0.125 0.094-0.134 0.181-0.009 0.084 0.013 0.194 0.069 0.337 0.047 0.116 0.166 0.425 0.4 0.334 0.75-0.288 1.581-0.444 2.334-0.444 0.856 0 1.688 0.169 2.469 0.497 0.622 0.263 1.206 0.644 1.844 1.194 0.047 0.041 0.097 0.059 0.147 0.059 0.125 0 0.244-0.122 0.347-0.237 0.169-0.191 0.287-0.35 0.119-0.509-0.609-0.575-1.275-1.006-2.1-1.356-0.894-0.372-1.847-0.563-2.825-0.563zM14.006 13.3v0c-0.113-0.113-0.209-0.178-0.294-0.203s-0.162-0.006-0.222 0.053l-0.056 0.056c-0.581 0.581-1.259 1.037-2.012 1.356-0.781 0.331-1.609 0.497-2.463 0.497-0.856 0-1.684-0.169-2.463-0.497-0.753-0.319-1.431-0.775-2.013-1.356-0.606-0.606-1.063-1.284-1.356-2.012-0.288-0.713-0.381-1.247-0.413-1.422-0.003-0.016-0.006-0.028-0.006-0.037-0.041-0.206-0.231-0.222-0.503-0.178-0.112 0.019-0.459 0.072-0.428 0.319v0.006c0.091 0.578 0.253 1.144 0.481 1.681 0.366 0.866 0.891 1.644 1.559 2.313s1.447 1.191 2.313 1.559c0.897 0.378 1.85 0.572 2.831 0.572s1.934-0.194 2.831-0.572c0.866-0.366 1.644-0.891 2.313-1.559 0 0 0.037-0.037 0.059-0.059 0.069-0.084 0.134-0.225-0.159-0.516z"
                }
            }
        ]
    })(props);
}
function ImSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM14.975 2.025c-1.367-1.367-3.583-1.367-4.95 0-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.43 0.022-0.856 0.132-1.249 0.328l-2.467-1.928c-0.571-0.446-1.396-0.345-1.842 0.226s-0.345 1.396 0.226 1.842l2.436 1.905c-0.265 1.043 0.010 2.196 0.827 3.012 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.891-3.484c0.723-0.104 1.419-0.434 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95zM6 14.105c-1.162 0-2.105-0.942-2.105-2.105 0-0.011 0.001-0.022 0.001-0.033l1.046 0.817c0.24 0.188 0.525 0.278 0.807 0.278 0.39 0 0.776-0.173 1.035-0.504 0.446-0.571 0.345-1.396-0.226-1.842l-0.992-0.776c0.14-0.029 0.285-0.045 0.434-0.045 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105zM12.5 7c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function ImSteam2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.749 13.063c0.424 0 0.84-0.205 1.093-0.585 0.402-0.603 0.239-1.418-0.364-1.82l-1.032-0.688c0.177-0.048 0.362-0.074 0.554-0.074 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105c-1.131 0-2.054-0.893-2.102-2.012l1.124 0.749c0.224 0.149 0.477 0.221 0.727 0.221zM13.333 0c1.467 0 2.667 1.2 2.667 2.667v10.666c0 1.468-1.2 2.667-2.667 2.667h-10.666c-1.467 0-2.667-1.199-2.667-2.667v-3.172l1.896 1.264c-0.182 0.987 0.108 2.044 0.872 2.808 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.892-3.484c0.723-0.104 1.419-0.433 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95s-3.583-1.367-4.95 0c-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.498 0.025-0.99 0.168-1.433 0.428l-3.404-2.269v-4.339c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5 1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5zM10 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function ImDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 0.5l-3.5 3 4.5 3 3.5-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.5l-3.5-3-4.5 3 3.5 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.5l3.5 3-4.5 2.5-3.5-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9l-4.5-2.5-3.5 3 4.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.377 13.212l-3.377-2.895-3.377 2.895-2.123-1.179v1.467l5.5 2.5 5.5-2.5v-1.467z"
                }
            }
        ]
    })(props);
}
function ImOnedrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.482 12.944c-0.942-0.235-1.466-0.984-1.468-2.095-0-0.355 0.025-0.525 0.114-0.754 0.217-0.56 0.793-0.982 1.55-1.138 0.377-0.077 0.493-0.16 0.493-0.353 0-0.060 0.045-0.24 0.1-0.399 0.249-0.724 0.71-1.327 1.202-1.573 0.515-0.258 0.776-0.316 1.399-0.313 0.886 0.005 1.327 0.197 1.945 0.846l0.34 0.357 0.304-0.105c1.473-0.51 2.942 0.358 3.061 1.809l0.032 0.397 0.29 0.104c0.829 0.297 1.218 0.92 1.148 1.837-0.046 0.599-0.326 1.078-0.77 1.315l-0.209 0.112-4.638 0.009c-3.564 0.007-4.697-0.006-4.893-0.055v0zM1.613 12.281c-0.565-0.142-1.164-0.67-1.445-1.273-0.159-0.342-0.168-0.393-0.168-0.998 0-0.576 0.014-0.668 0.14-0.954 0.267-0.603 0.78-1.038 1.422-1.21 0.136-0.036 0.263-0.094 0.283-0.128s0.043-0.221 0.050-0.415c0.045-1.206 0.794-2.269 1.839-2.61 0.565-0.184 1.306-0.202 1.92 0.058 0.195 0.082 0.173 0.1 0.585-0.471 0.244-0.338 0.705-0.695 1.108-0.909 0.435-0.231 0.887-0.337 1.428-0.336 1.512 0.004 2.815 1.003 3.297 2.529 0.154 0.487 0.146 0.624-0.035 0.628-0.079 0.002-0.306 0.048-0.505 0.102l-0.361 0.099-0.329-0.348c-0.928-0.98-2.441-1.192-3.728-0.522-0.514 0.268-0.927 0.652-1.239 1.153-0.222 0.357-0.506 1.024-0.506 1.189 0 0.117-0.090 0.176-0.474 0.309-1.189 0.412-1.883 1.364-1.882 2.582 0 0.443 0.108 0.986 0.258 1.296 0.057 0.117 0.088 0.228 0.070 0.247-0.046 0.049-1.525 0.032-1.73-0.019v0z"
                }
            }
        ]
    })(props);
}
function ImGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0.198c-4.418 0-8 3.582-8 8 0 3.535 2.292 6.533 5.471 7.591 0.4 0.074 0.547-0.174 0.547-0.385 0-0.191-0.008-0.821-0.011-1.489-2.226 0.484-2.695-0.944-2.695-0.944-0.364-0.925-0.888-1.171-0.888-1.171-0.726-0.497 0.055-0.486 0.055-0.486 0.803 0.056 1.226 0.824 1.226 0.824 0.714 1.223 1.872 0.869 2.328 0.665 0.072-0.517 0.279-0.87 0.508-1.070-1.777-0.202-3.645-0.888-3.645-3.954 0-0.873 0.313-1.587 0.824-2.147-0.083-0.202-0.357-1.015 0.077-2.117 0 0 0.672-0.215 2.201 0.82 0.638-0.177 1.322-0.266 2.002-0.269 0.68 0.003 1.365 0.092 2.004 0.269 1.527-1.035 2.198-0.82 2.198-0.82 0.435 1.102 0.162 1.916 0.079 2.117 0.513 0.56 0.823 1.274 0.823 2.147 0 3.073-1.872 3.749-3.653 3.947 0.287 0.248 0.543 0.735 0.543 1.481 0 1.070-0.009 1.932-0.009 2.195 0 0.213 0.144 0.462 0.55 0.384 3.177-1.059 5.466-4.057 5.466-7.59 0-4.418-3.582-8-8-8z"
                }
            }
        ]
    })(props);
}
function ImNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM13 13h-2v-8h-3v8h-5v-10h10v10z"
                }
            }
        ]
    })(props);
}
function ImBasecamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.666c-2.919 0-5.169 2.444-6.444 4.838-0.719 1.347-1.222 2.822-1.453 4.331-0.025 0.172-0.050 0.344-0.069 0.519-0.009 0.094-0.019 0.188-0.025 0.281-0.009 0.119-0.003 0.156 0.059 0.256 0.187 0.303 0.409 0.584 0.659 0.838 0.512 0.525 1.134 0.928 1.794 1.241 1.503 0.709 3.2 0.966 4.85 1.022 1.703 0.056 3.453-0.084 5.081-0.616 1.391-0.453 2.731-1.244 3.503-2.522 0.084-0.137 0.025-0.341 0.009-0.5-0.019-0.191-0.044-0.378-0.075-0.566-0.056-0.369-0.131-0.731-0.222-1.094-0.181-0.738-0.428-1.463-0.728-2.159-1.088-2.525-3.1-5.219-5.963-5.775-0.322-0.063-0.65-0.094-0.978-0.094zM8.1 13.909c-1.784 0-3.728-0.159-5.334-1.019-0.625-0.334-1.262-0.819-1.563-1.484-0.087-0.194-0.056-0.269-0.016-0.497 0.028-0.147 0.041-0.291 0.106-0.428 0.091-0.191 0.184-0.378 0.281-0.566 0.328-0.634 0.681-1.262 1.091-1.853 0.203-0.291 0.419-0.578 0.669-0.828 0.175-0.175 0.388-0.362 0.634-0.422 0.756-0.181 1.334 0.694 1.794 1.134 0.222 0.213 0.519 0.453 0.85 0.412 0.228-0.028 0.431-0.206 0.594-0.353 0.553-0.497 0.997-1.112 1.456-1.691 0.228-0.284 0.453-0.572 0.7-0.844 0.166-0.184 0.347-0.394 0.569-0.513 0.397-0.216 0.903 0.228 1.178 0.456 0.469 0.391 0.884 0.847 1.281 1.309 0.378 0.441 0.744 0.888 1.066 1.372 0.497 0.75 0.928 1.55 1.322 2.359 0.084 0.175 0.113 0.294 0.144 0.488 0.019 0.106 0.059 0.228 0.044 0.338-0.022 0.153-0.128 0.319-0.206 0.444-0.188 0.297-0.441 0.553-0.719 0.769-1.166 0.903-2.744 1.203-4.178 1.338-0.588 0.056-1.175 0.078-1.762 0.078z"
                }
            }
        ]
    })(props);
}
function ImTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7 12c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-8c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v8zM13 9c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-5c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v5z"
                }
            }
        ]
    })(props);
}
function ImWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8c0 2.313 1.38 4.312 3.382 5.259l-2.862-7.637c-0.333 0.727-0.52 1.531-0.52 2.378zM12.050 7.705c0-0.722-0.266-1.222-0.495-1.612-0.304-0.482-0.589-0.889-0.589-1.371 0-0.537 0.418-1.037 1.008-1.037 0.027 0 0.052 0.003 0.078 0.005-1.067-0.953-2.49-1.534-4.052-1.534-2.096 0-3.94 1.048-5.013 2.634 0.141 0.004 0.274 0.007 0.386 0.007 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.361 0.444 0.038 0.482 0 0-0.325 0.037-0.687 0.055l2.185 6.33 1.313-3.835-0.935-2.495c-0.323-0.019-0.629-0.055-0.629-0.055-0.323-0.019-0.285-0.5 0.038-0.482 0 0 0.991 0.074 1.58 0.074 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.362 0.444 0.038 0.482 0 0-0.326 0.037-0.687 0.055l2.168 6.282 0.599-1.947c0.259-0.809 0.457-1.389 0.457-1.889zM8.105 8.511l-1.8 5.095c0.538 0.154 1.106 0.238 1.695 0.238 0.699 0 1.369-0.117 1.992-0.331-0.016-0.025-0.031-0.052-0.043-0.081l-1.844-4.921zM13.265 5.196c0.026 0.186 0.040 0.386 0.040 0.601 0 0.593-0.114 1.259-0.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051 0-1.016-0.267-1.971-0.735-2.803zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z"
                }
            }
        ]
    })(props);
}
function ImJoomla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.156 4.323c0.513-0.513 1.344-0.513 1.856-0l0.122 0.123 1.58-1.581-0.123-0.123c-0.9-0.902-2.164-1.217-3.319-0.946-0.166-1.018-1.048-1.796-2.112-1.796-1.182 0-2.14 0.96-2.14 2.143 0 1.021 0.712 1.875 1.667 2.091-0.362 1.21-0.066 2.576 0.888 3.531l3.56 3.561 1.578-1.581-3.56-3.561c-0.511-0.511-0.512-1.346 0.003-1.861zM15.98 2.143c0-1.184-0.958-2.143-2.14-2.143-1.082 0-1.976 0.804-2.12 1.847-1.204-0.354-2.559-0.055-3.51 0.897l-3.56 3.561 1.58 1.581 3.559-3.56c0.515-0.515 1.344-0.514 1.854-0.003 0.512 0.513 0.512 1.346-0.001 1.859l-0.122 0.122 1.578 1.582 0.123-0.124c0.945-0.946 1.245-2.293 0.9-3.494 1.049-0.138 1.858-1.037 1.858-2.125zM14.16 11.735c0.283-1.163-0.031-2.443-0.939-3.352l-3.555-3.562-1.58 1.58 3.555 3.563c0.515 0.516 0.514 1.345 0.003 1.857-0.513 0.513-1.344 0.513-1.857-0l-0.121-0.122-1.578 1.582 0.121 0.121c0.961 0.962 2.338 1.257 3.553 0.883 0.197 0.979 1.061 1.716 2.098 1.716 1.181 0 2.14-0.959 2.14-2.143 0-1.081-0.8-1.976-1.84-2.122zM9.568 8.261l-3.555 3.562c-0.511 0.512-1.344 0.513-1.859-0.002-0.513-0.514-0.513-1.345-0.001-1.859l0.122-0.121-1.579-1.58-0.121 0.12c-0.918 0.919-1.228 2.216-0.929 3.39-0.944 0.223-1.646 1.072-1.646 2.086-0 1.184 0.958 2.143 2.14 2.143 1.017-0.001 1.869-0.71 2.087-1.662 1.167 0.29 2.453-0.020 3.365-0.934l3.555-3.562-1.578-1.582z"
                }
            }
        ]
    })(props);
}
function ImEllo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12.885 9.212c-0.575 2.23-2.584 3.788-4.885 3.788s-4.31-1.558-4.885-3.788c-0.097-0.377 0.131-0.764 0.508-0.861 0.058-0.015 0.118-0.023 0.177-0.023 0.322 0 0.604 0.218 0.684 0.531 0.414 1.605 1.86 2.727 3.516 2.727s3.102-1.121 3.516-2.727c0.081-0.313 0.362-0.531 0.684-0.531 0.060 0 0.12 0.008 0.178 0.023 0.183 0.047 0.336 0.163 0.432 0.326s0.123 0.353 0.075 0.536z"
                }
            }
        ]
    })(props);
}
function ImBlogger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.966 6h-0.897c-0.549 0-1.031-0.465-1.069-1v0c0-2.854-2.301-5-5.175-5h-2.622c-2.872 0-5.201 2.313-5.203 5.167v5.669c0 2.854 2.331 5.165 5.203 5.165h5.6c2.874 0 5.197-2.311 5.197-5.165v-3.662c0-0.57-0.46-1.173-1.034-1.173zM5 4h3c0.55 0 1 0.45 1 1s-0.45 1-1 1h-3c-0.55 0-1-0.45-1-1s0.45-1 1-1zM11 12h-6c-0.55 0-1-0.45-1-1s0.45-1 1-1h6c0.55 0 1 0.45 1 1s-0.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function ImBlogger2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14 10.125c0 2.141-1.741 3.875-3.897 3.875h-4.2c-2.156 0-3.903-1.734-3.903-3.875v-4.25c0-2.141 1.747-3.875 3.903-3.875h1.966c2.156 0 3.881 1.609 3.881 3.75 0.028 0.4 0.391 0.75 0.8 0.75h0.672c0.431 0 0.775 0.453 0.775 0.881v2.744z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10c0 0.55-0.45 1-1 1h-4c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h4c0.55 0 1 0.45 1 1v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v0z"
                }
            }
        ]
    })(props);
}
function ImTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.001 7l-0 3.659c0 0.928-0.012 1.463 0.086 1.727 0.098 0.262 0.342 0.534 0.609 0.691 0.354 0.212 0.758 0.318 1.214 0.318 0.81 0 1.289-0.107 2.090-0.633v2.405c-0.683 0.321-1.279 0.509-1.833 0.639-0.555 0.129-1.154 0.194-1.798 0.194-0.732 0-1.163-0.092-1.725-0.276-0.562-0.185-1.042-0.45-1.438-0.79-0.398-0.343-0.672-0.706-0.826-1.091s-0.23-0.944-0.23-1.676v-5.611h-2.147v-2.266c0.628-0.204 1.331-0.497 1.778-0.877 0.449-0.382 0.809-0.839 1.080-1.374 0.272-0.534 0.459-1.214 0.561-2.039h2.579l-0 4h3.999v3h-3.999z"
                }
            }
        ]
    })(props);
}
function ImTumblr2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.434 12.884c-0.472 0.222-0.9 0.378-1.281 0.469-0.381 0.088-0.797 0.134-1.241 0.134-0.506 0-0.803-0.063-1.191-0.191s-0.719-0.309-0.994-0.544c-0.275-0.238-0.463-0.488-0.569-0.753s-0.159-0.65-0.159-1.156v-3.872h-1.5v-1.563c0.434-0.141 0.938-0.344 1.244-0.606 0.309-0.263 0.559-0.578 0.744-0.947 0.188-0.369 0.316-0.837 0.388-1.406h1.569v2.55h2.556v1.972h-2.553v2.831c0 0.641-0.009 1.009 0.059 1.191s0.238 0.369 0.422 0.475c0.244 0.147 0.525 0.219 0.838 0.219 0.559 0 1.116-0.181 1.669-0.544v1.741z"
                }
            }
        ]
    })(props);
}
function ImYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.878 9.203v0c1.759-3.088 4.666-8.125 5.463-9.203-0.35 0.234-0.887 0.353-1.381 0.466l-0.747-0.466c-0.6 1.119-2.813 4.734-4.222 7.050-1.428-2.366-3.119-5.097-4.222-7.050-0.875 0.188-1.237 0.197-2.109 0v0 0c0 0 0 0 0 0v0c1.731 2.606 4.503 7.572 5.447 9.203v0l-0.128 6.797 1.013-0.466v-0.012l1.012 0.478-0.125-6.797z"
                }
            }
        ]
    })(props);
}
function ImYahoo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.019 1.087c-2.828 0-5.5-0.372-8.019-1.087 0 5.653 0 14.581 0 16 2.522-0.716 5.194-1.088 8.019-1.088 2.794 0 5.459 0.363 7.981 1.088 0-5.444 0-10.153 0-16-2.522 0.725-5.184 1.087-7.981 1.087zM12.45 2.453l-0.097 0.153c-0.091 0.144-0.172 0.266-0.284 0.438-0.15 0.225-0.431 0.672-0.769 1.247-0.094 0.159-0.209 0.35-0.328 0.556-0.228 0.384-0.484 0.819-0.688 1.162-0.084 0.147-0.169 0.297-0.256 0.447-0.225 0.391-0.456 0.794-0.678 1.181-0.228 0.403-0.453 0.8-0.678 1.194v0.397c0 0.55 0.012 1.15 0.031 1.684 0.009 0.244 0.019 0.678 0.031 1.137 0.012 0.547 0.025 1.113 0.041 1.4l0.003 0.088v0.009l-0.094-0.025c-0.037-0.009-0.072-0.019-0.109-0.028-0.113-0.025-0.234-0.044-0.353-0.056-0.072-0.006-0.147-0.009-0.222-0.009 0 0 0 0 0 0s0 0 0 0c-0.075 0-0.15 0.003-0.222 0.009-0.119 0.012-0.241 0.031-0.353 0.056-0.037 0.009-0.075 0.019-0.109 0.028l-0.094 0.025v-0.009l0.003-0.088c0.013-0.284 0.028-0.853 0.041-1.4 0.009-0.459 0.022-0.894 0.031-1.137 0.022-0.537 0.031-1.134 0.031-1.684v-0.397c-0.225-0.397-0.45-0.791-0.678-1.194-0.222-0.391-0.453-0.791-0.675-1.181-0.088-0.15-0.172-0.3-0.256-0.447-0.2-0.347-0.459-0.781-0.688-1.162-0.122-0.203-0.237-0.397-0.328-0.556-0.338-0.575-0.619-1.019-0.769-1.247-0.112-0.172-0.194-0.294-0.284-0.438l-0.097-0.153 0.175 0.050c0.222 0.063 0.45 0.094 0.694 0.094s0.478-0.031 0.697-0.094l0.053-0.016 0.028 0.047c0.431 0.778 1.591 2.684 2.284 3.825 0.237 0.394 0.428 0.703 0.522 0.862 0 0 0 0 0-0.003 0 0 0 0 0 0.003 0.094-0.156 0.284-0.469 0.522-0.862 0.694-1.138 1.853-3.044 2.284-3.825l0.028-0.047 0.053 0.016c0.219 0.063 0.453 0.094 0.697 0.094s0.472-0.031 0.694-0.094l0.166-0.050z"
                }
            }
        ]
    })(props);
}
function ImTux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.87 11.514c-1.28 0.596-2.471 0.589-3.271 0.532-0.954-0.069-1.721-0.33-2.058-0.558-0.208-0.141-0.49-0.086-0.631 0.122s-0.086 0.49 0.122 0.631c0.542 0.367 1.501 0.64 2.503 0.712 0.17 0.012 0.356 0.020 0.557 0.020 0.872 0 1.979-0.083 3.163-0.634 0.228-0.106 0.326-0.376 0.22-0.604s-0.376-0.326-0.604-0.22zM13.921 10.841c0.044-3.948 0.449-11.409-7.109-10.806-7.463 0.601-5.484 8.484-5.595 11.124-0.099 1.397-0.562 3.104-1.217 4.841h2.017c0.207-0.736 0.36-1.464 0.425-2.159 0.122 0.085 0.252 0.167 0.391 0.245 0.226 0.133 0.42 0.31 0.626 0.497 0.48 0.438 1.025 0.934 2.089 0.996 0.071 0.004 0.143 0.006 0.214 0.006 1.077 0 1.813-0.471 2.404-0.85 0.283-0.181 0.528-0.338 0.759-0.413 0.655-0.205 1.227-0.536 1.655-0.957 0.067-0.066 0.129-0.133 0.187-0.202 0.238 0.873 0.564 1.856 0.926 2.836h4.307c-1.034-1.597-2.101-3.162-2.079-5.159zM1.939 8.693c0-0 0-0-0-0.001-0.074-1.288 0.542-2.372 1.377-2.421s1.571 0.957 1.645 2.245c0 0 0 0 0 0.001 0.004 0.069 0.006 0.138 0.006 0.206-0.264 0.066-0.503 0.163-0.717 0.275-0.001-0.010-0.001-0.019-0.002-0.029 0-0 0-0 0-0-0.071-0.731-0.462-1.284-0.873-1.234s-0.686 0.684-0.614 1.415c0 0 0 0 0 0 0.031 0.319 0.123 0.604 0.251 0.819-0.032 0.025-0.122 0.091-0.225 0.166-0.078 0.057-0.172 0.126-0.286 0.21-0.311-0.408-0.524-0.993-0.562-1.655zM10.395 11.878c-0.030 0.681-0.92 1.322-1.743 1.579l-0.005 0.002c-0.342 0.111-0.647 0.306-0.97 0.513-0.543 0.347-1.104 0.706-1.914 0.706-0.053 0-0.108-0.002-0.161-0.005-0.742-0.043-1.090-0.36-1.529-0.761-0.232-0.211-0.472-0.43-0.781-0.611l-0.007-0.004c-0.667-0.377-1.081-0.845-1.108-1.253-0.013-0.203 0.077-0.378 0.268-0.522 0.416-0.312 0.695-0.516 0.879-0.651 0.205-0.15 0.267-0.195 0.313-0.239 0.033-0.031 0.068-0.065 0.106-0.103 0.382-0.371 1.021-0.993 2.002-0.993 0.6 0 1.264 0.231 1.971 0.686 0.333 0.217 0.623 0.317 0.99 0.444 0.252 0.087 0.539 0.186 0.922 0.35l0.006 0.003c0.357 0.147 0.78 0.415 0.76 0.858zM10.198 10.278c-0.069-0.035-0.14-0.068-0.215-0.098-0.345-0.148-0.622-0.248-0.852-0.328 0.127-0.248 0.206-0.558 0.213-0.894 0-0 0-0 0-0 0.018-0.818-0.395-1.483-0.922-1.484s-0.968 0.661-0.986 1.479c0 0 0 0 0 0-0.001 0.027-0.001 0.053-0 0.080-0.324-0.149-0.643-0.258-0.956-0.324-0.001-0.031-0.003-0.061-0.004-0.092 0-0 0-0.001 0-0.001-0.030-1.491 0.884-2.725 2.043-2.756s2.122 1.152 2.153 2.642c0 0 0 0.001 0 0.001 0.014 0.674-0.167 1.295-0.475 1.776z"
                }
            }
        ]
    })(props);
}
function ImAppleinc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.367 8.501c-0.020-2.026 1.652-2.998 1.727-3.046-0.94-1.375-2.404-1.564-2.926-1.585-1.246-0.126-2.431 0.734-3.064 0.734-0.631 0-1.607-0.715-2.64-0.696-1.358 0.020-2.61 0.79-3.31 2.006-1.411 2.448-0.361 6.076 1.014 8.061 0.672 0.972 1.473 2.064 2.525 2.025 1.013-0.040 1.396-0.656 2.621-0.656s1.569 0.656 2.641 0.635c1.090-0.020 1.781-0.991 2.448-1.966 0.772-1.128 1.089-2.219 1.108-2.275-0.024-0.011-2.126-0.816-2.147-3.236zM10.353 2.555c0.558-0.677 0.935-1.617 0.832-2.555-0.804 0.033-1.779 0.536-2.356 1.212-0.518 0.6-0.971 1.557-0.85 2.476 0.898 0.070 1.815-0.456 2.373-1.132z"
                }
            }
        ]
    })(props);
}
function ImFinder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.894 12.16c-0-0.001-0-0.001-0-0.002 0 0.001 0 0.001 0 0.002z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.916 12.727c-0-0.004-0-0.007-0.001-0.011 0 0.004 0 0.007 0.001 0.011z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.903 12.442c-0-0.003-0-0.006-0-0.008 0 0.003 0 0.006 0 0.008z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h7.716c0.001 0 0.001 0 0.002 0s0.001-0 0.002-0h6.28c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM3 3.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1zM15 15h-5.86c-0.105-0.658-0.17-1.336-0.209-1.994 0 0.002 0 0.004 0 0.005-0.308 0.034-0.618 0.051-0.931 0.051-2.088 0-4.1-0.76-5.664-2.141-0.233-0.206-0.255-0.561-0.050-0.794s0.561-0.255 0.794-0.050c1.358 1.199 3.105 1.859 4.919 1.859 0.298 0 0.595-0.018 0.888-0.053-0.034-1.847 0.107-3.311 0.11-3.334 0.014-0.141-0.032-0.28-0.127-0.385s-0.229-0.164-0.371-0.164h-1.487c0.022-0.541 0.079-1.466 0.234-2.503 0.295-1.981 0.812-3.528 1.502-4.497h6.251v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.445 13.050c-0.057 0.003-0.114 0.005-0.171 0.007 0.057-0.002 0.114-0.004 0.171-0.007z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.063c0.073 0 0.146-0.001 0.22-0.003-0.073 0.002-0.146 0.003-0.22 0.003z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.423 11.925c0.012-0.001 0.024-0.001 0.037-0.002-0.012 0.001-0.024 0.001-0.037 0.002z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.204 11.934c0.017-0 0.034-0.001 0.050-0.002-0.017 0.001-0.034 0.001-0.050 0.002z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.713 10.128c-0.206-0.233-0.561-0.255-0.794-0.050-1.135 1.002-2.542 1.627-4.032 1.806 0.007 0.364 0.020 0.742 0.043 1.127 1.749-0.191 3.403-0.916 4.733-2.090 0.233-0.206 0.255-0.561 0.050-0.794z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.93 13.012c-0.072 0.008-0.144 0.015-0.216 0.021 0.072-0.006 0.144-0.013 0.216-0.021z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.68 13.035c-0.061 0.005-0.122 0.009-0.183 0.013 0.061-0.004 0.122-0.008 0.183-0.013z"
                }
            }
        ]
    })(props);
}
function ImAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM2 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM3.5 11.5c0 0.828 0.672 1.5 1.5 1.5v0 2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2c0.828 0 1.5-0.672 1.5-1.5v-5.5h-9v5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.472 5c-0.152-1.373-0.922-2.559-2.025-3.276l0.5-1.001c0.123-0.247 0.023-0.547-0.224-0.671s-0.547-0.023-0.671 0.224l-0.502 1.004-0.13-0.052c-0.446-0.148-0.924-0.229-1.42-0.229s-0.974 0.081-1.42 0.229l-0.13 0.052-0.502-1.004c-0.123-0.247-0.424-0.347-0.671-0.224s-0.347 0.424-0.224 0.671l0.5 1.001c-1.103 0.716-1.873 1.903-2.025 3.276v0.5h8.972v-0.5h-0.028zM6.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.001-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5zM9.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.002-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5z"
                }
            }
        ]
    })(props);
}
function ImWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.441 7.999c-0.745-0.383-1.47-0.577-2.154-0.577-0.093 0-0.187 0.003-0.28 0.011-0.873 0.072-1.671 0.303-2.184 0.482-0.136 0.050-0.276 0.103-0.419 0.161l-1.403 4.866c0.964-0.357 1.817-0.53 2.598-0.53 1.263 0 2.18 0.472 2.937 0.958 0.359-1.217 1.219-4.158 1.476-5.036-0.187-0.114-0.376-0.228-0.571-0.333zM8.255 9.235l-1.413 4.909c0.419 0.24 1.83 1.001 2.91 1.001 0.872 0 1.848-0.223 2.982-0.684l1.349-4.718c-0.916 0.296-1.795 0.446-2.617 0.446-1.499 0-2.549-0.486-3.211-0.952zM4.575 5.762c1.205 0.012 2.096 0.472 2.835 0.945l1.449-4.958c-0.305-0.175-1.106-0.611-1.685-0.759-0.381-0.089-0.782-0.135-1.206-0.135-0.809 0.015-1.694 0.218-2.701 0.622l-1.382 4.853c1.013-0.382 1.885-0.568 2.689-0.568 0.001 0 0.002 0 0.002 0zM16 3.096c-0.919 0.357-1.816 0.539-2.672 0.539-1.433 0-2.489-0.497-3.173-0.974l-1.437 4.972c0.965 0.62 2.005 0.936 3.096 0.936 0.89 0 1.812-0.214 2.742-0.636l-0.003-0.035 0.058-0.014 1.39-4.788z"
                }
            }
        ]
    })(props);
}
function ImWindows8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.005 8l-0.005-4.876 6-0.815v5.691zM7 2.164l7.998-1.164v7h-7.998zM15 9l-0.002 7-7.998-1.125v-5.875zM6 14.747l-5.995-0.822-0-4.926h5.995z"
                }
            }
        ]
    })(props);
}
function ImSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.937 8.034c-0.283 0-0.552 0.055-0.798 0.154-0.164-1.787-1.723-3.188-3.625-3.188-0.465 0-0.917 0.088-1.317 0.237-0.156 0.058-0.197 0.117-0.197 0.233v6.292c0 0.121 0.098 0.222 0.221 0.234 0.005 0.001 5.68 0.003 5.717 0.003 1.139 0 2.062-0.888 2.062-1.983s-0.924-1.983-2.063-1.983zM6.25 12h0.5l0.25-3.503-0.25-3.497h-0.5l-0.25 3.497zM4.75 12h-0.5l-0.25-2.543 0.25-2.457h0.5l0.25 2.5zM2.25 12h0.5l0.25-2-0.25-2h-0.5l-0.25 2zM0.25 11h0.5l0.25-1-0.25-1h-0.5l-0.25 1z"
                }
            }
        ]
    })(props);
}
function ImSoundcloud2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM2.75 11h-0.5l-0.25-1.5 0.25-1.5h0.5l0.25 1.5-0.25 1.5zM4.75 11h-0.5l-0.25-2 0.25-2h0.5l0.25 2-0.25 2zM6.75 11h-0.5l-0.25-3 0.25-3h0.5l0.25 3-0.25 3zM12.894 11c-0.031 0-4.706-0.003-4.709-0.003-0.1-0.009-0.181-0.097-0.184-0.2v-5.394c0-0.1 0.034-0.15 0.162-0.2 0.331-0.128 0.703-0.203 1.088-0.203 1.566 0 2.85 1.2 2.987 2.734 0.203-0.084 0.425-0.131 0.656-0.131 0.938 0 1.7 0.762 1.7 1.7s-0.762 1.697-1.7 1.697z"
                }
            }
        ]
    })(props);
}
function ImSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.65 0.584c-0.025-0.016-0.053-0.028-0.078-0.041-0.028 0.006-0.053 0.009-0.081 0.016l0.159 0.025z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0.575 6.578c-0.006 0.028-0.009 0.056-0.012 0.081 0.016 0.025 0.025 0.050 0.041 0.075l-0.028-0.156z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.419 9.416c0.006-0.028 0.009-0.056 0.016-0.084-0.016-0.025-0.025-0.050-0.041-0.075l0.025 0.159z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.25 15.359c0.025 0.016 0.053 0.028 0.078 0.041 0.028-0.006 0.056-0.009 0.084-0.012l-0.162-0.028z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.434 9.331c-0.006 0.028-0.009 0.056-0.016 0.084l-0.028-0.162c0.016 0.028 0.028 0.053 0.044 0.078 0.081-0.45 0.125-0.909 0.125-1.369 0-1.019-0.2-2.009-0.594-2.941-0.381-0.9-0.925-1.709-1.619-2.403s-1.503-1.238-2.4-1.619c-0.931-0.394-1.922-0.594-2.941-0.594-0.481 0-0.963 0.044-1.431 0.134 0 0-0.003 0-0.003 0 0.025 0.012 0.053 0.025 0.078 0.041l-0.159-0.025c0.028-0.006 0.053-0.009 0.081-0.016-0.644-0.341-1.366-0.525-2.097-0.525-1.194 0-2.319 0.466-3.163 1.309s-1.309 1.969-1.309 3.163c0 0.759 0.197 1.509 0.563 2.169 0.006-0.028 0.009-0.056 0.012-0.081l0.028 0.159c-0.016-0.025-0.028-0.050-0.041-0.075-0.075 0.428-0.112 0.866-0.112 1.303 0 1.019 0.2 2.009 0.594 2.941 0.381 0.9 0.925 1.706 1.619 2.4s1.503 1.238 2.403 1.619c0.931 0.394 1.922 0.594 2.941 0.594 0.444 0 0.887-0.041 1.322-0.119-0.025-0.016-0.050-0.028-0.078-0.041l0.162 0.028c-0.028 0.006-0.056 0.009-0.084 0.012 0.669 0.378 1.428 0.581 2.2 0.581 1.194 0 2.319-0.466 3.162-1.309s1.309-1.969 1.309-3.162c-0.003-0.759-0.2-1.509-0.569-2.175zM8.034 12.591c-2.684 0-3.884-1.319-3.884-2.309 0-0.506 0.375-0.863 0.891-0.863 1.15 0 0.85 1.65 2.994 1.65 1.097 0 1.703-0.597 1.703-1.206 0-0.366-0.181-0.772-0.903-0.95l-2.388-0.597c-1.922-0.481-2.272-1.522-2.272-2.5 0-2.028 1.909-2.791 3.703-2.791 1.653 0 3.6 0.913 3.6 2.131 0 0.522-0.453 0.825-0.969 0.825-0.981 0-0.8-1.356-2.775-1.356-0.981 0-1.522 0.444-1.522 1.078s0.775 0.838 1.447 0.991l1.769 0.394c1.934 0.431 2.425 1.563 2.425 2.625 0 1.647-1.266 2.878-3.819 2.878z"
                }
            }
        ]
    })(props);
}
function ImReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10.049 12.137c0.258-0.203 0.631-0.159 0.834 0.099s0.159 0.631-0.099 0.834c-0.717 0.565-1.81 0.93-2.783 0.93s-2.066-0.365-2.784-0.93c-0.258-0.203-0.302-0.576-0.099-0.834s0.576-0.302 0.834-0.099c0.413 0.325 1.23 0.675 2.049 0.675s1.636-0.35 2.049-0.675zM16 8c0-1.105-0.895-2-2-2-0.752 0-1.406 0.415-1.748 1.028-1.028-0.562-2.28-0.926-3.645-1.010l1.193-2.68 2.284 0.659c0.206 0.583 0.761 1.002 1.415 1.002 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.571 0-1.068 0.319-1.321 0.789l-2.545-0.735c-0.285-0.082-0.587 0.058-0.707 0.329l-1.621 3.641c-1.33 0.094-2.551 0.453-3.557 1.004-0.342-0.613-0.996-1.028-1.748-1.028-1.105 0-2 0.895-2 2 0 0.817 0.491 1.52 1.193 1.83-0.126 0.375-0.193 0.767-0.193 1.17 0 2.761 3.134 5 7 5s7-2.239 7-5c0-0.403-0.067-0.795-0.193-1.17 0.703-0.31 1.193-1.013 1.193-1.83zM13.5 2.938c0.311 0 0.563 0.252 0.563 0.563s-0.252 0.563-0.563 0.563-0.563-0.252-0.563-0.563 0.252-0.563 0.563-0.563zM1 8c0-0.551 0.449-1 1-1 0.399 0 0.743 0.234 0.904 0.573-0.523 0.396-0.956 0.854-1.276 1.355-0.368-0.148-0.628-0.508-0.628-0.928zM8 14.813c-3.21 0-5.813-1.707-5.813-3.813s2.602-3.813 5.813-3.813c3.21 0 5.813 1.707 5.813 3.813s-2.602 3.813-5.813 3.813zM14.372 8.928c-0.32-0.502-0.753-0.959-1.276-1.355 0.161-0.338 0.505-0.573 0.904-0.573 0.551 0 1 0.449 1 1 0 0.42-0.26 0.78-0.628 0.928z"
                }
            }
        ]
    })(props);
}
function ImHackernews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM8.5 9.125v3.375h-1v-3.375l-2.734-5.125h1.134l2.1 3.938 2.1-3.938h1.134l-2.734 5.125z"
                }
            }
        ]
    })(props);
}
function ImWikipedia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.106 3.65c0 0.050-0.016 0.097-0.047 0.141-0.031 0.041-0.066 0.063-0.106 0.063-0.313 0.031-0.569 0.131-0.766 0.3-0.2 0.169-0.403 0.497-0.613 0.975l-3.225 7.272c-0.022 0.069-0.081 0.1-0.178 0.1-0.075 0-0.134-0.034-0.178-0.1l-1.809-3.781-2.081 3.781c-0.044 0.069-0.1 0.1-0.178 0.1-0.094 0-0.153-0.034-0.184-0.1l-3.166-7.269c-0.197-0.45-0.406-0.766-0.625-0.944s-0.525-0.291-0.916-0.331c-0.034 0-0.066-0.019-0.094-0.053-0.031-0.034-0.044-0.075-0.044-0.122 0-0.119 0.034-0.178 0.1-0.178 0.281 0 0.578 0.013 0.888 0.038 0.288 0.025 0.556 0.038 0.809 0.038 0.256 0 0.563-0.013 0.913-0.038 0.366-0.025 0.691-0.038 0.975-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.022 0.175-0.063 0.175c-0.281 0.022-0.506 0.094-0.669 0.216s-0.244 0.281-0.244 0.481c0 0.1 0.034 0.228 0.1 0.378l2.616 5.912 1.487-2.806-1.384-2.903c-0.25-0.519-0.453-0.853-0.612-1.003s-0.403-0.241-0.728-0.275c-0.031 0-0.056-0.019-0.084-0.053s-0.041-0.075-0.041-0.122c0-0.119 0.028-0.178 0.088-0.178 0.281 0 0.541 0.013 0.778 0.038 0.228 0.025 0.469 0.038 0.728 0.038 0.253 0 0.519-0.013 0.803-0.038 0.291-0.025 0.578-0.038 0.859-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.019 0.175-0.063 0.175c-0.566 0.038-0.847 0.2-0.847 0.481 0 0.125 0.066 0.322 0.197 0.588l0.916 1.859 0.912-1.7c0.125-0.241 0.191-0.444 0.191-0.606 0-0.388-0.281-0.594-0.847-0.619-0.050 0-0.075-0.059-0.075-0.175 0-0.044 0.012-0.081 0.037-0.119s0.050-0.056 0.075-0.056c0.203 0 0.45 0.013 0.747 0.038 0.281 0.025 0.516 0.038 0.697 0.038 0.131 0 0.322-0.013 0.575-0.031 0.319-0.028 0.588-0.044 0.803-0.044 0.050 0 0.075 0.050 0.075 0.15 0 0.134-0.047 0.203-0.137 0.203-0.328 0.034-0.594 0.125-0.794 0.272s-0.45 0.481-0.75 1.006l-1.222 2.237 1.644 3.35 2.428-5.647c0.084-0.206 0.125-0.397 0.125-0.569 0-0.412-0.281-0.631-0.847-0.659-0.050 0-0.075-0.059-0.075-0.175 0-0.119 0.037-0.178 0.113-0.178 0.206 0 0.45 0.013 0.734 0.038 0.262 0.025 0.481 0.038 0.656 0.038 0.188 0 0.4-0.013 0.644-0.038 0.253-0.025 0.481-0.038 0.684-0.038 0.063 0 0.094 0.050 0.094 0.15z"
                }
            }
        ]
    })(props);
}
function ImLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 13h-2v-7h2v7zM5 5c-0.553 0-1-0.447-1-1s0.447-1 1-1c0.553 0 1 0.447 1 1s-0.447 1-1 1zM13 13h-2v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4h-2v-7h2v1.241c0.412-0.566 1.044-1.241 1.75-1.241 1.244 0 2.25 1.119 2.25 2.5v4.5z"
                }
            }
        ]
    })(props);
}
function ImLinkedin2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2.767v1.418h0.040c0.385-0.691 1.327-1.418 2.732-1.418 2.921 0 3.461 1.818 3.461 4.183v4.817h-2.885v-4.27c0-1.018-0.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255v4.344h-2.883v-9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6h3v9h-3v-9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function ImLastfm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.056 11.972l-0.588-1.594c0 0-0.953 1.063-2.381 1.063-1.266 0-2.163-1.1-2.163-2.859 0-2.253 1.137-3.059 2.253-3.059 1.612 0 2.125 1.044 2.566 2.381l0.588 1.831c0.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.813-0.697 3.813-2.528 0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.513-1.044-1.063 0-0.622 0.494-0.991 1.3-0.991 0.881 0 1.356 0.331 1.428 1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262 0.622-3.262 2.622 0 1.247 0.606 2.034 2.125 2.4l1.247 0.294c0.934 0.219 1.247 0.606 1.247 1.137 0 0.678-0.659 0.953-1.906 0.953-1.85 0-2.622-0.972-3.059-2.309l-0.606-1.831c-0.766-2.384-1.994-3.263-4.431-3.263-2.694 0-4.125 1.703-4.125 4.6 0 2.784 1.428 4.287 3.997 4.287 2.069 0 3.059-0.972 3.059-0.972v0z"
                }
            }
        ]
    })(props);
}
function ImLastfm2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.666 11.887c-2.775 0-3.737-1.25-4.25-2.806l-0.513-1.603c-0.384-1.172-0.834-2.084-2.244-2.084-0.978 0-1.972 0.706-1.972 2.678 0 1.541 0.784 2.503 1.894 2.503 1.25 0 2.084-0.931 2.084-0.931l0.513 1.394c0 0-0.866 0.85-2.678 0.85-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206 0.769 3.881 2.853l0.528 1.603c0.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-0.241 1.669-0.834 0-0.466-0.272-0.803-1.091-0.994l-1.091-0.256c-1.331-0.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631 0.594 2.759 2.038l-1.603 0.194c-0.066-0.691-0.481-0.978-1.25-0.978-0.706 0-1.137 0.322-1.137 0.866 0 0.481 0.209 0.769 0.912 0.931l1.025 0.225c1.378 0.322 2.116 0.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z"
                }
            }
        ]
    })(props);
}
function ImDelicious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16v-16h-16zM8 15v-7h-7v-7h7v7h7v7h-7z"
                }
            }
        ]
    })(props);
}
function ImStumbleupon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5c-0.55 0-1 0.45-1 1v4c0 1.653-1.347 3-3 3s-3-1.347-3-3v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-1.653 1.347-3 3-3s3 1.347 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.331-0.45-0.781-1-0.781z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10c0 1.653-1.347 3-3 3s-3-1.347-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.769 0.45 1.219 1 1.219s1-0.45 1-1v-2h2v2z"
                }
            }
        ]
    })(props);
}
function ImStumbleupon2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.313 0h-10.625c-1.478 0-2.688 1.209-2.688 2.688v10.625c0 1.478 1.209 2.688 2.688 2.688h10.625c1.478 0 2.688-1.209 2.688-2.688v-10.625c0-1.478-1.209-2.688-2.688-2.688zM8 5c-0.551 0-1 0.449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3v-2h2v2c0 0.551 0.449 1 1 1s1-0.449 1-1v-4c0-1.654 1.346-3 3-3s3 1.346 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.333-0.449-0.781-1-0.781zM15 10c0 1.654-1.346 3-3 3s-3-1.346-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.77 0.449 1.219 1 1.219s1-0.449 1-1v-2h2v2z"
                }
            }
        ]
    })(props);
}
function ImStackoverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10v6h-16v-6h2v4h12v-4zM3 11h10v2h-10zM3.237 8.835l0.433-1.953 9.763 2.164-0.433 1.953zM4.37 4.821l0.845-1.813 9.063 4.226-0.845 1.813zM15.496 5.648l-1.218 1.587-7.934-6.088 0.88-1.147h0.91z"
                }
            }
        ]
    })(props);
}
function ImPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.069c-3.828 0-6.931 3.103-6.931 6.931 0 2.938 1.828 5.444 4.406 6.453-0.059-0.547-0.116-1.391 0.025-1.988 0.125-0.541 0.813-3.444 0.813-3.444s-0.206-0.416-0.206-1.028c0-0.963 0.559-1.684 1.253-1.684 0.591 0 0.878 0.444 0.878 0.975 0 0.594-0.378 1.484-0.575 2.306-0.166 0.691 0.344 1.253 1.025 1.253 1.231 0 2.178-1.3 2.178-3.175 0-1.659-1.194-2.819-2.894-2.819-1.972 0-3.128 1.478-3.128 3.009 0 0.597 0.228 1.234 0.516 1.581 0.056 0.069 0.066 0.128 0.047 0.2-0.053 0.219-0.169 0.691-0.194 0.787-0.031 0.128-0.1 0.153-0.231 0.094-0.866-0.403-1.406-1.669-1.406-2.684 0-2.188 1.587-4.194 4.578-4.194 2.403 0 4.272 1.712 4.272 4.003 0 2.388-1.506 4.313-3.597 4.313-0.703 0-1.362-0.366-1.588-0.797 0 0-0.347 1.322-0.431 1.647-0.156 0.603-0.578 1.356-0.862 1.816 0.65 0.2 1.337 0.309 2.053 0.309 3.828 0 6.931-3.103 6.931-6.931 0-3.831-3.103-6.934-6.931-6.934z"
                }
            }
        ]
    })(props);
}
function ImPinterest2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.412 0-8 3.587-8 8s3.587 8 8 8 8-3.588 8-8-3.588-8-8-8zM8 14.931c-0.716 0-1.403-0.109-2.053-0.309 0.281-0.459 0.706-1.216 0.862-1.816 0.084-0.325 0.431-1.647 0.431-1.647 0.225 0.431 0.888 0.797 1.587 0.797 2.091 0 3.597-1.922 3.597-4.313 0-2.291-1.869-4.003-4.272-4.003-2.991 0-4.578 2.009-4.578 4.194 0 1.016 0.541 2.281 1.406 2.684 0.131 0.063 0.2 0.034 0.231-0.094 0.022-0.097 0.141-0.566 0.194-0.787 0.016-0.069 0.009-0.131-0.047-0.2-0.287-0.347-0.516-0.988-0.516-1.581 0-1.528 1.156-3.009 3.128-3.009 1.703 0 2.894 1.159 2.894 2.819 0 1.875-0.947 3.175-2.178 3.175-0.681 0-1.191-0.563-1.025-1.253 0.197-0.825 0.575-1.713 0.575-2.306 0-0.531-0.284-0.975-0.878-0.975-0.697 0-1.253 0.719-1.253 1.684 0 0.612 0.206 1.028 0.206 1.028s-0.688 2.903-0.813 3.444c-0.141 0.6-0.084 1.441-0.025 1.988-2.578-1.006-4.406-3.512-4.406-6.45 0-3.828 3.103-6.931 6.931-6.931s6.931 3.103 6.931 6.931c0 3.828-3.103 6.931-6.931 6.931z"
                }
            }
        ]
    })(props);
}
function ImXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.884 10.406h-1.728c-0.103 0-0.181-0.047-0.225-0.119-0.047-0.075-0.047-0.169 0-0.266l1.838-3.244c0.003-0.003 0.003-0.006 0-0.009l-1.169-2.025c-0.047-0.097-0.056-0.191-0.009-0.266 0.044-0.072 0.131-0.109 0.237-0.109h1.731c0.266 0 0.397 0.172 0.481 0.325 0 0 1.181 2.063 1.191 2.075-0.069 0.125-1.869 3.303-1.869 3.303-0.094 0.162-0.219 0.334-0.478 0.334zM13.069 2.378l-3.831 6.775c-0.003 0.003-0.003 0.009 0 0.012l2.441 4.456c0.047 0.097 0.050 0.194 0.003 0.269-0.044 0.072-0.125 0.109-0.231 0.109h-1.728c-0.266 0-0.397-0.175-0.484-0.328 0 0-2.453-4.5-2.459-4.512 0.122-0.216 3.85-6.828 3.85-6.828 0.094-0.166 0.206-0.328 0.463-0.328h1.753c0.103 0 0.188 0.041 0.231 0.109 0.044 0.072 0.044 0.169-0.006 0.266z"
                }
            }
        ]
    })(props);
}
function ImXing2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.431 3.159c-0.138 0-0.256 0.050-0.316 0.144-0.059 0.1-0.050 0.225 0.013 0.353l1.559 2.7c0.003 0.006 0.003 0.009 0 0.013l-2.45 4.331c-0.063 0.128-0.059 0.256 0 0.353 0.059 0.094 0.163 0.156 0.3 0.156h2.306c0.344 0 0.513-0.234 0.628-0.447 0 0 2.397-4.241 2.491-4.406-0.009-0.016-1.588-2.766-1.588-2.766-0.116-0.203-0.287-0.431-0.644-0.431h-2.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.125 0c-0.344 0-0.494 0.216-0.619 0.441 0 0-4.972 8.816-5.134 9.106 0.009 0.016 3.278 6.016 3.278 6.016 0.116 0.203 0.291 0.441 0.644 0.441h2.306c0.137 0 0.247-0.053 0.306-0.147 0.063-0.1 0.059-0.228-0.006-0.356l-3.25-5.947c-0.003-0.006-0.003-0.009 0-0.016l5.109-9.034c0.063-0.128 0.066-0.256 0.006-0.356-0.059-0.094-0.169-0.147-0.306-0.147h-2.334z"
                }
            }
        ]
    })(props);
}
function ImFlattr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.743 0c-3.802 0-5.743 2.19-5.743 6.279v0 8.579l3.725-3.729v-4.358c0-1.694 0.449-2.772 1.955-3.014v0c0.526-0.103 1.621-0.067 2.317-0.067v0 2.587c0 0.024 0.003 0.066 0.009 0.087v0c0.029 0.105 0.124 0.181 0.236 0.182v0c0.063 0 0.123-0.033 0.184-0.093v0l6.455-6.453-9.139-0.001zM12.275 4.871v4.358c0 1.694-0.449 2.772-1.955 3.014v0c-0.526 0.103-1.621 0.067-2.317 0.067v0-2.587c0-0.023-0.003-0.066-0.009-0.087v0c-0.029-0.105-0.124-0.182-0.236-0.182v0c-0.064-0-0.123 0.033-0.184 0.093v0l-6.455 6.453 9.139 0.001c3.802 0 5.743-2.19 5.743-6.279v0-8.579l-3.725 3.729z"
                }
            }
        ]
    })(props);
}
function ImFoursquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.306 1.408c-0.188-0.256-0.488-0.408-0.806-0.408h-9.5c-0.552 0-1 0.448-1 1v12c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.382 0.076 0.26 0 0.516-0.102 0.707-0.293l3.707-3.707h2.586c0.437 0 0.824-0.284 0.954-0.702l2.5-8c0.095-0.304 0.040-0.634-0.149-0.891zM10.515 5h-3.515c-0.552 0-1 0.448-1 1s0.448 1 1 1h2.89l-0.625 2h-2.265c-0.265 0-0.52 0.105-0.707 0.293l-2.293 2.293v-8.586h7.14l-0.625 2z"
                }
            }
        ]
    })(props);
}
function ImYelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.514 10.21c-0.27 0.272-0.042 0.768-0.042 0.768l2.033 3.394c0 0 0.334 0.447 0.623 0.447 0.29 0 0.577-0.239 0.577-0.239l1.607-2.297c0 0 0.162-0.29 0.166-0.544 0.006-0.361-0.538-0.46-0.538-0.46l-3.805-1.222c-0 0-0.373-0.099-0.621 0.152zM9.321 8.5c0.195 0.33 0.732 0.234 0.732 0.234l3.796-1.109c0 0 0.517-0.21 0.591-0.491 0.072-0.281-0.085-0.619-0.085-0.619l-1.814-2.137c0 0-0.157-0.27-0.483-0.297-0.36-0.031-0.581 0.405-0.581 0.405l-2.145 3.375c0 0-0.19 0.336-0.010 0.64zM7.527 7.184c0.447-0.11 0.518-0.759 0.518-0.759l-0.030-5.404c0 0-0.067-0.667-0.367-0.847-0.47-0.285-0.609-0.136-0.744-0.116l-3.151 1.171c0 0-0.309 0.102-0.469 0.36-0.23 0.365 0.233 0.899 0.233 0.899l3.276 4.465c0 0 0.323 0.334 0.735 0.233zM6.749 9.371c0.011-0.417-0.5-0.667-0.5-0.667l-3.387-1.711c0 0-0.502-0.207-0.746-0.063-0.187 0.11-0.352 0.31-0.368 0.486l-0.221 2.716c0 0-0.033 0.471 0.089 0.685 0.173 0.304 0.741 0.092 0.741 0.092l3.955-0.874c0.154-0.103 0.423-0.113 0.438-0.664zM7.732 10.837c-0.339-0.174-0.746 0.187-0.746 0.187l-2.648 2.915c0 0-0.33 0.446-0.246 0.72 0.079 0.257 0.21 0.384 0.396 0.474l2.659 0.839c0 0 0.322 0.067 0.567-0.004 0.347-0.1 0.283-0.643 0.283-0.643l0.060-3.947c-0 0-0.014-0.38-0.324-0.541z"
                }
            }
        ]
    })(props);
}
function ImPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.531 4.822c-0.747 3.316-3.053 5.066-6.688 5.066h-1.209l-0.841 5.338h-1.013l-0.053 0.344c-0.034 0.228 0.141 0.431 0.369 0.431h2.588c0.306 0 0.566-0.222 0.616-0.525l0.025-0.131 0.488-3.091 0.031-0.169c0.047-0.303 0.309-0.525 0.616-0.525h0.384c2.506 0 4.469-1.019 5.044-3.963 0.216-1.119 0.134-2.069-0.356-2.775z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.984 1.206c-0.741-0.844-2.081-1.206-3.794-1.206h-4.972c-0.35 0-0.65 0.253-0.703 0.6l-2.072 13.131c-0.041 0.259 0.159 0.494 0.422 0.494h3.072l0.772-4.891-0.025 0.153c0.053-0.347 0.35-0.6 0.7-0.6h1.459c2.866 0 5.109-1.162 5.766-4.531 0.019-0.1 0.037-0.197 0.050-0.291 0.194-1.244 0-2.094-0.675-2.859z"
                }
            }
        ]
    })(props);
}
function ImChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.036 6.977l-2.29-3.966c1.466-1.835 3.722-3.012 6.254-3.012 2.929 0 5.489 1.574 6.883 3.922h-6.528c-0.117-0.010-0.236-0.016-0.356-0.016-1.904 0-3.509 1.307-3.964 3.071zM10.864 5.078h4.585c0.355 0.905 0.551 1.891 0.551 2.922 0 4.388-3.533 7.95-7.909 7.999l3.272-5.667c0.461-0.662 0.731-1.466 0.731-2.332 0-1.143-0.471-2.178-1.23-2.922zM5.094 8c0-1.603 1.304-2.906 2.906-2.906s2.906 1.304 2.906 2.906c0 1.602-1.304 2.906-2.906 2.906s-2.906-1.304-2.906-2.906zM9.097 11.944l-2.29 3.967c-3.852-0.576-6.806-3.899-6.806-7.911 0-1.425 0.373-2.763 1.026-3.922l3.266 5.657c0.654 1.392 2.070 2.359 3.707 2.359 0.38 0 0.747-0.052 1.097-0.149z"
                }
            }
        ]
    })(props);
}
function ImFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.977 5.221l-0.185 1.189c0 0-0.265-2.201-0.59-3.024-0.498-1.261-0.719-1.251-0.72-1.249 0.333 0.847 0.273 1.302 0.273 1.302s-0.591-1.609-2.152-2.121c-1.729-0.567-2.665-0.412-2.773-0.383-0.016-0-0.032-0-0.047-0 0.013 0.001 0.025 0.002 0.038 0.003-0.001 0-0.001 0.001-0.001 0.001 0.007 0.009 1.911 0.333 2.249 0.797 0 0-0.809 0-1.614 0.232-0.036 0.010 2.961 0.374 3.574 3.37 0 0-0.329-0.686-0.735-0.802 0.267 0.813 0.199 2.356-0.056 3.123-0.033 0.099-0.066-0.426-0.568-0.652 0.161 1.151-0.010 2.976-0.808 3.479-0.062 0.039 0.5-1.802 0.113-1.090-2.23 3.419-4.866 1.578-6.051 0.767 0.607 0.132 1.76-0.021 2.271-0.4 0.001-0 0.001-0.001 0.002-0.001 0.554-0.379 0.882-0.656 1.177-0.59s0.491-0.23 0.262-0.493c-0.229-0.263-0.786-0.625-1.539-0.428-0.531 0.139-1.19 0.727-2.194 0.132-0.771-0.457-0.844-0.837-0.851-1.1 0.019-0.093 0.043-0.18 0.072-0.26 0.089-0.248 0.358-0.323 0.508-0.382 0.254 0.044 0.473 0.123 0.703 0.241 0.003-0.076 0.004-0.178-0-0.293 0.022-0.044 0.008-0.176-0.027-0.337-0.020-0.161-0.053-0.328-0.106-0.48 0-0 0-0 0-0s0.002-0.001 0.002-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0-0.001 0.001-0.001c0.001-0.002 0.002-0.004 0.003-0.007 0.016-0.072 0.188-0.211 0.402-0.361 0.192-0.134 0.417-0.277 0.595-0.387 0.157-0.098 0.277-0.17 0.302-0.189 0.010-0.007 0.021-0.016 0.034-0.026 0.002-0.002 0.005-0.004 0.007-0.006s0.003-0.002 0.004-0.004c0.085-0.067 0.211-0.194 0.237-0.462 0-0.001 0-0.001 0-0.002 0.001-0.008 0.001-0.016 0.002-0.024 0-0.006 0.001-0.011 0.001-0.017 0-0.004 0-0.009 0.001-0.013 0-0.011 0.001-0.021 0.001-0.032 0-0.001 0-0.001 0-0.002 0-0.026-0-0.053-0.002-0.081-0.001-0.016-0.002-0.030-0.005-0.043-0-0.001-0-0.001-0-0.002s-0.001-0.003-0.001-0.004-0.001-0.005-0.002-0.007c-0-0-0-0-0-0.001-0.001-0.003-0.002-0.005-0.003-0.007-0-0-0-0-0-0-0.027-0.064-0.13-0.088-0.554-0.096-0-0-0.001-0-0.001-0v0c-0.173-0.003-0.399-0.003-0.695-0.002-0.52 0.002-0.807-0.508-0.898-0.705 0.126-0.695 0.489-1.19 1.085-1.525 0.011-0.006 0.009-0.012-0.004-0.015 0.117-0.071-1.41-0.002-2.112 0.891-0.623-0.155-1.166-0.144-1.635-0.035-0.090-0.003-0.202-0.014-0.335-0.041-0.311-0.282-0.757-0.803-0.781-1.425 0 0-0.001 0.001-0.004 0.003-0-0.006-0.001-0.012-0.001-0.018 0 0-0.949 0.729-0.807 2.717-0 0.032-0.001 0.062-0.002 0.092-0.257 0.348-0.384 0.641-0.394 0.706-0.228 0.463-0.458 1.16-0.646 2.218 0 0 0.131-0.417 0.395-0.889-0.194 0.594-0.346 1.518-0.257 2.904 0 0 0.024-0.307 0.107-0.75 0.065 0.86 0.352 1.921 1.076 3.169 1.39 2.396 3.526 3.605 5.887 3.791 0.419 0.035 0.845 0.035 1.272 0.003 0.039-0.003 0.079-0.006 0.118-0.009 0.484-0.034 0.971-0.107 1.457-0.224 6.643-1.606 5.921-9.628 5.921-9.628z"
                }
            }
        ]
    })(props);
}
function ImIe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.472 9.825h3.688c0.028-0.256 0.040-0.517 0.040-0.784 0-1.253-0.336-2.429-0.924-3.442 0.607-1.614 0.586-2.984-0.227-3.803-0.773-0.77-2.848-0.645-5.194 0.394-0.174-0.013-0.349-0.020-0.526-0.020-3.22 0-5.921 2.216-6.667 5.201 1.010-1.293 2.072-2.231 3.492-2.913-0.129 0.121-0.882 0.87-1.009 0.996-3.743 3.742-4.923 8.63-3.653 9.9 0.965 0.965 2.715 0.802 4.725-0.182 0.934 0.476 1.992 0.744 3.113 0.744 3.018 0 5.575-1.942 6.501-4.648h-3.717c-0.511 0.943-1.512 1.586-2.66 1.586s-2.148-0.642-2.66-1.586c-0.227-0.426-0.358-0.915-0.358-1.432v-0.011h6.035zM5.442 8.013c0.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728h-5.774zM14.015 2.559c0.524 0.529 0.511 1.503 0.063 2.719-0.768-1.17-1.883-2.093-3.2-2.619 1.408-0.604 2.553-0.684 3.137-0.1zM1.461 15.113c-0.668-0.669-0.467-2.072 0.394-3.763 0.536 1.504 1.581 2.767 2.927 3.581-1.491 0.677-2.712 0.792-3.321 0.182z"
                }
            }
        ]
    })(props);
}
function ImEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.241 7.103c0.469-3.7 2.994-7.056 7.519-7.103 2.731 0.053 4.978 1.291 6.316 3.65 0.672 1.231 0.881 2.525 0.925 3.953v1.678h-10.041c0.047 4.141 6.094 4 8.697 2.175v3.372c-1.525 0.916-4.984 1.734-7.662 0.681-2.281-0.856-3.906-3.244-3.897-5.541-0.075-2.978 1.481-4.95 3.897-6.072-0.513 0.634-0.903 1.334-1.106 2.547h5.669c0 0 0.331-3.388-3.209-3.388-3.338 0.116-5.744 2.056-7.106 4.047v0z"
                }
            }
        ]
    })(props);
}
function ImSafari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM14.975 7.388l-0.016-0.166c0.003 0.056 0.009 0.109 0.016 0.166zM13.881 4.2l-0.113-0.169c0.037 0.056 0.075 0.112 0.113 0.169zM13.447 3.603l-0.069-0.084c0.025 0.028 0.047 0.056 0.069 0.084zM12.478 2.619l-0.084-0.069c0.031 0.025 0.056 0.047 0.084 0.069zM11.969 2.231l-0.169-0.112c0.056 0.038 0.113 0.075 0.169 0.112zM8.778 1.044l-0.169-0.016c0.056 0.003 0.113 0.009 0.169 0.016zM7.388 1.025l-0.169 0.016c0.056-0.003 0.112-0.009 0.169-0.016zM4.2 2.119l-0.169 0.112c0.056-0.038 0.112-0.075 0.169-0.112zM3.603 2.553l-0.081 0.066c0.028-0.022 0.053-0.044 0.081-0.066zM2.619 3.522l-0.069 0.084c0.025-0.028 0.047-0.056 0.069-0.084zM2.231 4.031l-0.112 0.169c0.038-0.056 0.075-0.112 0.112-0.169zM1.044 7.222l-0.016 0.169c0.003-0.056 0.009-0.112 0.016-0.169zM1.025 8.613l0.016 0.169c-0.003-0.056-0.009-0.113-0.016-0.169zM2.119 11.797l0.112 0.169c-0.038-0.053-0.075-0.109-0.112-0.169zM2.25 11.994l1.247-0.834-0.138-0.209-1.247 0.834c-0.566-0.878-0.938-1.887-1.063-2.975l0.747-0.075-0.025-0.25-0.747 0.075c-0.012-0.144-0.019-0.291-0.022-0.438h1.5v-0.25h-1.5c0.003-0.147 0.009-0.291 0.022-0.438l0.747 0.072 0.025-0.25-0.747-0.072c0.125-1.088 0.5-2.097 1.066-2.975l1.247 0.834 0.138-0.209-1.25-0.828c0.084-0.119 0.169-0.237 0.259-0.35l0.578 0.475 0.159-0.194-0.578-0.475c0.094-0.112 0.194-0.219 0.294-0.325l1.059 1.059 0.178-0.178-1.059-1.059c0.106-0.1 0.212-0.2 0.322-0.294l0.475 0.581 0.194-0.159-0.475-0.578c0.116-0.091 0.231-0.178 0.35-0.263l0.834 1.247 0.209-0.138-0.834-1.247c0.878-0.566 1.888-0.938 2.975-1.063l0.075 0.747 0.25-0.025-0.075-0.747c0.144-0.012 0.291-0.019 0.438-0.022v1.5h0.25v-1.5c0.147 0.003 0.291 0.009 0.438 0.022l-0.072 0.747 0.25 0.025 0.072-0.747c1.088 0.125 2.097 0.5 2.975 1.066l-0.834 1.247 0.209 0.138 0.834-1.247c0.119 0.084 0.238 0.169 0.35 0.259l-0.475 0.578 0.194 0.159 0.475-0.578c0.113 0.094 0.219 0.194 0.325 0.294l-0.4 0.391-5.469 3.647-3.647 5.469-0.391 0.391c-0.1-0.106-0.2-0.213-0.294-0.322l0.578-0.475-0.159-0.194-0.578 0.475c-0.091-0.113-0.175-0.231-0.259-0.35zM2.619 12.478c-0.022-0.028-0.044-0.053-0.066-0.081l0.066 0.081zM3.522 13.381l0.081 0.066c-0.028-0.022-0.053-0.044-0.081-0.066zM4.031 13.766l0.169 0.113c-0.056-0.034-0.112-0.072-0.169-0.113zM7.222 14.956l0.169 0.016c-0.056-0.003-0.112-0.009-0.169-0.016zM8.613 14.975l0.166-0.016c-0.056 0.003-0.109 0.009-0.166 0.016zM11.8 13.881l0.169-0.113c-0.056 0.037-0.113 0.075-0.169 0.113zM12.397 13.447l0.084-0.069c-0.028 0.025-0.056 0.047-0.084 0.069zM12.944 12.956l0.012-0.012c-0.003 0.003-0.009 0.009-0.012 0.012zM13.381 12.478l0.069-0.084c-0.025 0.028-0.047 0.056-0.069 0.084zM13.491 12.344l-0.578-0.475-0.159 0.194 0.578 0.475c-0.094 0.113-0.194 0.219-0.294 0.325l-1.059-1.059-0.178 0.178 1.059 1.059c-0.106 0.1-0.213 0.2-0.322 0.294l-0.475-0.581-0.194 0.159 0.475 0.578c-0.116 0.091-0.231 0.178-0.35 0.262l-0.834-1.247-0.209 0.137 0.834 1.247c-0.878 0.566-1.887 0.938-2.975 1.063l-0.075-0.747-0.25 0.025 0.075 0.747c-0.144 0.012-0.291 0.019-0.438 0.022v-1.5h-0.25v1.5c-0.147-0.003-0.291-0.009-0.438-0.022l0.072-0.747-0.25-0.025-0.072 0.747c-1.088-0.125-2.097-0.5-2.975-1.066l0.834-1.247-0.209-0.137-0.828 1.247c-0.119-0.084-0.237-0.169-0.35-0.259l0.475-0.578-0.194-0.159-0.475 0.578c-0.112-0.094-0.219-0.194-0.325-0.294l0.394-0.391 5.469-3.647 3.647-5.469 0.391-0.391c0.1 0.106 0.2 0.212 0.294 0.322l-0.578 0.475 0.159 0.194 0.578-0.475c0.091 0.116 0.178 0.231 0.262 0.35l-1.247 0.834 0.137 0.209 1.247-0.834c0.566 0.878 0.938 1.888 1.063 2.975l-0.747 0.075 0.025 0.25 0.747-0.075c0.012 0.144 0.019 0.291 0.022 0.438h-1.5v0.25h1.5c-0.003 0.147-0.009 0.291-0.022 0.438l-0.747-0.072-0.025 0.25 0.747 0.072c-0.125 1.088-0.5 2.097-1.066 2.975l-1.247-0.834-0.137 0.209 1.247 0.834c-0.081 0.113-0.169 0.228-0.259 0.344zM14.975 8.609c-0.006 0.056-0.009 0.113-0.016 0.169l0.016-0.169zM13.881 11.8c-0.037 0.056-0.075 0.113-0.113 0.169l0.113-0.169z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.758 1.111l0.293 1.471-0.245 0.049-0.293-1.471 0.245-0.049z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.245 14.89l-0.293-1.471 0.245-0.049 0.293 1.471-0.245 0.049z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.088 1.264l0.218 0.718-0.239 0.073-0.218-0.718 0.239-0.073z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.913 14.733l-0.218-0.718 0.239-0.073 0.218 0.718-0.239 0.073z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.438 1.486l0.574 1.386-0.231 0.096-0.574-1.386 0.231-0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 14.515l-0.574-1.386 0.231-0.096 0.574 1.386-0.231 0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.588 1.885l0.22-0.118 0.354 0.661-0.22 0.118-0.354-0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.408 14.114l-0.22 0.118-0.354-0.661 0.22-0.118 0.354 0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.884 4.591l0.662 0.353-0.118 0.221-0.661-0.353 0.118-0.221z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.113 11.409l-0.662-0.353 0.118-0.22 0.662 0.353-0.118 0.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.872 6.010l-1.386-0.574 0.096-0.231 1.386 0.574-0.096 0.231z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.13 9.989l1.386 0.574-0.096 0.231-1.386-0.574 0.096-0.231z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.337 5.85l0.718 0.218-0.073 0.239-0.718-0.218 0.073-0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.661 10.151l-0.718-0.218 0.073-0.239 0.718 0.218-0.073 0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.157 6.512l1.471 0.293-0.049 0.245-1.471-0.293 0.049-0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.84 9.488l-1.471-0.293 0.049-0.245 1.471 0.293-0.049 0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.109 9.243l1.471-0.293 0.049 0.245-1.471 0.293-0.049-0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.888 6.757l-1.471 0.293-0.049-0.245 1.471-0.293 0.049 0.245z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.265 9.914l0.718-0.218 0.073 0.239-0.718 0.218-0.073-0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.734 6.089l-0.718 0.218-0.073-0.239 0.718-0.218 0.073 0.239z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.58 10.796l-0.096-0.231 1.386-0.574 0.096 0.231-1.386 0.574z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.419 5.207l0.096 0.231-1.386 0.574-0.096-0.231 1.386-0.574z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.888 11.41l-0.118-0.22 0.661-0.354 0.118 0.22-0.661 0.354z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.116 4.59l0.118 0.22-0.661 0.354-0.118-0.22 0.661-0.354z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.811 14.232l-0.22-0.118 0.354-0.661 0.22 0.118-0.354 0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.189 1.767l0.22 0.118-0.353 0.661-0.22-0.118 0.353-0.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.207 14.419l0.574-1.386 0.231 0.096-0.574 1.386-0.231-0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.795 1.58l-0.574 1.386-0.231-0.096 0.574-1.386 0.231 0.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.088 14.735l-0.239-0.073 0.218-0.718 0.239 0.073-0.218 0.718z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.912 1.264l0.239 0.073-0.218 0.718-0.239-0.073 0.218-0.718z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.757 14.888l-0.245-0.049 0.293-1.471 0.245 0.049-0.293 1.471z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.243 1.109l0.245 0.049-0.293 1.471-0.245-0.049 0.293-1.471z"
                }
            }
        ]
    })(props);
}
function ImOpera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v0 0c0 2.369-1.031 4.5-2.669 5.963-2.053 1-3.966 0.3-4.597-0.137 2.016-0.441 3.537-2.878 3.537-5.825s-1.522-5.384-3.537-5.828c0.634-0.438 2.547-1.137 4.597-0.138 1.637 1.466 2.669 3.597 2.669 5.966v0 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.366 3.491c-0.884 1.044-1.456 2.587-1.494 4.322 0 0.003 0 0.372 0 0.378 0.038 1.731 0.613 3.275 1.497 4.319 1.147 1.491 2.853 2.434 4.759 2.434 1.172 0 2.269-0.356 3.206-0.978-1.419 1.266-3.287 2.034-5.334 2.034-0.128 0-0.256-0.003-0.381-0.009-4.241-0.2-7.619-3.7-7.619-7.991 0-4.419 3.581-8 8-8 0.009 0 0.019 0 0.031 0 2.037 0.006 3.894 0.775 5.303 2.038-0.938-0.622-2.034-0.981-3.206-0.981-1.906 0-3.612 0.944-4.763 2.434z"
                }
            }
        ]
    })(props);
}
function ImFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.156 9.211c-0.213-0.21-0.686-0.321-1.406-0.331-0.487-0.005-1.073 0.038-1.69 0.124-0.276-0.159-0.561-0.333-0.784-0.542-0.601-0.561-1.103-1.34-1.415-2.197 0.020-0.080 0.038-0.15 0.054-0.222 0 0 0.339-1.923 0.249-2.573-0.012-0.089-0.020-0.115-0.044-0.184l-0.029-0.076c-0.092-0.212-0.273-0.437-0.556-0.425l-0.171-0.005c-0.316 0-0.573 0.161-0.64 0.403-0.205 0.757 0.007 1.889 0.39 3.355l-0.098 0.239c-0.275 0.67-0.619 1.345-0.923 1.94l-0.040 0.077c-0.32 0.626-0.61 1.157-0.873 1.607l-0.271 0.144c-0.020 0.010-0.485 0.257-0.594 0.323-0.926 0.553-1.539 1.18-1.641 1.678-0.032 0.159-0.008 0.362 0.156 0.456l0.263 0.132c0.114 0.057 0.234 0.086 0.357 0.086 0.659 0 1.425-0.821 2.48-2.662 1.218-0.396 2.604-0.726 3.819-0.908 0.926 0.521 2.065 0.883 2.783 0.883 0.128 0 0.238-0.012 0.327-0.036 0.138-0.037 0.254-0.115 0.325-0.222 0.139-0.21 0.168-0.499 0.13-0.795-0.011-0.088-0.081-0.196-0.157-0.271zM3.307 12.72c0.12-0.329 0.596-0.979 1.3-1.556 0.044-0.036 0.153-0.138 0.253-0.233-0.736 1.174-1.229 1.642-1.553 1.788zM7.476 3.12c0.212 0 0.333 0.534 0.343 1.035s-0.107 0.853-0.252 1.113c-0.12-0.385-0.179-0.992-0.179-1.389 0 0-0.009-0.759 0.088-0.759v0zM6.232 9.961c0.148-0.264 0.301-0.543 0.458-0.839 0.383-0.724 0.624-1.29 0.804-1.755 0.358 0.651 0.804 1.205 1.328 1.649 0.065 0.055 0.135 0.111 0.207 0.166-1.066 0.211-1.987 0.467-2.798 0.779v0zM12.952 9.901c-0.065 0.041-0.251 0.064-0.37 0.064-0.386 0-0.864-0.176-1.533-0.464 0.257-0.019 0.493-0.029 0.705-0.029 0.387 0 0.502-0.002 0.88 0.095s0.383 0.293 0.318 0.333v0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImFileOpenoffice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.785 7.37c-0.948-0.448-2.156-0.538-3.044 0.095 1.080-0.103 2.265 0.076 3.049 0.893 0.75-0.861 1.939-1.022 3.015-0.933-0.898-0.596-2.082-0.516-3.019-0.054v0zM10.401 9.465c-1.068-0.025-2.101 0.362-2.986 0.939-1.675-0.712-3.793-0.58-5.219 0.609 0.411-0.015 0.813-0.116 1.22-0.169 1.487-0.148 3.072 0.221 4.196 1.247 0.465-0.68 1.119-1.223 1.87-1.561 0.986-0.477 2.096-0.526 3.169-0.539-0.651-0.448-1.478-0.531-2.249-0.526z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.997 7.436h0.691l-0.797 3.534-1.036-4.969h-1.665l-1.205 4.969-0.903-4.969h-1.741l1.767 7.998h1.701l1.192-4.73 1.066 4.73h1.568l2.025-7.998h-2.663v1.435z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 6h-2.114l-1.496 2.204-1.496-2.204h-2.114l2.534 3.788-2.859 4.212h3.935v-1.431h-0.784l0.784-1.172 1.741 2.603h2.194l-2.859-4.212 2.534-3.788z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
                }
            }
        ]
    })(props);
}
function ImLibreoffice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354 0.354c-0.194-0.194-0.579-0.354-0.854-0.354h-6c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.159-0.659-0.354-0.854l-5.293-5.293zM13 15h-11v-14h5.487c0.046 0.008 0.131 0.043 0.169 0.070l5.274 5.274c0.027 0.038 0.062 0.123 0.070 0.169v8.487zM13.5 0h-3c-0.275 0-0.341 0.159-0.146 0.354l3.293 3.293c0.194 0.194 0.354 0.129 0.354-0.146v-3c0-0.275-0.225-0.5-0.5-0.5z"
                }
            }
        ]
    })(props);
}
function ImHtmlFive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.26 4.71h-6.758l0.161 1.809h6.437l-0.485 5.422-3.623 1.004-3.618-1.004-0.247-2.774h1.773l0.126 1.41 1.967 0.53 0.004-0.001 1.968-0.531 0.204-2.29h-6.121l-0.476-5.341h8.847l-0.158 1.766z"
                }
            }
        ]
    })(props);
}
function ImHtmlFive2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.668 13.482l-4.644 1.287v0.007l-0.012-0.004-0.012 0.004v-0.007l-4.644-1.287-1.098-12.304h11.508l-1.098 12.304zM10.168 8.284l-0.204 2.29-1.972 0.532-1.967-0.53-0.126-1.41h-1.773l0.247 2.774 3.626 1.003 3.615-1.003 0.485-5.422h-6.437l-0.161-1.809h6.758l0.158-1.766h-8.847l0.477 5.341z"
                }
            }
        ]
    })(props);
}
function ImCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.381 0.758l-0.537 2.686h10.934l-0.342 1.735h-10.94l-0.53 2.686h10.933l-0.61 3.063-4.406 1.46-3.819-1.46 0.261-1.329h-2.686l-0.639 3.224 6.316 2.417 7.281-2.417 2.403-12.066z"
                }
            }
        ]
    })(props);
}
function ImGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.698 7.287l-6.986-6.986c-0.402-0.402-1.055-0.402-1.457 0l-1.623 1.623 1.221 1.221c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5 0 0.232-0.053 0.451-0.146 0.647l2 2c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5c0-0.232 0.053-0.451 0.146-0.647l-2-2c-0.048 0.023-0.097 0.043-0.147 0.061v4.171c0.583 0.206 1 0.761 1 1.414 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.653 0.417-1.208 1-1.414v-4.171c-0.583-0.206-1-0.761-1-1.414 0-0.232 0.053-0.451 0.146-0.647l-1.221-1.221-4.623 4.623c-0.402 0.403-0.402 1.055 0 1.458l6.986 6.986c0.402 0.402 1.054 0.402 1.457 0l6.953-6.953c0.402-0.403 0.402-1.055-0-1.458z"
                }
            }
        ]
    })(props);
}
function ImCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.777 5.751l-7-4.667c-0.168-0.112-0.387-0.112-0.555 0l-7 4.667c-0.139 0.093-0.223 0.249-0.223 0.416v4.667c0 0.167 0.084 0.323 0.223 0.416l7 4.667c0.084 0.056 0.181 0.084 0.277 0.084s0.193-0.028 0.277-0.084l7-4.667c0.139-0.093 0.223-0.249 0.223-0.416v-4.667c0-0.167-0.084-0.323-0.223-0.416zM7.5 10.232l-2.599-1.732 2.599-1.732 2.599 1.732-2.599 1.732zM8 5.899v-3.465l5.599 3.732-2.599 1.732-3-2zM7 5.899l-3 2-2.599-1.732 5.599-3.732v3.465zM3.099 8.5l-2.099 1.399v-2.798l2.099 1.399zM4 9.101l3 2v3.465l-5.599-3.732 2.599-1.732zM8 11.101l3-2 2.599 1.732-5.599 3.732v-3.465zM11.901 8.5l2.099-1.399v2.798l-2.099-1.399z"
                }
            }
        ]
    })(props);
}
function ImSvg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.5c-0.444 0-0.843 0.193-1.118 0.5h-2.968l2.099-2.099c0.411 0.023 0.83-0.123 1.144-0.437 0.586-0.586 0.586-1.536 0-2.121s-1.536-0.586-2.121 0c-0.314 0.314-0.46 0.733-0.437 1.144l-2.099 2.099v-2.968c0.307-0.275 0.5-0.674 0.5-1.118 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.444 0.193 0.843 0.5 1.118v2.968l-2.099-2.099c0.023-0.411-0.123-0.83-0.437-1.144-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.314 0.314 0.733 0.46 1.144 0.437l2.099 2.099h-2.968c-0.275-0.307-0.674-0.5-1.118-0.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.444 0 0.843-0.193 1.118-0.5h2.968l-2.099 2.099c-0.411-0.023-0.83 0.123-1.144 0.437-0.586 0.586-0.586 1.536 0 2.121s1.536 0.586 2.121 0c0.314-0.314 0.46-0.733 0.437-1.144l2.099-2.099v2.968c-0.307 0.275-0.5 0.674-0.5 1.118 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.444-0.193-0.843-0.5-1.118v-2.968l2.099 2.099c-0.023 0.411 0.123 0.83 0.437 1.144 0.586 0.586 1.536 0.586 2.121 0s0.586-1.536 0-2.121c-0.314-0.314-0.733-0.46-1.144-0.437l-2.099-2.099h2.968c0.275 0.307 0.674 0.5 1.118 0.5 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function ImIcoMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "version": "1.1",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.055 8c0-1.022 0.829-1.851 1.851-1.851s1.851 0.829 1.851 1.851c0 1.022-0.829 1.851-1.851 1.851s-1.851-0.829-1.851-1.851zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM5.928 14.989c-2.406-1.4-4.023-4.005-4.023-6.989s1.617-5.589 4.023-6.989c2.406 1.399 4.025 4.005 4.025 6.989s-1.618 5.589-4.025 6.989z"
                }
            }
        ]
    })(props);
}

},{"../lib":"aq338","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bnUVV":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b5a9e4b06e8305a4");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _range = _interopRequireDefault(require("1136e902f5789932"));
/**
 * This function returns the rating based on the rating internal, rating limit and number of intervals
 */ function getRatings(minRatingValue, ratingInterval, numberOfIntervals) {
    var ratings = [];
    (0, _range["default"])(0, numberOfIntervals).forEach(function(rating) {
        ratings.push(minRatingValue + rating * ratingInterval);
    });
    return ratings;
}
var _default = exports["default"] = getRatings;

},{"b5a9e4b06e8305a4":"bm29M","1136e902f5789932":"lsF5X"}],"lsF5X":[function(require,module,exports) {
var createRange = require("900abe38566f7e01");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"900abe38566f7e01":"5snkf"}],"5snkf":[function(require,module,exports) {
var baseRange = require("20a2493f8d54f7bf"), isIterateeCall = require("d5022a7131584956"), toFinite = require("9b927efc993fec71");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"20a2493f8d54f7bf":"hWvuQ","d5022a7131584956":"Y7Izf","9b927efc993fec71":"9reuq"}],"hWvuQ":[function(require,module,exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"Y7Izf":[function(require,module,exports) {
var eq = require("81d15acafa01c128"), isArrayLike = require("4799e23472907bd7"), isIndex = require("a1cda6e72f5f758"), isObject = require("ed4346446d920f8b");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"81d15acafa01c128":"4xJYV","4799e23472907bd7":"9TOQ7","a1cda6e72f5f758":"ed9t2","ed4346446d920f8b":"bq7Fv"}],"9reuq":[function(require,module,exports) {
var toNumber = require("77e4709370d360c4");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"77e4709370d360c4":"ktkU9"}],"ktkU9":[function(require,module,exports) {
var baseTrim = require("293cfed90975b114"), isObject = require("48e0ff690bad64eb"), isSymbol = require("4b4cfb05282c8d07");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"293cfed90975b114":"aFYcB","48e0ff690bad64eb":"bq7Fv","4b4cfb05282c8d07":"6fjdJ"}],"aFYcB":[function(require,module,exports) {
var trimmedEndIndex = require("34c1cd0b96b8a3ab");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
module.exports = baseTrim;

},{"34c1cd0b96b8a3ab":"koPNu"}],"koPNu":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"k5FHG":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2a67e56a22b89dad");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("885c6930d5eb3cd3"));
var _modal = require("7b3a9a9411ca86d6");
var _row = _interopRequireDefault(require("d2e2fd7d9b3fb177"));
var _button = _interopRequireDefault(require("f68f561cb3ba577"));
var _propTypes = _interopRequireDefault(require("b99b896e8931c90f"));
var _ButtonWithToolTip = _interopRequireDefault(require("7b9cd9de49c2fe3c"));
var _FeedbackConstants = require("a7784fb8ca6d9c66");
var NonSkippableFooter = function NonSkippableFooter(_ref) {
    var isDisabled = _ref.isDisabled, onClickFooterButton = _ref.onClickFooterButton, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText;
    return /*#__PURE__*/ _react["default"].createElement(_modal.ModalFooter, null, /*#__PURE__*/ _react["default"].createElement(_row["default"], {
        alignmentHorizontal: "center",
        widths: "fit"
    }, isDisabled ? /*#__PURE__*/ _react["default"].createElement(_ButtonWithToolTip["default"], {
        onClickFooterButton: onClickFooterButton,
        title: _FeedbackConstants.REQUIRED_QUESTION_TITLE,
        submitButtonSize: submitButtonSize,
        submitButtonType: submitButtonType,
        submitButtonText: submitButtonText
    }) : /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: submitButtonType,
        size: submitButtonSize,
        onClick: onClickFooterButton
    }, submitButtonText)));
};
NonSkippableFooter.propTypes = {
    isDisabled: _propTypes["default"].bool.isRequired,
    onClickFooterButton: _propTypes["default"].func.isRequired,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string
};
NonSkippableFooter.defaultProps = {
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text
};
var _default = exports["default"] = NonSkippableFooter;

},{"2a67e56a22b89dad":"bm29M","885c6930d5eb3cd3":"6uln9","7b3a9a9411ca86d6":"bUAK2","d2e2fd7d9b3fb177":"gNI9h","f68f561cb3ba577":"gJQuD","b99b896e8931c90f":"gJRKl","7b9cd9de49c2fe3c":"fPm1z","a7784fb8ca6d9c66":"filWO"}],"fPm1z":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7878b09905ea9817");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("ef801e36e1e39074"));
var _button = _interopRequireDefault(require("bb8f3976b1d4f4c2"));
var _tooltip = _interopRequireDefault(require("a64706d12d99b77f"));
var _propTypes = _interopRequireDefault(require("f1b8a65c9f2882ec"));
var _FeedbackConstants = require("af04dd716dbb21f3");
var ButtonWithToolTip = function ButtonWithToolTip(_ref) {
    var onClickFooterButton = _ref.onClickFooterButton, title = _ref.title, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText;
    return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(_tooltip["default"], {
        position: "right",
        title: title
    }, /*#__PURE__*/ _react["default"].createElement("span", null, /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: submitButtonType,
        size: submitButtonSize,
        disabled: true,
        onClick: onClickFooterButton
    }, submitButtonText))));
};
ButtonWithToolTip.propTypes = {
    onClickFooterButton: _propTypes["default"].func.isRequired,
    title: _propTypes["default"].string.isRequired,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string
};
ButtonWithToolTip.defaultProps = {
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text
};
var _default = exports["default"] = ButtonWithToolTip;

},{"7878b09905ea9817":"bm29M","ef801e36e1e39074":"6uln9","bb8f3976b1d4f4c2":"gJQuD","a64706d12d99b77f":"kT4Gb","f1b8a65c9f2882ec":"gJRKl","af04dd716dbb21f3":"filWO"}],"kT4Gb":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3772c18bffd14575");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _tooltip = _interopRequireDefault(require("38e3405bb40481e6"));
var _default = _tooltip["default"];
exports["default"] = _default;

},{"3772c18bffd14575":"fk2Bw","38e3405bb40481e6":"6VpIK"}],"6VpIK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("43492f1f0532697");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("c5adc3b9ebdb0f09"));
var _classCallCheck2 = _interopRequireDefault(require("2847d5cb1ccee150"));
var _createClass2 = _interopRequireDefault(require("713d6fc5844b25ab"));
var _assertThisInitialized2 = _interopRequireDefault(require("8067f98da76948e"));
var _inherits2 = _interopRequireDefault(require("c0a52ddbf1eda5c5"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("e32a80f23df42575"));
var _getPrototypeOf2 = _interopRequireDefault(require("547e672d77fb7ca9"));
var _defineProperty2 = _interopRequireDefault(require("7e6ac1146a6d7c84"));
var _react = _interopRequireDefault(require("28db329db9dd5387"));
var _reactDom = _interopRequireDefault(require("29e0481639412a97"));
var _propTypes = _interopRequireDefault(require("1c75235a674bb388"));
var _emotion = require("c5468e8b6086be77");
var _popover = _interopRequireDefault(require("110d9add33b2a71a"));
var _elevation = require("60f0a8fed6920fd5");
var _theme = require("c06980e6f033b1d3");
var _popoverBody = _interopRequireDefault(require("107502f2666b1b0a"));
var _popoverController = _interopRequireDefault(require("7a8e5a056320c6d1"));
var _utils = require("7f21ec0ab7e255ca");
var _token = require("8021cce7632f4b97");
var _functional = require("801e54bcc3b2e3e2");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = (0, _functional.memoize)(function(maxWidth) {
    return (0, _emotion.css)({
        overflowWrap: "break-word",
        pointerEvents: "none",
        maxWidth: maxWidth
    });
});
/**
 * Add a tooltip to an element. A note on accessibility: tooltips should only be
 * added to elements that are focuseable. This allows keyboard users to open the
 * tooltip by tabbing to the tooltip's anchor node. Otherwise keyboard users
 * would not be able to open the tooltip. This means that *tooltips should not
 * be anchored to disabled elements directly*, since disabled elements generally
 * can't be focused. If you need to add context to a disabled element, consider
 * anchoring the tooltip to a help icon near the element:
 *
 * ```
 * <Row>
 *   <Button disabled={true}>Submit</Button>
 *   <Tooltip title="You can't perform this action, move along." position="right">
 *     <Icon tokens={helpIconTokens} tabIndex={0}>Help tooltip</Icon>
 *   </Tooltip>
 * </Row>
 * ```
 *
 * Alternatively you can wrap the disabled element in a non-disabled element to
 * ensure keyboard users can open the tooltip:
 *
 * ```
 * <Tooltip title="You can't perform this action, move along." position="right">
 *   <span tabIndex="0">
 *     <Button disabled={true}>Submit</Button>
 *   </span>
 * </Tooltip>
 * ```
 */ var Tooltip = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Tooltip, _React$Component);
    var _super = _createSuper(Tooltip);
    function Tooltip() {
        var _this;
        (0, _classCallCheck2["default"])(this, Tooltip);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            hover: false,
            focus: false
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOpen", function() {
            return _this.props.open === undefined ? _this.state.hover || _this.state.focus : _this.props.open;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorNode", function(node) {
            if (node && node !== _this.anchorNode) {
                /* eslint-disable-next-line react/no-find-dom-node */ _this.anchorNode = _reactDom["default"].findDOMNode(node); // If the Tooltip is managing state internally then bind the event
                // listeners that trigger internal state changes
                if (_this.props.open === undefined) _this.addEventListeners();
                 // If the Tooltip is supposed to be open then force an update so it
                // re-renders with the anchor node
                if (_this.isOpen()) _this.forceUpdate();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addEventListeners", function() {
            // Remove any existing event listeners to ensure we don't accidentally stack
            // multiple listeners
            _this.removeEventListeners();
            if (_this.anchorNode) {
                _this.anchorNode.addEventListener("mouseenter", _this.onMouseEnterAnchor); // NOTE: This *must* be bound using a native event listener because of a bug
                // in React: https://github.com/facebook/react/issues/4251
                _this.anchorNode.addEventListener("mouseleave", _this.onMouseLeaveAnchor);
                _this.anchorNode.addEventListener("focus", _this.onFocusAnchor, true);
                _this.anchorNode.addEventListener("blur", _this.onBlurAnchor, true);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeEventListeners", function() {
            if (_this.anchorNode) {
                _this.anchorNode.removeEventListener("mouseenter", _this.onMouseEnterAnchor);
                _this.anchorNode.removeEventListener("mouseleave", _this.onMouseLeaveAnchor);
                _this.anchorNode.removeEventListener("focus", _this.onFocusAnchor, true);
                _this.anchorNode.removeEventListener("blur", _this.onBlurAnchor, true);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterAnchor", function() {
            return _this.setState({
                hover: true
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveAnchor", function() {
            return _this.setState({
                hover: false,
                focus: false
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusAnchor", function() {
            return _this.setState({
                focus: true
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurAnchor", function() {
            return _this.setState({
                focus: false
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(Tooltip, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // If we're moving from state being managed via the `open` prop to state
                // being managed internally, bind the event listeners that trigger internal
                // state changes
                if (prevProps.open === undefined && this.props.open !== undefined) this.addEventListeners();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, title = _this$props.title, position = _this$props.position, maxWidth = _this$props.maxWidth, children = _this$props.children;
                var anchorNode = this.anchorNode;
                var oppositePosition = (0, _utils.flipAlignment)(position);
                var vertical = position === "top" || position === "bottom";
                var popover = /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _popover["default"],
                    map: (0, _token.getTokenHelper)("popover"),
                    key: "popover"
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_popoverController["default"], {
                        open: _this2.isOpen(),
                        anchorNode: anchorNode,
                        anchorOrigin: vertical ? "".concat(position, " center") : "center ".concat(position),
                        popoverOrigin: vertical ? "".concat(oppositePosition, " center") : "center ".concat(oppositePosition),
                        offsetVertical: vertical ? t("offsetWithArrow") : 0,
                        offsetHorizontal: vertical ? 0 : t("offsetWithArrow")
                    }, function(_ref) {
                        var popoverStyle = _ref.popoverStyle, popoverOrigin = _ref.popoverOrigin, anchorOrigin = _ref.anchorOrigin, anchorRect = _ref.anchorRect;
                        return /*#__PURE__*/ _react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({
                            style: popoverStyle,
                            type: "fill",
                            spacingInset: "small",
                            zIndex: _elevation.elevationTooltip,
                            className: styles(maxWidth)
                        }, _popoverBody["default"].generateArrowProps({
                            popoverOrigin: popoverOrigin,
                            anchorOrigin: anchorOrigin,
                            anchorRect: anchorRect
                        })), title);
                    });
                });
                var child = _react["default"].Children.only(children);
                return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].cloneElement(child, {
                    ref: this.updateAnchorNode
                }), popover);
            }
        }
    ]);
    return Tooltip;
}(_react["default"].Component);
Tooltip.propTypes = {};
Tooltip.defaultProps = {
    maxWidth: 300
};
var _default = Tooltip;
exports["default"] = _default;

},{"43492f1f0532697":"fk2Bw","c5adc3b9ebdb0f09":"ef0K4","2847d5cb1ccee150":"5Yd3f","713d6fc5844b25ab":"6Jptv","8067f98da76948e":"lMa5o","c0a52ddbf1eda5c5":"j4mqF","e32a80f23df42575":"krVd4","547e672d77fb7ca9":"8h5p9","7e6ac1146a6d7c84":"hcG56","28db329db9dd5387":"6uln9","29e0481639412a97":"b8T3j","1c75235a674bb388":"cnMFu","c5468e8b6086be77":"4deck","110d9add33b2a71a":"lnaFx","60f0a8fed6920fd5":"dKmTh","c06980e6f033b1d3":"eM9hO","107502f2666b1b0a":"3jot9","7a8e5a056320c6d1":"7BhWA","7f21ec0ab7e255ca":"6abrw","8021cce7632f4b97":"atHRo","801e54bcc3b2e3e2":"eKpY2"}],"3jot9":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("44eab8db6eb66f69");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _popoverBody = _interopRequireDefault(require("9ca9c086c935ff52"));
var _default = _popoverBody["default"];
exports["default"] = _default;

},{"44eab8db6eb66f69":"fk2Bw","9ca9c086c935ff52":"6niWk"}],"6niWk":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ca4012499de40579");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("ff492acf6a8f570f"));
var _react = _interopRequireDefault(require("3e3998b6f488adbd"));
var _propTypes = _interopRequireDefault(require("20a63c4757017902"));
var _capitalize = _interopRequireDefault(require("1d3f9a5cf7280970"));
var _emotion = require("4082984738f991dc");
var _popover = _interopRequireDefault(require("66b333dc51bac420"));
var _elevation = require("d29125100232aaba");
var _theme = require("e2a7e4c776280514");
var _utils = require("ac8227fc5d8ba462");
var _token = require("77b4555c9461809a");
var _cxMemoized = _interopRequireDefault(require("94fcbe36a3218d7b"));
var _text = _interopRequireDefault(require("351895f3293c955d"));
var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]), popoverArrowWidth = _getUnthemedTokens.popoverArrowWidth; // Takes an edge (e.g. "top") and turns it into a CSS border property (e.g.
// "borderTop").
var edgeToBorder = function edgeToBorder(edge) {
    return "border".concat((0, _capitalize["default"])(edge));
}; // Takes an edge (e.g. "top") and a CSS length (e.g. "5px") and creates a
// CSS translation function (e.g. "translateY(5px)") that can be added to an
// element  via the CSS "transform" property.
var edgeToTransform = function edgeToTransform(edge, amount) {
    return "translate".concat(edge === "left" || edge === "right" ? "X" : "Y", "(").concat(amount, ")");
}; // These styles are used to create the little arrow that points away from the
// popover. The method used to create the triangles involves psuedo elements
// with different transparent borders applied to certain sides. A good demo of
// this method can be found here: https://codepen.io/chriscoyier/pen/lotjh. The
// benefit of this method is that it doesn't require any images, but the
// downside is that you can't apply a border to the triangle. To get around
// this a border is faked by placing a slightly offset background-colored
// triangle (the :after pseudo element) on top of a border-colored triangle (the
// :before pseudo element).
var arrowStyles = function arrowStyles(t, _ref) {
    var _afterBefore, _before, _after;
    var type = _ref.type, arrowPosition = _ref.arrowPosition, arrowAlignment = _ref.arrowAlignment, arrowOffset = _ref.arrowOffset;
    var backgroundColor = t("backgroundColor", type);
    var borderColor = t("borderColor", type);
    var borderWidth = t("borderWidth");
    var arrowHeight = t("arrowHeight");
    var arrowWidthHalf = t("arrowWidth") / 2; // This is the edge of the popover (either "top" or "left") that is parallel
    // to the direction the arrow is pointing.
    var arrowParallelEdge = arrowPosition === "top" || arrowPosition === "bottom" ? "left" : "top"; // This is the edge of the popover that is opposite the edge that the arrow
    // is positioned on.
    var arrowOppositeEdge = (0, _utils.flipAlignment)(arrowPosition); // This uses maths to determine how far we have to scoot the fill triangle
    // along its axis to reveal exactly `borderWidth` pixels of the border
    // triangle along a line that is perpendicular to the edges of both triangles.
    var fillTriangleOffset = borderWidth / Math.sin(Math.atan(arrowWidthHalf / arrowHeight)); // This translates the arrow in the direction orthogonal to the direction that
    // the arrow is pointing (i.e. left/right for an arrow pointing up/down or
    // up/down for an arrow pointing left/right).
    var orthogonalTransform = ({
        top: [
            "".concat(arrowOffset, "px")
        ],
        left: [
            "".concat(arrowOffset, "px")
        ],
        right: [
            "-".concat(arrowOffset, "px"),
            "-100%"
        ],
        bottom: [
            "-".concat(arrowOffset, "px"),
            "-100%"
        ],
        center: [
            "".concat(arrowOffset, "px"),
            "-50%"
        ]
    })[arrowAlignment].map(function(amount) {
        return edgeToTransform(arrowParallelEdge, amount);
    }).join(" ");
    return (0, _emotion.css)({
        "&:after, &:before": (_afterBefore = {
            content: "''",
            position: "absolute",
            height: 0,
            width: 0
        }, (0, _defineProperty2["default"])(_afterBefore, arrowOppositeEdge, "100%"), (0, _defineProperty2["default"])(_afterBefore, arrowParallelEdge, {
            top: 0,
            left: 0,
            right: "100%",
            bottom: "100%",
            center: "50%"
        }[arrowAlignment]), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder(arrowParallelEdge), "".concat(arrowWidthHalf, "px solid transparent")), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder((0, _utils.flipAlignment)(arrowParallelEdge)), "".concat(arrowWidthHalf, "px solid transparent")), _afterBefore),
        // This creates a triangle with a background color that is the same color as
        // the popover's border.
        "&:before": (_before = {}, (0, _defineProperty2["default"])(_before, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(borderColor)), (0, _defineProperty2["default"])(_before, "transform", orthogonalTransform), _before),
        // If the popover has a border then this creates a triangle that is the same
        // color as the popover's background color. This triangle is displayed on
        // top of the border colored triangle but is scooted back just a bit to
        // reveal enough of the border triangle to create a faux border around
        // itself.
        "&:after": (_after = {}, (0, _defineProperty2["default"])(_after, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(backgroundColor)), (0, _defineProperty2["default"])(_after, "transform", "".concat(orthogonalTransform, " ").concat(edgeToTransform(arrowOppositeEdge, "".concat(arrowOppositeEdge === "top" || arrowOppositeEdge === "left" ? "-" : "").concat(fillTriangleOffset, "px")))), _after)
    });
};
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var type = _ref2.type, spacingInset = _ref2.spacingInset, zIndex = _ref2.zIndex, minWidth = _ref2.minWidth, maxWidth = _ref2.maxWidth, arrowPosition = _ref2.arrowPosition, arrowAlignment = _ref2.arrowAlignment, arrowOffset = _ref2.arrowOffset, allowOverflow = _ref2.allowOverflow;
    var borderColor = t("borderColor", type);
    return (0, _emotion.css)((0, _text["default"])(t, {
        color: type
    }), {
        display: "inline-block",
        position: "relative",
        outline: "none",
        zIndex: zIndex,
        minWidth: minWidth,
        maxWidth: maxWidth,
        // Children wrapper styles
        "& > div": {
            // If this is used with the PopoverController component then a max
            // width and height will be set on the outer element of this
            // component. Setting the max width and height to "inherit" here will
            // constrain this inner element to the same width/height as its parent
            // (oddly enough max width/height "100%" won't work because CSS). This
            // ensures that scrollbars will be shown for content that overflows.
            // Without these styles this element just extends outside of its
            // parent.
            maxHeight: allowOverflow ? "inherit" : undefined,
            maxWidth: allowOverflow ? "inherit" : undefined,
            overflow: allowOverflow ? "auto" : "hidden",
            padding: "".concat(t("spacingInsetVertical", spacingInset), "px ").concat(t("spacingInsetHorizontal", spacingInset), "px"),
            backgroundColor: t("backgroundColor", type),
            borderColor: borderColor,
            borderWidth: borderColor ? t("borderWidth") : undefined,
            borderStyle: borderColor ? "solid" : undefined,
            borderRadius: t("borderRadius"),
            boxShadow: t.boxShadowCss("dropShadow")
        }
    }, arrowPosition ? arrowStyles(t, {
        type: type,
        arrowPosition: arrowPosition,
        arrowAlignment: arrowAlignment,
        arrowOffset: arrowOffset
    }) : undefined);
}, [
    "type",
    "spacingInset",
    "zIndex",
    "maxWidth",
    "minWidth",
    "arrowPosition",
    "arrowAlignment",
    "arrowOffset",
    "allowOverflow"
]);
var PopoverBody = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_popover["default"], "popover");
    return /*#__PURE__*/ _react["default"].createElement("div", {
        onKeyDown: props.onKeyDown,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        tabIndex: props.tabIndex,
        style: props.style,
        className: (0, _cxMemoized["default"])(styles(t, props), props.className),
        role: props.tabIndex ? "dialog" : "tooltip",
        "aria-labelledby": props.labelledById,
        "aria-expanded": props.open,
        ref: ref
    }, /*#__PURE__*/ _react["default"].createElement("div", null, props.children));
}); // This helper generates the arrow props that are necessary to point a popover
// arrow at a particular anchor
PopoverBody.generateArrowProps = function(_ref3) {
    var popoverOrigin = _ref3.popoverOrigin, anchorOrigin = _ref3.anchorOrigin, anchorRect = _ref3.anchorRect;
    var vertical = popoverOrigin.y !== anchorOrigin.y && popoverOrigin.y === (0, _utils.flipAlignment)(anchorOrigin.y);
    var arrowAlignment = vertical ? popoverOrigin.x : popoverOrigin.y;
    return {
        arrowAlignment: arrowAlignment,
        arrowPosition: vertical ? popoverOrigin.y : popoverOrigin.x,
        arrowOffset: arrowAlignment !== "center" ? anchorRect[vertical ? "width" : "height"] / 2 - popoverArrowWidth / 2 : 0
    };
};
PopoverBody.displayName = "PopoverBody";
PopoverBody.propTypes = {};
PopoverBody.defaultProps = {
    open: true,
    type: "outline",
    arrowAlignment: "center",
    arrowOffset: 0,
    spacingInset: "small",
    zIndex: _elevation.elevationPopover
};
var _default = PopoverBody;
exports["default"] = _default;

},{"ca4012499de40579":"fk2Bw","ff492acf6a8f570f":"hcG56","3e3998b6f488adbd":"6uln9","20a63c4757017902":"cnMFu","1d3f9a5cf7280970":"lvFD8","4082984738f991dc":"4deck","66b333dc51bac420":"lnaFx","d29125100232aaba":"dKmTh","e2a7e4c776280514":"eM9hO","ac8227fc5d8ba462":"6abrw","77b4555c9461809a":"atHRo","94fcbe36a3218d7b":"6U7id","351895f3293c955d":"13UMz"}],"lvFD8":[function(require,module,exports) {
var toString = require("2b09f4d102ed04fc"), upperFirst = require("620b1b2d5d63bc78");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize(string) {
    return upperFirst(toString(string).toLowerCase());
}
module.exports = capitalize;

},{"2b09f4d102ed04fc":"bI8Cb","620b1b2d5d63bc78":"48IWu"}],"48IWu":[function(require,module,exports) {
var createCaseFirst = require("30872ecb4f40e1a5");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst("toUpperCase");
module.exports = upperFirst;

},{"30872ecb4f40e1a5":"gsqxL"}],"gsqxL":[function(require,module,exports) {
var castSlice = require("762a43400be65374"), hasUnicode = require("3079e5dc829ece4e"), stringToArray = require("4e89b19d56851f70"), toString = require("e6ab773a8070b58");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"762a43400be65374":"754uC","3079e5dc829ece4e":"5soAp","4e89b19d56851f70":"8iq3G","e6ab773a8070b58":"bI8Cb"}],"754uC":[function(require,module,exports) {
var baseSlice = require("bb37b621626e6b03");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"bb37b621626e6b03":"7vBlY"}],"7vBlY":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"5soAp":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"8iq3G":[function(require,module,exports) {
var asciiToArray = require("40be605d845fe613"), hasUnicode = require("f8da0f974bd4ed9c"), unicodeToArray = require("9e57f17ea24db76");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"40be605d845fe613":"i9gId","f8da0f974bd4ed9c":"5soAp","9e57f17ea24db76":"8a31J"}],"i9gId":[function(require,module,exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split("");
}
module.exports = asciiToArray;

},{}],"8a31J":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"bvCa6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("9e4f2c6658f4798");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("62a8ec9f56cd1f3f"));
var _modal = _interopRequireDefault(require("3e6cca61b71f48e9"));
var _column = _interopRequireDefault(require("e62dbe798bca2b34"));
var _text = _interopRequireDefault(require("2788f1624e1eda21"));
var _divider = _interopRequireDefault(require("b7913e59dcd14ade"));
var _propTypes = _interopRequireDefault(require("d524bfed1c5512ab"));
var _FeedbackConstants = require("7f5e46593afb8d66");
var _RequiredQuestionTypeComponentList = _interopRequireDefault(require("4147945a368059f4"));
var _SkippableFooter = _interopRequireDefault(require("903685308062039f"));
var _NonSkippableFooter = _interopRequireDefault(require("b5dd55845d370a81"));
var TriggeredFeedback = function TriggeredFeedback(_ref) {
    var open = _ref.open, isDisabled = _ref.isDisabled, onClose = _ref.onClose, onClickFooterButton = _ref.onClickFooterButton, title = _ref.title, description = _ref.description, questions = _ref.questions, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText, isSkippable = _ref.isSkippable, prePopulate = _ref.prePopulate;
    return /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/ _react["default"].createElement(_modal["default"], {
        title: title,
        open: open,
        scrollContainer: "viewport",
        closeLabel: "Close",
        describedById: "modal-description",
        width: "700px"
    }, /*#__PURE__*/ _react["default"].createElement(_column["default"], {
        spacingInset: "medium"
    }, /*#__PURE__*/ _react["default"].createElement(_text["default"], {
        id: "modal-description"
    }, description), /*#__PURE__*/ _react["default"].createElement(_divider["default"], {
        size: "small"
    }), /*#__PURE__*/ _react["default"].createElement(_RequiredQuestionTypeComponentList["default"], {
        questions: questions,
        prePopulate: prePopulate
    })), /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, null, isSkippable ? /*#__PURE__*/ _react["default"].createElement(_SkippableFooter["default"], {
        onClose: onClose,
        isDisabled: isDisabled,
        onClickFooterButton: onClickFooterButton,
        submitButtonSize: submitButtonSize,
        submitButtonText: submitButtonText,
        submitButtonType: submitButtonType
    }) : /*#__PURE__*/ _react["default"].createElement(_NonSkippableFooter["default"], {
        isDisabled: isDisabled,
        onClickFooterButton: onClickFooterButton,
        submitButtonSize: submitButtonSize,
        submitButtonText: submitButtonText,
        submitButtonType: submitButtonType
    }))));
};
TriggeredFeedback.propTypes = {
    open: _propTypes["default"].bool.isRequired,
    isDisabled: _propTypes["default"].bool.isRequired,
    onClose: _propTypes["default"].func.isRequired,
    onClickFooterButton: _propTypes["default"].func.isRequired,
    questions: _propTypes["default"].array.isRequired,
    title: _propTypes["default"].string,
    description: _propTypes["default"].string,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string,
    isSkippable: _propTypes["default"].bool,
    prePopulate: _propTypes["default"].object.isRequired
};
TriggeredFeedback.defaultProps = {
    title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
    description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text,
    isSkippable: true
};
var _default = exports["default"] = TriggeredFeedback;

},{"9e4f2c6658f4798":"bm29M","62a8ec9f56cd1f3f":"6uln9","3e6cca61b71f48e9":"bUAK2","e62dbe798bca2b34":"eInK6","2788f1624e1eda21":"6kD7p","b7913e59dcd14ade":"bON9z","d524bfed1c5512ab":"gJRKl","7f5e46593afb8d66":"filWO","4147945a368059f4":"dM4Li","903685308062039f":"4yHvs","b5dd55845d370a81":"k5FHG"}],"4yHvs":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("43e9c4856cd22f27");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("609c642382776ea8"));
var _modal = require("ba5a7b22eff38932");
var _link = _interopRequireDefault(require("76a439c52532b3ba"));
var _row = _interopRequireDefault(require("aa34c958f28cb33"));
var _column = _interopRequireDefault(require("18d9d09fd64e5b58"));
var _text = _interopRequireDefault(require("7111f2953c6f12c1"));
var _button = _interopRequireDefault(require("6e70351913d1378c"));
var _propTypes = _interopRequireDefault(require("bf60d769a56227f2"));
var _ButtonWithToolTip = _interopRequireDefault(require("edabd7da9d1f1d77"));
var _FeedbackConstants = require("e7d91cc3fdf510dc");
var SkippableFooter = function SkippableFooter(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled, onClickFooterButton = _ref.onClickFooterButton, submitButtonSize = _ref.submitButtonSize, submitButtonType = _ref.submitButtonType, submitButtonText = _ref.submitButtonText;
    return /*#__PURE__*/ _react["default"].createElement(_modal.ModalFooter, null, /*#__PURE__*/ _react["default"].createElement(_row["default"], {
        spacingInset: "medium",
        width: "100%",
        widths: [
            "grid-1",
            "grid-9",
            "grid-2"
        ]
    }, /*#__PURE__*/ _react["default"].createElement(_link["default"], {
        onClick: onClose
    }, /*#__PURE__*/ _react["default"].createElement(_text["default"], {
        type: "d50"
    }, _FeedbackConstants.FEEDBACK_LINKS.skip)), /*#__PURE__*/ _react["default"].createElement(_column["default"], null), isDisabled ? /*#__PURE__*/ _react["default"].createElement(_ButtonWithToolTip["default"], {
        onClickFooterButton: onClickFooterButton,
        title: _FeedbackConstants.REQUIRED_QUESTION_TITLE,
        submitButtonSize: submitButtonSize,
        submitButtonType: submitButtonType,
        submitButtonText: submitButtonText
    }) : /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: submitButtonType,
        size: submitButtonSize,
        onClick: onClickFooterButton
    }, submitButtonText)));
};
SkippableFooter.propTypes = {
    onClose: _propTypes["default"].func.isRequired,
    isDisabled: _propTypes["default"].bool.isRequired,
    onClickFooterButton: _propTypes["default"].func.isRequired,
    submitButtonSize: _propTypes["default"].string,
    submitButtonType: _propTypes["default"].string,
    submitButtonText: _propTypes["default"].string
};
SkippableFooter.defaultProps = {
    submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
    submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
    submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text
};
var _default = exports["default"] = SkippableFooter;

},{"43e9c4856cd22f27":"bm29M","609c642382776ea8":"6uln9","ba5a7b22eff38932":"bUAK2","76a439c52532b3ba":"cShWQ","aa34c958f28cb33":"gNI9h","18d9d09fd64e5b58":"eInK6","7111f2953c6f12c1":"6kD7p","6e70351913d1378c":"gJQuD","bf60d769a56227f2":"gJRKl","edabd7da9d1f1d77":"fPm1z","e7d91cc3fdf510dc":"filWO"}],"cShWQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("468b03da0cac4608");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _link = _interopRequireDefault(require("72a257ad049d432e"));
var _default = _link["default"];
exports["default"] = _default;

},{"468b03da0cac4608":"fk2Bw","72a257ad049d432e":"8UmFN"}],"8UmFN":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8922436fddfe08d9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("4bdd2f8955878e6b"));
var _react = _interopRequireDefault(require("400b88ad3c728486"));
var _propTypes = _interopRequireDefault(require("f4fa7d0611313d6e"));
var _theme = require("257833911fd7484f");
var _clickable = _interopRequireDefault(require("b7d68464a2465279"));
var _useFocus2 = _interopRequireDefault(require("6c70fbdf2338f6ab"));
var _emotion = require("7d34784f34429772");
var _getTextStyles = _interopRequireDefault(require("81403f07a64df1f4"));
var _link = _interopRequireDefault(require("ffc5c8d5cd327609"));
var _text = _interopRequireDefault(require("b073e9b12bacbc7a"));
var _focusRing = _interopRequireDefault(require("22c2320e47764c91"));
var _token = require("e241b0ce557557e5");
var _filterPropsByPrefix = _interopRequireDefault(require("763d895f05fdd82b"));
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var type = _ref.type, focus = _ref.focus, disabled = _ref.disabled;
    var _focusRingTokens = (0, _focusRing["default"])(t.tokens), focusRingWidth = _focusRingTokens.focusRingWidth, focusRingColorFocus = _focusRingTokens.focusRingColorFocus;
    return (0, _emotion.css)({
        display: "inline",
        // HACK: Use !important to override the color set by the text styles
        color: "".concat(t("foregroundColor", disabled ? "disabled" : "default"), " !important"),
        textDecoration: type === "primary" ? "underline" : "none",
        transition: t.transitionCss("motion", "color"),
        // Use custom focus rings styles that will work even if the link wraps
        // across multiple lines.
        // NOTE: IE11 doesn't support outline-offset so the focus ring will
        // be tighter in that browser. The alternative would be to use our
        // previous multiple-box-shadow approach, but that has other issues
        // because it has to make an assumption about the background color
        // behind the link.
        outline: focus ? "".concat(focusRingWidth, "px solid ").concat(focusRingColorFocus) : undefined,
        outlineOffset: 2,
        ":hover": !disabled && {
            color: "".concat(t("foregroundColorHover"), " !important"),
            textDecoration: type === "secondary" ? "underline" : undefined
        },
        ":active": !disabled && {
            color: "".concat(t("foregroundColorPressed"), " !important")
        }
    }, (0, _getTextStyles["default"])((0, _token.getTokenHelper)("text")((0, _text["default"])(t.tokens)), {}));
}, [
    "type",
    "focus",
    "disabled"
]);
var Link = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_link["default"], "link");
    var _useFocus = (0, _useFocus2["default"])(), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
        "data-"
    ]);
    return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, passThroughProps, {
        className: styles(t, {
            type: props.type,
            disabled: props.disabled,
            focus: focus && focusTrigger === "keyboard"
        }),
        target: props.target,
        rel: props.rel,
        disabled: props.disabled,
        href: props.href,
        onClick: props.onClick,
        tabIndex: props.tabIndex,
        download: props.download,
        propagateClickEvent: props.propagateClickEvent,
        tag: "a",
        ref: ref
    }), props.children);
});
Link.displayName = "Link";
Link.propTypes = {};
Link.defaultProps = {
    type: "primary"
};
var _default = Link;
exports["default"] = _default;

},{"8922436fddfe08d9":"fk2Bw","4bdd2f8955878e6b":"ef0K4","400b88ad3c728486":"6uln9","f4fa7d0611313d6e":"cnMFu","257833911fd7484f":"eM9hO","b7d68464a2465279":"iia1p","6c70fbdf2338f6ab":"ZdEsX","7d34784f34429772":"4deck","81403f07a64df1f4":"2xZE6","ffc5c8d5cd327609":"9NJp1","b073e9b12bacbc7a":"9Sdvg","22c2320e47764c91":"dixtu","e241b0ce557557e5":"atHRo","763d895f05fdd82b":"8cR2N"}],"9NJp1":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        linkForegroundColorDefault: tokens.themeForegroundAccentDefault,
        linkForegroundColorHover: tokens.themeForegroundAccentHover,
        linkForegroundColorPressed: tokens.themeForegroundAccentPressed,
        linkForegroundColorDisabled: tokens.themeBorderAccentDisabled,
        linkMotionDuration: "100ms",
        linkMotionFunction: "ease"
    };
};

},{}],"78qJ0":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3dc5e601e3a51bb5");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _QuestionTypes = _interopRequireDefault(require("235a496189fd8230"));
var createUserResponseObject = function createUserResponseObject(response, questions, timeTakenToRespond, feedbackSubmissionPageIdentifier, userId) {
    // function for creating response object corresponding to each question
    function createResponse(_ref) {
        var questionId = _ref.questionId, questionType = _ref.questionType;
        // filter out the response for the current question
        var answer = response.answers.filter(function(_ref2) {
            var id = _ref2.id;
            return questionId === id;
        });
        // based on the type of question userResponse is created
        var userResponse;
        switch(Object.keys(questionType)[0]){
            case _QuestionTypes["default"].MULTIPLE_CHOICE_QUESTION:
                userResponse = {
                    multipleChoiceQuestionTypeResponse: {
                        multipleChoiceQuestionResponse: answer[0].answer
                    }
                };
                break;
            case _QuestionTypes["default"].RATING_QUESTION:
                userResponse = {
                    ratingQuestionTypeResponse: {
                        ratingQuestionResponse: answer[0].answer
                    }
                };
                break;
            case _QuestionTypes["default"].TEXT_QUESTION:
                userResponse = {
                    textQuestionTypeResponse: {
                        textQuestionResponse: answer[0].answer
                    }
                };
                break;
            default:
                break;
        }
        return userResponse;
    }
    // For each question create an acknowledgement which includes question and its corresponding response object.
    var acknowledgements = questions.map(function(question) {
        return {
            question: question,
            response: createResponse(question) // creating response object
        };
    });
    // responseObject that will be stored in the backend
    var userResponseObject = {
        userFeedback: {
            metaData: {
                isAnonymous: false,
                // TODO: remove this flag.
                responseTimestamp: new Date(Date.now()).toISOString(),
                // current timestamp when the response is recorded.
                responseCollectionDurationInMilliSecond: timeTakenToRespond,
                // time taken by user to respond.
                // identifier of the page on which user was when feedback was submitted. It can be a string or a callback
                // function
                feedbackSubmissionPageIdentifier: typeof feedbackSubmissionPageIdentifier === "function" ? feedbackSubmissionPageIdentifier() : feedbackSubmissionPageIdentifier,
                userId: userId
            },
            acknowledgements: acknowledgements
        }
    };
    return userResponseObject;
};
var _default = exports["default"] = createUserResponseObject;

},{"3dc5e601e3a51bb5":"bm29M","235a496189fd8230":"jpUxc"}],"aVE3y":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("38c40c504e20dbe7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("672d49e1f13bc8ab"));
var _react = require("314941aaa6c97ff5");
var _uuid = _interopRequireDefault(require("9cceaa72abb573e"));
var _ui = require("79b8046b3e14a4e6");
var _UIState = _interopRequireDefault(require("ed8cd9fb8d86b922"));
/**
 * Hook for notification
 *
 * @returns {{ toasts: { id: string, timeout: number }, onCloseToast: (id: string) => undefined }}
 */ var useNotification = function useNotification() {
    var _useState = (0, _react.useState)([]), _useState2 = (0, _slicedToArray2["default"])(_useState, 2), toasts = _useState2[0], setToasts = _useState2[1];
    var _useContext = (0, _react.useContext)(_UIState["default"]), _useContext$state = _useContext.state, isSuccessNotificationShown = _useContext$state.isSuccessNotificationShown, isFailureNotificationShown = _useContext$state.isFailureNotificationShown, isGetQuestionsInProgress = _useContext$state.isGetQuestionsInProgress, isSubmitInProgress = _useContext$state.isSubmitInProgress, isSurveyEnabled = _useContext$state.isSurveyEnabled, isSurveySubmitted = _useContext$state.isSurveySubmitted, dispatch = _useContext.dispatch;
    // Action Handlers
    var hideNotification = (0, _react.useCallback)(function() {
        var action = (0, _ui.hideSuccessNotification)();
        dispatch(action);
    }, []);
    // Open and Close toasts
    var onOpenToast = (0, _react.useCallback)(function(config) {
        var type = config.type, message = config.message;
        var uid = _uuid["default"].v4();
        setToasts(toasts.concat({
            id: "".concat(uid),
            timeout: 3000,
            type: type,
            message: message
        }));
    }, [
        toasts,
        setToasts
    ]);
    var onCloseToast = (0, _react.useCallback)(function(id) {
        setToasts(toasts.filter(function(t) {
            return t.id !== id;
        }));
        hideNotification();
    }, [
        toasts
    ]);
    // Effects
    (0, _react.useEffect)(function() {
        if (isSuccessNotificationShown) onOpenToast({
            type: "success",
            message: "feedback.notifications.submit_success"
        });
        if (isFailureNotificationShown) onOpenToast({
            type: "error",
            message: "dev_app.error"
        });
    }, [
        isSuccessNotificationShown,
        isFailureNotificationShown
    ]);
    return {
        toasts: toasts,
        onCloseToast: onCloseToast,
        isGetQuestionsInProgress: isGetQuestionsInProgress,
        isSubmitInProgress: isSubmitInProgress,
        isSurveyEnabled: isSurveyEnabled,
        isSurveySubmitted: isSurveySubmitted
    };
};
var _default = exports["default"] = useNotification;

},{"38c40c504e20dbe7":"bm29M","672d49e1f13bc8ab":"8uMk6","314941aaa6c97ff5":"6uln9","9cceaa72abb573e":"4zigP","79b8046b3e14a4e6":"j53Ka","ed8cd9fb8d86b922":"VKPbn"}],"4zigP":[function(require,module,exports) {
var v1 = require("99edc97633d99ef4");
var v4 = require("183f89eeb3e97827");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"99edc97633d99ef4":"7ajKX","183f89eeb3e97827":"iRx4e"}],"7ajKX":[function(require,module,exports) {
var rng = require("dace327ee1b37b1c");
var bytesToUuid = require("a5875a0ada0c4407");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"dace327ee1b37b1c":"6Cedl","a5875a0ada0c4407":"amdbe"}],"6Cedl":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"amdbe":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"iRx4e":[function(require,module,exports) {
var rng = require("4e527bcdf3dcaa2");
var bytesToUuid = require("2f2f88b7a64da0cd");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"4e527bcdf3dcaa2":"6Cedl","2f2f88b7a64da0cd":"amdbe"}],"j53Ka":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showSuccessNotification = exports.showFailureNotification = exports.isSuverySubmitted = exports.isSurveyEnabled = exports.isSubmitInProgress = exports.isGetQuestionsInProgress = exports.hideSuccessNotification = void 0;
var _type = require("4a146aad56a67560");
var showSuccessNotification = exports.showSuccessNotification = function showSuccessNotification() {
    return {
        type: _type.SHOW_SUCCESS_NOTIFICATION
    };
};
var hideSuccessNotification = exports.hideSuccessNotification = function hideSuccessNotification() {
    return {
        type: _type.HIDE_SUCCESS_NOTIFICATION
    };
};
var showFailureNotification = exports.showFailureNotification = function showFailureNotification() {
    return {
        type: _type.SHOW_FAILURE_NOTIFICATION
    };
};
var isSubmitInProgress = exports.isSubmitInProgress = function isSubmitInProgress(payload) {
    return {
        type: _type.IS_SUBMIT_INPROGRESS,
        payload: payload
    };
};
var isSuverySubmitted = exports.isSuverySubmitted = function isSuverySubmitted(payload) {
    return {
        type: _type.IS_SURVEY_SUBMITTED,
        payload: payload
    };
};
var isGetQuestionsInProgress = exports.isGetQuestionsInProgress = function isGetQuestionsInProgress(payload) {
    return {
        type: _type.IS_GET_QUESTIONS_INPROGRESS,
        payload: payload
    };
};
var isSurveyEnabled = exports.isSurveyEnabled = function isSurveyEnabled(payload) {
    return {
        type: _type.IS_SURVEY_ENABLED,
        payload: payload
    };
};

},{"4a146aad56a67560":"hiJmi"}],"cslg4":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("81f78fa0f319e919");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
exports.isSiteExternal = isSiteExternal;
var _externalSiteConstants = require("a722854841c44c0f");
var _window = _interopRequireDefault(require("e2844997d749938b"));
function isSiteExternal() {
    var url = _window["default"].location.href;
    return url.includes(_externalSiteConstants.EXTERNAL_PASSPORT_APP_DOMAIN_NAME);
}
var _default = exports["default"] = isSiteExternal;

},{"81f78fa0f319e919":"bm29M","a722854841c44c0f":"aUJ7K","e2844997d749938b":"4crzt"}],"aUJ7K":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PARTNER_ACCOUNT_ID_SESSION = exports.PARTNER_ACCOUNT_ID_HEADER = exports.MONS_CUSTOMER_ID_SESSION = exports.MONS_CUSTOMER_ID_HEADER = exports.LPID_URL_QUERY = exports.EXTERNAL_PASSPORT_APP_DOMAIN_NAME = exports.CSRF_TOKEN_ID = void 0;
var EXTERNAL_PASSPORT_APP_DOMAIN_NAME = exports.EXTERNAL_PASSPORT_APP_DOMAIN_NAME = "carrierlogistics";
var MONS_CUSTOMER_ID_HEADER = exports.MONS_CUSTOMER_ID_HEADER = "_debug_amz-mons-customer";
var PARTNER_ACCOUNT_ID_HEADER = exports.PARTNER_ACCOUNT_ID_HEADER = "_debug_amz-mons-partner-account";
var MONS_CUSTOMER_ID_SESSION = exports.MONS_CUSTOMER_ID_SESSION = "monsCustomerId";
var PARTNER_ACCOUNT_ID_SESSION = exports.PARTNER_ACCOUNT_ID_SESSION = "partnerAccountId";
var LPID_URL_QUERY = exports.LPID_URL_QUERY = "mons_sel_dir_paid";
var CSRF_TOKEN_ID = exports.CSRF_TOKEN_ID = "anti-csrftoken-a2z";

},{}],"4crzt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _default = exports["default"] = window;

},{}],"gv7Md":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useInlineHelp = require("@amzn/carrier-logistics-inline-help-ui-assets/dist/hooks/useInlineHelp");
var _useInlineHelpDefault = parcelHelpers.interopDefault(_useInlineHelp);
var _help = require("@amzn/meridian-tokens/base/icon/help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("@amzn/meridian/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _symphonyPageMapping = require("../constants/symphonyPageMapping");
var _navigationalRoutes = require("../config/navigationalRoutes");
const InlineHelpModule = ()=>{
    const { openInlineHelpSheet } = (0, _useInlineHelpDefault.default)();
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const handleHelpIconClick = ()=>{
        // TODO: add all the pages routes which gets onboarded to inline help
        if ((0, _symphonyPageMapping.ROUTE_MAPPING)[pathname]) {
            if ((0, _navigationalRoutes.NPC_PATH) === pathname) {
                const npcStrategy = window.sessionStorage.getItem((0, _symphonyPageMapping.NPC_STRATEGY_KEY));
                const npcPageId = npcStrategy === (0, _symphonyPageMapping.NPC_DEFAULT_STRATEGY) ? (0, _symphonyPageMapping.ROUTE_MAPPING)[pathname] : `${(0, _symphonyPageMapping.ROUTE_MAPPING)[pathname]}-na`;
                openInlineHelpSheet(npcPageId);
            } else openInlineHelpSheet((0, _symphonyPageMapping.ROUTE_MAPPING)[pathname]);
        } else openInlineHelpSheet((0, _symphonyPageMapping.DEFAULT_PAGE));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        type: "icon",
        size: "small",
        label: "Help",
        onClick: handleHelpIconClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        tokens: (0, _helpDefault.default)
    }));
};
exports.default = InlineHelpModule;

},{"@amzn/carrier-logistics-inline-help-ui-assets/dist/hooks/useInlineHelp":"kqnal","@amzn/meridian-tokens/base/icon/help":"35wF0","@amzn/meridian/button":"k0QSK","@amzn/meridian/icon":"8MgRY","react":"6uln9","react-router-dom":"5fzqq","../constants/symphonyPageMapping":"bk9bn","../config/navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"35wF0":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconHelpData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' cx='12' cy='12' r='11'/%3e%3cpath d='M9.021 8.009c.464-1.175 1.722-1.99 2.99-2.008 1.74-.026 3.996.58 3.99 3.087-.006 2.854-4.073 2.89-4.045 5.367' stroke='currentColor' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='currentColor' fill-rule='nonzero' cx='12' cy='18.25' r='1.25'/%3e%3c/g%3e%3c/svg%3e",
    iconHelpWidth: 24,
    iconHelpHeight: 24
};

},{}],"bk9bn":[function(require,module,exports) {
/* eslint-disable import/prefer-default-export */ // page-route to page id mapping for Symphony
// Once all the page ids are on boarded, page id will be served from the backend
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROUTE_MAPPING", ()=>ROUTE_MAPPING);
parcelHelpers.export(exports, "DEFAULT_PAGE", ()=>DEFAULT_PAGE);
parcelHelpers.export(exports, "NPC_DEFAULT_STRATEGY", ()=>NPC_DEFAULT_STRATEGY);
parcelHelpers.export(exports, "NPC_STRATEGY_KEY", ()=>NPC_STRATEGY_KEY);
var _navigationalRoutes = require("../config/navigationalRoutes");
const ROUTE_MAPPING = {
    [(0, _navigationalRoutes.PARTNER_PICKER_PATH)]: "forecast-home",
    [(0, _navigationalRoutes.NPC_PATH)]: "npc-home",
    [(0, _navigationalRoutes.PERFORMANCE_INSIGHTS_PATH)]: "insights-home",
    [(0, _navigationalRoutes.PERFORMANCE_DASHBOARD_PATH)]: "dashboard-home",
    [(0, _navigationalRoutes.CASE_MANAGEMENT_PATH)]: "case-mgnt-home",
    [(0, _navigationalRoutes.CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH)]: "capacity-home",
    [(0, _navigationalRoutes.RUBIKS_PATH)]: "problem-solve-home"
};
const DEFAULT_PAGE = "home";
const NPC_DEFAULT_STRATEGY = "AMAZON_INITIATED";
const NPC_STRATEGY_KEY = "npcStrategy";

},{"../config/navigationalRoutes":"32s8M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2P2ct":[function(require,module,exports) {
/* eslint-disable no-nested-ternary */ /* eslint-disable react/no-children-prop */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _appConfig = require("@amzn/carrier-logistics-common-ui-assets/dist/constants/AppConfig");
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _loader = require("@amzn/meridian/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _responsive = require("@amzn/meridian/responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _select = require("@amzn/meridian/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _tag = require("@amzn/meridian/tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _tooltip = require("@amzn/meridian/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _withIntl = require("../../hoc/withIntl");
var _withIntlDefault = parcelHelpers.interopDefault(_withIntl);
var _useLpSelectActions = require("../../hooks/useLpSelectActions");
var _useLpSelectActionsDefault = parcelHelpers.interopDefault(_useLpSelectActions);
var _notFoundSvg = require("../../images/not-found.svg");
var _notFoundSvgDefault = parcelHelpers.interopDefault(_notFoundSvg);
var _selectOptionGroup = require("../commons/SelectOptionGroup");
var _selectOptionGroupDefault = parcelHelpers.interopDefault(_selectOptionGroup);
const LpDropdown = ()=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const { lpData, lpIdSelected, setLpSelected, searchQuery, setSearchQuery, dspData } = (0, _useLpSelectActionsDefault.default)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveDefault.default), {
        query: "min-width",
        props: {
            width: {
                default: 180,
                [(0, _breakpoints.DEVICE_WIDTHS).DESKTOP]: 300
            }
        }
    }, ({ width })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectDefault.default), {
            placeholder: formatMessage({
                id: "top_bar.select_lp"
            }),
            width: width,
            popoverMaxHeight: 400,
            value: lpIdSelected,
            onChange: setLpSelected,
            id: "lpSelect",
            searchQuery: searchQuery,
            onSearch: setSearchQuery
        }, lpData?.length === 0 && dspData?.length === 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.SelectOption), {
            label: "",
            disabled: true,
            children: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), {
                    alignmentHorizontal: "center"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
                    src: (0, _notFoundSvgDefault.default),
                    alt: formatMessage({
                        id: "lp_dropdown.not_found"
                    })
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
                    id: "lp_dropdown.not_found"
                })))
        }), lpData?.length > 0 && [
            (0, _selectOptionGroupDefault.default)({
                label: "service_provider_type.lp"
            }),
            ...lpData?.map(({ directedLpId, logisticsPartyDisplayName })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.SelectOption), {
                    value: directedLpId,
                    key: directedLpId,
                    label: logisticsPartyDisplayName,
                    children: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, logisticsPartyDisplayName))
                }))
        ], dspData?.length > 0 && [
            (0, _selectOptionGroupDefault.default)({
                label: "service_provider_type.dsp"
            }),
            ...dspData?.map(({ directedLpId, logisticsPartyDisplayName, serviceProviderIdentifierType })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.SelectOption), {
                    value: directedLpId,
                    key: directedLpId,
                    label: logisticsPartyDisplayName,
                    children: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
                            alignmentHorizontal: "justify"
                        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, logisticsPartyDisplayName), (0, _appConfig.SERVICE_PROVIDER_TAGS)[serviceProviderIdentifierType] && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
                            position: "top",
                            title: formatMessage({
                                id: (0, _appConfig.SERVICE_PROVIDER_TAGS)[serviceProviderIdentifierType].tooltip
                            })
                        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tagDefault.default), null)))
                }))
        ], ((0, _lodash.isNull)(lpData) || (0, _lodash.isNull)(dspData)) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.SelectOption), {
            label: "",
            disabled: true,
            children: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
                    alignmentHorizontal: "center",
                    minHeight: "100px"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loaderDefault.default), {
                    type: "circular",
                    size: "medium",
                    "data-testid": "lp-loader"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
                    id: "top_bar.loading_lps"
                })))
        }))));
};
exports.default = (0, _withIntlDefault.default)(LpDropdown);

},{"@amzn/carrier-logistics-common-ui-assets/dist/constants/AppConfig":"l3M8u","@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/meridian/column":"jFRKf","@amzn/meridian/loader":"1Ez7s","@amzn/meridian/responsive":"l7U3k","@amzn/meridian/row":"ba4AQ","@amzn/meridian/select":"iCetS","@amzn/meridian/tag":"hwkgx","@amzn/meridian/text":"hj2bM","@amzn/meridian/tooltip":"6eaDA","lodash":"3hMBK","react":"6uln9","react-intl":"4kbQW","../../hoc/withIntl":"7tU2V","../../hooks/useLpSelectActions":"haNx6","../../images/not-found.svg":"lohWh","../commons/SelectOptionGroup":"72M2v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l3M8u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MONS_DIRECTOR_ID_QUERY_PARAM", ()=>MONS_DIRECTOR_ID_QUERY_PARAM);
parcelHelpers.export(exports, "MONS_RETURN_TO_URL_KEY", ()=>MONS_RETURN_TO_URL_KEY);
parcelHelpers.export(exports, "REQUEST_PERMISSIONS_PAGE", ()=>REQUEST_PERMISSIONS_PAGE);
parcelHelpers.export(exports, "SERVICE_PROVIDER_MAPPING", ()=>SERVICE_PROVIDER_MAPPING);
parcelHelpers.export(exports, "SERVICE_PROVIDER_OPTIONS", ()=>SERVICE_PROVIDER_OPTIONS);
parcelHelpers.export(exports, "SERVICE_PROVIDER_TAGS", ()=>SERVICE_PROVIDER_TAGS);
var _coralComAmazonCarrierlogisticswebserverModel = require("@amzn/coral_com-amazon-carrierlogisticswebserver-model");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var MONS_DIRECTOR_ID_QUERY_PARAM = "mons_sel_dir_paid";
var MONS_RETURN_TO_URL_KEY = "returnTo";
var REQUEST_PERMISSIONS_PAGE = "/request/permissions";
var _obj;
var SERVICE_PROVIDER_MAPPING = (_obj = {
    all: "service_provider_options.all"
}, _define_property(_obj, (0, _coralComAmazonCarrierlogisticswebserverModel.ServiceProviderIdentifierType).LOGISTICS_PARTY_ID, "service_provider_options.lp"), _define_property(_obj, (0, _coralComAmazonCarrierlogisticswebserverModel.ServiceProviderIdentifierType).DSP_COMPANY_ID, "service_provider_options.dsp"), _obj);
var SERVICE_PROVIDER_OPTIONS = Object.keys(SERVICE_PROVIDER_MAPPING);
var SERVICE_PROVIDER_TAGS = _define_property({}, (0, _coralComAmazonCarrierlogisticswebserverModel.ServiceProviderIdentifierType).DSP_COMPANY_ID, {
    theme: "warning",
    id: "DSP",
    tooltip: "service_provider_options.dsp"
});

},{"@amzn/coral_com-amazon-carrierlogisticswebserver-model":"e8xZv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCetS":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a217376e6d0bcf9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SelectOption", {
    enumerable: true,
    get: function get() {
        return _selectOption["default"];
    }
});
exports["default"] = void 0;
var _select = _interopRequireDefault(require("58faf0de11c6e743"));
var _selectOption = _interopRequireDefault(require("ec5c150a4204e74d"));
var _default = _select["default"];
exports["default"] = _default;

},{"a217376e6d0bcf9":"5qxSW","58faf0de11c6e743":"cP1mJ","ec5c150a4204e74d":"jno0l"}],"cP1mJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3b205e345607acc3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("2889c984efacb6b5"));
var _toConsumableArray2 = _interopRequireDefault(require("66de777e05ed95d4"));
var _classCallCheck2 = _interopRequireDefault(require("dda574376a4d25aa"));
var _createClass2 = _interopRequireDefault(require("df204bb0d25b5687"));
var _assertThisInitialized2 = _interopRequireDefault(require("8d550ad05ba56043"));
var _inherits2 = _interopRequireDefault(require("58c73b232d0dcbfd"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("f54c6a724bcba6df"));
var _getPrototypeOf2 = _interopRequireDefault(require("2b3aa488c5ba38c"));
var _defineProperty2 = _interopRequireDefault(require("eb3ce24f9ed08ee4"));
var _react = _interopRequireDefault(require("ae84a26433bb0656"));
var _propTypes = _interopRequireDefault(require("32470d0f94a2b411"));
var _emotion = require("63143b4283cac3c");
var _keycode = _interopRequireDefault(require("ddb0497629f6152"));
var _uniqueId = _interopRequireDefault(require("b0d4361897e36854"));
var _find = _interopRequireDefault(require("8fb3e3ff790a106a"));
var _noop = _interopRequireDefault(require("563d94ca8307aeba"));
var _escapeRegExp = _interopRequireDefault(require("9fbde0d89c59690"));
var _chevronSelect = _interopRequireDefault(require("e68cb0c481a93fa3"));
var _select = _interopRequireDefault(require("d17bced426d97959"));
var _selectOptionList = _interopRequireDefault(require("265901caf0acfeab"));
var _selectOptionListContainer = _interopRequireDefault(require("8c4805d10c85ada8"));
var _utils = require("75e00cf3de6c23df");
var _inputBox = _interopRequireDefault(require("d415351e0acbb778"));
var _focus = _interopRequireDefault(require("ecb60ad6621ac2fc"));
var _theme = require("8ea522dc6a9c8a73");
var _responsive = _interopRequireDefault(require("2e154fa3d66a8479"));
var _context = _interopRequireDefault(require("91ede5c55644ed75"));
var _token = require("666f563c060777f0");
var _text = _interopRequireDefault(require("a7c43721c29cc493"));
var _inputReset = _interopRequireDefault(require("7e98146634702516"));
var _noTextWrap = _interopRequireDefault(require("57a6a97382083abd"));
var _visuallyHidden = _interopRequireDefault(require("a4162d11839eb8fd"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var width = _ref.width, minWidth = _ref.minWidth;
    return (0, _emotion.css)((0, _text["default"])(t), {
        outline: "none",
        position: "relative",
        width: width,
        // If an explicit width is set then don't allow the select to flex
        flex: width ? "none !important" : undefined,
        minWidth: minWidth
    });
}, [
    "width",
    "minWidth"
]);
var customSearchInputStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var disabled = _ref2.disabled, open = _ref2.open, empty = _ref2.empty;
    return (0, _emotion.css)((0, _inputReset["default"])({
        empty: empty,
        textColor: t("searchInputForegroundColorDefault"),
        placeholderColor: t("searchInputPlaceholderColor", disabled ? "disabled" : "default")
    }), // otherwise hide the input and show the label. Note that the input is
    // visually hidden but is still focuseable (so the user can tab to it).
    open ? {
        "& + div": {
            display: "none"
        }
    } : // focus/input reveal.
    _objectSpread(_objectSpread({}, _visuallyHidden["default"]), {}, {
        width: "auto",
        position: "initial"
    }));
}, [
    "disabled",
    "open",
    "empty"
]);
var valueLabelStyles = (0, _emotion.css)(_noTextWrap["default"]);
/* eslint-disable react/prop-types */ var SelectClass = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectClass, _React$Component);
    var _super = _createSuper(SelectClass);
    function SelectClass() {
        var _this;
        (0, _classCallCheck2["default"])(this, SelectClass);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            // Are the select options open?
            open: false,
            // This enables us to preselect an option in the option list. This is the
            // "default" because the internal state of the option list may change if the
            // user uses up/down arrow keys to manage the preselected index.
            defaultPreselectedIndex: undefined,
            // For this component, there are two types of searching:
            //   1) Custom searching is what happens when `onSearch` and `searchQuery`
            //      are passed in as props. This renders a search input inside the
            //      Select and allows the developer to filter options down according to
            //      any custom search algorithm.
            //   2) Native searching is what happens when no custom search props are
            //      passed. This search mimicks the behavior of native html selects -
            //      the search query is stored internally and the first option that
            //      matches the query (prefix matching only) is selected if the select
            //      is closed or "preselected" if the select is open.
            nativeSearchQuery: ""
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", _this.props.id || (0, _uniqueId["default"])("select-"));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "nativeSearchTimeout", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionListRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "customSearchInputRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function(ref) {
            _this.rootRef = ref; // If we are forwarding a ref, assign forwarded ref to root ref
            if (_this.props.forwardedRef) _this.props.forwardedRef.current = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOptionListRef", function(ref) {
            return _this.optionListRef = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateCustomSearchInputRef", function(ref) {
            return _this.customSearchInputRef = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMultiSelectable", function() {
            return Array.isArray(_this.props.value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isNativeSearching", function() {
            return /[\S]/.test(_this.state.nativeSearchQuery);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isCustomSearchable", function() {
            return Boolean(_this.props.onSearch);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function(_ref3) {
            var retainFocus = _ref3.retainFocus;
            var customSearchable = _this.isCustomSearchable();
            _this.setState({
                open: false,
                focus: retainFocus,
                defaultPreselectedIndex: undefined
            });
            if (customSearchable) _this.props.onSearch("");
             // Move focus back to the main node before closing the option list
            if (retainFocus) {
                if (_this.isCustomSearchable()) _this.customSearchInputRef.focus();
                else _this.rootRef.focus();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "nativeSearch", function(searchQuery) {
            var _this$props = _this.props, value = _this$props.value, onChange = _this$props.onChange, children = _this$props.children;
            var _this$state = _this.state, open = _this$state.open, defaultPreselectedIndex = _this$state.defaultPreselectedIndex;
            var options = (0, _utils.getOptionsFromChildren)(children).filter(function(_ref4) {
                var disabled = _ref4.disabled;
                return !disabled;
            });
            var selectedOption = (0, _find["default"])(options, function(option) {
                return (0, _utils.isOptionValueSelected)(value, option.value);
            }); // Look for the first option that starts with the full search query
            var searchQueryRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(searchQuery)), "i");
            var fullMatch = (0, _find["default"])(options, function(option) {
                return searchQueryRegExp.test(option.label);
            }); // Look for an option that starts with the last character typed. Sort the
            // options so that if the same character is typed repeatedly the focus
            // cycles through all matching options.
            var lastChar = searchQuery[searchQuery.length - 1];
            var lastCharRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(lastChar)), "i");
            var currentIndex = open ? defaultPreselectedIndex : selectedOption ? selectedOption.index : 0;
            var lastCharMatch = (0, _find["default"])([].concat((0, _toConsumableArray2["default"])(options.slice(currentIndex + 1)), (0, _toConsumableArray2["default"])(options.slice(0, currentIndex + 1))), function(option) {
                return lastCharRegExp.test(option.label);
            }); // Prefer a full match to a last character match
            var match = fullMatch || lastCharMatch; // If the select is expaneded and we have a match then focus it
            if (match && open) _this.setState({
                defaultPreselectedIndex: match.index
            });
            else if (match) onChange(_this.isMultiSelectable() ? [
                match.value
            ] : match.value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function(event) {
            var disabled = _this.props.disabled;
            var open = _this.state.open;
            var key = (0, _keycode["default"])(event); // HACK: Assume the key is "printable" (can be added to a search query) if
            // it's either of length 1 or a space.
            var printableKey = key && key.length === 1 ? key : key === "space" ? " " : undefined;
            var isNativeSearching = _this.isNativeSearching();
            var isCustomSearchable = _this.isCustomSearchable();
            var keyUsed = false; // If any character is typed that doesn't trigger behavior in the option
            // list (as indicated by event.defaultPrevented set to true) then make sure
            // the custom search input is focused
            if (isCustomSearchable && !event.defaultPrevented && _this.customSearchInputRef !== document.activeElement) _this.customSearchInputRef.focus();
             // If no custom search behavior is defined and a printable key was typed,
            // trigger the "native" search functionality that mimicks the browser
            if (!isCustomSearchable && printableKey) {
                var nativeSearchQuery = _this.state.nativeSearchQuery + printableKey;
                _this.setState({
                    nativeSearchQuery: nativeSearchQuery
                });
                _this.nativeSearch(nativeSearchQuery); // Reset the timeout that will the search query
                clearTimeout(_this.nativeSearchTimeout);
                _this.nativeSearchTimeout = window.setTimeout(function() {
                    return _this.setState({
                        nativeSearchQuery: "",
                        defaultPreselectedIndex: undefined
                    });
                }, SelectClass.nativeSearchTimeoutDuration);
                keyUsed = true;
            } // If no custmo search behavior is defined and backspace or delete was
            // pressed, clear the "native" search query
            if (!isCustomSearchable && (key === "backspace" || key === "delete")) {
                // Reset the timeout that will clears searc query and instead clear the
                // query immediately
                clearTimeout(_this.nativeSearchTimeout);
                _this.setState({
                    nativeSearchQuery: "",
                    defaultPreselectedIndex: undefined
                });
                keyUsed = true;
            } // If the user hits escape on an open select then close it
            if (open && key === "esc") {
                // Stop propagating the event upwards. This ensures that a parent element
                // (e.g. a modal) won't also handle the escape key.
                event.stopPropagation();
                _this.close({
                    retainFocus: true
                });
                keyUsed = true;
            } // If the user hits up, down, or backspace/delete/space (and they're not in
            // the middle of a search) on a collapsed select then open it
            if (!open && !disabled && (key === "up" || key === "down" || (key === "backspace" || key === "delete" || key === "space") && !isNativeSearching)) {
                _this.setState({
                    open: true
                });
                keyUsed = true;
            } // Disabled tabbing while the select is open
            if (open && key === "tab") keyUsed = true;
             // Don't perform the normal action associated with the key (e.g. scroll for
            // arrows/space) if the key was used for a select-related action
            if (keyUsed) event.preventDefault();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownOptionList", function(event) {
            // Prevent "space" from selecting an option when the user is searching
            if ((0, _keycode["default"])(event) === "space" && _this.isNativeSearching()) event.preventDefault();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownCustomSearchInput", function(event) {
            var key = (0, _keycode["default"])(event);
            var open = _this.state.open; // If the user presses an up/down arrow key when focused on an open
            // searchable select's search input, then transfer the focus to the option
            // list and immediately move the preselected index from the current option
            // to the next/previous option. This mimicks what would happen if the option
            // list was focused when the arrow key was pressed.
            if (open && (key === "down" || key === "up") && _this.optionListRef) {
                _this.setState({
                    defaultPreselectedIndex: _this.optionListRef.getNextPreselectedIndex(key === "down" ? 1 : -1)
                });
                _this.optionListRef.focus();
                event.preventDefault();
            } else if (open && key === "enter") {
                var firstOption = (0, _utils.getOptionsFromChildren)(_this.props.children)[0]; // Only select the first option if there's a search query
                if (firstOption && _this.props.searchQuery) _this.onClickOption(firstOption.value);
                 // Don't submit a form if the user presses enter on an open searchable
                // select
                event.preventDefault();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeCustomSearchInput", function(event) {
            var value = event.target.value;
            var defaultPreselectedIndex = _this.state.defaultPreselectedIndex; // Make sure the select is open if the user is typing in a search query
            if (!_this.state.open) _this.setState({
                open: true
            });
             // If we have a query, presleect the first option if it isn't already
            if (value && defaultPreselectedIndex !== 0) _this.setState({
                defaultPreselectedIndex: 0
            });
             // If we don't have a query, clear the preselected option
            if (!value && defaultPreselectedIndex !== -1) _this.setState({
                defaultPreselectedIndex: -1
            });
            _this.props.onSearch(value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownInputBox", function(event) {
            if (_this.isCustomSearchable()) {
                if (!_this.state.open) // If the user mouses down on a closed searchable select, open it
                _this.setState({
                    open: true
                });
                if (event.target !== _this.customSearchInputRef) {
                    // If the user mouses down on the input box of a custom searchable
                    // select, focus on the custom search input
                    _this.customSearchInputRef.focus();
                    event.preventDefault();
                }
            } else // If the user mouses down on a non-searchable select, toggle it
            _this.setState({
                open: !_this.state.open
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickOption", function(value) {
            if (_this.isMultiSelectable()) {
                // If the value is selected then deselect it, otherwise select it
                if ((0, _utils.isOptionValueSelected)(_this.props.value, value)) _this.props.onChange(_this.props.value.filter(function(v) {
                    return v !== value;
                }));
                else _this.props.onChange([].concat((0, _toConsumableArray2["default"])(_this.props.value), [
                    value
                ]));
            } else {
                _this.close({
                    retainFocus: true
                });
                _this.props.onChange(value);
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpenPopover", function() {
            if (_this.optionListRef) _this.optionListRef.componentDidMount();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCloseBottomSheet", function() {
            return _this.close({
                retainFocus: true
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function(event) {
            _this.close({
                retainFocus: false
            });
            if (_this.props.onBlur) _this.props.onBlur(event);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function() {
            if (_this.state.defaultPreselectedIndex !== undefined) _this.setState({
                defaultPreselectedIndex: undefined
            });
        });
        return _this;
    }
    (0, _createClass2["default"])(SelectClass, [
        {
            key: "componentDidMount",
            /**
     * Lifecycle hooks
     */ value: function componentDidMount() {
                if (this.props.autoFocus) {
                    // NOTE: React guarantees that callback refs will be resolved before
                    // componentDidMount is called, so this is safe.
                    if (this.isCustomSearchable()) this.customSearchInputRef.focus();
                    else this.rootRef.focus();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var open = this.state.open;
                var disabled = this.props.disabled && !prevProps.disabled; // Collapse the select if it was disabled while open
                if (disabled && open) this.close({
                    retainFocus: false
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Make sure we don't attempt to clear the searchQuery after the component
                // is gone
                clearTimeout(this.nativeSearchTimeout);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var _this$state2 = this.state, open = _this$state2.open, defaultPreselectedIndex = _this$state2.defaultPreselectedIndex;
                var isCustomSearchable = this.isCustomSearchable();
                var options = (0, _utils.getOptionsFromChildren)(props.children);
                var selectedOptions = options.filter(function(option) {
                    return (0, _utils.isOptionValueSelected)(props.value, option.value);
                });
                var valueLabel = props.valueLabel(selectedOptions) || "";
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _select["default"],
                    map: (0, _token.getTokenHelper)("select")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_focus["default"], {
                        onFocus: props.onFocus,
                        onBlur: _this2.onBlur,
                        multipleTargets: true
                    }, function(_ref5) {
                        var focus = _ref5.focus, focusProps = _ref5.focusProps;
                        return /*#__PURE__*/ _react["default"].createElement(_responsive["default"], {
                            query: "min-width",
                            fallback: "".concat(t("optionListPopoverBreakpoint"), "px"),
                            props: {
                                optionListContainerType: isCustomSearchable ? {
                                    "default": "popover"
                                } : (0, _defineProperty2["default"])({
                                    "default": "bottom-sheet"
                                }, "".concat(t("optionListPopoverBreakpoint"), "px"), "popover")
                            }
                        }, function(_ref7) {
                            var optionListContainerType = _ref7.optionListContainerType;
                            return /*#__PURE__*/ _react["default"].createElement("div", (0, _extends2["default"])({
                                tabIndex: props.disabled || isCustomSearchable ? undefined : "0",
                                id: _this2.id,
                                "aria-haspopup": "listbox",
                                "aria-expanded": open,
                                "aria-disabled": props.disabled,
                                "aria-placeholder": props.placeholder,
                                onKeyDown: props.disabled ? undefined : _this2.onKeyDown,
                                ref: _this2.updateRootRef,
                                className: styles(t, {
                                    width: props.width,
                                    minWidth: props.minWidth
                                })
                            }, focusProps), /*#__PURE__*/ _react["default"].createElement(_context["default"].Consumer, null, function(_ref8) {
                                var _ref8$suffixIconToken = _ref8.suffixIconTokens, suffixIconTokens = _ref8$suffixIconToken === void 0 ? _chevronSelect["default"] : _ref8$suffixIconToken;
                                return /*#__PURE__*/ _react["default"].createElement(_inputBox["default"], {
                                    label: props.label,
                                    htmlFor: _this2.id,
                                    empty: !valueLabel,
                                    focus: focus,
                                    suffixIconTokens: suffixIconTokens,
                                    animated: optionListContainerType === "popover",
                                    labelFloated: isCustomSearchable && open || Boolean(props.placeholder || valueLabel),
                                    disabled: props.disabled,
                                    size: props.size,
                                    prefix: props.prefix,
                                    suffix: props.suffix,
                                    error: props.error && !focus,
                                    cursor: isCustomSearchable && open ? "text" : "pointer",
                                    onMouseDown: props.disabled ? undefined : _this2.onMouseDownInputBox
                                }, isCustomSearchable ? /*#__PURE__*/ _react["default"].createElement("input", (0, _extends2["default"])({
                                    type: "search",
                                    onKeyDown: _this2.onKeyDownCustomSearchInput,
                                    className: customSearchInputStyles(t, {
                                        empty: _this2.props.searchQuery === undefined || _this2.props.searchQuery === "",
                                        open: open,
                                        disabled: props.disabled
                                    }),
                                    placeholder: props.placeholder,
                                    value: _this2.props.searchQuery || "",
                                    ref: _this2.updateCustomSearchInputRef,
                                    onChange: _this2.onChangeCustomSearchInput,
                                    disabled: props.disabled,
                                    autoComplete: "off"
                                }, focusProps)) : null, /*#__PURE__*/ _react["default"].createElement("div", {
                                    className: valueLabelStyles
                                }, valueLabel ? valueLabel : props.placeholder));
                            }), /*#__PURE__*/ _react["default"].createElement(_selectOptionListContainer["default"], {
                                type: optionListContainerType,
                                open: open,
                                popoverAnchorNode: _this2.rootRef,
                                popoverMaxHeight: props.popoverMaxHeight,
                                onOpenPopover: _this2.onOpenPopover,
                                onCloseBottomSheet: _this2.onCloseBottomSheet,
                                t: t
                            }, /*#__PURE__*/ _react["default"].createElement(_selectOptionList["default"], (0, _extends2["default"])({
                                open: open,
                                autoFocus: !isCustomSearchable,
                                value: props.value,
                                searchQuery: props.searchQuery,
                                defaultPreselectedIndex: defaultPreselectedIndex,
                                onChangePreselectedIndex: _this2.onChangePreselectedIndex,
                                onClickOption: _this2.onClickOption,
                                onKeyDown: _this2.onKeyDownOptionList,
                                ref: _this2.updateOptionListRef
                            }, focusProps), props.children)), props.name ? _this2.isMultiSelectable() ? props.value.map(function(value) {
                                return /*#__PURE__*/ _react["default"].createElement("input", {
                                    type: "hidden",
                                    key: value,
                                    name: "".concat(props.name, "[]"),
                                    value: value
                                });
                            }) : /*#__PURE__*/ _react["default"].createElement("input", {
                                type: "hidden",
                                name: props.name,
                                value: props.value || ""
                            }) : null);
                        });
                    });
                });
            }
        }
    ]);
    return SelectClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */ // Forward ref to class component. TODO: update class component
// to functional component.
(0, _defineProperty2["default"])(SelectClass, "nativeSearchTimeoutDuration", 1000);
var Select = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(SelectClass, (0, _extends2["default"])({}, props, {
        forwardedRef: ref
    }));
});
Select.displayName = "Select";
Select.propTypes = {
    /**
   * A list of `SelectOption` elements that represent the choices to present to
   * the user.
   *
   * If no `SelectOption` elements are provided then any other elements passed here
   * will be rendered in place of them. This allows you to render things like a
   * loading indicator while waiting for asyncronously loaded options or a
   * message to the user when no options are available. Note that these elements
   * cannot contain anything interactive like links or buttons for accessibility
   * reasons.
   */ children: _propTypes["default"].node.isRequired,
    /**
   * If set to true then the select will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   */ autoFocus: _propTypes["default"].bool,
    /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */ disabled: _propTypes["default"].bool,
    /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */ error: _propTypes["default"].bool,
    /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */ id: _propTypes["default"].string,
    /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored.
   */ label: _propTypes["default"].string,
    /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */ minWidth: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */ name: _propTypes["default"].string,
    /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */ placeholder: _propTypes["default"].string,
    /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */ popoverMaxHeight: _propTypes["default"].number,
    /**
   * Static text to show in an end-cap prepended to the select.
   */ prefix: _propTypes["default"].string,
    /**
   * Pass the query obtained via the `onSearch` handler back to this prop to
   * update the query rendered by the Select.
   */ searchQuery: _propTypes["default"].string,
    /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */ size: _propTypes["default"].oneOf([
        "small",
        "medium",
        "large",
        "xlarge"
    ]),
    /**
   * Static text to show in an end-cap appended to the input.
   */ suffix: _propTypes["default"].string,
    /**
   * This is the value of the currently selected option. Provide a number or
   * string value for a single-selectable Select, or an array of numbers or
   * strings for a multi-selectable Select. The matching option will
   * automatically be highlighted in the select.
   */ value: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number,
        _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([
            _propTypes["default"].string,
            _propTypes["default"].number
        ]))
    ]),
    /**
   * This function generates the label that is shown in the Select's form
   * field to summarize the current value of the Select. This function
   * receives an array containing all of the selected options that are
   * provided as children to the Select component.
   *
   * The default function will return the selected option's label
   * if one selected option is found. If more than one selected option is
   * found it will return "X selected".
   *
   * If you are filtering the options in the Select (e.g. for a searchable
   * Select), you will have to provide your own function here that does not
   * rely on the array of options passed to this function. As stated above
   * that array will only include selected options *that are currently
   * rendered as children*, so it won't include any selected options that have
   * been filtered out of the current view.
   */ valueLabel: _propTypes["default"].func,
    /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */ width: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ]),
    /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */ onBlur: _propTypes["default"].func,
    /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */ onChange: _propTypes["default"].func,
    /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */ onFocus: _propTypes["default"].func,
    /**
   * This function makes the select "searchable". A searchable select allows
   * the user to type a query into a text input to search through options.
   *
   * This function will be called with the user's latest query, which should
   * be passed back to the `searchQuery` prop. Note that this will not
   * automatically filter the options in the select. That responsibility is
   * still up to the developer.
   */ onSearch: _propTypes["default"].func
};
Select.defaultProps = {
    onChange: _noop["default"],
    size: "medium",
    valueLabel: function valueLabel(options) {
        return options.length === 1 ? options[0].label : options.length > 0 ? "".concat(options.length, " selected") : "";
    }
};
var _default = Select;
exports["default"] = _default;

},{"3b205e345607acc3":"5qxSW","2889c984efacb6b5":"fAmfl","66de777e05ed95d4":"cbgE8","dda574376a4d25aa":"aqLjQ","df204bb0d25b5687":"8X7ov","8d550ad05ba56043":"fA0LA","58c73b232d0dcbfd":"hAMmu","f54c6a724bcba6df":"37tJc","2b3aa488c5ba38c":"cE6Se","eb3ce24f9ed08ee4":"avcfc","ae84a26433bb0656":"6uln9","32470d0f94a2b411":"9Mqtv","63143b4283cac3c":"1BAMo","ddb0497629f6152":"4THh2","b0d4361897e36854":"4Lekm","8fb3e3ff790a106a":"b6TZs","563d94ca8307aeba":"hxHyu","9fbde0d89c59690":"8KiOd","e68cb0c481a93fa3":"8H7IN","d17bced426d97959":"3FkLK","265901caf0acfeab":"bM72i","8c4805d10c85ada8":"4Qke3","75e00cf3de6c23df":"ltBI7","d415351e0acbb778":"4y4sJ","ecb60ad6621ac2fc":"8iPDd","8ea522dc6a9c8a73":"dJlcb","2e154fa3d66a8479":"l7U3k","91ede5c55644ed75":"b5STI","666f563c060777f0":"bebc4","a7c43721c29cc493":"g6RQX","7e98146634702516":"jXzjN","57a6a97382083abd":"9CFwe","a4162d11839eb8fd":"kk7IH"}],"8KiOd":[function(require,module,exports) {
var toString = require("2c8c2f1a48c8780f");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function escapeRegExp(string) {
    string = toString(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
}
module.exports = escapeRegExp;

},{"2c8c2f1a48c8780f":"jihDg"}],"bM72i":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("41ffae28d0a84892");
var _interopRequireDefault = require("c742ddf4d7cf56c6");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("83abaaee18581715"));
var _classCallCheck2 = _interopRequireDefault(require("aee56910a2aecb75"));
var _createClass2 = _interopRequireDefault(require("e95e65946bd6acac"));
var _assertThisInitialized2 = _interopRequireDefault(require("87bd4d8b27e38908"));
var _inherits2 = _interopRequireDefault(require("e3d098a12273d159"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("d20c30baa3ce8154"));
var _getPrototypeOf2 = _interopRequireDefault(require("ac64732b44baf26c"));
var _defineProperty2 = _interopRequireDefault(require("9f86dd3d80815033"));
var _react = _interopRequireDefault(require("e4dc6d11b08ed19b"));
var _propTypes = _interopRequireDefault(require("1cbfc8d80ea0ddd2"));
var _utils = require("3b0431643a89dd9");
var _optionList = _interopRequireWildcard(require("9e537807024bf8a"));
var _highlightSubstring = _interopRequireDefault(require("a4c07449b758efef"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var SelectOptionList = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectOptionList, _React$Component);
    var _super = _createSuper(SelectOptionList);
    function SelectOptionList() {
        var _this;
        (0, _classCallCheck2["default"])(this, SelectOptionList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function(event) {
            event.preventDefault();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCustomSearchHighlightSubstring", function(option) {
            return function() {
                return /*#__PURE__*/ _react["default"].createElement(_highlightSubstring["default"], {
                    match: _this.props.searchQuery
                }, option.label);
            };
        });
        return _this;
    }
    (0, _createClass2["default"])(SelectOptionList, [
        {
            key: "shouldComponentUpdate",
            /**
     * Only update if the option list will continue to be open. This prevents the
     * list contents from changing while the Select is in the process of closing,
     * which can be jarring to the user.
     */ value: function shouldComponentUpdate(nextProps) {
                return nextProps.open;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var options = (0, _utils.getOptionsFromChildren)(props.children);
                var nonOptionChildren = options.length > 0 ? [] : (0, _utils.getNonOptionsFromChildren)(props.children);
                return options.length ? /*#__PURE__*/ _react["default"].createElement(_optionList["default"], {
                    autoFocus: props.autoFocus,
                    onFocus: props.onFocus,
                    onBlur: props.onBlur,
                    onKeyDown: props.onKeyDown,
                    defaultPreselectedIndex: props.defaultPreselectedIndex,
                    onChangePreselectedIndex: props.onChangePreselectedIndex,
                    multiSelectable: Array.isArray(props.value),
                    ref: props.forwardedRef
                }, options.map(function(option) {
                    return /*#__PURE__*/ _react["default"].createElement(_optionList.OptionListItem, (0, _extends2["default"])({}, option.passThroughProps, {
                        key: option.value,
                        selected: (0, _utils.isOptionValueSelected)(props.value, option.value),
                        onClick: function onClick() {
                            return props.onClickOption(option.value);
                        },
                        label: option.label,
                        disabled: option.disabled
                    }), // passed, use our own query text rendering
                    props.searchQuery && option.children === undefined ? _this2.renderCustomSearchHighlightSubstring(option) : option.children);
                })) : nonOptionChildren.length ? /*#__PURE__*/ _react["default"].createElement("div", {
                    onMouseDown: this.onMouseDownNonOptionChildren
                }, nonOptionChildren) : null;
            }
        }
    ]);
    return SelectOptionList;
}(_react["default"].Component);
SelectOptionList.propTypes = {};
function forwardRef(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(SelectOptionList, (0, _extends2["default"])({}, props, {
        forwardedRef: ref
    }));
}
forwardRef.displayName = "SelectOptionList";
var _default = /*#__PURE__*/ _react["default"].forwardRef(forwardRef);
exports["default"] = _default;

},{"41ffae28d0a84892":"4RXTR","c742ddf4d7cf56c6":"5qxSW","83abaaee18581715":"fAmfl","aee56910a2aecb75":"aqLjQ","e95e65946bd6acac":"8X7ov","87bd4d8b27e38908":"fA0LA","e3d098a12273d159":"hAMmu","d20c30baa3ce8154":"37tJc","ac64732b44baf26c":"cE6Se","9f86dd3d80815033":"avcfc","e4dc6d11b08ed19b":"6uln9","1cbfc8d80ea0ddd2":"9Mqtv","3b0431643a89dd9":"ltBI7","9e537807024bf8a":"c2pRs","a4c07449b758efef":"55UPn"}],"ltBI7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("851b34a30aa376bb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNonOptionsFromChildren = exports.getOptionsFromChildren = exports.isOptionValueSelected = exports.isOption = void 0;
var _react = _interopRequireDefault(require("69bf43cc72d38298"));
var _selectOption = _interopRequireDefault(require("8cd2a6c8cb567488"));
var _isElementOf = _interopRequireDefault(require("a479847e3d7e5fd0"));
var _filterPropsByPrefix = _interopRequireDefault(require("7c999d9aa67d5daf"));
var isOption = (0, _isElementOf["default"])(_selectOption["default"]);
exports.isOption = isOption;
var isOptionValueSelected = function isOptionValueSelected(selectedValue, optionValue) {
    return Array.isArray(selectedValue) ? selectedValue.indexOf(optionValue) !== -1 : selectedValue === optionValue;
};
exports.isOptionValueSelected = isOptionValueSelected;
var getOptionsFromChildren = function getOptionsFromChildren(children) {
    return _react["default"].Children.toArray(children).filter(isOption).map(function(child, index) {
        return {
            index: index,
            label: child.props.label.toString(),
            value: child.props.value,
            children: child.props.children,
            disabled: child.props.disabled,
            passThroughProps: (0, _filterPropsByPrefix["default"])(child.props, [
                "data-"
            ])
        };
    });
};
exports.getOptionsFromChildren = getOptionsFromChildren;
var getNonOptionsFromChildren = function getNonOptionsFromChildren(children) {
    return _react["default"].Children.toArray(children).filter(function(child) {
        return child && !isOption(child);
    });
};
exports.getNonOptionsFromChildren = getNonOptionsFromChildren;

},{"851b34a30aa376bb":"5qxSW","69bf43cc72d38298":"6uln9","8cd2a6c8cb567488":"jno0l","a479847e3d7e5fd0":"i2KEV","7c999d9aa67d5daf":"7Pq5E"}],"jno0l":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("6122139757e3e5de");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("7001d2643b775d33"));
var _createClass2 = _interopRequireDefault(require("75c9e3a1b93134d"));
var _inherits2 = _interopRequireDefault(require("8f959195feef9ab2"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("b26ddb4fa6f1036d"));
var _getPrototypeOf2 = _interopRequireDefault(require("6ae6698ee3a77bf8"));
var _react = _interopRequireDefault(require("8189c0869b34b25a"));
var _propTypes = _interopRequireDefault(require("e829ed49dcce2dd"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 */ var SelectOption = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectOption, _React$Component);
    var _super = _createSuper(SelectOption);
    function SelectOption() {
        (0, _classCallCheck2["default"])(this, SelectOption);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(SelectOption, [
        {
            key: "render",
            value: function render() {
                // The top-level OptionListItem component is used to render this. See
                // ./select-option-list for the implementation.
                return null;
            }
        }
    ]);
    return SelectOption;
}(_react["default"].Component);
SelectOption.propTypes = {};
var _default = SelectOption;
exports["default"] = _default;

},{"6122139757e3e5de":"5qxSW","7001d2643b775d33":"aqLjQ","75c9e3a1b93134d":"8X7ov","8f959195feef9ab2":"hAMmu","b26ddb4fa6f1036d":"37tJc","6ae6698ee3a77bf8":"cE6Se","8189c0869b34b25a":"6uln9","e829ed49dcce2dd":"9Mqtv"}],"c2pRs":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8d0efb17d69984a0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OptionListItem", {
    enumerable: true,
    get: function get() {
        return _optionListItem["default"];
    }
});
exports["default"] = void 0;
var _optionList = _interopRequireDefault(require("7d0734401c3fa4bb"));
var _optionListItem = _interopRequireDefault(require("631fc22e53c142e4"));
var _default = _optionList["default"];
exports["default"] = _default;

},{"8d0efb17d69984a0":"5qxSW","7d0734401c3fa4bb":"jXWo7","631fc22e53c142e4":"7OWCF"}],"jXWo7":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8dc7eee6f901fe1");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("730e3dea577239be"));
var _createClass2 = _interopRequireDefault(require("9930a7e9e42194b0"));
var _assertThisInitialized2 = _interopRequireDefault(require("11785b7a40c9dcaf"));
var _inherits2 = _interopRequireDefault(require("e5366b9da31bffd3"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("f280a9aaaedfb84d"));
var _getPrototypeOf2 = _interopRequireDefault(require("2f7c986189a58e76"));
var _defineProperty2 = _interopRequireDefault(require("92911be5d93c7480"));
var _react = _interopRequireDefault(require("3f65c6ca33bf6a4a"));
var _reactDom = _interopRequireDefault(require("f3801fe8bebd407a"));
var _propTypes = _interopRequireDefault(require("c0bb3e1fee213fb8"));
var _keycode = _interopRequireDefault(require("aa287276b2a8998d"));
var _emotion = require("fb1c249757f2b698");
var _uniqueId = _interopRequireDefault(require("fd916fcd21a11fd3"));
var _findIndex = _interopRequireDefault(require("d112f6a7f8a00a69"));
var _noop = _interopRequireDefault(require("234910a5e4433b7e"));
var _optionListItem = _interopRequireDefault(require("8469d790990200f5"));
var _theme = require("bcacd4e232920149");
var _token = require("fe575c8ebcb0f4c2");
var _functional = require("46b3889b65915f09");
var _text = _interopRequireDefault(require("5ff174383b561d3c"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = (0, _functional.memoize)(function(t) {
    return (0, _emotion.css)((0, _text["default"])(t), {
        outline: "none",
        // Item styles
        "& [role=option]": {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            boxSizing: "border-box",
            padding: "".concat(t("spacingInsetVertical"), "px ").concat(t("spacingInsetHorizontal"), "px"),
            transition: t.transitionCss("motion", [
                "color",
                "background-color"
            ]),
            // Foreground and background color
            backgroundColor: t("backgroundColorDefault"),
            color: t("foregroundColorDefault"),
            "&[aria-selected=true]": {
                backgroundColor: t("backgroundColorSelected"),
                color: t("foregroundColorSelected")
            },
            "&[aria-current=true]": {
                backgroundColor: t("backgroundColorPreselected"),
                color: t("foregroundColorPreselected")
            },
            "&:active": {
                backgroundColor: t("backgroundColorPressed"),
                color: t("foregroundColorPressed")
            },
            "&[disabled], &[aria-disabled]": {
                backgroundColor: t("backgroundColorDisabled"),
                color: t("foregroundColorDisabled")
            }
        },
        // Children styles
        "& [role=option] > *:first-child": {
            flex: "auto"
        },
        // Selected indicator styles
        "&[aria-multiselectable=true] [role=option]": {
            "& > *:last-child": {
                flexShrink: 0,
                marginLeft: t("spacingInsetHorizontal"),
                color: t("indicatorColorDefault"),
                transition: t.transitionCss("motion", "color")
            },
            "&[aria-current=true] > *:last-child": {
                color: t("indicatorColorPreselected")
            },
            "&[aria-selected=true] > *:last-child": {
                color: t("indicatorColorSelected")
            },
            "&:active > *:last-child": {
                color: t("indicatorColorPressed")
            },
            "&[disabled][aria-selected=true] > *:last-child, &[aria-disabled][aria-selected=true] > *:last-child": {
                color: t("indicatorColorDisabled")
            }
        }
    });
});
/**
 * This component helps render a keyboard-friendly list of selectable options.
 */ var OptionList = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(OptionList, _React$Component);
    var _super = _createSuper(OptionList);
    function OptionList() {
        var _this;
        (0, _classCallCheck2["default"])(this, OptionList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            preselectedIndex: _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.props.defaultPreselectedIndex !== undefined ? _this.props.defaultPreselectedIndex : -1
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("option-list-"));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionDomNodes", []);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listDomNode", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateListDomNode", function(node) {
            return _this.listDomNode = node;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedIndex", function(options) {
            return (0, _findIndex["default"])(options, function(option) {
                return option && option.props.selected;
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPreselectedIndex", function() {
            return _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.state.preselectedIndex;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextPreselectedIndex", function(offset) {
            var options = _react["default"].Children.toArray(_this.props.children);
            var preselectedIndex = _this.getPreselectedIndex();
            var selectedIndex = _this.getSelectedIndex(options);
            var enabledIndices = options.reduce(function(result, option, index) {
                if (option && !option.props.disabled) result.push(index);
                return result;
            }, []);
            var firstIndex = enabledIndices[0];
            var lastIndex = enabledIndices[enabledIndices.length - 1]; // If we've got a preselected or a selected option then move to the prev or
            // next option in the list (depending on the value of offset).
            var currentIndex = preselectedIndex !== -1 ? preselectedIndex : selectedIndex;
            if (currentIndex !== -1) {
                var nextIndex = enabledIndices[enabledIndices.indexOf(currentIndex) + offset];
                return nextIndex !== undefined ? nextIndex : offset < 0 ? firstIndex : lastIndex; // If we don't have a preselected or selected option and we were trying to
            // move up, preselect the option at the bottom of the list.
            } else if (offset < 0) return lastIndex; // If we don't have a preselected or selected option and we were trying to
            else return firstIndex;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function(preselectedIndex) {
            if (_this.props.preselectedIndex === undefined) _this.setState({
                preselectedIndex: preselectedIndex
            });
            _this.props.onChangePreselectedIndex(preselectedIndex);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownContainer", function(event) {
            // Call the user's key down handler first. If they prevent the default event
            // behavior, don't run any of our code.
            _this.props.onKeyDown(event);
            if (!event.defaultPrevented) {
                var key = (0, _keycode["default"])(event);
                var keyUsed = false; // Move the preselection up or down in the list when the up arrow is pressed
                if (key === "up" || key === "down") {
                    var preselectedIndex = _this.getNextPreselectedIndex(key === "up" ? -1 : 1);
                    _this.onChangePreselectedIndex(preselectedIndex);
                    _this.scrollOptionIntoView(preselectedIndex);
                    keyUsed = true;
                } // Simulate a click on the current preselected option when enter or space is
                // pressed
                if (key === "enter" || key === "space") {
                    var _preselectedIndex = _this.getPreselectedIndex();
                    if (_preselectedIndex !== -1) _react["default"].Children.toArray(_this.props.children)[_preselectedIndex].props.onClick();
                    keyUsed = true;
                } // Don't perform the normal action associated with the key (i.e. scroll for
                // arrows) if the key was used for an option list action
                if (keyUsed) event.preventDefault();
            }
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionRef", function(index) {
            return function(domNode) {
                return(/* eslint-disable-next-line react/no-find-dom-node */ _this.optionDomNodes[index] = _reactDom["default"].findDOMNode(domNode));
            };
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollOptionIntoView", function(index) {
            var optionDomNode = _this.optionDomNodes[index];
            if (optionDomNode) optionDomNode.scrollIntoView(optionDomNode);
        });
        return _this;
    }
    (0, _createClass2["default"])(OptionList, [
        {
            key: "focus",
            value: function focus() {
                return this.listDomNode.focus();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Scroll the preselected or selected option into view on mount
                var preselectedIndex = this.getPreselectedIndex();
                if (preselectedIndex !== -1) this.scrollOptionIntoView(preselectedIndex);
                else {
                    var options = _react["default"].Children.toArray(this.props.children);
                    this.scrollOptionIntoView(this.getSelectedIndex(options));
                } // Focus on mount
                if (this.props.autoFocus) // NOTE: React guarantees that callback refs will be resolved before
                // componentDidMount is called, so this is safe.
                this.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, preselectedIndex = _this$props.preselectedIndex, defaultPreselectedIndex = _this$props.defaultPreselectedIndex; // If the preselected index was changed via props, update the internal state
                if (preselectedIndex !== undefined && preselectedIndex !== prevProps.preselectedIndex) this.setState({
                    preselectedIndex: preselectedIndex
                });
                else if (preselectedIndex === undefined && defaultPreselectedIndex !== undefined && defaultPreselectedIndex !== prevProps.defaultPreselectedIndex) {
                    this.setState({
                        preselectedIndex: defaultPreselectedIndex
                    }); // If the default was changed then scroll it into view. We don't do this
                    // if the `preselectedIndex` prop is changed because that means the parent
                    // component is fully managing state and will need to be responsible for
                    // managing scroll position as well.
                    this.scrollOptionIntoView(defaultPreselectedIndex);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var preselectedIndex = this.state.preselectedIndex;
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _optionListItem["default"],
                    map: (0, _token.getTokenHelper)("optionListItem")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement("div", {
                        ref: _this2.updateListDomNode,
                        onKeyDown: _this2.onKeyDownContainer,
                        tabIndex: "0",
                        role: "listbox",
                        "aria-multiselectable": props.multiSelectable,
                        "aria-activedescendant": preselectedIndex ? "".concat(_this2.id, "-option-").concat(preselectedIndex) : undefined,
                        onFocus: props.onFocus,
                        onBlur: props.onBlur,
                        className: styles(t)
                    }, _react["default"].Children.map(props.children, function(option, index) {
                        return option ? /*#__PURE__*/ _react["default"].cloneElement(option, {
                            ref: _this2.optionRef(index),
                            id: "".concat(_this2.id, "-option-").concat(index),
                            preselected: index === preselectedIndex,
                            showIndicator: props.multiSelectable,
                            onChangePreselected: function onChangePreselected(preselected) {
                                return _this2.onChangePreselectedIndex(preselected ? index : -1);
                            }
                        }) : null;
                    }));
                });
            }
        }
    ]);
    return OptionList;
}(_react["default"].Component);
(0, _defineProperty2["default"])(OptionList, "defaultProps", {
    onKeyDown: _noop["default"],
    onChangePreselectedIndex: _noop["default"]
});
OptionList.propTypes = {};
var _default = OptionList;
exports["default"] = _default;

},{"8dc7eee6f901fe1":"5qxSW","730e3dea577239be":"aqLjQ","9930a7e9e42194b0":"8X7ov","11785b7a40c9dcaf":"fA0LA","e5366b9da31bffd3":"hAMmu","f280a9aaaedfb84d":"37tJc","2f7c986189a58e76":"cE6Se","92911be5d93c7480":"avcfc","3f65c6ca33bf6a4a":"6uln9","f3801fe8bebd407a":"b8T3j","c0bb3e1fee213fb8":"9Mqtv","aa287276b2a8998d":"4THh2","fb1c249757f2b698":"1BAMo","fd916fcd21a11fd3":"4Lekm","d112f6a7f8a00a69":"a1880","234910a5e4433b7e":"hxHyu","8469d790990200f5":"akOZE","bcacd4e232920149":"dJlcb","fe575c8ebcb0f4c2":"bebc4","46b3889b65915f09":"hze9s","5ff174383b561d3c":"g6RQX"}],"7OWCF":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("30b19736fd3a9032");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("a5d211392b8418b5"));
var _classCallCheck2 = _interopRequireDefault(require("31b0eaaa03acc8fd"));
var _createClass2 = _interopRequireDefault(require("fa2fc2ec065e4ad9"));
var _assertThisInitialized2 = _interopRequireDefault(require("b5c4883735e8e0f1"));
var _inherits2 = _interopRequireDefault(require("361fb2e805cb5811"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("81db168f08e4d564"));
var _getPrototypeOf2 = _interopRequireDefault(require("4158348b14eaf9f7"));
var _defineProperty2 = _interopRequireDefault(require("cd84a69c5f638636"));
var _react = _interopRequireDefault(require("9a325e776a4f6d67"));
var _propTypes = _interopRequireDefault(require("7c9181bc9624d1a5"));
var _checkLarge = _interopRequireDefault(require("2369826a0ddde48"));
var _clickable = _interopRequireDefault(require("524dc598e6319576"));
var _icon = _interopRequireDefault(require("56322a99bed88a40"));
var _filterPropsByPrefix = _interopRequireDefault(require("b237c91d36995a5c"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var OptionListItem = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(OptionListItem, _React$Component);
    var _super = _createSuper(OptionListItem);
    function OptionListItem() {
        var _this;
        (0, _classCallCheck2["default"])(this, OptionListItem);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
            preselected: _this.props.preselected,
            selected: _this.props.selected
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseX", 0);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseY", 0);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseMove", function(event) {
            if (!_this.props.preselected) _this.props.onChangePreselected(true);
             // Track the mouse position so we can detect whether `onMouseLeaveOption`
            // was triggered by a mouse move or by something else (e.g. scrolling).
            _this.mouseX = event.clientX;
            _this.mouseY = event.clientY;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnter", function(event) {
            // Track the mouse position so we can detect whether `onMouseLeaveOption`
            // was triggered by a mouse move or by something else (e.g. scrolling).
            _this.mouseX = event.clientX;
            _this.mouseY = event.clientY;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function(event) {
            // If the user has moused out of an option by moving their mouse (and not by
            // scrolling the option out from under their mouse) then blur it. Don't blur
            // if they haven't moved their mouse. This allows the user to use keyboard
            // navigation while their mouse cursor is resting over the list (otherwise
            // the mouse and keyboard end up fighting over control).
            if (_this.props.preselected && (event.clientX !== _this.mouseX || event.clientY !== _this.mouseY)) _this.props.onChangePreselected(false);
        });
        return _this;
    }
    (0, _createClass2["default"])(OptionListItem, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return nextProps.label !== this.props.label || nextProps.children !== this.props.children || nextProps.disabled !== this.props.disabled || nextProps.href !== this.props.href || nextProps.id !== this.props.id || nextState.selected !== this.state.selected || nextState.preselected !== this.state.preselected;
            }
        },
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this$state = this.state, selected = _this$state.selected, preselected = _this$state.preselected;
                var children = props.children ? props.children({
                    selected: selected,
                    preselected: preselected
                }) : props.label;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
                    disabled: props.disabled,
                    id: props.id,
                    href: props.href,
                    rel: props.rel,
                    target: props.target,
                    onClick: props.onClick,
                    onMouseMove: props.disabled ? undefined : this.onMouseMove,
                    onMouseEnter: props.disabled ? undefined : this.onMouseEnter,
                    onMouseLeave: props.disabled ? undefined : this.onMouseLeave,
                    role: "option",
                    "aria-selected": selected,
                    "aria-current": preselected ? "true" : undefined,
                    "aria-label": props.label,
                    tabIndex: "-1"
                }), /*#__PURE__*/ _react["default"].createElement("div", null, children), props.showIndicator ? /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                    tokens: _checkLarge["default"]
                }) : null);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var preselected = state.preselected, selected = state.selected;
                if (props.selected !== selected) // If the option was just selected or deselected then don't show the
                // preselected state
                return {
                    selected: props.selected,
                    preselected: false
                };
                else if (props.preselected !== preselected) // If the preselected prop was changed from on high then update the
                // internal preselected state to stay in sync
                return {
                    preselected: props.preselected
                };
                else return null;
            }
        }
    ]);
    return OptionListItem;
}(_react["default"].Component);
(0, _defineProperty2["default"])(OptionListItem, "defaultProps", {
    selected: false,
    preselected: false
});
OptionListItem.propTypes = {};
var _default = OptionListItem;
exports["default"] = _default;

},{"30b19736fd3a9032":"5qxSW","a5d211392b8418b5":"fAmfl","31b0eaaa03acc8fd":"aqLjQ","fa2fc2ec065e4ad9":"8X7ov","b5c4883735e8e0f1":"fA0LA","361fb2e805cb5811":"hAMmu","81db168f08e4d564":"37tJc","4158348b14eaf9f7":"cE6Se","cd84a69c5f638636":"avcfc","9a325e776a4f6d67":"6uln9","7c9181bc9624d1a5":"9Mqtv","2369826a0ddde48":"3Sg2u","524dc598e6319576":"iWCwP","56322a99bed88a40":"8MgRY","b237c91d36995a5c":"7Pq5E"}],"55UPn":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1054c58a62439253");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _highlightSubstring = _interopRequireDefault(require("d53ce0993a21d4f"));
var _default = _highlightSubstring["default"];
exports["default"] = _default;

},{"1054c58a62439253":"5qxSW","d53ce0993a21d4f":"j9Tyy"}],"j9Tyy":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7f79fff612133a2d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("7cbf8430c763f233"));
var _propTypes = _interopRequireDefault(require("30dab025049b0c18"));
var _escapeRegExp = _interopRequireDefault(require("a786a0f82e69de7"));
var _emotion = require("83d964c8bbf9f8fe");
var _typography = require("6992cc923f89fae2");
var maxMatchLength = 100;
var defaultMatchedStyles = (0, _emotion.css)({
    fontWeight: _typography.typographyFontWeightH300
});
var makeSubstringWithMatch = function makeSubstringWithMatch(text, match) {
    return {
        text: text,
        match: match
    };
};
/**
 * Parses string into an ordered array of objects with substrings
 * and if was a match or not.
 * getSubstringWithMatchBool(/abc/g, "abc def abc")
 * [ {text: "abc", match: true},
 *   {text: "def", match: false},
 *   {text: "abc", match: true} ]
 */ var getSubstringsWithMatchBool = function getSubstringsWithMatchBool(regexp, string) {
    var substringsWithMatchBool = [];
    var startBeforeIndex = 0;
    var match;
    do {
        match = regexp.exec(string);
        if (match) {
            var length = match[0].length;
            var matchText = string.substr(match.index, length);
            var beforeText = string.substr(startBeforeIndex, match.index - startBeforeIndex);
            if (beforeText) substringsWithMatchBool.push(makeSubstringWithMatch(beforeText, false));
            substringsWithMatchBool.push(makeSubstringWithMatch(matchText, true));
            startBeforeIndex = match.index + length;
        } // Keep looking for matches if we previously found a match
    // and our regular expression is global (i.e. get all matches)
    }while (match && regexp.global); // If there's still some text leftover at the end, gobble it up
    if (startBeforeIndex < string.length) {
        var restText = string.substr(startBeforeIndex);
        substringsWithMatchBool.push(makeSubstringWithMatch(restText, false));
    }
    return substringsWithMatchBool;
};
var HighlightSubstring = function HighlightSubstring(_ref) {
    var children = _ref.children, match = _ref.match, className = _ref.className;
    var string = Array.isArray(children) ? children.join("") : children;
    var regexp = match instanceof RegExp ? match : new RegExp((0, _escapeRegExp["default"])(match.substr(0, maxMatchLength)), "i");
    var substrings = getSubstringsWithMatchBool(regexp, string);
    return /*#__PURE__*/ _react["default"].createElement("span", null, substrings.map(function(_ref2, index) {
        var text = _ref2.text, match = _ref2.match;
        return !match ? /*#__PURE__*/ _react["default"].createElement(_react["default"].Fragment, {
            key: index
        }, text) : /*#__PURE__*/ _react["default"].createElement("span", {
            key: index,
            className: className
        }, text);
    }));
};
HighlightSubstring.propTypes = {};
HighlightSubstring.defaultProps = {
    className: defaultMatchedStyles
};
var _default = HighlightSubstring;
exports["default"] = _default;

},{"7f79fff612133a2d":"5qxSW","7cbf8430c763f233":"6uln9","30dab025049b0c18":"9Mqtv","a786a0f82e69de7":"8KiOd","83d964c8bbf9f8fe":"1BAMo","6992cc923f89fae2":"jsBpN"}],"4Qke3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c42f0e2bd4292055");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("6330e3ccab6a94cb"));
var _createClass2 = _interopRequireDefault(require("c994074a607b17c9"));
var _assertThisInitialized2 = _interopRequireDefault(require("28d6af13ccfb7273"));
var _inherits2 = _interopRequireDefault(require("a011255d30721e8f"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("ab806b7ec8f22505"));
var _getPrototypeOf2 = _interopRequireDefault(require("435bb2124aab3b71"));
var _defineProperty2 = _interopRequireDefault(require("82ce82201b17b4be"));
var _react = _interopRequireDefault(require("96c720869fb89fc7"));
var _propTypes = _interopRequireDefault(require("9469ec75fe5720fb"));
var _emotion = require("a9c09162511e8848");
var _popoverController = _interopRequireDefault(require("d38c02c971afb28e"));
var _bottomSheet = _interopRequireDefault(require("df5eb50813243560"));
var _token = require("dde533b341f846a0");
var _text = _interopRequireDefault(require("95752c101df859a9"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var popoverStyles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var anchorWidth = _ref.anchorWidth;
    return (0, _emotion.css)((0, _text["default"])(t), {
        boxSizing: "border-box",
        minWidth: anchorWidth,
        overflowY: "auto",
        outline: "none",
        backgroundColor: t("optionListBackgroundColor"),
        borderRadius: t("optionListBorderRadius"),
        border: t.borderCss("optionListBorder"),
        boxShadow: t.boxShadowCss("optionListShadow"),
        zIndex: t("optionListElevation")
    });
}, [
    "anchorWidth"
]);
var SelectOptionListContainer = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(SelectOptionListContainer, _React$Component);
    var _super = _createSuper(SelectOptionListContainer);
    function SelectOptionListContainer() {
        var _this;
        (0, _classCallCheck2["default"])(this, SelectOptionListContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopover", function() {
            return /*#__PURE__*/ _react["default"].createElement(_popoverController["default"], {
                open: _this.props.open,
                anchorNode: _this.props.popoverAnchorNode,
                anchorOrigin: "bottom left",
                popoverOrigin: "top left",
                offsetVertical: _this.props.t("optionListPopoverOffsetVertical"),
                maxHeight: _this.props.popoverMaxHeight,
                shrinkToFit: true,
                onOpen: _this.props.onOpenPopover
            }, function(_ref2) {
                var popoverStyle = _ref2.popoverStyle, anchorRect = _ref2.anchorRect;
                return /*#__PURE__*/ _react["default"].createElement("div", {
                    style: popoverStyle,
                    className: popoverStyles(_this.props.t, {
                        anchorWidth: anchorRect.width
                    })
                }, _this.props.children);
            });
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBottomSheet", function() {
            return /*#__PURE__*/ _react["default"].createElement(_bottomSheet["default"], {
                onClose: _this.props.onCloseBottomSheet,
                open: _this.props.open,
                type: "modal"
            }, _this.props.children);
        });
        return _this;
    }
    (0, _createClass2["default"])(SelectOptionListContainer, [
        {
            key: "render",
            value: function render() {
                return this.props.type === "popover" ? this.renderPopover() : this.renderBottomSheet();
            }
        }
    ]);
    return SelectOptionListContainer;
}(_react["default"].Component);
SelectOptionListContainer.propTypes = {};
var _default = SelectOptionListContainer;
exports["default"] = _default;

},{"c42f0e2bd4292055":"5qxSW","6330e3ccab6a94cb":"aqLjQ","c994074a607b17c9":"8X7ov","28d6af13ccfb7273":"fA0LA","a011255d30721e8f":"hAMmu","ab806b7ec8f22505":"37tJc","435bb2124aab3b71":"cE6Se","82ce82201b17b4be":"avcfc","96c720869fb89fc7":"6uln9","9469ec75fe5720fb":"9Mqtv","a9c09162511e8848":"1BAMo","d38c02c971afb28e":"4IZFM","df5eb50813243560":"iFJG3","dde533b341f846a0":"bebc4","95752c101df859a9":"g6RQX"}],"iFJG3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("649100aca39784b9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _bottomSheet = _interopRequireDefault(require("22a9a41a7e883cff"));
var _default = _bottomSheet["default"];
exports["default"] = _default;

},{"649100aca39784b9":"5qxSW","22a9a41a7e883cff":"3gKZY"}],"3gKZY":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e7592f2e8e4b9eb8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("6f79cdac5678fbe5"));
var _createClass2 = _interopRequireDefault(require("33d936bbb0f7f0e0"));
var _inherits2 = _interopRequireDefault(require("adc3fa1b7cf22fa8"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("ece2cec66978fe33"));
var _getPrototypeOf2 = _interopRequireDefault(require("a7d0007f5bcf6ed7"));
var _defineProperty2 = _interopRequireDefault(require("eaba5405fd4f51ea"));
var _react = _interopRequireDefault(require("56ba0cb24651eeb2"));
var _propTypes = _interopRequireDefault(require("c3ac53cf7add99ae"));
var _emotion = require("36e1522e1797f1d2");
var _noop = _interopRequireDefault(require("f07bb0f79124cda5"));
var _bottomSheet = _interopRequireDefault(require("ae7fdcc3ecf76e33"));
var _close = _interopRequireDefault(require("5bd1dc95c7df57b1"));
var _theme = require("a783ee539cc312c0");
var _sheet = _interopRequireDefault(require("75e00d99b66fcff9"));
var _button = _interopRequireDefault(require("2d91c6ace827cd27"));
var _icon = _interopRequireDefault(require("abb1ae00141843a"));
var _token = require("76f7a142dc6298d1");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var buttonWrapperStyles = (0, _emotion.css)({
    textAlign: "right"
});
/**
 * Render an element that provides access to secondary information via a sheet
 * that slides up from the bottom of the viewport.
 *
 * NOTICE: BottomSheet will be deprecated in the next major release 6.x in favor
 * of using [Sheet](https://meridian.a2z.com/components/sheet/).
 */ var BottomSheet = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(BottomSheet, _React$Component);
    var _super = _createSuper(BottomSheet);
    function BottomSheet() {
        (0, _classCallCheck2["default"])(this, BottomSheet);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(BottomSheet, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _bottomSheet["default"],
                    map: (0, _token.getTokenHelper)("bottomSheet")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_sheet["default"], {
                        open: props.open,
                        type: "overlay",
                        side: "bottom",
                        spacingInset: props.type === "modalWithControls" ? "small" : "none",
                        backgroundColor: t("backgroundColor"),
                        motionDuration: parseInt(t("motionTiming")),
                        motionFunction: t("motionFunction"),
                        onClose: props.onClose,
                        onOpen: props.onOpen,
                        id: props.id,
                        labelledById: props.labelledById,
                        describedById: props.describedById,
                        onFocus: props.onFocus,
                        onBlur: props.onBlur,
                        onKeyDown: props.onKeyDown
                    }, props.type === "modalWithControls" ? /*#__PURE__*/ _react["default"].createElement("div", {
                        className: buttonWrapperStyles
                    }, /*#__PURE__*/ _react["default"].createElement(_button["default"], {
                        type: "icon",
                        onClick: props.onClose,
                        size: "small"
                    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                        tokens: _close["default"]
                    }, props.closeLabel))) : null, /*#__PURE__*/ _react["default"].createElement("div", null, props.children));
                });
            }
        }
    ]);
    return BottomSheet;
}(_react["default"].Component);
(0, _defineProperty2["default"])(BottomSheet, "defaultProps", {
    type: "modal",
    onOpen: _noop["default"],
    closeLabel: "Close"
});
BottomSheet.propTypes = {};
var _default = BottomSheet;
exports["default"] = _default;

},{"e7592f2e8e4b9eb8":"5qxSW","6f79cdac5678fbe5":"aqLjQ","33d936bbb0f7f0e0":"8X7ov","adc3fa1b7cf22fa8":"hAMmu","ece2cec66978fe33":"37tJc","a7d0007f5bcf6ed7":"cE6Se","eaba5405fd4f51ea":"avcfc","56ba0cb24651eeb2":"6uln9","c3ac53cf7add99ae":"9Mqtv","36e1522e1797f1d2":"1BAMo","f07bb0f79124cda5":"hxHyu","ae7fdcc3ecf76e33":"gvycM","5bd1dc95c7df57b1":"2AQYC","a783ee539cc312c0":"dJlcb","75e00d99b66fcff9":"7qDip","2d91c6ace827cd27":"k0QSK","abb1ae00141843a":"8MgRY","76f7a142dc6298d1":"bebc4"}],"4y4sJ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8391bf114c5ac40b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _inputBox = _interopRequireDefault(require("997c2e2377d0201a"));
var _default = _inputBox["default"];
exports["default"] = _default;

},{"8391bf114c5ac40b":"5qxSW","997c2e2377d0201a":"1QDuD"}],"1QDuD":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("744c68be2bf22843");
var _interopRequireDefault = require("1ac802f8daafd5cc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("d3280de83a931a24"));
var _react = _interopRequireWildcard(require("990049c86cf853e3"));
var _propTypes = _interopRequireDefault(require("348b21a53fb447a7"));
var _emotion = require("ebf3190a149085a");
var _input = _interopRequireDefault(require("87d931d63bdb3c88"));
var _context = _interopRequireDefault(require("18c08dcca7262f3a"));
var _theme = require("9afbed370481f56c");
var _getIconCss = _interopRequireDefault(require("ebc737b2a0a6d85c"));
var _token = require("f98d2aca0c018f6b");
var _focusRing = _interopRequireDefault(require("83505a535da6ccd2"));
var _text = _interopRequireDefault(require("dfbf97813ce4bf22"));
var _noTextWrap = _interopRequireDefault(require("9f0d302b4b1e20e3"));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Styles
 */ /* Styles for the root element */ var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var cursor = _ref.cursor, size = _ref.size, focus = _ref.focus, error = _ref.error, disabled = _ref.disabled, width = _ref.width;
    var state = disabled ? "disabled" : focus ? "focus" : error ? "error" : "default";
    return (0, _emotion.css)((0, _text["default"])(t, {
        fontSize: size,
        lineHeight: "default",
        color: disabled ? "disabled" : "default"
    }), {
        display: "flex",
        boxSizing: "border-box",
        flexDirection: "row",
        justifyContent: "stretch",
        cursor: disabled ? "not-allowed" : cursor,
        borderRadius: t("borderRadius"),
        backgroundColor: t("backgroundColor", state),
        height: t("height", size),
        maxWidth: t("widthMax"),
        width: width,
        outline: "none",
        // If an explicit width is set then don't allow the input to flex
        flex: width ? "none !important" : undefined,
        borderWidth: t("borderWidth"),
        borderColor: t("borderColor", state),
        borderStyle: "solid"
    }, !disabled ? (0, _focusRing["default"])(t.tokens, {
        focus: focus,
        error: error,
        offset: 1,
        dropShadow: true,
        borderWidth: t("focusRingBorderWidth"),
        borderRadius: t("borderRadius")
    }) : undefined);
}, [
    "cursor",
    "size",
    "focus",
    "error",
    "disabled",
    "width"
]);
/* Styles for each segment of the input (e.g. an endcap, an icon, the input
container) */ var columnStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var size = _ref2.size, label = _ref2.label;
    var horizontalPadding = t("spacingInsetHorizontal");
    var verticalPadding = t("spacingInsetVertical", size); // If we have a label then reduce the top padding until the label is the same
    // number of pixels from the top as the original top padding when it's floated
    // down over the input
    var topPadding = label && verticalPadding > 0 ? verticalPadding - t("labelFloatDistance", size) : verticalPadding;
    return (0, _emotion.css)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "".concat(topPadding, "px ").concat(horizontalPadding, "px ").concat(verticalPadding, "px ").concat(horizontalPadding, "px")
    });
}, [
    "size",
    "label"
]);
var endcapBorderRadius = function endcapBorderRadius(radius, side) {
    return side === "left" ? "".concat(radius, "px 0 0 ").concat(radius, "px") : "0 ".concat(radius, "px ").concat(radius, "px 0");
};
var endcapBorderShadow = function endcapBorderShadow(t, _ref3) {
    var state = _ref3.state, side = _ref3.side;
    return side === "left" ? " 1px 0 0 0 ".concat(t("borderColor", state)) : "-1px 0 0 0 ".concat(t("borderColor", state));
};
/* Styles for the prefix/suffix caps on either end of the input */ var endcapStyles = (0, _token.memoizeTokenStyles)(function(t, _ref4) {
    var disabled = _ref4.disabled, side = _ref4.side, size = _ref4.size, label = _ref4.label;
    var state = disabled ? "disabled" : "default";
    return (0, _emotion.css)(columnStyles(t, {
        size: size,
        label: label
    }), {
        flexShrink: 0,
        backgroundColor: t("endcapBackgroundColor"),
        borderRadius: endcapBorderRadius(t("endcapBorderRadius"), side),
        boxShadow: endcapBorderShadow(t, {
            state: state,
            side: side
        })
    }, _noTextWrap["default"]);
}, [
    "disabled",
    "side",
    "size",
    "label"
]);
/* Styles for everything in-between the endcaps */ // since the aislestyle and columnstyle shares the same attributes
// we can memoize them together
var aisleStyles = (0, _token.memoizeTokenStyles)(function(t, _ref5) {
    var size = _ref5.size, label = _ref5.label;
    return (0, _emotion.css)(columnStyles(t, {
        size: size,
        label: label
    }), {
        flex: "auto",
        overflow: "hidden"
    });
}, [
    "size",
    "label"
]);
var labelStyles = (0, _token.memoizeTokenStyles)(function(t, _ref6) {
    var animated = _ref6.animated, focus = _ref6.focus, disabled = _ref6.disabled, floated = _ref6.floated, size = _ref6.size;
    var colorState = disabled ? "disabled" : focus ? "focus" : "default";
    return (0, _emotion.css)({
        display: "block",
        cursor: "inherit",
        color: t("labelColor", colorState),
        fontSize: t("labelFontSizeDefault"),
        marginBottom: t("spacingVertical"),
        transformOrigin: "top left",
        transform: floated ? "translateY(0px) scale(".concat(t("labelFontSizeFloated") / t("labelFontSizeDefault"), ")") : "translateY(".concat(t("labelFloatDistance", size), "px) scale(1)"),
        transition: animated ? t.transitionCss("labelMotion", [
            "color",
            "transform"
        ]) : undefined
    }, _noTextWrap["default"]);
}, [
    "animated",
    "focus",
    "disabled",
    "floated",
    "size"
]);
var iconStyles = (0, _token.memoizeTokenStyles)(function(t, _ref7) {
    var tokens = _ref7.tokens, disabled = _ref7.disabled, position = _ref7.position;
    var state = disabled ? "disabled" : "default";
    var _getIconFromTokens = (0, _token.getIconFromTokens)(tokens), width = _getIconFromTokens.width, data = _getIconFromTokens.data;
    return (0, _emotion.css)({
        flexShrink: 0,
        width: width,
        margin: position === "prefix" ? "0 0 0 ".concat(t("spacingInsetHorizontal"), "px") : "0 ".concat(t("spacingInsetHorizontal"), "px 0 0"),
        backgroundImage: (0, _getIconCss["default"])(data, t("foregroundColor", state)),
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    });
}, [
    "tokens",
    "disabled",
    "position"
]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function(t, _ref8) {
    var size = _ref8.size, disabled = _ref8.disabled, empty = _ref8.empty, label = _ref8.label, floated = _ref8.floated;
    var state = disabled ? "disabled" : "default";
    return (0, _emotion.css)({
        position: "relative",
        color: empty ? t("placeholderColor", state) : undefined,
        minHeight: t("lineHeight", size),
        lineHeight: t("lineHeight", size),
        opacity: label && !floated ? 0 : 1,
        pointerEvents: disabled ? "none" : undefined
    });
}, [
    "size",
    "disabled",
    "empty",
    "label",
    "floated"
]);
/**
 * Component
 */ function InputBox(props) {
    var t = (0, _theme.useTheme)(_input["default"], "input");
    var _useContext = (0, _react.useContext)(_context["default"]), onFocus = _useContext.onFocus, onBlur = _useContext.onBlur;
    var styleProps = _objectSpread(_objectSpread({}, props), {}, {
        // If we have a label then the size must be at least "xlarge"
        size: props.label && props.size !== "xlarge" && props.size !== "auto" ? "xlarge" : props.size,
        floated: !props.label || (props.labelFloated !== undefined ? props.labelFloated : !props.empty || props.focus)
    });
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, styleProps),
        onMouseDown: props.onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        tabIndex: "-1"
    }, props.prefix ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            side: "left"
        }))
    }, props.prefix) : null, props.prefixIconTokens ? /*#__PURE__*/ _react["default"].createElement("div", {
        role: "img",
        "aria-hidden": "true",
        className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            tokens: props.prefixIconTokens,
            position: "prefix"
        }))
    }) : null, /*#__PURE__*/ _react["default"].createElement("div", {
        className: aisleStyles(t, styleProps)
    }, props.label ? /*#__PURE__*/ _react["default"].createElement("label", {
        className: labelStyles(t, styleProps),
        htmlFor: props.htmlFor
    }, props.label) : null, /*#__PURE__*/ _react["default"].createElement("div", {
        className: childrenStyles(t, styleProps)
    }, props.children)), props.suffixIconTokens ? /*#__PURE__*/ _react["default"].createElement("div", {
        role: "img",
        "aria-hidden": "true",
        className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            tokens: props.suffixIconTokens,
            position: "suffix"
        }))
    }) : null, props.suffix ? typeof props.suffix === "string" ? /*#__PURE__*/ _react["default"].createElement("div", {
        className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
            side: "right"
        }))
    }, props.suffix) : props.suffix : null);
}
InputBox.propTypes = {};
InputBox.defaultProps = {
    size: "medium",
    cursor: "default",
    animated: true
};
var _default = InputBox;
exports["default"] = _default;

},{"744c68be2bf22843":"4RXTR","1ac802f8daafd5cc":"5qxSW","d3280de83a931a24":"avcfc","990049c86cf853e3":"6uln9","348b21a53fb447a7":"9Mqtv","ebf3190a149085a":"1BAMo","87d931d63bdb3c88":"gtfqn","18c08dcca7262f3a":"jFKkg","9afbed370481f56c":"dJlcb","ebc737b2a0a6d85c":"dVcs8","f98d2aca0c018f6b":"bebc4","83505a535da6ccd2":"5Dvm2","dfbf97813ce4bf22":"g6RQX","9f0d302b4b1e20e3":"9CFwe"}],"jFKkg":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("7211422aac3cd713");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("ea6350dd7cb1a576"));
var _default = /*#__PURE__*/ _react["default"].createContext({});
exports["default"] = _default;

},{"7211422aac3cd713":"5qxSW","ea6350dd7cb1a576":"6uln9"}],"b5STI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = require("d463bd80a3ea3561");
var _default = /*#__PURE__*/ (0, _react.createContext)({});
exports["default"] = _default;

},{"d463bd80a3ea3561":"6uln9"}],"jXzjN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var inputReset = function inputReset(_ref) {
    var textColor = _ref.textColor, placeholderColor = _ref.placeholderColor, empty = _ref.empty;
    return {
        display: "block",
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        width: "100%",
        color: textColor,
        WebkitTextFillColor: empty ? placeholderColor : textColor,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        outline: "none",
        // Base built-in style resets
        WebkitAppearance: "none",
        MozAppearance: "textfield",
        // Remove the clear button from search inputs
        "::-ms-clear": {
            display: "none"
        },
        "::-ms-reveal": {
            display: "none"
        },
        "::-webkit-search-decoration": {
            display: "none"
        },
        "::-webkit-search-cancel-button": {
            display: "none"
        },
        "::-webkit-search-results-button": {
            display: "none"
        },
        "::-webkit-search-results-decoration ": {
            display: "none"
        },
        // Remove the built-in error outline
        ":invalid": {
            boxShadow: "none"
        },
        ":-moz-submit-invalid": {
            boxShadow: "none"
        },
        ":-moz-ui-invalid": {
            boxShadow: "none"
        },
        // Remove the numeric input up/down buttons in webkit
        "::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: "0"
        },
        "::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: "0"
        },
        // Set the placeholder colors
        "::-moz-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        ":-moz-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        "::-ms-input-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        ":-ms-input-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        "::-webkit-input-placeholder": {
            opacity: "1",
            color: placeholderColor
        },
        "::placeholder": {
            opacity: "1",
            color: placeholderColor
        }
    };
};
var _default = inputReset;
exports["default"] = _default;

},{}],"hwkgx":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e3ac1bf1dccdccf8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _tag = _interopRequireDefault(require("8bea782cff1bfb2a"));
var _default = _tag["default"];
exports["default"] = _default;

},{"e3ac1bf1dccdccf8":"5qxSW","8bea782cff1bfb2a":"7SLEv"}],"7SLEv":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("1a30163d0fe65985");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("19b148586fadd5dd"));
var _propTypes = _interopRequireDefault(require("3cc210bca8d6d225"));
var _statusTag = _interopRequireDefault(require("f3cf6aa7e467c46b"));
var _dismissibleTag = _interopRequireDefault(require("2d724c87030b2e7a"));
var Tag = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return props.onClose && (props.type === "theme" || props.type === "neutral") && props.children ? /*#__PURE__*/ _react["default"].createElement(_dismissibleTag["default"], {
        onClose: props.onClose,
        closeLabel: props.closeLabel,
        type: props.type,
        ref: ref,
        "aria-label": props["aria-label"]
    }, props.children) : /*#__PURE__*/ _react["default"].createElement(_statusTag["default"], {
        type: props.type,
        ref: ref,
        "aria-label": props["aria-label"]
    }, props.children);
});
Tag.displayName = "Tag";
Tag.propTypes = {
    /**
   * An accessible label for the component. This will not be visible in the UI,
   * but will be read by screen readers. This is particularly helpful for
   * compact tags which don't have textual content.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */ "aria-label": _propTypes["default"].string,
    /**
   * The tag's label. Omit this to render a compact tag.
   */ children: _propTypes["default"].string,
    /**
   * An accessible label for the tag's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   *
   * @since 4.x
   */ closeLabel: _propTypes["default"].string,
    /**
   * The visual style of the tag.
   */ type: _propTypes["default"].oneOf([
        "theme",
        "neutral",
        "success",
        "warning",
        "error"
    ]),
    /**
   * If `type` is set to `"theme"` or `"neutral"`, a function can be provided
   * here to render a dismissable tag.
   *
   * This prop will be ignored for compact tags (if `children` is not set) or
   * for tags that are not of type `"theme"` or `"neutral"`.
   */ onClose: _propTypes["default"].func
};
Tag.defaultProps = {
    type: "theme"
};
var _default = Tag;
exports["default"] = _default;

},{"1a30163d0fe65985":"5qxSW","19b148586fadd5dd":"6uln9","3cc210bca8d6d225":"9Mqtv","f3cf6aa7e467c46b":"3webW","2d724c87030b2e7a":"jzaBZ"}],"3webW":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("197e8d1063cb853c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("def2e5874bff75c9"));
var _propTypes = _interopRequireDefault(require("1c38fbeaadbfd05c"));
var _theme = require("15125344ccf5b345");
var _emotion = require("1a56fffe497aef1d");
var _buttonReset = _interopRequireDefault(require("7279a26318279680"));
var _tag = _interopRequireDefault(require("373924bb9b53f7a3"));
var _token = require("689c3dbc480eb328");
var _text = _interopRequireDefault(require("9083f51943328c6a"));
var _indicator = _interopRequireDefault(require("fc6f37c838e79d0a"));
/**
 * Styles
 */ // HACK: This is necessary to keep IE11 from allowing the tag's text to overflow
// the boundaries of the tag. When we drop IE11 support this wrapper can be
// removed and the "display" property of the styles below can be changed from
// "flex" to "inline-flex".
var wrapperStylesForIE11 = (0, _emotion.css)({
    display: "inline-block"
});
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var type = _ref.type, children = _ref.children;
    return (0, _emotion.css)(_buttonReset["default"], (0, _text["default"])(t), {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: t("height"),
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, children === undefined ? {
        width: t("height")
    } : {
        borderRadius: t("borderRadius"),
        borderWidth: t("borderWidth"),
        borderStyle: "solid",
        borderColor: t("borderColorStatus", type),
        paddingRight: t("spacingInsetStatusRight"),
        paddingLeft: t("spacingInsetStatusLeft")
    });
}, [
    "type",
    "children"
]);
/**
 * Component
 */ var StatusTag = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_tag["default"], "tag");
    var compact = typeof props.children === "undefined" ? true : false;
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: wrapperStylesForIE11,
        ref: ref,
        "aria-label": props["aria-label"]
    }, /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, props)
    }, /*#__PURE__*/ _react["default"].createElement(_indicator["default"], {
        type: props.type,
        compact: compact
    }), /*#__PURE__*/ _react["default"].createElement("span", null, props.children)));
});
StatusTag.displayName = "StatusTag";
StatusTag.propTypes = {};
StatusTag.defaultProps = {
    type: "theme"
};
var _default = StatusTag;
exports["default"] = _default;

},{"197e8d1063cb853c":"5qxSW","def2e5874bff75c9":"6uln9","1c38fbeaadbfd05c":"9Mqtv","15125344ccf5b345":"dJlcb","1a56fffe497aef1d":"1BAMo","7279a26318279680":"eH0Hx","373924bb9b53f7a3":"gdSxN","689c3dbc480eb328":"bebc4","9083f51943328c6a":"g6RQX","fc6f37c838e79d0a":"gWLJ5"}],"gdSxN":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        tagFontSize: 14,
        tagHeight: 20,
        tagIndicatorDiameter: 12,
        tagCloseIconMotionDuration: "100ms",
        tagCloseIconMotionFunction: "ease",
        tagCloseIconSize: 16,
        tagCloseIconColorDismissibleThemeDefault: tokens.themeForegroundAccentDefault,
        tagCloseIconColorDismissibleThemeHover: tokens.themeForegroundAccentHover,
        tagCloseIconColorDismissibleThemePressed: tokens.themeForegroundAccentPressed,
        tagCloseIconColorDismissibleThemeFocus: tokens.themeForegroundAccentHover,
        tagCloseIconColorDismissibleNeutralDefault: tokens.themeForegroundTertiaryDefault,
        tagCloseIconColorDismissibleNeutralHover: tokens.themeForegroundSecondaryDefault,
        tagCloseIconColorDismissibleNeutralPressed: tokens.themeForegroundTertiaryPressed,
        tagCloseIconColorDismissibleNeutralFocus: tokens.themeForegroundSecondaryDefault,
        tagSpacingInsetStatusRight: 12,
        tagSpacingInsetStatusLeft: 4,
        tagSpacingInsetDismissibleRight: 2,
        tagSpacingInsetDismissibleLeft: 8,
        tagSpacingHorizontal: 8,
        tagBackgroundColorDismissibleTheme: tokens.themeBackgroundAccentDefault,
        tagBackgroundColorDismissibleNeutral: tokens.themeBackgroundTertiaryDefault,
        tagBorderWidth: 1,
        tagBorderRadius: 13,
        tagBorderColorStatusSuccess: "#ADE422",
        tagBorderColorStatusWarning: "#FAD000",
        tagBorderColorStatusError: "#CC0C39",
        tagBorderColorStatusNeutral: tokens.themeForegroundPrimaryDisabled,
        tagBorderColorStatusTheme: tokens.themeBorderAccentDefault,
        tagBorderColorDismissibleTheme: tokens.themeBorderAccentDefault,
        tagBorderColorDismissibleNeutral: tokens.themeForegroundPrimaryDisabled
    };
};

},{}],"gWLJ5":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("5178c9cbc34381be");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("ed69e2f664efb033"));
var _propTypes = _interopRequireDefault(require("4d078b003aabcf78"));
var _theme = require("9639519394b92cab");
var _emotion = require("2209ae32d389de39");
var _tag = _interopRequireDefault(require("c254325c384b90b9"));
/**
 * Styles
 */ var styles = function styles(t, _ref) {
    var type = _ref.type, compact = _ref.compact;
    return (0, _emotion.css)({
        display: "inline-block",
        width: t("indicatorDiameter"),
        height: t("indicatorDiameter"),
        backgroundColor: t("borderColorStatus", type),
        borderRadius: t("indicatorDiameter") / 2,
        marginRight: compact ? 0 : t("spacingHorizontal"),
        flexShrink: 0
    });
};
/**
 * Component
 */ function Indicator(props) {
    var t = (0, _theme.useTheme)(_tag["default"], "tag");
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, props)
    });
}
Indicator.propTypes = {};
Indicator.defaultProps = {
    type: "theme"
};
var _default = Indicator;
exports["default"] = _default;

},{"5178c9cbc34381be":"5qxSW","ed69e2f664efb033":"6uln9","4d078b003aabcf78":"9Mqtv","9639519394b92cab":"dJlcb","2209ae32d389de39":"1BAMo","c254325c384b90b9":"gdSxN"}],"jzaBZ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f232d02203d91ab5");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("d9361e727d27f554"));
var _react = _interopRequireDefault(require("bfec086ccf01ab06"));
var _propTypes = _interopRequireDefault(require("b4fe658143f6344b"));
var _theme = require("bec2cd53d86f1959");
var _useFocus2 = _interopRequireDefault(require("9ddbf580718c5f85"));
var _emotion = require("a0a878a2b55d3233");
var _tag = _interopRequireDefault(require("d7b11ed351de40d5"));
var _closeKnockout = _interopRequireDefault(require("19227d52b8c2cb32"));
var _clickable = _interopRequireDefault(require("45b33b963c3470b4"));
var _icon = _interopRequireDefault(require("ffc87b773b17cebe"));
var _token = require("c6966981a8938c7");
var _focusRing = _interopRequireDefault(require("2f1d5eba078b9795"));
var _text = _interopRequireDefault(require("4ae2d075ebe571f"));
/**
 * Styles
 */ var clickTargetSize = 20;
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var type = _ref.type;
    // This is the horizontal distance between the end of the icon and the end of the clickable,
    // on both the left and right side.
    var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
    return (0, _emotion.css)((0, _text["default"])(t), {
        backgroundColor: t("backgroundColorDismissible", type),
        borderRadius: t("borderRadius"),
        paddingRight: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px) "),
        paddingLeft: t("spacingInsetDismissibleLeft"),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: t("height"),
        lineHeight: "".concat(t("height"), "px"),
        whiteSpace: "nowrap",
        "& > button": {
            marginLeft: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)"),
            // HACK: revert line-height to 0 to keep button icon
            // centered vertically
            lineHeight: 0
        }
    });
}, [
    "type"
]);
var buttonStyles = (0, _token.memoizeTokenStyles)(function(t, _ref2) {
    var focus = _ref2.focus;
    var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
    return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
        focus: focus,
        borderRadius: 999,
        offset: 4 - iconClickableXDelta
    }), {
        width: clickTargetSize,
        height: clickTargetSize,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center"
    });
}, [
    "focus"
]);
var closeIconStyles = (0, _token.memoizeTokenStyles)(function(t, _ref3) {
    var type = _ref3.type;
    return (0, _emotion.css)({
        width: t("closeIconSize"),
        height: t("closeIconSize"),
        color: t("closeIconColorDismissible", [
            type,
            "default"
        ]),
        "button:hover &": {
            color: t("closeIconColorDismissible", [
                type,
                "hover"
            ])
        },
        "button:active &": {
            color: t("closeIconColorDismissible", [
                type,
                "pressed"
            ])
        },
        transition: t.transitionCss("closeIconMotion", "color")
    });
}, [
    "type"
]);
/**
 * Component
 */ var DissmissibleTag = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    var t = (0, _theme.useTheme)(_tag["default"], "tag");
    var _useFocus = (0, _useFocus2["default"])(), focus = _useFocus.focus, focusTrigger = _useFocus.focusTrigger, focusProps = _useFocus.focusProps;
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, {
            type: props.type
        }),
        ref: ref,
        "aria-label": props["aria-label"]
    }, /*#__PURE__*/ _react["default"].createElement("span", null, props.children), /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({
        onClick: props.onClose,
        className: buttonStyles(t, {
            focus: focus && focusTrigger === "keyboard"
        })
    }, focusProps, {
        "aria-label": props.closeLabel
    }), /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        className: closeIconStyles(t, props),
        tokens: _closeKnockout["default"]
    })));
});
DissmissibleTag.displayName = "DissmissibleTag";
DissmissibleTag.propTypes = {};
DissmissibleTag.defaultProps = {
    type: "theme"
};
var _default = DissmissibleTag;
exports["default"] = _default;

},{"f232d02203d91ab5":"5qxSW","d9361e727d27f554":"fAmfl","bfec086ccf01ab06":"6uln9","b4fe658143f6344b":"9Mqtv","bec2cd53d86f1959":"dJlcb","9ddbf580718c5f85":"7jVM9","a0a878a2b55d3233":"1BAMo","d7b11ed351de40d5":"gdSxN","19227d52b8c2cb32":"jgF95","45b33b963c3470b4":"iWCwP","ffc87b773b17cebe":"8MgRY","c6966981a8938c7":"bebc4","2f1d5eba078b9795":"5Dvm2","4ae2d075ebe571f":"g6RQX"}],"jgF95":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconCloseKnockoutData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.411 8.003l2.126-2.126a1 1 0 10-1.414-1.414L7.998 6.588l-2.12-2.124a1 1 0 10-1.416 1.412l2.122 2.126-2.121 2.12a1 1 0 001.414 1.415l2.12-2.12 2.115 2.12a1 1 0 101.416-1.413L9.41 8.004zM8 16A8 8 0 118 0a8 8 0 010 16z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
    iconCloseKnockoutWidth: 16,
    iconCloseKnockoutHeight: 16
};

},{}],"haNx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLpSelectActions", ()=>useLpSelectActions);
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _index = require("@amzn/carrierlogistics-commons/dist/hooks/authorisation/index");
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _dspFeature = require("@amzn/carrierlogistics-commons/dist/utils/featureFlags/dspFeature");
var _lodash = require("lodash");
var _react = require("react");
var _analytics1 = require("../constants/analytics");
var _externalPassportUIConstants = require("../constants/externalPassportUIConstants");
var _window = require("../utils/window");
var _windowDefault = parcelHelpers.interopDefault(_window);
const useLpSelectActions = ()=>{
    const authorizedLps = (0, _index.useAuthorisedLps)();
    const authorizedDeliverServiceProviders = (0, _index.useAuthorisedDSPs)();
    const authorizedDSPs = (0, _dspFeature.isDSPFeatureEnabled)() ? authorizedDeliverServiceProviders : [];
    const lpSelected = (0, _index.useSelectedLp)();
    const [searchQuery, setSearchQuery] = (0, _react.useState)("");
    const setLpSelected = (0, _react.useCallback)((value)=>{
        const searchParams = new URLSearchParams((0, _windowDefault.default).location.search);
        searchParams.set((0, _externalPassportUIConstants.MONS_DIRECTOR_ID_QUERY_PARAM), value);
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.DROPDOWN_ITEM_CLICK), {
            action_properties: {
                name: (0, _analytics1.LP_SELECT_DROPDOWN_ITEM_CLICK)
            },
            extra_properties: {
                lpId: value
            }
        });
        (0, _windowDefault.default).location.search = searchParams.toString();
    }, []);
    return {
        lpData: searchQuery ? authorizedLps.filter(({ logisticsPartyDisplayName })=>logisticsPartyDisplayName?.toLowerCase()?.includes(searchQuery.toLowerCase())) : authorizedLps,
        dspData: searchQuery ? authorizedDSPs.filter(({ logisticsPartyDisplayName })=>logisticsPartyDisplayName?.toLowerCase()?.includes(searchQuery.toLowerCase())) : authorizedDSPs,
        lpIdSelected: (0, _lodash.isEmpty)(authorizedLps) || (0, _lodash.isEmpty)(lpSelected?.directedLpId) ? "" : lpSelected.directedLpId,
        setLpSelected,
        searchQuery,
        setSearchQuery
    };
};
exports.default = useLpSelectActions;

},{"@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","@amzn/carrierlogistics-commons/dist/hooks/authorisation/index":"jz3IT","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/carrierlogistics-commons/dist/utils/featureFlags/dspFeature":"jKlob","lodash":"3hMBK","react":"6uln9","../constants/analytics":"zH2LJ","../constants/externalPassportUIConstants":"gaxjj","../utils/window":"4IKui","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lohWh":[function(require,module,exports) {
module.exports = require("47de5da25b77ca6b").getBundleURL("ciDtH") + "not-found.6a9ec007.svg";

},{"47de5da25b77ca6b":"c7Tr5"}],"72M2v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _select = require("@amzn/meridian/select");
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
const SelectOptionGroup = ({ label })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.SelectOption), {
        label: "",
        disabled: true,
        children: ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
                minHeight: "35px"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
                fontFamily: "bookerly",
                type: "h100"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
                id: label
            })))
    });
};
exports.default = SelectOptionGroup;

},{"@amzn/meridian/row":"ba4AQ","@amzn/meridian/select":"iCetS","@amzn/meridian/text":"hj2bM","react":"6uln9","react-intl":"4kbQW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gkJqv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pumsprovider = require("@amzn/PassportUserManagementUIAssets/dist/PUMSProvider");
var _pumsproviderDefault = parcelHelpers.interopDefault(_pumsprovider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _languageToggle = require("../components/LanguageToggle");
var _languageToggleDefault = parcelHelpers.interopDefault(_languageToggle);
const LanguageToggleModule = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pumsproviderDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _languageToggleDefault.default), null));
exports.default = LanguageToggleModule;

},{"@amzn/PassportUserManagementUIAssets/dist/PUMSProvider":"f63ez","react":"6uln9","../components/LanguageToggle":"U32fp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"U32fp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageToggle", ()=>LanguageToggle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("@amzn/meridian/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _tooltip = require("@amzn/meridian/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _column = require("@amzn/meridian/column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _reactRouter = require("react-router");
var _useUserProfile = require("@amzn/PassportUserManagementUIAssets/dist/hooks/useUserProfile");
var _useUserProfileDefault = parcelHelpers.interopDefault(_useUserProfile);
var _useUpdateUserLocale = require("@amzn/PassportUserManagementUIAssets/dist/hooks/useUpdateUserLocale");
var _useUpdateUserLocaleDefault = parcelHelpers.interopDefault(_useUpdateUserLocale);
var _carrierLogisticsCommonsContext = require("@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsContext");
var _carrierLogisticsCommonsContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsContext);
var _carrierLogisticsCommonsDispatchContext = require("@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsDispatchContext");
var _carrierLogisticsCommonsDispatchContextDefault = parcelHelpers.interopDefault(_carrierLogisticsCommonsDispatchContext);
var _localeUtils = require("../utils/localeUtils");
var _i18N = require("../config/i18n");
var _routeConfig = require("../routeConfig");
var _routeConfigDefault = parcelHelpers.interopDefault(_routeConfig);
var _localisation = require("../constants/localisation");
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _analytics1 = require("../constants/analytics");
const LanguageToggle = ()=>{
    const { pathname } = (0, _reactRouter.useLocation)();
    const { defaultLocale = (0, _i18N.DEFAULT_LOCALE) } = (0, _useUserProfileDefault.default)();
    const { localization: { locale = (0, _i18N.DEFAULT_LOCALE) } } = (0, _react.useContext)((0, _carrierLogisticsCommonsContextDefault.default));
    const { localisationDispatch } = (0, _react.useContext)((0, _carrierLogisticsCommonsDispatchContextDefault.default));
    const { updateUserLocale } = (0, _useUpdateUserLocaleDefault.default)();
    const toggleLocale = (0, _react.useCallback)((value)=>{
        localisationDispatch?.dispatchStoreLocale(value);
        (0, _localeUtils.setLocaleForAuthPortal)(value.replace("-", "_"));
        (0, _localeUtils.setLocaleToLocalStorage)(value.replace("-", "_"));
        if (value) {
            (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.DROPDOWN_ITEM_CLICK), {
                action_properties: {
                    name: (0, _analytics1.LOCALE_DROPDOWN_ITEM_CLICK)
                },
                extra_properties: {
                    locale: value
                }
            });
            updateUserLocale({
                defaultLocale: value.replace("-", "_")
            });
        }
    }, [
        localisationDispatch,
        updateUserLocale
    ]);
    (0, _react.useEffect)(()=>{
        localisationDispatch?.dispatchStoreLocale(defaultLocale === (0, _coralComAmazonPassportusermanagementservice.Locale).EN ? (0, _i18N.DEFAULT_LOCALE) : defaultLocale.replace("_", "-"));
    }, [
        defaultLocale
    ]);
    const getLocaleOptions = ()=>Object.keys((0, _coralComAmazonPassportusermanagementservice.Locale)).slice(1).map((option)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _select.SelectOption), {
                label: (0, _coralComAmazonPassportusermanagementservice.LocaleUserFriendlyString)[option],
                value: (0, _coralComAmazonPassportusermanagementservice.Locale)[option].replace("_", "-"),
                key: (0, _coralComAmazonPassportusermanagementservice.Locale)[option].replace("_", "-")
            }));
    const isLanguageToggleDisabled = (0, _react.useMemo)(()=>{
        const requiredRouteConfig = (0, _routeConfigDefault.default).find((rc)=>{
            const match = (0, _reactRouter.matchPath)(pathname, {
                path: rc.path
            });
            return match?.path === rc.path || pathname.includes(rc.path);
        });
        if (requiredRouteConfig && requiredRouteConfig.isLanguageToggleSupported || pathname === "/") return false;
        return true;
    }, [
        pathname
    ]);
    const isLanguageToggleHidden = (0, _react.useMemo)(()=>{
        const requiredRouteConfig = (0, _routeConfigDefault.default).find((rc)=>{
            const match = (0, _reactRouter.matchPath)(pathname, {
                path: rc.path
            });
            return match?.path === rc.path || pathname.includes(rc.path);
        });
        return !!requiredRouteConfig?.isLanguageToggleHidden;
    }, [
        pathname
    ]);
    return !isLanguageToggleHidden && (isLanguageToggleDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        title: (0, _localisation.LANGUAGE_TOGGLE_UNSUPPORTED),
        position: "top"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _columnDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectDefault.default), {
        id: "language-toggle",
        value: (0, _i18N.DEFAULT_LOCALE),
        size: "small",
        disabled: true
    }, getLocaleOptions()))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectDefault.default), {
        id: "language-toggle",
        value: locale,
        onChange: toggleLocale,
        size: "small"
    }, getLocaleOptions()));
};
exports.default = LanguageToggle;

},{"react":"6uln9","@amzn/meridian/select":"iCetS","@amzn/meridian/tooltip":"6eaDA","@amzn/meridian/column":"jFRKf","@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","react-router":"i3TiW","@amzn/PassportUserManagementUIAssets/dist/hooks/useUserProfile":"9heHG","@amzn/PassportUserManagementUIAssets/dist/hooks/useUpdateUserLocale":"5tyJl","@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsContext":"kTkCE","@amzn/carrierlogistics-commons/dist/context/CarrierLogisticsCommonsDispatchContext":"dmv1W","../utils/localeUtils":"cEqPz","../config/i18n":"i9CgO","../routeConfig":"9yJqt","../constants/localisation":"gxvnc","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","../constants/analytics":"zH2LJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9heHG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUserProfile", ()=>useUserProfile);
var _lodash = require("lodash");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _userManagementActions = require("../actions/userManagementActions");
var _selectors = require("../actions/userManagementActions/selectors");
var _isSiteExternal = require("../utils/isSiteExternal");
var _isSiteExternalDefault = parcelHelpers.interopDefault(_isSiteExternal);
var useUserProfile = function() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var history = (0, _reactRouter.useHistory)();
    var user = (0, _reactRedux.useSelector)((0, _selectors.getUserProfileInfoSelector));
    (0, _react.useEffect)(function() {
        if ((0, _lodash.isEmpty)(user) && (0, _isSiteExternalDefault.default)()) dispatch((0, _userManagementActions.getUserProfileInfo).request({
            history: history
        }));
    }, [
        dispatch,
        history,
        user
    ]);
    return user;
};
exports.default = useUserProfile;

},{"lodash":"6tRyo","react":"6uln9","react-redux":"3qqlL","react-router":"i3TiW","../actions/userManagementActions":"fIUa9","../actions/userManagementActions/selectors":"11U93","../utils/isSiteExternal":"76p21","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"11U93":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userSelector", ()=>userSelector);
parcelHelpers.export(exports, "getUserProfileInfoSelector", ()=>getUserProfileInfoSelector);
parcelHelpers.export(exports, "getInvitationStatus", ()=>getInvitationStatus);
parcelHelpers.export(exports, "getUsersListSelector", ()=>getUsersListSelector);
parcelHelpers.export(exports, "getInvitationsListSelector", ()=>getInvitationsListSelector);
parcelHelpers.export(exports, "getUsersListErrorSelector", ()=>getUsersListErrorSelector);
parcelHelpers.export(exports, "getCreateInvitationSuccessSelector", ()=>getCreateInvitationSuccessSelector);
parcelHelpers.export(exports, "getDeactivatedUsersSelector", ()=>getDeactivatedUsersSelector);
parcelHelpers.export(exports, "getRequestedUserDetailsSelector", ()=>getRequestedUserDetailsSelector);
var _reselect = require("reselect");
var userSelector = function(state) {
    return state.userManagement;
};
var getUserProfileInfoSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var user = param.user;
    return user;
});
var getInvitationStatus = (0, _reselect.createSelector)(userSelector, function(param) {
    var invitationStatus = param.invitationStatus;
    return invitationStatus;
});
var getUsersListSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var usersList = param.usersList;
    return usersList;
});
var getInvitationsListSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var invitationsList = param.invitationsList;
    return invitationsList;
});
var getUsersListErrorSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var usersListError = param.usersListError;
    return usersListError;
});
var getCreateInvitationSuccessSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var createInvitationSuccess = param.createInvitationSuccess;
    return createInvitationSuccess;
});
var getDeactivatedUsersSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var deactivatedUsersList = param.deactivatedUsersList;
    return deactivatedUsersList;
});
var getRequestedUserDetailsSelector = (0, _reselect.createSelector)(userSelector, function(param) {
    var requestedUserProfileDetails = param.requestedUserProfileDetails;
    return requestedUserProfileDetails;
});

},{"reselect":"i8if6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8if6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"dXNh9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXNh9":[function(require,module,exports) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5tyJl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUpdateUserLocale", ()=>useUpdateUserLocale);
var _react = require("react");
var _coralComAmazonPassportusermanagementservice = require("@amzn/coral_com-amazon-passportusermanagementservice");
var _reactRedux = require("react-redux");
var _userManagementActions = require("../actions/userManagementActions");
var _selectors = require("../actions/userManagementActions/selectors");
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useUpdateUserLocale = function() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var userObject = (0, _reactRedux.useSelector)((0, _selectors.getUserProfileInfoSelector));
    var updateUserLocale = (0, _react.useCallback)(function(payload) {
        dispatch((0, _userManagementActions.updateUserLocaleAction).request((0, _coralComAmazonPassportusermanagementservice.User).clone(_objectSpread({}, userObject, payload))));
    }, [
        dispatch,
        userObject
    ]);
    return {
        updateUserLocale: updateUserLocale
    };
};
exports.default = useUpdateUserLocale;

},{"react":"6uln9","@amzn/coral_com-amazon-passportusermanagementservice":"fKUeT","react-redux":"3qqlL","../actions/userManagementActions":"fIUa9","../actions/userManagementActions/selectors":"11U93","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6gMzn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useUserProfile = require("@amzn/PassportUserManagementUIAssets/dist/hooks/useUserProfile");
var _useUserProfileDefault = parcelHelpers.interopDefault(_useUserProfile);
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _breakpoints = require("@amzn/carrierlogistics-commons/dist/constants/breakpoints");
var _authorisation = require("@amzn/carrierlogistics-commons/dist/hooks/authorisation");
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _cog = require("@amzn/meridian-tokens/base/icon/cog");
var _cogDefault = parcelHelpers.interopDefault(_cog);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("@amzn/meridian/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _masthead = require("@amzn/meridian/masthead");
var _mastheadDefault = parcelHelpers.interopDefault(_masthead);
var _menu = require("@amzn/meridian/menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _responsive = require("@amzn/meridian/responsive");
var _responsiveDefault = parcelHelpers.interopDefault(_responsive);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _sideMenu = require("@amzn/meridian/side-menu");
var _sideMenuDefault = parcelHelpers.interopDefault(_sideMenu);
var _css = require("@emotion/css");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _navigationButtons = require("../components/NavigationButtons");
var _navigationButtonsDefault = parcelHelpers.interopDefault(_navigationButtons);
var _lpDropdown = require("../components/molecules/LpDropdown");
var _lpDropdownDefault = parcelHelpers.interopDefault(_lpDropdown);
var _manageUsersButton = require("../components/molecules/ManageUsersButton");
var _manageUsersButtonDefault = parcelHelpers.interopDefault(_manageUsersButton);
var _navigationalRoutes = require("../config/navigationalRoutes");
var _analytics1 = require("../constants/analytics");
var _common = require("../constants/common");
var _useNavigateToSpecifiedRoute = require("../hooks/useNavigateToSpecifiedRoute");
var _useNavigateToSpecifiedRouteDefault = parcelHelpers.interopDefault(_useNavigateToSpecifiedRoute);
var _useUserAccountActionRedirects = require("../hooks/useUserAccountActionRedirects");
var _useUserAccountActionRedirectsDefault = parcelHelpers.interopDefault(_useUserAccountActionRedirects);
var _carrierHubLogoSvg = require("../images/carrier-hub-logo.svg");
var _carrierHubLogoSvgDefault = parcelHelpers.interopDefault(_carrierHubLogoSvg);
var _clLogoSvg = require("../images/cl-logo.svg");
var _clLogoSvgDefault = parcelHelpers.interopDefault(_clLogoSvg);
var _getSettings = require("../utils/auth/getSettings");
var _getSettingsDefault = parcelHelpers.interopDefault(_getSettings);
var _authorizedPageUtils = require("../utils/authorizedPageUtils");
var _feedbackModule = require("./FeedbackModule");
var _feedbackModuleDefault = parcelHelpers.interopDefault(_feedbackModule);
var _inlineHelpModule = require("./InlineHelpModule");
var _inlineHelpModuleDefault = parcelHelpers.interopDefault(_inlineHelpModule);
var _languageToggleModule = require("./LanguageToggleModule");
var _languageToggleModuleDefault = parcelHelpers.interopDefault(_languageToggleModule);
const menubarLinkCss = (0, _css.css)`
  & {
    font-weight: 700;
    font-size: 14px;
  }
  &:hover {
    color: #4db9b0;
  }
`;
const getStartedHoverCss = (0, _css.css)`
  &:hover {
    color: #232f3e;
  }
`;
const TopBar = ({ onClick })=>{
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const { hasAdminRights } = (0, _authorisation.useLpAccessRights)();
    const selectedLp = (0, _authorisation.useSelectedLp)();
    const { lpId, logisticsPartyDisplayName, logisticsPartyName, countryCode } = selectedLp || {};
    const { userIdentifier, email } = (0, _useUserProfileDefault.default)();
    const isInternalUser = email && email.endsWith((0, _common.INTERNAL_USER_IDENTIFIER));
    const { customerId } = userIdentifier || {};
    // to render menu on mobile screen
    const [showSideBar, setShowSidebar] = (0, _react.useState)(false);
    const isNonSignedInPage = (0, _authorizedPageUtils.isANonSignedInPage)(pathname);
    const { signInRedirect, signOutRedirect } = (0, _useUserAccountActionRedirectsDefault.default)();
    const { navigateToSpecifiedRoute } = (0, _useNavigateToSpecifiedRouteDefault.default)();
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const handleSignOutClick = (0, _react.useCallback)(()=>{
        signOutRedirect();
        (0, _getSettingsDefault.default)().then(({ rumUIParams })=>{
            (0, _cloudwatchRum.setCustomSessionProperties)({}, rumUIParams);
        });
    }, [
        signOutRedirect
    ]);
    const onFAQClick = (0, _react.useCallback)(()=>{
        setShowSidebar(false);
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.HEADER_FAQ_BUTTON)
            }
        });
        navigateToSpecifiedRoute((0, _navigationalRoutes.FAQ_PAGE_PATH));
    }, [
        navigateToSpecifiedRoute
    ]);
    const onGetStartedClick = (0, _react.useCallback)(()=>{
        setShowSidebar(false);
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.HEADER_GET_STARTED_BUTTON)
            }
        });
        navigateToSpecifiedRoute((0, _navigationalRoutes.GET_STARTED_PATH));
    }, [
        navigateToSpecifiedRoute
    ]);
    const goToProfilePage = (0, _react.useCallback)(()=>{
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.MY_PROFILE_CLICK)
            }
        });
        navigateToSpecifiedRoute((0, _navigationalRoutes.PROFILE_PAGE));
    }, [
        navigateToSpecifiedRoute
    ]);
    const logoClickHandler = ()=>{
        navigateToSpecifiedRoute((0, _navigationalRoutes.HOME));
    };
    const goToManageUsersPage = (0, _react.useCallback)(()=>{
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.MANAGE_USERS_CLICK)
            }
        });
        navigateToSpecifiedRoute((0, _navigationalRoutes.MANAGE_USERS_PAGE));
    }, [
        navigateToSpecifiedRoute
    ]);
    const buttonRef = (0, _react.useRef)();
    const [open, setOpen] = (0, _react.useState)(false);
    const onSettingsClick = (0, _react.useCallback)(()=>{
        setOpen(true);
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.SETTINGS_BUTTON_CLICK)
            }
        });
    }, []);
    const onSettingsClose = (0, _react.useCallback)(()=>setOpen(false), []);
    (0, _react.useEffect)(()=>{
        const customSessionProperties = {
            ...lpId ? {
                logisticsPartyId: lpId
            } : {},
            ...logisticsPartyDisplayName ? {
                logisticsPartyDisplayName
            } : {},
            ...logisticsPartyName ? {
                logisticsPartyName
            } : {},
            ...customerId ? {
                customerId
            } : {},
            ...countryCode ? {
                countryCode
            } : {},
            isInternalUser: isInternalUser || false
        };
        if (Object.keys(customSessionProperties).length) (0, _getSettingsDefault.default)().then(({ rumUIParams })=>{
            (0, _cloudwatchRum.setCustomSessionProperties)(customSessionProperties, rumUIParams);
        });
    }, [
        lpId,
        logisticsPartyDisplayName,
        logisticsPartyName,
        customerId,
        countryCode
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveDefault.default), {
        query: "min-width",
        props: {
            isSmallScreen: {
                default: true,
                [(0, _breakpoints.DEVICE_WIDTHS).DESKTOP]: false
            },
            hideMenu: {
                default: false,
                [(0, _breakpoints.DEVICE_WIDTHS).DESKTOP]: true
            }
        }
    }, ({ isSmallScreen, hideMenu })=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "home-nav-header"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _mastheadDefault.default), {
            size: "large"
        }, !isNonSignedInPage && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _masthead.MastheadMenuButton), {
            onClick: onClick
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _masthead.MastheadTitle), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
            wrap: "down"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: (0, _carrierHubLogoSvgDefault.default),
            width: 195,
            alt: "Logo",
            onClick: logoClickHandler
        }), !isSmallScreen && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            selected: false
        }, (0, _authorizedPageUtils.isAuthorizedPage)(pathname) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _lpDropdownDefault.default), null)))), isNonSignedInPage ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, hideMenu ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _navigationButtonsDefault.default), {
            type: "link",
            onClick: onFAQClick,
            className: menubarLinkCss,
            text: "top_bar.frequently_asked_questions_button",
            color: "inverted"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _navigationButtonsDefault.default), {
            type: "link",
            onClick: signInRedirect,
            className: menubarLinkCss,
            text: "top_bar.sign_in_button",
            color: "inverted"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _languageToggleModuleDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _navigationButtonsDefault.default), {
            type: "secondary",
            onClick: onGetStartedClick,
            className: `${menubarLinkCss} ${getStartedHoverCss} `,
            text: "top_bar.get_started_button"
        })) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _masthead.MastheadMenuButton), {
            onClick: setShowSidebar,
            "data-testid": "homescreen-menu"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
            alignmentVertical: "stretch",
            spacing: "none"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenuDefault.default), {
            open: showSideBar,
            onClose: ()=>setShowSidebar(false),
            type: "overlay"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuTitle), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            src: (0, _clLogoSvgDefault.default),
            alt: ""
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
            selected: pathname.includes((0, _navigationalRoutes.FAQ_PAGE_PATH)),
            onClick: onFAQClick
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "top_bar.frequently_asked_questions_button"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
            onClick: signInRedirect
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "top_bar.sign_in_button"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _languageToggleModuleDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sideMenu.SideMenuLink), {
            selected: pathname.includes((0, _navigationalRoutes.GET_STARTED_PATH)),
            onClick: onGetStartedClick
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "top_bar.get_started_button"
        }))))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !isSmallScreen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _languageToggleModuleDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _feedbackModuleDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inlineHelpModuleDefault.default), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
            ref: buttonRef,
            onClick: onSettingsClick,
            type: "icon",
            size: "small",
            label: "settings",
            "aria-controls": "my-menu",
            "aria-haspopup": "menu",
            "aria-expanded": "false"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
            tokens: (0, _cogDefault.default)
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuDefault.default), {
            anchorNode: buttonRef.current,
            id: "my-menu",
            open: open,
            position: "left",
            onClose: onSettingsClose
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuItem), {
            onClick: goToProfilePage
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "top_bar.settings_menu.my_profile"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuItem), {
            disabled: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "top_bar.settings_menu.accounts"
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuItem), {
            onClick: goToManageUsersPage,
            disabled: !hasAdminRights
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _manageUsersButtonDefault.default), {
            hasAdminRights: hasAdminRights
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menu.MenuItem), {
            onClick: handleSignOutClick
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
            id: "top_bar.settings_menu.sign_out"
        })))))));
};
TopBar.propTypes = {
    onClick: (0, _propTypesDefault.default).func.isRequired
};
exports.default = TopBar;

},{"@amzn/PassportUserManagementUIAssets/dist/hooks/useUserProfile":"9heHG","@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","@amzn/carrierlogistics-commons/dist/constants/breakpoints":"65vIt","@amzn/carrierlogistics-commons/dist/hooks/authorisation":"jz3IT","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/meridian-tokens/base/icon/cog":"kGY9u","@amzn/meridian/button":"k0QSK","@amzn/meridian/icon":"8MgRY","@amzn/meridian/masthead":"jagoe","@amzn/meridian/menu":"13v5V","@amzn/meridian/responsive":"l7U3k","@amzn/meridian/row":"ba4AQ","@amzn/meridian/side-menu":"40yrh","@emotion/css":"awUBr","prop-types":"6FKs7","react":"6uln9","react-intl":"4kbQW","react-router-dom":"5fzqq","../components/NavigationButtons":"9WCze","../components/molecules/LpDropdown":"2P2ct","../components/molecules/ManageUsersButton":"7T7oW","../config/navigationalRoutes":"32s8M","../constants/analytics":"zH2LJ","../constants/common":"4gLZS","../hooks/useNavigateToSpecifiedRoute":"3G87j","../hooks/useUserAccountActionRedirects":"4CO0t","../images/carrier-hub-logo.svg":"2qJck","../images/cl-logo.svg":"bKAQK","../utils/auth/getSettings":"4BUv4","../utils/authorizedPageUtils":"8Nt2u","./FeedbackModule":"hGcLv","./InlineHelpModule":"gv7Md","./LanguageToggleModule":"gkJqv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kGY9u":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    iconCogData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='4'/%3e%3cpath d='M21 12a3 3 0 001.67 2.68 10.94 10.94 0 01-1.22 3 3 3 0 00-3.81 3.81 10.94 10.94 0 01-3 1.22 3 3 0 00-5.36 0 10.94 10.94 0 01-3-1.22 3 3 0 00-3.81-3.81 10.94 10.94 0 01-1.22-3 3 3 0 000-5.36 10.94 10.94 0 011.22-3 3 3 0 003.89-3.77 10.94 10.94 0 013-1.22 3 3 0 005.36 0 10.94 10.94 0 013 1.22 3 3 0 003.81 3.81 10.94 10.94 0 011.22 3A3 3 0 0021 12z' stroke-linecap='round'/%3e%3c/g%3e%3c/svg%3e",
    iconCogWidth: 24,
    iconCogHeight: 24
};

},{}],"jagoe":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b49574d2e36e2bc2");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MastheadLink", {
    enumerable: true,
    get: function get() {
        return _mastheadLink["default"];
    }
});
Object.defineProperty(exports, "MastheadTitle", {
    enumerable: true,
    get: function get() {
        return _mastheadTitle["default"];
    }
});
Object.defineProperty(exports, "MastheadMenuButton", {
    enumerable: true,
    get: function get() {
        return _mastheadMenuButton["default"];
    }
});
exports["default"] = void 0;
var _masthead = _interopRequireDefault(require("5cba4bddc94505d9"));
var _mastheadLink = _interopRequireDefault(require("eb8865babc540f67"));
var _mastheadTitle = _interopRequireDefault(require("d83fa119580d7f13"));
var _mastheadMenuButton = _interopRequireDefault(require("6530182090100043"));
var _default = _masthead["default"];
exports["default"] = _default;

},{"b49574d2e36e2bc2":"5qxSW","5cba4bddc94505d9":"9uA5r","eb8865babc540f67":"3t4qe","d83fa119580d7f13":"jAdWR","6530182090100043":"gwSmO"}],"9uA5r":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("88117bf7330312c5");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("368482ba122aef5c"));
var _createClass2 = _interopRequireDefault(require("2e8c1fb82c19c6bb"));
var _assertThisInitialized2 = _interopRequireDefault(require("8e8064fa63d46371"));
var _inherits2 = _interopRequireDefault(require("d7c6a8a1e805a058"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("f646b52568987ef8"));
var _getPrototypeOf2 = _interopRequireDefault(require("52bf0108d7bb769c"));
var _defineProperty2 = _interopRequireDefault(require("813b93f2d9ad0607"));
var _react = _interopRequireDefault(require("9a39f461276e46b9"));
var _propTypes = _interopRequireDefault(require("c3a5c9dc357ce232"));
var _emotion = require("be542ca8a9626790");
var _masthead = _interopRequireDefault(require("24aac9592c19afa8"));
var _mastheadLink = _interopRequireDefault(require("39aa1aa40636b48e"));
var _mastheadTitle = _interopRequireDefault(require("f9778170fc338ec8"));
var _mastheadMenuButton = _interopRequireDefault(require("1094dd07f0b746c2"));
var _theme = require("e6c5ffd69191baa7");
var _token = require("266d0b3eaf55971a");
var _isElementOf = _interopRequireDefault(require("6e941529b9a59324"));
var _isElementOfAny = _interopRequireDefault(require("f27aa0f63a6d8e28"));
var _text = _interopRequireDefault(require("2f8c9e93a1b8a1b4"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size;
    return (0, _emotion.css)((0, _text["default"])(t), {
        display: "flex",
        alignItems: "stretch",
        boxShadow: t.boxShadowCss("shadow"),
        backgroundColor: t("backgroundColor"),
        borderBottom: t.borderCss("border"),
        overflow: "hidden",
        minHeight: t("size", size),
        // Don't allow a flex parent to squish us
        flexShrink: 0,
        // This ensures that the masthead shadow is visible over elements below
        // it in webkit.
        position: "relative",
        zIndex: t("elevation"),
        // Title (and menu)
        "& > [mdn-masthead-title]": {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: size === "small" ? 0 : "8px 0"
        },
        // Links
        "& > [mdn-masthead-links]": {
            display: "flex",
            alignItems: "stretch",
            marginLeft: t("spacingHorizontal")
        },
        // Actions
        "& > [mdn-masthead-actions]": {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: "".concat(size === "small" ? "0px" : "8px", " ").concat(t("spacingHorizontal"), "px"),
            marginLeft: "auto",
            "& > * + *": {
                marginLeft: "8px !important"
            }
        },
        // HACK: IE11 doesn't respect min-height on a flex container, so we also
        // have to set the min height on all the children. See:
        // https://stackoverflow.com/a/40775383
        "& > *": {
            boxSizing: "border-box",
            minHeight: t("size", size)
        }
    });
}, [
    "size"
]);
/**
 * This component can be used to render a top navigation bar for your
 * application.
 */ var Masthead = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Masthead, _React$Component);
    var _super = _createSuper(Masthead);
    function Masthead() {
        var _this;
        (0, _classCallCheck2["default"])(this, Masthead);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMenuButton", (0, _isElementOf["default"])(_this.props.menuButtonComponent));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isTitle", (0, _isElementOf["default"])(_this.props.titleComponent));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isLink", (0, _isElementOfAny["default"])(_this.props.linkComponents));
        return _this;
    }
    (0, _createClass2["default"])(Masthead, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var size = this.props.size;
                var children = _react["default"].Children.toArray(this.props.children);
                var menuButton = children.filter(this.isMenuButton)[0];
                var title = children.filter(this.isTitle)[0];
                var links = children.filter(this.isLink).map(function(link) {
                    return /*#__PURE__*/ _react["default"].cloneElement(link, {
                        size: size
                    });
                });
                var actions = children.filter(function(child) {
                    return !_this2.isMenuButton(child) && !_this2.isTitle(child) && !_this2.isLink(child);
                });
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _masthead["default"],
                    map: (0, _token.getTokenHelper)("masthead")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement("nav", {
                        className: styles(t, {
                            size: size
                        })
                    }, menuButton || title ? /*#__PURE__*/ _react["default"].createElement("div", {
                        "mdn-masthead-title": ""
                    }, menuButton, title) : null, links.length ? /*#__PURE__*/ _react["default"].createElement("div", {
                        "mdn-masthead-links": ""
                    }, links) : null, actions.length > 0 ? /*#__PURE__*/ _react["default"].createElement("div", {
                        "mdn-masthead-actions": ""
                    }, actions) : null);
                });
            }
        }
    ]);
    return Masthead;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Masthead, "defaultProps", {
    size: "medium",
    menuButtonComponent: _mastheadMenuButton["default"],
    titleComponent: _mastheadTitle["default"],
    linkComponents: [
        _mastheadLink["default"]
    ]
});
Masthead.propTypes = {};
var _default = Masthead;
exports["default"] = _default;

},{"88117bf7330312c5":"5qxSW","368482ba122aef5c":"aqLjQ","2e8c1fb82c19c6bb":"8X7ov","8e8064fa63d46371":"fA0LA","d7c6a8a1e805a058":"hAMmu","f646b52568987ef8":"37tJc","52bf0108d7bb769c":"cE6Se","813b93f2d9ad0607":"avcfc","9a39f461276e46b9":"6uln9","c3a5c9dc357ce232":"9Mqtv","be542ca8a9626790":"1BAMo","24aac9592c19afa8":"3WGDk","39aa1aa40636b48e":"3t4qe","f9778170fc338ec8":"jAdWR","1094dd07f0b746c2":"gwSmO","e6c5ffd69191baa7":"dJlcb","266d0b3eaf55971a":"bebc4","6e941529b9a59324":"i2KEV","f27aa0f63a6d8e28":"bFGvy","2f8c9e93a1b8a1b4":"g6RQX"}],"3WGDk":[function(require,module,exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(tokens) {
    return {
        mastheadMobileShadowOffsetX: 0,
        mastheadMobileShadowOffsetY: 2,
        mastheadMobileShadowBlur: 4,
        mastheadMobileShadowSpread: 0,
        mastheadMobileShadowColor: "rgba(11, 12, 12, 0.16)",
        mastheadBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
        mastheadShadowOffsetX: 0,
        mastheadShadowOffsetY: 4,
        mastheadShadowBlur: 8,
        mastheadShadowSpread: 0,
        mastheadShadowColor: "rgba(11, 12, 12, 0.16)",
        mastheadElevation: 30,
        mastheadSpacingHorizontal: 16,
        mastheadMenuButtonWidth: 32,
        mastheadMenuButtonMotionDuration: "300ms",
        mastheadMenuButtonMotionFunction: "ease",
        mastheadSizeSmall: 36,
        mastheadSizeMedium: 48,
        mastheadSizeLarge: 56,
        mastheadLinkMotionDuration: "100ms",
        mastheadLinkMotionFunction: "ease",
        mastheadLinkSpacingInsetHorizontal: 16,
        mastheadLinkForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
        mastheadLinkForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
        mastheadLinkBackgroundColorHover: tokens.themeBackgroundAlternatePrimarySelected,
        mastheadLinkBackgroundColorPressed: tokens.themeBackgroundAlternatePrimaryHover,
        mastheadLinkIndicatorColor: tokens.themeBorderAccentDefault,
        mastheadLinkIndicatorHeight: 4,
        mastheadLinkIndicatorSpacingHorizontal: 4,
        mastheadLinkIndicatorSpacingVerticalDefault: 4,
        mastheadLinkIndicatorSpacingVerticalSmall: 0,
        mastheadLinkIndicatorBorderRadius: 999,
        mastheadBorderWidth: 1,
        mastheadBorderRadius: 0,
        mastheadBorderColor: tokens.themeBorderSecondaryDefault
    };
};

},{}],"3t4qe":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("56a22124368d3f25");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("fa3bb9c2a3737542"));
var _classCallCheck2 = _interopRequireDefault(require("92a2a14d3bf08e2c"));
var _createClass2 = _interopRequireDefault(require("f5263eb92160b92a"));
var _inherits2 = _interopRequireDefault(require("3b892cb873f62fcb"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("f4c814cb12cd97c1"));
var _getPrototypeOf2 = _interopRequireDefault(require("93c79d7138ad75c6"));
var _react = _interopRequireDefault(require("bb467a3c9eeffe9f"));
var _propTypes = _interopRequireDefault(require("4281765a6994e6f3"));
var _emotion = require("6b9c6c626bbc413b");
var _masthead = _interopRequireDefault(require("cd3cde70d38b0a1"));
var _theme = require("a5a75aa54b586356");
var _focus = _interopRequireDefault(require("9bd9d61ae2551f3b"));
var _clickable = _interopRequireDefault(require("b3ecea52b3465815"));
var _token = require("1efde393477c40e7");
var _focusRing = _interopRequireDefault(require("316432e49cd68c56"));
var _filterPropsByPrefix = _interopRequireDefault(require("a2fe7f3873511a56"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = function styles(t, _ref) {
    var focus = _ref.focus, disabled = _ref.disabled;
    return (0, _emotion.css)({
        display: "flex",
        alignItems: "center",
        color: t("foregroundColor", disabled ? "disabled" : "default"),
        padding: "0 ".concat(t("spacingInsetHorizontal"), "px"),
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        backgroundColor: t("backgroundColorDefault"),
        transition: t.transitionCss("motion", [
            "color",
            "background-color"
        ]),
        ":hover": !disabled ? {
            backgroundColor: t("backgroundColorHover")
        } : undefined,
        ":active": !disabled ? {
            backgroundColor: t("backgroundColorPressed")
        } : undefined,
        // HACK: This transform ensures that Chrome renders the text in the link
        // correctly after it has been pushed left or right by the masthead menu
        // button animation. Without this transform the kerning in Chrome ends up
        // a bit off after being moved.
        transform: "translateZ(0)"
    }, (0, _focusRing["default"])(t.tokens, {
        focus: focus
    }));
};
var indicatorStyles = function indicatorStyles(t, _ref2) {
    var selected = _ref2.selected, size = _ref2.size;
    return (0, _emotion.css)({
        position: "relative",
        "&:after": {
            content: "''",
            position: "absolute",
            top: "calc(100% + ".concat(t("indicatorSpacingVertical", size), "px)"),
            right: t("indicatorSpacingHorizontal") - t("spacingInsetHorizontal"),
            left: t("indicatorSpacingHorizontal") - t("spacingInsetHorizontal"),
            height: t("indicatorHeight"),
            backgroundColor: selected ? t("indicatorColor") : "transparent",
            borderRadius: t("indicatorBorderRadius"),
            transition: t.transitionCss("motion", "background-color")
        }
    });
};
/**
 * This component can be used to render a navigational link. Place this as a
 * child of the Masthead component.
 */ var MastheadLink = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(MastheadLink, _React$Component);
    var _super = _createSuper(MastheadLink);
    function MastheadLink() {
        (0, _classCallCheck2["default"])(this, MastheadLink);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(MastheadLink, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _masthead["default"],
                    map: (0, _token.getTokenHelper)("mastheadLink")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_focus["default"], null, function(_ref3) {
                        var focus = _ref3.focus, focusProps = _ref3.focusProps, focusTrigger = _ref3.focusTrigger;
                        return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
                            className: styles(t, {
                                focus: focus && focusTrigger === "keyboard",
                                disabled: props.disabled
                            }),
                            href: props.href,
                            onClick: props.onClick,
                            disabled: props.disabled,
                            target: props.target,
                            rel: props.rel,
                            "aria-current": props.selected ? "page" : undefined
                        }), /*#__PURE__*/ _react["default"].createElement("div", {
                            className: indicatorStyles(t, props)
                        }, props.children));
                    });
                });
            }
        }
    ]);
    return MastheadLink;
}(_react["default"].Component);
MastheadLink.propTypes = {};
var _default = MastheadLink;
exports["default"] = _default;

},{"56a22124368d3f25":"5qxSW","fa3bb9c2a3737542":"fAmfl","92a2a14d3bf08e2c":"aqLjQ","f5263eb92160b92a":"8X7ov","3b892cb873f62fcb":"hAMmu","f4c814cb12cd97c1":"37tJc","93c79d7138ad75c6":"cE6Se","bb467a3c9eeffe9f":"6uln9","4281765a6994e6f3":"9Mqtv","6b9c6c626bbc413b":"1BAMo","cd3cde70d38b0a1":"3WGDk","a5a75aa54b586356":"dJlcb","9bd9d61ae2551f3b":"8iPDd","b3ecea52b3465815":"iWCwP","1efde393477c40e7":"bebc4","316432e49cd68c56":"5Dvm2","a2fe7f3873511a56":"7Pq5E"}],"jAdWR":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e8221df93b9907cb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("2c73ca012718dae5"));
var _classCallCheck2 = _interopRequireDefault(require("a01831b6a4cf44f1"));
var _createClass2 = _interopRequireDefault(require("17d38e48ff60bc8d"));
var _inherits2 = _interopRequireDefault(require("e4e85cdd920d277d"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("cbc194ae9ef95c4c"));
var _getPrototypeOf2 = _interopRequireDefault(require("693e0dbcb573c39f"));
var _react = _interopRequireDefault(require("dc442da792d353a3"));
var _propTypes = _interopRequireDefault(require("2d634d3cdee08026"));
var _emotion = require("503a2e2a68564aa1");
var _masthead = _interopRequireDefault(require("526a018e64c12e39"));
var _theme = require("69d9b00d8d9747eb");
var _focus = _interopRequireDefault(require("934f416726483907"));
var _clickable = _interopRequireDefault(require("e26fb95ac8db1983"));
var _token = require("6d8b3455d99fd822");
var _focusRing = _interopRequireDefault(require("437502c6be713b99"));
var _filterPropsByPrefix = _interopRequireDefault(require("298a67fdf35ae916"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = function styles(t, _ref) {
    var focus = _ref.focus;
    return (0, _emotion.css)({
        display: "block",
        borderRadius: 4,
        paddingLeft: t("spacingHorizontal"),
        "& img": {
            display: "block"
        }
    }, (0, _focusRing["default"])(t.tokens, {
        offset: 4,
        borderRadius: 4,
        focus: focus
    }));
};
/**
 * This component can be used to render a logo/title lockup. Place this as a
 * child of the Masthead component.
 */ var MastheadTitle = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(MastheadTitle, _React$Component);
    var _super = _createSuper(MastheadTitle);
    function MastheadTitle() {
        (0, _classCallCheck2["default"])(this, MastheadTitle);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(MastheadTitle, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, href = _this$props.href, onClick = _this$props.onClick, children = _this$props.children, rel = _this$props.rel, target = _this$props.target;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _masthead["default"],
                    map: (0, _token.getTokenHelper)("masthead")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement(_focus["default"], null, function(_ref2) {
                        var focus = _ref2.focus, focusProps = _ref2.focusProps, focusTrigger = _ref2.focusTrigger;
                        return /*#__PURE__*/ _react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
                            className: styles(t, {
                                focus: focus && focusTrigger === "keyboard"
                            }),
                            href: href,
                            onClick: onClick,
                            rel: rel,
                            target: target
                        }), children);
                    });
                });
            }
        }
    ]);
    return MastheadTitle;
}(_react["default"].Component);
MastheadTitle.propTypes = {};
var _default = MastheadTitle;
exports["default"] = _default;

},{"e8221df93b9907cb":"5qxSW","2c73ca012718dae5":"fAmfl","a01831b6a4cf44f1":"aqLjQ","17d38e48ff60bc8d":"8X7ov","e4e85cdd920d277d":"hAMmu","cbc194ae9ef95c4c":"37tJc","693e0dbcb573c39f":"cE6Se","dc442da792d353a3":"6uln9","2d634d3cdee08026":"9Mqtv","503a2e2a68564aa1":"1BAMo","526a018e64c12e39":"3WGDk","69d9b00d8d9747eb":"dJlcb","934f416726483907":"8iPDd","e26fb95ac8db1983":"iWCwP","6d8b3455d99fd822":"bebc4","437502c6be713b99":"5Dvm2","298a67fdf35ae916":"7Pq5E"}],"gwSmO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("91976b3a5f29719a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("259d81d463192b"));
var _classCallCheck2 = _interopRequireDefault(require("d577a769d52a0479"));
var _createClass2 = _interopRequireDefault(require("deae18247e96a100"));
var _inherits2 = _interopRequireDefault(require("705a5bf3a64b5089"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("d27641972fdccadb"));
var _getPrototypeOf2 = _interopRequireDefault(require("7fe11368b641493"));
var _defineProperty2 = _interopRequireDefault(require("27af37756d444e21"));
var _react = _interopRequireDefault(require("10c4d42829daf0f"));
var _propTypes = _interopRequireDefault(require("38d57608774e816c"));
var _emotion = require("cf48d6e62d73ed8");
var _masthead = _interopRequireDefault(require("ea40020cdad8c4fb"));
var _menu = _interopRequireDefault(require("cc9766c2ed21f9a"));
var _theme = require("2420d4ed740c50c2");
var _button = _interopRequireDefault(require("a014bb338ffe5e61"));
var _icon = _interopRequireDefault(require("6b4f14e4e81f2d14"));
var _token = require("6d1c1bde0cee09d0");
var _filterPropsByPrefix = _interopRequireDefault(require("914d42b4d128fb9c"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var styles = function styles(t, _ref) {
    var open = _ref.open;
    return (0, _emotion.css)({
        width: open ? t("spacingHorizontal") + t("menuButtonWidth") : 0,
        transition: t.transitionCss("menuButtonMotion", "width"),
        "& > button": {
            "float": "right",
            marginLeft: t("spacingHorizontal")
        }
    });
};
/**
 * This component can be used to render a menu button in the top left of the
 * masthead. The button will animate smoothly when toggles via the "open" prop.
 */ var MastheadMenuButton = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(MastheadMenuButton, _React$Component);
    var _super = _createSuper(MastheadMenuButton);
    function MastheadMenuButton() {
        (0, _classCallCheck2["default"])(this, MastheadMenuButton);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(MastheadMenuButton, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, onClick = _this$props.onClick, open = _this$props.open;
                var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, [
                    "data-"
                ]);
                return /*#__PURE__*/ _react["default"].createElement(_theme.Style, {
                    tokens: _masthead["default"],
                    map: (0, _token.getTokenHelper)("masthead")
                }, function(t) {
                    return /*#__PURE__*/ _react["default"].createElement("div", {
                        className: styles(t, {
                            open: open
                        }),
                        "aria-hidden": !open
                    }, /*#__PURE__*/ _react["default"].createElement(_button["default"], (0, _extends2["default"])({}, passThroughProps, {
                        type: "icon",
                        size: "small",
                        onClick: onClick,
                        tabIndex: open ? undefined : "-1"
                    }), /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
                        tokens: _menu["default"]
                    }, children)));
                });
            }
        }
    ]);
    return MastheadMenuButton;
}(_react["default"].Component);
(0, _defineProperty2["default"])(MastheadMenuButton, "defaultProps", {
    children: "Menu",
    open: true
});
MastheadMenuButton.propTypes = {};
var _default = MastheadMenuButton;
exports["default"] = _default;

},{"91976b3a5f29719a":"5qxSW","259d81d463192b":"fAmfl","d577a769d52a0479":"aqLjQ","deae18247e96a100":"8X7ov","705a5bf3a64b5089":"hAMmu","d27641972fdccadb":"37tJc","7fe11368b641493":"cE6Se","27af37756d444e21":"avcfc","10c4d42829daf0f":"6uln9","38d57608774e816c":"9Mqtv","cf48d6e62d73ed8":"1BAMo","ea40020cdad8c4fb":"3WGDk","cc9766c2ed21f9a":"8Kse9","2420d4ed740c50c2":"dJlcb","a014bb338ffe5e61":"k0QSK","6b4f14e4e81f2d14":"8MgRY","6d1c1bde0cee09d0":"bebc4","914d42b4d128fb9c":"7Pq5E"}],"13v5V":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e27569ab69bb210e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuItem", {
    enumerable: true,
    get: function get() {
        return _menuItem["default"];
    }
});
exports["default"] = void 0;
var _menu = _interopRequireDefault(require("4abcfb2c69296e2f"));
var _menuItem = _interopRequireDefault(require("9ac04821d7213eac"));
var _default = _menu["default"];
exports["default"] = _default;

},{"e27569ab69bb210e":"5qxSW","4abcfb2c69296e2f":"9RwNw","9ac04821d7213eac":"aqu3u"}],"9RwNw":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("86fc15fa57be24c7");
var _interopRequireDefault = require("596c5dde853ed703");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("92776a685dac25eb"));
var _createClass2 = _interopRequireDefault(require("11faebb7dc4b8cca"));
var _assertThisInitialized2 = _interopRequireDefault(require("4e202586c7c01b0a"));
var _inherits2 = _interopRequireDefault(require("3b1adb3a5776b609"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("ba70409178f1c78f"));
var _getPrototypeOf2 = _interopRequireDefault(require("bc30054c229bd75a"));
var _defineProperty2 = _interopRequireDefault(require("f1e81e26a6a780f1"));
var _react = _interopRequireDefault(require("a95a37d91e8e4b34"));
var _reactDom = _interopRequireDefault(require("37aabd8224eb0829"));
var _propTypes = _interopRequireDefault(require("acad75331596a522"));
var _popover = _interopRequireDefault(require("6398442cae105022"));
var _optionList = _interopRequireWildcard(require("f86c37d199e0317c"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Renders a menu of options attached to another anchor element.
 *
 * NOTE: Do not mount a Menu inside an interactive element. The Menu's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Menu will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Menu being counted as a click on the element
 * where the Menu was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */ var Menu = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(Menu, _React$Component);
    var _super = _createSuper(Menu);
    function Menu() {
        var _this;
        (0, _classCallCheck2["default"])(this, Menu);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionListRef", undefined);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOptionListRef", function(ref) {
            return _this.optionListRef = ref;
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function() {
            // Re-trigger the option list's "componentDidMount" when the option list is
            // actually visible. This is necessary because the things the option list
            // does on mount, like setting the scroll and transferring focus, only work
            // when it's visible.
            _this.optionListRef.componentDidMount();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickItem", function(_ref) {
            var onClick = _ref.onClick, href = _ref.href, target = _ref.target;
            return function() {
                var anchorNode = _this.props.anchorNode; // Trigger the user-defined menu item action
                if (onClick) onClick(href);
                else if (href) window.open(href, target || "_self");
                 // Transfer focus back to the menu anchor (this will close the menu)
                /* eslint-disable-next-line react/no-find-dom-node */ _reactDom["default"].findDOMNode(anchorNode).focus(); // Clear the preselected menu item
                _this.setState({
                    preselectedIndex: undefined
                });
            };
        });
        return _this;
    }
    (0, _createClass2["default"])(Menu, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return nextProps.open || this.props.open;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var props = this.props; // If a minWidth is not set and the menu is positioned above or below the
                // anchor node, set the minWidth to the width of the anchor node
                var minWidth = this.props.minWidth === undefined && (props.position === "top" || props.position === "bottom") ? "anchor" : this.props.minWidth;
                return /*#__PURE__*/ _react["default"].createElement(_popover["default"], {
                    indicatorArrow: false,
                    open: props.open,
                    onClose: props.onClose,
                    onOpen: this.onOpen,
                    anchorNode: props.anchorNode,
                    minWidth: minWidth,
                    position: props.position,
                    alignment: props.alignment,
                    spacingInset: "none",
                    shrinkToFit: true
                }, /*#__PURE__*/ _react["default"].createElement(_optionList["default"], {
                    autoFocus: true,
                    ref: this.updateOptionListRef
                }, _react["default"].Children.map(props.children, function(option) {
                    return option ? /*#__PURE__*/ // TODO: See https://sim.amazon.com/issues/MRDN-296 regarding the
                    // empty label prop and the children-as-a-function below
                    _react["default"].createElement(_optionList.OptionListItem, {
                        onClick: _this2.onClickItem(option.props),
                        disabled: option.props.disabled,
                        href: option.props.href,
                        target: option.props.target,
                        rel: option.props.rel,
                        label: ""
                    }, function() {
                        return option.props.children;
                    }) : null;
                })));
            }
        }
    ]);
    return Menu;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Menu, "defaultProps", {
    alignment: "center"
});
Menu.propTypes = {};
var _default = Menu;
exports["default"] = _default;

},{"86fc15fa57be24c7":"4RXTR","596c5dde853ed703":"5qxSW","92776a685dac25eb":"aqLjQ","11faebb7dc4b8cca":"8X7ov","4e202586c7c01b0a":"fA0LA","3b1adb3a5776b609":"hAMmu","ba70409178f1c78f":"37tJc","bc30054c229bd75a":"cE6Se","f1e81e26a6a780f1":"avcfc","a95a37d91e8e4b34":"6uln9","37aabd8224eb0829":"b8T3j","acad75331596a522":"9Mqtv","6398442cae105022":"55onn","f86c37d199e0317c":"c2pRs"}],"55onn":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("4fbdf4fd52e097d9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PopoverHeader", {
    enumerable: true,
    get: function get() {
        return _popoverHeader["default"];
    }
});
exports["default"] = void 0;
var _popover = _interopRequireDefault(require("314f131587485bf9"));
var _popoverHeader = _interopRequireDefault(require("f4ff448b1ccbf2ea"));
var _default = _popover["default"];
exports["default"] = _default;

},{"4fbdf4fd52e097d9":"5qxSW","314f131587485bf9":"eOtoW","f4ff448b1ccbf2ea":"edRfO"}],"eOtoW":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("13880700734ae3f4");
var _interopRequireDefault = require("f659da5e23a6c70d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("63eee4ab452b63be"));
var _defineProperty2 = _interopRequireDefault(require("6893a690beae0abd"));
var _react = _interopRequireWildcard(require("2436ec0afa10626e"));
var _reactDom = _interopRequireDefault(require("f4149788b9a93239"));
var _propTypes = _interopRequireDefault(require("2545f9ad7d2b45b6"));
var _find = _interopRequireDefault(require("e172b7d13f535202"));
var _noop = _interopRequireDefault(require("1172d87749719220"));
var _uniqueId = _interopRequireDefault(require("4fbeeaf2d69c73cf"));
var _keycode = _interopRequireDefault(require("5cd87804071eab4a"));
var _popover = _interopRequireDefault(require("6552e11c218813f1"));
var _popoverHeader = _interopRequireDefault(require("e49cafefe374c83b"));
var _theme = require("9e0bfbba2e040cc7");
var _focusTrap = _interopRequireDefault(require("b7fae97148ce3423"));
var _popoverBody = _interopRequireDefault(require("153c567901ab8703"));
var _popoverController = _interopRequireDefault(require("1383b2e10f21a5b1"));
var _utils = require("ed87f1b1e023d688");
var _useOnBlurContainer2 = _interopRequireDefault(require("684de03636d1bac5"));
var _isElementOf = _interopRequireDefault(require("1beef60119d4cd3c"));
var _focus = require("d0ecb58541c40bbf");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var isHeader = (0, _isElementOf["default"])(_popoverHeader["default"]);
var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
    return !prevProps.open && !nextProps.open;
};
/**
 * Renders a popover attached to another anchor element.
 *
 * NOTE: Do not mount a Popover inside an interactive element. The Popover's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Popover will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Popover being counted as a click on the element
 * where the Popover was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */ var Popover = /*#__PURE__*/ _react["default"].memo(function(_ref) {
    var onOpenProp = _ref.onOpen, onKeyDownProp = _ref.onKeyDown, onClose = _ref.onClose, anchorNode = _ref.anchorNode, indicatorArrow = _ref.indicatorArrow, position = _ref.position, alignment = _ref.alignment, children = _ref.children, open = _ref.open, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, spacingInset = _ref.spacingInset, shrinkToFit = _ref.shrinkToFit;
    var popoverBody = (0, _react.useRef)();
    var id = (0, _react.useMemo)(function() {
        return (0, _uniqueId["default"])("popover-");
    }, []);
    var t = (0, _theme.useTheme)(_popover["default"], "popover"); // Transfer focus back to the popover anchor. This will automatically close
    // the popover because of our usage of `useOnBlurContainer` below.
    var close = (0, _react.useCallback)(function() {
        if (anchorNode.focus) anchorNode.focus();
        else /* eslint-disable-next-line react/no-find-dom-node */ _reactDom["default"].findDOMNode(anchorNode).focus();
    }, [
        anchorNode
    ]); // Create focus/blur handlers that will trigger onClose when focus moves
    // outside of the popover
    var _useOnBlurContainer = (0, _useOnBlurContainer2["default"])(onClose), onBlur = _useOnBlurContainer.onBlur, onFocus = _useOnBlurContainer.onFocus;
    var onOpen = (0, _react.useCallback)(function() {
        // When the popover is opened, focus on the first focuseable node inside
        // it *or* the popover itself if it doesn't contain any focuseable nodes.
        var firstFocusNode = (0, _focus.getKeyboardFocusNodes)(popoverBody.current)[0] || popoverBody.current;
        firstFocusNode.focus();
        onOpenProp();
    }, [
        popoverBody,
        onOpenProp
    ]); // If the user presses the escape key, close the popover.
    var onKeyDown = (0, _react.useCallback)(function(event) {
        if ((0, _keycode["default"])(event) === "esc") {
            // Stop propagating the event upwards. This ensures that a parent element
            // (e.g. a modal) won't also handle the escape key.
            event.stopPropagation();
            close();
        }
        onKeyDownProp(event);
    }, [
        onKeyDownProp,
        close
    ]);
    var vertical = position === "top" || position === "bottom";
    var childrenArray = _react["default"].Children.toArray(children);
    var headerChild = (0, _find["default"])(childrenArray, isHeader);
    var nonHeaderChildren = childrenArray.filter(function(child) {
        return !isHeader(child);
    }); // Check if the anchor node has a special attribute set in order to
    // customize the distance a popover is placed from the element. This is
    // useful for elements whose visual edge is not the same as their layout
    // edge, in which case they'll want to scoot the popover around to make it
    // appear a reasonable distance from the element's visual edge.
    var customOffset = (0, _react.useMemo)(function() {
        /* eslint-disable-next-line react/no-find-dom-node */ var anchorDomNode = anchorNode && _reactDom["default"].findDOMNode(anchorNode);
        var customOffset = parseInt(anchorDomNode && anchorDomNode.getAttribute("mdn-popover-offset"));
        return isNaN(customOffset) ? 0 : customOffset;
    }, [
        anchorNode
    ]); // Calculate the final offset based on tokens, the presence of an indicator
    // arrow, and any custom offset specified by the anchor node (see above).
    var offset = (0, _react.useMemo)(function() {
        return Math.max(0, t("offset", indicatorArrow ? "withArrow" : "withoutArrow") + customOffset);
    }, [
        t,
        indicatorArrow,
        customOffset
    ]);
    var headerId = headerChild ? "".concat(id, "-header") : undefined;
    return /*#__PURE__*/ _react["default"].createElement(_popoverController["default"], {
        open: open,
        anchorNode: anchorNode,
        anchorOrigin: vertical ? "".concat(position, " ").concat(alignment) : "".concat(alignment, " ").concat(position),
        popoverOrigin: vertical ? "".concat((0, _utils.flipAlignment)(position), " ").concat(alignment) : "".concat(alignment, " ").concat((0, _utils.flipAlignment)(position)),
        offsetVertical: vertical ? offset : 0,
        offsetHorizontal: vertical ? 0 : offset,
        onOpen: onOpen,
        shrinkToFit: shrinkToFit
    }, function(_ref2) {
        var popoverStyle = _ref2.popoverStyle, popoverOrigin = _ref2.popoverOrigin, anchorOrigin = _ref2.anchorOrigin, anchorRect = _ref2.anchorRect;
        return /*#__PURE__*/ _react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/ _react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({}, indicatorArrow ? _objectSpread({}, _popoverBody["default"].generateArrowProps({
            popoverOrigin: popoverOrigin,
            anchorOrigin: anchorOrigin,
            anchorRect: anchorRect
        })) : null, {
            style: popoverStyle,
            minWidth: minWidth === "anchor" ? anchorRect.width : minWidth,
            maxWidth: maxWidth === "anchor" ? anchorRect.width : maxWidth,
            spacingInset: spacingInset,
            onKeyDown: onKeyDown,
            onBlur: onBlur,
            onFocus: onFocus,
            tabIndex: "-1",
            ref: popoverBody,
            labelledById: headerId,
            allowOverflow: shrinkToFit
        }), headerChild ? /*#__PURE__*/ _react["default"].cloneElement(headerChild, {
            onClose: close,
            t: t,
            id: headerId
        }) : null, nonHeaderChildren));
    });
}, shouldNotUpdate);
Popover.displayName = "Popover";
Popover.propTypes = {};
Popover.defaultProps = {
    spacingInset: "medium",
    onKeyDown: _noop["default"],
    onOpen: _noop["default"],
    indicatorArrow: true,
    alignment: "center"
};
var _default = Popover;
exports["default"] = _default;

},{"13880700734ae3f4":"4RXTR","f659da5e23a6c70d":"5qxSW","63eee4ab452b63be":"fAmfl","6893a690beae0abd":"avcfc","2436ec0afa10626e":"6uln9","f4149788b9a93239":"b8T3j","2545f9ad7d2b45b6":"9Mqtv","e172b7d13f535202":"b6TZs","1172d87749719220":"hxHyu","4fbeeaf2d69c73cf":"4Lekm","5cd87804071eab4a":"4THh2","6552e11c218813f1":"lnaFx","e49cafefe374c83b":"edRfO","9e0bfbba2e040cc7":"dJlcb","b7fae97148ce3423":"aDJea","153c567901ab8703":"j1EaB","1383b2e10f21a5b1":"4IZFM","ed87f1b1e023d688":"gBO50","684de03636d1bac5":"hF2Y2","1beef60119d4cd3c":"i2KEV","d0ecb58541c40bbf":"jzxGB"}],"edRfO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("e7b52f2164e5687");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("83a1ce65999787b"));
var _propTypes = _interopRequireDefault(require("3b18478b2767d81"));
var _emotion = require("b64be2899622cd81");
var _close = _interopRequireDefault(require("7614caff15ec1e91"));
var _button = _interopRequireDefault(require("649a712dd36d233c"));
var _icon = _interopRequireDefault(require("99c207eee41855f2"));
var _functional = require("9b98c5546de3a412");
var styles = (0, _functional.memoize)(function(t) {
    return (0, _emotion.css)({
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        fontWeight: t("headerFontWeight"),
        marginBottom: t("spacingInsetVerticalMedium"),
        "& > button": {
            marginTop: 4 - t("spacingInsetVerticalMedium"),
            marginRight: 4 - t("spacingInsetHorizontalMedium"),
            marginLeft: t("headerSpacingHorizontal")
        }
    });
});
/**
 * This component can be used to render a title and close button for a popover.
 * Place this as a child of the Popover component.
 */ var PopoverHeader = /*#__PURE__*/ _react["default"].forwardRef(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement("div", {
        ref: ref,
        className: styles(props.t)
    }, /*#__PURE__*/ _react["default"].createElement("div", {
        id: props.id
    }, props.children), /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: "icon",
        size: "small",
        onClick: props.onClose
    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: _close["default"]
    }, props.closeLabel)));
});
PopoverHeader.displayName = "PopoverHeader";
PopoverHeader.propTypes = {
    /**
   * The contents of the header. Plain text recommended.
   */ children: _propTypes["default"].node.isRequired,
    /**
   * An accessible label for the close button.
   */ closeLabel: _propTypes["default"].string
};
PopoverHeader.defaultProps = {
    closeLabel: "Close"
};
var _default = PopoverHeader;
exports["default"] = _default;

},{"e7b52f2164e5687":"5qxSW","83a1ce65999787b":"6uln9","3b18478b2767d81":"9Mqtv","b64be2899622cd81":"1BAMo","7614caff15ec1e91":"2AQYC","649a712dd36d233c":"k0QSK","99c207eee41855f2":"8MgRY","9b98c5546de3a412":"hze9s"}],"hF2Y2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ccbbd7dbd710c7f7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _useOnBlurContainer = _interopRequireDefault(require("8dedb89fedeaaf1c"));
var _default = _useOnBlurContainer["default"];
exports["default"] = _default;

},{"ccbbd7dbd710c7f7":"5qxSW","8dedb89fedeaaf1c":"36Je7"}],"36Je7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = require("938b1009e58d5e1b");
/**
 * Use this to detect when focus is leaving an element that contains other
 * focuseable elements. *Works with portals*.
 *
 * Elements receive blur events when they lose focus, but they also receive blur
 * events when the focus is transferred between elements that they contain. In
 * this case they'll get a blur event for the descendant losing focus followed
 * immediately by a focus event for the descendant receiving focus. This hook
 * allows you to listen only for the blur events where the focus is actually
 * moving outside the element, and is not just being transferred between
 * descendants of the element.
 */ var useOnBlurContainer = function useOnBlurContainer(onBlurContainer) {
    var blurTimeout = (0, _react.useRef)();
    var focus = (0, _react.useRef)(); // Clear the blur timeout when unmounting
    (0, _react.useEffect)(function() {
        return function() {
            return clearTimeout(blurTimeout.current);
        };
    }, []); // When we get a blur event, mark the focus ref as false, wait one cycle,
    // and then execute the final callback if the focus ref is *still* false
    // (i.e. if onFocus wasn't called).
    var onBlur = (0, _react.useCallback)(function() {
        focus.current = false;
        blurTimeout.current = setTimeout(function() {
            if (!focus.current) onBlurContainer();
        }, 0);
    }, [
        onBlurContainer,
        focus
    ]); // Mark the focus ref as true whenever we get a focus event
    var onFocus = (0, _react.useCallback)(function() {
        focus.current = true;
    }, [
        focus
    ]);
    return {
        onBlur: onBlur,
        onFocus: onFocus
    };
};
var _default = useOnBlurContainer;
exports["default"] = _default;

},{"938b1009e58d5e1b":"6uln9"}],"aqu3u":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("dd92cb34f7cc795a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("2337e85bd219c76b"));
var _createClass2 = _interopRequireDefault(require("19fd66a5a97276ee"));
var _inherits2 = _interopRequireDefault(require("49da667284df9895"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("67e271646eb236cb"));
var _getPrototypeOf2 = _interopRequireDefault(require("2635b4973a66b2c0"));
var _react = _interopRequireDefault(require("caaab448310d9489"));
var _propTypes = _interopRequireDefault(require("c5c33f39e0949831"));
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var MenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, _inherits2["default"])(MenuItem, _React$Component);
    var _super = _createSuper(MenuItem);
    function MenuItem() {
        (0, _classCallCheck2["default"])(this, MenuItem);
        return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(MenuItem, [
        {
            key: "render",
            value: function render() {
                // This component is used to create a nice API, the OptionListItem
                // component is used to actually render the menu item
                return null;
            }
        }
    ]);
    return MenuItem;
}(_react["default"].Component);
MenuItem.propTypes = {};
var _default = MenuItem;
exports["default"] = _default;

},{"dd92cb34f7cc795a":"5qxSW","2337e85bd219c76b":"aqLjQ","19fd66a5a97276ee":"8X7ov","49da667284df9895":"hAMmu","67e271646eb236cb":"37tJc","2635b4973a66b2c0":"cE6Se","caaab448310d9489":"6uln9","c5c33f39e0949831":"9Mqtv"}],"9WCze":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _button = require("@amzn/meridian/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _text = require("@amzn/meridian/text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const NavigationButtons = ({ type, onClick, text, className, color })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        type: type,
        size: "small",
        onClick: onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textDefault.default), {
        type: "b200",
        color: color
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: text
    }))));
NavigationButtons.propTypes = {
    type: (0, _propTypesDefault.default).string.isRequired,
    onClick: (0, _propTypesDefault.default).func.isRequired,
    text: (0, _propTypesDefault.default).string.isRequired,
    color: (0, _propTypesDefault.default).string.isRequired,
    className: (0, _propTypesDefault.default).string.isRequired
};
exports.default = NavigationButtons;

},{"@amzn/meridian/button":"k0QSK","@amzn/meridian/text":"hj2bM","react":"6uln9","react-intl":"4kbQW","prop-types":"6FKs7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7T7oW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _box = require("@amzn/meridian/box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _row = require("@amzn/meridian/row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _meridian = require("../../constants/meridian");
var _infoComponent = require("../commons/InfoComponent");
var _infoComponentDefault = parcelHelpers.interopDefault(_infoComponent);
const ManageUsersButton = ({ hasAdminRights })=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        alignmentHorizontal: "justify"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rowDefault.default), {
        minWidth: "70%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "top_bar.settings_menu.manage_users"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infoComponentDefault.default), {
        disabled: hasAdminRights,
        messageId: "no_permissions",
        position: (0, _meridian.TooltipPositionsEnum).bottom
    })));
exports.default = ManageUsersButton;

},{"@amzn/meridian/box":"dxZXY","@amzn/meridian/row":"ba4AQ","react":"6uln9","react-intl":"4kbQW","../../constants/meridian":"1nhn4","../commons/InfoComponent":"euONe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1nhn4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipPositionsEnum", ()=>TooltipPositionsEnum);
const TooltipPositionsEnum = {
    end: "end",
    bottom: "bottom",
    left: "left",
    right: "right",
    top: "top"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"euONe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alertWarningSmall = require("@amzn/meridian-tokens/base/icon/alert-warning-small");
var _alertWarningSmallDefault = parcelHelpers.interopDefault(_alertWarningSmall);
var _tooltip = require("@amzn/meridian/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _icon = require("@amzn/meridian/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _reactIntl = require("react-intl");
var _meridian = require("../../constants/meridian");
const InfoComponent = ({ disabled, messageId, position = (0, _meridian.TooltipPositionsEnum).end })=>{
    const { formatMessage } = (0, _reactIntl.useIntl)();
    if (disabled) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), {
        position: position,
        title: formatMessage({
            id: messageId
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconDefault.default), {
        tokens: (0, _alertWarningSmallDefault.default)
    }));
};
exports.default = InfoComponent;

},{"react":"6uln9","@amzn/meridian-tokens/base/icon/alert-warning-small":"i8B7p","@amzn/meridian/tooltip":"6eaDA","@amzn/meridian/icon":"8MgRY","react-intl":"4kbQW","../../constants/meridian":"1nhn4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4CO0t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _userManagementConstants = require("../constants/userManagementConstants");
var _window = require("../utils/window");
var _windowDefault = parcelHelpers.interopDefault(_window);
var _useUserAccountActionsUrls = require("./useUserAccountActionsUrls");
var _useUserAccountActionsUrlsDefault = parcelHelpers.interopDefault(_useUserAccountActionsUrls);
var _cloudwatchRum = require("@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum");
var _analytics = require("@amzn/carrierlogistics-commons/dist/constants/analytics");
var _analytics1 = require("../constants/analytics");
function useUserAccountActionRedirects() {
    const { signInURL, signOutURL, signUpURL } = (0, _useUserAccountActionsUrlsDefault.default)();
    const signInRedirect = (0, _react.useCallback)(()=>{
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.HEADER_SIGN_IN_BUTTON)
            }
        });
        (0, _windowDefault.default).location.href = signInURL;
    }, [
        signInURL
    ]);
    const signOutRedirect = (0, _react.useCallback)(()=>{
        // removing customerID as a safe practice
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.SIGN_OUT_BUTTON)
            }
        });
        (0, _windowDefault.default).sessionStorage.removeItem((0, _userManagementConstants.MONS_CUSTOMER_ID_SESSION));
        (0, _windowDefault.default).location.href = signOutURL;
    }, [
        signOutURL
    ]);
    const signUpRedirect = (0, _react.useCallback)(()=>{
        (0, _cloudwatchRum.recordCustomEventInCloudWatchRUM)((0, _analytics.BUTTON_CLICK), {
            action_properties: {
                name: (0, _analytics1.SIGN_UP_BUTTON)
            }
        });
        (0, _windowDefault.default).location.href = signUpURL;
    }, [
        signUpURL
    ]);
    return {
        signInRedirect,
        signOutRedirect,
        signUpRedirect
    };
}
exports.default = useUserAccountActionRedirects;

},{"react":"6uln9","../constants/userManagementConstants":"gYWou","../utils/window":"4IKui","./useUserAccountActionsUrls":"1RPmB","@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum":"3ViCX","@amzn/carrierlogistics-commons/dist/constants/analytics":"hl6Ce","../constants/analytics":"zH2LJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYWou":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MONS_CUSTOMER_ID_SESSION", ()=>MONS_CUSTOMER_ID_SESSION);
parcelHelpers.export(exports, "CSRF_TOKEN_ID", ()=>CSRF_TOKEN_ID);
const MONS_CUSTOMER_ID_SESSION = "monsCustomerId";
const CSRF_TOKEN_ID = "anti-csrftoken-a2z";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1RPmB":[function(require,module,exports) {
/* eslint-disable camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _react = require("react");
var _getSettings = require("../utils/auth/getSettings");
var _getSettingsDefault = parcelHelpers.interopDefault(_getSettings);
var _urlUtils = require("../utils/urlUtils");
function useUserAccountActionsUrls() {
    const [authDetails, setAuthDetails] = (0, _react.useState)({});
    let signInURL = null;
    let signOutURL = null;
    let signUpURL = null;
    (0, _react.useEffect)(()=>{
        (0, _getSettingsDefault.default)().then(({ signinURL, signoutURL, signupURL, auth_redirect_params_signin, auth_redirect_params_signout, auth_redirect_params_signup })=>setAuthDetails({
                signinURL,
                signoutURL,
                signupURL,
                auth_redirect_params_signin,
                auth_redirect_params_signout,
                auth_redirect_params_signup
            }));
    }, []);
    if (!(0, _isEmptyDefault.default)(authDetails)) {
        const { signinURL, signoutURL, signupURL, auth_redirect_params_signin, auth_redirect_params_signout, auth_redirect_params_signup } = authDetails;
        signInURL = (0, _urlUtils.appendQueryParams)(signinURL, auth_redirect_params_signin);
        signOutURL = (0, _urlUtils.appendQueryParams)(signoutURL, auth_redirect_params_signout);
        signUpURL = (0, _urlUtils.appendQueryParams)(signupURL, auth_redirect_params_signup);
    }
    return {
        signInURL,
        signOutURL,
        signUpURL
    };
}
exports.default = useUserAccountActionsUrls;

},{"lodash/isEmpty":"7pljj","react":"6uln9","../utils/auth/getSettings":"4BUv4","../utils/urlUtils":"6a4Tm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7pljj":[function(require,module,exports) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"cUzQF","d63799a808049d04":"4Ug8n","1f4ee6aee3a7eae0":"asnYU","b708be4f72c2a706":"2VsjV","ab4b4eaf96f9163a":"5uWOF","80b58ade5ee2f70":"kfeDT","3a444e8bd8b275f2":"hcjX5","6af418b3352c301b":"hUF8Z"}],"cUzQF":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"hcjX5","3ec652610d8dd5d3":"2HmXG"}],"hcjX5":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"2HmXG":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"5rEQb"}],"5rEQb":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"4Ug8n":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"lRQg2","28e3344aae951f13":"lXR3t","b286298be5b1d9a4":"gLnFZ","3ae50c158f89813":"9vgKa","9f458755f627d456":"86FKS","8e9160b373d7fe66":"fQG2h","b210627dd951641f":"cLkAM"}],"lRQg2":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"g9yTj","f83c375075418382":"iGWPT"}],"g9yTj":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"gWgLs","16db51a0e009bd8c":"d6JxY"}],"gWgLs":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"i4ymb","cabbc2adfaeb27d9":"g1GOZ","cbb5703fe1562e7f":"3TlAp","388b819f47a43aa5":"cLkAM"}],"i4ymb":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"fQG2h","3cba3c966459d528":"3TlAp"}],"fQG2h":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"e0ngr","9b2aaf31b7bdd837":"5XmKh","46d5beb3375f8a28":"fT5CU"}],"e0ngr":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"iGWPT"}],"iGWPT":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"hw1wy"}],"hw1wy":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"5XmKh":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"e0ngr"}],"fT5CU":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"3TlAp":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"g1GOZ":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"jCWEv"}],"jCWEv":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"iGWPT"}],"cLkAM":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"d6JxY":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"lXR3t":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"g9yTj","29224713b8d411e6":"iGWPT"}],"gLnFZ":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"g9yTj","a5c6637bac681a0":"iGWPT"}],"9vgKa":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"g9yTj","ca486d41cdf819d4":"iGWPT"}],"86FKS":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"g9yTj","7a9a6581834a8452":"iGWPT"}],"asnYU":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"crxEa","bead821d6af018b5":"5TH1N"}],"crxEa":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"fQG2h","b6cdbe52dcf709f8":"5TH1N"}],"5TH1N":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"2VsjV":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"5uWOF":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"i4ymb","f3db08d4d1110aaf":"g5LO3"}],"g5LO3":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"kfeDT":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"iGWPT","a1e87b138cf75d1d":"9OHNT"}],"9OHNT":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"hUF8Z":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"9IaoX","903f50eb1c16d257":"993qv","fa49853a82034c30":"ihImP"}],"9IaoX":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"fQG2h","f661b3a120d7a4cb":"g5LO3","cdd86c83797c0618":"5TH1N"}],"993qv":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"ihImP":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"hw1wy"}],"4BUv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storeSettingsAndReturn", ()=>storeSettingsAndReturn);
parcelHelpers.export(exports, "getSettings", ()=>getSettings);
var _localSettings = require("../../config/localSettings");
var _localSettingsDefault = parcelHelpers.interopDefault(_localSettings);
const URL_SETTINGS = "/settings.json";
let storedSettings = null;
const storeSettingsAndReturn = (settings)=>{
    storedSettings = settings;
    return settings;
};
const getSettings = ()=>{
    if (storedSettings) return Promise.resolve(storedSettings);
    return fetch(URL_SETTINGS).then((response)=>response.json()).then((settings)=>storeSettingsAndReturn(settings)).catch(()=>storeSettingsAndReturn((0, _localSettingsDefault.default)));
};
exports.default = getSettings;

},{"../../config/localSettings":"b15jA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b15jA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    apiEndpoint: "https://webapi.beta.carrierhub.transportation.amazon.dev",
    signinURL: "https://carrierlogistics.integ.amazon.com/ap/signin",
    signoutURL: "https://carrierlogistics.integ.amazon.com/ap/signin",
    signupURL: "https://carrierlogistics.integ.amazon.com/ap/register",
    auth_redirect_params_signin: {
        _encoding: "UTF8",
        "openid.assoc_handle": "amzn_passport_carrierhub_us",
        pageId: "amzn_passport_carrierhub_us",
        "openid.claimed_id": "http://specs.openid.net/auth/2.0/identifier_select",
        "openid.identity": "http://specs.openid.net/auth/2.0/identifier_select",
        "openid.mode": "checkid_setup",
        "openid.ns": "http://specs.openid.net/auth/2.0",
        "openid.ns.pape": "http://specs.openid.net/extensions/pape/1.0",
        "openid.pape.max_auth_age": 0,
        "openid.return_to": "https://carrierlogistics.integ.amazon.com/landing-page"
    },
    auth_redirect_params_signout: {
        "openid.claimed_id": "http://specs.openid.net/auth/2.0/identifier_select",
        "openid.identity": "http://specs.openid.net/auth/2.0/identifier_select",
        "openid.assoc_handle": "amzn_passport_carrierhub_us",
        "openid.mode": "logout",
        "openid.ns": "http://specs.openid.net/auth/2.0",
        "openid.return_to": "https://carrierlogistics.integ.amazon.com/"
    },
    auth_redirect_params_signup: {
        "openid.return_to": "https://carrierlogistics.integ.amazon.com/profile",
        "openid.identity": "http://specs.openid.net/auth/2.0/identifier_select",
        "openid.assoc_handle": "amzn_passport_carrierhub_us",
        "openid.mode": "checkid_setup",
        "openid.claimed_id": "http://specs.openid.net/auth/2.0/identifier_select",
        pageId: "amzn_passport_carrierhub_us",
        "openid.ns": "http://specs.openid.net/auth/2.0"
    },
    devSiteCookies: {
        carrierlogistics: "",
        forecast: "H4sIAAAAAAAA/8WSwUoDMRCG3yXnza6rVmFvpSAVQaXqSTzMJrO7sUmmTCa1tuy7S6VCfYH2NvyX+fn+b6fAWrQL1w+SVPP+USjGQOv/kfHgwuHO7J/WyOwsJtXs1AyYHfI8t82cAj5Dj6pRg8gqNVWFG0GO4DtiNJAkO92igM5JIyTRtW6zWaLg7QTh5tro2l5Ouotgu5o/+zJdlRBgSxG+UmkoVC5a3JSDBK+K49cvAuLMjGLn+swgjuIZWkyzDMRui/btfpoS7vmdvMR+gUeSO8rRnokBRnEG5NQYxkIJQ0z+d/8H/D4o6yAsyOOxtmOhkqHVn+avtMS9MGr8AevqaSsRAwAA",
        capacity: "H4sIAAAAAAAA/8WTT08CQQzFv8uc2V1kQXBuhMRADGpAT8ZDma27DTNTnOnyN3x3swSNHrzCremh75f3Xg8KigKLGZWVRKXf3lsqoOP135WxQO4818E+rTEEKjAqfVAjCIEwjOuFHrPDZyhRaVWJrKLOMtwKBg/WwAoMyc6BhxIdeqkpWaBAsqjNEgX7PYTbrklu8qWlvN8OtPscpDFPwcGePWxiathl5AvcppU4q1q/pecCQmbE/oPKOoAQ+ytQDGupONAei9fJMEZs/Ls4RJPAI8s91764kgfohQzIpW04tpQE8NGe8n/A3bmyBG7GFv+prdIKgtewiZrAad1p5/3BXWfQ6w5yHdhiNmUf5/nEr9mcLjfHktGZf/rD3+hHw6vv33nhJTYtVMcvJAWXwGYDAAA=",
        npc: "H4sIAAAAAAAA/8VTPW/CMBD9L55JAiUB1RtCqkAVFEE7VR0O+5pYxD5knwMF8d+rIFqVoStspxvee3ofRwFao16asuIg5PtHR3i01Fy/VA3GXu7o65cGvTcag5BHMQbvDfpJXMsJWVxAiUKKinkbZJbhntE7qN1WWXBQokXH0SRrZEhiSBCSdVQbZBwWCINcJSGvmv6+12yC9Wnop2DhQA52IVVkM+M07tOKbS06f6lXDGzUmNynKaMHNuTuoGIUuSJvDqjfpqMQsPXv5iLaBObETxSdvpMH6Ngo4FvbcOoI9uBCfc7/Gb8ulTVgl1TjP7UVUoB3EnZBGrBS5kXxMOw95t1Bt5Ceasxm5MKqP3UNqTNyC5bMF+PZr/6WOija/szmlTbYFlCcvgGbI/ugYQMAAA=="
    },
    rumUIParams: {
        APPLICATION_ID: "f2ced7bb-d959-47f1-a8e7-23d3d833675b",
        APPLICATION_VERSION: "1.0.0",
        config: {
            sessionSampleRate: 1,
            guestRoleArn: "arn:aws:iam::576452334837:role/carrierlogistics-RUM-UnauthenticatedRole",
            identityPoolId: "us-east-1:a94b6056-2cde-4891-b9af-a20d5ec1cafd",
            endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
            telemetries: [
                "performance",
                "errors",
                "http"
            ],
            allowCookies: true,
            enableXRay: false
        },
        APPLICATION_REGION: "us-east-1"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6a4Tm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendQueryParams", ()=>appendQueryParams);
const appendQueryParams = (urlString, params)=>{
    const url = new URL(urlString);
    Object.entries(params).forEach(([k, v])=>url.searchParams.append(k, v));
    return url;
};
exports.default = {
    appendQueryParams
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2qJck":[function(require,module,exports) {
module.exports = require("fef5a5f8255fe6ff").getBundleURL("ciDtH") + "carrier-hub-logo.0b052307.svg";

},{"fef5a5f8255fe6ff":"c7Tr5"}],"hMwza":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("@amzn/meridian/alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _heading = require("@amzn/meridian/heading");
var _headingDefault = parcelHelpers.interopDefault(_heading);
var _reactIntl = require("react-intl");
var _nonSignedInPageRoutes = require("../config/nonSignedInPageRoutes");
var _index = require("@amzn/carrierlogistics-commons/dist/hooks/authorisation/index");
var _authorizedPageUtils = require("../utils/authorizedPageUtils");
var _reactRouterDom = require("react-router-dom");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
const UnAuthorizedAlert = ()=>{
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const { formatMessage } = (0, _reactIntl.useIntl)();
    const authorizedEntities = (0, _index.useAuthorisedEntities)();
    const [shouldHideAlert, setShouldHideAlert] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        // On page load authorizedEntities will be empty by default.
        if ((0, _isEmptyDefault.default)(authorizedEntities)) return;
        setShouldHideAlert((0, _authorizedPageUtils.hasAccessToAtleastOneTerm)(authorizedEntities));
    }, [
        authorizedEntities
    ]);
    const shouldShowAlert = (0, _nonSignedInPageRoutes.showUnAuthorizedAlert).some((path)=>pathname.includes(path));
    if (shouldHideAlert || !shouldShowAlert) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), {
        type: "warning",
        size: "large",
        title: formatMessage({
            id: "unauthorized.title"
        }),
        onClose: ()=>setShouldHideAlert(true)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingDefault.default), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactIntl.FormattedMessage), {
        id: "unauthorized.message"
    })));
};
exports.default = UnAuthorizedAlert;

},{"react":"6uln9","@amzn/meridian/alert":"ikD6d","@amzn/meridian/heading":"8qIYS","react-intl":"4kbQW","../config/nonSignedInPageRoutes":"6YOyO","@amzn/carrierlogistics-commons/dist/hooks/authorisation/index":"jz3IT","../utils/authorizedPageUtils":"8Nt2u","react-router-dom":"5fzqq","lodash/isEmpty":"7pljj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ikD6d":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("466edf5a099b3dfb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _alert = _interopRequireDefault(require("241bcf8e634480f8"));
var _default = _alert["default"];
exports["default"] = _default;

},{"466edf5a099b3dfb":"5qxSW","241bcf8e634480f8":"cCQAp"}],"cCQAp":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("71e6dfafc58e68a0");
var _interopRequireDefault = require("f340504721ccb787");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("fbe61c04fb942673"));
var _react = _interopRequireWildcard(require("3fd7318866b735d7"));
var _propTypes = _interopRequireDefault(require("e522802db39630d0"));
var _emotion = require("23e9c865ffb4a8ab");
var _uniqueId = _interopRequireDefault(require("a1bb853569d7d4f0"));
var _alert = _interopRequireDefault(require("c395f6a8c88ee618"));
var _alertErrorXlarge = _interopRequireDefault(require("45427e76aa393acb"));
var _alertErrorLarge = _interopRequireDefault(require("5d9b67b2c3aaba03"));
var _alertErrorSmall = _interopRequireDefault(require("861d22235263a91b"));
var _alertInformationalLarge = _interopRequireDefault(require("59f9a247142a3226"));
var _alertInformationalSmall = _interopRequireDefault(require("83b7511fe3b27fbd"));
var _alertSuccessXlarge = _interopRequireDefault(require("2623bfeb42f23135"));
var _alertSuccessLarge = _interopRequireDefault(require("a2a3a994c63b439c"));
var _alertSuccessSmall = _interopRequireDefault(require("6aed252dcc8266d1"));
var _alertWarningXlarge = _interopRequireDefault(require("90d3bea70dd2b60"));
var _alertWarningLarge = _interopRequireDefault(require("f73dcd27b4836c75"));
var _alertWarningSmall = _interopRequireDefault(require("b2da177f559687f1"));
var _close = _interopRequireDefault(require("42f0a62c557f369e"));
var _theme = require("95b5731b1d257725");
var _button = _interopRequireDefault(require("3c864a62e6496f86"));
var _icon = _interopRequireDefault(require("bd06586a822ed465"));
var _token = require("2eb35729117ab1b5");
var _focus = require("c017fe1a10504e6d");
var _getIconCss = _interopRequireDefault(require("1e8a991aa6253d14"));
var _text = _interopRequireDefault(require("e80fc780fda298d6"));
var iconTokens = {
    small: {
        error: _alertErrorSmall["default"],
        informational: _alertInformationalSmall["default"],
        success: _alertSuccessSmall["default"],
        warning: _alertWarningSmall["default"]
    },
    medium: {
        error: _alertErrorSmall["default"],
        informational: _alertInformationalSmall["default"],
        success: _alertSuccessSmall["default"],
        warning: _alertWarningSmall["default"]
    },
    large: {
        error: _alertErrorLarge["default"],
        informational: _alertInformationalLarge["default"],
        success: _alertSuccessLarge["default"],
        warning: _alertWarningLarge["default"]
    },
    xlarge: {
        error: _alertErrorXlarge["default"],
        informational: _alertInformationalLarge["default"],
        success: _alertSuccessXlarge["default"],
        warning: _alertWarningXlarge["default"]
    }
};
var styles = (0, _token.memoizeTokenStyles)(function(t, _ref) {
    var size = _ref.size, type = _ref.type, toast = _ref.toast, width = _ref.width;
    var borderWidth = t("borderWidth", size);
    var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
    return (0, _emotion.css)({
        /**
     * Container styles
     */ boxSizing: "border-box",
        display: "flex",
        flexDirection: size === "xlarge" ? "column" : "row",
        alignItems: size === "xlarge" ? "center" : "flex-start",
        backgroundColor: t("backgroundColor", [
            size,
            type
        ]),
        borderWidth: borderWidth,
        borderColor: t("borderColor", type),
        borderStyle: borderWidth ? "solid" : undefined,
        borderRadius: t("borderRadius"),
        padding: t("spacingInset", size),
        width: width,
        boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
        "& > * + *": {
            marginLeft: t("spacingHorizontal", size)
        },
        /**
     * Icon styles
     */ "& > [role=img]": {
            flexShrink: 0,
            alignSelf: size === "xlarge" ? "center" : "stretch",
            backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [
                size,
                type
            ])),
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: icon.width,
            // This ensures that the icon is vertically centered on the first line of
            // text for single-line alerts and on the first two lines of text for
            // multi-line alerts.
            minHeight: icon.height,
            maxHeight: icon.height * 2
        },
        /**
     * Title/message wrapper styles
     */ "& [mdn-text]": (0, _emotion.css)((0, _text["default"])(t, {
            fontSize: [
                "message",
                size
            ],
            fontWeight: "body",
            // TODO: This token should be renamed to "message"
            lineHeight: [
                "message",
                size
            ]
        }), {
            textAlign: size === "xlarge" ? "center" : "initial",
            color: t("foregroundColor", [
                size,
                type
            ]),
            flex: "auto",
            display: "flex",
            flexDirection: size === "xlarge" ? "column" : "row",
            // Allow the message to wrap below the title if it's too long to fit.
            flexWrap: "wrap"
        }),
        /**
     * Title styles
     */ "& [mdn-alert-title]": (0, _emotion.css)((0, _text["default"])(t, {
            fontSize: [
                "title",
                size
            ],
            fontWeight: "title",
            lineHeight: [
                "title",
                size
            ]
        }), {
            color: t("foregroundColor", [
                size,
                type
            ]),
            flexShrink: 0,
            fontWeight: t("fontWeightTitle"),
            marginRight: t("titleSpacingRight", size),
            marginTop: t("spacingVertical", size)
        }),
        /**
     * Message styles
     */ "& [mdn-alert-message]": {
            margin: 0,
            marginTop: t("spacingVertical", size),
            // Make the message fill the whole width of the alert, but keep it on
            // the same line as the title until it has to wrap.
            flex: "auto",
            flexShrink: 0,
            maxWidth: "100%"
        }
    });
}, [
    "size",
    "type",
    "toast",
    "width"
]);
var closeButtonStyles = function closeButtonStyles(t, _ref2) {
    var size = _ref2.size;
    return (0, _emotion.css)(size === "xlarge" ? {
        position: "absolute",
        top: t("closeButtonSpacing", size),
        right: t("closeButtonSpacing", size)
    } : {
        flexShrink: 0,
        margin: t("closeButtonSpacing", size) - t("spacingInset", size),
        marginLeft: t("spacingHorizontal", size)
    });
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */ function Alert(props) {
    var t = (0, _theme.useTheme)(_alert["default"], "alert");
    var idPrefix = (0, _react.useMemo)(function() {
        return (0, _uniqueId["default"])("alert-");
    }, []);
    var node = (0, _react.useRef)();
    var big = props.size === "large" || props.size === "xlarge";
    var title = big ? props.title : undefined;
    var titleId = title ? "".concat(idPrefix, "-title") : undefined;
    var childrenId = "".concat(idPrefix, "-children");
    var showCloseButton = props.onClose && props.size !== "small"; // If autoFocus is true then focus on the first interactive element in the
    // alert. This'll either be the first action rendered by the user or the
    // alert's close button if there are no actions.
    var autoFocus = props.autoFocus;
    (0, _react.useEffect)(function() {
        if (autoFocus) {
            var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current), _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1), firstFocusNode = _getKeyboardFocusNode2[0];
            if (firstFocusNode) firstFocusNode.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ _react["default"].createElement("div", {
        className: styles(t, props),
        ref: autoFocus ? node : undefined,
        role: showCloseButton ? "alertdialog" : "alert",
        "aria-labelledby": titleId,
        "aria-describedby": childrenId
    }, /*#__PURE__*/ _react["default"].createElement("div", {
        role: "img",
        "aria-hidden": "true"
    }), /*#__PURE__*/ _react["default"].createElement("div", {
        "mdn-text": ""
    }, title ? /*#__PURE__*/ _react["default"].createElement("div", {
        "mdn-alert-title": "",
        id: titleId
    }, title) : null, /*#__PURE__*/ _react["default"].createElement("div", {
        "mdn-alert-message": "",
        id: childrenId
    }, props.children)), showCloseButton ? /*#__PURE__*/ _react["default"].createElement(_button["default"], {
        type: "icon",
        size: big ? "medium" : "small",
        onClick: props.onClose,
        backdropColor: t("backgroundColor", [
            props.size,
            props.type
        ]),
        className: closeButtonStyles(t, props)
    }, /*#__PURE__*/ _react["default"].createElement(_icon["default"], {
        tokens: _close["default"]
    }, props.closeLabel)) : null);
}
Alert.propTypes = {};
Alert.defaultProps = {
    size: "large",
    type: "informational",
    closeLabel: "Dismiss"
};
var _default = Alert;
exports["default"] = _default;

},{"71e6dfafc58e68a0":"4RXTR","f340504721ccb787":"5qxSW","fbe61c04fb942673":"4QArz","3fd7318866b735d7":"6uln9","e522802db39630d0":"9Mqtv","23e9c865ffb4a8ab":"1BAMo","a1bb853569d7d4f0":"4Lekm","c395f6a8c88ee618":"hd8AG","45427e76aa393acb":"1qY3u","5d9b67b2c3aaba03":"1bKKf","861d22235263a91b":"60zDg","59f9a247142a3226":"5HZcC","83b7511fe3b27fbd":"f5V7t","2623bfeb42f23135":"64MbA","a2a3a994c63b439c":"dfQtq","6aed252dcc8266d1":"dUJtB","90d3bea70dd2b60":"g4mrT","f73dcd27b4836c75":"8sEIC","b2da177f559687f1":"i8B7p","42f0a62c557f369e":"2AQYC","95b5731b1d257725":"dJlcb","3c864a62e6496f86":"k0QSK","bd06586a822ed465":"8MgRY","2eb35729117ab1b5":"bebc4","c017fe1a10504e6d":"jzxGB","1e8a991aa6253d14":"dVcs8","e80fc780fda298d6":"g6RQX"}],"copTY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _userManagementConstants = require("../constants/userManagementConstants");
const updateCSRFToken = ()=>{
    const csrfTokenMeta = document.querySelector(`meta[name='${(0, _userManagementConstants.CSRF_TOKEN_ID)}']`);
    if (csrfTokenMeta) sessionStorage.setItem((0, _userManagementConstants.CSRF_TOKEN_ID), csrfTokenMeta.getAttribute("content"));
};
exports.default = updateCSRFToken;

},{"../constants/userManagementConstants":"gYWou","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},[], null, "parcelRequire6032")

//# sourceMappingURL=Root.b399390e.js.map
